export const pincodeData = {
  "ANDHRA PRADESH": {
    "ANANTAPUR": {
      "Peddakotla B.O": "515631",
      "Pinnadhari B.O": "515631",
      "Yerraguntapalle B.O": "515631",
      "Obulareddipalli B.O": "515581",
      "Odulapalli B.O": "515581",
      "Peddannavaripalli B.O": "515581",
      "Velichelamala B.O": "515581",
      "Gurrambailu B.O": "515571",
      "Marrimakulapalle B.O": "515631",
      "Modugulakunta B.O": "515631",
      "Kovvurivandlapalle B.O": "515581",
      "Nuthanakalva B.O": "515581",
      "Somalavandlapalle B.O": "515581",
      "Vepamanipeta B.O": "515581",
      "Ethodu B.O": "515571",
      "Pedaballi B.O": "515231",
      "Vankapalle B.O": "515571",
      "Hallikera Devarahalli B.O": "515311",
      "Inagalur B.O": "515311",
      "Kodihalli B.O": "515202",
      "Tammadehalli B.O": "515281",
      "Bussaiahgaripalli B.O": "515241",
      "Haludi B.O": "515311",
      "Madhudi B.O": "515311",
      "Narasambudi B.O": "515311",
      "P.Byadagere B.O": "515311",
      "Ragalinganahalli B.O": "515311",
      "Agraharam B.O": "515154",
      "Aladahalli B.O": "515281",
      "Chitnaduku B.O": "515281",
      "Halkur B.O": "515281",
      "Budidagaddapalli B.O": "515241",
      "Sreedharghatta B.O": "515871",
      "N.Thimmapuram B.O": "515842",
      "Poliki B.O": "515842",
      "Dosaludiki B.O": "515803",
      "Kottala B.O": "515803",
      "Ayyavaripalli B.O": "515722",
      "Chinnavadugur B.O": "515405",
      "Muradi B.O": "515865",
      "Obulapuram B.O": "515414",
      "Pallepalli B.O": "515865",
      "Appecharla B.O": "515455",
      "Chandana B.O": "515455",
      "Lakshumpalli B.O": "515455",
      "Chittur B.O": "515611",
      "Illuru B.O": "515611",
      "Kallumadi B.O": "515611",
      "Avuladatla B.O": "515867",
      "B.N.Halli B.O": "515867",
      "Belodu B.O": "515867",
      "Rayampalli B.O": "515812",
      "Renimakulapalli B.O": "515812",
      "Shaikshanipalli B.O": "515812",
      "Undabanda B.O": "515812",
      "Gadehothur B.O": "515832",
      "Kamalapadu B.O": "515408",
      "Bollanaguddem B.O": "515870",
      "Singanahalli B.O": "515871",
      "Uddihal B.O": "515871",
      "Kadadarabenchi B.O": "515842",
      "Budilisettipalli B.O": "515241",
      "Polepalli B.O": "515863",
      "Nelagonda B.O": "515842",
      "Kasapuram B.O": "515803",
      "Venkatampalli B.O": "515425",
      "Gangampalli B.O": "515231",
      "Guddadahalli B.O": "515271",
      "Hottethimmanahalli B.O": "515271",
      "Konkallu B.O": "515271",
      "Tallikera B.O": "515271",
      "Thirumaladevarapalli B.O": "515271",
      "Duddebanda B.O": "515164",
      "Kurubavandlapalli B.O": "515164",
      "Munimadugu B.O": "515164",
      "Sasanakota B.O": "515212",
      "Cherlokodigepalli B.O": "515303",
      "Manur B.O": "515303",
      "Kassamudram B.O": "515556",
      "Pulikintapalli B.O": "515556",
      "Apprascheruvu B.O": "515661",
      "Badannapalli B.O": "515672",
      "Chigicherla B.O": "515672",
      "Nasanakota B.O": "515672",
      "Ravulacheruvu B.O": "515672",
      "Sangala B.O": "515672",
      "Subbaraopeta B.O": "515672",
      "Gutibailu B.O": "515521",
      "Jeenulakunta B.O": "515521",
      "Kamatampalle B.O": "515521",
      "Katakamvaripalli B.O": "515521",
      "Kowlepalli B.O": "515591",
      "Muthyalacheruvu B.O": "515591",
      "Pulagampalli B.O": "515591",
      "Mundy Bazaar B.O": "515591",
      "Chennamanayani Kota B.O": "515641",
      "Dadalur B.O": "515641",
      "Elakuntla B.O": "515641",
      "Maruru B.O": "515641",
      "Nawabkota B.O": "515531",
      "Chippalamadugu B.O": "515541",
      "Lakkasamudram B.O": "515541",
      "Uppalapadu B.O": "515511",
      "Ubicherla B.O": "515551",
      "Gasikavaripalli B.O": "515154",
      "Chinnarayanipalli B.O": "515501",
      "Peddachigullarevu B.O": "515631",
      "Gowkanapalle B.O": "515581",
      "Kurlyreddivaripalli B.O": "515581",
      "Errakuntapalle B.O": "515571",
      "Gandhodivandlapalli B.O": "515571",
      "K.Mallireddipalle B.O": "515571",
      "Mundlavaripalli B.O": "515571",
      "Peddakadapalavaripalli B.O": "515571",
      "Hallikera B.O": "515311",
      "Karidasanahalli B.O": "515311",
      "Maddanakunta B.O": "515281",
      "Valasa B.O": "515281",
      "Kaganapalli B.O": "515241",
      "Mallepalli B.O": "515541",
      "Vadigepalli B.O": "515241",
      "Kuntimaddi B.O": "515101",
      "Nagasamudram B.O": "515401",
      "Thummalakunta B.O": "515341",
      "Jakkasamudram B.O": "515231",
      "Kammavaripalli B.O": "515231",
      "Kondapuram B.O": "515621",
      "Bommagondanahalli B.O": "515271",
      "Mutukuru B.O": "515271",
      "Venkatagiripalem B.O": "515164",
      "Nidraghatta B.O": "515286",
      "Malugur B.O": "515212",
      "Moda B.O": "515212",
      "Bullasamudram B.O": "515303",
      "Tummala B.O": "515556",
      "Ghntapuram B.O": "515661",
      "Musturu B.O": "515661",
      "Potlamarri B.O": "515661",
      "Buchayyagaripalli B.O": "515144",
      "Kesapuram B.O": "515144",
      "Mylasamudram B.O": "515144",
      "Narepalli B.O": "515144",
      "D.Cherlopalli B.O": "515672",
      "Darsimala B.O": "515672",
      "Mallakalva B.O": "515672",
      "Ramagiri B.O": "515672",
      "Tallimadugu B.O": "515672",
      "Dhaniyancheruvu B.O": "515521",
      "Katarupalle B.O": "515521",
      "Malamidipalli B.O": "515521",
      "N.P.Kunta B.O": "515521",
      "Bommireddipalli B.O": "515591",
      "K.Brahmanapalli B.O": "515591",
      "Narasampalli B.O": "515641",
      "Thogarakunta B.O": "515641",
      "Dabburivaripalli B.O": "515531",
      "Donnikota B.O": "515531",
      "Jagarajupalli B.O": "515133",
      "Locherla B.O": "515133",
      "Elukuntla B.O": "515159",
      "Jonnalakothapalli B.O": "515159",
      "Nallacherlopalli B.O": "515159",
      "Kondaguttapalli B.O": "515541",
      "Pothulanagepalli B.O": "515651",
      "Veldurthi B.O": "515651",
      "Gandlavandlapalli B.O": "515511",
      "Marthadu B.O": "515731",
      "N.Narsapuram B.O": "515803",
      "Anumpalli B.O": "515775",
      "Devarapalli B.O": "515775",
      "Vankarajukalva B.O": "515775",
      "Dimmagudi B.O": "515405",
      "Lachumpalli B.O": "515405",
      "Ramarajupalli B.O": "515405",
      "Kalyam B.O": "515865",
      "Muradi Hanumapuram B.O": "515865",
      "R.B.Vanka B.O": "515865",
      "Krishtipadu B.O": "515455",
      "Nagarur B.O": "515455",
      "Chitrachedu B.O": "515611",
      "Bommakkapalli B.O": "515867",
      "Unthakallu B.O": "515871",
      "Yerragunta B.O": "515722",
      "Chayapuram B.O": "515842",
      "Donekal B.O": "515842",
      "Gulapalyam B.O": "515842",
      "Thimmapuram B.O": "515765",
      "Eddulapalli B.O": "515775",
      "G.Kottala B.O": "515775",
      "Kalapuram B.O": "515775",
      "Katrimala B.O": "515775",
      "Mamadur B.O": "515405",
      "Miduthur B.O": "515405",
      "Lakshmi Bazar B.O": "515865",
      "Rayadurg Fort B.O": "515865",
      "Chadam B.O": "515865",
      "Kallagiri B.O": "515241",
      "Nyamaddala B.O": "515101",
      "Puletipalli B.O": "515101",
      "Tekulodu B.O": "515341",
      "Karavulapalli B.O": "515231",
      "Vanavolu B.O": "515231",
      "M.Rayapuram B.O": "515271",
      "Mandalahalli B.O": "515271",
      "Phalaram B.O": "515271",
      "Srirangarajupalli B.O": "515212",
      "Cheepuleti B.O": "515303",
      "Chikirevulapalli B.O": "515556",
      "Malyavantham B.O": "515661",
      "Darga Kondaopuram B.O": "515865",
      "Gramadatla B.O": "515865",
      "Pulakurthy B.O": "515865",
      "R.Kothapalli B.O": "515865",
      "T.Veerapuram B.O": "515865",
      "Veerapuram B.O": "515341",
      "Puppala B.O": "515455",
      "Ravuludiki B.O": "515455",
      "Rachepalli B.O": "515611",
      "Netrapalli B.O": "515867",
      "Rangachedu B.O": "515867",
      "Nemakallu B.O": "515871",
      "Gadekal B.O": "515842",
      "Hanchanahal B.O": "515842",
      "Uravakonda (Bus Stand) B.O": "515812",
      "Nakkanadoddi B.O": "515803",
      "Gajarampalli B.O": "515775",
      "Khaderpeta B.O": "515775",
      "Narasimpalli B.O": "515661",
      "Palyam B.O": "515775",
      "Edurur B.O": "515405",
      "Mallenipalli B.O": "515405",
      "Teliki B.O": "515405",
      "Gollapalli B.O": "515425",
      "Kadalur B.O": "515865",
      "Pulakunta B.O": "515865",
      "Pulicherla B.O": "515865",
      "Somalapuram B.O": "515865",
      "Chintalacheruvu B.O": "515455",
      "Thutrallapalli B.O": "515455",
      "Thabjula B.O": "515445",
      "Alamuru B.O": "515002",
      "Narasimpalli Thanda B.O": "515144",
      "Gotluru B.O": "515672",
      "Nallaboyanapalle B.O": "515672",
      "Regatipalli B.O": "515672",
      "Marrikommadinne B.O": "515521",
      "Mekalacheruvu B.O": "515521",
      "Inagaluru B.O": "515591",
      "Bhadrapuram B.O": "515641",
      "Mukthapuram B.O": "515159",
      "Sandrascherla B.O": "515641",
      "Thumucherla B.O": "515641",
      "Bonthalapalle B.O": "515571",
      "Eddulavaripalli B.O": "515531",
      "Kappalabanda B.O": "515133",
      "Marakuntapalli B.O": "515133",
      "Venkatagaripalli B.O": "515133",
      "Marala B.O": "515159",
      "Erradoddi B.O": "515541",
      "Kadiri Kuntlapalli B.O": "515541",
      "Kondamanayanipalem B.O": "515541",
      "Kadiripulikunta B.O": "515551",
      "Peddayellampalli B.O": "515551",
      "Gowrapuram B.O": "515561",
      "Thippepalle B.O": "515561",
      "Kothakota B.O": "515870",
      "Siddarampuram B.O": "515701",
      "Chowtakuntapalli B.O": "515501",
      "East Nadimpalle B.O": "515581",
      "Gangivaripalli B.O": "515581",
      "Balasamudram B.O": "515571",
      "Cheekatimanipalli B.O": "515571",
      "Chinnaramannagaripalli B.O": "515571",
      "Diguvathotlipalli B.O": "515571",
      "Kokkanti B.O": "515571",
      "Kondavenukapalli B.O": "515571",
      "Korthikota B.O": "515571",
      "Kotapalli B.O": "515571",
      "Palasamudram B.O": "515241",
      "Pathikuntapalli B.O": "515241",
      "Reddicheruvupalli B.O": "515241",
      "Thungodu B.O": "515241",
      "Gantimarri B.O": "515101",
      "Mustikovela B.O": "515101",
      "Bhupasamudram B.O": "515867",
      "Kanisettipalli B.O": "515144",
      "Lalepalli B.O": "515341",
      "Gownivaripalli B.O": "515231",
      "Gummaiahgaripalli B.O": "515231",
      "Guvvalaguttapalli B.O": "515231",
      "Mandalapalle B.O": "515231",
      "Puleru B.O": "515231",
      "Chikkachoragiri B.O": "515271",
      "Gunemorubagal B.O": "515286",
      "Kenkara B.O": "515286",
      "Morubagalu B.O": "515286",
      "Nachenahalli B.O": "515286",
      "Sivaram B.O": "515286",
      "Birepalli B.O": "515212",
      "Kotnur B.O": "515212",
      "Manesamudram B.O": "515212",
      "Chinnaganapalle B.O": "515556",
      "Gubanapalli B.O": "515763",
      "Vitlampalli B.O": "515763",
      "Janthaluru B.O": "515701",
      "Rotarypuram B.O": "515701",
      "Ullikallu B.O": "515611",
      "Junjurampalli B.O": "515867",
      "Budagavi B.O": "515812",
      "Cheekalagurki B.O": "515812",
      "Dharmapuri B.O": "515812",
      "Mopidi B.O": "515812",
      "Vekigonda B.O": "515812",
      "P.C.Peapully B.O": "515832",
      "Pottipadu B.O": "515832",
      "Karakamukkala B.O": "515870",
      "Kottalapalli B.O": "515870",
      "Narasapuram B.O": "515763",
      "Pillalapalli B.O": "515763",
      "C Bandameedapalli B.O": "515701",
      "K.K.Agraharam B.O": "515701",
      "Peravali B.O": "515701",
      "Reddipalli B.O": "515501",
      "Bhogasamudram B.O": "515415",
      "Kaverisamudram B.O": "515415",
      "Sajjaladinne B.O": "515415",
      "Kadavakallu B.O": "515445",
      "Peddapappuru B.O": "515445",
      "Kakkalpalli B.O": "515002",
      "Upparapalli B.O": "515002",
      "Kamarupalli B.O": "515751",
      "Havaligi B.O": "515870",
      "Pasalur B.O": "515408",
      "Peddayakkalur B.O": "515408",
      "Vemulapadu B.O": "515408",
      "Kannepalli B.O": "515763",
      "Muppalakunta B.O": "515763",
      "Yelagalavanka B.O": "515763",
      "Arakatavemula B.O": "515445",
      "Kothapalli B.O": "515731",
      "Kurugunta B.O": "515751",
      "Madigubba B.O": "515751",
      "Manirevu B.O": "515751",
      "Ramasagaram B.O": "515159",
      "Seeripi B.O": "515741",
      "Srirangapuram B.O": "515741",
      "Thagguparthi B.O": "515741",
      "Y Rama Puram B.O": "515741",
      "Yerragudi B.O": "515741",
      "Kancharavandlapalli B.O": "515556",
      "Nidigallu B.O": "515661",
      "Sanjeevapuram B.O": "515661",
      "Amagondapalem B.O": "515144",
      "Ganginepalli B.O": "515144",
      "Kodapaganipalli B.O": "515144",
      "Vengalammacheruvu B.O": "515144",
      "Dampetla B.O": "515672",
      "Kunuthuru B.O": "515672",
      "N.Madapuram B.O": "515672",
      "Thummala B.O": "515672",
      "Kurumamidi B.O": "515521",
      "P.Kothapalli B.O": "515551",
      "Eguvagangireddipalli B.O": "515531",
      "Kurumala B.O": "515531",
      "Mirjapuram B.O": "515133",
      "Nagireddipalli B.O": "515133",
      "Pothulakunta B.O": "515133",
      "Talamarla B.O": "515133",
      "Gunjepalli B.O": "515159",
      "Nelakota B.O": "515159",
      "Neerukuntapalle B.O": "515541",
      "Amidalakunta B.O": "515651",
      "Basampalli B.O": "515651",
      "Kanumukkala B.O": "515651",
      "Budanampalle B.O": "515511",
      "Dorigallu B.O": "515511",
      "Chowtivaripalle B.O": "515551",
      "Mohammadabad B.O": "515561",
      "Nallaguttapalli B.O": "515561",
      "Niluvarathipalli B.O": "515561",
      "Sunnampalle B.O": "515561",
      "Pandulakunta B.O": "515541",
      "Pyadindi B.O": "515651",
      "Kodavandlapalle B.O": "515511",
      "Sankepalle B.O": "515511",
      "Tavalamarri B.O": "515551",
      "Uruvoi Mallireddypalli B.O": "515551",
      "Gownipalli B.O": "515561",
      "Javukulakothapalle B.O": "515561",
      "Tangedikunta B.O": "515561",
      "Govindawada B.O": "515812",
      "Honnur B.O": "515812",
      "Janardhanapalli B.O": "515812",
      "Lathavaram B.O": "515812",
      "Ragulapadu B.O": "515832",
      "Tatrakallu B.O": "515832",
      "Velpumadugu B.O": "515870",
      "Thummalakuntapalli B.O": "515561",
      "Gunipalli B.O": "515154",
      "Mangalamadaka B.O": "515154",
      "Brahmanapalli B.O": "515401",
      "Cheemalavagupalli B.O": "515408",
      "Chintalayalapalli B.O": "515408",
      "Gudipadu B.O": "515408",
      "Muttala B.O": "515751",
      "P Siddarampuram B.O": "515751",
      "Duddekunta B.O": "515741",
      "Nakkalapalli B.O": "515741",
      "Aydukallu B.O": "515763",
      "Podarallapalli B.O": "515154",
      "Badavandlapalli B.O": "515501",
      "S.Rayapuram B.O": "515291",
      "Utukuru B.O": "515261",
      "Adadakulapalli B.O": "515124",
      "Chinnamanthur B.O": "515124",
      "Mavatur B.O": "515124",
      "Settipalli B.O": "515110",
      "Gurrapukonda B.O": "515305",
      "Jambalabanda B.O": "515305",
      "Dodaghatta B.O": "515123",
      "Gowrajupalle B.O": "515123",
      "Rachuru B.O": "515123",
      "Thurukalapatnam B.O": "515123",
      "Challapalli B.O": "515122",
      "Rangepalli B.O": "515122",
      "Suddakuntapalli B.O": "515122",
      "Nallamada B.O": "515501",
      "Vellamaddi B.O": "515501",
      "Rayalappadoddi B.O": "515763",
      "Theetakallu B.O": "515763",
      "Danduvaripalli B.O": "515701",
      "Korrapadu B.O": "515701",
      "Venkatapuram B.O": "515701",
      "Aluru B.O": "515415",
      "Igaduru B.O": "515415",
      "Chikkepalli B.O": "515445",
      "Muchukota B.O": "515445",
      "Parsannayapalli B.O": "515002",
      "Goridindla B.O": "515751",
      "Oddupalli B.O": "515751",
      "P Yaleru B.O": "515751",
      "Avulanna B.O": "515741",
      "Hanakanahal B.O": "515741",
      "Narinjagundlapalli B.O": "515741",
      "Budimepalli B.O": "515763",
      "Gonchireddypalli B.O": "515763",
      "Kenchanapalli B.O": "515867",
      "Veparalla B.O": "515867",
      "Chabala B.O": "515812",
      "Chinnamusturu B.O": "515812",
      "Mallapuram B.O": "515812",
      "Katakindapalli B.O": "515832",
      "Pandikunta B.O": "515832",
      "Palthur B.O": "515870",
      "Konauppalapadu B.O": "515408",
      "Nitturu B.O": "515408",
      "Bramhanayaleru B.O": "515002",
      "Bukkacherla B.O": "515002",
      "P Narayana Puram B.O": "515751",
      "Sanapa B.O": "515751",
      "Talupuru B.O": "515751",
      "Ankampalli B.O": "515741",
      "Kurakulapalli B.O": "515621",
      "Vepakunta B.O": "515621",
      "Atmakur B.O": "515631",
      "Garisalapalli B.O": "515631",
      "Maravapalli Agraharam B.O": "515631",
      "Vittapalli B.O": "515261",
      "Cholemarri B.O": "515124",
      "Kalipi B.O": "515124",
      "Mandli B.O": "515124",
      "Bandlapalli B.O": "515425",
      "Byrapuram B.O": "515110",
      "Karikera B.O": "515305",
      "Kumbaranagenahalli B.O": "515305",
      "Sankarakallu B.O": "515305",
      "Edulaballapuram B.O": "515122",
      "Gudipalli B.O": "515122",
      "Honnampalli B.O": "515261",
      "Sirekolam B.O": "515261",
      "Nagalur B.O": "515124",
      "Chennarajupalli B.O": "515110",
      "Konapuram B.O": "515761",
      "Venkatareddipalli B.O": "515415",
      "Basavanahalli B.O": "515305",
      "Hirethurpi B.O": "515305",
      "Bucherla B.O": "515123",
      "Gonimekalapalli B.O": "515123",
      "Dokkalahalli B.O": "515321",
      "Rathnagiri B.O": "515321",
      "Chakarlapalli B.O": "515122",
      "Chalakur B.O": "515122",
      "Pandiparthi B.O": "515122",
      "Enumulavaripalli B.O": "515501",
      "Beechaganipalli B.O": "515261",
      "Brahmasamudram B.O": "515871",
      "Cherukuru B.O": "515124",
      "Nallur B.O": "515124",
      "Sanipalli B.O": "515124",
      "Gonipeta B.O": "515110",
      "Kotlapalli B.O": "515110",
      "Nidimamidi B.O": "515110",
      "Rachavaraipalli B.O": "515110",
      "Hanumpalli B O": "515110",
      "Kogira B.O": "515123",
      "Mulakalacheruvu B.O": "515123",
      "Naranagepalli B.O": "515123",
      "R.Locherla B.O": "515123",
      "Dodderi B.O": "515321",
      "Hulikunta B.O": "515321",
      "Kaki B.O": "515321",
      "Nadimpalli B.O": "515122",
      "Naginayanicheruvu Thanda B.O": "515122",
      "Gopepalli B.O": "515501",
      "Motorchintalapalle B.O": "515621",
      "Kutalacheruvupalli B.O": "515501",
      "Malakavemula B.O": "515501",
      "Vankarakunta B.O": "515501",
      "Achampalle B.O": "515621",
      "Bhanukota B.O": "515621",
      "Chennampalli B.O": "515425",
      "Garimakulapalli B.O": "515621",
      "Maddalacheruvu B.O": "515621",
      "Pitchireddikottala B.O": "515621",
      "Ralla Anantapuram B.O": "515621",
      "Beedupalli B.O": "515134",
      "Brahmanapalle B.O": "515134",
      "Puttaparthi B.O": "515134",
      "Yenumulapalli B.O": "515134",
      "Chillakondayapalli B.O": "515631",
      "Chillavaripalle B.O": "515631",
      "Chinnachigullarevu B.O": "515631",
      "Dadithota B.O": "515631",
      "Kalasamudram B.O": "515501",
      "Pemanakuntapalli Thanda B.O": "515501",
      "Konetinayanipalem B.O": "515621",
      "Badenaikthanda B.O": "515134",
      "Kunukuntla B.O": "515631",
      "Santhebidanur B.O": "515211",
      "Somaghatta B.O": "515601",
      "Galibipalli B.O": "515331",
      "Kondur B.O": "515331",
      "Haresamudram B.O": "515301",
      "Yerrabommanahalli B.O": "515301",
      "BIT College BO": "515202",
      "Gangulavaipalem B.O": "515291",
      "Bevinahalli B.O": "515211",
      "Chowluru B.O": "515211",
      "Gollapuram B.O": "515211",
      "Kotipi B.O": "515211",
      "Cholasamudram B.O": "515711",
      "Demakethapalli B.O": "515331",
      "Kalluru B.O": "515465",
      "R.Anantapuram B.O": "515303",
      "Uppidipalli B.O": "515303",
      "Thumukunta Industrial Estate B.O": "515211",
      "Chagaleru B.O": "515601",
      "Kodur B.O": "515601",
      "Morasalapalli B.O": "515601",
      "Bisalamanepalli B.O": "515331",
      "Amidalagondi B.O": "515301",
      "Aswartharayaniroppam B.O": "515301",
      "Byagarlapalli B.O": "515301",
      "Chandakacherla B.O": "515301",
      "Hindupur Fort B.O": "515202",
      "Kaggallu B.O": "515202",
      "Dasappapalyam B.O": "515291",
      "Guddampalle B.O": "515291",
      "Gudduguriki B.O": "515291",
      "Mamidimakulapalli B.O": "515331",
      "Manepalli B.O": "515331",
      "Mydugolam B.O": "515331",
      "Sirivaram B.O": "515331",
      "Zilladakunta B.O": "515301",
      "P.Sadlapalli B.O": "515202",
      "Hottebetta B.O": "515291",
      "Kothagundumala B.O": "515291",
      "Pathapalle B.O": "516464",
      "Yelloti B.O": "515303",
      "S.Sadlapalli B.O": "515211",
      "Morampalle B.O": "515601",
      "Nesevandlapalli B.O": "515601",
      "Chalivendla B.O": "515331",
      "Kanchisamudram B.O": "515331",
      "Gowdanahalli B.O": "515301",
      "Melavoy B.O": "515301",
      "Madakasira Bazaar B.O": "515301",
      "Pulakunta B O": "515202",
      "Govindapuram B.O": "515291",
      "Urichintala B.O": "515415",
      "Velamakur B.O": "515415",
      "Jambuladinne B.O": "515731",
      "Kotanka B.O": "515731",
      "Podaralla B.O": "515731",
      "Thimmampeta B.O": "515731",
      "Yerraguntla B.O": "515731",
      "Rajiv Colony B.O": "515004",
      "Somaladoddi B.O": "515004",
      "Gandlaparthi B.O": "515722",
      "Hampapuram B.O": "515722",
      "Dodagatta B.O": "515761",
      "Mudigal B.O": "515761",
      "Palavoyi B.O": "515761",
      "Palluru B.O": "515765",
      "Vontareddipalli B.O": "515765",
      "Yenumuladoddi B.O": "515765",
      "Chiyyedu B.O": "515721",
      "Pulukunta B.O": "515721",
      "Jallipalli B.O": "515711",
      "Korrakodu B.O": "515711",
      "Marutla B.O": "515711",
      "Allapuram B.O": "515766",
      "Basapuram B.O": "515766",
      "Kuraganipalli B.O": "515425",
      "Nadimidoddi B.O": "515425",
      "Karthanaparthi B.O": "515787",
      "Muddinayanipalli B.O": "515787",
      "Chalivemula B.O": "515414",
      "Cherlopalli B.O": "515766",
      "Maddipalli B.O": "515414",
      "Therannapalli B.O": "515414",
      "Kanampalli B.O": "515731",
      "Taticherla B.O": "515731",
      "Vadiampeta B.O": "515731",
      "Rudrampeta B.O": "515004",
      "Tapovanagar B.O": "515004",
      "Palacherla B.O": "515722",
      "Gangavaram B.O": "515761",
      "Papampalli B.O": "515761",
      "Yatakal B.O": "515761",
      "Dasampalli B.O": "515765",
      "Tenagal B.O": "515765",
      "Mannila B.O": "515721",
      "Kadadarakunta B.O": "515711",
      "Akuledu B.O": "515731",
      "Guddalapalli B.O": "515731",
      "Bandameedapalli B.O": "515722",
      "Gondireddypalli B.O": "515722",
      "Golla B.O": "515761",
      "K Garudapuram B.O": "515761",
      "Kalvapalli B.O": "515761",
      "Kurabanahalli B.O": "515761",
      "Narayanapuram B.O": "515761",
      "Ontimiddi B.O": "515761",
      "Marrimakulapalli B.O": "515765",
      "Mulakanur B.O": "515765",
      "Kalagalla B.O": "515711",
      "Kammuru B.O": "515711",
      "Pabr Sam Site B.O": "515711",
      "Udiripikonda B.O": "515711",
      "Lakshmampalli B.O": "515465",
      "Malayanuru B.O": "515766",
      "Nizava.Lli B.O": "515766",
      "Thumukunta B.O": "515766",
      "Vaddepalem B.O": "515766",
      "Ganganapalli B.O": "515425",
      "Gugudu B.O": "515425",
      "H Sodanapalli B.O": "515425",
      "Julakalva B.O": "515425",
      "Kesepalli B.O": "515425",
      "Bhattuvanipalli B.O": "515787",
      "Chintakunta B.O": "515414",
      "Diguvapalli B.O": "515414",
      "Garuguchintalapallo B.O": "515414",
      "Cheliminahalli B.O": "515767",
      "Chintarlapalli B.O": "515767",
      "Thippanapalli B.O": "515767",
      "Salakamcheruvu B.O": "515435",
      "Bondaladinne B.O": "515411",
      "Rajaji Street B.O": "515005",
      "M.P.R.Site B.O": "515731",
      "Penakacherla B.O": "515731",
      "A Narayanapuram B.O": "515004",
      "Kakkalapalli Colony B.O": "515004",
      "Narasanenikunta B.O": "515004",
      "Rachanapalli B.O": "515004",
      "Raptadu B.O": "515722",
      "Thopudurthi B.O": "515722",
      "Bavarampalli B.O": "515761",
      "Chapiri B.O": "515761",
      "Chinnampalli B.O": "515761",
      "Virupapalli B.O": "515761",
      "Yerrampalli B.O": "515761",
      "Handepalli B.O": "515765",
      "Kadiridevarapalli B.O": "515765",
      "Gotkuru B.O": "515711",
      "Ipperu B.O": "515711",
      "Bestharapalli B.O": "515766",
      "Jambugumpala B.O": "515766",
      "Kadarampalli B.O": "515766",
      "Bondalawada B.O": "515425",
      "Chamaluru B.O": "515425",
      "Ramapuram B.O": "515787",
      "Thimmasamudram B.O": "515787",
      "Yenumulachennampalli B.O": "515787",
      "Komatikuntla B.O": "515414",
      "Kanakuru B.O": "515767",
      "Khairevu B.O": "515767",
      "Yerraguntapalli B.O": "515411",
      "Chintakayamanda B.O": "515465",
      "Ayyagarlapalli B.O": "515767",
      "Bhyrasamudram B.O": "515767",
      "Mamaduru B.O": "515767",
      "Parlachedu B.O": "515767",
      "Narasapuram East B.O": "515435",
      "Challavaripalli B.O": "515411",
      "Peddapolamada B.O": "515411",
      "Vanganuru B.O": "515411",
      "Araveedu B.O": "515465",
      "Lingareddipalli B.O": "515465",
      "Medikurthi B.O": "515465",
      "Vennupusalapalli B.O": "515465",
      "Pedda Kowkuntla B.O": "515822",
      "Sollapuram B.O": "515822",
      "Basinepalli B.O": "515402",
      "Gootyanantapur B.O": "515401",
      "Isurallapalli B.O": "515401",
      "Pedoddi B.O": "515401",
      "Gundiganipalli B.O": "515863",
      "Kodihalli West B.O": "515863",
      "Kesavapuram B.O": "515774",
      "Bommanahal B.O": "515871",
      "Ganigera B.O": "515871",
      "Godasalapalli B.O": "515871",
      "Karutlapalli B.O": "515711",
      "Muddalapuram B.O": "515711",
      "Appilepalli B.O": "515766",
      "Duggumarri B.O": "515425",
      "Madugupalli B.O": "515425",
      "Pappuru B.O": "515425",
      "Yellutla B.O": "515425",
      "Durdakunta B.O": "515787",
      "Kodipalli East B.O": "515787",
      "Kummanamala B.O": "515414",
      "Takkalapalli B.O": "515414",
      "Brahma Samudram B.O": "515767",
      "Mulakaledu B.O": "515767",
      "Narasapuram West B.O": "515435",
      "Chinnapolamada B.O": "515411",
      "Juturu B.O": "515411",
      "Senagalaguduru B.O": "515411",
      "Chilamakuru B.O": "515465",
      "Goddumarri B.O": "515465",
      "Kuchivaripalli B.O": "515465",
      "Raketla B.O": "515822",
      "Bethapalli B.O": "515402",
      "Gollaladoddi B.O": "515401",
      "Jakkalacheruvu B.O": "515401",
      "Pathakothacheruvu B.O": "515401",
      "Gonabhavi B.O": "515863",
      "Vepalaparthy B.O": "515863",
      "Koppalakonda B.O": "515774",
      "Devagiri B.O": "515871",
      "Kolaganahalli B.O": "515871",
      "Malyam B.O": "515871",
      "Singavaram B.O": "515465",
      "Thimmampalli B.O": "515465",
      "N.Hanumapuram B.O": "515822",
      "Nimbagallu B.O": "515822",
      "Kojjepalli B.O": "515401",
      "Konganapalli B.O": "515401",
      "B.T.Project B.O": "515863",
      "Kalugodu B.O": "515863",
      "Garudachedu B.O": "515871",
      "Jangampalli B.O": "515465",
      "Karidikonda B.O": "515402",
      "Kothapeta(Gooty) B.O": "515401",
      "Rajapuram B.O": "515401",
      "Thondapadu B.O": "515401",
      "Y.T.Cheruvu B.O": "515401",
      "Tallakera B.O": "515863",
      "Muntimadugu B.O": "515774",
      "Gonehal B.O": "515871",
      "Kalekurthy B.O": "515871",
      "Kudlur B.O": "515871",
      "Kuruvalli B.O": "515871",
      "Nagalapuram B.O": "515871",
      "Kundurpi S.O": "515766",
      "Putlur S.O": "515414",
      "Ramachandra Nagar S.O": "515001",
      "Guntakal H.O": "515801",
      "Kuderu S.O (Ananthapur)": "515711",
      "Old Town S.O (Ananthapur)": "515005",
      "Dharmavaram H.O": "515671",
      "Anantapur H.O": "515001",
      "Narapla S.O": "515425",
      "Kandukur S.O": "515721",
      "Motilal Street S.O": "515004",
      "Nuthimadugu S.O": "515787",
      "Patel Road S.O": "515001",
      "Hindupur H.O": "515201",
      "Dharmavaram R.S S.O": "515672",
      "Kondakamarla S.O": "515531",
      "Kothacheruvu S.O": "515133",
      "Pamudurthi S.O": "515154",
      "Chilamathur S.O": "515341",
      "Hindupur Sevamandir S.O": "515212",
      "Kallumarri S.O": "515303",
      "Parigi S.O": "515261",
      "Peddamanthur S.O": "515124",
      "Rallahalli S.O": "515305",
      "Atmakur(ATP) S.O": "515751",
      "Reddivaripalem S.O": "515411",
      "Singanamala S.O": "515435",
      "Yellanur S.O": "515465",
      "Guntakal Market S.O": "515801",
      "Herial S.O": "515872",
      "Old Guntakal S.O": "515803",
      "Pedda Vadagur S.O": "515405",
      "Rajendra Nagar S.O (Ananthapur)": "515801",
      "Rayalacheruvu S.O": "515455",
      "Tarimala S.O": "515611",
      "Uravakonda S.O": "515812",
      "Ammaladinne S.O": "515445",
      "Anantapur Collectorate S.O": "515001",
      "Belguppa S.O": "515741",
      "Bhogasamudram Project S.O": "515413",
      "Bommaganipalli S.O": "515763",
      "Bukkarayasamudram S.O": "515701",
      "Chukkalur S.O": "515415",
      "Georgepet S.O": "515004",
      "Anantapur Engg College S.O": "515002",
      "Jayalakshmipuram S.O (Ananthapur)": "515722",
      "Kalyandurg Bazar S.O": "515761",
      "Tadpatri Bus Stand S.O": "515411",
      "Railway Colony S.O (Ananthapur)": "515801",
      "Rayadurg S.O": "515865",
      "Udegolam S.O": "515867",
      "Vajrakarur S.O": "515832",
      "Vidapanakal S.O": "515870",
      "Aravindanagar S.O": "515001",
      "Gandhibazar S.O (Ananthapur)": "515005",
      "Garladinne S.O": "515731",
      "Kalyandurg S.O": "515761",
      "Kambadur S.O": "515765",
      "Bathalapalli S.O": "515661",
      "Dharmavaram Bazar S.O": "515671",
      "Gandlapenta S.O": "515521",
      "Kadiri S.O": "515591",
      "Krishnapuram S.O (Ananthapur)": "515159",
      "Prasanthigram S.O": "515134",
      "Tadimarri S.O": "515631",
      "Talupula S.O": "515581",
      "Budili S.O": "515241",
      "Gorantla S.O": "515231",
      "Hemavathi S.O": "515286",
      "Hindupur Extns S.O": "515201",
      "Kodikonda S.O": "515601",
      "Madakasira S.O": "515301",
      "Neelakantapuram S.O": "515291",
      "Penukonda Fort S.O": "515110",
      "Roddam S.O": "515123",
      "Rolla S.O": "515321",
      "Somandepalli S.O": "515122",
      "Bukkapatnam S.O": "515144",
      "Kadiri Chowk S.O": "515591",
      "Prasanthinilayam S.O": "515134",
      "Chennekothapalli S.O": "515101",
      "Lepakshi S.O": "515331",
      "Amadagur S.O": "515556",
      "Clock Tower Kadiri S.O": "515591",
      "Kanaganapalli S.O": "515641",
      "Kutagulla S.O": "515541",
      "Medapuram S.O": "515651",
      "Mudigubba S.O": "515511",
      "Nallacheruvu S.O": "515551",
      "Obula Devara Cheruvu S.O": "515561",
      "Patnam S.O": "515501",
      "Perur S.O (Ananthapur)": "515621",
      "Tanakallu S.O": "515571",
      "Ramnagar S.O (Ananthapur)": "515004",
      "Tadpatri Bazar S.O": "515411",
      "Tadpatri Extension S.O": "515411",
      "Tadpatri S.O": "515411",
      "Gooty Bazaar S.O": "515401",
      "Gooty R.S. S.O": "515402",
      "Hanumesh Nagar S.O": "515801",
      "Kallur R.S. S.O": "515774",
      "Kanekal S.O": "515871",
      "Konakondla S.O": "515842",
      "Modinabad S.O": "515801",
      "Pamidi S.O": "515775",
      "Timmanacharla S.O": "515801",
      "Yadiki S.O": "515408",
      "Sainagar S.O": "515001",
      "Satyanandanagar S.O": "515001",
      "Shettur S.O": "515767",
      "Sri Venkateswara Puram S.O": "515003",
      "Amidyaya S.O": "515822",
      "Gooty S.O": "515401",
      "Gummaghatta S.O": "515863",
      "Rayadurg  Bazar S.O": "515865",
      "Puttaparthy Main Bazar NDTSO": "515134",
      "Agali S.O (Ananthapur)": "515311",
      "Amarapuram S.O": "515281",
      "Gudibanda S.O (Ananthapur)": "515271",
      "Guttur S.O": "515164",
      "Kirikera S.O": "515211",
      "Muddireddypalli S.O": "515202",
      "Penukonda S.O": "515110"
    },
    "WEST GODAVARI": {
      "Kavuluru BO": "534176",
      "Gollavanitippa B.O": "534239",
      "Losari gutlapadu B.O": "534239",
      "Tokatippa B.O": "534239",
      "Doddanapudi B.O": "534237",
      "Kallakuru B.O": "534237",
      "Kolanapalli B.O": "534237",
      "Panjavemavaram B.O": "534247",
      "Tokalapudi B.O": "534247",
      "Toleru B.O": "534247",
      "Annavaram B.O": "534202",
      "Gollalakoderu B.O": "534202",
      "Taderu B.O": "534202",
      "Dusanapudi B.O": "534243",
      "Perkipalem B.O": "534243",
      "Nandamurugaruvu B.O": "534243",
      "Kalisipudi B.O": "534199",
      "Uradallapalem LWE B.O": "534134",
      "Andaluru B.O": "534238",
      "Nelapogula B.O": "534240",
      "Jakkaram B.O": "534206",
      "Kumudavalli B.O": "534210",
      "Ankoderu B.O": "534208",
      "China amiram B.O": "534204",
      "Pedagaruvu B.O": "534207",
      "Arthamuru B.O": "534199",
      "Appanna Cheruvu B.O": "534267",
      "Kavalipuram B.O": "534222",
      "Veerabhadrapuram B.O": "534222",
      "Prathikollanka B.O": "534004",
      "Challachintalapudi B.O": "534425",
      "R.Pangidigudem B.O": "534425",
      "Nimmalagudem B.O": "534448",
      "Rachuru B.O": "534406",
      "Regulakunta B.O": "534448",
      "Gollagudem B.O": "534406",
      "Ravulaparru B.O": "534406",
      "Balavarigudem B.O": "534460",
      "Kanthampalem B.O": "534460",
      "Raghavapuram B.O": "534460",
      "Venkatapuram B.O": "534460",
      "K.Gokavaram B.O": "534462",
      "Mattamagudem B.O": "534462",
      "Dorasanipadu B.O": "534426",
      "Timmapuram B.O": "534426",
      "Akkampeta B.O": "534455",
      "Marlagudem B.O": "534455",
      "Perampeta B.O": "534455",
      "Ankannagudem B.O": "534003",
      "P.Rajavaram B.O": "534456",
      "Ratsannagudem B.O": "534456",
      "Vankavarigudem B.O": "534456",
      "Ankalampadu B.O": "534449",
      "Uppalapadu B.O": "534449",
      "Kandrikagudem B.O": "534311",
      "Koyarajahmundry B.O": "534311",
      "Puliramannagudem B.O": "534311",
      "Atchuthapuram B.O": "534312",
      "Dippakayalapadu B.O": "534312",
      "Jagannadhapuram BO": "534475",
      "Tirumalapuram B.O": "534312",
      "Yerrampeta B.O": "534312",
      "Borrampalem B.O": "534451",
      "Sankuchakrapuram B.O": "534461",
      "Amberpeta B.O": "534401",
      "Kallacheruvu B.O": "534452",
      "Sagipadu B.O": "534452",
      "N.R.P. Agraharam B.O": "534199",
      "Pamulaparru B.O": "534199",
      "Vandram B.O": "534206",
      "Tillapudi B.O": "534245",
      "Nelamuru B.O": "534126",
      "Voduru B.O": "534126",
      "Deva B.O": "534123",
      "Matla Palem B.O": "534266",
      "Kalagam Pudi B.O": "534268",
      "Konteru B.O": "534268",
      "Ravipadu B.O": "534156",
      "Mattaparru B.O": "534265",
      "Vedangi Palem B.O": "534265",
      "Varidhanam B.O": "534265",
      "Pemmaraju Polavaram B.O": "534338",
      "Dagguluru B.O": "534250",
      "Kommuchikkala B.O": "534338",
      "Poolapalli B.O": "534250",
      "Serepalem B.O": "534281",
      "Darabharevu B.O": "534275",
      "Lakshmaneswaram B.O": "534275",
      "Korukollu B.O": "534209",
      "Mamuduru B.O": "534238",
      "Matsyapuri B.O": "534207",
      "Vempa B.O": "534207",
      "Cherukuwada B.O": "534199",
      "Chilukuru B.O": "534199",
      "Bandamcherla B.O": "534467",
      "Linganaboyinacherla B.O": "534275",
      "Kummarapurugupalem B.O": "534280",
      "Ramannapalem B.O": "534313",
      "Kommara B.O": "534196",
      "Minavilluru B.O": "534134",
      "Arjunudupalem B.O": "534217",
      "K.Illindalaparru B.O": "534217",
      "Annavarappadu B.O": "534330",
      "Tetali B.O": "534218",
      "Dammennu B.O": "534227",
      "Velagaduuru B.O": "534227",
      "Eletipadu B.O": "534320",
      "Kothalaparru B.O": "534320",
      "East Vipparru B.O": "534328",
      "Kapavaram B.O": "534342",
      "Munamarru B.O": "534324",
      "Tamarada B.O": "534324",
      "Enamadurru B.O": "534239",
      "Sisali B.O": "534237",
      "Navuduru B.O": "534238",
      "Bondada B.O": "534206",
      "Lakshminarasimhapuram B.O": "534206",
      "Vempadu B.O": "534206",
      "Lakshminarayanapuram B.O": "534209",
      "Kondepudi B.O": "534210",
      "Vendra B.O": "534210",
      "Ramannagudem B.O": "534102",
      "Chinanindrakolanu B.O": "534406",
      "Narayanapuram B.O": "534406",
      "Thokalapally B.O": "534406",
      "Lingagudem B.O": "534460",
      "Mallayagudem B.O": "534460",
      "Pothunuru B.O": "534442",
      "Recherla B.O": "534460",
      "Challavarigudem B.O": "534455",
      "Chinnavarigudem B.O": "534455",
      "Vegavaram B.O": "534455",
      "Bandivarigudem B.O": "534456",
      "Darbhagudem B.O": "534456",
      "Kamaiahpalem B.O": "534456",
      "Makkinavarigudem B.O": "534456",
      "Adamilli B.O": "534449",
      "Kamaiahkunta B.O": "534311",
      "Kopalli B.O": "534311",
      "Kotaramachandrapuram B.O": "534311",
      "Merakagudem B.O": "534311",
      "Bayyanagudem B.O": "534312",
      "Bodigudem B.O": "534315",
      "Gavaravaram B.O": "534312",
      "Narasannapalem BO": "534312",
      "Yerrampally B.O": "534461",
      "Kurellagudem B.O": "534401",
      "M.M.Puram B.O": "534401",
      "Tirumaladevipeta B.O": "534467",
      "Jonnalapalem B.O": "534240",
      "Madugupolavaram B.O": "534240",
      "Komarada B.O": "534208",
      "Peda amiram B.O": "534204",
      "Pennada B.O": "534243",
      "Bethapudi B.O": "534207",
      "T.Gokavaram B.O": "534452",
      "Vegivada B.O": "534452",
      "Vemulapally B.O": "534452",
      "Ganapavaram BO": "534444",
      "Sivadevunichikkala B.O": "534245",
      "Goraganamudi B.O": "534244",
      "Vankayalapalem B.O": "534244",
      "Juvvalapalem B.O": "534102",
      "Kalavapudi B.O": "534236",
      "Military Colony B.O": "534236",
      "Prathalameraka B.O": "534236",
      "Kaza B.O": "534268",
      "Bhatlamaguturu B.O": "534126",
      "Kanteru B.O": "534126",
      "Narinameraka B.O": "534266",
      "Chinchinada B.O": "534268",
      "Medapadu B.O": "534268",
      "Neredumilli B.O": "534268",
      "A.Vemavaram B.O": "534267",
      "Bhaggeswaram B.O": "534250",
      "Kothuru BO": "534146",
      "Venkatayapalem BO": "534316",
      "Surappagudem B.O": "534425",
      "Alivery B.O": "534448",
      "Doramamidi B.O": "534448",
      "Muppinavarigudem B.O": "534448",
      "Vippalapadu B.O": "534448",
      "Chintalapudi Cutchery B.O": "534460",
      "Ganapavaram": "534455",
      "Utasamudram B.O": "534460",
      "Yendapalli B.O": "534460",
      "Bhogole B.O": "534462",
      "Lingapalem B.O": "534462",
      "Rangapuram B.O": "534462",
      "APMC B.O": "534426",
      "Tirumalampalem B.O": "534426",
      "Mulagalampally B.O": "534455",
      "Srinivaspuram B.O": "534455",
      "A.Polavaram B.O": "534456",
      "Appalarajugudem B.O": "534456",
      "P.Ankampalem B.O": "534456",
      "Puchikapadu B.O": "534456",
      "Tatiyakulagudem B.O": "534456",
      "Jeelakarragudem B.O": "534449",
      "Rajanagaram B.O": "534311",
      "Karicherlagudem B.O": "534312",
      "Ponguturu B.O": "534312",
      "Vedanthapuram B.O": "534312",
      "Jagannadhapuram B.O": "534145",
      "Ch.Pothepalli B.O": "534451",
      "Ravikampadu B.O": "534451",
      "Edavally B.O": "534461",
      "Nagireddigudem B.O": "534461",
      "Jogannapalem B.O": "534450",
      "Koppulavarigudem B.O": "534435",
      "Mahadevapatnam B.O": "534199",
      "Pedapulleru B.O": "534199",
      "Uppuluru B.O": "534199",
      "Kathavapadu B.O": "534126",
      "Podalada B.O": "534126",
      "Mulaparru B.O": "534123",
      "Abbiraju Palem B.O": "534266",
      "Burugupalli B.O": "534266",
      "Ilapakurru B.O": "534266",
      "Ellamanchili Lanka B.O": "534268",
      "Adavipalem B.O": "534268",
      "Vaddiparru B.O": "534267",
      "Chintaparru B.O": "534250",
      "Velivela B.O": "534250",
      "Agarthipalem B.O": "534250",
      "Pandithavilluru B.O": "534122",
      "Kalipatnam B.O": "534281",
      "Perupalem B.O": "534281",
      "Kopparru B.O": "534275",
      "Miniminchilipadu B.O": "534327",
      "Unikili B.O": "534230",
      "Manchili B.O": "534134",
      "Moyyeru B.O": "534134",
      "Rayannapalem B.O": "534475",
      "Gopalapuram B.O": "534425",
      "Gunnampally B.O": "534425",
      "M.Nagulapally B.O": "534425",
      "Polasanipally B.O": "534425",
      "Komaravaram B.O": "534222",
      "Antervedigudem B.O": "534448",
      "Kommugudem B.O": "534102",
      "Korasavarigudem B.O": "534448",
      "Mangaiahpalem B.O": "534448",
      "Mettagudem B.O": "534448",
      "Yerraguntapally B.O": "534460",
      "Kalarayanagudem B.O": "534462",
      "Kothapally B.O": "534462",
      "Tch Rayudupalem B.O": "534462",
      "East Yedavally B.O": "534426",
      "Rallakunta B.O": "534426",
      "Tadicherla B.O": "534426",
      "Venkatakrishnapuram B.O": "534426",
      "G.Pangidigudem B.O": "534455",
      "Guravaigudem B.O": "534455",
      "Jonnavarigudem B.O": "534455",
      "Maisannagudem B.O": "534455",
      "Pattenapalem B.O": "534455",
      "Swarnavarigudem B.O": "534455",
      "Veerannapalem B.O": "534455",
      "A.Gokavaram B.O": "534416",
      "Kethavaram B.O": "534312",
      "Rajavaram B.O": "534312",
      "Ramanujapuram B.O": "534312",
      "Saripalli B.O": "534198",
      "Seethampeta B.O": "534312",
      "Devulapalli B.O": "534451",
      "G.Kothapalli B.O": "534451",
      "I.S.Jagannadhapuram B.O": "534451",
      "I.S.Raghavapuram B.O": "534451",
      "Tedlam B.O": "534461",
      "Velagapally B.O": "534461",
      "P.Kannapuram B.O": "534401",
      "Epigunta B.O": "534467",
      "Jaggavaram B.O": "534467",
      "Munduru B.O": "534450",
      "Vidyanagar B.O": "534450",
      "Seetharamanagar B.O": "534444",
      "Kolamuru B.O": "534199",
      "Penumanchili B.O": "534123",
      "Ayodhya Lanka B.O": "534266",
      "Bhimala Puram B.O": "534266",
      "Gumparru B.O": "534266",
      "Penumarru B.O": "534268",
      "Siragala Palli B.O": "534268",
      "Pedamallam B.O": "534269",
      "Valluru B.O": "534197",
      "Venkata Puram B.O": "534250",
      "Agarru B.O": "534250",
      "Mutyalapalli B.O": "534281",
      "Yenuguvanilanka B.O": "534275",
      "Venkatramapuram B.O": "534324",
      "Chilakapadu B.O": "534216",
      "Chivatam B.O": "534216",
      "Palangi B.O": "534216",
      "Digamarru B.O": "534275",
      "Kanchumarru B.O": "534230",
      "Skinnerapuram B.O": "534230",
      "Mupparthipadu B.O": "534134",
      "Paluru B.O": "534134",
      "Seethalm Kondepadu B.O": "534134",
      "Yeraih Cheruvu B.O": "534217",
      "Vadluru B.O": "534218",
      "Pekeru B.O": "534320",
      "Rapaka B.O": "534320",
      "Mallipudi B.O": "534124",
      "Nattarameswaram B.O": "534124",
      "Velagalavariplalem B.O": "534124",
      "Gavarlapalem B.O": "534225",
      "Gummampadu B.O": "534225",
      "S.Illindalaparru B.O": "534225",
      "Gudivakalanka B.O": "534004",
      "Jalipudi B.O": "534004",
      "Komadavole B.O": "534004",
      "Penumadam B.O": "534267",
      "Ullamparru B.O": "534265",
      "Vadlavani Palem B.O": "534265",
      "Vedangi B.O": "534265",
      "Chinamallam B.O": "534269",
      "Karugorumilli B.O": "534269",
      "Koderu B.O": "534269",
      "Aratlakatta B.O": "534250",
      "Satyavaram B.O": "534122",
      "Chinagolla Palem B.O": "534281",
      "Chittavaram B.O": "534275",
      "Mallavaram B.O": "534342",
      "Vemuladeevi B.O": "534275",
      "Akanivarithota B.O": "534280",
      "Mylavanilanka B.O": "534280",
      "Pasaladeevi B.O": "534280",
      "Turputallu B.O": "534280",
      "Ballipadu B.O": "534340",
      "Eduru B.O": "534134",
      "K.Samudrapugattu B.O": "534134",
      "Komarru B.O": "534134",
      "Tirupathipuram B.O": "534225",
      "Goteru B.O": "534217",
      "Dongaravipalem B.O": "534330",
      "Malleswaram B.O": "534330",
      "Mukkamala B.O": "534330",
      "Mutyalavaripalem B.O": "534330",
      "Ainaparru B.O": "534320",
      "Juttiga B.O": "534124",
      "Surampudi B.O": "534328",
      "Ilaparru B.O": "534326",
      "Nadipudi B.O": "534326",
      "Kothapadu B.O": "534217",
      "Yerramalla B.O": "534411",
      "Satyawada B.O": "534218",
      "Tadiparru B.O": "534227",
      "Kakileru B.O": "534320",
      "Koyyetipadu B.O": "534320",
      "Kannai Kumudavalli B.O": "534328",
      "Kothapalli Agraharam B.O": "534328",
      "Pali Gds B.O": "534225",
      "Varighedu B.O": "534225",
      "Pittalavemavarm B.O": "534324",
      "Taduvai": "534455",
      "Uppakapadu B.O": "534411",
      "Vellamilli B.O": "534411",
      "Mounjipadu B.O": "534165",
      "Kakarlamudi B.O": "534165",
      "Nidamarru B.O": "534195",
      "K.Pentapadu B.O": "534166",
      "Darisaparru B.O": "534166",
      "Parimalla B.O": "534166",
      "Racharla B.O": "534166",
      "Yanalapalli B.O": "534166",
      "Allampuram B.O": "534146",
      "Arugolanu B.O": "534146",
      "Konala B.O": "534146",
      "Krishnayampalemi B.O": "534146",
      "Ravigudem": "534444",
      "Repakagommu": "534444",
      "Navabpalem B.O": "534146",
      "Venkatramannagudem B.O": "534102",
      "Tadepalli B.O": "534102",
      "Bommidi B.O": "534411",
      "Kagupadu B.O": "534411",
      "Medinaraopalem B.O": "534432",
      "Satynarayanapuram B.O": "534432",
      "Galayagudem B.O": "534450",
      "Krothagudem B.O": "534427",
      "Kalaparru B.O": "534007",
      "Kokkiripadu B.O": "534007",
      "Gudipadu B.O": "534437",
      "Punikollu B.O": "534437",
      "Satyavole B.O": "534437",
      "Vadddigudem B.O": "534437",
      "Veerammakunta B.O": "534437",
      "Malkapuram B.O": "534002",
      "Mupparu B.O": "534002",
      "Ponangi B.O": "534002",
      "Vangayagudem B.O": "534002",
      "Vanguru B.O": "534002",
      "Tondipaka": "534444",
      "Upperu": "534444",
      "Tatkuragommu": "534444",
      "Amaravram": "534444",
      "Dachavaram": "534444",
      "Damacherla": "534444",
      "Vinjaram": "534444",
      "Mandalaparru B.O": "534195",
      "Jetlapalem B.O": "534166",
      "Muggalla B.O": "534197",
      "Cheepurugudem B.O": "534176",
      "Pothineedipalem B.O": "534176",
      "Muddapuram B.O": "534146",
      "Kunchinapalli B.O": "534102",
      "Veerampalem B.O": "534102",
      "Madhavaram": "534444",
      "Sridharvelair": "534444",
      "Rudramkota": "534444",
      "A.Gopavaram B.O": "534197",
      "Kadakatla B.O": "534102",
      "Kadiyedda B.O": "534102",
      "Ardhavaram B.O": "534197",
      "Nabipeta B.O": "534176",
      "Marampalli B.O": "534146",
      "Nandamuru B.O": "534146",
      "Kondruprolu B.O": "534102",
      "Padala B.O": "534102",
      "Badampudi B.O": "534411",
      "Nachugunta B.O": "534411",
      "Chinakapavaram B.O": "534235",
      "Chinamallipadu B.O": "534235",
      "Gummuluru B.O": "534235",
      "Velairpadu": "534444",
      "Katkuru": "534444",
      "Koida": "534444",
      "Somavarappadu B.O": "534450",
      "Agadalalanka B.O": "534427",
      "Bhogapuram B.O": "534007",
      "Chettunnapadu B.O": "534427",
      "Koppaka B.O": "534003",
      "Pinakadimi B.O": "534003",
      "Janampeta B.O": "534475",
      "Aibhimavaram B.O": "534235",
      "Cherukumilli B.O": "534316",
      "Kollaparru B.O": "534235",
      "Sidhapuram B.O": "534235",
      "Sriparru B.O": "534004",
      "Sriramvaram B.O": "534432",
      "Kuchimpudi B.O": "534435",
      "Ramasingavaram B.O": "534435",
      "Gogunta B.O": "534437",
      "Koniki B.O": "534437",
      "Raju Peta B.O": "534437",
      "Chodimella B.O": "534002",
      "Nadipally B.O": "534475",
      "Apparaopeta B.O": "534145",
      "Dumpagadapa B.O": "534235",
      "Kuppanapudi B.O": "534237",
      "Pedakapavaram B.O": "534235",
      "Deyyalatippa B.O": "534239",
      "Gangannagudem B.O": "534450",
      "Dosapadu B.O": "534442",
      "Naidugudem B.O": "534437",
      "Vasanthavada B.O": "534437",
      "Pedakadimi B.O": "534003",
      "Kothuru B.O": "534002",
      "Bapirajugudem B.O": "534475",
      "Kavvagunta B.O": "534475",
      "Mypa B.O": "534186",
      "Pullalapadu B.O": "534112",
      "Appannapeta B.O": "534186",
      "Garagaparru B.O": "534186",
      "Dommeru B.O": "534342",
      "NANDIGAMPADU B.O": "534342",
      "Lnd Peta B.O": "534318",
      "Pragadapalli B.O": "534318",
      "Reddinagampalem B.O": "534318",
      "GANGOLE B.O.": "534318",
      "Chinnayagudem B.O": "534316",
      "Bangarampeta B.O": "534315",
      "Mamidigondi B.O": "534315",
      "Paidipaka B.O": "534315",
      "D.Muppavaram B.O": "534302",
      "Gopavaram B.O": "534318",
      "Pandalaparru B.O": "534302",
      "Thogummi B.O": "534302",
      "Vadapalli B.O": "534302",
      "Chikkala B.O": "534305",
      "Katakoteswaram B.O": "534305",
      "Korumamidi B.O": "534305",
      "Kurukuru B.O": "534305",
      "Bodapadu B.O": "534196",
      "Chintapalli Agraharam B.O": "534196",
      "Kasipadu B.O": "534196",
      "Vakapalli B.O": "534196",
      "Pasalapudi B.O": "534156",
      "Surya Rao Palem B.O": "534156",
      "Jallikakinada B.O": "534186",
      "Dubacharla B.O": "534112",
      "D.Gopavaram B.O": "534195",
      "Chandravaram B.O": "534342",
      "Bandapuram B.O": "534313",
      "Gowripatnam B.O": "534313",
      "Krishnampalem B.O": "534313",
      "Sangayagudem B.O": "534313",
      "Gunjavaram B.O": "534318",
      "Kovvurupadu B.O": "534318",
      "Chityala B.O": "534316",
      "V.Ch.Gudem B.O": "534316",
      "Vadalagunta B.O": "534316",
      "Ajjaram B.O": "534331",
      "Teeparru B.O": "534331",
      "Kaldhari B.O": "534329",
      "Munipalli B.O": "534329",
      "Brahmanagudem B.O": "534301",
      "Daravaram B.O": "534301",
      "Kalavalapalli B.O": "534301",
      "Singavaram B.O": "534301",
      "Timmarajupalem B.O": "534301",
      "Tutigunta B.O": "534315",
      "Pattiseema B.O": "534315",
      "Ramayyapeta B.O": "534315",
      "Kesavaram B.O": "534186",
      "Vundurru B.O": "534186",
      "Aredu B.O": "534198",
      "Bhuvanapalli B.O": "534198",
      "Chanamilli B.O": "534198",
      "Yenikepalli B.O": "534198",
      "Bavaipalem BO": "534198",
      "Dandagarra B.O": "534145",
      "Moduggunta B.O": "534145",
      "Pullayagudem": "534145",
      "Gantavarigudem B.O": "534112",
      "Marellamudi B.O": "534112",
      "I.Pangidi B.O": "534342",
      "Pasivedala B.O": "534342",
      "Duddukuru B.O": "534313",
      "Pallantla B.O": "534313",
      "Yarnagudem B.O": "534313",
      "Karagapadu B.O": "534318",
      "Nandigudem B.O": "534316",
      "Yadavole B.O": "534316",
      "KOMATIKUNTA B.O": "534316",
      "K.Agraharam B.O": "534329",
      "Usulumarru B.O": "534329",
      "Markondapadu B.O": "534301",
      "Settipeta B.O": "534301",
      "Tallapalem B.O": "534301",
      "Kondrukota B.O": "534315",
      "Vk.Reddigudem B.O": "534315",
      "Jeedigunta B.O": "534302",
      "Purushottapalli B.O": "534302",
      "Pochavaram B.O": "534341",
      "Tadipudi B.O": "534341",
      "Malakapalli B.O": "534340",
      "Chidipi B.O": "534340",
      "Kumaradevam B.O": "534340",
      "Gundepalli B.O": "534111",
      "Telikecharla B.O": "534111",
      "Mudunuru B.O": "534196",
      "B.Kondepadu B.O": "534156",
      "Adavikolanu B.O": "534198",
      "Kaligotla B.O": "534198",
      "Krovvidi B.O": "534198",
      "Avapadu B.O": "534112",
      "Prakasaraopalem B.O": "534112",
      "Singarajupalem B.O": "534112",
      "Atlapadu B.O": "534302",
      "Vemuluru B.O": "534302",
      "MADDURULANKA B.O.": "534302",
      "Annadevarapeta B.O": "534341",
      "Bhimole B.O": "534341",
      "Gajjaram B.O": "534341",
      "Gutala B.O": "534341",
      "Peddavam B.O": "534340",
      "Penkanametta B.O": "534340",
      "Arikirevula B.O": "534340",
      "Atchannapalem B.O": "534111",
      "Jaggannapeta B.O": "534102",
      "Unagatla B.O": "534342",
      "Lakshmipuram B.O": "534313",
      "Hukumpeta B.O": "534318",
      "Kunkala B.O": "534318",
      "Rampalem B.O": "534318",
      "Guddigudem B.O": "534316",
      "SANJEEVAPURAM B.O.": "534316",
      "Pendyala B.O": "534329",
      "Velivennu B.O": "534329",
      "Kamsalipalem B.O": "534301",
      "Ravimetla B.O": "534301",
      "Itikalakota B.O": "534315",
      "Sivagiri B.O": "534315",
      "Madduru B.O": "534302",
      "Vijjeswaram B.O": "534302",
      "Tyajampudi B.O": "534305",
      "Tirugudumetta B.O": "534340",
      "Dharmavaram B.O": "534340",
      "Akuteegapadu B.O": "534196",
      "Korumilli B.O": "534156",
      "Kothapalli B.O": "534198",
      "Panduvva B.O": "534198",
      "Velagapalli B.O": "534198",
      "Akividu S.O": "534235",
      "Bhimavaram Bazar S.O": "534202",
      "Rayakuduru S.O": "534247",
      "Sivaraopeta S.O": "534202",
      "Viravasaram S.O": "534245",
      "Alamuru S.O (West Godavari)": "534126",
      "Doddipatla S.O": "534266",
      "Jinnuru S.O": "534265",
      "Kavitam S.O": "534338",
      "Khandavalli S.O": "534330",
      "Palakol H.O": "534260",
      "Eluru H.O": "534001",
      "Jangareddygudem H.O": "534447",
      "Konithiwada S.O": "534240",
      "Kopalle S.O": "534206",
      "Srungavruksham S.O": "534243",
      "Vissakoderu S.O": "534244",
      "Gummaluru S.O": "534267",
      "Lajapathiroya Peta S.O": "534260",
      "Lankalakoderu S.O": "534250",
      "Mogalturu S.O": "534281",
      "Narsapur Bazar S.O": "534275",
      "Palakol Bazar S.O": "534260",
      "Sitaramapuram S.O": "534280",
      "Aravalli S.O": "534230",
      "Bhimavaram Railway Colony S.O": "534201",
      "Dirusumarru S.O": "534239",
      "Kalla S.O": "534237",
      "Mogallu S.O": "534209",
      "Palakoderu S.O": "534210",
      "Polamuru S.O": "534238",
      "Undi S.O": "534199",
      "Yelurupadu S.O": "534236",
      "Atchanta S.O": "534123",
      "Ellamanchili S.O": "534268",
      "Kodamanchili S.O": "534269",
      "Roypeta S.O": "534275",
      "Rustumbada S.O": "534275",
      "Attili S.O": "534134",
      "Tadepalligudem H.O": "534101",
      "Bhimavaram H.O": "534201",
      "Tanuku H.O": "534211",
      "D.N.R.College S.O": "534202",
      "Rayalam S.O": "534208",
      "S.R.K.R .Engg.college S.O": "534204",
      "Someswaralayam S.O": "534201",
      "Sreeramapuram S.O": "534202",
      "Tundurru S.O": "534207",
      "Maruteru S.O": "534122",
      "Narsapur S.O (West Godavari)": "534275",
      "Poduru S.O": "534327",
      "Hanumantharaopeta S.O": "534211",
      "Iragavaram S.O": "534217",
      "Mandapaka S.O": "534218",
      "Tanuku Old Town S.O": "534211",
      "Gundugolanu So. S.O": "534427",
      "Power Peta S.O": "534002",
      "Vijayarai S.O": "534475",
      "Kakaraparru S.O": "534331",
      "Nidadavole S.O": "534301",
      "Polavaram S.O": "534315",
      "P.N.Kolanu S.O": "534195",
      "Vunguturu S.O (West Godavari)": "534411",
      "Yandagandi S.O": "534186",
      "Kovvur SO": "534350",
      "Chagallu S.O": "534342",
      "Dondapudi S.O": "534318",
      "Gopalapuram S.O (West Godavari)": "534316",
      "Gowtaminagar S.O": "534350",
      "Tadimalla S.O": "534305",
      "Duvva S.O": "534156",
      "Ganapavaram S.O (West Godavari)": "534198",
      "Nallajerla S.O": "534112",
      "Basivireddipeta S.O": "534301",
      "Nidadavole O.T. S.O": "534301",
      "Vegeswarapuram S.O": "534340",
      "Aphb Colony S.O": "534101",
      "Pippara S.O": "534197",
      "Pothavaram S.O": "534176",
      "Devarapalli S.O (West Godavari)": "534313",
      "Kanuru S.O": "534329",
      "RTC Bustand(kovvur S.O": "534350",
      "Samisragudem S.O": "534302",
      "Tallapudi S.O": "534341",
      "Ananthapallli S.O": "534111",
      "Ch.Agraharam S.O": "534196",
      "Madhavaram S.O (West Godavari)": "534145",
      "Pentapadu S.O": "534166",
      "Prattipadu S.O": "534146",
      "Tadepalligudem Town S.O": "534101",
      "Mortha S.O": "534227",
      "Penugonda S.O": "534320",
      "Benerjipeta S.O": "534001",
      "Chataparru S.O": "534004",
      "Eluru Bazar S.O": "534001",
      "Eluru Bus Station S.O": "534006",
      "Eluru Collectorate S.O": "534006",
      "Eluru R.S S.O": "534005",
      "Gopannapalem S.O": "534450",
      "Narasimharao Peta S.O": "534006",
      "Pedavegi": "534435",
      "Bhimadole S.O": "534425",
      "Penugonda Bazar S.O": "534320",
      "Peravali S.O": "534328",
      "Sajjapuram S.O": "534211",
      "Tanuku Bazar S.O": "534211",
      "Vadali S.O (West Godavari)": "534324",
      "Gandhinagaram S.O (West Godavari)": "534007",
      "Industrial Estate S.O (West Godavari)": "534007",
      "P&t Colony S.O (West Godavari)": "534007",
      "Sb Colony S.O": "534007",
      "Penumantra S.O": "534124",
      "Relangi S.O": "534225",
      "Sidhantam S.O": "534326",
      "Velpur S.O": "534222",
      "Venkatrayapuram S.O": "534215",
      "Vundrajavaram S.O": "534216",
      "Ashok Nagar S.O (West Godavari)": "534002",
      "Denduluru S.O": "534432",
      "Kovvali S.O": "534442",
      "Pedapadu S.O": "534437",
      "Ramachandra Rao Peta S.O": "534006",
      "Sanivarapu Peta S.O": "534003",
      "Tangellamudi S.O": "534005",
      "Venkata Rao Peta S.O": "534002",
      "Westren Street S.O": "534003",
      "Subbaraopeta S.O": "534101",
      "Tadepalligudem Bazar S.O": "534102",
      "West Vipparru S.O": "534165",
      "Koyyalagudem S.O": "534312",
      "Chebrole S.O (West Godavari)": "534406",
      "Dharmajigudem S.O": "534462",
      "Gowrisankara Puram S.O": "534455",
      "Kaikaram S.O": "534416",
      "Kamavarapukota S.O": "534449",
      "Kannapuram S.O": "534311",
      "Lakkavaram S.O (West Godavari)": "534451",
      "T.Narasapuram S.O": "534467",
      "Dwaraka Tirumala S.O": "534426",
      "Pulla S.O": "534401",
      "Buttayagudem S.O": "534448",
      "Chintalapudi S.O": "534460",
      "Jeelugumilli S.O": "534456",
      "Pragadavaram S.O": "534461",
      "Tadikalapudi S.O": "534452",
      "KUKUNOOR SO": "534444"
    },
    "VISAKHAPATANAM": {
      "Palavalasa B.O": "530052",
      "Ramavaram B.O": "531173",
      "Bhandevupuram B.O": "531219",
      "Mutcherla B.O": "531173",
      "Kanamam B.O": "531173",
      "Golugonda BO": "531084",
      "Addasaram BO": "531114",
      "A Kothapalle B.O": "531022",
      "Anandapuram B.O": "531022",
      "Dosalapadu BO": "531126",
      "Nallagonda BO": "531084",
      "Mushidipalli B.O": "531022",
      "K.J.Puram B.O": "531022",
      "Bondam B.O": "531149",
      "Burja B.O": "531149",
      "Chompi B.O": "531149",
      "Koruvada B.O": "531022",
      "Rama Yogi Agraharam B.O": "531022",
      "Varada B.O": "531022",
      "Gavarapalem B.O": "531022",
      "Baski B.O": "531149",
      "Chinalabudu B.O": "531149",
      "Gannela B.O": "531149",
      "Sowbhagya Rayapuram B.O": "531173",
      "D TALLAVALASA": "535005",
      "Bosubeda B.O": "531149",
      "Desapatrunipalem B.O": "531021",
      "Paltheru B.O": "533401",
      "Pakalapadu B.O": "531118",
      "Pinagadi B.O": "531173",
      "Annavaram B.O": "531111",
      "Iragi B.O": "531149",
      "Pedabaludu B.O": "531149",
      "Sunkarimetta B.O": "531149",
      "Araku B.O": "531151",
      "Arma B.O": "531151",
      "Gorapur B.O": "531151",
      "Guntagannela B.O": "531151",
      "Kollaput B.O": "531151",
      "Pattam B.O": "531151",
      "Rangaseela B.O": "531151",
      "Pudimadaka B.O": "531011",
      "Tanthadi B.O": "531011",
      "Janguluru B.O": "531055",
      "Adavi Agraharam B.O": "531036",
      "R Sivarampuram B.O": "531036",
      "Kannampalem B.O": "531036",
      "Nagayyapeta B.O": "531030",
      "Nagulapalli B.O": "531002",
      "Marepalli B.O": "531030",
      "Valabu B.O": "531030",
      "Murakada B.O": "531061",
      "Raja Koduru B.O": "531061",
      "Thadi B.O": "531019",
      "Kinthada B.O": "531034",
      "Bayyavaram B.O": "531031",
      "Tatituru B.O": "531162",
      "MULAKUDDU": "531162",
      "BODAMETTAPALEM": "531162",
      "Narava B.O": "530027",
      "Maddi B.O": "531219",
      "Padmanabham B.O": "531219",
      "Pedakodapalli B.O": "531077",
      "Santhari B.O": "531077",
      "Sobhakota B.O": "531077",
      "Durgam B.O": "531077",
      "Mettujoru B.O": "531077",
      "Antada B.O": "531084",
      "Bangarampeta B.O": "531084",
      "Chittempadu B.O": "531084",
      "Chodyam. B.O": "531084",
      "Revallu B.O": "531087",
      "Gabbada B.O": "531118",
      "J P Agraharam B.O": "531118",
      "K Yellavaram B.O": "531118",
      "Kitumula B.O": "531118",
      "Jammadevipeta B.O": "531027",
      "Kinthalli B.O": "531027",
      "M Koduru B.O": "531027",
      "Sagaram B.O": "531027",
      "Sankaram B.O": "531027",
      "Bheemaboinapalem B.O": "531113",
      "Burugupalem B.O": "531113",
      "Giduturu B.O": "531113",
      "Koduru B.O": "531002",
      "Tutipala B.O": "531113",
      "Vajragada B.O": "531113",
      "Potnuru B.O": "531219",
      "Sirlapalem B.O": "531219",
      "Durganagar B.O": "530029",
      "Chintalaagaraharam B.O": "530047",
      "Porlupalem B.O": "530047",
      "B.Tallavalasa B.O": "535005",
      "Bhandevpuram B.O": "535250",
      "Sagar Nagar B.O": "530045",
      "Gayatri Engg College B.O": "530048",
      "Tarluvada B.O": "530052",
      "Jaggayyapalem B.O": "530012",
      "Kapuluppada B.O": "531163",
      "Vellanki B.O": "531163",
      "Sangivalasa B.O": "531162",
      "Chippada B.O": "531162",
      "Dakamarri B.O": "531162",
      "Chammachinta B.O": "531115",
      "Golugondapeta B.O": "531115",
      "Gunupudi B.O": "531115",
      "M B Patnam B.O": "531115",
      "P Kotha Gudem B.O": "531115",
      "Pedajaggampeta B.O": "531115",
      "Sarugudu B.O": "531115",
      "Srungavaram B.O": "531115",
      "Minimuluru B.O": "531024",
      "Vanugupalli B.O": "531024",
      "Modapalli B.O": "531024",
      "Aduguluputtu B.O": "531040",
      "Makavaram B.O": "531032",
      "Panasaput B.O": "531040",
      "Poipalli B.O": "531040",
      "Barada B.O": "531040",
      "Dodiput B.O": "531040",
      "Chinapachila B.O": "531025",
      "Gompa B.O": "531025",
      "Devarapalli B.O": "531133",
      "R V NAGAR B.O": "531133",
      "Rintada B.O": "531133",
      "Vijayaramarajupeta B.O": "531026",
      "D Suravaram B.O": "531026",
      "Mangalapuram B.O": "531026",
      "Polipalli B.O": "531026",
      "Chittayyapalem B.O": "531026",
      "Amalapuram B.O": "531117",
      "Bodapalem B.O": "531117",
      "Cherlopalem B.O": "531055",
      "Kothaballuguda B.O": "531149",
      "Madala B.O": "531149",
      "Gasaba B.O": "531151",
      "Korra B.O": "531151",
      "Korrai B.O": "531151",
      "Layaganda B.O": "531151",
      "Chodapalle B.O": "531011",
      "Dosuru B.O": "531011",
      "Arjunagiri B.O": "531036",
      "Chakipalle B.O": "531036",
      "Damunapalle B.O": "531036",
      "Gogada Kothapalle B.O": "531036",
      "Gowripatnam B.O": "531036",
      "Jannavaram B.O": "531036",
      "Pakeersahebpeta B.O": "531036",
      "Pedagogada B.O": "531036",
      "Rajam B.O": "531036",
      "Pedakota B.O": "531030",
      "Pedanandipalle Agraharam B.O": "531030",
      "Chintalapudi B.O": "531087",
      "Tamarabba B.O": "531030",
      "Gokivada B.O": "531061",
      "Govindapalem B.O": "531061",
      "Haripuram B.O": "531061",
      "Kalavalapalle B.O": "531061",
      "Kothuru B.O": "535145",
      "Muddurthi B.O": "531023",
      "Pedamushidivada B.O": "531019",
      "Chowduvada B.O": "531034",
      "Gondupalem B.O": "531034",
      "K Santhaplem B.O": "531034",
      "Singannadorapalem B.O": "531034",
      "Iti Araku B.O": "531149",
      "Lother B.O": "531149",
      "Madagada B.O": "531149",
      "Siragam B.O": "531149",
      "Guntaseema B.O": "531151",
      "Kandrum B.O": "531151",
      "Kithalangi B.O": "531151",
      "Rangelisingi B.O": "531151",
      "Sagara B.O": "531151",
      "Tutangi B.O": "531151",
      "Dibbapalem SEZ R.H Colony BO": "531011",
      "Dumbriguda B.O": "531151",
      "Gattum B.O": "531151",
      "Kinchumanda B.O": "531151",
      "Sovva B.O": "531151",
      "Dupputuru B.O": "531011",
      "Rompalli B.O": "535273",
      "Bheempolu B.O": "535145",
      "Kasipatnam B.O": "535145",
      "Konapuram B.O": "535145",
      "Kondiba B.O": "535145",
      "Lalamkoduru B.O": "531011",
      "Chukkapalle B.O": "531036",
      "Kandepalli B.O": "531036",
      "LAXMIPURAM B.O": "531036",
      "Turuvolu B.O": "531036",
      "Bennavolu B.O": "531036",
      "Chinanadipalli B.O": "531030",
      "Raivada B.O": "531030",
      "Garisingi B.O": "531030",
      "Gorapudi B.O": "531061",
      "Rambilli B.O": "531061",
      "Bhogapuram B.O": "531023",
      "Juttada B.O": "531023",
      "Lankelapalem B.O": "531019",
      "Narsingaraopeta B.O": "531019",
      "Valluru B.O": "531019",
      "Arle B.O": "531034",
      "Gullepalle B.O": "531034",
      "Medicherla B.O": "531034",
      "Rongalinaidupalem B.O": "531034",
      "NSTL B.O": "530027",
      "Maduthuru B.O": "531011",
      "Chettupalle B.O": "531118",
      "Kandipudi B.O": "531127",
      "Mallam B.O": "531036",
      "Varahapuram B.O": "531036",
      "Timmannapalem B.O": "531036",
      "Neelakantapuram B.O": "531036",
      "Alamanda B.O": "531030",
      "Kasipuram B.O": "531030",
      "Kiverla B.O": "531030",
      "Tenugupudi B.O": "531030",
      "Zeenabadu B.O": "531030",
      "Dharapalem B.O": "531061",
      "Duddupalem B.O": "531023",
      "Rayapurajupeta B.O": "531023",
      "Maredupudi B.O": "531019",
      "Kothapenta B.O": "531034",
      "Pydampeta B.O": "531034",
      "Atcherla B.O": "531031",
      "Prahladapuram B.O": "530027",
      "Dibbapalem B.O": "531026",
      "Gangavaram B.O": "531087",
      "Gandigundam B.O": "531173",
      "Gidijala B.O": "531173",
      "Gorapalle B.O": "531173",
      "Gurrampalem B.O": "531173",
      "Pedagadi B.O": "531173",
      "Rampuram B.O": "531173",
      "Penta B.O": "531219",
      "Ananthavaram B.O": "531219",
      "Duvvada B.O": "530049",
      "Pedamadaka B.O": "530053",
      "Yendada B.O": "530045",
      "Pedagadili B.O": "530040",
      "Sri krishnapuram B.O": "530040",
      "Dayalnagar B.O": "530043",
      "Boddapalem B.O": "531163",
      "Boyapalem B.O": "531163",
      "Vemulavalasa B.O": "530052",
      "Amanam B.O": "531162",
      "Nagamayyapalem B.O": "531162",
      "Tallavalasa B.O": "531162",
      "Yarada B.O": "530005",
      "Yellapuvanipalem B.O": "530027",
      "Balacheruvu B.O": "530044",
      "V. Juttada B.O": "531173",
      "Gopalapuram B.O": "531002",
      "Boddaput B.O": "531077",
      "Konkasingi B.O": "531084",
      "Nadimpalem B.O": "531084",
      "Old K D Peta B.O": "531084",
      "Pappusettipalem B.O": "531084",
      "Bennabhupalapatnam B.O": "531118",
      "Butchampeta B.O": "531118",
      "Sanivaram B.O": "531118",
      "Rachapalli B.O": "531113",
      "Marripalem B.O": "531115",
      "Kindangi B.O": "531024",
      "Legisipalli B.O": "531024",
      "Basiputtu B.O": "531040",
      "Jarrela B.O": "531040",
      "Jolaput B.O": "531040",
      "Kilagada B.O": "531040",
      "Sujanakota B.O": "531040",
      "Vanabhangi B.O": "531040",
      "Laxmipeta B.O": "531040",
      "Koravangi B.O": "531040",
      "Injari B.O": "531040",
      "Vanagumma B.O": "531040",
      "MUDAPAKA": "531173",
      "Gandhavaram B.O": "531032",
      "Kovvada B.O": "531219",
      "Kusuluwada B.O": "531219",
      "Venkatapuram B.O": "531060",
      "Vedullanarava B.O": "530049",
      "Devada B.O": "530031",
      "Ainada B.O": "535005",
      "Gudivada B.O": "531083",
      "Pedauppalam B.O": "531083",
      "Revupolavaram B.O": "531083",
      "Timmapuram B.O": "531083",
      "Gunnempudi B.O": "531025",
      "Marupaka B.O": "531025",
      "Medivada B.O": "531025",
      "Seethayyapeta B.O": "531025",
      "Tattabanda B.O": "531025",
      "China Appannapalem B.O": "531026",
      "Chinamadina B.O": "531026",
      "Sarabhannapalem B.O": "531084",
      "Manchala B.O": "531028",
      "Sirijam B.O": "531028",
      "Bapiraju Kothapalli B.O": "531085",
      "Kodavatipudi B.O": "531085",
      "Lingapuram B.O": "531085",
      "Dondapudi B.O": "531114",
      "Nagarajupalem B.O": "531162",
      "Pandranki B.O": "531162",
      "Pindrangi B.O": "535183",
      "Pedaraba B.O": "535273",
      "Y S R Puram B.O": "535145",
      "Ananthagiri B.O": "535145",
      "B G Valasa B.O": "535145",
      "Appalrajupuram B.O": "531028",
      "Kandivaram B.O": "531028",
      "Chintaluru B.O": "531028",
      "Bylapudi B.O": "531028",
      "Panduru B.O": "531085",
      "Kannampeta B.O": "531114",
      "Kothapatnam B.O": "531114",
      "Budarallu B.O": "531087",
      "M Makavaram B.O": "531087",
      "Tallapalem B.O": "531031",
      "Theeda B.O": "531031",
      "Ugginapalem B.O": "531031",
      "Veduruparthi B.O": "531031",
      "Vadrapalem B.O": "531075",
      "Khazeepalem B.O": "531033",
      "Kondakarla B.O": "531033",
      "Pallapu Anandapuram B.O": "531033",
      "Thimmarajupeta B.O": "531033",
      "Vadrapalle B.O": "531033",
      "Ch Laxmipuram B.O": "531081",
      "Vempadu B.O": "531081",
      "Kagitha B.O": "531081",
      "Nellipudi B.O": "531081",
      "Thanam B.O": "531021",
      "Vennalapalem B.O": "531021",
      "Donkada B.O": "531126",
      "Guntapalle B.O": "531126",
      "Mangavaram B.O": "531126",
      "Namavaram B.O": "531126",
      "Thotaluru B.O": "531084",
      "Gadampalem B.O": "531084",
      "Cheedikada B.O": "531028",
      "Konam B.O": "531028",
      "M Kotapadu B.O": "531028",
      "Kalayanapulova B.O": "531114",
      "Kanchugummala B.O": "531114",
      "Kovvuru B.O": "531114",
      "Rolugunta B.O": "531114",
      "Tamaracherla B.O": "531114",
      "V Sarabhavaram B.O": "531114",
      "Pedamakavaram B.O": "531084",
      "Jaithavaram B.O": "531028",
      "Veeranarayanam B.O": "531028",
      "Gotivada Agraharam B.O": "531028",
      "V B Peta B.O": "531028",
      "Kailasapatnam B.O": "531085",
      "Rajupeta B.O": "531085",
      "Sunkapur B.O": "531085",
      "Jaggampeta B.O": "531114",
      "Komaruvolu B.O": "531114",
      "Konthalam B.O": "531114",
      "Cheedipalem B.O": "531087",
      "Kakarapadu B.O": "531087",
      "Mampa B.O": "531087",
      "Pathakota B.O": "531077",
      "Sukuru B.O": "531077",
      "Olda B.O": "531077",
      "Chekumaddila B.O": "531077",
      "Rapa B.O": "531077",
      "Ganneruputtu B.O": "531077",
      "K Mallampeta B.O": "531084",
      "Kinaparthi B.O": "531084",
      "Marrivada B.O": "531087",
      "Downuru B.O": "531118",
      "Gondipakalau B.O": "531118",
      "Gundupala B.O": "531118",
      "Kusarlapudi B.O": "531118",
      "M K Patnam B.O": "531118",
      "Pedda Boddepalli B.O": "531118",
      "Vaddipa B.O": "531118",
      "A Veeranarayanam B.O": "531027",
      "Devapuram B.O": "531027",
      "Gadirai B.O": "531027",
      "Satyavaram B.O": "531027",
      "Vommali Jagannadhapuram B.O": "531027",
      "L Ponnavolu B.O": "531027",
      "Jampena B.O": "531027",
      "Mallavaram B.O": "531113",
      "Pydipala B.O": "531113",
      "Adakula B.O": "531115",
      "Dharagangavaram B.O": "531115",
      "Gummadigonda B.O": "531115",
      "T R Project B.O": "531115",
      "Y B Agraharam B.O": "531115",
      "Chintalaveedhi B.O": "531024",
      "Iradapalle B.O": "531024",
      "Salugu B.O": "531024",
      "Kinchuru B.O": "531024",
      "Aradakota B.O": "531040",
      "Pedagaruvu B.O": "531077",
      "Tadigiri B.O": "531077",
      "Jarrakonda B.O": "531077",
      "Andiba B.O": "531077",
      "Matyapuram B.O": "531077",
      "Jogempeta B.O": "531084",
      "Kantaram B.O": "531084",
      "Kommika B.O": "531084",
      "Pathamallmpeta B.O": "531084",
      "Balighattam B.O": "531118",
      "Cheedigummala B.O": "531118",
      "Dharnasagaram B.O": "531118",
      "Gurandarapalem B.O": "531118",
      "Lammasingi B.O": "531118",
      "Nindugonda B.O": "531118",
      "Rajupakalu B.O": "531118",
      "Tajangi B.O": "531118",
      "Y G Peta B.O": "531118",
      "D Gottivada B.O": "531027",
      "Jalampalli B.O": "531027",
      "Tatiparthi B.O": "531027",
      "Pongalipaka B.O": "531027",
      "Kavagunta B.O": "531027",
      "Kondala Agraharam B.O": "531113",
      "P P Agraharam B.O": "531113",
      "E D Peta B.O": "531115",
      "Manyapuratla B.O": "531115",
      "Vedurupalle B.O": "531115",
      "Dokuluru B.O": "531024",
      "Gondeli B.O": "531024",
      "Vantlamamidi B.O": "531024",
      "Thumpada B.O": "531024",
      "Babusala B.O": "531040",
      "Darela B.O": "531040",
      "Karimukhput B.O": "531040",
      "Pedaguda B.O": "531040",
      "Seekari B.O": "531040",
      "Vanabhasingi B.O": "531040",
      "Ginnelakota B.O": "531040",
      "Jarjula B.O": "531040",
      "Kumada B.O": "531040",
      "Bungaput B.O": "531040",
      "Geddapalem B.O": "531083",
      "Koruprolu B.O": "531083",
      "Gudivada Veeravalli B.O": "531025",
      "Thotakurapalem B.O": "531025",
      "Lakkavarapupeta B.O": "531133",
      "Duppulavada B.O": "531105",
      "Kondupalem Agraharam B.O": "531026",
      "Turakalapudi B.O": "531026",
      "Kondempudi B.O": "531026",
      "Munchingput B.O": "531040",
      "Parreda B.O": "531040",
      "Rudakota B.O": "531040",
      "A U Engg College B.O": "530003",
      "Singannabanda B.O": "531162",
      "Nadupuru B.O": "530044",
      "Saripalli B.O": "531173",
      "Chinamushidiwada B.O": "530051",
      "Gudilova B.O": "531173",
      "Sontyam B.O": "531173",
      "Chinnapuram B.O": "531219",
      "Gottupalli B.O": "531219",
      "T.V.Agraharam B.O": "531219",
      "Simhachalam Hills B.O": "530028",
      "Pakeertekya B.O": "530049",
      "Islampeta B.O": "530031",
      "Jamiguda B.O": "531040",
      "Laxmipuram B.O": "531040",
      "Bondapalli B.O": "531040",
      "Rngabayalu B.O": "531040",
      "Chinnagummuluru B.O": "531083",
      "Galikonda B.O": "531133",
      "Pedavalasa B.O": "531133",
      "Sankada B.O": "531133",
      "Saparla B.O": "531133",
      "Darakonda B.O": "531105",
      "Butchiyyapeta B.O": "531026",
      "Dibbidi B.O": "531026",
      "Lopudi B.O": "531026",
      "Pottidorapalem B.O": "531026",
      "Veeravalli Agraharam B.O": "531026",
      "Mukundapuram B.O": "531026",
      "P Bhimavaram BO": "531026",
      "Gopalapatnam B.O": "531127",
      "Arilova B.O": "530040",
      "Kommadi B.O": "530048",
      "Tunglam B.O": "530012",
      "Mindi B.O": "530012",
      "Chepaluppada B.O": "531163",
      "INS Kalinga B.O": "531163",
      "Kothaparadesipalem B.O": "531163",
      "Rayapalem B.O": "531163",
      "Boni B.O": "531162",
      "Korada B.O": "531162",
      "Marikavalasa B.O": "530048",
      "Sheelanagar B.O": "530012",
      "Visweswarayanagar B.O": "530012",
      "J.V.Agraharam B.O": "531163",
      "Nerellavalasa B.O": "531163",
      "Peddipalem B.O": "531163",
      "Majjivalasa B.O": "531162",
      "Revidi B.O": "531162",
      "Pathavalasa B.O": "535183",
      "Tangudubilli B.O": "535183",
      "Gummakota B.O": "535273",
      "Muliaguda B.O": "535145",
      "Valasi B.O": "535145",
      "Tokuru B.O": "535145",
      "Garugubilli B.O": "535273",
      "Pedabidda B.O": "535145",
      "Tyda B.O": "535145",
      "Idatam B.O": "531127",
      "Chintagatla B.O": "531035",
      "Gullepalli B.O": "531035",
      "Petasudipuram B.O": "531055",
      "Turangalapalem B.O": "531055",
      "Vemagiri B.O": "531055",
      "Korukonda B.O": "531111",
      "Kothapalem B.O": "531111",
      "Luthugedda Jn. B.O": "531111",
      "Kudumusari B.O": "531111",
      "Bakuru B.O": "531077",
      "Galaganda B.O": "531077",
      "Guda B.O": "531077",
      "Gumma B.O": "535145",
      "Longuparthi B.O": "535145",
      "Uddandapuram B.O": "531126",
      "Lingarajupalem B.O": "531060",
      "Vommavaram B.O": "531060",
      "Kumarapuram  B.O": "531127",
      "Pentakota B.O": "531127",
      "Venkatanagaram B.O": "531127",
      "Anthakapalle B.O": "531035",
      "Asakapalle B.O": "531035",
      "Boduvalasa B.O": "531035",
      "Tekkalipalem B.O": "531035",
      "Kuntsangi B.O": "531032",
      "Maruturu B.O": "531032",
      "Uderoo B.O": "531032",
      "R Bheemavaram B.O": "531032",
      "Ameena Sahebpeta B.O": "531055",
      "Enugutuni B.O": "531055",
      "Melupaka B.O": "531055",
      "Pedapalli B.O": "531055",
      "Regupalem B.O": "531055",
      "Somavaram B.O": "531055",
      "Bennavaram B.O": "531111",
      "Chowdupalli B.O": "531111",
      "Jerrala B.O": "531111",
      "Thammingula B.O": "531111",
      "Vangasara B.O": "531111",
      "Bhimavaram B.O": "531082",
      "Gammili B.O": "531029",
      "Kuntharla B.O": "531029",
      "Singarbha B.O": "531029",
      "Vanthala B.O": "531029",
      "Gulleli B.O": "531029",
      "Kimudupalle B.O": "531077",
      "Kotnapalle B.O": "531077",
      "Sampathipuram B.O": "531031",
      "Gavaravaram B.O": "531075",
      "Vechalam B.O": "531075",
      "Boyila Kinthada B.O": "531075",
      "Mulakapalli B.O": "531075",
      "Nagavaram B.O": "531033",
      "Rajayyapeta B.O": "531081",
      "Vedullapalem B.O": "531081",
      "Ammulapalem B.O": "531002",
      "Kondupalem B.O": "531002",
      "Thotada B.O": "531002",
      "Nunaparthi B.O": "531020",
      "Venkatapathipalem B.O": "531020",
      "Dopperla B.O": "531021",
      "Payakarao Bonangi B.O": "531021",
      "Godicherla B.O": "531126",
      "Kannurupalem B.O": "531031",
      "Vetazangalapalem B.O": "531031",
      "Taruva Agraharam B.O": "531075",
      "Vakapalle B.O": "531075",
      "Timiram B.O": "531075",
      "Patipalle B.O": "531033",
      "Yerravaram B.O": "531033",
      "Bodugullam Agraharam B.O": "531081",
      "Chandanada B.O": "531081",
      "Pedateenarla B.O": "531081",
      "Upamaka Agraharam B.O": "531081",
      "Batlapudi B.O": "531002",
      "Rebaka B.O": "531126",
      "Ravada B.O": "531020",
      "Kalapaka B.O": "531021",
      "G J Puram B.O": "531126",
      "Kaligotla B.O": "531075",
      "MAMIDIPALLI B.O": "531075",
      "Chinadoddigallu B.O": "531081",
      "D L Puram B.O": "531081",
      "Peda Doddigallu B.O": "531081",
      "Amal College B.O": "531002",
      "Cheepurupalli B.O": "531020",
      "Dalaipalim B.O": "531020",
      "Bharnikam B.O": "531021",
      "Gullipadu B.O": "531126",
      "Sarvasiddi B.O": "531060",
      "Vakapadu B.O": "531060",
      "Adduru B.O": "531035",
      "Amruthpuram. B.O": "531035",
      "Gollalapalem B.O": "531035",
      "Kundram B.O": "531032",
      "Mamidipalem B.O": "531032",
      "T S Nagaram B.O": "531032",
      "Venkupalem B.O": "531032",
      "Mettapalem B.O": "531032",
      "Ganaparthi B.O": "531055",
      "Jagannadhapuram. B.O": "531055",
      "Pedaramabhadrapuram B.O": "531127",
      "Srirampuram B.O": "531127",
      "Aripaka B.O": "531035",
      "Kokkirapalle B.O": "531029",
      "Pulaparthi B.O": "531055",
      "Purushothapuram B.O": "531055",
      "Bylakinchangi B.O": "531111",
      "Mondigedda B.O": "531111",
      "Bonthilli B.O": "531029",
      "Gaduthuru B.O": "531029",
      "Killamkota B.O": "531029",
      "Lingeti B.O": "531029",
      "Luvvasingi B.O": "531029",
      "Pedalochali B.O": "531029",
      "Gomangi B.O": "531029",
      "Bongaram B.O": "531029",
      "Beeram B.O": "531029",
      "Mattam B.O": "531077",
      "Bangarammapalem B.O": "531035",
      "Mallunaidupalem B.O": "531035",
      "Chn Agraharam B.O": "531032",
      "Papayya Santhapalem B.O": "531032",
      "Bowluwada B.O": "531032",
      "Narasingabilli B.O": "531055",
      "Penugollu B.O": "531055",
      "Somalingapalem B.O": "531055",
      "Tsuchikonda B.O": "531055",
      "Damanapalli B.O": "531111",
      "Kommangi B.O": "531111",
      "Lothugedda B.O": "531111",
      "Vanchula B.O": "531111",
      "Yerrabommalu B.O": "531111",
      "Darlapudi B.O": "531082",
      "Bandaveedhi B.O": "531029",
      "Nurmathi B.O": "531029",
      "Sulabham B.O": "531029",
      "Addumanda B.O": "531077",
      "Gamparai B.O": "531077",
      "Guttulaputtu B.O": "531077",
      "Kamayyapeta B.O": "531077",
      "Konthili B.O": "531077",
      "P Kothapalle B.O": "531117",
      "Jilledupudi B.O": "531117",
      "Pamulavaka B.O": "531117",
      "Yerakannapalem B.O": "531117",
      "M Bennavaram B.O": "531117",
      "Araku Colony S.O": "531149",
      "Jawaharlalnehru Pharmacity S.O": "531019",
      "K Kotapadu S.O": "531034",
      "Nidanam Doddi S.O": "531002",
      "Paravada S.O": "531021",
      "Payakaraopeta S.O": "531126",
      "Yellamanchili S.O": "531055",
      "G Madugula S.O": "531029",
      "Kd Peta S.O": "531084",
      "Kj Puram S.O": "531028",
      "Nathavaram S.O": "531115",
      "Vaddadi S.O": "531026",
      "Atchutapuram S.O": "531011",
      "Kasimkota S.O": "531031",
      "S Rayavaram S.O": "531060",
      "Satyavaram S.O": "531127",
      "Subbavaram S.O": "531035",
      "Etikoppaka S.O": "531082",
      "Koyyuru S.O": "531087",
      "Madugula S.O": "531027",
      "Vemulapudi S.O": "531117",
      "A Koduru S.O": "531022",
      "Araku Rs S.O": "531151",
      "Chodavaram S.O": "531036",
      "Dimili S.O": "531061",
      "Gandhinagaram S.O (Visakhapatnam)": "531001",
      "Govada S.O": "531023",
      "Lakkavaram S.O (Visakhapatnam)": "531075",
      "Munagapaka S.O": "531033",
      "Nakkapalle S.O": "531081",
      "Thummapala S.O": "531032",
      "Chintapalli S.O": "531111",
      "Kotauratla S.O": "531085",
      "Krishna Bazar(Narsipatnam) S.O": "531118",
      "Gudem S.O": "531133",
      "Devarapalli S.O (Visakhapatnam)": "531030",
      "Ntpc Simhadri S.O": "531020",
      "Hukumpeta S.O": "531077",
      "Kothakota S.O (Visakhapatnam)": "531114",
      "Makavarapalem S.O": "531113",
      "Paderoo S.O": "531024",
      "Visakhapatnam H.O": "530001",
      "Waltair R S H.O": "530004",
      "Akkayyapalem S.O": "530016",
      "Gandhigram S.O (Visakhapatnam)": "530005",
      "Industrial Estate S.O (Visakhapatnam)": "530007",
      "Marripalem Vuda Colony S.O": "530009",
      "Naval Dock Yard S.O": "530014",
      "R P Agraharam S.O": "531219",
      "Sujatha Nagar S.O": "530051",
      "Zinc Smelter P S.O": "530015",
      "Autonagar S.O (Visakhapatnam Region)": "530012",
      "N A D S.O": "530009",
      "Pendurthy S.O": "531173",
      "R R V Puram S.O": "530029",
      "Special Economic Zone P.O": "530049",
      "Ukkunagaram S.O": "530032",
      "VM Steel Projrct Town Ship S.O": "530032",
      "Aganampudi S.O": "530053",
      "Pedabayalu S.O": "531040",
      "Pedagummuluru S.O": "531083",
      "Ravikamatham S.O": "531025",
      "Sileru Project S.O": "531105",
      "Anakapalle H.O": "531001",
      "Narsipatnam H.O": "531116",
      "Anandapuram S.O (Visakhapatnam)": "530052",
      "Chittivalasa S.O": "531162",
      "Gajuwaka S.O": "530026",
      "Gnanapuram S.O": "530004",
      "IRSD Area S.O": "530008",
      "Kancharapalem S.O": "530008",
      "Malkapuram S.O": "530011",
      "Muralinagar S.O": "530007",
      "Naval Base S.O": "530014",
      "Pedagantyada S.O": "530044",
      "Ratnagiri Colony S.O": "530048",
      "B H P V S.O": "530012",
      "Bheemunipatnam S.O": "531163",
      "Gopalapatnam S.O": "530027",
      "Marripalem S.O": "530018",
      "Nausenabagh S.O": "530005",
      "Simhachalam S.O": "530028",
      "Vadlapudi S.O": "530046",
      "Vepagunta S.O (Visakhapatnam)": "530047",
      "Visakhapatnam Steel Project S.O": "530031",
      "Andhra University S.O": "530003",
      "Dabagardens S.O": "530020",
      "Govt Dairy Farm S.O": "530040",
      "Kurupam Market S.O": "530001",
      "LIC Building S.O": "530004",
      "M.V.P.Colony S.O": "530017",
      "Madhurawada S.O": "530048",
      "Turners Choultry S.O": "530002",
      "Visalakshinagar S.O": "530043",
      "D.C. Buildings S.O": "530002",
      "Gitam Engg. College S.O": "530045",
      "H B Colony S.O": "530022",
      "KGH S.O": "530002",
      "L B Colony S.O": "530017",
      "P and T Colony (VM) S.O": "530013",
      "Pithapuram Colony S.O": "530003",
      "Pothinamallayapalem S.O": "530041",
      "Salagramapuram S.O": "530024",
      "Visakhapatnam Airport S.O": "530009",
      "Chinawaltair S.O": "530003",
      "Dwarakanagar S.O": "530016",
      "Fortward S.O": "530001",
      "Isakathota S.O": "530022",
      "Maharanipeta S.O": "530002",
      "VM Bus Station S.O": "530020",
      "Ghandhi Place S.O": "530003",
      "New Colony S.O": "530016",
      "Vidya Bhavan S.O": "530003"
    },
    "Y.S.R.": {
      "Pincha Dam Site B.O": "516129",
      "Jyothi B.O": "516237",
      "P. Kothapalli B.O": "516237",
      "Vontithatipalli B.O": "516237",
      "Gundlapalli B.O": "516130",
      "Kanchipativandlapalli B.O": "516130",
      "Peddabalija Palli B.O": "516130",
      "Peddapalli B.O": "516130",
      "Thimmasamudram B.O": "516130",
      "Pothapi B.O": "516151",
      "Tangedupalle B.O": "516329",
      "C Kothapalle B.O": "516293",
      "Gangayapalle B.O": "516293",
      "Gotur B.O": "516391",
      "Obulareddypalle B.O": "516321",
      "Mudumpadu B.O": "516129",
      "Bhagampalli B.O": "516130",
      "Reddivaripalli B.O": "516257",
      "Kumpinipuram B.O": "516151",
      "Jangampalli B.O": "516129",
      "Jangalapalli B.O": "516237",
      "Budidagunta Rachapalli B.O": "516130",
      "Polimerapalli B.O": "516130",
      "Sanipaya B.O": "516130",
      "Konapuram B.O": "516151",
      "Lebaka B.O": "516293",
      "Gangaperur B.O": "516213",
      "Rachapalli B.O": "516268",
      "Reddikottala B.O": "516193",
      "Vaddemanu B.O": "516193",
      "Alankhan Palli B.O": "516003",
      "Chemmumiapet B.O": "516003",
      "Ksrm Engg College B.O": "516003",
      "Lingareddy Palli B.O": "516003",
      "Anumpalli B.O": "516104",
      "Balireddygari Palli B.O": "516269",
      "Botlachervu B.O": "516269",
      "Chennamukka Palli B.O": "516269",
      "Devapatla B.O": "516215",
      "Machupalli B.O": "516002",
      "Ramanjaneyapuram B.O": "516002",
      "Kalavakunta B.O": "516505",
      "Edapalli B.O": "516268",
      "Gadikota B.O": "516268",
      "Anantharajup R.S. B.O": "516105",
      "Balireddy Palli B.O": "516105",
      "Chennarajupodu B.O": "516105",
      "Govindampalli B.O": "516105",
      "Akkireddygaripalli B.O": "516501",
      "Beebisahebpet B.O": "516501",
      "Mudrapalli B.O": "516128",
      "Obili B.O": "516128",
      "Thimmayyagaripalli B.O": "516128",
      "Thummachetlapalli B.O": "516128",
      "Lakshmigari Palli B.O": "516101",
      "Obanapalli B.O": "516101",
      "Settigunta B.O": "516101",
      "APSP Xl Batallion B.O": "516247",
      "Venkateswara Puram B.O": "516247",
      "Brahmanapalli B.O": "516217",
      "Mandaram B.O": "516126",
      "Mittameedipalli B.O": "516126",
      "Madithadu B.O": "516129",
      "Peddabidiki B.O": "516129",
      "Peddinenikalva B.O": "516129",
      "Gollapalli B.O": "516257",
      "Mohiddin Sahib Palli B.O": "516213",
      "Narvakatpalli B.O": "516213",
      "Rachagudipalli B.O": "516213",
      "Narayana(Nellore) B.O": "516126",
      "Chintharajupalli B.O": "516152",
      "Konarachapalli B.O": "516501",
      "Adapur B.O": "516150",
      "Pullapathur B.O": "516150",
      "Seshamanbapuram B.O": "516150",
      "Munnelli B.O": "516193",
      "Savisettipalli B.O": "516193",
      "Chinnakampalli B.O": "516003",
      "Krishnapur R.S. B.O": "516003",
      "Palampalli B.O": "516003",
      "Ramarajupalli B.O": "516003",
      "Eguvagottiveedu B.O": "516269",
      "Gorlamudiveedu B.O": "516269",
      "Gunnikuntla B.O": "516269",
      "Madhavaram B.O": "516269",
      "Guriginja Kunta B.O": "516215",
      "Motakatla B.O": "516215",
      "Rajuvaripalli B.O": "516215",
      "Settipalli B.O": "516215",
      "Buddayapalli B.O": "516002",
      "Degalavandlapalli B.O": "516002",
      "Siddavaram B.O": "516127",
      "Gurrappagaripalli B.O": "516268",
      "Ravulakolanu B.O": "516401",
      "T Thummalapalle B.O": "516401",
      "Peddaputta B.O": "516293",
      "Gangireddypalle B.O": "516321",
      "Gonumakulapalle B.O": "516321",
      "Veerannagattupalle B.O": "516329",
      "Ambavaram B.O": "516434",
      "Komarunipalle B.O": "516293",
      "Koppalu B.O": "516293",
      "Tappetla B.O": "516293",
      "Thollaganganapalle B.O": "516293",
      "Animela B.O": "516321",
      "Busireddypalle B.O": "516321",
      "Bhumayagaripalle B.O": "516349",
      "Velpula B.O": "516349",
      "Peddiveedu B.O": "516268",
      "Raghavarajupuram B.O": "516105",
      "Chenduvoyi B.O": "516501",
      "Muthukur B.O": "516350",
      "Venkatasettipalli B.O": "516501",
      "Besthapalli B.O": "516129",
      "Kattavaripalli B.O": "516128",
      "Polopalli B.O": "516104",
      "Buduguntapalli B.O": "516126",
      "Koneti Raju Kandrika B.O": "516101",
      "Srinivasa Nagar B.O": "516101",
      "Vellavari Kandrika B.O": "516101",
      "Venkatapathiraju Kandrika B.O": "516101",
      "Peddapalle B.O": "516247",
      "Cherlopalli B.O": "516126",
      "Karampalli B.O": "516126",
      "Tallapaka B.O": "516126",
      "Upparapalli B.O": "516162",
      "Akepadu B.O": "516150",
      "Cheyyeru  Project B.O": "516150",
      "Patur B.O": "516150",
      "AITS CAMPUS B.O": "516126",
      "Rangasamudram B.O": "516193",
      "Sankavaram B.O": "516193",
      "Chintha Komma Dinne B.O": "516003",
      "Kopparthi B.O": "516003",
      "S.V.U. P.G .centre B.O": "516003",
      "Abbavaramvandlapalli B.O": "516269",
      "Diguvagottiveedu B.O": "516269",
      "Endapalli B.O": "516269",
      "Katinayakunta B.O": "516269",
      "Adavikammapalli B.O": "516215",
      "Dudyala B.O": "516215",
      "Lingampalli B.O": "516002",
      "Patha Cuddapah B.O": "516002",
      "RTC Work Shop B.O": "516002",
      "Ukkayapalle B.O": "516002",
      "CENTRAL PRISON B.O": "516002",
      "Rajasahebpet B.O": "516505",
      "T.Sallagarigela B.O": "516505",
      "Thokalapalli B.O": "516505",
      "Galivaripalle B.O": "516293",
      "Moillacheruvu B.O": "516321",
      "Chinna Musali Reddy Palli B.O": "516004",
      "Mamillapalli B.O": "516217",
      "Mangampet B.O": "516105",
      "Yerraguntlakota B.O": "516105",
      "Kumbhagiri B.O": "516501",
      "Malinenipatnam B.O": "516501",
      "Malemarpuram B.O": "516128",
      "Nakkalapalli B.O": "516128",
      "Rajukunta B.O": "516104",
      "Chiyyavaram B.O": "516101",
      "Kukkala Doddi B.O": "516101",
      "Nekanapuram B.O": "516247",
      "Galivaripalli B.O": "516126",
      "Seetharamapuram B.O": "516126",
      "Allwyn Nagar B.O": "516150",
      "Ramireddypalle B.O": "516321",
      "Chagaleru B.O": "516349",
      "VKothapalle B.O": "516349",
      "Thogurupet B.O": "516150",
      "Chinnampelli B.O": "516108",
      "Kodigudlapadu B.O": "516193",
      "Pullaveedu B.O": "516193",
      "Rameswaram B.O": "516193",
      "Nagi Reddy Palli B.O": "516003",
      "Pabbapuram B.O": "516003",
      "Tadigotla B.O": "516003",
      "Utukur B.O": "516126",
      "Odiveedu B.O": "516269",
      "Pemmadapalli B.O": "516269",
      "Sibyala B.O": "516269",
      "Guttapalli B.O": "516215",
      "Muthukuvandla Palli B.O": "516215",
      "Narayana Reddy Palli B.O": "516215",
      "Rowthukunta B.O": "516215",
      "T. Sadipirallavandla Palli B.O": "516215",
      "Vaddevandlapalli B.O": "516215",
      "Palagiri B.O": "516321",
      "Yerramalapalle B.O": "516321",
      "Botumeedipalli B.O": "516108",
      "Chinnachowk B.O": "516002",
      "Takkolu B.O": "516002",
      "Matli B.O": "516268",
      "Somavaram B.O": "516268",
      "Vongimalla B.O": "516268",
      "Uppatur B.O": "516501",
      "Itimarpuram B.O": "516128",
      "Devamachupalli B.O": "516104",
      "Kampasamudram B.O": "516104",
      "Kandulavaripalli B.O": "516104",
      "Mylapalli B.O": "516104",
      "Barytes Factory B.O": "516101",
      "Surapurajupalli B.O": "516101",
      "Venkata Reddy Palli B.O": "516101",
      "Kothaboyanapalli B.O": "516126",
      "Kuchivaripalli B.O": "516126",
      "Lingarajupalli B.O": "516126",
      "Madanagopalapuram B.O": "516126",
      "Poli B.O": "516126",
      "Rollamadugu B.O": "516126",
      "Varadaiahgaripalli B.O": "516126",
      "Nadimpalli B.O": "516152",
      "Gundlur B.O": "516150",
      "Mandapalli B.O": "516150",
      "Nandalur Bazar B.O": "516150",
      "Naramrajupalli B.O": "516150",
      "Gondipalle B.O": "516218",
      "Kanamakindikottala B.O": "516349",
      "Mabbuchintalapalle B.O": "516349",
      "Pendluru B.O": "516349",
      "Duggannagaripalle B.O": "516350",
      "Pamuluru B.O": "516350",
      "K Sugumanchipalle B.O": "516474",
      "Konavaripalle B.O": "516474",
      "Chinnaorampadu B.O": "516108",
      "Narasingarajapuram B.O": "516127",
      "Gopamambapuram B.O": "516107",
      "Kothapet B.O": "516163",
      "Poluruvengannagaripalli B.O": "516107",
      "Ramasamudram B.O": "516107",
      "T.Kammapalli B.O": "516107",
      "Himakunta B.O": "516454",
      "Kasanur B.O": "516454",
      "Alavalapadu B.O": "516350",
      "Ayyavaripalle B.O": "516350",
      "Bakkannagaripalle B.O": "516350",
      "Bukkapatnam B.O": "516474",
      "Chevvanagayapalle B.O": "516474",
      "Dattapuram B.O": "516474",
      "Erragudi B.O": "516474",
      "Bhadrampalle": "516401",
      "Gurijala B.O": "516454",
      "Giddankipalle B.O": "516350",
      "T Velamvaripalle B.O": "516350",
      "Gutta Kinda Racha Palli B.O": "516129",
      "Bommavaram B.O": "516110",
      "Cheruvukinda Rachapalli B.O": "516110",
      "Nagavaram B.O": "516110",
      "Velagacherla B.O": "516127",
      "Ananthasamudram B.O": "516107",
      "Appayarajupet B.O": "516107",
      "Dalavaipalli B.O": "516107",
      "Puthanavaripalli B.O": "516107",
      "Siddanthipuram B.O": "516203",
      "Thavaripalli B.O": "516203",
      "Bedudur B.O": "516474",
      "Eturu B.O": "516474",
      "Kodur B.O": "516309",
      "Yenamalachintala B.O": "516474",
      "Buchupalle B.O": "516401",
      "Mallela B.O": "516401",
      "Obayapalle B.O": "516356",
      "Chirrajupalle B.O": "516310",
      "Kalamalla B.O": "516310",
      "Nidizuvvi B.O": "516310",
      "Veparala B.O": "516431",
      "Errapalle B.O": "516175",
      "Madirepalle B.O": "516175",
      "Peddajonnavaram B.O": "516175",
      "Ramapuram B.O": "516216",
      "Ramasainagar B.O": "516175",
      "Dorasanipalle B.O": "516361",
      "Hanumanagutti B.O": "516361",
      "Somulavaripalle B.O": "516361",
      "Kondasunkesula B.O": "516434",
      "Moragudi B.O": "516434",
      "Peddamudium B.O": "516434",
      "Purvabommepalle B.O": "516434",
      "Suddapalle B.O": "516434",
      "Meenapuram B.O": "516362",
      "Arakatavemula B.O": "516359",
      "Eruvapalem B.O": "516359",
      "Chintakunta B.O": "516172",
      "Nallaballe B.O": "516380",
      "Penikalapadu B.O": "516380",
      "Anandashram B.O": "516172",
      "Annaluru B.O": "516172",
      "Ananthapuram B.O": "516257",
      "Ekilapalli B.O": "516257",
      "Konampet B.O": "516257",
      "Abbavaram B.O": "516270",
      "Bandlapalli B.O": "516270",
      "Kondavandlapalli B.O": "516259",
      "Boppapuram B.O": "516193",
      "Dammanapalli B.O": "516193",
      "Itigullapadu B.O": "516193",
      "Korlakunta B.O": "516108",
      "Mukkavaripalli B.O": "516108",
      "Nukanapalli B.O": "516108",
      "Peddaorampadu B.O": "516108",
      "Venkatarajupalli B.O": "516110",
      "Dandlapalli B.O": "516107",
      "Vathalur B.O": "516107",
      "Kamballe B.O": "516401",
      "Lomada B.O": "516401",
      "Kathalur B.O": "516350",
      "Kuppalapalle B.O": "516350",
      "Nagoor B.O": "516350",
      "Nedarapeta B.O": "516474",
      "Regadipalle B.O": "516474",
      "Siregepalle B.O": "516474",
      "Thirumallayapalle B.O": "516474",
      "Nagulapalle B.O": "516356",
      "Seetharampuram B.O": "516356",
      "Bhimagundam B.O": "516433",
      "Gundlakunta B.O": "516431",
      "Chinnasinganapalle B.O": "516175",
      "Krishnampalle B.O": "516175",
      "Machanapalle B.O": "516175",
      "Neelapuram B.O": "516175",
      "Pullareddypeta B.O": "516175",
      "Vasudevapuram B.O": "516175",
      "Kakirenipalle B.O": "516361",
      "Sankarapuram B.O": "516361",
      "Gopavaram B.O": "516233",
      "Diguvakalavatala B.O": "516434",
      "Goriganur B.O": "516434",
      "Palur B.O": "516421",
      "Papayapalle B.O": "516434",
      "Peddandlur B.O": "516434",
      "Sunnapurallapalle B.O": "516434",
      "Tallamapuram B.O": "516362",
      "Khaderapalle B.O": "516356",
      "Pallavolu B.O": "516356",
      "MKambaladinne B.O": "516433",
      "Karamalavandlapalle B.O": "516431",
      "Bayanapalle B.O": "516175",
      "Kamanur B.O": "516175",
      "Kanagudur B.O": "516175",
      "Nelatur B.O": "516175",
      "TSallabasayapalle B.O": "516175",
      "Yerraguntlapalle B.O": "516362",
      "Chinnasettipalle B.O": "516359",
      "Gadegudur B.O": "516359",
      "Kulur B.O": "516359",
      "Bondalakunta B.O": "516380",
      "K Kothapalle B.O": "516380",
      "Uppaluru B.O": "516380",
      "Annapusastrulapalle B.O": "516172",
      "Alladupalle B.O": "516356",
      "Chiyyapadu B.O": "516356",
      "Narjampalle B.O": "516433",
      "Nawabpeta B.O": "516433",
      "Ponnampalle B.O": "516433",
      "Talamanchipatnam B.O": "516433",
      "Torrivemula B.O": "516433",
      "Bodithippanapadu B.O": "516431",
      "Ponnathota B.O": "516431",
      "SUppalapadu B.O": "516431",
      "Gudipadu B.O": "516175",
      "Idamadaka B.O": "516175",
      "Jillella B.O": "516175",
      "Venkupalle B.O": "516175",
      "Chennamarajupalle B.O": "516361",
      "Malepadu B.O": "516361",
      "Chowdur B.O": "516361",
      "Devagudi B.O": "516434",
      "Anantapuram B.O": "516355",
      "Nakkaladinne B.O": "516355",
      "Thippireddipalle B.O": "516355",
      "Annavaram B.O": "516362",
      "Kothapalle B.O": "516362",
      "Maduru B.O": "516362",
      "Parlapadu B.O": "516359",
      "Rajupalem B.O": "516359",
      "Velavali B.O": "516359",
      "Yamavaram B.O": "516380",
      "Peddasettipalle B.O": "516361",
      "Potladurthi B.O": "516361",
      "Gandikota B.O": "516434",
      "Gudemcheruvu B.O": "516434",
      "Vedururu B.O": "516355",
      "Upparapalle B.O": "516362",
      "Gopayapalle B.O": "516359",
      "Paidala B.O": "516359",
      "Tanguturu B.O": "516359",
      "Chinnadudyal B.O": "516380",
      "Rajulaguruvayapalle B.O": "516380",
      "Velpucherla B.O": "516380",
      "Bhadripalle B.O": "516172",
      "Venkataramapuram B.O": "516228",
      "Boyanapalli B.O": "516227",
      "Chinthalacheruvu B.O": "516227",
      "Mannemavaripalli B.O": "516227",
      "Kuppagattupalli B.O": "516259",
      "Mulapalli B.O": "516259",
      "Surabhi B.O": "516259",
      "Gadela B.O": "516108",
      "Yellayapalli B.O": "516108",
      "Nagaripadu B.O": "516110",
      "Kondur B.O": "516218",
      "Singareddypalli B.O": "516127",
      "Ananthaiah Gari Palle B.O": "516107",
      "Kommanavaripalli B.O": "516107",
      "Reddipalli B.O": "516107",
      "Thippayyapalli B.O": "516107",
      "Tripuravaram B.O": "516203",
      "Kurnoothala B.O": "516257",
      "Thudumaladinne B.O": "516203",
      "Appanakondayapalli B.O": "516257",
      "Dappepalli B.O": "516257",
      "Guntimadugu B.O": "516257",
      "Pothukurapalli B.O": "516270",
      "Rajupalli B.O": "516504",
      "Chinthalapalli B.O": "516193",
      "Maddirevula B.O": "516257",
      "Dinnepadu B.O": "516504",
      "Gopagudi Palli B.O": "516504",
      "Guvvalachervu B.O": "516504",
      "Hasanapuram B.O": "516504",
      "Akkalareddypalli B.O": "516193",
      "Amagampalli B.O": "516193",
      "Ankanagodiganur B.O": "516228",
      "Ganugapenta B.O": "516228",
      "Kalvapalli B.O": "516228",
      "Mekalavaripalli B.O": "516228",
      "Payalakunta B.O": "516228",
      "Valleruvaripalli B.O": "516227",
      "Addalamarri B.O": "516259",
      "Chakrayapet B.O": "516259",
      "Chilakampalli B.O": "516259",
      "Kumarakalva B.O": "516259",
      "Eguvanelatur B.O": "516502",
      "Gunthapalli B.O": "516502",
      "Bayanapalli B.O": "516162",
      "Kokkarayapalli B.O": "516162",
      "Mundlapalli B.O": "516162",
      "Pushpagiri B.O": "516162",
      "Ravulapalli B.O": "516203",
      "Brahmana Erragudi B.O": "516257",
      "Budida Gunta Palli B.O": "516257",
      "Kasthurirajupalli B.O": "516257",
      "Kakulavaram B.O": "516270",
      "Venkatreddygaripalli B.O": "516270",
      "Gallavandlapalle B.O": "516172",
      "Jandravaram B.O": "516172",
      "Krishnapuram B.O": "516172",
      "Lingaladinne B.O": "516172",
      "Nagasanipalle B.O": "516172",
      "Nandyalampeta B.O": "516172",
      "Obulareddypeta B.O": "516172",
      "Thippireddypalle B.O": "516216",
      "Viswanathapuram B.O": "516173",
      "Jangalapalle B.O": "516411",
      "N Kottalapalle B.O": "516411",
      "Nemalladinne B.O": "516411",
      "Seshareddipalle B.O": "516411",
      "Kallutla B.O": "516432",
      "Kammavaripalle B.O": "516216",
      "Ramachandrayapalle B.O": "516432",
      "Illur B.O": "516312",
      "Peddanapadu B.O": "516309",
      "Ganganapalle B.O": "516216",
      "Krishnamgaripalle B.O": "516421",
      "Saidapuram B.O": "516421",
      "Udavagandla B.O": "516421",
      "Bojjayapalle B.O": "516484",
      "Madur B.O": "516484",
      "Nakkalapalle B.O": "516484",
      "Kondayapalle B.O": "516289",
      "Kuppuruvaripalle B.O": "516289",
      "Letapalle B.O": "516289",
      "Sambatur B.O": "516289",
      "Tsadipiralla B.O": "516289",
      "Gandlur B.O": "516444",
      "Korrapadu B.O": "516444",
      "Mangapatnam B.O": "516444",
      "Nandyalampalle B.O": "516464",
      "Paidipalem B.O": "516464",
      "Akkulugaripalle B.O": "516396",
      "Diguvathuvvapalle B.O": "516218",
      "Kommaddi B.O": "516339",
      "Talapanur B.O": "516339",
      "Urutur B.O": "516339",
      "Vellatur B.O": "516216",
      "Chinnarangapuram B.O": "516391",
      "Chintalajutur B.O": "516391",
      "Erripalle B.O": "516391",
      "Gollalagudur B.O": "516391",
      "Agraharam B.O": "516454",
      "Chitlur B.O": "516504",
      "Kalpanayunicheruvu B.O": "516504",
      "Nallaguttapalli B.O": "516504",
      "Saraswatipalli B.O": "516504",
      "Suddamalla B.O": "516504",
      "Ayyavaripalli B.O": "516193",
      "Chennavaram B.O": "516193",
      "Govindayapalli B.O": "516193",
      "Reddyvaripalli B.O": "516214",
      "T. Sakibanda B.O": "516214",
      "Yerragatlavandlapalli B.O": "516214",
      "Cheemalacheruvupalli B.O": "516267",
      "Gopanapalli B.O": "516267",
      "Pandillapalli B.O": "516267",
      "Talamudipi B.O": "516267",
      "Tamtamvandlapalli B.O": "516267",
      "Thumukunta B.O": "516267",
      "Madakalavaripalli B.O": "516233",
      "Rachayapet B.O": "516233",
      "Tellapadu B.O": "516217",
      "Basavapuram B.O": "516503",
      "Konduvaripalli B.O": "516503",
      "K.Sunkesala B.O": "516203",
      "Kommaluru B.O": "516203",
      "Koonavaripalli B.O": "516203",
      "Chinnaguruvaluru B.O": "516172",
      "Lakshmipeta B.O": "516172",
      "Sankatithimmayapalle B.O": "516172",
      "Sivapuram B.O": "516172",
      "Ellampalle B.O": "516173",
      "Mittamanipalle B.O": "516173",
      "Chinnapasupula B.O": "516411",
      "Bestavemula B.O": "516432",
      "Prabhalaveedu B.O": "516228",
      "Ethirajupalli B.O": "516227",
      "Kamalakur B.O": "516227",
      "Katineni Erragudi B.O": "516259",
      "Nersupalli B.O": "516259",
      "Chinnakesampalli B.O": "516502",
      "Diguvanelatur B.O": "516502",
      "Kothapalli B.O": "516163",
      "Nandipalli B.O": "516502",
      "Rekalakunta B.O": "516502",
      "Ramanapalli B.O": "516162",
      "Devagudipalli B.O": "516214",
      "Kesapuram B.O": "516214",
      "Padamatikona B.O": "516214",
      "Dumpalagattu B.O": "516163",
      "Industrial Estate B.O": "516004",
      "Araveedu B.O": "516267",
      "Burujupalli 1 B.O": "516267",
      "Kamalamarri B.O": "516267",
      "Pulikunta B.O": "516267",
      "Rekulakunta B.O": "516233",
      "Narasapuram B.O": "516217",
      "Varikunta B.O": "516217",
      "Mallepalli B.O": "516503",
      "Palugurallapalli B.O": "516503",
      "Appanapalli B.O": "516203",
      "Bhumayapalli B.O": "516203",
      "Mekalabalayapalle B.O": "516312",
      "T Sunkesula B.O": "516309",
      "Valasapalle B.O": "516309",
      "Kondreddypalle B.O": "516421",
      "Santhakovur B.O": "516421",
      "Dondlavagu B.O": "516484",
      "Appayapalle B.O": "516289",
      "Dadireddypalle B.O": "516289",
      "Nallingayapalle B.O": "516289",
      "Podadurthy B.O": "516289",
      "Settivaripalle B.O": "516173",
      "Chevvaripalle B.O": "516464",
      "Musalreddipalle B.O": "516464",
      "Sunkesula B.O": "516464",
      "Gunakanapalle B.O": "516396",
      "Kommanuthala B.O": "516396",
      "Minnaiahgaripalle B.O": "516218",
      "Garlamittapalle B.O": "516339",
      "Kirthipalle B.O": "516339",
      "Paidikalva B.O": "516216",
      "Rachavaripalle B.O": "516216",
      "Ambakkapalle B.O": "516391",
      "Murarichintala B.O": "516391",
      "Peddarangapuram B.O": "516391",
      "R Thummalapalle B.O": "516391",
      "Brahmanapalle B.O": "516391",
      "Erraballe B.O": "516391",
      "Bidinamcherla B.O": "516454",
      "B . Kodur B.O": "516228",
      "Pedullapalli B.O": "516228",
      "Gudem B.O": "516227",
      "Gangarapupalli B.O": "516259",
      "Kalluripalli B.O": "516259",
      "Kuppam B.O": "516259",
      "Balayapalli B.O": "516502",
      "Dirasavantsa B.O": "516502",
      "Peddarajupalli B.O": "516502",
      "Chinnamachupalli B.O": "516162",
      "Obulampalli B.O": "516162",
      "Rachinnayapalli B.O": "516162",
      "Siddareddypalle B.O": "516172",
      "Uppaguntapalle B.O": "516172",
      "Ganjikunta B.O": "516173",
      "Balapanagudur B.O": "516411",
      "J Kothapalle B.O": "516411",
      "Chinnaventhurla B.O": "516432",
      "Dhodiyam B.O": "516432",
      "Chinadandlur B.O": "516312",
      "Achavalli B.O": "516421",
      "Inagalur B.O": "516421",
      "Nallacheruvupalle B.O": "516421",
      "Bonala B.O": "516484",
      "Kamasamudram B.O": "516484",
      "Koraguntapalle B.O": "516484",
      "C Gopalapuram B.O": "516289",
      "Kokatam B.O": "516289",
      "Pandillapalle B.O": "516289",
      "Peddacheppalle B.O": "516289",
      "Chowtapalle B.O": "516444",
      "Kodikandlapalle B.O": "516444",
      "P Anantapuram B.O": "516444",
      "Jangamreddypalle B.O": "516464",
      "Pottipadu B.O": "516464",
      "Thimmapuram B.O": "516464",
      "Y Kothapalle B.O": "516464",
      "Chinnakudala B.O": "516396",
      "Karnapapayapalle B.O": "516396",
      "Cheemalapenta B.O": "516218",
      "Machanur B.O": "516218",
      "C Rajupalem B.O": "516339",
      "Indukur B.O": "516339",
      "Moillakalav B.O": "516216",
      "Pathasankatipalle B.O": "516216",
      "Bokkudupalle B.O": "516391",
      "Ippatla B.O": "516391",
      "Nallapureddypalle B.O": "516391",
      "Peddajutur B.O": "516391",
      "B Cherlopalle B.O": "516454",
      "Thummalapalle B.O": "516309",
      "Ankalammagudur B.O": "516484",
      "Apparaopalle B.O": "516289",
      "Chinnacheppalle B.O": "516289",
      "Devarajupalle B.O": "516289",
      "Gangavaram B.O": "516289",
      "Yerragudipadu B.O": "516289",
      "Lopatnuthala B.O": "516396",
      "Parnapalle B.O": "516396",
      "Peddakudala B.O": "516396",
      "Velidandla B.O": "516396",
      "Thummalur B.O": "516218",
      "U Rajupalem B.O": "516218",
      "A. Obayapalle B.O": "516339",
      "Alidena B.O": "516339",
      "Veldurthi B.O": "516339",
      "Diguvapalle B.O": "516216",
      "Gopalapuram B.O": "516216",
      "Srinivasapuram B.O": "516216",
      "Pulivendlakutcherry B.O": "516391",
      "Ulimella B.O": "516391",
      "Venkatapuram B.O": "516391",
      "Bonamala B.O": "516214",
      "Kalibanda B.O": "516214",
      "Mallur B.O": "516214",
      "Burujupalli 2 B.O": "516267",
      "Karimireddy Vandlapalli B.O": "516267",
      "Pujalavandlapalli B.O": "516267",
      "Pyarampalli B.O": "516267",
      "Singamvaripalli B.O": "516267",
      "Veligallu B.O": "516267",
      "Bethayapalli B.O": "516233",
      "T. Sandrapalli B.O": "516233",
      "Musalreddypalli B.O": "516217",
      "Pittigunta B.O": "516217",
      "Mudumala B.O": "516503",
      "Pundlachennupalli B.O": "516503",
      "Beechuvaripalli B.O": "516203",
      "Kotlur B.O": "516203",
      "Miduthur B.O": "516203",
      "Nagapatnam B.O": "516203",
      "Thimmareddypalli B.O": "516259",
      "Jangamrajupalli B.O": "516502",
      "Kongalaveedu B.O": "516502",
      "Thangedupalli B.O": "516502",
      "Thiruvengalapuram B.O": "516502",
      "Sivalapalli B.O": "516162",
      "Goramchervu B.O": "516267",
      "Gundlacheruvu B.O": "516267",
      "Nuliveedu B.O": "516267",
      "Pandikunta B.O": "516267",
      "Chennupalli B.O": "516217",
      "Eguvaramapuram B.O": "516217",
      "Ganganapalli B.O": "516217",
      "Somireddypalli B.O": "516503",
      "T.Soudarivaripalli B.O": "516503",
      "Etur B.O": "516203",
      "Pullur kottalu B.O": "516203",
      "Duddekunta B.O": "516454",
      "Venkayakalva B.O": "515465",
      "Proddatur H.O": "516360",
      "Rajampet H.O": "516115",
      "Pulivendla H.O": "516390",
      "Cuddapah H.O": "516001",
      "Kodur S.O": "516101",
      "Mannur S.O (Cuddapah)": "516126",
      "Obulavaripalli S.O": "516108",
      "Rajampet Rs S.O": "516115",
      "Badvel Bazaar S.O": "516227",
      "Chennampalli S.O": "516502",
      "Jayanagar S.O (Cuddapah)": "516002",
      "Kalasapadu S.O": "516217",
      "Ravindra Nagar S.O": "516003",
      "RIMS S.O": "516002",
      "Shankarapuram (Cuddapah) S.O": "516002",
      "Sunnapuralla Palli S.O": "516001",
      "Yerramukkapalli S.O": "516004",
      "Yogi Vemana University S.O.": "516005",
      "Chakrapunayanipet S.O": "516128",
      "Anantharajupuram S.O": "516228",
      "Badvel S.O": "516227",
      "Chennur S.O (Cuddapah)": "516162",
      "Chinnamandem S.O": "516214",
      "Lakkireddy Palli S.O": "516257",
      "Anantharajupet S.O": "516105",
      "Atlur S.O": "516501",
      "Chitvel S.O": "516104",
      "Kodur Rs S.O": "516101",
      "Penagalur S.O": "516127",
      "Pullampet S.O": "516107",
      "Siddavattam S.O": "516237",
      "T. Sundupalli S.O": "516130",
      "Vontimitta S.O": "516213",
      "Madhavaram S.O (Cuddapah)": "516247",
      "Mantapampalli S.O": "516152",
      "Peddarachapalli S.O": "516110",
      "Tangatur S.O": "516151",
      "Nandalur S.O": "516150",
      "Rayavaram S.O (Cuddapah)": "516129",
      "Balathimmayyagaripalli S.O": "516259",
      "Cooperative Colony S.O": "516001",
      "Gopavaram Project Site S.O": "516233",
      "Maruti Nagar S.O": "516001",
      "Porumamilla S.O": "516193",
      "Sambepalli S.O": "516215",
      "Sanjeevi Nagar S.O": "516269",
      "Almaspet S.O": "516001",
      "Cuddapah Coop Sugars S.O": "516163",
      "Galiveedu S.O": "516267",
      "Kandimallayapalli S.O": "516503",
      "Khajipet S.O": "516203",
      "Masapet Bazar S.O": "516270",
      "Nagarajupet S.O": "516001",
      "Neelakantaraopet S.O": "516504",
      "Rayachoti S.O": "516269",
      "Tekurpet S.O": "516505",
      "Veeraballi S.O": "516268",
      "Chinnakomerla S.O": "516433",
      "College Road S.O": "516360",
      "Korrapadu Road S.O": "516360",
      "Muddanur S.O": "516380",
      "Mylavaram S.O (Cuddapah)": "516439",
      "Chapadu S.O": "516356",
      "Chilamakur S.O": "516310",
      "Dommaranandyala S.O": "516431",
      "Holmespet S.O": "516361",
      "Jammalamadugu North S.O": "516434",
      "Krishna Nagar S.O (Cuddapah)": "516311",
      "Mydekur S.O": "516172",
      "Onipenta S.O": "516173",
      "Proddatur Bazaar S.O": "516360",
      "Pulivendla Bus stand S.O": "516391",
      "Duvvur S.O (Cuddapah)": "516175",
      "Khadarabad S.O": "516362",
      "Korrapadu S.O": "516359",
      "Vv Reddy Nagar S.O": "516312",
      "YMR Colony S.O": "516360",
      "Kondapuram S.O (Cuddapah)": "516444",
      "Nandimandalam S.O": "516218",
      "Payasampalle S.O": "516339",
      "Tallaproddatur S.O": "516474",
      "Tallapalle S.O": "516350",
      "Idupulapaya(IIIT) S.O": "516330",
      "Gandhi Road S.O (Cuddapah)": "516360",
      "Jammalamadugu East S.O": "516434",
      "Jammalamadugu S.O": "516434",
      "Kallur S.O (Cuddapah)": "516355",
      "Modameedipalle S.O": "516360",
      "Peddapasupula S.O": "516411",
      "Vaddirala S.O": "516432",
      "Yerraguntla West S.O": "516309",
      "Agadur S.O": "516421",
      "Tondur S.O": "516401",
      "Vallur S.O (Cuddapah)": "516293",
      "Vemula S.O": "516349",
      "Proddatur Fort S.O": "516360",
      "Yerraguntla S.O (Cuddapah)": "516309",
      "Ankalammapeta S.O": "516390",
      "Balapanur S.O": "516484",
      "Kamalapuram S.O (Cuddapah)": "516289",
      "Lavanur S.O": "516464",
      "Lingala S.O (Cuddapah)": "516396",
      "Pendlimarri S.O": "516216",
      "Simhadripuram S.O": "516454",
      "Vaimpalle S.O": "516329",
      "Veerapunayanipalle S.O": "516321"
    },
    "SPSR NELLORE": {
      "VIKRAMASIMHAPURI UNIVERSITY SO": "524324",
      "Thurupurompi Dodla B.O": "524221",
      "Kothapeta B.O": "524221",
      "Narasimhapuram B.O": "524221",
      "Chennuru B.O": "524240",
      "Lingalapadu B.O": "524240",
      "Kapparallatippa B.O": "524152",
      "Ulavapalle B.O": "524152",
      "Zuvvaladinne B.O": "524152",
      "Somalaregada B.O": "524222",
      "Thurpuboyamadugula B.O": "524236",
      "Bodagudipadu B.O": "524240",
      "Gopannapalem Kandriga B.O": "524223",
      "Kammavaripalem B.O": "524234",
      "Kothapalli B.O": "524303",
      "Lingaraju Agraharam B.O": "524223",
      "Somavarappadu B.O": "524223",
      "Chinna Annalur B.O": "524224",
      "Jirravaripalem B.O": "524224",
      "Polampadu B.O": "524224",
      "Kunkuvaripalem B.O": "524239",
      "Somasila Hill Colony S.O": "524300",
      "Talluru B.O": "524142",
      "Isaka Damerla B.O": "524221",
      "Katrayapadu B.O": "524240",
      "Manubolupadu B.O": "524240",
      "Rangasamudram B.O": "524240",
      "Vellupodu B.O": "524240",
      "Allimadugu B.O": "524152",
      "Kothapalli Kovurgunta B.O": "524152",
      "Appasamudram B.O": "524222",
      "Rachavaripalli B.O": "524222",
      "Tsoudepalli B.O": "524236",
      "Gudinarava B.O": "524236",
      "Papannagaripalli B.O": "524236",
      "Thotlacheruvupalli B.O": "524236",
      "Brahmanakraka Agraharam B.O": "524223",
      "Chinnakraka B.O": "524223",
      "Budamgunta B.O": "524223",
      "Jammalapalem B.O": "524223",
      "Siripuram B.O": "524223",
      "Choudaripalem B.O": "524223",
      "Vepanapi B.O": "524224",
      "Mudimurthypuram B.O": "524239",
      "Veligandla B.O": "524239",
      "Bheemavaram B.O": "524312",
      "Chigurupadu B.O": "524421",
      "Palachur B.O": "524421",
      "Punnepalli B.O": "524421",
      "Thimmajikandriga B.O": "524421",
      "Annamedu B.O": "524126",
      "Kapulur B.O": "524126",
      "Talvaipadu B.O": "524126",
      "Ipuru B.O": "524323",
      "Pantapalem B.O": "524323",
      "Punabaka B.O": "524129",
      "Biradavolu B.O": "524345",
      "Yetur B.O": "524345",
      "Dos Colony B.O": "524121",
      "Maddurupalli B.O": "524408",
      "Mudivarthipalem B.O": "524313",
      "Tatakaladinne B.O": "524366",
      "Bandarupalli B.O": "524303",
      "Dundigam B.O": "524308",
      "Kondameedikondur B.O": "524308",
      "Kuppurupadu B.O": "524308",
      "Peramana B.O": "524308",
      "Tarunavoya B.O": "524308",
      "Manchalapalli B.O": "524302",
      "Chinacherukuru B.O": "524002",
      "Chintopu B.O": "524002",
      "Ntr Nagar B.O": "524002",
      "South Amaluru B.O": "524002",
      "Macherlavaripalem B.O": "524311",
      "Papireddypalem B.O": "524311",
      "Ponnapudipeddapalem B.O": "524318",
      "Thummagunta B.O": "524318",
      "Vavilla B.O": "524318",
      "Bodduvaripalem B.O": "524319",
      "Racherlapadu B.O": "524319",
      "Ganeswarapuram B.O": "524221",
      "Garimenapenta B.O": "524221",
      "Vengannapalem B.O": "524221",
      "Chowtaputtedu B.O": "524240",
      "Tadakalur B.O": "524240",
      "Venkatesupalem B.O": "524152",
      "Dasaripalli B.O": "524222",
      "Lakshmipuram B.O": "524225",
      "Mandalanaidupalli B.O": "524222",
      "Narrawada B.O": "524222",
      "Arlapadia B.O": "524236",
      "Guvvadi B.O": "524236",
      "Kondayapalem B.O": "524003",
      "Peddireddypalli B.O": "524236",
      "Virur B.O": "524236",
      "Annavaram B.O": "524223",
      "Chalamcherla B.O": "524223",
      "Rajuvari Chintalapalem B.O": "524223",
      "Thurupu Yerraballi B.O": "524239",
      "Chintaladevi B.O": "524239",
      "Dubagunta B.O": "524228",
      "Vadlapudi B.O": "524405",
      "Nelaballi B.O": "524126",
      "Thummur B.O": "524126",
      "Vinnamala B.O": "524126",
      "Yakasiri B.O": "524126",
      "Tirumalammapalem B.O": "524323",
      "Akkagaripeta B.O": "524129",
      "Chembedu B.O": "524129",
      "Chintapudi B.O": "524129",
      "Jeelapatur B.O": "524129",
      "Althurthi B.O": "524345",
      "Chittepalli B.O": "524345",
      "Narasapuram B.O": "524313",
      "Nidi Musali B.O": "524313",
      "Ramudupalem B.O": "524313",
      "Maneguntapadu B.O": "524366",
      "Mikkilimpeta B.O": "524366",
      "Ramannapalem B.O": "524366",
      "Ramapuram B.O": "524401",
      "Uchur B.O": "524121",
      "Edagali B.O": "524321",
      "Ananthamadugu B.O": "524407",
      "Marlapudi B.O": "524407",
      "Perumallapadu B.O": "524341",
      "Vemulachedu B.O": "524407",
      "Irakam B.O": "524401",
      "Kallur B.O": "524123",
      "Muttembaka B.O": "524415",
      "Guruvindapudi B.O": "524320",
      "Kanupuru B.O": "524320",
      "Chilakampadu B.O": "524132",
      "Petlur B.O": "524132",
      "Vallivedu B.O": "524132",
      "Tinnelapudi B.O": "524413",
      "Vunuguntapalem B.O": "524413",
      "Pathapadu B.O": "524309",
      "Surayapalem B.O": "524309",
      "Armenipadu B.O": "524402",
      "Chilamanchenu B.O": "524402",
      "Veerampalli B.O": "524405",
      "Venkannapalem B.O": "524002",
      "Bhyravaram B.O": "524421",
      "Graddagunta B.O": "524421",
      "Kotambedu B.O": "524421",
      "Perimidi B.O": "524421",
      "Beripeta B.O": "524126",
      "Chavali B.O": "524126",
      "Juvvalapalem B.O": "524126",
      "Kanururajupalem B.O": "524126",
      "Doruvulapalem B.O": "524323",
      "Gudluruvaripalem B.O": "524323",
      "Kanuparthi B.O": "524345",
      "Marupur B.O": "524345",
      "Mogallur B.O": "524345",
      "Navur B.O": "524345",
      "Toderu B.O": "524345",
      "Vavintaparthi B.O": "524345",
      "Cheropalli B.O": "524408",
      "Gilakapadu B.O": "524408",
      "Kandaleru Dam B.O": "524408",
      "Devarayapalli B.O": "524303",
      "Pathadevarayapalli B.O": "524303",
      "Vengampalli B.O": "524303",
      "Hasanapuram B.O": "524308",
      "Jangaladoruvu B.O": "524308",
      "Kolagatla B.O": "524308",
      "Vasili B.O": "524308",
      "Kodur B.O": "524002",
      "Kotha Kodur B.O": "524002",
      "Kothapalem B.O": "524413",
      "Navalakh Gardens B.O": "524002",
      "Nellimitta Kandriga B.O": "524002",
      "Utukur B.O": "524228",
      "Varini B.O": "524318",
      "Nelltur B.O": "524347",
      "Ananthapuram BO": "524347",
      "Peddapariya B.O": "524402",
      "Vojilirajupalem B.O": "524402",
      "Kogili B.O": "524127",
      "Matumadugu B.O": "524404",
      "Pigilam B.O": "524404",
      "Zangalapalli B.O": "524404",
      "Chejerla Kandriga B.O": "524341",
      "Chittalur B.O": "524341",
      "Kandali B.O": "524406",
      "Kommaneturu B.O": "524406",
      "Chintavaram B.O": "524412",
      "Tamminapatnam B.O": "524412",
      "Varagali B.O": "524412",
      "Palugodu B.O": "524134",
      "Velikallu B.O": "524134",
      "Bojjanapalli B.O": "524414",
      "Penubarthi B.O": "524346",
      "Alimili B.O": "524131",
      "Hastakaveri B.O": "524131",
      "Kundam B.O": "524131",
      "Kesavaram B.O": "524410",
      "Degapudi B.O": "524409",
      "Duggunta B.O": "524409",
      "Chintalatmakur B.O": "524343",
      "Kakivoya B.O": "524343",
      "Annagaripalem B.O": "524203",
      "Tallapalem": "524203",
      "Gowravaram B.O": "524302",
      "Brahmanakraka B.O": "524223",
      "Gattupalli B.O": "524223",
      "Thimmasamudram B.O": "524223",
      "Rajupalem B.O": "524126",
      "Veerannakollu B.O": "524224",
      "Nagasamudram B.O": "524224",
      "Musunur B.O": "524201",
      "Ganugapenta B.O": "524239",
      "Kommi B.O": "524239",
      "Madarabadara B.O": "524308",
      "Padamatikhambampadu B.O": "524302",
      "Somasila B.O": "524302",
      "Upplapadu B.O": "524302",
      "Mahalakshmipuram B.O": "524002",
      "Pedur B.O": "524311",
      "Thotapalli B.O": "524311",
      "Varakavipadu B.O": "524311",
      "Varigonda B.O": "524311",
      "Alaganipadu B.O": "524318",
      "Annareddypalem B.O": "524306",
      "Dampur B.O": "524318",
      "Naidupalem B.O": "524319",
      "Vatambedu B.O": "524121",
      "Velagalaponnur B.O": "524121",
      "Idimepalli B.O": "524321",
      "Valamedu B.O": "524415",
      "Chemudugunta B.O": "524320",
      "Chowtapalem B.O": "524320",
      "Dontali B.O": "524320",
      "Chintagunta B.O": "524132",
      "Lalapeta B.O": "524132",
      "Palemkota B.O": "524132",
      "Gudali B.O": "524413",
      "Mettu B.O": "524413",
      "Gollakandukur B.O": "524309",
      "Kandamur B.O": "524309",
      "Mamudur B.O": "524309",
      "Mohammadapuram B.O": "524309",
      "Vellanti B.O": "524309",
      "Gunupadu B.O": "524402",
      "Gurramkonda B.O": "524402",
      "Karaballavolu B.O": "524402",
      "Kurugonda B.O": "524402",
      "Aruru B.O": "524127",
      "Chillamur B.O": "524127",
      "Chittamur B.O": "524127",
      "Uppalamarthy B.O": "524127",
      "Athivaram B.O": "524421",
      "Muchalagunta B.O": "524126",
      "Pudur B.O": "524126",
      "Iskapalem B.O": "524323",
      "Tatipartipalem B.O": "524323",
      "Sirasanambedu B.O": "524129",
      "Amancherla B.O": "524345",
      "Ammavaripalem B.O": "524345",
      "Chatagotla B.O": "524345",
      "Venkatapuram B.O": "524345",
      "Nawabpeta B.O": "524408",
      "Kudithipalem B.O": "524313",
      "Somarajupalli B.O": "524313",
      "Yellayapalem B.O": "524366",
      "Amani Chiruvella B.O": "524303",
      "Chiramana B.O": "524308",
      "Korimerla B.O": "524308",
      "Srikolanu B.O": "524308",
      "Pathapalli B.O": "524302",
      "Allipuram B.O": "524002",
      "Narukuru B.O": "524002",
      "Potlapudi B.O": "524002",
      "Eduru B.O": "524311",
      "Mandapam B.O": "524311",
      "Parlapalli B.O": "524318",
      "Ramatheertham B.O": "524318",
      "Peyyalapalem B.O": "524319",
      "Josephpet B.O": "524321",
      "Pudiparthi B.O": "524321",
      "Chaganam B.O": "524407",
      "Chikavolu B.O": "524407",
      "Daggavolu B.O": "524407",
      "Gulimcherla B.O": "524407",
      "Jogipalli B.O": "524407",
      "Pokkandala B.O": "524407",
      "Pothegunta B.O": "524407",
      "Thoorpupundla B.O": "524407",
      "Karur B.O": "524401",
      "Balireddypalem B.O": "524415",
      "Palicherlapadu B.O": "524320",
      "Tikkavarapadu B.O": "524320",
      "Chillamanur B.O": "524132",
      "Chinnapareddypalli B.O": "524132",
      "Paravolu B.O": "524132",
      "Periavaram B.O": "524132",
      "Aravapalem B.O": "524127",
      "Mannarpolur(Urban Area) B.O": "524121",
      "Uggumudi B.O": "524121",
      "Anikepalli B.O": "524321",
      "Golagamudi B.O": "524321",
      "Lingasamudram B.O": "524134",
      "Palur B.O": "524407",
      "Kasipuram B.O": "524415",
      "Nellipudi B.O": "524415",
      "Kakutur B.O": "524320",
      "Kasumur B.O": "524320",
      "Althurupadu B.O": "524132",
      "Amuduru B.O": "524132",
      "Manulalpeta B.O": "524132",
      "Telugugangaproject B.O": "524132",
      "Yathalur B.O": "524132",
      "Vallipedu B.O": "524413",
      "Bathulapalli B.O": "524309",
      "Nedurupalli B.O": "524309",
      "Pelleru B.O": "524309",
      "Tatiparthi B.O": "524309",
      "Bhatlakanupur B.O": "524402",
      "Sagutur B.O": "524402",
      "Eswrawaka B.O": "524127",
      "Gottirprolu B.O": "524127",
      "Molakalapudi B.O": "524127",
      "Nadimpalli B.O": "524404",
      "Nidigallu B.O": "524404",
      "Chinnagopavaram B.O": "524341",
      "Kotitheertham B.O": "524341",
      "Vavileru B.O": "524341",
      "Momidi B.O": "524412",
      "Udathavaripalem B.O": "524412",
      "Yerur B.O": "524412",
      "Adurupalli B.O": "524342",
      "Velampalli B.O": "524134",
      "Vembuluru B.O": "524134",
      "Ramakur B.O": "524414",
      "Kamakur B.O": "524131",
      "Vendodu B.O": "524131",
      "Vedicherla B.O": "524131",
      "Ayyavaripalem B.O": "524310",
      "Chittedu B.O": "524410",
      "Devaravemuru B.O": "524409",
      "Griddalur B.O": "524409",
      "Chintalapalem B.O": "524343",
      "Chipinapi B.O": "524343",
      "Ammapalem B.O": "524404",
      "Balayapalli B.O": "524226",
      "Madapalli B.O": "524341",
      "Paderu B.O": "524341",
      "Thurpu Kambampadu B.O": "524341",
      "Vindur B.O": "524406",
      "Kollapanayunipalli B.O": "524342",
      "Kondagunta B.O": "524131",
      "P.R.Palem B.O": "524131",
      "Budanam B.O": "524410",
      "Kadagunta B.O": "524404",
      "Kayyur B.O": "524404",
      "Yachavaram B.O": "524404",
      "Ulavapalli B.O": "524341",
      "Nindali B.O": "524406",
      "Thippavarappadu B.O": "524406",
      "Nellatur B.O": "524406",
      "Ballavolu B.O": "524412",
      "Palicherlavaripalem B.O": "524412",
      "Tikkavaram B.O": "524312",
      "Tippaguntapalem B.O": "524412",
      "Chapalapalli B.O": "524134",
      "Madhavayapalem B.O": "524134",
      "Mopur B.O": "524134",
      "Gonupalli B.O": "524414",
      "Sydadupalli B.O": "524414",
      "Tegacherla B.O": "524414",
      "Thumaya B.O": "524414",
      "Yepur B.O": "524414",
      "Gottikadu B.O": "524131",
      "Kundakur B.O": "524131",
      "Mannur B.O": "524131",
      "Vajjavaripalem B.O": "524131",
      "Kandra B.O": "524131",
      "Vodur B.O": "524410",
      "Inukurthi B.O": "524409",
      "Mittatmakur B.O": "524409",
      "Talupur B.O": "524409",
      "Turimerla B.O": "524317",
      "Brahmanapalli B.O": "524230",
      "Rudrakota B.O": "524203",
      "Zakkepalligudur B.O": "524142",
      "Akkarajuvari Kandriga B.O": "524142",
      "Mondidinnepalem B.O": "524203",
      "Thummalapenta  B.O": "524203",
      "Lingamgunta B.O": "524302",
      "Chemadala B.O": "524142",
      "Patha Bitragunta B.O": "524142",
      "Alliguntapalem B.O": "524203",
      "Chennayapalem B.O": "524203",
      "Moddurupadu B.O": "524203",
      "Kovurpalli B.O": "524142",
      "Mungamuru B.O": "524142",
      "Nagulavaram B.O": "524142",
      "Nekunampeta B.O": "524239",
      "Saipeta B.O": "524239",
      "Ramavarapadu SC colony B.O": "524239",
      "Krishnapuram B.O": "524230",
      "Timmanaidupeta B.O": "524230",
      "Timmayapalem B.O": "524230",
      "Chinna Nagampalli B.O": "524310",
      "Maramreddipalli B.O": "524310",
      "Krakatur B.O": "524225",
      "Kummarakondur B.O": "524225",
      "Basinenipalli B.O": "524226",
      "Gaddamvaripalli B.O": "524226",
      "Kurrapalli B.O": "524226",
      "Chinna Kaniyampadu B.O": "524227",
      "Kakolluvaripalli B.O": "524227",
      "Thurupuchennampalli B.O": "524227",
      "Gottigundala B.O": "524228",
      "Nandigunta B.O": "524228",
      "Thoorpupalem B.O": "524239",
      "Chodavaram B.O": "524239",
      "Chabolu B.O": "524230",
      "Chinnamachanur B.O": "524230",
      "Gangulavaricheruvupalli B.O": "524230",
      "Narayanappapeta B.O": "524310",
      "Singareddipalli B.O": "524310",
      "Ananthapuram B.O": "524225",
      "Parikota B.O": "524225",
      "Peddakondur B.O": "524225",
      "Pullayapalli B.O": "524226",
      "Dakkanuru B.O": "524227",
      "Damncherla B.O": "524227",
      "Jaladevi B.O": "524227",
      "Vempadu B.O": "524227",
      "Katepalli B.O": "524228",
      "Nallagonda B.O": "524228",
      "Yepilagunta B.O": "524230",
      "Turupur B.O": "524225",
      "Masaipeta B.O": "524226",
      "Bhairavaram B.O": "524228",
      "Chandrapadia B.O": "524228",
      "Gangireddypalem B.O": "524228",
      "Yerikollu B.O": "524228",
      "Ramavarappadu B.O": "524239",
      "Bijjampalle B.O": "524230",
      "Kampasamudram B.O": "524230",
      "Venkatampeta B.O": "524230",
      "Bodasi Idayapalli B.O": "524310",
      "Jayapuram B.O": "524310",
      "Nemalladinna B.O": "524310",
      "Gudladona B.O": "524225",
      "Krishnampalli B.O": "524226",
      "Thimmareddypalli B.O": "524227",
      "Gundemadakala B.O": "524228",
      "Tellapadu B.O": "524304",
      "Chennarayunipalem B.O": "524315",
      "Indupur B.O": "524315",
      "Iskapalli B.O": "524315",
      "North Amaluru B.O": "524315",
      "North Mopur B.O": "524315",
      "Gudigunta B.O": "524302",
      "Pottepalem B.O": "524004",
      "South Mopur B.O": "524004",
      "Anumasamudram B.O": "524304",
      "Pandipadu B.O": "524304",
      "Pynapuram B.O": "524346",
      "Kanuparthipadu B.O": "524003",
      "Nellore Ceremic Factory B.O": "524003",
      "Marripadu B.O": "524306",
      "Padamatipalem B.O": "524306",
      "Panchedu B.O": "524306",
      "Vangallu B.O": "524306",
      "Elamanchipadu B.O": "524317",
      "Kothavangallu B.O": "524317",
      "Kavali Mustapuram B.O": "524234",
      "Kavali Yadavalli B.O": "524234",
      "Pathanapuram B.O": "524234",
      "Gudipallipadu B.O": "524314",
      "Jagdevipeta B.O": "524314",
      "Narayanareddypeta B.O": "524314",
      "Pallipadu B.O": "524314",
      "Aravedu B.O": "524307",
      "Botikerlapadu B.O": "524307",
      "Boyila chiruvella B.O": "524307",
      "Peda Kandla B.O": "524307",
      "Ramanaidupalli B.O": "524307",
      "Ramaswamypalli B.O": "524307",
      "Damaramadugu B.O": "524137",
      "Gangavaram B.O": "524137",
      "Pegallapadu B.O": "524312",
      "Vallur B.O": "524344",
      "Gangapatnam B.O": "524313",
      "Talamanchi B.O": "524315",
      "Chaparallapalli B.O": "524302",
      "Chilakalamarri B.O": "524302",
      "Chunchuluru B.O": "524302",
      "Padamatinaidupalli B.O": "524302",
      "Ponguru B.O": "524302",
      "Varikuntapadu B.O": "524302",
      "Buja Buja Nellore B.O": "524004",
      "Devarapalem B.O": "524004",
      "Kommarapudi B.O": "524004",
      "Battepadu B.O": "524322",
      "Cherloyadavalli B.O": "524322",
      "Rajavolu B.O": "524322",
      "Venkataraopalli B.O": "524322",
      "Kakupalli B.O": "524346",
      "Kalvelapalem B.O": "524346",
      "Madiraja Guduru B.O": "524346",
      "Koruturu B.O": "524313",
      "Kothapatnam B.O": "524411",
      "Molaganur B.O": "524411",
      "Pedavanjivaka B.O": "524411",
      "Siddavaram B.O": "524408",
      "Minamanamudi B.O": "524123",
      "Mizur B.O": "524123",
      "Mulapadava B.O": "524403",
      "Nidigurthi B.O": "524403",
      "Raviguntapalem B.O": "524403",
      "Thirumur B.O": "524403",
      "Yellore B.O": "524403",
      "Akkampeta B.O": "524121",
      "Baddevolu B.O": "524405",
      "Kalayakagollu B.O": "524305",
      "Minagallu B.O": "524305",
      "Penuballi B.O": "524305",
      "Vavveru B.O": "524305",
      "Kallurpalli B.O": "524003",
      "Punnur B.O": "524314",
      "Kothur Bit II B.O": "524314",
      "Gandlavedu B.O": "524307",
      "Damagunta B.O": "524316",
      "Gundlammapalem B.O": "524316",
      "Leguntapadu B.O": "524137",
      "Gummalladibba BO": "524137",
      "Allampadu B.O": "524312",
      "Kanupurpalli B.O": "524343",
      "Kullur B.O": "524343",
      "Nagulavellatur B.O": "524343",
      "Nookanapalli B.O": "524343",
      "Polireddipalem B.O": "524123",
      "Sreedhanamalli B.O": "524123",
      "Venumbaka B.O": "524123",
      "Kattuvapalli B.O": "524405",
      "Bandepalli B.O": "524405",
      "Cherlopalli B.O": "524405",
      "Kuricherlapadu B.O": "524405",
      "Batrakagallu B.O": "524315",
      "Gogulapalli B.O": "524315",
      "Purini B.O": "524315",
      "Velicherla B.O": "524315",
      "Bommavaram B.O": "524302",
      "Kamireddypadu B.O": "524302",
      "Mangupalli B.O": "524302",
      "Kottur B.O": "524004",
      "Chavatabheemavaram B.O": "524304",
      "Panugodu B.O": "524304",
      "Apparaopalem B.O": "524322",
      "Murugalla B.O": "524322",
      "Pottempadu B.O": "524346",
      "Isakapalem B.O": "524305",
      "Chintareddypalem B.O": "524003",
      "P.S.R Nagar B.O": "524003",
      "Siddipuram B.O": "524306",
      "Makthapuram B.O": "524306",
      "Peddaputtedu B.O": "524317",
      "Uppalapadu B.O": "524317",
      "Singapeta B.O": "524315",
      "Taticherlapalem B.O": "524315",
      "Bedusupalli B.O": "524302",
      "Kethugunta B.O": "524302",
      "Kondlapudi B.O": "524004",
      "Mulumudi B.O": "524004",
      "Peddabbipuram B.O": "524304",
      "Depur B.O": "524322",
      "Nagulapadu B.O": "524322",
      "Nuvvurupadu B.O": "524322",
      "Mamidipudi B.O": "524346",
      "Pidathapoluru B.O": "524346",
      "Chellayapalem B.O": "524305",
      "Jonnavada B.O": "524305",
      "Rebala B.O": "524305",
      "Reddypalem B.O": "524305",
      "Kattubadipalem B.O": "524305",
      "Bhaktavatsalanagar B.O": "524003",
      "Gundlapalem B.O": "524003",
      "Gudipadu B.O": "524234",
      "Zammavaram B.O": "524234",
      "Lebur B.O": "524314",
      "Dharmarao Cheruvupalli B.O": "524307",
      "Kona Samudram B.O": "524307",
      "Narampeta B.O": "524307",
      "Inamadugu B.O": "524137",
      "Mudivarthi B.O": "524137",
      "Pothireddypalem B.O": "524137",
      "Irlapadu B.O": "524312",
      "Gopalapuram B.O": "524344",
      "Narikellapalli B.O": "524344",
      "Kakarlapadu B.O": "524234",
      "Velpulagunta B.O": "524234",
      "Kodurupadu B.O": "524314",
      "Komarika B.O": "524314",
      "Basavarajupalem B.O": "524307",
      "Mahimalur B.O": "524307",
      "Nandavaram B.O": "524307",
      "Vennavada B.O": "524307",
      "Venkanapuram B.O": "524316",
      "Chowkacherla B.O": "524316",
      "Padmanabhasatram B.O": "524316",
      "Cherlopalem B.O": "524137",
      "Padugupadu B.O": "524137",
      "Patur B.O": "524137",
      "Vegur B.O": "524137",
      "Chilakapadu B.O": "524312",
      "Khaderpur B.O": "524312",
      "Damayapalem B.O": "524344",
      "Krishnapatnam B.O": "524344",
      "Telugurayapuram B.O": "524343",
      "Topugunta B.O": "524343",
      "Anepudi B.O": "524123",
      "Doravarisatram B.O": "524123",
      "Togaramudi B.O": "524123",
      "Buradagalikothapalem B.O": "524403",
      "Dugarajapatnam B.O": "524403",
      "Cherukumudi B.O": "524405",
      "Kommalapudi B.O": "524405",
      "Pidur B.O": "524405",
      "Kadalur B.O": "524121",
      "Karijatha B.O": "524121",
      "Mambathi B.O": "524121",
      "Manganellore B.O": "524121",
      "Tanamcherla B.O": "524408",
      "Vepinapi B.O": "524408",
      "Phase II B.O": "524124",
      "Damanellore B.O": "524121",
      "Tirumalapadu B.O": "524343",
      "Virubhotlapalli B.O": "524343",
      "Kokkupadu B.O": "524411",
      "Zarugumalli B.O": "524411",
      "Chinnathota B.O": "524403",
      "Karikadu B.O": "524403",
      "Vallamedu B.O": "524403",
      "Kolanukuduru B.O": "524405",
      "Madamanur B.O": "524405",
      "Sanayapalem B.O": "524408",
      "Pernadu B.O": "524124",
      "Venadu B.O": "524124",
      "Gudur H.O": "524101",
      "Anemadugu S.O": "524203",
      "Damavaram S.O": "524152",
      "Duthalur S.O": "524222",
      "Seetaramapuram S.O": "524310",
      "Andhrakesari Nagar S.O": "524004",
      "Atmakur (NL) S.O": "524322",
      "Balajinagar S.O": "524002",
      "Gumparlapadu S.O": "524234",
      "Kavali H.O": "524201",
      "Nellore H.O": "524001",
      "Virur S.O": "524309",
      "Venkatagiri Bazar S.O": "524132",
      "Venkatagiri Town S.O": "524132",
      "Chakalakonda S.O": "524221",
      "Dagadarthi S.O": "524240",
      "Gandipalem S.O": "524236",
      "Kaligiri S.O": "524224",
      "Kondapuram S.O (Nellore)": "524239",
      "Nandipadu S.O": "524230",
      "Udayagiri S.O (Nellore)": "524226",
      "Varikuntapadu S.O": "524227",
      "Vinjamur S.O": "524228",
      "Allur S.O": "524315",
      "Anantasagaram S.O": "524302",
      "Buchireddypalem S.O": "524305",
      "Duvvur S.O (Nellore)": "524306",
      "Gandavaram S.O": "524317",
      "Kodavaluru S.O": "524316",
      "Kovur S.O": "524137",
      "Vakadu S.O": "524415",
      "Venkatachalasatram S.O": "524320",
      "Yellasiri S.O": "524127",
      "Janathapeta S.O": "524201",
      "Jayampu S.O": "524131",
      "Nayudupeta S.O": "524126",
      "Rapur S.O": "524408",
      "Kavali Co op Colony S.O": "524201",
      "Brahmadevam S.O": "524346",
      "Dargamitta S.O": "524003",
      "Dcbc S.O": "524003",
      "Fathekhanpeta S.O": "524003",
      "Indukurpeta S.O": "524314",
      "Kovur Cutchery S.O": "524137",
      "Bitragunta S.O": "524142",
      "Jaladanki S.O": "524223",
      "Kavali Bazar S.O": "524201",
      "Siddanakonduru S.O": "524225",
      "A.C.Nagar S.O": "524002",
      "Anumasamudrampeta S.O": "524304",
      "Karatampadu S.O": "524307",
      "Lakshmipuram S.O": "524002",
      "Kaluvoya S.O": "524343",
      "Kota(NL) S.O": "524411",
      "Malavyanagar S.O": "524101",
      "Mallam S.O (Nellore)": "524403",
      "Manubolu S.O": "524405",
      "Nidiguntapalem S.O": "524323",
      "Vidyanagar S.O (Nellore)": "524413",
      "Vojili S.O": "524402",
      "Gudur East S.O": "524101",
      "Gundavolu S.O": "524414",
      "Kotapolur S.O": "524123",
      "Menakur S.O": "524421",
      "Podalakur S.O": "524345",
      "Sydapuram S.O": "524407",
      "Kadivedu S.O": "524410",
      "Kalichedu S.O": "524409",
      "Pellakur S.O": "524129",
      "Pulicotnagar S.O": "524121",
      "Sriharikota Range S.O": "524124",
      "Sullurpeta S.O": "524121",
      "Survepalli S.O": "524321",
      "Tada S.O": "524401",
      "Mulapeta S.O": "524003",
      "Nellore Bazar S.O": "524001",
      "Pogathota S.O": "524001",
      "Sangam S.O": "524308",
      "Thotapalliguduru S.O": "524311",
      "Kammapalem S.O": "524319",
      "Northrajupalem S.O": "524366",
      "Polytechnic S.O (Nellore)": "524005",
      "Revur S.O": "524303",
      "Vedayapalem S.O": "524004",
      "Marripadu S.O": "524312",
      "Muthukur S.O": "524344",
      "Ramalingapuram S.O": "524003",
      "Ranganayakulapeta S.O": "524001",
      "Stonehousepet S.O": "524002",
      "AP Genco Nelatur SO": "524347",
      "Mypadu S.O": "524313",
      "Trunk Road S.O (Nellore)": "524001",
      "Vidavalur S.O": "524318",
      "Chennur S.O (Nellore)": "524406",
      "Dakkili S.O": "524134",
      "Gudur Bazar S.O": "524101",
      "Chejerla S.O": "524341",
      "Chillakur S.O": "524412",
      "Dachur S.O": "524342",
      "Bangarupeta S.O": "524404"
    },
    "GUNTUR": {
      "Chittapuram B.O": "522658",
      "Udjerla B.O": "522658",
      "Mellavagu B.O": "522614",
      "Petasannegandla B.O": "522614",
      "Voppicherla B.O": "522614",
      "Ayyannapalem B.O": "522614",
      "Gadevaripalle B.O": "522614",
      "Garikapadu B.O": "522018",
      "Marripalem B.O": "522614",
      "Pedakodamagundla B.O": "522614",
      "Gundepalle B.O": "522658",
      "Kondayapalem B.O": "522658",
      "Chinakodamagundla B.O": "522614",
      "Chintapalle B.O": "522409",
      "Jayanthi Ramapuram B.O": "522614",
      "IRLAPADU B.O": "522646",
      "GARNEPUDI B.O": "522401",
      "NEELESWARAPALEM B.O": "522409",
      "Kopparru B.O": "522015",
      "Vangipuram B.O": "522015",
      "Garapadu B.O": "522402",
      "Kornepadu B.O": "522017",
      "Vinjanampadu B.O": "522017",
      "Vengalayapalem B.O": "522005",
      "Obulanaidupalem B.O": "522005",
      "Varagani B.O": "522401",
      "Enamadala B.O": "522019",
      "Nimmagaddavaripalem B.O": "522019",
      "Harischandrapuram B.O": "522020",
      "Muthayapalem B.O": "522102",
      "Kuragallu B.O": "522502",
      "Endroy B.O": "522016",
      "Karlapudi B.O": "522016",
      "Mothadaka B.O": "522016",
      "Chinakakani B.O": "522508",
      "Chirravuru B.O": "522303",
      "Uppalapadu B.O": "522615",
      "Pedakonduru B.O": "522305",
      "SRM University S.O": "522240",
      "Vanikunta B.O": "522658",
      "Nagireddipalle B.O": "522659",
      "Domalagundam B.O": "522663",
      "Gandiganumala B.O": "522663",
      "Manukondavaripalem B.O": "522616",
      "Pasumarru B.O": "522616",
      "Dharmavaram B.O": "522612",
      "Kakirala B.O": "522612",
      "Patlaveedu B.O": "522612",
      "Jaggapuram B.O": "522233",
      "Jaladi B.O": "522233",
      "Gummanampadu B.O": "522614",
      "Narasimhapuri B.O": "522614",
      "Sankarapuram B.O": "522614",
      "PEDDAVARAM B.O": "522659",
      "Srungarapuram B.O": "522305",
      "Atmakuru B.O": "522612",
      "Vaddeswaram B.O": "522302",
      "Bandarupalle B.O": "522018",
      "Damarapalle B.O": "522018",
      "Vutukuru B.O": "522410",
      "Velampalle B.O": "522435",
      "Koppunuru B.O": "522426",
      "Kotturu B.O": "522426",
      "Turakapalem B.O": "522438",
      "Visadala B.O": "522438",
      "Paludevarlapadu B.O": "522408",
      "Madala B.O": "522408",
      "Attaluru B.O": "522436",
      "Jalalapuram B.O": "522436",
      "ABBARAJUPALEM BO": "522436",
      "Kattamuru B.O": "522402",
      "Lingamguntla B.O": "522402",
      "Abburu B.O": "522402",
      "Panidem B.O": "522402",
      "Guttikonda B.O": "522413",
      "Pillutla B.O": "522413",
      "GOVINDAPURAM BO": "522413",
      "Ganapavaram B.O": "522111",
      "Nagavaram B.O": "522412",
      "Goli B.O": "522421",
      "Tummercode B.O": "522421",
      "Gottipalla B.O": "522613",
      "Kandlagunta B.O": "522603",
      "VAJRALAPADU BO": "522613",
      "Katrapadu B.O": "522235",
      "Pallapadu B.O": "522017",
      "Ankireddypalem B.O": "522005",
      "Gottipadu B.O": "522616",
      "Kondepadu B.O": "522019",
      "Koyavaripalem B.O": "522019",
      "Mallayapalem B.O": "522019",
      "Tikkireddyvaripalem B.O": "522019",
      "Dharanikota B.O": "522020",
      "Yerrabalem B.O": "522502",
      "Bethapudi B.O": "522549",
      "Nidamarru B.O": "522502",
      "Kaza B.O": "522016",
      "Gundimeda B.O": "522303",
      "Venkatakrishnapuram B.O": "522509",
      "Chinapalem B.O": "522305",
      "Lingamukkapalle B.O": "522659",
      "Murthuzapuram B.O": "522659",
      "PATHAZADDAVARIPALEM BO": "522659",
      "Remidicherla B.O": "522663",
      "Annavaram B.O": "522603",
      "Pothavaram B.O": "522616",
      "Mutukuru B.O": "522612",
      "Narmalapadu B.O": "522612",
      "TERALA BO": "522612",
      "RAJANAGAR BO": "522612",
      "Thimmapuram B.O": "522233",
      "Vankayalapadu B.O": "522233",
      "Gogulamudi B.O": "522015",
      "Ravipadu B.O": "522015",
      "Budampadu B.O": "522017",
      "Kurnuthala B.O": "522017",
      "Lalpuram B.O": "522017",
      "Lam B.O": "522034",
      "Kondapaturu B.O": "522112",
      "Chintalacheruvu B.O": "522659",
      "Mukkellapadu B.O": "522659",
      "Edavalli B.O": "522616",
      "Purushothapatnam B.O": "522616",
      "Kolagutla B.O": "522612",
      "Obulesunipalle B.O": "522612",
      "Syamarajapuram B.O": "522612",
      "JANGAMAHESWARAPADU BO": "522612",
      "Karuchola B.O": "522233",
      "Unnava B.O": "522233",
      "Turlapadu B.O": "522619",
      "Angaluru B.O": "522658",
      "Ananthavarappadu B.O": "522017",
      "Chamallamudi B.O": "522017",
      "Chintapallipadu B.O": "522017",
      "Yamarru B.O": "522017",
      "Gorantla B.O": "522034",
      "Jonnalagadda B.O": "522549",
      "Lam Ars B.O": "522034",
      "Appapuram B.O": "522611",
      "Ballukanudivari Palem B.O": "522112",
      "Garlapadu B.O": "522235",
      "Kommuru B.O": "522235",
      "Nagualapadu B.O": "522235",
      "Pusuluru B.O": "522235",
      "Chowdavaram B.O": "522019",
      "Perecherla B.O": "522009",
      "Pedamadduru B.O": "522020",
      "Vykuntapuram B.O": "522020",
      "Krishnayapalem B.O": "522502",
      "Neerukonda B.O": "522502",
      "Narukullapadu B.O": "522016",
      "Nevalikallu B.O": "522016",
      "Nidumukkala B.O": "522016",
      "Vunguturu B.O": "522016",
      "Gollamudi B.O": "522509",
      "Reddypalem B.O": "522614",
      "Revendrapadu B.O": "522302",
      "Pedapalem B.O": "522410",
      "Pothuru B.O": "522005",
      "Anaparru B.O": "522235",
      "Palaparru B.O": "522235",
      "Rajupalem B.O": "522235",
      "Ganikapudi B.O": "522019",
      "Nadimpalem B.O": "522019",
      "Pedapalakaluru B.O": "522009",
      "Didugu B.O": "522020",
      "Malladi B.O": "522020",
      "Navuluru B.O": "522502",
      "Latchannagudipudi B.O": "522016",
      "Mukkamala B.O": "522016",
      "Kanteru B.O": "522508",
      "Koppuravuru B.O": "522508",
      "Mellempudi B.O": "522303",
      "Takkellapadu B.O": "522438",
      "Venigandla B.O": "522509",
      "Perikalapudi B.O": "522305",
      "Veerlapalem B.O": "522305",
      "Ippatam B.O": "522302",
      "Kolanukonda B.O": "522302",
      "K.L.University B.O": "522302",
      "Bejathpuram B.O": "522018",
      "Godavarru Agraharam B.O": "522305",
      "GANDLURU BO": "522410",
      "GORANTLA BO": "522410",
      "Kothapalem B.O": "522435",
      "Pinnelli B.O": "522435",
      "Gannavaram B.O": "522426",
      "Kambhampadu B.O": "522660",
      "ECONAMPET BO": "522426",
      "Gundlapalem B.O": "522438",
      "Dammalapadu B.O": "522408",
      "Kunduruvaripalem B.O": "522408",
      "Lankalakurapadu B.O": "522408",
      "Lingapuram B.O": "522436",
      "Tammavaram B.O": "522436",
      "Bayyavaram B.O": "522402",
      "Bhatluru B.O": "522402",
      "Bhimavaram B.O": "522402",
      "Nandigama B.O": "522402",
      "Pakalapadu B.O": "522410",
      "GOGULAPADU BO": "522410",
      "Vemavaram B.O": "522529",
      "Chennayapalem B.O": "522435",
      "Kothapalle B.O": "522409",
      "Mandadi B.O": "522426",
      "Tallapalle B.O": "522426",
      "Velavarthipadu B.O": "522438",
      "Narnepadu B.O": "522408",
      "Turkapalem B.O": "522408",
      "Rudravaram B.O": "522408",
      "Jupudi B.O": "522212",
      "Kasipadu B.O": "522436",
      "RAMAPURAM BO": "522436",
      "Hussainnagaram B.O": "522402",
      "Lagadapadu B.O": "522402",
      "Munugodu B.O": "522402",
      "Janapadu B.O": "522413",
      "Konanki B.O": "522413",
      "BEERAVALLIPAYA BO": "522413",
      "SRI RUKMINIPURAM BO": "522413",
      "Dhulipalla B.O": "522412",
      "Mokkapadu B.O": "522412",
      "BRAHMANAPALLE BO": "522412",
      "Jettipalem B.O": "522421",
      "Rentala B.O": "522421",
      "MALLAVARAM BO": "522421",
      "PODAPADU BO": "522401",
      "Bodilaveedu B.O": "522613",
      "Gundalapadu B.O": "522549",
      "Rentapalla B.O": "522410",
      "Nagulavaram B.O": "522649",
      "Pasivemula B.O": "522426",
      "Rayavaram B.O": "522426",
      "Zammalamadaka B.O": "522426",
      "RACHAMALLAPADU BO": "522426",
      "Kattavaripalem B.O": "522438",
      "Komerapudi B.O": "522438",
      "Korrapadu B.O": "522438",
      "Bollavaram B.O": "522408",
      "Balusupadu B.O": "522436",
      "Patibandla B.O": "522402",
      "Pedamakkena B.O": "522402",
      "Gudipudi B.O": "522402",
      "Morjampadu B.O": "522413",
      "Nemalipuri B.O": "522413",
      "Panditivaripalem B.O": "522413",
      "Sitarampuram Mines B.O": "522413",
      "Zulakallu B.O": "522413",
      "Reddigudem B.O": "522412",
      "Tondapi B.O": "522412",
      "Bhrugubanda B.O": "522412",
      "Kandulavaripalem B.O": "522412",
      "Kothapullareddipuram B.O": "522613",
      "Sirigiripadu B.O": "522613",
      "Latchambhavi B.O": "522613",
      "Thimmareddipuram B.O": "522439",
      "Kotanemalipuri B.O": "522413",
      "Kothaganesunipadu B.O": "522413",
      "Kubadpuram B.O": "522413",
      "DEVARAMPADU BO": "522413",
      "Balijepalle B.O": "522412",
      "Kankanalapalle B.O": "522412",
      "Manchikallu B.O": "522421",
      "Mittagudipadu B.O": "522421",
      "Paluvai B.O": "522421",
      "Pasarlapadu B.O": "522421",
      "PALUVAI GATE BO": "522421",
      "Mandapadu B.O": "522401",
      "Paladugu B.O": "522401",
      "LOYAPALLI BO": "522613",
      "Cheruvukommupalem B.O": "522659",
      "Mugachintalapalem B.O": "522663",
      "Ravulapuram B.O": "522663",
      "Maddirala B.O": "522616",
      "Adigoppula B.O": "522612",
      "Polepalle B.O": "522612",
      "Sandepudi B.O": "522619",
      "Veluru B.O": "522619",
      "Bommarajupalle B.O": "522658",
      "Gorlavaripalem B.O": "522018",
      "Mandepudi B.O": "522018",
      "Ravela B.O": "522018",
      "Abbarajupalem B.O": "522237",
      "Borupalem B.O": "522237",
      "Dondapadu B.O": "522549",
      "Pamulapadu B.O": "522018",
      "Penumaka B.O": "522501",
      "Vaddamanu B.O": "522236",
      "Ainavolu B.O": "522237",
      "Mandadam B.O": "522237",
      "Prathuru B.O": "522501",
      "Rain Tree Park B.O": "522508",
      "Undavalli B.O": "522501",
      "Anantavaram B.O": "522236",
      "Nekkallu B.O": "522236",
      "Rayapudi B.O": "522237",
      "Velagapudi B.O": "522237",
      "Kunchanapalle B.O": "522501",
      "Pedaparimi B.O": "522236",
      "Nelapadu B.O": "522202",
      "Sakhamuru B.O": "522237",
      "Venkatapalem B.O": "522237",
      "Donepudi B.O": "522324",
      "Manduru B.O": "522313",
      "Mulpuru B.O": "522313",
      "Katevaram B.O": "522202",
      "Pathareddypalem B.O": "522212",
      "Vellaluru B.O": "522212",
      "Brahmanakoduru B.O": "522212",
      "Lemellepadu B.O": "522212",
      "Kavuru B.O": "522309",
      "Gullapalli B.O": "522309",
      "Jillellamudi B.O": "522113",
      "Kolaganivaripalem B.O": "522258",
      "Venigallavaripalem B.O": "522258",
      "Pamidimarru B.O": "522549",
      "Elavarru B.O": "522341",
      "Davuluru B.O": "522304",
      "Gudibandivaripalem B.O": "522304",
      "Chintallanka B.O": "522324",
      "Gajullanka B.O": "522324",
      "Krapa B.O": "522324",
      "Ravikampadu B.O": "522324",
      "Chinagadelavarru B.O": "522313",
      "Pedaravuru B.O": "522202",
      "Kunchavaram B.O": "522306",
      "Kothapalli narikellapalli B.O": "522212",
      "Kothareddypalem B.O": "522212",
      "Vatticheruku B.O": "522212",
      "Vinayasramam B.O": "522309",
      "Tumuluru B.O": "522304",
      "Potharlanka B.O": "522324",
      "Chinaparimi B.O": "522313",
      "Kancherlapalem B.O": "522202",
      "Athota B.O": "522306",
      "Ananthavaram B.O": "522410",
      "Pallegunta B.O": "522415",
      "Gudipadu B.O": "522410",
      "Kastala B.O": "522410",
      "Konduru B.O": "522410",
      "Konuru B.O": "522410",
      "Peesapadu B.O": "522410",
      "Velpuru B.O": "522646",
      "Vipparla B.O": "522615",
      "Balemarru B.O": "522410",
      "Grandhasiri B.O": "522410",
      "Talluru B.O": "522529",
      "Voravakallu B.O": "522410",
      "Yerukalapudi B.O": "522306",
      "Chatragadda B.O": "522265",
      "Godavarru B.O": "522212",
      "Lingamguntlapalem B.O": "522212",
      "Mutluru B.O": "522212",
      "Vetapalem B.O": "522212",
      "Ramabhotlapalem B.O": "522309",
      "Arumbaka B.O": "522309",
      "Balusulapalem B.O": "522309",
      "Narasayapalem B.O": "522113",
      "Reteru B.O": "522113",
      "Boddulurupadu B.O": "522324",
      "Yadavuru B.O": "522313",
      "Dantaluru B.O": "522306",
      "Gollamudipadu B.O": "522212",
      "Gundavaram B.O": "522212",
      "Manchala B.O": "522212",
      "Srirangapuram B.O": "522212",
      "Arepalle Agraharam B.O": "522309",
      "Mulapalem B.O": "522113",
      "A F Station B.O": "522102",
      "Bhavanamvaripalem B.O": "522311",
      "Poondla B.O": "522310",
      "Gopapuram B.O": "522310",
      "Gudipudiagraharam B.O": "522310",
      "Iteru B.O": "522310",
      "Sangupalem B.O": "522311",
      "Koduru komali B.O": "522311",
      "Selapadu B.O": "522213",
      "Suddapalli B.O": "522213",
      "Pedapulivarru B.O": "522257",
      "Pesarlanka B.O": "522257",
      "Champadu B.O": "522261",
      "Jampani B.O": "522261",
      "Pyaparru B.O": "522341",
      "Ilavaram B.O": "522259",
      "Ponnapalli Agraharam B.O": "522259",
      "Pedapuluguvaripalem B.O": "522111",
      "Perali B.O": "522111",
      "Pedagollapalem B.O": "522111",
      "Adavuladivi B.O": "522262",
      "Allaparru B.O": "522262",
      "Dindi B.O": "522262",
      "Mulukuduru B.O": "522315",
      "Karankivaripalem B.O": "522268",
      "Pushadapuvaripalem B.O": "522268",
      "Bavajipalem B.O": "522314",
      "Aremanda B.O": "522316",
      "Siripudi B.O": "522329",
      "Khajipalem B.O": "522329",
      "Peddapalle B.O": "522329",
      "Aluru B.O": "522124",
      "Chinalingayapalem B.O": "522124",
      "Vupparapalem B.O": "522647",
      "Kankatapalem B.O": "522317",
      "Murukondapadu B.O": "522317",
      "Stuvartpuram Colony B.O": "522317",
      "Mamillapalli B.O": "522318",
      "Edlapalli B.O": "522211",
      "Penugudurupadu B.O": "522211",
      "Konetipuram B.O": "522256",
      "Pallekona B.O": "522256",
      "Penumarru B.O": "522256",
      "Kantamrajukonduru B.O": "522330",
      "Manchikalapudi B.O": "522330",
      "Penumuli B.O": "522330",
      "Tummapudi B.O": "522330",
      "Marripudi B.O": "522310",
      "Nandirajuthota B.O": "522102",
      "Narakoduru B.O": "522212",
      "Voleru B.O": "522265",
      "Nallurupalem B.O": "522265",
      "Penumudi B.O": "522265",
      "Sajjavaripalem B.O": "522265",
      "Vuppudi B.O": "522265",
      "Amudarlanka B.O": "522257",
      "Chinapulivarru B.O": "522257",
      "Butumalli B.O": "522261",
      "Peravalipalem B.O": "522261",
      "Peddavaram B.O": "522259",
      "Nalamothuvaripalem B.O": "522111",
      "Doppalapudi B.O": "522316",
      "Bodapadu B.O": "522341",
      "Kondamudi B.O": "522341",
      "Gudavalli B.O": "522259",
      "Nadimpalli B.O": "522259",
      "Rajavole B.O": "522259",
      "Yazali B.O": "522111",
      "Kallipalem B.O": "522262",
      "Gurunadhanagar B.O": "522262",
      "Mantripalem B.O": "522262",
      "Pragnam B.O": "522262",
      "Bodipalem B.O": "522315",
      "Itikampadu B.O": "522315",
      "Pudivada B.O": "522268",
      "Amudalapalli B.O": "522314",
      "Pedamatlapudi B.O": "522314",
      "Dandamudi B.O": "522316",
      "Munipalli B.O": "522316",
      "Chintalapudi B.O": "522124",
      "Kondabalavaripalem B.O": "522124",
      "Govada B.O": "522325",
      "Pedapudi B.O": "522325",
      "Chilumuru B.O": "522301",
      "Singupalem B.O": "522264",
      "Gangadipalem B.O": "522264",
      "Tummala B.O": "522264",
      "Chiluvuru B.O": "522330",
      "Munnangi B.O": "522304",
      "Mannava B.O": "522316",
      "Vallabharaopalem B.O": "522124",
      "Valluru B.O": "522124",
      "Vaddemukkala B.O": "522124",
      "Nadigaddapalem B.O": "522318",
      "Pedagadelavarru B.O": "522318",
      "Korutadiparru B.O": "522312",
      "Moparru B.O": "522312",
      "Annavarapulanka B.O": "522301",
      "Burripalem B.O": "522301",
      "Hanumanpalem B.O": "522301",
      "Surepalli B.O": "522256",
      "Allamudi B.O": "522256",
      "Kaithepalle B.O": "522264",
      "Mrutyumjayapalem B.O": "522264",
      "Piratlanka B.O": "522264",
      "Vaddevaripalem B.O": "522264",
      "Vallabhapuram B.O": "522308",
      "Kazipeta B.O": "522307",
      "Gudivada B.O": "522307",
      "Karumuru B.O": "522265",
      "Nalluru B.O": "522265",
      "Peteru B.O": "522265",
      "Anamarlapudi B.O": "522213",
      "Kiskindapalem B.O": "505325",
      "Peravali B.O": "522261",
      "Varahapuram Agraharam B.O": "522261",
      "Allavaripalem B.O": "522259",
      "Thotapalli B.O": "522259",
      "Buddam B.O": "522111",
      "Chintayapalem B.O": "522111",
      "Chinkapalem B.O": "522262",
      "Pallapatla B.O": "522262",
      "Komali B.O": "522315",
      "Nanduru B.O": "522315",
      "Bellamvaripalem B.O": "522268",
      "Pulipadu B.O": "522415",
      "Andukuru B.O": "522410",
      "Dodleru B.O": "522410",
      "Govindapuram B.O": "522611",
      "Chirumamilla B.O": "522234",
      "Lingaraopalem B.O": "522234",
      "Karlakunta B.O": "522615",
      "Machavaram B.O": "522615",
      "EDWARDPET BO": "522615",
      "Ramudipalem B.O": "522660",
      "Ravvavaram B.O": "522660",
      "Reddipalem B.O": "522603",
      "Chinakancherla B.O": "522649",
      "Enugupalem B.O": "522649",
      "Gokanakonda B.O": "522649",
      "Hassannayunipalem B.O": "522649",
      "Kondaveedu B.O": "522529",
      "Singhiskhanpet B.O": "522529",
      "Arvapalli B.O": "522603",
      "Tungapadu B.O": "522603",
      "Annavarappadu B.O": "522617",
      "Gogulapadu B.O": "522414",
      "Merikapudi B.O": "522549",
      "Munagapadu B.O": "522549",
      "Guntupalem B.O": "522646",
      "Kondramutla B.O": "522647",
      "Koppukonda B.O": "522647",
      "Kotcherla B.O": "522647",
      "Challagariga B.O": "522409",
      "Chamarru B.O": "522409",
      "Bodanam B.O": "522411",
      "Chandrajupalem B.O": "522411",
      "Chityala B.O": "522411",
      "Chityala Thanda B.O": "522411",
      "Papayapalem B.O": "522411",
      "Vannayapalem B.O": "522411",
      "Kesanapalle B.O": "522549",
      "Madinapadu B.O": "522414",
      "Nadikudi B.O": "522414",
      "Gonepudi B.O": "522611",
      "Irlapadu B.O": "522611",
      "Jangalapalle B.O": "522647",
      "Inumetla B.O": "522615",
      "Narasingapadu B.O": "522615",
      "KOTHAPALEM BO": "522615",
      "Pathakothapalem B.O": "522660",
      "Vetrayuni Appapuram B.O": "522660",
      "Pitchikalapalem B.O": "522649",
      "Ameenabad B.O": "522529",
      "Nudurupadu B.O": "522529",
      "Palapadu B.O": "522603",
      "Dechavaram B.O": "522603",
      "TURAKAPALEM BO": "522603",
      "Alavala B.O": "522617",
      "Vadlamudivaripalem B.O": "522617",
      "ATCHAIAHPALEM BO": "522617",
      "Gorizavole B.O": "522549",
      "Kanaparru B.O": "522549",
      "Sankurathripadu B.O": "522549",
      "Bukkapuram B.O": "522549",
      "Mathukumalli B.O": "522646",
      "Sanampudi B.O": "522646",
      "Perurupadu B.O": "522657",
      "Nadigadda B.O": "522647",
      "Sivapuram B.O": "522647",
      "Neelagangavaram B.O": "522647",
      "Emmajigudem B.O": "522411",
      "Perikapadu Thanda B.O": "522411",
      "Venkatayapalem B.O": "522411",
      "Veerapuram B.O": "522437",
      "Mutyalampadu B.O": "522414",
      "Ramapuram B.O": "522414",
      "Srinagar B.O": "522414",
      "BATRUPALEM BO": "522414",
      "Ambapuram B.O": "522415",
      "Jangamaheswarapuram B.O": "522415",
      "Miriyala B.O": "522415",
      "KACHAVARAM BO": "522614",
      "Kammavaripalem B.O": "522611",
      "Kattubadivaripalem B.O": "522611",
      "Butchipapannapalem B.O": "522661",
      "Boppudi B.O": "522626",
      "Gopalamvaripalem B.O": "522626",
      "Rajapeta B.O": "522626",
      "Tatapudi B.O": "522626",
      "Solasa B.O": "522234",
      "Tubadu B.O": "522234",
      "Chejerla B.O": "522615",
      "Gundlapalle B.O": "522615",
      "Santhagudipadu B.O": "522615",
      "Tsallagundla B.O": "522615",
      "Mulakaluru B.O": "522603",
      "Mupparajuvaripalem B.O": "522660",
      "Perumallapalli B.O": "522649",
      "Lakkarajugarlapadu B.O": "522529",
      "Chagallu B.O": "522603",
      "Ikkurru B.O": "522603",
      "Kakani B.O": "522603",
      "Lingamguntla  Agraharam B.O": "522603",
      "Petlurivaripalem B.O": "522603",
      "Konakanchivaripalem B.O": "522617",
      "Ramireddipalem B.O": "522617",
      "Chandavaram B.O": "522549",
      "Guravayapalem B.O": "522549",
      "Ellamanda B.O": "522549",
      "Kanumarlapudi B.O": "522646",
      "Karumanchi B.O": "522646",
      "Kothaluru B.O": "522646",
      "Gutlapalle B.O": "522657",
      "Kandrika B.O": "522529",
      "Kanumalacheruvu B.O": "522657",
      "Agnigundala B.O": "522647",
      "Andugula Kothapalem B.O": "522647",
      "Brahmanapalle B.O": "522647",
      "Chatragaddapadu B.O": "522647",
      "Vittamrajupalle B.O": "522647",
      "Taduvai B.O": "522409",
      "Tallacheruvu B.O": "522409",
      "CHERUKUMPALEM BO": "522409",
      "Machayapalem B.O": "522411",
      "China Garlapadu B.O": "522437",
      "Chinaagraharam B.O": "522437",
      "Karalapadu B.O": "522437",
      "Pedagarlapadu B.O": "522437",
      "Gamalapadu B.O": "522414",
      "Sarangapalle B.O": "522414",
      "KATRAPADU BO": "522414",
      "Daida B.O": "522415",
      "PAMIDIPADU BO": "522614",
      "Gangannapalem B.O": "522611",
      "Inumella B.O": "522661",
      "Cheemalamarri B.O": "522615",
      "Kunkalagunta B.O": "522615",
      "Tripurapuram B.O": "522615",
      "Pamidipadu B.O": "522660",
      "Puvvada B.O": "522660",
      "Talarlapalle B.O": "522660",
      "Pittambanda B.O": "522649",
      "Yerraguntlapadu B.O": "522529",
      "Rupenagunta B.O": "522603",
      "Vipparlapalle B.O": "522603",
      "Pamidipadu Agraharam B.O": "522603",
      "Turumella B.O": "522617",
      "Endugumpalem B.O": "522549",
      "Ponugupadu B.O": "522549",
      "Potluru B.O": "522646",
      "Vayyakallu B.O": "522646",
      "Naidupalem B.O": "522657",
      "Vaddemgunta B.O": "522657",
      "Cheekateegalapalem B.O": "522647",
      "Jalalapalem B.O": "522647",
      "Nirmalanagar B.O": "522647",
      "Tellabadu B.O": "522647",
      "Thimmayapalem B.O": "522647",
      "Kogantivaripalem B.O": "522409",
      "Madipadu B.O": "522409",
      "PUTLAGUDEM BO": "522409",
      "Chowtapapayapalem B.O": "522411",
      "Hassannabad B.O": "522411",
      "MANNESULTANPALEM BO": "522411",
      "Tummalacheruvu B.O": "522437",
      "Pondugula B.O": "522414",
      "Tangeda B.O": "522414",
      "Cherlagudipadu B.O": "522415",
      "Gangavaram B.O": "522415",
      "Gottimukkala B.O": "522415",
      "Madugula B.O": "522415",
      "Idupalli B.O": "522268",
      "Muttupalli Agraharam B.O": "522268",
      "Yeletipalem B.O": "522268",
      "Alluru B.O": "522314",
      "Kollimarla B.O": "522316",
      "Manthenavaripalem B.O": "522329",
      "Tallapalem B.O": "522124",
      "Pandrapadu B.O": "522124",
      "Modukur B.O": "522318",
      "Alapadu B.O": "522312",
      "Maruproluvaripalem B.O": "522102",
      "Bhoolayapalem B.O": "522311",
      "Kovelamudi B.O": "522212",
      "Guddikayalanka B.O": "522265",
      "Kannegantivaripalem B.O": "522265",
      "Murthota B.O": "522265",
      "Vullipalem B.O": "522265",
      "Vejendla B.O": "522213",
      "Sekuru B.O": "522213",
      "Vadlamudi B.O": "522213",
      "Balijepalli B.O": "522261",
      "Chavali B.O": "522261",
      "Kuchellapadu B.O": "522261",
      "Panchalavaram B.O": "522325",
      "Chadalavada B.O": "522301",
      "Ipuru B.O": "522301",
      "Valiveru B.O": "522211",
      "Pothumeraka B.O": "522264",
      "Visweswaram B.O": "522264",
      "Morampudi B.O": "522330",
      "Kopalle B.O": "522307",
      "Chivaluru B.O": "522304",
      "Pidaparru B.O": "522304",
      "Nagaram S.O (Guntur)": "522268",
      "Nidubrole S.O": "522124",
      "Nizampatnam S.O": "522314",
      "Patsalatadiparru S.O": "522316",
      "Ponnur Bazar S.O": "522124",
      "Machavaram S.O (Tenali)": "522315",
      "Railpeta Bapatla S.O": "522101",
      "Amartaluru S.O": "522325",
      "Pittalavanipalem S.O": "522329",
      "Ponnur S.O": "522124",
      "Snpagraharam S.O": "522101",
      "Stuvartpuram S.O": "522317",
      "Tsunduru S.O": "522318",
      "Turumella S.O": "522312",
      "Angalakudur S.O": "522211",
      "Karlapalem S.O": "522111",
      "Kuchinapudi S.O": "522262",
      "Rangaraothota S.O": "522101",
      "Anantavaram S.O": "522301",
      "Bhattiprolu S.O": "522256",
      "Chodayapalem S.O": "522264",
      "Gandhinagar S.O (Guntur)": "522201",
      "Isukapalle S.O": "522265",
      "Railpeta   Repale S.O": "522265",
      "Repalle S.O": "522265",
      "Sangamjagarlamudi S.O": "522213",
      "China Ravuru Tenali S.O": "522201",
      "Emani S.O": "522308",
      "Kolluru S.O": "522324",
      "Kothapeta S.O (Guntur)": "522201",
      "Old Mangalagiri S.O": "522503",
      "Pedavadlapudi S.O": "522302",
      "Pinapad Tenali S.O": "522202",
      "Duggirala S.O": "522330",
      "Ithanagar S.O": "522201",
      "Kollipara S.O": "522304",
      "Kuchipudi S.O": "522313",
      "Morrispeta S.O": "522202",
      "Nandivelugu S.O": "522306",
      "Wahabchowk tenali S.O": "522201",
      "Tenali H.O": "522201",
      "Kolakaluru S.O": "522307",
      "Vellaturu S.O": "522257",
      "Vemuru S.O": "522261",
      "Satyanarayanapuram S.O (Guntur)": "522202",
      "Tenali Bazar S.O": "522201",
      "Bapatla H.O": "522101",
      "PWD Colony S.O": "522426",
      "Guntur H.O": "522002",
      "Sattenapalle H.O": "522403",
      "Mangalagiri H.O": "522503",
      "Narasaraopet H.O": "522601",
      "Mangalagiri Busstand S.O": "522503",
      "Namburu S.O": "522508",
      "Nutakki S.O": "522303",
      "Ponnekallu S.O": "522018",
      "Tadikonda S.O": "522236",
      "Tulluru S.O": "522237",
      "A.P.Secretariat S.O": "522238",
      "Nagarjuna Nagar S.O": "522510",
      "Polakampadu Ind. Area S.O": "522501",
      "Tadepalle S.O": "522501",
      "Abbineniguntapalem S.O": "522015",
      "Bus Stand(Guntur) S.O": "522001",
      "Etukuru Road(Guntur) S.O": "522003",
      "Factories Ward S.O": "522003",
      "Govt. General Hospital S.O": "522001",
      "Guntur Bazar S.O": "522003",
      "Guntur Collectorate S.O": "522004",
      "Kothapeta(Guntur) S.O": "522001",
      "L.W.Works(Guntur) S.O": "522007",
      "Amaravathi Road(Guntur) S.O": "522007",
      "College Road(Guntur) S.O": "522001",
      "Etukuru S.O": "522017",
      "Koritepadu(Guntur) S.O": "522007",
      "Nallapadu S.O": "522005",
      "Old Guntur S.O": "522001",
      "Pattabhipuram(Guntur) S.O": "522006",
      "Prathipadu S.O (Guntur)": "522019",
      "S.K.P.Temple(Guntur) S.O": "522003",
      "Venugopalanagar Colony S.O": "522004",
      "Chalapathi Nagar S.O": "522034",
      "Apsp Colony(Mangalagiri) S.O": "522503",
      "K.C.Works S.O": "522502",
      "Lemalle S.O": "522016",
      "Medikonduru S.O": "522438",
      "Parastyalluru S.O": "522436",
      "Rajupalem S.O (Guntur)": "522412",
      "Pedanandipadu S.O": "522235",
      "Railpet(Guntur) S.O": "522001",
      "Perecherla Junction S.O": "522009",
      "A.T.Agraharam(Guntur) S.O": "522004",
      "Chandramoulinagar S.O": "522007",
      "Choutra(Guntur) S.O": "522003",
      "Industrial Estate S.O (Guntur)": "522034",
      "Kakumanu S.O": "522112",
      "Nehru Nagar(Guntur) S.O": "522001",
      "S.V.N.Colony(Guntur) S.O": "522006",
      "Trunk Road(Guntur) S.O": "522004",
      "Amaravathi S.O": "522020",
      "Pedakakani S.O": "522509",
      "Pedapalem S.O": "522305",
      "A.P.High Court S.O": "522239",
      "Machavaram S.O (Narasaraopet)": "522435",
      "Muppalla S.O (Guntur)": "522408",
      "Pedakurapadu S.O": "522402",
      "Piduguralla S.O": "522413",
      "Vijayapuri South S.O": "522439",
      "Brodipet(Guntur) S.O": "522002",
      "Chowdaripeta(Guntur) S.O": "522006",
      "Krosuru S.O": "522410",
      "Macherla S.O (Guntur)": "522426",
      "Rentachintala S.O": "522421",
      "Siripuram S.O (Guntur)": "522401",
      "Veldurthy S.O": "522613",
      "Chebrole S.O (Guntur)": "522212",
      "Appikatla S.O": "522310",
      "Bapatla Engg College S.O": "522102",
      "Chandole S.O": "522311",
      "Intur S.O": "522341",
      "Cherukupalle S.O": "522309",
      "Cheruvu S.O": "522113",
      "Dhulipudi S.O": "522258",
      "Kanagala S.O (Guntur)": "522259",
      "Arundalpet (NSV) S.O": "522601",
      "Chilakaluripet Bazar S.O": "522616",
      "Chilakaluripet S.O": "522616",
      "Ipuru S.O": "522658",
      "Karempudi S.O": "522614",
      "Komaravallipadu S.O": "522616",
      "Nadendla S.O": "522234",
      "Nuzendla S.O": "522660",
      "Savalyapuram S.O": "522646",
      "Vellatur S.O": "522657",
      "Brahmanapalle S.O": "522437",
      "Ainavole S.O": "522659",
      "Bandlamottu S.O": "522663",
      "Durgi S.O": "522612",
      "Ganapavaram S.O (Guntur)": "522619",
      "Kothapet(VKD) S.O": "522647",
      "Muppalla(VKD) S.O": "522661",
      "Narasaraopet Bazar S.O": "522601",
      "Pedakancherla S.O": "522649",
      "Prakashnagar S.O": "522601",
      "Satuluru S.O": "522549",
      "Vinukonda S.O": "522647",
      "Nekarikallu S.O": "522615",
      "Phirangipuram S.O": "522529",
      "Atchampet S.O": "522409",
      "Dachpalle S.O": "522414",
      "Edlapadu S.O": "522233",
      "Kavuru S.O": "522611",
      "Murikipudi S.O": "522626",
      "N.S.C.Colony S.O": "522601",
      "NSP Colony S.O": "522647",
      "Ravipadu S.O (Guntur)": "522603",
      "Rompicherla S.O (Guntur)": "522617",
      "Subbaiah Thota S.O": "522616",
      "Bellamkonda S.O": "522411",
      "Gandhi Chowk S.O (Guntur)": "522403",
      "Gurazalla S.O": "522415"
    },
    "PRAKASAM": {
      "Mannepalli B.O": "523264",
      "Sivarampuram B.O": "523264",
      "Dhenuvakonda B.O": "523263",
      "Pallamalli B.O": "523263",
      "Doddavaram B.O": "523263",
      "Kunkupadu B.O": "523264",
      "Lakkavaram B.O": "523264",
      "Nagambotlavaripalem B.O": "523264",
      "Mallavaram B.O": "523263",
      "Nekunambadu B.O": "523263",
      "Chekurapadu B.O": "523262",
      "Madhavaram B.O": "523264",
      "Rajanagaram B.O": "523264",
      "Chandrapadu B.O": "523263",
      "Ilapavuluru B.O": "523263",
      "Edubadu B.O": "523171",
      "Garnepudi B.O": "523171",
      "Poluru B.O": "523171",
      "Dronadula B.O": "523190",
      "Daggubadu B.O": "523190",
      "Vankayalapadu B.O": "523190",
      "Hanumoji Palem B.O": "523167",
      "Koniki B.O": "523167",
      "Chinagumpalle B.O": "523181",
      "Motupalli B.O": "523184",
      "Chinanandipadu B.O": "523169",
      "Adusumalli B.O": "523169",
      "Devarapalli B.O": "523169",
      "Veerannapalem B.O": "523169",
      "Ramanayyapalem B.O": "523169",
      "Vadarevu B.O": "523157",
      "Jarbulavaripale B.O": "523185",
      "Audipudi B.O": "523170",
      "Chimidithapadu B.O": "523281",
      "Kothapeta B.O": "523157",
      "Ayyaparajupalem B.O": "523271",
      "Yadavalli B.O": "523245",
      "Khajipuram B.O": "523346",
      "P.Venkatapuram B.O": "523346",
      "Akkapalem B.O": "523328",
      "R.Ummadivaram B.O": "523328",
      "Sathakodu B.O": "523328",
      "J.Pullalacheruvu B.O": "523368",
      "Idamakallu B.O": "523369",
      "Narashimapalle B.O": "523369",
      "Peddaobanayunipalle B.O": "523370",
      "Seethanagulavaram B.O": "523332",
      "Nasarsahebpalle B.O": "523371",
      "Chollaveedu B.O": "523372",
      "Idupur B.O": "523320",
      "Peddaraveedu B.O": "523320",
      "Pregallapadu B.O": "523320",
      "Ganapavaram B.O": "523326",
      "Kankanalapalle B.O": "523326",
      "Mudivemula B.O": "523326",
      "Kalanuthala B.O": "523329",
      "Sunkesula B.O": "523329",
      "Thippayapalem B.O": "523329",
      "Eguvacherlopalle B.O": "523331",
      "Jammidornala B.O": "523331",
      "Katakanipalle B.O": "523331",
      "Nallaguntla B.O": "523369",
      "Pedda Bommalapuram B.O": "523331",
      "Basinepalle B.O": "523346",
      "Galizerugulla B.O": "523346",
      "Janapalacheruvu B.O": "523346",
      "Timmarajupalem B.O": "523171",
      "Nagandla B.O": "523190",
      "Pusapadu B.O": "523190",
      "Bhimavaram B.O": "523292",
      "Gangavaram B.O": "523225",
      "Naidu Vari Palem B.O": "523167",
      "Pavulur B.O": "523167",
      "Gavinivaripalem B.O": "523166",
      "Thotavaripalem B.O": "523166",
      "Kunkalamarru B.O": "523168",
      "Gollapudiagraharam B.O": "523169",
      "Jagarlamudi B.O": "523169",
      "Kollavaripalem B.O": "523169",
      "Yerramvaripalem B.O": "523169",
      "Burlavaripalem B.O": "523157",
      "Timidithapadu B.O": "523170",
      "Puretipalli B.O": "523281",
      "Pakala B.O": "523101",
      "Kalikavaya B.O": "523101",
      "Ananandapuram B.O": "523101",
      "M L Engg. College B.O": "523101",
      "Alakurapadu B.O": "523274",
      "Kakuturivaripalem B.O": "523274",
      "Velagapudi B.O": "523274",
      "Chagallu B.O": "523292",
      "Mannetikota B.O": "523292",
      "Tumadu B.O": "523279",
      "Chodavaram B.O": "523279",
      "Chundi B.O": "523116",
      "Polinenicheruvu B.O": "523116",
      "Kandulur B.O": "523272",
      "Yerazerla B.O": "523272",
      "Binginapalli B.O": "523104",
      "Mopadu B.O": "523110",
      "Ayyavaripalli B.O": "523116",
      "Raghunadhapuram B.O": "523110",
      "Ambavaram Kothapalli B.O": "523112",
      "Arivemula B.O": "523112",
      "Darsiguntapeta B.O": "523112",
      "Kovilampadu B.O": "523112",
      "Nallamadugula B.O": "523112",
      "Votlabailu B.O": "523112",
      "Devavaram B.O": "523247",
      "Garimenapenta B.O": "523246",
      "Naidupet B.O": "523246",
      "Hazipuram B.O": "523227",
      "Kutagundla B.O": "523227",
      "Siddavaram B.O": "523241",
      "Alavalapadu B.O": "523212",
      "Bandiveli Gandla B.O": "523304",
      "Kalluru B.O": "523304",
      "Morapagunta B.O": "523223",
      "Nagireddipalli B.O": "523223",
      "Pedavullagallu B.O": "523265",
      "Polavaram B.O": "523265",
      "Sankarapuram B.O": "523265",
      "Pallepalem B.O": "523135",
      "Rajubangarupalem B.O": "523135",
      "Pathachirala B.O": "523165",
      "Gandhinagar B.O": "523165",
      "Maddirallamuppalla B.O": "523181",
      "Komaranenivaripalem B.O": "523169",
      "Munnagivaripalem B.O": "523169",
      "Nuthalapadu B.O": "523169",
      "Pothukatla B.O": "523169",
      "Punuru B.O": "523169",
      "Kurthula B.O": "523157",
      "Papayapalem B.O": "523157",
      "Desaipet B.O": "523187",
      "Kalikavayabitragunta B.O": "523101",
      "Kanumalla B.O": "523101",
      "Nandanavanam B.O": "523228",
      "Old Singarayakonda B.O": "523101",
      "Sanampudi B.O": "523101",
      "Somarajupalli B.O": "523101",
      "K.Rajupalem B.O": "523292",
      "Atmakur B.O": "523292",
      "Karedu B.O": "523292",
      "Krishnapuram B.O": "523292",
      "Sameeripalem B.O": "523116",
      "Ammapalem B.O": "523116",
      "Mallavarappadu B.O": "523272",
      "Marlapadu B.O": "523272",
      "Pellur B.O": "523272",
      "Balijapalem B.O": "523110",
      "Eastkattakindapalli B.O": "523110",
      "Guntupalli B.O": "523301",
      "Tumativaripalem B.O": "523110",
      "Ayyalurivaripalli B.O": "523112",
      "Chennapanayunipalli B.O": "523112",
      "Chintapadu B.O": "523112",
      "Nimmareddipalem B.O": "523247",
      "Raja,mpalli B.O": "523247",
      "Ramachandrapuram B.O": "523329",
      "Thurupuchavatapalem B.O": "523247",
      "Venkatachalampalli B.O": "523247",
      "Chinamanagundam B.O": "523246",
      "Perareddipalli B.O": "523246",
      "Batchalakurapadu B.O": "523246",
      "Gayamvaripalli B.O": "523246",
      "Katragunta B.O": "523246",
      "Pedadasaripalli B.O": "523227",
      "Pedadasullapalli B.O": "523227",
      "Seetharampuram B.O": "523227",
      "Kaluzuvvalapadu B.O": "523241",
      "Nagarajukunta B.O": "523241",
      "Munagapadu B.O": "523241",
      "Darsichandalur B.O": "523304",
      "Kotalapalli B.O": "523223",
      "Pedagogulapalli B.O": "523223",
      "Naidupalem B.O": "523327",
      "Errabalem B.O": "523328",
      "Aurangabad B.O": "523370",
      "Chinnaobanayunipalle B.O": "523370",
      "Kalugotla B.O": "523370",
      "Lanjakota B.O": "523370",
      "Tadivaripalle B.O": "523332",
      "Akaveedu B.O": "523372",
      "Chatlamada B.O": "523320",
      "Chatlamitta B.O": "523320",
      "Darimadugu B.O": "523320",
      "Devarajugattu B.O": "523320",
      "Isukatripuravaram B.O": "523326",
      "Medepi B.O": "523326",
      "Miriyampalle B.O": "523326",
      "Rajupalem B.O": "523301",
      "Jammanapalle B.O": "523329",
      "Kondepalle B.O": "523329",
      "Nikarampalle B.O": "523329",
      "Puchakayalapalle B.O": "523329",
      "Thammadapalle B.O": "523331",
      "Inagallu B.O": "523171",
      "Bodavada B.O": "523253",
      "Gonasapudu B.O": "523181",
      "Budavada B.O": "523169",
      "Nagulapalem B.O": "523169",
      "Upputuru B.O": "523169",
      "Timmasamudram B.O": "523185",
      "Kodavalivaripalem B.O": "523170",
      "Kesavarappadu B.O": "523170",
      "Darakanipadu B.O": "523281",
      "Potluru B.O": "523281",
      "Patchava B.O": "523271",
      "Janardhnapuram B.O": "523271",
      "Kattugudipalem B.O": "523271",
      "Konapalle B.O": "523346",
      "M.Pullacheruvu B.O": "523346",
      "Manepalle B.O": "523328",
      "Mutukula B.O": "523328",
      "Venkatareddypalle B.O": "523328",
      "Anumalapalle B.O": "523368",
      "Gowthavaram B.O": "523368",
      "Palakaveedu B.O": "523368",
      "Makthapuram B.O": "523369",
      "Thamballapalle B.O": "523369",
      "Lingojipalle B.O": "523370",
      "Salakalaveedu B.O": "523370",
      "Gollapalle B.O": "523330",
      "Meerjampeta B.O": "523332",
      "Tarlupadumission Compound B.O": "523332",
      "Ammavaripalem B.O": "523281",
      "Baddepudi B.O": "523281",
      "Chirrikurapadu B.O": "523271",
      "Gongotireddipalem B.O": "523271",
      "Jallapalem B.O": "523271",
      "Mangalikunta B.O": "523371",
      "Rayavaram B.O": "523371",
      "Madarpalle B.O": "523372",
      "Narasireddypalle B.O": "523372",
      "B.Cherlopalle B.O": "523320",
      "Gobbur B.O": "523320",
      "Maddalakatta B.O": "523320",
      "Thangirallapalle B.O": "523320",
      "G.Ummadivaram B.O": "523326",
      "Ramasamudram B.O": "523326",
      "Ramachandrakota B.O": "523331",
      "Tettu B.O": "523291",
      "Oguru B.O": "523101",
      "Ananthavaram B.O": "523301",
      "Chintalapalem B.O": "523274",
      "Devagudur B.O": "523274",
      "Jammulapalem B.O": "523274",
      "Jarugumalli B.O": "523274",
      "Chakicherla B.O": "523292",
      "Veerepalli B.O": "523292",
      "Chinavenkannapalem B.O": "523279",
      "Palukur B.O": "523101",
      "Vikkirallapeta B.O": "523101",
      "Kondikandukur B.O": "523101",
      "Jayavaram B.O": "523274",
      "Vaviletipadu B.O": "523274",
      "M.Nidamanur B.O": "523279",
      "Vennuru B.O": "523279",
      "Kondasamudram B.O": "523116",
      "Polinenipalem B.O": "523116",
      "Karumanchi B.O": "523272",
      "Konizedu B.O": "523272",
      "Vengamukka Palem B.O": "523272",
      "Kodigumpala B.O": "523110",
      "Khambaladinne B.O": "523110",
      "Lakshminarasapuram B.O": "523110",
      "Anikalapalli B.O": "523112",
      "Kothapalli B.O": "523247",
      "Mohammadapuram B.O": "523246",
      "Nagampalli B.O": "523246",
      "Pathapadu B.O": "523230",
      "Edaravaripalli B.O": "523227",
      "Regadipalli B.O": "523241",
      "Tuvvapadu B.O": "523241",
      "Yerraobanapalem B.O": "523304",
      "Ats Palem B.O": "523304",
      "Bodanampadu B.O": "523304",
      "Gangadonakonda B.O": "523304",
      "Narasamambapuram B.O": "523223",
      "Pasupugallu B.O": "523265",
      "Umamaheswarapuram B.O": "523265",
      "Vemula B.O": "523265",
      "Raviguntapalli B.O": "523230",
      "Devarapalem B.O": "523253",
      "Talamalla B.O": "523253",
      "Gannavaram B.O": "504214",
      "Sanikavaram B.O": "523331",
      "Singarapalle B.O": "523346",
      "Marrivemula B.O": "523328",
      "Panduvanagulavaram B.O": "523224",
      "Ramagopalapuram B.O": "523224",
      "Vemparala B.O": "523201",
      "Makkenavaripalem B.O": "523303",
      "Sunkaravaripalem B.O": "523201",
      "Uppalapadu": "523201",
      "Chervanuppalapadu B.O": "523180",
      "Paletipadu B.O": "523279",
      "Savireddi Palem B.O": "523272",
      "Thurpu Naidu Palem B.O": "523272",
      "Kondaboinapalli B.O": "523112",
      "Mundlapadu B.O": "523112",
      "Musunurukothapalli B.O": "523112",
      "Uppalapadu B.O": "523112",
      "Venkatapur B.O": "523247",
      "Pothavaram B.O": "523183",
      "Pulipadu B.O": "523247",
      "Chalivendram B.O": "523247",
      "Gajulaplli B.O": "523246",
      "Vemulapadu B.O": "523273",
      "Chinmuppalapadu B.O": "523227",
      "Doddichintala B.O": "523227",
      "Mugachintala B.O": "523241",
      "Vaddimadugu B.O": "523241",
      "Veligandla B.O": "523241",
      "Igalapadu": "523241",
      "Nayudupalem B.O": "523115",
      "Peddavaram B.O": "523304",
      "Namasivayapuram B.O": "523304",
      "Potlapadu B.O": "523304",
      "West Gangavaram B.O": "523304",
      "West Veerayapalem B.O": "523304",
      "Ballavaram B.O": "523223",
      "Gollaplli B.O": "523223",
      "Boppidivaripalem B.O": "523265",
      "Idara B.O": "523265",
      "Mahadevapuram B.O": "523101",
      "Paluru B.O": "523101",
      "Manchikalapadu B.O": "523226",
      "G.L.Puram B.O": "523226",
      "Gonugunta B.O": "523226",
      "Panakalapalem B.O": "523182",
      "Surepalli B.O": "523303",
      "Kukutlapalli B.O": "523303",
      "Paritalavaripalem B.O": "523303",
      "Yerrapalem B.O": "523212",
      "Bollavarappadu B.O": "523212",
      "Thimmana Palem B.O": "523212",
      "Annangi B.O": "523211",
      "Gullapalli B.O": "523211",
      "Bobbepalli B.O": "523301",
      "CHERUKURU B.O": "523169",
      "Immadicheruvu B.O": "523224",
      "Jallapaem B.O": "523224",
      "Kanakanampadu B.O": "523224",
      "Pulikuntla B.O": "523224",
      "Anumalaveedu B.O": "523368",
      "Kalavapalle B.O": "523368",
      "Somidevipalle B.O": "523368",
      "Bhupathipalle B.O": "523332",
      "Bondalapadu B.O": "523332",
      "Malyavanthunipadu B.O": "523332",
      "Kethagudipi B.O": "523371",
      "Nagellamudipi B.O": "523371",
      "Akkapalle B.O": "523372",
      "Araveetikota B.O": "523372",
      "Peddanallakalva B.O": "523372",
      "SGIT BO-Darimadugu": "523320",
      "Annasamudram B.O": "523326",
      "Chintakunta B.O": "523329",
      "Gottipadia B.O": "523329",
      "Rallapalli B.O": "523224",
      "Nagarajupalli B.O": "523301",
      "Yeddanapudi B.O": "523301",
      "Baitamanjuluru B.O": "523261",
      "Chadalavada B.O": "523183",
      "Kandlagunta B.O": "523183",
      "Paidipadu B.O": "523271",
      "Kopperapalem B.O": "523302",
      "B.Machavaram B.O": "523225",
      "Rudravaram B.O": "523225",
      "Machavaram B.O": "523113",
      "Vedullacheruvu B.O": "523224",
      "Nagulapadu B.O": "523201",
      "Velamuripadu B.O": "506003",
      "Bommnampadu B.O": "523201",
      "Chakrayapalem B.O": "523201",
      "Venkatapuram B.O": "523108",
      "Zammalamadaka B.O": "523201",
      "Chavatapalem B.O": "523109",
      "Bhusarapalli B.O": "523226",
      "Chilamkur B.O": "523108",
      "R.L.Puram B.O": "523226",
      "Madanur B.O": "523280",
      "Aluru B.O": "523182",
      "Dasarajupalli B.O": "523182",
      "Devarampadu B.O": "523182",
      "Vaidena B.O": "523303",
      "Chennupalli B.O": "523303",
      "Elchuru B.O": "523303",
      "Kopperapadu B.O": "523213",
      "Anamanamuru B.O": "523212",
      "Bodduvaripalem B.O": "523212",
      "Guravareddipalem B.O": "523211",
      "Inamanamelluru B.O": "523211",
      "Ballikurva B.O": "523301",
      "Degaramudi B.O": "523301",
      "Jonnatali B.O": "523301",
      "Yanamadala B.O": "523301",
      "Bollapalli B.O": "523261",
      "Kondamuru B.O": "523261",
      "Minnekallu B.O": "523302",
      "Pathamagulur B.O": "523302",
      "Enikapadu B.O": "523225",
      "Gummalampadu B.O": "523225",
      "Veluru B.O": "523253",
      "Annavaram B.O": "523253",
      "Boddikurapadu B.O": "523253",
      "Kalavakur B.O": "523201",
      "Kasyapuram B.O": "523201",
      "Khambampadu B.O": "523201",
      "Kotikalapudi B.O": "523201",
      "Nuzellpalli B.O": "523201",
      "Kanuparthi B.O": "523180",
      "Raparala B.O": "523180",
      "Pulikonda B.O": "523226",
      "Bandlamudi B.O": "523226",
      "Arikatlavaripalem B.O": "523214",
      "Janakavaram B.O": "523214",
      "Nuzellapalli B.O": "523214",
      "Alluru B.O": "523286",
      "Koppole B.O": "523286",
      "Motumala B.O": "523286",
      "Daivalaravuru B.O": "523212",
      "K.Thakkellapadu B.O": "523212",
      "Korisapadu B.O": "523212",
      "Pitchikalagudipadu B.O": "523212",
      "Eastgangavaram B.O": "523264",
      "Thammavaram B.O": "523212",
      "Nelaturu B.O": "523211",
      "Rachavaripalem B.O": "523211",
      "Konidena B.O": "523301",
      "Vemavaramagraharam B.O": "523301",
      "Vinjanampadu B.O": "523301",
      "Bhagavanrajupalem B.O": "504346",
      "Kolalapudi B.O": "523261",
      "Kondamanjulur B.O": "523261",
      "Hanumapuram B.O": "523183",
      "Brahmananidamanuru B.O": "523183",
      "Tangedumalli B.O": "523302",
      "Vellalacheruvu B.O": "523302",
      "Maddulur B.O": "523225",
      "Mangamuru B.O": "523225",
      "Pidathalagudipadu B.O": "523225",
      "Korrapativaripalem B.O": "523264",
      "Modepalli B.O": "523264",
      "Turakapalem B.O": "523264",
      "Kellampalli B.O": "523265",
      "Kunchepalli B.O": "523247",
      "Bellamkondavaripalem B.O": "523252",
      "Thotavenganapalem B.O": "523252",
      "Kalagotla B.O": "523254",
      "Botikarlapadu B.O": "523230",
      "Dubagunta": "523109",
      "Nippatlapadu B.O": "523253",
      "Chimata B.O": "523253",
      "Kakarla B.O": "523333",
      "Sivarayunipeta B.O": "523253",
      "Tripurasundaripuram B.O": "523253",
      "Gokulam B.O": "523224",
      "Purimetla B.O": "523265",
      "Mailavaram B.O": "523201",
      "Marella B.O": "523117",
      "Thimmayapalem B.O": "523201",
      "Chinaravipadu B.O": "523226",
      "Kunamnenivaripalem B.O": "523226",
      "Ulichi B.O": "523182",
      "Kunduru B.O": "523303",
      "Muktheswaram B.O": "523303",
      "S.L. Gudipadu B.O": "523303",
      "Padarthi B.O": "523286",
      "Basavannapalem B.O": "523211",
      "Doddavarappadu B.O": "523211",
      "Pedakothapalli B.O": "523211",
      "Vellampalli B.O": "523211",
      "Pedaambadipudi B.O": "523301",
      "Uppumagulur B.O": "523301",
      "Mallayapalem B.O": "523301",
      "Rajugaripalem B.O": "523301",
      "Reningavaram B.O": "523261",
      "Prasangulapadu B.O": "523183",
      "Kamepalli B.O": "523302",
      "Kopparam B.O": "523302",
      "Mainampadu B.O": "523225",
      "Y.Laxmipuram B.O": "523225",
      "Pernamitta B.O": "523225",
      "Yendluru B.O": "523225",
      "Vittalapuram B.O": "523264",
      "KOTAPADU B.O": "523214",
      "Ankepalli B.O": "523253",
      "Buchannapalem B.O": "523245",
      "Madalavaripalem B.O": "523245",
      "Vallayapalem B.O": "523253",
      "Zuvvaleru B.O": "523245",
      "East Veerayapalem B.O": "523252",
      "Singanapalem B.O": "523252",
      "Kothayeruvaripalli B.O": "523254",
      "Chinairlapadu B.O": "523254",
      "Ballipalli B.O": "523230",
      "Cheerladinne B.O": "523230",
      "Kancharlavaripalem B.O": "523230",
      "Lingareddipalli B.O": "523230",
      "Tummagunta B.O": "523230",
      "Kuchipudi B.O": "523270",
      "Ramulaveedu B.O": "523247",
      "Chandalur": "523214",
      "Akkacheruvu B.O": "523245",
      "Gollapalli B.O": "523247",
      "Marripudi B.O": "523253",
      "Sudanagunta B.O": "523245",
      "Botlapalem B.O": "523252",
      "Bommireddipalli B.O": "523254",
      "Garlapeta B.O": "523254",
      "Chakirala B.O": "523230",
      "Markondapuram B.O": "523230",
      "Zuvvigunta B.O": "523270",
      "Anakarlapudi B.O": "523270",
      "Dharmavarm B.O": "523270",
      "Polireddipalem B.O": "523270",
      "Ramayyapalem B.O": "523270",
      "Mogilicherla B.O": "523114",
      "Mutyalapadu B.O": "523115",
      "Malepadu B.O": "523109",
      "Edlurapadu B.O": "523109",
      "Jillellamudi B.O": "523109",
      "Uppaledinne B.O": "523271",
      "Mugachinala B.O": "523270",
      "Timmareddipalem B.O": "523114",
      "Chinapavani B.O": "523115",
      "Chinalatrip B.O": "523115",
      "Medarametlapalem B.O": "523115",
      "Muppavaram B.O": "523273",
      "Kalavalla B.O": "523113",
      "Sakhavaram B.O": "523113",
      "Kondamudusupalem B.O": "523113",
      "Ravulakollu B.O": "523109",
      "Singarabotlapalem B.O": "523109",
      "Pandalapadu B.O": "523109",
      "Chevuru B.O": "523291",
      "Tangella B.O": "523271",
      "Verdhinenivaripalem B.O": "523271",
      "Nennurapadu B.O": "523270",
      "Goginenivari Palaem B.O": "523270",
      "Kattavarpalem B.O": "523270",
      "Pedakandlagunta B.O": "523270",
      "Rallapadu Project B.O": "523114",
      "Annaboinapalli B.O": "523115",
      "Dappalampadu B.O": "523113",
      "Naldalpur B.O": "523113",
      "Muppalla B.O": "523109",
      "Kovur Kandukur B.O": "523109",
      "N.N.Kandrika B.O": "523271",
      "Narasingole B.O": "523271",
      "Netivaripalem B.O": "523271",
      "Petlur B.O": "523270",
      "Regalagaddapalem B.O": "523270",
      "Tatakulapalem B.O": "523270",
      "Bodawada B.O": "523114",
      "Ponduru B.O": "523273",
      "Nekunampuram B.O": "523113",
      "V.R.Kota B.O": "523113",
      "Badevaripalem B.O": "523113",
      "Parikondapadu B.O": "523113",
      "Singamanenipalli B.O": "523113",
      "Pedamopadu B.O": "523113",
      "Timmapalem B.O": "523109",
      "Atchampeta B.O": "523335",
      "Bollupalle B.O": "523335",
      "Narayanapalle B.O": "523335",
      "Mokshagundam B.O": "523334",
      "Pandillapalle B.O": "523334",
      "Pusalapadu B.O": "523334",
      "Basireddypalle B.O": "523333",
      "Bommilingam B.O": "523333",
      "Chinnacumbum B.O": "523333",
      "Badapuram B.O": "523305",
      "Chandavaram B.O": "523305",
      "Donakonda Rly.Colony B.O": "523305",
      "Vekatapuram B.O": "523305",
      "Lellapalle B.O": "523330",
      "Nadigadda B.O": "523330",
      "Obulakkapalli B.O": "523330",
      "Vadampalli B.O": "523330",
      "Thaticherla B.O": "523356",
      "Block Area B.O": "523327",
      "Boyalapalle B.O": "523327",
      "Brahmanapalle B.O": "523357",
      "Diguvametta B.O": "523357",
      "Kongalaveedu B.O": "523357",
      "Krishnam Setty Palle B.O": "523357",
      "Bogolu B.O": "523336",
      "Donakonda B.O": "523336",
      "Lingapuram B.O": "523336",
      "Maddalamadaka B.O": "523336",
      "Burjupalle B.O": "523367",
      "Kommanuru B.O": "523367",
      "Cherukur B.O": "523109",
      "Ippagunta B.O": "523109",
      "Venkupalem B.O": "523109",
      "Mocherla B.O": "523291",
      "Ravuru B.O": "523291",
      "Darga B.O": "523334",
      "Chinnayachavaram B.O": "523333",
      "Hazarathgudem B.O": "523333",
      "Maratithanda B.O": "523333",
      "Rangapuram B.O": "523333",
      "Gudipadu B.O": "523111",
      "Lakshmipuram B.O": "523305",
      "Nallabothulavaripalem B.O": "523305",
      "Rudrasamudram B.O": "523305",
      "Hasanapuram B.O": "523330",
      "Vellampalle B.O": "523330",
      "Akkapalli B.O": "523356",
      "Daddavada B.O": "523356",
      "Oddualvagupalle B.O": "523356",
      "Chapalamadugu B.O": "523327",
      "Gangapalem B.O": "523327",
      "Gollavidipi B.O": "523327",
      "Komarole B.O": "523327",
      "Mallapalem B.O": "523327",
      "Narasayapalem B.O": "523327",
      "Veerabhadrapuram B.O": "523336",
      "Bodapadu B.O": "523315",
      "Kalivelapalle B.O": "523315",
      "Manginapudi B.O": "523315",
      "Pothalapadu B.O": "523315",
      "Ambavaram B.O": "523357",
      "Podilikondapalle B.O": "523357",
      "Yellupalle B.O": "523357",
      "Posupalle B.O": "523373",
      "Yerramsettyvaripalle B.O": "523373",
      "Ayyavaripalle B.O": "523336",
      "Mittameedipalle B.O": "523336",
      "Yerrabalem B.O": "523336",
      "Sanjeevaraopeta B.O": "523367",
      "Chinnagudipadu B.O": "523331",
      "Manduvavaripalem B.O": "523262",
      "Mukthinuthalapadu B.O": "523262",
      "Edumudi B.O": "523186",
      "Konanki B.O": "523260",
      "Pedjangalapalli B.O": "523260",
      "Chinakothapalli B.O": "523260",
      "Ramkur B.O": "523260",
      "Sankavarappadu B.O": "523260",
      "Maddiralapadu B.O": "523262",
      "Chimmiribanda B.O": "523260",
      "Nekunambad B.O": "523334",
      "Gannepalle B.O": "523333",
      "Velagalapaya B.O": "523333",
      "Aravallipadu B.O": "523305",
      "Indlacheruvu B.O": "523305",
      "Polepalle B.O": "523305",
      "Ramapuram B.O": "523305",
      "Gangupalle B.O": "523330",
      "Gurrapusala B.O": "523330",
      "Viswanadhapuram B.O": "523330",
      "Gudimetta B.O": "523356",
      "Satyavolu B.O": "523356",
      "Endrapalle B.O": "523327",
      "Ganjivaripalle B.O": "523327",
      "Gurijepalle B.O": "523327",
      "Venkatadripalem B.O": "523327",
      "Kavalakuntla BO": "523327",
      "Anantavaram B.O": "523315",
      "Ganugapenta B.O": "523315",
      "Mallampeta B.O": "523315",
      "Pedda yachavaram B.O": "523315",
      "Narava B.O": "523357",
      "Thimmapuram B.O": "523357",
      "Allinagaram B.O": "523373",
      "Pamurupalle B.O": "523373",
      "Reddi Cherla B.O": "523373",
      "Gadikota B.O": "523367",
      "Obulapuram B.O": "523367",
      "Chinna Dornala B.O": "523331",
      "Chintala B.O": "523331",
      "Papinenipalle B.O": "523335",
      "J.Krishnapuram B.O": "523333",
      "Jangamguntla B.O": "523333",
      "Kandulapuram B.O": "523333",
      "Magatur B.O": "523333",
      "Nagulavaram B.O": "523333",
      "Gangadevipalle B.O": "523305",
      "Thummedalapadu B.O": "523305",
      "Vaddipadu B.O": "523305",
      "Ammanigudipadu B.O": "523330",
      "Cumbumpadu B.O": "523330",
      "Ankireddypalle B.O": "523356",
      "Muraripalle B.O": "523327",
      "Peddakolukula B.O": "523327",
      "Kocherlakota B.O": "523315",
      "Badinenipalle B.O": "523373",
      "Chintalapalle B.O": "523373",
      "Gopalunipalle B.O": "523373",
      "Hanumantharayunipalli B.O": "523373",
      "Vuyyalawada B.O": "523367",
      "Ayanamukkala B.O": "523331",
      "Kodandaramapuram B.O": "523117",
      "Marrikuntapalli B.O": "523117",
      "Gudipatipalli B.O": "523228",
      "Kudumalaguntla B.O": "523228",
      "Mangampalli B.O": "523228",
      "Valicherla B.O": "523228",
      "Lingamgunta B.O": "523262",
      "Rachapudi B.O": "523186",
      "Dharmavaram B.O": "523260",
      "K.Agraharam B.O": "523111",
      "Murugummi B.O": "523111",
      "Neredupalli B.O": "523111",
      "Bukkapuram B.O": "523108",
      "Dubagunta B.O": "523108",
      "Inimerla B.O": "523108",
      "Irsalagundam B.O": "523245",
      "Nandanamarella B.O": "523245",
      "Pedairlapadu B.O": "523117",
      "Chintagumpalli B.O": "523117",
      "Thalakondapadu B.O": "523117",
      "Ummanapalli B.O": "523228",
      "Chinnipadu B.O": "523111",
      "Vemavaram B.O": "523111",
      "Narramarella B.O": "523108",
      "Pedarajupalem B.O": "523108",
      "Challagirigala B.O": "523245",
      "Dirisavancha B.O": "523245",
      "Kambalapadu B.O": "523245",
      "Yedugundlapadu B.O": "523262",
      "Pedaganjam B.O": "523186",
      "Duddukur B.O": "523186",
      "Komminenivaripalem B.O": "523260",
      "Darsiagraharam B.O": "523260",
      "Narayapalli B.O": "523228",
      "Timmareddypalli B.O": "523228",
      "Venkateswarapuram B.O": "523111",
      "Guravajipet B.O": "523108",
      "Naddimallapuram B.O": "523108",
      "Turupukodigundlapadu B.O": "523108",
      "Vangapadu B.O": "523108",
      "Chinarikatla B.O": "523245",
      "Baduguleru B.O": "523245",
      "Vengalayapalli B.O": "523117",
      "Nallagandla B.O": "523228",
      "Gudevaripalem B.O": "523111",
      "Talluru B.O": "523111",
      "Vengalapuram": "523111",
      "Kattakindipalli B.O": "523108",
      "Vaggampalli B.O": "523108",
      "Gundlasamudram B.O": "523253",
      "Chirala H.O": "523155",
      "Kandukur H.O": "523105",
      "Podili H.O": "523240",
      "Ongole H.O": "523001",
      "Markapur H.O": "523316",
      "A.B.V.Palem S.O": "523171",
      "Bosenagar S.O (Prakasam)": "523155",
      "Kadavakuduru S.O": "523181",
      "Karamchedu S.O": "523168",
      "Perala S.O": "523157",
      "Ravuri Pet S.O": "523187",
      "Santharavur S.O": "523185",
      "Kondepi S.O": "523270",
      "Ulavapadu S.O": "523292",
      "Darsi S.O": "523247",
      "Gotlagattu S.O": "523246",
      "Kurichedu S.O": "523304",
      "Pothakamur S.O": "523252",
      "Veligandla S.O": "523224",
      "Addanki Gate S.O": "523001",
      "J.Pangulur S.O": "523214",
      "Karavadi S.O": "523182",
      "M.M.T. Road S.O": "523212",
      "Maddipadu S.O": "523211",
      "Prakasam Bhavan S.O": "523001",
      "Tallur S.O (Prakasam)": "523264",
      "Uppugundur S.O": "523186",
      "Cumbum S.O (Prakasam)": "523333",
      "Dupadu S.O": "523330",
      "Giddalur Bazar S.O": "523357",
      "Giddalur West S.O": "523357",
      "Mohiddin Puram S.O": "523336",
      "Ravipadu S.O (Prakasam)": "523370",
      "Thurimella S.O": "523372",
      "Tokapalle S.O": "523320",
      "Tripurantakam S.O": "523326",
      "Idupulapadu S.O": "523190",
      "Ipurupalem S.O": "523166",
      "Parchur S.O": "523169",
      "Kandukur Cutchery S.O": "523105",
      "Ramapatnam S.O": "523291",
      "Tangutur S.O": "523274",
      "Vallur S.O (Prakasam)": "523272",
      "Botlagudur S.O": "523110",
      "H.M.Padu S.O": "523227",
      "Mogallur S.O": "523223",
      "P.G.Palli S.O": "523228",
      "Pedarikatla S.O": "523245",
      "Sankavaram S.O": "523254",
      "Addanki S.O": "523201",
      "Ethamukkala S.O": "523280",
      "Gopala Nagar (O) S.O": "523001",
      "N.S.C Colony (O) S.O": "523001",
      "Ongole Bazar S.O": "523001",
      "Ramnagar(A) S.O": "523201",
      "Ramnagar(O) S.O": "523001",
      "Thurupupalem S.O": "523001",
      "Kanigiri S.O": "523230",
      "Chirala Bazar S.O": "523157",
      "Inkollu S.O": "523167",
      "Prasad Nagar So (C ) S.O": "523157",
      "Vetapalem S.O": "523187",
      "Gudluru S.O": "523281",
      "Kamepalli S.O": "523271",
      "Linga Samudram S.O": "523114",
      "Peda Pavani S.O": "523115",
      "Peridepi S.O": "523273",
      "Pokur S.O": "523113",
      "S.Konda S.O": "523101",
      "Tanguturu Bus Stand S.O": "523274",
      "Uppalapadu (K) S.O": "523279",
      "Konakana Metla S.O": "523241",
      "Pa Padu S.O": "523111",
      "Chimakurty S.O": "523226",
      "Dcp(O) S.O": "523001",
      "Kommalapadu S.O": "523303",
      "Kothapatnam S.O": "523286",
      "Kurnool Road (O) S.O": "523002",
      "Lawyer Pet (O) S.O": "523002",
      "M.M.Donka (O) S.O": "523002",
      "Marturu S.O": "523301",
      "Ravinuthala S.O": "523213",
      "Santhamagulur S.O": "523302",
      "Tellapadu S.O": "523263",
      "Erragondapalem S.O": "523327",
      "Gajjalakonda S.O": "523315",
      "Markapur East S.O": "523316",
      "Thummalacheruvu S.O": "523371",
      "Vemulakota S.O": "523329",
      "Ardhaveedu S.O": "523335",
      "Besthavari  Peta S.O": "523334",
      "Cumbum East S.O": "523333",
      "Donakonda R.S. S.O": "523305",
      "Komarole S.O": "523373",
      "Mundlapadu S.O": "523367",
      "Pedda Dornala S.O": "523331",
      "Racherla S.O": "523368",
      "Rajupalem S.O (Prakasam)": "523369",
      "Edavalli S.O": "523356",
      "Giddalur S.O": "523357",
      "Markapur Bazar S.O": "523316",
      "Pitikayagulla S.O": "523346",
      "Pullala Cheruvu S.O": "523328",
      "Tarlupadu S.O": "523332",
      "Chinaganjam S.O": "523135",
      "Jandrapet S.O": "523165",
      "Mgc Market(C ) S.O": "523156",
      "Pandillapalli S.O": "523184",
      "Santha Bazar S.O": "523155",
      "Swarna S.O": "523170",
      "Kandukur South S.O": "523105",
      "Ponnalore S.O": "523109",
      "V V Palem S.O": "523116",
      "Woollapalem S.O": "523104",
      "C.S.Puram S.O": "523112",
      "Mundlamur S.O": "523265",
      "P.C.Palli S.O": "523117",
      "Pamur S.O": "523108",
      "Uppalapadu (P) S.O": "523253",
      "Ammanabrolu S.O": "523180",
      "Muppavaram S.O": "523261",
      "N.G.Padu S.O": "523183",
      "Santhanuthalapadu S.O": "523225",
      "Santhapeta (O) S.O": "523001",
      "Throvagunta S.O": "523262",
      "Valaparla S.O": "523260"
    },
    "EAST GODAVARI": {
      "North Gopalapuram B.O": "533274",
      "Kantevaripadu B.O": "533253",
      "Padamatipalem B.O": "533250",
      "Pasarlapudi B.O": "533247",
      "Pedapatnam Lanka B.O": "533247",
      "Avidi B.O": "533229",
      "Modekurru B.O": "533229",
      "Gogannamatham B.O": "533248",
      "Katrenipadu B.O": "533248",
      "Ithakota B.O": "533238",
      "Laxmi Polavaram B.O": "533236",
      "Ankampalem B.O": "533236",
      "Narkedmilli B.O": "533236",
      "Gudimula B.O": "533251",
      "Gondi B.O": "533251",
      "Rameswaram B.O": "533251",
      "Eastpalem B.O": "533244",
      "Palagummi B.O": "533249",
      "Jaggannapeta B.O": "533249",
      "Pedapatnam B.O": "533249",
      "NAGAMPALLI B.O": "533290",
      "Vadrevupalli B.O": "533249",
      "Lolla B.O": "533346",
      "SURYARAOPETA B.O": "533232",
      "Satellite City B.O": "533107",
      "Chikilintha B.O": "533436",
      "Ananthagiri B.O": "533436",
      "Jaddangi B.O": "533436",
      "Labbarthi B.O": "533436",
      "Doddigunta B.O": "533291",
      "Pedarayavaram B.O": "533291",
      "Chintaluru B.O": "533446",
      "Santhapydipala B.O": "533446",
      "Raghavapatnam B.O": "533446",
      "Kodada B.O": "533408",
      "D Polavaram B.O": "533401",
      "Hamsavaram B.O": "533401",
      "Dairy Farm Center S.O": "533007",
      "Kondapalli B.O": "533436",
      "Vudimudi B.O": "533274",
      "G.Pedapudi B.O": "533274",
      "Ganti B.O": "533274",
      "Mummidivarappadu B.O": "533274",
      "Sankaraguptam B.O": "533250",
      "Srungavarappadu B.O": "533250",
      "Adurru B.O": "533247",
      "Donelapalem B.O": "533436",
      "Godi O Kurthi B.O": "533436",
      "Kindra B.O": "533436",
      "Lagarayi B.O": "533436",
      "Lododdi B.O": "533436",
      "Sarabhavaram B.O": "533286",
      "Subhadrampeta B.O": "533291",
      "Samalkot Agrl Farm B": "533440",
      "B.Doddavaram B.O": "533247",
      "Aravapalem B.O": "533248",
      "Magatapalli B.O": "533248",
      "Mattaparru B.O": "533244",
      "Manepalli B.O": "533249",
      "Mogalikuduru B.O": "533249",
      "Nagullanka B.O": "533249",
      "Vadapalli B.O": "533288",
      "Santhiashram B.O": "533446",
      "Boddavaram B.O": "533401",
      "Nandivampu B.O": "533401",
      "Gogullanka B.O": "533464",
      "Gokavaram B.O": "533430",
      "Hukumpeta S.O": "533107",
      "Kedarlanka B.O": "533223",
      "Devarapalli B.O": "533223",
      "Yenugulamahal B.O": "533223",
      "Kathimanda B.O": "533254",
      "Lutukurru B.O": "533247",
      "Vegivaripalem B.O": "533248",
      "Ketharajuupalli B.O": "533238",
      "Komarajulanka B.O": "533238",
      "Ravulapadu B.O": "533238",
      "Sakhinetipalli Lanka B.O": "533251",
      "SEETHARAMPURAM B.O": "533297",
      "Mallampudi B.O": "533296",
      "INDUKURUPETA S.O": "533354",
      "DEWANCHERUVU S.O": "533353",
      "Yellayyapeta B.O": "533408",
      "Tatiparthi S.O": "533451",
      "Vattigadda B.O": "533436",
      "Aminabad B.O": "533436",
      "Kirrabu B.O": "533436",
      "Urlakulapadu B.O": "533436",
      "Mukundavaram B.O": "533291",
      "Satyanarayanapuram B.O": "533440",
      "G Kothapalli B.O": "533446",
      "Mulagapudi B.O": "533446",
      "Sakhinetipallipalem B.O": "533251",
      "Srirampuram B.O": "533296",
      "Medicherlapalem B.O": "533244",
      "Chintalapalli B.O": "533244",
      "Kesanapalli B.O": "533244",
      "Kunavaram B.O": "533213",
      "Billakurru B.O": "533228",
      "Madupalli B.O": "533228",
      "Pasupalli B.O": "533228",
      "Tadikona B.O": "533218",
      "Vadapalem B.O": "533223",
      "Irusumanda B.O": "533239",
      "Visweswarayapuram B.O": "533254",
      "Gudimellanka B.O": "533253",
      "Ramarajulanka B.O": "533253",
      "Chintalamori B.O": "533250",
      "Appanapalli B.O": "533247",
      "Badava B.O": "533247",
      "Idarada B.O": "533247",
      "Mamidikuduru B.O": "533247",
      "Pasarlapudilanka B.O": "533247",
      "Narendrapuram B.O": "533294",
      "Chirata Pudi B.O": "533229",
      "Kadali B.O": "533248",
      "Mulikipalli B.O": "533248",
      "Karavaka B.O": "533248",
      "Vedureswaram B.O": "533238",
      "Podagatapalli B.O": "533236",
      "Gudapalli B.O": "533244",
      "Podalada B.O": "533249",
      "Nellipudi B.O": "533285",
      "Vontimamidi B.O": "533408",
      "Addaripeta B.O": "533401",
      "Nadigatla Vari Savaram B.O": "533401",
      "Chamavaram B.O": "533401",
      "K Mallavaram B.O": "533401",
      "GANGAVARAM S.O": "533355",
      "Vathangi B.O": "533436",
      "Cherukumpalem B.O": "533436",
      "Thantikonda B.O": "533436",
      "Konthangi B.O": "533446",
      "Routhulapudi B.O": "533446",
      "Meraka Chamavaram B.O": "533446",
      "Pedamallapuram B.O": "533446",
      "A Kothapalli B.O": "533408",
      "Krishnapuram B.O": "533408",
      "Srungavruksham B.O": "533408",
      "Rekhavanipalem B.O": "533401",
      "S Annavaram B.O": "533401",
      "Velamakothuru B.O": "533401",
      "Gundala B.O": "533352",
      "Chodavaram B.O": "533352",
      "Forebey Dam Camp B.O": "533348",
      "Kommuru B.O": "533352",
      "Mukunuru B.O": "533352",
      "RAMAVARAM B.O.": "533352",
      "KANNAIGUDEM B.O.": "533352",
      "Chintalagudem B.O": "533352",
      "Yatapaka B.O": "533352",
      "Kachavaram B.O": "533351",
      "Murumuru B.O": "533351",
      "Nandigama B.O": "533351",
      "Tekubaka B.O": "533351",
      "Pedamittapalli B.O": "533349",
      "Rakapalli B.O": "533349",
      "Sriramgiri B.O": "533349",
      "Mangampadu B.O": "533348",
      "Chidumuru B.O": "533352",
      "Choppalli B.O": "533352",
      "Edurallapalli B.O": "533352",
      "Laxmipuram B.O": "533352",
      "VISSAPURAM B.O.": "533351",
      "Ummadivaram B.O": "533349",
      "Pulluru Phc B.O": "533347",
      "Chatti B.O": "533352",
      "Godlagudem B.O": "533352",
      "Kolturu B.O": "533352",
      "Vegithota B.O": "533352",
      "G.KOTHAGUDEM B.O.": "533352",
      "PITCHUKULAPADU B.O.": "533352",
      "RAMAGOPALAPURAM B.O.": "533352",
      "REGULAPADU B.O.": "533352",
      "Gannavaram B.O": "533351",
      "Jeediguppa B.O": "533349",
      "Vaddigudem B.O": "533349",
      "Chintur B.O": "533347",
      "Gogubaka B.O": "533352",
      "Tummala B.O": "533352",
      "Purushottapatnam B.O": "533287",
      "Venkatareddipeta B.O": "533352",
      "CHADALAVADA B.O.": "533352",
      "RAYANIPETA B.O.": "533352",
      "Gannerugoyyapadu B.O": "533351",
      "NALLAKUNTA B.O.": "533351",
      "KARAKAGUDEM B.O.": "533351",
      "Chintaregupalli B.O": "533349",
      "Vemulavada B.O": "533462",
      "Pathigondi B.O": "533463",
      "Gurazanapalli B.O": "533016",
      "Kurada B.O": "533260",
      "Yanamadala B.O": "533260",
      "Georgepeta B.O": "533464",
      "Guthenadeevi B.O": "533464",
      "Injaram B.O": "533464",
      "Pandraprolu B.O": "533428",
      "Pinjarakonda B.O": "533428",
      "Gondolu B.O": "533428",
      "Jaderu B.O": "533428",
      "Kinaparthi B.O": "533428",
      "Marripalem B.O": "533428",
      "Marriveedu B.O": "533428",
      "Godi B.O": "533217",
      "Munjavarapukottu B.O": "533214",
      "Nandampudi B.O": "533214",
      "Sannavilli B.O": "533222",
      "Uppalaguptam B.O": "533222",
      "Nadipudi B.O": "533221",
      "Tondavaram B.O": "533221",
      "Gangalakurru Agraharam B.O": "533221",
      "Pallamkurru B.O": "533212",
      "Komaragiri B.O": "533450",
      "Muramalla B.O": "533220",
      "Serilanka B.O": "533220",
      "T.Kothapalli B.O": "533220",
      "Matlapadu B.O": "533428",
      "Thimmapuram B.O": "533406",
      "Bendapudi B.O": "533406",
      "Ainavillilanka B.O": "533211",
      "Kondukuduru B.O": "533211",
      "Moolapolam B.O": "533211",
      "Sanapallilanka B.O": "533211",
      "Ainapuram B.O": "533216",
      "P.E.Chinayapalem B.O": "533406",
      "Ravikampadu B.O": "533406",
      "Srungadhara Agraharam B.O": "533406",
      "Vommangi B.O": "533430",
      "P.Donthamuru B.O": "533445",
      "Raparthi B.O": "533445",
      "J Burugupudi B.O": "533435",
      "Koturu B.O": "533435",
      "Ramavaram B.O": "533264",
      "Mallepalli B.O": "533435",
      "Mallisala B.O": "533435",
      "Narendrapatnam B.O": "533435",
      "Z Ragampeta B.O": "533435",
      "B Kothuru B.O": "533431",
      "Jagapathinagaram B.O": "533431",
      "Peddanapalli B.O": "533431",
      "Rajupalem B.O": "533344",
      "S Thimmapuram B.O": "533431",
      "Surapurajupeta B.O": "533407",
      "Allipudi B.O": "533407",
      "Bhimavarapukota B.O": "533407",
      "Nagulapalli B.O": "533447",
      "Ramanakkapeta B.O": "533447",
      "Jalluru B.O": "533433",
      "Pulimeru B.O": "533433",
      "Muggulla B.O": "533287",
      "Venkatanagaram B.O": "533105",
      "ABHICHERLA B.O.": "533350",
      "Polamuru B.O": "533342",
      "Nalluru B.O": "533307",
      "Rangapuram B.O": "533343",
      "Pasalapudi B.O": "533261",
      "Narsipudi B.O": "533232",
      "Burugupudi B.O": "533292",
      "N.T.Rajapuram B.O": "533297",
      "Singarampalem B.O": "533297",
      "Goragummi B.O": "533284",
      "Chinabhimpalli B.O": "533286",
      "Devaram B.O": "533286",
      "Gadelapalem B.O": "533286",
      "Indukurupeta B.O": "533286",
      "Madhavarayudupalem B.O": "533126",
      "Madiki B.O": "533126",
      "Muramanda B.O": "533126",
      "Gadala B.O": "533102",
      "Jambupatnam B.O": "533289",
      "Narasimhapuram B.O": "533289",
      "Vedurupaka B.O": "533345",
      "Narasapuram B.O": "533285",
      "Soorampalem B.O": "533285",
      "Jaggampalem B.O": "533285",
      "Kamarajupeta B.O": "533285",
      "Koti B.O": "533290",
      "Raghavapuram B.O": "533290",
      "Veerampalem B.O": "533294",
      "East Gonagudem B.O": "533294",
      "Seethapalli B.O": "533288",
      "Sunnampadu B.O": "533288",
      "Palem B.O": "533288",
      "Kudupuru B.O": "533263",
      "Kapavaram B.O": "533342",
      "Nelaparthipadu B.O": "533262",
      "Ithapudi B.O": "533262",
      "Jagannaiyakulapalem B.O": "533262",
      "Pathatungapadu B.O": "533341",
      "Radheyapalem B.O": "533341",
      "G.Yerrampalem B.O": "533341",
      "Sundarapalli B.O": "533306",
      "Kulla B.O": "533305",
      "Panangipalli B.O": "533305",
      "Satyavada B.O": "533305",
      "Arthamuru B.O": "533340",
      "Ippanapadu B.O": "533340",
      "Palathodu B.O": "533340",
      "Peketipakalu B.O": "533340",
      "Seethanagaram B.O": "533234",
      "Choppella B.O": "533234",
      "Butchampeta B.O": "533292",
      "Vemagiri B.O": "533125",
      "Amudalabanda B.O": "533284",
      "Doramamidi B.O": "533428",
      "Lakkonda B.O": "533284",
      "Tirumalayapalem B.O": "533286",
      "Krishunipalem B.O": "533286",
      "Kanavaram B.O": "533296",
      "Srikrishnapatnam B.O": "533296",
      "Tokada B.O": "533296",
      "Rajavolu B.O": "533124",
      "Jegurupadu B.O": "533126",
      "Veeravaram B.O": "533483",
      "Gummalladoddi B.O": "533289",
      "Munagala B.O": "533289",
      "Mallavaram B.O": "533285",
      "Bhupatipalem B.O": "533285",
      "Molleru B.O": "533285",
      "Bolleddupalem B.O": "533290",
      "Chavadikota B.O": "533295",
      "Chintalapudi B.O": "533295",
      "G.Donthamuru B.O": "533294",
      "Madicherla B.O": "533288",
      "Tatiwada B.O": "533288",
      "Tunnuru B.O": "533288",
      "Hukumpeta B.O": "533107",
      "Raghudevapuram B.O": "533287",
      "Mirthipadu B.O": "533293",
      "Mulakallanka B.O": "533293",
      "Munikodali B.O": "533293",
      "KUTURU B.O.": "533350",
      "MARRIGUDEM B.O.": "533350",
      "LINGAPURAM B.O.": "533350",
      "TUMMILERU B.O.": "533349",
      "Mulastanam B.O": "533233",
      "Jonnada B.O": "533233",
      "Laxminarasapuram B.O": "533342",
      "Vedurumudi B.O": "533307",
      "Vulapalli B.O": "533343",
      "Someswaram B.O": "533261",
      "Modukuru B.O": "533232",
      "Pedapalla B.O": "533232",
      "Penikeru B.O": "533232",
      "Kuyyeru B.O": "533263",
      "Korumilli B.O": "533309",
      "Machara B.O": "533309",
      "Tatapudi B.O": "533309",
      "Nelaturu B.O": "533308",
      "Maredubaka B.O": "533429",
      "Gangavaram B.O": "533305",
      "Vakatippa B.O": "533305",
      "Kurmapuram B.O": "533256",
      "Muchimilli B.O": "533256",
      "Narasapurapupeta B.O": "533256",
      "Tallapolam B.O": "533256",
      "CHODAVARAM B.O.": "533256",
      "KOTHURU B.O.": "533256",
      "Komaripalem B.O": "533346",
      "Tadepalle B.O": "533288",
      "Atchutapuratriam B.O": "533006",
      "Ganganapalli B.O": "533006",
      "Sahapuram B.O": "533462",
      "Gadimoga B.O": "533463",
      "Kolanka B.O": "533450",
      "Yedurulanka B.O": "533464",
      "Kapulapalem B.O": "533464",
      "Neelapalli B.O": "533464",
      "Thungamadugula B.O": "533428",
      "Bhimavaram B.O": "533428",
      "Dhanyampalem B.O": "533428",
      "Beerampalli B.O": "533288",
      "Dorachintalapalem B.O": "533288",
      "Ginnepalli B.O": "533288",
      "Pamugandi B.O": "533288",
      "Pidimgoyya B.O": "533107",
      "Vangalapudi B.O": "533287",
      "APHB Colony B.O": "533106",
      "Devaguptam B.O": "533217",
      "Godilanka B.O": "533217",
      "Bhatnavilli B.O": "533222",
      "Gunnepalli B.O": "533222",
      "Pedagadavilli B.O": "533222",
      "Gangalakurru B.O": "533221",
      "Mogallamori B.O": "533210",
      "Nadavapalli B.O": "533212",
      "Kesanakurru B.O": "533220",
      "Pasuvullanka B.O": "533220",
      "Kamujuvarilanka B.O": "533241",
      "Nedunuru B.O": "533241",
      "Veeravallipelem B.O": "533211",
      "Velavalapalli B.O": "533211",
      "Chinakothalanka B.O": "533216",
      "Gedillanka B.O": "533216",
      "Goditippa B.O": "533217",
      "Munganda B.O": "533214",
      "Annavaram Devasthanam B.O": "533406",
      "N Narendrapatnam B.O": "533406",
      "Repuru B.O": "533006",
      "Pothavaram B.O": "533214",
      "Bheemanapalli B.O": "533222",
      "Cheyyuru B.O": "533222",
      "N.Kothapalli B.O": "533222",
      "Penumalla B.O": "533262",
      "Sakurru B.O": "533221",
      "Indupalli B.O": "533221",
      "Komaragiripatnam B.O": "533210",
      "Bojjavaripeta B.O": "533212",
      "Balusutippa B.O": "533212",
      "Kandikuppa B.O": "533212",
      "Pallam B.O": "533212",
      "Uppudi B.O": "533212",
      "I.Polavaram B.O": "533288",
      "Tillakuppa B.O": "533220",
      "Nallacheruvu B.O": "533241",
      "Vakkalanka B.O": "533241",
      "Ainavalli B.O": "533211",
      "Tottaramudi B.O": "533211",
      "Krapa Chintalapudi B.O": "533216",
      "Annampalli B.O": "533216",
      "Guthulavaripalem B.O": "533217",
      "Samanthakurru B.O": "533217",
      "Turupulanka B.O": "533217",
      "Isukapudi B.O": "533214",
      "Machavaram B.O": "533214",
      "Gollavilli B.O": "533222",
      "Tummalapalli B.O": "533210",
      "Vodalarevu B.O": "533210",
      "Koppigunta B.O": "533212",
      "Mokkalitippa B.O": "533212",
      "Battucheruvu B.O": "533212",
      "Kaikavolu B.O": "533006",
      "Pedapudi B.O": "533006",
      "Katavaram B.O": "533293",
      "PEDARKUR B.O.": "533350",
      "Mahendrawada B.O": "533342",
      "Atchutapuram B.O": "533289",
      "Teki B.O": "533307",
      "Singampalli B.O": "533343",
      "Pulagurtha B.O": "533261",
      "Gummileru B.O": "533232",
      "Pinapalla B.O": "533232",
      "Balantram B.O": "533263",
      "Duggudurru B.O": "533263",
      "Karakuduru B.O": "533006",
      "Rayabhupalapatnam B.O": "533437",
      "Z.Bhavaram B.O": "533462",
      "Kesavapuram B.O": "533463",
      "Penuguduru B.O": "533016",
      "Aratlakatta B.O": "533016",
      "Kovvuru B.O": "533016",
      "Bodlanka B.O": "533428",
      "Vetamamidi B.O": "533428",
      "Yerramreddypalem B.O": "533428",
      "Kota B.O": "533306",
      "Koduru B.O": "533406",
      "Latchireddipalem B.O": "533406",
      "Durgada B.O": "533449",
      "Lampakalova B.O": "533430",
      "Rachapalli B.O": "533430",
      "Irripaka B.O": "533435",
      "Yerravaram B.O": "533435",
      "Govindapuram B.O": "533435",
      "Vazrakutam B.O": "533444",
      "Geddanapalli B.O": "533212",
      "Mukkullu B.O": "533431",
      "Rajavaram B.O": "533235",
      "G Ragampeta B.O": "533437",
      "Gudivada B.O": "533437",
      "Katravulapalli B.O": "533437",
      "Kattamuru B.O": "533437",
      "Marlova B.O": "533437",
      "Viravada B.O": "533450",
      "Masakapalli B.O": "533263",
      "Pekeru B.O": "533263",
      "Hasanbada B.O": "533262",
      "Kunduru B.O": "533262",
      "Venkatayapalem B.O": "533262",
      "Kesavaram B.O": "533341",
      "Valluru B.O": "533308",
      "Amjuru B.O": "533305",
      "Tamarapalli B.O": "533288",
      "Yandagandi B.O": "533305",
      "Konkuduru B.O": "533345",
      "Venturu B.O": "533256",
      "Vedurupakasavaram B.O": "533346",
      "Velagathodu B.O": "533340",
      "Dulla B.O": "533234",
      "Dontikurru B.O": "533212",
      "Gadilanka B.O": "533216",
      "Kothalanka B.O": "533216",
      "Rampa B.O": "533288",
      "Punyakshetram B.O": "533107",
      "Ramachandrapuram B.O": "533287",
      "Pedasankarlapudi B.O": "533432",
      "Badadanampalli B.O": "533436",
      "Pydi Konda B.O": "533401",
      "Kummarilova B.O": "533401",
      "P Vemavaram B.O": "533434",
      "Pedabrahmadevam B.O": "533434",
      "Unduru B.O": "533434",
      "Rayapalli B.O": "533483",
      "Chavitidibbalu B.O": "533483",
      "Durcherthi B.O": "533483",
      "Lingamparthi B.O": "533429",
      "Vakada B.O": "533462",
      "Kandregula B.O": "533462",
      "Chinakondepudi B.O": "533287",
      "Kateru B.O": "533105",
      "CHUCHIREVULAGUDEM B.O.": "533350",
      "P.Mallavaram B.O": "533463",
      "Silalanka B.O": "533463",
      "Nadakuduru B.O": "533016",
      "Siripuram B.O": "533432",
      "G.Moolapalem B.O": "533464",
      "Pillanka B.O": "533464",
      "Pallipalem B.O": "533464",
      "Uppangala B.O": "533464",
      "K Yerragonda B.O": "533428",
      "Yellavaram B.O": "533428",
      "Cheedipalem B.O": "533428",
      "Konalova B.O": "533428",
      "Mohanapuram B.O": "533428",
      "Somannapalem B.O": "533428",
      "Yendapalli B.O": "533447",
      "Tetagunta B.O": "533406",
      "Mandapam B.O": "533406",
      "Kothaperumallapuram B.O": "533449",
      "A V Nagaram B.O": "533449",
      "Uttarakanchi B.O": "533430",
      "Rayavaram B.O": "533445",
      "Bhogapuram B.O": "533445",
      "Gurrampalem B.O": "533435",
      "Talluru B.O": "534315",
      "Rajapudi B.O": "533435",
      "Somavaram B.O": "533435",
      "Chendurti B.O": "533444",
      "Chillangi B.O": "533431",
      "Indugupalli B.O": "533407",
      "Kothakottam B.O": "533407",
      "Chadalada B.O": "533433",
      "Gorinta B.O": "533433",
      "Ramesampeta B.O": "533437",
      "Tamarada B.O": "533437",
      "Marripudi B.O": "533437",
      "Vadlamuru B.O": "533437",
      "KONDRAJUPETA B.O.": "533350",
      "JAGGAVARAM B.O.": "533350",
      "Mukkinada B.O": "533342",
      "Peraramachandrapuram B.O": "533342",
      "Duppalapudi B.O": "533342",
      "Balabhadrapuram B.O": "533343",
      "Matsavaram B.O": "533261",
      "Sandhipudi B.O": "533232",
      "Bhatlapalika B.O": "533263",
      "Jagannadhagiri B.O": "533262",
      "Vegayampeta B.O": "533262",
      "Addampalli B.O": "533262",
      "Sivala B.O": "533262",
      "Z.Medapadu B.O": "533341",
      "Pedaparthi B.O": "533264",
      "Arikarevula B.O": "533256",
      "Vella B.O": "533256",
      "Koppavaram B.O": "533346",
      "F K Palem B.O": "533450",
      "Gorsa B.O": "533450",
      "Lakshminarasapuram B.O": "533450",
      "Chinasankaralapudi B.O": "533432",
      "Yeluru B.O": "533432",
      "Vemavaram B.O": "533401",
      "V K Rayapuram B.O": "533434",
      "Medapadu B.O": "533434",
      "Gurthedu B.O": "533483",
      "Dakodu B.O": "533483",
      "Panasalapalem B.O": "533483",
      "Bhadravaram B.O": "533429",
      "J Annavaram B.O": "533429",
      "Kommanapalli B.O": "533449",
      "A Mallavaram B.O": "533449",
      "Pothuluru B.O": "533430",
      "Tatiparthi B.O": "533445",
      "Kodavali B.O": "533444",
      "Kamatam Mallavaram B.O": "533407",
      "Billananduru B.O": "533407",
      "K E Chinnayyapalem B.O": "533407",
      "Pudipalli B.O": "533339",
      "V.Ramannapalem B.O": "533339",
      "Chinaramanayyapeta B.O": "533339",
      "Choppakonda B.O": "533339",
      "Kalavacherala B.O": "533297",
      "Murari B.O": "533297",
      "Gangampalem B.O": "533286",
      "Rampayerrampalem B.O": "533286",
      "Bommuru B.O": "533124",
      "Kondagunturu B.O": "533124",
      "Pottilanka B.O": "533126",
      "Kolamuru B.O": "533102",
      "Nidigatla B.O": "533102",
      "Palacherla B.O": "533102",
      "Visranthipuram B.O": "533102",
      "Kanupuru B.O": "533289",
      "Srirangapatnam B.O": "533289",
      "Pidathamamidi B.O": "533285",
      "Bayyanapalli B.O": "533285",
      "Kundada B.O": "533295",
      "Chatlawada B.O": "533295",
      "Ramaswamipeta B.O": "533294",
      "Divili B.O": "533433",
      "Goneda B.O": "533437",
      "Kandrakota B.O": "533437",
      "Nayakampalli B.O": "533437",
      "Gokivada B.O": "533450",
      "Virava B.O": "533450",
      "Ammirekula B.O": "533436",
      "Amaravalli B.O": "533448",
      "Hussain Puram B.O": "533434",
      "Chamagadda B.O": "533483",
      "D. Ramavaram  B.O": "533483",
      "Dalipadu B.O": "533483",
      "P Yerragonda B.O": "533483",
      "Pedavadisakarra B.O": "533483",
      "Kimmuru B.O": "533429",
      "Anuru B.O": "533437",
      "Surampalem B.O": "533437",
      "Chandanampalem B.O": "533450",
      "Chitrada B.O": "533450",
      "Isukapalli B.O": "533450",
      "Kondevaram B.O": "533450",
      "Navara B.O": "533450",
      "Pavara B.O": "533450",
      "Mulapeta B.O": "533448",
      "Ponnada B.O": "533448",
      "Peravaram B.O": "533235",
      "Puligogulapadu B.O": "533429",
      "Gontuvanipalem B.O": "533429",
      "Vadisaleru B.O": "533294",
      "Velugubanda B.O": "533294",
      "Marriwada B.O": "533288",
      "Musurumilli B.O": "533288",
      "Akuru B.O": "533288",
      "Bandapalli B.O": "533288",
      "Bolagonda B.O": "533288",
      "Busigudem B.O": "533288",
      "D.Velamakota B.O": "533288",
      "Geddada B.O": "533288",
      "Manturu B.O": "533339",
      "Nandarada B.O": "533292",
      "K.Gopalapuram B.O": "533297",
      "Utla B.O": "533284",
      "B.Velamakota B.O": "533284",
      "Kothada B.O": "533284",
      "Indukuru B.O": "533286",
      "Tantikonda B.O": "533286",
      "Dewancheruvu B.O": "533296",
      "Chakradwarabandham B.O": "533296",
      "Baduguvanilanka B.O": "533126",
      "Kadiyapulanka B.O": "533126",
      "Burrilanka B.O": "533126",
      "Madhurapudi B.O": "533102",
      "Ramadasupeta B.O": "533102",
      "Gadarada B.O": "533289",
      "Foulkspeta B.O": "533285",
      "Itikayalapalli B.O": "533290",
      "Gujjumamidivalasa B.O": "533295",
      "Kutrawada B.O": "533295",
      "Pullangi B.O": "533295",
      "Ramanayyapeta B.O": "533005",
      "Tirumali B.O": "533429",
      "Vanchangi B.O": "533429",
      "Vetukuru B.O": "533295",
      "Pallakadiyam B.O": "533294",
      "Ilakolanu B.O": "533294",
      "Vemulukonda B.O": "533288",
      "Kondamodalu B.O": "534315",
      "Sarpavaram B.O": "533005",
      "Atchampeta B.O": "533005",
      "Valasapakala B.O": "533005",
      "Chintaplli B.O": "533344",
      "Bandanapudi B.O": "533468",
      "Kajuluru B.O": "533468",
      "Manjeru B.O": "533468",
      "Seela B.O": "533468",
      "Thammavaram B.O": "533005",
      "Chollangipeta B.O": "533461",
      "Kumarapriyam B.O": "533344",
      "Peddada B.O": "533344",
      "Pyna B.O": "533344",
      "Vijayarayudupalem B.O": "533468",
      "Vidyanagaram B.O": "533201",
      "Kodurupadu B.O": "533218",
      "Mosalapalli B.O": "533239",
      "Challapalli B.O": "533213",
      "Surasani Yanam B.O": "533213",
      "K.Jagannadhapuram B.O": "533577",
      "Pothukurru B.O": "533577",
      "Velicheru B.O": "533235",
      "Madhavapatnam B.O": "533005",
      "Nemam B.O": "533005",
      "Panasapadu B.O": "533005",
      "Gandredu B.O": "533344",
      "Sampara B.O": "533344",
      "Vendra B.O": "533344",
      "Peddapurappadu B.O": "533468",
      "Tarlampudi B.O": "533468",
      "Yandamuru B.O": "533468",
      "Kamini B.O": "533216",
      "Addalapalem B.O": "533252",
      "Antarvedi Devastanam B.O": "533252",
      "Kesavadasupalem B.O": "533252",
      "Rambagh B.O": "533252",
      "Vasanthavada B.O": "533235",
      "Vaddiparru B.O": "533235",
      "Vutchili B.O": "533235",
      "Krapa B.O": "533216",
      "Somidevarapalem B.O": "533216",
      "Gudala B.O": "533218",
      "Immidivarappadu B.O": "533218",
      "K.Pedapudi B.O": "533239",
      "Vannechintalapudi B.O": "533213",
      "Vilasavilli B.O": "533213",
      "Gopavaram B.O": "533213",
      "Kamanagaruvu B.O": "533213",
      "Saripalli B.O": "533213",
      "Magam B.O": "533577",
      "A.Vemavaram B.O": "533577",
      "Appanaramunilanka B.O": "533252",
      "Pulidindi B.O": "533235",
      "Mondepulanka B.O": "533240",
      "L.Gannavaram B.O": "533240",
      "Yenugupalli B.O": "533240",
      "Panduru B.O": "533005",
      "Thimmaparam B.O": "533005",
      "Patavala B.O": "533461",
      "Aryavatam B.O": "533468",
      "Gorripudi B.O": "533468",
      "Selapaka B.O": "533468",
      "Komanapalli B.O": "533216",
      "Thanelanka B.O": "533216",
      "Rollapalem B.O": "533218",
      "Tandavapalli B.O": "533213",
      "Janupalli B.O": "533577",
      "Antarvedi B.O": "533252",
      "Bobbarlanka B.O": "533235",
      "Kattunga B.O": "533235",
      "Danavaipeta S.O": "533103",
      "Aryapuram S.O": "533104",
      "Devipatnam S.O": "533339",
      "Dosakayapalli S.O": "533292",
      "Fort Gate S.O": "533101",
      "GSL Medical College S.O": "533296",
      "Korukonda S.O": "533289",
      "Kothapalli S.O (East Godavari)": "533285",
      "Rampachodavaram S.O": "533288",
      "Sarangadarametta S.O": "533105",
      "Engg.College S.O": "533003",
      "Bhaskarnagar S.O": "533003",
      "Spinning Mills Centre S.O": "533106",
      "Sriramnagar S.O(Rajahmundry)": "533105",
      "Syamalanagar S.O": "533103",
      "Govt.Gen Hospital S.O": "533001",
      "Mehernagar S.O": "533003",
      "Suryaraopeta S.O": "533001",
      "Addatigala S.O": "533428",
      "Gollaprolu S.O": "533445",
      "Kirlampudi S.O": "533431",
      "Kotananduru S.O": "533407",
      "Mallam S.O (East Godavari)": "533433",
      "Peddapuram Town S.O": "533437",
      "Samalkot Pen Lines S.O": "533440",
      "Sankhavaram S.O": "533446",
      "Tuni S.O": "533401",
      "Vetlapalem S.O": "533434",
      "Y .Ramavaram S.O": "533483",
      "Ambajipeta S.O": "533214",
      "Bendamurlanka S.O": "533210",
      "Bodasakurru S.O": "533215",
      "Kesanakurrupalem S.O": "533220",
      "New Colony S.O (East Godavari)": "533201",
      "Vilasa S.O": "533577",
      "D.Gannavaram S.O": "533240",
      "Ponnamanda S.O": "533248",
      "Ryali S.O": "533236",
      "Anatavaram S.O": "533222",
      "Bandarlanka S.O": "533221",
      "Moberlypeta S.O": "533201",
      "Peruru S.O": "533218",
      "Samanasa S.O": "533213",
      "Mori S.O (East Godavari)": "533250",
      "Ravulapalem S.O": "533238",
      "Tatipaka Bazar S.O": "533249",
      "Amalapuram H.O": "533201",
      "Vullithota S.O": "533101",
      "Adikavi Nannayya University Campus S.O": "533296",
      "KUNAVARAM S.O.": "533350",
      "Angara S.O": "533307",
      "Kutukuluru S.O": "533264",
      "Mandapeta S.O": "533308",
      "Pamarru S.O (East Godavari)": "533305",
      "Tapeswaram S.O": "533340",
      "Velampalem S.O": "533262",
      "Gokaram S.O": "533286",
      "Government College S.O (East Godavari)": "533105",
      "Maredumilli S.O": "533295",
      "Rajanagaram S.O": "533294",
      "Ramakrishna Nagar S.O": "533101",
      "Sithanagaram S.O": "533287",
      "Syamalamba Temple S.O": "533101",
      "Torredu S.O": "533293",
      "Trunk Road Junction S.O": "533105",
      "Weavers Colony S.O": "533105",
      "Ramachandrapuram Old Town S.O": "533256",
      "Rayavaram S.O (East Godavari)": "533346",
      "Alcot Gardens S.O": "533101",
      "Gandepalli S.O": "533297",
      "Gangavaram S.O": "533284",
      "Dowlaiswaram S.O": "533125",
      "Kadiyam S.O": "533126",
      "Satellite City S.O": "533107",
      "V.R. PURAM S.O": "533349",
      "Alamuru S.O (East Godavari)": "533233",
      "Bikkavolu S.O": "533343",
      "Chelluru S.O": "533261",
      "Dangeru S.O": "533263",
      "Draksharamam S.O": "533262",
      "Kotipalli S.O": "533306",
      "Industrial Estate S.O (East Godavari)": "533124",
      "Konthamuru S.O": "533102",
      "Kotikesavaram S.O": "533290",
      "Prakasamnagar S.O": "533106",
      "Rtc Bus Complex Centre S.O": "533103",
      "Anaparthy S.O": "533342",
      "Chintaluru S.O": "533232",
      "Dwarapudi S.O": "533341",
      "Kapileswarapuram S.O (East Godavari)": "533309",
      "Mandapeta Bazar S.O": "533308",
      "Pandalapaka S.O": "533345",
      "Allavaram S.O": "533217",
      "Katrenikona S.O": "533212",
      "Pulletikurru S.O": "533239",
      "Rdo's Office Road S.O": "533201",
      "Atreyapuram S.O": "533235",
      "Lakkavaram S.O (East Godavari)": "533254",
      "Malikipuram S.O": "533253",
      "Nagaram S.O (East Godavari)": "533247",
      "Vubalanka S.O": "533237",
      "Amalapuram Bus Complex S.O": "533201",
      "Gandhi Bazar S.O (East Godavari)": "533201",
      "Mukkamala S.O": "533241",
      "Mukteswaram S.O": "533211",
      "Mummidivaram S.O": "533216",
      "Antarvedipalem S.O": "533252",
      "Gopalapuram S.O (East Godavari)": "533274",
      "Kothapeta S.O (East Godavari)": "533223",
      "Palivela S.O": "533229",
      "Sakhinetipalli S.O": "533251",
      "Sivakodu S.O": "533244",
      "Tatipaka S.O": "533249",
      "Vanapalli S.O": "533228",
      "Jagannaickpur S.O": "533002",
      "Kakinada Bazar S.O": "533001",
      "Karapa S.O": "533462",
      "Tallarevu S.O": "533463",
      "Velangi S.O": "533260",
      "Chebrolu S.O": "533449",
      "Dharamavaram S.O": "533430",
      "Kothapeta (PTP) S.O": "533450",
      "Peddapuram S.O": "533437",
      "Rangampeta S.O": "533291",
      "Samalkot R S S.O": "533440",
      "Thondangi S.O": "533408",
      "Tuni Old Bazar S.O": "533401",
      "Uppada S.O": "533448",
      "Church Square S.O": "533002",
      "Coringa S.O": "533461",
      "G.Mamidada S.O": "533344",
      "Apiic S.O": "533005",
      "APSP Camp S.O (East Godavari)": "533005",
      "Gandhinagar(KKD) S.O": "533004",
      "Samalkot H.O": "533440",
      "Gollapalem S.O": "533468",
      "Indrapalem S.O": "533006",
      "KD collectorate S.O": "533001",
      "Sriramnagar S.O (Kakinada)": "533003",
      "Kathipudi S.O": "533444",
      "Razole H.O": "533242",
      "Kothapalli (U) S.O": "533447",
      "Pithapuram Town S.O": "533450",
      "Rajavommangi S.O": "533436",
      "Yeleswaram S.O": "533429",
      "Yeditha S.O": "533234",
      "Mothugudem S.O": "533347",
      "Rajahmundry H.O": "533101",
      "Ramachandrapuram H.O": "533255",
      "Kakinada H.O": "533001",
      "M S N Charties S.O": "533002",
      "Ramaraopet S.O": "533004",
      "Turangi S.O": "533016",
      "Ammajipeta S.O": "533401",
      "Annavaram S.O": "533406",
      "Jaggampeta S.O": "533435",
      "Pithapuram S.O": "533450",
      "Prathipadu S.O (East Godavari)": "533432",
      "Nellipaka S.O": "533352",
      "Donkarayi S.O": "533348",
      "Thotapalli S.O (Khammam)": "533351"
    },
    "VIZIANAGARAM": {
      "CHILAKAM": "535525",
      "KONDAKINDRAM": "535260",
      "Nemalam B.O": "535126",
      "Gangannapadu B.O": "535124",
      "Kusumuru B.O": "535124",
      "Vadada B.O": "535124",
      "Buradavenkatapuram B.O": "535463",
      "Chinagudaba B.O": "535463",
      "Vallarigudaba B.O": "535463",
      "Vullibhadra B.O": "535463",
      "Elwinpeta B.O": "535523",
      "Manda B.O": "503188",
      "Pedakharja B.O": "535523",
      "Voppangi B.O": "535523",
      "Podi B.O": "535523",
      "Chemuduguda B.O": "535523",
      "Bommika Jagannadhapuram B.O": "535594",
      "Joguladumma B.O": "535594",
      "Tamarakhandi Jammu B.O": "535594",
      "Kemiseela B.O": "535521",
      "Gumada B.O": "535521",
      "Jarna B.O": "535521",
      "Kuneru B.O": "535581",
      "Rajyalakshmipuram B.O": "535521",
      "Tulasivalasa B.O": "535521",
      "Rayagadajammu B.O": "535524",
      "Duddukhallu B.O": "535524",
      "Gavarampeta B.O": "535526",
      "Jumbiri B.O": "535534",
      "DATTIRAJERU S.O": "535582",
      "Amiti B.O": "535523",
      "Goluguvalasa B.O": "535126",
      "Koratam B.O": "535126",
      "Mudidam Ravivalasa B.O": "535124",
      "Nandigam B.O": "535216",
      "Rajeru B.O": "535124",
      "Ravipalli B.O": "535463",
      "Dalaivalasa B.O": "535463",
      "Gottivalasa B.O": "535463",
      "Kothapalli B.O": "535463",
      "Sanyasirajupeta B.O": "535463",
      "Sivvam B.O": "535463",
      "Iridi B.O": "535523",
      "Kedaripuram B.O": "535523",
      "Dummangi B.O": "535523",
      "Gumma B.O": "535523",
      "Tadikonda B.O": "535523",
      "Dangabhadra B.O": "535594",
      "Ramabhadrapuram B.O": "535160",
      "Sikhabadi B.O": "535594",
      "Babbidi B.O": "535521",
      "Janjhavathi Colony B.O": "535521",
      "Kallikota B.O": "535521",
      "Lakshminaiduvalasa B.O": "535521",
      "Madalangi B.O": "535521",
      "Palem B.O": "535521",
      "Pedasakha B.O": "535521",
      "Thodumu B.O": "535521",
      "Chaparayabinnidi B.O": "535524",
      "Dalaipeta B.O": "535524",
      "Kannapudoravalasa B.O": "535526",
      "Parajapadu B.O": "535526",
      "Voosakonda B.O": "505525",
      "Zarada B.O": "535534",
      "Kottuparuva B.O": "535593",
      "Thonam B.O": "535593",
      "Kondadevupalli B.O": "535568",
      "Karada B.O": "535568",
      "Burjavalasa B.O": "535579",
      "Kondakenguva B.O": "535579",
      "Kota Sirlam B.O": "535579",
      "Rompalli B.O": "535579",
      "Bangarampeta B.O": "535591",
      "Purohitunivalasa B.O": "535591",
      "Guruvunaidupeta B.O": "535591",
      "Kothavalasa B.O": "535501",
      "Pedapadam B.O": "535591",
      "KAPUSAMBHAM": "535128",
      "VENDRAM B.O": "535003",
      "Taduru B.O": "535591",
      "Ramavaram B.O": "535215",
      "Appayyapeta B.O": "535546",
      "Koyyannapeta B.O": "535546",
      "Nidagallu B.O": "535546",
      "Garividi B.O": "535101",
      "Devada B.O": "535183",
      "Devunikanapaka B.O": "535101",
      "Locherla B.O": "535126",
      "Velagavalasa B.O": "535126",
      "Kunayavalasa B.O": "535124",
      "Uddavolu B.O": "532122",
      "Lumbesu B.O": "503225",
      "Nandrukona B.O": "503230",
      "Rella B.O": "535523",
      "Lakkaguda B.O": "535523",
      "Puttajammu B.O": "535523",
      "Yegulavada B.O": "535523",
      "Kotipam B.O": "535521",
      "Chollapadam B.O": "535521",
      "Goipaka B.O": "535521",
      "Kottu B.O": "535521",
      "Regidi B.O": "535524",
      "Gotivada B.O": "535524",
      "Kitchada B.O": "535524",
      "Pedamerangi B.O": "535526",
      "Pippalabhadra B.O": "535526",
      "Tumbali B.O": "535526",
      "Gorjipadu B.O": "535534",
      "Thunda B.O": "535547",
      "Kandulapadam B.O": "535593",
      "Mavudi B.O": "535593",
      "Ramalingapuram B.O": "535125",
      "Karlam B.O": "535125",
      "Perapi B.O": "535125",
      "Panasapeddikonavalasa B.O": "535592",
      "Nandabalaga B.O": "535568",
      "Thurumamidi B.O": "535547",
      "Antivalasa B.O": "535521",
      "Dandigam B.O": "535593",
      "Kurukutti B.O": "535593",
      "Maripalli B.O": "535534",
      "Pandiri Mamidivalasa B.O": "535593",
      "Sambara B.O": "535593",
      "Devarapodilam B.O": "535125",
      "Nimmalavalasa B.O": "535125",
      "Karrivalasa B.O": "535592",
      "Padmapuram B.O": "535592",
      "Pinapenki B.O": "535568",
      "Sariki B.O": "535593",
      "Sivili Peddavalasa B.O": "535593",
      "Gollala Mulagam B.O": "535125",
      "Palavalasa B.O": "535220",
      "Gadivalasa B.O": "535592",
      "Kesali B.O": "535592",
      "Akulakatta B.O": "535124",
      "Kotturu B.O": "535463",
      "Marupenta B.O": "535463",
      "Rastakuntubai B.O": "535523",
      "Karivalasa B.O": "535523",
      "Kondavada B.O": "535523",
      "Kukkidi B.O": "535523",
      "Vangara B.O": "535580",
      "Chinageesada B.O": "535521",
      "Gangareguvalasa B.O": "535521",
      "Sivannapeta B.O": "535524",
      "Buddemkharja B.O": "535524",
      "Chintalabelagam B.O": "535526",
      "Sivadavalasa B.O": "535568",
      "Chowdantivalasa B.O": "535579",
      "Duppalapudi B.O": "535579",
      "Itlamamidipalli B.O": "535579",
      "Sompuram B.O": "535579",
      "Tarapuram B.O": "535579",
      "Chinabhogili B.O": "503235",
      "Khasapeta B.O": "535161",
      "Maripivalasa B.O": "535546",
      "Geddapuvalasa B.O": "535101",
      "Ippalavalasa B.O": "535581",
      "Konuru B.O": "535101",
      "Lavidam Agraharam B.O": "535101",
      "Pedabantupalli B.O": "535101",
      "Paradi B.O": "503321",
      "Patharega B.O": "535579",
      "Arikathota B.O": "535579",
      "Mamidivalasa B.O": "535579",
      "Pachalavalasa B.O": "535579",
      "Kharasavalasa B.O": "535591",
      "Panchali B.O": "535591",
      "Viswanadhapuram B.O": "535591",
      "Matumuru B.O": "535591",
      "Mosuru B.O": "535591",
      "Narlavalasa B.O": "535591",
      "Nelliparthi B.O": "535591",
      "Panukuvalasa B.O": "535591",
      "Parannavalasa B.O": "535591",
      "Pedaborabanda B.O": "535591",
      "Burja B.O": "535546",
      "Chakarapalli B.O": "535546",
      "Geddaluppi B.O": "535546",
      "Gutchimi B.O": "535580",
      "Venkatabhyripuram B.O": "535546",
      "Thondrangi B.O": "535101",
      "Chinabantupalli B.O": "535101",
      "Kottakki B.O": "503145",
      "Busayavalasa B.O": "535579",
      "Jannivalasa B.O": "535579",
      "Korapukothavalasa B.O": "535579",
      "Sivarampuram B.O": "535591",
      "Tamarakhandi B.O": "535546",
      "Ajjada B.O": "535546",
      "Krishnarayapuram B.O": "535546",
      "Lakshmipuram Agraharam B.O": "535546",
      "Pedankalam B.O": "535546",
      "Arthamuru B.O": "535101",
      "Dummeda B.O": "535101",
      "Penubarthi B.O": "535101",
      "Galavilli B.O": "532122",
      "Sundarada B.O": "532122",
      "Seetharampuram B.O": "535161",
      "Pynampadu B.O": "531151",
      "Yangada B.O": "531151",
      "Komatipalli B.O": "535559",
      "Kotyada B.O": "535240",
      "Nidigattu B.O": "535240",
      "Katakapalli B.O": "535240",
      "Bantupalli B.O": "535216",
      "Chakivalasa B.O": "535216",
      "Gudepuvalasa B.O": "535216",
      "Regubilli B.O": "535160",
      "Raindram B.O": "535260",
      "Tamatada B.O": "535260",
      "B.Rajeru B.O": "535260",
      "Devupalli B.O": "535260",
      "Uddangi B.O": "535581",
      "Badevalasa": "535581",
      "Pedathadivada B.O": "535006",
      "Gunupur B.O": "535006",
      "Talari B.O": "535148",
      "Vemulapalli B.O": "535148",
      "M Gumudam B.O": "535270",
      "Madhupada B.O": "535148",
      "Marupalli B.O": "535270",
      "Mutcherla B.O": "535270",
      "P P Agraharam B.O": "535270",
      "Budathanapalli B.O": "535215",
      "Korlam B.O": "535215",
      "Lakkidam B.O": "535215",
      "Jonnavalasa B.O": "535004",
      "Pinavemali B.O": "535004",
      "Rakodu B.O": "535004",
      "Dharmapuri B.O": "535004",
      "V B Peta B.O": "535250",
      "V R Palem B.O": "535250",
      "Alugubilli B.O": "535250",
      "Annamurajupeta B.O": "535250",
      "Bheemasinghi B.O": "535250",
      "Pakirkitthali B.O": "535220",
      "Cheepuruvalasa B.O": "535183",
      "Denderu B.O": "535183",
      "Pothampeta B.O": "535183",
      "Rangarayapuram B.O": "535573",
      "T Sanduluru B.O": "535161",
      "Athava B.O": "535161",
      "Dasulapalem B.O": "535161",
      "Melia Kancheru B.O": "535273",
      "Salipeta B.O": "535273",
      "S S R Peta B.O": "535217",
      "Chodavaram B.O": "535217",
      "Gurla B.O": "535217",
      "Tummalapeta B.O": "535217",
      "Chinakada B.O": "535580",
      "Datti Rajeru B.O": "535580",
      "Pedamedapalli B.O": "535580",
      "Vindhyavasi B.O": "535580",
      "Kumili B.O": "535204",
      "Rellivalasa B.O": "535204",
      "Kandivalasa B.O": "535204",
      "Kanimella B.O": "535204",
      "Kg Pathasala B.O": "535204",
      "A T Agraharam B.O": "535218",
      "Seethampeta B.O": "535145",
      "S G Peta B.O": "535145",
      "T B Vara B.O": "535145",
      "Velduru B.O": "535213",
      "N K R Puram B.O": "535281",
      "Kanapaka B.O": "535003",
      "Nelivada B.O": "535003",
      "Gajularega B.O": "535003",
      "Karatam B.O": "535003",
      "Kondakarakam B.O": "535003",
      "Chintalavalasa B.O": "535005",
      "Jonnada B.O": "535005",
      "Malicherala B.O": "535005",
      "Revallapalem B.O": "535160",
      "Seetharamapuram B.O": "535160",
      "Rachakindam B.O": "535260",
      "Jakkuva B.O": "535581",
      "Jayathi B.O": "535581",
      "Bhudevipeta B.O": "535270",
      "Lingalavalasa B.O": "535270",
      "Logisa B.O": "535270",
      "G Ch Penta B.O": "535270",
      "Kenguva B.O": "535270",
      "Vemali B.O": "535270",
      "Narava B.O": "535215",
      "Vasantha B.O": "535215",
      "R B Puram B.O": "535250",
      "Sasanapalli B.O": "535250",
      "Tanavaram B.O": "535250",
      "Bheemali B.O": "535240",
      "Garikavalasa B.O": "535220",
      "Kondagandredu B.O": "535220",
      "Chintalapalem B.O": "531173",
      "Alamanda Sandy B.O": "535240",
      "Ganivada B.O": "535240",
      "Kalagada B.O": "535240",
      "Cheluvuru B.O": "535005",
      "Amatamravivalasa B.O": "535216",
      "Gantlam B.O": "535216",
      "Madanapuram B.O": "535160",
      "Garudabilli B.O": "535260",
      "Konda.Lingalavalasa B.O": "535581",
      "Jammu B.O": "535217",
      "Pinathadivada B.O": "535006",
      "Gopalapalli B.O": "535148",
      "Krishnapuram B.O": "535204",
      "Gollupalem B.O": "535270",
      "Konisa B.O": "535270",
      "S R R Puram B.O": "535270",
      "P.S.R Puram B.O": "535215",
      "Pedavemali B.O": "535215",
      "Neelavathi B.O": "535215",
      "Siripuram B.O": "535215",
      "Jaddetivalasa B.O": "535250",
      "Vizinigiri B.O": "535250",
      "Gudem B.O": "535220",
      "Polipalli B.O": "531162",
      "Kallepalli B.O": "535183",
      "Relli B.O": "535183",
      "Cheedivalasa B.O": "535183",
      "Singarai B.O": "535161",
      "Sompuram Agraharam B.O": "535161",
      "Pittada B.O": "535273",
      "Parasam B.O": "535280",
      "Anandapuram B.O": "535280",
      "Buradapeta B.O": "535280",
      "Damarasingi B.O": "535217",
      "Manyapuripeta B.O": "535217",
      "Kondatamarapalli B.O": "509324",
      "Kothapalem B.O": "535221",
      "Gobhyam B.O": "535580",
      "Ingilapalli Agraharam B.O": "535580",
      "Kompangi B.O": "535580",
      "Komatipalli Agraharam B.O": "535580",
      "S Chintalavalasa B.O": "535580",
      "Kovvada Agraharam B.O": "535204",
      "Sativada B.O": "535218",
      "Tangudubilli B.O": "535218",
      "Tatipudi B.O": "535160",
      "Valluru B.O": "535218",
      "Veeranaraynam B.O": "535145",
      "Konada B.O": "535213",
      "Pasupam B.O": "535213",
      "A S Peta B.O": "535281",
      "Banadi B.O": "535281",
      "Ayyannapeta B.O": "535003",
      "Dwarapudi B.O": "535003",
      "Gedalavani Palem B.O": "535240",
      "Kantakapalli B.O": "535240",
      "Vedullavalasa B.O": "535128",
      "Raghumanda B.O": "535005",
      "Mopada B.O": "535005",
      "Kancheru B.O": "535216",
      "Munjeru B.O": "535216",
      "Akkivaram B.O": "535216",
      "Mukkam B.O": "535216",
      "Savaravilli B.O": "535216",
      "Vasadi B.O": "535160",
      "Kanimeraka B.O": "535260",
      "Khadarnagar B.O": "535002",
      "Munginapalli B.O": "535006",
      "Kottam B.O": "535148",
      "Jinnam Agrharam B.O": "535270",
      "Pathabaggam B.O": "535270",
      "Tummikapalli B.O": "535270",
      "M Kothavalasa B.O": "535270",
      "Pedakada B.O": "535270",
      "Kotarupalli B.O": "535215",
      "Ompalli B.O": "535215",
      "Penasam B.O": "535215",
      "Sarika B.O": "535004",
      "Chinatada B.O": "535250",
      "Pavada B.O": "535250",
      "Jagaram B.O": "535250",
      "Krishnapalli B.O": "535502",
      "Buduruwada B.O": "535527",
      "Dabbagedda B.O": "535527",
      "Dokiseela B.O": "535527",
      "Gochekka B.O": "535527",
      "Ankavaram B.O": "535525",
      "Basangi B.O": "535525",
      "Naguru B.O": "535525",
      "Pedabuddidi B.O": "535525",
      "Sunki Agraharam B.O": "535525",
      "Ravada B.O": "531162",
      "Modavalasa B.O": "531162",
      "Tatavari Kittali B.O": "535220",
      "Gangubudi B.O": "535183",
      "Viyyammapeta B.O": "535183",
      "Bhaligattam B.O": "535183",
      "Uttarapalli B.O": "535183",
      "R G Peta B.O": "535161",
      "Golzam B.O": "535161",
      "Lingampeta B.O": "535161",
      "Andra B.O": "535273",
      "Chintalapeta B.O": "535280",
      "Nadupuru B.O": "535280",
      "Jarajapupeta B.O": "535217",
      "Kondavelagada B.O": "535217",
      "Nagallavalasa B.O": "535217",
      "Vallapuram B.O": "535217",
      "Ginjeru B.O": "535221",
      "Godiyada B.O": "535221",
      "Maradam B.O": "535580",
      "Vijayaramapuram B.O": "535580",
      "Datti B.O": "535580",
      "Pedachamalapalli B.O": "535580",
      "Sarayyavalasa B.O": "535580",
      "Chodamma Agraharam B.O": "535204",
      "Govindapuram B.O": "535204",
      "Gumpam Agraharam B.O": "535204",
      "Perapuram B.O": "535204",
      "Challavanithota B.O": "535204",
      "Alugolu B.O": "535218",
      "Kothapeta B.O": "535218",
      "Gushini B.O": "535218",
      "Gudivada B.O": "535281",
      "Palli Gandredu B.O": "535220",
      "Tettangi B.O": "535220",
      "K R Peta B.O": "535183",
      "Tummukapalli B.O": "535183",
      "V B Puram B.O": "535183",
      "Kummapalli B.O": "535183",
      "Mangalapalem B.O": "535183",
      "Malliveedu B.O": "535161",
      "Kallempudi B.O": "535161",
      "Jammadevipeta B.O": "535161",
      "G T Peta B.O": "535273",
      "Lothugedda B.O": "535273",
      "Kondagumpam B.O": "535280",
      "Mudduru B.O": "535280",
      "Gujjangivalasa B.O": "535217",
      "Kella B.O": "535217",
      "Garida B.O": "535217",
      "Atchutapuram B.O": "535217",
      "Kirthubarthi B.O": "535221",
      "J Gumadam B.O": "535221",
      "Veduruvada B.O": "535221",
      "Kuntinivalasa B.O": "535580",
      "Gadasam B.O": "535580",
      "Poram B.O": "535580",
      "Alladapalem B.O": "535204",
      "Vempadam B.O": "535204",
      "Chintapalli B.O": "535204",
      "Chollangipeta B.O": "535204",
      "Lankapillipalem B.O": "535204",
      "Boppadam B.O": "535218",
      "Ragolu B.O": "535218",
      "Malayada B.O": "535218",
      "Saripalli B.O": "535218",
      "Boddam B.O": "535145",
      "Korukonda B.O": "535214",
      "Dabbirajupeta B.O": "535281",
      "Nallaballi B.O": "535281",
      "Veeluparthi B.O": "535281",
      "Duppada B.O": "535003",
      "Gotlam B.O": "535003",
      "Thotapalem B.O": "535003",
      "M J R Peta B.O": "535218",
      "Pedakandepalli B.O": "535145",
      "Timidi B.O": "535145",
      "K G Budi B.O": "535145",
      "Mallipudi B.O": "535145",
      "Pathivada B.O": "535213",
      "Kopperla B.O": "535213",
      "B S Factory B.O": "535214",
      "M Kothasvalasa B.O": "535214",
      "Vavilapadu B.O": "535281",
      "Ambativalasa B.O": "535003",
      "Gokapeta B.O": "535003",
      "Gunkalam B.O": "535003",
      "Tekkali B.O": "535003",
      "Pedamariki B.O": "535502",
      "Bandaluppi B.O": "535527",
      "Surampeta B.O": "535527",
      "Tallaburidi B.O": "535527",
      "Putturu B.O": "535527",
      "Gunanupuram B.O": "535525",
      "Kudama B.O": "535525",
      "Lakhanapuram B.O": "535525",
      "Arasada B.O": "535557",
      "Dibbaguddivalasa B.O": "535573",
      "Kannampeta B.O": "535573",
      "Latchayyapeta B.O": "535573",
      "Penta B.O": "535573",
      "Kotaseetharampuram B.O": "535559",
      "Subhadra Agraharam B.O": "535559",
      "Billalavalasa B.O": "535128",
      "Bondapalli B.O": "535128",
      "Gulivinda Agraharam B.O": "535128",
      "Bhimavaram B.O": "535578",
      "Koduru B.O": "535578",
      "Mallampeta B.O": "535578",
      "Shikarganj B.O": "535578",
      "Bhupalarajapuram B.O": "535102",
      "Vengapuram Agraharam B.O": "535557",
      "Gangada B.O": "535557",
      "Pedapenki B.O": "535557",
      "Barli B.O": "535559",
      "Bobbili R.S B.O": "535559",
      "Chintada B.O": "535559",
      "Mokhasa Duggivalasa B.O": "535128",
      "Badangi B.O": "535578",
      "Gajarayanavalasa B.O": "535578",
      "Bhyripuram B.O": "535102",
      "Gadelamarrivalasa B.O": "535102",
      "Balagudaba B.O": "535502",
      "Duggi B.O": "535502",
      "Sudigam B.O": "535527",
      "Santhoshapuram B.O": "535525",
      "Turakanaiduvalasa B.O": "535525",
      "Addapuseela B.O": "535502",
      "Philipnagar B.O": "535502",
      "Vikrampuram B.O": "535502",
      "Jamadala B.O": "535527",
      "Donkala Kothapatnam B.O": "535527",
      "Puligummi B.O": "535527",
      "Sirlam B.O": "535527",
      "Gijaba B.O": "535525",
      "Markondaputti B.O": "535547",
      "Thotapalli B.O": "535525",
      "Tumarada B.O": "535557",
      "Ampavalli B.O": "535557",
      "Narayanapuram B.O": "535557",
      "Alajangi B.O": "535573",
      "Church Road Ndt B.O": "535573",
      "Gorle Seetharampuram B.O": "535559",
      "Mirthivalasa B.O": "535559",
      "Ramuduvalasa B.O": "535559",
      "Garugubilli B.O": "535128",
      "Sivaram B.O": "535128",
      "Gottipalli B.O": "535102",
      "Mokhasa Lingalavalasa B.O": "535102",
      "Vootapalli B.O": "535102",
      "Kasipatnam B.O": "535547",
      "Chemudu B.O": "535547",
      "Budarayavalasa B.O": "535102",
      "Saraivalasa B.O": "535547",
      "A.Venkampeta B.O": "535547",
      "Duggeru B.O": "535547",
      "Kaviripalli B.O": "535547",
      "Kondabaridi B.O": "535534",
      "Neelakanthapuram B.O": "535534",
      "Valasaballeru B.O": "535534",
      "Lakshminarayanapuram B.O": "535522",
      "Narsipuram B.O": "535522",
      "Venkampeta B.O": "505187",
      "Dharmalakshmipuram B.O": "535534",
      "Pedagottili B.O": "535534",
      "Sivada B.O": "535534",
      "Tittiri B.O": "535534",
      "Udayapuram B.O": "535534",
      "Mulaga B.O": "535522",
      "Chilakalapalli B.O": "535557",
      "Palagara B.O": "535557",
      "Vantharam B.O": "535557",
      "Rajupeta B.O": "535573",
      "Chitrakota Boddavalasa B.O": "535573",
      "Gollapalli B.O": "535573",
      "Patha Bobbili B.O": "535573",
      "Gadelavalasa B.O": "535559",
      "Janumallavalasa B.O": "535559",
      "Kalavarai Agraharam B.O": "535559",
      "Mettavalasa B.O": "535559",
      "Pakki B.O": "535559",
      "Gotnandi B.O": "535128",
      "Kumaram B.O": "535128",
      "Yadika B.O": "535128",
      "Golladi Agraharam B.O": "535578",
      "Paltheru B.O": "535578",
      "Mugada B.O": "535578",
      "Naidu Valasa B.O": "535578",
      "Pappala Lingalavalasa B.O": "535578",
      "Timiteru Burjavalasa B.O": "505503",
      "Merakamudidam B.O": "535102",
      "Bangaruvalasa B.O": "535547",
      "Chappabutchampeta B.O": "535547",
      "Lakshmipuram B.O": "535547",
      "Gujjuvai B.O": "535534",
      "Vobbangi B.O": "535534",
      "Sangamvalasa B.O": "535522",
      "Kavitibhadra B.O": "535522",
      "Gollalapalem B.O": "532407",
      "Kagam B.O": "532127",
      "Rachagumadam B.O": "532127",
      "Marrivalasa B.O": "532127",
      "Perumali B.O": "532127",
      "Sathamvalasa B.O": "532127",
      "Jagannadhapuram S.O": "535501",
      "Jiyyammavalsa S.O": "535594",
      "Mondemkhallu S.O": "535534",
      "Parvatipuram Town S.O": "535501",
      "Komarada S.O": "535521",
      "Kurupam S.O": "535524",
      "Mrutyunjayarayanagaram S.O": "535522",
      "Pedabondapalli S.O": "535527",
      "Ravivalasa S.O": "535525",
      "Vizianagaram H.O": "535002",
      "Balijipeta S.O": "535557",
      "Garbham S.O": "535102",
      "Mamidipalle S.O": "535593",
      "Salur Fort S.O": "535591",
      "Salur S.O": "535591",
      "Seethanagaram S.O": "535546",
      "Shreeramnagar Ind.Colony S.O": "535101",
      "Uttaravalli S.O": "535124",
      "Donkinavalasa S.O": "535578",
      "Pachipenta S.O": "535592",
      "Piridi S.O": "535568",
      "Parvatipuram Bus Stand S.O": "535502",
      "Dasannapeta S.O": "535002",
      "Denkada S.O": "535006",
      "Apsp Quarters S.O": "535005",
      "Kothapeta S.O (Vizianagaram)": "535002",
      "Mentada S.O": "535273",
      "Pedamajjipalem S.O": "535221",
      "Pedamanapuram S.O": "535580",
      "Ramathirtam S.O": "535218",
      "S Kota S.O": "535145",
      "Singavaram S.O": "535213",
      "Vepada S.O": "535281",
      "Vizianagaram Market S.O": "535001",
      "Merangi S.O": "535526",
      "Dharmavaram S.O": "535148",
      "Industrial Estate S.O (Vizianagaram)": "535004",
      "Jami S.O": "535250",
      "Kothavalasa S.O": "535183",
      "L Kota S.O": "535161",
      "Nellimarla S.O": "535217",
      "Pusapatirega S.O": "535204",
      "Vizianagaram City S.O": "535001",
      "Vizianagaram Collectorate S.O": "535003",
      "Bobbili H.O": "535558",
      "Parvatipuram H.O": "535501",
      "Bobbili Bazar S.O": "535573",
      "Bobbili Govt.Hospital Road S.O": "535559",
      "Makkuva S.O": "535547",
      "Shreeramnagar S.O": "535101",
      "Therlam S.O": "535126",
      "Garugubilli S.O": "535463",
      "Alamanda R S S.O": "535240",
      "Bhogapuram S.O": "535216",
      "Kotagandredu S.O": "535220",
      "Ss Korukonda S.O": "535214",
      "Vizianagaram Court Complex S.O": "535004",
      "Chipurupalle S.O": "535128",
      "Mettapalli S.O": "535125",
      "Ramabhadrapuram S.O": "535579",
      "Gummalakshmipuram S.O": "535523",
      "Bonangi S.O": "535160",
      "Bondapalli S.O": "535260",
      "Challapeta S.O": "535581",
      "Gajapathinagaram S.O": "535270",
      "Gantyada S.O": "535215",
      "Moida S.O": "535280",
      "Vizianagaram Contonment S.O": "535003",
      "Vzm R.S S.O": "535003"
    },
    "CHITTOOR": {
      "Bodevandlapalle B.O": "517194",
      "Nerabailu B.O": "517194",
      "Nadimcherla B.O": "517305",
      "Pasalavandlapalle B.O": "517305",
      "Vallivedu B.O": "517152",
      "Kadirirayacheruvu B.O": "517297",
      "Kotakonda B.O": "517297",
      "Sangasamudram B.O": "517297",
      "Batagundrevaripalle B.O": "517213",
      "Maddipatlavandlapalle B.O": "517213",
      "Moorevandlapalle B.O": "517234",
      "Aramadakalavandlapalle B.O": "517236",
      "Kotagudibanda B.O": "517236",
      "Kaamireddivaripalle B.O": "517234",
      "Kanduru B.O": "517234",
      "Venkatapathy Nagar BO": "517505",
      "Diguvamagham B.O": "517129",
      "Gollapalle B.O": "517620",
      "Madhavaram B.O": "517129",
      "Vengampalle B.O": "517129",
      "Dasarlapalle B.O": "517415",
      "Jambuvaripalle B.O": "517416",
      "K.G. Satram B.O": "517416",
      "Katappagaripalle B.O": "517416",
      "Tenebanda B.O": "517004",
      "Kajoor B.O": "517002",
      "Ramanaidupalle B.O": "517125",
      "Venkatapuram B.O": "517125",
      "Ollur B.O": "517643",
      "Beerakuppam B.O": "517589",
      "Govardhanagiri B.O": "517589",
      "Rajanagaram B.O": "517589",
      "Pudupet B.O": "517590",
      "Veerakaveri Rajapuram B.O": "517590",
      "Agaram B.O": "517587",
      "Inagalur B.O": "517620",
      "Vepanjeri B.O": "517125",
      "Erlampalle B.O": "517130",
      "Kukkalapalle B.O": "517128",
      "Kothapalle KNP B.O": "517131",
      "Puthur B.O": "517131",
      "Gandrajupalle B.O": "517432",
      "Gundagallu B.O": "517432",
      "Moram B.O": "517432",
      "Mannavaram B.O": "517620",
      "Upanishadvihar B.O": "517640",
      "Kaliyambakam B.O": "517586",
      "Peddakanuparthi B.O": "517642",
      "Koppedu B.O": "517587",
      "Vengalathur B.O": "517587",
      "Nandimangalam B.O": "517583",
      "Rachapalem B.O": "517583",
      "Dasukuppam B.O": "517588",
      "Rajagopalapuram B.O": "517588",
      "Sirunambudur B.O": "517588",
      "Ramakrishnapuram B.O": "517571",
      "Thimmarajukandriga B.O": "517571",
      "Challapalem B.O": "517641",
      "Maddiledu B.O": "517641",
      "Ramapuram B.O": "517291",
      "Kancharapalem B.O": "517541",
      "Lingamanaidupalle B.O": "517541",
      "West Varathur B.O": "517541",
      "Kumarabommarajapuram B.O": "517584",
      "Krishnapuram B.O": "517589",
      "Modugulapalem B.O": "517619",
      "Panguru B.O": "517619",
      "Balijapalli B.O": "517561",
      "Kuppam Badur B.O": "517561",
      "Thimmarajupalle B.O": "517561",
      "Komaragunta B.O": "517569",
      "Nallavenganapalli B.O": "517569",
      "Dudhevaripalle B.O": "517194",
      "Kotakadapalle B.O": "517194",
      "Nadimkandriga B.O": "517305",
      "Thippireddigarialle B.O": "517193",
      "Nagarimadugu B.O": "517277",
      "Sakamvaripalle B.O": "517277",
      "Mogarala B.O": "517152",
      "Vedagirivaripalle B.O": "517152",
      "Kalicherla B.O": "517297",
      "Kanumalopalle B.O": "517297",
      "Sarimadugu B.O": "517297",
      "Garnimitta B.O": "517213",
      "Maddulacheruvupalem B.O": "517213",
      "Marella B.O": "517213",
      "Nuthanakalava B.O": "517213",
      "T.Sandravaripalle B.O": "517213",
      "Thuvvapalle B.O": "517236",
      "Guttapalem B.O": "517234",
      "Kalikiri Kothapalle B.O": "517234",
      "Pudichennakesavapuram B.O": "517643",
      "Sadasivapuram B.O": "517643",
      "Adivikodiyambedu B.O": "517589",
      "Bytikodiyambedu B.O": "517589",
      "Bugga Agraharam B.O": "517590",
      "Mangadu Kothur B.O": "517590",
      "Tadukupet B.O": "517590",
      "Venkatapathi Rajuvaripet B.O": "517590",
      "Bheemunicheruvu B.O": "517581",
      "Alapakam B.O": "517591",
      "Cherukuvaripalle B.O": "517113",
      "Reddivaripalle B.O": "517326",
      "Gundluru B.O": "517235",
      "Nawabpet B.O": "517235",
      "Kamavaram Kothapet B.O": "517172",
      "Pulicherla B.O": "517172",
      "Budithavedu B.O": "517237",
      "Marrikuntapalle B.O": "517237",
      "Kalyani Dam B.O": "517102",
      "Mangapuram B.O": "517102",
      "Chittipiralla B.O": "517112",
      "Pothukanuma B.O": "517112",
      "Agraharam B.O": "517280",
      "Ganugachinta B.O": "517214",
      "Jandla B.O": "517214",
      "Mudupulavemula B.O": "517214",
      "Challavaripalle B.O": "517192",
      "Diguvapalem B.O": "517291",
      "Jarravaripalle B.O": "517299",
      "Marripadu B.O": "517299",
      "Chodavaram B.O": "517536",
      "Muchivolu B.O": "517536",
      "Pillamadu B.O": "517536",
      "Katur B.O": "517645",
      "Ragigunta B.O": "517643",
      "Sadasiva Sankarapuram B.O": "517589",
      "Siddirajukandriga B.O": "517589",
      "Iruguvoi B.O": "517590",
      "Kakavedu B.O": "517590",
      "Kavetipuram B.O": "517590",
      "Kothur Venkatapuram B.O": "517590",
      "Aroor B.O": "517591",
      "Chavarambakam B.O": "517591",
      "Damarapakam B.O": "517591",
      "Elakatur B.O": "517591",
      "Empedu B.O": "517620",
      "Urandur B.O": "517640",
      "Kshurikapuram B.O": "517586",
      "Ardhamalaputheri B.O": "517642",
      "Konathaneri B.O": "517642",
      "Pudi B.O": "517642",
      "Thorur B.O": "517583",
      "Kotabailu B.O": "517194",
      "Thatimakulapalle B.O": "517194",
      "Thettupalle B.O": "517194",
      "Udayamanikyam B.O": "517194",
      "Yegavuru B.O": "517194",
      "Yerravaripalem B.O": "517194",
      "Yellutla B.O": "517305",
      "Cheruvumundarapalle B.O": "517193",
      "Rangannagarigadda B.O": "517193",
      "T.Sattevaripalle B.O": "517193",
      "Ayyavaripalle B.O": "517277",
      "Gandaboyanapalle B.O": "517277",
      "Eachaneri B.O": "517129",
      "Gajulapalle B.O": "517129",
      "Manchuru B.O": "517277",
      "Mugalamarrikothapalle B.O": "517277",
      "Pullleticheruvupalle B.O": "517277",
      "Gundlaguttapalle B.O": "517152",
      "Gundlapalle B.O": "517152",
      "Kukkarajupalle B.O": "517297",
      "Papepalle B.O": "517297",
      "Gorantlapalle B.O": "517213",
      "Jangampalle B.O": "517213",
      "Matampalle Agraharam B.O": "517213",
      "Sorakayalapeta B.O": "517213",
      "Devalapalle B.O": "517236",
      "Galivaripalle B.O": "517236",
      "Kalakada Doddipalle B.O": "517236",
      "Kona B.O": "517236",
      "Chintalavaripalli B.O": "517234",
      "Chinthagunta B.O": "517194",
      "Chitticherla B.O": "517194",
      "Peddamandyam B.O": "517297",
      "Siddavaram B.O": "517297",
      "Veligallu B.O": "517297",
      "Kambhamvaripalle B.O": "517213",
      "Kuppamvandlapalle B.O": "517213",
      "Mallarapuvandlapalle B.O": "517213",
      "Vagalla B.O": "517213",
      "Nagaripalle B.O": "517234",
      "Palamanda B.O": "517234",
      "Mathyam B.O": "517129",
      "Pallicheruvu B.O": "517129",
      "Putramaddi B.O": "517129",
      "Sadakuppam B.O": "517129",
      "Sarakallu B.O": "517129",
      "Thumbakuppam B.O": "517416",
      "Mapakshi B.O": "517002",
      "Narigapalle B.O": "517002",
      "Mahadevamangalam B.O": "517125",
      "Mukkalathur B.O": "517125",
      "Nandanuru B.O": "517125",
      "Ilavaripalle B.O": "517130",
      "Polakala B.O": "517130",
      "Pullur B.O": "517130",
      "Yellampalle Santhagate B.O": "517130",
      "Yerrepalle B.O": "517130",
      "Madhavaram IRM B.O": "517128",
      "Mahasamudram B.O": "517128",
      "Periyambadi B.O": "517128",
      "Diguvatadakara B.O": "517131",
      "Thavanampalle B.O": "517131",
      "Uttarabrahmanapalle B.O": "517131",
      "Mallakunta B.O": "517129",
      "Todatara B.O": "517129",
      "Alappalle B.O": "517415",
      "Kadapanatham B.O": "517415",
      "Karidirivaripalle B.O": "517416",
      "Thumba B.O": "517416",
      "T. Savatapalle B.O": "517004",
      "Chennamagudipalle B.O": "517002",
      "Ellamrajupalle B.O": "517125",
      "Velkur B.O": "517125",
      "Govindareddipalle B.O": "517130",
      "Nampalle B.O": "517130",
      "Paipalle B.O": "517131",
      "Patnam B.O": "517131",
      "Kattakindapalle B.O": "517129",
      "Lakkanapalle B.O": "517415",
      "Peddachellaragunta B.O": "517415",
      "Theertham B.O": "517415",
      "Thotakanuma B.O": "517415",
      "Errandlapalle B.O": "517416",
      "Mangalapalle B.O": "517416",
      "Muthukuru B.O": "517416",
      "Nalagampalle B.O": "517416",
      "Thambuganipalle B.O": "517416",
      "Cherlopalle B.O": "517583",
      "Palem B.O": "517234",
      "Regallu B.O": "517234",
      "Suramala B.O": "517643",
      "Kannavaram B.O": "517589",
      "Karani B.O": "517589",
      "Pulikundram B.O": "517589",
      "Aranyam Kandriga B.O": "517581",
      "Kemparapalem B.O": "517581",
      "Palamangalam B.O": "517581",
      "Thumbur B.O": "517581",
      "Venkatakrishnapalem B.O": "517581",
      "Poli B.O": "517620",
      "Vagavedu B.O": "517620",
      "Velampadu B.O": "517620",
      "Yelavedu B.O": "517620",
      "Aravakothur B.O": "517640",
      "Sri Sukabrahmasramam B.O": "517640",
      "Sriharipuram B.O": "517586",
      "Vijayapuram B.O": "517586",
      "Sriramapuram B.O": "517587",
      "Velur B.O": "517587",
      "Chinnarajukuppam B.O": "517583",
      "Surendranagaram B.O": "517583",
      "Govindapalem B.O": "517583",
      "Irugulam B.O": "517588",
      "Kothamarikuppam B.O": "517588",
      "Madanambedu B.O": "517588",
      "Pravalvanneswarapuram B.O": "517588",
      "Karipakam B.O": "517541",
      "Pandur B.O": "517541",
      "Talarivettu B.O": "517541",
      "Kandadu B.O": "517619",
      "Vyasasramam B.O": "517619",
      "Mittakandriga B.O": "517561",
      "Brahmanapalle B.O": "517643",
      "Gudimallam B.O": "517526",
      "Padiri B.O": "517591",
      "Kalavagunta B.O": "517127",
      "Thotambedu B.O": "517640",
      "Jagannathapuram B.O": "517586",
      "Jambada B.O": "517586",
      "Kosalanagaram B.O": "517586",
      "Bhavanisankarapuram B.O": "517642",
      "Poyya B.O": "517642",
      "Arai B.O": "517587",
      "Kotamangapuram B.O": "517587",
      "Nesanur B.O": "517583",
      "Ambakam B.O": "517588",
      "Rasapalem B.O": "517588",
      "Seetharamapuram B.O": "517571",
      "Bokkasampalem B.O": "517641",
      "Kapugunneri B.O": "517641",
      "Pullareddikandriga B.O": "517641",
      "Kadur B.O": "517541",
      "Merlapaka B.O": "517619",
      "Chuttuguntaramapuram B.O": "517561",
      "Kammapalle B.O": "517422",
      "Kuntrapakam B.O": "517561",
      "Nadavalur B.O": "517561",
      "Nethakuppam B.O": "517561",
      "Erramaraju Palle B.O": "517569",
      "Mambedu B.O": "517569",
      "Pallamala B.O": "517645",
      "Annur B.O": "517582",
      "Nochilirajukandriga B.O": "517582",
      "Udamalakudithi B.O": "517582",
      "Kalathur B.O": "517643",
      "M.A.Rajulakandriga B.O": "517643",
      "Perur B.O": "517505",
      "Thondavada B.O": "517505",
      "Athur B.O": "517520",
      "Cotton Mills B.O": "517520",
      "Mamanduru B.O": "517520",
      "S.V.Arts College B.O": "517502",
      "Thummalagunta B.O": "517502",
      "Vemur B.O": "517503",
      "D.N.Choultry B.O": "517501",
      "Alimelumangapuram B.O": "517571",
      "K.M.Agraharam B.O": "517571",
      "Narayanapuram B.O": "517571",
      "Ammapalem B.O": "517641",
      "Bandarupalle B.O": "517641",
      "Chilamathur B.O": "517541",
      "Parameswaramangalam B.O": "517584",
      "Tirumala Kuppam B.O": "517584",
      "Anjimedu B.O": "517619",
      "Chindepalle B.O": "517619",
      "Durgaperi B.O": "517619",
      "Durga Samudram B.O": "517561",
      "Gangireddipalli B.O": "517561",
      "Kannikapuram B.O": "517561",
      "Nennur B.O": "517561",
      "Pathagunta B.O": "517569",
      "Perumallapalle B.O": "517569",
      "Thirumalayapalli B.O": "517569",
      "Pantramanapalle B.O": "517004",
      "Reddigunta B.O": "517002",
      "Peddakalva B.O": "517125",
      "Yetteri B.O": "517125",
      "Ellampalle Kothuru B.O": "517130",
      "Appinapalle B.O": "517432",
      "Belupalle B.O": "517432",
      "Chappidipalle B.O": "517432",
      "Nellipatla B.O": "517432",
      "Mamadugu B.O": "517432",
      "Vedurukuppam B.O": "517569",
      "Chellur B.O": "517526",
      "Karakambadi B.O": "517520",
      "Kothapalem B.O": "517520",
      "Daminadu B.O": "517503",
      "Padi B.O": "517503",
      "Panakam B.O": "517503",
      "Akkarampalli B.O": "517507",
      "Avilalal B.O": "517507",
      "Chiguruvada B.O": "517507",
      "Vootupalle B.O": "517234",
      "Errakotapalle B.O": "517235",
      "Mudiyamvaripalle B.O": "517235",
      "Kavetigaripalle B.O": "517172",
      "Pallavolu B.O": "517237",
      "Dornakambala B.O": "517102",
      "Kotala B.O": "517418",
      "Seshapuram B.O": "517102",
      "Gadanki B.O": "517112",
      "Kasipentla B.O": "517112",
      "Pakala Kothakota B.O": "517112",
      "Peddagorpadu B.O": "517112",
      "Peddaramapuram B.O": "517112",
      "Sankampalle B.O": "517112",
      "Gudarevupalle B.O": "517214",
      "Kondreddigaripalle B.O": "517214",
      "Mellacheruvu B.O": "517214",
      "Palamgadda B.O": "517214",
      "Jangavandlapalle B.O": "517192",
      "Peddagottigallu B.O": "517192",
      "Amilepalle B.O": "517291",
      "Yenugondapalem B.O": "517291",
      "Kuraparthi B.O": "517299",
      "Obulampalle B.O": "517299",
      "Karakollu B.O": "517645",
      "Kukkambakam B.O": "517645",
      "Adavikothuru B.O": "517592",
      "Allamadugu B.O": "517582",
      "Adaram B.O": "517643",
      "Kanchanapalle B.O": "517643",
      "Kumara Venkata Bhupala Puram B.O": "517643",
      "Nayanicheruvupalle B.O": "517237",
      "Ranganathapuram B.O": "517237",
      "T.Sakirevupalle B.O": "517237",
      "Mungilipattu B.O": "517102",
      "Rangampet B.O": "517102",
      "Kalroadpalle B.O": "517112",
      "Maddinayanipalle B.O": "517351",
      "Nendragunta B.O": "517112",
      "Panapakam B.O": "517112",
      "Talupula B.O": "517214",
      "Ustikayalapenta B.O": "517214",
      "Vadlakunta B.O": "517214",
      "Vepulabailu B.O": "517214",
      "Motumallela B.O": "517192",
      "Peddamallela B.O": "517192",
      "T.Rachapalle B.O": "517291",
      "Peddapalavedu B.O": "517645",
      "Santhavelur B.O": "517645",
      "Gundrajukuppam B.O": "517592",
      "Mudipalle B.O": "517592",
      "Satravada B.O": "517592",
      "Chinnadoravarikandriga B.O": "517582",
      "Damodaramaharajapuram B.O": "517582",
      "Kathirapalle B.O": "517582",
      "Kollagunta B.O": "517582",
      "Chittathur B.O": "517643",
      "Valligatla B.O": "517234",
      "Muthukuvaripalle B.O": "517113",
      "V.P.V.Kothapalle B.O": "517113",
      "Thimmapuram B.O": "517235",
      "Desireddigaripalle B.O": "517172",
      "Gadi B.O": "517237",
      "Ayithepalle B.O": "517102",
      "Bhimavaram B.O": "517102",
      "Bopparajupalle B.O": "517102",
      "Buchinaidupalle B.O": "517102",
      "Venuthanapalle B.O": "517112",
      "Bandakindapalle B.O": "517214",
      "Bodumallulavaripalle B.O": "517214",
      "Doddipalle B.O": "517127",
      "Ellamanda B.O": "517214",
      "Marrimakulapalle B.O": "517247",
      "Settivaripalle B.O": "517291",
      "Vittalam B.O": "517299",
      "Chiyyavaram B.O": "517536",
      "Gottipudi B.O": "517536",
      "Kasaram B.O": "517536",
      "Obulayapalle B.O": "517536",
      "Alathur B.O": "517645",
      "Gajulapellur B.O": "517645",
      "Terani B.O": "517592",
      "R.K.V.Bahadurpet B.O": "517582",
      "Vathalur B.O": "517582",
      "G.S.T.Centre B.O": "517644",
      "Adavaram B.O": "517643",
      "Anjuru B.O": "517643",
      "Madibaka B.O": "517526",
      "Munagalapalem B.O": "517526",
      "Ravillavarikandriga B.O": "517526",
      "C.Gollapalle B.O": "517505",
      "Sanambhatla B.O": "517505",
      "Kummarapalle B.O": "517520",
      "Madhavamala B.O": "517520",
      "Thukivakam B.O": "517520",
      "Vedullacheruvu B.O": "517520",
      "Thandlam B.O": "517503",
      "Tirumala North B.O": "517504",
      "Aradigunta B.O": "517247",
      "Malenatham B.O": "517247",
      "Mittachintavaripalle B.O": "517247",
      "Nanasahebpet B.O": "517247",
      "Nekkondi B.O": "517247",
      "Konerukuppam B.O": "517423",
      "Arimanipenta B.O": "517401",
      "Bandarlapalle B.O": "517401",
      "Erraballe B.O": "517352",
      "Thettu B.O": "517352",
      "Nellapalle B.O": "517414",
      "Thurlapalle B.O": "517414",
      "Booragamanda B.O": "517123",
      "Mangalam B.O": "517507",
      "Yeddulavaripalle B.O": "517418",
      "Bairupalle B.O": "517424",
      "Cheldiganipalle B.O": "517424",
      "Chintamakulapalle B.O": "517424",
      "Pudipatla B.O": "517247",
      "Gajulamandyam B.O": "517520",
      "Pillapalem B.O": "517520",
      "S.V.Agricultural College B.O": "517502",
      "Veterinary Science College B.O": "517502",
      "R.T.C.Bus Stand B.O": "517501",
      "A.P.H.B.Colony B.O": "517507",
      "Brahmanapattu B.O": "517551",
      "Padiredu B.O": "517551",
      "Pathiputtur B.O": "517551",
      "S.V.R.Pet B.O": "517551",
      "Srinivasanagar B.O": "517507",
      "Thimminaidupalem B.O": "517507",
      "Applayagunta B.O": "517551",
      "Obularajukandriga B.O": "517551",
      "Pudi R.S. B.O": "517551",
      "Thirumanyam Rajula Kandriga B.O": "517551",
      "Sompalem B.O": "517390",
      "Sompalle B.O": "517390",
      "T.Sowdasamudram B.O": "517390",
      "Tavalam B.O": "517280",
      "Vengamvaripale B.O": "517280",
      "Kandukuru B.O": "517391",
      "Katnagallu B.O": "517391",
      "Katiperi B.O": "517247",
      "Kothakota B.O": "517247",
      "Kudurucheemanapalle B.O": "517247",
      "Magandlapalle B.O": "517247",
      "Sugalimitta B.O": "517247",
      "Nallappareddiyuru B.O": "517423",
      "Peddur B.O": "517423",
      "Sogadaballa B.O": "517423",
      "Konganapalle B.O": "517401",
      "Muddanapalle B.O": "517401",
      "Santhabandapalle B.O": "517401",
      "Gandlapalle B.O": "517123",
      "Reddivaripalle SDM B.O": "517123",
      "Thatiguntapalem B.O": "517123",
      "Musalikunta B.O": "517418",
      "Pachalamarri B.O": "517418",
      "Renumakulapalle B.O": "517418",
      "Mudaramdoddi B.O": "517424",
      "Nernipalle B.O": "517424",
      "Pamuganipalle B.O": "517424",
      "Pulikallu PTM  B.O": "517391",
      "Bhimaganipalle B.O": "517247",
      "Karasanapalle B.O": "517247",
      "Muthukur B.O": "517247",
      "Vanamaladinne B.O": "517247",
      "Karlagatta B.O": "517423",
      "Nadimpalle RBDR B.O": "517423",
      "Naniyala B.O": "517401",
      "Rajupeta B.O": "517401",
      "Satyanarayanapuram B.O": "517507",
      "T.T.D.Press B.O": "517507",
      "Mushtoor B.O": "517280",
      "Nawabkota B.O": "517391",
      "Pattamvandlapalle B.O": "517391",
      "T.Sodam B.O": "517391",
      "Arikela B.O": "517247",
      "Chedalla B.O": "517247",
      "Melamdoddi B.O": "517247",
      "Peddavelagathur B.O": "517247",
      "Punganur Bus Stand B.O": "517247",
      "Yetavakili B.O": "517247",
      "Boyanapalle B.O": "517423",
      "Santhipuram B.O": "517423",
      "Pallikuppam B.O": "517401",
      "Peddur RKPM B.O": "517401",
      "Veeranamala B.O": "517401",
      "Itikanellore B.O": "517414",
      "Gongivaripalle B.O": "517123",
      "Nadigadda B.O": "517123",
      "Gopidinne B.O": "517418",
      "Peddur Reservoir B.O": "517418",
      "Vemareddigaripalle B.O": "517418",
      "Gonamakulapalle B.O": "517424",
      "Kongattam B.O": "517424",
      "Cherukuvaipalle B.O": "517123",
      "Bandrevu B.O": "517418",
      "Kannemadugu B.O": "517418",
      "Danamaiahgarivuru B.O": "517424",
      "Javvanapalle B.O": "517424",
      "Devaragudipalle B.O": "517167",
      "Ksheerasamudram B.O": "517167",
      "Marripalle B.O": "517167",
      "Pullur KTP B.O": "517167",
      "Ripunjirajapuram B.O": "517167",
      "Keeramanda B.O": "517429",
      "Kattmanchi B.O": "517127",
      "Poonepallekandriga B.O": "517127",
      "Sathambakkam B.O": "517127",
      "Vavilthota B.O": "517127",
      "Gudipala B.O": "517132",
      "Kothapalle B.O": "517132",
      "Marakalakuppam B.O": "517132",
      "Naraharipet B.O": "517132",
      "Pengaragunta B.O": "517408",
      "Chinnamreddikandriga B.O": "517126",
      "Gudyanampalle B.O": "517126",
      "Jakkidona B.O": "517126",
      "Tenepalle B.O": "517124",
      "Thalupulapalle B.O": "517124",
      "Madireddipalle B.O": "517422",
      "Vepanapalle B.O": "517422",
      "Badikayalapalle B.O": "517370",
      "Devalacheruvu B.O": "517351",
      "Gollapalle BRK B.O": "517351",
      "Nidigunta B.O": "517432",
      "Pathikonda B.O": "517432",
      "Sivadi B.O": "517432",
      "Arimakulapalle B.O": "517167",
      "Mittoor B.O": "517429",
      "Palamakulapalle B.O": "517429",
      "Chittoor Sugarfactory B.O": "517127",
      "Devalampet B.O": "517167",
      "Nelavoy B.O": "517167",
      "Srirangarajapuram B.O": "517167",
      "Tekumanda B.O": "517429",
      "Chinnaickenpalle B.O": "517127",
      "Muthireval B.O": "517127",
      "Bommasamudram B.O": "517132",
      "Papisettipalle B.O": "517132",
      "Cheelapalle B.O": "517419",
      "Chalamangalam B.O": "517408",
      "Kalagatur B.O": "517408",
      "Mandipetkotur B.O": "517408",
      "Melmai B.O": "517408",
      "Kamachinnayapalle B.O": "517126",
      "Pulikallu B.O": "517126",
      "Baitapalle B.O": "517124",
      "Polavaram B.O": "517124",
      "Vajjireddipalle B.O": "517124",
      "Adilakshmambapuram B.O": "517403",
      "Amudala B.O": "517421",
      "Balaganganapalle B.O": "517421",
      "Matavalam B.O": "517599",
      "Siddarajurangarajukandiga B.O": "517599",
      "Bodaguttapalle B.O": "517422",
      "Kasiralla B.O": "517422",
      "Kotalam B.O": "517422",
      "Madumuru B.O": "517370",
      "Rangasamudram B.O": "517370",
      "Vepurikota B.O": "517351",
      "Mittapalle B.O": "517319",
      "Pathapolu B.O": "517319",
      "Nanjampet B.O": "517257",
      "Nellimanda B.O": "517257",
      "Pandillapalle B.O": "517257",
      "Parikidona B.O": "517257",
      "Patrapalle B.O": "517257",
      "Cheekunatham B.O": "517425",
      "Kangundi B.O": "517425",
      "Krishnadasanapalle B.O": "517425",
      "Lakshmipuram B.O": "517425",
      "Mittapalle KPM B.O": "517425",
      "P.E.S.MEDICAL COLLEGE B.O": "517425",
      "Vizalapuram B.O": "517425",
      "Horsely Hills B.O": "517326",
      "Valasapalle B.O": "517326",
      "Ghattu B.O": "517326",
      "Peddapalem B.O": "517390",
      "Muthukur NRP B.O": "517419",
      "Narasimhapuram B.O": "517419",
      "Pachanapalle B.O": "517419",
      "Thalambedu B.O": "517419",
      "Kallupalle B.O": "517408",
      "Keelapatla B.O": "517408",
      "Kurmai B.O": "517408",
      "L.S.Farm B.O": "517408",
      "Thurupupalle B.O": "517126",
      "Ugranapalle B.O": "517126",
      "Erracheruvupalle B.O": "517124",
      "Kammguttapalle B.O": "517124",
      "Mudigolam B.O": "517124",
      "Palakur B.O": "517124",
      "Naragallu B.O": "517403",
      "Narasimharajapuram B.O": "517421",
      "Pachigunta B.O": "517421",
      "S.S.Konda B.O": "517421",
      "Varathur B.O": "517421",
      "Simharajapuram B.O": "517599",
      "Srikaverirajapuram B.O": "517599",
      "Vanadurgapuram B.O": "517599",
      "Budithireddipalle B.O": "517422",
      "Gollapalle YDM B.O": "517422",
      "Kandriga B.O": "517422",
      "Boochipalle B.O": "517370",
      "Boorlapalle B.O": "517370",
      "Rapurivaripalle B.O": "517370",
      "Balireddigaripalle B.O": "517351",
      "Chokkandlapalle B.O": "517417",
      "Kurizala B.O": "517417",
      "Ramasamudram B.O": "517417",
      "Dadepallerajulur B.O": "517257",
      "Gaddamvaripalle B.O": "517257",
      "Irikipenta B.O": "517257",
      "Bisanatham B.O": "517426",
      "Gudipalle B.O": "517426",
      "Kanamanapalle B.O": "517426",
      "Pogurupalle B.O": "517426",
      "Adavibudugur B.O": "517425",
      "Balla B.O": "517425",
      "Sivaramapuram B.O": "517425",
      "Vasanadu B.O": "517425",
      "Kosuvaripalle B.O": "517350",
      "Matluvaripalle B.O": "517350",
      "Mudivedu B.O": "517350",
      "Angallu B.O": "517326",
      "Appa Rao Street B.O": "517326",
      "Arogyavaram B.O": "517326",
      "Kotevaripalle B.O": "517326",
      "Kotevuru B.O": "517326",
      "Malepadu B.O": "517326",
      "Annagaripalle B.O": "517390",
      "T.Salimamidi B.O": "517370",
      "Thummanamgutta B.O": "517351",
      "Miniki B.O": "517417",
      "Nadimpalle B.O": "517417",
      "Penchupadu B.O": "517417",
      "Gajulavaripalle B.O": "517319",
      "Madanapalle Spinning Mills Gds B.O": "517319",
      "Charala B.O": "517257",
      "Gattuvaripalle B.O": "517257",
      "Kagathi B.O": "517257",
      "Peddaupparapalle B.O": "517257",
      "Somala B.O": "517257",
      "Sanganapalle B.O": "517426",
      "Dasegowniyur B.O": "517425",
      "Noolakunta B.O": "517425",
      "Vendugampalle B.O": "517425",
      "Pitchalvandlapalle B.O": "517350",
      "Basinikonda B.O": "517326",
      "Chandramakulapalle B.O": "517326",
      "Edigapalle B.O": "517326",
      "Ponnutipalem B.O": "517326",
      "Gudupalle B.O": "517390",
      "Kalavapalle B.O": "517390",
      "Mangunta B.O": "517167",
      "Nellaipalle B.O": "517167",
      "Settivanatham B.O": "517167",
      "Veerakanellore B.O": "517167",
      "Gurramkonda Vandlavuru B.O": "517429",
      "Ragimanipenta B.O": "517429",
      "Bandapalle B.O": "517127",
      "Kotrakona B.O": "517127",
      "Chittapara B.O": "517132",
      "Pallur B.O": "517132",
      "Thumminda B.O": "517132",
      "Diguvamasapalle B.O": "517419",
      "Dandapalle B.O": "517408",
      "Maredupalle B.O": "517408",
      "Gangavaram B.O": "517408",
      "Panjani B.O": "517408",
      "Oddepalle B.O": "517126",
      "Samireddipalle B.O": "517126",
      "Akanambattu B.O": "517124",
      "Chinnakalikiri B.O": "517124",
      "Patoor B.O": "517124",
      "Avalkonda B.O": "517421",
      "Kothavenkatapuram B.O": "517421",
      "Deenabandupuram B.O": "517599",
      "Palasamudram B.O": "517599",
      "Keenatipalle B.O": "517422",
      "Beerangi B.O": "517370",
      "Mallela B.O": "517370",
      "Obireddipalle B.O": "517370",
      "Sampathikota B.O": "517370",
      "Nariganipalle B.O": "517417",
      "Kothavaripalle B.O": "517319",
      "Kondamarri B.O": "517257",
      "Mekalachinnepalle B.O": "517257",
      "Peddayellakunta B.O": "517257",
      "Suraiahgaripalle B.O": "517257",
      "Sonnarasanapalle B.O": "517426",
      "Dandikuppam B.O": "517425",
      "Gudlanayanipalle B.O": "517425",
      "Kamathamur B.O": "517425",
      "Mallan R.S. B.O": "517425",
      "Peddabangarunatham B.O": "517425",
      "Singasamudram B.O": "517425",
      "Bayappagaripalle B.O": "517326",
      "Cheekalabailu B.O": "517326",
      "Neerugattuvaripalle B.O": "517326",
      "Rachavetivaripalle B.O": "517326",
      "Vempalle B.O": "517326",
      "Kadirinathunikota B.O": "517390",
      "Mulakalacheruvu B.O": "517390",
      "Satyavedu S.O": "517588",
      "Kapilateertham Road S.O": "517501",
      "Kattakindavenkatapuram S.O": "517561",
      "Pachikapallam S.O": "517569",
      "R.S.Gardens S.O": "517507",
      "Renigunta S.O": "517520",
      "S.V.Medical College S.O": "517507",
      "S.V.Nagar S.O": "517502",
      "Tiruchanoor Road S.O": "517501",
      "Puttur South S.O": "517583",
      "Madanapalle H.O": "517325",
      "Varadaiahpalem S.O": "517541",
      "Yerpedu S.O": "517619",
      "Srikalahasti H.O": "517644",
      "Tirupati H.O": "517501",
      "Perumallapalle S.O": "517505",
      "Settipalli S.O": "517506",
      "Tiruchanoor S.O": "517503",
      "Tirumala S.O (Chittoor)": "517504",
      "Tirupati North S.O": "517507",
      "S.P.Medical College for women SVIMS": "517507",
      "Chandragiri H.O": "517101",
      "Puttur S.O": "517583",
      "Bhavani Nagar S.O": "517501",
      "Jagannathapuram S.O": "517501",
      "Korlagunta S.O": "517501",
      "S.V.University S.O": "517502",
      "Tirupati Bazar S.O": "517501",
      "Tirupati East S.O": "517501",
      "Sri Bommarajapuram S.O": "517571",
      "Srikalahasti North S.O": "517644",
      "Chittoor H.O": "517001",
      "Chittoor Bazar S.O": "517001",
      "Ctr Court Buildings S.O": "517001",
      "Pathapeta palamaner S.O": "517408",
      "Penumur S.O": "517126",
      "Prasanth Nagar S.O (Chittoor)": "517128",
      "Readspet S.O": "517001",
      "Burakayalakota S.O": "517351",
      "Mulakalacheruvu R.S. S.O": "517390",
      "Iruvaram S.O": "517128",
      "Kanipakam S.O": "517131",
      "Narasingarayanipettah S.O": "517419",
      "Palamaner S.O": "517408",
      "Thugundram S.O": "517421",
      "Beerangi Kothakota S.O": "517370",
      "Chinnatippasamudram S.O": "517319",
      "Chowdepalle S.O": "517257",
      "Madanapalle Society Colony S.O": "517325",
      "Peddatippasamudram S.O": "517391",
      "Rallabudugur S.O": "517423",
      "Sodam S.O": "517123",
      "Rishivalley S.O": "517352",
      "Royalpet S.O": "517414",
      "Thamballapalle S.O": "517418",
      "Thondamanadu S.O": "517641",
      "Vepagunta S.O (Chittoor)": "517584",
      "Sricity S.E.Z SO": "517646",
      "Papanaidupet S.O": "517526",
      "Tirupati South S.O": "517501",
      "Tirupati West S.O": "517501",
      "Vadamalpet S.O": "517551",
      "Venkatagirikota S.O": "517424",
      "Bangarupalem S.O": "517416",
      "Chittoor North S.O": "517004",
      "Ctr Collectorate S.O": "517002",
      "Ctr Market S.O": "517001",
      "Gangadhara Nellore S.O": "517125",
      "Kolamasanapalle S.O": "517432",
      "Mogili Venkatagiri S.O": "517429",
      "Murukambattu S.O": "517127",
      "Ramapuram S.O (Chittoor)": "517403",
      "Vengalrajukuppam S.O": "517599",
      "Yadamari S.O": "517422",
      "Dravidian University S.O": "517426",
      "Kothapeta Madanapalle S.O": "517325",
      "Kuppam S.O": "517425",
      "Kurabalakota S.O": "517350",
      "Arugonda S.O": "517129",
      "Baireddipalle S.O": "517415",
      "Iral S.O": "517130",
      "Kothapalle S.O": "517167",
      "Lalugardens S.O": "517002",
      "Nangamangalam S.O": "517132",
      "Puthalapattu S.O": "517124",
      "Chembakur S.O": "517417",
      "Madanapalle Bazar S.O": "517326",
      "Nimmanapalle S.O": "517280",
      "Punganur S.O": "517247",
      "Ramakuppam S.O": "517401",
      "Gurramkonda S.O": "517297",
      "Mahal S.O (Chittoor)": "517235",
      "Mangalampet S.O": "517172",
      "Medikurthi S.O": "517237",
      "Kovanur S.O": "517643",
      "Pallam S.O": "517620",
      "Panagal S.O": "517640",
      "Pannur S.O (Chittoor)": "517586",
      "Peddakannali S.O": "517642",
      "Pissatur S.O": "517587",
      "Bhakarapet S.O": "517194",
      "Chinnagottigallu S.O": "517193",
      "Gyarampalle kothapalle S.O": "517213",
      "Kalikiri S.O": "517234",
      "Narasingapuram S.O (Chittoor)": "517102",
      "Tarigonda S.O": "517291",
      "Ekambarakuppam S.O": "517592",
      "Nagalapuram S.O (Chittoor)": "517589",
      "Narayanavaram S.O": "517581",
      "Nindra S.O": "517591",
      "Chandragiri Fort S.O": "517101",
      "Cherlopalle S.O": "517305",
      "Chintaparthi S.O": "517277",
      "Damalacheruvu S.O": "517152",
      "Pakala S.O": "517112",
      "Piler S.O": "517214",
      "Rompicherla S.O (Chittoor)": "517192",
      "Vayalpad S.O": "517299",
      "Buchinaidu Kandriga S.O": "517645",
      "Karvetinagar S.O": "517582",
      "Kalakada S.O": "517236",
      "Kallur S.O (Chittoor)": "517113",
      "Nehru Bazar (Piler) S.O": "517214",
      "Akkurthi S.O": "517536",
      "Kothapet (Srikalahasti) S.O": "517644",
      "Nagari S.O": "517590"
    },
    "SRIKAKULAM": {
      "Pogiri B.O": "532148",
      "Ramachandrapuram Agraharam B.O": "532148",
      "Yenduva B.O": "532148",
      "Keesara B.O": "532455",
      "Ponnuturu B.O": "532457",
      "Bairisingupuram S.O": "532187",
      "Batuva B.O": "535125",
      "Gobburu B.O": "532148",
      "Nandabalaga B.O": "532148",
      "Chettupodilam B.O": "532148",
      "Gedda Kancharam B.O": "532148",
      "Niddam B.O": "532148",
      "Pusam B.O": "532458",
      "Santhakaviti B.O": "532123",
      "Vavilavalasa B.O": "532123",
      "Nayaralavalasa B.O": "532122",
      "Parampeta B.O": "532122",
      "Mamidipalli B.O": "532123",
      "Potrakonda B.O": "532264",
      "Nadumuru B.O": "532263",
      "Bendi B.O": "532220",
      "Kothagraharam B.O": "532220",
      "Tekkalipatnam B.O": "532220",
      "Ganguvada B.O": "532243",
      "Neelavathi B.O": "532243",
      "Bhirlangi B.O": "532312",
      "Koligam B.O": "532312",
      "Mandapalli B.O": "532312",
      "Belagam B.O": "532290",
      "Khajuru B.O": "532290",
      "Pedasrirampuram B.O": "532290",
      "Garudabhadra B.O": "532222",
      "Laxmidevipeta B.O": "532222",
      "Pallisaradhi B.O": "532222",
      "Vajrapukotturu B.O": "532222",
      "Beejiputti B.O": "532322",
      "Kistupuram B.O": "532195",
      "Kurudu B.O": "532195",
      "Santhabommali B.O": "532195",
      "Cheepi B.O": "532242",
      "Killoyicolony B.O": "532242",
      "Kothapalli B.O": "532242",
      "Gonapaputtuga B.O": "532292",
      "Jada B.O": "532148",
      "Boddam B.O": "532148",
      "Chandraiahpeta B.O": "532148",
      "Kusumapuram B.O": "532292",
      "Marripadu B.O": "532455",
      "Mulapeta B.O": "532211",
      "Goppili B.O": "532221",
      "Karajada B.O": "532221",
      "Borubhadra B.O": "532214",
      "Mandarada B.O": "532123",
      "Vasudevapatnam B.O": "532123",
      "Vungarada B.O": "532123",
      "Ambada B.O": "532122",
      "Arasada B.O": "532122",
      "Bhagempeta B.O": "532122",
      "Pedasirlam B.O": "532122",
      "Sarasanapalli B.O": "532122",
      "Talada B.O": "532123",
      "KR Puram BO": "532123",
      "Madduvalasa B.O": "532122",
      "Neelayyavalasa B.O": "532122",
      "Chowkipeta B.O": "532264",
      "Palavalasa B.O": "532264",
      "Uppalam B.O": "532263",
      "Yerramukkam B.O": "532263",
      "Kavitaagraharam B.O": "532220",
      "Pedalaxmipuram B.O": "532216",
      "Kondalogam B.O": "532243",
      "Burjapadu B.O": "532312",
      "Loddaputti B.O": "532312",
      "Purushothapur (IPR) B.O": "532312",
      "Jhadupudi B.O": "532290",
      "Sahalalaputtuga B.O": "532290",
      "Nagarampalli B.O": "532222",
      "Jagathi B.O": "532322",
      "Elamanchili B.O": "532195",
      "Pattupuram B.O": "532195",
      "T.Lingalapadu B.O": "532195",
      "Gudarurajamanipuram B.O": "532242",
      "Rushikudda B.O": "532292",
      "Pedapadmapuram B.O": "532215",
      "Buragam B.O": "532284",
      "Talagam B.O": "532461",
      "Devanaltada B.O": "532211",
      "Hanumanthunaidupeta BO": "532211",
      "Akasalakkavaram BO": "532211",
      "Lotturu BO": "532221",
      "Haridasupuram B.O": "532218",
      "Kanitivooru B.O": "532218",
      "Kurmanadhapuram B.O": "532218",
      "Pedamuraharipuram B.O": "532218",
      "Jinkibhadra B.O": "532284",
      "Sasanam B.O": "532203",
      "Kommusariapalli B.O": "532203",
      "Talatampara B.O": "532292",
      "Kondagudem BO": "532123",
      "Ampolu B.O": "532404",
      "Chinavatsavalasa B.O": "532404",
      "Lingalavalasa B.O": "532123",
      "Vatsavalasa B.O": "532404",
      "Kandisa B.O": "532122",
      "Kodisa B.O": "532443",
      "Tunivada B.O": "532122",
      "Venkampeta B.O": "532122",
      "Bathupuram B.O": "532219",
      "Metturu B.O": "532219",
      "Vonkuluru B.O": "532219",
      "Badupuram B.O": "532264",
      "Bhogapuram B.O": "532264",
      "Turakasasanam B.O": "532264",
      "Budarisingi BO": "532264",
      "Gollagandi B.O": "532263",
      "Venkatapuram B.O": "532407",
      "Bantukotturu B.O": "532220",
      "Amalakudiya BO": "532220",
      "Parasurampuram BO": "532220",
      "Jhadupalli B.O": "532216",
      "Sekharapuram B.O": "532216",
      "Banapuram B.O": "532216",
      "Garudakhandi B.O": "532220",
      "Pedanarayanapuram B.O": "532220",
      "Arakabhadra BO": "532312",
      "Rattakanna B.O": "532312",
      "MUCHINDRA": "532312",
      "Gorlapadu B.O": "532290",
      "Makarampuram B.O": "532290",
      "Gangaram B.O": "532195",
      "Jarjangi B.O": "532195",
      "Kotabomma R.S. B.O": "532195",
      "Sondipudi B.O": "532242",
      "Borivanka B.O": "532292",
      "Isakalapalem B.O": "532292",
      "Dolagovindapuram B.O": "532291",
      "Kesaripada B.O": "532291",
      "Mundala B.O": "532291",
      "Dandugopalapuram B.O": "532212",
      "Dimilada B.O": "532212",
      "Jandapeta B.O": "532212",
      "Ravivalasa B.O": "532212",
      "Meghavaram B.O": "532211",
      "Kedaripuram B.O": "532221",
      "Rentikota B.O": "532221",
      "Tarlakota B.O": "532221",
      "Amalapadu B.O": "532218",
      "Aitam Engg.College B.O": "532203",
      "Chakipalli B.O": "532203",
      "Dimidijola B.O": "532203",
      "Nowgam B.O": "532203",
      "Rangoi B.O": "532243",
      "Suvarnapuram B.O": "532243",
      "Tallabhadra B.O": "532243",
      "Loharibanda BO": "532243",
      "Deppilugonapaputtuga B.O": "532312",
      "Dharmapuram B.O": "532402",
      "Edupuram B.O": "532312",
      "Haripuram B.O": "532312",
      "Karapadu B.O": "532312",
      "Kesupuram B.O": "532312",
      "Peddakojjiria B.O": "532290",
      "Anthrakudda B.O": "532222",
      "Boddapadu B.O": "532222",
      "Chinabadam B.O": "532222",
      "Dokulapadu B.O": "532222",
      "Kapaskudda B.O": "532322",
      "Rajapuram B.O": "532322",
      "Silagam B.O": "532322",
      "Danta B.O": "532195",
      "Kamalanabhapuram B.O": "532195",
      "Kakarapalli B.O": "532195",
      "Siriakhandi B.O": "532215",
      "Vasundhara B.O": "532215",
      "Sarubujjili B.O": "532458",
      "Kambalarayudupeta B.O": "532218",
      "Kondavooru B.O": "532218",
      "Pathatekkali B.O": "532218",
      "Brc Puram B.O": "532284",
      "Jalantrakota B.O": "532284",
      "Narasingupalli B.O": "532203",
      "Parasurampuram B.O": "532203",
      "Deenabhandupuram B.O": "532215",
      "Kerasingi BO": "532215",
      "Poleru B.O": "532291",
      "Sailada B.O": "532212",
      "Kothalingudu B.O": "532211",
      "Lakkivalasa B.O": "532211",
      "Bharanikota BO": "532221",
      "Komaraltada B.O": "532218",
      "Reyyipadu B.O": "532218",
      "Singuru BO": "532218",
      "UG Puram BO": "532218",
      "Palasapuram B.O": "532284",
      "Bhogabeni BO": "532284",
      "Pedalavunipalli B.O": "532203",
      "Siddhantham B.O": "532458",
      "Telikipenta B.O": "532458",
      "Vondrajola B.O": "532458",
      "Govindapuram B.O": "532123",
      "KOTTAPALLI": "532203",
      "LINGALAVALASA": "532203",
      "NARSIPURAM": "532203",
      "Bhagavanpuram BO": "532203",
      "POLAVARAM": "532203",
      "Baddumarri BO": "532203",
      "Mamidivalasa B.O": "532445",
      "Sankili B.O": "532440",
      "Tampatapalli B.O": "532440",
      "Vatapagu B.O": "532440",
      "Voni B.O": "532440",
      "Sambham B.O": "532443",
      "Rajulagumada B.O": "532461",
      "Kottisa B.O": "532461",
      "Gumada B.O": "532460",
      "Kadakella B.O": "532460",
      "Kambara B.O": "532460",
      "Killada B.O": "532460",
      "Narsipuram B.O": "532460",
      "Pedapolla B.O": "532460",
      "Pubbada B.O": "532460",
      "Regulapadu B.O": "532432",
      "Temburu B.O": "532203",
      "GUDEM": "532203",
      "Ayodhyapuram B.O": "532203",
      "VENUGOPALAPURAM": "532203",
      "Seethapuram B.O": "532203",
      "NANDIGAM": "532203",
      "Adavaram B.O": "532440",
      "Kondapuram B.O": "532440",
      "Purli B.O": "532440",
      "Sivvam B.O": "532461",
      "Vangara B.O": "532461",
      "Donubai B.O": "532460",
      "Titukupai B.O": "532460",
      "Vanduva B.O": "532460",
      "Singidi B.O": "532456",
      "Guttavilli B.O": "532445",
      "Javam B.O": "532445",
      "Khandyam B.O": "532445",
      "Neelampeta B.O": "532445",
      "Thotavada B.O": "532445",
      "Annampeta BO": "532445",
      "Thogaram B.O": "532484",
      "Vanjangi B.O": "532484",
      "Lankam BO": "532484",
      "Akulatampara B.O": "532459",
      "Bhagiradhipuram B.O": "532459",
      "Padali B.O": "532459",
      "Peddaseedhi B.O": "532214",
      "Romadala B.O": "532214",
      "KOMMANAPALLI": "532214",
      "Ghanasara B.O": "532455",
      "Gunabhadra B.O": "532455",
      "Haddubangi B.O": "532455",
      "Korama B.O": "532455",
      "Parapuram B.O": "532455",
      "Peddadimili B.O": "532455",
      "Puliputti B.O": "532455",
      "Sirusuvada B.O": "532455",
      "Gurandi B.O": "532459",
      "Loharijola B.O": "532456",
      "Togiri B.O": "532427",
      "Yalamanchili B.O": "532427",
      "Belamam B.O": "532484",
      "Ragolu B.O": "532484",
      "Labba B.O": "532459",
      "Tulagam B.O": "532459",
      "Tungatampara B.O": "532459",
      "Somarajapuram B.O": "532459",
      "Challavanipeta B.O": "532432",
      "Gotivada B.O": "532432",
      "Gonepadu B.O": "532458",
      "Bhamini B.O": "532456",
      "Manumakonda BO": "532456",
      "Bhadri B.O": "532427",
      "Timadam B.O": "532427",
      "Lakkupuram B.O": "532445",
      "Peddapeta BO": "532445",
      "Modallavalasa B.O": "532484",
      "Tadivalasa B.O": "532484",
      "Kommuvalasa B.O": "532459",
      "Kondaragolu B.O": "532459",
      "Karavanja B.O": "532432",
      "Chennaivalasa BO": "532432",
      "Dhanupuram B.O": "532214",
      "Kallata B.O": "532214",
      "Baleru B.O": "532455",
      "Putikavalasa BO": "532455",
      "Chintalabadavanja B.O": "532458",
      "Kadagandi B.O": "532458",
      "Peddakota B.O": "532458",
      "Maniga BO": "532456",
      "Kommanapalli B.O": "532427",
      "Allena B.O": "532445",
      "Labham B.O": "532445",
      "Gudem B.O": "532484",
      "Thotada B.O": "532484",
      "Gulumuru B.O": "532459",
      "Irapadu B.O": "532459",
      "Neradi B.O": "532459",
      "Pedasankili B.O": "532459",
      "Dalemrajuvalasa B.O": "535128",
      "Routhupeta B.O": "535128",
      "Regidi B.O": "532440",
      "Bukkuru B.O": "532440",
      "Gottamangalapuram B.O": "532440",
      "Komiri B.O": "532440",
      "Pedakotipalli B.O": "532440",
      "Gondi B.O": "532443",
      "Kuddapalli B.O": "532443",
      "Kusimi B.O": "532443",
      "Chidimi B.O": "532460",
      "Chittapudivalasa B.O": "532460",
      "Chinakittalapadu B.O": "532214",
      "Dharmalaxmipuram B.O": "532214",
      "Pedalamba B.O": "532214",
      "Chinnabagga B.O": "532455",
      "Somagandi B.O": "532455",
      "Dabbapadu B.O": "532458",
      "Pedasavalapuram B.O": "532458",
      "Aradali B.O": "532440",
      "Pedarama B.O": "532443",
      "Manda B.O": "532443",
      "Pedduru B.O": "532443",
      "Rushingi B.O": "532461",
      "Gadagamma B.O": "532460",
      "Hussainpuram B.O": "532460",
      "Kathulakaviti B.O": "532460",
      "Mokhasarajapuram B.O": "532460",
      "Samarelli B.O": "532460",
      "Tudi B.O": "532460",
      "Maruwada B.O": "535557",
      "Bitiwada B.O": "532462",
      "Talavaram B.O": "532462",
      "Navagam B.O": "532462",
      "Potli B.O": "532462",
      "Singupuram B.O": "532462",
      "Bhasuru B.O": "532440",
      "Devudala B.O": "532440",
      "Jamparakota B.O": "532462",
      "Kinjangi B.O": "535557",
      "Iruwada B.O": "535557",
      "Koppara B.O": "535557",
      "Garraju Chipurupalle B.O": "535128",
      "Yeragam B.O": "532458",
      "Mulasavalapuram BO": "532458",
      "Nagarikatakam B.O": "532428",
      "Jaduru B.O": "532421",
      "Komarti B.O": "532421",
      "Satyavaram B.O": "532421",
      "Shalantri B.O": "532190",
      "Labara B.O": "532213",
      "Tiddimi B.O": "532213",
      "Challayyavalasa B.O": "532429",
      "Dola B.O": "532429",
      "Nimmada B.O": "532430",
      "Karakavalasa B.O": "532428",
      "Devadi B.O": "532421",
      "Talasamudram B.O": "532429",
      "Mabagam B.O": "532421",
      "Makivalasa B.O": "532425",
      "Piruvada B.O": "532421",
      "Karagam BO": "532421",
      "Balada B.O": "532457",
      "Dimili B.O": "532457",
      "Kadumu B.O": "532457",
      "Kurigam B.O": "532457",
      "Alamajipeta B.O": "532190",
      "Chiguruvalasa B.O": "532190",
      "Kondavalasa B.O": "532190",
      "Rottavalasa B.O": "532190",
      "Peddamallipuram B.O": "532213",
      "R.L.Puram B.O": "532213",
      "Sarali B.O": "532213",
      "Seetarampalli B.O": "532213",
      "Amapalam B.O": "532429",
      "Jagannadhapuram B.O": "532430",
      "Koduru B.O": "532430",
      "Gathalavalasa BO": "532430",
      "Malagam BO": "532430",
      "Annupuram B.O": "532426",
      "Burujuvada B.O": "532426",
      "Jamachakram B.O": "532426",
      "Savaraddapanasa B.O": "532426",
      "Nadagam B.O": "532425",
      "B.S.Puram B.O": "532186",
      "Cheemalavalasa B.O": "532186",
      "CHINTHADA": "532186",
      "Koyyam B.O": "532408",
      "Ponnada B.O": "532408",
      "Kothapeta B.O": "532005",
      "Muddada B.O": "532005",
      "Jeerupalem B.O": "532407",
      "Kotapalem B.O": "532407",
      "Kovvadamachilesam B.O": "532407",
      "Ranasthalam B.O": "532407",
      "Tallavalasa B.O": "532407",
      "Allivalasa BO": "532407",
      "Allinagaram B.O": "532403",
      "Budumuru B.O": "532403",
      "Kuppili B.O": "532403",
      "Tamavada B.O": "532403",
      "Palakhandyam B.O": "532168",
      "Thandyam B.O": "532168",
      "Walteru B.O": "532168",
      "METTAVALASA": "532168",
      "Dhavalapeta B.O": "532168",
      "Arjunavalasa B.O": "532409",
      "Devunipalavalasa B.O": "532409",
      "Pathivadapalem B.O": "532409",
      "Sancham B.O": "532409",
      "Aguru B.O": "532127",
      "Agurukancharam B.O": "532127",
      "Anthakapalli B.O": "532127",
      "Bodduru B.O": "532127",
      "Bomminaiduvalasa B.O": "532127",
      "Kanimetta B.O": "532402",
      "Rahimanpuram B.O": "532430",
      "Rana B.O": "532474",
      "Lukulam B.O": "532425",
      "Avalangi B.O": "532462",
      "Sangam B.O": "532462",
      "Tettangi B.O": "532462",
      "Paraselli B.O": "532425",
      "Kalaparthi B.O": "532186",
      "Akkulapeta B.O": "532186",
      "Kasimivalasa B.O": "532186",
      "Ponnam B.O": "532186",
      "Silagam Singuvalasa BO": "532186",
      "Ippili B.O": "532401",
      "Dharmavaram B.O": "532408",
      "Vommaravilli B.O": "532406",
      "Tamminaidupeta BO": "532410",
      "Bhairi B.O": "532405",
      "Tulugu B.O": "532405",
      "Gumadam B.O": "532407",
      "Laveru B.O": "532407",
      "Teppalavalasa B.O": "532407",
      "Bantupalle B.O": "532407",
      "Ajjaram B.O": "532403",
      "Bejjipuram B.O": "532403",
      "Kesavarayunipalem B.O": "532403",
      "Kesavadasupuram BO": "532403",
      "Lakshmipuram BO": "532403",
      "Anandapuram B.O": "532168",
      "Devaravalasa B.O": "532168",
      "Mandavakuriti B.O": "532168",
      "Mirtivalasa B.O": "532168",
      "Siripuram B.O": "532168",
      "Tankaladuggivalasa B.O": "532168",
      "Thungapeta B.O": "532168",
      "Derasam B.O": "532409",
      "Rajam B.O": "532409",
      "Varisam B.O": "532409",
      "Dasariraminaiduvalasa B.O": "532127",
      "Gadimudidam B.O": "532127",
      "Penubaka B.O": "532127",
      "Kinthali B.O": "532402",
      "Kotipalli BO": "532402",
      "Kittalapadu B.O": "532428",
      "Idulavalasa B.O": "532421",
      "Kambakaya B.O": "532421",
      "Madapam B.O": "532421",
      "Peddalogidi B.O": "532213",
      "Deerghasi B.O": "532429",
      "Gollalavalasa B.O": "532429",
      "Belamara B.O": "532430",
      "Runku Hanumanthapuram B.O": "532430",
      "Umilada B.O": "532430",
      "Aludu B.O": "532426",
      "Kodaddapanasa BO": "532426",
      "Peddabammidi B.O": "532474",
      "Tilaru B.O": "532474",
      "Chikkalavalasa B.O": "532425",
      "Alikam B.O": "532186",
      "Korlakota B.O": "532186",
      "Naira B.O": "532186",
      "Tandemvalasa B.O": "532186",
      "Uppinivalasa B.O": "532186",
      "Kistappapeta BO": "532186",
      "Mofusbandar B.O": "532401",
      "Peddapadu B.O": "532401",
      "Sanivada B.O": "532401",
      "D. Matchilesam B.O": "532408",
      "Tonangi B.O": "532406",
      "Fareedpeta B.O": "532410",
      "Korlam B.O": "532405",
      "Thotapalem B.O": "532005",
      "Patharlapalli B.O": "532407",
      "Ravada B.O": "532407",
      "Budatavalasa B.O": "532403",
      "Mahanthipalem B.O": "532403",
      "Buridikancharam B.O": "532168",
      "Chittarupuram B.O": "532168",
      "Urjam B.O": "532429",
      "Dandulaxmipuram B.O": "532430",
      "Harischandrapuram B.O": "532430",
      "Yetturallapadu B.O": "532474",
      "Chinabammidi BO": "532474",
      "Allada B.O": "532425",
      "Andhavaram B.O": "532425",
      "Chodavaram B.O": "532425",
      "Kameswaripeta B.O": "532425",
      "Parlam B.O": "532425",
      "Badam B.O": "532425",
      "Chittivalasa B.O": "532186",
      "Kanugulavalasa B.O": "532186",
      "Opivada Venkampeta B.O": "532186",
      "Turakapeta B.O": "532186",
      "Patrunivalasa B.O": "532401",
      "Vadada B.O": "532401",
      "Bandaruvanipeta B.O": "532406",
      "Buravilli B.O": "532405",
      "Salihundam B.O": "532405",
      "Sathivada B.O": "532405",
      "Adapaka B.O": "532403",
      "Gokarnapalli B.O": "532168",
      "Honjaram B.O": "532168",
      "Laidam B.O": "532168",
      "Lolugu B.O": "532168",
      "Pathakumkam B.O": "532168",
      "Rapaka B.O": "532168",
      "Banam B.O": "532168",
      "Naruva B.O": "532409",
      "Korallavalasa B.O": "532127",
      "Maredubaka B.O": "532127",
      "Nagulavalasa B.O": "532127",
      "Vommi B.O": "532127",
      "Gopalapuram B.O": "532127",
      "Dallavalasa B.O": "532402",
      "Ambakhandi B.O": "532123",
      "Manthina B.O": "532168",
      "Santhavuriti B.O": "532168",
      "Suravam B.O": "532168",
      "Tamaram B.O": "532168",
      "Gorinta B.O": "532168",
      "Maruvada BO": "532409",
      "G.M.R.Nagar B.O": "532127",
      "Guravam B.O": "532127",
      "Tholapi B.O": "532402",
      "Neelanagaram S.O": "532462",
      "Palakonda S.O": "532440",
      "Seethampeta S.O": "532443",
      "Seetharampuram Inam S.O": "532461",
      "Veeraghattam S.O": "532460",
      "Srikakulam H.O": "532001",
      "Kotturu S.O": "532455",
      "P.S.Puram S.O": "532190",
      "Polaki S.O": "532429",
      "Srikakulam Market S.O": "532001",
      "Srikakulam Town S.O": "532001",
      "Brahmanatarla S.O": "532220",
      "Haripuram S.O": "532243",
      "Sompeta S.O": "532284",
      "Venkateswara Colony S.O": "532203",
      "Budithi S.O": "532427",
      "Dusi Rs S.O": "532484",
      "Mukhalingam S.O": "532428",
      "Priyagraharam S.O": "532430",
      "Saravakota S.O": "532426",
      "Urlam S.O": "532425",
      "Calingapatnam S.O": "532406",
      "Gara S.O": "532405",
      "Murapaka S.O": "532403",
      "Ponduru S.O": "532168",
      "Akkupalli S.O": "532219",
      "Chapara S.O": "532216",
      "Ichchapuram Bus Stand S.O": "532312",
      "Ichchapuram S.O": "532312",
      "Kanchili S.O": "532290",
      "Mandasa S.O": "532242",
      "Ms Palli S.O": "532291",
      "Battili S.O": "532456",
      "Burja S.O": "532445",
      "Jalumuru S.O": "532432",
      "Korasavada S.O": "532214",
      "Narasannapeta S.O": "532421",
      "Nivagam S.O": "532457",
      "Tilaru RS S.O": "532474",
      "Vengala Rao Colony S.O": "532186",
      "Etcherla S.O": "532410",
      "J.R.Puram S.O": "532407",
      "Pydibheemavaram S.O": "532409",
      "Hiramandalam S.O": "532459",
      "L.N.Peta S.O": "532458",
      "Narasannapeta Market S.O": "532421",
      "Rajam S.O": "532127",
      "S.R.Puram S.O": "532123",
      "Srikakulam New Colony S.O": "532001",
      "Srikurmam S.O": "532404",
      "Vunukuru S.O": "532122",
      "Amadalavalasa H.O": "532185",
      "Tekkali H.O": "532201",
      "Baruva R S S.O": "532264",
      "Kasibugga S.O (Srikakulam)": "532222",
      "Kaviti S.O": "532322",
      "Manikyapuram S.O": "532292",
      "Meliaputti S.O": "532215",
      "Naupada RS S.O": "532212",
      "Palasa S.O": "532221",
      "Pathapatnam S.O": "532213",
      "Arasavilli S.O": "532401",
      "Bontalakoduru S.O": "532408",
      "Gujarathipeta S.O": "532005",
      "S.M.Puram S.O": "532402",
      "Srikakulam Collectorate S.O": "532001",
      "Srikakulam District Court S.O": "532001",
      "Srikakulam Official Colony S.O": "532001",
      "Srikakulam Zilla Parishad S.O": "532001",
      "Sigadam S.O": "532148",
      "Baruva S.O": "532263",
      "Kotabommali S.O": "532195",
      "Naupada S.O (Srikakulam)": "532211",
      "Pundi R S S.O": "532218"
    },
    "KURNOOL": {
      "Kamalapuri B.O": "518196",
      "Sangapatnam B.O": "518196",
      "Singanapalle B.O": "518196",
      "Sunkesula B.O": "518196",
      "Mandalur B.O": "518543",
      "Mittapalle B.O": "518124",
      "Pathakandukur B.O": "518543",
      "Peddabodanam B.O": "518543",
      "Peddachintakunta B.O": "518543",
      "R.Krishnapuram B.O": "518543",
      "R.Papampalle B.O": "518543",
      "S.Lingam Dinne B.O": "518543",
      "Appalapuram B.O": "518124",
      "Gollagutta B.O": "518124",
      "Kypa B.O": "518124",
      "Yanakandla B.O": "518124",
      "A.Kodur B.O": "518523",
      "B.Kodur B.O": "518523",
      "Bhimavaram B.O": "518523",
      "Pesaravai B.O": "518523",
      "Chinnavangali B.O": "518553",
      "Chintalacheruvu B.O": "518553",
      "Peddavangali B.O": "518553",
      "Srirangapuram B.O": "518583",
      "Guntanala B.O": "518593",
      "Maddur B.O": "518533",
      "Mitnala B.O": "518593",
      "Alamur B.O": "518112",
      "Kotakandukur B.O": "518543",
      "Muthalur B.O": "518543",
      "Padakandla B.O": "518543",
      "Sarvaipalle B.O": "518543",
      "Isvi B.O": "518302",
      "Musanahalli B.O": "518302",
      "Kuruvalli B.O": "518395",
      "Molagavalli B.O": "518395",
      "Peddahothur B.O": "518395",
      "Chigali B.O": "518347",
      "Haligera B.O": "518347",
      "Nagaruru B.O": "518347",
      "Bevinahal B.O": "518348",
      "Gulyam B.O": "518348",
      "Nitravatti B.O": "518348",
      "Katriki B.O": "518333",
      "Sulekeri B.O": "518333",
      "Virupapuram B.O": "518347",
      "Lingadahalli B.O": "518308",
      "Santhekudlur B.O": "518308",
      "Kandanathi B.O": "518350",
      "Badinehal B.O": "518344",
      "Chinnathumbalam B.O": "518313",
      "Duddi B.O": "518313",
      "Chilakaladona B.O": "518345",
      "Pulichinta B.O": "518343",
      "Beldona B.O": "518396",
      "Yeruru B.O": "518396",
      "Chinnahulthi B.O": "518380",
      "Hosuru B.O": "518380",
      "Ratana B.O": "518380",
      "Banavasi B.O": "518323",
      "G.Singavaram B.O": "518004",
      "Krishnagiri B.O": "518124",
      "Lingambodu B.O": "518124",
      "Pathapadu B.O": "518124",
      "Yerragudi B.O": "518166",
      "Erraguntla B.O": "518523",
      "Kakanur B.O": "518523",
      "Parnapalle B.O": "518523",
      "Gotlur B.O": "518553",
      "Ammireddinagar B.O": "518135",
      "Gopavaram B.O": "518583",
      "Kotakonda B.O": "518225",
      "M.Chintakunta B.O": "518674",
      "S.Nagulavaram B.O": "518593",
      "Gunjalapadu B.O": "518134",
      "Joladarasi B.O": "518134",
      "Kampamalla B.O": "518134",
      "Lingala B.O": "518134",
      "Kanakadripalli B.O": "518123",
      "Nandipadu B.O": "518123",
      "Chanugondla B.O": "518464",
      "Vasanthapuram B.O": "518196",
      "Ahobilam B.O": "518543",
      "Bachepalle B.O": "518543",
      "Kondupalle B.O": "518543",
      "Obulampalle B.O": "518543",
      "Katikavanikunta B.O": "518124",
      "Nandavaram B.O": "518124",
      "Tamballapalle B.O": "518124",
      "Tangatur B.O": "518124",
      "Karimaddula B.O": "518523",
      "Godiganur B.O": "518553",
      "Kalugotlapalle B.O": "518553",
      "Chakarajuvemula B.O": "518135",
      "Ramachandrapuram B.O": "518135",
      "Gundampadu B.O": "518583",
      "Mahadevapuram B.O": "518583",
      "Julepalle B.O": "518674",
      "Pasurapadu B.O": "518674",
      "Pusulur B.O": "518593",
      "Harivaram B.O": "518134",
      "Kalugotla B.O": "518217",
      "Kristipadu B.O": "518134",
      "Peddakopperla B.O": "518134",
      "Abdullapuram B.O": "518533",
      "Kalvatala B.O": "518123",
      "Meerjapuram B.O": "518123",
      "Chintakommudinne B.O": "518543",
      "G.Jambuladinne B.O": "518543",
      "Mangampeta B.O": "518124",
      "Meerapuram B.O": "518124",
      "Tellapuri B.O": "518124",
      "Venkatapuram B.O": "518225",
      "Yagantipalle B.O": "518124",
      "Mallavemula B.O": "518553",
      "Muthyalapadu B.O": "518553",
      "Nelampadu B.O": "518553",
      "Kondapuram B.O": "518462",
      "U.Govindinne B.O": "518135",
      "U.Kothapalle B.O": "518135",
      "Beeravolu B.O": "518176",
      "Boyalakuntla B.O": "518583",
      "Chennur B.O": "518583",
      "Gangavaram B.O": "518583",
      "Yellavathula B.O": "518583",
      "Allur B.O": "518432",
      "Bhimunipadu B.O": "518134",
      "Bijanavemula B.O": "518134",
      "Gulladurthi B.O": "518134",
      "Gundupapala B.O": "518134",
      "Pottipadu B.O": "518134",
      "Revanur B.O": "518134",
      "Ankireddypalli B.O": "518123",
      "Chintalayapalli B.O": "518123",
      "Gorivimanipalle B.O": "518123",
      "Itekala B.O": "518123",
      "Dibbanakallu B.O": "518302",
      "G.Hosanahalli B.O": "518302",
      "Devanabanda B.O": "518347",
      "Kamavaram B.O": "518302",
      "Kammarchedu B.O": "518302",
      "Madhire B.O": "518302",
      "Peddathumbalam B.O": "518302",
      "Arikera B.O": "518395",
      "Hattibelagallu B.O": "518395",
      "Marakattu B.O": "518395",
      "Nerniki B.O": "518395",
      "Billekallu B.O": "518347",
      "Chintakunta B.O": "518348",
      "Hardageri B.O": "518348",
      "Medehal B.O": "518348",
      "Chudi B.O": "518333",
      "Nadichagi B.O": "518333",
      "Gajjehalli B.O": "518308",
      "Naganathanahalli B.O": "518308",
      "Vandavagili B.O": "518308",
      "Chinna Pendekallu B.O": "518350",
      "Karumanchi B.O": "518350",
      "Bapuram B.O": "518348",
      "Erigeri B.O": "518344",
      "Kuppagallu B.O": "518344",
      "Upparahal B.O": "518344",
      "Belagallu B.O": "518313",
      "Chirtanakallu B.O": "518313",
      "Om Nagar B.O": "518313",
      "M.Agraharam B.O": "518385",
      "Nancherla B.O": "518385",
      "Chatnihalli B.O": "518345",
      "N.Khairavadi B.O": "518345",
      "Machapuram B.O": "518343",
      "Bantanahalu B.O": "518396",
      "Chippagiri B.O": "518396",
      "Ramadurgam B.O": "518396",
      "Dudekonda B.O": "518380",
      "Jutur B.O": "518401",
      "Putchakayalamada B.O": "518380",
      "Arekallu B.O": "518302",
      "Baichigeri B.O": "518302",
      "Basapuram B.O": "518302",
      "Dhanapuram B.O": "518302",
      "Manekurthi B.O": "518302",
      "Bilehalu B.O": "518395",
      "Chinnahothur B.O": "518395",
      "Ellarthi B.O": "518395",
      "Halebidu B.O": "518395",
      "Muddanageri B.O": "518395",
      "Atikalagundu B.O": "518347",
      "Basarakodu B.O": "518347",
      "Tangaradona B.O": "518347",
      "Siddapuram B.O": "518422",
      "T.Sakibanda B.O": "518348",
      "Chinnahyti B.O": "518346",
      "Honnur B.O": "518346",
      "Kogilathota B.O": "518346",
      "Chinnaharivanam B.O": "518308",
      "Banavanur B.O": "518350",
      "Byluppala B.O": "518350",
      "D. Kotakonda B.O": "518350",
      "Mulagundam B.O": "518350",
      "Dommaladinne B.O": "518344",
      "Hanavolu B.O": "518344",
      "Kuntanahal B.O": "518344",
      "Roudur B.O": "518344",
      "Urukunda B.O": "518344",
      "Arlabanda B.O": "518313",
      "Hampa B.O": "518385",
      "Ibharampuram B.O": "518345",
      "Kalludevakuntla B.O": "518345",
      "Gummanur B.O": "518396",
      "Khajeepuram B.O": "518396",
      "Mallikarjunahalli B.O": "518396",
      "Nagardona B.O": "518396",
      "Buruzula B.O": "518380",
      "Chakkaralla B.O": "518380",
      "Chandoli B.O": "518380",
      "Joharapuram B.O": "518002",
      "Muthukur B.O": "518347",
      "Kaminehal B.O": "518348",
      "Kokkarchedu B.O": "518348",
      "Gudikambali B.O": "518333",
      "Marlamadiki B.O": "518346",
      "Sammatageri B.O": "518346",
      "Harivanam B.O": "518308",
      "Hebbatam B.O": "518308",
      "B.Agraharam B.O": "518350",
      "Jummaladinne B.O": "518313",
      "Kandukuru B.O": "518313",
      "Malapalli B.O": "518313",
      "Vandagallu B.O": "518313",
      "Kanakaveedu B.O": "518343",
      "Pandikona B.O": "518380",
      "Pulikonda B.O": "518380",
      "H.Muravani B.O": "518323",
      "Kapati B.O": "518323",
      "Kothur B.O": "518390",
      "Mekadona B.O": "518323",
      "Pesalabanda B.O": "518323",
      "Aminabad B.O": "518390",
      "Channampalli B.O": "518390",
      "Jonnagiri B.O": "518390",
      "Pagidirai B.O": "518390",
      "Kaggallu B.O": "518349",
      "Jillalla B.O": "518176",
      "Kranthinagar B.O": "518502",
      "Kothapalle B.O": "518502",
      "Kottala B.O": "518502",
      "Mahanandi B.O": "518502",
      "Maseedpuram B.O": "518502",
      "Raithunagaram B.O": "518502",
      "Sivavaram B.O": "518122",
      "Uppalapadu B.O": "518002",
      "Bhupanapadu B.O": "518112",
      "Kavulur B.O": "518112",
      "Sugalithanda B.O": "518112",
      "Vaddugandla B.O": "518112",
      "Peddaventhurla B.O": "518166",
      "R.Lingamdinne B.O": "518166",
      "Chindukur B.O": "518511",
      "Galichennayapalem B.O": "518513",
      "Thudumaladinne B.O": "518155",
      "Doddanakeri B.O": "518323",
      "Doddimekala B.O": "518323",
      "Upparlapalli B.O": "518390",
      "Thollamadugu B.O": "518123",
      "Anupur B.O": "518176",
      "Cheruvupalle B.O": "518176",
      "Mahanandi Cattle Farm B.O": "518502",
      "Pandurangapuram B.O": "518502",
      "Togarchedu B.O": "518216",
      "Kakaravada B.O": "518145",
      "Cherlopalli B.O": "518122",
      "Konededu B.O": "518112",
      "Thammarajupalle B.O": "518112",
      "Giddalur(Kkt) B.O": "518166",
      "Rayamalpuram B.O": "518511",
      "Chandalur B.O": "518594",
      "T.Lingamdinne B.O": "518594",
      "Ramapuram B.O": "518122",
      "Kaminenipalle B.O": "518563",
      "Bollavaram B.O": "518218",
      "Thammadapalle B.O": "518512",
      "R.Jammuladinne B.O": "518155",
      "Suddamalla B.O": "518155",
      "Balavegammanagar B.O": "518573",
      "Jeenepalle B.O": "518573",
      "Petnikota B.O": "518123",
      "Thummalapenta B.O": "518123",
      "S.Kothur B.O": "518176",
      "Ayalur B.O": "518502",
      "Chabolu B.O": "518502",
      "Nandipalle B.O": "518502",
      "Akkampalli B.O": "518145",
      "Chennampalli B.O": "518122",
      "Kondamanayunipalli B.O": "518122",
      "Kunukuntala B.O": "518122",
      "Balapanur B.O": "518112",
      "Panem Bus Stand B.O": "518112",
      "Ramakrishnapuram B.O": "518176",
      "Thimmanayanipeta B.O": "518166",
      "Koratamaddi B.O": "518511",
      "Pulimaddi B.O": "518511",
      "Alavakonda B.O": "518165",
      "Lingapuram B.O": "518513",
      "Singavaram B.O": "518513",
      "Jillella B.O": "518563",
      "Eernapadu B.O": "518512",
      "Peddaemmanur B.O": "518155",
      "Rupanagudi B.O": "518155",
      "Gumparamandinne B.O": "518573",
      "Bathalur B.O": "518510",
      "Erragudidinne B.O": "518510",
      "Palukur B.O": "518176",
      "Ramathirtham B.O": "518176",
      "Billalapuram B.O": "518502",
      "Chalama B.O": "518502",
      "Chapirevula B.O": "518502",
      "Deebaguntla B.O": "518502",
      "Govindapalle B.O": "518502",
      "Udumalpuram B.O": "518502",
      "Santhiram Medical College B.O": "518502",
      "Belum B.O": "518122",
      "Mettupalle B.O": "518122",
      "Ramavaram B.O": "518122",
      "Ramireddipalle B.O": "518166",
      "Durvesi B.O": "518511",
      "Gadigarevula B.O": "518511",
      "Kondajutur B.O": "518511",
      "Chinnakambalur B.O": "518594",
      "Peddakambalur B.O": "518594",
      "Kanala B.O": "518165",
      "Mukkamalla B.O": "518165",
      "Bodemmanur B.O": "518155",
      "Injedu B.O": "518155",
      "Mayalur B.O": "518155",
      "Kotapadu B.O": "518573",
      "M.Krishnapuram B.O": "518573",
      "Rajanagaram B.O": "518573",
      "Veerareddypalle B.O": "518573",
      "Nallagatla B.O": "518510",
      "Kotekallu B.O": "518360",
      "Mugati B.O": "518360",
      "Nagaladinne B.O": "518343",
      "Peddakothali B.O": "518343",
      "Bairluty B.O": "518422",
      "Bhanumukkala B.O": "518422",
      "Dudyala B.O": "518422",
      "Erramattam B.O": "518422",
      "Gokavaram B.O": "518422",
      "Guvvalakunta B.O": "518422",
      "Iskala B.O": "518422",
      "Kothapalli B.O": "518422",
      "Stantanpuram B.O": "518006",
      "Julekallu B.O": "518462",
      "Palukudoddi B.O": "518462",
      "Pudur B.O": "518432",
      "Vaddeman B.O": "518432",
      "Ternekallu B.O": "518465",
      "B.Ramadurgam B.O": "518222",
      "Bogolu B.O": "518222",
      "Chityala B.O": "518222",
      "Ungaralagundla B.O": "518222",
      "Eddupenta B.O": "518222",
      "Pothugal B.O": "518225",
      "Vanala B.O": "518508",
      "Kadumur B.O": "518452",
      "Kethavaram B.O": "518452",
      "Pasupula B.O": "518220",
      "Puricherla B.O": "518452",
      "Rudravaram B.O": "518452",
      "Alavala B.O": "518463",
      "Gudipadu B.O": "518221",
      "Kothakota B.O": "518221",
      "Mallapuram B.O": "518466",
      "Munagala B.O": "518466",
      "Garladinne B.O": "518220",
      "Kommemarri B.O": "518220",
      "Nereducherla B.O": "518220",
      "Kallukunta B.O": "518323",
      "Mantriki B.O": "518323",
      "G.Erragudi B.O": "518390",
      "Madananthapuram B.O": "518390",
      "Peravali B.O": "518390",
      "Jampapuram B.O": "518349",
      "Sathanur B.O": "518349",
      "Sunkeswari B.O": "518349",
      "Vagarur Thimmapuram B.O": "518349",
      "Enigabala B.O": "518360",
      "Govt Live Stock Form B.O": "518360",
      "Gudikal B.O": "518360",
      "Halaharvi B.O": "518360",
      "Venkatagiri B.O": "518464",
      "Nandikunta B.O": "518422",
      "Burandoddi B.O": "518462",
      "Gundrevula B.O": "518462",
      "Inagandla B.O": "518462",
      "Thimmandoddi B.O": "518462",
      "Sitharampuram B.O": "518599",
      "Yembai B.O": "518599",
      "Kandikayapalli B.O": "518206",
      "Alardinne B.O": "518465",
      "Jilledubudakala B.O": "518465",
      "Katarukonda B.O": "518222",
      "Koilakonda B.O": "518222",
      "Kotchervu B.O": "518222",
      "Agaveli B.O": "518225",
      "Chellelichelimala B.O": "518225",
      "Chunchu Erragudi B.O": "518225",
      "Bilakalaguduru B.O": "518508",
      "Talamudipi B.O": "518508",
      "Thudicherla B.O": "518508",
      "Diguvapadu B.O": "518452",
      "Kulumala B.O": "518463",
      "Peddamarriveedu B.O": "518463",
      "Peddanelatur B.O": "518463",
      "Anugonda B.O": "518467",
      "Erradoddi B.O": "518467",
      "Gorantla B.O": "518467",
      "Madhavaram (kurnool)B.O": "518349",
      "Kambaladinne B.O": "518360",
      "Parlapalli B.O": "518360",
      "T.B.P.Colony B.O": "518360",
      "Indireswaram B.O": "518422",
      "Karivena B.O": "518422",
      "M.Lingapuram B.O": "518422",
      "Nallakalva B.O": "518422",
      "Sivapuram B.O": "518422",
      "Kambadahal B.O": "518360",
      "Mudumala B.O": "518462",
      "Pulakurthi B.O": "518462",
      "Muddavaram B.O": "518599",
      "Kollabavapuram B.O": "518432",
      "Bugganipalli B.O": "518206",
      "Karivemula B.O": "518465",
      "Kunkanur B.O": "518465",
      "Pallidoddi B.O": "518465",
      "Yelamakur B.O": "518465",
      "Dharmavaram B.O": "518222",
      "Kamaganikuntla B.O": "518222",
      "Malliyala B.O": "518222",
      "Udumulapadu B.O": "518222",
      "Lakkasagaram B.O": "518225",
      "Korrapolur B.O": "518508",
      "Manchalakatta B.O": "518508",
      "Nandanapalli B.O": "518452",
      "Padidempadu B.O": "518452",
      "Ratsamarri B.O": "518349",
      "Sugur B.O": "518349",
      "Daivamdinne B.O": "518360",
      "Kadimetla B.O": "518360",
      "T.Sallakudlur B.O": "518360",
      "Kurukunda B.O": "518422",
      "Musalimadugu B.O": "518422",
      "Pinnapuram B.O": "518422",
      "Siddepalli B.O": "518422",
      "Vadlaramapuram B.O": "518422",
      "Brahmanadoddi B.O": "518462",
      "Polukallu B.O": "518462",
      "T Samala Gudur B.O": "518462",
      "Kulumalapalli B.O": "518599",
      "Musalayacheruvu B.O": "518599",
      "Damagatla B.O": "518432",
      "Kappatralla B.O": "518465",
      "Khairuppala B.O": "518465",
      "Nelatalamarri B.O": "518465",
      "Nellibanda B.O": "518465",
      "Yatakallu B.O": "518465",
      "Jagadurthi B.O": "518222",
      "Kamalapuram B.O": "518222",
      "Malkapuram B.O": "518222",
      "Sudepalli B.O": "518222",
      "Kambalapadu B.O": "518225",
      "Grandhivemula B.O": "518508",
      "Regadigudur B.O": "518508",
      "Masapeta B.O": "518452",
      "Ganjihalli B.O": "518463",
      "Iranbanda B.O": "518463",
      "B.Tandrapadu B.O": "518007",
      "Remata B.O": "518466",
      "Boyanacheruvupalle B.O": "518220",
      "Utakonda B.O": "518220",
      "A.Gokulapadu B.O": "518467",
      "Amadaguntla B.O": "518467",
      "Biravolu B.O": "518412",
      "Pagidala B.O": "518412",
      "Pullagummi B.O": "518217",
      "S.Boyanapalli B.O": "518217",
      "Sarparajapuram B.O": "518217",
      "L.Polur B.O": "518218",
      "Nayakallu B.O": "518218",
      "Bommireddipalli B.O": "518216",
      "Cherukulapadu B.O": "518216",
      "Kosanapalle B.O": "518216",
      "Vempenta B.O": "518533",
      "Erukalacheruvu B.O": "518225",
      "Errabadu B.O": "518463",
      "G.D.Project B.O": "518463",
      "H.Khairvadi B.O": "518463",
      "Thippanuru B.O": "518463",
      "R.Kanapuram B.O": "518466",
      "Alebad B.O": "518220",
      "Burugula B.O": "518220",
      "Racherla B.O": "518220",
      "Mudamalakurthi B.O": "518464",
      "Pyalakurthi B.O": "518464",
      "Varkur B.O": "518464",
      "Nehru Nagar B.O": "518411",
      "Chintalapalli B.O": "518405",
      "Chowtkur B.O": "518405",
      "Devanur B.O": "518405",
      "Jalakanur B.O": "518405",
      "E.Thandrapadu B.O": "518004",
      "Edururu B.O": "518004",
      "Gondiparla B.O": "518004",
      "Bannuru B.O": "518401",
      "Ganapuram B.O": "518401",
      "N.S.C.Farm B.O": "518401",
      "Sathanikota B.O": "518401",
      "Pendekallu Bus Stand B.O": "518468",
      "T.Sanugondla B.O": "518468",
      "Sankirenipalli B.O": "518412",
      "Krishnapuram B.O": "518217",
      "Balapalapalli B.O": "518598",
      "Kalluru B.O": "518003",
      "Mallepalli B.O": "518216",
      "Banakacherla B.O": "518533",
      "Narayanapauram B.O": "518533",
      "Komarole B.O": "518010",
      "Sekunala B.O": "518010",
      "Laddagiri B.O": "518467",
      "S.Erragudi B.O": "518467",
      "Ulchala B.O": "518467",
      "Meedivemula B.O": "518002",
      "Krishna Puram B.O": "518464",
      "Alaganur B.O": "518405",
      "Veepanagandla B.O": "518405",
      "Mamidalapadu B.O": "518004",
      "Nidjur B.O": "518004",
      "S.R.P.M B.O": "518004",
      "Mandlem B.O": "518401",
      "Tangadancha B.O": "518401",
      "Tarturu B.O": "518401",
      "K.Markapuram B.O": "518467",
      "Bukkapuram B.O": "518002",
      "Dinnedevarapadu B.O": "518002",
      "Bijina Vemula B.O": "518411",
      "R.Konthalapadu B.O": "518004",
      "Tholisapuram B.O": "518004",
      "Parumanchala B.O": "518401",
      "Tummalur B.O": "518401",
      "Kadamakuntla B.O": "518221",
      "Pothidoddi B.O": "518221",
      "Bondimadugula B.O": "518468",
      "Gundlakonda B.O": "518468",
      "Parla B.O": "518467",
      "Salkapuram B.O": "518467",
      "Loddipalli B.O": "518002",
      "Narnur B.O": "518002",
      "Vuyyalawada B.O": "518002",
      "Kurunur B.O": "518464",
      "Mutsumarri B.O": "518411",
      "Cherukucherla B.O": "518405",
      "Rollapadu B.O": "518405",
      "Munagalapadu B.O": "518004",
      "Hussainapuram B.O": "518010",
      "Jakkasanikuntla B.O": "518221",
      "Peddapodilla B.O": "518221",
      "Sebhaspuram B.O": "518221",
      "Vengalampalli B.O": "518221",
      "Edduladoddi B.O": "518468",
      "Panchalingala B.O": "518004",
      "P.Lingapuram B.O": "518401",
      "Malyala B.O": "518401",
      "Tarigopula B.O": "518401",
      "Chelimilla B.O": "518442",
      "Erraguduru B.O": "518442",
      "Mittakandala B.O": "518442",
      "Chandrapalli B.O": "518221",
      "Mettupalli B.O": "518221",
      "N.Rangapuram B.O": "518221",
      "P.R.Palli B.O": "518221",
      "Chinnapodilla B.O": "518221",
      "Devarabanda B.O": "518221",
      "Kalachatla B.O": "518221",
      "Peddapaya B.O": "518221",
      "Yenugumarri B.O": "518221",
      "Marella B.O": "518468",
      "Mukkella B.O": "518468",
      "Gutupalli B.O": "518598",
      "H.Kottala B.O": "518598",
      "R.Kothapalli B.O": "518598",
      "Rahimanpuram B.O": "518598",
      "Chatlamallapuram B.O": "518218",
      "Chinnatekur B.O": "518218",
      "Konganapadu B.O": "518218",
      "N.Venkatapuram B.O": "518216",
      "Talla Gokulapadu B.O": "518216",
      "Boyarevula B.O": "518533",
      "Guntakandala B.O": "518533",
      "Madhavaram B.O": "518533",
      "P.Devalapuram B.O": "518533",
      "Velpanur B.O": "518533",
      "Gani B.O": "518010",
      "Kalva B.O": "518010",
      "Nallachelimala B.O": "518468",
      "Rampalli B.O": "518468",
      "Prathakota east B.O": "518412",
      "Thatipadu B.O": "518412",
      "M.Pendakallu B.O": "518217",
      "Industrial Estate B.O": "518003",
      "Peddapadu B.O": "518003",
      "Bastipadu B.O": "518218",
      "Tadakanapalli B.O": "518218",
      "Amakathadu B.O": "518216",
      "Govardhanagiri B.O": "518216",
      "Lakshminagaram B.O": "518216",
      "Bhojanam B.O": "518533",
      "Mothukuru B.O": "518533",
      "N.Konthalapadu B.O": "518010",
      "Somayajulapalli B.O": "518010",
      "Nandyal H.O": "518501",
      "Kurnool H.O": "518001",
      "Adoni H.O": "518301",
      "Aspari S.O": "518347",
      "Bhar Peta Adoni S.O": "518301",
      "Halaharvi S.O": "518348",
      "Halvi S.O": "518333",
      "Holalagondi S.O": "518346",
      "Ingaladahal S.O": "518308",
      "Adoni Arts College S.O": "518302",
      "Adoni town S.O": "518301",
      "Kadivella S.O": "518350",
      "Kavuthalam S.O": "518344",
      "Alur S.O (Kurnool)": "518395",
      "Kosigi S.O": "518313",
      "Maddikera S.O": "518385",
      "Mantralaya S.O (Kurnool)": "518345",
      "Pattikonda S.O": "518380",
      "Peddakadubur S.O": "518323",
      "Yemmiganur S.O": "518360",
      "Yemmiganur bazar S.O": "518360",
      "Atmakur S.O (Kurnool)": "518422",
      "Bhagya Nagar kurnool S.O": "518004",
      "Brahmanakotkur S.O": "518432",
      "Dhone bazar S.O": "518222",
      "Gadivemula S.O": "518508",
      "Gargeyapuram S.O": "518452",
      "GPRE College S.O": "518007",
      "Knl osmaniacollege S.O": "518001",
      "Kurnool chowk S.O": "518001",
      "N R Peta KNL S.O": "518004",
      "S.S.Dam East S.O": "518102",
      "Sri Krishna Nagar S.O": "518002",
      "Srisailam S.O": "518101",
      "Nemakallu S.O": "518396",
      "Akumalla S.O": "518196",
      "Gajulapalle S.O": "518583",
      "Illuri Kotha Peta S.O": "518186",
      "Industrial Estate S.O (Kurnool)": "518502",
      "M.V. Nagar S.O": "518543",
      "Nandyal Bazar S.O": "518501",
      "Sanjamala S.O": "518165",
      "Tekke S.O": "518501",
      "Thimmapuram S.O": "518512",
      "Banaganapalle S.O": "518124",
      "Banaganapalle South S.O": "518124",
      "Dornipadu S.O": "518135",
      "Gospadu S.O": "518674",
      "Koilakuntla S.O": "518134",
      "Kolimigundla S.O": "518123",
      "Nandyal R.S. S.O": "518502",
      "Noone Palle S.O": "518502",
      "Perusomula S.O": "518166",
      "Polur S.O (Kurnool)": "518511",
      "Rudravaram S.O": "518594",
      "S.K.D.Nagar S.O": "518301",
      "Tungabhadra S.O": "518349",
      "Ashoknagar S.O (Kurnool)": "518005",
      "Balaji Nagar S.O": "518006",
      "Bethamcherla S.O": "518599",
      "Gudur S.O (Kurnool)": "518466",
      "KNL camp B S.O": "518002",
      "Kodumur S.O": "518464",
      "Kurnool Bazar S.O": "518001",
      "M.S.Nagar S.O": "518002",
      "Belagal S.O": "518462",
      "Dhone S.O": "518222",
      "Rangapuram S.O": "518598",
      "Vorvakallu S.O": "518010",
      "Nandavaram S.O": "518343",
      "Tuggali S.O": "518390",
      "Cement Nagar S.O": "518206",
      "Devanakonda S.O": "518465",
      "Jaladurgam S.O": "518220",
      "Konidela S.O": "518411",
      "Kurnool Dt Court S.O": "518001",
      "Gonegandla S.O": "518463",
      "K.N.Puram S.O": "518467",
      "Kurnool Kothapeta S.O": "518004",
      "Midthur S.O": "518405",
      "Nandikotkur S.O": "518401",
      "Nandikotkur bazar S.O": "518401",
      "Pamulapadu S.O": "518442",
      "Peapully S.O": "518221",
      "Pendekallu S.O": "518468",
      "Prathakota S.O": "518412",
      "Veldurthi S.O": "518216",
      "Krishnagiri S.O": "518225",
      "Ulindakonda S.O": "518218",
      "Kurnool Medical College S.O": "518002",
      "Allagadda MDG S.O": "518543",
      "Chagalamarri S.O": "518553",
      "Kanala S.O": "518593",
      "N.G.O.S Colony S.O": "518502",
      "Owk S.O": "518122",
      "Panem S.O": "518112",
      "Srinivasa Nagar S.O": "518501",
      "Uyyalawada S.O": "518155",
      "Bandi Atmakur S.O": "518523",
      "Koilakuntla Bus Stand S.O": "518134",
      "Nandivargam S.O": "518176",
      "Nossam S.O": "518145",
      "Sanjeeva Nagar S.O": "518501",
      "Santajutur S.O": "518513",
      "Sirvel S.O": "518563",
      "Prakash Nagar S.O": "518004",
      "Ramalla Kota S.O": "518217",
      "SAP Camp kNL S.O": "518003",
      "Velgode S.O": "518533",
      "Yallur S.O": "518573",
      "Yerraguntla S.O (Kurnool)": "518510"
    },
    "KRISHNA": {
      "NDC VIJAYAWADA": "521225",
      "Mallela B.O": "509132",
      "Kokilampadu B.O": "521235",
      "Sriniketan B.O": "521235",
      "Kodurupadu B.O": "521110",
      "Remalle B.O": "521110",
      "Keesara BO": "521185",
      "Bokinala B.O": "521260",
      "Siddantham B.O": "521330",
      "Cherukumilli B.O": "521324",
      "Chorampudi B.O": "521324",
      "Komatigunta Lock B.O": "521260",
      "Tarigoppula R.S. B.O": "521260",
      "Krishna University S.O": "521004",
      "Kappaladoddi B.O": "521366",
      "L.K.Gunta B.O": "521366",
      "Lellagaruvu B.O": "521366",
      "Nadupuru B.O": "521366",
      "Konkepudi B.O": "521366",
      "Tenneru B.O": "521260",
      "Jayapuram B.O": "521328",
      "Komallapudi B.O": "521324",
      "Neelipudi B.O": "521324",
      "Kruthivennu SO": "521320",
      "Chandrala B.O": "521230",
      "Serikalavapudi B.O": "521330",
      "Amudalapalli B.O": "521312",
      "Mutcherla B.O": "521366",
      "Nandigama B.O": "521366",
      "Modumudi B.O": "521122",
      "Viswanadhapalli B.O": "521122",
      "Devarakota B.O": "521133",
      "Ghantasalapalem B.O": "521133",
      "Barlapudi B.O": "521136",
      "Eddanapudi B.O": "521136",
      "Kanchakoduru B.O": "521150",
      "Maddipatla B.O": "521150",
      "Turakapalem B.O": "521150",
      "Chinakallepalli B.O": "521132",
      "Korlapadu B.O": "521345",
      "Vempadu B.O": "521260",
      "Nuzella B.O": "521330",
      "Bommuluru B.O": "521105",
      "Krithivennu B.O": "521324",
      "Lakshmipuram B.O": "521235",
      "Malleswaram B.O": "521324",
      "Matlam B.O": "521324",
      "Mulaparru B.O": "521324",
      "Munipeda B.O": "521324",
      "Siddharthanagar B.O": "521202",
      "Polasanipalli B.O": "521111",
      "Jangamgudem B.O": "521111",
      "Papanasanam B.O": "521132",
      "Ullipalem B.O": "521328",
      "Vekanuru B.O": "521122",
      "Vemanda B.O": "521311",
      "Tippanagunta B.O": "521106",
      "Velpucherla B.O": "521207",
      "Mukkollupadu B.O": "521207",
      "Gullapudi B.O": "521403",
      "Lopudi B.O": "521213",
      "Surepalli B.O": "521213",
      "Valasapalli B.O": "521213",
      "Korlamanda B.O": "521214",
      "Kotapadu B.O": "521214",
      "Kudapa B.O": "521215",
      "Ampapuram B.O": "521109",
      "Rolupadu B.O": "521235",
      "Kommireddipalli B.O": "521235",
      "Munukulla B.O": "521235",
      "Suravaram B.O": "521109",
      "Rajagopalapuram B.O": "521110",
      "Rangannagudem B.O": "521110",
      "Umamaheswarapuram B.O": "521110",
      "Veleru B.O": "521110",
      "Galigopuram B.O": "521109",
      "Chintalapadu B.O": "521183",
      "Vamukuntla B.O": "521235",
      "Vavilala B.O": "521235",
      "Vinagadapa B.O": "521403",
      "Tunikipadu B.O": "521401",
      "Vutukuru B.O": "521401",
      "Chiravada B.O": "521109",
      "Maddulaparva B.O": "521215",
      "Narasapuram B.O": "521215",
      "Telladevarapalli B.O": "521215",
      "Veldipadu B.O": "521312",
      "Kothapalli B.O": "521403",
      "Mallavalli B.O": "521111",
      "Mirzapuram B.O": "521111",
      "Pallerlamudi B.O": "521105",
      "Perikeedu Bridge B.O": "521105",
      "Akumarru B.O": "521149",
      "Kankata B.O": "521149",
      "Kosuru B.O": "521150",
      "Mallampalli B.O": "521150",
      "Chitturupu B.O": "521132",
      "Srikakulam B.O": "521132",
      "Swatantrapuram B.O": "521328",
      "Salempalem B.O": "521328",
      "Mangalapuram B.O": "521131",
      "Pedaprolu B.O": "521125",
      "Vemulamada B.O": "521135",
      "Ganapeswaram B.O": "521120",
      "Kammanamoulu B.O": "521120",
      "V.Kothapalem B.O": "521122",
      "Chittiguduru B.O": "521149",
      "Chitturu B.O": "521150",
      "Divigollapalem B.O": "521328",
      "Hamsaladeevi B.O": "521328",
      "Lingareddipalem B.O": "521328",
      "Mandapakala B.O": "521328",
      "Bhogireddipalli B.O": "521131",
      "Daliparru B.O": "521131",
      "Endakuduru B.O": "521131",
      "Ammireddigudem B.O": "521403",
      "Arlapadu B.O": "521403",
      "Erramadu B.O": "521403",
      "Dundiralapadu B.O": "521401",
      "Konijerla B.O": "521401",
      "Lankapalli B.O": "521131",
      "Chiruvolulanka B.O": "521125",
      "K.Kothapalem B.O": "521125",
      "Kokkiligadda B.O": "521125",
      "Nagayatippa B.O": "521125",
      "Dd.Puram B.O": "521120",
      "Edurumondi B.O": "521120",
      "Etimogga B.O": "521120",
      "Nangegadda B.O": "521120",
      "Elakurru B.O": "521156",
      "Mantripalem B.O": "521156",
      "Tallapalem B.O": "521002",
      "Pedayadara B.O": "521003",
      "Polatitippa B.O": "521003",
      "S.N.Gollapalem B.O": "521003",
      "Saradanagar B.O": "521003",
      "Jakkamcherla B.O": "521332",
      "Mukkollu B.O": "521332",
      "Kurada B.O": "521356",
      "Pittalalanka B.O": "521122",
      "Puligadda B.O": "521122",
      "Ramachandrapuram(Divi) B.O": "521122",
      "V.Rudravaram B.O": "521133",
      "Kokanarayanapalem B.O": "521149",
      "Chinamuttevi B.O": "521136",
      "Pedamuttevi B.O": "521136",
      "Tadepalli B.O": "520012",
      "Velivolu B.O": "521132",
      "Chodavaram B.O": "521139",
      "T.Kothapalem B.O": "521120",
      "Talagadadeevi B.O": "521120",
      "P.G.Lanka B.O": "521156",
      "Tarakaturu B.O": "521156",
      "Nimmaluru B.O": "521158",
      "Majeru B.O": "521131",
      "Gudapadu B.O": "521135",
      "Bhavadevarapalli B.O": "521120",
      "Nagayalanka East B.O": "521120",
      "Parrachivara B.O": "521120",
      "Sorlagondhi B.O": "521120",
      "Undrapudi B.O": "521157",
      "Bhatlapenumarru B.O": "521138",
      "Mallavolu B.O": "521162",
      "Rayavaram B.O": "521162",
      "Manginapudi B.O": "521002",
      "Pothepalli B.O": "521002",
      "Gundupalem B.O": "521003",
      "Mpm Fort B.O": "521003",
      "Tummalacheruvu B.O": "521003",
      "Pesaramilli B.O": "521332",
      "Penjendra B.O": "521356",
      "Nagavaram B.O": "521331",
      "Vemavaram B.O": "521190",
      "Arthamuru B.O": "521369",
      "Kakarlamudi B.O": "521369",
      "Akulamannadu B.O": "521366",
      "Palankipadu B.O": "521158",
      "Daggumilli(Z) B.O": "521157",
      "Jujjuvaram B.O": "521157",
      "Kondiparru B.O": "521157",
      "Kurumaddali B.O": "521157",
      "Serinarasannapalem B.O": "521105",
      "Arugolanu B.O": "521106",
      "Kakulapadu B.O": "521106",
      "Puttagunta B.O": "521106",
      "Balive B.O": "521207",
      "Chintalavalli B.O": "521207",
      "Ellapuram B.O": "521207",
      "Gopavaram B.O": "521333",
      "Katrenipadu B.O": "521207",
      "Akkireddygudem B.O": "521213",
      "Chekkapalli B.O": "521213",
      "Chittapur B.O": "521213",
      "Digavalli B.O": "521213",
      "Chatrai B.O": "521214",
      "Chinnampet B.O": "521214",
      "Annaraopet B.O": "521215",
      "Chandrupatla B.O": "521215",
      "Garapadu B.O": "521312",
      "Koyyagurapadu B.O": "521312",
      "Ponukumadu B.O": "521312",
      "Tukkuluru B.O": "521111",
      "Sitaramapuram B.O": "521105",
      "Lankapalli Agraharam B.O": "521311",
      "Pothureddipalli B.O": "521207",
      "Somavaram B.O": "521184",
      "Gudipadu B.O": "521213",
      "Janardhanavaram B.O": "521214",
      "Kalagara B.O": "521214",
      "Polavaram B.O": "521214",
      "Muchinapalli B.O": "521215",
      "Reddigudem B.O": "521215",
      "Tatakuntla B.O": "521215",
      "Pasumarru B.O": "521157",
      "Perisepalli B.O": "521157",
      "Mamidikolla B.O": "521356",
      "Kavipuram B.O": "521331",
      "Nemali B.O": "521401",
      "Satyalapadu B.O": "521401",
      "Bandarugudem B.O": "521109",
      "Kongamcherla B.O": "521331",
      "Chennuru B.O": "521366",
      "Chevendra B.O": "521366",
      "Chittipalem B.O": "521366",
      "K.P.Lock B.O": "521366",
      "Rimmanapudi B.O": "521157",
      "Kummaripalem B.O": "521130",
      "Venaktapuram B.O": "521130",
      "Ayyanki B.O": "521138",
      "Ramannapet B.O": "521162",
      "Kanuru B.O": "520007",
      "Karagraharam B.O": "521002",
      "Mekavanipalem B.O": "521002",
      "Chinnapuram B.O": "521003",
      "Kanchadam B.O": "521369",
      "Nandamuru B.O": "521311",
      "Penumalli B.O": "521369",
      "Satulru B.O": "521369",
      "Ravicherla B.O": "521202",
      "Annavaram B.O": "521202",
      "Billanapalli B.O": "521111",
      "Morsapudi B.O": "521111",
      "Devaragunta B.O": "521111",
      "Bapulapadu B.O": "521105",
      "Koyyuru B.O": "521105",
      "Madicherla B.O": "521105",
      "Aripirala B.O": "521106",
      "Pedalingala B.O": "521106",
      "Ramannagudem B.O": "521106",
      "Korlagunta B.O": "521207",
      "Kondaparva B.O": "521213",
      "Tummagudem B.O": "521213",
      "Krishnaraopalem B.O": "521214",
      "Pothanapalli B.O": "521214",
      "Jagannadhapuram B.O": "521215",
      "Kunaparajaparva B.O": "521215",
      "Velinuthala B.O": "521312",
      "Gosavedu B.O": "521403",
      "Nali B.O": "521120",
      "Pedakammavaripalem B.O": "521120",
      "Uruturu B.O": "521157",
      "Inampudi B.O": "521138",
      "Pedapatnam B.O": "521002",
      "Pothireddipalem B.O": "521002",
      "Yadlavanipalem B.O": "521002",
      "Gilakaladindi B.O": "521003",
      "Kammavaricheruvu B.O": "521003",
      "Vadapalem B.O": "521003",
      "Rudravaram B.O": "521227",
      "Venturumilli B.O": "521332",
      "Daggumailli B.O": "521356",
      "Vadlamannadu B.O": "521331",
      "Jinjeru B.O": "521369",
      "Kanumuru B.O": "521256",
      "Chintalanerva B.O": "521401",
      "Sanagapadu B.O": "521185",
      "Vemulapalli B.O": "521185",
      "Chandapuram B.O": "521185",
      "Ramireddipalli B.O": "521184",
      "Torragudipadu B.O": "521184",
      "Venkatapuram B.O": "521344",
      "Singavaram B.O": "521190",
      "Bhadrirajupalem B.O": "521163",
      "Vemulanarva B.O": "521402",
      "Choragudi B.O": "521250",
      "Krishnapuram B.O": "521250",
      "Pamidimukkala B.O": "521250",
      "Borrapothupalem B.O": "521366",
      "Jupudi B.O": "521456",
      "Ketanakonda B.O": "521456",
      "Kotikalapudi B.O": "521456",
      "Garikiparru B.O": "521165",
      "Buthumillipadu B.O": "521101",
      "Purushothapatnam B.O": "521101",
      "Roynagar B.O": "521101",
      "Lime Stone Town Ship B.O": "521175",
      "Nadakuduru B.O": "521126",
      "Vakkalagadda B.O": "521126",
      "Edlalanka B.O": "521122",
      "Malkapuram B.O": "521175",
      "Shermohammadpet B.O": "521175",
      "Srinivasa Nagar Colony B.O": "521175",
      "Takkellapadu B.O": "521345",
      "Gottumukkala B.O": "521180",
      "Moguluru B.O": "521180",
      "Munnaluru B.O": "521180",
      "Ponnavaram B.O": "521180",
      "Gani Atkuru B.O": "521180",
      "Kalavapamula B.O": "521164",
      "Ramachandrapuram B.O": "521226",
      "Ambedkarnagar B.O": "521165",
      "Iluru B.O": "521247",
      "Madhurapuram B.O": "521247",
      "Patamatalankapalli B.O": "521247",
      "China Nandigama B.O": "521230",
      "Koduru B.O": "521227",
      "Morusumilli B.O": "521230",
      "Chandrgudem B.O": "521230",
      "Naguluru B.O": "521230",
      "Pondugula B.O": "521230",
      "Konduru B.O": "521333",
      "Azzampudi B.O": "521101",
      "Bahubalendrunigudem B.O": "521101",
      "Gannavaram Centre B.O": "521101",
      "Anumanchipalli B.O": "521175",
      "Kontalapalli B.O": "521181",
      "Narasimharaopalem B.O": "521181",
      "Jammavaram B.O": "521180",
      "Paritala B.O": "521180",
      "Hanumanthapuram B.O": "521246",
      "Chavutapalli B.O": "521227",
      "Kakarla B.O": "521227",
      "Kavuluru B.O": "521228",
      "Kattubadipalem BO": "521228",
      "Vedadri B.O": "521457",
      "Gurazada B.O": "521256",
      "Saipuram B.O": "521256",
      "Srirangapuram B.O": "521247",
      "Eturu B.O": "521183",
      "Guttavaripalem B.O": "521183",
      "Thotaravulapadu B.O": "521183",
      "Pulluru B.O": "521230",
      "Cheruvukommupalem B.O": "521185",
      "Allapuram B.O": "521101",
      "Ramapuram B.O": "521321",
      "Tummalapalli B.O": "521321",
      "Achavaram B.O": "521333",
      "Mulaupparagudem B.O": "521344",
      "Santhoshapuram B.O": "521344",
      "Tamarakollu B.O": "521343",
      "Vemavarappadu B.O": "521343",
      "Chigurukota B.O": "521345",
      "Chowtapalli B.O": "521170",
      "Komarru B.O": "521325",
      "Lingala B.O": "521402",
      "Balusupadu B.O": "521175",
      "Gandrai B.O": "521175",
      "Chennaraopalem B.O": "521181",
      "Gudem Madhavaram B.O": "521181",
      "Peddapuram B.O": "521181",
      "Vellanki B.O": "521181",
      "Jaccampudi B.O": "520012",
      "Chevitikallu B.O": "521180",
      "Damuluru B.O": "521180",
      "Krishnanagar B.O": "520007",
      "Manthena B.O": "521151",
      "Proddutur B.O": "521151",
      "Vanukuru B.O": "521151",
      "Punadipadu B.O": "521151",
      "Royyur B.O": "521151",
      "Enikepadu B.O": "521108",
      "Pedapulipaka B.O": "521134",
      "Repudi B.O": "521226",
      "Krishnaraopalem": "521226",
      "Chinaogirala B.O": "521245",
      "Kotha Edara B.O": "521211",
      "Wambay Colony BO": "520015",
      "Bandipalem B.O": "521178",
      "Bhimavaram B.O": "521178",
      "Gowravaram B.O": "521178",
      "Atkuru B.O": "521229",
      "Chevutur B.O": "521229",
      "Duggiralapadu B.O": "521229",
      "Ganginenipalem B.O": "521229",
      "Vellaturu B.O": "521229",
      "Pedakamanapudi B.O": "521325",
      "Kottada B.O": "521340",
      "Penchikalamarru B.O": "521340",
      "Seetanapalli B.O": "521340",
      "Vadarlapadu B.O": "521340",
      "Putrela B.O": "521227",
      "Gollamandala B.O": "521227",
      "Vallampatla B.O": "521227",
      "Ilaprolu B.O": "521228",
      "Pinapaka B.O": "521228",
      "Jayanthipuram B.O": "521457",
      "Velpuru B.O": "521104",
      "Guruvindapalli B.O": "521247",
      "Inapur B.O": "521247",
      "Turlapadu B.O": "521183",
      "Savaragudem B.O": "521107",
      "Vasanthanagar B.O": "520007",
      "Edupugallu B.O": "521151",
      "Godavarru B.O": "521151",
      "Uppaluru B.O": "521151",
      "Gudavalli B.O": "521104",
      "Ramakrishnapuram BO": "520003",
      "Sagguru B.O": "521211",
      "Seetharampuram B.O": "521211",
      "Zakkulanekkalam B.O": "521102",
      "Popuru B.O": "521182",
      "Vibharintapadu B.O": "521182",
      "Bobbellapadu B.O": "521182",
      "Kasarabad B.O": "521182",
      "Punnavalli B.O": "521182",
      "Mangollu B.O": "521178",
      "Pochampalli B.O": "521178",
      "Velagaleru B.O": "521229",
      "Chinatummidi B.O": "521329",
      "Korraguntapalem B.O": "521329",
      "Pedatummidi B.O": "521329",
      "Singarayapalem B.O": "521329",
      "Addada B.O": "521390",
      "Gunnanapudi B.O": "521326",
      "Ingilipakalanka B.O": "521326",
      "Nandigamalanka B.O": "521326",
      "Dandiganapudi B.O": "521327",
      "Lingavaram B.O": "521327",
      "Polukonda B.O": "521327",
      "Ponukumada B.O": "521327",
      "Bhushanagulla B.O": "521263",
      "Pedaparupudi B.O": "521263",
      "Chinayerukapadu B.O": "521322",
      "Komaravolu B.O": "521322",
      "Tativarru B.O": "521322",
      "Dosapadu B.O": "521321",
      "Ilaparru B.O": "521321",
      "Kudaravalli B.O": "521321",
      "Atapaka B.O": "521333",
      "Tadinada B.O": "521333",
      "Varahapatnam B.O": "521333",
      "Kondangi B.O": "521344",
      "Lodidalanka B.O": "521344",
      "Alluru B.O": "521181",
      "Mokasakalvapudi B.O": "521345",
      "Prathipadu B.O": "521345",
      "Vadali B.O": "521325",
      "Vanapumala B.O": "521263",
      "Boruvancha B.O": "521202",
      "Ganapavaram B.O": "521230",
      "Tolukodu B.O": "521230",
      "Gollamudi B.O": "521184",
      "Enamadala B.O": "521202",
      "Nidamarru B.O": "521324",
      "Pendurru B.O": "521324",
      "Chinaparupudi B.O": "521148",
      "Gandhi Asramam B.O": "521322",
      "Moparru B.O": "521321",
      "Pedavirivada B.O": "521321",
      "Chavalipadu B.O": "521333",
      "Kallapalem B.O": "521333",
      "China Tadinada B.O": "521333",
      "Pothumarru B.O": "521344",
      "Devapudi B.O": "521343",
      "Sanarudravaram B.O": "521343",
      "Ayyavarirudravaram B.O": "521345",
      "Perekegudem B.O": "521345",
      "Dondapadu B.O": "521323",
      "Serigolvepalli B.O": "521323",
      "Chinapalaparru B.O": "521325",
      "K.P.Agraharam B.O": "521325",
      "Sankarshanapuram B.O": "521325",
      "Vinnakota B.O": "521325",
      "Appikatla B.O": "521261",
      "Alapadu R.S. B.O": "521340",
      "Doddipatla B.O": "521340",
      "Utukuru B.O": "521329",
      "Vaivaka B.O": "521329",
      "Vanudurru B.O": "521329",
      "Jonnalagadda B.O": "521184",
      "Kanchala B.O": "521185",
      "Kethaveerunipadu B.O": "521185",
      "Pendyala B.O": "521185",
      "Adavinekkalam B.O": "521212",
      "Pathapadu B.O": "521212",
      "Surampalli B.O": "521212",
      "Atkur B.O": "521286",
      "Pottipadu B.O": "521286",
      "Veerapanenigudem B.O": "521286",
      "Sivapuram B.O": "521190",
      "Kannevidu B.O": "521190",
      "Makkapeta B.O": "521190",
      "Mundlapadu B.O": "521190",
      "Subbayyagudem B.O": "521190",
      "Rayanapadu B.O": "521241",
      "Paidurupadu B.O": "521241",
      "Chagantipadu B.O": "521163",
      "Khambampadu B.O": "521402",
      "Pentalavarigudem B.O": "521402",
      "Doddadevarapadu B.O": "521170",
      "Konathamatmakur B.O": "521170",
      "Agniparru B.O": "521250",
      "Aminapuram B.O": "521250",
      "Gandigunta B.O": "521165",
      "Kanakavalli B.O": "521165",
      "Yanamalakuduru B.O": "520007",
      "Cheemalapadu B.O": "521226",
      "Kunderu B.O": "521245",
      "Chopparametla B.O": "521211",
      "Narasingapalem B.O": "521211",
      "Thotapalli B.O": "521211",
      "Kesarapalli B.O": "521102",
      "Konayapalem B.O": "521182",
      "Veladikothapalem B.O": "521182",
      "Gudimetla B.O": "521182",
      "Kodavatikallu B.O": "521182",
      "Peda Modugapalli B.O": "521178",
      "Tirumalagiri B.O": "521178",
      "Cheruvu Madhavaram B.O": "521229",
      "H Mutyalampadu B.O": "521229",
      "Gandepalli B.O": "521185",
      "Ithavaram B.O": "521185",
      "Pallagiri B.O": "521184",
      "Raghavapuram B.O": "521184",
      "Kanasanapalli B.O": "521212",
      "Lingagudem B.O": "521190",
      "Muchintala B.O": "521190",
      "Guntupalli B.O": "521241",
      "Dabbakupalli B.O": "521402",
      "Unikili B.O": "521326",
      "Anamanapudi B.O": "521327",
      "Valivarthipadu B.O": "521327",
      "Pagolu B.O": "521126",
      "Yarlagadda B.O": "521126",
      "Bandlaicheruvu B.O": "521122",
      "Kothapet(Divi) B.O": "521122",
      "Aswaraopalem B.O": "521122",
      "Kakaravai B.O": "521402",
      "Polampalli B.O": "521402",
      "Damulur B.O": "521170",
      "Jayanthi B.O": "521170",
      "Penumatcha B.O": "521250",
      "Chilukuru B.O": "521456",
      "Mulapadu B.O": "521456",
      "Penamakuru B.O": "521165",
      "Nawabpet B.O": "521185",
      "Kammavaripalem B.O": "521184",
      "Lingalapadu B.O": "521185",
      "Tempalli B.O": "521286",
      "Anigandlapadu B.O": "521190",
      "Gopinenipalem B.O": "521190",
      "Gummadidurru B.O": "521190",
      "Devarapalli B.O": "521163",
      "Pamulalanka B.O": "521163",
      "Valluripalem B.O": "521163",
      "Machinenipalem B.O": "521402",
      "Talluru B.O": "521402",
      "Yakamuru B.O": "521165",
      "Kuntamukkala B.O": "521230",
      "Munagacherla B.O": "521185",
      "Chikkavaram B.O": "521101",
      "Gollanapalli B.O": "521101",
      "Pandraka B.O": "521324",
      "Edulamaddali B.O": "521148",
      "Lakshminarasimhapuram B.O": "521321",
      "Nandivada B.O": "521321",
      "Vennanapudi B.O": "521321",
      "Chintapadu B.O": "521333",
      "Vinjaram B.O": "521333",
      "Mattagunta B.O": "521344",
      "Pedalanka B.O": "521344",
      "Bomminampadu B.O": "521343",
      "Prodduvaka B.O": "521343",
      "Bhyravapatnam B.O": "521345",
      "Gannavaram B.O": "521345",
      "Singanapudi B.O": "521345",
      "Guntakoduru B.O": "521323",
      "Pedapalaparru B.O": "521323",
      "Guraza B.O": "521325",
      "Kanukollu B.O": "521325",
      "Peruru B.O": "521325",
      "Peyyeru B.O": "521325",
      "Bollapadu B.O": "521261",
      "Bhujabalapatnam B.O": "521340",
      "Kolletikota B.O": "521340",
      "Chevuru B.O": "521329",
      "Gopavarapugudem B.O": "521101",
      "Budhavaram B.O": "521101",
      "Budavada B.O": "521175",
      "Jami Annavaram B.O": "521175",
      "Dachavaram B.O": "521181",
      "Ambapuram B.O": "520012",
      "Kadavakollu B.O": "521164",
      "Polisettipadu B.O": "521227",
      "Urivi B.O": "521329",
      "Vadavalli B.O": "521329",
      "Putlacheruvu B.O": "521326",
      "Guruvindagunta B.O": "521263",
      "Hanumanthunigudem B.O": "521202",
      "Ganugapadu B.O": "521227",
      "Vemireddipalle B.O": "521227",
      "Ida Kondaplli B.O": "521228",
      "Muktyala B.O": "521457",
      "Marrivada B.O": "521256",
      "Gopuvanipalem B.O": "521256",
      "Tadanki B.O": "521256",
      "Kuderu B.O": "521247",
      "Velvdam B.O": "521230",
      "Boddapadu B.O": "521151",
      "Madduru B.O": "521151",
      "Gosala B.O": "521151",
      "Ganguru B.O": "521139",
      "Nepalli B.O": "521245",
      "Pedaogirala B.O": "521245",
      "Edara B.O": "521211",
      "Idulagudem B.O": "521211",
      "Krishnavaram B.O": "521211",
      "Nugondapalli B.O": "521211",
      "Sobhanapuram B.O": "521211",
      "Vattigudipadu B.O": "521211",
      "Payakapuram. B.O": "520015",
      "Pokkunuru B.O": "521182",
      "Konakanchi B.O": "521178",
      "Sunnampadu B.O": "521229",
      "APUHS SO": "520008",
      "Autonagar S.O": "520007",
      "Civil Coursts S.O": "520002",
      "Gunadala S.O": "520004",
      "Kankipadu S.O": "521151",
      "Krishnalanka S.O": "520013",
      "Nidamanuru S.O": "521104",
      "Penamaluru S.O": "521139",
      "Poranki S.O": "521137",
      "Ramavarappadu S.O": "521108",
      "Suryaraopet S.O": "520002",
      "Vj Polytechnic S.O": "520008",
      "Azitnagar S.O": "520015",
      "Bhavanipuram S.O": "520012",
      "Chittinagar S.O": "520001",
      "Gannavaram S.O": "521101",
      "Gollapudi S.O": "521225",
      "Juzzuru S.O": "521181",
      "Lakshminagar S.O": "520011",
      "Meduru S.O": "521247",
      "Nandigama S.O": "521185",
      "Pedavutapalli S.O": "521286",
      "Railway Wagon Work Shop S.O": "521241",
      "Satyanarayanapuram S.O (Vijayawada)": "520011",
      "VTPS S.O": "521456",
      "Vuyyuru S.O": "521165",
      "Magallu SO": "521184",
      "Durga Agraharam S.O": "520002",
      "Moghalrajpuram S.O": "520010",
      "A.C.Company S.O": "520003",
      "A.Konduru S.O": "521226",
      "Akunuru S.O": "521245",
      "Aukiripalli S.O": "521211",
      "Bacon Factory S.O": "521102",
      "G Konduru S.O": "521229",
      "Jaggaiahpet S.O": "521175",
      "Kanchikacharla S.O": "521180",
      "Katuru S.O": "521164",
      "Kondapalli S.O": "521228",
      "Mylavaram S.O (Krishna)": "521230",
      "Nunna S.O": "521212",
      "Vatsavai S.O": "521402",
      "Veerullapadu S.O": "521170",
      "Wnchipet S.O": "520001",
      "Madhuranagar S.O": "520011",
      "Industrial Estate S.O (Krishna)": "520007",
      "Kolavennu S.O": "521153",
      "Machavaram S.O (Krishna)": "520004",
      "Venkateswarapuram S.O": "520010",
      "Currency Nagar S.O": "520008",
      "A.P.H.B.Colony S.O": "520012",
      "Chillakallu S.O": "521178",
      "Durgapuram S.O": "520003",
      "Ibrahimpatnam S.O (Krishna)": "521456",
      "Khambhampadu S.O": "521227",
      "Kumaraswamy Raja Nagar S.O": "521457",
      "Mantada S.O": "521256",
      "Muppalla S.O (Krishna)": "521183",
      "Mustabad S.O (Krishna)": "521107",
      "Purnanandampet S.O": "520003",
      "RAMALINGESWAR NAGAR S.O": "520013",
      "Punnamathota S.O": "520010",
      "Tadigadapa S.O": "521134",
      "Chandarlapadu S.O": "521182",
      "Gandhinagaram S.O (Vijayawada)": "520003",
      "Kamakotinagar S.O": "520012",
      "Kapileswarapuram S.O (Krishna)": "521246",
      "Avanigadda H.O": "521121",
      "Lakshmana Nagar S.O": "521165",
      "Penuganchiprolu S.O": "521190",
      "Virankilock S.O": "521250",
      "JNNURM Colony S.O": "521231",
      "Thotlavalluru S.O": "521163",
      "Vja Railway Junction S.O": "520001",
      "Vja Rly Divl Office S.O": "520001",
      "Gudivada H.O": "521301",
      "Machilipatnam H.O": "521001",
      "Buckinghampet H.O": "520002",
      "Vijayawada H.O": "520001",
      "Angaluru S.O": "521330",
      "Golvepalli (Zami) S.O": "521322",
      "Korukollu S.O": "521343",
      "Mudinepalli S.O": "521325",
      "Mudunuru S.O": "521261",
      "Nuzvid S.O": "521201",
      "Musunuru S.O": "521207",
      "Penugolanu S.O": "521401",
      "Tiruvuru S.O": "521235",
      "Janardhanapuram S.O": "521321",
      "Mandavalli S.O": "521345",
      "Pedamaddali S.O": "521390",
      "Rajendranagar Colony S.O": "521301",
      "Satyanarayanapuram S.O (Gudivada)": "521301",
      "Tamirisa S.O": "521327",
      "Nuzvid Bazar S.O": "521201",
      "Vidyanagar S.O (Krishna)": "521201",
      "Manikonda S.O": "521260",
      "Ventrapragada S.O": "521263",
      "Dum Dum Gardens S.O": "521201",
      "Gollapalli S.O (Krishna)": "521111",
      "Hanuman Junction S.O": "521105",
      "Indupalli S.O": "521311",
      "Kanumolu S.O": "521106",
      "Telaprolu S.O": "521109",
      "Veeravalli S.O": "521110",
      "Gampalagudem S.O": "521403",
      "Ghantasala S.O": "521133",
      "Guduru S.O": "521149",
      "Kaja S.O": "521150",
      "Kodali S.O": "521132",
      "Movva S.O": "521135",
      "Pedasanagallu S.O": "521138",
      "Bhaskarapuram S.O": "521001",
      "Valandapalem S.O": "521002",
      "K.P.Centre S.O": "521136",
      "Nagayalanka S.O": "521120",
      "Nidumolu S.O": "521156",
      "Polavaram(K) S.O": "521162",
      "Balaramunipet S.O": "521001",
      "Desaipet S.O": "521001",
      "Dt.Court S.O": "521002",
      "Gudlavalleru S.O": "521356",
      "Inagudurupet S.O": "521001",
      "K.P.Pur S.O": "521002",
      "U.G.C.Works S.O": "521001",
      "Koduru S.O": "521328",
      "Pamarru S.O (Krishna)": "521157",
      "Pedakallepalli S.O": "521130",
      "Batchupet S.O": "521001",
      "Chilakalapudi S.O": "521002",
      "Chintaguntapalem S.O": "521003",
      "Godugupet S.O": "521001",
      "Bantumilli S.O": "521324",
      "Elamarru S.O": "521148",
      "Kaikalur S.O": "521333",
      "Kalidindi S.O": "521344",
      "Moturu S.O": "521323",
      "Pallevada S.O": "521340",
      "Pedagonnuru S.O": "521329",
      "Rudrapaka S.O": "521326",
      "APIIIT S.O": "521202",
      "Ramanakkapet S.O": "521213",
      "Tsanubanda S.O": "521214",
      "Kavutaram S.O": "521331",
      "Malakapatnam S.O": "521001",
      "Munjuluru S.O": "521369",
      "Challapalli S.O": "521126",
      "Gandhikshetram S.O": "521122",
      "Lakshmipuram S.O (Krishna)": "521131",
      "Mopidevi S.O": "521125",
      "Nimmakuru S.O": "521158",
      "Pamarru Bazar S.O": "521157",
      "Brahmapuram S.O": "521366",
      "Dokiparru S.O": "521332",
      "Pedana S.O": "521366",
      "Rajupet S.O": "521001",
      "Vissannapet S.O": "521215",
      "Vunguturu S.O (Krishna)": "521312"
    }
  },
  "BIHAR": {
    "BANKA": {
      "Kathrang BO": "813105",
      "Sanjha BO": "813105",
      "Singhnan BO": "813105",
      "Logain BO": "813108",
      "Dumaria BO": "813212",
      "Harchandi BO": "813105",
      "Laskari BO": "813105",
      "Nawada bazar BO": "813105",
      "Rauka BO": "813105",
      "Rupsa BO": "813105",
      "Kushmaha BO": "813104",
      "Laxmipur Chiraya BO": "813108",
      "RANGA BO": "813207",
      "PARMANANDPUR ITWA": "813207",
      "Pair BO": "813205",
      "Raugaon BO": "813110",
      "Chandadih BO": "813109",
      "Manjhoni BO": "813109",
      "Shreepathas BO": "813109",
      "Vijayhat BO": "813109",
      "Morma BO": "813107",
      "Ranjodha BO": "813107",
      "Belarimilki BO": "813211",
      "Chutia BO": "813211",
      "Kaitha BO": "813211",
      "Kumarpur BO": "813211",
      "Kumri BO": "813212",
      "Santadih BO": "813212",
      "Thilkulia BO": "813212",
      "Ahiro BO": "813110",
      "Chalna BO": "813110",
      "Motanga BO": "813110",
      "Hirambhi BO": "813109",
      "Bamdev BO": "813107",
      "Gopalpur BO": "813107",
      "Kathoun BO": "813107",
      "Lakra BO": "813107",
      "Mahisota BO": "813211",
      "Mirzapur BO": "813211",
      "Pakaria BO": "813211",
      "Jotha BO": "813109",
      "Kolhatha BO": "813109",
      "Lilatari BO": "813109",
      "Orhara BO": "813109",
      "Shreepathar BO": "813109",
      "Uprama BO": "813107",
      "Warsabad BO": "813211",
      "Kadrachak BO": "813211",
      "Kasba BO": "813211",
      "Sihuri B.O": "813101",
      "Makaita BO": "813105",
      "Darha BO": "813212",
      "Gerua BO": "813212",
      "Pathara BO": "813110",
      "Sadpur BO": "813110",
      "Bhatkund BO": "813109",
      "Bindi BO": "813109",
      "Chanjeri BO": "813109",
      "Patsorikhaira BO": "813107",
      "Rojabar BO": "813107",
      "Gidhora BO": "813211",
      "Krma BO": "813211",
      "Phulhara BO": "811308",
      "Narayanpur BO": "813103",
      "Sondiha Babhangama BO": "813103",
      "Sondiha Dharmdiha BO": "813103",
      "Telia BO": "813103",
      "DOMUHAN": "813202",
      "HARIPUR": "813202",
      "RANGATTA": "813202",
      "Bara BO": "813202",
      "Barhara BO": "813202",
      "Dahuwa BO": "813104",
      "Gokula  KURAWA BO": "813104",
      "Golhatti BO": "813104",
      "Gorgama BO": "813101",
      "Kairee BO": "813104",
      "Pelwa B.O": "814131",
      "Bairoganj BO": "813106",
      "Keruar BO": "813106",
      "Papraiba BO": "813106",
      "Pirra BO": "813106",
      "Supaha BO": "813106",
      "Bahrna BO": "813207",
      "Bhatshila BO": "813207",
      "Pararia BO": "813211",
      "Bhalua BO": "813221",
      "Ramchna BO": "813221",
      "LAKHNOUDIH": "813202",
      "LAXMIPUR": "813202",
      "PATHRA": "813202",
      "Tengza BO": "813202",
      "Bagduma BO": "813104",
      "Maniyarpur BO": "813104",
      "Pilua Jharna BO": "813104",
      "Saraiya BO": "813104",
      "Serua BO": "813104",
      "Bank BO": "814131",
      "Bhorabazar  BO": "814131",
      "Bhorsar BO": "814131",
      "Barwasini BO": "813106",
      "Baniakura BO": "813106",
      "Kolhasar BO": "813106",
      "Katsakrah BO": "813106",
      "Malbathan BO": "813106",
      "Kathoun B.O": "813106",
      "Dhankuria BO": "813207",
      "Karanja BO": "813207",
      "Nimia BO": "813207",
      "Nraun BO": "813207",
      "Rata BO": "813207",
      "Chatmadih BO": "813201",
      "Khojhi BO": "813103",
      "Lakhpura BO": "813103",
      "Baid Pur BO": "813211",
      "Basbita BO": "813221",
      "Chathar Dhaniar BO": "813221",
      "Golni Kusaha BO": "813221",
      "Dharia BO": "813205",
      "Hasai BO": "813205",
      "Batsar BO": "813205",
      "JAMDAHA": "813202",
      "JOGDIHA": "813202",
      "Bijaynagar": "813202",
      "chutia": "813202",
      "DANRA": "813202",
      "KUNOUNI": "813202",
      "Mathura Sahibganj BO": "813202",
      "Bhghwa BO": "813104",
      "Bisanpur Bhurbhuri BO": "813104",
      "Mandar Vidyapith BO": "813104",
      "Nayagaon BO": "813104",
      "Sabalpur BO": "813104",
      "Sukhia Barhet BO": "813104",
      "Jokta Fatehpur BO": "814131",
      "Lohari BO": "814131",
      "Charkapathar BO": "813106",
      "Jaipur BO": "813106",
      "Tetaria BO": "813106",
      "Uparchakmarhia BO": "813106",
      "Bishanpur BO": "813205",
      "Fullidumar BO": "813207",
      "Pasmanandpur BO": "813207",
      "Rauja BO": "813207",
      "Buzurgharna BO": "813105",
      "MAHESHADIH": "813202",
      "MANJIRA GOURIPUR": "813202",
      "MERHA": "813202",
      "Basmatta BO": "813202",
      "Manjhili Matihani BO": "813202",
      "Rajpur BO": "813101",
      "Bhurna BO": "813104",
      "CHUAPANI BO": "813104",
      "Phaga BO": "813104",
      "Shyambazar BO": "813104",
      "Inarabaran BO": "814131",
      "Kumartar BO": "814131",
      "Bhelwa BO": "813106",
      "Kamdeodih BO": "813106",
      "Tonapathar BO": "813106",
      "Beldiha BO": "813207",
      "Bhitia BO": "813207",
      "Saguni BO": "813211",
      "Baliskadma BO": "813205",
      "Rahmandih BO": "813205",
      "Pathada BO": "813101",
      "Pawai SO BanBO": "813101",
      "Rajwara BO": "813101",
      "Sultanpur BO": "813101",
      "Surhari BO": "813101",
      "Telia Lowgain BO": "813101",
      "SAMUKHIYAMORE": "813101",
      "BARHUNA BO": "813103",
      "Dhakamor BO": "813103",
      "Jagatpur BO": "813103",
      "Kajhia BO": "813103",
      "Belsira BO": "813101",
      "Bharko BO": "813101",
      "Bishambharchak BO": "813101",
      "Dumarama BO": "813101",
      "JETHOR JAMUA": "813101",
      "MAKDUMA": "813101",
      "PARARIA CHAKKADIH": "813101",
      "Baidachak BO": "813101",
      "Kathail BO": "813101",
      "Kolbuzurg BO": "813101",
      "Ranikita BO": "813101",
      "Sobhanpur Katoria BO": "813101",
      "Sathiyari BO": "813205",
      "BHIKHANPUR": "813101",
      "DUDHARI": "813101",
      "RAMCHANDRAPUR ITAHARI": "813101",
      "SAMUKHIYA": "813101",
      "Balia Mahra BO": "813103",
      "Kakwara BO": "813103",
      "Abhiyudayasharan BO": "813101",
      "Kamdeopur BO": "813101",
      "Kenduar BO": "813101",
      "Mahadeopur BO": "813101",
      "Salempur BO": "813101",
      "Bhadaria BO": "813101",
      "Auria BO": "813103",
      "KHARHARA BO": "813103",
      "Banka HO": "813102",
      "Belhar SO": "813202",
      "Panjwara SO": "813110",
      "Punsia SO": "813109",
      "Shambhuganj SO": "813211",
      "Amarpur SO Banka": "813101",
      "Rajoun SO": "813107",
      "Barahat SO": "813103",
      "Bounsi SO": "813104",
      "Chandan SO": "814131",
      "Katoria SO": "813106",
      "Khesar SO": "813207"
    },
    "BHAGALPUR": {
      "Mohiuddivpur BO": "813105",
      "Kasri BO": "813203",
      "Mahesh Munda BO": "813203",
      "Sangitbaita BO": "813203",
      "Akidatpur BO": "853202",
      "Lokmanpur BO": "853202",
      "Raghopur BO": "853202",
      "Tulsipur Jamunia BO": "853202",
      "Barani BO": "813222",
      "Nandlalpur BO": "813222",
      "Baluachak BO": "812005",
      "Khutaha BO": "812005",
      "Sahjatpur BO": "812005",
      "Bharakhand Naybas BO": "853203",
      "Nagarpara BO": "853203",
      "Raipur BO": "853203",
      "Sathishnagar BO": "853203",
      "Dariapur BO": "812006",
      "Haridaspur BO": "812006",
      "Sajour BO": "812006",
      "Dharahara BO": "853204",
      "Dimaha BO": "853204",
      "Khairpurkadwa BO": "853204",
      "Latra BO": "853204",
      "Madrauni BO": "853204",
      "Mohanpur BO": "853204",
      "Pakra B.O": "853204",
      "Sahuparbatta BO": "853204",
      "Amapali BO": "813209",
      "Mohanpur Govinpur BO": "813209",
      "Rifatpur BO": "813209",
      "Salempurtola BO": "813209",
      "Srinagar BO": "813209",
      "Suktia BO": "853205",
      "Tintangadiara BO": "853205",
      "Bahadurpur BO": "813210",
      "Chakdaria BO": "813210",
      "Machipur BO": "813210",
      "Pharka BO": "813210",
      "Shaukarpur BO": "813210",
      "Bakchappar BO": "813108",
      "Kapsona BO": "813108",
      "Kodanda BO": "813108",
      "Bhawanipur BO": "813203",
      "Bhawanpura BO": "853202",
      "Ishapur Chorhar BO": "853202",
      "Jamunia BO": "853202",
      "Kaluchak Bispuria BO": "853202",
      "Ekdara BO": "813222",
      "Kishandaspur BO": "813222",
      "Saino BO": "813105",
      "Patharghatta BO": "813203",
      "Shobhnathpur BO": "813203",
      "Laxmipur BO": "813222",
      "Ranidiara BO": "813222",
      "Puraini BO": "812005",
      "Bharatkhand dyorhi BO": "853203",
      "Chakrami BO": "853203",
      "Khajraitha BO": "853203",
      "Madhurapur BO": "853203",
      "Akbarnagar BO": "812006",
      "Bhatoria BO": "812006",
      "Chaknarayanpur BO": "812006",
      "Chandrabhanpur BO": "812006",
      "Khaira BO": "812006",
      "Kishandaspur amkhoria BO": "812006",
      "Abhiya bazarBO": "853204",
      "Baisi jahangira BO": "853204",
      "Gosaigaov BO": "853204",
      "Jagatpur BO": "853204",
      "Kadwadiara BO": "853204",
      "KHAGRA": "853204",
      "Makhatakia BO": "853204",
      "Maniamore BO": "853204",
      "NAGRAH BO": "853204",
      "Bakharpur BO": "813209",
      "Barmasia BO": "813209",
      "Duldulia BO": "813209",
      "Kaliprasad BO": "813209",
      "Khawaspur MILKI BO": "813209",
      "Moultola BO": "813209",
      "Narayanpur BO": "813209",
      "Parshurampur BO": "813209",
      "Pirpainti Bazar BO": "813209",
      "Raghunitola BO": "853205",
      "Mamallkha BO": "813210",
      "Parghari BO": "813210",
      "Pithna BO": "813210",
      "Kiranpur BO": "813108",
      "Panchrukhi Bazar BO": "813108",
      "Rataupur Maikpur BO": "813108",
      "Sahjadpur BO": "813108",
      "Samastipur BO": "813108",
      "Lagma BO": "813222",
      "Rampur BO": "813222",
      "Danda Bazar BO": "812005",
      "Kajraili BO": "812005",
      "Khiribandha BO": "812005",
      "Harnathpur BO": "812006",
      "Pratapnager BO": "853204",
      "Rangra BO": "853204",
      "Sadhwa BO": "853204",
      "Tetripakra BO": "853204",
      "Sarkanda BO": "813209",
      "Srimatpur BO": "813209",
      "Jotgobind BO": "853205",
      "Kamlakund BO": "853205",
      "Phulakia BO": "853205",
      "Agarpur BO": "813210",
      "Alinagear Rajpur BO": "813210",
      "Afzugaj BO": "813213",
      "Kasimpur BO": "813105",
      "Satjori BO": "813105",
      "Tarcha BO": "813105",
      "Kalgigaj BO": "813203",
      "Lalapur Bhader BO": "813203",
      "Mirjafari BO": "853202",
      "Telghee BO": "853202",
      "Akabarpur BO": "813222",
      "BudhuchaK BO": "813222",
      "Ekchari Khawas BO": "813222",
      "Gourachouki BO": "812005",
      "Sanhouli BO": "812005",
      "Balaha BO": "853203",
      "Paharpur BO": "853203",
      "Charabargaon BO": "812006",
      "Gobrain BO": "812006",
      "Ratanganj BO": "812006",
      "Bhawauipur BO": "853204",
      "Chapar BO": "853204",
      "Dholbazza  BO": "853204",
      "Panchgachia Bazar BO": "853204",
      "Singhia makandpur BO": "853204",
      "Sadipur BO": "813209",
      "Bhimdestola BO": "853205",
      "Ismailpur BO": "853205",
      "Tintanga BO": "853205",
      "Bishanpurjicho BO": "813210",
      "Fatehpur SO BhagalpBO": "813210",
      "Goradih BO": "813210",
      "Amba BO": "813108",
      "Harpur BO": "813108",
      "Mokinpur English BO": "813108",
      "Satparaiya BO": "813108",
      "Ganganiya BO": "811211",
      "Gangapur Diara BO": "813213",
      "Udhadih BO": "813213",
      "Kumaitha BO": "813213",
      "Baijani BO": "812005",
      "Burhanath BO": "812005",
      "Khanjarpur BO": "812005",
      "Nayagaon BO": "813201",
      "Marwa BO": "853201",
      "Amribishapur BO": "812004",
      "Mirzapur BO": "812004",
      "Arar BO": "813204",
      "Beijnathpur BO": "813204",
      "Chaknathu BO": "813204",
      "Channo BO": "813204",
      "Hathiyok BO": "813213",
      "Mardimushari BO": "813213",
      "Mirhatti BO": "813213",
      "Nansar BO": "813213",
      "Bath BO": "813201",
      "Amarpur BO": "853201",
      "Babhangama BO": "853201",
      "ChhotInaki BO": "813204",
      "Madarganj BO": "813204",
      "Mahesakhore BO": "813204",
      "Pathakdih BO": "813204",
      "Sanokhar  BazarBO": "813204",
      "Kathara BO": "813213",
      "Jahagira BO": "813213",
      "Khanpurmal BO": "813213",
      "TILAKPUR BO": "813213",
      "Mahiyama BO": "813205",
      "Tarar BO": "813205",
      "Nadiyama BO": "813205",
      "Pothia BO": "813205",
      "Prasasthdih BO": "813205",
      "Roshanpur BO": "813206",
      "Sian BO": "813206",
      "Badluchak BO": "813105",
      "Semaria BO": "812005",
      "Bharamarpur BO": "853201",
      "Gouripur BO": "853201",
      "Jhandapur BO": "853201",
      "Sonbarsa BO": "853201",
      "Shankarpur BO": "812004",
      "Dhanokhar": "813204",
      "Dhubai BO": "813204",
      "Kairia BO": "813204",
      "Sohail BO": "813204",
      "Trimohan BO": "813204",
      "ABHYUDAY ASHRAM": "813101",
      "Habibpur BO": "812005",
      "S S Lane BO": "812005",
      "Dhuibelari BO": "813201",
      "Karaharia BO": "813201",
      "Dharampurrahi BO": "853201",
      "Hario BO": "853201",
      "LaTTIPUR BO": "853201",
      "Milki BO": "853201",
      "Fatehpur BO": "812004",
      "Ranuchakmakandpur BO": "812004",
      "Amdanda BO": "813204",
      "Dhanoura BO": "813204",
      "Laxmipur Babhania BO": "813204",
      "Silhan BO": "813204",
      "Srimatpur Belsar BO": "813204",
      "Mangachak BO": "813205",
      "Sanhoula BO": "813205",
      "Chandpur BO": "813105",
      "Maheshpur BO": "813205",
      "Murhan BO": "813205",
      "Sakrama BO": "813205",
      "Bhagalpur HO": "812001",
      "Aliganj SO": "812005",
      "Ishakchak SO": "812001",
      "Jagdishpur SO Bhagalpur": "813105",
      "Mathurapur SO Bhagalpur": "813222",
      "STGoriar SO": "853205",
      "Barahpura": "812001",
      "M M Ashram": "812003",
      "Mayaganj": "812001",
      "Kharmanchak": "812001",
      "Adampur SO": "812001",
      "Bhagalpur City SO": "812002",
      "Bhaglapur Distt Board": "812001",
      "Champanagar SO": "812004",
      "Ghogha SO": "813205",
      "Kahalgaon SO": "813203",
      "Naugachia SO": "853204",
      "STP Kahalgaon SO": "813214",
      "Sultanganj SO Bhagalpur": "813213",
      "Tatarpur": "812002",
      "Bhaglapur  Engg College": "813210",
      "Tilkamanjhi": "812001",
      "Barari SO": "812003",
      "Bihpur SO": "853201",
      "Ekchari SO": "813204",
      "Ishipur SO": "813206",
      "Karik Bazar SO": "853202",
      "Mirjanhat SO": "812005",
      "Narayanpur SO Bhagalpur": "853203",
      "Nathnagar SO": "812006",
      "Pripainti SO": "813209",
      "Sahebganj": "812004",
      "Bhaglapur Central Jail": "813210",
      "S R Sultanganj SO": "813213",
      "Sabour SO": "813210",
      "Sahkund SO": "813108",
      "Sujaganj Bazar SO": "812002",
      "T N B College SO": "812007"
    },
    "MADHEPURA": {
      "Bhowadeorhi BO": "853204",
      "Arajpur BO": "853204",
      "Bhatgama BO": "853204",
      "Bajraha BO": "852219",
      "KRatwara BO": "852219",
      "Khara Budhma BO": "852219",
      "Morsanda BO": "852219",
      "Barahi Hasanpur BO": "852128",
      "Bathanparsa BO": "852132",
      "Jirwa BO": "852132",
      "Kalhua BO": "852132",
      "Lalpur Sarropatti BO": "852128",
      "Rupauli Jiwachpur BO": "852128",
      "Shankarpur BO": "852132",
      "Sripur Tengraha BO": "852128",
      "Bispatti BO": "852219",
      "Kunjouri BO": "852219",
      "Kurshandi BO": "852219",
      "Mahua Bazar BO": "852219",
      "N Bhagipur BO": "852219",
      "Sapardah BO": "852219",
      "Singhar BO": "852219",
      "Majarhat BO": "852128",
      "Manhara Sukhashan BO": "852128",
      "KSPur BO": "852220",
      "Manpur BO": "852128",
      "Maoura Ramnagar BO": "852132",
      "Patori BO": "852128",
      "Piprahi BO": "852128",
      "Raibhir BO": "852128",
      "Gangapur BO": "852122",
      "Itahari BO": "852219",
      "KMillik BO": "852219",
      "RNKhwan BO": "852219",
      "SMadheli BO": "852219",
      "TBargaon BO": "852219",
      "Behri BO": "852128",
      "Bhawanipur BO": "852128",
      "Gahumani BO": "852128",
      "Gidha BO": "852128",
      "Jharkaha BO": "852132",
      "Jirwa Madheli BO": "852132",
      "Sigion BO": "852128",
      "Sonbersa BO": "852132",
      "Karibiahi BO": "852139",
      "Basanwara BO": "852219",
      "Khurhan Mal BO": "852219",
      "Mahmooda BO": "852219",
      "Muraut BO": "852219",
      "Phulaut BO": "852219",
      "Sahjadpur BO": "852219",
      "Behrari BO": "852128",
      "Hanuman Nagar Chouraha BO": "852128",
      "Kataia Satokar BO": "852128",
      "Maheshua BO": "852128",
      "Ratanpura BO": "852128",
      "Rupauli Lalpatti BO": "852128",
      "Bishanpurarar BO": "852115",
      "Jhalari BO": "852115",
      "Gopalpur BO": "852220",
      "RBarateni BO": "852220",
      "Shyam BO": "852220",
      "Bariahi BO": "852132",
      "Karauti Bazar BO": "852220",
      "Laskari BO": "852220",
      "Murli Chandwa BO": "852220",
      "Naya Nagar BO": "852220",
      "Rampur Khora BO": "852220",
      "Anandpura BO": "852115",
      "Basnahi BO": "852115",
      "Chatra BO": "852115",
      "Sukhashan BO": "852115",
      "Temabhelwa BO": "852115",
      "Jhanjhari BO": "852115",
      "Peernagar BO": "852115",
      "Mohamadpur BO": "852115",
      "Shahpur BO": "852115",
      "Bhatni BO": "852112",
      "Jadua Patti BO": "852112",
      "Ranipatti BO": "852112",
      "SNHat BO": "852112",
      "Jagjiwan Ashram BO": "852113",
      "Manikpur BO": "852113",
      "Sakarpura BO": "852113",
      "Tuniahi BO": "852113",
      "BKorhlahi BO": "852112",
      "Israin BO": "852112",
      "SBToli BO": "852112",
      "SRauta BO": "852112",
      "Maliya BO": "852113",
      "Sabaila BO": "852113",
      "Sahugarh BO": "852113",
      "Turkahi BO": "852113",
      "T Dhanchhoa BO": "852121",
      "Amarpura BO": "852122",
      "Dinapatti BO": "852122",
      "Murliganj Tola BO": "852122",
      "Rampur BO": "852122",
      "Ratanpatti BO": "852122",
      "Rahua BO": "852116",
      "Goth Bardaha BO": "852202",
      "L Bhagwati BO": "852112",
      "Lalkuria BO": "852112",
      "Mangarwara BO": "852112",
      "Pandeypatti BO": "852112",
      "Parmanandpur BO": "852112",
      "Puraini BO": "852112",
      "Ramganj BO": "852112",
      "Bhagwanpur BO": "852113",
      "Bhirkhi BO": "852113",
      "Arraha BO": "852121",
      "BGarhia BO": "852121",
      "Murliganj Bazar BO": "852122",
      "Bhatrandha BO": "852124",
      "Ghailar BO": "852124",
      "Jiwachpur BO": "852124",
      "Srinagar BO": "852124",
      "Aurai BO": "852116",
      "Manjoura BO": "852116",
      "Basudeva BO": "852121",
      "SSimraha BO": "852121",
      "Hareshwari Dighi BO": "852122",
      "Lc Ashthan BO": "852122",
      "Raghunath Pur BO": "852122",
      "Rahta BO": "852122",
      "Tamot Persa BO": "852122",
      "Chikni Phulkaha BO": "852124",
      "Durgapur BO": "852116",
      "Gamail  BO": "852101",
      "Kathotia BO": "852101",
      "Besarh BO": "852112",
      "MBaghaili BO": "852112",
      "Ramnagar Bazar BO": "852112",
      "Bharahi BO": "852113",
      "Gorela BO": "852113",
      "Sukhasan Chakla BO": "852113",
      "Tulsibari BO": "852113",
      "BTekhti BO": "852121",
      "SDakshinwari BO": "852121",
      "HKala BO": "852122",
      "Jorgama BO": "852122",
      "Parwa BO": "852122",
      "Chitti BO": "852124",
      "Kherho BO": "852116",
      "Naya Tola BO": "852116",
      "Laxmipur Lalchand BO": "852101",
      "Madhuban BO": "852101",
      "Hathionda BO": "852101",
      "Madhukarchak BO": "852101",
      "Mohanpur Choumukh BO": "852101",
      "Biri Rampal BO": "852101",
      "Fatehpur BO": "852101",
      "Belari BO": "852114",
      "Belo BO": "852114",
      "Bhadol BO": "852114",
      "Murho BO": "852114",
      "Narsingbag BO": "852114",
      "Rajni BO": "852101",
      "Rajni Babhangama BO": "852101",
      "Sarauni Kala BO": "852101",
      "BAIDYANATHPUR": "852101",
      "PNPur BO": "852114",
      "Rampatti BO": "852114",
      "SMillick BO": "852114",
      "DKalan BO": "852213",
      "Paina BO": "852213",
      "Pararia BO": "852101",
      "Bhairo Patti BO": "852114",
      "Dhurgaon BO": "852114",
      "Pokhram BO": "852114",
      "BBarhona BO": "852213",
      "Chiraouri BO": "852213",
      "Orahi BO": "852108",
      "Rahta Chamukh BO": "852101",
      "Bhatkhora BO": "852114",
      "Jeeta Pur BO": "852114",
      "Bansgopal BO": "852213",
      "Makdampur BO": "852213",
      "Koshlipatti BO": "852108",
      "Abhirampur BO": "852213",
      "Dhaneshpur BO": "852213",
      "Ghosai BO": "852213",
      "Laua Lagam BO": "852213",
      "Koriyarh BO": "852108",
      "Kumarkhand SO": "852112",
      "Mathahi SO": "852121",
      "Murliganj SO": "852122",
      "Singheshwar SO": "852128",
      "TPCollegemadhepura SO": "852113",
      "Madhepura Collectorate SO": "852113",
      "Puraini Bazar SO": "852116",
      "Udakishunganj SO": "852220",
      "Shankarpur Bazar SO": "852132",
      "Behariganj SO": "852101",
      "Bnmu University Madhepura SO": "852113",
      "Gamaharia SO": "852108",
      "Madhepura MDG": "852113",
      "Shah Alam Nagar SO": "852219",
      "Budhma SO": "852114",
      "Chausa SO Madhepura": "852213",
      "Gwalpara SO": "852115"
    },
    "BEGUSARAI": {
      "Papraur BO": "851210",
      "Maheswara BO": "851127",
      "Muzaffara BO": "851127",
      "Sonihar BO": "848201",
      "Gaura BO": "851113",
      "Chamtha BO": "851111",
      "Kaidrabad BO": "851111",
      "Lodiyahi BO": "851111",
      "Rani BO": "851111",
      "Rudauli BO": "851111",
      "Rupasbaj BO": "851111",
      "Samsipur Bhith BO": "851111",
      "Nonpur BO": "851112",
      "Pasopur BO": "851112",
      "Sahuri BO": "851112",
      "Tilrath BO": "851112",
      "Dahiya BO": "851120",
      "Suryapura BO": "851120",
      "Kavia BO": "851120",
      "Aijani BO": "848204",
      "Baraipura BO": "848204",
      "Dunhi BO": "848204",
      "Sihmachakka BO": "848204",
      "Bishanpur Ahok BO": "851204",
      "Ballia Bazar BO": "851211",
      "Bank BO": "851211",
      "Bari Ballia BO": "851211",
      "Bhagatpur BO": "851211",
      "Lakhminia Bazar BO": "851211",
      "Birpur BO": "851127",
      "Fazilpur BO": "851127",
      "Koria Haibatpur BO": "851127",
      "Agapur BO": "851128",
      "Bagras BO": "848201",
      "Deopura BO": "848201",
      "Samsa BO": "851128",
      "Fateha BO": "851111",
      "Manopur BO": "851111",
      "NSheotol BO": "851111",
      "Dhankaul BO": "851112",
      "MBabhangama BO": "851112",
      "Ninga BO": "851112",
      "Amarpur BO": "851118",
      "Neola BO": "851120",
      "Bhith BO": "851120",
      "Korai BO": "848204",
      "Lakhanpatti BO": "848204",
      "Purpathar BO": "848204",
      "Bahuara BO": "851204",
      "Danauli Phulwaria BO": "851211",
      "Gokhle Nagar Bishanpur BO": "851211",
      "Parmanandpur BO": "851211",
      "Rahatpur BO": "851211",
      "Sadpur BO": "851211",
      "Chhourahi BO": "848202",
      "Kumbhi BO": "848202",
      "Balahpur BO": "851129",
      "Dhabauli BO": "851129",
      "Kushmahaut BO": "851129",
      "Mahendrapur BO": "851129",
      "Matihani BO": "851129",
      "Mohanaigh BO": "851129",
      "Paspura BO": "851129",
      "Sihma BO": "851129",
      "Chhatauna BO": "851130",
      "Ajhaur BO": "851131",
      "Kaith BO": "851131",
      "Parna BO": "851131",
      "Dumri BO": "851117",
      "Bakhadda BO": "851217",
      "Raghunathpur BO": "851217",
      "Saligrami BO": "851217",
      "Sandalpur BO": "851217",
      "Cheria BO": "851132",
      "Suja BO": "851218",
      "Amjadpur Pidhauli BO": "851133",
      "Chandaur BO": "851133",
      "Dularpur BO": "851133",
      "Sanjat BO": "851120",
      "Singhaul BO": "851134",
      "Noorpur BO": "851210",
      "Dafarpur BO": "851127",
      "Jokia BO": "851127",
      "Panapur BO": "851127",
      "Saraunja BO": "851127",
      "Chakbedulia BO": "851128",
      "Govindpur BO": "851128",
      "Naipur BO": "851128",
      "Gamharia BO": "848201",
      "Ghagrha BO": "848201",
      "Mohanpur BO": "851131",
      "Rampur BO": "848201",
      "Ahiyapur BO": "851111",
      "Barkhunt BO": "851111",
      "Amba BO": "851112",
      "Jayintigram BO": "851120",
      "Mirzapurchand BO": "851112",
      "Buchauli BO": "851120",
      "Simaria BO": "851126",
      "Simaria Ghat BO": "851126",
      "Malipur BO": "848204",
      "Parora BO": "848204",
      "Gorgama BO": "851211",
      "Madhusudanpur BO": "851211",
      "Mahipa Tol BO": "851211",
      "Tetri BO": "851211",
      "Akopur BO": "848202",
      "Amaridih BO": "848202",
      "Bashi BO": "848202",
      "Badalpura BO": "851129",
      "Rampur Matihani BO": "851129",
      "Safapur BO": "851129",
      "Sahpur BO": "851129",
      "Saidpur BO": "851129",
      "Sisauni Kothi BO": "851130",
      "Dihpar BO": "851127",
      "Pabra BO": "851127",
      "Pahsara Babhangama BO": "851127",
      "Rasidpur BO": "851128",
      "Khodabandpur BO": "848202",
      "Malpur BO": "848202",
      "Phaphaut BO": "848202",
      "Sakarbasa BO": "848202",
      "Sakrauli BO": "848202",
      "Tarabariarpur BO": "848202",
      "Bagdobh BO": "851129",
      "Bhairwar BO": "851129",
      "Chhitraur BO": "851129",
      "Hanspur BO": "851129",
      "Katarmala BO": "851130",
      "Rajakpur BO": "851130",
      "Sankh BO": "851131",
      "Lakhanpur BO": "851133",
      "Maheshpur BO": "851133",
      "Chak Hamid BO": "848201",
      "Sital Rampur BO": "848201",
      "Sonma BO": "848201",
      "Parihara BO": "848201",
      "Madhurapur BO": "851113",
      "Chirainyatol BO": "851111",
      "Gehuni BO": "851111",
      "Godhna BO": "851111",
      "Marachi Kalan BO": "851111",
      "Rajapur BO": "851111",
      "Khizirchak BO": "851112",
      "Pipra Devas BO": "851112",
      "Ishapur BO": "851120",
      "Tajpur BO": "851120",
      "Gara BO": "851120",
      "Gram Garhara BO": "851126",
      "Ekamba BO": "848204",
      "Kumharson BO": "848204",
      "Rajaur BO": "848204",
      "Hardia BO": "851204",
      "Bishanpur BO": "851211",
      "Dandari BO": "851211",
      "Hussaina BO": "851211",
      "Paharpur BO": "851211",
      "Sadanandpur BO": "851211",
      "Banduar BO": "851131",
      "Chandpura BO": "851131",
      "Chhapki BO": "851131",
      "Chilmil BO": "851131",
      "Chauki BO": "851217",
      "Chharrapatti BO": "851217",
      "Panchbir BO": "851217",
      "Phulmallik BO": "851217",
      "Khanjahapur BO": "851132",
      "Mehdasahpur BO": "851132",
      "Nayanagar BO": "851133",
      "Takiadadpur BO": "851133",
      "Binodpur BO": "851134",
      "Kamruddinpur BO": "851134",
      "Keshave BO": "851134",
      "Bariarpurtola Sirsi BO": "848202",
      "Bhoja BO": "848202",
      "Pansalla BO": "848202",
      "Lakho BO": "851129",
      "Maniappa BO": "851129",
      "Naktitola BO": "851129",
      "Ramdiri BO": "851129",
      "Hasanpur BO": "851130",
      "Babhangama BO": "851131",
      "Damdama BO": "851131",
      "Khamhar BO": "851131",
      "Nagdah BO": "851117",
      "Salemabad BO": "851217",
      "Samastipur BO": "851217",
      "Sanha BO": "851217",
      "Arjuntola Baryarpur BO": "851132",
      "Bikrampur BO": "851132",
      "Laruara BO": "851218",
      "Banwaripur BO": "851133",
      "Churamachak BO": "851133",
      "Hariharpur BO": "851133",
      "Mukhtiyarpur BO": "851133",
      "Raghunandanpur BO": "851133",
      "Rachiahi Akashpur BO": "851134",
      "MALHIPUR BO": "851116",
      "Barra BO": "848210",
      "Daulatpur BO": "848210",
      "Akbarpur BO": "811106",
      "Shamho BO": "811106",
      "Ss Barari BO": "811106",
      "Bijulia BO": "811106",
      "GDCollege Road SO": "851101",
      "Mansurchak SO": "851128",
      "Rajaura SO": "851131",
      "Sahebpur Kamal SO": "851217",
      "Sripur SO": "851132",
      "Suhird Nagar SO": "851218",
      "BEGUSARAI ZILA PARISHAD S.O": "851101",
      "Barauni SO": "851112",
      "Begusarai Court SO": "851101",
      "Garhpura SO": "848204",
      "Naokothi SO": "851130",
      "Sri Ram Press SO": "851101",
      "BTPP SO": "851116",
      "Bachhawara SO": "851111",
      "Barauni Oil Refinery SO": "851114",
      "Bihat SO": "851135",
      "Garhara SO": "851126",
      "Lakhminia SO": "851211",
      "Mahna SO": "851210",
      "Mirzapur Banduar SO": "851129",
      "BBazar SO": "848201",
      "BDeorhi SO": "851113",
      "Barauni Urvark Nagar SO": "851115",
      "Baro SO": "851118",
      "Bhagwanpur SO": "851120",
      "Manjhaul SO": "851127",
      "Meghaul SO": "848202",
      "Refinery Township SO": "851117",
      "Sakarpura SO": "848203",
      "Teghra SO": "851133",
      "Ullao SO": "851134",
      "Begusarai HO": "851101"
    },
    "MUNGER": {
      "Dadri BO": "813212",
      "Khabra BO": "813212",
      "Bhikhadih BO": "813212",
      "Bhadaura BO": "811211",
      "Ekashi BO": "811211",
      "Jankinagar BO": "811211",
      "Kharia BO": "811211",
      "Lohchi BO": "811211",
      "B M Tola BO": "811202",
      "Baha Chowki BO": "811202",
      "Bank Harpur BO": "811202",
      "Benigir BO": "811202",
      "Agrahan BO": "811211",
      "Purshotampur BO": "811211",
      "Binda Diyara BO": "811211",
      "Ghorghat BO": "811211",
      "K Shampur BO": "811211",
      "Kalyanpur BO": "811211",
      "Maheshpur BO": "811211",
      "Dariayapur BO": "811202",
      "Kamargama BO": "813221",
      "Launaparsa BO": "813221",
      "Sahora BO": "813221",
      "Sishua BO": "813221",
      "Supour BO": "813221",
      "Kalarampur BO": "811211",
      "Nawagarhi BO": "811211",
      "Ratanpur BO": "811211",
      "Farda BO": "811202",
      "Masumganj BO": "813213",
      "Makwa BO": "813201",
      "Muskipur BO": "813201",
      "Bhagalpur Devgaon BO": "813221",
      "Durmalta BO": "813221",
      "Madhochih BO": "813221",
      "Amaiya BO": "813201",
      "Chorgaon BO": "813201",
      "Ghazipur BO": "813221",
      "Harpur BO": "813221",
      "Manikpur BO": "813221",
      "Rangaon BO": "813221",
      "Barhunia BO": "813221",
      "Kahua BO": "813221",
      "Majhgain BO": "813221",
      "Nowgain BO": "813221",
      "Parwara BO": "813221",
      "Gonai BO": "813201",
      "Lakhanpur BO": "813201",
      "Mamai BO": "813201",
      "Tola Bangalwa BO": "811212",
      "Banhara BO": "811213",
      "Barhauna BO": "811213",
      "Bichhichanchar BO": "811213",
      "Gobadda BO": "811213",
      "Teghara BO": "811213",
      "Tetia Bambar BO": "811213",
      "Sarobagh BO": "811214",
      "Lahauta Ghatwari BO": "811212",
      "Mangarh BO": "811212",
      "Kendua BO": "811213",
      "Khaira BO": "811213",
      "Manjhgay BO": "811213",
      "Muzaffarganj BO": "811213",
      "Parsando BO": "811213",
      "R CMaidan BO": "811213",
      "Pattam BO": "811214",
      "Itwa BO": "811212",
      "Gangata More BO": "811213",
      "Khaira Doray BO": "811213",
      "Lagma BO": "811213",
      "Raja Dih BO": "811213",
      "Rathaitha BO": "811213",
      "Sadobh BO": "811213",
      "Ithari BO": "811214",
      "Safiabad BO": "811214",
      "Orabagicha BO": "811212",
      "Mahgana B.O": "811212",
      "Dariapur BO": "811213",
      "Gaurab Dih BO": "811213",
      "L Laxmipur BO": "811213",
      "Ramankabad BO": "811213",
      "Shivpur Logain BO": "811213",
      "Halimpur BO": "811214",
      "Jamalpur WS": "811201",
      "J Nagar BO": "811202",
      "Shiv Kund BO": "811202",
      "Taufir BO": "811202",
      "Barmasia BO": "811212",
      "Zamin Degree BO": "811202",
      "Bhalar BO": "811212",
      "Kutlupur BO": "811202",
      "Mathar BO": "811202",
      "Shankarpur BO": "811202",
      "Heru Diyara BO": "811202",
      "Singhia BO": "811202",
      "Tikarampur BO": "811202",
      "Amari BO": "811212",
      "Munger HO": "811201",
      "Sangrampur SO Bhagalpur": "813212",
      "Asarganj SO": "813201",
      "TARAPUR SO": "813221",
      "Bariarpur SO Munger": "811211",
      "Basudeopur SO": "811202",
      "Haweli Kharagpur SO": "811213",
      "Munger College SO": "811201",
      "Munger Fort SO": "811201",
      "NDRoad Munger SO": "811201",
      "Jamalpur SO Munger": "811214",
      "Munger Town SO": "811201",
      "Sadar Bazar Jamalpur SO": "811214",
      "Ganga Darshan SO": "811201",
      "Purab Sarai SO": "811201",
      "Belan Bazar SO": "811201",
      "Dharhara SO Munger": "811212",
      "Lal Darwaza SO Munger": "811201"
    },
    "SUPAUL": {
      "KAMALPUR": "847451",
      "KUNAULI": "847451",
      "Dagmara": "847451",
      "Balha BO": "852130",
      "Basbitti BO": "852130",
      "Dabhari BO": "852131",
      "Karupur BO": "852131",
      "Kharail BO": "852131",
      "Maujaha BO": "852131",
      "Ghiwaha BO": "852137",
      "Gwalpara BO": "852137",
      "Mohmmad Ganj BO": "852137",
      "Bauraha BO": "852215",
      "Parsa Madho BO": "852138",
      "Babhangama BO": "852139",
      "Baljora BO": "852139",
      "Jaraila BO": "852139",
      "Malhanwa BO": "852139",
      "Orlaha Bazitpur BO": "852139",
      "Sikarhatta": "847451",
      "Dumra BO": "852130",
      "Hati BO": "852130",
      "Nemua BO": "852130",
      "Parsharma BO": "852130",
      "Telwa Situhar BO": "852130",
      "Bina BO": "852131",
      "Dighiya BO": "852131",
      "Gidarahi BO": "852131",
      "Jobaha BO": "852131",
      "Jolahaniya BO": "852131",
      "Kadampura BO": "852131",
      "Hariharpur BO": "852137",
      "Khunti BO": "852137",
      "Bakaur BO": "852130",
      "Babhani Bhelwa BO": "852131",
      "Basaha BO": "852131",
      "Khokhnaha BO": "852131",
      "Laurh BO": "852131",
      "Monga Sihol BO": "852131",
      "Nirmali BO": "852131",
      "Pathra BO": "852131",
      "Piprakhurd BO": "852131",
      "Chunnimal BO": "852137",
      "Girdharpatti BO": "852137",
      "Pariyahi BO": "852137",
      "Chauhatta BO": "852138",
      "Malarh BO": "852138",
      "Narahi BO": "852138",
      "Barkurwa BO": "852139",
      "Bhura BO": "852139",
      "Chouraha BO": "852132",
      "Daparkha BO": "852139",
      "Barahihat BO": "852130",
      "Bela Terha BO": "852131",
      "Chainsinghpatti BO": "852131",
      "Ghuran BO": "852131",
      "Kariho BO": "852131",
      "Kataia Mahe BO": "852131",
      "Daharia BO": "852137",
      "Lalganj BO": "852137",
      "Mohanpur BO": "852137",
      "Abhuar BO": "852138",
      "Nauwa Bakhar BO": "852138",
      "Tullapatti BO": "852108",
      "Lalpur BO": "852137",
      "Maheshpur BO": "852109",
      "Barail BO": "852110",
      "Kathbanshi BO": "852110",
      "Makuna BO": "852110",
      "Baghla BO": "852139",
      "Mirjawa BO": "852139",
      "Thumha BO": "852131",
      "Ratauli BO": "852138",
      "Singihaun BO": "852138",
      "Sripur Sukhasan BO": "852138",
      "Kumiahi BO": "852139",
      "Kushaha BO": "852139",
      "Laharnia BO": "852139",
      "Latauna BO": "852139",
      "Mohania BO": "852110",
      "Rakia BO": "852110",
      "Ramnagar BO": "852108",
      "Mahadeo Asthan BO": "852109",
      "Ekma BO": "852110",
      "Laukaha BO": "852110",
      "Achalpur BO": "852109",
      "Devipur BO": "852109",
      "Dharhara BO": "852109",
      "Khorma BO": "852133",
      "Marauna BO": "852133",
      "Mungraha": "847452",
      "Barhara": "847452",
      "BELHA": "847452",
      "Mahadev Math BO": "847452",
      "Narendrapur BO": "847452",
      "Belhi": "847452",
      "Hariyahi": "847452",
      "Ganeshpur BO": "852133",
      "Kamrail BO": "852133",
      "Dighia": "847452",
      "Manoharpatti": "847452",
      "Parikonch": "847452",
      "Sarojabela": "847452",
      "Ganaura BO": "852133",
      "Lalpur": "847452",
      "Mouahi": "847452",
      "Baskhora BO": "852133",
      "Charne BO": "852214",
      "Koria Patti BO": "852214",
      "Manganj BO": "852214",
      "Phulkahi BO": "852111",
      "Radha Nagar BO": "852111",
      "Baisi BO": "852215",
      "Daulatpur BO": "852215",
      "Motipur BO": "852215",
      "Sripur BO": "852215",
      "BFulkaha BO": "852214",
      "Bishanpur BO": "852105",
      "Govinpur BO": "852214",
      "Mahulia BO": "852214",
      "Hulas BO": "852111",
      "Jhila Dumari BO": "852111",
      "Sahpur Prithbi Patti BO": "852111",
      "Simrahi Bazar BO": "852111",
      "Hariraha BO": "852215",
      "Janak Lal Basanpatti BO": "852215",
      "Amha BO": "852108",
      "Surjapur BO": "852125",
      "Tekuna BO": "852125",
      "Manganj Bazar BO": "852214",
      "Persa Garhi BO": "852214",
      "Raghunathpur BO": "852214",
      "Rajeshwari BO": "852214",
      "Tamua BO": "852214",
      "Finglas BO": "852111",
      "Haripur BO": "852111",
      "Dumari BO": "852215",
      "Goshpur BO": "852215",
      "Tarhi Bazar BO": "852215",
      "Laxmipur BO": "852218",
      "Sakhua BO": "852218",
      "Simaria BO": "852218",
      "Bhawanipur Patni BO": "852125",
      "Gonaha BO": "852125",
      "Dinapatti BO": "852218",
      "Kamargama BO": "852218",
      "Persa BO": "852218",
      "Rajpur BO": "813102",
      "Jiwachhpur BO": "852125",
      "Sukhanagar BO": "852125",
      "Balbhadrapur BO": "854339",
      "Lakshminia BO": "854339",
      "Guria BO": "852214",
      "PPrayag BO": "852214",
      "Narainpur BO": "852111",
      "Ram Bishanpur BO": "852111",
      "Baisa BO": "852215",
      "Chitti Hanuman Nagar BO": "852215",
      "Korlahi BO": "852215",
      "Ratanpura BO": "852215",
      "Bheropatti BO": "852218",
      "Gelhia Bishanpur BO": "852218",
      "Pakri BO": "852218",
      "Tarhi Bhawanipur BO": "852218",
      "Chilauni BO": "852125",
      "Govindpur BO": "852125",
      "Madhubani BO": "852125",
      "Sanskrit Nirmali BO": "854339",
      "Sitapur BO": "854339",
      "Bhimpur BO": "854339",
      "Matiayari BO": "854339",
      "Cahndpiper BO": "852105",
      "Gangapur BO": "852105",
      "Kamaldaha BO": "852105",
      "Murli BO": "852105",
      "Banailipatti BO": "854340",
      "Baltharwa BO": "852105",
      "Phulwaria BO": "852105",
      "Siyana BO": "852105",
      "Basantpur BO": "854340",
      "Andouli BO": "852105",
      "Banania BO": "852105",
      "Raharia BO": "852105",
      "Saraigarh BO": "852105",
      "Saheban BO": "854338",
      "Hatwaria BO": "852108",
      "Herdi BO": "852108",
      "Supaul HO": "852131",
      "Nirmali SO": "847452",
      "Bhaptiyahi Bazar SO": "852105",
      "Jadia SO": "852214",
      "Karjain Bazar SO": "852215",
      "Sukhpur SO": "852130",
      "Supaul Bazar SO": "852131",
      "Surpatganj SO": "852137",
      "Triveniganj SO": "852139",
      "KUNAUALI BAZAR SO": "847451",
      "Bhimnagar Bairrage SO": "854338",
      "Pratapganj SO Supaul": "852125",
      "Birpur SO Supaul": "854340",
      "Garh Baruari SO": "852110",
      "Pipra Bazar SO": "852218",
      "Tharbitta SO": "852138",
      "Balua Bazar SO": "854339",
      "Ganpatganj SO Supaul": "852109",
      "Jia Ram Raghopur SO": "852111",
      "Janardanpur SO": "852133"
    },
    "KHAGARIA": {
      "Jhiktia BO": "851213",
      "Babu Bagicha BO": "851214",
      "Balha  BO": "851214",
      "Fango BO": "851214",
      "Thatha BO": "851214",
      "Kaithi BO": "851201",
      "Keshavnagar BO": "851201",
      "Bhadas BO": "851204",
      "Bishanpur Dumri BO": "851204",
      "Durgapur BO": "851204",
      "Jahangir Tola BO": "851204",
      "Jalkaura BO": "851204",
      "Labhgaon BO": "851204",
      "Pakrail BO": "851213",
      "Rohiyar BO": "851214",
      "Sansarpur BO": "851214",
      "Siswa BO": "851214",
      "Madarpur BO": "851213",
      "Patel Nagar Bharra BO": "851213",
      "Samaspur BO": "851213",
      "Amni BO": "851214",
      "Saidpur BO": "851214",
      "Sumbha BO": "848201",
      "Chorhli BO": "852161",
      "Mohinath Nagar BO": "852161",
      "Pansalwa BO": "852161",
      "Pirnagra Deorhi BO": "852161",
      "Borney BO": "851201",
      "Paura BO": "851201",
      "Phulwaria BO": "851201",
      "Sonbarsa Ghat BO": "851201",
      "Araria Balha BO": "851203",
      "Gopalpur BO": "851203",
      "Jhawabohiyar BO": "851203",
      "Phudkichak BO": "851203",
      "Asli Kothia BO": "851204",
      "Bela Simri BO": "851204",
      "Chatarghat BO": "851204",
      "Rahimpur BO": "851204",
      "Gaura Shakti Tola BO": "851205",
      "Mehsauri BO": "851205",
      "Deotha BO": "851212",
      "Itmadi BO": "851212",
      "Sondiha BO": "851212",
      "Bishanpur BO": "851215",
      "Kolwara BO": "851216",
      "Lagar BO": "851216",
      "Alauli BO": "848203",
      "Bahadurpur BO": "848203",
      "Burhwa BO": "848203",
      "Meghauna BO": "848203",
      "Raun BO": "848203",
      "Amba B.O (Alauli S.O)": "851206",
      "Hathwan B.O (Alauli S.O)": "851206",
      "Jogia  B.O (Alauli S.O)": "851206",
      "Banni BO": "851213",
      "Farreh BO": "851213",
      "Garhiya BO": "851214",
      "Thuthi BO": "851214",
      "Mali BO": "852129",
      "Dhari Pachout BO": "852161",
      "Dighaun BO": "852161",
      "Dumri BO": "852161",
      "Kurwan BO": "852161",
      "Rohiyama BO": "852161",
      "Sakrohar BO": "852161",
      "Telihar BO": "852161",
      "Kharaita BO": "851201",
      "Nawada BO": "851201",
      "Sahraun BO": "851201",
      "Saraiya BO": "851201",
      "Borna BO": "851202",
      "Garmohini BO": "851203",
      "Goraiya Bathan BO": "851203",
      "Harinmar BO": "851203",
      "Malia BO": "851203",
      "Bandehra BO": "851212",
      "Birwas BO": "851212",
      "Kabela BO": "851215",
      "Babhabgama BO": "851204",
      "Chandpur Khurd BO": "851204",
      "Rani Sakarpura BO": "851204",
      "Tetrabad Chandpura BO": "851204",
      "Amousi BO": "851205",
      "Marar BO": "851205",
      "Ranko BO": "851205",
      "Rasounk BO": "851205",
      "Sanhauli BO": "851205",
      "Pasraha BO": "851212",
      "Piparpanti BO": "851212",
      "Pipra Baisa BO": "851212",
      "Agauni BO": "851216",
      "Bharsoi BO": "851216",
      "Chak Prayag BO": "851216",
      "Dumaria Buzurg BO": "851216",
      "Kulharia BO": "851216",
      "Madhopur BO": "851215",
      "Salarpur BO": "851216",
      "Goriyami BO": "848203",
      "Sahsi BO": "848203",
      "Sanokhar BO": "848203",
      "Simraha BO": "848203",
      "Cherakhera B.O (Alauli S.O)": "851206",
      "Goriyami B.O Alauli S.O)": "851206",
      "Amba BO": "848203",
      "Anantpur BO": "848203",
      "Budhaura BO": "848203",
      "Hathwan BO": "848203",
      "Jogia BO": "848203",
      "Machhra BO": "848203",
      "Anantpur B.O (Alauli S.O)": "851206",
      "Belanawada BO": "852161",
      "Pachaut BO": "852161",
      "Phulwaria Deorhi BO": "852161",
      "Bhutali Malpa BO": "851201",
      "Nirpur BO": "851201",
      "Ratan BO": "851203",
      "Shergarh BO": "851203",
      "Bachauta BO": "851204",
      "Barai Bangraha BO": "851204",
      "Dighni BO": "851204",
      "Khargi Terasi BO": "851204",
      "Mathurapur BO": "851204",
      "Olapur Ganguar BO": "851204",
      "Ram Nagar Math BO": "851204",
      "Khutha BO": "851205",
      "Badia BO": "851213",
      "Dinachakla BO": "851212",
      "Jhanjhara BO": "851212",
      "Pipralathif BO": "851212",
      "Dumaria Khurd BO": "851215",
      "Jorawarpur BO": "851215",
      "Kanhaiyachak BO": "851216",
      "Temtha BO": "851216",
      "Chhera Khera BO": "848203",
      "Haripur BO": "848203",
      "Mohraghat Press BO": "848203",
      "Saharbanni BO": "848203",
      "Raun B.O (Alauli S.O)": "851206",
      "Mohraghat Prass B.O (Alauli S.O)": "851206",
      "Sahsi B.O (Alauli S.O)": "851206",
      "Khagaria Bazar SO": "851204",
      "Khagaria Mukhya Dakghar SO": "851204",
      "Parbatta SO": "851216",
      "Naya Gaon SO Begusarai": "851215",
      "Chautham SO": "851201",
      "Mansi SO": "851214",
      "Alauli S.O": "851206",
      "Beldaur SO": "852161",
      "Gogri SO": "851202",
      "Jamalpur Gogri SO": "851203",
      "Koshi College SO": "851205",
      "Maheshkhunt SO": "851213",
      "Mohaddipur SO Khagaria": "851212"
    },
    "AURANGABAD": {
      "NPGCL Aditi Nagar S.O": "824304",
      "Bedauli BO": "824111",
      "Deshpur BO": "824111",
      "Pandaria BO": "824111",
      "Pirwan BO": "824219",
      "Ballia BO": "824111",
      "CDhongra BO": "824111",
      "Jaitiya BO": "824116",
      "Dumra BO": "824120",
      "Gheura BO": "824111",
      "Mahsu BO": "824111",
      "Matpa BO": "824111",
      "Parta BO": "824111",
      "Ankupa BO": "824123",
      "Ghatrain BO": "824208",
      "Ankora RS BO": "824303",
      "Barem BO": "824303",
      "Chainpur BO": "824303",
      "J H Tendua BO": "824301",
      "Kandi BO": "824301",
      "RAMPUR B.O": "824301",
      "Amilauna BO": "824124",
      "B Sagarpur BO": "824124",
      "Malwan BO": "824124",
      "Narainpur BO": "824124",
      "Panti BO": "824125",
      "Pogar BO": "824125",
      "Beri Khiriawan BO": "824208",
      "Salaiya BO": "824208",
      "Beri BO": "824208",
      "Khadiha Kerka BO": "824303",
      "Naur BO": "824303",
      "Simra BO": "824303",
      "Sonaura BO": "824303",
      "Bara BO": "824301",
      "Chandragarh BO": "824301",
      "ITWAN BO": "824301",
      "Bariyawan B.O": "824301",
      "Bel BO": "824124",
      "Jai Govind Nagar BO": "824124",
      "Kaithi BO": "824124",
      "Kara BO": "824124",
      "Khudwan BO": "824124",
      "Kurhwan BO": "824124",
      "Baksibigha BO": "824125",
      "Bishambharpur BO": "824125",
      "Chiraila BO": "824125",
      "Dugul BO": "824125",
      "Simla BO": "824125",
      "Charkanwan BO": "824125",
      "Jogia BO": "824102",
      "Kanbehari BO": "824102",
      "Kunda BO": "824102",
      "Sahukarma BO": "824125",
      "Baxar BO": "824129",
      "Dadar BO": "824129",
      "Ithat BO": "824102",
      "Riyasat Mali BO": "824102",
      "Silar BO": "824202",
      "Koilwan BO": "824115",
      "Barabanadih BO": "824302",
      "Khajuri Saraiya BO": "824302",
      "Poiwan BO": "824103",
      "Rajoi BO": "824103",
      "Teldiha BO": "824103",
      "Udhampur BO": "824103",
      "Manjurahi BO": "824102",
      "R B Nagar BO": "824102",
      "Sori BO": "824102",
      "Sunurganj BO": "824102",
      "Angrahi BO": "824115",
      "Dhamani BO": "824115",
      "Jhinguri BO": "824115",
      "Mungia BO": "824302",
      "Saratu BO": "824302",
      "Baligaon BO": "824103",
      "Chain BO": "824103",
      "Choukhra BO": "824103",
      "Dadhapi BO": "824103",
      "Khaira Rajpur BO": "824123",
      "Pipra Bagahi BO": "824123",
      "Nagmatia BO": "824208",
      "Umga BO": "824208",
      "Gosaidih BO": "824303",
      "Mahuawan BO": "824208",
      "Pirauta BO": "824303",
      "Simri Dhamni BO": "824303",
      "Belain BO": "824301",
      "Bharub BO": "824124",
      "Dhangain BO": "824124",
      "Dihara BO": "824124",
      "Ramnagar BO": "824124",
      "Sananpura BO": "824124",
      "Tejpura BO": "824124",
      "Kasma BO": "824125",
      "Nima Chaturbhuj BO": "824125",
      "Sihuli BO": "824125",
      "Chubra BO": "824125",
      "Karma Pandey BO": "824129",
      "Chauria BO": "824102",
      "G Kharma BO": "824102",
      "Karma Bhagwan BO": "824102",
      "Khadiha BO": "824102",
      "Naugarh BO": "824102",
      "Rajpur BO": "824102",
      "Barkapandu BO": "824302",
      "Akhoini Regania BO": "824103",
      "Gardi BO": "824103",
      "Kapasia BO": "824103",
      "P Sikandarpur BO": "824103",
      "Saduri Karma BO": "824112",
      "Siris BO": "824112",
      "Son Nagar BO": "824112",
      "Chanda BO": "824113",
      "Gaini BO": "824113",
      "Khairadip BO": "824113",
      "Kashipur Tetaria BO": "824112",
      "R Pithanua BO": "824112",
      "Akauni BO": "824113",
      "Tarari BO": "824113",
      "Anchha BO": "824143",
      "Fort Daudnagar BO": "824143",
      "Jamuawan BO": "824143",
      "Baluganj BO": "824202",
      "Bedhani BO": "824202",
      "Erki BO": "824202",
      "Malhara BO": "824114",
      "Pachaukhar BO": "824202",
      "Singhana BO": "824202",
      "Jaitpur BO": "824114",
      "Akauna BO": "824203",
      "Fag BO": "824203",
      "Sakardiha BO": "824203",
      "Apiroo BO": "824120",
      "Bantara BO": "824120",
      "Jalpura BO": "824120",
      "Khuthan BO": "824120",
      "Barahi BO": "824122",
      "Kurwan BO": "824122",
      "Latta BO": "824122",
      "Phesar BO": "824121",
      "Ramchandra Nagar BO": "824121",
      "Pilchhi BO": "824113",
      "Sansa BO": "824143",
      "Ararua BO": "824202",
      "Bahuara BO": "824202",
      "Dumari BO": "824202",
      "Amari BO": "824203",
      "Ankuri BO": "824203",
      "Belawarish BO": "824203",
      "Budhai BO": "824203",
      "Darha BO": "824203",
      "Darwan BO": "824203",
      "Malhad BO": "824203",
      "Temura BO": "824122",
      "Itar BO": "824122",
      "Deoria Kala BO": "824121",
      "Pauthu BO": "824121",
      "Gijna BO": "824121",
      "Chauri BO": "824127",
      "Charan BO": "824112",
      "Jagatpur BO": "824112",
      "Jagdishpur BO": "824112",
      "Jhumardihra BO": "824112",
      "Satuahi BO": "824112",
      "Shamshernagar BO": "824143",
      "Tarar BO": "824143",
      "Bishunpur Chatti BO": "824202",
      "Dadhpa BO": "824202",
      "Dhibra BO": "824202",
      "Ketaki BO": "824202",
      "Manika BO": "824202",
      "Niyamatpur BO": "824202",
      "Sargawan BO": "824202",
      "Munjhar BO": "824114",
      "Shekhpura BO": "824114",
      "Gorkatti BO": "824203",
      "Kaithi Siro BO": "824203",
      "Dindir BO": "824120",
      "Entwan BO": "824120",
      "G Kenap BO": "824120",
      "Bhadwa Bazar BO": "824122",
      "Dosma BO": "824122",
      "Indrar BO": "824122",
      "Karsara BO": "824122",
      "Bhartholi BO": "824121",
      "Karsawan BO": "824121",
      "Panrawan BO": "824121",
      "Unthu BO": "824121",
      "K P Tendua BO": "824123",
      "Narendra Khap BO": "824123",
      "Turta BO": "824123",
      "Pirthoo BO": "824208",
      "Nima Anjan": "824208",
      "Bairia BO": "824303",
      "Mirjapur BO": "824303",
      "Rajbari Kala BO": "824303",
      "Basdiha BO": "824301",
      "Sattar BO": "824301",
      "Barauli BO": "824124",
      "Chechari BO": "824124",
      "P Babhandiha BO": "824124",
      "Sunbarasa BO": "824124",
      "Arthua BO": "824125",
      "Gordiha BO": "824125",
      "Kerap BO": "824125",
      "Ranidih BO": "824125",
      "Sihuli Khaira BO": "824125",
      "Sarawak BO": "824125",
      "Dihuri Ekauni BO": "824129",
      "Sandya BO": "824129",
      "Bijauli BO": "824102",
      "Ibrahimpur BO": "824102",
      "Jaipur BO": "824102",
      "Risiap BO": "824102",
      "Riyasat Pawai BO": "824102",
      "Sonhathoo BO": "824115",
      "Karmalahang BO": "824302",
      "Mehian BO": "824302",
      "Ghoshta BO": "824103",
      "Khaira Manjhouli BO": "824103",
      "Kona BO": "824103",
      "Paharpura BO": "824103",
      "Urdina BO": "824112",
      "R B Bigha BO": "824112",
      "Tengra BO": "824112",
      "Aranda BO": "824113",
      "Tara BO": "824113",
      "Amauna BO": "824143",
      "Arai BO": "824143",
      "Dhnaoh Bigha BO": "824143",
      "H Bigha BO": "824143",
      "Banua BO": "824202",
      "Belsara BO": "824202",
      "Dumri Belwan BO": "824202",
      "Barpa BO": "824114",
      "Gamhari BO": "824203",
      "Munjhara BO": "824203",
      "Singhari BO": "824203",
      "Tayap BO": "824203",
      "Uphara BO": "824203",
      "Baghoi BO": "824120",
      "Chaurahi BO": "824120",
      "Hathiara BO": "824120",
      "Purhara BO": "824120",
      "Lahasa BO": "824122",
      "Lukka BO": "824122",
      "Molbiganj Pothu BO": "824122",
      "Pokhraha BO": "824121",
      "Sarsawli BO": "824121",
      "Kataiya": "824202",
      "Aurangabad BH HO": "824101",
      "Jakhim SO": "824122",
      "Jamhor SO": "824121",
      "Madanpur SO AurangabadBH": "824208",
      "Tandwa SO AurangabadBH": "824302",
      "Kutumba SO": "824123",
      "Rukundi Jhikatia SO": "824129",
      "War SO": "824103",
      "Nabinagar SO": "824301",
      "Obra SO AurangabadBH": "824124",
      "S S College SO": "824102",
      "Goh SO": "824203",
      "Haspura SO": "824120",
      "Rafiganj SO": "824125",
      "Sihari SO": "824115",
      "Deo SO": "824202",
      "Deohara SO": "824114",
      "Aurangabad Kutchehry SO": "824101",
      "Amba SO": "824111",
      "Barun SO AurangabadBH": "824112",
      "Bhakharua SO": "824113",
      "Daudnagar SO": "824143"
    },
    "BHOJPUR": {
      "Gaharuaon BO": "802204",
      "Jamorhi BO": "802204",
      "Jethwar Bhatt BO": "802204",
      "Babhaniaon BO": "802158",
      "Bahuara BO": "802158",
      "Bairahi BO": "802158",
      "Barad Parwa BO": "802158",
      "Mahuaon BO": "802183",
      "Daulatpur BO": "802163",
      "Saraiyan BO": "802313",
      "Narayanpur BO": "802201",
      "Pachma BO": "802204",
      "Kahathu masurhi BO": "802158",
      "Manudehari BO": "802158",
      "Tenduni BO": "802158",
      "Kurur BO": "802205",
      "Bichhiaon BO": "802206",
      "Bishunpur Dumaria BO": "802314",
      "Sakariramnagar BO": "802204",
      "Masuri BO": "802158",
      "Chaturbhujibaraon BO": "802159",
      "Jamuaon BO": "802159",
      "Rajeyan BO": "802159",
      "Khopira BO": "802206",
      "Maniachh BO": "802206",
      "Sarathua BO": "802206",
      "Sonpura BO": "802206",
      "Birampur BO": "802314",
      "Imadpur BO": "802222",
      "Kolodihri BO": "802222",
      "Moapkalan BO": "802222",
      "Kawara BO": "802162",
      "Masarh BO": "802162",
      "Pachrukhia Kala BO": "802163",
      "Phuhan BO": "802163",
      "Andhari BO": "802222",
      "Sikrahta Kala BO": "802222",
      "Kulharia BO": "802160",
      "Khangaon BO": "802161",
      "Saneya Barhata BO": "802162",
      "Babhangawan BO": "802163",
      "Bagmajhauan BO": "802163",
      "Parasia BO": "802158",
      "Sheopurkunai BO": "802158",
      "Siaruan BO": "802158",
      "Bhakura BO": "802205",
      "Kirhi BO": "802205",
      "Kushi BO": "802205",
      "Bankat BO": "802206",
      "Dularpur BO": "802206",
      "Jamuaon Dihari BO": "802206",
      "Bagar BO": "802222",
      "Dhandihan BO": "802160",
      "Katkaira BO": "802160",
      "Allipur BO": "802161",
      "Bhadwar BO": "802161",
      "Jamira BO": "802161",
      "Babura BO": "802163",
      "Osain BO": "802183",
      "Krishnagarh BO": "802313",
      "Noaon BO": "802204",
      "Pachrukhia BO": "802204",
      "Hetampur BO": "802158",
      "Kakila BO": "802158",
      "Sonbarsa BO": "802112",
      "Belaur BO": "802206",
      "Sakhuan BO": "802206",
      "Gidha BO": "802314",
      "Sripalpur BO": "802314",
      "Panwari BO": "802222",
      "Purahra BO": "802222",
      "Sakaddi BO": "802160",
      "Bandhu Chhapra BO": "802163",
      "Manikpur BO": "802163",
      "Rajapur English BO": "802163",
      "Thakuri BO": "802207",
      "Baruhi BO": "802208",
      "Dhobha Bazar BO": "802156",
      "Kahen BO": "802203",
      "Kaup BO": "802203",
      "Ratnarh BO": "802203",
      "Sahangi BO": "802203",
      "Sheopur BO": "802203",
      "Banahi BO": "802183",
      "Baisadih BO": "802207",
      "Barauli BO": "802207",
      "Basauri BO": "802207",
      "Chakia BO": "802207",
      "Kurmurhi BO": "802207",
      "Sedahan BO": "802207",
      "Sikraulfatehpur BO": "802207",
      "Mainpura BO": "802156",
      "Ayer BO": "802203",
      "Hadiabad BO": "802203",
      "Ichari BO": "802203",
      "Kamariaon BO": "802183",
      "Kahndani BO": "802202",
      "Kataria BO": "802202",
      "Lahthan BO": "802202",
      "Narayan Pur Baghaur BO": "802202",
      "Pitath": "802202",
      "Chasi BO": "802201",
      "Dilia BO": "802201",
      "Karbasin BO": "802201",
      "Pawar BO": "802201",
      "Pharpur BO": "802201",
      "Jalpura BO": "802352",
      "Jokta BO": "802352",
      "Nasaratpur BO": "802352",
      "Bakhorapur BO": "802311",
      "Ekauna BO": "802311",
      "Khawaspur BO": "841312",
      "Lahang Dumaria BO": "802351",
      "Baulipur BO": "802152",
      "Haradiya BO": "802152",
      "Kateyan BO": "802152",
      "Bampali BO": "802312",
      "Belghat Balua BO": "802312",
      "Pasaur BO": "802223",
      "Siyadih BO": "802223",
      "Belauti BO": "802154",
      "Bemari BO": "802154",
      "Kalyanpur BO": "802154",
      "Amehata BO": "802202",
      "Kurmichak BO": "802201",
      "Sewatha BO": "802201",
      "Ramsahar BO": "802311",
      "Sunderpur Barja BO": "802351",
      "Tola Achraj Lal BO": "802351",
      "Karwan BO": "802312",
      "Mahuli BO": "802312",
      "Pirauta BO": "802312",
      "Ratanpur BO": "802312",
      "Majhiaon BO": "802223",
      "Malaur BO": "802223",
      "Mansagar BO": "802223",
      "Mukundpur BO": "802223",
      "Hanswadih BO": "802155",
      "Kesawan BO": "802155",
      "Rajapur BO": "802155",
      "Sandaur BO": "802154",
      "Akarua BO": "802155",
      "Bambhawar BO": "802155",
      "Agrsanda Behara BO": "802156",
      "Dariapur BO": "802156",
      "Purana Haripur BO": "802163",
      "Bachari BO": "802207",
      "Deochanda BO": "802207",
      "Dhrubdihan BO": "802207",
      "Lahritiwaridih BO": "802207",
      "Dhanchhuhan BO": "802208",
      "Dhanauti BO": "802207",
      "Dumaria BO": "802207",
      "Lahrabad BO": "802207",
      "Nagraon BO": "802207",
      "Nonar BO": "802207",
      "Dulamchak Chak Chaudhari BO": "802208",
      "Khajuria BO": "802156",
      "Chhotka Sasaram BO": "802157",
      "Balbandh BO": "802203",
      "Baligaon BO": "802203",
      "Bankat Sikaria BO": "802183",
      "Karisath BO": "802157",
      "Bagwan BO": "802203",
      "Barnaon BO": "802203",
      "Semraon BO": "802203",
      "Pitaru BO": "802202",
      "Bargaon  BO": "802201",
      "Madanpur BO": "802201",
      "Pawana BO": "802201",
      "Waliganj BO": "802301",
      "Lauhar Farna BO": "802311",
      "Mohanpur  Karja BO": "802311",
      "Lachhutola BO": "802351",
      "Salempur BO": "802351",
      "Bharasra Judge BO": "802152",
      "Dawan BO": "802152",
      "Barka Dumra BO": "802312",
      "Bhelai BO": "802312",
      "Chandi BO": "802223",
      "Kumhaila BO": "802223",
      "Amrainawada BO": "802154",
      "Chhwarhi BO": "802155",
      "Basantpur BO": "802156",
      "Baghi BO": "802201",
      "Berath BO": "802201",
      "Lasari BO": "802201",
      "Posawa BO": "802201",
      "Pratappur BO": "802352",
      "Matukpur BO": "802311",
      "Neknam Tola BO": "802311",
      "Balua High School BO": "802351",
      "Bimwan BO": "802152",
      "Chakai BO": "802152",
      "Gangahar BO": "802312",
      "Koil BO": "802223",
      "Lilari BO": "802223",
      "Nagari BO": "802223",
      "Belauna BO": "802154",
      "Ayar BO": "802155",
      "Kesari BO": "802155",
      "Tar BO": "802155",
      "Waina Jamuni Pur BO": "802155",
      "Koshiar BO": "802208",
      "Perhap BO": "802208",
      "Peur BO": "802208",
      "Baga BO": "802164",
      "Chilhose BO": "802164",
      "Ramasarh BO": "802164",
      "Ranisagar BO": "802165",
      "Semaria Patti Ojha BO": "802165",
      "Shahjauli BO": "802165",
      "Khraonkalan BO": "802208",
      "Sandesh Bhatauli BO": "802164",
      "Ekwari BO": "802208",
      "Nawada Pataria BO": "802208",
      "Chilhar BO": "802164",
      "Kundeshar BO": "802165",
      "Sarna BO": "802165",
      "Suhia BO": "802165",
      "Nathmalpur BO": "802316",
      "Sinhaghat BO": "802316",
      "Sohara Tribhuani BO": "802316",
      "Mahulighat BO": "802316",
      "Guljarpur BO": "802208",
      "Kirkiri BO": "802164",
      "Kori BO": "802164",
      "Pandurarampur BO": "802164",
      "Phulari BO": "802164",
      "Bariswan BO": "802165",
      "Bharauli BO": "802165",
      "Birpur BO": "802165",
      "Horil Chhapra BO": "802165",
      "Prashurampur BO": "802316",
      "Piania BO": "802210",
      "Charghat Chanaur BO": "802166",
      "Damodarpur BO": "802166",
      "Gaura BO": "802166",
      "Prasaunda BO": "802112",
      "Bihta English BO": "802209",
      "Barkagaon  BO": "802209",
      "Dakhin Ekauna BO": "802210",
      "Bahoranpur BO": "802166",
      "Chamarpur BO": "802166",
      "LKDera BO": "802112",
      "Tikthi BO": "802112",
      "Deo BO": "802209",
      "Dhangawan BO": "802209",
      "Sara BO": "802209",
      "Isharapura BO": "802112",
      "Bhadsera BO": "802209",
      "Ashni Jaitpur BO": "802210",
      "Deoria BO": "802210",
      "Barakhrauni BO": "802166",
      "Chandakewatia BO": "802166",
      "Karnamepur BO": "802112",
      "Arrah HO": "802301",
      "Arrah Chowk SO": "802301",
      "Benwalia SO": "802351",
      "Dhamar SO": "802156",
      "Gajrajganj SO": "802157",
      "Garhani SO": "802203",
      "HDJain College SO": "802301",
      "Khutahan SO": "802222",
      "Anaith SO": "802302",
      "Barahara SO": "802311",
      "Chandawa SO": "802312",
      "Chaurasta Bihia SO": "802154",
      "Gunari SO": "802313",
      "Jitaura SO": "802159",
      "Karath SO": "802205",
      "Maharaja College SO": "802301",
      "Naya Mohamad  Pur SO": "802163",
      "Pakari SO": "802301",
      "Sahar SO Bhojpur": "802208",
      "Shahbad DisttBoard Ara SO": "802301",
      "Sheoganj SO Bhojpur": "802301",
      "Udawant Nagar SO": "802210",
      "Arrah Kutchey SO": "802301",
      "Dalippur SO Bhojpur": "802155",
      "Hasan Bazar SO": "802204",
      "Jagdishpur SO Bhojpur": "802158",
      "Kayamnagar SO": "802314",
      "Koilwar SO": "802160",
      "Narhi Chandi SO": "802161",
      "Nawada Ben SO": "802162",
      "Piru SO": "802207",
      "Sandesh SO": "802164",
      "Shahpurpatti SO": "802165",
      "Sinha SO": "802316",
      "Umraonganj SO": "802166",
      "Bihia SO": "802152",
      "Charpokhari SO": "802223",
      "Gaudarh Rudranagar SO": "802183",
      "Kasap SO": "802206",
      "Tarari SO": "802209",
      "Agiaon SO": "802201",
      "Agiaon Bazar SO": "802202",
      "Akhagaon SO": "802352"
    },
    "ROHTAS": {
      "Derhgaon BO": "802204",
      "Chaugain BO": "802205",
      "Sheopur BO": "802204",
      "Sakla Bazar BO": "802205",
      "Dhangain BO": "802212",
      "Dharupur BO": "802212",
      "Durgadi BO": "802212",
      "Ghosia Kala BO": "802212",
      "Bishunpur BO": "802219",
      "Siyawak BO": "802219",
      "Bensagar BO": "802220",
      "Sioruan BO": "802220",
      "Udaipur BO": "802220",
      "Barkadih BO": "821113",
      "Dhowdarh BO": "821113",
      "Gotpa BO": "821113",
      "K Mahdeo BO": "802212",
      "Mani BO": "802212",
      "Mohanpur BO": "802212",
      "Motha BO": "802212",
      "Munji BO": "802212",
      "Bisheni Kala BO": "802219",
      "Itriya BO": "802220",
      "Kajhain BO": "802220",
      "Masauna BO": "802220",
      "Dumari Sahpur BO": "821111",
      "Silari BO": "821111",
      "Thanua BO": "821111",
      "Barki Kharari BO": "821113",
      "Barki Mahuli BO": "821113",
      "Burhan Road BO": "821113",
      "Chhotki Chenari BO": "821113",
      "Darigaon BO": "821113",
      "Sikaria BO": "821113",
      "Goshaldih BO": "802212",
      "Jamorhi BO": "802212",
      "Karakat BO": "802212",
      "Maidhara BO": "802212",
      "Nonhar BO": "802212",
      "Sokhara BO": "802219",
      "Karmaini BO": "802220",
      "Tilain BO": "802220",
      "Baraila BO": "821111",
      "Kirhindi BO": "821111",
      "Torni BO": "821111",
      "Alampur BO": "821113",
      "Rajandih BO": "802219",
      "Suara BO": "802219",
      "Baknaura BO": "821311",
      "Kushdihra BO": "821311",
      "Imirtha BO": "802221",
      "Jhalkhoria BO": "821113",
      "Konar BO": "821113",
      "Malwar BO": "821113",
      "Mokar BO": "821113",
      "Muradabad BO": "821113",
      "A Saraiya BO": "821312",
      "Bhadokhra BO": "821312",
      "Sewahi BO": "821312",
      "Dehi BO": "821113",
      "Nishan Nagar Baddi BO": "821113",
      "Sarai BO": "821113",
      "Hurka BO": "821312",
      "Ramdihra BO": "821312",
      "Khuria BO": "821113",
      "Nad BO": "821113",
      "Raipur Chore BO": "821113",
      "Samardihan BO": "821113",
      "Chandanpura BO": "821312",
      "Mahrajganj BO": "821312",
      "Gotapa BO": "802212",
      "Jonhi BO": "802212",
      "Karma BO": "802212",
      "Mamrejpur BO": "821104",
      "Nauhatta BO": "821304",
      "Sabar BO": "821104",
      "Bararhi BO": "821305",
      "A Kala BO": "802226",
      "Kaniyari BO": "802213",
      "Kund BO": "802213",
      "Sujatpur BO": "802213",
      "Nonsari BO": "802215",
      "Sirkhinda BO": "802215",
      "Dhawani BO": "802214",
      "Khanaithi BO": "821107",
      "Kopsar BO": "821107",
      "Mahuari BO": "821107",
      "Panapur BO": "821107",
      "Pipra BO": "821107",
      "Gara BO": "821112",
      "Khudru BO": "821112",
      "Kuchila BO": "821112",
      "Laheri BO": "821112",
      "Jeena BO": "821310",
      "Karma Pathkhaulia BO": "821310",
      "Pawani BO": "821310",
      "Taraon BO": "821310",
      "Thakurai Parasia BO": "821310",
      "Basudeo Dehri BO": "802218",
      "Bishambhrpur BO": "802218",
      "Dharkandha BO": "802218",
      "Kusumhara BO": "802218",
      "Bhitari Bandh BO": "821104",
      "Sikrour BO": "821104",
      "Ugahni BO": "821104",
      "Gangouli BO": "821305",
      "Kanchanpur BO": "821305",
      "Manikpur Bastipur BO": "821305",
      "Baraon Kala BO": "821306",
      "Sohagi BO": "821306",
      "Belvaiyan BO": "802213",
      "Bhanpur BO": "802213",
      "Jamroh BO": "802213",
      "Mahroh BO": "802213",
      "Baraon BO": "802215",
      "Barki Akorhi BO": "802215",
      "Bhelari BO": "802215",
      "Chhatauna BO": "802215",
      "Mujrarh BO": "802215",
      "Penar BO": "802215",
      "Tararh BO": "802215",
      "Baradih BO": "802214",
      "Burhwal BO": "802214",
      "Nawadih BO": "821308",
      "Amaura BO": "821309",
      "Danwar BO": "821309",
      "Balthari BO": "821107",
      "Dhanej BO": "821107",
      "Ghordiha BO": "821107",
      "Daidhan BO": "821112",
      "Dighita BO": "821112",
      "Sadokhar BO": "821104",
      "Jamuhar BO": "821305",
      "Khairhan BO": "821305",
      "Nahauna BO": "821305",
      "Pahleza BO": "821305",
      "Akorha BO": "802213",
      "Andore BO": "802213",
      "Basadihan BO": "802213",
      "Jigana BO": "802213",
      "Barhari BO": "802215",
      "Ghosia BO": "802215",
      "Hathini BO": "802215",
      "Jabra BO": "802215",
      "Karahansi BO": "802215",
      "Amoura BO": "802214",
      "Bad BO": "802214",
      "Belwain BO": "802214",
      "Gorakh Parasi BO": "802214",
      "Dhanhara BO": "821309",
      "Osaon BO": "821309",
      "Parsar BO": "821309",
      "Samahuta BO": "821309",
      "Ararua BO": "821107",
      "Barhutikala BO": "821107",
      "Dibhia BO": "821107",
      "Bahuara BO": "802216",
      "Belwan BO": "802217",
      "Eghara BO": "802217",
      "Pachpokhari BO": "802217",
      "Pararia BO": "802217",
      "Sisirita BO": "802217",
      "Marojhian BO": "821310",
      "Manipur BO": "802217",
      "Muodihan BO": "802217",
      "Amiyawar BO": "821310",
      "Chitokhar BO": "821310",
      "Mahdewa BO": "821310",
      "Sikarian Ultenganj BO": "821310",
      "Nadaon BO": "802218",
      "Amaon Baraon BO": "821104",
      "Chandarkaihti BO": "821104",
      "Dumari BO": "821104",
      "Karwandia BO": "821305",
      "Paruhar BO": "821306",
      "Chilheuon BO": "802213",
      "Sikthi BO": "802213",
      "Babhni BO": "802215",
      "Bhaluahi BO": "802215",
      "Kharari BO": "802215",
      "Panjer BO": "802215",
      "Ruphatha BO": "802215",
      "Semra BO": "802215",
      "Sisirit BO": "802215",
      "Tendua BO": "802215",
      "Deo BO": "802214",
      "Gachhai BO": "802214",
      "Karup Itwa BO": "802214",
      "Shankarpuri BO": "821308",
      "B Kaithi BO": "821309",
      "Puhpi BO": "802218",
      "Rajpur BO": "802218",
      "Saraon BO": "802218",
      "Surware Ke Bararhi BO": "802218",
      "Deokhaira BO": "821107",
      "Gori BO": "821107",
      "Daraon BO": "821112",
      "Doiya BO": "821112",
      "Karup Indrahiyan BO": "802217",
      "Atimi BO": "821310",
      "Dhanaw English BO": "821310",
      "Khirion BO": "821310",
      "Mangraon BO": "821310",
      "Medinipur BO": "821310",
      "Turk Bigha BO": "821310",
      "Arthu BO": "802218",
      "Bhalunidham BO": "802218",
      "Ganj Bharsara BO": "802218",
      "Lilwachh BO": "802218",
      "Natwar Khurd BO": "802218",
      "Chanp BO": "821301",
      "Semri BO": "802211",
      "Majhigawan BO": "821304",
      "Parariya BO": "821304",
      "Chandi BO": "821301",
      "Mednipur BO": "802211",
      "Parchha BO": "821304",
      "Muriyar BO": "821301",
      "Tetrarh BO": "821301",
      "Nawadih Karma BO": "821302",
      "Awarhi BO": "802211",
      "Chatara BO": "802211",
      "Gunsej BO": "802211",
      "Chunhatta BO": "821304",
      "Daranagar BO": "821304",
      "Akorhi BO": "821301",
      "Bank BO": "821301",
      "Gamhariya BO": "821301",
      "Jaipur BO": "821301",
      "Rehal BO": "821304",
      "Tilokhar BO": "821304",
      "Sasaram HO": "821115",
      "Gandhi Path SO": "821115",
      "Gorari SO": "802214",
      "Garh Nokha SO": "802215",
      "Kargahar SO": "821107",
      "Koath SO": "802216",
      "Meari Bazar SO": "802217",
      "Harihar Ganj SO Rohtas": "821310",
      "New Area Sasaram SO": "821115",
      "Sanjhauli SO": "802220",
      "Sasaram Bazar SO": "821115",
      "Tenduni Chauk SO": "802212",
      "Tilouthu SO": "821312",
      "Indrapuri SO": "821308",
      "Kachhwa SO Rohtas": "821309",
      "Rajpur SO Rohtas": "802219",
      "Sasaram Local Board SO": "821115",
      "Sheosagar SO": "821111",
      "Surajpura SO": "802221",
      "Takia Bazar SO": "821113",
      "Kochas SO": "821112",
      "Nasriganj SO": "821310",
      "Natwar SO": "802218",
      "Rohtas SO": "821311",
      "Akorhi Bazar SO": "821301",
      "Darihat SO": "821306",
      "Dehrionsone SO": "821307",
      "Banjari SO": "821303",
      "Chenari SO": "821104",
      "Dawath SO": "802226",
      "Dehri BMP SO": "821307",
      "Baulia SO": "821304",
      "Bikramganj SO": "802212",
      "Dalmianagar SO": "821305",
      "Amjhore Camp SO": "821302",
      "Babhnaul SO": "802211",
      "Dehri R S SO": "821307",
      "Dinara SO Rohtas": "802213"
    },
    "MADHUBANI": {
      "CQuaztola BO": "847122",
      "Hudra BO": "847227",
      "Birpur Harpatti BO": "847227",
      "Ekhathha BO": "847227",
      "Gajhara BO": "847227",
      "Malin Belha BO": "847227",
      "Ekhari BO": "847232",
      "Jhaloun BO": "847232",
      "Basudevpur BO": "847421",
      "Lalmania BO": "847421",
      "Madhopur BO": "847421",
      "Gurmaha BO": "847231",
      "Shahpur BO": "847102",
      "Ranti BO": "847214",
      "Sapta BO": "847214",
      "Siktiahi BO": "847227",
      "Teghra BO": "847227",
      "Khajedih BO": "847232",
      "Kumarkhat BO": "847232",
      "Mahtha BO": "847232",
      "Mirjapur BO": "847232",
      "Piprahi BO": "847232",
      "Sidhhap Parsahi BO": "847232",
      "Tharhi Sidhhap BO": "847232",
      "Basania BO": "847421",
      "Chaturbhuj Piprahi BO": "847421",
      "Karmegh BO": "847421",
      "Laxamipur BO": "847421",
      "Mangrauni BO": "847214",
      "Pilakhwar BO": "847214",
      "Parohi BO": "847122",
      "Bhatraghat BO": "847122",
      "Bherwa BO": "847304",
      "Hiropatti BO": "847304",
      "Sadullahpur BO": "847304",
      "Izra BO": "847337",
      "Satghara BO": "847224",
      "Singhia Deorhi BO": "847306",
      "Noorchak BO": "847122",
      "Pathrahi BO": "847227",
      "Garha BO": "847232",
      "Parsahi Sirsiya BO": "847421",
      "Bhour BO": "847231",
      "Udaypur Bithwar BO": "847231",
      "Raghunidehat BO": "847214",
      "Damala BO": "847304",
      "Bhataura BO": "847306",
      "Jamsam BO": "847234",
      "Maksuda BO": "847234",
      "BBelahi BO": "847215",
      "Belhwar BO": "847215",
      "Jitwarpur BO": "847215",
      "Nazirpur BO": "847215",
      "Shibipatti BO": "847215",
      "Mailam BO": "847235",
      "Bhagwatipurnahar BO": "847236",
      "Biroul BO": "847236",
      "Rakhwari BO": "847411",
      "Awari BO": "847308",
      "Bengra BO": "847308",
      "Durgapatti BO": "847308",
      "Bhalpatti BO": "847239",
      "Dahaura BO": "847239",
      "Kanhouli BO": "847239",
      "Meghoul BO": "847239",
      "Raghopur Deorhi BO": "847239",
      "Lohna BO": "847424",
      "Rampur BO": "847240",
      "Kachhua BO": "847410",
      "Kachhubi BO": "847410",
      "Bishoul BO": "847240",
      "Harlakhi BO": "847240",
      "Sothgaon BO": "847240",
      "Andah BO": "847234",
      "Bhawanipur BO": "847234",
      "Dahibatnathwan BO": "847234",
      "Kalapatti BO": "847409",
      "Mahthour BO": "847409",
      "Murli BO": "847409",
      "Sijaulia BO": "847409",
      "Siswabazar BO": "847409",
      "Sugapatti BO": "847409",
      "Suriahi Ramnagar BO": "847409",
      "Kakraul BO": "847238",
      "Kapileshwar Asthan BO": "847238",
      "Kharaua BO": "847238",
      "Bhariabishanpur BO": "847235",
      "Bhatsimar BO": "847235",
      "Simri BO": "847222",
      "Sugauna BO": "847235",
      "Dumra BO": "847411",
      "Jalsain BO": "847411",
      "Narpatinagar BO": "847239",
      "Mahindwar Navtoli BO": "847109",
      "Sirkharia BO": "847109",
      "Tazpur BO": "847109",
      "Gandhwair BO": "847234",
      "Makrampur BO": "847234",
      "Shambhuar BO": "847234",
      "Bagha Kusmar BO": "847409",
      "Brahmpur BO": "847409",
      "Tengrar BO": "847409",
      "Chapahi BO": "847235",
      "Gangdwar BO": "847235",
      "Korahiyabalha BO": "847235",
      "Pariharpur BO": "847235",
      "Kaithai BO": "847236",
      "Barsam BO": "847411",
      "Raima BO": "847404",
      "Uttra BO": "847308",
      "Baliabikrampur BO": "847239",
      "Nainaghat BO": "847239",
      "Sagarpur BO": "847239",
      "Raje BO": "847424",
      "Sakhwar BO": "847424",
      "Sonre BO": "847410",
      "Nanaour BO": "847109",
      "Phulhar BO": "847240",
      "Pipraun BO": "847240",
      "Birsair BO": "847234",
      "Dahiwatmadhopur BO": "847234",
      "Salempur BO": "847223",
      "Balua BO": "847409",
      "Dhanauja BO": "847409",
      "Siswabarhi BO": "847409",
      "Husainpur BO": "847238",
      "Chichrikanungo BO": "847235",
      "Ghonghour BO": "847235",
      "Kewalpatti BO": "847235",
      "Nakti BO": "847235",
      "Patwara BO": "847235",
      "Shyamsidhap BO": "847235",
      "Bathne BO": "847236",
      "Koilakh BO": "847236",
      "Raghopurbalat BO": "847236",
      "Gangaur BO": "847308",
      "Sonai BO": "847308",
      "Najramahmda BO": "847239",
      "Paithankabai BO": "847239",
      "Sankorthu BO": "847424",
      "Berma BO": "847410",
      "Lawani BO": "847410",
      "Araria Sangra BO": "847109",
      "Parsa BO": "847402",
      "Khauna BO": "847240",
      "Banki BO": "847408",
      "Basipatti BO": "847408",
      "Mahpatia BO": "847408",
      "Pachahi BO": "847408",
      "Phatki BO": "847408",
      "Rahua Sangram BO": "847408",
      "Loha BO": "847213",
      "Saurath BO": "847213",
      "Shubhankarpur BO": "847213",
      "Auraha BO": "847108",
      "Bharkhori BO": "847108",
      "Chhajana BO": "847108",
      "Chichorba BO": "847108",
      "Dhabahi BO": "847108",
      "Karhari BO": "847108",
      "Bela BO": "847226",
      "Bheja BO": "847408",
      "Chunni BO": "847408",
      "Ramchandra BO": "847408",
      "Tardiha BO": "847408",
      "Tengraha BO": "847408",
      "Kariot BO": "847108",
      "Kukurdaura BO": "847108",
      "Dhanchhiha Baruar BO": "847108",
      "Belauncha BO": "847408",
      "Bhakhrain BO": "847408",
      "Bhargama BO": "847408",
      "Bhith Bhagwanpur BO": "847408",
      "Daldal BO": "847408",
      "Sunder Virajit BO": "847408",
      "Basuki Bihari BO": "847305",
      "Jagatpur BO": "847402",
      "Belhi Bhawanipur BO": "847108",
      "Laukahi BO": "847108",
      "Neor BO": "847108",
      "Laukahi Dhanchhiha BO": "847108",
      "Ratnasara BO": "847108",
      "Pastan BO": "847401",
      "Sanpatahi BO": "847401",
      "Tharhi BO": "847401",
      "Belauza BO": "847222",
      "Nagdah Balain BO": "847222",
      "Nagwas BO": "847222",
      "Chandra Dih BO": "847224",
      "Mauahi BO": "847224",
      "Misrauli BO": "847224",
      "Shivnagar BO": "847102",
      "Ganauli BO": "847401",
      "Madna BO": "847401",
      "Ektara BO": "847222",
      "Kerwar BO": "847222",
      "Devhar BO": "847224",
      "Khozpur BO": "847224",
      "Karbi Dhankaul BO": "847102",
      "Meghwan BO": "847102",
      "Damo BO": "847225",
      "Dubahi Mahinathpur BO": "847225",
      "Kamalpur BO": "847225",
      "Marhia BO": "847225",
      "Damodarpur BO": "847223",
      "Dhakjari BO": "847223",
      "Basuara BO": "847212",
      "Bath BO": "847408",
      "Bhagta BO": "847408",
      "Dwalakh BO": "847408",
      "Kapsiya BO": "847213",
      "Bangama BO": "847108",
      "Bhaptiahi BO": "847108",
      "Kakardobh BO": "847108",
      "Makhnaha BO": "847108",
      "Mansapur BO": "847108",
      "Rajaram Patti BO": "847108",
      "Bardaha BO": "847401",
      "Navkarhi BO": "847222",
      "Barri BO": "847102",
      "Bisanpur BO": "847102",
      "Birpur BO": "847225",
      "Bankatta Uren BO": "847223",
      "Barha BO": "847223",
      "Barhampura BO": "847223",
      "Biratpur Birauli BO": "847223",
      "Tisi Narsam BO": "847223",
      "Kakna BO": "847212",
      "Khajuri BO": "847212",
      "Malangia BO": "847212",
      "Amouza BO": "847402",
      "Baikabishanpur BO": "847402",
      "Gahuma Beria BO": "847402",
      "Chachraha BO": "847226",
      "Kamalabari BO": "847226",
      "Usarahi Deodha BO": "847226",
      "Behat Goth BO": "847403",
      "Parjuar BO": "847229",
      "Chatra BO": "847223",
      "Chhaurahi BO": "847228",
      "Maheaswara BO": "847228",
      "Dumari BO": "847212",
      "Sirpurhati BO": "847212",
      "Chikna BO": "847402",
      "Garatol BO": "847402",
      "Sudairatauli BO": "847402",
      "Dhamiapatti BO": "847226",
      "Dorbar BO": "847226",
      "Korahia BO": "847226",
      "Narar BO": "847226",
      "Pursaulia BO": "847226",
      "Deep BO": "847403",
      "Rataul BO": "847403",
      "Umari BO": "847403",
      "Chanouraganj BO": "847404",
      "Harna BO": "847404",
      "Kathia BO": "847404",
      "Sant Nagar BO": "847404",
      "Sukhet BO": "847404",
      "Dhanga BO": "847229",
      "Karmauli BO": "847229",
      "Mureth BO": "847229",
      "Bhakua BO": "847228",
      "Gobraura BO": "847228",
      "Kalikapur BO": "847402",
      "Laxmipur BO": "847228",
      "Taraiya BO": "847102",
      "Hattapur BO": "847225",
      "Jaso BO": "847225",
      "Jonki BO": "847225",
      "Kataya BO": "847225",
      "Ganguli BO": "847223",
      "Genaur BO": "847223",
      "Kataiya BO": "847223",
      "Lorika BO": "847223",
      "Parsauni BO": "847223",
      "Parsuna BO": "847223",
      "Bhachhi BO": "847212",
      "Basuari BO": "847402",
      "Belha BO": "847402",
      "Keotna BO": "847402",
      "Matras BO": "847402",
      "Pirojgadh BO": "847402",
      "Saini BO": "847402",
      "Sangi BO": "847402",
      "Sarauti BO": "847402",
      "Baira BO": "847226",
      "Barhi BO": "847226",
      "Kuar BO": "847226",
      "Parwa BO": "847226",
      "Seli Beli BO": "847226",
      "Sidhap Kalan BO": "847226",
      "Harbhanga BO": "847403",
      "Kaithinia BO": "847403",
      "Lakhnour BO": "847403",
      "Laufa BO": "847403",
      "Raja Kharwar BO": "847403",
      "Harri BO": "847404",
      "Hata Rupauli BO": "847404",
      "Imadpatti BO": "847404",
      "Kako BO": "847404",
      "Kotjia Bharam BO": "847404",
      "Mahrail BO": "847404",
      "Mehath BO": "847404",
      "Haripur Baxi Tola BO": "847229",
      "Haripur Dih Tol BO": "847229",
      "Malmal BO": "847229",
      "Benta BO": "847228",
      "Bhatchaura BO": "847228",
      "Biraul BO": "847228",
      "Barhara BO": "847401",
      "Kulharia BO": "847401",
      "Jafra BO": "847222",
      "Karhi BO": "847222",
      "Nahas Rupauli BO": "847222",
      "Dhamaura BO": "847224",
      "Kharagwani BO": "847224",
      "Pachrukhi BO": "847224",
      "Pirhi BO": "847224",
      "Ramnipatti BO": "847224",
      "Tirhuta BO": "847224",
      "DChandpura BO": "847102",
      "Massa BO": "847102",
      "Chhatauni BO": "847225",
      "Dighia Phent BO": "847225",
      "Ghorabanki BO": "847225",
      "Deopura BO": "847223",
      "Pokhrouni BO": "847223",
      "Sohroul BO": "847223",
      "Kharra BO": "847212",
      "Alola BO": "847402",
      "Amahi BO": "847402",
      "Biraoul BO": "847402",
      "Dharmdiha BO": "847402",
      "Hatni BO": "847402",
      "Jageshwar Asthan BO": "847402",
      "Tilath BO": "847402",
      "Deodha BO": "847226",
      "Dullipatti BO": "847226",
      "Padma BO": "847226",
      "Uchhal BO": "847226",
      "Daiya Kharwar BO": "847403",
      "Gangapur BO": "847403",
      "Rupauli BO": "847403",
      "Belarahi BO": "847404",
      "Choramahrail BO": "847404",
      "Simra BO": "847404",
      "Vijai BO": "847404",
      "Paraul BO": "847229",
      "Rashidpur BO": "847229",
      "Baruar BO": "847228",
      "Datuar BO": "847228",
      "Kanhauli BO": "847228",
      "Kasma Marar BO": "847228",
      "Maina Sukki BO": "847228",
      "Marukia BO": "847228",
      "Hisardeorhi BO": "847230",
      "Jiraul BO": "847230",
      "Naruar BO": "847407",
      "Palimohan BO": "847228",
      "Selra BO": "847228",
      "Thahar BO": "847228",
      "Benta Parsa BO": "847230",
      "Kauwaha Barhi BO": "847230",
      "Siriapur BO": "847230",
      "Barhmotra BO": "847227",
      "Belhi BO": "847227",
      "Sarabe Tarapatti BO": "847228",
      "Akaur BO": "847230",
      "Keotha BO": "847230",
      "Manpour BO": "847230",
      "Bathnaha BO": "847227",
      "Mahua Ekdara BO": "847228",
      "Bhaiyapatti BO": "847230",
      "Bisfi SO": "847122",
      "Andhra SO": "847401",
      "Madhubani HO": "847211",
      "Ladania SO": "847232",
      "Laukaha SO": "847421",
      "Mdb Bara Bazar SO": "847213",
      "RKCollage SO": "847215",
      "Khajauli SO": "847228",
      "M G Bazar SO": "847214",
      "Madhepur SO": "847408",
      "Madhubani Court SO": "847211",
      "Madhwapur SO": "847305",
      "Rahika SO": "847238",
      "Rajnagar SO Madhubani": "847235",
      "Rampatti SO": "847236",
      "Rudrapur SO Madhubani": "847411",
      "Sarisavpahi SO": "847424",
      "Jhanjharpur Court SO": "847404",
      "Khutauna SO": "847227",
      "Narahiya SO": "847108",
      "Sahar SO Madhubani": "847308",
      "Tamuria SO": "847410",
      "Kaluahi SO": "847229",
      "Khirhar SO": "847230",
      "Lohat SO": "847231",
      "Pandaul SO": "847234",
      "Phulparas SO": "847409",
      "Sakri Madhubani SO": "847239",
      "Tulapatganj SO": "847109",
      "Umgaon kothi SO": "847240",
      "Baboobarhi SO": "847224",
      "Basopatti SO": "847225",
      "Benipatti SO": "847223",
      "Bhowara SO": "847212",
      "Jhanjharpur RS SO": "847403",
      "Jhanjharpur SO": "847404",
      "Arerhat SO": "847222",
      "Jaynagar Bazar SO": "847226",
      "Basaith Chandpura SO": "847102",
      "Ghoghardiha SO": "847402",
      "Jaynagar SO": "847226"
    },
    "SAMASTIPUR": {
      "Basatpur BO": "847301",
      "Darshuar BO": "847301",
      "Gobarsitha BO": "847301",
      "Jatmalpura Tira BO": "847301",
      "SMajarahia BO": "847105",
      "Dumri Bindgama BO": "848506",
      "Hardaspur Diara BO": "848506",
      "Mohanpur BO": "848101",
      "Jhakhar BO": "848216",
      "Pokhraira BO": "848113",
      "Ranitol BO": "848113",
      "Singhiakhurd BO": "848113",
      "Barahi BO": "848207",
      "Pushaho BO": "848207",
      "Salha Buzurg BO": "848207",
      "Kharsand BO": "847301",
      "PGhiwahi BO": "847105",
      "Ranna BO": "847105",
      "Boraj BO": "847105",
      "Dharnipatti BO": "848506",
      "Rasalpur BO": "848506",
      "Haripur BO": "848216",
      "Koan Bajitpur BO": "848113",
      "Punas BO": "848113",
      "Sakhwa BO": "848207",
      "Sihma BO": "848207",
      "Tetrahi BO": "848207",
      "Ujan BO": "848207",
      "Akhtiarpur Khajuri BO": "848114",
      "Jahingra BO": "848506",
      "Jalalpur BO": "848506",
      "Madhopur BO": "848211",
      "Ratanpur Bela BO": "848113",
      "Belsandi BO": "848302",
      "Jagmohra BO": "848207",
      "Marthua BO": "848207",
      "Narpa BO": "848207",
      "Sohma BO": "848207",
      "Arout BO": "848210",
      "Sonupur BO": "848210",
      "Jhakhra BO": "848127",
      "Jitwarpur Kumhira BO": "848127",
      "Belsandi Dih BO": "848236",
      "Patpara BO": "848236",
      "Akauna BO": "848209",
      "Phulhara BO": "848209",
      "Rahiyar Kochi BO": "848209",
      "Gauspur Sarsauna BO": "848130",
      "Kasba Tajpur BO": "848130",
      "Chaita BO": "848132",
      "Chandauli BO": "848115",
      "Rampur Samthu BO": "848132",
      "Rupauli BO": "848132",
      "Sagma BO": "848132",
      "Satanpur BO": "848132",
      "Bazidpur BO": "848503",
      "Bochaha BO": "848503",
      "Namapur BO": "848125",
      "Somnaha Mirzanagar BO": "848125",
      "Sormar Baghla BO": "848125",
      "Baidyanathpur BO": "848210",
      "Bishanpur Abhi BO": "848210",
      "Muradpur BO": "848210",
      "Rahua BO": "848133",
      "Harpur Pusa BO": "848125",
      "Kalaunjar BO": "848125",
      "Saidpur BO": "848125",
      "Hasanpur [Rusera BO": "848210",
      "Udaipur BO": "848210",
      "Harilochanpur BO": "848127",
      "Ramchandarpur BO": "848127",
      "Angarghat BO": "848236",
      "Bishanpur Diha BO": "848209",
      "Nirpur Bharwaria BO": "848209",
      "Sonsa BO": "848209",
      "Sumbha Deorhi BO": "848209",
      "Baghi BO": "848130",
      "Motipur BO": "848210",
      "Rahimabad BO": "848130",
      "Belari BO": "848132",
      "Karihara BO": "848132",
      "LMPatti BO": "848132",
      "Harpur Bochaha BO": "848503",
      "Rajwara BO": "848210",
      "Rasalpur Dharha BO": "848210",
      "Akhtiarpur BO": "848127",
      "Barbatta BO": "848127",
      "Bathua Buzurg BO": "848127",
      "Bazidpur Kumhira BO": "848127",
      "Bikrampur Bandey BO": "848129",
      "Karpoorigram BO": "848129",
      "Nirpur BO": "848129",
      "Bhorejairam BO": "848236",
      "Kapan BO": "848236",
      "MTAlampur BO": "848236",
      "Banda BO": "848209",
      "Basudeva BO": "848209",
      "Hardia BO": "848209",
      "Morwarai BO": "848209",
      "Tara BO": "848209",
      "Wari BO": "848209",
      "Bherokhra BO": "848130",
      "Fatehpur Bela BO": "848130",
      "Bhagwanpur Lohagir BO": "848132",
      "Bhagwarpur Kamla BO": "848132",
      "Madhaipur BO": "848503",
      "Mau Dhaneshpur BO": "848503",
      "Raspur Patasia BO": "848503",
      "Sherpur Dhepura BO": "848503",
      "Mohammedpur Koari BO": "848131",
      "Gohi Bishanpur BO": "848133",
      "Kashore BO": "848133",
      "Khan Mirzapur BO": "848503",
      "Shahpur Baghauni BO": "848131",
      "Malinagar BO": "848125",
      "Chakthat BO": "848210",
      "Bhagwatpur BO": "848127",
      "Harpur Barhetta BO": "848127",
      "Manikpur BO": "848127",
      "Bharpura BO": "848236",
      "Buzurgdwar BO": "848236",
      "Nathudwar BO": "848236",
      "Bangarhatta BO": "848209",
      "Dasaut BO": "848209",
      "Lilhaul BO": "848209",
      "Srikameshwar Nagar BO": "848209",
      "Adharpur BO": "848130",
      "Manpura BO": "848130",
      "Akha Bishanpur BO": "848132",
      "Gaopur BO": "848132",
      "Pataili BO": "848132",
      "Garhsisai BO": "848503",
      "Kancha BO": "848503",
      "Simri BO": "848503",
      "Kubouliram BO": "848131",
      "Mohiuddinpur Rajwa BO": "848131",
      "Sadipur BO": "848133",
      "Bahadurpur BO": "848114",
      "Bajitpur Meari BO": "848114",
      "Belamegh BO": "848114",
      "Bombaiya Harlal BO": "848114",
      "Chapta BO": "848114",
      "Depura BO": "848114",
      "Rampur Jalalpur BO": "848114",
      "Chakhaji BO": "848115",
      "Dharmagatpur Bathua BO": "848115",
      "Malikaur BO": "848115",
      "Thahra Gopalpur BO": "848115",
      "Sakarpura BO": "848205",
      "Sasan BO": "848205",
      "Hansopur BO": "848117",
      "Jahangirpur Kothia BO": "848117",
      "Karian BO": "848117",
      "Rebra BO": "848117",
      "Sadipurghat BO": "848117",
      "Shankarpur BO": "848117",
      "Soman BO": "848117",
      "Mordiwa BO": "848134",
      "Dhrubgama BO": "848302",
      "Jagdish Paran BO": "848302",
      "Janardanpur BO": "848302",
      "Jitwaria BO": "848302",
      "Mahmadpur Sakra BO": "848160",
      "Mehsi BO": "848160",
      "Samartha BO": "848160",
      "Begampur BO": "848101",
      "BhDhurlak BO": "848101",
      "Hansa BO": "848101",
      "Harpur Ailoth BO": "848101",
      "LBPura BO": "848101",
      "Lagunia Raghukanth BO": "848101",
      "Lagunia Surya Kanth BO": "848101",
      "Purnahi BO": "848301",
      "Chaksikandar BO": "848122",
      "Jahangirpur Lagma BO": "848208",
      "Sibaisingpur BO": "848502",
      "Nikaspur Nisfi BO": "848121",
      "Ramapur Maheshpur BO": "848121",
      "Raghopur BO": "848211",
      "Sakhmohan BO": "848211",
      "Surauli BO": "848211",
      "Indrawara BO": "848505",
      "Khalispur BO": "848505",
      "Chaksaho BO": "848504",
      "Dharampur Bandey BO": "848504",
      "Gorgama BO": "848504",
      "Ashinchak BO": "848114",
      "Ghataho BO": "848114",
      "Janakpur BO": "848114",
      "Mehsari BO": "848114",
      "Mishratol BO": "848114",
      "Mukhtiarpur BO": "848114",
      "Bishanpur Bathua BO": "848115",
      "Ahilwar BO": "848205",
      "Balahi BO": "848117",
      "Balha Nandenagar BO": "848117",
      "Khairi BO": "848117",
      "Khanpur BO": "848117",
      "Bhagwanpur Desua BO": "848134",
      "Birnamatula BO": "848134",
      "Bishanpur Hakimabad BO": "848134",
      "Chhatauna BO": "848134",
      "Dadhia Asadhar BO": "848134",
      "Harpur Rewari BO": "848134",
      "Mathurapur BO": "848114",
      "Shekhopur BO": "848101",
      "Chhatneshwar BO": "848301",
      "Bishanpur Keothar BO": "848206",
      "Patsa BO": "848206",
      "Chakpahar BO": "848122",
      "Andaur BO": "848502",
      "Barhauna BO": "848502",
      "Bhadaiya BO": "848502",
      "Kalyanpur Basti BO": "848502",
      "Bishanpur Beri BO": "848501",
      "Chapar BO": "848501",
      "Dashara BO": "848501",
      "Harail BO": "848501",
      "Jaunapur BO": "848501",
      "Mahathi BO": "848211",
      "Manda BO": "848211",
      "Patailia BO": "848211",
      "BChaksekhu BO": "848114",
      "Chandchour BO": "848114",
      "Keota BO": "848114",
      "Musapur BO": "848114",
      "Pagra BO": "848114",
      "Paroria BO": "848301",
      "Soeral BO": "848114",
      "Gajpatti BO": "848205",
      "Mauzi BO": "848205",
      "Bandhar BO": "848117",
      "Dinmanpur BO": "848117",
      "Parwana BO": "848117",
      "Raniparti BO": "848117",
      "Jitwarpur Chouth BO": "848134",
      "Ladaura Dargah BO": "848302",
      "Chakhabib BO": "848160",
      "BAiloth BO": "848101",
      "Rahmatpur BO": "848101",
      "Sari BO": "848101",
      "Bhatwan BO": "848206",
      "Kale Narpatnagar BO": "848206",
      "Songar BO": "848122",
      "Bharwari BO": "848208",
      "Mahen BO": "848208",
      "Nayanagar BO": "848208",
      "Gangeshwar Nagar BO": "848502",
      "Mahmmadipur BO": "848502",
      "Kursaha BO": "848501",
      "Rajpur BO": "848501",
      "Sultanpur East BO": "848501",
      "Bibhutipur BO": "848211",
      "Chora Tabhka BO": "848211",
      "Muktapur BO": "848102",
      "Ahmadpur BO": "848505",
      "Gangsara BO": "848505",
      "Kumaiya BO": "848505",
      "Keshonarainpur BO": "848504",
      "Maricha BO": "848504",
      "Sahpur Undi BO": "848504",
      "Basudeopur BO": "848102",
      "Birsisngpur Deorhi BO": "848102",
      "Gopalpur BO": "848102",
      "Kishanpur Yusuf BO": "848505",
      "Pachbhinda BO": "848505",
      "Raghunathpur BO": "848505",
      "Raipur Buzurg BO": "848505",
      "Sarangpur BO": "848505",
      "Sheora BO": "848504",
      "Taradhamaun BO": "848504",
      "Balhajainarain BO": "848125",
      "Dhobgama BO": "848125",
      "Hajpurwa Karua BO": "848125",
      "Harpur Mahmada BO": "848125",
      "Banghara BO": "848114",
      "Chakbahauddin BO": "848114",
      "Chaknawada BO": "848114",
      "Kamraon BO": "848114",
      "Konaila BO": "848114",
      "Pachpaika BO": "848114",
      "Pan Basadhia BO": "848114",
      "Pandit Tol Tabhka BO": "848114",
      "Morsand BO": "848115",
      "Aura BO": "848205",
      "Hasanpur BO": "848205",
      "Rampur Rajwa BO": "848205",
      "Ballipur BO": "848117",
      "Bhataura BO": "848117",
      "Masina BO": "848117",
      "RRBhadrapur BO": "848117",
      "Sripur Gahar BO": "848117",
      "Hasanpur Jitwarpur BO": "848134",
      "Keos Nizamat BO": "848134",
      "Kharaj Jitwarpur BO": "848134",
      "Chakmehsi BO": "848302",
      "Kurba Barhetta BO": "848302",
      "Madhurapur Tara BO": "848302",
      "Bajitpur Bombaiya BO": "848160",
      "Kerai BO": "848160",
      "BRBCollege BO": "848101",
      "Rampur Dudhpura BO": "848101",
      "Satmalpur BO": "848101",
      "Khajuri BO": "848301",
      "Rampur Kushaiya BO": "848301",
      "Nakuni BO": "848206",
      "Harpur Bhindi BO": "848122",
      "Srichandpur Kothia BO": "848122",
      "Geeta Deodha BO": "848208",
      "Mahuli BO": "848208",
      "Rajajan BO": "848502",
      "Tetarpur BO": "848502",
      "Bakarpur BO": "848501",
      "Matiur BO": "848501",
      "Sultanpur West BO": "848501",
      "Gangapur BO": "848121",
      "Bhuswar BO": "848211",
      "Boria BO": "848211",
      "Desari BO": "848211",
      "Bajitpur Karnail BO": "848505",
      "Darwa Mathurapur BO": "848505",
      "Larua BO": "848505",
      "Bahadurpur Patory BO": "848504",
      "Chandpura BO": "848504",
      "Jorpura BO": "848504",
      "Lagunia BO": "848504",
      "Simariabhindia BO": "847301",
      "Dhamaun BO": "844506",
      "Hetanpur BO": "844506",
      "Inayatpur BO": "844506",
      "Samastipur HO": "848101",
      "Baghra SO Samastipur": "848506",
      "Bihrha SO": "848216",
      "Dalsinghsarai SO": "848114",
      "Kalyanpur Chowk SO": "848302",
      "Narhan SO": "848211",
      "Sarairanjan SO": "848127",
      "Singhia SO": "848209",
      "Ujiarpur SO": "848132",
      "Birouli Rural Institute SO": "848113",
      "Kishanpur SO Samastipur": "848301",
      "Kundal SO Samastipur": "848206",
      "Mangalgarh SO": "848208",
      "Mohiuddin Nagar RS SO": "848502",
      "Morwa SO": "848121",
      "Nauraga SO": "848102",
      "Pusa SO": "848125",
      "Samastipur Bazar SO": "848101",
      "Singhia Ghat SO": "848236",
      "Tajpur SO Samastipur": "848130",
      "Warish Nagar SO": "848133",
      "Dalsingsarai Bazar SO": "848114",
      "Jitwarpur SO": "848134",
      "Kashipur Samastipur SO": "848101",
      "P Pur Halai": "848505",
      "Patory Bazar Cinema Chowk SO": "848504",
      "Shambhupatti SO": "848129",
      "Vidhyapati Nagar SO": "848503",
      "Bithan SO": "848207",
      "Dighra SO": "848115",
      "Hassanpur S Mill SO": "848205",
      "Ilmasnagar SO": "848117",
      "Kalyanpur SO Samastipur": "848160",
      "Mohiuddin N Baluahi SO": "848501",
      "Madhopur Dighrua SO": "848122",
      "Mohiuddin Nagar SO": "848501",
      "Patory SO": "848504",
      "Rosera SO": "848210",
      "Rusera Thana SO": "848210",
      "Waini SO": "848131"
    },
    "DARBHANGA": {
      "Kora BO": "847104",
      "Manikauli BO": "847104",
      "Doghra BO": "847302",
      "Kharajpur BO": "846003",
      "MSinuara BO": "846003",
      "Narsara BO": "846003",
      "Ojhaul BO": "846003",
      "Chakwa BO": "847301",
      "Rarhi BO": "847302",
      "Narayanpur BO": "847204",
      "Dilahi BO": "846003",
      "Panchobe BO": "846003",
      "Rupauli Ghat BO": "846003",
      "Kasraur BO": "847427",
      "Pali Mahathwar BO": "847427",
      "Salempur Lagma BO": "847427",
      "Koilam BO": "847301",
      "Chak Tataila BO": "847304",
      "Jagwan BO": "847304",
      "Nagardih BO": "847304",
      "Dulha BO": "847121",
      "Baruary BO": "847107",
      "Dhoi BO": "846009",
      "Kabirchak BO": "846009",
      "Adalpur BO": "847115",
      "Kothia BO": "847306",
      "Madhupur BO": "847306",
      "Barhi BO": "846005",
      "Lalsahpur BO": "846005",
      "Sisodih BO": "846005",
      "Narauchdham BO": "847307",
      "BParsa BO": "847337",
      "Pacharhi BO": "847337",
      "Bhuskaul BO": "846007",
      "Paigambarpur BO": "847123",
      "Baskatti BO": "847202",
      "Habidih BO": "847202",
      "Itwa Shivnagar BO": "847202",
      "Baligaon BO": "847101",
      "Chilha Dilawarpur BO": "847101",
      "Madanpur BO": "847101",
      "Nimathi BO": "847101",
      "Inai BO": "847105",
      "Kothra BO": "847105",
      "BRusselpur BO": "847203",
      "Balthari BO": "847203",
      "DKaskaur BO": "847203",
      "Laxmipur Kakorba BO": "847203",
      "Nadiami BO": "847203",
      "Sonpur BO": "847203",
      "Reorha BO": "847302",
      "Bandhauli BO": "847303",
      "Bishanpur BO": "847303",
      "Chandauna BO": "847303",
      "Garri BO": "847303",
      "Alimabad Nimrauli BO": "847304",
      "Kaithwar BO": "847204",
      "Kakorha BO": "847204",
      "Baghras BO": "847427",
      "Galma BO": "847427",
      "Ganaun BO": "847427",
      "Haripur BO": "847233",
      "Punhad BO": "847427",
      "Rashiyari BO": "847427",
      "Kishanpur Baikunth BO": "847301",
      "Kharari BO": "847301",
      "Bardaha BO": "847304",
      "Dharia BO": "847304",
      "Kumhrauli BO": "847304",
      "Pali BO": "847304",
      "Rathaus BO": "847304",
      "Arai Birdipur BO": "847106",
      "Barhaulia BO": "847106",
      "Moro BO": "847106",
      "Ashraha BO": "847121",
      "Banka BO": "847121",
      "Basauli BO": "847121",
      "Bhoj Pandaul BO": "847121",
      "Darima BO": "847121",
      "Laxman Nagar BO": "847107",
      "Maheshwara BO": "847107",
      "Seodaha Barail BO": "847107",
      "Subhash Keso BO": "847107",
      "Susta BO": "847107",
      "Tharma BO": "847107",
      "Kapchhahi BO": "846009",
      "Mahpara BO": "846009",
      "Milkichak BO": "846009",
      "Sonki BO": "846009",
      "Bijuli BO": "847115",
      "Loam BO": "847115",
      "Tarsarai BO": "847115",
      "Hariharpur BO": "847306",
      "KManjhigama BO": "847306",
      "Kanaur BO": "847306",
      "Karhatia BO": "847306",
      "Sonhaun BO": "846005",
      "Brahampur Sotia BO": "847307",
      "Katka BO": "847307",
      "Chatwan BO": "847337",
      "Chhacha BO": "847337",
      "Chhotaipatti BO": "847337",
      "Saho BO": "847202",
      "Shivram BO": "847233",
      "Sidhauli BO": "847101",
      "Sirua Maner BO": "847101",
      "Srirampur BO": "847101",
      "Arga BO": "847105",
      "Baghauni BO": "847105",
      "Bakmandal BO": "847105",
      "Asi BO": "847203",
      "Bhadhar BO": "847203",
      "Goraman Singh BO": "847203",
      "Jakso Jamalpur BO": "847203",
      "Paghari BO": "847105",
      "Patania BO": "847203",
      "Ahiyari BO": "847304",
      "Ratanpura BO": "846002",
      "Sarwara BO": "847106",
      "Khirma BO": "847121",
      "Nayagaon BO": "847121",
      "SLalganj BO": "847121",
      "Singhaso BO": "847121",
      "Gaighat BO": "847107",
      "Janta BO": "847107",
      "KPirochha BO": "847107",
      "Ladour BO": "847107",
      "Telhan BO": "847115",
      "Nikasi BO": "847306",
      "SDangarwara BO": "847306",
      "BBira BO": "846005",
      "BKAsthan BO": "846005",
      "Bihar Nursary BO": "847123",
      "Kathalia BO": "847123",
      "Mahwa BO": "847202",
      "Sher Bijulia BO": "847202",
      "Sihaul BO": "847202",
      "Dhanauli BO": "847101",
      "Gujrauli BO": "847101",
      "Harhachcha BO": "847101",
      "Hawasa BO": "847101",
      "Jogiara BO": "847101",
      "Khaira Kunji BO": "847101",
      "Matunia BO": "847105",
      "Narayandohat BO": "847105",
      "Afzala BO": "847203",
      "Ahilwara BO": "847203",
      "Kanhai BO": "847203",
      "Kothram BO": "847203",
      "PBuzurg BO": "847203",
      "Sahasram BO": "847203",
      "Katki Bazar BO": "846004",
      "Qadirabad BO": "846004",
      "Katraul BO": "847302",
      "Agai BO": "847303",
      "Jahangirtola BO": "847303",
      "Sherpur BO": "847204",
      "Dihrampur BO": "846003",
      "Goriari BO": "846003",
      "PBasant BO": "846003",
      "Taralahi BO": "846003",
      "Adharpur BO": "847427",
      "Jhagarua BO": "847427",
      "Pohaddi Bela BO": "847427",
      "Tarwara BO": "847202",
      "Ghoshrama BO": "847301",
      "Hathauri BO": "847301",
      "Muraitha BO": "847304",
      "Raghauli BO": "847304",
      "Araila BO": "847106",
      "ABabhangama BO": "847121",
      "Jalwara BO": "847121",
      "Balour BO": "847422",
      "Benibad BO": "847107",
      "Kabaria Khutwara BO": "846009",
      "Kharua BO": "847115",
      "Karjapatti BO": "847306",
      "Madhopatti BO": "847306",
      "Bariaul BO": "846005",
      "Siso BO": "846005",
      "Sanahpurdih BO": "847307",
      "Belhi": "847337",
      "Lahwar BO": "847337",
      "Sadiquepur BO": "847337",
      "Atihar BO": "846007",
      "GBasailha BO": "846007",
      "Rampura BO": "847123",
      "Brahampatti BO": "847202",
      "Bhacchi BO": "847101",
      "Jorja BO": "847101",
      "Mirzapur BO": "847101",
      "Patore BO": "847101",
      "Ughra BO": "847101",
      "Baghra Simri BO": "847105",
      "Khangraitha BO": "847105",
      "Thathopur BO": "847105",
      "Akabarpur Bank BO": "847203",
      "Aurahi BO": "847203",
      "Bauram BO": "847203",
      "Ladaho BO": "847203",
      "Nishihara BO": "847203",
      "Uchhati BO": "847203",
      "Atahar BO": "847201",
      "Baghaul BO": "847201",
      "Baigani BO": "847201",
      "Laxmanpur BO": "847201",
      "Mahuli BO": "847201",
      "Nawada BO": "847201",
      "Shivnagarghat BO": "847103",
      "Basatwara BO": "847428",
      "Kansi BO": "847428",
      "Bhawanipur BO": "847103",
      "Kaligaon BO": "847104",
      "Adhloam BO": "847201",
      "Dakaram Pauri BO": "847201",
      "Kanthudih BO": "847201",
      "SRBithauli BO": "847201",
      "Sahari BO": "847201",
      "Andauli BO": "847103",
      "Motipur BO": "847103",
      "Ruchighat BO": "847103",
      "Kamrouli BO": "847428",
      "Chakla BO": "847201",
      "Jarso BO": "847201",
      "Trimuhanighat BO": "847201",
      "Antaur BO": "847103",
      "Harsinghpur BO": "847103",
      "KJagdishpur BO": "847103",
      "Mohiuddinagar Pakari BO": "847103",
      "Neori BO": "847103",
      "Ashthua BO": "847104",
      "Ramauli BO": "847201",
      "Sajanpura BO": "847201",
      "Sajhuar BO": "847201",
      "Susari BO": "847201",
      "Jayantipur BO": "847103",
      "Korthu BO": "847103",
      "Mahinam BO": "847103",
      "Nari BO": "847103",
      "Pohhadi BO": "847103",
      "Rohar BO": "847103",
      "Banauli BO": "847428",
      "Sugrain BO": "848207",
      "Tilkeshwar BO": "848207",
      "Nowdega Balha BO": "848209",
      "Balha BO": "848209",
      "Deokuli BO": "848209",
      "Harinagar BO": "848209",
      "Jagannathpur BO": "848209",
      "Bairampur BO": "848209",
      "MorwaraIi BO": "848209",
      "Barra BO": "848206",
      "Satighat BO": "848213",
      "Simartoka BO": "848213",
      "Usri BO": "848213",
      "Bargaon BO": "848213",
      "Hirni BO": "848213",
      "Ithar BO": "848213",
      "Beridharsham BO": "848213",
      "Dinmo BO": "848213",
      "Jhajhra BO": "848213",
      "Bhindua BO": "848213",
      "Chigri BO": "848213",
      "Keotgama BO": "848213",
      "Ujua BO": "848213",
      "Bazitpur BO": "847422",
      "Bhandar Sogani BO": "847422",
      "Brahampura BO": "847422",
      "Ratwara BO": "847301",
      "Sadhopur BO": "847301",
      "Dasauth BO": "847405",
      "Dhamsain BO": "847405",
      "Dhamuara BO": "847405",
      "Gorkha BO": "847405",
      "Thengaha BO": "847405",
      "Tumaul BO": "847405",
      "LAGMA Rambhadrapur BO": "847407",
      "Amaithi BO": "847233",
      "Badarbanna BO": "847233",
      "Maun Behat BO": "847423",
      "BMVPith BO": "846002",
      "MSajhouti BO": "847301",
      "Rasalpur BO": "847301",
      "Alinagar BO": "847405",
      "NN Patti BO": "847405",
      "Gangauli BO": "847407",
      "Baghant BO": "847422",
      "Bishwanathpur Tarauni BO": "847233",
      "Habi Bhuar BO": "847233",
      "Lahatta BO": "847423",
      "Chanaur BO": "847422",
      "Ramnagar Dhusi BO": "847233",
      "Bathia BO": "847423",
      "Bauharwa BO": "847423",
      "Garaul BO": "847423",
      "Hariath BO": "847423",
      "Sirnia BO": "846002",
      "Thalwara BO": "846002",
      "P Dharampur BO": "847301",
      "Dadpatti BO": "847405",
      "Jaideopatti BO": "847405",
      "Sahjauli BO": "847405",
      "Sinuar Gopal BO": "847429",
      "Pokhar Bhinda BO": "847407",
      "Tatuar BO": "847422",
      "Batho BO": "847233",
      "Fardaha BO": "847233",
      "Kathra BO": "847423",
      "Chandanpatti BO": "846002",
      "MPBahadurpur BO": "846002",
      "Rasidpur BO": "847423",
      "Bahadurpur BO": "846002",
      "Dekuli BO": "846002",
      "RAPMills BO": "846002",
      "Bahera SO": "847201",
      "C M College SO": "846004",
      "Jogiara SO": "847303",
      "Darbhanga Bara Bazar SO": "846004",
      "K D S U SO": "846008",
      "Bharathi SO": "847428",
      "Darbhanga Chowk SO": "846004",
      "Darbhanga City SO": "846004",
      "Jalley SO": "847302",
      "Benipur SO": "847103",
      "Bharwara SO": "847104",
      "Kamtaul SO": "847304",
      "Kathalwari SO": "846004",
      "Muria SO": "847115",
      "Kurso Nadiami SO": "847405",
      "Nehra SO": "847233",
      "Keotsa Baruari SO": "847107",
      "Kilaghat SO": "846004",
      "Laxmisagar SO Darbhanga": "846009",
      "Pindaruch SO": "847306",
      "Bishnupur SO Darbhanga": "847204",
      "DMC SO": "846003",
      "Putai SO": "847423",
      "SHMC SO": "846002",
      "Sahoparari SO": "847202",
      "Keoti Ranway SO": "847121",
      "Postal Traning Centre SO": "846005",
      "Saramohanpur SO": "846007",
      "Singhwara SO": "847123",
      "Anandpur SO": "847101",
      "Baheri SO Darbhanga": "847105",
      "Benta South SO": "846003",
      "Hayaghat Bilashpur SO": "847301",
      "Imambari SO": "846001",
      "Kusothar SO": "847429",
      "Laheriasarai Court SO": "846001",
      "Lohna Road SO": "847407",
      "Kansi Simri SO": "847106",
      "Ratanpur SO Darbhanga": "847307",
      "Ryam Factory SO": "847337",
      "Subhankarpur SO": "846006",
      "Biraul SO": "847203",
      "Ghanshyampur SO Darbhanga": "847427",
      "Manigachi SO": "847422",
      "Laheriasarai HO": "846001",
      "Darbhanga HO": "846004",
      "Kuseshwar Asthan SO": "848213"
    },
    "PURBI CHAMPARAN": {
      "Konhia BO": "845432",
      "Siswa Kharar BO": "845432",
      "Bairiya BO": "845424",
      "Chainpur BO": "845437",
      "Laxmipur Pokhariya BO": "845433",
      "Murla BO": "845433",
      "Singasani BO": "845433",
      "Gonaha BO": "845305",
      "Jokiyari BO": "845305",
      "Kaurihar BO": "845305",
      "Sihpur BO": "845305",
      "Sikandarpur BO": "845434",
      "Chhapra Bahas BO": "845435",
      "Janerwa  BO": "845435",
      "Mukhalishpur Pachrukha BO": "845435",
      "Bahuarawa BO": "845456",
      "Chhapawa Phulwaria BO": "845456",
      "Mali BO": "845456",
      "Kajraha BO": "845436",
      "Baharupia BO": "845437",
      "Barharwa Kala BO": "845437",
      "Hardia BO": "845401",
      "Darmaha BO": "845432",
      "Hazipur BO": "845432",
      "Siswa Patna BO": "845432",
      "Dhanhar Dihuli BO": "845433",
      "Belwa BO": "845305",
      "Bariariya BO": "845434",
      "Manglapur Rajpur BO": "845434",
      "Puchharia BO": "845434",
      "Bairiadih BO": "845435",
      "Sugauli Bazar BO": "845456",
      "Bahuarwa Gopi Singh BO": "845436",
      "Madhuwahan Brit BO": "845436",
      "Semraha BO": "845436",
      "Gariba BO": "845432",
      "Jasauli Jamunia BO": "845432",
      "Bela BO": "845433",
      "Champapur BO": "845433",
      "Inrawa BO": "845433",
      "Tola Mauje BO": "845433",
      "Adhkaparia Phulwaria BO": "845433",
      "Bhelahi BO": "845305",
      "Hardiya BO": "845305",
      "Thikaha Bhawanipur BO": "845434",
      "BRTNariarwa BO": "845435",
      "Khagani BO": "845435",
      "Sapaha BO": "845435",
      "Gudra BO": "845456",
      "Sugaon BO": "845456",
      "Gheghawa BO": "845436",
      "Raghunathpur BO": "845433",
      "Ahiraulia BO": "845417",
      "Amodei BO": "845433",
      "Andhra BO": "845433",
      "Bagahi BO": "845433",
      "Majharia BO": "845433",
      "Parsauna Madan BO": "845433",
      "Patani BO": "845433",
      "Noniyadih BO": "845305",
      "Parsurampur BO": "845416",
      "Purandara BO": "845305",
      "Siswa Sounaha BO": "845305",
      "Belghati BO": "845435",
      "Belwa Rai Khas BO": "845435",
      "Bhargawan BO": "845435",
      "Bhataha BO": "845456",
      "Kaithwalia BO": "845456",
      "Parsa BO": "845456",
      "Sripur BO": "845456",
      "Sukul Pakar BO": "845456",
      "Dalpat Bishunpur BO": "845427",
      "Gonahi BO": "845427",
      "Jhitkahiya BO": "845406",
      "Jihuli BO": "845427",
      "Bakhari BO": "845413",
      "Gamharia BO": "845431",
      "Jhitkahia BO": "845431",
      "Kukurjari BO": "845431",
      "Majhar Gohiya BO": "845428",
      "Sishani BO": "845428",
      "Balua Zulfikarabad BO": "845457",
      "Bara Shankar BO": "845457",
      "Saraiya Gopal BO": "845457",
      "Ibrahimpur Parsauni BO": "845430",
      "Izor Bara BO": "845430",
      "Kalu Pakar BO": "845430",
      "Kodariya BO": "845430",
      "Muzia BO": "845430",
      "Ashok Pakari BO": "845429",
      "Bangari BO": "845429",
      "Belwatia BO": "845429",
      "Chandrahiya BO": "845429",
      "Madhopur Karamwa BO": "845431",
      "Kashi Pakari BO": "845406",
      "Nankardewa BO": "845406",
      "Narha Panapur BO": "845406",
      "Salempur BO": "845406",
      "Bhopatpur BO": "845432",
      "Khori Pakar BO": "845427",
      "Noonfarwa BO": "845427",
      "Ajgarwa BO": "845428",
      "Dhanujee BO": "845428",
      "Itwa BO": "845428",
      "Bela Baiju BO": "845457",
      "Parsauni Kapoor BO": "845457",
      "Bisunpur Basant BO": "845430",
      "Mankarwa BO": "845430",
      "Jhakhara BO": "845429",
      "MBBathana BO": "845429",
      "Pajiarwa BO": "845431",
      "Madhopur Keso BO": "845406",
      "Noniman BO": "845406",
      "Bhgwatia BO": "845432",
      "Barmashwa BO": "845437",
      "Gai Ghat BO": "845437",
      "Kotwa BO": "845437",
      "Makhuwa BO": "845437",
      "Manikpur BO": "845437",
      "Sapahi BO": "845437",
      "Talwa Pokhar BO": "845437",
      "Tikaita BO": "845437",
      "Jagiraha BO": "845437",
      "Jaishingpur BO": "845437",
      "Jasauli Patti BO": "845437",
      "Kushar BO": "845437",
      "Madhopur BO": "845415",
      "Shankar Sharaiya BO": "845437",
      "Narayanpur BO": "845427",
      "Padmuker BO": "845427",
      "Barkagaon BO": "845428",
      "Betauna BO": "845457",
      "Mirzapur BO": "845457",
      "Deokulia BO": "845430",
      "Kumhrar BO": "845430",
      "Jiwdhara BO": "845429",
      "Mathurapur BO": "845429",
      "Mansingha BO": "845431",
      "Phulwar BO": "845431",
      "Bhurkurwa BO": "845406",
      "Murarpur BO": "845437",
      "Bakhari Mahesh BO": "845413",
      "Shambhuchak BO": "845413",
      "Balo Chak BO": "845412",
      "Baramania BO": "845412",
      "Bhuwan Chapra BO": "845412",
      "Dulama BO": "845414",
      "Jitaura BO": "845414",
      "Majhaulia BO": "845414",
      "Sundar Patti BO": "845414",
      "Mathia Brit BO": "845302",
      "Pakaria BO": "845302",
      "Purshottampur BO": "845302",
      "Semrahia BO": "845302",
      "Ahiraulia Bhinak BO": "845415",
      "Baidnathpur BO": "845415",
      "Khartari BO": "845415",
      "Semra BO": "845415",
      "Kuriya BO": "845416",
      "Parsauni Kishun BO": "845416",
      "Ramkaran Pakari BO": "845416",
      "Sagar BO": "845416",
      "Dumra BO": "845417",
      "Kararia BO": "845417",
      "Machhargawa BO": "845417",
      "Mahatha Tola BO": "845417",
      "Ruphara BO": "845418",
      "Semra Sagardina BO": "845418",
      "Sirauna BO": "845418",
      "Athmohan BO": "845303",
      "Jamunia Koraiya BO": "845303",
      "Salaha BO": "845419",
      "Khodadpur BO": "845420",
      "Koilhara BO": "845420",
      "Balua BO": "845422",
      "Jadopur BO": "845422",
      "Paharia BO": "845422",
      "Panditpur BO": "845422",
      "Rai Kararia BO": "845422",
      "Son Barsa BO": "845422",
      "Mangalpur BO": "845423",
      "Gad Bahuari BO": "845440",
      "Bijdhari Nizamat BO": "845424",
      "Gawandri BO": "845304",
      "Karmawa BO": "845304",
      "Katha Loknathpur BO": "845401",
      "Laxmipur BO": "845401",
      "Siswania BO": "845301",
      "Damodarpur Mathia BO": "845425",
      "Mamarkha BO": "845425",
      "Nawadih BO": "845458",
      "Radhia BO": "845458",
      "Dilawarpur BO": "845426",
      "Madhopur Govind BO": "845426",
      "Mahamada BO": "845426",
      "Sirsia Ganesh BO": "845426",
      "Kanchhedwa BO": "845422",
      "Math Lohiyar BO": "845422",
      "Nonea BO": "845422",
      "Rampur Khajuria BO": "845423",
      "Sembhuapur BO": "845423",
      "Laukaria BO": "845440",
      "ParsaunaTapasi BO": "845440",
      "Palanwa BO": "845440",
      "Sakarar BO": "845440",
      "Balua Tola BO": "845304",
      "Barharwa FMohamad BO": "845304",
      "Barwa Khurd BO": "845304",
      "Chandanwara BO": "845304",
      "Ajgarhimath BO": "845401",
      "Chailaha BO": "845401",
      "Dhekaha Bazar BO": "845401",
      "Bharwalia BO": "845425",
      "Mankararia BO": "845422",
      "Pannapur Ranjeeta BO": "845422",
      "Siswa Bazar BO": "845422",
      "Purvi Pakari BO": "845423",
      "Sarotar BO": "845423",
      "Bankat BO": "845424",
      "Kunwar Dhekha BO": "845424",
      "Gurhanawa BO": "845304",
      "Telhara Kala BO": "845304",
      "Khairi Ajgarwa BO": "845401",
      "Madhubanighat BO": "845401",
      "Barawa BO": "845302",
      "Belahiya BO": "845301",
      "Bhawanipur Bazar BO": "845301",
      "Bishunpurwa BO": "845301",
      "Gamaharia Kala BO": "845301",
      "Narkatia BO": "845301",
      "Purainia BO": "845301",
      "Sirsia Khurd BO": "845301",
      "Sirsiya Kala BO": "845301",
      "Chandrahia  BO": "845411",
      "Ghiwadhar BO": "845411",
      "Gobindapur Bazar BO": "845411",
      "Jagapakar BO": "845411",
      "Ahiman Chapra BO": "845413",
      "Bahlolpur BO": "845418",
      "Pakari Dixit BO": "845412",
      "Pipra Khem BO": "845412",
      "Sawangia BO": "845412",
      "Sital Pur BO": "845412",
      "Bijayee BO": "845315",
      "Champapur Koiria BO": "845315",
      "Dipahi Dharharwa BO": "845315",
      "Mathia Bhopat BO": "845315",
      "Darpa BO": "845302",
      "Ekdari BO": "845302",
      "Juafar BO": "845302",
      "Tinkoni BO": "845302",
      "Rampur BO": "845415",
      "Sariyatpur Khan Tola BO": "845416",
      "Olaha Madubani BO": "845417",
      "Bara Jai Ram BO": "845418",
      "Barharwa Siwan BO": "845418",
      "Haraj Narullahpur BO": "845418",
      "Harnaraina BO": "845418",
      "Karsahiya BO": "845418",
      "Kathmalia BO": "845418",
      "Kadamawa BO": "845303",
      "Khurahiya BO": "845303",
      "Nawada Izara BO": "845419",
      "Pipara BO": "845419",
      "Krishna Nagara BO": "845420",
      "Madhurapur BO": "845420",
      "Rupani BO": "845420",
      "Belwa Madho BO": "845423",
      "Dumariaghat BO": "845423",
      "Karhan BO": "845423",
      "Naya Gaon BO": "845424",
      "Sundarpur BO": "845424",
      "Tajpur Patkhaulia BO": "845424",
      "Phulwaria BO": "845304",
      "Pataura BO": "845401",
      "Rupdih BO": "845401",
      "Siswa BO": "845401",
      "Sirsa Colony BO": "845401",
      "Suraha BO": "845401",
      "MSikatia BO": "845425",
      "Nagdaha BO": "845425",
      "Sirni Bazar BO": "845425",
      "Chhapkahia BO": "845458",
      "Puran Chapra BO": "845426",
      "Bariarpur BO": "845401",
      "Rulahi BO": "845401",
      "Bakhathaura BO": "845301",
      "Dubaha BO": "845301",
      "Gamharia Khurd BO": "845301",
      "Bahadurpur BO": "845411",
      "Kritpur Mathiya BO": "845411",
      "Kalyanpur BO": "845413",
      "Katahariya BO": "845413",
      "Harpur Nag BO": "845412",
      "Kuawa BO": "845412",
      "Bagaha Champaran BO": "845315",
      "Mazirwa BO": "845315",
      "Nonuara BO": "845315",
      "Bokane Kala BO": "845414",
      "Chorma BO": "845414",
      "Nawada BO": "845414",
      "Chanari BO": "845302",
      "Jitpur BO": "845302",
      "Kodarkat BO": "845302",
      "Mahuawa Imilia BO": "845302",
      "Tikulia BO": "845416",
      "Mirpur BO": "845415",
      "Patjirwa BO": "845415",
      "Bediban Madhuban BO": "845416",
      "Khairimal BO": "845416",
      "Bhada Murli BO": "845417",
      "Sabaiya BO": "845437",
      "Shyampur BO": "845417",
      "Barharwa Lakhansen BO": "845418",
      "Harnatha BO": "845418",
      "Kapur Pakari BO": "845418",
      "Laukhan BO": "845418",
      "Raghopur Gangapipar BO": "845418",
      "Jhauaram BO": "845418",
      "Bankatwa BO": "845303",
      "Purnahiya BO": "845303",
      "Sripur Kawaiya BO": "845303",
      "Chandi Sthan BO": "845419",
      "Kauriya BO": "845420",
      "Naurangia BO": "845420",
      "Chatia BO": "845425",
      "Sonwal BO": "845425",
      "Ganga Pipara BO": "845458",
      "Paharpur BO": "845458",
      "Bans Ghat BO": "845426",
      "Gawandra BO": "845426",
      "Madan Sirsiya BO": "845426",
      "Bhandar BO": "845427",
      "Rampurwa Bazar BO": "845458",
      "Garahiya BO": "845426",
      "KHariram BO": "845426",
      "Kasba Mehsi BO": "845426",
      "Kataha BO": "845426",
      "Auraia BO": "845301",
      "Harpur BO": "845301",
      "Lauriya BO": "845411",
      "Bishambharapur BO": "845413",
      "Parsauni Wajit BO": "845413",
      "Koila Belwa BO": "845412",
      "Biradban Mirchaiya BO": "845412",
      "Nimoiya BO": "845315",
      "Inarwa Phulwar BO": "845315",
      "Chapra Bihari BO": "845414",
      "Siraha BO": "845414",
      "Bella Champaran  BO": "845302",
      "Lakhaura BO": "845302",
      "Latihanawa BO": "845302",
      "Mahuawa BO": "845415",
      "Misraulia BO": "845415",
      "Chintamanpur BO": "845416",
      "Bhatwalia BO": "845417",
      "Parsauna BO": "845417",
      "Jamua BO": "845418",
      "Madhubani Kala BO": "845418",
      "Amawa BO": "845303",
      "Bijwani BO": "845303",
      "Jhajhara BO": "845303",
      "Izara BO": "845419",
      "Sareya Khas BO": "845419",
      "Bazitpur BO": "845420",
      "Bhelwa BO": "845420",
      "Moglania BO": "845420",
      "Dhawahi BO": "845422",
      "Chaita SO": "845414",
      "Damodarpur SO": "845416",
      "Dariapur SO East Champaran": "845417",
      "Ghora Sahan SO": "845303",
      "Gobindganj SO": "845419",
      "Kundwa Chainpur SO": "845304",
      "Motihari  College SO": "845401",
      "Motihari City SO": "845401",
      "Raghunathpur Bazar SO": "845431",
      "Sangrampur SO East Champaran": "845434",
      "Semra SO East Champaran": "845435",
      "Areraj SO": "845411",
      "Bairia SO East Champaran": "845401",
      "Jaitapur Laukaria SO": "845440",
      "Majharia SO": "845401",
      "Malahi SO": "845425",
      "Motihari Chowk SO": "845401",
      "Patahi SO East Champaran": "845457",
      "Phenhara SO": "845430",
      "Tetaria Factory SO": "845436",
      "Adapur SO": "845301",
      "Bakarpur Jagat SO": "845413",
      "Bhelwa Circle SO": "845315",
      "Dhaka SO": "845418",
      "Manguraha SO": "845458",
      "Mehsi SO": "845426",
      "Motihari Court SO": "845401",
      "Rajepur Champaran SO": "845406",
      "Rajpur SO East Champaran": "845432",
      "Ramgahrwa SO": "845433",
      "Raxaul SO": "845305",
      "Sugauli SO": "845456",
      "Turkaulia SO": "845437",
      "Bara Chakia SO": "845412",
      "Chauradano SO": "845302",
      "Chiraiya SO": "845415",
      "Gulwara Madhuban SO": "845420",
      "Harsiddhi SO": "845422",
      "Hussaini SO": "845423",
      "Kesharia SO": "845424",
      "Pachpakari SO": "845427",
      "Pakari Dayal SO": "845428",
      "Pipra Factory SO": "845429",
      "Motihari HO": "845401"
    },
    "SARAN": {
      "Paharpur BO": "841302",
      "Kamta BO": "841403",
      "Ushti BO": "841403",
      "Shitalpur Bazar BO": "841201",
      "Asahani BO": "841204",
      "Atarsan BO": "841204",
      "Inayatpur BO": "841205",
      "Jaitpur Bharwalia BO": "841205",
      "Khardahiya BO": "841205",
      "Basahi BO": "841206",
      "Aami BO": "841207",
      "Malkhachak BO": "841207",
      "Manupur BO": "841207",
      "Bhorahopur BO": "841208",
      "Chhitraulia BO": "841208",
      "Harpur BO": "841208",
      "Kewani BO": "841311",
      "Madarpur BO": "841422",
      "Mohammadpur BO": "841311",
      "Parsajogini BO": "841311",
      "Doriganj BO": "841211",
      "Dhanaw BO": "841403",
      "Dhangarha BO": "841403",
      "GPiparpanti BO": "841403",
      "HKarah BO": "841403",
      "Mirzapur Khurd Lauwa BO": "841403",
      "Puchhari BO": "841403",
      "Satua BO": "841403",
      "Sohai Shahpur BO": "841403",
      "DSultanpur BO": "841202",
      "Fatehpur Chain BO": "841202",
      "Bangra BO": "841205",
      "Barwakhurd BO": "841205",
      "Russi BO": "841205",
      "Banpura Bazar BO": "841206",
      "Mujauna BO": "841207",
      "Saidpur BO": "841216",
      "Jayee Chapra BO": "841209",
      "Khajuhatti BO": "841209",
      "Matiyar BO": "841209",
      "Saraibuksh BO": "841311",
      "Sobhepur BO": "841311",
      "K P Rampur BO": "841211",
      "Mehrauli BO": "841211",
      "Rasalpura BO": "841211",
      "Berui BO": "841403",
      "Chorauwa BO": "841403",
      "Hariharpur BO": "841403",
      "Nagdiha BO": "841403",
      "Dharmapura BO": "841201",
      "Jamanpura BO": "841201",
      "Itawa BO": "841202",
      "Rahampur BO": "841202",
      "Chanchaura BO": "841414",
      "Rasualpur Chatti BO": "841204",
      "Kohra BO": "841205",
      "Kumna BO": "841205",
      "Mane BO": "841205",
      "Tarwa Pojhia BO": "841205",
      "Manikpura BO": "841220",
      "Goraipur BO": "841207",
      "Khanpur BO": "841208",
      "Amdarhi BO": "841208",
      "Bishunpura Kala BO": "841208",
      "Ekma Nautan BO": "841208",
      "Safari BO": "841208",
      "Cheful BO": "841209",
      "Gola Mubarkpur BO": "841209",
      "Sahebzadatola BO": "841312",
      "Gohpur BO": "841311",
      "Saidsarai BO": "841311",
      "Chirand BO": "841211",
      "JBishunpura BO": "841211",
      "Bhatkeshri BO": "841403",
      "KManohar BO": "841403",
      "Lauwa Kala BO": "841403",
      "Murarpur BO": "841403",
      "Saraya BO": "841403",
      "Madansath BO": "841201",
      "Kudarbadha BO": "841202",
      "Ramgarha BO": "841202",
      "Dohar BO": "841204",
      "Eksar BO": "841204",
      "Lejuar BO": "841205",
      "Sonia BO": "841205",
      "Puchitikala BO": "841206",
      "Haraji BO": "841207",
      "Jaitipur BO": "841207",
      "Nachap BO": "841208",
      "Rith BO": "841208",
      "Dumaigarh BO": "841209",
      "Sitabdiara BO": "841312",
      "Bhainsmara BO": "841311",
      "Katsa BO": "841311",
      "Rampur BO": "841311",
      "Khalpura BO": "841211",
      "Tarwar BO": "841419",
      "Tejpurwa BO": "841419",
      "Dumri BO": "841313",
      "Gawandri BO": "841424",
      "Lauwa BO": "841424",
      "Arna BO": "841417",
      "Bahrauli BO": "841417",
      "Pakari BO": "841417",
      "Deo Bahuara BO": "841442",
      "Mothaha BO": "841442",
      "Rampur Khorram BO": "841442",
      "Tujarpur BO": "841442",
      "Koreya BO": "841218",
      "Pakri Mohammadpur BO": "841218",
      "Rampur Atauli BO": "841421",
      "Sikati Bhikham BO": "841421",
      "Sonauli BO": "841421",
      "Bhatgai BO": "841424",
      "Bhorha BO": "841424",
      "Pachbhinda BO": "841424",
      "Pokhrera BO": "841424",
      "Rampur Rudra BO": "841424",
      "Gamahria BO": "841421",
      "Semri BO": "841421",
      "Ardewa BO": "841424",
      "Bhalua Bhikhari BO": "841424",
      "Moreya BO": "841424",
      "Pachraur BO": "841424",
      "Rajdhani BO": "841424",
      "Balsohi BO": "841417",
      "Dhenuki BO": "841417",
      "Bhaluhi BO": "841419",
      "Rasulpur BO": "841419",
      "Ushri Chandpura BO": "841424",
      "Jaithar BO": "841417",
      "Kawalpura BO": "841417",
      "Nawada BO": "841412",
      "Sherukaha BO": "841417",
      "Atta BO": "841419",
      "Awari BO": "841419",
      "Bardahiya BO": "841419",
      "Senduari BO": "841419",
      "Silhauri BO": "841419",
      "Arwa BO": "841442",
      "Amardah BO": "841421",
      "Belhari BO": "841424",
      "Bhagwatpur BO": "841424",
      "Parauna BO": "841424",
      "Chhapia BO": "841417",
      "Dumari Chhapia BO": "841417",
      "Rasauli BO": "841417",
      "Hussepur BO": "841220",
      "Ishrauli BO": "841419",
      "Bankat BO": "841422",
      "Bela BO": "841221",
      "Baijalpur Keso BO": "841101",
      "Pahleza Barka BO": "841101",
      "Rahimpur BO": "841101",
      "Jagarnathpur BO": "841222",
      "Patti Sital BO": "841222",
      "Baldiha BO": "841401",
      "Bhawalpur BO": "841401",
      "Narayanpur BO": "841401",
      "Nautan BO": "841401",
      "Puraina BO": "841401",
      "Dholahi Kaithal BO": "841402",
      "Phulwaria BO": "841460",
      "Bellour BO": "841410",
      "Brit Bhagwanpr BO": "841410",
      "Sonbarsa BO": "841313",
      "Pirauta BO": "841443",
      "Salimapur BO": "841443",
      "Usari Kala BO": "841443",
      "Ram Chaura BO": "841411",
      "Salempur BO": "841411",
      "Shyam Kauria BO": "841411",
      "Hafijpur BO": "841422",
      "Kolhua BO": "841422",
      "Arbindnagar BO": "841221",
      "Basti Jalal BO": "841221",
      "Barua BO": "841101",
      "Kharika BO": "841101",
      "Sisai BO": "841422",
      "Bharpura BO": "841101",
      "Darihara BO": "841101",
      "Govindchak BO": "841101",
      "Harihar Kshetra BO": "841101",
      "Sabalpur BO": "841101",
      "Saraiya BO": "841101",
      "Sikarpur BO": "841101",
      "TMPal BO": "841101",
      "Piraridih BO": "841222",
      "PBChapra BO": "841401",
      "Sareya Basant BO": "841401",
      "Bheldi BO": "841402",
      "Serampur BO": "841460",
      "Satjora Bazar BO": "841410",
      "Khabsi BO": "841443",
      "Narharpur BO": "841443",
      "Maricha BO": "841411",
      "Rampur Kala BO": "841414",
      "Parmanandpur BO": "841101",
      "Fursatpur BO": "841222",
      "Kakrahat BO": "841222",
      "Amnour Harnarain BO": "841401",
      "Basantpur Bangla BO": "841401",
      "Dharhara Kala BO": "841402",
      "Pachlakh BO": "841402",
      "Lachhi Kaituka BO": "841460",
      "Chakia BO": "841410",
      "Shio Mohammadpur BO": "841443",
      "Agauthar Nanda BO": "841411",
      "Sahawa BO": "841411",
      "Terha BO": "841411",
      "Afaur BO": "841414",
      "Meera Mushehri BO": "841414",
      "Ferusa BO": "841415",
      "Mubarakpur BO": "841415",
      "Sadhpur BO": "841415",
      "Pipra BO": "841422",
      "Sarmi BO": "841422",
      "Bajaiha BO": "841221",
      "Dariapur BO": "841221",
      "Ismela BO": "841221",
      "Unehchak BO": "841221",
      "Deorhi BO": "841401",
      "GNParshurampur BO": "841401",
      "Jhakhra BO": "841401",
      "Karanpura BO": "841401",
      "Pachrukhi BO": "841402",
      "Kaituka Nandan BO": "841460",
      "Dubauli BO": "841410",
      "Bhithi Sahabuddin BO": "841411",
      "Chandpurwa BO": "841411",
      "Kerwa BO": "841411",
      "Badlu Tola BO": "841414",
      "Kakadhiya BO": "841414",
      "Kanar Hariharpur BO": "841414",
      "Madhopur BO": "841415",
      "Olahanpur BO": "841415",
      "Rasidpur BO": "841415",
      "Amar Chapra BO": "841414",
      "Manpur BO": "841414",
      "Mushehri BO": "841414",
      "Bhualpur BO": "841415",
      "Kahi BO": "841412",
      "Kotheya BO": "841216",
      "Sawari Buxi Jee BO": "841412",
      "Deopura BO": "841212",
      "Chatra BO": "841213",
      "Hasulahi Deoria BO": "841213",
      "Pirmaker BO": "841215",
      "GDurgapur BO": "841313",
      "Fakuli BO": "841316",
      "Jhauwa BO": "841216",
      "Kans Diara BO": "841216",
      "Aruwa BO": "841224",
      "Dhamsar BO": "841224",
      "Baksanda BO": "841219",
      "Zilkabad BO": "841211",
      "GSBangra BO": "841412",
      "Kishunpur BO": "841412",
      "Sakaddi BO": "841412",
      "Bigaha BO": "841212",
      "Saraon BO": "841212",
      "Bhatwalia BO": "841214",
      "Kachnar BO": "841214",
      "Natwar Semaria BO": "841214",
      "Anwal BO": "841213",
      "Deoria BO": "841225",
      "Majlishpur BO": "841213",
      "Ghorhat Mathia BO": "841313",
      "Narwan BO": "841223",
      "Magaidih BO": "841316",
      "Dumari Balua BO": "841216",
      "Badar Zamin BO": "841224",
      "Lahladpur BO": "841224",
      "Bhagwanpur BO": "841219",
      "M Kuari BO": "841219",
      "Parsauna BO": "841219",
      "Keshri Mathia BO": "841220",
      "Pachua BO": "841220",
      "Tari BO": "841302",
      "Pirauna BO": "841302",
      "Ashok Nagar BO": "841412",
      "Basdila BO": "841412",
      "Dhoopnagar Dhobawal BO": "841412",
      "Nandpur BO": "841313",
      "Narpaliya BO": "841313",
      "Mirpur Zuara BO": "841216",
      "Anjani BO": "841219",
      "BTKohra BO": "841219",
      "Babhangawa BO": "841219",
      "Barka Baneya BO": "841219",
      "Marar BO": "841219",
      "Gurukul Mehiya BO": "841302",
      "Sarha BO": "841302",
      "Enai BO": "841305",
      "Jigna Parsa BO": "841305",
      "Majhanpura BO": "841305",
      "Sengar Tola BO": "841305",
      "Mangolapur BO": "841412",
      "Banpura BO": "841212",
      "Dhelhari BO": "841214",
      "Khairwar BO": "841214",
      "Methwalia BO": "841213",
      "Mukrera BO": "841213",
      "Rewari BO": "841213",
      "Baghakol BO": "841215",
      "Banauta BO": "841215",
      "Bhatha BO": "841215",
      "Dumari Bujurg BO": "841217",
      "Gopalpur BO": "841217",
      "Purushottampur Nazirganj BO": "841224",
      "Telcha BO": "841224",
      "Latrahiya BO": "841219",
      "Pojhi BO": "841219",
      "Sahar Chapra BO": "841219",
      "Karahi BO": "841220",
      "Bodha Chapra BO": "841225",
      "Gheghta BO": "841302",
      "Mahamda BO": "841302",
      "Daulatganj BO": "841301",
      "Sirsia BO": "841305",
      "Brahampur BO": "841305",
      "Barwe BO": "841219",
      "Masti Chak BO": "841219",
      "Rampur Bindalal BO": "841220",
      "Chapra HO": "841301",
      "Marhowrah HO": "841418",
      "Bareja SO Saran": "841201",
      "Chainwa SO": "841204",
      "Dighwara SO": "841207",
      "Gariba Tola SO": "841312",
      "Jagdam College SO": "841301",
      "Rajendra College SO Saran": "841301",
      "Sonepur RS SO": "841101",
      "Sutihar SO": "841222",
      "Aphar SO": "841402",
      "Gaura SO Saran": "841443",
      "Basant SO": "841202",
      "Fulwaria Tajpur SO": "841209",
      "Gultenganj SO": "841211",
      "Jogia SO": "841212",
      "Kopa Samhota SO": "841213",
      "Manjhi SO": "841313",
      "Parsagarh SO": "841220",
      "Revelganj SO": "841305",
      "Amnour SO": "841401",
      "Bhatha Sonho SO": "841460",
      "Masrakh SO": "841417",
      "Sarhwara SO": "841421",
      "Ishuwapur SO": "841411",
      "Mirzapur SO Saran": "841419",
      "Baniapur SO": "841403",
      "Bhagwan Bazar SO": "841301",
      "Dayalpur SO Saran": "841206",
      "District Board SO": "841301",
      "Garkha SO": "841311",
      "Jalalpur Bazar SO": "841412",
      "Maker SO": "841215",
      "Mauna SO": "841301",
      "Mohamadpur SO": "841223",
      "Pratappur SO Saran": "841225",
      "Sitalpur SO": "841221",
      "Sonepur SO Saran": "841101",
      "Khaira SO Saran": "841414",
      "Nagra SO Saran": "841442",
      "Paiga SO": "841218",
      "Taraiya SO": "841424",
      "Daudpur SO Saran": "841205",
      "Ekma SO": "841208",
      "Kopa Bazar SO": "841214",
      "Naini SO Saran": "841316",
      "Naraon SO": "841216",
      "Nayagaon SO": "841217",
      "Panditpur SO": "841224",
      "Parsa SO": "841219",
      "Purwari Telpa SO": "841302",
      "Sahajitpur SO": "841422",
      "Dumarshan Bangra SO": "841410",
      "Khodaibagh SO": "841415"
    },
    "PURNIA": {
      "Srimaha BO": "853204",
      "Balia BO": "853204",
      "Laxmipurgirdhar BO": "853204",
      "Tolikola BO": "854330",
      "Bharmara BO": "854330",
      "Jhawari BO": "854330",
      "Majgama BO": "854330",
      "Matkopa BO": "854330",
      "Betouna BO": "854330",
      "Bochgaon BO": "854330",
      "Gurahi BO": "854330",
      "KullaKhas BO": "854330",
      "Madarghat BO": "854330",
      "Mahamadia BO": "854330",
      "Majhuwakalan BO": "854330",
      "Mathour BO": "854330",
      "Bhangha Chandpur BO": "852122",
      "Mirchaibari BO": "852122",
      "Naulakhi BO": "852122",
      "Charaiya BO": "854315",
      "Gangarghosh BO": "854315",
      "Balua Kachahari BO": "854201",
      "Bishanpur Dutt BO": "854202",
      "Damgara BO": "854202",
      "Deottar BO": "854202",
      "Indrapur Barhara BO": "854334",
      "Bithnauli BO": "854304",
      "Jageli BO": "854304",
      "Khemchand BO": "854304",
      "Parora BO": "854304",
      "Rupaspur BO": "854304",
      "Lalganj BO": "854303",
      "Sahuria BO": "852122",
      "Purnea Aerodram BO": "854303",
      "Sahara BO": "854303",
      "Bhogabhatgama BO": "854337",
      "Kalsar BO": "854337",
      "Gaura BO": "854337",
      "Bahora BO": "854306",
      "Hafania BO": "854315",
      "Kanharia BO": "854315",
      "Khoksa BO": "854315",
      "Machhatta BO": "854315",
      "Makelibalgachhi BO": "854315",
      "Bishanpur Deorhi BO": "854203",
      "Dibra BO": "854203",
      "Harirahi BO": "854203",
      "Kamalpur BO": "854203",
      "Bardela BO": "854204",
      "Barhari BO": "854204",
      "Kukraon BO": "854204",
      "Asja Mobaiya BO": "854315",
      "Bishanpur BO": "854315",
      "Kharaiya BO": "854315",
      "Routahat BO": "854315",
      "Sourajabar BO": "854315",
      "Malinia Diara BO": "854201",
      "Dhima BO": "854202",
      "Ladugarh BO": "854202",
      "Bhatsara BO": "854203",
      "Latraha BO": "854203",
      "Orlaha BO": "854203",
      "Ajhokopa BO": "854204",
      "Dumra BO": "854204",
      "Durgapur BO": "854204",
      "Jhalari BO": "854204",
      "STBrahmgyani BO": "854204",
      "Sondeep BO": "854204",
      "Akarthapa BO": "854102",
      "Ekraha BO": "854102",
      "Pipra BO": "854102",
      "Chandrahi BO": "854205",
      "Sanjhaghat BO": "854205",
      "Dharhara Millik BO": "854202",
      "MPurandaha BO": "854202",
      "Maharajganj BO": "854202",
      "Nipania BO": "854202",
      "Mauzampatti BO": "854203",
      "Nirpur BO": "854203",
      "Bahdura BO": "854204",
      "Ballia BO": "854204",
      "Mohania Chakla BO": "854102",
      "Rampur Tilak BO": "854102",
      "Akbarpur BO": "852116",
      "Laxmipur Bisharia BO": "852101",
      "Shilanath Rupauli BO": "854102",
      "Amari kukron BO": "854205",
      "Gairah BO": "854325",
      "Madhavnagar BO": "854204",
      "Mehdi BO": "854204",
      "Rupauli BO": "854204",
      "Birnagar BO": "854102",
      "Chakmaka BO": "854102",
      "Jankinagar BO": "854102",
      "Mangalbar Chiraiya BO": "854102",
      "Sripur BO": "854205",
      "Barsauni BO": "854326",
      "Belouri BO": "854326",
      "Mahalbari BO": "854326",
      "Siarkhan BO": "854326",
      "Singhiya BO": "854304",
      "Jhunni Kalan BO": "854304",
      "Rahua BO": "854303",
      "Bela Rikbaganj BO": "854304",
      "Kajha BO": "854304",
      "Srinagar BO": "854304",
      "Khudna Rupaspur BO": "854303",
      "Maranga BO": "854303",
      "Belwa BO": "854337",
      "Burhia Dhankatta BO": "854306",
      "Chanka BO": "854304",
      "Ganeshpur BO": "854304",
      "Garhiyabalua BO": "854304",
      "Khokha BO": "854304",
      "Mirganj BO": "854304",
      "Rangpura BO": "854304",
      "BKAsthan BO": "854303",
      "Gangali BO": "854303",
      "Goasi BO": "854303",
      "Harda BO": "854303",
      "Hasanganj BO": "854337",
      "Gokulpur BO": "854306",
      "Parasmani BO": "854306",
      "Zianganj BO": "854306",
      "Amour BO": "854315",
      "Channidoria BO": "854315",
      "Sadipur Bhutaha BO": "854315",
      "Talbari BO": "854315",
      "Ramnagar BO": "854201",
      "Aurahi Gobindpur BO": "854202",
      "Haripur Madi BO": "854202",
      "Kajhi BO": "854202",
      "Laukahi Sukhasan BO": "854202",
      "Rasarh BO": "854202",
      "Bhatottar Chakla BO": "854203",
      "Maldiha BO": "854203",
      "Dobha BO": "854204",
      "Jabe BO": "854204",
      "Sahidganj BO": "854204",
      "Raghunathpur BO": "854204",
      "Harpatti BO": "854102",
      "Tetrahi BO": "854102",
      "Banshi Purandaha BO": "854205",
      "Kuwarigola BO": "854205",
      "Southa BO": "854325",
      "Mohan kunda BO": "854326",
      "Ahilgaon BO": "854327",
      "Sohangaon BO": "854327",
      "Bara Idagah BO": "854330",
      "Champawati BO": "854306",
      "Dagarua Hat BO": "854326",
      "Sirsia BO": "852101",
      "Pokharia Benguwabad BO": "854326",
      "Ekamba Nishara BO": "854327",
      "Tarauna BO": "854327",
      "Adhang BO": "854330",
      "Begumpur BO": "854330",
      "Purnea HO": "854301",
      "Banaili SO": "854201",
      "Barhara Kothi SO": "854203",
      "Kasba SO Purnia": "854330",
      "Khuskibagh SO": "854305",
      "Purnea Chowk SO": "854304",
      "Purnea City SO": "854302",
      "Purnea Court SO": "854301",
      "Dhamdaha SO": "854205",
      "Purnea Polyticnic SO": "854303",
      "Banmankhi SO": "854202",
      "Bhatta Bazar SO": "854301",
      "Bhawanipur Rajdham SO": "854204",
      "Chopra Ram Nagar SO": "854102",
      "Garhbanaili SO": "854325",
      "Gulabbagh SO": "854326",
      "Jalalgarh SO": "854327",
      "Ranipatra SO": "854337",
      "Sarsi SO": "854306",
      "Baisi SO": "854315",
      "Purnea DB SO": "854301"
    },
    "SAHARSA": {
      "Koparia BO": "852126",
      "Bariarpur BO": "852127",
      "Ghordaur BO": "852127",
      "Khamauti BO": "852127",
      "Kenjari BO": "852129",
      "Lagma Deorhi BO": "852129",
      "Chandour BO": "852221",
      "Gamaharia Rampur BO": "852221",
      "Kachra Karahia BO": "852221",
      "Khajuri BO": "852221",
      "Harewa BO": "852126",
      "Itahari BO": "852126",
      "Balhampur BO": "852127",
      "Sardiha BO": "852127",
      "Simri BO": "852127",
      "Sonpura BO": "852127",
      "Rasalpur BO": "852123",
      "Sahsoul BO": "852129",
      "Shahpur BO": "852129",
      "Soha BO": "852129",
      "Sugma BO": "852129",
      "Ajgeba BO": "852221",
      "Baijnathpur BO": "852221",
      "Rauta BO": "852221",
      "Sahuria BO": "852221",
      "Suhath BO": "852221",
      "Jamal Nagar BO": "852126",
      "Mobarakpur BO": "852126",
      "Gordah BO": "852127",
      "Tariama BO": "852127",
      "Maina BO": "852129",
      "Barsam BO": "852217",
      "Damgarhi BO": "852221",
      "Uteshra BO": "852126",
      "Bhatauni BO": "852127",
      "Goriari BO": "852127",
      "Mahkhar BO": "852127",
      "Paharpur BO": "852127",
      "Rahua BO": "852127",
      "Sarbella BO": "852127",
      "Dehad BO": "852129",
      "Pararia BO": "852129",
      "Garhia Vijaypur BO": "852221",
      "Kanp BO": "852221",
      "B Bhelahi BO": "852216",
      "Manuar BO": "852216",
      "Sisauna BO": "852216",
      "Amrita BO": "852217",
      "Atalkha BO": "852217",
      "Jalsima BO": "852217",
      "Khajurah BO": "852217",
      "Bakunia BO": "852123",
      "Chandryan Dharhara BO": "852123",
      "Kedlipatti BO": "852123",
      "Mohanpur BO": "852123",
      "Ramnagar Bharna BO": "852123",
      "Shahpur Manjhol BO": "852123",
      "GBihra BO": "852124",
      "Menha Khadimpur BO": "852124",
      "Patori BO": "852124",
      "Purshotampur BO": "852124",
      "Sattar BO": "852124",
      "Basauna BO": "852202",
      "Bharouli Dhakjhari BO": "852202",
      "Kahra BO": "852202",
      "Saharsa Basti BO": "852202",
      "Aina BO": "852216",
      "Baghwa BO": "852216",
      "KBalua BO": "852216",
      "Kundah BO": "852216",
      "Maina Gram BO": "852216",
      "Mokma BO": "852217",
      "Noneti BO": "852217",
      "Aran BO": "852124",
      "Bara BO": "852124",
      "Barhsher BO": "852124",
      "Amarpur BO": "852202",
      "BSPatti BO": "852202",
      "Mohanpur Dudhela BO": "852202",
      "Murli Basantpur BO": "852202",
      "Nariyarh BO": "852202",
      "Patuaha BO": "852202",
      "Rampur BO": "852106",
      "Telhar BO": "852216",
      "Telwa BO": "852216",
      "Terhi BO": "852216",
      "Baraith BO": "852217",
      "Bargaon BO": "852217",
      "Bhaddi Durgapur BO": "852217",
      "Barharia BO": "852123",
      "Darhar BO": "852123",
      "Dhrampur BO": "852123",
      "Ekrah BO": "852123",
      "Kataiya BO": "852123",
      "RTulsiahi BO": "852124",
      "Diwari BO": "852202",
      "Garhia BO": "852202",
      "Simraha BO": "852202",
      "Sisai BO": "852202",
      "Sulindabad BO": "852202",
      "Alani BO": "852126",
      "Bhelwa BO": "852126",
      "Parri BO": "852212",
      "Arapatti BO": "852216",
      "Narayanpur BO": "852216",
      "Sarauni BO": "852216",
      "Balia BO": "852217",
      "Biratpur BO": "852217",
      "Jamhara BO": "852217",
      "Kishanpur BO": "852217",
      "Baira BO": "852123",
      "Muradpur BO": "852123",
      "Bijalpur BO": "852124",
      "Manjhaul BO": "852124",
      "Nandalali BO": "852124",
      "Sihaul BO": "852124",
      "Benghaha BO": "852202",
      "Dhamsena BO": "852202",
      "Haripur BO": "852202",
      "Rupanagar BO": "852202",
      "Samda BO": "852202",
      "Chainpur BO": "852212",
      "Rahuamani BO": "852212",
      "Bariahi BO": "852212",
      "Ghoghsam BO": "852106",
      "Gopalpur BO": "852106",
      "Kabira BO": "852106",
      "Kathdumar BO": "852106",
      "Balwahat BO": "852106",
      "Patarghat BO": "852107",
      "Belwara BO": "852106",
      "Dhanpura BO": "852106",
      "Saronja BO": "852106",
      "Sitanabad BO": "852106",
      "Golma BO": "852107",
      "Kapasia BO": "852107",
      "Belhi Teghra BO": "852106",
      "Bhavdeva BO": "852106",
      "Khojuri Matihani BO": "852106",
      "Sakra Paharpur BO": "852106",
      "Shankarpur BO": "852106",
      "Ghoghanpatti BO": "852107",
      "MKahra BO": "852107",
      "Kharagpur BO": "852106",
      "Rajanpur BO": "852106",
      "Bishanpur BO": "852107",
      "Pama BO": "852107",
      "Pastpar BO": "852107",
      "Saharsa HO": "852201",
      "Mangwar SO": "852217",
      "Saharsa Bazar SO": "852201",
      "Saharsa DistBoard SO": "852201",
      "Salkhua Bazar SO": "852126",
      "Dhabauli SO": "852107",
      "Nauhatta SO": "852123",
      "Simri Bakhtiarpur SO": "852127",
      "Sonbersa Raj SO": "852129",
      "Sour Bazar SO": "852221",
      "Bangaon SO Saharsa": "852212",
      "Chapraon SO": "852106",
      "Mahishi SO": "852216",
      "Panchgachiya SO": "852124",
      "Saharsa Collec SO": "852202"
    },
    "SITAMARHI": {
      "Kharkha BO": "847302",
      "Chakauti BO": "847307",
      "Nayatola BO": "847302",
      "Olipur Sarhachia BO": "843117",
      "Pitaunjhia BO": "843116",
      "Sirkhiria BO": "843117",
      "Chak Shambhu BO": "843117",
      "Gorigama BO": "843117",
      "Banaul BO": "843326",
      "Batra BO": "843326",
      "Gauri BO": "843326",
      "BJairam BO": "843327",
      "RGanguly BO": "843327",
      "Ranjitpur BO": "843327",
      "Riga Colony BO": "843327",
      "Bhanaspatti BO": "843328",
      "Thahar BO": "843328",
      "Thumma BO": "843328",
      "Bhavdepur BO": "843302",
      "Rajopatti BO": "843302",
      "Sirauli BO": "843302",
      "CC Union": "843302",
      "PRajwara BO": "843330",
      "H Dularpur BO": "843331",
      "Hanumannagar BO": "843331",
      "Mahuawa BO": "843331",
      "Sutihara BO": "843331",
      "BhBhimpur BO": "843311",
      "Bel BO": "843313",
      "Bengahi BO": "843313",
      "Bhakurahar BO": "843313",
      "Dumarbana BO": "843313",
      "Piprathi Punarvas BO": "843313",
      "Akhta BO": "843313",
      "BHarpur BO": "843314",
      "BMachacha BO": "843314",
      "BNarha BO": "843314",
      "BPhulwariya BO": "843314",
      "CTakiya BO": "843314",
      "Bokhtha BO": "843315",
      "D Kala BO": "843315",
      "D Khurd BO": "843315",
      "Dheng BO": "843315",
      "Kansar BO": "843316",
      "Kathaur BO": "843316",
      "P Tajpur BO": "843316",
      "T Chhapra BO": "843316",
      "Goraul Sharif BO": "843318",
      "Mahisautha BO": "843318",
      "Jadupatti Bazar BO": "843319",
      "Pirokhar BO": "843319",
      "Sujatpur BO": "843319",
      "Chaipura BO": "843320",
      "Gangati BO": "843320",
      "Bathasli BO": "843326",
      "Babhangama BO": "843327",
      "Bairiya BO": "843327",
      "Khairwa BO": "843327",
      "Kharsan BO": "843327",
      "Maudah BO": "843327",
      "P Pataniya": "843327",
      "Riga Gote BO": "843327",
      "Amghatta BO": "843302",
      "Anhari BO": "843302",
      "B Piprarhi BO": "843302",
      "Banchauri BO": "843302",
      "FGirmishani BO": "843302",
      "Harnahiya BO": "843302",
      "KSiroman BO": "843302",
      "Kishanpur BO": "843302",
      "Parsauni BO": "843302",
      "Dalkawa BO": "843330",
      "Barahi BO": "843327",
      "Meghpur BO": "843331",
      "Lautan BO": "843117",
      "MSakrauli BO": "843326",
      "Pokhraira BO": "843326",
      "Bhagwanpur BO": "843327",
      "CBishanpur BO": "843327",
      "MMandal BO": "843327",
      "PBasantpur BO": "843327",
      "Pokharbhinda BO": "843320",
      "Rain Shankar BO": "843328",
      "Bariyarpur BO": "843302",
      "Bhairo Bhoop BO": "843302",
      "Bishanpur BO": "843324",
      "M Rampur BO": "843302",
      "Paktola BO": "843302",
      "Parmanandpur BO": "843302",
      "Punaura BO": "843302",
      "Araria BO": "843330",
      "Kohbarawa BO": "843330",
      "Mushaharniya BO": "843330",
      "Bakhari BO": "843325",
      "Bhitha Bazar BO": "843331",
      "Majhaura BO": "843331",
      "Malahi BO": "843324",
      "Radhaur BO": "843331",
      "Shrikhandi Bhitta BO": "843331",
      "Gisara BO": "843311",
      "RBagahi BO": "843311",
      "Jamua BO": "843313",
      "Pachtaki Jaddu BO": "843313",
      "Awapur BO": "843314",
      "Baburban BO": "843324",
      "Bangaon BO": "843314",
      "H Barharwa BO": "843314",
      "K Barhmtoli BO": "843314",
      "Siwaipaiti BO": "843314",
      "Basbitta BO": "843315",
      "Gharwara BO": "843315",
      "BBasudeo BO": "843117",
      "Madhurapur BO": "843314",
      "R Raghunathpur BO": "843315",
      "Suppi BO": "843315",
      "Bhandari BO": "843316",
      "J Kothia BO": "843316",
      "Sauli BO": "843316",
      "B Jay Nagar BO": "843317",
      "K Bhandar BO": "843317",
      "Singrahiya BO": "843317",
      "Singwahini BO": "843317",
      "Bhaurgarah BO": "843318",
      "Saterh BO": "843318",
      "BBehta BO": "843319",
      "DMathauna BO": "843319",
      "B Maksudan BO": "843320",
      "BBajitpur BO": "843320",
      "Bachharpur BO": "843320",
      "Dumharpatti BO": "843320",
      "Subhaigarh BO": "843117",
      "MBasaha BO": "843314",
      "Muraul BO": "843314",
      "Belahiya BO": "843314",
      "Jaffarpur BO": "843316",
      "K Motnaje BO": "843316",
      "Hanuman Nagar BO": "843317",
      "Haribela BO": "843317",
      "M Kala BO": "843317",
      "Bokhra BO": "843318",
      "B Dharmapur BO": "843320",
      "Basotra BO": "843320",
      "Bedaul BO": "843320",
      "Bhantabari BO": "843320",
      "Balasath BO": "843326",
      "Gaura BO": "843326",
      "Pandaul Buzurg BO": "843326",
      "KThikha BO": "843327",
      "Narha BO": "843331",
      "Rewasi BO": "843327",
      "Sahbajpur BO": "843327",
      "Baligarh BO": "843328",
      "MMorsand BO": "843328",
      "Mehsaul BO": "843328",
      "Raxiya BO": "843328",
      "Bangaraha BO": "843302",
      "Bathnaha BO": "843302",
      "Chakmahila BO": "843302",
      "Koily BO": "843302",
      "Maniyari BO": "843302",
      "RGosaipur BO": "843302",
      "GPitaunjhia BO": "843116",
      "Gaus Nagar BO": "843117",
      "Shanki BO": "843302",
      "Mayurwa BO": "843330",
      "PParsain BO": "843330",
      "Baghari BO": "843323",
      "Kumma BO": "843331",
      "Ragharpura BO": "843331",
      "Belahi BO": "843311",
      "Partapur BO": "843311",
      "Ashogi Purshottam BO": "843313",
      "Marpa Factory BO": "843313",
      "Bajitpur BO": "843314",
      "Harpurwa BO": "843314",
      "Patdaura BO": "843314",
      "Pachara BO": "843314",
      "Gamhariya BO": "843315",
      "Harpurkala BO": "843315",
      "S Kala BO": "843315",
      "Chandauli Timha BO": "843316",
      "Dumra BO": "843316",
      "P Murahi BO": "843316",
      "Patahi BO": "843316",
      "Fulkahan BO": "843317",
      "P Dadan BO": "843317",
      "Koryahi BO": "843319",
      "B Rasalpur BO": "843320",
      "Lattipur BO": "843322",
      "Madhopur BO": "843322",
      "Sahiyara BO": "843332",
      "Sonaul Mahoday BO": "843332",
      "Kamaladah BO": "843323",
      "Lagma Azamgarh BO": "843323",
      "Chak Sarmastpur BO": "843104",
      "Lalpur BO": "843323",
      "KBP Pupri BO": "843320",
      "Piprarhi BO": "843320",
      "Dighi BO": "843322",
      "Bagaha BO": "843332",
      "Bahera BO": "843332",
      "Manariya BO": "843332",
      "B Dhanushi BO": "843323",
      "Garha BO": "843320",
      "B Jahidpur BO": "843333",
      "Humayupur BO": "843333",
      "Koili BO": "843333",
      "Andauli BO": "843324",
      "Lahuriya BO": "843324",
      "Manpaur BO": "843324",
      "Sardalpatti BO": "843324",
      "MBalaha BO": "843325",
      "Bhulli BO": "843325",
      "Parshurampur BO": "843325",
      "Prem Nagar Subhai BO": "843323",
      "Saura BO": "843333",
      "Sirsi BO": "843333",
      "Bathuara BO": "843324",
      "Indarwa BO": "843324",
      "Kanhawa BO": "843324",
      "Sirsia BO": "843324",
      "Vishwa BO": "843324",
      "Jhajhihat BO": "843320",
      "Narayanpur BO": "843320",
      "Panthpakar BO": "843322",
      "Pachaharwa BO": "843332",
      "K Bishanpur BO": "843323",
      "Tikauli BO": "843323",
      "Madaripur BO": "843333",
      "Mahammadpur Dalel BO": "843333",
      "BMachhpakauni BO": "843324",
      "Betaha BO": "843324",
      "Dharharwa BO": "843324",
      "Jagdar BO": "843324",
      "Mahadeopatti BO": "843324",
      "Narga BO": "843324",
      "Sahargama BO": "843324",
      "Rampur Bakhari BO": "843325",
      "H Chandei BO": "843320",
      "Hardiya BO": "843320",
      "Ratan Lasmi BO": "843320",
      "Chinachak BO": "843320",
      "Jogiwana BO": "843322",
      "Kamaldah BO": "843322",
      "Chhaurahiya BO": "843332",
      "KMadan BO": "843332",
      "MMalinia BO": "843332",
      "B Shantikutir BO": "843333",
      "Bhadiyan BO": "843333",
      "Dadari BO": "843333",
      "Dhadhi BO": "843333",
      "Janipur BO": "843333",
      "Majhaur BO": "843333",
      "Ratwara BO": "843333",
      "PKoria BO": "843324",
      "PPhulhatta BO": "843324",
      "Parsa BO": "843324",
      "RBhanpur BO": "843324",
      "Dhankaul BO": "843325",
      "KGajpatti BO": "843325",
      "Kuama BO": "843325",
      "Madanpur BO": "843325",
      "Sitamarhi HO": "843301",
      "Janaki Asthan SO": "843302",
      "Janakpur Road SO": "843320",
      "Parsauni SO": "843325",
      "Bairgania SO": "843313",
      "Bajpatti SO": "843314",
      "Koat Bazar SO": "843302",
      "Majhaulia Estate SO": "843322",
      "Nanpur SO": "843333",
      "Pupari Bazar SO": "843320",
      "Shaktipith Chandidham SO": "843301",
      "Sonbersa SO": "843330",
      "Athri SO": "843311",
      "Barharwa SO Sitamarhi": "843315",
      "Bhutahi SO": "843317",
      "Majorganj SO": "843332",
      "Parihar SO": "843324",
      "Riga SO": "843327",
      "Sitamarhi Bazar SO": "843302",
      "Sursand SO": "843331",
      "Bairgania Bazar SO": "843313",
      "Belsand SO": "843316",
      "Budhnagra Deorhi SO": "843318",
      "Choraut SO": "843319",
      "Manikchowk SO": "843323",
      "Raipur SO Sitamarhi": "843326",
      "Runnisaidpur SO": "843328"
    },
    "PASHCHIM CHAMPARAN": {
      "Dukhi Chhapar BO": "845307",
      "Purainia BO": "845307",
      "Kurshi Barawa BO": "845307",
      "Mathia Kathia BO": "845307",
      "Sugaha Bhawanipur BO": "845307",
      "Sundar Gaon BO": "845307",
      "Laxmipur Bherihari BO": "845107",
      "Rampurwa BO": "845105",
      "Behra BO": "845307",
      "Bhawara BO": "845307",
      "Jagarnathpur BO": "845307",
      "Murli Parsauni BO": "845307",
      "Sargatia BO": "845307",
      "Lagunaha BO": "845101",
      "Mehura BO": "845101",
      "Sirisia BO": "845450",
      "Piparia BO": "845101",
      "Barwat Pasrain BO": "845438",
      "Gonauli BO": "845438",
      "Mahna Gani BO": "845438",
      "Shikarpur BO": "845454",
      "Champapur Gonauli BO": "845107",
      "Gopalpur BO": "845307",
      "Haripur BO": "845307",
      "Harpur BO": "845101",
      "Manpur BO": "845101",
      "Barwat Sena BO": "845438",
      "Lalgarh BO": "845438",
      "Pipra Naurangia BO": "845438",
      "BB Bankatwa BO": "845101",
      "Bargaon BO": "845101",
      "Chandraha BO": "845101",
      "Patilar BO": "845101",
      "Rajwatia BO": "845101",
      "Singari BO": "845101",
      "Banu Chhapar BO": "845438",
      "Bettiah Dih BO": "845438",
      "Padar Khap BO": "845101",
      "Parsa BO": "845101",
      "Dhum Nagar BO": "845438",
      "KRHigh School BO": "845438",
      "Pipra Pakari BO": "845438",
      "Belwa BO": "845449",
      "Jaitia BO": "845449",
      "Tikulia BO": "845449",
      "Laxmipur BO": "845450",
      "Gokhula BO": "845451",
      "Rakhahi BO": "845451",
      "Dianmarawa BO": "845103",
      "Jharmahuee BO": "845103",
      "Jogia BO": "845103",
      "Murali BO": "845103",
      "Telpur BO": "845103",
      "B Banahura BO": "845459",
      "Jhakhara BO": "845459",
      "Shyampur Kotaraha BO": "845459",
      "Teluha BO": "845459",
      "Barwa Ojha BO": "845452",
      "Puraina BO": "845452",
      "Bariarwa BO": "845453",
      "Belwa More BO": "845453",
      "Kehunia BO": "845453",
      "Lakhanpur BO": "845453",
      "Parsa Factory BO": "845453",
      "Daunaha BO": "845104",
      "Dhumnagar BO": "845104",
      "Piprasi BO": "845104",
      "Sisai BO": "845104",
      "Bastha BO": "845306",
      "Siswa Bhangaha BO": "845306",
      "Bakharia BO": "845454",
      "Dhokharaha BO": "845454",
      "Ratanmala Mathia BO": "845454",
      "Khairpokhara BO": "845105",
      "Pharsahani BO": "845105",
      "Sidhaw BO": "845105",
      "Taruanwa BO": "845105",
      "Amolwa BO": "845455",
      "Belsandi BO": "845455",
      "Sugauli BO": "845455",
      "Bairiya Farm BO": "845438",
      "Balua Rampurwa BO": "845438",
      "Khadda BO": "845438",
      "Pokharia BO": "845438",
      "San Sariya BO": "845438",
      "Bhairoganj BO": "845106",
      "Kolhua BO": "845106",
      "Majharia BO": "845106",
      "Meghwal Mathia BO": "845106",
      "Semari Dumari BO": "845106",
      "Tribhuani BO": "845106",
      "Bheriharwa BO": "845449",
      "Chaubey Tola BO": "845449",
      "Danial Parsauna BO": "845449",
      "Dhamaura BO": "845449",
      "Pokharia Rai BO": "845449",
      "Puraina Gosai BO": "845449",
      "Sathi BO": "845449",
      "Sihpur BO": "845449",
      "Bargajwa BO": "845451",
      "Chauhatta BO": "845451",
      "Damrapur BO": "845451",
      "Rampur BO": "845451",
      "Sitapur BO": "845103",
      "Majharia Kisun BO": "845459",
      "Mangalpur Gudaria BO": "845459",
      "Ramnagar Bankat BO": "845459",
      "Ramparsauna BO": "845453",
      "Roari BO": "845453",
      "Sahadat Pur BO": "845453",
      "Dharampur BO": "845449",
      "Auraiya BO": "845450",
      "Gurwalia BO": "845450",
      "Jado Chhapar BO": "845450",
      "Kurwa Mathia BO": "845450",
      "Maldi BO": "845451",
      "Mangrahari BO": "845451",
      "Maniari BO": "845451",
      "Padraun BO": "845451",
      "Bagahi BO": "845452",
      "Ahwar Shaikh BO": "845459",
      "Amwa Majhar BO": "845459",
      "Bisunpura BO": "845459",
      "Dudhiawa BO": "845452",
      "Dumari Bazar BO": "845452",
      "Jaralpur Dih BO": "845452",
      "Machhargawan BO": "845452",
      "Sirnagar BO": "845452",
      "Briti Matiaria BO": "845453",
      "Dhobini BO": "845453",
      "Dumara BO": "845453",
      "Gobraura BO": "845453",
      "Balua Thori Bazar BO": "845104",
      "Bhitaha BO": "845104",
      "Binahi BO": "845104",
      "Kathar BO": "845104",
      "Khaira Tola BO": "845104",
      "Machhaha BO": "845104",
      "Mura Dih BO": "845104",
      "Ghorpakari BO": "845306",
      "Gora Karamwa BO": "845454",
      "Harpur Tola BO": "845454",
      "Majhariya Sheikh BO": "845454",
      "Siswa Basantpur BO": "845453",
      "Siswania BO": "845453",
      "Dumari BO": "845104",
      "Taulaha BO": "845104",
      "Marjadwa BO": "845306",
      "Pindari BO": "845306",
      "Jawkatia BO": "845454",
      "Kathaia BO": "845454",
      "Rulahi Nizamat BO": "845454",
      "Sariswa Bazar BO": "845454",
      "Bhikhana Thori BO": "845455",
      "Bhitiharwa Ashram BO": "845455",
      "Goithahi BO": "845455",
      "Jamunia BO": "845455",
      "Serwa Masjidwa BO": "845455",
      "B Patkhaulia BO": "845438",
      "B Ratanpura BO": "845438",
      "Bhitaha Nizamat BO": "845438",
      "Laukariya BO": "845438",
      "Nautan Dubey BO": "845438",
      "Pakhanaha Bazar BO": "845438",
      "Patzirwa BO": "845438",
      "Bhawal BO": "845106",
      "Cheutaha BO": "845106",
      "Nauragia Done BO": "845106",
      "Serwa Done BO": "845106",
      "Sigari Bigari BO": "845106",
      "Mathia Brit BO": "845454",
      "Mohachhinain BO": "845454",
      "Senwaria BO": "845454",
      "Borwal BO": "845105",
      "Kunai Bhelahi BO": "845105",
      "Mangalpur BO": "845105",
      "Naurangia BO": "845105",
      "Tarwalia BO": "845105",
      "Tinferia BO": "845105",
      "Musharwa BO": "845455",
      "Rajpur Madan BO": "845455",
      "Saidpur BO": "845455",
      "Alpaha BO": "845438",
      "B K Chowk BO": "845438",
      "Surajpur BO": "845438",
      "Tadhawa Nandpur BO": "845438",
      "Gobarahia Done BO": "845106",
      "Gobardhana BO": "845106",
      "Baishakhawa BO": "845307",
      "Bakulahar Math BO": "845449",
      "Bhabhata BO": "845449",
      "Dhankutwa BO": "845449",
      "Ghogha BO": "845449",
      "Ashram Brindavan BO": "845450",
      "Mushahari BO": "845450",
      "Turahapatti BO": "845450",
      "Bargo BO": "845103",
      "Dumaria Estate BO": "845103",
      "Mahui BO": "845103",
      "Sabeya BO": "845103",
      "Alamganj Bazar BO": "845459",
      "Bishabhar Pur BO": "845459",
      "Jagarnath Pur BO": "845459",
      "Sareya BO": "845459",
      "Victoria Mission BO": "845459",
      "Chamukha BO": "845452",
      "Nawalpur BO": "845452",
      "Shiorajpur BO": "845452",
      "Baswariya BO": "845453",
      "Bijbania BO": "845453",
      "Mathia BO": "845453",
      "Parsauni Farm BO": "845453",
      "Bhuidharwa BO": "845104",
      "Chilwania BO": "845104",
      "Dhanaha BO": "845104",
      "Parsauna BO": "845104",
      "Ranglalahi BO": "845104",
      "Bhaluahia BO": "845306",
      "Inarwa Bazar BO": "845306",
      "Chailabhar BO": "845454",
      "Chanayan Bandh BO": "845454",
      "Lal Saraiya BO": "845454",
      "Madhopur BO": "845454",
      "Rajabhar BO": "845454",
      "Rampurwa Mahanwa BO": "845454",
      "Bakuli BO": "845105",
      "Harnatar BO": "845105",
      "Malkauli BO": "845105",
      "Semra Labedaha BO": "845105",
      "Semra Medraul BO": "845105",
      "Sohagi Barwa BO": "845105",
      "Anjua BO": "845455",
      "Belwa Bahuari BO": "845455",
      "Lachhnauta BO": "845455",
      "Mahuawa BO": "845455",
      "Manwa Parsi BO": "845455",
      "Taulaha Champaran BO": "845455",
      "Baijua BO": "845438",
      "Bhawanipur BO": "845438",
      "Gambhirpur BO": "845438",
      "Refujee Camp BO": "845438",
      "Sareya Ojhwalia BO": "845438",
      "Sheorajpur BO": "845438",
      "Bakhari Pachrukhia BO": "845106",
      "Gudgudi BO": "845106",
      "Behari Bankatwa BO": "845307",
      "Bettiah HO": "845438",
      "Chanpatia R S SO": "845449",
      "Chuhari SO": "845450",
      "DKShikarpur SO": "845451",
      "Majhaulia Rs SO": "845454",
      "Naya Tola Bettiah SO": "845438",
      "Ramnagar SO West Champaran": "845106",
      "Sikta SO": "845307",
      "Belbagh SO": "845438",
      "Naraipur SO": "845105",
      "Chanpatia Bazar SO": "845449",
      "Harinagar SO": "845103",
      "Mainatand SO": "845306",
      "Meena Bazar Bettiah SO": "845438",
      "Narkaiaganj SO": "845455",
      "Bagaha SO": "845101",
      "Bettiah RS SO": "845438",
      "Jagdishpur SO West Champaran": "845459",
      "Jogapatti SO": "845452",
      "Lal Bazar Bettiah SO": "845438",
      "Lauriya SO": "845453",
      "Madhubani SO": "845104",
      "Valmiki Nagar SO": "845107"
    },
    "GAYA": {
      "NAGWANGARH BO": "824219",
      "Nimabidhoul BO": "824219",
      "Kathautia BO": "824211",
      "Anjan BO": "824217",
      "Roshanganj BO": "824217",
      "Bhaluachatti BO": "824201",
      "Binda BO": "824201",
      "Dongra BO": "824201",
      "Madhopur BO": "824236",
      "Turi BO": "804435",
      "Jhari BO": "824219",
      "Parsawan BO": "824217",
      "Lutua BO": "824217",
      "Chuawar BO": "824217",
      "Bumuar BO": "824201",
      "Dewania BO": "824201",
      "Jamuara Kala BO": "824217",
      "Panania BO": "824217",
      "Sagdiha BO": "824217",
      "Tilaiya BO": "824217",
      "Dhamna BO": "824201",
      "Naugarh BO": "824219",
      "Phulwaria Baheri BO": "824219",
      "Angra BO": "824116",
      "Bham BO": "824116",
      "Darma BO": "824116",
      "Azamgarh BO": "824217",
      "B  Chaugain BO": "824217",
      "Mahamana BO": "824236",
      "Musi BO": "824236",
      "Sadopur BO": "804435",
      "Malheya BO": "824236",
      "Panchanpur BO": "824236",
      "Pura BO": "824236",
      "Ranipur Nishurpur BO": "824236",
      "Simuara BO": "824236",
      "Nimsar BO": "804435",
      "PANDABIGHA": "804435",
      "Karisowa BO": "805131",
      "Kharaua BO": "805131",
      "Kharghara BO": "805131",
      "Khirwan BO": "805131",
      "Kurkihar BO": "805131",
      "S Nawada BO": "805131",
      "Sahiya BO": "805131",
      "Singhwara BO": "805131",
      "Mok BO": "824207",
      "Murera BO": "824207",
      "Sinduria BO": "824207",
      "Siyadih BO": "824207",
      "Tarari BO": "824207",
      "Kartahi BO": "824211",
      "Paruhara BO": "824211",
      "Saonkala BO": "824211",
      "Bara BO": "824236",
      "Bedauli BO": "824210",
      "Dumri BO": "805128",
      "Kenar BO": "805128",
      "Kother BO": "805128",
      "M H Chack BO": "805128",
      "Nagwan BO": "805128",
      "Kothi BO": "824210",
      "Barhussainganj BO": "824211",
      "Betibigha BO": "824211",
      "Dhab Chiraiya BO": "824211",
      "Chilim BO": "824211",
      "Kachauri BO": "824211",
      "Mohabbatpur BO": "824211",
      "Chakkarbandha BO": "824221",
      "B Makdumpur BO": "805128",
      "Chowar BO": "805128",
      "Pasarhi BO": "805128",
      "Amethi BO": "805131",
      "Bisunpur BO": "805131",
      "Ghogha BO": "805131",
      "Rajwara BO": "805131",
      "Nagwan Pathra BO": "824210",
      "Chitabkhurd BO": "824211",
      "Ismailpur BO": "824205",
      "Shyamnagar Nima BO": "824211",
      "Kewala Kala BO": "824221",
      "Gotibandh BO": "824221",
      "Jaigir BO": "824201",
      "Patluka BO": "824201",
      "Amarut BO": "824220",
      "Ghoraghat BO": "824220",
      "Sahuberma BO": "824205",
      "Maigra BO": "824206",
      "Phulwaria BO": "824206",
      "Adai BO": "824207",
      "Kaithisadipur BO": "824207",
      "Sharwankhas BO": "824201",
      "Kurmawan BO": "824209",
      "Nainsagar BO": "824220",
      "Pirasin BO": "824220",
      "Sidhpur BO": "824206",
      "BManjhiawan BO": "824207",
      "Chechaura BO": "824207",
      "Eguna BO": "824207",
      "Goharpur BO": "824207",
      "Bairka BO": "823311",
      "Bathani BO": "823311",
      "Punar BO": "823311",
      "Jamunapur Noudiha BO": "823311",
      "Saren BO": "823311",
      "Sarvahada BO": "823311",
      "Tetar BO": "823311",
      "GEHLORE": "823311",
      "Derhma BO": "804403",
      "Kachnama BO": "804403",
      "DARAMPUR": "804403",
      "CHIRAILLA": "804403",
      "Basarhi BO": "824231",
      "Dema BO": "824231",
      "Mocharim BO": "824231",
      "Bhoremirganj BO": "823003",
      "Bithosarif BO": "823003",
      "Lodipur BO": "824209",
      "Manpur BO": "823003",
      "Chakand RS BO": "804404",
      "Laxmipur BO": "804404",
      "Salepur Fatehpur BO": "804404",
      "Gajanpur BO": "824237",
      "Pandey Parasawan BO": "823004",
      "Ambatari BO": "824232",
      "Charokharigarh BO": "824232",
      "Kanti BO": "824232",
      "Ketra BO": "824232",
      "Powa BO": "824232",
      "Utli Bara BO": "824232",
      "Kesru Dharampur BO": "823002",
      "Deokali BO": "824118",
      "Konchi BO": "824118",
      "Kormathu BO": "824118",
      "Hathiawan BO": "804407",
      "Satamas BO": "804407",
      "Baraini BO": "824233",
      "Musepur BO": "824233",
      "NAUDIHA": "824233",
      "Sirdundichak BO": "824233",
      "Gopalkera BO": "824201",
      "Rondawan BO": "824201",
      "Babahandeo BO": "824220",
      "Bahoura BO": "824220",
      "Bhadeya BO": "824220",
      "Gangi BO": "824220",
      "Bharaunda BO": "824205",
      "Chansi BO": "824205",
      "Duba BO": "824205",
      "Khajuri BO": "824207",
      "Tankupa BO": "824232",
      "Utrain BO": "824207",
      "Salaiya BO": "824210",
      "Dariaura BO": "824211",
      "Sri Rampur BO": "824211",
      "Akouna BO": "824211",
      "Adarchak BO": "824221",
      "Bodhi Bigha BO": "824221",
      "Zindapur BO": "824234",
      "Bohiya BO": "824235",
      "Mahimapur BO": "824235",
      "Makhdumpur Harhi BO": "824235",
      "Sarbahda BO": "824235",
      "Tuturakhi BO": "824235",
      "Laxman Bigha BO": "824209",
      "Maranchi BO": "824209",
      "Charaili BO": "824236",
      "Dighwara BO": "824236",
      "Chiriyawan BO": "823311",
      "Jethian BO": "823311",
      "Khukri BO": "823311",
      "Agni BO": "804403",
      "Belhari BO": "804403",
      "Amwan BO": "824231",
      "Alipur BO": "823003",
      "Baragandhar BO": "823003",
      "Bhadeji BO": "823003",
      "Nauranga BO": "823003",
      "Rasalpur BO": "823003",
      "Sohaipur BO": "823003",
      "Sondhi BO": "823003",
      "Bara Rahimbigha BO": "804404",
      "Baiju Bigha BO": "824237",
      "Bishunpura BO": "824237",
      "Deo Nagar Uchirwan BO": "824237",
      "Sagahi BO": "824237",
      "Bhare BO": "824232",
      "Choukiya BO": "824232",
      "Dhibar BO": "824232",
      "Lakhaipur BO": "824232",
      "Makhdumpur BO": "824232",
      "Manjhouli BO": "824232",
      "Mohanpur BO": "824232",
      "Musaila BO": "824232",
      "AROPUR": "824232",
      "SALAIYAKALA": "824232",
      "Burman BO": "824118",
      "Budhoul BO": "824118",
      "Daboor BO": "824118",
      "Baijdah BO": "805128",
      "Dharampur BO": "805128",
      "Mahugain BO": "805128",
      "Arawan BO": "805131",
      "Ghariya BO": "805131",
      "Kajoor BO": "805131",
      "Manjhauli BO": "805131",
      "Panley BO": "805131",
      "Diha BO": "824118",
      "Kerki BO": "824118",
      "Takiya Karpi BO": "804407",
      "Bihta BO": "824233",
      "Dehuri BO": "824233",
      "Dema Fatehpur BO": "824233",
      "Dhansingara BO": "824233",
      "Hemara BO": "824233",
      "Sripur BO": "824233",
      "Sahdeokhap BO": "824234",
      "Dhibri BO": "824235",
      "Kamalpur BO": "824235",
      "Rewai BO": "824235",
      "Salempur BO": "824235",
      "Khanetu BO": "824209",
      "Jalalpur BO": "824236",
      "Law BO": "824236",
      "Ayer BO": "823311",
      "Patharkatti BO": "823311",
      "Piyar BO": "823311",
      "SMoulanagar BO": "823311",
      "Teusa Bandhubigha BO": "823311",
      "DHUSARI": "823311",
      "Bhimdaspur BO": "804403",
      "Chandouti Bhagawanpur BO": "804403",
      "Neori BO": "804403",
      "Samaspur BO": "804403",
      "Silounja BO": "804403",
      "Bankraur BO": "824231",
      "Hathiyar BO": "824231",
      "Kendui BO": "824231",
      "Koshila BO": "824231",
      "Parariya BO": "824231",
      "Chhatubagh BO": "823003",
      "Khanjahapur BO": "823003",
      "Kusha Bija B.O": "824220",
      "Erki BO": "804404",
      "Meera Bigha BO": "804404",
      "Rouna BO": "804404",
      "Phurhuriya BO": "824237",
      "Punaul BO": "824237",
      "Rajan Ithari BO": "824237",
      "Bagadaha BO": "823004",
      "Jamri BO": "823004",
      "Akamba BO": "824232",
      "Gurpa RS BO": "824232",
      "Hematpur BO": "824232",
      "Itwan BO": "824232",
      "Jani Bigha BO": "824232",
      "Ghatera BO": "824118",
      "Kanousi BO": "824118",
      "Manjhiyawan BO": "824118",
      "Lahathua BO": "824201",
      "Hardwan BO": "824220",
      "Balia BO": "824205",
      "Pakri BO": "824205",
      "Malahari BO": "824206",
      "Pakri Guria BO": "824206",
      "Pipra BO": "824221",
      "Ahiyapur BO": "824207",
      "Kabar BO": "824207",
      "Mathurapur BO": "824118",
      "Paharabali BO": "824118",
      "Tineri BO": "824118",
      "Aima Chouki BO": "824233",
      "Naili BO": "824233",
      "Panari BO": "824233",
      "Rauniya BO": "824233",
      "Ker BO": "824235",
      "Kespa BO": "824235",
      "Ur Bishunpur BO": "824235",
      "Usas Deora BO": "824235",
      "Puna Kala BO": "824209",
      "Solra BO": "824209",
      "Arkdhibariya BO": "824236",
      "Bhaismara Maksudpur BO": "824236",
      "Bhori BO": "824236",
      "Bandimaniyara BO": "823311",
      "Birnoi BO": "823311",
      "Telari BO": "823311",
      "Koiri Bigha BO": "804403",
      "Railly BO": "804403",
      "Bhalua BO": "804404",
      "Moratal BO": "824231",
      "Bijubigha BO": "823003",
      "Budhgere BO": "823003",
      "Maksudpur BO": "823003",
      "Nagariyawan BO": "823003",
      "Ilra BO": "824237",
      "Anjanwan BO": "824232",
      "Bahsa Pipra BO": "824232",
      "Baraila BO": "824232",
      "Dumarichatti BO": "824232",
      "Kadhariya BO": "824232",
      "Kariyadpur BO": "824232",
      "Lodhway BO": "824232",
      "Naudiha Jhurang BO": "824232",
      "Churi BO": "823002",
      "Kujapi BO": "823002",
      "Dighi BO": "824118",
      "Dushadh Bigha BO": "824118",
      "Korap BO": "824118",
      "Malpa BO": "824118",
      "Tajpur BO": "804407",
      "Bindaul BO": "824233",
      "Chiraili BO": "824233",
      "Nadara BO": "824233",
      "Sapneri BO": "824233",
      "Bargaon BO": "824235",
      "Sanda BO": "824235",
      "T Jalalpur BO": "824235",
      "Kapasiya BO": "824209",
      "Dharamashala BO": "824236",
      "Fatehpur Nepa BO": "824236",
      "Jamuara BO": "824236",
      "Nimthu BO": "803116",
      "Karubigha BO": "803116",
      "Gaya HO": "823001",
      "Bairagi SO": "823002",
      "APColony SO Gaya": "823001",
      "Belaganj SO": "804403",
      "Durga Asthan SO": "823003",
      "Gaya DB SO": "823001",
      "Paraiya SO": "824209",
      "Purani Godown SO": "823001",
      "Bodhgaya SO": "824231",
      "Chowk SO": "823001",
      "Gaya Jail SO": "823001",
      "Gewal Bigha SO": "823001",
      "Guraru Mills SO": "824118",
      "Chakand SO": "804404",
      "Chandouti SO": "823001",
      "Civil Lines SO Gaya": "823001",
      "Delha SO": "823002",
      "Karimganj SO": "823001",
      "Kharkhura SO": "823002",
      "Mow SO": "824235",
      "Tekari SO": "824236",
      "Asc CentreN Gaya SO": "823005",
      "Atri SO": "823311",
      "Buniyad Ganj SO": "823003",
      "Chand Chourah SO": "823001",
      "Cherki SO": "824237",
      "Civil Aerodram SO": "823004",
      "Fatehpur SO Gaya": "824232",
      "Gaya RS SO": "823002",
      "Khizersarai SO": "824233",
      "Magadh University SO": "824234",
      "New Godown SO": "823001",
      "Main SO": "804435",
      "Gurua SO": "824205",
      "Imamganj SO": "824206",
      "Dumaria SO": "824221",
      "Gola Bajar Sherghati SO": "824211",
      "Konch SO Gaya": "824207",
      "Raniganj SO Gaya": "824210",
      "Sherghati SO": "824211",
      "Dobhi SO": "824220",
      "Barachatti SO": "824201",
      "Amas SO": "824219",
      "Bankey Bajar SO": "824217",
      "Wazirganj SO Gaya": "805131",
      "Anti SO": "824116",
      "Tarwan SO": "805128"
    },
    "PATNA": {
      "Pareo BO": "802160",
      "Akbarpur BO": "804401",
      "Kodra BO": "804401",
      "NADWAN BO": "804453",
      "NISARPURA BO": "804453",
      "PAIMARGHAT BO": "804453",
      "PATHAR HAT BO": "804453",
      "SAKRAICHA BO": "804453",
      "SRIPALPUR BO": "804453",
      "SUITHA BO": "804453",
      "Burhara BO": "803212",
      "Achuara BO": "803213",
      "Belchi BO": "803110",
      "L KACHUARA BO": "804453",
      "LAKHANA BO": "804453",
      "Akhtiyarpur BO": "801104",
      "ARAP BO": "801104",
      "MARANCHI BO": "804453",
      "MOHANPUR BO": "804453",
      "PARTHU BO": "804453",
      "Dariyapur B.O": "804453",
      "Saistapur BO": "803211",
      "Shawani BO": "803211",
      "Karnauti BO": "803212",
      "Madhopur BO": "803212",
      "Rawaich BO": "803212",
      "Tola Sohan Rai BO": "803212",
      "Bhagwatpur Karmaur BO": "803214",
      "Bihari Bigha BO": "803214",
      "LAKHANPAR BO": "804453",
      "MITTANCHAK BO": "804453",
      "PARSA BO": "803201",
      "Chanda BO": "803212",
      "Satya Bhaiya BO": "803212",
      "Badopur BO": "803214",
      "Dhabhma BO": "803214",
      "Kondi BO": "803214",
      "Parsawan BO": "803214",
      "Sahri BO": "803214",
      "Atnama BO": "803213",
      "Bhatgaon BO": "803213",
      "Mobarakpur BO": "803213",
      "Saksohra BO": "803213",
      "Daulatpur BO": "803214",
      "Chaknawada BO": "803213",
      "Darveshpur BO": "803213",
      "Ekdanga BO": "803213",
      "Hazipur Belaur BO": "803213",
      "Khajurar BO": "803213",
      "Mahammadpur BO": "803213",
      "Ghoswari BO": "803212",
      "Ramnagar Diara BO": "803212",
      "Sabnima Khurd BO": "803212",
      "Agwanpur BO": "803214",
      "Bahrawan BO": "803214",
      "Gowasa Shikhpura BO": "803214",
      "Ranabigha BO": "803214",
      "Sarhan BO": "803214",
      "Andauli BO": "803213",
      "Berhana BO": "803213",
      "Masathu BO": "803213",
      "Nadama Tola BO": "803213",
      "Baruane BO": "803307",
      "Kothia BO": "800009",
      "Sonagopalpur BO": "800007",
      "DGTOLA BO": "803203",
      "MOBARAKPUR BO": "801505",
      "NAGWAN BO": "801109",
      "SGOPALPUR BO": "801109",
      "SRAMPUR BO": "801109",
      "MASAURHA BO": "801110",
      "MURIKA BO": "801110",
      "PAIPURA KALA BO": "801110",
      "SARSI BO": "801110",
      "Maranchi B.O": "800009",
      "Punadih BO": "800009",
      "Sabalpur BO": "800009",
      "Alampur Gonpura BO": "801505",
      "DHIBRA BO": "801505",
      "APiplawan BO": "801109",
      "Ajwan BO": "801109",
      "CHIRAURA BO": "801109",
      "KARAI BO": "801109",
      "BANAULI KHURD BO": "801110",
      "CHANDHOSH BO": "801110",
      "CHIKSHI BO": "801110",
      "DAHIA BO": "801110",
      "SIKARIA BO": "801110",
      "Mangla Devi BO": "800007",
      "RUKUNPUR BO": "803203",
      "Amarpura BO": "801109",
      "CHESI BO": "801109",
      "KORAWAN BO": "801109",
      "SARASAT BO": "801109",
      "ANKURI BO": "801110",
      "JANPUR BO": "801110",
      "KHANPURA BO": "801110",
      "KURKURI BO": "801110",
      "SIDHIPUR BO": "801110",
      "SIGORI BO": "801110",
      "SIYARAMPUR BO": "801110",
      "MADHOPUR BO": "801503",
      "MANGARPAL BO": "801108",
      "MEHDAWAN BO": "801108",
      "PATILA BO": "801108",
      "Akauna BO": "804453",
      "Ahiyapur BO": "801108",
      "KCHAUHATTAR BO": "801108",
      "RAMNAGAR BO": "801108",
      "Aikhan BO": "801102",
      "JAMUI BO": "801102",
      "SIHI BO": "801102",
      "BARAH BO": "801112",
      "CHIPURA KURD BO": "804453",
      "LALA BHADSARA BO": "801102",
      "MDIHULI BO": "801102",
      "SADAWAH BO": "801102",
      "SAHORA BO": "801102",
      "SORANGPUR BO": "801102",
      "JAT DUMARI BO": "804453",
      "KALYANPUR BO": "804453",
      "KANDAP BO": "804453",
      "KEORA BO": "804453",
      "Jodhan Bigha BO": "803110",
      "Missi BO": "803110",
      "Sigaryawn BO": "801304",
      "Top BO": "801304",
      "Chintamanchak BO": "803302",
      "Karkain B.O": "811104",
      "Korari BO": "803110",
      "Malpur BO": "803301",
      "Maranchi BO": "803301",
      "Rampur Dumra BO": "803301",
      "Bairia BO": "800007",
      "Nadghat BO": "800007",
      "Fatehpur B.O": "800007",
      "Chaughara BO": "800008",
      "NANDLALABAD BO": "803203",
      "USFA BO": "803203",
      "SORAMPUR BO": "801505",
      "BELA TARARI BO": "801109",
      "CDARIYAPUR BO": "801109",
      "KARANJA BO": "801109",
      "KHAJURI BO": "801109",
      "RBJAITIPUR BO": "801109",
      "Achua BO": "801110",
      "JARKHA BO": "801110",
      "MAHABALIPUR BO": "801110",
      "MUKHMILPUR BO": "801110",
      "RANIPUR BO": "801110",
      "SEHRA BO": "801110",
      "HULASHI TOLA BO": "801108",
      "RAMPUR DIARA BO": "801108",
      "BHARATPURA BO": "801102",
      "SINGHARA BO": "801102",
      "BASUHAR BO": "804453",
      "DEHRI BO": "804453",
      "KURTHAUL BO": "804453",
      "Sahari B.O": "811104",
      "Gopalur BO": "803110",
      "Sirsi BO": "803110",
      "Diyawan BO": "801304",
      "Dhanak Dove BO": "803302",
      "Paijuna BO": "803302",
      "Aunta BO": "803303",
      "Chaksawar BO": "803211",
      "Dakshnichak BO": "803211",
      "Jalalpur BO": "803211",
      "Nayabigha BO": "803211",
      "Rahimapur BO": "803211",
      "Ramnagar Karai Kachhar BO": "803211",
      "Rupas BO": "803211",
      "Raily BO": "803221",
      "Sahdeopur Chaturbhujpur BO": "803306",
      "Fatehpur BO": "803211",
      "Karjan BO": "803211",
      "DATIYANA BO": "801104",
      "KAB BO": "801104",
      "WAZIRPUR BO": "801104",
      "NAYA PANAPUR BO": "800012",
      "BAIKATPUR BO": "803202",
      "KARAUTA BO": "803202",
      "KATAUNA BO": "803202",
      "LAKHANPURA BO": "803202",
      "MANJHAULI BO": "803202",
      "DSIMARI BO": "801103",
      "BMACHHERIAMA BO": "803201",
      "GAURI PUNDO BO": "803201",
      "MAHIUDDINPUR BO": "803201",
      "KHARAUNA BO": "804454",
      "BAHRAMPUR BO": "804451",
      "BARHIBIGHA BO": "804451",
      "NANAURI BO": "804451",
      "NAWASI CHAK BO": "804451",
      "SONMAI BO": "804451",
      "VIJAYPURA BO": "804451",
      "BEDAULI BO": "804452",
      "BHASMA BO": "804452",
      "CHHATA BO": "804452",
      "HANSADIH BO": "804452",
      "KHAINIA BO": "804452",
      "KOSUT BO": "804452",
      "PITWANS BO": "804452",
      "USMANCHAK BO": "804452",
      "JAMSAUT BO": "801503",
      "GANGAHARA BO": "801503",
      "BEUR BO": "800002",
      "PAKRI BO": "800002",
      "BISHUNPURA BO": "801111",
      "DHANAUT BO": "801506",
      "M KACHUARA BO": "800030",
      "MKURJI BO": "801105",
      "DANARA BO": "801104",
      "GORAKHARI BO": "801104",
      "PANAPUR BO": "800012",
      "DOMA BO": "803202",
      "KALADIARA BO": "803202",
      "Amhara BO": "801103",
      "ANANDPUR HOMEGUARD BO": "801103",
      "BAHPURA BO": "801103",
      "KUNJWAN BO": "801103",
      "TARANAGAR BO": "801103",
      "BENI BIGHA BO": "801104",
      "Akilpur BO": "800012",
      "Alipur Bihta BO": "803202",
      "BARUNA BO": "803201",
      "KACHIDARGALI BO": "803201",
      "KANCHANPUR BO": "801103",
      "MASARHI BO": "803201",
      "BARA BO": "804454",
      "REWAN BO": "804454",
      "BANSBIGHA BO": "804451",
      "BAURAHI BO": "804451",
      "DEODHA BO": "804451",
      "DHANARUA BO": "804451",
      "NADPURA BO": "804451",
      "NASARATPUR BO": "804451",
      "SIMHARI BO": "804451",
      "BARNI BO": "804452",
      "BHADAURA BO": "804452",
      "CHARMA BO": "804452",
      "GANGACHAK BO": "804452",
      "GHORAHUA BO": "804452",
      "LAHSUNA BO": "804452",
      "POAWAN BO": "804452",
      "SANDA BO": "804452",
      "DALIPCHAK BO": "801503",
      "JRTOLA BO": "801503",
      "TISKHORA BO": "801111",
      "WAZITPUR BO": "801111",
      "PAHARI BO": "800030",
      "KOHAWAN BO": "803202",
      "NETAR BO": "803202",
      "RAMCHAURA BO": "803202",
      "SALIMPUR BO": "803202",
      "KATESHAR BO": "801103",
      "ANDA BO": "801113",
      "BALUA BO": "801113",
      "DUMRI BO": "803201",
      "JAITIA BO": "804451",
      "KANSARI BO": "804451",
      "MALLICKPUR BO": "804451",
      "MANKIPAR BO": "804451",
      "PANDITGANJ BO": "804451",
      "Rastranagar Rarha BO": "804451",
      "KNATAUL BO": "804452",
      "LALBENGWA BO": "801503",
      "SHERPUR BO": "801503",
      "DAUDPUR BO": "801503",
      "D KALAPUR BO": "801111",
      "SHIKARPUR BO": "801105",
      "MGOPALPUR BO": "801104",
      "MAHAJPURA BO": "801104",
      "RAJIPUR BO": "801104",
      "SAIDAPBAD BO": "801104",
      "GYASPUR MAHAJI BO": "803202",
      "KAYAMPUR BO": "803202",
      "Anandpur BO": "801103",
      "MUSEPUR BO": "801103",
      "PPAINATHI BO": "801103",
      "FARIDPUR BO": "801113",
      "SARAI BO": "801113",
      "GARHOCHAK BO": "803201",
      "SULTANPUR BO": "803201",
      "BERRA BO": "804454",
      "BHAGWANGANJ BO": "804454",
      "BHAKHARI BO": "804451",
      "BHERAGAWAN BO": "804451",
      "BIR BO": "804451",
      "PABHERA BO": "804451",
      "Pabheri more BO": "804451",
      "BINDAUL BO": "801112",
      "DOGHRA BO": "801112",
      "ENISARPURA BO": "801112",
      "PATUT BO": "801112",
      "DAULATPUR BO": "804452",
      "DEWAN BO": "804452",
      "GARIHARA BO": "804452",
      "BEAPUR BO": "801503",
      "CHANDMARI BO": "801503",
      "SADIKPUR BO": "801503",
      "KGOPALPUR BO": "801111",
      "PAINAL BO": "801111",
      "SRICHANDPUR BO": "801111",
      "DHELMA BO": "800020",
      "Karara BO": "803302",
      "More BO": "803302",
      "Fulelpur BO": "803211",
      "Bhuapur BO": "803211",
      "Shivnar BO": "803302",
      "Tartar BO": "803302",
      "Pirbarhauna BO": "801305",
      "Salarpur BO": "801305",
      "Shahjahanpur BO": "801305",
      "Lemuabad BO": "803221",
      "Bakawa BO": "803306",
      "Arai BO": "801304",
      "Arai Benipur BO": "801305",
      "Ashrafpur BO": "801305",
      "Mekra BO": "803221",
      "Prahladpur BO": "803306",
      "Samya Kurmichak BO": "803306",
      "Kanhaipur BO": "803221",
      "Bankipore HO": "800004",
      "Patna GPO": "800001",
      "LOHIA NAGAR H.O": "800020",
      "Rajendra Nagar SO Patna": "800016",
      "West Lohianagar SO": "800020",
      "MEHDIGANJ S.O": "800008",
      "Ashiananagar SO": "800025",
      "BHColony SO": "800026",
      "BPSC SO": "800001",
      "RAJ BHAWAN SO": "800022",
      "Bataganj SO": "800018",
      "Indian Nation SO": "800001",
      "Kidwaipuri SO": "800001",
      "New Jaganpura SO": "800027",
      "Patliputra SO": "800013",
      "Sheikhpura SO Patna": "800014",
      "Sri Krishnapuri SO": "800001",
      "KHUSRUPUR SO": "803202",
      "Purvi laxmi nagar SO": "800030",
      "Ashok Nagar SO Patna": "800020",
      "Chowk Shikarpur SO": "800008",
      "Gulzarbagh SO": "800007",
      "Katra Bazar SO Patna": "800008",
      "Kumhrar SO": "800026",
      "MYSandalpur SO": "800006",
      "Machharhatta SO": "800008",
      "Machhuatoli SO": "800004",
      "Mahavir Asthan SO": "800008",
      "Nanmuhia SO": "800007",
      "PMCH SO": "800004",
      "Patna City SO": "800008",
      "Patna Collectoriate SO": "800001",
      "Patna High Court SO": "800028",
      "BSEBOARD SO": "800017",
      "BV College SO": "800014",
      "Chiraiyatand SO": "800001",
      "Gardanibagh SO": "800001",
      "Hotel Republic SO": "800001",
      "Jamal Road SO": "800001",
      "Keshari Nagar S.O": "800024",
      "Alawalpur SO": "803203",
      "BIKRAM S.O": "801104",
      "DIGHA S.O": "800012",
      "FATWA S.O": "803201",
      "NADAUL S.O": "804454",
      "HAZRAT SAIN SO": "804451",
      "LAI S.O": "801112",
      "SADISOPUR S.O": "801111",
      "SAHAYNAGAR S.O": "801506",
      "Sri Madhoji Mills SO": "800008",
      "Danapur Bazar SO": "801503",
      "Kadamkuan SO": "800003",
      "Mithapur SO Patna": "800001",
      "Patna Aerodrome SO": "800014",
      "Punaichak SO": "800001",
      "RBlock SO": "800001",
      "Vidyut Parisad SO": "800021",
      "P.SHARIF S.O": "801505",
      "MANER S.O": "801108",
      "BIHTA S.O": "801103",
      "MASAURHI S.O": "804452",
      "Bakhtiyarpur SO": "803212",
      "Mokama SO": "803302",
      "Mokamachauk SO": "803302",
      "Mokamaghat SO": "803303",
      "Naya Tola SO Patna": "800004",
      "Pachhim Darwaza SO": "800008",
      "Patna University SO": "800005",
      "RMS Colony SO": "800020",
      "BC Road SO": "800001",
      "CDA SO": "800019",
      "Darul Mallick SO": "800001",
      "Dighaghat SO": "800011",
      "Khagaul Bazar SO": "801105",
      "LBS Nagar SO": "800023",
      "Makhdumpur Digha SO": "800011",
      "Navshakti SO": "800001",
      "New Jakkanpur SO": "800001",
      "Patna Sectt SO": "800015",
      "Postal Park SO": "800001",
      "Ram Jaipal Nagar SO": "801503",
      "Athmalgola SO": "803211",
      "Barh Rs SO": "803214",
      "Pandarak SO": "803221",
      "Sadaquat Ashram SO": "800010",
      "IIT Patna Bihta SO": "801106",
      "NAUBATPUR SO": "801109",
      "PALIGANJ S.O": "801110",
      "BELHAURI S.O": "801102",
      "PUNPUN S.O": "804453",
      "NEORA S.O": "801113",
      "D.CANTT. S.O": "801503",
      "ANISABAD S.O": "800002",
      "KHAGAUL S.O": "801105",
      "Chitragupta Nagar SO": "800020",
      "Diwan Mohalla SO": "800008",
      "JCRoad SO": "800004",
      "KSector SO": "800020",
      "Mahendru SO": "800006",
      "Marufganj SO": "800008",
      "Bhadaur SO Patna": "803307",
      "Barh Court SO": "803213",
      "Barh SO Patna": "803213",
      "Hathidah SO": "803301",
      "NTPC Barh SO": "803215",
      "Samyagarh SO": "803306",
      "AIIMS SO": "801507",
      "Dental College SO": "800007",
      "B R Centre S.O": "801503",
      "Bank Road SO Patna": "800001",
      "Begampur SO Patna": "800009"
    },
    "GOPALGANJ": {
      "Dabchhu BO": "841420",
      "Gamhari BO": "841420",
      "Paharpur BO": "841420",
      "Dumaria BO": "841423",
      "Jhanjhawa Mohamadpur BO": "841423",
      "Dhatingna BO": "841440",
      "Ramchandrapur BO": "841440",
      "Safiabad BO": "841416",
      "Amarpura BO": "841423",
      "Jhirwa BO": "841440",
      "Manbodhparsauni BO": "841440",
      "Sukulbrindawan BO": "841440",
      "Faizullahpur BO": "841420",
      "Khajuria BO": "841505",
      "Maniyara BO": "841505",
      "Barhima BO": "841423",
      "Harpur Tengrahi BO": "841423",
      "Gopalpur BO": "841503",
      "Harpurjan BO": "841420",
      "Katalpur BO": "841420",
      "Matiyari BO": "841426",
      "Rampur Daud BO": "841505",
      "Sorahiya BO": "841423",
      "Tekniwas BO": "841423",
      "Rajapur BO": "841441",
      "Semaria BO": "841441",
      "Rupanchhap BO": "841405",
      "Sadauwan BO": "841405",
      "Salempur BO": "841405",
      "Sareya Narendra BO": "841405",
      "Sikatiya Sridhar Sahi BO": "841405",
      "Bhagwatparsa BO": "841425",
      "Chhitauna BO": "841426",
      "Ahiyapur BO": "841426",
      "Rudalpur BO": "841426",
      "Sisai BO": "841426",
      "Batardey BO": "841405",
      "Devapur BO": "841405",
      "Hassanpur Mathiya BO": "841405",
      "Kahla BO": "841405",
      "Hussepur BO": "841426",
      "Jagtauli BO": "841426",
      "Jignadubey BO": "841426",
      "Lamichaur BO": "841426",
      "BDMahuwan BO": "841508",
      "Jagdishpur BO": "841508",
      "Sahdi Giri BO": "841508",
      "Bhathwa BO": "841441",
      "Achhaibar Pipra BO": "841405",
      "BRampur BO": "841405",
      "Kamalpur BO": "841405",
      "MBiraicha BO": "841405",
      "Neori BO": "841437",
      "Phulwaria BO": "841425",
      "Chakarwakhas BO": "841426",
      "DNarendra BO": "841426",
      "Musahri Bazar BO": "841426",
      "Bairiya BO": "841508",
      "Maheshpur BO": "841508",
      "Khalgaon BO": "841441",
      "BASonbarsa BO": "841405",
      "Khajuri BO": "841405",
      "Lohijara BO": "841405",
      "Nawada BO": "841405",
      "Kalyanpur BO": "841425",
      "Songharwa BO": "841425",
      "Bankata Jagirdari BO": "841426",
      "Bharpurwa BO": "841508",
      "Pyarepur BO": "841410",
      "Dangsi BO": "841407",
      "Maharani BO": "841407",
      "Mohammadpur BO": "841407",
      "KSrirampur BO": "841427",
      "Manjhariya BO": "841427",
      "Amwa Nakchhed BO": "841428",
      "Ekderwa BO": "841428",
      "Manikpur BO": "841428",
      "Pasrama BO": "841428",
      "Jamsar BO": "841436",
      "Kusaundhi BO": "841436",
      "Machhagar BO": "841436",
      "Peoli BO": "841436",
      "Repura BO": "841436",
      "Belsand BO": "841413",
      "Madhopur BO": "841413",
      "Rudrapur BO": "841437",
      "Sohnariya BO": "841437",
      "Mateya Khas BO": "841501",
      "Ratanpura BO": "841501",
      "Salehpur BO": "841501",
      "Sepaya BO": "841501",
      "Kailgarh BO": "841438",
      "Koila Deva BO": "841438",
      "Rasulpur BO": "841438",
      "Rajwahi BO": "841428",
      "Semrahi BO": "841428",
      "UR Bangra BO": "841428",
      "PBhagwanpur BO": "841428",
      "Sukulwa BO": "841428",
      "Barheyan BO": "841436",
      "GS Manjha BO": "841436",
      "Semraon BO": "841436",
      "Jasauli BO": "841437",
      "Bindwalia BO": "841501",
      "Durgmatihania BO": "841501",
      "Baleshra BO": "841438",
      "JJagarnath BO": "841438",
      "Lachhwar BO": "841438",
      "Line Bazar BO": "841438",
      "Mohamadpur BO": "841438",
      "Sundri BO": "841438",
      "Balthra BO": "841503",
      "Dhebwa BO": "841503",
      "Narahwan Sukla BO": "841503",
      "Parwan BO": "841428",
      "RP Tengrahi BO": "841428",
      "BR Bhan BO": "841436",
      "Barkagaon BO": "841436",
      "Siswania BO": "841436",
      "Sohagpur BO": "841436",
      "Mahuwan BO": "841437",
      "Pachdeori BO": "841437",
      "Bishambharpur BO": "841501",
      "Karwatahi Bazar BO": "841501",
      "BA Pakwalia BO": "841438",
      "M Madho BO": "841438",
      "Radhaganj BO": "841438",
      "Sakhekhas BO": "841438",
      "Sawraje BO": "841438",
      "Uchkagaon BO": "841438",
      "Siswa BO": "841503",
      "Hakam BO": "841407",
      "Gausia BO": "841427",
      "Koini BO": "841427",
      "Pathra BO": "841427",
      "Purdiltola BO": "841427",
      "Babubishunpur BO": "841428",
      "Dumaria Dhamapakar BO": "841428",
      "Kararia BO": "841428",
      "Narkatia BO": "841428",
      "Mahuwa BO": "841407",
      "Reotith BO": "841407",
      "Sher BO": "841407",
      "Shyampur BO": "841407",
      "Talimapur BO": "841407",
      "Bhaisahi BO": "841427",
      "Dharamparsa BO": "841427",
      "VS Mill BO": "841428",
      "Yadavpur Dukhharan BO": "841428",
      "Mirja Pur BO": "841436",
      "Belhi Khas BO": "841437",
      "Bhagipatti Jhul BO": "841437",
      "Dharhara BO": "841437",
      "Gaura BO": "841437",
      "Baliwan sagar BO": "841501",
      "Uchka Gaon BO": "841501",
      "KMATIHANIYA NRK TOLA": "841501",
      "Jagarnath BO": "841438",
      "Jignamath BO": "841438",
      "KK Kararia BO": "841438",
      "Lakri Dargah BO": "841438",
      "Mishra Batrahan BO": "841438",
      "Paikauli Baddo BO": "841438",
      "Pakri BO": "841438",
      "Sathi BO": "841438",
      "Sawana BO": "841438",
      "Bodhachhapar BO": "841503",
      "Koiripatti BO": "841503",
      "Sanhaula BO": "841503",
      "Semra Bazar BO": "841503",
      "Thakrahan BO": "841503",
      "Khawajapur BO": "841428",
      "Kashi Tengrahi BO": "841407",
      "Khajuhatti BO": "841407",
      "Baikunthpur BO": "841409",
      "Usribazar BO": "841409",
      "Mungarha BO": "841427",
      "Nimuiya BO": "841427",
      "Parsurampur BO": "841427",
      "Rachhopali BO": "841427",
      "Baraiptti BO": "841428",
      "Basdila BO": "841428",
      "Bhitbherwa BO": "841428",
      "Dahibhata BO": "841428",
      "Gopalganj HO": "841428",
      "Barauli SO Gopalganj": "841405",
      "Jamobazar SO": "841413",
      "Kuchaikote SO": "841501",
      "Nechwajalapur SO": "841503",
      "Rajapatti SO": "841420",
      "Sasamusa SO": "841505",
      "Baghibazar SO": "841441",
      "Hathwa SO": "841436",
      "Sidhwalia SO": "841423",
      "Thawe SO": "841440",
      "Bijaipur SO Gopalganj": "841508",
      "Bishunpura SO": "841407",
      "Garhmanjha SO": "841427",
      "Gopalganj College SO": "841428",
      "Kateya SO": "841437",
      "Mirganj SO": "841438",
      "Bathubazar SO": "841425",
      "Bhore SO": "841426",
      "Dighwdubauli SO": "841409"
    },
    "MUZAFFARPUR": {
      "Tehwara BO": "847123",
      "Lakhanpur BO": "847307",
      "Bhalura BO": "843312",
      "Sakrichandpusa BO": "848125",
      "Dubiahi BO": "843106",
      "Bahilwara Roopnath BO": "844111",
      "Khabra BO": "843113",
      "Chahuta BO": "843312",
      "Dumri BO": "843113",
      "Mirzapur BO": "843103",
      "Gopalpur Neora BO": "843126",
      "Laloo Chapra BO": "843126",
      "Muza Patrahia BO": "843126",
      "RKMalahi BO": "843126",
      "Godanpatti BO": "843118",
      "Kanhara BO": "843118",
      "Amarakh BO": "843119",
      "Binda BO": "843119",
      "Budhnagra Radha BO": "843119",
      "MBadal BO": "843119",
      "MSusta BO": "843119",
      "Chainpur Bangra BO": "843119",
      "Jagdishpur Baghnagari BO": "843119",
      "Narauli BO": "843119",
      "Kinaru BO": "844127",
      "CRPF Camp BO": "842004",
      "Dadar kolhua BO": "843108",
      "BKarman BO": "843111",
      "Bakhari BO": "843111",
      "Barjee BO": "843111",
      "MGopinathpur BO": "843111",
      "Mahmada BO": "843111",
      "Mahual RS BO": "843111",
      "SJahangirpur BO": "843111",
      "Sundar Sarai BO": "843111",
      "SSandha BO": "843111",
      "Berai BO": "843129",
      "Shahila Balli BO": "843129",
      "Bahdinpur BO": "843112",
      "Chochahi Saraiya BO": "843112",
      "KBabhangaon BO": "843112",
      "Belwar BO": "844111",
      "Bahilwara Govind BO": "844111",
      "Hatha BO": "848125",
      "Bahilwara Bhual BO": "844111",
      "MFarakpur BO": "843116",
      "Maksudpur BO": "843117",
      "Manpur Ratnauli BO": "843116",
      "BKesho BO": "843109",
      "Balthi Mushahari BO": "843118",
      "Chiraila BO": "843118",
      "Chorghatta BO": "843111",
      "MBalmi BO": "843111",
      "Jasauli BO": "843111",
      "Pakari BO": "843111",
      "Amnaur BO": "843129",
      "Atrar BO": "843129",
      "Saraiya Bazar BO": "843112",
      "Bhatauna BO": "843113",
      "Mutlupur BO": "843115",
      "Noonfara BO": "843115",
      "DRSah BO": "842002",
      "Mushahari Farm BO": "842002",
      "Sheikhpur BO": "842002",
      "Bhadai BO": "843116",
      "Dakrama BO": "843116",
      "Dharampur BO": "843117",
      "CDharharwa BO": "843328",
      "Chandwara BO": "843328",
      "Chamarua BO": "843113",
      "Ladaura Pakari BO": "843113",
      "Pakari Pakohi BO": "843113",
      "Simra Urf Afzalpur BO": "843113",
      "Munni Bangari BO": "843115",
      "Rampur Dayal BO": "843115",
      "Ratwara BO": "843115",
      "RKAshram BO": "842002",
      "Kharhar BO": "843117",
      "BRudal BO": "843111",
      "Harnahi BO": "843111",
      "Jasoda Math BO": "843111",
      "KBithraul BO": "843111",
      "Baruraj BO": "843111",
      "PTJiwar BO": "843129",
      "Bishundatpur BO": "843113",
      "Damodarpur BO": "843113",
      "Marwan BO": "843119",
      "Subhankarpur BO": "843113",
      "Bandra BO": "843115",
      "Ghosrama BO": "843115",
      "PBishanpur BO": "843115",
      "Shrikant BO": "843115",
      "Naya Tola SO MuzaffarpBO": "842002",
      "Kachhi Sarai BO": "842002",
      "Ghanshyampur BO": "843328",
      "Bedaul Asli BO": "843116",
      "Dih Jiwar BO": "843116",
      "Janar BO": "843116",
      "Korlahia Mansingh BO": "843117",
      "Ganiari BO": "843119",
      "Jalalpur BO": "843119",
      "Markan BO": "843119",
      "Paigambarpur BO": "843119",
      "Prahladpur BO": "843119",
      "Saraiya BO": "843127",
      "Basauli BO": "844127",
      "Ch Harishankar BO": "844127",
      "Charhua BO": "844127",
      "Dariyapur Kafen BO": "844127",
      "Mahindwara BO": "843117",
      "Matihani BO": "843116",
      "Chakna BO": "843126",
      "Raghunathpur BO": "843126",
      "Adigopalpur BO": "843118",
      "Athar BO": "843118",
      "Jarang Deorhi BO": "843118",
      "Loma BO": "843118",
      "Chapra Megh BO": "843119",
      "Dumari BO": "843119",
      "Manika BO": "843119",
      "Sangopatti BO": "843119",
      "Sonbarsa Dih BO": "843119",
      "Bharwari SO MuzaffarpBO": "843119",
      "Jhikati BO": "844127",
      "KMohan BO": "844127",
      "Ratnauli BO": "844127",
      "Jamalabad BO": "842004",
      "Sarhachia BO": "843116",
      "Tengraha BO": "843117",
      "Raja Rampur BO": "843126",
      "Ibrahimpur BO": "843118",
      "Kamarthu BO": "843118",
      "Maithi BO": "843118",
      "Sakarwara BO": "843118",
      "Chhitrauli BO": "843119",
      "MPachdahi BO": "843119",
      "Madhopur BO": "843119",
      "Siho BO": "843119",
      "Mahanth Maniari BO": "843119",
      "KMadhuban BO": "844127",
      "Kerma BO": "844127",
      "Sakari Saraiya BO": "844127",
      "Pupari BO": "844127",
      "Daud Chapra BO": "842004",
      "Jhapaha BO": "842004",
      "Mustafapur BO": "842004",
      "Belahi Lachchi BO": "843131",
      "BFiroj BO": "843111",
      "Bakatpur BO": "843111",
      "Jhingaha BO": "843111",
      "Manohar Chapra BO": "843111",
      "Pana Chapra BO": "843111",
      "Rajepur BO": "843111",
      "Morsandi BO": "843111",
      "Barhad BO": "843129",
      "HKhanpur BO": "843129",
      "Shahila Rampur BO": "843129",
      "Bara Daud BO": "843112",
      "Koria Nizamat BO": "843112",
      "ABishanpur BO": "843113",
      "Kharauna BO": "843113",
      "Bariarpur Karpur BO": "843115",
      "Patsara BO": "843115",
      "Pirapur BO": "843115",
      "Tepari BO": "843115",
      "APurushotampur BO": "842002",
      "Narsinghpur BO": "843105",
      "Susta BO": "842002",
      "BUmapat Basant BO": "843116",
      "Hanswara BO": "843116",
      "Bharthua BO": "843328",
      "Balra Ismail BO": "844112",
      "Bashantpur Patti BO": "843101",
      "Choubey Ambara BO": "843101",
      "Kamalpura BO": "843101",
      "Madhaul BO": "843101",
      "Datapur Pachbhirwa BO": "843101",
      "GKNagar BO": "843102",
      "Kishanpur Telour BO": "843102",
      "Newachak BO": "843102",
      "Katesar BO": "843102",
      "Rampur Mina BO": "843127",
      "Shirsia Jagdish BO": "843127",
      "Amma BO": "843103",
      "Baghakhal BO": "843103",
      "Majhaulia BO": "843104",
      "Mohabatpur BO": "843120",
      "Mohamadpur BO": "843120",
      "PBasarat BO": "843120",
      "Kokilwara BO": "843312",
      "Rajkhand BO": "843312",
      "Rewa Basantpur BO": "843101",
      "Raja Pakar BO": "843102",
      "Sahbajpur Puraina BO": "843102",
      "Mohammadpur Bhopat BO": "843102",
      "Jita Chapra BO": "843127",
      "Hasna BO": "843103",
      "PShyam BO": "843103",
      "Raini BO": "843121",
      "BMuza BO": "843120",
      "Dhanaiya BO": "843120",
      "Gokhula Rupauli BO": "843120",
      "BBaghnagari BO": "843105",
      "Mehshi BO": "843105",
      "Daudpur BO": "843107",
      "Phular BO": "843107",
      "Sarmastpur BO": "843107",
      "Bajitpur BO": "843123",
      "Kolwara BO": "843123",
      "Repura RBishwanath BO": "843123",
      "BTayab BO": "843360",
      "BPandey BO": "843109",
      "Haridaspur BO": "843109",
      "Pakhnaha Shriram BO": "843109",
      "Pipra Asli BO": "843109",
      "Singar BO": "843109",
      "Patti Aswari BO": "843124",
      "Harkhauli BO": "843321",
      "Pahsaul BO": "843321",
      "Bhagwanpur BO": "843120",
      "Chandrahatti BO": "844120",
      "Ahiyapur BO": "843125",
      "BNijamat BO": "843125",
      "Rup Chapra BO": "843125",
      "Tarawa BO": "843125",
      "Maripur BO": "842003",
      "Barhanda BO": "843128",
      "Chatursi BO": "843128",
      "Harser BO": "843128",
      "Meghua BO": "843131",
      "Narwara BO": "843131",
      "Tengrari BO": "843128",
      "Mansoorpur BO": "843101",
      "Sundarpur BO": "843102",
      "Baburban Tajpur BO": "843127",
      "Gharbhara BO": "843103",
      "Malpur BO": "843103",
      "Ram Nagar BO": "843103",
      "SMuraul BO": "843121",
      "Bhagwatpur BO": "843120",
      "Neknampur BO": "843120",
      "Govindpur Bela BO": "843105",
      "Chhap BO": "843107",
      "Fatehabad BO": "843107",
      "Mohjama BO": "843107",
      "Phulwaria BO": "843107",
      "Repura Mahadeo BO": "843107",
      "Karja BO": "843106",
      "Berua BO": "843122",
      "Pagahia Aima BO": "843122",
      "Amaitha BO": "843123",
      "Panapur Akhtiarpur BO": "843123",
      "Sirkohia BO": "843123",
      "Angoa BO": "843360",
      "Ufrauli BO": "843360",
      "Birpur BO": "843109",
      "Nariar Panapur BO": "843109",
      "Panapur Kariat BO": "843109",
      "Fateha BO": "843124",
      "Thikaha Basudeo BO": "843124",
      "Gangeya BO": "843321",
      "Khangura BO": "843321",
      "Balaur BO": "844120",
      "Chakwaja Nagma BO": "844120",
      "BKalyan BO": "843125",
      "Hussepur BO": "843125",
      "Jagdishpur BO": "843125",
      "Rajwara BO": "843125",
      "Manain BO": "843125",
      "Brindawan BO": "843131",
      "Raghai BO": "843128",
      "Sonbarsa BO": "843131",
      "Turki Khararu BO": "843128",
      "RSaghari BO": "843312",
      "Ratwara Bindwara BO": "843312",
      "Sahi Minapur BO": "843312",
      "Sahpur Maricha BO": "844112",
      "Parsauni Nath BO": "843127",
      "Choumukh BO": "843103",
      "Dahila BO": "843103",
      "Kafen BO": "843103",
      "Lohsari BO": "843103",
      "Sanathi BO": "843103",
      "Unsar BO": "843103",
      "BBakhari BO": "843121",
      "IRNagar BO": "843121",
      "Mirapur BO": "843121",
      "Pilkhi Gajpatti BO": "843121",
      "Dharfari BO": "843120",
      "Tola Muza BO": "843120",
      "Partapur BO": "843106",
      "Rupauli BO": "843106",
      "Jamin Mathia BO": "843109",
      "KHRamani BO": "843109",
      "Kabilpur BO": "843109",
      "Mahartha BO": "843109",
      "Jamalpur BO": "843124",
      "PMushahari BO": "843124",
      "Bandpura BO": "843321",
      "Baraitha BO": "843321",
      "Basua BO": "843321",
      "Dhanaur BO": "843321",
      "Sonepur BO": "843321",
      "Mathurapur Buzurg BO": "843321",
      "Girigama Dih BO": "844120",
      "M Afzalpur BO": "844120",
      "Rajala BO": "844120",
      "Balthi Narhar BO": "843125",
      "Paraspatti BO": "843125",
      "Ghosaut BO": "843128",
      "HManshahi BO": "843128",
      "Kodaria BO": "843128",
      "Mahdaiya BO": "843128",
      "Mustafaganj BO": "843128",
      "BBajitpur BO": "843111",
      "BBarna BO": "843111",
      "Sahpurpatti BO": "843120",
      "Sohansa BO": "843120",
      "Beladam BO": "843105",
      "Govindpur Bejha BO": "843105",
      "Machhahi BO": "843105",
      "Titra Ashanand BO": "843105",
      "Jaimal Dumari BO": "843107",
      "Kalyanpur BO": "843107",
      "Karamwari BO": "843107",
      "Khutahi BO": "843107",
      "Chochahi Chapra BO": "843122",
      "Parsauni Pagahia BO": "843122",
      "Rampur Bheriahi BO": "843122",
      "Basara Shukul BO": "843123",
      "Ginjas BO": "843123",
      "Changel BO": "843360",
      "Chapra Dharampur Jaddu BO": "843108",
      "Sirsia Buzurg BO": "843108",
      "Bmahanand BO": "843109",
      "Raksha BO": "843109",
      "SBarkagaon BO": "843109",
      "Sadiquepur BO": "843109",
      "Sainpatti SPSingh BO": "843109",
      "Pindauli BO": "843321",
      "Shivdaspur BO": "843321",
      "Anant Kamtaul BO": "844120",
      "Azizpur BO": "844120",
      "Basatpur BO": "843125",
      "Basudeo Sarai BO": "843125",
      "Bishunpur Patti BO": "843125",
      "MHazari BO": "843125",
      "Madhubani BO": "843125",
      "Sagahari BO": "843128",
      "Shitalpatti BO": "843128",
      "Siwaipatti BO": "843128",
      "Raghopur BO": "843128",
      "Ajna Kot BO": "843111",
      "Muzaffarpur HO": "842001",
      "Aurai SO Muzaffarpur": "843312",
      "Bihar University SO": "842001",
      "Chandanpatti SO": "843104",
      "Deoria SO Muzaffarpur": "843120",
      "Jaintpur Estate SO": "843123",
      "Aghoria Bazaar SO": "842002",
      "DACollege SO": "843121",
      "Dholi SO": "843105",
      "Gidha SO": "843106",
      "Kalwari SO Muzaffarpur": "842006",
      "Kalyani SO": "842001",
      "Kanti TPS SO": "843130",
      "Kathaiya SO": "843124",
      "MIT SO": "842003",
      "Malighat Maniari SO": "842001",
      "Minapur SO": "843128",
      "Amgola SO": "842001",
      "Birihma Bazar SO": "843127",
      "Bochaha SO": "843103",
      "Geyaspur SO": "843107",
      "Imlichatti SO": "842001",
      "Kanhauli Azra SO": "842002",
      "Kanti SO": "843109",
      "MIC SO": "842005",
      "BMPVI SO": "842001",
      "Baghi SO Muzaffarpur": "844112",
      "Bakhra SO": "843101",
      "Bariarpur SO Muzaffarpur": "843102",
      "Chhata Bazar SO Muzaffarpur": "842001",
      "Hardi SO Muzaffarpur": "843122",
      "Jajuar SO": "843360",
      "Katra SO Muzaffarpur": "843321",
      "Kurhani SO": "844120",
      "Kurnowl SO": "843125",
      "Piar SO": "843115",
      "Purani Bazar SO": "842001",
      "SSKBhawan SO": "842001",
      "Saraiyaganj SO": "842001",
      "Umanagar SO": "842004",
      "PKolhua SO": "843108",
      "Tariyani Chowk SO": "843131",
      "Motijheel SO Muzaffarpur": "842001",
      "Muzaffarpur Court SO": "842001",
      "Pakki Sarai SO": "842001",
      "Patahi SO Muzaffarpur": "843113",
      "Sarfuddinpur SO": "843118",
      "Kuahi SO": "843116",
      "Motipur SO": "843111",
      "Muz Collectorate SO": "842001",
      "RDSCollege SO": "842002",
      "Rampur Hari SO": "843117",
      "Saraiya Factory SO": "843126",
      "Sikandarpur SO Muzaffarpur": "842001",
      "Silout SO": "843119",
      "Narma SO": "843129",
      "Paroo SO": "843112",
      "Ramna SO Muzaffarpur": "842002",
      "Turki SO": "844127"
    },
    "KATIHAR": {
      "Bakiadiara BO": "813209",
      "KATARIYA": "853204",
      "Awadpur BO": "855102",
      "Chhoghra BO": "855102",
      "Bairia B.O": "854112",
      "Paharpur BO": "854112",
      "Chandpur BO": "854101",
      "Khaira BO": "854101",
      "Moula Nagar BO": "854101",
      "Nandgola BO": "854101",
      "Dasgram BO": "855102",
      "B BALRAMPUR BO": "854317",
      "BAGHWA BO": "854317",
      "BALUPARA BO": "854317",
      "BATNA BO": "854317",
      "PURANAGANJ BO": "854317",
      "S WONKAR BO": "854317",
      "TINGACHIA BO": "854103",
      "CHANDPUR BO": "855105",
      "CHOWKI HARIPUR BO": "855105",
      "DAWASAI BO": "855105",
      "Mathurapur BO": "855102",
      "Nimoul BO": "855113",
      "KURUM BO": "854317",
      "MAHI NAGAR BO": "854317",
      "MAHISHAL BO": "854317",
      "MARWA BO": "854104",
      "BAKIA BO": "854104",
      "D BISHANPUR BO": "854104",
      "DUMAR BO": "854104",
      "HASIMPUR BO": "854104",
      "KNGURMELA BO": "854104",
      "KANT NAGAR BO": "854104",
      "SANDALPUR BO": "854106",
      "BUDH NAGAR BO": "854107",
      "SAHJA BO": "854107",
      "Durgapur BO": "854112",
      "Gopalpur Diara BO": "854112",
      "Simra BO": "854101",
      "Tikapatti BO": "854101",
      "Pardiara BO": "854112",
      "Goriar BO": "854101",
      "Sameli BO": "854101",
      "Hat Balrampur BO": "855102",
      "KHIDIRPUR BO": "855102",
      "Sankola BO": "855102",
      "SHITALMANI BO": "855102",
      "AJHRAIL BO": "854317",
      "BHELAGANJ BO": "854317",
      "DANGOL BO": "854317",
      "KIRORA BO": "854317",
      "MADHEPUR BO": "854317",
      "MANMAN BO": "854317",
      "MUKURIA BO": "854317",
      "SUDHANI RS BO": "854317",
      "MANSAHI BO": "854103",
      "BABHANI BO": "855105",
      "BHANDARTAL BO": "854104",
      "JOTRAMRAI BO": "854104",
      "KARHAGOLA BO": "854104",
      "MARGHIA BO": "854104",
      "DALAN BO": "854106",
      "BELWA BO": "854107",
      "MADHURA BO": "854107",
      "SAURIYA": "854107",
      "Bakharganj BO": "854112",
      "CHOWKCHAMA BO": "854112",
      "Pani Kamla BO": "854112",
      "Balthi Maheshpur BO": "854101",
      "Chapahari BO": "854101",
      "MTDevipur BO": "854101",
      "PARVELI BO": "855105",
      "PAKAHARA BO": "854104",
      "PAWAI BO": "854104",
      "ROUNIA BO": "854104",
      "SAMDA BO": "854104",
      "SUKHASAN BO": "854107",
      "Kehunia BO": "854116",
      "MAINA NAGAR BO": "854116",
      "BHATWARA BO": "854108",
      "MUSAPUR BO": "854108",
      "BASTAUL BO": "854116",
      "D BAGCHALLA BO": "854116",
      "Tangore BO": "854116",
      "Kantakosh BO": "854113",
      "Chhohar BO": "854114",
      "SALEHPUR BO": "854114",
      "Dilli Diwanganj BO": "854117",
      "Dhumnagar BO": "855113",
      "KURHELA BOBRA BO": "855113",
      "Sadapur BO": "855113",
      "Siktia BO": "855113",
      "Teghra BO": "855113",
      "Sikat BO": "854115",
      "Kadwa BO": "855114",
      "RAGHELI BO": "855114",
      "GOWALTOLI BO": "855102",
      "Jalki BO": "855102",
      "Porla BO": "855102",
      "Shivananpur BO": "855102",
      "BIGHOUR BO": "854317",
      "DHACHNA BO": "854317",
      "GANJAN BO": "854317",
      "TELTA BO": "854317",
      "KUMARIPUR BO": "854103",
      "SIRNEA BO": "854103",
      "BHARRI BO": "855105",
      "SAGRATH BO": "855105",
      "BHAIS DIARA BO": "854104",
      "BISHANPUR BO": "854104",
      "JARLAHI BO": "854104",
      "LAXMIPUR BO": "854104",
      "B SIMARIA BO": "854106",
      "DIGHRI BO": "854106",
      "KURETHA BO": "854107",
      "SISIYA BO": "854108",
      "DHARHAN BO": "854116",
      "Gauripur BO": "854116",
      "MAHUAR BO": "854116",
      "BNDIARA BO": "854113",
      "Hemkunj BO": "854113",
      "Madarichak BO": "854113",
      "Falka BO": "854114",
      "Pirmokam BO": "854114",
      "Neema BO": "854117",
      "Jhawa BO": "855113",
      "Kharsouta BO": "855113",
      "SHIHIPUR BO": "855113",
      "BHBHIR BO": "854115",
      "Kabar BO": "854115",
      "Dumaria BO": "855114",
      "MPGARH BO": "855114",
      "DHANETHA BO": "854108",
      "JHAGRUCHAK BO": "854108",
      "KHERIA BO": "854108",
      "MORSANDA BO": "854108",
      "BAINA BO": "854116",
      "Pranpur BO": "854116",
      "Dilarpur BO": "854113",
      "MUJWAR BO": "854113",
      "M NAWABGANJ BO": "854113",
      "Narayanpur BO": "854113",
      "RNBOULIA BO": "854113",
      "TM Baghar BO": "854113",
      "Bareta BO": "854114",
      "BALTAR BO": "855113",
      "Belbari BO": "855113",
      "Sujapur BO": "854115",
      "Palsa BO": "854116",
      "Basantpur BO": "854114",
      "Bhangaha BO": "854114",
      "Azamnagar BO": "855113",
      "Balia Belon BO": "855113",
      "Bansgarha BO": "854115",
      "Binjee BO": "854115",
      "Jagdishpur BO": "854115",
      "ARIHANA BO": "855114",
      "Bijaili BO": "855114",
      "Dandkhora BO": "855114",
      "FATEHPUR BO": "854317",
      "Rautara BO": "854337",
      "Katihar HO": "854105",
      "Katihar Colony SO": "854105",
      "Katihar Mill SO": "854107",
      "Manihari SO": "854113",
      "Katihar Bmp Camp SO": "854106",
      "Katihar Court SO": "854109",
      "Katihar Rs SO": "854105",
      "Korha SO": "854108",
      "Sonaili SO": "855114",
      "Durgaganj SO": "855105",
      "Katihar Bara Bazar SO": "854105",
      "Mahadevpur SO Katihar": "854116",
      "Pothia SO": "854114",
      "Rosna SO": "854117",
      "Salmari SO": "855113",
      "Semapur Factory SO": "854115",
      "Barsoi SO": "855102",
      "Amdabad SO": "854112",
      "Daharia Molls SO": "854103",
      "Ayodhyaganj Bazar SO": "854101",
      "Barsoighat SO": "854317",
      "Gurubazar SO": "854104"
    },
    "JAMUI": {
      "Abgil Chaurama BO": "811301",
      "Darkha BO": "811301",
      "Kaiyar BO": "811301",
      "Noni BO": "811301",
      "Bamdah BO": "811303",
      "Bichkorwa BO": "811303",
      "Koluadih BO": "811303",
      "Barmoria BO": "811303",
      "Dadhwa BO": "811303",
      "Ramchandradih BO": "811303",
      "Sahora BO": "811301",
      "Seway BO": "811301",
      "Chandra Mandi BO": "811303",
      "Dulampur BO": "811303",
      "Gaganpur BO": "811303",
      "Kiya Jori BO": "811303",
      "Madhopur BO": "811303",
      "N Silfari BO": "811303",
      "Patauwa BO": "811303",
      "S Batpar BO": "811303",
      "Tola Urba BO": "811303",
      "Banpur BO": "811305",
      "Baladih BO": "811301",
      "Dhanama BO": "811301",
      "Dinnagar BO": "811301",
      "Hilsa BO": "811301",
      "Islamnagar BO": "811301",
      "Phariatadih BO": "811303",
      "Pojha BO": "811303",
      "Chango Dih BO": "811305",
      "Chuwan BO": "811305",
      "Nayagaon BO": "811305",
      "Sohjana BO": "811305",
      "Suggi BO": "811305",
      "Dhamna BO": "811305",
      "Batia BO": "811308",
      "Chain BO": "811308",
      "Sahiya BO": "811308",
      "Tabha BO": "811308",
      "Bajila BO": "811308",
      "Jit Jhingoibo BO": "811317",
      "Kharaich BO": "811317",
      "Khelari BO": "811317",
      "Mundbaro BO": "811317",
      "Matia BO": "811312",
      "Amrath BO": "811313",
      "Maniyadda BO": "811313",
      "Numar BO": "811313",
      "Pathak Chack BO": "811313",
      "Agahara Barubatta BO": "811313",
      "Karma BO": "811315",
      "Khardih BO": "811315",
      "Kumar BO": "811315",
      "Lachhuar BO": "811315",
      "Manjosh BO": "811315",
      "Bisodah BO": "811316",
      "Kewal BO": "811316",
      "Kharma BO": "811316",
      "Khuranda BO": "811316",
      "Aghara So BO": "811314",
      "Bishanpur BO": "811314",
      "Markama BO": "811301",
      "Mirzaganj BO": "811301",
      "Pursanda BO": "811301",
      "Basbittibo BO": "811303",
      "Korane BO": "811303",
      "Saraun BO": "811303",
      "Dabil BO": "811305",
      "Kewal Fariyatta BO": "811305",
      "Kharhawa BO": "811305",
      "Mango Bandar BO": "811305",
      "Chhapar Dih BO": "811308",
      "Rajala BO": "811308",
      "Bhour BO": "811317",
      "Chanashly BO": "811317",
      "Dumarkola BO": "811317",
      "Dundu BO": "811317",
      "Barabandh BO": "811317",
      "Arnawabank B.O": "811317",
      "Harkhar BO": "811317",
      "Anandpur BO": "811312",
      "Dighi BO": "811312",
      "Domamarhar BO": "811312",
      "Kala BO": "811312",
      "Darha BO": "811313",
      "Daulatpur BO": "811313",
      "Dhadhaur BO": "811313",
      "Dhandh BO": "811313",
      "Kakan BO": "811313",
      "Katauna BO": "811313",
      "Khadigram BO": "811313",
      "Kharsari BO": "811313",
      "Rabai BO": "811315",
      "Sarsa Bichwe BO": "811315",
      "Sawal Bigha BO": "811315",
      "Sijhauri BO": "811315",
      "Tal Saharsa BO": "811315",
      "Naiyadih BO": "811314",
      "P Matihana BO": "811314",
      "Balthar BO": "811314",
      "Chhuchhnaria BO": "811314",
      "Dhodhari BO": "811314",
      "Gagra BO": "811305",
      "Garsanda BO": "811305",
      "Keshopur BO": "811305",
      "Sevai BO": "811305",
      "Tihiya BO": "811305",
      "Fatehpur BO": "811308",
      "Karma Borba BO": "811308",
      "Ghughuldih BO": "811305",
      "Maura BO": "811305",
      "Ratanpur BO": "811305",
      "Sonpai BO": "811305",
      "Karhara BO": "811308",
      "Sugba Urown BO": "811308",
      "T Barmasia BO": "811308",
      "T Chhapa BO": "811308",
      "Baribag BO": "811317",
      "Gadibishanpur BO": "811317",
      "Gopalpur BO": "811317",
      "Nimnawada BO": "811317",
      "Telia Dih BO": "811312",
      "Arsar BO": "811313",
      "Bukar BO": "811313",
      "Kolhua BO": "811313",
      "Lohra BO": "811313",
      "Sankurha BO": "811313",
      "Bariarpur BO": "811313",
      "B Bahadurpur BO": "811315",
      "Pirhinda BO": "811315",
      "Mohanpur BO": "811316",
      "Charkapathal BO": "811314",
      "Dumari BO": "811314",
      "Narganjo BO": "811308",
      "T Barajor BO": "811308",
      "Hathia BO": "811308",
      "Amari BO": "811317",
      "Garhi BO": "811317",
      "Nariyana BO": "811317",
      "Pradhanchak BO": "811317",
      "Arbaria BO": "811312",
      "Gaura BO": "811312",
      "Barahat BO": "811313",
      "Chaura BO": "811313",
      "Konan BO": "811313",
      "Mahadeo Simaria BO": "811313",
      "Mathurapur BO": "811315",
      "Patambar BO": "811315",
      "Telwa Bazar BO": "811316",
      "Jhundo BO": "811314",
      "Maheshwari BO": "811314",
      "Loha BO": "811314",
      "Jamui HO": "811307",
      "Aliganj SO Jamui": "811301",
      "Chakai SO": "811303",
      "Jhajha Bazar SO": "811308",
      "Sikandra SO Jamui": "811315",
      "Simultala SO": "811316",
      "Gidhaur SO": "811305",
      "Jamui Court SO": "811307",
      "Khaira SO Jamui": "811317",
      "Jhajha SO": "811308",
      "Mallehpur SO": "811313",
      "Laxmipur Jamui SO": "811312",
      "Sono SO": "811314"
    },
    "ARWAL": {
      "Prasadi English BO": "804401",
      "Hasanpur BO": "804402",
      "Makhdumabad BO": "804402",
      "Khajuri BO": "804419",
      "Murari BO": "804419",
      "KHARASIN": "804419",
      "Mednipur Brahiya BO": "804421",
      "Rajepur BO": "804421",
      "Karhari BO": "804423",
      "Mouri BO": "804426",
      "Puarainia BO": "804426",
      "Injore BO": "804428",
      "Parasi BO": "804428",
      "Sarwarpur BO": "804428",
      "Khabhaini BO": "804402",
      "Rampur Waina BO": "804402",
      "Keyal BO": "804419",
      "Mali BO": "804419",
      "Terra BO": "804419",
      "Lari BO": "804421",
      "Manikpur BO": "804421",
      "Nighwan BO": "804421",
      "Pondil BO": "804421",
      "Pinjarawan BO": "804423",
      "Pariyari BO": "804426",
      "Jalpura BO": "804401",
      "Pakharpur BO": "804401",
      "Sakarichowki BO": "804401",
      "Fatehpur Sanda BO": "804402",
      "Anandpur BO": "804419",
      "Annua BO": "804419",
      "Barnathu BO": "804419",
      "Dora BO": "804419",
      "Bara BO": "804421",
      "Rampur Chouram BO": "804402",
      "Sarwan BO": "804402",
      "Walidad BO": "804402",
      "Narga BO": "804419",
      "Puran BO": "804419",
      "Sahar Telpa BO": "804419",
      "Sonbhadra BO": "804419",
      "Majhiyawan BO": "804421",
      "Narhi BO": "804421",
      "Shadipur BO": "804421",
      "Aiara BO": "804426",
      "Bajitpur BO": "804426",
      "Junathi BO": "804426",
      "Kochhasa BO": "804426",
      "Bambhai BO": "804428",
      "Kamta BO": "804428",
      "Koel Bhupat BO": "804428",
      "Masadpur BO": "804428",
      "Niranjanpur BO": "804428",
      "Terri BO": "804428",
      "Bara Korium BO": "804401",
      "Bhadasi BO": "804401",
      "Bithra BO": "804421",
      "Ibrahimpur BO": "804423",
      "SALEMPUR": "804426",
      "Rampurchai BO": "804428",
      "Sakri Khurd BO": "804428",
      "Seikhpura BO": "804428",
      "Belkhara BO": "804428",
      "Jaipur BO": "804428",
      "Jamuhari BO": "804428",
      "Turk Telpa BO": "824203",
      "Manpur Chanda BO": "824127",
      "Agnoor BO": "824143",
      "Sohsa BO": "824127",
      "Belaon BO": "824127",
      "Belsar BO": "824127",
      "Hridaychak BO": "824127",
      "Utrawan BO": "824235",
      "Khantangi BO": "824235",
      "Karpi SO": "804419",
      "Kurtha SO": "804421",
      "Baidrabad SO": "804402",
      "Nagla Kinger SO": "804423",
      "SP Imamganj SO": "804426",
      "Usari SO": "804428",
      "Arwal SO": "804401",
      "Kaler SO": "824127"
    },
    "JEHANABAD": {
      "Jaitipur Kurwa BO": "804432",
      "Korma BO": "804432",
      "Banshi Bigha BO": "804405",
      "Tilkai BO": "804405",
      "Ginji BO": "804406",
      "Dharampur BO": "804417",
      "Kalpa BO": "804417",
      "Muther BO": "804417",
      "Alinagarpali BO": "804418",
      "Utarsarthu BO": "804418",
      "Golakpur Dehuni BO": "804420",
      "Mohiudinpur BO": "804420",
      "Aira BO": "804421",
      "Kachnawan BO": "804422",
      "Ner BO": "804422",
      "Solhanda BO": "804422",
      "Sohariya BO": "804423",
      "Dhana Dehri BO": "804429",
      "Junathi BO": "804429",
      "Kormathu BO": "804424",
      "Newari BO": "804425",
      "Sikandarpur BO": "804425",
      "Malathi BO": "804427",
      "Sarthua BO": "804427",
      "Bharthu BO": "804432",
      "Chhotki Akouna BO": "804432",
      "Atiawan BO": "804432",
      "Julfipur Modanganj BO": "804432",
      "Daulatpur Arhit BO": "804432",
      "Deora BO": "804432",
      "Jagdari BO": "804432",
      "Uber BO": "804405",
      "Babhana BO": "804417",
      "Bharthua BO": "804417",
      "Kosdihra BO": "804417",
      "Kumbhawan BO": "804417",
      "Bhadsara BO": "804418",
      "Nonhi BO": "804418",
      "Saistabad BO": "804418",
      "Waina BO": "804418",
      "Allahganj BO": "804405",
      "Bhaikh BO": "804405",
      "Sonawa BO": "804405",
      "Dhangawan BO": "804417",
      "Korauna BO": "804417",
      "Nauru BO": "804417",
      "Saidabad BO": "804417",
      "Hati BO": "804420",
      "Nagma Erazi BO": "804420",
      "Dakra BO": "804422",
      "Makarpur BO": "804422",
      "Sagarpur BO": "804422",
      "Jamuk BO": "804429",
      "Kaswan BO": "804429",
      "Ikil BO": "804425",
      "Kurtha Bazar BO": "804427",
      "Birra BO": "804405",
      "Bishunganj BO": "804405",
      "Jamanganj BO": "804405",
      "Kurre BO": "804405",
      "Korra BO": "804406",
      "Saho Bigha BO": "804406",
      "Lakhawar B.O": "804406",
      "Mandil BO": "804417",
      "Paigambarpur BO": "804417",
      "Pandooi BO": "804417",
      "Pinjora BO": "804417",
      "Pinjore BO": "804417",
      "Tej Bigha BO": "804420",
      "Ratni Bazar BO": "804421",
      "Bandeya BO": "804422",
      "Berka BO": "804422",
      "Chhariyari BO": "804422",
      "Jagpura BO": "804424",
      "Manjhosh BO": "804424",
      "Patiyawan BO": "804424",
      "Amain BO": "804425",
      "Sugaon BO": "804427",
      "Supi BO": "804427",
      "Abgila BO": "804423",
      "Waina Lakhaipur BO": "804423",
      "Barheta BO": "804423",
      "Noawan BO": "804429",
      "Salarpur BO": "804429",
      "Sarta BO": "804429",
      "Surangapur BO": "804429",
      "Gayani Bigha BO": "804424",
      "Ghejan BO": "804424",
      "Pandoul BO": "804425",
      "Sisamba BO": "804425",
      "Charh BO": "804427",
      "Kalanour BO": "804427",
      "Saren BO": "804427",
      "Rampur BO": "804403",
      "Bauri Beldari BO": "804407",
      "Pathakchak B.O.": "804407",
      "Umta BO": "804403",
      "Dhawal Bigha BO": "804407",
      "Gangapur BO": "804407",
      "Keur BO": "804407",
      "Jarubanwariya BO": "824233",
      "Chhatiyana BO": "804403",
      "Bhagawanpur BO": "804407",
      "Narma BO": "804407",
      "Pitamberpur BO": "801306",
      "Murgawan BO": "801303",
      "Rustampur BO": "801303",
      "PATARIA BO": "804454",
      "BARAWAN BO": "804452",
      "MOKAR BO": "804454",
      "SEONAN BO": "804454",
      "BSIKARIA BO": "804454",
      "Jehanabad HO": "804408",
      "Jehanabad RS SO": "804417",
      "Kako SO": "804418",
      "Makhdumpur SO": "804422",
      "Hulashganj SO": "804407",
      "Dharaut SO": "804405",
      "Sakurabad SO": "804425",
      "Bandhuganj SO": "804432",
      "Kazisarai SO": "804420",
      "Paibigha SO": "804424",
      "Tehta SO": "804427",
      "Ghosi SO Jehanabad": "804406",
      "Jehanabad Kutchary SO": "804408",
      "Nehalpur SO": "804429"
    },
    "SIWAN": {
      "Nadiwan BO": "841231",
      "Tiyan BO": "841231",
      "Hakam BO": "841227",
      "Nathuchhap BO": "841227",
      "Sahlaur BO": "841227",
      "Hariharpur Kala BO": "841434",
      "Sarari BO": "841434",
      "Balua BO": "841435",
      "Chakari BO": "841435",
      "Tarwa Parsia BO": "841435",
      "Dhanutihata BO": "841236",
      "Chimanpura BO": "841416",
      "Khawaspur BO": "841416",
      "Chhotkateghra BO": "841238",
      "Gohpur Bajrahia BO": "841238",
      "Jigrawan BO": "841238",
      "Pakwalia BO": "841238",
      "Rajapur BO": "841238",
      "Rukundipur BO": "841238",
      "Merhi BO": "841240",
      "Belauri BO": "841239",
      "Bishwar BO": "841239",
      "Lebhri BO": "841239",
      "Sematar BO": "841239",
      "Chakia BO": "841507",
      "Kaladumra BO": "841439",
      "Sarauti BO": "841241",
      "Harnathpur BO": "841504",
      "BPEkdanga BO": "841243",
      "Chainpur Hata BO": "841243",
      "Dhanuti BO": "841226",
      "Hardia BO": "841226",
      "Tarwa BO": "841226",
      "Ramgarh BO": "841203",
      "Chaukihasan BO": "841506",
      "Jalalpur BO": "841233",
      "Karanpura BO": "841506",
      "Ratanpura BO": "841506",
      "Shakara BO": "841506",
      "Bharuli BO": "841245",
      "Mania BO": "841245",
      "Piprahiya BO": "841245",
      "Shiopur Sakra BO": "841245",
      "Thepaha Bazar BO": "841245",
      "Bhawrajpur BO": "841231",
      "Faridpur BO": "841231",
      "Gaighat BO": "841231",
      "Jaijore BO": "841231",
      "Kherai BO": "841231",
      "Sikandarpur BO": "841434",
      "Dumrahar BO": "841435",
      "Srikalpur BO": "841435",
      "Hathura BO": "841237",
      "Machakna BO": "841237",
      "Patar BO": "841502",
      "Santhi BO": "841502",
      "Lakari BO": "841416",
      "Hahwa BO": "841238",
      "Karsaut BO": "841238",
      "Kasdeora Bangra BO": "841238",
      "Kothua Sarangpur BO": "841238",
      "Tarwaparsa BO": "841240",
      "Akolhi BO": "841239",
      "Anugrhnagar BO": "841239",
      "Krom BO": "841239",
      "Langarpura BO": "841239",
      "Punak BO": "841239",
      "Seotapur BO": "841239",
      "Sohgra BO": "841239",
      "Talli BO": "841239",
      "PKRampur BO": "841507",
      "Sadiha BO": "841507",
      "Singhauli BO": "841507",
      "Sani Basantpur BO": "841439",
      "Badram BO": "841241",
      "Champ BO": "841241",
      "Gambhria BO": "841241",
      "Itwa Bartwalia BO": "841241",
      "Jasauli BO": "841241",
      "Choiapali BO": "841242",
      "Paterha BO": "841242",
      "Ratanparauli BO": "841242",
      "Narhan BO": "841504",
      "Rajpur BO": "841504",
      "Ramnagar BO": "841504",
      "Nand Pur Amwari BO": "841231",
      "Kandhpakar BO": "841287",
      "Khalishpur BO": "841227",
      "Mahuwari BO": "841227",
      "Papaur BO": "841227",
      "Harihar Pur Lalgarh BO": "841434",
      "Marachhi BO": "841434",
      "Bhlua BO": "841435",
      "Chitakhal BO": "841435",
      "Tenua BO": "841435",
      "Rajanpura BO": "841236",
      "Rampur Ke Tola BO": "841236",
      "Bhikhpur BO": "841237",
      "Dumra BO": "841416",
      "Parauli BO": "841416",
      "Sarif Jalalpur BO": "841416",
      "Bishunpura BO": "841238",
      "Deoria BO": "841238",
      "Pasnauli BO": "841238",
      "Rishura BO": "841238",
      "Chandparsa BO": "841240",
      "Bilaspur BO": "841239",
      "Bishunpura Bazar BO": "841239",
      "Daraila BO": "841239",
      "Jamuaon BO": "841239",
      "Sarhrwa BO": "841239",
      "Bherwania BO": "841507",
      "Bithuna BO": "841507",
      "Govindapur BO": "841507",
      "Chainpur BO": "841439",
      "Purandarpur BO": "841439",
      "Nainpura BO": "841241",
      "Sonbarsa BO": "841241",
      "Admapur BO": "841504",
      "Karsar BO": "841504",
      "NIKHTI KALA BO": "841504",
      "Barkamanjha BO": "841243",
      "Nautan BO": "841243",
      "Pachphera BO": "841243",
      "Sirisia BO": "841413",
      "Amlori BO": "841226",
      "Chapia Bujurg BO": "841226",
      "Jiyan BO": "841226",
      "Sarsar BO": "841226",
      "Tetria BO": "841226",
      "Rasulpur Chakri BO": "841244",
      "Siktia BO": "841244",
      "Dindayalpur BO": "841506",
      "Pipra Naryan BO": "841506",
      "Saraya Sah Mohamd BO": "841506",
      "Chhitanpur BO": "841245",
      "Kpmishrauli BO": "841245",
      "Miyan Ke Bhatkan BO": "841245",
      "Habibnagar BO": "841226",
      "Balaun BO": "841244",
      "Bhartpura BO": "841506",
      "Laxmiganj Sisai BO": "841506",
      "Madhopur BO": "841210",
      "Makariyar BO": "841245",
      "Pachokhar BO": "841245",
      "Ruiyabangra BO": "841245",
      "Sanjalpur BO": "841245",
      "Sisahni BO": "841245",
      "Sarwe BO": "841227",
      "Siwan Mission House BO": "841227",
      "Surwala BO": "841227",
      "Ukhai BO": "841227",
      "Bhithi BO": "841434",
      "Dudhra BO": "841434",
      "Aranda BO": "841236",
      "Bhikhpur Bhgwanpur BO": "841236",
      "Siswan Kala BO": "841236",
      "Ballia BO": "841237",
      "Balliapokhra BO": "841238",
      "S Bangra BO": "841238",
      "Bargaon BO": "841239",
      "Belaur BO": "841239",
      "Bkulari BO": "841239",
      "English BO": "841239",
      "Lawa Rampur BO": "841507",
      "Agya BO": "841439",
      "Laxmiganj BO": "841439",
      "Sahatwar BO": "841439",
      "Saidpura BO": "841439",
      "Chhotka Manjha BO": "841243",
      "Jagdishpur Kothi BO": "841243",
      "Kabirpur BO": "841243",
      "Keelpur BO": "841243",
      "Khalwa BO": "841243",
      "Semaria BO": "841243",
      "Badheyan BO": "841226",
      "Barkagaon BO": "841226",
      "Bhantapokher BO": "841226",
      "Chakra BO": "841226",
      "Mahodipur BO": "841226",
      "Markan BO": "841226",
      "Partap Pur BO": "841226",
      "Bhikha Bandh Satjora BO": "841244",
      "Pipra BO": "841244",
      "Babhanbara BO": "841506",
      "Balia BO": "841506",
      "Banthu Sriram BO": "841245",
      "Bardaha BO": "841245",
      "Barhulia BO": "841245",
      "Bhaisakhal BO": "841245",
      "Gaziapur BO": "841446",
      "Titra BO": "841245",
      "Pihuli BO": "841287",
      "Alapur BO": "841286",
      "Mahmoodpur BO": "841232",
      "Sadarpur BO": "841232",
      "KTBharauli BO": "841404",
      "Rafipur BO": "841286",
      "Telkathu BO": "841286",
      "Koerigawan BO": "841232",
      "Kashila BO": "841287",
      "Harihans BO": "841286",
      "Sahuli BO": "841286",
      "Sagar Sultanpur BO": "841417",
      "BHALUAN BO": "841232",
      "Chorauli BO": "841406",
      "Hussaipurnand BO": "841406",
      "Jagatpur BO": "841406",
      "Kherwa BO": "841406",
      "Mohmda Bazar BO": "841406",
      "Molnapur BO": "841406",
      "Sahrkola BO": "841406",
      "Sekhpura BO": "841406",
      "Bhikhampur BO": "841408",
      "Hulesra BO": "841408",
      "Sahsrawan BO": "841408",
      "Sondhani BO": "841408",
      "BHIMPUR BO": "841232",
      "HARDIA BO": "841232",
      "Baghi BO": "841406",
      "Basaowan BO": "841406",
      "Chorma BO": "841406",
      "Kauria BO": "841406",
      "Sughri BO": "841406",
      "Barkagaowan BO": "841408",
      "Ansar BO": "841203",
      "Dighwalia BO": "841203",
      "Jagdishpur BO": "841203",
      "Gauri BO": "841234",
      "Krishnapali BO": "841234",
      "Machhauta BO": "841233",
      "PHarsar BO": "841233",
      "Rasulpur Tilouta BO": "841233",
      "Harnatar BO": "841235",
      "Tariwani BO": "841235",
      "Barhni BO": "841227",
      "TETHALI BO": "841232",
      "Mathia BO": "841235",
      "Murakhap BO": "841235",
      "Benusar BO": "841227",
      "Benusar Bujurg BO": "841227",
      "Chanaur BO": "841227",
      "Chhapmathia BO": "841227",
      "Bakhari BO": "841203",
      "Bangra Ke Bari BO": "841203",
      "Chhitauli BO": "841203",
      "Sarhara BO": "841203",
      "Amarpur BO": "841234",
      "Balahu BO": "841234",
      "Bishwania BO": "841234",
      "Harsardhanauti BO": "841233",
      "Kolhua BO": "841233",
      "Belaon BO": "841235",
      "Kanhauli BO": "841235",
      "Kumhatti BO": "841235",
      "Netwar BO": "841235",
      "Newari BO": "841509",
      "Panjwar BO": "841509",
      "Tari BO": "841509",
      "Bhagar BO": "841210",
      "Gayaspur BO": "841210",
      "Ghurghat BO": "841210",
      "BAHADURPUR BAZAR BO": "841232",
      "Baijubarhoga BO": "841406",
      "Sohilpatti BO": "841406",
      "Barhipurgop BO": "841408",
      "Nandamura BO": "841203",
      "Keotalia BO": "841234",
      "Sareyarampur BO": "841234",
      "Laheji BO": "841233",
      "Mandrauli BO": "841233",
      "Ramsapur BO": "841233",
      "Draili Mathia BO": "841235",
      "Murera BO": "841235",
      "Kachnar BO": "841210",
      "Noniyapatti BO": "841210",
      "Barhani Bazar BO": "841227",
      "Basopali BO": "841227",
      "Hasua BO": "841436",
      "Sultanpur Kala BO": "841413",
      "Jogapur Kothi BO": "841413",
      "Hatimpur BO": "841413",
      "Paltuhatta BO": "841413",
      "Aghaila BO": "841436",
      "Pachlakhi BO": "841436",
      "Baghauna BO": "841223",
      "Siwan HO": "841226",
      "Siwan Chowk Bazar SO": "841226",
      "Takipur SO": "841244",
      "Tarwara SO": "841506",
      "Zeradei SO": "841245",
      "Lakrinabiganj S.O": "841447",
      "Chapra Road SO": "841226",
      "Done SO": "841235",
      "Gangpur Siswan SO": "841210",
      "Mahrajganj SO Siwan": "841238",
      "Sahpur SO": "841243",
      "Bakerganj SO": "841286",
      "Barhria SO": "841232",
      "Darauli SO": "841234",
      "Daronda SO": "841233",
      "Hussainganj SO": "841237",
      "Kishunpura SO": "841416",
      "Mustfabad SO": "841439",
      "Raghunathpur SO Siwan": "841504",
      "Andar SO": "841231",
      "Asaon SO": "841287",
      "Bagaura SO": "841404",
      "Bhagwanpur Hat SO": "841408",
      "Chainpur SO Siwan": "841203",
      "Khujhwa SO": "841502",
      "Mahuwal Mahal SO": "841240",
      "Mairwa SO": "841239",
      "Mora SO Siwan": "841507",
      "Paterhi SO": "841242",
      "Basantpur SO Siwan": "841406",
      "Gabhirar SO": "841509",
      "Gaushalaroad Siwan SO": "841227",
      "Goreakothi SO": "841434",
      "Guthni SO": "841435",
      "Hasanpura SO": "841236",
      "Narendrapur SO": "841446",
      "Pachrukhi SO": "841241",
      "Satation Road SO": "841226"
    },
    "KISHANGANJ": {
      "Fatehpur BO": "855101",
      "Jhala BO": "855101",
      "Matiari BO": "855101",
      "Rupani BO": "855101",
      "KORHOBARI BO": "855101",
      "Laucha BO": "855101",
      "Lohargarha BO": "855101",
      "TERHAGACHHI BO": "855101",
      "Thiraniganj BO": "855101",
      "Tulsia BO": "855101",
      "Dhangarha BO": "855101",
      "Dhantola BO": "855101",
      "M BATHNA BO": "855101",
      "Mangura BO": "855101",
      "Dighalbank BO": "855101",
      "NISHANDRA BO": "855101",
      "SOMESHWAR BO": "855101",
      "Baigna BO": "855101",
      "DHUSMALHAT BO": "855107",
      "GMBATHNA BO": "855107",
      "KANHAIYABARI HAT BO": "855107",
      "Bibiganj BO": "855101",
      "Bishanpur BO": "855101",
      "Bairia BO": "855101",
      "BHORADAH": "855101",
      "BHOLMARA BO": "855108",
      "TARABARI BO": "855108",
      "ASJA BO": "855107",
      "GANGI BO": "855107",
      "KASHIBARI HAT BO": "855107",
      "KUTTI GOLA BO": "855107",
      "RUNKI BO": "855107",
      "Bangama BO": "855101",
      "Bhittabari BO": "855101",
      "CHATTAR GACHHI BO": "855117",
      "Khatia Pichhia BO": "855117",
      "MARIYA BO": "855117",
      "PThakurbari BO": "855117",
      "Nainagachhi BO": "855116",
      "Pathamari BO": "855116",
      "Chanamana BO": "855117",
      "Daluahat BO": "855117",
      "Mirjapur BO": "855117",
      "Pahar Katta BO": "855117",
      "SHITALPUR BO": "855117",
      "Bhawaniganj BO": "855116",
      "Churli BO": "855116",
      "Patharia BO": "855116",
      "MAUDHA BO": "855115",
      "Shishabari BO": "855115",
      "Hulhuli BO": "855116",
      "KHODAGANJ BO": "855108",
      "MEHARGANJ BO": "855108",
      "PADAMPUR BO": "855108",
      "POWAKHALI BO": "855108",
      "ALTAHAT BO": "855107",
      "BELWA BO": "855107",
      "NATUA PARA BO": "855107",
      "PATKOI HAT BO": "855107",
      "PIYAJEE BO": "855107",
      "RAIPUR BO": "855107",
      "SIRSEE BO": "855107",
      "Angarhat BO": "855115",
      "BBBHARATPUR BO": "855108",
      "JIA POKHAR BO": "855108",
      "SARAIKURI BO": "855108",
      "BAGALBARI BO": "855107",
      "CHAKLA GHAT BO": "855107",
      "KHARUDAH BO": "855107",
      "SINGHIA BO": "855107",
      "TEOSA BO": "855107",
      "Dhanpatganj BO": "855115",
      "Dogharia BO": "855115",
      "Haldikhora BO": "855115",
      "Kochadhaman BO": "855115",
      "Mirpur BO": "855115",
      "Singhari BO": "855115",
      "Panasihat BO": "855117",
      "Poth RS BO": "855117",
      "Gunjanmari BO": "855116",
      "Jirangachhi BO": "855116",
      "Gamharia BO": "854333",
      "Piprithan BO": "855116",
      "Ruidhasa BO": "855116",
      "Kishanganj Bazar SO": "855108",
      "Kishanganj SO": "855107",
      "Thakurganj SO": "855116",
      "Bahadurganj SO Kishanganj": "855101",
      "Sontha SO": "855115",
      "Taiyabpur SO": "855117",
      "Galgalia SO": "855106"
    },
    "LAKHISARAI": {
      "Ghonghsa BO": "811315",
      "Matashi BO": "811315",
      "Ganga Sarai BO": "811302",
      "Jaitpur BO": "811302",
      "Jalal Pur Nauranga BO": "811302",
      "Khutha BO": "811302",
      "Dhira BO": "811315",
      "Noma BO": "811315",
      "Birupur BO": "811302",
      "Dumari BO": "811302",
      "Tarhari BO": "811315",
      "L Kalyanpur BO": "811302",
      "Pipariya BO": "811302",
      "Talsharama BO": "811302",
      "M Nagar BO": "811315",
      "B Dariyapur BO": "811302",
      "Chetan Tola Khutha BO": "811302",
      "Sadaibigha BO": "811302",
      "Pawai BO": "811309",
      "Pokhrama BO": "811309",
      "Rampur BO": "811310",
      "Sahoor BO": "811310",
      "Manjhway BO": "811311",
      "Mankattha BO": "811311",
      "Nandnama BO": "811311",
      "Pacham BO": "811311",
      "S Khairma BO": "811311",
      "S Salaunja BO": "811311",
      "Sharma BO": "811311",
      "Shiovsona BO": "811311",
      "Alinagar BO": "811106",
      "Amarpur BO": "811106",
      "Gopalpur BO": "811310",
      "Malia BO": "811310",
      "Mano BO": "811310",
      "G Parsando BO": "811311",
      "Kisanpur BO": "811311",
      "Mahisona BO": "811311",
      "Parsama BO": "811311",
      "Ramgarh BO": "811311",
      "Rehua BO": "811311",
      "Tetarhat BO": "811311",
      "Abhaypur BO": "811112",
      "Kiranpur BO": "811106",
      "Arma BO": "811309",
      "Lai BO": "811309",
      "Bannu Bagicha BO": "811310",
      "Bichhwey BO": "811310",
      "Singhchak BO": "811310",
      "CR Lakhisarai BO": "811311",
      "Mohanpur BO": "811311",
      "Baghaur BO": "811311",
      "Belari BO": "811311",
      "Nadiyama BO": "811107",
      "R Mahsaura BO": "811107",
      "S Imam Nagar BO": "811107",
      "Kachhiyana BO": "811107",
      "Pratappur BO": "811107",
      "Bhabangama BO": "811311",
      "Dhiradar BO": "811311",
      "Halsi BO": "811311",
      "Ramchandrapur BO": "811311",
      "Dighari BO": "811106",
      "Mustafapur BO": "811106",
      "Paharpur BO": "811106",
      "Billo BO": "811107",
      "Urain BO": "811309",
      "Janki Dih Beldaria BO": "811310",
      "Mananpur BO": "811310",
      "Sangrampur BO": "811310",
      "Shobhani BO": "811310",
      "Aurey BO": "811311",
      "Balgudar BO": "811311",
      "Damodar Pur BO": "811311",
      "Dihra BO": "811311",
      "Kendi BO": "811311",
      "Konag BO": "811311",
      "Ramnagar BO": "811311",
      "Walipur BO": "811311",
      "Rahatpur B.O": "811311",
      "Loshghani BO": "811112",
      "K T Laxmipur BO": "811106",
      "Nandpur BO": "811106",
      "Barhiya SO": "811302",
      "Lakhisarai Court SO": "811311",
      "Surajgaraha SO": "811106",
      "Kiulrs SO": "811310",
      "PBLakhisarai SO": "811311",
      "Kajra SO": "811309",
      "Piri Bazar SO": "811112",
      "Lakhisarai SO": "811311"
    },
    "KAIMUR (BHABUA)": {
      "Kurasan BO": "821101",
      "Mahuari BO": "821101",
      "Mion BO": "821101",
      "Mokari BO": "821101",
      "Pahariya BO": "821101",
      "Saitha BO": "821101",
      "Sonhan BO": "821101",
      "Ujari Sikathi BO": "821101",
      "Dumarkon BO": "821102",
      "Jaitpur Kalan BO": "821102",
      "Dewhalia BO": "821110",
      "Jamurna BO": "821110",
      "Umapur Saraiya BO": "821102",
      "Bararhi BO": "821103",
      "Baraura BO": "821110",
      "Chhotki Kulhariya BO": "821110",
      "Darwan BO": "821110",
      "Adhaura BO": "821102",
      "Khajura BO": "821102",
      "Kolhua BO": "821102",
      "Biur BO": "821103",
      "Upari BO": "802132",
      "Chhewari BO": "821110",
      "Kajura BO": "821110",
      "Thakura BO": "802132",
      "Dumduma BO": "802132",
      "Jaldaha BO": "821110",
      "Sahu Ka Mahua BO": "821110",
      "Orrah BO": "821101",
      "Rudrawar Kala BO": "821101",
      "Betari BO": "821101",
      "Chakedihra BO": "821102",
      "Kaser BO": "821102",
      "Kharenda BO": "821102",
      "Mudhi BO": "821103",
      "Amaon BO": "821106",
      "Badauha BO": "821106",
      "Bhorari BO": "821106",
      "Sirhira BO": "821106",
      "Sirsi BO": "821106",
      "Odar BO": "821108",
      "Pipra Sakarwar BO": "821108",
      "Piyan BO": "821108",
      "Torni Lahera BO": "821108",
      "Turki BO": "821108",
      "Ubaon B.O": "821108",
      "Akorhi BO": "821109",
      "B Khas BO": "821109",
      "Badupur BO": "821109",
      "Nateya BO": "821109",
      "Sondhi BO": "821109",
      "Sukul Pipra BO": "821109",
      "Sikandarpur BO": "821103",
      "Dumaraith BO": "821105",
      "Kabilashpur BO": "821105",
      "Manihari BO": "821105",
      "Pachilikhi BO": "821105",
      "Pipriya BO": "821105",
      "Chhotka Amaon BO": "821106",
      "Goi BO": "821106",
      "Parbatpur BO": "821106",
      "Shiorampur BO": "821106",
      "Akhtiarpur BO": "821108",
      "Fakhrabad BO": "821108",
      "Mohan Darwan BO": "821108",
      "Karamnasa BO": "821105",
      "Karari BO": "821105",
      "Kasthari BO": "821105",
      "Kuriari BO": "821105",
      "Jamalpur  Paturi BO": "821106",
      "Karji BO": "821106",
      "Kilani BO": "821106",
      "Kuddi BO": "821106",
      "Basahi BO": "821108",
      "Bhadoula BO": "821108",
      "Bisodihri BO": "821108",
      "Derwan BO": "821108",
      "Kewarhi BO": "821108",
      "Khurmabad BO": "821108",
      "Mahuwat BO": "821108",
      "Dadar BO": "821109",
      "Dangri BO": "821109",
      "Darhwa BO": "821109",
      "Katra Kala BO": "821109",
      "Khnethi BO": "821109",
      "Mujan BO": "821109",
      "Muthani BO": "821109",
      "Salathua BO": "821109",
      "Shahbajpur BO": "821109",
      "Belondi BO": "821109",
      "Harnathpur BO": "821109",
      "Kathej BO": "821109",
      "Ratwar BO": "821109",
      "Ruppur BO": "821109",
      "Bheria BO": "821105",
      "Chhata BO": "821105",
      "K Kalyanpur BO": "821105",
      "Masaurha BO": "821105",
      "Chand BO": "821106",
      "Gehwa BO": "821106",
      "Lohdan BO": "821106",
      "Saukhara BO": "821106",
      "Mahila BO": "802132",
      "Akhini BO": "802132",
      "Bagarhi BO": "802132",
      "Satowanti BO": "802132",
      "Awarainya BO": "821108",
      "Dhawpokhar BO": "821108",
      "Kathrain BO": "821108",
      "Nasej BO": "821108",
      "Padri BO": "821108",
      "Telari BO": "821108",
      "Bare BO": "821109",
      "Bhitti BO": "821109",
      "Kaithi BO": "821109",
      "Panapur BO": "821109",
      "Taraitha BO": "802132",
      "Chandesh BO": "802132",
      "Karmhari BO": "802132",
      "Panjraon BO": "802132",
      "Akhlaspur BO": "821101",
      "Khaira BO": "821101",
      "Darauli BO": "821101",
      "Noan SO": "802132",
      "Hatta SO Kaimur Bhabua": "821106",
      "Kudra Bazar SO": "821108",
      "Mohania SO": "821109",
      "Kudra SO": "821108",
      "Ramgarh SO Kaimur Bhabua": "821110",
      "Bhabua SO": "821101",
      "Chainpur SO Kaimur Bhabua": "821103",
      "Bhagwanpur SO Kaimur Bhabua": "821102",
      "Durgawati SO": "821105"
    },
    "NALANDA": {
      "Tajnipur BO": "803213",
      "Kachcharia BO": "801307",
      "Bhadru BO": "803108",
      "Dayalpur BO": "803108",
      "Gonkura BO": "803108",
      "Gunjarchak BO": "803108",
      "Kaila BO": "803107",
      "Oriyawan BO": "801301",
      "Parthu BO": "801301",
      "Pasanchi BO": "801301",
      "Puna BO": "801301",
      "Ranipur BO": "801301",
      "Barah BO": "803110",
      "Bena BO": "803110",
      "Jaitpur BO": "801307",
      "Daniawan Pendapur BO": "801301",
      "Dhangawan BO": "801301",
      "Dhurgaon BO": "801301",
      "Habbibpur BO": "801301",
      "Jagai BO": "801301",
      "Khaddi Lodipur BO": "801301",
      "Koshiyawan BO": "801301",
      "Madanpur BO": "801301",
      "Nishchalganj BO": "801301",
      "Badarbali BO": "803110",
      "Bajitpur Mudhari BO": "803110",
      "Maira Barich BO": "805105",
      "Badi BO": "805105",
      "Bahadurganj BO": "805105",
      "Bhagwanpur BO": "805105",
      "Bilari BO": "805130",
      "Bansdih BO": "801307",
      "Badhauna BO": "803108",
      "Raisa BO": "803108",
      "Tulsigarh BO": "803108",
      "Aungari BO": "801301",
      "Bali Belchi BO": "803110",
      "Basniwan BO": "803110",
      "Birju Milki BO": "803110",
      "Amraura BO": "801307",
      "Chhariari Bujurg BO": "801307",
      "Madhopur BO": "803108",
      "Rukhai BO": "803108",
      "Satnag BO": "803108",
      "Bajitpur Khiruti BO": "801301",
      "Ekangerdih BO": "801301",
      "Juniar BO": "801301",
      "Ope BO": "801301",
      "Besai Bigha BO": "801301",
      "Bakra BO": "803110",
      "Jagatpur BO": "803110",
      "Kharthua BO": "803110",
      "Murgiachak BO": "803110",
      "Sabnahua BO": "803110",
      "Babhanbarui BO": "801302",
      "Chiksoura BO": "801302",
      "Dahabigha BO": "801302",
      "Kachiyawan BO": "801302",
      "Kamta BO": "801302",
      "Kapsima BO": "801302",
      "Aatma BO": "801303",
      "Barahgawan BO": "801303",
      "Gazipur BO": "805105",
      "Katauna BO": "805130",
      "Barai BO": "801303",
      "Panchlowa BO": "801303",
      "Sanda BO": "801303",
      "Jamuawan B.O": "801301",
      "Musarhi BO": "801304",
      "Salempur BO": "801304",
      "Mirnagar B.O": "811104",
      "Ramnathpur B.O": "811104",
      "Abdachak BO": "803107",
      "Andi BO": "803107",
      "Belchi Sharif BO": "803107",
      "Hussain Pur BO": "803107",
      "Jear BO": "803107",
      "Chero BO": "803110",
      "Chhatiana BO": "803110",
      "Daily BO": "803110",
      "Lohra BO": "803110",
      "Sarthua BO": "803110",
      "Akbarpur BO": "801302",
      "Asharhi BO": "801302",
      "Keshopur BO": "801302",
      "Mirzapur BO": "801302",
      "Pyarepur B.O": "811104",
      "Narari BO": "803120",
      "Raipur Koil Bigha BO": "803120",
      "Bind BO": "803107",
      "Desna BO": "803107",
      "Jana BO": "803107",
      "Gopalbad B.O": "811104",
      "Bindidih BO": "803109",
      "Mow Bindidah BO": "803109",
      "Purani BO": "803109",
      "Railer BO": "803109",
      "Ajaypur BO": "803120",
      "Choti Chariari BO": "803120",
      "Dharampur BO": "803120",
      "Itaura BO": "803107",
      "Jamsari BO": "803107",
      "Chero B.O": "811104",
      "Husaina B.O": "811104",
      "Diha BO": "803120",
      "Pratappur BO": "803120",
      "Borhog BO": "803107",
      "Khushiyalpur BO": "801306",
      "Naima BO": "801306",
      "Narayanpur BO": "801306",
      "Salepur BO": "801306",
      "Nerut BO": "803107",
      "Paroha BO": "803107",
      "Sarbahadi BO": "803107",
      "Uttarthu BO": "803107",
      "Dosut BO": "803110",
      "Kolawan BO": "803110",
      "Nehusa BO": "803110",
      "Pachoura BO": "803110",
      "Sirsi Dihra BO": "803110",
      "Bhobhi BO": "801302",
      "Chamarbigha BO": "801302",
      "Mai BO": "801302",
      "Arjunsarthuya BO": "801303",
      "Borisarai BO": "801303",
      "Kochra BO": "801303",
      "Pathana BO": "801303",
      "Makrauta BO": "801304",
      "Damodarpur Waldha BO": "801305",
      "Mahanandpur BO": "803216",
      "Mari BO": "803111",
      "Mighi Nagma BO": "803111",
      "Kulti BO": "803107",
      "Noawan BO": "803107",
      "Palatpura BO": "803107",
      "Waiyao BO": "803107",
      "Konand BO": "803107",
      "Mafi BO": "803107",
      "Malti BO": "803107",
      "Onda BO": "803107",
      "Barakhurd BO": "803113",
      "Koklakchak BO": "803113",
      "Bangpur BO": "803114",
      "Bain BO": "803114",
      "Dahpar Sargaon BO": "803114",
      "Eksara BO": "803114",
      "Gaurav Nagar BO": "803114",
      "Soure BO": "803114",
      "NOHSA BO": "803114",
      "Barandi BO": "803119",
      "Bhandari BO": "803119",
      "Chandoura BO": "803119",
      "Goror BO": "803116",
      "Laranpur BO": "803116",
      "Molanachak BO": "803116",
      "Molanadih BO": "803116",
      "Nahub BO": "803116",
      "Baswanbigha BO": "803216",
      "Chhabilapur BO": "803216",
      "Ranabigha BO": "803216",
      "Singthu BO": "803216",
      "Tetrawan BO": "803216",
      "Tiuri BO": "803216",
      "Banarsibigha BO": "803117",
      "Bara BO": "803117",
      "Akauna B.O": "803117",
      "Mominpur BO": "801302",
      "Niriatulsipur BO": "801302",
      "Bele BO": "801303",
      "Chandhari BO": "801303",
      "Dhobdiha BO": "801303",
      "Ichhos BO": "801303",
      "Khodaganj BO": "801303",
      "Khorampur BO": "801303",
      "Bahapar BO": "801304",
      "Daniyawan BO": "801304",
      "Akair BO": "801305",
      "Bargaon BO": "803111",
      "Deepnagar BO": "803111",
      "Sabait BO": "803111",
      "Gonawan BO": "803110",
      "Gosaimath BO": "803110",
      "Narsanda BO": "803110",
      "Poari BO": "803110",
      "Sirnawan BO": "803110",
      "Bhoklapar BO": "801302",
      "Kawa BO": "801302",
      "Korawan BO": "801302",
      "Mohiddinpur BO": "801302",
      "Yogipur BO": "801302",
      "Bardih BO": "801303",
      "Beshwak BO": "801303",
      "Dariyapur BO": "801303",
      "Kobil BO": "801303",
      "Mahmuda BO": "801303",
      "Panhar BO": "801303",
      "Rasisa BO": "801303",
      "Korari BO": "801304",
      "Merhma BO": "801304",
      "Bodhibigharamghat BO": "801305",
      "Khapura BO": "801305",
      "Mahuri BO": "803111",
      "Mirchaiganj BO": "803111",
      "Sakraurah BO": "803111",
      "Andhana BO": "803113",
      "Kathrahi BO": "803107",
      "Mohammadpur BO": "803107",
      "Sare BO": "803107",
      "Mandachh BO": "801306",
      "Soniawan B.O": "801306",
      "Parasdiha BO": "801305",
      "Tinalodipur BO": "801305",
      "Dharahara BO": "803111",
      "Machhalduhe BO": "803111",
      "Nirpur BO": "803111",
      "Bheria BO": "803113",
      "Charuipar BO": "803113",
      "Ganpura BO": "803113",
      "Kathauli BO": "803113",
      "Adampur BO": "803109",
      "Gopalpur BO": "803109",
      "Khanpur BO": "803109",
      "Nanaura BO": "803113",
      "Ajanaura BO": "803114",
      "Ant BO": "803114",
      "Khaira BO": "803114",
      "Pillich BO": "803114",
      "Chorsua BO": "803115",
      "Mai Farida BO": "803119",
      "Punha BO": "803119",
      "Sosandi BO": "803119",
      "Lahuar BO": "803116",
      "Mukhtarganj BO": "803116",
      "Rajgir Kund BO": "803116",
      "Dumrawan BO": "803216",
      "Maghra BO": "803216",
      "Naisarai BO": "803216",
      "Pachauri BO": "803216",
      "Tungi BO": "803216",
      "MAHKAR BO": "803202",
      "Eksari BO": "803117",
      "Gorawan BO": "803117",
      "Barara BO": "803118",
      "Khojpura BO": "801306",
      "Nailly BO": "803113",
      "Alawan BO": "803114",
      "Gurusaranpu BO": "803114",
      "Jagdishpur Tiyari BO": "803114",
      "BHOJPUR BO": "803202",
      "CHISTIPUR BO": "803202",
      "SARHARI BO": "803202",
      "TELMAR BO": "803202",
      "Murgaon BO": "803114",
      "Durgapur BO": "803115",
      "Pyarepur BO": "803115",
      "Amba BO": "803119",
      "Itasang Bhadwa BO": "803119",
      "Peshaur BO": "803119",
      "Barnausha BO": "803116",
      "Meyar BO": "803116",
      "Nekpur BO": "803116",
      "Pathraura BO": "803116",
      "Hargawan BO": "803216",
      "Muraura BO": "803216",
      "Bhui BO": "803117",
      "Ghostawan BO": "803117",
      "Mallikpur BO": "803117",
      "Bhagan Bigha BO": "803118",
      "Musepur BO": "803118",
      "Kanhaiya Ganj BO": "801306",
      "Pariouna BO": "803113",
      "Rasalpur BO": "803114",
      "Shankardih BO": "803114",
      "Sinama BO": "803114",
      "Sonchari BO": "803114",
      "Ghorsrawan BO": "803115",
      "Nanand BO": "803115",
      "Nepura BO": "803115",
      "Pawa BO": "803115",
      "Sonsa BO": "803119",
      "Uttarnama BO": "803119",
      "Sirhari BO": "803116",
      "Sithaura BO": "803116",
      "Suhawanpur BO": "803116",
      "Veerayatan BO": "803116",
      "Daruara BO": "803216",
      "Karah BO": "803117",
      "Karjara BO": "803117",
      "Madhar BO": "803117",
      "Doiya BO": "803118",
      "Kairi Meyar BO": "803118",
      "BERTHU BO": "804451",
      "Khaje Itwar Sarai BO": "803118",
      "Moratalab BO": "803118",
      "Biharsharif HO": "803101",
      "Alinagar SO": "803101",
      "Amber SO": "803101",
      "Bhathar SO": "801307",
      "Ekangersarai SO": "801301",
      "Karaipersurai SO": "801304",
      "Nalanda College SO": "803101",
      "Nalanda SO": "803111",
      "Giriak SO": "803109",
      "Sakunat SO": "803101",
      "Silao SO": "803117",
      "Ashanagar SO": "803118",
      "Asta SO": "803120",
      "Asthawan SO": "803107",
      "Islampur SO Nalanda": "801303",
      "Mogalkuan SO": "803118",
      "Nursarai SO": "803113",
      "Rahui SO": "803119",
      "Chandi SO": "803108",
      "Harnaut SO": "803110",
      "Hilsa SO": "801302",
      "Nagarnausa SO": "801305",
      "Parwalpur SO": "803114",
      "Ramchandrapur SO": "803216",
      "Telhara SO Nalanda": "801306",
      "Katrisarai SO": "805105",
      "Sarmera S.O": "811104",
      "Ordnance Factory Rajgir SO": "803121",
      "Pawapuri SO": "803115",
      "Rajgir SO": "803116",
      "Sohsarai SO": "803118"
    },
    "SHEIKHPURA": {
      "Gilani BO": "811101",
      "Ibrahimpur BO": "811101",
      "K Milki Chak BO": "811101",
      "Kenar Kalan BO": "811101",
      "Kewti BO": "811101",
      "Kishanpur BO": "811101",
      "CR Barbigha BO": "811101",
      "Dhanuki BO": "811101",
      "Mohani BO": "811101",
      "Onama BO": "811101",
      "Ramjan Pur BO": "811101",
      "Rampur Sinday BO": "811101",
      "Samas BO": "811101",
      "Teus BO": "811101",
      "Babhanbigha BO": "811101",
      "Kajifatuchak BO": "811101",
      "Kuthaut BO": "811101",
      "Malwa BO": "811101",
      "Sarba BO": "811101",
      "Belchhi BO": "811105",
      "Amawan BO": "811101",
      "Asthana BO": "811101",
      "Belaw BO": "811101",
      "Maldah BO": "811101",
      "Maur BO": "811101",
      "Sadarpur BO": "811101",
      "Subhanpur BO": "811101",
      "Toygarh BO": "811101",
      "Gagaur BO": "811102",
      "Katari BO": "811102",
      "Chakdin BO": "811103",
      "Bhojdih BO": "811105",
      "Biman BO": "811105",
      "Brindaban BO": "811105",
      "Chorwar BO": "811105",
      "Deoley": "811105",
      "Maninda BO": "811105",
      "Masodha BO": "811105",
      "Mobarakpur BO": "811105",
      "Navinagar Kakrar BO": "811105",
      "Pain BO": "811105",
      "Bhadausi BO": "811107",
      "Kaithwan BO": "811107",
      "Pachana BO": "811107",
      "Singhaul BO": "811102",
      "Ambari BO": "811103",
      "Jean Bigha BO": "811103",
      "Panhesa BO": "811103",
      "Abgil Chandey BO": "811105",
      "Audhey BO": "811105",
      "Diha BO": "811105",
      "Kasar BO": "811105",
      "Lodipur BO": "811105",
      "Pathraitha BO": "811105",
      "SGhuskari BO": "811105",
      "Bhadous BO": "811107",
      "Dih Kushumbha BO": "811107",
      "Mafo BO": "811102",
      "Ugaban BO": "811103",
      "Hathiyama BO": "811105",
      "Hussainabad BO": "811105",
      "Kamta B.O": "811105",
      "Kare BO": "811105",
      "Kushumbha BO": "811105",
      "BBartara BO": "811107",
      "Esuwa BO": "811102",
      "Sasaur BO": "811102",
      "Charuawan BO": "811103",
      "Paharia BO": "811103",
      "Purankama BO": "811105",
      "Afni BO": "811105",
      "D Lodipur BO": "811105",
      "Gabai BO": "811105",
      "Karki BO": "811105",
      "Kusherhi BO": "811105",
      "Mandana BO": "811105",
      "Pharpar BO": "811105",
      "Pinjari BO": "811105",
      "Sanaiya BO": "811105",
      "Akarha BO": "811304",
      "Bahachha BO": "811304",
      "Lohan BO": "811304",
      "Asthama BO": "811304",
      "Chakandra BO": "811304",
      "Hassari BO": "811304",
      "Sohdi BO": "811304",
      "Chhatiara BO": "811304",
      "Chordargah BO": "811304",
      "Ekrama BO": "811304",
      "Gagri BO": "811304",
      "Karandey BO": "811304",
      "Barbigha SO": "811101",
      "Mehus SO": "811102",
      "Sheikhpura Bazar SO": "811105",
      "Sheikhpura SO Sheikhpura": "811105",
      "Chewara SO": "811304",
      "Nimi SO": "811103",
      "Sheikhpura R S SO": "811105",
      "Sirari SO": "811107"
    },
    "VAISHALI": {
      "Ishmilepur BO": "844103",
      "Izra  BO": "844103",
      "Nandlalpur BO": "844113",
      "Hargovindpur BO": "844501",
      "Chakgarho Daudnagar BO": "844503",
      "Chechar BO": "844503",
      "Dilawarpur Govardhan BO": "844503",
      "Govindpur Gokhula BO": "844503",
      "Kutubpur Saidpur BO": "844503",
      "Mathurapur Sultan BO": "844503",
      "Lakhani BO": "844502",
      "Chakamgola BO": "844504",
      "Rampur Madhaul BO": "844504",
      "Ufraul BO": "844504",
      "Bilandpur BO": "844116",
      "Bishanpur Bejha BO": "844116",
      "Fatehpur Fulwaria BO": "844116",
      "Rampur Ratnakar BO": "844116",
      "Bhuwalpur Bahadurpur BO": "844118",
      "Chakmaruf BO": "844118",
      "Dighi Kala BO": "844102",
      "Jadhua BO": "844102",
      "Murtuzapur BO": "844505",
      "Narainpur Deopura BO": "844505",
      "Pirapur BO": "844505",
      "Rasulpur Purusottam BO": "844505",
      "Bibipur BO": "844111",
      "Chandralay BO": "844103",
      "Minapur Rai BO": "844103",
      "Amritpur BO": "844113",
      "Daudnagar BO": "844113",
      "Bithauli BO": "844114",
      "Boaria BO": "844114",
      "Garjaul BO": "844114",
      "Hansikewal BO": "844114",
      "Pirapur Mathura BO": "844114",
      "Piroi BO": "844114",
      "Raghunathpur Imadpur BO": "844114",
      "Chandpura BO": "844502",
      "Dayalpur Garh BO": "844502",
      "Bishanpur Said Urf Bakarpur BO": "844115",
      "Chandpura Nankar BO": "844504",
      "Dhandhua BO": "844504",
      "Jafarpatti BO": "844504",
      "Jahangirpur Sham BO": "844504",
      "Khokhsa Bujurg BO": "844504",
      "Dharampur BO": "844111",
      "Paterha Jairam BO": "844111",
      "Sain BO": "844111",
      "Balwakuari BO": "844103",
      "Harauli BO": "844103",
      "Madhopur Ram BO": "844113",
      "Karnauti BO": "844501",
      "Sarmastpur BO": "844501",
      "Bishanpur  Bande BO": "844114",
      "Husaina Khurd BO": "844114",
      "Kiratpur Rajaram BO": "844114",
      "Rasulpur Korigaon BO": "844114",
      "Warispur BO": "844114",
      "Bishunpur Rajkhand BO": "844503",
      "Jafrabad BO": "844503",
      "Navanagar BO": "844503",
      "Bajitpur Malahi BO": "844502",
      "Balatand BO": "844502",
      "Hilalpur Madarpur BO": "844502",
      "Rahimapur BO": "844502",
      "Sahdullpur Dhabouli BO": "844502",
      "Kalyanpur BO": "844115",
      "Azampur BO": "844504",
      "Bakhari Supayan BO": "844504",
      "Bhataulia BO": "844504",
      "Lakhmipur BO": "844504",
      "Kharika  BO": "844504",
      "Pachdamia BO": "844119",
      "Maganpur BO": "844118",
      "Bhairopur Deodhi BO": "844102",
      "Panapur Dharampur BO": "844102",
      "Rajauli BO": "844102",
      "Chansarai BO": "844505",
      "Maniarpur BO": "844504",
      "Paura BO": "844117",
      "Kartahan BO": "844119",
      "Garahua BO": "844118",
      "Sondho BO": "844118",
      "Sadullahpur BO": "844102",
      "Subhai BO": "844102",
      "Arnia BO": "844505",
      "Bhathahi BO": "844505",
      "Bishanpur Bedaulia BO": "844505",
      "Hauzpura BO": "844111",
      "Karneji BO": "844111",
      "Gadaisarai BO": "844103",
      "Chaklahlad BO": "844113",
      "Madarna BO": "844113",
      "Harpur Fatikwara BO": "844501",
      "Marai BO": "844501",
      "Supaul BO": "844501",
      "Asoi BO": "844114",
      "Katarmala BO": "844114",
      "Rasulpur Enayat BO": "844114",
      "Satpura BO": "844114",
      "Bajitpur Saidat BO": "844503",
      "Khilwat BO": "844503",
      "Madhurapur BO": "844503",
      "Bahuara BO": "844502",
      "Bishanpur Titara BO": "844502",
      "Gauspur Bariarpur BO": "844115",
      "Khanpur Pakari BO": "844115",
      "Mohanpur BO": "844508",
      "Basantpur BO": "844504",
      "Kadilpur BO": "844504",
      "Mamrejpur BO": "844504",
      "Mukundpur Grahi BO": "844504",
      "Gurmia BO": "844117",
      "Bathna Mahodat BO": "844118",
      "Kheshramadih BO": "844118",
      "Malikpura BO": "844118",
      "Padmaul BO": "844118",
      "Rajasan BO": "844102",
      "Ratnakar BO": "844102",
      "Chamarhara Mamsai BO": "844505",
      "Dih Bichauli BO": "844505",
      "Kalapahar BO": "844505",
      "Loma BO": "844505",
      "Mahisaur BO": "844505",
      "Jowaj BO": "844505",
      "Mahipura BO": "844505",
      "Mansingpur Bijhrauli BO": "844505",
      "Ababakarpur BO": "844112",
      "Bhartipur BO": "843104",
      "Dubaha Buzurg BO": "843104",
      "Keshopur BO": "843104",
      "Krishnawara BO": "843104",
      "Malpur Agrail BO": "843104",
      "NChampapur BO": "843104",
      "Bherokhara BO": "844112",
      "Chapaith BO": "844112",
      "Sehan BO": "844112",
      "Dargah Bela BO": "843104",
      "Chhourahi BO": "844122",
      "Hasapur Bhadwas BO": "844122",
      "Mirza Nagar BO": "844122",
      "Naharpur BO": "844122",
      "Dhankaul BO": "843114",
      "Madhopur Nijhma BO": "844122",
      "Laxmanpur BO": "844122",
      "Madhaul BO": "844122",
      "Phular BO": "844122",
      "Kawadid BO": "843114",
      "Maudah BO": "843114",
      "Maudah Buzurg BO": "843114",
      "Pastara BO": "843114",
      "Ramouli BO": "843114",
      "Sukki BO": "843114",
      "Paharpur BO": "844508",
      "Nilkanthpur BO": "844122",
      "Rampur Ramhar BO": "844122",
      "Baligaon Chandpura BO": "843114",
      "Saidpur Dumra BO": "843114",
      "Jarang Rampur BO": "844123",
      "Sirsabiran BO": "844123",
      "Juramanpur Rampur BO": "844508",
      "Jurawanpur Karari BO": "844508",
      "Birpur  BO": "844508",
      "Panapur Langa BO": "844124",
      "Chakjamal BO": "844509",
      "Anjani BO": "844125",
      "Thathan Buzurg BO": "844125",
      "Chitrauli BO": "844126",
      "Bishanpur Arara BO": "844112",
      "Khajechand Chapra BO": "844112",
      "Alinagar Leorhan BO": "843104",
      "Dehuli Buzurg BO": "843104",
      "Raghopur Chandel BO": "844508",
      "Baikunthpur BO": "844124",
      "Sarai Dhanesh BO": "844509",
      "Belkunda BO": "844125",
      "Bhojpatti BO": "844125",
      "Birna Lakhan Sen BO": "844125",
      "Mani Bhakurahar BO": "844125",
      "Harpur Belwa BO": "844126",
      "Jahangirpur Salkhanni BO": "844126",
      "Mahathi Dharamchand BO": "844126",
      "Milki Urf  Chakwaje Khijirpur BO": "844126",
      "Pour BO": "844126",
      "Sarmaspura BO": "844126",
      "Serpur Chatwara BO": "844126",
      "Mansurpur Halaiya BO": "844112",
      "Mathna Mallik BO": "844112",
      "Khesrahi BO": "843114",
      "Simarwara Durgapur BO": "843114",
      "Abbul Hasanpur BO": "844123",
      "Jurawanpur Barari BO": "844508",
      "Saistapur BO": "844508",
      "Senduari BO": "844124",
      "Bajitpur Kasturi BO": "844509",
      "Paharpur Toi BO": "844509",
      "Akhtiyarpur Paterha BO": "844125",
      "Nari Khurd BO": "844126",
      "Rahimpur Jagdish BO": "844128",
      "Tisiuta Dharampur BO": "844126",
      "Chakramdas BO": "844128",
      "Kanhauli BO": "844122",
      "Karhatia Buzurg BO": "844122",
      "Rasalpur Fatah BO": "844122",
      "Salempur Dumaria BO": "844122",
      "Ababakarpur  Kowahi BO": "843114",
      "Majhauli BO": "844123",
      "Rikhar BO": "844123",
      "Sahtha BO": "844123",
      "Sathiauta Bhagwan BO": "844123",
      "Bishanpur BO": "844508",
      "Chaksingar BO": "844508",
      "Chandpura Idrak BO": "844508",
      "Rampur Shyamchand BO": "844508",
      "Rushtampur BO": "844508",
      "Basara BO": "844124",
      "Nainha BO": "844124",
      "Sekhopur BO": "844509",
      "Adalpur BO": "844126",
      "Chakaiya BO": "844126",
      "Gara Urf Govindpur Devi BO": "844126",
      "Sahpur BO": "844505",
      "Shoharthi BO": "844505",
      "Mandaidih BO": "843110",
      "Jalalpur BO": "844121",
      "Kazari Buzurg BO": "844507",
      "Pohiar BO": "844507",
      "Nayaganj BO": "844506",
      "Chandsarai Sahdullahchak BO": "844122",
      "Bitandipur  BO": "844505",
      "Purkhauli BO": "844121",
      "Sahdullahpur BO": "844121",
      "Gorigama BO": "844507",
      "Alipur Hatta BO": "844506",
      "Hasanpur BO": "844506",
      "Lawapur Mahnar BO": "844506",
      "Salha BO": "844505",
      "Malpur BO": "843110",
      "Marui BO": "843110",
      "Jaintipur BO": "844121",
      "Khanjahachak BO": "844121",
      "Khopi BO": "844507",
      "Parmanandpur BO": "844507",
      "Rampur Kumaharkol BO": "844507",
      "Hasanpur Gurda BO": "844506",
      "Sultanpur BO": "844506",
      "Bakhri Dua BO": "844122",
      "Chaksaid BO": "844122",
      "Chehrakala BO": "844122",
      "Ajijpur Chande BO": "843110",
      "Bardiha Turki BO": "843110",
      "Dabhaichh BO": "843110",
      "Manikpur Pakri BO": "844121",
      "Mukundpur Bhat BO": "844507",
      "Rampur Bhaghel BO": "844507",
      "Lawapur Narain BO": "844506",
      "Marauatpur BO": "844506",
      "Palwaiya BO": "844506",
      "Taibpur BO": "844506",
      "Baksama BO": "844122",
      "Bhagwatpur Taraura BO": "844122",
      "Bhanborhan BO": "844122",
      "Chakmajahid BO": "844122",
      "Hajipur HO": "844101",
      "Basudeopur Chandel SO": "844501",
      "Chaksikandar SO": "844115",
      "Desari SO": "844504",
      "Yusufpur SO": "844101",
      "Bidupur Bazar SO": "844503",
      "Bidupur Rs SO": "844502",
      "Dumari SO Vaishali": "844116",
      "Goraul SO": "844118",
      "Hajipur IndArea SO": "844102",
      "Mahnar Road Rs SO": "844507",
      "Aniruddha Belsar SO": "844111",
      "Bhagwanpur SO Vaishali": "844114",
      "Dharhara SO Vaishali": "844117",
      "Kumar Bajitpur SO": "843110",
      "Prataptand SO": "844123",
      "Rajapakar SO": "844124",
      "Sahdei Buzurg SO": "844509",
      "Sarai SO": "844125",
      "Vaishali SO": "844128",
      "Mahnar SO": "844506",
      "Patepur SO": "843114",
      "Raghopur SO": "844508",
      "Singhara SO": "844126",
      "Anzanpeer Chok SO": "844103",
      "Balukaram SO": "844113",
      "Ghataro SO": "844119",
      "Hajipur Chowk SO": "844101",
      "Jhandaha SO": "844505",
      "Lalganj Vaishali SO": "844121",
      "Mahuwa SO": "844122",
      "Rambhadra SO": "844101"
    },
    "SHEOHAR": {
      "S Sultan BO": "843334",
      "Hiramma BO": "843329",
      "Jahagirpur BO": "843329",
      "M Chhatta BO": "843329",
      "Mahuariya BO": "843329",
      "Mathurapur BO": "843329",
      "Parrahi BO": "843329",
      "Shyampur BO": "843329",
      "Tajpur BO": "843329",
      "Nayagaon BO": "843329",
      "Basantpatti BO": "843334",
      "Chakfateha BO": "843334",
      "Garahiya BO": "843334",
      "MDostiya BO": "843334",
      "Bhatahan BO": "843329",
      "Bhorahan BO": "843329",
      "Chimanpur BO": "843329",
      "Kasturia BO": "843329",
      "Phulkahan BO": "843329",
      "Belwa BO": "843334",
      "M Pokharbinda BO": "843334",
      "Mahuawa BO": "843334",
      "Fatahapur BO": "843329",
      "Harnahiya BO": "843329",
      "Kamrauli BO": "843329",
      "Khairwa Darp BO": "843329",
      "S Katsari BO": "843329",
      "Garhwa BO": "843334",
      "D Katasari BO": "843329",
      "H Dumma BO": "843329",
      "Kushahar BO": "843329",
      "M Kararia BO": "843329",
      "Pardeshiya BO": "843329",
      "Salempur BO": "843329",
      "B Jagjiwan BO": "843334",
      "B Chandiha BO": "843334",
      "Adauri BO": "843334",
      "Amua BO": "843334",
      "B Baaz BO": "843334",
      "Aura BO": "843131",
      "GDharampur BO": "843128",
      "Sarwarpur BO": "843131",
      "Sheohar SO": "843329",
      "B Jagdish SO": "843335",
      "Barahi Jagdish SO": "843335",
      "Piprarhi SO": "843334"
    },
    "NAWADA": {
      "Nazardih B.O": "805104",
      "Phuldih BO": "805106",
      "Masaurha BO": "805109",
      "Prama BO": "805109",
      "Reula BO": "805109",
      "Lond BO": "805122",
      "Meskaur BO": "805122",
      "Raja Bigha BO": "805122",
      "Baksoti BO": "805121",
      "Bhanail BO": "805121",
      "Budhwara BO": "805121",
      "Chhoti Amawa BO": "805121",
      "Pakariya B.O": "805123",
      "Budhauli BO": "805124",
      "Chandradeep BO": "805124",
      "Gulani BO": "805124",
      "Konadpur BO": "805124",
      "Marwa BO": "805124",
      "Rayes BO": "805124",
      "Simariya BO": "805124",
      "Andharwari BO": "805125",
      "Bahadurpur BO": "805125",
      "Phatehpurmore BO": "805126",
      "Sughari BO": "805126",
      "Chauby BO": "805127",
      "Ramraichack BO": "805127",
      "Dhandhar BO": "805129",
      "Khanpur BO": "805129",
      "Manjhaway BO": "805129",
      "Mosama BO": "805130",
      "Nromurar BO": "805130",
      "Paingari BO": "805130",
      "Sambey BO": "805130",
      "Dermobara BO": "805104",
      "Ghostama BO": "805104",
      "Khalsadhibari BO": "805104",
      "Marue BO": "805104",
      "D Garh Itpakwa BO": "805106",
      "Kewaii BO": "805106",
      "Kharsari BO": "805106",
      "Lalpur BO": "805106",
      "Madhurapur BO": "805106",
      "Kundabhalua BO": "805107",
      "Rupau BO": "805107",
      "Roh BO": "805107",
      "ORRO BO": "805109",
      "PACHHIYA B.O": "805109",
      "Hanriya B.O": "805109",
      "Ankari BO": "805122",
      "Biju Bigha BO": "805122",
      "Rasalpur BO": "805122",
      "Spur Gowasa BO": "805122",
      "Konibar BO": "805122",
      "Asarhi BO": "805111",
      "Gonawan BO": "805111",
      "Mahnadpur BO": "805111",
      "Pachra BO": "805111",
      "Babhnaur BO": "805111",
      "Akaunabazar BO": "805123",
      "Sonsihari BO": "805123",
      "Arha BO": "805124",
      "Derma BO": "805112",
      "Diri BO": "805112",
      "Teyar BO": "805112",
      "Targir BO": "805125",
      "B Garhrampur BO": "805126",
      "Baksanda BO": "805126",
      "S Marighgawa BO": "805127",
      "Sherpur BO": "805127",
      "Birnawan BO": "805113",
      "Chackwai BO": "805130",
      "Dariyapur BO": "805129",
      "Dergoan BO": "805113",
      "Khakhari BO": "805113",
      "Sihin BO": "805103",
      "Paura BO": "805104",
      "Sadipur BO": "805104",
      "Kadhar BO": "805106",
      "Mahapurchhab BO": "805106",
      "N Purwaritola BO": "805106",
      "Sundri Dumari BO": "805106",
      "Bhattagarh BO": "805107",
      "Mahrawan BO": "805107",
      "Siur BO": "805107",
      "Apsai BO": "805108",
      "Bajitpur BO": "805108",
      "Aranikesopur BO": "805109",
      "Kahuara BO": "805109",
      "Sarsu BO": "805109",
      "Bargaon BO": "805122",
      "G B Kendua Konihar BO": "805122",
      "Rajan BO": "805122",
      "Tetariya BO": "805102",
      "Chhatihar BO": "805111",
      "Hasapur BO": "805111",
      "Sisma BO": "805111",
      "Dumari BO": "805121",
      "Mheshdih BO": "805121",
      "Bhadokhara BO": "805123",
      "Kenasari BO": "805123",
      "Sabhari BO": "805123",
      "Frahimabad BO": "805112",
      "Makhar BO": "805112",
      "Pithauri BO": "805112",
      "Chamotha BO": "805125",
      "Singar BO": "805125",
      "Koriauna BO": "805126",
      "Kusmuhar BO": "805126",
      "Arnadi BO": "805129",
      "Bauri BO": "805113",
      "Bhatta BO": "805113",
      "Kochagoan BO": "805130",
      "Manjaur BO": "805130",
      "Subhanpur B.O": "805113",
      "Punther BO": "805103",
      "Sachaul BO": "805103",
      "Bermi BO": "805104",
      "Ohari BO": "805104",
      "Rajapur Saur BO": "805104",
      "Manjhila BO": "805106",
      "Okhariyagolab BO": "805106",
      "Shekhodaura BO": "805106",
      "Marara BO": "805107",
      "Parwati BO": "805108",
      "Dohra BO": "805109",
      "Kosla BO": "805109",
      "Seotar BO": "805109",
      "Khanwan BO": "805122",
      "Merkuri BO": "805122",
      "Lkhamohna BO": "805121",
      "Oraina BO": "805123",
      "Datraul BO": "805124",
      "Juri BO": "805124",
      "Nanaura BO": "805112",
      "Bansgopal BO": "805125",
      "Dhamani BO": "805125",
      "Kuhila BO": "805126",
      "Paharpur BO": "805126",
      "Manjhauli BO": "805127",
      "Bhadseni BO": "805129",
      "Belar BO": "805113",
      "Jalalpur BO": "805130",
      "Makanpur BO": "805130",
      "Millky BO": "805130",
      "Samharigarh BO": "805132",
      "Baijnathpur BO": "805103",
      "Chhotipali BO": "805103",
      "Dona BO": "805103",
      "Barasolapur BO": "805101",
      "Aruri BO": "805132",
      "Baghibardiha BO": "805132",
      "Kaliyachak BO": "801302",
      "Dhewdha BO": "805132",
      "Dharhara BO": "805101",
      "Bisunpur BO": "805102",
      "Barat Sarai BO": "805103",
      "Barhauna BO": "805103",
      "Chhota Jamura BO": "805103",
      "Chhotashekhpur BO": "805103",
      "Dhanar BO": "805101",
      "Dosut BO": "805132",
      "Keshauri BO": "805132",
      "Sarkanda BO": "805102",
      "Dhanwan BO": "805103",
      "Nawadha HO": "805110",
      "Dhamul SO": "805101",
      "Orhanpur SO": "805123",
      "Pakaribarwan SO": "805124",
      "Parnawada SO": "805112",
      "Bihar Keshri sri Krishn Singh SO": "805114",
      "Rajauli SO": "805125",
      "Sirdala SO": "805127",
      "Kosi SO Nawada": "805107",
      "Lalbigha SO": "805108",
      "Nardiganj SO": "805109",
      "Narhat SO": "805122",
      "Kashichak SO": "805113",
      "Dumrawan SO": "805132",
      "Govindpur SO Nawada": "805102",
      "Hasua SO": "805103",
      "Kadirganj SO": "805104",
      "Kawakol SO": "805106",
      "Nawada Kutchery SO": "805111",
      "Nemdarganj SO": "805121",
      "Rajhat SO": "805126",
      "Tungi SO": "805129",
      "Warisaliganj SO": "805130"
    },
    "ARARIA": {
      "Bathraha Ashabhag BO": "854332",
      "Pahunsi BO": "854332",
      "Bardahahat BO": "854333",
      "Bhirbhiri BO": "854333",
      "Bhojpur BO": "854333",
      "Megra Mehndipur BO": "854331",
      "Sohagmare BO": "854331",
      "Tirakhardah BO": "854331",
      "Majhuwa BO": "854318",
      "Amgachhi BO": "854332",
      "Haldharahat BO": "854331",
      "Bangama BO": "854312",
      "Hansa BO": "854312",
      "Karankia BO": "854312",
      "Baunsi BO": "854312",
      "Chandardai BO": "854312",
      "Chhatiouna BO": "854312",
      "Gidwas BO": "854312",
      "Chiknihat BO": "854331",
      "Jamua BO": "854331",
      "Balua kaliaganj BO": "854333",
      "Barmasia Simarbani BO": "854333",
      "Dehati BO": "854333",
      "Basaity BO": "854312",
      "Gunwanti BO": "854312",
      "Kamaldaha BO": "854312",
      "Mahsail BO": "854312",
      "Rajokhar BO": "854312",
      "Tamghatti BO": "854312",
      "Araria Bairgachhi BO": "854311",
      "Dabhara BO": "854311",
      "Bhatgama BO": "854202",
      "Hingua BO": "854202",
      "Bhadeshwar BO": "854316",
      "Sonapur Bazar BO": "854316",
      "Amhara BO": "854318",
      "B Rampur BO": "854318",
      "Kushmoul BO": "854318",
      "Pipra BO": "854318",
      "Mirzapur BO": "854312",
      "Mohani BO": "854312",
      "Pahsara BO": "854312",
      "Gairki BO": "854311",
      "Kakan BO": "854311",
      "Pategana BO": "854311",
      "RTMohan BO": "854311",
      "Rampur Mohanpur BO": "854311",
      "Kala Balua BO": "854201",
      "Parsa Hat BO": "854202",
      "Haldia Bokra BO": "854318",
      "Haripur Dak BO": "854318",
      "Kannaili BO": "854318",
      "Khairkhan BO": "854318",
      "Matiyari BO": "854329",
      "Musahari Idgah BO": "854318",
      "Palasi Chakardaha BO": "854318",
      "Panjarkatta BO": "854318",
      "Pothia BO": "854318",
      "Machhaila BO": "854325",
      "Maheshwari BO": "854328",
      "Jahanpur BO": "854329",
      "Kesharra BO": "854329",
      "Kursail BO": "854329",
      "Mainahat BO": "854329",
      "Pararia BO": "854333",
      "Urlaha BO": "854333",
      "Belsara BO": "854334",
      "Maujaha BO": "854334",
      "Pachira BO": "854334",
      "Sirsia Kalan BO": "854334",
      "Fatehpur BO": "854335",
      "Khagra BO": "854335",
      "Bela Basmatia BO": "854336",
      "Ghurna BO": "854336",
      "Balua Deorhi BO": "854311",
      "Bansbari BO": "854311",
      "Baturbari BO": "854311",
      "Bochi BO": "854311",
      "Dubha BO": "854311",
      "Amouna BO": "854316",
      "Bhangahi BO": "854316",
      "Bhargama BO": "854102",
      "Koshkapur BO": "854318",
      "Ramai BO": "854318",
      "Rampur BO": "854318",
      "Shankarpur BO": "854318",
      "Simarbani BO": "854318",
      "Mahalgaon BO": "854325",
      "Masuria BO": "854325",
      "PTDumaria BO": "854325",
      "Baharbari BO": "854329",
      "Parmanpur BO": "854312",
      "Dharamaganj BO": "854333",
      "Kujari BO": "854333",
      "Maldwar BO": "854333",
      "Palasi BO": "854333",
      "KBaijnathpur BO": "854334",
      "Khajurihat BO": "854334",
      "Parihari BO": "854334",
      "Raghunathpur BO": "854334",
      "Shekhapura BO": "854334",
      "Barhara BO": "854335",
      "Manikpur BO": "854336",
      "Farkia BO": "854304",
      "Bagdahara BO": "854311",
      "Chirah BO": "854311",
      "Doria Sonapur BO": "854311",
      "Gaiyari BO": "854311",
      "Haryabara BO": "854311",
      "Aurahi Hingua BO": "854318",
      "Dholbazza BO": "854318",
      "Khawashpur BO": "854318",
      "Kushmaha BO": "854318",
      "Parwaha BO": "854318",
      "Sourgaon BO": "854318",
      "Tiraskund BO": "854318",
      "Bhuna BO": "854325",
      "Chainpur BO": "854325",
      "Paiktola BO": "854325",
      "Bara Istambarar BO": "854329",
      "Chakaihat BO": "854329",
      "Pakari BO": "854329",
      "Sohandarhat BO": "854329",
      "Kankhudia BO": "854333",
      "Sikti BO": "854333",
      "Bikash Bhargama BO": "854334",
      "Dumuria Bisstaria BO": "854334",
      "Mirjapur Kothi BO": "854334",
      "Paikpar BO": "854334",
      "Bhagwa Deviganj BO": "854335",
      "Gokhlapur BO": "854335",
      "Mirdaul BO": "854335",
      "Basmatia BO": "854336",
      "Bhawanipur BO": "854336",
      "Sadhubeli BO": "854304",
      "Bagulaha BO": "854334",
      "Jagta BO": "854334",
      "Jaynagar BO": "854334",
      "Kushkapur BO": "854334",
      "Madhulata BO": "854334",
      "Mahthawabazar BO": "854334",
      "Manullah patti BO": "854334",
      "Madhura BO": "854335",
      "Nathpur BO": "854335",
      "Pithoura BO": "854335",
      "Rajganj BO": "854335",
      "Achra BO": "854336",
      "Simraha BO": "854318",
      "Tamganj BO": "854318",
      "Bagnagar BO": "854325",
      "Chokta BO": "854325",
      "Rampur Kodarkatti BO": "854325",
      "Bihari BO": "854329",
      "Dalmalpur BO": "854329",
      "Patharbari BO": "854329",
      "Tarbi BO": "854329",
      "Araria SO": "854311",
      "Kursakanta SO": "854331",
      "Madanpur SO Araria": "854333",
      "Araria RS SO": "854312",
      "Jogbani SO": "854328",
      "Kuari SO": "854332",
      "Narpatganj SO": "854335",
      "Forbesganj SO": "854318",
      "Nawabganj SO Araria": "854336",
      "SRForbesganj SO": "854318",
      "Bathnaha SO": "854316",
      "Jokihat SO": "854329",
      "Maryganj SO": "854334"
    },
    "BUXAR": {
      "Pokharahan BO": "802134",
      "Rahathua BO": "802134",
      "Asha Parari BO": "802135",
      "Tiyar BO": "802134",
      "Jogia BO": "802111",
      "Barki Nainijor BO": "802112",
      "Deokuli BO": "802112",
      "Kamarpur BO": "802102",
      "MVCollege Buxar BO": "802102",
      "Ojha Baraon BO": "802115",
      "Phaphadar BO": "802115",
      "Akhauripur Gola BO": "802114",
      "Chunni BO": "802114",
      "Gosaipur BO": "802114",
      "Rampur BO": "802127",
      "Ahirauli BO": "802116",
      "Gagaura BO": "802117",
      "Upadhyapandeypur BO": "802118",
      "Nagpur BO": "802122",
      "Rauni BO": "802122",
      "Sisrarh BO": "802122",
      "Atrauna BO": "802123",
      "Basantpur BO": "802123",
      "Khanita BO": "802123",
      "Katiknar BO": "802125",
      "Mania BO": "802125",
      "Salsala BO": "802125",
      "Amsari BO": "802126",
      "Rasen BO": "802128",
      "Atimi BO": "802129",
      "Sikraul BO": "802129",
      "Sahiyar BO": "802131",
      "Balua BO": "802130",
      "Dallupur BO": "802130",
      "Naya Bhojpur BO": "802133",
      "Parasia BO": "802111",
      "Sarenja BO": "802114",
      "Sonpa BO": "802114",
      "Arjunpur BO": "802116",
      "Sarimpur BO": "802116",
      "Indaur BO": "802117",
      "Itarhian BO": "802117",
      "Kakaria BO": "802117",
      "Baruna RS BO": "802119",
      "Ekauni BO": "802119",
      "Hariyana Cattle Farm BO": "802119",
      "Lakhandihara BO": "802119",
      "Pasahara BO": "802119",
      "Khirauli BO": "802136",
      "Mahila BO": "802123",
      "Unwas BO": "802123",
      "Chanawath BO": "802125",
      "Bhadar BO": "802126",
      "Kasia BO": "802126",
      "Khandricha BO": "802126",
      "Mathila BO": "802126",
      "Jalahara BO": "802128",
      "Jamauli BO": "802128",
      "Kajaria BO": "802128",
      "Kanehari BO": "802128",
      "Girdhar Baraon BO": "802127",
      "Dhanbakhra BO": "802129",
      "Girdharpur BO": "802129",
      "Jigna BO": "802129",
      "Karsar BO": "802129",
      "Chhilhari BO": "802133",
      "Manjhawari BO": "802133",
      "Nagwan BO": "802133",
      "Dharauli BO": "802134",
      "Ekrasi BO": "802134",
      "Nuaon BO": "802111",
      "Sowan BO": "802111",
      "Chhotkarajpur BO": "802113",
      "Kant BO": "802112",
      "Mahuar BO": "802112",
      "Boksa BO": "802103",
      "Nadaoan BO": "802103",
      "Pandeypatti BO": "802103",
      "Barka Sikraul BO": "802114",
      "Barki Kulharia BO": "802116",
      "Dalsagar BO": "802116",
      "Majharia BO": "802116",
      "Khocharia BO": "802117",
      "Nehalpur BO": "802117",
      "Nagpura BO": "802118",
      "Umarpur Diar BO": "802118",
      "Barka Singhanpura BO": "802120",
      "Kharahatand BO": "802120",
      "Ariaon BO": "802119",
      "Barki Basauli BO": "802119",
      "Nandan BO": "802119",
      "Hethua BO": "802122",
      "Bashudhar BO": "802123",
      "Waina BO": "802125",
      "Belahari BO": "802126",
      "Kanjharua BO": "802126",
      "Kopawan BO": "802126",
      "Chaubey Ke Prasia BO": "802128",
      "Manikpur BO": "802128",
      "Moharihan BO": "802128",
      "Belaon BO": "802129",
      "Bisikala BO": "802129",
      "Pararia Pramanpur BO": "802129",
      "Ekauna Dubauli BO": "802131",
      "Rajpur BO": "802131",
      "Hathilpur BO": "802130",
      "Chaukia BO": "802133",
      "Chhatnawar BO": "802133",
      "Bagen BO": "802134",
      "Bhada BO": "802134",
      "Nachap BO": "802134",
      "Diaman BO": "802111",
      "Kathar BO": "802111",
      "Keshopur BO": "802113",
      "Nainijor BO": "802112",
      "Umedpur BO": "802112",
      "Mahdah BO": "802103",
      "Sondhila BO": "802103",
      "Karhshi BO": "802102",
      "Pulia BO": "802102",
      "Banarpur BO": "802114",
      "Dehari BO": "802114",
      "Sukarwalia BO": "802114",
      "Pawani": "802114",
      "Dahiwar BO": "802116",
      "Bikaram English BO": "802117",
      "Saisar Ganghari BO": "802117",
      "Mansingh Patti Barkagaon BO": "802118",
      "Sonbarsa BO": "802125",
      "Chakki BO": "802120",
      "Rani Singhanpura BO": "802120",
      "Attaon BO": "802119",
      "Nenua BO": "802119",
      "Deoria BO": "802122",
      "Mangraon Sangraon BO": "802122",
      "Baikunthpur BO": "802123",
      "Diwan De Barka Gaon BO": "802123",
      "Kukurahan BO": "802123",
      "Sheopur  North BO": "802125",
      "Athar BO": "802126",
      "Mugaon BO": "802126",
      "Banni BO": "802128",
      "Harpur BO": "802128",
      "Khiri BO": "802128",
      "Mukhraon BO": "802128",
      "Basaon Kalan BO": "802129",
      "Bhatauli BO": "802129",
      "Rupsagar BO": "802129",
      "Gangauli BO": "802131",
      "Gaighat BO": "802130",
      "Barka Dhakaich BO": "802133",
      "Tundiganjbazar BO": "802133",
      "Baruhan BO": "802134",
      "Bhadwar Barari BO": "802134",
      "Kaithi BO": "802134",
      "Buxar HO": "802101",
      "Brahmapur Chaurasta SO": "802112",
      "Buxar Gajadhar Ganj SO": "802103",
      "Dumari SO Buxar": "802120",
      "Dumraon SO": "802119",
      "Hitawarajpur SO": "802122",
      "Koran Sarai SO": "802126",
      "Nai Bazar SO Buxar": "802101",
      "Nawanagar SO Buxar": "802129",
      "Simari SO": "802135",
      "Barkarajpur SO": "802113",
      "Brahampur SO": "802112",
      "Chaugai SO": "802115",
      "Itarhi SO": "802123",
      "Sohni Patti SO": "802101",
      "Buxar Jail SO": "802102",
      "Chausa SO Buxar": "802114",
      "Dulahpur SO": "802118",
      "Dumraon Textiles SO": "802136",
      "Kesath SO": "802125",
      "Manoharpur SO Buxar": "802128",
      "Murar SO": "802127",
      "Niazipur SO": "802131",
      "Raghunathpur SO Buxar": "802134",
      "Arak SO": "802111",
      "Churamanpur SO": "802116",
      "Dhansoi SO": "802117",
      "Nimej SO": "802130",
      "Purana Bhojpur SO": "802133"
    }
  },
  "TELANGANA": {
    "NIZAMABAD": {
      "Arsapalli B.O": "503186",
      "Camp Ootpalli B.O": "503180",
      "Eraspalli B.O": "503180",
      "JALALPUR B.O": "503201",
      "Boregaon B.O": "503230",
      "Hangarga B.O": "503207",
      "Kandagaon B.O": "503235",
      "Neela B.O": "503235",
      "Sangam B.O": "503185",
      "Hansa B.O": "503185",
      "Jadijamalpur B.O": "503185",
      "Mavandikalan B.O": "503185",
      "Bardipur B.O": "503230",
      "Mahabub Farm B.O": "503202",
      "Mangalpahad B.O": "503202",
      "Ashok Farm B.O": "503246",
      "Chikli B.O": "503246",
      "Gandhinagar B.O": "503246",
      "Jillapalli B.O": "503207",
      "Pothangal B.O": "503246",
      "Govur B.O": "503206",
      "Humnapur B.O": "503206",
      "Malkapoor B.O": "503206",
      "Lakshmikisan Farm B.O": "503245",
      "Mokanpalli B.O": "503245",
      "Pocharam B.O": "503186",
      "Old Varni B.O": "503201",
      "Jakhora B.O": "503201",
      "Pegdapalli B.O": "503235",
      "Mandarna B.O": "503185",
      "Pentakurd B.O": "503185",
      "Badsi B.O": "503230",
      "Kurnapalli B.O": "503202",
      "Kondur B.O": "503165",
      "Binola B.O": "503246",
      "Sunkini B.O": "503207",
      "Domaledgi B.O": "503207",
      "Konepalli B.O": "503245",
      "Maddepalli B.O": "503245",
      "Kandakurthi B.O": "503235",
      "ARP Camp B.O": "503235",
      "Kaldurki B.O": "503185",
      "Salampahad B.O": "503185",
      "Saloora B.O": "503185",
      "Madhavnagar B.O": "503230",
      "Mudakpalli B.O": "503230",
      "Sirpur B.O": "503230",
      "Ailapur B.O": "503246",
      "Gotmukla B.O": "503246",
      "Hegdoli B.O": "503207",
      "Abhangapatnam B.O": "503245",
      "Dupalli B.O": "503245",
      "Kosli B.O": "503245",
      "Tadbiloli B.O": "503245",
      "Amrad B.O": "503003",
      "Mubaraknagar B.O": "503003",
      "Amdapur B.O": "503180",
      "Srinagar B.O": "503201",
      "Pentakalan B.O": "503235",
      "Satapur B.O": "503235",
      "Satapurfarm B.O": "503235",
      "Khazipur B.O": "503185",
      "Raithunagar B.O": "503185",
      "Manchippa B.O": "503230",
      "Narsingpalli B.O": "503230",
      "Nyalkal B.O": "503230",
      "Jamlam B.O": "503202",
      "Thanakalan B.O": "503202",
      "Nalleshwar B.O": "503246",
      "Tungini B.O": "503246",
      "Yethonda B.O": "503207",
      "Fathenagar B.O": "503245",
      "Nagepur B.O": "503245",
      "Yamcha B.O": "503245",
      "Mendora B.O": "503219",
      "Pepri B.O": "503307",
      "Valgodkalan B.O": "503165",
      "Gadkole B.O": "503165",
      "Hanojipet B.O": "503165",
      "Doosgaon B.O": "503175",
      "Mullangi B.O": "503213",
      "Nadpalli B.O": "503175",
      "Nallapalli B.O": "503164",
      "Ansanpalli B.O": "503164",
      "Sudlam B.O": "503164",
      "Yellareddypalli B.O": "503164",
      "Uploor B.O": "503308",
      "Chotpalli B.O": "503308",
      "Mupkal B.O": "503218",
      "Vencherial B.O": "503218",
      "Andhranagar B.O": "503213",
      "Deekampalli B.O": "503213",
      "Ramchandrapalli B.O": "503213",
      "Bashirabad B.O": "503225",
      "Ramannapet B.O": "503225",
      "Chimrajpalli B.O": "503212",
      "Ummeda B.O": "503212",
      "Dattapur B.O": "503212",
      "Narkoda Jagir B.O": "503212",
      "Doodgaon B.O": "503219",
      "Dharmora B.O": "503311",
      "Lakhora B.O": "503311",
      "Chepur B.O": "503223",
      "Govindpet B.O": "503223",
      "Munpalli B.O": "503223",
      "Dichpalli B.O": "503175",
      "Kanjar B.O": "503175",
      "Keshpalli B.O": "503175",
      "Koratpalli B.O": "503175",
      "Padkal B.O": "503175",
      "Suddapalli B.O": "503175",
      "Indalwai B.O": "503164",
      "Mittapalli B.O": "503164",
      "Yergatla B.O": "503308",
      "Nagampet B.O": "503218",
      "Kalhadi B.O": "503213",
      "Donkeshwar B.O": "503212",
      "Valmikinagar B.O": "503003",
      "Ranampalli B.O": "503188",
      "Ananthagiri B.O": "503186",
      "Komanpalli B.O": "503217",
      "TEST OFFICE": "999999",
      "Vennelb B.O": "503217",
      "Chengal B.O": "503307",
      "GONGUPPAL B.O": "503307",
      "Narsapuram B.O": "503307",
      "Jagiryal B.O": "503307",
      "MENTRAJPALLI B.O": "503175",
      "MALLARAM B.O": "503003",
      "Gadepalli B.O": "503212",
      "Marampalli B.O": "503212",
      "Vannel K  B.O": "503212",
      "Motha B.O": "503311",
      "Padgal B.O": "503311",
      "Kolpak B.O": "503223",
      "Macherla B.O": "503223",
      "Magdi B.O": "503223",
      "Manthani B.O": "503223",
      "Torlikonda B.O": "503223",
      "Chimanpalli B.O": "503165",
      "Damannapet B.O": "503165",
      "Nyavanandi B.O": "503165",
      "Rautla B.O": "503165",
      "Toompalli B.O": "503165",
      "Ramadgu B.O": "503164",
      "Gummiryal B.O": "503308",
      "Hasakothur B.O": "503308",
      "Tadlarampur B.O": "503308",
      "Nallur B.O": "503218",
      "Ranjarla B.O": "503218",
      "Shetpalli B.O": "503218",
      "Vempalli B.O": "503218",
      "Gutpa B.O": "503213",
      "Waddiyat B.O": "503225",
      "Sunket B.O": "503225",
      "Noothpalli B.O": "503212",
      "Shapur B.O": "503212",
      "Savel B.O": "503219",
      "Velgatur B.O": "503219",
      "Ankapoor B.O": "503223",
      "Argul B.O": "503223",
      "MAMIDIPALLI B.O": "503003",
      "MANIKBHANDAR B.O": "503003",
      "Muchkur B.O": "503307",
      "Challagarga B.O": "503165",
      "Dubbak B.O": "503165",
      "Chakarnpalli B.O": "503175",
      "Sikkindrapur B.O": "503175",
      "Yanampalli B.O": "503175",
      "Kulaspur B.O": "503175",
      "Gannaram B.O": "503164",
      "Kamalapur B.O": "503164",
      "Sirnapalli R.S. B.O": "503164",
      "Tadpakal B.O": "503308",
      "Mukpal B.O": "503230",
      "Thimmapur B.O": "503225",
      "Palem B.O": "503225",
      "Thorath B.O": "503225",
      "Badguni B.O": "503212",
      "Khudwanpur B.O": "503212",
      "Talveda B.O": "503212",
      "Akloor B.O": "503311",
      "Donkal B.O": "503311",
      "Degaon B.O": "503223",
      "Issapalli B.O": "503223",
      "Mirdhapalli B.O": "503223",
      "Perkit B.O": "503223",
      "MALLAPUR B.O": "503164",
      "KOTHAPALLI B.O": "503246",
      "RAMPUR B.O": "503164",
      "SIRIKONDA B.O": "503165",
      "KALOOR B.O": "503003",
      "ALOOR B.O": "503223",
      "PIPRI B.O": "503223",
      "KALLUR B.O": "503207",
      "NARSAPUR B.O": "503180",
      "YELMAL B.O": "503213",
      "Raikur B.O": "503188",
      "Subriyal B.O": "503217",
      "Janakampet B.O": "503307",
      "Konasamudram B.O": "503307",
      "Boregaon ) B.O": "503003",
      "Anandnagar B.O": "503188",
      "Rudrur R.S. B.O": "503188",
      "Teglaipalli B.O": "503188",
      "Gundaram B.O": "503186",
      "Narkhoda B.O": "503307",
      "FATHEPUR B.O": "503217",
      "Bodepalli B.O": "503217",
      "Babapur B.O": "503307",
      "Pallikonda B.O": "503307",
      "Sikandrapur B.O": "503307",
      "Bejjora B.O": "503307",
      "Bhimgal Buzrug B.O": "503307",
      "CHANDUR B.O": "503206",
      "Konapur B.O": "505325",
      "MADHAPUR B.O": "503213",
      "KALIGOT B.O": "503175",
      "KHANAPUR B.O": "503223",
      "CHITTAPUR B.O": "503217",
      "BUSSAPUR B.O": "503218",
      "CHINTAKUNTA B.O": "503206",
      "VENKATAPUR B.O": "503311",
      "NAGAPURAM B.O": "503308",
      "MADANPALLI B.O": "503003",
      "KUKNOOR B.O": "503311",
      "CHANDRAYANPALLI B.O": "503164",
      "KAMALAPUR B.O": "503245",
      "ANKSAPUR B.O": "503311",
      "DOODGOAN COLONY B.O": "503219",
      "SOANPET B.O": "503219",
      "GHANPUR B.O": "503206",
      "DEVAKKAPET B.O": "503307",
      "PALDA B.O": "503246",
      "JANKAMPET B.O": "503186",
      "Armoor H.O": "503224",
      "Nizamabad H.O": "503001",
      "Edapalli S.O": "503202",
      "Mosra S.O": "503206",
      "Navipet S.O": "503245",
      "Phullong S.O": "503001",
      "Jannepalli S.O": "503246",
      "Jawahar Road S.O": "503001",
      "Rakasipet S.O": "503185",
      "Rudrur S.O": "503188",
      "Sarangapur S.O": "503186",
      "Shakkarnagar S.O": "503180",
      "Subhashnagar S.O": "503002",
      "Gajulpet S.O": "503001",
      "Kanteshwar S.O": "503002",
      "Kotagalli S.O": "503001",
      "Shivajinagar S.O": "503001",
      "Balkonda S.O": "503217",
      "Dichpalli RS S.O": "503175",
      "Nandipet S.O": "503212",
      "Telangana University S.O": "503322",
      "Vailpur S.O": "503311",
      "Zirayathnagar S.O": "503223",
      "Renjal S.O": "503235",
      "Bodhan S.O": "503185",
      "Dharmaram S.O": "503230",
      "Yellammagutta S.O": "503003",
      "Bhimgal S.O": "503307",
      "Gurbabadi S.O": "503002",
      "Kotgir S.O": "503207",
      "Mjp Nagar S.O": "503003",
      "Nizamabad RS S.O": "503003",
      "Varni S.O": "503201",
      "Kammarpalli S.O": "503308",
      "Kissannagar S.O": "503218",
      "Sriramsagar Project S.O": "503219",
      "APSP Camp S.O": "503174",
      "Bhimgal Busstand S.O": "503307",
      "Darpalli S.O": "503165",
      "Indalwai RS S.O": "503164",
      "Makloor S.O": "503213",
      "Modtad S.O": "503225"
    },
    "KAMAREDDY": {
      "Singitham B.O": "503187",
      "Mahmadpur B.O": "503101",
      "Malkapur B.O": "503125",
      "Tujlapur B.O": "503125",
      "Yadaram B.O": "503125",
      "Ugrawai B.O": "503112",
      "Yellappagonda B.O": "503112",
      "PALVANCHA B.O": "503112",
      "Polkampet B.O": "503124",
      "Pothiapalli B.O": "503124",
      "Dongli B.O": "503309",
      "Tandur B.O": "503108",
      "Hasanpalli B.O": "503302",
      "Vaddepalli B.O": "503302",
      "Thirumalapur B.O": "503187",
      "Bhagirathipalli B.O": "503101",
      "Rameshwarpalli B.O": "503101",
      "Issanagar B.O": "503125",
      "Hasgal B.O": "503306",
      "Amberipet B.O": "503123",
      "Lingupalli B.O": "503102",
      "Kyasampalli  B.O": "503112",
      "Machareddy B.O": "503112",
      "Tekriyal B.O": "503112",
      "Gundekallur B.O": "503309",
      "Mogha B.O": "503309",
      "KODCHERA B.O": "503309",
      "Chinnur B.O": "503108",
      "Pocharam B.O": "503108",
      "Shetpalli B.O": "503108",
      "Mallur B.O": "503302",
      "Kodapkal Kalan B.O": "503310",
      "Kodapkal Khurd B.O": "503310",
      "Kotaipalli B.O": "503310",
      "Thimmanagar B.O": "503310",
      "Annaramkalan B.O": "503310",
      "Gundaram B.O": "503110",
      "Kondapur B.O": "503110",
      "Kalwaral B.O": "503145",
      "Bhoompalli B.O": "503145",
      "Kupriyal B.O": "503145",
      "Endriyal B.O": "503120",
      "Kistapur B.O": "503321",
      "Kolas  B.O": "503305",
      "Shantapur B.O": "503305",
      "Ankole B.O": "503301",
      "Bomandevpalli B.O": "503301",
      "Nachapalli B.O": "503301",
      "Wajidnagar B.O": "503187",
      "Budmi B.O": "503187",
      "Galipur B.O": "503187",
      "Thippapur B.O": "503101",
      "Bhikno R.S. B.O": "503101",
      "Dhadgi B.O": "503306",
      "Faridpet B.O": "503123",
      "Sangameshwar B.O": "503123",
      "Gurjal B.O": "503114",
      "Pothangalkalan B.O": "503114",
      "Narsannapalli B.O": "503102",
      "Pondurthy B.O": "503102",
      "Anthampalli B.O": "503102",
      "Adloor B.O": "503112",
      "Chukkapur B.O": "503112",
      "Devanappli B.O": "503112",
      "Korpole B.O": "503124",
      "Perumalla B.O": "503124",
      "Shakarga B.O": "503309",
      "Tadgur B.O": "503309",
      "Manoor B.O": "503309",
      "Thimmakapalli B.O": "503110",
      "Gidda B.O": "503144",
      "Esaipet B.O": "503144",
      "Isrojiwadi B.O": "503144",
      "Somarampet B.O": "503144",
      "Kalyani B.O": "503122",
      "Rudraram B.O": "503122",
      "Godmegaon B.O": "503310",
      "Chinnamallareddy B.O": "503110",
      "Chitial B.O": "503110",
      "Moshampur B.O": "503144",
      "Padmajiwadi B.O": "503145",
      "Atmakur B.O": "503122",
      "Gundiwait B.O": "503122",
      "Yellutla B.O": "503122",
      "Kankal B.O": "503120",
      "Nandiwada B.O": "503120",
      "Nasrullabad B.O": "503321",
      "Thimmapuram B.O": "503321",
      "Edgikalan B.O": "503305",
      "Gullabuzrug B.O": "503305",
      "Wajrakhandi B.O": "503305",
      "Hangarga B.O": "503309",
      "Mailaram B.O": "503301",
      "Bhavanipet B.O": "503112",
      "Bikkanur B.O": "503122",
      "Jangamaipalli B.O": "503122",
      "Masanipet B.O": "503122",
      "Demi B.O": "503120",
      "Tadkole B.O": "503187",
      "Ibrahimpet B.O": "503187",
      "Komalancha B.O": "503187",
      "Mallareddy Kalan B.O": "503101",
      "Fathlapur B.O": "503306",
      "Neeral B.O": "503114",
      "Methusangam B.O": "503114",
      "Kamareddy Arts and Science B.O": "503112",
      "Krishnajivadi B.O": "503112",
      "Eklara B.O": "503309",
      "Lachan B.O": "503309",
      "Limbur B.O": "503309",
      "Malthummeda B.O": "503108",
      "Achampet B.O": "503302",
      "Kaslabad B.O": "503310",
      "Baswannapalli B.O": "503110",
      "Maddikunta B.O": "503144",
      "Posanipet B.O": "503144",
      "Uppalwai B.O": "503144",
      "Markal B.O": "503145",
      "Bollaram B.O": "503122",
      "Jalalpur B.O": "503122",
      "Mathumal B.O": "503122",
      "Karadpalli B.O": "503120",
      "Tadwai B.O": "503120",
      "Barangedgi B.O": "503321",
      "Dongaon B.O": "503305",
      "Khandeballur B.O": "503305",
      "Durki B.O": "503301",
      "Namli B.O": "503301",
      "Madduchervu B.O": "503187",
      "ANNARAM B.O": "503144",
      "JANGOAN B.O": "503125",
      "Borlam B.O": "503187",
      "CHILLARGI B.O": "503310",
      "Konapur B.O": "503187",
      "Mudholi B.O": "503187",
      "Rampur B.O": "503187",
      "Yellareddypalli B.O": "503110",
      "Desaipet B.O": "503187",
      "MOHAMMADNAGAR B.O": "503302",
      "HANMAJIPET B.O": "503187",
      "MOTHE B.O": "503120",
      "DAMARANCHA B.O": "503321",
      "GHANPUR B.O": "503112",
      "ANNASAGAR B.O": "503302",
      "LINGAMPALLI B.O": "503124",
      "LINGAPUR B.O": "503112",
      "GOURARAM B.O": "503187",
      "LINGAREDDY B.O": "503122",
      "UTNOOR B.O": "503145",
      "Thimmapur B.O": "503122",
      "BASWAPUR B.O": "503305",
      "KACHAPUR B.O": "503101",
      "BRAHMANPALLI B.O": "503112",
      "MACHAPUR B.O": "503122",
      "MUTHYAMPET B.O": "503123",
      "LACHAPET B.O": "503112",
      "DHARMARAOPET B.O": "503145",
      "ANCHANUR B.O": "503123",
      "GARGUL B.O": "503144",
      "SHETPALLI B.O": "503124",
      "ARGONDA B.O": "503110",
      "ADIVILINGAL B.O": "503122",
      "REDDYPET B.O": "503144",
      "BANDARANJAL B.O": "503187",
      "TALAMADLA B.O": "503102",
      "PULKAL B.O": "503306",
      "Kamareddy H.O": "503111",
      "Mirzapur S.O": "503301",
      "Banswada S.O": "503187",
      "Lingampet S.O": "503124",
      "Nizamsagar S.O": "503302",
      "Ramareddy S.O": "503144",
      "Sadasivanagar S.O": "503145",
      "Bibipet S.O": "503125",
      "Bichkunda S.O": "503306",
      "Nagireddypet S.O": "503108",
      "Birkur S.O": "503321",
      "Jukkal S.O": "503305",
      "Gandhari S.O": "503114",
      "Kamareddy RS S.O": "503112",
      "Rajampet S.O": "503110",
      "Bhiknoor S.O": "503101",
      "Domakonda S.O": "503123",
      "Jangampalli S.O": "503102",
      "Madnoor S.O": "503309",
      "Pitlam S.O": "503310",
      "Yellareddy S.O": "503122",
      "Yerrapahad S.O": "503120"
    },
    "PEDDAPALLI": {
      "Gollapalli B.O": "505186",
      "Ithrajpalle B.O": "505186",
      "Bonthakuntapalli B.O": "505186",
      "Gangaram B.O": "505153",
      "Keshanpalli B.O": "505153",
      "Moolasala B.O": "505162",
      "Regadi Maddikunta B.O": "505162",
      "Madaka B.O": "505152",
      "Gumpula B.O": "505152",
      "Odela B.O": "505152",
      "Kukkalagudur B.O": "505514",
      "Mudrial B.O": "505514",
      "Murmur B.O": "505514",
      "Dongathurthi B.O": "505187",
      "Kannal B.O": "505184",
      "Palakurthy B.O": "505187",
      "Lakkaram B.O": "505212",
      "Maidambanda B.O": "505212",
      "Kothur B.O": "505525",
      "Sivapalli B.O": "505525",
      "Venkatraopalli B.O": "505525",
      "Sundilla B.O": "505209",
      "Jangaon B.O": "505209",
      "Maredpak B.O": "505209",
      "Julapalli B.O": "505525",
      "Rangapuram B.O": "505188",
      "Parpalli B.O": "505153",
      "Kishtampet B.O": "505153",
      "Mallial B.O": "505153",
      "Motlapalli B.O": "505153",
      "Madupalli B.O": "505162",
      "Kothapalli B.O": "505162",
      "Pegadapalli B.O": "505162",
      "Komera B.O": "505152",
      "Shanagonda B.O": "505152",
      "Pandilla B.O": "505152",
      "Pothiyal B.O": "505514",
      "Bramanpalli B.O": "505514",
      "Botlavanaparthy B.O": "505187",
      "Jiyaram B.O": "505187",
      "Ragned B.O": "505187",
      "Kanagarthy B.O": "505187",
      "Kalvacherla B.O": "505212",
      "Dhulkatta B.O": "505525",
      "Muppirithota B.O": "505525",
      "Kachapur B.O": "505525",
      "Sultanpur B.O": "505525",
      "Maidpalli B.O": "505209",
      "Perepalli B.O": "505188",
      "Mirzampet B.O": "505153",
      "Tarpalli B.O": "505153",
      "Indurth B.O": "505152",
      "Isala Thakkallapalli B.O": "505187",
      "Palitham B.O": "505187",
      "Ratnapur B.O": "505212",
      "Adivarampet B.O": "505212",
      "Ladnapur B.O": "505212",
      "Wadakapur B.O": "505525",
      "Rathpalli B.O": "505153",
      "Kanagarthi B.O": "505152",
      "Goyalvada B.O": "505514",
      "Rachepalli B.O": "505187",
      "Begumpet B.O": "505212",
      "Kummarikunta B.O": "505525",
      "Telkunta B.O": "505525",
      "Elakalapalli B.O": "505188",
      "Rompikunta B.O": "505188",
      "Arinda B.O": "505184",
      "Ooraed B.O": "505184",
      "Eklaspur BO": "505184",
      "Khammapalli B.O": "505184",
      "Siripuram B.O": "505184",
      "Venkatapur B.O": "505184",
      "Rampalli B.O": "505174",
      "Appannapet B.O": "505174",
      "Kunaram B.O": "505174",
      "Turkalamaddikunta B.O": "505174",
      "Vennampalli B.O": "505174",
      "Peddampet B.O": "505208",
      "Mallialpalli B.O": "505208",
      "Thogurai B.O": "505185",
      "Munjampalle B.O": "505416",
      "Peddapur B.O": "505415",
      "Mallapur B.O": "505415",
      "Pathipaka B.O": "505415",
      "Adivisrirampur B.O": "505184",
      "Mutharam B.O": "505184",
      "Nagaram B.O": "505184",
      "Puttapaka B.O": "505184",
      "Chamanpalle B.O": "505416",
      "Katkanpalli B.O": "505416",
      "Bhojannapeta B.O": "505174",
      "Mangapeta B.O": "505174",
      "Maredgonda B.O": "505174",
      "Kundanpalli B.O": "505208",
      "Kanukula B.O": "505185",
      "Neerkula B.O": "505185",
      "Adivisomanpalli B.O": "505184",
      "Gajulapalli B.O": "505184",
      "Jallaram B.O": "505184",
      "Dharmaram B.O": "505184",
      "Gunjapadaga B.O": "505184",
      "Chinnakalwala B.O": "505174",
      "Peddabankur B.O": "505174",
      "Peddakalval B.O": "505174",
      "Guttepalli B.O": "505185",
      "Kodurpak B.O": "505185",
      "Poosala B.O": "505185",
      "Suddala B.O": "505185",
      "Bommareddypalli B.O": "505416",
      "Medaram B.O": "505416",
      "Gopalpur B.O": "505184",
      "Chandapalli B.O": "505174",
      "Nettoor B.O": "505174",
      "Raghavapur B.O": "505174",
      "Abadi Ramagundam B.O": "505208",
      "Raikaldevapalli B.O": "505185",
      "Narayanapur B.O": "505185",
      "Peddapalli H.O": "505172",
      "Kolanur S.O": "505162",
      "Pothkapalli S.O": "505152",
      "Gv8incline S.O": "505211",
      "Kamanpur S.O": "505188",
      "Ramagundam S.O": "505208",
      "Annapoorna colony S.O": "505215",
      "Anthergaon Textiles S.O": "505514",
      "Basanthnagar S.O": "505187",
      "Godavarikhani S.O": "505209",
      "Jyothinagar NTPC S.O": "505215",
      "Sultanabad S.O": "505185",
      "Vithalnagar S.O": "505214",
      "Kalvasrirampur S.O": "505153",
      "Fertilizercity S.O": "505210",
      "Peddapalli R.S S.O": "505172",
      "Scab S.O": "505209",
      "Centanary Colony S.O": "505212",
      "Elgaid S.O": "505525",
      "Manthani S.O": "505184",
      "P.P Colony S.O": "505174",
      "Dharmaram S.O": "505416",
      "Garrepalli S.O": "505186"
    },
    "KARIMNAGAR": {
      "Mukdampur B.O": "505186",
      "Mallial B.O": "505122",
      "Kanikulagidda B.O": "505498",
      "Yellabotharam B.O": "505498",
      "Sirsapalli B.O": "505498",
      "Thumenapalli B.O": "505498",
      "Bornapalli B.O": "505498",
      "Kanaparthi B.O": "505129",
      "Muttaram B.O": "505470",
      "Metpalli B.O": "505470",
      "Vegurpalli B.O": "505505",
      "Devampalli B.O": "505505",
      "Mogalipalam B.O": "505474",
      "Rekonda B.O": "505474",
      "Rachapalli B.O": "505475",
      "Vilasagar B.O": "505475",
      "Reddipalli B.O": "505502",
      "Yelbak B.O": "505502",
      "Shayampet B.O": "505122",
      "Chelpur B.O": "505122",
      "Illanthakunta B.O": "505122",
      "Erukulagudem B.O": "505498",
      "Godashal B.O": "505498",
      "Pothireddipalli B.O": "505129",
      "Kothaghat B.O": "505490",
      "Amudalapalli B.O": "505470",
      "Gaddapak B.O": "505470",
      "Pachnur B.O": "505505",
      "Ramachandrapuram B.O": "505472",
      "Ambalpur B.O": "505474",
      "Kondapalakala B.O": "505474",
      "Kandgal B.O": "505101",
      "Amangurthi B.O": "505480",
      "Vanthadupula B.O": "505475",
      "Deshaipalli B.O": "505502",
      "Ghanmukla B.O": "505502",
      "Chamanpalli B.O": "505186",
      "Madipalli B.O": "505122",
      "Sarsaid B.O": "505122",
      "Dharmaram B.O": "505122",
      "Kanagarthi B.O": "505122",
      "Pothireddipet B.O": "505498",
      "Korepalli B.O": "505129",
      "Valbhapur B.O": "505129",
      "Eklaspur B.O": "505490",
      "Rajapur B.O": "505470",
      "Laxmipuram B.O": "505505",
      "Aknoor B.O": "505472",
      "Bommanapalli B.O": "505472",
      "Gangipalli B.O": "505474",
      "Raikal B.O": "505480",
      "Bommakal B.O": "505002",
      "Bijgirsharif B.O": "505475",
      "Bijnur B.O": "505475",
      "Thanugula B.O": "505475",
      "Kondapaka B.O": "505502",
      "Narsingapur B.O": "505502",
      "Cherlabuthkur B.O": "505186",
      "Jupaka B.O": "505498",
      "Papaiahpalli B.O": "505498",
      "Rampur B.O": "505498",
      "Singapur B.O": "505498",
      "Machanpalli B.O": "505129",
      "Bedgal B.O": "505129",
      "Vennampalli B.O": "505490",
      "Kannapur B.O": "505470",
      "Kachapur B.O": "505470",
      "Challur B.O": "505505",
      "Mamidalapalli B.O": "505505",
      "Kalleda B.O": "505505",
      "Duddenapalli B.O": "505472",
      "Shivarampalli B.O": "505472",
      "Ullampalli B.O": "505472",
      "Ghanpur B.O": "505472",
      "Yaradpalli B.O": "505474",
      "Dharmarajpalli B.O": "505101",
      "Katrapalli B.O": "505480",
      "Tekurthi B.O": "505475",
      "Koorkal B.O": "505502",
      "Mylaram B.O": "505530",
      "Lingapur B.O": "505469",
      "Vidyaranyapuri BO": "505002",
      "Arnakonda B.O": "505415",
      "Ragumpet B.O": "505415",
      "Rukmapur B.O": "505415",
      "Asifnagar B.O": "505401",
      "Achampalli B.O": "505445",
      "Garshakurthy B.O": "505445",
      "Kurikyal B.O": "505445",
      "Sunderagiri B.O": "505467",
      "Vardhavelli B.O": "505502",
      "Vannaram B.O": "505451",
      "Malkapur B.O": "505451",
      "Annaram B.O": "505469",
      "Polampalli B.O": "505469",
      "Chinthakunta B.O": "505002",
      "Satavahana University Campus B.O": "505002",
      "Indurthi B.O": "505481",
      "Nallagonda B.O": "505481",
      "Katnapalli B.O": "505531",
      "Gumlapur B.O": "505531",
      "Mothe B.O": "505531",
      "Rudraram B.O": "505531",
      "Gunukula Kondapur B.O": "505530",
      "Nedunur B.O": "505530",
      "Kothapalli B.O": "505481",
      "Kolimikunta B.O": "505415",
      "Revelli B.O": "505415",
      "Vedurugatta B.O": "505415",
      "Nagulamallial B.O": "505401",
      "Gattubhuthkur B.O": "505445",
      "Chigurumamidi B.O": "505467",
      "Deshrajpalli B.O": "505451",
      "Vedira B.O": "505451",
      "Velchal B.O": "505451",
      "Algunur B.O": "505527",
      "Mannempalli B.O": "505469",
      "Arepalli B.O": "505002",
      "Mulkanur B.O": "505481",
      "Ramancha B.O": "505481",
      "Gundi B.O": "505531",
      "Gannervaram B.O": "505530",
      "Jangapalli B.O": "505530",
      "MallapurBO": "505445",
      "Mallapur B.O": "505469",
      "Durshed B.O": "505002",
      "Kamanpur B.O": "505002",
      "Sarvareddypalli B.O": "505531",
      "Shanagar B.O": "505531",
      "Chakunta B.O": "505415",
      "Chityalapalli B.O": "505415",
      "Nagunur B.O": "505415",
      "Nagireddipur B.O": "505445",
      "Venkataipalli B.O": "505445",
      "Chengerla B.O": "505469",
      "Porandla B.O": "505469",
      "Chegurthi B.O": "505002",
      "Laxmipur B.O": "505531",
      "Ryalapalli B.O": "505531",
      "Thirumalapur B.O": "505531",
      "Gopalraopet B.O": "505531",
      "Renikunta B.O": "505530",
      "Vachunur B.O": "505530",
      "Veldhi B.O": "505469",
      "Mudimanikyam B.O": "505481",
      "Nawabpet B.O": "505467",
      "Narayanpur B.O": "505445",
      "Munjampalli B.O": "505469",
      "Parlapalli B.O": "505469",
      "Bhupalapatnam B.O": "505415",
      "Thimmapur B.O": "505527",
      "Gattududdenapalli BO": "505469",
      "Upper Mallial B.O": "505445",
      "Lower Manair Dam Colony S.O": "505527",
      "Manakondur S.O": "505469",
      "Nustulapur S.O": "505481",
      "Ramnagar S.O": "505001",
      "Choppadandi S.O": "505415",
      "Collectorate Complex S.O": "505001",
      "Huzurabad H.O": "505468",
      "Elgandal S.O": "505401",
      "Gangadhara S.O": "505445",
      "Kothapalli S.O": "505451",
      "Ramadugu S.O": "505531",
      "Dist. Court Building S.O": "505001",
      "Jawaharnagar S.O": "505001",
      "Jublikaman S.O": "505001",
      "Mukharampura S.O": "505002",
      "Karimnagar H.O": "505001",
      "Keshavapatnam S.O": "505490",
      "Molangur S.O": "505470",
      "Tadikal S.O": "505474",
      "Veenavanka S.O": "505502",
      "Ootur S.O": "505505",
      "Saidapur S.O": "505472",
      "Khadeemabadi S.O": "505129",
      "Vavilala S.O": "505475",
      "Jammikunta S.O": "505122",
      "Kakatiya Cannal Campus S.O": "505498"
    },
    "MEDCHAL MALKAJGIRI": {
      "Yadgarpalli B.O": "501301",
      "Korremal B.O": "500088",
      "Pratapsingaram B.O": "500088",
      "Pochampally B.O": "500100",
      "CMR College  B.O": "501401",
      "Aliabad B.O": "500101",
      "Anantaram B.O": "500101",
      "BITS B.O": "500078",
      "Ankireddipalli B.O": "501301",
      "Thimmaipalli B.O": "501301",
      "Venkatadri B.O": "500088",
      "Dindigul B.O": "500043",
      "Srirangavaram B.O": "500043",
      "Jawahar Nagar B.O": "500087",
      "Athveli B.O": "501401",
      "Rajbolaram B.O": "501401",
      "Bomraspet B.O": "500078",
      "Jaggamguda B.O": "500101",
      "Mudchintanapalli B.O": "500101",
      "Bogaram B.O": "501301",
      "Cherlapalli B.O": "501301",
      "Edulabad B.O": "501301",
      "Keesara B.O": "501301",
      "Keesaragutta B.O": "501301",
      "Katchavanisingaram B.O": "500088",
      "Bahadurpalli B.O": "500043",
      "Gajularamaram B.O": "500055",
      "Dabirpur B.O": "501401",
      "Girmapur B.O": "501401",
      "Gowdavalli B.O": "501401",
      "Lalgadi Malakpet B.O": "500101",
      "Ankushapur B.O": "501301",
      "Cherial B.O": "501301",
      "Rampallidiara B.O": "501301",
      "Rompally B.O": "501301",
      "Bowrampet B.O": "500043",
      "Gagillapur B.O": "500043",
      "Kutbullapur B.O": "500055",
      "Doolapalli B.O": "500100",
      "Nutankal B.O": "501401",
      "Pudur B.O": "501401",
      "Ravalkol B.O": "501401",
      "Devaryamjal B.O": "500078",
      "Kolthur B.O": "500101",
      "Kyasaram B.O": "500101",
      "Peddalaxmapur B.O": "500101",
      "Uddemarri B.O": "500078",
      "Peerzadiguda B.O": "500039",
      "Ponnal B.O": "500078",
      "Thumkunta B.O": "500078",
      "Turkapalliyadaram B.O": "500101",
      "Bachupally B.O": "500090",
      "CRPF B.O": "500078",
      "Mallampet BO": "500090",
      "Fathenagar Colony S.O": "500018",
      "Bharat Nagar Colony S.O": "500018",
      "Sanathnagar I E S.O": "500018",
      "Ramanthapur": "500013",
      "I.E.Nacharam S.O": "500076",
      "Motinagar SO": "500114",
      "Snehapuri Colony S.O": "500076",
      "G.S.I (S.R) Bandlaguda S.O": "500068",
      "Hindustan Cables S.O": "500051",
      "Boduppal S.O": "500092",
      "Medipalli S.O": "500098",
      "Uppal S.O": "500039",
      "Dr As Rao Nagar S.O": "500062",
      "Nagaram S.O": "500083",
      "JJ Nagar Colony S.O": "500087",
      "Medchal S.O": "501401",
      "Nisa Hakimpet S.O": "500078",
      "Rangareddynagar S.O": "500037",
      "Shamirpet S.O": "500101",
      "Ecil S.O": "500062",
      "Samskruthi S.O": "500088",
      "Jai Jawan Colony S.O": "500103",
      "Balanagar Township S.O": "500037",
      "Hal S.O": "500042",
      "Begumpet S.O": "500016",
      "Airforce Academy S.O": "500043",
      "Kompally S.O": "500100",
      "Malkajgiri S.O": "500047",
      "Miyapur S.O": "500049",
      "Nizampet  S.O": "500090",
      "Mathrusri Nagar S.O": "500049",
      "IDA Jeedimetla S.O": "500055",
      "Jntu Kukat Pally S.O": "500085",
      "Vivekanandanagar Colony S.O": "500072",
      "Pragathinagar S.O": "500090",
      "VASANTHNAGAR SO": "500085",
      "Ghatkesar S.O": "501301",
      "Alwal S.O": "500010",
      "HMT Township S.O": "500054",
      "Kukatpally S.O": "500072",
      "Suchitra Junction S.O": "500067",
      "Vikasnagar S.O": "500093"
    },
    "VIKARABAD": {
      "Porur B.O": "501102",
      "Nagawaram B.O": "501121",
      "Rasnam B.O": "501121",
      "Morangpalli B.O": "501202",
      "Patloor B.O": "501202",
      "Sirpura B.O": "501202",
      "Tekulapalli B.O": "501202",
      "Thummalapalli B.O": "501202",
      "Velchal B.O": "501202",
      "Chanchalpet B.O": "501111",
      "Chimaldari B.O": "501111",
      "Devarampalli B.O": "501111",
      "Adikcherla B.O": "501142",
      "Gazipur B.O": "501142",
      "Chengomal B.O": "501501",
      "Peda Umenthyal B.O": "501501",
      "Peta Madaram B.O": "501501",
      "Sultanpur B.O": "501501",
      "Mubarakpur B.O": "501203",
      "Yellakonda B.O": "501203",
      "Chengole B.O": "501141",
      "Gingurthi B.O": "501141",
      "Kokat B.O": "501141",
      "Narayanpur B.O": "501141",
      "Agnoor B.O": "501144",
      "Bennur B.O": "501144",
      "Chennaram B.O": "501144",
      "Timmaipalli B.O": "501144",
      "Anantagiripally B.O": "501102",
      "Atveli B.O": "501102",
      "Sivareddypet B.O": "501102",
      "Ghatepalli B.O": "501121",
      "Karvelli B.O": "501121",
      "Kukonda B.O": "501121",
      "Kalkhoda B.O": "501106",
      "Malasomaram B.O": "501106",
      "Nagasamunder B.O": "501106",
      "Ravulapalli B.O": "501106",
      "Rompalli B.O": "501106",
      "Yenkepalle B.O": "501106",
      "Kotmarpalli B.O": "501202",
      "Mekavanampalli B.O": "501202",
      "Pulmamidi B.O": "501111",
      "Jangaon B.O": "501142",
      "Gharsinghapur B.O": "501501",
      "Kistapur B.O": "501501",
      "Somangurthi B.O": "501501",
      "Syedpalli B.O": "501501",
      "Kandanhalli B.O": "501141",
      "Pagdyal B.O": "501144",
      "Mailwar B.O": "501143",
      "Navalga B.O": "501143",
      "Yakmai B.O": "501143",
      "Ainapur B.O": "501502",
      "Wootpalli B.O": "501502",
      "Sangamkalan B.O": "501158",
      "Dhannaram B.O": "501102",
      "Girgitpalle B.O": "501102",
      "Madanapalli B.O": "501102",
      "Pulapalli B.O": "501102",
      "Ramanathgudpally B.O": "501102",
      "Haridasapalli B.O": "501121",
      "Tarigopula B.O": "501121",
      "Bantwaram B.O": "501106",
      "Barwad B.O": "501106",
      "Amradikalan B.O": "501202",
      "Buchampalli B.O": "501202",
      "Enkatala B.O": "501202",
      "Kesaram B.O": "501202",
      "Kolkonda B.O": "501202",
      "Kothlapur B.O": "501202",
      "Nagulapalli B.O": "501142",
      "Chinnagottiga B.O": "501143",
      "Damarched B.O": "501143",
      "Jeevangi B.O": "501143",
      "Karankot B.O": "501158",
      "Malkapur B.O": "501158",
      "Regondi B.O": "501142",
      "Kurviched B.O": "501143",
      "Bandelkacherla B.O": "501502",
      "Dirsampalli B.O": "501502",
      "Doma B.O": "501502",
      "Mujahidpur B.O": "501502",
      "Thattepalli B.O": "501142",
      "Turmamidi B.O": "501142",
      "Kudmoor B.O": "501501",
      "Kudvandapur B.O": "501501",
      "Manchanpalli B.O": "501501",
      "Medpalli B.O": "501501",
      "Mittakorud B.O": "501501",
      "Naskal B.O": "501501",
      "Nizampet Medpalli B.O": "501501",
      "Allapur B.O": "501141",
      "Antharam B.O": "509336",
      "Jaidupalli B.O": "501102",
      "Kadcherla B.O": "501102",
      "Kothagdi B.O": "501102",
      "Malwardevrampalli B.O": "501102",
      "Mudgul Chittempalle B.O": "501102",
      "Munnur Somaram B.O": "501102",
      "Phulmaddi B.O": "501102",
      "Gouraram B.O": "509350",
      "Kudirmalla B.O": "509350",
      "Kothur B.O": "509338",
      "Dornal B.O": "501121",
      "Mominkalan B.O": "501121",
      "Kothapalli B.O": "501106",
      "Mothukapalli B.O": "501106",
      "Ramapur B.O": "501106",
      "Salbathapur B.O": "501106",
      "Yennaram B.O": "501106",
      "Marpallikalan B.O": "501202",
      "Panchalingal B.O": "501202",
      "Arkatala B.O": "501111",
      "Chittigadda B.O": "501111",
      "Madireddipalli B.O": "501111",
      "Indur B.O": "501142",
      "Kasimpur B.O": "501143",
      "Manthangod B.O": "501143",
      "Badampalli B.O": "501502",
      "Sivareddipalli B.O": "501502",
      "Mittabaspalle B.O": "501158",
      "Mombapur B.O": "501142",
      "Chityal B.O": "501501",
      "Kankal B.O": "501501",
      "Riapol B.O": "501501",
      "Rupkhanpet B.O": "501501",
      "Gunj B.O": "501141",
      "Manthatti B.O": "501141",
      "Devnoor B.O": "501144",
      "Juntapalli B.O": "501144",
      "Ekmamidi B.O": "501102",
      "Godamguda B.O": "501102",
      "Pulusmamidi B.O": "501102",
      "Siddaloor B.O": "501102",
      "Nandigam B.O": "509350",
      "Erupmalla B.O": "509338",
      "Bomraspet B.O": "509338",
      "Balaji Nagar B.O": "509338",
      "Kusumasamudram B.O": "509335",
      "Tunkimetla B.O": "509338",
      "Wadcherla B.O": "509338",
      "Yenkipalli B.O": "509338",
      "Metlakunta B.O": "509338",
      "Parsapur B.O": "509338",
      "Regadmailwar B.O": "509338",
      "Chilmulmailwar B.O": "509338",
      "Dadapur B.O": "509339",
      "Puttapahad B.O": "509335",
      "Chellapur B.O": "509335",
      "Lakcherla B.O": "509350",
      "Chowdarpalli B.O": "509350",
      "Dudiyal B.O": "509350",
      "Neetur B.O": "509350",
      "Chitlapally B.O": "509338",
      "Buranpur B.O": "509338",
      "Eranpally B.O": "509338",
      "Gottimukkala B.O": "501102",
      "Tirmalapur B.O": "509335",
      "Komshetpally B.O": "502345",
      "Mothkur B.O": "509335",
      "Kothapally B.O": "509340",
      "Nandaram B.O": "509336",
      "Tekalkode B.O": "509336",
      "Manneguda B.O": "501102",
      "Chowdapur B.O": "509340",
      "Chandrakallu B.O": "509336",
      "Gokhafaslawar B.O": "509336",
      "Desai Pally B.O": "509336",
      "Annaram B.O": "509336",
      "Marrikal B.O": "509340",
      "Balampet B.O": "509336",
      "Angadi Raichur B.O": "509336",
      "Doultabad B.O": "509336",
      "Kasturpally B.O": "509336",
      "Devalfaslawar B.O": "509336",
      "Indanur B.O": "509336",
      "Bichal B.O": "509336",
      "Challapur B.O": "509336",
      "Rudraram B.O": "509336",
      "Husnabad S.O": "509350",
      "Kulakcherla S.O": "509335",
      "Kodangal S.O": "509338",
      "Vikarabad H.O": "501101",
      "Kotpalli S.O": "501106",
      "Purgi S.O": "501501",
      "Mominpet S.O": "501202",
      "Yalal S.O": "501144",
      "Allampalli S.O.": "501102",
      "CCI Tandur S.O": "501158",
      "Dharur S.O": "501121",
      "Nawabpet S.O": "501111",
      "Peddimal S.O": "501142",
      "Tandur S.O": "501141",
      "Basheerabad S.O": "501143",
      "Bompalli S.O": "501502",
      "Rawulapally S.O": "509336"
    },
    "RANGA REDDY": {
      "Toolkalan B.O": "501509",
      "Munaganur S.O": "501505",
      "Kanmeta B.O": "501503",
      "Kowkunta B.O": "501503",
      "Malkapur B.O": "501503",
      "Maharajpet B.O": "501203",
      "Mokila B.O": "501203",
      "Parveda B.O": "501203",
      "Singapur B.O": "501203",
      "Yelvawthy B.O": "501203",
      "Amdapur B.O": "501504",
      "Chilkur B.O": "501504",
      "Kanakamamidi B.O": "501504",
      "Tatiparthy B.O": "501509",
      "Toolkhurd B.O": "501509",
      "Damargidda B.O": "501503",
      "Nyalata B.O": "501503",
      "Pamena B.O": "501503",
      "Regadi Doswada B.O": "501501",
      "Bhulkapur B.O": "501203",
      "Kodalkal B.O": "501203",
      "Proddatur B.O": "501203",
      "Chandanvelly B.O": "501503",
      "Pedda Mangalaram B.O": "501504",
      "Venkatapur B.O": "501504",
      "Jalpally B.O": "500005",
      "Jaitwaram B.O": "500113",
      "Rachaloor B.O": "501359",
      "Kothwalguda B.O": "501218",
      "Nanajpur B.O": "501218",
      "Almasguda B.O": "500112",
      "Pedda Amberpet B.O": "501505",
      "Cherlapatelguda B.O": "501506",
      "Gummadvalli B.O": "501506",
      "Kongararaviral B.O": "501510",
      "Vinjapur B.O": "501510",
      "Manchal B.O": "501508",
      "Rangapur B.O": "501508",
      "Batasingaram B.O": "501512",
      "Torrur B.O": "501511",
      "Akulamylaram B.O": "501509",
      "Mirkhanpet B.O": "501509",
      "Gundal B.O": "501503",
      "Kandlapalli B.O": "501503",
      "Kandwada B.O": "501503",
      "Regad Ghanapur B.O": "501503",
      "Tangadpalli B.O": "501503",
      "Alur B.O": "501503",
      "Antaram B.O": "509357",
      "Kokapet B.O": "500075",
      "Narsingi B.O": "500089",
      "Mahalinhapuram  B.O": "501203",
      "Surangal B.O": "501504",
      "Balapur B.O": "500005",
      "Pahadisharif B.O": "500005",
      "Maisaram B.O": "501359",
      "Nednur B.O": "500113",
      "Pulmamdi B.O": "500113",
      "HARSHAGUDA B.O": "501359",
      "Kuntloor B.O": "501505",
      "Pasumamla B.O": "501505",
      "Eliminedu B.O": "501506",
      "Ramdaspalli B.O": "501510",
      "Seriguda B.O": "501510",
      "Arutla B.O": "501508",
      "Mailaram B.O": "501508",
      "Japal B.O": "501508",
      "Anajpur B.O": "501512",
      "Wattinagulapalli B.O": "500075",
      "Akuthotapalli B.O": "509321",
      "Kanapur B.O": "509321",
      "Chukkapur B.O": "509321",
      "Irvin B.O": "509321",
      "Burgula B.O": "509202",
      "Devuniyerravalli B.O": "501503",
      "Mudimial B.O": "501503",
      "Orella B.O": "501503",
      "Chenvelli B.O": "501503",
      "Kothapally B.O": "501203",
      "Medipalli B.O": "501509",
      "Tangutoor B.O": "501203",
      "Chinna Mangalaram B.O": "501504",
      "Kethireddipalli B.O": "501504",
      "Gudur B.O": "500113",
      "Tummaloor B.O": "501359",
      "Kismatpur B.O": "500030",
      "Nagaram B.O": "501218",
      "Narkhoda B.O": "501218",
      "Bandaraviryal B.O": "501505",
      "Qutbullahpur B.O": "501505",
      "Taramatipet B.O": "501505",
      "Aghapalli B.O": "501506",
      "Madhapur B.O": "501506",
      "Adibhatla B.O": "501510",
      "Kongarakalan B.O": "501510",
      "Turkayamjal B.O": "501510",
      "Lingampalli B.O": "501508",
      "Polkampalli B.O": "501508",
      "Koheda B.O": "501511",
      "Chintapatla B.O": "501509",
      "Mondigowrelly B.O": "501509",
      "Nazdeek Singaram B.O": "501509",
      "Gandipet B.O": "500075",
      "Janwada B.O": "500075",
      "Mancherevula B.O": "500089",
      "Madhurapuram B.O": "509202",
      "Chippalapalli B.O": "500113",
      "Dabbediguda B.O": "500113",
      "Lemur B.O": "501359",
      "Chinnagolconda B.O": "501218",
      "Gollapallikalan B.O": "501218",
      "Gaganpahad B.O": "500052",
      "Gowrelly B.O": "501505",
      "Kawadpalli B.O": "501505",
      "Gungal B.O": "501506",
      "Kappapahad B.O": "501506",
      "Pocharam B.O": "501506",
      "Timmapur B.O": "501506",
      "Mangalpalli B.O": "501510",
      "Nadergul B.O": "501510",
      "Tadlapalliguda B.O": "501508",
      "Jillellaguda B.O": "500079",
      "Chowderpalli B.O": "501509",
      "Kothapalli B.O": "501509",
      "Kurmidda B.O": "501509",
      "Manthangoud Gowrelly B.O": "501509",
      "Nallavelli B.O": "501509",
      "Nandiwanaparthi B.O": "501509",
      "Aziz Nagar B.O": "500075",
      "Himayathnagar B.O": "500075",
      "Andugula B.O": "509321",
      "Aurpalli B.O": "509321",
      "Pomalpally B.O": "509202",
      "Lohaypalli B.O": "508245",
      "Mudwin B.O": "509321",
      "Talakondapalli B.O": "509321",
      "Vittaipalli B.O": "509321",
      "Girikothapally B.O": "509321",
      "Annaram B.O": "509202",
      "Karkalpahad B.O": "509358",
      "Konapur B.O": "509358",
      "Chippanuthala B.O": "509321",
      "Cherikonda B.O": "509321",
      "Rayakal B.O": "509202",
      "Ekvaipalli B.O": "509358",
      "Mucherla B.O": "509358",
      "Thommidirekula B.O": "509408",
      "Eklaskhampet B.O": "509408",
      "Edra B.O": "509207",
      "Agriyal B.O": "509207",
      "Siddapur B.O": "509228",
      "Appareddipally B.O": "509327",
      "Julapally B.O": "509357",
      "Yelikatta B.O": "509410",
      "Reddipalem B.O": "509325",
      "Dubbacherla B.O": "509325",
      "Kammadanam B.O": "509216",
      "Nidadavelli B.O": "509408",
      "Padkal B.O": "509408",
      "Mutpoor B.O": "509207",
      "Nandigaon B.O": "509228",
      "Arkepally B.O": "509327",
      "Bramhanpally B.O": "509327",
      "Kulkulpally B.O": "509327",
      "Chowlapally B.O": "509410",
      "Pidikiryala B.O": "509410",
      "Tondapally B.O": "509325",
      "Veerlapally B.O": "509325",
      "Ameerpet B.O": "509325",
      "Papireddiguda B.O": "509216",
      "Sardarnagar B.O": "509217",
      "Tadlapalli B.O": "509217",
      "Hythabad B.O": "509217",
      "Alwala B.O": "509408",
      "Vemulanarva B.O": "509408",
      "Kothapet B.O": "509408",
      "Thangallapalli B.O": "509207",
      "Thummalapalli B.O": "509207",
      "Uttaraspalli B.O": "509207",
      "Gattuippalapally B.O": "509320",
      "Chinchode B.O": "509410",
      "Manmarri B.O": "509410",
      "Sangam B.O": "509216",
      "Veluerla  B.O": "509216",
      "Chilkamarri B.O": "509216",
      "Doskal B.O": "509216",
      "Faruqnagar B.O": "509216",
      "Kalakonda B.O": "509360",
      "Santhapuram B.O": "509408",
      "Chowlapalli B.O": "509408",
      "Kakanur B.O": "509408",
      "Ravichedu B.O": "509408",
      "Eleckicherla B.O": "509207",
      "Chowdarigudem B.O": "509207",
      "Penjerla B.O": "509228",
      "Inmulnarva B.O": "509228",
      "Nagilla B.O": "509327",
      "Chndradana B.O": "509357",
      "Rampuram B.O": "509357",
      "Yeljal B.O": "509357",
      "Srirangapur B.O": "509410",
      "Kalwakole B.O": "509325",
      "Shapur B.O": "509325",
      "Thimmapur B.O": "509325",
      "Chegur B.O": "509325",
      "Fathimapur B.O": "509325",
      "Chatanpalli B.O": "509216",
      "Nagulapalli B.O": "509216",
      "Mamidipally B.O": "509217",
      "Polepally B.O": "509360",
      "Manikonda S.O": "500089",
      "Don Bosco Nagar S.O": "500086",
      "Kattedan I.E. S.O": "500077",
      "Mankhal S.O": "501359",
      "Rajendranagar S.O": "500030",
      "Shamshabad S.O": "501218",
      "Dilsukhnagar Colony S.O": "500060",
      "Ragannaguda X Road S.O": "501510",
      "Raipole S.O": "501508",
      "Rama Krishnapuram S.O": "500102",
      "Rangareddy District Court S.O": "500074",
      "Vaishalinagar S.O": "500079",
      "Yacharam S.O": "501509",
      "I S B Campus S.O": "500111",
      "Hydershahkote S.O": "500091",
      "Himayat Sagar SO": "500091",
      "Chitrapuri Colony S.O.": "500104",
      "Hyderguda S.O": "500048",
      "Research Centre Imarat S.O": "500069",
      "Gayathrinagar S.O": "500097",
      "Hayatnagar S.O": "501505",
      "P and T Colony (Gaddiannaram) S.O": "500060",
      "Hasthinapuram S.O": "500079",
      "R.G.I. Airport S.O": "500108",
      "Chaitanyapuri Colony S.O": "500060",
      "Keshogiri S.O": "500005",
      "Lingampalli S.O": "500019",
      "C.B.I.T S.O": "500075",
      "CUC S.O": "500046",
      "Manuu S.O": "500032",
      "S.V.P.N.P.A. S.O": "500052",
      "Kandukur S.O": "500113",
      "Huda Resi. Complex S.O": "500035",
      "Ibrahimpatnam S.O": "501506",
      "Sanghinagar S.O": "501511",
      "Vaidehinagar S.O": "500070",
      "Lal Bahadurnagar S.O": "500074",
      "Meerpet S.O": "500097",
      "Ramoji Film City S.O": "501512",
      "Saradanagar S.O": "500070",
      "Saroornagar S.O": "500035",
      "Vanasthalipuram S.O": "500070",
      "Autonagar SO": "500115",
      "Chandanagar S.O": "500050",
      "Moinabad S.O": "501504",
      "Shankarpalli S.O": "501203",
      "Chevella S.O": "501503",
      "Madgul S.O": "509327",
      "Palmakole S.O": "509325",
      "Keshampet S.O": "509408",
      "Shahabad S.O": "509217",
      "Kothur S.O": "509228",
      "Mogalgidda S.O": "509410",
      "Shadnagar S.O": "509216",
      "Amangal S.O": "509321",
      "Kadthal S.O": "509358",
      "Kondurgu S.O": "509207"
    },
    "SANGAREDDY": {
      "Pulkal B.O": "502293",
      "IIT HYDERABAD SO": "502284",
      "Mannapur B.O": "502221",
      "Atmakur B.O": "502291",
      "Gopanpally B.O": "502221",
      "Ratnapur B.O": "502251",
      "Kalbemal B.O": "502249",
      "Ananthasagar B.O": "502286",
      "Bellapur B.O": "502286",
      "Kangti B.O": "502286",
      "Nagoor B.O": "502286",
      "Sanjeevaraopet B.O": "502286",
      "Shelgera B.O": "502286",
      "Wasar B.O": "502286",
      "Yenkemuri B.O": "502286",
      "Kakijanwada B.O": "502256",
      "Hasnabad B.O": "502257",
      "Singtham B.O": "502257",
      "Bagareddypally B.O": "502318",
      "Shaikapur B.O": "502318",
      "Anthargaon B.O": "502287",
      "Naganpally B.O": "502287",
      "Ryakal B.O": "502287",
      "Krishnapur B.O": "502246",
      "Maddikunta B.O": "502291",
      "Allipur B.O": "502318",
      "Lingapur B.O": "502286",
      "Ch Konapur B.O": "502295",
      "Lingampally B.O": "502345",
      "Paidigummal B.O": "502210",
      "Pothareddypally B.O": "502210",
      "Machireddypally B.O": "502210",
      "Burdipahad B.O": "502228",
      "Metalkunta B.O": "502249",
      "Chapta B.O": "502286",
      "Morgi B.O": "502286",
      "Rudrar B.O": "502286",
      "Yelgoi B.O": "502249",
      "Manur B.O": "502286",
      "Jambgi B.O": "502257",
      "Karchal B.O": "502257",
      "Algole B.O": "502318",
      "Anegunta B.O": "502318",
      "Mardi B.O": "502287",
      "Rasool B.O": "502287",
      "BASWAPUR B.O": "502293",
      "Picharagadi B.O": "502210",
      "Sajjapur B.O": "502210",
      "Bilalpur B.O": "502210",
      "Khanapur": "502210",
      "Abbenda B.O": "502286",
      "Peepalpalli B.O": "502257",
      "Gotgarpally B.O": "502318",
      "Hoti  B.O": "502318",
      "Sultanabad B.O": "502287",
      "Tadkal B.O": "502287",
      "Bibipet B.O": "502287",
      "Guntamarpally B.O": "502246",
      "Doultabad B.O": "502296",
      "Erdanur B.O": "502296",
      "Taherkhanpet B.O": "502296",
      "Nidijipla B.O": "502270",
      "Khammampally B.O": "502345",
      "Fasalwadi B.O": "502294",
      "Elmela B.O": "502300",
      "Terpole B.O": "502295",
      "Indresham B.O": "502319",
      "Mangapet B.O": "502319",
      "Indrakaran B.O": "502329",
      "Tangadpalli B.O": "502291",
      "Satwar B.O": "502221",
      "Gudpally B.O": "502221",
      "Pothulaboguda B.O": "502269",
      "RAIPALLY BO": "502269",
      "Choutkur B.O": "502273",
      "Isnapur B.O": "502307",
      "Waddi B.O": "502251",
      "Didgi B.O": "502228",
      "Mamidgi B.O": "502249",
      "Rejinthal B.O": "502249",
      "Badalgaon B.O": "502286",
      "Dawoor B.O": "502286",
      "Hanmanthraopet B.O": "502286",
      "Karamungi B.O": "502286",
      "Tornal B.O": "502286",
      "Audatpur B.O": "502286",
      "Karasgutti B.O": "502286",
      "Hulgera B.O": "502256",
      "Chalki B.O": "502256",
      "Malchalma B.O": "502318",
      "Malkapur  B.O": "502318",
      "Machnoor B.O": "502246",
      "Jeerlapally B.O": "502246",
      "KRISHNAPUR B.O": "502371",
      "Devnoor B.O": "502269",
      "Gorrekal B.O": "502269",
      "Korpole B.O": "502273",
      "Mudimanik B.O": "502273",
      "Sureddy Itikyal B.O": "502273",
      "Chitkul B.O": "502307",
      "Chidruppa B.O": "502296",
      "Chintalcheru B.O": "502296",
      "Gundlamachnoor B.O": "502296",
      "Chintakunta B.O": "502270",
      "Khadeerabad B.O": "502270",
      "Yeddumailaram B.O": "502285",
      "Cheriyal B.O": "502285",
      "Tadlapally B.O": "502294",
      "Pati Ghanpur B.O": "502300",
      "Togarpalli B.O": "502306",
      "Kanukunta B.O": "502313",
      "Nallvalli B.O": "502313",
      "Nagdhar B.O": "502371",
      "Shivanagar B.O": "502319",
      "Sultanpur B.O": "502319",
      "Madharam B.O": "509320",
      "Borancha B.O": "502290",
      "Kowlampet B.O": "502329",
      "Veltoor B.O": "502291",
      "Manthoor B.O": "502293",
      "Peddareddypet B.O": "502293",
      "Pocharam B.O": "502293",
      "Minpur B.O": "502293",
      "Panyal B.O": "502314",
      "Madgi B.O": "502221",
      "Mogudampally B.O": "502221",
      "Edulapally B.O": "502321",
      "Guruzwada B.O": "502321",
      "Chilkepally B.O": "502321",
      "Dappur B.O": "502251",
      "Mungi B.O": "502251",
      "Almaipet B.O": "502273",
      "Shivampet B.O": "502273",
      "Vendikole B.O": "502273",
      "Bhanur B.O": "502305",
      "Lakdaram B.O": "502307",
      "Sikindaspur B.O": "502296",
      "Bodupatla B.O": "502296",
      "Hathnura B.O": "502296",
      "Neredigunta B.O": "502270",
      "Posanipet B.O": "502270",
      "Makta Kyasaram B.O": "502345",
      "Mallikharjunpally B.O": "502345",
      "Kollur B.O": "502300",
      "Nandigaon B.O": "502300",
      "Kondapur B.O": "502306",
      "Masanpally B.O": "502371",
      "Gollapalli B.O": "502295",
      "Mallepalli B.O": "502295",
      "Kistareddypet B.O": "502319",
      "Peddakanjarla B.O": "502319",
      "Vailal B.O": "502319",
      "Gitam University B.O": "502329",
      "Kolkur B.O": "502291",
      "Nizampur B.O": "502291",
      "Babulgaon B.O": "502291",
      "Konyal B.O": "502314",
      "Khasimpur B.O": "502221",
      "Yedakulapalli B.O": "502321",
      "Madri B.O": "502321",
      "MunipallY B.O": "502345",
      "Tellapur B.O": "502032",
      "Venkatapur B.O": "502291",
      "Pashamailaram B.O": "502307",
      "Kasala B.O": "502296",
      "Waddepalli B.O": "502296",
      "Aksanpally B.O": "502270",
      "Marvelly B.O": "502270",
      "Ramsanpalli B.O": "502270",
      "Dakoor B.O": "502270",
      "Lonikurd B.O": "502345",
      "Tatpalli B.O": "502345",
      "Kalivemula B.O": "502285",
      "Topgonda B.O": "502285",
      "Nagulapalli B.O": "502300",
      "Pati B.O": "502300",
      "Peddapur B.O": "502306",
      "Marepalli B.O": "502306",
      "Annaram B.O": "502313",
      "Kalher B.O": "502371",
      "Bachepally B.O": "502371",
      "Malkapur B.O": "502295",
      "Jinnaram B.O": "502319",
      "Chetlapotharam B.O": "502319",
      "Ameenpur B.O": "502032",
      "Konapur B.O": "502291",
      "Suraram B.O": "502291",
      "Gonglur B.O": "502293",
      "Dhanasiri B.O": "502221",
      "Ippepally B.O": "502221",
      "Kaveli B.O": "502321",
      "Rajnelli B.O": "502321",
      "Kadpal B.O": "502287",
      "Maniyarpally B.O": "502210",
      "ANANTHASAGAR B.O": "502306",
      "Cheekurthy B.O": "502256",
      "Buchinelly B.O": "502228",
      "Pastapur B.O": "502318",
      "Chinthalghat B.O": "502321",
      "Vallur B.O": "502286",
      "Bonthapalli B.O": "502313",
      "Damarigidda B.O": "502286",
      "Ananthavaram B.O": "502345",
      "Budhera B.O": "502345",
      "Pampad B.O": "502257",
      "Pulkurthy B.O": "502286",
      "Kuppanagar B.O": "502246",
      "Vootla B.O": "502319",
      "Gummadidala B.O": "502313",
      "Sangareddy H.O": "502001",
      "Zaheerabad H.O": "502220",
      "Bharatinagar S.O": "502032",
      "Jogipet S.O": "502270",
      "Ramachandrapuram He S.O": "502032",
      "Kohir S.O": "502210",
      "Raikode S.O": "502257",
      "Sirgapur S.O": "502287",
      "A.I.E. R.C.puram S.O": "502032",
      "Admn. Bldgs S.O": "502032",
      "Aie Bollaram S.O": "502325",
      "Kandi S.O": "502285",
      "Nandikandi S.O": "502306",
      "O.F.Yeddumailaram S.O": "502205",
      "Patancheru S.O": "502319",
      "Ramachanrapuram Village S.O": "502032",
      "Rudraram S.O": "502329",
      "Digwal S.O": "502321",
      "Mirzapur S.O": "502249",
      "Narayankhed S.O": "502286",
      "Andole S.O": "502273",
      "Icrisat S.O": "502324",
      "Kamkole S.O": "502345",
      "Manjira Barrage S.O": "502294",
      "Muthangi S.O": "502300",
      "Patancheru Ie S.O": "502319",
      "Sangareddy Bs Complex S.O": "502001",
      "Singoor Project S.O": "502293",
      "Charakpally S.O": "502221",
      "Madhunagar S.O": "502228",
      "Nyalkal S.O": "502256",
      "Bdl Bhanur S.O": "502305",
      "IDA Pashamailaram S.O": "502307",
      "Ismailkhanpet S.O": "502296",
      "Mig Colony S.O": "502032",
      "Nizampet S.O": "502371",
      "P.R.Pally Chowrasta S.O": "502295",
      "Patancheru Ph.II S.O": "502319",
      "Rajampet Colony S.O": "502001",
      "Sadasivpet S.O": "502291",
      "Sangareddy Collectorate S.O": "502001",
      "Sirpura S.O": "502314",
      "Hadnur S.O": "502251",
      "Ranjhole S.O": "502318",
      "Zarasangam S.O": "502246"
    },
    "KHAMMAM": {
      "Motamarri B.O": "507204",
      "Mustikuntla B.O": "507204",
      "Buddavaram B.O": "507169",
      "Kongara B.O": "507169",
      "Jagannadhapuram B.O": "507208",
      "Komatlagudem B.O": "507122",
      "Proddutur B.O": "507208",
      "Gopalapuram B.O": "507163",
      "Buradaraghavapur B.O": "507168",
      "Gudimalla B.O": "507003",
      "Kachirajugudem B.O": "507003",
      "Theerthala B.O": "507003",
      "Venkatayapalem B.O": "507003",
      "Chirumarri B.O": "507158",
      "Guvvalagudem` B.O": "507158",
      "Mudigonda B.O": "507158",
      "Vallapuram B.O": "507158",
      "Battulapalli B.O": "507209",
      "Chennoor B.O": "507209",
      "Pedakorukondi B.O": "507209",
      "Talluri Venkatapuram B.O": "507209",
      "Telgaram B.O": "507209",
      "Kamepalli B.O": "507122",
      "Madhavaram B.O": "507122",
      "Perupalli B.O": "507122",
      "Chinnabeeravalli": "507204",
      "Rayanapeta": "507204",
      "Mangapuram B.O": "507169",
      "Rayagudem B.O": "507169",
      "Ananthasagar B.O": "507208",
      "Pandillapalli B.O": "507208",
      "Seethampeta B.O": "507208",
      "Timminenipalem B.O": "507208",
      "Tootikuntla B.O": "507208",
      "Raghunadhapalem B.O": "507161",
      "Dharedu B.O": "507003",
      "Kamalapuram B.O": "507158",
      "Kistapuram B.O": "507159",
      "Medepalli B.O": "507158",
      "Pammi B.O": "507158",
      "Chinakorukondi B.O": "507209",
      "Narayanapuram B.O": "507303",
      "Pedabeeravalli B.O": "507204",
      "Ravinoothala B.O": "507204",
      "Garlapadu": "507204",
      "Appalanarasimhapuram B.O": "507169",
      "Banapuram B.O": "507169",
      "Kattukacharam B.O": "507169",
      "Lachagudem B.O": "507208",
      "Matkepalli Namavaram B.O": "507208",
      "Nagiligonda B.O": "507208",
      "Nagulavancha B.O": "507208",
      "Nereda B.O": "507208",
      "Ballepalli B.O": "507002",
      "Kaikondaigudem B.O": "507002",
      "Khanapuram Haweli B.O": "507002",
      "Lachaguda B.O": "507168",
      "Nacharam B.O": "507168",
      "Rayamadharam B.O": "507168",
      "Thootakalingannapeta B.O": "507168",
      "UPPALA CHALAKA": "507168",
      "Kamanchikal B.O": "507003",
      "Laxmipuram B.O": "507003",
      "Mallemadugu B.O": "507003",
      "Pandregupalli B.O": "507003",
      "Relakayalapalli B.O": "507122",
      "Viswanathapalli B.O": "507122",
      "Chimmapudi B.O": "507182",
      "Irlapudi B.O": "507182",
      "Gattusingaram B.O": "507159",
      "Papatpalli B.O": "507003",
      "Seetharampuram B.O": "507123",
      "Tangampadu B.O": "507003",
      "Korlagudem B.O": "507209",
      "Mucharam B.O": "507209",
      "Muthagudem B.O": "507163",
      "Tallapenta B.O": "507209",
      "Challasamudram B.O": "507122",
      "Budidampad B.O": "507182",
      "Mallaram B.O": "507304",
      "Pedamandava B.O": "507169",
      "Vallabhi B.O": "507169",
      "Chinamandava B.O": "507208",
      "Kodumuru B.O": "507208",
      "Patharlapahad B.O": "507183",
      "Ramakrishnapuram B.O": "507208",
      "Repallewada B.O": "507208",
      "Koyachelaka B.O": "507002",
      "Tekulapalli B.O": "507209",
      "Arikayalapadu B.O": "507168",
      "Jannaram B.O": "507168",
      "Timmaraopeta B.O": "507168",
      "Gollapahad B.O": "507003",
      "Gudurpahad B.O": "507003",
      "Venkatagiri B.O": "507003",
      "Ammapeta B.O": "507158",
      "Mallannapalem B.O": "507158",
      "Venkatapuram B.O": "507201",
      "Chandrupatla B.O": "507209",
      "Peruvancha B.O": "507209",
      "Yerraboinapalli B.O": "507209",
      "Vennavalli": "507209",
      "Chimalapahad B.O": "507122",
      "Singareni B.O": "507122",
      "Tadakalapudi B.O": "507122",
      "Govindarala B.O": "507182",
      "Kothalingala B.O": "507182",
      "Keptainbanjar": "507182",
      "Muddunuru B.O": "507167",
      "Noothankal B.O": "507167",
      "Chegomma B.O": "507170",
      "Jeelacheruvu B.O": "507170",
      "Madhapuram B.O": "507170",
      "Nelapatla B.O": "507170",
      "Teldarupalli B.O": "507170",
      "Konijerla B.O": "507305",
      "Lingagudem B.O": "507302",
      "Velugumatla B.O": "507318",
      "Vepakuntla B.O": "507318",
      "Kothagudem": "507318",
      "Gubbagurthi B.O": "507165",
      "Mallepalli B.O": "507159",
      "Narasimhulagudem B.O": "507159",
      "Allinagaram B.O": "507203",
      "Illuru B.O": "507203",
      "Madupalli B.O": "507203",
      "Nidanapuram B.O": "507203",
      "Vangaveedu B.O": "507203",
      "Acharlagudem B.O": "507160",
      "Aryagudem B.O": "507160",
      "Bodualbanda B.O": "507160",
      "Ramachandrapuram B.O": "507160",
      "Motapuram B.O": "507159",
      "Mutyalagudem B.O": "507159",
      "Perikasingaram B.O": "507159",
      "Desinenipalem B.O": "507203",
      "Khammampadu B.O": "507203",
      "Maturu B.O": "507203",
      "Rayapatnam B.O": "507203",
      "Anasagaram B.O": "507160",
      "Bhairavunipalli B.O": "507160",
      "Pynampalli B.O": "507161",
      "Rajeswarapuram B.O": "507160",
      "Singareddipalem B.O": "507160",
      "Edullacheruvu B.O": "507183",
      "Ashthanagurthi B.O": "507304",
      "Kalakota B.O": "507304",
      "Hasnabad B.O": "507161",
      "Jupeda B.O": "507161",
      "PEDDATHANDA": "507003",
      "MANGALAGUDEM": "507003",
      "Gandhasiri B.O": "507158",
      "Suvarnapuram B.O": "507158",
      "Manikyaram B.O": "507122",
      "Pathalingala B.O": "507122",
      "Pinjaramadugu B.O": "507122",
      "Vootukuru B.O": "507122",
      "Giddavarigudem": "507122",
      "Maddulapalli B.O": "507170",
      "Manchigonda B.O": "507182",
      "Mucherla B.O": "507182",
      "Basithnagar": "507182",
      "Kotapadu": "507182",
      "Ramkyathanda": "507182",
      "Kurnavalli B.O": "507167",
      "Mittapalli B.O": "507167",
      "Edavalli B.O": "507170",
      "Ponnekal B.O": "507170",
      "Kondavanamala B.O": "507305",
      "Munagala B.O": "507305",
      "Arekodu B.O": "507163",
      "Edulapuram B.O": "507163",
      "Billupahad B.O": "507167",
      "Kalakodima B.O": "507167",
      "Kesavapuram B.O": "507170",
      "Kondapuram B.O": "507170",
      "Lokya Thanda B.O": "507170",
      "Ammapalem B.O": "507305",
      "Chinagopathi B.O": "507305",
      "Mallupalli": "507305",
      "Arempula B.O": "507163",
      "Kokkireni B.O": "507163",
      "Pocharam B.O": "507163",
      "Tallacheruvu B.O": "507163",
      "Allipuram B.O": "507318",
      "Gannavaram B.O": "507165",
      "Garikapadu B.O": "507165",
      "Vandanam B.O": "507318",
      "Pangidi": "507318",
      "Gollapudi B.O": "507165",
      "KESAVAPURAM": "507167",
      "Kattakuru B.O": "507170",
      "Munigepalli B.O": "507170",
      "Gopathi B.O": "507305",
      "Gopavaram B.O": "507305",
      "Tummalapalli B.O": "507305",
      "Basavapuram B.O": "507318",
      "Mallepalli Chintagurthi B.O": "507318",
      "Dammaigudem B.O": "507183",
      "Hydersaipeta B.O": "507183",
      "Chandruthanda": "507183",
      "Brahmanapalli B.O": "507304",
      "Beerole B.O": "507161",
      "Gaigollapalli B.O": "507161",
      "Kakaravai B.O": "507161",
      "Kothuru B.O": "507159",
      "Turakagudem B.O": "507159",
      "Ambarupeta B.O": "507203",
      "Atukuru B.O": "507203",
      "Chilkur B.O": "507203",
      "Mahadevapuram B.O": "507203",
      "Ammagudem B.O": "507160",
      "Tirumalapuram B.O": "507160",
      "Chowtapalli B.O": "507161",
      "Mohammadapuram B.O": "507161",
      "Medidepalli B.O": "507161",
      "Annaruguda B.O": "507167",
      "Polepalli": "507003",
      "Guravaigudem B.O": "507159",
      "Jakkepalli B.O": "507159",
      "Dendukuru B.O": "507203",
      "Jilugumadu": "507203",
      "Chennaram B.O": "507160",
      "Koratlagudem B.O": "507160",
      "Mandrajupalli B.O": "507160",
      "Mujjugudem B.O": "507160",
      "Nachepalli B.O": "507160",
      "Surdepalli B.O": "507160",
      "Bhagyathaveedu B.O": "507157",
      "Eswaramadharam B.O": "507157",
      "Jujjularaopet B.O": "507157",
      "Nayakangudem B.O": "507157",
      "Rajupeta B.O": "507157",
      "Jallepalli B.O": "507183",
      "Tetlapahad B.O": "507183",
      "Tippareddiguem B.O": "507183",
      "Paladugu B.O": "507304",
      "Repalle B.O": "507304",
      "JALIMUDI": "507304",
      "Bachodu B.O": "507161",
      "Ayyavarigudem B.O": "507202",
      "Bhimavaram B.O": "507202",
      "Allapadu B.O": "507204",
      "B Ganagaram B.O": "507303",
      "Duddepudi B.O": "507303",
      "Gandugulapalli B.O": "507303",
      "Kakarlapalli B.O": "507303",
      "Arasarlapahad B.O": "507164",
      "Kunchaparthi B.O": "507164",
      "Marlapadu B.O": "507164",
      "Racharla B.O": "507164",
      "Choppakatlapalem B.O": "507204",
      "Guntupalli Gopavaram B.O": "507202",
      "Pedagopavaram B.O": "507202",
      "Buchireddypalem": "507202",
      "Chirunomula B.O": "507204",
      "Lakshmipuram B.O": "507204",
      "Sadasivunipalem B.O": "507303",
      "Taluk Office B.O": "507303",
      "Tumburu B.O": "507303",
      "CHERUKUPALLI": "507303",
      "Usirikayalapalli B.O": "507123",
      "Mondivarri B.O": "507303",
      "Kallorgudem B.O": "507164",
      "Kandukur B.O": "507164",
      "Mamnoor B.O": "507202",
      "Kachavaram": "507202",
      "Musalimadugu B.O": "507165",
      "Narapunenipalli B.O": "507165",
      "Pallipadu B.O": "507165",
      "Tatipudi B.O": "507165",
      "Vippalamadaka B.O": "507165",
      "Dachapuram": "507165",
      "Salebanjar": "507165",
      "Lalapuram": "507165",
      "Lingannapalem": "507165",
      "Pegallapadu B.O": "507201",
      "Ramannapalem B.O": "507201",
      "Remidicherla B.O": "507201",
      "Sakinaveedu B.O": "507201",
      "Siddinenigudem B.O": "507201",
      "Bhavannapalem B.O": "507316",
      "Bayyannagudem B.O": "507302",
      "Kuppanakuntla B.O": "507302",
      "Kistaram B.O": "507303",
      "Nagupalli B.O": "507303",
      "Siddaram B.O": "507303",
      "Gangadevunipadu": "507302",
      "Bhagyanagar Thanda B.O": "507123",
      "Pinapaka B.O": "507165",
      "Punyapur B.O": "507165",
      "Rebbavaram B.O": "507165",
      "Tondalagopavaram B.O": "507201",
      "Gatlagowraram": "507201",
      "Rajulapalem": "507201",
      "Yerugatla B.O": "507302",
      "Ganeshunipadu": "507302",
      "Khanapuram B.O": "507165",
      "Siripuram Kanigiri B.O": "507165",
      "Somavaram B.O": "507165",
      "Jamalapuram B.O": "507201",
      "Meenavolu B.O": "507201",
      "Lankapalli B.O": "507302",
      "Mandalapahad B.O": "507302",
      "Uppalachelka B.O": "507302",
      "Kondrupadu": "507302",
      "Kondakodima B.O": "507165",
      "Singarayapalem B.O": "507165",
      "Snanala Laxmipuram B.O": "507165",
      "Enagali B.O": "507201",
      "Kothapalem B.O": "507201",
      "Takkellapadu B.O": "507201",
      "Yatalakunta B.O": "507316",
      "New Karaigudem B.O": "507302",
      "Pallewada B.O": "507302",
      "Khammam H.O": "507001",
      "Burhanpuram S.O": "507001",
      "Bus Station S.O": "507001",
      "Cheruvumadharam S.O": "507169",
      "Church Road S.O": "507001",
      "Gokinepalli S.O": "507158",
      "Kusumanchi S.O": "507159",
      "Subled S.O": "507161",
      "Tirumalayapalem S.O": "507163",
      "Yerrupalem S.O": "507201",
      "Banigandlapahad S.O": "507202",
      "Chintakani S.O": "507208",
      "Collectorate S.O": "507002",
      "Dabala Bazar S.O": "507003",
      "Gandhichowk S.O": "507003",
      "Guttalabazar S.O": "507003",
      "Komminepalli S.O": "507182",
      "Madhira Bazar S.O": "507203",
      "Madhira S.O": "507203",
      "Pindipolu S.O": "507183",
      "Wyra S.O": "507165",
      "Bommakal S.O": "507204",
      "Enkoor S.O": "507168",
      "Kallur S.O": "507209",
      "Nelakondapalli S.O": "507160",
      "Palair S.O": "507157",
      "Siripuram S.O": "507304",
      "Tallada S.O": "507167",
      "Tanikella S.O": "507305",
      "Trunk Road S.O": "507003",
      "Sathupalli S.O": "507303",
      "Industrial Area S.O": "507002",
      "Karepalli S.O": "507122",
      "Nsc Campus S.O": "507002",
      "Tallampahad S.O": "507170",
      "V.V.Palem S.O": "507318",
      "Y.C. Roads S.O": "507002",
      "Penuballi S.O": "507302",
      "Vemsur S.O": "507164"
    },
    "SIDDIPET": {
      "Venkatapur BO": "502114",
      "Madhuda B.O": "505472",
      "Mohammadapur B.O": "505472",
      "Dharmaram B.O": "502108",
      "Dharmareddipally B.O": "502278",
      "Kolgur B.O": "502278",
      "Singavatum B.O": "502278",
      "Gonepally B.O": "502267",
      "Tadakapally B.O": "502114",
      "Potharam B.O": "505467",
      "Thotapalli B.O": "505466",
      "Choutapalli B.O": "505466",
      "Vinjapalli B.O": "505528",
      "Gagillapur BO": "505528",
      "Kachapur B.O": "505467",
      "Gouravelli B.O": "505467",
      "Pandilla B.O": "505467",
      "Cheelapur B.O": "505473",
      "Koheda B.O": "505473",
      "Vadloorbegumpet B.O": "505530",
      "Chinchinkota B.O": "506223",
      "Dommat B.O": "502247",
      "Narsaipalli B.O": "506223",
      "Pothireddipalli B.O": "506223",
      "Ramsagar B.O": "506223",
      "Veecharani B.O": "506223",
      "Akkannapet B.O": "505466",
      "Gandipalli B.O": "505466",
      "Gugilla B.O": "505528",
      "Ramchandrapuram B.O": "505528",
      "Parveda B.O": "505467",
      "Thangallapalli B.O": "505473",
      "Vadloor B.O": "505530",
      "Varkole B.O": "505530",
      "Dilalpur B.O": "502278",
      "Venkataraopet B.O": "502278",
      "Ananthsagar B.O": "502267",
      "Ch.Ankireddipally B.O": "502267",
      "Medipally B.O": "502267",
      "Appanapally B.O": "502114",
      "Gudikandula B.O": "502114",
      "Daulapur B.O": "502281",
      "Pedda Koduru B.O": "502276",
      "Ramancha B.O": "502276",
      "Marpadaga B.O": "502372",
      "Thoguta B.O": "502372",
      "Yellareddypet B.O": "502372",
      "Mangole B.O": "502301",
      "Tipparam B.O": "502301",
      "Yerraballi B.O": "502301",
      "Ankshapur B.O": "502280",
      "Khajipur B.O": "502102",
      "Narmetta B.O": "502375",
      "Venkatapur B.O": "502375",
      "Rampur B.O": "502375",
      "Erraballi B.O": "502279",
      "Gouraram B.O": "502279",
      "Bhailampur B.O": "502279",
      "Mamidial B.O": "502279",
      "Dacharam B.O": "505528",
      "Thirumalapur B.O": "502278",
      "Bayyaram B.O": "502278",
      "Narsampally B.O": "502279",
      "Wargal B.O": "502279",
      "Sirigiripally B.O": "502311",
      "Ramaram B.O": "502278",
      "Ramasagar B.O": "502278",
      "Mandapally B.O": "502267",
      "Ramunipatla B.O": "502267",
      "Sikindlapur B.O": "502267",
      "Ghanpur B.O": "502114",
      "Thimmapur B.O": "502114",
      "Insanpally B.O": "502114",
      "Alirajpet B.O": "502281",
      "Rimmanguda B.O": "502312",
      "Watipally B.O": "502312",
      "Munigadapa B.O": "502312",
      "Sirisinagandla B.O": "502372",
      "Gatlamalyal B.O": "502280",
      "Khata B.O": "502280",
      "Mittapally B.O": "502375",
      "Rajgopalpet B.O": "502375",
      "Velkatur B.O": "502375",
      "Chebarthy B.O": "502279",
      "Markook B.O": "502279",
      "Mulugu B.O": "502279",
      "Tuniki Bollaram B.O": "502279",
      "Mirzapur B.O": "505466",
      "Ramavaram B.O": "505466",
      "Kallepalli B.O": "505528",
      "Gundaram B.O": "505528",
      "Kuchanapalli B.O": "505467",
      "Sriramulapalli B.O": "505467",
      "Baswapur B.O": "505473",
      "Regulapalli B.O": "505473",
      "Kondapur B.O": "506367",
      "Nagapuri B.O": "506223",
      "Aknoor B.O": "506223",
      "Arjunpatla B.O": "506223",
      "Gagillapur B.O": "506367",
      "Jangaon B.O": "505466",
      "Katkur B.O": "505466",
      "Keshavapur B.O": "505466",
      "Potlapalli B.O": "505467",
      "Regonda B.O": "505467",
      "Tornal B.O": "502114",
      "Dhamarakunta B.O": "502281",
      "Itikyala B.O": "502281",
      "Peerlapally B.O": "502281",
      "Timmapur B.O": "502312",
      "Gurralagondi B.O": "502276",
      "Pedda Masanipally B.O": "502372",
      "Timmareddipally B.O": "502372",
      "Teegul Narsapur B.O": "502301",
      "Vemulagattu B.O": "502301",
      "Akkenapally B.O": "502280",
      "Pothireddipet B.O": "502102",
      "Cheelasagr B.O": "502279",
      "Mylaram B.O": "502310",
      "Akkaram B.O": "502311",
      "Gundareddipalli B.O": "505473",
      "Teegul B.O": "502311",
      "Chinthamadaka B.O": "502107",
      "Gurujakunta B.O": "506223",
      "Kadaverugu B.O": "506223",
      "Bhairanpalli B.O": "506367",
      "Kootigal B.O": "506367",
      "Chityal B.O": "506355",
      "Ainapur B.O": "506355",
      "Ladnoor B.O": "506224",
      "Samudrala": "505467",
      "Jalapalli B.O": "506367",
      "Lingapur B.O": "506367",
      "Danampalli B.O": "506355",
      "Komaravalli B.O": "506355",
      "Posanpalli B.O": "506355",
      "Tadur Bo' B.O": "506355",
      "Chepial B.O": "502247",
      "Salakpur B.O": "506224",
      "Majeedpally B.O": "502334",
      "Dharmajipet B.O": "502108",
      "Raiploe B.O": "502278",
      "Kanugal B.O": "502114",
      "Gollapally B.O": "502281",
      "Varadarajapuram B.O": "502281",
      "Chandlapur B.O": "502276",
      "Lingareddipally B.O": "502276",
      "Jakkapur B.O": "502276",
      "Zapti Nacharam B.O": "502372",
      "Zapthi Lingareddypalli B.O": "502372",
      "Etigadda Kistapur B.O": "502301",
      "Chatlapally B.O": "502301",
      "Chinna Kistapur B.O": "502301",
      "Pallepahad B.O": "502301",
      "Bhumpally B.O": "502102",
      "Jangapalli B.O": "502102",
      "Baddipadaga B.O": "502375",
      "Chinna Gundavelli B.O": "502107",
      "Ibrahimpur B.O": "502107",
      "Narayanaraopet B.O": "502107",
      "Raghvapur B.O": "502107",
      "Choudaram B.O": "502310",
      "Vittalapur B.O": "502310",
      "Ande B.O": "502108",
      "Bakrichepial B.O": "502277",
      "Velikatta B.O": "502277",
      "Jaligaon B.O": "502278",
      "Rebarthy B.O": "506367",
      "Vallampatla B.O": "506367",
      "Guruvannapet B.O": "506355",
      "Marmamul B.O": "506224",
      "Bikkal B.O": "506367",
      "Dhulmitta B.O": "506367",
      "Narayanpur BO": "505481",
      "Mutrajpally B.O": "502278",
      "Gundavelly B.O": "502108",
      "Akaram B.O": "502108",
      "Rajakkapat B.O": "502108",
      "Yenagurthy B.O": "502108",
      "Ponnal B.O": "502277",
      "Bandaram B.O": "502277",
      "Pidched B.O": "502278",
      "Bejgaon B.O": "502278",
      "Nacharam B.O": "502334",
      "Lachapet B.O": "502108",
      "Mirdiddi B.O": "502108",
      "Mothe B.O": "502108",
      "Gambheerpur B.O": "502108",
      "Habsipur B.O": "502108",
      "Kaslabad B.O": "502108",
      "Ankireddipally B.O": "502277",
      "Anajipur B.O": "502278",
      "Raorukala B.O": "502107",
      "Indupial B.O": "502247",
      "Bangla Venkatapur B.O": "502334",
      "Kokonda B.O": "502336",
      "Veloor B.O": "502336",
      "Surampally B.O": "502247",
      "Waddepalli B.O": "502334",
      "Begumpet B.O": "502334",
      "Nemtur B.O": "502334",
      "Ambedkarnagar B.O": "502103",
      "Chittapur B.O": "502108",
      "Dumpalapally B.O": "502108",
      "Cheekode B.O": "502108",
      "Chellapur B.O": "502108",
      "Ramakkapet B.O": "502108",
      "Ahmedipur B.O": "502278",
      "Meenajipet B.O": "502336",
      "Tuniki B.O": "502336",
      "Alwal B.O": "502247",
      "Doulathabad B.O": "502247",
      "Rudraram BO": "502102",
      "Veerannapet B.O": "506224",
      "Mallampalli B.O": "505466",
      "Kurella B.O": "505473",
      "Shanigaram S.O": "505473",
      "Bejjanki S.O": "505528",
      "Anthakpet S.O": "505466",
      "Husnabad S.O": "505467",
      "Thotapalli S.O": "505530",
      "Siddipet H.O": "502103",
      "Mustial S.O": "506224",
      "Maddur S.O": "506367",
      "Chiryal S.O": "506223",
      "Marrimuchal S.O": "506355",
      "Allipur S.O": "502310",
      "Dubbak S.O": "502108",
      "Kodakandla S.O": "502312",
      "Kuknoorpally S.O": "502301",
      "Nangnoor S.O": "502280",
      "Duddeda S.O": "502277",
      "Irkode S.O": "502114",
      "Kodurkurd S.O": "502276",
      "Kondapak S.O": "502372",
      "Siddipet Busstand S.O": "502103",
      "Bharathnagar Town S.O": "502103",
      "Gujvail S.O": "502278",
      "Jagadevpur S.O": "502281",
      "Pamulaparthy S.O": "502279",
      "Prashanthnagar Town S.O": "502103",
      "Pregnapur S.O": "502311",
      "Ibrahimnagar S.O": "502267",
      "Nehru Road Town S.O": "502103",
      "Palamakula S.O": "502375",
      "Pullur S.O": "502107"
    },
    "WARANGAL URBAN": {
      "Kothapalli B.O": "505497",
      "Manikyapur B.O": "505497",
      "Deshrajpalli B.O": "505102",
      "Guniparthi B.O": "505102",
      "Mutharam B.O": "505471",
      "Veeranarayanpur B.O": "505476",
      "Koppur B.O": "505497",
      "Penchikalpet B.O": "505498",
      "Keshavapur B.O": "505102",
      "Buttareddy Gudem B.O": "505102",
      "Vangapalli B.O": "505102",
      "Yerrapalli B.O": "505471",
      "Kannur B.O": "505101",
      "Bhimpalli B.O": "505101",
      "Damera B.O": "505476",
      "Suraram B.O": "505476",
      "Gunded B.O": "505122",
      "Timmapur B.O": "506005",
      "Nerella B.O": "505102",
      "Shanigaram B.O": "505102",
      "Kothakonda B.O": "505471",
      "Mallaram B.O": "505471",
      "Dharmaram B.O": "505471",
      "Bavopet B.O": "505101",
      "Dandepalli B.O": "505101",
      "Valbhapur B.O": "505476",
      "Gopalpur B.O": "505476",
      "Narsingapur B.O": "505497",
      "Ratnagiri B.O": "505497",
      "Jeelugula B.O": "505498",
      "Madannapet B.O": "505102",
      "Kaniparthi B.O": "505102",
      "Ambala B.O": "505102",
      "Gudur B.O": "505102",
      "Mustafapur B.O": "505471",
      "Kannaram B.O": "505471",
      "Arepalli B.O": "506006",
      "Gorrekunta B.O": "506006",
      "Vangapahad B.O": "506006",
      "Industrial Estate B.O": "506007",
      "Kothapeta B.O": "506006",
      "Malakpalli B.O": "506003",
      "Kadipikonda B.O": "506003",
      "Aanole B.O": "506310",
      "Mamnoor B.O": "506166",
      "Shivnagar B.O": "506008",
      "Ashalapalli B.O": "506005",
      "Singaram B.O": "506005",
      "Paidipalli B.O": "506006",
      "Agricultur Research Station B.O": "506007",
      "Pragathi Industrila Estate B.O": "506002",
      "Ontimamidipalli B.O": "506310",
      "Nandanam B.O": "506313",
      "Railway Gate B.O": "506008",
      "Punnel B.O": "506310",
      "Kondaparthy B.O": "506003",
      "Narayanagiri B.O": "506142",
      "Saipet B.O": "506142",
      "Kyathampalli B.O": "506151",
      "Dharmapuram B.O": "506144",
      "Garmillapalli B.O": "506143",
      "Dharmasagar B.O": "506142",
      "Velair B.O": "506142",
      "Devannapet B.O": "506370",
      "Unikicherla B.O": "506370",
      "Kakkiralapalli B.O": "506313",
      "Bollikunta B.O": "506005",
      "Taralapalli B.O": "506003",
      "Venkatapur B.O": "506003",
      "Bhatpally B.O": "506003",
      "Shalapalli B.O": "506142",
      "Mallikudurla B.O": "506151",
      "Tatikayala B.O": "506151",
      "Mulkalagudem B.O": "506003",
      "Yelkurthy B.O": "506142",
      "Mupparam B.O": "506142",
      "Peesara B.O": "506145",
      "Janakipuram B.O": "506151",
      "Shodesha Palli B.O": "506151",
      "Pembarthy B.O": "506371",
      "Yellapur B.O": "506371",
      "Jayagiri B.O": "506371",
      "Madipalli B.O": "506371",
      "Seethampet B.O": "506371",
      "Ananthasagar B.O": "506371",
      "Bheemaram B.O": "506015",
      "Chintagattu B.O": "506015",
      "Devnoor B.O": "506371",
      "Nagaram B.O": "506371",
      "Mucherla B.O": "506015",
      "Pegadapalli B.O": "506015",
      "Tekulagudem B.O": "506003",
      "Rampur B.O": "506151",
      "Beat Bazar S.O": "506002",
      "Dharmaram S.O": "506330",
      "Karimabad S.O": "506002",
      "Kasibugga S.O": "506002",
      "Deshaipet S.O": "506006",
      "M.G.M Hospital S.O": "506002",
      "Mandi Bazar S.O": "506002",
      "Panthani S.O": "506310",
      "Rangshaipet S.O": "506005",
      "Laxmipur  S.O": "506013",
      "Mamnoor S.O": "506166",
      "Svn Road S.O": "506002",
      "K.M.College S.O": "506007",
      "Mahathma Gandhi Road S.O": "506002",
      "Matwada S.O": "506002",
      "Fort Warangal S.O.": "506008",
      "Warangal H.O": "506002",
      "Hanamkonda H.O": "506001",
      "K C Colony S.O": "506015",
      "Peddapendyal S.O": "506151",
      "R E College S.O": "506004",
      "Waddepalli S.O": "506370",
      "Kazipet S.O": "506003",
      "Madikonda S.O": "506142",
      "Reddicolony S.O": "506011",
      "Subedari S.O": "506001",
      "D H Suthoon S.O": "506011",
      "Fatimanagar S.O": "506004",
      "Lashkar Bazar S.O": "506001",
      "Bapujinagar S.O": "506003",
      "Hasanparthy S.O": "506371",
      "Naimnagar S.O": "506009",
      "Vidyaranyapuri S.O": "506009",
      "Kamalapur S.O": "505102",
      "Mulkunur S.O": "505471",
      "Uppal S.O": "505101",
      "Yelkathurthi S.O": "505476",
      "Vangara S.O": "505480",
      "Bheemdevarpalli S.O": "505497"
    },
    "MANCHERIAL": {
      "Arepally B.O": "504204",
      "Nasirabad B.O": "504204",
      "Alegaon B.O": "504201",
      "Kollur B.O": "504201",
      "Parpalli B.O": "504201",
      "Somanpalli B.O": "504201",
      "Devulawada B.O": "504201",
      "Singapur B.O": "504302",
      "Venkatapur B.O": "504219",
      "Tadlapet B.O": "504206",
      "Jandavenkatapur B.O": "504207",
      "Raipally B.O": "504207",
      "Mittapalli Jagir B.O": "504216",
      "Pownur B.O": "504216",
      "Indaram B.O": "504216",
      "Kundaram B.O": "504216",
      "Dharmaram B.O": "504205",
      "Kawal B.O": "504205",
      "Mandamarri B.O": "504231",
      "Nandarampalli B.O": "504214",
      "Neelwai B.O": "504214",
      "Dowdepelli B.O": "504215",
      "Korvichelma B.O": "504215",
      "Rebenapalli B.O": "504215",
      "Mulkala B.O": "504209",
      "Kushnepalli B.O": "504219",
      "Mailaram B.O": "504219",
      "Kistampet B.O": "504204",
      "Angarajpalli B.O": "504201",
      "Asnad B.O": "504201",
      "Dugunapalli B.O": "504201",
      "Sirsa B.O": "504201",
      "Naspur B.O": "504302",
      "Peddapet B.O": "504206",
      "Dwaraka B.O": "504206",
      "Mamidipalli B.O": "504206",
      "Laxmipur B.O": "504207",
      "Peddampet B.O": "504207",
      "Hazipur B.O": "504207",
      "Kistapur B.O": "504205",
      "Pegdapally B.O": "504216",
      "Shetpally B.O": "504216",
      "Wellal B.O": "504216",
      "Ponkal B.O": "504205",
      "Indanpalli B.O": "504205",
      "Kalmadgu B.O": "504205",
      "Andugulapet B.O": "504231",
      "Dharmaraopet B.O": "504231",
      "Kasipet B.O": "504231",
      "Jangaon B.O": "504214",
      "Itikyal B.O": "504215",
      "Modela B.O": "504215",
      "Velganoor B.O": "504215",
      "Rebbena B.O": "504219",
      "Mamidigattu B.O": "504204",
      "Suddala B.O": "504204",
      "Kommera B.O": "504201",
      "Nagapur B.O": "504201",
      "Ponnaram B.O": "504216",
      "Tekumatla B.O": "504216",
      "Kyatanpalli B.O": "504214",
      "Mallampet B.O": "504214",
      "Vemanpalli B.O": "504214",
      "Mulkalpet B.O": "504214",
      "Gadapur B.O": "504209",
      "Timmapur B.O": "504209",
      "Patha Mancherial B.O": "504209",
      "Annaram B.O": "504201",
      "Pokkur B.O": "504201",
      "Lingapur B.O": "504206",
      "Tapalpur B.O": "504206",
      "Madaripeta B.O": "504206",
      "Namnoor B.O": "504207",
      "Gollakota B.O": "504207",
      "Karnamamidi B.O": "504207",
      "Badampalli B.O": "504205",
      "Mulmadag B.O": "504205",
      "Nakkalapalli B.O": "504214",
      "Chandaram B.O": "504215",
      "Gudem B.O": "504215",
      "Venkatraopet B.O": "504215",
      "Jilleda B.O": "504219",
      "Metpalli B.O": "504219",
      "Perkapalli B.O": "504251",
      "Jajjaravelli B.O": "504251",
      "Akenapalli B.O": "504251",
      "Budakalan B.O": "504251",
      "Budakurd B.O": "504251",
      "Awadam B.O": "504204",
      "Maddikal B.O": "504204",
      "Gurjal B.O": "504251",
      "Mittapalli B.O": "504251",
      "Police Colony B.O": "504251",
      "Jankapur B.O": "504251",
      "Shanthi Khani B.O": "504251",
      "Somagudem Coal Mines B.O": "504251",
      "Weagaon B.O": "504251",
      "Achlapur B.O": "504273",
      "Boyapalli B.O": "504272",
      "Repallewada B.O": "504272",
      "Vempalli B.O": "504209",
      "Dwarakapur B.O": "504272",
      "Bhimni B.O": "504273",
      "Mallidi B.O": "504273",
      "Chintaguda B.O": "504205",
      "Kyathanpalli B.O": "504301",
      "Karjibheempur B.O": "504273",
      "Chakepalli B.O": "504272",
      "Kannepalli B.O": "504219",
      "Mancherial H.O": "504208",
      "Agm Colony S.O": "504251",
      "Bheemaram S.O": "504204",
      "Jaipur S.O": "504216",
      "Mancherial Bazar S.O": "504208",
      "Tandur  S.O": "504272",
      "Bellampalli S.O": "504251",
      "Coal Chemical Complex S.O": "504302",
      "Kotapalli S.O": "504214",
      "Luxettipet S.O": "504215",
      "Srirampur Colony S.O": "504303",
      "Bellampalli R.S. S.O": "504251",
      "Chinnoor S.O": "504201",
      "Devapur Cement Works S.O": "504218",
      "Donabanda S.O": "504207",
      "Grain Market S.O": "504208",
      "Mandamarri Colleries S.O": "504231",
      "Ramakrishnapur S.O": "504301",
      "Dandepalli S.O": "504206",
      "Jannaram S.O": "504205",
      "Kalyani Khani S.O": "504231",
      "Madaram Township S.O": "504220",
      "Mancherial Cement Works S.O": "504209",
      "Nennel S.O": "504219",
      "Rechini S.O": "504273"
    },
    "KUMURAM BHEEM ASIFABAD": {
      "Tumpally B.O": "504294",
      "Kanchavelli B.O": "504219",
      "Devaiguda B.O": "504294",
      "Giravalli B.O": "504219",
      "Rebbena B.O": "504299",
      "Ullipittadorli B.O": "504294",
      "Gudamamda B.O": "504311",
      "Ada B.O": "504293",
      "Gundi B.O": "504293",
      "Modi B.O": "504293",
      "Yellaram B.O": "504293",
      "Mamidipalli B.O": "504313",
      "Ushegaon B.O": "504313",
      "Daboli B.O": "504313",
      "Pangdi B.O": "504313",
      "Settihadapnoor B.O": "504313",
      "Netnoor B.O": "504313",
      "Chorpalli B.O": "504313",
      "Mahagaon B.O": "504313",
      "Marlawai B.O": "504313",
      "Phulara B.O": "504313",
      "Kanchanpalli B.O": "504313",
      "Rasimetta B.O": "504313",
      "Goyagaon B.O": "504293",
      "Kanargaon B.O": "504293",
      "Patnapur B.O": "504311",
      "Babapur B.O": "504293",
      "Devapur B.O": "504293",
      "Kerameri B.O": "504293",
      "Movad B.O": "504293",
      "Surdapur B.O": "504293",
      "Buruguda B.O": "504293",
      "Jamni B.O": "504313",
      "Lingapur B.O": "504313",
      "Sirpur B.O": "504313",
      "Ashepalli B.O": "504313",
      "Gangapur B.O": "504292",
      "Khairgaon B.O": "504292",
      "Dimda B.O": "504299",
      "Gudem B.O": "504299",
      "Gudlabori B.O": "504299",
      "Gundaipet B.O": "504299",
      "Karjavelli B.O": "504299",
      "Bejjur B.O": "504299",
      "Dhaba B.O": "504299",
      "Muthyampet B.O": "504299",
      "Ootsurangapalli B.O": "504299",
      "Papanpet B.O": "504299",
      "Andevelli B.O": "504296",
      "Chadvai B.O": "504296",
      "Tungeda B.O": "504296",
      "Bareguda B.O": "504296",
      "Vempalli B.O": "504296",
      "Old Town B.O": "504296",
      "Pangidimadra B.O": "504297",
      "Khamana B.O": "504295",
      "Kondapalli B.O": "504292",
      "Narayanpur B.O": "504292",
      "Navegaon B.O": "504292",
      "Takkalapalli B.O": "504292",
      "Ainam B.O": "504273",
      "Bodepelli B.O": "504273",
      "Bibra B.O": "504273",
      "Hatini B.O": "504273",
      "Babasagar B.O": "504299",
      "Chintalamanepalli B.O": "504299",
      "Talodi B.O": "504299",
      "Munjampalli B.O": "504299",
      "Easgaon   V B.O": "504296",
      "Easgaon Camp B.O": "504296",
      "Penchikalpet B.O": "504296",
      "Raspalli B.O": "504296",
      "Kannepalli B.O": "504297",
      "Moindagudipet B.O": "504297",
      "Indhani B.O": "504295",
      "Bambara B.O": "504295",
      "Golleti B.O": "504292",
      "Nambal B.O": "504292",
      "Gudipet B.O": "504273",
      "Ityal B.O": "504273",
      "Kalwada B.O": "504273",
      "Kothimir B.O": "504273",
      "Lonavelli B.O": "504299",
      "Marthadi B.O": "504299",
      "Mogardhagar B.O": "504299",
      "Gurudpet B.O": "504299",
      "Bapur B.O": "504299",
      "Dhorpalli B.O": "504299",
      "Ginnedhari B.O": "504297",
      "Mangi B.O": "504297",
      "Manikyapur B.O": "504297",
      "Rompalli B.O": "504297",
      "Dehgaon B.O": "504273",
      "Chintakunta B.O": "504299",
      "Kowthala B.O": "504299",
      "Mogavelli B.O": "504299",
      "Hudkuli B.O": "504299",
      "Pardi B.O": "504299",
      "Ankhoda B.O": "504299",
      "Chinthaguda B.O": "504296",
      "Sanjeevnagar B.O": "504296",
      "Mosam B.O": "504296",
      "Sirsilk Colony B.O": "504296",
      "Khirdi B.O": "504295",
      "M.G. Road S.O": "504296",
      "Tiryani S.O": "504297",
      "Sirpur S.O": "504299",
      "Jainoor S.O": "504313",
      "Chirrakunta S.O": "504294",
      "Rebbena S.O": "504292",
      "Sirpur Khagaznagar S.O": "504296",
      "Wankidi S.O": "504295",
      "Asifabad S.O": "504293",
      "Industrial Area S.O": "504296"
    },
    "WARANGAL RURAL": {
      "Laxmipur B.O": "506342",
      "Dabeerpet B.O": "506132",
      "Kothur B.O": "506313",
      "Chandrugonda B.O": "506122",
      "Jhalli B.O": "506122",
      "Burgumadla B.O": "506365",
      "Topanapalli B.O": "506369",
      "Mogilcherla B.O": "506006",
      "Geegugonda B.O": "506330",
      "Machapur B.O": "506330",
      "Govindapur B.O": "506132",
      "Narakkapet B.O": "506132",
      "Mudigonda B.O": "506122",
      "Nagaram B.O": "506391",
      "Soorpalli B.O": "506122",
      "Upparapalli B.O": "506310",
      "Chintanekkonda B.O": "506369",
      "Engal B.O": "506369",
      "Kalleda B.O": "506365",
      "Saireddipalli B.O": "506369",
      "Siddapur B.O": "506006",
      "Venkatapur B.O": "506006",
      "Chintalapalli B.O": "506330",
      "Elgur B.O": "506330",
      "Vancahnagiri B.O": "506330",
      "Venkatapur Haveli B.O": "506330",
      "Gundalpahad B.O": "506132",
      "Itikalapalli B.O": "506132",
      "Khanapur B.O": "506132",
      "Madannapet B.O": "506132",
      "Medapalli B.O": "506132",
      "Ameenabad B.O": "506122",
      "Deekshakunta B.O": "506122",
      "Kogilvai B.O": "506006",
      "Ladella B.O": "506006",
      "Mallareddipalli B.O": "506006",
      "Manugonda B.O": "506330",
      "Ookal B.O": "506330",
      "Pallarguda B.O": "506330",
      "Chennaram B.O": "506310",
      "Gavicherla B.O": "506310",
      "Konkapaka B.O": "506365",
      "Keshavapur B.O": "506314",
      "Kolanpalli B.O": "506314",
      "Teegarajpalli B.O": "506310",
      "Somaram B.O": "506365",
      "Wadlakonda B.O": "506365",
      "Katrepalli B.O": "506330",
      "Yellanda B.O": "506313",
      "Kammepalli B.O": "506333",
      "Venkatapuram B.O": "506333",
      "Peddakorpole B.O": "506112",
      "Ashoknagar B.O": "506132",
      "Bhanjipet B.O": "506132",
      "Dwarakapet B.O": "506132",
      "Muthojipet B.O": "506132",
      "Lingagiri B.O": "506122",
      "Appalraopet B.O": "506369",
      "Damera B.O": "506006",
      "Elkurthy B.O": "506330",
      "Shayampet  B.O": "506330",
      "Lohitha B.O": "506310",
      "Gopanpalli B.O": "506365",
      "Katrapalli B.O": "506349",
      "Rollakal B.O": "506365",
      "Kondur B.O": "506314",
      "Viswanathapur B.O": "506331",
      "Sannur B.O": "506163",
      "Bandouthapur B.O": "506313",
      "Katrial B.O": "506313",
      "Dammannapet B.O": "506316",
      "Muripirala B.O": "506314",
      "Nallballi B.O": "506310",
      "Annaram B.O": "506365",
      "Choutapalli B.O": "506365",
      "Dowlathnagar B.O": "506365",
      "Kondapur B.O": "506314",
      "Mylaram B.O": "506314",
      "Taharapur B.O": "506319",
      "Kamareddipalli B.O": "506319",
      "Elgur Station B.O": "506329",
      "Liabarthy B.O": "506313",
      "Reddipalem B.O": "506313",
      "Sagaram B.O": "506313",
      "Kantatmakur B.O": "506391",
      "Nachenapalli B.O": "506331",
      "Timmapet B.O": "506333",
      "Gurijala B.O": "506331",
      "Laknepalli B.O": "506331",
      "Mondrai B.O": "506331",
      "Ookal Raiparthy B.O": "506314",
      "Perkaveid B.O": "506314",
      "Thirumalaipalli B.O": "506314",
      "Gadepalli B.O": "506005",
      "Kapulakanparthy B.O": "506005",
      "Maheshwaram B.O": "506331",
      "Mallampalli B.O": "506333",
      "Mandapalli B.O": "506331",
      "Mohammadapur B.O": "506333",
      "Koppula B.O": "506319",
      "Kothagattu Singaram B.O": "506319",
      "Pathipak B.O": "506319",
      "Vellampalli B.O": "506391",
      "Gatlakaniparthy B.O": "506319",
      "Peddakodepak B.O": "506319",
      "Alankhanipet B.O": "506112",
      "Mangalvaripet B.O": "506134",
      "Pasaragonda B.O": "506342",
      "Pulukurthy B.O": "506342",
      "Neredupalli B.O": "506349",
      "Cherlapalli B.O": "506391",
      "Hussainpalli B.O": "506319",
      "Akkampet B.O": "506342",
      "Chowlapalli B.O": "506342",
      "Peddapur B.O": "506342",
      "Dongalasingaram B.O": "506349",
      "Muddunur B.O": "506349",
      "Kowkonda B.O": "506391",
      "Narsakkapalli B.O": "506391",
      "Lingapuram B.O": "506332",
      "Papaiahpet B.O": "506332",
      "Yellaigudem B.O": "506332",
      "Mustialapalli B.O": "506342",
      "Neerukulla B.O": "506342",
      "Rangapur B.O": "506349",
      "Relakunta B.O": "506349",
      "Bollonipalli B.O": "506349",
      "Shanigaram B.O": "506349",
      "Puligilla B.O": "506391",
      "Raiparthy B.O": "506391",
      "Varikol B.O": "506391",
      "Thimmarayanpahad B.O": "506332",
      "Bhudharaopet B.O": "506134",
      "Rudragudem B.O": "506349",
      "Chowtaparthy B.O": "506391",
      "Narlapur B.O": "506391",
      "Dharmaraopet B.O": "506134",
      "Konapuram B.O": "506332",
      "Maqdumpuram B.O": "506332",
      "Oorugonda B.O": "506342",
      "Nekkonda S.O": "506122",
      "Raiparthy S.O": "506314",
      "Redlawada S.O": "506369",
      "Parwathagiri S.O": "506365",
      "Togarrai S.O": "506331",
      "Duggondi S.O": "506333",
      "Wardhannapet S.O": "506313",
      "Sangam S.O": "506329",
      "Parkal H.O": "506164",
      "Atmakur S.O": "506342",
      "Nadikuda S.O": "506391",
      "Nallabelli S.O": "506350",
      "Shayampet S.O": "506319",
      "Narsampet S.O": "506132",
      "Chennaraopet S.O": "506332"
    },
    "MAHABUBABAD": {
      "Gopalapuram B.O": "507210",
      "Upparapalli B.O": "506112",
      "Edulapalli B.O": "506135",
      "Inchaguda B.O": "506135",
      "Jangamvarigudem B.O": "506135",
      "Ootai B.O": "506135",
      "Punugondla B.O": "506135",
      "Mulkanoor B.O": "507210",
      "Garedipalli": "507210",
      "Velbelli B.O": "506135",
      "Ayyagaripalli B.O": "506105",
      "Abbaipalem B.O": "506315",
      "Bhavajigudem B.O": "506315",
      "Gundepudi B.O": "506315",
      "Veeram B.O": "506315",
      "Yerjerla B.O": "506315",
      "Rajulakothapalli B.O": "506368",
      "Yerrabelligudem B.O": "506368",
      "Gudur B.O": "506104",
      "Amangala B.O": "506102",
      "Bheriwada B.O": "506102",
      "Penugonda B.O": "506102",
      "Vavilala B.O": "506102",
      "Naikpalli B.O": "506112",
      "Rajanpalli B.O": "506112",
      "Ammeenapur B.O": "506112",
      "Musmi B.O": "506135",
      "Chintapalli B.O": "506105",
      "Kandikonda B.O": "506105",
      "Madapur B.O": "506105",
      "Mogilcherla B.O": "506105",
      "Serole B.O": "506105",
      "Sudenapalli B.O": "506105",
      "Tallasankeesa B.O": "506105",
      "Tattupalli B.O": "506105",
      "Purushothamaigudem B.O": "506315",
      "Rampur B.O": "506315",
      "Tadla Ookal B.O": "506315",
      "Thanamcherla B.O": "506315",
      "Uggampalli B.O": "506315",
      "Mungalveedu B.O": "506368",
      "Nainala B.O": "506368",
      "Singaram B.O": "506104",
      "Kollapur B.O": "506103",
      "Matwada B.O": "506103",
      "Mudupugal B.O": "506102",
      "Govindapur B.O": "506103",
      "Bhathulapalli B.O": "506135",
      "Komatlagudem B.O": "506135",
      "Madaguda B.O": "506135",
      "Marrigudem B.O": "506135",
      "Pogullapalli B.O": "506135",
      "Burhanpur B.O": "506315",
      "Chillamcherla B.O": "506315",
      "Dharmaram B.O": "506315",
      "Galivarigudem B.O": "506315",
      "Madanthurthi B.O": "506368",
      "Mecharajpalli B.O": "506368",
      "Jangligonda B.O": "506104",
      "Jayyaram B.O": "506104",
      "Kousalyadevipalli B.O": "506104",
      "Narasimlaguda B.O": "506104",
      "Alair B.O": "506102",
      "Apparajpalli B.O": "506103",
      "Buddugonda B.O": "506103",
      "Edulapoosalapalli B.O": "506102",
      "Gundrathimadugu B.O": "506102",
      "Jamandlapalli B.O": "506103",
      "Rajole B.O": "506102",
      "Reddial B.O": "506103",
      "Stn. Gundrathimadugu B.O": "506102",
      "Tadlapoosalapalli B.O": "506102",
      "Pullur B.O": "507210",
      "Rampuram B.O": "507210",
      "Seethampeta B.O": "507210",
      "Chinnavangara B.O": "506317",
      "Pochampalli B.O": "506317",
      "Gurthur B.O": "506163",
      "Haripirala B.O": "506163",
      "Kantaipalem B.O": "506163",
      "Madhupalli' B.O": "506163",
      "Matair B.O": "506163",
      "Ammapur B.O": "506163",
      "Fathepur B.O": "506163",
      "Yelkatte B.O": "506163",
      "Karkala B.O": "506318",
      "Annaram B.O": "506102",
      "Laxmipur B.O": "506102",
      "Teegalavenii B.O": "506112",
      "Narayanapuram B.O": "506112",
      "Gangaram B.O": "506135",
      "Sadireddipalli B.O": "506135",
      "Bethole B.O": "506105",
      "Kamepalli B.O": "506105",
      "Modugulaguda B.O": "506105",
      "Nallela B.O": "506105",
      "Upparguda B.O": "506105",
      "Anepur B.O": "506315",
      "Maripeda  B.O": "506315",
      "Neelkurthi B.O": "506315",
      "Yellampet B.O": "506315",
      "Ravirala B.O": "506368",
      "Sriramgiri B.O": "506368",
      "Jama Thanda B.O": "506368",
      "Chengapur B.O": "506104",
      "Gundamrajpalli B.O": "506104",
      "Parvathagiri B.O": "506104",
      "Kothareddial B.O": "506103",
      "Nadiwada B.O": "506103",
      "Vemnoor B.O": "506102",
      "Kamalapuram B.O": "507210",
      "Ponnekal B.O": "507210",
      "Seripuram": "507210",
      "Nancharimadur B.O": "506317",
      "Cheralpalem B.O": "506163",
      "Venkatapur B.O": "506163",
      "Gantlakunta B.O": "506318",
      "Korepalli B.O": "506318",
      "Authapur B.O": "506317",
      "Budharam B.O": "507210",
      "Dubbagudem B.O": "507210",
      "Pocharam B.O": "507122",
      "Bommakal B.O": "506318",
      "Chityal B.O": "506318",
      "Mallial B.O": "506102",
      "Gajulagattu B.O": "506134",
      "Ingurthy B.O": "506112",
      "Kalvala B.O": "506112",
      "Katrepalli B.O": "506112",
      "Komatipalli B.O": "506112",
      "Mupparamkurd B.O": "506112",
      "Anantharam B.O": "506102",
      "Pungode B.O": "506134",
      "Chinnagaram B.O": "506112",
      "Intikanne B.O": "506112",
      "Jaipur B.O": "506324",
      "Kummarikunta B.O": "506324",
      "Chilkode B.O": "506381",
      "Kannegundla B.O": "506381",
      "Ayodhyapur B.O": "506134",
      "Bhupathipet B.O": "506134",
      "Dameravancha B.O": "506134",
      "Kothapeta B.O": "507211",
      "Ramachandrapuram B.O": "507211",
      "S.N.Puram B.O": "507211",
      "Uppalapahad B.O": "507211",
      "Gundenga B.O": "506332",
      "Agapet B.O": "506324",
      "Reponi B.O": "506324",
      "Vanthadapala B.O": "506324",
      "Ammapalem B.O": "506381",
      "Andanalapadu B.O": "506381",
      "Balapala B.O": "506381",
      "Beersettigudem B.O": "506324",
      "Bodlada B.O": "506324",
      "Brahmanakothapalli B.O": "506324",
      "Datla B.O": "506324",
      "Mungimadugu B.O": "506324",
      "Mupparamkalan B.O": "506324",
      "Manneguda B.O": "506381",
      "Mulkalapalli B.O": "506381",
      "Vennaram B.O": "506381",
      "Vuyyalawada B.O": "506381",
      "Macherla B.O": "506134",
      "Seethanagar B.O": "506134",
      "Dhansari B.O": "506112",
      "Kesamudram Town B.O": "506112",
      "Korukondapalli B.O": "506112",
      "Balajipeta B.O": "507211",
      "Gunnepalli B.O": "506324",
      "Kommulavancha B.O": "506324",
      "Narasimulapet B.O": "506324",
      "Cathedrol Compound B.O": "506381",
      "Gollacherla B.O": "506381",
      "Perumandlasankeesa B.O": "506381",
      "Bollepalli B.O": "506134",
      "Irsulapuram B.O": "507211",
      "Venkataramapuram B.O": "507211",
      "KAMBALAPALLY": "507211",
      "Gowraram B.O": "507211",
      "KOTHAGUDEM": "507211",
      "VENKATAPURAM": "507211",
      "New Abadi S.O": "506102",
      "Peddavangara S.O": "506317",
      "Neerada S.O": "506104",
      "Kambalapalli S.O": "506103",
      "Waddekothapally S.O": "506318",
      "Turrur S.O": "506163",
      "Mahabubabad H.O": "506101",
      "Nallikaddur S.O": "506368",
      "Dornakal S.O": "506381",
      "Gudur S.O": "506134",
      "Kuravi S.O": "506105",
      "Kothaguda S.O": "506135",
      "Dantalapalli S.O": "506324",
      "Kesamudram S.O": "506112",
      "Maripeda S.O": "506315",
      "Bayyaram S.O": "507211",
      "Garla S.O": "507210"
    },
    "Jagitial": {
      "Thimmapur BO": "505425",
      "Laxmipur B.O": "505529",
      "Itikyal BO": "505460",
      "Potharam B.O": "505452",
      "Mohanraopet B.O": "505453",
      "Kondrikarla B.O": "505325",
      "Metlachittapur B.O": "505325",
      "Mogalpet B.O": "505331",
      "Vempet B.O": "505331",
      "Kandlapalli B.O": "505454",
      "Nakkalapet B.O": "505454",
      "Chelgal B.O": "505455",
      "New Bus Stand Jagtial B.O": "505455",
      "Mallannapet B.O": "505529",
      "Nagnur Lachakkapet B.O": "505529",
      "Dumpet B.O": "505462",
      "Servapuram B.O": "505452",
      "Thakkallapalli B.O": "505452",
      "Myadampalli B.O": "505452",
      "Tattupalli B.O": "505452",
      "Pormalla B.O": "505453",
      "Atmakur B.O": "505526",
      "Jaggasagar B.O": "505325",
      "Namapur B.O": "505531",
      "Sataram B.O": "505331",
      "Habshipur B.O": "505454",
      "Thumminala B.O": "505454",
      "Valgonda B.O": "505454",
      "Gandhinagar NDBO": "505455",
      "Anthergaon B.O": "505455",
      "Pembatla Konapur B.O": "505529",
      "Raichpalli B.O": "505529",
      "Joganapalli B.O": "505460",
      "Madhunur B.O": "505425",
      "Yamapur B.O": "505450",
      "Maddutla B.O": "505452",
      "Nookapalli B.O": "505452",
      "Kalvakota B.O": "505453",
      "Katlakunta B.O": "505453",
      "Medipalli B.O": "505325",
      "Peggarla B.O": "505325",
      "Dharmarajpalli B.O": "505331",
      "Vempalli Venkatraopet B.O": "505331",
      "Kalleda B.O": "505454",
      "Kolvai B.O": "505454",
      "Mangela B.O": "505454",
      "Narsimulapalli B.O": "505454",
      "Darur B.O": "505455",
      "Morapalli B.O": "505455",
      "Mothe B.O": "505455",
      "Arpapalli B.O": "505529",
      "Kummarpalli B.O": "505460",
      "Paidimadugu B.O": "505460",
      "Ekeenpur B.O": "505462",
      "Takkallapalli B.O": "505454",
      "Banda Lingapur B.O": "505325",
      "Mehtapur B.O": "505460",
      "Thatlavai B.O": "505460",
      "Bhushanraopet B.O": "505462",
      "Kathalapur B.O": "505462",
      "Mannegudem B.O": "505462",
      "Buggaram B.O": "505454",
      "Sarangapur B.O": "505454",
      "Rampur B.O": "505452",
      "Kothapet B.O": "505526",
      "Velgatur B.O": "505526",
      "Kondapur B.O": "505453",
      "Govindaram B.O": "505306",
      "Tandrial B.O": "505306",
      "Rajaram B.O": "505425",
      "Chilvakodur B.O": "505532",
      "Thirumalapur B.O": "505532",
      "Aggimalla B.O": "505532",
      "Bathkepalli B.O": "505532",
      "Arevelli B.O": "505452",
      "Balwanthapur B.O": "505452",
      "Maddulapalli B.O": "505452",
      "Manala B.O": "505452",
      "Thatipalli B.O": "505453",
      "Vallampalli B.O": "505453",
      "Venkatropet B.O": "505325",
      "Chinnametpalli B.O": "505453",
      "Chowlamaddi B.O": "505325",
      "Konaraopet B.O": "505325",
      "Ragavpet B.O": "505331",
      "Chittapur B.O": "505331",
      "Donur B.O": "505454",
      "Thungur B.O": "505454",
      "Beerpur B.O": "505454",
      "Ibrahimnagar B.O": "505529",
      "Allipur B.O": "505460",
      "Bornapalli B.O": "505460",
      "Katkapur B.O": "505460",
      "Mootapalli B.O": "505460",
      "Ramojipet B.O": "505460",
      "Dulur B.O": "505462",
      "Mallapur BO": "505331",
      "Sirikonda B.O": "505425",
      "Pathagudur B.O": "505416",
      "Godur B.O": "505325",
      "Lingampet B.O": "505306",
      "Donthapur B.O": "505425",
      "Rayapatnam B.O": "505425",
      "Lingapur B.O": "505532",
      "Varsikonda B.O": "505450",
      "Gullakota B.O": "505526",
      "Jagadevpet B.O": "505526",
      "Porandla B.O": "505529",
      "Kallur B.O": "505330",
      "Yousufnagar B.O": "505330",
      "Bommena B.O": "505306",
      "Desaipet B.O": "505306",
      "Gambirpur B.O": "505306",
      "Jaina B.O": "505425",
      "Kamalapur B.O": "505425",
      "Nancherla B.O": "505532",
      "Rapalli B.O": "505532",
      "Shakalla B.O": "505532",
      "Vengalaipet B.O": "505532",
      "Ammakkapet B.O": "505450",
      "Leegalamarri B.O": "505415",
      "Ambaripet B.O": "505526",
      "Muthunur B.O": "505526",
      "Godshalpet B.O": "505526",
      "Tippaipalli B.O": "505501",
      "Chegaon B.O": "505416",
      "Tirumalapur B.O": "505501",
      "Cheppial B.O": "505501",
      "Nachupalli B.O": "505501",
      "Chinthakunta B.O": "505462",
      "Dabba B.O": "505450",
      "Muthyampet B.O": "505452",
      "Kapparaopet B.O": "505526",
      "Sthambampalli B.O": "505526",
      "Poodur B.O": "505501",
      "Ramsagar B.O": "505501",
      "Aithpalli B.O": "505531",
      "Bhupathipur B.O": "505460",
      "Erdandi B.O": "505450",
      "Komatikondapur B.O": "505450",
      "Vemulakurthi B.O": "505450",
      "Vellulla B.O": "505325",
      "Yellapur B.O": "505415",
      "Pegadapalli B.O": "505532",
      "Peddapur B.O": "505325",
      "Venkatapur B.O": "505330",
      "Bheemaram B.O": "505453",
      "Raghavapatnam B.O": "505532",
      "Venugumatla B.O": "505532",
      "Namilikonda B.O": "505501",
      "Rathnapur B.O": "505331",
      "Jabithapur B.O": "505455",
      "Chandoli B.O": "505532",
      "Siripuram B.O": "505331",
      "kondapurBO": "505526",
      "Kishanraopet B.O": "505526",
      "Madhapur BO": "505330",
      "Thippannapet B.O": "505529",
      "Gopalapur B.O": "505425",
      "Kodimial S.O": "505501",
      "Jagtial H.O": "505327",
      "Raikal S.O": "505460",
      "Endapalli S.O": "505526",
      "Ambaripet S.O": "505306",
      "Dharmapuri S.O": "505425",
      "Koratla Bazar S.O": "505326",
      "Koratla S.O": "505326",
      "Medpalli S.O": "505453",
      "Metpalli Bazar S.O": "505325",
      "Metpalli S.O": "505325",
      "Muthyampet S.O": "505331",
      "Ailapur S.O": "505330",
      "Khila Jagtial S.O": "505327",
      "New Abadi Jagtial S.O": "505327",
      "Sirikonda S.O": "505462",
      "Mallial S.O": "505452",
      "Nerella S.O": "505454",
      "Pochampad Project Colony S.O": "505455",
      "Polas S.O": "505529",
      "Gollapalli S.O": "505532",
      "Ibrahimpatnam S.O": "505450"
    },
    "HYDERABAD": {
      "Sripuram Colony B.O": "500036",
      "Tadban B.O": "500064",
      "CRP Camp B.O": "500005",
      "Nanakramguda B.O": "500008",
      "A.Gs. Staff Quarters S.O": "500045",
      "Bazarghat S.O": "500004",
      "Dr.B R Ambedkar O.U  S.O": "500033",
      "I.M.Colony S.O": "500082",
      "Murad Nagar S.O": "500028",
      "Erragadda S.O": "500018",
      "Jubilee Hills S.O": "500033",
      "Kakatiya Nagar S.O": "500008",
      "Anandnagar S.O": "500004",
      "Cyberabad S.O": "500081",
      "Film Nagar S.O": "500096",
      "Raj Bhawan S.O": "500041",
      "Banjara Hills S.O": "500034",
      "Humayunnagar S.O": "500028",
      "Sanjeev Reddy Nagar S.O": "500038",
      "Srinagar Colony S.O": "500073",
      "IBC Hyderabad": "500109",
      "Begum Bazar S.O": "500012",
      "High Court S.O": "500066",
      "Kanchanbagh S.O": "500058",
      "Saidabad S.O": "500059",
      "Santoshnagar Colony S.O": "500059",
      "Andhra Mahila Sabha S.O": "500044",
      "A.Gs Office S.O": "500004",
      "Gagan Mahal S.O": "500029",
      "Gandhi Bhawan S.O": "500001",
      "LIC Division S.O": "500063",
      "Lunger House S.O": "500008",
      "Parishram Bhawan S.O": "500004",
      "State Bank Of India S.O": "500095",
      "Vivekananda Nagar Colony S.O": "500018",
      "Yousufguda S.O": "500045",
      "Golconda S.O": "500008",
      "Narayanguda S.O": "500029",
      "Sakkubai Nagar S.O": "500008",
      "Toli Chowki S.O": "500008",
      "Vengal Rao Nagar S.O": "500038",
      "Central Secretariat S.O": "500022",
      "Ibrahim Bagh Lines S.O": "500031",
      "Karwan Sahu S.O": "500006",
      "Kulsumpura S.O": "500006",
      "Moazzampura S.O": "500001",
      "Vidhan Sabha S.O": "500004",
      "Shantinagar S.O": "500028",
      "Somajiguda S.O": "500082",
      "Vijay Nagar Colony S.O": "500057",
      "Prashasan Nagar S.O": "500110",
      "Falaknuma S.O": "500053",
      "Fatehdarwaza S.O": "500065",
      "Uppuguda S.O": "500053",
      "Yakutpura S.O": "500023",
      "Malakpet Colony S.O": "500036",
      "Nallakunta S.O": "500044",
      "Ashoknagar S.O": "500020",
      "Bahadurpura S.O": "500064",
      "Sahifa S.O": "500024",
      "Shahalibanda S.O": "500065",
      "Barkatpura S.O": "500027",
      "C.R.P. Camp S.O": "500005",
      "Saidabad Colony S.O": "500059",
      "Badangpet S.O": "500112",
      "Amberpet S.O": "500013",
      "New Nallakunta S.O": "500044",
      "Osmannagar S.O": "500036",
      "Vidyanagar S.O": "500044",
      "Trimulgherry H.O": "500015",
      "Stn. Kachiguda H.O": "500027",
      "Secunderabad H.O": "500003",
      "Gachibowli S.O": "500032",
      "Himayathnagar S.O": "500029",
      "Kothaguda S.O": "500084",
      "New Mla Quarters S.O": "500063",
      "Putlibowli S.O": "500095",
      "Ramakrishna Mutt S.O": "500029",
      "Seetharampet S.O": "500001",
      "State Bank Of Hyderabad S.O": "500001",
      "Gopanpally S.O": "500107",
      "Khairatabad H.O": "500004",
      "Hyderabad G.P.O.": "500001",
      "Charminar HO": "500002",
      "Gandhinagar S.O": "500080",
      "Musheerabad (D) S.O": "500020",
      "Ngri S.O": "500007",
      "Prakashamnagar S.O": "500016",
      "Rail Nilayam S.O": "500025",
      "Bolarum Bazar S.O": "500010",
      "EME Records S.O": "500015",
      "Hakimpet S.O": "500014",
      "Himmatnagar S.O": "500025",
      "Lallaguda S.O": "500017",
      "Lallapet S.O": "500017",
      "Nehrunagar S.O": "500026",
      "Ramakrishna Puram S.O": "500056",
      "Bolarum S.O": "500010",
      "Sitaphalmandi S.O": "500061",
      "Zamistanpur S.O": "500020",
      "Anandbagh S.O": "500047",
      "Bowenpally S.O": "500011",
      "Sainikpuri S.O": "500094",
      "Golconda Chowrastha S.O": "500020",
      "Ie Moulali S.O": "500040",
      "IICT S.O": "500007",
      "Jama I Osmania S.O": "500007",
      "Aoc Records S.O": "500015",
      "Manovikasnagar S.O": "500009",
      "Neredmet S.O": "500056"
    },
    "Nirmal": {
      "Udumpur B.O": "504205",
      "Pochampadu LF B.O": "503219",
      "Waddial B.O": "504106",
      "Yellapalli B.O": "504106",
      "Dasturabad B.O": "504202",
      "Bellalbadi B.O": "504202",
      "Munial B.O": "504202",
      "Madhapur B.O": "504105",
      "Brahmangaon B.O": "504101",
      "Kirgul Buzurg B.O": "504101",
      "Elwath B.O": "504101",
      "Chata B.O": "504103",
      "Chondi B.O": "504103",
      "Bholsa B.O": "504103",
      "Kothalgaon B.O": "504103",
      "Malegoan B.O": "504103",
      "Pardi (B) B.O": "504103",
      "Aloor B.O": "504110",
      "Gopalpet B.O": "504110",
      "Boregaon B.O": "504101",
      "Dhani B.O": "504110",
      "Bansapalli B.O": "504306",
      "Gundampalli B.O": "504306",
      "Rampur B.O": "504306",
      "Limba B.O": "504109",
      "Pendpalli B.O": "504109",
      "Timmapur B.O": "504109",
      "Tandra B.O": "504310",
      "Dehgaon B.O": "504102",
      "Elegoan B.O": "504102",
      "Elvi B.O": "504102",
      "Kankapur B.O": "504101",
      "Bidralli B.O": "504101",
      "Ashta B.O": "504101",
      "Bhosi B.O": "504103",
      "Mahalingi B.O": "504103",
      "Pulsi B.O": "504103",
      "Sonari B.O": "504103",
      "Chichondi B.O": "504103",
      "Nigwa B.O": "504103",
      "Vengwapet B.O": "504110",
      "Nachan Yellapur B.O": "504203",
      "Ola B.O": "504109",
      "Dimmadurthy B.O": "504310",
      "Chintalchanda B.O": "504310",
      "Rajura B.O": "504104",
      "Kolur B.O": "504102",
      "Lohesra B.O": "504104",
      "Mahagaon B.O": "504103",
      "Beltharoda B.O": "504103",
      "Koutla B.O": "504110",
      "Jam B.O": "504110",
      "Birvelli B.O": "504306",
      "Chityal B.O": "504202",
      "Kalwa B.O": "504306",
      "Badankurthi B.O": "504203",
      "Mandapalli B.O": "504203",
      "Pembi B.O": "504203",
      "Sunkli B.O": "504109",
      "Kallur B.O": "504109",
      "Parimandal B.O": "504310",
      "Kamalkote B.O": "504310",
      "Kamol B.O": "504102",
      "Tanur B.O": "504102",
      "Yedbid B.O": "504102",
      "Javla B.O": "504102",
      "Ambaripet B.O": "504202",
      "Koutla K B.O": "504106",
      "Laxmanchanda B.O": "504106",
      "Mallapur B.O": "504106",
      "Ratnapur Kandly B.O": "504106",
      "Maddipadaga B.O": "504202",
      "Revojipet B.O": "504202",
      "Kadthal B.O": "504105",
      "Parpalli B.O": "504105",
      "Yelmal B.O": "504105",
      "Manjulapur B.O": "504106",
      "Bangalpet B.O": "504106",
      "Lingapur B.O": "504202",
      "Kuchanpalli B.O": "504105",
      "Pakpatla B.O": "504105",
      "Peechara B.O": "504105",
      "Siddalkunta B.O": "504105",
      "Doderna B.O": "504103",
      "Kubeer B.O": "504103",
      "Sawli B.O": "504103",
      "Chincholi Malak B.O": "504110",
      "Ponkur B.O": "504110",
      "Sarangapur B.O": "504110",
      "Mujgi B.O": "504306",
      "Sirgapur B.O": "504306",
      "Dilwarpur B.O": "504203",
      "Pata Yellapur B.O": "504203",
      "Surjapur B.O": "504203",
      "Beernandi B.O": "504203",
      "Sathanpalli B.O": "504203",
      "Andukur B.O": "504109",
      "Gulmadag B.O": "504109",
      "Koratkal B.O": "504310",
      "Ponkal B.O": "504310",
      "Medpalli B.O": "504310",
      "Puspur B.O": "504102",
      "Manmad B.O": "504104",
      "New Pipri B.O": "504104",
      "Gadchanda B.O": "504104",
      "Panchagudi B.O": "504104",
      "Raipur K B.O": "504104",
      "Venkatapur B.O": "504106",
      "Dilawarpur S.O": "504306",
      "Narsapur S.O": "504104",
      "RGU IIIT Campus Basar S.O": "504107",
      "Bhainsa S.O": "504103",
      "Indiranagar S.O": "504106",
      "Khanapur S.O": "504203",
      "Peddur S.O": "504202",
      "Basar S.O": "504101",
      "Chincholi  S.O": "504110",
      "Mamda S.O": "504310",
      "Mudhole S.O": "504102",
      "Soan S.O": "504105",
      "Kasba S.O": "504106",
      "Kuntala S.O": "504109",
      "Nirmal S.O": "504106"
    },
    "YADADRI BHUVANAGIRI": {
      "Gujja B.O": "508253",
      "Gudimalkapur B.O": "508253",
      "Vailpallli B.O": "508253",
      "Pedapadisala B.O": "508223",
      "Podiched B.O": "508277",
      "Veldevi B.O": "508277",
      "Dacharam B.O": "508277",
      "Vankamamidi B.O": "508284",
      "Inderial B.O": "508284",
      "Julur B.O": "508284",
      "Pillayipalli B.O": "508284",
      "Chirragudur B.O": "508277",
      "Gattusingaram B.O": "508277",
      "Govindapuram B.O": "508277",
      "M.Turkapalli B.O": "508112",
      "Chandupatla B.O": "508286",
      "Chinakandukur B.O": "508286",
      "Veeravally B.O": "508286",
      "Yadagirigutta B.O": "508115",
      "Datarpalli B.O": "508115",
      "Kacharam B.O": "508115",
      "Vasalmari B.O": "508115",
      "Venkatpuram B.O": "508115",
      "Panthangi B.O": "508252",
      "Tangedapalli B.O": "508252",
      "Sangam B.O": "508252",
      "Somavaram B.O": "508105",
      "Begampet B.O": "508105",
      "Challoor B.O": "508105",
      "Doodi Venkatapuram B.O": "508105",
      "Gouraipalli B.O": "508105",
      "Rajapet B.O": "508105",
      "Bhogavaram B.O": "508113",
      "Kakkireni B.O": "508113",
      "Munipampla B.O": "508113",
      "Shobhanadripuram B.O": "508113",
      "Yennaram B.O": "508113",
      "Dubbaka B.O": "508113",
      "Anajipur B.O": "508285",
      "Bodduguda B.O": "508277",
      "Kanchanapally B.O": "508277",
      "Musipatla B.O": "508277",
      "Ramavaram B.O": "508277",
      "Dharmaram B.O": "508277",
      "Suddala B.O": "508277",
      "Jiblakpalli B.O": "508284",
      "Namila B.O": "508105",
      "Bondugula B.O": "508105",
      "Jalasingaram B.O": "508105",
      "Pamkunta B.O.": "508105",
      "Yellunki B.O": "508113",
      "Pahalwanpur B.O": "508285",
      "Bollepalli B.O": "508285",
      "Edullaguda B.O": "508112",
      "Nagaram B.O": "508112",
      "Bujilapuram B.O": "508277",
      "Kondagadapa B.O": "508277",
      "Patimatla B.O": "508277",
      "Palliwada B.O": "508113",
      "Suraram B.O": "508113",
      "Iskilla B.O": "508113",
      "Survail B.O": "508253",
      "Teratpalli B.O": "508253",
      "Putpak B.O": "508253",
      "Vasthakonduru B.O": "508223",
      "Sunkishala B.O": "508112",
      "Vemulkonda B.O": "508112",
      "Chittapur B.O": "508112",
      "Ikkurthi B.O": "508286",
      "Choller B.O": "508286",
      "Kunoor B.O": "508286",
      "Gandhamalla B.O": "508115",
      "Veerareddipalli B.O": "508115",
      "Ibrahimpuram B.O": "508115",
      "Swamulavarilingotam B.O": "508252",
      "Janakipuram B.O": "508223",
      "Bandakothapally B.O": "508223",
      "Goprajupalli B.O": "508112",
      "Mogilipak B.O": "508112",
      "Velwarthy B.O": "508112",
      "Peddatoor B.O": "508112",
      "Cheemalakondur B.O": "508286",
      "Matoor B.O": "508286",
      "Motakondur B.O": "508286",
      "Dattayipalli B.O": "508115",
      "Jangampalli B.O": "508115",
      "Saidapuram B.O": "508115",
      "Turkapalli B.O": "508115",
      "Devalammanagaram B.O": "508252",
      "Gokaram B.O": "508252",
      "Jaikesaram B.O": "508252",
      "Koyyalagudem B.O": "508252",
      "Malkapuram B.O": "508252",
      "Chinakondur B.O": "508252",
      "Pipalpahad B.O": "508252",
      "Janampalli B.O": "508113",
      "Siripur B.O": "508113",
      "Puligilla B.O": "508285",
      "Kanchanapalli B.O": "508285",
      "Golankonda B.O": "508101",
      "Tangtoor B.O": "508101",
      "Kollur B.O": "508101",
      "Muripirala B.O": "508111",
      "Chada B.O": "508111",
      "Khapraipally B.O": "508111",
      "Parupalli B.O": "508105",
      "Kurella B.O": "508111",
      "Jangaon B.O": "508253",
      "Thummalguda B.O": "508112",
      "Arroor B.O": "508112",
      "Peddakandkur B.O": "508286",
      "Raigiri B.O": "508286",
      "Varaturu B.O": "508286",
      "Masaipet B.O": "508115",
      "Mallapur B.O": "508115",
      "Lingojigudem B.O": "508252",
      "Niyalapatla B.O": "508252",
      "Maripadiga B.O": "508101",
      "Kolanpaka B.O": "508101",
      "Seetarampur B.O": "508101",
      "Sharajpet B.O": "508101",
      "Paladugu B.O": "508111",
      "Pallepahad B.O": "508111",
      "Pallerla B.O": "508111",
      "Rahimkhanpeta B.O": "508111",
      "Katepally B.O": "508111",
      "Koratikal B.O": "508111",
      "Anantaram B.O": "508101",
      "Chikatimamadi B.O": "508117",
      "Baswapur B.O": "508117",
      "Renikunta B.O.": "508105",
      "Laxmapuram B.O": "508113",
      "Maqdoompalli B.O": "508285",
      "Nandanam B.O": "508285",
      "Redlarepaka B.O": "508285",
      "Maryal B.O": "508117",
      "Town Bhongir B.O": "508117",
      "Madhapuram B.O": "508117",
      "Jameelapet B.O": "508126",
      "Raghavapuram B.O": "508126",
      "Inkriyala B.O": "508126",
      "Anajpuram B.O": "508277",
      "Masanpalli B.O": "508277",
      "Brahmanapalli B.O": "508126",
      "Dattappagudem B.O": "508277",
      "Gundal B.O": "508277",
      "Repakapatti B.O": "508277",
      "Velmazala B.O": "508101",
      "Chandepalli B.O": "508111",
      "Servepalli B.O": "508111",
      "DuppalliB.O": "508111",
      "Rustapur B.O": "508117",
      "Theriala B.O": "508111",
      "Hanumapuram B.O": "508117",
      "Pyaravaram B.O": "508117",
      "Wadaparthi B.O": "508117",
      "Medipalli B.O": "508117",
      "Bhattuguda B.O": "508126",
      "Guduru B.O": "508126",
      "Ramalingampalli B.O": "508126",
      "Bommalramaram B.O": "508126",
      "Jalalpur B.O": "508126",
      "Kondamadugu B.O": "508126",
      "Kotamarthy B.O": "508277",
      "Turkalshapuram B.O": "508277",
      "Pallipahad B.O": "508117",
      "Hazipur B.O": "508126",
      "Naginenipalli B.O": "508126",
      "Jainapalli B.O": "508126",
      "Ambala B.O": "508277",
      "Chowllaramavaram B.O": "508277",
      "Addagudur B.O": "508277",
      "Bhongir H.O": "508116",
      "Atmakur S.O": "508111",
      "Tekulasomaram S.O": "508285",
      "Wangapalli S.O": "508286",
      "Choutuppala S.O": "508252",
      "Narayanpur S.O": "508253",
      "Alir S.O": "508101",
      "Bhongir Gunj S.O": "508117",
      "Bibinagar S.O": "508126",
      "Yadgarpalli S.O": "508115",
      "Raghunathpur S.O": "508105",
      "Mothcore S.O": "508277",
      "Pochampalli S.O": "508284",
      "Ramannapeta S.O": "508113",
      "Valigonda S.O": "508112"
    },
    "MEDAK": {
      "Mallampet BO": "502303",
      "Malyal BO": "502102",
      "Ratnapur B.O": "502313",
      "Narlapur BO": "502102",
      "CHANDUR B.O": "502314",
      "Machapur B.O": "531149",
      "Chelmeda B.O": "502102",
      "Kondapur BO": "502102",
      "Kalwakunta B.O": "502102",
      "Rayalapur B.O": "502102",
      "Chevella B.O": "502269",
      "Bodamatpally B.O": "502269",
      "Yelmakanna B.O": "502316",
      "Peddachintakunta B.O": "502313",
      "Kagazmaddur B.O": "502313",
      "Lingampalli B.O": "502290",
      "Gajwada B.O": "502290",
      "Jukal B.O": "502271",
      "Makta Laxmapur B.O": "502271",
      "Shankarampet Bazar B.O": "502271",
      "Cheelpechedu B.O": "502314",
      "Pillutla B.O": "502313",
      "Rustumpet B.O": "502313",
      "R ITIKYAL BO": "502290",
      "Uthloor B.O": "502271",
      "Faizabad B.O": "502314",
      "Naskal B.O": "502102",
      "Muslapur B.O": "502269",
      "Peddapur B.O": "502270",
      "Kanchanpally B.O": "502316",
      "Tunki B.O": "502316",
      "Chinnagottimukla B.O": "502313",
      "Peddagottimukla B.O": "502313",
      "Gomaram B.O": "502313",
      "Gottimukla B.O": "502290",
      "Moosapet B.O": "502313",
      "Ajjamarry B.O": "502314",
      "Gangapur B.O": "502115",
      "Reddipally B.O": "502255",
      "Suraram B.O": "502255",
      "Rajpet B.O": "502113",
      "Manepally B.O": "502109",
      "Ananthasagar B.O": "502247",
      "Chandaipet B.O": "502247",
      "Shankarampet B.O": "502248",
      "Lingaipally B.O": "502303",
      "Laxminagar B.O": "502125",
      "Banda Posanipally B.O": "502117",
      "M.Bhupathipur B.O": "502117",
      "S. Kondapur B.O": "502117",
      "Kulcharam B.O": "502381",
      "Wariguntham B.O": "502381",
      "Yenagandla B.O": "502381",
      "Elakurthy B.O": "502302",
      "Bodagattu B.O": "502302",
      "Yelapgonda B.O": "502302",
      "Shivampet B.O": "502334",
      "Chilver B.O": "502269",
      "Kusangi B.O": "502270",
      "Chitkul B.O": "502270",
      "Khajipet B.O": "502316",
      "Mohammed Nagar B.O": "502316",
      "Mutrajpally B.O": "502316",
      "Lingapur B.O": "502313",
      "Cheelapalli B.O": "502271",
      "Tenkati B.O": "502271",
      "Sommakkapet B.O": "502314",
      "Dongala Dharmaram B.O": "502102",
      "Konapur BO": "502102",
      "Brahamanpally B.O": "502334",
      "Nagasanipally B.O": "502331",
      "Kodapaka B.O": "502331",
      "Venkatapur B.O": "502117",
      "Pambanda B.O": "502334",
      "Kurthiwada B.O": "502331",
      "Boguda Bhupathipur B.O": "502113",
      "Manoharabad B.O": "502336",
      "Parikibanda B.O": "502336",
      "Ravelli B.O": "502336",
      "Perur B.O": "502109",
      "Mangalparthy B.O": "502109",
      "Kunthanpally B.O": "502335",
      "Gunreddipally B.O": "502335",
      "Nagulapally B.O": "502313",
      "Mirzapally B.O": "502248",
      "Palvancha B.O": "502302",
      "Donthi B.O": "502334",
      "Ghanpur B.O": "502334",
      "Laxmapur B.O": "502115",
      "Chinna Shivnoor B.O": "502255",
      "Uppu Lingapur B.O": "502255",
      "Yeldurthy B.O": "502255",
      "Burugupally B.O": "502113",
      "Pathur BO": "502113",
      "Kuchavaram B.O": "502336",
      "Fareedpur B.O": "502130",
      "Toguta B.O": "502130",
      "Amsanipally B.O": "502109",
      "Rampur B.O": "502109",
      "Ryalamagudu B.O": "502109",
      "BONAL BO": "502247",
      "Islampur B.O": "502335",
      "Zapthi Shivnoor B.O": "502248",
      "Gavvalapally B.O": "502248",
      "Madur B.O": "502248",
      "Bujrampet B.O": "502381",
      "Sangaipet B.O": "502381",
      "Arkela B.O": "502302",
      "Dhanoora B.O": "502302",
      "Mupparam B.O": "502302",
      "Chandi B.O": "502334",
      "Katrial B.O": "502115",
      "Thonigandla B.O": "502115",
      "Daripally B.O": "502255",
      "Wadiaram B.O": "502255",
      "Nagapuram B.O": "502113",
      "Ausulapally B.O": "502113",
      "Timmaipally B.O": "502113",
      "Maddulwai B.O": "502130",
      "Sardana B.O": "502130",
      "M. Jalalpur. B.O": "502109",
      "Kuknoor B.O": "502109",
      "Pothamshettipally B.O": "502109",
      "Ibrahimpur B.O": "502247",
      "Khajapur B.O": "502248",
      "Yellapur B.O": "502125",
      "Settipally Kalan B.O": "502117",
      "Kongal Ghanpur B.O": "502381",
      "Paitara B.O": "502381",
      "Bacharam B.O": "502302",
      "Kadloor B.O": "502302",
      "Tampulur B.O": "502302",
      "Kothapalli B.O": "502331",
      "Chandampet BO": "502255",
      "rayalapur B.O": "502316",
      "Medak H.O": "502110",
      "Akkannapet S.O": "502115",
      "Chegunta S.O": "502255",
      "Haveli Ghanpur S.O": "502113",
      "Kadlakal S.O": "502336",
      "Alladurg S.O": "502269",
      "Regode S.O": "502290",
      "Narsapur S.O": "502313",
      "Shankarampet S.O": "502271",
      "Kowdipally S.O": "502316",
      "Medak Buss stand S.O": "502110",
      "Papannapet S.O": "502303",
      "Nizampet S.O": "502102",
      "Kuchanpally S.O": "502130",
      "Masaipet S.O": "502335",
      "Narsingee S.O": "502248",
      "Machavaram S.O": "502109",
      "Medak Town S.O": "502110",
      "Podichanpally S.O": "502125",
      "Ramayampet S.O": "502101",
      "Rangampet S.O": "502381",
      "Tekmal S.O": "502302",
      "Makkarajpet S.O": "502247",
      "Rajpally S.O": "502117",
      "Toopran S.O": "502334",
      "Yousufpet S.O": "502331"
    },
    "NALGONDA": {
      "Damera Bhimanapalli B.O": "508245",
      "Narsinghpatla B.O": "508244",
      "Tallavellamla B.O": "508244",
      "Peddapuram B.O": "508373",
      "Teppelaneni  Gouraram B.O": "508373",
      "Velmakanne B.O": "508253",
      "Chalmeda B.O": "508253",
      "Madayadavally B.O": "508254",
      "Yellareddiguda B.O": "508254",
      "Utlapally B.O": "508266",
      "Medavaram B.O": "508266",
      "Dandampalli B.O": "508002",
      "Kanchanpalli B.O": "508002",
      "Junuthala B.O": "508256",
      "NADIKUDA B.O": "508256",
      "Pochampalli Devarakonda": "508256",
      "Thenepalli B.O": "508256",
      "Aitipamula B.O": "508205",
      "Bollepally B.O": "508205",
      "Chandanapally B.O": "508205",
      "Parada B.O": "508205",
      "Chandupatla B.O": "508211",
      "Gorankalapally B.O": "508211",
      "Suraram B.O": "508211",
      "Tatikal B.O": "508211",
      "Gudivada B.O": "508211",
      "Thungathurthy B.O": "508211",
      "Gurajala B.O": "508210",
      "Manimadde B.O": "508210",
      "Itukula Pahad B.O": "508210",
      "Akaram B.O": "508210",
      "Regatta B.O": "508255",
      "Gundrepalli B.O": "508255",
      "Narmata B.O": "508255",
      "Gadiagouraram B.O": "508250",
      "Injamur B.O": "508250",
      "Kurmedu B.O": "508250",
      "Sivaneniguda B.O": "508114",
      "Yelkatta B.O": "508114",
      "Gundrampalli B.O": "508114",
      "Chitriala B.O": "508248",
      "Iddampalli B.O": "508248",
      "Perval B.O": "508248",
      "Tadkol B.O": "508248",
      "Teldevarapally B.O": "508248",
      "Bollanpalli B.O": "508258",
      "Goanbowinpalli B.O": "508258",
      "Rahamanthapur B.O": "508258",
      "Mosangi B.O": "508257",
      "Tirmalgiri B.O": "508377",
      "Chalakurthi B.O": "508202",
      "Azmapur B.O": "508243",
      "Chintakuntla B.O": "508243",
      "Duggiala B.O": "508243",
      "Yergandlapalli B.O": "508245",
      "Nerellapally B.O": "508245",
      "Polepalli Ramnagar B.O": "508245",
      "Vattapalli B.O": "508245",
      "Gudapur B.O": "508244",
      "Ookondi B.O": "508244",
      "Pulipalupula B.O": "508244",
      "Palvela B.O": "508244",
      "Medlavai B.O": "508373",
      "Amanbole B.O": "508254",
      "Pallepahad B.O": "508254",
      "Vattimarthi B.O": "508254",
      "Cherlapalli B.O": "508002",
      "Kakulakondaram B.O": "508002",
      "Amangal B.O": "508374",
      "Cheruvupally B.O": "508374",
      "Indugula B.O": "508374",
      "Pamulapahad B.O": "508374",
      "Agamothkur B.O": "508374",
      "Chervuannaram B.O": "508205",
      "Kurumarthy B.O": "508205",
      "Chandampally B.O": "508211",
      "Cherukupally B.O": "508211",
      "Inupamula B.O": "508211",
      "Kethepally": "508211",
      "Adloor B.O": "508210",
      "Damera B.O": "508245",
      "Thirgallapalli B.O": "508245",
      "Venkate swara Nagar B.O": "508245",
      "Kondapuram B.O": "508244",
      "Gatlamallepally B.O": "508373",
      "Pasnur B.O": "508373",
      "Vaddepally B.O": "508373",
      "Chillapur B.O": "508253",
      "Ghatuppal B.O": "508253",
      "Sivannaguda B.O": "508245",
      "Dugenevally B.O": "508205",
      "Eduloor B.O": "508205",
      "Kadaparthy B.O": "508210",
      "Chittaloor B.O": "508210",
      "Uppalancha B.O": "508210",
      "Ananthampet B.O": "508245",
      "Indurthi B.O": "508245",
      "Kudabakshpalli B.O": "508245",
      "Lankalpalli B.O": "508245",
      "Bodangaparthi B.O": "508244",
      "Domalpalli B.O": "508244",
      "Kompally B.O": "508377",
      "Venkatampet B.O": "508373",
      "Akkinepally B.O": "508254",
      "Parvedula B.O": "508266",
      "POTHANOOR B.O": "508266",
      "Kesarajupally B.O": "508002",
      "Marriguda B.O": "508002",
      "Pangal B.O": "508002",
      "Koppole B.O": "508256",
      "Chepuru B.O": "508256",
      "Thanedarpalli B.O": "508256",
      "CHAMALAPALLY B.O": "508256",
      "Annerparthy B.O": "508254",
      "Cherughatt B.O": "508254",
      "Nemmani B.O": "508254",
      "Tondalvai B.O": "508254",
      "Thungathurthi B.O": "508266",
      "Pulcherla B.O": "508266",
      "Sirsangandla B.O": "508266",
      "Teppalamadugu B.O": "508266",
      "Velmaguda B.O": "508266",
      "Appajipet B.O": "508002",
      "Pagidimarri B.O": "508004",
      "Cherla Gowravaram B.O": "508004",
      "Dorepally B.O": "508004",
      "Shapally B.O": "508205",
      "Munukuntla B.O": "508205",
      "Bandapalem B.O": "508211",
      "Bopparam B.O": "508211",
      "Marrur B.O": "508211",
      "Nomula B.O": "508211",
      "Ogodu B.O": "508211",
      "Pittalaguda B.O": "508256",
      "Ramagiri B.O": "508210",
      "Utkoor B.O": "508278",
      "Wangamarthy B.O": "508210",
      "Korlapahad B.O": "508211",
      "Kothapeta B.O": "508211",
      "Mangalapally B.O": "508211",
      "Koppolu B.O": "508376",
      "Bhairavanibanda B.O": "508210",
      "Perkakondaram B.O": "508210",
      "Shaligouraram B.O": "508210",
      "Madharam Kalan B.O": "508210",
      "G.Aeroli B.O": "508255",
      "Kanagal B.O": "508255",
      "Kastala B.O": "508255",
      "Pangode B.O": "508255",
      "Pullemla B.O": "508255",
      "Takkallapalli B.O": "508250",
      "Aipur B.O": "508114",
      "Mandra B.O": "508114",
      "Perepalli B.O": "508114",
      "Kistapur B.O": "508114",
      "Sunkenapally B.O": "508252",
      "Gottimukla B.O": "508248",
      "Kacharajupally B.O": "508248",
      "Konda Bhimanpalli B.O": "508248",
      "Murupunutala B.O": "508248",
      "Pogilla B.O": "508248",
      "Seripalli B.O": "508248",
      "Polepalli B.O": "508248",
      "Kambalapally B.O": "508248",
      "Mududandla B.O": "508258",
      "Vavikole B.O": "508258",
      "Veeraboinapally B.O": "508258",
      "Yerraram B.O": "508258",
      "Thaukalpur B.O": "508258",
      "Chilkamarri B.O": "508257",
      "Shagazipur B.O": "508257",
      "Sultanpur B.O": "508257",
      "Vijayapuri North B.O": "508202",
      "Pedda Adisarlapally B.O": "508243",
      "Thummlapally B.O": "508255",
      "Bangarigadda B.O": "508208",
      "Idukuda B.O": "508255",
      "Kurmapalli B.O": "508250",
      "Madnapur B.O": "508250",
      "Peddakaparthi B.O": "508114",
      "Urumadla B.O": "508114",
      "Vanipakala B.O": "508114",
      "Gagillapur B.O": "508248",
      "Padmatpalli B.O": "508248",
      "Shakewalli B.O": "508248",
      "Toorapalli B.O": "508248",
      "Mallareddipalli B.O": "508248",
      "Thimmapur B.O": "508248",
      "Kamepalli B.O": "508258",
      "Bogguladinne B.O": "508258",
      "Chamdampet B.O": "508258",
      "Cherkupalli B.O": "508258",
      "Kandkoor B.O": "508258",
      "Tippalnenigouraram B.O": "508258",
      "Gummadvelli B.O": "508257",
      "Palwai B.O": "508257",
      "Rajawaram B.O": "508377",
      "Alwal B.O": "508377",
      "Chinthalapalem B.O": "508202",
      "Banda Timmapuram B.O": "508243",
      "Vaddipatla B.O": "508243",
      "Vattikode B.O": "508255",
      "Angadipet B.O": "508255",
      "Bommakal B.O": "508374",
      "Regulagadda B.O": "508278",
      "Tummadam B.O": "508278",
      "Kamareddigudem B.O": "508278",
      "Alagadapa B.O": "508208",
      "Devulapally Kalan B.O": "508208",
      "Matoor B.O": "508208",
      "Nandipahad B.O": "508208",
      "Rayini Palem B.O": "508208",
      "Veerlapalem B.O": "508208",
      "Gudur B.O": "508208",
      "Sarvaram B.O": "508247",
      "Pajjur B.O": "508247",
      "Nasarlapalli B.O": "508250",
      "Nerada B.O": "508114",
      "Velmined B.O": "508114",
      "Brahmana Vellemla B.O": "508114",
      "Kaparthi Khurd B.O": "508114",
      "Kothapalli B.O": "508248",
      "Neredgum B.O": "508248",
      "Peddamungal B.O": "508248",
      "Mudigonda B.O": "508248",
      "Khanapur B.O": "508258",
      "Ganpellibhimanpally B.O": "508257",
      "Ghanpur B.O": "508257",
      "Anumula B.O": "508377",
      "Marepalli B.O": "508377",
      "Ragundala B.O": "508377",
      "Yacharam B.O": "508377",
      "Perur B.O": "508377",
      "Nellikal B.O": "508202",
      "Pendlipakla B.O": "508243",
      "Borraipalem B.O": "508355",
      "Bheemavaram B.O": "508374",
      "Bokkamunthalapahad B.O": "508278",
      "Hazarigudem B.O": "508278",
      "Mukundapuram B.O": "508278",
      "Rajannagudem B.O": "508278",
      "Marapaka B.O": "508278",
      "Adavidevulapally B.O": "508208",
      "Anjanapally B.O": "508208",
      "Molkacharla B.O": "508208",
      "Thungapahad B.O": "508208",
      "Venkatadripalem B.O": "508208",
      "Mushampally B.O": "508247",
      "Mamidyala B.O": "508247",
      "Tadakamalla B.O": "508217",
      "Settipalem B.O": "508217",
      "Duggepally B.O": "508278",
      "Muppavaram B.O": "508278",
      "Ramadugu B.O": "508278",
      "Vempahad B.O": "508278",
      "Amruth Nagar B.O": "508208",
      "Babasahebpet B.O": "508208",
      "Chennaipalem B.O": "508208",
      "Sanjaynagar B.O": "508208",
      "Koratkal B.O": "508244",
      "Devathapalli B.O": "508243",
      "Mustipalli B.O": "508243",
      "Takkellapahad B.O": "508208",
      "Tripuraram B.O": "508208",
      "Rudraram B.O": "508208",
      "Indloor B.O": "508247",
      "Chetlachennaram B.O": "508247",
      "Chinnamadharam B.O": "508247",
      "Topucharla B.O": "508217",
      "Kondrapole B.O": "508355",
      "Damaracherla B.O": "508355",
      "Chirumarthy B.O": "508374",
      "Kannekal B.O": "508374",
      "Salkunoor B.O": "508374",
      "Annaram B.O": "508278",
      "Yerrabally B.O": "508278",
      "Narammagudem B.O": "508278",
      "Ibrahimpet B.O": "508278",
      "Keshavapuram B.O": "508208",
      "Ragadapa B.O": "508208",
      "Yadgarpally B.O": "508208",
      "Utlapalli B.O": "508208",
      "Jangareddygudem B.O": "508247",
      "Rajupeta B.O": "508247",
      "Kukkadam B.O": "508217",
      "Molkapatnam B.O": "508217",
      "Ravulapenta B.O": "508217",
      "Dilawarpur B.O": "508355",
      "Chikatimamidi B.O": "508244",
      "Nalgonda H.O": "508001",
      "Miryalguda H.O": "508207",
      "Madgulapally S.O": "508374",
      "Nakrekal S.O": "508211",
      "Vallala S.O": "508210",
      "Nidamanoor S.O": "508278",
      "Thipparthi S.O": "508247",
      "Kattangur S.O": "508205",
      "NSP Camp Miryalaguda S.O": "508208",
      "Vemulapally S.O": "508217",
      "Wadapally S.O": "508355",
      "Chintapalli S.O": "508250",
      "Halia S.O": "508377",
      "Oldabadi S.O": "508001",
      "Clocktower S.O": "508001",
      "Kondamallepalli S.O": "508243",
      "Manyamchalka S.O": "508001",
      "Munugode S.O": "508244",
      "Narkatpalli S.O": "508254",
      "Powerhousehostel S.O": "508202",
      "S.L.B.C Campcolny Gandamvarigudem S.O": "508004",
      "Gurrampode S.O": "508256",
      "Chityala S.O": "508114",
      "Devarkonda S.O": "508248",
      "Gudipally S.O": "508257",
      "Bottuguda S.O": "508001",
      "Chandur S.O": "508255",
      "Dindi Project S.O": "508258",
      "Gandhinagar S.O": "508248",
      "Hillcolony S.O": "508202",
      "Marriguda S.O": "508245",
      "Nampalli S.O": "508373",
      "Pedavoora S.O": "508266",
      "Ramagiri S.O": "508002"
    },
    "JANGOAN": {
      "Rangapur B.O": "506318",
      "Kondapur B.O": "506145",
      "Chennur B.O": "506222",
      "Edunuthala B.O": "506222",
      "Visnoor B.O": "506222",
      "Walmidi B.O": "506222",
      "Regula B.O": "506317",
      "Oblapur B.O": "506316",
      "Thammadapalli B.O": "506143",
      "Kantharamavaram B.O": "506222",
      "Mutharam B.O": "506222",
      "Dardepalli B.O": "506316",
      "Manchuppal B.O": "506222",
      "Pakhal B.O": "506222",
      "Mallampally B.O": "506317",
      "Vavila B.O": "506317",
      "Kanchanpalli B.O": "506244",
      "Sreepathipalli B.O": "506145",
      "Venkeswaraswamygutta B.O": "506145",
      "Itikalapalli B.O": "506221",
      "Alimpur B.O": "506221",
      "Kesireddypalli B.O": "506221",
      "Kothapalli B.O": "506303",
      "Raghavapur B.O": "506301",
      "Salvapur B.O": "506223",
      "Lingampalli B.O": "506145",
      "Dharmapuram B.O": "506302",
      "Kamareddigudem B.O": "506302",
      "Kunur B.O": "506143",
      "Nemiligonda B.O": "506143",
      "Kurchapalli B.O": "506252",
      "Timmapuram B.O": "506316",
      "Chilpur B.O": "506145",
      "Rajavaram B.O": "506144",
      "Chinnapendyal B.O": "506144",
      "Naskal B.O": "506144",
      "Pallagutta B.O": "506144",
      "Obulkeshavapur B.O": "506221",
      "Peddaramancherla B.O": "506221",
      "Pochannapet B.O": "506221",
      "Veldanda B.O": "506221",
      "Tatikonda B.O": "506301",
      "Krishnajigudem B.O": "506301",
      "Meedikonda B.O": "506301",
      "Laxmakkapalli B.O": "506302",
      "Kadavendi B.O": "506302",
      "Madhapur B.O": "506302",
      "Raghunathpalli B.O": "506143",
      "Tanedarpalli B.O": "506143",
      "Konney B.O": "506221",
      "Nagireddipalli B.O": "506221",
      "Abdulnagaram B.O": "506145",
      "Venkatadripet B.O": "506145",
      "Dabbakunta Palli B.O": "506221",
      "Tammadapalli B.O": "506221",
      "Fatheshapur B.O": "506244",
      "China Raman Cherla B.O": "506221",
      "Kodavatur B.O": "506221",
      "Fathepur B.O": "506301",
      "Padamatikeshavapur B.O": "506223",
      "Shatapur B.O": "506302",
      "Torrur B.O": "506302",
      "Pamnoor B.O": "506143",
      "Shivunipalli B.O": "506143",
      "Govardanagiri B.O": "506301",
      "Hanumanthapur B.O": "506175",
      "Peddapahad B.O": "506175",
      "Yerragolla Pahad B.O": "506175",
      "Adavikeshvapur B.O": "506175",
      "Narsapur B.O": "506224",
      "Tharigoppula B.O": "506224",
      "Bandanagaram B.O": "506224",
      "Lingala Ghanpur B.O": "506201",
      "Mekhal Ghat B.O": "506244",
      "Nidigonda B.O": "506244",
      "Gabbeta B.O": "506244",
      "Mandelagudem B.O": "506244",
      "Ramarajpalli B.O": "506303",
      "Cheetur B.O": "506303",
      "Nelapogula B.O": "506303",
      "Waddicherla B.O": "506303",
      "Gollapalli B.O": "506302",
      "Seetarampur B.O": "506302",
      "Teegaram B.O": "506143",
      "Thimmampet B.O": "506143",
      "Uppugal B.O": "506143",
      "Viswanathapur B.O": "506143",
      "Bommera B.O": "506252",
      "Gudur B.O": "506252",
      "Chitakodur B.O": "506175",
      "Vadlakonda B.O": "506175",
      "Jeedikal B.O": "506201",
      "Siripuram B.O": "506201",
      "Yellamula B.O": "506201",
      "Gummadavalli B.O": "506201",
      "Iravennur B.O": "506244",
      "Manchupahad B.O": "506244",
      "Mangal Banda Thanda B.O": "506244",
      "Kolkonda B.O": "506303",
      "Kundaram B.O": "506303",
      "Kodur B.O": "506303",
      "Marudkalan B.O": "506303",
      "Gangupahad B.O": "506175",
      "Shamirpet B.O": "506175",
      "Yenkiryal B.O": "506175",
      "Yeswantapur B.O": "506175",
      "Solipuram B.O": "506367",
      "Katkur B.O": "506224",
      "Pasaramadla B.O": "506201",
      "Siddanki B.O": "506201",
      "Komandla B.O": "506244",
      "Singarajpalli B.O": "506303",
      "Nirmal B.O": "506303",
      "Wanaparthy B.O": "506303",
      "Marigadi B.O": "506175",
      "Narmetta B.O": "506175",
      "Nellutla B.O": "506175",
      "Ankushapur B.O": "506367",
      "Akkarajpalli B.O": "506224",
      "Ammapur B.O": "506224",
      "Kalyam B.O": "506201",
      "Narayanpur B.O": "506244",
      "Quilashapur B.O": "506244",
      "Veldi B.O": "506244",
      "Aswaraopalli B.O": "506244",
      "Ibrahimpur B.O": "506244",
      "Appireddipalli B.O": "506303",
      "Marudhkard B.O": "506303",
      "Ramachandrapuram B.O": "506221",
      "Banjipet B.O": "506244",
      "Samudrala B.O": "506252",
      "Gangapur B.O": "506221",
      "Mondrai B.O": "506302",
      "Kodakondla S.O": "506222",
      "Zaffargadh S.O": "506316",
      "Jangaon H.O": "506167",
      "Ippaguda S.O": "506252",
      "Waddicherla Nawabpet S.O": "506303",
      "Malkapur S.O": "506145",
      "Jangaon Bazar S.O": "506175",
      "Raghunath Pally S.O": "506244",
      "Devaruppal S.O": "506302",
      "Ghanpur Station S.O": "506143",
      "Pembarthy S.O": "506201",
      "Abadighanpur S.O": "506144",
      "Buchannapet S.O": "506221",
      "Chagal S.O": "506301",
      "Palakurthy S.O": "506146"
    },
    "MAHABUBNAGAR": {
      "Janampet B.O": "509382",
      "Kothamolgara B.O": "509382",
      "Jingirala B.O": "509204",
      "Nagaram B.O": "509204",
      "Baswaipalli B.O": "509204",
      "Kotakadra B.O": "509204",
      "Buddaram B.O": "509334",
      "Gundiyal B.O": "509334",
      "Kongat Pally B.O": "509334",
      "Advi Venkatapur B.O": "509002",
      "Boyapally B.O": "509002",
      "Yenugonda B.O": "509002",
      "Vinjamur B.O": "509371",
      "Parpally B.O": "509371",
      "Pathamolgara B.O": "509382",
      "Pedda Mungalched B.O": "509382",
      "Ponnakallu B.O": "509382",
      "Chowdur B.O": "509202",
      "Amistapur B.O": "509382",
      "Addakal B.O": "509382",
      "Mothighanapur B.O": "509202",
      "Kollur B.O": "509202",
      "Kandur B.O": "509382",
      "Manikonda B.O": "509204",
      "Machanpalli B.O": "509204",
      "Koilsagar B.O": "509204",
      "Chinnadarpalli B.O": "509334",
      "Ibrahimbad B.O": "509334",
      "Yedira B.O": "509002",
      "Kodur B.O": "509002",
      "Malkapuram B.O": "509371",
      "Seri Venkatapur B.O": "509371",
      "Tatikonda B.O": "509382",
      "Gaddegudem B.O": "509204",
      "Pedda Darpally B.O": "509334",
      "Tankara B.O": "509334",
      "Munimoksham B.O": "509334",
      "Vepur B.O": "509334",
      "Dharmapur B.O": "509002",
      "Palkonda B.O": "509002",
      "Ankilla B.O": "509371",
      "Chandraspalli B.O": "509371",
      "Kothlabad B.O": "509371",
      "Kazipur B.O": "509371",
      "Suraram B.O": "509371",
      "Rachala B.O": "509219",
      "Varne B.O": "509219",
      "Annasagar B.O": "509382",
      "Polkampally B.O": "509382",
      "Pothulmadugu B.O": "509382",
      "Gajulapet B.O": "509382",
      "Chowdarpalli B.O": "509204",
      "Dokur B.O": "509204",
      "Bandamedipally B.O": "509002",
      "Kothapet B.O": "509002",
      "Pagidial B.O": "509371",
      "Garlapahad B.O": "509371",
      "Rampur B.O": "509371",
      "Vennached B.O": "509339",
      "Undiyal B.O": "509130",
      "Perur B.O": "509219",
      "Pallamarri B.O": "509409",
      "Waddeman B.O": "509409",
      "Julapalli B.O": "509337",
      "Komireddi Pally B.O": "509337",
      "Kondapur B.O": "509340",
      "Bandarpally B.O": "509409",
      "Fareedpur B.O": "509409",
      "Nellikondi B.O": "509409",
      "Gurakonda B.O": "509409",
      "Salkarpet B.O": "509337",
      "Shaik Pally B.O": "509337",
      "Venkatreddypally B.O": "509337",
      "Laxmipally B.O": "509380",
      "Vemula B.O": "509357",
      "Fathepur B.O": "509340",
      "Chinta Kunta Kurd B.O": "509131",
      "Rajapur B.O": "509202",
      "Udithyala B.O": "509202",
      "Yemmajipur B.O": "509202",
      "Gunded B.O": "509202",
      "Kucherkal B.O": "509202",
      "Pomal B.O": "509202",
      "Rangareddyguda B.O": "509202",
      "Wadiyala B.O": "509357",
      "Chilvera B.O": "509357",
      "Kottooru B.O": "509357",
      "Kodgal B.O": "509302",
      "Tatiparthi B.O": "509302",
      "Gangapuram B.O": "509302",
      "Peddarevalli B.O": "509408",
      "Ayyavaripalli B.O": "509357",
      "Donur B.O": "509357",
      "Koukunt R.S. B.O": "509219",
      "Muchintala B.O": "509219",
      "Rekulampalli B.O": "509219",
      "Peddaadiryala B.O": "509408",
      "Chinnarevalli B.O": "509408",
      "Edganpalli B.O": "509302",
      "Karvena B.O": "509302",
      "Malleboinpalli B.O": "509302",
      "Gollapalli B.O": "509302",
      "Polepalli B.O": "509302",
      "Valloor B.O": "509302",
      "Damganpur B.O": "509409",
      "Gandwed B.O": "509337",
      "Ammapur B.O": "509110",
      "Maddur B.O": "509110",
      "Appampally B.O": "509110",
      "C.Thirumalapuram B.O": "509110",
      "Yelkacherla B.O": "509406",
      "Allipur B.O": "509110",
      "Peddawarval B.O": "509335",
      "Mangampet B.O": "509337",
      "Nancherla B.O": "509337",
      "Lingampaly B.O": "509340",
      "Thirmalapur B.O": "509340",
      "Ippatur B.O": "509340",
      "Kanmankalwa B.O": "509340",
      "Karkonda B.O": "509340",
      "Karur B.O": "509340",
      "Kuchur B.O": "509340",
      "Vaspul B.O": "509357",
      "Boinpalli B.O": "509357",
      "Kothapalli B.O": "509357",
      "Nasarullabad B.O": "509302",
      "Nerallapalli B.O": "509302",
      "Kakarlapahad B.O": "509340",
      "Yanmangandla B.O": "509340",
      "Gurukunta B.O": "509340",
      "Kanmanoor B.O": "509381",
      "Maddigatal B.O": "509406",
      "Gopanpally B.O": "509219",
      "Bhutpur S.O": "509382",
      "Lalkot S.O": "509409",
      "Mbn Rs S.O": "509001",
      "Mohammadabad S.O": "509337",
      "Osmangunj S.O": "509001",
      "Mahabubnagar H.O": "509001",
      "Koukuntla S.O": "509219",
      "Hanumanpura S.O": "509001",
      "Hunwada S.O": "509334",
      "Koilkonda S.O": "509371",
      "Devarkadra S.O": "509204",
      "Ind. Estate S.O": "509002",
      "Musapet S.O": "509380",
      "Nawabpet S.O": "509340",
      "Stn. Jadcherla H.O": "509301",
      "Veerannapet S.O": "509001",
      "Pathapalamur S.O": "509001",
      "T.D. Gutta S.O": "509001",
      "Town Jadcherla S.O": "509302",
      "Balanagar S.O": "509202",
      "Midjil S.O": "509357"
    },
    "Narayanpet": {
      "Bapanpally B.O": "509407",
      "Kamsanpally B.O": "509407",
      "Malreddy Pally B.O": "509407",
      "Wathugundla B.O": "509407",
      "Gotur B.O": "509204",
      "Kistapur B.O": "509204",
      "Jatram Kalan B.O": "509205",
      "Polepally B.O": "509350",
      "Kachwar B.O": "509353",
      "Patherched B.O": "509353",
      "Raikode B.O": "509353",
      "Kondapuram B.O": "509371",
      "Togapur B.O": "509339",
      "Chennaram B.O": "509339",
      "Kulpur B.O": "509352",
      "Hindupur B.O": "509352",
      "Tangadgi B.O": "509352",
      "Kankurthy B.O": "509407",
      "Lokurthy B.O": "509407",
      "Udamalgidda B.O": "509407",
      "Gudigandla B.O": "509205",
      "Mandipalli B.O": "509205",
      "Bhutpur B.O": "509353",
      "Chandravancha B.O": "509339",
      "Mirzapur B.O": "509339",
      "Mudmal B.O": "509352",
      "Kothapally B.O": "509411",
      "Kandanpally B.O": "509407",
      "Narsapur B.O": "509407",
      "Annasagar B.O": "509407",
      "Pusalpahad B.O": "509204",
      "Kollampalli B.O": "509205",
      "Bijwar B.O": "509205",
      "Nidgurthy B.O": "509205",
      "Rampur B.O": "509353",
      "Undekode B.O": "509353",
      "Gokul Nagar B.O": "509371",
      "Pothreddipalli B.O": "509339",
      "Bhogaram B.O": "509339",
      "Sarzakhanpet B.O": "509339",
      "Gudeballur B.O": "509352",
      "Narva B.O": "509130",
      "Bommanpad B.O": "509407",
      "Gudimunkan Pally B.O": "509407",
      "Kyathanpally B.O": "509407",
      "Chinna Jatram B.O": "509205",
      "Gunumukla B.O": "509205",
      "Hakeempet B.O": "509350",
      "Manthan Gode B.O": "509353",
      "Pulimamidi B.O": "509353",
      "Mushrifa B.O": "509339",
      "Gundumal B.O": "509339",
      "Alampally B.O": "509352",
      "Chegunta B.O": "509352",
      "Kunsi B.O": "509352",
      "Jinnaram B.O": "509409",
      "Nidijinta B.O": "509411",
      "Dasardoddi B.O": "509208",
      "Mustipalli B.O": "509208",
      "Eligandla B.O": "509351",
      "Kotakonda B.O": "509210",
      "Bhairamkonda B.O": "509210",
      "Chittanur B.O": "509409",
      "Pallerla B.O": "509411",
      "Pedripadu B.O": "509411",
      "Kalwal B.O": "509208",
      "Satyawar B.O": "509208",
      "Ujjali B.O": "509208",
      "Wadwat B.O": "509208",
      "Sangambanda B.O": "509208",
      "Neredgaon B.O": "509208",
      "Madhwar B.O": "509311",
      "Appareddipalli B.O": "509210",
      "Abhangapur B.O": "509210",
      "Amdipur B.O": "509210",
      "Yamki B.O": "509130",
      "Kadmoor B.O": "509130",
      "Lankal B.O": "509130",
      "Renwatla B.O": "509411",
      "Bhuneed B.O": "509411",
      "Dorepally B.O": "509411",
      "Damganpur B.O": "509411",
      "Chityala B.O": "509208",
      "Rudrasamudram B.O": "509208",
      "Anugonda B.O": "509208",
      "Warkur B.O": "509208",
      "Theelair B.O": "509351",
      "Kanmanur B.O": "509351",
      "Pagdimarri B.O": "509210",
      "Perapalla B.O": "509210",
      "Singwar B.O": "509210",
      "Jajapur B.O": "509210",
      "Mogalmadka B.O": "509336",
      "Edavally B.O": "509311",
      "Kollur B.O": "509311",
      "P.C.Kunta B.O": "509409",
      "Rakonda B.O": "509409",
      "Chandapur B.O": "509208",
      "Maganur B.O": "509208",
      "Panchalingal B.O": "509208",
      "Panchdev Pahad B.O": "509208",
      "Karne B.O": "509208",
      "Ibrahimpatnam B.O": "509351",
      "Jalalpur B.O": "509210",
      "Thirumalapur B.O": "509210",
      "Peddaporla B.O": "509311",
      "Lingampally B.O": "509311",
      "Chinnaporla B.O": "509311",
      "Tipraspally B.O": "509311",
      "Vithalapuram B.O": "509336",
      "Mallepalli B.O": "509311",
      "Damargidda S.O": "509407",
      "Makthal S.O": "509208",
      "Marrikal S.O": "509351",
      "Kosgi S.O": "509339",
      "Krishna S.O": "509352",
      "Maddur S.O": "509411",
      "Narayanpet Bazar S.O": "509210",
      "Dhanwada S.O": "509205",
      "Jaklair S.O": "509353",
      "Narayanpet S.O": "509210",
      "Utkur S.O": "509311"
    },
    "SURYAPET": {
      "Imampet B.O": "508214",
      "Penpahad B.O": "508214",
      "Raghavapuram B.O": "508214",
      "Vatti Khammam Pahad B.O": "508214",
      "Thimmapur B.O": "508224",
      "Annaram": "508214",
      "Ameenabad B.O": "508206",
      "Dwarakunta B.O": "508206",
      "Chilkur B.O": "508206",
      "Venkatramapuram B.O": "508206",
      "Ramapuram B.O": "508246",
      "Kokkireni B.O": "508233",
      "Mukundapuram B.O": "508221",
      "Jagannadhapuram B.O": "508233",
      "Vijaya Raghavapuram B.O": "508233",
      "Cheedella B.O": "508233",
      "Edavalli B.O": "508221",
      "Chinnanemila B.O": "508221",
      "Pasunoor B.O": "508279",
      "Mothey B.O": "508212",
      "Urlugonda B.O": "508212",
      "Annaram B.O": "508280",
      "Reddygudem B.O": "508280",
      "Maddirala B.O": "508280",
      "Thonda B.O": "508223",
      "Jalalpuram B.O": "508223",
      "Nelamarry B.O": "508214",
      "Pillalamarry B.O": "508214",
      "Dharmapuram B.O": "508214",
      "Shantinagar B.O": "508206",
      "Chanupally B.O": "508206",
      "Chimiryala B.O": "508206",
      "Kalakova B.O": "508233",
      "Taduvai B.O": "508233",
      "Sreerangapuram B.O": "508234",
      "Vallapuram B.O": "508234",
      "Miryala B.O": "508221",
      "Yerrapahad B.O": "508221",
      "Aipoor B.O": "508221",
      "Chilpakuntla B.O": "508221",
      "Etoor B.O": "508279",
      "Nasimpet B.O": "508212",
      "Ravipahad B.O": "508212",
      "Tummalapenpahad B.O": "508212",
      "Vibhalapuram B.O": "508212",
      "Balemula B.O": "508376",
      "Yendlapally B.O": "508376",
      "Pinnaipalem B.O": "508376",
      "Ramaram B.O": "508376",
      "Ravulapally B.O": "508280",
      "Vempati B.O": "508280",
      "Karvirala Kothagudem B.O": "508280",
      "Velugupally B.O": "508280",
      "Velichala B.O": "508223",
      "Malipuram B.O": "508223",
      "Gaddipally B.O": "508201",
      "Lingala B.O": "508201",
      "Medaram B.O": "508201",
      "Jerripothula Gudem B.O": "508204",
      "Karakkayala Gudem B.O": "508204",
      "Bethavolu B.O": "508204",
      "Sarvaram B.O": "508204",
      "Kondapuram B.O": "508204",
      "Chintalapalem B.O": "508246",
      "Shobhanadrigudem B.O": "508246",
      "Bothalapalem B.O": "508218",
      "Janpahad B.O": "508218",
      "Bodaladinne B.O": "508218",
      "Guduguntlapalem B.O": "508218",
      "Gundlapahad B.O": "508218",
      "Gattikal B.O": "508224",
      "Patha Suryapet B.O": "508224",
      "Kasarlapahad": "508224",
      "Kandibanda B.O": "508238",
      "Kuchipudi B.O": "508238",
      "Chintalacheruvu B.O": "508214",
      "Duraj Pally B.O": "508214",
      "Enubamula B.O": "508214",
      "Gajulamalkapuram B.O": "508214",
      "Gumpula Tirumalgiri B.O": "508214",
      "Singareddy Palem B.O": "508214",
      "Talla Khammam Pahad B.O": "508214",
      "Vallabha Puram B.O": "508214",
      "Ananthagiri B.O": "508206",
      "Komarabanda B.O": "508206",
      "Jammigadda B.O": "508214",
      "Kasarabaad B.O": "508214",
      "Kuda Kuda B.O": "508214",
      "Madaram B.O": "508214",
      "Namavaram B.O": "508214",
      "Chandupatla B.O": "508221",
      "Anantharam B.O": "508214",
      "Singavaram B.O": "508206",
      "Thammara B.O": "508206",
      "Gondriyala B.O": "508206",
      "Nallabandagudem B.O": "508206",
      "Mogalaikota B.O": "508206",
      "Palavaram B.O": "508206",
      "Redlakunta B.O": "508206",
      "X Roads Kodad B.O": "508206",
      "Balajinagar B.O": "508206",
      "Akupamula B.O": "508233",
      "Tellaballi B.O": "508233",
      "Ganapavaram B.O": "508238",
      "Ratnavaram B.O": "508234",
      "Tripuravaram B.O": "508234",
      "Venugopalapuram B.O": "508234",
      "Bopparam B.O": "508221",
      "Isthalapuram B.O": "508221",
      "Patharla Pahad B.O": "508221",
      "Narayanagudem B.O": "508233",
      "Narsimhula Gudem B.O": "508233",
      "Repala B.O": "508233",
      "Kagitaramachandrapuram B.O": "508234",
      "Karivirala B.O": "508234",
      "Siripuram B.O": "508234",
      "Tallasingaram B.O": "508221",
      "Pedanemilla B.O": "508221",
      "Polumalla B.O": "508221",
      "D Kothapally B.O": "508279",
      "Parsaipally B.O": "508279",
      "Pasthala B.O": "508279",
      "Annariguda B.O": "508212",
      "Atmakur B.O": "508212",
      "Burkacharla B.O": "508212",
      "Mamillaguda B.O": "508212",
      "Kotapahad B.O": "508212",
      "Nemmikal B.O": "508212",
      "Gonrentla B.O": "508280",
      "Bikumalla B.O": "508221",
      "Lingampally B.O": "508221",
      "Wardhamankota B.O": "508279",
      "Tummagudem B.O": "508212",
      "Hussainabad B.O": "508212",
      "Rayanaguda B.O": "508376",
      "Yerkaram B.O": "508376",
      "Gummadavally B.O": "508280",
      "Kukkadam B.O": "508280",
      "Thoorpugudem B.O": "508280",
      "Gottiparthi B.O": "508280",
      "Ganugabanda": "508280",
      "Gundepuri B.O": "508223",
      "Tatipamula B.O": "508223",
      "Mamidyala": "508223",
      "Phanigiri B.O": "508279",
      "Ganugabanda B.O": "508201",
      "Rainiguda B.O": "508201",
      "Choutapally B.O": "508204",
      "Yepalasingaram B.O": "508204",
      "Gundlapally B.O": "508204",
      "Chintriyala B.O": "508246",
      "Thammavaram B.O": "508246",
      "Palakaveedu B.O": "508218",
      "Jajireddy Gudem B.O": "508224",
      "Ramachandrapuram B.O": "508224",
      "Venkepally B.O": "508224",
      "Ramalaxmipuram B.O": "508238",
      "Chivemula B.O": "508214",
      "Keethavarigudem B.O": "508201",
      "Kalmalcheruvu B.O": "508201",
      "Tallamalkapuram B.O": "508201",
      "Velidanda B.O": "508201",
      "Pedaveedu B.O": "508204",
      "Yathavakilla B.O": "508204",
      "Booruggadda B.O": "508204",
      "Lingagiri B.O": "508204",
      "Raghunadhapalem B.O": "508204",
      "Dondapadu B.O": "508246",
      "Dirsencharla B.O": "508218",
      "Somavaram B.O": "508218",
      "Sunyapahad B.O": "508355",
      "Pale Annaram B.O": "508238",
      "Togarrai B.O": "508238",
      "Anajpur B.O": "508214",
      "Anireddy Gudem B.O": "508214",
      "Bhaktalapuram B.O": "508214",
      "Ponugode B.O": "508201",
      "Lakkavaram B.O": "508204",
      "Mattampally B.O": "508204",
      "Simhapuri B.O": "508204",
      "Wardhapuram B.O": "508204",
      "Amaravaram B.O": "508204",
      "Gudimalkapuram B.O": "508246",
      "Revoor B.O": "508246",
      "Vellatoor B.O": "508246",
      "Dacharam B.O": "508218",
      "Penchikaldinne B.O": "508218",
      "Solipeta B.O": "508224",
      "Kandagatla B.O": "508224",
      "Kommala B.O": "508224",
      "Koduru B.O": "508224",
      "Kapugal B.O": "508238",
      "Erravaram B.O": "508238",
      "Suryapet H.O": "508213",
      "Huzurnagar S.O": "508204",
      "Medlacheruvu S.O": "508246",
      "Arvapalli S.O": "508224",
      "Gudibanda S.O": "508238",
      "Sirikonda S.O": "508212",
      "Nagaram S.O": "508279",
      "Garidepally S.O": "508201",
      "Nereducharla S.O": "508218",
      "K.K.Road S.O": "508213",
      "Kodad S.O": "508206",
      "Noothankal S.O": "508221",
      "Tekumatla S.O": "508376",
      "Munagala S.O": "508233",
      "Nadigudem S.O": "508234",
      "Bank Street S.O": "508213",
      "I.E.Suryapet S.O": "508214",
      "Thungathurthi S.O": "508280",
      "Tirumalgiri S.O": "508223"
    },
    "JAYASHANKAR BHUPALAPALLY": {
      "Vadupulavancha B.O": "505503",
      "Dhanwada B.O": "505503",
      "Yedlapalli B.O": "505503",
      "Mutharam B.O": "505503",
      "Annaram B.O": "505503",
      "Bayyaram B.O": "505503",
      "Chintakani B.O": "505503",
      "Borlagudem B.O": "505503",
      "Rudraram B.O": "505503",
      "Gollabudharam B.O": "506169",
      "Tekumatla B.O": "506356",
      "Mylaram B.O": "506345",
      "Vilasagar B.O": "505503",
      "Damarkunta B.O": "505503",
      "Gangaram B.O": "505503",
      "Vallamkunta B.O": "505503",
      "Dharmaraopet B.O": "506345",
      "Kaleswaram B.O": "505504",
      "Lingal B.O": "506348",
      "Repak B.O": "506348",
      "Chalivagu Kaniparthy BO": "506348",
      "Chinnakodepak B.O": "506319",
      "Ambatpalli B.O": "505504",
      "Kondapur B.O": "506345",
      "Kothapalli Gori BO": "506348",
      "Kothapalli v B.O": "506170",
      "Repakpalli B.O": "506348",
      "Ramannagudem B.O": "506348",
      "Rangaiahpalli B.O": "506348",
      "Dammannapet B.O": "506348",
      "Madthapalli B.O": "506348",
      "Bommapur B.O": "505504",
      "Mallaram B.O": "505184",
      "Peddatundla B.O": "505184",
      "Thadcherla B.O": "505184",
      "Suraram B.O": "505504",
      "Sultanpur B.O": "506348",
      "Chennapur B.O": "506319",
      "Palimela B.O": "505504",
      "Gorlavaid B.O": "506168",
      "Peddapur B.O": "506168",
      "Dubyal B.O": "506356",
      "Garimillapalli B.O": "506356",
      "Kundanpalli B.O": "506356",
      "Nawabpet B.O": "506356",
      "Ramakistapur B.O": "506356",
      "Gangireni Gudem B.O": "506348",
      "Jaggaiahpet B.O": "506348",
      "Tirumalagiri B.O": "506348",
      "Nagaram B.O": "506169",
      "Laxmareddipalli B.O": "506168",
      "Gurrampaet B.O": "506168",
      "Tirumalapur B.O": "506356",
      "Budharam B.O": "506345",
      "Chainpak B.O": "506170",
      "Metpalli B.O": "506366",
      "Motlapalli B.O": "506366",
      "Mulkalapally B.O": "506366",
      "Peddakomati Palli B.O": "506366",
      "Jhengaid B.O": "506169",
      "Kasimpalli B.O": "506169",
      "Challagarige B.O": "506356",
      "Pangidipalli B.O": "506356",
      "Rangapur B.O": "506366",
      "Ponagandla B.O": "506170",
      "Akinepalli B.O": "506366",
      "Pidicilla B.O": "506366",
      "Issipet B.O": "506366",
      "Venkatapur B.O": "506366",
      "Adavikamalapur B.O": "506169",
      "Azamnagar B.O": "506169",
      "Kompalli B.O": "506168",
      "Empaid B.O": "506356",
      "Jookal B.O": "506356",
      "Raghavareddipet B.O": "506356",
      "Bhagirathipet B.O": "506345",
      "Gopalpur B.O": "506170",
      "Jadalpet B.O": "506170",
      "Vemulapalli B.O": "506366",
      "Venkataraopalli B.O": "506356",
      "Nainpak B.O": "506170",
      "Vadthal B.O": "506170",
      "Pothugal B.O": "506366",
      "Parlapalli B.O": "506366",
      "Kodavatancha B.O": "506348",
      "KTPP S.O": "506170",
      "Mogullapalli S.O": "506366",
      "Regonda S.O": "506348",
      "Chityal S.O": "506356",
      "Bhupalapalli S.O": "506169",
      "Chelpur S.O": "506168",
      "Ghanpur  S.O": "506345",
      "Kataram S.O": "505503",
      "Mahadeopur S.O": "505504"
    },
    "Mulugu": {
      "Kondai B.O": "506165",
      "Kalvapalli B.O": "506347",
      "Lingala B.O": "506347",
      "Thimmampet B.O": "506172",
      "Narlapur B.O": "506347",
      "Rampur B.O": "506347",
      "Karlapalli B.O": "506347",
      "Oorattam B.O": "506347",
      "Rangapur Project Nagar B.O": "506347",
      "Bittupalli B.O": "506347",
      "Laknavaram B.O": "506347",
      "Medaram B.O": "506347",
      "Ramannagudem B.O": "506165",
      "Beeravelli B.O": "506344",
      "Shahpalli B.O": "506165",
      "Tupakulagudem B.O": "506165",
      "Akulavarighampur B.O": "506165",
      "Chalvai B.O": "506344",
      "Gangaram B.O": "506344",
      "Katapur B.O": "506344",
      "Pathipalli B.O": "506352",
      "Sarvapur B.O": "506352",
      "Domeda B.O": "506172",
      "Ramanakkapet B.O": "506172",
      "Borenarsapur B.O": "506172",
      "Komatipalli B.O": "506172",
      "Mohd.Gouspalli B.O": "506349",
      "Pandikunta B.O": "506349",
      "Jaggannapet B.O": "506343",
      "Jakaram B.O": "506343",
      "Madanpalli B.O": "506343",
      "Chinnaboinapalli B.O": "506165",
      "Gurrevula B.O": "506165",
      "Nallakunta B.O": "506345",
      "Machapur B.O": "506344",
      "Kothur B.O": "506352",
      "Incherla B.O": "506352",
      "Buchannapet B.O": "506172",
      "Chunchupalli B.O": "506172",
      "Brahmanpalli B.O": "506172",
      "Kathigudem B.O": "506172",
      "Mangapet B.O": "506172",
      "Abbapur B.O": "506343",
      "Keshavapur B.O": "506343",
      "Patrapuram BO": "507136",
      "Ramachandrapuram B.O": "506349",
      "Suraveedu B.O": "507133",
      "Murumuru B.O": "507136",
      "Peruru B.O": "507136",
      "Ilapuram B.O": "506165",
      "Rajannapet B.O": "506165",
      "Roheer B.O": "506165",
      "Thimmapur B.O": "506345",
      "Laxmidevipet B.O": "506345",
      "Bussapur B.O": "506344",
      "Pambapur B.O": "506344",
      "Raghavapatnam B.O": "506344",
      "Rangapur B.O": "506344",
      "Tadvai B.O": "506344",
      "Ankannagudem B.O": "506352",
      "Kannaigudem B.O": "506352",
      "Poredupalli B.O": "506172",
      "Rajupet B.O": "506172",
      "Mallur B.O": "506172",
      "Venkatapur B.O": "506352",
      "Shivapuram B.O": "506165",
      "Buttaigudem B.O": "506165",
      "Chelpak B.O": "506165",
      "Etur B.O": "506165",
      "Ramanujpur B.O": "506345",
      "Dumpaligudem B.O": "506344",
      "Devagiripatnam B.O": "506352",
      "Kasimdevipet B.O": "506352",
      "Akinepalli Mallaram B.O": "506172",
      "Cherupalli B.O": "506172",
      "Vodagudem B.O": "506172",
      "Narsapur B.O": "506343",
      "Bandarupalli B.O": "506343",
      "Edira B.O": "507133",
      "Veerabhadravaram BO": "507136",
      "Cherukuru B.O": "507136",
      "Pragallapalli B.O": "507136",
      "Wazeedu Nagaram B.O": "507136",
      "Krishnapuram": "507136",
      "Marikala": "507136",
      "Albaka B.O": "507133",
      "Chandrupatla B.O": "507136",
      "Edicharlapalli B.O": "507136",
      "Gummadidoddi B.O": "507136",
      "Chintoor": "507136",
      "Dharmavaram": "507136",
      "Kongala B.O": "507136",
      "Inchencherupalli B.O": "506343",
      "Ramachandrunipet B.O": "506172",
      "Narsimhasagar B.O": "506172",
      "Palampeta B.O": "506345",
      "Narsapur(Bore) B.O": "506344",
      "Muppanapalli B.O": "506165",
      "Kamaram B.O": "506344",
      "Govindaraopet S.O": "506344",
      "Mulug S.O": "506343",
      "Jangalapally S.O": "506352",
      "Mallampalli S.O": "506349",
      "Pasra S.O": "506347",
      "Eturunagaram S.O": "506165",
      "Kamalapur Town Ship S.O": "506172",
      "Venkatapuram S.O": "507136"
    },
    "JOGULAMBA GADWAL": {
      "Mannapur B.O": "509133",
      "Marlabeed B.O": "509133",
      "Oppair B.O": "509133",
      "Pagunta B.O": "509133",
      "Pathapalem B.O": "509133",
      "Bonkur B.O": "509128",
      "Dharmavaram B.O": "509128",
      "Kalakuntla B.O": "509128",
      "Korvipad B.O": "509128",
      "Vallur B.O": "509128",
      "Vemula B.O": "509128",
      "Thummala Chervu B.O": "509132",
      "Yelkur B.O": "509132",
      "Konkal B.O": "509126",
      "Peddatandrapad B.O": "509126",
      "Julaikal B.O": "509126",
      "Itkyalapad B.O": "509153",
      "Jallapur B.O": "509153",
      "Kyathur B.O": "509153",
      "Pullur B.O": "509153",
      "Kothapally B.O": "509133",
      "Parmal B.O": "509133",
      "Ryalam Pahad B.O": "509133",
      "Poodur B.O": "509133",
      "Atmakur B.O": "509133",
      "BOYALAGUDEM B.O": "509129",
      "Tottinon Doddi B.O": "509129",
      "Induvasi B.O": "509129",
      "Sindhanoor B.O": "509129",
      "Nandinne B.O": "509129",
      "Peddamamidala Padu B.O": "509128",
      "Chennipad B.O": "509128",
      "Itkyala B.O": "509128",
      "Pallepad B.O": "509128",
      "Puttandoddi B.O": "509128",
      "Bijwar B.O": "509132",
      "Alur B.O": "509132",
      "Amervoi B.O": "509132",
      "Palvoi B.O": "509132",
      "Paipadu B.O": "509126",
      "Chagapur B.O": "509126",
      "Kovaldinne B.O": "509126",
      "Shantinagar B.O": "509126",
      "Linganvai B.O": "509153",
      "Takkasila B.O": "509153",
      "Pragatur B.O": "509153",
      "Yapadinne B.O": "509135",
      "Pedda Dhanwada B.O": "509135",
      "Nettampahad B.O": "509133",
      "Priyadarshini Juriyala Project B.O": "509133",
      "Thimmapur B.O": "509133",
      "Chintalkunta B.O": "509129",
      "Ghattu B.O": "509129",
      "Gorlakhan Doddi B.O": "509129",
      "Peddadinne B.O": "509128",
      "Peddapothulapad B.O": "509128",
      "Satarla B.O": "509128",
      "Aragidda B.O": "509132",
      "Waddepalli B.O": "509126",
      "Marmungal B.O": "509153",
      "Uppal B.O": "509135",
      "Gundimalla B.O": "509152",
      "Chagadona B.O": "509127",
      "Eklaspur B.O": "509127",
      "Pulikallu B.O": "509127",
      "Uttanur B.O": "509127",
      "Vitalapur B.O": "509127",
      "Beechpally B.O": "509133",
      "Chintareval B.O": "509133",
      "Kondapally B.O": "509133",
      "Mulkalpally B.O": "509133",
      "Erikichedu B.O": "509129",
      "Kancherla B.O": "509129",
      "Udandapur B.O": "509128",
      "Maddelabanda B.O": "509132",
      "Penchikalpadu B.O": "509132",
      "Ramapuram B.O": "509126",
      "Chinna Tandrapad B.O": "509135",
      "Mandoddi B.O": "509135",
      "Tangal B.O": "509135",
      "Bukkapur B.O": "509152",
      "Singwar Bo": "509152",
      "Mittadoddi B.O": "509127",
      "Dharur B.O": "509133",
      "Jammiched B.O": "509133",
      "Kakulavaram B.O": "509133",
      "Kondair B.O": "509133",
      "Medikonda B.O": "509127",
      "Alwalpad B.O": "509133",
      "Baswapur B.O": "509152",
      "Bingidoddi B.O": "509127",
      "Tatikunta B.O": "509127",
      "Ananthapur B.O": "509133",
      "Beerole B.O": "509133",
      "Alampur S.O": "509152",
      "Krishna Nagar S.O": "509133",
      "Uppal Camp S.O": "509135",
      "Ieeja S.O": "509127",
      "Muldakal S.O": "509132",
      "Gadwal H.O": "509125",
      "Manavapad S.O": "509128",
      "Rajoli S.O": "509126",
      "Undavelly S.O": "509153",
      "Macherla S.O": "509129"
    },
    "ADILABAD": {
      "Kortakal B.O": "504323",
      "Gadiguda B.O": "504311",
      "Nagapur B.O": "504311",
      "Tadihadapnoor B.O": "504311",
      "Lakkaram B.O": "504311",
      "Mankapur B.O": "504311",
      "Narnoor B.O": "504311",
      "Gonadhanora B.O": "504312",
      "Arli Tarad B.O": "504312",
      "Kosai B.O": "504312",
      "Pardi K B.O": "504304",
      "Chinchughat B.O": "504002",
      "Cotton Market B.O": "504002",
      "Khodad B.O": "504002",
      "Pochera B.O": "504304",
      "Ponnari B.O": "504002",
      "Saidpur B.O": "504002",
      "Rampur B.O": "504307",
      "Girnoor B.O": "504307",
      "Gurjamannur B.O": "504308",
      "Waghapur B.O": "504308",
      "Sangdi B.O": "504309",
      "Sirsanna B.O": "504309",
      "Akoli B.O": "504309",
      "Chaprala B.O": "504309",
      "Ghotkuri B.O": "504309",
      "Guda B.O": "504309",
      "Jainad B.O": "504309",
      "Koora B.O": "504309",
      "Dasnapur B.O": "504346",
      "Gourapur B.O": "504346",
      "Harkapur B.O": "504346",
      "Umri B.O": "504346",
      "Buggaram B.O": "504323",
      "Gowliguda B.O": "504323",
      "Boregaon B.O": "504307",
      "Ghanpur B.O": "504311",
      "Marlapally B.O": "504304",
      "Bhutai B.O": "504304",
      "Kampamediguda B.O": "504002",
      "Pippaldhari B.O": "504002",
      "Ramai B.O": "504002",
      "Tantoli B.O": "504002",
      "Sirchelma B.O": "504307",
      "Malyal B.O": "504307",
      "Pipri B.O": "504346",
      "Sirkonda B.O": "504307",
      "Tosham B.O": "504308",
      "Bharampur B.O": "504308",
      "Pendalwada B.O": "504309",
      "Bela B.O": "504309",
      "Sawapur B.O": "504309",
      "Lachampur B.O": "504309",
      "Keslapur B.O": "504346",
      "Narsapur B.O": "504307",
      "Pulimadugu B.O": "504346",
      "Yenda B.O": "504346",
      "Dehgaon B.O": "504304",
      "Jatharla B.O": "504304",
      "Kuchlapur B.O": "504312",
      "Patnapur B.O": "504304",
      "Sonala B.O": "504304",
      "Bazar Hathnur B.O": "504304",
      "Chintalbori B.O": "504304",
      "Ankoli B.O": "504002",
      "Chanda T B.O": "504002",
      "Mavala B.O": "504002",
      "Toyaguda B.O": "504002",
      "Powna B.O": "504307",
      "Sonpelli B.O": "504307",
      "Talamadri B.O": "504307",
      "Muthnur B.O": "504346",
      "Sitagondi B.O": "504308",
      "Deepaiguda B.O": "504309",
      "Khogdur B.O": "504309",
      "Nirala B.O": "504309",
      "Chichdhari Khanapur B.O": "504346",
      "Ginnera B.O": "504346",
      "Vaddur B.O": "504323",
      "Kumhari B.O": "504323",
      "Gunjala B.O": "504311",
      "Hasnapur B.O": "504311",
      "Chandur B.O": "504311",
      "Nagalkonda B.O": "504311",
      "Tarnam B.O": "504323",
      "Wankidi B.O": "504323",
      "Dantanpalli B.O": "504311",
      "Dhaba B.O": "504311",
      "Sangvi B.O": "504311",
      "Bhimpur B.O": "504311",
      "Karanji B.O": "504312",
      "Sunkidi B.O": "504312",
      "Jhary B.O": "504312",
      "Talamadgu B.O": "504312",
      "Khairdatwa B.O": "504311",
      "Birsaipet B.O": "504311",
      "Kothapalli B.O": "504311",
      "Lingi B.O": "504312",
      "Ruyyadi B.O": "504312",
      "Kapparla B.O": "504312",
      "Pippalkoti B.O": "504312",
      "Kowtha Buzurg  B.O": "504304",
      "Dhannoor B.O": "504304",
      "Gokonda B.O": "504304",
      "Karathwada B.O": "504304",
      "Bheemsari B.O": "504002",
      "Yapalguda B.O": "504002",
      "Mukhra Buzurg B.O": "504307",
      "Adegaon B.O": "504307",
      "Girjam B.O": "504307",
      "Kokasmannur B.O": "504307",
      "Tembi B.O": "504307",
      "Devapur B.O": "504308",
      "Kolahari B.O": "504308",
      "Palli B B.O": "504308",
      "Shantapur B.O": "504308",
      "Salawada B.O": "504346",
      "Shampur B.O": "504346",
      "Wadegaon B.O": "504346",
      "Dhanora B B.O": "504346",
      "Adilabad H.O": "504001",
      "Adilabad Collectorate S.O": "504001",
      "Bhuktapur S.O": "504001",
      "Boath S.O": "504304",
      "Gudihatnoor S.O": "504308",
      "Indervelli S.O": "504346",
      "Station Road S.O": "504001",
      "Dasnapur Colony  D.S.O": "504002",
      "Tamsi S.O": "504312",
      "Echoda S.O": "504307",
      "Gandhi Chowk S.O": "504001",
      "Neradigonda S.O": "504323",
      "Ootnur S.O": "504311",
      "Bhagyanagar S.O": "504001",
      "Gumma S.O": "504309"
    },
    "RAJANNA SIRCILLA": {
      "Bandalingampalli B.O": "505303",
      "Narayanapur B.O": "505303",
      "Balarajpalli B.O": "505403",
      "Bavasaipet B.O": "505403",
      "Pothugal B.O": "505404",
      "Gajasingaram B.O": "505305",
      "Thimmapur B.O": "505307",
      "Jogapur B.O": "505307",
      "Kanagarthi B.O": "505301",
      "Kolanur B.O": "505301",
      "Marthanpet B.O": "505301",
      "Malakpet B.O": "505301",
      "Nimmapalli B.O": "505301",
      "Badnepalli B.O": "505405",
      "Chintalathana B.O": "505302",
      "Jillella B.O": "505405",
      "Sarampalli B.O": "505405",
      "Satrajpalli B.O": "505302",
      "Suddala B.O": "505302",
      "Sankepalli B.O": "505302",
      "Tadagonda B.O": "505524",
      "Fazilnagar B.O": "505524",
      "Narsingapur B.O": "505524",
      "Vallampatla B.O": "505402",
      "Galipalli B.O": "505530",
      "Dammannapet B.O": "505304",
      "Kothapalli B.O": "505304",
      "Kondapur B.O": "505303",
      "Padira B.O": "505303",
      "Bandapalli B.O": "505403",
      "Yengal B.O": "505403",
      "Cheekode B.O": "505404",
      "Namapur B.O": "505404",
      "Adivipadira B.O": "505305",
      "Almaspur B.O": "505305",
      "Garjanapalli B.O": "505305",
      "Gorantial B.O": "505305",
      "Mallial B.O": "505307",
      "Katkur B.O": "505301",
      "Mamidipalli B.O": "505301",
      "Bonala B.O": "505301",
      "Mallaram B.O": "505403",
      "Chandurthi B.O": "505403",
      "Marrigadda B.O": "505403",
      "Bandankal B.O": "505404",
      "Avunur B.O": "505404",
      "Therlamaddi B.O": "505404",
      "Gollapalli B.O": "505305",
      "Koratlapet B.O": "505305",
      "Samudralingapur B.O": "505305",
      "Lingampet B.O": "505307",
      "Dharmaram B.O": "505301",
      "Peddur B.O": "505301",
      "Nizamabad B.O": "505301",
      "Laxmipuram B.O": "505405",
      "Baswapur B.O": "505405",
      "Dumala B.O": "505303",
      "Hanmajipet B.O": "505403",
      "Konaraopet B.O": "505301",
      "Veernapalli B.O": "505305",
      "Sanugula B.O": "505307",
      "Chandrampet B.O": "505301",
      "Venkatapur B.O": "505301",
      "Venkatraopet B  O": "505301",
      "MallapurB.O": "505401",
      "Nerella B.O": "505405",
      "Tangallapalli B.O": "505405",
      "Stambampalli B.O": "505302",
      "Anupur B.O": "505302",
      "Repaka B.O": "505528",
      "Ananthapalli B.O": "505524",
      "Vilasagar B.O": "505524",
      "Manwada B.O": "505401",
      "Pothur B.O": "505401",
      "Cheerlavancha B.O": "505302",
      "Mukshanpet B.O": "505402",
      "Rahimkhanpet B.O": "505402",
      "Chinnalingapur B.O": "505405",
      "Mandepalli B.O": "505405",
      "Chekkapalli B.O": "505302",
      "Marpaka B.O": "505302",
      "Dacharam B.O": "505405",
      "Korem B.O": "505524",
      "Kandikatkur B.O": "505401",
      "Kodurpak BO": "505524",
      "Nookalamarri B.O": "505524",
      "Ottimalla B.O": "505524",
      "Ananthagiri B.O": "505402",
      "Anantharam B.O": "505402",
      "Vanthadupula B.O": "505402",
      "Velgipur B.O": "505402",
      "Voblapur B.O": "505402",
      "Tallapalli B.O": "505530",
      "Parvella B.O": "505530",
      "Mallareddipet B.O": "505304",
      "Srigadha B.O": "505304",
      "Manair Project B.O": "505304",
      "Narmala B.O": "505304",
      "Nagaram B.O": "505301",
      "Mucherla B.O": "505304",
      "Lingannapet B.O": "505304",
      "Peddalingapur B.O": "505405",
      "Moodapalli B.O": "505403",
      "Manala B.O": "505307",
      "Maddikunta B.O": "505404",
      "Nagumpet B.O": "505304",
      "Gudem B.O": "505404",
      "Rudraram B.O": "505302",
      "Valbhapur B.O": "505405",
      "Vemulawada S.O": "505302",
      "Boenpalli S.O": "505524",
      "Ellanthakunta S.O": "505402",
      "Tadoor S.O": "505405",
      "Gambhiraopet S.O": "505304",
      "Kishandaspet S.O": "505303",
      "Marripalli S.O": "505403",
      "Gandhichowk Srisilla S.O": "505301",
      "Racherla Boppapur S.O": "505305",
      "Sirsilla S.O": "505301",
      "Rudrangi S.O": "505307",
      "Mustabad S.O": "505404"
    },
    "WANAPARTHY": {
      "Veltur B.O": "509382",
      "Nagal Kadmoor B.O": "509130",
      "Motlampally B.O": "509131",
      "Nandimalla B.O": "509131",
      "Maddigatla B.O": "509382",
      "Irladinne B.O": "509130",
      "Kamaluddinpur B.O": "509380",
      "Solipur B.O": "509380",
      "Ghanpur B.O": "509380",
      "Thipdampally B.O": "509131",
      "Mulamalla B.O": "509131",
      "Mamidimada B.O": "509380",
      "Manajipet B.O": "509380",
      "Manigilla B.O": "509106",
      "Savaigudem B.O": "509106",
      "Thatiparthi B.O": "509206",
      "Yedula B.O": "509206",
      "J.Thirumalapuram B.O": "509206",
      "Polkepahad B.O": "509206",
      "Remadla B.O": "509206",
      "Munnanur B.O": "509206",
      "Chimanguntapalle B.O": "509206",
      "Keshampet B.O": "509206",
      "Pamireddipalli B.O": "509206",
      "Chityala B.O": "509206",
      "Mastipur B.O": "509130",
      "Rechintala B.O": "509131",
      "Arepally B.O": "509131",
      "Gopanpet B.O": "509131",
      "Juriyala B.O": "509131",
      "Apparala B.O": "509110",
      "Dantanoor B.O": "509110",
      "Konnur B.O": "509110",
      "Ayyavaripally B.O": "509105",
      "Rangapuram B.O": "509104",
      "Sugur B.O": "509104",
      "Venkatapur B.O": "509104",
      "Chinnamaroor B.O": "509104",
      "Peddamarur B.O": "509104",
      "Mahmmadapuram B.O": "509120",
      "Revalli B.O": "509235",
      "Ravipakula B.O": "509235",
      "Bekkem B.O": "509104",
      "Yaparla B.O": "509104",
      "Dagada B.O": "509104",
      "Gummadam B.O": "509104",
      "Miraspally B.O": "509104",
      "Nyetvally B.O": "509104",
      "Laxmipally B.O": "509104",
      "Bollavaram B.O": "509105",
      "Rajapeta B.O": "509381",
      "Rayanpet B.O": "509381",
      "Ajjakallu B.O": "509110",
      "Busireddypalli B.O": "509120",
      "Dawasipally B.O": "509120",
      "Gopulapuram B.O": "509120",
      "Kalwaral B.O": "509120",
      "Kanchiraopalli B.O": "509120",
      "Kethepalli B.O": "509120",
      "Panugallu B.O": "509120",
      "Shakhapur B.O": "509120",
      "Thalpunooru B.O": "509235",
      "Pedamandadi B.O": "509106",
      "Kadirepahad B.O": "509206",
      "Yedutla B.O": "509206",
      "Buddharam B.O": "509206",
      "Parvathapuram B.O": "509380",
      "Veeraipally B.O": "509380",
      "Kadukuntla B.O": "509381",
      "Kanmetta B.O": "509381",
      "Peddagudem B.O": "509381",
      "Chennaram B.O": "509206",
      "Duppalli B.O": "509110",
      "Ammayapally B.O": "509104",
      "Shakapur B.O": "509104",
      "Vellatur B.O": "509104",
      "Chandapur B.O": "509120",
      "Chinthakunta B.O": "509120",
      "Nagapore B.O": "509235",
      "Palem B.O": "509381",
      "Sankireddypalli B.O": "509381",
      "Amadabakula B.O": "509381",
      "Atmacore S.O": "509131",
      "Amerchinta S.O": "509130",
      "Wanaparthy H.O": "509103",
      "Gandhichowk": "509106",
      "Madanapuram S.O": "509110",
      "Kothakota S.O": "509381",
      "Pebbair S.O": "509104",
      "Srirangapur S.O": "509120",
      "Gopalpet S.O": "509206"
    },
    "NAGARKURNOOL": {
      "Kondareddipally B.O": "509401",
      "Raghupathipeta B.O": "509324",
      "Sirasanagandla B.O": "509324",
      "Yellikal B.O": "509324",
      "Gundur B.O": "509324",
      "Tarnikal B.O": "509320",
      "Thotapally B.O": "509320",
      "Kurumidda B.O": "509320",
      "Rachur B.O": "509320",
      "Bhuddasamadram B.O": "509302",
      "Konetipur B.O": "509349",
      "Uppalpahad B.O": "509349",
      "Chadurpalli B.O": "509360",
      "Gattuthumman B.O": "509375",
      "Hajipur B.O": "509375",
      "Chandapur B.O": "509375",
      "Rangapur B.O": "509349",
      "Ippalapally B.O": "509201",
      "Kummaronipally B.O": "509201",
      "Gangaram B.O": "509203",
      "Latpally B.O": "509203",
      "Manganoor B.O": "509203",
      "Rajapur B.O": "509206",
      "Yettam B.O": "509102",
      "Tandra B.O": "509324",
      "Jupally B.O": "509324",
      "Urkondapeta B.O": "509320",
      "Vepur B.O": "509320",
      "Gudiganpally B.O": "509357",
      "Dindi Chintapalli B.O": "509349",
      "Kuppagandla B.O": "509360",
      "Bommanpally B.O": "509375",
      "Mannevaripally B.O": "509375",
      "Nadimpally B.O": "509375",
      "Akkaram B.O": "509375",
      "Thirmalapuram B.O": "509201",
      "Turkaplli B.O": "509201",
      "Udimilla B.O": "509201",
      "Shayanpally B.O": "509203",
      "Vattem B.O": "509203",
      "Velgonda B.O": "509105",
      "Machupalli B.O": "509206",
      "Muthireddypally B.O": "509206",
      "Nagulpalli  B.O": "509206",
      "Singotam B.O": "509102",
      "Yellur B.O": "509102",
      "Yenmanbetla B.O": "509102",
      "Ausalikunta B.O": "509401",
      "Vallabhapur B.O": "509401",
      "Appayapally B.O": "509401",
      "Balmoor B.O": "509401",
      "Lingasanipally B.O": "509324",
      "Mukurala B.O": "509324",
      "Ippapahad B.O": "509320",
      "Ramreddipally B.O": "509320",
      "Madharam B.O": "509320",
      "Avancha B.O": "509302",
      "Polkampalli B.O": "509349",
      "Sarvareddipalli B.O": "509349",
      "Thippareddypalli B.O": "509349",
      "Ulpara B.O": "509349",
      "Cherukur B.O": "509360",
      "Kotra B.O": "509360",
      "Pothepalli B.O": "509360",
      "Siddapur B.O": "509375",
      "Thummanpet B.O": "509375",
      "Inole B.O": "509375",
      "Macharam B.O": "509201",
      "Maddimadugu B.O": "509201",
      "Mananur B.O": "509201",
      "Padra B.O": "509201",
      "Chitlamkunta B.O": "509201",
      "Banala B.O": "509401",
      "Komatikunta B.O": "509401",
      "Kondanagula B.O": "509401",
      "Guntakodur B.O": "509209",
      "Medipur B.O": "509209",
      "Gudlanarva B.O": "509215",
      "Kummera B.O": "509215",
      "Khanapur B.O": "509215",
      "Lingasanpalli B.O": "509215",
      "Aleru B.O": "509412",
      "Gantaraopally B.O": "509412",
      "Mustipally B.O": "509412",
      "Satapur B.O": "509412",
      "Vattipally B.O": "509412",
      "Jetaprole B.O": "509105",
      "Kondur B.O": "509105",
      "Koppunur B.O": "509105",
      "Gaggalapally B.O": "509385",
      "Goureddipally B.O": "509385",
      "Jinkunta B.O": "509385",
      "Laknaram B.O": "509385",
      "Mamidlapally B.O": "509385",
      "Gorata B.O": "509406",
      "Ippalapalli B.O": "509406",
      "Venicherla B.O": "509235",
      "Surapuram B.O": "509401",
      "Yapatla B.O": "509401",
      "Ambatpally B.O": "509401",
      "Tandur B.O": "509209",
      "Uuyyalwada B.O": "509209",
      "Wanapatla B.O": "509209",
      "Yadireddipalli B.O": "509209",
      "Yendabetla B.O": "509209",
      "Chadubatla B.O": "509209",
      "Jonnalabogada B.O": "509412",
      "Marikal B.O": "509406",
      "Muddunurkalan B.O": "509412",
      "Pasupula B.O": "509412",
      "Venkatampally B.O": "509105",
      "Chintalapally B.O": "509105",
      "Upparapally B.O": "509385",
      "Puljala B.O": "509385",
      "Kodaparthi B.O": "509406",
      "Edurepalli B.O": "509406",
      "Appajipally B.O": "509406",
      "Sripur B.O": "509235",
      "Peddapur B.O": "509360",
      "Thadoor B.O": "509376",
      "Veltoor B.O": "509376",
      "Jabtisadaguda B.O": "509376",
      "Kamsanpally B.O": "509376",
      "Dhararam B.O": "509401",
      "Sirsawada B.O": "509209",
      "Naganool B.O": "509209",
      "Papagal B.O": "509209",
      "Pothreddipalli B.O": "509215",
      "Chandrakal B.O": "509412",
      "D.Thirumalapur B.O": "509412",
      "Veepangandla B.O": "509105",
      "Gopalapuram B.O": "509105",
      "Watwarlapalli B.O": "509326",
      "Laxmapur B.O": "509201",
      "Peddur B.O": "509385",
      "Tallapally B.O": "509385",
      "Manthati B.O": "509385",
      "Karvanga B.O": "509385",
      "Malkapur B.O": "509385",
      "Gumkonda B.O": "509406",
      "Chegunta B.O": "509406",
      "Gudipalli B.O": "509235",
      "Polesettipalli B.O": "509376",
      "Palkapally B.O": "509376",
      "Ramajipalli B.O": "509376",
      "Piratvanpalli B.O": "509376",
      "Charakonda B.O": "509324",
      "Jajala B.O": "509324",
      "Panjugula B.O": "509324",
      "Gokaram B.O": "509324",
      "Urkonda B.O": "509320",
      "Jakinalapally B.O": "509320",
      "Rachala Pally B.O": "509320",
      "Revalli B.O": "509357",
      "Mittasadguda B.O": "509349",
      "Umapur B.O": "509349",
      "Gazra B.O": "509349",
      "Ajilapuram B.O": "509360",
      "Barkatpalli B.O": "509360",
      "Bollampalli B.O": "509360",
      "Bhairapuram B.O": "509360",
      "Ghanpur B.O": "509375",
      "Madhavanpalli B.O": "509201",
      "Mared B.O": "509201",
      "Venkeshwaram B.O": "509201",
      "Jamgamreddypalli B.O": "509201",
      "Mahadeanpet B.O": "509203",
      "Polepally B.O": "509203",
      "Singaiapalli B.O": "509206",
      "Kondaraopally B.O": "509102",
      "Molachinthalapally B.O": "509102",
      "Narsayapally B.O": "509102",
      "Kalwakole B.O": "509102",
      "Kudikilla B.O": "509102",
      "Janumpally B.O": "509102",
      "Kodair B.O": "509102",
      "Ananthavaram B.O": "509401",
      "Chennampally B.O": "509401",
      "Godal B.O": "509401",
      "Indrakal B.O": "509209",
      "Aitol B.O": "509209",
      "Nallavelli B.O": "509209",
      "Bhallanpalli B.O": "509215",
      "WADDAMAN B.O": "509215",
      "Peddakarpamula B.O": "509412",
      "Ganyagula B.O": "509412",
      "Sanginenipally B.O": "509105",
      "Tumkunta B.O": "509105",
      "Malleswaram B.O": "509105",
      "Gattunellikuduru B.O": "509385",
      "Peddapally B.O": "509385",
      "Gaddampally B.O": "509385",
      "Rakonda B.O": "509385",
      "Gowraram B.O": "509385",
      "Bhavajipally B.O": "509406",
      "Marepally B.O": "509406",
      "Penmella B.O": "509376",
      "Puljal B.O": "509376",
      "Vangoor S.O": "509349",
      "Achampet S.O": "509375",
      "Peddakothapally S.O": "509412",
      "Kalwakurthy S.O": "509324",
      "Marchala S.O": "509320",
      "Lingala S.O": "509401",
      "Nagarkurnool S.O": "509209",
      "Palem S.O": "509215",
      "Pentlavally S.O": "509105",
      "Thelkapally S.O": "509385",
      "Veldanda S.O": "509360",
      "Amrabad S.O": "509201",
      "Kollapur S.O": "509102",
      "Thimmajipet S.O": "509406",
      "Bijnapally S.O": "509203",
      "Srisailam Dam  S.O": "509326",
      "Thoodukurthy S.O": "509235",
      "Uppununthala S.O": "509376"
    },
    "BHADRADRI KOTHAGUDEM": {
      "Nagineniprolu B.O": "507114",
      "Pinapaka Pattinagar B.O": "507114",
      "Subbampeta B.O": "507133",
      "Anjubaka": "507137",
      "NARASAPURAM": "507137",
      "SEETARAMPURAM": "507137",
      "Ammagaripally B.O": "507116",
      "Ashwapur B.O": "507116",
      "Chintrial B.O": "507116",
      "Anantharampatti Mallur B.O": "507117",
      "Pinapaka B.O": "507117",
      "Singareddipalli B.O": "507117",
      "Uppaka B.O": "507117",
      "Padmapuram": "507117",
      "Yanambilel B.O": "507115",
      "Payakariyanambile": "507115",
      "KUDUNURU": "507140",
      "Mothipattinagar B.O": "507128",
      "Nellipaka B.O": "507128",
      "Nargundukarnagar B.O": "507118",
      "Regalla B.O": "507118",
      "Seethampeta B.O": "507120",
      "Singhabhupalem B.O": "507120",
      "Bethalapadu": "507120",
      "Morampalli B.O": "507114",
      "Mogallapalli B.O": "507133",
      "Upparigudem": "507133",
      "Arlagudem B.O": "507137",
      "Dabbanuthala B.O": "507137",
      "Pydigudem B.O": "507137",
      "Peddakamalapuram": "507137",
      "KOTHAPALLI": "507137",
      "Gondigudem B.O": "507116",
      "Jaggaram": "507116",
      "Krishnasagar B.O": "507114",
      "Gangolu B.O": "507137",
      "Laxminagaram B.O": "507137",
      "Musalimadugu B.O": "507114",
      "Timmampeta B.O": "507114",
      "Lingapuram B.O": "507133",
      "Chinabandirevu B.O": "507137",
      "Sunnambatti B.O": "507137",
      "Turubaka B.O": "507137",
      "SINGAVARAM": "507137",
      "Mittagudem B.O": "507116",
      "Mondikunta": "507116",
      "Gopalaraopeta B.O": "507117",
      "Janampeta B.O": "507117",
      "Pagideru B.O": "507117",
      "Ramanajaram": "507117",
      "VENKATRAOPET": "507117",
      "Jagannadhapuram N B.O": "507115",
      "Nagaram B.O": "507115",
      "Pogallapalli B.O": "507115",
      "Thogugudem B.O": "507115",
      "Nallaballi B.O": "507137",
      "Parnasala B.O": "507137",
      "ANANDAPURAM": "507116",
      "Tummalacheruvu": "507116",
      "Bayyaram B.O": "507117",
      "Bhupathiraopeta B.O": "507117",
      "Kondaigudem B.O": "507117",
      "Mallaram B.O": "507117",
      "Manuguru B.O": "507117",
      "Cherupalli B.O": "507137",
      "Kamalapuram B.O": "507115",
      "Karakavagu B.O": "507115",
      "Kinnersani Project B.O": "507115",
      "Mukamamidi B.O": "507115",
      "Pandurangapuram B.O": "507115",
      "Patha Paloncha B.O": "507115",
      "Gommugudem B.O": "507140",
      "Kurnapalli B.O": "507140",
      "Mamidigudem B.O": "507140",
      "Pedamatasileru B.O": "507140",
      "PEDDIPALLI": "507140",
      "Duginepalli B.O": "507117",
      "Karakagudem B.O": "507117",
      "Elchireddipalli": "507117",
      "Samithisingaram": "507117",
      "Dantalaboru B.O": "507115",
      "Jagannadhapuram K.P.  B.O": "507115",
      "Mulakalapalli B.O": "507115",
      "Posugudem B.O": "507115",
      "Ulvanoor B.O": "507115",
      "Tegada B.O": "507140",
      "DEVARAPALLI": "507140",
      "KALLIVERU": "507140",
      "Kothaguda B.O": "507118",
      "Mining Engineering Complex B.O": "507118",
      "CHUNCHUPALLI": "507118",
      "Raghavapuram B.O": "507120",
      "Penagadapa B.O": "507103",
      "Manikyaram B.O": "507124",
      "Rompaid B.O": "507124",
      "Sayanapalli B.O": "507123",
      "Tekulapalli B.O": "507123",
      "Kachanapalli B.O": "507123",
      "Hemachandrapuram B.O": "507118",
      "MYLARAM": "507118",
      "Ganugapadu B.O": "507120",
      "Tippanapalli B.O": "507120",
      "Raithwari Kothagudem B.O": "507140",
      "Gummadivalli B.O": "507301",
      "Naramvarigudem B.O": "507301",
      "Narayanapuram B.O": "507301",
      "Tirumalakunta B.O": "507301",
      "Bachuvarigudem": "507301",
      "Nandipadu": "507301",
      "Nacharam B.O": "507306",
      "Chandrugonda B.O": "507166",
      "Guraigudem": "507166",
      "Anantaram": "507166",
      "Annapureddipalli B.O": "507316",
      "Chaprala Palli B.O": "507316",
      "Karivarigudem B.O": "507120",
      "Sarvaram B.O": "507120",
      "Machinenipeta": "507120",
      "Komararam B.O": "507124",
      "Anisettipalli B.O": "507124",
      "Bodu B.O": "507124",
      "Lingagudem B.O": "507123",
      "Ragaboinagudem B.O": "507123",
      "Sudimalla B.O": "507123",
      "Muthapuram B.O": "507123",
      "Allapalli B.O": "507124",
      "Markodu B.O": "507124",
      "Sampathnagar B.O": "507124",
      "Gundala B.O": "507123",
      "Settipalli B.O": "507124",
      "Ananthogu B.O": "507124",
      "Lachagudem B.O": "507124",
      "Bethampudi B.O": "507123",
      "Koyagudem B.O": "507123",
      "Pegallapadu B.O": "507123",
      "Sulanagar B.O": "507123",
      "Badduthanda": "507123",
      "Achutapuram": "507301",
      "Malkaram B.O": "507306",
      "Mandalapalli B.O": "507306",
      "Mustibanda B.O": "507306",
      "P.N.Puram B.O": "507166",
      "Pokalagudem B.O": "507166",
      "Ravikampadu B.O": "507166",
      "Pentlam B.O": "507316",
      "Anantharam B.O": "507301",
      "Ootlapalli": "507301",
      "Ankampalem B.O": "507306",
      "Lingalapalli B.O": "507306",
      "Maddulagudem B.O": "507306",
      "Jammigudem": "507306",
      "Gundepudi B.O": "507166",
      "Maddukur B.O": "507166",
      "Papakole B.O": "507166",
      "Rajapuram B.O": "507316",
      "Garibpeta B.O": "507118",
      "Asupaka B.O": "507301",
      "Vinayakapuram B.O": "507301",
      "Ganeshpadu B.O": "507306",
      "Patwarigudem B.O": "507306",
      "Damarcharla B.O": "507166",
      "Kakarla B.O": "507166",
      "Abbugudem B.O": "507316",
      "Bangaruchelka B.O": "507118",
      "Chatakonda B.O": "507118",
      "Bhadrachalam H.O": "507111",
      "P.V.Township S.O": "507125",
      "Sarapaka S.O": "507128",
      "Kothagudem Colls H.O": "507101",
      "Charla S.O": "507133",
      "Dummagudem S.O": "507137",
      "Siil Campus S.O": "507154",
      "Hwp Aswapur Colony S.O": "507116",
      "Manuguru Colls S.O": "507117",
      "Ramalayam S.O": "507111",
      "B.R.Colony S.O": "507111",
      "Burgampahad S.O": "507114",
      "Paloncha S.O": "507115",
      "S.N.Puram S.O": "507140",
      "T.P.Campus S.O": "507115",
      "Kothagudem Bazar S.O": "507101",
      "Sca Bldg S.O": "507101",
      "Sujathanagar S.O": "507120",
      "Venkateshkhani S.O": "507103",
      "Bhajanamandir S.O": "507101",
      "Dammapeta S.O": "507306",
      "Gouthampur S.O": "507138",
      "Laxmidepalli S.O": "507101",
      "Yellandu S.O": "507123",
      "Aswaraopet S.O": "507301",
      "Julurpahad S.O": "507166",
      "Peddireddigudem S.O": "507316",
      "Ramavaram S.O": "507118",
      "Rudrampur S.O": "507119",
      "Yellandu Colls S.O": "507124"
    }
  },
  "RAJASTHAN": {
    "BARMER": {
      "Akal B.O": "344704",
      "Daukiyon ka Tala B.O": "344032",
      "Pandarwali B.O": "344706",
      "Kerawa B.O": "344011",
      "Sarla B.O": "344706",
      "Sata B.O": "344706",
      "Chochra B.O": "344701",
      "Kotra B.O": "344701",
      "Nagarda B.O": "344701",
      "Tanu Mansingh B.O": "344701",
      "Adel B.O": "344033",
      "Chadon Ki Dhani B.O": "344033",
      "Lolawa B.O": "344033",
      "Sinhar B.O": "344706",
      "Arang B.O": "344701",
      "Balai B.O": "344701",
      "Bhinyad B.O": "344701",
      "Jhankali B.O": "344701",
      "Junejon Ki Basti B.O": "344701",
      "Undu B.O": "344701",
      "Hodu B.O": "344033",
      "Kamthai B.O": "344033",
      "Khara Mahechan B.O": "344033",
      "Kharia Khurd B.O": "344033",
      "Mangle Ki Beri B.O": "344033",
      "Dhani Jan Singh Ki Beri B.O": "344701",
      "Dharvi Kallan B.O": "344701",
      "Dharvi Khurd B.O": "344701",
      "Kanasar B.O": "344701",
      "Kashmir B.O": "344701",
      "Nimbla B.O": "344701",
      "Thumbali B.O": "344026",
      "Dandali B.O": "344033",
      "Dhanne Ki Dhani B.O": "344033",
      "Ed Sindhari B.O": "344033",
      "Golia Jet B.O": "344033",
      "Jogasar B.O": "344033",
      "Nehron Ki Dhani B.O": "344033",
      "Salaria B.O": "344706",
      "Sinhaniya B.O": "344706",
      "Balasar B.O": "344701",
      "Bissukallan B.O": "344701",
      "Jasa Ka Gaon B.O": "344701",
      "Mokhab B.O": "344701",
      "Mungeria B.O": "344701",
      "Pusad B.O": "344701",
      "Band B.O": "344033",
      "Chhotu B.O": "344033",
      "Khudala B.O": "344033",
      "Koslu B.O": "344033",
      "Mandawala B.O": "344033",
      "Hudon Ki Dhani B.O": "344035",
      "Jhak B.O": "344035",
      "Lunada B.O": "344035",
      "Madpura Barwala B.O": "344035",
      "Madpura Sani B.O": "344035",
      "Rateu B.O": "344035",
      "Chilanadi B.O": "344032",
      "Khanoda B.O": "344032",
      "Khardi B.O": "344032",
      "Khokhsar B.O": "344032",
      "Kudi B.O": "344032",
      "Kumpalia B.O": "344032",
      "Sathuni Purohitan B.O": "344032",
      "Bhata B.O": "344801",
      "Dhanwa B.O": "344801",
      "Kharwa B.O": "344027",
      "Bhachbhar B.O": "344502",
      "Bhilon Ka Par B.O": "344502",
      "Bukar B.O": "344502",
      "Chadi B.O": "344502",
      "Detani B.O": "344502",
      "Kantal Ka Par B.O": "344502",
      "Kharchi B.O": "344502",
      "Kharia Kallan B.O": "344502",
      "Pandhi Ka Par B.O": "344502",
      "Radwa B.O": "344012",
      "Sanau B.O": "344012",
      "Undkha B.O": "344012",
      "Arthandi B.O": "344021",
      "Bhalron Ka Bada B.O": "344021",
      "Hathitala B.O": "344708",
      "Ishrol B.O": "344708",
      "Jakhdon Ki Dhani B.O": "344708",
      "Leelsar B.O": "344708",
      "Bhawaria B.O": "344706",
      "Bisasar B.O": "344706",
      "Chinchrasar B.O": "344706",
      "Ekal B.O": "344706",
      "Gangasara B.O": "344706",
      "Gidan B.O": "344706",
      "Hathala B.O": "344706",
      "Pandhi Ka Niwan B.O": "344706",
      "Phagalia B.O": "344706",
      "Nokhada B.O": "344033",
      "Panyala Kallan B.O": "344033",
      "Sadecha B.O": "344033",
      "Golia Bhailan B.O": "344044",
      "Meli Bandha B.O": "344044",
      "Siner B.O": "344044",
      "Hire Ki Dhani B.O": "344037",
      "Punion Ka Tala B.O": "344037",
      "Shohda B.O": "344037",
      "Gora B.O": "344704",
      "Kartia B.O": "344704",
      "Kekar B.O": "344704",
      "Kitnoria B.O": "344704",
      "Loharwa B.O": "344704",
      "Mangta B.O": "344704",
      "Manki B.O": "344704",
      "Ogala B.O": "344704",
      "Udasar B.O": "344704",
      "Leelma B.O": "344501",
      "Munabao B.O": "344501",
      "Banta B.O": "344031",
      "Dedawas B.O": "344031",
      "Jalikheda B.O": "344031",
      "Junwa Jagir B.O": "344031",
      "Piprali B.O": "344031",
      "Bagawas B.O": "344026",
      "Soorpura B.O": "344026",
      "Batadu B.O": "344035",
      "Bhurtia B.O": "344035",
      "Chitar Ka Par B.O": "344035",
      "Harkhali B.O": "344035",
      "Kathadi B.O": "344043",
      "Khandap B.O": "344043",
      "Kundal B.O": "344043",
      "Nimbalkot B.O": "344033",
      "Gudanal B.O": "344044",
      "Indrana B.O": "344044",
      "Kuship B.O": "344044",
      "Maori B.O": "344044",
      "Jakhada B.O": "344037",
      "Khimpsar B.O": "344037",
      "Lapundara Tarli B.O": "344037",
      "Purawa B.O": "344704",
      "Ranasar Kallan B.O": "344704",
      "Rohila B.O": "344704",
      "Rohila West B.O": "344704",
      "Boothia B.O": "344501",
      "Mahilawas B.O": "344043",
      "Sella B.O": "344043",
      "Badnava B.O": "344032",
      "Patodi B.O": "344032",
      "Patodi Navatala B.O": "344032",
      "Richholi B.O": "344032",
      "Sajiyali Pk B.O": "344032",
      "Dharna B.O": "344801",
      "Itwaya B.O": "344801",
      "Mithoda B.O": "344801",
      "Umarlai B.O": "344027",
      "Akoda B.O": "344012",
      "Balau B.O": "344012",
      "Borwa B.O": "344703",
      "Sanjata B.O": "344703",
      "Taku Beri B.O": "344703",
      "Kotari B.O": "344021",
      "Rampura B.O": "344021",
      "Ranideshipura B.O": "344021",
      "Arti B.O": "344706",
      "Jharpa B.O": "344706",
      "Nosar B.O": "344033",
      "Sada B.O": "344033",
      "Sanpa Manji B.O": "344033",
      "Shobhala Jetmal II B.O": "344033",
      "Chandi Ka Par B.O": "344501",
      "Jaisindh R.S. B.O": "344501",
      "Jaisindhar B.O": "344501",
      "Sindhasawa Chauhan B.O": "344031",
      "Sindhasawa Harniyan B.O": "344031",
      "Undari Juni B.O": "344031",
      "Jhampli Kallan B.O": "344705",
      "Khudal B.O": "344705",
      "Rajdal B.O": "344705",
      "Swamy Ka Gaon B.O": "344705",
      "Asarwa [Araba] B.O": "344026",
      "Deora B.O": "344044",
      "Devandi B.O": "344044",
      "Shahar B.O": "344037",
      "Kabooli B.O": "344704",
      "Koja B.O": "344704",
      "Koliyana B.O": "344704",
      "Kothala B.O": "344704",
      "Khaniyani B.O": "344501",
      "Panchala B.O": "344501",
      "Rohidi B.O": "344501",
      "Shahdad Ka Par B.O": "344501",
      "Sundra B.O": "344501",
      "Bhakharpura B.O": "344031",
      "Bhedana B.O": "344031",
      "Daboi B.O": "344031",
      "Dangaria B.O": "344031",
      "Bandra B.O": "344035",
      "Bhimda B.O": "344035",
      "Chokhala B.O": "344035",
      "Uttarlai Mines B.O": "344035",
      "Bhagwa B.O": "344043",
      "Rakhi B.O": "344043",
      "Kalewa B.O": "344032",
      "Pachpadra Salt B.O": "344032",
      "Patau Khurd B.O": "344032",
      "Simarkhiya Purohitan B.O": "344032",
      "Tirsinghdi B.O": "344032",
      "Juna Mitha Kheda B.O": "344801",
      "Pau B.O": "344801",
      "Kanana B.O": "344027",
      "Sillore B.O": "344027",
      "Babuguleria B.O": "344502",
      "Gardia B.O": "344502",
      "Sajan Ka Par B.O": "344502",
      "Tamliyar B.O": "344502",
      "Balera B.O": "344012",
      "Goliar B.O": "344012",
      "Sanwlore B.O": "344012",
      "Taratara B.O": "344012",
      "Chawa B.O": "344703",
      "Kharantia Khurd B.O": "344703",
      "Ramsar Ka Kua B.O": "344703",
      "Sarli B.O": "344703",
      "Sewaniyala B.O": "344703",
      "Kamon Ka Bada B.O": "344021",
      "Khejadiyali B.O": "344021",
      "Majal B.O": "344021",
      "Sewali B.O": "344021",
      "Booth Jetmal B.O": "344708",
      "Ramdeoria B.O": "344708",
      "Sodiyar B.O": "344708",
      "Bamarwala B.O": "344706",
      "Bhanwar B.O": "344706",
      "Jaton Ka Bera B.O": "344706",
      "Kundanpura B.O": "344706",
      "Moolani B.O": "344706",
      "Ranasar Khurd B.O": "344033",
      "Moothali B.O": "344044",
      "Padarli B.O": "344044",
      "Thapan B.O": "344044",
      "Gida B.O": "344037",
      "Kosariya B.O": "344035",
      "Rohili B.O": "344035",
      "Dhiran B.O": "344043",
      "Motisara B.O": "344043",
      "Ramania B.O": "344043",
      "Bhandiyawas B.O": "344032",
      "Gopari B.O": "344032",
      "Kharda BS B.O": "344032",
      "Newai B.O": "344032",
      "Pareu B.O": "344032",
      "Simarkhiya Khara B.O": "344032",
      "Thob B.O": "344032",
      "Kankhi B.O": "344801",
      "Jethantri B.O": "344027",
      "Kankrala B.O": "344027",
      "Abhey Ka Par B.O": "344502",
      "Gagaria B.O": "344502",
      "Kachhabe Ki Dhani B.O": "344502",
      "Ranasar B.O": "344502",
      "Setrau B.O": "344502",
      "Dudhwakhurd B.O": "344012",
      "Junapatrasar B.O": "344012",
      "Taratara Math B.O": "344012",
      "Punion Ki Basti B.O": "344703",
      "Sarnu B.O": "344703",
      "Ajit B.O": "344021",
      "Bamseen B.O": "344021",
      "Deedhas B.O": "344021",
      "Karmawas B.O": "344021",
      "Ratri B.O": "344021",
      "Bachhrau B.O": "344708",
      "Dudhiya Kallan B.O": "344708",
      "Mehlu B.O": "344708",
      "Bakhasar B.O": "344706",
      "Bhalgaon B.O": "344706",
      "Harpalia B.O": "344706",
      "Janpalia B.O": "344706",
      "Navatala Bakhasar B.O": "344706",
      "Jajwa B.O": "344037",
      "Keshumbla Bhatian B.O": "344037",
      "Manpura Kharda B.O": "344037",
      "Swau Moolraj B.O": "344037",
      "Katarla B.O": "344704",
      "Khari B.O": "344704",
      "Lukhu B.O": "344704",
      "Mithara Khurd B.O": "344704",
      "Panoria B.O": "344704",
      "Sonari B.O": "344704",
      "Bandasar B.O": "344501",
      "Medusar B.O": "344501",
      "Tamlore B.O": "344501",
      "Alpura B.O": "344031",
      "Gandhavkallan B.O": "344031",
      "Nagarnava B.O": "344031",
      "Ratanpura B.O": "344031",
      "Hadwa B.O": "344705",
      "Balau Jati B.O": "344026",
      "Godawas B.O": "344026",
      "Gwalnada B.O": "344026",
      "Sarwadi Purohitan B.O": "344026",
      "Jalipa B.O": "344001",
      "Gehun B.O": "344001",
      "Hapon Ki Dhani B.O": "344001",
      "Redana B.O": "344001",
      "Khudasa B.O": "344001",
      "Khadeen B.O": "344001",
      "Bhadkha B.O": "344001",
      "Chandesara B.O": "344034",
      "Go R.S. B.O": "344034",
      "Kanod B.O": "344034",
      "Kharapar B.O": "344034",
      "Santara B.O": "344034",
      "Dakha B.O": "344022",
      "Janiyana B.O": "344022",
      "Kaludi B.O": "344022",
      "Mungda B.O": "344022",
      "Sinli Jagir B.O": "344022",
      "Tapra B.O": "344022",
      "Bhadresh B.O": "344011",
      "Bishala Agore B.O": "344011",
      "Chetrodi B.O": "344011",
      "Chuli B.O": "344011",
      "Fogera B.O": "344011",
      "Burhan Ka Tala B.O": "344702",
      "Dharasar B.O": "344702",
      "Dhok B.O": "344702",
      "Gohar Ka Tala B.O": "344702",
      "Kaprau B.O": "344702",
      "Kharia Rathodan B.O": "344702",
      "Konra B.O": "344702",
      "Lakhwara B.O": "344702",
      "Mate Ka Tala B.O": "344702",
      "Shobhala B.O": "344702",
      "Sriramwala B.O": "344702",
      "Boli B.O": "344704",
      "Chalkana B.O": "344704",
      "Dudhu B.O": "344704",
      "Doli Rajguran B.O": "344026",
      "Korna B.O": "344026",
      "Neori B.O": "344026",
      "Magne Ki Dhani B.O": "344001",
      "Mahabar B.O": "344001",
      "Gangala B.O": "344001",
      "Malpura B.O": "344001",
      "Nokh B.O": "344001",
      "Para B.O": "344001",
      "Sinyani B.O": "344001",
      "Jasai B.O": "344001",
      "Hathma B.O": "344001",
      "Kharia Tala B.O": "344001",
      "Baitu Panji B.O": "344034",
      "Bhimarl R.S. B.O": "344034",
      "Bhimarlai B.O": "344034",
      "Bhojasar B.O": "344034",
      "Dudhwa B.O": "344034",
      "Somesara B.O": "344034",
      "Asada B.O": "344022",
      "Nand B.O": "344011",
      "Sura B.O": "344011",
      "Unroad B.O": "344011",
      "KHABDALA B.O": "344011",
      "Adrim Ka Tala B.O": "344702",
      "Alamsar B.O": "344702",
      "Antia B.O": "344702",
      "Baori Kallan B.O": "344702",
      "Gumane Ka Tala B.O": "344702",
      "Juna Lakhwara B.O": "344702",
      "Paradia B.O": "344702",
      "Punjasar B.O": "344702",
      "Rabasar B.O": "344702",
      "Ramjan Ki Gaffan B.O": "344702",
      "Bamnore Amarshah B.O": "344704",
      "Bhag Bhare Ki Beri B.O": "344704",
      "Bhalikhal B.O": "344704",
      "Bhalisar B.O": "344704",
      "Bhanwarlai B.O": "344001",
      "Garal B.O": "344001",
      "Khara Rathodan B.O": "344001",
      "Indroi B.O": "344001",
      "Barmer Agore B.O": "344001",
      "Bola B.O": "344001",
      "Jaydu B.O": "344001",
      "Kagau B.O": "344001",
      "Kurla B.O": "344001",
      "Baitu Bhimji B.O": "344034",
      "Chidiya B.O": "344034",
      "Khattu B.O": "344034",
      "Kolu B.O": "344034",
      "Panawara B.O": "344034",
      "Uttarni B.O": "344034",
      "Bhunka B.O": "344022",
      "Budiwara B.O": "344022",
      "Jagsa B.O": "344022",
      "Kitnod B.O": "344022",
      "Sarana B.O": "344022",
      "Tilwara B.O": "344022",
      "Asadi B.O": "344011",
      "Bandhada B.O": "344011",
      "Dabar B.O": "344011",
      "Harsani B.O": "344011",
      "Malwa B.O": "344011",
      "Bhojaria B.O": "344702",
      "Binjrad B.O": "344702",
      "Dedusar B.O": "344702",
      "Dhanau B.O": "344702",
      "Jaisar B.O": "344702",
      "Kelnoor B.O": "344702",
      "Mitharau B.O": "344702",
      "Navatala Jetmal B.O": "344702",
      "Saiyon Ka Tala B.O": "344702",
      "Sarupe Ka Tala B.O": "344702",
      "Somarad B.O": "344702",
      "Uparla B.O": "344702",
      "Alamsariya B.O": "344704",
      "Bamarla B.O": "344704",
      "Bherudi B.O": "344704",
      "Bisarniya B.O": "344704",
      "Bore Charnan B.O": "344704",
      "Dolikallan B.O": "344026",
      "Mandali B.O": "344026",
      "Nagana B.O": "344026",
      "Raniadashipura B.O": "344026",
      "Derasar B.O": "344001",
      "Langera B.O": "344001",
      "Mithra Khurd B.O": "344001",
      "Atimalani B.O": "344001",
      "Shivkar B.O": "344001",
      "Kapurdi B.O": "344001",
      "Marudi B.O": "344001",
      "Uttarl R.S. B.O": "344001",
      "Akadara B.O": "344034",
      "Baitu Chimanji B.O": "344034",
      "Madhasar B.O": "344034",
      "Asotra B.O": "344022",
      "Bithuja B.O": "344022",
      "Adarsh Basti B.O": "344011",
      "Balewa B.O": "344011",
      "Girab B.O": "344011",
      "Lunukhurd B.O": "344011",
      "Binjasar B.O": "344702",
      "Booth Rathodan B.O": "344702",
      "Intada B.O": "344702",
      "Jalila B.O": "344702",
      "Mithe Ka Tala B.O": "344702",
      "Nehron Ka Tala B.O": "344702",
      "Netrad B.O": "344702",
      "Ratasar B.O": "344702",
      "Sanwa B.O": "344702",
      "Shobhala Jetmal B.O": "344702",
      "Arniyali B.O": "344704",
      "Bhimthal B.O": "344704",
      "Bhunia B.O": "344704",
      "Barmer H.O": "344001",
      "Baitu S.O": "344034",
      "Balotra IA S.O": "344022",
      "Balotra S.O": "344022",
      "Barmer Coll S.O": "344001",
      "Bishala S.O": "344011",
      "Dhorimana S.O": "344704",
      "Gadra Road S.O": "344501",
      "Padru S.O": "344801",
      "Parlu S.O": "344027",
      "Rawatsar S.O (Barmer)": "344703",
      "Balotra SB S.O": "344022",
      "Barmer DB S.O": "344001",
      "Barmer RS S.O": "344001",
      "Gunga S.O": "344705",
      "Mokalsar S.O": "344043",
      "Ramsar S.O (Barmer)": "344502",
      "Samdari RS S.O": "344021",
      "Sanawara S.O": "344708",
      "Sedwa S.O": "344706",
      "Shiv S.O": "344701",
      "Sindhari S.O": "344033",
      "Swau Padamsingh S.O": "344037",
      "Barmer PR S.O": "344001",
      "Jasol S.O": "344024",
      "Kavas S.O": "344035",
      "Mewanagar S.O": "344025",
      "Pachpadra City S.O": "344032",
      "Samdari S.O": "344021",
      "Siwana S.O": "344044",
      "Chohtan S.O": "344702",
      "Gudamalani S.O": "344031",
      "Kalyanpur S.O (Barmer)": "344026",
      "Ranigaon S.O": "344012"
    },
    "JODHPUR": {
      "NDC Jodhpur": "342002",
      "Paldi Khichiyan": "342304",
      "Jhak BO": "342602",
      "Kharia Mithapur BO": "342602",
      "Pichiyak BO": "342602",
      "Gingala BO": "342312",
      "Hatundi BO": "342312",
      "Jakhan BO": "342312",
      "Kapooria BO": "342312",
      "Poonasar BO": "342312",
      "Kolu Pabuji BO": "342314",
      "Kolu Rathoran BO": "342314",
      "Sagrau BO": "342314",
      "Amla BO": "342308",
      "Barjasar BO": "342308",
      "Denok BO": "342308",
      "Sewania BO": "342604",
      "Barsallu Kallan BO": "342312",
      "Champasar BO": "342312",
      "Kinjari BO": "342312",
      "Ridmalsar BO": "342312",
      "Rohina BO": "342312",
      "Kanodia BO": "342314",
      "Sanurij BO": "342314",
      "Bhacharna BO": "342801",
      "Dhanari Kallan BO": "342029",
      "Kajnau Kallan BO": "342029",
      "Karwar BO": "342037",
      "Kasti BO": "342037",
      "Lavera Khurd BO": "342037",
      "Lordi Panditji BO": "342037",
      "Nandiya Khurd BO": "342029",
      "Paschimi Dhani BO": "342302",
      "Samrau BO": "342302",
      "Mogra Kallan BO": "342802",
      "Satlana BO": "342802",
      "Sikarpura BO": "342802",
      "Surpura BO": "342304",
      "Bhenser Chawandiali BO": "342305",
      "Umed Nagar BO": "342305",
      "Dabri BO": "342303",
      "Khabra Khurd BO": "342303",
      "Khetasar BO": "342301",
      "Sar BO": "342801",
      "Udaliyawas BO": "342602",
      "Bugri BO": "342312",
      "Khindakore BO": "342312",
      "Laxman Nagar BO": "342312",
      "Raimalwara BO": "342312",
      "Tapoo BO": "342312",
      "Kushlawa BO": "342314",
      "Thadia BO": "342314",
      "Moriya Munjasar BO": "342308",
      "Bhawad BO": "342037",
      "Kherapa BO": "342029",
      "Nandia Kallan BO": "342029",
      "Sawant Kuan Khurd BO": "342037",
      "Dhelana BO": "342302",
      "Lohawat Jatabas BO": "342302",
      "Dholasar BO": "342308",
      "Padiyal BO": "342308",
      "Anvana BO": "342037",
      "Danwra BO": "342037",
      "Kelva Kallan BO": "342037",
      "Netra BO": "342037",
      "Jammeshwar Nagar BO": "342302",
      "Palli BO": "342302",
      "Guda Vishnoiyan BO": "342802",
      "Kakani BO": "342802",
      "Khara Bera Purohitan BO": "342802",
      "Kharda Mewasa BO": "342305",
      "Baran Khurd BO": "342303",
      "Bhikamkore BO": "342303",
      "Khara Bera Bheemawatan BO": "342802",
      "Khejarli Kallan BO": "342802",
      "Punjla BO": "342304",
      "Jud BO": "342305",
      "Manaklao BO": "342305",
      "Rampura Bhatiyan BO": "342305",
      "Bethwasia BO": "342303",
      "Chandarakh BO": "342303",
      "Patel Nagar BO": "342604",
      "Feench BO": "342801",
      "Piparli BO": "342801",
      "Rohicha Kallan BO": "342801",
      "Rohicha Khurd BO": "342801",
      "Sarecha BO": "342801",
      "Palina BO": "342308",
      "Shaitan Singh Nagar BO": "342308",
      "Lavera Kallan BO": "342037",
      "Dhandiya BO": "342802",
      "Lodi Daijran BO": "342001",
      "Chokhan BO": "342001",
      "Bambore Darjiyan BO": "342001",
      "Neora BO": "342303",
      "Padasala BO": "342303",
      "Thob BO": "342303",
      "Loonawas Khara BO": "342014",
      "Narnadi BO": "342014",
      "Sinali BO": "342014",
      "Subdand BO": "342014",
      "Chandsama BO": "342314",
      "Dadhu BO": "345021",
      "Mandla BO": "345021",
      "Bavarli BO": "342001",
      "Bamnu BO": "345021",
      "Burkiya BO": "342606",
      "Utwaliya BO": "342314",
      "Daipara Khichiyan BO": "342014",
      "Dhawa BO": "342014",
      "Doli BO": "342014",
      "Janadesar BO": "342014",
      "Dayakore BO": "342309",
      "Nosar BO": "342303",
      "Sirmandi BO": "342303",
      "Badliya BO": "342014",
      "Chali BO": "342014",
      "Loonawas Kallan BO": "342014",
      "Lorta Achalawatan BO": "342309",
      "Bhandukalla BO": "342014",
      "Chincharli BO": "342014",
      "Jhanwar BO": "342014",
      "Khudala BO": "342014",
      "Bhojakore BO": "342309",
      "Gilakore BO": "342309",
      "Barnau BO": "342309",
      "Bher BO": "342309",
      "Bari Baori BO": "342301",
      "Nathrau BO": "342309",
      "Dhandhaniya Bhayalan BO": "342001",
      "Surani BO": "342001",
      "Bhiyasar BO": "342311",
      "Suwap BO": "342311",
      "Barni Khurd BO": "342901",
      "Dadmi BO": "342901",
      "Belwa Ranajee BO": "342023",
      "Jhinjhinyala BO": "342023",
      "Bhatinda BO": "342027",
      "Bisalpur BO": "342027",
      "Salwa Kallan BO": "342027",
      "Kanasar BO": "342307",
      "Loona BO": "342307",
      "Lamba BO": "342605",
      "Olvi BO": "342605",
      "Tilwasni BO": "342605",
      "Bagoria BO": "342603",
      "Ustran BO": "342603",
      "Jetiwas BO": "342602",
      "Dhandhaniya BO": "342001",
      "Cheemana BO": "342311",
      "Ghantiyali BO": "342311",
      "Ishru BO": "342311",
      "Jaisla BO": "342311",
      "Mattoda BO": "342311",
      "Nimbo Ka Talab BO": "342311",
      "Belwa Rajawtan  BO": "342023",
      "Bhandu Charni BO": "342023",
      "Bhandu Jati BO": "342023",
      "Judia BO": "342023",
      "Kui Inda BO": "342023",
      "Chandelao BO": "342027",
      "Daikara BO": "342027",
      "Gangani BO": "342027",
      "Jajiwal Kallan BO": "342027",
      "Jaleli Fozdara BO": "342027",
      "Bari Sidh BO": "342307",
      "Chakhoo BO": "342307",
      "Malamsingh Ki Sidh BO": "342307",
      "Noore Ki Bhuj BO": "342307",
      "Boyal BO": "342605",
      "Hungaon Kallan BO": "342605",
      "Kaprda BO": "342605",
      "Padasla Kallan BO": "342605",
      "Rawar BO": "342605",
      "Silari BO": "342605",
      "Birani BO": "342603",
      "Nadsar BO": "342603",
      "Barli BO": "342001",
      "Badu BO": "342311",
      "Gajsinghpura BO": "342901",
      "Garasni BO": "342901",
      "Mageria BO": "342901",
      "Paldi Ranawatan BO": "342901",
      "Radod BO": "342901",
      "Rajlani BO": "342901",
      "Balesar Durgawatan BO": "342023",
      "Dangiawas BO": "342027",
      "Dantiwara BO": "342027",
      "Kakelao BO": "342027",
      "Khatiyasani BO": "342027",
      "Modi Joshiyan BO": "342027",
      "Palasni BO": "342027",
      "Udat BO": "342307",
      "Joliyali BO": "342001",
      "Agolai BO": "342001",
      "Bapini BO": "342311",
      "Bhojasar BO": "342311",
      "Kelansar BO": "342311",
      "Nokhra Bhatiyan BO": "342311",
      "Basni Harisingh BO": "342901",
      "Bastawa BO": "342023",
      "Belwa Bagawatan BO": "342023",
      "Gopalsar BO": "342023",
      "Nimba Ka Gaon BO": "342023",
      "Banwarla BO": "342027",
      "Binawas BO": "342027",
      "Birami BO": "342027",
      "Jajeli Daikara BO": "342027",
      "Peethawas BO": "342027",
      "Kansingh Ki Sidh BO": "342307",
      "Khidrat BO": "342307",
      "Bala BO": "342605",
      "Hariada BO": "342605",
      "Malkosni BO": "342605",
      "Ramasni BO": "342605",
      "Ghanamagra BO": "342605",
      "Birai BO": "342306",
      "Hiradesar BO": "342603",
      "Mailana BO": "342603",
      "Surpura Khurd BO": "342603",
      "Barna BO": "342602",
      "Bengti Kallan BO": "342301",
      "Malar BO": "342606",
      "Raneri BO": "342301",
      "Shekhasar BO": "342301",
      "Khangta BO": "342606",
      "Kharia Khangar BO": "342606",
      "Kheri Salwa BO": "342606",
      "Kood BO": "342606",
      "Nandiya Prabhawati BO": "342606",
      "Buchakallan BO": "342601",
      "Chirdani BO": "342601",
      "Chodhan BO": "342601",
      "Chokari Kallan BO": "342601",
      "Sindhipura BO": "342601",
      "Siyara BO": "342601",
      "Deda BO": "342025",
      "Deda Hapan BO": "342025",
      "Dewatu BO": "342025",
      "Khiny Asariya BO": "342025",
      "Lawaran BO": "342025",
      "Sai BO": "342022",
      "Suwalia BO": "342022",
      "Chuturpura BO": "342022",
      "Beru BO": "342024",
      "Chawanda BO": "342024",
      "Khirja Ashan BO": "342028",
      "Barla Basni BO": "342306",
      "Bhalasariya BO": "342306",
      "Binjwaria BO": "342306",
      "Chamu BO": "342306",
      "Deriya BO": "342306",
      "Baru BO": "342301",
      "Hopardi BO": "342301",
      "Jalora BO": "342301",
      "Lordiyan BO": "342301",
      "Tekra BO": "342301",
      "Bhundana BO": "342606",
      "Rajshri Nagar BO": "342606",
      "Ramdawas Kallan BO": "342606",
      "Sewki Kallan BO": "342606",
      "Madaliya BO": "342601",
      "Sambhariya BO": "342601",
      "Sathin BO": "342601",
      "Nandra Kallan BO": "342015",
      "Nandri BO": "342015",
      "Chordiyan BO": "342025",
      "Pabusar BO": "342021",
      "Shekhala BO": "342025",
      "Garha BO": "342022",
      "Himmatpura BO": "342022",
      "Raisar BO": "342022",
      "Popawas BO": "342024",
      "Khudiyala BO": "342306",
      "Mandial Kallan BO": "342306",
      "Narwa BO": "342306",
      "Panchala Khurd BO": "342306",
      "Bengti Khurd BO": "342301",
      "Chilla BO": "342301",
      "Jamba BO": "342301",
      "Mohri BO": "342301",
      "Motai BO": "342301",
      "Neneu BO": "342301",
      "Bucheti BO": "342606",
      "Dhoru BO": "342606",
      "Palri Sidhan BO": "342606",
      "Devatara BO": "342606",
      "Bhagasani BO": "342601",
      "Hariyadhana BO": "342601",
      "Khawaspura BO": "342601",
      "Kosana BO": "342601",
      "Nanan BO": "342601",
      "Riyan BO": "342601",
      "Salawas BO": "342013",
      "Kharda Randheer BO": "342015",
      "Bhaloo Kallan BO": "342025",
      "Dasania BO": "342021",
      "Jaitsar BO": "342021",
      "Kalau BO": "342021",
      "Ketu Hema BO": "342025",
      "Solankiya Tala BO": "342025",
      "Bhungra BO": "342022",
      "Sointra BO": "342022",
      "Ghantiyala BO": "342024",
      "Keru BO": "342024",
      "Khirja Khas BO": "342028",
      "Khirja Tibna BO": "342028",
      "Banaka Bas BO": "342306",
      "Berdon Ka Bass BO": "342306",
      "Cherai BO": "342306",
      "Gheora BO": "342306",
      "Jelu Gagari BO": "342306",
      "Utamber BO": "342306",
      "Bithdi BO": "342301",
      "Hindalgore BO": "342301",
      "Mokheri BO": "342301",
      "Singhda BO": "342301",
      "Tepu BO": "342301",
      "Artiyan Kallan BO": "342606",
      "Borvi Khurd BO": "342606",
      "Kudi BO": "342606",
      "Ratkuria BO": "342606",
      "Khejarla BO": "342601",
      "Ramaniyana BO": "342601",
      "Ransi Gaon BO": "342601",
      "Jhalamand BO": "342013",
      "Fitkasani BO": "342015",
      "Asarlai BO": "342025",
      "Bhalu Rajwan BO": "342025",
      "Jethania BO": "342021",
      "Ketu Kallan BO": "342025",
      "Dheerpura BO": "342025",
      "Bhomsagar BO": "342022",
      "Chaba BO": "342022",
      "Dev rajgarh BO": "342022",
      "Kali Beri BO": "342024",
      "Malunga BO": "342024",
      "Salori BO": "342024",
      "Siyada BO": "342028",
      "Balarwa BO": "342306",
      "Devania BO": "342306",
      "Indroka BO": "342306",
      "Jodhpur Chopasni Road SO": "342003",
      "Jodhpur City SO": "342001",
      "Balesar SO": "342023",
      "Jodhpur KUM Mandore Road SO": "342007",
      "Jodhpur University Campus SO": "342001",
      "Khichan SO": "342308",
      "Bilara SO": "342602",
      "Dunara SO": "342801",
      "Jodhpur Bhagat Ki Kothi SO": "342001",
      "Jodhpur Girdikot SO": "342001",
      "Jodhpur KUM Bhagat Ki Kothi SO": "342005",
      "Jodhpur Kachery SO": "342006",
      "Jodhpur Mahamandir SO": "342006",
      "Jodhpur Residency Road SO": "342011",
      "Banar SO": "342027",
      "Bhopalgarh SO": "342603",
      "Borunda SO": "342604",
      "Chadi SO": "342312",
      "Dechu SO": "342314",
      "Jalori Gate SO": "342003",
      "Jodhpur Aerodrame SO": "342011",
      "Jodhpur BSF Trg Centre SO": "342026",
      "Jodhpur Cloth Market SO": "342001",
      "Jodhpur Marudhar Ind  Area SO": "342005",
      "Jodhpur Rasala Road SO": "342006",
      "Kabutaron Ka Chowk SO": "342001",
      "Kuri Bhagtasni Housing Board SO": "342005",
      "Bap SO": "342307",
      "Bhavi SO": "342605",
      "Boranada SO": "342012",
      "Jodhpur Agency SO": "342011",
      "Jodhpur Shastri Nagar SO": "342003",
      "Jodhpur Umaid Bhawan SO": "342006",
      "Jodhpur HO": "342001",
      "Luni SO": "342802",
      "Nandanwan SO": "342008",
      "Osian SO": "342303",
      "Peelwa SO": "342309",
      "Pipar Chopra Bazar SO": "342601",
      "Pipar SO": "342601",
      "Railway Office SO": "342001",
      "Lavera Baori SO": "342037",
      "Phalodi SO": "342301",
      "Pipar Road SO": "342606",
      "Shergarh SO Jodhpur": "342022",
      "Subhash Nagar Jodhpur SO": "342008",
      "Teori SO": "342306",
      "Soyla PO": "342029",
      "Aau SO": "342311",
      "Asop SO": "342901",
      "Lohawat SO": "342302",
      "Mandore SO": "342304",
      "Pal SO": "342014",
      "Ratanada SO": "342011",
      "Setrawa SO": "342025",
      "Tena SO": "342028",
      "Mathania SO": "342305",
      "Phalodi Sadar Bazar SO": "342301",
      "Pratap Nagar SO Jodhpur": "342003",
      "Soorsagar SO": "342024",
      "Sangaria SO Jodhpur": "342013",
      "Saran Nagar SO": "342015",
      "Siwanchi Gate SO": "342001",
      "Rajasthan High Court NB SO": "342013",
      "Somesar SO": "342021",
      "IIT JODHPUR": "342030"
    },
    "JHUNJHUNU": {
      "Bhainsawata Kalan S.O": "333517",
      "Mahansar B.O": "331027",
      "Chanana S.O": "333020",
      "Kankaria S.O": "333055",
      "Churella S.O": "333010",
      "Bahadurwas B.O": "333704",
      "Bajisar B.O": "333704",
      "Chanderapura B.O": "333704",
      "Sigra B.O": "333704",
      "Balaria B.O": "333705",
      "Kishorepura B.O": "333053",
      "Mainpura B.O": "333053",
      "Badet B.O": "331026",
      "Budhaka Bas B.O": "331026",
      "Girdharpura Shahpura B.O": "333307",
      "Inderpura B.O": "333307",
      "Kot B.O": "333307",
      "Nangal B.O": "333307",
      "Khalasi B.O": "333704",
      "Lumawas B.O": "333704",
      "Wahidpura B.O": "333704",
      "Ghoriwara Kalan B.O": "333705",
      "Kaseru B.O": "333705",
      "Bay B.O": "333042",
      "Chobdaranki Dhani B.O": "333042",
      "Nawalari B.O": "333042",
      "Bibasar B.O": "333041",
      "Siriyasar Kaklan B.O": "333041",
      "Dhamora B.O": "333308",
      "Kakarana B.O": "333053",
      "Khoh B.O": "333053",
      "Pachlangi B.O": "333801",
      "Kaliasar B.O": "331026",
      "Bagora B.O": "333307",
      "Hanumanpura B.O": "333704",
      "Kuharu B.O": "333704",
      "Toliasar B.O": "333704",
      "Ghoriwara Khurd B.O": "333705",
      "Mandasi B.O": "333705",
      "Barwasi B.O": "333042",
      "Chelasi B.O": "333042",
      "Bhojnagar B.O": "333308",
      "Naya Parasrampura B.O": "333308",
      "Kankaria B.O": "333053",
      "Papara B.O": "333801",
      "Jabasar B.O": "331026",
      "Khyali B.O": "331026",
      "Dholekhera B.O": "333307",
      "Maharadasi B.O": "333704",
      "Mojas B.O": "333704",
      "Narsinghanni B.O": "333705",
      "Pabana B.O": "333705",
      "Dhania B.O": "333042",
      "Khirod B.O": "333042",
      "Kolsia B.O": "333042",
      "Monwari B.O": "333042",
      "Bharu B.O": "333041",
      "Bhojasar B.O": "333041",
      "Derwala B.O": "333041",
      "Dhigal B.O": "333041",
      "Durana B.O": "333041",
      "Hetamsar B.O": "333041",
      "Chanwara B.O": "333053",
      "Deepura B.O": "333053",
      "Gadala Kalkan B.O": "333053",
      "Gura B.O": "333053",
      "Newari B.O": "333053",
      "Bagoli B.O": "333801",
      "Jodhpura B.O": "333801",
      "Manaksas B.O": "333801",
      "Chhawasari B.O": "333012",
      "Hukampura B.O": "333012",
      "Ked B.O": "333012",
      "Khatkar B.O": "333012",
      "Khinwasar B.O": "333012",
      "Bamanwas B.O": "333026",
      "Bhukana B.O": "333026",
      "Gadakhera B.O": "333026",
      "Pichanawa B.O": "333026",
      "Badsari Ka Bas B.O": "333026",
      "Gidania B.O": "333027",
      "Chinchroli B.O": "333501",
      "Madhogarh B.O": "333501",
      "Sanjay Nagar B.O": "333501",
      "Adarsh Nagar B.O": "333023",
      "Jaipahari B.O": "333023",
      "Badbar B.O": "333502",
      "Kalakhari B.O": "333502",
      "Kali Pahari B.O": "333024",
      "Mohanpura B.O": "333024",
      "Asalwas B.O": "333033",
      "Berla B.O": "333033",
      "Kukloth Kalan B.O": "333033",
      "Swami Sehi B.O": "333026",
      "Nangli Gujran B.O": "333026",
      "Sari B.O": "333027",
      "Alipur B.O": "333023",
      "Bakhatawarpura B.O": "333023",
      "Desusar B.O": "333023",
      "Khudana B.O": "333023",
      "Narnod Maligaon B.O": "333023",
      "Pakori Dhani B.O": "333023",
      "Saga B.O": "333502",
      "Sahad B.O": "333502",
      "Sirsala B.O": "333502",
      "Sultana Ahiran B.O": "333502",
      "Bharunda Kalan B.O": "333024",
      "Bhudanpura B.O": "333033",
      "Dhingaria B.O": "333033",
      "Dhulwa B.O": "333033",
      "Gadli B.O": "333033",
      "Bigodana B.O": "333026",
      "Chanana B.O": "333026",
      "Nangli Saledi Singh B.O": "333026",
      "Bhatiwar B.O": "333026",
      "Rasoolpur B.O": "333026",
      "Aduka B.O": "333026",
      "Lamba Gothra B.O": "333026",
      "Ram Rikh Ki Dhani B.O": "333026",
      "Sehi Kalan B.O": "333026",
      "Heerawaa B.O": "333027",
      "Jodha Ka Bas B.O": "333027",
      "Khadot B.O": "333027",
      "Khandawa B.O": "333502",
      "Lambi Ahir B.O": "333502",
      "Mainana B.O": "333502",
      "Palota B.O": "333502",
      "Sanwlod B.O": "333502",
      "Bharunda Khurd B.O": "333024",
      "Nayasar B.O": "333001",
      "Samsapur B.O": "333001",
      "Shinshiya B.O": "333001",
      "Abusar B.O": "333001",
      "Udas B.O": "333001",
      "Bas Ghasiram B.O": "331025",
      "Ajari Bari B.O": "333021",
      "Binjusar B.O": "333021",
      "Hasalsar B.O": "333021",
      "Malsar B.O": "333021",
      "Bidasar B.O": "331027",
      "Birmi B.O": "331027",
      "Todpura B.O": "333303",
      "Phooskhani B.O": "333701",
      "Hansasari B.O": "333011",
      "Sonasar B.O": "333011",
      "Dabri Baloda B.O": "333707",
      "Delsar Kaklan B.O": "333707",
      "Deogaon B.O": "333707",
      "Jejusar B.O": "333707",
      "Togara Kalan B.O": "333707",
      "Togara Khurd B.O": "333707",
      "Bugala B.O": "333305",
      "Chhau B.O": "333305",
      "Kari B.O": "333305",
      "Majhau B.O": "333305",
      "Hamiri B.O": "333001",
      "Lootu B.O": "333001",
      "Indali B.O": "333001",
      "Bhurasar B.O": "333001",
      "Bishanpura B.O": "333021",
      "Signore B.O": "333032",
      "Dhilsar B.O": "331027",
      "Dulchas B.O": "331027",
      "Gangiasar B.O": "331027",
      "Patoda B.O": "331027",
      "Tain B.O": "331027",
      "Kharkhari B.O": "333011",
      "Kairu B.O": "333707",
      "Bar Ki Dhani B.O": "333022",
      "Raghunathpura B.O": "333029",
      "Patusari B.O": "333001",
      "Purohitonki Dhani B.O": "333001",
      "Bakara B.O": "333001",
      "Hansasar B.O": "333001",
      "Haripura B.O": "331025",
      "Kant B.O": "331025",
      "Sithal B.O": "333021",
      "Chandawa B.O": "331027",
      "K.K. Dhani B.O": "331027",
      "Kodesar B.O": "331027",
      "Girawadi B.O": "333302",
      "Jahaz B.O": "333302",
      "Mandawara B.O": "333302",
      "Mauta B.O": "333302",
      "Sotwara B.O": "333707",
      "Duriya B.O": "333022",
      "Jaitpura B.O": "333034",
      "Kakreu Kalan B.O": "331028",
      "Charawas B.O": "333026",
      "Nunia Gothra B.O": "333026",
      "Ojtu B.O": "333026",
      "Barau B.O": "333026",
      "Kidwana B.O": "333026",
      "Gadrata B.O": "333501",
      "Kalota B.O": "333501",
      "Budana B.O": "333023",
      "Kasimpura B.O": "333023",
      "Lalpur B.O": "333023",
      "Lamba B.O": "333023",
      "Jhanjha B.O": "333502",
      "Khajpur Naya B.O": "333024",
      "Balonda B.O": "333033",
      "Kuloth Chhoti B.O": "333033",
      "Niradhana B.O": "331028",
      "Pithusar B.O": "331028",
      "Barwa B.O": "333304",
      "Basawa B.O": "333304",
      "Gothara B.O": "333304",
      "Bhikhansar B.O": "331030",
      "Shekhasar B.O": "333001",
      "Bhimsar B.O": "333001",
      "Kolinda B.O": "333001",
      "Paratappura B.O": "333001",
      "Khatehpura B.O": "333001",
      "Rampura B.O": "333036",
      "Bajawa B.O": "333025",
      "Deorasar B.O": "333021",
      "Gilonki  Dhani B.O": "333032",
      "Diloi South B.O": "331027",
      "Punio Ka Bas3 B.O": "331027",
      "Lohargal B.O": "333303",
      "Tonk Chhhilri B.O": "333303",
      "Ladusar B.O": "333011",
      "Loona B.O": "333011",
      "Kumawas B.O": "333707",
      "Ranasar B.O": "333707",
      "Bamlas B.O": "333022",
      "Dahani Risiyan B.O": "333022",
      "Posana B.O": "333022",
      "Bhagera B.O": "333305",
      "Niwai B.O": "333305",
      "Birol B.O": "333304",
      "Gharadana Khurd B.O": "333514",
      "Loyal B.O": "333514",
      "Manota Jatan B.O": "333514",
      "Jeeni B.O": "333030",
      "Pharat B.O": "333030",
      "Badalwas B.O": "333503",
      "Bagor B.O": "333503",
      "Ghasera B.O": "333034",
      "Jharoda B.O": "333034",
      "Kajala B.O": "333034",
      "Udamandi B.O": "333034",
      "Badangarh B.O": "333035",
      "Churina B.O": "333515",
      "Gunti B.O": "333515",
      "Nihaloth B.O": "333515",
      "Panthroli B.O": "333515",
      "Jherli B.O": "333031",
      "Khudania B.O": "333031",
      "Ladunda B.O": "333031",
      "Likhawa B.O": "333031",
      "Morwa B.O": "333031",
      "Makro B.O": "333504",
      "Nalpur B.O": "333503",
      "Papurana B.O": "333503",
      "Tihara B.O": "333503",
      "Jakhora B.O": "333025",
      "Nalawa B.O": "333025",
      "Doodwa B.O": "332746",
      "Gujarwas B.O": "333516",
      "Khanpur B.O": "333516",
      "Moi Purani B.O": "333516",
      "Nand B.O": "333001",
      "Kherala B.O": "333035",
      "Santore B.O": "333515",
      "Sohali B.O": "333515",
      "Bangothari B.O": "333031",
      "Beri B.O": "333031",
      "Norangpura B.O": "332716",
      "Mandri B.O": "332746",
      "Ranwa B.O": "332746",
      "Basawata Khurd B.O": "333516",
      "Chittausa B.O": "333516",
      "Shahpura B.O": "333516",
      "Thali B.O": "333516",
      "Keharpura B.O": "333028",
      "Kishorpura B.O": "333028",
      "Kithana B.O": "333028",
      "Kyamsar B.O": "333028",
      "Maharampur B.O": "333028",
      "Padampura B.O": "333028",
      "Solana B.O": "333028",
      "Agawana Khurd B.O": "333029",
      "Bhawathari B.O": "333029",
      "Kakoda B.O": "333029",
      "Nangali Gujarwas B.O": "333036",
      "Sihor B.O": "333036",
      "Ureeka B.O": "333033",
      "Bhobia B.O": "333030",
      "Dhana B.O": "333504",
      "Manota Kalan B.O": "333504",
      "Beelawa B.O": "333503",
      "Dada Fatehpura B.O": "333503",
      "Bhuriwas B.O": "333034",
      "Nuhania B.O": "333034",
      "Dabri B.O": "333025",
      "Bhaloth B.O": "333515",
      "Dhandhar Ka Bas B.O": "333031",
      "Dobara B.O": "333031",
      "Dulaniya B.O": "333031",
      "Kaji B.O": "333031",
      "Pantharia B.O": "333031",
      "Sujdola B.O": "333031",
      "Dalelpura B.O": "332716",
      "Padewa B.O": "332716",
      "Dalota B.O": "332746",
      "Thathwari B.O": "332746",
      "Dhadhot Kalan B.O": "333516",
      "Ghardana Kalan B.O": "333516",
      "Puhania B.O": "333516",
      "Gowala B.O": "333028",
      "Kasani B.O": "333029",
      "Pilod B.O": "333029",
      "Mehara Jatuwas B.O": "333036",
      "Churella B.O": "333001",
      "Mahapalwas B.O": "333033",
      "Dhani Badan B.O": "333514",
      "Kharkhara B.O": "333514",
      "Teelawali B.O": "333514",
      "Dhindawa Aguna B.O": "333030",
      "Tatija B.O": "333504",
      "Bansiyal B.O": "333503",
      "Chirani B.O": "333503",
      "Tyonda B.O": "333503",
      "Dhakamandi B.O": "333034",
      "Lalamandi B.O": "333034",
      "Sagawa B.O": "333034",
      "Bajala B.O": "333025",
      "Budania B.O": "333025",
      "Deoroad B.O": "333035",
      "Bhirr B.O": "333515",
      "Deolawas B.O": "333515",
      "Pacheri Chhoti B.O": "333515",
      "Raipur Ahiran B.O": "333515",
      "Chhapara B.O": "333031",
      "Doodawa B.O": "333031",
      "Haminpur B.O": "333031",
      "Peepli B.O": "333031",
      "Hardia B.O": "332716",
      "Dhosi B.O": "332746",
      "Gorir B.O": "332746",
      "Dumoli Khurd B.O": "333516",
      "Goth B.O": "333516",
      "Muradpur B.O": "333516",
      "Raipur Jatan B.O": "333516",
      "Thincholi B.O": "333028",
      "Lotia B.O": "333029",
      "Kishanpura B.O": "333036",
      "Chirawa H.O": "333026",
      "Jhunjhunu H.O": "333001",
      "Ardawata S.O": "333027",
      "Babai S.O (Jhujhunu)": "333501",
      "Bagar S.O": "333023",
      "Jakhod S.O": "333033",
      "Kajara S.O": "333030",
      "Khetri Bazar S.O": "333503",
      "Khetri Nagar S.O": "333504",
      "Khetri S.O (Jhujhunu)": "333503",
      "Mandrella S.O": "333025",
      "Narhar S.O": "333035",
      "Pacheri Badi S.O": "333515",
      "Pilani S.O": "333031",
      "Shimala S.O": "332746",
      "Sultana S.O": "333028",
      "Tibabasai S.O": "333036",
      "Chirana S.O": "333303",
      "Dundlod RS S.O": "333705",
      "Footla Bazar S.O": "333001",
      "Gudhagorjika S.O": "333022",
      "Mandawa Bazar S.O": "333704",
      "Nawalgarh S.O": "333042",
      "Parasrampura S.O": "333308",
      "Kcpt Khetri Nagar S.O": "333504",
      "Kolihan Nagar S.O": "333503",
      "Surajgarh Bazar S.O": "333029",
      "Baragaon (Jhunjhunu)S.O": "333021",
      "Jakhal S.O": "333305",
      "Buhana S.O": "333502",
      "Ceeri Pilani S.O": "333031",
      "Chirawa Town S.O": "333026",
      "Jasrapur S.O": "333514",
      "Kuharwas S.O": "333034",
      "Singhana S.O": "333516",
      "Surajgarh S.O": "333029",
      "V.V. Pilani S.O": "333031",
      "Chhapoli S.O": "333302",
      "Jhajhar S.O": "333304",
      "Jhunjhunu City S.O": "333001",
      "Malsisar S.O": "331028",
      "Mukundgarh S.O": "333705",
      "Nansagate Nawalgarh S.O": "333042",
      "Saraisurpura S.O": "333801",
      "Tamkore S.O": "331026",
      "Udaipurwati S.O": "333307",
      "Islampur S.O (Jhujhunu)": "333024",
      "Sefragunwar S.O": "332716",
      "Alsisar S.O": "331025",
      "Bhorki S.O": "333032",
      "Bissau S.O": "331027",
      "C.R. Mukundgarh S.O": "333705",
      "Churiajitgarh S.O": "333701",
      "Dhanuri S.O": "333011",
      "Doomra S.O": "333707",
      "Dundlod S.O": "333702",
      "Gandhi Chowk Jhunjhunu S.O": "333001",
      "Jhunjhunu Bazar S.O": "333001",
      "Jhunjhunu Court S.O": "333001",
      "Mahansar S.O": "331030",
      "Mandawa S.O": "333704",
      "Nua S.O": "333041",
      "Titanwar S.O": "333012",
      "Ponkh S.O": "333053"
    },
    "JALORE": {
      "Dantiwas B.O": "343029",
      "Kawatra B.O": "343030",
      "Loonawas B.O": "343030",
      "Rah B.O": "343030",
      "Alri B.O": "343049",
      "Balwara B.O": "343042",
      "Bhawrani B.O": "343042",
      "Tikhi B.O": "343042",
      "Sikwara B.O": "307803",
      "Somta B.O": "307803",
      "Binjrol B.O": "343040",
      "Raniwara Khurd B.O": "343040",
      "Sankad B.O": "343040",
      "Sewara B.O": "343041",
      "Arnay B.O": "343041",
      "Bichhawadi B.O": "343041",
      "Birol B.O": "343041",
      "Duthwa B.O": "343041",
      "Golasan B.O": "343041",
      "Luniyasar B.O": "343041",
      "Nenol B.O": "343041",
      "Sarwana B.O": "343041",
      "Babtra B.O": "343022",
      "Jeewana B.O": "343022",
      "Taliyana B.O": "343022",
      "Bhetala B.O": "343024",
      "Othwala B.O": "343021",
      "Dhamseen B.O": "343048",
      "Jaitu B.O": "343030",
      "Jeran B.O": "343030",
      "Vali B.O": "343030",
      "Debawas B.O": "343042",
      "Odwara B.O": "343042",
      "Boogaon B.O": "307803",
      "Chandur B.O": "307803",
      "Mandoli Nagar B.O": "307803",
      "Ajodar B.O": "343040",
      "Kuda B.O": "343040",
      "Meda B.O": "343040",
      "Pamana B.O": "343040",
      "Bhadwal B.O": "343041",
      "Bhawatra B.O": "343041",
      "Dabal B.O": "343041",
      "Dhamana B.O": "343041",
      "Hariyali B.O": "343041",
      "Karola B.O": "343041",
      "Keriya B.O": "343041",
      "Parawa B.O": "343041",
      "Pur B.O": "343041",
      "Meghalwa B.O": "343022",
      "Posana B.O": "343022",
      "Sangana B.O": "343022",
      "Sirana B.O": "343022",
      "Chandana B.O": "343024",
      "Raipuria B.O": "343024",
      "Sawna B.O": "343024",
      "Narsana B.O": "343030",
      "Chirpatia B.O": "343049",
      "Kori B.O": "343049",
      "Panseri B.O": "343049",
      "Savidhar B.O": "343049",
      "Akhrad B.O": "343039",
      "Puran B.O": "343039",
      "Surajwara B.O": "343039",
      "Raithal B.O": "343042",
      "Mudtrasili B.O": "307803",
      "Punakkalan B.O": "307803",
      "Deora B.O": "343040",
      "Dungri B.O": "343041",
      "Gundau B.O": "343040",
      "Hemguda B.O": "343040",
      "Itada B.O": "343040",
      "Jhab B.O": "343040",
      "Jhakhari B.O": "343040",
      "Kardan B.O": "343040",
      "Karwada B.O": "343040",
      "Akoli B.O": "343025",
      "Bawarla B.O": "343041",
      "Chitalwana B.O": "343041",
      "Chora B.O": "343041",
      "Hotigaon B.O": "343041",
      "Jakhal B.O": "343041",
      "Surawa B.O": "343041",
      "Veerawa B.O": "343041",
      "Dangra B.O": "343021",
      "Elana B.O": "343021",
      "Nimblana B.O": "343021",
      "Safada B.O": "343001",
      "Meda Uparla B.O": "343001",
      "Unn B.O": "343001",
      "Thawla B.O": "343001",
      "Samtipura B.O": "343001",
      "Bhenswara B.O": "307029",
      "Charli B.O": "307029",
      "Chunda B.O": "307029",
      "Ghana B.O": "307029",
      "Govindla B.O": "307029",
      "Neelkanth B.O": "307029",
      "Norwa B.O": "307029",
      "Nosra B.O": "307029",
      "Sanwara B.O": "307029",
      "Dadal B.O": "343032",
      "Koridhawecha B.O": "343032",
      "Surana B.O": "343032",
      "Leta B.O": "343001",
      "Rewatra B.O": "343001",
      "Sankarna B.O": "343001",
      "Deoki B.O": "307029",
      "Godan B.O": "307029",
      "Kamba B.O": "307029",
      "Kishangarh B.O": "307029",
      "Nimbla B.O": "307029",
      "Chenpura B.O": "343032",
      "Detakalan B.O": "343032",
      "Morseem B.O": "343032",
      "Nandia B.O": "343032",
      "Bakra B.O": "343025",
      "Bhagli Sindhlan B.O": "343001",
      "Aipura B.O": "307029",
      "Bala B.O": "307029",
      "Bankli B.O": "307029",
      "Baori B.O": "307029",
      "Bhadrajun B.O": "307029",
      "Samuja B.O": "307029",
      "Sugalia Jodha B.O": "307029",
      "Vedia B.O": "307029",
      "Rangala B.O": "343032",
      "Raota B.O": "343032",
      "Bibalsar B.O": "343025",
      "Chura B.O": "343025",
      "Degaon B.O": "343025",
      "Narnawas B.O": "343025",
      "Bhadvi B.O": "343029",
      "Bhagal Sefta B.O": "343029",
      "Jodwara B.O": "343029",
      "Kora B.O": "343029",
      "Munthala Kaba B.O": "343029",
      "Nimbawas B.O": "343029",
      "Punasa B.O": "343029",
      "Unri B.O": "343023",
      "Bakra Road B.O": "343025",
      "Berath B.O": "343025",
      "Madgaon B.O": "343025",
      "Kotkastan B.O": "343029",
      "Kuka B.O": "343029",
      "Ledarmer B.O": "343029",
      "Mandhar B.O": "343029",
      "Nasoli B.O": "343029",
      "Pantheri B.O": "343023",
      "Thalwad B.O": "343023",
      "Agawari B.O": "307030",
      "Bedana B.O": "307030",
      "Bhimguda B.O": "343027",
      "Dantlawas B.O": "307515",
      "Dorda B.O": "307515",
      "Gajapura B.O": "307515",
      "Dhumbadia B.O": "343030",
      "Noon B.O": "343025",
      "Santhu B.O": "343025",
      "Bharudi B.O": "343029",
      "Borta B.O": "343029",
      "Chatwara B.O": "343029",
      "Daspan B.O": "343029",
      "Thobau B.O": "343029",
      "Vandhar B.O": "343029",
      "Dodiyali B.O": "307030",
      "Kawarada B.O": "307030",
      "Kawlan B.O": "307030",
      "Padarli B.O": "307030",
      "Palasia B.O": "307030",
      "Panchota B.O": "307030",
      "Paota B.O": "307030",
      "Dawal B.O": "343027",
      "Janvi B.O": "343027",
      "Khejariyali B.O": "343027",
      "Rajikawas B.O": "307515",
      "Sundhaparbat B.O": "307515",
      "Bithura B.O": "307030",
      "Dayalpura B.O": "307030",
      "Rodla B.O": "307030",
      "Valdara B.O": "307030",
      "Amli B.O": "343027",
      "Kalapura B.O": "307515",
      "Dungarwas B.O": "343030",
      "Kaleti B.O": "343030",
      "Komta B.O": "343030",
      "Sewari B.O": "343030",
      "Bilar B.O": "343049",
      "Chitrodi B.O": "343049",
      "Ropsi B.O": "343049",
      "Silasan B.O": "343049",
      "Anwloj B.O": "343042",
      "Bishangarh B.O": "343042",
      "Sarana B.O": "343042",
      "Basda Dhanji B.O": "343028",
      "Serna B.O": "343028",
      "Sandhara B.O": "307803",
      "Thoor B.O": "307803",
      "Dantwara B.O": "343040",
      "Dhanol B.O": "343040",
      "Gong B.O": "343040",
      "Korka B.O": "343040",
      "Ratanpur B.O": "343040",
      "Sarnau B.O": "343040",
      "Achalpur B.O": "343041",
      "Balera B.O": "343041",
      "Bhadruna B.O": "343041",
      "Hadetar B.O": "343041",
      "Khara B.O": "343041",
      "Panchala B.O": "343041",
      "Ranodar B.O": "343041",
      "Asana B.O": "343022",
      "Chorau B.O": "343022",
      "Keshwana B.O": "343001",
      "Veerana B.O": "343001",
      "Chawarcha B.O": "343001",
      "Harji B.O": "343001",
      "Alasan B.O": "343001",
      "Badanwari B.O": "307029",
      "Bhorda B.O": "307029",
      "Rama B.O": "307029",
      "Sankhwali B.O": "307029",
      "Jaisawas B.O": "343032",
      "Tiloda B.O": "343032",
      "Dakatra B.O": "343025",
      "Doodsi B.O": "343025",
      "Sarat B.O": "343025",
      "Bhagal Bhim B.O": "343029",
      "Bhalni B.O": "343029",
      "Fagotra B.O": "343029",
      "Gazipura B.O": "343029",
      "Khanpur B.O": "343029",
      "Narta B.O": "343029",
      "Paoli B.O": "343029",
      "Tawab B.O": "343029",
      "Bhuti B.O": "307030",
      "Chandrai B.O": "307030",
      "Umedpur B.O": "307030",
      "Soonthri B.O": "343027",
      "Surachand B.O": "343027",
      "Golana B.O": "307515",
      "Jalore H.O": "343001",
      "Ahore S.O": "307029",
      "Bhinmal S.O": "343029",
      "Joojani S.O": "343030",
      "Malwara S.O": "343039",
      "Bagoda S.O": "343032",
      "Bagra S.O": "343025",
      "Hadecha S.O": "343027",
      "Jalore V.D.C. S.O": "343001",
      "Ramseen S.O": "307803",
      "Siana S.O": "343024",
      "Mandwala S.O": "343042",
      "Modran S.O": "343028",
      "Vadgaon S.O (Jalor)": "343048",
      "Gudabalotan S.O": "307030",
      "I.A.Jalore S.O": "343002",
      "Kagmala S.O": "343049",
      "Bhinmal Sadar Bazar S.O": "343029",
      "Dhansa S.O": "343023",
      "Jaswantpura S.O": "307515",
      "Raniwara S.O": "343040",
      "Sanchore S.O": "343041",
      "Sayla S.O (Jalor)": "343022",
      "Ummedabad S.O": "343021"
    },
    "HANUMANGARH": {
      "PALLU S.O": "335522",
      "Bahlolnagar B.O": "335801",
      "Fatehgarh B.O": "335801",
      "Kamana B.O": "335801",
      "Karanisar Sahjipura B.O": "335801",
      "Bharwana B.O": "335504",
      "Deeplana B.O": "335504",
      "Dhilki B.O": "335504",
      "Ujjalwas B.O": "335504",
      "Sardargarhia B.O": "335504",
      "Dablibaspema B.O": "335802",
      "Gurusar Modia B.O": "335802",
      "Hardayalpura B.O": "335802",
      "Kewalwali Dhani B.O": "335802",
      "Amarpura Theri B.O": "335513",
      "Jhamber B.O": "335513",
      "Kishanpura Dikhnada B.O": "335513",
      "Mundriabara B.O": "335502",
      "Raslana B.O": "335502",
      "Aradhki B.O": "335523",
      "Dalpatpura B.O": "335523",
      "Dhandhela B.O": "335523",
      "Gorkhana B.O": "335523",
      "Khuiuyan B.O": "335523",
      "Lalania B.O": "335523",
      "Malwani B.O": "335523",
      "Munsari B.O": "335504",
      "Naulakhi B.O": "335523",
      "Neemla B.O": "335523",
      "Ahmedpura B.O": "335803",
      "Amarpura Rathan B.O": "335803",
      "Sanghar B.O": "335803",
      "Chahiyan B.O": "335524",
      "Daniyasar B.O": "335524",
      "Dhannasar B.O": "335524",
      "Hardaswali B.O": "335524",
      "Jorawarpura B.O": "335524",
      "Mirzewali Mer B.O": "335524",
      "Mohanmagaria B.O": "335524",
      "Moter B.O": "335524",
      "Karanpura B.O": "335501",
      "Garhichhani B.O": "335511",
      "Jhansal B.O": "335511",
      "Mahrana B.O": "335511",
      "Malkhera B.O": "335511",
      "Sagra B.O": "335503",
      "Sherda B.O": "335503",
      "Shivdanpura B.O": "335503",
      "Suratpura B.O": "335503",
      "Barwali B.O": "335504",
      "Sherekan B.O": "335513",
      "Dungarana B.O": "335502",
      "Gheu B.O": "335502",
      "Kanau B.O": "335502",
      "Kiradabara B.O": "335502",
      "Daulatpura B.O": "335065",
      "Fatehpura B.O": "335065",
      "Jabrasar B.O": "335523",
      "Jasana B.O": "335523",
      "Padampura B.O": "335523",
      "Pandusar B.O": "335523",
      "Ratanpura B.O": "335063",
      "Sirangsar B.O": "335523",
      "Sonari B.O": "335523",
      "Jakharanwali B.O": "335803",
      "Kalibanga B.O": "335803",
      "Lakhasar B.O": "335803",
      "Likhmisar B.O": "335803",
      "Longwala B.O": "335803",
      "15 Kwd B.O": "335524",
      "4 Cym B.O": "335524",
      "4 Dwm B.O": "335524",
      "Gandhi Bari B.O": "335501",
      "Utradabas B.O": "335501",
      "Ramgarhia B.O": "335511",
      "Sherpura B.O": "335511",
      "Asan B.O": "335503",
      "Gadhra B.O": "335503",
      "Badbiran B.O": "335504",
      "Lalana B.O": "335504",
      "Nathwania B.O": "335504",
      "Ramgarh B.O": "335504",
      "Amarsinghwala B.O": "335802",
      "Pakka Bhadwan B.O": "335802",
      "Surewali B.O": "335802",
      "Ramsara Narain B.O": "335513",
      "Bojhla B.O": "335502",
      "Kuji B.O": "335502",
      "Malerkhera B.O": "335065",
      "Nagrana B.O": "335065",
      "Bhukarka B.O": "335523",
      "Deidas B.O": "335523",
      "Dhansia B.O": "335523",
      "Durjana B.O": "335523",
      "Jhedasar B.O": "335523",
      "Meghana B.O": "335523",
      "Phephana B.O": "335523",
      "Soorpura B.O": "335523",
      "Tidyasar B.O": "335523",
      "Chohilanwali B.O": "335803",
      "Dulmana B.O": "335803",
      "Panditanwali B.O": "335803",
      "Prempura B.O": "335803",
      "Baramsar B.O": "335524",
      "Bhompura B.O": "335524",
      "Dablikalan B.O": "335524",
      "Kanwani B.O": "335524",
      "Lakhuwali Head B.O": "335524",
      "Mahela B.O": "335524",
      "Naiyasar B.O": "335524",
      "Rasuwala B.O": "335062",
      "Chak Jawalasinghwala B.O": "335512",
      "Pakka Saharana B.O": "335512",
      "CHAK 6 UTS B.O": "335512",
      "Dobi B.O": "335501",
      "Indergarh B.O": "335062",
      "Kishanpura Utrada B.O": "335062",
      "Rorawali B.O": "335512",
      "Nawan B.O": "335512",
      "Makkasar B.O": "335512",
      "Anupshahar B.O": "335501",
      "Bhadi B.O": "335501",
      "Bhagwan B.O": "335501",
      "Bhanai B.O": "335501",
      "Biran B.O": "335511",
      "Ninan B.O": "335511",
      "Sahuwala B.O": "335511",
      "Bhirani B.O": "335503",
      "Jogiwala B.O": "335503",
      "Parlika B.O": "335504",
      "Khachwana B.O": "335504",
      "Nethrana B.O": "335504",
      "Chak 26 JRK B.O": "335802",
      "Ayalki B.O": "335802",
      "Khotanwali B.O": "335802",
      "Kamrani B.O": "335513",
      "Kohlan B.O": "335513",
      "Malsisar B.O": "335502",
      "Lilanwali B.O": "335065",
      "Birkali B.O": "335523",
      "Chak Sardarpura B.O": "335523",
      "Dhani LaL khan B.O": "335523",
      "Gandheli B.O": "335523",
      "Gudia B.O": "335063",
      "Khinania B.O": "335523",
      "Mandarpura B.O": "335523",
      "Nanau B.O": "335523",
      "Thirana B.O": "335523",
      "Toparia B.O": "335523",
      "Chak 34 Stg B.O": "335803",
      "Dhaba B.O": "335063",
      "Pilibanga Village B.O": "335803",
      "Balochanwala B.O": "335803",
      "Bherunsari B.O": "335524",
      "Bisrasar B.O": "335524",
      "Chahuwali B.O": "335524",
      "Khoda B.O": "335524",
      "Modhunagar B.O": "335524",
      "Mainawali B.O": "335524",
      "Jandwali B.O": "335512",
      "Jorkia B.O": "335512",
      "Bhojasar B.O": "335501",
      "Thalarka B.O": "335524",
      "Rampura Mala B.O": "335063",
      "Meharwala B.O": "335526",
      "Inderpura B.O": "335064",
      "Kalwasia B.O": "335064",
      "Narayangarh B.O": "335064",
      "Satipura B.O": "335512",
      "Ajitpura B.O": "335501",
      "Bhangarh B.O": "335501",
      "Bolanwali B.O": "335063",
      "Deengarh B.O": "335063",
      "Jandwali Sikhan B.O": "335063",
      "Kharakhera B.O": "335063",
      "Kikarawali B.O": "335063",
      "Kulchander B.O": "335063",
      "Naiwala B.O": "335063",
      "Nathwana B.O": "335063",
      "Nukera B.O": "335063",
      "Munda B.O": "335526",
      "Pakki Dabli B.O": "335526",
      "Panniwali B.O": "335526",
      "Rampura Ramsara B.O": "335526",
      "Rathikhara B.O": "335526",
      "Pallu B.O": "335524",
      "Purabsar B.O": "335524",
      "Rampura Matoria B.O": "335524",
      "Bashir B.O": "335063",
      "Bhakranwali B.O": "335063",
      "Sabuana B.O": "335063",
      "Santpura B.O": "335063",
      "Chak 2 Ksp B.O": "335526",
      "Chak 4 Ksp B.O": "335526",
      "Masitanwali B.O": "335526",
      "Silwala Khurd B.O": "335526",
      "Manuka B.O": "335064",
      "Hirnawali B.O": "335064",
      "Naurangdesar B.O": "335524",
      "Poharka B.O": "335524",
      "Amarpura Jalukhat B.O": "335063",
      "Bhagatpura B.O": "335063",
      "Gilwala B.O": "335063",
      "Haripura B.O": "335063",
      "Morjand Sikhan B.O": "335063",
      "Saliwala B.O": "335063",
      "Shahpini B.O": "335063",
      "Vidyapeeth B.O": "335063",
      "Silwala Kalan B.O": "335525",
      "Masani B.O": "335526",
      "Peerkamadia B.O": "335526",
      "Surewala B.O": "335526",
      "Kheruwala B.O": "335064",
      "Hanumangarh Jn. H.O": "335512",
      "Nohar Bazar S.O": "335523",
      "Pilibangan S.O": "335803",
      "Talwara Jheel S.O": "335525",
      "Tibbi S.O": "335526",
      "Nai Abdi Hanumangarh Town S.O": "335513",
      "Nohar S.O": "335523",
      "Rawatsar S.O (Hanumangarh)": "335524",
      "Sangaria Rs S.O": "335063",
      "Sangaria S.O (Hanumangarh)": "335063",
      "Dholipal S.O": "335064",
      "Hanumangarh Town Bazar S.O": "335513",
      "Hanumangarh Town S.O": "335513",
      "Kalana S.O": "335502",
      "Bhadra S.O": "335501",
      "Dabri S.O": "335503",
      "Goluwala S.O": "335802",
      "Manaksar S.O": "335065",
      "Channibari S.O": "335511",
      "Civil Line Hanumangarh3 S.O": "335512",
      "Gogameri S.O": "335504",
      "Hanumangarh Jn. Court S.O": "335512",
      "Dabli Rathan S.O": "335801"
    },
    "AJMER": {
      "KAKALWARA BO": "305813",
      "KAYAMPURA BO": "305811",
      "NODAL DELIVERY CENTRE": "305004",
      "Hatikhera B.O": "305005",
      "Dorai B.O": "305003",
      "Kanwalai B.O": "305021",
      "Bhagwan Pura B.O": "305403",
      "Deo Nagar B.O": "305022",
      "Bithur B.O": "305205",
      "Kaklana B.O": "305205",
      "Kotaj B.O": "305205",
      "Chorsiawas B.O": "305004",
      "Makarwali B.O": "305004",
      "Nosar B.O": "305004",
      "Amba Masina B.O": "305206",
      "Googhra B.O": "305023",
      "Mohami B.O": "305023",
      "Makhupura B.O": "305002",
      "Rasoolpura B.O": "305024",
      "Kanas B.O": "305022",
      "Nand B.O": "305022",
      "Makrera B.O": "305206",
      "Ajaiser B.O": "305005",
      "Kharkheri B.O": "305005",
      "Kayar B.O": "305023",
      "Ladpura B.O": "305023",
      "Somalpur B.O": "305003",
      "Sendaria B.O": "305002",
      "Nareli B.O": "305024",
      "Hatundi B.O": "305012",
      "Ganahera B.O": "305022",
      "Kishanpura B.O": "305927",
      "Picholia B.O": "305022",
      "Maya Pur B.O": "305205",
      "Bhaonta B.O": "305206",
      "Bhudol B.O": "305023",
      "Bubani B.O": "305023",
      "Chachiwas B.O": "305023",
      "Gegal Akhari B.O": "305023",
      "Untra B.O": "305023",
      "Khori B.O": "305021",
      "Tilora B.O": "305022",
      "Dumara B.O": "305206",
      "Kesarpura B.O": "305206",
      "Deo Puri B.O": "305801",
      "Dindwara B.O": "305801",
      "Katsura B.O": "305801",
      "Mundoti B.O": "305801",
      "Akodia B.O": "305813",
      "Bhamolao B.O": "305813",
      "Dang B.O": "305813",
      "Tabiji B.O": "305206",
      "Dhasook B.O": "305801",
      "Sardar Singh Ki Dhani B.O": "305801",
      "Thal B.O": "305801",
      "Dadia B.O": "305813",
      "Gagunda B.O": "305813",
      "Sursara B.O": "305801",
      "Khandach B.O": "305801",
      "Jheerota B.O": "305801",
      "Bhogadeet B.O": "305813",
      "Lamba B.O": "305813",
      "Sandolia B.O": "305813",
      "Nooriawas B.O": "305206",
      "Ralaota B.O": "305801",
      "Barna B.O": "305801",
      "Bandar Sindari B.O": "305801",
      "Sanwatsar B.O": "305801",
      "Gothiana B.O": "305813",
      "Kalanada B.O": "305813",
      "Andheri Deori B.O": "305901",
      "Balad B.O": "305901",
      "Bayala B.O": "305901",
      "Dedpura B.O": "305631",
      "Malpura B.O": "305901",
      "Sedaria B.O": "305901",
      "Delwara B.O": "305901",
      "Noondri Maldev B.O": "305901",
      "Roopnagar B.O": "305901",
      "Suhawa B.O": "305901",
      "Paranga B.O": "305621",
      "Asan B.O": "305926",
      "Boobaniya B.O": "305401",
      "Nandla B.O": "305401",
      "Badi B.O": "305624",
      "Satawaria B.O": "305630",
      "Dantra B.O": "305207",
      "Nagelao B.O": "305207",
      "Rawatmal B.O": "305923",
      "Soniana B.O": "305923",
      "Taragarh Dadoli B.O": "305923",
      "Bhimpura B.O": "305203",
      "Brickchiawas B.O": "305203",
      "Lulwa B.O": "305623",
      "Mewaria B.O": "305204",
      "Pagaran B.O": "305204",
      "Rampura Dabla B.O": "305204",
      "Atitmand B.O": "305925",
      "Noondri Mendratan B.O": "305901",
      "Dewas B.O": "305631",
      "Jharwasa B.O": "305621",
      "Karanti B.O": "305621",
      "Kumharia B.O": "305621",
      "Niyara B.O": "305621",
      "Barakhan B.O": "305926",
      "Palri B.O": "305926",
      "Roop Nagar Arnali B.O": "305926",
      "Sobri B.O": "305622",
      "Baghsuri B.O": "305401",
      "Banewara B.O": "305401",
      "Ekal Singha B.O": "305624",
      "Nimera B.O": "305624",
      "Hanutia B.O": "305625",
      "Lodiyana B.O": "305625",
      "Nai Kalan B.O": "305927",
      "Gola B.O": "305202",
      "Kanakhera B.O": "305202",
      "Lamana B.O": "305202",
      "Piplaj B.O": "305405",
      "Arjunpura B.O": "305203",
      "Dholadanta B.O": "305623",
      "Kheempura B.O": "305623",
      "Kirap B.O": "305623",
      "Manpura B.O": "305623",
      "Mayala B.O": "305623",
      "Shahpura B.O": "305925",
      "Surdiya B.O": "305925",
      "Sanod B.O": "305601",
      "Sarana B.O": "305601",
      "Loharwara B.O": "305601",
      "Arwar B.O": "305601",
      "Deogaon B.O": "305415",
      "Harpura B.O": "305406",
      "Hingonia B.O": "305406",
      "Bhimrawas B.O": "305405",
      "Khawas B.O": "305405",
      "Mehru Kalan B.O": "305405",
      "Deo Khera B.O": "305925",
      "Jhadol B.O": "305402",
      "Mawasia B.O": "305402",
      "Morajhari B.O": "305402",
      "Tilana B.O": "305402",
      "Kebania B.O": "305627",
      "Kitap B.O": "305627",
      "Rammalia B.O": "305627",
      "Malto Ki Ber B.O": "305924",
      "Dhal B.O": "305601",
      "Asha Pura B.O": "305601",
      "Karonj B.O": "305415",
      "Kaseer B.O": "305412",
      "Manoharpura B.O": "305412",
      "Sher Garh B.O": "305412",
      "Siyar B.O": "305412",
      "Lalai B.O": "305406",
      "Lasadia B.O": "305406",
      "Kohda B.O": "305408",
      "Salari B.O": "305408",
      "Udaipur Kalan B.O": "305802",
      "Chitakhera B.O": "305811",
      "Magara B.O": "305811",
      "Bhadoon B.O": "305814",
      "Jajota B.O": "305814",
      "Kotdi B.O": "305814",
      "Nawa B.O": "305814",
      "Danta B.O": "305025",
      "Farkia B.O": "305025",
      "Jilawara B.O": "305025",
      "Palran B.O": "305025",
      "Patan B.O": "305816",
      "Tikawara B.O": "305802",
      "Ararka B.O": "305811",
      "Babaicha B.O": "305811",
      "Sinodia B.O": "305814",
      "Tyod B.O": "305814",
      "Singara B.O": "305815",
      "Beer B.O": "305025",
      "Nalu B.O": "305816",
      "Silora B.O": "305802",
      "Magri B.O": "305811",
      "Nitooti B.O": "305814",
      "Paner B.O": "305814",
      "Pinglod B.O": "305815",
      "Tityari B.O": "305815",
      "Badliya B.O": "305025",
      "Mundolao B.O": "305025",
      "Tihari B.O": "305025",
      "Shivpura Ghata B.O": "305631",
      "Jalia i B.O": "305901",
      "Beawar Khas B.O": "305901",
      "Narbad Khera B.O": "305901",
      "Banjari B.O": "305926",
      "Khodmal B.O": "305926",
      "Bubkiya B.O": "305622",
      "Khayda B.O": "305622",
      "Barali B.O": "305624",
      "Doulatpura B.O": "305631",
      "Sathana B.O": "305624",
      "Singhawal B.O": "305624",
      "Begliawas B.O": "305630",
      "Anakar B.O": "305922",
      "Alipura B.O": "305207",
      "Durgawas B.O": "305927",
      "Kotra B.O": "305927",
      "Rudlai B.O": "305202",
      "Deomali B.O": "305623",
      "Nandwara B.O": "305623",
      "Shyamgarh B.O": "305623",
      "Budhwara B.O": "305204",
      "Kalesara B.O": "305204",
      "Gohana B.O": "305925",
      "Dilwara B.O": "305601",
      "Bhatiyani B.O": "305601",
      "Goyla B.O": "305601",
      "Bhagawant Pura B.O": "305601",
      "Motipura B.O": "305601",
      "Lamagra B.O": "305629",
      "Barol B.O": "305412",
      "Borada B.O": "305412",
      "Bogla B.O": "305408",
      "Jeewana B.O": "305631",
      "Sarmalia B.O": "305901",
      "Jhak B.O": "305901",
      "Chhachhundra B.O": "305621",
      "Bamanheda B.O": "305926",
      "Dhatol B.O": "305622",
      "Rajosi B.O": "305401",
      "Baral B.O": "305624",
      "Ratakot B.O": "305624",
      "Shikhrani B.O": "305624",
      "Leswa B.O": "305201",
      "Lamba Kund Ka B.O": "305630",
      "Jhipian B.O": "305630",
      "Bar Kochara B.O": "305922",
      "Dewata B.O": "305922",
      "Bhadsuri B.O": "305207",
      "Dodiana B.O": "305207",
      "Leeri B.O": "305203",
      "Harrajpura B.O": "305623",
      "Moyana B.O": "305623",
      "Shergarh B.O": "305623",
      "Fathepura B.O": "305204",
      "Karnos B.O": "305204",
      "Narwar B.O": "305811",
      "Nosal B.O": "305814",
      "Raghunath Pura B.O": "305814",
      "Khatoli B.O": "305815",
      "Kana Kheri B.O": "305025",
      "Kanpura B.O": "305025",
      "Kalinjer B.O": "305925",
      "Sarvena B.O": "305925",
      "Raitakhera B.O": "305925",
      "Mandawaria B.O": "305402",
      "Samproda B.O": "305402",
      "Jotayan B.O": "305627",
      "Derathu B.O": "305601",
      "Shokalia B.O": "305601",
      "Lawera B.O": "305601",
      "K.K.GOPAL B.O": "305408",
      "Gudha Khurd B.O": "305629",
      "Deolia Kalan B.O": "305629",
      "Bidla B.O": "305412",
      "Dabrella B.O": "305412",
      "Dhundhari B.O": "305408",
      "Molkiya B.O": "305408",
      "Taswaria B.O": "305408",
      "Aloli B.O": "305405",
      "Bharai B.O": "305404",
      "Jetpura B.O": "305404",
      "Kerot B.O": "305404",
      "Mevada Kalan B.O": "305404",
      "MEWADAKHURD B.O": "305404",
      "Surkhand B.O": "305628",
      "Bisundri B.O": "305407",
      "Chitiawas B.O": "305407",
      "Ghatiyali B.O": "305407",
      "Sironj B.O": "305813",
      "Barala B.O": "305628",
      "Kanai Kalan B.O": "305628",
      "Jadana B.O": "305403",
      "Khiriya B.O": "305403",
      "Tankawas B.O": "305407",
      "Buharu B.O": "305812",
      "Sankariya B.O": "305405",
      "Pranhera B.O": "305404",
      "Sanpla B.O": "305404",
      "Sunpa B.O": "305404",
      "Kurthal B.O": "305628",
      "Padlia B.O": "305628",
      "Satolav B.O": "305403",
      "Gulgaon B.O": "305407",
      "Kunwar Ji Ka Kalera B.O": "305407",
      "Kushayata B.O": "305407",
      "Chhota Naraina B.O": "305812",
      "Amarpura B.O": "305819",
      "Sargoan B.O": "305802",
      "Ajgara B.O": "305404",
      "Pharkia B.O": "305404",
      "Rampali B.O": "305404",
      "Sarsari B.O": "305404",
      "Kanai Khurd B.O": "305628",
      "Nandsi B.O": "305628",
      "Bajata B.O": "305407",
      "Gordha B.O": "305407",
      "Napa Khera B.O": "305407",
      "Sadara B.O": "305407",
      "Madanganj Kishangarh H.O": "305801",
      "Beawar [Raj] H.O": "305901",
      "Ajmer H.O": "305001",
      "Nasirabad H.O": "305601",
      "Adarsh Nagar (Ajmer) S.O": "305002",
      "B.K.Kaul Nagar S.O": "305004",
      "Bhajan Ganj Ajmer S.O": "305001",
      "Dhan Mandi Ajmer S.O": "305001",
      "Gagwana S.O": "305023",
      "Kaiser Ganj Ajmer S.O": "305001",
      "Naka Madar Ajmer S.O": "305007",
      "Pal Beesla Ajmer S.O": "305007",
      "Pushkar Bazar S.O": "305022",
      "Raj. Edu. Board Ajmer S.O": "305001",
      "Ram Ganj Ajmer S.O": "305003",
      "Vaishali Nagar Ajmer S.O": "305004",
      "Arain S.O": "305813",
      "Karkeri S.O": "305819",
      "Kuchil S.O": "305811",
      "Barakhera S.O": "305926",
      "Beawar R.S. S.O": "305901",
      "Jalia  II S.O": "305625",
      "Jamola S.O": "305630",
      "Jethana S.O": "305207",
      "Lotiyana S.O": "305923",
      "Nehru Nagar (Beawar) S.O": "305901",
      "Pisangan S.O": "305204",
      "Chanderverdai Nagar S.O": "305003",
      "Ajai Nagra S.O": "305003",
      "Hmt Ajmer Dtso S.O": "305003",
      "Ie Makhu Pura Ajmer S.O": "305002",
      "Jones Ganj Ajmer S.O": "305001",
      "Loco Work Shop Ajmer S.O": "305001",
      "Maday S.O": "305024",
      "Mayo S.O": "305007",
      "Panchsheel Nagar  S.O": "305004",
      "Raj Garh (Ajmer) S.O": "305205",
      "RPSC Ajmer S.O": "305001",
      "Session Court Ajmer S.O": "305001",
      "Aditya Mills S.O": "305801",
      "Chandra Colony S.O": "305801",
      "Shivaji Nagar S.O (Ajmer)": "305801",
      "Srinagar S.O (Ajmer)": "305025",
      "Bandanwara S.O": "305621",
      "Govind Garh S.O": "305201",
      "Rajiawas S.O": "305925",
      "Todgarh S.O": "305924",
      "Champaneri S.O": "305629",
      "Fathegarh S.O": "305412",
      "Dargha Shareef Ajmer S.O": "305001",
      "Jln Hospital Ajmer S.O": "305001",
      "Karel S.O": "305021",
      "Mds University Ajmer S.O": "305009",
      "Nagra Ajmer S.O": "305001",
      "Pushkar S.O": "305022",
      "Regional College Ajmer S.O": "305004",
      "Alwar Gate Ajmer S.O": "305001",
      "Ashok Marg Ajmer S.O": "305001",
      "Crpf Ajmer S.O": "305005",
      "Ganj Ajmer S.O": "305001",
      "Gc Road Ajmer S.O": "305007",
      "Gujar Dharti Ajmer S.O": "305001",
      "Kutchery S.O (Ajmer)": "305001",
      "Mss Hatundi S.O": "305012",
      "Naya Bazar S.O (Ajmer)": "305001",
      "Shastri Nagar S.O (Ajmer)": "305001",
      "Dhan Mandi   Kishan Garh S.O": "305802",
      "Gandhi Nagar Madanganj S.O": "305801",
      "Roopnagar S.O": "305814",
      "Salemabad S.O": "305815",
      "Saradhana S.O": "305206",
      "Harmara S.O": "305812",
      "Kishangarh City S.O": "305802",
      "Marble Ind. Area Kishangarh S.O": "305801",
      "Tiloniya S.O": "305816",
      "Central University of Rajasthan S.O": "305817",
      "Bhinai S.O": "305622",
      "Bhwani Khera S.O": "305401",
      "Bijainagar S.O": "305624",
      "Kabra S.O": "305927",
      "Kharwa S.O": "305202",
      "Masuda S.O": "305623",
      "Ramsar S.O (Ajmer)": "305402",
      "Sendra Road (Beawar) S.O": "305901",
      "RAMGARH S.O": "305631",
      "Junia S.O": "305406",
      "Jawaja S.O": "305922",
      "Mangliawas S.O": "305203",
      "Shahpura Mohalla( Beawar ) S.O": "305901",
      "Tantoti S.O": "305627",
      "Baghera S.O": "305415",
      "Kadera S.O": "305405",
      "Nagola S.O": "305628",
      "Sawar S.O": "305407",
      "PARA S.O": "305408",
      "Sarwar S.O": "305403",
      "Kekri S.O": "305404"
    },
    "PRATAPGARH": {
      "Bori B.O": "312619",
      "Ghantali B.O": "312624",
      "Sowania B.O": "312615",
      "Sodalpur B.O": "312624",
      "Jethalia B.O": "312624",
      "Nayan B.O": "312624",
      "Chhari B.O": "312624",
      "Semliya B.O": "312615",
      "Dunglawani B.O": "312615",
      "Kelamela B.O": "312624",
      "Kupda B.O": "312624",
      "Ambawali B.O": "312604",
      "Dhaula pani B.O": "312604",
      "Karunda B.O": "312604",
      "Kesunda B.O": "312604",
      "Ambirama B.O": "312619",
      "Bardia B.O": "312623",
      "Ninor B.O": "312619",
      "Raipurjangal B.O": "312619",
      "Salamgarh B.O": "312619",
      "Barawarda B.O": "312616",
      "Dhiknia B.O": "312616",
      "Dudhli Tanda B.O": "312616",
      "Narani B.O": "312604",
      "Subi B.O": "312604",
      "Swaroopganj B.O": "312604",
      "Chakunda B.O": "312619",
      "Jeerawata B.O": "312619",
      "Unthel B.O": "312619",
      "Kheranarsingh Mata B.O": "312616",
      "Madhura Talab B.O": "312616",
      "Narayankheda B.O": "312616",
      "Sidhpura B.O": "312616",
      "Teela B.O": "312616",
      "Untakheda B.O": "312616",
      "Ganeshpura B.O": "312604",
      "Gomana B.O": "312604",
      "Peelikheda B.O": "312604",
      "Semarthali B.O": "312604",
      "Banslai B.O": "312619",
      "Barisagthali B.O": "312619",
      "Raipur B.O": "312619",
      "Sowaniya B.O": "312624",
      "Gagrol B.O": "312604",
      "Jalodia B.O": "312604",
      "Pithalwadikalan B.O": "312604",
      "Siyakhedi B.O": "312604",
      "Chandera B.O": "312619",
      "KANGARH.BO": "312619",
      "Sewna B.O": "312619",
      "Baori Khera B.O": "312616",
      "Meriyakhedi B.O": "312616",
      "Dunglavani B.O": "312624",
      "Semaliya B.O": "312624",
      "Nagdi B.O": "312615",
      "Sagathali Thana B.O": "312615",
      "Veerawali B.O": "312615",
      "Prathvipura BO": "312624",
      "Basad B.O": "312605",
      "Basera B.O": "312605",
      "Bilesari B.O": "312605",
      "Chiklad B.O": "312605",
      "Kuni B.O": "312605",
      "Mandawara B.O": "312605",
      "Mandkalan B.O": "312605",
      "Manohar Garh B.O": "312605",
      "Pandawa B.O": "312605",
      "Rampuria B.O": "312605",
      "Ratanpuria B.O": "312605",
      "Richawara B.O": "312605",
      "Piloo B.O": "312623",
      "Semnop B.O": "312623",
      "Thada B.O": "312623",
      "Naugama B.O": "312615",
      "NALWA BO": "312625",
      "Akhepur B.O": "312605",
      "Amlawad B.O": "312605",
      "Angora B.O": "312605",
      "Anoppura B.O": "312605",
      "Gotarsi B.O": "312605",
      "Jhansri B.O": "312605",
      "Jolar B.O": "312605",
      "Kotwal B.O": "312605",
      "Kulthana B.O": "312605",
      "Luharia B.O": "312605",
      "Padliya B.O": "312605",
      "Selarpura Kalan B.O": "312605",
      "Kanora B.O": "312623",
      "Kheda B.O": "312623",
      "Khoria B.O": "312623",
      "Asawata B.O": "312605",
      "Barilank B.O": "312605",
      "Barotha B.O": "312605",
      "Dabda B.O": "312605",
      "Dewad B.O": "312605",
      "Gyaspur B.O": "312605",
      "Kalyanpura B.O": "312605",
      "Kerwas B.O": "312605",
      "Mota Dhamaniya B.O": "312605",
      "Motikhedi B.O": "312605",
      "Pal B.O": "312605",
      "Pateliya B.O": "312605",
      "Varmandal B.O": "312605",
      "Gadola B.O": "312623",
      "Magroda B.O": "312623",
      "Sakriya B.O": "312623",
      "Jamli B.O": "312624",
      "Achalawada B.O": "312615",
      "Kotri B.O": "312615",
      "Lalgarh B.O": "312615",
      "Moheda B.O": "312615",
      "Fathegarh B.O": "312615",
      "Kanad B.O": "312615",
      "Bhojpur B.O": "312625",
      "Chari B.O": "312625",
      "Dantalia B.O": "312625",
      "Anant B.O": "312626",
      "Bharkundi B.O": "312626",
      "Boria B.O": "312626",
      "Gopalpura B.O": "312626",
      "Devla B.O": "312625",
      "Managaon B.O": "312625",
      "Pahada B.O": "312625",
      "Parel B.O": "312625",
      "Badwaskalan B.O": "312615",
      "Chupna B.O": "312615",
      "Hinglat B.O": "312615",
      "Jajli B.O": "312615",
      "Achalpur B.O": "312605",
      "Anwleshwar B.O": "312605",
      "Bajranggarh B.O": "312605",
      "Devgarh B.O": "312605",
      "Gandher B.O": "312605",
      "Kachotiya B.O": "312605",
      "Kherot B.O": "312605",
      "Nakor B.O": "312605",
      "Suhagpura B.O": "312605",
      "Veerpur B.O": "312605",
      "Bhuwasia B.O": "312623",
      "Kesharpura B.O": "312623",
      "Panmodi B.O": "312623",
      "Gadriawas B.O": "312625",
      "Jhadoli B.O": "312625",
      "Keshariawad B.O": "312625",
      "Sihar B.O": "312625",
      "Achnera B.O": "312615",
      "Bedma B.O": "312615",
      "Mowai B.O": "312615",
      "Gadwas B.O": "312625",
      "Lohagarh B.O": "312625",
      "Piplia B.O": "312625",
      "Lodia B.O": "312626",
      "Mungana B.O": "312626",
      "AAd B.O": "312626",
      "Khunta B.O": "312626",
      "Mandvi B.O": "312626",
      "Gothada B.O": "312626",
      "Kutchery Partabgarh S.O": "312605",
      "Rathajana S.O": "312623",
      "Chhoti Sadari S.O": "312604",
      "Pratap garh S.O (Chittorgarh)": "312605",
      "Dalot S.O": "312619",
      "Dhariawad S.O": "312625",
      "Arnod S.O": "312615",
      "Dhamotar  S.O": "312616",
      "Peepalkhunt S.O": "312624",
      "Parsola S.O": "312626"
    },
    "KOTA": {
      "I.P.I.A. KOTA S.O.": "324005",
      "MANDANA S. O.": "325003",
      "NDC Kota": "324002",
      "BORKHERA S.O.": "324003",
      "Khedia B.O": "325207",
      "Borkheda B.O": "324002",
      "Morak Gaon B.O": "326520",
      "Ayani B.O": "325214",
      "Jaloda Khatian B.O": "325214",
      "Laxmi Pura B.O": "325214",
      "Kunjed B.O": "325207",
      "Laturi B.O": "325207",
      "Khedli B.O": "326518",
      "Salera Khurd B.O": "326518",
      "Durjanpura B.O": "325214",
      "Luhawad B.O": "325214",
      "Labaniya B.O": "325207",
      "Moi Kalan B.O": "325207",
      "Hatiya Kheri B.O": "326518",
      "Ruddha Kheda B.O": "326518",
      "Arjunpura B.O": "324002",
      "Kishan Pura Takiya B.O": "324002",
      "Sogaria B.O": "324002",
      "Kheemuch B.O": "326517",
      "Satal Khedi B.O": "326519",
      "Undwa B.O": "326519",
      "Budha Deet B.O": "325204",
      "Dhanwa B.O": "325204",
      "Jhargaon B.O": "325204",
      "Kotradeep Singh B.O": "325204",
      "Mandanpura B.O": "325204",
      "Mandawara B.O": "325204",
      "Deoli B.O": "326518",
      "Dhakadkhedi B.O": "325001",
      "Khajuri B.O": "325001",
      "Khajurna B.O.": "325001",
      "Khandgaon B.O": "325001",
      "Deoli Khurd B.O": "326519",
      "Kudaila B.O": "326519",
      "Hingi B.O": "325601",
      "Kishanpura B.O": "325601",
      "Kundanpur B.O": "325601",
      "Pipa Khedi B.O": "326519",
      "Digod B.O": "325601",
      "Kamolar B.O": "325601",
      "Kuradia B.O": "325601",
      "Rolana B.O": "325601",
      "Shyampura B.O": "325601",
      "Choma Malian B.O": "325203",
      "Golya Hedi B.O": "325203",
      "Ukalda B.O": "325203",
      "Banethia B.O": "325204",
      "Kishorepura B.O": "325204",
      "Morpa B.O": "325204",
      "Takarwara B.O": "325204",
      "Girdharpura B.O": "324008",
      "Bhanwaria B.O": "325003",
      "Gopalpura B.O": "325003",
      "Aamli B.O": "325001",
      "Baniani B.O": "325001",
      "Khurad B.O": "325001",
      "Salawad Khurd B.O": "326530",
      "Mandap B.O": "325601",
      "Haripura B.O": "325203",
      "Polai Kalan B.O": "325203",
      "Rel B.O": "325203",
      "Suhana B.O": "325203",
      "Barod B.O": "325204",
      "Nautara B.O": "325204",
      "Ummedpura B.O": "325003",
      "Mandana B.O": "325003",
      "Mandlya B.O": "325003",
      "Ranpur B.O": "325003",
      "Dolya B.O": "324010",
      "Dhoti B.O": "325001",
      "Gandiphali B.O": "325001",
      "Kherdarasoolpur B.O": "325001",
      "Kamalpura B.O": "326517",
      "Kukra Khurd B.O": "326517",
      "Julmi B.O": "326519",
      "Kumbhkot B.O": "326519",
      "Borina Kalan B.O": "325601",
      "Vinod Khurd B.O": "325601",
      "Bhanda Hera B.O": "325203",
      "Dhaba B.O": "325203",
      "Amarpura B.O": "325204",
      "Kharula B.O": "325204",
      "Kherli Tanwaran B.O": "325204",
      "Lakh Sanija B.O": "325204",
      "Toran B.O": "325204",
      "Nanta B.O": "324008",
      "Dhani Kasar B.O": "325003",
      "Borabas B.O": "324010",
      "Aralia Jagir B.O": "325001",
      "Arand Kheda B.O": "325001",
      "Golana B.O": "325001",
      "Jakhora B.O": "325001",
      "Mawasa B.O": "325001",
      "Naya Nohra B.O": "324002",
      "Barodia Kalan B.O": "326520",
      "Budh Khan B.O": "326520",
      "Sahrod B.O": "325207",
      "Tulsan B.O": "325207",
      "Alod B.O": "326518",
      "Ghatoli B.O": "326518",
      "Mamore B.O": "325602",
      "Sawan Bhadon B.O": "325602",
      "Dungarja B.O": "325201",
      "Binayaka B.O": "325004",
      "Nonera B.O": "325004",
      "Pushod B.O": "325004",
      "Rajopa B.O": "325004",
      "Baluheda B.O": "325602",
      "Dhulet B.O": "325602",
      "Goyanda B.O": "326529",
      "Balupa B.O": "325009",
      "Chhapol B.O": "325009",
      "Jatwada B.O": "325009",
      "Miyana B.O": "325009",
      "Talab B.O": "325009",
      "Manasgaon B.O": "325201",
      "Nimoda B.O": "325201",
      "Parliya B.O": "325201",
      "Tathed B.O": "325201",
      "Bamori B.O": "325208",
      "Bhaura B.O": "325208",
      "Gainta B.O": "325004",
      "Ganeshganj B.O": "325004",
      "Karwad B.O": "325004",
      "Khyawada B.O": "325004",
      "Shahnawda B.O": "325004",
      "Darrah B.O": "325602",
      "Dhipari B.O": "325009",
      "Jorawarpura B.O": "325009",
      "Kakrawada B.O": "325009",
      "Kotsuan B.O": "325201",
      "Sarola B.O": "325208",
      "Bambolia Kalan B.O": "325004",
      "Piplda B.O": "325004",
      "Ranodia B.O": "325004",
      "Anwan B.O": "325602",
      "Bansya hedi B.O": "325602",
      "Hingonia B.O": "325602",
      "Richhadia B.O": "326529",
      "Bagli B.O": "325009",
      "Borda B.O": "325009",
      "Nimola B.O": "325009",
      "Small Industrial Area Kota S.O": "324007",
      "Subzi Mandi Kota S.O": "324006",
      "Suket S.O": "326530",
      "Vigyan Nagar Kota S.O": "324005",
      "P.I.P. Kota S.O": "324005",
      "Talwandi Kota S.O": "324005",
      "Udyog Puri Kota S.O": "324004",
      "Kota H.O": "324001",
      "New Grain Mandi Kota H.O": "324007",
      "Chechat S.O": "326518",
      "Itawa S.O": "325004",
      "Khairabad S.O (Kota)": "326529",
      "Khatoli S.O": "325009",
      "Nayapura Kota S.O": "324001",
      "Ram Ganj Mandi S.O": "326519",
      "Simlia S.O": "325203",
      "Subhash Marg Kota S.O": "324001",
      "Gumanpura Kota S.O": "324007",
      "Industerial Estate Kota S.O": "324003",
      "Kaithun S.O": "325001",
      "Digod S.O": "325201",
      "Gadepan S.O": "325208",
      "New Railway Colony Kota S.O": "324002",
      "Sangod S.O": "325601",
      "Thermal Colony Kota S.O": "324008",
      "Wagon Repair Colony Kota S.O": "324002",
      "Engineering College Kota S.O": "324010",
      "Bapawar S.O": "325207",
      "Kota Jn. S.O": "324002",
      "Kota Kutchery S.O": "324001",
      "Morak S.O": "326517",
      "Mahaveer Nagar Kota S.O": "324005",
      "Aditya Nagar S.O": "326520",
      "Ayana S.O": "325214",
      "Kanwas S.O": "325602",
      "Sultanpur S.O": "325204",
      "Cable Nagar S.O": "325003",
      "Chhawni Ram Chandra Pura S.O": "324007",
      "Dadabari Kota S.O": "324009",
      "Kaithuni Pole Kota S.O": "324006",
      "Kota City S.O": "324006"
    },
    "BARAN": {
      "KERWALIYA B.O": "325209",
      "Kachri B.O": "325209",
      "Sorkhand Kalan B.O": "325209",
      "Bhojya Kheri B.O": "325202",
      "Sorsan B.O": "325202",
      "Badora B.O": "325223",
      "Bhensara B.O": "325223",
      "Shergarh B.O": "325223",
      "Chardana B.O": "325218",
      "Kachra B.O": "325218",
      "Patna B.O": "325218",
      "Barana B.O": "325205",
      "Batawada B.O": "325205",
      "Dhoti B.O": "325205",
      "Gajanpura B.O": "325205",
      "Kalmanda B.O": "325205",
      "Moondla Bisoti B.O": "325205",
      "Ratawad B.O": "325205",
      "Sundlak B.O": "325205",
      "Lisadia B.O": "325222",
      "Bapcha B.O": "325220",
      "Halgana B.O": "325220",
      "Tam Khera B.O": "325209",
      "Bijora B.O": "325209",
      "Anatana B.O": "325218",
      "Ardan B.O": "325218",
      "Barlan B.O": "325218",
      "Mundla B.O": "325218",
      "Bengana B.O": "325205",
      "Chhajawa B.O": "325205",
      "Iklera B.O": "325205",
      "Kherali B.O": "325205",
      "Mandola B.O": "325205",
      "Mathna B.O": "325205",
      "Badwa B.O": "325209",
      "Jai Nagar B.O": "325209",
      "Pachel Kalan B.O": "325209",
      "Khajurana Kalan B.O": "325202",
      "Thikaria B.O": "325202",
      "Bamori B.O": "325223",
      "Bichalas B.O": "325223",
      "Jalwara B.O": "325218",
      "Khuri B.O": "325218",
      "Piplod B.O": "325218",
      "Fatehpur B.O": "325205",
      "Karnaheda B.O": "325205",
      "Melkheri B.O": "325205",
      "Nareda B.O": "325205",
      "Patheda B.O": "325205",
      "Hingonia B.O": "325222",
      "Simli B.O": "325222",
      "Batawada Par B.O": "325220",
      "Godia Mehar B.O": "325220",
      "Hana Heri B.O": "325220",
      "Kotri B.O": "325220",
      "Kulinjara B.O": "325220",
      "Mundkya B.O": "325220",
      "Nipania B.O": "325220",
      "Pachpada B.O": "325220",
      "Teetar Kheri B.O": "325220",
      "Telni B.O": "325220",
      "Ajnawar B.O": "325221",
      "Bamorighata B.O": "325221",
      "Banjari B.O": "325221",
      "Bhavpura B.O": "325221",
      "Khajuria B.O": "325221",
      "Rai B.O": "325221",
      "Sarthal B.O": "325221",
      "Sethkolu B.O": "325221",
      "Bansthuni B.O": "325216",
      "Baroni B.O": "325216",
      "Asnawar B.O": "325215",
      "Bamori Kalan B.O": "325215",
      "Relawan  B.O. B.O": "325215",
      "Sevni B.O": "325215",
      "Simlia B.O": "325215",
      "Hani Heda B.O": "325219",
      "Kharkheda Ramlothan B.O": "325219",
      "Kundi B.O": "325219",
      "Mothpur B.O": "325219",
      "Agar B.O": "325217",
      "Khatka B.O": "325217",
      "Mahodra B.O": "325217",
      "Mundiyar B.O": "325217",
      "Shubhadra Colony B.O": "325217",
      "Badipura B.O": "325224",
      "Paraniya B.O": "325224",
      "Kadia Ban B.O": "325220",
      "Phalia B.O": "325220",
      "Semli B.O": "325220",
      "Gordhanpra B.O": "325221",
      "Harnawda Shaji ED B.O": "325221",
      "Kachnariya Kalan B.O": "325221",
      "Kadia Hat B.O": "325220",
      "Kotrapar B.O": "325220",
      "Bilendi B.O": "325221",
      "Dholam B.O": "325221",
      "Digod Khalsa B.O": "325221",
      "Gagchana B.O": "325221",
      "Jhinjhni B.O": "325221",
      "Kalmodiya B.O": "325221",
      "Sahjanpur B.O": "325221",
      "Digodpar B.O": "325216",
      "Sakrawada B.O": "325216",
      "Bhatwada B.O": "325215",
      "Ishwarpura B.O": "325215",
      "Mau B.O": "325215",
      "Raingarh B.O": "325215",
      "Nanawata B.O": "325219",
      "Phool Barod B.O": "325219",
      "Beel Kheda Dang B.O": "325217",
      "Benta B.O": "325217",
      "Kasba Thana B.O": "325217",
      "Sahrol Taleti B.O": "325217",
      "Badgaon B.O": "325206",
      "Patunda B.O": "325206",
      "Bhanwargarh B.O": "325224",
      "Jarela B.O": "325215",
      "Karwari Kalan B.O": "325215",
      "Kishanpura B.O": "325215",
      "Mal Bamori B.O": "325215",
      "Deori B.O": "325217",
      "Dhikwani B.O": "325217",
      "Ganeshpura B.O": "325217",
      "Khanda Sahrol B.O": "325217",
      "Raithal B.O": "325206",
      "Shahpura B.O": "325206",
      "Tisaya B.O": "325222",
      "Udpura B.O": "325206",
      "Chhaatarganj B.O": "325224",
      "Ghatti Colony B.O": "325224",
      "Kadia Nohar B.O": "325220",
      "Pali B.O": "325220",
      "Deori jodh B.O": "325221",
      "Digod Jagir B.O": "325221",
      "Kalpajagir B.O": "325221",
      "Mohkampura B.O": "325221",
      "Chhinod B.O": "325216",
      "Garda B.O": "325216",
      "Missai B.O": "325216",
      "Dhumar Khedi B.O": "325215",
      "Jaloda Tejaji B.O": "325215",
      "Piplod Kalan B.O": "325215",
      "Ramgarh B.O": "325215",
      "Dilod B.O": "325219",
      "Hathidilod B.O": "325219",
      "Mawasa B.O": "325219",
      "Musai Gujaran B.O": "325219",
      "Tancha B.O": "325219",
      "Bamangaon B.O": "325217",
      "Beel Kheda Mal B.O": "325217",
      "Bhoyal B.O": "325217",
      "Kasba Nonera B.O": "325217",
      "Natai B.O": "325217",
      "Rajpur B.O": "325217",
      "Samrania B.O": "325217",
      "Sanwara B.O": "325217",
      "Baldarah B.O": "325206",
      "Balda B.O": "325224",
      "Khandela B.O": "325224",
      "Kherli B.O": "325224",
      "Nahargarth B.O": "325224",
      "Bamolia Kalan B.O": "325209",
      "Mandeeta B.O": "325202",
      "Mirja Pur B.O": "325202",
      "Palaitha B.O": "325202",
      "Raj Garh B.O": "325202",
      "Katawar B.O": "325223",
      "Richhanda B.O": "325223",
      "Sakatpur B.O": "325223",
      "Marma Chah B.O": "325218",
      "Merma Talab B.O": "325218",
      "Bamla B.O": "325207",
      "Bada B.O": "325222",
      "Koyala B.O": "325222",
      "Miyada B.O": "325222",
      "Bhilwada Neecha B.O": "325220",
      "Bhulon B.O": "325220",
      "Bhuwakheri B.O": "325220",
      "Chachoda B.O": "325220",
      "Jaipla B.O": "325220",
      "Bajrang Garh B.O": "325216",
      "Anta S.O": "325202",
      "Bohat S.O": "325222",
      "Kelwara S.O": "325224",
      "ATRU S.O": "325218",
      "Chhabra S.O": "325220",
      "Chhipa Barod S.O": "325221",
      "Mangrol S.O": "325215",
      "Baran MDG S.O": "325205",
      "Kishan Ganj S.O": "325216",
      "Krishi Upaj Mandi Baran S.O": "325205",
      "Shahabad S.O (Baran)": "325217",
      "Anta Gas Power Project Anta S.O": "325209",
      "Atone S.O": "325223",
      "Salpura S.O": "325219",
      "Siswali S.O": "325206"
    },
    "UDAIPUR": {
      "Amberi B.O": "313011",
      "Chansda B.O": "313003",
      "Kharwa B.O": "313003",
      "Umaramines B.O": "313003",
      "Bokhada B.O": "313704",
      "Padrada B.O": "313704",
      "Roachh B.O": "313704",
      "Chandora B.O": "313903",
      "Kolar B.O": "313903",
      "Medi Dhani B.O": "313903",
      "Sagtari B.O": "313903",
      "Surkhand Ka Khera B.O": "313903",
      "Karda B.O": "313001",
      "Palodara B.O": "313001",
      "Piladhar B.O": "313001",
      "Kikawas B.O": "313601",
      "Morath B.O": "313206",
      "Bana Khurd B.O": "313902",
      "Katanwara B.O": "313904",
      "Kejad B.O": "313902",
      "Pal Sarara B.O": "313902",
      "Sagtara B.O": "313902",
      "Ganawal B.O": "313704",
      "Jemli B.O": "313704",
      "Kamol B.O": "313704",
      "Kalyanpur B.O": "313903",
      "Kuradia B.O": "313903",
      "Navda B.O": "313903",
      "Shayampura B.O": "313903",
      "Bhoiyon Ki Pancholi B.O": "313003",
      "Kaladwas B.O": "313003",
      "Kanpur B.O": "313003",
      "Lakadwas B.O": "313003",
      "Matoon B.O": "313003",
      "Bhuwana B.O": "313001",
      "Dakan Kotra B.O": "313001",
      "Dhinkli B.O": "313001",
      "Dhundi B.O": "313001",
      "Karanpur B.O": "313601",
      "Rundera B.O": "313601",
      "Deopura B.O": "313901",
      "Jawar B.O": "313901",
      "Bhensda Kalan B.O": "313024",
      "Puria Kheri B.O": "313601",
      "Tarawat B.O": "313601",
      "Mahuwara B.O": "313901",
      "Bhalon Ka Guda B.O": "313024",
      "Khartana B.O": "313206",
      "Pal Nimboda B.O": "313902",
      "Diyan B.O": "313704",
      "Palasma B.O": "313704",
      "Punawali B.O": "313704",
      "Semad B.O": "313704",
      "Chorai B.O": "313903",
      "Depur B.O": "313903",
      "Kunda B.O": "313903",
      "Rajol B.O": "313903",
      "Jhamar Kotra B.O": "313003",
      "B K Kalwana B.O": "313704",
      "Bhanpura B.O": "313704",
      "Singhara B.O": "313704",
      "Suavaton Ka Guda B.O": "313704",
      "Tarpal B.O": "313704",
      "Dhankiwara B.O": "313903",
      "Jambuda B.O": "313027",
      "Kewda Khurd B.O": "313001",
      "Saveena B.O": "313001",
      "Titardi B.O": "313001",
      "Balathal B.O": "313601",
      "Bhatewaar B.O": "313601",
      "Dhamania B.O": "313601",
      "Bichhadi B.O": "313024",
      "Debari B.O": "313024",
      "Gudli B.O": "313706",
      "Balicha B.O": "313804",
      "Fatehpur B.O": "313001",
      "Kathar B.O": "313001",
      "Paner B.O": "313001",
      "Royda B.O": "313001",
      "ARS Station B.O": "313601",
      "Nawania B.O": "313601",
      "Padla B.O": "313901",
      "Singhatwara B.O": "313901",
      "Sakroda B.O": "313203",
      "Amar Pura B.O": "313602",
      "Arnia B.O": "313604",
      "Dhikiya B.O": "313604",
      "Lunda B.O": "313604",
      "Agad B.O": "313604",
      "Akola B.O": "313604",
      "Dholia B.O": "313604",
      "Kali Bhit B.O": "313604",
      "Anjani B.O": "313604",
      "Baalicha B.O": "313604",
      "Lasadia B.O": "313604",
      "Sheshpur B.O": "313038",
      "Bharev B.O": "313604",
      "Deolia B.O": "313604",
      "Dhamniya B.O": "313604",
      "Kun B.O": "313604",
      "Laku Ka Lewa B.O": "313604",
      "Vati B.O": "313322",
      "Lakhawali B.O": "313011",
      "Idana B.O": "313706",
      "Mayada B.O": "313706",
      "Panund B.O": "313706",
      "Phila B.O": "313706",
      "Bansada B.O": "313603",
      "Bhopa Khera B.O": "313603",
      "Dabaycha B.O": "313804",
      "Deri B.O": "313804",
      "Harshawara B.O": "313804",
      "Sundra B.O": "313804",
      "Thana B.O": "313904",
      "Gupri B.O": "313022",
      "Iswal B.O": "313011",
      "Loyra B.O": "313011",
      "Thoor B.O": "313011",
      "Dhundia B.O": "313603",
      "Kundai B.O": "313603",
      "Saleda B.O": "313603",
      "Barda B.O": "313011",
      "Bhutala B.O": "313011",
      "Sapetia B.O": "313011",
      "Ballabh B.O": "313706",
      "Gingla B.O": "313706",
      "Utharda B.O": "313706",
      "Badgaon B.O": "313205",
      "Kkunthwas B.O": "313603",
      "Sarangpura B.O": "313604",
      "Kanbai B.O": "313804",
      "Nayagaon B.O": "313038",
      "Sarera B.O": "313804",
      "Daroli B.O": "313022",
      "Bari Tb (S) B.O": "313011",
      "Bedla B.O": "313011",
      "Losing B.O": "313011",
      "Madar B.O": "313011",
      "Shobhagpura B.O": "313011",
      "Narayan Seva Sansthan": "313011",
      "Dhavdi B.O": "313706",
      "Gudel B.O": "313706",
      "Sihad B.O": "313706",
      "Sulawas B.O": "313706",
      "Tekan B.O": "313706",
      "Chargadia B.O": "313603",
      "Hinta B.O": "313603",
      "Motida B.O": "313603",
      "Dayli B.O": "313904",
      "Nathara B.O": "313904",
      "Adiwali B.O": "313804",
      "Jayra B.O": "313804",
      "Karawada B.O": "313804",
      "Patia B.O": "313804",
      "Pithalpura B.O": "313604",
      "Boyana B.O": "313201",
      "Dholi Magri B.O": "313201",
      "Sangwa B.O": "313201",
      "Arinda B.O": "313602",
      "Baggad B.O": "313602",
      "Menar B.O": "313602",
      "Badla B.O": "313803",
      "Ghodi B.O": "313803",
      "Khandiobri B.O": "313803",
      "Sulai B.O": "313803",
      "Bikarni B.O": "307025",
      "Guran B.O": "307025",
      "Mahad B.O": "307025",
      "Mamer B.O": "307025",
      "Nayawas B.O": "307025",
      "Bemla B.O": "313703",
      "Jagat B.O": "313703",
      "Wali B.O": "313703",
      "Bhimal B.O": "313203",
      "Khempur B.O": "313203",
      "Bujhra B.O": "313031",
      "Madla B.O": "313702",
      "Pipalwara B.O": "313702",
      "Bekria B.O": "313708",
      "Gogrood B.O": "313708",
      "Beerothi B.O": "313906",
      "Bhansol Garwara B.O": "313204",
      "Damana B.O": "313702",
      "Dewas B.O": "313702",
      "Ghasa B.O": "313201",
      "Nahar Magra B.O": "313201",
      "Rakhyawal B.O": "313201",
      "Salera Kalan B.O": "313201",
      "Veerdholia B.O": "313201",
      "Barodia B.O": "313602",
      "Batharda Kalan B.O": "313602",
      "Batharda Khurd B.O": "313602",
      "Modi B.O": "313705",
      "Onarsingh Ki Bhagal B.O": "313602",
      "Vana B.O": "313602",
      "Bhanda B.O": "313803",
      "Dhinkwas B.O": "313803",
      "Suveri B.O": "313803",
      "Bakhel B.O": "307025",
      "Barli B.O": "307025",
      "Dhedmaria B.O": "307025",
      "Mandawal B.O": "307025",
      "Mandwa B.O": "307025",
      "Medi B.O": "307025",
      "Merpur B.O": "307025",
      "Adwas B.O": "313703",
      "Ajbara B.O": "313703",
      "Shishvi B.O": "313703",
      "Lopada B.O": "313203",
      "Phalichada B.O": "313203",
      "Vadiyar B.O": "313203",
      "Alsigarh B.O": "313031",
      "Baghpura B.O": "313702",
      "Jekra B.O": "313702",
      "Rao Madra B.O": "313708",
      "Saidem B.O": "313708",
      "Teja Ka Was B.O": "313708",
      "Gejvi B.O": "313906",
      "Padawali B.O": "313906",
      "Sameeja B.O": "313906",
      "Vass B.O": "313906",
      "Dheemari B.O": "313702",
      "Dodawali B.O": "313702",
      "Godana B.O": "313702",
      "Sallada B.O": "313905",
      "Sarsia B.O": "313905",
      "Udaipuria Jagir B.O": "313905",
      "Kharsan B.O": "313602",
      "Bawalwara B.O": "313803",
      "Khanmeen B.O": "313803",
      "Larathi B.O": "313803",
      "Pograkalan B.O": "313803",
      "Saroli B.O": "313803",
      "Jogiwara B.O": "307025",
      "Kagwas B.O": "307025",
      "Samoli B.O": "307025",
      "Sandraf B.O": "307025",
      "Naijhar B.O": "313703",
      "Semal B.O": "313703",
      "Madri B.O": "313702",
      "Makradeo B.O": "313702",
      "Saradeet B.O": "313702",
      "Sisarma B.O": "313031",
      "Jhadoli B.O": "313708",
      "Kyari B.O": "313708",
      "Loharcha B.O": "313708",
      "Malwa Ka Chora B.O": "313708",
      "Amloda B.O": "313038",
      "Bhabrana B.O": "313038",
      "Ghatod B.O": "313905",
      "Dholgiri Ka Khera B.O": "313038",
      "Jodhpur Khurd B.O": "313038",
      "Karakalan B.O": "313038",
      "Manpur B.O": "313701",
      "Bijanwas B.O": "313201",
      "Chandesara B.O": "313201",
      "Majawada B.O": "313602",
      "Barothi B.O": "313803",
      "Bayri B.O": "313803",
      "Jawas B.O": "313803",
      "Karchha B.O": "313803",
      "Katarwas B.O": "313803",
      "Jed B.O": "307025",
      "Juda B.O": "307025",
      "Khajuria B.O": "307025",
      "Mahadi B.O": "307025",
      "Sada B.O": "307025",
      "Dantesar B.O": "313703",
      "Jawad B.O": "313204",
      "Methudi B.O": "313703",
      "Gadoli B.O": "313203",
      "Ladani B.O": "313203",
      "Bari Undri B.O": "313031",
      "Pai B.O": "313031",
      "Dhol B.O": "313708",
      "Jaswantgarh B.O": "313708",
      "Mewaron Ka Math B.O": "313708",
      "Pipla B.O": "313708",
      "Chirwa B.O": "313202",
      "Gogala B.O": "313702",
      "Mohd. Phalasia B.O": "313702",
      "Sultan Ji ka  Kherwara B.O": "313702",
      "Chatpur B.O": "313905",
      "Shyampura B.O": "313905",
      "Jetana B.O": "313038",
      "Samoda B.O": "313038",
      "B K Kherwara B.O": "313702",
      "Gorana B.O": "313702",
      "Khakhad B.O": "313702",
      "Dhingri B.O": "313905",
      "Kantora B.O": "313905",
      "Veerpura B.O": "313905",
      "Budel B.O": "313038",
      "Ghated B.O": "313038",
      "Kalyankalan B.O": "313038",
      "Matasula B.O": "313038",
      "Payara B.O": "313038",
      "Kadmal B.O": "313322",
      "Kaliwas B.O": "313202",
      "Khedi B.O": "313022",
      "Kachhaba B.O": "313705",
      "Majawad B.O": "313705",
      "Majawadi B.O": "313705",
      "Nal B.O": "313705",
      "Obra Kalan B.O": "313705",
      "Badawali B.O": "313026",
      "Baroda B.O": "313026",
      "Pandiyawara B.O": "313026",
      "Shaktawat Ka Guda B.O": "313026",
      "Tokar B.O": "313026",
      "Changedi B.O": "313205",
      "Intali B.O": "313205",
      "Bagdunda B.O": "313705",
      "Rawalia Kalan B.O": "313705",
      "Intali Pal B.O": "313026",
      "Katev B.O": "313026",
      "Oda B.O": "313701",
      "Garnalakotra B.O": "313802",
      "Godawat Gorimba B.O": "313802",
      "Bassi B.O": "313027",
      "Bassi Junjawat B.O": "313027",
      "Kherad B.O": "313027",
      "Morila B.O": "313027",
      "Orwaria B.O": "313027",
      "Mahuda B.O": "313204",
      "Palan Kalan B.O": "313204",
      "Sindhu B.O": "313204",
      "Thamla B.O": "313204",
      "Chanawada B.O": "313801",
      "Kaya B.O": "313801",
      "Pal Kharwad B.O": "313801",
      "Bichhiwara B.O": "313701",
      "Daiya B.O": "313701",
      "Kolyari B.O": "313701",
      "Lathuni B.O": "313701",
      "Som B.O": "313701",
      "Upreta B.O": "313701",
      "Kagdar B.O": "313802",
      "Kanuwara B.O": "313802",
      "Ugamna Kotra B.O": "313802",
      "Bedawal B.O": "313027",
      "Chiboda B.O": "313027",
      "Dal B.O": "313027",
      "Dharod B.O": "313027",
      "Gamda Pal B.O": "313027",
      "Thada B.O": "313027",
      "Nandwel B.O": "313022",
      "Vasni Kalan B.O": "313205",
      "Bhadviguda B.O": "313705",
      "Chhali B.O": "313705",
      "Ravlia Khurd B.O": "313705",
      "Surajgarh B.O": "313705",
      "Dagar B.O": "313026",
      "Noli B.O": "313026",
      "Adkalia B.O": "313027",
      "Merta B.O": "313022",
      "Chatia Khedi B.O": "313705",
      "Chorbaori B.O": "313705",
      "Mada B.O": "313705",
      "Morwal B.O": "313705",
      "Bhoraipal B.O": "313026",
      "Godasar B.O": "313026",
      "Mallada B.O": "313026",
      "Rathora B.O": "313026",
      "Noorda B.O": "313204",
      "Wanri B.O": "313204",
      "Barapal B.O": "313801",
      "Paduna B.O": "313801",
      "Sarupal B.O": "313801",
      "Ambassa B.O": "313701",
      "Amlia B.O": "313701",
      "Balua B.O": "313802",
      "Bhudar B.O": "313802",
      "Kojawara B.O": "313802",
      "Pareda B.O": "313802",
      "Sagwara B.O": "313802",
      "Banoda B.O": "313027",
      "Deogam B.O": "313027",
      "Kharka B.O": "313027",
      "Seria B.O": "313027",
      "Toda B.O": "313027",
      "Jewana B.O": "313206",
      "Tidi B.O": "313801",
      "Amiwara B.O": "313701",
      "Nichli Sigri B.O": "313701",
      "Bilakh B.O": "313802",
      "Massaron Ki Obri B.O": "313802",
      "Paderi B.O": "313802",
      "Pipli (A) B.O": "313802",
      "Pipli (B) B.O": "313802",
      "Bamnia B.O": "313027",
      "Isarwas Dangiyan B.O": "313027",
      "Karawali B.O": "313027",
      "Malpur B.O": "313027",
      "Saradi B.O": "313027",
      "Bhinder S.O (Udaipur)": "313603",
      "Chhani S.O (Udaipur)": "313804",
      "Dabok S.O": "313022",
      "Fatehnagar S.O (Udaipur)": "313205",
      "Badgaon S.O": "313011",
      "Bambora S.O": "313706",
      "Chawand S.O": "313904",
      "Udaipur H.O": "313004",
      "Intali Khera S.O": "313026",
      "Khemli S.O": "313201",
      "Kherwara S.O": "313803",
      "Kurawar S.O (Udaipur)": "313703",
      "Nandeshma S.O": "313708",
      "Jhadol (S) S.O": "313905",
      "Palana Khurd S.O": "313204",
      "Udaipur Naya Sarafa S.O": "313001",
      "Udaipur Rani Road S.O": "313001",
      "Udaipur Shastri Circle S.O": "313001",
      "Dhelana": "313805",
      "Ogna S.O": "313906",
      "Parsad S.O": "313801",
      "Sanwar S.O (Udaipur)": "313206",
      "Sarara S.O": "313902",
      "Semari S.O": "313903",
      "Udaipur H Magri S.O": "313002",
      "Udaipur Macchala Magra S.O": "313001",
      "Udaipur Railway Station S.O": "313001",
      "Udaipur Station Road S.O": "313001",
      "Udaipur University Campus S.O": "313001",
      "Zinc Smelter S.O": "313024",
      "Jhadol (P) S.O": "313702",
      "Kanore S.O": "313604",
      "Phalasia S.O": "313701",
      "Salumber S.O": "313027",
      "Udaipur Pratapnagar S.O": "313001",
      "Vallabhnagar S.O (Udaipur)": "313601",
      "Gogunda S.O": "313705",
      "Jhallara S.O": "313038",
      "Kheroda S.O": "313602",
      "Kotra S.O (Udaipur)": "307025",
      "Mavli Jn. S.O": "313203",
      "Nai S.O": "313031",
      "Rishabhdeo S.O": "313802",
      "Sayra S.O": "313704",
      "Udaipur City S.O": "313001",
      "Udaipur Fatehpura S.O": "313001",
      "Udaipur Industrial Area S.O": "313003",
      "Udaipur Palace Road S.O": "313001",
      "Udaipur Surajpole S.O": "313001",
      "Zawar Mines S.O": "313901"
    },
    "JAISALMER": {
      "Damodara BO": "345001",
      "Chhatrel BO": "345001",
      "Mokhala BO": "345001",
      "Dangari BO": "345027",
      "Roopsi BO": "345001",
      "Mulana BO": "345001",
      "Bhadasar BO": "345001",
      "Dedha BO": "345001",
      "Rasla BO": "345001",
      "Parewar BO": "345001",
      "Keeta BO": "345001",
      "Bhoo BO": "345001",
      "Amarsalagar BO": "345001",
      "Khinya BO": "345001",
      "Dewa BO": "345001",
      "Koda BO": "345027",
      "Lakha BO": "345027",
      "Modha BO": "345027",
      "Rewari BO": "345027",
      "Seerhar BO": "345027",
      "Bericiyala BO": "345034",
      "Phulia BO": "345034",
      "Chandan BO": "345031",
      "Sodakore BO": "345031",
      "Hamira BO": "345033",
      "Sam BO": "345001",
      "Baramsar BO": "345001",
      "Salkha BO": "345001",
      "Tejpala BO": "345001",
      "Madwa BO": "345024",
      "Baiya BO": "345027",
      "Kunda BO": "345027",
      "Rama BO": "345027",
      "Randha BO": "345027",
      "Sangad BO": "345027",
      "Kotri BO": "345034",
      "Pithala BO": "345034",
      "Satto BO": "345034",
      "Chacha BO": "345031",
      "Dholiya BO": "345031",
      "Kanod Rawaliya BO": "345033",
      "Away BO": "345028",
      "Poonam Nagar BO": "345001",
      "Adabala BO": "345001",
      "Bandha BO": "345001",
      "Deora BO": "345001",
      "Bhagu Ka Gaon BO": "345001",
      "Sonu BO": "345001",
      "Bida BO": "345001",
      "Chatogarh BO": "345001",
      "Dabla BO": "345001",
      "Balu Singh Ki Dhani BO": "345024",
      "Jaimla BO": "345024",
      "Kapuriya BO": "345027",
      "Badoda Gaon BO": "345001",
      "Dhaisar BO": "345001",
      "Narsinghaon Ki Dhani BO": "345001",
      "Kanoi BO": "345001",
      "Kathori BO": "345001",
      "Khuiyala BO": "345001",
      "Nedai BO": "345001",
      "Sultana BO": "345001",
      "Chelak BO": "345001",
      "Lanela BO": "345001",
      "Pannasar BO": "345024",
      "Bhadli BO": "345027",
      "Devikot BO": "345027",
      "Jhinjhinyali BO": "345027",
      "Tejmalta BO": "345027",
      "Tejrawa BO": "345027",
      "Mandai BO": "345027",
      "Karda BO": "345034",
      "Lunar BO": "345034",
      "Myazhar BO": "345034",
      "Pochina BO": "345034",
      "Bhadariya BO": "345031",
      "Delasar BO": "345031",
      "Khetolai BO": "345031",
      "Odhania BO": "345031",
      "Askandra BO": "345028",
      "Pancheka Talab BO": "345028",
      "Satyaya BO": "345028",
      "Tadana BO": "345028",
      "Bahala BO": "345028",
      "Bharewala BO": "345028",
      "Bodana BO": "342310",
      "Sanwara Gaon BO": "342310",
      "Bandhewa BO": "345025",
      "Rajmathai BO": "345025",
      "Swami Ki Dhani BO": "345025",
      "Chowk BO": "345021",
      "Gomat BO": "345021",
      "Jhalaria BO": "345021",
      "Padroda BO": "345021",
      "Ratariya BO": "345021",
      "Ekah BO": "345023",
      "Loharki BO": "345023",
      "Bonada BO": "345026",
      "Sanawara BO": "345026",
      "Tawriwala BO": "345028",
      "Jhabra BO": "345021",
      "Kelawa BO": "345021",
      "Lawan BO": "345021",
      "Ajasar BO": "345023",
      "Bardana BO": "345023",
      "Chayan BO": "345023",
      "Raghwa BO": "345022",
      "Seuwa BO": "345022",
      "Loona Kallan BO": "345026",
      "Loona Khurd BO": "345026",
      "Chinu BO": "345028",
      "Sohanpura BO": "345025",
      "Nathusar BO": "345021",
      "Ujlan BO": "345021",
      "Khara BO": "345023",
      "Bhensara BO": "345026",
      "Rajgarh BO": "345026",
      "Didhu BO": "345028",
      "Madasar BO": "345028",
      "Bhikodai BO": "345025",
      "Dantal BO": "345025",
      "Padampura BO": "345025",
      "Phulasar BO": "345025",
      "Baghthal BO": "345021",
      "Barath Ka Gaon BO": "345021",
      "Modardi BO": "345021",
      "Tanot BO": "345022",
      "Nedan BO": "345026",
      "Ola BO": "345026",
      "Jaisalmer Gopa Chowk SO": "345001",
      "Jaisalmer Ignp Colony SO": "345001",
      "Khoohri SO": "345034",
      "Nachana SO": "345028",
      "Nokh SO": "342310",
      "Pokaran SO": "345021",
      "Ramgarh SO Jaisalmer": "345022",
      "Phalsund SO": "345025",
      "Ramdeora SO": "345023",
      "Lathi SO Jaisalmer": "345031",
      "Pokaran City SO": "345021",
      "Sankra SO Jaisalmer": "345026",
      "Jaisalmer HO": "345001",
      "Jaisalmer Bsf SO": "345001",
      "Fatehgarh SO": "345027",
      "Gandhi Colony Jaisalmer SO": "345001",
      "Bhaniyana SO": "345024",
      "Jaisalmer Collectorate SO": "345001"
    },
    "JAIPUR": {
      "Didawata BO": "303006",
      "Gopalpura BO": "303108",
      "Jhardla BO": "303006",
      "Dhamana BO": "303009",
      "Jhag BO": "303009",
      "Chainpura BO": "303348",
      "Narera BO": "303005",
      "Nimera BO": "303005",
      "Akoda BO": "303338",
      "Bobas B.O": "303124",
      "Bagawas BO": "303603",
      "Baseri Khurd BO": "303603",
      "Bhainsawa BO": "303603",
      "Doongri Khurd BO": "303603",
      "Dabach BO": "303006",
      "Dosara BO": "303006",
      "Gangoti Kalan BO": "303009",
      "Kansel BO": "303009",
      "Mamana BO": "303348",
      "Sanwarda BO": "303348",
      "Chakwada BO": "303005",
      "Choru BO": "303005",
      "Kishorpura BO": "303005",
      "Gudha Bersal BO": "303338",
      "Kachroda BO": "303338",
      "Doongrikalan BO": "303603",
      "Mandore BO": "303009",
      "Gidhani BO": "303348",
      "Marwa BO": "303348",
      "Ghatiyali BO": "303005",
      "Kudli BO": "303005",
      "Mandi BO": "303005",
      "Mehandwas BO": "303005",
      "Boraj BO": "303338",
      "Hirnoda BO": "303338",
      "Harsoli BO": "303008",
      "Khedi Milk BO": "303603",
      "Sanwali BO": "303009",
      "Srirampura BO": "303348",
      "Ladana BO": "303005",
      "Lasadiya BO": "303005",
      "Mandawari BO": "303005",
      "Pachala BO": "303005",
      "Parwan BO": "303005",
      "Malyawas BO": "303338",
      "Rojdi BO": "303338",
      "Shardulpura BO": "303338",
      "Teja Ka Bas BO": "303338",
      "Ugariwas BO": "303338",
      "Kishangarh Renwal BO": "303603",
      "Asalpur BO": "303604",
      "Habaspura BO": "303604",
      "Bichoon BO": "303604",
      "Korsina BO": "303604",
      "Nangal Govind BO": "303602",
      "Kareda Khurd BO": "303901",
      "Kothoon BO": "303901",
      "Malpuria BO": "303901",
      "Sawai Madhosinghpura BO": "303901",
      "Silki Doongari BO": "303901",
      "Tamariya BO": "303901",
      "Thoomli Ka Bas BO": "303901",
      "BHAPURA BO": "303904",
      "Dantri BO": "303008",
      "Dhandholi BO": "303008",
      "Sali BO": "303008",
      "Sewa BO": "303008",
      "Sinodia BO": "303008",
      "Kalakh BO": "303124",
      "Kodi BO": "303328",
      "Bassi Naga BO": "303706",
      "Bhamori BO": "303706",
      "Durjania Was BO": "303706",
      "Manda Bhim Singh BO": "303604",
      "Gudhaliya BO": "303602",
      "Kishanpura BO": "303602",
      "Ajairajpura BO": "303007",
      "Chhandel Kalan BO": "303901",
      "Kadera BO": "303901",
      "Nimodiya BO": "303901",
      "Dabla Kalan BO": "303904",
      "Pahandia BO": "303904",
      "Peepla BO": "303904",
      "Nanan BO": "303008",
      "Pachar BO": "303706",
      "Achalpura BO": "303908",
      "Dhani Boraj BO": "303328",
      "Dheendha BO": "303328",
      "Mundoti BO": "303328",
      "Sinodiya BO": "303328",
      "Machwa BO": "303706",
      "Arp Dhelana BO": "303908",
      "Jhapda Kalan BO": "303908",
      "Radoli BO": "303908",
      "Roopahedi Khurd BO": "303908",
      "Theekariya Meena BO": "303908",
      "Chandamakalan BO": "303006",
      "Kazipura BO": "303604",
      "Salt Colony BO": "303604",
      "Mokhampura BO": "303604",
      "Astikalan BO": "303602",
      "Deva Ka Bas BO": "303602",
      "Itawa BO": "303602",
      "Awania BO": "303007",
      "Begas BO": "303007",
      "DEHMI KALAN": "303007",
      "Gadota BO": "303007",
      "Mahlan BO": "303007",
      "Gohandi BO": "303904",
      "Harsulia BO": "303904",
      "Heerapura BO": "303904",
      "Mohabatpura BO": "303904",
      "Gagardoo BO": "303008",
      "Gehlota BO": "303008",
      "Khudiyala BO": "303008",
      "Padasoli BO": "303305",
      "Rehlana BO": "303008",
      "Sakhoon BO": "303008",
      "Bhadwa BO": "303328",
      "Bhaislana BO": "303328",
      "Jorpura BO": "303328",
      "Jorpura Sundariawas B.O": "303124",
      "Murlipura B.O": "303124",
      "Barodiya BO": "303908",
      "Ramnagar BO": "303908",
      "Roopa Hedi Kalan BO": "303908",
      "Theekariya Gujran BO": "303908",
      "Khandel BO": "303604",
      "Tyod BO": "303604",
      "Luniawas BO": "303602",
      "Turkyawas BO": "303602",
      "Rampura Unti BO": "303007",
      "Akodiya BO": "303901",
      "Garwasi BO": "303901",
      "Mandlia Meda BO": "303901",
      "Sanwalia BO": "303901",
      "Shaakar Khawda BO": "303901",
      "Thali BO": "303001",
      "Chittora BO": "303904",
      "Panwalia BO": "303904",
      "Ladera BO": "303008",
      "Rasili BO": "303008",
      "Sirohi Kalan BO": "303008",
      "Bhojpura BO": "303328",
      "Mundota BO": "303706",
      "Kashipura BO": "303908",
      "Khera Raniwas BO": "303908",
      "Bhankrota BO": "303006",
      "Bichi BO": "303006",
      "Shivsinghpura BO": "303806",
      "Bhopawa BO": "303807",
      "Gulab Bari BO": "303806",
      "Jagatpura BO": "303806",
      "Jatanwali BO": "303806",
      "Mahar Kalan BO": "303806",
      "Beelwadi BO": "303102",
      "Chhitoli BO": "303102",
      "Sothana BO": "303102",
      "Mundiagaarh BO": "303603",
      "Ramjipura BO": "303603",
      "Teetaria BO": "303903",
      "Toontoli BO": "303903",
      "Devan BO": "303103",
      "Badi Jori BO": "303103",
      "Devipura BO": "303103",
      "Khori BO": "303103",
      "Jaitpura Khinchi BO": "303002",
      "Nayan BO": "303601",
      "Radawas BO": "303601",
      "Bhawani BO": "303001",
      "Hadota BO": "303702",
      "Khadi Bagh BO": "303702",
      "Amarpura BO": "303804",
      "Charanwas BO": "303804",
      "Dhanota BO": "303804",
      "Kanipura BO": "303701",
      "Nangal Ladi BO": "303701",
      "Punana BO": "303701",
      "Raghunathpura BO": "303107",
      "Anantpura BO": "303712",
      "Mathasula BO": "303109",
      "Raisar BO": "303109",
      "Alisar BO": "303801",
      "Chinoi BO": "303801",
      "Dhola Ka Bas BO": "303801",
      "Jaisinghpura BO": "303106",
      "Naupura BO": "303801",
      "Singot Kalan BO": "303803",
      "Kujota BO": "303108",
      "Mohanpura BO": "303301",
      "Mahar Khurd BO": "303806",
      "Loharwada BO": "303807",
      "Kuthada BO": "303102",
      "Surmalikpur BO": "303603",
      "Khijuria Brahmin BO": "303903",
      "Sambharia BO": "303903",
      "Yaarlipura BO": "303903",
      "Vidhani BO": "303905",
      "Badodia BO": "303103",
      "Let Ka Bas BO": "303103",
      "Nathawala BO": "303103",
      "Rampura BO": "303106",
      "Kant BO": "303103",
      "Rajpurawas Tala BO": "303002",
      "Hanutia BO": "303601",
      "Footalo BO": "303001",
      "Bajrangpura BO": "303119",
      "Jawanpura BO": "303119",
      "Nangal Koju BO": "303804",
      "Raopura BO": "303804",
      "Amloda BO": "303120",
      "Chatarpura BO": "303701",
      "Jairampura BO": "303701",
      "Radahkishanpura BO": "303701",
      "Chetawala BO": "303704",
      "Lalwas BO": "303109",
      "Manota BO": "303109",
      "Kanarpura BO": "303801",
      "Pratapura BO": "303801",
      "Kariri BO": "303803",
      "Singot Khurd BO": "303803",
      "Hathnoda BO": "303807",
      "Lalasar BO": "303603",
      "Badapadampura BO": "303903",
      "Chandlai BO": "303903",
      "Dadiya BO": "303905",
      "Jaje Kalan BO": "303103",
      "Saiwad BO": "303103",
      "Bidara BO": "303103",
      "Chhapra Khurd BO": "303103",
      "Bhuranpura B.O": "303002",
      "Markhi BO": "303601",
      "Dangaarwara BO": "303001",
      "Raipur BO": "303001",
      "Tholai BO": "303001",
      "Antela BO": "303119",
      "Bagawas Ahiran BO": "303119",
      "Sirsali BO": "303702",
      "Bobadi BO": "303120",
      "Dantala Meena BO": "303120",
      "Dhola BO": "303120",
      "Kanwarpura BO": "303120",
      "Surana BO": "303120",
      "Bhutera BO": "303712",
      "Dhodsar BO": "303712",
      "Hasteda BO": "303712",
      "Manda Bhinda BO": "303712",
      "Bhato Ki Gali BO": "303701",
      "Rambura Dabari BO": "303704",
      "Bandha Jamwaramgarh BO": "303109",
      "Booj BO": "303109",
      "Kharkara BO": "303109",
      "Samred Kalan BO": "303109",
      "Sandarsar BO": "303801",
      "Bilanderpur BO": "303803",
      "Govindpura Baseri BO": "303803",
      "Chaturbhuj BO": "303108",
      "Kalyanpura BO": "303108",
      "Kansli BO": "303108",
      "Keshwana BO": "303108",
      "Molaheda BO": "303108",
      "Naya Bas BO": "303806",
      "Nangal Bharda BO": "303807",
      "Badwa BO": "303305",
      "Dharampura BO": "303305",
      "Rajpura BO": "303305",
      "Chanwandia BO": "303301",
      "Deogaon BO": "303301",
      "Doodhali BO": "303301",
      "Hathoj B.O": "302012",
      "Khajalpura BO": "303903",
      "Kumariawas BO": "303903",
      "Goner BO": "303905",
      "Ghasipura BO": "303103",
      "Chhapra Kalan Shahpura BO": "303103",
      "Nithara BO": "303103",
      "Chimanpura BO": "303105",
      "Kali Pahadi BO": "303002",
      "Labana BO": "303002",
      "Hanutpura BO": "303601",
      "Birsana BO": "303001",
      "Dantil BO": "303107",
      "Sankotra BO": "303001",
      "Bagawas Choriyasi BO": "303119",
      "Luhakna Khurd BO": "303119",
      "Tankarda BO": "303702",
      "Niwana BO": "303804",
      "Tigaria BO": "303804",
      "Behlod BO": "303120",
      "Chharsa BO": "303120",
      "Jaichandpura BO": "303120",
      "Khora Bisal B.O": "302012",
      "Rojda B.O": "302012",
      "Akhepura B.O": "302013",
      "Nangal Purohitan B.O": "302013",
      "Lakhana B.O": "302029",
      "Mahapura B.O": "302026",
      "Neendar B.O": "302013",
      "Dhankya B.O": "302041",
      "Mundia Rampura B.O": "302041",
      "Khora Lad Khani BO": "303120",
      "Tala BO": "303120",
      "Dhoblai BO": "303712",
      "Malikpur BO": "303712",
      "Nangal Turkan BO": "303712",
      "Deogudha BO": "303701",
      "Jalsu BO": "303701",
      "Bhurthal BO": "303704",
      "Khore Shyamdas BO": "303704",
      "Khawa BO": "303109",
      "Mahangi BO": "303109",
      "Raithal BO": "303801",
      "Gonera BO": "303108",
      "Goverdhanpura BO": "303108",
      "Dhula BO": "303305",
      "Hansmahal BO": "303305",
      "Kacholiya BO": "303301",
      "Jhajwar BO": "303305",
      "Jhar BO": "303305",
      "Benada BO": "303301",
      "Lalgarh BO": "303301",
      "Kishanpura B.O": "302012",
      "Bilwa B.O": "302022",
      "Jatwara BO": "303305",
      "Newar BO": "303305",
      "Khatipura BO": "303301",
      "Neendar Banar B.O": "302012",
      "Neota B.O": "302029",
      "Mordha BO": "303108",
      "Pawana BO": "303108",
      "Sangteda BO": "303108",
      "Sunderpura BO": "303108",
      "Paldi BO": "303003",
      "Teori BO": "303003",
      "Bagwara BO": "303805",
      "Beri BO": "303105",
      "Kharab BO": "303105",
      "Fatehpura Khurd BO": "303106",
      "Dwarikapura BO": "303107",
      "Karoli BO": "303110",
      "Mandha BO": "303110",
      "Dev Ka Harwada BO": "303104",
      "Lakher BO": "303104",
      "Nawalpura BO": "303104",
      "Sirohi BO": "303104",
      "Bilochi BO": "303805",
      "Cheethwari BO": "303805",
      "Manpura Machedi BO": "303805",
      "Rundal BO": "303805",
      "Sewapura BO": "303805",
      "Deota BO": "303105",
      "Kalyanpura Kalan BO": "303105",
      "Raikaranpura BO": "303105",
      "SUKLAWAS": "303105",
      "Bhonawas BO": "303106",
      "Buchara BO": "303106",
      "Jodhpura BO": "303107",
      "Pathredi BO": "303107",
      "Bhalloji BO": "303110",
      "Bhankari BO": "303110",
      "Manoharpura BO": "303301",
      "Mansar Khedi BO": "303301",
      "Palawalan Jatan BO": "303301",
      "Faliawas BO": "303012",
      "Paniyala BO": "303108",
      "Bishangarh BO": "303104",
      "Chitanu Kalan BO": "303104",
      "Veelpur BO": "303104",
      "Bhamod BO": "303003",
      "Naurangpura BO": "303003",
      "Talba Bihajar BO": "303003",
      "Daulatpura BO": "303805",
      "Banethi BO": "303105",
      "Purshottampura BO": "303105",
      "Barnagar BO": "303106",
      "Panditpura BO": "303106",
      "Torda Kalan BO": "303106",
      "Bhainslana BO": "303107",
      "Panchudala BO": "303110",
      "Dholi BO": "303806",
      "Nangal Soosawatan B.O": "302028",
      "Natata B.O": "302028",
      "Toda Meena B.O": "302028",
      "Nangal Panditpura BO": "303108",
      "Ramsinghpura BO": "303108",
      "Chandwaji BO": "303104",
      "Jodhula BO": "303003",
      "Chonp BO": "303805",
      "Banar BO": "303105",
      "Chhardera BO": "303105",
      "Sarund BO": "303105",
      "Khelana BO": "303106",
      "Taskola BO": "303106",
      "Thikariya BO": "303106",
      "Bhuri Baraja BO": "303107",
      "Suderpura Dhadha BO": "303107",
      "Sujatnagar BO": "303107",
      "KAIRODI BO": "303110",
      "Bansa BO": "303806",
      "Toda Bhata BO": "303301",
      "Burthal BO": "303012",
      "Basna B.O": "302028",
      "Langariyawas B.O": "302027",
      "Rahori B.O": "302027",
      "Roopwas B.O": "302027",
      "Saipura B.O": "302027",
      "Saiwar B.O": "302027",
      "Luniawas B.O": "302031",
      "Sumel B.O": "302031",
      "Bilod B.O": "302028",
      "Jaisinghpura Bas B.O": "302026",
      "Bhanpur Kalan B.O": "302028",
      "Dhand B.O": "302028",
      "Indergarh B.O": "302027",
      "Kunthada Khurd BO": "303012",
      "Nayla BO": "303012",
      "Papad BO": "303012",
      "Dantli BO": "303012",
      "Jeetawal BO": "303012",
      "Airport Sanganer S.O": "302029",
      "Kishanpole Bazar S.O": "302002",
      "Krishi Upaj Mandi S.O": "302003",
      "M.I.Road S.O": "302001",
      "Janta Colony S.O": "302004",
      "Jhalana Doongri S.O": "302004",
      "Krishna Mandir S.O": "302004",
      "Rajasthan University S.O": "302004",
      "Tilak Nagar S.O (Jaipur)": "302004",
      "Ajmer Road S.O": "302006",
      "Amba Bari S.O": "302039",
      "Amer S.O": "302028",
      "Bani Park S.O": "302016",
      "Dwarikapuri S.O": "302016",
      "Harmada S.O": "302013",
      "Jaipur R.S. S.O": "302006",
      "Jaisinghpura Khore S.O": "302036",
      "Shyam Nagar S.O (Jaipur)": "302019",
      "Vaishali Nagar S.O": "302021",
      "Training Center Mansarowar SO": "302020",
      "Banskho SO": "303305",
      "Bassi SO Jaipur": "303301",
      "A C Jobner SO": "303329",
      "Chittora Renwal SO": "303904",
      "Dudu SO": "303008",
      "Kotkhawada SO": "303908",
      "Phulera Bazar SO": "303338",
      "Shivdaspura SO": "303903",
      "Watika SO": "303905",
      "Achrol SO": "303002",
      "Gathwadi SO": "303120",
      "Manoharpur SO Jaipur": "303104",
      "Samod SO": "303806",
      "Virat Nagar SO": "303102",
      "Govind Nagar S.O (Jaipur)": "302002",
      "Indra Bazar S.O": "302001",
      "Vidyut Bhawan S.O": "302005",
      "Durgapura S.O": "302018",
      "Gandhi Nagar S.O (Jaipur)": "302015",
      "Jamdoli S.O": "302031",
      "Mrec Jaipur S.O": "302017",
      "Tonk Road SO": "302015",
      "Collectorate S.O (Jaipur)": "302016",
      "Crpf Campus  Lalwas S.O": "302027",
      "Pratap Nagar Housing Board S.O": "302033",
      "Pratap Nagar Sector 11 S.O": "302033",
      "Raj Bhawan S.O (Jaipur)": "302006",
      "Sanganer Bazar S.O": "302029",
      "Sindhi Colony S.O": "302016",
      "Sitapura Industrial Area S.O": "302022",
      "Vishwakarma Industrial Area S.O": "302013",
      "Bindayaka S.O.": "302041",
      "Bad Ke Balaji S.O": "302042",
      "Sambhar Lake HO": "303604",
      "Badhal SO": "303602",
      "Jobner SO": "303328",
      "Kalwad SO": "303706",
      "Phulera SO": "303338",
      "Renwal SO": "303603",
      "Amarsar SO": "303601",
      "Jahota SO": "303701",
      "Kotputli SO": "303108",
      "Med SO": "303003",
      "Morija SO": "303805",
      "Nareda SO": "303105",
      "Shastri Nagar H.O": "302016",
      "Jaipur G.P.O.": "302001",
      "Jawahar Nagar H.O": "302004",
      "Chandpole Bazar S.O": "302001",
      "Haldiyon Ka Rasta S.O": "302003",
      "High Court S.O (Jaipur)": "302005",
      "Jaipur City S.O": "302003",
      "Purani Basti S.O (Jaipur)": "302001",
      "Rajasthan Secretariate S.O": "302005",
      "Jagatpura S.O": "302017",
      "Bhankrota S.O": "302026",
      "Jhotwara S.O": "302012",
      "Khatipura S.O": "302012",
      "Mahindra World City S.O (Jaipur)": "302037",
      "P.W.D.Office S.O": "302006",
      "Panchyawala S.O": "302034",
      "Road No 5 Vkia S.O": "302013",
      "Kookas S.O": "302038",
      "Sirsi SO": "302045",
      "Bhanpur kalan S.O": "302046",
      "Amer Road S.O": "302002",
      "C.P.M.G S.O": "302001",
      "Legislative Assembly S.O": "302005",
      "N.C.R.Building S.O": "302005",
      "Station Road S.O (Jaipur)": "302006",
      "Tripolia Bazar S.O": "302002",
      "Arjun Lal Sethi Nagar S.O": "302004",
      "Malviya Nagar S.O (Jaipur)": "302017",
      "Raja Park Colony S.O": "302004",
      "S.M.S.Hospital S.O": "302004",
      "Muhana S.O": "302043",
      "Mansarovar S.O": "302020",
      "Murlipura S.O": "302039",
      "S.F.S.Mansarovar S.O": "302020",
      "Vidhyadhar Nagar S.O": "302039",
      "Nangal Jaisabohara S.O": "302040",
      "Shahpura HO": "303103",
      "Bassi chak SO": "303301",
      "Bagru SO": "303007",
      "Madhorajpura SO": "303006",
      "Phagi SO": "303005",
      "Vedaant Gyan Valley SO": "303122",
      "Karansar SO": "303123",
      "HINGONIA S.O": "303124",
      "Chomu SO": "303702",
      "Jaitpura I A SO": "303704",
      "Jamwaramgarh SO": "303109",
      "NIMS University SO": "303121",
      "PaotaJaipur SO": "303106",
      "Pragpura SO": "303107",
      "Kanota SO": "303012",
      "Chaksu SO": "303901",
      "Mozmabad SO": "303009",
      "Naraina SO": "303348",
      "Andhi SO": "303001",
      "Bhabroo SO": "303119",
      "Etwa Bhopji SO": "303804",
      "Govindgarh SO Jaipur": "303712",
      "Kaladera SO": "303801",
      "Khejroli SO": "303803",
      "Rajnauta SO": "303110",
      "Udaipuria SO": "303807",
      "Govindpura S.O.": "302044"
    },
    "BIKANER": {
      "Pundalsar B.O": "331803",
      "Riri B.O": "331803",
      "Rajedoo B.O": "331803",
      "Tejrasar B.O": "334202",
      "Soniyasar B.O": "331803",
      "Thakariyasar B.O": "331803",
      "Toliyasar B.O": "331803",
      "Upni B.O": "331803",
      "Badhnu B.O": "334202",
      "Belasar B.O": "334202",
      "Kuchor Aguni B.O": "334202",
      "Kuchor Athuni B.O": "334202",
      "Moondsar B.O": "334202",
      "Gusainsar B.O": "331803",
      "Jalwali B.O": "334001",
      "Rajasar Bhatiyan B.O": "334001",
      "Lakhusar B.O": "334001",
      "Surdhana Chauhanan B.O": "334001",
      "Kelan B.O": "334001",
      "Kawani B.O": "334001",
      "Surjara B.O": "334001",
      "Bhaluri B.O": "334305",
      "Kharbara B.O": "334021",
      "Mahadevwali B.O": "334021",
      "Morkhana Athuna B.O": "334801",
      "Parwa B.O": "334801",
      "Bhanekagaon B.O": "334303",
      "Girajsar B.O": "334303",
      "Nal Bari B.O": "334001",
      "Shiv Bari B.O": "334001",
      "Sujandeser B.O": "334001",
      "Bholasar Budhan B.O": "334001",
      "Kolasar B.O": "334001",
      "Makrasar B.O": "334001",
      "Gadhwala B.O": "334001",
      "Bikampur B.O": "334305",
      "Raner B.O": "334021",
      "Takhatpura B.O": "334021",
      "Sansardesar B.O": "334021",
      "Akasar B.O": "334001",
      "Kanasar B.O": "334001",
      "Kalasar B.O": "334001",
      "Godoo B.O": "334305",
      "Gogariyawala B.O": "334305",
      "Mankasar B.O": "334305",
      "Mithriya B.O": "334305",
      "Phulasar Khurd B.O": "334305",
      "Ranjeetpura B.O": "334305",
      "Dandi B.O": "334021",
      "Loonkhan B.O": "334021",
      "Bhamatsar B.O": "334801",
      "Sinjguru B.O": "334801",
      "Surpura B.O": "334801",
      "Nagrasar B.O": "334303",
      "Nokhara B.O": "334303",
      "Gajner Palace B.O": "334001",
      "Jaimalsar B.O": "334001",
      "Karmisar B.O": "334001",
      "Bachasar B.O": "334001",
      "Amarpura B.O": "334001",
      "Norangdesar B.O": "334001",
      "Khari Charnan B.O": "334001",
      "Bagadsar B.O": "334305",
      "Barsalpur B.O": "334305",
      "Bijeri B.O": "334305",
      "Motigarh B.O": "334021",
      "Satasar B.O": "334021",
      "Ghatoo B.O": "334801",
      "Rasisar B.O": "334801",
      "Gariyala B.O": "334303",
      "Grandhi B.O": "334303",
      "Hadan B.O": "334302",
      "Jhajhoo B.O": "334302",
      "Khindasar B.O": "334302",
      "Dusarna B.O": "331811",
      "Jodhasar B.O": "331811",
      "Likhmisar B.O": "331811",
      "Sanwatsar B.O": "331811",
      "Gersar B.O": "334022",
      "Runiya Bara Bas B.O": "334022",
      "Ankhisar B.O": "334802",
      "Berasar B.O": "334802",
      "Dhoopaliya B.O": "334802",
      "Jasrasar B.O": "334802",
      "Bamanwali B.O": "334601",
      "Dheerera R.S. B.O": "334601",
      "Dheerera Village B.O": "334601",
      "Garabdesar B.O": "334602",
      "Kharda B.O": "334602",
      "Chak 8 Kyd B.O": "334023",
      "Karamwala B.O": "334023",
      "Gajroopdesar B.O": "334201",
      "Kesardesarjatan B.O": "334201",
      "Ramsar B.O": "334201",
      "Bandhra B.O": "334803",
      "Beekasar B.O": "334803",
      "Bhalda B.O": "334803",
      "Charkra B.O": "334803",
      "Kisnasar B.O": "334804",
      "Koo Dsoo B.O": "334804",
      "Nathusar B.O": "334804",
      "Dhaneru B.O": "331803",
      "Dheerdesar Chotiyan B.O": "331803",
      "Indpalsar B.O": "331803",
      "Jaisalsar B.O": "331803",
      "Sadhasar B.O": "334802",
      "Seeniwala B.O": "334802",
      "Thawariya B.O": "334802",
      "Udsar B.O": "334802",
      "Utmamdesar B.O": "334802",
      "17 K.Y.D. B.O": "334023",
      "2 K.L.D. B.O": "334023",
      "Bhikhnera B.O": "334603",
      "Dulmera B.O": "334603",
      "Hansera B.O": "334603",
      "Kapoorisar B.O": "334603",
      "Khinyera B.O": "334603",
      "Khokhrana B.O": "334603",
      "Rajasar Karnisar B.O": "334603",
      "Arjansar B.O": "334604",
      "Jaitpur B.O": "334604",
      "Malkisar B.O": "334604",
      "Mithdiya B.O": "334604",
      "Rambag B.O": "334604",
      "Sherpura B.O": "334604",
      "Aadsar B.O": "331801",
      "Jalabsar B.O": "331801",
      "Surjansar B.O": "331801",
      "Udrasar B.O": "331801",
      "Hiyadesar B.O": "334803",
      "Nokha Villege B.O": "334803",
      "Raisar B.O": "334803",
      "Rora B.O": "334803",
      "Bandhala B.O": "334804",
      "Badela B.O": "331803",
      "Bana B.O": "331803",
      "Bapeu B.O": "331803",
      "Barjangsar B.O": "331803",
      "Keu B.O": "331803",
      "Kunpalsar B.O": "331803",
      "Kuntasar B.O": "331803",
      "Likhmadesar B.O": "331803",
      "Gura B.O": "334302",
      "Manakarasar B.O": "331811",
      "Punrasar B.O": "331811",
      "Samandsar B.O": "331811",
      "Serera B.O": "334022",
      "Dasori B.O": "334302",
      "Kotri B.O": "334302",
      "Derajsar B.O": "331811",
      "Barsingsar B.O": "334402",
      "Lalmdesar B.O": "334402",
      "Saroopdesar B.O": "334402",
      "Gondusar B.O": "334802",
      "Jesalsar B.O": "334802",
      "Kakra B.O": "334802",
      "Lalamdesar Bara B.O": "334802",
      "Mansoori B.O": "334802",
      "Malasar B.O": "334601",
      "Kujti B.O": "334602",
      "Rawansar B.O": "334602",
      "61 Head B.O": "334023",
      "Dantaur B.O": "334023",
      "Karnisar Bhatiyan B.O": "334808",
      "Siyasar Panchkosa B.O": "334808",
      "Rojan B.O": "334603",
      "Sui B.O": "334603",
      "Sowa B.O": "334201",
      "Chitana B.O": "334803",
      "Desalsar B.O": "334803",
      "Jaisingdesar B.O": "334803",
      "Kakoo B.O": "334803",
      "Saloondiya B.O": "334803",
      "Siyana Bhatiyana B.O": "334803",
      "Somalsar B.O": "334803",
      "Dhingsari B.O": "334804",
      "Kumbhasariya B.O": "334804",
      "Saisar B.O": "334804",
      "Bigga B.O": "331803",
      "Delwan B.O": "331803",
      "Jakhasar B.O": "331803",
      "Kalyansar B.O": "331803",
      "Migsariya B.O": "331803",
      "Hadlan Bhatiyan B.O": "334302",
      "Madh B.O": "334302",
      "Bainisar B.O": "331811",
      "Dulchasar B.O": "331811",
      "Jhanjheu B.O": "331811",
      "Lakhasar B.O": "331811",
      "Sheruna B.O": "331811",
      "Ambasar B.O": "334402",
      "Palana B.O": "334402",
      "Bambloo B.O": "334022",
      "Ridmalsar B.O": "334022",
      "Bithnok B.O": "334302",
      "Gajsukhdesar B.O": "334802",
      "Jhadeli B.O": "334802",
      "Mainsar B.O": "334802",
      "Moondar B.O": "334802",
      "Khara B.O": "334601",
      "Sodhwali B.O": "334601",
      "Sahjrasar B.O": "334602",
      "Delitalai B.O": "334808",
      "Siyasarchogan B.O": "334023",
      "Kankarwala B.O": "334603",
      "Nathwana B.O": "334603",
      "Shekhsar B.O": "334603",
      "Surnana B.O": "334603",
      "Baladesar B.O": "334604",
      "Dawa B.O": "334803",
      "Hansasar B.O": "334803",
      "Jangloo B.O": "334803",
      "Sadhoona B.O": "334803",
      "Sarunda B.O": "334803",
      "Dharnok B.O": "334804",
      "Udasar B.O": "334804",
      "Beejhansar B.O": "331803",
      "Biggabas Ramsara B.O": "331803",
      "Jetasar B.O": "331803",
      "Keetasar B.O": "331803",
      "Chani B.O": "334302",
      "Bheloo B.O": "334302",
      "Bikaner H.O": "334001",
      "Bajju S.O": "334305",
      "Bangalanagar S.O": "334004",
      "Bhinasar S.O": "334403",
      "Bikaner Kutchery S.O": "334001",
      "Chhatararh S.O": "334021",
      "Gangashahar S.O": "334401",
      "Jamsar S.O": "334601",
      "Jassusar Gate S.O": "334001",
      "Kalu S.O": "334602",
      "Lalgarh Road S.O": "334001",
      "Mahajan S.O": "334604",
      "Shri Dungargarh S.O": "331803",
      "Sitla Gate S.O": "334001",
      "Sudsar S.O": "331811",
      "D.S.Office S.O": "334001",
      "Deshnoke S.O": "334801",
      "Diyatra S.O": "334303",
      "Dungar College S.O": "334001",
      "Himatsar S.O": "334802",
      "M.G.Road S.O": "334001",
      "Kalubas S.O": "331803",
      "Kotegate S.O": "334001",
      "Lalkar S.O": "334001",
      "Mohta Chowk S.O": "334001",
      "Pabubari S.O": "334001",
      "Panchoo S.O": "334804",
      "Pawanpuri S.O (Bikaner)": "334003",
      "Pugal S.O": "334808",
      "Raj.Krishi Vishwavidhyalaya S.O": "334006",
      "Sinthal S.O": "334202",
      "Udasar S.O": "334022",
      "Napasar S.O": "334201",
      "Railway Workshop S.O": "334004",
      "Rcp Colony S.O": "334004",
      "Sadul Colony S.O": "334001",
      "Sri Kolayat Ji S.O": "334302",
      "Bichhwal Ind.Area S.O": "334006",
      "Bikaner City S.O": "334001",
      "Khajuwala S.O": "334023",
      "Lunkaransar S.O": "334603",
      "Momasar S.O": "331801",
      "Nokha S.O": "334803",
      "Rani Bazar S.O (Rajasthan Circle)": "334001",
      "Udairamsar S.O": "334402"
    },
    "JHALAWAR": {
      "Suwas B.O": "326036",
      "Chanpa Khurd B.O": "326035",
      "Karanwas B.O": "326035",
      "Khod B.O": "326501",
      "Piplia B.O": "326501",
      "Samrai B.O": "326501",
      "Chachhlao B.O": "326513",
      "Karodia B.O": "326513",
      "Sangria B.O": "326513",
      "Soyala B.O": "326036",
      "Taraj B.O": "326035",
      "Gundi B.O": "326501",
      "Jawahar Nagar B.O": "326501",
      "Kanwara B.O": "326501",
      "Bolia Bujurg B.O": "326513",
      "Dabla Kheenchi B.O": "326513",
      "Dola B.O": "326513",
      "Unhel B.O": "326513",
      "Dhanoda B.O": "326035",
      "Malanwas B.O": "326035",
      "Bhilwari B.O": "326501",
      "Rajpura B.O": "326501",
      "Dubalia B.O": "326513",
      "Hemda B.O": "326513",
      "Salotia B.O": "326513",
      "Semlia B.O": "326513",
      "Akawad Khurd B.O": "326035",
      "Bareda B.O": "326035",
      "Gadia B.O": "326513",
      "Mangispur B.O": "326513",
      "Osav B.O": "326513",
      "Sirpoi B.O": "326513",
      "Ditya Khedi B.O": "326036",
      "Fateh Garh B.O": "326036",
      "Jhumki B.O": "326036",
      "Salri B.O": "326036",
      "Semli Khan B.O": "326036",
      "Dewal Kheda B.O": "326036",
      "Himmat Garh B.O": "326036",
      "Kali Talai B.O": "326036",
      "Mathania B.O": "326036",
      "Piplod B.O": "326036",
      "Kutki B.O": "326036",
      "Salawad B.O": "326023",
      "Titarwasa  B.O": "326023",
      "Jarga B.O": "326038",
      "Panwar B.O": "326038",
      "Piplaj B.O": "326038",
      "Sojpur B.O": "326038",
      "Sumar B.O": "326038",
      "Banskhedi B.O": "326037",
      "Akodiya B.O": "326038",
      "Golana B.O": "326038",
      "Jolpa B.O": "326038",
      "Pakhrana B.O": "326038",
      "Anwalheda B.O": "326037",
      "Dangipura B.O": "326037",
      "Garbolia B.O": "326037",
      "Kolukheri Kalan B.O": "326037",
      "Maharajpura B.O": "326037",
      "Semlihat B.O": "326037",
      "Todri Jagannath B.O": "326037",
      "Awar B.O": "326512",
      "Gurah B.O": "326512",
      "Sarod B.O": "326512",
      "Dabla Bhoj B.O": "326034",
      "Dharonia B.O": "326034",
      "Govindpura B.O": "326023",
      "Khairana B.O": "326034",
      "Saroniya B.O": "326034",
      "Chandipur B.O": "326037",
      "Manpasar B.O": "326037",
      "Pindola B.O": "326037",
      "Ranwasia B.O": "326037",
      "Sorti B.O": "326037",
      "Thiakria B.O": "326037",
      "Todrimeeran B.O": "326037",
      "Maralwada B.O": "326512",
      "Mishroli B.O": "326033",
      "Harnawda Gaja B.O": "326034",
      "Bhagwanpura B.O": "326038",
      "Dobra B.O": "326514",
      "Gadarwada Noorji B.O": "326038",
      "Khandi B.O": "326038",
      "Leemi B.O": "326038",
      "Baneth B.O": "326037",
      "Banskheda B.O": "326037",
      "Khatkakhedi B.O": "326037",
      "Bisthunia B.O": "326512",
      "Devgarh B.O": "326514",
      "Guradia Joga B.O": "326512",
      "Guradia Kalan B.O": "326512",
      "Naharghatta B.O": "326512",
      "Kotri B.O": "326034",
      "Odiya Khedi B.O": "326034",
      "Ramai Dalpat B.O": "326034",
      "Dahikheda B.O": "326038",
      "Kanwarpura B.O": "326038",
      "Maraitha B.O": "326038",
      "Chandpura Bheelan B.O": "326037",
      "Jawar B.O": "326037",
      "Kherkheda B.O": "326037",
      "Kolukheri Maliyan B.O": "326037",
      "Samrol B.O": "326037",
      "Bani B.O": "326512",
      "Guradia Khurd B.O": "326512",
      "Karawan B.O": "326512",
      "Pagaria B.O": "326512",
      "Silahgarh B.O": "326512",
      "Singhpur B.O": "326512",
      "Danta B.O": "326034",
      "Kharpakalan B.O": "326034",
      "Naulai B.O": "326034",
      "Rampuria B.O": "326034",
      "Banore B.O": "326036",
      "Mandawar B.O": "326001",
      "Harigarh B.O": "326001",
      "Baira Garh B.O": "326033",
      "Churalia B.O": "326033",
      "Deori Kalan B.O": "326033",
      "Gehu Khedi B.O": "326033",
      "Lawasal B.O": "326021",
      "Panwasa B.O": "326021",
      "Kushalpura B.O": "326022",
      "Modi B.O": "326022",
      "Nanore B.O": "326022",
      "Ganeshpura B.O": "326502",
      "Ghatod B.O": "326502",
      "Guradia Mana B.O": "326502",
      "Kundi Kheda B.O": "326502",
      "Bardia Veer Ji B.O": "326515",
      "Dhaturia B.O": "326514",
      "Dodi B.O": "326514",
      "Sunari B.O": "326516",
      "Asalpur B.O": "326039",
      "Bahalta B.O": "326039",
      "Banskhedi Lodhan B.O": "326039",
      "Binda Kheda B.O": "326039",
      "Kalmandi Kalan B.O": "326023",
      "Khanpuria B.O": "326023",
      "Duragpura B.O": "326001",
      "Gagron B.O": "326001",
      "Gordhanpura B.O": "326001",
      "Saredi B.O": "326033",
      "Thanawad B.O": "326033",
      "Thedol B.O": "326033",
      "Turkadia B.O": "326033",
      "Iktasa B.O": "326021",
      "Agaria B.O": "326022",
      "Karal Gaon B.O": "326022",
      "Kundla B.O": "326515",
      "Magsi B.O": "326515",
      "Parapeeli B.O": "326515",
      "Parlia B.O": "326515",
      "Ranaira B.O": "326515",
      "Rawangurari B.O": "326515",
      "Nandpur B.O": "326514",
      "Tisai B.O": "326514",
      "Guradia Jhala B.O": "326516",
      "Kachnara B.O": "326516",
      "Kohri Jhar B.O": "326039",
      "Sarda B.O": "326039",
      "Badbad B.O": "326023",
      "Bhanwarsa B.O": "326023",
      "Parlia Kulmi B.O": "326023",
      "Ratlai B.O": "326023",
      "Richhawan B.O": "326023",
      "Borda Mau B.O": "326001",
      "Bhimsagar Dam B.O": "326001",
      "Laiphal B.O": "326001",
      "Ametha B.O": "326033",
      "Lasudia Shaha B.O": "326033",
      "Dungargaon B.O": "326021",
      "Junakheda B.O": "326021",
      "Baday B.O": "326022",
      "Dev Nagar B.O": "326022",
      "Gurukul B.O": "326022",
      "Anwali Kalan B.O": "326502",
      "Mogra B.O": "326502",
      "Sulia B.O": "326502",
      "Chara B.O": "326515",
      "Kumthia B.O": "326515",
      "Unhel Nagdev B.O": "326515",
      "Jagdishpura B.O": "326514",
      "Kayasara B.O": "326514",
      "Luharia B.O": "326514",
      "Piplia Khurd B.O": "326514",
      "Kelu Kheri B.O": "326516",
      "Rampura B.O": "326516",
      "Borband B.O": "326039",
      "Gopalpura B.O": "326039",
      "Pachola  B.O": "326039",
      "Umaria B.O": "326039",
      "Dunda B.O": "326023",
      "Guradkheda B.O": "326023",
      "Rijhone B.O": "326023",
      "Mundla B.O": "326001",
      "Bagher B.O": "326001",
      "Badwad B.O": "326033",
      "Kam Khera B.O": "326033",
      "Lhas B.O": "326033",
      "Maithun B.O": "326033",
      "Barodia B.O": "326021",
      "Ruparel B.O": "326021",
      "Garwada B.O": "326022",
      "Thobariya Khurd B.O": "326022",
      "Narayan Kheda B.O": "326502",
      "Berla B.O": "326515",
      "Keetia B.O": "326515",
      "Talawali B.O": "326515",
      "Dudhalia B.O": "326514",
      "Harnawda B.O": "326514",
      "Jamuniya B.O": "326514",
      "Mandirpur B.O": "326514",
      "Rojhana B.O": "326516",
      "Sarwad B.O": "326516",
      "Borkhedi Gujran B.O": "326039",
      "Gulkhedi": "326039",
      "Sarkhandia B.O": "326039",
      "Deori B.O": "326023",
      "Nasirabad B.O": "326023",
      "Rundlao B.O": "326023",
      "Jhalawar H.O": "326001",
      "Mohangarh SO Jaisalmer": "345033",
      "Chaumahla S.O": "326515",
      "Jhalara Patan City S.O": "326023",
      "Raipur S.O (Jhalawar)": "326036",
      "Asnawar S.O": "326021",
      "Collectorate Jhalawar S.O": "326001",
      "Gangdhar S.O": "326516",
      "Khanpur S.O": "326038",
      "Manohar Thana S.O": "326037",
      "Pach Pahar S.O": "326512",
      "Pirawa S.O": "326034",
      "Shrichhattarpur S.O": "326501",
      "Bakani S.O": "326022",
      "Bhawanimandi S.O": "326502",
      "Dag S.O": "326514",
      "Ghatoli S.O": "326039",
      "Sunel S.O": "326513",
      "Aklera S.O": "326033",
      "Sarola S.O": "326035"
    },
    "ALWAR": {
      "Madhogarh B.O": "301001",
      "Akbarpur B.O": "301001",
      "Bamboli B.O": "301001",
      "Mahuakhurd B.O": "301001",
      "Burja B.O": "301001",
      "Ghat B.O": "301001",
      "Bhajera B.O": "301409",
      "Chikani B.O": "301028",
      "Chorotipahar B.O": "301028",
      "Deenar B.O": "301021",
      "Gandura B.O": "301021",
      "Molia B.O": "301021",
      "Bhandodi B.O": "301414",
      "Bhikhaheri B.O": "301413",
      "Bahtookalan B.O": "321605",
      "Baseth B.O": "321605",
      "Masari B.O": "321605",
      "Methna B.O": "321605",
      "Reta B.O": "321605",
      "Natoj B.O": "321606",
      "Samuchi B.O": "321606",
      "Sonkher B.O": "321606",
      "Kalgaon B.O": "301702",
      "Khanpur Mewan B.O": "301405",
      "Langerwas B.O": "301405",
      "Gahankar B.O": "301405",
      "Machari B.O": "301408",
      "Raisis B.O": "301001",
      "Nangli Megha B.O": "301001",
      "Umren B.O": "301001",
      "Diwakari B.O": "301001",
      "Kakrali Meo B.O": "301028",
      "Kherajahar B.O": "301028",
      "Itera B.O": "301021",
      "Nizamnagar B.O": "301021",
      "Beleta B.O": "301414",
      "Chandupura B.O": "301414",
      "Poonkher B.O": "301414",
      "Barkokhurd B.O": "301413",
      "Gothra B.O": "301405",
      "Khera Mahmood B.O": "301604",
      "Rambas B.O": "301604",
      "Isrota B.O": "321605",
      "Bagarrajput B.O": "301001",
      "Toolera B.O": "301001",
      "Raibka B.O": "301028",
      "Shahdoli B.O": "301028",
      "Untwal B.O": "301028",
      "Buntoli B.O": "301021",
      "Sadhka B.O": "301021",
      "Nawalpura B.O": "301414",
      "Palwa B.O": "301706",
      "Jhalatala B.O": "301413",
      "Kheramangal Singh B.O": "301413",
      "Pinan B.O": "301413",
      "Sedampur B.O": "301604",
      "Semla Khurd B.O": "301604",
      "Arwa B.O": "321605",
      "Sonkh B.O": "321605",
      "Kalwari B.O": "321606",
      "Sonkheri B.O": "321606",
      "Baghora B.O": "301411",
      "Bambora B.O": "301405",
      "Baskripal Nagar B.O": "301405",
      "Bhindoosi B.O": "301405",
      "Moosakhera B.O": "301405",
      "Mothuka B.O": "301405",
      "Veersingh Pur B.O": "301405",
      "Khuteta Kalan B.O": "301001",
      "Bhoggore B.O": "301001",
      "Siliserh B.O": "301001",
      "Karoli B.O": "301028",
      "Kithoor B.O": "301028",
      "Beda B.O": "301021",
      "Butiyana B.O": "301021",
      "Nibhera B.O": "301021",
      "Shahdod B.O": "301019",
      "Bahali B.O": "301414",
      "Patan B.O": "301414",
      "Kanethi B.O": "301413",
      "Sehra B.O": "301413",
      "Todanagar B.O": "301413",
      "Dongri B.O": "301604",
      "Phari B.O": "301604",
      "Kherameda B.O": "321605",
      "Sudiana B.O": "321605",
      "Tasai B.O": "321605",
      "Titpuri B.O": "321605",
      "Silarpur B.O": "301018",
      "Daroda B.O": "321606",
      "Doroli B.O": "301408",
      "Mahond B.O": "301405",
      "Mancha B.O": "301405",
      "Tarwala B.O": "301405",
      "Thons B.O": "301405",
      "Bhagana B.O": "301702",
      "Mathuraheda B.O": "321605",
      "Tikri B.O": "321605",
      "Sheetal B.O": "301018",
      "Dantia B.O": "321606",
      "Garu B.O": "321606",
      "Ghasoli B.O": "301405",
      "Mandha B.O": "301405",
      "Tehnoli B.O": "301405",
      "Beelaheri B.O": "301702",
      "Hingwahera B.O": "301411",
      "Mundana B.O": "301411",
      "Palpur B.O": "301702",
      "Phullawas B.O": "301411",
      "Shahpur B.O": "301023",
      "Chandoli B.O": "301023",
      "Manchal B.O": "301701",
      "Bhanot B.O": "301401",
      "Gaduwas B.O": "301401",
      "Manka B.O": "301401",
      "ALAMDIKA B.O": "301405",
      "MACHHROLI B.O": "301405",
      "Girudi B.O": "301402",
      "Dera Bamanwas B.O": "301022",
      "Dwarapur B.O": "301022",
      "Garh Basai B.O": "301022",
      "Saleta B.O": "301022",
      "Bandra B.O": "301411",
      "Bichhala B.O": "301411",
      "Bhangroli B.O": "301022",
      "Gudhachurani B.O": "301022",
      "Malutana B.O": "301022",
      "Sariska Palace B.O": "301022",
      "Bilaspur B.O": "301411",
      "Gotoli B.O": "301411",
      "Isroda B.O": "301411",
      "Rabhana B.O": "301411",
      "Titarka B.O": "301411",
      "Parisal B.O": "301023",
      "gadoj B.O": "301701",
      "Sherpur B.O": "301701",
      "Jainpurwas B.O": "301701",
      "Pahari B.O": "301701",
      "A.G.Dadhiya B.O": "301401",
      "Jonal B.O": "301401",
      "Seelgaon B.O": "301401",
      "Jalawas B.O": "301714",
      "Khareda B.O": "301406",
      "Kolahera B.O": "301024",
      "Mundawar B.O": "301024",
      "Nayabas B.O": "301024",
      "Beejwa B.O": "301025",
      "Cheerwa B.O": "301025",
      "Ramji ka Guwada B.O": "301027",
      "Binjari B.O": "301408",
      "Dhamred B.O": "301408",
      "Dubbi B.O": "301408",
      "Bighota B.O": "301415",
      "Balata B.O": "301406",
      "Dhakpuri B.O": "301406",
      "Jamalpur B.O": "301406",
      "Kalsara B.O": "301406",
      "Desula B.O": "301030",
      "Jatpur B.O": "301030",
      "Khanpur Jat B.O": "301030",
      "Kherli Syed B.O": "301030",
      "Berla B.O": "321633",
      "Chhilori B.O": "321633",
      "Chimrauli Gaur B.O": "321633",
      "Devli B.O": "321633",
      "Khoramalawali B.O": "321633",
      "Ajabpura B.O": "301024",
      "Garhi B.O": "301024",
      "Devti B.O": "301415",
      "Neemla B.O": "301415",
      "Koondla B.O": "301415",
      "Indpura B.O": "301026",
      "khilora B.O": "301026",
      "Kkoh B.O": "301026",
      "Milakpur B.O": "301026",
      "Intoli B.O": "301409",
      "Jamdoli B.O": "301409",
      "Karanpura B.O": "301409",
      "Keelpurkhera B.O": "301409",
      "Mundia B.O": "301409",
      "Pragpura B.O": "301409",
      "Khoh B.O": "301410",
      "Khonkhar B.O": "301035",
      "Sahari B.O": "301035",
      "Tilwar B.O": "301410",
      "Beejwar B.O": "301406",
      "Kerwawal B.O": "301406",
      "Leeli B.O": "321607",
      "Pala B.O": "301406",
      "Bahala B.O": "301030",
      "Basaijogian B.O": "301024",
      "Neemuchana B.O": "301024",
      "CHANDPURI B.O": "301024",
      "Neekuch B.O": "301025",
      "Rasgaon B.O": "301025",
      "Lalpura B.O": "301027",
      "Nangalbani B.O": "301027",
      "Barer B.O": "301408",
      "Karoth B.O": "301408",
      "Moonpur B.O": "301408",
      "Pada B.O": "301408",
      "Vabeli B.O": "301408",
      "Nathalwara B.O": "301415",
      "Chomu B.O": "301026",
      "KHERI B.O": "301026",
      "Malpur B.O": "301026",
      "Naswari B.O": "301026",
      "Sirmor B.O": "301026",
      "Bhuda B.O": "301409",
      "Dera B.O": "301409",
      "Parbeni B.O": "301409",
      "Bhanwar B.O": "301035",
      "Kheda Kalyanpur B.O": "301035",
      "New Jahadu B.O": "301035",
      "Maseet B.O": "301707",
      "Milakpur Turk B.O": "301707",
      "Talab B.O": "301410",
      "Bhandrol B.O": "301022",
      "Duhar Chogan B.O": "301022",
      "Kishori B.O": "301022",
      "Seelibaori B.O": "301022",
      "Suratgarh B.O": "301022",
      "Birampur B.O": "301411",
      "Hameerka B.O": "301411",
      "Jeroli B.O": "301411",
      "Sarheta B.O": "301411",
      "Shahbad B.O": "301411",
      "Jatiyana B.O": "301403",
      "Rata Khurd B.O": "301023",
      "Nangal Khoria B.O": "301701",
      "Tasing B.O": "301701",
      "Khatankhera B.O": "301701",
      "Hamidpur B.O": "301701",
      "Mohammedpur B.O": "301701",
      "Beejwar Chauhan B.O": "301401",
      "Saraikalan B.O": "301401",
      "Sihalikalan B.O": "301401",
      "Nangal Salia B.O": "301403",
      "Sanoli B.O": "301714",
      "Ikrotia B.O": "301702",
      "Jodia B.O": "301702",
      "Khanpur B.O": "301702",
      "Pur B.O": "301702",
      "Ujoli B.O": "301702",
      "Bichgaon B.O": "321607",
      "Hasanpur B.O": "321607",
      "Jadla B.O": "321607",
      "Khudiana B.O": "321607",
      "Santhalpur B.O": "301402",
      "Shyampura B.O": "301402",
      "Kolila B.O": "301020",
      "Basai B.O": "301709",
      "Alanpur B.O": "301412",
      "Bhungra Ahir B.O": "301427",
      "Hatoondi B.O": "301427",
      "Mundanwara Kalan B.O": "301427",
      "Basai Kalan B.O": "301404",
      "Vallabhgram B.O": "301404",
      "Gyanpura B.O": "301024",
      "KARANA B.O": "301024",
      "kherkheri Kalan B.O": "301024",
      "Dhanwari B.O": "301025",
      "Agar B.O": "301027",
      "Ajabgarh B.O": "301027",
      "Piplai B.O": "301027",
      "Samra B.O": "301027",
      "Srichandpura B.O": "301408",
      "Surer B.O": "301408",
      "Saloli B.O": "301409",
      "Adoli B.O": "301035",
      "Budhi Bawal B.O": "301707",
      "Chauharpur B.O": "301707",
      "Gwalda B.O": "301707",
      "Jhiwana B.O": "301707",
      "Joria B.O": "301707",
      "Baldeogarh B.O": "301410",
      "Ghewar B.O": "301410",
      "Golakabas B.O": "301410",
      "Sorai B.O": "321607",
      "Toda B.O": "321607",
      "Lekri B.O": "301402",
      "Ratanpura B.O": "301402",
      "Khohar B.O": "301709",
      "Peepli B.O": "301427",
      "Patalia B.O": "301403",
      "Bagheri kala BO": "301403",
      "Guwana B.O": "301713",
      "Khohrana B.O": "301713",
      "Khohri B.O": "301713",
      "Maharajawas B.O": "301713",
      "Ghatla B.O": "301404",
      "Noor Nagar B.O": "301404",
      "Pahel B.O": "301404",
      "Patan Mewan B.O": "301404",
      "Ranoth B.O": "301404",
      "Rasgan B.O": "301404",
      "Sorkha Kalan B.O": "301404",
      "Tatarpur B.O": "301404",
      "Kayasa B.O": "301703",
      "Majrikanhawas B.O": "301703",
      "Talwana B.O": "301703",
      "Gopipura B.O": "301407",
      "Sheopur B.O": "301407",
      "Nanagwas B.O": "301704",
      "Gugalkota B.O": "301706",
      "Jonicha Khurd B.O": "301706",
      "Jonichakalan B.O": "301706",
      "Nagli B.O": "301708",
      "Raisarana B.O": "301708",
      "Siryani B.O": "301708",
      "Rodwal B.O": "301705",
      "Gunti B.O": "301701",
      "Jaguwas B.O": "301701",
      "Kankardopa B.O": "301701",
      "Rewali B.O": "301701",
      "Basni B.O": "301401",
      "Bhupsera B.O": "301402",
      "Buteri B.O": "301402",
      "Choola B.O": "301402",
      "Fetehpur B.O": "301402",
      "Barkhera B.O": "301406",
      "Haldeena B.O": "301406",
      "Nithari B.O": "301406",
      "Prithvipura B.O": "301406",
      "Bhageet B.O": "301030",
      "Salpur B.O": "301030",
      "Bedar B.O": "321633",
      "Bharkol B.O": "321633",
      "Bamanwas Kankar B.O": "301024",
      "Bilali B.O": "301024",
      "Chatarpura B.O": "301024",
      "Vijayapura B.O": "301024",
      "Mubarikpur B.O": "301025",
      "Pata B.O": "301025",
      "Raghunathgarh B.O": "301025",
      "Jhiri B.O": "301027",
      "Padakchapli B.O": "301027",
      "Ballupura B.O": "301408",
      "Thana B.O": "301408",
      "Sakat B.O": "301415",
      "Motiwara B.O": "301415",
      "Alaora B.O": "301026",
      "Peproli B.O": "301026",
      "Khutabpura B.O": "301702",
      "Matalwas B.O": "301702",
      "Barodakan B.O": "321607",
      "Harsana B.O": "321607",
      "Jaoli B.O": "321607",
      "Ramnagar B.O": "321607",
      "Karoda B.O": "301020",
      "Mirjapur B.O": "301403",
      "Babari B.O": "301412",
      "Bamanwas B.O": "301412",
      "Anantpura B.O": "301713",
      "Jasai B.O": "301427",
      "Sodawas B.O": "301427",
      "Bahroj B.O": "301404",
      "Jindoli B.O": "301404",
      "Santo B.O": "301708",
      "Doomroli B.O": "301703",
      "Kanhawas B.O": "301703",
      "Balluwas B.O": "301407",
      "Giglana B.O": "301704",
      "Kathoowas B.O": "301704",
      "Khoondrot B.O": "301704",
      "Naghori B.O": "301705",
      "Chaubara B.O": "301706",
      "Pholadpur B.O": "301706",
      "Sainthli B.O": "301026",
      "Bulari B.O": "301409",
      "Tehtra B.O": "301409",
      "Bhanokhar B.O": "301035",
      "Jatwara B.O": "301035",
      "Salwari B.O": "301035",
      "Bhonker B.O": "301707",
      "Mehesra B.O": "301707",
      "Dariba Project B.O": "301410",
      "Gordhanpura B.O": "301410",
      "Syaluta B.O": "301410",
      "Khera B.O": "301402",
      "Gunta B.O": "301402",
      "Hazipur B.O": "301402",
      "Lakkakanagal B.O": "301402",
      "Ladpur B.O": "301702",
      "Nangalkhanjadi B.O": "321607",
      "Noorpurganjpur B.O": "321607",
      "Mahanpur B.O": "301402",
      "Dooghera B.O": "301020",
      "Budhwal B.O": "301709",
      "Khanpur Ahir B.O": "301403",
      "Babaria B.O": "301412",
      "Bhagukawas B.O": "301412",
      "Shamda B.O": "301412",
      "Padmara Khurd B.O": "301427",
      "Rajwara B.O": "301427",
      "Ismailpur B.O": "301404",
      "Mator B.O": "301404",
      "Aklimpur B.O": "301703",
      "Dosod B.O": "301703",
      "Basmenpur B.O": "301407",
      "Chandpur B.O": "301407",
      "Dabarwas B.O": "301704",
      "Huria Kalan B.O": "301704",
      "Mehtawas B.O": "301704",
      "Partapur B.O": "301704",
      "Gheelot B.O": "301705",
      "Pratapsinghpura B.O": "301705",
      "Sakatpura (Bawad) B.O": "301706",
      "Holawas B.O": "301402",
      "Khori B.O": "301402",
      "Hamirpur B.O": "301402",
      "Bahror H.O": "301701",
      "Alwar H.O": "301001",
      "Kotkassim S.O": "301702",
      "Matasya Ind. Area S.O": "301030",
      "Mauj Pur S.O": "321633",
      "Sectt. Alwar S.O": "301001",
      "Tapukara S.O": "301707",
      "Thanagazi S.O": "301022",
      "Tizara S.O": "301411",
      "Bansur S.O": "301402",
      "Barrod S.O": "301020",
      "Harsora S.O": "301412",
      "Jakhrana S.O": "301713",
      "Majari Kalan S.O": "301703",
      "Shahjahanpur S.O": "301706",
      "Kherli S.O": "321606",
      "MOTIDOONGRI S.O": "301002",
      "Narainpur S.O (Alwar)": "301024",
      "R.H.B. Bhiwari S.O": "301019",
      "Hnuman circle Alwar": "301001",
      "Tehla S.O": "301410",
      "Bahror Jat S.O": "301714",
      "Karni Kot S.O": "301427",
      "Khairthal S.O": "301404",
      "Neemrana S.O": "301705",
      "Machari Chowk,rajgarh S.O": "301408",
      "Malakhera Gate Alwar S.O": "301001",
      "Pratap Garh S.O (Alwar)": "301027",
      "Railway Station Alwar S.O": "301001",
      "Rajgarh (Alwar) S.O": "301408",
      "Rajpur S.O (Alwar)": "301415",
      "Reni S.O": "301409",
      "Shivajee Park Alwar S.O": "301001",
      "Harsauli S.O": "301403",
      "Mandhan S.O": "301704",
      "Delhi Gate Alwar S.O": "301001",
      "Alwar Bus Stand S.O": "301001",
      "Bahadurpur S.O": "301028",
      "Barodameo S.O": "301021",
      "Dhigawara S.O": "301414",
      "Garhi Sawai Ram S.O": "301413",
      "Govind Garh Alwar S.O": "301604",
      "Aryanagar Alwar S.O": "301001",
      "Bhiwari Ind. Area. Alwar S.O": "301019",
      "Khazuri Bass S.O": "301018",
      "Kishan Garh Bass S.O": "301405",
      "Laxman Garh S.O": "321607",
      "Malakhera S.O": "301406",
      "Nogaon S.O": "301025",
      "Ramgarh S.O (Alwar)": "301026",
      "Ronijathan S.O": "301035",
      "Tripoliya Alwar S.O": "301001",
      "Vijay Mandir S.O": "301023",
      "Ajerka S.O": "301401",
      "Gandala S.O": "301709",
      "Kutina S.O": "301708",
      "Mandawar S.O (Alwar)": "301407",
      "Rampur S.O (Alwar)": "301416",
      "H.B.Colony Alwar S.O": "301001",
      "Kathumar S.O": "321605"
    },
    "BUNDI": {
      "Badodiya B.O": "323001",
      "Dolara B.O": "323001",
      "Lalpura B.O": "323001",
      "Akoda B.O": "323026",
      "Mangal B.O": "323001",
      "Matunda B.O": "323001",
      "Thikarda B.O": "323026",
      "Alod B.O": "323024",
      "Morsan B.O": "323802",
      "Sadera B.O": "323802",
      "Roteda B.O": "323301",
      "Borkhandi B.O": "323001",
      "Talab Gaon B.O": "323001",
      "Ramganj B.O": "323001",
      "Silore B.O": "323001",
      "Basoli B.O": "323024",
      "Bhawanipura B.O": "323026",
      "Chetan B.O": "323024",
      "Negharh B.O": "323024",
      "Owan B.O": "323024",
      "Ramchandra Ji Ka Kheda B.O": "323024",
      "Ranipura B.O": "323026",
      "Bansi B.O": "323802",
      "Bhajneri B.O": "323802",
      "Gudasadawartia B.O": "323802",
      "Balkasa B.O": "323301",
      "Chardana B.O": "323301",
      "Jaithal B.O": "323301",
      "Antarda B.O": "323616",
      "Ramnagar B.O": "323001",
      "Khiniya B.O": "323001",
      "Gudha Nathawatan B.O": "323001",
      "Abar B.O": "323024",
      "Gothra B.O": "323026",
      "Mendi B.O": "323024",
      "Ronija B.O": "323026",
      "Sathur B.O": "323024",
      "Dokun B.O": "323802",
      "Dugari B.O": "323802",
      "Sahan B.O": "323802",
      "Sahaspuriya B.O": "323023",
      "Mohanpura B.O": "323613",
      "Karwala Ki Jhopri B.O": "323301",
      "Chatarpura B.O": "323001",
      "Bherupura Antri B.O": "323026",
      "Borda B.O": "323026",
      "Neem Ka Kheda B.O": "323001",
      "Dhowara B.O": "323024",
      "Guda Turkadi B.O": "323024",
      "Sanwatgarh B.O": "323026",
      "Soran B.O": "323026",
      "Dabeta B.O": "323802",
      "Guda Deo Ji B.O": "323802",
      "Chatarganj B.O": "323023",
      "Babai B.O": "323613",
      "Arnetha B.O": "323301",
      "Hingonia B.O": "323301",
      "Jaloda B.O": "323301",
      "Jawahar Sagar Dam B.O": "323022",
      "Balban B.O": "323614",
      "Chanda Khurd B.O": "323614",
      "Alphanagar B.O": "323021",
      "Barundhan B.O": "323021",
      "Dora B.O": "323021",
      "Jhakhmund B.O": "323021",
      "Sunwasa B.O": "323021",
      "Pagaran B.O": "323025",
      "Phalenda B.O": "323025",
      "Tonkra B.O": "323025",
      "Bajar B.O": "323021",
      "Ballop B.O": "323021",
      "Basni B.O": "323025",
      "Guda Gokulpura B.O": "323025",
      "Kachola B.O": "323025",
      "Nawalpura B.O": "323614",
      "Jamitpura B.O": "323021",
      "Laxmipura B.O": "323021",
      "Leeleda B.O": "323021",
      "Notada B.O": "323603",
      "Vijaygarh B.O": "323025",
      "Anghora B.O": "323614",
      "Daulatpura B.O": "323614",
      "Anthada B.O": "323021",
      "Dehit B.O": "323021",
      "Gumanpura B.O": "323021",
      "Ladpura B.O": "323021",
      "Pech Ki Baori B.O": "323025",
      "Thana B.O": "323025",
      "Jarkhoda B.O": "323616",
      "Chitawa B.O": "323602",
      "Gamach B.O": "323602",
      "Karwala B.O": "323602",
      "Lesarda B.O": "323602",
      "Bamori B.O": "323803",
      "Borda Kachhiyan B.O": "323803",
      "Gendoli B.O": "323803",
      "Peepliya B.O": "323803",
      "Bada Kheda B.O": "323603",
      "Dei Kheda B.O": "323603",
      "Dhagaria B.O": "323603",
      "Ghat Ka Barana B.O": "323603",
      "Laban B.O": "323603",
      "Bachola B.O": "323801",
      "Balapura B.O": "323801",
      "Amli B.O": "323022",
      "Budhpura B.O": "323022",
      "Dabi B.O": "323022",
      "Kaithuda B.O": "323616",
      "Neem Ka Khera B.O": "323616",
      "Radi B.O": "323602",
      "Songar B.O": "323602",
      "Tirath B.O": "323602",
      "Ajeta B.O": "323803",
      "Jetpur B.O": "323803",
      "Khyawda B.O": "323803",
      "Rehana B.O": "323803",
      "Papdi B.O": "323603",
      "Sakhawda B.O": "323603",
      "Chainpuria B.O": "323801",
      "Sisola B.O": "323801",
      "Gadarda B.O": "323022",
      "Khadipur B.O": "323022",
      "Khajoori B.O": "323616",
      "Renthoda B.O": "323616",
      "Talwas B.O": "323616",
      "Jhali Ji Ka Barana B.O": "323803",
      "Pholai B.O": "323803",
      "Raithal B.O": "323803",
      "Rajwas B.O": "323803",
      "Gambhira B.O": "323801",
      "Jajawar B.O": "323801",
      "Khanpura B.O": "323801",
      "Phuleta B.O": "323801",
      "Rajalawata B.O": "323801",
      "Samidhi B.O": "323801",
      "Suwania B.O": "323801",
      "Lambakho B.O": "323022",
      "Loicha B.O": "323022",
      "Mani B.O": "323616",
      "Bhiya B.O": "323602",
      "Maiza B.O": "323602",
      "Sarsala B.O": "323602",
      "Bherupura Ojhha B.O": "323803",
      "Luharpura B.O": "323803",
      "Nayagaon B.O": "323803",
      "Jawati Kalan B.O": "323803",
      "Ajanda B.O": "323603",
      "Baswada B.O": "323603",
      "Makhida B.O": "323603",
      "Rebarpura B.O": "323603",
      "Utharana B.O": "323603",
      "Bamangaon B.O": "323801",
      "Dhanugaon B.O": "323801",
      "Dhanesar B.O": "323022",
      "Kalpuria B.O": "323022",
      "Balchand Para Bundi S.O": "323001",
      "Baranaya Gaon S.O": "323024",
      "Hindoli S.O": "323023",
      "Kesoraipatan Sugar Factoy S.O": "323602",
      "Lakheri Gaon S.O": "323615",
      "New Colony Bundi S.O": "323001",
      "Sumerganj Mandi S.O": "323614",
      "Talera S.O (Bundi)": "323021",
      "Karwar S.O": "323616",
      "Lakheri S.O": "323603",
      "Namana S.O": "323022",
      "Umar S.O": "323025",
      "Dei S.O": "323802",
      "Kapren S.O": "323301",
      "Khatkar S.O": "323803",
      "Nainwan S.O": "323801",
      "Indergarh S.O (Bundi)": "323613",
      "Kesoraipatan S.O": "323601",
      "Dablana S.O": "323026",
      "Bundi H.O": "323001"
    },
    "BHARATPUR": {
      "Hingota B.O": "321206",
      "Jatoli Thoon B.O": "321206",
      "Moondoti B.O": "321205",
      "Pendka B.O": "321205",
      "Sirthala B.O": "321205",
      "Tarondar B.O": "321205",
      "Bodoli Dahar B.O": "321204",
      "Kathol B.O": "321204",
      "Samler B.O": "321204",
      "Awar B.O": "321202",
      "Konrer B.O": "321202",
      "Tamrer B.O": "321202",
      "Bhutoli B.O": "321642",
      "Jharkai B.O": "321642",
      "Niyotha B.O": "321642",
      "Alghani B.O": "321024",
      "Berru B.O": "321024",
      "Jhanjhar B.O": "321024",
      "Kaithwara B.O": "321024",
      "Khesti B.O": "321024",
      "Ranf B.O": "321024",
      "Mahmadpura BO": "321405",
      "Pali Dang BO": "321405",
      "Mahalpur Choora BO": "321403",
      "Poonchhari B.O": "321205",
      "Semla Kalan B.O": "321205",
      "Semli B.O": "321205",
      "Khandeola B.O": "321204",
      "Ladamka B.O": "321204",
      "Nagla Satwari B.O": "321204",
      "Ubhaka B.O": "321204",
      "Jai Sri B.O": "321024",
      "Jalalpur B.O": "321024",
      "Khohri B.O": "321203",
      "Olanda B.O": "321024",
      "Pipalkheda B.O": "321024",
      "Samri BO": "321405",
      "Jaluki B.O": "321205",
      "Khakhawali B.O": "321205",
      "Manota Kalan B.O": "321205",
      "Mundiya B.O": "321205",
      "Gangora B.O": "321204",
      "Ghatmika B.O": "321204",
      "Gopalgarh B.O": "321204",
      "Jotri Peepal B.O": "321204",
      "Jotruhalla B.O": "321204",
      "Alipur B.O": "321615",
      "Babekhar B.O": "321615",
      "Bhaiseena B.O": "321615",
      "Jharauti B.O": "321615",
      "Abhorra B.O": "321202",
      "Gunsara B.O": "321202",
      "Kasot B.O": "321202",
      "Talfara B.O": "321202",
      "Gudawali B.O": "321001",
      "Naom B.O": "321642",
      "Pili B.O": "321642",
      "Boodli B.O": "321024",
      "Bhawanpura BO": "321405",
      "Dumaria BO": "321405",
      "Garhi Bajna BO": "321405",
      "Kot BO": "321405",
      "Singhania BO": "321405",
      "Tarsuma BO": "321405",
      "Turtipura BO": "321405",
      "Dana Khedli BO": "321403",
      "Jatmasi BO": "321403",
      "Jotroli BO": "321403",
      "Dundawal B.O": "321205",
      "Dawak B.O": "321024",
      "Gulpada B.O": "321024",
      "Kakrala B.O": "321024",
      "Padalwas B.O": "321205",
      "Sadpuri B.O": "321205",
      "Sundrawali B.O": "321205",
      "Thoon B.O": "321205",
      "KUMHAREDI B.O": "321205",
      "Bhonri B.O": "321204",
      "Dhoolet B.O": "321204",
      "Papra B.O": "321204",
      "Pathroli B.O": "321204",
      "Saumka B.O": "321204",
      "Naroli B.O": "321615",
      "Khangri B.O": "321642",
      "Alamshah B.O": "321024",
      "Palka B.O": "321024",
      "Teski B.O": "321024",
      "Nagla Tula BO": "321405",
      "Paraua BO": "321405",
      "Sirrond BO": "321403",
      "Kherli Gujar B.O": "321601",
      "Moloni B.O": "321601",
      "Mudiya Lalita B.O": "321601",
      "Pali B.O": "321601",
      "Usrani B.O": "321206",
      "Badipur B.O": "321023",
      "Bamanwari B.O": "321023",
      "Gaomri B.O": "321023",
      "Nonera B.O": "321023",
      "Satwas B.O": "321023",
      "Bolkhera B.O": "321022",
      "Indrauli B.O": "321022",
      "Matuki B.O": "321022",
      "Musepur B.O": "321022",
      "Mehrawar B.O": "321201",
      "Pala B.O": "321201",
      "Anchera B.O": "321602",
      "Kamalpura B.O": "321407",
      "Newada B.O": "321407",
      "Salempur Khurd B.O": "321407",
      "Saheda B.O": "321023",
      "Sehson B.O": "321023",
      "Akata B.O": "321022",
      "Sunhera B.O": "321022",
      "Dhanwara B.O": "321201",
      "Belara B.O": "321602",
      "Bhadira B.O": "321602",
      "Karai B.O": "321602",
      "Karili B.O": "321602",
      "Luhasa B.O": "321602",
      "Manjhi B.O": "321602",
      "Paharsar B.O": "321602",
      "Unch B.O": "321602",
      "Mudia Sadh B.O": "321407",
      "Ghosinga B.O": "321023",
      "Unchera B.O": "321023",
      "Barauli Dhau B.O": "321022",
      "Bilond B.O": "321022",
      "Dhamari B.O": "321022",
      "Dhilawati B.O": "321022",
      "Sablana B.O": "321022",
      "Birheru B.O": "321201",
      "Pichumar B.O": "321201",
      "Sinsini B.O": "321201",
      "Gadauli B.O": "321602",
      "Gangrauli B.O": "321602",
      "Kawai B.O": "321602",
      "Raisis B.O": "321602",
      "Sihi B.O": "321602",
      "Bhatpura B.O": "321205",
      "Hantra B.O": "321601",
      "Thairwa": "321206",
      "Dandera B.O": "321023",
      "Nogaom B.O": "321023",
      "Pai B.O": "321023",
      "Anand Dadri B.O": "321022",
      "Bhandara B.O": "321022",
      "Bilong B.O": "321022",
      "Chhichhalwari B.O": "321022",
      "Garh Ajan B.O": "321022",
      "Luhesor B.O": "321022",
      "Pasopa B.O": "321022",
      "Astawan B.O": "321201",
      "Sabora B.O": "321206",
      "Sikrori B.O": "321201",
      "Saint BO": "321201",
      "Bhatawali B.O": "321602",
      "Ishapur Katara B.O": "321602",
      "Khatoti B.O": "321602",
      "Paprera B.O": "321602",
      "Ronija B.O": "321602",
      "Ikran B.O": "321001",
      "Khemra B.O.": "321001",
      "Baben B.O": "321026",
      "Bhandore B.O": "321026",
      "Borai B.O": "321026",
      "Dehra B.O": "321028",
      "Dharsoni B.O": "321028",
      "Chichana B.O": "321001",
      "Forest Lodge B.O": "321001",
      "Aghapur B.O": "321001",
      "Tuhiya B.O": "321001",
      "PUNJABI NAGLA": "321001",
      "Gaomdi B.O": "321021",
      "Phulwara B.O": "321021",
      "Kasoda B.O": "321026",
      "Murwara B.O": "321026",
      "Barkheda B.O": "321028",
      "Paraswara B.O": "321028",
      "Malah B.O": "321001",
      "Behnera B.O": "321001",
      "Sogar B.O": "321001",
      "Ghusiyari B.O": "321001",
      "Sunari B.O": "321001",
      "Pipla B.O": "321021",
      "Lakhanpur B.O": "321028",
      "Bargha B.O": "321301",
      "Bhainsa B.O": "321301",
      "Kurka B.O": "321301",
      "Bilothi B.O": "321025",
      "Dhormui B.O": "321025",
      "Moroli Kalan B.O": "321025",
      "Dhanota B.O": "321303",
      "Kumha B.O": "321303",
      "Ludhawai B.O": "321303",
      "Andhiyari B.O": "321302",
      "Bachhamdi B.O": "321302",
      "Ekta B.O": "321302",
      "Nigoi B.O": "321203",
      "Bachhren B.O": "321407",
      "Pingora B.O": "321028",
      "Bansi B.O": "321301",
      "Ajan B.O": "321025",
      "Santruk B.O": "321025",
      "Helak B.O": "321303",
      "Mudota B.O": "321303",
      "Uncha Gaom B.O": "321303",
      "Mudhera B.O": "321302",
      "Nekpur B.O": "321302",
      "Chulhera B.O": "321203",
      "Khoh B.O": "321203",
      "Baroli Chuth B.O": "321203",
      "Nehra Chauth B.O": "321203",
      "Shiswara B.O": "321206",
      "Barauli Chhar B.O": "321614",
      "Baroli Ran B.O": "321614",
      "Ghatri B.O": "321409",
      "Hathodi B.O": "321409",
      "Jahaj B.O": "321409",
      "Majajpur B.O": "321409",
      "Nithar B.O": "321409",
      "M.V.Peeth Bhusawar B.O": "321406",
      "Hatizar B.O": "321028",
      "Jahangirpur B.O": "321028",
      "Ajau B.O": "321303",
      "Bansi Khurd B.O": "321303",
      "Bhont B.O": "321303",
      "Nagla Tehriyan B.O": "321302",
      "Sehna B.O": "321302",
      "Veerampura B.O": "321302",
      "Guhana B.O": "321203",
      "Pasta B.O": "321203",
      "Au B.O": "321203",
      "Samai Kheda B.O": "321203",
      "Bedham B.O": "321206",
      "Jateri B.O": "321203",
      "Syorawali B.O": "321206",
      "Piprau B.O": "321614",
      "Talchhera B.O": "321614",
      "Jasupura B.O": "321409",
      "Kalsada B.O": "321409",
      "Karawali B.O": "321409",
      "Mainapura B.O": "321409",
      "Randhirgarh B.O": "321406",
      "Saindhli B.O": "321406",
      "Suhari B.O": "321406",
      "Bahtana B.O": "321203",
      "Bahaj B.O": "321203",
      "Panhori B.O": "321206",
      "Didawali B.O": "321203",
      "Iklera B.O": "321203",
      "Utarda B.O": "321614",
      "Baroli B.O": "321406",
      "Bachhamdi Noh B.O": "321001",
      "Undra B.O": "321001",
      "Chiksana B.O": "321001",
      "Barso B.O": "321001",
      "Barakhur B.O": "321021",
      "Hatheni B.O": "321021",
      "Madhoni B.O": "321026",
      "Atari B.O": "321028",
      "Mai B.O": "321028",
      "Shekhpur B.O": "321028",
      "Bareh Mafi B.O": "321301",
      "Jatoli Rathbhan B.O": "321025",
      "Takha B.O": "321025",
      "Gagwana B.O": "321303",
      "Jharoli B.O": "321303",
      "Mahua B.O": "321303",
      "Par B.O": "321303",
      "Milakpur B.O": "321302",
      "Badangarh B.O": "321201",
      "Parmadra B.O": "321203",
      "Moroli B.O": "321206",
      "Dantlothi B.O": "321206",
      "Nayabas B.O": "321614",
      "Gogera B.O": "321409",
      "Salempur Kalan B.O": "321409",
      "Diwali B.O": "321406",
      "Narharpur B.O": "321406",
      "Bijwari B.O": "321407",
      "Nayagaom Khalsa B.O": "321406",
      "Chentoli B.O": "321407",
      "Gobra BO": "321401",
      "Lehchora Kalan BO": "321401",
      "Sikandara BO": "321401",
      "Thana Dang BO": "321401",
      "Naroli BO": "321410",
      "Purabai Kheda BO": "321410",
      "Kapoora Malooka BO": "321411",
      "Karwari BO": "321411",
      "Keir BO": "321411",
      "Khan Kheda BO": "321411",
      "Bidiyari BO": "321401",
      "Damdama BO": "321401",
      "Nahroli BO": "321401",
      "Adda BO": "321411",
      "Khunt Kheda BO": "321411",
      "Madanpur BO": "321411",
      "Mehrawar BO": "321411",
      "Raroda BO": "321411",
      "Daulat Garh BO": "321404",
      "Dorda BO": "321404",
      "Ibrahimpur BO": "321404",
      "Khan Surjapur BO": "321404",
      "Dahina Gaon BO": "321402",
      "Khera Thakur BO": "321402",
      "Madha Pura BO": "321402",
      "Bajhera Kalan BO": "321408",
      "Farso BO": "321401",
      "Kanavar BO": "321401",
      "Mahaloni BO": "321401",
      "Navali BO": "321401",
      "Shahpur Dang BO": "321401",
      "Singhada BO": "321410",
      "Aroda BO": "321411",
      "Milsama BO": "321404",
      "Nayagaon BO": "321404",
      "Moroli Dang BO": "321402",
      "Hishamada BO": "321408",
      "Jagjiwanpur BO": "321408",
      "Lakhanpur BO": "321408",
      "Umrend BO": "321408",
      "Dhadhren BO": "321411",
      "Dahgaon BO": "321401",
      "Khohra BO": "321401",
      "Salabad BO": "321401",
      "Shergarh BO": "321401",
      "Sadpura BO": "321410",
      "Soopa BO": "321410",
      "Bagren BO": "321411",
      "Gajipur BO": "321411",
      "Samogar BO": "321411",
      "Chenkora BO": "321404",
      "Khanwa BO": "321404",
      "Mertha BO": "321404",
      "Ondelgaddi BO": "321404",
      "Kakraua BO": "321402",
      "Rasilpur BO": "321402",
      "Bansi BO": "321408",
      "Muhari BO": "321408",
      "Samraya BO": "321408",
      "Siras BO": "321408",
      "Chak Samri BO": "321404",
      "Maloni BO": "321404",
      "Noharda BO": "321404",
      "Rundh BO": "321404",
      "Baroda BO": "321402",
      "Mandoli BO": "321402",
      "Nibhera BO": "321402",
      "Jeewad BO": "321408",
      "Rahimgarh BO": "321408",
      "Suhans BO": "321408",
      "Sikri S.O": "321024",
      "Bayana SO": "321401",
      "Bazariya Bayana SO": "321401",
      "Kachahri Bayana SO": "321401",
      "Khareri SO": "321411",
      "Roopbas SO": "321404",
      "Band Baretha SO": "321405",
      "Banshi Paharpur SO": "321403",
      "Brahmbad SO": "321410",
      "Penghore S.O": "321202",
      "Sarsena S.O": "321642",
      "Bharatpur H.O": "321001",
      "Deeg H.O": "321203",
      "Rudawal SO": "321402",
      "Weir SO": "321408",
      "Bharatpur Agency S.O": "321001",
      "Collectorate BTP S.O": "321001",
      "Kotwalibharatpur S.O": "321001",
      "Krishna Colony BTP S.O": "321001",
      "Mathura Gate BTP S.O": "321001",
      "Ranjeet Nagar BTP S.O": "321001",
      "Sewar S.O": "321303",
      "Uchain S.O": "321302",
      "Halena S.O": "321601",
      "Nadbai S.O": "321602",
      "Kherli Gadasia S.O": "321028",
      "New Mandi BTP S.O": "321001",
      "Rareh S.O": "321025",
      "Akhaigarh S.O": "321614",
      "Bhusawar S.O": "321406",
      "Janoothar S.O": "321206",
      "Bharatpur City S.O": "321001",
      "Gopalgarh BTP S.O": "321001",
      "Kumhergate BTP S.O": "321001",
      "Pichuna S.O": "321301",
      "Ballabhgarh S.O": "321409",
      "Jurhera S.O": "321023",
      "Kamanlsg S.O": "321022",
      "Nadbai Town S.O": "321602",
      "Nagar S.O (Bharatpur)": "321205",
      "Pathena S.O": "321615",
      "Pahari S.O (Bharatpur)": "321204",
      "Anahgatebharatpur S.O": "321001",
      "Jaghina S.O": "321021",
      "Kanjoli Line S.O": "321026",
      "Chhonkarwara Kalan S.O": "321407",
      "Kumher S.O": "321201"
    },
    "DUNGARPUR": {
      "Pal Mathugamda B.O": "314001",
      "Gamdi Ahada B.O": "314001",
      "Chouki B.O": "314037",
      "Dojapal B.O": "314037",
      "Metali B.O": "314001",
      "Rohanwara B.O": "314001",
      "Jalukuwa B.O": "314001",
      "Kherwara Chela B.O": "314001",
      "Balota B.O": "314037",
      "Salaj B.O": "314037",
      "Hirata B.O": "314037",
      "Kanhari B.O": "314037",
      "Gol B.O": "314021",
      "Parda Itiwar B.O": "314021",
      "Raiki B.O": "314021",
      "Tokwasa B.O": "314021",
      "Bhasore B.O": "314023",
      "Gada Kumaria B.O": "314023",
      "Jashpur Jabka B.O": "314023",
      "Bageri B.O": "314031",
      "Sundarpur B.O": "314001",
      "Mada B.O": "314001",
      "Biladi B.O": "314001",
      "Mewada B.O": "314001",
      "Veerpur B.O": "314001",
      "Bilia Badgama B.O": "314037",
      "Nalwarda B.O": "314037",
      "Surata B.O": "314037",
      "Amaritia B.O": "314021",
      "Khudarda B.O": "314021",
      "Rampur Mewada B.O": "314001",
      "Somkamla Amba B.O": "314021",
      "Galiana B.O": "314023",
      "Khalil B.O": "314023",
      "Mandwa B.O": "314001",
      "Mathugamda B.O": "314001",
      "Piplada B.O": "314001",
      "Surpur B.O": "314001",
      "Teejwar B.O": "314001",
      "Galander B.O": "314001",
      "Kokapur B.O": "314023",
      "Lilwasa B.O": "314023",
      "Mowai B.O": "314023",
      "Barothi B.O": "314801",
      "Ger B.O": "314801",
      "Kherwara B.O": "314801",
      "Palisoda B.O": "314801",
      "Palpadar B.O": "314801",
      "Talaiya B.O": "314801",
      "Gara Mertiya B.O": "314030",
      "Gundlara B.O": "314030",
      "Kuwan B.O": "314030",
      "Panch Kundli B.O": "314030",
      "Jhosawa B.O": "314035",
      "Kasariya B.O": "314035",
      "Asela B.O": "314036",
      "Naraniya B.O": "314036",
      "Pagara B.O": "314404",
      "Vassi B.O": "314036",
      "Jethana B.O": "314031",
      "Amzara B.O": "314801",
      "Chundawada B.O": "314801",
      "Kherasa B.O": "314030",
      "Baba Ki Bar B.O": "314035",
      "Bhamai B.O": "314035",
      "Bhesara Bara B.O": "314035",
      "Kheda Kachawasa B.O": "314036",
      "Underda B.O": "314036",
      "Upergaon B.O": "314036",
      "Bansia B.O": "314402",
      "Garmala B.O": "314804",
      "Ghugra B.O": "314804",
      "Sanchia B.O": "314804",
      "Ghata Ka Gaon B.O": "314027",
      "Ghotad B.O": "314027",
      "Hadmala B.O": "314027",
      "Leemri B.O": "314027",
      "Semlia Ghata B.O": "314027",
      "Suraj Gaon B.O": "314027",
      "Phaota B.O": "314401",
      "Virat B.O": "314401",
      "Rampur Sati B.O": "314011",
      "Shishod B.O": "314011",
      "Tadi Obri B.O": "314011",
      "Vagdari B.O": "314011",
      "Bandela B.O": "314406",
      "Bankra B.O": "314406",
      "Punawada B.O": "314406",
      "Rajpur B.O": "314406",
      "Baroda B.O": "314038",
      "Hathai B.O": "314034",
      "Kanthari B.O": "314034",
      "Odwariya B.O": "314034",
      "Parda Thoor B.O": "314034",
      "Ragunathpura B.O": "314034",
      "Biloora B.O": "314022",
      "Devpur B.O": "314022",
      "Semalia Pandya B.O": "314031",
      "Vandarved B.O": "314031",
      "Khajuri B.O": "314801",
      "Modar B.O": "314801",
      "Badgama B.O": "314030",
      "Bawadi B.O": "314030",
      "Dhangaon B.O": "314030",
      "Doongar B.O": "314030",
      "Ramsore B.O": "314030",
      "Rathari B.O": "314030",
      "Saleda B.O": "314030",
      "Sendola B.O": "314030",
      "Likhatiya  B.O": "314035",
      "Parda Mataji B.O": "314035",
      "Ratriya B.O": "314035",
      "Ubli B.O": "314035",
      "Dhavri B.O": "314036",
      "Dowda B.O": "314036",
      "Bodamali B.O": "314402",
      "Bhiyana B.O": "314804",
      "Bori B.O": "314804",
      "Karada B.O": "314024",
      "Padra B.O": "314024",
      "Bokhla B.O": "314011",
      "Dewal B.O": "314011",
      "Gamdi Deval B.O": "314011",
      "Gamdi Pal B.O": "314011",
      "Dariyati B.O": "314406",
      "Dookan B.O": "314406",
      "Jorawarpur B.O": "314406",
      "Jhariyana B.O": "314038",
      "Kabja B.O": "314038",
      "Mal B.O": "314038",
      "Bhojato Ka Oda B.O": "314034",
      "Deosomnath B.O": "314034",
      "Dolpur B.O": "314022",
      "Gandhwa B.O": "314402",
      "Karawada B.O": "314402",
      "Nagria Panchela B.O": "314402",
      "Pohri Patelan B.O": "314402",
      "Silohi B.O": "314026",
      "Karoli B.O": "314804",
      "Sabli B.O": "314804",
      "Ambada B.O": "314030",
      "Daiyana B.O": "314027",
      "Decha B.O": "314401",
      "Parda Mehton ka B.O": "314401",
      "Gamdi Devki B.O": "314024",
      "Oad B.O": "314024",
      "Bara B.O": "314011",
      "Gardhuna B.O": "314011",
      "Bhachdhia B.O": "314406",
      "Dhodhra B.O": "314406",
      "Jharani B.O": "314406",
      "Kolkhanda B.O": "314028",
      "Mando Ki Pal B.O": "314028",
      "Bodigama Kalan B.O": "314038",
      "Ghotada B.O": "314038",
      "Katisor B.O": "314038",
      "Pachlasa Chhota B.O": "314038",
      "Vasunder Chhoti B.O": "314038",
      "Dhatana B.O": "314034",
      "Ganeshpur B.O": "314034",
      "Khempur B.O": "314034",
      "Thoor ki pal B.O": "314034",
      "Bharga B.O": "314022",
      "Diwda Bada B.O": "314031",
      "Chhapi B.O": "314801",
      "Dhamod B.O": "314801",
      "Malmatha B.O": "314801",
      "Ratanpur B.O": "314801",
      "Dungarsaran B.O": "314030",
      "Gariyata B.O": "314030",
      "Jasela B.O": "314030",
      "Kochri B.O": "314030",
      "Nandia B.O": "314030",
      "Tamboliya B.O": "314030",
      "Gada Jasrajpur B.O": "314035",
      "Jogpur B.O": "314035",
      "Gada Moraiya B.O": "314036",
      "Kherwara Sulai B.O": "314036",
      "Paldhara B.O": "314036",
      "Ghuver B.O": "314402",
      "Pohri Khatu B.O": "314402",
      "Vedsa B.O": "314402",
      "Balwara B.O": "314804",
      "Navalshyam B.O": "314804",
      "Odabada B.O": "314804",
      "Thana B.O": "314804",
      "Chadoli B.O": "314027",
      "Diwda Chhota B.O": "314027",
      "Mewara B.O": "314027",
      "Barbudnia B.O": "314401",
      "Pepala Gunj B.O": "314401",
      "Akhaipur B.O": "314024",
      "Gumanpura B.O": "314011",
      "Dhoondhariya B.O": "314406",
      "Malakholda B.O": "314406",
      "Mandav B.O": "314028",
      "Bhiyodi B.O": "314038",
      "Borigama Chhota B.O": "314038",
      "Lapania B.O": "314038",
      "Pachalasa Bada B.O": "314038",
      "Devla B.O": "314034",
      "Falonj B.O": "314034",
      "Indora B.O": "314034",
      "Kareliya B.O": "314034",
      "Kheda Samor B.O": "314034",
      "Sakani B.O": "314034",
      "Savgarh B.O": "314034",
      "Bhakhrad B.O": "314022",
      "Gamdi B.O": "314022",
      "Talora B.O": "314022",
      "Varsinghpur B.O": "314025",
      "Gowadi B.O": "314025",
      "Palmavit B.O": "314025",
      "Badi Likhi B.O": "314403",
      "Charwara B.O": "314403",
      "Sarthuna B.O": "314403",
      "Nandod B.O": "314029",
      "Munged B.O": "314022",
      "Nandli B.O": "314022",
      "Nithauva B.O": "314022",
      "Pal Nithauwa B.O": "314022",
      "Gada Jhumji B.O": "314032",
      "Gada Wasan B.O": "314032",
      "Kariyana B.O": "314032",
      "Khadlai B.O": "314032",
      "Rasta B.O": "314403",
      "Sadaria B.O": "314403",
      "Sakarsi B.O": "314403",
      "Khanan B.O": "314022",
      "Lodawal B.O": "314022",
      "Miyala B.O": "314022",
      "Pindawal B.O": "314022",
      "Sagot B.O": "314022",
      "Gamda Brahamania B.O": "314025",
      "Semaliya B.O": "314032",
      "Gara Gokal B.O": "314403",
      "Jhalai B.O": "314403",
      "Seethal B.O": "314403",
      "Kahela B.O": "314029",
      "Jogiwara B.O": "314022",
      "Rinchha B.O": "314022",
      "Solanj B.O": "314022",
      "Valai B.O": "314022",
      "Ara B.O": "314025",
      "Buchiya Bada B.O": "314032",
      "Padardi Badi B.O": "314032",
      "Vamasa B.O": "314032",
      "Jalap B.O": "314403",
      "Mandli B.O": "314403",
      "Beejawara B.O": "314029",
      "Gara Bejaniya B.O": "314029",
      "Nougama B.O": "314029",
      "Tamtiya B.O": "314029",
      "Ghata B.O": "314404",
      "Nokhna B.O": "314029",
      "Bera B.O": "314404",
      "Bhinda B.O": "314404",
      "Genji B.O": "314404",
      "Pokhrun B.O": "314404",
      "Mahudipal B.O": "314404",
      "Rainta B.O": "314404",
      "Varda B.O": "314029",
      "Jhontri B.O": "314404",
      "Sansarpur B.O": "314404",
      "Venja B.O": "314404",
      "Dungarpur H.O": "314001",
      "Dhambola S.O": "314402",
      "Galiakot S.O": "314026",
      "Obri S.O": "314401",
      "Punali S.O": "314028",
      "Punjpur S.O": "314038",
      "Sagwara Bazar S.O": "314025",
      "Simalwara S.O": "314403",
      "Antri S.O (Dungarpur)": "314037",
      "Aspur S.O": "314021",
      "Damdi S.O": "314036",
      "Khadagda S.O": "314027",
      "Padwa S.O (Dungarpur)": "314024",
      "Sabla S.O": "314022",
      "Kanba S.O": "314804",
      "Peeth S.O": "314406",
      "Ramgarh S.O (Dungarpur)": "314034",
      "Saroda S.O": "314032",
      "Bankora S.O": "314023",
      "Bhiluda S.O": "314031",
      "Bichhiwara S.O": "314801",
      "Chikhli S.O (Dungarpur)": "314030",
      "Chitri S.O": "314035",
      "Dungarpur Gapsagar S.O": "314001",
      "Paldeval S.O": "314011",
      "Sagwara S.O": "314025",
      "Thakarda S.O": "314029",
      "Vikasnagar S.O (Dungarpur)": "314404"
    },
    "DHOLPUR": {
      "Tor BO": "328001",
      "Basaineem BO": "328001",
      "Dubra BO": "328001",
      "Mahmadpur BO": "328001",
      "Sanora BO": "328031",
      "Bijoli BO": "328021",
      "Dhanora BO": "328021",
      "Dhimari BO": "328021",
      "Gajpura BO": "328021",
      "Naksoda BO": "328021",
      "Nidhara BO": "328021",
      "Sone Ka Gurja BO": "328021",
      "Tontari BO": "328021",
      "Kolari BO": "328023",
      "Kurenda BO": "328041",
      "Maloni Panwar BO": "328023",
      "Nidhera Kalan BO": "328023",
      "Bhesena BO": "328001",
      "Kasimpur BO": "328001",
      "Sandey BO": "328001",
      "Angai BO": "328031",
      "Lilothi Jhala BO": "328031",
      "Aligarh BO": "328021",
      "Khanpur Meena BO": "328021",
      "Rupaspur BO": "328021",
      "Singorai BO": "328021",
      "Donari BO": "328023",
      "Pipraua BO": "328023",
      "Tagawali BO": "328001",
      "Moroli BO": "328001",
      "Chilachond BO": "328031",
      "Kansotikhera BO": "328021",
      "Umreh BO": "328021",
      "Barehmori BO": "328001",
      "Bichhia BO": "328001",
      "Odi BO": "328001",
      "Jatoli BO": "328001",
      "Sadikpur BO": "328001",
      "Jirauli BO": "328001",
      "Rahrai BO": "328031",
      "Bahadurpur BO": "328021",
      "Matsura BO": "328021",
      "Sahedi BO": "328021",
      "Salemabad BO": "328021",
      "Kharagpur BO": "328023",
      "Piphera BO": "328023",
      "Sakhwara BO": "328023",
      "Bharli BO": "328022",
      "Dhorr BO": "328022",
      "Ekta BO": "328022",
      "Jarga BO": "328022",
      "Khori Ibrahimpur BO": "328022",
      "Mahu Gulawali BO": "328022",
      "Mamodhan BO": "328022",
      "Mudik BO": "328022",
      "Afjalpur BO": "328041",
      "Kotra BO": "328028",
      "Varipura BO": "328028",
      "Visnoda BO": "328028",
      "Baretha BO": "328024",
      "Atarsuma BO": "328022",
      "Salempur BO": "328022",
      "Tajpur BO": "328022",
      "Lakhepura BO": "328041",
      "Marholi BO": "328041",
      "Nagala Bidhora BO": "328041",
      "Norha BO": "328041",
      "Bagcholi Khar BO": "328024",
      "Viparpur BO": "328024",
      "Virondha BO": "328024",
      "Jetpur BO": "328029",
      "Lalpur Rehsena BO": "328029",
      "Madhabhau BO": "328029",
      "Pakkapura BO": "328029",
      "Samor Marena BO": "328029",
      "Sarani Khera BO": "328030",
      "Ambarpur BO": "328025",
      "Sikroda BO": "328025",
      "Silawat BO": "328025",
      "Singhawali BO": "328025",
      "Boreilly BO": "328027",
      "Lajjakigarhi BO": "328027",
      "Madha Kankoli BO": "328027",
      "Neem Khera BO": "328027",
      "Nunhera BO": "328027",
      "Siyasat Nagar BO": "328023",
      "Barai BO": "328022",
      "Daupura BO": "328022",
      "Harjupura BO": "328022",
      "Khidora BO": "328022",
      "Nadanpur BO": "328022",
      "Poonthpura BO": "328022",
      "Badretha BO": "328041",
      "Japawali BO": "328041",
      "Basainadang BO": "328028",
      "Nagar BO": "328025",
      "Bintipura BO": "328024",
      "Dubati BO": "328024",
      "Hinota BO": "328024",
      "Mangrol BO": "328024",
      "Jasupura BO": "328024",
      "Kherli BO": "328024",
      "Kotpura BO": "328024",
      "Chilpura BO": "328029",
      "Faraspura BO": "328029",
      "Gari Chatola BO": "328030",
      "Maloni Khurd BO": "328030",
      "Manpur BO": "328030",
      "Pureni BO": "328030",
      "Basai Ghiyaram BO": "328025",
      "Dhondi Ka Pura BO": "328025",
      "Ganhedi BO": "328025",
      "Hathbai BO": "328025",
      "Mithawali BO": "328025",
      "Nadoli BO": "328025",
      "Nahila BO": "328025",
      "Sahrauli BO": "328027",
      "Tasimo BO": "328027",
      "Bijholi BO": "328026",
      "Biloni BO": "328030",
      "Chandpura BO": "328026",
      "Kharauli BO": "328026",
      "Madhasil BO": "328026",
      "Padampura BO": "328026",
      "Bagthar BO": "328022",
      "Pipron BO": "328022",
      "Ratanpur BO": "328022",
      "Gadhi Sukkha BO": "328041",
      "Mahua Kheda BO": "328041",
      "Nagla Dulhe Khan BO": "328041",
      "Sohan BO": "328041",
      "Bothpura BO": "328024",
      "Jalalpur BO": "328024",
      "Mauja Ka Nagla BO": "328024",
      "Tanda BO": "328024",
      "Gunpur BO": "328029",
      "Karkakherli BO": "328029",
      "Pahari BO": "328029",
      "Basai Samanta BO": "328030",
      "Bajna BO": "328025",
      "Khudila BO": "328025",
      "Samona BO": "328025",
      "Chitora BO": "328027",
      "Kanasil BO": "328027",
      "Kunkuta BO": "328027",
      "Rajaura Khurd BO": "328027",
      "Golari BO": "328026",
      "Sahapura BO": "328024",
      "Basai Kare BO": "328029",
      "Kathoomari BO": "328029",
      "Mahadpura BO": "328029",
      "Kolua BO": "328030",
      "Purani Chhawani BO": "328030",
      "Tehri BO": "328030",
      "Barsala BO": "328025",
      "Dev Khera BO": "328025",
      "Gari Zafar BO": "328025",
      "Khanpura BO": "328025",
      "Machhariya BO": "328025",
      "Samliyapura BO": "328025",
      "Kenthari BO": "328027",
      "Rajaura Kalan BO": "328027",
      "Chandrawali BO": "328026",
      "Domai BO": "328026",
      "Jhiri BO": "328026",
      "Madanpur BO": "328026",
      "Barauli SO Dholpur": "328031",
      "Bari SO": "328021",
      "Civil Court Dholpur SO": "328001",
      "Keshar Bagh SO": "328028",
      "Marena SO": "328029",
      "Basai Nabab SO": "328023",
      "Baseri SO": "328022",
      "Kanchanpur SO Dholpur": "328041",
      "Rajakhera SO": "328025",
      "Bazariya Dholpur SO": "328001",
      "Bari Rs SO": "328021",
      "Maniya SO": "328024",
      "Panch Gaon SO": "328030",
      "Saipau SO": "328027",
      "Dholpur HO": "328001",
      "New Bus Stand Dholpur SO": "328001",
      "Sarmathura SO": "328026",
      "Udaibhan Ganj Dholpur SO": "328001"
    },
    "NAGAUR": {
      "Wer B.O": "314001",
      "Chawandia B.O": "341516",
      "Dholia B.O": "341304",
      "Ledi B.O": "341304",
      "Kharesh B.O": "341318",
      "Sania B.O": "341318",
      "Hariyajun B.O": "341508",
      "Indokha B.O": "341319",
      "Muwana B.O": "341508",
      "Jijoth B.O": "341519",
      "Rid B.O": "341503",
      "Sanju B.O": "341503",
      "Tilanesh B.O": "341503",
      "Moriallan B.O": "341515",
      "Thata B.O": "341515",
      "Balsamand B.O": "341304",
      "Palot B.O": "341305",
      "Sagoobari B.O": "341305",
      "Palara B.O": "341508",
      "Panchwa B.O": "341508",
      "Rajaliya B.O": "341508",
      "Rasal B.O": "341508",
      "S.Padampura B.O": "341508",
      "Araksar B.O": "341519",
      "Chitawa B.O": "341519",
      "Bhadlia B.O": "341517",
      "Asotapura B.O": "341306",
      "Sunari B.O": "341306",
      "Shimbhupura B.O": "341507",
      "Nimod B.O": "341506",
      "Banwaligudha B.O": "341533",
      "Lichana B.O": "341533",
      "Lalas B.O": "341509",
      "Baldu B.O": "341316",
      "Dhananwa B.O": "341319",
      "Daudsar B.O": "341516",
      "Parewari B.O": "341516",
      "Tanwara B.O": "341022",
      "Pirwa B.O": "341318",
      "Agoonta B.O": "341305",
      "Banthri B.O": "341305",
      "Kerap B.O": "341305",
      "Mamroda B.O": "341305",
      "Anandpura B.O": "341508",
      "Bhanwata B.O": "341508",
      "Bhooni B.O": "341508",
      "Charanwas B.O": "341508",
      "Nalot B.O": "341519",
      "Prempura B.O": "341519",
      "Shiv B.O": "341519",
      "Rasidpura B.O": "341517",
      "Shyamgarh B.O": "341507",
      "Akoda B.O": "341506",
      "Bansa B.O": "341506",
      "Jharod B.O": "341506",
      "Khakholi B.O": "341506",
      "Bhagwanpura B.O": "341509",
      "Chosala B.O": "341509",
      "Govindi B.O": "341509",
      "Gudhasalt B.O": "341509",
      "Hudeel B.O": "341509",
      "Phirod B.O": "341001",
      "Rohini B.O": "341001",
      "Unthwaliya B.O": "341001",
      "Kalri B.O": "341001",
      "Bhadwasi B.O": "341001",
      "Chenar B.O": "341001",
      "Daru B.O": "341001",
      "Jharisara B.O": "341001",
      "Harnawa B.O": "341501",
      "Janjila B.O": "341501",
      "Mundghasoi B.O": "341509",
      "Panchota B.O": "341509",
      "Thikariya Khurd B.O": "341509",
      "Todas B.O": "341509",
      "Dudoli B.O": "341316",
      "Hudas B.O": "341316",
      "Malgaon B.O": "341316",
      "Thakriyas B.O": "341316",
      "Dhingasari B.O": "341317",
      "Dhurila B.O": "341317",
      "Genana B.O": "341317",
      "Khamiyad B.O": "341317",
      "Kharwaliya B.O": "341319",
      "Nawad B.O": "341319",
      "Thebari B.O": "341319",
      "Bhadana B.O": "341026",
      "Bher B.O": "341001",
      "Ganthilasar B.O": "341001",
      "Chau B.O": "341001",
      "Gudhabhagwandas B.O": "341001",
      "Pabusar B.O": "341001",
      "Sadokan B.O": "341001",
      "Tausar B.O": "341001",
      "Deu B.O": "341001",
      "Singar B.O": "341001",
      "Bhakrod B.O": "341001",
      "Chuntisara B.O": "341001",
      "Lalana Khurd B.O": "341501",
      "Nimbri B.O": "341501",
      "Bhadasar B.O": "341516",
      "Dabari B.O": "341304",
      "Kasumbi B.O": "341304",
      "Rodu B.O": "341304",
      "Khojas B.O": "341318",
      "Ransisar B.O": "341305",
      "Dalelpura B.O": "341508",
      "Heerani B.O": "341508",
      "Jiliya B.O": "341508",
      "Kankariya B.O": "341508",
      "Narainpura B.O": "341508",
      "Rooppura B.O": "341508",
      "Sabalpura B.O": "341520",
      "Daulatpura B.O": "341303",
      "Motipura B.O": "341519",
      "Gelasar B.O": "341517",
      "Bakalia B.O": "341306",
      "Deolikallan B.O": "341507",
      "Berwa B.O": "341506",
      "Dabara B.O": "341506",
      "Palrinawa B.O": "341533",
      "Jabdinagar B.O": "341509",
      "Khorandi B.O": "341509",
      "Lunwa B.O": "341509",
      "Bharnawa B.O": "341316",
      "Asarwa B.O": "341319",
      "Chindaliya B.O": "341319",
      "Gaondi B.O": "341319",
      "Tantwas B.O": "341001",
      "Anwaliyasar B.O": "341001",
      "Bhundel B.O": "341001",
      "Shyamsar B.O": "341001",
      "Janewa B.O": "341001",
      "Karnu B.O": "341001",
      "Datina B.O": "341001",
      "Kharnal B.O": "341001",
      "Kharikaramsota B.O": "341001",
      "Sinod B.O": "341001",
      "Bhadawa B.O": "341501",
      "Sirsu B.O": "341501",
      "Barangaon B.O": "341021",
      "Nagwara B.O": "341519",
      "Nandolichandawatan B.O": "341517",
      "Dujar B.O": "341306",
      "Begsar B.O": "341506",
      "Dikawa B.O": "341506",
      "Khardiya B.O": "341504",
      "Mindha B.O": "341509",
      "Chandrai B.O": "341316",
      "Gorau B.O": "341316",
      "Odit B.O": "341316",
      "Sinwa B.O": "341317",
      "Chandi B.O": "341319",
      "Mandukara B.O": "341319",
      "Panchori B.O": "341001",
      "Balaya B.O": "341001",
      "Alai B.O": "341001",
      "Chawandiya B.O": "341001",
      "Jalaniyasar B.O": "341001",
      "Sukhwasi B.O": "341001",
      "Satheran B.O": "341001",
      "Gogelao B.O": "341001",
      "Tankala B.O": "341001",
      "Jodhiyasi B.O": "341001",
      "Gular B.O": "341501",
      "Boodhi B.O": "341021",
      "Bhinchawa B.O": "341302",
      "Hudia B.O": "341502",
      "Jusariya B.O": "341505",
      "Loroli B.O": "341502",
      "Saferkallan B.O": "341502",
      "Akora B.O": "341022",
      "Somana B.O": "341022",
      "Surpalia B.O": "341022",
      "Damboi Khurd B.O": "341504",
      "Dobariya B.O": "341504",
      "Kherileela B.O": "341504",
      "Kuchipala B.O": "341504",
      "Gingaliya B.O": "341520",
      "Ladoli B.O": "341520",
      "Mamroli B.O": "341520",
      "Jakhali B.O": "341502",
      "Barnel B.O": "341023",
      "Ramsia B.O": "341504",
      "Raidhanu B.O": "341021",
      "Burdi B.O": "341022",
      "Chhapara B.O": "341303",
      "Jhareli B.O": "341022",
      "Kameria B.O": "341022",
      "Dobarikallan B.O": "341504",
      "Itawalakha B.O": "341504",
      "Jaswantpura B.O": "341504",
      "Kumari B.O": "341021",
      "Dhandholi B.O": "341520",
      "Gedakallan B.O": "341520",
      "Nandoli Mertiyan B.O": "341520",
      "Dabariya B.O": "341502",
      "Jiwadiya B.O": "341502",
      "Kalwa B.O": "341502",
      "Manana B.O": "341502",
      "Modicharana B.O": "341502",
      "Soneli B.O": "341022",
      "Alatawa B.O": "341504",
      "Bhiyankallan B.O": "341504",
      "Kheriseela B.O": "341504",
      "Nundara B.O": "341504",
      "Dangawas B.O": "341510",
      "Gagrana B.O": "341510",
      "Gawardi B.O": "341510",
      "Indawar B.O": "341510",
      "Kanwariyat B.O": "341510",
      "Satlas B.O": "341510",
      "Ratrana B.O": "305026",
      "Sudwar B.O": "341031",
      "Tehla B.O": "341031",
      "Bhadasiya B.O": "341512",
      "Bhakhari B.O": "341512",
      "Lambajatan B.O": "341510",
      "Lampolai B.O": "341510",
      "Mokala B.O": "341510",
      "Morra B.O": "341510",
      "Bhikarniyakallan B.O": "341031",
      "Dhanipura B.O": "305026",
      "Mewara B.O": "341031",
      "Banwal B.O": "341512",
      "Bassi B.O": "341512",
      "Khakharki B.O": "341510",
      "Khanpur B.O": "341512",
      "Kinsariya B.O": "341512",
      "Peeplad B.O": "341512",
      "Rabariyad B.O": "341512",
      "Rohindi B.O": "341512",
      "Taparwara B.O": "341512",
      "Rohisa B.O": "341513",
      "Sensara B.O": "341513",
      "Pipasar B.O": "341029",
      "Sewari B.O": "341029",
      "Ghatwa B.O": "341508",
      "Jhalara B.O": "341512",
      "Jal R.S. B.O": "341514",
      "Jalsu Nanak B.O": "341514",
      "Nimbolakallan B.O": "341514",
      "Alaniyawas B.O": "341513",
      "Bijathal B.O": "341513",
      "Didiyakallan B.O": "341027",
      "Gagwana B.O": "341027",
      "Khanwar B.O": "341027",
      "Manglod B.O": "341027",
      "Merwas B.O": "341030",
      "Pharrod B.O": "341030",
      "Rohina B.O": "341030",
      "Sandila B.O": "341030",
      "Dhandhalas B.O": "341510",
      "Kurdayan B.O": "341510",
      "Mugadara B.O": "341510",
      "Sarnawara B.O": "341504",
      "Asawari B.O": "342902",
      "Dugoli B.O": "341023",
      "Gudha Jodhan B.O": "341023",
      "Gugaryali B.O": "341023",
      "Jochina B.O": "341023",
      "Badayali B.O": "341518",
      "Bhatnokha B.O": "341028",
      "Sankhawas B.O": "341028",
      "Sheelgaon B.O": "341028",
      "Bairathal B.O": "341025",
      "Bhanwanda B.O": "341025",
      "Kantiya B.O": "341025",
      "Madpura B.O": "341025",
      "Manakpura B.O": "341025",
      "Nagari B.O": "341025",
      "Narwakallan B.O": "341025",
      "Dhaneriya B.O": "341510",
      "Ganthiya B.O": "341510",
      "Kalru B.O": "341510",
      "Katyasani B.O": "341510",
      "Netariya B.O": "341510",
      "Rasaliyawas B.O": "341510",
      "Badighati B.O": "305026",
      "Nimbola Bishwa B.O": "305026",
      "Sathana B.O": "341031",
      "Bagot B.O": "341512",
      "Chitai B.O": "341512",
      "Mayapur B.O": "341512",
      "Banwarala B.O": "341514",
      "Butati B.O": "341514",
      "Jalsukallan B.O": "341514",
      "Rajod B.O": "341023",
      "Jatawas B.O": "341513",
      "Kod B.O": "341513",
      "Bugarda B.O": "341027",
      "Ratanga B.O": "341027",
      "Dehari B.O": "341030",
      "Ubasi B.O": "341030",
      "Basni Sejan B.O": "342902",
      "Diyawari B.O": "342902",
      "Toonkaliyan B.O": "342902",
      "Bidiad B.O": "341542",
      "Chhajoli B.O": "341023",
      "Rotoo B.O": "341023",
      "Ladawa B.O": "341518",
      "Bhadora B.O": "341028",
      "Dhadhariyakallan B.O": "341028",
      "Mori B.O": "341028",
      "Mundiyar B.O": "341028",
      "Birloka B.O": "341025",
      "Kurchi B.O": "341025",
      "Akeli b B.O": "341024",
      "Bachhwari B.O": "341024",
      "Bursu B.O": "341505",
      "Gunawati B.O": "341505",
      "Manglana B.O": "341505",
      "Oladan B.O": "341511",
      "Bargaon B.O": "341510",
      "Bhuriyasani B.O": "341510",
      "Harsolav B.O": "342902",
      "Nokhachandawatan B.O": "342902",
      "Senani B.O": "342902",
      "Kathoti B.O": "341023",
      "Khinyala B.O": "341023",
      "Bhanwal B.O": "341518",
      "Jaswantabad B.O": "341518",
      "Gawalu B.O": "341028",
      "Gowankallan B.O": "341028",
      "Roon B.O": "341028",
      "Achina B.O": "341025",
      "Akala Hamiran B.O": "341025",
      "Panchlasidha B.O": "341025",
      "Tadas B.O": "341025",
      "Borwa B.O": "341024",
      "Chhawata Khurd B.O": "341024",
      "Gajoo B.O": "341024",
      "Geloli B.O": "341024",
      "Kasnau B.O": "341024",
      "Barwali B.O": "341505",
      "Datani B.O": "341511",
      "Dhadhwara B.O": "341511",
      "Dhawa B.O": "341511",
      "Jaroda B.O": "341511",
      "Kheduli B.O": "341511",
      "Akeli a B.O": "341510",
      "Arniyala B.O": "341510",
      "Baggar B.O": "341510",
      "Lunsara B.O": "341024",
      "Nimbrichandawatan B.O": "341024",
      "Dildhani B.O": "341505",
      "Jusari B.O": "341505",
      "Kukrod B.O": "341505",
      "Inana B.O": "341026",
      "Jhujhanda B.O": "341026",
      "Karlu B.O": "341026",
      "Thirod B.O": "341026",
      "Chundiya B.O": "341510",
      "Dhanapa B.O": "342902",
      "Talanpur B.O": "342902",
      "Billoo B.O": "341542",
      "Morer B.O": "341542",
      "Dugastau B.O": "341023",
      "Silanwad B.O": "341023",
      "Liliya B.O": "341518",
      "Medas B.O": "341518",
      "Janana B.O": "341028",
      "Palrijodhan B.O": "341028",
      "Khatora B.O": "341025",
      "Arwar B.O": "341024",
      "Chholukhan B.O": "341303",
      "Firwasi B.O": "341303",
      "Dhyawa B.O": "341303",
      "Girroda Mitha B.O": "341303",
      "Phogari B.O": "341303",
      "Ramsabas B.O": "341303",
      "Lachhari B.O": "341303",
      "Sanwarad B.O": "341303",
      "Singrawatkallan B.O": "341303",
      "Modiawat B.O": "341551",
      "Nuwa B.O": "341551",
      "Badabara B.O": "341302",
      "Bajoli B.O": "341503",
      "Bamana B.O": "341503",
      "Dugorachala B.O": "341503",
      "Idwa B.O": "341503",
      "Jaola B.O": "341503",
      "Kherwa B.O": "341503",
      "Peelwa B.O": "341503",
      "Poonlota B.O": "341503",
      "Rajlota B.O": "341503",
      "Marwarbalia B.O": "341303",
      "Reengan B.O": "341303",
      "Supaka B.O": "341303",
      "Barangana B.O": "341303",
      "Singhana B.O": "341303",
      "Chuwa B.O": "341301",
      "Jakhara B.O": "341301",
      "Kasari B.O": "341301",
      "Kiro R.S. B.O": "341301",
      "Ganeshpura B.O": "341551",
      "Khariya B.O": "341551",
      "Kyamsar B.O": "341551",
      "Chandaroon B.O": "341503",
      "Degana Village B.O": "341503",
      "Dotina B.O": "341503",
      "Langod B.O": "341503",
      "Mandaljodhan B.O": "341503",
      "Midiyan B.O": "341503",
      "Mithariya B.O": "341503",
      "Morikhurd B.O": "341503",
      "Netiyas B.O": "341503",
      "Peeh B.O": "341503",
      "Ramsari B.O": "341503",
      "Bhaola B.O": "341024",
      "Gothara B.O": "341024",
      "Barwala B.O": "341505",
      "Bharnai B.O": "341505",
      "Chhapri B.O": "341511",
      "Jogimagara B.O": "341511",
      "Kupras B.O": "341511",
      "Beetan B.O": "341510",
      "Chawandiyakallan B.O": "341510",
      "Ambapa B.O": "341303",
      "Dayalpura B.O": "341303",
      "Mithri B.O": "341303",
      "Sardi B.O": "341303",
      "Khinwaj B.O": "341303",
      "Mawa B.O": "341303",
      "Sewa B.O": "341303",
      "Khatiyabasani B.O": "341303",
      "Raidhana B.O": "341303",
      "Manjhi B.O": "341301",
      "Bardawa B.O": "341551",
      "Sardarpura Khurd B.O": "341551",
      "Pawa B.O": "341302",
      "Ranigaon B.O": "341302",
      "Bajwas B.O": "341503",
      "Barana B.O": "341503",
      "Kitalsar B.O": "341503",
      "Kurdada B.O": "341503",
      "Paliyas B.O": "341503",
      "Ajawa B.O": "341303",
      "Chhotichhapri B.O": "341303",
      "Nimbikhurd B.O": "341303",
      "Barichhapri B.O": "341303",
      "Kalwani B.O": "341303",
      "Lalsari B.O": "341303",
      "Rajapura B.O": "341301",
      "Barikallan B.O": "341551",
      "Dindarpura B.O": "341551",
      "Payali B.O": "341551",
      "Sudarasan B.O": "341551",
      "Serani Ki Dhani B.O": "341302",
      "Binthwaliya B.O": "341503",
      "Chosali B.O": "341503",
      "Khurikallan B.O": "341503",
      "Kundari B.O": "341503",
      "Nimbrikallan B.O": "341503",
      "Palrikallan B.O": "341503",
      "Pundlu B.O": "341510",
      "Bherunda B.O": "341031",
      "Dodiyana B.O": "341031",
      "Nathawara B.O": "341031",
      "Padukhurd B.O": "341031",
      "Bansed B.O": "341512",
      "Dhadhota B.O": "341512",
      "Gangawa B.O": "341512",
      "Khokhar B.O": "341512",
      "Neniya B.O": "341512",
      "Antroli Khurd B.O": "341514",
      "Choliyas B.O": "341514",
      "Khinyas B.O": "341514",
      "Punas B.O": "341514",
      "Sirasana B.O": "341514",
      "Jhintiya B.O": "341513",
      "Ladpura B.O": "341513",
      "Surjaniyawas B.O": "341027",
      "Chiloo B.O": "341029",
      "Didwana H.O": "341303",
      "Nagaur H.O": "341001",
      "Degana S.O": "341503",
      "Koliya S.O": "341305",
      "Ladnun Lsg S.O": "341306",
      "Maulasar S.O": "341506",
      "Bansiwala Temple S.O": "341001",
      "Besroli S.O": "341520",
      "Jael S.O": "341023",
      "Khajwana S.O": "341028",
      "Khinwsar S.O": "341025",
      "Kuchera S.O (Nagaur)": "341024",
      "Merta Road S.O": "341511",
      "Merta S.O": "341510",
      "Nagaurcity S.O": "341001",
      "Parbatsar S.O": "341512",
      "Bari Khatu S.O": "341301",
      "Chhotikhatu S.O": "341302",
      "D.M.Didwana S.O": "341303",
      "Dhankoli S.O": "341516",
      "I.A.Nawacity S.O": "341509",
      "Khunkhuna S.O": "341318",
      "Mithri S.O": "341533",
      "Ratau S.O": "341317",
      "Station Road Didwana S.O": "341303",
      "Badu S.O (Nagaur)": "341501",
      "Basni S.O": "341021",
      "Gotan S.O": "342902",
      "Makrana S.B. S.O": "341505",
      "Riyan S.O": "341513",
      "Rol S.O": "341027",
      "Tarnau S.O": "341030",
      "Makrana S.O": "341505",
      "Berichhoti S.O": "341551",
      "Kuchamancity S.O": "341508",
      "Ladariya S.O": "341517",
      "Ladnuncity S.O": "341306",
      "Maroth S.O": "341507",
      "Nimbijodhan S.O": "341316",
      "Pahelipatti Ladnun S.O": "341306",
      "Rahugate Ladnun S.O": "341306",
      "S.R. Kuchamancity S.O": "341508",
      "Toshina S.O": "341319",
      "Borawar S.O": "341502",
      "Gachhipura S.O": "341504",
      "I.A.Bidiad S.O": "341542",
      "Jasnagar S.O": "341518",
      "Makrana Rs S.O": "341505",
      "Marwar Mundwa S.O": "341026",
      "Sribalaji S.O": "341029",
      "PANCHORI S.O.": "341020",
      "Harsore S.O": "341515",
      "Jaswantgarh S.O": "341304",
      "Kukanwali S.O": "341519",
      "Nawacity Lsg S.O": "341509",
      "Deh S.O": "341022",
      "Kum Merta S.O": "341510",
      "Merta City S.O": "341510",
      "Padukallan S.O": "341031",
      "Ren S.O": "341514",
      "Thanwala S.O": "305026"
    },
    "DAUSA": {
      "Thikriya BO": "303509",
      "Kaluwas BO": "303505",
      "Malwas BO": "303505",
      "Manpura BO": "303505",
      "Khawaraoji BO": "303506",
      "Mundghisya BO": "303313",
      "Shyalawas Kalan BO": "303506",
      "Thumdi BO": "303506",
      "Amrabad BO": "303510",
      "Beechha BO": "303510",
      "Bidarkhan BO": "303510",
      "Churiawas BO": "303505",
      "Rahuwas BO": "303505",
      "Gahnoli BO": "321612",
      "Gazipura BO": "321612",
      "Palanheda BO": "321612",
      "Santha BO": "321612",
      "Unkroond BO": "321613",
      "Khuntla BO": "303326",
      "Peechupara Kalan BO": "303326",
      "Heengwa BO": "303508",
      "Hemlyawala BO": "303302",
      "Mahadeopura BO": "303302",
      "Karangarh": "303302",
      "Madhogarh": "303302",
      "Udaipuria BO": "303509",
      "Kallawas BO": "303505",
      "Koliwara BO": "303505",
      "Palunda BO": "303505",
      "Hapawas BO": "303506",
      "Shyampura Kalan BO": "303510",
      "Dholkhera BO": "321613",
      "Bishanpura BO": "303507",
      "Neemla BO": "303507",
      "Bawanpara BO": "303326",
      "Brahman Bairada BO": "303326",
      "Kalwan BO": "303508",
      "Namner BO": "303508",
      "Bas Badwa BO": "303302",
      "Garh BO": "303302",
      "Chharda BO": "303505",
      "Dob BO": "303505",
      "Jaun BO": "303506",
      "Barkhera BO": "321613",
      "Pakhar BO": "321613",
      "Bapi BO": "303507",
      "Chhokarwada BO": "303326",
      "Kuti Mariyada BO": "303326",
      "Kundera Doongar BO": "303508",
      "Anantpura BO": "303302",
      "Danau Kalan BO": "303302",
      "Gangliawas BO": "303510",
      "Boroda BO": "303507",
      "Kableshwar BO": "303507",
      "Khuri Kalan BO": "303507",
      "Nabhawala BO": "303507",
      "Udawala BO": "303507",
      "Abhaneri BO": "303326",
      "Bhandari BO": "303326",
      "Patoli BO": "321610",
      "Hingotia BO": "303303",
      "Jirota Khurd BO": "303303",
      "Kherwal BO": "303303",
      "Chandrana BO": "303303",
      "Baniyana BO": "303303",
      "Jasota BO": "303303",
      "Mahesara Kalan BO": "303303",
      "Nangal Bairsi BO": "303303",
      "Surajpura BO": "303303",
      "Kolana BO": "303313",
      "Liloj BO": "303313",
      "Nandera BO": "303313",
      "Panditpura BO": "303313",
      "Peechupada Khurd BO": "303313",
      "Shyalawas Khurd BO": "303313",
      "Ananantwada BO": "303313",
      "Badial Kalan BO": "303313",
      "Bhandeda BO": "303313",
      "Unbadagaon BO": "303313",
      "Dwarapura BO": "303313",
      "Khedi": "303305",
      "Sodala B.O": "303313",
      "Malarna BO": "303303",
      "Bhandana BO": "303303",
      "Bhankari BO": "303303",
      "Bada Gaon BO": "322240",
      "Arniya BO": "303313",
      "Bandikui Jagir BO": "303313",
      "Delari BO": "303313",
      "Ralawata BO": "303501",
      "Maheshara Khurd BO": "303303",
      "Chawandeda BO": "303303",
      "Alooda BO": "303303",
      "Ladi Ka Bas BO": "303303",
      "Badiyal Khurd BO": "303313",
      "Pratappura BO": "303313",
      "Shalawas Kalan BO": "303313",
      "Mahukhera BO": "303315",
      "Nihalpura BO": "303315",
      "Sudharanpada BO": "303315",
      "Kalakho Ambadi BO": "303501",
      "Balahera BO": "303315",
      "Dhigaria Bhim BO": "303315",
      "Gudha Ashikpura BO": "303315",
      "Farrashpura BO": "303501",
      "Gothra BO": "303501",
      "Jhanpdawas BO": "303501",
      "Shekhpura BO": "303501",
      "Khatumbar BO": "303511",
      "Dhanawad BO": "303304",
      "Denda Basedi BO": "303502",
      "Gerota BO": "303502",
      "Chandera BO": "303509",
      "Koondla BO": "322240",
      "Badoli BO": "303325",
      "Bilona BO": "303503",
      "Chondiawas BO": "303503",
      "Kankariya BO": "303503",
      "Sanwasa BO": "303503",
      "Srimaa BO": "303503",
      "Patan BO": "303004",
      "Banawar BO": "321609",
      "Mandawar Singh BO": "321609",
      "Gagwana BO": "321608",
      "Salampura BO": "321608",
      "Samleti BO": "321608",
      "Binori BO": "303504",
      "Khurra BO": "303504",
      "Nandri BO": "303509",
      "Gullana BO": "303327",
      "Jhajhirampura BO": "303327",
      "Karnawar BO": "303327",
      "Shabdawali BO": "303327",
      "Aliapara BO": "303315",
      "Alipur BO": "303315",
      "Bejupada BO": "303315",
      "Behrawanda BO": "303501",
      "Gandarawa BO": "303501",
      "MOCHINGPURA": "303501",
      "Salempura BO": "303511",
      "Dolika BO": "303304",
      "Kalakho Sadak BO": "303304",
      "Gangadwadi BO": "303502",
      "Nahira BO": "322240",
      "Salempura Chowki BO": "322240",
      "Talchidi BO": "322240",
      "Bagdi BO": "303503",
      "Khatwa BO": "303503",
      "Lalpura BO": "303503",
      "Mirjapura BO": "303503",
      "Nirjharna BO": "303503",
      "Khanwas BO": "303004",
      "Tudiyana BO": "321608",
      "Vishala BO": "321608",
      "Lotwara BO": "303509",
      "Pancholi BO": "303509",
      "Peepalki BO": "303509",
      "Lanka BO": "303501",
      "Digo BO": "303511",
      "Dungarpur BO": "303511",
      "Nizampura BO": "303511",
      "Rajoli BO": "303511",
      "Kelai BO": "303304",
      "Peelwa Kalan BO": "303304",
      "Achalpura BO": "303502",
      "Aund Meena BO": "322240",
      "Gadarwada Gujran BO": "303325",
      "Kali Pahadi BO": "303325",
      "Kalota BO": "303325",
      "Sindoli BO": "303325",
      "Deoli BO": "303503",
      "Hodayali BO": "303503",
      "Jhapada BO": "303503",
      "Kalyanpura BO": "303503",
      "Talab Gaon BO": "303503",
      "Thuni Dhirajpura BO": "303503",
      "Bhurla BO": "303004",
      "Dhigariya BO": "303004",
      "Golada BO": "303315",
      "Hingota BO": "303315",
      "Gumanpura BO": "303501",
      "Jopada BO": "303501",
      "Ranoli BO": "303501",
      "Torda BO": "303501",
      "Dugrawata BO": "303004",
      "Garh Himmat Singh BO": "321609",
      "Haildena BO": "321609",
      "Kot BO": "321609",
      "Norangwada BO": "321608",
      "Pali BO": "321608",
      "Ramgarh BO": "321608",
      "Mahariya BO": "303504",
      "Suratpura BO": "303504",
      "Toda Thekla BO": "303504",
      "Indawa BO": "303511",
      "Bane Ka Barkhera BO": "303304",
      "Reta BO": "303304",
      "Ghumna BO": "303502",
      "Ancheri BO": "303323",
      "Muhi BO": "303323",
      "Bada Bujurg BO": "322240",
      "Dhand BO": "322240",
      "Bahnwatabhanwati BO": "303325",
      "Gudhliya BO": "303325",
      "Kolwa Gram BO": "303325",
      "Titarwada Kalan BO": "303325",
      "Chandsen BO": "303503",
      "Daulatpura BO": "303503",
      "Shivsinghpura BO": "303503",
      "Sumel BO": "303503",
      "Bhateri BO": "303004",
      "Rajwas BO": "303004",
      "Jatwara BO": "321609",
      "Reendali BO": "321609",
      "Balahedi BO": "321608",
      "Hurla BO": "321608",
      "Khonchpuri BO": "321608",
      "Rontehdiya BO": "321608",
      "Kherla Khurd BO": "303504",
      "Kishorpura BO": "303504",
      "Karodi BO": "303509",
      "Pundarpada BO": "303509",
      "Bandikui SO": "303313",
      "Bhandarej SO": "303501",
      "Dausa Town SO": "303303",
      "Dubbi SO": "303304",
      "Mahwa Road SO": "321609",
      "Manpur SO Dausa": "303509",
      "Baswa SO Dausa": "303327",
      "Geejgarh SO": "303502",
      "Mahwa SO": "321608",
      "Paota Dausa SO": "321612",
      "Rasidpur SO": "321613",
      "Sainthal SO": "303507",
      "Sikandra SO Dausa": "303326",
      "Sikrai SO": "303508",
      "Bandikui Mandi SO": "303313",
      "Bewai SO": "303315",
      "Didwana SO": "303511",
      "Gudha Katla SO": "303323",
      "Kundal SO Dausa": "303325",
      "Mandawari SO": "303504",
      "Nangal Rajawatan SO": "303505",
      "Toonga SO": "303302",
      "Dausa HO": "303303",
      "Collectorate Dausa SO": "303303",
      "Kherla SO": "322240",
      "Lalsot SO": "303503",
      "Lawain SO": "303004",
      "Paparda SO": "303506",
      "Ramgarh Pachwara SO": "303510"
    },
    "BANSWARA": {
      "Paloda B.O": "327605",
      "Andheshwar B.O": "327602",
      "Dungra Chhota B.O": "327602",
      "Jalampura B.O": "327602",
      "Khundni Rupa B.O": "327602",
      "Tanda Mangla B.O": "327602",
      "Badi Saredi B.O": "327025",
      "Kheda B.O": "327025",
      "Kushalpura B.O": "327025",
      "Sundanpur B.O": "327025",
      "Kherdabada B.O": "327026",
      "Sagwadiya B.O": "327025",
      "Badgun B.O": "327026",
      "Dungra Kalan B.O": "327602",
      "Godawara Nareng B.O": "327602",
      "Thikariya B.O": "327001",
      "Bhungda B.O": "327026",
      "Cheev B.O": "327026",
      "Chaura Kalan B.O": "327602",
      "Kesharwadi B.O": "327602",
      "Machchar Para B.O": "327602",
      "Tambesara B.O": "327602",
      "Tandi Kalan B.O": "327602",
      "Masotiya B.O": "327025",
      "Himmatgarh B.O": "327602",
      "Itala B.O": "327602",
      "Magarda Bada B.O": "327602",
      "Mahudi Maska B.O": "327602",
      "Rath Dhanraj B.O": "327602",
      "Rohaniya Laxman Singh B.O": "327602",
      "Bachadiya B.O": "327025",
      "Bhimsore B.O": "327025",
      "Gamdi B.O": "327025",
      "Kunwala B.O": "327025",
      "Sakaria B.O": "327025",
      "Saredi Chhoti B.O": "327025",
      "Vajwanaia B.O": "327025",
      "Bodigama B.O": "327603",
      "Chokhala B.O": "327604",
      "Karji B.O": "327604",
      "Balawara B.O": "327603",
      "Bansala B.O": "327603",
      "Buda Bassi B.O": "327021",
      "Dukawara B.O": "327021",
      "Karanpur B.O": "327021",
      "Agarpura B.O": "327022",
      "Umbada B.O": "327022",
      "Kanji Ka Gara B.O": "327023",
      "Sanawasa B.O": "327023",
      "Naugama B.O": "327603",
      "Odwara B.O": "327034",
      "Panasi Chhoti B.O": "327034",
      "Kanthao B.O": "327027",
      "Miyasa B.O": "327027",
      "Narwali B.O": "327027",
      "Badi Sarwa B.O": "327801",
      "Badli Pada B.O": "327801",
      "Badwasa B.O": "327801",
      "Kotra Ranga B.O": "327801",
      "Timbada B.O": "327801",
      "Rohanwari B.O": "327601",
      "Pali Kalan B.O": "327604",
      "Samaria B.O": "327604",
      "Amar singh Ka Garha B.O": "327021",
      "Asan B.O": "327021",
      "Bamanparda B.O": "327021",
      "Chopasang B.O": "327022",
      "Daduka B.O": "327022",
      "Jharas B.O": "327022",
      "Kheran Ka Parda B.O": "327022",
      "Khodan B.O": "327022",
      "Malana B.O": "327022",
      "Badana B.O": "327023",
      "Delwara Lokiya B.O": "327023",
      "Doodka B.O": "327023",
      "Padal Chhoti B.O": "327023",
      "Padoli Rathor B.O": "327023",
      "Ador B.O": "327034",
      "Amja B.O": "327034",
      "Nagawara B.O": "327606",
      "Peeplod B.O": "327606",
      "Rakho B.O": "327606",
      "Borpi Khera B.O": "327027",
      "Sarodia B.O": "327027",
      "Kushalapada B.O": "327801",
      "Loharia B.O": "327801",
      "Ramgarh B.O": "327801",
      "Sabalpur B.O": "327801",
      "Akhebhanji Ka Gara B.O": "327605",
      "Sallopat B.O": "327601",
      "Shergarh B.O": "327601",
      "Udaipura B.O": "327601",
      "Budwa B.O": "327604",
      "Saliya B.O": "327604",
      "Bhoyar B.O": "327021",
      "Borda B.O": "327021",
      "Mota Goan B.O": "327021",
      "Berwa B.O": "327022",
      "Bori B.O": "327022",
      "Mor B.O": "327022",
      "Samagarha B.O": "327022",
      "Jharkaniya B.O": "327023",
      "Padal Badi B.O": "327023",
      "Runjia B.O": "327023",
      "Gopinath Ka Garha B.O": "327034",
      "Nahali B.O": "327034",
      "Paraheda B.O": "327034",
      "Raiyana B.O": "327034",
      "Lilwani B.O": "327606",
      "Sagwa B.O": "327606",
      "Dagal B.O": "327027",
      "Dungar B.O": "327027",
      "Mudasal B.O": "327027",
      "Charkani B.O": "327801",
      "Dhumath B.O": "327801",
      "Jhikali B.O": "327801",
      "Mundri B.O": "327031",
      "Padikalan B.O": "327801",
      "Salia B.O": "327601",
      "Sangariya B.O": "327601",
      "Ummadgarhi B.O": "327601",
      "Limthan B.O": "327604",
      "Sagrod B.O": "327604",
      "Surwania B.O": "327604",
      "Patan B.O": "327801",
      "Bhimpur B.O": "327021",
      "Bhuwasa B.O": "327021",
      "Mota Tanda B.O": "327021",
      "Asoda B.O": "327022",
      "Bhagora B.O": "327022",
      "Matwala B.O": "327022",
      "Naya Goan B.O": "327022",
      "Amarthun B.O": "327023",
      "Devda B.O": "327023",
      "Jagpura B.O": "327023",
      "Padoli Gordhan B.O": "327023",
      "Bhatar B.O": "327034",
      "Madlada B.O": "327034",
      "Pindarama B.O": "327034",
      "Tamtiya Rathor B.O": "327034",
      "Biladi B.O": "327606",
      "Mahudi B.O": "327606",
      "Suwala B.O": "327606",
      "Dungariya B.O": "327027",
      "Kherwa B.O": "327027",
      "Rupji Ka Kheda B.O": "327027",
      "Bassi B.O": "327801",
      "Chhoti Sarwa B.O": "327801",
      "Kalinjara B.O": "327801",
      "Mokampura B.O": "327001",
      "Unkala B.O": "327801",
      "Lasada B.O": "327605",
      "Jhupel B.O": "327001",
      "Khajuri B.O": "327001",
      "Tajpur B.O": "327001",
      "Godi Tajpur B.O": "327001",
      "Fefar B.O": "327001",
      "Khandu B.O": "327001",
      "Kundal B.O": "327001",
      "Rohida B.O": "327001",
      "Upla Ghantala B.O": "327001",
      "Badgoan B.O": "327001",
      "Badliya B.O": "327031",
      "Kotra B.O": "327001",
      "Mordi Nichali B.O": "327001",
      "Panchalwasa B.O": "327001",
      "Badrel Khurd B.O": "327001",
      "Boriya B.O": "327001",
      "Kaserpura B.O": "327001",
      "Chandwara B.O": "327031",
      "Cheekli Teja B.O": "327031",
      "Chhaja B.O": "327031",
      "Phalwa B.O": "327031",
      "Sundrao B.O": "327031",
      "Ajna B.O": "327032",
      "Bassi Badi B.O": "327032",
      "Dana Khari B.O": "327001",
      "Bor Khaber B.O": "327001",
      "Bhapor B.O": "327001",
      "Kupda B.O": "327001",
      "Nichala Ghantala B.O": "327001",
      "Galkiya B.O": "327001",
      "Singhpura B.O": "327001",
      "Barjodia B.O": "327031",
      "Madkola B.O": "327031",
      "Naharpura B.O": "327031",
      "Biloda B.O": "327032",
      "Chordi B.O": "327601",
      "Dhalar B.O": "327601",
      "Gangad Talai B.O": "327601",
      "Handi B.O": "327601",
      "Jher Moti B.O": "327601",
      "Panchawara B.O": "327032",
      "Saranpur B.O": "327032",
      "Borwat B.O": "327001",
      "Kalakhet B.O": "327001",
      "Lodha B.O": "327001",
      "Katumbi B.O": "327001",
      "Nalda B.O": "327001",
      "Chanduji Ka Gara B.O": "327001",
      "Surpur B.O": "327001",
      "Sevna B.O": "327001",
      "Jahapura B.O": "327001",
      "Maheshpura B.O": "327001",
      "Napla B.O": "327001",
      "Dokar B.O": "327031",
      "Kajelia B.O": "327031",
      "Minapadar B.O": "327031",
      "Tamtiya B.O": "327001",
      "Vakhatpura B.O": "327032",
      "Moti Timbi B.O": "327601",
      "Ram ka Munna B.O": "327601",
      "Rohaniya B.O": "327601",
      "Kesharpura B.O": "327032",
      "Nawadhara B.O": "327032",
      "Jhanjharwa B.O": "327601",
      "Khodalim B.O": "327601",
      "Khunta Galia B.O": "327601",
      "Bari B.O": "327001",
      "Chriyawasa B.O": "327001",
      "Danpur B.O": "327001",
      "Navagoan B.O": "327001",
      "Kundla Kalan B.O": "327001",
      "Kheda Khas B.O": "327001",
      "Sundni B.O": "327001",
      "Chacha Kota B.O": "327001",
      "Kuwania B.O": "327001",
      "Chhoti Sarwan B.O": "327001",
      "Harnathpura B.O": "327001",
      "Palaswani B.O": "327001",
      "Ambalia B.O": "327031",
      "Bareth B.O": "327031",
      "Obla B.O": "327031",
      "Kotada B.O": "327032",
      "Paderi B.O": "327032",
      "Bhaler Bhodar B.O": "327601",
      "Jambudi B.O": "327601",
      "Lankai B.O": "327601",
      "Banswara H.O": "327001",
      "Banswara Prathvi Ganj S.O": "327001",
      "Chhinch S.O": "327603",
      "Kushal Garh Bazar S.O": "327801",
      "Ghatol S.O": "327023",
      "Kalinjara S.O": "327606",
      "Luharia S.O": "327605",
      "Sajjan Garh S.O": "327602",
      "Banswara Ind. Area S.O": "327001",
      "Talwara S.O": "327025",
      "Anandpuri S.O (Banswara)": "327031",
      "Arthuna S.O": "327032",
      "Bagidora S.O": "327601",
      "Banswara City S.O": "327001",
      "Banswara Mahi Colony S.O": "327001",
      "Barodia S.O": "327604",
      "Ganoda S.O": "327021",
      "Garhi S.O (Banswara)": "327022",
      "Jolana S.O": "327034",
      "Khamera S.O": "327027",
      "Kushalgarh S.O": "327801",
      "Mahidam S.O": "327026",
      "Partapur S.O": "327024"
    },
    "CHURU": {
      "Sarayan B.O": "331304",
      "Seowa B.O": "331304",
      "Hamusar B.O": "331022",
      "Sangasar B.O": "331022",
      "Loha B.O": "331022",
      "Melusar B.O": "331304",
      "Bachharara Bara B.O": "331022",
      "Charanwasi B.O": "331022",
      "Jandwa B.O": "331022",
      "Sahanali Bari B.O": "331022",
      "Dariba B.O": "331501",
      "Dewani B.O": "331502",
      "Deepsar B.O": "331022",
      "Tidiasar B.O": "331022",
      "Gorisar B.O": "331022",
      "Bhanuda B.O": "331022",
      "Daudsar B.O": "331022",
      "Ladhasar B.O": "331022",
      "Thathawata B.O": "331022",
      "Pabusar B.O": "331022",
      "Payali B.O": "331022",
      "Ranasar Bikan B.O": "331504",
      "Bhasina B.O": "331518",
      "Sarothia B.O": "331518",
      "Absar B.O": "331505",
      "Bhojasar B.O": "331411",
      "Harasar B.O": "331505",
      "Abadsar B.O": "331802",
      "Binadesar B.O": "331802",
      "Jegania B.O": "331802",
      "Lachharsar B.O": "331802",
      "Simsia B.O": "331802",
      "Charia B.O": "331506",
      "Kharia Kaniram B.O": "331506",
      "Norangsar B.O": "331506",
      "Shobhasar B.O": "331506",
      "Bamboo B.O": "331517",
      "Girwarsar B.O": "331517",
      "Kalyansar B.O": "331518",
      "Mundra B.O": "331518",
      "Ratnadesar B.O": "331505",
      "Alsar B.O": "331802",
      "Bandwa B.O": "331802",
      "Bharpalsar B.O": "331802",
      "Bhawandesar B.O": "331802",
      "Khinchiwala B.O": "331506",
      "Khuri B.O": "331506",
      "Murdakia B.O": "331506",
      "Amarsar B.O": "331517",
      "Bairasar B.O": "331517",
      "Guleria B.O": "331507",
      "Jindrasar B.O": "331507",
      "Kanuta B.O": "331507",
      "Kolasar B.O": "331507",
      "Sadu Bari B.O": "331517",
      "Udwala B.O": "331517",
      "Bobasar Bidawtan B.O": "331507",
      "Lodsar B.O": "331507",
      "Malsisar B.O": "331507",
      "Togawas B.O": "331304",
      "Bhukhredi B.O": "331022",
      "Khudera Charnan B.O": "331022",
      "Kusumdesar B.O": "331022",
      "Golsar B.O": "331022",
      "Jaleu B.O": "331022",
      "Noowan B.O": "331022",
      "Dunkar B.O": "331501",
      "Balera B.O": "331503",
      "Gopalpura B.O": "331503",
      "Ajeetsar B.O": "331504",
      "Asalsar B.O": "331504",
      "Kangar B.O": "331504",
      "Jeeli B.O": "331518",
      "Jogalsar B.O": "331518",
      "Rajiasar B.O": "331505",
      "Jetasar B.O": "331802",
      "Joglia B.O": "331802",
      "Loonasar B.O": "331802",
      "Parsneu B.O": "331802",
      "Bamania B.O": "331506",
      "Kanwari B.O": "331506",
      "Charla B.O": "331517",
      "Katar Chhoti B.O": "331517",
      "Luhara B.O": "331517",
      "Parewara B.O": "331517",
      "Reda B.O": "331517",
      "Redi Bhurawas B.O": "331304",
      "Dulrasar B.O": "331022",
      "Nosaria B.O": "331022",
      "Roopalisar B.O": "331022",
      "Lunchh B.O": "331022",
      "Ratansara B.O": "331022",
      "Hudera B.O": "331022",
      "Sehla B.O": "331022",
      "Gopalpuria B.O": "331022",
      "Khotari B.O": "331022",
      "Biramsar B.O": "331022",
      "Badsar B.O": "331518",
      "Bagsara B.O": "331518",
      "Parawa B.O": "331518",
      "Dhatri B.O": "331505",
      "Dhandheru Bhamuwan B.O": "331802",
      "Bhimsar B.O": "331506",
      "Mainasar B.O": "331506",
      "Nyama B.O": "331506",
      "Sandan B.O": "331506",
      "Sitsar B.O": "331506",
      "Inyara B.O": "331517",
      "Tehandesar B.O": "331517",
      "Utalad B.O": "331517",
      "Badabar B.O": "331507",
      "Magrasar B.O": "331507",
      "Bain B.O": "331304",
      "Gajuwas B.O": "331304",
      "Jharsar Kandhlan B.O": "331304",
      "Bhuchawas B.O": "331304",
      "Chalkoi Banirotan B.O": "331304",
      "Changoi B.O": "331304",
      "Dhana Bhakran B.O": "331304",
      "Dhani Asha B.O": "331304",
      "Dhani Kumharan B.O": "331304",
      "Pandreu Tal B.O": "331304",
      "Pandreu Tibba B.O": "331304",
      "Kotwad Tal B.O": "331304",
      "Anandsinghpura B.O": "331304",
      "Banara B.O": "331304",
      "Bhaleri B.O": "331304",
      "Jori B.O": "331304",
      "Kalwas B.O": "331304",
      "Kohina B.O": "331304",
      "Rajas B.O": "331304",
      "Ramsara Tal B.O": "331701",
      "Allayala B.O": "331304",
      "Bhalau Tal B.O": "331304",
      "Bhanin B.O": "331304",
      "Jigsana Tal B.O": "331304",
      "Jothran B.O": "331304",
      "Nethwa B.O": "331304",
      "Punras B.O": "331304",
      "Ranasar B.O": "331001",
      "Jharia B.O": "331001",
      "Karwasar B.O": "331001",
      "Dhadhar B.O": "331001",
      "Ghanghu B.O": "331001",
      "Ghantel B.O": "331001",
      "Rampura Bass B.O": "331001",
      "Kalwasia B.O": "331411",
      "Malkasar B.O": "331411",
      "Morthal B.O": "331029",
      "Rajpura B.O": "331029",
      "Satyun B.O": "331029",
      "Neema B.O": "331305",
      "Nuhand B.O": "331305",
      "Sardarpura B.O": "331305",
      "Thirpali Bari B.O": "331305",
      "Bhainsali B.O": "331301",
      "Bhojan B.O": "331301",
      "Kalari B.O": "331301",
      "Dhani Mozi B.O": "331023",
      "Pithisar B.O": "331001",
      "Dhirasar B.O": "331001",
      "Jasasar B.O": "331001",
      "Dandu B.O": "331001",
      "Lakhau B.O": "331001",
      "Barjangsar B.O": "331411",
      "Jaitsisar B.O": "331411",
      "Dudhwakha R.S. B.O": "331029",
      "Hadyal Village B.O": "331029",
      "Phogan B.O": "331402",
      "Sarsar B.O": "331402",
      "Udasar Bidawtan B.O": "331402",
      "Khairubari B.O": "331301",
      "Nawan B.O": "331301",
      "Depalsar B.O": "331021",
      "Meghsar B.O": "331302",
      "Bairasar Chhota B.O": "331023",
      "Bhagela B.O": "331023",
      "Chubakia Tal B.O": "331023",
      "Gulpura B.O": "331023",
      "Gwalisar B.O": "331023",
      "Dhigarla B.O": "331023",
      "Dhingi B.O": "331023",
      "Narwasi Village B.O": "331023",
      "Nyangal Chhoti B.O": "331023",
      "Paharsar B.O": "331023",
      "Ragha Chhoti B.O": "331023",
      "Suratpura B.O": "331023",
      "Somasisar B.O": "331302",
      "Baijwa B.O": "331303",
      "Janau Khari B.O": "331303",
      "Norangpura B.O": "331303",
      "Rawantsar Kunjla B.O": "331303",
      "Bhojasar Upadhiyan B.O": "331403",
      "Gajusar B.O": "331403",
      "Kalyanpura B.O": "331403",
      "Sawai Bari B.O": "331403",
      "Simla B.O": "331403",
      "Udsar B.O": "331403",
      "Dhanoti Chhoti B.O": "331701",
      "Lilaki B.O": "331023",
      "Thanmathoi B.O": "331023",
      "Gagarwas": "331023",
      "Punsisar B.O": "331302",
      "Raiyatunda B.O": "331302",
      "Sankhan Tal B.O": "331303",
      "Baila B.O": "331403",
      "Bandhnau B.O": "331403",
      "Bhadasar B.O": "331403",
      "Karansar B.O": "331403",
      "Khejara B.O": "331403",
      "Rajasar Bikan B.O": "331403",
      "Rangaisar B.O": "331403",
      "Ratusar B.O": "331403",
      "Binasar B.O": "331031",
      "Molisar B.O": "331031",
      "Raipuria B.O": "331031",
      "Dhanoti Kalan B.O": "331701",
      "Galar B.O": "331701",
      "Kanjan B.O": "331701",
      "Bhamasi B.O": "331001",
      "Somasi B.O": "331001",
      "Nakrasar B.O": "331001",
      "Dhadharia Charnan B.O": "331001",
      "Ramsara B.O": "331001",
      "Khansoli B.O": "331001",
      "Bukalsar Bara B.O": "331411",
      "Ransisar B.O": "331411",
      "Tolasar B.O": "331411",
      "Ladria B.O": "331029",
      "Lohsana Chhota B.O": "331029",
      "Sirsala B.O": "331029",
      "Bhamreed B.O": "331305",
      "Chand Gothi B.O": "331305",
      "Jaisinghsar B.O": "331402",
      "Biran B.O": "331301",
      "Bungi B.O": "331023",
      "Devipura B.O": "331023",
      "Dokwa B.O": "331023",
      "Gothya Bari B.O": "331023",
      "Hadyal R.S. B.O": "331023",
      "Jaitpura B.O": "331023",
      "Lambor Bari B.O": "331023",
      "Modawasi B.O": "331023",
      "Narwasi R.S. B.O": "331023",
      "Dhirwas B.O": "331302",
      "Kalana Tal B.O": "331303",
      "Lilawati B.O": "331303",
      "Bikamsara B.O": "331403",
      "Boghera B.O": "331403",
      "Mehari Rajviyan B.O": "331403",
      "Pichkai Tal B.O": "331403",
      "Sonpalsar B.O": "331403",
      "Bhimsana B.O": "331701",
      "Dhani Bari B.O": "331701",
      "Jasrasar B.O": "331001",
      "Khandwa B.O": "331001",
      "Sahjusar B.O": "331001",
      "Asalkheri B.O": "331001",
      "Buntia B.O": "331001",
      "Ginari Patta Lohasana B.O": "331001",
      "Khinwasar B.O": "331001",
      "Jaitasar B.O": "331411",
      "Malsar B.O": "331411",
      "Sadasar B.O": "331411",
      "Inderpura B.O": "331029",
      "Lohsana Bara B.O": "331029",
      "Sirsali B.O": "331029",
      "Binjawas B.O": "331305",
      "Harpalu Tal B.O": "331305",
      "Derajsar B.O": "331402",
      "Kaklasar B.O": "331402",
      "Bewar B.O": "331301",
      "Dhani D.S.Pura B.O": "331021",
      "Untawalia B.O": "331021",
      "Bhuwari B.O": "331023",
      "Chainpura Chhota B.O": "331023",
      "Dadrewa B.O": "331023",
      "Ghanau B.O": "331023",
      "Hansiyawas B.O": "331023",
      "Jharsar Chhota B.O": "331023",
      "Lakhlan B.O": "331023",
      "Laseri B.O": "331023",
      "Mahalana Utarada B.O": "331023",
      "Mundi Tal B.O": "331023",
      "Nyangal Bari B.O": "331023",
      "Bharang B.O": "331302",
      "Mehrasar Uppadhiyan B.O": "331302",
      "Jaswantpura B.O": "331303",
      "Nesal B.O": "331303",
      "Sulkhania B.O": "331303",
      "Adsisar B.O": "331403",
      "Aspalsar Bara B.O": "331403",
      "Billu Bass Rampura B.O": "331403",
      "Dhani Pachera B.O": "331403",
      "Mehrasar Chachera B.O": "331403",
      "Patlisar Bara B.O": "331403",
      "Ramsisar B.O": "331403",
      "Birami Khalsa B.O": "331701",
      "Malwas B.O": "331701",
      "Churu H.O": "331001",
      "Ratangarh H.O": "331022",
      "B.S.Road Churu S.O": "331001",
      "Churu City S.O": "331001",
      "Dudhwakhara S.O": "331029",
      "Ghantaghar Churu S.O": "331001",
      "Hamirwas S.O": "331305",
      "Pulasar S.O": "331402",
      "Sankhu Fort S.O": "331303",
      "Bidasar S.O": "331501",
      "Chhapar S.O": "331502",
      "Rampura Beri S.O": "331301",
      "Satra S.O": "331031",
      "Charwas S.O": "331503",
      "Parihara S.O (Churu)": "331505",
      "Rajaldesar S.O": "331802",
      "Gogasar S.O": "331504",
      "Lalgarh S.O (Churu)": "331518",
      "Naya Bass Sujangarh S.O": "331507",
      "Power House Ratangarh S.O": "331022",
      "Bhanipura S.O": "331411",
      "Patel Chowk Sadulpur S.O": "331023",
      "Ratan Nagar S.O": "331021",
      "Sadulpur City S.O": "331023",
      "Sadulpur S.O": "331023",
      "Sidhmukh S.O": "331701",
      "Station Road Churu S.O": "331001",
      "G.G.Sujangarh S.O": "331507",
      "Churu Collectorate S.O": "331001",
      "Gvm Sardarshahr S.O": "331403",
      "Moti Chowk Sardarshahr S.O": "331403",
      "Sabji Mandi Sardarshahar S.O": "331403",
      "Sahwa S.O": "331302",
      "Sardarshahar S.O": "331403",
      "Taranagar Bazar S.O": "331304",
      "Taranagar S.O": "331304",
      "E.G.Ratangarh S.O": "331022",
      "Rajaldesar Bazar S.O": "331802",
      "Ratangarh RS S.O": "331022",
      "Salasar S.O": "331506",
      "Sandwa S.O": "331517",
      "Sujangarh RS S.O": "331507",
      "Sujangarh S.O": "331507"
    },
    "SIROHI": {
      "Utraj B.O": "307501",
      "Dattani B.O": "307026",
      "Derri B.O": "307026",
      "Jayadara B.O": "307032",
      "Santpur B.O": "307026",
      "Uplagarh B.O": "307032",
      "Malgaon B.O": "307511",
      "Sanwara B.O": "307022",
      "Sirodi B.O": "307511",
      "Thandi Beri B.O.": "307031",
      "Dhan B.O": "307512",
      "Sanpur B.O": "307512",
      "Gol B.O": "307801",
      "Lass B.O": "307801",
      "Manora B.O": "307801",
      "Basantgarh B.O": "307019",
      "Madia B.O": "307802",
      "Sorda B.O": "307513",
      "Awal B.O": "307026",
      "Channar B.O": "307026",
      "Dhavli B.O": "307026",
      "Delwara B.O": "307501",
      "Chandela B.O": "307026",
      "Chandrawati B.O": "307026",
      "Kyariya B.O": "307026",
      "Makawal B.O": "307026",
      "Mawal B.O": "307026",
      "Morthala B.O": "307026",
      "Nichalagarh B.O": "307032",
      "Ore B.O": "307026",
      "Dak B.O": "307511",
      "Gulabganj B.O": "307511",
      "Amli B.O": "307031",
      "Amlari B.O": "307512",
      "Barloot B.O": "307801",
      "Bhutgaon B.O": "307801",
      "Deldar B.O": "307032",
      "Oda B.O": "307801",
      "Chadual B.O": "307802",
      "Jela B.O": "307802",
      "Mohabbatnagar B.O": "307802",
      "Jetawara B.O": "307513",
      "Pithapura B.O": "307513",
      "Andore B.O": "307043",
      "Girwar B.O": "307026",
      "Siyawa B.O": "307026",
      "Soorpagla B.O": "307026",
      "Tankiya B.O": "307032",
      "Tartoli B.O": "307026",
      "Vasda B.O": "307026",
      "Hathal B.O": "307511",
      "Nagani B.O": "307511",
      "Pamera B.O": "307511",
      "Mandani B.O": "307801",
      "Mandwara B.O": "307801",
      "Udd B.O": "307801",
      "Varada B.O": "307801",
      "Phungani B.O": "307802",
      "Sartara B.O": "307802",
      "Sildar B.O": "307802",
      "Tanwari B.O": "307802",
      "Bant B.O": "307513",
      "Oriya B.O": "307501",
      "Bahadurpura B.O": "307026",
      "Deldar B.O.": "307801",
      "Jamburi B.O": "307026",
      "Khadat B.O": "307026",
      "Mungthala B.O": "307026",
      "Dabani B.O": "307511",
      "Positra B.O": "307511",
      "Udwaria B.O": "307511",
      "Nimbaj B.O": "307512",
      "Jhadoliveer B.O": "307801",
      "Manadar B.O": "307801",
      "Mandwaria B.O": "307801",
      "Naradara B.O": "307801",
      "Haliwara B.O": "307802",
      "Mermandwara B.O": "307802",
      "Nawara B.O": "307802",
      "Raipur B.O": "307513",
      "Vellangari B.O": "307001",
      "Dhanta B.O": "307001",
      "Gohili B.O": "307001",
      "Krishnaganj B.O": "307001",
      "Mandwa B.O": "307001",
      "Balda B.O": "307001",
      "Mamawali B.O": "307001",
      "Padiv B.O": "307001",
      "Khambal B.O": "307001",
      "Makroda B.O": "307001",
      "Rampura B.O": "307001",
      "Sindrath B.O": "307001",
      "Dodua B.O": "307001",
      "Sivera B.O": "307022",
      "Verwara B.O": "307022",
      "Rowada B.O": "307028",
      "Padar B.O": "307514",
      "Amthala B.O": "307510",
      "Ganka B.O": "307510",
      "Kiverli B.O": "307510",
      "Van B.O": "307043",
      "Janapur B.O": "307022",
      "Jhadoli B.O": "307022",
      "Kojra B.O": "307022",
      "Moras B.O": "307022",
      "Arathwara B.O": "307028",
      "Bhev B.O": "307028",
      "Jogapura B.O": "307028",
      "Basan B.O": "307514",
      "Bhatana B.O": "307514",
      "Jeerawal B.O": "307514",
      "Doytra B.O": "307024",
      "Paba B.O": "307024",
      "Valoriya B.O": "307024",
      "Vasa B.O": "307024",
      "Bhawari B.O": "307023",
      "Dhanari B.O": "307023",
      "Ishra B.O": "307023",
      "Kachholi B.O": "307023",
      "Kermandwara B.O": "307023",
      "Mandwarakhalsa B.O": "307023",
      "Badgaon B.O": "307027",
      "Bagseen B.O": "307043",
      "Uthman B.O": "307043",
      "Ajari B.O": "307022",
      "Nandia B.O": "307022",
      "Varli B.O": "307022",
      "Khandera B.O": "307028",
      "Lunol B.O": "307514",
      "Marol B.O": "307514",
      "Bhula B.O": "307024",
      "Vatera B.O": "307024",
      "Nitora B.O": "307023",
      "Achpura B.O": "307510",
      "Akrabhatta B.O": "307510",
      "Muderla B.O": "307510",
      "Dhurbana B.O": "307027",
      "Kesharpura B.O": "307027",
      "Chhibagaon B.O": "307043",
      "Morli B.O": "307043",
      "Peshua B.O": "307022",
      "Telpur B.O": "307022",
      "Alpa B.O": "307028",
      "Chuli B.O": "307028",
      "Joyla B.O": "307028",
      "Bherugarh B.O": "307514",
      "Jolapur B.O": "307514",
      "Magriwara B.O": "307514",
      "Varman B.O": "307514",
      "Bhimana R.S. B.O": "307024",
      "Jetpura B.O": "307027",
      "Sirohi H.O": "307001",
      "A.I.A. Aburoad S.O": "307026",
      "Anadra S.O": "307511",
      "Dantrai S.O": "307512",
      "Reodar S.O": "307514",
      "Sarupganj S.O": "307023",
      "Shantivan S.O": "307510",
      "Aburoad Diesel Shed S.O": "307026",
      "Jawal S.O": "307801",
      "Mandar S.O (Sirohi)": "307513",
      "Posalia S.O": "307028",
      "Abu S.O": "307501",
      "Aburoad Gandhi Nagar S.O": "307026",
      "Aburoad S.O": "307026",
      "Jkpuram S.O": "307019",
      "Pindwara S.O": "307022",
      "Sirohi Bhatkra S.O": "307001",
      "Binanigram S.O": "307031",
      "Kalandari S.O": "307802",
      "Palri M S.O": "307043",
      "Rohida S.O": "307024",
      "Sheoganj S.O (Sirohi)": "307027",
      "Sirohi Sarupvilas S.O": "307001",
      "BHARJA S.O": "307032"
    },
    "RAJSAMAND": {
      "Unwas B.O": "313322",
      "Galwa B.O": "313327",
      "Jetpura B.O": "313327",
      "Jhor B.O": "313327",
      "Phiyawadi B.O": "313327",
      "Maja B.O": "313323",
      "Namana B.O": "313323",
      "Pakhand B.O": "313323",
      "Jitawas B.O": "313328",
      "Junda B.O": "313328",
      "Kessuli B.O": "313301",
      "Kadia B.O": "313325",
      "Gogathala B.O": "313328",
      "Dowra B.O": "313330",
      "Sakroda B.O": "313324",
      "Dhayla B.O": "313301",
      "Gunjol B.O": "313301",
      "Karoli B.O": "313301",
      "Salore B.O": "313301",
      "Shishoda B.O": "313301",
      "Sadri B.O": "313329",
      "Sakrawas B.O": "313329",
      "Sansera B.O": "313329",
      "Naogama B.O": "313342",
      "Rajiawas B.O": "313342",
      "Godach B.O": "313011",
      "Tantol B.O": "313322",
      "Binol B.O": "313327",
      "Pipli Ahiran B.O": "313327",
      "Bamanhera B.O": "313323",
      "Lapsia B.O": "313328",
      "Lodiyana B.O": "313330",
      "Olanakhera B.O": "313330",
      "Kunthwa B.O": "313301",
      "Mandiyana B.O": "313301",
      "Odan B.O": "313301",
      "Banerian B.O": "313329",
      "Pipli Dadiyan B.O": "313329",
      "Emdi B.O": "313342",
      "Nedach B.O": "313011",
      "Akodara B.O": "313323",
      "Bijnol B.O": "313323",
      "Khandel B.O": "313328",
      "Jilola B.O": "313330",
      "Panotia B.O": "313207",
      "Bagol B.O": "313301",
      "Lal Madri B.O": "313301",
      "Bamnia Kalan B.O": "313329",
      "Chowkdi B.O": "313329",
      "Bhatoli B.O": "313342",
      "Dhoinda B.O": "313342",
      "Boraj B.O": "313324",
      "Gajpur B.O": "313324",
      "Piparda B.O": "313324",
      "Badrada B.O": "313324",
      "Mandawar B.O": "313341",
      "Miyala B.O": "313341",
      "Thikarwas B.O": "313341",
      "Godhaji Ja Gaon B.O": "305921",
      "Kukar Khera B.O": "305921",
      "Kukra B.O": "305921",
      "Samliya B.O": "305921",
      "Togi B.O": "305921",
      "Kuanthal B.O": "313332",
      "Liki B.O": "313332",
      "Mad B.O": "313332",
      "Sathia B.O": "313333",
      "Sevantri B.O": "313333",
      "Sunkhar B.O": "313333",
      "Thurawad B.O": "313333",
      "Todawara Gujran B.O": "313333",
      "Charana B.O": "313211",
      "Gawaardi B.O": "313211",
      "Rama B.O": "313202",
      "Shishvi B.O": "313202",
      "Punawali B.O": "313324",
      "Kalinjar B.O": "313324",
      "Mundol B.O": "313324",
      "Pasund B.O": "313324",
      "Baggad B.O": "313341",
      "Ajitgarh B.O": "305921",
      "Aagaria B.O": "313332",
      "Bikawas B.O": "313332",
      "Nanana B.O": "313332",
      "Bansa B.O": "313333",
      "Janawad B.O": "313333",
      "Jhilwara B.O": "313333",
      "Kalaguman B.O": "313333",
      "Manakwas B.O": "313202",
      "Chhaplian B.O": "313331",
      "Daver B.O": "313331",
      "Isharmand B.O": "313331",
      "Kakrod B.O": "313331",
      "Bankora B.O": "313325",
      "Baradara B.O": "313325",
      "Balicha B.O": "313322",
      "Molela B.O": "313322",
      "Saloda B.O": "313322",
      "Masatiyon Ki Madri B.O": "313324",
      "Bhana B.O": "313324",
      "Mahalon Ki Pipli B.O": "313324",
      "Pharara B.O": "313324",
      "Sanghat Kalan B.O": "313324",
      "Bhawa B.O": "313324",
      "Hamelon Ki Bar B.O": "313341",
      "Lakha Guda B.O": "313341",
      "Dansaria B.O": "305921",
      "Kaladeh B.O": "305921",
      "Goval B.O": "313332",
      "Khakharmala B.O": "313332",
      "Narana B.O": "313332",
      "Selaguda B.O": "313332",
      "Kharnota B.O": "313333",
      "Manawaton Ka Guda B.O": "313333",
      "Umarwas B.O": "313333",
      "Kotri B.O": "313211",
      "Rajpura B.O": "313211",
      "Kailashpuri B.O": "313202",
      "Anjana B.O": "313331",
      "Barjal B.O": "313331",
      "Kalesaria B.O": "313331",
      "Kuncholi B.O": "313325",
      "Majera B.O": "313325",
      "Mohi B.O": "313324",
      "Sayon Ka Khera B.O": "313324",
      "Sundarcha B.O": "313324",
      "Piplantri B.O": "313324",
      "Koyal B.O": "313324",
      "Kachhabali B.O": "313341",
      "Balli Ijassa Kheda B.O": "305921",
      "Gosundi B.O": "313332",
      "Jeeran B.O": "313332",
      "Rinchhed B.O": "313333",
      "Tikar B.O": "313332",
      "Lambodi B.O": "313333",
      "Dunger Khera B.O": "305922",
      "Saroth B.O": "305922",
      "Kabra B.O": "313211",
      "Bilota B.O": "313202",
      "Negadia B.O": "313202",
      "Bagana B.O": "313331",
      "Khamlighat B.O": "313331",
      "Kundwa B.O": "313331",
      "Lasani B.O": "313331",
      "Pipli B.O": "313331",
      "Ranchhedi B.O": "313331",
      "Koshiwara B.O": "313321",
      "Aidana B.O": "313334",
      "Antalia B.O": "313334",
      "Antri B.O": "313325",
      "Nardaska Guda B.O": "313331",
      "Pardi B.O": "313331",
      "Usar B.O": "313321",
      "Khatmala B.O": "313334",
      "Merda Khalsa B.O": "313334",
      "Padasali B.O": "313334",
      "Tansol B.O": "313334",
      "Tunkra B.O": "313334",
      "Kankrwa B.O": "313325",
      "Kesar B.O": "313325",
      "Taladari B.O": "313325",
      "Semal B.O": "313322",
      "Madaria B.O": "313331",
      "Tal B.O": "313331",
      "Pachhamata B.O": "313207",
      "Bhada Bhanuja B.O": "313321",
      "Jhalon Ki Madar B.O": "313321",
      "Morcha B.O": "313321",
      "Sameecha B.O": "313321",
      "Dhaneen B.O": "313334",
      "Jhanjhar B.O": "313334",
      "Sapol B.O": "313334",
      "Uthnol B.O": "313204",
      "Biliyawas B.O": "305922",
      "Savadari B.O": "313331",
      "Khad Bamnia B.O": "313207",
      "Kkundia B.O": "313207",
      "Bhensa Kamed B.O": "313321",
      "Machind B.O": "313321",
      "Pipla B.O": "313321",
      "Atma B.O": "313334",
      "Laget Khera B.O": "305925",
      "Kanooja B.O": "313325",
      "Oda B.O": "313325",
      "Sema B.O": "313322",
      "Borwa B.O": "305901",
      "Dhanyla B.O": "313334",
      "Siyana B.O": "313334",
      "Shekhawas B.O": "311302",
      "Dhaneria B.O": "313206",
      "Bar B.O": "311302",
      "Bhim S.O": "305921",
      "Kelwa S.O (Rajsamand)": "313334",
      "Kotharia S.O (Rajsamand)": "313323",
      "Kuraj S.O": "313328",
      "Nathdwara Chaupati S.O": "313301",
      "Nathdwara S.O": "313301",
      "Rajsamand S.O": "313324",
      "Gilund S.O": "313207",
      "Goanguda S.O": "313321",
      "Kelwara S.O": "313325",
      "Barar S.O": "313341",
      "Charbhuja S.O": "313333",
      "Delwara S.O": "313202",
      "Deogarh S.O (Rajsamand)": "313331",
      "Khamnore S.O": "313322",
      "Railmagra S.O": "313329",
      "Kankroli H.O": "313324",
      "Charbhuja Road S.O": "313332",
      "Dariba S.O": "313211",
      "Koaria S.O": "313327",
      "Lawa Sardargarh S.O": "313330",
      "T F Kankroli S.O": "313342"
    },
    "SIKAR": {
      "Bhojpur BO": "332709",
      "Hod BO": "332709",
      "Khatundra BO": "332709",
      "Saledipura BO": "332709",
      "Abhawas BO": "332602",
      "Samer BO": "332602",
      "Gudha BO": "332603",
      "Dayalkinangal BO": "332711",
      "Godawas BO": "332713",
      "Nimod BO": "332713",
      "Dalpatpura BO": "332718",
      "Raipur BO": "332718",
      "Dadia Rampura BO": "332404",
      "Kotri Dhayalan BO": "332404",
      "Tapiplya BO": "332404",
      "Rampura BO": "332718",
      "Sihori BO": "332719",
      "Simrala BO": "332719",
      "Dansroli BO": "332742",
      "Kankra BO": "332742",
      "Rajpura Nosal BO": "332742",
      "Surera BO": "332742",
      "Maonda Kalan BO": "332711",
      "Maonda Khurd BO": "332711",
      "Nangal Nathusar BO": "332712",
      "Nathusar BO": "332712",
      "Ratanpura BO": "332712",
      "Kotra BO": "332713",
      "Mahawa BO": "332713",
      "Mandholi BO": "332713",
      "Napawali BO": "332713",
      "Ballupura BO": "332718",
      "Bihar BO": "332718",
      "Chhajakinangal BO": "332718",
      "Lakhani BO": "332404",
      "Lampuwa BO": "332404",
      "Bhagwanpura BO": "332714",
      "Govindpura BO": "332402",
      "Jassika Kabas BO": "332714",
      "Garh Bhopji BO": "332719",
      "Kalyanpura BO": "332719",
      "Dayara BO": "332709",
      "Dhani Guman Singh BO": "332709",
      "Dudhwalonkabas BO": "332709",
      "Gokulkabas BO": "332709",
      "Kotri BO": "332715",
      "Paniharwas BO": "332709",
      "Royal BO": "332709",
      "Aloda BO": "332602",
      "Chomupurohitan BO": "332602",
      "Ganora BO": "332602",
      "Lamiya BO": "332602",
      "Simarla Pironka BO": "332603",
      "Jillo BO": "332711",
      "Makri BO": "332711",
      "Lisariya BO": "332712",
      "Dokan BO": "332718",
      "Doongakinangal BO": "332718",
      "Ghasipura BO": "332718",
      "Rajpura BO": "332721",
      "Ramsinghkidhani BO": "332718",
      "Shyampura BO": "332710",
      "Jetusar BO": "332404",
      "Kardka BO": "332719",
      "Kerpura BO": "332709",
      "Tiwarikidhani BO": "332709",
      "Arnia BO": "332603",
      "Bharija BO": "332742",
      "Nathakinangal BO": "332711",
      "Footala BO": "332712",
      "Bhudoli BO": "332713",
      "Khadra BO": "332713",
      "Nayabas BO": "332301",
      "Puranabas BO": "332713",
      "Biharipur BO": "332718",
      "Dabla BO": "332718",
      "Hasampur BO": "332718",
      "Bhopatpura BO": "332404",
      "Sargoth BO": "332404",
      "Bhagoth BO": "332714",
      "Rooppura BO": "332719",
      "Palri BO": "332031",
      "Bagri BO": "332311",
      "Bairas BO": "332311",
      "Jana BO": "332025",
      "Khanri BO": "332025",
      "Kachhwa BO": "332026",
      "Kothyari BO": "332026",
      "Kumas BO": "332311",
      "Tunwa BO": "332026",
      "Abhaipura BO": "332402",
      "Govati BO": "332402",
      "Ghana BO": "332312",
      "Khakholi BO": "332041",
      "Molyasi BO": "332041",
      "Pardoli Badi BO": "332041",
      "Rulyana Mali BO": "332041",
      "Sewa BO": "332041",
      "Chainpura BO": "332027",
      "Gungara BO": "332027",
      "Takhalsar BO": "331024",
      "Thedi BO": "331024",
      "Trilokpura BO": "332403",
      "Hudera BO": "332304",
      "Rosawa BO": "332304",
      "Sekhisar BO": "332304",
      "Balod Bhakaran BO": "332305",
      "Balod Chhoti BO": "332305",
      "Dabri BO": "332305",
      "Sarwari BO": "332030",
      "Sujanpura BO": "332030",
      "Tihay BO": "332307",
      "Bassi BO": "332715",
      "Nangal Bhim BO": "332715",
      "Patwari Ka Bas BO": "332715",
      "Tiwari Ki Dhani BO": "332715",
      "Holikabas BO": "332715",
      "Jairampura BO": "332715",
      "Kanchanpur BO": "332715",
      "Dhaliawas BO": "332715",
      "Raipur Jagir BO": "332701",
      "Bajiawas BO": "332601",
      "Banathala BO": "332601",
      "Charanwas BO": "332601",
      "Ladpur BO": "332411",
      "Mundiawas BO": "332702",
      "Neemawas BO": "332702",
      "Ladikabas BO": "332705",
      "Subhash Nagar BO": "332031",
      "Dharamshala BO": "332031",
      "Batranau BO": "332311",
      "Chachiwad BO": "332311",
      "Narodara BO": "332311",
      "Gudha Chhota BO": "332402",
      "Mandha Madni BO": "332402",
      "Prithvipura BO": "332715",
      "Sunderpura BO": "332402",
      "Miran BO": "332312",
      "Sola BO": "332312",
      "Sutot BO": "332041",
      "Hardayalpura BO": "332027",
      "Kushalpura BO": "332027",
      "Dhakas BO": "331024",
      "Kayamsar BO": "331024",
      "Bajore BO": "332403",
      "Goriyan BO": "332722",
      "Bibipur BO": "332317",
      "Bhilunda BO": "332028",
      "Binjasi BO": "332028",
      "Dher Ka Bas BO": "332028",
      "Fatehpura BO": "332721",
      "Dantru BO": "332311",
      "Bhirana BO": "332025",
      "Chirasara BO": "332025",
      "Sangliya BO": "332025",
      "Ghirnia Bada BO": "332026",
      "Ajabpura BO": "332402",
      "Gordhanpura BO": "332402",
      "Alkhpura Bogan BO": "332312",
      "Garoda BO": "332312",
      "Hapas BO": "332312",
      "Kirdoli BO": "332041",
      "Sewad Badi BO": "332041",
      "Sihot Chhoti BO": "332041",
      "Purohitkabas BO": "332027",
      "Neemakidhani BO": "331024",
      "Sahnusar BO": "331024",
      "Khandelsar BO": "332403",
      "Rewasa BO": "332403",
      "Baral BO": "332405",
      "Palasara BO": "332405",
      "Ved Ki Dhani BO": "332405",
      "Rulyani BO": "332028",
      "Tasar Badi BO": "332042",
      "Mordunga BO": "332030",
      "Bhuwala BO": "332042",
      "Palwas BO": "332042",
      "Dhabawali BO": "332715",
      "Ajmeri BO": "332701",
      "Deorala BO": "332701",
      "Garh Taknet BO": "332701",
      "Kishorepura BO": "332701",
      "Seepur BO": "332701",
      "Tatera BO": "332701",
      "Likhma Ka Bas BO": "332601",
      "Meirajanpura BO": "332703",
      "Chiplata BO": "332705",
      "Deepawas BO": "332705",
      "Thimoli BO": "332307",
      "Ralawata BO": "332715",
      "Bharni BO": "332715",
      "Hansapur BO": "332715",
      "Pithalpur BO": "332701",
      "Thikaria BO": "332411",
      "Dhingpur BO": "332601",
      "Jalund BO": "332601",
      "Khora BO": "332601",
      "Rulana BO": "332601",
      "Bhurdonkabas BO": "332703",
      "Suliawas BO": "332702",
      "Khiroti BO": "332705",
      "Mokalwas BO": "332705",
      "Posani BO": "332031",
      "Yalsar BO": "332031",
      "Deenwa BO": "332311",
      "Hamirpura BO": "332311",
      "Singodra BO": "332311",
      "Bhima BO": "332025",
      "Bosana BO": "332025",
      "Losal Chhoti BO": "332025",
      "Barsinghpura BO": "332709",
      "Dookia BO": "332402",
      "Jurathara BO": "332402",
      "Ladhana BO": "332402",
      "Bathot BO": "332312",
      "Bhojasar BO": "332312",
      "Raghunathgarh BO": "332027",
      "Singhasan BO": "332027",
      "Khotiya BO": "331024",
      "Kanwarpura BO": "332001",
      "Almas BO": "332303",
      "Bagroda BO": "332303",
      "Bhagasara BO": "332303",
      "Ramshisar BO": "332302",
      "Tajsar BO": "332301",
      "Bhooma Bada BO": "332318",
      "Dhanani BO": "332318",
      "Mangloona BO": "332318",
      "Gothra Taglan BO": "332023",
      "Jachas BO": "332023",
      "Mandota BO": "332023",
      "Sesam BO": "332023",
      "Roopgarh BO": "332406",
      "Beri BO": "332031",
      "Gothra Bhukaran BO": "332031",
      "Kolida BO": "332031",
      "Deogarh BO": "332021",
      "Dujod BO": "332021",
      "Gokulpura BO": "332021",
      "Churi Miyon BO": "332401",
      "Kheri Radan BO": "332401",
      "Doodwa BO": "332316",
      "Khinwasar BO": "332316",
      "Panlawa BO": "332316",
      "Anokhu BO": "332002",
      "Chuwas BO": "332301",
      "Dewas BO": "332301",
      "Fadanpura BO": "332301",
      "Gangiasar BO": "332301",
      "Nethwa BO": "331024",
      "Raipura BO": "332403",
      "Sherpura Sujas BO": "332403",
      "Badusar BO": "332317",
      "Rajas BO": "332317",
      "Sangarwa BO": "332405",
      "Gunatoo BO": "332028",
      "Shahpura BO": "332411",
      "Dugoli BO": "332042",
      "Bagriawas BO": "332715",
      "Mau BO": "332715",
      "Vijaypura BO": "332715",
      "Aspura BO": "332701",
      "Jugrajpura BO": "332701",
      "Mandusiya BO": "332701",
      "Malikpur BO": "332411",
      "Kantia BO": "332601",
      "Mota Ki Dhani BO": "332601",
      "Dholasari BO": "332703",
      "Motlawas BO": "332702",
      "Dariba BO": "332705",
      "Ganwari BO": "332705",
      "Jalalsar BO": "332301",
      "Mandela Bada BO": "332301",
      "Mandela Chhota BO": "332301",
      "Kudli BO": "332024",
      "Tarpura BO": "332024",
      "Badalwas BO": "332023",
      "Banura BO": "332023",
      "Bhagatpura BO": "332023",
      "Bidoli BO": "332023",
      "Gassu BO": "332315",
      "Jasrasar BO": "332315",
      "Lalasi BO": "332315",
      "Palthana BO": "332315",
      "Dudhwa BO": "332406",
      "Jeenmata BO": "332406",
      "Jeenwas BO": "332406",
      "Nathawatpura BO": "332001",
      "Antri BO": "332021",
      "Harsh BO": "332021",
      "Mandawara BO": "332021",
      "Rahnawa BO": "332401",
      "Sankhu BO": "332401",
      "Birodi Chotti BO": "332316",
      "Bheenchari BO": "332303",
      "Hirna BO": "332303",
      "Palas BO": "332302",
      "Nagwa BO": "332002",
      "Pewa BO": "332002",
      "Banthod BO": "332301",
      "Birania BO": "332301",
      "Garinda BO": "332301",
      "Harsawa BO": "332301",
      "Sutod BO": "332029",
      "Juliasar BO": "332318",
      "Narsas BO": "332318",
      "Dadia BO": "332024",
      "Jheegar Chhoti BO": "332024",
      "Mundawara BO": "332023",
      "Badhadhar BO": "332315",
      "Rashidpura BO": "332315",
      "Sanwloda Ladkhani BO": "332315",
      "Mohanpura BO": "332406",
      "Ralwata BO": "332406",
      "Bhaironpura BO": "332001",
      "Sabalpura BO": "332001",
      "Chandpura BO": "332021",
      "Kashikabas BO": "332021",
      "Puran Badi BO": "332021",
      "Athwas BO": "332401",
      "Disnau BO": "332401",
      "Kaswali BO": "332401",
      "Madhopura BO": "332401",
      "Birodibadi BO": "332316",
      "Kheerwa BO": "332316",
      "Beedsar BO": "332316",
      "Dinwa BO": "332303",
      "Nabipura BO": "332303",
      "Kasli BO": "332002",
      "Netarwas BO": "332002",
      "Bari BO": "332301",
      "Godia Bada BO": "332301",
      "Karanga Bada BO": "332301",
      "Bochi BO": "332029",
      "Tiroki Badi BO": "332029",
      "Bhadwasi BO": "332024",
      "Dinarpura BO": "332024",
      "Sami BO": "332023",
      "Akwa BO": "332315",
      "Sanwaloda Dhayalan BO": "332315",
      "Sanwloda Purohitan BO": "332315",
      "Nimera BO": "332722",
      "Reta BO": "332406",
      "Sawaipura BO": "332722",
      "Shola BO": "332722",
      "Hathideh BO": "332707",
      "Toda BO": "332705",
      "Chala BO": "332706",
      "Shyamgarh BO": "332721",
      "Sanwalpura Shekhawatan BO": "332707",
      "Sanwalpura Tanwaran BO": "332707",
      "Narsinghpuri BO": "332706",
      "Thikariya BO": "332706",
      "Sakraimata BO": "332721",
      "Kasarda BO": "332722",
      "Hardaskabas BO": "332707",
      "Surani BO": "332707",
      "Bhadwari BO": "332708",
      "Dhani Jorawarsingh BO": "332708",
      "Lorwara BO": "332708",
      "Chowkri BO": "332706",
      "Jankipura BO": "332722",
      "Haripura BO": "332707",
      "Neemki BO": "332708",
      "Samrathpura BO": "332708",
      "Chakgopinathpura BO": "332710",
      "Karad BO": "332710",
      "Pachar BO": "332710",
      "Basri BO": "332708",
      "Basri Khurd BO": "332708",
      "Bamanwas BO": "332709",
      "Jugalpura BO": "332708",
      "Kanwat RS BO": "332708",
      "Pritampuri BO": "332708",
      "Koolie BO": "332710",
      "Umara BO": "332710",
      "Harjanpura BO": "332708",
      "Athbigha BO": "332709",
      "Sikar HO": "332001",
      "Fatehpur Shekhawati SO": "332301",
      "Jajod SO Lachhmangarh": "332318",
      "Bajaj RoadSikar SO": "332001",
      "Bajajgram SO": "332021",
      "Devipura SO": "332001",
      "Katrathal SO": "332024",
      "Srimadhopur HO": "332715",
      "Balaran SO": "332401",
      "Beedasar SO": "332316",
      "Dhandhan SO": "332302",
      "Fatehpur Bazar SO": "332301",
      "Gandhinagar SO Sikar": "332001",
      "Ganeri SO": "332029",
      "Khuri Badi SO": "332315",
      "Kochhore SO": "332406",
      "Lachhmangarh Bazar SO": "332311",
      "Beswa SO": "332303",
      "Dhod SO": "332002",
      "Fatehpuri Gate SO": "332001",
      "Khoor SO": "332023",
      "Koodan SO": "332031",
      "Lachhmangarh SO": "332311",
      "Losal SO": "332025",
      "Palsana SO Sikar": "332402",
      "Patoda SO Sikar": "332312",
      "Sadinsar SO": "332305",
      "Shishu SO": "332405",
      "Singrawat SO": "332030",
      "Ajitgarh Amarsar SO": "332701",
      "Ganeshwar SO": "332705",
      "Mahroli SO": "332603",
      "Srimadhopur Bazar SO": "332715",
      "Srimadhopur RS SO": "332715",
      "Surani Bazar Srimadhopur SO": "332715",
      "Mochiwara SO": "332001",
      "Nayama Bazar Lachhmangarh SO": "332311",
      "Nechhwa SO": "332026",
      "Phagalwa SO": "332041",
      "Ramgarh Bazar SO": "331024",
      "Ramgarh Shekhawati SO": "331024",
      "Rolsabsar SO": "332304",
      "Tatanwa SO": "332042",
      "Danta Ramgarh SO": "332703",
      "Khandela SO": "332709",
      "Mandha Surera SO": "332742",
      "NPKhandela SO": "332709",
      "Ringas SO": "332404",
      "Thoi SO": "332719",
      "Piprali SO": "332027",
      "Ranoli SO Sikar": "332403",
      "Sihot Badi SO": "332028",
      "Sikaria BazarFatehpur SO": "332301",
      "Baori SO": "332411",
      "Baya SO": "332601",
      "Losal Bazar SO": "332025",
      "Roru Badi SO": "332317",
      "Tihawali SO": "332307",
      "Danta SO": "332702",
      "Jajod SO Srimadhopur": "332722",
      "Khatushyamjika SO": "332602",
      "Maonda RS SO": "332711",
      "Mundru SO": "332712",
      "Patan SO Sikar": "332718",
      "Sirohi SO": "332714",
      "Guhala SO": "332706",
      "Gurara SO": "332721",
      "Jharli SO": "332707",
      "Kanwat Town SO": "332708",
      "Khachariawas SO": "332710",
      "Nimkathana SO": "332713",
      "Nimkathana Town SO": "332713",
      "Ringas Town SO": "332404"
    },
    "CHITTORGARH": {
      "Rajgarh B.O": "312022",
      "Sadi B.O": "312901",
      "Raita B.O": "312023",
      "Rawarda B.O": "312023",
      "Badoliya B.O": "323307",
      "Barodia B.O": "312021",
      "Idra B.O": "312024",
      "Kunthana B.O": "312024",
      "Leswa B.O": "312024",
      "Lothiyana B.O": "312024",
      "Sangesara B.O": "312024",
      "Meghniwas B.O": "323304",
      "Sripura B.O": "323304",
      "Tambolia B.O": "323304",
      "Pari B.O": "312204",
      "Phalasiya B.O": "312204",
      "Nannana B.O": "312614",
      "Biloda B.O": "312402",
      "Palod B.O": "312402",
      "Bood B.O": "312901",
      "Jojron Ka Kheda B.O": "312901",
      "Kanti B.O": "312901",
      "Kharkhanda B.O": "312901",
      "Kunwalia B.O": "312901",
      "Mandfiya B.O": "312901",
      "Raghunathpura B.O": "312901",
      "Undwa B.O": "312901",
      "Dhanet Kalan B.O": "312201",
      "Kanthariya Chobe Ji Ka B.O": "312201",
      "Balarada B.O": "312202",
      "Bhatton Ka Bamniya B.O": "312202",
      "Sonagar B.O": "312022",
      "Chechi  B.O": "312023",
      "Dhamancha B.O": "312023",
      "Gulana B.O": "312023",
      "Jainagar B.O": "312023",
      "Samaria Khurd B.O": "312023",
      "Eklingpura B.O": "323307",
      "Bhalundi B.O": "312602",
      "Bambori B.O": "312614",
      "Alod B.O": "312404",
      "Binayaka B.O": "312404",
      "Pirana B.O": "312402",
      "Rawatpura B.O": "312402",
      "Bavlas B.O": "312901",
      "Bolon Ka Sanwata B.O": "312901",
      "Sudri B.O": "312901",
      "Suwania B.O": "312901",
      "Tumbadia B.O": "312207",
      "Rewlia Khurd B.O": "312201",
      "Satpura B.O": "312201",
      "Surpur B.O": "312201",
      "Bhanuja B.O": "312603",
      "Gardana B.O": "312603",
      "Damakhera B.O": "312202",
      "Dhamana B.O": "312202",
      "Pandoli S T B.O": "312202",
      "Rolia B.O": "312202",
      "Uchnarkhurd B.O": "312202",
      "Bhatoli Bagrian B.O": "312027",
      "Dhanet B.O": "312027",
      "Nadakhera B.O": "312027",
      "Arnia Joshi B.O": "312620",
      "Arnoda B.O": "312620",
      "Khermalia B.O": "312603",
      "Deopura B.O": "312023",
      "Jawada  1 B.O": "312023",
      "Katunda B.O": "312023",
      "Pachunda B.O": "312023",
      "Khatikhera B.O": "323307",
      "Potlajagir B.O": "312602",
      "Morwan B.O": "312024",
      "Napania B.O": "312024",
      "Gopalpura B.O": "312022",
      "Bhoopal  Nagar B.O": "312204",
      "Kankarwa B.O": "312204",
      "Mungana B.O": "312204",
      "Jaloda Jagir B.O00": "312614",
      "Mandla Charan B.O": "312614",
      "Karsana B.O": "312404",
      "Sangria B.O": "312404",
      "Putholi B.O": "312021",
      "Sainik School B.O": "312021",
      "Badwai B.O": "312402",
      "Borda B.O": "312901",
      "Jawasia B.O": "312901",
      "Soniyana B.O": "312901",
      "Mishron Ki Pipli B.O": "312201",
      "Pandolimataji Ki B.O": "312201",
      "Anoppura B.O": "312202",
      "Dowani B.O": "312202",
      "Jashma B.O": "312202",
      "Chikarada B.O": "312027",
      "Bhawaliya B.O": "312620",
      "Karunda B.O": "312620",
      "Unkliya B.O": "312620",
      "Napawali B.O": "312603",
      "Punawali B.O": "312603",
      "Abhaypur B.O": "312022",
      "Balkundikalan B.O": "312023",
      "Daulatpura B.O": "312023",
      "Dorai B.O": "312023",
      "Mandawari B.O": "312023",
      "Nandwai B.O": "312023",
      "Thukrai B.O": "312023",
      "Jalkhera B.O": "323307",
      "Mohana B.O": "323307",
      "Asawara B.O": "312602",
      "Dheerji Ka Khera B.O": "312602",
      "Bagund B.O": "312024",
      "Mangalwar B.O": "312024",
      "Nagawali B.O": "312024",
      "Borav B.O": "323304",
      "Babarana B.O": "312202",
      "Kanakhera B.O": "312202",
      "Usrol B.O": "312204",
      "Bhagwanpura B.O": "312614",
      "Khodip B.O": "312614",
      "Delwas B.O": "312404",
      "Phalodara B.O": "312402",
      "Rolahera B.O": "312021",
      "Arned B.O": "312402",
      "Semlia Peela Khera B.O": "312402",
      "Chogawadi B.O": "312901",
      "Rood B.O": "312901",
      "Kashmore B.O": "312201",
      "Odund B.O": "312201",
      "Hathiyana B.O": "312202",
      "Nimbahera B.O": "312202",
      "Akola Kalan B.O": "312027",
      "Udpura B.O": "312620",
      "Peend B.O": "312603",
      "Badwal B.O": "312401",
      "Mahuda B.O": "312401",
      "Jarkhana B.O": "312403",
      "Parsoli B.O": "312022",
      "Ratichandjikakhera B.O": "312403",
      "Amarpura B.O": "312022",
      "Anwalhera B.O": "312022",
      "Kherpura B.O": "312022",
      "Pal B.O": "312022",
      "Palka B.O": "312022",
      "Munjwa B.O": "312403",
      "Satola B.O": "312403",
      "Kheri B.O": "312022",
      "Bhatoli Brahmnan B.O": "312403",
      "Kiratpura B.O": "312403",
      "Laxmipura B.O": "312403",
      "Manpura Jagir B.O": "312403",
      "Bijaipur B.O": "312022",
      "Dugar B.O": "312022",
      "Badolighata B.O": "312601",
      "Bangreda B.O": "312601",
      "Bangreda Ghata B.O": "312606",
      "Marjivi B.O": "312601",
      "Sihana B.O": "312206",
      "Kannoj B.O": "312613",
      "Nahargarh B.O": "312613",
      "Sukhwara B.O": "312613",
      "Ghatiawali B.O": "312612",
      "Kewalpura B.O": "312401",
      "Karju B.O": "312403",
      "Khardeola B.O": "312403",
      "Bichhor B.O": "312022",
      "Gilund B.O": "312612",
      "Jalampura B.O": "312612",
      "Samari B.O": "312612",
      "Basera B.O": "312601",
      "Gadola B.O": "312601",
      "Kotri Kalan B.O": "312601",
      "Lasdawn B.O": "312601",
      "Arni B.O": "312203",
      "Dindoli B.O": "312203",
      "Harnathpur B.O": "312203",
      "Marmi B.O": "312203",
      "Banakiyakalan B.O": "312207",
      "Maharaaj Ki Netawal B.O": "312207",
      "Narela B.O": "312207",
      "Mandesara B.O": "323306",
      "Rajpura B.O": "323306",
      "Sadalkhera B.O": "312603",
      "Badolimadhosingh B.O": "312601",
      "Doria B.O": "312601",
      "Keli B.O": "312601",
      "Melana B.O": "312606",
      "Ranikhera B.O": "312601",
      "Sarsi B.O": "312606",
      "Lasadiaya Kalan B.O": "312206",
      "Rewara B.O": "312206",
      "Sankhali B.O": "312203",
      "Upreda B.O": "312203",
      "Chiksi B.O": "312613",
      "Arniapanth B.O": "312612",
      "Satkhanda B.O": "312612",
      "Hingoria B.O": "312207",
      "Jitiya B.O": "312207",
      "Motipura B.O": "312022",
      "Nagri B.O": "312022",
      "Umand B.O": "312205",
      "Chittorgarh Fort B.O": "312025",
      "Akiya B.O": "312024",
      "Netawal garh pachhali B.O": "312025",
      "Ochhari B.O": "312025",
      "Semalpura B.O": "312025",
      "Chakunda B.O": "312205",
      "Chorwadi B.O": "312205",
      "Gundli B.O": "312205",
      "Karjali B.O": "312205",
      "Bansen B.O": "312024",
      "Sehnwa B.O": "312025",
      "Nilod B.ON": "312205",
      "Tana B.O": "312205",
      "Bari B.O": "312601",
      "Dalla (Kishanpura) B.O": "312601",
      "Jaliya B.O": "312601",
      "Jawada  II B.O": "312601",
      "Phalwa B.O": "312601",
      "Rassoolpura B.O": "312601",
      "Bhalotan Ki Kheri B.O": "312206",
      "Nevaria B.O": "312206",
      "Adana B.O": "312203",
      "Bhimgarh B.O": "312203",
      "Jadana B.O": "312203",
      "Muroli B.O": "312203",
      "Baru B.O": "312207",
      "Langach B.O": "312207",
      "Deori B.O": "312025",
      "Pipalwas B.O": "312024",
      "Semlia B.O": "312025",
      "Murla B.O": "312205",
      "Patoliya B.O": "312205",
      "Chittorgarh H.O": "312001",
      "Adityapuram S.O": "312622",
      "Bassi S.O (Chittorgarh)": "312022",
      "Bhadesar S.O": "312602",
      "Collectorate  Chittorgarh S.O": "312001",
      "Gangrar S.O": "312901",
      "Nikumbh S.O": "312603",
      "Pahuna S.O": "312206",
      "Sawa S.O": "312613",
      "Sadas S.O": "312627",
      "Barisadari S.O": "312403",
      "Bohera S.O": "312404",
      "Cement Factory S.O": "312021",
      "Doongla S.O": "312402",
      "Gosunda S.O": "312201",
      "Kapasan  Town S.O": "312202",
      "Mandfia S.O": "312027",
      "Nimbahera S.O": "312601",
      "Ranasanga  Bazar  Chittorgarh S.O": "312001",
      "Rawatbhatta  Bazar S.O": "323305",
      "Shambhupura S.O": "312612",
      "Vikram Nagar S.O": "323306",
      "Akola S.O (Chittorgarh)": "312205",
      "Bansi S.O (Chittorgarh)": "312401",
      "Bhabhanagar S.O": "323307",
      "Bhenshroadgarh S.O": "323304",
      "Bhoopal sagar S.O": "312204",
      "Binota S.O": "312614",
      "Kailash  Nagar S.O": "312617",
      "Kapasan S.O": "312202",
      "Rashmi S.O": "312203",
      "Anushakti S.O": "323303",
      "Begun S.O": "312023",
      "Bhadsaura S.O": "312024",
      "Kanera S.O": "312606",
      "Mangrol S.O (Chittorgarh)": "312620",
      "Senthi S.O": "312025",
      "Singhpur S.O (Chittorgarh)": "312207"
    },
    "SAWAI MADHOPUR": {
      "Khandeola BO": "322001",
      "Daulatpura BO": "322001",
      "Mui BO": "322001",
      "Rawanjana Doongar BO": "322001",
      "Khijuri BO": "322001",
      "Jhopra BO": "322701",
      "Kolada BO": "322023",
      "Lakhanpur BO": "322023",
      "Mitrapura BO": "322023",
      "Aulwada BO": "322034",
      "Badagaon Didayach BO": "322702",
      "Balaria BO": "322702",
      "Khatupura BO": "322001",
      "Sherpur Khilchipur BO": "322001",
      "Ghameera BO": "322001",
      "Kustala BO": "322001",
      "Allapur BO": "322001",
      "Jonla BO": "322701",
      "Lorwara BO": "322701",
      "Kushalpura BO": "322023",
      "Chhan BO": "322001",
      "Rawanjana Chaur BO": "322001",
      "Dhamun Khurd BO": "322001",
      "Jinapur BO": "322001",
      "Bapui BO": "322023",
      "Bans Torda BO": "322023",
      "Gungorad BO": "322023",
      "Udgaon BO": "322023",
      "Badolas BO": "322034",
      "Makholi BO": "322034",
      "Padana BO": "322034",
      "Banjari BO": "322702",
      "Panwdera BO": "322702",
      "Rajmana BO": "322702",
      "Kosra Chhareta Tod BO": "322025",
      "Kyarda Kalan BO": "322025",
      "Badhkalan BO": "322201",
      "Sumel BO": "322201",
      "Baman Baroda BO": "322201",
      "Moran BO": "322023",
      "Nimod BO": "322030",
      "Pipalwada BO": "322023",
      "Rathod BO": "322023",
      "Bhedola BO": "322702",
      "Ancher BO": "322703",
      "Sarsop BO": "322703",
      "Barnawada BO": "322025",
      "Bhahraonda Kalan BO": "322025",
      "Bichpuri Gujran BO": "322025",
      "Khoontala BO": "322201",
      "Koyla BO": "322201",
      "Dungarwada BO": "322211",
      "Jahra BO": "322211",
      "Tundila BO": "322211",
      "Sankara BO": "322202",
      "Toksi BO": "322202",
      "Doongri BO": "322033",
      "Maksudanpura BO": "322033",
      "Datasuti  BO": "322215",
      "Khandeep BO": "322205",
      "Bairada BO": "322214",
      "Barnala BO": "322214",
      "Chandanholi BO": "322214",
      "Kherli BO": "322214",
      "Jiwali BO": "322219",
      "Meena Baroda BO": "322219",
      "Phulwada Popat BO": "322219",
      "Hindupura BO": "322024",
      "Jolanda BO": "322024",
      "Bhadlav BO": "322029",
      "Chharoda BO": "322029",
      "Kodyai BO": "322030",
      "Falsawata BO": "322028",
      "Morpa BO": "322028",
      "Dangarwada BO": "322026",
      "Dumoda BO": "322026",
      "Lahsoda BO": "322026",
      "Phalodi BO": "322026",
      "Ajnoti BO": "322027",
      "Aniyala BO": "322025",
      "Baler BO": "322025",
      "Barod BO": "322025",
      "Gandawar BO": "322025",
      "Goth Bihari BO": "322025",
      "Amargarh Chaur BO": "322201",
      "Lalpur Umri BO": "322201",
      "Talawada BO": "322201",
      "Shafipura BO": "322211",
      "Salempur BO": "322202",
      "Bichhi Doona BO": "322033",
      "Choti Udai BO": "322205",
      "Mahanandpur BO": "322205",
      "Batoda BO": "322214",
      "Bhanwar BO": "322214",
      "Binjari BO": "322214",
      "Palasod BO": "322214",
      "Gandal BO": "322204",
      "Medi BO": "322219",
      "Pawata Gaddi BO": "322219",
      "Raipur BO": "322219",
      "Talwada BO": "322025",
      "Bhadoti BO": "322024",
      "Gambhira BO": "322024",
      "Mamdoli BO": "322024",
      "Endwa BO": "322029",
      "Shayampura BO": "322029",
      "Nogaon BO": "322201",
      "Liwali BO": "322211",
      "Meena Koleta BO": "322211",
      "Raghopura BO": "322211",
      "Bichpuri BO": "322212",
      "Riwali BO": "322212",
      "Chhawa BO": "322202",
      "Chuli BO": "322202",
      "Jiwatkheda BO": "322203",
      "Baglai BO": "322205",
      "Dabar BO": "322214",
      "Jiwad BO": "322214",
      "Mehrawar BO": "322214",
      "Sancholi BO": "322214",
      "Sitod BO": "322214",
      "Sundery BO": "322214",
      "Shyaroli BO": "322219",
      "Naypur BO": "322025",
      "Redawat BO": "322025",
      "Jastana BO": "322030",
      "Behted BO": "322028",
      "Mahapura BO": "322704",
      "Galad Kalan BO": "322030",
      "Taranpur BO": "322030",
      "Dhanoli BO": "322027",
      "Jadawata BO": "322027",
      "Baharnwanda Khurd BO": "322001",
      "Pancholas BO": "322001",
      "Atunkalan BO": "322001",
      "Mai Kalan BO": "322001",
      "Dakwa BO": "322001",
      "Adalwada Kalan BO": "322701",
      "Jatwara Kalan BO": "322701",
      "Bagdoli BO": "322023",
      "Borda BO": "322023",
      "Jhanun BO": "322023",
      "Selu BO": "322034",
      "Bagina BO": "322702",
      "Tapur BO": "322703",
      "Akhaigarh BO": "322025",
      "Badwas BO": "322025",
      "Gothra BO": "322025",
      "Kuredi BO": "322025",
      "Udaikalan BO": "322201",
      "Bucholai BO": "322201",
      "Ahmadpur BO": "322201",
      "Kunkata Kalan BO": "322201",
      "Badila BO": "322211",
      "Kakrala BO": "322211",
      "Ranila BO": "322211",
      "Amavragarh BO": "322212",
      "Sukar BO": "322212",
      "Khanpur Baroda BO": "322202",
      "Bhoori Pahari BO": "322033",
      "Narayanpur Tatwara BO": "322203",
      "Mohcha BO": "322205",
      "Bichhoch BO": "322214",
      "Narauli Chaur BO": "322214",
      "Phulwada BO": "322214",
      "Baroli BO": "322219",
      "Seva BO": "322219",
      "Padri BO": "322025",
      "Singor Kalan BO": "322025",
      "Didwadi BO": "322024",
      "Hathdoli BO": "322024",
      "Shesha BO": "322024",
      "Rawal BO": "322029",
      "Datooli BO": "322030",
      "Gotod BO": "322030",
      "Pipalda BO": "322030",
      "Bhooka BO": "322028",
      "Chitara BO": "322026",
      "Dubbi BO": "322027",
      "Karmoda BO": "322027",
      "Mainpura BO": "322027",
      "Nindarda BO": "322027",
      "Ramdi BO": "322027",
      "Sunari BO": "322027",
      "Bamanwas SO": "322211",
      "Krishi Upaj Mandi Gangapur SO": "322201",
      "New Mandi Gangapur SO": "322201",
      "Gangapur Bazar SO": "322201",
      "Piloda SO": "322205",
      "Piplai SO": "322214",
      "Railway Colony Gangapur SO": "322201",
      "Malarna R S SO": "322033",
      "Wazirpur SO": "322219",
      "Gangapur HO": "322201",
      "Sawaimadhopur HO": "322001",
      "Mahukala SO": "322202",
      "Phalodi Quarry SO": "322026",
      "Shiwar SO": "322704",
      "Malrna Chaur SO": "322030",
      "Sawaimadhopur Bazar SO": "322021",
      "Soorwal SO": "322027",
      "Adarsh Nagar SO Sawai Madhopur": "322001",
      "Khirni SO": "322024",
      "Kundera SO": "322029",
      "Malrna Doongar SO": "322028",
      "Sawaimadhopur Town SO": "322021",
      "Alanpur SO": "322021",
      "Bonli SO": "322023",
      "Chakeri SO": "322034",
      "Chauth Ka Barwara SO": "322702",
      "Isharda SO": "322703",
      "Bhagwatgarh SO": "322701",
      "Khandar SO": "322025"
    },
    "KARAULI": {
      "Matasula BO": "321611",
      "Mirzapur BO": "321611",
      "Nangal Lat BO": "321611",
      "Dadanpur BO": "321611",
      "Kariri BO": "321611",
      "Machadi BO": "321611",
      "Padampura BO": "321611",
      "Shahrakhar BO": "321611",
      "Vajeda BO": "322234",
      "Khoobnagar BO": "322249",
      "Sasedi BO": "322249",
      "Dhoreta BO": "322251",
      "Kased BO": "322251",
      "Mongepura BO": "322251",
      "Ninder BO": "322251",
      "Shekhpura BO": "322220",
      "Bhukrawali BO": "322252",
      "Dhanda BO": "322252",
      "Chainpura BO": "322213",
      "Dhawan BO": "322213",
      "Badagaon BO": "322216",
      "Mohanpura BO": "322216",
      "Dabra BO": "322255",
      "Gairai BO": "322255",
      "Jahangirpur BO": "322255",
      "Kachroda BO": "322255",
      "Mandawra BO": "322255",
      "Mahmadpur BO": "322255",
      "Samerda BO": "322255",
      "Shaikhpura BO": "322255",
      "Fatehpur BO": "322241",
      "Hadoti BO": "322033",
      "Dalpura BO": "322215",
      "Garhkheda BO": "322215",
      "Jirna BO": "322215",
      "Salawad BO": "322215",
      "Baroda Gajrajpal BO": "322203",
      "Bajna BO": "322218",
      "Bukna BO": "322218",
      "Daulatpura BO": "322218",
      "Jakhoda BO": "322218",
      "Kalyanpura BO": "322218",
      "Binega BO": "322219",
      "Dahra BO": "322230",
      "Bhopar BO": "322230",
      "Nagala Meena BO": "322230",
      "Bajna Kalan BO": "322230",
      "Bhandari Anduruni BO": "322238",
      "Kudhawal BO": "322238",
      "Dukawali BO": "322236",
      "Sakarghata BO": "322236",
      "Sankarwada BO": "321610",
      "Kherli Gurjar BO": "322254",
      "Mundia BO": "322254",
      "Thigharia BO": "322254",
      "Kalyani BO": "322243",
      "Bhankari BO": "322249",
      "Harnagar BO": "322249",
      "Aound BO": "322251",
      "Ranipura BO": "322251",
      "Bhawali BO": "322242",
      "Khunda BO": "322242",
      "Chandangaon BO": "322220",
      "Pahadiyanagar BO": "322220",
      "Shantiveer Nagar BO": "322220",
      "Jatwada BO": "322252",
      "Tali BO": "322252",
      "Dholeta BO": "322213",
      "Kamalpura BO": "322213",
      "Pal BO": "322213",
      "Rajpura BO": "322213",
      "Bhilapada BO": "322216",
      "Bhartun BO": "322255",
      "Ledia BO": "322255",
      "Kherla BO": "322202",
      "Bardala BO": "322215",
      "Kema BO": "322215",
      "Eket BO": "322203",
      "Amarwad BO": "322218",
      "Bagida BO": "322218",
      "Inayati BO": "322218",
      "Ramthara BO": "322218",
      "Sengarpura BO": "322219",
      "Kyarda Khurd BO": "322230",
      "Jhareda BO": "322230",
      "Salempur BO": "322230",
      "Sikroda Meena BO": "322230",
      "Lahchoda BO": "322230",
      "Badleta Khurd BO": "322238",
      "Urden BO": "322238",
      "Sherpur BO": "322236",
      "SAKARGHATA BO": "322236",
      "Bhajeda BO": "321610",
      "Parla Khalsa BO": "321610",
      "Jagdishpura BO": "322254",
      "Mohammedpur BO": "322254",
      "Dorawali BO": "321611",
      "Jhadisa BO": "321611",
      "Jonl BO": "321611",
      "Khedi BO": "321611",
      "Mannauj BO": "321611",
      "Bhanwara BO": "322212",
      "Chirawanda BO": "322212",
      "TALCHIDA BO": "322213",
      "Timawa BO": "322213",
      "Baloti BO": "322202",
      "Jodli BO": "322203",
      "Khidarpur BO": "322203",
      "Masawata BO": "322203",
      "Kishorpura BO": "322218",
      "Luloj BO": "322218",
      "Badasawata BO": "322204",
      "Bagor BO": "322204",
      "Kunjela BO": "322204",
      "Karsoli BO": "322230",
      "Lapawali BO": "322230",
      "Kanchroli BO": "322230",
      "Katara Ajij BO": "322230",
      "Nangal Pahadi BO": "322238",
      "Hukmikheda BO": "322236",
      "Jagar BO": "322236",
      "Jatnagla BO": "322236",
      "Khedihewat BO": "322236",
      "Gubreda BO": "322242",
      "Gurda BO": "322242",
      "Jamura BO": "322242",
      "Kanchanpur BO": "322242",
      "Ratiyapura BO": "322242",
      "Rundh Ka Pura BO": "322242",
      "Danalpur BO": "322220",
      "Kemla BO": "322220",
      "Maheswa BO": "322220",
      "Nisura BO": "322220",
      "Rendayal Gurjar BO": "322220",
      "Bhaisa BO": "321611",
      "Bonl BO": "321611",
      "Gorda BO": "321611",
      "Khohra BO": "321611",
      "Manderu BO": "321611",
      "Jahira BO": "322213",
      "Kheda Malupada BO": "322213",
      "Rajaheda BO": "322213",
      "Tesgaon BO": "322216",
      "Bariya BO": "322255",
      "Bijalpur BO": "322255",
      "Kashipura BO": "322255",
      "Makanpur BO": "322255",
      "Nimoda R S BO": "322202",
      "Dahariya BO": "322215",
      "Jitkipur BO": "322215",
      "Raysana BO": "322215",
      "Chauragon BO": "322203",
      "Jirota BO": "322203",
      "Amargarh Dang BO": "322218",
      "Gothra BO": "322218",
      "Vapoti BO": "322218",
      "Lawad BO": "322204",
      "Sop BO": "322204",
      "Parita BO": "322219",
      "Singhania BO": "322230",
      "Bargama BO": "322230",
      "Kanjoli BO": "322230",
      "Khareta BO": "322230",
      "Mandawara BO": "322230",
      "Morda BO": "322238",
      "Pahadi BO": "322238",
      "Pali BO": "322236",
      "Vijaypura BO": "322236",
      "Bhanakpura BO": "321610",
      "Devlane BO": "322254",
      "Ateiwa BO": "322243",
      "Todupura BO": "322234",
      "Bahadurpur BO": "322249",
      "Bugdar BO": "322249",
      "Chandelipura BO": "322251",
      "Pancholi BO": "322251",
      "Rodhai BO": "322251",
      "Chhabar BO": "322242",
      "Khedia BO": "322242",
      "Narayana BO": "322242",
      "Siloti BO": "322242",
      "Ranoli BO": "322220",
      "Ronsi BO": "322220",
      "Somla BO": "322252",
      "Ajijpur BO": "321611",
      "Karsai BO": "322243",
      "Khohri BO": "322243",
      "Marmada BO": "322243",
      "Nanpur BO": "322243",
      "Nibhera BO": "322243",
      "Ata BO": "322241",
      "Mandakheda BO": "322241",
      "Pipalpura BO": "322241",
      "Raghuvanshi BO": "322241",
      "Rondkala BO": "322241",
      "Karanpur BO": "322243",
      "Chainpur BO": "322241",
      "Kondar BO": "322241",
      "Manchi BO": "322241",
      "Katkad BO": "322234",
      "Muthiyapur BO": "322234",
      "Palanpur BO": "322234",
      "Kota BO": "322243",
      "Maholi BO": "322243",
      "Rampur Dhabai BO": "322243",
      "Barkheda BO": "322241",
      "Gunesera BO": "322241",
      "Sunderpura BO": "322241",
      "Gavda Meena BO": "322234",
      "Kotri BO": "322234",
      "Shri Mahaveerji R S BO": "322234",
      "Lohara BO": "322243",
      "Rajor BO": "322243",
      "Toda BO": "322243",
      "Gadholi BO": "322241",
      "Gudla BO": "322241",
      "Saiypur BO": "322241",
      "Tulsipura BO": "322241",
      "Irenia BO": "322234",
      "Sanet BO": "322234",
      "Garhmoran SO": "322212",
      "Narauli Dang SO": "322203",
      "Sapotara SO": "322218",
      "Balghat SO": "322238",
      "Court Karauli SO": "322241",
      "Ghonsla SO": "322254",
      "Hindaun Mandi SO": "322230",
      "Hindaun HO": "322230",
      "Kurgaon SO": "322255",
      "Dhindora SO": "322236",
      "Ghatabalaji SO": "321610",
      "Nadoti SO": "322215",
      "Shahar SO": "322204",
      "Kailadevi SO": "322243",
      "Gudhachandraji SO": "322213",
      "Kemri SO Karauli": "322216",
      "Hindaun City SO": "322230",
      "Karauli SO": "322241",
      "Kheda SO": "322234",
      "Mandrail SO": "322251",
      "Phoota Kot Karauli SO": "322241",
      "Masalpur SO": "322242",
      "Shrimahaveerji SO": "322220",
      "Todabhim SO": "321611",
      "Langra SO": "322249",
      "Suroth SO": "322252"
    },
    "TONK": {
      "Dakhiya B.O": "304001",
      "Galod B.O": "304001",
      "Bharni B.O": "304001",
      "Dodwari B.O": "304001",
      "Lamba B.O": "304001",
      "Sankhana B.O": "304001",
      "Palda B.O": "304001",
      "Choru B.O": "304023",
      "Mohammed Pura B.O": "304023",
      "Kalmanda B.O": "304501",
      "Chaturbhujpura B.O": "304022",
      "Sunara B.O": "304022",
      "Botunda B.O": "304804",
      "Borkhandi B.O": "304504",
      "Chavandia B.O": "304504",
      "Sitarampura B.O": "304504",
      "Balunda B.O": "304026",
      "Kanwara B.O": "304802",
      "Bahad B.O": "304025",
      "Jamdoli B.O": "304025",
      "Khirgi B.O": "304025",
      "Lalwadi B.O": "304025",
      "Nohata B.O": "304025",
      "Titonli(Badagaon) B.O": "304025",
      "Jharli B.O": "304503",
      "Awara B.O": "304502",
      "Kuharakalan B.O": "304502",
      "Takholi B.O": "304001",
      "Wazirpura B.O": "304001",
      "Kabra B.O": "304001",
      "Soran B.O": "304001",
      "Arniya Kedar B.O": "304001",
      "Bambore B.O": "304001",
      "Kholiya B.O": "304023",
      "Kunder B.O": "304023",
      "Mandawara B.O": "304023",
      "Payga B.O": "304023",
      "Pchala B.O": "304023",
      "Shop B.O": "304023",
      "Palai B.O": "304024",
      "Jodhpuria B.O": "304022",
      "Deshma B.O": "304504",
      "Dholi B.O": "304504",
      "Jhirana B.O": "304504",
      "Lawa B.O": "304504",
      "Anwan B.O": "304802",
      "Sitapura B.O": "304802",
      "Tonkrawas B.O": "304802",
      "Dehlod B.O": "304025",
      "Mahapura B.O": "304025",
      "Sindoliya B.O": "304503",
      "Dungri Kalan B.O": "304502",
      "Ganwar B.O": "304502",
      "Indoli B.O": "304502",
      "Kantoli B.O": "304502",
      "Geroli B.O": "304001",
      "Chandlai B.O": "304001",
      "Chhan B.O": "304001",
      "Ghas B.O": "304001",
      "Pasrotia B.O": "304001",
      "Harchandera B.O": "304001",
      "Lawadar B.O": "304001",
      "Hedri Pura B.O": "304023",
      "Chandsen B.O": "304501",
      "Deoli Gaon B.O": "304804",
      "Gaonri B.O": "304804",
      "Kaseer B.O": "304804",
      "Bheepur B.O": "304504",
      "Malikpur B.O": "304504",
      "Soda Baori B.O": "304504",
      "Chandwar B.O": "304026",
      "Dewarawas B.O": "304802",
      "Ghad B.O": "304802",
      "Juniya B.O": "304802",
      "Santhali B.O": "304802",
      "Bhartala B.O": "304025",
      "Datwas B.O": "304025",
      "Kacholia B.O": "304503",
      "Morla B.O": "304503",
      "Dardahind B.O": "304001",
      "Sonwa B.O": "304001",
      "Mandawar B.O": "304001",
      "Deoli Bhanchi B.O": "304001",
      "Raj.State Tennries Ltd. B.O": "304001",
      "Mehandwas B.O": "304001",
      "Dhuwan B.O": "304001",
      "Amli B.O": "304023",
      "Bilota B.O": "304023",
      "Deoli B.O": "304023",
      "Kadila B.O": "304501",
      "Raholi B.O": "304022",
      "Ambapura Colony Daulta B.O": "304804",
      "Rajmahal B.O": "304804",
      "Chainpura B.O": "304504",
      "Chosla B.O": "304504",
      "Naner B.O": "304504",
      "Nimera B.O": "304504",
      "Soda B.O": "304504",
      "Banthali B.O": "304802",
      "Charnet B.O": "304026",
      "Gurai B.O": "304026",
      "Rajkot B.O": "304802",
      "Satwara B.O": "304026",
      "Khareda Bujurg B.O": "304025",
      "Nayagaon B.O": "304025",
      "Sirohi B.O": "304025",
      "Antoli B.O": "304503",
      "Budha Dewal B.O": "304503",
      "Aliyari B.O": "304502",
      "Datob B.O": "304502",
      "Kookar B.O": "304502",
      "Siras B.O": "304021",
      "Sohela B.O": "304021",
      "Chandli B.O": "304803",
      "Niwaria B.O": "304803",
      "Bassi B.O": "304505",
      "Ganeti B.O": "304505",
      "Hamirpur B.O": "304505",
      "Indokia B.O": "304505",
      "Khareda B.O": "304505",
      "Mor Bhatiyan B.O": "304505",
      "Jaulan B.O": "304021",
      "Jugalpura B.O": "304021",
      "Khandewat B.O": "304021",
      "Luhara B.O": "304021",
      "Mundia B.O": "304021",
      "Seedra B.O": "304021",
      "Bagdawa B.O": "304801",
      "Dardaturki B.O": "304801",
      "Kashipura B.O": "304801",
      "Loharwara B.O": "304801",
      "Bansera B.O": "304505",
      "Baori B.O": "304505",
      "Barwas B.O": "304505",
      "Thadoli B.O": "304505",
      "Banetha B.O": "304024",
      "Bosariya B.O": "304024",
      "Gothara B.O": "304026",
      "Jhundwa B.O": "304024",
      "Ranipura B.O": "304026",
      "Roop Pura B.O": "304024",
      "Sunthra B.O": "304024",
      "Khandwa B.O": "304021",
      "Parana B.O": "304021",
      "Polyada B.O": "304803",
      "Ranoli B.O": "304801",
      "Sandera B.O": "304801",
      "Bhanwata B.O": "304505",
      "Bisalpur B.O": "304505",
      "Dabardumba B.O": "304505",
      "Kakalwad B.O": "304505",
      "Laxmipura B.O": "304505",
      "Mundia Kalan B.O": "304505",
      "Balithal B.O": "304024",
      "Kachrawata B.O": "304024",
      "Khatoli B.O": "304024",
      "Mohammed Garh B.O": "304024",
      "Natwara B.O": "304021",
      "Pahari B.O": "304021",
      "Rajwas B.O": "304021",
      "Sanwatgarh B.O": "304803",
      "Bagari B.O": "304801",
      "Chogai B.O": "304801",
      "Kathmana B.O": "304801",
      "Phyawadi B.O": "304801",
      "Bhasu B.O": "304505",
      "Lamba Kalan B.O": "304505",
      "Kakor B.O": "304026",
      "Khelniya B.O": "304024",
      "Phuleta B.O": "304026",
      "Roopwas B.O": "304026",
      "Sureli B.O": "304024",
      "Kurar B.O": "304502",
      "Nagar B.O": "304502",
      "Panwalia B.O": "304502",
      "Reendliya Rampura B.O": "304502",
      "Tilanju B.O": "304502",
      "Hatuna B.O": "304021",
      "Rajpura B.O": "304502",
      "Reendliya B.O": "304502",
      "Mandolai B.O": "304502",
      "Mehrun B.O": "304502",
      "Moar B.O": "304502",
      "Tordisagar B.O": "304502",
      "Uniara Khurd B.O": "304502",
      "Beejwad B.O": "304507",
      "Dabar Kalan B.O": "304507",
      "Pachewar B.O": "304502",
      "Parli B.O": "304502",
      "Sanwaria B.O": "304502",
      "Maleda B.O": "304507",
      "Titaria B.O": "304507",
      "Chainpuria B.O": "304021",
      "Dangarthal B.O": "304021",
      "Hisampur B.O": "304507",
      "Thanwala B.O": "304507",
      "Baroni B.O": "304021",
      "Chanani B.O": "304021",
      "Deoli S.O (Tonk)": "304804",
      "Govt.College Tonk S.O": "304001",
      "Malpura S.O": "304502",
      "Panwar S.O": "304803",
      "Purani Tonk S.O": "304001",
      "Aligarh S.O (Tonk)": "304023",
      "Jumma Masjid Tonk S.O": "304001",
      "Quafala Bazar Tonk S.O": "304001",
      "Uniara S.O": "304024",
      "Lambaharisingh S.O": "304503",
      "Deoli Bazar S.O": "304804",
      "Duni S.O (Tonk)": "304802",
      "Nasirda S.O": "304507",
      "Newai RS S.O": "304021",
      "Newai S.O": "304021",
      "Todarai Singh S.O": "304505",
      "Avikanagar S.O": "304501",
      "Banasthali Vidya Peeth S.O": "304022",
      "Diggi S.O": "304504",
      "Jhilai S.O": "304025",
      "Nagarfort S.O": "304026",
      "Peeplu S.O": "304801",
      "Tonk Raj H.O": "304001"
    },
    "BHILWARA": {
      "Mohanpura B.O": "311604",
      "Ralayata B.O": "311604",
      "Sarana B.O": "311604",
      "Shyam Garh B.O": "311604",
      "Palri B.O": "311026",
      "Rupaheli Khurd B.O": "311026",
      "Sirdiyas B.O": "311026",
      "Bagudar B.O": "311202",
      "Bavri B.O": "311202",
      "Bharni Kalan B.O": "311202",
      "Bihada B.O": "311202",
      "Ropan B.O": "311202",
      "Titoda B.O": "311202",
      "Hukumpura B.O": "311407",
      "Kanechan Kalan B.O": "311407",
      "Kanechan Khurd B.O": "311407",
      "Sangari B.O": "311407",
      "Bankda B.O": "311203",
      "Baroda B.O": "311203",
      "Biletha B.O": "311203",
      "Dhor B.O": "311203",
      "Bhopalgarh B.O": "311802",
      "Bhunas B.O": "311802",
      "Deoli B.O": "311802",
      "Gundli B.O": "311802",
      "Gurlan B.O": "311802",
      "Karoi CO B.O": "311802",
      "Kochoria B.O": "311802",
      "Ghadwala Ka Kheda B.O": "311024",
      "Lambia Kalan B.O": "311024",
      "Lambia Khurd B.O": "311024",
      "Borana CO B.O": "311803",
      "Khankhermala B.O": "311803",
      "Kot B.O": "311803",
      "Nahari B.O": "311803",
      "Thana B.O": "311804",
      "Goverdhanpura B.O": "311804",
      "Tumkarwar B.O": "311030",
      "Kanvlias B.O": "311030",
      "Surawas B.O": "311806",
      "Arnia Ghoda B.O": "311404",
      "Arnia Rasa B.O": "311404",
      "Dabla Chanda B.O": "311404",
      "Lulas B.O": "311404",
      "Dantra B.O": "311301",
      "Jagpura B.O": "311204",
      "Ban Ka Kheda B.O": "311011",
      "Bholi B.O": "311011",
      "Danthal B.O": "311011",
      "Haled B.O": "311011",
      "Khedliya B.O": "311011",
      "Kodu Kota B.O": "311011",
      "Almas B.O": "311026",
      "Bhagwanpura B.O": "311026",
      "Bheemdiyas B.O": "311026",
      "Brahmano Ki Sareri B.O": "311026",
      "Paroli B.O": "311202",
      "Atun B.O": "311802",
      "Rampuria B.O": "311804",
      "Sethuria B.O": "311802",
      "Balesaria B.O": "311024",
      "Bera B.O": "311024",
      "Dholi B.O": "311024",
      "Lambia Station B.O": "311024",
      "Motipur B.O": "311024",
      "Sarewadi B.O": "311803",
      "Thala B.O": "311605",
      "Umari B.O": "311803",
      "Bemali B.O": "311804",
      "Bhabhana B.O": "311804",
      "Chileshwar B.O": "311804",
      "Chitamba B.O": "311804",
      "Gyangarh B.O": "311804",
      "Kasuriya B.O": "311030",
      "Majhawas B.O": "311806",
      "Negdia Ka Khera B.O": "311806",
      "Satliyas B.O": "311806",
      "Bachkhera B.O": "311404",
      "Basera B.O": "311404",
      "Mata Ji Ka Khera B.O": "311404",
      "Mindolia B.O": "311404",
      "Mahula B.O": "311404",
      "Khejri B.O": "311204",
      "Motras B.O": "311204",
      "Lasadiya B.O": "311011",
      "Mahuwakhurd B.O": "311011",
      "Rupaheli B.O": "311011",
      "Malka Khera B.O": "311606",
      "Manpura B.O": "311604",
      "Srinagar B.O": "311604",
      "Kabradia B.O": "311026",
      "Keriya B.O": "311026",
      "Gandher B.O": "311202",
      "Lasadia B.O": "311202",
      "Dohriya B.O": "311407",
      "Taswaria Basa B.O": "311407",
      "Bai B.O": "311203",
      "Gudha B.O": "311602",
      "Shakkargarh B.O": "311203",
      "Dariba B.O": "311802",
      "Dudiya B.O": "311802",
      "Mahendragarh B.O": "311802",
      "Pansal B.O": "311802",
      "Iras B.O": "311024",
      "Kundia Kalan B.O": "311024",
      "Sodar B.O": "311024",
      "Bheeta B.O": "311803",
      "Narayan Khera B.O": "311803",
      "Palran B.O": "311803",
      "Amalda CO B.O": "311804",
      "Dhuwala B.O": "311403",
      "Marewada B.O": "311804",
      "Bhojras B.O": "311030",
      "Dabla B.O": "311030",
      "Khankhala B.O": "311806",
      "Salera B.O": "311806",
      "Borda B.O": "311603",
      "Dabla Kachra B.O": "311404",
      "Kaniya B.O": "305625",
      "Kadisahna B.O": "311404",
      "Rahad B.O": "311404",
      "Akarsada B.O": "311204",
      "Barsani B.O": "311204",
      "Badla B.O": "311021",
      "Kanda B.O": "311011",
      "Mangthala B.O": "311606",
      "Singoli B.O": "311604",
      "Ganglas B.O": "311026",
      "Karjaliya B.O": "311026",
      "Bishniya B.O": "311202",
      "Jamoli B.O": "311202",
      "Titodi B.O": "311202",
      "Deoriya B.O": "311407",
      "Khajuri B.O": "311203",
      "Ullela B.O": "311203",
      "Dhosar B.O": "311802",
      "Malola B.O": "311802",
      "Sanganer B.O": "311011",
      "Baldarkha CO B.O": "311408",
      "Bamnia B.O": "311408",
      "Phulia Khurd B.O": "311408",
      "Taswaria Khurd B.O": "311408",
      "Pithas B.O": "311802",
      "Gendliya B. O.": "311025",
      "Jitya B.O": "311025",
      "Kherabad B.O": "311025",
      "Mangrop B.O": "311025",
      "Amarwasi B.O": "311201",
      "Uncha B.O": "311201",
      "Bhagunagar B.O": "311605",
      "Dhamnia B.O": "311605",
      "Kheruna B.O": "311605",
      "Rajgarh B.O": "311605",
      "Arwar B.O": "311023",
      "Dhanop B.O": "311023",
      "Kotri Bhado Ki B.O": "311023",
      "Chhaprel B.O": "311603",
      "Gega Ka Khera B.O": "311603",
      "Sankda B.O": "311603",
      "Swaipur B.O": "311603",
      "Baldarkha B.O": "311604",
      "Kaliyas B.O": "311024",
      "Sareri CO B.O": "311024",
      "Nathdiyas B.O": "311803",
      "Pitha Ka Khera B.O": "311803",
      "Sagreo B.O": "311803",
      "Bagolia B.O": "311804",
      "Dahimatha B.O": "311804",
      "Gorkhiya B.O": "311804",
      "Nimbahera Jatan B.O": "311804",
      "Shivpur B.O": "311804",
      "Barantia B.O": "311030",
      "Gharta B.O": "311030",
      "Kangani B.O": "311806",
      "Potlan B.O": "311806",
      "Sargaon B.O": "311806",
      "Amli Kalan B.O": "311404",
      "Bhojpur B.O": "311404",
      "Biliya B.O": "311404",
      "Dhikola B.O": "311404",
      "Pratappura B.O": "311404",
      "Ragurajpura B.O": "311404",
      "Tehnal B.O": "311404",
      "Amesar B.O": "311204",
      "Antali B.O": "311204",
      "Phalamada B.O": "311204",
      "Sangramgarh B.O": "311204",
      "Arjiya B.O": "311011",
      "Seedriyas B.O": "311011",
      "Itmaria B.O": "311408",
      "Nimbahera Kalan B.O": "311408",
      "Satola Ka Khera B.O": "311011",
      "Udliyas B.O": "311011",
      "Megras B.O": "311408",
      "Munshi B.O": "311408",
      "Chainpura B.O": "311301",
      "Darawat CO B.O": "311301",
      "Daulatgarh B.O": "311301",
      "Pura B.O": "311302",
      "Rampura B.O": "311302",
      "Adsipura B.O": "311402",
      "Kankolia B.O": "311401",
      "Kunwar B.O": "311401",
      "Rakshi B.O": "311401",
      "Richda B.O": "311401",
      "Salriya Kalan B.O": "311401",
      "Sardarnagar B.O": "311401",
      "Dhakarkhedi B.O": "311601",
      "Jawal B.O": "311601",
      "Makredi B.O": "311602",
      "Naya Nagar B.O": "311602",
      "Ganeshpura B.O": "311801",
      "Lakhola B.O": "311801",
      "Nandsha B.O": "311801",
      "Soniyana B.O": "311801",
      "Parasoli B.O": "311301",
      "Ragunathpura B.O": "311301",
      "Ratanpura B.O": "311301",
      "Rooppura B.O": "311301",
      "Tiloli B.O": "311301",
      "Jaitgarh B.O": "311302",
      "Khedela B.O": "311302",
      "Mogar B.O": "311302",
      "Ojhiyana B.O": "311302",
      "Patan B.O": "311302",
      "Bavlas B.O": "311402",
      "Boriapura B.O": "311402",
      "Joravarpura B.O": "311402",
      "Leswa B.O": "311402",
      "Sangwa B.O": "311402",
      "Tunka B.O": "311402",
      "Nandrai B.O": "311601",
      "Suras B.O": "311403",
      "Aroli B.O": "311602",
      "Bhopatpura B.O": "311602",
      "Gopalpura B.O": "311602",
      "Amli B.O": "311025",
      "Arnia B.O": "311801",
      "Ashaholi B.O": "311801",
      "Bharak B.O": "311801",
      "Lamba Khari Ka B.O": "311021",
      "Pipli B.O": "311025",
      "Borani B.O": "311201",
      "Gadoli B.O": "311201",
      "Kuradia B.O": "311201",
      "Sarsiya B.O": "311201",
      "Jhanjhola B.O": "311605",
      "Chawandia B.O": "311805",
      "Ullai B.O": "311805",
      "Itdiya B.O": "311023",
      "Barliyas B.O": "311603",
      "Jeeva Ka Khera B.O": "311603",
      "Kothaj B.O": "311603",
      "Mansha B.O": "311603",
      "Redwas B.O": "311603",
      "Bhadu B.O": "311403",
      "Meja B.O": "311403",
      "Bikaran B.O": "311606",
      "Bajunda B.O": "311301",
      "Borela B.O": "311301",
      "Jhalriya B.O": "311301",
      "Kidimal B.O": "311301",
      "Negdia B.O": "311301",
      "Bhojpura B.O": "311302",
      "Ghodas B.O": "311402",
      "Bara Mahuwa B.O": "311401",
      "Chamanpura B.O": "311401",
      "Jalia B.O": "311601",
      "Jojwa B.O": "311601",
      "Khatwara B.O": "311601",
      "Bikampura B.O": "311602",
      "Kasya Kala B.O": "311602",
      "Tharoda B.O": "311602",
      "Uma Ji Ka Kheda B.O": "311602",
      "Cheerkheda B.O": "311801",
      "Shivrati B.O": "311801",
      "Barana B.O": "311301",
      "Katar B.O": "311301",
      "Kavlas B.O": "311301",
      "Lachura B.O": "311301",
      "Bhadsi B.O": "311302",
      "Chatarpur B.O": "311302",
      "Chandras B.O": "311402",
      "Gageda B.O": "311021",
      "Taswariya B.O": "311021",
      "Suthepa B.O": "311025",
      "Swaroopganj B.O": "311025",
      "Itunda B.O": "311201",
      "Luharikala B.O": "311201",
      "Rawatkhera B.O": "311201",
      "Amalda B.O": "311605",
      "Amargarh B.O": "311605",
      "Galwa B.O": "311805",
      "Jhadol B.O": "311805",
      "Khemana B.O": "311805",
      "Mokhunda B.O": "311805",
      "Birdhol B.O": "311603",
      "Reeth B.O": "311603",
      "Chankhed B.O": "311403",
      "Laduwas B.O": "311403",
      "Luhariya B.O": "311403",
      "Jalindri B.O": "311606",
      "Kalyanpura B.O": "311604",
      "Khachrol B.O": "311604",
      "Ladpura B.O": "311604",
      "Babrana B.O": "311401",
      "Baran B.O": "311401",
      "Kalsans B.O": "311401",
      "Kankrolia B.O": "311601",
      "Kishangarh B.O": "311601",
      "Bijolia Khurd B.O": "311602",
      "Chand Ji Ki Kheri B.O": "311602",
      "Salawatia B.O": "311602",
      "Tiliswa B.O": "311602",
      "Delana B.O": "311801",
      "Jalampura B.O": "311021",
      "Ama B.O": "311025",
      "Bardod B.O": "311025",
      "Ojayada B.O": "311025",
      "Agucha B.O": "311022",
      "Gangithala B.O": "311201",
      "Tikar B.O": "311201",
      "Jassu Ji Ka Khera B.O": "311605",
      "Manoharpura B.O": "311605",
      "Sarthala B.O": "311605",
      "Titoda Tehla B.O": "311605",
      "Deoria B.O": "311805",
      "Nandsha J B.O": "311805",
      "Khamore B.O": "311023",
      "Sangria B.O": "311023",
      "Akola B.O": "311603",
      "Gahuli B.O": "311603",
      "Rased B.O": "311603",
      "Baori B.O": "311403",
      "Santokpura B.O": "311403",
      "Barundani B.O": "311604",
      "Genoli B.O": "311604",
      "Mahuwa B.O": "311604",
      "Bhilwara H.O": "311001",
      "Badnore S.O": "311302",
      "Bhilwara Court S.O": "311001",
      "Bigod S.O": "311601",
      "Hamirgarh S.O": "311025",
      "Hurda S.O": "311022",
      "Jahazpur S.O": "311201",
      "Kachola S.O": "311605",
      "Mandal S.O (Bhilwara)": "311403",
      "Mod Ka Nimbahera S.O": "311026",
      "Railagaon S.O": "311024",
      "Rupaheli S.O": "311030",
      "Sahada S.O": "311806",
      "Subhash Nagar Bhilwara S.O": "311001",
      "Banera S.O": "311401",
      "Bapunagar Bhilwara S.O": "311001",
      "Bhilwara City S.O": "311001",
      "Bhilwara Rly Station S.O": "311001",
      "Gulabpura S.O": "311021",
      "Koshithal S.O": "311805",
      "Kotri S.O (Bhilwara)": "311603",
      "Phulia Kalan S.O": "311407",
      "Shastri Nagar Gangapur S.O": "311801",
      "Suwana S.O": "311011",
      "Shyampura S. O.": "311606",
      "Asind S.O": "311301",
      "Azad Nagar S.O (Bhilwara)": "311001",
      "Bagore S.O": "311402",
      "Gangapur (Bhilwara) S.O": "311801",
      "Kothian S.O": "311023",
      "Labour Colony S.O (Bhilwara)": "311001",
      "Piplund S.O": "311203",
      "Pur S.O (Bhilwara)": "311802",
      "Raja Ji Ka Kareda S.O": "311804",
      "Shahpura Raj S.O": "311404",
      "Upreda S.O": "311408",
      "Bijolian S.O": "311602",
      "Indra Market S.O": "311001",
      "Kashipuri Bhilwara S.O": "311001",
      "Krisi Upaj Mandi Bwa S.O": "311001",
      "Kundgate Shahpura S.O": "311404",
      "Mandalgarh S.O": "311604",
      "Pander S.O": "311202",
      "Raipur S.O (Bhilwara)": "311803",
      "Shambhugarh S.O": "311204"
    },
    "PALI": {
      "Itendra Mertiyan B.O": "306119",
      "Khatukara B.O": "306119",
      "Khinawari B.O": "306302",
      "Lototi B.O": "306302",
      "Patwa B.O": "306302",
      "Phoolmal B.O": "306302",
      "Saleriya B.O": "306119",
      "Asarlai B.O": "306303",
      "Mohrai B.O": "306303",
      "Bansiya B.O": "306307",
      "Guriya B.O": "306307",
      "Beethu B.O": "306421",
      "Chotila B.O": "306421",
      "Dhabar Kalan B.O": "306421",
      "Diwandi B.O": "306421",
      "Dudiya B.O": "306421",
      "Khandi B.O": "306421",
      "Kharda B.O": "306603",
      "Kulthana B.O": "306421",
      "Babagaon B.O": "306708",
      "Amarpura B.O": "306102",
      "Chang B.O": "306102",
      "Toonkra B.O": "306102",
      "Nadana bhatan B.O": "306119",
      "Bagiara B.O": "306305",
      "Chawandiya B.O": "306305",
      "Karmawas Patta B.O": "306307",
      "Mohra   Kalan B.O": "306307",
      "Jhoontha B.O": "306304",
      "Pachanpura B.O": "306304",
      "Pawa B.O": "306708",
      "Sindru B.O": "306708",
      "Kanuja B.O": "306102",
      "Ratadiya B.O": "306102",
      "Relra B.O": "306102",
      "Chadwas B.O": "306104",
      "Roopawas B.O": "306104",
      "Shivpura B.O": "306104",
      "B.M.G. Hospital Ramnagar B.O": "306902",
      "Fattapura B.O": "306902",
      "Kanpura B.O": "306902",
      "Chopra B.O": "306104",
      "Dhakri B.O": "306104",
      "Ramasani   Bala B.O": "306104",
      "Reprawas B.O": "306104",
      "Jhujanda B.O": "306302",
      "Ramawas B.O": "306302",
      "Talkiya B.O": "306302",
      "Jawali B.O": "306119",
      "Leelamba B.O": "306305",
      "Sangawas B.O": "306303",
      "Raira Kalan B.O": "306307",
      "Haripur B.O": "306304",
      "Kalab kalan B.O": "306304",
      "Gelawas B.O": "306421",
      "Mandawas B.O": "306421",
      "Basant B.O": "306708",
      "Kheemara B.O": "306708",
      "Giri B.O": "306102",
      "Nanana B.O": "306102",
      "Beelawas B.O": "306104",
      "Dhinawas B.O": "306104",
      "Mandla B.O": "306104",
      "Meo B.O": "306104",
      "Surayta B.O": "306104",
      "Netra B.O": "306902",
      "Pomawa B.O": "306902",
      "Gogra B.O": "306912",
      "Rajadand B.O": "306302",
      "Raniwal B.O": "306302",
      "Dhariya B.O": "306119",
      "Karmawas Maliyan B.O": "306305",
      "Nimbera  Kalan B.O": "306305",
      "Barsa B.O": "306001",
      "Chawadiya B.O": "306001",
      "Khariya Soda B.O": "306001",
      "Karadi B.O": "306001",
      "Khardi B.O": "306001",
      "Kharchi B.O": "306001",
      "Sinla B.O": "306308",
      "Chelawas B.O": "306001",
      "Deoli Auwa B.O": "306021",
      "Guda Kesarsingh B.O": "306021",
      "Sabalpura B.O": "306307",
      "Deepawas B.O": "306304",
      "Bayad B.O": "306421",
      "Chenda B.O": "306421",
      "Gadwara B.O": "306421",
      "Kalali B.O": "306421",
      "Rohat R.S. B.O": "306421",
      "Dujana B.O": "306708",
      "Koselao B.O": "306708",
      "Bootiwas B.O": "306102",
      "Chittar B.O": "306102",
      "Atabara B.O": "306104",
      "Hingawas B.O": "306104",
      "Khariya neev B.O": "306104",
      "Rajola   Kalan B.O": "306104",
      "Koliwara B.O": "306902",
      "Palri jod B.O": "306902",
      "Balana B.O": "306912",
      "Basna B.O": "306306",
      "Agewa B.O": "306302",
      "Ber   Kalan B.O": "306302",
      "Bithora Kallan B.O": "306001",
      "Hemliyawas Khurd B.O": "306001",
      "Isali B.O": "306021",
      "Kirana B.O": "306105",
      "Mesiya B.O": "306105",
      "Rampura   Kalan B.O": "306306",
      "Sandiya B.O": "306306",
      "Ghorawar B.O": "306709",
      "Rabriyawas B.O": "306709",
      "Balrai B.O": "306422",
      "Deegai B.O": "306422",
      "Kalaliya B.O": "306105",
      "Deoli Kalan B.O": "306306",
      "Murdawa B.O": "306306",
      "Dhola B.O": "306422",
      "Keerwa B.O": "306422",
      "Deoria B.O": "306302",
      "Anoppura B.O": "306602",
      "Beethora B.O": "306602",
      "Basni Jojawar B.O": "306022",
      "Bhagora B.O": "306022",
      "Dhanla B.O": "306022",
      "Kot  Solankiyan B.O": "306022",
      "Hingola Khurd B.O": "306501",
      "Bagol B.O": "306502",
      "Barwa B.O": "306706",
      "Mirgesar B.O": "306706",
      "Panchalwara B.O": "306705",
      "Sheotalao B.O": "306705",
      "Neepal B.O": "306603",
      "Prithviraj Ka Gurha B.O": "306603",
      "Bhandar B.O": "306504",
      "Bheemana B.O": "306504",
      "Bopari B.O": "306023",
      "Saran B.O": "306023",
      "Seeriyari B.O": "306023",
      "Mandigarh B.O": "306702",
      "Ranakpur B.O": "306702",
      "Sindharli B.O": "306702",
      "Bhaisana B.O": "306103",
      "Bornadi B.O": "306103",
      "Guda Kalan B.O": "306103",
      "Kantaliya B.O": "306103",
      "Manda B.O": "306103",
      "Musaliya B.O": "306103",
      "Bhadarlau B.O": "306503",
      "Dutariya B.O": "306503",
      "Inderwara B.O": "306503",
      "Neembara B.O": "306503",
      "Panchetiya B.O": "306503",
      "Tewali B.O": "306503",
      "Dari B.O": "306401",
      "Rupawas B.O": "306401",
      "Jhintra B.O": "306401",
      "Kerla B.O": "306401",
      "Sumel B.O": "306101",
      "Digarna B.O": "306308",
      "Kharadi B.O": "306308",
      "Nimbol B.O": "306308",
      "Balupura B.O": "306901",
      "Hajiwas B.O": "306105",
      "Chanddawal R.S. B.O": "306306",
      "Khokhra B.O": "306306",
      "Balada B.O": "306709",
      "Denda B.O": "306422",
      "Guda Endla B.O": "306422",
      "Koorna B.O": "306422",
      "Birol B.O": "306302",
      "Garniya B.O": "306302",
      "Gajnai B.O": "306114",
      "Guda Binja B.O": "306114",
      "Kelwad B.O": "306114",
      "Khodiya B.O": "306114",
      "Dantiwara B.O": "306701",
      "Sela B.O": "306701",
      "Dadai B.O": "306601",
      "SAKADARA B.O.": "306602",
      "Bera B.O": "306126",
      "Bisalpur B.O": "306126",
      "Gajnipura B.O": "306502",
      "Ghenri B.O": "306502",
      "Magartalab B.O": "306502",
      "Siwas B.O": "306502",
      "Bheetwara B.O": "306705",
      "Morkha B.O": "306705",
      "Deoli Pabuji B.O": "306603",
      "Jeewand Kalan B.O": "306603",
      "Kishanpura B.O": "306603",
      "Malnoo B.O": "306504",
      "Guda Soorsingh B.O": "306023",
      "Malsabaori B.O": "306023",
      "Phulad B.O": "306023",
      "Radawas B.O": "306023",
      "Dhana B.O": "306115",
      "Itendra Charnan B.O": "306115",
      "Kheemel B.O": "306115",
      "Lapod B.O": "306115",
      "Beejapur B.O": "306707",
      "Hariyamali B.O": "306103",
      "Neembli  Manda B.O": "306103",
      "Bhakriwala B.O": "306401",
      "Bhanwari B.O": "306401",
      "Manihari B.O": "306401",
      "Mandiya B.O": "306401",
      "Bhoombaliya B.O": "306301",
      "Kekindra B.O": "306301",
      "Piplad B.O": "306114",
      "Boya B.O": "306701",
      "Varkana B.O": "306601",
      "Ana B.O": "306703",
      "Sumer B.O": "306703",
      "Dhani B.O": "306116",
      "Kakaradi B.O": "306126",
      "Perwa B.O": "306126",
      "Sansari B.O": "306022",
      "Dhamli B.O": "306501",
      "Lambiya B.O": "306301",
      "Dayalana B.O": "306502",
      "Pilowani B.O": "306502",
      "Wandar B.O": "306502",
      "Lalrai B.O": "306705",
      "Kesooli B.O": "306603",
      "Amaliya B.O": "306504",
      "Chamunderi B.O": "306504",
      "Koyalbao B.O": "306504",
      "Chirpatiya B.O": "306023",
      "Gadhana B.O": "306023",
      "Thakurwas B.O": "306023",
      "Chanchori B.O": "306115",
      "Mandal B.O": "306115",
      "Rani Gaon B.O": "306115",
      "Vidhyawari B.O": "306115",
      "Mada B.O": "306702",
      "Goriya B.O": "306707",
      "Alawas B.O": "306103",
      "Dhundhla B.O": "306103",
      "Rendri B.O": "306103",
      "Sehwaj B.O": "306103",
      "Banta Town B.O": "306503",
      "Bheemaliya B.O": "306503",
      "Sodawas B.O": "306503",
      "Thakurla B.O": "306503",
      "Sonai Manji B.O": "306401",
      "Jadan B.O": "306401",
      "Bomadra B.O": "306401",
      "Dayalpura B.O": "306401",
      "Kanwaliya  Kalan B.O": "306301",
      "Bamnera B.O": "306901",
      "Khiwandi B.O": "306901",
      "Birantiya Kalan B.O": "306105",
      "Pratap   Garh B.O": "306101",
      "Ras B.O": "306101",
      "Sewariya B.O": "306101",
      "Novi B.O": "306901",
      "Bagri Kalaliya B.O": "306105",
      "Deoli Hulla B.O": "306114",
      "Pachunda   Kalan B.O": "306114",
      "Kot  Baliyan B.O": "306701",
      "Narlai B.O": "306703",
      "Deotra B.O": "306116",
      "Falna Village B.O": "306116",
      "Dudapura B.O": "306704",
      "Dudni B.O": "306126",
      "Mori Bera B.O": "306126",
      "Panota B.O": "306022",
      "Sapooni B.O": "306501",
      "Kerli B.O": "306502",
      "Raipuriya B.O": "306502",
      "Sesli B.O": "306706",
      "Gudalass B.O": "306705",
      "Latara B.O": "306705",
      "Dhalop B.O": "306603",
      "Kotri B.O": "306603",
      "Sanwalta B.O": "306603",
      "Kothar B.O": "306504",
      "Kumatiya B.O": "306504",
      "Borimada B.O": "306023",
      "Chokariya B.O": "306023",
      "Beerami B.O": "306115",
      "Mokampura B.O": "306115",
      "Barod B.O": "306702",
      "Bhatund B.O": "306707",
      "Padarla B.O": "306707",
      "Sena B.O": "306707",
      "Babhan B.O": "306103",
      "Guda shama B.O": "306103",
      "Jeejardi B.O": "306103",
      "Rajola   Khurd B.O": "306103",
      "Sawrad B.O": "306103",
      "Seesarwada B.O": "306103",
      "Shekhawas B.O": "306103",
      "Siyat B.O": "306103",
      "Boosi B.O": "306503",
      "Bhangesar B.O": "306401",
      "Rana B.O": "306401",
      "Giradra B.O": "306401",
      "Sardar Samand B.O": "306401",
      "Neembli Uran B.O": "306401",
      "Hemawas B.O": "306401",
      "Falka   Kalan B.O": "306301",
      "Dhaneriya B.O": "306101",
      "Auwa R.S. B.O": "306001",
      "Hemliyawas Kala B.O": "306001",
      "Dhareshwar B.O": "306001",
      "Guda Ramsingh B.O": "306021",
      "Januda B.O": "306021",
      "Kurki B.O": "306101",
      "Banjakuri B.O": "306308",
      "Bharunda B.O": "306901",
      "Korta B.O": "306901",
      "Birantiya Khurd B.O": "306105",
      "Pali Marwar H.O": "306401",
      "Jojawar S.O": "306022",
      "Khairwa S.O": "306501",
      "Mundara S.O": "306705",
      "Nadol S.O": "306603",
      "Sojat  Road S.O": "306103",
      "Somesar S.O": "306503",
      "Bar S.O": "306105",
      "Chandawal S.O": "306306",
      "Khod S.O": "306119",
      "Kushalpura S.O": "306305",
      "Pali Industrial Estate S.O": "306401",
      "Pali Kutchery S.O": "306401",
      "Pipliya Kalan S.O": "306307",
      "Sojat Bazar S.O": "306104",
      "Sojat S.O": "306104",
      "Tagatgarh S.O": "306912",
      "Marwar Jn. H.O": "306001",
      "Auwa S.O": "306021",
      "Bali S.O": "306701",
      "Bijowa S.O": "306601",
      "Desuri S.O": "306703",
      "Falna S.O": "306116",
      "Khinwara S.O": "306502",
      "Lunawa S.O": "306706",
      "Nana S.O": "306504",
      "Ranawas S.O": "306023",
      "Anandpur Kalu S.O": "306301",
      "Dlf Rabriyawas S.O": "306709",
      "Gundoj S.O": "306422",
      "Nimaj S.O": "306303",
      "Pali  Housing Board S.O": "306401",
      "Pali City S.O": "306401",
      "Pali Railway Station S.O": "306401",
      "Pali Veer Durgadas  Nagar S.O": "306401",
      "Sanderao S.O": "306708",
      "Sumerpur S.O": "306902",
      "Chanod S.O": "306602",
      "Rani S.O (Pali)": "306115",
      "Rani Sadar Bazar S.O": "306115",
      "Sadri S.O": "306702",
      "Balunda S.O": "306308",
      "Jaitaran S.O": "306302",
      "Raipur  Marwar S.O": "306304",
      "Sumerpur Krishi Upaj Mandi S.O": "306902",
      "Bagri Nagar S.O": "306114",
      "Falna  I. E. S.O": "306116",
      "Ghanerao S.O": "306704",
      "Jawai  Bandh S.O": "306126",
      "Sewari S.O": "306707",
      "Babra S.O (Pali)": "306101",
      "Bankli S.O": "306901",
      "Rohat S.O (Pali)": "306421",
      "Sendra S.O": "306102"
    },
    "GANGANAGAR": {
      "Thandewala B.O": "335024",
      "Zorawarpura B.O": "335024",
      "9 Ml B.O": "335025",
      "Bakhtanwali B.O": "335025",
      "Ladhuwala B.O": "335025",
      "Narsinghpura B.O": "335025",
      "2 Rkma B.O": "335707",
      "Chak 22 RJD B.O": "335708",
      "Chak 4 KPD B.O": "335708",
      "7 Gd B.O": "335711",
      "Chak 7 KND B.O": "335708",
      "Kotha B.O": "335901",
      "Pakki B.O": "335901",
      "Sujawalpur B.O": "335901",
      "6 Gb B.O": "335702",
      "Bugia B.O": "335702",
      "Jankidaswala B.O": "335702",
      "Sarupsar B.O": "335702",
      "19 F B.O": "335027",
      "Arayan B.O": "335027",
      "Gulabewala B.O": "335027",
      "1 Sm B.O": "335707",
      "Chak 2 KLD B.O": "335708",
      "Khanuwali B.O": "335708",
      "Malkana Khurd B.O": "335027",
      "Mohlan B.O": "335027",
      "CHAK 2 V B.O": "335027",
      "Morjand Khari B.O": "335037",
      "10 Z B.O": "335001",
      "11 Z B.O": "335001",
      "19 Z B.O": "335038",
      "6tk B.O": "335039",
      "Dabla B.O": "335039",
      "Jhotanwali B.O": "335039",
      "Udsar B.O": "335039",
      "10TK B.O": "335039",
      "50gg B.O": "335040",
      "Dharinganwali B.O": "335040",
      "Kharlan B.O": "335040",
      "23bb B.O": "335041",
      "29bb B.O": "335041",
      "12 H B.O": "335711",
      "13 M D B.O": "335711",
      "2 K M B.O": "335711",
      "Phusewala B.O": "335038",
      "Sangetpura B.O": "335038",
      "5tk B.O": "335039",
      "6cc B.O": "335041",
      "8nn B.O": "335041",
      "Bhadwanwala B.O": "335051",
      "Fozuwala B.O": "335051",
      "Karadwali B.O": "335051",
      "Satzanda B.O": "335051",
      "Shyamgarh B.O": "335051",
      "Thakri B.O": "335051",
      "Jorkian B.O": "335041",
      "Sanwatsar B.O": "335021",
      "16BB B.O": "335041",
      "Tamkot B.O": "335041",
      "41RB B.O": "335041",
      "11ps B.O": "335051",
      "22ps B.O": "335051",
      "67rb B.O": "335051",
      "68np B.O": "335051",
      "Bhompura B.O": "335051",
      "Sukhchainpura B.O": "335051",
      "65gb B.O": "335703",
      "70gb B.O": "335703",
      "Pharsewala B.O": "335061",
      "Ratanpura B.O": "335061",
      "Banwali B.O": "335062",
      "Dalianwali B.O": "335062",
      "12 Gb B.O": "335704",
      "40 Gb B.O": "335704",
      "Khyaliwala B.O": "335024",
      "Motasarkhuni B.O": "335024",
      "Sangrana B.O": "335024",
      "Chak 10 KD B.O": "335708",
      "Chak 12 KND B.O": "335708",
      "2 Gmb B.O": "335707",
      "7 Mld B.O": "335707",
      "Khobar B.O": "335708",
      "12 MLD B.O": "335707",
      "Khakhan B.O": "335901",
      "Kaminpura B.O": "335027",
      "Sardarpura Jiwan B.O": "335037",
      "Patroda B.O": "335711",
      "23 Z B.O": "335038",
      "Bakhtana B.O": "335038",
      "31ml B.O": "335039",
      "13ff B.O": "335040",
      "40f B.O": "335040",
      "2rb B.O": "335041",
      "42 Gb B.O": "335704",
      "5 As B.O": "335704",
      "Kalyankote B.O": "335704",
      "Raghunathpura B.O": "335704",
      "Bilochia B.O": "335704",
      "42 H B.O": "335073",
      "47 F B.O": "335073",
      "Burjwala B.O": "335073",
      "Danewala B.O": "335073",
      "8 Shpd B.O": "335705",
      "Badopal B.O": "335073",
      "Mokalsar B.O": "335804",
      "Narwana B.O": "335804",
      "Rajiasar B.O": "335804",
      "15blda B.O": "335703",
      "15lm B.O": "335703",
      "2a B.O": "335703",
      "72gb B.O": "335703",
      "74gb B.O": "335703",
      "9lm B.O": "335703",
      "1 Ps B.O": "335061",
      "Khatsajwar B.O": "335062",
      "Manniwali B.O": "335062",
      "Noorpura B.O": "335062",
      "Bhopalpura B.O": "335704",
      "15 o B.O": "335073",
      "3 o B.O": "335073",
      "Naggi B.O": "335073",
      "Roopnagar B.O": "335073",
      "Tejewala B.O": "335073",
      "14 S Majhiwala B.O": "335073",
      "Farm Colony Suratgarh B.O": "335804",
      "Ghamandia B.O": "335804",
      "Ramsara Jakhran B.O": "335804",
      "Sardarpura Bika B.O": "335804",
      "Somasar B.O": "335805",
      "Thukrana B.O": "335805",
      "Chak 2ll B.O": "335002",
      "Dharmsinghwala B.O": "335002",
      "Govindpura B.O": "335002",
      "Khayaliwala B.O": "335002",
      "5 EEA B.O": "335041",
      "Fakirwali B.O": "335041",
      "Jalloki B.O": "335041",
      "71rb B.O": "335051",
      "Bagicha B.O": "335051",
      "Mohannagar B.O": "335051",
      "Mokamwala B.O": "335051",
      "Ganguwala B.O": "335051",
      "48gba B.O": "335703",
      "61gb B.O": "335703",
      "Kupli B.O": "335703",
      "54 Lnp B.O": "335061",
      "Fakirwali Kothi B.O": "335061",
      "Alipura B.O": "335062",
      "Budharwali B.O": "335062",
      "Chhapanwali B.O": "335062",
      "Gadderkhera B.O": "335062",
      "17 Gb B.O": "335704",
      "25 Gb B.O": "335704",
      "4 Bld B.O": "335704",
      "Govindsar B.O": "335704",
      "6 o B.O": "335073",
      "Baringa B.O": "335073",
      "Majhiwala B.O": "335073",
      "Bhagwansar B.O": "335804",
      "Birdwal Head B.O": "335804",
      "Manaksar B.O": "335804",
      "Manaktheri B.O": "335804",
      "Padampura B.O": "335804",
      "Rajpura Pipran B.O": "335804",
      "Mahiyanwali B.O": "335002",
      "Nathwala B.O": "335002",
      "Sihaganwali B.O": "335002",
      "Rajpura B.O": "335024",
      "Chak 13 DOL B.O": "335708",
      "5 Psd B.O": "335707",
      "Rojari B.O": "335707",
      "Dullapur Kerri B.O": "335901",
      "Orki B.O": "335901",
      "7 Lc B.O": "335702",
      "Raghunathgarh B.O": "335702",
      "Jetsar Farm B.O": "335702",
      "Gurusar B.O": "335027",
      "Malkana Kalan B.O": "335027",
      "Panniwali B.O": "335037",
      "6 D D B.O": "335711",
      "Satrana B.O": "335711",
      "3 C Chotti B.O": "335038",
      "Daulatpura B.O": "335038",
      "Matili Rathan B.O": "335038",
      "Sahibsinghwala B.O": "335038",
      "16ps B.O": "335039",
      "19ps B.O": "335039",
      "3mk B.O": "335039",
      "14ff B.O": "335040",
      "Srinagar B.O": "335040",
      "4nn B.O": "335041",
      "5nn B.O": "335041",
      "Binjbaila B.O": "335041",
      "Delwan B.O": "335041",
      "3 Y B.O": "335001",
      "Chak 5 Ll B.O": "335001",
      "Rohirawali Suthran B.O": "335001",
      "Khatlabana B.O": "335001",
      "Rohiranwali Rathan B.O": "335001",
      "1lsm9(Bada Colony) B.O": "335701",
      "Khokharanwali B.O": "335701",
      "Lakhahakam B.O": "335021",
      "Chak 4 G Choti B.O": "335022",
      "Ghamoorwali B.O": "335041",
      "9ps B.O": "335051",
      "Bajuwala B.O": "335051",
      "Likhmewala B.O": "335051",
      "Nanuwala B.O": "335051",
      "Thandi B.O": "335051",
      "Kikarwali B.O": "335051",
      "3nd B.O": "335703",
      "51gb B.O": "335703",
      "Gomanwali B.O": "335703",
      "Nahranwali B.O": "335703",
      "69 Lnp B.O": "335061",
      "Harkhewala B.O": "335061",
      "Hakamabada B.O": "335062",
      "Karadwala B.O": "335062",
      "3 F D M B.O": "335705",
      "19 Gb B.O": "335704",
      "Birmana B.O": "335704",
      "Gudli B.O": "335704",
      "61 F B.O": "335073",
      "Mukan Pabusar B.O": "335073",
      "Radewala B.O": "335073",
      "Birdhwal R.S.(Suratgarh) B.O": "335805",
      "Deidaspura B.O": "335804",
      "Hindor B.O": "335804",
      "Maler B.O": "335804",
      "Rampura B.O": "335804",
      "Rampura Neola B.O": "335804",
      "Rayanwali B.O": "335805",
      "Thethar B.O": "335805",
      "Chak 13 Lnp B.O": "335002",
      "Kundlawala B.O": "335002",
      "Netewala B.O": "335002",
      "Chak 4bb B.O": "335022",
      "Chak 5 Kk B.O": "335022",
      "Chak 6 G Choti B.O": "335022",
      "Chak 2 X B.O": "335023",
      "Mohanpura B.O": "335001",
      "Sadhuwali B.O": "335001",
      "Chak 22 A B.O": "335701",
      "Chak 27 A B.O": "335701",
      "Chak 86 Gb B.O": "335701",
      "Chak15 A B.O": "335701",
      "Chak 1 KK B.O": "335022",
      "Dhingawali B.O": "335022",
      "Gudhuwala B.O": "335022",
      "Jodhewala B.O": "335022",
      "Kalian B.O": "335001",
      "Maderan B.O": "335001",
      "15 Z B.O": "335001",
      "Fathui B.O": "335001",
      "78 Gb B.O": "335701",
      "Banda B.O": "335701",
      "Kamrania B.O": "335701",
      "41 Ps B.O": "335021",
      "Khatan B.O": "335021",
      "Sameja(15 PTD) B.O": "335021",
      "Chak 27 Gg B.O": "335022",
      "Sagarwala B.O": "335022",
      "Chak 24 H B.O": "335023",
      "Chak 30 H B.O": "335023",
      "19 Rb B.O": "335024",
      "4 Jj B.O": "335024",
      "2 Ffa B.O": "335024",
      "23 Ff B.O": "335024",
      "32 Bb B.O": "335024",
      "35 Bb B.O": "335024",
      "56 F B.O": "335024",
      "Chakbhagsar B.O": "335001",
      "Chak 5 E Chhoti B.O": "335001",
      "12 Z B.O": "335001",
      "Sahuwala B.O": "335001",
      "Chak 20 GG B.O": "335001",
      "90 Gb B.O": "335701",
      "Bhatiwala B.O": "335701",
      "39 Ps B.O": "335021",
      "Chak 75 NP B.O": "335021",
      "Chak 11 G Choti B.O": "335022",
      "Chak 3h Choti B.O": "335022",
      "Rattewale B.O": "335022",
      "Tatarsar B.O": "335022",
      "Chak 28 H B.O": "335023",
      "Dhanoor B.O": "335023",
      "15 Ff B.O": "335024",
      "Sriganganagar Rs S.O": "335001",
      "Anupgarh S.O": "335701",
      "Block Area S.O": "335001",
      "Gajsinghpur S.O": "335024",
      "Ganeshgarh S.O": "335025",
      "Jetsar S.O": "335702",
      "Mirzewala S.O": "335038",
      "Mukarjee Nagar S.O": "335001",
      "Purani Abadi S.O": "335001",
      "Raisinghnagar S.O": "335051",
      "Srikaranpur S.O": "335073",
      "STPS Suratgarh S.O": "335805",
      "Sriganganagar H.O": "335001",
      "Bishanpura S.O": "335021",
      "Chunawadh S.O": "335022",
      "Lalgarh Jatan S.O": "335037",
      "Mukalawa S.O": "335039",
      "Padampur S.O": "335041",
      "Suratgarh City S.O": "335804",
      "RAWLA S.O": "335708",
      "Dalpatsinghpur S.O": "335023",
      "Gharsana S.O": "335707",
      "Hindumalkote S.O": "335901",
      "Kesrisinghpur S.O": "335027",
      "Mandi Gharsana S.O": "335711",
      "Goushala Road S.O": "335001",
      "Mandi Sriganganagar S.O": "335001",
      "Ramsinghpur S.O": "335703",
      "Ridmalsar S.O": "335061",
      "Sardargarh S.O": "335705",
      "Suratgarh S.O": "335804",
      "Nizampura S.O": "335040",
      "Sadulshahar S.O": "335062",
      "Sribijaynagar S.O": "335704",
      "Udyog Vihar S.O": "335002"
    }
  },
  "PUNJAB": {
    "PATIALA": {
      "SWAI SINGH WALA B.O": "147111",
      "BINJAL B.O": "147111",
      "BHANRA BO": "147007",
      "JANDOLI BO": "140402",
      "Nandpur Kesho BO": "147004",
      "Roshanpur BO": "147111",
      "Badshahpur BO": "147102",
      "Dedna BO": "147102",
      "Kakrala BO": "147201",
      "Daunkalan BO": "147021",
      "Janherian BO": "147021",
      "Babarpur BO": "147201",
      "Chintawala BO": "147201",
      "Dhablan BO": "147201",
      "Godaya BO": "147201",
      "Mandaur BO": "147201",
      "Dhingi BO": "147201",
      "Galwati BO": "147201",
      "Kaleh Majra BO": "147201",
      "Lubana BO": "147201",
      "Jasso Majra BO": "147202",
      "Jindalpur BO": "147202",
      "Mallewal BO": "147202",
      "Behru BO": "147111",
      "Bhunerheri BO": "147111",
      "Dhudan Sadhan BO": "147111",
      "Massingan BO": "147111",
      "Miranpur BO": "147111",
      "Harchandpura BO": "147102",
      "Kulbanoo BO": "147102",
      "Sadharanpur BO": "147102",
      "Chappar BO": "147021",
      "Jogipur BO": "147021",
      "Kheri Mandlan BO": "147021",
      "Kalyan BO": "147005",
      "Ranbirpura BO": "147005",
      "Ajnoda Kalan BO": "147201",
      "Barsat BO": "147201",
      "Dandrala Dhindsa BO": "147201",
      "Gunike BO": "147201",
      "Bhari Panaich BO": "147202",
      "Raisal BO": "147202",
      "Dakaunda BO": "147104",
      "Buzark BO": "147102",
      "Binaheri BO": "147201",
      "Gtc Nabha BO": "147201",
      "Agol BO": "147202",
      "Fatehpur BO": "147202",
      "Mangewal BO": "147202",
      "Ramgarh BO": "147201",
      "Tohra BO": "147104",
      "Julkan BO": "147111",
      "Khanaura BO": "147202",
      "Matrauda BO": "147202",
      "Sakrali BO": "147202",
      "Tarkheri BO": "147104",
      "Aero Kalan BO": "147111",
      "Devinagar BO": "147111",
      "Gharam BO": "147111",
      "Dakala BO": "147007",
      "Gulhar BO": "147105",
      "Gulzarpura BO": "147105",
      "Harayu Khurd BO": "147105",
      "Jogewal BO": "147105",
      "Behmna BO": "147101",
      "Nainkalan BO": "147007",
      "Jhandi BO": "147007",
      "Bibipur BO": "147101",
      "Kulburchan BO": "147101",
      "Kutbanpur BO": "147101",
      "Marori BO": "147101",
      "Panjola BO": "147101",
      "Gajjumajra BO": "147101",
      "Allowal BO": "147006",
      "Ajrawar BO": "140701",
      "Bhatmajra BO": "140701",
      "Gopalpur BO": "140701",
      "Kotla BO": "140402",
      "Nanhera BO": "140417",
      "Nogawan BO": "140417",
      "Sandharsi BO": "140417",
      "Shambu Kalan BO": "140417",
      "Tepla BO": "140417",
      "Arno BO": "147105",
      "Duggal BO": "147105",
      "Shutrana BO": "147105",
      "Kularan BO": "147101",
      "Lachru Kalan BO": "140702",
      "Marru BO": "140702",
      "Sarala Kalan BO": "140702",
      "Lohsimbly BO": "140702",
      "Narru BO": "140701",
      "Sehra BO": "140701",
      "Pabri BO": "140701",
      "Basantpura BO": "140402",
      "Dhankansu Kalan BO": "140402",
      "Shamdoo BO": "140402",
      "Untsar BO": "140417",
      "Rohta BO": "147201",
      "Sular BO": "147007",
      "Saphera BO": "147007",
      "Beharjach BO": "147105",
      "Kartarpur BO": "147105",
      "Nial BO": "147105",
      "Balbera BO": "147101",
      "Dhainthal BO": "147101",
      "Gajewas BO": "147101",
      "Kamalpur BO": "147101",
      "Talwandi Malik BO": "147101",
      "Bhankher BO": "147103",
      "Lang BO": "147006",
      "Bakshiwala BO": "147006",
      "Karala BO": "140601",
      "Khanpur BO": "140701",
      "Dhuman BO": "140602",
      "Chalheri BO": "140402",
      "Suhron BO": "140402",
      "Khadauli BO": "140402",
      "Bhedwal BO": "140402",
      "Ugani BO": "140402",
      "Gadapur BO": "140417",
      "Kheri Gurna BO": "140417",
      "Thuha BO": "140417",
      "New Rakhra BO": "147201",
      "Rajgarh BO": "147201",
      "Thuhi BO": "147201",
      "Wazidpur BO": "147007",
      "Passiana BO": "147007",
      "Daftari Wala BO": "147105",
      "Duttal BO": "147105",
      "Khanewal BO": "147105",
      "Shergarh BO": "147105",
      "Taipur BO": "147105",
      "Charaso Kartarpur BO": "147101",
      "Dhanetha BO": "147101",
      "Karhali BO": "147101",
      "Rajla BO": "147101",
      "Sidhuwal BO": "147006",
      "Chalela BO": "147006",
      "Jhansla BO": "140601",
      "Harpalpur BO": "140701",
      "Mandauli BO": "140701",
      "Khera Gajju BO": "140602",
      "Urdan BO": "140602",
      "Bhapal BO": "140402",
      "Chamaru BO": "140402",
      "Jandmangoli BO": "140417",
      "Patiala HO": "147001",
      "Rajpura HO": "140401",
      "Anaj Mandi Nabha SO": "147201",
      "Bahera Road Patiala SO": "147001",
      "D C W SO": "147003",
      "Civil Lines Patiala SO": "147001",
      "Ghagga SO": "147102",
      "Govt Printing Press SO": "147004",
      "Guruteghbahadurgarh SO": "147021",
      "Jaurian Bhattian SO": "147001",
      "Law Court SO": "147001",
      "Majithia Enclave SO": "147005",
      "Medical College SO Patiala": "147001",
      "Bhadson SO": "147202",
      "Devigarh SO": "147111",
      "Dukhniwaran SO": "147004",
      "Nabha SO": "147201",
      "Gurbax Colony SO": "147003",
      "Patran SO": "147105",
      "Tripri SO": "147004",
      "University SO": "147002",
      "KSM Rajpura SO": "140401",
      "Ragho Majra Patiala SO": "147001",
      "Samana SO": "147101",
      "Nodal Delivery Center (Parcel)  Patiala": "147008",
      "Ghanaur SO": "140702",
      "Kauli SO": "140701",
      "Manakpur SO": "140602",
      "New Lal Bagh Colony SO": "147007",
      "Patiala City SO": "147001",
      "Sanaur SO": "147103",
      "Sheran Wala Gate Patiala SO": "147001",
      "Urban Estate SO": "147002",
      "RGNUL Punjab Patiala SO": "147006",
      "NSNIS PATIALA SO": "147001",
      "IFP Rajpura SO": "140401",
      "TIET SO": "147004",
      "Rajpura Township SO": "140402",
      "Shambhu SO": "140417"
    },
    "MOGA": {
      "Smalsar S.O": "142049",
      "Guru Teg Bahadur Garh B.O": "142049",
      "Bir Raoke BO": "142037",
      "Alamwala Kalan BO": "142038",
      "Baraghar BO": "142038",
      "Langeana Kalan BO": "142038",
      "Langeana Khurd BO": "142038",
      "Mahla Kalan BO": "142038",
      "Bhagike BO": "142039",
      "Bahona BO": "142011",
      "Ajitwal BO": "142053",
      "Chuhar Chak BO": "142053",
      "Matwani BO": "142053",
      "Dadahur BO": "142048",
      "Daroli Bhai BO": "142048",
      "Daulatpur Nicha BO": "142048",
      "Joge Wala BO": "142048",
      "Kalia Wala Karmuka BO": "142048",
      "Nidhanwala BO": "142048",
      "Rattian BO": "142048",
      "Sada Singh Wala BO": "142048",
      "Saffuwala BO": "142048",
      "Phulewala BO": "142056",
      "Rode BO": "142049",
      "Sekha Kalan BO": "142049",
      "Smalsar BO": "142049",
      "Lopon BO": "142037",
      "Budh Singh Wala BO": "142002",
      "Channuwala BO": "142038",
      "Nathoke BO": "142038",
      "Rajeana BO": "142038",
      "Kussa BO": "142039",
      "Machhike BO": "142039",
      "Raman BO": "142039",
      "Mallianwala BO": "142040",
      "Ramuwala Kalan BO": "142040",
      "Bughipura BO": "142011",
      "Mehna BO": "142011",
      "Killi Chahal BO": "142053",
      "Takhanwadh BO": "142053",
      "Darapur BO": "142048",
      "Korewala Kalan BO": "142048",
      "Lande BO": "142049",
      "Kaleke BO": "142038",
      "Kotla Mehar Singh wala BO": "142038",
      "Ladhai Ke BO": "142038",
      "Lohara BO": "142043",
      "Minian BO": "142039",
      "Nangal BO": "142039",
      "Ramuwala Harchoke BO": "142040",
      "Ramuwala Nawan BO": "142040",
      "Mehron BO": "142011",
      "Nathuwala Jadid BO": "142053",
      "Bukan Wala BO": "142048",
      "Thaman Wala BO": "142048",
      "Malliana BO": "142037",
      "Raoke Kalan BO": "142037",
      "Chand Purana BO": "142038",
      "Jai Singh Wala BO": "142038",
      "Mandhiran Wala BO": "142038",
      "Nathuwala West BO": "142038",
      "Baude BO": "142039",
      "Himmatpura BO": "142039",
      "Dhurkot Kalan BO": "142011",
      "Daudhar BO": "142053",
      "Jhandiana Sarki BO": "142053",
      "Madhoke BO": "142053",
      "Chotian Kalan BO": "142048",
      "Dagru BO": "142048",
      "Jhandiana BO": "142048",
      "Khosa Pando BO": "142048",
      "Khukhrana BO": "142048",
      "Mahesari BO": "142048",
      "Salina BO": "142048",
      "Gholia Kalan BO": "142056",
      "Ranian BO": "142056",
      "Mari Mustafa BO": "142049",
      "Bambhia Bhai Ka BO": "151208",
      "Saho Ke BO": "151208",
      "Wandar BO": "151208",
      "Chuhar Chak Khurd BO": "152028",
      "Longodeva BO": "152028",
      "Sukha Nand BO": "142049",
      "Kapure BO": "142054",
      "Kokri Heron BO": "142054",
      "Kokri Khurd BO": "142054",
      "Dina BO": "142046",
      "Khai BO": "142046",
      "Khosa Randhir BO": "152028",
      "Thathi Bhai BO": "142049",
      "Chugawan BO": "142054",
      "Kishan Garh BO": "142045",
      "Rauli BO": "142003",
      "Saidoke BO": "142055",
      "Jita Singh Wala BO": "142057",
      "Sangatpura BO": "142057",
      "Aminwala BO": "142042",
      "Fatehgarh Korotana BO": "142042",
      "Karyal BO": "142042",
      "Kot Sadar Khan BO": "142042",
      "Sherpur Tiaba BO": "142042",
      "Indergarh BO": "142058",
      "Datewala BO": "142043",
      "Fateh Garh Panjtoor BO": "142043",
      "Shah Abu Bakkar BO": "142043",
      "Chak Kannian Kalan BO": "142058",
      "Mandar Kalan BO": "142043",
      "Qadarwala BO": "142043",
      "Datta BO": "142041",
      "Talwandi Mallian BO": "142041",
      "Lohgarh BO": "142042",
      "Pandori Arian BO": "142042",
      "Kamaal Ke BO": "142042",
      "Varoke BO": "142049",
      "Raunta BO": "142045",
      "Dhalleke BO": "142003",
      "Ransih Khurd BO": "142055",
      "Takhtupura BO": "142055",
      "Didarewala BO": "142046",
      "Chand Nau BO": "142002",
      "Tarewala BO": "142002",
      "Kokri Wehniwal BO": "142041",
      "Nurpur Hakkiman BO": "142042",
      "Dholewala BO": "142042",
      "Jalalabad East BO": "142042",
      "Kaila BO": "142042",
      "Purane Wala BO": "142054",
      "Dosanjh BO": "142003",
      "Landeke BO": "142003",
      "Dhurkot Ransih BO": "142055",
      "Gaziana BO": "142055",
      "Madheke BO": "142055",
      "Jaimal Wala BO": "142002",
      "Charik BO": "142002",
      "Singhe Wala BO": "142002",
      "Khote BO": "142046",
      "Ganji Gulab Singh BO": "142057",
      "Kotla Rai Ka BO": "142057",
      "Maur Nau Abad BO": "142057",
      "Tharaj BO": "142057",
      "Bhaloor BO": "151207",
      "Ghaloti BO": "142043",
      "Karahewala BO": "142043",
      "Badhni Khurd BO": "142037",
      "Nasirewala BO": "142058",
      "Gargrah BO": "142043",
      "Janer BO": "142043",
      "Malke BO": "151207",
      "PG Khurd BO": "151207",
      "Moga HO": "142001",
      "Gholia Khurd SO": "142056",
      "GTR MOGA SO": "142001",
      "Guru Teg Bahadur Garh SO": "142049",
      "Industrial Area Moga SO": "142001",
      "Kokri Kalan SO": "142054",
      "Manoke SO": "142045",
      "Nihal Singh Wala SO": "142055",
      "Patto Hira Singh SO": "142046",
      "Purana Moga SO": "142002",
      "Bhinder SO Firozpur": "142041",
      "Kot Ise Khan SO": "142043",
      "Bilaspur Moga SO": "142039",
      "Samadh Bhai SO": "142057",
      "Dala SO": "142011",
      "Ghall Kalan SO": "142048",
      "Badhni Kalan SO": "142037",
      "Baghapurana SO": "142038",
      "Butter SO": "142040",
      "Dhudike SO": "142053",
      "Moga Kty SO": "142003",
      "Manawan SO": "152028",
      "Dharamkot SO": "142042",
      "Kishanpura SO Moga": "142058"
    },
    "FARIDKOT": {
      "Golewala S.O": "151214",
      "Sadhanwala B.O": "151214",
      "Dod BO": "151205",
      "Golewala BO": "151213",
      "Pipli BO": "151214",
      "Tehna BO": "151213",
      "Chandbhan BO": "151202",
      "Hari Nau BO": "151204",
      "Koharwala BO": "151204",
      "Matta BO": "151204",
      "Romana Ajit Singh BO": "151205",
      "Wara Bhai Ka BO": "151205",
      "Arrayianwala BO": "151214",
      "Bhagthala Kalan BO": "151214",
      "Bishnandi BO": "151202",
      "Rorikapura BO": "151202",
      "Dhilwan Kalan BO": "151204",
      "Behbal Khurd BO": "151208",
      "Jhakhar Wala BO": "151208",
      "Khara BO": "152025",
      "Chandbaja BO": "151213",
      "Dhudhi BO": "151213",
      "Pakhi Kalan BO": "151214",
      "Rajowala BO": "151214",
      "DHURKOT BO": "151213",
      "Kasam Bhatti BO": "151202",
      "Madhak BO": "151202",
      "Rameana BO": "151202",
      "Fatehgarh Dabri Khana BO": "151205",
      "Seda Singh Wala BO": "151205",
      "Kammiana BO": "151213",
      "Moranwali BO": "151213",
      "Sukhan Wala BO": "151213",
      "Quila Nau BO": "151213",
      "Ghugiana BO": "151214",
      "Chaina BO": "151202",
      "Gumti Khurd BO": "151202",
      "Dhaipai BO": "151204",
      "Ghanianwala BO": "151207",
      "Momara BO": "151212",
      "Mour Sohag BO": "151204",
      "Sivian BO": "151207",
      "Bihle Wala BO": "151212",
      "Deep Singh Wala BO": "151212",
      "Machaki Kalan BO": "151212",
      "Dhimanwali BO": "151209",
      "Machaki Mal Singh BO": "151209",
      "Sikhanwala BO": "151209",
      "Wander Jatana BO": "151209",
      "Romana Albel Singh BO": "151204",
      "Aulakh BO": "151207",
      "Jiwanwala BO": "151207",
      "Gurudwara Jand Sahib BO": "151212",
      "Sarawan BO": "151204",
      "Kot Sukhia BO": "151207",
      "Janerian BO": "151212",
      "Mehmuana BO": "151212",
      "Wara Daraka BO": "151209",
      "Faridkot HO": "151203",
      "Sadiq SO": "151212",
      "Sandhwan SO": "151209",
      "Panj Grain Kalan SO": "151207",
      "Baja Khana SO": "151205",
      "Faridkot Mandi SO": "151203",
      "Kotkapura SO": "151204",
      "Bargari SO": "151208",
      "Harindra Nagar Faridkot SO": "151213",
      "Jaitu SO": "151202"
    },
    "LUDHIANA": {
      "BALION BO": "141114",
      "GHUMNEWAL B.O": "141110",
      "BHATTIAN SO": "141008",
      "Kishangarh BO": "141412",
      "Borra BO": "141127",
      "Junewal BO": "141126",
      "Panjeta BO": "141126",
      "Saharan Majra BO": "141117",
      "Chhounta BO": "141127",
      "Rattangarh BO": "141127",
      "Baggakhurd BO": "141008",
      "Binjal BO": "142032",
      "Jhorran BO": "142032",
      "Nathowal BO": "142032",
      "Nanaksar BO": "142036",
      "Kailey BO": "141107",
      "Litter BO": "141107",
      "Rajoana Kalan BO": "141107",
      "Lakha BO": "142031",
      "Dhaipai BO": "142029",
      "Dholan Kalan BO": "142029",
      "Mansuran BO": "142029",
      "Sujapur BO": "142030",
      "Hans Kalan BO": "142030",
      "Lalton Khurd BO": "142022",
      "Thakarwal BO": "142022",
      "Dev Nagar BO": "142022",
      "Malakpur BO": "142027",
      "Pamali BO": "142021",
      "Raqba BO": "141422",
      "Jangpura BO": "141101",
      "Mandiani BO": "141101",
      "Mullanpur BO": "141101",
      "Pandori BO": "141101",
      "Bhanohar BO": "141102",
      "Dewatwal BO": "141102",
      "Fatehgarh Siwian BO": "142036",
      "Chak Kalan BO": "141110",
      "Dholan BO": "142030",
      "Chachrari BO": "142030",
      "Bhattia BO": "141008",
      "Karyana Kalan BO": "141015",
      "Mattewara BO": "141007",
      "Noorwala BO": "141007",
      "Nurpurbet BO": "141008",
      "Chakkar BO": "142035",
      "Dangian BO": "142035",
      "Bhainidarera BO": "141108",
      "Leel BO": "141108",
      "Nangal Kalan BO": "141108",
      "Bhaini Baringa BO": "141109",
      "Gondwal BO": "141109",
      "Jalaldiwal BO": "141109",
      "Tajpura BO": "141109",
      "Gidderwindi BO": "142033",
      "Jandi BO": "142033",
      "Junetpura BO": "142033",
      "Leelan BO": "142033",
      "Sidhwan Kalan BO": "142024",
      "Bhundri BO": "142025",
      "Talwandi Khurd BO": "142025",
      "Chhourian BO": "141121",
      "Pawat BO": "141121",
      "Bhourla BO": "141412",
      "Libra BO": "141412",
      "Mohanpur BO": "141412",
      "Boothgarh BO": "141007",
      "Mangat BO": "141007",
      "Rupalon BO": "141421",
      "Paddi BO": "141206",
      "Dhandran BO": "141116",
      "Dulley BO": "141116",
      "Rohno Kalan BO": "141414",
      "Gaddowal BO": "141112",
      "Babarpur BO": "141119",
      "Ber Khurd BO": "141119",
      "Barmalipur BO": "141416",
      "Ghudani Khurd BO": "141416",
      "Pamal BO": "142021",
      "Pherurain BO": "142032",
      "Hissowal BO": "141422",
      "Dhatt BO": "141101",
      "Rurka BO": "141101",
      "Gahaur BO": "141102",
      "Issewal BO": "141102",
      "Sherpur Kalan BO": "142036",
      "Barhmi BO": "141107",
      "Heeran Hans BO": "141107",
      "Bhatta Dhahan BO": "141110",
      "Purain BO": "141110",
      "Chajjewal BO": "142030",
      "Cheema BO": "142030",
      "Akalgarh BO": "141104",
      "Sudhar BO": "141104",
      "Dad BO": "142022",
      "Dallah BO": "142035",
      "Gurreh BO": "142023",
      "Kular BO": "142023",
      "Meerpur Hans BO": "142023",
      "Pabbian BO": "142023",
      "Nangal Khurd BO": "141108",
      "Johalan BO": "141109",
      "Kalas BO": "141109",
      "Talwandi Rai BO": "141109",
      "Ramgarh Bhullar BO": "142033",
      "Raowal BO": "142033",
      "Sadarpura BO": "142033",
      "Sodhiwal BO": "142033",
      "Tihara BO": "142033",
      "Bodalwala BO": "142024",
      "Bharowal BO": "142025",
      "New Rajguru Nagar BO": "142028",
      "Bahomajra BO": "141412",
      "Bhamaddi BO": "141412",
      "Butaheri BO": "141118",
      "Bilaspur BO": "141421",
      "Bowani BO": "141421",
      "Doburji BO": "141421",
      "Jaspalon BO": "141421",
      "Ghangas BO": "141419",
      "Chhapar BO": "141204",
      "Jassowal BO": "141116",
      "Sarih BO": "141116",
      "Maksudran BO": "141416",
      "Kalal Majra BO": "141417",
      "Kotla Bhari BO": "141417",
      "Goslan BO": "141417",
      "Goh BO": "141417",
      "Sahibana BO": "141123",
      "Bhagwanpura BO": "141114",
      "Bharthala BO": "141114",
      "Bondli BO": "141114",
      "Dhindsa BO": "141114",
      "Neelon Kalan BO": "141114",
      "Ballowal BO": "141202",
      "Chakohi BO": "141414",
      "Hoal BO": "141414",
      "Nasrali BO": "141414",
      "Bharthala Randhawa BO": "141415",
      "Jargari BO": "141415",
      "Sirthala BO": "141415",
      "Kotala BO": "141125",
      "Nanowal Kalan BO": "141125",
      "Sihala BO": "141125",
      "Uppal BO": "141113",
      "Heeran BO": "141112",
      "Jandiali BO": "141112",
      "Bahrampur BO": "141205",
      "Barundi BO": "141205",
      "Punjgarain BO": "141115",
      "Takhran BO": "141115",
      "Mehma Singh Wala BO": "141203",
      "Chak Mafi BO": "141417",
      "Seh BO": "141417",
      "Begowal BO": "141418",
      "Kubba BO": "141418",
      "Manki Bhagour BO": "141114",
      "Muskabad BO": "141114",
      "Nagra BO": "141114",
      "Otalan BO": "141114",
      "Nandpur BO": "141120",
      "Tibba BO": "141120",
      "Kila Hans BO": "141117",
      "Jhamat BO": "141117",
      "Kalahar BO": "141117",
      "Karamsar BO": "141117",
      "Chak Bahi Ke BO": "142032",
      "Hassanpur BO": "141102",
      "Sheikh Daulat BO": "142036",
      "Attiana BO": "141107",
      "Burj Hakima BO": "141107",
      "Nurpur BO": "141107",
      "Bassian Bet BO": "141110",
      "Roomi BO": "142030",
      "Ghuman BO": "141104",
      "Hamaunpura BO": "142022",
      "Hawas BO": "141007",
      "Khwajke BO": "141007",
      "Lodhowal BO": "141008",
      "Rasulpur BO": "142035",
      "Tuggal BO": "142023",
      "Bhamipura BO": "142034",
      "Lamme BO": "142034",
      "Andlu BO": "141108",
      "Dadahur BO": "141109",
      "Lohat baddi BO": "141109",
      "Sehbazpura BO": "141109",
      "Rattowal BO": "141105",
      "Madarpura BO": "142033",
      "Barsal BO": "142024",
      "Birk BO": "142024",
      "Sangatpura BO": "142024",
      "Chimna BO": "142024",
      "Khanjarwal BO": "142025",
      "Talwandi Kalan BO": "142025",
      "Sherpur Bet BO": "141121",
      "Bija Kalan BO": "141412",
      "Lehra BO": "141118",
      "Sihaura BO": "141413",
      "Jatana BO": "141421",
      "Lapran BO": "141421",
      "Guram BO": "141206",
      "Mukandpur BO": "141206",
      "Shankar BO": "141206",
      "Khera BO": "141204",
      "Chaminda BO": "141202",
      "Ikolaha BO": "141414",
      "Sangowal BO": "141122",
      "Kot Gangu Rai BO": "141113",
      "Bhagpura BO": "141112",
      "Bhairro Munna BO": "141112",
      "Dhanansu BO": "141112",
      "Rachhine BO": "141205",
      "Maherna Kalan BO": "141205",
      "Hambowal BO": "141115",
      "Kuhli Kalan BO": "141119",
      "Sihan Daud BO": "141119",
      "Jartauli BO": "141203",
      "Lalori Kalan BO": "141417",
      "Manupur BO": "141417",
      "Mehdoodan BO": "141418",
      "Ghulal BO": "141114",
      "Heddon BO": "141114",
      "Mal Majra BO": "141114",
      "Sarwarpur BO": "141114",
      "Ladhran BO": "141114",
      "Madpur BO": "141114",
      "Kanech BO": "141120",
      "Nanakpur Jagera BO": "141117",
      "Kaunke Kalan BO": "142035",
      "Jassowal Kalan BO": "142023",
      "Morkarima BO": "142023",
      "Sohian BO": "142023",
      "Daherka BO": "142034",
      "Akhara BO": "142034",
      "Khandur BO": "141103",
      "Rajgarh BO": "141421",
      "Burj Hari Singh Wala BO": "141109",
      "Kalsian BO": "141109",
      "Abbowal BO": "141105",
      "Sahauli BO": "141105",
      "Tossey BO": "141105",
      "Bangsipur BO": "142033",
      "Lodhiwal BO": "142033",
      "Malsian Bajan BO": "142033",
      "Bhaini Araiyan B.O": "142033",
      "Bazurg BO": "142024",
      "Srs Nagar BO": "142024",
      "Malak BO": "142024",
      "Majri BO": "142025",
      "Bagli Kalan BO": "141412",
      "Ghungrali Rajputan BO": "141412",
      "Khatorachuharam BO": "141118",
      "Saya Kalan BO": "141118",
      "Nizampur BO": "141413",
      "Kaddon BO": "141421",
      "Bhutta BO": "141206",
      "Khanpur BO": "141206",
      "Ghaloti BO": "141419",
      "Dhulkot BO": "141204",
      "Kalakh BO": "141204",
      "Pohiar BO": "141204",
      "Alamgir BO": "141116",
      "Phalewal BO": "141202",
      "Allona Pallah BO": "141414",
      "Jallajan BO": "141414",
      "Rajewal BO": "141114",
      "Rauni BO": "141415",
      "Natt BO": "141122",
      "Chhandran BO": "141113",
      "Budhewal BO": "141112",
      "Rangowal BO": "141205",
      "Jodhwal BO": "141115",
      "Lubangarh BO": "141115",
      "Dhudhal Kalan BO": "141119",
      "Ramgarh Sardaran BO": "141119",
      "Assi Kalan BO": "141203",
      "Lohgarh BO": "141203",
      "Harion Kalan BO": "141417",
      "Salaudi BO": "141417",
      "Ghungrali Sikhan BO": "141114",
      "Kotla Samashpur BO": "141114",
      "Shamspur BO": "141114",
      "Bilga BO": "141120",
      "Pawa BO": "141120",
      "Lehal BO": "141117",
      "Jagraon HO": "142026",
      "Khanna HO": "141401",
      "Ludhiana HO": "141001",
      "AP Basti SO": "141003",
      "Basant Avenue SO": "141013",
      "Dhandari Kalan SO": "141014",
      "Durgapuri SO": "141001",
      "Gne College SO": "141006",
      "Jugiana SO": "141017",
      "Labour Colony SO Ludhiana": "141003",
      "Basti Jodhewal SO": "141007",
      "Eros Bajra Road SO": "141007",
      "Bassian SO": "142032",
      "Bopa Rai Kalan SO Ludhiana": "141422",
      "Dakha SO": "141102",
      "Galib Kalan SO": "142036",
      "Halwara Aerodrome SO": "141106",
      "Halwara SO": "141107",
      "Kamalpura SO": "142030",
      "KCG Sudhar SO": "141104",
      "Mann SO": "142023",
      "Mohie SO": "141103",
      "Dhamote SO": "141413",
      "Doraha SO Ludhiana": "141421",
      "Ghungrana SO": "141204",
      "Jarg SO": "141415",
      "Kakrala Kalan SO": "141125",
      "Latala SO": "141205",
      "Maloudh SO": "141119",
      "Ramgarh SO Ludhiana": "141123",
      "Iqbal Ganj SO": "141008",
      "Millerganj SO": "141003",
      "New Courts SO": "141001",
      "New Model Town SO": "141002",
      "Pt Colony SO Ludhiana": "141001",
      "Samrala Road SO": "141008",
      "Sanehwal SO": "141120",
      "Koom Kalan SO": "141127",
      "Lohora SO": "141016",
      "Dakha Mandi SO": "141101",
      "Jagraon City SO": "142026",
      "Mallah SO": "142035",
      "Sarabha SO": "141105",
      "Sidhwan Bet SO": "142033",
      "Threeke SO": "142028",
      "Amloh RoadKhanna SO": "141401",
      "Behlolpur SO": "141121",
      "Daheru SO": "141412",
      "Dehlon SO": "141118",
      "Ghawaddi SO": "141206",
      "Ghudani Kalan SO": "141419",
      "Machhiwara SO": "141115",
      "Narangwal SO": "141203",
      "Payal SO": "141416",
      "Rahawan SO": "141417",
      "Ayali Kalan SO": "142027",
      "Baddowal SO": "142021",
      "Hambran SO": "141110",
      "Jodhan SO": "142029",
      "Lalton Kalan SO": "142022",
      "Sidhwan Khurd SO": "142024",
      "Gill SO": "141116",
      "Jaspal Banger SO": "141122",
      "Kohara SO": "141112",
      "Rampur SO Ludhiana": "141418",
      "Sihar SO": "141117",
      "New Hargobind Nagar SO": "141008",
      "Partpsinghwala SO": "141008",
      "Sarabha Nagar SO": "141001",
      "Satsang Road SO": "141001",
      "Shimlapuri SO": "141003",
      "BR Street SO": "141008",
      "Bharat Nagar SO Ludhiana": "141001",
      "Central Post Office SO": "141008",
      "Daba Road SO": "141014",
      "Jamalpur Awana SO": "141010",
      "Janta Nagar SO": "141003",
      "LR Market SO": "141008",
      "Madhopuri SO": "141008",
      "Model Town Ludhiana SO": "141002",
      "PAU SO": "141004",
      "Passi Nagar SO": "141013",
      "Rajguru Nagar SO": "141012",
      "Sidhpeeth SO": "141001",
      "Nodal Delivery Centre, Ludhiana": "141011",
      "CMC SO Ludhiana": "141008",
      "Focal Point SO": "141010",
      "Guru Arjan Dev Nagar SO": "141008",
      "Indl  Colony SO": "141003",
      "Ludhiana Kty SO": "141001",
      "Moti Nagar SO": "141010",
      "Mundian Kalan SO": "141015",
      "Netaji Nagar SO Ludhiana": "141008",
      "Hathur SO": "142031",
      "Jagraon Tehsil SO": "142026",
      "Manuke SO": "142034",
      "Pakhowal SO": "141108",
      "Raekot SO": "141109",
      "Sowaddi SO": "142025",
      "Gujjarwal SO": "141202",
      "Issru SO": "141414",
      "Katani Kalan SO": "141113",
      "Kila Raipur SO": "141201",
      "Nai Mandi Khanna SO": "141401",
      "Samrala City SO": "141114",
      "Samrala SO": "141114",
      "Sri Bhaini Sahib SO": "141126",
      "Shivpuri SO Ludhiana": "141008"
    },
    "S.A.S Nagar": {
      "Sunny Enclave S.O.": "160055",
      "Dappar BO": "140506",
      "Kuranwala BO": "140507",
      "Tassimbli BO": "140501",
      "Tiwana BO": "140501",
      "Daon BO": "160055",
      "Gholumajra BO": "140506",
      "Devinagar BO": "140507",
      "Rampur Sainia BO": "140507",
      "Dharamgarh BO": "140306",
      "Joula Kalan BO": "140501",
      "Khelan BO": "140501",
      "Jangipur BO": "140506",
      "Handesera BO": "140501",
      "Jarut BO": "140501",
      "Jauli BO": "140501",
      "Jharmarhi BO": "140501",
      "Samgoli BO": "140501",
      "Bhankarpur BO": "140201",
      "Balongi BO": "160055",
      "Jalalpur BO": "140506",
      "Baroli BO": "140507",
      "Rani Majra BO": "140901",
      "Sirsihni BO": "140501",
      "Bassian Brahman BO": "140413",
      "Marauli Kalan BO": "140413",
      "Sakrulapur BO": "140413",
      "Daun Majra BO": "140301",
      "Jandpur BO": "140301",
      "Naya Shehar BO": "140301",
      "Palheri BO": "140301",
      "Kubaheri BO": "140109",
      "Mundhon Kalan BO": "140103",
      "Singhpura BO": "140103",
      "Geega Majra BO": "140307",
      "Jhanjeri BO": "140307",
      "Majatri BO": "140307",
      "Chhatt BO": "140603",
      "Dayalpur Sodhian BO": "140603",
      "Jhingran Kalan BO": "140103",
      "Kaishanpura BO": "140103",
      "Kalewal BO": "140103",
      "Bhago Majra BO": "140307",
      "Chudiala Sudan BO": "140307",
      "Siswan BO": "140110",
      "Hoshiarpur Taqipur BO": "140110",
      "Kansala BO": "140110",
      "Mauli Baidwan BO": "140308",
      "Nagal Charbar BO": "140601",
      "Cholta Khurd BO": "140301",
      "Radiala BO": "140301",
      "TCKharar BO": "140301",
      "Allahpur BO": "140103",
      "Chintgarh BO": "140103",
      "Dhanauri BO": "140103",
      "Rasanheri BO": "140307",
      "Mote Majra BO": "140306",
      "Parol BO": "140901",
      "Kuda Jassu BO": "140901",
      "Baraudi BO": "140110",
      "Phatwan BO": "140110",
      "Kumbra BO": "140308",
      "Pabhat BO": "140603",
      "Bajheri BO": "140413",
      "Garangan BO": "140413",
      "Roorkee Pukhta BO": "140301",
      "Tewar BO": "140301",
      "Burmajra BO": "140103",
      "Sahauran BO": "140103",
      "Sihon Majra BO": "140103",
      "Sotal BO": "140103",
      "Machhlikalan BO": "140307",
      "Dhurali BO": "140306",
      "Raipur Kalan BO": "140306",
      "Jayanti Devi BO": "140901",
      "Manakpur Sharif BO": "140110",
      "Chandigarh Sector 55 SO": "160055",
      "Chandigarh Sector 56 SO": "160055",
      "Chandigarh Sector 60 SO": "160059",
      "Chandigarh Sector 65 SO": "160062",
      "Chandigarh Sector 59 SO": "160059",
      "Chandigarh Sector 62 SO": "160062",
      "Baltana SO": "140604",
      "Chandigarh Sector 61 SO": "160062",
      "Mubarakpur SO Patiala": "140201",
      "Gharuan SO": "140413",
      "Khizrabad West SO": "140109",
      "Chandigarh Sector 67 SO": "160062",
      "Dappar Ad SO": "140506",
      "Dhakaoli SO": "160104",
      "Lalru SO": "140501",
      "Naya Gaon SO Mohali": "160103",
      "Zirakpur SO": "140603",
      "Landran SO": "140307",
      "Derabassi SO": "140507",
      "Kharar SO Rupnagar": "140301",
      "Sialba Majri SO": "140110",
      "Chandigarh Sector 71 SO": "160071",
      "Kurali SO": "140103",
      "Mullanpur SO": "140901",
      "Manauli SO": "140306",
      "Sohana SO": "140308",
      "Banur SO": "140601"
    },
    "KAPURTHALA": {
      "KHALWARA BO": "144402",
      "Dalla BO": "144626",
      "Kabirpur BO": "144626",
      "Paramjitpur BO": "144626",
      "Sarai Jattan BO": "144402",
      "Sherpur Dona BO": "144626",
      "Dhapai BO": "144603",
      "Mansoorwal BO": "144603",
      "Bhadas BO": "144622",
      "Boparai BO": "144622",
      "Bhabiana BO": "144407",
      "Rampur Sunera BO": "144407",
      "Bhagana BO": "144405",
      "Mayopatti BO": "144405",
      "Chak Prema BO": "144402",
      "Sangatpur BO": "144402",
      "Chiheru BO": "144411",
      "Bhulana BO": "144620",
      "Mothanwala BO": "144620",
      "Saidowal BO": "144620",
      "Sandhu Chatha BO": "144625",
      "Fattu Dhinga BO": "144606",
      "Khiranwali BO": "144606",
      "Saidpur BO": "144628",
      "Wadala Kalan BO": "144603",
      "Ahmedpur BO": "144603",
      "Khanowal BO": "144603",
      "Buttar BO": "144622",
      "Mana Talwandi BO": "144622",
      "Mauli BO": "144632",
      "Rawalpindi Gulab Shah BO": "144407",
      "Sahni BO": "144405",
      "Bohani BO": "144403",
      "Bhanoki BO": "144402",
      "Khajurla BO": "144411",
      "Maheru BO": "144411",
      "Bhanolanga BO": "144620",
      "Rampur Jagir BO": "144626",
      "Khukhrain BO": "144606",
      "Tibba BO": "144628",
      "Ibban BO": "144603",
      "Baler Khanpur BO": "144603",
      "Alampur Bhakha BO": "144622",
      "Ramgarh BO": "144622",
      "Rehana Jattan BO": "144407",
      "Barn BO": "144403",
      "Nangal Majha BO": "144403",
      "Palahi BO": "144403",
      "Mehtan BO": "144402",
      "Bhullarai BO": "144402",
      "Hardasspur BO": "144411",
      "Madhopur BO": "144411",
      "Dadwindi BO": "144620",
      "Khaira Dona BO": "144620",
      "Mahabalipur BO": "144620",
      "Merripur BO": "144620",
      "Burewal BO": "144628",
      "Khalu BO": "144628",
      "Nasirpur BO": "144628",
      "Bhawanipur BO": "144606",
      "Nathu Chahal BO": "144603",
      "Aujla Jogi BO": "144603",
      "Khassan BO": "144622",
      "Sher Singh Wala BO": "144622",
      "PCJamalpur BO": "144632",
      "Athouli BO": "144402",
      "Lakhpur BO": "144402",
      "Raipur Pir Bux Wala": "144819",
      "Maqsoodpur BO": "144819",
      "Miani Bhagopurian BO": "144631",
      "Chakoki BO": "144624",
      "Raipur Arryan BO": "144624",
      "Talwara BO": "144624",
      "Manak BO": "144402",
      "Mirzapur BO": "144624",
      "Bhandal Bet BO": "144804",
      "Butala BO": "144804",
      "Dhaliwal Bet BO": "144804",
      "Miani Bakerpur BO": "144804",
      "Akbarpur BO": "144621",
      "Muddowal BO": "144802",
      "Ramidi BO": "144802",
      "Subhanpur BO": "144802",
      "Kanjli BO": "144802",
      "Awan Bikeshah BO": "144621",
      "Jaid BO": "144621",
      "Nurpur Lubana BO": "144804",
      "Sangojla BO": "144804",
      "Lakhan Ke Padde BO": "144802",
      "Bariar BO": "144621",
      "Saiflabad BO": "144804",
      "Surkhpur BO": "144804",
      "Pandori BO": "144402",
      "LAKHAN KALAN BO": "144802",
      "Kapurthala HO": "144601",
      "Phagwara HO": "144401",
      "Kala Sanghian SO": "144623",
      "KAPURTHALA TOWN SO": "144601",
      "Nangal Lubana SO": "144631",
      "Sheikhupur SO Kapurthala": "144620",
      "Sidhwan Dona SO": "144625",
      "Thatha Jadid SO": "144628",
      "PTU Campus Kapurthala SO": "144603",
      "Chachoki SO": "144632",
      "THAPAR COLONY PHAGWARA SO": "144401",
      "University Campus Nanak Nagri SO": "144411",
      "RAIL COACH FACTORY KAPURTHALA SO": "144602",
      "Sultanpur Lodhi SO": "144626",
      "Bazar Sarafan Phagwara SO": "144401",
      "DOMELI SO": "144407",
      "Mehli Gate Phagwara SO": "144401",
      "Gnqc Sultanpur SO": "144626",
      "Jagatjit Nagar SO": "144802",
      "Nadala SO": "144624",
      "IBRAHIMWAL": "144819",
      "Talwandi Chaudharian SO": "144606",
      "Narur SO": "144405",
      "PANCHHAT SO": "144408",
      "RANIPUR SO": "144403",
      "Dhilwan SO": "144804",
      "Sainik School Kapurthala SO": "144601",
      "Kanjli Road Kapurthala SO": "144601",
      "Banga Road Phagwara SO": "144401",
      "Bholath SO": "144622",
      "Satnampura SO": "144402",
      "Begowal SO": "144621"
    },
    "JALANDHAR": {
      "Mullewal Khera BO": "144702",
      "Poonian BO": "144702",
      "Bath Kalan BO": "144044",
      "Maheem BO": "144044",
      "Khokhewal BO": "144036",
      "Birk BO": "144632",
      "Nagra BO": "144037",
      "Pharwala BO": "144037",
      "Tahli BO": "144043",
      "Kotli Gujjran BO": "144702",
      "Mianwal Arrayan BO": "144702",
      "Talwandi Buttian BO": "144702",
      "Sharakpur BO": "144042",
      "Kular BO": "144625",
      "Powadhra BO": "144036",
      "Rorkee BO": "144311",
      "Chak Vendal BO": "144033",
      "Dhaliwal BO": "144002",
      "Kang Arryan BO": "144035",
      "Mehsumpur BO": "144035",
      "Daduwal BO": "144032",
      "Dhanipind BO": "144633",
      "Birpind BO": "144043",
      "Littran BO": "144043",
      "Lassuri BO": "144702",
      "Mianwal BO": "144702",
      "Sindher BO": "144702",
      "Chak Mughlani BO": "144042",
      "Talwandi Madho BO": "144625",
      "Thamanwal BO": "144036",
      "Bhardwajian BO": "144034",
      "Ghurka BO": "144632",
      "Chanian BO": "144033",
      "Mau Mianwal BO": "144035",
      "Kangniwal BO": "144032",
      "Lakhanpal BO": "144633",
      "Guree BO": "144043",
      "Nawanpind BO": "144043",
      "Raipur BO": "144411",
      "Bahamanian BO": "144702",
      "Bajwa Kalan BO": "144702",
      "Killi BO": "144702",
      "Chak Kalan BO": "144042",
      "Khaira Majha BO": "144603",
      "Mowai BO": "144036",
      "Mithra BO": "144034",
      "Pabwan BO": "144034",
      "Sunner Kalan BO": "144034",
      "Bhangala BO": "144033",
      "Wajuha Khurd BO": "144033",
      "Massani BO": "144416",
      "Dhaleta BO": "144418",
      "Mansurpur BO": "144418",
      "Phalpota BO": "144418",
      "Samrai BO": "144418",
      "Lehal BO": "144502",
      "Sarhal Mandi BO": "144502",
      "Mothada Khurd BO": "144409",
      "Paddi Jagir BO": "144409",
      "Khusropur BO": "144806",
      "Mandi BO": "144416",
      "Chak Desraj BO": "144418",
      "Kang Jagir BO": "144418",
      "Kot Grewal BO": "144502",
      "Dhesian Sangh BO": "144409",
      "Rurka Khurd BO": "144409",
      "Kot Kalan BO": "144024",
      "Sofi Pind BO": "144024",
      "Atti BO": "144418",
      "Dhandwar BO": "144502",
      "Birbansian BO": "144409",
      "Gohawar BO": "144409",
      "Sargundi BO": "144409",
      "Udhopur BO": "144020",
      "Sansarpur BO": "144024",
      "Bharsingpura BO": "144419",
      "Landhran BO": "144419",
      "Thalla BO": "144419",
      "Chachrari BO": "144409",
      "Mahal BO": "144409",
      "Mothada Kalan BO": "144409",
      "Qadian Wali BO": "144020",
      "Gumtali BO": "144039",
      "Kandola Kalan BO": "144039",
      "Kot Badal Khan BO": "144039",
      "Shadipur BO": "144039",
      "Umarpur Kalan BO": "144039",
      "Sohal Jagir BO": "144703",
      "Bhallowal BO": "144039",
      "Chuheki BO": "144039",
      "Ramewal BO": "144039",
      "Uppal Jagir BO": "144039",
      "Talwandi Sanghera BO": "144703",
      "Bhandal Himmat BO": "144039",
      "Gumtala BO": "144039",
      "Saidowal BO": "144039",
      "Uppal Bhupa BO": "144039",
      "Talwan BO": "144039",
      "Raunt BO": "144703",
      "Sadiqpur BO": "144703",
      "Sandhewal BO": "144703",
      "Mustafapur BO": "144801",
      "Manak BO": "144629",
      "Nawanpind Danewal BO": "144629",
      "Turna BO": "144629",
      "Malupur BO": "144701",
      "Adarman BO": "144041",
      "Parjian Kalan BO": "144041",
      "Shahpur BO": "144041",
      "Tandaura BO": "144041",
      "Udhowal BO": "144041",
      "Bhullar BO": "144040",
      "Gandhran BO": "144040",
      "Pandori Khas BO": "144040",
      "Kanian Kalan BO": "144703",
      "Kala Khera BO": "144801",
      "Bara Jodh Singh BO": "144629",
      "Gidder Pindi BO": "144629",
      "Kang Kalan BO": "144629",
      "Yusufpur Darewal BO": "144629",
      "Chak Chela BO": "144701",
      "Daulatpur Dhadde BO": "144701",
      "Gill Seowal BO": "144701",
      "Kangnah BO": "144701",
      "Khanpur Dhadde BO": "144701",
      "Baloki BO": "144041",
      "Bulanda BO": "144041",
      "Danewal BO": "144041",
      "Bara Sidhpur BO": "144040",
      "Nihaluwal BO": "144701",
      "Rupewali BO": "144701",
      "Lidhran BO": "144004",
      "Malri BO": "144040",
      "Nawanpind Jattan BO": "144040",
      "Nurpur BO": "144004",
      "Tut Kalan BO": "144040",
      "Kotla Surajmal BO": "144703",
      "Nawan Qilla BO": "144703",
      "Uggi BO": "144623",
      "Rahimpur BO": "144623",
      "Kang Khurd BO": "144629",
      "Nahal BO": "144629",
      "Phul Gudewal BO": "144629",
      "Muridwal BO": "144701",
      "Akbarpur Kalan BO": "144041",
      "Haripur BO": "144041",
      "Sangowal BO": "144041",
      "Singhpur BO": "144041",
      "Umarwal Billa BO": "144041",
      "Bhodipur BO": "144040",
      "Billi Chuharmi BO": "144040",
      "Bagga BO": "144703",
      "Nagar BO": "144410",
      "Pandori Nijjran BO": "144102",
      "Salala BO": "144102",
      "Ucha BO": "144102",
      "Kishangarh BO": "144301",
      "Naugajja BO": "144301",
      "Sikandarpur BO": "144301",
      "Mand BO": "144021",
      "Rajpur BO": "144201",
      "Sanaura BO": "144201",
      "Dhogri BO": "144025",
      "Hazara BO": "144025",
      "Jaitewali BO": "144025",
      "Kapur Pind BO": "144025",
      "Khambra BO": "144026",
      "Lohar Partapura BO": "144026",
      "Malko Tarar BO": "144026",
      "Phoolpur Dhanal BO": "144026",
      "Talhan BO": "144101",
      "Kang Saboo BO": "144630",
      "Mundh BO": "144630",
      "Rasulpur Kalan BO": "144630",
      "Sainiwal BO": "144630",
      "Kahlwan BO": "144805",
      "Sarai Khas BO": "144805",
      "Khiwa BO": "144623",
      "Nijjran BO": "144623",
      "Talwandi Saleem BO": "144623",
      "Kadiana BO": "144410",
      "Khaira BO": "144410",
      "Dhina BO": "144022",
      "Dhingrian BO": "144102",
      "Haripur Sirowal BO": "144102",
      "Kotla BO": "144106",
      "Manko BO": "144106",
      "Sarobad BO": "144106",
      "Hellor BO": "144021",
      "Kohala BO": "144002",
      "Dolike Sunderpur BO": "144302",
      "Kishanpur BO": "144302",
      "Behram Sarista BO": "144201",
      "Bhatnura Lubana BO": "144201",
      "Binpalke BO": "144201",
      "Jandir BO": "144201",
      "Loharan BO": "144201",
      "Randhawa Masanda BO": "144004",
      "Raipur Rasulpur BO": "144004",
      "Tehang BO": "144410",
      "Mithapur BO": "144022",
      "Kandola BO": "144103",
      "Isherwal BO": "144102",
      "Mohaddipur BO": "144102",
      "Chuharwali BO": "144102",
      "Chukhiara BO": "144106",
      "Jalbhe BO": "144106",
      "Athola BO": "144002",
      "Gakhlan BO": "144002",
      "Duhre BO": "144302",
      "Cholang BO": "144201",
      "Kingra Chowala BO": "144201",
      "Laroi BO": "144201",
      "Madhopur Jhander BO": "144201",
      "Pachranga BO": "144201",
      "Daroli Khurd BO": "144104",
      "Nussi BO": "144004",
      "Bal BO": "144004",
      "Budhiana BO": "144025",
      "Madar BO": "144025",
      "Jallowal BO": "144303",
      "Rohjari BO": "144303",
      "Sadana BO": "144303",
      "Tajpur BO": "144026",
      "Khurla BO": "144003",
      "Kotli Than Singh BO": "144101",
      "Gohir BO": "144630",
      "Adhi BO": "144623",
      "Haripur Khalsa BO": "144410",
      "Shahpur Bhattian BO": "144410",
      "Ganna Pind BO": "144410",
      "Damunda BO": "144103",
      "Khurdpur BO": "144102",
      "Najka BO": "144102",
      "Ghurial BO": "144106",
      "Chamiara BO": "144002",
      "Ladhra BO": "144201",
      "Laroya BO": "144201",
      "Manakrai BO": "144201",
      "Patial BO": "144201",
      "Lallian BO": "144028",
      "Sheikhe Pind BO": "144025",
      "Kandhala Guru BO": "144303",
      "Kalyanpur BO": "144026",
      "Samipur BO": "144026",
      "Wadala BO": "144003",
      "Kalra BO": "144030",
      "Bhojowal BO": "144101",
      "Bolina Doaba BO": "144101",
      "Parasrampur BO": "144101",
      "Herran BO": "144630",
      "Talwandi Bhairon BO": "144630",
      "Kudowal BO": "144803",
      "Jallowal Madhopur BO": "144623",
      "Sheikhupur BO": "144029",
      "Chhokran BO": "144029",
      "Dakoha SO": "144023",
      "Dhanowali SO": "144010",
      "Goraya SO": "144409",
      "Jamsher SO": "144020",
      "Moron SO": "144029",
      "Apra SO": "144416",
      "Kukar Pind SO": "144024",
      "Jalandhar City HO": "144001",
      "Dosanjh Kalan SO": "144502",
      "Industrial Area Phillaur SO": "144410",
      "Ladhewali SO": "144007",
      "Millitary Hospital SO": "144005",
      "Bara Pind SO": "144418",
      "BSF Campus SO": "144006",
      "Dayalpur SO Jalandhar": "144419",
      "Jalandhar Cantt HO": "144005",
      "Nangal Ambian SO": "144703",
      "Shahkot SO": "144702",
      "RURKA KALAN SO": "144031",
      "Malsian SO": "144701",
      "Mehatpur SO Jalandhar": "144041",
      "Nakoder SO": "144040",
      "Shankar SO": "144042",
      "SIDHWAN R S SO": "144044",
      "NEW JUDICIAL COURT COMPLEX NAKODAR SO": "144040",
      "Bundala SO Jalandhar": "144034",
      "Partappura SO": "144035",
      "Pasla SO": "144037",
      "SARHALI SO": "144633",
      "SARIH SO": "144043",
      "Kartarpur SO": "144801",
      "Bilga SO": "144036",
      "Samrai SO": "144032",
      "Dialpur SO": "144803",
      "Lohian SO": "144629",
      "Urban Estate SO Jalandhar": "144022",
      "Adda Kathar SO": "144106",
      "Bhogpur SO Jalandhar": "144201",
      "Civil Secretariate SO": "144002",
      "Fentonganj SO": "144001",
      "Grain Market SO Jalandhar": "144008",
      "Guru Amar Dass Nagar SO": "144008",
      "Phillaur SO": "144410",
      "Rama Mandi SO": "144005",
      "Alawalpur SO Jalandhar": "144301",
      "P T S Phillaur SO": "144410",
      "Sadar Bazar Jalandhar Cantt SO": "144005",
      "Basti Guzan SO": "144002",
      "Bazar Shahidan SO": "144001",
      "Bhargav Camp SO": "144003",
      "Bikrampura SO": "144008",
      "Charanjitpura SO": "144008",
      "Daroli Kalan SO": "144104",
      "Guru Ravidass Road SO": "144004",
      "Kala Bakra SO": "144303",
      "Nagra SO Jalandhar": "144021",
      "Rasta Mohalla SO": "144001",
      "Reru SO": "144004",
      "S U S Nagar SO": "144001",
      "Shakti Nagar SO Jalandhar": "144001",
      "Nurmahal SO": "144039",
      "Pattar Kalan SO": "144806",
      "DHESIAN KAHNA SO": "144311",
      "JANDIALA SO": "144033",
      "Hoshiarpur Road SO": "144004",
      "Lambra SO": "144026",
      "Preet Nagar SO Jalandhar": "144004",
      "REC Jalandhar SO": "144011",
      "Sodal Road SO": "144004",
      "CRPF Campus Sarai Khas SO": "144805",
      "PAP Lines Jalandhar Cantt SO": "144006",
      "Adampur AD SO": "144103",
      "Basti Bawa Khel SO": "144021",
      "Basti Danishmandan SO": "144002",
      "Basti Nau SO": "144002",
      "Basti Sheikh SO": "144002",
      "Bhagat Bazar SO": "144008",
      "Chitti SO": "144028",
      "Adampur Doaba SO": "144102",
      "Bazaar Nauhrian SO": "144008",
      "Beas Pind SO": "144302",
      "Chogitti SO": "144009",
      "D A V  College SO": "144008",
      "Industrial Town SO": "144004",
      "Jandu Singha SO": "144025",
      "Lajpat Nagar Jalandhar SO": "144001",
      "Model House SO": "144003",
      "Padhiana SO": "144030",
      "Sant Nagar SO Jalandhar": "144001",
      "Suranussi SO": "144027",
      "Tower Town Colony SO": "144003",
      "General Bus Stand SO Jalandhar": "144001",
      "Model Town Jalandhar SO": "144003",
      "N R Colony SO": "144001",
      "Patara SO Jalandhar": "144101",
      "Railway Road SO Jalandhar": "144001",
      "Regional Campus GNDU SO": "144009",
      "Session Court SO Jalandhar": "144001",
      "Nodal Delivery Centre, Jalandhar": "144012",
      "Bopa Rai Kalan SO Jalandhar": "144630",
      "DGNakoder SO": "144040"
    },
    "Shahid Bhagat Singh Nagar": {
      "Jandiali BO": "144632",
      "Khothra Kalan BO": "144632",
      "Mehli BO": "144632",
      "Chinkoa BO": "144526",
      "Garle Dhaha BO": "144526",
      "Gulpur BO": "144526",
      "Makhoopur BO": "144525",
      "Mallewal BO": "144525",
      "Phambra BO": "144417",
      "Dhahan BO": "144505",
      "Heon BO": "144505",
      "Jhander Kalan BO": "144505",
      "Thanian BO": "144505",
      "Bhan Mazara BO": "144504",
      "Chak Bilgan BO": "144504",
      "Sarhal Qazian BO": "144502",
      "Bharta Khurd BO": "144518",
      "Garh Padhiana BO": "144518",
      "Dhangerpur BO": "144515",
      "Mirpur Jattan BO": "144515",
      "Muzaffarpur BO": "144515",
      "Shahabpur BO": "144515",
      "Bhin BO": "144512",
      "Mandhali BO": "144501",
      "Sarhan Renuan BO": "144501",
      "Gobindpur BO": "144510",
      "Paddi Matwali BO": "144510",
      "Pathlawa BO": "144510",
      "Sauna BO": "144516",
      "Bachhauri BO": "144526",
      "Mohar BO": "144526",
      "Rurki Muglan BO": "144526",
      "Sahdra BO": "144525",
      "Begumpur BO": "144524",
      "Kareempur Chahwala BO": "144524",
      "Baharowal BO": "144505",
      "Chak Kalan BO": "144505",
      "Kaleran BO": "144505",
      "Lidhar Kalan BO": "144502",
      "Bazidpur BO": "144518",
      "Mehrampur BO": "144518",
      "Sheikhepur Bagh BO": "144515",
      "Bhut BO": "144512",
      "Palli Uchi BO": "144512",
      "Khanpur BO": "144509",
      "Bhan rmazara BO": "144516",
      "Kaulgarh BO": "144526",
      "Phirni Mazara BO": "144526",
      "Rakkran Dhaha BO": "144526",
      "Chandiani Khurd BO": "144525",
      "Chandpur Rurki BO": "144524",
      "Pojewal BO": "144524",
      "Bisla BO": "144505",
      "Jandiala BO": "144505",
      "Malupota BO": "144505",
      "Langeri Jagirdaran BO": "144504",
      "Gunachaur BO": "144511",
      "Bharta Kalan BO": "144518",
      "Usmanpur BO": "144515",
      "Mangowal BO": "144512",
      "Lakhpur BO": "144509",
      "Jasso Mazara BO": "144501",
      "Bhagaura BO": "144516",
      "Bhaura BO": "144506",
      "Karawar BO": "144526",
      "Mojowal Majara BO": "144526",
      "Torowal BO": "144524",
      "Chak Ramu BO": "144504",
      "Katt BO": "144504",
      "Herian BO": "144511",
      "Majara Nau Abad BO": "144511",
      "Raipur Dhaba BO": "144511",
      "Kharkowal BO": "144518",
      "Khoja BO": "144518",
      "Jabbowal BO": "144512",
      "Khatkar Kalan BO": "144512",
      "Palli Jhikki BO": "144512",
      "Rampur BO": "144510",
      "Daulatpur BO": "144516",
      "Karimpur BO": "144516",
      "Kishanpura BO": "144516",
      "Sanawa BO": "144516",
      "Sujjon BO": "144506",
      "Karnana BO": "144513",
      "Rasulpur BO": "144513",
      "Allachaur BO": "144514",
      "Kariam BO": "144514",
      "Bharoli BO": "144503",
      "Ghuman BO": "144503",
      "Kangroor BO": "144503",
      "Kahlon BO": "144517",
      "Kot Ranjha BO": "144517",
      "Hansron BO": "144421",
      "Mehmoodpur BO": "144421",
      "Malpur BO": "144508",
      "Kulam BO": "144514",
      "Saloh BO": "144514",
      "Katarian BO": "144503",
      "Maqsoodpur BO": "144503",
      "Hiala BO": "144517",
      "Bohara BO": "144421",
      "Mirpur Lakha BO": "144421",
      "Chak Dana BO": "144422",
      "Garhi Qanogaon BO": "144521",
      "Garlon Bet BO": "144521",
      "Nighi BO": "144522",
      "Rel B.O": "144533",
      "Ghamaur BO": "144521",
      "Kangna Bet BO": "144521",
      "Rattewal BO": "144521",
      "Takarala BO": "144521",
      "Bagowal BO": "144522",
      "Aduana BO": "144521",
      "Mehatpur Oladini BO": "144521",
      "Udhanwal BO": "144521",
      "Banah BO": "144522",
      "Majara Jattan BO": "144522",
      "Bains BO": "144508",
      "Kariha BO": "144508",
      "Barnala Kalan BO": "144514",
      "Mahalon BO": "144503",
      "Sandhwan BO": "144503",
      "Behloor Kalan BO": "144517",
      "Bairsian BO": "144517",
      "Ghataron BO": "144421",
      "Bhakhlaur BO": "144422",
      "Bhaddi BO": "144521",
      "Nawanpind Tapprian BO": "144521",
      "Rakkar Bet BO": "144521",
      "Thopia BO": "144521",
      "Bharthala BO": "144522",
      "Mutton BO": "144522",
      "Surapur BO": "144506",
      "Chahal Kalan BO": "144507",
      "Hakimpur BO": "144507",
      "Jhingran BO": "144507",
      "Kamam BO": "144513",
      "Jagatpur BO": "144507",
      "Laroya BO": "144507",
      "Malo Mazara BO": "144029",
      "Talwandi Fattu BO": "144507",
      "Ratinda BO": "144029",
      "Amargarh BO": "144513",
      "Aur SO": "144417",
      "Garcha SO": "144518",
      "Gulshan Bazar Nawanshahar SO": "144514",
      "Khankhana SO": "144509",
      "Lassara SO": "144415",
      "Mahil Gailan SO": "144506",
      "Naura SO": "144508",
      "Behram SO": "144504",
      "Ladhana Jhikka SO": "144510",
      "N R Banga SO": "144505",
      "Banga SO": "144505",
      "Kahma SO": "144512",
      "Langroya SO": "144516",
      "Saroa SO": "144524",
      "Dosanjh Khurd SO": "144511",
      "Jadla SO": "144515",
      "Kultham SO": "144501",
      "Mokandpur SO": "144507",
      "Musapur SO": "144513",
      "Mehandpur SO": "144526",
      "Rahon SO": "144517",
      "Nawanshahar SO": "144514",
      "Pharala SO": "144503",
      "Sahlon SO": "144421",
      "Urapar SO": "144422",
      "Kathagrh SO": "144522",
      "Asron S.O": "144533",
      "Balachaur SO": "144521",
      "Sahiba SO": "144525",
      "Nawanshahar Mandi SO": "144514"
    },
    "AMRITSAR": {
      "Bhoewali BO": "143102",
      "Jafarkot BO": "143102",
      "Gorala BO": "143102",
      "Guru Ka Bagh BO": "143102",
      "Karyala BO": "143102",
      "Mehlanwala BO": "143102",
      "Mohar BO": "143102",
      "Othian BO": "143102",
      "Dhanoakalan BO": "143108",
      "Mode BO": "143108",
      "Mohawa BO": "143108",
      "Neshta BO": "143108",
      "Bhalaipur Purban BO": "143202",
      "Dhianpur BO": "143202",
      "Lakhuwal BO": "143202",
      "Jamalpur BO": "143203",
      "Jagdev Khurd BO": "143102",
      "Jastarwal BO": "143102",
      "Sarangdeo BO": "143102",
      "Uggar Aulakh BO": "143102",
      "Bachiwind BO": "143108",
      "Rangarh BO": "143108",
      "Wadala Khurd BO": "143202",
      "Bhlaipur Dorgan BO": "143201",
      "Kot Mehtab BO": "143201",
      "Makowal BO": "143103",
      "Sidhar BO": "143103",
      "Balharwal BO": "143102",
      "Dhariwal Kaler BO": "143102",
      "Gaggomahal BO": "143102",
      "Jasrur BO": "143102",
      "Sehensra BO": "143102",
      "Assarapur BO": "143108",
      "Bhaini Rajputan BO": "143108",
      "Rajatal BO": "143108",
      "Wadalkalan BO": "143202",
      "Bhalojla BO": "143201",
      "Dulonangal BO": "143201",
      "Gagrewal BO": "143201",
      "Kamalpur BO": "143103",
      "Bhallapind BO": "143102",
      "Fatehwal BO": "143102",
      "Shahura BO": "143108",
      "Khanpur BO": "143203",
      "Sheron Bagga BO": "143203",
      "Gaure Nangal BO": "143103",
      "Muchal BO": "143111",
      "Sidhar Rajputan BO": "143111",
      "Chatiwind BO": "143022",
      "Budha Theh BO": "143601",
      "Jagdev Bar BO": "143601",
      "Nag Kalan BO": "143601",
      "Sham Nagar BO": "143601",
      "Tarpai BO": "143601",
      "Gohalwar Warpal BO": "143022",
      "Rataul BO": "143022",
      "Warpal BO": "143022",
      "Kotla Sultan Singh BO": "143601",
      "Babowal BO": "143119",
      "Bagga BO": "143101",
      "Ram Diwali Muslama BO": "143119",
      "Chabha BO": "143022",
      "Bal Khurd BO": "143601",
      "Balkalan BO": "143601",
      "Begowal BO": "143601",
      "Bhangali BO": "143601",
      "Wadala Viram BO": "143601",
      "Sialka BO": "143119",
      "Thothian BO": "143111",
      "Gilwali BO": "143022",
      "Mehma BO": "143022",
      "Daburji BO": "143022",
      "Dadupura BO": "143601",
      "Jalalpura BO": "143601",
      "Marari Kalan BO": "143601",
      "Sohian Kalan BO": "143601",
      "Lopoke BO": "143109",
      "Mud Khokhar BO": "143109",
      "Chhidan BO": "143107",
      "Chicha BO": "143107",
      "Gharinda BO": "143107",
      "Hoshiar Nagar BO": "143107",
      "Ibban Kalan BO": "143009",
      "Sangna BO": "143009",
      "Nangal Dial Singh BO": "143113",
      "Nawanpind BO": "143113",
      "Rasulpur Kalan BO": "143113",
      "Tangra BO": "143149",
      "Tmmowal BO": "143149",
      "Abdal BO": "143502",
      "Ajaiwali BO": "143502",
      "Chogawan Rupowali BO": "143502",
      "Allowal BO": "143111",
      "Bhorchi Rajputana BO": "143111",
      "Butari BO": "143111",
      "Raipur Kalan BO": "143113",
      "Bhangwan BO": "143149",
      "Chhajalwindi BO": "143149",
      "Pakharpura BO": "143502",
      "Talwandi Dasaunda Singh BO": "143502",
      "Waryam Nangal BO": "143502",
      "Jaspal BO": "143111",
      "Kaleke BO": "143111",
      "Kakkar BO": "143109",
      "Bal Sarai BO": "143204",
      "Bhakna Kalan BO": "143107",
      "Ladhewal BO": "143107",
      "Thathgarh BO": "143009",
      "Wadala Johal BO": "143113",
      "Devidaspura BO": "143149",
      "Mallian BO": "143149",
      "Jaintipur BO": "143502",
      "Ludhar BO": "143502",
      "Uddoke BO": "143119",
      "Chananke BO": "143114",
      "Rajdhan BO": "143114",
      "Udhonangal BO": "143114",
      "Saidoke BO": "143114",
      "Adiwala BO": "143101",
      "Dujowal BO": "143603",
      "Jatta BO": "143603",
      "Chakkare Khan BO": "143112",
      "Jallupura Khera BO": "143112",
      "Khojkipur BO": "143112",
      "Lidhar BO": "143112",
      "Mianwind BO": "143112",
      "Akalgarh Dhupaian BO": "143116",
      "Bhattike BO": "143116",
      "Chogawan Sidhpur BO": "143116",
      "Mallowal BO": "143116",
      "Vallah BO": "143501",
      "Ekal Gudda BO": "143115",
      "Manawala Kalan BO": "143115",
      "Sarli Kalan BO": "143115",
      "Jalalusman BO": "143114",
      "Mehsampura BO": "143114",
      "Mehta BO": "143114",
      "Jhanjoti BO": "143101",
      "Loharka Kalan BO": "143101",
      "Mallunangal BO": "143101",
      "Dhardeo BO": "143205",
      "Ghagar Bhana BO": "143205",
      "Dist Jail BO": "143008",
      "Tanel BO": "143116",
      "Khankot Garden Colony BO": "143501",
      "Mudhal BO": "143501",
      "Nizampura BO": "143501",
      "Manawala Khurd BO": "143413",
      "Bhittewad BO": "143101",
      "Heir BO": "143101",
      "Miran Kot BO": "143101",
      "Ghonewal BO": "143603",
      "Dahoorian BO": "143603",
      "Bhinder BO": "143112",
      "Chima Bath BO": "143112",
      "Pheruman BO": "143112",
      "Butter Sivya BO": "143205",
      "Gumtala BO": "143008",
      "Pandori Warraich BO": "143008",
      "Dehriwala BO": "143116",
      "Jabowal BO": "143116",
      "Lola BO": "143116",
      "Jahangir BO": "143501",
      "Sohian Khurd BO": "143501",
      "Dharar BO": "143115",
      "Meherbanapura BO": "143115",
      "Sarli Khurd BO": "143115",
      "Taragarh BO": "143115",
      "Bhilowal Pacca BO": "143109",
      "Bhindi Aulakh BO": "143109",
      "Jodhe BO": "143204",
      "Bhopa Rai BO": "143107",
      "Padri BO": "143107",
      "Ram Tirath BO": "143107",
      "Bohru BO": "143009",
      "Talwandi Dogran BO": "143113",
      "Chohan BO": "143149",
      "Jandiala Cb BO": "143149",
      "Jethuwal BO": "143502",
      "Dhulka BO": "143111",
      "Lohgarh BO": "143111",
      "Arjan Manga BO": "143114",
      "Khabe Rajputana BO": "143114",
      "Harsha Chhina BO": "143101",
      "Jagdev Kalan BO": "143101",
      "Thoba BO": "143603",
      "Uppal BO": "143112",
      "Nangli BO": "143008",
      "Naushehra Nangli BO": "143008",
      "Kot Khera BO": "143116",
      "Fatehgarh Shukarchack BO": "143501",
      "Makhanwindi BO": "143501",
      "Jhita Kalan BO": "143413",
      "Takhutuchak BO": "143115",
      "Balbawa BO": "143606",
      "Kasail BO": "143105",
      "Kathania BO": "143105",
      "Khaper Kheri BO": "143105",
      "Brar BO": "143109",
      "Chawinda BO": "143109",
      "Khiala Kalan BO": "143109",
      "Manawala BO": "143109",
      "Bhindi Saydan BO": "143109",
      "Sarangra BO": "143109",
      "Dhade BO": "143504",
      "Kotli Dhole Shah BO": "143504",
      "Leharka BO": "143504",
      "Ram Diwali Hinduan BO": "143504",
      "Madhu Chhanga BO": "143606",
      "Mohan Bhandari BO": "143606",
      "Sangatpura BO": "143606",
      "Vachhoa BO": "143606",
      "Mahal BO": "143105",
      "Vanike BO": "143109",
      "Ranian BO": "143109",
      "Tera Kalan BO": "143103",
      "Bhilowal BO": "143504",
      "Shahzada BO": "143504",
      "Chak Sikandar BO": "143606",
      "Khatrian Kalan BO": "143606",
      "Dhand BO": "143105",
      "Wadala Bhittewad BO": "143105",
      "Dhaul Kalan BO": "143105",
      "Bhullar BO": "143109",
      "Kohala BO": "143109",
      "Tut BO": "143109",
      "Jhander BO": "143606",
      "Kotla Gujjran BO": "143606",
      "Basarke Gillan BO": "143105",
      "Gomanpura BO": "143105",
      "Kale Ghanupur BO": "143105",
      "Wadali Guru BO": "143105",
      "Hardo Maura BO": "143109",
      "Kohali BO": "143109",
      "Saurian BO": "143109",
      "Amritsar GPO": "143001",
      "Ajnala SO": "143102",
      "Chogawan SO": "143109",
      "Durgiana Mandir SO": "143001",
      "Fatehpur Rajputan SO": "143113",
      "Golden Temple SO": "143006",
      "Guru Nanak Dev University SO": "143005",
      "Kangra Colony SO": "143001",
      "Katra Karam Singh SO": "143006",
      "Ramdass SO": "143603",
      "Sultan Wind Gate SO": "143001",
      "Verka SO": "143501",
      "Bundala SO Amritsar": "143413",
      "Amritsar Kty SO": "143001",
      "Attari SO": "143108",
      "Beas SO": "143201",
      "Chamiari SO": "143103",
      "Chowk Rattan Singh SO": "143001",
      "Fatahpur SO": "143009",
      "Kathunangal SO": "143502",
      "Khalsa College SO": "143002",
      "Lawrence Road SO": "143001",
      "Majith Mandi SO": "143006",
      "Medical College SO Amritsar": "143001",
      "Nawan Kot SO": "143001",
      "Rayya SO": "143112",
      "Vijaya Nagar SO": "143001",
      "Jandiala Guru SO": "143115",
      "Baba Bakala SO": "143202",
      "Guru Bazar SO": "143006",
      "Katra Sher Singh SO": "143006",
      "Khilchian SO": "143111",
      "Kot Mit Singh SO": "143022",
      "Mohan Nagar SO Amritsar": "143006",
      "Raja Sansi SO": "143101",
      "Rayon  Silk Mill SO": "143105",
      "Tarsika SO": "143116",
      "Attari Rd Check Post SO": "143108",
      "Basti Ram Dhab SO": "143006",
      "Butala SO": "143203",
      "Chawinda Devi SO": "143504",
      "Chetanpura SO": "143606",
      "Chheharta SO": "143105",
      "DBJSingh SO": "143204",
      "Distillery Khasa SO": "143107",
      "Gandhi Bazar SO Amritsar": "143006",
      "Guru Ram Dass Niwas SO": "143006",
      "Hide Market SO": "143001",
      "Hs College SO": "143006",
      "JFMill SO": "143002",
      "Jandiala RS SO": "143149",
      "KOT ATMA RAM": "143006",
      "Majitha SO": "143601",
      "Mattewal SO": "143119",
      "Mehta Chowk SO": "143114",
      "NRL Workshop SO": "143001",
      "Sathiala SO": "143205",
      "Sjs Avenue SO": "143008",
      "Sultanwind SO": "143006",
      "Focal Point SO": "143006",
      "NODAL DELIVERY OFFICE": "143003",
      "Nodal Delivery Centre, Amritsar": "143004"
    },
    "BATHINDA": {
      "Dikh BO": "151103",
      "Kotra Koreyan Wala BO": "151103",
      "Pitho BO": "151103",
      "Dial Pura Bhai Ka BO": "151108",
      "Ramu Wala Jalalka BO": "151108",
      "Gehri Butter BO": "151401",
      "Jangi Rana BO": "151401",
      "Kotli Sabo BO": "151401",
      "Pakka Kalan BO": "151401",
      "Mandi Kalan BO": "151103",
      "Hakam Singh Wala BO": "151108",
      "Jalal BO": "151108",
      "Kaur Singh Wala BO": "151108",
      "Kishan Pura Kutti BO": "151401",
      "Kot Guru BO": "151401",
      "Dhade BO": "151103",
      "Ramanvas BO": "151103",
      "Aklia Jalal BO": "151108",
      "Ghudda BO": "151401",
      "Jassi Bag Wali BO": "151401",
      "Nand Garh BO": "151401",
      "Pathrala BO": "151401",
      "Gill Kalan BO": "151103",
      "Jaidan BO": "151103",
      "Jethu Ke BO": "151103",
      "Karar Wala BO": "151103",
      "Bandi BO": "151401",
      "Chak Attar Singh Wala BO": "151401",
      "Chak Ruldu Singh Wala BO": "151401",
      "Dunne Wala BO": "151401",
      "Teona Pujarian BO": "151302",
      "Behman Diwana BO": "151005",
      "Teona BO": "151005",
      "Chughe Kalan BO": "151005",
      "Hamirgarh BO": "151206",
      "Jhanduke BO": "151101",
      "Rai Khanna BO": "151101",
      "Sema BO": "151101",
      "Tung Wali BO": "151101",
      "Ablu BO": "151201",
      "Mehma Sarja BO": "151201",
      "Mehma Sawai BO": "151201",
      "Nehian Wala BO": "151201",
      "Virk Kalan BO": "151201",
      "Jaga Ram Tirath BO": "151302",
      "Kalal Wala BO": "151302",
      "Sekhpura BO": "151302",
      "Rai Ke Kalan BO": "151401",
      "Behman Jassa Singh Wala BO": "151302",
      "Bhagi Bander BO": "151302",
      "Chethewala BO": "151302",
      "Kaureana BO": "151302",
      "Jai Singh Wala BO": "151005",
      "Jhumba BO": "151005",
      "Jassi Pau Wali BO": "151005",
      "Gulab Garh BO": "151101",
      "Lehra Bega BO": "151111",
      "Lehra Dhur Kot BO": "151111",
      "Sevian BO": "151002",
      "Ganga BO": "151201",
      "Harrai Pur BO": "151201",
      "Janda Wala BO": "151201",
      "Jeeda BO": "151201",
      "Jiwan Singh Wala BO": "151302",
      "Natheha BO": "151302",
      "Singo BO": "151302",
      "Sardargarh BO": "151005",
      "Kot Shamir BO": "151005",
      "Guru Sar Sehne Wala BO": "151005",
      "Maluka BO": "151206",
      "Ghanda Bana BO": "151106",
      "Bhucho Kalan BO": "151101",
      "Chak Bakhtu BO": "151101",
      "Lehra Khanna BO": "151111",
      "Deon BO": "151002",
      "Akalia Kalan BO": "151201",
      "Bhokhra BO": "151201",
      "Khemuana BO": "151201",
      "Balloh BO": "151510",
      "Gehri Baghi BO": "151005",
      "Bir Behman BO": "151005",
      "Multania BO": "151005",
      "Naruana BO": "151005",
      "Balluna BO": "151005",
      "Bibi Wala BO": "151005",
      "Nasib Pura BO": "151005",
      "Kotha Guru BO": "151206",
      "Siryewala BO": "151206",
      "Gumti Kalan BO": "151106",
      "Bhucho Khurd BO": "151101",
      "Chak Fateh Sngh Wala BO": "151101",
      "Kot Fatta BO": "151101",
      "Bhisiana BO": "151201",
      "Burj Mehma BO": "151201",
      "Mehma Bhagwana BO": "151201",
      "Virk Khurd BO": "151201",
      "Chauke BO": "151510",
      "Mehta BO": "151005",
      "Gehri Bara Singh BO": "151509",
      "Mai Sar Khana BO": "151509",
      "Maur Kalan BO": "151509",
      "Poohli BO": "151102",
      "Dhapali BO": "151104",
      "Laleana BO": "151301",
      "Sekhu BO": "151301",
      "Ballian Wali BO": "151103",
      "Kamalu Swaitch BO": "151509",
      "Kutti Wal Kalan BO": "151509",
      "Peer Kot BO": "151509",
      "Bhaini Kani BO": "151105",
      "Bangi Rughu BO": "151301",
      "Bangi Ruldu BO": "151301",
      "Giana BO": "151301",
      "Kot Bakhtu BO": "151301",
      "Jodhpur Pakhar BO": "151509",
      "Ram Nagar BO": "151509",
      "Bajjoana BO": "151102",
      "Dial Pura Mirja BO": "151102",
      "Govind Pura BO": "151102",
      "Nathpura BO": "151102",
      "Raiya BO": "151104",
      "Sailbrah BO": "151104",
      "Burj Sema BO": "151509",
      "Ghuman Kalan BO": "151509",
      "Raj Garh Kubbe BO": "151509",
      "Kalyan Sukha BO": "151102",
      "Poohla BO": "151102",
      "Alike BO": "151104",
      "Malkana BO": "151301",
      "Bhagwan Garh BO": "151301",
      "Bhunder BO": "151103",
      "Bathinda HO": "151001",
      "Ind Estate Bathinda SO": "151001",
      "Phul SO": "151104",
      "Raman SO": "151301",
      "Rampura Phul SO": "151103",
      "Bathinda City SO": "151005",
      "Bhai Rupa SO": "151106",
      "Bhucho Mandi SO": "151101",
      "Ghtp Lehra Mohabbat SO": "151111",
      "Nathana SO": "151102",
      "Nfl Bathinda SO": "151003",
      "Kamla Nehru Colony Bathinda SO": "151001",
      "Mehraj SO": "151105",
      "Rampura Mandi SO": "151103",
      "Salabatpura SO": "151108",
      "Talwandi Sabo SO": "151302",
      "Bathinda Cantt SO": "151004",
      "Bhagta Bhai SO": "151206",
      "Gndtp Bathinda SO": "151002",
      "Goniana Mandi SO": "151201",
      "Maur Mandi SO": "151509",
      "Nai Basti Bathinda SO": "151001",
      "Railway Colony SO Bathinda": "151005",
      "Sangat SO": "151401",
      "MRSTU Bathinda": "151001",
      "NDC Bathinda": "151006"
    },
    "SANGRUR": {
      "Kheri Chehlan BO": "148025",
      "Tibba BO": "148025",
      "Bakshiwala BO": "148028",
      "Khadial BO": "148028",
      "Ram Nagar Chhana BO": "148025",
      "Kanakwal Bhanguan BO": "148028",
      "Kotra Amru BO": "148028",
      "Nilowal BO": "148028",
      "Bajwa BO": "148025",
      "Katron BO": "148025",
      "Chathe Roti Ram BO": "148028",
      "Jakhepal BO": "148028",
      "Gujran BO": "148035",
      "Janal BO": "148035",
      "Kadial BO": "148035",
      "Kamalpur BO": "148035",
      "Kheri BO": "148002",
      "Mehlan BO": "148002",
      "Hassanpur BO": "148034",
      "Mandi Bhadur Singh Wala BO": "148034",
      "Saron BO": "148034",
      "Haryau BO": "148031",
      "Phalera BO": "148031",
      "Balian BO": "148002",
      "Chural Kalan BO": "148033",
      "Dehla BO": "148033",
      "Dhindsa BO": "148033",
      "Nawangaon BO": "148033",
      "Banarsi BO": "148027",
      "Gulhari BO": "148027",
      "Fatehgarh Panjgrian BO": "148020",
      "Khetla BO": "148035",
      "Rogla BO": "148035",
      "Samuran BO": "148035",
      "Uppli BO": "148002",
      "Ubhewal BO": "148002",
      "Changal BO": "148034",
      "Kanjla BO": "148034",
      "Punnawal BO": "148034",
      "Ghorenab BO": "148031",
      "Gobindpura Jawaharwala BO": "148031",
      "Loha Khera BO": "148106",
      "Dudian BO": "148033",
      "Hamirgarh BO": "148033",
      "Makorar Sahib BO": "148033",
      "Maniana BO": "148033",
      "Raidharana BO": "148033",
      "Bhulan BO": "148027",
      "Khanal Kalan BO": "148035",
      "Mauran BO": "148035",
      "Changli BO": "148025",
      "Herike BO": "148025",
      "Dharamgarh BO": "148028",
      "Sulargharat BO": "148035",
      "Kular  Khurd BO": "148002",
      "Duggan BO": "148002",
      "Gaggarpur BO": "148002",
      "Bhindran BO": "148002",
      "Qila Hakima BO": "148034",
      "Daska BO": "148031",
      "Gidrani BO": "148031",
      "Sangatpura BO": "148031",
      "Dhadrian BO": "148106",
      "Mander Kalan BO": "148106",
      "Balran BO": "148033",
      "Lehal Kalan BO": "148033",
      "Mandvi BO": "148027",
      "Bahadurpur BO": "148002",
      "Chathe Sekhwan BO": "148002",
      "Badrukhan BO": "148002",
      "Gurusar Mastuana BO": "148002",
      "Mangwal BO": "148002",
      "Benra BO": "148034",
      "Bakhora Kalan BO": "148031",
      "Bhutal Kalan BO": "148031",
      "Chotian BO": "148031",
      "Namol BO": "148106",
      "Sahoke BO": "148106",
      "Sheron BO": "148106",
      "Bangan BO": "148033",
      "Rampur Gujran BO": "148033",
      "Shadihari BO": "148033",
      "Andana BO": "148027",
      "Dhatogal BO": "148022",
      "Bhullerheri BO": "148017",
      "Alloarakh BO": "148026",
      "Balial BO": "148026",
      "Ghanaur Jattan BO": "148026",
      "Gharachon BO": "148026",
      "Nagra BO": "148026",
      "Bharo BO": "148026",
      "Shahpur kalan BO": "148029",
      "Ganduan BO": "148030",
      "Ugrahan BO": "148030",
      "Kumbherwal BO": "148024",
      "Rangian BO": "148024",
      "Chhahar BO": "148035",
      "Mehsampur BO": "148017",
      "Meemsa BO": "148017",
      "Harchandpur BO": "148017",
      "Kalajhar BO": "148026",
      "Kapial BO": "148026",
      "Majhi BO": "148026",
      "Nadampur BO": "148026",
      "Kauhrian BO": "148030",
      "Bamal BO": "148024",
      "Baradwal BO": "148024",
      "Bhasaur BO": "148024",
      "Ghanaur Khurd BO": "148024",
      "Ghanauri Kalan BO": "148024",
      "Kaheru BO": "148024",
      "Kandhargarh BO": "148018",
      "Batriana BO": "148026",
      "Bhattiwal Kalan BO": "148026",
      "Channo BO": "148026",
      "Lad Banjara BO": "148030",
      "Mojowal BO": "148030",
      "Nangla BO": "148030",
      "Mullowal BO": "148024",
      "Bhojowali BO": "148017",
      "Balad Kalan BO": "148026",
      "Kakra BO": "148026",
      "Sakraudi BO": "148026",
      "Jharon BO": "148029",
      "Bhai Ke Pishore BO": "148030",
      "Gobindgarh Khokhar BO": "148030",
      "Badshahpur BO": "148024",
      "Banbhauri BO": "148024",
      "Rajomajra BO": "148024",
      "Sangrur HO": "148001",
      "CR Malerkotla SO": "148023",
      "Gaga Road SO": "148031",
      "H R Sangrur SO": "148002",
      "Lehragaga SO": "148031",
      "Sunam City SO": "148028",
      "Cheema SO": "148029",
      "Chhajli SO": "148030",
      "Dhuri SO": "148024",
      "Dirba SO": "148035",
      "Ladda SO": "148034",
      "N G M Sangrur SO": "148001",
      "Pakki Khanauri SO": "148027",
      "Sangrur Kty SO": "148001",
      "Sherpur SO": "148025",
      "Sliet Longowal SO": "148106",
      "Bhawanigarh SO": "148026",
      "IA Malerkotla SO": "148023",
      "Mini Secteriate Sangrur SO": "148001",
      "Sr Dhuri SO": "148024",
      "Sunam SO": "148028",
      "Bhalwan SO": "148017",
      "Moonak SO": "148033",
      "Sunam Kty S.O": "148028"
    },
    "BARNALA": {
      "Wazid Ke Khurd BO": "148109",
      "Pakhoke BO": "148103",
      "Chhiniwal Khurd BO": "148100",
      "Dhilwan BO": "148108",
      "Ghunas BO": "148108",
      "Karamgarh BO": "148109",
      "Cheema BO": "148103",
      "Jodhpur BO": "148103",
      "Thuliwal BO": "148025",
      "Moom BO": "148100",
      "Ramgarh BO": "148100",
      "Pakho Kalan BO": "148108",
      "Sukhpura Maur BO": "148108",
      "Sehjra BO": "148109",
      "Guram BO": "148025",
      "Bhotna BO": "148100",
      "Bihla BO": "148100",
      "Dewana BO": "148100",
      "Sher Singh Pura BO": "148100",
      "Daraj BO": "148108",
      "Mauran BO": "148108",
      "Badbar BO": "148106",
      "Nihaluwal BO": "148104",
      "Bhadalwad BO": "148109",
      "Nangal Thulewal BO": "148109",
      "Chauhan Ke Kalan BO": "148109",
      "Rure Ke Kalan BO": "148107",
      "Bhaini Mehraj BO": "148106",
      "Hamidi BO": "148025",
      "Bakhatgarh BO": "148100",
      "Gehal BO": "148100",
      "Tajoke BO": "148108",
      "Ugoke BO": "148108",
      "Chhiniwal Kalan BO": "148104",
      "Kalalmajra BO": "148104",
      "Kurar BO": "148104",
      "Qutba BO": "148104",
      "Dhaula BO": "148107",
      "Dhurkot BO": "148107",
      "Kahne Ke BO": "148107",
      "Khudi  Kalan BO": "148107",
      "Chananwal BO": "148104",
      "Chhapa BO": "148104",
      "Gangohar BO": "148104",
      "Nainewal BO": "148102",
      "Talwandi BO": "148102",
      "Dangarh BO": "148105",
      "Harigarh BO": "148105",
      "Kaleke BO": "148105",
      "Kattu BO": "148105",
      "Raisar BO": "148101",
      "Attar Singh Wala BO": "148105",
      "Bhathlan BO": "148105",
      "Kotduna BO": "148105",
      "Sekha BO": "148024",
      "Pharwahi BO": "148101",
      "Thikriwala BO": "148101",
      "Jangiana BO": "148102",
      "Sandhu Kalan BO": "148102",
      "Bhaini Jassan BO": "148105",
      "Pandher BO": "148105",
      "Jhaloor BO": "148024",
      "Barnala SO": "148101",
      "Handiaya SO": "148107",
      "Mehal Kalan SO": "148104",
      "Bhadaur SO Sangrur": "148102",
      "Longowal SO": "148106",
      "Ncc Barnala SO": "148101",
      "Sanghera SO": "148109",
      "Barnala Kty SO": "148101",
      "Dhanaula SO": "148105",
      "Shaina SO": "148103",
      "Tallewal SO": "148100",
      "Tapa SO": "148108"
    },
    "MALERKOTLA": {
      "Sangala BO": "148023",
      "Kup Kalan BO": "148019",
      "Himtana BO": "148023",
      "Khanpur BO": "148023",
      "Khanpur Mandian BO": "148023",
      "Manvi BO": "148023",
      "Mubarkpur BO": "148023",
      "Roorkee Kalan BO": "148023",
      "Saraud BO": "148023",
      "Jhuner BO": "148020",
      "Shergarh Cheema BO": "148020",
      "Hathan BO": "148023",
      "Hussainpura BO": "148023",
      "Bhogiwal BO": "148019",
      "Bhurthala Mander BO": "148023",
      "Haider Nagar BO": "148023",
      "Manak Majra BO": "148023",
      "Kalyan BO": "148020",
      "Khurd BO": "148020",
      "Mithewal BO": "148020",
      "Lassoi BO": "148023",
      "Kanganwal BO": "148020",
      "Kothala BO": "148020",
      "Manki BO": "148020",
      "Bhoodan BO": "148023",
      "Gowara BO": "148023",
      "Mohamedpur BO": "148020",
      "Mullabadha BO": "148022",
      "Rohira BO": "148021",
      "Jhall BO": "148022",
      "Bhatian Khurd BO": "148018",
      "Dehliz Kalan BO": "148021",
      "Jandali Khurd BO": "148021",
      "Nathu Majra BO": "148021",
      "Maholi Kalan BO": "148021",
      "Banbhaura BO": "148022",
      "Bathan BO": "148022",
      "Jabbomajra BO": "148022",
      "Chaunda BO": "148022",
      "Ahmedgarh sO": "148021",
      "Amargarh SO": "148022",
      "Bagrian SO": "148018",
      "Jitwal Kalan SO": "148019",
      "Malerkotla SO": "148023",
      "Sandhaur SO": "148020"
    },
    "HOSHIARPUR": {
      "Gondpur BO": "146105",
      "Possi BO": "144531",
      "Hakumatpur BO": "146107",
      "Fatehgarh Niara BO": "146022",
      "Dhakkowal BO": "146111",
      "Sahri BO": "146111",
      "Saleempur BO": "144202",
      "Mona Klan BO": "146112",
      "Kharaudi BO": "146107",
      "Dagana Kalan BO": "146022",
      "Nasrala BO": "146022",
      "Ajram BO": "146111",
      "Kahri BO": "146111",
      "Bhungarani BO": "146112",
      "Hukkran BO": "146112",
      "Pandorikad BO": "146112",
      "Badesron BO": "144528",
      "Fateh Pur Khurd BO": "144528",
      "Saila Kalan BO": "144529",
      "Chak Singha BO": "144532",
      "Hayatpur Rurki BO": "144532",
      "Badla Mahi BO": "144105",
      "Mandial BO": "144105",
      "Pandori Rajputan BO": "144105",
      "Talwandi Arayan BO": "144105",
      "Jandiala BO": "146109",
      "Langeri BO": "146109",
      "Meghowal BO": "146109",
      "Birampur BO": "144528",
      "Dhamai BO": "144532",
      "Sahungra BO": "144532",
      "Pandori Phagurian BO": "144105",
      "Soos BO": "144105",
      "Jiwanpur Jattan BO": "146109",
      "Mazara Dingrian BO": "146109",
      "Meghowal Ganjyan BO": "146022",
      "Taragarh BO": "146022",
      "Attowal BO": "146111",
      "Bassi Daulat Khan BO": "146111",
      "Bathian Brahmnan BO": "146111",
      "Harta BO": "146112",
      "Mukhliana BO": "146112",
      "Ahrana Klaln BO": "146112",
      "Tanuli BO": "146112",
      "Pandori Bibi BO": "146112",
      "Kukkran BO": "144528",
      "Moela Wahidpur BO": "144528",
      "Padrana BO": "144528",
      "Pakhowal BO": "144528",
      "Satnaur BO": "144528",
      "Bassi Gulam Hussain BO": "146021",
      "Bassi Purani BO": "146021",
      "Dada BO": "146021",
      "Nara BO": "146021",
      "Paddi Sura Singh BO": "144529",
      "Bainstani Kalan BO": "144105",
      "Kitna BO": "144531",
      "Ganeshpur Bharta BO": "146106",
      "Khera BO": "146106",
      "Bhatrana BO": "146111",
      "Badla BO": "144223",
      "Bharowal BO": "144529",
      "Dadyal BO": "144529",
      "Jassowal BO": "144529",
      "Panam BO": "144532",
      "Rurki Khas BO": "144532",
      "Simbli BO": "144532",
      "Kharar Achharwal BO": "146108",
      "Laksian BO": "146108",
      "Makhsoospur BO": "146108",
      "Pandori  Ganga Singh BO": "146108",
      "Sarhala Khurd BO": "146108",
      "Phambian BO": "144105",
      "Gandhowal BO": "146109",
      "Dadupur Garoa BO": "144105",
      "Kadiana BO": "144105",
      "Kathe Adhkare BO": "144105",
      "Sandhra BO": "144105",
      "Sandhra Sodhian BO": "144105",
      "Mehngarwal Doaba BO": "146109",
      "Muggowal BO": "146109",
      "Sakruli BO": "146109",
      "KHANAURA BO": "144404",
      "Jahan Khelan BO": "146110",
      "Kharkan Camp BO": "146110",
      "Mehlanwali BO": "146110",
      "Behbalpur BO": "144519",
      "Mananhana BO": "144519",
      "Thinda BO": "144519",
      "Chak Sadu BO": "146110",
      "Pach Nangal Khushalpur BO": "144519",
      "Bahowal BO": "146105",
      "Nangal Khunga BO": "144212",
      "Argowal BO": "144207",
      "Bahtiwal BO": "144207",
      "Chathial Khurd BO": "144207",
      "Saggran BO": "144221",
      "Nangal Bihalan BO": "144221",
      "Bhagran BO": "144221",
      "Bariana BO": "144208",
      "Bassi Ballo BO": "144208",
      "Chowki Patiari BO": "144209",
      "Dandoh BO": "144209",
      "Patial BO": "144209",
      "Behlakhan BO": "144223",
      "Dadial BO": "144223",
      "Narangpur BO": "144223",
      "Rampur Haler BO": "144223",
      "Ghorewaha BO": "146116",
      "Dhugga Kalan BO": "144305",
      "Safdarpur BO": "144305",
      "Bodal Garna Sahib BO": "144305",
      "Jalalpur BO": "144202",
      "Hoshiarpur Kalota BO": "144211",
      "Mansoorpur BO": "144211",
      "Musahibpur BO": "144211",
      "Baja Chak BO": "144214",
      "Dhanoa BO": "144214",
      "Terkiana BO": "144214",
      "Bassi Jalal Khan BO": "144204",
      "Jaura BO": "144204",
      "SHERGARH BO": "146023",
      "Jaja BO": "144212",
      "Kandhali Narangpur BO": "144212",
      "Bhagowal BO": "146024",
      "Lambra Kangri BO": "146113",
      "Pandori Bawa Dass BO": "146113",
      "Lachowal BO": "146113",
      "Fatehpur BO": "144222",
      "Handwal BO": "144222",
      "Karari BO": "144222",
      "Kukanet BO": "144206",
      "Mand Pandher BO": "144207",
      "Pandori Atwal BO": "144207",
      "Rupowal BO": "144207",
      "Jandaur BO": "144207",
      "Jalota BO": "144207",
      "Passi Kandi BO": "144207",
      "Kurala Kalan BO": "144204",
      "Nadalon BO": "144404",
      "Panjaura BO": "144404",
      "Bombeli BO": "146101",
      "Manolian BO": "146101",
      "Nangal Khurd BO": "146101",
      "Bachhohi BO": "146102",
      "Bahadarpur Bahian BO": "146102",
      "Chabbewal BO": "146102",
      "Jandoli BO": "146102",
      "Maili BO": "146102",
      "Garhi Mansowal BO": "144523",
      "Kotmaira BO": "144523",
      "Dhada Kalan BO": "144520",
      "Pandori Ladha Singh BO": "144520",
      "Suni BO": "144520",
      "Lalwan BO": "144530",
      "Kaindowal BO": "144530",
      "Panwan BO": "144207",
      "Budhabar BO": "144221",
      "Dhamian BO": "144221",
      "Gera BO": "144221",
      "Sariana BO": "144221",
      "Bhikhowal BO": "144208",
      "Baghpur BO": "144208",
      "Kakkon BO": "144208",
      "Alampur BO": "144202",
      "Bains Awan BO": "144202",
      "Sango Katrala BO": "144211",
      "Mundian Jattan BO": "146114",
      "Begumpur Jandiala BO": "146115",
      "Kalubahar BO": "146115",
      "Umarpur BO": "144214",
      "Manak Dheri BO": "144204",
      "Saidpur BO": "144204",
      "Munak Kalan BO": "144204",
      "Chagran BO": "146023",
      "Nangal Shahidan BO": "146023",
      "Sarangwal BO": "146102",
      "Bhilowal BO": "146104",
      "Bohan BO": "146104",
      "Jallowal Khanoor BO": "146104",
      "Lehli Kalan BO": "146104",
      "Nainwan BO": "144523",
      "Thowana BO": "144520",
      "Chohal BO": "146024",
      "Mehngarwal BO": "146024",
      "Degham BO": "144527",
      "Garhi Matton BO": "144527",
      "Gogon BO": "144527",
      "Khanpur BO": "146114",
      "Amroh BO": "144224",
      "Bhater BO": "144224",
      "Bhavnaur BO": "144224",
      "Manhota BO": "144213",
      "Sansarpur BO": "144213",
      "Jhawan BO": "144212",
      "Rajpur Gahot BO": "144212",
      "Gignowal BO": "146113",
      "Sikri BO": "146113",
      "Ambala Jattan BO": "144207",
      "Chang Basoa BO": "144207",
      "Chipra BO": "144207",
      "Daddar BO": "144221",
      "Ghogra BO": "144221",
      "Gobindpur Khun Khun BO": "144208",
      "Sataur BO": "144208",
      "Behkushala BO": "144223",
      "Sarhala Mundian BO": "146116",
      "Khunkhun Kalan BO": "144305",
      "Berchha BO": "144305",
      "Nathupur BO": "144202",
      "Tahli BO": "144202",
      "Khanpur Latifpur BO": "144211",
      "Naushera Pattan BO": "144211",
      "Abdulapur BO": "144214",
      "Lamin Pandori BO": "144214",
      "Talwandi Dadian BO": "144204",
      "Todarpur BO": "144404",
      "Mehtiana BO": "144404",
      "Dihana BO": "144406",
      "Ram Colony Camp BO": "146023",
      "Kalewal Bhagtan BO": "146102",
      "Naru Nangal BO": "146102",
      "Singhpur BO": "146102",
      "Jangliana BO": "146103",
      "Bajrawar BO": "146104",
      "Patti BO": "146104",
      "Bhawanipur BO": "144523",
      "Kalewal BO": "144523",
      "Mehand Wani BO": "144523",
      "Aiman Jattan BO": "144520",
      "Mustapur BO": "146024",
      "Manguawal Nari BO": "146024",
      "Basiala BO": "144527",
      "Gajjar BO": "144530",
      "Rampur Jhanjowal BO": "144530",
      "Harsipind BO": "144212",
      "Kandhala Sheikhan BO": "144212",
      "Maseet Pal Kot BO": "144212",
      "Dhade Fateh Singh BO": "146113",
      "Khadiala BO": "146113",
      "Nainowal Jattan BO": "146113",
      "Hardokhanpur BO": "146113",
      "Deopur BO": "144222",
      "Bahera BO": "144206",
      "Daffar BO": "144207",
      "Bhana BO": "144207",
      "Dagon BO": "144221",
      "Ghagwal BO": "144221",
      "Seeprian BO": "144221",
      "Bassi Wazid BO": "144208",
      "Kotlanaudh Singh BO": "144208",
      "Hardo Neknama BO": "144223",
      "Muradpur Naryal BO": "146116",
      "Johal BO": "144305",
      "Jhingar Kalan BO": "144305",
      "Ranipind BO": "144202",
      "Parika BO": "144211",
      "Tranglian BO": "144211",
      "Rajwal BO": "144216",
      "Changala BO": "144214",
      "Baich BO": "144204",
      "Talwandi Sallan BO": "144204",
      "Zahura BO": "144204",
      "Phuglana BO": "144404",
      "Parsowal BO": "146102",
      "Thakrowal BO": "146103",
      "Sasoli BO": "146104",
      "Haibowal BO": "144523",
      "Adamwal BO": "146024",
      "Bora BO": "144527",
      "Denowal Kalan BO": "144527",
      "Ibrahimpur BO": "144527",
      "Ror Mazara BO": "144527",
      "Fateh Pur Kothi BO": "144530",
      "Bringali BO": "144224",
      "Ramgarh Sikri BO": "144224",
      "Bariowal BO": "144306",
      "Kotli Khas BO": "144306",
      "Fatehpur Bhattlan BO": "144213",
      "Koi BO": "144213",
      "Dhoot Kalan BO": "144210",
      "Khiala Bulanda BO": "144210",
      "Channaur BO": "144306",
      "Dhola Khera BO": "144306",
      "Hardo Khund Pur BO": "144306",
      "Harse Mansar BO": "144306",
      "Chak Ladhian BO": "144210",
      "Chautala BO": "144210",
      "Darapur BO": "144210",
      "Dharampur BO": "144224",
      "Behbalmanj BO": "144306",
      "Jandwal BO": "144306",
      "Mehtabpur BO": "144306",
      "Hussain Pur Lalowal BO": "144210",
      "Sarhala Kalan SO": "146108",
      "Sham Chaurasi SO": "144105",
      "Tuto Mazara SO": "146109",
      "Dasuya HO": "144205",
      "Hoshiarpur HO": "146001",
      "Bhanowal SO": "144213",
      "Bhambotar SO": "144224",
      "Bhangala SO": "144306",
      "Binewal SO": "144523",
      "Model Town SO Hoshiarpur": "146001",
      "Moranwali SO": "144531",
      "Rajpur Bhayan SO": "146112",
      "Rampur Bilron SO": "144528",
      "Bhunga SO": "144210",
      "Mukerian SO": "144211",
      "Bahadurpur Chowk SO": "146001",
      "Bajwara SO": "146023",
      "Barian  Kalan SO": "146101",
      "Bassi Kalan SO": "146102",
      "Hoshiarpur City SO": "146001",
      "Kamalpur SO Nawanshahr": "146001",
      "Kotfathui SO": "144519",
      "Mahilpur SO": "146105",
      "Mini Sectt SO": "146001",
      "Purhiran SO": "146111",
      "Bulhowal SO": "146113",
      "Garhdiwala SO": "144207",
      "Hajipur SO": "144221",
      "Kamahi Devi SO": "144223",
      "Bham SO": "146103",
      "Bharwain Road SO": "146001",
      "Datarpur SO": "144222",
      "Dholbaha SO": "144206",
      "Hariana SO": "144208",
      "Janauri SO": "144209",
      "Kandhala Jattan SO": "146116",
      "Khudda SO": "144305",
      "Pajjodeotta SO": "146115",
      "Tanda SO": "144204",
      "Urmar SO": "144204",
      "Bihala SO": "146104",
      "Gaushala Bazar SO": "146001",
      "Jaijon SO": "144530",
      "Nangal Kalan SO": "146106",
      "Paldi SO Hoshiarpur": "146107",
      "Sadhu Ashram SO": "146021",
      "Samundra SO": "144532",
      "Binjon SO": "144520",
      "Factory Area Chohal SO": "146024",
      "Garhshanker SO": "144527",
      "Kot Abdul Khaliq SO": "146110",
      "Piplanwala SO": "146022",
      "Railway Road SO Hoshiarpur": "146001",
      "Saila Khurd SO": "144529",
      "Budhipind SO": "144212",
      "Miani SO": "144202",
      "Nandachaur SO": "146114",
      "Talwara Township SO": "144216",
      "Tanda Ram Sahai SO": "144214",
      "Ajnoha SO": "144404",
      "Baddon SO": "144406"
    },
    "Tarn Taran": {
      "Valtoha BO": "143416",
      "Varnala BO": "143416",
      "Chahal BO": "143414",
      "Cheema Kalan BO": "143414",
      "Gandiwind BO": "143414",
      "Naushhra Dhalla BO": "143414",
      "Bakipur BO": "143302",
      "Musse BO": "143302",
      "Padhri Kalan BO": "143302",
      "Sohal BO": "143302",
      "Bhucher Kalan BO": "143302",
      "Jeowala BO": "143302",
      "Jhamke BO": "143302",
      "Jalalabad BO": "143118",
      "Rampur Bhootwind BO": "143118",
      "Sohawa BO": "143410",
      "Gaggobhua BO": "143302",
      "Pindian BO": "143118",
      "Vairowal Bawian BO": "143118",
      "Dadeha Sahib BO": "143410",
      "Gandiwind Dhattal BO": "143410",
      "Khara BO": "143410",
      "Marhana BO": "143410",
      "Thatha BO": "143410",
      "Beharipura BO": "143118",
      "Hothian BO": "143118",
      "Tharu BO": "143402",
      "Thathi Khara BO": "143402",
      "Bagrian BO": "143402",
      "Naurangabad BO": "143402",
      "Johal Raju Singh BO": "143402",
      "Pandori Gola BO": "143402",
      "Daleke BO": "143402",
      "Manochahal BO": "143402",
      "Kadgill BO": "143402",
      "Khabedogran BO": "143402",
      "Qilla Kavi Santokh BO": "143402",
      "Pandori Takhtmal BO": "143402",
      "Palasaur BO": "143402",
      "Pandori Ransingh BO": "143402",
      "Aima Kalan BO": "143301",
      "Baghiari BO": "143301",
      "Kot Dharam Chand Kalan BO": "143301",
      "Lalu Ghuman BO": "143301",
      "Chamba Kalan BO": "143408",
      "Pheloke BO": "143411",
      "Sheron BO": "143411",
      "Tur BO": "143411",
      "Usman BO": "143411",
      "Johal Dhai Wala BO": "143407",
      "Pringri BO": "143412",
      "Ratta Gudda BO": "143412",
      "Dayal Pura BO": "143304",
      "Kalsian Kalan BO": "143304",
      "Marjindpura BO": "143304",
      "Pahuwind BO": "143303",
      "Singhpura BO": "143303",
      "Alaadeenpur BO": "143411",
      "Munda Pind BO": "143407",
      "Bhai Ladhu BO": "143304",
      "Chuslewar BO": "143304",
      "Dinewal BO": "143406",
      "Kallah BO": "143406",
      "Pakhoke BO": "143406",
      "Dall BO": "143305",
      "Algon Khurd BO": "143419",
      "Bhathal Bhai BO": "143409",
      "Mohanpura BO": "143409",
      "Bhoprai BO": "143416",
      "Bhuse BO": "143107",
      "Blair BO": "143303",
      "Sugga BO": "143303",
      "Panjwar BO": "143301",
      "Pakhopura BO": "143408",
      "Jamarai BO": "143411",
      "Lalpura BO": "143411",
      "Rusulpur BO": "143411",
      "Shahabpur BO": "143411",
      "Khela BO": "143407",
      "Dhunda BO": "143422",
      "Manak Dheke BO": "143422",
      "Alipur BO": "143412",
      "Kirtowal BO": "143412",
      "Bahmniwala BO": "143416",
      "Kullah BO": "143304",
      "Manihala Jai Singh BO": "143304",
      "Jaura BO": "143415",
      "Sarhali Mandan BO": "143415",
      "Shahbazpura BO": "143415",
      "Deo BO": "143406",
      "Jahangir BO": "143406",
      "Chhina Bidhi Chand BO": "143305",
      "Sidhwa BO": "143305",
      "Wan Tara Singh BO": "143305",
      "Dibbi Pura BO": "143419",
      "Lakhna BO": "143419",
      "Mastgarh BO": "143419",
      "Brahmpura BO": "143409",
      "Rani Villa BO": "143409",
      "Bhagupura BO": "143416",
      "Bhatte Bhaini BO": "143416",
      "Dubli BO": "143416",
      "Kot Budha BO": "143416",
      "Mahaneke Jandh BO": "143416",
      "Lauka BO": "143415",
      "Nandpur BO": "143415",
      "Nagoke BO": "143117",
      "Viring BO": "143117",
      "Vain Poin BO": "143117",
      "Mandir Mathra Bhagi BO": "143305",
      "Mari Kamboke BO": "143305",
      "Mari Megha BO": "143305",
      "Amarkot BO": "143419",
      "Asal Autar BO": "143419",
      "Bhure Kohna BO": "143419",
      "Bhure Nau BO": "143419",
      "Mehndipura BO": "143419",
      "Rattoke Gurudwara BO": "143419",
      "Thathian Mahantan BO": "143409",
      "Saidpur BO": "143416",
      "Shaheed BO": "143416",
      "Takarpura BO": "143416",
      "Bainka BO": "143303",
      "Maluwal BO": "143301",
      "Dhundhai Wala BO": "143408",
      "Gharka Buwala BO": "143408",
      "Ruriwala BO": "143408",
      "Banwalipur BO": "143411",
      "Kot MohdKhan BO": "143411",
      "Behal BO": "143407",
      "Khawaspur BO": "143407",
      "Jhandher M Purkhan BO": "143422",
      "Jaunke BO": "143412",
      "Bhagwanpura BO": "143304",
      "Makhi Kalan BO": "143304",
      "Manakpura BO": "143304",
      "Galalipur BO": "143415",
      "Sakhira BO": "143415",
      "Sheikh BO": "143415",
      "Bath BO": "143406",
      "Banian BO": "143117",
      "Basarke BO": "143305",
      "Narli BO": "143305",
      "Rajoke BO": "143305",
      "Kalia Sanktra BO": "143419",
      "Mahmoodpura BO": "143419",
      "Manawan BO": "143419",
      "Sangatpura BO": "143409",
      "Warrian BO": "143409",
      "Barwala BO": "143416",
      "Bhangala BO": "143416",
      "Dhariwal BO": "143416",
      "Gharyala BO": "143416",
      "Sabhra BO": "143416",
      "Bharowal BO": "143117",
      "Tarn Taran HO": "143401",
      "Fatehabad SO Amritsar": "143407",
      "Khadoor Sahib SO": "143117",
      "Khem Karan SO": "143419",
      "Naushehra Pannuan SO": "143409",
      "Patti SO Tarn Taran": "143416",
      "Dhotian SO": "143411",
      "Harike SO": "143412",
      "Vairowal SO": "143118",
      "Police Lines Tarn Taran SO": "143402",
      "Goindwal SO": "143422",
      "Kairon SO": "143415",
      "Sur Singh SO": "143302",
      "Bhikhiwind SO": "143303",
      "Chabhal SO": "143301",
      "Chohla Sahib SO": "143408",
      "Kacha Pacca SO": "143304",
      "Kang SO": "143406",
      "Khalra SO": "143305",
      "Sarai Amant Khan SO": "143414",
      "Sarhali SO Tarn Taran": "143410"
    },
    "SRI MUKTSAR SAHIB": {
      "Aspal BO": "151210",
      "Mohlan BO": "151210",
      "Pakki BO": "151210",
      "Urang BO": "151210",
      "Karampatti BO": "151210",
      "Kattianwali BO": "151210",
      "Dabwali Dhab BO": "152115",
      "Gurusar Jodhe Ka BO": "152115",
      "Khema Khera BO": "152115",
      "Mahni Kherea BO": "152115",
      "Chhattiana BO": "152031",
      "Gurhi Sangar BO": "152031",
      "Kauni BO": "152031",
      "Mallan BO": "152031",
      "Ghagga BO": "152101",
      "Husner": "152101",
      "Kot Bhai BO": "152101",
      "Lalbai BO": "152101",
      "Sahib Chand BO": "152101",
      "Assa Buttar BO": "152025",
      "Hari Ke Kalan BO": "152025",
      "Tarmala BO": "152115",
      "Butter Sharing BO": "152031",
      "Sukhana Ablu BO": "152031",
      "Channu BO": "152101",
      "Peori BO": "152101",
      "Bodi Wala BO": "151210",
      "Qabar Wala BO": "151210",
      "Rani Wala BO": "151210",
      "Ratta Khera BO": "151210",
      "Ratta Tibba BO": "151210",
      "Sarawan Bodla BO": "151210",
      "Khokhar BO": "152025",
      "Sarai Naga BO": "152025",
      "Sure Wala BO": "152025",
      "Kotli BO": "151202",
      "Midda BO": "151210",
      "Panni Wala Fatta BO": "151210",
      "Bhutti Wala BO": "152025",
      "Sham Khera BO": "152115",
      "Bhullar BO": "152031",
      "Bhaliana BO": "152101",
      "Daula BO": "152101",
      "Madhir BO": "152101",
      "Tharaj Wala BO": "152101",
      "Panjawa BO": "152113",
      "Sikh Wala BO": "152113",
      "Singhewala BO": "152113",
      "Chappianwali BO": "152107",
      "Dabwali Rahurianwali BO": "152107",
      "Virk Khera BO": "152107",
      "Lakhewali BO": "152026",
      "Lubanianwali BO": "152026",
      "Udekaran BO": "152026",
      "Chak Duhe Wala BO": "152032",
      "Chak Gilze Wala BO": "152032",
      "Dhaula Kingra BO": "152114",
      "Fatehpur Minian BO": "152114",
      "Kuttianwali BO": "152114",
      "Mahuana BO": "152114",
      "Badal BO": "152113",
      "Banwala BO": "152113",
      "Bhitti Wala BO": "152113",
      "Mehna BO": "152113",
      "Bhagwanpura BO": "152107",
      "Burj Sidhwan BO": "152107",
      "Bring Khera BO": "151211",
      "Middu Khera BO": "151211",
      "Ballamgarh BO": "152026",
      "Thandewala BO": "152026",
      "Badian BO": "152112",
      "Bhullerian BO": "152112",
      "Bhunder BO": "152112",
      "Ena Khera BO": "152112",
      "Khunan Kalan BO": "152112",
      "Mahbadhar BO": "152032",
      "Sotha BO": "152032",
      "Khuddian Gulab Singh BO": "152113",
      "Faqarsar BO": "152107",
      "Malout Village BO": "152107",
      "Haku Wala BO": "151211",
      "Killianwali BO": "151211",
      "Akalgarh BO": "152026",
      "Bhagsar BO": "152026",
      "Jhabel Wali BO": "152026",
      "Madrassa BO": "152026",
      "Nandgarh BO": "152026",
      "Sanghu dhon BO": "152026",
      "Jhurar BO": "152112",
      "Malwala Katorewala BO": "152112",
      "Bam BO": "152032",
      "Chak Shere Wala BO": "152032",
      "Abul Khurana BO": "152114",
      "Deon Khera BO": "152114",
      "Phullu Khera BO": "152114",
      "Sehna Khera BO": "152114",
      "Fatuhi Khera BO": "152113",
      "Kandu Khera BO": "152113",
      "Mann BO": "152113",
      "Roran Wali BO": "152113",
      "Ghumiara Khera BO": "152107",
      "Jand Wala Chadat Singh BO": "152107",
      "Ghumiara BO": "151211",
      "Lohara BO": "151211",
      "Badhai BO": "152026",
      "Goniana Village BO": "152026",
      "Kanianwali BO": "152026",
      "Mangatker BO": "152026",
      "Rahurianwali BO": "152026",
      "Sammewali BO": "152026",
      "Seerwali BO": "152026",
      "Gurusar BO": "152112",
      "Khane Ki Dhab BO": "152112",
      "Kuraiwala BO": "152112",
      "Lakkarwala BO": "152112",
      "Tarkhanwala BO": "152112",
      "Bhangchari BO": "152032",
      "Chak Mahanbadhar BO": "152032",
      "Dhigana BO": "152032",
      "Tamkot BO": "152032",
      "Adhnian BO": "152114",
      "Ratherian BO": "152114",
      "Ram Nagar SO Muktsar": "152112",
      "Tappa Khera SO": "152114",
      "Rupana SO": "152032",
      "Bhaika Khera SO": "152115",
      "Doda SO Muktsar": "152031",
      "Malout SO": "152107",
      "Mandi Killianwali SO": "151211",
      "Alamwala SO": "151210",
      "Bariwala SO": "152025",
      "Muktsar Kty SO": "152026",
      "Gidderbaha SO": "152101",
      "Lambi SO": "152113",
      "Muktsar SO": "152026"
    },
    "FATEHGARH SAHIB": {
      "Bharpurgarh BO": "147203",
      "Kaulgarh BO": "147203",
      "Khanian BO": "147203",
      "Khumna BO": "147203",
      "Tibbi BO": "147203",
      "Lataur BO": "140406",
      "Rampur Landiali BO": "140408",
      "Rupalheri BO": "140408",
      "Malkomajra BO": "140406",
      "Mannupur BO": "140406",
      "Nabipur BO": "140406",
      "Tanda Badha BO": "147203",
      "Pamaur BO": "140408",
      "Saidpura BO": "140406",
      "Talania BO": "140406",
      "Machrai Kalan BO": "147203",
      "Noorpur BO": "147203",
      "Roorki BO": "147104",
      "Balhari Kalan BO": "140408",
      "Dhangerian BO": "140408",
      "Harlalpur BO": "140406",
      "Sadhugarh BO": "140406",
      "Mullepur BO": "147004",
      "Naraingarh BO": "147203",
      "Samaspur BO": "147203",
      "Badali Ala Singh BO": "140408",
      "Khera BO": "140408",
      "Mahadian BO": "140406",
      "Makrampur BO": "140408",
      "Rajindergarh BO": "140406",
      "Reona Ucha BO": "140406",
      "Bazidpur BO": "140412",
      "Ghumandgarh BO": "140412",
      "Khalaspur BO": "140412",
      "Nandpur Kalaur BO": "140412",
      "Nogawan BO": "140412",
      "Barwali Khurd BO": "141411",
      "Fatehgarh Niwan BO": "141411",
      "Kheri Noudh Singh BO": "141411",
      "Lohar Majra Kalan BO": "141411",
      "Pharaur BO": "141801",
      "Shahpur BO": "147301",
      "Bhamarsibuland BO": "140405",
      "Sainipur BO": "140405",
      "Amrala BO": "140802",
      "Rattangarh BO": "141801",
      "Raipur Majri BO": "141411",
      "Shamaspur Singhan BO": "141801",
      "Maneli BO": "141801",
      "Bhagrana BO": "140602",
      "Buras BO": "140602",
      "Dadu Majra BO": "140602",
      "Pola BO": "140402",
      "Dulwan BO": "140802",
      "Lohar Majra Khurd BO": "140802",
      "Khant BO": "140802",
      "Badwala BO": "140412",
      "Hargana BO": "141411",
      "Kotla Badla BO": "141411",
      "Jatana Ucha BO": "141801",
      "Manela BO": "141801",
      "Salana BO": "147301",
      "Badochikalan BO": "140405",
      "Jallah BO": "140405",
      "Panjokha BO": "140802",
      "Adampur BO": "140406",
      "Dhundan BO": "140412",
      "Kotla Ajner BO": "141411",
      "Chari BO": "141801",
      "Kumbh BO": "147301",
      "Mullepur Kalan BO": "140405",
      "Sidhpur kalan BO": "140802",
      "Hawara Kalan BO": "140802",
      "Amloh SO": "147203",
      "Chinarthal Kalan SO": "147104",
      "Mandigobindgarh SO": "147301",
      "Sanghol SO": "140802",
      "Mandigobindgarh IT SO": "147301",
      "Sirhind SO": "140406",
      "Bhari SO": "141411",
      "Khamano Kalan SO": "141801",
      "Sirhind City SO": "140406",
      "Bassi SO": "140412",
      "Fatehgarh Sahib SO": "140407",
      "RR Sirhind SO": "140406",
      "Sangatpur Sodhian SO": "140405",
      "Chunni Kalan SO": "140408"
    },
    "MANSA": {
      "Jhanda Kalan BO": "151507",
      "Jhanda Khurd BO": "151507",
      "Karandi BO": "151507",
      "Kulrian BO": "151501",
      "Ranghrial BO": "151501",
      "Burj Hari BO": "151508",
      "Moosa BO": "151508",
      "Makha Chelan BO": "151504",
      "Matti BO": "151504",
      "Dhalewan BO": "151502",
      "Kulana BO": "151502",
      "Phaphre Bhaike BO": "151502",
      "Adamke BO": "151506",
      "Fatehpur BO": "151506",
      "Hingna BO": "151506",
      "Ralla BO": "151510",
      "Khaira Kalan BO": "151507",
      "Mirpur Kalan BO": "151507",
      "Behniwal BO": "151302",
      "Sangha BO": "151507",
      "Chehlanwali BO": "151302",
      "Dhingar BO": "151302",
      "Bahadurpur BO": "151501",
      "Kahangarh BO": "151501",
      "Ubha BO": "151508",
      "Atlakalan BO": "151504",
      "Dalel Singh Wala BO": "151504",
      "Hamirgarh Dhaipai BO": "151504",
      "Dalelwala BO": "151503",
      "Maghnia BO": "151503",
      "Reond Kalan BO": "151503",
      "Saidewala BO": "151503",
      "Ahmedpur BO": "151502",
      "Bachhuana BO": "151502",
      "Bappiana BO": "151502",
      "Biroke Kalan BO": "151502",
      "Kusla BO": "151506",
      "Aklia BO": "151510",
      "Ahlupur BO": "151507",
      "Mankhera BO": "151507",
      "Nahran BO": "151507",
      "Gobindpura BO": "151501",
      "Kishangarh Saide Singh Wala BO": "151501",
      "Khiala Kalan BO": "151508",
      "Hiron Kalan BO": "151504",
      "Khiwa Khurd BO": "151504",
      "Alampur Mandra BO": "151503",
      "Tahlian BO": "151503",
      "Alampur Bodla BO": "151502",
      "Bareh BO": "151502",
      "Borewal BO": "151502",
      "Dodra BO": "151502",
      "Hodla Kalan BO": "151502",
      "Fatta Maluka BO": "151506",
      "Jhanduke BO": "151506",
      "Lallian Wali BO": "151506",
      "Moffar BO": "151506",
      "Akkanwali BO": "151505",
      "Dharampura BO": "151501",
      "Khokhar Kalan BO": "151508",
      "Tamkot BO": "151508",
      "Khiwa Kalan BO": "151504",
      "Kotra Kalan BO": "151504",
      "Samaon BO": "151504",
      "Uddat Saidewala BO": "151503",
      "Datewas BO": "151502",
      "Gurney Kalan BO": "151502",
      "Kishangarh Pharwahi BO": "151502",
      "Chenewala BO": "151506",
      "Ghuddu Wala BO": "151506",
      "Jatana Kalan BO": "151506",
      "Malkon BO": "151506",
      "Dulo Wal BO": "151505",
      "Jaurkian BO": "151505",
      "Makha BO": "151505",
      "Bajjewala BO": "151505",
      "Gehley BO": "151505",
      "Kotli Kalan BO": "151509",
      "Khara BO": "151505",
      "Kot Dharmu BO": "151505",
      "Nangal Kalan BO": "151505",
      "Narinder Pura BO": "151505",
      "Rai Pur BO": "151505",
      "Saharna BO": "151505",
      "Bhamme Kalan BO": "151505",
      "Kot Lallu BO": "151505",
      "Lakhmir Wala BO": "151505",
      "Mian BO": "151505",
      "Udit Bhagat Ram BO": "151505",
      "Bareta SO": "151501",
      "Distt Couts Mansa SO": "151505",
      "Boha SO": "151503",
      "Budhlada SO": "151502",
      "Grain Market Mansa SO": "151505",
      "Mansa SO Mansa": "151505",
      "Bhaini Bagha SO": "151508",
      "Bhikhi SO": "151504",
      "Joga SO": "151510",
      "Jhunir SO": "151506",
      "Sardulgarh SO": "151507"
    },
    "FIROZEPUR": {
      "Karma BO": "152023",
      "Lakho Ke Behram BO": "152023",
      "Sanehar BO": "152028",
      "Gill BO": "142060",
      "Dastul Sahib BO": "152004",
      "Rukna Begu BO": "152004",
      "Bharana BO": "152005",
      "Pandori Khatrian BO": "142050",
      "Sodhiwala BO": "142050",
      "Tumber Bhan BO": "142050",
      "Dhandian BO": "142047",
      "Mahianwala Kalan BO": "142047",
      "Markhai BO": "142047",
      "Thatha Kishan Singh BO": "142047",
      "Balkhandi BO": "152028",
      "Jhanda Bagga Purana BO": "152028",
      "Jhatre BO": "152028",
      "Talwandi Jallekhan BO": "152028",
      "Sukhewala BO": "152028",
      "Bazidpur BO": "152004",
      "Patel Nagar BO": "152004",
      "Saidanwala BO": "152004",
      "Sayianwala BO": "152004",
      "Chuchak Wind BO": "142047",
      "Wakilanwali BO": "142047",
      "Tibbi Khurd BO": "152023",
      "Kot Karor Kalan BO": "142060",
      "Loham BO": "142060",
      "Faridewala BO": "152005",
      "Lohgarh Thakran BO": "152005",
      "Sandhe Hasham BO": "152005",
      "Dhanna Shahid BO": "142050",
      "Haraj BO": "142050",
      "Kassoana BO": "142050",
      "Lalle BO": "142050",
      "Pheroke BO": "142047",
      "Santuwala BO": "142047",
      "Shahwala BO": "142047",
      "Hazara Singh Wala BO": "152023",
      "Khunder Uttar BO": "152023",
      "Awan BO": "152028",
      "Mansoor Deva BO": "152028",
      "Kabbar Wacha BO": "142060",
      "Nurpur Sethan BO": "152004",
      "Toot BO": "152004",
      "Chugatte Wala BO": "152005",
      "Khosa Dal Singh BO": "152005",
      "Sodhi Nagar BO": "152005",
      "Sekhwan BO": "142050",
      "Sulhani BO": "142050",
      "Wara Waryam Singh BO": "142050",
      "Malloke BO": "142047",
      "Mehar Singh Wala BO": "142047",
      "Shazada Sant Singh BO": "142047",
      "Valtoha BO": "142047",
      "Guddar Dhandi BO": "152022",
      "Jandwala BO": "152022",
      "Jhariwala BO": "152022",
      "Behak Gujjaran BO": "142044",
      "Shianpari BO": "142044",
      "Rukne Wala BO": "152021",
      "Sudh Singh Wala BO": "152021",
      "Chhanga Khurd BO": "152023",
      "Khai Pheme Ki BO": "152003",
      "Mahalam BO": "152002",
      "Mehma BO": "152002",
      "Bare Ke BO": "152002",
      "Bhangali Kalan BO": "142052",
      "Mana Singh Wala BO": "142052",
      "Shakur BO": "142052",
      "Wara Bhai Ka BO": "142052",
      "Ahmad Dhandi BO": "152022",
      "Sharienwala BO": "152022",
      "Sohangarh Thakkran BO": "152022",
      "Kamal Wala BO": "152021",
      "Dhira Patra BO": "152003",
      "Fatttuwala BO": "152003",
      "Chak Haraj BO": "152002",
      "Dulchike BO": "152002",
      "Jhok Tehal Singh BO": "152002",
      "Ghall Khurd BO": "142052",
      "Itanwali BO": "142052",
      "Karmuwala BO": "142052",
      "Chhanga Rai Uttar BO": "152022",
      "Palla Megha BO": "152002",
      "Machhi Bugra BO": "142052",
      "Ratta Khera Pb Singh BO": "142052",
      "Shahzadi BO": "142052",
      "Jhoke Harihar BO": "152003",
      "Dod RS BO": "152002",
      "Kohar Singh Wala BO": "152002",
      "Maste Ke BO": "152002",
      "Khushhal Singh Wala": "152002",
      "Bhanger BO": "142052",
      "Dhindsa BO": "142052",
      "Piareana BO": "142052",
      "Thethar Kalan BO": "142052",
      "Chak Mahantan Wala BO": "152022",
      "Ranjitgarh BO": "152022",
      "Fatehgarh Sabrah BO": "142044",
      "Pir Mohamad BO": "142044",
      "Arif Ke BO": "152021",
      "Malluwalia Wala BO": "152021",
      "Pindi BO": "152022",
      "Makhu Canal Colony BO": "142044",
      "Sarhali BO": "142044",
      "Ferozepur HO": "152001",
      "Talwandi Bhai SO": "142050",
      "Zira SO": "142047",
      "Mudki SO": "142060",
      "SBS Engg Colleger Ferozpeur SO": "152004",
      "Sabzi Mandi Ferozepur City SO": "152002",
      "Sherkhan Wala SO": "152005",
      "Sadar Bazar SO Firozpur": "152001",
      "Industrial Area Ferozepur city": "152002",
      "Chowk Arya Samaj Ferozepur SO": "152002",
      "Ferozeshah SO": "142052",
      "Cantt Railway Station Ferozepu SO": "152001",
      "Makhu SO": "142044",
      "Guruharsahai SO": "152022",
      "Mallanwala SO": "152021",
      "Mamdot SO": "152023",
      "Canal Colony Ferozepur SO": "152003",
      "Ferozepur City SO": "152002"
    },
    "FAZILKA": {
      "Chak Kherewala BO": "152033",
      "Nukerian BO": "152033",
      "Giddranwali BO": "152132",
      "Jandwala Hanumanta BO": "152132",
      "Churiwala Dhanna BO": "152122",
      "Roharian Wali BO": "152122",
      "Dutaran Wala BO": "152118",
      "Khuban BO": "152118",
      "Sitto Gunno BO": "152118",
      "Mehrana BO": "152118",
      "Rampura BO": "152118",
      "Ratta Khera BO": "152033",
      "Panjawan Mandal BO": "152132",
      "Panniwala Mohala BO": "152132",
      "Shergarh BO": "152132",
      "Usman Khera BO": "152132",
      "Dharangwala BO": "152122",
      "Ghallu BO": "152122",
      "Jhummianwali BO": "152122",
      "Kohrianwali BO": "152122",
      "Sardarpura BO": "152118",
      "Bazidpur Bhooma BO": "152118",
      "Kular BO": "152118",
      "Rajpura BO": "152118",
      "Chak Badhoke BO": "152033",
      "Bhangar Khera BO": "152132",
      "Dalmir Khera BO": "152132",
      "Raipura BO": "152118",
      "Sherewala BO": "152118",
      "Chak Janisar BO": "152033",
      "Khuranj BO": "152033",
      "Dhigan Wali BO": "152132",
      "Gumjal BO": "152132",
      "Tootwala BO": "152132",
      "Bazidpur Kattianwali BO": "152122",
      "Danger Khera BO": "152122",
      "Muradwala Dal Singh BO": "152122",
      "Himatpura BO": "152118",
      "Khairpur BO": "152118",
      "Dodewala BO": "152118",
      "Bhagoo BO": "152116",
      "Rajanwali BO": "152116",
      "Waryam Khera BO": "152116",
      "Jandwala Bhimeshah BO": "152124",
      "Jhottianwali BO": "152124",
      "Mahuana Bodla BO": "152124",
      "Azamwala BO": "152121",
      "Kamal Wala BO": "152121",
      "Katehra BO": "152121",
      "Koil Khera BO": "152128",
      "Panjkosi BO": "152128",
      "Sappanwali BO": "152128",
      "Sayadwala BO": "152128",
      "Chanan Khera BO": "152117",
      "Gaddan Dob BO": "152117",
      "Kera Khera BO": "152117",
      "Chak Banwala BO": "152123",
      "Kirianwali BO": "152020",
      "Mandi Ladhuka BO": "152020",
      "Bahamni Wala BO": "152024",
      "Bsf Campus Chak Araian BO": "152024",
      "Chak Gulam Rasool Wala BO": "152024",
      "Chak Saidoke BO": "152024",
      "Shatirwala BO": "152121",
      "Kabul Shah Khuban BO": "152121",
      "Bakainwala BO": "152128",
      "Dharampura BO": "152128",
      "Jandwala Mira Sangla BO": "152128",
      "Killianwali BO": "152128",
      "Rukanpura BO": "152116",
      "Aslamwala BO": "152124",
      "Bahawal Bassi BO": "152117",
      "Bhungal BO": "152117",
      "Kundal BO": "152117",
      "Mallukpur BO": "152117",
      "Ramgarh BO": "152117",
      "Chimnewala BO": "152123",
      "Hasta Kalan BO": "152123",
      "Jandwala Kharta BO": "152123",
      "Jaurki Andhewali BO": "152123",
      "Mauzam BO": "152123",
      "Rana BO": "152123",
      "Sabuana BO": "152123",
      "Govt Seed Form BO": "152116",
      "Jhurar Khera BO": "152116",
      "Kandwala Amarkot BO": "152116",
      "Kikar Khera BO": "152116",
      "Dabwala Kalan BO": "152124",
      "Dhippanwali BO": "152124",
      "Ghattianwali Jattan BO": "152124",
      "Mullianwali BO": "152124",
      "Pakkan BO": "152124",
      "Tahliwal Bodla BO": "152124",
      "Dhab Kokerian BO": "152117",
      "Jodhpur BO": "152117",
      "Alamgarh BO": "152116",
      "Burj Mohar BO": "152116",
      "Patti Sadiq BO": "152116",
      "Ramsara BO": "152116",
      "Wahabwala BO": "152116",
      "Kandwala Hazarkhan BO": "152124",
      "Tahliwala Jattan BO": "152124",
      "Bahadur Khera BO": "152117",
      "Gobindgarh BO": "152117",
      "Behak BO": "152020",
      "Chak Sotrian BO": "152020",
      "Karni Khera BO": "152123",
      "Ladhuka BO": "152020",
      "Bagge Ke Uttar BO": "152024",
      "Ghubaya BO": "152020",
      "Ladhuwala Uttar BO": "152024",
      "Lamochar Kalan BO": "152020",
      "Panje Ke Uttar BO": "152024",
      "Khippanwali BO": "152121",
      "Shajrana BO": "152121",
      "Danewala BO": "152128",
      "Haripura BO": "152128",
      "Roop Nagar BO": "152128",
      "Amir Khas BO": "152024",
      "Jiwan Araian BO": "152024",
      "Pakka Kale Wala BO": "152024",
      "Dhandi Qadim BO": "152024",
      "Kheowali Dhab BO": "152121",
      "Mamu Khera BO": "152121",
      "Diwan Khera BO": "152128",
      "Patrewala BO": "152128",
      "Nihal Khera SO": "152122",
      "Sitto SO": "152118",
      "Railway Road Mandi  Ladhuka": "152020",
      "New Judicial Court Complex Fazilka": "152123",
      "Nai Abadi Abohar SO": "152116",
      "New Grain Market Abohar SO": "152116",
      "Abohar SO": "152116",
      "Fazilka SO": "152123",
      "Gandhi Nagar Fazilka SO": "152123",
      "Khuiyan Server SO": "152128",
      "Maujgarh SO": "152132",
      "Balluana SO": "152117",
      "Jalalabad T SO": "152024",
      "Jalalabad W SO": "152024",
      "Mandi Amin Ganj SO": "152033",
      "Arniwala Sheikh Subhan SO": "152124",
      "Khui Khera SO": "152121",
      "Abohar Mandi SO": "152116",
      "Krishna Nagari Abohar SO": "152116"
    },
    "GURDASPUR": {
      "Dadiala Natt BO": "143507",
      "Talwandi Lal Singh BO": "143507",
      "Akarpura BO": "143511",
      "Dargabad BO": "143511",
      "Hakimpur BO": "143511",
      "Sarwali BO": "143511",
      "Qila Lal Singh BO": "143511",
      "Fazlabad BO": "143511",
      "Dharamkot Randhawa BO": "143604",
      "Singhpura BO": "143604",
      "Talwandi Rama BO": "143604",
      "Raimal BO": "143605",
      "Ghoga BO": "143507",
      "Gujjarpura BO": "143507",
      "Kastiwal BO": "143507",
      "Marar BO": "143507",
      "Sarupwali BO": "143507",
      "Balpurian BO": "143507",
      "Hardo Jhande BO": "143507",
      "Gagowali BO": "143511",
      "Dharamkot Bagga BO": "143511",
      "Haruwal e BO": "143604",
      "Udhowali Khurd BO": "143604",
      "Dharowali BO": "143605",
      "Riali BO": "143507",
      "Athwal BO": "143511",
      "Bhangowani BO": "143511",
      "Dalam BO": "143511",
      "Wadala Banger BO": "143511",
      "Bhuller BO": "143511",
      "Khushalpur BO": "143604",
      "Pakiwan BO": "143604",
      "Shahpur Goraya BO": "143604",
      "Bharial BO": "143525",
      "Hayat Nagar BO": "143520",
      "Khojepur BO": "143530",
      "Dabhanwala Kalan BO": "143507",
      "Shankarpura BO": "143507",
      "Bhandal BO": "143511",
      "Mirzajan BO": "143511",
      "Rai Chak BO": "143511",
      "Jaura Singha BO": "143511",
      "Bhagthana Tulian BO": "143604",
      "Shahpur Jajan BO": "143604",
      "Shahzada BO": "143604",
      "Kotli Surat Malhi BO": "143605",
      "Shikar BO": "143605",
      "Jhabkra BO": "143525",
      "Bhopar Saidan BO": "143520",
      "Chore Sidhwan BO": "143520",
      "Saidowal Kalan BO": "143530",
      "Gaznipur e BO": "143520",
      "Jaura Chhattran BO": "143520",
      "Pakhariwal BO": "143520",
      "Babri BO": "143529",
      "Bhumbli BO": "143529",
      "Babehali BO": "143530",
      "Chhalle BO": "143530",
      "Gazikot BO": "143530",
      "Kotli Sainian BO": "143530",
      "Khaira BO": "143602",
      "Man BO": "143602",
      "Paracha BO": "143602",
      "Bolewal BO": "143514",
      "Batala Sugar Mills BO": "143506",
      "G S T C Batala BO": "143506",
      "Massania BO": "143506",
      "Udhanwal BO": "143506",
      "Chahal BO": "143506",
      "Bhole Ke BO": "143513",
      "Dalla Chak BO": "143513",
      "Ghanie Ke Banger BO": "143513",
      "Villa Teja BO": "143513",
      "Khokhar Faujjian BO": "143518",
      "Sarchur BO": "143602",
      "Ladha Mundha BO": "143514",
      "Villa Baijju BO": "143514",
      "Bodhe Di Khui BO": "143506",
      "Ranger Nangal BO": "143506",
      "Barila Kalan BO": "143512",
      "Bishankot BO": "143512",
      "Buchenangal BO": "143512",
      "Dalelpur BO": "143512",
      "Ghuman Kalan BO": "143518",
      "Dhapai BO": "143516",
      "Kandila BO": "143516",
      "Cheema Khudi BO": "143515",
      "Kishankot BO": "143515",
      "Machrai BO": "143515",
      "Mari Buchian BO": "143515",
      "Ghorewah BO": "143517",
      "Kotli Harchandan BO": "143517",
      "Mullanwal BO": "143517",
      "Nanowal Jinder BO": "143517",
      "Galhri BO": "143526",
      "Magar Mudian BO": "143526",
      "Hemrajpur BO": "143526",
      "Aulakh Kalan BO": "143527",
      "Chak Sharif BO": "143528",
      "Kala Bala e BO": "143528",
      "Passanwal BO": "143518",
      "Babri Jiwan Wal BO": "143520",
      "Gurdas Nangal BO": "143520",
      "Sidhwan BO": "143529",
      "Ghot BO": "143530",
      "Lakhanpal BO": "143530",
      "Satkoha BO": "143518",
      "Kot Todarmal BO": "143516",
      "Bharath BO": "143527",
      "Dodwan BO": "143532",
      "Kot Santokh Rai BO": "143519",
      "Zaffarwal BO": "143519",
      "Sahari BO": "143519",
      "Kalichpure BO": "143531",
      "Pandori Bainsan BO": "143531",
      "Paniar BO": "143531",
      "Dostpur BO": "143526",
      "Dugri BO": "143526",
      "Bianpure BO": "143533",
      "Jharoli BO": "143533",
      "Bahadurpur Rajoa BO": "143527",
      "Basrai BO": "143527",
      "Beri BO": "143527",
      "Pindarori BO": "143527",
      "Tugalwala BO": "143527",
      "Samrai BO": "143602",
      "Dakoha BO": "143514",
      "Padhe BO": "143514",
      "Dadiala BO": "143506",
      "Harpura Dhandoi BO": "143506",
      "Siray BO": "143513",
      "Fattupur BO": "143512",
      "Dehriwal BO": "143518",
      "Fazula Chak BO": "143518",
      "Dhandal BO": "143516",
      "Ballarwal BO": "143515",
      "Mari Panwan BO": "143515",
      "Bhaini Mian Khan BO": "143517",
      "Fateh Nangal BO": "143519",
      "Kalyanpur BO": "143519",
      "Bhatoya BO": "143531",
      "Talibpur Pandori BO": "143531",
      "Hardo Chhani BO": "143526",
      "Sale Chak BO": "143526",
      "Jagowal Bet BO": "143528",
      "Saidowal Khurd BO": "143528",
      "Hardorwal BO": "143602",
      "Nasarke BO": "143602",
      "Parowal BO": "143602",
      "Bhoman BO": "143514",
      "Chone BO": "143514",
      "Wadala Granthia BO": "143506",
      "Chaudhriwal BO": "143506",
      "Panjgarian BO": "143506",
      "Jaito Sarja BO": "143506",
      "Rajeke BO": "143513",
      "Teja Kalan BO": "143513",
      "Lakhan Kalan BO": "143512",
      "Dial Garh BO": "143518",
      "Seikhwan BO": "143518",
      "Khojala BO": "143516",
      "Leel Kalan BO": "143516",
      "Mari Tanda BO": "143515",
      "Alma BO": "143517",
      "Kaler Kalan BO": "143519",
      "Khunda BO": "143519",
      "Langah BO": "143519",
      "Awankha BO": "143531",
      "Sahowal BO": "143531",
      "Islampur BO": "143526",
      "Chaunta BO": "143533",
      "Bham BO": "143527",
      "Bhambri BO": "143527",
      "Nainakot BO": "143528",
      "Batala HO": "143505",
      "Gurdaspur HO": "143521",
      "Bhagowal SO": "143511",
      "Kala Afgana SO": "143513",
      "Kahnuwan SO": "143528",
      "Aliwal SO": "143507",
      "Batala City SO": "143505",
      "Ghoman SO": "143514",
      "Govt Poly Tech Batala SO": "143506",
      "Naushera Majja Singh SO": "143518",
      "Behrampur SO": "143532",
      "Gurdaspur Kutchery SO": "143521",
      "Harchowal SO": "143527",
      "Sohal SO": "143520",
      "Dera Baba Nanak SO": "143604",
      "Fatehgarh Churian SO": "143602",
      "Guru Nanak Nagar SO Gurdaspur": "143505",
      "Krishna Nagar Batala SO": "143505",
      "Dinanagar SO": "143531",
      "Marara SO": "143525",
      "Tibber SO": "143529",
      "Dhianpur SO": "143605",
      "Kalanaur SO Gurdaspur": "143512",
      "Nehru Gate Batala SO": "143505",
      "Qadian SO": "143516",
      "Srihargobindpur SO": "143515",
      "Judicial Complex Batala SO": "143505",
      "Bhattian SO": "143517",
      "Dhariwal SO": "143519",
      "Dorangla SO": "143526",
      "Tibri SO": "143530"
    },
    "RUPNAGAR": {
      "Agampur BO": "140118",
      "Hafizabad BO": "140111",
      "Jatana BO": "140111",
      "Kheri Salabatpur BO": "140111",
      "Jhallian Khurd BO": "140111",
      "Phool Khurd BO": "140111",
      "Daroli BO": "140133",
      "Dher BO": "140133",
      "Kalitran BO": "140133",
      "Katlaur BO": "140112",
      "Sandhwan BO": "140112",
      "Newkiri Afgana BO": "140112",
      "Swamipur BO": "140126",
      "Thaluh BO": "140123",
      "Lodhi Majra BO": "140113",
      "Massewal BO": "140115",
      "Jhinjari BO": "140116",
      "Barsalpur BO": "140102",
      "Chaklan BO": "140102",
      "Dumna BO": "140102",
      "Pathreri Jattan BO": "140108",
      "Purkhali BO": "140108",
      "Rangilpur BO": "140108",
      "Sainfalpur BO": "140108",
      "Nangal Talwara BO": "140124",
      "Katta Sabour B.O": "140128",
      "Khera Kalmout B.O": "140128",
      "Behrampur BO": "140125",
      "Manakpur BO": "140125",
      "Bhallian BO": "140111",
      "Bhoje Majra BO": "140111",
      "Bhallan B.O": "140127",
      "Bhallari B.O": "140127",
      "Bhanam B.O": "140127",
      "Gohlani BO": "140126",
      "Jhaj B.O": "140128",
      "Makari BO": "140117",
      "Rauli Jhinjri BO": "140117",
      "Jhandian BO": "140119",
      "Tibba Taparian BO": "140119",
      "Bazidpur BO": "140111",
      "Behrampur Bet BO": "140111",
      "Khamera BO": "140133",
      "Bharatgarh Canal Colony BO": "140114",
      "Bhaku Majra BO": "140112",
      "Bass Bhabour BO": "140126",
      "Mojowal BO": "140126",
      "Malikpur BO": "140113",
      "Paharpur Samloh BO": "140116",
      "Ballamgarh BO": "140108",
      "Kotla Nihang BO": "140108",
      "Bhamnara BO": "140101",
      "Rattangarh Ii BO": "140101",
      "Dhobeta BO": "140124",
      "Barwa BO": "140117",
      "Basali BO": "140117",
      "Jatauli BO": "140117",
      "Kalwan B.O": "140128",
      "Thana BO": "140117",
      "Ajauli BO": "140125",
      "Abiana BO": "140119",
      "Dhamana BO": "140119",
      "Baddi Jhallian BO": "140111",
      "Bhairon Majra BO": "140111",
      "Jandbari BO": "140133",
      "Gardley BO": "140114",
      "Bassi Gujran BO": "140112",
      "Sukhshal BO": "140127",
      "Mangewal BO": "140123",
      "Nangal Sirsa BO": "140113",
      "Kainaur BO": "140102",
      "Makrauna Kalan BO": "140102",
      "Samana Kalan BO": "140102",
      "Behrampur Zimidari BO": "140108",
      "Singh Bhagwantpur BO": "140108",
      "Dhangrali BO": "140101",
      "Saheri BO": "140101",
      "Tajpura BO": "140101",
      "Nangal Nikku BO": "140124",
      "Chanauli BO": "140117",
      "Kahanpur Khui B.O": "140128",
      "Bandelhari BO": "140125",
      "Bajrur BO": "140119",
      "Bhaowal BO": "140119",
      "Ropar HO": "140001",
      "Bhanupali SO": "140133",
      "Bharatgarh SO": "140114",
      "Kiratpur Sahib SO": "140115",
      "Kotla Power House SO": "140116",
      "Bela SO Rupnagar": "140111",
      "Chamkaur Sahib SO": "140112",
      "Ghanauli SO": "140113",
      "Ganugwal SO": "140123",
      "New Nangram SO": "140127",
      "Mian Pur SO": "140108",
      "Morinda SO": "140101",
      "Naya Nangal Sector 2 SO": "140126",
      "I I T ROPAR": "140001",
      "Nangal Dam SO": "140124",
      "Nurpur Bedi SO": "140117",
      "Takhatgarh SO": "140119",
      "Anand Pur Sahib SO": "140118",
      "Fertilizer Factory Nangal SO": "140126",
      "Nangal Township SO": "140124",
      "Nuhon Colony Ropar SO": "140113",
      "Thermal Plant Colony Ropar SO": "140001",
      "Lutheri SO": "140102",
      "Minisectt Ropar SO": "140001",
      "Pratap Nagar Nangal SO": "140125",
      "DUMEWAL SO": "140128"
    },
    "PATHANKOT": {
      "Ghiala BO": "145101",
      "Gurrah BO": "145101",
      "Kaunterpur BO": "145101",
      "Badhani BO": "145001",
      "Chakkar BO": "145001",
      "Dharkalan BO": "145001",
      "Uchathara BO": "145001",
      "Panjore BO": "145023",
      "Ranipur BO": "145023",
      "Jhakholari BO": "145025",
      "Kiri Khurd BO": "145025",
      "Narot Mehra BO": "145025",
      "Syonti BO": "145001",
      "Baknaur BO": "143534",
      "Kathlaur BO": "143534",
      "Saidipur BO": "143534",
      "Naushehra Nal Bandan BO": "145025",
      "Sarna BO": "145025",
      "Sunder Chak BO": "145025",
      "Habit Pindi e BO": "143525",
      "Nangal BO": "145101",
      "Datial BO": "145026",
      "Hara BO": "145001",
      "Jandwal BO": "145001",
      "Mamoon BO": "145001",
      "Trihari BO": "145001",
      "Shahpur Kandi BO": "145029",
      "Gho BO": "145023",
      "Rattangarh BO": "143534",
      "Naurangpur BO": "145025",
      "Fatehpur BO": "145026",
      "Haryal BO": "145001",
      "Karoli BO": "145001",
      "Kot BO": "145029",
      "Bhabber BO": "145023",
      "Lehroon BO": "145022",
      "Ferozepur Kalan BO": "145023",
      "Lahri Gujran BO": "143534",
      "Parmanand BO": "143534",
      "Sahaura Khurd BO": "143534",
      "Bhattwan BO": "145022",
      "Sarti BO": "145022",
      "Bharoli BO": "145025",
      "Janial BO": "145027",
      "Khojeke Chak BO": "145027",
      "Jangal BO": "143531",
      "Tharial BO": "145024",
      "Chashma BO": "145025",
      "Dholowal BO": "143531",
      "Bhanguri BO": "145022",
      "Bhoa BO": "145025",
      "Farida Nagar BO": "145025",
      "Dalhousie Road Pathankot SO": "145001",
      "Dunera SO": "145022",
      "Shahpur Kandi Township SO": "145029",
      "Dhangu Road Pathankot SO": "145001",
      "Khanpur Chowk Pathankot SO": "145001",
      "Malakpur SO": "145025",
      "Abrol Nagar Pathankot SO": "145001",
      "Bamial SO": "145027",
      "Beacon Pathankot SO": "145001",
      "Dhaki Road Pathankot SO": "145001",
      "Gharota SO": "143533",
      "Mission Road Pathankot SO": "145001",
      "Civil Court Pathankot SO": "145001",
      "Madhopur SO Gurdaspur": "145024",
      "Mirthal SO": "145101",
      "Narot Jailmal Singh SO": "145026",
      "Pathankot SO": "145001",
      "Sujanpur SO Gurdaspur": "145023",
      "Taragarh Gurdaspur SO": "143534"
    }
  },
  "ASSAM": {
    "HAILAKANDI": {
      "Gharmura Bazar B.O": "788162",
      "Gharmura Bus Stand B.O": "788162",
      "Algapur PT V B.O": "788150",
      "Chandipur B.O": "788150",
      "Matirgram B.O": "788150",
      "Narainpur North B.O": "788801",
      "Polarpar B.O": "788801",
      "Alexanderpur B.O": "788161",
      "Appin B.O": "788161",
      "Dholai Malai B.O": "788161",
      "Dholai South B.O": "788161",
      "Ratakandi B.O": "788152",
      "Uzankupa B.O": "788152",
      "Narainpur B.O": "788152",
      "Boalipar Bazar B.O": "788155",
      "Brojapur B.O": "788155",
      "Lakhirbond PT II B.O": "788155",
      "Paikan B.O": "788155",
      "Mohanpur B.O": "788150",
      "Burnibrease T E B.O": "788801",
      "Jankibazar B.O": "788801",
      "Dinanathpur PT I B.O": "788161",
      "Katlacherra Bazar B.O": "788161",
      "Telkatta B.O": "788161",
      "Chandpur West B.O": "788152",
      "Hailakandi Bazar B.O": "788152",
      "Hailakandi East B.O": "788152",
      "Kanchanpur PT II B.O": "788152",
      "Chandrapur PT II B.O": "788163",
      "Lalamukh B.O": "788163",
      "Umednagar B.O": "788163",
      "Karicherra Bazar B.O": "788165",
      "Lalpani B.O": "788165",
      "Barband B.O": "788164",
      "Kayah T E B.O": "788164",
      "Nimaichandpur PT II B.O": "788168",
      "Kuchila Bazar B.O": "788155",
      "Nitainagar B.O": "788155",
      "Samarikona B.O": "788155",
      "Ratanpur B.O": "788155",
      "Sultanicherra B.O": "788162",
      "Algapur PT II B.O": "788150",
      "Rongpur Boalipar B.O": "788161",
      "Bansbari PT II B.O": "788152",
      "Bhatirkupa B.O": "788152",
      "Rajyeswarpur Pt II B.O": "788163",
      "Rongpur South B.O": "788163",
      "Sahabad B.O": "788163",
      "Sarbanandapur B.O": "788163",
      "Dharirghat Grant B.O": "788165",
      "Dholai T E B.O": "788165",
      "Lakhinagar T E B.O": "788164",
      "Lala Deb Block B.O": "788164",
      "Nischintapur B.O": "788164",
      "Singala B.O": "788164",
      "Mirirgool B.O": "788168",
      "Nityanandapur B.O": "788168",
      "Baliura B.O": "788155",
      "Purba Sonapur B.O": "788155",
      "Rangauti PT II B.O": "788155",
      "Rongpur North B.O": "788155",
      "Vichingcha B.O": "788155",
      "BIDYANAGAR S.O": "788738",
      "Sudarshanpur B.O": "788160",
      "Ramnathpur B.O": "788162",
      "Saidband PT II B.O": "788150",
      "Bakrihawar PT III B.O": "788801",
      "Chiparsangam B.O": "788801",
      "Harishnagar B.O": "788161",
      "Rangabawk B.O": "788161",
      "Rupacherra Basti B.O": "788161",
      "Gangpar Dhumkar B.O": "788152",
      "Hailakandi College B.O": "788152",
      "Kacharitol B.O": "788163",
      "Madaripar B.O": "788163",
      "Tantoo Maniknagar B.O": "788163",
      "Vernerpur B.O": "788163",
      "Kukicherra B.O": "788165",
      "Amala B.O": "788164",
      "Aynakhal Bazar B.O": "788164",
      "Bowarghat B.O": "788164",
      "Katagaon B.O": "788168",
      "Bar Hailakandi B.O": "788155",
      "Matijuri B.O": "788155",
      "Rangauti B.O": "788155",
      "Kalinagar S.O": "788801",
      "Lala S.O": "788163",
      "Panchgram S.O": "788802",
      "Rajyeswarpur S.O": "788168",
      "Jamira Bazar S.O": "788162",
      "Kalibari Bazar S.O": "788150",
      "Katlacherra S.O": "788161",
      "Lakshmisahar S.O": "788152",
      "Manipur Bagan S.O": "788165",
      "Monacherra S.O": "788164",
      "Jaffirband S.O": "788160",
      "Ratanpur Road S.O": "788155",
      "Hailakandi H.O": "788151"
    },
    "SOUTH SALMARA MANCACHAR": {
      "Hatsingimari  S.O": "783135",
      "Dhanuagaon B.O": "783135",
      "Manullapara B.O": "783135",
      "Fulerchar B.O": "783135",
      "Hatsingimari B.O": "783135",
      "Kalapani B.O": "783135",
      "Kanaimara B.O": "783135",
      "Barkona B.O": "783131",
      "Sarkarergaon B.O": "783127",
      "Muhurirchar B.O": "783128",
      "Nilokhia B.O": "783128",
      "Piazbari B.O": "783128",
      "Purandiara B.O": "783135",
      "Jhowdanga B.O": "783131",
      "Kakripara B.O": "783131",
      "Patakata B.O": "783127",
      "Ravatari B.O": "783127",
      "Tumni B.O": "783127",
      "Kokradanga B.O": "783128",
      "Radhamadhabhat B.O": "783131",
      "Bauskata B.O": "783127",
      "Pocharchar B.O": "783127",
      "Hazirhat B.O": "783128",
      "Fekamari S.O": "783135",
      "Mankachar S.O": "783131",
      "Sukchar S.O (Dhubri)": "783128",
      "Salmara South S.O": "783127"
    },
    "KARIMGANJ": {
      "Baruala B.O": "788734",
      "Bidyanagar B.O": "788734",
      "Damcherra Bagan B.O": "788736",
      "Bhairabnagar B.O": "788152",
      "Fenairbond B.O": "788737",
      "Pechaala B.O": "788734",
      "West Harinagar B.O": "788734",
      "Banskhantilla B.O": "788736",
      "Chamtilla B.O": "788736",
      "Cheragi B.O": "788737",
      "South Sonapur B.O": "788737",
      "Chamela Bazar B.O": "788166",
      "Kalachup B.O": "788166",
      "Kalinagar T E B.O": "788166",
      "Muliala B.O": "788735",
      "Brojendrapur B.O": "788156",
      "Gamaria B.O": "788156",
      "Anglarbazar B.O": "788806",
      "Asalkandi B.O": "788723",
      "Govindaganj Bazar B.O": "788733",
      "Rakeshnagar B.O": "788701",
      "Puthini B.O": "788725",
      "Baithakhal Basti B.O": "788726",
      "Longai B.O": "788728",
      "Ghambhira Basti B.O": "788737",
      "Daluganj B.O": "788166",
      "Kalairbond B.O": "788806",
      "Hasanpur B.O": "788806",
      "Malua B.O": "788806",
      "Umarpur B.O": "788806",
      "Eraligool B.O": "788723",
      "Fakuagram B.O": "788723",
      "Kathaltoli Bazar B.O": "788725",
      "Dhalibeel PT II B.O": "788734",
      "Leelachela B.O": "788734",
      "Singlacherra Bazar B.O": "788736",
      "Vetarbond B.O": "788736",
      "Rakhalbasti B.O": "788152",
      "Kalamagura B.O": "788737",
      "Maniknagar B.O": "788166",
      "Netaji Nagar B.O": "788166",
      "Sripur B.O": "788166",
      "Adarkona B.O": "788701",
      "Lamajuar B.O": "788701",
      "Marjatkandi B.O": "788701",
      "Mirzapur B.O": "788701",
      "Basantinagar B.O": "788725",
      "Kalkalighat B.O": "788725",
      "Katabari B.O": "788726",
      "Lowairpoa B.O": "788726",
      "Solgoi B.O": "788726",
      "Balipipla Bazar B.O": "788728",
      "Kotamani Bazar B.O": "788728",
      "BAZARGHAT B.O": "788733",
      "Purba Harinagar B.O": "788734",
      "Sibbari Krishna Nagar B.O": "788734",
      "Chantilla B.O": "788736",
      "Dullabcherra Bazar B.O": "788736",
      "Bishnunagar East B.O": "788152",
      "Madanmohan B.O": "788152",
      "Kadamtala B.O": "788166",
      "Dalgram PT II B.O": "788735",
      "Tongibari B.O": "788735",
      "Dargarband Bazar B.O": "788156",
      "Muktaranpur B.O": "788156",
      "Srigouri B.O": "788806",
      "Madandighirpar B.O": "788723",
      "Basudevnagar B.O": "788723",
      "Nagendranagar B.O": "788733",
      "Rajpasa B.O": "788701",
      "Medley B.O": "788725",
      "Tilbhum B.O": "788725",
      "Manikbond B.O": "788728",
      "Mahakhal B.O": "788701",
      "Bagbari B.O": "788720",
      "Chaitanyanagar B.O": "788720",
      "Chatal B.O": "788720",
      "Gulcherra B.O": "788720",
      "Kanishail B.O": "788711",
      "Singaria Bazar B.O": "788719",
      "Pathu B.O": "788781",
      "Alamkhani B.O": "788722",
      "Brahmansashan B.O": "788722",
      "Dasgram B.O": "788722",
      "Ranibari B.O": "788722",
      "Patharkandi Anchalik B.O": "788724",
      "Tinokhal B.O": "788724",
      "Dharakuna B.O": "788712",
      "Kalima B.O": "788712",
      "Karnamadhu B.O": "788712",
      "Maizgram B.O": "788712",
      "Sutarkandi B.O": "788712",
      "Barkatpur B.O": "788713",
      "Chargola Bazar B.O": "788713",
      "Jobainpur B.O": "788713",
      "Panighat B.O": "788709",
      "Longai Road B.O": "788710",
      "Latu B.O": "788781",
      "Jadutilla B.O": "788720",
      "Shyamnagar B.O": "788720",
      "Telikhalerpar B.O": "788711",
      "Longaighat B.O": "788710",
      "Mullaganj Bazar B.O": "788719",
      "Bishnunagar B.O": "788781",
      "Promodenagar B.O": "788722",
      "Bhurunga B.O": "788724",
      "Jurbari B.O": "788724",
      "Pathar Kandi Bazar B.O": "788724",
      "Ambarkhani B.O": "788712",
      "Nairgram B.O": "788713",
      "Banamali B.O": "788710",
      "Lakhibazar B.O": "788709",
      "Janakalyan Bazar B.O": "788720",
      "Siberchak B.O": "788720",
      "Girishganj Bazar B.O": "788711",
      "Nathupur B.O": "788711",
      "Baropunji B.O": "788781",
      "Durganagar B.O": "788722",
      "Duttagram B.O": "788722",
      "Ramanikrishna B.O": "788722",
      "Bubrighat B.O": "788724",
      "Duhalia B.O": "788724",
      "Kanaibazar B.O": "788724",
      "Aylabari B.O": "788712",
      "Jalalnagar B.O": "788712",
      "Kurikala B.O": "788712",
      "Manikganj B.O": "788712",
      "Lalarchak B.O": "788713",
      "Jagannathi B.O": "788709",
      "Nayagram B.O": "788709",
      "Sadarashi B.O": "788709",
      "Dullabcherra S.O": "788736",
      "Ramkrishnanagar S.O": "788166",
      "Badarpur Bazar S.O": "788806",
      "Baraigram S.O": "788723",
      "Patharkandi S.O": "788724",
      "Tillabazar S.O": "788709",
      "Anipur S.O": "788734",
      "Badarpurghat S.O": "788803",
      "Olivacherra S.O": "788737",
      "Badarpur S.O (Karimganj": "788806",
      "Bazaricherra Bazar S.O": "788727",
      "Chandkhira S.O": "788725",
      "Nilam Bazar S.O": "788722",
      "Subashnagar S.O": "788710",
      "Ratabari S.O": "788735",
      "Anilgarh S.O": "788156",
      "Bazarghat S.O (Karimganj": "788733",
      "Hatikhira S.O": "788726",
      "Isabeel S.O": "788728",
      "Kaliganj Bazar S.O": "788720",
      "Kayasthagram S.O": "788719",
      "Settlement Road S.O": "788712",
      "Silchar Road S.O": "788713",
      "Bhanga Bazaar S.O": "788701",
      "Char Bazar S.O": "788710",
      "Karimganj Bazar S.O": "788711",
      "Karimganj Court S.O": "788710",
      "Karimganj Station Road S.O": "788710",
      "Mahisashan S.O": "788781",
      "Karimganj H.O": "788710"
    },
    "BAKSA": {
      "Salbari S.O": "781320",
      "Kachukata B.O": "781367",
      "Kalakuchi B.O": "781367",
      "Kalbari B.O": "781367",
      "Nizdafeli B.O": "781367",
      "Pachimjargaon B.O": "781367",
      "Paddapar B.O": "781367",
      "Athiabari B.O": "781377",
      "Garamdew B.O": "781377",
      "Charaimari B.O": "781377",
      "Mazdia B.O": "781367",
      "Tinpukhuri B.O": "781367",
      "Zarkona B.O": "781367",
      "Lafakuchi B.O": "781377",
      "Kachubari B.O": "781367",
      "Natunhowly B.O": "781367",
      "Ulubari B.O": "781367",
      "Rampur B.O": "781377",
      "Betna B.O": "781366",
      "Gurmow B.O": "781366",
      "Silkijhar B.O": "781366",
      "Baghdoba B.O": "781366",
      "Bardangrikuchi B.O": "781366",
      "Karparbhitha B.O": "781366",
      "Mahajanpara B.O": "781366",
      "Barpathar B.O": "781364",
      "Bhogpur B.O": "781366",
      "Chenigaon B.O": "781364",
      "Suagpur B.O": "781364",
      "Tengajhar B.O": "781364",
      "Betagaon B.O": "781364",
      "Bangalipara B.O": "781364",
      "Deosunga B.O": "781364",
      "Dahkaunia B.O": "781346",
      "Bennabari B.O": "781333",
      "Dalbari B.O": "781333",
      "Kalipur B.O": "781360",
      "Kauli B.O": "781360",
      "Dongpar B.O": "781368",
      "Kalcheni B.O": "781368",
      "Latibari B.O": "781368",
      "Sidhinathpur B.O": "781368",
      "Tebitola B.O": "781368",
      "Medaghat B.O": "781355",
      "Angardhowa B.O": "781344",
      "Gerua B.O": "781344",
      "Nayabasti B.O": "781344",
      "Nizbangalipara B.O": "781333",
      "Pub Baramchari B.O": "781333",
      "Saukuchi B.O": "781333",
      "Thanguri B.O": "781333",
      "Bholebatabari B.O": "781364",
      "Nawkata B.O": "781364",
      "Amingaon Chowk B.O": "781343",
      "Jalagaon B.O": "781373",
      "Darangapar B.O": "781360",
      "Haziragaon B.O": "781360",
      "Banbari B.O": "781372",
      "Barimukh B.O": "781372",
      "Dihira B.O": "781372",
      "Kataligaon B.O": "781372",
      "Karemura B.O": "781355",
      "Bagulamari B.O": "781344",
      "Muktapur B.O": "781344",
      "Kathalbari B.O": "781346",
      "Madhapur B.O": "781346",
      "Murmela B.O": "781346",
      "Dangarmakha B.O": "781333",
      "Chaibari B.O": "781343",
      "Japadang B.O": "781343",
      "Pakhamara B.O": "781343",
      "Barchakadal B.O": "781373",
      "Angarkata B.O": "781360",
      "Chechapani B.O": "781360",
      "Menaka B.O": "781360",
      "Patkijuli B.O": "781360",
      "Adalbari B.O": "781372",
      "Motipur B.O": "781372",
      "Nikashi B.O": "781372",
      "Uttarkuchi B.O": "781372",
      "Bagrikhuti B.O": "781368",
      "Dhekipota B.O": "781368",
      "Gandhibari B.O": "781367",
      "Amayapur B.O": "781367",
      "Barkhopa B.O": "781367",
      "Geruapara B.O": "781355",
      "Khagrabari B.O": "781344",
      "Barsimlaguri B.O": "781346",
      "Kaljar B.O": "781346",
      "Kharua B.O": "781346",
      "Merkuchi B.O": "781346",
      "Debachara B.O": "781333",
      "Dighaldonga B.O": "781343",
      "Ahopa B.O": "781373",
      "Darangamela B.O": "781360",
      "Paharpur B.O": "781360",
      "Pakribari B.O": "781360",
      "Narayanpur B.O": "781372",
      "Pamuapathar B.O": "781372",
      "Subankhata B.O": "781372",
      "Dangargaon B.O": "781368",
      "Dumuria B.O": "781367",
      "Ghogpar B.O": "781367",
      "Anchali B.O": "781327",
      "Bakua B.O": "781327",
      "Koklabari B.O": "781330",
      "Kamardisa B.O": "781330",
      "Lowkata B.O": "781330",
      "Bamunkata B.O": "781327",
      "Gandhipur B.O": "781327",
      "Barghogra B.O": "781330",
      "Bihapara B.O": "781365",
      "Golagaon B.O": "781327",
      "Betbari B.O": "781327",
      "Darkuchi S.O": "781376",
      "Maharipara S.O": "781364",
      "Nagrijuli S.O": "781368",
      "Tambulpur S.O": "781367",
      "Baganpara S.O": "781344",
      "Thamna S.O (Nalbari)": "781377",
      "Jalahghat S.O": "781327",
      "Barama S.O": "781346",
      "Barimakha S.O": "781333",
      "Mussalpur S.O": "781372",
      "Goreswar S.O": "781366",
      "Simla S.O": "781330",
      "Dhanbil S.O": "781343",
      "Doomni S.O": "781373",
      "Kumarikata S.O": "781360"
    },
    "BARPETA": {
      "Bhaluki B.O": "781371",
      "Salbari B.O": "781318",
      "Amguri B.O": "781317",
      "Helana B.O": "781375",
      "Puranbhowanipur B.O": "781318",
      "Sonafuli B.O": "781318",
      "Balabhitha B.O": "781313",
      "Guagacha B.O": "781313",
      "Balapet B.O": "781317",
      "Barnagarcollege B.O": "781317",
      "C Bazar B.O": "781317",
      "Saudarvitha B.O": "781318",
      "Mazgaon B.O": "781313",
      "Bhalukadoba B.O": "781317",
      "Duramari B.O": "781317",
      "Suliakata B.O": "781317",
      "Uzirahar B.O": "783101",
      "Rupahi B.O": "781318",
      "Chamuagati B.O": "781318",
      "Mespara B.O": "781313",
      "B Noontola B.O": "781317",
      "Chachaka B.O": "781317",
      "Kamargaon B.O": "781317",
      "Chukurngbari B.O": "781317",
      "Golibandha B.O": "781375",
      "Rampur Dekapara B.O": "781375",
      "Bhotanta Mohitara B.O": "781328",
      "Charnabazar B.O": "781328",
      "Kalapani Bazar B.O": "781315",
      "Katajhar B.O": "781315",
      "Kohitama B.O": "781315",
      "Mainamata B.O": "781315",
      "Mairajar B.O": "781315",
      "Palhaji B.O": "781309",
      "Kayakuchi Bazar B.O": "781352",
      "Khablarvitha B.O": "781352",
      "Kurobaha B.O": "781352",
      "Nakuchi Pathar B.O": "781352",
      "Sarutapa B.O": "781352",
      "Bhogdia B.O": "781305",
      "Jatradia B.O": "781305",
      "Ghugubari B.O": "781319",
      "Langla B.O": "781319",
      "Niz Rampur B.O": "781319",
      "Baghbar B.O": "781308",
      "Balajan B.O": "781308",
      "Habidongra Bazar B.O": "781308",
      "Kadomtola B.O": "781308",
      "Kathalmurighat B.O": "781328",
      "Barengabari B.O": "781315",
      "Khairabari B.O": "781315",
      "Bheraldi B.O": "781309",
      "Keotkuchi B.O": "781309",
      "Chaparbari Bazar B.O": "781352",
      "Kamalpur B.O": "781352",
      "Naligaon B.O": "781352",
      "Khangra B.O": "781305",
      "Pacim Mazdia B.O": "781305",
      "Sukmanah B.O": "781316",
      "Charcharia B.O": "781319",
      "Gunialguri B.O": "781319",
      "Chakabausi B.O": "781308",
      "Dharampur B.O": "781308",
      "Sitoli B.O": "781308",
      "Chandmama B.O": "781321",
      "Sonabari B.O": "781321",
      "Bhairaguri B.O": "781311",
      "Erabamundi B.O": "781311",
      "Rangia Bhaithabhangahat B.O": "781311",
      "Akaya B.O": "781329",
      "Tuplaipanbari B.O": "781329",
      "Amdah B.O": "781325",
      "Bhakuamari B.O": "781325",
      "Bhotantasaderi B.O": "781325",
      "Baradi B.O": "781314",
      "Jania B.O": "781314",
      "Patbaushi B.O": "781314",
      "Karaguri B.O": "781307",
      "Nasatraphulbari B.O": "781307",
      "Barbhitha Dolarpathar B.O": "781318",
      "Barghol B.O": "781302",
      "Bilashi Para Bazar B.O": "781315",
      "Kalahbhanga B.O": "781315",
      "Labdangguri Gaon B.O": "781315",
      "Nimua B.O": "781315",
      "Nirala B.O": "781308",
      "Bonghugi B.O": "781321",
      "Burikhamar B.O": "781311",
      "Garatari B.O": "781311",
      "Raoli B.O": "781311",
      "Maripur Anandapur B.O": "781329",
      "Pubrihabari B.O": "781329",
      "Sarumanikpur B.O": "781329",
      "Bamunkuchi B.O": "781326",
      "Barbatabari B.O": "781326",
      "Gobindapur B.O": "781326",
      "Gomafulbari B.O": "781302",
      "Nizbahari B.O": "781302",
      "Gobardhana B.O": "781315",
      "Khardhara B.O": "781309",
      "Barbala B.O": "781316",
      "Ghilajari B.O": "781316",
      "Jasihatipara B.O": "781316",
      "Kujarpith B.O": "781316",
      "Balikuri B.O": "781319",
      "Sawpur B.O": "781319",
      "Manikpur B.O": "781308",
      "Ramaparapam B.O": "781308",
      "Deoldi B.O": "781308",
      "DP Deoldi B.O": "781321",
      "Ishabpur B.O": "781321",
      "Patharchali Chatala B.O": "781321",
      "Bagodi B.O": "781311",
      "Daisingri B.O": "781329",
      "Hathinapur B.O": "781325",
      "Odalguri B.O": "781325",
      "Bhatkuchi B.O": "781314",
      "Gajia B.O": "781314",
      "Ganakkuchi B.O": "781314",
      "Garaimari B.O": "781314",
      "Amrikhowa B.O": "781307",
      "Barkapla B.O": "781307",
      "Byaskuchi B.O": "781307",
      "Kamalabari B.O": "781307",
      "Bhalaguri B.O": "781318",
      "Chenglimari B.O": "781318",
      "Hudukhata B.O": "781318",
      "Kardoiguri B.O": "781318",
      "Bhogerpar B.O": "781309",
      "Dhakua B.O": "781309",
      "Radhakuchi B.O": "781309",
      "Galia B.O": "781352",
      "Paka Bet Bari Pathar B.O": "781352",
      "Makrikuchi B.O": "781305",
      "Chenimari B.O": "781305",
      "Ambari B.O": "781316",
      "Dabaliapara B.O": "781316",
      "Khatalpara B.O": "781316",
      "Moutupuri B.O": "781316",
      "Balagaon B.O": "781319",
      "Bankubhanga B.O": "781319",
      "Bhoirarpam B.O": "781308",
      "Pahumara B.O": "781308",
      "Satrakanara Bazar B.O": "781308",
      "Kapahtolichikni B.O": "781321",
      "Tarakandi B.O": "781321",
      "Gahia B.O": "781311",
      "Bhogpur B.O": "781329",
      "Dubi B.O": "781325",
      "Muguria B.O": "781325",
      "Raypur B.O": "781325",
      "Barpalli B.O": "781314",
      "Jahurpam B.O": "781314",
      "Jarabari B.O": "781314",
      "Kadang B.O": "781314",
      "Sonkuchi B.O": "781314",
      "Namsala B.O": "781307",
      "Parakuchi B.O": "781307",
      "Anandabazar B.O": "781318",
      "Barmazra B.O": "781318",
      "Bamakhata B.O": "781325",
      "Barbang B.O": "781325",
      "Bhethua B.O": "781325",
      "Sundaridia B.O": "781314",
      "Mandia S.O": "781308",
      "Nityananda S.O": "781329",
      "Patacharkuchi S.O": "781326",
      "Sarthebari S.O": "781307",
      "Sarupeta S.O": "781318",
      "Thakurbazar S.O": "781301",
      "Barpeta Road S.O": "781315",
      "Santinagar S.O (Barpeta)": "781314",
      "Sorbhog S.O": "781317",
      "Baharihat S.O": "781302",
      "Bhella S.O": "781309",
      "Howly S.O": "781316",
      "Mayanbari S.O": "781321",
      "Pathsala S.O": "781325",
      "Bangaon S.O (Nalbari)": "781375",
      "Baghmarabazar S.O": "781328",
      "Bajali College S.O": "781325",
      "Bhowanipur S.O": "781352",
      "Chenga S.O": "781305",
      "Kalgachia S.O": "781319",
      "Nagaon Bazar S.O": "781311",
      "Simlaguri S.O": "781313",
      "Barpeta H.O": "781301"
    },
    "NALBARI": {
      "Digheli B.O": "781371",
      "Nakhara B.O": "781371",
      "Sialmari B.O": "781371",
      "Khatabari BO": "781335",
      "Baramchari B.O": "781355",
      "Batsar B.O": "781303",
      "Bihampur B.O": "781303",
      "Mularkuchi B.O": "781303",
      "Bakuajari B.O": "781340",
      "Khukhundi B.O": "781340",
      "Narua B.O": "781138",
      "Pachim Kajia Gaon B.O": "781138",
      "Barnibari B.O": "781304",
      "Bonmaza B.O": "781304",
      "Dirua B.O": "781304",
      "Bhadra B.O": "781334",
      "Allia B.O": "781369",
      "Bagurihati B.O": "781310",
      "Balowa B.O": "781310",
      "Deharkalakuchi B.O": "781310",
      "Arikuchi B.O": "781339",
      "Bala B.O": "781339",
      "Barkhanajan B.O": "781337",
      "Chengnoi B.O": "781337",
      "Bhangnamari B.O": "781126",
      "Loharkatha B.O": "781126",
      "Lowpara B.O": "781126",
      "Nizsantipur B.O": "781349",
      "Bamunbari B.O": "781312",
      "Chinadi B.O": "781312",
      "Lachima B.O": "781312",
      "Niz Namati B.O": "781355",
      "Sathimuka B.O": "781355",
      "Panigaon B.O": "781303",
      "Suradi B.O": "781340",
      "Larkuchi B.O": "781138",
      "Amani B.O": "781306",
      "Gamerimuri B.O": "781306",
      "Gopalthan B.O": "781334",
      "Janigog B.O": "781334",
      "Nankarbhaira B.O": "781369",
      "Arangmow B.O": "781347",
      "Athgharia B.O": "781347",
      "Bhojkuchi B.O": "781374",
      "Jalkhana B.O": "781374",
      "Bagalsroad Chowk B.O": "781348",
      "Barkuriha B.O": "781348",
      "Budrukuchi B.O": "781348",
      "Narayanpur B.O": "781126",
      "Uttarbarsiral B.O": "781349",
      "Nathkuchi B.O": "781355",
      "Hidilatari B.O": "781138",
      "Kachuapathar B.O": "781138",
      "Kekankuchi B.O": "781138",
      "Gandhia B.O": "781304",
      "Pachimchamata B.O": "781306",
      "Balilecha B.O": "781334",
      "Barazara B.O": "781334",
      "Mugkuchi B.O": "781334",
      "Terechia B.O": "781334",
      "Barajol B.O": "781369",
      "Guakuchi B.O": "781369",
      "Niz Pakowa B.O": "781353",
      "Barpit B.O": "781378",
      "Khakharisal B.O": "781310",
      "Gobradal B.O": "781370",
      "Baridatara B.O": "781351",
      "Burinagar B.O": "781341",
      "Balisatra B.O": "781350",
      "Chatama B.O": "781350",
      "Dakhingaon B.O": "781350",
      "Lakhopur B.O": "781338",
      "Niztapa B.O": "781338",
      "Pubkalakuchi B.O": "781348",
      "Sondha B.O": "781337",
      "Adabari B.O": "781126",
      "Dagapara B.O": "781126",
      "Meruattari B.O": "781126",
      "Naherbari B.O": "781349",
      "Daulasal B.O": "781312",
      "Chatla B.O": "781312",
      "Dhuhi B.O": "781350",
      "Lahkarpara B.O": "781350",
      "Piplibari B.O": "781338",
      "Peradhara B.O": "781312",
      "Raumaripathar B.O": "781312",
      "Bori B.O": "781338",
      "Helacha B.O": "781338",
      "Banagram Chowk B.O": "781303",
      "Barnaddi B.O": "781303",
      "Kaplabari B.O": "781138",
      "Kakaya B.O": "781304",
      "Rupia Bathan B.O": "781306",
      "Arara B.O": "781334",
      "Bardigheli B.O": "781334",
      "Chandkuchi B.O": "781334",
      "Niz Bahjani B.O": "781334",
      "Chilling B.O": "781369",
      "Khatikuchi B.O": "781369",
      "Sandheli B.O": "781353",
      "Bali B.O": "781378",
      "Kharsitha B.O": "781370",
      "Barbari B.O": "781351",
      "Ulabari B.O": "781339",
      "Balikaria B.O": "781341",
      "Kendukuchi B.O": "781341",
      "Hatinamati B.O": "781337",
      "Balikuchi B.O": "781126",
      "Chanda B.O": "781126",
      "Jaysagar B.O": "781126",
      "Kandhbari B.O": "781126",
      "Lowtola B.O": "781126",
      "Balitara B.O": "781349",
      "Mahina B.O": "781349",
      "Nichalamari B.O": "781349",
      "Barghopa B.O": "781312",
      "Kalarchar B.O": "781312",
      "Mugdi B.O": "781312",
      "Barenghati B.O": "781350",
      "Kamrupbarkhola B.O": "781350",
      "Sauramari B.O": "781350",
      "Ghograpar S.O": "781369",
      "Jagra S.O": "781310",
      "Khatabari S.O": "781335",
      "Milanpur S.O": "781337",
      "Mukalmua S.O": "781126",
      "Sanekuchi S.O": "781350",
      "Solmara S.O": "781338",
      "Bartola S.O": "781138",
      "Belsor S.O": "781304",
      "Karia S.O": "781339",
      "Makhibaha S.O": "781374",
      "Banekuchi S.O": "781340",
      "Bidyapur S.O": "781335",
      "Chamata S.O": "781306",
      "Chowkbazar S.O (Nalbari)": "781334",
      "Gopalbazar S.O": "781353",
      "Haribhanga S.O": "781378",
      "Kalag S.O": "781351",
      "Marowa S.O": "781348",
      "Nizdhamdhama S.O": "781349",
      "Rampur S.O (Nalbari)": "781312",
      "Tihu S.O": "781371",
      "Assam Syntex S.O": "781355",
      "Banagram S.O": "781303",
      "Kaithalkuchi S.O": "781370",
      "Kamarkuchi S.O": "781347",
      "Kazipara S.O": "781341",
      "Nalbari H.O": "781335"
    },
    "CACHAR": {
      "Nayabeel B.O": "788117",
      "Nunapani T E B.O": "788117",
      "Chibitabichia B.O": "788150",
      "Salchapra B.O": "788801",
      "Chandranathpur B.O": "788817",
      "Dinanathpur B.O": "788817",
      "Tikarburunga B.O": "788817",
      "Rosekandi B.O": "788117",
      "Sarbantilla B.O": "788117",
      "New Bag O Bahar B.O": "788113",
      "Fulbari B.O": "788802",
      "Bilburunga B.O": "788817",
      "Damcherra B.O": "788817",
      "Sonapur B.O": "788817",
      "Sahapur B.O": "788117",
      "Borakhai T E B.O": "788113",
      "Barthal B.O": "788113",
      "Borodukan B.O": "788113",
      "Chotojalenga B.O": "788113",
      "Behara PT IV B.O": "788817",
      "Bhangarpar B.O": "788817",
      "Rajyeshpur West B.O": "788816",
      "Gumrah Bazar B.O": "788815",
      "Baroitoli B.O": "788815",
      "Purnagar B.O": "788816",
      "Barsangam B.O": "788117",
      "Taranathpur B.O": "788117",
      "Bag O Bahar B.O": "788113",
      "Loharband B.O": "788113",
      "Pratapur B.O": "788113",
      "Sialtek B.O": "788802",
      "Bhubaneswarnagar B.O": "788817",
      "Bidyaratanpur B.O": "788120",
      "Kakmara B.O": "788101",
      "Dhanipur B.O": "788120",
      "Jamalpur B.O": "788120",
      "Singerbond B.O": "788126",
      "Subhang B.O": "788111",
      "Bhubandhar T E B.O": "788114",
      "Mahadebpur PT I B.O": "788114",
      "Dilkhush T E B.O": "788106",
      "Karaikandi B.O": "788101",
      "Pallorbond B.O": "788101",
      "Paloi B.O": "788123",
      "Channighat B.O": "788120",
      "Hawaithang B.O": "788120",
      "Swastipally B.O": "788126",
      "Naraincherra B.O": "788110",
      "Debipur B.O": "788114",
      "Saptagram B.O": "788114",
      "Suktola B.O": "788114",
      "Hmarkhawlin B.O": "788106",
      "Binnakandi B.O": "788126",
      "Chengjui Grant B.O": "788126",
      "Chhotomanda B.O": "788126",
      "Nutan Ramnagar B.O": "788126",
      "Laboc T E B.O": "788102",
      "Lallong T E B.O": "788102",
      "Thailoo T E B.O": "788102",
      "Gurudayalpur B.O": "788114",
      "Jibangram B.O": "788114",
      "Madripar B.O": "788101",
      "Manipur Pti B.O": "788101",
      "Panibhora B.O": "788123",
      "Punimukh B.O": "788123",
      "Santipur B.O": "788123",
      "Lailapur B.O": "788120",
      "Shyamacharanpur B.O": "788120",
      "Balacherra T E B.O": "788110",
      "Barjatrapur B.O": "788110",
      "Chandpur B.O": "788110",
      "Purandarpur B.O": "788110",
      "Clever House B.O": "788112",
      "Sildhubi B.O": "788112",
      "Barthal T E B.O": "788102",
      "Dulalgram B.O": "788114",
      "Gojalghat B.O": "788114",
      "Diyungbra B.O": "782448",
      "Bhairabpur B.O": "788815",
      "Karkori B.O": "788815",
      "Khelma PT VII B.O": "788815",
      "Sadirkhal B.O": "788815",
      "Sayedpur Amtala B.O": "788815",
      "Lathimara B.O": "788805",
      "Gangapur B.O": "788804",
      "Buribail B.O": "788025",
      "Dudpur B.O": "788025",
      "Ganirgram B.O": "788025",
      "Bagpur B.O": "788101",
      "Chandrapur B.O": "788101",
      "Daluagram B.O": "788101",
      "Dungripar B.O": "788101",
      "Hiyairbond B.O": "788127",
      "Diska Grant B.O": "788107",
      "Baromuni B.O": "788121",
      "Nagdirgram B.O": "788121",
      "Langlacherra B.O": "788108",
      "Rajartilla B.O": "788805",
      "Krishnapur B.O": "788025",
      "Mahadevpur B.O": "788025",
      "Harinetilla B.O": "788011",
      "Irongmara Bazar B.O": "788011",
      "Algapur B.O": "788101",
      "Harinagar Bazar B.O": "788107",
      "Joyput PT III B.O": "788107",
      "Kamranga B.O": "788107",
      "Kanakpur East B.O": "788107",
      "Digarkhal Bazar B.O": "788815",
      "Harinagar Pt IV B.O": "788805",
      "Govindapur West B.O": "788804",
      "Rakhal Khalerpar B.O": "788025",
      "Govindapur East B.O": "788101",
      "Sarboday Nagar B.O": "788004",
      "Mahalthal B.O": "788107",
      "Saradapally B.O": "788107",
      "Martycherra B.O": "788108",
      "Kanakpur B.O": "788006",
      "Larsingpar B.O": "788002",
      "Boali Basti B.O": "788099",
      "Sundari B.O": "788099",
      "Batertal B.O": "788015",
      "Jogiabasti B.O": "788115",
      "Kajidahar B.O": "788115",
      "Uttar Sonpur B.O": "788098",
      "Chekarcham B.O": "788116",
      "Darmikhal B.O": "788116",
      "Berenga B.O": "788005",
      "Bethukandi B.O": "788005",
      "Bhakatpur Pt VIII B.O": "788005",
      "Dhanehari B.O": "788013",
      "Dhakin Mohonpur B.O": "788119",
      "Baglaghat B.O": "788026",
      "Digar Srikona B.O": "788026",
      "Chirukandi B.O": "788003",
      "Dudpatil B.O": "788003",
      "Chandighat T E B.O": "788030",
      "Dayapur B.O": "788030",
      "Dayapur T E B.O": "788030",
      "Durganagar T E B.O": "788030",
      "Chhoto Dudpatil PT I B.O": "788002",
      "Haticherra Grant PT VII B.O": "788002",
      "Bhuban Valley B.O": "788099",
      "Choto Dudpatil Grant B.O": "788002",
      "Sibbari Road B.O": "788002",
      "Ganganagar B.O": "788099",
      "Berabak PT II B.O": "788115",
      "Labacpar PT III B.O": "788098",
      "Kalakhal B.O": "788116",
      "Rukni B.O": "788116",
      "Kanakpur Pt II": "788005",
      "Nutan Dayapur B.O": "788009",
      "Saidpur B.O": "788013",
      "Jhanjarbali B.O": "788119",
      "Kachudaram B.O": "788119",
      "Selurpar B.O": "788119",
      "Tulargram PT II B.O": "788119",
      "Machughat B.O": "788003",
      "Subedar Basti B.O": "788003",
      "Amaranagar T E B.O": "788030",
      "Gossaipur B.O": "788030",
      "Chaligram B.O": "788815",
      "Chincuri T E B.O": "788007",
      "R K Mission Road B.O": "788007",
      "Singari B.O": "788007",
      "Kalachandpur B.O": "788098",
      "Lallong Pt II B.O": "788098",
      "Maniupr PT II B.O": "788098",
      "Rukni PT I B.O": "788116",
      "Rukni T E B.O": "788116",
      "Sachinpur B.O": "788116",
      "Arkatipur B.O": "788009",
      "Badripar B.O": "788009",
      "Cossipur B.O": "788009",
      "Machpara B.O": "788009",
      "Dumurghat B.O": "788031",
      "Bharakhai B.O": "788010",
      "Ghungoor Kuarpar B.O": "788010",
      "Kaptanpur B.O": "788119",
      "Kaptanpur PT 18 B.O": "788119",
      "Mangalpur B.O": "788119",
      "Gobindanagar B.O": "788119",
      "Topkhana B.O": "788003",
      "Kanchanpur B.O": "788007",
      "Haticherra T E B.O": "788030",
      "Larsing T E B.O": "788030",
      "Lathigram B.O": "788030",
      "Madhura B.O": "788030",
      "Nagar T E B.O": "788030",
      "Hilara Colony B.O": "788815",
      "Kalaincherra B.O": "788815",
      "Jagadishpur B.O": "788805",
      "Ganirgram PT II B.O": "788025",
      "Nizjoynagar B.O": "788025",
      "Hazarigram Bazar B.O": "788101",
      "Uttar Lalpani B.O": "788104",
      "Baladhan T E B.O": "788107",
      "Kumacherra B.O": "788107",
      "Marchakhal B.O": "788107",
      "Tolengram B.O": "788108",
      "Uttar Krishnapur B.O": "788006",
      "Itkhola B.O": "788002",
      "Leburbond B.O": "788002",
      "Didarkush Basti B.O": "788099",
      "Maniarkhal B.O": "788099",
      "Saint Katharine B.O": "788099",
      "Atharotilla B.O": "788115",
      "Boaljur B.O": "788115",
      "Nutan Bazar B.O": "788115",
      "Ujan Tarapur B.O": "788098",
      "Sibpur B.O": "788098",
      "Hatikhal Bazar B.O": "788116",
      "Rammanikpur B.O": "788116",
      "Sundari PT II B.O": "788116",
      "Jaiforpur B.O": "788005",
      "Kathal TE B.O": "788005",
      "Rongpur PT II B.O": "788009",
      "Thaligram B.O": "788031",
      "Neairgram B.O": "788013",
      "Saidpur PT II B.O": "788013",
      "Satkarakandi B.O": "788013",
      "Amjurghat B.O": "788119",
      "Jhoragul B.O": "788119",
      "Kachudaram PT I B.O": "788119",
      "Thanjanlaikai B.O": "788119",
      "Rajnagar B.O": "788026",
      "Ramnagar Tarapur B.O": "788003",
      "Tarapur Khelma B.O": "788003",
      "Jaffirbond Pt I B.O": "788030",
      "Gossaipur PT I B.O": "788030",
      "Pangram B.O": "788030",
      "Katigorah S.O": "788805",
      "Arunachal S.O": "788025",
      "Binnakandi Ghat S.O": "788126",
      "Borkhola S.O": "788110",
      "Fulertal S.O": "788106",
      "G C College S.O": "788004",
      "Jirighat S.O": "788104",
      "Malugram S.O": "788002",
      "Meherpur S.O": "788015",
      "Narsingpur S.O": "788115",
      "Pailapool S.O": "788098",
      "Salganga S.O": "788031",
      "Sonabarighat S.O": "788013",
      "Barjalenga S.O": "788117",
      "Banskandi S.O": "788101",
      "Dholai Bazar S.O": "788114",
      "Hospital Road S.O (Cachar": "788005",
      "Jarailtala Bazar S.O": "788127",
      "Kabuganj Bazar S.O": "788121",
      "Matinagar S.O": "788099",
      "Rangirkhari S.O": "788005",
      "Silchar Court S.O": "788001",
      "Silcuri S.O": "788118",
      "Sonaimukh S.O": "788119",
      "Dwarband S.O": "788113",
      "Behara Bazar S.O": "788817",
      "Jalalpur S.O (Cachar": "788816",
      "Kalain S.O": "788815",
      "Assam University S.O": "788011",
      "Bekirpar S.O": "788123",
      "Bhaga Bazar S.O": "788120",
      "Dalu S.O": "788111",
      "Derby S.O": "788112",
      "Dewanji Bazar S.O": "788001",
      "Joypur Rajabazar S.O": "788107",
      "Lakhipur S.O (Cachar": "788103",
      "Link Road S.O (Cachar": "788006",
      "Rongpur S.O": "788009",
      "Silchar Medical College S.O": "788014",
      "Srikona S.O": "788026",
      "Udarbond S.O": "788030",
      "Katirail S.O": "788804",
      "C R Avenue S.O": "788005",
      "Dewan S.O": "788102",
      "Kumbhir S.O": "788108",
      "Kumbhirgram Airport S.O": "788109",
      "Madhurbond S.O": "788001",
      "Palonghat S.O": "788116",
      "Silchar REC S.O": "788010",
      "Tarapur Part VII S.O": "788003",
      "Tarapur S.O (Cachar": "788003",
      "Vivekananda Road S.O": "788007",
      "Silchar H.O": "788001"
    },
    "Biswanath": {
      "Daflagarh B.O": "784171",
      "Tewaripal B.O": "784175",
      "Balijan Barua B.O": "784171",
      "Borjharani B.O": "784184",
      "Ghogra Basti B.O": "784168",
      "Ghahigaon Chariali B.O": "784170",
      "Karibil Bangali B.O": "784170",
      "Dubia B.O": "784178",
      "Kalmouguri B.O": "784178",
      "Balichang B.O": "784174",
      "DhuliKuhiarbari B.O": "784174",
      "Salaikati B.O": "784174",
      "Borpam Tiniali B.O": "784175",
      "Chengamari B.O": "784175",
      "Niz Sootea B.O": "784175",
      "No.2 Ghahigaon B.O": "784175",
      "Pratapgarh B.O": "784175",
      "Chamardoloni B.O": "784175",
      "Solal Sonari B.O": "784175",
      "Brahmajan B.O": "784172",
      "Dipara Pukhuri B.O": "784172",
      "Gameri B.O": "784172",
      "Helemguri B.O": "784172",
      "Borjuli Nepaligaon B.O": "784179",
      "Solemari No.1 B.O": "784177",
      "Arragaon No.1 B.O": "784167",
      "Bhimdanga B.O": "784167",
      "Kakila Chariali B.O": "784168",
      "Milanpur B.O": "784168",
      "Mail Bazar B.O": "784170",
      "Mukoli Gaon B.O": "784170",
      "Bordupsonalibari B.O": "784178",
      "Santipurdeorigaon B.O": "784178",
      "Nagsankar B.O": "784189",
      "Garpal B.O": "784175",
      "No.3 Nalbari B.O": "784175",
      "Gobinda Elengisatra B.O": "784168",
      "Magoni B.O": "784168",
      "Kauri Pathar B.O": "784170",
      "Alupara B.O": "784178",
      "Pulisomoni No.1 B.O": "784178",
      "Tinikhuti B.O": "784173",
      "Khanaguri B.O": "784175",
      "Diphalu Satra B.O": "784169",
      "Kharaiguri B.O": "784169",
      "Bakori Doloni B.O": "784172",
      "Balijan B.O": "784172",
      "Batiamari B.O": "784179",
      "Cherelia B.O": "784167",
      "Rampur Darrang B.O": "784167",
      "Gelapukhuri B.O": "784176",
      "Monabari B.O": "784176",
      "Poken No.1 B.O": "784168",
      "Rajabari B.O": "784168",
      "Simaluguri B.O": "784168",
      "Sonapur B.O": "784168",
      "Amlakhi Dalani B.O": "784170",
      "Mazukuchi B.O": "784178",
      "Mikirborachuk B.O": "784178",
      "Bakrapatta B.O": "784175",
      "Bokabil B.O": "784175",
      "Lohitmukh B.O": "784169",
      "Rawanmukh B.O": "784169",
      "Subansirimukh B.O": "784169",
      "Buroi Ghat B.O": "784179",
      "Janata B.O": "784179",
      "Geruabari B.O": "784176",
      "Kunwari B.O": "784176",
      "Lahorijan B.O": "784176",
      "Lehugaon B.O": "784176",
      "Sakomato B.O": "784176",
      "Kamdewal B.O": "784169",
      "Khatargaon B.O": "784169",
      "Bihmari B.O": "784179",
      "Gangmouthan B.O": "784167",
      "Burigong B.O": "784176",
      "Panibharal B.O": "784176",
      "Howajan  S.O": "784169",
      "Mijikajan S.O": "784173",
      "Tetenbari S.O": "784171",
      "Sootea S.O": "784175",
      "Barangabari S.O": "784172",
      "Bedeti S.O": "784179",
      "Behali S.O": "784166",
      "Chariali MDG": "784176",
      "Gingia S.O": "784184",
      "Halem S.O": "784170",
      "Kalabari S.O": "784178",
      "Karsontala S.O": "784189",
      "Pabhoi S.O": "784174",
      "Biswanathghat S.O": "784177",
      "Borgong S.O": "784167",
      "Gohpur S.O": "784168"
    },
    "SONITPUR": {
      "Bargaon B.O": "784149",
      "Teliagaon B.O": "784149",
      "Borbil Kachari B.O": "784149",
      "Ghatua B.O": "784149",
      "Jahamari B.O": "784149",
      "Kalakuchi B.O": "784149",
      "Silikhabari B.O": "784149",
      "Bhergaon Kochgaon B.O": "784149",
      "Garuduba B.O": "784149",
      "Ulubari B.O": "784149",
      "Rangapukhuri B.O": "784501",
      "Solmara B.O": "784501",
      "Chitalmari B.O": "784110",
      "Ghogra B.O": "784110",
      "Natun Sirajuli B.O": "784112",
      "Bhojkhowa Chapori B.O": "784027",
      "Dolabari B.O": "784027",
      "Balichapori B.O": "784027",
      "Rangachakua B.O": "784182",
      "Towbhanga B.O": "784182",
      "Hoograjuli B.O": "784507",
      "Orientoli B.O": "784112",
      "Nankey Patgaon B.O": "784101",
      "Dipota B.O": "784150",
      "Khelmati B.O": "784153",
      "Bahbari B.O": "784502",
      "Batashipur B.O": "784111",
      "Gamani B.O": "784103",
      "Dibru Darrang B.O": "784111",
      "Keherukhanda B.O": "784110",
      "Mansiri B.O": "784105",
      "Gameripal B.O": "784180",
      "Panpur B.O": "784180",
      "Bansbera B.O": "784506",
      "Dighalijuli B.O": "784506",
      "Bordikorai B.O": "784182",
      "Itakhola B.O": "784182",
      "Singitoli B.O": "784025",
      "Dopdopi B.O": "784505",
      "Kailajuli B.O": "784505",
      "Fatasimalugaon B.O": "784117",
      "Mazrowmari B.O": "784117",
      "Narengkati B.O": "784507",
      "Farshipam B.O": "784110",
      "Mitham Bangali B.O": "784110",
      "Palasbasti Pathar B.O": "784112",
      "Natun Baithabhonga B.O": "784105",
      "Nandikeswar B.O": "784180",
      "Solaguri B.O": "784180",
      "Balipukhuri Tiniali B.O": "784154",
      "Sonaipam B.O": "784102",
      "Dhankhana B.O": "784506",
      "Balijuri B.O": "784182",
      "Hatinga B.O": "784182",
      "Tengabasti B.O": "784025",
      "Uriamguri B.O": "784025",
      "Thakurbari B.O": "784505",
      "Kacharison B.O": "784117",
      "Rakhsyashmari B.O": "784507",
      "Bogipukhuri B.O": "784112",
      "Godamghat B.O": "784101",
      "Da Parbatia B.O": "784150",
      "Bapubheti B.O": "784153",
      "Phulaguri B.O": "784504",
      "Uttar Amloga B.O": "784103",
      "Bhalukpong B.O": "784103",
      "Gormara B.O": "784111",
      "Mejengjuli B.O": "784111",
      "Pirakata No.2 B.O": "784110",
      "Rangagora Darrang B.O": "784110",
      "Singri B.O": "784110",
      "Upper Panbari B.O": "784110",
      "Bokajan B.O": "784105",
      "Nikamul Satra B.O": "784154",
      "Garubandha B.O": "784506",
      "Jiagabharu B.O": "784506",
      "Nepalibasti B.O": "784506",
      "Bakola B.O": "784182",
      "Urahiloga B.O": "784505",
      "Haleswar B.O": "784104",
      "Balipukhuri Joradia B.O": "784117",
      "Biskhuti B.O": "784117",
      "Borsola B.O": "784117",
      "Bhangamandir B.O": "784112",
      "Ameribari B.O": "784101",
      "Pithakhowa B.O": "784153",
      "Aujuli Rangagora B.O": "784103",
      "Khelmati Bazar B.O": "784101",
      "Silonigaon B.O": "784101",
      "Da Besseria B.O": "784150",
      "Bandarmari B.O": "784153",
      "Gabharu B.O": "784153",
      "Manijharni B.O": "784502",
      "Dhendoi B.O": "784504",
      "Chengelimara B.O": "784103",
      "Tezpur Medical College S.O": "784010",
      "Bindukuri S.O": "784502",
      "Darrang Panbari S.O": "784111",
      "Dhekiajuli S.O": "784110",
      "Chariduar S.O": "784103",
      "Hazarapar S.O": "784001",
      "Jamugurihat S.O": "784180",
      "Kaliabhomora S.O": "784027",
      "Ketekibari S.O": "784154",
      "Mahabhairab S.O": "784001",
      "Rangapara S.O": "784505",
      "Missamari S.O": "784506",
      "Napaam S.O": "784028",
      "Sirajuli S.O": "784117",
      "Tezpur Bazar S.O": "784001",
      "Bihaguri S.O": "784153",
      "Borjuli S.O": "784504",
      "Ghoramari S.O": "784105",
      "Kacharigaon S.O": "784001",
      "Khalihamari S.O": "784026",
      "Naharbari S.O": "784182",
      "Panchmile S.O": "784025",
      "Sonitpur S.O": "784001",
      "Thelamara S.O": "784149",
      "Alisinga S.O": "784112",
      "Balipara S.O": "784101",
      "Besseria S.O": "784150",
      "Dekargaon S.O": "784501",
      "Lokra S.O": "784102",
      "Shalonibari S.O": "784104",
      "Tezpur H.O": "784001"
    },
    "DIBRUGARH": {
      "Bhurburi B.O": "786003",
      "Sessa B.O": "786003",
      "Balijan North Te B.O": "786184",
      "Chetia Gaon B.O": "786184",
      "Matiakhana B.O": "786184",
      "Chaulkhowa B.O": "786004",
      "Jagoloni Grant B.O": "786004",
      "Jamirah B.O": "786004",
      "Alimur B.O": "786101",
      "Lilapur B.O": "786602",
      "Tingrai Chariali B.O": "786602",
      "Kamargaon B.O": "786614",
      "Ushapur B.O": "786614",
      "Naliapool B.O": "786001",
      "Baligaon B.O": "785676",
      "Bhogamurgaon B.O": "785676",
      "Khowang Chariali B.O": "785676",
      "Sessughat B.O": "785676",
      "Silputa B.O": "785676",
      "Buri Khowang B.O": "785675",
      "Dikari Morang Gaon B.O": "785675",
      "Ghuguloni Ahumgaon B.O": "785675",
      "Majbam Chariali B.O": "785675",
      "Tarajan B.O": "785675",
      "Tiloinagar B.O": "785675",
      "Hatkhula B.O": "786010",
      "Melengial Gaon B.O": "786010",
      "Naga Ghuli Kanaigaon B.O": "786012",
      "Balimora B.O": "786610",
      "Dihing Kinar B.O": "786610",
      "Konwarigaon B.O": "786610",
      "Rangalipathar B.O": "786610",
      "Ashabam B.O": "786621",
      "Dhuapathar B.O": "786611",
      "Lachit Nagar B.O": "786611",
      "Bhajoni B.O": "786103",
      "Na Deoghoria B.O": "786103",
      "Pan Dhua Tiniali B.O": "786103",
      "Kasulugaon B.O": "786612",
      "Ratanpur B.O": "786003",
      "Mancotta B.O": "786003",
      "Nirmaligaon B.O": "786003",
      "Purnananda Road B.O": "786003",
      "Barpathar B.O": "786004",
      "Behating Tiniali B.O": "786004",
      "Dighalia B.O": "786101",
      "Dihing Hola B.O": "786101",
      "Garpara B.O": "786101",
      "Hazelbank B.O": "786101",
      "Mahmora B.O": "786101",
      "Moderkhat B.O": "786101",
      "Nadua B.O": "786101",
      "Jaloni Dibruduar B.O": "786602",
      "Kachari Pathar B.O": "786602",
      "Kathalguri B.O": "785675",
      "Erameshlow Gaon B.O": "785676",
      "Goroimarigaon B.O": "785676",
      "Kolowlowa B.O": "785676",
      "Kotoha B.O": "785676",
      "Krisipam Nigam B.O": "785675",
      "Nahazhar B.O": "785675",
      "Rangchali B.O": "785675",
      "Sechowapukhuri B.O": "785675",
      "Chiringhula B.O": "786010",
      "Dibrugarh Polytechnic B.O": "786010",
      "Konwar Handique Gaon B.O": "786008",
      "Kumar Gaon B.O": "786008",
      "Raja Bheta B.O": "786008",
      "Tingkhong Dighalia B.O": "786008",
      "Harabari B.O": "786012",
      "Borbamgaon B.O": "786610",
      "Desam B.O": "786610",
      "Sasoni B.O": "786610",
      "Tiniali Tea Estate B.O": "786610",
      "Tipling Bhadoi Gaon B.O": "786610",
      "Ghinai B.O": "786621",
      "Mahmora Ali Kinar B.O": "786621",
      "Nigam B.O": "786621",
      "Silgrant B.O": "786621",
      "Bhadoi Pachali B.O": "786191",
      "Kamini Tea Estate B.O": "786191",
      "Nagajan B.O": "786191",
      "Barbam B.O": "786611",
      "Chenibill Chungipathar B.O": "786103",
      "Dangopara Chariali B.O": "786611",
      "Mahkhowa B.O": "786611",
      "Pithaguti B.O": "786611",
      "Borabhayapuri B.O": "786103",
      "Hatibondha B.O": "786103",
      "Lengrai B.O": "786103",
      "Harak Pathar B.O": "786003",
      "Jokai B.O": "786003",
      "Jokai Bongaon B.O": "786003",
      "Khamti Ghat B.O": "786003",
      "Bismile B.O": "786184",
      "Hatiali Siding B.O": "786184",
      "Pakharijania B.O": "786184",
      "Pulunga B.O": "786184",
      "Bogibil B.O": "786004",
      "Oakland B.O": "786101",
      "Phukanarkhat B.O": "786101",
      "Khaliamari B.O": "786001",
      "Adarsha Deurigaon B.O": "785676",
      "Balai Nagaon B.O": "785676",
      "Nagargaon B.O": "785676",
      "Nakhat Sonowal Gaon B.O": "785676",
      "Dhemechi B.O": "785675",
      "Dihingia Gaon B.O": "785675",
      "Thengal B.O": "785675",
      "Konwaripathar B.O": "786010",
      "Romai Te B.O": "786010",
      "Sarbodaya B.O": "786010",
      "Timonagaon B.O": "786010",
      "Dhaman B.O": "786610",
      "Dibru Amguri B.O": "786610",
      "Koliapani B.O": "786610",
      "Borkhermia B.O": "786621",
      "Niz Bhekulajan B.O": "786103",
      "Bogadat B.O": "786612",
      "Garguri B.O": "786612",
      "Nilmoni Te B.O": "786612",
      "Sisumari Barpathar B.O": "786612",
      "Chowkidingee B.O": "786003",
      "Khania Gaon B.O": "786003",
      "Dinjoy B.O": "786184",
      "Rang Changi B.O": "786184",
      "Dhamalgaon B.O": "786004",
      "Bachapathar B.O": "786101",
      "Kendriya  Vidyalaya B.O": "786602",
      "Raja Ali B.O": "786602",
      "Jeypore Mobile B.O": "786614",
      "Tipam B.O": "786614",
      "Barpathar Gaon B.O": "785676",
      "Chaharikata B.O": "785676",
      "Haladhibari B.O": "785676",
      "Padumoni Gaon No 1 B.O": "785676",
      "Dikhari Kinar Gaon B.O": "785675",
      "Gozpuria B.O": "785675",
      "Lukumai B.O": "785675",
      "Pathalibam B.O": "785675",
      "Tinthengia B.O": "785675",
      "Bokul B.O": "786010",
      "Puthahula B.O": "786010",
      "Bamunibill B.O": "786610",
      "Fakialgaon B.O": "786610",
      "Gojpuria B.O": "786610",
      "Mathawani B.O": "786610",
      "Salmari B.O": "786610",
      "Bokuloni Chariali B.O": "786191",
      "Zutlibari B.O": "786191",
      "Dirai Te B.O": "786611",
      "Kenduguri Te B.O": "786611",
      "Dillibari B.O": "786612",
      "Ouguri B.O": "786612",
      "Hiloidhari B.O": "786002",
      "Aghunibari B.O": "786613",
      "Baji Pohumara B.O": "786613",
      "Borpathar B.O": "786613",
      "Bhardhara B.O": "786183",
      "Bogdung B.O": "786183",
      "Medela B.O": "786007",
      "Domur Dolong B.O": "786613",
      "Garpthar B.O": "786613",
      "Ouphulia Chariali B.O": "786613",
      "Gohaingaon B.O": "786007",
      "Kalakhowa Chariali B.O": "786007",
      "Lalmati Gaon B.O": "786007",
      "Banipur B.O": "786003",
      "Garbandhi Bamunpukhuri B.O": "786613",
      "Kekuri Sonowal B.O": "786613",
      "Lengeri Bazar B.O": "786613",
      "Nachani B.O": "786613",
      "Naharpara Barbil B.O": "786613",
      "Nemupathar B.O": "786613",
      "Balaibari B.O": "786007",
      "Bam Kolakhowa B.O": "786007",
      "Deurigaon B.O": "786007",
      "Dighaliagaon B.O": "786007",
      "Garudharia B.O": "786007",
      "Bindhakata B.O": "786189",
      "Diksam Ouphulia B.O": "786613",
      "Sologuri B.O": "786613",
      "Itakhuli B.O": "786007",
      "Lezai B.O": "786007",
      "Bairagimath B.O": "786003",
      "Parbatpur S.O": "786623",
      "Rajgarh (Dibrugarh) S.O": "786611",
      "Santipara S.O": "786001",
      "Tengakhat S.O": "786103",
      "Naoholia S.O": "786191",
      "Panchali S.O": "786001",
      "Tingkhong S.O": "786612",
      "Bamunbari S.O": "786613",
      "Central Revenue Building S.O": "786003",
      "Jalan Nagar S.O": "786005",
      "Kadamoni S.O": "786001",
      "Khowang S.O": "785675",
      "Mohanaghat S.O": "786008",
      "Anandapara S.O": "786692",
      "Assam Medical College S.O": "786002",
      "Dikom S.O": "786101",
      "Duliajan S.O": "786602",
      "Khowang Ghat S.O": "785676",
      "Lepetkata S.O": "786006",
      "Dibrugarh H.O": "786001",
      "Chabua Air Field S.O": "786102",
      "Dibrugarh University S.O": "786004",
      "Graham Bazar S.O": "786001",
      "Barbaruah S.O": "786007",
      "Chabua S.O": "786184",
      "Jeypore S.O": "786614",
      "Namrup S.O": "786621",
      "Lahoal S.O": "786010",
      "Mohanbari Air Field S.O": "786012",
      "Naharkatia S.O": "786610",
      "Namrup Thermal Power Station S.O": "786622"
    },
    "LAKHIMPUR": {
      "Bholabari B.O": "787033",
      "Letekupukhuri B.O": "787033",
      "Pokadal B.O": "784161",
      "Rajabari B.O": "784161",
      "Bahpara B.O": "787055",
      "Gobindapur B.O": "787055",
      "Joysagar B.O": "787055",
      "Kekuri Pamuagaon B.O": "787055",
      "Deotala B.O": "787033",
      "Durpang B.O": "787033",
      "Gosaibari B.O": "787033",
      "Kerekjuli B.O": "787033",
      "Bahgora Deurigaon B.O": "784161",
      "Hamarathan B.O": "784161",
      "Japjup B.O": "784161",
      "Laholial B.O": "784161",
      "Barkhamukh B.O": "787055",
      "Begumgaon B.O": "787055",
      "Bokulguri B.O": "787055",
      "Singra B.O": "787023",
      "Ahomoni B.O": "787052",
      "Kharkati B.O": "787052",
      "Salmora Tiniali B.O": "787052",
      "Subansiri Koibarta Adarsha Gao B.O": "787056",
      "Madhupur B.O": "787033",
      "Badati B.O": "784161",
      "Dongibill B.O": "784161",
      "Kachikota Mirideurigaon B.O": "784161",
      "Morichapathar B.O": "784161",
      "Jalbhari B.O": "787055",
      "Sagarpur B.O": "787023",
      "Kankan Chapori B.O": "787055",
      "Kekuri B.O": "787055",
      "Kalakhowa Adarsha Gaon B.O": "787023",
      "Amtola Jaintpur B.O": "787052",
      "Khoga B.O": "787052",
      "Kuhiarbari B.O": "787052",
      "Naragaon B.O": "787052",
      "Barbali B.O": "784163",
      "Dighalia Hiloidhari B.O": "787055",
      "Fukhanarhat B.O": "787052",
      "Garchiga B.O": "787052",
      "Katri Chapori B.O": "787056",
      "Ukhamati B.O": "787056",
      "Sonardheki B.O": "787052",
      "Pithguri B.O": "784163",
      "Sundia B.O": "787055",
      "Bonpuroi B.O": "784165",
      "Dharmagarh Sevashram B.O": "784165",
      "Kachua B.O": "784165",
      "Mohemari B.O": "787055",
      "Neogaghuli B.O": "787055",
      "Arimora Tiniali B.O": "784165",
      "Puli Naharani B.O": "784165",
      "Khajuapatir B.O": "787055",
      "Kherkatamukh B.O": "787055",
      "Manikachuk B.O": "787055",
      "Medhisutigaon B.O": "787055",
      "Ouguri Dangdhara B.O": "787055",
      "Bhatowkuchi B.O": "784165",
      "Moderguri B.O": "787055",
      "Mornoi Bebejia B.O": "787055",
      "Patrichuk B.O": "787055",
      "Kamalpur Chariali B.O": "784165",
      "Kuksabari B.O": "784165",
      "Duliapthar B.O": "784164",
      "Kinapathar B.O": "784164",
      "Meramukh B.O": "784164",
      "Batamari Tiniali B.O": "787053",
      "Purana Parghat B.O": "787053",
      "Adi Alengi Satra B.O": "787054",
      "Ruptali Adarshagaon B.O": "784165",
      "Simaluguri B.O": "784165",
      "Bordeurigaon B.O": "784164",
      "Jorabari B.O": "784164",
      "Kamalpur B.O": "784164",
      "Madhavpur B.O": "784164",
      "Raidongia B.O": "784164",
      "Daulatpur B.O": "787054",
      "Dhunaguri B.O": "787054",
      "Kutubpur B.O": "787054",
      "Dejoo Te B.O": "787031",
      "Dharmapur B.O": "784160",
      "Gabharu Tunijan B.O": "784160",
      "Kakoi Rajgarh B.O": "787051",
      "Moitri Ashram B.O": "787051",
      "Rongajan Borbil B.O": "787051",
      "Nemutengani B.O": "787058",
      "Badhakhara B.O": "787032",
      "Borkhelia B.O": "787032",
      "Dirgha Majgaon B.O": "787032",
      "Rangati Charali B.O": "784165",
      "Padmapur B.O": "784164",
      "Bilmukh B.O": "787053",
      "Deuliagaon B.O": "787053",
      "Kaligaon B.O": "787053",
      "Mornoikhora B.O": "787054",
      "Sonapur B.O": "784160",
      "Angerkhowa B.O": "787031",
      "Bogolijan B.O": "787031",
      "Bormuriachuk B.O": "787031",
      "Rampur Deurigaon B.O": "787031",
      "Gereki B.O": "787032",
      "Uttar Kulabali B.O": "787032",
      "Bongalchuk B.O": "787023",
      "Bor Alengi Satra B.O": "787054",
      "Sandowkhowa B.O": "787054",
      "Budhbazar B.O": "787031",
      "Hatilung B.O": "787031",
      "Pohumara B.O": "787031",
      "Silonibari B.O": "787031",
      "Haribor Naharoni B.O": "784160",
      "Joriguri B.O": "784160",
      "Chaboti B.O": "787051",
      "Gandhia Tiniali B.O": "787058",
      "2 No Bokanala B.O": "787032",
      "Bhimpara Balijan B.O": "787032",
      "Charaimoria B.O": "787032",
      "Tariani Berbhanga B.O": "787032",
      "Borshala B.O": "787023",
      "Doolahat B.O": "787023",
      "Panbari B.O": "784164",
      "Dhenukhana B.O": "787053",
      "Ga Dangar Chuk B.O": "787053",
      "Ghatapara B.O": "787053",
      "Likhakchapori B.O": "787054",
      "Azad B.O": "787031",
      "Bahadurchuk B.O": "787031",
      "Borgaya Khagori B.O": "787031",
      "Japisajia B.O": "787031",
      "Khonajan B.O": "787031",
      "Kowadonga B.O": "787031",
      "Merbil B.O": "784160",
      "Parbatipur B.O": "784160",
      "Goroimari B.O": "787032",
      "Hindugaon B.O": "787032",
      "Kadam B.O": "787032",
      "Mahaijan B.O": "787032",
      "Harmoti Merbil B.O": "784160",
      "Lakhanabari B.O": "784160",
      "Joyhing Te B.O": "787051",
      "Hapotia B.O": "787058",
      "Jugisuti B.O": "787058",
      "Boginadi B.O": "787032",
      "Gharmora B.O": "787032",
      "Ghunasuti B.O": "787032",
      "Gorumoria B.O": "787032",
      "Konwargaon B.O": "787032",
      "Rongpuria B.O": "787032",
      "Fulbari Bokanadi B.O": "787023",
      "Bhogpur Chariali S.O": "787033",
      "Dhalpur S.O": "784165",
      "Dikrong S.O": "784164",
      "Khelmati S.O": "787031",
      "Pathalipam S.O": "787056",
      "Dhakuakhana S.O": "787055",
      "Islamgaon S.O": "787054",
      "Laluk S.O": "784160",
      "Panigaon S.O": "787052",
      "Bihupuria S.O": "784161",
      "Ghilamara S.O": "787053",
      "Lilabari AF S.O": "787051",
      "Pathalipahar S.O": "784163",
      "Moidumia S.O": "787032",
      "Naoboicha S.O": "787023",
      "North Lakhimpur H.O": "787001"
    },
    "CHIRANG": {
      "Kajalgaon S.O": "783385",
      "Kashikotra B.O": "783373",
      "Khungring B.O": "783375",
      "Santipur B.O": "783375",
      "Champabati Bazar B.O": "783373",
      "Duttapur B.O": "783373",
      "Bagargaon B.O": "783390",
      "Bangalijhora B.O": "783390",
      "Bhandra Bazar B.O": "783390",
      "Bholatol B.O": "783390",
      "Hanchara B.O": "783390",
      "Hapachara B.O": "783390",
      "Jharbishpani B.O": "783390",
      "Kaliagaon B.O": "783390",
      "Amguri Bazar B.O": "783393",
      "Amteka Bazar B.O": "783393",
      "B.Ladanguri B.O": "783393",
      "Ballamguri Bazar B.O": "783393",
      "Silbari Abdaipara B.O": "783393",
      "Deosiri B.O": "783375",
      "Ranipur B.O": "783375",
      "Garubhasa B.O": "783373",
      "Mozabari B.O": "783373",
      "Ouguri B.O": "783394",
      "Patabari B.O": "783394",
      "Tukrijhora B.O": "783394",
      "Mongolian Bazar B.O": "783390",
      "Betini B.O": "783393",
      "Betnapara B.O": "783393",
      "Ananda Bazar B.O": "783390",
      "Dakshin Bijni B.O": "783390",
      "Gerukabari B.O": "783390",
      "Dongshia Para B.O": "783393",
      "Malibhita B.O": "783393",
      "Malipara B.O": "783393",
      "Chatonilibari B.O": "783394",
      "Chatianguri B.O": "783390",
      "Fagunagaon B.O": "783390",
      "Goraimari B.O": "783390",
      "Kawatika B.O": "783390",
      "Silkhaguri B.O": "783390",
      "Alukhunda Bazar B.O": "783391",
      "Kokragaon B.O": "783372",
      "Ranchaidham B.O": "783372",
      "Tilakgaon B.O": "783372",
      "Joypur B.O": "783393",
      "Khungkhurajhara B.O": "783393",
      "Koilamoila B.O": "783393",
      "Nehru Bazar B.O": "783393",
      "Kajalgaon B.O": "783385",
      "Barpathar B.O": "783391",
      "Panbari B.O": "783391",
      "Dhantala Bazar B.O": "783372",
      "Fulguri B.O": "783372",
      "Monakocha B.O": "783391",
      "Bidyapur B.O": "783372",
      "Bilaspur B.O": "783372",
      "Dologaon B.O": "783372",
      "Boro Bazar S.O": "783393",
      "Bijni S.O": "783390",
      "Dhaligaon S.O": "783385",
      "Basugaon S.O": "783372",
      "Sidli S.O": "783373",
      "Runikhata S.O": "783375",
      "Bengtal S.O": "783394"
    },
    "DHUBRI": {
      "Barkaila Serso B.O": "783330",
      "Dhumerghat B.O": "783330",
      "Madartari B.O": "783330",
      "Airkata Bazar B.O": "783330",
      "Chirakuti Bazar B.O": "783330",
      "Hamidabad B.O": "783330",
      "Jamadarhat B.O": "783330",
      "Simlabari B.O": "783371",
      "Khalisabhita B.O": "783330",
      "Dhanpur B.O": "783337",
      "Haraltari B.O": "783337",
      "Kartimari B.O": "783337",
      "Monglajhora B.O": "783337",
      "Pratapkhata B.O": "783337",
      "Tipkai B.O": "783337",
      "Tulsibil B.O": "783337",
      "Aminkata B.O": "783337",
      "Bashbari B.O": "783337",
      "Kherbari B.O": "783335",
      "Pabarchara B.O": "783335",
      "South Jhapsabari B.O": "783335",
      "Rangamati B.O": "783339",
      "Gutipara B.O": "783349",
      "Piazbari Makrijhora B.O": "783349",
      "Silgara B.O": "783348",
      "Suapata B.O": "783348",
      "Tingba B.O": "783123",
      "Bhumka B.O": "783337",
      "Duligaon B.O": "783337",
      "Bidyardabri B.O": "783335",
      "Chatoguma B.O": "783335",
      "Dighaltari B.O": "783335",
      "Jhaskal B.O": "783335",
      "Mahamayahat B.O": "783335",
      "Borshijhora B.O": "783339",
      "Debitola B.O": "783339",
      "Geramari B.O": "783339",
      "Jharnerchar B.O": "783339",
      "Aironjongla B.O": "783323",
      "Dhubri Balurchar B.O": "783323",
      "Muthakhowa B.O": "783323",
      "Chagalchara B.O": "783324",
      "Dharmasala B.O": "783324",
      "Bangalipara B.O": "783348",
      "Boalkamari B.O": "783348",
      "Chirakuti Pt i B.O": "783348",
      "Dhirbil B.O": "783348",
      "Gashbari B.O": "783348",
      "Gobardhanpara B.O": "783348",
      "Kajaikata B.O": "783348",
      "Tilapara B.O": "783348",
      "Kaldoba B.O": "783335",
      "Maragadadhar B.O": "783335",
      "Pokalagi B.O": "783335",
      "Khopati B.O": "783339",
      "Bondihana B.O": "783349",
      "Khanabari Araiani B.O": "783349",
      "Patamari B.O": "783324",
      "Bhotgaon B.O": "783301",
      "Hakama B.O": "783348",
      "Jamduar B.O": "783348",
      "Nayeralga B.O": "783348",
      "South Geramari B.O": "783331",
      "Chagolia B.O": "783335",
      "Jhapsabari B.O": "783335",
      "Kaimari B.O": "783335",
      "Satrasal B.O": "783335",
      "Boraibari Pt  V B.O": "783339",
      "Kazigaon B.O": "783339",
      "Podmeralga B.O": "783339",
      "Choudhurirchar B.O": "783349",
      "Howrarpar B.O": "783324",
      "Tistarpar B.O": "783324",
      "Barkanda B.O": "783348",
      "Hatipota B.O": "783348",
      "Jalabila B.O": "783348",
      "Barundanga B.O": "783334",
      "Belguri B.O": "783334",
      "Dafarpur B.O": "783334",
      "Debottar Hasdaha B.O": "783334",
      "Sonahat B.O": "783334",
      "Tokrerchara B.O": "783334",
      "Raijhora Bahalpur B.O": "783371",
      "Asharikandi B.O": "783331",
      "Balajan B.O": "783331",
      "Banyaguri B.O": "783331",
      "Khudimari B.O": "783331",
      "Baladoba B.O": "783334",
      "Kacharihat B.O": "783334",
      "Lakhimari B.O": "783334",
      "Molandubi B.O": "783334",
      "Paglahat B.O": "783334",
      "Kadamtala Pt IIi B.O": "783348",
      "Salkocha B.O": "783348",
      "Silairpar B.O": "783331",
      "Bhatipetla B.O": "783334",
      "Borocharaikhola B.O": "783334",
      "Madhusoulmari B.O": "783331",
      "Sahebganj Naicherkuti B.O": "783331",
      "Tiamari B.O": "783331",
      "Bichandai B.O": "783334",
      "Bishkhowa B.O": "783334",
      "Kachakhana B.O": "783334",
      "Kismat Hasdaha B.O": "783334",
      "Moterjhar B.O": "783334",
      "Raipur B.O": "783334",
      "Khalilpur B.O": "783325",
      "Dimakuri B.O": "783334",
      "Ratiadaha B.O": "783334",
      "Falimari  Pt i B.O": "783325",
      "Majerchar B.O": "783325",
      "Bidyapara S.O": "783324",
      "Bilasipara S.O": "783348",
      "Dhubri Bazar S.O": "783301",
      "Fakirganj S.O": "783330",
      "Golakganj S.O": "783334",
      "Jhagrarpar S.O": "783325",
      "Chapar S.O": "783371",
      "Gauripur S.O": "783331",
      "Dingdinga S.O": "783333",
      "Alamganj S.O": "783339",
      "Amco Road S.O": "783323",
      "Bagribari S.O": "783349",
      "Sapatgram S.O": "783337",
      "Agomoni S.O": "783335",
      "Dhubri H.O": "783301"
    },
    "MAJULI": {
      "Kambong Gaon B.O": "787052",
      "Dafalakata B.O": "787052",
      "Echarikata Balijan B.O": "787052",
      "Na Ali Mirigaon B.O": "787052",
      "Madhupur B.O": "785104",
      "Kulamua Missing B.O": "785104",
      "Madhya Ahatguri B.O": "785614",
      "Bhuramora B.O": "785104",
      "Chitadarchuk B.O": "785104",
      "Kamalpur B.O": "785104",
      "Rowmara B.O": "785614",
      "Ahatguri B.O": "785614",
      "Kaliagaon B.O": "785614",
      "Bargayan B.O": "785104",
      "Hazarikagaon B.O": "785104",
      "Jokaibowa B.O": "785104",
      "Chumaimari Missing Gaon B.O": "785102",
      "Balichapori B.O": "785104",
      "Goalgaon B.O": "785104",
      "Karatipar B.O": "785104",
      "Missamora Missing Gaon B.O": "785104",
      "Phulanibari B.O": "785104",
      "Phutuki Chapori B.O": "785104",
      "Rangachahi Nikinikhowa B.O": "785104",
      "Majorchapori B.O": "785104",
      "Borpomua Lakhimi B.O": "785105",
      "Chamahiati B.O": "785105",
      "Jengraichapori B.O": "785105",
      "Taburam Lahon B.O": "785104",
      "Jengraikumarbari B.O": "785105",
      "Rongachahi B.O": "785104",
      "Murmuria Missing Gaon B.O": "785105",
      "Ratanpur Mirigaon B.O": "785105",
      "Sonowal Kachari B.O": "785110",
      "Karki Chuk Missing Gaon B.O": "785105",
      "Bengenati Satra B.O": "785106",
      "Morituni B.O": "785106",
      "Gayengaon B.O": "785110",
      "New Bessamora B.O": "785110",
      "Majordeori B.O": "785105",
      "Auniati Satra B.O": "785106",
      "Botiamari B.O": "785106",
      "Gezera B.O": "785110",
      "Miligaon Tiniali B.O": "785110",
      "Mudoibil B.O": "785105",
      "Sri Ram Bonomali B.O": "785105",
      "Potiagaon B.O": "785106",
      "Totoya B.O": "785106",
      "Bhakatiduar B.O": "785110",
      "Chamaguri Kamalabari B.O": "785110",
      "Ratanpur B.O": "785110",
      "Solmora B.O": "785110",
      "Kamalabari S.O": "785106",
      "Majulibongaon S.O": "785110",
      "Dakhin Pat Satra S.O": "785102",
      "Jengraimukh S.O": "785105",
      "Garmursatra S.O": "785104"
    },
    "GOALPARA": {
      "Khusdhowa B.O": "783124",
      "Manupara B.O": "783124",
      "Lela B.O": "783124",
      "Upartala B.O": "783124",
      "Tisimpur B.O": "783120",
      "Salpara B.O": "783123",
      "Baida B.O": "783120",
      "Bardamal B.O": "783120",
      "Barjhora B.O": "783120",
      "Dwarka B.O": "783120",
      "Kachadal B.O": "783134",
      "Melopara B.O": "783134",
      "Ambari B.O": "783123",
      "Ambuk B.O": "783123",
      "Chekowary B.O": "783123",
      "Dighali B.O": "783123",
      "Kothakuthi B.O": "783123",
      "Bandarshi B.O": "783124",
      "Maladhara B.O": "783120",
      "Markula B.O": "783120",
      "Nishangram B.O": "783122",
      "Barbhita B.O": "783101",
      "Dakurbhita B.O": "783101",
      "Badahapur B.O": "783120",
      "Balbala Kalapani B.O": "783120",
      "Depalsung B.O": "783120",
      "Jurigaon B.O": "783120",
      "Suarmari B.O": "783120",
      "Dariduri B.O": "783101",
      "Govindapur B.O": "783101",
      "Kharmuza B.O": "783101",
      "Katarihara B.O": "783132",
      "Harimura B.O": "783126",
      "Khardang B.O": "783126",
      "Kukurkata B.O": "783126",
      "Lalabari B.O": "783126",
      "Rajmita Pantai B.O": "783129",
      "Rowkhowa B.O": "783129",
      "Takimari B.O": "783129",
      "Dahela B.O": "783125",
      "Dalgoma B.O": "783125",
      "Gossaibari B.O": "783125",
      "Kahibari B.O": "783130",
      "Patpara B.O": "783130",
      "Simlitola B.O": "783130",
      "Tiplai B.O": "783130",
      "Mornai B.O": "783101",
      "Rakhasini B.O": "783101",
      "Tulsibari B.O": "783132",
      "Baguan B.O": "783129",
      "Balarbhita B.O": "783129",
      "Bashbari B.O": "783129",
      "Beserkona B.O": "783129",
      "Hashdoba B.O": "783129",
      "Joybhum B.O": "783129",
      "Joypur Bazar B.O": "783129",
      "Chakla B.O": "783125",
      "Sesapani B.O": "783134",
      "Bagdoba B.O": "783123",
      "Amjonga B.O": "783124",
      "Darakh B.O": "783124",
      "Baladmarirchar B.O": "783101",
      "Bhalukdubi B.O": "783101",
      "Dubapara B.O": "783101",
      "Kalyanpur B.O": "783101",
      "Simlabari B.O": "783101",
      "Ramharirchar B.O": "783101",
      "Dharai B.O": "783132",
      "Chotomatia B.O": "783126",
      "Tukura B.O": "783126",
      "Aolatoli B.O": "783129",
      "Chunari B.O": "783129",
      "Fetangapara B.O": "783129",
      "Gaurnagar B.O": "783132",
      "Chotipara B.O": "783126",
      "Dhaigaon B.O": "783126",
      "Misilkhowa B.O": "783126",
      "Zira B.O": "783126",
      "Ambari Bazar B.O": "783129",
      "Dhamer Reserve B.O": "783129",
      "Joyramkuchi B.O": "783129",
      "Nidanpur B.O": "783129",
      "Bahati B.O": "783125",
      "Matia Bazar B.O": "783125",
      "Sutarpara B.O": "783125",
      "Dhanubhanga B.O": "783130",
      "Meserbhita B.O": "783129",
      "Panisali B.O": "783129",
      "Bakaitari B.O": "783125",
      "Athiabari B.O": "783130",
      "Goalpara S.O": "783101",
      "Lakhipur S.O (Goalpara)": "783129",
      "Rajapara S.O": "783133",
      "Rangjuli S.O": "783130",
      "Dudhnoi S.O": "783124",
      "Jaleswar S.O": "783132",
      "Matia S.O": "783125",
      "Darrangiri S.O.": "783134",
      "Damra S.O": "783122",
      "Dhupdhara S.O": "783123",
      "Krishnai S.O": "783126",
      "Agia S.O": "783120",
      "Baladmari S.O": "783101"
    },
    "DHEMAJI": {
      "Deuribarbam B.O": "787026",
      "Jairampur B.O": "787026",
      "Missamari B.O": "787026",
      "Salmari No.2 B.O": "787026",
      "Hollowdanga B.O": "787026",
      "Madhuripathar B.O": "787059",
      "Burisuti B.O": "787110",
      "Pipalguri B.O": "787110",
      "Silabaligaon B.O": "787059",
      "Dekapam B.O": "787061",
      "Dipa B.O": "787061",
      "Somkong Pagar B.O": "787061",
      "Talem B.O": "787061",
      "Kerekani Majgaon B.O": "787110",
      "Samarajan Tiniali B.O": "787026",
      "Demow Chariali B.O": "787059",
      "Majorbari Budhbaria Bazar B.O": "787059",
      "Bhebeli Gaon B.O": "787110",
      "Mechaki Tongani Mirigaon B.O": "787110",
      "Palengi Pachali B.O": "787110",
      "Pukia B.O": "787110",
      "Kulajan Tiniali B.O": "787110",
      "Muktiar Chapori B.O": "787110",
      "Namgharia B.O": "787059",
      "Nilakh Chariali B.O": "787110",
      "Ramyapur B.O": "787110",
      "Akajan Bormuria B.O": "787059",
      "Betanipam B.O": "787059",
      "Bhagwan B.O": "787059",
      "Cementmukh B.O": "787059",
      "Aktai B.O": "787110",
      "Batuamukh B.O": "787110",
      "Dhunaguri Borgaya Deori Gaon B.O": "787110",
      "Janakalyan Chariali B.O": "787110",
      "Borlung B.O": "787057",
      "Gohaingaon B.O": "787057",
      "Batgharia B.O": "787057",
      "Goalchapori B.O": "787057",
      "Jamuguri Panchali B.O": "787057",
      "Khubalia B.O": "787057",
      "Moridhal B.O": "787057",
      "Mingmang B.O": "787035",
      "Bordoibam B.O": "787053",
      "Khalihamari B.O": "787053",
      "Kadamguri B.O": "787034",
      "Khorachukgaon B.O": "787034",
      "Na Nadi Bhebeli Kahcari Gaon B.O": "787034",
      "Borachira Gaon B.O": "787057",
      "Bulakata B.O": "787057",
      "Jiadhal B.O": "787057",
      "Lakhipathar B.O": "787057",
      "Nalbari Kachari B.O": "787035",
      "Leku B.O": "787060",
      "Ratanpur B.O": "787060",
      "Aradhal B.O": "787057",
      "Bauli B.O": "787057",
      "Bishnupur B.O": "787057",
      "Matikhola B.O": "787057",
      "Nagakhelia B.O": "787057",
      "Perabari B.O": "787057",
      "Raiting B.O": "787057",
      "Subahi B.O": "787057",
      "Laguaborah B.O": "787053",
      "Kaupatani B.O": "787034",
      "Lotakigaon B.O": "787034",
      "Moinapara B.O": "787034",
      "Kabu Chapori B.O": "787060",
      "Laimekuri B.O": "787060",
      "Kaitung B.O": "787058",
      "Khaliamari Pamuagaon B.O": "787058",
      "Gali Borbali B.O": "787060",
      "Ramdhan Dikhari B.O": "787060",
      "Zonekareng B.O": "787060",
      "Jorkata B.O": "787058",
      "Kachari Pathar B.O": "787058",
      "Kalakata B.O": "787058",
      "Guttung B.O": "787057",
      "Hatigarh B.O": "787057",
      "Ghughuhadal B.O": "787053",
      "Bengenagarah B.O": "787058",
      "Dhubabari B.O": "787058",
      "Norowathan B.O": "787058",
      "Seujiapathar B.O": "787058",
      "Dighali Debera B.O": "787058",
      "Sissimukh B.O": "787058",
      "Machkhowa S.O": "787058",
      "Simen Chapori S.O": "787061",
      "Gerukamukh S.O": "787035",
      "Dhemaji S.O": "787057",
      "Bordoloni S.O": "787026",
      "Gogamukh S.O": "787034",
      "Jonai S.O": "787060",
      "Silapathar S.O": "787059",
      "Sissiborgaon S.O": "787110"
    },
    "KAMRUP": {
      "Alikash B.O": "781137",
      "Batahidia B.O": "781137",
      "Balikuchi B.O": "781381",
      "Dopdar B.O": "781030",
      "Bhitarduar B.O": "781137",
      "Jahirpur B.O": "781137",
      "Pingaleswar B.O": "781381",
      "Dobok B.O": "781380",
      "Kaniha B.O": "781380",
      "Puthimari B.O": "781380",
      "Choudhurykhat B.O": "781141",
      "Dumunichowki B.O": "781121",
      "Mandakata B.O": "781121",
      "Futuri B.O": "781122",
      "Gohalkona B.O": "781123",
      "Paneri B.O": "781123",
      "Mataikhar B.O": "781120",
      "Balapukhuri B.O": "781124",
      "Borjhar B.O": "781124",
      "Kaimari B.O": "781124",
      "Pachim Dhuligaon B.O": "781124",
      "Ukiam B.O": "781124",
      "Samuka B.O": "781129",
      "Bagta B.O": "781102",
      "Borni B.O": "781102",
      "Nampara Majarkuri B.O": "781102",
      "Soniadi B.O": "781102",
      "Amranga B.O": "781125",
      "Panikhaiti B.O": "781137",
      "Toparpathar B.O": "781137",
      "Tukrapara B.O": "781137",
      "Chanmaguri B.O": "781380",
      "Kharikot B.O": "781380",
      "Batarhat B.O": "781122",
      "Dakhala B.O": "781122",
      "Durapara B.O": "781123",
      "Kinangaon B.O": "781123",
      "Mauman Ashram B.O": "781123",
      "Champaknagar B.O": "781124",
      "Ghoramara B.O": "781124",
      "Natun Jharobari B.O": "781124",
      "Ratanpur B.O": "781124",
      "Tulsibari B.O": "781376",
      "Lower Lumpi B.O": "781129",
      "Akadi B.O": "781102",
      "Bhelkarbazar B.O": "781102",
      "Ramdia B.O": "781102",
      "Bihdia B.O": "781381",
      "Karora B.O": "781381",
      "Barpalaha B.O": "781121",
      "Bhomolahati B.O": "781121",
      "Saledal B.O": "781121",
      "Rangamati B.O": "781122",
      "Sarpara B.O": "781122",
      "Simina B.O": "781122",
      "Bhalukghata B.O": "781123",
      "Birpara B.O": "781123",
      "Boko Agchia B.O": "781123",
      "Boko Rajapara B.O": "781123",
      "Baralabari B.O": "781101",
      "Deoduar B.O": "781101",
      "Dorakahara B.O": "781101",
      "Panitema B.O": "781101",
      "Gerua B.O": "781102",
      "Kalitakuchi B.O": "781102",
      "Khapenikuchi B.O": "781102",
      "Khetri Hardia B.O": "781102",
      "Sikarhati B.O": "781125",
      "Barbaka B.O": "781030",
      "Madhyamkhanda B.O": "781030",
      "Rongmahal B.O": "781030",
      "Hatipara B.O": "781137",
      "Mahimari B.O": "781137",
      "Collegenagar B.O": "781031",
      "Loch B.O": "781381",
      "Sutargaon B.O": "781381",
      "Baruajani B.O": "781380",
      "Hinguli B.O": "781380",
      "Kalajalchowk B.O": "781380",
      "Jambari B.O": "781141",
      "Santipur B.O": "781141",
      "Halda B.O": "781121",
      "Kendua B.O": "781121",
      "Dehaligaon B.O": "781122",
      "Loharghat B.O": "781120",
      "Rajapara B.O": "781120",
      "Pubborka B.O": "781101",
      "Bakalipara B.O": "781124",
      "Sidilapara B.O": "781124",
      "Nalapara B.O": "781129",
      "Dampur B.O": "781102",
      "Hablaka B.O": "781102",
      "Kuwarpur B.O": "781102",
      "Tokradia B.O": "781102",
      "Topabari B.O": "781102",
      "Amtala B.O": "781134",
      "Baniapara B.O": "781124",
      "Jiakur B.O": "781134",
      "Bargaon B.O": "781104",
      "Boromboi B.O": "781104",
      "Nizmanakuchi B.O": "781104",
      "Maniari Tiniali B.O": "781125",
      "Badlabazar B.O": "781127",
      "Bagmarachar B.O": "781127",
      "Hekra B.O": "781127",
      "Jamlai B.O": "781127",
      "Kalubari B.O": "781127",
      "Rowmari B.O": "781104",
      "Gosaihat B.O": "781125",
      "Alupati B.O": "781127",
      "Kachumara B.O": "781127",
      "Uzankuri B.O": "781102",
      "Dadara B.O": "781104",
      "Pacharia B.O": "781104",
      "Tetelia B.O": "781104",
      "Dhengargaon B.O": "781125",
      "Kulsirange B.O": "781125",
      "Kalardia B.O": "781127",
      "Kholabandha B.O": "781127",
      "Dekachang B.O": "781136",
      "Jogiparapathar B.O": "781136",
      "Mahtoli B.O": "781136",
      "Bardal B.O": "781354",
      "Barghuli B.O": "781354",
      "Chapania B.O": "781354",
      "Deolkuchi B.O": "781354",
      "Bamundi B.O": "781103",
      "Bongshor B.O": "781103",
      "Bardekpar B.O": "781382",
      "Dihina B.O": "781382",
      "Japia B.O": "781382",
      "Mandira B.O": "781127",
      "Champaparabazar B.O": "781136",
      "Kalatoli B.O": "781136",
      "Malibaribazar B.O": "781136",
      "Bhagawatipara B.O": "781132",
      "Satpakhali B.O": "781132",
      "Gopalpur B.O": "781354",
      "Madhukuchi B.O": "781354",
      "Maranjana B.O": "781354",
      "Damalchos B.O": "781135",
      "Helecha B.O": "781382",
      "Khudradimu B.O": "781382",
      "Palahartari B.O": "781127",
      "Pathimari B.O": "781127",
      "Pijupara B.O": "781127",
      "Tupamari B.O": "781127",
      "Baruapathar B.O": "781136",
      "Jamtala B.O": "781365",
      "Titkuri B.O": "781354",
      "Udiana B.O": "781354",
      "Bargaon Khaliha B.O": "781135",
      "Simlatarabari B.O": "781135",
      "Singra Rajapara B.O": "781135",
      "Saraibaha B.O.": "781135",
      "Gandhmow B.O": "781103",
      "Siliguri B.O": "781103",
      "Srihati B.O": "781103",
      "Naitar B.O": "781127",
      "Bhauriabhita B.O": "781136",
      "Malibaripathar B.O": "781136",
      "Nahira B.O": "781132",
      "Tinali B.O": "781365",
      "Bangaon B.O": "781354",
      "Dhepargaon B.O": "781354",
      "Kachari Solmari B.O": "781354",
      "Pitambarhat Bazali B.O": "781354",
      "Tarani B.O": "781354",
      "Bondapara B.O": "781135",
      "Gamarimura B.O": "781135",
      "Pachia B.O": "781135",
      "Halogaon B.O": "781103",
      "Aggumi S.O": "781137",
      "Baihata Chariali S.O": "781381",
      "Kukurmara S.O": "781134",
      "Rangia R.S. S.O": "781365",
      "Boko S.O": "781123",
      "Changsari S.O": "781101",
      "Hahimbazar S.O": "781129",
      "Hajo S.O": "781102",
      "Kulhati S.O": "781104",
      "Pachim Samaria S.O": "781136",
      "Dagaon S.O.": "781133",
      "Bezera S.O": "781121",
      "Borduar S.O": "781120",
      "I I T S.O": "781039",
      "Nagarbera S.O": "781127",
      "Palashbari S.O": "781128",
      "Rangia S.O": "781354",
      "Rani S.O (Kamrup)": "781131",
      "Soneswar S.O": "781382",
      "North Guwahati S.O": "781030",
      "Amingaon S.O": "781031",
      "Baihata S.O": "781380",
      "Bamunigaon S.O (Kamrup)": "781141",
      "Bijoynagar S.O": "781122",
      "Chhaygaon S.O": "781124",
      "Mirza S.O": "781125",
      "Rampur S.O (Kamrup)": "781132",
      "Singra S.O": "781135",
      "Soalkuchi S.O": "781103"
    },
    "KOKRAJHAR": {
      "Saraibil B.O": "783350",
      "Salakati B.O": "783369",
      "Athiabari B.O": "783346",
      "Jharbari B.O": "783346",
      "Pakriguri B.O": "783346",
      "Ramfalbil B.O": "783346",
      "Karigaon B.O": "783373",
      "Jaraguri B.O": "783361",
      "Simultapu B.O": "783361",
      "Barjan B.O": "783332",
      "Kamandanga B.O": "783332",
      "Takampur B.O": "783350",
      "Mainaguri B.O": "783354",
      "Petlagaon B.O": "783332",
      "Srinagar B.O": "783332",
      "Chitila Bhubannagar B.O": "783354",
      "Patgaon B.O": "783346",
      "Shialmari B.O": "783346",
      "Goladangi B.O": "783361",
      "Haraputa B.O": "783361",
      "Uzanpetla B.O": "783332",
      "Mahamayadham B.O": "783349",
      "Panbari Bazar B.O": "783360",
      "Rajadabri B.O": "783360",
      "Sapkata B.O": "783360",
      "Raimona B.O": "783350",
      "Kalipukhuri B.O": "783369",
      "Aflagaon B.O": "783346",
      "Gossainichina B.O": "783346",
      "Kakormari B.O": "783346",
      "Shyamthaibari B.O": "783346",
      "Lalmati Tumbagan B.O": "783332",
      "Koimari B.O": "783360",
      "Daloabari B.O": "783370",
      "Haloadal B.O": "783370",
      "Haltugaon B.O": "783370",
      "Kashipara Bhotgaon B.O": "783370",
      "Gambaribil B.O": "783336",
      "Khargaon B.O": "783370",
      "Kokrajhar Bagicha B.O": "783370",
      "Rangalikhata B.O": "783370",
      "Ultapani B.O": "783370",
      "Choibari B.O": "783376",
      "Failaguri B.O": "783333",
      "Banargaon B.O": "783347",
      "Batabari B.O": "783347",
      "Bhalukmari B.O": "783347",
      "Tetliguri B.O": "783347",
      "Baruapara B.O": "783345",
      "Futkibari B.O": "783345",
      "Helaguri B.O": "783345",
      "Garufela Bazar B.O": "783360",
      "Gossaigaon No.II B.O": "783360",
      "Padmabil B.O": "783360",
      "Patakata B.O": "783360",
      "Satyapur B.O": "783360",
      "Gangia B.O": "783350",
      "Maktaigaon B.O": "783360",
      "Bairali B.O": "783350",
      "Jaleswari B.O": "783350",
      "Rupsi B.O": "783331",
      "Bishmuri B.O": "783370",
      "Chandrapara B.O": "783370",
      "Titaguri B.O": "783370",
      "Binnyakhata B.O": "783336",
      "Kamalsing B.O": "783336",
      "Majergaon B.O": "783376",
      "Grahampur B.O": "783333",
      "Hakamabil B.O": "783347",
      "Puthimari B.O": "783347",
      "Raniganj B.O": "783345",
      "Ballimari B.O": "783360",
      "Bhodeaguri B.O": "783360",
      "Joyma B.O": "783360",
      "Kashiabari B.O": "783360",
      "Boro Gendrabil B.O": "783370",
      "Rainadabri B.O": "783370",
      "Simbargaon B.O": "783370",
      "Magurmari B.O": "783370",
      "Dabargaon B.O": "783376",
      "Lawdanga B.O": "783347",
      "Baghmari B.O": "783345",
      "Shesergaon B.O": "783345",
      "Anthaibari B.O": "783360",
      "Chakma B.O": "783360",
      "Nayekgaon B.O": "783376",
      "Dumeriguri B.O": "783347",
      "Lakhiganj Bazar B.O": "783345",
      "Guabari B.O": "783360",
      "Jambuguri B.O": "783360",
      "Joyma Bazar B.O": "783360",
      "Dotma S.O": "783347",
      "Bhowraguri S.O": "783336",
      "Choraikhola S.O": "783376",
      "Kachugaon S.O": "783350",
      "Saktiashram S.O": "783354",
      "Serfanguri S.O": "783346",
      "Srirampur S.O (Kokrajhar)": "783361",
      "Tamarhat S.O": "783332",
      "Fakiragram S.O": "783345",
      "Salakati Project S.O": "783369",
      "Shantinagar S.O (Kokrajhar)": "783370",
      "Gossaigaon S.O": "783360",
      "Kokrajhar H.O": "783370"
    },
    "KAMRUP METRO": {
      "Gandhinagar B.O": "782403",
      "Nizdemoria B.O": "782403",
      "Hahara B.O": "782402",
      "Gitanagar B.O": "781024",
      "Dhirenpara B.O": "781025",
      "Dhopguri B.O": "782403",
      "Durungpahar B.O": "782403",
      "Bonda B.O": "781026",
      "Panikhaiti B.O": "781026",
      "Amsinggaon E (S  85) B.O": "781027",
      "Chamatapathar B.O": "782402",
      "Jorabat B.O": "781023",
      "Nartap B.O": "782402",
      "Sonai Kamalajari B.O": "782402",
      "Tepesia B.O": "782402",
      "Dharapur B.O": "781017",
      "Bongra B.O": "781015",
      "Gobardhan B.O": "781150",
      "Panbari B.O": "782401",
      "Japorigog B.O": "781005",
      "Malaybari B.O": "782403",
      "Topatali B.O": "782403",
      "Bhattaparagaral B.O": "781017",
      "Debgotanagar B.O": "781011",
      "Agchia B.O": "781128",
      "Majirgaon B.O": "781128",
      "Mayang Kamarpur B.O": "782411",
      "Dehangarigaon B.O": "781012",
      "Sadilapur B.O": "781012",
      "Panjabari S.O": "781037",
      "Rehabari S.O": "781008",
      "Satgaon S.O": "781027",
      "Sonapur S.O": "782402",
      "Ulubari S.O": "781007",
      "Pandu Rly Colony S.O": "781012",
      "Udayan Vihar S.O": "781171",
      "Azara S.O": "781017",
      "Guwahati Airport S.O": "781015",
      "Odalbakra S.O": "781034",
      "Paltanbazar S.O": "781008",
      "Patharquerry S.O": "781171",
      "Sawkuchi S.O": "781040",
      "Silpukhuri S.O": "781003",
      "Uzanbazar S.O": "781001",
      "IBC Guwahati P.O": "781002",
      "Gotanagar S.O": "781011",
      "Jalukbari S.O": "781013",
      "Zoo Road S.O": "781024",
      "Garchuk S.O": "781035",
      "Mlg Rly Hqs S.O": "781011",
      "Pandu S.O": "781012",
      "Ambari Fatasil S.O": "781025",
      "Assam Sachivalaya S.O": "781006",
      "Hengrabari S.O": "781036",
      "Indrapur S.O": "781032",
      "Narangi S.O": "781026",
      "Assam Tribune S.O": "781003",
      "Bamunimaidan S.O": "781021",
      "Chandrapur S.O (Kamrup)": "781150",
      "Digaru S.O": "782401",
      "Gopinathnagar S.O": "781016",
      "Kharguli S.O": "781004",
      "Lachitnagar S.O": "781007",
      "Kamakhya S.O": "781010",
      "Khanapara S.O": "781022",
      "Khetri S.O (Kamrup)": "782403",
      "Noonmati S.O": "781020",
      "Amerigog S.O": "781023",
      "Basistha S.O": "781029",
      "Beltola S.O": "781028",
      "Bharalumukh S.O": "781009",
      "Binovanagar S.O": "781018",
      "Dispur S.O": "781005",
      "Fancy Bazar S.O": "781001",
      "Hatigaon Chariali S.O": "781038",
      "Kahilipara S.O": "781019",
      "Guwahati University H.O": "781014",
      "Guwahati G.P.O.": "781001"
    },
    "NAGAON": {
      "Barpani B.O": "782450",
      "Paharguri B.O": "782450",
      "Singia B.O": "782140",
      "Rangagarah B.O": "782140",
      "Sibasthan B.O": "782140",
      "Udmari B.O": "782140",
      "Sonarigaon B.O": "782123",
      "Ghehua Chalchali B.O": "782128",
      "Kaliadinga B.O": "782128",
      "Bhomoraguri B.O": "782143",
      "Kurhimari B.O": "782143",
      "Uttar Garanjan B.O": "782128",
      "Uttar Khatowal B.O": "782128",
      "Borghuli B.O": "782143",
      "Pub Futaljar B.O": "782128",
      "Kathpara Bazar B.O": "782120",
      "Lailuri B.O": "782120",
      "Ghahibhatikuri B.O": "782144",
      "Kandali B.O": "782102",
      "Nibukali B.O": "782102",
      "Potani Gomothagaon B.O": "782102",
      "Balikatia B.O": "782122",
      "Barangatoli B.O": "782141",
      "Chalchali B.O": "782141",
      "Kalongpar Halowagaon B.O": "782141",
      "Fulaguri B.O": "782103",
      "Khaigarh B.O": "782103",
      "Molankata B.O": "782103",
      "Ramjanati B.O": "782103",
      "Gatonga B.O": "782125",
      "Hatipukhuri B.O": "782125",
      "Pub Amarakanda B.O": "782125",
      "Pubsalpara B.O": "782125",
      "Teliachapari B.O": "782125",
      "Sarishabari B.O": "782139",
      "Bajiagaon B.O": "782140",
      "Chakitop B.O": "782140",
      "Geruaati Bazar B.O": "782140",
      "Bagamukh B.O": "782120",
      "Teliagaon B.O": "782141",
      "Bagariguri B.O": "782103",
      "Barmanipur B.O": "782142",
      "Chakalaghat B.O": "782142",
      "Jamuguri B.O": "782142",
      "Majgaon B.O": "782142",
      "Parkup Pahar B.O": "782135",
      "Barapujia B.O": "782103",
      "Dighaldori B.O": "782103",
      "Dighaliati B.O": "782103",
      "Barghat B.O": "782125",
      "Dighali B.O": "782125",
      "Chalapathar B.O": "782122",
      "Hatizuzua B.O": "782122",
      "Lalunggaon B.O": "782122",
      "Gosaibori B.O": "782142",
      "Hatichung B.O": "782142",
      "Pubguimari B.O": "782425",
      "Salmora B.O": "782425",
      "Balisatra B.O": "782122",
      "Batamari B.O": "782122",
      "Borbheti B.O": "782122",
      "Kadomoni B.O": "782122",
      "Barchila B.O": "782142",
      "Bajbatamari B.O": "782425",
      "Beltola B.O": "782425",
      "Kakatigaon B.O": "782425",
      "Rowmari Bill B.O": "782123",
      "Sologuri B.O": "782123",
      "Tuktuki B.O": "782123",
      "Aibheti B.O": "782002",
      "Kachamari Boragaon B.O": "782002",
      "Khutikatia B.O": "782002",
      "Dimaruguri B.O": "782003",
      "Hatipara B.O": "782003",
      "Kuthori B.O": "782136",
      "Seconee Borhola B.O": "782136",
      "Borghuli Sapmar B.O": "782120",
      "Dakhin Beloguri B.O": "782120",
      "Deorigaon B.O": "782144",
      "Uttar Petboha B.O": "782144",
      "Bamuni B.O": "782102",
      "Barpanigaon B.O": "782141",
      "Kakhorigaon B.O": "782141",
      "Marangialgaon B.O": "782141",
      "Rahagaon B.O": "782103",
      "Saragaon B.O": "782103",
      "Kumargaon B.O": "782125",
      "Saidoria B.O": "782125",
      "Tarabari B.O": "782125",
      "Barjuri B.O": "782139",
      "Bheleoguri B.O": "782140",
      "Kawaimari B.O": "782140",
      "Mowamari B.O": "782140",
      "Chitalmari Beel B.O": "782124",
      "Fakali Pathar B.O": "782124",
      "Tetelisara B.O": "782426",
      "Biharigaon B.O": "782101",
      "Bharidhua B.O": "782120",
      "Burhachaparigao B.O": "782120",
      "Hatlaokhowa B.O": "782120",
      "Borkola B.O": "782144",
      "Amlakhi B.O": "782122",
      "Halowagaon B.O": "782141",
      "Hariamukh B.O": "782103",
      "Kanchanpur B.O": "782125",
      "Puthikhaiti B.O": "782125",
      "Rowmari B.O": "782125",
      "Singimari B.O": "782125",
      "Anjukpani B.O": "782139",
      "Magurmari B.O": "782140",
      "Padumoni B.O": "782140",
      "Pub Baralimari B.O": "782124",
      "Sutirpar B.O": "782124",
      "Debnarikoli B.O": "782426",
      "Ghilani B.O": "782426",
      "Jurirpar B.O": "782426",
      "Rengbeng B.O": "782427",
      "Tulashimukh B.O": "782101",
      "Chatabar B.O": "782106",
      "Borbheti Dhing B.O": "782123",
      "Dhupaguri B.O": "782123",
      "Niz dhing B.O": "782123",
      "Chillangani B.O": "782002",
      "Herapatty B.O": "782002",
      "Majarati B.O": "782002",
      "Dakarghat B.O": "782003",
      "Nagaon Padel B.O": "782003",
      "Amguri B.O": "782136",
      "Bagari B.O": "782136",
      "Hatbor B.O": "782136",
      "Leteripar Bazar B.O": "782124",
      "Mithapukhuripar B.O": "782124",
      "Singari Madrassa B.O": "782124",
      "Teliabebejia B.O": "782124",
      "Dakhin Sangchaki B.O": "782426",
      "Gerjaipam B.O": "782426",
      "Kachua B.O": "782426",
      "Patiapam B.O": "782426",
      "Simaluguri B.O": "782426",
      "Jumurmur B.O": "782427",
      "Pubthoria B.O": "782137",
      "Amoni B.O": "782138",
      "Rantholi B.O": "782101",
      "Dhaniabheti B.O": "782122",
      "Jengani B.O": "782122",
      "Patiachapari B.O": "782122",
      "Gakhajua B.O": "782142",
      "Jajori B.O": "782142",
      "Kathalguri B.O": "782135",
      "Amsoi Bazar B.O": "782425",
      "Bamunijan B.O": "782425",
      "Gaspara B.O": "782425",
      "Laopani B.O": "782425",
      "Alikuchi B.O": "782106",
      "Alitangani B.O": "782124",
      "Dagaon B.O": "782124",
      "Kashari B.O": "782124",
      "Tinsukia Juria B.O": "782124",
      "Niz narikoli B.O": "782426",
      "Puthimari Bazar B.O": "782426",
      "Satlanga B.O": "782426",
      "Bengenaati B.O": "782137",
      "Barbhagia B.O": "782138",
      "No.1 Gayangaon B.O": "782126",
      "Oper Uzaragaon B.O": "782101",
      "Akorabori B.O": "782123",
      "Bechamari B.O": "782123",
      "Dhing Bazar B.O": "782123",
      "Bihlangani B.O": "782002",
      "Huzrangagarah B.O": "782002",
      "Solmari B.O": "782002",
      "Amolapatty B.O": "782003",
      "Chottahaibor B.O": "782003",
      "Mohkhuli B.O": "782003",
      "Uriagaon B.O": "782003",
      "Burapahar B.O": "782136",
      "Chamuagaon B.O": "782123",
      "Kandhulimari B.O": "782123",
      "Silpukhuri B.O": "782123",
      "Senchowa B.O": "782002",
      "Madhupur B.O": "782003",
      "Majpathori B.O": "782003",
      "Palasani B.O": "782003",
      "Pathori B.O": "782003",
      "Barhampur S.O": "782102",
      "Batadraba S.O": "782122",
      "Dhing S.O": "782123",
      "Itachali S.O": "782003",
      "Kathiatoli S.O": "782427",
      "Rupahi S.O": "782125",
      "Samaguri S.O": "782140",
      "Ambagan S.O": "782120",
      "Baligaon S.O": "782144",
      "Bebejia S.O": "782142",
      "Chapanalla S.O": "782135",
      "Juria S.O": "782124",
      "Missa S.O": "782138",
      "Puranigudam S.O": "782141",
      "Silghat S.O": "782143",
      "Baithalangsho S.O": "782450",
      "Chaparmukh S.O": "782425",
      "Haiborgaon S.O": "782002",
      "Kampur S.O": "782426",
      "Kuworitul S.O": "782137",
      "Nagaon Girls  College S.O": "782001",
      "Nonoi S.O": "782101",
      "Raha S.O": "782103",
      "Salana S.O": "782139",
      "Garajan Bazar S.O": "782128",
      "Jakhalabandha S.O": "782136",
      "Nagaon H.O": "782001"
    },
    "GOLAGHAT": {
      "Dabidubi B.O": "785611",
      "Mirigaon B.O": "785602",
      "Silonijan B.O": "785602",
      "Dusutimukh B.O": "785611",
      "Goriajan B.O": "785611",
      "Kordoiguri B.O": "785602",
      "Kacharihat B.O": "785702",
      "Missionpatty B.O": "785702",
      "Moukhowa B.O": "785702",
      "Balijan Aamtenga B.O": "785612",
      "Borjuri B.O": "785612",
      "Dhansirimukh": "785612",
      "Dofalada B.O": "785612",
      "Naharjaan B.O": "785612",
      "Nakkati B.O": "785611",
      "Rongagora Ghat B.O": "785611",
      "Bilgaon B.O": "785602",
      "Dapathar B.O": "785602",
      "Disirigayan Satra B.O": "785602",
      "Missamora B.O": "785618",
      "Naharani B.O": "785618",
      "Haladhibari B.O": "785618",
      "Bamborahi B.O": "785702",
      "Barpatharua B.O": "785702",
      "Falangani B.O": "785702",
      "Murphulani B.O": "785702",
      "Padumani B.O": "785702",
      "Pulibar Bidyapith B.O": "785702",
      "Ultajaan B.O": "785702",
      "Khotiakhuli B.O": "785612",
      "Bongalgaon B.O": "785614",
      "Dadhara B.O": "785614",
      "Dani Chapori B.O": "785614",
      "Alengmuria B.O": "785622",
      "Chinatoli B.O": "785622",
      "Doria T.E. B.O": "785622",
      "Bokalaigaon B.O": "785625",
      "Borjan B.O": "785610",
      "Bonkowal B.O": "785619",
      "Goriatika Barpathar B.O": "785619",
      "Bokial B.O": "785613",
      "Dholaguri B.O": "785613",
      "Sapekhati B.O": "785705",
      "Cinakon Chariali B.O": "785615",
      "Jamuguri B.O": "785603",
      "Lakhibari Tiniali B.O": "785603",
      "Bormukoli B.O": "785703",
      "Fetagaon B.O": "785703",
      "Sohoguri Kachari B.O": "785703",
      "Negheriting B.O": "785703",
      "Dhupguri B.O": "785601",
      "Gohaingaon B.O": "785601",
      "Siljuri B.O": "785612",
      "Joraguri B.O": "785614",
      "Khangia B.O": "785614",
      "Panjan Sarupathar B.O": "785601",
      "Rajapukhuri B.O": "785601",
      "Bholaguri B.O": "785611",
      "Bongaon B.O": "785611",
      "Premhara B.O": "785602",
      "Dhodang Gaon B.O": "785618",
      "Adharsatra B.O": "785702",
      "Doigrung B.O": "785702",
      "Halmira Te B.O": "785702",
      "Marangi Chariali B.O": "785702",
      "Kakachang B.O": "785612",
      "Lakhowjaan Tiniali B.O": "785612",
      "Amgurinabhanga B.O": "785614",
      "Bahguri B.O": "785614",
      "Kamargaonchariali B.O": "785614",
      "Hahpani B.O": "785614",
      "Betioni B.O": "785622",
      "Nabheta B.O": "785622",
      "Napamuakamargaon B.O": "785625",
      "Mohpara B.O": "785609",
      "Barting Naochalia B.O": "785626",
      "Gomariguri B.O": "785705",
      "Ratanpur Sishupani B.O": "785705",
      "Upper Lengtha B.O": "785602",
      "Batiporia B.O": "785618",
      "Dubialgaon B.O": "785618",
      "Howtoly B.O": "785702",
      "Marangi B.O": "785702",
      "Melamora B.O": "785702",
      "Bokakhat Rajabari B.O": "785612",
      "Diffolu T.E. B.O": "785612",
      "Dolamara B.O": "785612",
      "Rangamati B.O": "785614",
      "Ganakpukhuri B.O": "785622",
      "Moluahabi B.O": "785622",
      "Rahdhala B.O": "785622",
      "Salikihaat B.O": "785625",
      "Mohoramukh B.O": "785619",
      "Hatiekhowa B.O": "785626",
      "Namkhatoal B.O": "785626",
      "Chowdangpathar B.O": "785705",
      "Kachamari B.O": "785705",
      "Karuabahi Satra B.O": "785615",
      "Barua Gaon B.O": "785603",
      "Sitalpather B.O": "785703",
      "Uriamghat B.O": "785601",
      "Mudoigaon B.O": "785614",
      "Kathalguri B.O": "785622",
      "Pub Khumtai B.O": "785622",
      "Athabari B.O": "785625",
      "Kachupathar B.O": "785619",
      "Khumtai B.O": "785619",
      "Hatikhuli B.O": "785609",
      "Kaziranga B.O": "785609",
      "Hukurakhat B.O": "785626",
      "Chalangpathar B.O": "785705",
      "Behora B.O": "785615",
      "Ghiladhari B.O": "785603",
      "Habichukia B.O": "785603",
      "Telishal B.O": "785705",
      "Kanaighat B.O": "785699",
      "Dhodang B.O": "785615",
      "Kuruabahi Tiniali B.O": "785615",
      "Nogora Grant B.O": "785603",
      "Chukiapather B.O": "785601",
      "Chungajan B.O": "785601",
      "Tengabari B.O": "785601",
      "Naojan B.O": "785601",
      "Kamargaon S.O (Golaghat)": "785619",
      "Kaziranga National Park S.O": "785609",
      "Letekujaan S.O": "785613",
      "Numaligarh Refinery Project S.O": "785699",
      "Bengenakhowa S.O": "785702",
      "Dergaon S.O": "785614",
      "Merapani S.O": "785705",
      "Numaligarh S.O": "785615",
      "Oating S.O": "785603",
      "Ptc Dergaon S.O": "785703",
      "Sarupathar S.O": "785601",
      "Barpathar S.O": "785602",
      "Baruabamungaon S.O": "785618",
      "Dergaon Chariali S.O": "785614",
      "Dhekial S.O": "785622",
      "Furkating S.O": "785610",
      "Badulipaar S.O": "785611",
      "Bokakhat S.O": "785612",
      "Kamarbandha Ali S.O": "785625",
      "Maheema S.O": "785626",
      "Golaghat H.O": "785621"
    },
    "WEST KARBI ANGLONG": {
      "Honkram B.O": "782450",
      "Amtreng B.O": "782450",
      "Tengralangso B.O": "782450",
      "Tikahill B.O": "782450",
      "Phangtrengphang B.O": "782485",
      "Satgaon B.O": "782485",
      "Khanduli B.O": "782486",
      "Umcherra B.O": "782486",
      "Menmeji B.O": "782435",
      "Forest Bazar B.O": "782448",
      "Jengkha B.O": "782448",
      "Jirikinding B.O": "782448",
      "Jaljuri B.O": "782485",
      "Kalanga B.O": "782485",
      "Borthal B.O": "782485",
      "Taradubi B.O": "782485",
      "Amrang B.O": "782448",
      "Panjaborpathar B.O": "782450",
      "Honlokrok B.O": "782485",
      "Tumpreng B.O": "782485",
      "Dayangmukh B.O": "782448",
      "Sangsiga Bazar B.O": "782448",
      "Ulukunchi B.O": "782413",
      "Umpanai B.O": "782413",
      "Amguri B.O": "782413",
      "Umswai B.O": "782413",
      "Patsari B.O": "782413",
      "Donkamokam S.O": "782485",
      "Kheroni S.O": "782448",
      "Hamren S.O": "782486"
    },
    "JORHAT": {
      "Goalgaon Baliati B.O": "785703",
      "Baghmora B.O": "785101",
      "Bahana Tiniali B.O": "785101",
      "Potiagaon B.O": "785101",
      "Rongdoi Chariali B.O": "785101",
      "Chowkhat B.O": "785101",
      "Raidangjuri B.O": "785631",
      "Rajabahar B.O": "785631",
      "Rajabari B.O": "785631",
      "Ujanitarani B.O": "785631",
      "Chenijaan B.O": "785010",
      "Kachagoral B.O": "785010",
      "Kalakhowa B.O": "785010",
      "Kakodonga Bekajan B.O": "785631",
      "Mirigaon B.O": "785631",
      "Mohimabari B.O": "785631",
      "Mokrong B.O": "785631",
      "Koronga B.O": "785008",
      "Lichubari B.O": "785008",
      "Konwaripukhuri B.O": "785008",
      "Garumora B.O": "785703",
      "Sockolatinga B.O": "785703",
      "Borkhelia Goon B.O": "785101",
      "Hatigarh Balichapori B.O": "785101",
      "Moutgaon B.O": "785101",
      "Pokamura B.O": "785004",
      "Gorajan B.O": "785631",
      "Paanjaan Borholla B.O": "785631",
      "Urongial B.O": "785631",
      "Sotai B.O": "785010",
      "Chowtang B.O": "785101",
      "Chalihagaon B.O": "785004",
      "Ikarani B.O": "785631",
      "Muktinagar B.O": "785631",
      "Pulikaitoni B.O": "785631",
      "Pub charigaon B.O": "785010",
      "Gojpuria B.O": "785008",
      "Dagaon B.O": "785682",
      "Mori Jhanji B.O": "785682",
      "Kachamari B.O": "785616",
      "Namchungi B.O": "785616",
      "Satriagaon B.O": "785616",
      "Tamulbari B.O": "785616",
      "Bongalpukhuri B.O": "785014",
      "Halowapathar B.O": "785636",
      "Hemlai B.O": "785636",
      "Jogduar Sonari B.O": "785112",
      "Deogharia B.O": "785630",
      "Dihingia B.O": "785630",
      "Fulbari B.O": "785630",
      "Jalukonibari B.O": "785630",
      "Tipomia B.O": "785630",
      "Titabor Mohimabari B.O": "785630",
      "Bamunpukhuri B.O": "785683",
      "Robigaon B.O": "785683",
      "Teteliguri B.O": "785683",
      "Charaibahi B.O": "785616",
      "Chungi B.O": "785616",
      "Tekelagaon B.O": "785616",
      "Kukurachowa B.O": "785636",
      "Seleng Lawjan B.O": "785636",
      "Boloma B.O": "785112",
      "Bormathauri B.O": "785112",
      "Jakharia B.O": "785112",
      "Teok Rajabari B.O": "785112",
      "Uttar Dulia B.O": "785112",
      "Sodial Kochari Gaon B.O": "785630",
      "Bhuyanhat B.O": "785680",
      "Kawaimari Gohaingaon B.O": "785683",
      "Amtoll Chintamoni B.O": "785682",
      "Bhogamukh B.O": "785682",
      "Jelengitup B.O": "785682",
      "Lahowal B.O": "785682",
      "Japichajia B.O": "785636",
      "Majnoi B.O": "785636",
      "Bejorchiga B.O": "785112",
      "Dulakhoria B.O": "785112",
      "Jhanjimukh B.O": "785112",
      "Majkuri B.O": "785112",
      "Ouguri Missing B.O": "785112",
      "Baruajan B.O": "785630",
      "Madhapur B.O": "785630",
      "Rongajan B.O": "785630",
      "Bonai B.O": "785683",
      "Dhalajan B.O": "785616",
      "Melamati B.O": "785632",
      "Gabharu Konwargaon B.O": "785636",
      "Namsisu B.O": "785636",
      "Jogduar B.O": "785112",
      "Koliapani B.O": "785112",
      "Mudoijan Tiniali B.O": "785112",
      "Morangaon B.O": "785630",
      "Titabor Tiniali B.O": "785630",
      "Jhanji Hah Chara B.O": "785683",
      "Pathalial B.O": "785683",
      "Itakhuli B.O": "785007",
      "Parbatia B.O": "785006",
      "Tilikiaam B.O": "785006",
      "Dahotia B.O": "785006",
      "Bailunggaon B.O": "785107",
      "Charighoria B.O": "785108",
      "Namdeori B.O": "785108",
      "Kachukhat B.O": "785633",
      "Nagadhuli B.O": "785633",
      "Sycotta B.O": "785633",
      "Hulalbari B.O": "785700",
      "Kopradhara B.O": "785700",
      "Meleng B.O": "785634",
      "Pulibor B.O": "785006",
      "Dharigaon B.O": "785107",
      "Rajoi B.O": "785107",
      "Alengmora B.O": "785108",
      "Barchapori Khakanguri B.O": "785108",
      "Koliani B.O": "785108",
      "Takaruchuk B.O": "785108",
      "Bandor Chaliha B.O": "785633",
      "Desoinagar B.O": "785015",
      "Gorokhiadol B.O": "785015",
      "Meleng Te B.O": "785700",
      "Doklongia B.O": "785634",
      "Chungi Lahing B.O": "785635",
      "Lakhibari B.O": "785635",
      "Ujani Rajabari B.O": "785635",
      "Murmuria B.O": "785704",
      "Birina Shayek B.O": "785632",
      "Nagajanka B.O": "785634",
      "Namrupia B.O": "785634",
      "Bajalani Kohar B.O": "785009",
      "Balijan Te B.O": "785635",
      "Fechual B.O": "785635",
      "Gohainbari B.O": "785635",
      "Khatisona B.O": "785635",
      "Lahinggaon B.O": "785635",
      "Mogroigaon B.O": "785635",
      "Morongial B.O": "785635",
      "Bogargaon B.O": "785632",
      "Hatigarh B.O": "785007",
      "Charingia B.O": "785006",
      "Sundarpur B.O": "785107",
      "Bahphola B.O": "785108",
      "Bahoni B.O": "785633",
      "Dhekorgorah B.O": "785015",
      "Dhekiakhowa B.O": "785700",
      "Meleng Grant B.O": "785635",
      "Naginijan B.O": "785635",
      "Chakial B.O": "785632",
      "Bor Ahom Kathani B.O": "785006",
      "Panichokua B.O": "785006",
      "Dewangaon B.O": "785107",
      "Kakajan Duliagaon B.O": "785107",
      "Kamarkhatowal B.O": "785107",
      "Pirakota B.O": "785107",
      "Malowpathar B.O": "785108",
      "Nahatia B.O": "785108",
      "Fakalapather B.O": "785111",
      "Purani Gohaingaon B.O": "785111",
      "Bhogdaimukh S.O": "785001",
      "Dhalarsatra S.O": "785001",
      "Kakilamukh S.O": "785108",
      "Khorikotia S.O": "785633",
      "Ongc Jorhat S.O": "785704",
      "Jorhat Engg College S.O": "785007",
      "Kakajan S.O": "785107",
      "Lahdoigarh Chariali S.O": "785700",
      "Titabor S.O": "785630",
      "Assam Agriculture University S.O": "785013",
      "Bahana S.O": "785101",
      "Borholla S.O": "785631",
      "Chengeli Gaon S.O": "785010",
      "Cinnamara S.O": "785008",
      "Gatanga S.O": "785616",
      "Nakachari S.O": "785635",
      "Neamatighat S.O": "785111",
      "Purana Titabor S.O": "785632",
      "Rajabari S.O": "785014",
      "Selenghat S.O": "785636",
      "Teok S.O": "785112",
      "Tamulichiga S.O": "785682",
      "Barbheta S.O": "785004",
      "Garali S.O": "785001",
      "Jorhat Reserch Lab S.O": "785006",
      "Korokatoly S.O": "785015",
      "Macharhat S.O": "785001",
      "Mariani S.O": "785634",
      "Na Ali Dhekiajuli S.O": "785009",
      "Tarajan S.O": "785001",
      "Jorhat H.O": "785001"
    },
    "TINSUKIA": {
      "Adarshgaon B.O": "786174",
      "Inthemgaon B.O": "786174",
      "Kathalguri B.O": "786174",
      "Hatighuli B.O": "786154",
      "Megela B.O": "786154",
      "Pakharijan B.O": "786146",
      "Bordoloinagar B.O": "786156",
      "Dangrigaon B.O": "786156",
      "Khetopathergaon B.O": "786148",
      "Laika B.O": "786147",
      "Limbuguri B.O": "786147",
      "Aroimuria B.O": "786154",
      "Sripuria Bengali Gaon B.O": "786145",
      "Sarudhadum B.O": "786156",
      "Challet B.O": "786179",
      "Laipuli B.O": "786183",
      "Barmajan B.O": "786174",
      "Amguri B.O": "786160",
      "Chikarajan B.O": "786160",
      "Hollong Gutibari B.O": "786160",
      "Khamti Gowali B.O": "786147",
      "Chalihanagar B.O": "786146",
      "Kordoiguri B.O": "786156",
      "Laupati B.O": "786156",
      "Buraburi Than B.O": "786157",
      "Islampur B.O": "786157",
      "3 No Borbil B.O": "786171",
      "Baghbari Gaon B.O": "786189",
      "Balijan T.E. B.O": "786601",
      "Bishnupur B.O": "786188",
      "Bormuchai B.O": "786152",
      "Chellenguri B.O": "786152",
      "Dirak Maithong B.O": "786152",
      "Kachari Maithong B.O": "786152",
      "Kailash Pur B.O": "786152",
      "Kashijan B.O": "786152",
      "Navajyoti B.O": "786152",
      "Kukuremara B.O": "786158",
      "Long Gaon B.O": "786182",
      "Mullang B.O": "786182",
      "Tirap B.O": "786182",
      "Udai Pur B.O": "786182",
      "Alubari B.O": "786181",
      "Borgolai B.O": "786181",
      "Dibong B.O": "786181",
      "Ketetong B.O": "786181",
      "Baruahola B.O": "786183",
      "Balijan B.O": "786171",
      "Bogapani B.O": "786171",
      "Powai B.O": "786171",
      "Bordubi Te B.O": "786151",
      "Dohotiagaon B.O": "786151",
      "Koomsang B.O": "786151",
      "Dihingia Gaon B.O": "786192",
      "Bisfootia B.O": "786601",
      "Rampur B.O": "786188",
      "Borali B.O": "786152",
      "Tinali Nowgong B.O": "786152",
      "Tonganabazar B.O": "786152",
      "Natun Balijan B.O": "786158",
      "Kumchai B.O": "786182",
      "Lekhapani B.O": "786182",
      "Ashok Nagar B.O": "786170",
      "Langkashi B.O": "786170",
      "Agbandha Bengali Gaon B.O": "786187",
      "Lamagaon B.O": "786181",
      "Kukurekhowa B.O": "786183",
      "Purani Pukhuri B.O": "786174",
      "Arunodaya B.O": "786160",
      "Barhullung B.O": "786160",
      "Gobarbheti B.O": "786160",
      "Hahkhati B.O": "786154",
      "Kadamoni B.O": "786145",
      "Lohari B.O": "786146",
      "Netaji Road B.O": "786159",
      "Gakhirbheti B.O": "786156",
      "Lainagaon B.O": "786156",
      "Santipur B.O": "786150",
      "Gellapukhuri B.O": "786126",
      "Santipur Bazar B.O": "786157",
      "Golai B.O": "786171",
      "Lakhipather B.O": "786171",
      "Nazirating B.O": "786171",
      "Gahoripam B.O": "786183",
      "Ulup Gaon B.O": "786181",
      "Barchapri B.O": "786183",
      "Kanjikhowa B.O": "786183",
      "Tingrai B.O": "786171",
      "Samdang B.O": "786190",
      "Bisagaon B.O": "786182",
      "Borgaon B.O": "786170",
      "Amarpur B.O": "786157",
      "Bhimpathar B.O": "786171",
      "Dhekiajan B.O": "786171",
      "Dighal Tarrang B.O": "786151",
      "Kakojan B.O": "786151",
      "Rupbon B.O": "786151",
      "Laklapathar B.O": "786188",
      "Bordirak B.O": "786152",
      "Talpathar B.O": "786152",
      "Tonganagaon B.O": "786152",
      "Hamuk Jan B.O": "786182",
      "Ledo Tikok B.O": "786182",
      "Makumkilla B.O": "786187",
      "Margherita New Colony B.O": "786181",
      "Hijiguri S.O": "786192",
      "Hoogrijan S.O": "786601",
      "Ledo S.O": "786182",
      "Panitola S.O": "786183",
      "Pengri S.O": "786174",
      "Prakash Bazar S.O": "786125",
      "Sadiya S.O": "786155",
      "Saikhowaghat S.O": "786154",
      "Senairam Bazar S.O": "786125",
      "Sripuria S.O": "786145",
      "Talap S.O (Tinsukia)": "786156",
      "Digboi Charali S.O": "786171",
      "Digboi S.O": "786171",
      "Doom Dooma S.O": "786151",
      "Hansara S.O": "786190",
      "Kundil S.O": "786158",
      "Rangagora S.O": "786147",
      "Rupaisiding S.O": "786153",
      "Tipong S.O": "786179",
      "Chapakhowa S.O": "786157",
      "Dinjan S.O": "786189",
      "Kakapathar S.O": "786152",
      "Makum Junction S.O": "786170",
      "Makum Pathar S.O": "786187",
      "Parbotia S.O": "786125",
      "Sukriting S.O": "786159",
      "Barhapjan S.O": "786150",
      "Borguri S.O": "786126",
      "Durgabari S.O": "786125",
      "Jagun S.O": "786188",
      "Jubilee Digboi S.O": "786173",
      "Margherita S.O": "786181",
      "Muliabari S.O": "786171",
      "Phillobari S.O": "786160",
      "Sukhanpukhuri S.O": "786146",
      "Monkhooli S.O.": "786148",
      "Tinsukia H.O": "786125"
    },
    "KARBI ANGLONG": {
      "Pub Silputa B.O": "782482",
      "Shyampathar B.O": "782482",
      "Silputa Tiniali B.O": "782482",
      "Tarabasa B.O": "782482",
      "Teteliguri B.O": "782482",
      "Udali No 1 B.O": "782482",
      "Vitorkaliani B.O": "782490",
      "Chakihola B.O": "782490",
      "Golaibasti B.O": "782480",
      "Hidipi B.O": "782480",
      "Kailajan B.O": "782480",
      "Karagaon B.O": "782480",
      "Khatkhati B.O": "782480",
      "Kuligaon B.O": "782480",
      "Morakordoiguri B.O": "782480",
      "Neparpatty B.O": "782470",
      "Rangapahar Siding B.O": "782470",
      "Tengelijan B.O": "782470",
      "Rongkhelon B.O": "782462",
      "Duarbamuni B.O": "782441",
      "Kajesara Matikhola B.O": "782441",
      "Langlakso B.O": "782441",
      "Parakhowa Bazar B.O": "782441",
      "Samelangso B.O": "782441",
      "Sildharampur B.O": "782441",
      "Uttar Borbil B.O": "782481",
      "Kachupukhuri B.O": "782482",
      "Balipathar B.O": "782470",
      "Diphu Bazar B.O": "782462",
      "Disama B.O": "782462",
      "Lurulangso B.O": "782462",
      "Phanglangso B.O": "782462",
      "Baghpani B.O": "782441",
      "Bheleoghat B.O": "782441",
      "Danghap B.O": "782441",
      "Wirwar B.O": "782441",
      "Baligaon Tiniali B.O": "782481",
      "Dakhin Dighalipar B.O": "782481",
      "Eradighalpani B.O": "782481",
      "Hidibonglong B.O": "782481",
      "Amlakhi Bazar B.O": "782461",
      "Kheronigaon B.O": "782461",
      "Bargaon B.O": "782425",
      "Disobai B.O": "782482",
      "Langbangdingpi B.O": "782482",
      "Deihari B.O": "782490",
      "Dillai B.O": "782480",
      "Gautambasti B.O": "782480",
      "Daldali B.O": "782470",
      "Dwajungphang B.O": "782470",
      "Dewanbasti B.O": "782462",
      "Cherakani B.O": "782441",
      "Dentaghat B.O": "782441",
      "Panjuri B.O": "782441",
      "Amonigaon B.O": "782481",
      "Bobilgaon B.O": "782481",
      "Panditghat B.O": "782481",
      "Rajapathar B.O": "782481",
      "Barlongpher B.O": "782447",
      "Mahendijua B.O": "782461",
      "Lorenthepi B.O": "782482",
      "Samaguri Bazar B.O": "782482",
      "Bogijan B.O": "782490",
      "Jongpha B.O": "782490",
      "Deithor B.O": "782480",
      "Dillai Parbat B.O": "782480",
      "Laharijan B.O": "782480",
      "Sarihajan B.O": "782480",
      "Deopani B.O": "782470",
      "Japrajan B.O": "782470",
      "Baghmari B.O": "782462",
      "Dilaji B.O": "782462",
      "Rengkimi Village B.O": "782462",
      "Biswanathpathar B.O": "782441",
      "Langhin Manikpur B.O": "782441",
      "Langhin Tiniali B.O": "782441",
      "Padumpukhuri B.O": "782441",
      "Phulani B.O": "782441",
      "Okrang B.O": "782481",
      "Palakamati B.O": "782481",
      "Rongkut B.O": "782481",
      "Langcholiet B.O": "782447",
      "Nailalung B.O": "782447",
      "Longnit B.O": "782461",
      "Rongplimplam B.O": "782461",
      "Kathterongaon B.O": "782136",
      "Bokajan S.O": "782480",
      "Manja S.O": "782461",
      "Bokajan C F S.O": "782490",
      "Dhansripar S.O": "782470",
      "Bakalighat S.O": "782482",
      "Howraghat S.O": "782481",
      "Diphu Govt.College S.O": "782462",
      "Dokmaka S.O": "782441",
      "Diphu H.O": "782460"
    },
    "HOJAI": {
      "Golaghatiabasti B.O": "782435",
      "Nandapur Chariali B.O": "782435",
      "Dumaihagi Dapara B.O": "782428",
      "Garukhunda B.O": "782428",
      "Radhanagar B.O": "782429",
      "Lachit Pathar B.O": "782446",
      "Lamsakhang B.O": "782446",
      "Lankeswarigrant B.O": "782446",
      "Pub Lumding Bazar B.O": "782447",
      "Bhalukmari B.O": "782442",
      "Borboha B.O": "782442",
      "Jurapukhuri B.O": "782442",
      "Kaki Chalchali B.O": "782442",
      "Amtola B.O": "782435",
      "Dimrupar B.O": "782435",
      "Sibpur B.O": "782429",
      "Anneria B.O": "782446",
      "Fultoli Bazar B.O": "782446",
      "Pipal Pukhuri B.O": "782446",
      "Sambari Dagaon B.O": "782446",
      "Sankarpur B.O": "782446",
      "Teralangso B.O": "782446",
      "Udalani Bazar B.O": "782446",
      "Watijor B.O": "782446",
      "Samarail B.O": "782439",
      "Choudhury Bazar B.O": "782439",
      "Kapashbari B.O": "782445",
      "Hojai R.S. B.O": "782435",
      "Siliguri B.O": "782435",
      "Singaribasti B.O": "782435",
      "Debasthan Bazar B.O": "782481",
      "Jungle Block B.O": "782428",
      "Derapathar B.O": "782446",
      "Gosaigaon B.O": "782446",
      "Mailoo Bazar B.O": "782446",
      "Nakhuti Bazar B.O": "782446",
      "Thaisupar B.O": "782446",
      "Khengergaon B.O": "782447",
      "Lumding Bazar B.O": "782447",
      "Charing B.O": "782439",
      "Karayani B.O": "782439",
      "Barangatoli Bazar B.O": "782445",
      "Kaki B.O": "782442",
      "Gopalnagar B.O": "782435",
      "Komorakata B.O": "782435",
      "Padumpukhuri B.O": "782435",
      "Telibasti B.O": "782435",
      "Borbali B.O": "782481",
      "Barapatia B.O": "782428",
      "Hawaipur B.O": "782446",
      "Kharikhana B.O": "782446",
      "Laskarpathar B.O": "782446",
      "Mainapur Bazar B.O": "782446",
      "Tiniali Bazar B.O": "782446",
      "Harlongpher B.O": "782447",
      "Taralangso No 1 B.O": "782447",
      "Barhawar B.O": "782439",
      "Dighaljar B.O": "782439",
      "Ambari B.O": "782445",
      "Joynagar Madrassa B.O": "782445",
      "Azarbari Krishna Nagar B.O": "782442",
      "Purana Kaki B.O": "782442",
      "Changmaji B.O": "782440",
      "Koroiguri B.O": "782440",
      "Hindu Block B.O": "782440",
      "Modertoli B.O": "782440",
      "Jamunamukh S.O": "782428",
      "Jogijan Bazar S.O": "782429",
      "Lumding S.O": "782447",
      "Sankardev Nagar S.O": "782442",
      "Daboka S.O": "782440",
      "Hojai Bazar S.O": "782435",
      "Hojai S.O": "782435",
      "Murazar Bazar S.O": "782439",
      "Lanka S.O (Nagaon)": "782446",
      "Nilbagan S.O": "782445"
    },
    "BONGAIGAON": {
      "Balapara B.O": "783388",
      "Ambari B.O": "783384",
      "B.S.Gram B.O": "783384",
      "Barigaon B.O": "783384",
      "Deohati B.O": "783384",
      "Santoshpur B.O": "783384",
      "Tilpukhuri B.O": "783384",
      "Chaprakata B.O": "783380",
      "Chipansila B.O": "783380",
      "Dongaigaon B.O": "783380",
      "Khagrabari B.O": "783380",
      "Chalantapara B.O": "783388",
      "Koreya B.O": "783388",
      "Lengtisinga B.O": "783384",
      "Madrasapara B.O": "783384",
      "Nararbhita B.O": "783384",
      "Nayagaon B.O": "783384",
      "Chakapara B.O": "783380",
      "North Baitamari B.O": "783380",
      "Popragaon B.O": "783380",
      "Majharalga B.O": "783388",
      "Dumerguri B.O": "783384",
      "Golapara B.O": "783384",
      "Kushbari B.O": "783384",
      "Lalmati B.O": "783384",
      "Rangapani B.O": "783384",
      "Topgaon B.O": "783384",
      "Mulagaon B.O": "783380",
      "Dumuria Piradhara B.O": "783384",
      "Pachania B.O": "783382",
      "Kokila B.O": "783392",
      "Numberpara B.O": "783392",
      "Bhotguti Huramara B.O": "783383",
      "Kheluapara B.O": "783371",
      "Kirtanpara B.O": "783384",
      "Latibari B.O": "783384",
      "Nayasatra B.O": "783384",
      "Chapaguri B.O": "783380",
      "Khwaja Dolaigaon B.O": "783380",
      "Natunpara B.O": "783380",
      "Barjana B.O": "783382",
      "Adlaguri B.O": "783392",
      "Chakihali B.O": "783392",
      "Chakla B.O": "783392",
      "Simlaguri B.O": "783381",
      "Khagarpur B.O": "783383",
      "Sidalsati B.O": "783383",
      "Kayetpara B.O": "783389",
      "Malegarh B.O": "783382",
      "Aolaguri B.O": "783392",
      "Nowapara B.O": "783392",
      "Sonaikhola B.O": "783391",
      "Ghilaguri B.O": "783383",
      "Dompara B.O": "783392",
      "Nowagaon B.O": "783392",
      "Salabila Bazar B.O": "783392",
      "Garugaon B.O": "783383",
      "Kakaijana B.O": "783383",
      "Jogighopa S.O": "783382",
      "Manikpur S.O (Bongaigaon)": "783392",
      "North Bongaigaon S.O": "783380",
      "New Bongaigaon S.O": "783381",
      "Bongaigaon S.O": "783380",
      "Patiladaha S.O": "783391",
      "Salmara North S.O": "783383",
      "Boitamari S.O": "783389",
      "Barpara S.O": "783380",
      "A.P.Mill S.O": "783388",
      "Abhayapuri S.O": "783384"
    },
    "UDALGURI": {
      "Aminpara B.O": "784514",
      "Batabari B.O": "784507",
      "Khuchurabari B.O": "784507",
      "Mahalia Para B.O": "784507",
      "Shillongkhuti B.O": "784508",
      "Garaibari B.O": "784509",
      "Kajiamati B.O": "784509",
      "Khowrang B.O": "784509",
      "Khuchurabari Habigaon B.O": "784509",
      "Ekrabari B.O": "784514",
      "Borjhar Bazar B.O": "784114",
      "Dhansiri Bazar B.O": "784114",
      "Bengbari B.O": "784523",
      "Dalong Ghat B.O": "784528",
      "Mechakapukhuri B.O": "784521",
      "Palahgarh B.O": "784521",
      "Chamuapara B.O": "784521",
      "Bandarguri B.O": "784509",
      "Nalkhamara B.O": "784509",
      "Dafalapota B.O": "784114",
      "Goriajhar B.O": "784523",
      "Kachubilhat B.O": "784523",
      "Ratanpur B.O": "784523",
      "Maugaon B.O": "784528",
      "Nashanshali B.O": "784528",
      "Sikari Banglow B.O": "784528",
      "Rowta Chariali B.O": "784508",
      "Murmela B.O": "784521",
      "Purandia B.O": "784521",
      "Barjalah B.O": "784521",
      "Ranipukhuri B.O": "784525",
      "Barigoan B.O": "784510",
      "No.1 Amjuli B.O": "784510",
      "Tamulbari B.O": "784510",
      "Chengapathar B.O": "784525",
      "Gerua Bazar B.O": "784514",
      "Pathakpur B.O": "784507",
      "No.2 Saikia Chuburi B.O": "784114",
      "Jamuguri B.O": "784114",
      "Bhuyankhat B.O": "784528",
      "Dhopguri B.O": "784528",
      "Bhalukmari B.O": "784508",
      "Barnagram B.O": "784509",
      "Mazkhuti B.O": "784509",
      "Thana Udalguri B.O": "784509",
      "Mohanpur B.O": "784509",
      "No.2 Barangajuli B.O": "784527",
      "No.3 Rajagarh B.O": "784527",
      "Shamtilla B.O": "784190",
      "Kalikhola B.O": "784526",
      "Ghograbazar B.O": "784524",
      "Lakhimpur B.O": "784525",
      "Majorchuba B.O": "784525",
      "Bholabari B.O": "784525",
      "Tengabari B.O": "784525",
      "Bogpuri B.O": "784522",
      "Malmura B.O": "784522",
      "Nichilamari B.O": "784522",
      "Sastrapara B.O": "784510",
      "Barampur Kalaigaon B.O": "784525",
      "Barkalachowka B.O": "784525",
      "Bhekulikanda B.O": "784525",
      "Baralakhat B.O": "784522",
      "Barangabari B.O": "784522",
      "Rangajuli B.O": "784522",
      "Bahmola B.O": "784522",
      "Kuhiarkuchi B.O": "784522",
      "Panishali B.O": "784522",
      "Thakuriapara B.O": "784522",
      "Bongaligaon B.O": "784113",
      "Khagrabari B.O": "784527",
      "Suklai B.O": "784527",
      "Bhairakunda B.O": "784513",
      "Pachim Patla B.O": "784526",
      "Ambagan B.O": "784510",
      "BATAKUCHI B.O.": "784510",
      "Ajodhyapur B.O": "784524",
      "Teliapara B.O": "784524",
      "Kabir Ali B.O": "784525",
      "Bhergaon B.O": "784522",
      "Jalukbari B.O": "784522",
      "Bholaguri B.O": "784522",
      "Dalakati Borobazar B.O": "784113",
      "Udalguri S.O": "784509",
      "Bhakatpara S.O": "784190",
      "Harisinga S.O": "784510",
      "Kopati S.O": "784113",
      "Mazbat S.O": "784507",
      "Rowta S.O": "784508",
      "Dimakuchi S.O": "784526",
      "Hatigarh S.O (Darrang": "784524",
      "Atterikhat S.O": "784527",
      "Kalaigaon S.O": "784525",
      "Khoirabari S.O": "784522",
      "Orang S.O": "784114",
      "Panerihat S.O": "784523",
      "Purani Tangla S.O": "784528",
      "Tangla S.O": "784521",
      "Sapangaon S.O": "784513"
    },
    "DARRANG": {
      "Bechimari B.O": "784514",
      "Dipila Chowka B.O": "784144",
      "Hatimara B.O": "784144",
      "Daipam B.O": "784514",
      "Padupuri Mazgaon B.O": "784514",
      "Silbori B.O": "784114",
      "Barampur B.O": "784144",
      "Dighirpar B.O": "784144",
      "Bordolguri B.O": "784145",
      "Hazarikapara B.O": "784145",
      "Marowachowka B.O": "784145",
      "Sanowa B.O": "784145",
      "Chamuapara B.O": "784529",
      "Dahinagaon B.O": "784529",
      "Ramhari Chowka B.O": "784529",
      "Jangalpara B.O": "784116",
      "Chamatiapara B.O": "784147",
      "Naharbari B.O": "784147",
      "Kenduguri B.O": "784148",
      "Niz Kharupetia B.O": "784115",
      "Punia No.1 B.O": "784115",
      "Santipukhuri B.O": "784144",
      "Khandajan B.O": "784145",
      "Kuruwa B.O": "784145",
      "Chamuakhat B.O": "784190",
      "Mangalanagar B.O": "784529",
      "Rajghat B.O": "784529",
      "Rangamati B.O": "784529",
      "Barigaon No.2 B.O": "784147",
      "Burargarh B.O": "784147",
      "Outola B.O": "784525",
      "Galandi B.O": "784115",
      "Chengeliajhar B.O": "784145",
      "Dhekipara B.O": "784145",
      "Dholpur B.O": "784145",
      "Ganesh Kunwari B.O": "784145",
      "Satkhali B.O": "784145",
      "Barbagan B.O": "784190",
      "Aulachowka B.O": "784529",
      "Jaljali B.O": "784529",
      "Jonaramchowka B.O": "784529",
      "Chakrabasti B.O": "784116",
      "No.2 Sialmari B.O": "784116",
      "Pati Darrang B.O": "784147",
      "Balabari B.O": "784146",
      "Minapara B.O": "784146",
      "Mudoibari B.O": "784146",
      "Andherighat B.O": "784148",
      "Burha B.O": "784148",
      "Ghansimali B.O": "784115",
      "Kharupetiaghat Bazar B.O": "784115",
      "Bajanapathar B.O": "784145",
      "Byaspara B.O": "784145",
      "Garukhuti B.O": "784145",
      "Maroi B.O": "784145",
      "Muslimghopa B.O": "784145",
      "Howli Mohanpur B.O": "784529",
      "Burhi Nagar B.O": "784147",
      "Deodhani Ghat B.O": "784147",
      "Hengalpara B.O": "784148",
      "Tengara B.O": "784148",
      "Bherbheribill B.O": "784525",
      "Kunwari Pukhuri B.O": "784115",
      "Dalgaon S.O": "784116",
      "Chapaichowka S.O": "784529",
      "Dhula S.O": "784146",
      "Pathorighat S.O": "784144",
      "Deomornoi S.O": "784147",
      "Duni S.O (Darrang": "784148",
      "Lalpul Bazar S.O": "784514",
      "Kharupetiaghat S.O": "784115",
      "Sipajhar S.O": "784145",
      "Mangaldoi H.O": "784125"
    },
    "CHARAIDEO": {
      "Chalapather B.O": "785688",
      "Khaloighogora B.O": "785688",
      "Silakuti B.O": "785698",
      "Photikachowa B.O": "785670",
      "Batomora B.O": "785670",
      "Baruanagar B.O": "785692",
      "Nagahat B.O": "785692",
      "Moranjan B.O": "785673",
      "Moudumoni B.O": "785673",
      "Patsaku B.O": "785673",
      "Dholebagan B.O": "785686",
      "Bonomali B.O": "785689",
      "Desangpani B.O": "785689",
      "Mon Mohan Gaon B.O": "785689",
      "Kachumari B.O": "785670",
      "Rangoli B.O": "785670",
      "Baregaon B.O": "785692",
      "Bhogbari Kanugaon B.O": "785692",
      "Chotianaguri B.O": "785692",
      "Ghorajaan B.O": "785692",
      "Rahan B.O": "785692",
      "Chakalia B.O": "785673",
      "Dubba B.O": "785673",
      "Bekadolong B.O": "785690",
      "Namtola B.O": "785690",
      "Bishrampur B.O": "785670",
      "Longpotia B.O": "785692",
      "Towkok B.O": "785640",
      "Saru Mothura B.O": "785688",
      "Dichow Botua B.O": "785670",
      "Barbaruakhat B.O": "785692",
      "Dhuniapathar B.O": "785692",
      "Ouguri Shyam B.O": "785692",
      "Ujanikuri B.O": "785692",
      "Domar Dolong B.O": "785673",
      "Hologuri B.O": "785673",
      "Aideopukhuri B.O": "785690",
      "Bengenabari B.O": "785690",
      "Teokghat B.O": "785690",
      "Naphuk B.O": "785689",
      "Mothurapur B.O": "785689",
      "Nimonagarh B.O": "785689",
      "Bhalukaguri B.O": "785691",
      "Bharali Pukhuri B.O": "785691",
      "Borahigaon B.O": "785691",
      "Deepling B.O": "785691",
      "Kakotibari B.O": "785691",
      "Barpatra Te B.O": "785693",
      "Barua Chali B.O": "785693",
      "Changmai B.O": "785693",
      "Deopani  Habigaon B.O": "785693",
      "Maibella B.O": "785689",
      "Mahmora Balijan B.O": "785691",
      "Pohuchungi Pather B.O": "785691",
      "Ronga Bam Habi B.O": "785691",
      "Timon B.O": "785691",
      "Dillighat B.O": "785693",
      "Siloni Nagar B.O": "785693",
      "Korokani B.O": "785691",
      "Miripather B.O": "785691",
      "Teok Gaon B.O": "785691",
      "Lefera B.O": "785693",
      "Titlagarh Chariali B.O": "785693",
      "Borhat S.O": "785693",
      "Sonari S.O (Sibsagar)": "785690",
      "Bhojo S.O": "785691",
      "Lakowah S.O": "785688",
      "Lakwah R.S. S.O": "785698",
      "Moran S.O": "785669",
      "Moranhat S.O": "785670",
      "Sapekhati S.O": "785692",
      "Sepon S.O": "785673",
      "Suffry S.O": "785689"
    },
    "SIVASAGAR": {
      "Chaulkara B.O": "785667",
      "Nakatani B.O": "785667",
      "Santipur B.O": "785667",
      "Mohkhuti B.O": "785669",
      "Barua Ali B.O": "785684",
      "Baulipukhuri Sensua B.O": "785684",
      "Chetia Gaon B.O": "785684",
      "Bihubar Te B.O": "785685",
      "Bortol B.O": "785685",
      "Chakimukh B.O": "785685",
      "Chepangani B.O": "785685",
      "Bakhor Bengena B.O": "785674",
      "Bokota Chand Bessa B.O": "785674",
      "Charubhanga Dihingia B.O": "785674",
      "Nongalmora  Tiniali B.O": "785674",
      "Bogidole B.O": "785697",
      "Dhai Ali B.O": "785697",
      "Duliagaon B.O": "785697",
      "Gohaingaon B.O": "785697",
      "Messagarh B.O": "785697",
      "Meteka B.O": "785697",
      "Mithapukhuri B.O": "785697",
      "Namtial Pathar B.O": "785697",
      "Betbari B.O": "785640",
      "Nimaigarh Habi B.O": "785687",
      "Tengapukhuri B.O": "785686",
      "Bhitarual B.O": "785682",
      "Chintamoni B.O": "785682",
      "Khonamukh B.O": "785682",
      "Bhatiapar B.O": "785667",
      "Dikshu B.O": "785684",
      "Tiphuk B.O": "785684",
      "Bamunpukhuri B.O": "785685",
      "Gargaon B.O": "785685",
      "Panibill B.O": "785685",
      "Karigaon B.O": "785667",
      "Deorihabi Chakalia B.O": "785669",
      "Karchowa B.O": "785684",
      "Bauli Maidam B.O": "785685",
      "Dhitaipukhuri B.O": "785685",
      "Lakhimi Jan B.O": "785685",
      "Rajapool B.O": "785685",
      "Upper Nazira B.O": "785685",
      "Bam Rajabari B.O": "785671",
      "Tengaponia B.O": "785671",
      "Arjun Guri B.O": "785697",
      "Barhoiting B.O": "785697",
      "Khamon B.O": "785697",
      "Sukan Pukhuri B.O": "785697",
      "Koibarta Dolonigaon B.O": "785672",
      "Bihubar B.O": "785687",
      "Nagaon B.O": "785687",
      "Moutgaon B.O": "785686",
      "Ramugaon B.O": "785686",
      "Silasaku B.O": "785686",
      "Missajan B.O": "785684",
      "Na Pam Baruati B.O": "785684",
      "Namti Bamungaon B.O": "785684",
      "Namti Chariali B.O": "785684",
      "Namti Pathar B.O": "785684",
      "Deopani B.O": "785684",
      "Hudupara B.O": "785685",
      "Ligiripukhuri B.O": "785685",
      "Mackeypur B.O": "785685",
      "Maduri B.O": "785685",
      "Mezenga B.O": "785685",
      "Namati B.O": "785685",
      "Dihing Than B.O": "785671",
      "Dihingia Gaon B.O": "785671",
      "Gorbhanga B.O": "785671",
      "Paraliguri B.O": "785671",
      "Akhoi Phutia B.O": "785697",
      "Joirapar B.O": "785697",
      "Palengi B.O": "785672",
      "Pioli Pukhuri B.O": "785685",
      "Rajmao B.O": "785685",
      "Dihing Mukh B.O": "785671",
      "Samukjan B.O": "785671",
      "Amkotia B.O": "785697",
      "Baghshumout B.O": "785697",
      "Kenduguri B.O": "785697",
      "Charagua B.O": "785672",
      "Desanghat B.O": "785672",
      "Dhopabar B.O": "785687",
      "Gormur Miri Gaon B.O": "785687",
      "Ramaniali B.O": "785686",
      "Dopdhar B.O": "785681",
      "Halouating Grant B.O": "785681",
      "Lalimchiga B.O": "785680",
      "Morabazar B.O": "785680",
      "Hafaluting B.O": "785661",
      "Dehajan B.O": "785662",
      "Borbam Te B.O": "785680",
      "Chataichiga Kakotigaon B.O": "785680",
      "Nahat B.O": "785662",
      "Ailamukh B.O": "785664",
      "Nakhana B.O": "785664",
      "Athkhel B.O": "785696",
      "Khorahat B.O": "785662",
      "Konwar Dihingia B.O": "785662",
      "Banmukh B.O": "785663",
      "Betena B.O": "785663",
      "Chenimora B.O": "785663",
      "Dekhowmukh B.O": "785664",
      "Hatighuli B.O": "785664",
      "Kaliori B.O": "785664",
      "Khona Khokora B.O": "785664",
      "Silpukhuri B.O": "785664",
      "Jatakia B.O": "785666",
      "Khemdeo Pukhuri B.O": "785666",
      "Mogorahat B.O": "785666",
      "Namtial Gaon B.O": "785666",
      "Borahibari B.O": "785680",
      "Charingia  Pukhuri B.O": "785680",
      "Baruatigaon B.O": "785661",
      "Chamua Khanikar B.O": "785661",
      "Afala B.O": "785663",
      "Deogharia B.O": "785696",
      "Hatipoti Grant B.O": "785696",
      "Singibill B.O": "785696",
      "Bhadhara B.O": "785701",
      "Daya Chariali B.O": "785701",
      "Jhanji Jamuguri B.O": "785683",
      "Jorabari B.O": "785683",
      "Moranchiga B.O": "785683",
      "Rong Ghar Chariali B.O": "785665",
      "Rudrasagar B.O": "785665",
      "Nazira Dulakakharia B.O": "785696",
      "Cherekapar B.O": "785701",
      "Khelua B.O": "785701",
      "Singhaduar B.O": "785701",
      "Phulpanichiga B.O": "785683",
      "Charaimuria B.O": "785666",
      "Napam Bekajan B.O": "785682",
      "Baghjan Grant B.O": "785681",
      "Madhavnagar B.O": "785681",
      "Deoraja Maidum B.O": "785680",
      "Jalukgaon B.O": "785680",
      "Majbari B.O": "785680",
      "SAMAGURI BO": "785680",
      "Udaypur B.O": "785662",
      "Demowmukh B.O": "785663",
      "Panbessa B.O": "785663",
      "Bharalua Tiniali B.O": "785664",
      "Komorajan B.O": "785664",
      "Teliadunga B.O": "785664",
      "Nogagaon B.O": "785701",
      "Chirakhunda B.O": "785666",
      "Sologuri B.O": "785666",
      "Baliaghat B.O": "785667",
      "Charing S.O": "785661",
      "Demow S.O": "785662",
      "Hahchara S.O": "785701",
      "Kaloogaon S.O": "785666",
      "Nemuguri S.O": "785674",
      "Amguri Haloating S.O": "785681",
      "Disangmukh S.O": "785663",
      "Geleky S.O": "785696",
      "Jhanji S.O": "785683",
      "ONGC Colony S.O": "785697",
      "Rajmai S.O": "785672",
      "Simaluguri S.O": "785686",
      "Namtidoll S.O": "785684",
      "Nitaipukhuri S.O": "785671",
      "Phukannagar S.O": "785640",
      "Santak S.O": "785687",
      "Amguri S.O": "785680",
      "Gaurisagar S.O": "785664",
      "Joysagar S.O": "785665",
      "Konwarpur S.O": "785667",
      "Nazira S.O": "785685",
      "Rongpurnagar S.O": "785640",
      "Sivasagar H.O": "785640"
    },
    "MARIGAON": {
      "Gandhibori B.O": "782103",
      "Khaplangkuchi B.O": "782103",
      "Baralimari B.O": "782121",
      "Geruagaon B.O": "782121",
      "Lengeribori B.O": "782121",
      "Pukarkata B.O": "782121",
      "Bamunbori B.O": "782103",
      "Sondoba B.O": "782121",
      "Dungarpar B.O": "782121",
      "Haloakanda B.O": "782121",
      "Toptola B.O": "782121",
      "Burgaon B.O": "782411",
      "Hatiamukh B.O": "782411",
      "Jagi B.O": "782411",
      "Jhargaon B.O": "782411",
      "Goroimari B.O": "782104",
      "Kachadhara Nakhanda B.O": "782104",
      "Amlighat B.O": "782413",
      "Nellie B.O": "782413",
      "Katanigaon B.O": "782127",
      "Satiantoli B.O": "782127",
      "Tengaguri B.O": "782127",
      "Goroimaripathar B.O": "782126",
      "Hahcharagaon B.O": "782126",
      "Lochanabori B.O": "782126",
      "Azarbari B.O": "782105",
      "Baghara B.O": "782105",
      "Barangani B.O": "782127",
      "Baribandha B.O": "782127",
      "Chetwaikhaitee B.O": "782127",
      "Doloigaon B.O": "782126",
      "Ghagua B.O": "782105",
      "Kapahera B.O": "782103",
      "Bangalpara B.O": "782105",
      "Damal B.O": "782105",
      "Komoraguri B.O": "782105",
      "Manipur B.O": "782105",
      "Natuagaon B.O": "782105",
      "Sarubori B.O": "782105",
      "Mikirbheta B.O": "782106",
      "Bangaldhara B.O": "782412",
      "Barkuloi B.O": "782411",
      "Buraburi B.O": "782411",
      "Khulagaon B.O": "782411",
      "Manaha Kacharigaon B.O": "782411",
      "Natun Bangalbori B.O": "782411",
      "Patrabori B.O": "782104",
      "Solmari Mikirgaon B.O": "782104",
      "Tokonabori B.O": "782104",
      "Killing Valley B.O": "782413",
      "Barbori B.O": "782127",
      "Dewaguri B.O": "782127",
      "Falihamari Pathar B.O": "782127",
      "Datialbori B.O": "782126",
      "Sahariagaon B.O": "782126",
      "Doloichuba B.O": "782105",
      "Karatipam B.O": "782105",
      "Gagalmari B.O": "782121",
      "Sandahkhaiti B.O": "782121",
      "Tarabori Kalsila Satra B.O": "782104",
      "Deosal B.O": "782413",
      "Dumkura Bazar B.O": "782127",
      "Jalakiabari B.O": "782127",
      "Sagunbahipathar B.O": "782126",
      "Salkati Pathar B.O": "782126",
      "Dighalbori B.O": "782105",
      "Udari B.O": "782105",
      "Barchala B.O": "782106",
      "Chabukdhara B.O": "782106",
      "Nagabandha B.O": "782106",
      "Silchung B.O": "782412",
      "Dayang Beloguri B.O": "782410",
      "Dongarbori B.O": "782410",
      "Nizdandua B.O": "782104",
      "Patidaya B.O": "782104",
      "Sukdal Sarubori B.O": "782104",
      "Garukhuti B.O": "782106",
      "Habibarangabari B.O": "782106",
      "Bhomoraguri B.O": "782106",
      "Ahatguri B.O": "782412",
      "Barpak B.O": "782411",
      "Kuranibori B.O": "782411",
      "Raja Mayang B.O": "782411",
      "Bhurbandha B.O": "782104",
      "Patuakata B.O": "782104",
      "Sapmarigaon B.O": "782104",
      "Lahorighat S.O": "782127",
      "Dharamtul S.O": "782412",
      "Jaluguti S.O": "782104",
      "Bhuragaon S.O": "782121",
      "Jagiroad S.O": "782410",
      "Morigaon S.O": "782105",
      "Charaibahi S.O": "782106",
      "Jagibhakatgaon S.O": "782411",
      "Kagajnagar S.O": "782413",
      "Moirabari S.O": "782126"
    },
    "DIMA HASAO": {
      "Topadisa B.O": "788820",
      "Christiankempai B.O": "788819",
      "Dihangi B.O": "788819",
      "Mailongdisha B.O": "788818",
      "Redzol B.O": "788818",
      "Bararkap B.O": "788107",
      "Lodikachari B.O": "788108",
      "Mupa B.O": "788832",
      "Kholjang B.O": "788830",
      "Laisang B.O": "788830",
      "Pangmoul B.O": "788830",
      "Tulpoi B.O": "788830",
      "Zion B.O": "788820",
      "Dibari B.O": "788819",
      "Dintharveng B.O": "788819",
      "Kanabasti B.O": "788819",
      "Michidui B.O": "788819",
      "Narsingwari B.O": "788819",
      "Bandarkhal B.O": "788818",
      "Leiri B.O": "788107",
      "Dautohaza B.O": "788830",
      "Hange B.O": "788830",
      "Laisang Bagan B.O": "788830",
      "Lasang B.O": "788830",
      "Hajang B.O": "788831",
      "Hazadisha B.O": "788831",
      "Haflo R.S. B.O": "788820",
      "Fengpui B.O": "788819",
      "Jatinga Tenali B.O": "788819",
      "Mulhoi B.O": "788819",
      "Sonpijang B.O": "788819",
      "Baro Mulkoi B.O": "788818",
      "Jatinga B.O": "788818",
      "Mauchar B.O": "788107",
      "Hatikhali B.O": "788832",
      "Mandardisha B.O": "788832",
      "Impui Hindu B.O": "788830",
      "Khognam B.O": "788830",
      "Vawngzawl B.O": "788830",
      "Longkhu B.O": "788931",
      "Panch Kilometer B.O": "788931",
      "Sangbar B.O": "788931",
      "Borolabang B.O": "788931",
      "Garampani B.O": "788931",
      "Govindanagar B.O": "788931",
      "Assam Quary B.O": "788931",
      "Bagetar B.O": "788820",
      "Electric Veng B.O": "788820",
      "Sarkari Bagan B.O": "788820",
      "Kalibari  3rd PWD Colony B.O": "788819",
      "Gunjung B.O": "788819",
      "Haflong Bazar B.O": "788819",
      "Kanaan B.O": "788819",
      "Santilla B.O": "788819",
      "Dittakcherra B.O": "788818",
      "Kharthang B.O": "788818",
      "Narainpur B.O": "788818",
      "Dezabra B.O": "788832",
      "Langting Hasin B.O": "788832",
      "Hangrum B.O": "788830",
      "Saran B.O": "788830",
      "Manigipur B.O": "788831",
      "Kaprey B.O": "788831",
      "Khejurbond B.O": "788831",
      "Simtuilong B.O": "788831",
      "Nablaidisha B.O": "788831",
      "Wardendisha B.O": "788831",
      "Haflong S.O": "788819",
      "Langting S.O": "788832",
      "Haflong Ptc S.O": "788820",
      "Maibong S.O": "788831",
      "Harengajao S.O": "788818",
      "Mahur S.O": "788830",
      "Umrangshu S.O": "788931"
    }
  },
  "UTTAR PRADESH": {
    "KANPUR NAGAR": {
      "NDC Kanpur": "208001",
      "Majhawan BO": "209214",
      "Kasigaon BO": "208021",
      "Sanigawan BO": "208021",
      "Hardauli BO": "209214",
      "Ramaipur BO": "209214",
      "Baripal BO": "209206",
      "Shambuhi BO": "209206",
      "Maitha BO": "209307",
      "Maitha RS BO": "209307",
      "Sapai BO": "209214",
      "Sirhi Itra BO": "209214",
      "Mardanpur BO": "209305",
      "Kheora BO": "208017",
      "Pachor BO": "209217",
      "Tikra BO": "209217",
      "Aranjhami BO": "209401",
      "Baraigarh BO": "209401",
      "Subhauli BO": "209402",
      "Tilsahari BO": "209402",
      "Karbigvan BO": "209402",
      "Dehli Ujagar BO": "209214",
      "Deosarh BO": "209214",
      "Udaipur BO": "209214",
      "Bhimsen BO": "209305",
      "Birhar BO": "209209",
      "Pahewa BO": "209209",
      "Pasikhera BO": "209209",
      "Anupur BO": "209206",
      "Behta Bujurg BO": "209209",
      "Baikunthpur BO": "209217",
      "Bausar BO": "209401",
      "Kudani BO": "209401",
      "Nasra BO": "209401",
      "Palhepur BO": "209401",
      "Semarjhal BO": "209401",
      "Bisayakpur BO": "209304",
      "Jugrajpur BO": "209304",
      "Parsauli BO": "209304",
      "Rania BO": "209304",
      "Jarkala BO": "209402",
      "Kamalpur BO": "209402",
      "Maharajpur BO": "209402",
      "Phuphuwar BO": "209402",
      "Parasadepur BO": "209402",
      "Bheoli BO": "209402",
      "Pipergaon BO": "208021",
      "Taudhakpur BO": "208021",
      "Maholi BO": "208001",
      "Bharu BO": "209214",
      "Targaonw BO": "209308",
      "Tilsada BO": "209308",
      "Tejpur BO": "209308",
      "Ratanpur BO": "209206",
      "Chaurai BO": "209214",
      "Gayatri Seedh Peeth Khadeshar BO": "209214",
      "Jamu BO": "209214",
      "Kathara BO": "209214",
      "Katherua BO": "209214",
      "Bhauti Pratappur BO": "209305",
      "Itra BO": "209217",
      "Pem BO": "209217",
      "Bithoor BO": "209217",
      "Gazipur BO": "209401",
      "Rasulpur Umra BO": "209401",
      "Sarh BO": "209401",
      "Bhadrsa BO": "209402",
      "Salempur BO": "209402",
      "Prempur Badagaon BO": "209402",
      "Mahua Gaon BO": "209402",
      "Sajeti BO": "209206",
      "Bauhar BO": "209209",
      "Barnaow BO": "209308",
      "Padari Lalpur BO": "209308",
      "Shambhuaa BO": "209308",
      "Sarai Gadewa BO": "209203",
      "Kathongar BO": "208021",
      "Chhatarpur BO": "209205",
      "Kadari Champatpur BO": "209214",
      "Kaindha BO": "209214",
      "Senpara Paschim BO": "209305",
      "Tatya Ganj BO": "209217",
      "Amour BO": "209401",
      "Behta Gambhirpur BO": "209401",
      "Gopalpur BO": "209401",
      "Harchandkhera BO": "209401",
      "Pali Bhogipur BO": "209401",
      "Sawaijpur BO": "209401",
      "Binour BO": "209304",
      "Fatehpur Roshnai BO": "209304",
      "Raipur Kukhat BO": "209304",
      "Hathigaon BO": "209402",
      "Purwameer BO": "209402",
      "Kulgaon BO": "209402",
      "Rooma BO": "209402",
      "Durooli BO": "209121",
      "Jahangirabad BO": "209308",
      "Umri BO": "209209",
      "Surar BO": "209307",
      "Bachhna BO": "209202",
      "Bedi Alipur BO": "209202",
      "Kamsaan BO": "209202",
      "Makanpur BO": "209202",
      "Tisti BO": "209202",
      "Rautapur Kalan BO": "209203",
      "Tari Pathakpur BO": "209203",
      "Akbarpur Birbal BO": "209206",
      "Dhamna Bujurg BO": "209206",
      "Harbansh Pur BO": "209206",
      "Kohara BO": "209206",
      "Kuwankhera BO": "209206",
      "Rawatpur Chaudhriyan BO": "209209",
      "Baranda BO": "209202",
      "Devha BO": "209202",
      "Gajna BO": "209202",
      "Kakwan BO": "209202",
      "Bakothi BO": "209202",
      "Rahimpur Bisdhan BO": "209202",
      "Gabdaha BO": "209203",
      "Jajpur BO": "209206",
      "Kaitha BO": "209206",
      "Nauranga BO": "209206",
      "Bhool BO": "209307",
      "Dharmangadpur BO": "209206",
      "Aakeen BO": "209202",
      "Anaie BO": "209202",
      "Anta BO": "209202",
      "Aurangpur Gahdeva BO": "209202",
      "Nanamau BO": "209202",
      "Nashirapur BO": "209202",
      "Raipur BO": "209308",
      "Ghanshyampur BO": "209203",
      "Bhaisau BO": "209205",
      "Kakoopur BO": "209205",
      "Nadiha BO": "209210",
      "Saibasu BO": "209210",
      "Bara Daulatpur BO": "209206",
      "Bari Mahtaen BO": "209206",
      "Bhadras BO": "209206",
      "Bhadwara BO": "209206",
      "Patrsa BO": "209206",
      "Rar BO": "209206",
      "Revna BO": "209206",
      "Roop Nagar BO": "209206",
      "Bhairampur BO": "209305",
      "Sadar Bazar Ghatampur BO": "209206",
      "Srinagar BO": "209206",
      "Virsinghpur BO": "209209",
      "Araul BO": "209202",
      "Panki Ganga Ganj BO": "208020",
      "Aurotahar Pur BO": "209202",
      "Khera Kurshi BO": "209202",
      "Maujampur BO": "209202",
      "Pihani Majbootnagar BO": "209202",
      "Uttha BO": "209202",
      "Gauri Bhagwantpur BO": "209203",
      "Malon BO": "209203",
      "Asdhna BO": "209206",
      "Chanwar BO": "209206",
      "Gujela BO": "209206",
      "Itrra BO": "209206",
      "Korea BO": "209206",
      "Parachand BO": "209206",
      "Pras BO": "209206",
      "Rawaipur BO": "209206",
      "Kotra Makrandpur BO": "209206",
      "Girsi BO": "209311",
      "Sugarardeva EUP  9346 BO": "209210",
      "Kanpur Cantt HO": "208004",
      "Nawabganj HO": "208002",
      "Sambhalpur BO": "209205",
      "Dudwa BO": "209210",
      "Radhan  EUP5857 BO": "209210",
      "Bibipur BO": "209206",
      "Kanpur HO": "208001",
      "Oriya BO": "209202",
      "Bhausana BO": "209205",
      "Beeramau BO": "209210",
      "Bairi Akbarpur BO": "208017",
      "Barra SO": "208027",
      "COD SO Kanpur Nagar": "208013",
      "Meerpur Cantt SO": "208004",
      "Barra Vishwa Bank SectorA SO": "208027",
      "Birhana Raod SO": "208001",
      "Harjinder Nagar SO": "208007",
      "Khapra Mohal SO": "208004",
      "N H Road SO": "208021",
      "Napier Road SO": "208004",
      "Naubasta SO": "208021",
      "Nayaganj SO": "208001",
      "Shyam Nagar SO Kanpur Nagar": "208013",
      "Colonelganj SO Kanpur Nagar": "208001",
      "Farrashkhana SO": "208001",
      "K M Street SO": "208001",
      "Agriculture College SO": "208002",
      "Gsvm Medical College SO": "208002",
      "BBGaon SO": "209209",
      "BILHAUR": "209202",
      "Ghatampur SO": "209206",
      "Uttaripura SO": "209210",
      "Hns Nagar SO": "208005",
      "Industrial Estate SO Kanpur Nagar": "208012",
      "Jawahar Nagar SO Kanpur Nagar": "208012",
      "N C Line SO": "208002",
      "Naveen Nagar SO": "208025",
      "Munshipurwa SO": "208023",
      "Oe Factory SO": "208001",
      "Philkhana SO": "208001",
      "T P Nagar SO": "208023",
      "Chakarpur SO": "209305",
      "Cotton Mill SO": "208001",
      "Gwaltoli SO": "208001",
      "Kanpur Court SO": "208001",
      "Keshav Puram SO Kanpur Nagar": "208017",
      "Armapore Estate SO": "208009",
      "Armapore SO": "208009",
      "Bima Vihar SO": "208024",
      "D O Oil Mill SO": "208012",
      "Indira Nagar SO Kanpur Nagar": "208026",
      "Kalyanpur SO Kanpur Nagar": "208017",
      "Kaushalpuri SO": "208012",
      "Motijheel SO Kanpur Nagar": "208002",
      "Anand Nagar SO Kanpur Nagar": "208011",
      "Anwarganj SO": "208003",
      "Cambridge Road SO": "208007",
      "Chakeri Aerodrum SO": "208008",
      "Govind Nagar SO Kanpur Nagar": "208006",
      "Krishna Nagar SO Kanpur Nagar": "208007",
      "New Pac Lines SO": "208015",
      "Railganj SO": "208004",
      "RBI Colony SO": "208011",
      "Fahimabad SO": "208001",
      "B N Shukla  Sons SO": "208001",
      "CAT SO": "208008",
      "Dhankutti SO": "208001",
      "Dmsrde SO": "208013",
      "Gandhi Grame SO": "208007",
      "Govind Nagar West SO": "208006",
      "Hal Colony SO": "208007",
      "Hatia SO Kanpur Nagar": "208001",
      "J K Puri SO": "208010",
      "Juhi Colony SO": "208014",
      "Naramau SO": "209217",
      "Panki SO Kanpur Nagar": "208020",
      "R K Nagar SO Kanpur Nagar": "208012",
      "Rawatpur SO": "208019",
      "Shivaji Nagar SO Kanpur Nagar": "208005",
      "Kidwai Nagar SO Kanpur Nagar": "208011",
      "Narona Exchange SO": "208004",
      "Nirala Nagar SO": "208014",
      "Shiwans Tanney SO": "208010",
      "Yashoda Nagar SO": "208011",
      "Bidhnoo SO": "209214",
      "Elgin Mills SO": "208001",
      "Mandhana SO": "209217",
      "Narwal SO": "209401",
      "Naveen Market SO": "208001",
      "Sarsaul SO": "209402",
      "Employeement Exchange SO": "208002",
      "Hbti SO": "208002",
      "Iit SO": "208016",
      "K P University SO": "208024",
      "Nsi SO": "208017",
      "Vijai Nagar SO Kanpur Nagar": "208005",
      "Kanpur West SO": "208001",
      "Sachendi SO": "209304",
      "Arya Nagar SO Kanpur Nagar": "208002",
      "Avas Vikas Yojna No 3 SO": "208017",
      "Chauki Jarib SO": "208003",
      "Purana Kanpur SO": "208002",
      "Patara SO": "209308",
      "Sheorajpur SO": "209205",
      "Chaubepur SO": "209203",
      "Rambagh SO Kanpur Nagar": "208012",
      "Ratan Lal Nagar SO": "208022",
      "Saketpuri SO": "208025",
      "Sisamau SO": "208012",
      "Syyed Nagar Post Office SO": "208019",
      "Udyog Nagar SO Kanpur Nagar": "208022",
      "Sarvodaya Nagar SO": "208005",
      "Swarup Nagar SO": "208002"
    },
    "GORAKHPUR": {
      "NDC Gorakhpur": "273001",
      "Chapiya BO": "273016",
      "Davarpar BO": "273016",
      "Ahirauli Bujurg BO": "273213",
      "Trilokpur BO": "273213",
      "KOTHA BO": "273406",
      "Gigani Bujurg BO": "273407",
      "Mahubujurg BO": "273407",
      "Marwatiya BO": "273407",
      "Shahpur BO": "273407",
      "Sidhawana BO": "273407",
      "Sonbarsa Bazar BO": "273002",
      "Mohammadpur Hagana BO": "273155",
      "Machhaligaon BO": "273155",
      "Dihghat BO": "273405",
      "Ramchaura BO": "273158",
      "Rigouli BO": "273158",
      "Sonoura Bujurg BO": "273158",
      "Baghar BO": "273404",
      "Gaunar BO": "273201",
      "Pali BO": "273403",
      "Lahsari BO": "273016",
      "Nausar BO": "273016",
      "Baraw BO": "273213",
      "Baripur BO": "273213",
      "Deharatikar BO": "273213",
      "Sukrauli BO": "273213",
      "Gaursaira BO": "273406",
      "Hardi Chak BO": "273406",
      "Araw jagdish BO": "273407",
      "Bela Khurd BO": "273407",
      "Dhudhara BO": "273407",
      "Gajpur BO": "273413",
      "Keshawapar BO": "273407",
      "Newas BO": "273209",
      "Pandeypura BO": "273403",
      "Jungle Ramgarh BO": "273002",
      "Rajahi Camp BO": "273002",
      "Karimnagar BO": "273155",
      "Kuin Bazar BO": "273405",
      "Jainpur BO": "273306",
      "Junjle Dumri No2 BO": "273306",
      "Sumergarh BO": "273306",
      "Haraiya BO": "273203",
      "Mithabel BO": "273203",
      "Basantpur BO": "273158",
      "Rajpur BO": "273158",
      "Suras BO": "273158",
      "Mehia BO": "273201",
      "Bargo BO": "273016",
      "Rampur BO": "273016",
      "Alawalpur BO": "273213",
      "Asauji Bazar BO": "273213",
      "Badago BO": "273213",
      "Patakhuli BO": "273213",
      "Baraipurwa BO": "273406",
      "Barni Gopalpur BO": "273406",
      "Saraya Tiwari BO": "273406",
      "Purwa Bazar BO": "273407",
      "Raujadargah BO": "273407",
      "Baraipur BO": "273002",
      "Gopalpur BO": "273408",
      "Bankata BO": "273155",
      "Bautha BO": "273405",
      "Bishunpura BO": "273405",
      "Khutahan Khas BO": "273306",
      "Samdar Khurd BO": "273306",
      "Nauwabari BO": "273203",
      "Baluwa BO": "273158",
      "Gulhariya BO": "273013",
      "Kunwar BO": "273158",
      "Loharpurwa BO": "273158",
      "Lalpur Tikar BO": "273016",
      "Mirzapur Bazar BO": "273016",
      "Nauwa Awal BO": "273016",
      "Brahmasari BO": "273213",
      "Bhatauli BO": "273406",
      "Ropnari BO": "273406",
      "Biraikhurd BO": "273407",
      "Dhuriyapar BO": "273407",
      "Gaurkhas BO": "273407",
      "Kotwa BO": "273407",
      "Pachperwa BO": "273407",
      "Rohari BO": "273407",
      "Jagdishpur BO": "273002",
      "Kusumhi Bazar BO": "273002",
      "Sihoria BO": "273002",
      "Indrapur BO": "273155",
      "Sarpataha BO": "273155",
      "Dumraila BO": "273405",
      "Sadhana BO": "273405",
      "Chiutahan BO": "273306",
      "Jungle Dumri No1 BO": "273306",
      "Jungle Rasoolpur BO": "273203",
      "Bhaurabari BO": "273158",
      "Dhrampur BO": "273158",
      "Khajurgawan BO": "273158",
      "Netwar Bazar BO": "273158",
      "Thakurnagar BO": "273158",
      "Bishwanathpur BO": "273201",
      "Gonghat BO": "276306",
      "Basahi BO": "273404",
      "Madanpura BO": "273212",
      "Mahuraon BO": "273212",
      "Pachauri BO": "273212",
      "Pagar BO": "273212",
      "Bhitirawat BO": "273209",
      "Dhuriapar BO": "273209",
      "Dumarinivas BO": "273209",
      "Gadhashand BO": "273209",
      "Kodari BO": "273209",
      "Mahaita BO": "273209",
      "Minwa BO": "273209",
      "Parmeshwarpur BO": "273209",
      "Rithuwakhor BO": "273209",
      "Baraipar BO": "273209",
      "Bhiti BO": "273401",
      "Chhapra BO": "273412",
      "Dadri BO": "273412",
      "Rampur Bhaghaura BO": "273412",
      "Riaon BO": "273412",
      "Sahuwakol BO": "273412",
      "Semra Khurd BO": "273412",
      "Semar Dadi BO": "273212",
      "Tenua BO": "273212",
      "Bharsad BO": "273209",
      "Ghaghsara BO": "273209",
      "Katai Tikar BO": "273212",
      "Khajani Tehsil BO": "273212",
      "Khajuri BO": "273212",
      "Bharpahi BO": "273209",
      "Rautapur BO": "273209",
      "Gangapar BO": "273412",
      "Khakhaichkhor BO": "273412",
      "Kodarpandey BO": "273412",
      "Mohaljalkar BO": "273412",
      "Ujjarpar BO": "273412",
      "Bahrampur BO": "273016",
      "Amtaura BO": "273212",
      "Bargahan BO": "273212",
      "Jhuriya BO": "273212",
      "Balapar BO": "273007",
      "Jangle Beni Madho BO": "273007",
      "Jungle Kauria BO": "273007",
      "Sihorwa BO": "273007",
      "Kalyanpur BO": "273165",
      "Kanapar BO": "273403",
      "Makhanaha BO": "273165",
      "Bhaisa Bazar BO": "273212",
      "Bigahi BO": "273212",
      "Jakahi BO": "273212",
      "Karanpura BO": "273212",
      "Maina Bhagar BO": "273007",
      "Mirpur BO": "273007",
      "Jungle Chauri BO": "273010",
      "Raiganj BO": "273010",
      "Rampur Pandey BO": "273212",
      "Sonbarsa Babu BO": "273212",
      "Piprouli BO": "273212",
      "Bhaishlar BO": "273209",
      "Chadraon BO": "273209",
      "Harpur Budhat BO": "273209",
      "Lakhanapar BO": "273209",
      "Randauli BO": "273209",
      "Sidhauli BO": "273209",
      "Khirkitadubey BO": "273412",
      "Mathia BO": "273412",
      "Newada BO": "273412",
      "Sihaijpar BO": "273412",
      "Bihari Bujurg BO": "273212",
      "Chhatai BO": "273212",
      "Dhobouli BO": "273212",
      "Hariharpur BO": "273212",
      "Belakanta BO": "273152",
      "Awadhpur BO": "273202",
      "Basdila BO": "273202",
      "Ban BO": "273165",
      "Fardahani BO": "273165",
      "Mahawan Khore BO": "273165",
      "Nawapar BO": "273165",
      "Rakhore BO": "273165",
      "Turkwalia BO": "273165",
      "Hemdhapur BO": "273152",
      "Naiyapar Khurd BO": "273152",
      "Amahia BO": "273202",
      "Dumri Khas BO": "273202",
      "Gahira BO": "273202",
      "Sonbarsa BO": "273201",
      "Parmeshwar Pur BO": "273007",
      "Rampurgopalpur BO": "273007",
      "Rampur Rakba BO": "273201",
      "Satahwa Purvi BO": "273201",
      "Basiakhor BO": "273212",
      "Bharohiya BO": "273212",
      "Dewrartula BO": "273212",
      "Gadar BO": "273212",
      "Jaitpur BO": "273212",
      "Jungle Dhushar BO": "273014",
      "Jungle Laxmipur BO": "273014",
      "Jungle Saligram BO": "273014",
      "Jangle Agahi BO": "273165",
      "Sarhari BO": "273165",
      "Thawaipar BO": "273165",
      "Tighara BO": "273165",
      "Patra Bazar BO": "273152",
      "Unaula BO": "273152",
      "Bhaisaha BO": "273202",
      "Jungle Gauri BO": "273202",
      "Phutahwa Inar BO": "273202",
      "Rajdhani BO": "273202",
      "Lachchipur BO": "273007",
      "Maniram BO": "273007",
      "Khorabar BO": "273010",
      "Jungle Tulshiram BO": "273014",
      "Barhyachowk BO": "273165",
      "Kataharimahurasar BO": "273165",
      "Majhauna BO": "273165",
      "Rajabari BO": "273165",
      "Rawatganj BO": "273165",
      "Tikaria BO": "273165",
      "Luhasi BO": "273152",
      "Parasurampur BO": "273152",
      "Belwa Babu BO": "273202",
      "Bhauwapar Bazar BO": "273202",
      "Jhangha BO": "273202",
      "Parsauni BO": "273201",
      "Bandoh BO": "273161",
      "Marhatha BO": "273161",
      "Mundera Bazar BO": "273201",
      "Phulwaria BO": "273201",
      "Jungle Ayodhya Prasad BO": "273013",
      "Jungle Aurahi BO": "273013",
      "Bhita BO": "273403",
      "Bhuswal BO": "273403",
      "Bisaunpur BO": "273403",
      "Belwa Dakhli BO": "273402",
      "Baria Khas BO": "273402",
      "Newaijpar BO": "273402",
      "Nibidubey BO": "273402",
      "Parsia BO": "273402",
      "Patna BO": "273402",
      "Mokarimpur BO": "273404",
      "Kakrakhore BO": "273401",
      "Khoratha BO": "273401",
      "Kusmaul BO": "273401",
      "Misraulia BO": "273401",
      "Murarpur BO": "273409",
      "Tarayapar BO": "273409",
      "Uchagaon BO": "273409",
      "Belabirbhan BO": "273411",
      "Belkur BO": "273411",
      "Dandi BO": "273413",
      "Dharsi BO": "273411",
      "Ilahibagh BO": "273001",
      "Chargawan BO": "273013",
      "Jigina Bhion BO": "273403",
      "Malahanpar BO": "273403",
      "Sahuapar BO": "273403",
      "Barpar BO": "273402",
      "Bhatpar BO": "273402",
      "Madria BO": "273402",
      "Siddhegaur BO": "273402",
      "Tiha Mohammadpur BO": "273402",
      "Lakhuapakar BO": "273404",
      "Shankarpur BO": "273404",
      "Bagaghadha BO": "273401",
      "Cheriya BO": "273401",
      "Pichaura BO": "273401",
      "Bishunpur Raja BO": "273409",
      "Jharkata BO": "273409",
      "Badhyapar BO": "273211",
      "Bheunsa BO": "273211",
      "Israuli BO": "273211",
      "Murdewa BO": "273211",
      "Jagdishpur Bhaluwan BO": "273411",
      "Rakhat BO": "273411",
      "Khajuri Baboo BO": "273411",
      "Deepgarh BO": "273408",
      "Patauha BO": "273408",
      "Samayathanbhiti BO": "273408",
      "Bharroh BO": "273408",
      "Baswanpur BO": "273413",
      "Boopgarh BO": "273413",
      "Girdharpur BO": "273413",
      "Karjhi BO": "273413",
      "Mahuja BO": "273413",
      "Hata Buzurg BO": "273403",
      "Bimuti BO": "273402",
      "Derwa BO": "273402",
      "Farsand BO": "273402",
      "Tanda BO": "273402",
      "Babhnauli BO": "273404",
      "Gaighat BO": "273404",
      "Kuri Bazar BO": "273404",
      "Piparshandi BO": "273404",
      "Bhagawanpur BO": "273401",
      "Baranagar BO": "273409",
      "Barigaon BO": "273211",
      "Karwal Majhgawa BO": "273411",
      "Kotha BO": "273411",
      "Salarpur BO": "273411",
      "Basudiha BO": "273411",
      "Kohra Buzurg BO": "273408",
      "Janipur BO": "273413",
      "Kakrahi BO": "273408",
      "Kodri BO": "273408",
      "Mannipursahdauli BO": "273408",
      "Jagatbela BO": "273015",
      "Manjharia BO": "273015",
      "Chawaria Buzurg BO": "273413",
      "Dhanauda Buzurg BO": "273413",
      "Dubauli BO": "273413",
      "Munderathakurai BO": "273413",
      "Pakdidubey BO": "273413",
      "Shingaha BO": "273413",
      "Sohgaura BO": "273413",
      "Tiyar BO": "273413",
      "Jafra Bazar BO": "273001",
      "Jhungia Bazar BO": "273013",
      "Baghrain BO": "273403",
      "Siswa Urf Siuwa BO": "273403",
      "Bhrauli BO": "273402",
      "Khandaesari BO": "273402",
      "Mahuapar BO": "273402",
      "Pirahani BO": "273402",
      "Sukulpuri BO": "273402",
      "Siswa Babu BO": "273404",
      "Jungle Rani Sohas BO": "273401",
      "Barpar Mafi BO": "273409",
      "Harpur BO": "273409",
      "Dhuriyapar Chini mil BO": "273409",
      "Karamdeva BO": "273211",
      "Gharsaon BO": "273411",
      "Rajgarh BO": "273411",
      "Chilwa BO": "273408",
      "Dewalapar BO": "273408",
      "Niaon BO": "273408",
      "Dohariya Bazar BO": "273015",
      "Baksuri BO": "273413",
      "Belipar BO": "273413",
      "Mahuarkol BO": "273413",
      "Malaon BO": "273413",
      "Thunni Mahadev Chak BO": "273413",
      "Kanaicha BO": "273413",
      "Kanail BO": "273413",
      "Gorakhpur HO": "273001",
      "Pipraich S.O": "273152",
      "Sardar Nagar S.O": "273202",
      "Campierganj S.O": "273158",
      "Brahmpur S.O Gorakhpur": "273203",
      "Chauri Chaura S.O": "273201",
      "Fertilizer Factory S.O": "273007",
      "Pac Camp SO": "273014",
      "Pepeeganj S.O": "273165",
      "Bansgaon SO Gorakhpur": "273403",
      "Barhalganj SO": "273402",
      "Betia Hata SO": "273001",
      "Civil Court SO Gorakhpur": "273001",
      "Dharamshala SO": "273001",
      "Gagaha SO": "273411",
      "Gita Press SO": "273005",
      "Gorakhnath Mandir SO": "273015",
      "Gorakhpur Kutchery SO": "273001",
      "Gorakhpur University SO": "273009",
      "Labour Camp SO": "273001",
      "Loco  Workshop LSG SO": "273012",
      "Shivpur SO Gorakhpur": "273412",
      "Unwal SO": "273406",
      "SURAJKUND COLONY": "273015",
      "BRD Medical College SO": "273013",
      "Belghat SO": "273404",
      "Daudpur SO": "273001",
      "Dhakhwa Bazar SO": "273211",
      "Shivpurinewcolony SO": "273016",
      "Urdu Bazar SO": "273005",
      "A.P.Station S.O": "273002",
      "Barhi S.O Gorakhpur": "273405",
      "Arogyamandir SO": "273003",
      "Ashok Nagar SO Gorakhpur": "273004",
      "Gita Vatika SO": "273006",
      "Golghar SO": "273001",
      "GR Railway Station SO": "273012",
      "Jatepur North SO": "273015",
      "Kauriram SO": "273413",
      "Kazipur Kalan SO": "273001",
      "Khajni SO": "273212",
      "Railway Colony SO Gorakhpur": "273012",
      "Siddharth Enclave SO": "273017",
      "Sikriganj SO": "273213",
      "Bhathat S.O": "273306",
      "M.M.M.E.College S.O": "273010",
      "Mohaddipur S.O Gorakhpur": "273008",
      "Alinagar SO": "273001",
      "Allahadadpur SO": "273001",
      "Bank Road SO Gorakhpur": "273001",
      "Basharatpur SO": "273004",
      "Bhowapar SO": "273401",
      "Buxipur SO": "273001",
      "Deidiha SO": "273409",
      "Gola SO Gorakhpur": "273408",
      "Rajghat SO": "273005",
      "Sahajanwa SO": "273209",
      "Turkmanpur SO": "273005",
      "Uruwa Bazar SO": "273407",
      "Kunraghat S.O": "273008"
    },
    "GHAZIABAD": {
      "NDC Ghaziabad": "201001",
      "Dundaheda BO": "201009",
      "Jindal Nagar BO": "201015",
      "Kushlia BO": "201015",
      "Ingrahm Institute BO": "201002",
      "Behta Hazipur BO": "201102",
      "Mandola BO": "201102",
      "Kaila BO": "201009",
      "Nasratpura BO": "201009",
      "Nahal BO": "201015",
      "Rajapur BO": "201002",
      "Sadarpur BO": "201002",
      "Shahpur Bamheta BO": "201002",
      "Badshahpur Siroli BO": "201102",
      "Chirori BO": "201102",
      "Jaoli BO": "201102",
      "Roja Yakoobpur BO": "201009",
      "Adhyatmik Nagar BO": "201015",
      "Dasna BO": "201015",
      "Aurangabad Ristal BO": "201003",
      "BubKheri BO": "201003",
      "Chipiana BO": "201009",
      "Dasna Gate BO": "201009",
      "Dasna RS BO": "201015",
      "Hasanpur Bhowapur BO": "201010",
      "Raispur BO": "201002",
      "Teela Shahbazpur BO": "201102",
      "Atore Nangla BO": "201003",
      "Abupur BO": "201206",
      "Noorpur BO": "201206",
      "Raoli Kalan BO": "201206",
      "Shahpur BO": "201206",
      "Sultanpur BO": "201206",
      "Surana BO": "201206",
      "Atrauli BO": "245304",
      "Bhadaula BO": "245304",
      "Churiyala BO": "201201",
      "Rori BO": "201201",
      "Saidpur BO": "201201",
      "Nagla Akhu BO": "201204",
      "Niwari BO": "201204",
      "Painga BO": "201204",
      "Shahjahanpur BO": "201204",
      "Bhadauli BO": "201206",
      "Didauli BO": "201206",
      "Kumhera BO": "201206",
      "Nekpur BO": "201206",
      "Farrukh Ng BO": "201003",
      "Nistauli BO": "201003",
      "Basantpur Sainthli BO": "201206",
      "Bhikanpur BO": "201206",
      "Khimawti BO": "201206",
      "Murad Nagar Town BO": "201206",
      "Bhojpur BO": "245304",
      "Faridnagar BO": "245304",
      "Kalchina BO": "245304",
      "Samaipur BO": "245304",
      "Meerpur Hindu": "201103",
      "Talheta BO": "201201",
      "Begmabad BO": "201204",
      "Khanjarpur BO": "201204",
      "Tibra BO": "201204",
      "Tyori BO": "245304",
      "Pasonda BO": "201005",
      "Gyaspur BO": "201204",
      "Morta BO": "201003",
      "Dosa Banjarpur BO": "201206",
      "Duhai BO": "201206",
      "Jalalabad BO": "201206",
      "Jalalpur Dhindhar BO": "201206",
      "Kakra BO": "201206",
      "Kanauja BO": "201206",
      "Mukimpur BO": "245304",
      "Sara BO": "201201",
      "Sikri Kalan BO": "201204",
      "Sikri Khurd BO": "201204",
      "Khindora BO": "201204",
      "Patla BO": "201204",
      "Saunda BO": "201204",
      "Ghaziabad HO": "201001",
      "Arya Nagar SO": "201009",
      "Ashok Nagar SO": "201001",
      "Chandra Nagar SO": "201011",
      "Hindon Nagar SO": "201015",
      "Loni SO": "201102",
      "Model Town SO": "201018",
      "Tronica City SO": "201103",
      "Vijay Nagar SO": "201009",
      "Crossings Republik SO": "201016",
      "Shastri Nagar SO": "201002",
      "Govindpuri SO": "201201",
      "Chikamberpur SO": "201006",
      "Ghaziabad City SO": "201009",
      "Govindpuram SO": "201013",
      "New Raj Nagar SO": "201002",
      "Police Line Harsaon SO": "201002",
      "Raj Nagar Extension SO": "201017",
      "Vasundhra SO": "201012",
      "RAKNPA SO": "201002",
      "Harmukhpuri SO": "201201",
      "Bharat Nagar SO": "201010",
      "Hindon Air Field SO": "201004",
      "Meerut Road SO": "201003",
      "Nehru Nagar SO": "201001",
      "Shipra Sun City SO": "201014",
      "Khora SO": "201020",
      "IESahibabad SO": "201010",
      "Kamla Nehru Nagar SO": "201002",
      "Kaushambi SO": "201010",
      "Kavi Nagar SO": "201002",
      "Mohan Nagar SO": "201007",
      "Murad Nagar Bazar SO": "201206",
      "Murad Nagar SO": "201206",
      "Ramte Ram Road SO": "201001",
      "Sahibabad SO": "201005",
      "Vivekanand Nagar SO": "201002",
      "Bhopura SO": "201006",
      "Vaishali SO": "201019",
      "Abhay Khand 03 SO": "201021",
      "Modi Nagar SO": "201204"
    },
    "AGRA": {
      "NDC Agra": "282001",
      "Maloni BO": "283104",
      "Pura Guman Singh BO": "283104",
      "Rudhmuli BO": "283104",
      "Khanda BO": "283201",
      "Mahwatpur BO": "283201",
      "Murthar Alipur BO": "283201",
      "Bichola BO": "283113",
      "Bitholi BO": "283113",
      "Pharera BO": "283113",
      "Rajora BO": "283113",
      "Jaganpur BO": "282005",
      "Agwar BO": "283202",
      "Behrampur BO": "283202",
      "Bhagupur BO": "283202",
      "Mehra Chudhary BO": "283111",
      "Nagar Chand BO": "283111",
      "Nagaria BO": "283111",
      "Nibohara BO": "283111",
      "Jarar BO": "283104",
      "Kwari BO": "283104",
      "Vikrampur BO": "283104",
      "Anwal Khera BO": "283201",
      "Arela BO": "283201",
      "Mitaoli BO": "283201",
      "Tehu BO": "283201",
      "Pidhora BO": "283113",
      "Dhaurra BO": "283202",
      "Gubroth BO": "283111",
      "Jarari BO": "283111",
      "Kaulara Kalan BO": "283111",
      "Kundaul BO": "283111",
      "Rasoolpur BO": "283121",
      "Sikrara BO": "283111",
      "Bateshwar BO": "283104",
      "Chamraua BO": "283104",
      "Chaurangahar BO": "283104",
      "Chamraula BO": "283201",
      "Chaoli BO": "283201",
      "Chokda BO": "283201",
      "Nagla Bel BO": "283201",
      "Siktara BO": "283201",
      "Ushmanpur BO": "283201",
      "Barauli Gujar BO": "283111",
      "Bhalokhara BO": "283111",
      "Bihari BO": "283111",
      "Bijhamai BO": "283111",
      "Gonseli BO": "283104",
      "Kamtari BO": "283104",
      "Pura Tinnet BO": "283104",
      "Sidhaoli BO": "283104",
      "Aharan BO": "283201",
      "Mukhbar BO": "283201",
      "Nagla Bari BO": "283201",
      "Holipura BO": "283113",
      "Pura Kanhera BO": "283113",
      "Ratoti BO": "283113",
      "Dharera BO": "283202",
      "Sawain BO": "283202",
      "Arnota BO": "283111",
      "Dauki BO": "283111",
      "Jagrajpur BO": "283111",
      "Khander BO": "283111",
      "Maharajpur BO": "283111",
      "Palia BO": "283111",
      "Sanjeti BO": "283114",
      "Shiv Nagar BO": "283114",
      "Hasanpur BO": "283126",
      "Malupur BO": "283126",
      "Pent Khera BO": "283126",
      "Sarai BO": "283126",
      "Basoni BO": "283123",
      "Gajaura BO": "283123",
      "Karkoli BO": "283123",
      "Arsena BO": "282007",
      "Artoni BO": "282007",
      "Bodla BO": "282007",
      "Budhana Mustkil BO": "282006",
      "Sultan Pura BO": "282009",
      "Raibha BO": "283101",
      "Rampur BO": "283101",
      "Jarua Katra BO": "283102",
      "Bamrauli Ahir BO": "282009",
      "Kakua BO": "282009",
      "Nagla Kali BO": "282009",
      "Tanora Noorpur BO": "283111",
      "Chitra Hat BO": "283114",
      "Khilawali BO": "283114",
      "Mau BO": "283114",
      "Naugawan BO": "283114",
      "Shiaupura BO": "283114",
      "Baman BO": "283126",
      "Barenda BO": "283123",
      "Kukthari BO": "283123",
      "Reha BO": "283123",
      "Kailash BO": "282007",
      "Panwari BO": "282007",
      "Kalal Kheria BO": "282006",
      "Rehan Kalan BO": "282006",
      "Labour Colony BO": "282006",
      "Seola Jat BO": "282009",
      "Arrua Khas BO": "283101",
      "Mangrol Jat BO": "283101",
      "Sandhan BO": "283101",
      "Barara BO": "283102",
      "Malpura BO": "283102",
      "Daoli BO": "283105",
      "Karahara BO": "283105",
      "Sahata BO": "283105",
      "Sunari BO": "283105",
      "Karodhana Kala BO": "282009",
      "Khandri BO": "282002",
      "Arhera BO": "283110",
      "Baseri Kazi BO": "283110",
      "Dabar BO": "283110",
      "Doora BO": "283110",
      "Jajauli BO": "283110",
      "Mandi Mirja Khan BO": "283110",
      "Gurki Mandi BO": "283110",
      "Swara BO": "283111",
      "Tarauli Gujar BO": "283111",
      "Tiwaha BO": "283111",
      "Wazitpur BO": "283111",
      "Garhwar BO": "283114",
      "Kachora Ghat BO": "283114",
      "Kukapur BO": "283114",
      "Murhi Chauraha BO": "283126",
      "Manikpura BO": "283123",
      "Tasond BO": "283123",
      "Umretha BO": "283123",
      "Keetham BO": "282007",
      "Runkata BO": "282007",
      "Dhandupura BO": "282006",
      "Hazipur Khera BO": "283126",
      "Nagla Sabla BO": "282006",
      "Biara BO": "283101",
      "Daultabad BO": "283101",
      "Hansela BO": "283101",
      "Kachaura BO": "283101",
      "Berichahar BO": "283102",
      "Bisalpur BO": "283102",
      "Dhanoli BO": "283102",
      "Garsani BO": "283102",
      "Murkia BO": "283102",
      "Ujarai BO": "283102",
      "Kukthala BO": "283105",
      "Midhakur BO": "283105",
      "Pathauli BO": "283105",
      "Sahara BO": "283105",
      "Shahi BO": "283105",
      "Rohta BO": "282009",
      "Semri BO": "282009",
      "Billoch Pura BO": "282002",
      "Bharkol BO": "283110",
      "Chauma Shahpur BO": "283110",
      "Churiyari BO": "283110",
      "Nadgawan BO": "283114",
      "Parna BO": "283114",
      "Richhpura BO": "283114",
      "Shahpur Brahman BO": "283114",
      "Basona BO": "283126",
      "Kanjauli BO": "283126",
      "Poiya Tarrakpur BO": "283126",
      "Semera BO": "283126",
      "Uncha BO": "283126",
      "Biprawali BO": "283123",
      "Sabora BO": "283123",
      "Bainpur BO": "282007",
      "Dahtora BO": "282007",
      "Bamrauli Katara BO": "282006",
      "Chhalesar BO": "282006",
      "Naraich BO": "282006",
      "Achnera Mandi BO": "283101",
      "Baharawati BO": "283101",
      "Kathwari BO": "283101",
      "Turkia BO": "283101",
      "Akhabai BO": "283102",
      "Kheria BO": "283112",
      "Mankeda BO": "283102",
      "Atoos BO": "283105",
      "Kalwari BO": "283105",
      "Deori BO": "282009",
      "Kurra Chittaipur BO": "282009",
      "Nainana Jat BO": "282009",
      "Aulanda BO": "283110",
      "Dulhara BO": "283110",
      "Jajau BO": "283124",
      "Korai BO": "283110",
      "Bamrauli BO": "283104",
      "Samara BO": "283110",
      "Mahab BO": "283112",
      "Mihawa BO": "283112",
      "Nagla Patam BO": "283112",
      "Bamnai Kalan BO": "283115",
      "Basai Jagner BO": "283115",
      "Bhara BO": "283115",
      "Dehgawan BO": "283115",
      "Sikraondha BO": "283110",
      "Undera BO": "283110",
      "Nagar BO": "283110",
      "Bikapur Tap Kharga BO": "283112",
      "Darki BO": "283112",
      "Puseta BO": "283112",
      "Mehdau BO": "283110",
      "Patsal BO": "283110",
      "Birthala BO": "283112",
      "Rahlai BO": "283112",
      "Sarendi BO": "283119",
      "Waha BO": "283119",
      "Bhilawali BO": "283121",
      "Nagla Dulhe Khan BO": "283121",
      "Rojholi BO": "283122",
      "Birharu BO": "283124",
      "Garshan BO": "283124",
      "Hironda BO": "283124",
      "Jonai BO": "283124",
      "Phool Pur BO": "283125",
      "Shahpur Toola BO": "283125",
      "Dhanina BO": "283115",
      "Richoba BO": "283115",
      "Digrauta BO": "283119",
      "Sarendha BO": "283119",
      "Bhakar BO": "283121",
      "Beman BO": "283122",
      "Puramana BO": "283122",
      "Salemabad BO": "283122",
      "Birai BO": "283124",
      "Dankasha BO": "283124",
      "Ladhu Khera BO": "283124",
      "Dhim Shree BO": "283125",
      "HNKhera BO": "283125",
      "Lahra BO": "283125",
      "Thana Shankar Dwari BO": "283125",
      "Therai BO": "283125",
      "Soni Khera BO": "283115",
      "Tantpur BO": "283115",
      "Chandsor BO": "283115",
      "Barwar BO": "283119",
      "Cheet BO": "283119",
      "Deoretha BO": "283122",
      "Mahuar BO": "283122",
      "Nahchani BO": "283122",
      "Nadeem BO": "283124",
      "Rithori BO": "283124",
      "Tehra BO": "283124",
      "Barauli Ahir BO": "283125",
      "Barobara Khurd BO": "283125",
      "Chitaura BO": "283125",
      "Dhanaula Kalan BO": "283125",
      "Garhi Lal Kalan BO": "283125",
      "Gutila BO": "283125",
      "Lakhurani BO": "283125",
      "Pentikhera BO": "283125",
      "Noni BO": "283115",
      "Singaich BO": "283115",
      "Garh Mukha BO": "283119",
      "Baseri Chahar BO": "283122",
      "Jaingara BO": "283122",
      "Ayela BO": "283124",
      "Digner BO": "283125",
      "Shyamo BO": "283125",
      "Agra Fort HO": "282003",
      "Agra HO": "282001",
      "Civil Court SO": "282002",
      "Gokulpura": "282002",
      "INDRAPURAM SO": "282001",
      "KAGROL SO": "283119",
      "KHERAGARH SO": "283121",
      "MALVIYA KUNJ SO": "282002",
      "MEDICAL COLLEGE SO": "282002",
      "NAI KI MANDI": "282010",
      "NAMNER": "282001",
      "POLICE LINE": "282010",
      "SHAHGANJ SO": "282010",
      "TAJGANJ SO": "282001",
      "VAYU VIHAR SO": "283105",
      "Deori Road": "282001",
      "GL Emporium": "282001",
      "Hotel Clark Shiraj": "282001",
      "KIRAOLI SO": "283122",
      "PN PHATAK SO": "282010",
      "RAJAMANDI": "282002",
      "RAKABGANJ SO": "282001",
      "TP NAGAR SO": "282002",
      "TAJ SO": "282001",
      "15 Bn PAC": "282001",
      "Fatehpur Sikri": "283110",
      "IAF SO": "282008",
      "IDGAH COLONY SO": "282001",
      "JAGDISHPURA SO": "282002",
      "LOHAMANDI SO": "282002",
      "PRR SO": "282001",
      "SADAR BAZAR SO": "282001",
      "SAIYAN  SO": "283124",
      "SHAMSABAD SO": "283125",
      "SARAI KHWAJA SO": "282001",
      "Civil Lines SO": "282002",
      "Collectorate SO": "282010",
      "IRADAT NAGAR SO": "283112",
      "JAGNER SO": "283115",
      "LAJPATKUNJ SO": "282002",
      "NMPALIKA SO": "282002",
      "RBS COLLEGE SO": "282002",
      "SANJAY PLACE SO": "282002",
      "Avas Vikas Colony SO": "282007",
      "BP Oilmill SO": "282003",
      "Barhan SO": "283201",
      "Bhadrauli SO": "283113",
      "Dayal Bagh": "282005",
      "Fatehabad Bazar": "283111",
      "Fatehabad": "283111",
      "Foundary Nagar": "282006",
      "JAITPUR SO": "283114",
      "PHULATTI BAZAR": "282003",
      "SHASTRIPURAM SO": "282007",
      "WAZIRPURA  SO": "282003",
      "LAWYERS COLONY SO": "282004",
      "AGRA CANTT RLY STN SO": "282001",
      "Hospital Road": "282003",
      "JOHRI BAZAR SO": "282003",
      "KALIBARI": "282003",
      "KHANDAULI SO": "283126",
      "NV COLONY": "282004",
      "NEW AGRA": "282005",
      "RAWATPARA  SO": "282003",
      "SHOE MARKET SO": "282003",
      "SIKANDRA SO": "282007",
      "YAMUNA BRIDGE  SO": "282006",
      "509 Commad SO": "282001",
      "Agra Barracks SO": "282001",
      "Agra City SO": "282003",
      "Bah SO": "283104",
      "Etmadpur": "283202",
      "GG Industries": "282004",
      "GM Khan": "282003",
      "INDUSTRIAL ESTATE SO": "282006",
      "JOHNS MILLS SO": "282004",
      "KH SANSTHAN SO": "282005",
      "KAMLA NAGAR SO": "282004",
      "KARMYOGI ENCLAVE SO": "282005",
      "TAJ NAGRI": "282004",
      "YAMUNA KINARA  SO": "282005",
      "Akola SO": "283102",
      "BM Khan SO": "282002",
      "Bhogipura SO": "282010",
      "Agra University SO": "282004",
      "Gandhi Nagar": "282003",
      "PINAHAT": "283123",
      "SUBJI MANDI SO": "282007",
      "Achhnera SO": "283101",
      "BV Bichpuri SO": "283105",
      "Baluganj SO": "282001",
      "COD SO": "282009"
    },
    "PRAYAGRAJ": {
      "NTPC Kohdar Meja SO": "212308",
      "Ganja BO": "211012",
      "Gauspur Katahula BO": "211012",
      "Karehnda BO": "211012",
      "Bampur BO": "212104",
      "Bagbana BO": "212111",
      "Balapur BO": "212111",
      "Purwa Khas BO": "212111",
      "Bahraicha BO": "212106",
      "Chhapar BO": "212106",
      "Kapraura BO": "212106",
      "Kaundhiyra BO": "212106",
      "Khiri BO": "212106",
      "Bhita BO": "212107",
      "Chhatahra BO": "212107",
      "Chhiri BO": "212107",
      "Chilla BO": "212107",
      "Lalapur Bhatpura BO": "212107",
      "Akorha BO": "212301",
      "Mohabbatganj Uparhar BO": "211007",
      "Asrawey Kalan BO": "211012",
      "Bhagwatpur BO": "211012",
      "Bedauli BO": "212104",
      "Daswar BO": "212104",
      "Nahwai ED BO": "212104",
      "Trisentulapur BO": "212104",
      "Inguwa Kathgaon BO": "212202",
      "Karma BO": "212111",
      "Belsara BO": "212106",
      "Khoonta BO": "212106",
      "Maida BO": "212106",
      "Belamundi BO": "212107",
      "Dhara BO": "212107",
      "Kanti BO": "212107",
      "Lohgara BO": "212107",
      "Naganpur BO": "212107",
      "Othgi Tarhar BO": "212107",
      "Panwar BO": "212107",
      "Tatarganj BO": "212107",
      "Deora BO": "212301",
      "Dharwara BO": "212301",
      "Issauta BO": "212301",
      "Dandi Bazar BO": "211008",
      "Bisauna BO": "211012",
      "Jalalpur Ghosi BO": "211012",
      "Mandardeeh Mafi BO": "211012",
      "Bhanjanpur BO": "212104",
      "Ghoorpur BO": "212111",
      "Barha BO": "212106",
      "Bharat Nagar BO": "212106",
      "Chamu BO": "212106",
      "Lendiyari BO": "212106",
      "Nari Bari ED BO": "212106",
      "Bara BO": "212107",
      "Dubaha BO": "212107",
      "Leondi BO": "212107",
      "Harduwa BO": "212301",
      "Konhdar BO": "212301",
      "Bamhrauli Uparhar BO": "211012",
      "Shergarh BO": "211012",
      "Dohatha BO": "212104",
      "Hata BO": "212104",
      "Kosda Kalan BO": "212104",
      "Madar BO": "212104",
      "Majhigaown BO": "212104",
      "Manda BO": "212104",
      "Shukulpur BO": "212104",
      "Sonversa BO": "212104",
      "Sulem Sarai BO": "211011",
      "Kheraht Khurd BO": "212106",
      "Palpatti BO": "212106",
      "Panwari BO": "212106",
      "Sujani BO": "212106",
      "Manpur BO": "212107",
      "Naudhiya Tarhar BO": "212107",
      "Nagarwar BO": "212107",
      "Panduwa BO": "212107",
      "Arai BO": "212301",
      "Baraon BO": "212301",
      "Bendon BO": "212301",
      "Karchha RS BO": "212301",
      "Mungari BO": "212301",
      "Pathra BO": "212301",
      "Pindi BO": "212301",
      "Barethi BO": "221505",
      "Dubawal BO": "221505",
      "Mukundpur BO": "212503",
      "Niyayipur BO": "212503",
      "Mandwa Bazar BO": "212401",
      "Kotwa BO": "221505",
      "Leelapur Kala BO": "221505",
      "Ramaipur BO": "221505",
      "Bhagwatipurkhutana BO": "212503",
      "Dahiyawan BO": "212503",
      "Siyadeeh BO": "221503",
      "Jagatpur BO": "221505",
      "Katwaroopur BO": "221505",
      "Sarai Inayat BO": "221505",
      "Barai Harakh BO": "212503",
      "Sarai Madan Urf Chanti BO": "212503",
      "Maharchha BO": "212401",
      "Prem Nagar Chauraha BO": "212502",
      "Shivgarh BO": "212502",
      "Bhogwara BO": "212405",
      "Khakhaicha BO": "212405",
      "Soron BO": "212405",
      "Hetapur BO": "221505",
      "Jamunipur BO": "221505",
      "Mugarshan BO": "221505",
      "Aruvaon BO": "212503",
      "Purabnara BO": "212503",
      "Anuwa BO": "212401",
      "Chanethu BO": "212401",
      "Nasratpur BO": "212502",
      "Basna BO": "212405",
      "Piprao BO": "212301",
      "Birpur BO": "212307",
      "Deeha BO": "212307",
      "Ghodedeeh BO": "212307",
      "Mahori BO": "212307",
      "Ayodhya BO": "212306",
      "Badaur BO": "212306",
      "Badokhar BO": "212306",
      "Beri BO": "212306",
      "Pachera BO": "212306",
      "Ahmedpur Asrauli BO": "212208",
      "Sallahpur BO": "212208",
      "Karaundi BO": "212502",
      "Khargapur BO": "212502",
      "Barasta Kalan BO": "212405",
      "Garha BO": "212306",
      "Kapasi Kalan BO": "212306",
      "Karpia BO": "212306",
      "Khajuri BO": "212306",
      "Kheoli Kalan BO": "212306",
      "Paintiha BO": "212306",
      "Rampur Kalan BO": "212306",
      "Saji BO": "212306",
      "Amilia Kalan BO": "212303",
      "Amora BO": "212303",
      "Barha Kalan BO": "212303",
      "Bharari BO": "212303",
      "Zera BO": "212303",
      "Basahra BO": "212302",
      "Chaka BO": "221508",
      "Nibi BO": "211008",
      "Dharampur BO": "274308",
      "Basahra Uparhar BO": "212108",
      "Bemra BO": "212108",
      "Chowki BO": "212305",
      "Achhola BO": "212303",
      "Nibaiya BO": "212303",
      "Samhan BO": "212303",
      "Uruwa BO": "212303",
      "Dari BO": "212302",
      "Gunai Gaharpur BO": "212302",
      "Kurki Kalan BO": "212302",
      "Lutar BO": "212302",
      "Lohari BO": "212305",
      "Madra Mukundpur BO": "212305",
      "Shukulpur ED BO": "212305",
      "Deys Medical Tiraha BO": "211010",
      "Khandesara BO": "211010",
      "Aladadpur BO": "229411",
      "Mendara BO": "229411",
      "Prem Misirpur Korali BO": "229411",
      "Shringverpur BO": "229411",
      "Masni Jagdishpur BO": "229412",
      "Mubarakpur BO": "229412",
      "Pachdeora BO": "229412",
      "Saraswatipur Urf Kaudihar BO": "229412",
      "Aura BO": "221502",
      "Bhelsi BO": "221502",
      "Bhiti BO": "221502",
      "Lokmanpur BO": "221502",
      "Mahajna BO": "221502",
      "Pure Kanta BO": "221502",
      "Tela BO": "221502",
      "Beerapur BO": "221503",
      "Bhopatpur BO": "221503",
      "Dhanupur BO": "221503",
      "Handia TI BO": "221503",
      "Lakshagrih BO": "221503",
      "Mawaiya Hindwani BO": "221503",
      "Prithvipur BO": "221503",
      "Malawan Khurd BO": "211019",
      "Nibi Kalan BO": "211019",
      "Rampur Kotwa BO": "229413",
      "Narainganj BO": "212507",
      "Hathigahan BO": "211013",
      "Ismailganj BO": "211013",
      "Jagdishpur BO": "221503",
      "Madhonagar Bigahia BO": "211013",
      "Deewanganj BO": "212402",
      "Kapsa BO": "212402",
      "Belwa BO": "221507",
      "Garapur BO": "221507",
      "Paranipur BO": "212305",
      "Ramnagar BO": "212305",
      "Unchdeeh BO": "212305",
      "Upraura BO": "212305",
      "Bilari BO": "221502",
      "Jaswan BO": "221502",
      "Newada BO": "212507",
      "Nindula BO": "212401",
      "Patwa BO": "212401",
      "Pipari BO": "212401",
      "Chhibaiya BO": "211019",
      "Parewa Narainpur BO": "229413",
      "Piyari Urf Bijlipur BO": "229413",
      "Bakajalalpur BO": "212507",
      "Chhata BO": "212507",
      "MohdPur Gheempur BO": "212507",
      "Nai Bazar BO": "212507",
      "Tejpur BO": "212507",
      "Bahadurgarh Arwasi BO": "212402",
      "Chamrupur Urf Nantaut BO": "212402",
      "Saraj Mamrej BO": "221507",
      "Silaundhi BO": "212301",
      "Tilakhwar BO": "212301",
      "Rokari BO": "212307",
      "Bhageshar BO": "212306",
      "Chiraon BO": "212306",
      "Handia Manpur BO": "212306",
      "Kush Fara BO": "212306",
      "Misirpur BO": "212306",
      "Sansarpur BO": "212306",
      "Ahmedpur Pawan BO": "212208",
      "Fatehpur Ghat BO": "212208",
      "Pura Mufti ED BO": "212208",
      "Hetapatti BO": "221507",
      "Aunta BO": "212303",
      "Bhaganpur BO": "212303",
      "Lotarh BO": "212303",
      "Kathauli BO": "212303",
      "Belhat BO": "212302",
      "Bhatauti BO": "212302",
      "Pasna BO": "212302",
      "Arail BO": "211008",
      "Bhandiwar BO": "212108",
      "Newadhiya Uparhar BO": "212108",
      "Bigahuna BO": "212305",
      "Dohariya BO": "212305",
      "Dubeypur BO": "212305",
      "Balraj Nagar BO": "229412",
      "Serawan BO": "229412",
      "Bithauli BO": "221502",
      "Girdkot BO": "221502",
      "Kewai Buzurg BO": "221502",
      "Bagai Khurd BO": "212404",
      "Bamaila BO": "221503",
      "Haripur Marron BO": "221503",
      "Jaguwa BO": "221503",
      "Shahipur BO": "221503",
      "Nibi Bari BO": "212401",
      "Chhatnag BO": "211019",
      "Andhiyaari BO": "229413",
      "Biharia BO": "229413",
      "Chhitpalgarh BO": "212507",
      "Mehraunda BO": "212507",
      "Siswan BO": "212507",
      "Umariasari BO": "212507",
      "Sewaith BO": "211013",
      "Gorigon BO": "212402",
      "Basgit Bazar BO": "221508",
      "Buir BO": "221508",
      "Dhokari BO": "221508",
      "Baharia Bazar BO": "212109",
      "Bomapur BO": "212109",
      "Kahli BO": "212109",
      "Badagaon BO": "212502",
      "Bari BO": "212502",
      "Jalalpur Kasba BO": "212402",
      "Katrauli BO": "212402",
      "Pratappur BO": "212402",
      "Singra Mau BO": "221507",
      "Sonai BO": "212301",
      "Bhunda BO": "212307",
      "Panasa BO": "212307",
      "Baraha BO": "212307",
      "Bisari BO": "212306",
      "Deoghat BO": "212306",
      "Mahuli BO": "212306",
      "Nathupur BO": "212306",
      "Ramgarh BO": "212306",
      "Mohdpur Taluka BO": "212208",
      "Ashey  Pur BO": "221508",
      "Dumduma BO": "221508",
      "Motiha BO": "221508",
      "Sikikhurda BO": "221508",
      "Kamlanagar BO": "212109",
      "Kumhauna BO": "212109",
      "Chandpur BO": "212502",
      "Babhani Hethar BO": "212303",
      "Masauli BO": "212303",
      "Newadhiya BO": "212303",
      "Bhaiyan BO": "212302",
      "Siki Kalan BO": "212302",
      "Tigza BO": "212302",
      "Bihariya BO": "212108",
      "Jawaniya BO": "212305",
      "Mansoorabad BO": "229411",
      "Pure Ghasi BO": "229411",
      "Bajha Mazra Lohia Nagar BO": "229412",
      "Ulda BO": "229412",
      "Atraura BO": "221502",
      "Dhobaha BO": "221502",
      "Babuganj BO": "212404",
      "Katahra BO": "221503",
      "Sirsa Chauraha BO": "221503",
      "Nindura BO": "229413",
      "Harisenganj BO": "212507",
      "Kiraon BO": "212507",
      "Gohari BO": "211013",
      "Malak Harhar BO": "211013",
      "Chandopara BO": "212402",
      "Deoli BO": "212402",
      "Kanethi BO": "212402",
      "Mailahan BO": "212402",
      "Ramgarh Kothari BO": "212402",
      "Babhan Kuiyan BO": "221507",
      "Deonahri BO": "221507",
      "Mendewa BO": "221507",
      "Umari BO": "221507",
      "Sehuadeeh BO": "212402",
      "Arahkala BO": "221508",
      "Khaptiha BO": "221508",
      "Utraon BO": "221508",
      "Karnaipur BO": "212109",
      "Allahabad HO": "211001",
      "Allahabad Kty HO": "211002",
      "Allahabad Chowk SO": "211003",
      "Allahabad City SO": "211003",
      "C D A P SO": "211014",
      "Agriculture Institute SO": "211007",
      "Allahabad New Cantt SO": "211001",
      "Attarsuiya SO": "211003",
      "Bahadurganj SO Allahabad": "211003",
      "Begumsarai SO": "211011",
      "Ahmadganj SO": "211003",
      "Allahabad Fort SO": "211005",
      "Allahabad High Court SO": "211017",
      "Bamrauli SO": "211012",
      "Bharatganj SO": "212104",
      "Dhoomanganj SO": "211011",
      "I T I Naini SO": "211010",
      "Karchhana SO": "212301",
      "Koraon SO": "212306",
      "Meja SO": "212302",
      "New Bairahana SO": "211003",
      "Public Service Commission SO": "211018",
      "Dandupur SO": "212111",
      "Jasra SO": "212107",
      "Krishna Nagar SO": "211003",
      "Leader SO": "211001",
      "Malaka SO": "211001",
      "Purshottam Nagar SO": "211016",
      "Rajrooppur SO": "211011",
      "S N Marg SO": "211001",
      "Sirsa SO": "212305",
      "Hanumanganj SO": "221505",
      "Jhunsi SO": "211019",
      "Lalgopal Ganj SO": "229413",
      "M L N EnggColl": "211004",
      "Mau Aima SO": "212507",
      "Phoolpur SO": "212402",
      "Subhash Ngr SO": "211002",
      "Subedarganj SO": "211015",
      "Allahabad NDC": "211023",
      "Baraut SO": "221502",
      "Cavellary Lines SO": "211004",
      "Daraganj SO": "211006",
      "Ghiya Nagar SO": "212404",
      "Kamlanagar SO": "211002",
      "Ugrasen Pur SO": "212405",
      "Rajarshi Tondon Open University SO": "211021",
      "University SO": "211002",
      "CRPF Group Center Ismailganj SO": "211022",
      "Chheoki SO": "212105",
      "Hindi Sahitya Sammelan SO": "211003",
      "I L C SO": "211008",
      "Jari Bazar SO": "212106",
      "K N Marg SO": "211001",
      "Kalyani Devi SO": "211003",
      "Manauri SO": "212208",
      "Meja Road SO": "212303",
      "Mutthiganj SO": "211003",
      "Naini Pac SO": "211008",
      "S R Marg SO": "211003",
      "Shankargarh SO": "212108",
      "Allahpur SO": "211006",
      "Atrampur SO": "229412",
      "DisttBoard SO": "211002",
      "Handia SO": "221503",
      "Holagarh SO": "212503",
      "Indian Press SO": "211002",
      "Janghai Bazar SO": "212401",
      "Phaphamau SO": "211013",
      "Prayag SO": "211002",
      "Sikandra SO": "212109",
      "Sohbatia Bagh SO": "211006",
      "Soraon SO": "212502",
      "Central PO Kumbh Mela SO": "211020",
      "G T B Nagar SO": "211016",
      "Kesaria Road SO": "211016",
      "Khain SO": "212307",
      "Manauri AF SO": "212212",
      "Naini SO": "211008",
      "Prayag Mahila Vidyapith SO": "211003",
      "T S L SO": "211010",
      "Anapur SO": "229411",
      "George Town SO": "211002",
      "K G Marg SO": "211002",
      "Katra SO": "211002",
      "Nirala Chowk SO": "211006",
      "Rajapur SO": "211002",
      "Sahson SO": "221507",
      "Saidabad SO": "221508",
      "Parade West PO Kumbh Mela": "211020",
      "Jhunsi South PO Kumbh Mela": "211020",
      "Arail PO Kumbh Mela": "211020"
    },
    "LUCKNOW": {
      "NDC LUCKNOW GPO": "226001",
      "NDC Lucknow Chowk Ho": "226003",
      "Thakurganj BO": "226003",
      "SAIRPUR BO": "226201",
      "Saraura BO": "226201",
      "Amraigaon BO": "226028",
      "Juggaur BO": "226028",
      "Kathwara B.O": "226202",
      "Begariya Mau BO": "226501",
      "KASIMPUR BIRUHA  BO": "226501",
      "Bahargaon BO": "226203",
      "Kumharawan BO": "226203",
      "Anaura Kalan BO": "226028",
      "Goila BO": "226028",
      "Raitha BO": "226202",
      "Mahmoodpur BO": "226501",
      "Rasoolpur Tikaniamau BO": "226501",
      "Salempur BO": "226501",
      "Sathwara BO": "226501",
      "Arjunpur BO": "226203",
      "Bibipur BO": "226203",
      "Jamkhanwa BO": "226203",
      "Kharika BO": "226002",
      "Batha Sabauli BO": "226021",
      "Ghaila BO": "226013",
      "Chandrawal BO": "226002",
      "Hasanpur Keoli BO": "226002",
      "Nilmatha BO": "226002",
      "Maleshemau BO": "226010",
      "Diguria BO": "226013",
      "BASHA BO": "226026",
      "Gudamba BO": "226026",
      "Rajauli BO": "226026",
      "Laulai BO": "226028",
      "Malhaur BO": "226028",
      "Rasoolpur Saadat BO": "226028",
      "Amethi BO": "226501",
      "Akariakalan BO": "226203",
      "Alamnagar BO": "226017",
      "ASTI BO": "226201",
      "Bhauli BO": "226201",
      "Jagdishpur BO": "226201",
      "Khantari BO": "226201",
      "Neewan BO": "226401",
      "HASNAPUR BO": "226501",
      "Amaniganj BO": "226203",
      "Ateswa BO": "226203",
      "Indara BO": "226203",
      "T Tib BO": "226003",
      "Kamlabad Badauli BO": "226201",
      "Kotwa BO": "226201",
      "Rahimnagar Padiyana BO": "226401",
      "Mahigawan BO": "226203",
      "Mahona BO": "226203",
      "Dona BO": "226101",
      "Kahla BO": "226102",
      "Baddaiyan BO": "226104",
      "Narosa BO": "226203",
      "Paharpur BO": "226203",
      "Sarai Damu BO": "226203",
      "Khushalganj BO": "226101",
      "Malha BO": "226101",
      "Rehman Khera BO": "226101",
      "Bhadwana BO": "226102",
      "Dhendhemau BO": "226102",
      "Ant Garhi": "226104",
      "Atari BO": "226104",
      "Raghunathpur BO": "226104",
      "Ranipara BO": "226104",
      "Salehnagar BO": "226104",
      "Thari BO": "226104",
      "Bhilampur BO": "226301",
      "Kankaha BO": "226301",
      "Mati BO": "226002",
      "Utrethia BO": "226002",
      "Kushmaura BO": "226301",
      "Keoli BO": "226303",
      "Dayalpur BO": "226302",
      "Mastipur BO": "226302",
      "Sahinjana B O": "226103",
      "Suspan B O": "226103",
      "Amausi BO": "226008",
      "C E School BO": "226008",
      "Arjunganj BO": "226002",
      "Bakkash BO": "226002",
      "Barauna BO": "226002",
      "Bhadrukh BO": "226002",
      "Bijnaur BO": "226002",
      "Chaupatiyan BO": "226003",
      "Amberganj BO": "226003",
      "Nadan Mahal BO": "226003",
      "Bauromau BO": "226201",
      "Ain BO": "226401",
      "Aurawan BO": "226401",
      "Bani BO": "226401",
      "Benti BO": "226401",
      "Bhatgaon BO": "226401",
      "Garhi Chunauti BO": "226401",
      "Harauni BO": "226401",
      "Tirwa BO": "226401",
      "Singhamau BO": "226203",
      "Usarana BO": "226203",
      "Amethia Salempur BO": "226101",
      "Baragaon BO": "226101",
      "Gohramau BO": "226101",
      "Khalispur BO": "226101",
      "Kasmandi Kalan BO": "226102",
      "Kasmandi Khurd BO": "226102",
      "Katauli BO": "226102",
      "Mahmoodnagar BO": "226102",
      "Sindhrawan BO": "226102",
      "Gahdon BO": "226104",
      "Gopramau BO": "226104",
      "Khandsara BO": "226104",
      "Bhadeswa BO": "226301",
      "Barwalia BO": "226301",
      "Mohari Khurd BO": "226301",
      "Purseni BO": "226301",
      "Sarai Gudauli BO": "226301",
      "Daulatpur BO": "226103",
      "Gaunda BO": "226103",
      "Sadrauna BO": "226008",
      "Bazargaon BO": "226104",
      "Munnu Khera BO": "226104",
      "Patauna BO": "226104",
      "Thawar BO": "226104",
      "Deoti BO": "226301",
      "Jaitikhera BO": "226301",
      "Kalli Pacchim BO": "226301",
      "Sisendi BO": "226301",
      "Bahrauli BO": "226303",
      "Karora BO": "226303",
      "Samesi BO": "226303",
      "Meerak Nagar BO": "226302",
      "Jamolia BO": "226103",
      "Mawai Kalan BO": "226103",
      "Int Gaon BO": "226008",
      "Mawai Padiyana BO": "226008",
      "Chakganjaria BO": "226002",
      "Madiyaon BO": "226021",
      "Behta BO": "226026",
      "Bahroo BO": "226101",
      "Barawan Kalan BO": "226101",
      "Dilawarnagar BO": "226102",
      "Kakrabad BO": "226102",
      "Bahraura BO": "226104",
      "Bhagwantpur BO": "226104",
      "Mawai Khurd BO": "226104",
      "Nabipanah BO": "226104",
      "Umrawal BO": "226104",
      "Beerpur BO": "226104",
      "Jabrauli BO": "226301",
      "Adampur Janubi BO": "226303",
      "Chatauni BO": "226303",
      "Utrawan BO": "226302",
      "Jindaur BO": "226103",
      "Rusena BO": "226103",
      "Maunda BO": "226008",
      "Piparsand BO": "226008",
      "Lucknow GPO": "226001",
      "Lucknow Chowk HO": "226003",
      "Narain Nagar SO": "226016",
      "Secd Indiranagar SO": "226016",
      "Sgpgi SO": "226014",
      "Topkhana Bazar SO": "226002",
      "Sarvoday Nagar SO": "226016",
      "Secretariat SO Lucknow": "226001",
      "Aishbagh SO": "226004",
      "Banthara SO Lucknow": "226401",
      "Barha SO": "226005",
      "CW Workshop SO": "226005",
      "FFTC INDAURABAGH SO": "226202",
      "Golaganj SO": "226018",
      "Gosainganj SO": "226501",
      "Gurdwara SO": "226004",
      "Hussainabad SO": "226003",
      "Kakori SO": "226101",
      "MANAS NAGAR SO": "226023",
      "Medical College SO": "226003",
      "Mill Road SO": "226004",
      "Mohanlalganj SO": "226301",
      "Nagram SO": "226303",
      "Sanatan Dharam Vidya Peeth SO": "226026",
      "Vikas Nagar SO": "226022",
      "Vineet Khand SO": "226010",
      "A N L Colony SO": "226004",
      "Avas Vikas Colony SO Lucknow": "226017",
      "Chinhat SO": "226028",
      "Hasnain Market SO": "226003",
      "Indira Nagar SO": "226016",
      "LOCOMOTIVE WORKSHOP SO": "226005",
      "MALL SO": "226104",
      "Navinmandi SO": "226020",
      "New Ganeshganj SO": "226018",
      "R B Colony SO": "226018",
      "R G C Mill SO": "226017",
      "UPG Camp SO": "226027",
      "Victoriaganj SO": "226003",
      "AP Sabha SO": "226001",
      "Aliganj Extension SO": "226024",
      "Aliganj SO": "226024",
      "Chandganj SO": "226024",
      "D S Bazar SO": "226002",
      "Indiranagar Sec18 SO": "226016",
      "Jawahar Bhawan SO": "226001",
      "Kalyanpur SO Lucknow": "226022",
      "M N Colony SO": "226006",
      "NAUBASTA SO LUCKNOW": "226003",
      "R A College SO": "226004",
      "R P Line SO": "226007",
      "Rahimabad SO": "226103",
      "Raja Bazar SO": "226003",
      "Rajendranagar SO Lucknow": "226004",
      "Sarojini Nagar SO": "226008",
      "Sunderbagh SO": "226018",
      "VISHAL KHAND SO": "226010",
      "B R A University SO": "226025",
      "C B Lines SO": "226002",
      "Dilkusha SO": "226002",
      "Gomti Nagar SO": "226010",
      "Gomtinagar Vistar SO": "226010",
      "H E School SO": "226006",
      "Industria Area Chinhat SO": "226019",
      "Maharishi Vidya Mandir SO": "226020",
      "Adarsh Nagar SO": "226005",
      "Aminabad Park SO": "226018",
      "Bakshi Ka Talab SO": "226201",
      "Balrampur Hospital SO": "226018",
      "Charbagh SO": "226004",
      "D M Road SO": "226020",
      "Ganeshganj SO": "226018",
      "H C Bench SO": "226010",
      "Industrial Area SO": "226009",
      "Itaunja SO": "226203",
      "LDA Colony SO": "226012",
      "Loni Katra SO": "226020",
      "MANAK NAGAR SO": "226011",
      "NADWA SO": "226007",
      "Niralanagar SO": "226020",
      "Pandariba SO": "226004",
      "Pawanpuri SO Lucknow": "226005",
      "Shivaji Marg SO Lucknow": "226018",
      "Sujanpura SO": "226005",
      "Triveni Nagar SO": "226020",
      "Yahiaganj SO": "226003",
      "Sushant Golf City SO": "226030",
      "Old High Court Campus S.O": "226001",
      "Canal Colony SO": "226001",
      "Darul Safa SO": "226001",
      "Ghazipur SO Lucknow": "226016",
      "IIT Dasauli SO": "226026",
      "Jankipuram SO": "226021",
      "Military Hospital SO": "226002",
      "New Hyderabad SO": "226007",
      "Sant Market SO": "226006",
      "Shia Lines SO": "226002",
      "Vishwas Khand SO": "226010",
      "32 Bn PAC SO Lucknow": "226023",
      "Ashiana Colony SO": "226012",
      "Alambagh SO": "226005",
      "AMAUSI AD SO": "226009",
      "Anand Nagar SO": "226005",
      "Arya Nagar SO": "226004",
      "Blunt Square SO": "226004",
      "CPMG Campus SO": "226001",
      "Daliganj SO": "226020",
      "Malihabad SO": "226102",
      "Mansoor Nagar SO": "226003",
      "Naya Gaon SO": "226018",
      "Nigohan SO": "226302",
      "Rajajipuram SO": "226017",
      "Saadatganj SO Lucknow": "226003",
      "Sarai Mali Khan SO": "226003",
      "Sarfraj SO": "226003",
      "Sector B Indira Nagar SO": "226016",
      "Singar Nagar SO": "226005",
      "Vrindavan Colony SO": "226029",
      "Wazirganj SO Lucknow": "226018",
      "CRPF Bijnore SO Lucknow": "226002",
      "SNI AREA SO": "226008",
      "Cimap SO": "226015",
      "Gokhley Marg SO": "226001",
      "Hal SO Lucknow": "226016",
      "IIM Lucknow SO": "226013",
      "Indiranagar Sec14 SO": "226016",
      "Indiranagar Sec21 SO": "226016",
      "Jankipuram Extension SO": "226031",
      "Lalbagh SO Lucknow": "226001",
      "Mahanagar SO": "226006"
    },
    "ALIGARH": {
      "NDC Aligarh": "202001",
      "Digsari BO": "202123",
      "Kemthal BO": "202123",
      "Majhola BO": "202134",
      "Manena Ummedpur BO": "202134",
      "Fatehgarhi BO": "202135",
      "Kasison BO": "202135",
      "Khera Sattu BO": "202135",
      "Madanpur BO": "202135",
      "Shiwala BO": "202135",
      "Pachawari BO": "202123",
      "Paindapur BO": "202123",
      "Talesara BO": "202123",
      "Bhavigarh BO": "202125",
      "Chhadawali BO": "202125",
      "Gurushikharan BO": "202125",
      "Rukhala BO": "202134",
      "Aidalpur BO": "202135",
      "Nagla Birkhu BO": "202123",
      "Nagla Jhujhar BO": "202123",
      "Rajawal BO": "202123",
      "Kalai BO": "202125",
      "Narona Akapur BO": "202125",
      "Sadhu Ashram BO": "202125",
      "PilAkhna": "202121",
      "Naugawan BO": "202134",
      "Ahraula BO": "202135",
      "Bankner BO": "202135",
      "Manti Basai BO": "202123",
      "Nagla Jagdeo BO": "202123",
      "Sehri Madangarhi BO": "202123",
      "Dhantauli BO": "285001",
      "Barotha BO": "202125",
      "Budhansi BO": "202125",
      "Jhijharka BO": "202280",
      "Khan Alampur BO": "202125",
      "Ukhlana BO": "202125",
      "Balwant Nagaria BO": "202143",
      "Jaidpura BO": "202165",
      "Malav BO": "202165",
      "Siarol BO": "202165",
      "Simrauthi BO": "202165",
      "Bazidpur BO": "250611",
      "Deopur BO": "202143",
      "Madhaula BO": "202143",
      "Gharbara BO": "202165",
      "Deorau BO": "202143",
      "Pahawati BO": "202143",
      "Bena BO": "202165",
      "Gorola BO": "202165",
      "Utasani BO": "202165",
      "Bhimpur BO": "202142",
      "Chilawati BO": "202142",
      "Rampur Shahpur BO": "202142",
      "Udaipur BO": "202142",
      "Sudeshpur BO": "202132",
      "Bhamora Kalan BO": "202130",
      "Bhikampur BO": "202130",
      "Habibganj BO": "202130",
      "Abhaipur Behlolpur BO": "202133",
      "Mandpur BO": "202133",
      "Nah BO": "202133",
      "Narupura BO": "202133",
      "Paitra Nawabpur BO": "202133",
      "Rajpur B.O": "202141",
      "Ranjeet Garhi BO": "202141",
      "Resari BO": "202141",
      "Kandauli BO": "202136",
      "Kanoi BO": "202136",
      "Budha Gaon BO": "202134",
      "Kanobi BO": "202134",
      "Gehtoli Nirmal BO": "202131",
      "Nahal BO": "202131",
      "Nagla Padam BO": "202132",
      "Ogipur BO": "202132",
      "Alampur Fatehpur BO": "202133",
      "Bonai BO": "202133",
      "Dinapur BO": "202133",
      "Haranpur Kalan BO": "202133",
      "Jirauli BO": "202133",
      "Khandua BO": "202133",
      "Lehra BO": "202133",
      "Sankra BO": "202133",
      "Zafar Manzil BO": "202133",
      "Dewa Hamidpur BO": "202141",
      "Salpur BO": "202141",
      "Takipur BO": "202141",
      "Umri BO": "246761",
      "Korah Rustampur BO": "202136",
      "Mohrena BO": "202136",
      "Bhaiyan BO": "202124",
      "Kajrauth BO": "202124",
      "Kalayanpur Bhagirathpur BO": "202281",
      "Matroi BO": "202124",
      "Mohreni BO": "202124",
      "Sahara Khurd BO": "202124",
      "Kakethal BO": "202281",
      "Lohgarh BO": "202281",
      "Salarpur BO": "202282",
      "Baranadi BO": "202128",
      "Rehsupur BO": "202128",
      "Sheikhupur BO": "202128",
      "Palsera BO": "202137",
      "Pempur BO": "202137",
      "Jalalpur BO": "202155",
      "Shadipur BO": "202137",
      "Songra BO": "202126",
      "Parki BO": "202127",
      "Hasona Jagmohanpur BO": "202129",
      "Kutubour Amarpur BO": "202129",
      "Pahari Pur BO": "202129",
      "Phusauli BO": "202129",
      "Pipoli BO": "202129",
      "Arrana BO": "202138",
      "Bamani BO": "202138",
      "Bamoti BO": "202138",
      "Bisara BO": "202138",
      "Jarara B.O": "202138",
      "Pala Chand BO": "202138",
      "Dunai BO": "202140",
      "Ismailpur BO": "202140",
      "Jiroli Dor BO": "202140",
      "Rait BO": "202140",
      "Sabalpur BO": "202155",
      "Pali Mukimpur BO": "202131",
      "Pipari BO": "202131",
      "Hinsel BO": "202142",
      "Amritpur BO": "202132",
      "Kaseru BO": "202132",
      "Sunpahar BO": "202130",
      "Harnaut BO": "202133",
      "Kaser BO": "202133",
      "Rajpur Khas BO": "202133",
      "Rampur Chandyana BO": "202133",
      "Sahjahanpur Baijna BO": "202133",
      "Bharatpur BO": "202141",
      "Karanpur BO": "202142",
      "Narainpur BO": "202141",
      "Sahajpura BO": "202141",
      "Sujanpur BO": "262907",
      "Pothi BO": "202136",
      "Tamkoli BO": "202136",
      "Badhari Bujurg BO": "202134",
      "Dabha BO": "202121",
      "Suhawali BO": "202121",
      "Bahadurpur Kota BO": "202122",
      "Ahmedpur BO": "202002",
      "Aisi BO": "202002",
      "Bhankri Ahiwasi BO": "202150",
      "Bidirka BO": "202002",
      "Hastpur Chandfari BO": "202124",
      "Jallupur Sehore BO": "202002",
      "Kamalpur BO": "202002",
      "Konchhor BO": "202002",
      "Naglamandir BO": "202002",
      "Panethi BO": "202002",
      "Sarsol BO": "202002",
      "Kalyanpur  Rani BO": "202281",
      "Orani Dalpatpur BO": "202280",
      "Teothu BO": "202280",
      "Jatwar BO": "202145",
      "Bistauli BO": "202170",
      "Gangrol BO": "202170",
      "Badesara BO": "202131",
      "Simardhari BO": "202124",
      "Bajauta BO": "202137",
      "Maur BO": "202137",
      "Sumera BO": "202126",
      "Chhalesar BO": "202127",
      "Godha BO": "202127",
      "Khera Bujurg BO": "202127",
      "Utra BO": "202129",
      "Datawali BO": "283203",
      "Bhanauli BO": "202140",
      "Jamuna BO": "202282",
      "Klyanpur BO": "202282",
      "Malikpura BO": "202150",
      "Shahabajpur BO": "202150",
      "Shahpur Madrak BO": "202150",
      "Jalokhari BO": "202155",
      "Madha Habibpur BO": "202155",
      "Mehgora BO": "202155",
      "Mirpur Khas BO": "202155",
      "Allahdadpur  BO": "202002",
      "Beethna BO": "202002",
      "Bhadesi BO": "202002",
      "Bhankri Niranjankot BO": "202002",
      "Bhemti BO": "202002",
      "Dhanipur BO": "202002",
      "Shahpur Kutub BO": "202002",
      "Behrabad BO": "202280",
      "Bhangra BO": "202145",
      "Chandaua Goverdhanapur BO": "202131",
      "Dudhma BO": "202131",
      "Sarai Kutub BO": "202001",
      "Khair Mandi BO": "202138",
      "Naurangabad BO": "202001",
      "Khera Narain Singh BO": "202121",
      "Khurrampur BO": "202121",
      "Ladhaua BO": "202121",
      "Manai BO": "202121",
      "Chherat BO": "202122",
      "Pala Kastali BO": "202122",
      "Sikandarpur Kota BO": "202122",
      "Siya Khas BO": "202122",
      "Digsi BO": "202002",
      "Govindpur Fagoi BO": "202002",
      "Mahua BO": "202002",
      "Mehrawal BO": "202002",
      "Mukandpur BO": "202002",
      "Nagla Devi BO": "202002",
      "Chhabilpur BO": "202280",
      "Ganiyabali BO": "202280",
      "Ghazipur BO": "202280",
      "Izzatpur BO": "202280",
      "Gorai BO": "202145",
      "Mohkampur Garia BO": "202145",
      "Sathini BO": "202145",
      "Sudama Ka Bas BO": "202145",
      "Tamotia BO": "202145",
      "Kathera BO": "202170",
      "Panehra BO": "202131",
      "Rajatau BO": "202131",
      "Nagla Sarua BO": "202142",
      "Bhagatpur BO": "202132",
      "Bharpur BO": "202132",
      "Bain Kalan BO": "202130",
      "Dhansari BO": "202130",
      "Siroli BO": "202130",
      "Hardoi BO": "202133",
      "Rajmau BO": "202133",
      "Ramnagar BO": "202133",
      "Jamonka BO": "202141",
      "Kilpur BO": "202141",
      "Parai BO": "202136",
      "Bilona Chitsari BO": "202134",
      "Gidauli BO": "202124",
      "Salempur BO": "202124",
      "Bhojpur Nuri BO": "202281",
      "Hetalpur BO": "202137",
      "Khandeha BO": "202137",
      "Barauli B.O": "202126",
      "Debthala BO": "202126",
      "Sikharna BO": "202127",
      "Alampur Rani   BO": "202129",
      "Bhilet Ramnagar BO": "202129",
      "Usram BO": "202138",
      "Andla BO": "202140",
      "Beharipur BO": "202140",
      "Majupur BO": "202140",
      "Atrauli Ro RS BO": "202282",
      "Kazimabad BO": "202282",
      "Sahnaul BO": "202282",
      "Gadrana BO": "202150",
      "Musepur Jalal BO": "202150",
      "Deta Khurd BO": "202155",
      "Sasni Gate BO": "202001",
      "Jiroli Hira Singh BO": "202121",
      "Mandanpur BO": "202121",
      "Tuamai BO": "202121",
      "Amrauli BO": "202122",
      "Adaun BO": "202002",
      "Gursena BO": "202124",
      "Kalwa BO": "202002",
      "Kesopur jofari BO": "202140",
      "Pala Aisi BO": "202002",
      "Quarsi BO": "202002",
      "Madholi BO": "202280",
      "Pureni BO": "202280",
      "Jamaun BO": "202145",
      "Khirsauli BO": "202145",
      "Maisubhasgram BO": "202145",
      "Chhonk BO": "202170",
      "Chhaichhau BO": "202124",
      "Harautha BO": "202124",
      "Kalua Bhilet BO": "202124",
      "Gahlau BO": "202124",
      "Bembirpur BO": "202281",
      "Chakathal BO": "202281",
      "Changeri BO": "202128",
      "Jatrauli BO": "202137",
      "Baraula BO": "202126",
      "Daheli BO": "202126",
      "Daupur BO": "202126",
      "Pilona BO": "202126",
      "Satha BO": "202127",
      "Sunamai BO": "202127",
      "Talib Nagar BO": "202127",
      "Barla BO": "202129",
      "Shahagarh BO": "202129",
      "Achna BO": "202138",
      "Sawai Raghunathpur BO": "202138",
      "Utwara BO": "202138",
      "Akrawat BO": "202140",
      "Badon BO": "202140",
      "Kiratpur Nimana BO": "202140",
      "Shikharan BO": "202140",
      "Badholi BO": "202282",
      "Madrak BO": "202150",
      "Tappal SO": "202165",
      "Upperkot SO": "202001",
      "Vishnupuri SO": "202001",
      "Aligarh HO": "202001",
      "Aligarh Dairy Farm S.O": "202122",
      "Aligarh Muslim University S.O": "202002",
      "Bijauli S.O": "202131",
      "Birpura S.O": "202142",
      "Chandaus S.O": "202132",
      "Dayal Nagar SO": "202141",
      "Gomat SO": "202135",
      "Jalali SO": "202128",
      "Kasimpur SO": "202127",
      "Kauriyaganj SO": "202129",
      "Mahavir Ganj SO": "202001",
      "Manik Chowk SO": "202001",
      "Medical College SO Aligarh": "202002",
      "Somna SO": "202143",
      "Subhash Road SO Aligarh": "202001",
      "T R M M Aligarh SO": "202001",
      "Aligarh City S.O": "202001",
      "Atrauli S.O": "202280",
      "Bannadevi S.O": "202001",
      "Bijaigarh S.O": "202170",
      "Civil Court SO Aligarh": "202001",
      "D S College SO": "202001",
      "Khair SO": "202138",
      "Lodha SO": "202140",
      "Malviya Nagar SO Aligarh": "202282",
      "N C Kasimpur SO": "202127",
      "Palirajapur SO": "202150",
      "Beswan S.O": "202145",
      "Dadon SO": "202133",
      "Dodhpur SO": "202001",
      "Form Press SO": "202001",
      "Akrabad S.O": "202121",
      "Chharra SO": "202130",
      "Delhi Gate SO Aligarh": "202001",
      "Gabhana SO": "202136",
      "Gonda SO": "202123",
      "Iglas SO": "202124",
      "Industrial Area Aligarh SO": "202001",
      "J D Singh SO": "202281",
      "Jawan SO": "202126",
      "Kutchery SO Aligarh": "202001",
      "Madar Darwaja SO": "202001",
      "Mangalayatan University SO": "202146",
      "Pisawah SO": "202155",
      "Ramghat Road SO": "202001",
      "Sarai Labaria SO": "202001",
      "Gandhi Eye Hospital SO": "202001",
      "Gangiri SO": "202134",
      "Harduaganj SO": "202125",
      "I T I Road SO": "202001",
      "Jaiganj SO": "202001",
      "Jattari SO": "202137",
      "Rasal Ganj SO": "202001",
      "Sarai Khirni SO": "202001"
    },
    "JHANSI": {
      "NDC Jhansi": "284001",
      "Amrokh BO": "284303",
      "Bharosa BO": "284303",
      "Chelra BO": "284303",
      "Kharauwa BO": "284303",
      "Kumhrar BO": "284303",
      "Patti Kumharra BO": "284303",
      "Amgaon BO": "284306",
      "Pali Pahari BO": "284419",
      "Rajapur BO": "284419",
      "Bangra BO": "284205",
      "Gairaha BO": "284205",
      "Kachneo BO": "284205",
      "Magarpur BO": "284205",
      "Palra BO": "284205",
      "Uldan BO": "284205",
      "Lahar Gird BO": "284003",
      "Bijna BO": "284206",
      "Pandwaha BO": "284206",
      "Old Mau BO": "284204",
      "Ladawra BO": "284303",
      "Lawan BO": "284303",
      "Nandkhas BO": "284303",
      "Pandori BO": "284303",
      "Ambabai BO": "284419",
      "Khisni Buzurg BO": "284205",
      "Luhari BO": "284205",
      "Padra BO": "284205",
      "Chheonta BO": "284304",
      "Chirgaon Khurd BO": "284304",
      "Garhiagaon BO": "284003",
      "Barhwar BO": "284206",
      "Dhurwai BO": "284206",
      "Pasaura BO": "284206",
      "Rora Bhatpura BO": "284204",
      "Rupa Dhamna BO": "284204",
      "Saipura BO": "284204",
      "Siaori BO": "284204",
      "Sijari Buzurg BO": "284204",
      "Kochha Bhanwar BO": "284128",
      "Atariya BO": "284303",
      "Bakwan BO": "284303",
      "Basobai BO": "284303",
      "Belma Kalan BO": "284303",
      "Jaunra BO": "284303",
      "Pulia BO": "284303",
      "Semri BO": "284303",
      "Shahjahanpur BO": "284303",
      "Talaud BO": "284303",
      "Nari BO": "284306",
      "Pahargaon BO": "284306",
      "Sersa BO": "284306",
      "Sesha BO": "284306",
      "Ratausa BO": "284205",
      "Sakrar BO": "284205",
      "Badokhari BO": "284304",
      "Roni Baragaon BO": "284204",
      "Amra BO": "284303",
      "Bheonraghat BO": "284303",
      "Karkos BO": "284303",
      "Kumhariya BO": "284303",
      "Reo BO": "284303",
      "Simiriya BO": "284303",
      "Tori BO": "284303",
      "Khilli BO": "284306",
      "Dangarwaha BO": "284419",
      "Punaoli Kalan BO": "284419",
      "Amanpurawar BO": "284205",
      "Deori Singhpura BO": "284205",
      "Ghurat BO": "284205",
      "Katera BO": "284205",
      "Pathguwan BO": "284205",
      "Siaoni Khurd BO": "284205",
      "Vijay Garh BO": "284205",
      "Sakin BO": "284304",
      "Karari BO": "284003",
      "Lohagarh BO": "285205",
      "Haiwatpura BO": "284204",
      "Kakwara BO": "284204",
      "Kureecha BO": "284204",
      "Mahewa BO": "284204",
      "Dhamna Payak BO": "284204",
      "Dhawakar BO": "284204",
      "Ghat Lehchura BO": "284204",
      "Markuan BO": "284204",
      "Rewan BO": "284204",
      "Dhamnakhurd BO": "284121",
      "Garhmau BO": "284121",
      "Jonri Buzurg BO": "284121",
      "Palar BO": "284121",
      "Ghughuwa BO": "284201",
      "Taindol BO": "284201",
      "Bhagwantpura BO": "284127",
      "Khajraha Buzurg BO": "284120",
      "Khajraha Khurd BO": "284120",
      "Mathurapura BO": "284120",
      "Ram Nagar BO": "284301",
      "Siya BO": "284301",
      "Asta BO": "284202",
      "Sarsenda BO": "284202",
      "Sutta BO": "284202",
      "Tehrauli BO": "284202",
      "Bhojala BO": "284002",
      "Banka Pahari BO": "284204",
      "Barauri BO": "284204",
      "Berwai BO": "284204",
      "Bhadarwara BO": "284204",
      "Bijaura BO": "284204",
      "Bonda BO": "284204",
      "Churara BO": "284204",
      "Bijauli BO": "284135",
      "Ghisauli BO": "284401",
      "Manpura BO": "284401",
      "Nayakhera BO": "284401",
      "Aupara BO": "284301",
      "Bajhera BO": "284301",
      "Jaryai BO": "284301",
      "Iskil BO": "284302",
      "Labhera BO": "284302",
      "Patha BO": "284302",
      "Kachir BO": "284203",
      "Kakarwai BO": "284203",
      "Khadaura BO": "284203",
      "Moti Katra BO": "284203",
      "Rampura BO": "284203",
      "BangraBangri": "284202",
      "Dhawari BO": "284202",
      "Garhwai BO": "284202",
      "Jakhaura BO": "284202",
      "Karguwan Khurd BO": "284202",
      "Boodha BO": "284002",
      "Sainyargate BO": "284002",
      "Aivani BO": "284204",
      "Dhaurra BO": "284204",
      "Ghat Kotra BO": "284204",
      "Itayal BO": "284204",
      "Patha Dhakarwara BO": "284204",
      "Hasari BO": "284135",
      "Burhpura BO": "284401",
      "Birguwan BO": "284121",
      "Ranguwan BO": "284121",
      "Ujyan BO": "284121",
      "Khailar BO": "284120",
      "Baral BO": "284301",
      "Karguwan BO": "284301",
      "Ahiraura BO": "284302",
      "Gonti BO": "284302",
      "Simardha BO": "284203",
      "Bamaur BO": "284202",
      "Dhanaura BO": "284202",
      "Ghuraiya BO": "284202",
      "Kuretha BO": "284202",
      "Nauta BO": "284202",
      "Isagarh BO": "284002",
      "Nandanpura BO": "284003",
      "Orchha Gate BO": "284002",
      "Akseo BO": "284204",
      "Bhandra Khilara BO": "284204",
      "Lalkurti Bazar": "284003",
      "Baidora BO": "284401",
      "Chanaoni BO": "284401",
      "Baratakalan BO": "284121",
      "Sarol BO": "284121",
      "Simraha BO": "284127",
      "Chamrauwa BO": "284120",
      "Pahari Buzurg BO": "284301",
      "Simthari BO": "284301",
      "Bilati Karke BO": "284302",
      "Dumrai BO": "284203",
      "Siya Kharka BO": "284203",
      "Baghaira BO": "284202",
      "Gokul BO": "284202",
      "Kudri BO": "284202",
      "Nagra BO": "284202",
      "Khushipura BO": "284002",
      "Bamhori BO": "284204",
      "Bhadarwara Khurd BO": "284204",
      "Bhasneh BO": "284204",
      "JHANSI HO": "284001",
      "Babina Cantt SO": "284401",
      "Barwasagar SO": "284201",
      "C  W Workshop SO": "284003",
      "Chirgaon SO Jhansi": "284301",
      "Mauranipur SO": "284204",
      "Poonchh SO": "284306",
      "Samthar SO": "284304",
      "Abbotganj SO": "284003",
      "Babina Town SO": "284401",
      "Bhattagaon SO": "284127",
      "Mlb Medical College SO": "284128",
      "Moth SO": "284303",
      "Raksa SO": "284419",
      "Ranipur SO Jhansi": "284205",
      "Subhashganj SO": "284002",
      "33 Bn Pac Jhansi SO": "284135",
      "BHEL SO Jhansi": "284120",
      "Ayurvedic University SO": "284003",
      "Bara Bazar SO Jhansi": "284002",
      "Baragaon SO Jhansi": "284121",
      "Erich SO": "284302",
      "Gursarai SO": "284202",
      "Jhansi Cantt SO": "284001",
      "Jhansi City SO": "284002",
      "Jhansi Railway Station SO": "284003",
      "Mauranipur Bus Stand SO": "284204",
      "Naria Bazar SO": "284002",
      "Parichha Thermal Power Project SO": "284305",
      "Premnagar SO Jhansi": "284003",
      "Sipri Bazar SO": "284003",
      "Tori Fatehpur SO": "284206",
      "Bundelkhand University SO": "284128",
      "Chauraha Municipal Board SO": "284001",
      "Garautha SO": "284203",
      "Jhansi Kutchery SO": "284001",
      "Jhansi Sadar Bazar SO": "284001"
    },
    "SAHARANPUR": {
      "NDC Saharanpur": "247001",
      "Halalpur BO": "247001",
      "Sabdalpur BO": "247001",
      "Kailashpur BO": "247001",
      "Macharheri BO": "247001",
      "SHariya BO": "247001",
      "Kankarkui BO": "247001",
      "Badheri Ghoghu BO": "247001",
      "Randeva BO": "247340",
      "Raniyala Dayalpur BO": "247340",
      "Beera Kheri BO": "247340",
      "Mussail BO": "247120",
      "Randol BO": "247120",
      "Bhuradev BO": "247121",
      "Faizabad BO": "247121",
      "Jatonwala BO": "247121",
      "Sadholi Quadeem BO": "247121",
      "Budhakhera BO": "247231",
      "Lashkarpur BO": "247662",
      "Sherpur Khanazadpur BO": "247662",
      "Ambehta Shekhan BO": "247554",
      "B Majbatta BO": "247554",
      "Banhera Khas BO": "247554",
      "Gopali BO": "247554",
      "Kenduki BO": "247554",
      "Saraswati Nagar BO": "247554",
      "Chauradev BO": "247669",
      "Bansdei BO": "247341",
      "Dudhla BO": "247341",
      "Jandhera BO": "247341",
      "Khajnawar BO": "247129",
      "Dhangera BO": "247551",
      "Kota BO": "247551",
      "Paharpur BO": "247551",
      "Tansipur BO": "247551",
      "Badhi BO": "247342",
      "Nasrullahgarh BO": "247342",
      "Sirsaka BO": "247342",
      "Anantmau BO": "247452",
      "Bhabsi BO": "247452",
      "Ambehta Chand BO": "247451",
      "Jandhera Samaspur BO": "247451",
      "Sona Arjunpur BO": "247451",
      "Umahikalan BO": "247451",
      "Dhikka Kalan BO": "247232",
      "Gaderheri BO": "247232",
      "Pilakhni BO": "247232",
      "Mavi Kalan BO": "247001",
      "Shekhpura Qudeem BO": "247001",
      "Nandi Firozpur BO": "247001",
      "Phandpuri BO": "247001",
      "Harpal BO": "247001",
      "Nagrajpur BO": "247001",
      "Sunheti Kharkhari BO": "247001",
      "Tiwaya BO": "247001",
      "Pundain BO": "247001",
      "Ghunna BO": "247120",
      "Kasimpur BO": "247121",
      "Mirjapur Poll BO": "247121",
      "Raipur BO": "247232",
      "Toderpur BO": "247231",
      "Simbhalki Gujjar BO": "247662",
      "Tanko Sunderpur BO": "247662",
      "Bastam BO": "247554",
      "Bhaila Kalan BO": "247554",
      "Gangdaspur BO": "247554",
      "Kulsath BO": "247554",
      "Kuri BO": "247554",
      "Miragpur BO": "247554",
      "Rankhandi BO": "247554",
      "Jharwan BO": "247341",
      "Kunda Kalan BO": "247341",
      "Lakhnauti BO": "247341",
      "Rangail BO": "247341",
      "Mora BO": "247453",
      "Naya Gaon BO": "247453",
      "Shimlana BO": "247453",
      "Kurdi Khera BO": "247129",
      "Pandoli BO": "247551",
      "Paniyali Kasimpur BO": "247551",
      "Khudana BO": "247452",
      "Mahengi BO": "247452",
      "Bhankla BO": "247451",
      "Chakwali BO": "247451",
      "Ghathera BO": "247451",
      "Gudamb BO": "247451",
      "Alipura BO": "247232",
      "Dhakdei BO": "247001",
      "Malhipur BO": "247001",
      "Salempur Bhukheri BO": "247001",
      "Unali BO": "247001",
      "Dhaiki BO": "247340",
      "Dhorala BO": "247340",
      "Khera Afgan BO": "247340",
      "Rehri Tajpur BO": "247120",
      "Topri BO": "247120",
      "Bahera Sandal Singh BO": "247120",
      "Kamboh Majra BO": "247121",
      "Samaspur Naugaon BO": "247121",
      "Biharigarh BO": "247662",
      "Halwana BO": "247662",
      "Diwalheri BO": "247554",
      "Sakhan Khurd BO": "247554",
      "Sanpla Khatri BO": "247554",
      "Harora BO": "247669",
      "Khajuri Akbarpur BO": "247669",
      "Beenpur BO": "247341",
      "Niyamatpur BO": "247129",
      "Sansarpur BO": "247129",
      "Bachiti BO": "247551",
      "Aghiana BO": "247342",
      "Bhari BO": "247452",
      "Jandheri BO": "247452",
      "Islamnagar BO": "247451",
      "Nalhera Gujjar BO": "247451",
      "Pahansu BO": "247451",
      "Sherpur BO": "247451",
      "Shahjahanpur BO": "247232",
      "Sorana BO": "247232",
      "Telipura BO": "247232",
      "Nazirpura Devli BO": "247001",
      "Pheraheri BO": "247001",
      "Baliakheri BO": "247001",
      "Sadak Dudhli BO": "247001",
      "Randheri BO": "247340",
      "Kalsia BO": "247120",
      "Punwarka BO": "247120",
      "Jasmour BO": "247121",
      "Ruhalki BO": "247121",
      "Bartha Kayastha BO": "247231",
      "Khushalipur BO": "247662",
      "Mohand BO": "247662",
      "Amboli BO": "247554",
      "Babupur BO": "247554",
      "Chandena Koli BO": "247554",
      "Ghaloli BO": "247554",
      "Gunarsa BO": "247554",
      "Jaroda Jatt BO": "247554",
      "Sarsina BO": "247554",
      "Talheri Buzurg BO": "247554",
      "Khadlana BO": "247341",
      "Mohanpur BO": "247341",
      "Bahera BO": "247453",
      "Thaska BO": "247453",
      "Anwarpur Baroli BO": "247129",
      "Kaluwala Jahanpur BO": "247129",
      "Khurrampur BO": "247129",
      "Talhapur BO": "247129",
      "Khajoorwala BO": "247551",
      "Khera Mugal BO": "247551",
      "Lakhnaur BO": "247551",
      "Hassanpur BO": "247001",
      "Salhapur BO": "247342",
      "Tabur BO": "247342",
      "Bargaon BO": "247452",
      "Tikrol BO": "247452",
      "Ahmedpur BO": "247451",
      "Jandkhera BO": "247451",
      "Umrikalan BO": "247451",
      "Chauri BO": "247232",
      "Jhabiran BO": "247232",
      "Qutubpur BO": "247232",
      "Saharanpur HO": "247001",
      "Lakhi Gate SO": "247001",
      "Mazahir Uloom SO": "247001",
      "Paper Mill SO": "247001",
      "PTC SO": "247002",
      "Saharanpur Kutchery SO": "247001",
      "Sugar Mill Sarsawa SO": "247232",
      "Titron SO": "247343",
      "Rani Bazar SO": "247001",
      "Khalasi Line SO": "247001",
      "Mission Compound SO": "247001",
      "Muzaffrabad SO": "247129",
      "Nagal SO Saharanpur": "247551",
      "Qutubsher SO": "247001",
      "Rampur SO Saharanpur": "247451",
      "Narainpuri SO": "247001",
      "Prasar Kendra Rampur SO": "247451",
      "Veer Nagar SO": "247001",
      "Khumran Pul SO": "247001",
      "Labour Colony SO": "247001",
      "Mangal Nagar SO": "247001",
      "Nakur SO": "247342",
      "Nanauta SO": "247452",
      "Nehru Market SO": "247001",
      "Saharanpur City SO": "247001",
      "Sarsawa SO": "247232",
      "Behat SO Saharanpur": "247121",
      "Gangoh SO": "247341",
      "Hakikat Nagar SO": "247001",
      "Ambehta SO": "247340",
      "Babail Buzurg SO": "247120",
      "Chakrata Road SO": "247001",
      "Chilkana SO": "247231",
      "Darul Uloom Deoband SO": "247554",
      "Bus Stand Deoband SO": "247554",
      "Deoband SO": "247554",
      "Gagalheri SO": "247669",
      "Gatta Mill SO": "247001",
      "Gopal Nagar SO": "247001",
      "Industrial Estate Deoband SO": "247554",
      "Jaroda Panda SO": "247453",
      "Badshahi Bagh SO": "247122",
      "Bajoria Marg SO": "247001",
      "Chhutmalpur SO": "247662",
      "Khalapar SO": "247001"
    },
    "MEERUT": {
      "NDC  Meerut": "250001",
      "Pallavpuram S.O": "250110",
      "Pathauli BO": "250341",
      "Daurala Gaon BO": "250221",
      "Lohiya BO": "250221",
      "Latifpur BO": "250404",
      "Maur Khurd BO": "250404",
      "Behsuma BO": "250404",
      "Aseelpur BO": "250104",
      "Muzaffarpur Bagarpur BO": "250104",
      "Shahjahanpur BO": "250104",
      "Murlipur Phool BO": "250004",
      "Akbarpur Sadat BO": "250401",
      "Assa BO": "250401",
      "Dhanpura BO": "250401",
      "Jai Singhpur BO": "250401",
      "Mawana Khurd BO": "250401",
      "Nagla Hareru BO": "250401",
      "Tofapur BO": "250401",
      "Chitwana Sherpur BO": "250406",
      "Etmadpur BO": "250406",
      "Ruhasa BO": "250223",
      "Bhamori BO": "250342",
      "Laskarganj BO": "250342",
      "Mulhera BO": "250342",
      "Khiwai BO": "250344",
      "Panchli Khurd BO": "250002",
      "Mohd Pur Dhoomi BO": "250626",
      "Bhola BO": "250501",
      "Nek BO": "250501",
      "Peepla Idrishpur BO": "250501",
      "Ajrara BO": "245206",
      "Kaul BO": "245206",
      "Phaphunda BO": "245206",
      "Uldhan BO": "245206",
      "Kazamabad Goon BO": "250205",
      "Khirwa Jalalpur BO": "250341",
      "Samoli Khash Pur BO": "250221",
      "Sarsawa BO": "250221",
      "Gesupur BO": "250104",
      "Jaroda BO": "250104",
      "Lalyaana BO": "250104",
      "Mahalka BO": "250222",
      "Sholda BO": "250106",
      "Dhikauli BO": "250402",
      "Sathla BO": "250402",
      "Alipur Morna BO": "250401",
      "Bhainsa BO": "250401",
      "Darveshpur BO": "250401",
      "Gadeena BO": "250401",
      "Niloha BO": "250401",
      "Phitkari BO": "250401",
      "Pilona BO": "250401",
      "Rahaoti BO": "250401",
      "Dulhera BO": "250110",
      "Pabli Khas BO": "250110",
      "AP Badhla BO": "250406",
      "Agwanpur BO": "250406",
      "Ahmedpur BO": "250406",
      "Khera BO": "250342",
      "Kushaoli BO": "250342",
      "Pithlokar BO": "250342",
      "Rardhana BO": "250342",
      "Salawa BO": "250342",
      "Bhooni BO": "250344",
      "Siwal BO": "250501",
      "Atrara BO": "245206",
      "Bhadoli BO": "245206",
      "Baram BO": "250502",
      "Chandori Khas BO": "250502",
      "Poothkhas BO": "250502",
      "Rasna BO": "250502",
      "Rasulpur Kinoni BO": "250502",
      "Alipur BO": "250221",
      "Bastora BO": "250404",
      "Digamber Jain Mandir BO": "250404",
      "Doodhli BO": "250404",
      "Ganeshpur BO": "250404",
      "Radhana BO": "250104",
      "Sarwani Arifpur BO": "250104",
      "Datawali BO": "250004",
      "Hasanpur Kadim BO": "250004",
      "Jithauli BO": "250004",
      "Kina Nagar BO": "250004",
      "Sisoli BO": "250004",
      "Pohli BO": "250341",
      "Kulanjan BO": "250221",
      "Mataur BO": "250221",
      "Kishorepur BO": "250404",
      "M P Sikhera BO": "250404",
      "Saifpur Karamchanpur BO": "250404",
      "Tarapur BO": "250404",
      "Mahalwala BO": "250104",
      "Nagli Badli BO": "250104",
      "Shafibad Loti BO": "250104",
      "Samai Pur BO": "250004",
      "Mahal BO": "250222",
      "Kaull BO": "250401",
      "Meewan BO": "250401",
      "Naidu BO": "250401",
      "Sandhan BO": "250401",
      "Amarsinghpur BO": "250406",
      "Ekla Rasulpur BO": "250406",
      "Khajuri BO": "250406",
      "Poothi BO": "250406",
      "Sondutt BO": "250406",
      "Baparsi BO": "250342",
      "Chhabariya BO": "250342",
      "Mahadev BO": "250342",
      "Muzahidpur BO": "250342",
      "Harra BO": "250344",
      "Maina Poothi BO": "250344",
      "Karnawal BO": "250344",
      "Malyana BO": "250002",
      "Lisari BO": "250002",
      "Behrampur BO": "250501",
      "Dahadra BO": "250501",
      "Khanpur BO": "250501",
      "Kurali BO": "250501",
      "Gagol BO": "245206",
      "Khaspur BO": "245206",
      "Panchi BO": "245206",
      "Sarawa BO": "245206",
      "Kanshi BO": "250205",
      "Muzakkipur BO": "250205",
      "Navinmandi BO": "250002",
      "Amanullapur BO": "250502",
      "Kaithwari BO": "250502",
      "Hasanpur Kalan BO": "250106",
      "Paswara BO": "250106",
      "Rachhauti BO": "250106",
      "Jai BO": "250406",
      "Manpur BO": "250406",
      "Naarangpur BO": "250406",
      "Siyal BO": "250406",
      "Dadri BO": "250223",
      "Kailii BO": "250223",
      "Kapsad BO": "250223",
      "Mandora BO": "250223",
      "Chhur BO": "250342",
      "Jhitkari BO": "250342",
      "Kaland BO": "250342",
      "Kalandi BO": "250342",
      "Dahar BO": "250344",
      "Gotka BO": "250344",
      "Jassar Sultan Nagar BO": "250344",
      "Panchli Buzurg BO": "250344",
      "Budhera Zahidpur BO": "250002",
      "Ghosipur BO": "250002",
      "Dhaulri BO": "250626",
      "Bhoor Baral BO": "250103",
      "Partapur BO": "250103",
      "Rithani BO": "250103",
      "Jani Kalan BO": "250501",
      "Kalanjari BO": "250501",
      "Kitholi BO": "250501",
      "Bijauli BO": "245206",
      "Chandsara BO": "245206",
      "Kaili BO": "245206",
      "Chhajupur BO": "250205",
      "Dalampur BO": "250502",
      "Kalina BO": "250502",
      "Kalyanpur BO": "250502",
      "Narangpur BO": "250502",
      "Arnawali BO": "250502",
      "Meerpur BO": "250502",
      "Satwai BO": "250502",
      "Dabka BO": "250001",
      "Phalauda BO": "250401",
      "Kastla Shamshernagar BO": "250001",
      "Rajpura BO": "250001",
      "Abdullapur BO": "250001",
      "Incholi BO": "250001",
      "Bhatipura BO": "250001",
      "Mundali BO": "250001",
      "Bana BO": "250001",
      "Sikhera BO": "250001",
      "Kayastha Badha BO": "250001",
      "Mainthna Inder Singh BO": "250001",
      "Ekri BO": "250341",
      "Jangethi BO": "250341",
      "Janjokhar BO": "250341",
      "Rasulpur Aurangabad BO": "250001",
      "Maukhas BO": "250001",
      "Rukanpur Morna BO": "250001",
      "Muzaffarnagar Saini BO": "250001",
      "Bahadurpur BO": "250341",
      "Jatauli BO": "250001",
      "Gurukul Dorli BO": "250001",
      "B N Nanu BO": "250341",
      "Bhalsona BO": "250341",
      "Meerut Cantt HO": "250001",
      "Meerut City HO": "250002",
      "Defence Colony SO Meerut": "250001",
      "Kaseru Khera SO": "250001",
      "Lawar SO": "250222",
      "Saket SO Meerut": "250003",
      "Sardhana Road SO": "250001",
      "Sardhana SO": "250342",
      "Victoria Park SO": "250001",
      "Baghpat Gate SO": "250002",
      "I E Partapur SO": "250103",
      "Jani SO": "250501",
      "Lisari Gate SO": "250002",
      "Meerut City R S SO": "250002",
      "Boundary Road SO": "250001",
      "Daurala SO": "250221",
      "Kithore SO": "250104",
      "Krishna Nagar SO": "250001",
      "Mawana Factory SO": "250402",
      "Mawana Tehsil SO": "250401",
      "Meerut Kutchery SO": "250003",
      "Meerut University SO": "250004",
      "Sakoti Tanda SO": "250223",
      "Shastri Nagar SO Meerut": "250004",
      "Banker Street SO": "250002",
      "Budhana Gate SO": "250002",
      "Kaiser Ganj SO": "250002",
      "Meerut Tehsil SO": "250002",
      "Kanker Khera SO": "250001",
      "L L R M Medcollege SO": "250004",
      "Mawana SO": "250401",
      "Parikshitgarh SO": "250406",
      "Chhipi Tank SO": "250001",
      "Kabari Bazar SO": "250002",
      "Kharkhauda SO": "245206",
      "Kishanpura SO Meerut": "250002",
      "Rasulpur Rohta SO": "250502",
      "MIET SO": "250005",
      "Ramlila Ground SO": "250002",
      "Suraj Kund Road SO": "250001",
      "Mohiuddinpur SO": "250205",
      "Nadir Ali  Co SO": "250002",
      "Ramnagar SO Meerut": "250002",
      "Sarrafa Bazar SO": "250002",
      "Shivpuri SO Meerut": "250001",
      "Thapar Nagar SO": "250001",
      "Begum Bagh SO": "250001",
      "Belvedere SO": "250001",
      "CBSardhana SO": "250342",
      "Dabathwa SO": "250341",
      "Ganganagar SO": "250001",
      "Hastinapur SO": "250404",
      "Machhara SO": "250106",
      "Modipuram SO": "250110",
      "P R C SO": "250001",
      "RABazar SO": "250001",
      "Sarurpur Khurd SO": "250344",
      "Anaj Mandi SO Meerut": "250002",
      "Gandhi Ashram SO Meerut": "250001",
      "Abulane SO": "250001",
      "Rly Road Meerut SO": "250002",
      "SGMandi SO": "250002",
      "W K Road SO": "250001"
    },
    "VARANASI": {
      "Ledhupur S.O.": "221007",
      "Mustafabad BO": "221104",
      "Narainpur BO": "221104",
      "Pachraon BO": "221104",
      "Bariyasanpur BO": "221112",
      "Kamauli BO": "221112",
      "Ajgara BO": "221101",
      "Amarpatti BO": "221101",
      "Babiaon BO": "221101",
      "Bela BO": "221101",
      "Jagdishpur BO": "221202",
      "Katari BO": "221101",
      "Kohashi BO": "221101",
      "Lakhanpur BO": "221101",
      "Laskarpur BO": "221101",
      "Niyar BO": "221101",
      "Rajapur BO": "221101",
      "Singhpur BO": "221101",
      "Sultanipur BO": "221101",
      "Ambba BO": "221104",
      "Gobraha BO": "221104",
      "Jalhupur BO": "221104",
      "Khetalpur BO": "221104",
      "Piyari BO": "221104",
      "Ramchandipur BO": "221104",
      "Tiwaripur BO": "221104",
      "Ukathi BO": "221104",
      "Saraimohana BO": "221112",
      "Bathauli BO": "221101",
      "Bhadawan BO": "221101",
      "Hathiyarkalan BO": "221101",
      "Kaithaur BO": "221101",
      "Saraiya No1 BO": "221101",
      "Tewar BO": "221101",
      "Bachhaon BO": "221011",
      "Susuwahi BO": "221011",
      "Garwasi Toal BO": "221005",
      "Chandrawati BO": "221116",
      "Srikanthpur BO": "221116",
      "Amauli BO": "221104",
      "Hariadih BO": "221104",
      "Shivdasa BO": "221104",
      "Shankerpur BO": "221112",
      "Umrahan BO": "221112",
      "Chaubepurkhurd BO": "221101",
      "Gosaipurmohawn BO": "221101",
      "Udaipur BO": "221101",
      "Tikari BO": "221011",
      "Sunderpur BO": "221005",
      "Rajwari BO": "221116",
      "Tekuri BO": "221116",
      "Barthara Khurd BO": "221104",
      "Bartharakalan BO": "221104",
      "Chhitauni BO": "221104",
      "Dhaurahara SO VaranaBO": "221104",
      "Luthakalan BO": "221104",
      "Moonari BO": "221104",
      "Barain BO": "221112",
      "Danganj Bazar BO": "221101",
      "Kurahuwan BO": "221011",
      "Kateshar BO": "221008",
      "Naipurakhurd BO": "221011",
      "Ramna BO": "221011",
      "Seergoverdhan BO": "221011",
      "Bhagwanpur BO": "221005",
      "Hasanpur Biraon BO": "221201",
      "Kharawan BO": "221201",
      "Kuru BO": "221201",
      "Konia BO": "221007",
      "Tapowanashram BO": "221007",
      "Balua Gajapur BO": "221201",
      "Danupur BO": "221201",
      "Lamahi BO": "221007",
      "Rasoolgarh BO": "221007",
      "Sathwa BO": "221007",
      "Sultanpur BO": "221007",
      "Ashapur BO": "221007",
      "Akorha BO": "221201",
      "Bhonda BO": "221201",
      "Kaithauli BO": "221006",
      "Pure Raghunathpur BO": "221006",
      "Sajoi BO": "221302",
      "Sarauni BO": "221302",
      "Lahartara BO": "221106",
      "Phulawaria BO": "221106",
      "Paniyara BO": "221305",
      "Shahanshahpur BO": "221305",
      "Dabethuwa BO": "221207",
      "Nayepur Chaumuhani BO": "221207",
      "Tari BO": "221207",
      "Thaney Rampur BO": "221207",
      "Ayar BO": "221202",
      "Bhopapur BO": "221202",
      "Gorai BO": "221307",
      "Banakat BO": "221403",
      "Garthama BO": "221208",
      "Hiramanpur BO": "221208",
      "Katuna BO": "221208",
      "Sisawan BO": "221201",
      "Basani BO": "221204",
      "Ramapur Hathiwar BO": "221204",
      "Rohana BO": "221108",
      "Harshosh BO": "221302",
      "Jamalpur BO": "221105",
      "Kotwa Koraut BO": "221105",
      "Hariharpur BO": "221405",
      "Raisipur BO": "221405",
      "Dhandhorpur BO": "221305",
      "Khochawan BO": "221313",
      "Barahi Newada BO": "221207",
      "Mangalpur BO": "221107",
      "Murdaha Bazar BO": "221202",
      "Odar BO": "221202",
      "Kardhana BO": "221307",
      "Mankaiya BO": "221307",
      "Belwan BO": "221206",
      "Kanakpur BO": "221206",
      "Phoolpur BO": "221206",
      "Birbhanpur BO": "221311",
      "Mahgaon BO": "221311",
      "Barki BO": "221403",
      "Raghupur BO": "221403",
      "Sakalpur BO": "221403",
      "Sikhari Barki BO": "221403",
      "Rupchandpur BO": "221208",
      "Madhumakhiya BO": "221201",
      "Chiurapur BO": "221204",
      "Rasoolpur BO": "221204",
      "Jagatpur BO": "221302",
      "Kajisarai BO": "221105",
      "Jansa Bazar BO": "221405",
      "Khewali BO": "221405",
      "Marui BO": "221208",
      "Domaila BO": "221313",
      "Koruta Bazar BO": "221107",
      "Nahiyan BO": "221202",
      "Puarikalan BO": "221202",
      "Benipur Kundariya BO": "221307",
      "Jhanjhaur BO": "221206",
      "Karkhiaon BO": "221206",
      "Surahi BO": "221206",
      "Babhaniaon BO": "221311",
      "Kashipur BO": "221311",
      "Bhikhampur BO": "221403",
      "Christ Nagar BO": "221003",
      "Varanasi HO": "221001",
      "Varanasi Cantt HO": "221002",
      "Deochandpur BO": "221204",
      "Kaniyar BO": "221204",
      "Khataura BO": "221204",
      "Kuar BO": "221204",
      "Kundi BO": "221204",
      "Birapatti BO": "221105",
      "Ghamahapur BO": "221105",
      "Basantpur BO": "221405",
      "Daipur BO": "221405",
      "Rameswar BO": "221405",
      "Bazardiha BO": "221106",
      "Kandawa BO": "221106",
      "Thathara BO": "221313",
      "Rajpur BO": "221202",
      "Shivrampur BO": "221202",
      "Khalispur BO": "221206",
      "Parsara BO": "221206",
      "Ramdih BO": "221403",
      "Palahipatti BO": "221208",
      "Sehamalpur BO": "221208",
      "Chamaon BO": "221003",
      "Pisaur BO": "221003",
      "Pindarai BO": "221206",
      "Mehandiganj BO": "221311",
      "Bhitkuri BO": "221403",
      "Kalikabara BO": "221403",
      "Kapsethi BO": "221403",
      "Garkhara BO": "221208",
      "Sarsawan BO": "221003",
      "CHIRAIGAON SO": "221112",
      "Dafi SO": "221011",
      "Daranagar SO": "221001",
      "Gaighat SO": "221001",
      "Kabirchaura SO": "221001",
      "Rani Bhawani Katra SO": "221001",
      "Sarva Seva Sangh SO": "221001",
      "NDC Varanasi": "221407",
      "Ardely Bazar SO": "221002",
      "Aurangabad SO Varanasi": "221010",
      "Baragaon SO Varanasi": "221204",
      "Bhelupura SO": "221010",
      "Gdk SO": "221010",
      "HPS SO": "221010",
      "Kachhwa Road SO": "221313",
      "Lohta SO": "221107",
      "Mahmoorganj SO": "221010",
      "Mangari SO": "221202",
      "Pindra SO": "221206",
      "Rajatalab SO": "221311",
      "Sindhora SO": "221208",
      "VARANASI SHIVPUR SO": "221003",
      "West Colony SO": "221004",
      "Bengalitola SO": "221001",
      "Bhu  H SO": "221005",
      "Bunker Market SO": "221001",
      "Chaubeypur SO": "221104",
      "Dasaswmedh SO": "221001",
      "Durgakund SO": "221005",
      "Hindu Vishwa Vidhyalaya SO": "221005",
      "Iswargangi SO": "221001",
      "Pahariya Mandi SO": "221007",
      "Ramnagar SO Varanasi": "221008",
      "Shivala SO": "221001",
      "Anai SO": "221201",
      "DLW SO": "221004",
      "Gangapur Varanasi SO": "221302",
      "Industrial Estate Varanasi SO": "221106",
      "Kamachha SO": "221010",
      "Kashi Vidhya Pith SO": "221002",
      "Khajuri SO Varanasi": "221002",
      "Luxa SO": "221010",
      "Mirzamurad SO": "221307",
      "SVV SO": "221002",
      "Sigra SO": "221010",
      "Chandmari SO": "221003",
      "Chaukhamba SO": "221001",
      "Chetganj SO": "221001",
      "Jaitpura SO": "221001",
      "Kaithi SO": "221116",
      "Kasi RS SO": "221001",
      "Kedarghat SO": "221001",
      "Madanpura SO": "221001",
      "Ramapura SO": "221001",
      "Varanasi City SO": "221001",
      "Babatpur Ad SO": "221006",
      "Belpco SO": "221010",
      "Bhulanpur Pac SO": "221108",
      "Jawahar Nagar SO Varanasi": "221002",
      "Khojwa Bazar SO": "221010",
      "Nagar Maha Palika SO": "221010",
      "Sewapuri SO": "221403",
      "Telibagh SO": "221002",
      "Vsi Kutchhery SO": "221002",
      "Cholapur SO": "221101",
      "Hanuman Phathak SO": "221001",
      "Hanumanghat SO": "221001",
      "Kashi Viswnath Mandir SO": "221001",
      "Lanka SO": "221005",
      "Mahamandal SO": "221001",
      "Malviya Nagar SO": "221005",
      "Ram Nagar Pac SO": "221008",
      "Sarnath SO": "221007",
      "Vijay Sirohi Nagar SO": "221001",
      "Kustha Sewa Ashram SO": "221012",
      "39 Gtd SO": "221002",
      "Drmo SO": "221002",
      "Harhua SO": "221105",
      "Hathi Bazar SO": "221405",
      "Jakhini SO": "221305",
      "Kathiraon SO": "221207",
      "Manduadih SO": "221103",
      "UP Collage SO": "221002",
      "Jayapur SO Varanasi": "221109",
      "Assi SO": "221005"
    },
    "MORADABAD": {
      "NDC Moradabad": "244001",
      "Jahangirpur BO": "244001",
      "Baheri Brahmnan BO": "244402",
      "Bhagatpur Tanda BO": "244402",
      "Gopiwala BO": "244601",
      "Nanhuwala BO": "244601",
      "Pasiapura BO": "244601",
      "Raghowala BO": "244601",
      "Ratupura BO": "244601",
      "Padia Nagla BO": "244402",
      "Pipalsana BO": "244402",
      "Sidhlau Nazarpur BO": "244402",
      "Bahoranpur Narauli BO": "244415",
      "Guarau BO": "244415",
      "Darapur BO": "244602",
      "Rajupur Kalan BO": "244602",
      "Khawajpur BO": "244601",
      "Longi Kalan BO": "244601",
      "Noorpur BO": "244001",
      "Burhanpur BO": "244402",
      "Devipura BO": "244402",
      "Narainpur BO": "244415",
      "Sherpur Patti BO": "244602",
      "Fareed Nagar Mustqum BO": "244601",
      "Kishanpur Gaonri BO": "244601",
      "Chandpur BO": "244402",
      "Laloowala BO": "244402",
      "RN Sahaspur BO": "244415",
      "Sharif Nagar BO": "244602",
      "Tanda Afzal BO": "244602",
      "Bahadur Nagar BO": "244601",
      "Kalajhanda BO": "244601",
      "Aliabad BO": "244401",
      "Dhakia Jut BO": "244401",
      "Akkadilari BO": "244104",
      "Hiran Khera BO": "244104",
      "Kankar Khera BO": "244104",
      "Gakharpur BO": "244401",
      "Rehta Mafi BO": "244401",
      "Majholi Khas BO": "244413",
      "Beerpur Than BO": "244104",
      "Ganeshpur BO": "244104",
      "Garhi Salempur BO": "244501",
      "Matlabpur Sadarpur BO": "244501",
      "Mundha Kheri BO": "244501",
      "Umri Sabzi Pur BO": "244102",
      "Sitapuri BO": "244001",
      "Sonakpur BO": "244105",
      "Lakri Fazalpur BO": "244001",
      "Godhi BO": "244001",
      "Harthala Colony BO": "244001",
      "Qazipura BO": "244105",
      "Amarpur Kashi BO": "244411",
      "Sanai BO": "244411",
      "Sarkara Bishnoi BO": "244401",
      "Sihali Khadar BO": "244401",
      "Haryana BO": "244413",
      "Hathipur Chandoi BO": "244413",
      "Sardar Nagar BO": "244104",
      "Sarkara Khas BO": "244104",
      "Siras Khera BO": "244104",
      "Akbarpur Sihali BO": "244501",
      "Chhajlet BO": "244501",
      "Umari Kalan BO": "244501",
      "Gumsani BO": "244102",
      "Devapur Mustkam Pur BO": "244001",
      "Hasanpur Katia BO": "244001",
      "Macharria BO": "244001",
      "Fatehpur Vishnoi BO": "244504",
      "Kafiabad BO": "244504",
      "Kuchawali BO": "244504",
      "Ladawali BO": "244504",
      "Chandrapur Kalan BO": "244411",
      "Chhitauni BO": "244411",
      "Sagarpur BO": "244411",
      "Kothi Khidmatpur BO": "244501",
      "Kuri Rawana BO": "244501",
      "Madhpur BO": "244501",
      "Ratanpur Kalan BO": "244102",
      "Husainpur Hamir BO": "244001",
      "Sultanpur Dost BO": "244601",
      "Beejna BO": "244001",
      "Rajpur Kesaria BO": "244001",
      "Faredi BO": "244001",
      "Gataura BO": "244411",
      "Jalalpur BO": "244411",
      "Jargaon BO": "244411",
      "Ronda BO": "244411",
      "Sihali Mala BO": "244411",
      "Malakpursemli BO": "244401",
      "Sahaspuri BO": "244401",
      "Hathipur Chittu BO": "244413",
      "Tewar Khas BO": "244413",
      "Chandanpur Isapur BO": "244104",
      "Deolari BO": "244104",
      "Saifni BO": "244411",
      "Syaundara BO": "244411",
      "Thaonla BO": "244411",
      "Jahangirpur Chakpheri BO": "244501",
      "MohdPur Mafi BO": "244501",
      "Pathangi BO": "244501",
      "Yusufpur Naglia BO": "244102",
      "Mukarrabpur BO": "244001",
      "Tumaria Kalan BO": "244001",
      "Bhensia BO": "244001",
      "Modha BO": "244504",
      "Sarai Khajoor BO": "244504",
      "Dharampur Kalan BO": "244411",
      "Kharsol BO": "244411",
      "Khawari Awwal BO": "244411",
      "Mangoopura BO": "244411",
      "Uncha Gaon BO": "244001",
      "Moradabad HO": "244001",
      "Pakbara SO": "244102",
      "Dilari SO": "244401",
      "Moradabad Kutchery SO": "244001",
      "Nai Basti SO Moradabad": "244001",
      "Nawabpura SO": "244001",
      "Vikas Bhawan Moradabad SO": "244105",
      "Aghwanpur SO": "244504",
      "Gandhi Nagar Moradabad SO": "244001",
      "Katghar SO Moradabad": "244001",
      "Kundarki SO": "244413",
      "Majhola SO Moradabad": "244103",
      "Mandi Naj SO": "244001",
      "Moradabad City SO": "244001",
      "Moradabad RS SO": "244001",
      "PTC Moradabad SO": "244001",
      "R N  Area SO": "244001",
      "PAC Moradabad SO": "244001",
      "Raja Ka Sahaspur SO": "244415",
      "Stationroad SO": "244001",
      "Bilari SO": "244411",
      "Faij Ganj Bazar SO": "244001",
      "Galshaheed SO": "244001",
      "Pipalsana RS SO": "244402",
      "Thakurdwara SO": "244601",
      "Town Hall SO Moradabad": "244001",
      "RTS Moradabad SO": "244001",
      "SPF Mrd SO": "244001",
      "Kanth SO": "244501",
      "Mundha SO": "244104",
      "Surjan Nagar SO": "244602"
    },
    "BAREILLY": {
      "NDC Bareilly": "243001",
      "Nagaria Sobarni BO": "243505",
      "Khazuria Sampat BO": "243123",
      "Kunwarpur Banzaria BO": "243123",
      "Mehtarpur BO": "243123",
      "Mohanpur BO": "243123",
      "Padarathpur BO": "243123",
      "Baragoan BO": "243303",
      "Basantpur BO": "243303",
      "Beodhan Khurd BO": "243303",
      "Hardaspur BO": "243303",
      "Lilaur BO": "243303",
      "Dunka BO": "243505",
      "Junahi BO": "243505",
      "Kanakpuri BO": "243505",
      "Kulchha BO": "243505",
      "Labhari BO": "243303",
      "Sona BO": "243303",
      "Hafizganj BO": "243407",
      "Bairamnagar BO": "243505",
      "Balli BO": "243505",
      "Mehmoodpur BO": "243301",
      "Gugai BO": "243504",
      "Hurhuri BO": "243504",
      "Mandanpur BO": "243504",
      "SINDHAULI BO": "243504",
      "Baboora BO": "262406",
      "Bapu Nagar BO": "262406",
      "Narharpur Gaurikhera BO": "262406",
      "Parasrampur BO": "262406",
      "Sardarnagar BO": "262406",
      "Sundari Amsah BO": "262406",
      "Balipur BO": "243123",
      "Bhainsori BO": "244701",
      "Kesarpur Saidpur BO": "243123",
      "Thiria Nizawatkhan BO": "243123",
      "Barser Sikandarpur BO": "243303",
      "Gurgaon BO": "243303",
      "Kangawan Shyam BO": "243303",
      "Shivpuri BO": "243303",
      "Ahemdabad BO": "243407",
      "Barhepura BO": "243407",
      "Mundia Bhikampur BO": "243407",
      "Dhaneli BO": "243505",
      "Gehluiya BO": "243505",
      "Mawai Kazian BO": "243505",
      "Biharman Nagla BO": "243122",
      "Mundia Ahamad Nagar BO": "243002",
      "Nrmc BO": "243122",
      "Dhaneta BO": "243504",
      "Bhadpura BO": "262406",
      "Bhauwa Bazar BO": "262406",
      "Dhaurera BO": "262406",
      "Khajuria Sriram BO": "262406",
      "Mundia Teli BO": "262406",
      "Saidpur Hakins BO": "243122",
      "Goola BO": "243504",
      "Gularia BO": "243504",
      "Samaspur BO": "243504",
      "Simaria BO": "243504",
      "Abhayrajpur BO": "262406",
      "Alahiya BO": "262406",
      "Bijamau BO": "262406",
      "Jeoti Jagir BO": "262406",
      "Rukumpur BO": "262406",
      "Bithri Chainpur BO": "243123",
      "Rajau Paraspur BO": "243123",
      "Kesarpur BO": "243303",
      "Mau Chandpur BO": "243303",
      "Sirauli BO": "243303",
      "Baraur BO": "243407",
      "Grem BO": "243407",
      "Harharpur BO": "243407",
      "Paiga BO": "243407",
      "Itau Dhura BO": "243201",
      "Jasai Nagar BO": "243201",
      "Jokhanpur BO": "243201",
      "Man Pur BO": "243201",
      "Mundia Navibux": "243201",
      "Nadeli BO": "243201",
      "Koharapeer BO": "243003",
      "Masjid Domni BO": "243003",
      "NEKPUR BO": "243003",
      "Shehdana Colony BO": "243003",
      "Shubhash Nagar BO": "243003",
      "Surla BO": "243202",
      "DOHRIYA BO": "243126",
      "Aliganj BO": "243302",
      "Anurudhpur BO": "243302",
      "Majhgawan BO": "243302",
      "Swale Nagar BO": "243502",
      "Tiliapurbo BO": "243502",
      "Faiznagar BO": "243503",
      "Kakra Kalan BO": "243503",
      "Khateli BO": "243503",
      "Ratna BO": "243407",
      "Haldi BO": "243505",
      "Rithora BO": "243002",
      "Behroli BO": "243504",
      "Kuan Tanda BO": "243503",
      "Laungpur BO": "243503",
      "Nawada Bilsandi BO": "243503",
      "Bargawan BO": "243506",
      "Jaraul BO": "243506",
      "Kareli BO": "243004",
      "Kiara BO": "243004",
      "Sarai Talfi BO": "243004",
      "Simra Boripur BO": "243004",
      "Bhandsar BO": "243002",
      "Dibna BO": "243504",
      "Attangachandpur BO": "262406",
      "Bilasnagar BO": "262406",
      "Dalelnagar BO": "262406",
      "Keolaria BO": "262406",
      "Bhura Bahadur Pur BO": "243201",
      "Damkhoda BO": "243201",
      "Rasoolpur BO": "243201",
      "Rath BO": "243201",
      "Richha BO": "243201",
      "Sharif Nagar BO": "243201",
      "Yaqoobganj BO": "243201",
      "Himmatpur BO": "243402",
      "Kaimua BO": "243402",
      "Langura BO": "243402",
      "Kusari BO": "243401",
      "Rajupur BO": "243401",
      "Sirohi BO": "243401",
      "Atamanda BO": "243202",
      "Bhairpura BO": "243202",
      "Bilwa BO": "243202",
      "Chakdah BO": "243202",
      "Kalyanpur BO": "243302",
      "Kundaria Faizulapur BO": "243302",
      "Rajupur Kalan BO": "243302",
      "Sahasa BO": "243302",
      "Sudanpur BO": "243302",
      "Gauntara BO": "243502",
      "Ghunsa BO": "243502",
      "Nandausi BO": "243502",
      "Rohili BO": "243203",
      "Athana BO": "243503",
      "Budhauuli BO": "243503",
      "Dalpura BO": "243503",
      "Dhakni Rajpuri BO": "243503",
      "Qadarganj BO": "243503",
      "Sarkara BO": "243503",
      "Simra Bahor Nagla BO": "243503",
      "Shahpur Baniyan BO": "243506",
      "Tiswa BO": "243506",
      "Dandia Nagla BO": "243201",
      "Faridpur BO": "243201",
      "Nazarganj BO": "243201",
      "Pindari Ashok BO": "243201",
      "Siatheri BO": "243201",
      "Milak Majhera BO": "243402",
      "Naurangpur BO": "243402",
      "Singha BO": "243402",
      "Gulab Nagar BO": "243003",
      "Alampur Jafarabad BO": "243401",
      "Kudha BO": "243401",
      "Dhaura BO": "243202",
      "Pachdeora Kalan BO": "243202",
      "Balai Bhagwantpur BO": "243302",
      "Jitaur BO": "243302",
      "Khelam BO": "243302",
      "Mandora BO": "243302",
      "Nisui BO": "243302",
      "Bohit BO": "243502",
      "Jogither BO": "243502",
      "Mandauli BO": "243502",
      "Teolia BO": "243502",
      "Chathia BO": "243203",
      "Kanman BO": "243203",
      "Mundia Jagir BO": "243203",
      "Angadpur Khamaria BO": "243503",
      "Marhi Sukatia BO": "243503",
      "Piperthara BO": "243503",
      "Raipur Hans BO": "243503",
      "Sunha BO": "243503",
      "Nagaria Kalan BO": "243506",
      "Shivpuri Raudhauli BO": "243506",
      "Chanehti BO": "243004",
      "Haraulia BO": "243004",
      "Umarsia BO": "243004",
      "Narkhera BO": "243505",
      "Aonla Katra BO": "243301",
      "Aonla Kila BO": "243301",
      "Dunda Sumali BO": "243201",
      "Girdharpur BO": "243201",
      "Pachpera BO": "243201",
      "Naugawan Thakuran BO": "243402",
      "Sarau BO": "243402",
      "Sardar Nagar Ghat BO": "243402",
      "Baljati BO": "243003",
      "Deochara BO": "243401",
      "Khanpur BO": "243202",
      "Atarchhedi BO": "243302",
      "Gaini BO": "243302",
      "Naugawan Bramhanan BO": "243302",
      "Dauli Raghuwar Dayal BO": "243502",
      "Khalilpur BO": "243502",
      "Basudharan BO": "243203",
      "Gularia Mohammad Hussain BO": "243203",
      "Khera Ramnagar BO": "243203",
      "Rehpura Ganimat BO": "243203",
      "Hazipur Khazuria B BO": "243503",
      "Nagaria Vikram BO": "243503",
      "Pachomi BO": "243503",
      "Rampura Ratan BO": "243503",
      "Tara Khas BO": "243506",
      "Malgoan BO": "243403",
      "Akha BO": "243004",
      "Chaubari BO": "243004",
      "Shishgarh BO": "243505",
      "Sahora BO": "243505",
      "Shergarh BO": "243505",
      "Bareilly HO": "243001",
      "Manona BO": "243301",
      "Phulasi BO": "243301",
      "Mohammad Ganj BO": "243501",
      "Soraha BO": "243501",
      "Digoi BO": "243301",
      "Katsari BO": "243301",
      "Reoti BO": "243301",
      "Sirsa Jagir BO": "243501",
      "Gotha Khandua BO": "243301",
      "Guleli BO": "243301",
      "Kangaon BO": "243301",
      "Kasumara BO": "243301",
      "Mohammadpur Pathra BO": "243301",
      "Noorpur BO": "243301",
      "Tanda BO": "243301",
      "Urla BO": "243301",
      "Agras BO": "243501",
      "Aundh BO": "243501",
      "Bhitaura BO": "243501",
      "Meerapur Rafiabad BO": "243501",
      "Airforce Station": "243002",
      "Ballia SO": "243402",
      "Bhamora SO": "243401",
      "Aonla SO": "243301",
      "Baheri": "243201",
      "Bareilly Cantt": "243001",
      "Bareilly College": "243001",
      "Bareilly Kty": "243001",
      "Bareilly RS": "243001",
      "CARI SO": "243122",
      "Chaupla": "243001",
      "Bhuta": "243126",
      "Deorania": "243203",
      "Bisharatganj": "243302",
      "CBGanj": "243502",
      "B R Factory": "243501",
      "Bareilly City": "243003",
      "Bhojipura": "243202",
      "Izzatnagar": "243122",
      "Municipal Board SO": "243001",
      "Rajendra Nagar SO Bareilly": "243122",
      "Senthal SO": "243407",
      "Sanjay Nagar SO": "243005",
      "Fatehganj East": "243506",
      "Kila": "243003",
      "Kunwarpur SO": "243003",
      "Mahanagar SO": "243006",
      "Mission Hospital SO": "243001",
      "Nawabganj SO Bareilly": "262406",
      "Prem Nagar SO Bareilly": "243005",
      "RKUniversity SO": "243006",
      "Shamat Ganj SO": "243005",
      "Shyam Ganj SO": "243005",
      "Surkha SO": "243003",
      "ITBP": "243004",
      "KKNiazia": "243003",
      "KSW Tulsi Nagar": "243201",
      "Mango Road SO": "243001",
      "Marhinath Road SO": "243001",
      "Nc Lines Bareilly SO": "243001",
      "Faridpur": "243503",
      "Iffco Township SO": "243403",
      "Malook Pur SO": "243003",
      "Meerganj SO Bareilly": "243504",
      "Ner Workshop SO": "243122",
      "Old City SO": "243005",
      "PACDso SO": "243123",
      "Ram Nagar SO Bareilly": "243303",
      "Sadar Bazar SO Bareilly": "243001",
      "Shahi SO": "243505",
      "Shubhash Market SO": "243003",
      "Tehsil Aonla SO": "243301"
    },
    "MUZAFFARNAGAR": {
      "NDC MUZAFFAR NAGAR": "251001",
      "Pinna BO": "251306",
      "Rahamatpur Garwara BO": "251308",
      "Tissa BO": "251308",
      "Titawi BO": "251301",
      "Chhapar BO": "251307",
      "Kasampur Patheri BO": "251307",
      "Khudda BO": "251307",
      "Phalauda BO": "251307",
      "Jhal Nirgajani BO": "251308",
      "Malpura BO": "251308",
      "Nagla Bujurg BO": "251308",
      "Rahakada BO": "251308",
      "Bagowali BO": "251001",
      "Sahojani Tagan BO": "251001",
      "Makhiyali BO": "251001",
      "Taoli BO": "251001",
      "Sarwat BO": "251001",
      "Kukara BO": "251001",
      "Pachanda Kalan BO": "251001",
      "Sher Nagar BO": "251001",
      "Datiyana BO": "251001",
      "Rampur BO": "251001",
      "Roni Hazipur BO": "251301",
      "Amir Nagar BO": "251306",
      "Kazi Khera BO": "251306",
      "Mandi BO": "251306",
      "Nasir Pur BO": "251306",
      "Khaikheri BO": "251310",
      "Tuglakpur BO": "251310",
      "Behra Thru BO": "251308",
      "Jat Mujhera BO": "251308",
      "Harsauli BO": "251001",
      "Karwara BO": "251001",
      "Ratheri BO": "251001",
      "Barwala BO": "251001",
      "Budina Kalan BO": "251301",
      "Jasoi BO": "251301",
      "Nagala Pithora BO": "251301",
      "Mussa Bilaspur BO": "251001",
      "Kinoni BO": "251001",
      "Megha Kheri BO": "251001",
      "Agarwal Paper Mill BO": "251001",
      "Nirmana BO": "251001",
      "Dedheru Kalan BO": "251001",
      "Biral BO": "247771",
      "Mohamad Pur Madan BO": "251301",
      "Phugana BO": "247776",
      "Bhora Kalan BO": "251319",
      "Budina Khurd BO": "251306",
      "Mukandpur BO": "251306",
      "Badheri BO": "251307",
      "Rai BO": "251307",
      "Gadhla BO": "251310",
      "Tejalhera BO": "251310",
      "Belra BO": "251308",
      "Jauli BO": "251308",
      "Sikkri BO": "251308",
      "Bhoora Khurd BO": "251319",
      "Alipur Aterna BO": "251309",
      "Barkata BO": "251309",
      "Kuralsi BO": "251309",
      "Kurawa BO": "251309",
      "Kurthal BO": "251309",
      "Loi Sarai BO": "251309",
      "Reoli Nagla BO": "251309",
      "Tanda Majara BO": "251309",
      "Toda BO": "251309",
      "Khusropur BO": "251311",
      "Kulheri BO": "251311",
      "Kutesra BO": "251311",
      "Luhari Khurd BO": "251311",
      "Jaroda BO": "251003",
      "Sujroo BO": "251003",
      "Vehlana BO": "251003",
      "Doodhli BO": "247772",
      "Bajidpur Kawali BO": "251314",
      "Baroda BO": "251309",
      "Dabheri Rasulpur BO": "251309",
      "Jaula BO": "251309",
      "Mohmand Pur Rai Singh BO": "251309",
      "Raipur Aterna BO": "251309",
      "Chokra BO": "251311",
      "Paoti BO": "251311",
      "Lachera BO": "251003",
      "Balwa Kheri BO": "247772",
      "Budha Khera BO": "247772",
      "Pipal Shah BO": "247772",
      "Chittora BO": "251314",
      "Ghatayan BO": "251314",
      "Bhangela BO": "251201",
      "Chand Seena BO": "251201",
      "Galibpur BO": "251201",
      "Incholi BO": "251201",
      "Nawla BO": "251201",
      "Sarai Rasulpur BO": "251201",
      "Titoda BO": "251201",
      "Bihari BO": "251203",
      "Purbaliyan BO": "251203",
      "Bhooma BO": "251315",
      "Tendhera BO": "251316",
      "Hassanpur BO": "251320",
      "Baheri BO": "251202",
      "Kachauli BO": "251202",
      "Dhanayan BO": "251318",
      "Kutba BO": "251318",
      "Mubarikpur BO": "251318",
      "Mundbhar BO": "251319",
      "Sawtoo BO": "251319",
      "Shikarpur BO": "251319",
      "Bitawada BO": "251309",
      "Garhi Sakhawatpur BO": "251309",
      "Itawa BO": "251309",
      "Kamruddin Nagar BO": "251309",
      "Chand Samad BO": "251201",
      "Dayalpuri BO": "251201",
      "Fahimpur Khurd BO": "251201",
      "Dudha Heri BO": "251203",
      "Hussainpur Bhopara BO": "251203",
      "Kithora BO": "251315",
      "Kutubpur BO": "251315",
      "Bhokarheri BO": "251316",
      "Chorawala BO": "251316",
      "Kakrauli BO": "251316",
      "Khokani BO": "251316",
      "Kelanpur BO": "251327",
      "Sherpur BO": "251327",
      "Maleera BO": "251202",
      "Rohana Khurd BO": "251202",
      "Dhindawali BO": "251318",
      "Dinkarpur BO": "251318",
      "Grahi Noabad BO": "251309",
      "Hussainabad Bhanwara BO": "251309",
      "Hussainpur Kalan BO": "251309",
      "Luhsana BO": "251309",
      "Nagwa BO": "251309",
      "Biralasi BO": "247772",
      "Niamu BO": "247772",
      "Behra Assa BO": "251314",
      "Dhansari BO": "251314",
      "Nagla Madore College BO": "251314",
      "Sambhal Hera BO": "251314",
      "Antwara BO": "251201",
      "Bhainsi BO": "251201",
      "Pamnawali BO": "251201",
      "Pipalhera BO": "251201",
      "Satheri BO": "251201",
      "Bahadurpur BO": "251203",
      "Bhikki BO": "251203",
      "Pura BO": "251203",
      "Behupura BO": "251316",
      "Shukartal BO": "251316",
      "Tewra BO": "251316",
      "Badhai Khurd BO": "251202",
      "Barkali BO": "251202",
      "Kaserwa BO": "251318",
      "Palri BO": "251318",
      "Karoda BO": "247776",
      "Muzaffarnagar HO": "251001",
      "Jandheri BO": "251314",
      "Kawal BO": "251314",
      "Kujhera BO": "251314",
      "Rajpur Kalan BO": "251314",
      "Salarpur BO": "251314",
      "Tissang BO": "251314",
      "Parasauli BO": "247775",
      "Rajpur Chhajpur BO": "247775",
      "Barsoo BO": "251201",
      "Jasaula BO": "251201",
      "Kailwara Kalan BO": "251201",
      "Khanjapur BO": "251201",
      "Kheri Rangdhang BO": "251201",
      "Phulat BO": "251201",
      "Satguru Nagar BO": "251201",
      "Jeewana BO": "251203",
      "Mansurpur Village BO": "251203",
      "Kasampur Khola BO": "251315",
      "Katiya BO": "251315",
      "Badiwala BO": "251327",
      "Hari Nagar BO": "251327",
      "Badhai Kalan BO": "251202",
      "Goela BO": "251318",
      "Kakra BO": "251318",
      "Shoram BO": "251318",
      "Umarpur BO": "251318",
      "Kharar BO": "247776",
      "Khera Mastan BO": "247776",
      "Barla SO": "251307",
      "Beghrajpur SO": "251203",
      "Charthawal SO": "251311",
      "Gandhi Colony SO": "251001",
      "Morna SO": "251316",
      "Muzaffar Nagar City SO": "251002",
      "Nai Abadi Budhana SO": "251309",
      "Navin Mandi Sthal SO": "251001",
      "Purkazi SO": "251327",
      "Shahpur Muzaffarnagar SO": "251318",
      "Shamli Road SO": "251002",
      "Sugar Mill Road Khatauli SO": "251201",
      "Tehsil Jansath SO": "251314",
      "Industrial Estate SO Muzaffarnagar": "251003",
      "Khala Par SO": "251002",
      "Miranpur SO": "251315",
      "Sisauli SO": "251319",
      "South Civil  Lines SO": "251001",
      "Alipur Kheri SO": "251301",
      "Anandpuri SO Muzaffarnagar": "251001",
      "Bhopa SO": "251308",
      "Brahmpuri SO": "251001",
      "Ganga Ram Pura SO": "251001",
      "Jansath SO": "251314",
      "Khatauli Bazar SO": "251201",
      "Kutchery Mzn SO": "251001",
      "Rohana Mills SO": "251202",
      "Baghra SO Muzaffarnagar": "251306",
      "Basera SO": "251310",
      "Bhopa Road SO": "251001",
      "Budhana SO": "251309",
      "Khatauli SO": "251201",
      "Laddhawala SO": "251002",
      "Mansurpur SO": "251203",
      "Prempuri SO": "251002",
      "Rampuram SO": "251001",
      "Ramraj SO": "251320"
    },
    "BALLIA": {
      "Sheopur Diar BO": "802131",
      "Nauranga BO": "277205",
      "Hanumanganj BO": "277001",
      "Deokali BO": "221717",
      "Gopalnagar BO": "277208",
      "Ibrahima Bad BO": "277208",
      "Pachkhora BO": "277123",
      "Sawan BO": "277123",
      "Sikariyan Kalan BO": "277123",
      "Achalgarh BO": "277209",
      "Bhojchapra BO": "277209",
      "Bhopalpur BO": "277209",
      "Chheridih BO": "277209",
      "Jharkataha BO": "277209",
      "Sri Nagar BO": "277209",
      "Binaha BO": "277211",
      "Dumariya BO": "277211",
      "Pandah BO": "277303",
      "Siwankala BO": "277303",
      "Apail BO": "277304",
      "Karnai BO": "277304",
      "Halpur BO": "277213",
      "Malhaua Chorkaind BO": "277213",
      "Sakarpura BO": "277213",
      "Atarsua BO": "221712",
      "Pradhanpur BO": "221712",
      "Nawapura BO": "221712",
      "Nagahar BO": "221712",
      "Kharuaon BO": "221712",
      "Maharajpur BO": "221712",
      "Nagpur BO": "221712",
      "Akhop BO": "221715",
      "Awayen BO": "221715",
      "Bahuta Chak Upadhyay BO": "221715",
      "Banspar Bahorwa BO": "221715",
      "Sonadih BO": "221715",
      "Ubhaon BO": "221715",
      "Naraon BO": "221701",
      "Birpura BO": "221709",
      "Isari Salempur BO": "221709",
      "Balesara BO": "277121",
      "Budhuan BO": "277121",
      "Sisyandkala BO": "221718",
      "Telma BO": "221718",
      "Babhanauli BO": "221716",
      "Barawan Ratipatti BO": "221716",
      "Bhujaini BO": "221716",
      "Govindpur BO": "221716",
      "Jajauli No2 BO": "221716",
      "Amaon BO": "277501",
      "Baghuna BO": "277501",
      "Atrauli BO": "221711",
      "Chandi BO": "221711",
      "Khanwar BO": "221711",
      "Kodai BO": "221711",
      "Malapharsenpur BO": "221711",
      "Nikasi BO": "221711",
      "Sultanpur BO": "277207",
      "Tadi Bada Gaon BO": "221711",
      "Chaura BO": "277502",
      "Rampur Chit BO": "277502",
      "Middha BO": "277506",
      "Thohilpali BO": "277124",
      "Usasa BO": "277124",
      "Jamalpur BO": "277208",
      "Narayengarh BO": "277208",
      "Sonbarsa BO": "277208",
      "Janaupur BO": "277123",
      "Dalchapra BO": "277209",
      "Hariahan Kalan BO": "277209",
      "Muradih BO": "277209",
      "Bigahi BO": "277211",
      "Chnd Pur BO": "277211",
      "Kusaura BO": "277211",
      "Bachhapar BO": "277303",
      "Banahra BO": "277303",
      "Nanhul BO": "277303",
      "Sisotar BO": "277303",
      "Beruarbari BO": "277304",
      "Bharakhara BO": "277304",
      "Karammar BO": "277304",
      "Jam BO": "221712",
      "Amaharpatti Uttar BO": "221712",
      "Siswar BO": "221712",
      "Amahara BO": "221712",
      "Saraybharti BO": "221712",
      "Mundera BO": "221712",
      "Parasia BO": "221711",
      "Bilthara Bazar BO": "221715",
      "Chandadih BO": "221715",
      "Sarya Dihu Bhagat BO": "221715",
      "Turtipar BO": "221715",
      "Gopalpur BO": "221701",
      "Kajhari BO": "221701",
      "Tikadeori BO": "221701",
      "Nasirpurkalan BO": "221713",
      "Takha BO": "221709",
      "Kharahatar BO": "277121",
      "Saraya BO": "277121",
      "Rampur Kanungoa BO": "221718",
      "Sikarhata BO": "221718",
      "Auria Kalan BO": "221716",
      "Bahorawan BO": "221716",
      "Bhimpura BO": "221711",
      "Kasoundar BO": "221716",
      "Ramgarh BO": "277501",
      "Deoriha BO": "221711",
      "Ekail BO": "221711",
      "Lahasani BO": "221711",
      "Narhi BO": "221711",
      "Jagadara BO": "277124",
      "Pakari BO": "277124",
      "Durjanpur BO": "277208",
      "Gonhia Chapra BO": "277208",
      "Kusauri BO": "277209",
      "Puras BO": "277211",
      "Rohuan BO": "277211",
      "Chetankishor BO": "277303",
      "Gosain Pur BO": "277303",
      "Karmauta BO": "277303",
      "Kazipur BO": "277303",
      "Athialapura BO": "221712",
      "Bhelai BO": "221712",
      "Chandrawar BO": "221712",
      "Sardaspur BO": "221712",
      "Rampur BO": "277207",
      "Rasoolpur BO": "221712",
      "Haldi Rampur BO": "221715",
      "Indauli BO": "221715",
      "Jiutpura BO": "221715",
      "Pasuhari BO": "221715",
      "Asanwar BO": "221701",
      "Aundi BO": "221701",
      "Chhibbi BO": "221701",
      "Dumari BO": "277203",
      "Sanwara BO": "221701",
      "Sinhachawar BO": "221701",
      "Akhtiyarpur BO": "221713",
      "Barhwalia BO": "221713",
      "Daulatpur BO": "221713",
      "Khari BO": "221709",
      "Ratsi Mehmanpur BO": "221709",
      "Thamhanpura BO": "277506",
      "Triloknanda BO": "221711",
      "Cherueyan BO": "277503",
      "Piprakala BO": "277504",
      "Prasadpur BO": "277124",
      "Ukachhi BO": "277124",
      "Chakia BO": "277208",
      "Karmanpur BO": "277208",
      "Madhubani BO": "277208",
      "Suremanpur BO": "277208",
      "Gaighat BO": "277209",
      "Moonchapra BO": "277209",
      "Bisauli BO": "277211",
      "Balupur BO": "277303",
      "Charawan Barwan BO": "277303",
      "Lilkar BO": "277303",
      "Masoompur BO": "277303",
      "Dhanauti BO": "277304",
      "Chintamanpur BO": "221712",
      "Kotwari BO": "221712",
      "Baijalpur BO": "221712",
      "Kurem BO": "221712",
      "Chainpur Gulaura BO": "221715",
      "Farsatar BO": "221715",
      "Kundail BO": "221715",
      "Piparauli BO": "221715",
      "Hajauli BO": "221701",
      "Kopawan BO": "221701",
      "Uchera BO": "221701",
      "Karon BO": "221713",
      "Katharia BO": "221713",
      "Sarya Bagdaura BO": "221709",
      "Jigini BO": "277121",
      "Kurejee BO": "277121",
      "Gauapar BO": "221718",
      "Rachauli BO": "221718",
      "Rupwar Bhagwanpur BO": "221718",
      "Barauli BO": "221716",
      "Ibrahimpatti BO": "221716",
      "Mahari BO": "221716",
      "Patoi BO": "221716",
      "Shahpur BO": "277121",
      "Charauan BO": "221718",
      "Jamuaon BO": "221718",
      "Palia Khas BO": "221718",
      "Mohammadpur BO": "221716",
      "Semaria BO": "277216",
      "Udharan BO": "221716",
      "Uskar BO": "221716",
      "Bharauli BO": "277501",
      "Biharaharpur BO": "221711",
      "Chachaya BO": "221711",
      "Gothain BO": "221711",
      "Inds0 BO": "221711",
      "Anjorpur BO": "277502",
      "Singhpur BO": "277503",
      "Kotwa Narayenpur BO": "277501",
      "Tutuwari BO": "277501",
      "Bachhaipur BO": "221711",
      "Dihwa BO": "221711",
      "Nanaura BO": "221711",
      "Bisukia BO": "277503",
      "Surahi BO": "277504",
      "Sawan Chapra BO": "277216",
      "Dudhaila Kalan BO": "277403",
      "Bahadura BO": "277207",
      "Baghuri BO": "221717",
      "Khathghara BO": "221717",
      "Rudrawar BO": "221717",
      "Duhabihra BO": "221717",
      "Isarpitha Patti BO": "221717",
      "Jajauli BO": "221717",
      "Jamui BO": "221717",
      "Chak Usaraila BO": "277124",
      "Parvatpur BO": "277219",
      "Sripalpur BO": "277216",
      "Suryabhanpur BO": "277216",
      "Belahari BO": "277403",
      "Dighar BO": "277403",
      "Kanchanpur BO": "277403",
      "Bhikharia BO": "277207",
      "Manikpur BO": "277207",
      "Muriyari BO": "277207",
      "Koth BO": "221717",
      "Bahuara BO": "277216",
      "Piyaraunta BO": "277403",
      "Barasari Jageer BO": "277207",
      "Bharthaon Bo": "221717",
      "Dhoridih BO": "221717",
      "Karsi BO": "221717",
      "Kathaura BO": "221717",
      "Husainabad BO": "277219",
      "Kharauni BO": "277219",
      "Jigirasand BO": "277302",
      "Khejuri BO": "277302",
      "Panicha BO": "277302",
      "Saharaspali BO": "277001",
      "Takarsand BO": "277001",
      "Khoripakar BO": "277001",
      "Raghunath Pur Piparpatti BO": "277001",
      "Bhagwanpur BO": "277201",
      "Chandpur BO": "277201",
      "Jagdeva BO": "277201",
      "Pandey Pur BO": "277201",
      "Amghat BO": "277203",
      "Dawani BO": "277203",
      "Salempur BO": "277203",
      "Bakawan BO": "277202",
      "Kaithauli BO": "277202",
      "Rajpur BO": "277202",
      "Kodahara Uparwar BO": "277204",
      "Murli Chhapra BO": "277204",
      "Ram Nagar BO": "277204",
      "Sonaki Bhat BO": "277204",
      "BALLIA HO": "277001",
      "RASRA HO": "221712",
      "Zeera Basti BO": "277001",
      "Sitakund BO": "277402",
      "Tengarihi BO": "277201",
      "Hardattpur BO": "277202",
      "Shivpur Datiwar BO": "277301",
      "Janari BO": "277401",
      "Repura BO": "277401",
      "Sahodih BO": "277210",
      "Jai Prakash Nagar BO": "277204",
      "Balihar BO": "277205",
      "Babubel BO": "277402",
      "Sonwani BO": "277402",
      "Chand Diar BO": "277214",
      "Sanwaru Bandh BO": "277001",
      "Basarik Pah BO": "277001",
      "Tikhampur BO": "277001",
      "Majhauli BO": "277203",
      "Sher BO": "277203",
      "Deodih BO": "277202",
      "Mairitar BO": "277202",
      "Suryapura BO": "277301",
      "Nagwa BO": "277401",
      "Shivpur Dier BO": "277401",
      "Dokati BO": "277204",
      "Rudrapur BO": "277402",
      "Asan BO": "277302",
      "Bara Gaon BO": "277302",
      "Kummhaila BO": "277301",
      "Agrauli BO": "277401",
      "Akhar BO": "277401",
      "Dubhar BO": "277401",
      "Hariharpur BO": "277401",
      "Chhotaki Seriya BO": "277210",
      "Kewara BO": "277210",
      "Daya Chhapra BO": "277205",
      "Gangapur BO": "277205",
      "Baghaunch BO": "277402",
      "Jawahi BO": "277402",
      "Jawahi Dear BO": "277402",
      "Ibrahimabad Uprwar BO": "277214",
      "Laxman Chapra BO": "277214",
      "Shobha Chapra BO": "277214",
      "Hathaunj BO": "277302",
      "Kirtupur BO": "277219",
      "Bharsar SO": "277401",
      "Civillines SO": "277001",
      "Dallan Chhapra SO": "277204",
      "Haldi SO Ballia": "277402",
      "Kharasara SO": "277302",
      "Nawanagar SO Ballia": "221717",
      "Shahidpark SO": "277001",
      "Sikanderpur Bus Stand SO": "277303",
      "VBNarayanpur SO": "277213",
      "BILTHARA ROAD SO": "221715",
      "Chilkahar SO": "221701",
      "Phehpana SO": "277503",
      "Bansdih Road SO": "277203",
      "Dubey Chhapra SO": "277205",
      "Jagdishpur SO Ballia": "277001",
      "Majhua SO": "277403",
      "SUKHPURA SO": "277304",
      "GARHMALPUR SO": "221709",
      "NAGRA SO": "221711",
      "Narhi SO": "277502",
      "Rasra Town SO": "221712",
      "SOHAON SO": "277504",
      "Ballia City SO": "277001",
      "Basantpur SO Ballia": "277301",
      "Chhata SO Ballia": "277210",
      "Karanchhapa SO": "277214",
      "Kheosar SO": "277219",
      "Lalganj Ballia SO": "277216",
      "Pur SO Ballia": "277124",
      "Raniganj Bazar SO": "277208",
      "RATSAR SO": "277123",
      "Sahatwar SO": "277211",
      "SIKANDERPUR SO": "277303",
      "Chitbaragaon SO": "221713",
      "Kidihirapur SO": "221716",
      "Baheri SO Ballia": "277001",
      "Bairia SO Ballia": "277201",
      "Bansdih SO": "277202",
      "Bhriguashram SO": "277001",
      "Maniar SO": "277207",
      "REOTI SO": "277209",
      "TDCollege SO": "277001",
      "Garwar SO": "277121",
      "Khandwa SO": "221718",
      "Korantadih SO": "277501",
      "Sagarpali SO": "277506"
    },
    "MATHURA": {
      "Udhar BO": "281204",
      "Bachagaon BO": "281123",
      "Kaunthra BO": "281123",
      "Nainu Patti BO": "281123",
      "Jarara BO": "281205",
      "Panigaon BO": "281204",
      "Siriya Ki Nagaria BO": "281204",
      "Agaryala BO": "281404",
      "Naugaon BO": "281404",
      "Gajoo BO": "281206",
      "Dalauta BO": "281404",
      "Fonder BO": "281123",
      "Son BO": "281123",
      "Bhidoni BO": "281205",
      "Karahari BO": "281205",
      "Lohai BO": "281205",
      "Meerpur BO": "281205",
      "Sikanderpur BO": "281205",
      "Bhadanwara BO": "281205",
      "Bhalai BO": "281205",
      "Khaira Kothi BO": "281205",
      "Nawali BO": "281205",
      "Rajagarhi Khawal BO": "281205",
      "Manav Sewa Sangh BO": "281121",
      "Sardargarh BO": "281204",
      "Adooki BO": "281006",
      "Aurangabad BO": "281006",
      "Bad BO": "281006",
      "Jatwari BO": "281404",
      "Ranhera BO": "281404",
      "Senwa BO": "281404",
      "Gudera BO": "281206",
      "Kumhan BO": "281206",
      "Bhooreka BO": "281205",
      "Hasanpur BO": "281205",
      "Maholi BO": "209402",
      "Kishanpur BO": "281305",
      "Sihora BO": "281305",
      "Rawal Banger BO": "281305",
      "Bakla BO": "281204",
      "Barhaun BO": "281204",
      "Bisawali BO": "281204",
      "Bhadraban BO": "281202",
      "Bhainsa BO": "281005",
      "Kosi Khurd BO": "281005",
      "Musmuna BO": "281203",
      "Raipur BO": "209863",
      "Madem BO": "281204",
      "Manina Balu BO": "281204",
      "Harnaul BO": "281202",
      "Jabra BO": "281202",
      "Naseeti BO": "281202",
      "Tentigaon BO": "281202",
      "Sersa BO": "281005",
      "Badhauta BO": "281504",
      "Pelkhu BO": "281504",
      "Karab BO": "281204",
      "Khirari BO": "281204",
      "Lohban BO": "281204",
      "Nagaura BO": "281204",
      "Hayatpur BO": "281305",
      "Arrua BO": "281202",
      "Dangoli Banger BO": "281202",
      "Barari BO": "281005",
      "Dhangaon BO": "281005",
      "Chhinparai BO": "281203",
      "Ral BO": "281504",
      "Airakhera BO": "281204",
      "Neemgaon BO": "281502",
      "Bandi BO": "281301",
      "Barauli BO": "281301",
      "Daulatpur BO": "281301",
      "Jharautha BO": "281301",
      "Parkham Gujar BO": "281406",
      "Sakatpur BO": "241001",
      "Kamai BO": "281405",
      "Ajhai Kurd BO": "281406",
      "Akbarpur BO": "281406",
      "Atas Bangar BO": "281406",
      "Dhansinga BO": "281401",
      "Khaira BO": "272153",
      "Gadhya Latipur BO": "281122",
      "Jhudawai BO": "281122",
      "Ole BO": "281122",
      "Prem Nagar BO": "281003",
      "Anyor BO": "281502",
      "Sahar BO": "281502",
      "Siwal BO": "281502",
      "Jab BO": "281403",
      "Kamar BO": "281403",
      "Kharoth": "281403",
      "Lalpur BO": "281403",
      "Roop Nagar BO": "281403",
      "Tarauli BO": "281406",
      "Beri BO": "281122",
      "Mahrauli BO": "281502",
      "Mudseras BO": "281502",
      "Paintha BO": "281502",
      "Byonhi BO": "281308",
      "Daghenta BO": "281308",
      "Karsaura BO": "281308",
      "Nasirpur BO": "281308",
      "Barchawali BO": "281403",
      "Bathain Kalan BO": "281403",
      "Dahgaon BO": "281403",
      "Satoha BO": "281004",
      "Usfar BO": "281004",
      "Magna BO": "281301",
      "Nera BO": "281301",
      "Patlauni BO": "281301",
      "Hathia BO": "281405",
      "Sehi BO": "281406",
      "Bishambhara BO": "281401",
      "Ladhpur BO": "281401",
      "Ranwari BO": "281401",
      "Dhanajeewana BO": "281122",
      "Pilua BO": "281122",
      "Bharana Kalan BO": "281502",
      "Mahmadpur Parasoli BO": "281502",
      "Anora BO": "281308",
      "Sarai Daud BO": "281308",
      "Bukharari BO": "281403",
      "Gidoh BO": "281403",
      "Nandgaon BO": "281403",
      "Bati BO": "281004",
      "Akosh BO": "281301",
      "Madaura BO": "281301",
      "Nagla Bali BO": "281301",
      "Avairani BO": "281301",
      "Maharana BO": "281405",
      "Dautana BO": "281401",
      "Nari BO": "281401",
      "Paigaon BO": "281401",
      "Bhaderua BO": "281122",
      "Parkham BO": "281122",
      "Pingari BO": "281122",
      "Raipura Jat BO": "281122",
      "Bhagosa BO": "281502",
      "Deoseras BO": "281502",
      "Palson BO": "281502",
      "Baltikari BO": "281308",
      "Pachawar BO": "281308",
      "Sonkh Khera BO": "281308",
      "Hatana BO": "281403",
      "Kadauna BO": "281403",
      "Kotban BO": "281403",
      "Phalen BO": "281403",
      "Sahpur BO": "281403",
      "Chhatikara  BO": "281003",
      "Edalgarhi BO": "281201",
      "Managarhi BO": "281201",
      "GB Jatipura BO": "281502",
      "Gurukul BO": "281121",
      "Mitholi BO": "281201",
      "Parsoli BO": "281201",
      "Magorra BO": "281123",
      "Jait BO": "281406",
      "Jikhangaon BO": "281501",
      "Chandpur Kalan BO": "281201",
      "Kolahar BO": "281201",
      "Pachahara BO": "281201",
      "Laxmi Nagar BO": "281204",
      "Brij Academy BO": "281121",
      "Junsuti BO": "281501",
      "Khamni BO": "281501",
      "Ahamadpur BO": "281201",
      "Awakhera BO": "281201",
      "Barauth BO": "281201",
      "Shall BO": "281201",
      "Mathura HO": "281001",
      "Chatta Bazar SO Mathura": "281001",
      "Krishna Puri SO": "281001",
      "Mahaban SO": "281305",
      "Mant SO": "281202",
      "Mathura City SO": "281001",
      "Sankat Mochan SO": "281001",
      "Sri Bankey Bihari Ji SO": "281121",
      "Vrindaban SO": "281121",
      "Chandanban SO": "281001",
      "Barsana SO": "281405",
      "Bharatpur Darwaza SO": "281001",
      "Leela Dham SO": "281121",
      "Mathura Chawk SO": "281001",
      "Raman Reti SO": "281121",
      "Raya SO": "281204",
      "Sadar Bazar SO Mathura": "281001",
      "Sonai SO Mathura": "281206",
      "Sonkh SO": "281123",
      "Sukh Sancharak SO": "281001",
      "Surir SO": "281205",
      "Maholi Road SO": "281004",
      "Aring SO": "281501",
      "Arya Samaj Road SO": "281001",
      "Bajna SO Mathura": "281201",
      "Chaumuhan SO": "281406",
      "Deeg Gate SO": "281001",
      "Farah SO": "281122",
      "GN Bazar SO": "281121",
      "Gokul SO": "281303",
      "Kosi Kalan SO": "281403",
      "Nauhjhil SO": "281203",
      "Radhakund SO": "281504",
      "Refinery Nagar SO": "281006",
      "Roberts Line SO Mathura": "281001",
      "Baldeo SO": "281301",
      "Chhata SO Mathura": "281401",
      "Civil Court SO Mathura": "281001",
      "Gayatri Tapo Bhoomi SO": "281003",
      "Goverdhan SO": "281502",
      "Jugasana SO": "281308",
      "Krishna Nagar SO Mathura": "281004",
      "Lal Darwaza SO Mathura": "281001",
      "Loi Bazar SO": "281121",
      "Mathura Jn RS SO": "281001",
      "Mathura Refinery SO": "281005",
      "Shergarh SO Mathura": "281404",
      "Sri Krishna Janam Sthan SO": "281001",
      "Veterinary College SO": "281001"
    },
    "HATHRAS": {
      "Basamaroo BO": "281306",
      "Edalpur BO": "281306",
      "Salempur BO": "203001",
      "Arti BO": "281307",
      "Gutehara BO": "281307",
      "Jarau BO": "281306",
      "Kursanda BO": "281306",
      "Kajrauthi BO": "281306",
      "Naugaon BO": "281306",
      "Hasanpur Baru BO": "281307",
      "Khonda BO": "281307",
      "Madaka Bhoj BO": "281307",
      "Nagla Beru BO": "281307",
      "Bedai BO": "281306",
      "Samadpur BO": "281306",
      "Dhadau BO": "281307",
      "Karkauli BO": "281307",
      "Sikhra BO": "281307",
      "Kanau BO": "204212",
      "Maho BO": "204212",
      "Kailora BO": "204102",
      "Dariyapur BO": "203001",
      "Ladpur BO": "204101",
      "Band Abdulhamipur BO": "204212",
      "Bapandai BO": "204212",
      "Bonai Mohabbatpur BO": "204212",
      "Nagla Danda BO": "204212",
      "Baghraya BO": "204102",
      "Dhatroi BO": "204102",
      "Allehpur BO": "204101",
      "Arjunpur BO": "204101",
      "Bisana BO": "204101",
      "Gangcholi BO": "204101",
      "Lakhnu BO": "204101",
      "Bwarwana BO": "204212",
      "Gangapur BO": "204212",
      "Shankerpur BO": "204212",
      "Punner BO": "204102",
      "Thulai BO": "204102",
      "Ahen BO": "204101",
      "Garhi Balna BO": "204101",
      "Jogia BO": "204101",
      "Karas BO": "204101",
      "Koka BO": "204101",
      "L C Hathras BO": "204101",
      "Gadola BO": "204212",
      "Guarau Kalan BO": "204212",
      "Rati Ka Nagla BO": "204212",
      "Siktara BO": "204212",
      "Srinagar BO": "204212",
      "Akhaipur BO": "204102",
      "Ahabaranpur BO": "204101",
      "Hatisa Bhagwantpur BO": "204101",
      "Kunwarpur BO": "204101",
      "Ratanpur Hussainpur BO": "204215",
      "Tati Dadia BO": "204215",
      "Mai BO": "281302",
      "Midhawali BO": "281302",
      "Rasgaon BO": "281104",
      "Bharatia BO": "281302",
      "Baramai BO": "281302",
      "Garhumrao BO": "281302",
      "Luheta Khurd BO": "204101",
      "Meetai BO": "204101",
      "Ruheri BO": "204101",
      "Tehra BO": "204101",
      "Tuksan BO": "204101",
      "Veernagar BO": "204101",
      "Tochhigarh BO": "204101",
      "Pipalgaon BO": "204211",
      "Agrana BO": "204211",
      "Basai Kazi BO": "202150",
      "Barsauli BO": "204214",
      "Rudayan BO": "204216",
      "Bastoi BO": "204215",
      "Gopi BO": "204215",
      "Gudmai Misripur BO": "204215",
      "Jiroli Kalan BO": "204215",
      "Tasinga BO": "281302",
      "Mahrara BO": "281104",
      "Bhenkuri BO": "204214",
      "Jansoi BO": "204214",
      "Basgoi BO": "204216",
      "Jiroli BO": "204216",
      "Mohariya BO": "204216",
      "Ama Madapur BO": "204215",
      "Bamnoi BO": "204215",
      "Barai Shahpur BO": "204215",
      "Chandpur Mirza BO": "204215",
      "Sikur BO": "202139",
      "Dandesari BO": "204211",
      "Garhi Hirasingh BO": "204211",
      "Northa Isepur BO": "204211",
      "Agsauli Bo": "204211",
      "Asroi BO": "204213",
      "Bardwari BO": "204213",
      "Tatarpur BO": "202150",
      "Mendamai BO": "204214",
      "Nagaria Patti BO": "204214",
      "Nagla Veer Sahai BO": "204214",
      "Pora BO": "204214",
      "Chhonda BO": "204216",
      "Dwarikapur BO": "204216",
      "Kanya Gurukul BO": "204216",
      "Arnot BO": "204215",
      "Ginoli Kishanpur BO": "204215",
      "Mau Chirayal BO": "204215",
      "Dedamai BO": "202150",
      "Parsara BO": "204101",
      "Khera Tikari BO": "204102",
      "Chandaiya BO": "202139",
      "Lutsan BO": "202139",
      "Bhatikara BO": "204211",
      "Pachaun BO": "204211",
      "Sujawalpur BO": "204211",
      "Bhisi Mirjapur BO": "204211",
      "Jawar BO": "204213",
      "Pata Khas BO": "204213",
      "Penth Gaon BO": "204213",
      "Mendu BO": "204102",
      "Bhuraka BO": "204214",
      "Parhil BO": "204216",
      "Susayat Kalan BO": "204216",
      "Tilothi BO": "204216",
      "Basai Babas BO": "204215",
      "Kapasiya BO": "204215",
      "Sokhana BO": "204101",
      "Komari BO": "202139",
      "Ganthri Shahpur BO": "204211",
      "Tikari Kalan BO": "204211",
      "Bartar khas BO": "204211",
      "Jatoi BO": "204213",
      "Kota BO": "204213",
      "Pateni BO": "204213",
      "Kachaura SO": "204211",
      "Mursan SO": "204213",
      "Sasni SO": "204216",
      "G C Sasni SO": "204216",
      "K G W Sasni SO": "202139",
      "Hasayan SO": "204212",
      "Hathras City SO": "204101",
      "Hathras Jn RS SO": "204102",
      "Hathras SO": "204101",
      "I A Hathras SO": "204101",
      "Naj Mandi S Rao SO": "204215",
      "Sikandra Rao SO": "204215",
      "M M Hathras SO": "204101",
      "Nayaganj Hathras SO": "204101",
      "Purdilpur SO": "204214",
      "Sadabad SO": "281306",
      "Bisawar SO": "281302",
      "Jalesar RS SO": "281104",
      "Sahpau SO": "281307"
    },
    "SHAHJAHANPUR": {
      "Gurugram BO": "242221",
      "Makrandpur BO": "242221",
      "Malupur BO": "242221",
      "Mangtora BO": "242221",
      "Tingri BO": "242221",
      "Bhainsi BO": "242223",
      "Deoriajhala BO": "242223",
      "Kundramajra BO": "242303",
      "Sarjupur BO": "242303",
      "Simariaraipur BO": "242303",
      "Jalalpur BO": "242305",
      "Kamlapur BO": "242305",
      "Kheramajhkhera BO": "242305",
      "Laxmipur BO": "242305",
      "Majila BO": "242305",
      "Sootha BO": "242305",
      "Lalpur BO": "242405",
      "Malika BO": "242405",
      "Muradpur BO": "242405",
      "Narotha Hansram BO": "242405",
      "Dadraul BO": "242226",
      "Nawadrudrapur BO": "242301",
      "Paliapatti BO": "242301",
      "Sandaamipur BO": "242301",
      "Seora BO": "242301",
      "Sikandarpurkalanan BO": "242301",
      "Bharribasantpur BO": "242407",
      "Bikrampurchakora BO": "242407",
      "Bilandpurgaddipur BO": "242407",
      "Chandeura BO": "242407",
      "Dhakiatiwari BO": "242407",
      "Ganpatpur BO": "242407",
      "Safaura BO": "242407",
      "Sandakhas BO": "242407",
      "Talgaon BO": "242407",
      "Unkalan BO": "242407",
      "Baragaon BO": "242401",
      "Jam Daulatpur BO": "242221",
      "Kateli Bmaua BO": "242221",
      "Khadhar BO": "242221",
      "Shahpur BO": "242221",
      "Sulamanpurpatti BO": "242221",
      "Udaipurbhoor BO": "242221",
      "Audapur BO": "242223",
      "Gandhar BO": "242223",
      "Hathel BO": "242223",
      "Indeypur BO": "242223",
      "Paraincha BO": "242223",
      "Rawatpur BO": "242223",
      "Sarthauli BO": "242223",
      "Barriprasidhpur BO": "242303",
      "Khamaria BO": "242303",
      "Marena BO": "242303",
      "Shankerpur BO": "242303",
      "Hasanpur BO": "242305",
      "Jiginia BO": "242305",
      "Korigawan BO": "242305",
      "Dhaknalahia BO": "242405",
      "Khandepur BO": "242405",
      "Prasadpur BO": "242405",
      "Tahkhurdkalan BO": "242405",
      "Azizganj BO": "242226",
      "Raikhera BO": "242226",
      "Batlaiya BO": "242301",
      "Jaitipur BO": "242301",
      "Kudaiya BO": "242301",
      "Madnapur BO": "242301",
      "Ukhlinawada BO": "242301",
      "Bahanderi BO": "242407",
      "Deoria BO": "242407",
      "Hatgaon BO": "242407",
      "Parsonakhalilpur BO": "242407",
      "Rampurbasant BO": "242407",
      "Ayun BO": "242401",
      "Behtasambad BO": "242401",
      "Gangsara BO": "242401",
      "Kotawari BO": "242401",
      "Mudiakurmiyat BO": "242401",
      "Bamhora BO": "242127",
      "Dasia BO": "242127",
      "Jakhia BO": "242127",
      "Kilapur BO": "242127",
      "Kunderi BO": "242127",
      "Mai Khurd Kalan BO": "242127",
      "Parthipur Kuverpur BO": "242127",
      "Bilsandibuzurg BO": "242401",
      "Gandharpur BO": "242401",
      "Jewan BO": "242401",
      "Nahil BO": "242401",
      "Satwabuzurg BO": "242401",
      "Sunara Buzurg BO": "242401",
      "Ullia BO": "242401",
      "Behta Jangal BO": "242127",
      "Bhundeli BO": "242127",
      "Bikrampur BO": "242127",
      "Chaurabagerkhet BO": "242127",
      "Paraur BO": "242127",
      "Kakrala BO": "242221",
      "Mirzapur BO": "242221",
      "S Purkayasthan BO": "242221",
      "Singaha Yusufpur BO": "242221",
      "Chandpur BO": "242405",
      "Tulapur BO": "242405",
      "Amora BO": "242223",
      "Dilawarpur BO": "242223",
      "Kamalnainpur BO": "242223",
      "Mp Mamarazpur BO": "242223",
      "Piprolaahmadpur BO": "242223",
      "Umraha BO": "242223",
      "Awa BO": "242303",
      "Garhiarangeen BO": "242303",
      "Umarsar BO": "242303",
      "Akbaria BO": "242305",
      "Hariharpursimra BO": "242305",
      "Gunara BO": "242221",
      "N G Mahsulpur BO": "242221",
      "Palharai BO": "242221",
      "Pehna BO": "242221",
      "Pirthvipurdhai BO": "242221",
      "Zarinpur BO": "242221",
      "Babakkarpur BO": "242223",
      "Barenda BO": "242223",
      "Kurriakalan BO": "242223",
      "Lakhnaur BO": "242223",
      "Malhpur BO": "242223",
      "Mohdpurazmabad BO": "242223",
      "Bhanpura BO": "242303",
      "Gogeypur BO": "242303",
      "Govindpur BO": "242303",
      "Charkhaula BO": "242305",
      "Baisaribaisra BO": "242301",
      "Barkherajaipal BO": "242301",
      "Jarharharipur BO": "242301",
      "Jeorabhoor BO": "242301",
      "Kotakhas BO": "242301",
      "Andkhera BO": "242407",
      "Areli BO": "242407",
      "Zindpura BO": "242407",
      "Agonasujanpur BO": "242401",
      "Jujharpur BO": "242401",
      "Kaluapur BO": "242401",
      "Kanpara BO": "242401",
      "Gundaura Daudpur BO": "242127",
      "Rautapur BO": "242405",
      "Silhua BO": "242405",
      "Jamaur BO": "242226",
      "Bauri BO": "242301",
      "Budhwana BO": "242301",
      "Kakraua BO": "242301",
      "Khundra BO": "242301",
      "Madroli BO": "242301",
      "Shahpurkhitaua BO": "242301",
      "Azizpur BO": "242407",
      "Ladhaula BO": "242407",
      "Anawa BO": "242401",
      "Korokuiyan BO": "242401",
      "Mahuichathia BO": "242401",
      "Astoli BO": "242127",
      "Barakalan BO": "242127",
      "Dahelia BO": "242127",
      "Khajuri BO": "242127",
      "Kundaria BO": "242127",
      "Laxmanpur BO": "242127",
      "Pach Deoria BO": "242127",
      "Patna Devkali BO": "242127",
      "Pilhua BO": "242127",
      "Bankagaon BO": "242306",
      "Ramapurbarkatpur BO": "242306",
      "Siswa BO": "242306",
      "Pasgawan BO": "242406",
      "Raura BO": "242406",
      "Dhaneora BO": "242307",
      "Gopalpurthatheura BO": "242307",
      "Khairpurmilkipur BO": "242307",
      "Maujampur BO": "242307",
      "Niyamatpur BO": "242001",
      "Dabhora Simra BO": "242303",
      "Dudwa BO": "242042",
      "Mohiuddinpur BO": "242042",
      "Tindua Nagaria BO": "242042",
      "Maksoodapur BO": "242042",
      "Alldadpur Baihari BO": "242221",
      "Barua BO": "242221",
      "Chilaua BO": "242220",
      "Azmatpur BO": "242042",
      "D Ghanshyam BO": "242042",
      "Devkali BO": "242042",
      "Nabhichi BO": "242042",
      "Ranmastpur BO": "242042",
      "Baharia BO": "242221",
      "Ch Sahabganj BO": "242221",
      "Bartara BO": "242306",
      "Bhatpurarasulpur BO": "242306",
      "Bhawalkhera BO": "242306",
      "Sarhi BO": "242306",
      "Scri BO": "242306",
      "Shahganj BO": "242306",
      "Badshahnagar BO": "242406",
      "Chandapur BO": "242406",
      "Chauhanapur BO": "242406",
      "SeramauSouth BO": "242406",
      "Singraha BO": "242406",
      "Banthara BO": "242307",
      "Bilhari BO": "242307",
      "Dabhora BO": "242307",
      "Nizampur BO": "242307",
      "Piproli BO": "242307",
      "Samdhana BO": "242307",
      "Dalelganj BO": "242001",
      "Sindholi BO": "242001",
      "Tera BO": "242001",
      "Chaurasia BO": "242220",
      "Jearrahimpur BO": "242220",
      "Raghunathpur BO": "242220",
      "Burhaura BO": "242221",
      "Ch Bahadupur BO": "242221",
      "Dhiaria BO": "242221",
      "Gularia BO": "242221",
      "Chhetepur BO": "242306",
      "Kursanda BO": "242306",
      "Uliapur BO": "242306",
      "Kaneng BO": "242406",
      "Mudigawan BO": "242406",
      "Shahjapur BO": "242406",
      "Chauhatia BO": "242307",
      "Dhakiaragha BO": "242307",
      "Rajanpur BO": "242307",
      "Rati BO": "242307",
      "Rujwari BO": "242307",
      "Usmanpur Sarfra BO": "242127",
      "Gurri BO": "242306",
      "Padrasikandarpur BO": "242306",
      "Uchaunlia BO": "242306",
      "Kahelia BO": "242406",
      "Khiriaheer BO": "242406",
      "Saraura BO": "242406",
      "Birsinghpur BO": "242307",
      "Rudrapur BO": "242307",
      "Chak Kanahu BO": "242001",
      "Tikri BO": "242001",
      "Subhash Nagar BO": "242001",
      "Ashrafpur BO": "242220",
      "Bhambi BO": "242042",
      "D P J Pur BO": "242042",
      "Nawadabanki BO": "242042",
      "Rarua BO": "242042",
      "Bangaon BO": "242221",
      "Bhaunti BO": "242221",
      "Khiria Rasoolpur BO": "242001",
      "Paina Buzurg BO": "242001",
      "Gora Raipur BO": "242001",
      "Katia Tola BO": "242001",
      "Pingri Pingra BO": "242001",
      "Basulia BO": "242001",
      "Murchha BO": "242001",
      "Mudia Pamar BO": "242001",
      "Kiratpur BO": "242001",
      "Mahasir BO": "242001",
      "Shahbaznagar BO": "242001",
      "Ghusgawan BO": "242001",
      "Ghantaghar BO": "242001",
      "Shahjahanpur HO": "242001",
      "Bahadurganj SO": "242001",
      "Banda SO Shahjahanpur": "242042",
      "Baruzai SO": "242001",
      "A C Factory SO": "242001",
      "Allahganj SO": "242220",
      "Charkambha SO": "242001",
      "Carewganj SO": "242001",
      "H Road SO": "242001",
      "Garrah Road SO": "242001",
      "Khera Bajhera SO": "242303",
      "Khudaganj SO": "242305",
      "Nigohi SO": "242407",
      "Powayan SO": "242401",
      "Shahjahanpur City SO": "242001",
      "Hindu Pattil SO": "242307",
      "Jalal Nagar SO": "242001",
      "Kant SO": "242223",
      "Khutar SO": "242405",
      "M Ashram SO": "242226",
      "R B Kalan SO": "242127",
      "Rosa RS SO": "242306",
      "Rosa SO": "242406",
      "Shahjahanpur Chawk SO": "242001",
      "Tilhar SO": "242307",
      "Jalalabad Mandi SO": "242221",
      "Jalalabad SO Shahjahanpur": "242221",
      "Miranpur Katra SO": "242301",
      "Mohanganj SO": "242001",
      "Krishnanagar SO": "242001",
      "Sadar Bazar SO": "242001",
      "Shahjahanpur Kutchery SO": "242001",
      "Shahjahanpur R S SO": "242001"
    },
    "KAUSHAMBI": {
      "Muratganj ED BO": "212201",
      "Kasenda BO": "212202",
      "Tilgodi BO": "212202",
      "Jayantipur BO": "212202",
      "Badagaon BO": "212203",
      "Raxwara BO": "212206",
      "Vaish Kanti BO": "212206",
      "Bamrauli BO": "212201",
      "Kokhraj BO": "212201",
      "Faridpur Salem BO": "212202",
      "Balipur Tata BO": "212203",
      "Beruwa BO": "212203",
      "Kaju BO": "212203",
      "Jahangirabad BO": "212204",
      "Sawrai Buzurg BO": "212204",
      "Korion BO": "212205",
      "Balak Mau BO": "212201",
      "Bisara BO": "212201",
      "Kasia Purab BO": "212201",
      "Boonda BO": "212202",
      "Chalauli BO": "212202",
      "Gauhani Badi BO": "212203",
      "Khandeora BO": "212203",
      "Nawawan BO": "212204",
      "Shahjadpur ED BO": "212204",
      "Afzalpur Saton BO": "212205",
      "Aureni BO": "212205",
      "Zafarpur Mahawan BO": "212206",
      "Bidaom BO": "212206",
      "Dariyapur Majhiyawan BO": "212201",
      "Guwara Gayyabpur BO": "212201",
      "Kakorha BO": "212201",
      "Kasia Pashchim BO": "212201",
      "Amirsa BO": "212202",
      "Bhikhpur Mendwara BO": "212202",
      "Jalalpur Sana BO": "212202",
      "Lokipur BO": "212203",
      "Alipur Jeeta BO": "212205",
      "Paras BO": "212205",
      "Baserhi BO": "212213",
      "Gauspur BO": "212213",
      "Sayed Serawan BO": "212213",
      "Sikandarpur Bazha BO": "212213",
      "Bhelkha BO": "212207",
      "Kadipur BO": "212207",
      "Kumbhiyawan BO": "212207",
      "Alwara BO": "212214",
      "Bairampur BO": "212214",
      "Champaha Bazar BO": "212214",
      "Goraju BO": "212214",
      "Katari BO": "212214",
      "Dharampur BO": "212216",
      "Hasanpur BO": "212216",
      "Samsabad BO": "212217",
      "Selraha BO": "212217",
      "Shakha BO": "212217",
      "Newada BO": "212218",
      "Noorpur BO": "212218",
      "Hinauta BO": "212207",
      "Purkhas BO": "212218",
      "Sarswan BO": "212207",
      "Shahpur BO": "212207",
      "Ranipur BO": "212214",
      "Arkamahabirpur BO": "212216",
      "Bandhuri Rasulipur BO": "212216",
      "Basuhar BO": "212216",
      "Hisambad BO": "212216",
      "Kanaili BO": "212216",
      "Khonpa BO": "212216",
      "Bhadehri BO": "212217",
      "Dorma BO": "212217",
      "Ganpa BO": "212217",
      "Govindpur Goriyon BO": "212217",
      "Mohabbatpur Painsa BO": "212217",
      "Alam Chand BO": "212213",
      "Bandhawa Rajwar BO": "212207",
      "Mawai BO": "212207",
      "Naugira BO": "212207",
      "Tewa BO": "212207",
      "Andhawan BO": "212214",
      "Kaushambi BO": "212214",
      "Bhakanda BO": "212216",
      "Harraipur BO": "212216",
      "Mahila BO": "212216",
      "Maohar BO": "212216",
      "Yugrajpur BO": "212216",
      "Ajhuwa Bazar ED BO": "212217",
      "Barat Fariq BO": "212217",
      "Kanwar BO": "212217",
      "Nidura BO": "212217",
      "Siyara Mithepur BO": "212217",
      "Tanda BO": "212217",
      "Tulsipur BO": "212217",
      "Audhan BO": "212218",
      "Imli Gaon BO": "212218",
      "Shaikhpur Rasoolpur BO": "212208",
      "Kurron BO": "212207",
      "Osa BO": "212207",
      "Ten Shah Aimabad BO": "212207",
      "Purab Sarira BO": "212214",
      "Banthari BO": "212216",
      "Berauncha BO": "212216",
      "Makdoompur Dhoksaha BO": "212216",
      "Mohiuddinpur BO": "212216",
      "Afjalpurwari BO": "212217",
      "Anetha BO": "212217",
      "Nara BO": "212217",
      "Rampur Dhamawan BO": "212217",
      "Udhinbuzurg BO": "212217",
      "Bigahra Usmanpur BO": "212218",
      "Chail SO Kaushambi": "212202",
      "Bharwari SO Kaushambi": "212201",
      "Charwa SO": "212203",
      "Kara SO": "212205",
      "Karari SO": "212206",
      "Manjhanpur SO": "212207",
      "Sirathu SO": "212217",
      "Daranagar SO Allahabad": "212204",
      "Mahgaon SO": "212213",
      "Sarai Akil SO": "212216",
      "Pashchim Sarira SO": "212214",
      "Tilhapur SO": "212218"
    },
    "CHANDAULI": {
      "Babhniyaon Raipur BO": "232105",
      "Hingutarjagdishpur BO": "232105",
      "Shaheedgaon BO": "232105",
      "Torwan BO": "232105",
      "Jalalpur BO": "232106",
      "Kamharia BO": "232108",
      "Kawaipaharpur BO": "232106",
      "Chandasi BO": "232101",
      "Jamunipur BO": "232104",
      "Amara BO": "232110",
      "Dabaria BO": "232105",
      "Sakrari BO": "232105",
      "Awati BO": "232106",
      "Dheena BO": "232106",
      "Hetampur BO": "232106",
      "Kadirabad BO": "232106",
      "Pipari BO": "232106",
      "Alampur BO": "232101",
      "Bharchha BO": "232101",
      "Dulhipur BO": "232101",
      "Kurahana BO": "232101",
      "Chakarghatta BO": "232111",
      "Amilia BO": "232118",
      "Bhorsar BO": "232118",
      "Kanta BO": "232104",
      "Parasikalan BO": "232104",
      "Dharaon BO": "232105",
      "Khagwal BO": "232104",
      "Khurja BO": "232104",
      "Launda BO": "232104",
      "Majhwarkhas BO": "232104",
      "Marhi BO": "232104",
      "Vishunpura BO": "232104",
      "Arkaura BO": "232106",
      "Dighghi BO": "232106",
      "Raiytha BO": "232106",
      "Sishaurakalan BO": "232106",
      "Alinagar BO": "232101",
      "Hanumanpur BO": "232101",
      "Amdaha BO": "232111",
      "Majhghain BO": "232111",
      "Laxmangarh BO": "232107",
      "Pharsand Mohanpur BO": "232120",
      "Keshavpur BO": "232120",
      "Rupetha BO": "232120",
      "Baraura BO": "232118",
      "Baghari BO": "232106",
      "Barahan BO": "232106",
      "Chilabali BO": "232106",
      "Derhawan BO": "232106",
      "Kharan BO": "232106",
      "Meerasarai BO": "232106",
      "Merahan BO": "232106",
      "Noori BO": "232106",
      "Dandi BO": "232101",
      "Derwakalan BO": "232101",
      "Jalilpur BO": "232101",
      "Niyamatabad BO": "232101",
      "Pachokhar BO": "232101",
      "Shamsherpur BO": "232111",
      "Ballipur BO": "232107",
      "Nadi Nidhaura BO": "232107",
      "Nairhi BO": "232107",
      "Saifpur BO": "232107",
      "Janso Ki Marai BO": "232120",
      "Kori BO": "232120",
      "Maharkha BO": "232120",
      "Sanghati BO": "232120",
      "Amaon BO": "232118",
      "Jarkhor BO": "232102",
      "Pasahi BO": "232102",
      "Shivpur BO": "232102",
      "Bhaisahi BO": "232103",
      "Bhatraul BO": "232103",
      "Gaighat BO": "232103",
      "Akorha BO": "232102",
      "Dhaneja BO": "232102",
      "Gauri BO": "232102",
      "Mavaiya BO": "232102",
      "Sikari BO": "232102",
      "Bhabhaura BO": "232103",
      "Bhikhampur BO": "232103",
      "Kharaujha BO": "232103",
      "Bhadauliya BO": "232102",
      "Dharde BO": "232102",
      "Bentairi BO": "232103",
      "Musakhan BO": "232103",
      "Rampurkala BO": "232103",
      "Utraut BO": "232103",
      "Dharauli BO": "232104",
      "Pachwania BO": "232103",
      "Saidupur BO": "232103",
      "Sikanderpur BO": "232103",
      "Sikarganj BO": "232103",
      "Barthara Kalan BO": "232104",
      "Basila BO": "232104",
      "Bisauri BO": "232104",
      "Karnaul BO": "232118",
      "Bhurkura BO": "232118",
      "Ghosawa BO": "232110",
      "Jeori BO": "232110",
      "Naubatpur BO": "232110",
      "Kawanr BO": "232109",
      "Kharehara BO": "232109",
      "Mahuwarikhas BO": "232109",
      "Mathela BO": "232109",
      "Naikot BO": "232109",
      "Papaura BO": "232109",
      "Prabhupur BO": "232109",
      "Bardisanda B.O": "232108",
      "Marufpur BO": "221115",
      "Piparia BO": "232103",
      "Tiyari BO": "232103",
      "Jagdish Sarai BO": "232104",
      "Dhunnoo BO": "232118",
      "Keraigaon BO": "232118",
      "Khakhara BO": "232118",
      "Tiyara BO": "232118",
      "Bagahikumbhapur BO": "232110",
      "Bhatiza BO": "232110",
      "Fesuda BO": "232110",
      "Oyarchak BO": "232110",
      "Rewasa BO": "232110",
      "Bathawar BO": "232109",
      "Chahania BO": "232109",
      "Awajapur BO": "232108",
      "Maniyarpur BO": "232108",
      "Ranepur BO": "232108",
      "Samudpur BO": "221115",
      "Khilchi BO": "232118",
      "Adsand BO": "232110",
      "Arangi BO": "232110",
      "Asana BO": "232110",
      "Rampur BO": "232110",
      "Amilai BO": "232109",
      "Balua BO": "232109",
      "Darahara BO": "232108",
      "Dighwat BO": "232108",
      "Kavarua BO": "232108",
      "Mahesua Nai Bazar BO": "232108",
      "Jurahardhan BO": "221115",
      "Mahuwarkalan BO": "221115",
      "Illia BO": "232118",
      "Katwamafi BO": "232118",
      "Barahani BO": "232110",
      "Bhujana BO": "232110",
      "Chiraigaon BO": "232110",
      "Imilia BO": "232110",
      "Seruka BO": "232110",
      "Sogai BO": "232110",
      "Gurera BO": "232109",
      "Sewari BO": "232109",
      "Bhojapur BO": "232108",
      "Naraina BO": "232108",
      "Paura BO": "232108",
      "Tulsiashram Nonar BO": "232108",
      "Chhapara BO": "221115",
      "Patti BO": "221115",
      "Targaonajgara BO": "221115",
      "Chakia SO": "232103",
      "Chandauli SO": "232104",
      "Mugalsarai SO": "232101",
      "Railway Colony SO": "232101",
      "Sahupuri SO": "221009",
      "Saiyadraja SO": "232110",
      "Sakaldiha Bazar SO": "232109",
      "Ramgarh SO Chandauli": "232107",
      "Kamalpur SO": "232106",
      "Naugarh SO": "232111",
      "Dhanapur SO": "232105",
      "Patelnagar SO": "232101",
      "Sadalpura SO": "232120",
      "Sahabganj SO Chandauli": "232118",
      "Sakaldiha SO": "232108",
      "Tanda Kalan SO": "221115",
      "Basant Nagar SO": "221110",
      "Baburi SO": "232102"
    },
    "PILIBHIT": {
      "Goradhanenega BO": "262123",
      "Haripur BO": "262123",
      "Sondha BO": "262123",
      "Seramau North BO": "262123",
      "Sultanpur BO": "262123",
      "Mahuagundey BO": "262123",
      "Kajriniranjanpur BO": "262123",
      "Shahi BO": "262001",
      "Chandia Hajara BO": "262904",
      "Kabir Ganj BO": "262904",
      "Shardapuri BO": "262904",
      "Ram Nagar BO": "262904",
      "Ashok Nagar BO": "262904",
      "Jatpura BO": "262122",
      "Lalpur BO": "262001",
      "Morania Gandhi Nagar BO": "262904",
      "Hardaspur BO": "262302",
      "Kanakore BO": "262001",
      "Kalyanpur Khas BO": "262001",
      "Gahluia BO": "262001",
      "Jaitpur BO": "262001",
      "Amkhera BO": "262203",
      "Bahadurpur BO": "262203",
      "Ram Nagar Jagatpur BO": "262203",
      "Sehpura BO": "262203",
      "Simra Akbar Ganj BO": "262203",
      "Bhaden Kanja BO": "262202",
      "Kareli BO": "262202",
      "Meerpur Hamupura BO": "262202",
      "Amrita BO": "262201",
      "Azampur Barkhera BO": "262201",
      "Badhera BO": "262201",
      "Churra BO": "262201",
      "Dhakia Ranjeet BO": "262201",
      "Imalia Gangi BO": "262201",
      "Intgoan BO": "262201",
      "Khandepur BO": "262201",
      "Kishni BO": "262201",
      "Neoria Mobile BO": "262305",
      "Pandari BO": "262305",
      "Chandia Hazara BO": "262122",
      "Dhuria Palia BO": "262122",
      "Dudhia Khurd BO": "262122",
      "Gobhia Sarai BO": "262122",
      "Bithora Kalan BO": "262001",
      "Dalelganj BO": "262001",
      "Lalauri Khera BO": "262001",
      "Mala Colony BO": "262001",
      "Gajraula Kalan BO": "262001",
      "Khamaria Pull BO": "262001",
      "Piparia Agroo BO": "262001",
      "Khundara BO": "262001",
      "Baratbhoj BO": "262001",
      "Barehpura BO": "262121",
      "Harraipur BO": "262121",
      "Kargaina BO": "262121",
      "Parewa Vaish BO": "262121",
      "Chathiya BO": "262121",
      "Jeorah Kalyanpur BO": "262203",
      "Karunapur Karoor BO": "262203",
      "Khajuria Pachpera BO": "262203",
      "Madhupuri BO": "262203",
      "Mudia Hulas BO": "262203",
      "Narainpur BO": "262203",
      "Pania Ramkishan BO": "262203",
      "Amra Karoor BO": "262201",
      "Bauni BO": "262201",
      "Mohammadpur Bhanja BO": "262201",
      "Naugawan Santosh BO": "262201",
      "Chandupur BO": "262124",
      "Ghatampur BO": "262122",
      "Madhotanda BO": "262122",
      "Naujalia Nakatia BO": "262122",
      "Piperia Dulai BO": "262122",
      "Ramnagra Colony BO": "262122",
      "Roodpur BO": "262122",
      "Shahgarh BO": "262122",
      "Sherpur BO": "262122",
      "Shivnagar BO": "262122",
      "Udaikaranpur BO": "262122",
      "Guladiya Bhoopsingh BO": "262122",
      "Jitauriya  BO": "262122",
      "Sardar Nagar BO": "262001",
      "Bahanpur BO": "262001",
      "Roopur Kamaloo BO": "262001",
      "Dang BO": "262001",
      "Richhaula BO": "262001",
      "Sakhaula BO": "262001",
      "Tirkunia BO": "262121",
      "Bhopatpura BO": "262203",
      "Parasi Ramkishan BO": "262203",
      "Pauta Kalan BO": "262203",
      "Bakania BO": "262202",
      "Behti BO": "262202",
      "Chandoi BO": "262001",
      "Sarauri BO": "262001",
      "Suhas BO": "262001",
      "Nizamdandi BO": "262001",
      "Bhikaripur BO": "262001",
      "Maktul BO": "262001",
      "Pilibhit Chowk Ndedso BO": "262001",
      "Banskhera BO": "262121",
      "Bhadsara BO": "262121",
      "Mundalia BO": "262121",
      "Pipalia BO": "262121",
      "Daulatpur BO": "262203",
      "Jogither BO": "262203",
      "Parsia BO": "262203",
      "Piperia Mundan BO": "262203",
      "Bamrauli BO": "262202",
      "SINDHAURA KHARAGPUR BO": "262202",
      "Ahirwara BO": "262201",
      "Deoria Kalan BO": "262201",
      "Jallapur BO": "262201",
      "Luhicha BO": "262201",
      "Meerpur Bahanpur BO": "262201",
      "Paharganj BO": "262201",
      "Rohania BO": "262201",
      "Harrai BO": "262201",
      "Biharipur Hira BO": "262201",
      "Jamunia BO": "262124",
      "MATHANA  JAPTI BO": "262124",
      "Sunpahar BO": "262302",
      "Bhagwantapur BO": "262122",
      "Ghungchai BO": "262122",
      "Kadherchaura BO": "262122",
      "Kasganja BO": "262122",
      "Rampura Fakire BO": "262122",
      "Sabalpur BO": "262122",
      "Pachpeda Taluke Maharajpur BO": "262122",
      "Ranth BO": "262202",
      "Barkhera Chaturaha BO": "262201",
      "Chandpura BO": "262201",
      "Deohana BO": "262201",
      "Ghajhera BO": "262201",
      "Karrkhera BO": "262201",
      "Kumirkha BO": "262201",
      "Madhopur BO": "262201",
      "Rasiayankhanpur BO": "262201",
      "Piperia Santosh BO": "262124",
      "Dunidam BO": "262302",
      "Abhaipur BO": "262122",
      "Bhairo Kalan BO": "262122",
      "Gulabtanda BO": "262122",
      "Karnapur BO": "262122",
      "Jahanabad BO": "262001",
      "Pilibhit HO": "262001",
      "Ganesh Ganj SO Pilibhit": "262122",
      "Kali Nagar SO": "262124",
      "Amaria SO": "262121",
      "Bilsanda SO": "262202",
      "Katra Bazar SO Pilibhit": "262201",
      "Neoria SO": "262305",
      "Jograjpur SO": "262123",
      "Khakra SO": "262001",
      "Pilibhit City SO": "262001",
      "Barkhera SO": "262203",
      "Bisalpur SO": "262201",
      "Majhola SO Bareilly": "262302",
      "Pilibhit Kutchery SO": "262001",
      "Pooranpur SO": "262122",
      "Station Road Pilibhit SO": "262001"
    },
    "AMROHA": {
      "Gajana BO": "244221",
      "Jalajpur Dhana BO": "244221",
      "Papsara BO": "244221",
      "Telipurmali BO": "244221",
      "Nanhera Aliarpur BO": "244221",
      "Qazi Sarai Urf Kankar Sarai BO": "244221",
      "Buderna BO": "244221",
      "Hajarpur Jamania BO": "244221",
      "Mundha Khera BO": "244221",
      "Gulariya BO": "244221",
      "Bahadur Pur Khurd BO": "244221",
      "Kailsa BO": "244221",
      "Ahraula Mafi BO": "244231",
      "Chuchelakalan BO": "244231",
      "Dingra BO": "244231",
      "Iqbalpur Urf Kamelpor BO": "244231",
      "Kapsua BO": "244231",
      "Kankather BO": "244235",
      "Khadgujar BO": "244235",
      "Nagliamev BO": "244235",
      "Pipalidaud BO": "244241",
      "Sihalijagir BO": "244241",
      "Yaqubpur BO": "244241",
      "Palaula BO": "244222",
      "Saghan Machharya BO": "244222",
      "Lakarhat BO": "244501",
      "Makhdoompur BO": "244251",
      "Didaura BO": "244102",
      "Chand Nagar BO": "244236",
      "Khajuri BO": "244236",
      "Maheshra BO": "244236",
      "Adampur BO": "244255",
      "Bartaura BO": "244255",
      "Bijnaura BO": "244242",
      "Chakooni BO": "244242",
      "Chakanwala BO": "244225",
      "Tomra BO": "244225",
      "Ladanpur BO": "244231",
      "Wasipur BO": "244231",
      "Salempurgosai BO": "244235",
      "Burawali BO": "244241",
      "Mangraula BO": "244241",
      "Sarkari  Ajij BO": "244222",
      "Tohfapur Bhawanipur BO": "244222",
      "Jamna Khas BO": "244501",
      "Awalpur BO": "244251",
      "Gajasthal BO": "244251",
      "Kaural BO": "244251",
      "Chaudhar Pur BO": "244102",
      "Painti Kalan BO": "244102",
      "Daryal Khadar BO": "244255",
      "Imratpur BO": "244255",
      "Dehpa BO": "244242",
      "Dhawarsi BO": "244242",
      "Said Nagli BO": "244242",
      "Phanderi BO": "244231",
      "Gangacholi BO": "244241",
      "Gangwar BO": "244241",
      "Didauli BO": "244222",
      "Basera Taga BO": "244501",
      "Bibra Khurd BO": "244501",
      "Khera Apraula BO": "244251",
      "Deorhi Urf Hadipur BO": "244102",
      "Paurara BO": "244255",
      "Lohari Bhoor BO": "244242",
      "Osa Mafi BO": "244242",
      "Sohat BO": "244242",
      "Dhauti BO": "244225",
      "Sherpur BO": "244225",
      "Kauralla BO": "244231",
      "Papsari BO": "244231",
      "SR Dhanaura BO": "244231",
      "Bijaura BO": "244235",
      "Tigree BO": "244235",
      "Patai Bhoor BO": "244241",
      "Sarkara Kamal BO": "244222",
      "Kail Bakri BO": "244501",
      "Jajroo BO": "244251",
      "Patai Khalsa BO": "244102",
      "Atrasikalan BO": "244236",
      "Karaundi BO": "244236",
      "Piplikalan BO": "244236",
      "Chhapna BO": "244255",
      "Gangeshwari BO": "244255",
      "Jahtauli BO": "244255",
      "Dhakka BO": "244242",
      "Kunderki Bhoor BO": "244242",
      "Amroha HO": "244221",
      "Gajraula SO": "244235",
      "Rajab Pur SO": "244236",
      "Amroha Bazar SO": "244221",
      "Bhartiya Gram SO": "244223",
      "Joya SO": "244222",
      "Kundan Nagar SO": "244245",
      "Rehra SO": "244255",
      "Ujhari SO": "244242",
      "Amroha Shahi Chabutra SO": "244221",
      "Bachhraon SO": "244225",
      "Dhanaura SO": "244231",
      "Hasanpur SO Jyotiba Phule Nagar": "244241",
      "M B Hasanpur SO": "244241",
      "Nawgawan SO": "244251"
    },
    "BASTI": {
      "Bhawanipur BO": "272124",
      "Samaspur BO": "272124",
      "Kothwa BO": "272124",
      "Naraiyanpur BO": "272124",
      "Niranjanpur BO": "272124",
      "Pipragautam BO": "272124",
      "Gonare BO": "272171",
      "Newari BO": "272171",
      "Rautapar BO": "272171",
      "Misrauliya BO": "272124",
      "Thokwa BO": "272171",
      "Gaura Upadhyay BO": "272124",
      "Rampur BO": "272178",
      "Sillo BO": "272124",
      "Barahpur BO": "272155",
      "Belghat BO": "272163",
      "Pendar BO": "272163",
      "Pikaura BO": "272163",
      "Pipra Kazi BO": "272163",
      "Ambari BO": "272150",
      "Dasia BO": "272150",
      "Majhauwa Baikunth BO": "272150",
      "Raunakala BO": "272150",
      "Delhwa BO": "272301",
      "Dihukpura BO": "272301",
      "Parsaon BO": "272301",
      "Rajpur Bairihwa BO": "272301",
      "Belsar BO": "272163",
      "Belwaria Jungle BO": "272161",
      "Mansoornagar BO": "272163",
      "Bhadawal BO": "272155",
      "Chorkhari BO": "272155",
      "Gauhania BO": "272155",
      "Chhardahi BO": "272301",
      "Chilma Bazar BO": "272301",
      "Kewarimustahkam BO": "272301",
      "Manuwa BO": "272301",
      "Bairikhala BO": "272163",
      "Itbahara BO": "272163",
      "Kurda BO": "272163",
      "Sukrauli BO": "272163",
      "Misraulia Bhaiya BO": "272150",
      "Amari Bazar BO": "272155",
      "Keshwapur BO": "272155",
      "Mahuwapar BO": "272155",
      "Sukrauli Chaudhary BO": "272155",
      "Bhangura BO": "272301",
      "Gaighat BO": "272301",
      "Gauspur BO": "272301",
      "Kanaila BO": "272301",
      "Kusaura BO": "272301",
      "Naikapar BO": "272301",
      "Ainpur BO": "272163",
      "Ajgaiba Jungle BO": "272163",
      "Bhainsa Chaubey BO": "272163",
      "Kachhia BO": "272163",
      "Sardaha Sukul BO": "272163",
      "Shivpur BO": "272163",
      "Tinich BO": "272163",
      "Kohra BO": "272150",
      "Parsa  Damya BO": "272150",
      "Mahrajganj BO": "272155",
      "Majhauwa Babu BO": "272155",
      "Thana Khas BO": "272155",
      "BaiMustahkam BO": "272301",
      "Dingrapur BO": "272301",
      "Kudraha BO": "272301",
      "Umaria BO": "272301",
      "Ahra BO": "272178",
      "Bodwal BO": "272178",
      "Chaikala BO": "272178",
      "Changera Mangera BO": "272178",
      "Sanda BO": "272178",
      "Dewapar BO": "272302",
      "Kasaila BO": "272302",
      "Meetanjot BO": "272302",
      "Semara BO": "272302",
      "Diwakarpur BO": "272181",
      "Jitipur BO": "272181",
      "Bhainsaha BO": "272130",
      "Deferi BO": "272130",
      "Harish Nagar BO": "272130",
      "Dudhaura BO": "272002",
      "Gaura BO": "272002",
      "Pakri Jai BO": "272002",
      "Puraina Mansoor BO": "272002",
      "Puraina Pandey BO": "272002",
      "Pursia BO": "272002",
      "Saithawalia BO": "272002",
      "Subdeiyakala BO": "272002",
      "Sehuda Kala BO": "272148",
      "Sagra BO": "272151",
      "Jahlipur BO": "272190",
      "Lapsi BO": "272190",
      "Majhauwa Khurd BO": "272190",
      "Sihari Sardaha BO": "272190",
      "Nandnagar BO": "272129",
      "Sikandarpur BO": "272129",
      "Tharuapur BO": "272129",
      "BelwaBO": "272129",
      "Bhuwandand BO": "272178",
      "Budhakala BO": "272178",
      "Daridiha BO": "272178",
      "Ekdangi BO": "272178",
      "Padari BO": "272178",
      "Unchgaon BO": "272178",
      "Katya BO": "272302",
      "Mahripur BO": "272302",
      "Ranipur BO": "272302",
      "Belbharia Ram Gulam BO": "272181",
      "Itwakungai BO": "272181",
      "Mahadewa BO": "272181",
      "Vedipur BO": "272181",
      "Gopinathpur BO": "272130",
      "Jagdishpur BO": "272130",
      "Bankata BO": "272002",
      "Bhelkha BO": "272002",
      "Ganeshpur BO": "272002",
      "Jamadashahi BO": "272002",
      "Karma Khan BO": "272002",
      "Majhauwa Khajuri BO": "272002",
      "Nagahara BO": "272002",
      "Pakari Dhaurahra BO": "272002",
      "Raghunathpur BO": "272130",
      "Dandwapandey BO": "272148",
      "Bankatia BO": "272151",
      "Malhwar BO": "272151",
      "Chaukwa BO": "272190",
      "Jinswa BO": "272190",
      "Teliha Deeh BO": "272190",
      "Dhenugawan BO": "272129",
      "Siarapar BO": "272182",
      "Dhirauli Babu BO": "272127",
      "Ghorsayen BO": "272127",
      "Jaitapur BO": "272127",
      "Baghari BO": "272178",
      "Gulariha Sirma BO": "272178",
      "Karah Pithia BO": "272178",
      "Kurthia BO": "272178",
      "Sallepur BO": "272178",
      "Beili BO": "272302",
      "Marwatia Baboo BO": "272302",
      "Lalpur BO": "272130",
      "Salempur BO": "272130",
      "Sringinari BO": "272130",
      "Baghnagar BO": "272002",
      "Bai Pokhar BO": "272002",
      "Kondra Pandey BO": "272002",
      "Labnapar BO": "272002",
      "Majahuwameer BO": "272002",
      "Kerauna BO": "272148",
      "Mahuwar BO": "272148",
      "Bargadwa BO": "272190",
      "Sonha BO": "272190",
      "Bansgoan BO": "272178",
      "Kuriyar BO": "272178",
      "Rajapur Sarraiya BO": "272178",
      "Unchahara Kala BO": "272178",
      "Bahadurpur BO": "272302",
      "Kathar Jungle BO": "272302",
      "Lakhanahat BO": "272302",
      "Pokharni BO": "272302",
      "Hundrakunwar BO": "272181",
      "Raghwapur BO": "272181",
      "Kharawan Kunwsar BO": "272130",
      "Nedula BO": "272130",
      "Basti Sugar Factory BO": "272002",
      "Chhapia Sheobaran BO": "272002",
      "Hathiagarh BO": "272002",
      "Karahi BO": "272002",
      "Madwanagar BO": "272002",
      "Manjharia Vikram BO": "272002",
      "Marwatia Kasaila BO": "272002",
      "Orawara BO": "272002",
      "Rasoolpur BO": "272002",
      "Ushara Shahid BO": "272002",
      "Athadama BO": "272151",
      "Bhitehara BO": "272151",
      "Khambha BO": "272151",
      "Surwarkalan BO": "272151",
      "Amrauli Sumali BO": "272190",
      "Bishunpurwa BO": "272190",
      "Malauli Gosain BO": "272129",
      "Belhara BO": "272182",
      "Sansarpur BO": "272182",
      "Hiyaroopur BO": "272127",
      "Gaura Pandey BO": "271305",
      "Amarediha BO": "272194",
      "Dhaurahra BO": "272194",
      "Khesuwa BO": "272127",
      "Pachwas BO": "272127",
      "Dhosar BO": "272194",
      "Karmahiya BO": "272194",
      "Piraila Garib BO": "272194",
      "Ramnagar BO": "272194",
      "Barahuwan BO": "272123",
      "Sarraiya Atibal BO": "272128",
      "Sudipur BO": "272128",
      "Turkipur BO": "272128",
      "Barahata BO": "272131",
      "Barhni BO": "272131",
      "Bemhari BO": "272131",
      "Dailapur BO": "272131",
      "Pak Bakhtawar BO": "272131",
      "Tilakpur BO": "272131",
      "Mahuwadabar BO": "272161",
      "Deisand BO": "272123",
      "Pagar BO": "272123",
      "Khairati BO": "272177",
      "Naguwa BO": "272177",
      "Kataria BO": "272128",
      "Dubaulia BO": "272131",
      "Gopiapar BO": "272131",
      "Govindpara BO": "272131",
      "Kodai BO": "272131",
      "Naghara BO": "272131",
      "Unji BO": "272131",
      "Tusail BO": "272194",
      "Barhya BO": "272161",
      "Nande Kuwan BO": "272128",
      "Haribanshpur BO": "272131",
      "Kaudikol BO": "272131",
      "C C M Padmapur BO": "272131",
      "Jajupur BO": "272127",
      "Sangrampur BO": "272127",
      "Turasi BO": "272127",
      "Bhanpur Babu BO": "272194",
      "Dhawai BO": "272194",
      "Tandwa BO": "272194",
      "Bharwalia BO": "272123",
      "Khoria BO": "272123",
      "Bhitani BO": "272177",
      "Kharka BO": "272177",
      "Bardia Kunwar BO": "272128",
      "Roopgarh BO": "272128",
      "Bairagal BO": "272131",
      "Dubauli Dubey BO": "272131",
      "Garha BO": "272131",
      "Mahuwalakhanpur BO": "272131",
      "Ojhaganj BO": "272131",
      "Pokhara BO": "272131",
      "Basti HO": "272001",
      "Basti BS SO": "272002",
      "Dakhin Darwaza SO Basti": "272002",
      "Gandhinagar SO Basti": "272001",
      "Pandey Bazar SO": "272002",
      "Rudranagar SO": "272151",
      "Saltauwa SO": "272190",
      "Shankarpur SO": "272129",
      "Munderwa SO": "272178",
      "Amorha": "272127",
      "Babhnan SO": "272161",
      "Bankati Bazar SO": "272123",
      "Hanumanganj SO": "272150",
      "ITI SO Basti": "272001",
      "Kalwari SO": "272301",
      "Lalganj Basti SO": "272171",
      "Mahson SO": "272124",
      "Rayath SO": "272148",
      "Asnahra SO": "272194",
      "Bishesharganj SO": "272128",
      "Nagar Bazar SO": "272302",
      "Paikolia SO": "272181",
      "Parasrampur SO": "272130",
      "Walterganj SO": "272182",
      "Banpur SO": "272177",
      "Basti Kutchery SO": "272001",
      "Captainganj SO": "272131",
      "Civil Line SO Basti": "272001",
      "Gaur RS SO": "272163",
      "Harraiya SO": "272155",
      "Orijote SO": "272001",
      "Purani Basti SO": "272002",
      "TB Clinic SO Basti": "272002"
    },
    "SANT KABEER NAGAR": {
      "Pakhuwapar BO": "272175",
      "Shivapar BO": "272162",
      "Sikari BO": "272175",
      "Utrawal BO": "272175",
      "Asharfa Bad BO": "272173",
      "Chhitahi BO": "272172",
      "Belauli BO": "272271",
      "Bhitia Kala BO": "272271",
      "Bisauwa BO": "272271",
      "Ghurapali BO": "272271",
      "Jagdishpur Urf Lahuradeva BO": "272175",
      "TNDeoria BO": "272175",
      "Tama BO": "272165",
      "Girdhar Pur BO": "272173",
      "Rasula Bad BO": "272173",
      "Taryapar BO": "272172",
      "Barhya BO": "272271",
      "Bhatauli BO": "272271",
      "Gagnai Rao BO": "272271",
      "Gulariha BO": "272271",
      "Karmaini BO": "272271",
      "Gorhi BO": "272175",
      "Madhopur BO": "272162",
      "Misraulia BO": "272175",
      "Sugapankhi BO": "272175",
      "Umari Kalan BO": "272175",
      "Padaria BO": "272173",
      "Siswania BO": "272172",
      "Jamohara BO": "272271",
      "Jaswal BO": "272271",
      "Kauwathore BO": "272271",
      "Gangauli BO": "272175",
      "Ghatramha BO": "272175",
      "Koni BO": "272175",
      "Meerganj BO": "272175",
      "Samdaha BO": "272175",
      "Lutuhi BO": "272172",
      "Siktaha BO": "272172",
      "Devri BO": "272165",
      "Ghorang BO": "272165",
      "Malauli BO": "272165",
      "Tumpar BO": "272164",
      "Atraura BO": "272175",
      "Baghauli BO": "272175",
      "Bania Bari BO": "272175",
      "Bargo BO": "272175",
      "Chakdahi BO": "272175",
      "Deokali Kala BO": "272176",
      "Dhaurepar BO": "272176",
      "Dhobbhara BO": "272176",
      "Gaighat BO": "272176",
      "Pindia Bazar BO": "272176",
      "Revta BO": "272176",
      "Auradand BO": "272165",
      "Bakainia BO": "272165",
      "Barparwa BO": "272165",
      "Bhainsa Khoont BO": "272165",
      "Rajnauli BO": "272165",
      "Sirsi BO": "272165",
      "Bhagata BO": "272164",
      "Chandrahar BO": "272164",
      "Devapar BO": "272164",
      "Dhanjwsal BO": "272164",
      "Ekma BO": "272175",
      "Parsa Jhakaria BO": "272125",
      "Mahobara BO": "272176",
      "Nukta BO": "272176",
      "Babhnauli BO": "272165",
      "Baridiha BO": "272165",
      "Jigina BO": "272165",
      "Molnapur BO": "272164",
      "Tamakhas BO": "272164",
      "Dhamaicha BO": "272175",
      "Pakari Araji BO": "272125",
      "Sangath BO": "272125",
      "Sumha BO": "272125",
      "Bhainsahi BO": "272176",
      "Kali Jagdishpur BO": "272176",
      "Mukhlishpur BO": "272176",
      "Onia BO": "272176",
      "Baijnathpur BO": "272165",
      "Bharwal Parvata BO": "272165",
      "Katarsoyam BO": "272165",
      "Mundera Shukul BO": "272165",
      "Tanda BO": "272165",
      "Tighra BO": "272165",
      "Belduha BO": "272164",
      "Govindpur BO": "272164",
      "Popaya BO": "272164",
      "Taraini BO": "272164",
      "Vishwanathpur BO": "272164",
      "Bhujaini BO": "272175",
      "Deegha BO": "272175",
      "Gandhigram BO": "272175",
      "Gunakhor BO": "272126",
      "Kohriyawan BO": "272126",
      "Tinharimafi BO": "272126",
      "Belhar Kala BO": "272270",
      "Kudwa BO": "272271",
      "Naugo BO": "272271",
      "Pachneori BO": "272271",
      "Sxande Khurd BO": "272271",
      "Pipra Pratham BO": "272148",
      "Hatwa BO": "272125",
      "Kaitholia BO": "272148",
      "Babhni Misra BO": "272126",
      "Banskhor Kalan BO": "272126",
      "Bhagausa BO": "272126",
      "Dandwakala BO": "272126",
      "Bhataura BO": "272270",
      "Karma Kalan BO": "272270",
      "Kotia Urf Sekhui BO": "272270",
      "Loharsan BO": "272270",
      "Bhainsamafi BO": "272270",
      "Chiraiha BO": "272148",
      "Manaitapur BO": "272148",
      "Bhitiya BO": "272126",
      "Danokuiya BO": "272126",
      "Tilja BO": "272126",
      "Narayanpur BO": "272270",
      "Belhasa BO": "272199",
      "Kopia BO": "272199",
      "Santoshpur BO": "272199",
      "Chaparaghat BO": "272162",
      "Dihwa BO": "272162",
      "Marpauna BO": "272162",
      "Rosaya Bazar BO": "272162",
      "Semardadi BO": "272162",
      "Khatiyawan BO": "272125",
      "Lauki Lala BO": "272125",
      "Melan Khurd BO": "272125",
      "Pakaria BO": "272199",
      "Sai Buzurg BO": "272199",
      "Sitikar BO": "272199",
      "Ashraf Pur BO": "272162",
      "Takiya BO": "272162",
      "Umariya Pandey BO": "272162",
      "Chhagulia Bagulia BO": "272125",
      "Chhata BO": "272125",
      "Jeodhara BO": "272125",
      "Mudadeehabeg BO": "272125",
      "Pachawa BO": "272125",
      "Pachpokhari BO": "272125",
      "Bhagwanpur BO": "272199",
      "Ghenchuwa BO": "272199",
      "Chapra Magarvi BO": "272162",
      "Pauli BO": "272162",
      "Rampur Barakoni BO": "272162",
      "Bajahara BO": "272125",
      "Bhivra BO": "272125",
      "Burhi Belhar BO": "272125",
      "Kusuru Khurd BO": "272125",
      "Baur Byas BO": "272154",
      "Nandaur BO": "272199",
      "Ramwapur BO": "272199",
      "Govind Ganj BO": "272162",
      "Sanichara Bazar BO": "272162",
      "Umariya Bazar BO": "272162",
      "Joorie BO": "272125",
      "Mahani BO": "272125",
      "Kudja BO": "272154",
      "Belrai BO": "272154",
      "Menhdupar BO": "272154",
      "Agiyauna BO": "272152",
      "Banauli BO": "272154",
      "Mahui Nankar BO": "272154",
      "Tikur BO": "272154",
      "Dumaria Buzurg BO": "272154",
      "Kalnakhor BO": "272154",
      "Khajuri BO": "272154",
      "Mushahara BO": "272154",
      "Pendari Buzurg BO": "272154",
      "Sakarpar BO": "272154",
      "Hainsar Bazar SO": "272165",
      "Khalilabad SO": "272175",
      "Santha SO": "272270",
      "Dhanghata SO": "272162",
      "Maghar SO": "272173",
      "Menhdawal SO": "272271",
      "Dharamsinghwa SO": "272154",
      "Bakhira SO": "272199",
      "Dudhara SO": "272125",
      "Ganpatganj SO": "272176",
      "Hariharpur SO": "272164",
      "Khalilabad Bus Stand SO": "272175",
      "Mahuli SO": "272172",
      "Semariyawan SO": "272126"
    },
    "FARRUKHABAD": {
      "Mahoi BO": "209743",
      "Sahaspur BO": "209743",
      "Ugrapur Sultan Patti BO": "209743",
      "Harsinghpur Goa BO": "209504",
      "Khinmini BO": "209504",
      "Rasidpur Mai BO": "209504",
      "Shukrullapur BO": "209504",
      "Nadaura BO": "209652",
      "Babna BO": "209501",
      "Khalwara BO": "209501",
      "Bihar BO": "209652",
      "Gosarpur BO": "209651",
      "Rohila BO": "209651",
      "Sakwai BO": "209651",
      "Tajpur BO": "209651",
      "Pilkhana BO": "209501",
      "Puthari BO": "209501",
      "Sirmaura Banger BO": "209501",
      "Ukhra BO": "209501",
      "Merapur BO": "209652",
      "Barakeshav BO": "209651",
      "Maudha BO": "209651",
      "Sirauli BO": "209651",
      "Kanasi BO": "209501",
      "Kurar BO": "209501",
      "Arjunpur BO": "209652",
      "Barkhiriya BO": "209652",
      "Guthina BO": "209652",
      "Rajendra Nagar BO": "209652",
      "Roop Nagar BO": "209652",
      "Sankisa BO": "209652",
      "Nagla Nan BO": "209745",
      "Chilsara BO": "209745",
      "Ugarpur BO": "209503",
      "Kisrauli BO": "209503",
      "Kuiyan Khera BO": "209503",
      "Nagla Bagh Rathaura BO": "209652",
      "Nagla Kel Champat BO": "209652",
      "Pakhna BO": "209652",
      "Amlaiya Ashanand BO": "209745",
      "Bhojpur BO": "209749",
      "Sitauli BO": "209749",
      "Barai BO": "209745",
      "Bharka BO": "209601",
      "Barhpur BO": "209601",
      "Khandauli BO": "209621",
      "Sabalpur BO": "209621",
      "Harsinghpur BO": "209622",
      "Singanpur BO": "209602",
      "K P Ghat BO": "209625",
      "Kila BO": "209625",
      "Pachpukhra BO": "209625",
      "Pipergaon BO": "209625",
      "Musakhiria BO": "209739",
      "Rajeypur Tappa Mandal BO": "209739",
      "Barkhera BO": "209502",
      "Bhatasa BO": "209502",
      "College Rd Kaimganj BO": "209502",
      "K K W BO": "209502",
      "Lahra BO": "209502",
      "Lakhanpur BO": "209502",
      "Rajipur BO": "209724",
      "Rampur Majhgaon BO": "209724",
      "Singhirampur BO": "209724",
      "Sarah BO": "209601",
      "Ghatiaghat BO": "209601",
      "Jainpur Maheshpur BO": "209621",
      "Kumhraur BO": "209622",
      "Pithnapur BO": "209622",
      "Gaisinghpur BO": "209602",
      "Kanjhiana BO": "209602",
      "Baraun BO": "209625",
      "Gadanpur Turra BO": "209739",
      "Jhasi BO": "209739",
      "Ahmadganj BO": "209502",
      "Bara Biku BO": "209502",
      "Mau Rashidabad BO": "209502",
      "Paithan BO": "209502",
      "Kadhar BO": "209724",
      "Khudaganj BO": "209724",
      "Mistni Bahbalpur BO": "209505",
      "Rudain BO": "209505",
      "Kanheypur BO": "209743",
      "Chapra BO": "209622",
      "Bhopat Patti BO": "209602",
      "Danmandi BO": "209739",
      "Daraura BO": "209739",
      "Ataipur BO": "209502",
      "Raipur BO": "209502",
      "Rashidabad Tiwariyan BO": "209502",
      "Rutaul BO": "209502",
      "Sikanderpur Khas BO": "209505",
      "Siwara Khas BO": "209505",
      "Dhirpur BO": "209743",
      "Jyonta BO": "209743",
      "Maseni BO": "209601",
      "Gandhi BO": "209621",
      "Kankapur BO": "209621",
      "Hariharpur BO": "209622",
      "Karanpur Dutt BO": "209622",
      "Jaitpur BO": "209602",
      "Runi BO": "209602",
      "Awajpur BO": "209625",
      "Gutasi BO": "209625",
      "Civil Lines BO": "209601",
      "Jarari BO": "209739",
      "Kandhrapur BO": "209739",
      "Barjhala BO": "209502",
      "Behta Ballu BO": "209502",
      "Ganga Darwaja Kmj BO": "209502",
      "Narainamau BO": "209502",
      "Pitaura BO": "209502",
      "Silsanda BO": "209502",
      "Gadanpur Deorajpur BO": "209724",
      "Katrauli Patti BO": "209724",
      "Bilsari BO": "209505",
      "Raukari BO": "209505",
      "Madanpur BO": "209743",
      "Fatehgarh HO": "209601",
      "Farrukhabad R S SO": "209625",
      "Lindsayganj SO": "209625",
      "Neebkarori SO": "209652",
      "Roshnabad SO": "209745",
      "Yaqutganj SO": "209749",
      "Bholeypur SO": "209601",
      "Distt Jail SO Farrukhabad": "209601",
      "Jahanganj SO": "209739",
      "Kutchery Fatehgarh SO": "209601",
      "Lal Sarai SO": "209625",
      "Mathia Devi SO": "209625",
      "Nawabganj SO Farrukhabad": "209501",
      "Panda Bagh SO": "209625",
      "Avas Vikas Colony SO": "209625",
      "Central Jail SO": "209602",
      "Farrukhabad SO": "209625",
      "Fatehgarh RS SO": "209601",
      "ITE SO": "209625",
      "Kaimganj SO": "209502",
      "Kamalganj SO": "209724",
      "Kampil SO": "209505",
      "Kotwali Road Ftg SO": "209601",
      "Manjhana SO": "209504",
      "Nehru Road SO Farrukhabad": "209625",
      "Nitganja SO": "209625",
      "Rly Road Kaimganj SO": "209502",
      "Aligarh SO Farrukhabad": "209621",
      "Amratpur SO": "209622",
      "Bazaria Farrukhabad SO": "209625",
      "Bazaza Bazar SO": "209601",
      "Bibiganj SO Farrukhabad": "209625",
      "JNVRoad SO": "209601",
      "Khimseypur SO": "209743",
      "Mohamdabad SO": "209651",
      "RRC Fatehgarh SO": "209601",
      "Shamsabad SO Farrukhabad": "209503"
    },
    "SIDDHARTH NAGAR": {
      "Ajgara BO": "272153",
      "Mau BO": "272153",
      "Gauri BO": "272153",
      "Bihra BO": "272153",
      "Barao Nansar BO": "272153",
      "Harraiya Nankar BO": "272153",
      "Jeewa BO": "272153",
      "Suparaja BO": "272153",
      "Rudrapurr BO": "272153",
      "Chauri Khurd BO": "272148",
      "Masaicha BO": "272151",
      "Fatehpur BO": "272189",
      "Jhahraon BO": "272189",
      "Shahpur BO": "272189",
      "Amauna Pandey BO": "272191",
      "Bharatbhari BO": "272191",
      "Bajrabhari BO": "272192",
      "Dhobha BO": "272189",
      "Govindpur BO": "272192",
      "Mahadeoghurhoo BO": "272192",
      "Mudila Nankar BO": "272192",
      "Kakrahwa BO": "272206",
      "Karmaini BO": "272206",
      "Lotan BO": "272206",
      "Mahapaliuttar BO": "272206",
      "Cchamapur BO": "272205",
      "Dabra BO": "272205",
      "Mahatha Bazar BO": "272205",
      "Bhadanw": "272205",
      "Bheemapar BO": "272207",
      "Dhensanankar BO": "272207",
      "Kondragrant BO": "272207",
      "Harkauli BO": "272204",
      "Santora BO": "272204",
      "Bhelaunji BO": "272208",
      "Khakhara Khurd BO": "272208",
      "Tandia Bazar BO": "272208",
      "Sehari Khas BO": "272189",
      "Bhadokhar BO": "272192",
      "Bhojwar BO": "272192",
      "Biskohar BO": "272192",
      "Dhangarwa BO": "272192",
      "Patila BO": "272192",
      "Rehra Kalan BO": "272192",
      "Dulhanorth BO": "272206",
      "Ekdangwa BO": "272206",
      "Sainua BO": "272206",
      "Sikri Bazar BO": "272206",
      "Chetra BO": "272205",
      "Khaira Bazar BO": "272205",
      "Makraur BO": "272205",
      "Nakahi BO": "272205",
      "Pakri BO": "272205",
      "Ramwapur BO": "272205",
      "Deora Bazar BO": "272207",
      "Jogia Udaipur BO": "272207",
      "Madhuharpur BO": "272207",
      "Maharia BO": "272207",
      "Ahri BO": "272204",
      "Bhadehargrant BO": "272204",
      "Nagawa BO": "272208",
      "Semrahna BO": "272208",
      "Sohas Khas BO": "272208",
      "Sugahi BO": "272208",
      "Bidra BO": "272153",
      "Janiajote BO": "272153",
      "Kapiyawa BO": "272148",
      "Chharahata BO": "272151",
      "Chhitauni BO": "272151",
      "Dindai BO": "272151",
      "Katbandh BO": "272151",
      "Semari BO": "272151",
      "Penda BO": "272189",
      "Quadirabad BO": "272189",
      "Rasoolpur BO": "272189",
      "Kathwathia Alam BO": "272191",
      "Malhwar BO": "272191",
      "Manoharpur BO": "272191",
      "Telgadia Bzg BO": "272191",
      "Jigina Thakur BO": "272192",
      "Karahiagosain BO": "272192",
      "Kathela BO": "272192",
      "Khadsari BO": "272192",
      "Tenuwagrant BO": "272192",
      "Trilokpur BO": "272192",
      "Buddhi Khas": "272192",
      "Sekhuiya BO": "272203",
      "Bagheli BO": "272206",
      "Beltikar BO": "272206",
      "Antari Bazar BO": "272205",
      "Chilihia BO": "272204",
      "Dhusurai Bzg BO": "272204",
      "Badahara BO": "272208",
      "Bairwanankar BO": "272208",
      "Gaura Bazar BO": "272189",
      "Kusumhi BO": "272189",
      "Malimainha BO": "272189",
      "Turkaulia BO": "272189",
      "Bewa Chauraha BO": "272191",
      "Bairwa BO": "272192",
      "Gagapur BO": "272192",
      "Khuniyawan BO": "272192",
      "Maina BO": "272192",
      "Semari Khan Kot BO": "272192",
      "Birdpur No13 BO": "272203",
      "Sonkhar BO": "272153",
      "Ghosiyari Bzr BO": "272148",
      "Masina Khas BO": "272151",
      "Bhitpara BO": "272206",
      "Haribanshpur BO": "272206",
      "Khakhara BO": "272206",
      "Madhubani BO": "272206",
      "Ramnagar BO": "272201",
      "Mahthawal BO": "272206",
      "Dhanaura Mustahkam BO": "272205",
      "Harraiya BO": "272207",
      "Mahulani BO": "272207",
      "Patni Jungle BO": "272207",
      "Katehna BO": "272204",
      "Khurhuria BO": "272204",
      "Imiliha BO": "272208",
      "Madanpur BO": "272208",
      "Karma BO": "272208",
      "Bangawa BO": "272153",
      "Bhanwari BO": "272153",
      "Asogwa BO": "272153",
      "Khaira Khas B0": "272153",
      "Mohankola BO": "272201",
      "Par RS BO": "272201",
      "Ramwapur Jagatram BO": "272193",
      "Birdpur No7 BO": "272202",
      "Bishunpurwa BO": "272202",
      "Mudila Khatai BO": "272202",
      "Narkul BO": "272202",
      "Arji BO": "272152",
      "Belaukh BO": "272152",
      "Charthari BO": "272152",
      "Deokali BO": "272152",
      "Pasai BO": "272152",
      "Rajediha Bazar BO": "272152",
      "Rithia Bazar BO": "272152",
      "Bhandariamanik Ganj BO": "272189",
      "Bharwatia Bzr BO": "272189",
      "Bijwar Barhai BO": "272189",
      "Bitharia BO": "272189",
      "Kurthia BO": "272153",
      "Asnar BO": "272153",
      "Pathara Bzr BO": "272153",
      "Chetia BO": "272153",
      "Bargadwa  Khabhri BO": "272153",
      "Narkataha BO": "272153",
      "Bohli BO": "272201",
      "Dhekhari BO": "272201",
      "Bhawaniganj BO": "272195",
      "Piraila BO": "272195",
      "Wasadargah BO": "272195",
      "Kamsar BO": "272193",
      "Sukla Jote BO": "272193",
      "Parsa Belhari BO": "272202",
      "Bankeygaon BO": "272152",
      "Gopalpur BO": "272152",
      "Kadja BO": "272152",
      "Lahara BO": "272152",
      "Nasirganj BO": "272152",
      "Tilaura BO": "272152",
      "Dhaurahara BO": "272189",
      "Bansi HO": "272153",
      "Dandwaghat BO": "272153",
      "Kakrapokhar BO": "272153",
      "Kotiagarori BO": "272153",
      "Pachhar BO": "272153",
      "Dhebarua BO": "272201",
      "Mahadev Buzurg BO": "272201",
      "Mailani BO": "272195",
      "Parsa Khurd BO": "272195",
      "Chaukhara BO": "272193",
      "Chitahi BO": "272193",
      "Mahuwa Bzg BO": "272193",
      "Alidapur BO": "272202",
      "Pachgawan BO": "272202",
      "Piparsan BO": "272202",
      "Banethu BO": "272152",
      "Bisunpurwa BO": "272152",
      "Marwatia Bazar BO": "272152",
      "Sawadand BO": "272152",
      "Sishania BO": "272152",
      "Suhai Kanpurwa BO": "272152",
      "Chafa BO": "272189",
      "Madhukarpur BO": "272153",
      "Kolhui BO": "272153",
      "Karahi BO": "272153",
      "Mithwal Bazaar BO": "272153",
      "Bankuiya BO": "272153",
      "Talpurwa BO": "272153",
      "Ramwapur Dubey BO": "272153",
      "Sekhui BO": "272153",
      "Tilauli BO": "272153",
      "Audahi Kalan BO": "272201",
      "Bhanpurkhas BO": "272195",
      "Shankarpur BO": "272195",
      "Ramwapur Raut BO": "272193",
      "Sikta BO": "272193",
      "Sohna BO": "272193",
      "Pachmohani BO": "272152",
      "Beerpur BO": "272189",
      "Basantpur BO": "272153",
      "Daldala SO": "272152",
      "Hallaur SO": "272191",
      "Tetari Bazar SO": "272207",
      "Domariyaganj SO": "272189",
      "Itwa SO": "272192",
      "Naugarh SO": "272203",
      "Shoharatgarh SO": "272205",
      "Udairajganj SO": "272204",
      "Sheopatinagar SO": "272206",
      "Uska Bazar SO": "272208",
      "Barhni SO": "272201",
      "Bayara SO": "272195",
      "Birdpur SO": "272202",
      "Civil Line Siddharth Nagar": "272207",
      "Bhanwapur SO": "272193"
    },
    "LALITPUR": {
      "Ronda": "284403",
      "Marrauli BO": "284402",
      "Paah BO": "284402",
      "Pura Kakdari BO": "284402",
      "Sunwaha BO": "284402",
      "Gadyana BO": "284122",
      "Baghaura BO": "284123",
      "Bhailoni Suba BO": "284123",
      "Bhaoni BO": "284123",
      "Chiglauwa BO": "284123",
      "Nanaura BO": "284124",
      "Rakh Panchampur BO": "284124",
      "Siron Kalan BO": "284124",
      "Sirsi BO": "284124",
      "Gurha BO": "284405",
      "Kakrauwa BO": "284405",
      "Khajuriya BO": "284405",
      "Khiriya Latkanju BO": "284405",
      "Khitwans BO": "284405",
      "Kumheri BO": "284405",
      "Silawan BO": "284405",
      "Satarwans BO": "284403",
      "Khiriya Chhatara BO": "284403",
      "Niwai Nibaho BO": "284403",
      "Pali BO": "284403",
      "Kailguwan BO": "284402",
      "Asaupura BO": "284122",
      "Dulawan BO": "284122",
      "Kalyanpura BO": "284403",
      "Baroda Daang BO": "284123",
      "Dasrara BO": "284123",
      "Ladhwari BO": "284123",
      "Ghisauli BO": "284124",
      "Pipra Raipur BO": "284124",
      "Dhauri Sagar BO": "284404",
      "Didonia BO": "284404",
      "Gidwaha BO": "284404",
      "Gona Kushmadh BO": "284405",
      "Nainwara BO": "284405",
      "Patha BO": "284405",
      "Arjunkhiriya BO": "284406",
      "Kuantala BO": "284403",
      "Serwans Khurd BO": "284403",
      "Silgan BO": "284403",
      "Masaura Khurd BO": "284403",
      "Dhaurra": "284403",
      "Billa BO": "284402",
      "Barkhiriya BO": "284122",
      "Basatguwan BO": "284122",
      "Bastrawan BO": "284122",
      "Deoran BO": "284122",
      "Lakhanpura BO": "284122",
      "Nadanwara": "284122",
      "Muhara BO": "284122",
      "Bachhraoni BO": "284123",
      "Nagara BO": "284123",
      "Paron BO": "284123",
      "Baroda Swami BO": "284124",
      "Girar BO": "284404",
      "Karitoran BO": "284404",
      "Sadhumar BO": "284404",
      "Saidpur BO": "284404",
      "Siron Madawra BO": "284404",
      "Sonrai BO": "284404",
      "Bamhori Bahadur Singh BO": "284405",
      "Bhondi BO": "284405",
      "Chhapchhaul BO": "284405",
      "Bomori Bansa BO": "284406",
      "Dongra Kalan BO": "284406",
      "Dongra Khurd BO": "284406",
      "Gauna BO": "284406",
      "Chadhraoo BO": "284403",
      "Kuagaon BO": "284402",
      "Udaipura BO": "284402",
      "Alapur BO": "284122",
      "Gadiya BO": "284122",
      "Jamalpur BO": "284122",
      "Karmai BO": "284122",
      "Bamhori Khandel BO": "284123",
      "Bhailoni Lodh BO": "284123",
      "Chungi BO": "284123",
      "Dhangol BO": "284123",
      "Kisalwans BO": "284124",
      "Mainwara BO": "284124",
      "Nauharkalan BO": "284124",
      "Bamhori Madawra BO": "284404",
      "Dhawa BO": "284404",
      "Garholi Kalan BO": "284404",
      "Dhawari BO": "284405",
      "Naikaura BO": "284405",
      "Saujana BO": "284405",
      "Sindwaha BO": "284405",
      "Bangawan Kalan BO": "284136",
      "Balabehat BO": "284406",
      "Mahauli BO": "284406",
      "Barodabijlaun BO": "284403",
      "Dailwara BO": "284403",
      "Patauwa BO": "284403",
      "Baarod BO": "284403",
      "Piprai BO": "284403",
      "Ghatwar BO": "284403",
      "Bamhori Kalan BO": "284403",
      "Jijyawan BO": "284403",
      "Birdha BO": "284403",
      "Burhwar BO": "284403",
      "Daoni BO": "284403",
      "Jamuniya BO": "284403",
      "Kachnadakala BO": "284403",
      "Jeeron BO": "284403",
      "Padhna BO": "284403",
      "Bant": "284403",
      "Mirchwara BO": "284403",
      "Tera BO": "284403",
      "Jakhlaun BO": "284403",
      "Rajwara BO": "284403",
      "Umariya BO": "284406",
      "Bamhori Sarr BO": "284126",
      "Patna BO": "284406",
      "Thanwara BO": "284501",
      "Kadesarakalan BO": "284126",
      "Miyaoon BO": "284126",
      "Bijrautha BO": "284126",
      "Hasarkalan BO": "284126",
      "Bhuchera BO": "284126",
      "Paraul BO": "284406",
      "Deori BO": "284501",
      "Lagaun BO": "284501",
      "Badiwar Kalan BO": "284126",
      "Kakdari BO": "284126",
      "Khandi BO": "284126",
      "Pawa BO": "284126",
      "Natthikheda BO": "284126",
      "Sarsend BO": "284126",
      "Poora Kalan BO": "284126",
      "Poora Virdha BO": "284126",
      "Rajawan BO": "284126",
      "Sanori BO": "284126",
      "Serwans Kalan BO": "284126",
      "LALITPUR HO": "284403",
      "Lakeviewcamp SO": "284125",
      "Mahroni SO": "284405",
      "Narahat SO": "284406",
      "Rajghat Dam Project SO": "284501",
      "Siddhisagar SO": "284403",
      "Talbehat SO": "284126",
      "Barh SO Lalitpur": "284123",
      "Katra Bazar Lalitpur SO": "284403",
      "Bansi SO Lalitpur": "284122",
      "Jakhaura SO": "284124",
      "Lalitpur Railway Station SO": "284403",
      "Madawra SO": "284404",
      "Matatila SO": "284136",
      "Banpur SO Lalitpur": "284402"
    },
    "MAHARAJGANJ": {
      "Ratanpur BO": "273308",
      "Pharendra Khurd BO": "273155",
      "Pokharbhinda BO": "273155",
      "Ramnagar BO": "273164",
      "Badhara Baraipar BO": "273306",
      "Laxmipurektanga BO": "273302",
      "Pachrukhia BO": "273302",
      "Shikarpur BO": "273302",
      "Siswa Raja BO": "273302",
      "Sohrauna Tiwari BO": "273302",
      "Lehrabazar BO": "273157",
      "Mahulani BO": "273157",
      "Mishrouliya BO": "273157",
      "Shahabad BO": "273157",
      "Bhagwanpur Bazar BO": "273308",
      "Nipania BO": "273308",
      "Zara BO": "273308",
      "Baratgarah BO": "273155",
      "Bhainsi BO": "273302",
      "Harakpur BO": "273302",
      "Pakdi Dixit BO": "273302",
      "Piparpati Tiwari BO": "273302",
      "Tarkulwa Tiwari BO": "273302",
      "Sahjanwa Babu BO": "273157",
      "Bargadwa Harriya BO": "273155",
      "Dandwarkhurd BO": "273155",
      "Mathuranagar BO": "273155",
      "Natwa Jungle BO": "273306",
      "Piparpati BO": "273306",
      "Shyamdeorva BO": "273306",
      "Balua BO": "273302",
      "Belwatikar BO": "273302",
      "Gopala BO": "273302",
      "Banjaria Sonbarsa BO": "273157",
      "Bargahpur BO": "273157",
      "Goplapur BO": "273155",
      "Lvp Nagar BO": "273155",
      "Lezar Mahdewa BO": "273155",
      "Laxmipurdeurwa BO": "273302",
      "Laxmipurshiwala BO": "273302",
      "Parsa Gidahi BO": "273302",
      "Purena Khandi Chauri BO": "273302",
      "Belaharriya BO": "273157",
      "Sauraha BO": "273157",
      "Amwa Buzurg BO": "273309",
      "Eksarwa BO": "273309",
      "Rudra pur shivnath BO": "273309",
      "Rajdhani BO": "273162",
      "Kamhariakala BO": "273303",
      "Katahra BO": "273303",
      "Khajuria BO": "273303",
      "Khutha Bazar BO": "273303",
      "Kotamukund Pur BO": "273303",
      "Chakdah BO": "273164",
      "Kajari BO": "273164",
      "Karamahwa BO": "273164",
      "Karialia BO": "273164",
      "Khoria Bazar BO": "273164",
      "Laxmipur Khurd BO": "273311",
      "Meghauli Kala BO": "273311",
      "Mahua sukul BO": "273310",
      "Sikandrajitpur BO": "273161",
      "Basantpur BO": "273162",
      "Biraicha BO": "273151",
      "Rampur Baldiha BO": "273151",
      "Kamharia Buzurg BO": "273309",
      "Raj mandir Kala BO": "273309",
      "Puranderpur BO": "273162",
      "Pipra Sohat BO": "273162",
      "Bhagirath Pur BO": "273162",
      "Bagapar BO": "273303",
      "Chauk BO": "273303",
      "Darahata BO": "273303",
      "Karmha BO": "273303",
      "Mahuawa BO": "273303",
      "Patrengwa BO": "273207",
      "Senduria BO": "273207",
      "Charalaha BO": "273164",
      "Naikot BO": "273164",
      "Puraniha BO": "273164",
      "Gadaura BO": "273311",
      "Jhulnipur BO": "273311",
      "Kamasin khurd BO": "273310",
      "Maula Ganj BO": "273310",
      "Rajaura Khurd BO": "273310",
      "Mansorganj Khurd BO": "273165",
      "Narakataha Bazar BO": "273165",
      "Ardauna BO": "273163",
      "Rampur Kala BO": "273163",
      "Sabaya BO": "273163",
      "Harpurtiwari BO": "273301",
      "Badhra Mahant BO": "273163",
      "Lohepar BO": "273163",
      "Devgatti BO": "273305",
      "Jhingti BO": "273305",
      "Sekhwani BO": "273305",
      "Shiwatari Bzr BO": "273305",
      "Gaura Dubey BO": "273151",
      "Mednipur BO": "273151",
      "Munderi BO": "273151",
      "Narayanpur BO": "273151",
      "Shikargarh BO": "273309",
      "Khlikgarh BO": "273162",
      "Shaildah BO": "273162",
      "Banspar Baijauli BO": "273303",
      "Bauliaraja BO": "273303",
      "Belwa Khurd BO": "273303",
      "Belwa Qazi BO": "273303",
      "Nadua Bazar BO": "273303",
      "Panewa Panei BO": "273303",
      "Rudhaulibhawshak BO": "273303",
      "Salamat Garh BO": "273303",
      "Sonara BO": "273303",
      "Bheria BO": "273207",
      "Jagdaur BO": "273207",
      "Jamuie Pandit BO": "273207",
      "Mishraulia BO": "273207",
      "Parsauni BO": "273207",
      "Adda Bazar BO": "273164",
      "Banarisihakhurd BO": "273164",
      "Auratar BO": "273304",
      "Baithwalia BO": "273304",
      "Bali BO": "273304",
      "Doma Khas BO": "273304",
      "Ledi BO": "273304",
      "Bodna BO": "273311",
      "Baidabazar BO": "273310",
      "Madhonagar BO": "273310",
      "Dhanaha Nayak BO": "273301",
      "Jaddupipra BO": "273301",
      "Nebuiya BO": "273301",
      "Semra Chandauli BO": "273301",
      "Basuli  Farm BO": "273163",
      "Chargha BO": "273163",
      "Guri Badhipurwa BO": "273163",
      "Kaima BO": "273163",
      "Karamahi BO": "273163",
      "Katahari BO": "273163",
      "Khesrari BO": "273163",
      "Kothibhar BO": "273163",
      "Dangrupur BO": "273305",
      "Manikapur BO": "273305",
      "Banspar BO": "273151",
      "Chaumukha BO": "273151",
      "Pakdi Bishunpur BO": "273151",
      "Pakdiar Bishunpur BO": "273151",
      "Kesauli BO": "273309",
      "Lalpur BO": "273309",
      "Dhuswakala BO": "273162",
      "Mudila BO": "273162",
      "Semra Maharaj BO": "273162",
      "Smardhira BO": "273162",
      "Chehari BO": "273303",
      "Dhanewa Dhanai BO": "273303",
      "Neta Surhurwa BO": "273303",
      "Pakdinauni A BO": "273303",
      "Sewareji BO": "273303",
      "Uska BO": "273303",
      "Badhara Mir BO": "273207",
      "Gaunaria BO": "273207",
      "Madhubani BO": "273207",
      "Mujahna Buzurg BO": "273207",
      "Pipra Bazar BO": "273207",
      "Sonbarsa BO": "273207",
      "Madanpura BO": "273304",
      "Sekhui BO": "273304",
      "Rengahia BO": "273311",
      "Devipur BO": "273310",
      "Basahia Buzurg BO": "273301",
      "Dharmauli BO": "273301",
      "Lakhima BO": "273301",
      "Domara BO": "273165",
      "Gangibazar BO": "273165",
      "Bariarpur BO": "273163",
      "Chainpur BO": "273163",
      "Germa BO": "273163",
      "Madhwalia BO": "273163",
      "Dogahra BO": "273305",
      "Parsamalik BO": "273305",
      "Pipra BO": "273305",
      "Belouha BO": "273161",
      "Baisar BO": "273161",
      "Mahdewa BO": "273161",
      "Nausagra BO": "273161",
      "Maharajganj H.O": "273303",
      "Siswa Bazar S.O": "273163",
      "Thuthibari S.O": "273305",
      "Bhitauli Bazar S.O": "273302",
      "Paniyara S.O": "273310",
      "Anandnagar S.O  Maharajganj": "273155",
      "Bribgemanganj S.O": "273157",
      "Collectrate Compound Maharajganj S.O": "273303",
      "Dhani Bazar S.O": "273161",
      "Ghughli R.S. S.O": "273151",
      "Laxmipur Maharajganj S.O": "273162",
      "Mithaura Bazar S.O": "273207",
      "Nichlaul S.O": "273304",
      "Koluhi S.O": "273309",
      "Nautanwa Bazar S.O": "273164",
      "Sonauli S.O": "273308",
      "Orwalliya S.O": "273311",
      "Partawal Bazar S.O": "273301"
    },
    "HAPUR": {
      "Dadri": "245101",
      "Chhajupur": "245101",
      "Galand BO": "201015",
      "Udai Rampur Nangla BO": "201015",
      "Kandaula BO": "245301",
      "Parpa BO": "245301",
      "Saulana BO": "245301",
      "Dehra BO": "245301",
      "Samana BO": "245301",
      "Hasanpur BO": "201015",
      "Raghunathpur": "245101",
      "Mahmoodpur": "245101",
      "Dhanaura": "245101",
      "Harsinghpur": "245101",
      "Anwarpur BO": "245304",
      "Bajhera Khurd BO": "245304",
      "Girdharpur Tumrel BO": "245101",
      "Phagota BO": "245101",
      "Kathikhera BO": "245101",
      "Bajhera Kalan BO": "245101",
      "Dahana BO": "245101",
      "Iklehdi BO": "245101",
      "Bankhanda BO": "245201",
      "Hosdarpur Garhi BO": "245201",
      "Kanya Kalyanpur BO": "245201",
      "Matnaura BO": "245201",
      "Tatarpur BO": "245201",
      "Upera BO": "245201",
      "Bihuni BO": "245205",
      "Gandu Nagla BO": "245205",
      "Jakhera Rahmatpur BO": "245205",
      "Luhari BO": "245205",
      "Bharna BO": "245207",
      "Datiyana BO": "245207",
      "Dhana BO": "245207",
      "Mohdpur Khudaliya BO": "245207",
      "Dehpa Azampur BO": "245304",
      "Nagola BO": "245304",
      "Kandoli BO": "245304",
      "Bhatiyana BO": "245101",
      "Shah Mohiuddinpur BO": "245101",
      "Gohra Alamgirpur BO": "245101",
      "Alipur BO": "245201",
      "Rasulpur BO": "245201",
      "Sikandarpur Kakori BO": "245201",
      "Alam Nagar BO": "245208",
      "Garh Bridge Halt BO": "245205",
      "Bagarpur BO": "245205",
      "Dotai BO": "245205",
      "Jharina BO": "245205",
      "Nanpur BO": "245205",
      "Salarpur BO": "245205",
      "Phuldehra BO": "245207",
      "Sikhera BO": "245207",
      "Chhajarsi BO": "245304",
      "Doohri BO": "245304",
      "Madrasa Sadat BO": "245101",
      "Chamri BO": "245101",
      "Ghungrala BO": "245101",
      "Mathurawali BO": "245101",
      "Asaura BO": "245101",
      "Hafizpur Ubarpur BO": "245101",
      "Bachlota BO": "245201",
      "Nali Hussainpur BO": "245201",
      "Sheikhpur BO": "245201",
      "Bhadsiana BO": "245208",
      "Bhaina Dholpur BO": "245205",
      "Dehra Rampur BO": "245205",
      "Haidarpur BO": "245205",
      "Khilwai BO": "245205",
      "Muradpur Janupura BO": "245205",
      "Sadullapur Lodhi BO": "245205",
      "Kastala BO": "245304",
      "Khera BO": "245304",
      "Rampur Puth BO": "245101",
      "Kharkhari BO": "245101",
      "Sapnawat BO": "245101",
      "Nan BO": "245101",
      "Mahmoodpur Palwara BO": "245208",
      "Nek Nanpur Nanai BO": "245208",
      "Sharpur BO": "245208",
      "Athsaini BO": "245205",
      "Shyampur Jatt BO": "245205",
      "Wait BO": "245207",
      "Achheja BO": "245101",
      "Baxur BO": "245207",
      "Mubarikpur BO": "245207",
      "Rajethi BO": "245207",
      "New Hapur HO": "245101",
      "Dhaulana SO": "245301",
      "Pilkhuwa  SO": "245304",
      "Hapur Mandi SO": "245101",
      "Kishanganj Hapur SO": "245101",
      "New Market Pilkhauwa SO": "245304",
      "Bahadurgarh SO": "245208",
      "Garh Town SO": "245205",
      "Railway Road Hapur SO": "245101",
      "Garhmukteshwar SO": "245205",
      "Gyan Lok Hapur SO": "245101",
      "Babugarh SO": "245201",
      "Kuchesar Chopla SO": "245201",
      "Simbhaoli SO": "245207"
    },
    "BAGHPAT": {
      "Dolcha BO": "250626",
      "Duttnagar BO": "250626",
      "Mukri BO": "250626",
      "Faizpur Ninana BO": "250619",
      "Gauripur BO": "250619",
      "Chaubli BO": "250611",
      "Gurana BO": "250611",
      "Basaudh BO": "250601",
      "Daula BO": "250601",
      "Garhi BO": "250601",
      "Tera BO": "250606",
      "Bijrol BO": "250620",
      "Barnawa BO": "250345",
      "Chandyan BO": "250345",
      "Badarkha BO": "250617",
      "Nangal BO": "250617",
      "Rathaura BO": "250617",
      "Hisawda BO": "250615",
      "Khatta Prahladpur BO": "250615",
      "Lalyana BO": "250615",
      "Bharal BO": "250622",
      "Jhundpur BO": "250622",
      "Kanhar BO": "250622",
      "Muzaffarpur Kanwara BO": "250622",
      "Pusar BO": "250622",
      "Daha BO": "250622",
      "Bhagot BO": "250101",
      "Fakharpur BO": "250101",
      "Garhi Kalanjiri BO": "250101",
      "Khera Hatana BO": "250619",
      "Gangnauli BO": "250625",
      "Nirpura BO": "250625",
      "Lohadda BO": "250611",
      "Shahpur Badholi BO": "250611",
      "Hilwari BO": "250611",
      "Khwaja Nagla BO": "250611",
      "Rajpur Khampur BO": "250611",
      "Luhari BO": "250611",
      "Malakpur BO": "250611",
      "Bali BO": "250601",
      "Bilochpura BO": "250606",
      "Gwali Khera BO": "250606",
      "Ram Nagar BO": "250606",
      "Saidbhar BO": "250606",
      "Baghpat Sugar Mill BO": "250609",
      "Sisana BO": "250609",
      "Barwala BO": "250621",
      "Gunga Kheri BO": "250621",
      "Jalalpur BO": "250621",
      "Johri BO": "250345",
      "Soop BO": "250623",
      "Sabga BO": "250617",
      "Sherpur Luhari BO": "250617",
      "Chamrawal BO": "250615",
      "Azampur Mulsam BO": "250622",
      "Begmabad Garhi BO": "250622",
      "Gauna BO": "250101",
      "Ibrahimpur Mazra BO": "250623",
      "Jiwana BO": "250623",
      "Kakripur BO": "250623",
      "Kasimpur Khari BO": "250623",
      "Lumb BO": "250623",
      "Kirthal BO": "250623",
      "Barka BO": "250611",
      "Dohja BO": "250611",
      "Dhikana BO": "250611",
      "Dhanaura Silver Nagar BO": "250611",
      "Alwalpur BO": "250611",
      "Budhera BO": "250611",
      "Sadiqpur Sinoli BO": "250611",
      "Mitli BO": "250601",
      "Nerojpur Gujar BO": "250601",
      "Sujra BO": "250601",
      "Garhi Hazurabad BO": "250606",
      "Singhaoli Ahir BO": "250606",
      "Bijwara BO": "250345",
      "Fatehpur Poothi BO": "250345",
      "Galheta BO": "250345",
      "Sirsalgarh BO": "250345",
      "Titroda BO": "250345",
      "Bodha BO": "250617",
      "Kurri BO": "250617",
      "Tugana BO": "250617",
      "Pabla Begmabad BO": "250615",
      "Pilana BO": "250615",
      "Dhanaura Tikri BO": "250622",
      "Idrishpur BO": "250622",
      "Palri BO": "250622",
      "Bassi BO": "250101",
      "Gothra BO": "250101",
      "Phulera BO": "250101",
      "Rataul BO": "250101",
      "Sunehra BO": "250101",
      "Asarfabad Thal BO": "250623",
      "Budhpur BO": "250623",
      "Ramala BO": "250623",
      "Kherki BO": "250619",
      "Mozizabad Nangal BO": "250625",
      "Sujti BO": "250625",
      "Audhapur BO": "250611",
      "Barawad BO": "250611",
      "Kotana BO": "250611",
      "Shikohpur BO": "250611",
      "Jaunmana BO": "250611",
      "Teodhi BO": "250611",
      "Bazidpur BO": "250611",
      "Nibali BO": "250601",
      "Budhsaini BO": "250606",
      "Mawi Kalan BO": "250606",
      "Ahera BO": "250609",
      "Khatta BO": "250609",
      "Kandera BO": "250620",
      "Fazalpur BO": "250345",
      "Jiwaana BO": "250345",
      "Muzampur Kamala BO": "250345",
      "Ranchhar BO": "250345",
      "Sirsali BO": "250345",
      "Hewa BO": "250617",
      "Kakor Kalan BO": "250617",
      "Silana BO": "250617",
      "Halalpur BO": "250617",
      "Gaidbara BO": "250622",
      "Palra BO": "250622",
      "Baragaon BO": "250101",
      "Mubarikpur BO": "250101",
      "Sankrodh BO": "250101",
      "Asara BO": "250623",
      "Basauli BO": "250623",
      "Baraut HO": "250611",
      "Baleni SO": "250626",
      "Khekra SO": "250101",
      "Rly Road Khekra SO": "250101",
      "Baghpat SO": "250609",
      "Binauli SO": "250345",
      "Dhikauli SO": "250615",
      "Doghat SO": "250622",
      "Tikri SO": "250625",
      "Bamnauli SO": "250620",
      "Kishanpur Baral SO": "250623",
      "Nehru Rd Baraut SO": "250611",
      "Sarurpur Kalan SO": "250619",
      "Agarwal Mandi SO": "250601",
      "Aminagar Sarai SO": "250606",
      "Baoli SO": "250621",
      "Chhaprauli SO": "250617",
      "Gandhi Chowk Baraut SO": "250611",
      "Nai Mandi Baraut SO": "250611"
    },
    "AYODHYA": {
      "Chirra Mohammad Pur BO": "224001",
      "Hardoiya BO": "224225",
      "Mawai Kalan BO": "224225",
      "Dharauli BO": "224121",
      "Gaddopur BO": "224121",
      "Mahuwa BO": "224121",
      "Sarauli BO": "224121",
      "Taldholi BO": "224121",
      "Narain Ashram BO": "224123",
      "Raiganj BO": "224123",
      "Kareru BO": "224126",
      "Pirkhauli BO": "224126",
      "Seewar BO": "224126",
      "Gauhanna Qanoongo BO": "224127",
      "Naipura BO": "224202",
      "Akhtiyarpur BO": "224116",
      "Jarail Kalan BO": "224116",
      "Banket BO": "224204",
      "Chwardhar BO": "224204",
      "Gundhaur BO": "224204",
      "Saraibhanauli BO": "224204",
      "Arsath BO": "224209",
      "Kannawan BO": "224209",
      "Paroma BO": "224209",
      "Rauhari BO": "224209",
      "Tharia Kalan BO": "224209",
      "Dadera BO": "224135",
      "Ismail Nagar Singra BO": "224189",
      "Kundurkha Khurd BO": "224189",
      "Deokali BO": "224001",
      "Bandanpur BO": "224141",
      "Ramapur BO": "224141",
      "Raniwan BO": "224141",
      "Teliagarh BO": "224141",
      "Mian Ganj BO": "224208",
      "Paraspur Sathra BO": "224208",
      "Urwa Vaish BO": "224208",
      "Basawan BO": "224228",
      "Kadanpur BO": "224228",
      "Bhav Nathpur BO": "224206",
      "Mangari BO": "224206",
      "Mumtaj Nagar BO": "224001",
      "Sariyawan BO": "224001",
      "Gopalpur BO": "224001",
      "Kalyanpur Keotani BO": "224225",
      "Paliya Pratapshah BO": "224225",
      "Chandaura BO": "224121",
      "Gauhania BO": "224121",
      "Manudiha BO": "224121",
      "Ramnagar Amawan Sufi BO": "224121",
      "Gurukul BO": "224123",
      "Hajipur BO": "224126",
      "Maholi Uprahar BO": "224126",
      "Gothwara BO": "224127",
      "Mehnauna BO": "224127",
      "Kailkeshopur BO": "224202",
      "Raithua BO": "224202",
      "Shujaganj BO": "224116",
      "Ballipur BO": "224204",
      "Bhawapur BO": "224204",
      "Malethukanak BO": "224204",
      "Ruroo BO": "224204",
      "Bainti BO": "224209",
      "Janjwara BO": "224209",
      "Ninhiyawan Bazar BO": "224209",
      "Sulhepur BO": "224203",
      "Alwalpur BO": "224135",
      "Kandai Kalan BO": "224189",
      "Bala Paikauli BO": "224141",
      "Chachikpur BO": "224141",
      "Samda BO": "224141",
      "Malethu Buzurg BO": "224208",
      "Para Tajpur BO": "224208",
      "Sonbarsa BO": "224208",
      "Chirauli BO": "224228",
      "Kahuwa BO": "224228",
      "Gadopur Majhwa BO": "224001",
      "Mau Yaduwanshpur BO": "224001",
      "Haripur Jalalabad BO": "224001",
      "Kot Sarai BO": "224001",
      "Ahiran Subansh BO": "224225",
      "Bakauli BO": "224121",
      "Harakhpur BO": "224121",
      "Mahmedpur BO": "224121",
      "Ranopali BO": "224123",
      "Swarg Dwar BO": "224123",
      "Gondwa BO": "224126",
      "Kadipur BO": "224127",
      "Rani Bazar BO": "224127",
      "Sari BO": "224127",
      "Sirhir BO": "224127",
      "Sohkhawan BO": "224127",
      "Sondhiyawan BO": "224127",
      "Saraitha BO": "224116",
      "Khapraila Bazar BO": "224204",
      "Kurha BO": "224204",
      "Pohpi BO": "224204",
      "Benipur Chandauli BO": "224209",
      "Bhitergaon BO": "224209",
      "Hathigo BO": "224209",
      "Dhrampur BO": "224135",
      "Sanethu BO": "224135",
      "Shahnawan BO": "224135",
      "Baidarapur BO": "224189",
      "Dillisaraiya BO": "224189",
      "Sahadatganj BO": "224001",
      "Chandrikaganj BO": "224141",
      "Fatehpur Kamasin BO": "224141",
      "Jaitpur Nidhiyawan BO": "224141",
      "Adilpur BO": "224208",
      "Banswar Kalan BO": "224208",
      "Chamela BO": "224208",
      "Aghiyari BO": "224228",
      "Bodahari BO": "224206",
      "Katari BO": "224206",
      "Mahawan BO": "224201",
      "Manapur BO": "224001",
      "Naka Muzzafra BO": "224001",
      "Reona BO": "224225",
      "Nandauli BO": "224121",
      "Raipatti BO": "224121",
      "Golaghat BO": "224123",
      "Ramnagar Dhaurahra BO": "224126",
      "Sarangpur BO": "224126",
      "Abboopur BO": "224116",
      "Karaundi BO": "224116",
      "Khairi BO": "224116",
      "Rauzagaon BO": "224116",
      "Dashrathpur BO": "224204",
      "Dharehata Dashrathpur BO": "224204",
      "Gaura BO": "224204",
      "Gayaspur BO": "224204",
      "Sherpur Para BO": "224204",
      "Sohawal Saloni BO": "224204",
      "Toron Darab Ganj BO": "224204",
      "Jyoti Sadan BO": "224133",
      "Mubarakganj BO": "224189",
      "Pilkhawan BO": "224189",
      "Surwari BO": "224189",
      "Tandwa BO": "224189",
      "Water Works BO": "224001",
      "Amsin BO": "224141",
      "Ankaripur BO": "224141",
      "Rajapur Sraiya BO": "224141",
      "Sagar Pati Pandhula BO": "224208",
      "Singhora BO": "224208",
      "Kinauli BO": "224228",
      "Bhaironpur Tikari BO": "224206",
      "Koro Raghopur BO": "224206",
      "Marui Sahai Singh BO": "224206",
      "Ramnagar Chaukia BO": "224206",
      "Sidhari Bazar BO": "224153",
      "Pachiyana BO": "224205",
      "Sihipur BO": "224205",
      "Udharna BO": "224205",
      "Khanpur BO": "224158",
      "Kinhupur BO": "224158",
      "Kotdeeh BO": "224158",
      "Kumbhi BO": "224158",
      "Dehriyawan BO": "224207",
      "Gayasuddinpur BO": "224207",
      "Jalapur Bhaggoo BO": "224207",
      "Konchha BO": "224207",
      "Manjanpur BO": "224117",
      "Narauli BO": "224117",
      "Alnabhari BO": "224161",
      "Babuapur BO": "224161",
      "Baihari BO": "224161",
      "Beraspur BO": "224161",
      "Kasari BO": "224118",
      "Paharpur BO": "224118",
      "Rampur Janak BO": "224118",
      "Anjrauli BO": "224164",
      "Bhimatali BO": "224164",
      "Parsawan Khurd BO": "224164",
      "Kondri BO": "224201",
      "Narainpur BO": "224201",
      "Pora BO": "224201",
      "Giraunda BO": "224119",
      "Hunhuna BO": "224119",
      "Deogarh BO": "224171",
      "Gyanpur BO": "224171",
      "Baraon BO": "224203",
      "Beni Gaddopur BO": "224203",
      "Kodaila BO": "224203",
      "Hariharpur Kayasthan BO": "224120",
      "Neoti BO": "224120",
      "Rudauli City BO": "224120",
      "Bhitaura BO": "224188",
      "Jaganpur BO": "224188",
      "Kesharuabujurg BO": "224203",
      "Khamipurnidhiywan BO": "224195",
      "Paliachalpur BO": "224195",
      "Barauli BO": "224153",
      "Bhakhauli BO": "224153",
      "Deogaon BO": "224153",
      "Ghorwal BO": "224153",
      "Janabazar BO": "224205",
      "Pachgawan BO": "224205",
      "Shekhanpur BO": "224158",
      "Jorium BO": "224229",
      "Lalpur BO": "224234",
      "Pausara BO": "224234",
      "Rohiyawan BO": "224234",
      "Mumrej Nagar BO": "224207",
      "Bhoya BO": "224161",
      "Dalpatpur BO": "224161",
      "Dilasiganj BO": "224161",
      "JKIC  Arwat BO": "224161",
      "Jarhi BO": "224161",
      "Rauwa Lohangpur BO": "224161",
      "Amraigaon BO": "224118",
      "Talgaon BO": "224118",
      "Umapur BO": "224118",
      "Chitaura BO": "224164",
      "Dhanaicha BO": "224164",
      "Nimari BO": "224164",
      "Barwa BO": "224182",
      "Sanaha BO": "224182",
      "Aihar BO": "224120",
      "Bari BO": "224120",
      "Ferozpur Makhdoomi BO": "224120",
      "Astikaan BO": "224284",
      "Khirauni BO": "224188",
      "Magalsi BO": "224188",
      "Barehta BO": "224195",
      "Ghuritikar BO": "224195",
      "Sonaura Gaupur BO": "224195",
      "Mewapur BO": "224153",
      "Rasoolpur Lilha BO": "224153",
      "Banghusara BO": "224205",
      "Haiderganj BO": "224205",
      "Majnai BO": "224158",
      "Seora BO": "224158",
      "Bawan BO": "224229",
      "Pithila BO": "224229",
      "Sherawa Ghat BO": "224234",
      "Asrewa BO": "224207",
      "Neora BO": "224117",
      "Seonrahara BO": "224117",
      "Bakarganj BO": "224161",
      "Benawa BO": "224161",
      "Sarai Sagar BO": "224161",
      "Bihara BO": "224118",
      "Dewait BO": "224118",
      "Mathanewada BO": "224118",
      "Saidpur BO": "224118",
      "Sherpur BO": "224118",
      "Gokula BO": "224164",
      "Manjhanpur BO": "224164",
      "Tendha Khurd BO": "224164",
      "Upadhyapur BO": "224164",
      "Bankegaon BO": "224201",
      "Itaura BO": "224201",
      "Rampur Sardha BO": "224201",
      "Pure Kamgar BO": "224119",
      "Sithauli BO": "224119",
      "Madna BO": "224171",
      "Srai Rasi BO": "224171",
      "Netwari Chaturpur BO": "224203",
      "Parsawan BO": "224203",
      "Taarun Blgara BO": "224203",
      "Lakhauri BO": "224182",
      "Shahpur BO": "224120",
      "Station Road Rudauli BO": "224120",
      "Ghurehta BO": "224284",
      "Taksara BO": "224284",
      "Arthar BO": "224188",
      "Meerpur BO": "224188",
      "Moiyabegumganj BO": "224188",
      "Jaishingmau BO": "224195",
      "Nuawan Baidara BO": "224206",
      "Bakchuna BO": "224153",
      "Kotiya BO": "224153",
      "Palpur BO": "224153",
      "Rautawan BO": "224153",
      "Belarambagh BO": "224205",
      "Dahema BO": "224205",
      "Teria BO": "224205",
      "Kurawan BO": "224158",
      "Palia Jagmohan Singh BO": "224158",
      "Tarauli BO": "224158",
      "Uchhahpali BO": "224158",
      "Birauli BO": "224229",
      "Sidhauna BO": "224229",
      "Tindauli BO": "224229",
      "Basantpur BO": "224234",
      "Sarai Khargi BO": "224207",
      "Sandawa BO": "224117",
      "Balrampur BO": "224161",
      "Tandauli BO": "224161",
      "Chandramau BO": "224118",
      "Hansrajpur BO": "224118",
      "Saimsi BO": "224118",
      "Sunba BO": "224118",
      "Lodhaura B.O.": "224118",
      "Ghatauli BO": "224164",
      "Marui Ganeshpur BO": "224164",
      "Ranapur BO": "224164",
      "Dasauli BO": "224201",
      "Jakhauli BO": "224119",
      "Rani Mau Bhatthi BO": "224119",
      "Janapur BO": "224171",
      "Nawada BO": "224182",
      "Tanda Sufi BO": "224120",
      "Dhema Vaish BO": "224284",
      "Mubarakpur Umarni BO": "224284",
      "Majnawa BO": "224188",
      "Panditpur BO": "224188",
      "Kakauli BO": "224195",
      "Faizabad HO": "224001",
      "Achhora SO": "224225",
      "Amaniganj SO": "224121",
      "Ayodhya RS SO": "224123",
      "Barun SO Ambedkar Nagar": "224127",
      "Bhilsar SO": "224116",
      "Dabha Samer SO": "224133",
      "Faizabad RS SO": "224001",
      "Fatehganj SO": "224001",
      "Acharya Nagar SO": "224001",
      "Baragaon RS SO": "224126",
      "Dharamarg SO": "224001",
      "Faizabad Cantt SO": "224001",
      "Faizabad Kutchery SO": "224001",
      "Kandhari Bazar SO": "224001",
      "Kuchera SO": "224158",
      "Kumarganj SO": "224229",
      "Ayodhya SO": "224123",
      "Bharatkund SO": "224202",
      "Deorhi SO": "224189",
      "Faizabad City SO": "224001",
      "Goshaiganj SO": "224141",
      "Harringtonganj SO": "224208",
      "Khajurahat SO": "224206",
      "Majurddinpur SO": "224207",
      "Motibagah SO": "224001",
      "Maya SO": "224161",
      "Meermau SO": "224118",
      "Milkipur SO": "224164",
      "Niywan SO": "224001",
      "Patranga RS SO": "224119",
      "Bikapur SO": "224204",
      "Chaurebazar SO": "224209",
      "Darshan Nagar SO": "224135",
      "Inayatnagar SO": "224228",
      "Janpad Chikitsalaya SO": "224001",
      "Khandasa SO": "224153",
      "Khapradih SO": "224205",
      "Raunahi SO": "224182",
      "Rudauli SO": "224120",
      "Sahebganj SO": "224001",
      "Sohawal RS SO": "224188",
      "Terhi Bazar SO": "224123",
      "Tikari SO": "224195",
      "Mahboobganj SO": "224234",
      "Mandi Samiti SO": "224001",
      "Motinagar SO": "224201",
      "Purah SO": "224171",
      "Rampur Bhagan SO": "224203",
      "Sadar Bazar SO": "224001",
      "Shahganj SO": "224284",
      "Ramkot SO": "224123",
      "Ramnagar Colony SO": "224001",
      "Lalbagh SO": "224001",
      "Mawai SO": "224117"
    },
    "AMBEDKAR NAGAR": {
      "Masorha BO": "224183",
      "Barepur BO": "224186",
      "Larpur BO": "224186",
      "Rukunuddinpur BO": "224186",
      "Maharajganj BO": "224227",
      "Mumrejpur BO": "224227",
      "Brahimpur Kusma BO": "224190",
      "Debipur BO": "224190",
      "Khaspur BO": "224190",
      "Sarjupur BO": "224183",
      "Amartal BO": "224186",
      "Gomunpur BO": "224186",
      "Hajpura BO": "224186",
      "Katui BO": "224186",
      "Sulhantara BO": "224186",
      "Makhdumsarai BO": "224227",
      "Chhajapur BO": "224190",
      "Hajlapur BO": "224190",
      "Husainpur Sudnaha BO": "224190",
      "Makhdoom Nagar BO": "224190",
      "Tanda City BO": "224190",
      "Asgawan BO": "224141",
      "Basantpur BO": "224206",
      "Machhiligaon BO": "224186",
      "Baraura BO": "224227",
      "Lodipur BO": "224227",
      "Husainpur Girant BO": "224190",
      "Lorpur BO": "224235",
      "Naugaon BO": "224235",
      "Sijhauli BO": "224235",
      "Katgharmusa BO": "224186",
      "Sultangarh BO": "224186",
      "Rampur Mungradilla BO": "224227",
      "Ajmeri Badshahpur BO": "224190",
      "Arsawan BO": "224190",
      "Asopur BO": "224190",
      "Balaiya Jagdishpur BO": "224190",
      "Mubarakpur BO": "224190",
      "Nandapur BO": "224190",
      "Pirthivipur BO": "224190",
      "Rampur Kalan BO": "224190",
      "Chahoraghat BO": "224181",
      "Neeba BO": "224181",
      "Sarawan BO": "224181",
      "Shajana Hamjapur BO": "224181",
      "Majgaon BO": "224183",
      "Bemaval BO": "224181",
      "Bidhar BO": "224181",
      "Bsaiya Ganga Sagar BO": "224181",
      "Lakhmipur BO": "224181",
      "Lawaiya Pratappur BO": "224183",
      "Kawahianjanpur BO": "224181",
      "Lakhandih BO": "224181",
      "Lakhnipatti BO": "224181",
      "Sutharpara BO": "224181",
      "Hisamuddinpur Pipra BO": "224181",
      "Shahpur Bangawan BO": "224181",
      "Yadavpur BO": "224181",
      "Mahulia BO": "224183",
      "Mahuwari BO": "224234",
      "Atraura BO": "224234",
      "Karampur Barsawan BO": "224234",
      "Utrethu BO": "224234",
      "Bhupatipur BO": "224122",
      "Ashapur BO": "224125",
      "Chakiya BO": "224125",
      "Purebadalhi BO": "224125",
      "Ratna BO": "224125",
      "Khalispur BO": "224159",
      "Makhdoom Baramadpur BO": "224159",
      "Paruiya Ashram BO": "224159",
      "Setha Kalan BO": "224159",
      "Surhurpur BO": "224159",
      "Deohat BO": "224210",
      "Rampur Rampatti BO": "224210",
      "Tendwa Paharpur BO": "224210",
      "Achhati BO": "224129",
      "Sultanpur Kabirpur BO": "224129",
      "Parwar Bhari BO": "224132",
      "Umrawan BO": "224132",
      "Sikraura Kanchanpur BO": "224137",
      "Tandwa Jalal BO": "224137",
      "Tendwai Kalan BO": "224137",
      "Ahirauli Govind Sahab BO": "224139",
      "Ajmalpur BO": "224139",
      "Bhiyaon BO": "224139",
      "Marahara BO": "224139",
      "Noorpur Kalan BO": "224139",
      "Pindoria BO": "224139",
      "Rasoolpur Mundera BO": "224143",
      "Naipura BO": "224145",
      "Husainpur BO": "224146",
      "Kartora BO": "224146",
      "Saidapur BO": "224146",
      "Admapur BO": "224147",
      "Akhtara Narainpur BO": "224147",
      "Kannoopur BO": "224149",
      "Mainpur BO": "224149",
      "Mathia BO": "224149",
      "Nagpur BO": "224149",
      "Paekauli Bazar BO": "224149",
      "Ashrafpur Barwa BO": "224151",
      "Bhari Diha BO": "224151",
      "Karampur BO": "224151",
      "Baragaon Brahimpur BO": "224230",
      "Dhiwa Daulatpur BO": "224230",
      "Atwari BO": "224157",
      "Hath Pakar BO": "224157",
      "Ramdas Patti BO": "224157",
      "Dargah Rasoolpur BO": "224155",
      "Gaura Mohammadpur BO": "224155",
      "Hiri Pakaria BO": "224231",
      "Jaitoopur BO": "224231",
      "Ram Nagar Karri BO": "224231",
      "Rudaupur BO": "224152",
      "Samar Singhpur BO": "224152",
      "Kadipur Khas BO": "224168",
      "Meerpur Sheikhpur BO": "224168",
      "Nasirpur BO": "224168",
      "Semari BO": "224168",
      "Chak Bhadaya BO": "224176",
      "Bukia BO": "224129",
      "Indaipur BO": "224129",
      "Kaurahi BO": "224129",
      "Bathua BO": "224132",
      "Bhadar BO": "224132",
      "Kahi BO": "224132",
      "Karnaipur BO": "224132",
      "Ahirauli Ranimau BO": "224137",
      "Persanpur BO": "224137",
      "Samdih BO": "224137",
      "Neori BO": "224139",
      "Rakba Amola BO": "224139",
      "Aribpur BO": "224143",
      "Dhenkara BO": "224143",
      "Gohila BO": "224143",
      "Haridaspur BO": "224143",
      "Sabukpur BO": "224143",
      "Saidpur Lurvadih BO": "224143",
      "Semaur BO": "224143",
      "Semra Nasirpur BO": "224143",
      "Tarauli Mubarakpur BO": "224143",
      "Ainawa BO": "224145",
      "Avsanpur BO": "224145",
      "Saidpur Bhitari BO": "224146",
      "Shikrohar BO": "224146",
      "Tara Khurd BO": "224146",
      "Hariharpur BO": "224147",
      "Jainti BO": "224147",
      "Kalyanpur BO": "224147",
      "Khamariyanghat BO": "224147",
      "Madainiya BO": "224147",
      "Madarmau BO": "224147",
      "Rambag Baragaon BO": "224147",
      "Ambarpur BO": "224149",
      "Arai BO": "224149",
      "Ashrafpur Majhagawan BO": "224149",
      "Baragaon Sheikhpur BO": "224149",
      "Rukunpur Kasimpur BO": "224149",
      "Pyare Pur BO": "224151",
      "Yarkee BO": "224151",
      "Gayaspur Samsuddinpur BO": "224155",
      "Jeewat BO": "224155",
      "Daridiha BO": "224231",
      "Itauri BO": "224159",
      "Kalepur Mahuwal BO": "224159",
      "Kar Misripur BO": "224159",
      "Khajuri BO": "224159",
      "Arjunpur BO": "224152",
      "Basohari BO": "224152",
      "Tewaripur Sabna BO": "224152",
      "Adampur Tiloni BO": "224168",
      "Bandan Deeh BO": "224168",
      "Baramadpur Jariyari BO": "224168",
      "Bhikharipur BO": "224168",
      "Madhupur BO": "224125",
      "Mundehra BO": "224125",
      "Bhaupur BO": "224210",
      "Bela Parsa BO": "224129",
      "Garha BO": "224129",
      "Lakhanpur BO": "224129",
      "Mujahidpur BO": "224129",
      "Sukul Bazar BO": "224129",
      "Madarbhari BO": "224132",
      "Pariyawan BO": "224132",
      "Alauddinur BO": "224137",
      "Nikaspur BO": "224137",
      "Bishambharpur BO": "224139",
      "Manikpur BO": "224143",
      "Naurahni Rampur BO": "224143",
      "Zainuddinpur BO": "224143",
      "Bharsari BO": "224145",
      "Faridpur Kalan BO": "224145",
      "Asnara BO": "224147",
      "Chandipur Khurd BO": "224147",
      "Jamaloopur BO": "224147",
      "Narwa Pitambarpur BO": "224147",
      "Tikoria Buzurg BO": "224147",
      "Bhaukuwan BO": "224149",
      "Daulatabad BO": "224149",
      "Rajepur Kopa BO": "224149",
      "Sheopal BO": "224149",
      "Udaipur BO": "224149",
      "Khajawan BO": "224151",
      "Marthua Saraiya BO": "224151",
      "Shadipur BO": "224230",
      "Ahirauli BO": "224157",
      "Sonawan BO": "224157",
      "Bhidur BO": "224155",
      "Tandwa Maulai BO": "224155",
      "Bela BO": "224231",
      "Chiotipara BO": "224231",
      "Jamu Kalan BO": "224231",
      "Narharpur BO": "224231",
      "Dhaurua BO": "224159",
      "Benipur BO": "224152",
      "Lohjhara BO": "224152",
      "Rambaba BO": "224152",
      "Dandupur BO": "224168",
      "Mansapur BO": "224168",
      "Bijli Tihayatpur BO": "224176",
      "Lalmanpur BO": "224176",
      "Annapur BO": "224181",
      "Aribpur Ramnagar BO": "224181",
      "Mubarakpurpikar BO": "224176",
      "Mundiyari BO": "224176",
      "Tandwa Bharatpur BO": "224176",
      "Mirzapur BO": "224125",
      "Pakhanpurbichaila BO": "224125",
      "Bhadohi BO": "224159",
      "Dharamganj BO": "224152",
      "Mustafabad BO": "224152",
      "Saya BO": "224152",
      "Bahorikpur BO": "224168",
      "Baramadpur Lohra BO": "224168",
      "Chanaipur BO": "224168",
      "Kudia Chitauna BO": "224168",
      "Subhakarpur BO": "224168",
      "Bankata Bujurg BO": "224176",
      "Katariya Yaqubpur BO": "224122",
      "Mubarakpur Daiyadeeh BO": "224122",
      "Rampur Jaisingh BO": "224122",
      "Bewana BO": "224122",
      "Tajpur BO": "224122",
      "Daudpur BO": "224210",
      "Kurki Bazar BO": "224210",
      "Baniyani BO": "224129",
      "Majhgawan BO": "224129",
      "Makoiya BO": "224129",
      "Sheotara BO": "224129",
      "Bangaon BO": "224132",
      "Kela Lal Khan BO": "224132",
      "Malawan BO": "224132",
      "Gharwal BO": "224137",
      "Kharuwaon BO": "224137",
      "Amari BO": "224139",
      "Deeh Bhilon BO": "224139",
      "Mathura Rasoolpur BO": "224139",
      "Makrahi BO": "224143",
      "Musepur BO": "224143",
      "Chitoi BO": "224145",
      "Khukhutara BO": "224145",
      "Kakardilla BO": "224146",
      "Alaupur BO": "224147",
      "Bairi Buzurg BO": "224147",
      "Jogipur Dhanikpur BO": "224147",
      "Nariyawa BO": "224147",
      "Umari Jalal BO": "224147",
      "Begikol BO": "224149",
      "Bhujgi BO": "224149",
      "Fatehpur BO": "224149",
      "Ismailpur Tahepur BO": "224149",
      "Nathu Pur Laudhana BO": "224149",
      "Pethia BO": "224149",
      "Tighara BO": "224149",
      "Khewar BO": "224151",
      "Pratappur Chamurkha BO": "224151",
      "Chandpur BO": "224230",
      "Jamunipur BO": "224230",
      "Fatehpur Belabagh BO": "224157",
      "Paras Katui BO": "224155",
      "Chapra BO": "224231",
      "Keotahi BO": "224231",
      "Mathani BO": "224231",
      "Sehra Jalalpur BO": "224231",
      "Mungari Samaisa BO": "224122",
      "Bangaondihwa BO": "224122",
      "Rampursakarwari BO": "224122",
      "Sirsiya Jamunipur BO": "224176",
      "Amadarveshpur BO": "224181",
      "Kalhuwa Kaura BO": "224122",
      "Kotwa Mohamadpur BO": "224122",
      "Seehmaikarirat BO": "224122",
      "Songaon BO": "224122",
      "Kurcha BO": "224122",
      "Muslim Jagdishpur BO": "224122",
      "Akbarpur HO": "224122",
      "Iltifatganj SO": "224145",
      "Katehari SO": "224151",
      "Khemapur SO": "224157",
      "Kichhauccha SO": "224155",
      "Rajesultanpur SO": "224176",
      "Ram Nagar SO Ambedkar Nagar": "224181",
      "Surapur SO": "224227",
      "Tanda SO Ambedkar Nagar": "224190",
      "Bandipur SO": "224125",
      "Baskhari SO": "224129",
      "Deoria SO Ambedkar Nagar": "224137",
      "Kedarnagar SO": "224230",
      "Malipur SO": "224159",
      "Pahitipur SO": "224168",
      "Saidahi SO": "224183",
      "Tanda Tehseel SO": "224190",
      "Bariyawan SO": "224210",
      "Bhiti SO": "224132",
      "Hakeem Pur SO": "224232",
      "Hanswar SO": "224143",
      "Jafarganj SO": "224146",
      "Jahangirganj SO": "224147",
      "Jalalpur SO Ambedkar Nagar": "224149",
      "Sahzadpur SO": "224122",
      "Vidhut Nagar SO": "224238",
      "Bus Station Akbarpur SO": "224122",
      "Dulahoopur SO": "224139",
      "Maharuwa Gola SO": "224231",
      "Mijhaura SO": "224152",
      "Sikandarpur SO Ambedkar Nagar": "224186",
      "UPSS Mill SO": "224235"
    },
    "MIRZAPUR": {
      "Agarsand BO": "231305",
      "Bangla Devaria BO": "231305",
      "Rehi BO": "231211",
      "Tilaon BO": "231211",
      "Tita BO": "231211",
      "Usari Khamaria BO": "231211",
      "Jaipatti Kala BO": "231305",
      "Kamalpur BO": "231305",
      "Chhota Mirzapur BO": "231305",
      "Domari BO": "231305",
      "Khajuraul BO": "231305",
      "Purusottam Pur BO": "231305",
      "Shahpur BO": "231305",
      "Sher Pur BO": "231305",
      "Devaria BO": "231305",
      "Hariharpur BO": "231305",
      "Pachevara BO": "231305",
      "Rupaudha BO": "231305",
      "Bihsada BO": "231303",
      "Kushhan BO": "231303",
      "Balliparwa BO": "231312",
      "Kamasin BO": "231312",
      "Kolna BO": "231304",
      "Kusumhi BO": "231304",
      "Lahaura BO": "231304",
      "Media BO": "231304",
      "Raipuria BO": "231304",
      "Rudauli BO": "231304",
      "Sarson Gram BO": "231304",
      "Shakteshgarh BO": "231304",
      "Devpura BO": "231210",
      "Hinauta BO": "231210",
      "Jamui BO": "231210",
      "Rampur 38 BO": "231210",
      "Semara Baraho BO": "231210",
      "Bajta BO": "231313",
      "Gogaon BO": "231313",
      "Hargarh Bazar BO": "231313",
      "Kakarad BO": "231309",
      "Kota Shiv Pratap Singh BO": "231211",
      "Lahangpur BO": "231211",
      "Matwar BO": "231211",
      "Nadaulikaraundi BO": "231211",
      "Nadini BO": "231303",
      "Nibi Gaharwar BO": "231303",
      "Supantha BO": "231303",
      "Tilthi BO": "231312",
      "Bharpura BO": "231304",
      "Bhudkuda BO": "231304",
      "Chunar Rly Station BO": "231304",
      "Darhiram BO": "231304",
      "Hinauti BO": "231304",
      "Jalalpur Mafi BO": "231304",
      "Mohanpur Bhavrakh BO": "231304",
      "Marihan BO": "231210",
      "Nigatpur BO": "231314",
      "Bhainsa BO": "231501",
      "Bidapur BO": "231501",
      "Birshahpur BO": "231501",
      "Gadauli BO": "231501",
      "Gursandi BO": "231501",
      "Majhawan BO": "231501",
      "Meoli BO": "231501",
      "Sandwa BO": "231501",
      "Padaria Kala BO": "231309",
      "Patharaul BO": "231309",
      "Ahungi Kala BO": "231211",
      "Amaha Mafi BO": "231211",
      "Babura Kala BO": "231211",
      "Baraudha Belan BO": "231211",
      "Bhaisod Balay Pahad BO": "231211",
      "Dramandganj BO": "231211",
      "Dadwan Pakseda BO": "231303",
      "Kholua BO": "231312",
      "Mujehara BO": "231312",
      "Bharehata BO": "231304",
      "Bhawanipur BO": "231304",
      "Dargah Sharif BO": "231304",
      "Gangpur BO": "231304",
      "Jamuhar BO": "231304",
      "Kathinai BO": "231304",
      "Nakati Mishrauli BO": "231304",
      "Pahadi BO": "231304",
      "Thiresapur BO": "231304",
      "Patehara Khurd BO": "231210",
      "Dugauli BO": "231313",
      "Khaira BO": "231313",
      "Baraini BO": "231501",
      "Bhatauli BO": "231501",
      "Jalalpur BO": "231501",
      "Neorhia Ghat BO": "231501",
      "Kotwa BO": "231309",
      "Rampur Atari BO": "231309",
      "Barbasa Gaharwar BO": "231211",
      "Bedaur BO": "231211",
      "Bilra Patehara BO": "231211",
      "Hallia BO": "231211",
      "Kanokhar BO": "231211",
      "Navgawan BO": "231211",
      "Surahan BO": "231302",
      "Ekali BO": "231301",
      "Hussainpur BO": "231301",
      "Ghanshyampur BO": "231302",
      "Gothaura BO": "231302",
      "Jamalpur BO": "231302",
      "Manaur BO": "231302",
      "Biraura BO": "231303",
      "Birohi BO": "231303",
      "Kalna BO": "231303",
      "Mawaiya BO": "231312",
      "Putlighar BO": "231312",
      "Bagahi BO": "231304",
      "Kandawa BO": "231304",
      "Khanjadipur BO": "231304",
      "Padari BO": "231304",
      "Patihata BO": "231304",
      "Sindhora BO": "231304",
      "Tendua Kala BO": "231304",
      "Baghaura BO": "231210",
      "Kalwari Mafi BO": "231210",
      "Lalpur Naudiha BO": "231210",
      "Rajgarh BO": "231210",
      "Gaura BO": "231313",
      "Sri Niwas Dham BO": "231313",
      "Mahamalpur BO": "231501",
      "Semari Khas BO": "231501",
      "Belahara BO": "231309",
      "Kanhaipur BO": "231309",
      "Sirsi BO": "231309",
      "Bardiha Kala BO": "231211",
      "Dubarkala BO": "231211",
      "Hardi Gulalpur BO": "231211",
      "Pavari Kala BO": "231211",
      "Mahuari Kala BO": "231307",
      "Mahuwaria BO": "231307",
      "Musaffarganj BO": "231307",
      "Nakahara BO": "231307",
      "Bhuelikhas BO": "231302",
      "Derhauna BO": "231302",
      "Pachegada BO": "231302",
      "Pathraura BO": "231302",
      "Pidkhir BO": "231302",
      "Adhwar BO": "231301",
      "Ghatampur BO": "231301",
      "Chhatahan BO": "231307",
      "Hariharpur Bedauli BO": "231307",
      "Raipur Pokhta BO": "231307",
      "Rajpur Amghat BO": "231307",
      "Patulki BO": "231211",
      "Pipra BO": "231211",
      "Akodhi BO": "231307",
      "Amoi BO": "231307",
      "Babura BO": "231307",
      "Samogara BO": "231307",
      "Bahuar BO": "231302",
      "Chaturipur BO": "231302",
      "Sherwa BO": "231302",
      "Barkachha BO": "231307",
      "Dewari BO": "231307",
      "Paidapur BO": "231307",
      "Rajapur BO": "231307",
      "Domanpur BO": "231306",
      "Hansipur BO": "231306",
      "Khanpur BO": "231306",
      "Magarahan BO": "231306",
      "Bagahan BO": "231306",
      "Ramgarh Kiriyat BO": "231306",
      "Mirzapur HO": "231001",
      "Industrial Estate SO Mirzapur": "231001",
      "Laldiggi SO": "231001",
      "Narainpur SO Mirzapur": "231305",
      "Sikhar SO": "231306",
      "Vindhyachal SO": "231307",
      "Wellesly Ganj SO": "231001",
      "Jigna RS SO": "231313",
      "Kachhwa SO Mirzapur": "231501",
      "Lalganj Mirzapur SO": "231211",
      "Mirzapur Kutchery SO": "231001",
      "Jamua SO Mirzapur": "231314",
      "Mirzapur City SO": "231001",
      "Kubari Patehara SO": "231309",
      "Mirzapur Chowk SO": "231001",
      "Chunar Cement Factory SO": "231311",
      "Ganesh Ganj SO Mirzapur": "231001",
      "Chunar Tehsil SO": "231304",
      "Ahraura SO": "231301",
      "Chilh SO": "231312",
      "Chunar SO": "231304",
      "Adalhat SO": "231302",
      "Bijaipur SO Mirzapur": "231303"
    },
    "KANNAUJ": {
      "Dadauna BO": "209747",
      "Majhupur BO": "209747",
      "Paraur BO": "209747",
      "Rohili BO": "209735",
      "Tera Jaket BO": "209735",
      "Miyaganj BO": "209727",
      "Muraiya Buzurg BO": "209727",
      "Nazrapur Patti BO": "209727",
      "Painda Bad BO": "209727",
      "Aruha BO": "209728",
      "Birpur BO": "209747",
      "Salempur BO": "209731",
      "Sarifabad BO": "209747",
      "Gangemau BO": "209727",
      "Kushum Khor BO": "209727",
      "Mitra Senpur BO": "209727",
      "Nera BO": "209727",
      "Teramallu BO": "209727",
      "Chapunna BO": "209728",
      "Gyaspur BO": "209728",
      "Murra BO": "209728",
      "Nizampur BO": "209728",
      "Nauli BO": "209729",
      "Amolar BO": "209731",
      "Sursi BO": "209734",
      "Basta BO": "209732",
      "Deodha BO": "209738",
      "Khanpur BO": "209738",
      "Miruan Marha BO": "209738",
      "Bahadurpur Majhgaon BO": "209728",
      "Bangawan Kharg BO": "209728",
      "Behta Rampur BO": "209728",
      "Gulariyapur BO": "209728",
      "Khadini BO": "209728",
      "Bhunna BO": "209734",
      "Khama BO": "209734",
      "Patti BO": "209734",
      "Rura BO": "209734",
      "Lohamarh BO": "209732",
      "Mahteypurwa BO": "209732",
      "Tirwa Ganj BO": "209732",
      "Ferozpur BO": "209738",
      "Kudhina BO": "209738",
      "Mawai Bilwari BO": "209738",
      "Rampur Majhila BO": "209738",
      "Godhani BO": "209727",
      "Jalalpur Panwara BO": "209727",
      "Jaspura Pur BO": "209727",
      "Ishampur BO": "209728",
      "Sakatpur BO": "209728",
      "Sarai Theku BO": "209728",
      "Aseha BO": "209729",
      "Bibia Jalalpur BO": "209729",
      "Jeramau Alampur BO": "209731",
      "Madhonagar BO": "209731",
      "Sataura BO": "209731",
      "Bhadausi BO": "209734",
      "Barauli BO": "209727",
      "Ibrahimpur Zagir BO": "209727",
      "Malikapur BO": "209727",
      "Tidiyapur BO": "209727",
      "Haseran BO": "209728",
      "Kisai Jagdishpur BO": "209728",
      "Nademau BO": "209728",
      "Chanderpur BO": "209729",
      "Bamrauli BO": "209731",
      "Tahpur BO": "209731",
      "Balanpur BO": "209732",
      "Behrin BO": "209732",
      "Hariharpur BO": "209720",
      "Hathin BO": "209721",
      "Jafrabad BO": "209721",
      "Nigoh BO": "209721",
      "Prempur BO": "209721",
      "Dundwabuzurg BO": "209722",
      "Ismailpur BO": "209722",
      "Agaus BO": "209723",
      "Lakh BO": "209723",
      "Madhpura BO": "209723",
      "Jewan BO": "209733",
      "Kiratpur BO": "209733",
      "Matauli BO": "209733",
      "Auser BO": "209736",
      "Bhaunrajpur BO": "209720",
      "Lokpur BO": "209720",
      "K P Banwari BO": "209721",
      "Khubariapur BO": "209721",
      "Mighauli BO": "209721",
      "Naugai BO": "209721",
      "Samdhan BO": "209722",
      "Belamau Saraiya BO": "209723",
      "Bhagwantpur BO": "209723",
      "Fatehpur BO": "209733",
      "Saunsarapur BO": "209733",
      "Jankhat BO": "209736",
      "Simaria BO": "209736",
      "Asaltabad BO": "209720",
      "Bahbalpur BO": "209721",
      "Galla Mandi CBR BO": "209721",
      "Majhpurwa BO": "209722",
      "Mohanpur Ratanpur BO": "209722",
      "Parsaramau Majhretha BO": "209723",
      "Pura Rai BO": "209723",
      "Anaugi BO": "209733",
      "Bhainsiapur BO": "209724",
      "Chiyasar BO": "209724",
      "Binaura Rampur BO": "209736",
      "Hamirpur BO": "209736",
      "Haraipur BO": "209736",
      "Akbarpur BO": "209721",
      "Kasawa BO": "209721",
      "Khojipur BO": "209721",
      "Merapur Garhiya BO": "209721",
      "Nandlalpur BO": "209721",
      "Tera Rabbu BO": "209722",
      "Uncha BO": "209722",
      "Bahosi BO": "209723",
      "Kalsan BO": "209723",
      "Gugrapur BO": "209733",
      "Kulhapur BO": "209733",
      "Mirgawan Ki Garhi BO": "209733",
      "Umrain BO": "209736",
      "Bishungarh SO Kannauj": "209720",
      "Gurusahaiganj SO": "209722",
      "Hari Nagar SO Kannauj": "209725",
      "Saraimira SO": "209727",
      "Talgram SO": "209731",
      "Thathia SO": "209734",
      "Tirwa SO": "209732",
      "Chhipatti SO": "209725",
      "Khairnagar SO": "209736",
      "Makrand Nagar SO": "209726",
      "Sarai Prayag SO": "209735",
      "Saurikh SO": "209728",
      "Bazaria Chhibramau SO": "209721",
      "Chhibramau SO": "209721",
      "Jalalabad SO Kannauj": "209733",
      "Kannauj SO": "209725",
      "Kannauj Samachar SO": "209725",
      "Umarda SO": "209738",
      "Indergarh SO Kannauj": "209723",
      "Sakrawa SO": "209747",
      "Sikanderpur SO Kannauj": "209729"
    },
    "SONBHADRA": {
      "Jamgaon BO": "231215",
      "Mudiladeeh BO": "231215",
      "Panauli BO": "231215",
      "Sarvat BO": "231215",
      "Banki BO": "231213",
      "Maachi BO": "231213",
      "Nandana BO": "231213",
      "Sandi BO": "231213",
      "Billi Markundi BO": "231219",
      "Panari BO": "231219",
      "Pakarhat BO": "231213",
      "Pannuganj BO": "231213",
      "Pauni BO": "231213",
      "Raipur BO": "231213",
      "Rampur BO": "231213",
      "Parsoi BO": "231219",
      "Dohari BO": "231215",
      "Shahganj BO": "231215",
      "Majhidand BO": "231213",
      "Padarikala BO": "231213",
      "Retikala BO": "231213",
      "Shivpur BO": "231213",
      "Asanahar BO": "231223",
      "Bachara BO": "231223",
      "Chapki BO": "231223",
      "Cherui BO": "231206",
      "Padarachh BO": "231207",
      "Babhani BO": "231208",
      "Chainpur BO": "231208",
      "Ekdari BO": "231208",
      "Gadia BO": "231208",
      "Kirbil BO": "231208",
      "Pakari BO": "231208",
      "Satbahani BO": "231208",
      "Baidand BO": "231210",
      "Rizul BO": "231210",
      "Sabha Lilwahi BO": "231210",
      "Bairpan BO": "231225",
      "Pindari BO": "231223",
      "Sindoor BO": "231223",
      "Bharahari BO": "231205",
      "Chatarvar BO": "231205",
      "Kanachh BO": "231205",
      "Salkhan BO": "231205",
      "Sinduria BO": "231205",
      "Gurmura BO": "231207",
      "Jharo Khurd BO": "231208",
      "Lohadi BO": "231210",
      "Sundari BO": "231212",
      "Dibulgani BO": "231225",
      "Radhore BO": "231225",
      "Dharti Dand BO": "231223",
      "Jarhan BO": "231223",
      "Badgaon BO": "231205",
      "Jugail BO": "231205",
      "Kargara BO": "231205",
      "Kudari BO": "231205",
      "Newari BO": "231205",
      "Kota BO": "231207",
      "Arangpani BO": "231208",
      "Hathwani BO": "231208",
      "Karahia BO": "231208",
      "Myorpur BO": "231208",
      "Amilaudha BO": "231210",
      "Kanethi BO": "231210",
      "Padwania BO": "231210",
      "Shivdwar BO": "231210",
      "Bagharu BO": "231212",
      "Ghaghara BO": "231212",
      "Sagobandh BO": "231212",
      "Kandhaura BO": "231225",
      "Ghaghari BO": "231223",
      "Nadhira BO": "231223",
      "Adalganj BO": "231205",
      "Kharhara BO": "231205",
      "Khokha Karahia BO": "231208",
      "Mahuli BO": "231208",
      "Rajkhad BO": "231208",
      "Parsona BO": "231210",
      "Tilaulikala BO": "231210",
      "Ghiwahi BO": "231226",
      "Dhorpa BO": "231226",
      "Kachnarwa BO": "231226",
      "Lilasikala BO": "231212",
      "Naudiha BO": "231212",
      "Bagesoti BO": "231226",
      "Kewal BO": "231226",
      "Kone BO": "231226",
      "Dhuma BO": "231226",
      "Naudiha  Ramgarh BO": "231226",
      "Rorwan BO": "231226",
      "Mahuaria BO": "231212",
      "Chachikalan BO": "231226",
      "Kudwan BO": "231226",
      "Mishri BO": "231226",
      "Khajura BO": "231218",
      "Bahuar BO": "231216",
      "Bahuara BO": "231216",
      "Dharnipur BO": "231216",
      "Khairpur BO": "231216",
      "Madhupur BO": "231216",
      "Siltham BO": "231213",
      "Belhatthi BO": "231217",
      "Sukhdevanand Ashram BO": "231217",
      "Kaithi BO": "231216",
      "Karma BO": "231216",
      "Kasyakala BO": "231216",
      "Narokhar BO": "231216",
      "Sahijankala BO": "231216",
      "Siddhi Kala BO": "231216",
      "Banvasi Seva Ashram BO": "231221",
      "Akchhor BO": "231216",
      "Bichchhi BO": "231216",
      "Hinauta BO": "231216",
      "Khairahi BO": "231216",
      "Oeni Mishra BO": "231216",
      "Parasi Dubey BO": "231216",
      "Yogichaura BO": "231222",
      "Kakarahi BO": "231216",
      "Mokarsim BO": "231216",
      "Nai Bazar BO": "231216",
      "Sukrut BO": "231216",
      "Tarawan BO": "231216",
      "Tendu BO": "231216",
      "Ghorawal SO": "231210",
      "Gurma Markundi SO": "231209",
      "Ram Garh SO": "231213",
      "Renusagar SO": "231218",
      "Robertsganj SO": "231216",
      "Khadia Project SO": "231222",
      "Obra Thermal SO": "231219",
      "Shaktinagar SO Sonbhadra": "231222",
      "Turra SO": "231221",
      "Kakari Project SO": "231224",
      "Rajpur SO Sonbhadra": "231215",
      "Renukoot SO": "231217",
      "Robertsganj Hydle Colony SO": "231216",
      "Shaktinagar Thermal Power Stat SO": "231222",
      "Obra SO Sonbhadra": "231219",
      "Wyndhamganj SO": "231226",
      "Amwar SO": "231212",
      "Dalla SO": "231207",
      "Dudhi SO": "231208",
      "Beej Pur SO": "231223",
      "Anpara Tps SO": "231225",
      "Beena Project SO": "231220",
      "Chopan SO": "231205",
      "Churk SO": "231206"
    },
    "PRATAPGARH": {
      "Kandharpur BO": "230401",
      "Katari BO": "230401",
      "Narharpur BO": "230401",
      "Parasrampur BO": "230401",
      "Itaura BO": "230204",
      "Jagapur BO": "230204",
      "Jhingur BO": "230204",
      "Laroo BO": "230204",
      "Amawan BO": "230125",
      "Belha BO": "230132",
      "Dewapur BO": "230132",
      "Gondey BO": "230403",
      "Bhagwatganj BO": "230402",
      "Majhigawan BO": "230402",
      "Sarai Bhimsen BO": "230142",
      "Sarai Murar Singh BO": "230402",
      "Charaiya BO": "230135",
      "Dhandhar BO": "230135",
      "Fatehpur BO": "230135",
      "Kanja Sarai Gulami BO": "230135",
      "Kansapatti BO": "230135",
      "Kukuwar BO": "230135",
      "Dherehana BO": "230002",
      "Mohanganj BO": "230002",
      "Binaika BO": "230121",
      "Chhatauna BO": "230121",
      "Diyawan BO": "230121",
      "Gaura Mafi BO": "230121",
      "Durgaganj BO": "230304",
      "Hariharganj BO": "230304",
      "Prithviganj BO": "230304",
      "Pure Gosain BO": "230304",
      "Ramnagar BO": "230304",
      "Sansarpur BO": "230304",
      "Lakhipur Kapsa BO": "230138",
      "Manapur BO": "230138",
      "Lakhapur BO": "230139",
      "Laxmikant Ganj BO": "230139",
      "Mustafabad BO": "230139",
      "Paranipur BO": "230139",
      "Rahatikar BO": "230139",
      "Abdul Wahidganj BO": "230141",
      "Adlabad BO": "230141",
      "Lawana Bhawaniganj BO": "230141",
      "Manuhar BO": "230141",
      "Narainpur Kalan BO": "230306",
      "Naudera BO": "230306",
      "Surwa Mishirpur BO": "230306",
      "Sarai Raja BO": "230404",
      "Besar BO": "230133",
      "Pure Newal BO": "230503",
      "Rajapur Rainiya BO": "230503",
      "Ramnagar Bhojpur BO": "230503",
      "Surajgarh BO": "230401",
      "Aimajatupur BO": "230204",
      "Badgawan BO": "230204",
      "Bainti BO": "230204",
      "Barai BO": "230204",
      "Machheha Herdopatti BO": "230204",
      "Maghi BO": "230204",
      "Majhilgaon BO": "230204",
      "Sujauli BO": "230204",
      "Tajpur BO": "230204",
      "Kanpa BO": "230403",
      "Madhupur BO": "230403",
      "Sadar Bazar BO": "230403",
      "Bachhuwa BO": "230402",
      "Baishpur BO": "230402",
      "Barari BO": "230134",
      "Donai BO": "230134",
      "Gadauri BO": "230134",
      "Rendi Garapur BO": "230135",
      "Sonpura BO": "230121",
      "Bhuidaha BO": "230304",
      "Deogarh Kamasin BO": "230304",
      "Medhauli BO": "230304",
      "Mirzapur BO": "230304",
      "Dhadhuwa Gajan BO": "230136",
      "Handaur BO": "230136",
      "Harakhpur Kotwa BO": "230136",
      "Kotwa Shukulpur BO": "230136",
      "Ramganj BO": "230139",
      "Ranki BO": "230139",
      "Rehuwa Lalganj BO": "230139",
      "Newarhiya BO": "230141",
      "Ping BO": "230141",
      "Ramapur BO": "230141",
      "Rokaiyapur BO": "230141",
      "Ahiyapur BO": "230142",
      "Bijahara BO": "230142",
      "Ishanpur BO": "230142",
      "Shahbari BO": "230503",
      "Atarsand BO": "230401",
      "Sarai Shankar BO": "230401",
      "Bedhan Gopalpur BO": "230204",
      "Jamethi BO": "230204",
      "Khemipur BO": "230204",
      "Laxmaneshwar Nath Dham BO": "230204",
      "Ajhara BO": "230132",
      "Asrahi BO": "230132",
      "Idilpur BO": "230132",
      "Jasmarha BO": "230132",
      "Kumbhapur BO": "230132",
      "Rampur Baoli BO": "230132",
      "Barachha BO": "230403",
      "Hanumanganj BO": "230403",
      "Salhipur BO": "230403",
      "Balikaranganj BO": "230402",
      "Hainshi Parji BO": "230402",
      "Katra Gulab Singh BO": "230402",
      "Sarai Nahar Rai BO": "230402",
      "Pure Dhana BO": "230134",
      "Bahuta BO": "230135",
      "Belarampur BO": "230135",
      "Pandri Mustarka BO": "230135",
      "Pure Ojha BO": "230002",
      "Ramganj Bazar BO": "230121",
      "Bansi BO": "230304",
      "Lachchhipur BO": "230304",
      "Sipah Maheri BO": "230304",
      "Bahuchara BO": "230137",
      "Tejgarh BO": "230137",
      "Labeda BO": "230138",
      "Ami BO": "230139",
      "Benimadho Nagar BO": "230139",
      "Dhangarh BO": "230141",
      "Kamapatti BO": "230141",
      "Jogipur BO": "230142",
      "Bhikhnapur BO": "230404",
      "Sarai Chheolaha BO": "230133",
      "Sarai Madhai BO": "230133",
      "Sandwa Chandika BO": "230503",
      "Basupur BO": "230401",
      "Sarai Rajai BO": "230401",
      "Shahpur BO": "230401",
      "Aindha BO": "230204",
      "Bansiyara BO": "230204",
      "Baswahi BO": "230204",
      "Karenti BO": "230204",
      "Mangarh BO": "230204",
      "Rahwain BO": "230204",
      "Jalesharganj BO": "230132",
      "Khaprahi BO": "230132",
      "Khajuri BO": "230503",
      "Purwara BO": "230132",
      "Ranjitpur Chilbila BO": "230403",
      "Sarai Ganai BO": "230403",
      "Tala BO": "230403",
      "Harakhpur BO": "230402",
      "Kalyanpur BO": "230402",
      "Uri Ka Dih BO": "230402",
      "Gajariya BO": "230134",
      "Lauwar BO": "230134",
      "Sarkhelpur BO": "230134",
      "Barahupur BO": "230135",
      "Muzahi Bazar BO": "230135",
      "Patkhauli BO": "230135",
      "Sarai Mahesh BO": "230135",
      "Teonga BO": "230002",
      "Kilai BO": "230121",
      "Adharganj BO": "230304",
      "Babu Patti BO": "230304",
      "Kushfara BO": "230304",
      "Paharpur BO": "230136",
      "Kataiya BO": "230137",
      "Dhindhui BO": "230138",
      "Baba Ka Gaon BO": "230139",
      "Darra BO": "230139",
      "Bakol BO": "230141",
      "Kushuwapur BO": "230141",
      "Pike Nagar BO": "230142",
      "Kailidih BO": "230306",
      "Molnapur BO": "230124",
      "Parhat Khas BO": "230124",
      "Bhawanipur BO": "230501",
      "Dhaurahra BO": "230124",
      "Dubeypur BO": "230501",
      "Para Hamidpur BO": "230501",
      "Bhawaniganj Kota BO": "230143",
      "Hathigawan BO": "230201",
      "Jahanabad BO": "230201",
      "Kanawan BO": "230201",
      "Kilahanapur BO": "230201",
      "Pandwasi BO": "230144",
      "Rendveer BO": "230144",
      "Sarai Anadeo BO": "230144",
      "Gadhiyawan BO": "230124",
      "Kumbhi Aima BO": "230125",
      "Mangapur BO": "230125",
      "Muraini BO": "230125",
      "Nanauti BO": "230125",
      "Shivpur": "230401",
      "Dulhepur BO": "230144",
      "Pooranpur Khajoor BO": "230144",
      "Aspur Deosara BO": "230124",
      "Kabirpur BO": "230124",
      "Sadaha BO": "230124",
      "Umari BO": "230501",
      "Jariyari BO": "230125",
      "Pure Bhagwat BO": "230125",
      "Pure Noti BO": "230126",
      "Chamrupur BO": "230144",
      "Bhanaipur BO": "230124",
      "Dahi BO": "230124",
      "Pure Dhani BO": "230124",
      "Deori BO": "230125",
      "Rajapur BO": "230125",
      "Udaipur BO": "230125",
      "Gujwar BO": "230143",
      "Purmeisultanpur BO": "230143",
      "Bisahiya BO": "230201",
      "Deeha BO": "230201",
      "Mahmadpur Bhaon BO": "230201",
      "Mohaddinagar BO": "230201",
      "Sakardaha BO": "230201",
      "Umrar BO": "230125",
      "Dakhwapur BO": "230143",
      "Pratappur Chergarh BO": "230143",
      "Bihar BO": "230201",
      "Budhapur BO": "230201",
      "Parsipur BO": "230201",
      "Shekhpur Ashiq BO": "230201",
      "Sarsi BO": "230405",
      "Dhingwas BO": "230128",
      "Maheshganj BO": "230128",
      "Bajha Bheet BO": "230202",
      "Tikuri Dashrathpur BO": "230201",
      "Umari Kotila BO": "230201",
      "Bashirpur BO": "230127",
      "Dandupur Mufrid BO": "230127",
      "Dwarikapur BO": "230127",
      "Kadipur BO": "230127",
      "Pure Roopdhar Kothiyahi BO": "230127",
      "Deokali BO": "230405",
      "Dharauli BO": "230503",
      "Bhikhapur Kanidih BO": "230128",
      "Chitamanpur Patna BO": "230128",
      "Gotani BO": "230202",
      "Jhonkwara BO": "229408",
      "Lat Tara BO": "230202",
      "Radhauli BO": "230202",
      "Kahla BO": "230301",
      "Padwa Nasirpur BO": "230301",
      "Silaundhi BO": "230301",
      "Sultanpur BO": "230301",
      "Misiddipur BO": "230302",
      "Shivgarh Bindaganj BO": "230302",
      "Chakwarh BO": "230129",
      "Kamolibirbhanpur BO": "230129",
      "Tiwaripur BO": "230202",
      "Bhadausi BO": "230502",
      "Dhekahi BO": "230502",
      "Pure Guru BO": "230502",
      "Raibi Rajanipur BO": "230502",
      "Amapur Berra BO": "230301",
      "Bhojemau BO": "230301",
      "Birapur BO": "230302",
      "Baron BO": "230129",
      "Korrahi BO": "230129",
      "Malawan Chhajaipur BO": "230129",
      "Newadi BO": "230129",
      "Shayd Yasinpur BO": "229408",
      "Bahlolpur BO": "230131",
      "Bhupiamau BO": "230131",
      "Kotha Newarhiya BO": "230503",
      "Kondrajit BO": "230129",
      "Lala Bazar BO": "229408",
      "Jahnaipur BO": "230131",
      "Pure Narsingh Bhan BO": "230131",
      "Rajgarh BO": "230131",
      "Rampur Gauri BO": "230131",
      "Gaura Dand BO": "230503",
      "Katehati BO": "230503",
      "Premdhar Patti BO": "230127",
      "Utras BO": "230405",
      "Wari Kalan BO": "230405",
      "Kushaha BO": "230128",
      "Mahrajganj BO": "230128",
      "Ram Nagar BO": "230128",
      "Garhi Samsabad BO": "230202",
      "Sahjani BO": "230202",
      "Biharganj BO": "230502",
      "Pure keshav Rai BO": "230502",
      "Pure Madhosingh BO": "230502",
      "Antari BO": "230301",
      "Dhanuha BO": "230301",
      "Bichhur BO": "230302",
      "Garapur BO": "230302",
      "Samaspur BO": "230201",
      "Siya BO": "230201",
      "Pure Gajai BO": "230128",
      "Raigarh BO": "230128",
      "Rajapur Bindhan BO": "230128",
      "Sarai Indrawat BO": "230128",
      "Gobari BO": "230502",
      "Jagesharganj BO": "230502",
      "Mahamdapur BO": "230502",
      "Upadhyaypur BO": "230502",
      "Kutulitya BO": "230129",
      "Agai BO": "229410",
      "Bhatni BO": "229410",
      "Jewai BO": "229410",
      "Panigo BO": "229408",
      "Chhatarpur BO": "230503",
      "Dhansari BO": "230129",
      "Naubasta BO": "230129",
      "Alapur BO": "229408",
      "Pariyawan BO": "229408",
      "Afim Ki Kothi BO": "230131",
      "Bhadohi BO": "230131",
      "Kithawar BO": "230503",
      "Kolbajhan BO": "230503",
      "Pratapgarh HO": "230001",
      "Bhadri SO": "230201",
      "Bhangwa Ki Chungi SO": "230001",
      "Garhi Manikpur SO": "230202",
      "Jethwara SO": "230129",
      "Kaithola SO": "229410",
      "Katra Medniganj SO": "230131",
      "Kohdaur SO": "230401",
      "M C Ganj SO": "230001",
      "Paltan Bazar SO": "230001",
      "PDCHAURAHA SO": "230121",
      "Sagra SO": "230136",
      "Sahebganj SO": "230137",
      "Sangipur SO": "230139",
      "Suwansa SO": "230306",
      "Amargarh SO Pratapgarh": "230124",
      "Babaganj SO": "230143",
      "Darchhut SO": "230405",
      "Gaura R S SO": "230301",
      "Kishunganj SO": "230503",
      "Kunda": "230204",
      "Madhoganj SO": "230403",
      "Saifabad SO": "230138",
      "Shitlaganj SO": "230142",
      "Vishwanathganj SO": "230404",
      "Ajgara SO": "230144",
      "Antu SO": "230501",
      "Atheha SO": "230125",
      "Derwa SO": "230128",
      "Garwara SO": "230502",
      "Jamtali SO": "230302",
      "Kalakankar SO": "229408",
      "Lalganj": "230132",
      "Mandhata SO": "230402",
      "Railway Colony SO": "230001",
      "Raniganj SO": "230304",
      "Station Road SO": "230001",
      "Babuganj SO": "230126",
      "Dalippur SO Pratapgarh": "230127",
      "Laxmanpur SO": "230130",
      "Oraiyadeeh SO": "230134",
      "Patti": "230135",
      "Pratapgarh City SO": "230002",
      "Sangramgarh SO": "230141",
      "PIRTHIGANJ BAZAR SO": "230133"
    },
    "FATEHPUR": {
      "Dhakauli BO": "212601",
      "Kandhi BO": "212601",
      "Baranpur BO": "212601",
      "Birnai BO": "212631",
      "Teliyani BO": "212601",
      "Shah BO": "212601",
      "Bilandpur BO": "212601",
      "Damapur BO": "212601",
      "Ramwan BO": "212601",
      "Sangaon BO": "212601",
      "Beragarhiwa BO": "212601",
      "Banarsi BO": "212601",
      "Churiyani BO": "212601",
      "Burhwan BO": "212631",
      "Hariharganj BO": "212601",
      "Meoli BO": "212601",
      "Farshi BO": "212651",
      "Naugaon BO": "212654",
      "Ailai BO": "212655",
      "Alampur Giriya BO": "212655",
      "Silmi BO": "212655",
      "Teni BO": "212655",
      "Tesahi Bujurg BO": "212655",
      "Tyonja BO": "212655",
      "Ukathu BO": "212655",
      "Vijaeepur BO": "212655",
      "Deori Bujurg BO": "212657",
      "Digharua BO": "212657",
      "Khotila Sijauli BO": "212657",
      "Missi BO": "212657",
      "Musafa BO": "212657",
      "Naraicha BO": "212657",
      "Selawan BO": "212657",
      "Sultangarh BO": "212657",
      "Gharwasipur BO": "212656",
      "Jahangirnagar Gahura BO": "212656",
      "Jairampur BO": "212656",
      "Kot BO": "212656",
      "Anjana Bhairaon BO": "212658",
      "Beonti BO": "212658",
      "Sarkandi BO": "212658",
      "Kapil Kalan BO": "212659",
      "Padhara BO": "212665",
      "Shadipur BO": "212665",
      "Maujmabad BO": "212651",
      "Mawai BO": "212651",
      "Chitauli BO": "212655",
      "Fatehpur Tekari BO": "212655",
      "Hardon BO": "212655",
      "Kasba Sohan BO": "212655",
      "Katoghan BO": "212655",
      "Bara BO": "212657",
      "Narauli BO": "212658",
      "Paharpur BO": "212658",
      "Raipur Bhasraul BO": "212658",
      "Ajamatpur BO": "212661",
      "Korra Kanak BO": "212661",
      "Ashok Nagar Bharsawan BO": "212664",
      "Bhadba BO": "212664",
      "Dawatpur BO": "212664",
      "Guneer BO": "212664",
      "Kalyanpur BO": "212664",
      "Kotiya BO": "212664",
      "Rari Bujurg BO": "212664",
      "Tarapur BO": "212664",
      "Sarai Shahjada BO": "212664",
      "Abhaipur BO": "212665",
      "Aung BO": "212665",
      "Gugauli BO": "212665",
      "Sheorajpur BO": "212665",
      "Ahewa BO": "212651",
      "Chitishapur BO": "212651",
      "Kishandaspur BO": "212654",
      "Amaon BO": "212655",
      "Bhakharana BO": "212655",
      "Kumbhipur BO": "212655",
      "Purain BO": "212655",
      "Basant Khera BO": "212657",
      "Bijauli BO": "212657",
      "Deomai BO": "212657",
      "Jafarganj BO": "212657",
      "Arhaiya BO": "212656",
      "Dendasai BO": "212656",
      "Kulli BO": "212656",
      "Chandapur BO": "212658",
      "Garha BO": "212658",
      "Sarauli BO": "212658",
      "Banthara BO": "212659",
      "Arhawal BO": "212661",
      "Mahana BO": "212661",
      "Rewari Bujurg BO": "212664",
      "Korsam BO": "212665",
      "Mirai BO": "212665",
      "Chandpur BO": "212631",
      "Dapsaura BO": "212631",
      "Dayalnagar BO": "212631",
      "Dhamina Khurd BO": "212631",
      "Kandhiya BO": "212620",
      "Kaundar BO": "212620",
      "Manawan BO": "212620",
      "Ram Nagar Kauhan BO": "212620",
      "Rithwan Bhairwan BO": "212620",
      "Aurai BO": "212622",
      "Ghoori Bujurg BO": "212622",
      "Malaon BO": "212622",
      "Manda Sarai BO": "212622",
      "Datauli BO": "212663",
      "Hasaupur BO": "212650",
      "Karmon BO": "212650",
      "Nizamuddinpur BO": "212650",
      "Salempur BO": "212650",
      "Bamharauli BO": "212641",
      "Belain BO": "212641",
      "Devrar BO": "212641",
      "Kharsendwa BO": "212641",
      "Afoi BO": "212653",
      "Allipur BO": "212653",
      "Baigaon BO": "212653",
      "Ijura Bujurg BO": "212653",
      "Sarkee BO": "212621",
      "Shankha BO": "212621",
      "Suketi BO": "212621",
      "BHITAURA BO": "212601",
      "Kaunh BO": "212631",
      "Rithwa Awajipur BO": "212631",
      "Salhepur BO": "212631",
      "Ainjhi BO": "212620",
      "Jarauli BO": "212620",
      "Naraini BO": "212622",
      "Muttaur BO": "212663",
      "Sidhaon BO": "212663",
      "Tapani BO": "212663",
      "Jonihan BO": "212635",
      "Khunta BO": "212635",
      "Lalpur BO": "212635",
      "Mahraha BO": "212635",
      "Chhichhni BO": "212621",
      "Deolan BO": "212621",
      "Gambhari BO": "212621",
      "Khesahan BO": "212621",
      "Asani BO": "212651",
      "Baswa BO": "212655",
      "Budwan BO": "212655",
      "Kharai BO": "212655",
      "Pauli BO": "212655",
      "Bakewar Sarai BO": "212657",
      "Barigawan BO": "212657",
      "Bhaisauli BO": "212657",
      "Bijuri BO": "212657",
      "Baraipur BO": "212656",
      "Saidpur Pachmai BO": "212656",
      "Sothrapur BO": "212656",
      "Ekdala BO": "212658",
      "Malookbari BO": "212658",
      "Rari BO": "212658",
      "Alampur BO": "212659",
      "Gauri BO": "212661",
      "Mahakhera BO": "212661",
      "Chakhendi BO": "212664",
      "Khadra BO": "212665",
      "Madokipur BO": "212665",
      "Umari BO": "212601",
      "Korai BO": "212601",
      "Gauri Aura BO": "212631",
      "Makarandpur BO": "212631",
      "Badanpur B.O": "212631",
      "Andipur BO": "212620",
      "Berui BO": "212620",
      "Tikar BO": "212620",
      "Dharmpur Saton BO": "212622",
      "Muraon BO": "212622",
      "Thariyaon BO": "212622",
      "Ladigaon BO": "212663",
      "Saibasi BO": "212663",
      "Chhichha BO": "212635",
      "Jafrabad BO": "212635",
      "Mandraon BO": "212635",
      "Amilihapal BO": "212650",
      "Arhauli BO": "212641",
      "Jam BO": "212641",
      "Narsinghpur Kabraha BO": "212641",
      "Mandwan BO": "212653",
      "Budhramau BO": "212621",
      "Kusumbhi BO": "212621",
      "Laugaon BO": "212621",
      "Pamrauli BO": "212621",
      "Gaura BO": "212631",
      "Gohrari BO": "212631",
      "Berraon BO": "212620",
      "Chak Korra Sadat BO": "212622",
      "Khas Mau BO": "212622",
      "Sahjahanpur Selraha BO": "212622",
      "Sawant BO": "212622",
      "Baragaon BO": "212663",
      "Chakas Karan BO": "212663",
      "Dugrai BO": "212663",
      "Alamganj BO": "212635",
      "Deegh BO": "212635",
      "Gaura Bujurg BO": "212650",
      "Yauhan BO": "212650",
      "Ahmadpur Kusumbha BO": "212641",
      "Dampur BO": "212641",
      "Kalyanpur Kachrauli BO": "212641",
      "Pallawan BO": "212641",
      "MPGaunti BO": "212653",
      "Sultanpurghosh BO": "212653",
      "Lamehata BO": "212621",
      "Mawaiya BO": "212621",
      "Paina Khurd BO": "212621",
      "Sewramau BO": "212621",
      "Ayah BO": "212601",
      "Bilanda BO": "212645",
      "Bandipur BO": "212652",
      "Patti BO": "212652",
      "Semramanapur BO": "212652",
      "Sithaura BO": "212652",
      "Lateefpur BO": "212645",
      "Mahoi BO": "212645",
      "KKasimpur BO": "212652",
      "Kaseruwa BO": "212652",
      "Mohamdabad BO": "212652",
      "Paigamberpur BO": "212652",
      "Itaily BO": "212652",
      "Raipur Muwari BO": "212652",
      "Saraisaba BO": "212652",
      "Shahpur BO": "212652",
      "Fatehpur HO": "212601",
      "Asother SO": "212620",
      "Erayan SO": "212653",
      "Fatehpur City SO": "212601",
      "Fatehpur Town SO": "212601",
      "Khaga SO": "212655",
      "Khajuha SO": "212657",
      "Khakhreru SO": "212656",
      "Chandiyana SO": "212601",
      "Chheolaha SO": "212650",
      "Ghazipur SO Fatehpur": "212621",
      "Khaga Town SO": "212655",
      "Lalauli SO": "212661",
      "Malwan Town SO": "212664",
      "Bindki SO": "212635",
      "Fatehpur Court SO": "212601",
      "Haswa SO": "212645",
      "Hathgaon SO": "212652",
      "Husainganj SO Fatehpur": "212651",
      "Jamraon SO": "212654",
      "Kishanpur SO Fatehpur": "212658",
      "Kora Jahanabad SO": "212659",
      "Amauli SO": "212631",
      "Bahrampur SO": "212622",
      "Bahua SO": "212663",
      "Dhata SO": "212641",
      "Malwan RS SO": "212664",
      "Mauhar SO": "212665",
      "Purani Bindki SO": "212635"
    },
    "MAU": {
      "Jogari BO": "275306",
      "Hathini BO": "275102",
      "Itaura Dori Pur BO": "275305",
      "Mohammadpur Math BO": "275102",
      "Dhawariya Sath BO": "275305",
      "Mirpur Rahimabad BO": "275306",
      "Ali Nagar BO": "275102",
      "Tajopur BO": "275305",
      "Undura BO": "221603",
      "Kathtaraon BO": "221602",
      "Lakhnaur BO": "221602",
      "Nemdand BO": "221602",
      "Rampur BO": "221602",
      "Allauddinpur BO": "276403",
      "Amarhar BO": "276403",
      "Ranipur BO": "276403",
      "Golauri BO": "221706",
      "Kanso BO": "221706",
      "Meuri BO": "221706",
      "Mustafa Bad BO": "221706",
      "Pindohari BO": "221706",
      "Dholana BO": "276405",
      "Bhela Bandh BO": "275305",
      "Faizullahpur BO": "275305",
      "Kurthi Zafar Pur BO": "275305",
      "Badua Godam BO": "275305",
      "Khiriya BO": "275103",
      "Bagali Pijra BO": "275103",
      "Salahabad BO": "275103",
      "Jajaauli BO": "221603",
      "Katghar Shankar BO": "221603",
      "Lalanpur BO": "221603",
      "Daulasepur BO": "276403",
      "Kanjhakhurd BO": "276403",
      "Khurhar BO": "276403",
      "Kolaura BO": "276403",
      "Makhuni BO": "276403",
      "Pali Garh BO": "276403",
      "Palia BO": "276403",
      "Lalitpur BO": "275307",
      "Majhwara BO": "275307",
      "Makhmelpur BO": "275307",
      "Moongmas BO": "275307",
      "Mohammadpur Hasanpur BO": "276306",
      "Rasoolpur BO": "276306",
      "Sikari Kot BO": "276306",
      "Bara BO": "276405",
      "Bhadir BO": "276405",
      "Baundih BO": "221603",
      "Fatehpur Talratoy BO": "221603",
      "Saundih BO": "221603",
      "Siddha Ahilashpur BO": "221603",
      "Belauli BO": "221602",
      "Halima Bad BO": "276403",
      "Surahu Pur BO": "276403",
      "Raini BO": "276403",
      "Khairabad BO": "276403",
      "Ailakhaimilia BO": "221706",
      "Belaujha BO": "221706",
      "Semrajpur BO": "221706",
      "Bela Sultanpur BO": "275307",
      "Pawani BO": "275307",
      "Bibi Pur BO": "276306",
      "Kuranga BO": "276306",
      "Dhaur Hara BO": "276405",
      "Hardas Pur BO": "275305",
      "Kasara BO": "275102",
      "Saharoj BO": "275305",
      "Baktawar Ganj BO": "275305",
      "Piparidih BO": "275103",
      "Raikwardeeh BO": "275103",
      "Banpokhara BO": "221603",
      "Bhairopur BO": "221603",
      "Nathupur BO": "221603",
      "Sipaibrahima Bad BO": "221603",
      "Bahadurpur BO": "221602",
      "Kamalsagar BO": "221602",
      "Bandikala BO": "276403",
      "Utarizpur BO": "276403",
      "Ataraul Pandey BO": "221706",
      "Chhichore BO": "221706",
      "Nasira Bad Kala BO": "221706",
      "Sidhwal BO": "221706",
      "Lakhani Mubarakpur BO": "275307",
      "Parsupur BO": "275307",
      "Bela Kasaila BO": "276306",
      "Dargah BO": "276306",
      "Misarauli BO": "276129",
      "Dewal Ashram BO": "276405",
      "Bada Gaon BO": "276403",
      "Rampur Sohand BO": "275301",
      "Fateh Pur Tal Naraja BO": "275302",
      "Bhagwat BO": "276129",
      "Bramhanpur BO": "276129",
      "Daulatabad BO": "276129",
      "Canal Head BO": "275303",
      "Gotha BO": "275303",
      "Mohammadabad Sipah BO": "275303",
      "Bariyadih BO": "221601",
      "Dhrampur Bisnupur BO": "221601",
      "Molnapur BO": "221601",
      "Manik Pur Haraura BO": "275304",
      "Pakari Bujurg BO": "275304",
      "Sultan Pur BO": "275304",
      "Saravan BO": "221705",
      "Gokulpura BO": "276402",
      "Kekai Hindola BO": "276402",
      "Sulatanipur BO": "276402",
      "SAUSARWA BO": "276402",
      "Kamarawa BO": "276129",
      "Sachui BO": "276129",
      "Sarauda BO": "276129",
      "Ardauna BO": "221705",
      "Chakara BO": "221705",
      "Talai Pur BO": "221705",
      "Umapur BO": "221705",
      "Adari BO": "275102",
      "Pidhwal BO": "275105",
      "Sarai Ganesh BO": "275105",
      "Fatehpur BO": "276402",
      "Yakubpur BO": "276402",
      "Piwatal BO": "275301",
      "Usari Khurd BO": "275301",
      "Hamid Pur BO": "275302",
      "Vijra Pura BO": "275302",
      "Barahalaganj BO": "276129",
      "Chhapara BO": "276129",
      "Jigar Sandi BO": "276129",
      "Sherpur BO": "276129",
      "Nai Bazar BO": "275303",
      "Gagaupur BO": "221601",
      "Parasia BO": "221601",
      "Jamdih BO": "275304",
      "Gahani BO": "221705",
      "Kirath Sarai BO": "221705",
      "Pardaha BO": "221705",
      "Dumraon BO": "221705",
      "Inderpur Bhalya BO": "221705",
      "Ariyaso BO": "275105",
      "Kari Sath BO": "275105",
      "Maur Bojh BO": "275105",
      "Padari BO": "276402",
      "Parasi BO": "276402",
      "Dangauli BO": "275306",
      "Bhatmila BO": "275301",
      "Bojhi Bazar BO": "275301",
      "Taktewarampur BO": "275301",
      "Iraura Chaubey Pur BO": "275302",
      "Narawa Sarai BO": "275302",
      "Kajha BO": "276129",
      "Karami BO": "276129",
      "Mande BO": "276129",
      "Rasepur BO": "276129",
      "Panail BO": "275303",
      "Gajiyapur BO": "221601",
      "Ahamadpur Asana BO": "275304",
      "Gahana BO": "221705",
      "Badraon BO": "275301",
      "Pahasa BO": "221705",
      "Kalyanpur BO": "275105",
      "Lilari Bharauli BO": "275105",
      "Nagpur BO": "276402",
      "Rajapur BO": "276402",
      "Bandi Ghat BO": "275306",
      "Kahinaur BO": "275101",
      "Hemai BO": "275301",
      "Piruth Singhpur BO": "275301",
      "Katirahi Bugurg BO": "275301",
      "Pilsui BO": "275301",
      "Sutarahi BO": "276406",
      "Mau HO": "275101",
      "HALDHARPUR SO": "221705",
      "JAMALMIRZAPUR SO": "275105",
      "KOIRIYAPAR SO": "275306",
      "Bhopaura SO": "275302",
      "DUBARI SO": "221601",
      "GHOSI SO": "275304",
      "Chiraia Kot SO": "276129",
      "KOPAGANJ SO": "275305",
      "Kushmaur SO": "275103",
      "Mau Town SO": "275101",
      "Mohammadabad Gohna SO": "276403",
      "Mau RS SO": "275101",
      "Ratan Pura SO": "221706",
      "Semari Jamal Pur SO": "275307",
      "Walid Pur SO": "276405",
      "Amila SO": "275301",
      "Dohari  Ghat SO": "275303",
      "INDARA": "275102",
      "KARAHA SO": "276402",
      "Madhu Ban SO": "221603",
      "MARYADPUR SO": "221602",
      "Mirjahadipura Chowk SO": "275101",
      "Mohammadabad Gohana Chowk SO": "276403",
      "Suraj Pur SO": "276306"
    },
    "BAHRAICH": {
      "Khasha MohdPur BO": "271825",
      "Lakkha Baundi BO": "271825",
      "Murauwa BO": "271825",
      "Gopchandpur BO": "271825",
      "Hardi BO": "271825",
      "Rampurwa BO": "271825",
      "Gadamar Kuurd BO": "271825",
      "Newada BO": "271830",
      "Pipri BO": "271825",
      "Bhabnoti Shankarpur BO": "271825",
      "Fatehpurwapur BO": "271825",
      "Sisaiya Chunamani BO": "271825",
      "Tandwabasantpur BO": "271825",
      "Gangwal BO": "271821",
      "Sablapur BO": "271825",
      "Ganga Jamuni BO": "271821",
      "Kakri BO": "271865",
      "Kotwa BO": "271865",
      "Puraina Bhawani Bux BO": "271865",
      "Sarra Maundri BO": "271865",
      "Sarraiya BO": "271865",
      "Payagpur Bus Station BO": "271871",
      "Ramnagar Khajuri BO": "271871",
      "Semariyawan BO": "271871",
      "Begampur BO": "271875",
      "Dandey Kuinya BO": "271875",
      "Deorania BO": "271875",
      "Dharmanpur BO": "271875",
      "Patna Ghesiyari BO": "271875",
      "Shankarpur BO": "271875",
      "Babaganj BO": "271881",
      "Banjaria BO": "271865",
      "Boundi BO": "271830",
      "Laluhi BO": "271830",
      "Patrahiya BO": "271830",
      "Rampur Dhobia BO": "271830",
      "Khanpur Mallah BO": "271821",
      "Khariha BO": "271821",
      "Lakkharampur BO": "271821",
      "Parsia BO": "271870",
      "Piparia Mahipal Singh BO": "271870",
      "Sarsa BO": "271806",
      "Balchandpur BO": "271902",
      "Bamiyari BO": "271902",
      "Baundi BO": "271902",
      "Bhilora Basu BO": "271902",
      "Khapurwa BO": "271902",
      "Kundaspara BO": "271902",
      "Madhavpur BO": "271902",
      "Maila Saraiya BO": "271902",
      "Bhaggarwa BO": "271872",
      "Bhangha BO": "271872",
      "Gujra BO": "271872",
      "Haiveriya BO": "271872",
      "Meerpur Koniya BO": "271872",
      "Newasi BO": "271872",
      "Kandaila Khas BO": "271904",
      "Badrauli BO": "271903",
      "Birahimpur BO": "271903",
      "Gandara BO": "271903",
      "Goraihia BO": "271903",
      "Kundasar BO": "271903",
      "Maholi BO": "271903",
      "Sutauli BO": "271903",
      "Umari BO": "271903",
      "Aliabulbul BO": "271802",
      "Bahraich RS BO": "271802",
      "Chandarkha Bujurga BO": "271802",
      "Diha BO": "271802",
      "Ambarpur BO": "271851",
      "Bakaina Bazar BO": "271851",
      "Khaira Dhaukal BO": "271851",
      "Kishunpur Meetha BO": "271851",
      "Raipur BO": "271875",
      "Rajapur Kalan BO": "271851",
      "Shankarpur Laxmanpur BO": "271851",
      "Vanshpurwa BO": "271851",
      "Sikandarpur BO": "271824",
      "Bhaukhara BO": "271882",
      "Bhopatpur BO": "271882",
      "Bulbul Newaj BO": "271882",
      "Intaha BO": "271882",
      "Majhara BO": "271855",
      "Nausurgumtiha BO": "271855",
      "Nisangora BO": "271855",
      "Lakhai Kalan BO": "271865",
      "Mansoor Nagar BO": "271865",
      "Rajapur Kala BO": "271865",
      "Ram Nagar Semara BO": "271865",
      "Tiwari Gaon BO": "271865",
      "Ailo BO": "271871",
      "Basanera BO": "271871",
      "Dhauli BO": "271871",
      "Farda Sumerpur BO": "271806",
      "Gotutti BO": "271875",
      "Devra BO": "271881",
      "Madhavpur Nidaona BO": "271881",
      "Prahalad Gaon BO": "271881",
      "Baibahi BO": "271830",
      "Baldoopurwa BO": "271830",
      "Bardaha BO": "271830",
      "Bitania BO": "271830",
      "Chahalwa BO": "271841",
      "Karikot BO": "271841",
      "Shivpur Bairagi BO": "271821",
      "Ailiha BO": "271870",
      "Belwa Padum BO": "271806",
      "Katghara Kala BO": "271870",
      "Kaudha BO": "271902",
      "Shukulpurwa BO": "271902",
      "Tendwa Mahant BO": "271902",
      "Chafaria Bazar BO": "271841",
      "Barkharia BO": "271841",
      "Kandra BO": "271872",
      "Narounda BO": "271872",
      "Patupur BO": "271872",
      "Jataura BO": "271901",
      "Mustafabad BO": "271904",
      "Chaukgoi BO": "271802",
      "Mohammad Nagar BO": "271802",
      "Reoli BO": "271802",
      "Shekhdahir BO": "271802",
      "Tulsipur BO": "271802",
      "Maikupurwa BO": "271851",
      "Matera Kalan BO": "271851",
      "Mahsi BO": "271824",
      "Pandri Tara BO": "271882",
      "Dharampur BO": "271855",
      "Dharmapur BO": "271855",
      "Gangapur BO": "271855",
      "Gaurapipra BO": "271855",
      "Kakraha BO": "271855",
      "Kundwa BO": "271855",
      "Lohiya Nagar BO": "271855",
      "Madhwapur BO": "271855",
      "Petraha BO": "271855",
      "Pratappur Jungal Matera BO": "271855",
      "Handa Basehri BO": "271865",
      "Nawab Ganj Alia Bad BO": "271865",
      "Rahmatogaon BO": "271865",
      "Umaria BO": "271865",
      "Kashijot BO": "271871",
      "Lalpur BO": "271806",
      "Mankapur Kala BO": "271871",
      "Shivdaha BO": "271871",
      "Balbhaddrapur BO": "271875",
      "Dihwa BO": "271875",
      "Hardutt Nagar BO": "271875",
      "Soharwa BO": "271875",
      "Charda BO": "271881",
      "Jalalpur BO": "271881",
      "Makanpur BO": "271881",
      "Basantapur BO": "271872",
      "Bichhiya BO": "271841",
      "Sujauli BO": "271841",
      "Jamunaha Bhawania Pur BO": "271865",
      "Manwaria Diwan BO": "271865",
      "Pargahawa BO": "271865",
      "Raibojha BO": "271865",
      "Kot Bazar BO": "271871",
      "Laukahi BO": "271871",
      "Tallab Baghel BO": "271871",
      "Karanpur BO": "271875",
      "Kewalpur BO": "271851",
      "Bhawaniapur BO": "271830",
      "Khaira Kala BO": "271830",
      "Manikpur BO": "271830",
      "Raiganj BO": "271830",
      "Sohbatia BO": "271830",
      "Kursaha BO": "271821",
      "Puraina BO": "271821",
      "Sohariyawan BO": "271821",
      "Hariharpur BO": "271870",
      "Satpediya BO": "271806",
      "Dahaura BO": "271902",
      "Gureharipur BO": "271902",
      "Nandwal BO": "271902",
      "Ramgarhi BO": "271902",
      "Sarai Jagna BO": "271902",
      "Jagtapur BO": "271872",
      "Bhartha BO": "271901",
      "Rani Ganj BO": "271904",
      "Mahuri Kala BO": "271904",
      "Devlakha BO": "271903",
      "Katka Bhagatpurwa BO": "271903",
      "Naugoiyan BO": "271903",
      "Payrepur BO": "271903",
      "Chittuara BO": "271802",
      "Jhingha Road BO": "271802",
      "Metkaha BO": "271802",
      "Turahni Rajjab BO": "271802",
      "Churaipurwa BO": "271851",
      "Garethi Gurudutt Singh BO": "271851",
      "Mukeria BO": "271851",
      "Nautala BO": "271851",
      "Sadhuwapur BO": "271824",
      "Amwa Molvi BO": "271882",
      "Moharba BO": "271882",
      "Balai Goan BO": "271855",
      "Belhan BO": "271855",
      "Gopia BO": "271855",
      "Mangouriha BO": "271855",
      "Motipur BO": "271855",
      "Murtiha BO": "271855",
      "Nidhipurwa BO": "271855",
      "Raniapur Gobrahi BO": "271821",
      "Chakujot BO": "271870",
      "Imilia BO": "271870",
      "Babkapur BO": "271902",
      "Gajadharpur BO": "271902",
      "Jaitapur BO": "271902",
      "Khairabazar BO": "271902",
      "Mundki BO": "271902",
      "Raipura BO": "271902",
      "Katraniaghat BO": "271841",
      "Fakirpuri BO": "271841",
      "Jiganiamahipal BO": "271872",
      "Parwani Gauri BO": "271855",
      "Khanpur BO": "271872",
      "Singhpur BO": "271872",
      "Badhauli BO": "271904",
      "Tappe Sipah BO": "271901",
      "Harchanda BO": "271904",
      "Arai Umari BO": "271904",
      "Babhnanpurwa BO": "271903",
      "Majhara Taukali BO": "271903",
      "Parsendi BO": "271903",
      "Vairi Maheshpur BO": "271903",
      "Chaukharia BO": "271802",
      "Dargah BO": "271802",
      "Katra Bahadurpur BO": "271802",
      "Chok Sahar BO": "271851",
      "Naruttampur BO": "271851",
      "Pachdevri BO": "271851",
      "Kapoorpur BO": "271824",
      "Rehuwa Mansoor BO": "271824",
      "Aswa Mohammad Pur BO": "271882",
      "Maina Newaria BO": "271882",
      "Pakara Deoria BO": "271882",
      "Balsinghpur BO": "271855",
      "Daulatpur BO": "271855",
      "Goorh BO": "271855",
      "Harkhapur BO": "271855",
      "Matehi BO": "271855",
      "Nainiha BO": "271855",
      "Sangwa BO": "271855",
      "Chamarpurwa BO": "271865",
      "Dhannigaon BO": "271865",
      "Girdharpur BO": "271865",
      "Gurghutta BO": "271865",
      "Bahraich HO": "271801",
      "Argorwa BO": "271865",
      "Balha BO": "271865",
      "Bankashi BO": "271865",
      "Botania BO": "271865",
      "Saraa Kalan BO": "271855",
      "Amwa Pokhar BO": "271865",
      "Gaighat BO": "271865",
      "Govindpur Pandit BO": "271865",
      "Semari Bazar BO": "271855",
      "Shahpur Kalan BO": "271855",
      "Urra Bazar BO": "271855",
      "Chandanpur K Pur BO": "271865",
      "Chhwani Bazar SO": "271801",
      "Chilwaria SO": "271870",
      "Kalpipara SO": "271802",
      "Mihinpurwa SO": "271855",
      "Rupaidiha SO": "271881",
      "Barnapur SO": "271825",
      "Bisheswarganj SO": "271821",
      "Girijapuri Coloney SO": "271841",
      "Gudari Bazar SO": "271801",
      "Jarwal SO": "271904",
      "Kaiserganj SO": "271903",
      "Mahsi Tahsil SO": "271824",
      "Payagpur SO": "271871",
      "Qanoongopura SO": "271801",
      "Shivpur SO Bahraich": "271830",
      "Khutehna Chauraha SO": "271806",
      "Bahraich City SO": "271801",
      "Fakharpur SO": "271902",
      "Huzoorpur SO": "271872",
      "Jarwal Road SO": "271901",
      "Kharighat SO": "271851",
      "Matera RS SO": "271882",
      "Nanpara SO": "271865",
      "Risia SO": "271875"
    },
    "JAUNPUR": {
      "Bhagwanpur BO": "230133",
      "Gokha BO": "222127",
      "Jamua BO": "222127",
      "Mujar BO": "222127",
      "Bangaonpatti BO": "222125",
      "Khujhidih BO": "222201",
      "Kushmaul BO": "222201",
      "Sultanpur BO": "222201",
      "Unchgaon BO": "223102",
      "Belaunakala BO": "222162",
      "Gothaon BO": "222162",
      "Gaddopur BO": "222170",
      "Jamaupatti BO": "222125",
      "Medha BO": "222125",
      "Muradpur BO": "222125",
      "Shahpur BO": "222131",
      "Tiara BO": "222125",
      "Udpur Ghelhawa BO": "222125",
      "Bhilampur BO": "222201",
      "Ghuripur BO": "222201",
      "Saraibhogi BO": "222201",
      "Barhata BO": "222144",
      "Gonapar BO": "222144",
      "Itaha BO": "222144",
      "Katahit BO": "222144",
      "Sonahita BO": "222144",
      "Manapur BO": "222162",
      "Sarsara BO": "222162",
      "Nonari BO": "222128",
      "Aara BO": "222133",
      "Shahopatti BO": "222127",
      "Kuhi Kalan BO": "222125",
      "Mirsahdpur BO": "222125",
      "Newada Mukhalispur BO": "222125",
      "Sarai Durgadas BO": "222126",
      "Umari BO": "222133",
      "Alaiya BO": "222201",
      "Neoraha BO": "222201",
      "Malai BO": "222162",
      "Mangara BO": "222162",
      "Nigoh BO": "222162",
      "Pariyat BO": "222162",
      "Sotipur BO": "222162",
      "Baneora BO": "222128",
      "Lagdharpur BO": "222128",
      "Tarati BO": "222128",
      "Balrampur BO": "222129",
      "Biri BO": "222129",
      "Dhirajpur BO": "222132",
      "Kuwarda BO": "222132",
      "Bhawaniganj BO": "222128",
      "Budhhipur BO": "222128",
      "Dhanethu BO": "222128",
      "Khetapur BO": "222128",
      "Argupur Kala BO": "223103",
      "Chitako BO": "222129",
      "Gobara BO": "222129",
      "Hariharpur BO": "222203",
      "Hisampur BO": "222129",
      "Masida BO": "222132",
      "Shambhuganj BO": "222132",
      "Baghendra BO": "222133",
      "Koraur BO": "212401",
      "Kanuani BO": "222146",
      "Brahmanpur BO": "222142",
      "Bami BO": "222143",
      "Bhatewra Kathar BO": "212401",
      "Lapari BO": "222139",
      "Parakamal BO": "222139",
      "Potaria BO": "222139",
      "Anguli BO": "223104",
      "Bhagmalpur BO": "223104",
      "Dihiya BO": "223104",
      "Manikala BO": "222139",
      "Marhat BO": "223104",
      "Sauraia BO": "223104",
      "Majhgawan BO": "222146",
      "Kanhabanshipur BO": "222127",
      "Nizamuddinpur BO": "222127",
      "Dhema BO": "222125",
      "Meerapur Kewal BO": "222126",
      "Pyareypur Bijhawat BO": "222126",
      "Belwar BO": "222201",
      "Premkapura BO": "222201",
      "Rampur Kundaha BO": "222201",
      "Alamganj BO": "222162",
      "Bhannaur BO": "222162",
      "Gaurapatti BO": "222162",
      "Kusa BO": "222162",
      "Paltupur BO": "222162",
      "Pilkathua BO": "222162",
      "Latifpur BO": "223103",
      "Bhaisa BO": "222129",
      "Chandepur BO": "222129",
      "Madhi BO": "222129",
      "Patrahi BO": "222129",
      "Kohara Sultanpur BO": "222132",
      "Ghanshyampur Jaunpur BO": "223104",
      "Kishundaspur BO": "212401",
      "Panauli BO": "223104",
      "Ranipur BO": "223104",
      "Haripur BO": "222146",
      "Kheosipur BO": "222146",
      "Koilari BO": "222148",
      "Ranimau BO": "222139",
      "Songar BO": "222139",
      "Gajendrapur BO": "223104",
      "Gauspur BO": "223104",
      "Gopalapur BO": "222137",
      "Narauli BO": "223104",
      "Pilkichha BO": "223104",
      "Mai BO": "222146",
      "Oina BO": "222146",
      "Senapur BO": "222148",
      "Verdiha BO": "222148",
      "Damarua BO": "222135",
      "Asbaranpur BO": "222136",
      "Dewapar BO": "222136",
      "Dharaon BO": "222136",
      "Kusia BO": "222136",
      "Lahangpur BO": "222136",
      "Purev BO": "222136",
      "Rajepur BO": "222136",
      "Trilochan Badagaon BO": "222136",
      "Shitla Chaukiya BO": "222002",
      "Gopipur BO": "222138",
      "Kusaila BO": "222142",
      "Pesara BO": "222142",
      "Sarauni BO": "222142",
      "Japtapur BO": "222139",
      "Kalapur BO": "222139",
      "Khodauli BO": "222139",
      "Mustafabad BO": "222143",
      "Karaura BO": "222143",
      "Khajurahat BO": "222143",
      "Kotwa BO": "222143",
      "Mathura BO": "222143",
      "Belawa Bazar BO": "222161",
      "Belgahan BO": "222161",
      "Bujurga BO": "222161",
      "Chorari BO": "222161",
      "Mainpur BO": "222161",
      "Mithepar BO": "222161",
      "Mokalpur BO": "222161",
      "Ramnagar Vidhmauwa BO": "222161",
      "Seur BO": "222161",
      "Bhiduna BO": "222165",
      "Karobankat BO": "222165",
      "Kaserawa BO": "222165",
      "Katwar BO": "222165",
      "Vijayeepur BO": "222170",
      "Batnahit BO": "222202",
      "Dariaoganj BO": "222109",
      "Garhabaghrai BO": "222109",
      "Leduka BO": "222109",
      "Sadanpur BO": "222109",
      "Basauli BO": "223102",
      "Ishapur BO": "223102",
      "Pataila BO": "223102",
      "Samodhpur BO": "223102",
      "Garaila BO": "222003",
      "Hindi Baghaila BO": "222003",
      "ITISiddikpur BO": "222003",
      "Jamuhai BO": "222003",
      "Auraila BO": "222105",
      "Adiar BO": "222203",
      "Banidih BO": "222203",
      "Bhanpur BO": "222203",
      "Bharathipur BO": "222203",
      "Bhiura BO": "222203",
      "Prithvipur BO": "222203",
      "Khunsapur BO": "222141",
      "Gairwah BO": "223103",
      "Gurbari BO": "223103",
      "Patti Chakesar BO": "223103",
      "Bakuchi BO": "223101",
      "Chhatai Kala BO": "223101",
      "Khapraha BO": "222131",
      "Rithi BO": "222131",
      "Gonauli BO": "222175",
      "Tilora BO": "222143",
      "Kolhua BO": "222145",
      "Lohinda BO": "222145",
      "Mitawa BO": "222145",
      "Rajapur BO": "222145",
      "Jiaramau BO": "222161",
      "Sudanipur BO": "222161",
      "Sirauli BO": "222165",
      "Amara BO": "222170",
      "Murara BO": "222170",
      "Pawara BO": "222202",
      "Raipur BO": "222202",
      "Rajjupur BO": "222202",
      "Ramnagar BO": "223105",
      "Barpur BO": "222109",
      "Kilhapur BO": "222204",
      "Tikara BO": "222204",
      "Unchdih BO": "222204",
      "Pathana BO": "222003",
      "Rampur Baijapur BO": "222003",
      "Saidpur Garaur BO": "222003",
      "Saraikhwaja BO": "222003",
      "Kuddupur BO": "222105",
      "Madarpur BO": "222105",
      "Wazidpur BO": "222203",
      "Agraura BO": "222141",
      "Pokhara BO": "222149",
      "Taraon BO": "222149",
      "Sabarhad BO": "223101",
      "Suris BO": "223101",
      "Sarijahangirpatti BO": "223105",
      "Ahmadpur BO": "222180",
      "Bibipur BO": "222180",
      "Imalo BO": "222180",
      "Kumarpatti BO": "222175",
      "Nakahara BO": "222175",
      "Gangauli BO": "223105",
      "Kammarpur BO": "223105",
      "Barain BO": "222181",
      "Ratnupur BO": "222181",
      "Sohani BO": "222181",
      "Zamaitha BO": "222180",
      "Bhadeora BO": "222133",
      "Dubepur BO": "222136",
      "Gutwan BO": "222136",
      "Sehmalpur BO": "222136",
      "Sukhlalganj BO": "222137",
      "Tejgarh BO": "222137",
      "Harbaspur BO": "222002",
      "Jagdishpur BO": "222002",
      "Kalichabad BO": "222002",
      "Kirtapur BO": "222002",
      "Amahit BO": "222142",
      "Belhari BO": "222142",
      "Deduana BO": "222142",
      "Narhan BO": "222142",
      "Pasewa BO": "222142",
      "Arand BO": "222139",
      "Chorsand BO": "222133",
      "Pilikhini BO": "222133",
      "Mehandi BO": "222135",
      "Sieura BO": "222135",
      "Bakarabad BO": "222136",
      "Bishunpur Majhwara BO": "222136",
      "Nahora BO": "222136",
      "Newada BO": "222136",
      "Chhangapur BO": "222137",
      "Dharmapur BO": "222002",
      "Muradganj BO": "222002",
      "Purani Bazar BO": "222002",
      "Pariyawan BO": "222138",
      "Deokali BO": "222142",
      "Jaigopalganj BO": "222142",
      "Guraini BO": "222139",
      "Jamdahan BO": "222139",
      "Barawan BO": "222143",
      "Bhikhpur Kala BO": "222143",
      "Barji BO": "222145",
      "Gareriha BO": "222145",
      "Shankarganj BO": "222145",
      "Shekhpur Khutahani BO": "222145",
      "Ajoshi BO": "222161",
      "Itaye BO": "222161",
      "Kishunpur BO": "222161",
      "Shitalganj BO": "222161",
      "Babhaniyaw BO": "222165",
      "Bhathar BO": "222165",
      "Mahuari BO": "222165",
      "Manikapur BO": "222165",
      "Beerampur BO": "222170",
      "Belaon BO": "222170",
      "Kudda BO": "222170",
      "Dan BO": "222202",
      "Madhupur BO": "222202",
      "Ukani BO": "222202",
      "Birbhanpur BO": "222109",
      "Dakkhinpatti Ranno BO": "222109",
      "Saderi BO": "222109",
      "Gariaon BO": "222204",
      "Sohansa BO": "222204",
      "Basaratpur BO": "222003",
      "Kanja BO": "222003",
      "Khalilpur BO": "222003",
      "NDC Jamuhai BO": "222003",
      "Sonikpur BO": "222003",
      "Poly BO": "222105",
      "Ashawan BO": "222203",
      "Marikpur BO": "222203",
      "Badalapur Khurd BO": "222141",
      "Bishunpur BO": "223103",
      "Chakara BO": "222149",
      "Kusarana BO": "222149",
      "Sherawan BO": "222131",
      "Baharipur BO": "222175",
      "Sirkina BO": "222175",
      "Sarpataha BO": "223105",
      "Udaichandpur BO": "222181",
      "Hauz BO": "222180",
      "Kabulpur BO": "222180",
      "Kukuhan BO": "222133",
      "Nayansand BO": "222133",
      "Samadhganj BO": "222135",
      "Bhaupur BO": "222136",
      "Bidauri BO": "222136",
      "Lalpur BO": "222136",
      "Pasiahi Khurd BO": "222136",
      "Sirkoni BO": "222136",
      "Aura BO": "222137",
      "Damodara BO": "222137",
      "Kumbhapur BO": "222137",
      "Premapur BO": "222002",
      "Shivapar BO": "222002",
      "Dehari BO": "223103",
      "Dilla Ka Pura BO": "222142",
      "Murki BO": "222142",
      "Ayurved Vishwavidyalay BO": "222139",
      "Gulalpur BO": "222139",
      "Jaigahan BO": "222139",
      "Belasin BO": "222143",
      "Ghagharia BO": "222143",
      "Asaropur BO": "222145",
      "Bhatauli BO": "222145",
      "Barigaon Newada BO": "222161",
      "Daudi BO": "222161",
      "Jagarnathpur BO": "222161",
      "Khajurahawa BO": "222161",
      "Kuttupur BO": "222161",
      "Amai BO": "222165",
      "Barigaondih BO": "222165",
      "Bhikhpur BO": "222202",
      "Kunwarpur BO": "222202",
      "Saraibika BO": "222202",
      "Belawan BO": "222109",
      "Buxa BO": "222109",
      "Adhanpur BO": "223102",
      "Bhagasa BO": "223102",
      "Rasulpur BO": "223102",
      "Aurahi BO": "222003",
      "Bhakura BO": "222003",
      "Jangipur Khurd BO": "222003",
      "Malhani BO": "222003",
      "Kailawar BO": "222105",
      "Rampur Naddi BO": "222105",
      "Ashapur BO": "222203",
      "BHadkin BO": "222203",
      "Gandhauna BO": "222203",
      "Pachawal BO": "222203",
      "Sureri BO": "222203",
      "Kandhikala BO": "222141",
      "Khalishpur BO": "222141",
      "Tezi Bazar BO": "222141",
      "Bazar Arasia BO": "223103",
      "Jamunia BO": "223103",
      "Sultanpur Ghughuri BO": "223103",
      "Bodari BO": "222149",
      "Kachhawan BO": "222149",
      "Takha BO": "223101",
      "Pahetiapur BO": "222175",
      "Thakurganj BO": "222175",
      "Dukhaipur Sambalshah BO": "223105",
      "Behra BO": "222181",
      "Maharupur BO": "222180",
      "Jaunpur HO": "222001",
      "Badlapur SO": "222125",
      "Barsathi SO": "222162",
      "Civil Court SO Jaunpur": "222002",
      "Khuthan SO": "223104",
      "Mahraj Ganj SO": "222145",
      "Patti Narendra SO": "223102",
      "Sgrd College Dobhi SO": "222149",
      "Shahganj Tehseel Parisar SO": "223101",
      "Shastri Marg SO": "222001",
      "Sikrara SO": "222131",
      "Singramau SO": "222175",
      "Umarpur SO": "222002",
      "Baderi SO": "222127",
      "Balwarganj SO": "222201",
      "Gaurabadshahpur SO": "222133",
      "Kajgaon SO Jaunpur": "222138",
      "Khetasarai SO": "222139",
      "Mariahun SO": "222161",
      "Purvanchal Vishwa Vidyalaya SO": "222003",
      "Saraiharakhu SO": "222141",
      "Soithakalan SO": "223105",
      "TD College SO": "222002",
      "Thanagaddi SO": "222181",
      "Zafarabad SO": "222180",
      "Baraipar SO": "222144",
      "Bazar Neorhia SO": "222128",
      "Collectrate Compound SO": "222002",
      "College Colony SO": "222002",
      "Gulzarganj SO": "222135",
      "Jalalpur SO Jaunpur": "222136",
      "Jaunpur Kty SO": "222002",
      "Kutir Chakkey SO": "222146",
      "Muftiganj SO": "222170",
      "Naupedwa SO": "222109",
      "Pukhta Sarai SO": "222002",
      "Rampur SO Jaunpur": "222203",
      "Shahganj SO Jaunpur": "223101",
      "Sutahatti Bazar SO": "222001",
      "RAJA BAZAR SO JAUNPUR": "222126",
      "Chandwak SO": "222129",
      "Fatehganj SO Jaunpur": "222132",
      "Jamalapur SO": "222137",
      "Kerakat SO": "222142",
      "Leorua SO": "222148",
      "Machhali Shahar SO": "222143",
      "Mariahun Bazar SO": "222161",
      "Meerganj SO Jaunpur": "222165",
      "Mungra Badshahpur SO": "222202",
      "Nibhapur SO": "222204",
      "Raj College SO": "222001",
      "Ramdayalganj SO": "222105",
      "Saraimohiddin SO": "223103",
      "Shakarmandi SO": "222001"
    },
    "ETAH": {
      "Ahamdabad BO": "207002",
      "Rustamgarh BO": "207002",
      "Chhachena BO": "207003",
      "Garhi BO": "207003",
      "Kantore BO": "207401",
      "Nagla Galu BO": "207002",
      "Neorai BO": "207002",
      "Rarpatti BO": "207002",
      "Angriya BO": "207247",
      "Daheliyapooth BO": "207247",
      "Sarauth BO": "207247",
      "Sarutiya BO": "207247",
      "Ubhai Asadnagar BO": "207247",
      "Narura BO": "207301",
      "Pipehra BO": "207301",
      "Baroliya BO": "207248",
      "Fagnaul BO": "207248",
      "Jalalpur Santhal BO": "207248",
      "Kasela BO": "207248",
      "Chirgawan BO": "207302",
      "Ganehspur BO": "207302",
      "Shakrauli BO": "207302",
      "Simrau BO": "207302",
      "Takhawan BO": "207302",
      "Bahadurpur BO": "207401",
      "Kanar Kheraa BO": "207401",
      "Kutukpur Kaseri BO": "207401",
      "Mohani Mamoorganj BO": "207401",
      "Achalpur BO": "207125",
      "Banthal Kutukpur BO": "207125",
      "Burhenabad BO": "207125",
      "Dholeswar BO": "207122",
      "Magrauli BO": "207122",
      "Margayan BO": "207122",
      "Mitraul BO": "207122",
      "Muiddinpur BO": "207120",
      "Ambarpur Rejor BO": "207121",
      "Angadpur BO": "207121",
      "Bhartoli BO": "207121",
      "Chaprai Sikandarpur BO": "207121",
      "Gahi BO": "207247",
      "Kaila BO": "207247",
      "Kakora BO": "207247",
      "Partappur BO": "207241",
      "Samaspur Dengri BO": "207241",
      "Borakalan BO": "207301",
      "Gahrana BO": "207301",
      "Jalukhera BO": "207301",
      "Jarani Kalan BO": "207301",
      "Shekhpura BO": "207248",
      "Barna BO": "207249",
      "Daheliya BO": "207249",
      "Dharoli BO": "207249",
      "Jiroliya BO": "207249",
      "Khirya Nagar Shah BO": "207249",
      "Nagla Leeladhar BO": "207249",
      "Berni BO": "207302",
      "Nagla Anni BO": "207302",
      "Narau BO": "207302",
      "Naukhera BO": "207302",
      "Neem Khera BO": "207302",
      "Salempur Pironda BO": "207401",
      "Sirsa Tippu BO": "207125",
      "Barai BO": "207120",
      "Bijora BO": "207244",
      "Bilsad BO": "207244",
      "Gariya Jagannath BO": "207244",
      "Lothra BO": "207121",
      "Nandpur Bailamay BO": "207121",
      "Peepal Khairia BO": "207121",
      "Puraon BO": "207003",
      "Amraulirattanpur BO": "207247",
      "Junedpur BO": "207247",
      "Nadrala BO": "207247",
      "Pardanapur BO": "207247",
      "Barabhodela BO": "207301",
      "Basundhara BO": "207301",
      "Pondari BO": "207301",
      "Tikathar BO": "207301",
      "Datauli BO": "207248",
      "Rupdhani BO": "207248",
      "Bhaupura BO": "207249",
      "Meidupura BO": "207249",
      "Sahadat Nagar BO": "207249",
      "Targawan BO": "207249",
      "Gudaun BO": "207302",
      "Isauli BO": "207302",
      "Jamon BO": "207302",
      "Maksud Pur BO": "207302",
      "Rejua BO": "207302",
      "Shahnagar Timarua BO": "207302",
      "Beri BO": "207401",
      "Mehni Sora BO": "207401",
      "Pidora BO": "207401",
      "Tirlokpur BO": "207401",
      "Dhiramai BO": "207125",
      "Lodhamai BO": "207125",
      "Sheorai BO": "207125",
      "Dalshahpur BO": "207122",
      "Gahaitoo BO": "207122",
      "Manora BO": "207122",
      "Bhadwas BO": "207120",
      "Jogamai Kalan BO": "207120",
      "Songra BO": "207120",
      "Alliyapur BO": "207244",
      "Luhari Kherra BO": "207244",
      "Mokampur BO": "207244",
      "Kawar BO": "207121",
      "Saina Kalan BO": "207121",
      "Kartala BO": "207003",
      "Akbarpurkot BO": "207247",
      "Datingara BO": "207247",
      "Jasrathpur BO": "207247",
      "Mohammadnagar Bajhera BO": "207247",
      "Nagla Gajpat BO": "207247",
      "Baraikalyanpur BO": "207301",
      "Khatout BO": "207301",
      "Rohina Mirjapur BO": "207301",
      "Udaipura BO": "207248",
      "Barahpur BO": "207249",
      "Bhalol BO": "207249",
      "Pinjari BO": "207249",
      "Parauli Suhagpur BO": "207249",
      "Badhawali BO": "207302",
      "Jainpura BO": "207302",
      "Misauli BO": "207302",
      "Pilkhatra BO": "207302",
      "Punhera BO": "207302",
      "Sarai Neem BO": "207302",
      "Piwari BO": "207401",
      "Gobra BO": "207125",
      "Naya  Bans BO": "207125",
      "Jhinwar BO": "207122",
      "Barigawan BO": "207120",
      "Jitauli BO": "207120",
      "Majhola BO": "207244",
      "Nagla Pohpi BO": "207244",
      "Shahpur Tehla BO": "207244",
      "Ishara Purbi BO": "207121",
      "Khaddua BO": "207003",
      "Bhagwala BO": "207003",
      "Jamlapur BO": "207003",
      "Bijauri BO": "207002",
      "Nigoh Hasanpur BO": "207003",
      "Parson BO": "207003",
      "Kangrol BO": "207003",
      "Loya Badshapur BO": "207002",
      "Nagla Khilli BO": "207002",
      "Begaur BO": "207002",
      "Manikpur BO": "207003",
      "Sarnau BO": "207002",
      "Mohanpura BO": "207401",
      "Chhoti Nidhaoli BO": "207002",
      "Garia Sheelam BO": "207003",
      "Malwan BO": "207003",
      "Rijor BO": "207002",
      "Kashon BO": "207003",
      "Sheetal Pur BO": "207003",
      "Mahua Khaira BO": "207003",
      "Milawali BO": "207002",
      "Datai BO": "207002",
      "Ahemadpur Nagla Dhanu BO": "207002",
      "Kansuri BO": "207003",
      "Babsa BO": "207002",
      "Alipur BO": "207250",
      "Kalua Teel Pur BO": "207250",
      "Unchagaon BO": "281104",
      "Hirondi BO": "207003",
      "Sonhar BO": "207003",
      "Pamas BO": "207003",
      "Phaphoto BO": "207002",
      "Kakrawali BO": "207002",
      "Nagla Pawal BO": "207002",
      "Girora BO": "207002",
      "Jeskhpur BO": "207003",
      "Jirsimi BO": "207002",
      "Marthara Bhagwandas BO": "207002",
      "Sarvodaya Ashram BO": "207002",
      "Lalgarhi BO": "207002",
      "Kharsulia BO": "207250",
      "Barauli BO": "207003",
      "Rajpur BO": "207002",
      "Aruna Nagar SO": "207002",
      "Mirehachi SO": "207125",
      "Patiali Gate SO": "207001",
      "Raja Ka Rampur SO": "207244",
      "Sakeet SO": "207121",
      "Aliganj SO Etah": "207247",
      "Amanpur SO": "207241",
      "Dhumri SO": "207248",
      "Jaithra SO": "207249",
      "Jalesar SO": "207302",
      "Nidholi Kalan SO": "207122",
      "Awagarh SO": "207301",
      "Brahm Sajiwan SO": "207003",
      "Collectorate Compound SO": "207001",
      "Pilua SO": "207120",
      "Sarai Aghat SO": "207250",
      "Etah HO": "207001",
      "Gandhi Market SO Etah": "207001",
      "Marehara SO": "207401"
    },
    "AZAMGARH": {
      "Bisunpura BO": "276405",
      "Dev Kali Tas BO": "276403",
      "Pichari BO": "276403",
      "Bhuvana Bujurga BO": "276405",
      "Patkhauli BO": "276125",
      "Mahula BO": "275303",
      "Basgit BO": "276128",
      "Gahaji BO": "223221",
      "Gauri BO": "223221",
      "Khajuri BO": "223221",
      "Samsabad BO": "223221",
      "Sarain BO": "223221",
      "Jagdishpur BO": "276304",
      "Jameen Bilari BO": "276124",
      "Lilapatti Bankatia BO": "276124",
      "Mandanpur BO": "276124",
      "Godhana BO": "223222",
      "Khanjahan Pur BO": "223222",
      "Badaya BO": "223223",
      "Bansgaon BO": "223223",
      "Basahia BO": "223223",
      "Govind Pur BO": "223223",
      "Mahagu Pur BO": "223223",
      "Mir Pur BO": "223223",
      "Ajampur BO": "276125",
      "Bheera BO": "276301",
      "Dubara BO": "276301",
      "Jeoli BO": "276301",
      "Mahuja Newada BO": "276301",
      "Patwadh Kautuk BO": "276121",
      "Shekhupur BO": "276121",
      "Vijayapar BO": "276121",
      "Mohamdalla BO": "276128",
      "Palhani BO": "276128",
      "Sidhari BO": "276128",
      "Gopal Pur Sadar BO": "276128",
      "Ram Pur Katharawa BO": "276201",
      "Guwai BO": "223224",
      "Hubbi Ganj BO": "223224",
      "Karui BO": "223224",
      "Kaura Gahani BO": "223224",
      "Belaon BO": "276302",
      "Chhaon BO": "276302",
      "Dayalpur BO": "276302",
      "Kalanderpur BO": "276302",
      "Bibipur BO": "276123",
      "Gauri Narayanpur BO": "276135",
      "Jolhapur BO": "276135",
      "Ban Kat Jagdeesh BO": "276142",
      "Bharauli BO": "276142",
      "Bhilampur Chhapra BO": "276142",
      "Gaura BO": "276204",
      "Meh Mauni BO": "276141",
      "Mokhalish Pur BO": "276141",
      "Tahar Wajid Pur BO": "276141",
      "Murhar BO": "276303",
      "Nurvey BO": "276303",
      "Sarai Mohan BO": "276303",
      "Bhuidharpur BO": "276208",
      "Khutia BO": "276208",
      "Lahar Par BO": "276141",
      "Lasara Khurd BO": "276303",
      "Kisundaspur BO": "276208",
      "Khalifatpur BO": "276208",
      "Baraipur BO": "223221",
      "Bhimal Patti BO": "223221",
      "Malgaon BO": "223222",
      "Nauhara BO": "223222",
      "Lohara BO": "276406",
      "Madia Par BO": "223223",
      "Kakarahatta BO": "276125",
      "Kote BO": "276125",
      "Chhitauna BO": "223221",
      "Edilpur BO": "223221",
      "Vinoa Puri BO": "223221",
      "Chhapra Sultanpur BO": "276124",
      "Punapar BO": "276124",
      "Oril BO": "223222",
      "Deora Patti BO": "223223",
      "Pakar Deeha BO": "223223",
      "Sen Pur BO": "223223",
      "Chhattarpur Khushahal BO": "276125",
      "Baddo Pur BO": "276125",
      "Pithaupur Rasti BO": "276126",
      "Uchahuwan BO": "276126",
      "Ashwania BO": "276301",
      "Bargahan BO": "276301",
      "Pichhaura BO": "276301",
      "Sohauli BO": "276301",
      "Maukutubpur BO": "276127",
      "Sirahi BO": "276127",
      "Jairajpur BO": "276121",
      "Badaura BO": "276128",
      "Deeha BO": "276128",
      "Kisun Pur BO": "276128",
      "Sewata BO": "276128",
      "Gopalpur Sethuli BO": "276201",
      "Sri Kant Pur BO": "276201",
      "Chitara Mahamud Pur BO": "223224",
      "Mir Ahmedpur Sahjada BO": "223224",
      "Palthi BO": "223224",
      "Ranipur Razamo BO": "276302",
      "Dharwara BO": "276131",
      "Mittupur BO": "276131",
      "Bhavar Nath BO": "276135",
      "Amari BO": "276142",
      "Kakarahi BO": "276142",
      "Beohara BO": "276202",
      "Hafiz Pur BO": "276125",
      "Harra Ki Chungi BO": "276125",
      "Aira Bujurg BO": "276126",
      "Haraura BO": "276126",
      "Khargpur BO": "276126",
      "Sonhara BO": "276301",
      "Udiawan BO": "276301",
      "Haraia BO": "276127",
      "Ramgarh BO": "276127",
      "Bhimbar BO": "276121",
      "Bindawal BO": "276121",
      "Chhihi BO": "276121",
      "Emalipur BO": "276121",
      "Bhangaha BO": "276128",
      "Gambhir Ban BO": "276128",
      "Kanaila BO": "276128",
      "Samaida BO": "276128",
      "Kalicha Bad BO": "276201",
      "Kanjahit BO": "276201",
      "Martin Ganj BO": "223224",
      "Karisath BO": "276131",
      "Khoulukhor BO": "276131",
      "Koilari BO": "276207",
      "Lapsipur BO": "276131",
      "Sema BO": "276131",
      "Maharaj Pur BO": "276135",
      "Kothwa Jalal Pur BO": "276142",
      "Mangit Pur BO": "276142",
      "Pipari BO": "276142",
      "Rithia BO": "276142",
      "Kujiyari BO": "223227",
      "Niauj BO": "276305",
      "Rajapur Sikaraur BO": "276305",
      "Rangdih BO": "276305",
      "Towa BO": "276305",
      "Bhaisha BO": "276139",
      "Ashona BO": "276406",
      "Bamhaur BO": "276406",
      "Kerama BO": "276406",
      "Kaudia BO": "276141",
      "Maniyar Pur BO": "276141",
      "Pach Khaura BO": "276141",
      "Baksh Pur BO": "276303",
      "Irani BO": "276303",
      "Kammar Pur BO": "276303",
      "Madharsia BO": "276208",
      "Ora BO": "276208",
      "Nardah BO": "276305",
      "Araji Amani BO": "276139",
      "Dewara Jadid II BO": "276137",
      "Raut Mau BO": "276406",
      "Shahgarh BO": "276406",
      "Bharathipur BO": "276123",
      "Tandadeeh BO": "276123",
      "Babu Ki Basti BO": "276305",
      "Beenapara BO": "276305",
      "Mirja Pur BO": "276305",
      "Harkhpura Khas BO": "276139",
      "Jurarampur BO": "276139",
      "Khan Pur Bhagatpatti BO": "276139",
      "Rasulpur Nandalal BO": "276139",
      "Shivpur BO": "276137",
      "Singhwara BO": "276139",
      "Maholi BO": "276123",
      "Naurasia BO": "276123",
      "Tandawa BO": "276123",
      "Bilari BO": "223221",
      "Daniyalpur BO": "223221",
      "Kushmahara BO": "223221",
      "Sukhi Pur BO": "223221",
      "Youdhisthirpatti BO": "223221",
      "Dighwania Majhuwa BO": "276124",
      "Narhankhas BO": "276124",
      "Palia Maphi BO": "223222",
      "Base Pur Dandava BO": "223223",
      "Bhagat Pur BO": "223223",
      "Gajendra Patti Bhidaura BO": "223223",
      "Nandana BO": "223223",
      "Anjam Shhid BO": "276125",
      "Bangaon BO": "276123",
      "Badasara Aima BO": "276141",
      "Badasara Khalsa BO": "276141",
      "Bhedaura BO": "276141",
      "Newada BO": "276141",
      "Rasul Pur Pasi Pur BO": "276141",
      "Jamuawan BO": "276303",
      "Nasiruddinpur BO": "276208",
      "Muzaffarpur BO": "276208",
      "Phulaieh Khajura BO": "276126",
      "Singhpur BO": "276126",
      "Ahirauli BO": "276301",
      "Barauna BO": "276301",
      "Jameen Rasulpur BO": "276127",
      "Barohi Fetahpur BO": "276121",
      "Gaddopur BO": "276121",
      "Patila Gaosh Pur BO": "276121",
      "Uchagaon BO": "276128",
      "Jamal Pur BO": "276128",
      "Zafarpur BO": "276128",
      "Bahadur Pur BO": "276201",
      "Chewar Pachhim BO": "276201",
      "Kariya Gopal Pur BO": "276201",
      "Sikraur BO": "276201",
      "Bhadaon BO": "223224",
      "Fulesh BO": "223224",
      "Surahan BO": "223224",
      "Mujaffarpur BO": "276302",
      "Sarai Paltu BO": "276302",
      "Bhujahi BO": "276131",
      "Mahuyamurarpur BO": "276131",
      "Punargi BO": "276131",
      "Hira Patti BO": "276135",
      "Shbili BO": "276135",
      "Ataraith BO": "276142",
      "Kabiruddin Pur BO": "276142",
      "Keshav Pur BO": "276142",
      "Nandaon BO": "276305",
      "Haidarabad BO": "276122",
      "Jameel Pur BO": "276139",
      "Dewara Naubrar BO": "276137",
      "Bhawarpur BO": "276123",
      "Kamahariya BO": "276123",
      "Pakari BO": "276123",
      "Chewata BO": "276141",
      "Bhopalpur BO": "276202",
      "Chirkihit BO": "276202",
      "Lahuwan BO": "276202",
      "Pandaha BO": "276202",
      "Naraipur BO": "276136",
      "Tarauka BO": "276136",
      "Huse Pur BO": "276137",
      "Rama Pur BO": "223225",
      "Kubakhas BO": "276203",
      "Sidhauna BO": "276203",
      "Hardaspur BO": "276204",
      "Pawani Kala BO": "276204",
      "Renda BO": "276204",
      "Balaipur BO": "276143",
      "Abusaidpur BO": "276205",
      "Bisham BO": "276205",
      "Bind Mathia BO": "276404",
      "Pahi BO": "276404",
      "Mohanath BO": "276206",
      "Sodhari BO": "276206",
      "Mataulipur BO": "276206",
      "Chak Inami BO": "276206",
      "Bhani Pur BO": "276288",
      "Galib Pur BO": "276288",
      "Kohanda BO": "276288",
      "Khutauli BO": "276304",
      "Mundwar BO": "276304",
      "Bakhara BO": "223226",
      "Sikaraur Sahabari BO": "223226",
      "Tamauli BO": "276207",
      "Tegar Pur BO": "276207",
      "Esmail Pir BO": "276122",
      "Tahir Pur BO": "276122",
      "Amuwari BO": "276138",
      "Maltari BO": "276138",
      "Mohmmadpur BO": "276138",
      "Badagaon BO": "223227",
      "Fariha BO": "223227",
      "Jaitipur BO": "276202",
      "Karsara BO": "276202",
      "Katauli Kala BO": "276202",
      "Khaniara BO": "276202",
      "Sarawan BO": "276202",
      "Ubarpur BO": "276202",
      "Bardiha BO": "276136",
      "Dighwania Kaji BO": "276136",
      "Garerua BO": "276136",
      "Jokhara BO": "276136",
      "Naharpur BO": "223225",
      "Bela Klichpur BO": "276203",
      "Dandwal BO": "276203",
      "Diriapur Newada BO": "276203",
      "Karauti BO": "276204",
      "Nai BO": "276204",
      "Khandaura BO": "276143",
      "Sumhadeeh BO": "276288",
      "Banbirpur BO": "276304",
      "Buxpur Mejawa BO": "276304",
      "Dharmdaspur Newada BO": "276304",
      "Kotila BO": "276207",
      "Shethawal BO": "276207",
      "Ajaji Dewara Karkhia BO": "276122",
      "Baijabari BO": "276122",
      "Dewara Khas Raja BO": "276122",
      "Karkhia Rutam Sarai BO": "276122",
      "Berama BO": "276138",
      "Chaklal Chand BO": "276140",
      "Bithuwa BO": "276202",
      "Mohammad Pur Dharang BO": "276202",
      "Bankatia BO": "276136",
      "Luchui BO": "276136",
      "Pihar BO": "276136",
      "Dewara Jadid I BO": "276137",
      "Raida BO": "223225",
      "Nehula BO": "276203",
      "Sihuka Abhirpur BO": "276203",
      "Dewait BO": "276204",
      "Gopalpur BO": "276204",
      "Kharihani BO": "276204",
      "Bindra Bazar BO": "276205",
      "Jamalpur BO": "276205",
      "Amilo BO": "276404",
      "Khaliasemari BO": "276206",
      "Shiwali BO": "276206",
      "Khairuddinpur BO": "276288",
      "Bhormau BO": "276304",
      "Durbasa BO": "276304",
      "Khurasan BO": "276304",
      "Mundiyar BO": "276304",
      "Chandai BO": "276207",
      "Sirsal BO": "276207",
      "Chan Patti BO": "276122",
      "Haji Pur BO": "276122",
      "Matia BO": "276122",
      "Urdiha BO": "276122",
      "Mahulia Bojhia BO": "276138",
      "Ambarpur BO": "223227",
      "Badaharia BO": "223227",
      "Azamgarh HO": "276001",
      "Gomadih BO": "276202",
      "Narsingh Pur BO": "276202",
      "Safipur BO": "276202",
      "Salempur BO": "276202",
      "Mahesh Pur BO": "276137",
      "Molana Pur BO": "276137",
      "Faridpur BO": "223225",
      "Tilkhara Pura Dani BO": "276203",
      "Babu Ki Khajuri BO": "276204",
      "Bachhawal BO": "276204",
      "Benupur BO": "276204",
      "Dama BO": "276204",
      "Rasoolpur BO": "276204",
      "Kalafatpur BO": "276143",
      "Mangrawa BO": "276205",
      "Palhana BO": "276202",
      "Gujar Par BO": "276404",
      "Bairampur BO": "276206",
      "Barikhas BO": "276206",
      "Chandabhari BO": "276206",
      "Zamin Katghar BO": "276206",
      "Bahauddinpur BO": "276288",
      "Mutkallipur BO": "276288",
      "Loniadeeh BO": "276304",
      "Bunda BO": "223226",
      "Chhittepur BO": "223226",
      "Ishapur BO": "223226",
      "Ajagara Masharki BO": "276122",
      "Jameen Harkhori BO": "276140",
      "Khalispur BO": "276138",
      "Firuddin Pur BO": "223227",
      "Gandhuai BO": "223227",
      "RANI KI SARAI SO": "276207",
      "Terahi SO": "276141",
      "Saraimeer SO": "276305",
      "Sardaha SO": "276139",
      "Sathion SO": "276406",
      "Tarawa SO": "276123",
      "PUSPNAGAR SO": "223226",
      "RAUNAPAR SO": "276122",
      "Thekma SO": "276303",
      "PHOOLPUR SO": "276304",
      "PHOOLPUR TOWN SO": "276304",
      "SAGRI SO": "276138",
      "Sanjar Pur SO": "223227",
      "Tika Pur SO": "276208",
      "CHANDESAR": "276128",
      "GAMBHIRPUR SO": "276302",
      "JAHANAGANJ SO": "276131",
      "MAHUL SO": "223225",
      "MUBARAKPUR SO": "276404",
      "PAWAI SO": "276288",
      "Aharaula SO": "223221",
      "Bansgaon SO Azamgarh": "276126",
      "MAHARAJGANJ SO": "276137",
      "MEHNAGAR SO": "276204",
      "Ambari SO": "223222",
      "Ataraulia SO": "223223",
      "Bankat SO": "276125",
      "Bilaria Ganj SO": "276121",
      "DEOGAON SO": "276201",
      "DIDARGANJ SO": "223224",
      "KANDHARAPUR SO": "276135",
      "KOILSA SO": "276142",
      "MOHAMMADPUR SO": "276205",
      "NIZAMBAD SO": "276206",
      "Ajamat Garh Estate SO": "276124",
      "Azamgarh City SO": "276001",
      "Azamgarh RS SO": "276001",
      "Bardah SO": "276301",
      "Bazar Gosain SO": "276127",
      "JIYANPUR SO": "276140",
      "LALGANJ SO": "276202",
      "LATGHAT SO": "276136",
      "MEHNAJPUR SO": "276203",
      "MITTOOPUR": "276143"
    },
    "GHAZIPUR": {
      "Muriyar BO": "233304",
      "Kharwadih BO": "275205",
      "Manihari BO": "275205",
      "Yuvrajpur BO": "232332",
      "Mahpur BO": "233304",
      "Gorsara BO": "232333",
      "Surhurpur BO": "275205",
      "Bhikhichaura BO": "232332",
      "Patkaniya BO": "232332",
      "Gaura BO": "232328",
      "KHAJURA BO": "233304",
      "Amaura BO": "232333",
      "Athatha BO": "232333",
      "Dewal BO": "232333",
      "Mahna BO": "232333",
      "Basewa BO": "275205",
      "Guraini BO": "275205",
      "Bharauli Kalan BO": "233228",
      "Goshalpur BO": "233228",
      "Mahend BO": "233228",
      "Patar BO": "233228",
      "Holipur BO": "233304",
      "Kaneri BO": "233304",
      "Bhadaura BO": "232333",
      "Lahna BO": "232333",
      "Maniya BO": "232333",
      "NAULI": "232333",
      "Seorai BO": "232333",
      "Utrauli BO": "232333",
      "Sauri BO": "275205",
      "Sonwani BO": "233228",
      "Garua Maksudpur BO": "232332",
      "Gaighat BO": "232331",
      "Rohura BO": "232331",
      "Darauli BO": "232329",
      "Dhanauta BO": "232329",
      "Lahuwar BO": "232329",
      "Pachokhar BO": "232329",
      "Alawalpur BO": "233305",
      "Andhau BO": "233305",
      "Arakhpur BO": "233305",
      "Belwa Urf Rasulpur BO": "233305",
      "Abhaipur BO": "232331",
      "Baruin BO": "232331",
      "Kataila BO": "233305",
      "Pahetia BO": "233305",
      "Narsinghpur BO": "232331",
      "Umarganj Nariaon BO": "232329",
      "Gumma BO": "233305",
      "Manpur BO": "233305",
      "Dhanarhi BO": "232330",
      "Daudpur BO": "232331",
      "Khargasipur Urf Naibazar BO": "232331",
      "Tokwa BO": "232331",
      "Bahadurpur BO": "232329",
      "Phulli BO": "232329",
      "Buzurga Gouspur BO": "233305",
      "Rampur Jiwan BO": "233305",
      "Sauna BO": "233221",
      "Soniyapar BO": "233221",
      "Pali BO": "275201",
      "Ameda BO": "233221",
      "Anauni BO": "233221",
      "Dadara BO": "233221",
      "Banki Khurd BO": "233229",
      "Bhikham Amhat BO": "233229",
      "Kamupur BO": "233229",
      "Mason BO": "233231",
      "Bhuwarpur BO": "233307",
      "Bikrampur BO": "233307",
      "Makhdumpur BO": "233307",
      "Ruhipur BO": "233300",
      "Taraon BO": "233306",
      "Turna BO": "233306",
      "Asaon BO": "232336",
      "Mircha BO": "232326",
      "Mohammadpur BO": "232326",
      "Nagsar BO": "232326",
      "BEMUA BO": "232326",
      "Dhamupur BO": "275202",
      "Hardaspur Kalan BO": "275202",
      "Jalalabad BO": "275202",
      "Lediha BO": "275202",
      "Basudeopur BO": "233222",
      "Dahendu BO": "233222",
      "Dhotari BO": "233222",
      "Gathia BO": "233222",
      "Ramgarh BO": "275201",
      "Salamatpur BO": "275201",
      "Mata BO": "233229",
      "Birpur BO": "233231",
      "Kanuwan BO": "233231",
      "Kathar BO": "233231",
      "Taraon Balua BO": "233231",
      "Dharmagatpur BO": "233300",
      "Pandepur Radhey BO": "233300",
      "Ranipur BO": "233300",
      "Basuchak BO": "233306",
      "Jewal BO": "233306",
      "Betabar Kalan BO": "232340",
      "Jeevpur BO": "232340",
      "Sabbalpur Kalan BO": "232340",
      "SONHARIYA BO": "232336",
      "Kusi BO": "232326",
      "Bhataura BO": "232327",
      "Sayer BO": "232327",
      "Maudha BO": "233221",
      "Singarpur BO": "233221",
      "Mahuwari BO": "275201",
      "Narainpur BO": "233229",
      "Jashdeopur BO": "233231",
      "Sukhdehra BO": "233231",
      "Mangari BO": "233307",
      "Bharsar BO": "233300",
      "Chaurabojh BO": "233300",
      "Paharpur Kalan BO": "233306",
      "Rasulpur Pacharasi BO": "233306",
      "Saidabad BO": "232340",
      "Tajpur Majnha BO": "232340",
      "Bhagirathpur BO": "232336",
      "Gohda Bishunpura BO": "232326",
      "Sinhani BO": "232326",
      "Tiyari BO": "232326",
      "Baragaon BO": "275202",
      "Orarai BO": "275202",
      "Belhari BO": "233221",
      "Karampur BO": "233221",
      "Amrupur BO": "233231",
      "Loharpur BO": "233231",
      "Mirzabad Mania BO": "233231",
      "Khidirganj BO": "233307",
      "Uchauri BO": "233307",
      "Badhupur BO": "233300",
      "Tilesara BO": "233300",
      "Rampur Majha BO": "233306",
      "Sammanpur BO": "233306",
      "Tisaura BO": "232340",
      "Andharipur Sonwal BO": "232336",
      "Bhuwalchak BO": "232336",
      "Dewaitha BO": "232326",
      "Raksaha BO": "232326",
      "Sarahula BO": "232326",
      "Tajpur Kurra BO": "232326",
      "Rehti Malipur BO": "275202",
      "Tirchhi BO": "275202",
      "Sikhari BO": "275202",
      "Pachauri BO": "232327",
      "Alawalpur Afga BO": "233222",
      "Hajipur Baresar BO": "233222",
      "Abishahan BO": "233222",
      "Jahurabad BO": "233222",
      "Saitapatti BO": "233232",
      "Bhurkura BO": "275203",
      "Burhanpur BO": "275203",
      "Basuka BO": "232339",
      "Lilapur BO": "233224",
      "Sikandarpur BO": "233224",
      "Patepur BO": "233225",
      "Utraon BO": "233225",
      "Deoria BO": "233233",
      "Joga Musahib BO": "233233",
      "Yusufpur BO": "233310",
      "Birbalpur BO": "233226",
      "Bogna BO": "233226",
      "Chaubepur BO": "233226",
      "Prithvipur BO": "233226",
      "Singera BO": "233226",
      "Pardhan Ki Bareji BO": "233227",
      "Semara BO": "233227",
      "Tamalpura BO": "233227",
      "Tandawan BO": "233227",
      "Tiwaripur BO": "233227",
      "Bagend BO": "233301",
      "Bareji BO": "233301",
      "Kataria BO": "233301",
      "Parasa BO": "233301",
      "Rajapur BO": "233301",
      "Alipur Bangawan BO": "233302",
      "Chandipur BO": "233302",
      "Bhala BO": "233303",
      "Lawa BO": "233303",
      "Para BO": "233303",
      "Sihori BO": "233311",
      "Khalispur BO": "233002",
      "Mahrajganj BO": "233002",
      "Khanpur BO": "233223",
      "Baurawan BO": "233304",
      "Bhitari BO": "233304",
      "Puraina BO": "233232",
      "Chauja BO": "275203",
      "Jalalpurdhani BO": "275203",
      "Asawar BO": "233225",
      "Dubiha BO": "233225",
      "Khajurgaon BO": "233230",
      "Khetabpur BO": "275203",
      "Siyari BO": "233233",
      "Hansrajpur BO": "233310",
      "Sarai Gobind BO": "233310",
      "Dhanespur BO": "233226",
      "Harhari BO": "233226",
      "Indaur BO": "233226",
      "Kansahari BO": "233226",
      "Kelhi BO": "233226",
      "Kondari BO": "233226",
      "Abadan Bairan BO": "233227",
      "Awathahi BO": "233227",
      "Balapur BO": "233227",
      "Gauspur BO": "233227",
      "Kundesar BO": "233227",
      "Machhati BO": "233227",
      "Fateullahpur BO": "233302",
      "Madanahi BO": "233302",
      "Naisare BO": "233302",
      "Nari Pachdeora BO": "233302",
      "Sabua BO": "233302",
      "Saheri BO": "233302",
      "Sujanipur BO": "233311",
      "Baipur Deokali BO": "233002",
      "Bikapur BO": "233002",
      "Chak Abdul Sattar BO": "233002",
      "Chaukiya BO": "233002",
      "Noorpur BO": "233002",
      "Permeth BO": "233002",
      "Pithapur BO": "233002",
      "Rasulpur Kanhwara BO": "233002",
      "Sohilapur BO": "233002",
      "Baheri BO": "233223",
      "Barwa Kalan BO": "275204",
      "Bhala Khurd BO": "275204",
      "Darhwal BO": "275204",
      "Daulatnagar BO": "275204",
      "Mirzapur BO": "275204",
      "Paliwar BO": "275204",
      "Raipur BO": "275204",
      "Dahra Kalan BO": "233304",
      "Dhuwarjun BO": "233304",
      "Mahespur Kalan BO": "233222",
      "Renga BO": "233222",
      "Dharammarpur BO": "233232",
      "Jhotna": "275203",
      "Padumpur BO": "275203",
      "Rampur Balbhadra BO": "275203",
      "Nasirpur BO": "232339",
      "Chochakpur BO": "233224",
      "Mainpur BO": "233224",
      "Gondaur BO": "233225",
      "Maura BO": "233225",
      "Maharaur BO": "233230",
      "Shekhanpur BO": "233230",
      "Khairabari BO": "233233",
      "Mundera BO": "233233",
      "Bajidpur BO": "233310",
      "Bhojapur BO": "233226",
      "Bijaura BO": "233226",
      "Gahli Basarikpur BO": "233226",
      "Gai BO": "233226",
      "Gobindpur BO": "233226",
      "Nakhatpur BO": "233226",
      "Pipnar BO": "233226",
      "Murki Kalan BO": "233227",
      "Pakhanpura BO": "233227",
      "Shahbazkuli BO": "233227",
      "Belsari BO": "233302",
      "Dhanaipur BO": "233302",
      "Miranpur BO": "233303",
      "Barhat BO": "233311",
      "Dhari Kala BO": "233311",
      "Katghara BO": "233311",
      "Parsotia BO": "233311",
      "Akarmpur Banjaripur BO": "233002",
      "Fadanpur BO": "233002",
      "Jaitpura BO": "233002",
      "Sarai Gokul BO": "233002",
      "Amehta BO": "233223",
      "Newada BO": "233223",
      "Derhgawan BO": "232328",
      "Pakari BO": "232328",
      "Bahariabad BO": "275204",
      "Dora BO": "275204",
      "Hurmuzpur BO": "275204",
      "Mirpur BO": "275204",
      "Shishuapar BO": "275204",
      "Basupur BO": "233304",
      "Deochandpur BO": "233304",
      "Semaur BO": "233222",
      "Barsara BO": "233232",
      "Dinapur BO": "233232",
      "Alipur Madara BO": "275203",
      "Orasan BO": "275203",
      "Sadarjahanpur BO": "275203",
      "Deokali BO": "232339",
      "Gandhinagar BO": "233225",
      "Hartmanpur BO": "233225",
      "Rajapur Katya BO": "233230",
      "Sidhaut BO": "233230",
      "Lauwadih BO": "233233",
      "Reosara BO": "233233",
      "Chaura BO": "233310",
      "Barahi BO": "233226",
      "Dorasar BO": "233226",
      "Ghariha BO": "233226",
      "Matehu BO": "233226",
      "Murtazipur BO": "233227",
      "Dhelwa BO": "233302",
      "Kusumhi Kalan BO": "233302",
      "Sauram BO": "233302",
      "Bauri BO": "233303",
      "Chilar BO": "233311",
      "Pahalwanpur BO": "233311",
      "Atwa Fatehpur BO": "233002",
      "Chhawani Line BO": "233002",
      "Hussainpur BO": "233002",
      "Kaithwalia BO": "233002",
      "Rauza BO": "233002",
      "Talwal BO": "233002",
      "Bahediya BO": "233223",
      "Gauri BO": "233223",
      "Akbarpur BO": "275204",
      "Gadaipur BO": "275204",
      "Maudhia BO": "275204",
      "Salempur Baghai BO": "275204",
      "Ukraon BO": "275204",
      "Chaktaj Katghara BO": "233304",
      "Daulatpur BO": "233304",
      "Ghazipur HO": "233001",
      "Aurihar SO": "233221",
      "Bahadurganj": "275201",
      "Deoria SO Ghazipur": "232340",
      "Gahmar Bazar SO": "232327",
      "Ghazipur City SO": "233001",
      "Jakhania SO": "275203",
      "Mardah SO": "233226",
      "Peernagar SO": "233002",
      "Rampur SO Ghazipur": "233223",
      "Reotipur SO": "232328",
      "Saidpur Bazar SO": "233304",
      "Satramganj Bazar SO": "232333",
      "Tarighat SO": "232332",
      "Zamania RS SO": "232331",
      "Sherpur Kalan SO": "233234",
      "BARA": "232325",
      "Dharhni SO": "232336",
      "Dildarnagar Bazar SO": "232326",
      "Gahmar SO": "232327",
      "Gangauli SO": "233222",
      "Ghazipur RS SO": "233001",
      "Khardiha SO": "233233",
      "Malikpura SO": "233310",
      "Mubarakpur SO Ghazipur": "233301",
      "Sadat SO": "275204",
      "Subhashnagar SO Ghazipur": "233001",
      "Zamania Bazar SO": "232329",
      "BARACHAWAR SO": "233229",
      "BHIMAPAR SO": "233307",
      "BIRNO SO": "233300",
      "Karanda SO": "233224",
      "Kasimabad SO": "233230",
      "Mohammadabad Yusufpur SO": "233227",
      "Saidpur SO Ghazipur": "233304",
      "Shadiabad SO": "275205",
      "Tajpur Dehma SO": "233228",
      "Usia SO": "232330",
      "Yusufpur Bazar SO": "233227",
      "SUHWAL SO": "232341",
      "BHAWARKOL SO": "233231",
      "DEGREE COLLEGE SO": "233001",
      "Deokali SO": "233306",
      "Dildarnagar SO": "232326",
      "Dullahpur SO": "275202",
      "Goshandepur SO": "233232",
      "Karahiya SO": "232339",
      "Karimuddinpur SO": "233225",
      "Markeenganj SO": "233001",
      "Nandganj SO": "233302",
      "Nonhara SO": "233303",
      "NSS Mill SO": "233311",
      "Zamania SO": "232329",
      "ZANGIPUR SO": "233305"
    },
    "ETAWAH": {
      "Hardoi BO": "206253",
      "Kathua BO": "206253",
      "Kharduli BO": "206253",
      "Birondhi BO": "206242",
      "Garhwana BO": "206242",
      "Sirsa BO": "206253",
      "Kheda Helu BO": "206253",
      "Baharpur BO": "206242",
      "Ber BO": "206242",
      "Kharkauli BO": "206253",
      "Kumahwar BO": "206253",
      "Rahin BO": "206253",
      "Santoshpur Ghat BO": "206253",
      "Garha Kasda BO": "206121",
      "Kariyawali BO": "206121",
      "Bojha BO": "206120",
      "Pilkhana BO": "206120",
      "Fatehpura BO": "206124",
      "Ingurri BO": "206124",
      "Ludhiani BO": "206124",
      "Prithvirampur BO": "206124",
      "Beena BO": "206123",
      "Kadampur BO": "206123",
      "Ureng BO": "206120",
      "Kharagpur Saraiya BO": "206123",
      "Parasana BO": "206123",
      "Punja BO": "206123",
      "Purela BO": "206123",
      "Sarsai Helu BO": "206123",
      "Sarsai Nawar BO": "206123",
      "Usrahar BO": "206123",
      "Chakwa Bujurg BO": "206253",
      "Puraoli BO": "206128",
      "Pilkhar BO": "206003",
      "Barauli Jamunapar BO": "206131",
      "Barhpura BO": "206131",
      "Gati BO": "206131",
      "Pachhayagaon BO": "206131",
      "Ginja BO": "206130",
      "Bhareh BO": "206121",
      "Indrawakhi BO": "206120",
      "Gulabpura BO": "206124",
      "Sherpur BO": "206124",
      "Kauwa BO": "206123",
      "Moonj BO": "206123",
      "Abhinaypur Pathakpur BO": "206253",
      "Musaoli BO": "206003",
      "Larkhaur BO": "206130",
      "Ajabpur BO": "206131",
      "Jarhauli BO": "206131",
      "Niwarikalan BO": "206120",
      "Bijauli BO": "206124",
      "Ghughsina BO": "206124",
      "Kunetha BO": "206124",
      "Bakauli BO": "206123",
      "Chaubia BO": "206123",
      "Karri BO": "206123",
      "Baroli Khurd BO": "206253",
      "Ujhiani BO": "206128",
      "Chitbhawan BO": "206003",
      "Manikpur Bissu BO": "206003",
      "Kuiya BO": "206130",
      "Heonra BO": "206130",
      "Bahuri BO": "206131",
      "Garhaita BO": "206131",
      "Jaitpura Par BO": "206131",
      "Kamet BO": "206131",
      "Murong BO": "206131",
      "Kakrahi BO": "206242",
      "Maman BO": "206242",
      "Merhi Dudhi BO": "206242",
      "Nagaria Yadwan BO": "206242",
      "Pali Khurd BO": "206242",
      "Sahson BO": "206125",
      "Sindaus BO": "206125",
      "Titawali BO": "206125",
      "Birari BO": "206126",
      "Karwa Bujurg BO": "206126",
      "Ritaur BO": "206126",
      "Vaidpura BO": "206002",
      "Pratapner BO": "206002",
      "Balrai BO": "206245",
      "Bauth BO": "206245",
      "Jasohan BO": "206245",
      "Kandheshi Pachar BO": "206242",
      "Kunwara BO": "206242",
      "Sainfi BO": "206242",
      "Samthar BO": "206242",
      "Sarai Chauri BO": "206242",
      "Kursena BO": "206245",
      "Sirhaul BO": "206245",
      "Sishat BO": "206245",
      "Vijaypura BO": "206245",
      "Takrupur BO": "206127",
      "Andawa BO": "206128",
      "Girdharipura BO": "206242",
      "Kushna BO": "206242",
      "Takha BO": "206242",
      "Umarsenda BO": "206242",
      "College Road Bharthana BO": "206242",
      "Purana Bharthana BO": "206242",
      "Bidauri BO": "206125",
      "Bindwa Kalan BO": "206125",
      "Bithauli BO": "206125",
      "Jhabrapura BO": "206245",
      "Kaisth BO": "206245",
      "Kokawali BO": "206245",
      "Dhanua BO": "206245",
      "Bahadurpurghar BO": "206127",
      "Ekari BO": "206127",
      "Eknaur BO": "206127",
      "Bachheri BO": "206125",
      "Barechha BO": "206125",
      "Chaurela BO": "206125",
      "Kandheshi Ghar BO": "206125",
      "Rajpur BO": "206125",
      "Baisolighat BO": "206126",
      "Dadora BO": "206126",
      "Maniamau BO": "206126",
      "Prithvipur BO": "206126",
      "Adhiyapur BO": "206002",
      "Sarangpura BO": "206002",
      "Bibamau BO": "206245",
      "Dharwar BO": "206245",
      "Jagsora BO": "206245",
      "Malajani BO": "206245",
      "Nagla Taur BO": "206245",
      "Niloi BO": "206245",
      "Chandpura BO": "206127",
      "Chindauli BO": "206127",
      "Paharpur BO": "206127",
      "Kudrail BO": "206242",
      "Malhausi BO": "206242",
      "Ramain BO": "206242",
      "Samhon BO": "206242",
      "Sarawa BO": "206242",
      "Bansari BO": "206125",
      "Bindwa Khurd BO": "206125",
      "Gauhani BO": "206125",
      "Jagtauli BO": "206125",
      "Piprauli Gadhia BO": "206125",
      "Chandanpur BO": "206126",
      "Mugalpur Naraini BO": "206126",
      "Datawali BO": "206002",
      "Garhi Ram Dhan BO": "206245",
      "Nagla Ram Sunder BO": "206245",
      "Bidhipura BO": "206127",
      "Durgapura BO": "206127",
      "Nandgawan BO": "206127",
      "Lavedi BO": "206127",
      "Etawah HO": "206001",
      "Aheripur SO": "206120",
      "Ashok Nagar SO Etawah": "206001",
      "Bakewar SO": "206124",
      "Bharthana SO": "206242",
      "Etawah Kutchery SO": "206001",
      "Jaswant Nagar SO": "206245",
      "Lakhana SO": "206127",
      "Lalpura Etawah SO": "206001",
      "Bajaria SO": "206001",
      "Basrehar SO": "206253",
      "Chakar Nagar SO": "206125",
      "Satyawadi Etawah SO": "206001",
      "Baralokpur SO": "206123",
      "Distt Board  Etawah SO": "206001",
      "Ekdil SO": "206126",
      "Etawah City SO": "206001",
      "Etawah New City SO": "206001",
      "K K D C Etawah SO": "206001",
      "Mandir Mahewa SO": "206128",
      "Ram Lila Road SO": "206003",
      "Udi SO": "206131",
      "I T I Etawah SO": "206002",
      "Jaswant Nagar Bazar SO": "206245",
      "Saifai SO": "206130"
    },
    "GAUTAM BUDDHA NAGAR": {
      "Chhapraula BO": "201009",
      "Parsol BO": "203201",
      "Chiti BO": "203202",
      "Rasool pur  Rithaury BO": "203202",
      "Wair BO": "203202",
      "Bilaspur BO": "203202",
      "Bhunna  Jattan BO": "203141",
      "Chingrawly BO": "203141",
      "Firoujpur BO": "203141",
      "Hasanpur BO": "203141",
      "Mangrauli BO": "203135",
      "Sabota Zafrabad BO": "203135",
      "Mahmoodpur Jadon BO": "203203",
      "Salempur  Jat BO": "203203",
      "Wailana BO": "203203",
      "Ahamedpur  Chauroli BO": "203155",
      "Runhera BO": "203155",
      "Jawan BO": "203141",
      "Lodana BO": "203141",
      "Narmohamadpur BO": "203141",
      "Ram  Garhi BO": "203141",
      "Shahpur  Kala BO": "203141",
      "Dayanatpur BO": "203135",
      "Banchaoli BO": "203203",
      "Bichhat Sujanpur BO": "203203",
      "Biraundi Tajpur BO": "203203",
      "Ronija BO": "203209",
      "Tirthaly BO": "203209",
      "Bankapur BO": "203155",
      "Chanchali BO": "203155",
      "Dhanouri   Kalan BO": "203201",
      "Mirzapur Niloni BO": "203201",
      "Baroda BO": "203202",
      "Deota BO": "203202",
      "Salempur  Gujar BO": "203202",
      "Bhaipur BO": "203141",
      "Chhapana BO": "203141",
      "Gotheny BO": "203141",
      "Faleda BO": "203135",
      "Kureb BO": "203135",
      "Chola BO": "203203",
      "Jhajhar BO": "203203",
      "Sunpera BO": "203203",
      "Karauli Banger BO": "203209",
      "Manchad BO": "203155",
      "Neemka BO": "203155",
      "Nawada BO": "203201",
      "Astauly BO": "203202",
      "Kanigarhi BO": "203135",
      "Dhanaura BO": "203203",
      "Khabra  Khanpur BO": "203203",
      "Bhaipur  Brahmanan BO": "203209",
      "Kishore Pur BO": "203155",
      "Akbarpur Churai BO": "212652",
      "Kot BO": "201314",
      "Luharli BO": "201314",
      "Sainthli BO": "201314",
      "Kasna BO": "201312",
      "Maicha BO": "201312",
      "Nagla Charandas BO": "201305",
      "Behrampur BO": "201314",
      "Bambawar BO": "203207",
      "Chainsa BO": "201314",
      "Jarcha BO": "203207",
      "Khandera BO": "201314",
      "Kheri Bhanota BO": "201311",
      "Bedpura BO": "203207",
      "Sakipur BO": "201310",
      "Baraula BO": "201304",
      "Gejha BO": "201304",
      "Sarfabad BO": "201307",
      "Piaoli BO": "201008",
      "Achheja BO": "203207",
      "Kalaunda BO": "203207",
      "Khatana BO": "203207",
      "Pali BO": "201311",
      "Kulesra BO": "201306",
      "Ghori BO": "201310",
      "Chhaprauli Bengar BO": "201304",
      "Salarpur Kalan BO": "201008",
      "Tilapta Karanwas BO": "201311",
      "Chholas BO": "201314",
      "Chithera BO": "201314",
      "Dhoom BO": "203207",
      "Dujana BO": "203207",
      "Kachera Versabad BO": "203207",
      "Chhajarsi BO": "201309",
      "Bisara BO": "201008",
      "Gurukul  Sikandrabad SO": "203202",
      "Rabupura SO": "203209",
      "Jewar SO": "203135",
      "Thora SO": "203155",
      "Noida HO": "201301",
      "Dankaur SO": "203201",
      "Jahangirpur SO": "203141",
      "Kakore SO": "203203",
      "Knowledge ParkI SO": "201310",
      "Sec 16 Noida SO": "201301",
      "Sec37 Noida SO": "201303",
      "NDC Noida": "201302",
      "Container Depot SO": "201311",
      "Dadri SO": "203207",
      "Sec 27 Noida SO": "201301",
      "Sec41 Noida SO": "201303",
      "Sec45 Noida SO": "201303",
      "Vidyut Nagar SO": "201008",
      "CRPF Greater Noida SO": "201306",
      "Sec 122 Noida SO": "201316",
      "Maharshi Nagar SO": "201304",
      "NEPZ SO": "201305",
      "Sec34 Noida SO": "201307",
      "Sec55 Noida SO": "201309",
      "Sec62 Noida SO": "201309",
      "Gurjinder Vihar SO": "201315",
      "Alpha Greater Noida SO": "201310",
      "Amity university SO": "201313",
      "Gautam Budh University SO": "201312",
      "IA Surajpur SO": "201306",
      "Sec 12 Noida SO": "201307",
      "Sector 30 Noida SO": "201303",
      "Shiv Nadar University SO": "201314",
      "Sec 01 Greater Noida SO": "201318",
      "Sec 128 Noida SO": "201317"
    },
    "Kasganj": {
      "Nadarmai BO": "207241",
      "Sarsai Narau BO": "207241",
      "Harsena BO": "207124",
      "Jakhera BO": "207124",
      "Kudhar BO": "207124",
      "Mubarik Pur Mafi BO": "207124",
      "Kadarganj BO": "207242",
      "Mohanpur BO": "207242",
      "Singpur BO": "207242",
      "Sunngarhi BO": "207242",
      "Behta BO": "207123",
      "Gorha BO": "207123",
      "Kayampur Baheria BO": "207123",
      "Mahdava BO": "207123",
      "Mihari BO": "207123",
      "Nagla Katila BO": "207123",
      "Rekhpur BO": "207123",
      "Baznagar BO": "207402",
      "Jagpura BO": "207243",
      "Khaduya BO": "207243",
      "Myau BO": "207243",
      "Bhargain BO": "207244",
      "Kinawa BO": "207124",
      "Abhaipura BO": "207241",
      "Karsana BO": "207241",
      "Sujrai BO": "207241",
      "Kumraua BO": "207124",
      "Jasmai BO": "207248",
      "Bastarmau BO": "207242",
      "Midhola Bujurg BO": "207242",
      "Sikehara BO": "207242",
      "Ballia BO": "207243",
      "Narthar BO": "207243",
      "Thana Darioganj BO": "207243",
      "Kachhela BO": "207245",
      "Myasur BO": "207245",
      "Pachgain BO": "207124",
      "Bahrojpur BO": "207242",
      "Chirola BO": "207242",
      "Tilsai BO": "207123",
      "Ashokpur BO": "207243",
      "Aurangabad BO": "207243",
      "Bahdola BO": "207243",
      "Raja Rijola BO": "207243",
      "Rajepur Kurra BO": "207243",
      "Sahori BO": "207243",
      "Sanauri Khas BO": "207243",
      "Amirasa BO": "207245",
      "Faroli BO": "207245",
      "Jahangirpur BO": "207245",
      "Yakootganj BO": "207245",
      "Arjunpur Nauabad BO": "207241",
      "Tharachithara BO": "207241",
      "Kisarauli BO": "207124",
      "Mahawar BO": "207124",
      "Nameni BO": "207124",
      "Sarawal BO": "207248",
      "Garka BO": "207242",
      "Karampur BO": "207242",
      "Nagla Bhimsen BO": "207242",
      "Samaspur BO": "207242",
      "Pathreki BO": "207123",
      "Salai BO": "207123",
      "Gaupura BO": "207402",
      "Roshan Nagar BO": "207402",
      "Bahora BO": "207243",
      "Hathodaban BO": "207243",
      "Nardoli BO": "207243",
      "Khojpur BO": "207245",
      "Devri Prahlad Pur BO": "207403",
      "Ganga Garh BO": "207403",
      "Badria BO": "207403",
      "Wazirpur BO": "207123",
      "Dholna BO": "207124",
      "Aun BO": "207246",
      "Bhensrasi BO": "207246",
      "Nadrai BO": "207123",
      "Bhujpura BO": "207246",
      "Dhondhara BO": "207246",
      "Magthara BO": "207246",
      "Goyati BO": "207403",
      "Salempur Bebe BO": "207403",
      "Sirawali BO": "207403",
      "Virahampuri BO": "207403",
      "Nawab Ganj BO": "207123",
      "Fatehpur BO": "207246",
      "Khiriya Patti BO": "207246",
      "Pilkhuni BO": "207246",
      "Kadarwadi BO": "207403",
      "Malikpur BO": "207403",
      "Mehmood Pur Pukhata BO": "207403",
      "Dhansinghpur BO": "207246",
      "Kamalpur BO": "207246",
      "Naugaon BO": "207246",
      "Pithanpur BO": "207246",
      "Sultanpur BO": "207246",
      "Khairpur BO": "207403",
      "Bilram SO": "207124",
      "Soron SO": "207403",
      "Gunjdundwara SO": "207242",
      "Neoli SO": "207402",
      "Barahdwari SO": "207123",
      "Kasganj SO": "207123",
      "Patiali SO": "207243",
      "Sirhpura SO": "207246",
      "Kasganj RS SO": "207123",
      "Sahawar SO": "207245"
    },
    "FIROZABAD": {
      "Gangauli BO": "224172",
      "Jagdishpur BO": "224172",
      "Kumbhiya BO": "224172",
      "Punhad BO": "224172",
      "Anjana BO": "224172",
      "Bhadauli BO": "224172",
      "Sihoriya BO": "224172",
      "Akalabad Hasanpur BO": "283203",
      "Alhadadpur BO": "283203",
      "Dolupura BO": "283203",
      "Basai Mohammadpur BO": "283203",
      "Gudaun BO": "283203",
      "Pendat BO": "283152",
      "Suraya BO": "283152",
      "Jatau BO": "283206",
      "Narkhi BO": "283206",
      "Okhra BO": "283206",
      "Sekhupur  Hatwant BO": "283145",
      "Viltigarh BO": "283145",
      "Husainpur BO": "283103",
      "Jarakhi BO": "283103",
      "Usneedha BO": "283130",
      "Bachhela Bachheli BO": "283142",
      "Mustfabad BO": "283207",
      "Pilakhatar BO": "283207",
      "Kaitha BO": "283207",
      "Harha BO": "283141",
      "I L C Shikohabad BO": "283141",
      "Keshari BO": "283141",
      "Madhoganj BO": "283141",
      "Jaymai BO": "283151",
      "Madanpur BO": "283151",
      "Paigu BO": "283151",
      "Saray Murlidhar BO": "283151",
      "Bachhagaon BO": "283204",
      "Dheerpura BO": "283204",
      "Nagla Beech BO": "283204",
      "Nepai BO": "283203",
      "Firozabad Bazar BO": "283203",
      "Gazipur BO": "283203",
      "Mainpuri Gate  Firozabad BO": "283203",
      "Asan BO": "283203",
      "Chandwar BO": "283203",
      "Bhadana BO": "283152",
      "Bhagner BO": "283152",
      "Nagla Nahar BO": "283152",
      "Bahat BO": "283136",
      "Banbara BO": "283136",
      "Jhapara BO": "283136",
      "Kaurara Bujurga BO": "283136",
      "Bartara BO": "283206",
      "Kanwara BO": "283145",
      "Kurri Kuppa BO": "283103",
      "Nagla Dheer BO": "283130",
      "Nagla Kanchan BO": "283130",
      "Kharaua BO": "283142",
      "Keshpura BO": "283207",
      "Asua BO": "283141",
      "Gurha BO": "283141",
      "Nagla Bajdar BO": "283141",
      "Dakhinara BO": "283135",
      "A G M Bhawali BO": "283151",
      "Chulhawali BO": "283204",
      "Himmatpur BO": "283204",
      "Mersena BO": "283204",
      "Bhondela BO": "283204",
      "Mohammdabad BO": "283204",
      "Ali Nagar Kenjra BO": "283203",
      "Bilhena BO": "283203",
      "Gonchh BO": "283203",
      "Pachwan BO": "283203",
      "Jarauli Kalan BO": "283203",
      "Dokeli BO": "283203",
      "Sarhamai BO": "283203",
      "Farida BO": "283152",
      "Katana BO": "283152",
      "Gopalpur BO": "283152",
      "Akbarpur Kutukpur BO": "283136",
      "Kushiyari BO": "283136",
      "Patti BO": "283136",
      "Gangni BO": "283206",
      "Jajumai BO": "283145",
      "Khairgarh BO": "283145",
      "Sarhupur BO": "283145",
      "Baghai BO": "283103",
      "Kotaki BO": "283103",
      "Usayani BO": "283103",
      "Kadipur BO": "283130",
      "Kharit BO": "283130",
      "Bhadan BO": "283142",
      "Kaurari Kherha BO": "283142",
      "Nagla Gulal BO": "283142",
      "Ruchan  Manikpur BO": "283142",
      "Dhatari BO": "283135",
      "Mandai BO": "283135",
      "Thanumai BO": "283135",
      "Urmura BO": "283135",
      "Jaundhary BO": "283204",
      "Katki BO": "283204",
      "Nagla Dutt BO": "283204",
      "Nagla Sikander BO": "283204",
      "Pachokhara BO": "283204",
      "Rasoolabad BO": "283204",
      "Salempur BO": "283136",
      "Tikari BO": "283204",
      "Ummargarh BO": "283204",
      "Rupaspur BO": "283203",
      "Asafabad BO": "283203",
      "Matsena BO": "283203",
      "Jakhai BO": "283203",
      "Raipura BO": "283203",
      "Datawali BO": "283203",
      "JALALPUR BO": "283203",
      "MOINUDINPUR BO": "283203",
      "Kailai BO": "283152",
      "Uresar BO": "283152",
      "Milawali BO": "283136",
      "Dorsa BO": "283206",
      "Ketana Harsha BO": "283145",
      "Pratappur BO": "283145",
      "Hirangaon BO": "283103",
      "Bara Gaon BO": "283130",
      "Kheria Patikara BO": "283130",
      "Balipur BO": "283142",
      "Garhsan BO": "283142",
      "Ukhrend BO": "283142",
      "Urawarhastref BO": "283142",
      "Konder BO": "283207",
      "Ghaghau BO": "283141",
      "Nasirpur BO": "283141",
      "Amaur Nagla Jeevan BO": "283151",
      "Karhara BO": "283151",
      "Saray Bhartara BO": "283151",
      "Sothara BO": "283151",
      "Tilyani BO": "283151",
      "Dev Kherha BO": "283204",
      "Gondai BO": "283204",
      "Gwari Nagla Singhi BO": "283204",
      "Mohammadi BO": "283204",
      "Pamari BO": "283204",
      "Rajawali BO": "283204",
      "Rajmal BO": "283204",
      "Firozabad HO": "283203",
      "Makkhanpur SO": "283145",
      "Oef  Firozabad SO": "283103",
      "Sirsaganj SO": "283151",
      "Bara Bazar Shikohabad SO": "283135",
      "Jasrana SO": "283136",
      "Parham SO": "283130",
      "Pariyar SO": "283142",
      "Shikohabad RS SO": "283141",
      "Tundla SO": "283204",
      "Tundla Chauraha SO": "283204",
      "Collectorate firozabad SO": "283205",
      "Eka SO": "283152",
      "Labour Collony  Firozabad SO": "283203",
      "Phariha SO": "283207",
      "Railway Road Firozabad SO": "283203",
      "Narayan Nagar SO": "283203",
      "Rasulabad SO": "224172",
      "Kotla SO Firozabad": "283206",
      "S N H Road Firozabad SO": "283203",
      "Shikohabad SO": "283135"
    },
    "SHRAVASTI": {
      "Chahalwa BO": "271831",
      "Dudhwania BO": "271831",
      "Ekgharwa BO": "271831",
      "Gothwa BO": "271831",
      "Hariharpur Rani BO": "271831",
      "Pure Gokul Singh BO": "271831",
      "Ramgarhi BO": "271831",
      "Samari Chak Pihani BO": "271831",
      "Bairagijot BO": "271831",
      "Bhangha BO": "271831",
      "Janki Nagar BO": "271831",
      "Jokhwa Bazar BO": "271831",
      "Mujehna BO": "271831",
      "Parsa Deharia BO": "271831",
      "Aggapur BO": "271831",
      "Akbarapur Semra BO": "271831",
      "Kishun Pur Chand Bhari BO": "271831",
      "Kotwa BO": "271831",
      "Laxmanpur Bazar BO": "271831",
      "Machhrihwa BO": "271831",
      "Naubasta BO": "271831",
      "Parasrampur BO": "271831",
      "Bachkahwa BO": "271840",
      "Badal Pur BO": "271840",
      "Beerpur BO": "271840",
      "Bhartha Rosan Garh BO": "271840",
      "Gabbapur BO": "271840",
      "Bishunapur BO": "271804",
      "Gulara BO": "271840",
      "Amwa BO": "271831",
      "Banthihwa BO": "271831",
      "Jogin Bharia BO": "271831",
      "Patna Khargaura BO": "271831",
      "Kathara Bazar BO": "271803",
      "Shahpur Bara BO": "271835",
      "Siswara BO": "271835",
      "Takiya BO": "271845",
      "Tendwa Mahanth BO": "271845",
      "Dikuali BO": "271804",
      "Doobkalan BO": "271804",
      "Hasnapur BO": "271804",
      "Laxmanpur Semrahniya BO": "271804",
      "Bhagwanpur Bhaisahi BO": "271803",
      "Gopala Sarai BO": "271803",
      "Jamunaha Heera Singh BO": "271803",
      "Maharu Murtiha BO": "271803",
      "Shikari Chanda BO": "271803",
      "Sitkahana BO": "271803",
      "Babhni BO": "271840",
      "Chetia Murar BO": "271835",
      "Dharsawan BO": "271835",
      "Jaichandpur BO": "271835",
      "Balapur BO": "271845",
      "Bhutaha BO": "271845",
      "Dhanuhi BO": "271845",
      "Ganeshpur BO": "271845",
      "Amrahwa BO": "271803",
      "Jamdan BO": "271803",
      "Kalkalwa BO": "271803",
      "Mahdeiya BO": "271805",
      "Beer Pur Khairaniya BO": "271201",
      "Bhatpurwa Kala BO": "271201",
      "Kanibojhi BO": "271803",
      "Laxmanpur Kothi BO": "271803",
      "Puredeen Namgarh BO": "271805",
      "Katha BO": "271835",
      "Rampur Painda BO": "271835",
      "Vijaypur Sisawan BO": "271835",
      "Khargaura Janoob BO": "271845",
      "Manoharapur BO": "271845",
      "Bhausawan BO": "271804",
      "Ramnagra BO": "271804",
      "Sonwan BO": "271804",
      "Raideeh BO": "271835",
      "Semgarha BO": "271835",
      "Khajurar BO": "271845",
      "Madara BO": "271845",
      "Sonrai BO": "271845",
      "Nasirganj BO": "271804",
      "Shahpur Kathotia BO": "271804",
      "Hempur BO": "271840",
      "Shankarpur BO": "271840",
      "Taal Baghaura BO": "271840",
      "Pure Wale BO": "271840",
      "Shahpur Bargadwa BO": "271840",
      "Katkuiya BO": "271840",
      "Madhwapur BO": "271840",
      "Medikiya BO": "271840",
      "Motipur BO": "271840",
      "Jabdi BO": "271840",
      "Pure Prasad BO": "271840",
      "Ranipur BO": "271840",
      "Sonbarsa BO": "271840",
      "Titiharia BO": "271840",
      "Gilaula SO": "271835",
      "Ikauna SO": "271845",
      "Laxman Nagar Bazar SO": "271804",
      "Patna Malhipur SO": "271803",
      "Bhinga SO": "271831",
      "Shravasti SO": "271805",
      "Sirsia SO": "271840"
    },
    "DEORIA": {
      "Govindpur BO": "274405",
      "Madrapali Bharth Rai BO": "274405",
      "Fatehpur BO": "274204",
      "Jogia Buzurg BO": "274204",
      "Chakarawa Bahordas BO": "274509",
      "Mathura Chhapar BO": "274405",
      "Jokaha Khas BO": "274204",
      "Kanhauli BO": "274204",
      "Karauta BO": "274204",
      "Mahiganj BO": "274204",
      "Manga Kodar BO": "274204",
      "Pipara Kachhar BO": "274204",
      "Shitalmajha BO": "274204",
      "Bakuchi BO": "274808",
      "Babhani BO": "274807",
      "Bardihadal BO": "274204",
      "Ekla Mishraulia BO": "274204",
      "Korawa BO": "274204",
      "Tiwai BO": "274204",
      "Ahirauli BO": "274509",
      "Balepur BO": "274509",
      "Gaura BO": "274405",
      "Pipra Madan Gopal BO": "274405",
      "Sidhua BO": "274405",
      "Baurdih BO": "274502",
      "Chhapauli BO": "274204",
      "Koilgarha BO": "274204",
      "Laxmipur BO": "274204",
      "Tara Sara BO": "274204",
      "Barthi BO": "274808",
      "Chero BO": "274808",
      "Belwa BO": "274405",
      "Katrari BO": "274806",
      "Majhgaon BO": "274806",
      "Rampur Awasthi BO": "274807",
      "Bardgonia BO": "274201",
      "Nawapar BO": "274601",
      "Parsia Dewar BO": "274601",
      "Sonari BO": "274601",
      "Deosia BO": "274602",
      "Israuli BO": "274602",
      "Belwa Baboo BO": "274701",
      "Bharahey Chaura BO": "274701",
      "Dumari BO": "274701",
      "Nonapar BO": "274701",
      "Bahiari Baghel BO": "274702",
      "Bara Dixit BO": "274603",
      "Deogaon BO": "274202",
      "Kalaban BO": "274202",
      "Kataura BO": "274202",
      "Sirjam Khas BO": "274202",
      "Jaitpura BO": "274501",
      "Karaundi BO": "274501",
      "Majhwalia BO": "274501",
      "Noonkhar BO": "274501",
      "Bagaha BO": "274505",
      "Matiara Jagdish BO": "274502",
      "Mehraunaghat BO": "274502",
      "Nadauli BO": "274502",
      "Sutawar BO": "274502",
      "Jamira BO": "274205",
      "Khareshar BO": "274205",
      "Naipur BO": "274205",
      "Nakail BO": "274205",
      "Kodara BO": "274506",
      "Mahuja BO": "274506",
      "Payasi BO": "274506",
      "Hata BO": "274703",
      "Rahimpur BO": "274703",
      "Ratsia BO": "274703",
      "Bishunpura Bazar BO": "274404",
      "Kotwa Misir BO": "274404",
      "Mehaharhangpur BO": "274404",
      "Pakaha BO": "274404",
      "Ajana BO": "274508",
      "Ametahi BO": "274405",
      "Baliawan BO": "274405",
      "Bhikhampura BO": "274405",
      "Deoria Budhoo Khan BO": "274405",
      "Garer BO": "274807",
      "Hata Banuadih BO": "274807",
      "Lahilpar BO": "274807",
      "Piperpanti BO": "274807",
      "Batulahi BO": "274201",
      "Chhitahi Bazar BO": "274201",
      "Ranihawa BO": "274201",
      "Udhopur BO": "274201",
      "Inguri Bazar BO": "274704",
      "Parsia Chhitani Singh BO": "274704",
      "Bhaidava BO": "274601",
      "Nandana BO": "274601",
      "Nema BO": "274602",
      "Takia BO": "274602",
      "Karmtar Sher Khan BO": "274182",
      "Thakur Deoria BO": "274182",
      "Padari Bazar BO": "274701",
      "Pipara Dixit BO": "274701",
      "Rampur Khori Bari BO": "274701",
      "Barka Gaon BO": "274702",
      "Bhingari Bazar BO": "274702",
      "Kothilwa BO": "274702",
      "Pakri Baboo BO": "274702",
      "Sawarenji BO": "274702",
      "Bhulaipur BO": "274603",
      "Kaparwar BO": "274603",
      "Jogam BO": "274202",
      "Khaira Banua BO": "274202",
      "Labkani BO": "274202",
      "Lerha BO": "274202",
      "Balua Afgan BO": "274705",
      "Raibari BO": "274705",
      "Baidauli BO": "274501",
      "Barhara BO": "274807",
      "Bardiha Parsuram BO": "274505",
      "Dharmer BO": "274505",
      "Pipara Mishir BO": "274505",
      "Ropan Chhapara BO": "274502",
      "Pipara Chandrabhan BO": "274807",
      "Kushahari BO": "274807",
      "Gotha Rasoolpur BO": "274201",
      "Karjahan BO": "274603",
      "Sohanpur BO": "274704",
      "Koraya BO": "274182",
      "Langra Bazar BO": "274182",
      "Marhawa BO": "274182",
      "Tekua BO": "274182",
      "Sisawa BO": "274701",
      "Kukur Ghanti BO": "274702",
      "Maripar BO": "274702",
      "Sarya BO": "274702",
      "Tikampar BO": "274702",
      "Bishunpura Dewar BO": "274603",
      "Khori BO": "274603",
      "Kotpur Pipra BO": "274603",
      "Mahen BO": "274603",
      "Mirjapur BO": "274603",
      "Bakhara Khas BO": "274202",
      "Belkunda BO": "274202",
      "Patherhat BO": "274202",
      "Sadhopur BO": "274202",
      "Pipara Shukul BO": "274501",
      "Sallahpur BO": "274501",
      "Panika Bazar BO": "274505",
      "Churia BO": "274502",
      "Kasili BO": "274604",
      "Mauna Garhwa BO": "274604",
      "Bansopatti BO": "274703",
      "Baraon BO": "274205",
      "Bhera Pakar BO": "274506",
      "Andila BO": "274604",
      "Garauna BO": "274604",
      "Satraon BO": "274604",
      "Tikar BO": "274604",
      "Bankul BO": "274703",
      "Bhawani Chapar BO": "274703",
      "Baghauchghat BO": "274404",
      "Pandaypur BO": "274404",
      "Sakutai BO": "274404",
      "Shahpur Shukla BO": "274404",
      "Khema Dei BO": "274508",
      "Dhanauti Khurd BO": "274807",
      "Siswa Panday BO": "274806",
      "Sonughat BO": "274807",
      "Badhaya Buzurg BO": "274806",
      "Deoria Meer BO": "274807",
      "Paikauli Maharaj BO": "274806",
      "Barpar BO": "274201",
      "Baurdih Tiwari BO": "274201",
      "Kauntey Nagar BO": "274201",
      "Barnai BO": "274201",
      "Balua BO": "274704",
      "Barakagaon BO": "274601",
      "Markara BO": "274601",
      "Nariaon BO": "274602",
      "Reoli BO": "274602",
      "Peokol BO": "274701",
      "Puraini BO": "274701",
      "Ahirauli Baghel BO": "274702",
      "Bankata Amethia BO": "274702",
      "Bhathwa Tiwari BO": "274702",
      "Khampar BO": "274702",
      "Pipra Uttar Patti BO": "274702",
      "Karail Shukla BO": "274603",
      "Chariayan Buzurg BO": "274202",
      "Indupur BO": "274202",
      "Karmajeetpur BO": "274202",
      "Khairatia BO": "274202",
      "Mathia Sahu BO": "274202",
      "Sohasa BO": "274202",
      "Pipara Bithal BO": "274705",
      "Baikunthpur BO": "274501",
      "Bijapur Jhantaur BO": "274501",
      "Parsia Mishir BO": "274501",
      "DB Ashram BO": "274505",
      "Malkauli  BO": "274505",
      "Babhnauli Pandey BO": "274502",
      "Naini BO": "274502",
      "Rawatpar Amethia BO": "274502",
      "Chakarwa BO": "274205",
      "Samogar BO": "274205",
      "Bankata Misir BO": "274506",
      "Chanuki BO": "274506",
      "Dhaula Pandit BO": "274604",
      "Telia Kalan BO": "274604",
      "Bhopatpura BO": "274703",
      "Khurwasia BO": "274703",
      "Baghara BO": "274404",
      "Rampur Mahuabari BO": "274404",
      "Kharwania BO": "274508",
      "Sajaon BO": "274508",
      "Phulwaria Lachhi BO": "274807",
      "Belwania BO": "274807",
      "GIEstate BO": "274806",
      "Bairauna BO": "274807",
      "Bariarpur BO": "274807",
      "Parsia Jaddu BO": "274806",
      "Batrauli Pandey BO": "274807",
      "Dol Chhapra BO": "274509",
      "Dumwalia BO": "274509",
      "Madhawapur BO": "274509",
      "Sohnag BO": "274509",
      "Majha Narain BO": "274208",
      "Chordiha BO": "274509",
      "Pipara Ramdhar BO": "274808",
      "Baida BO": "274208",
      "Ekauna BO": "274208",
      "Sirsia Gotha BO": "274408",
      "Nautan Hathia Garh BO": "274206",
      "Pakri Birbhadra BO": "274206",
      "Nagawa Khas BO": "274208",
      "Kanchanpur BO": "274408",
      "Mahuapatan BO": "274408",
      "Mushari BO": "274408",
      "Bhatni Buzurg BO": "274206",
      "Pipra Daula Kadam BO": "274206",
      "Deoria  Urf Shampur BO": "274509",
      "Itahua Chandauli BO": "274808",
      "Rampur Buzurg BO": "274509",
      "Srinagar BO": "274509",
      "Belawa Dubauli BO": "274208",
      "Bhelaur BO": "274208",
      "Bajaratar Mahuawa BO": "274408",
      "Banjaria BO": "274408",
      "Thengval Dubey BO": "274509",
      "Tulsi Bara BO": "274509",
      "Pach Lari BO": "274208",
      "Pachrukha BO": "274208",
      "Piprajham BO": "274408",
      "Rampurgarh BO": "274408",
      "Sirsia Khohia BO": "274408",
      "Sohnaria BO": "274408",
      "Desahi Barwa BO": "274206",
      "Shahjahanpur BO": "274408",
      "Tigharakhairwa BO": "273413",
      "Bhatni Dadan BO": "274206",
      "Padauli Padiapar BO": "274206",
      "Deoria HO": "274001",
      "Bhagalpur SO": "274602",
      "Gaura Jai Nagar SO": "274603",
      "Khukhundoo SO": "274501",
      "Madanpur SO": "274205",
      "Pindi SO": "274508",
      "Rampur SO": "274405",
      "Baitalpur SO": "274201",
      "Barhaj SO": "274601",
      "Bhatpar Rani SO": "274702",
      "Gauri Bazar SO": "274202",
      "Lar Road SO": "274505",
      "Rudrapur SO": "274204",
      "SANT VINOBA MARG SO": "274807",
      "Salaempur SO": "274509",
      "Saraon SO": "274208",
      "Chakara Gosai SO": "274808",
      "Bhaluani SO": "274182",
      "DEORIA KUTCHARY SO": "274001",
      "Deoria Railway Station SO": "274806",
      "HANUMAN MANDIR SO": "274001",
      "NAI BAZAR SO": "274001",
      "Patherdewa SO": "274404",
      "Hetimpur S O": "274206",
      "Bankata SO": "274704",
      "Bhatani SO": "274701",
      "DEORIA NEW COLONY SO": "274001",
      "Ghanti SO": "274705",
      "Lar SO": "274502",
      "Majhauli Raj SO": "274506",
      "Paina SO": "274604",
      "Paratappur SO": "274703",
      "RAM GULAM TOLA SO": "274001",
      "Tarkulwa SO": "274408"
    },
    "JALAUN": {
      "Khanua BO": "285205",
      "Khutaila BO": "285205",
      "Kishunpura BO": "285205",
      "Daulatpur BO": "285125",
      "Gora Rathor BO": "285125",
      "Lohai BO": "285125",
      "Kursenda BO": "285126",
      "Kanasi BO": "285205",
      "Khairi BO": "285205",
      "Sadupura BO": "285205",
      "Salaiyya Buzurg BO": "285205",
      "Sami BO": "285205",
      "Sunaya BO": "285205",
      "Barsar BO": "285223",
      "Binaura BO": "285123",
      "Kurkuru BO": "285223",
      "Said Nagar BO": "285223",
      "Tikri BO": "285125",
      "Eekon BO": "285130",
      "Jakha BO": "285130",
      "Nipaniya BO": "285130",
      "Pipri Athgaiyan BO": "285130",
      "Simhara Kasimpur BO": "285130",
      "Chitaura BO": "285126",
      "Harauli BO": "285126",
      "Kailor BO": "285126",
      "Nunsai BO": "285001",
      "Bharsoonda BO": "285201",
      "Bilayan BO": "285201",
      "Birasni BO": "285201",
      "Birguwan Buzurg BO": "285201",
      "Dhurat BO": "285201",
      "Jakhauli BO": "285201",
      "Jamrohi Khurd BO": "285201",
      "Pindari BO": "285201",
      "Bhadreikhi BO": "285202",
      "Karamchandpur BO": "285202",
      "Kurahna Alamgir BO": "285202",
      "Masgaon BO": "285202",
      "Parasan BO": "285202",
      "Atarehati BO": "285121",
      "Garherna BO": "285121",
      "Gopalpura BO": "285121",
      "Mijhauna BO": "285121",
      "Naoli BO": "285121",
      "Bagi BO": "285203",
      "Barkhera BO": "285203",
      "Bhendi BO": "285203",
      "Harchandpur BO": "285203",
      "Mohana BO": "285122",
      "Bilond BO": "285124",
      "Dhoota BO": "285124",
      "Lidaupur BO": "285124",
      "Aurekhi BO": "285123",
      "Babai BO": "285123",
      "Chaki BO": "285123",
      "Kuthonda Buzurg BO": "285123",
      "Pratappura BO": "285123",
      "Sahav BO": "285123",
      "Salabad BO": "285123",
      "Sarawan BO": "285123",
      "Kashirampur BO": "285204",
      "Magraul BO": "285204",
      "Mainupur BO": "285204",
      "Anda BO": "285205",
      "Baroda Kalan BO": "285205",
      "Bhend BO": "285205",
      "Deogaon BO": "285205",
      "Somai BO": "285201",
      "Sarsela BO": "285202",
      "Shahjahanpur BO": "285202",
      "Ingui BO": "285121",
      "Parawar BO": "285121",
      "Alipur BO": "285203",
      "Lamsar BO": "285203",
      "Margayan BO": "285203",
      "Matra BO": "285203",
      "Bandhauli BO": "285122",
      "Kartalapur BO": "285128",
      "Madora BO": "285128",
      "Madori BO": "285128",
      "Sheikhpur Buzurg BO": "285128",
      "Gadhela BO": "285123",
      "Keolari BO": "285123",
      "Khaksis BO": "285123",
      "Jaitpura BO": "285205",
      "Pachipuri BO": "285205",
      "Toomra BO": "285205",
      "Kailiya BO": "285205",
      "Aindha BO": "285223",
      "Sikri Vyas BO": "285223",
      "Bhadeikh BO": "285125",
      "Pipri Gaharwar BO": "285125",
      "Romai Mustkil BO": "285125",
      "Sheikhpur Ahir BO": "285125",
      "Waoli BO": "285125",
      "Abhedepur BO": "285130",
      "Damras BO": "285130",
      "Dhamna BO": "285126",
      "Kainth BO": "285205",
      "Paniyara BO": "285205",
      "Titra Khalilpur BO": "285205",
      "Nahili BO": "285125",
      "Rampura Kirwaha BO": "285125",
      "Roora Jaitia BO": "285125",
      "Shankarpur BO": "285125",
      "Bichauli BO": "285130",
      "Sirsa Kalar BO": "285130",
      "Ramhetpura BO": "285126",
      "Shahjadpura BO": "285001",
      "Dhantauli": "285001",
      "Kharka": "285001",
      "Akorhi BO": "285201",
      "Chandurra BO": "285201",
      "Satoh BO": "285201",
      "Imiliya Buzurg BO": "285202",
      "Piprayan BO": "285202",
      "Rirua BO": "285202",
      "Jugrajpura BO": "285121",
      "Kuthonda BO": "285121",
      "Manpura BO": "285121",
      "Rendhar BO": "285121",
      "Sarr BO": "285121",
      "Sirsa Dogarhi BO": "285121",
      "Babina BO": "285203",
      "Chatela BO": "285203",
      "Udanpur BO": "285203",
      "Jaisari Kalan BO": "285122",
      "Mohammedabad BO": "285122",
      "Gora Bhoopka BO": "285128",
      "Patrahi BO": "285124",
      "Akorhi Dubey BO": "285123",
      "Atariya BO": "285123",
      "Garhgawan BO": "285123",
      "Jagnewa BO": "285123",
      "Nadai BO": "285123",
      "Sikri Raja BO": "285123",
      "Gulaoli BO": "285204",
      "Nibahna BO": "285204",
      "Mahewa": "285204",
      "Aknewa BO": "285205",
      "Chamend BO": "285205",
      "Jaganpura BO": "285205",
      "Karmer BO": "285001",
      "Basob BO": "285201",
      "Birguwan Khurd BO": "285201",
      "Dhagwan Kalan BO": "285201",
      "Pirona BO": "285201",
      "Chamari BO": "285202",
      "Chhonk BO": "285202",
      "Sandhi BO": "285202",
      "Usargaon BO": "285202",
      "Atagaon BO": "285121",
      "Kudaari BO": "285121",
      "Rura Sirsa BO": "285121",
      "Garrehi BO": "285203",
      "Mawai Ahir BO": "285203",
      "Gurha BO": "285122",
      "Kusmiliya BO": "285122",
      "Bhaoupura BO": "285128",
      "Bahadurpur BO": "285124",
      "Jaigha BO": "285124",
      "Mai BO": "285124",
      "Amkhera BO": "285123",
      "Atra Kalan BO": "285123",
      "Chhiriya Salempur BO": "285123",
      "Hatheri BO": "285123",
      "Itahiya BO": "285123",
      "Kusmara BO": "285123",
      "Lahchura BO": "285123",
      "Musmariya BO": "285123",
      "Parwatpura BO": "285123",
      "Sarsai BO": "285123",
      "Urgaon BO": "285123",
      "Bairai BO": "285204",
      "Kalpi RS BO": "285204",
      "Bhadari BO": "285205",
      "Chhani BO": "285205",
      "Diraoti BO": "285205",
      "Guraoti BO": "285205",
      "Roora Addu BO": "285001",
      "Chilli BO": "285001",
      "Kukargaon BO": "285001",
      "Imiliya BO": "285001",
      "Aeir BO": "285001",
      "Beerpura BO": "285001",
      "Kharoosa BO": "285001",
      "Gohan": "285129",
      "Mandri BO": "285001",
      "Baragaon BO": "285001",
      "Garhar BO": "285001",
      "Sihari BO": "285126",
      "Baseeth BO": "285206",
      "Gaindoli BO": "285206",
      "Pachokhara BO": "285127",
      "Rudrapura BO": "285127",
      "Nawar BO": "285129",
      "Rahiya BO": "285001",
      "Timron BO": "285001",
      "Sidhpura BO": "285127",
      "Teehar BO": "285127",
      "Churkhi": "285123",
      "Itaura": "285202",
      "Sihari Daoodpur BO": "285001",
      "Kharra BO": "285001",
      "Hardoi Guzar BO": "285001",
      "Ghillaur BO": "285206",
      "Naraul BO": "285127",
      "Uncha BO": "285127",
      "Eeton BO": "285129",
      "Dhanaura BO": "285001",
      "Sajera BO": "285206",
      "Ninaoli BO": "285127",
      "Ajeetapur BO": "285129",
      "Majeeth BO": "285129",
      "ORAI HO": "285001",
      "Jagammanpur SO": "285124",
      "Kotra SO Jalaun": "285223",
      "Nadigaon SO": "285206",
      "Ait SO": "285201",
      "Konch Bazariya SO": "285205",
      "Konch SO Jalaun": "285205",
      "Madhogarh SO Jalaun": "285126",
      "Navin Mandi Konch SO": "285205",
      "Rampura SO Jalaun": "285127",
      "Ata SO": "285202",
      "Baoni Estate SO": "285203",
      "Dvc Road Orai SO": "285001",
      "Hadrukh SO": "285128",
      "Jalaun Town SO": "285123",
      "Kalpi SO": "285204",
      "Kuthond SO": "285125",
      "Orai Kutchery SO": "285001",
      "Orai Town SO": "285001",
      "Rath Road Orai SO": "285001",
      "Umri SO Jalaun": "285129",
      "Bangra SO": "285121",
      "Dakore SO": "285122",
      "Jalaun SO": "285123",
      "Madaripur SO": "285130",
      "Orai Railway Station SO": "285001"
    },
    "KHERI": {
      "Shankarpur BO": "261501",
      "Nauser Gularia BO": "262901",
      "Padaria Tula BO": "262901",
      "Rara Bazar BO": "262901",
      "Bijua BO": "262901",
      "Dharmapur BO": "262903",
      "Ludhauri BO": "262903",
      "Banika BO": "262725",
      "Dhusaru BO": "262725",
      "Khanpur Gurela BO": "262725",
      "Basantapur Kallan BO": "262902",
      "Baudhiya Kallan BO": "262902",
      "Bela Kallan BO": "262902",
      "Chheduipattia BO": "262902",
      "Dudwaghat BO": "262902",
      "Sera Bera BO": "262902",
      "Basahi BO": "262904",
      "Vichitra Nagar BO": "262904",
      "Sujanpur BO": "262907",
      "Rampur Sutehra BO": "262805",
      "Belaparsua BO": "262906",
      "Belrayan BO": "262906",
      "Raipur BO": "261502",
      "Ambora BO": "262901",
      "Bijauria BO": "262902",
      "Patihan BO": "262902",
      "Dhakherwa Khalsa BO": "262907",
      "Dhakherwa Nankar BO": "262907",
      "Jamhaura BO": "262907",
      "Badagaon BO": "262726",
      "Banjaria BO": "262726",
      "Basaha BO": "262726",
      "Chakai BO": "262726",
      "Baibaha BO": "262805",
      "Belhori BO": "262805",
      "Bheekhampur BO": "262805",
      "Ghumara Madera BO": "262805",
      "Motipur BO": "262725",
      "Naubana BO": "262905",
      "Naurangabad BO": "262905",
      "Singaha Kallan BO": "262905",
      "Sinhauna BO": "262905",
      "Ganga Nagar BO": "262906",
      "Muda Bujurg BO": "262903",
      "Rakehati BO": "262903",
      "Tikar BO": "262725",
      "Ataria BO": "262902",
      "Ballipur BO": "262902",
      "Mahangapur BO": "262902",
      "Marocha BO": "262902",
      "Trikaulia BO": "262902",
      "Dareri BO": "262907",
      "Kothia BO": "262726",
      "Kotwa BO": "262805",
      "Parsehra Madarpur BO": "262805",
      "Mudia BO": "262805",
      "Banbirpur BO": "262906",
      "Kadia BO": "262906",
      "Kuaudiyala Ghat BO": "262906",
      "Suratnagar BO": "262906",
      "Dhoyanpur BO": "262908",
      "Masor Khambh BO": "262908",
      "Jhandi Raj BO": "262903",
      "Bisenpuri BO": "262902",
      "Gauri Fanta BO": "262902",
      "Majhgain BO": "262902",
      "Tilokpur BO": "262902",
      "Bhanpuri BO": "262904",
      "Dhakherwa BO": "262907",
      "Podhua BO": "262907",
      "Teliyar BO": "262907",
      "Khawahia No 2 BO": "262907",
      "Raipur Ghunshi BO": "262805",
      "Khairigarh BO": "262905",
      "Gadania BO": "262906",
      "Gularia Pathor Shah BO": "262906",
      "Manjha BO": "262906",
      "Barotha BO": "262903",
      "Binaura BO": "262903",
      "Daulatpur BO": "262903",
      "Sanigawan BO": "261501",
      "Tikaula BO": "261501",
      "Bhanpur BO": "262901",
      "Matehia BO": "262901",
      "Nijhota BO": "262908",
      "Jethra BO": "262722",
      "Kumhaina BO": "262722",
      "Hazaratpur BO": "262801",
      "Alipur BO": "262802",
      "Bhoolanpur BO": "261501",
      "Gauria BO": "261501",
      "Kasta BO": "261501",
      "Pahara BO": "261501",
      "Patna Baijnatpurwa BO": "262728",
      "Rabahi BO": "262728",
      "Sarsawa BO": "262728",
      "Bamhanpur BO": "262903",
      "Dubaha BO": "262903",
      "Midania BO": "262701",
      "Rasulpur BO": "262722",
      "Samodidih BO": "262722",
      "Sherpur BO": "262722",
      "Khanjanpur BO": "262801",
      "Kukra Town BO": "262801",
      "Ratasia BO": "261501",
      "Madwa BO": "262722",
      "Maharaj Nagar BO": "262701",
      "Mohammadapur BO": "262722",
      "Samdoha BO": "262722",
      "Pahar Nagar BO": "262801",
      "Lakhaha BO": "261501",
      "Paila BO": "261501",
      "Saidipur Harraiya BO": "262728",
      "Sakethu BO": "262728",
      "Adlabad BO": "262903",
      "Lakhun BO": "262722",
      "Pakaria BO": "262722",
      "Usha Form BO": "262801",
      "Hindustan Farm BO": "262801",
      "Bel BO": "261501",
      "Karanpur BO": "261501",
      "Neemgaon BO": "261501",
      "Murai Tajpur BO": "261121",
      "Udaipur Mahewa BO": "262701",
      "Bijhauli BO": "262701",
      "Rangila Nagar BO": "262701",
      "Lokesor BO": "262701",
      "Barkherwa BO": "262701",
      "Aira BO": "262722",
      "Lakhperaganj BO": "262701",
      "Siyathu BO": "262701",
      "Kalaam BO": "262701",
      "Rajgarh BO": "262701",
      "Chakmusepur BO": "262722",
      "Gaisapur BO": "262722",
      "Kaimahra BO": "262701",
      "Mudia Khera BO": "262701",
      "Baherwa BO": "262701",
      "Ganeshpur BO": "261502",
      "Piparawan BO": "262701",
      "Razaganj BO": "262701",
      "Deokali BO": "262701",
      "Adalispur BO": "262722",
      "Belwamoti BO": "262722",
      "Rampur Gokul BO": "262701",
      "Fardhan BO": "262701",
      "Manyora BO": "262701",
      "Murtiha BO": "262701",
      "Meerpur BO": "262701",
      "Bajahi BO": "262908",
      "Bankati BO": "262908",
      "Kajaria BO": "262908",
      "Kharbahia BO": "262723",
      "Sisaiya Kallan BO": "262723",
      "Aliganj BO": "262802",
      "Mohammdabad BO": "262802",
      "Rasulpanah BO": "262802",
      "Roshan Nagar BO": "262802",
      "Sansarpur BO": "262802",
      "Durgapur Padari BO": "261502",
      "Firozabad BO": "261502",
      "Khamaria Kallan BO": "261502",
      "Laukahi Isanagar BO": "261502",
      "Laukahi Mallapur BO": "261502",
      "Mochnapur BO": "261502",
      "Ramlok Kabiraha BO": "261502",
      "Akathi BO": "262724",
      "Dulahi BO": "262724",
      "GT Amethi BO": "262724",
      "Ghurghutta Bujurg BO": "262724",
      "Gopalapur BO": "261502",
      "Ambarsot BO": "262721",
      "Bhira Ghanshi BO": "262721",
      "Khambhar Khera BO": "261506",
      "Laukiha BO": "261506",
      "Pratappur BO": "261506",
      "Aurongabad BO": "261505",
      "Panai BO": "261505",
      "Bhoora BO": "262908",
      "Parasiya BO": "262908",
      "Dhakia BO": "262908",
      "Bhatpurwa Kallan BO": "262723",
      "Gudaria BO": "262723",
      "Lahabari BO": "262723",
      "Bhaithia BO": "262802",
      "Bakkhari BO": "262802",
      "Grant No11 BO": "262802",
      "Khargapur BO": "262802",
      "Landonpur Grant BO": "262802",
      "Muda Sawaran BO": "262802",
      "Ram Nagar Khurd BO": "262802",
      "Rampur Grant BO": "262802",
      "Saukhiya BO": "262802",
      "Badalipur BO": "261502",
      "Beltua BO": "261502",
      "Hasanpur Katauli BO": "261502",
      "Mudi BO": "261502",
      "Naribehar BO": "261502",
      "Rudrapur Salim BO": "261502",
      "Singawar BO": "261502",
      "Ram Nagar Bagaha BO": "262724",
      "Mahangukhera BO": "262721",
      "Mohola BO": "262721",
      "Sadhauna BO": "262721",
      "Daudpur BO": "261506",
      "Madhwapur Barola BO": "261506",
      "Pipra Goom BO": "261506",
      "Srinagar BO": "261506",
      "Tetarpur BO": "261506",
      "Mudia Puja Gaon BO": "261506",
      "Badhwari Marg BO": "261505",
      "Barbar BO": "261505",
      "Kaimahara BO": "261505",
      "Kaluamoti BO": "261505",
      "Khunti Bujurg BO": "261505",
      "Mohammadpur Nazir BO": "261505",
      "Mullapur BO": "261505",
      "Nayagaon Jat BO": "261505",
      "Sukhbasa BO": "261505",
      "Khamaria BO": "261505",
      "Tharvaranpur BO": "262803",
      "Birampur BO": "262727",
      "Lalhaua BO": "262727",
      "Sandilwa BO": "262727",
      "Awadhpur BO": "262727",
      "Ajehra BO": "262804",
      "Bagrethi BO": "262804",
      "Balmia Barkhar BO": "262804",
      "Bijhauli Sahaspur BO": "262804",
      "Gulauli BO": "262804",
      "Kiriyara BO": "262804",
      "Piparia Kaptan BO": "262804",
      "Rampur Banwari BO": "261505",
      "Saraunia BO": "261505",
      "Machhechha BO": "262804",
      "Magadapur BO": "262804",
      "Muda Ghalib BO": "262804",
      "Sasiya Ganj BO": "262804",
      "Shahpur Jagir BO": "262804",
      "Shankarpur Raja BO": "262804",
      "Sisaura Nasir BO": "262804",
      "Kathkusuma BO": "262728",
      "Chhedia Pashchim BO": "262908",
      "Borbata BO": "262908",
      "Davipurwa BO": "262723",
      "Kafara BO": "262723",
      "Ahemad Nagar BO": "262802",
      "Azan BO": "262802",
      "Bhallia Bujurg BO": "262802",
      "Haiderabad BO": "262802",
      "Kotwora Raj BO": "262802",
      "Maheshpur BO": "262802",
      "Rampur Daatpur BO": "262802",
      "Betisahdeo BO": "261502",
      "Gaura BO": "261506",
      "Virsinghpur BO": "261502",
      "Abhayapur BO": "262724",
      "Veerpur BO": "262804",
      "Haukana BO": "262724",
      "Nizampurnighati BO": "262721",
      "Aggar Khurd BO": "261506",
      "Pipra Form BO": "261506",
      "Sunderwal BO": "261506",
      "Baikuan BO": "261505",
      "Kakaraha BO": "261505",
      "Mohiddunpur BO": "261505",
      "Nayagaon BO": "261505",
      "Palhapur BO": "261505",
      "Pasgawan BO": "261505",
      "Sheopuri BO": "261505",
      "Sheorajpur BO": "261505",
      "Sunava BO": "261505",
      "Abgawan BO": "262727",
      "Semrawan BO": "262727",
      "Amir Nagar BO": "262804",
      "Baida BO": "262804",
      "Beni Rajpur BO": "262804",
      "Lauki Khera BO": "262804",
      "Mohammadpur Tajpur BO": "262804",
      "Piparia Dhani BO": "262804",
      "Sisaura Nikumpur BO": "262804",
      "Kumbhi BO": "262804",
      "Atkohana BO": "262728",
      "Nauapur Ghat BO": "262728",
      "Sunda BO": "262908",
      "Surma BO": "262908",
      "Saunaha BO": "262908",
      "Dhuskiya BO": "262908",
      "Puraina BO": "262908",
      "Amethi BO": "262723",
      "Baburi BO": "262723",
      "Bajaha BO": "262723",
      "Basantapur BO": "262723",
      "Chhitaunia BO": "262802",
      "Gharthania BO": "262802",
      "Jalalpur BO": "262802",
      "Jamunabad Form BO": "262802",
      "Kaparaha BO": "262802",
      "Pareli BO": "262802",
      "Parsehra BO": "262802",
      "Sishnour BO": "262802",
      "Suhela BO": "262802",
      "Banshi BO": "262802",
      "Kanchanpur BO": "262802",
      "Mamari BO": "262802",
      "Bhedhia BO": "261502",
      "Chandrasa Kallan BO": "261502",
      "Mukhalishpur BO": "261502",
      "Sikatiha Chapkaha BO": "261502",
      "Mallbehar BO": "262724",
      "Nainapur BO": "262724",
      "Semri BO": "262724",
      "Ramia Behar BO": "262724",
      "Mohammadpur Mahewa BO": "262721",
      "Rudrapur Kallan BO": "262721",
      "Sisaura BO": "261506",
      "PhoolBehad BO": "261506",
      "BADHAIYA BO": "261505",
      "Bisari Khera BO": "261505",
      "Fatepur BO": "261505",
      "Jangbahadur Ganj BO": "261505",
      "Kusumi BO": "261505",
      "Lidhiyayi BO": "261505",
      "Maksudpur BO": "261505",
      "Muborakpur BO": "261505",
      "Baghoom BO": "261505",
      "Suwabojh Jungle BO": "262803",
      "Mailani Gram BO": "262803",
      "Khanjan Nagar BO": "262727",
      "Neem Cheni BO": "262727",
      "Kheri HO": "262701",
      "Odara BO": "262727",
      "Farenda BO": "262804",
      "Gaffar Nagar BO": "262804",
      "Gokan BO": "262804",
      "Itauwa BO": "262804",
      "Aira Estate SO": "262722",
      "Behjam SO": "261501",
      "Mahewa Ganj SO": "261506",
      "Mailani SO": "262803",
      "Mohammadi SO": "262804",
      "Nakha SO": "262728",
      "Pallia SO": "262902",
      "Sampurna Nagar SO": "262904",
      "Sankata Devi SO": "262701",
      "Shivpuri SO Kheri": "262701",
      "Sikandrabad SO Kheri": "262805",
      "Bhira SO Kheri": "262901",
      "Chandan Chauki SO": "262908",
      "Dhaurahara SO Kheri": "262723",
      "Gola Town SO": "262802",
      "Naibasti SO": "262701",
      "Isanagar SO Kheri": "261502",
      "Kheri Town SO": "262702",
      "Nighasan SO": "262903",
      "Semra SO Kheri": "262907",
      "Singahi SO": "262905",
      "Tikunia SO": "262906",
      "Bankey Ganj SO": "262801",
      "Gola Gokaran Nath SO": "262802",
      "Jatpurwa SO": "262724",
      "Lagucha SO": "262721",
      "Lakhimpur SO": "262701",
      "Maigal Ganj SO": "261505",
      "Mitauli SO": "262727",
      "Oel SO Kheri": "262725",
      "Sharda Nagar SO": "262726"
    },
    "BUDAUN": {
      "Salarpur BO": "243601",
      "Noorpur BO": "243601",
      "Ushawan BO": "243631",
      "Manunagar BO": "243632",
      "Mohkampur BO": "243632",
      "Nizamuddin Purshah BO": "243632",
      "Sangrampur BO": "243632",
      "Sikri BO": "243632",
      "Ambiapur BO": "243633",
      "Bairmai Khurd BO": "243633",
      "Bans Barolia BO": "243633",
      "Behta Gusain BO": "243633",
      "Paharpur BO": "243633",
      "Pindol BO": "243633",
      "Reonai BO": "243633",
      "Sarah Barolia BO": "243633",
      "Prithvipur BO": "243720",
      "Ghilaur BO": "243635",
      "Jamalpur BO": "243635",
      "Karanpur BO": "243724",
      "Labhari BO": "243635",
      "Majhara BO": "243635",
      "Manikapur Kaur BO": "243635",
      "Abhigaon BO": "243631",
      "Chitaura BO": "243631",
      "Miaoo BO": "243631",
      "Naviganj BO": "243631",
      "Bhoor Bisauli BO": "243632",
      "Mirzapura Sohra BO": "243633",
      "Mushepur BO": "243633",
      "Sateti BO": "243633",
      "Sirasaul BO": "243633",
      "Sirtaul BO": "243633",
      "Deorijeet BO": "243634",
      "Kartoli BO": "243634",
      "Puthi Sarai BO": "243634",
      "Rehma BO": "243634",
      "Bhanpur BO": "243720",
      "Dabtori BO": "243720",
      "Jasrathpur BO": "243720",
      "Mudia Dhuroki BO": "243720",
      "Azampur Bisaria BO": "243635",
      "Baksena BO": "243635",
      "Bhau Nagla BO": "243635",
      "Palia Gujar BO": "243635",
      "Papar Hamzapur BO": "243635",
      "Puraini BO": "243635",
      "Saijani BO": "243635",
      "Salempur BO": "243635",
      "Sarai Piparia BO": "243635",
      "Danpur BO": "243723",
      "Garikhanpur BO": "243723",
      "Nagla Barah BO": "243723",
      "Reonaiya BO": "243636",
      "Sikandrabad BO": "243636",
      "Ikh Khera BO": "243724",
      "Kariamai BO": "243724",
      "Mewali BO": "243724",
      "Dharampur Tappa Vaish BO": "243638",
      "Kariyaban BO": "243638",
      "Aslaur BO": "243723",
      "Bhusaya BO": "243723",
      "Chandoi BO": "243723",
      "Nadha BO": "243723",
      "Dehemu BO": "243636",
      "Afjalpur Chhaganpur BO": "243638",
      "Baksar BO": "243638",
      "Bhagta Nagla BO": "243638",
      "Kolhai BO": "243638",
      "Malpurtatera BO": "243638",
      "Mustafabad Jaretha BO": "243638",
      "Lahi Faridpur BO": "243601",
      "Naushera BO": "243601",
      "Sakhanu BO": "243601",
      "Sheikhupur BO Budaun": "243601",
      "Jagat BO": "243601",
      "Gauntra BO": "243631",
      "Maraura BO": "243631",
      "Faizganj Behta BO": "243632",
      "Laxmipur BO": "243632",
      "Sisaraka BO": "243632",
      "Gudhni BO": "243633",
      "Khitaura BO": "243633",
      "Naithuwa BO": "243633",
      "Parauli BO": "243633",
      "Sarah Bagholi BO": "243633",
      "Sarup Pur BO": "243633",
      "Beor BO": "243634",
      "Khajuria BO": "243720",
      "Tara Pathakpur BO": "243720",
      "Daharpur Kalan BO": "243635",
      "Hazratpur BO": "243635",
      "Mausampur BO": "243635",
      "Nauni BO": "243635",
      "Prasidhpur BO": "243635",
      "Qazi Mohalla BO": "243601",
      "Beor Kasimabad BO": "243723",
      "Kotha BO": "243723",
      "Sitholi BO": "243723",
      "Surahi BO": "243723",
      "Katiyan BO": "243637",
      "Unola BO": "243601",
      "Fatehpur BO": "243601",
      "Qadarchawk BO": "243601",
      "Gurgaon BO": "243601",
      "Lakhanpur BO": "243601",
      "Husainpur Pukhta BO": "243636",
      "Nana Khera BO": "243636",
      "Pipraul Pukhta BO": "243636",
      "Bondri  BO": "243636",
      "Chani BO": "243724",
      "Pipri Raghunathpur BO": "243724",
      "Ughaiti BO": "243724",
      "Dakarapukhta BO": "243638",
      "Nadail BO": "243638",
      "Asrasi BO": "243601",
      "Ikri BO": "243601",
      "Jalalpur BO": "243601",
      "Kakora BO": "243601",
      "Gura Barala BO": "243631",
      "Mansanagla BO": "243631",
      "Danbri BO": "243632",
      "Gangoli BO": "243632",
      "Dudhauni BO": "243633",
      "Haibatpur BO": "243633",
      "Nagarjhoona BO": "243633",
      "Simarra Bhojpur BO": "243633",
      "Bilhat BO": "243634",
      "Sikrauri BO": "243634",
      "Hatsa BO": "243720",
      "Mohammad Pur Mai BO": "243720",
      "Parveznagar BO": "243720",
      "Bela Dandi BO": "243635",
      "Chitri BO": "243635",
      "Nagaria Khanu BO": "243635",
      "Nawada Madhukar BO": "243635",
      "Pipla BO": "243635",
      "Allahpur Samaspur BO": "243723",
      "Rajthal BO": "243723",
      "Noorpur Pinoni BO": "243723",
      "Gudhana BO": "243637",
      "Mohammad Ganj BO": "243637",
      "Jeora Parwala BO": "243636",
      "Palia Pukhta BO": "243636",
      "Budaun RS": "243601",
      "Jakheli BO": "243601",
      "Shyam Nagar BO": "243601",
      "Gularia BO": "243630",
      "Bhoora Bhadraul BO": "243636",
      "Bhavipur BO": "243724",
      "Gandhrauli BO": "243724",
      "Kangawan gugau BO": "243724",
      "Khandwa BO": "243724",
      "Saraira BO": "243724",
      "Bhamori BO": "243638",
      "Dehgawan BO": "243638",
      "Narsena BO": "243638",
      "Sirsa Khurd BO": "243638",
      "Agthra BO": "243725",
      "Atarpura BO": "243725",
      "Bagrain BO": "243725",
      "Gandah BO": "243630",
      "Kama BO": "243630",
      "Mehtabpur BO": "243630",
      "Chhatuiya BO": "243639",
      "Garhi BO": "243639",
      "Gathona BO": "243639",
      "Hazarat Ganj BO": "243639",
      "Sohi BO": "243726",
      "Budhwai BO": "243601",
      "Sirsa Dabrai BO": "243601",
      "Sotha BO": "243601",
      "Sujawali BO": "243638",
      "Sukrullapur BO": "243638",
      "Usmanpur BO": "243638",
      "Zarifnagar BO": "243638",
      "Nauli Harnathpur BO": "243725",
      "Pepal BO": "243725",
      "Reharia BO": "243725",
      "Sigthara BO": "243725",
      "Urena BO": "243725",
      "Abdulla Ganj BO": "243639",
      "Isapur Baheria BO": "243639",
      "Pusgawan BO": "243639",
      "Shahjadnagar BO": "243639",
      "Bhundi BO": "243641",
      "Katra Sadatganj BO": "243641",
      "Lilwan BO": "243641",
      "Bankota BO": "243726",
      "Baror Amanullapur BO": "243726",
      "Beoli BO": "243726",
      "Tehra BO": "243638",
      "Katgaon BO": "243725",
      "Bhatauli BO": "243630",
      "Khukri BO": "243630",
      "Sukhaura BO": "243630",
      "Bamnausi BO": "243639",
      "Basoma BO": "243639",
      "Rasoola BO": "243639",
      "Risauli BO": "243639",
      "Sanjarpur Baljeet BO": "243639",
      "Khera Jalalpur BO": "243641",
      "Sareli Pukhta BO": "243641",
      "Barategdar BO": "243726",
      "Gotha BO": "243726",
      "Jinaura BO": "243726",
      "Sursena BO": "243726",
      "Arifpur Nawada BO": "243601",
      "Singraura BO": "243601",
      "Kandela BO": "243601",
      "Nizampur BO": "243601",
      "Ram Zanpur BO": "243601",
      "Gidhaul BO": "243601",
      "Katinna Barchau BO": "243601",
      "MN Sulra BO": "243601",
      "Bharkuian BO": "243601",
      "Tigra BO": "243638",
      "Bhawanipur Khairu BO": "243638",
      "Karkheri BO": "243725",
      "Khurampur Bhamori BO": "243725",
      "Makrandpur BO": "243725",
      "Jhuksa BO": "243630",
      "Mailha BO": "243630",
      "Sadullaganj BO": "243630",
      "Sisaiya Gusain BO": "243630",
      "Barsua BO": "243639",
      "Butla Daulat BO": "243639",
      "Sakri Jangal BO": "243639",
      "Rijola BO": "243641",
      "Hatra BO": "243726",
      "Rota BO": "243726",
      "Barachirra BO": "243601",
      "Nauli Fatuhabad BO": "243601",
      "Mongar BO": "243601",
      "Kudah Shahpur BO": "243601",
      "Roop Pur BO": "243601",
      "Asis Berkhin BO": "243601",
      "Qazi Tola BO": "243638",
      "Rasoolpur Bela BO": "243638",
      "Rasoolpur Kalan BO": "243638",
      "Samspurmalik Fatta BO": "243638",
      "Silhari BO": "243638",
      "Sagrai BO": "243638",
      "Shahnagar Patparaganj BO": "243638",
      "Dugraiya BO": "243601",
      "Kumargaon BO": "243601",
      "Kurau BO": "243601",
      "Musajhag BO": "243601",
      "Gauramai BO": "243601",
      "MACHLAI": "243601",
      "Sakri Kasimpur BO": "243601",
      "Abul Fazal EnclaveI SO": "110025",
      "Budaun HO": "243601",
      "Baburam Market SO": "243601",
      "Binawar SO": "243634",
      "Bisauli SO": "243720",
      "Budaun City SO": "243601",
      "Chaudhary Sarai SO": "243601",
      "Dataganj SO": "243635",
      "Saidpur SO Budaun": "243725",
      "Station Road SO Budaun": "243601",
      "Brahmpur SO Budaun": "243601",
      "Halwai Chawk SO": "243601",
      "Kakrala SO": "243637",
      "Kachhla SO": "243636",
      "Rudain SO": "243724",
      "Ujhani SO": "243639",
      "Sahaswan SO": "243638",
      "Wazirganj SO Budaun": "243726",
      "Allapur SO": "243631",
      "Asafpur SO": "243632",
      "Bilsi SO": "243633",
      "Civil Lines SO": "243601",
      "Islamnagar SO": "243723",
      "Patiali Sarai SO": "243601",
      "Police Line SO Budaun": "243601",
      "Samrer SO": "243630",
      "Santigarh  Ujhani SO": "243639",
      "Usehat SO": "243641"
    },
    "SAMBHAL": {
      "Bhakrauli BO": "243751",
      "Dinaura BO": "243751",
      "Hirauni BO": "243751",
      "Saitua BO": "243751",
      "Shahjanabad BO": "243751",
      "Asadpur BO": "243722",
      "Bairpur Maharaji BO": "243722",
      "Gari Bichola BO": "243723",
      "Jarwar BO": "243723",
      "Jijonda BO": "243727",
      "Qadrabad BO": "243638",
      "Ghosali Bahan BO": "243722",
      "Isampur Danda BO": "243722",
      "Kashipur BO": "243722",
      "Lahara Nagla Shyam BO": "243722",
      "Nadrauli BO": "243722",
      "Nagla Ajmeri BO": "243722",
      "Pusawali BO": "243722",
      "Mehua Hasanganj BO": "242021",
      "Singhaula Daulatsingh BO": "243727",
      "Bhirawati BO": "243751",
      "Harphari BO": "243751",
      "Kail BO": "243751",
      "KHALILPUR": "243751",
      "Bandarai BO": "243722",
      "Dhandwara BO": "243722",
      "Madkawali BO": "243722",
      "Pataria BO": "243722",
      "Rewara BO": "243722",
      "Bajhawli BO": "244414",
      "Modhpur Wabai BO": "244414",
      "Sarthal BO": "244414",
      "Chamroa BO": "244302",
      "Mohd Pur Tanda BO": "244302",
      "Mohra Lakhupura BO": "244302",
      "Nuria Sarai BO": "244302",
      "Senjana BO": "244302",
      "Singhpur Sani BO": "244302",
      "Gurer BO": "244301",
      "Mahmoodpur BO": "244301",
      "Qasimpur BO": "244301",
      "Rehtaul BO": "244301",
      "Ummedpur BO": "244301",
      "Chandankati BO": "244302",
      "Dilgaura BO": "244302",
      "Hasanpur Manjapta BO": "244302",
      "Mian Sarai BO": "244302",
      "Amawati Qutubpur BO": "244303",
      "Datauli BO": "244303",
      "Gauhat BO": "244303",
      "Hayatnagar BO": "244303",
      "Baripur Bhamrowa BO": "244301",
      "Bharthal Madapur BO": "244301",
      "Mohd Sadikpur BO": "244414",
      "Singhauli Kalloo BO": "243727",
      "Mithanpur BO": "243638",
      "Chhapra BO": "243751",
      "Dhanari BO": "243751",
      "Dupta Kalan BO": "243751",
      "Ikona BO": "243751",
      "Mehmoodpur BO": "243751",
      "Dabthara Harlal BO": "243722",
      "Sarai Brahman BO": "243722",
      "Gawan BO": "243727",
      "Neora BO": "243727",
      "Tharesa Jai Singh BO": "244414",
      "Akhtiarpur Thillupura BO": "244302",
      "Bhawanipur BO": "244302",
      "Pawasa BO": "244302",
      "RP Niyaoli BO": "244302",
      "Salarpur BO": "244302",
      "Thati BO": "244302",
      "Rudayan BO": "244303",
      "Sondhan Mohdpur BO": "244303",
      "Azamnagar Chopra BO": "244301",
      "Fatehpur Malakpur BO": "244301",
      "Hajratnagar Garhi BO": "244301",
      "Niyamatpur BO": "244301",
      "Bhatola BO": "244302",
      "Isapur Sunwari BO": "244302",
      "Kasauli BO": "244302",
      "Lakhauri Jalalpur BO": "244302",
      "Ruknuddin Sarai BO": "244302",
      "Sherpur BO": "244303",
      "Barahi BO": "244301",
      "Dingarpur BO": "244301",
      "Mainather BO": "244301",
      "Mohd Ganj BO": "244412",
      "Raholi BO": "244412",
      "Afjalpur Darauli BO": "244414",
      "Ancholi BO": "244414",
      "Saidpur Gangu BO": "244304",
      "Obri BO": "244102",
      "Chatan BO": "244410",
      "Faridpur Khushal BO": "244410",
      "Mau Ka Ther BO": "244410",
      "Nadhos BO": "244410",
      "Rajpur Kalan BO": "244410",
      "Sadatwari BO": "244410",
      "Bahroli Taharpur BO": "244410",
      "Dharampur Ratta BO": "244411",
      "Kurh Fatehgarh BO": "244411",
      "Chandausi RS BO": "244412",
      "Maulagarh BO": "244412",
      "Alipur Buzurg BO": "244414",
      "Nagla Purvi BO": "244412",
      "Behta Khas BO": "244412",
      "Ratupura BO": "244102",
      "Shahbaj Pur Kalan BO": "244102",
      "Fatehpur Samsoi BO": "244410",
      "Jarai Hayat Nagar BO": "244410",
      "Majhola BO": "244410",
      "Muletha BO": "244410",
      "Pathakpur BO": "244410",
      "Raipur Kalan BO": "244410",
      "Berni BO": "244411",
      "Chhawara BO": "244411",
      "Dugawar BO": "244304",
      "Dulapur Urf Darapur BO": "244304",
      "Madala Fatehpur BO": "244304",
      "Satupura BO": "244304",
      "Anchora  Kamboh BO": "244304",
      "Harthala BO": "244102",
      "Khaspur BO": "244102",
      "Asalatpur Jarai BO": "244412",
      "Barauli Rustampur BO": "244412",
      "Gumthal BO": "244412",
      "Kaithal BO": "244412",
      "Mai BO": "244412",
      "Manota BO": "244304",
      "Rampur Urf Yarpur BO": "244304",
      "Madhan BO": "244102",
      "Alpur Maithra BO": "244410",
      "Rampura BO": "244410",
      "Sheoraj  Pur BO": "244410",
      "Akrauli BO": "244411",
      "Sarai Jawalapuri BO": "244411",
      "Bania Khera BO": "244412",
      "Budh Nagar Khandwa BO": "244412",
      "Janeta BO": "244412",
      "Chandausi SO": "244412",
      "Deepa Sarai SO": "244302",
      "Narauli SO": "244414",
      "Asmoli SO": "244304",
      "Bahjoi SO": "244410",
      "Sarai Tarin SO": "244303",
      "Braham Bazar Chandausi SO": "244412",
      "Railway Colony Chandausi SO": "244412",
      "Sambhal SO": "244302",
      "Sirsi SO Moradabad": "244301",
      "Gunnaur SO": "243722",
      "IA Babrala SO": "242021",
      "Chandausi Bara Bazar SO": "244412",
      "Babrala SO": "243751",
      "Rajpura SO Budaun": "243727"
    },
    "HAMIRPUR": {
      "Kakrau BO": "285203",
      "Mawaijar BO": "210341",
      "Patyara BO": "210341",
      "Kuwan BO": "210425",
      "Surha BO": "210425",
      "Bilauta BO": "210505",
      "Jhalokhar BO": "210505",
      "Kandaur BO": "210505",
      "Patara BO": "210505",
      "Dhagwan BO": "210428",
      "Jarakhar BO": "210428",
      "Nauranga BO": "210428",
      "Pahari Bhitari BO": "210506",
      "Khera Silazit BO": "210422",
      "Zitkiri BO": "210422",
      "Bhauli BO": "210505",
      "Chilli BO": "210431",
      "Gahrauli BO": "210506",
      "Gundela BO": "210506",
      "Imiliya BO": "210506",
      "Artara BO": "210507",
      "Bhulsi BO": "210507",
      "Biharka BO": "210507",
      "Garha BO": "210507",
      "Beri BO": "285203",
      "Patanpur BO": "210341",
      "Atrauli BO": "210422",
      "Chhandaut BO": "210422",
      "Itailiya BO": "210422",
      "Kharaunj BO": "210505",
      "Kusmara BO": "210505",
      "Para BO": "210505",
      "Malehta BO": "210428",
      "Baswari BO": "210506",
      "Neoria BO": "210506",
      "Bhamai BO": "210507",
      "Deogaon BO": "210341",
      "Bira BO": "210422",
      "Islampur BO": "210422",
      "Gusiyari BO": "210504",
      "Misripur BO": "210505",
      "Shekaupur BO": "210505",
      "Tolarawat BO": "210428",
      "Bihuni Kalan BO": "210506",
      "Masgaon BO": "210506",
      "Bhaismari BO": "210507",
      "Bigahna BO": "210507",
      "Mehuna Mundera BO": "210507",
      "Naraich BO": "210507",
      "Padhori BO": "210507",
      "Parchhat BO": "210507",
      "Urdana BO": "210507",
      "Itaura BO": "210431",
      "Jakeri BO": "210431",
      "Kaitha BO": "210431",
      "Nakra BO": "210431",
      "Odera BO": "210431",
      "Saidpur BO": "210431",
      "Amood BO": "210432",
      "Bilgaon BO": "210432",
      "Jalalpur BO": "210432",
      "Mamna BO": "210432",
      "Neoli Bansa BO": "210432",
      "Gyondi BO": "210507",
      "Khandeh BO": "210507",
      "Kunetha BO": "210507",
      "Sisolar BO": "210507",
      "Aunta BO": "210431",
      "Dhanauri BO": "210431",
      "Turra BO": "210431",
      "Chhiboli BO": "210432",
      "Kaithi BO": "210507",
      "Kamharia BO": "210507",
      "Basela BO": "210431",
      "Puraini BO": "210432",
      "Ichauli BO": "210507",
      "Kishwahi BO": "210507",
      "Manjhoopur BO": "210301",
      "Pauthia Bujurg BO": "210301",
      "Atariyan BO": "210502",
      "Banki BO": "210502",
      "Amgaon BO": "210430",
      "Barauli Kharka BO": "210430",
      "Barwa BO": "210341",
      "Tikrauli BO": "210301",
      "Kalaulitir BO": "210301",
      "Surauli Bujurg BO": "210301",
      "Birkhera BO": "210502",
      "Kundaura BO": "210502",
      "Makraon BO": "210507",
      "Ragaul Tahsil BO": "210507",
      "Bhainsai BO": "210431",
      "Dhamna BO": "210431",
      "Sarsai BO": "210431",
      "Umariya BO": "210431",
      "Dhauhal Buzurg BO": "210432",
      "Inderpura BO": "210432",
      "Nadehra BO": "210502",
      "Pachkhura BO": "210502",
      "Pandhari BO": "210502",
      "Terha BO": "210502",
      "Mahera BO": "210501",
      "Ruripara BO": "210501",
      "Sayar BO": "210501",
      "Swasa Bujurg BO": "210501",
      "Magrauth BO": "210430",
      "Rahank BO": "210430",
      "Rawatpura BO": "210430",
      "Bandhur Khurd BO": "210501",
      "Lodipur Newada BO": "210501",
      "Umari BO": "210501",
      "Chikasi BO": "210430",
      "Kachhewan Kalan BO": "210430",
      "Bidokhar BO": "210341",
      "Kuchhechha BO": "210301",
      "Ujnedi BO": "210301",
      "Chandpura BO": "210502",
      "Bajehta BO": "210501",
      "Chhani Buzurg BO": "210501",
      "Jigni BO": "210430",
      "Kargawan BO": "210430",
      "Hamirpur HO": "210301",
      "Hamirpur DB SO": "210301",
      "Bewar SO Hamirpur": "210501",
      "Gohand SO": "210430",
      "Ingohta SO": "210341",
      "Jaria SO Hamirpur": "210422",
      "Kot Bazar Rath SO": "210431",
      "Majhagawan SO": "210428",
      "Rath SO": "210431",
      "Sarila State SO": "210432",
      "Baruwa Sumerpur SO": "210502",
      "Kurara SO": "210505",
      "Muskara SO": "210506",
      "Ragaul SO": "210507"
    },
    "MAHOBA": {
      "Akona BO": "210423",
      "Ari BO": "210423",
      "Budhwara BO": "210423",
      "Sheohar BO": "210424",
      "Singhaupur Baghari BO": "210424",
      "Sukaura BO": "210424",
      "Sirsi Khurd BO": "210504",
      "Basaut BO": "210425",
      "Bilbai BO": "210427",
      "Chikahra BO": "210427",
      "Sijahri BO": "210427",
      "Tikamau BO": "210427",
      "Gaurahari BO": "210429",
      "Kaithi BO": "210429",
      "Kankuwan BO": "210429",
      "Kashipur BO": "210429",
      "Kohaniya BO": "210429",
      "Mahobkanth BO": "210429",
      "Dharaun BO": "210424",
      "Garha BO": "210421",
      "Khajuriha Pahra BO": "210424",
      "Makarbai BO": "210424",
      "Chichara BO": "210504",
      "Kahra BO": "210504",
      "Karahiya BO": "210504",
      "Khiruhi BO": "210504",
      "Mawai Khurd BO": "210504",
      "Ladpur BO": "210426",
      "Mudhari BO": "210426",
      "Paswara BO": "210427",
      "Bahadurpur Kalan BO": "210429",
      "Bendo BO": "210429",
      "Paharia BO": "210429",
      "Syondhi BO": "210429",
      "Teiya BO": "210429",
      "Ajnar BO": "210423",
      "Baghanra BO": "210423",
      "Mahuabandh BO": "210423",
      "Pachara BO": "210423",
      "Bila Dakhin BO": "210424",
      "Rewai Sunaicha BO": "210424",
      "Rewan BO": "210504",
      "Sirsi Kalan BO": "210504",
      "Satari BO": "210426",
      "Mahoba RS BO": "210427",
      "Bharwara BO": "210429",
      "Budero BO": "210429",
      "Kilahua BO": "210429",
      "Mahua BO": "210429",
      "Nagradang BO": "210423",
      "Tikaria BO": "210423",
      "Chhani Kalan BO": "210424",
      "Ganj BO": "210424",
      "Mahewa BO": "210424",
      "Parsaha BO": "210424",
      "Patha BO": "210424",
      "Chhirka BO": "210504",
      "Ainchana BO": "210425",
      "Bagwaha BO": "210426",
      "Sugira BO": "210426",
      "Karahra Kalan BO": "210427",
      "Bijaypur BO": "210429",
      "Dulara BO": "210429",
      "Masoodpura BO": "210429",
      "Roori Kalan BO": "210429",
      "Umari BO": "210429",
      "Atrarmaf BO": "210433",
      "Bilkhi BO": "210433",
      "Pawa BO": "210433",
      "Pipramaf BO": "210433",
      "Salarpur BO": "210433",
      "Sijwaha BO": "210433",
      "Supa BO": "210421",
      "Bhandra BO": "210433",
      "Nanaura BO": "210433",
      "Aktaunhan BO": "210421",
      "Anghaura BO": "210421",
      "Bamrara BO": "210421",
      "Rewai BO": "210421",
      "Bamhauri Kalan BO": "210421",
      "Chandauli BO": "210421",
      "Rainpura BO": "210421",
      "Gandhi Nagar Mahoba SO": "210427",
      "Kabrai SO": "210424",
      "Panwari SO": "210429",
      "Kulpahar SO": "210426",
      "Mahoba SO": "210427",
      "Charkhari State SO": "210421",
      "Jaitpur SO Mahoba": "210423",
      "Khanna SO": "210504",
      "Kharela SO": "210425",
      "Srinagar SO Mahoba": "210433"
    },
    "BULANDSHAHR": {
      "Bigraou BO": "203412",
      "Barhpura BO": "203398",
      "Darawer BO": "203398",
      "Narsena BO": "203398",
      "Shikoi BO": "203398",
      "Bhatwara BO": "203131",
      "Seekri BO": "203131",
      "Bagrai  Khurd BO": "203131",
      "Shahbaz Pur BO": "203131",
      "Bada Gaon BO": "203131",
      "Kirra BO": "203131",
      "Pindrawal BO": "203397",
      "Sahar BO": "203397",
      "Tyore  Buzurg BO": "203397",
      "Bhikampur BO": "203392",
      "Chehla BO": "203392",
      "Indoure  Khera BO": "203392",
      "Keeratpur BO": "203392",
      "Muradpur BO": "203392",
      "Poothery  Kalan BO": "203392",
      "Runsi BO": "203392",
      "Dogawan BO": "203393",
      "Pilkhana BO": "203393",
      "Uamrara BO": "203393",
      "Gwarauly BO": "203129",
      "Nagliya  Udaibhan BO": "203129",
      "Raipur Palda BO": "203129",
      "Rampur  Manpur BO": "203129",
      "Sonda  Habibpur BO": "203132",
      "Kunwarpur BO": "203396",
      "Lalner BO": "203396",
      "Jargawan BO": "203399",
      "Lalkuan BO": "203001",
      "Mirjapur BO": "203001",
      "Mukeempur BO": "203001",
      "Ghunghraoli Banwaripur BO": "203001",
      "Luharaly Ludhiyana BO": "203001",
      "Dhamraoli BO": "203002",
      "Malakpur BO": "203390",
      "Parly BO": "203390",
      "Roopwas BO": "203390",
      "Siraura Bangar BO": "203390",
      "Surajpur  Makhena BO": "203390",
      "Banhpur BO": "203402",
      "Benipur BO": "203402",
      "Kuchesar BO": "203402",
      "Lad Pur BO": "203402",
      "Madona Jafara Bad BO": "203402",
      "Sathala BO": "203402",
      "Barhana BO": "203403",
      "Bharkau BO": "203403",
      "Asawar BO": "203408",
      "Til BegumPur BO": "203206",
      "Darora BO": "203394",
      "Guraoli BO": "203394",
      "Jakheta BO": "203394",
      "Jatpura BO": "203394",
      "Raghunathpur BO": "203405",
      "Sonjhana Jhaya BO": "203405",
      "Katiyawali BO": "203391",
      "Khelia Kalyanpur BO": "203391",
      "Mundi Bakapur BO": "203407",
      "Nimchana BO": "203407",
      "Parwana BO": "203407",
      "Sega Jagatpur BO": "203407",
      "Sehra BO": "203411",
      "Gajipur BO": "203205",
      "Ishmail Pur BO": "203205",
      "Kanwra BO": "203205",
      "Doulatpur   Kala BO": "203398",
      "Ghungharwaly BO": "203398",
      "Muni BO": "203131",
      "Roop  Wash Pachgain BO": "203131",
      "Agaura  Hameerpur BO": "203131",
      "Jawal BO": "203131",
      "Choundhera BO": "203392",
      "Dangarh BO": "203392",
      "Satwara BO": "203392",
      "Karanbash BO": "203393",
      "Kaser  Kalan BO": "203393",
      "Kaser  Khurd BO": "203393",
      "Asgarpur BO": "203132",
      "Belon BO": "203389",
      "Rampur BO": "203389",
      "GangaGarhi BO": "203396",
      "Chiroury BO": "203399",
      "Guthaoli BO": "203001",
      "Naya  Gaon BO": "203001",
      "Rangpur BO": "203001",
      "Dhamera  Keerat BO": "203001",
      "Bagsara BO": "203390",
      "Paswasara BO": "203401",
      "Visundhara BO": "203401",
      "Chandiyana BO": "203403",
      "Kisola BO": "203403",
      "Baghwala BO": "203408",
      "Bhatauna BO": "203408",
      "Chaprawat BO": "203408",
      "Ginora Shekh BO": "203408",
      "Harchana BO": "203408",
      "Isapur BO": "203408",
      "Kurli BO": "203408",
      "Mohana BO": "203408",
      "Oledha BO": "203408",
      "Pitubash BO": "203408",
      "Senta BO": "203408",
      "Bansuri BO": "203394",
      "Navi Nagar BO": "203394",
      "Sankhani BO": "203394",
      "Tauli BO": "203394",
      "Titauta Veer BO": "203394",
      "Amarpur BO": "203405",
      "Chathera BO": "203405",
      "Ginaura Nangali BO": "203405",
      "Pali Partapur BO": "203405",
      "Andhiyar BO": "203391",
      "Shekhpur Gadwa BO": "203407",
      "Agauta BO": "203411",
      "Ahmadanagar BO": "203411",
      "AkapurTiyana BO": "203411",
      "Barkatpur BO": "203411",
      "Nisurkha BO": "203411",
      "Maithna  Jagatpur BO": "203409",
      "Utrouly BO": "203409",
      "Ashwari BO": "203150",
      "Bhudhana BO": "203150",
      "Jugsana  Kalan BO": "203150",
      "Manglore BO": "203150",
      "Shiwaly BO": "203150",
      "Sarawa BO": "203395",
      "Aurangabad Aheer BO": "203205",
      "Mahepa BO": "203205",
      "Barouli Basdev Pur BO": "203412",
      "Khad  Mohan Nagar BO": "203412",
      "Waira  Firozpur BO": "203412",
      "Ahar BO": "203398",
      "Amargarh BO": "203398",
      "Khandoi BO": "203398",
      "Mawai BO": "203398",
      "Thana  Gajraula BO": "203398",
      "Bichoula BO": "203131",
      "Dinoul BO": "203131",
      "Meerpur BO": "203131",
      "Kalena BO": "203131",
      "Nagla Mahiuddinpur BO": "203131",
      "Raniaoli BO": "203131",
      "Dashhera  Kherli BO": "203131",
      "Biroura BO": "203397",
      "Narau BO": "203397",
      "Ahmadgarh BO": "203392",
      "Donka BO": "203392",
      "Khakhunda BO": "203392",
      "Asadpur Gher BO": "203393",
      "Dharmpur BO": "203393",
      "Rahim  Kot BO": "203393",
      "Raj Ghat BO": "203393",
      "Talwar BO": "203393",
      "Devrala BO": "203129",
      "Gangawaly BO": "203129",
      "Sabitgarh BO": "203129",
      "Dabar BO": "203132",
      "Sarangpur BO": "203132",
      "Dighi BO": "203396",
      "Dharakpur BO": "203399",
      "Sarai Ghashi BO": "203001",
      "Aulina BO": "203001",
      "Jauli Garh BO": "203001",
      "Hattmabad BO": "203001",
      "Dhatori BO": "203001",
      "Malagarh BO": "203001",
      "Jhal Khera BO": "203002",
      "Shikhera BO": "203002",
      "Bhargava Pharmecy BO": "203390",
      "Birauli BO": "203390",
      "Bhopatpur Bo": "203390",
      "Bihta BO": "203402",
      "Hingwara BO": "203402",
      "Gesupur Barwala BO": "203403",
      "Hazipur BO": "203403",
      "Mankari BO": "203403",
      "Baral BO": "203408",
      "Kisauli BO": "203408",
      "Charora BO": "203394",
      "Dhalana BO": "203394",
      "JaleelPur BO": "203394",
      "Khadana BO": "203394",
      "Khanauda BO": "203394",
      "Kamalpur BO": "203405",
      "Riwada BO": "203391",
      "Bihra BO": "203407",
      "Bhainsakhur BO": "203411",
      "Sihi BO": "203411",
      "Balka BO": "203409",
      "Raura BO": "203150",
      "Ronda BO": "203150",
      "Anchrookalan BO": "203395",
      "Daduwa Mutafabad BO": "203395",
      "Bilsoory BO": "203205",
      "Geshupur BO": "203205",
      "Chitson BO": "203001",
      "Surjawaly BO": "203131",
      "Kahira BO": "203001",
      "Chanderu BO": "203001",
      "Akabarpur BO": "203001",
      "Dariyapur BO": "203001",
      "Salempur BO": "203001",
      "Naithala  Hasanpur BO": "203002",
      "Bibiyana BO": "203390",
      "Jirauli BO": "203390",
      "Chitsona Ali Pur BO": "203402",
      "Buklana BO": "203403",
      "Dhaniya Wali BO": "203403",
      "Jalalpur BO": "203403",
      "Asfabad Chandpura BO": "203408",
      "Banboai BO": "203408",
      "Garhiya Manpur BO": "203408",
      "Khushhalpur BO": "203408",
      "Kota BO": "203408",
      "Chandauk BO": "203394",
      "Kakrai BO": "203394",
      "Khalor BO": "203394",
      "GirauraBO": "203405",
      "Kanauna BO": "203405",
      "Bhaipur BO": "203391",
      "Bhainsrauli BO": "203411",
      "Partapur BO": "203411",
      "Tajpur BO": "203411",
      "Birouli BO": "203409",
      "Jadoul BO": "203409",
      "Ajnara BO": "203150",
      "Pondhery BO": "203150",
      "Rehamapur Siyawali BO": "203150",
      "Bohich BO": "203395",
      "Kailawan BO": "203395",
      "Utrawaly BO": "203395",
      "Bharana BO": "203205",
      "Prangarh BO": "203205",
      "Sanota BO": "203205",
      "Baddha  Bazidpur BO": "203412",
      "Bhainsaura BO": "203412",
      "Mahav BO": "203412",
      "Auranga Bad Taherpur BO": "203398",
      "Mauwa  Khera BO": "203398",
      "Mohersha BO": "203398",
      "Kehroula BO": "203131",
      "Dharpa Chuhar Pur BO": "203131",
      "Arniya BO": "203131",
      "Munda  Khera BO": "203131",
      "Senda  Faridpur BO": "203131",
      "Behlolpur BO": "203397",
      "Kamona BO": "203397",
      "DaoulatpurKhurd BO": "203392",
      "Shekhpur BO": "203392",
      "Daurau BO": "203393",
      "Kharikbari BO": "203393",
      "Khushalabad BO": "203393",
      "Satoha BO": "203393",
      "Aterna BO": "203129",
      "Badshahpur Pachgain BO": "203129",
      "Farkana  Gangagarhi BO": "203129",
      "Bhadaura Kamalpur BO": "203132",
      "Samashpur BO": "203132",
      "Vijay  Nagliya BO": "203389",
      "Banel BO": "203396",
      "Fazalpur BO": "203396",
      "Soi BO": "203396",
      "Jarara BO": "203131",
      "Bulandshahr HO": "203001",
      "AgSchool SO": "203002",
      "Anupshahr SO": "203390",
      "Bhoor SO": "203001",
      "Dav   College Bulandshahr SO": "203001",
      "Deputy  Ganj  Bulandshahr SO": "203001",
      "Khanpur SO Bulandshahr": "203405",
      "Panni  Nagar SO": "203001",
      "Siyana SO": "203412",
      "Khurja  Jn  RS SO": "203132",
      "NAPP SO": "203389",
      "Ramghat SO Bulandshahr": "203399",
      "Industrial Estate Sikandrabad SO": "203206",
      "Ipdc  Bulandshahr SO": "203001",
      "Jahangirabad Mandi SO": "203394",
      "Jahangirabad SO Bulandshahr": "203394",
      "Lakhaoti SO": "203407",
      "Obs Gulaothi SO": "203408",
      "Saidpur SO Bulandshahr": "203411",
      "Uncha Gaon SO": "203398",
      "Chhatary SO": "203397",
      "Danpur SO Bulandshahr": "203392",
      "Debai  Bazar SO": "203393",
      "Debai SO": "203393",
      "Karora SO": "203129",
      "Khurja  Chowk SO": "203131",
      "Narora SO": "203389",
      "Subhash  Road  Khurja SO": "203131",
      "Aurangabad SO Bulandshahr": "203401",
      "Bb  Nagar SO": "203402",
      "Bugrasi SO": "203403",
      "Bulandshahr Tehsil SO": "203001",
      "Gulaothi SO": "203408",
      "Kayasthwara  Sikandrabad SO": "203205",
      "Sarai  Chhabila SO": "203409",
      "Shikarpur SO Bulandshahr": "203395",
      "Gt Road  Khurja SO": "203131",
      "Khurja HO": "203131",
      "Bulandshahr  Kutchery SO": "203001",
      "Krishananagar SO": "203001",
      "KSC Mill  Anupshahr SO": "203391",
      "Shahkarinagar SO": "203150",
      "Sikandrabad SO Bulandshahr": "203205",
      "Pahasu SO": "203396"
    },
    "BALRAMPUR": {
      "Mirjapur BO": "271201",
      "Lal Nagar Sipahia BO": "271208",
      "Bank Bazar BO": "271604",
      "Badhara Bhitaura BO": "271604",
      "Bhairampur BO": "271604",
      "Chhitarpara BO": "271604",
      "Naubasta Mundila BO": "271604",
      "Bahre Kuiya BO": "271201",
      "Belha BO": "271201",
      "Bhojpur Tharu BO": "271210",
      "Hallaura BO": "271210",
      "Khamahariya BO": "271210",
      "Raniyapur BO": "271203",
      "Badalpur BO": "271205",
      "Mujehani BO": "271205",
      "Rampur Banghusra BO": "271607",
      "Bhagwanpur BO": "271208",
      "Bhangaha Kala BO": "271208",
      "Chauhattar Kalan BO": "271208",
      "Laukahwa BO": "271208",
      "Laxmi Nagar BO": "271208",
      "Majgaon BO": "271208",
      "Husaina Bad Grant BO": "271604",
      "Jaita Pur BO": "271604",
      "Khajuria BO": "271604",
      "Bangai BO": "271208",
      "Dharampur BO": "271208",
      "Jahandaria BO": "271208",
      "Rani Jot BO": "271208",
      "Dualata Bad Grant BO": "271604",
      "Gaindas Bujurg BO": "271604",
      "Gajpur Grant BO": "271604",
      "Intai BO": "271604",
      "Katra Shankar Nagar BO": "271201",
      "Bheekh Pur BO": "271201",
      "Birahimpur BO": "271201",
      "Gumri BO": "271609",
      "Mahadeiya State BO": "271609",
      "Pipra Ram Chandar BO": "271609",
      "Puraina Wajid BO": "271609",
      "Rehra Mafi BO": "271609",
      "Bakaulirajpur BO": "271210",
      "Chauhattar Khurd BO": "271210",
      "Gulriha Sandwa BO": "271210",
      "Mutehra BO": "271203",
      "Newal Garh BO": "271203",
      "Ramwapur BO": "271203",
      "Gugauli BO": "271205",
      "Gulriha BO": "271205",
      "Kauwapur BO": "271205",
      "Lai Budwa BO": "271205",
      "Bhagwanpur Kondar BO": "271206",
      "Bhathar BO": "271206",
      "Bisunpur Vishram BO": "271206",
      "Chandanpur BO": "271206",
      "Imlia Kondar BO": "271206",
      "Kataiyabhari BO": "271206",
      "Kohar Gaddi BO": "271206",
      "Rehra Cahuki BO": "271206",
      "Ghughulpur BO": "271201",
      "Purab Tola BO": "271201",
      "Gajaihwa BO": "271201",
      "Jabdha BO": "271201",
      "Puraina BO": "271210",
      "Shivpur Mhadev BO": "271210",
      "Sonpur BO": "271207",
      "Thakurapur BO": "271210",
      "Ganeshpur BO": "271215",
      "Baldev Nagar BO": "271861",
      "Bankatwa BO": "271861",
      "Amauli Dhamali BO": "271206",
      "Madni BO": "271206",
      "Majgawan BO": "271206",
      "Kundwa BO": "271215",
      "Kutti Ram Talha BO": "271215",
      "Madha Nagar BO": "271215",
      "Malda BO": "271215",
      "Bardaulia BO": "271207",
      "Bishunipur BO": "271201",
      "Chaudhary Deeh BO": "271207",
      "Shankarpur Kalan BO": "271206",
      "Suganagar Dumri BO": "271206",
      "Thurwaliya BO": "271206",
      "Adamtara BO": "271215",
      "Bargadha Sohna BO": "271215",
      "Bargadwa BO": "271215",
      "Belhsa BO": "271215",
      "Dhawai BO": "271215",
      "PANDARI BO": "271201",
      "Gudra BO": "271208",
      "Kondari BO": "271208",
      "Naikiniya BO": "271208",
      "Allipur Bujurg BO": "271604",
      "Dhaurahara BO": "271604",
      "Entai Rampur BO": "271604",
      "Godahana BO": "271604",
      "Nandauri BO": "271604",
      "Sehrinwa BO": "271205",
      "Mangra Kohal BO": "271861",
      "Badhara BO": "271206",
      "Banghusri BO": "271206",
      "Dumri BO": "271206",
      "Gurchihwa BO": "271206",
      "Parasrampur BO": "271206",
      "Rajdarwa Tharu BO": "271206",
      "Achkawapur BO": "271215",
      "Bemiha BO": "271215",
      "Manpur BO": "271215",
      "Pipriha Jamuni BO": "271215",
      "Vijay Nagar BO": "271215",
      "BUDHIPUR BO": "271306",
      "Hasanpur BO": "271207",
      "Shankar Nagar BO": "271207",
      "Deoria Mubarakpur BO": "271607",
      "Maniyaria BO": "271607",
      "Bargadhi BO": "271201",
      "Distt Court Balrampur  BO": "271201",
      "BISHUNPUR BO": "271207",
      "Jewnar BO": "271201",
      "Fakirapur BO": "271609",
      "Jamuni Kala BO": "271210",
      "Manikapur BO": "271210",
      "Amwabas BO": "271203",
      "Mundila BO": "271205",
      "Sugganagar BO": "271205",
      "Kodri BO": "271861",
      "Laliya BO": "271861",
      "Pranpur BO": "271861",
      "Bairihwa BO": "271206",
      "Bethaniya Karihniya BO": "271206",
      "Dhabauliya BO": "271206",
      "Parasrampur Rajahana BO": "271206",
      "Ram Nagar BO": "271206",
      "Visunpur Tantanwa BO": "271206",
      "Bhagwanpur Khadar BO": "271215",
      "Manohrapur BO": "271215",
      "Tirlokpur BO": "271215",
      "Badhya Fareed Khan BO": "271306",
      "Kishunpur Grant BO": "271306",
      "Deopura BO": "271207",
      "Motipur BO": "271207",
      "Datauli BO": "271306",
      "Saraikhas BO": "271306",
      "Ahirauli Buzurg BO": "271306",
      "Udaipur BO": "271207",
      "Dari Chaura BO": "271607",
      "Deoria Rani Jot BO": "271607",
      "Mahuwa BO": "271607",
      "Pehar BO": "271604",
      "Utraula Bazar BO": "271604",
      "Achalpur Kaithawalia BO": "271307",
      "Deoria Inayat BO": "271307",
      "Obarideeh BO": "271307",
      "Sekhuiya BO": "271604",
      "Parsona BO": "271604",
      "Terhwa Nawabad BO": "271604",
      "Kharhana Naudeehwa BO": "271307",
      "Lokiya Tahir BO": "271307",
      "Maddo Chaura BO": "271307",
      "Kishunpur Sagar BO": "271307",
      "Ramapur Grant BO": "271307",
      "Bhelya Madanpur BO": "271307",
      "Golahipur BO": "271307",
      "Intai Abdullah BO": "271307",
      "Balrampur HO": "271201",
      "FARENDA BO": "271201",
      "Koilara BO": "271201",
      "Bhagautiganj SO": "271201",
      "Chamrupur SO": "271609",
      "Gainsari SO": "271210",
      "Jarwa SO": "271203",
      "Balrampur Degree College SO": "271201",
      "Mahrajganj SO Balrampur": "271205",
      "Shivpura SO": "271207",
      "Sriduttganj SO": "271607",
      "Sadullanagar SO": "271307",
      "Mathura Bazar SO": "271861",
      "Purani Bazar Pachperwa SO": "271215",
      "Rehra Bazar SO": "271306",
      "Tulsipur SO": "271208",
      "Pachperwa SO": "271206",
      "Utraula SO": "271604"
    },
    "SULTANPUR": {
      "Mokalpur BO": "228171",
      "Amari BO": "228161",
      "Mangrawan BO": "228161",
      "Narayanpur BO": "228161",
      "Pakarpur BO": "228161",
      "Bisawan BO": "227812",
      "HARPUR BO": "228172",
      "Kenaura BO": "227816",
      "Baranpur BO": "227812",
      "Saraiya Mafi BO": "227812",
      "RUPAIPUR BO": "228172",
      "Dobhiara BO": "227815",
      "Jarai Kalan BO": "227815",
      "Sikari BO": "227815",
      "Bandhua Kalan BO": "227808",
      "Jurupur BO": "227808",
      "Maniyarpur BO": "227808",
      "Naugawan Raitasi BO": "227808",
      "Dadupur BO": "227808",
      "Amilia Sikara BO": "228141",
      "Rupinpur BO": "228141",
      "Sonawan BO": "222301",
      "Akorhi BO": "228151",
      "Babhangawan BO": "228151",
      "Bariauna BO": "228151",
      "Chakchurawanpur BO": "228151",
      "Nachana BO": "228151",
      "Rajupur Ikdala BO": "228151",
      "Saidkhanpur BO": "228151",
      "Bhandara BO": "228155",
      "Tirchhe BO": "228155",
      "Jamkhuri BO": "222302",
      "Mahdeva BO": "222302",
      "Parasurampur BO": "222302",
      "Raipur BO": "222302",
      "Waini BO": "222302",
      "Kothara Khurd BO": "222303",
      "Tamarsepur BO": "222303",
      "Chorma BO": "228142",
      "Isur BO": "228142",
      "Kareban BO": "228142",
      "Lahauta BO": "228142",
      "Para BO": "227813",
      "Dehli Mubarakpur BO": "228159",
      "Tikariya BO": "228159",
      "Bhain BO": "228159",
      "Gaura Tikari BO": "228161",
      "Haripur BO": "228161",
      "Hinduabad BO": "228161",
      "Rawania BO": "228161",
      "Shahabuddinpur BO": "228161",
      "Sukulpur BO": "228161",
      "Surapur BO": "228161",
      "Trilokpur Newada BO": "228161",
      "BHELARA BO": "228172",
      "KALAN BO": "228172",
      "Jasapara BO": "228119",
      "Madhavpur Chhatauna BO": "228119",
      "Misrauli BO": "228119",
      "Saifullaganj BO": "228119",
      "Ugharpur BO": "228119",
      "Moongar BO": "228141",
      "Numaye Maraye BO": "228141",
      "Palia BO": "228141",
      "Burhana BO": "228145",
      "Dandia Amrethu BO": "228145",
      "Hamidpur BO": "228145",
      "Hamjapur Pathan BO": "228145",
      "Katghara Patti BO": "228145",
      "Naugawan Tir BO": "228155",
      "Rupapur BO": "228155",
      "Sarkaura BO": "228155",
      "Bhadaiyan BO": "222302",
      "Budhapur BO": "222302",
      "Chaukia BO": "222302",
      "Garabpur BO": "222302",
      "Raja Umari BO": "222302",
      "Ramgarh BO": "222302",
      "Rikhpur BO": "222302",
      "Rampur BO": "222303",
      "Sadarpur BO": "222303",
      "Safipur BO": "222303",
      "Sukul Umari BO": "222303",
      "Miranpurr BO": "228159",
      "Bhatauta Tulsi Patti BO": "228161",
      "Deorajpur BO": "228161",
      "Magarsan Kala BO": "228161",
      "Meopur BO": "228161",
      "Paharpur BO": "228161",
      "Usrauli BO": "228161",
      "BANGAWAN DEEH BO": "228172",
      "Baregaon BO": "228119",
      "Hayatnagar BO": "228119",
      "Teary BO": "228119",
      "Waidaha  BO": "228119",
      "Pipari BO": "227815",
      "Ramapur BO": "227808",
      "Shahpur BO": "227808",
      "Birsinghpur BO": "228141",
      "Jamalpur Jajrahi BO": "228141",
      "Purushottampur BO": "228141",
      "Seotari BO": "228141",
      "Barauna Dih BO": "228145",
      "Biri Hajipur BO": "228145",
      "Kadipur Khurd BO": "228145",
      "Kisundaspur BO": "228145",
      "Musatafabad Saraiya BO": "228145",
      "Satanpur BO": "228145",
      "Malhipur BO": "222301",
      "Chandipur BO": "228151",
      "Dheka Pakhanpur BO": "228151",
      "Gaura BO": "228151",
      "Jura Patti BO": "228151",
      "Khadar Basantpur BO": "228155",
      "Parsipur BO": "228155",
      "Sohgauli BO": "228155",
      "Bahrauli BO": "228159",
      "Barua BO": "222302",
      "Maksudan BO": "222302",
      "Narharpur BO": "222302",
      "Shankarpur BO": "222302",
      "Tato Muraini BO": "222302",
      "Dewarh BO": "222303",
      "Baura Jagdishpur BO": "228142",
      "Bijhuri BO": "228142",
      "Parsa Darwa BO": "228142",
      "Semari Pursottampur BO": "228159",
      "Bhada BO": "228159",
      "Fatehpur Sangat BO": "228119",
      "Dubepur BO": "227815",
      "Taudhikpur BO": "227815",
      "Umara BO": "227815",
      "Bahlolpur BO": "227808",
      "Bankepur BO": "227808",
      "Palhipur BO": "227808",
      "Biraipur BO": "228141",
      "Dharsauli BO": "228141",
      "Banke Gaon BO": "228145",
      "Barwaripur BO": "228145",
      "Katsari BO": "228145",
      "Malikpur Nonara BO": "228145",
      "Raibigo BO": "228145",
      "Angnakol BO": "228118",
      "Bainti Kalan BO": "222301",
      "Dhajai Keshavpur BO": "228151",
      "Dhundhu BO": "228151",
      "Guptarganj BO": "228151",
      "Kotwa Lahangrai BO": "228151",
      "Parwar BO": "228151",
      "Seur Chamurkha BO": "228151",
      "Bansi BO": "228155",
      "Ferozpur Kala BO": "228155",
      "Barsara BO": "222302",
      "Belahi BO": "222302",
      "Ghatampur BO": "222302",
      "Hardaspur BO": "222302",
      "Misirpur BO": "222302",
      "Narendapur BO": "222302",
      "Shahpur Harbansh BO": "222302",
      "Sheshanpur BO": "222302",
      "Bhua Pathkauli BO": "222303",
      "Chhapar BO": "222303",
      "Khanpur BO": "222303",
      "Bhikhupur BO": "228142",
      "Parsara BO": "228142",
      "Alahadadpur BO": "228159",
      "Lohra Mau BO": "228001",
      "Jhauara BO": "228001",
      "Ahimane BO": "228001",
      "Bhapta BO": "228001",
      "Katawan BO": "228001",
      "Paudhan Rampur BO": "228171",
      "Tajuddinpur BO": "228171",
      "Baburi BO": "227805",
      "Dharawan BO": "227805",
      "Agai BO": "228121",
      "Bhikharpur BO": "228121",
      "Barmhauli BO": "227814",
      "Kanehti BO": "227814",
      "Dehriyawan BO": "227806",
      "Nandauli BO": "227806",
      "Raincha BO": "227806",
      "Mirpur Saraiya BO": "228133",
      "Ranipur BO": "227304",
      "Shivgarh BO": "227304",
      "Kachha Bhitaura BO": "228132",
      "Paras Patti BO": "228132",
      "Ugharpur Bhatpura BO": "228132",
      "Bhanti BO": "227408",
      "Bani BO": "228131",
      "Khalispur Dingur BO": "228131",
      "Kunda Bhairavpur BO": "228131",
      "Narayanpur Kalan BO": "228131",
      "Palia Golpur BO": "228131",
      "Umarpur BO": "228131",
      "Inayatpur BO": "228125",
      "Mahmoodpur BO": "228125",
      "Bahadurpur BO": "228001",
      "Chhatauna BO": "228001",
      "Anirudhpur BO": "228171",
      "Gorabarik BO": "228001",
      "Bikwajitpur BO": "228001",
      "Ramnagar Kot BO": "228001",
      "Dhakwa BO": "228001",
      "Harthua Babhanpur BO": "228171",
      "Kuchhmuchh BO": "228001",
      "Baijapur BO": "228001",
      "Uturi BO": "228001",
      "Abhiya Kalan BO": "228001",
      "Ganpat Sahai Degree College BO": "228001",
      "Hanumanganj BO": "228001",
      "Pakhrauli BO": "228001",
      "Alimuddinpur BO": "228171",
      "Alipur Saravan BO": "228171",
      "Chandaur BO": "228121",
      "Makdoomnagar BO": "228121",
      "Mayang BO": "228121",
      "Pipargaon BO": "228121",
      "Ainjar BO": "227814",
      "Bahurahwan BO": "227814",
      "Singhni BO": "227814",
      "Athaisi BO": "228120",
      "Damodarpur BO": "228120",
      "Saini BO": "227806",
      "Soraon BO": "227806",
      "Ausanpur BO": "227304",
      "Garayen BO": "227304",
      "Harha BO": "227304",
      "Kandhaipur BO": "227304",
      "Dhema BO": "228132",
      "Kharsara BO": "228132",
      "Lama Bankata BO": "228132",
      "Motigarpur BO": "228132",
      "Paharpur Sarai Bhikham BO": "228132",
      "Gosaisinghpur BO": "228131",
      "Hatiyawan BO": "228131",
      "Imligaon BO": "228131",
      "Kamtaganj BO": "228131",
      "Ballipur BO": "228125",
      "Dih Dhaggupur BO": "228125",
      "Faridpur BO": "228171",
      "Haji Patti BO": "227805",
      "Khokhipur BO": "227805",
      "Kotia BO": "227805",
      "Majhana BO": "227805",
      "Rajupur BO": "227805",
      "Nandrai BO": "227814",
      "Padare BO": "227814",
      "Peero Saraia BO": "227814",
      "Dih BO": "227806",
      "Gaura Loharia BO": "227806",
      "Kampa BO": "227806",
      "Meghmau BO": "227806",
      "Bahauddinpur BO": "228133",
      "Basupur BO": "228133",
      "Bhilampur BO": "228131",
      "Chhitepatti BO": "228131",
      "Sarsawan BO": "228131",
      "Surhurpur BO": "228131",
      "Manipur Patna BO": "228125",
      "Motiganj BO": "228125",
      "Pratap Pur BO": "228125",
      "Sonara BO": "228125",
      "Unurkha BO": "228171",
      "Bela Pashchim BO": "227805",
      "Unchgaon BO": "227805",
      "Bingi BO": "228121",
      "Jajjaur BO": "228121",
      "Murua BO": "228121",
      "Baqghauna BO": "227814",
      "Deora BO": "227814",
      "Kaithwara BO": "228120",
      "Bhakhari BO": "227806",
      "Narsara BO": "227806",
      "Tirhut BO": "227806",
      "Nanemau BO": "228133",
      "Arjunpur BO": "227304",
      "Bhardhipur BO": "227304",
      "Kaithapur BO": "227304",
      "Patipur BO": "227304",
      "Suryabhan Patti BO": "227304",
      "Ahda BO": "228132",
      "Hamzabad BO": "228132",
      "Bikana BO": "227408",
      "Bethara BO": "228131",
      "Dhanaupur BO": "228131",
      "Kaithi Jalalpur BO": "228131",
      "Kumbhi BO": "228131",
      "Loknathpur BO": "228131",
      "Paharpur Rai Patti BO": "228131",
      "Rohiyawan Jalalpur BO": "228131",
      "Kanauli BO": "228125",
      "Sultanpur Avadh HO": "228001",
      "Civil Lines Sultanpur SO": "228001",
      "Dostpur SO": "228131",
      "Jaisinghpur SO Sultanpur": "228141",
      "Karaundia SO": "228001",
      "Khairabad SO Sultanpur": "228001",
      "Belwai SO": "228172",
      "Deara SO": "228132",
      "Dhammaur SO": "227408",
      "Dwarikaganj SO": "228125",
      "Gosainganj SO Sultanpur": "228119",
      "Kadipur SO": "228145",
      "Kurebhar SO": "228151",
      "Haliapur SO": "227815",
      "Kamla Nehru Institute SO": "228118",
      "Koiripur SO": "222301",
      "Bharkhare SO": "227304",
      "Ataula SO": "227814",
      "Bazar Baldirai SO": "227806",
      "Kurwar SO": "228155",
      "Lambhua SO": "222302",
      "Tawakkalpur Nagra SO": "228161",
      "Wallipur SO": "227812",
      "Akhandnagar SO": "228171",
      "Baraunsa SO": "228120",
      "Belahari SO": "228133",
      "Bus Station SO Sultanpur": "228001",
      "Hasanpur SO Sultanpur": "227808",
      "Loco Colony SO": "228001",
      "Maharani Pachchhim SO": "222303",
      "Mahmoodpur Semri SO": "228142",
      "Shyamnagar SO Sultanpur": "228001",
      "Aliganj Bazar SO": "227805",
      "Atarsuma SO": "228121"
    },
    "BIJNOR": {
      "Mehamdabad BO": "246726",
      "Nagal Jat BO": "246726",
      "Paijaniya BO": "246726",
      "Pawati BO": "246726",
      "Dhokalpur BO": "246728",
      "Khari BO": "246728",
      "Nawada BO": "246728",
      "Umri BO": "246728",
      "Bhojpur BO": "246731",
      "Sisauna BO": "246729",
      "Amhera BO": "246726",
      "Sherpur Kalyan BO": "246726",
      "Bahupura BO": "246731",
      "Barampur BO": "246731",
      "Maseet BO": "246729",
      "Bilai BO": "246726",
      "Kumharpura Urf Ibrahimpur BO": "246726",
      "Dhanaura BO": "246728",
      "Chitawar BO": "246731",
      "Gandhore BO": "246725",
      "Imliya BO": "246725",
      "Roniya BO": "246725",
      "Saindwar BO": "246725",
      "Siau BO": "246725",
      "Nayak Nagla BO": "246729",
      "Baldiya BO": "246726",
      "Chanda Nagli BO": "246726",
      "Chowkpuri BO": "246728",
      "Heempur Deepa BO": "246725",
      "Jalilpur BO": "246725",
      "Sudnipur Rawati BO": "246725",
      "Fazalpur Dhaki BO": "246729",
      "Naya Gaon BO": "246701",
      "Gajraula Shiv BO": "246701",
      "Kharak Jeetpur BO": "246701",
      "Agri BO": "246701",
      "Sabdalpur Rehra BO": "246701",
      "Daranagar Ganj BO": "246701",
      "Dharm Nagri BO": "246701",
      "Mo Pur Mandawali BO": "246701",
      "Akondha BO": "246736",
      "Basantpur BO": "246736",
      "Darbara BO": "246725",
      "Datiyana BO": "246725",
      "Shadipur BO": "246764",
      "Bahadarpur Sherfuddin BO": "246721",
      "Budgara BO": "246721",
      "Chandok RS BO": "246721",
      "Raipur Berisal BO": "246721",
      "Rawli BO": "246721",
      "Sabalpur Bitra BO": "246732",
      "Jogirampuri BO": "246763",
      "Kishanpur Aanwla BO": "246763",
      "Bhaguwala BO": "246749",
      "Padli Basera BO": "246761",
      "Bhatiyana Khushalpur BO": "246761",
      "Mankuaa BO": "246761",
      "Sarkara Chakrajmal BO": "246761",
      "Dhakka Karamchand BO": "246761",
      "Gordhanpur BO": "246722",
      "Hidayatpur BO": "246722",
      "Kalluwala BO": "246722",
      "Kasampur Garhi BO": "246722",
      "Sirwasuchand BO": "246722",
      "Shahpur Kheri BO": "246727",
      "Bhagwanpur BO": "246762",
      "Haijarpur BO": "246762",
      "Harbanspur Dharam BO": "246762",
      "Jeetpur Paldi BO": "246762",
      "Majhera Shakroo BO": "246762",
      "Manawwarpur  Said BO": "246762",
      "Medpura Sultan BO": "246762",
      "Saidpuri Mahichand BO": "246762",
      "Akhera BO": "246733",
      "Alhedalpur Mubarak BO": "246733",
      "Bairmabad  Garhi BO": "246733",
      "Sedha BO": "246733",
      "Sherpur Balla BO": "246733",
      "Sikri Buzurg BO": "246733",
      "Aheerpura BO": "246734",
      "Allauddinpur BO": "246734",
      "Azampur BO": "246734",
      "Shadipur Milak BO": "246734",
      "Mehmoodpur BO": "246745",
      "Allhapurmohkam BO": "246747",
      "Bhanauti BO": "246747",
      "Hafizabad BO": "246747",
      "Haraivli BO": "246747",
      "Hussainpur BO": "246731",
      "Mauzzampur Narayan BO": "246731",
      "Meman Bhanera BO": "246731",
      "Rajapur Sadat BO": "246764",
      "Qadrabad BO": "246722",
      "MohdPur Devmal BO": "246721",
      "Mohiddinpur BO": "246721",
      "Narayanpur BO": "246721",
      "Chandanpura BO": "246763",
      "Dhansini BO": "246763",
      "Fazalpur BO": "246763",
      "Jalalabad Bijnor BO": "246763",
      "Jhakaki BO": "246763",
      "Kotkader BO": "246763",
      "Lal Dhang BO": "246763",
      "Mahawatpur Billoch BO": "246763",
      "Talipada BO": "246763",
      "Manpurshivpuri BO": "246761",
      "Saddobair BO": "246761",
      "Tibri BO": "246761",
      "Athai Sheikh BO": "246761",
      "Morna BO": "246761",
      "Aasfabad Chaman BO": "246722",
      "Alampur Ganvri BO": "246722",
      "Bheekhawala BO": "246722",
      "Udaipur BO": "246722",
      "Asgaripur BO": "246727",
      "Bishanpur BO": "246727",
      "Manjhola Billoch BO": "246727",
      "Nagli Pathwari BO": "246727",
      "Islamabad BO": "246762",
      "Milak Mukeempur BO": "246733",
      "Mohammedpur Kamil BO": "246733",
      "Nakibpur Khajoori BO": "246733",
      "Narayan Kheri BO": "246733",
      "Khaspura BO": "246734",
      "Shiwala Kalan BO": "246734",
      "Sabdalpur BO": "246735",
      "Haldua Mafi BO": "246745",
      "Kiwar BO": "246745",
      "Maqsoodpur BO": "246745",
      "Daultabad BO": "246746",
      "Shahnagar Kurali BO": "246747",
      "Shahzadpur BO": "246747",
      "Suawala BO": "246747",
      "Kumhera BO": "246731",
      "Padla BO": "246731",
      "Baibalpur BO": "246764",
      "Jhilmila BO": "246764",
      "Lakhuwala BO": "246764",
      "Mirzapur Mahesh Urf Bankpur BO": "246764",
      "Khanpur Madho BO": "246721",
      "Jalpur BO": "246732",
      "Gaindi Khata BO": "246763",
      "Jahanabad Khobda BO": "246763",
      "Mithi Beri BO": "246763",
      "Raipur Sadat BO": "246763",
      "Tanda Maidas BO": "246763",
      "Bijauri BO": "246749",
      "Mandawali BO": "246749",
      "Bakshanpur BO": "246761",
      "Habibwala BO": "246761",
      "Amkhera  Sanjarpur BO": "246761",
      "Heempur Buzurg BO": "246725",
      "Ismailpur BO": "246725",
      "Mirzapur Khader BO": "246725",
      "Pipli Jat BO": "246725",
      "Singha BO": "246725",
      "Baberpur BO": "246729",
      "Gangu Nagla BO": "246729",
      "Nasiri BO": "246701",
      "Uledha BO": "246701",
      "Qaziwala BO": "246701",
      "Bakherpur Garhi BO": "246701",
      "Fatehpur Kalan BO": "246701",
      "Bharaira BO": "246701",
      "Suwheri BO": "246701",
      "Prathvipur BO": "246701",
      "Rasoolpur Nagla BO": "246736",
      "Ajdev Khanpur BO": "246725",
      "Bahmanshora BO": "246725",
      "Faridpur Bhogi BO": "246701",
      "Sardhani BO": "246701",
      "Mangolpura Roopchand BO": "246701",
      "Vidur Kuti BO": "246701",
      "SaidaBad BO": "246701",
      "Khirni Barkatpur BO": "246723",
      "Tisotra BO": "246723",
      "Bakaina BO": "246736",
      "Aurangabad Urf Sikanderpur BO": "246725",
      "Bagarpur BO": "246725",
      "Doodhli BO": "246731",
      "Rampur Bishna BO": "246731",
      "Akbarabad BO": "246764",
      "Barooki BO": "246764",
      "Maheswari Jat BO": "246764",
      "Sunpata BO": "246764",
      "Ganjalpur BO": "246721",
      "Maheswari Nagla BO": "246721",
      "Rajpur Nawada BO": "246732",
      "Sofatpur BO": "246732",
      "Gajraula Paimar BO": "246763",
      "Guniapur BO": "246763",
      "Sikanderpur Basi BO": "246763",
      "Jatpura Bonda BO": "246749",
      "Mohanpur BO": "246749",
      "Milak Puranpur BO": "246761",
      "Mauri Kedarpur BO": "246761",
      "Nasirpur Banwari BO": "246761",
      "Neendru BO": "246761",
      "Sarkathal Sahni BO": "246761",
      "Anwarpur Chandka BO": "246722",
      "Jamanwala BO": "246722",
      "Maniyawala BO": "246722",
      "Rehar BO": "246722",
      "Barkhera BO": "246724",
      "Lodhipur Milak BO": "246727",
      "Alladinpur  Bhogi BO": "246762",
      "Bhogli BO": "246762",
      "Harganpur BO": "246762",
      "Nainpura BO": "246762",
      "Harganpur Sajauli BO": "246733",
      "Meharlipur BO": "246733",
      "Phoolsanda BO": "246733",
      "Rustampur Sherpali Jat BO": "246733",
      "Taharpur Said BO": "246733",
      "Bakhrabad  Urf Khatai BO": "246734",
      "Dharupur BO": "246734",
      "Murhat BO": "246734",
      "Mustafabad BO": "246734",
      "Ratagarh BO": "246734",
      "Jamalpur Kirat BO": "246735",
      "Kolasagar BO": "246735",
      "Mewa Nawada BO": "246745",
      "Nawada Kesho BO": "246746",
      "Sadafal BO": "246746",
      "Jatpura BO": "246747",
      "Mohammedpur Rajauri BO": "246747",
      "Puraini BO": "246761",
      "Maujampur Suraj BO": "246761",
      "Mauzampur Jaitra BO": "246761",
      "Pipalsana BO": "246761",
      "UMRI BO": "246761",
      "Bhatpura BO": "246722",
      "Birla Farm BO": "246722",
      "Rasoolabad BO": "246722",
      "Tanda Shahuwala BO": "246724",
      "Jheeran BO": "246727",
      "Kmala BO": "246727",
      "Alaihdajpur Khajuba BO": "246762",
      "Hirawali BO": "246762",
      "Pakhanpur BO": "246762",
      "Begrajpur BO": "246733",
      "Mahua BO": "246733",
      "Rampur Bidar BO": "246733",
      "Sadruddin Nagar BO": "246733",
      "Bhaisa BO": "246734",
      "Gohawar BO": "246734",
      "Pheena BO": "246734",
      "Bhogpur BO": "246735",
      "Rawana Shikarpur BO": "246735",
      "Bagwara BO": "246745",
      "Sadaranpur BO": "246745",
      "Budhanpur BO": "246746",
      "Mukarabpuri BO": "246746",
      "Palanpur BO": "246746",
      "Sipahiwala BO": "246746",
      "Mirzapur BO": "246747",
      "Nwadasaidpur Jalal BO": "246747",
      "Shergarh BO": "246747",
      "Bijnor HO": "246701",
      "Dhampur HO": "246761",
      "Balawali SO": "246723",
      "Bashta SO": "246736",
      "Chandpur Sugar Factory SO": "246729",
      "Civil Line SO": "246701",
      "Khatriyan SO": "246701",
      "Mandawar SO Bijnor": "246721",
      "Nagal SO Bijnor": "246732",
      "Najibabad RS SO": "246763",
      "Najibabad SO": "246763",
      "District Board SO": "246701",
      "Chandpur RS PO": "246725",
      "Afzalgarh SO": "246722",
      "Hassupura SO": "246727",
      "Nagina SO Bijnor": "246762",
      "Nehtaur Bus Stand SO": "246733",
      "Sahaspur SO Bijnor": "246745",
      "Sherkot SO": "246747",
      "B I Estate SO": "246701",
      "Chandpur SO": "246725",
      "I A Najibabad SO": "246763",
      "Jatan SO": "246701",
      "Kallooganj SO": "246763",
      "Najibabad Tehsil SO": "246763",
      "Badhapur SO": "246724",
      "Chotti Mandi Dhampur SO": "246761",
      "Dhampur Mandi SO": "246761",
      "Ganj Bazar Nagina SO": "246762",
      "Main Bazar Nehtaur SO": "246733",
      "Nagina Bazar SO": "246762",
      "Basi Kiratapur SO": "246731",
      "Haldaur SO": "246726",
      "Jhalu SO": "246728",
      "Kotwali SO Bijnor": "246764",
      "Noorpur SO": "246734",
      "Rahu Nagli SO": "246737",
      "Seohara RS SO": "246746",
      "Kiratpur SO": "246731",
      "Nai Basti SO": "246701",
      "Sahanpur SO": "246749",
      "Dhampur Sugar Mill SO": "246761",
      "Nehtaur SO": "246733",
      "Rajakatajpur SO": "246735",
      "Seohara SO": "246746"
    },
    "RAMPUR": {
      "Khusro Bagh BO": "244901",
      "Daniapur BO": "244901",
      "Aghapur BO": "244901",
      "Bara Khas BO": "244901",
      "Kakrawa BO": "244901",
      "Anwaria Talibabad BO": "244921",
      "Bhansia Jawalapuri BO": "244921",
      "Chandela BO": "244921",
      "Ishanagar BO": "244921",
      "Mathkhera  BO": "244921",
      "Milak Khanam BO": "244921",
      "Panwaria BO": "244923",
      "Rampura Buzurg BO": "244923",
      "Dhamora BO": "244701",
      "Dhaneli Uttari BO": "244701",
      "Bhonrka BO": "244701",
      "Kiramcha BO": "244701",
      "Gangapur Purvi BO": "244701",
      "Param BO": "244701",
      "Azim Nagar BO": "244927",
      "Deorania BO": "244927",
      "Ghrampur Narendrapur BO": "244922",
      "Karenthi BO": "244922",
      "Madhukar BO": "244922",
      "Meerapur Meerganj BO": "244924",
      "Nanka Rani BO": "244924",
      "Paigamberpur BO": "244921",
      "Puswara BO": "244924",
      "Chamrawa BO": "244901",
      "Koila BO": "244901",
      "Punjab Nagar BO": "244901",
      "Rewari Kalan BO": "244901",
      "Kira BO": "244901",
      "Pipalia Gopal BO": "244921",
      "Rasdandia BO": "244921",
      "Ratanpura BO": "244921",
      "Simaria BO": "244921",
      "Godhi BO": "244923",
      "Jiwai Kadim BO": "244701",
      "Khod BO": "244927",
      "Mursaina BO": "244927",
      "Nagalia Aqil BO": "244927",
      "Doondawala BO": "244924",
      "Khempur BO": "244921",
      "Khod Sharif BO": "244924",
      "Kunwarpur BO": "244924",
      "Juthia BO": "244901",
      "Mahu Nagar BO": "244901",
      "Madhauli BO": "244901",
      "Patwai BO": "244901",
      "Nipania BO": "244901",
      "Benazir BO": "244901",
      "Nankar BO": "244901",
      "Ahro BO": "244921",
      "Begamabad BO": "244921",
      "Hamidabad BO": "244921",
      "Khandia BO": "244921",
      "Nawabganj BO": "244921",
      "Swarg Farm BO": "244923",
      "Khamaria BO": "244701",
      "Mankara BO": "244701",
      "Patti Basantpur BO": "244701",
      "Rathonda BO": "244701",
      "Koop BO": "244701",
      "Parshupura BO": "244701",
      "Ahmad Nagar Kalan BO": "244927",
      "Hamirpur BO": "244927",
      "Dhakia BO": "244922",
      "Tanda BO": "244922",
      "Maswasi BO": "244924",
      "Samodia BO": "244924",
      "Chikti Ramnagar BO": "244901",
      "Bhot BO": "244901",
      "Ajit Pur BO": "244901",
      "Mathurapur BO": "244901",
      "Roshan Bag Road BO": "244901",
      "Mulla Khera BO": "244921",
      "Chandain BO": "244923",
      "Babura BO": "244701",
      "Keorar BO": "244701",
      "Silai Bara Gaon BO": "244701",
      "Loha BO": "244701",
      "Kashipur BO": "244927",
      "Lalpur Kalan BO": "244927",
      "Singhankhera BO": "244927",
      "Bara Gaon BO": "244922",
      "Rawana BO": "244922",
      "Unchagaon BO": "244922",
      "Bhot Baqqal BO": "244924",
      "Manpur BO": "244925",
      "Rehmatganj BO": "244924",
      "Narkhera BO": "244901",
      "Daryal BO": "244925",
      "Dhanupura BO": "244925",
      "Lambakhera BO": "244925",
      "Mewla Kalan BO": "244925",
      "Pipli Nayak BO": "244925",
      "Ramnagar Latifpur BO": "244925",
      "Udmawala BO": "244925",
      "Bakenia BO": "244901",
      "Dheeraj Nagar BO": "244925",
      "Rampur HO": "244901",
      "Milak SO": "244701",
      "MBRampur SO": "244901",
      "Meston Ganj SO": "244901",
      "Purana Ganj SO": "244901",
      "Jwala Nagar SO": "244901",
      "Rampur City SO": "244901",
      "Said Nagar SO": "244927",
      "Tanda Badli SO": "244925",
      "Tehsil Rampur SO": "244901",
      "CRP Hq SO": "244901",
      "Civil Line Rampur SO": "244901",
      "RAMPUR DISTILLERY SO": "244901",
      "Rampur Secretariate SO": "244901",
      "Shahbad SO Rampur": "244922",
      "Bilaspur Chini Mill SO": "244923",
      "Suar SO": "244924",
      "Modipur SO": "244926",
      "Rampur Chowk SO": "244901",
      "Bilaspur Rampur SO": "244921",
      "C  M Store SO": "244901",
      "Islam Ganj SO": "244901",
      "Kemri SO Rampur": "244928"
    },
    "KANPUR DEHAT": {
      "Korwakhurd BO": "209101",
      "Bilhapur BO": "209112",
      "Debair BO": "209112",
      "Devrahut BO": "209112",
      "Paniyamau BO": "209112",
      "Selhoopur BO": "209112",
      "Kodwa BO": "209307",
      "Lalpur SheorajPur": "209307",
      "Bhuganiyapur BO": "209101",
      "Gauriyapur BO": "209101",
      "Gujraai BO": "209101",
      "Jhindaura BO": "209101",
      "Karosa BO": "209101",
      "Lalpur II BO": "209101",
      "Lalpur RS BO": "209101",
      "Shekhpur BO": "209112",
      "Hathika BO": "209307",
      "Bewain BO": "209101",
      "Kumbhi BO": "209101",
      "RATHGAON BO": "209208",
      "Sariyapur BO": "209101",
      "Gaur BO": "209112",
      "Mancha BO": "209112",
      "Mohana EUP 7305 BO": "209311",
      "MAti KishunPur BO": "209311",
      "Sithmara BO": "209302",
      "Jalihapur BO": "209302",
      "Bhandemau BO": "209310",
      "Jasapur BO": "209310",
      "Khanpur BO": "209310",
      "Mahua Mahoi BO": "209310",
      "Bamhrauli BO": "209208",
      "Daheli BO": "209208",
      "Kachhigaon BO": "209111",
      "Saray BO": "209111",
      "Rasdhan BO": "209115",
      "Rurgaon BO": "209115",
      "Makrandpur BO": "209306",
      "Narkhurd BO": "209306",
      "Shisahi BO": "209306",
      "Usri BO": "209306",
      "Gahlo Zarbi BO": "209303",
      "Pur EUP3155 BO": "209303",
      "Roshanmau  EUP6054 BO": "209303",
      "Devipur BO": "209303",
      "Chilaauli BO": "209303",
      "Gajner BO": "209121",
      "Gangruli BO": "209121",
      "Hathai BO": "209121",
      "Ratanpur BO": "209306",
      "Sandelpur BO": "209125",
      "Patra BO": "209311",
      "Akaru BO": "209302",
      "Ban BO": "209302",
      "Chhatrsa BO": "209302",
      "Dilauliya BO": "209302",
      "Kahijari BO": "209204",
      "Makhauli BO": "209208",
      "Singrasipur BO": "209208",
      "Akodhi BO": "209111",
      "Bhognipur BO": "209111",
      "Doharapur BO": "209115",
      "Gaurikaran BO": "209115",
      "Kamalpur BO": "209115",
      "Kandhi BO": "209115",
      "Auderi BO": "209115",
      "Ramau BO": "209115",
      "Asalatganj BO": "209306",
      "BhaisayanEUP7098 BO": "209306",
      "Bharamau BO": "209306",
      "Birhuan BO": "209306",
      "Banipara BO": "209303",
      "Duwari BO": "209121",
      "Pama RS BO": "209121",
      "Rasulpur GogumauEUP7906 BO": "209121",
      "Sairua BO": "209121",
      "Saitha BO": "209121",
      "Bairi Sawai BO": "209204",
      "Bannapur BO": "209204",
      "Barra Tharra BO": "209204",
      "Bewan BO": "209101",
      "Rurwahar BO": "209101",
      "Nonapur BO": "209112",
      "Gurdahi Bujurg BO": "209125",
      "Kasolar BO": "209125",
      "Manpur BO": "209125",
      "Palhnapur BO": "209125",
      "Injuarampur BO": "209302",
      "Khamhaila BO": "209302",
      "Sunderpur Gajan BO": "209302",
      "Aurangabad BO": "209310",
      "Nonari BO": "209310",
      "Katri BO": "209208",
      "Haramau BO": "209111",
      "Bhal BO": "209115",
      "Damanpur BO": "209115",
      "Madiyapur BO": "209115",
      "Mubarakpur BO": "209115",
      "Shahjahanpur BO": "209115",
      "Silhara BO": "209115",
      "Laloo Bo": "209306",
      "Nahuwa Nogaon BO": "209306",
      "Jaganpur BO": "209303",
      "Shahi  EUP6127 BO": "209303",
      "Kausum BO": "209121",
      "Lohari BO": "209121",
      "Mangta BO": "209121",
      "Juniya BO": "209121",
      "Arsun Bangar BO": "209125",
      "Khawajaphool BO": "209125",
      "Laxmanpur Pilakh BO": "209302",
      "Kishaura BO": "209302",
      "Asvi BO": "209310",
      "Paraukh BO": "209310",
      "Bamhrauli Ghat BO": "209208",
      "Gadatha BO": "209208",
      "Chak Chalpur BO": "209111",
      "Hansemau BO": "209111",
      "Anwa BO": "209115",
      "Budhauli BO": "209115",
      "Satti BO": "209115",
      "Vaina BO": "209115",
      "Jot BO": "209306",
      "Mahera BO": "209306",
      "Naila BO": "209306",
      "Puran Purwa BO": "209306",
      "SujanpurEUP9348 BO": "209306",
      "Indrarukh BO": "209303",
      "Kari Kalwari BO": "209303",
      "Kashipur BO": "209303",
      "Sargaon Bujurg BO": "209303",
      "Tigaei BO": "209303",
      "Bharatpur Piyasi BO": "209121",
      "Karsa BO": "209121",
      "Kathethi EUP7895 BO": "209121",
      "Manethu BO": "209121",
      "Ninaya BO": "209121",
      "Sultanur Perajore BO": "209121",
      "Jithrauli BO": "209121",
      "Aonaha BO": "209204",
      "Dharampur BO": "209125",
      "Mirgaon BO": "209125",
      "Pindarthu BO": "209125",
      "Umarpur BO": "209125",
      "GARDHIYA BO": "209125",
      "Gurugaon BO": "209312",
      "Kailai BO": "209312",
      "Badhapur BO": "209101",
      "Naubasta BO": "209307",
      "Raipalpur BO": "209307",
      "Aslanapur BO": "209301",
      "Galuapur BO": "209301",
      "Reri BO": "209301",
      "Bara BO": "209311",
      "Meenapur BO": "209312",
      "Mohammedpur BO": "209312",
      "Sithrabujurg BO": "209312",
      "Baalai Bujurg BO": "209301",
      "Hathuma BO": "209301",
      "Arhariyamau BO": "209312",
      "Girdau BO": "209312",
      "Baghpur BO": "209307",
      "Badagaon Bhikhi BO": "209301",
      "Bijhara BO": "209301",
      "Ursaan BO": "209301",
      "Dalipnagar BO": "209204",
      "Nigoha BO": "209204",
      "Jalalpur BO": "209312",
      "Malasa BO": "209312",
      "Pratappur BO": "209307",
      "Rasatpur BO": "209307",
      "Angadpur BO": "209301",
      "mungisapur BO": "209301",
      "Sakrawa BO": "209204",
      "Biroha BO": "209204",
      "MAdauli BO": "209303",
      "Bhiwan BO": "209204",
      "Mawaiya BO": "209204",
      "Kanjeti BO": "209204",
      "Sakhrez BO": "209204",
      "Akbarpur SO": "209101",
      "Amraudha SO": "209112",
      "Jhinjhak SO": "209302",
      "Musa Nagar SO": "209208",
      "Rura SO": "209303",
      "Rajpur SO Kanpur Dehat": "209115",
      "Sarwankhera SO": "209121",
      "Sheoli SO": "209204",
      "Sikandra SO Kanpur Dehat": "209125",
      "BARAUR": "209312",
      "BHAUPUR": "209307",
      "Jainpur I A SO": "209311",
      "Rasulabad SO Kanpur Dehat": "209306",
      "Derapur SO": "209301",
      "Mangalpur SO Kanpur Dehat": "209310",
      "Pukhrayan SO": "209111"
    },
    "RAE BARELI": {
      "Rasulpur BO": "229001",
      "Hathnasa BO": "229212",
      "Ibrahimpur BO": "229212",
      "Murarmau BO": "229212",
      "Nibi BO": "229212",
      "Lachhipur BO": "229211",
      "Mahraniganj BO": "229211",
      "Rblqila BO": "229001",
      "Taqia Kala BO": "229001",
      "Sandi Nagin BO": "229001",
      "Rustampur BO": "229001",
      "Asahanjagatpur BO": "229301",
      "Bannawa BO": "229301",
      "Bhairampur BO": "229301",
      "Gurha BO": "229301",
      "Kurricudauli BO": "229301",
      "Gondwara BO": "229310",
      "Khurrampur BO": "229406",
      "Para Kala BO": "229103",
      "Ramgaon BO": "229103",
      "Reewa BO": "229103",
      "Kaithagaon BO": "229801",
      "Khairahni Pahargarh BO": "229401",
      "Kishundaspur BO": "229401",
      "Kotia Chitra BO": "229401",
      "Beni Kama BO": "229402",
      "Bhaon BO": "229402",
      "Babhanpur BO": "229305",
      "Kurha BO": "229305",
      "Gopalpur BO": "229124",
      "Jaudaha BO": "229124",
      "Kanhpur BO": "229124",
      "Ramipur BO": "229124",
      "Garhi Majre Pokhanni BO": "229306",
      "Jyona BO": "229306",
      "Kubna BO": "229306",
      "Mon BO": "229306",
      "Pahremau BO": "229306",
      "Tewaripur BO": "229128",
      "Mawai BO": "229404",
      "Raipur BO": "229215",
      "Tejgaon BO": "229215",
      "Nakphulaha BO": "229001",
      "Khajuro BO": "229308",
      "Neem Tikar BO": "229301",
      "Paschim Gaon BO": "229301",
      "Raja Mau BO": "229301",
      "Shekhpur Samodha BO": "229301",
      "Uchauri BO": "229301",
      "Mohgawa BO": "229310",
      "Sarain Manik BO": "229310",
      "Tikari Dandu BO": "229310",
      "Osah BO": "229103",
      "Ganga Ganj BO": "229303",
      "Johwasarki BO": "229303",
      "Kathwara BO": "229303",
      "Khidirpurkaraundi BO": "229303",
      "Paharpur Kaso BO": "229303",
      "Rahwa BO": "229303",
      "Raghaupur BO": "229123",
      "Salethu BO": "229123",
      "Babuganj BO": "229401",
      "Bhilampur BO": "229401",
      "Bichiya Wadi BO": "229401",
      "Gularhia MajDhuta BO": "229401",
      "Laxmiganj BO": "229401",
      "Pari BO": "229401",
      "Pure Jham Singh BO": "229401",
      "Rohania BO": "229401",
      "Undwa BO": "229401",
      "Maliak Mau Aima BO": "229010",
      "Rahi BO": "229010",
      "Chichauli BO": "229402",
      "Harpur Halla BO": "229402",
      "Shankarpur BO": "229402",
      "Sandaha BO": "229305",
      "Amawan BO": "229306",
      "Babanbujurg BO": "229306",
      "Sothi BO": "229306",
      "Thulwasa BO": "229306",
      "Meethapur BO": "229216",
      "Pachkhara BO": "229404",
      "Prahladpur BO": "229404",
      "Sareni BO": "229404",
      "Ashrafpur BO": "229307",
      "Binnao BO": "229307",
      "Chatoh BO": "229307",
      "Ataura Khurd BO": "229130",
      "Hazipur BO": "229130",
      "Baghaula BO": "229128",
      "Bhadokhar BO": "229405",
      "Akordhia BO": "229404",
      "Arkha BO": "229404",
      "Baragaon BO": "229404",
      "Dhanpulpur BO": "229212",
      "Satwa Khera BO": "229212",
      "Bakuliha BO": "229211",
      "Jogapur BO": "229211",
      "Dariba BO": "229001",
      "Matiha BO": "229001",
      "Ashanandpur BO": "229001",
      "Lodhwamau BO": "229001",
      "Isiya BO": "229301",
      "Kasrawan BO": "229301",
      "Tilenda BO": "229301",
      "Lodhwari BO": "229310",
      "Rokha BO": "229310",
      "Betaura BO": "229302",
      "Alipur BO": "229103",
      "Jamurawan BO": "229103",
      "Nerthua BO": "229103",
      "Bargadaha BO": "229303",
      "Dighaura BO": "229303",
      "Kundanganj BO": "229303",
      "Padera BO": "229303",
      "Bala BO": "229123",
      "Majhigawan BO": "229123",
      "Kaziana BO": "229401",
      "Kusumi BO": "229401",
      "Mirzapur Aihari BO": "229401",
      "Reoli BO": "229401",
      "Hewtaha Nedia BO": "229402",
      "Ram Garh Tikaria BO": "229402",
      "Tikaria BO": "229402",
      "Kanta BO": "229305",
      "Ratason BO": "229124",
      "Bahadurnagar BO": "229306",
      "Chandapur BO": "229306",
      "Muraini BO": "229306",
      "Tisha Khanapur BO": "229306",
      "Korihar BO": "229130",
      "Bara Deeh BO": "229128",
      "Khurehti BO": "229128",
      "Semra BO": "229128",
      "Malkegaon BO": "229215",
      "Deopur BO": "229212",
      "Gajpati Khera BO": "229212",
      "Samodha BO": "229212",
      "Deogaon BO": "229211",
      "Deaur BO": "229001",
      "Bathuwakhas BO": "229001",
      "Jathua Tappa BO": "229001",
      "Ichauli BO": "229301",
      "Kannawan BO": "229301",
      "Thulendi BO": "229301",
      "Dohri BO": "229310",
      "Jagdishpur BO": "229310",
      "Gangehra BO": "229406",
      "Pothai BO": "229302",
      "Kusri Sagarpur BO": "229103",
      "Pure Thakur Ram Tewari BO": "229304",
      "Azmat Ulla Ganj BO": "229303",
      "Chauhania BO": "229303",
      "Oie BO": "229303",
      "Ghurauna BO": "229123",
      "Ishwardaspur BO": "229401",
      "Rupamau BO": "229010",
      "Jamori BO": "229402",
      "Kewalpur Baretha BO": "229402",
      "Tikar Agachipur BO": "229402",
      "Utarpara BO": "229402",
      "Barkhurdarpur BO": "229305",
      "Paraiya Namaksar BO": "229305",
      "Rampur Kasiha BO": "229124",
      "Dusauti BO": "229306",
      "Janai BO": "229306",
      "Maugarbi BO": "229306",
      "Sidhauna BO": "229306",
      "Sultanpur Khera BO": "229130",
      "Sanehi BO": "229128",
      "Suchi BO": "229128",
      "Khagipur Sandwa BO": "229405",
      "Daulatpur BO": "229202",
      "Kandrawan BO": "229404",
      "PRKaithwal BO": "229404",
      "Sawaiya Hasan BO": "229404",
      "Umran BO": "229404",
      "Alampur BO": "229307",
      "Bhuemau BO": "229405",
      "Mohammadpur Kutcharia BO": "229405",
      "Gangaoli BO": "229404",
      "Kotra Bahadur Ganj BO": "229404",
      "Nisgar BO": "229202",
      "Gopali Khera BO": "229216",
      "Musapur BO": "229216",
      "Rautapur BO": "229216",
      "Pure Bharo Mishir BO": "229203",
      "Utragauri BO": "229203",
      "Alawalpur BO": "229204",
      "Hamirmau BO": "229204",
      "Jalalpur Dhai BO": "229204",
      "Korauli Budhkar BO": "229204",
      "Konsa BO": "229122",
      "Kalyanpur Railly BO": "229125",
      "Radhabalampur BO": "229125",
      "Shanker Ganj Bazar BO": "229125",
      "Dukanaha BO": "229205",
      "Kusundi BO": "229210",
      "Barara Bujurg BO": "229207",
      "Bishundaspur BO": "229207",
      "Jhampur BO": "229215",
      "Bithooli BO": "229202",
      "Chahotar BO": "229202",
      "Gahrauli BO": "229202",
      "Kahjurgaon BO": "229216",
      "Ralpur BO": "229216",
      "Rampur Kala BO": "229216",
      "Ambara Mathai BO": "229204",
      "Banapar BO": "229204",
      "Bharsana BO": "229204",
      "Gonda BO": "229204",
      "Katra BO": "229204",
      "Sataon BO": "229122",
      "Seni BO": "229122",
      "Melthua BO": "229125",
      "Thulrai BO": "229125",
      "Baraundi BO": "229205",
      "Bhietrgaon BO": "229205",
      "Bhimganj BO": "229207",
      "Sheopuri BO": "229209",
      "Beni Madhiganj BO": "229216",
      "Singhortara BO": "229216",
      "Bahai BO": "229203",
      "Belahni BO": "229203",
      "Chanda Tikar BO": "229203",
      "Murethi BO": "229204",
      "Sudamapur BO": "229204",
      "Suttha BO": "229204",
      "Tala BO": "229122",
      "Tikwamau BO": "229122",
      "Bela Ghusisi BO": "229125",
      "Bela Khara BO": "229125",
      "Darigapur BO": "229125",
      "Saguni BO": "229205",
      "Kalyan Pur Bainti BO": "229207",
      "Karkasa BO": "229207",
      "Pakhrauli BO": "229207",
      "Barha BO": "229208",
      "Mubarakpur BO": "229208",
      "Drigpal Ganj BO": "229210",
      "Kodra BO": "229202",
      "Usroo BO": "229202",
      "Bairua BO": "229216",
      "Gegason BO": "229216",
      "Chilaula BO": "229203",
      "Sondasi BO": "229203",
      "Ismailmau BO": "229204",
      "Jharaha BO": "229204",
      "Sultanpur Janauli BO": "229204",
      "Bardar BO": "229122",
      "Mishir Khera BO": "229122",
      "Sahjaura BO": "229122",
      "Barraua BO": "229125",
      "Bhira Govindpur BO": "229125",
      "Ghurwara BO": "229125",
      "Terukha BO": "229125",
      "Khanapur Khusti BO": "229205",
      "Ranapur Pahrauli BO": "229210",
      "Balbhadrapur BO": "229207",
      "Narsawan BO": "229207",
      "Satanpur BO": "229208",
      "Dudhwan BO": "229215",
      "Burdhanpur BO": "229316",
      "Sarawan BO": "229316",
      "Beoli BO": "229127",
      "Matka BO": "229127",
      "Rasoolpur BO": "229127",
      "Dostpur BO": "229311",
      "Kunwarmau BO": "229307",
      "Lahnga BO": "229307",
      "Mau BO": "229307",
      "Paksarawan BO": "229127",
      "Sikandarpur BO": "229126",
      "Siwan BO": "229126",
      "Bedaru BO": "229308",
      "Bhawanigarh BO": "229308",
      "Dehli BO": "229308",
      "Deepemau BO": "229206",
      "Maha Khera BO": "229206",
      "Asharasidpur BO": "229129",
      "Atawan BO": "229129",
      "Bara BO": "229129",
      "Bhuwalpur BO": "229129",
      "Ahiyapur BO": "229316",
      "Hardaspur BO": "229316",
      "Rasehta BO": "229316",
      "Mamuni BO": "229127",
      "Matrampur BO": "229127",
      "Mohanganj BO": "229127",
      "Bahadur Nagar BO": "229311",
      "Churua BO": "229311",
      "Kasna BO": "229308",
      "Kumbhi BO": "229308",
      "Achai BO": "229802",
      "JPNatai BO": "229308",
      "Bishun Khera BO": "229206",
      "Merui BO": "229206",
      "Madhukarpur BO": "229121",
      "Bijemau BO": "229201",
      "Hasnapur BO": "229121",
      "Ambara Paschim BO": "229206",
      "Bannamau BO": "229206",
      "Kumraura BO": "229206",
      "Lalumau BO": "229206",
      "Ajitpur BO": "229206",
      "Akauni BO": "229206",
      "Ataura Bujurg BO": "229121",
      "Kundwal BO": "229121",
      "Pahuri BO": "229201",
      "Sujwaria BO": "229307",
      "Dharai BO": "229127",
      "Nain BO": "229127",
      "Purab Nain BO": "229129",
      "Rewhara BO": "229127",
      "Pindauli BO": "229311",
      "Kotwa Mohammadabad BO": "229126",
      "Pendara BO": "229802",
      "Bainti BO": "229308",
      "Dahigawan BO": "229308",
      "Gumawan BO": "229308",
      "Seoli BO": "229308",
      "Lalganj Bazar BO": "229206",
      "Semarpaha BO": "229206",
      "Lodipur Utrawan BO": "229121",
      "Umramau BO": "229121",
      "Bemaura BO": "229201",
      "Lalganj Raebareli HO": "229206",
      "Raebarely HO": "229001",
      "Atarhar SO": "229210",
      "Gurbuxganj SO": "229122",
      "Murai Ka Bagh SO": "229207",
      "Sareni SO": "229212",
      "Semri SO": "229211",
      "Deeh SO": "229310",
      "Hardoi SO": "229123",
      "Jawahar Vihar SO": "229010",
      "K K Bajar SO": "229124",
      "Raebarelykty SO": "229001",
      "Satyanagar SO Raebareli": "229001",
      "Behta SO": "229201",
      "Bhojpur SO Raebareli": "229202",
      "Cheolaha SO": "229216",
      "Kathgar SO": "229125",
      "Nihastha SO": "229208",
      "Paho SO": "229209",
      "Rail Coach Factory LalganjRaebareli SO": "229120",
      "Bachrawan SO": "229301",
      "Bus Station SO Raebareli": "229001",
      "Fgtp Unchahar SO": "229406",
      "Munshiganj SO Raebareli": "229405",
      "Parsadepur SO": "229129",
      "Ratapur SO": "229316",
      "Dalmau SO": "229203",
      "Purepandey SO": "229215",
      "Hallaur SO Raebareli": "229103",
      "Jagatpur SO Raebareli": "229402",
      "Mustafabad SO Raebareli": "229404",
      "Nasirabad SO": "229307",
      "Salon SO": "229127",
      "Sehgon SO": "229311",
      "Shivgarh SO": "229308",
      "Aihar SO": "229121",
      "Gaura SO Raebareli": "229204",
      "Khiro SO": "229205",
      "25th PAC SO": "229001",
      "Harchandpur SO Raebareli": "229303",
      "Itaurabujurg SO": "229401",
      "ITI SO Raebareli": "229010",
      "Mahrajganj SO Raebareli": "229306",
      "Malik Mau Chaubara SO": "229130",
      "Mejarganj SO": "229128",
      "Townhall SO": "229001",
      "Zilaparisad SO": "229001"
    },
    "AURAIYA": {
      "Bhaupur BO": "206122",
      "Chirhuli BO": "206122",
      "Baghaipur BO": "206241",
      "Bhainsol BO": "206241",
      "Chhachhund BO": "206241",
      "Ghasara BO": "206241",
      "Samayan BO": "206252",
      "Surendha BO": "206252",
      "Umrain BO": "206252",
      "Juhikha BO": "206121",
      "Khetupur BO": "206121",
      "Senganpur BO": "206121",
      "Hardu BO": "206251",
      "Alipur BO": "206243",
      "Bhikhara BO": "206243",
      "Luhiapur BO": "206122",
      "Bharsen BO": "206122",
      "Keontra BO": "206122",
      "Panhar BO": "206122",
      "Mohammdabad BO": "206241",
      "Amavata BO": "206121",
      "Atsoo BO": "206121",
      "Babain BO": "206121",
      "Badera BO": "206121",
      "Goora BO": "206243",
      "Indapamau BO": "206243",
      "Kaithawa BO": "206243",
      "Pusauli BO": "206243",
      "Rathgaon BO": "206243",
      "Sabhad BO": "206243",
      "Dakhlipur BO": "206244",
      "Dhupkari BO": "206244",
      "Gulariha BO": "206244",
      "Purakalan BO": "206244",
      "Seengpurva Mana BO": "206244",
      "Sehud BO": "206244",
      "Naugawan BO": "206246",
      "Ailly BO": "206249",
      "Masoodpur BO": "206249",
      "Gapchariapur BO": "206248",
      "Harbanspur BO": "206248",
      "Kursi BO": "206248",
      "Madokmeet BO": "206248",
      "Purwa Bhikha BO": "206248",
      "Bhadsan BO": "206120",
      "Darbatpur BO": "206120",
      "Dondapur BO": "206243",
      "Bijhai BO": "206244",
      "Sondhemau BO": "206244",
      "Umri BO": "206244",
      "Belhupur BO": "206246",
      "Binpurapur BO": "206246",
      "Piprauli Shiv BO": "206255",
      "Yakubpur BO": "206255",
      "Mahmoodpur BO": "206129",
      "Nigra BO": "206129",
      "Phariha BO": "206129",
      "Uncha BO": "206129",
      "Adhasi BO": "206247",
      "Rurukalan BO": "206249",
      "Sarai Sheesgram BO": "206249",
      "Ikaurapur BO": "206122",
      "Tilak Nagar BO": "206122",
      "Jaitapur BO": "206122",
      "Burhadana BO": "206122",
      "Kakhawatoo BO": "206122",
      "Itailly BO": "206241",
      "Pata RS BO": "206241",
      "Barauna Kalan BO": "206252",
      "Patna Airwa BO": "206252",
      "Ballapur BO": "206121",
      "Bhurepurkalan BO": "206121",
      "Gauhani Kalan BO": "206121",
      "Sanphar BO": "206121",
      "Gailly BO": "206251",
      "Asjana BO": "206243",
      "Bhaipur BO": "206243",
      "Kakor Buzurg BO": "206244",
      "Nauli BO": "206244",
      "Sahayal BO": "206244",
      "Deoraon BO": "206250",
      "Rajuamau BO": "206250",
      "Dahgaon BO": "206246",
      "Lahrapur BO": "206246",
      "Daulatpur BO": "206122",
      "Sahabda BO": "206122",
      "Badharipur BO": "206122",
      "Khanpur BO": "206122",
      "Kharka BO": "206122",
      "Sherpur Saraiya BO": "206122",
      "Bamuripur BO": "206122",
      "Bansi BO": "206241",
      "Dashera BO": "206241",
      "Gwari BO": "206241",
      "Nagaria BO": "206241",
      "Badhin BO": "206252",
      "Bhedpur BO": "206252",
      "Bilawan BO": "206121",
      "Janishnagar BO": "206121",
      "Sohari Garhia BO": "206121",
      "Mahu BO": "206251",
      "Bandhmau BO": "206243",
      "Banthara BO": "206243",
      "Tilakpur Farm BO": "206243",
      "Aghara BO": "206244",
      "Piparpur BO": "206244",
      "Kamara BO": "206250",
      "Saraipukhta BO": "206250",
      "Kanchausi BO": "206246",
      "Madhwapur BO": "206246",
      "Jalalpur BO": "206255",
      "Bakhariya BO": "206129",
      "Bhikhepur BO": "206129",
      "Chapta BO": "206129",
      "Roshangpur BO": "206129",
      "Haidarpur BO": "206129",
      "Bhagya Nagar BO": "206247",
      "Fatehpur Beni BO": "206247",
      "Murhi BO": "206247",
      "Barahar BO": "206249",
      "Kudarkot BO": "206249",
      "Narainpur BO": "206248",
      "Marhadaspur BO": "206255",
      "Bhason BO": "206129",
      "Birhuni BO": "206129",
      "Karampur BO": "206129",
      "Sikharna BO": "206129",
      "Ayana BO": "206129",
      "Ata BO": "206247",
      "Jua BO": "206247",
      "Salhapur BO": "206247",
      "Kalabhoj BO": "206249",
      "Pasuwa BO": "206249",
      "Purwa Jain BO": "206248",
      "Shivganj BO": "206248",
      "Sekhupur Adhar Singh BO": "206120",
      "Phoolpur BO": "206128",
      "Anantram Sonasi BO": "206128",
      "Jagannathpur BO": "206128",
      "Babarpur SO Auraiya": "206121",
      "Airwa Katra SO": "206252",
      "Dibiapur Mandi SO": "206244",
      "Nevilganj SO": "206241",
      "Achhalda SO": "206241",
      "Ajitmal SO": "206121",
      "Bidhuna SO": "206243",
      "Dibiapur SO": "206244",
      "Malhosi SO": "206255",
      "N T P C Dibiapur SO": "206244",
      "Narainpur SO Auraiya": "206122",
      "Phaphund SO": "206247",
      "Auraiya HO": "206122",
      "Bela SO Auraiya": "206251",
      "Harchandpur SO Auraiya": "206250",
      "Kanchausi Bazar SO": "206246",
      "Muradganj SO": "206129",
      "Ruruganj SO": "206249",
      "Sahar SO Auraiya": "206248"
    },
    "MAINPURI": {
      "Daulatpur BO": "205001",
      "Nagla Jula BO": "205001",
      "Jasmai BO": "209720",
      "Jot BO": "209720",
      "Kaitholi BO": "209720",
      "Ahirwa BO": "205001",
      "Badshahpur BO": "205121",
      "Baijua Khas BO": "205121",
      "Bajhera  Bujurg BO": "205121",
      "Johari Nagar BO": "205121",
      "Nauner BO": "205001",
      "Beonti Khurd BO": "205001",
      "JIC Nauner BO": "205001",
      "Sikandarpur BO": "205001",
      "Aunha BO": "205268",
      "Anjani BO": "205001",
      "Lalupur BO": "205001",
      "Agautha BO": "205247",
      "Pundari BO": "205247",
      "Ratanpur Bara BO": "205247",
      "Chandikara BO": "205261",
      "Dihuli BO": "205261",
      "Sukurullapur BO": "205261",
      "Garhia Chhinkaura BO": "205301",
      "Joga BO": "205301",
      "MUDAI BO": "205301",
      "Aung BO": "205262",
      "Chhachha BO": "205262",
      "Garhia Govindepur BO": "205262",
      "Jamaura BO": "205262",
      "Mota BO": "205262",
      "Rajwana BO": "205262",
      "Isai Gopalpur BO": "205263",
      "Madhan BO": "205263",
      "Manauna BO": "205263",
      "Kirthua BO": "205264",
      "Nagla Dik BO": "205264",
      "Nakau BO": "205264",
      "Chauraipur BO": "205303",
      "Chitayan BO": "205303",
      "Farenzi BO": "205303",
      "Kutukpur BO": "205303",
      "Naigwan kheria BO": "205303",
      "Belahar BO": "205265",
      "Jakhaua BO": "205265",
      "Salempur BO": "205265",
      "Ghitauli BO": "205001",
      "Gola Bazar BO": "205001",
      "Kakan BO": "205001",
      "Karimganj BO": "205001",
      "Musayatpur Kheriya BO": "205121",
      "Shahjahanpur BO": "205121",
      "Sagauni BO": "205001",
      "Dharmangadpur BO": "205247",
      "Hathpau BO": "205247",
      "Jagir BO": "205247",
      "Dalupur BO": "205261",
      "Dharau BO": "205001",
      "Ninauli BO": "205001",
      "Auden Padaria BO": "205001",
      "Kharpari BO": "205001",
      "Bhawat BO": "205247",
      "Hazipur Nera BO": "205261",
      "Lakhanmau BO": "205261",
      "Sarakh BO": "205261",
      "Bharaul BO": "205121",
      "Azmabad Araon BO": "205121",
      "Kalhor BO": "205121",
      "Pachawer BO": "205121",
      "Paronkha BO": "205301",
      "Mahmudia BO": "205301",
      "Aghar BO": "205262",
      "Rui Sinaura BO": "205262",
      "Vinodpur BO": "205262",
      "Thorwa BO": "205263",
      "Bamtapur BO": "205264",
      "Chandpura BO": "205264",
      "Shjhajipur BO": "205264",
      "Saman BO": "205303",
      "Lakhaura BO": "205265",
      "Nanamau BO": "205265",
      "Aunchha BO": "205263",
      "Takharau BO": "205268",
      "Vinayakpur BO": "205268",
      "Arsara BO": "205304",
      "Elabans BO": "205304",
      "Ramnagar BO": "205304",
      "Dalippur Kailai BO": "205267",
      "Kinhawar BO": "205267",
      "Darwah BO": "205119",
      "Halpura BO": "205119",
      "Alipur Kherha BO": "205262",
      "Bhadehi BO": "209720",
      "Todarpur BO": "209720",
      "Kapoorpur BO": "205001",
      "Raja Ki Bajria BO": "205001",
      "Karhal Gate Mainpuri BO": "205001",
      "Ratibhanpur BO": "205001",
      "Auden Mandan BO": "205001",
      "Manchhana BO": "205001",
      "Allau BO": "205247",
      "Sugaon BO": "205247",
      "Banigon BO": "205261",
      "Nawa Terha BO": "205261",
      "Talibpur BO": "205261",
      "Bajhera BO": "205301",
      "Kaua Tanda BO": "205301",
      "Madhupuri BO": "205301",
      "Manpur Hari BO": "205301",
      "Nabiganj BO": "205301",
      "Nagla Painth BO": "205301",
      "Paronkh BO": "205263",
      "Andani BO": "205264",
      "Atirajpur BO": "205264",
      "Pairar Shahpur BO": "205264",
      "Urthan BO": "205264",
      "Alupura BO": "205265",
      "Sahan BO": "205268",
      "Sauj BO": "205268",
      "Kumhaul BO": "205304",
      "Kurhi BO": "205304",
      "Madhukarpur BO": "205304",
      "Nagla Semar BO": "205267",
      "Sahara BO": "205267",
      "Simarai BO": "205267",
      "Tisauli BO": "205267",
      "Jabapur BO": "205119",
      "Kosma BO": "205119",
      "Kuchela BO": "205119",
      "Aramsarai BO": "205262",
      "Bhaisrauli BO": "205262",
      "Himaunpur BO": "205262",
      "Maujepur Havelia BO": "205262",
      "Rakari BO": "205262",
      "Town Hall BO": "205262",
      "Achalpur BO": "205263",
      "Chetai BO": "205263",
      "Ujhaiya Fakirpur BO": "205263",
      "Bhidaura BO": "205264",
      "Grhiya BO": "205264",
      "Basait BO": "205303",
      "Maholi Shamserganj BO": "205303",
      "Ratheh BO": "205303",
      "Lahara BO": "205265",
      "Naugaon BO": "205265",
      "Sharifpur BO": "205265",
      "Sonai BO": "205265",
      "Mohabbatpur BO": "205268",
      "Ranipur BO": "205268",
      "Ahimalpur BO": "205304",
      "Mudausi BO": "205304",
      "Bichhawan BO": "205267",
      "Jagatpur B BO": "205267",
      "Gangsi BO": "205119",
      "Mainpuri HO": "205001",
      "Patara BO": "205268",
      "Manigaon BO": "205304",
      "Sakra BO": "205304",
      "Uncha Islamabad BO": "205304",
      "Aurandh BO": "205267",
      "Balarpur BO": "205267",
      "Civil Court SO Mainpuri": "205001",
      "Kishni SO": "205303",
      "Kuraoli SO": "205265",
      "Kurra SO": "205268",
      "Kusmara SO": "205304",
      "Mainpuri City SO": "205001",
      "Naya Bazar Bhongaon SO": "205262",
      "Awadh Nagar SO": "205001",
      "Bewar SO Mainpuri": "205301",
      "Mainpuri R S SO": "205001",
      "Baranahal SO": "205261",
      "Galla Mandi Kurawali SO": "205265",
      "Jeonti SO": "205263",
      "Karhal SO Mainpuri": "205264",
      "Ghiror SO": "205121",
      "Ajitganj SO": "205247",
      "Bewar Bazar SO": "205301",
      "Bhongaon SO": "205262",
      "Sultanganj SO Mainpuri": "205267",
      "Tindauli SO": "205119",
      "Zilla Parishad SO": "205001"
    },
    "HARDOI": {
      "Lalpalpur BO": "241001",
      "Rara BO": "241001",
      "Saitiyapur BO": "241001",
      "Sakara BO": "241001",
      "Poora Bahadur BO": "241001",
      "Bahar BO": "241001",
      "Bawan BO": "241001",
      "Madara BO": "241001",
      "Maholiya Shivpar BO": "241001",
      "Malihamau BO": "241001",
      "Barkherwa BO": "241121",
      "Bhithadan BO": "241122",
      "Faridapur BO": "241122",
      "Kaimau BO": "241122",
      "Bootamau BO": "241401",
      "Bahlolpur BO": "241201",
      "Bara Gaon BO": "241201",
      "Bhatoli BO": "241201",
      "Gauri Dayampur BO": "241201",
      "Hiya BO": "241201",
      "Allipur BO": "241125",
      "Chathia Dhanwar BO": "241125",
      "Majhila BO": "241125",
      "Manpur BO": "241125",
      "Chathia BO": "241304",
      "Gondarao BO": "241304",
      "Hans Barauli BO": "241304",
      "Kalyanmal BO": "241304",
      "Karim Nagar Sunauwa BO": "241304",
      "Raipur BO": "241304",
      "Tikari BO": "241304",
      "Chhatia Rampur BO": "241202",
      "Chhawan BO": "241202",
      "Hazipur BO": "241202",
      "Kaudiya BO": "241202",
      "Andharra BO": "241301",
      "Chhibaramau BO": "241301",
      "Dabha BO": "241301",
      "Durgaganj BO": "241301",
      "Sugwan BO": "241301",
      "Erka Bherka BO": "241203",
      "Goni Gondwa BO": "241203",
      "Khajohana BO": "241305",
      "Khurda Madarpur BO": "241305",
      "Nayagaon BO": "241305",
      "Sathara BO": "241001",
      "Kutuwapur BO": "241001",
      "Naya Gaon Mubarakpur BO": "241001",
      "Tatyora BO": "241001",
      "Mangolapur BO": "241121",
      "Lilwal BO": "241404",
      "Sadila BO": "241404",
      "Tadiyawan BO": "241404",
      "Thok Bandho BO": "241121",
      "Meoni BO": "241122",
      "Pachkohara BO": "241122",
      "Victoriyaganj BO": "241122",
      "Bamtapur BO": "241401",
      "Bhailamau BO": "241401",
      "Jahidpur BO": "241201",
      "Sakaha BO": "241125",
      "Sharma Fatehpur BO": "241125",
      "Pawayan BO": "241202",
      "Parsola BO": "241301",
      "Jangaon BO": "241203",
      "Kashipur Baheria BO": "241203",
      "Sarva BO": "241203",
      "Behsar BO": "241305",
      "Turtipur BO": "241001",
      "Sadai Behta BO": "241001",
      "Bhadaicha BO": "241001",
      "Kakendi BO": "241001",
      "Dhiar Maholiya BO": "241001",
      "Bhitha Maha Singh BO": "241121",
      "Kalika BO": "241121",
      "Mahri BO": "241122",
      "Lonar BO": "241401",
      "Simariya BO": "241401",
      "Birauli BO": "241201",
      "Madar BO": "241201",
      "Bijgawan BO": "241406",
      "Mawaiya BO": "241125",
      "Todarpur R S BO": "241125",
      "Umrauli BO": "241125",
      "Jairajpur BO": "241304",
      "Kothawan BO": "241304",
      "Nagwa BO": "241304",
      "Umrari BO": "241304",
      "Ajamatpur BO": "241202",
      "Bhatpur BO": "241202",
      "Mahitha BO": "241202",
      "Noorpur  Hathaura BO": "241301",
      "Pasner BO": "241301",
      "Atsaliya BO": "241203",
      "Mahagawan BO": "241203",
      "Sikrori BO": "241203",
      "Ashi Azampur BO": "241305",
      "Bhainsari BO": "241404",
      "Hariharpur BO": "241404",
      "Bahorwa BO": "241404",
      "Deoria BO": "241404",
      "Harrai BO": "241124",
      "Khajurahara BO": "241001",
      "Sikarohari BO": "241001",
      "Kaudha BO": "241001",
      "Babnapur BO": "241001",
      "Odra BO": "241001",
      "Eja BO": "241001",
      "Kurria BO": "241001",
      "Neer BO": "241001",
      "Sursa BO": "241001",
      "Sakatpur BO": "241001",
      "Atwa Kataiya BO": "241121",
      "Bharayal BO": "241121",
      "Gadeora BO": "241121",
      "Bamhna Khera BO": "241122",
      "Masit BO": "241122",
      "Khanigaon Khurd BO": "241401",
      "Naseoli Gopal BO": "241401",
      "Sahpur Nau BO": "241401",
      "Behendar Khurd BO": "241201",
      "Dewari BO": "241201",
      "Jarha BO": "241201",
      "Kudauni BO": "241201",
      "Bahera Rasoolpur BO": "241125",
      "Kaimi BO": "241125",
      "Todarpur Gaon BO": "241125",
      "Tolwa Aat Danpur BO": "241125",
      "Beruwa BO": "241304",
      "Bhikpur Aima BO": "241304",
      "Harraiya BO": "241304",
      "Jarauwa BO": "241304",
      "Kuniya BO": "241304",
      "Majhigawan BO": "241202",
      "Ugpur BO": "241304",
      "Bani BO": "241202",
      "Dahigawan BO": "241301",
      "Jareuli Sherpur BO": "241301",
      "Tundwal BO": "241301",
      "Bahuti BO": "241203",
      "Majhigawan Gadeora BO": "241203",
      "Mohammadpur Belwaran BO": "241203",
      "Tikra Khurd BO": "241203",
      "Subhan Khera BO": "241305",
      "Terwa Dahigawan BO": "241305",
      "Teni BO": "241404",
      "Mansoor Nagar BO": "241405",
      "Uchawal BO": "241405",
      "Behta Rampura BO": "241402",
      "Khasaura BO": "241402",
      "Pithanapur Nagariya BO": "241402",
      "Uncha Gaon BO": "241402",
      "Thamarawa BO": "241404",
      "Chandeli BO": "241405",
      "Kurseli BO": "241405",
      "Arjunpur BO": "241402",
      "Arwal BO": "241402",
      "Barnai Chatarkha BO": "241402",
      "Lamkan BO": "241402",
      "Palia BO": "241402",
      "Semaria BO": "241402",
      "Shahpur Basudeo BO": "241302",
      "Shuklapur Bhagat BO": "241302",
      "Bhagwant Nagar BO": "241303",
      "Daru Kuinwa BO": "241303",
      "Goswa BO": "241303",
      "Raghopur BO": "241303",
      "Shahpur Ganga BO": "241303",
      "Aamtara BO": "241123",
      "Aliganj Nankheria BO": "241123",
      "Daultpur BO": "241123",
      "Harha Malikapur BO": "241123",
      "Jeora BO": "241123",
      "Banjariya BO": "241406",
      "Majhiya BO": "241406",
      "Pandarawa Kot BO": "241406",
      "Bandaraha BO": "241407",
      "Bhogiyapur BO": "241407",
      "Chaina BO": "241407",
      "Daheliya Rampur BO": "241407",
      "Jahani Khera BO": "241407",
      "Atia Sahpur BO": "241204",
      "Atrauli BO": "241204",
      "Loomamau BO": "241204",
      "Malaiya BO": "241204",
      "Anjhi R S BO": "241124",
      "Fatehpur Gayand BO": "241124",
      "Fatehpur Gazi BO": "241124",
      "Pareli BO": "241124",
      "Sarsawan BO": "241124",
      "Sikandarpu Narkatara BO": "241124",
      "Singulapur BO": "241124",
      "Atwa Ali Mardanpur BO": "241126",
      "Barwa Sarsand BO": "241126",
      "Gaura BO": "241302",
      "Shahbda BO": "241302",
      "Babatmau BO": "241303",
      "Barahuwan BO": "241303",
      "Matiyamau BO": "241303",
      "Purwawan BO": "241303",
      "Shahpur Pawar BO": "241303",
      "Amirta BO": "241123",
      "Babarpur BO": "241123",
      "Bilsari BO": "241123",
      "Lakhmapur BO": "241123",
      "Pachdeora BO": "241123",
      "Sahjanpur BO": "241123",
      "Itara BO": "241406",
      "Kusuma BO": "241406",
      "Sirsa BO": "241406",
      "Alam Nagar BO": "241407",
      "Mahmoodpur Saraiya BO": "241407",
      "Rabha BO": "241407",
      "Rasoolpur BO": "241407",
      "Adampur BO": "241403",
      "Sarhiapur BO": "241403",
      "Dalelnagar BO": "241204",
      "Rainso BO": "241204",
      "Sandila Town BO": "241204",
      "Anjhi Gaon BO": "241124",
      "Kakarghata BO": "241124",
      "Kundi BO": "241124",
      "Tumurkee BO": "241124",
      "Bhadeora BO": "241405",
      "Pila Mahuwa BO": "241405",
      "Baran BO": "241402",
      "Barsohiya BO": "241402",
      "Malautha BO": "241402",
      "Satautha BO": "241402",
      "Tikar BO": "241402",
      "Balamau Village BO": "241126",
      "Gajoo BO": "241126",
      "Samspur BO": "241126",
      "Gauntra BO": "241302",
      "Odra Pachlai BO": "241302",
      "Selapur BO": "241302",
      "Barauna BO": "241303",
      "Bhithai BO": "241303",
      "Phulai BO": "241303",
      "Anangpur BO": "241123",
      "Baijupur BO": "241123",
      "Dhani Nagla BO": "241123",
      "Munder BO": "241123",
      "Burhagaon BO": "241406",
      "Para BO": "241406",
      "Abdulla Nagar BO": "241407",
      "Kunwarpur Basith BO": "241407",
      "Raingai BO": "241407",
      "Sahijana BO": "241407",
      "Akhbelpur Malwa BO": "241403",
      "Chanadapur BO": "241402",
      "Daheliya BO": "241402",
      "Hathaura Raj BO": "241126",
      "Kalauli BO": "241126",
      "Kursath BO": "241126",
      "Lonhra BO": "241126",
      "Pahuntera BO": "241302",
      "Parcha Rasoolpur BO": "241302",
      "Sadarpur BO": "241302",
      "Sautera BO": "241302",
      "Bakhaura BO": "241303",
      "Bansa BO": "241303",
      "Ishwarpur Sain BO": "241303",
      "Baruwara BO": "241123",
      "Bharakhani BO": "241123",
      "Kamalpur BO": "241123",
      "Khitauli BO": "241123",
      "Maikpur BO": "241123",
      "Sarai Raghav BO": "241123",
      "Sawaijpur BO": "241123",
      "Jareli BO": "241406",
      "Karim Nagar BO": "241406",
      "Khateli BO": "241406",
      "Manikapur BO": "241407",
      "Baghrai BO": "241403",
      "Chacharapur BO": "241403",
      "Jarauli Newada BO": "241403",
      "Kuchila BO": "241403",
      "Mansoorpur BO": "241403",
      "Malehra BO": "241204",
      "Meer Nagar Ajigawan BO": "241204",
      "Teriya BO": "241204",
      "Jamura BO": "241124",
      "Siroman Nagar BO": "241124",
      "Srimau BO": "241403",
      "Atwa Bhasen BO": "241204",
      "Chhanoiya BO": "241204",
      "Saank BO": "241204",
      "Sarve BO": "241204",
      "Basit Nagar BO": "241124",
      "Kodra Saraiya BO": "241124",
      "Nagla Lothu BO": "241124",
      "Udharanpur BO": "241124",
      "Ganj Jalalabad BO": "209869",
      "Hardoi HO": "241001",
      "Bharawan SO": "241202",
      "Bilgram SO": "241301",
      "Hardoi Bazar SO": "241001",
      "Hardoi R S SO": "241001",
      "Madhoganj SO Hardoi": "241302",
      "Saadat Nagar SO": "241407",
      "Sandila I Estate SO": "241127",
      "Shahabad SO Hardoi": "241124",
      "Baghauli SO": "241122",
      "Barwan SO Hardoi": "241401",
      "Hardoi Kutchery SO": "241001",
      "Harpalpur SO Hardoi": "241402",
      "Aihrori SO": "241121",
      "Civil Lines SO Hardoi": "241001",
      "Dhikunni SO": "241203",
      "Hariyawan SO": "241405",
      "Mallawan SO": "241303",
      "Munney Miyan Ka Chauraha SO": "241001",
      "Nabi Purwa SO": "241001",
      "Pihani SO": "241406",
      "Shahabad BS SO": "241124",
      "Behander SO": "241201",
      "Behta Gokul SO": "241125",
      "Beniganj SO": "241304",
      "Bilgram BS SO": "241301",
      "Gaus Ganj SO": "241305",
      "Gopamau SO": "241404",
      "Lucknow Road SO": "241001",
      "Kachhauna SO": "241126",
      "Nai Basti SO Hardoi": "241001",
      "Pali SO Hardoi": "241123",
      "Sandi SO": "241403",
      "Sandila SO": "241204",
      "Uncha Thok SO": "241001",
      "Vanshi Nagar SO": "241001",
      "White Ganj SO": "241001"
    },
    "BANDA": {
      "Charka BO": "210125",
      "Kharauli BO": "210125",
      "Mau BO": "210125",
      "Museewan BO": "210125",
      "Parsauli BO": "210125",
      "Sandasani BO": "210125",
      "Satnyaon BO": "210125",
      "Arjunah BO": "210120",
      "Kulsari BO": "210129",
      "Pongari BO": "210129",
      "Sarha BO": "210129",
      "Chandpura BO": "210129",
      "Padui BO": "210001",
      "Triveni BO": "210001",
      "Lama BO": "210001",
      "Tindwara BO": "210001",
      "Parsaunda BO": "210001",
      "Badokhar Bujurg BO": "210001",
      "Mohanpurwa BO": "210001",
      "Kanwara BO": "210001",
      "Mawai BO": "210001",
      "Gureh BO": "210001",
      "Manipur BO": "210001",
      "Paprenda BO": "210001",
      "Alona BO": "210001",
      "Hathaura BO": "210001",
      "Pachnehi BO": "210001",
      "Khaptiha Kalan BO": "210001",
      "Anathuwa BO": "210201",
      "Ballan BO": "210201",
      "Gadaon BO": "210201",
      "Beonja BO": "210121",
      "Bhabhua BO": "210121",
      "Majhila BO": "210121",
      "Majhiwan BO": "210121",
      "Murwal BO": "210121",
      "Nibhaur BO": "210121",
      "Umarahni BO": "210121",
      "Dadhwamanpur BO": "210202",
      "Hariharpur BO": "210202",
      "Mahuta BO": "210202",
      "Pathara BO": "210202",
      "Turra BO": "210202",
      "Kairikhurd BO": "210203",
      "Korrahi BO": "210203",
      "Marauli BO": "210203",
      "Pahari Bujurg Sani BO": "210203",
      "Saya BO": "210203",
      "Punahur BO": "210201",
      "Bhadedu BO": "210121",
      "Hardauli BO": "210121",
      "Pawaiya BO": "210121",
      "Pindaran BO": "210121",
      "Sheo BO": "210121",
      "Simauni BO": "210121",
      "Akona BO": "210203",
      "Tindura BO": "210203",
      "Padarathpur BO": "210123",
      "Palra BO": "210123",
      "Sadimadanpur BO": "210123",
      "Berraon BO": "210125",
      "Bira BO": "210125",
      "Budhauli BO": "210125",
      "Pachhauhan BO": "210125",
      "Tilausa BO": "210125",
      "Gharaunda BO": "210120",
      "Mahua BO": "210120",
      "Makri BO": "210120",
      "Malehra Newada BO": "210120",
      "Gumanganj BO": "210129",
      "Lahureta BO": "210129",
      "Nauhai BO": "210129",
      "Padmai BO": "210129",
      "Lakhanpur BO": "210125",
      "Marka BO": "210125",
      "Katrawal BO": "210120",
      "Saunta Syondha BO": "210120",
      "Baheri BO": "210129",
      "Jamwara BO": "210129",
      "Kartal BO": "210129",
      "Bilgaon BO": "210001",
      "Ganchha BO": "210001",
      "Girwan BO": "210001",
      "Masuri BO": "210001",
      "Atarahat BO": "210001",
      "Ajeetpur BO": "210001",
      "Badokhar Khurd BO": "210001",
      "Mataundh BO": "210001",
      "Jaurahi BO": "210001",
      "Paigambarpur BO": "210001",
      "Bansi BO": "210001",
      "Chausar BO": "210201",
      "Gokhia BO": "210201",
      "Oraha BO": "210201",
      "Augasi BO": "210121",
      "Badagaon BO": "210121",
      "Jalalpur BO": "210121",
      "Nilathu BO": "210121",
      "Paras BO": "210121",
      "Samgara BO": "210121",
      "Baghelabari BO": "210202",
      "Jabrapur BO": "210202",
      "Piyar BO": "210202",
      "Bagha BO": "210203",
      "Chhilolar BO": "210203",
      "Jamoo BO": "210203",
      "Ranipur BO": "210203",
      "Singhpur BO": "210203",
      "Dighwat BO": "210123",
      "Jauharpur BO": "210128",
      "Armar BO": "210125",
      "Parsahar BO": "210129",
      "Risaura BO": "210129",
      "Ingua BO": "210125",
      "Lohra BO": "210125",
      "Mamsi Khurd BO": "210125",
      "Narayanpur BO": "210125",
      "Pannah BO": "210125",
      "Hastam BO": "210120",
      "Khurhand BO": "210120",
      "Nagnedi BO": "210120",
      "Sahewa BO": "210120",
      "Birauna BO": "210129",
      "Gurha Kalan BO": "210129",
      "Kalinjar BO": "210129",
      "Nahri BO": "210129",
      "Pangara BO": "210129",
      "Baraimanpur BO": "210001",
      "Mahokhar BO": "210001",
      "Goeramugli BO": "210001",
      "Achharaund BO": "210001",
      "Luktara BO": "210001",
      "Banda Katra BO": "210001",
      "Durendi BO": "210001",
      "Basahari BO": "210001",
      "JAMALPUR": "210001",
      "Khambhaura BO": "210201",
      "Pachokhar BO": "210201",
      "Pindkhar BO": "210201",
      "Aliha BO": "210121",
      "Bagehta BO": "210121",
      "Palhari BO": "210121",
      "Patwan BO": "210121",
      "Sathi BO": "210121",
      "Harhamafi BO": "210202",
      "Pauhar BO": "210202",
      "Bachhaundha BO": "210203",
      "Bisandi BO": "210203",
      "Para BO": "210203",
      "Bichhwahi BO": "210123",
      "Gugauli BO": "210123",
      "Piprahari BO": "210123",
      "Audaha BO": "210125",
      "Banthari BO": "210125",
      "Chhehraon BO": "210001",
      "Jari BO": "210001",
      "Baragaon BO": "210126",
      "Dharikhera BO": "210126",
      "Padohra BO": "210126",
      "Sikahula BO": "210126",
      "Bhujrakh BO": "210128",
      "Mungus BO": "210128",
      "Semri Basilpur BO": "210128",
      "Adri BO": "210126",
      "Amara BO": "210126",
      "Amlor BO": "210126",
      "Piprodar BO": "210126",
      "Rampur BO": "210126",
      "Sabada BO": "210126",
      "Sindhan Kalan BO": "210126",
      "Amlikaur BO": "210128",
      "Benda BO": "210128",
      "Khaunda BO": "210128",
      "Pipargawan BO": "210128",
      "Gauri Kalan BO": "210126",
      "Gazipur BO": "210126",
      "Jhanjhari Ka Purwa BO": "210126",
      "Marjha BO": "210126",
      "Mawaighat BO": "210126",
      "Narauli BO": "210126",
      "Chhanehara Lalpur BO": "210001",
      "Chandwara BO": "210126",
      "Gadaria BO": "210126",
      "Jaspura BO": "210126",
      "Madauli Kalan BO": "210126",
      "Nandadeo BO": "210126",
      "Nari BO": "210126",
      "Mahui BO": "210128",
      "Banda HO": "210001",
      "Baberu SO": "210121",
      "Badausa SO": "210202",
      "Banda Kutchery SO": "210001",
      "Bisanda SO": "210203",
      "Chhoti Bazar SO": "210001",
      "Kamasin SO": "210125",
      "Naraini SO": "210129",
      "Pailani SO": "210126",
      "Chillatara SO": "210123",
      "Banda Aliganj SO": "210001",
      "Banda City SO": "210001",
      "Banda RS SO": "210001",
      "Khurand RS SO": "210120",
      "P G College Attara SO": "210201",
      "Atarra SO": "210201",
      "Banda DC SO": "210001",
      "Tindwari SO": "210128",
      "Oran S.O": "210122"
    },
    "BARABANKI": {
      "Rasauli BO": "225001",
      "Ram Van Kuteer BO": "225001",
      "Badshahnagar BO": "225401",
      "Chirra BO": "225401",
      "Sarai Barai BO": "225401",
      "Kheorajpur BO": "225416",
      "Tikariya Saidkhanpur BO": "225416",
      "Banarki BO": "225201",
      "Bhitauli BO": "225201",
      "Lodhaura BO": "225201",
      "Mallapur BO": "225201",
      "Sirauli Kalan BO": "225202",
      "Telwari BO": "225202",
      "Telyani BO": "225202",
      "Imliha BO": "225403",
      "Tarapur BO": "225403",
      "Neoli Danapur BO": "225404",
      "Gheri BO": "225301",
      "Harrai BO": "225301",
      "Sarsaundi BO": "225301",
      "Tera Kalan BO": "225301",
      "Ukhari BO": "225301",
      "Bhitauli Kalan BO": "225003",
      "Gadia BO": "225003",
      "Tindola BO": "225003",
      "Kanwan BO": "225124",
      "Khanpur BO": "225124",
      "Kharsatiya BO": "225124",
      "Lahi BO": "225124",
      "Lohangpur BO": "225124",
      "Ratauli BO": "225124",
      "Bhanauli BO": "225121",
      "Bhanmau BO": "225121",
      "Birahimabad BO": "225121",
      "Daravpur BO": "225121",
      "Sanauli BO": "225405",
      "Thorthia BO": "225405",
      "Darhara BO": "225203",
      "Dayalpur BO": "225119",
      "Inayatpur BO": "225119",
      "Anwari BO": "225302",
      "Atahara BO": "225302",
      "Darawan BO": "225302",
      "Gariya Bazar BO": "225302",
      "Dharoopur BO": "225416",
      "Gajpatipur BO": "225416",
      "Jarauli BO": "225416",
      "Jargawan BO": "225416",
      "Semrai BO": "225202",
      "Ismailpur BO": "225301",
      "Jaruwa BO": "225301",
      "Malookpur BO": "225301",
      "Mittai BO": "225301",
      "Muradabad BO": "225301",
      "Peend BO": "225301",
      "Aseni BO": "225003",
      "Basti BO": "225003",
      "Ansari BO": "225124",
      "Beejapur BO": "225124",
      "Thalwara BO": "225124",
      "Umrawal Kirsia BO": "225124",
      "Manpur BO": "225121",
      "Nanmau BO": "225121",
      "Neoli BO": "225121",
      "Ghazipur BO": "225405",
      "Hunsepur BO": "225405",
      "Jariyari BO": "225405",
      "Bibiapur BO": "225119",
      "Ghunghter BO": "225302",
      "Nindoora BO": "225302",
      "Pandari BO": "225302",
      "Rasoolpur BO": "225401",
      "Sirsaipur BO": "225302",
      "Shahabpur BO": "225001",
      "Khetasarai BO": "225401",
      "Puredalai BO": "225401",
      "Dhanauli BO": "225416",
      "Motikpur BO": "225416",
      "Poore Chandraman BO": "225416",
      "Nahamau BO": "225202",
      "Khutauli BO": "225403",
      "Kusfar BO": "225403",
      "Patulki BO": "225404",
      "Bishunpur BO": "225301",
      "Khanwaha BO": "225301",
      "Kheoli BO": "225301",
      "Mujeebpur BO": "225301",
      "Patna BO": "225301",
      "Safedabad BO": "225003",
      "Bhikhara BO": "225124",
      "Ghar Kuiyan BO": "225124",
      "Rauli BO": "225124",
      "Saalpur BO": "225124",
      "Galhamau BO": "225121",
      "Patmau BO": "225121",
      "Tikra BO": "225121",
      "Kithoori Daroga BO": "225405",
      "Meruwa BO": "225405",
      "Khijirpur BO": "225203",
      "Dadera BO": "225302",
      "Mohsand BO": "225302",
      "Tikaitganj BO": "225302",
      "Bansa Sharif BO": "225204",
      "Barail BO": "225001",
      "Fattapur Kalan BO": "225401",
      "Dandoopur BO": "225416",
      "Mansara BO": "225416",
      "Paigamberpur BO": "225416",
      "Silhaur BO": "225416",
      "Itaura BO": "225403",
      "Qyampur BO": "225403",
      "Pahroopur BO": "225404",
      "Baburi Gaon BO": "225301",
      "Kasimganj BO": "225301",
      "Kondari BO": "225301",
      "Narain Bhari BO": "225301",
      "Shafipur BO": "225301",
      "Madhopur BO": "225003",
      "Chaubeesi BO": "225124",
      "Kamela BO": "225124",
      "Ruknuddinpur BO": "225124",
      "Sarai Rawat BO": "225124",
      "Barauli Malik BO": "225121",
      "Bhayara BO": "225204",
      "Bindaura BO": "225204",
      "Budhwara BO": "225204",
      "Digsari BO": "225409",
      "Dilauna BO": "225409",
      "Hakami BO": "225409",
      "Dadrauli Bhawaniapur BO": "225206",
      "Kandhaipur BO": "225206",
      "Mushkabad BO": "225206",
      "Ambaur BO": "225412",
      "Baghaura BO": "225412",
      "Mahmoodabad BO": "225412",
      "Palhari BO": "225412",
      "Akhtiyarpur  Sharifabad BO": "225122",
      "Gehendwar BO": "225122",
      "Sarai Parsanda BO": "225122",
      "Baddoopur BO": "225306",
      "Chiraiya BO": "225125",
      "Kandarwal BO": "225304",
      "Lalpur Karauta BO": "225304",
      "Basara BO": "225305",
      "Belahara BO": "225305",
      "Bheriya BO": "225305",
      "Jagsenda BO": "225305",
      "Talgaon BO": "225305",
      "Bansgaon BO": "225415",
      "Gidrapur BO": "225415",
      "Hadha BO": "225415",
      "Hassaur BO": "225415",
      "Qusba Ichauli BO": "225415",
      "Ranikatra BO": "225415",
      "Bhilwal BO": "225126",
      "Ganehari BO": "225126",
      "Garhi BO": "225126",
      "Hasanpur BO": "225126",
      "Loni Katra BO": "225126",
      "Manodharpur BO": "225126",
      "Mohammadpur BO": "225126",
      "Tejwapur BO": "225126",
      "Bibipur Garh BO": "225120",
      "Nainamau BO": "225204",
      "Neola Karsanda BO": "225204",
      "Ram Mandai BO": "225303",
      "Bhikharpur BO": "225409",
      "Dhanauli Thakuran BO": "225409",
      "Kithaiya BO": "225409",
      "Shahpur BO": "225409",
      "Bhainsuriya BO": "225205",
      "Madhawapur BO": "225205",
      "Mailaraiganj BO": "225206",
      "Maulabad BO": "225206",
      "Dadra BO": "225412",
      "Lachhbar Bajaha BO": "225412",
      "Sarai Kayasthan BO": "225412",
      "Barauli Jata BO": "225122",
      "Markhapur BO": "225122",
      "Teergaon BO": "225122",
      "Bajgahni BO": "225306",
      "Basantpur BO": "225306",
      "Shailie Keeratpur BO": "225306",
      "Semrawan BO": "225413",
      "Chaila BO": "225207",
      "Khajuri BO": "225207",
      "Markamau BO": "225207",
      "Gerawan BO": "225125",
      "Sarai Gopi BO": "225125",
      "Daulatpur BO": "225414",
      "Hetmapur BO": "225304",
      "Bindaura Dhartharia BO": "225305",
      "Dhaurahra BO": "225121",
      "Sethmau BO": "225121",
      "Bhawaniyapur Kheoli BO": "225405",
      "Kotwa Sarak BO": "225405",
      "Said Khanpur BO": "225405",
      "Kamarkha BO": "225203",
      "Sadruddinpur BO": "225203",
      "Bahrauli BO": "225302",
      "Barhaidih Maholia BO": "225302",
      "Sulemabad BO": "225302",
      "Dharampur BO": "225305",
      "Jagatpur BO": "225305",
      "Kandraula BO": "225305",
      "Khansi Sarai BO": "225305",
      "Madanpur BO": "225305",
      "Majhgawan Sharif BO": "225305",
      "Sirauli Surjanpur BO": "225305",
      "Terhwa BO": "225305",
      "Nandna Kala BO": "225305",
      "Bangawan BO": "225415",
      "Kothri Gauriya BO": "225415",
      "Manjhela BO": "225415",
      "Sarai Dunauli BO": "225415",
      "Baburiha BO": "225208",
      "Bara BO": "225126",
      "Jaurass BO": "225126",
      "Kakari BO": "225126",
      "Pareewan BO": "225126",
      "Pokhra BO": "225126",
      "Shivnaam BO": "225126",
      "Mohabbatpur BO": "225120",
      "Sohawan BO": "225120",
      "Kola BO": "225414",
      "Basauli BO": "225303",
      "Amahia BO": "225409",
      "Ashrafpur BO": "225409",
      "Sukhipur BO": "225409",
      "Surajpur BO": "225409",
      "Tiwaripur BO": "225409",
      "Sirkauli BO": "225205",
      "Bilakhiya BO": "225205",
      "Pyarepur BO": "225206",
      "Ram Sahai BO": "225206",
      "Rampur Katra BO": "225206",
      "Ahmadpur BO": "225412",
      "Saifpur BO": "225412",
      "Hansuwapara BO": "225306",
      "Kaji Behta BO": "225306",
      "Katuri Kalan BO": "225306",
      "Khinjhana BO": "225306",
      "Rahilamau BO": "225306",
      "Sadrapur BO": "225306",
      "Dhanaura BO": "225413",
      "Malhauli BO": "225413",
      "Maugorpur BO": "225413",
      "Neochhana BO": "225413",
      "Addra BO": "225207",
      "Banwa BO": "225123",
      "Magauwan BO": "225125",
      "Sharifabad BO": "225125",
      "Raniganj Bazar BO": "225304",
      "Ruhera BO": "225304",
      "Gudauli BO": "225305",
      "Hasanpur Tanda BO": "225305",
      "Hazratpur BO": "225305",
      "Itaunja BO": "225305",
      "Mithwara BO": "225305",
      "Ralbhari BO": "225305",
      "Sarhemau BO": "225305",
      "Sarsawan BO": "225305",
      "Sikari Jeewal BO": "225415",
      "Udwat Nagar BO": "225415",
      "Puremanbhawan Singh BO": "225208",
      "Khwajapur BO": "225126",
      "Tilokpur Usmanpur BO": "225126",
      "Barain BO": "225414",
      "Bhitaura Lakhan BO": "225414",
      "Garhi Rakhmau BO": "225414",
      "Naseernagar BO": "225204",
      "Niyamatpur BO": "225204",
      "Belpur BO": "225409",
      "Chauri Aladadpur BO": "225409",
      "Maulahara BO": "225409",
      "Amoli Kalan BO": "225205",
      "Katka BO": "225205",
      "Malauli BO": "225206",
      "Saidanpur BO": "225206",
      "Behta BO": "225412",
      "Loharpur BO": "225412",
      "Udhauli BO": "225412",
      "Yakootganj BO": "225412",
      "Laxmanpur BO": "225122",
      "Bandagi Nagar BO": "225306",
      "Bhadras BO": "225306",
      "Jharsawan BO": "225306",
      "Salempur BO": "225306",
      "Sarsa BO": "225413",
      "Uchita BO": "225413",
      "Badosarai BO": "225207",
      "Danapur Shukla BO": "225207",
      "Kamoli BO": "225207",
      "Kintoor BO": "225207",
      "Para Khandauli BO": "225123",
      "Islampur BO": "225125",
      "Jameen Husainabad BO": "225125",
      "Palia BO": "225125",
      "Jhanjhari BO": "225304",
      "Chheda BO": "225305",
      "Gaura BO": "225305",
      "Israuli BO": "225305",
      "Jafarpur BO": "225305",
      "Khapurwa BO": "225305",
      "Kutloopur BO": "225305",
      "Mahmoodpur BO": "225305",
      "Sundhiyamau BO": "225305",
      "Watia BO": "225305",
      "Kotwa Dham BO": "225415",
      "Panapur BO": "225415",
      "Ranimau Tarai BO": "225415",
      "Achhechha BO": "225208",
      "Budhera BO": "225208",
      "Sihali BO": "225208",
      "Kaboolpur BO": "225126",
      "Khaira Kankoo BO": "225126",
      "Ramnagar Pareeva BO": "225126",
      "Barabanki HO": "225001",
      "Baragaon BO": "225204",
      "Asandra SO": "225416",
      "Banki SO Barabanki": "225001",
      "Barabanki Bazar SO": "225001",
      "Bahramghat SO": "225201",
      "10th BN  P A C Barabanki S.O.": "225001",
      "Dewa Sharif SO": "225301",
      "Gandhi Aashram SO": "225003",
      "Kothi SO Barabanki": "225119",
      "Aliabad SO": "225401",
      "Haidergarh SO": "225124",
      "Jahangeerabad Raj SO": "225203",
      "Barabanki Collectorate SO": "225001",
      "Barabanki Sugar Mill SO": "225002",
      "Burhwal Sugar Mill SO": "225202",
      "Dariya Bad SO": "225403",
      "Dariyabad RS SO": "225404",
      "Harakh SO": "225121",
      "Hathaunda SO": "225405",
      "Mohammad Pur Khaley SO": "225303",
      "Ramnagar SO Barabanki": "225205",
      "Shahpur Bhagauli SO": "225306",
      "Sidhaur SO": "225413",
      "Subeha SO": "225125",
      "Suratganj SO": "225304",
      "Tilokpur SO Barabanki": "225208",
      "Trivediganj SO": "225126",
      "Usmanpur SO": "225120",
      "Zaidpur SO": "225414",
      "Kursi SO": "225302",
      "Masauli SO": "225204",
      "Munshiganj SO Barabanki": "225001",
      "Satrikh SO": "225122",
      "Tehsil Fateh Pur SO": "225305",
      "Ram Sanehi Ghat SO": "225409",
      "Saadatganj SO Barabanki": "225206",
      "Sirauli Gaus Pur SO": "225207",
      "Safderganj SO": "225412",
      "Somaiya Nagar SO": "225123",
      "Tikait Nagar SO": "225415"
    },
    "Amethi": {
      "Khara BO": "229135",
      "Satanpurwa BO": "229135",
      "Pirhi BO": "229302",
      "Tinera BO": "229302",
      "Sarain Mahesha BO": "229304",
      "Shahmau BO": "229304",
      "Singhpur BO": "229304",
      "Banbharia BO": "229801",
      "Jijauli BO": "229801",
      "Kathaura BO": "229801",
      "Kotwa BO": "229801",
      "Jais City BO": "229305",
      "Sangrampur BO": "230501",
      "Deokali BO": "227816",
      "Hussainganj Kala BO": "227816",
      "Tenduwa BO": "229302",
      "Kankupur BO": "227816",
      "Mangrauli BO": "227816",
      "Sathyain BO": "227816",
      "Manapur BO": "227411",
      "Harkhumau BO": "227811",
      "Sansarpur BO": "227811",
      "Shivgarh Jalalpur BO": "227413",
      "Mahemau BO": "227816",
      "Makhdoompur BO": "227816",
      "Sonari BO": "227816",
      "Tanda BO": "227816",
      "Tarsara BO": "227411",
      "Tandwa BO": "227411",
      "Kisni BO": "227811",
      "Mahona BO": "227811",
      "Unchgaon BO": "227811",
      "Barsanda BO": "227816",
      "Kauhar BO": "227411",
      "Karnaipur BO": "227413",
      "Kasara BO": "227413",
      "Deoraha BO": "227413",
      "Umra Dih BO": "227801",
      "Anapur BO": "227409",
      "Asura BO": "227409",
      "Barna Tikar BO": "227409",
      "Bisundaspur BO": "227409",
      "Dharai Mafi BO": "227412",
      "Pashchim Duara BO": "227412",
      "Pichhuti BO": "227815",
      "Mahrajganj BO": "227808",
      "Panhauna BO": "229135",
      "Nigoha BO": "229302",
      "Pure Wade Singh BO": "229302",
      "Domadih BO": "227809",
      "Gai Mau BO": "227809",
      "Jagesarganj BO": "227809",
      "Kamrauli BO": "227809",
      "Sindurwa BO": "227809",
      "Pichhaura BO": "227813",
      "Purab Bisara BO": "227813",
      "Bhikhipur BO": "227807",
      "Bisara Pashchim BO": "227807",
      "Mangra BO": "228159",
      "Trisuli BO": "228159",
      "Kitiyawan BO": "227411",
      "Korari Hir Shah BO": "227411",
      "Kunda BO": "227411",
      "Pali BO": "227811",
      "Seora BO": "227811",
      "Teosi BO": "227811",
      "Dakkhingaon BO": "227811",
      "Bhimi Pachchhim BO": "227413",
      "Chandheria BO": "227413",
      "Karaundi BO": "227413",
      "Sarme BO": "227801",
      "Sukhi Bajgarh BO": "227801",
      "Purabgaon BO": "227409",
      "Raghipur BO": "227409",
      "Saintha BO": "227409",
      "Tikaria BO": "227409",
      "Mangauli BO": "227809",
      "Muhammadpur BO": "227809",
      "Naudand BO": "227809",
      "Asarfpur BO": "227813",
      "Aurangabad BO": "227813",
      "Chanauki BO": "227813",
      "Mayas BO": "227807",
      "Nayakot Dharauli BO": "227807",
      "Piparpur BO": "228159",
      "Sarwan BO": "229302",
      "Mohna BO": "229304",
      "Udwa Hemrajpur BO": "229304",
      "Mochwa BO": "228159",
      "Dhema BO": "228159",
      "Baharpur BO": "227816",
      "Durgapur BO": "227816",
      "Kalyanpur BO": "227816",
      "Mau Atwara BO": "227816",
      "Sevain BO": "227411",
      "Mardanpur BO": "227811",
      "Phatefpur BO": "227811",
      "Parbatpur BO": "227801",
      "Hardon BO": "227409",
      "Mau BO": "227409",
      "Darpipur BO": "227412",
      "Thauri BO": "227815",
      "Goriabad BO": "227809",
      "Rasulpur BO": "227809",
      "Sidhiawan BO": "227809",
      "Adhanpur BO": "227813",
      "Rukunpur BO": "229135",
      "Kotwarmau BO": "229302",
      "Samrahda BO": "229302",
      "Kura BO": "229304",
      "Odari BO": "229304",
      "Tama Mau BO": "229304",
      "Chilauli BO": "229801",
      "Bhanauli BO": "227813",
      "Dadra BO": "227813",
      "Imligaon Chupi BO": "227813",
      "Rudauli BO": "227813",
      "Barehti BO": "227807",
      "Gunnaur BO": "227807",
      "Harkaranpur BO": "227807",
      "Aindhi BO": "227409",
      "Arjunpur BO": "227409",
      "Basti Dei BO": "227409",
      "Dhani Jalalpur BO": "227409",
      "Juthipur BO": "227409",
      "Guwawan BO": "227409",
      "Purab Gaon BO": "227815",
      "Dulari Nagar BO": "227809",
      "Hari Mau BO": "227809",
      "Rajkheta BO": "227809",
      "Saresar BO": "227809",
      "Gajanpur Duaria BO": "227813",
      "Kasimpur BO": "229305",
      "Bhadsana BO": "229306",
      "Ondeeh BO": "229306",
      "Isauli BO": "227813",
      "Rasulabad BO": "227813",
      "Sadipur BO": "227813",
      "Hardoia BO": "227807",
      "Bhewain BO": "228159",
      "Korari Gidhar Shah BO": "227405",
      "Pandri BO": "227405",
      "Pindoria BO": "227405",
      "Purab Kasthuni BO": "227805",
      "Bargaon BO": "227407",
      "Dhanapur BO": "227407",
      "Misrauli BO": "227407",
      "Ramgarh BO": "227407",
      "Mai Ghatkaur BO": "227408",
      "Sanaha BO": "227408",
      "Saruawan BO": "227408",
      "Tikari BO": "227408",
      "Nimi BO": "227801",
      "Gaderi BO": "227405",
      "Umapur Gana Patti BO": "227405",
      "Kakwa BO": "227405",
      "Bhawapur BO": "227406",
      "Ratapur BO": "227406",
      "Hargaon BO": "227801",
      "Rajamau BO": "229309",
      "Sambhai BO": "227801",
      "Darkha BO": "227405",
      "Rebha BO": "227405",
      "Kohra BO": "227405",
      "Naraini BO": "227405",
      "Paharganj BO": "227405",
      "Thengaha BO": "227405",
      "Mahmadpur BO": "227405",
      "Jangal Ramnagar BO": "227405",
      "Agahar BO": "227405",
      "Benipur BO": "227405",
      "Ram Nagar BO": "227405",
      "Amtahi BO": "227406",
      "Achalpur BO": "227801",
      "Balbhadrapur BO": "227801",
      "Baraulia BO": "227801",
      "Bhoen BO": "227801",
      "Mawai BO": "227801",
      "Dahiyawan BO": "227406",
      "Sawangi BO": "227406",
      "Angrawan BO": "227801",
      "Bhatgawan BO": "227801",
      "Gaura Katari BO": "227801",
      "Katari BO": "227801",
      "Ram Bax Garh BO": "227801",
      "Resi BO": "227801",
      "Khekharua BO": "229126",
      "Rampur Pawara BO": "229126",
      "Jagatpur BO": "229802",
      "Kharwan BO": "229802",
      "Kukha Rampur BO": "229802",
      "Kusumbhi BO": "229802",
      "Bahua BO": "229309",
      "Barkot BO": "229309",
      "Kamai BO": "229309",
      "Pakargaon BO": "229309",
      "Phoola BO": "229309",
      "Bhawani Nagar BO": "229309",
      "Chetra Bujurg BO": "229309",
      "Khanaipur Karangaon BO": "229309",
      "Khanapur Chapra BO": "229309",
      "Kutumra BO": "229309",
      "Mahia Senduria BO": "229802",
      "Chiluli BO": "229309",
      "Gokula BO": "229309",
      "Jai Nagra BO": "229309",
      "Mattepur BO": "229309",
      "Merdhauna BO": "229309",
      "Saimbasi BO": "229309",
      "Akbarpur Pharsi BO": "229126",
      "Basantpur BO": "229802",
      "Lauli BO": "229802",
      "Ahuri BO": "229309",
      "Fatehpur BO": "229309",
      "Gardehri BO": "229309",
      "Haswa BO": "229309",
      "Jamurwa BO": "229309",
      "Mohanganj BO": "229309",
      "Rastamau BO": "229309",
      "Shankarganj  BO": "229309",
      "Amethi HO": "227405",
      "Jagdishpur Industrial Area SO": "227817",
      "Jagdishpur SO Sultanpur": "227809",
      "Musafirkhana SO": "227813",
      "Sukul Ka Bazar SO": "227811",
      "Gauriganj SO": "227409",
      "Ramganj SO Sultanpur": "228159",
      "Raniganj SO Sultanpur": "227816",
      "Tikarmafi SO": "227413",
      "Inhauna SO": "229801",
      "Bisesarganj SO": "227407",
      "Gaura Jamon SO": "227801",
      "Pindara SO": "227807",
      "Shahgarh SO Sultanpur": "227411",
      "Aharwabhawani SO": "229135",
      "Sheoratanganj SO": "229802",
      "Tiloi SO": "229309",
      "H A L Korwa SO": "227412",
      "Bhadar SO": "227406",
      "CRPF CAMP TRISUNDI SO": "228159",
      "Semrauta SO": "229126",
      "Fursatganj SO": "229302",
      "Harbansganj SO": "229304",
      "Jais SO": "229305",
      "Wahabganj SO": "229305"
    },
    "UNNAO": {
      "Anikhurd BO": "209870",
      "Asiwan BO": "209870",
      "Kanigaon BO": "209870",
      "Devgaon BO": "209871",
      "Korari Khurd BO": "209871",
      "Lawani Kalan BO": "209871",
      "Munda BO": "209871",
      "Pariyar BO": "209871",
      "Korari Kalan BO": "209860",
      "Wsaina BO": "209860",
      "Pansariya EUP9189 BO": "209860",
      "Barithana BO": "209870",
      "Birsinghpur BO": "209870",
      "Hydrabad BO": "209870",
      "Mirzapur Kalan BO": "209870",
      "Miyanganj BO": "209870",
      "Mustafabad BO": "209870",
      "Purthiyawa BO": "209870",
      "Bhadsar Nausahra BO": "209871",
      "Dabauli BO": "209871",
      "Daldalha BO": "209871",
      "jamuniya Kachh BO": "209871",
      "Auras BO": "209870",
      "Baghwa Kola BO": "209870",
      "Laglesra BO": "209870",
      "Mirzapur Ajgaon BO": "209870",
      "Rampur Gadewa BO": "209870",
      "Sorauli Khanpur BO": "209870",
      "Udshah BO": "209871",
      "Aderuwa BO": "209860",
      "Bether BO": "209860",
      "Sikandarpur Karan BO": "209860",
      "Bhadohi BO": "209860",
      "Ranipur BO": "209860",
      "Atwa BO": "209871",
      "Bamhna BO": "209871",
      "Jajamau BO": "209871",
      "Mustafabad Pakhrora BO": "209871",
      "Band Hamirpur BO": "209860",
      "Manjra Bhikhna BO": "209860",
      "Nibai BO": "209860",
      "Rawal Kalan BO": "209860",
      "Rithnai BO": "209860",
      "Bachhauli BO": "209870",
      "Mawai Dhamiyan BO": "209870",
      "Saray Malkaadim BO": "209870",
      "Tiyar BO": "209870",
      "Bandakhera BO": "209871",
      "Darauli BO": "209871",
      "Fatehpur Chaurasi BO": "209871",
      "Gangadas Pur BO": "209871",
      "Kanjaura BO": "209862",
      "Mraunda Majhwara BO": "209871",
      "Mudha BO": "209871",
      "Osiya BO": "209871",
      "Sarai Sakhan BO": "209871",
      "Unnwa BO": "209871",
      "Badarka BO": "209860",
      "Hadha BO": "209860",
      "Itauli BO": "209860",
      "Karowan BO": "209801",
      "Sikandarpur Sihura BO": "209801",
      "Singrosi BO": "209801",
      "Deeh BO": "209801",
      "Jamuka BO": "209801",
      "Kanta Guljarpur BO": "209801",
      "Makhi BO": "209801",
      "Bhauli BO": "209831",
      "Jaitipur BO": "209831",
      "Parenda BO": "209831",
      "Rainapur BO": "209831",
      "Argoopur BO": "209868",
      "Atwabaik BO": "209868",
      "Rajepur BO": "209868",
      "Alipur BO": "209863",
      "Baxer BO": "209863",
      "Jagatpur BO": "209863",
      "Terha BO": "209863",
      "Sawain BO": "209864",
      "Ghatampur BO": "209865",
      "Kulaha Bagha BO": "209865",
      "Pakrakhurd BO": "209866",
      "Zamipur BO": "209866",
      "Dubeypur BO": "209827",
      "Mehramau BO": "209827",
      "Kalwari BO": "209869",
      "Banther BO": "209862",
      "Banigaon BO": "209825",
      "Kanchanpur BO": "209821",
      "Sagoli BO": "209821",
      "Samadha BO": "209821",
      "Nevalganj BO": "209881",
      "Samadpur Hardas BO": "209881",
      "Darehata BO": "209859",
      "Kusumbhi BO": "209859",
      "HILAULI": "209821",
      "Kodra BO": "209870",
      "Sohramau BO": "209859",
      "Panhan BO": "209867",
      "Shukla Khera BO": "209867",
      "Sijni BO": "209867",
      "Bichhiya BO": "209825",
      "Dela BO": "209825",
      "Majhgawa Sadku BO": "209825",
      "Taura BO": "209825",
      "Jargaon BO": "209825",
      "Sarosi BO": "209801",
      "Pidna BO": "209801",
      "Poora N Pansari BO": "209801",
      "Thana BO": "209801",
      "Tikargadi BO": "209801",
      "Takia Nigohi Unnao BO": "209801",
      "Kursath BO": "209801",
      "Shadipur BO": "209801",
      "Chandpur Jhalaei BO": "209831",
      "Makoor BO": "209831",
      "Nawai BO": "209831",
      "Raipur Garhi BO": "209831",
      "Jogi Kot BO": "209868",
      "Ruri Sadikpur BO": "209868",
      "Sainpur Sagaura BO": "209868",
      "Sursaini BO": "209868",
      "Utmaanpur BO": "209868",
      "Daundiya Khera BO": "209863",
      "Dundpur Jothra BO": "209863",
      "Majhgawa BO": "209863",
      "Narain Das Khera BO": "209863",
      "Raipur BO": "209863",
      "Sagwar BO": "209863",
      "Mahesh Khera BO": "209864",
      "Pali BO": "209865",
      "Raithana BO": "209865",
      "Sumerpur BO": "209866",
      "Pasakhera BO": "209827",
      "Unchgaon Sani BO": "209827",
      "Chharihara BO": "209841",
      "Maula Bankipur BO": "209841",
      "Maswasi BO": "209862",
      "Sahjani BO": "209862",
      "Shekh Pur Nari BO": "209862",
      "Gujouly BO": "209821",
      "Gulriha BO": "209821",
      "Kardaha BO": "209821",
      "Lotna BO": "209821",
      "Lowa Singhan Khera BO": "209821",
      "Mawai BO": "209821",
      "Shahpur Tonda BO": "209881",
      "Asawar BO": "209859",
      "Mirrikalan BO": "209859",
      "Akwabad BO": "209867",
      "Bardaha BO": "209867",
      "Dhamni Khera BO": "209867",
      "Indemau BO": "209867",
      "Madarpur Narainpur BO": "209825",
      "Mohmmedpur BO": "209825",
      "Nevarna BO": "209825",
      "Orhar BO": "209825",
      "Padri Khurd BO": "209825",
      "Devmai BO": "209825",
      "Unnao HO": "209801",
      "Sainta BO": "209801",
      "Kesar Ganj BO": "209801",
      "Patiyara BO": "209801",
      "Ugoo BO": "209801",
      "Patari BO": "209801",
      "Raukarna BO": "209801",
      "Aterdhani BO": "209801",
      "Chamrauli BO": "209831",
      "Bhikharipur Patsiya BO": "209868",
      "Faridpur Katter BO": "209868",
      "Hafizabad BO": "209868",
      "Jagatnagar BO": "209868",
      "Chandan Pur BO": "209863",
      "Dhanikhera BO": "209863",
      "Dhankoli BO": "209863",
      "Behta Bhawani BO": "209865",
      "Bisen Mau BO": "209865",
      "Garha Kola BO": "209865",
      "Chainpur BO": "209866",
      "Gaura BO": "209866",
      "Kundenpur BO": "209866",
      "Malona BO": "209866",
      "Mankapur BO": "209866",
      "Devra Kalan BO": "209861",
      "Majra Piper Khera BO": "209861",
      "Shankerpur Sarai BO": "209861",
      "SNC BO": "209801",
      "Rupau BO": "209801",
      "Dipwal BO": "209801",
      "Gauraiya Kalan BO": "209801",
      "Tikra BO": "209801",
      "Atesuwa BO": "209831",
      "Kodara Sandana BO": "209831",
      "Sonik BO": "209831",
      "Ashayash BO": "209868",
      "Khambhauli BO": "209868",
      "Madhapur BO": "209868",
      "kodra bakhat khera BO": "209863",
      "Panai Kalan BO": "209864",
      "Kharoli BO": "209865",
      "Osia BO": "209865",
      "Rujhai BO": "209865",
      "Aakampur BO": "209866",
      "Pokhri BO": "209866",
      "Aon BO": "209827",
      "Magraiyar BO": "209827",
      "Hariyapur BO": "209869",
      "Raghurampur BO": "209869",
      "Vyoli Islamabad BO": "209869",
      "NEOTANI BO": "209841",
      "Akrampur BO": "209862",
      "Musandi BO": "209821",
      "Sandana BO": "209821",
      "Dhaura BO": "209881",
      "Arjunamau BO": "209859",
      "Asha Khera BO": "209859",
      "Kantha BO": "209859",
      "Katehru BO": "209859",
      "Sahrawa BO": "209859",
      "Majhgawan Sevak BO": "209867",
      "Parsanda BO": "209867",
      "Wazidpur BO": "209867",
      "Chetra BO": "209825",
      "DHANNIPUR BO": "209825",
      "Mirzapur Sumbhari BO": "209825",
      "Nathikhera BO": "209825",
      "Padri Kalan BO": "209825",
      "Targaon BO": "209825",
      "Tripurarpur BO": "209825",
      "Ballapur BO": "209869",
      "Ahesa BO": "209821",
      "Akohari BO": "209821",
      "Drehata BO": "209821",
      "Mouddinpur BO": "209821",
      "Muktemau BO": "209821",
      "Para BO": "209821",
      "Sarwan BO": "209821",
      "Bisara BO": "209821",
      "Rasulpur Bakiya BO": "209881",
      "Asoha BO": "209859",
      "Chaupai BO": "209859",
      "Akbarpur BO": "209867",
      "Badaurra BO": "209825",
      "Baigaon BO": "209825",
      "Bhadnag BO": "209825",
      "Bhopatpur BO": "209825",
      "Ajgain SO": "209831",
      "Mohan SO": "209881",
      "Nawabganj SO Unnao": "209859",
      "Purwa SO": "209825",
      "Bangermau SO": "209868",
      "Bara SO Unnao": "209863",
      "Ganga Ghat SO": "209861",
      "Ganj Moradabad SO": "209869",
      "Jawaher Nager SO": "209801",
      "Rasulabad SO Unnao": "209870",
      "Achalganj": "209860",
      "Bihar SO": "209866",
      "Csa Colony SO": "209801",
      "Hasanganj SO": "209841",
      "Bhagwant Nagar SO": "209864",
      "Bighapur SO": "209865",
      "Chamiyani SO": "209827",
      "Collectorate Unnao SO": "209801",
      "Magarwara SO": "209862",
      "Maurawan SO": "209821",
      "Patan SO Unnao": "209867",
      "Qila SO": "209801",
      "Safipur SO": "209871"
    },
    "CHITRAKOOT": {
      "Chandramara BO": "210205",
      "Itwan BO": "210205",
      "Lodhwara BO": "210205",
      "Sigwan BO": "210208",
      "Unchadih BO": "210208",
      "Manka BO": "210208",
      "Hanna Vinaika BO": "210209",
      "Khandeho BO": "210209",
      "Khaptiha BO": "210209",
      "Agarahunda BO": "210205",
      "Ainchwara BO": "210205",
      "Ragauli BO": "210205",
      "Raipura BO": "210205",
      "Rukma khurd BO": "210205",
      "Bharatkoop": "210205",
      "Chakla BO": "210205",
      "Nai Bazar Karwi BO": "210205",
      "Sheorampur BO": "210205",
      "Goiya Kalan BO": "210208",
      "Itwan Dundela BO": "210208",
      "Saraiya BO": "210208",
      "Chhibon BO": "210209",
      "Hatwa BO": "210209",
      "Mandaur BO": "210209",
      "Pardawan BO": "210209",
      "Semardaha BO": "210205",
      "Bargarh BO": "210208",
      "Markundi BO": "210208",
      "Murka BO": "210208",
      "Barha Kotra BO": "210209",
      "Barua BO": "210209",
      "Purab Patai BO": "210209",
      "Ram Nagar BO": "210209",
      "Sirwawal BO": "210209",
      "Rauli Kalyanpur BO": "210202",
      "Khohi BO": "210204",
      "Semaria Jagannath basi BO": "210204",
      "Ghuretanpur BO": "210202",
      "Titihara BO": "210202",
      "Bhaisaundha BO": "210204",
      "Audaha BO": "210206",
      "Basila BO": "210205",
      "Bhauri BO": "210205",
      "Purwa Tarauha BO": "210205",
      "Semaria Charandasi BO": "210205",
      "Sidhpur BO": "210205",
      "Garchappa BO": "210208",
      "Kaubra BO": "210208",
      "Baria BO": "210209",
      "Biyawal BO": "210209",
      "Lauri BO": "210209",
      "Nibi BO": "210209",
      "Asoh BO": "210206",
      "Bachharan BO": "210206",
      "Rasin BO": "210202",
      "Jankikund BO": "210204",
      "Baramafi BO": "210206",
      "Hardoli BO": "210206",
      "Nadintaura BO": "210206",
      "Parsaunja BO": "210206",
      "Kalwalia BO": "210207",
      "Beohara BO": "210206",
      "Chaura BO": "210206",
      "Darsenda BO": "210206",
      "Ganiwa Parsidhpur BO": "210206",
      "Bardwara BO": "210207",
      "Bhadedu BO": "210207",
      "Kapna Itaura BO": "210206",
      "Karwara Bujurg BO": "210206",
      "Lohda BO": "210206",
      "Biharwan BO": "210207",
      "Mamsi Bujurg BO": "210207",
      "Nandin Kurmiyan BO": "210207",
      "Sardhuwa BO": "210207",
      "Ora BO": "210206",
      "Chillimal BO": "210207",
      "Karaundi Kalan BO": "210207",
      "Khatwara BO": "210207",
      "Karwi MDG": "210205",
      "Chitrakot SO": "210204",
      "Manikpur SO Chitrakoot": "210208",
      "Mauchhibu SO": "210209",
      "Pahari SO Chitrakoot": "210206",
      "Karwi RS SO": "210205",
      "Rajapur SO Chitrakoot": "210207"
    },
    "SHAMLI": {
      "Hiranwara BO": "251305",
      "Karoda Hathi BO": "251305",
      "Kedi BO": "251305",
      "Kurmali BO": "251305",
      "Butrara BO": "251305",
      "Choonsa BO": "251305",
      "Gogwan Jalalpur BO": "251305",
      "Bharsi BO": "247771",
      "Nala BO": "247771",
      "Bhanera BO": "247771",
      "Pipal Hera BO": "251305",
      "Maharampur BO": "247776",
      "Malandi BO": "247776",
      "Bhaisani Islampur BO": "247777",
      "Chausana BO": "247778",
      "Gagaur BO": "247778",
      "Garhi Hasanpur BO": "247778",
      "Kail Shikarpur BO": "247777",
      "Mundet Khadar BO": "247778",
      "Rangana BO": "247778",
      "Khanpur BO": "247777",
      "Nojal BO": "247777",
      "Lank BO": "247776",
      "Taprana BO": "247776",
      "Bhanera Jat BO": "251319",
      "Harar Fatehpur BO": "247777",
      "Sonta BO": "251301",
      "Banti Khera BO": "251305",
      "Sonta Rasulpur BO": "247777",
      "Toda BO": "247778",
      "Garhi Abdulha Khan BO": "247778",
      "Hath Choya BO": "247778",
      "Pindora BO": "247778",
      "Lilon BO": "247776",
      "Silawar BO": "247776",
      "Titauli BO": "247776",
      "Bhajju BO": "251319",
      "Bhanera Udda BO": "247777",
      "Hind BO": "247777",
      "Chandena Mal BO": "247772",
      "Dakhori BO": "247772",
      "Gandewara BO": "247772",
      "Bhoora BO": "247774",
      "Hasanpur Luhari BO": "247772",
      "Tana BO": "247773",
      "Kheri Buchha BO": "247774",
      "Uncha Gaon BO": "247774",
      "Dundu Khera BO": "247775",
      "Kiwana BO": "247775",
      "Shamli Sugar Mills BO": "247776",
      "Badheo BO": "247776",
      "Balwa BO": "247776",
      "Garhi Pukhta BO": "247776",
      "Kudana BO": "247776",
      "Kandela BO": "247774",
      "Khurgaon Issopur BO": "247774",
      "Garhi Daulat BO": "247775",
      "Islampur Ghasauli BO": "247775",
      "Isso Pur Teel BO": "247775",
      "Jasala BO": "247775",
      "Lisarh BO": "247775",
      "Banat BO": "247776",
      "Bahawari BO": "247776",
      "Dullakheri BO": "247776",
      "Jasana Urf Mastgarh BO": "247776",
      "Kabarout BO": "247776",
      "Nojjal BO": "247772",
      "Pawati Kalan BO": "247773",
      "Purmafi BO": "247773",
      "Udpur BO": "247773",
      "Beenra BO": "247774",
      "Titarwara BO": "247774",
      "Gangeru BO": "247775",
      "Khandrawali BO": "247775",
      "Makhmoolpur BO": "247775",
      "Rasulpur Gujran BO": "247775",
      "Tahirpur Bhabisa BO": "247775",
      "Bhainswal BO": "247776",
      "Kaserwa Kalan BO": "247776",
      "Kheri Karmu BO": "247776",
      "Gogwan BO": "247773",
      "Kairtoo BO": "247773",
      "Sunna BO": "247775",
      "Dhimanpura SO": "247776",
      "Jalalabad SO Muzaffarnagar": "247772",
      "Shamli SO": "247776",
      "Thanabhawan SO": "247777",
      "Un SO Muzaffarnagar": "247778",
      "Babri SO": "251305",
      "Jhinjhana SO": "247773",
      "Kandhala SO": "247775",
      "Shamli Mandi SO": "247776",
      "Bara Bazar Shamli SO": "247776",
      "Kairana SO": "247774",
      "Ailum SO": "247771",
      "Ganj Bazar Kandhala SO": "247775",
      "Ganna Samiti Shamli SO": "247776"
    },
    "KUSHI NAGAR": {
      "Ragarganj BO": "274306",
      "Rampur Bagaha BO": "274306",
      "Kohargaddi BO": "274802",
      "Mathia Buzurg BO": "274802",
      "Nebua Raiganj": "274802",
      "Siswa Maniraj": "274802",
      "Amwa Bazar BO": "274305",
      "Barwa Bazar BO": "274305",
      "Singaha BO": "274305",
      "Tekuatar BO": "274305",
      "Chilua BO": "274207",
      "Padari BO": "274207",
      "Pindara BO": "274207",
      "Pagara Prsad Giri BO": "274407",
      "Baghachaur BO": "274409",
      "Salemgarh BO": "274409",
      "Pagar BO": "274306",
      "Bali BO": "274802",
      "Gethihawa BO": "274802",
      "Kotwa Bazar BO": "274305",
      "Naurangia BO": "274305",
      "Parwarpar BO": "274305",
      "Pipra Bazar BO": "274305",
      "Ruari BO": "274305",
      "Gauri Ibrahim BO": "274406",
      "Mania Chhapar BO": "274306",
      "Barwa Ratanpur BO": "274802",
      "Belwaghat BO": "274802",
      "Bhaisaha BO": "274802",
      "Bhujauli Buzurg": "274802",
      "Morban BO": "274305",
      "Madhopur Buzurg BO": "274406",
      "Piparaghat BO": "274406",
      "Rakaba Junglepatti BO": "274406",
      "Sarya BO": "274309",
      "Bagahi BO": "274407",
      "Barwa Raja Pakar BO": "274407",
      "Laxmipur Baboo BO": "274407",
      "Bahadur Pur BO": "274409",
      "Jabahi Dayal BO": "274409",
      "Pipara Agarwa BO": "274409",
      "Vedupar BO": "274409",
      "Dhadha Buzurg BO": "274207",
      "Naumunda BO": "274207",
      "Pakari BO": "274207",
      "Parsauni Buzurg BO": "274407",
      "Marar Bindwalia BO": "274306",
      "Puraini BO": "274306",
      "Khairi BO": "274802",
      "Madanpur Bherihari BO": "274802",
      "Sohrauna": "274802",
      "Khajuri Bazar BO": "274305",
      "Kushumhi BO": "274305",
      "Pakariyar Bazar BO": "274305",
      "Rambar Buzurg BO": "274305",
      "Sidhawey BO": "274305",
      "Gauri Jagdish BO": "274406",
      "Barsaina BO": "274207",
      "Vijaikaf BO": "274207",
      "Dhuria Imilia BO": "274407",
      "Ahiraulidan BO": "274409",
      "Mathia Sriram BO": "274409",
      "Tarya Lachhiram BO": "274409",
      "Kuber Sthan BO": "274309",
      "Khesiya BO": "274308",
      "Singha Patti BO": "274307",
      "Kinnarpatti BO": "274307",
      "Sidhuwa Bangar BO": "274309",
      "Jataha Bazar BO": "274307",
      "Asana BO": "274149",
      "Mahuwa Buzurg BO": "274149",
      "Rohuwa Machhargawa BO": "274149",
      "Turkdiha BO": "274149",
      "Atharaha BO": "274301",
      "Bharsar Khas BO": "274301",
      "Malukahi BO": "274301",
      "Bishunpura BO": "274302",
      "Dashahawa BO": "274302",
      "Rampur Barhan BO": "274302",
      "Banbira BO": "274401",
      "Bihar Buzurg BO": "274401",
      "Farendaha BO": "274401",
      "Jaura Man Rakhan BO": "274401",
      "Nakataha Misir BO": "274401",
      "Pipra Kanak BO": "274401",
      "Semara Hardo Patti BO": "274401",
      "Sumahi Khurd BO": "274401",
      "Arjun Dumari BO": "274203",
      "Bhuri Pakar BO": "274203",
      "Pipraicha BO": "274203",
      "Rampur Sohrauna BO": "274203",
      "Sirsia BO": "274203",
      "Karmaini Premwalia BO": "274402",
      "Mahuawa Karkhana BO": "274402",
      "Natwalia BO": "274402",
      "Sakhopar BO": "274402",
      "Basdila Pandey BO": "274303",
      "Horlapur BO": "274303",
      "Pipra Jatampur BO": "274303",
      "Deoria Baboo BO": "274306",
      "Dandopur BO": "274308",
      "Padari Pipar patti BO": "274307",
      "Chiurapali BO": "274149",
      "Jagdishpur Dharmdani BO": "274149",
      "Kundur BO": "274149",
      "Lehani BO": "274149",
      "Mansoorganj BO": "274149",
      "Mujdiha BO": "274149",
      "Fardaha BO": "274301",
      "Gaunaria BO": "274301",
      "Khabhara Bhar BO": "274301",
      "Pipara Brahaman BO": "274301",
      "Rampur Chaubey BO": "274301",
      "Singari BO": "274301",
      "Rampur Jungle BO": "274801",
      "Amawa Digar BO": "274302",
      "Bansgaon BO": "274302",
      "Barwa Patti BO": "274302",
      "Koilasawa BO": "274401",
      "Lachhia BO": "274401",
      "Laxmipur Mishra BO": "274401",
      "Sohang BO": "274401",
      "Dharmpur BO": "274203",
      "Jhanga BO": "274203",
      "Langari BO": "274203",
      "Narainpur BO": "274203",
      "Pipara BO": "274203",
      "Sahbajpur BO": "274206",
      "Mathia Naraipur BO": "274402",
      "Sapaha BO": "274402",
      "Sekhwania BO": "274402",
      "Chandarpur BO": "274306",
      "Khanu Chhapara BO": "274306",
      "Sarpatahi BO": "274308",
      "Balkuriya BO": "274308",
      "Deoria Pandey BO": "274309",
      "Parsauni BO": "274309",
      "Belwa Jungle BO": "274308",
      "Nahar Chhapara BO": "274308",
      "Pakari Buzurg BO": "274309",
      "Bankata Bharpurawa BO": "274149",
      "Bhaluhi BO": "274149",
      "Somali BO": "274149",
      "Baulia BO": "274301",
      "Gauri Sriram BO": "274302",
      "Gurwalia BO": "274401",
      "Tirma Sahun BO": "274302",
      "Belwa Karkhana BO": "274401",
      "Bhatahi Khurd BO": "274401",
      "Chandrauta BO": "274401",
      "Shankar Pat Khauli BO": "274401",
      "Rampur Buzurug BO": "274203",
      "Samogar BO": "274203",
      "Dumari Swangi Patti BO": "274206",
      "Ahirauli Bazar BO": "274149",
      "Dilip Nagar BO": "274402",
      "Dhuria Khas BO": "274402",
      "JIC Sohasa Mathia BO": "274402",
      "Goraria BO": "274303",
      "Jhankaul BO": "274303",
      "Laxmipur BO": "274303",
      "Sikata BO": "274303",
      "Kusumha BO": "274306",
      "Lala Chhapara BO": "274306",
      "Maghi Kotilwa BO": "274307",
      "Katai Bharpurwa BO": "274307",
      "Dumarbhar BO": "274309",
      "Babuiya Harpur BO": "274307",
      "Siawa Goiti BO": "274307",
      "Bettiah BO": "274307",
      "Ahirauli bazar BO": "274402",
      "Karitin BO": "274301",
      "Mathauli BO": "274301",
      "Mundera BO": "274301",
      "Chaf BO": "274302",
      "Dharampur Parbat BO": "274302",
      "Mahuawa Buzurg BO": "274302",
      "Kishundeopur BO": "274401",
      "Nadawa Bishunpur BO": "274401",
      "Pataherawa BO": "274401",
      "Sariya Mahanth Patti BO": "274401",
      "Bhaisahi Bazar BO": "274203",
      "Bikram Bhisunpur BO": "274203",
      "Paikauli BO": "274203",
      "Sakrauli BO": "274203",
      "Naika Chhapar BO": "274206",
      "Kurmauta Manjharia BO": "274402",
      "Mainpur BO": "274402",
      "Parsauni Khurd BO": "274402",
      "Batrauli Bazar BO": "274303",
      "Pachrukhia BO": "274303",
      "Chakhani Bhumihari Patti BO": "274306",
      "Harpur Mafi BO": "274306",
      "Khutahi BO": "274306",
      "Padrauna HO": "274304",
      "1CBPO": "900056",
      "Dudhai SO": "274302",
      "Fazilnagar SO": "274401",
      "Padrauna City SO": "274308",
      "Tarya Sujan SO": "274409",
      "Kasia S O": "274402",
      "Padrauna Chhavani SO": "274309",
      "Tamkuhi SO": "274407",
      "Bodarwar SO": "274149",
      "Chhitauni SO": "274801",
      "Kathkuiyan SO": "274303",
      "Laxmiganj SO": "274306",
      "Captainganj SO": "274301",
      "HATA SO": "274203",
      "KUSHINAGAR SO": "274403",
      "Padrauna Sugar Factory SO": "274307",
      "Raja Bazar Khadda SO": "274802",
      "Ramkola SO": "274305",
      "Seorahi SO": "274406",
      "Sukrauli SO": "274207"
    },
    "GONDA": {
      "Mehnawan BO": "271603",
      "Pure Basalat BO": "271603",
      "Retwa Gara BO": "271603",
      "Bangai Barwar BO": "271602",
      "Belawa Bahuta BO": "271202",
      "Para Sarai BO": "271202",
      "Tirre Manorama BO": "271202",
      "Janki Nagar BO": "271209",
      "Ashidha BO": "271204",
      "Bhatpurwa BO": "271204",
      "Bakharwa BO": "271603",
      "Debari Kalan BO": "271603",
      "Ujjaini Kalan BO": "271603",
      "Belbharia BO": "271602",
      "Bisambharpur BO": "271602",
      "Dulhapur BO": "271602",
      "Dutt Nagar BO": "271602",
      "Binuhani BO": "271202",
      "Bishunpur Sangam BO": "271202",
      "Ranipur BO": "271403",
      "Devtaha BO": "271209",
      "Jhalidham BO": "271204",
      "Kamrawan BO": "271204",
      "Pipra Bhodhar BO": "271204",
      "Pirwartara BO": "271204",
      "Basant Pur Raja BO": "271209",
      "Bhawanipur Uppadhyay BO": "271209",
      "Rajapur BO": "271504",
      "Fattepur BO": "271312",
      "Narharpur BO": "271312",
      "Bangaon BO": "271403",
      "Narayan Pur Kala BO": "271503",
      "Pure Nidhi BO": "271503",
      "Tilka Deeh BO": "271503",
      "Mallapur BO": "271122",
      "Rupaideeh BO": "271122",
      "Bhgahar Buland BO": "271123",
      "Chetpur BO": "271123",
      "Taj Pur BO": "271123",
      "Andhiyari BO": "271302",
      "Bhorha BO": "271302",
      "Dhuswa BO": "271302",
      "Kunjalpur BO": "271302",
      "Mawai BO": "271305",
      "Shitalganj Grant BO": "271305",
      "Bankati Suryabali Singh BO": "271602",
      "Rudragarh Nausi BO": "271602",
      "Ayah BO": "271202",
      "Gilauli BO": "271202",
      "Bhangaha Hussain Nagar BO": "271204",
      "Bishunpur Bel Bharia BO": "271204",
      "Sisai Jangal BO": "271204",
      "Ismaila BO": "271312",
      "Keshav Nagar Grant BO": "271312",
      "Kook Nagar Grant BO": "271312",
      "Chauhan Purwa BO": "271503",
      "Deva Pasiya BO": "271503",
      "Dubha Bazar BO": "271503",
      "Katuwa Nala BO": "271503",
      "Pipari Majha BO": "271503",
      "Selhari BO": "271503",
      "Shahajot BO": "271503",
      "Urdi BO": "271503",
      "Bangai BO": "271122",
      "Beerpur Bhoj BO": "271122",
      "Sahjanwa BO": "271122",
      "Darjikuwa BO": "271123",
      "Durjan Pur Pandey BO": "271123",
      "Mahdeiya Chaksar BO": "271123",
      "Madhaipur BO": "271123",
      "Nagwa BO": "271123",
      "Ramnagar Tarhar BO": "271123",
      "Ummedjot BO": "271123",
      "Bairi Pur Ramnath BO": "271302",
      "Balli Pur BO": "271302",
      "Bankasia BO": "271302",
      "Bhitaura BO": "271302",
      "Lamti Ukaruhwa BO": "271302",
      "Machhali Gaon BO": "271302",
      "Mallhipur BO": "271302",
      "Pachupati Jagtapur BO": "271302",
      "Surjapur BO": "271302",
      "SN Chapiya BO": "271305",
      "Mahewa Gopal BO": "271301",
      "Rajgarh BO": "271301",
      "Khirai Khirwa BO": "271301",
      "Ghari Ghat BO": "271312",
      "Farenda Khurda BO": "271312",
      "Hathiagarh BO": "271312",
      "Maddo Bazar BO": "271312",
      "Sitarampur Grant BO": "271312",
      "Ahiya Chet BO": "271503",
      "Bhartha BO": "271503",
      "Kotiya Madara BO": "271503",
      "Bhairampur BO": "271122",
      "Khairam Lalwa Chak BO": "271122",
      "Pipara  Bazar BO": "271122",
      "Ramapur BO": "271122",
      "Bauriha BO": "271123",
      "Chandipur BO": "271123",
      "Narayanpuredha BO": "271123",
      "Deoria BO": "271302",
      "Dinkarpur BO": "271302",
      "Ghunahi BO": "271302",
      "Jhilahi BO": "271302",
      "Karoha Man BO": "271302",
      "Ailanpur Grant BO": "271305",
      "Hathini Bhopatpur BO": "271305",
      "Manda BO": "271305",
      "Sohila BO": "271305",
      "Govindpara BO": "271301",
      "Daulatpur Grant BO": "271312",
      "Bichhudi BO": "271122",
      "Parsia Rani BO": "271122",
      "Pure Bahori BO": "271122",
      "USRAINA BO": "271122",
      "Harna Tayar BO": "271302",
      "Harsinghwa Chauhan BO": "271302",
      "Jigana Bazar BO": "271302",
      "Gaighat BO": "271305",
      "Majhauwa Bujurg BO": "271305",
      "Surwar Khurd BO": "271305",
      "Haldhar Mau BO": "271126",
      "Kauraha Jagdish Pur BO": "271126",
      "Charu BO": "271313",
      "Parsaudaikar BO": "271313",
      "Bamdera BO": "271125",
      "Dumaria Deeh BO": "271310",
      "Majhgaon BO": "271310",
      "Bhabhuwa Kot BO": "271311",
      "Chitrauli BO": "271311",
      "Gobrepurwa BO": "271311",
      "Pandri Kirpal BO": "271002",
      "Pure Dal BO": "271402",
      "Baksaila BO": "271401",
      "Nagdahi BO": "271401",
      "Umrapur Chauhan BO": "271401",
      "Imiliarupi BO": "271601",
      "Dhobharai BO": "271003",
      "Jhauhana BO": "271003",
      "KHARGOO CHAND PUR BO": "271003",
      "Madhopur BO": "271003",
      "Kotha BO": "271129",
      "Gursari BO": "271502",
      "Kurtha BO": "271502",
      "Nahwa Parsaura BO": "271502",
      "Pandey Chaura BO": "271502",
      "Akbar Pur BO": "271309",
      "Dhaurahra Ghat BO": "271309",
      "Allipur Grant BO": "271312",
      "Khamariaha Bujurg BO": "271313",
      "Kotkhas BO": "271313",
      "Mahrajganj Grant BO": "271313",
      "Mandap BO": "271313",
      "Parsa Tiwari BO": "271313",
      "Sabarpur BO": "271313",
      "Durgodwa BO": "271125",
      "Kaithola BO": "271125",
      "Thakurapur BO": "271125",
      "Jahgirwa BO": "271311",
      "Lale Mau BO": "271311",
      "Mauhar BO": "271311",
      "Barauli BO": "271402",
      "Dixar BO": "271402",
      "Semri Kala BO": "271402",
      "Sonauli Mohammad Pur BO": "271402",
      "Adampur BO": "271401",
      "Dewarda BO": "271401",
      "Didsia Kala BO": "271401",
      "Gopipur BO": "271401",
      "Karamdeeh BO": "271601",
      "Malari BO": "271601",
      "Banwaria BO": "271003",
      "Paidi Azab Singh BO": "271003",
      "Pathwalia BO": "271003",
      "TPatti BO": "271003",
      "Naipur BO": "271129",
      "Sakraura BO": "271502",
      "Shisa Mau BO": "271502",
      "Usrair BO": "271502",
      "Gedsar BO": "271309",
      "Ghacha BO": "271309",
      "Rangi BO": "271309",
      "Sakipur BO": "271309",
      "Bangawan BO": "271312",
      "Chandradeep Ghat BO": "271312",
      "Sumeripur BO": "271301",
      "Khargupur BO": "271303",
      "Lauwa Beerpur BO": "271303",
      "Akohari BO": "271504",
      "Bishunpur Kla BO": "271504",
      "Dehras BO": "271504",
      "Kundwa Tewaripur BO": "271504",
      "Paska BO": "271504",
      "Subhagpur BO": "271504",
      "Utraula BO": "271504",
      "Khadauwan BO": "271319",
      "Lakar Mandi BO": "271319",
      "Ramapur Bhagahi BO": "271319",
      "Dhodhey Pur BO": "271403",
      "Niyama BO": "271403",
      "Pure Ghisiram BO": "271403",
      "Kodar BO": "271124",
      "Rampur Kharahta BO": "271124",
      "Mahngoopur BO": "271303",
      "Raghuraj Nagar BO": "271303",
      "Semra Sekhpur BO": "271303",
      "Tulsipur Majha BO": "271303",
      "Vishnoharpur BO": "271303",
      "Madhaipur khanderai BO": "271504",
      "Malaon BO": "271504",
      "Marchaur BO": "271504",
      "Mijhaura BO": "271504",
      "Raksaria BO": "271504",
      "Saraiya BO": "271504",
      "Naubasta BO": "271124",
      "Parsagodari BO": "271126",
      "Sarwangpurwa BO": "271126",
      "Dalpatpur BO": "271310",
      "Babhani Kanoongo BO": "271002",
      "Bahlol Pur BO": "271002",
      "Burha Dewar BO": "271002",
      "Aili Parsauli BO": "271402",
      "Banuwa BO": "271402",
      "Liloi Kala BO": "271401",
      "Neerpur Khayala BO": "271401",
      "Parsada BO": "271401",
      "Sisai BO": "271401",
      "Susunda BO": "271401",
      "Chandawatpur BO": "271003",
      "DNath BO": "271003",
      "Firojpur Tarhar BO": "271003",
      "Mokalpur BO": "271003",
      "Kandaru BO": "271502",
      "Malauna BO": "271502",
      "Mohammadpur BO": "271502",
      "Babhanjot BO": "271312",
      "Ram Pur Bansawan BO": "271301",
      "Siha Gaon BO": "271301",
      "Ashokpur BO": "271303",
      "Kisundaspur BO": "271303",
      "Aata BO": "271504",
      "Bahuwan Madar Majha BO": "271504",
      "Balmathar BO": "271504",
      "Bhauriganj BO": "271504",
      "Lali Purwa BO": "271504",
      "Taorasi BO": "271504",
      "Haribanshpur BO": "271319",
      "Garauli BO": "271403",
      "Jamtha BO": "271403",
      "Khojanpur BO": "271403",
      "Kindhaura BO": "271403",
      "Paras BO": "271403",
      "Sarawa BO": "271403",
      "Singha Chanda BO": "271403",
      "Taradheeh BO": "271403",
      "Tiwari Bazar BO": "271403",
      "Babhani BO": "271124",
      "Beliya BO": "271124",
      "Birahmatpur BO": "271124",
      "Karda BO": "271124",
      "Rampur Tengraha BO": "271124",
      "Bans Gaon Pure Bhojai BO": "271126",
      "Kharthari BO": "271126",
      "Belahri Bujurg BO": "271313",
      "Chuwar BO": "271313",
      "Baruee Gondha BO": "271125",
      "Hariyagara BO": "271125",
      "Thathiya Mathiya BO": "271125",
      "Kasipur BO": "271310",
      "Dhanawa BO": "271311",
      "Gurwalia BO": "271311",
      "Imliya Gurdayal BO": "271002",
      "Gaj Singh Pur BO": "271402",
      "SIDHAUTI BO": "271402",
      "Barsada Ram Singh BO": "271401",
      "Badnapur BO": "271401",
      "Changeri BO": "271401",
      "Mangura Bazar BO": "271401",
      "Deoria Alawal BO": "271601",
      "Banjaria BO": "271003",
      "Budhaipurwa BO": "271003",
      "Forbisganj BO": "271003",
      "Keshav Pur Paharwa BO": "271003",
      "Banepur BO": "271129",
      "Karnipur Deeh BO": "271129",
      "Paharapur BO": "271502",
      "Parsa Mahesi BO": "271502",
      "Pipri Rawat BO": "271502",
      "Bhopat Pur BO": "271309",
      "Gauhani BO": "271309",
      "Siswaria BO": "271301",
      "Turkadeeha BO": "271301",
      "Durjanpur BO": "271303",
      "Charsari BO": "271504",
      "Dhanaura BO": "271504",
      "Jarauli BO": "271504",
      "Mohna BO": "271504",
      "Pure Azab BO": "271504",
      "Kolahanpur Visen BO": "271319",
      "Madwa Bujurga BO": "271307",
      "Amdahi BO": "271403",
      "Dhanauli BO": "271403",
      "Ram Adhin Purwa BO": "271403",
      "Achalpur BO": "271124",
      "khiri deeh BO": "271124",
      "Majhara BO": "271124",
      "Gonda HO": "271001",
      "Intyathok SO": "271202",
      "Dhaneypur SO": "271602",
      "Khargoopur SO": "271204",
      "Jaiprabha Gram SO": "271209",
      "BBSingh SO": "271126",
      "Balpur SO": "271125",
      "Begamganj SO": "271402",
      "Bishunpur Bairiya SO": "271601",
      "Khorasha SO": "271123",
      "Mankapur Bazar SO": "271302",
      "Nawabganj SO Gonda": "271303",
      "Utraula Road SO": "271003",
      "Srinagar SO Gonda": "271603",
      "DPGhat SO": "271309",
      "Iti Mankapur SO": "271308",
      "Katra Bazar SO Gonda": "271503",
      "Kauria SO": "271122",
      "Maskanwa Rs SO": "271305",
      "Motiganj SO Gonda": "271301",
      "P A C SO": "271001",
      "Bankatwa SO": "271003",
      "Bargaon Gonda SO": "271002",
      "Chandapur SO Gonda": "271129",
      "Civil Line SO Gonda": "271001",
      "Colonelganj SO Gonda": "271502",
      "Dadua Bazar SO": "271002",
      "Gaura Chawki SO": "271312",
      "Nawabganj S F SO": "271304",
      "Babhnan Sugar Factory SO": "271313",
      "Bankatwa Dehat SO": "271310",
      "Bargadi Kot SO": "271311",
      "Belser SO": "271401",
      "Bus Station SO Gonda": "271003",
      "Gonda City SO": "271003",
      "Mankapur SO Gonda": "271302",
      "Paraspur SO": "271504",
      "Pure Shivdayal Ganj SO": "271319",
      "Tarabganj SO": "271403",
      "Wazeerganj SO": "271124"
    },
    "SITAPUR": {
      "Bhithauli BO": "261302",
      "Bhithaura BO": "261302",
      "Hasnapur BO": "261201",
      "Kasmanda BO": "261302",
      "Ashrafpur BO": "261131",
      "Dharaincha Bazar BO": "261131",
      "Piparia Form BO": "262728",
      "Phoolpur Gunia BO": "262722",
      "Banni Kharela BO": "261145",
      "Hathiya Gazipur BO": "261145",
      "Munderi BO": "261145",
      "Purwa Dasa Pur BO": "261145",
      "Akbapur BO": "261401",
      "Arthapur BO": "261401",
      "Garasa BO": "261401",
      "Qutubnagar BO": "261401",
      "Atwa BO": "261402",
      "Bhithauli Chitrakoot BO": "261402",
      "Bhadebhar BO": "261404",
      "Bahadurnagar BO": "261151",
      "Bargawan BO": "261151",
      "Bhakuraha BO": "261151",
      "Musabbarpur BO": "261151",
      "Gonda Deoria BO": "261204",
      "Kothwal BO": "261204",
      "Golok Kondar BO": "261205",
      "Gwari BO": "261205",
      "Itauri BO": "261205",
      "Kankari BO": "261205",
      "Kodaura BO": "261205",
      "Meer Nagar BO": "261206",
      "Pahla BO": "261206",
      "Rampur Kalan BO": "261206",
      "Bari BO": "261303",
      "Baunabhari BO": "261303",
      "Chauriya BO": "261303",
      "Belwa Baharurpur BO": "261145",
      "Marsanda BO": "261136",
      "Ulara BO": "261145",
      "Ant BO": "261401",
      "Mohkampur Mandaruwa BO": "261401",
      "Dadeura BO": "261404",
      "Parsehra BO": "261404",
      "Fakharpur BO": "261151",
      "Gursanda BO": "261151",
      "Mathan BO": "261151",
      "Angaraura BO": "261204",
      "Chikkari Dhandhar BO": "261204",
      "Gondaha BO": "261204",
      "Keora BO": "261204",
      "Lohiyanagar BO": "261204",
      "Bambhiya BO": "261205",
      "Husainpur Khani BO": "261205",
      "Jatpurwa Kishoreganj BO": "261205",
      "Magdapur BO": "261205",
      "Rajapur Kalan BO": "261205",
      "Shankarpur BO": "261205",
      "Balsinghpur BO": "261206",
      "Bilauli Bazar BO": "261206",
      "Shamshabad BO": "261206",
      "Sirsa Khurd BO": "261206",
      "Amberpur BO": "261303",
      "Atariya BO": "261303",
      "Dhawarpara BO": "261303",
      "Gandhauli BO": "261303",
      "Kursi BO": "261303",
      "Tendua BO": "261145",
      "Kishunpur BO": "261401",
      "Phulruwa BO": "261401",
      "Sahabnagar BO": "261401",
      "Sejkhurd BO": "261151",
      "Ataura BO": "261204",
      "Bahadurganj BO": "261204",
      "Bansura BO": "261204",
      "Bhagipur BO": "261204",
      "Sadhuwapur BO": "261204",
      "Umari Ganeshpur BO": "261204",
      "Madhawapur BO": "261302",
      "Sujaulia BO": "261302",
      "Unchakhera Kalan BO": "261302",
      "Nerpur BO": "261131",
      "Rahimabad BO": "261131",
      "Suhetara BO": "261131",
      "Tappa Khajuriya BO": "261131",
      "Gularipurwa BO": "261135",
      "Kakrahi BO": "261135",
      "Karseora BO": "261135",
      "Makanpur BO": "261135",
      "Raipur Ganj BO": "261135",
      "Shahpur BO": "261135",
      "Badrawan BO": "261405",
      "Manapur BO": "261203",
      "Meeranagar BO": "261203",
      "Painteypur BO": "261203",
      "Purwa Rewan BO": "261203",
      "Beehat Gaur BO": "261141",
      "Bisara BO": "261141",
      "Chaturaiya BO": "261141",
      "Kusaila BO": "261141",
      "Pailakisha BO": "261141",
      "Patabodh BO": "261141",
      "Salahpur BO": "261141",
      "Ramgarh BO": "261403",
      "Ramshala BO": "261403",
      "Rehuwa BO": "261301",
      "Ahmedabad BO": "261201",
      "Bakahuan BO": "261201",
      "Bhinaini BO": "261201",
      "Manikapur BO": "261201",
      "Razakarnai BO": "261201",
      "Sadarpur BO": "261201",
      "Kabirpur Budhanpur BO": "261121",
      "Pichhaura BO": "261121",
      "Rajepur BO": "261121",
      "Rakhauna BO": "261121",
      "Saadat Nagar BO": "261121",
      "Selumau BO": "261121",
      "Baragaon Bhurjiha BO": "261125",
      "Khanpur BO": "261202",
      "Naseerpur BO": "261202",
      "Palhari BO": "261202",
      "Punjikhera BO": "261202",
      "Rewan BO": "261202",
      "Sanda BO": "261202",
      "Bambhera BO": "261302",
      "Garhisenpur BO": "261131",
      "Behra Kodehra BO": "261135",
      "Beni Sarain BO": "261135",
      "Bhadfar BO": "261135",
      "Bilariya BO": "261135",
      "Nabinagar BO": "261135",
      "Newada Nayagaon BO": "261135",
      "Ramnagar BO": "261135",
      "Beehatbeeram BO": "261405",
      "Rajepara BO": "261405",
      "Mohammadpur Kadim BO": "261203",
      "Niyamatpur Labarha BO": "261203",
      "Neri Kalan BO": "261001",
      "Lalpuir BO": "261302",
      "Suraincha BO": "261302",
      "Gauriya BO": "261131",
      "Paharpur Maheshpur BO": "261131",
      "Akbarpur BO": "261135",
      "Dhakera BO": "261135",
      "Gurepara BO": "261135",
      "Katesar BO": "261135",
      "Laharpur East BO": "261135",
      "Nimauchi BO": "261135",
      "Sherpur BO": "261135",
      "Amtamau BO": "261405",
      "Baniyamau BO": "261405",
      "Fateh Nagar BO": "261405",
      "Imiliya Manpur BO": "261203",
      "Marahmatnagar BO": "261203",
      "Bachhawal BO": "261141",
      "Bambhaura BO": "261141",
      "Baragaon BO": "261141",
      "Barbatapur Chitahla BO": "261141",
      "Chathia BO": "261141",
      "Urdauli BO": "261141",
      "Padukha BO": "261203",
      "Bhurkuri BO": "261141",
      "Brahmawali BO": "261403",
      "Girdharpur BO": "261141",
      "Neri BO": "261141",
      "Tikra Teekar BO": "261141",
      "Wazirnagar BO": "261141",
      "Reseura Form BO": "261001",
      "Kunera BO": "261403",
      "Lauli BO": "261403",
      "Mudia Kail BO": "261403",
      "Sandana BO": "261403",
      "Ahewa BO": "261301",
      "Dahawa BO": "261301",
      "Neelgaon BO": "261301",
      "Saidapur BO": "261301",
      "Bhurkunda Bazar BO": "261201",
      "Kaimahara Kalan BO": "261201",
      "Madnapur BO": "261201",
      "Mangrahiya Bazar BO": "261201",
      "Shivthana BO": "261201",
      "Tikra BO": "261201",
      "Akhtiyarpur BO": "261121",
      "Keoti Kalan BO": "261121",
      "Parsehra Nath BO": "261121",
      "Tihar BO": "261121",
      "Mazlishpur BO": "261125",
      "Bohra BO": "261202",
      "Jhauwa BO": "261202",
      "Basaideeh BO": "261302",
      "Bhadmara BO": "261205",
      "Dalpatpur BO": "261205",
      "Dhenua BO": "261205",
      "Seepatpur BO": "261205",
      "Semra BO": "261205",
      "Thoura BO": "261205",
      "Babupur BO": "261206",
      "Garhi Kherwa BO": "261303",
      "Hindaura BO": "261303",
      "Husainganj BO": "261303",
      "Kondaria BO": "261303",
      "Pachhimgaon BO": "261303",
      "Parewajal BO": "261303",
      "Raipur Deo Singh BO": "261303",
      "Saholi BO": "261303",
      "Dugana BO": "261136",
      "Bisenda BO": "261145",
      "Saraiyan Sani BO": "261145",
      "Islamnagar BO": "261401",
      "Kolhuwa BO": "261401",
      "Nighuwamau BO": "261404",
      "Sakrara BO": "261404",
      "Kotra Deokali BO": "261151",
      "Itia BO": "261204",
      "Para Ramnagra BO": "261204",
      "Terwa Manikapur BO": "261204",
      "Bambhanawan BO": "261205",
      "Bhartha BO": "261205",
      "Kondari BO": "261205",
      "Panditpurwa BO": "261205",
      "Seota BO": "261205",
      "Thangaon BO": "261205",
      "Bambhaur BO": "261206",
      "Ishwarwara BO": "261206",
      "Saraiyan Mahipat Singh BO": "261206",
      "Sultanapur BO": "261206",
      "Akohra BO": "261303",
      "Anshuamau BO": "261303",
      "Badanpur BO": "261303",
      "Ganga Ganj BO": "261303",
      "Godhana BO": "261303",
      "Makhuwapur BO": "261302",
      "Neorajpur BO": "261302",
      "Phoolpur BO": "261302",
      "Saraura Kalan BO": "261302",
      "Shah Jalalpur BO": "261302",
      "Sharifganj BO": "261131",
      "Mudrasan BO": "261135",
      "Murthana BO": "261135",
      "Baghain BO": "261203",
      "Bhethra Madhav BO": "261203",
      "Chandpur BO": "261403",
      "Parwatpur BO": "261203",
      "Samardaha BO": "261203",
      "Hathia BO": "261141",
      "Inayat Nagar BO": "261141",
      "Jahansapur BO": "261141",
      "Kachura BO": "261141",
      "Kateeli BO": "261141",
      "Sadikapur BO": "261141",
      "Kathwa BO": "261303",
      "Kuchlai BO": "261303",
      "Banzariya BO": "261001",
      "Jar BO": "261001",
      "Padrakha BO": "261001",
      "Mirzapur BO": "261001",
      "Bartal BO": "261403",
      "Gohilari BO": "261403",
      "Korauna BO": "261403",
      "Mareli BO": "261403",
      "Ralamau BO": "261403",
      "Samsapur BO": "261403",
      "Sarosa BO": "261403",
      "Baloia BO": "261301",
      "Daulatpur Behma BO": "261301",
      "Manduri BO": "261301",
      "Sair BO": "261301",
      "Sarwa Jalalpur BO": "261301",
      "Bhusna BO": "261201",
      "Deokaliya BO": "261201",
      "Maharaj Nagar BO": "261201",
      "Sarain BO": "261303",
      "Badeliya BO": "261121",
      "Koriya Udnapur BO": "261121",
      "Mumtajpur BO": "261121",
      "Tareenpur BO": "261001",
      "Khagesiamau BO": "261001",
      "Baseti BO": "261001",
      "Koriya Udaipur BO": "261001",
      "Kasimpur BO": "261001",
      "Keshavpur BO": "261001",
      "Bharauna BO": "261403",
      "Gangoopur BO": "261403",
      "Kalli BO": "261403",
      "Tatroi BO": "261403",
      "Dhakhinawan BO": "261301",
      "Kabra BO": "261301",
      "Khalgaon BO": "261301",
      "Kharwalia BO": "261301",
      "Sarwa BO": "261301",
      "Unchakhera Ajai BO": "261301",
      "Bilauli Nankari BO": "261201",
      "Dhoukalganj BO": "261201",
      "Gurera BO": "261201",
      "Kauwa Khera BO": "261201",
      "Keoty Badullah BO": "261201",
      "Kotra BO": "261201",
      "Lashkarpur BO": "261201",
      "Pokhra Kalan BO": "261201",
      "Ramabhari BO": "261201",
      "Belamau Kalan BO": "261121",
      "Dateli BO": "261121",
      "Gurdhapa BO": "261121",
      "Hargaon ND BO": "261121",
      "Kusuma BO": "261121",
      "Mudikhera BO": "261121",
      "Bizwar BO": "261125",
      "Shah Maholi BO": "261125",
      "Sonari BO": "261125",
      "Adwari BO": "261202",
      "Basudaha BO": "261202",
      "Sonawan BO": "261208",
      "Sujawalpur BO": "261208",
      "Newada BO": "261121",
      "Umari BO": "261121",
      "Gauria Kalan BO": "261125",
      "Mubarakpur Udaipur BO": "261125",
      "Nauwa Mahmoodpur BO": "261125",
      "Bhainsaha BO": "261202",
      "Chandraseni BO": "261202",
      "Supauli BO": "261202",
      "Lalpur BO": "261136",
      "Maror BO": "261136",
      "Sakaran BO": "261136",
      "Sumrawan BO": "261136",
      "Angarasi Shekhwapur BO": "261207",
      "Gauria Jhal BO": "261207",
      "Kaimahra BO": "261207",
      "Parsendi BO": "261207",
      "Teola BO": "261207",
      "Behta Pakauri BO": "261208",
      "Govindapur BO": "261208",
      "Ramuwapur BO": "261208",
      "Salpur BO": "261208",
      "Manwa BO": "261303",
      "Terwa BO": "261303",
      "Dhourahra BO": "261136",
      "Itauwa BO": "261136",
      "Sitarasoi BO": "261303",
      "Imaliya Sultanpur BO": "261001",
      "Mainasi Saraiyan BO": "261001",
      "Lilsi BO": "261001",
      "Sahsapur BO": "261001",
      "Kusepa BO": "261136",
      "Lakhuwabehar BO": "261136",
      "Maithaura BO": "261136",
      "Matuwa Saraiyan BO": "261136",
      "Sonsari BO": "261136",
      "Tanda Kalan BO": "261136",
      "Dhondhi BO": "261207",
      "Itari BO": "261207",
      "Ajaipur BO": "261208",
      "Biswan Khurd BO": "261208",
      "Rehar BO": "261208",
      "Kalabahadurpur BO": "261207",
      "Kasraila Bazar BO": "261207",
      "Kazi Sarain BO": "261207",
      "Makhpur Jareli BO": "261207",
      "Mubarakpur BO": "261207",
      "Samaisa BO": "261207",
      "Hazaratpur BO": "261208",
      "Kathura BO": "261208",
      "Mallapur BO": "261208",
      "Mudila BO": "261208",
      "Humaunpur BO": "261001",
      "Chinhara BO": "261001",
      "Indrauli BO": "261001",
      "Daranagar BO": "261001",
      "Dhouremau BO": "261001",
      "Angarasi BO": "261001",
      "Ailiya BO": "261001",
      "Ramkot BO": "261001",
      "Belgawan BO": "261001",
      "Mahadeo Atra BO": "262721",
      "Nakia Khera BO": "261505",
      "Sitapur HO": "261001",
      "Alamnagar SO": "261001",
      "Avas Vikas Colony SO Sitapur": "261001",
      "Bhandia SO": "261301",
      "Biswan SO": "261201",
      "Husainganj SO Sitapur": "261125",
      "Lohar Bagh SO": "261001",
      "Mahmudabad SO": "261203",
      "Maholi SO": "261141",
      "Mishrikh SO": "261401",
      "Rampur Mathura SO": "261204",
      "Reosa SO": "261205",
      "Singhnapur SO": "261136",
      "Sitapur City SO": "261001",
      "Sitapur Kutchehry SO": "261001",
      "Talgaon SO": "261207",
      "Bus Stand SO": "261001",
      "Eye Hospital SO": "261001",
      "Jail Road SO Sitapur": "261001",
      "Kamlapur SO Sitapur": "261302",
      "Laharpur SO": "261135",
      "Manpur SO Sitapur": "261145",
      "OLD TOWN SO": "261001",
      "Parsada SO": "261404",
      "Pisawan SO": "261151",
      "Aurangabad SO Sitapur": "261403",
      "Machharehta SO": "261405",
      "Nai Basti SO Sitapur": "261001",
      "Naimisharanya SO": "261402",
      "Sidhauli SO": "261303",
      "Tambour SO": "261208",
      "Vijay Laxmi Nagar SO": "261001",
      "27 Bn PAC SO": "261001",
      "HS Mills SO": "261121",
      "Jahangirabad SO Sitapur": "261202",
      "Khairabad SO Sitapur": "261131",
      "Mishrikh Tirth SO": "261401",
      "RPV SO": "261001",
      "Saraiyan Raja Saheb SO": "261206",
      "Second Bn PAC SO": "261001",
      "Xi Bn PAC SO": "261001",
      "Naveen Mandi SO": "261001"
    },
    "BHADOHI": {
      "Ghosiya BO": "221301",
      "Hridaipur BO": "221301",
      "Kurauna BO": "221301",
      "Asanao Bazar BO": "221401",
      "Munsiladpur BO": "221401",
      "Pipris BO": "221401",
      "Dasharthpur BO": "221304",
      "Laxamanpatti BO": "221304",
      "Koilara BO": "221306",
      "Baripur BO": "221309",
      "Berawa Paharpur BO": "221309",
      "Chhechhuwan BO": "221309",
      "Dhantulsi BO": "221309",
      "Narepar Sitamarhi BO": "221309",
      "Dwarikapur BO": "221314",
      "Darunaha BO": "221402",
      "Domanpur BO": "221402",
      "Abhiya BO": "221404",
      "Abholi BO": "221404",
      "Kador BO": "221404",
      "Matethu BO": "221404",
      "Sarroi BO": "221401",
      "Jagannathpur BO": "221303",
      "RS Dham BO": "221303",
      "Chakkisundas BO": "221304",
      "Nathaipur BO": "221304",
      "Sadopur BO": "221304",
      "Sagarraipur BO": "221310",
      "Suryabhanpur BO": "221310",
      "Sahasepur BO": "221306",
      "Ithara BO": "221309",
      "Girdbaragaon BO": "221314",
      "Saripur BO": "221314",
      "Babusarai BO": "221314",
      "Amilauri BO": "221406",
      "Kukarauthi BO": "221409",
      "Birampur BO": "221308",
      "Sudhwai BO": "221308",
      "Amawa Khurd BO": "221402",
      "Bhagawanpur Kanhari BO": "221402",
      "Bhikharirampur BO": "221404",
      "Durgaganj BO": "221404",
      "Gaura BO": "221404",
      "Sanda BO": "221404",
      "Pipargaon BO": "221301",
      "Ugapur BO": "221301",
      "Raya BO": "221401",
      "Uchetha BO": "221401",
      "Loharakhas BO": "221303",
      "Tilanga BO": "221303",
      "Achhawar BO": "221304",
      "Pali BO": "221304",
      "Ramampur BO": "221304",
      "Sarairajputani BO": "221304",
      "Semradh BO": "221310",
      "Pakhawaiya BO": "221306",
      "Digh BO": "221309",
      "Katra Bazar BO": "221309",
      "Sarawatkhani BO": "221314",
      "Umarha BO": "221314",
      "Ajaipur BO": "221406",
      "Kariyaon BO": "221406",
      "Bayaon BO": "221308",
      "Bichhiya BO": "221308",
      "Rohi BO": "221308",
      "Bahari BO": "221402",
      "Barawa Bazar BO": "221402",
      "Palhaiya BO": "221402",
      "Abarana BO": "221404",
      "Bhori BO": "221404",
      "Bisauli Kripalpur BO": "221404",
      "Ekauni BO": "221404",
      "Sarai Kansrai BO": "221404",
      "Amilaur BO": "221303",
      "Bairibisa BO": "221303",
      "Bhawanipur BO": "221303",
      "Dhirpur BO": "221303",
      "Chaksundarpur BO": "221304",
      "Baragaon BO": "221310",
      "Darawasi BO": "221310",
      "Ibrhimpur Uparwar BO": "221310",
      "Purani Bazar BO": "221406",
      "Puregareria BO": "221406",
      "Pargaspur BO": "221409",
      "Gohilaon BO": "221402",
      "Jhauwa BO": "221402",
      "Bauribojh BO": "221404",
      "Bhanda BO": "221404",
      "Patti Bejaon BO": "221404",
      "Gopiganj SO": "221303",
      "Gyanpur SO": "221304",
      "Parsipur SO": "221402",
      "Aurai SO Sant Ravidas Nagar": "221301",
      "Bhadohi SO": "221401",
      "Koirauna SO": "221309",
      "Mondh SO": "221406",
      "Ozh SO": "221308",
      "Katra Bazar SO Varanasi": "221401",
      "Nai Bazar SO Sant Ravidas Nagar": "221409",
      "Suriyawan SO": "221404",
      "Jangiganj SO": "221310",
      "Khamaria SO Varanasi": "221306",
      "Mahrajganj SO Sant Ravidas Nagar": "221314"
    }
  },
  "KARNATAKA": {
    "BIDAR": {
      "MANHALLI  S.O": "585447",
      "Aliabad B.O": "585404",
      "Hangarga(B) B.O": "585326",
      "Alandi B.O": "585328",
      "Ambesangvi B.O": "585328",
      "Halsi (L) B.O": "585411",
      "Gadgi B.O": "585402",
      "Janwada B.O": "585402",
      "Markhal B.O": "585414",
      "Yernalli B.O": "585402",
      "Chidri B.O": "585403",
      "Chintalgera B.O": "585403",
      "Chitta B.O": "585403",
      "Malegaon B.O": "585403",
      "Malkapur B.O": "585403",
      "Walkhindi B.O": "585412",
      "Dhannura (H) B.O": "585413",
      "Janthi B.O": "585413",
      "Kappargaon B.O": "585329",
      "Attarga B.O": "585416",
      "Bolegaon B.O": "585416",
      "Badalgaon B.O": "585326",
      "Chintaki B.O": "585326",
      "Ekamba B.O": "585445",
      "Kherda (A) B.O": "585326",
      "Mohmadapur B.O": "585326",
      "Nandi Bijalgaon B.O": "585326",
      "Sawargaon B.O": "585326",
      "Basavakalyan Eng College B.O": "585327",
      "Bet Balkunda B.O": "585327",
      "Morkhandi B.O": "585327",
      "Muchlam B.O": "585327",
      "Toglur B.O": "585327",
      "Beeri (K) B.O": "585328",
      "Dadgi B.O": "585328",
      "Dongapur B.O": "585328",
      "Kurubkhelagi B.O": "585328",
      "Bhatasangvi B.O": "585411",
      "Madkatti B.O": "585411",
      "Methi Melkunda B.O": "585411",
      "Bakchowdi B.O": "585402",
      "Kaplapur (A) B.O": "585402",
      "Secundrapur B.O": "585402",
      "Astoor B.O": "585403",
      "Haladkeri B.O": "585403",
      "Hokrana (K) B.O": "585403",
      "Rajgira B.O": "585403",
      "Yakatpur B.O": "585403",
      "Belkhera B.O": "585412",
      "Ghodwadi B.O": "585418",
      "Kumar Chincholli B.O": "585418",
      "Kanji B.O": "585413",
      "Kon Melkunda B.O": "585413",
      "Maroor B.O": "585413",
      "Dakulgi B.O": "585415",
      "Mangalgi B.O": "585329",
      "Nandgaon B.O": "585329",
      "Halsi Tugaon B.O": "585416",
      "Jamkhandi B.O": "585416",
      "Chordapka B.O": "585326",
      "Eklera B.O": "585326",
      "Hokarana B.O": "585326",
      "Belura B.O": "585327",
      "Dhannura(K) B.O": "585327",
      "Kitta B.O": "585327",
      "Beeri (B) B.O": "585328",
      "Bhalki Town B.O": "585328",
      "Jaigaon B.O": "585328",
      "Khatak Chincholli B.O": "585328",
      "Morambi B.O": "585328",
      "Gorchincholli B.O": "585411",
      "Seoni  B.O": "585411",
      "Aliember B.O": "585402",
      "Andur B.O": "585402",
      "K.H.B. Colony Bidar B.O": "585402",
      "Kolhar (K) B.O": "585402",
      "Rajnal B.O": "585402",
      "Srimandal B.O": "585402",
      "Baroor B.O": "585403",
      "Chillargi B.O": "585403",
      "Goonalli B.O": "585403",
      "Mailoor B.O": "585403",
      "Sindol B.O": "585403",
      "Tadpalli B.O": "585403",
      "Banhalli B.O": "585412",
      "Handikera B.O": "585418",
      "Othagi B.O": "585418",
      "Joldapka B.O": "585413",
      "Chalakapur B.O": "585414",
      "Masimadu B.O": "585414",
      "Byalhalli B.O": "585415",
      "Halhalli (K) B.O": "585415",
      "Madargaon B.O": "585329",
      "Nagankhera B.O": "585329",
      "Goundgaon B.O": "585416",
      "Kesar Jawalga B.O": "585416",
      "Bawalgaon B.O": "585326",
      "Bhandarkumta B.O": "585326",
      "Bonthi B.O": "585326",
      "Chikli (U) B.O": "585326",
      "Kollur (A) B.O": "585326",
      "Mugnal B.O": "585326",
      "Nagmarpalli B.O": "585326",
      "Raipalli B.O": "585326",
      "Sundal B.O": "585326",
      "Yengunda B.O": "585326",
      "Gorta (B) B.O": "585327",
      "Gour B.O": "585327",
      "Kadepur B.O": "585327",
      "Khanapur (K) B.O": "585327",
      "Narayanpur B.O": "585327",
      "Partapur B.O": "585327",
      "Sastapur B.O": "585327",
      "Dawargaon B.O": "585328",
      "Talwada (M) B.O": "585328",
      "Telgaon B.O": "585328",
      "Warwatti (B) B.O": "585328",
      "Yenkura B.O": "585328",
      "Kalsar Tugaon B.O": "585411",
      "Ladha (B) B.O": "585411",
      "Lakhangaon B.O": "585411",
      "Chambol B.O": "585402",
      "Chimkod B.O": "585402",
      "Amlapur B.O": "585403",
      "Manhalli B.O": "585403",
      "Nagora B.O": "585403",
      "Itga B.O": "585412",
      "Kodambal B.O": "585412",
      "Mustari B.O": "585412",
      "Udbal B.O": "585412",
      "Chandanhalli B.O": "585418",
      "Ghatboral B.O": "585418",
      "Hunsnal B.O": "585418",
      "Jalsangi B.O": "585418",
      "Mugnoor B.O": "585418",
      "Sultanbad B.O": "585418",
      "Kardyal B.O": "585413",
      "Kosam B.O": "585413",
      "Malchapur B.O": "585413",
      "Rudnoor B.O": "585413",
      "Siddeshwar B.O": "585413",
      "Talwada (K) B.O": "585413",
      "Alura B.O": "585414",
      "Benchincholli B.O": "585414",
      "Sinbandgi B.O": "585415",
      "Tugaon (C) Katti B.O": "585415",
      "Ranjol Kheni B.O": "585329",
      "Sirkatnalli B.O": "585329",
      "Sitalgera B.O": "585329",
      "Talmadgi B.O": "585329",
      "Alwai B.O": "585416",
      "Muttangi B.O": "585227",
      "Udamnalli B.O": "585227",
      "Chandakapur B.O": "585419",
      "Chitta (K) B.O": "585419",
      "Ghotala B.O": "585327",
      "Yelladgundi B.O": "585445",
      "Harkud B.O": "585437",
      "Hipparga Ghat B.O": "585437",
      "Maisalga B.O": "585437",
      "Chandori B.O": "585443",
      "Karkyal B.O": "585443",
      "Hupla B.O": "585444",
      "Nirgudi B.O": "585331",
      "Chikli (J) B.O": "585421",
      "Jamgi B.O": "585421",
      "Ladha (A) B.O": "585421",
      "Wadgaon (D) B.O": "585421",
      "Bedkunda B.O": "585436",
      "Halhalli B.O": "585436",
      "Hippalgaon(A) B.O": "585436",
      "Changler B.O": "585227",
      "Karaknalli B.O": "585227",
      "Madargi B.O": "585227",
      "Markunda B.O": "585227",
      "Rekulgi B.O": "585227",
      "Algood B.O": "585445",
      "Betgera B.O": "585445",
      "Bhosga B.O": "585445",
      "Gundoor B.O": "585419",
      "Hattarga B.O": "585445",
      "Honalli B.O": "585419",
      "Jajanmugali B.O": "585327",
      "Ladwanti B.O": "585445",
      "Kalkhora B.O": "585437",
      "Kherda B.O": "585437",
      "Kinni B.O": "585437",
      "Korekal B.O": "585443",
      "Torna B.O": "585443",
      "Pandargera B.O": "585331",
      "Rajola B.O": "585331",
      "Shembelli B.O": "585421",
      "Surhalli B.O": "585421",
      "Ujani B.O": "585421",
      "Maskal B.O": "585436",
      "Nidoda B.O": "585436",
      "Bembalgi B.O": "585227",
      "Meenkera B.O": "585227",
      "Nirna B.O": "585227",
      "Ujlam B.O": "585419",
      "Hipparga Bagh B.O": "585437",
      "Hirenagaon B.O": "585437",
      "Belkoni (M) B.O": "585443",
      "Chimegaon B.O": "585443",
      "Balur B.O": "585444",
      "Hajnal B.O": "585444",
      "Islampur B.O": "585331",
      "Yerbagh B.O": "585331",
      "Dhupat Mahagaon B.O": "585421",
      "Medpalli B.O": "585421",
      "Belkoni B.O": "585436",
      "Hedgapur B.O": "585436",
      "Halli B.O": "585419",
      "Chiknagaon B.O": "585437",
      "Gadlegaon B.O": "585437",
      "Yeklera B.O": "585437",
      "Yerandi B.O": "585437",
      "Ahmadabad B.O": "585444",
      "Chandapur B.O": "585444",
      "Rola B.O": "585331",
      "Tadola B.O": "585331",
      "Jojana B.O": "585421",
      "Kawadgaon B.O": "585421",
      "Koutha (B) B.O": "585421",
      "Kushnoor Gadi B.O": "585421",
      "Balat (K) B.O": "585436",
      "Saigaon B.O": "585416",
      "Dhannura (R) B.O": "585330",
      "Kallur B.O": "585330",
      "Diggi B.O": "585417",
      "Holsamunder B.O": "585417",
      "Madnoor B.O": "585417",
      "Sangam B.O": "585417",
      "Bagdal B.O": "585226",
      "Bhairnalli B.O": "585226",
      "Yedlapur B.O": "585226",
      "Gadwanti B.O": "585353",
      "Bemalkhed B.O": "585227",
      "Hallikhed (K) B.O": "585330",
      "Sindankera B.O": "585330",
      "Horandi B.O": "585417",
      "Kalgapur B.O": "585417",
      "Murki B.O": "585417",
      "Sawali B.O": "585417",
      "Aurad (S) B.O": "585226",
      "Bawgi B.O": "585226",
      "Budhera B.O": "585226",
      "Sangolgi B.O": "585226",
      "Veterinary Univ. Campus B.O": "585226",
      "Dhumansur B.O": "585353",
      "Hunsgera B.O": "585353",
      "Mehkar B.O": "585416",
      "Mirkhal B.O": "585416",
      "Wanjarkhed B.O": "585416",
      "Hankuni B.O": "585330",
      "Humnabad Industrial Area B.O": "585330",
      "Chandeshwar B.O": "585417",
      "Dongam (M) B.O": "585417",
      "Sonala B.O": "585417",
      "Chatnalli B.O": "585226",
      "Kadwad B.O": "585226",
      "Khasampur B.O": "585226",
      "Mandaknalli B.O": "585226",
      "Kankatta B.O": "585353",
      "Sedol B.O": "585353",
      "Hulsoor Khed B.O": "585417",
      "Khatgaon B.O": "585417",
      "Kotgyal B.O": "585417",
      "Sirsi (A) B.O": "585226",
      "Bidar H.O": "585401",
      "Aurad (B) S.O": "585326",
      "Bidar G.N.Jhira S.O": "585402",
      "Bidar Gandhi Gunj S.O": "585403",
      "Bidar Osman Gunj S.O": "585401",
      "C B College S.O": "585328",
      "Dubalgundi S.O": "585418",
      "Hallikhed SF S.O": "585415",
      "Humnabad S.O": "585330",
      "Kamalnagar S.O": "585417",
      "Siddharudh Math Area S.O": "585403",
      "Bidar Shah Gunj S.O": "585401",
      "Halbarga S.O": "585413",
      "Hulsoor S.O": "585416",
      "Thanna Kushnoor S.O": "585436",
      "Basavakalyan Bazar S.O": "585327",
      "Bhalki S.O": "585328",
      "Chitguppa S.O": "585412",
      "Hoodgi S.O": "585329",
      "IAF Stn  S.O": "585401",
      "Mannakhelli S.O": "585227",
      "Mudbi S.O": "585437",
      "Nittur S.O": "585444",
      "Rajeshwar S.O": "585331",
      "Basavakalyan S.O": "585327",
      "Bhatambra S.O": "585411",
      "Hallikhed (B) S.O": "585414",
      "Kamthana S.O": "585226",
      "Maniknagar S.O": "585353",
      "Matala S.O": "585419",
      "Mudhol (B) S.O": "585443",
      "Santhpur S.O": "585421",
      "KOHINOOR SO": "585445",
      "Naubad SO": "585404"
    },
    "DAKSHINA KANNADA": {
      "Bajal S.O": "575009",
      "Karnoor B.O": "574313",
      "Kallige B.O": "574219",
      "Polali B.O": "574219",
      "Kutrupady B.O": "574221",
      "Noojibalthila B.O": "574221",
      "Renjilady B.O": "574221",
      "Veerakamba B.O": "574222",
      "Puthila B.O": "574326",
      "Nala B.O": "574217",
      "Padangady B.O": "574217",
      "Pilya B.O": "574217",
      "Sirlalu B.O": "574217",
      "Tenkakarandur B.O": "574217",
      "Vodilnala B.O": "574217",
      "Hariharapallathadka B.O": "574218",
      "Kalmakar B.O": "574218",
      "Kamila B.O": "574218",
      "Kollamogru B.O": "574218",
      "Ammunje B.O": "574219",
      "Badagabellur B.O": "574219",
      "Kodimbala B.O": "574221",
      "Uli B.O": "574326",
      "Uruvalu B.O": "574326",
      "Murulya B.O": "574328",
      "Yenmur B.O": "574328",
      "Shishila B.O": "574198",
      "Tannirpantha B.O": "574326",
      "Kanakamajal B.O": "574223",
      "Pernaje B.O": "574223",
      "Gerukatte B.O": "574217",
      "Kaniyur(Beltangady) B.O": "574217",
      "Devachalla B.O": "574218",
      "Madappady B.O": "574218",
      "Belloor B.O": "574219",
      "Kedila B.O": "574220",
      "Padnur B.O": "574220",
      "Ballya B.O": "574221",
      "Karingana B.O": "574222",
      "Bandar B.O": "574326",
      "Barya B.O": "574326",
      "Charvaka B.O": "574328",
      "Ariadka B.O": "574223",
      "Arasinamakki B.O": "574198",
      "Shibaje B.O": "574198",
      "Machina B.O": "574224",
      "Balugodu B.O": "574218",
      "Nadugallu B.O": "574218",
      "Soole Padavu B.O": "574313",
      "Benjanapadavu B.O": "574219",
      "Modankap B.O": "574219",
      "Idkidu B.O": "574220",
      "Kudippady B.O": "574220",
      "Yedamangala B.O": "574221",
      "Bolanthuru B.O": "574222",
      "Kodapadavu B.O": "574222",
      "Karaya B.O": "574326",
      "Bobbekri B.O": "574328",
      "Dolpady B.O": "574328",
      "Karopady B.O": "574279",
      "Kudupallathadka B.O": "574279",
      "Badagannur B.O": "574223",
      "Petrame B.O": "574198",
      "Kuvettu B.O": "574224",
      "Barebettu B.O": "574323",
      "Ananthady B.O": "574253",
      "Kagekana B.O": "574253",
      "Kakkinje B.O": "574228",
      "Thotathady B.O": "574228",
      "Bannur B.O": "574203",
      "Perne B.O": "574325",
      "Gundia B.O": "574229",
      "Shirady B.O": "574229",
      "Kombar B.O": "574230",
      "Sunkadakatte B.O": "574230",
      "Sajipamunnur B.O": "574231",
      "Sajipapadu B.O": "574231",
      "Kuthkunja B.O": "574232",
      "Goonadka B.O": "574234",
      "Alike B.O": "574235",
      "Karpe B.O": "574237",
      "Devarahalli B.O": "574238",
      "Aivernad B.O": "574239",
      "Ajjavara B.O": "574239",
      "Peral B.O": "574239",
      "Haleneranky B.O": "574241",
      "Thekkar B.O": "574241",
      "Volalu B.O": "574241",
      "Dandegoli B.O": "574324",
      "Neerkaje B.O": "574243",
      "Puncha B.O": "574243",
      "Mudupadukodi B.O": "574265",
      "Banangady B.O": "574274",
      "Kudripadavu B.O": "574274",
      "Gandibagilu B.O": "574228",
      "Kadirudyavara B.O": "574228",
      "Kalmanja B.O": "574228",
      "Ichilampady B.O": "574229",
      "Konalu B.O": "574229",
      "Rekya B.O": "574229",
      "Kaddya B.O": "574230",
      "Bettampady B.O": "574259",
      "Irde B.O": "574259",
      "Nidpalli B.O": "574259",
      "Shamboor B.O": "574231",
      "Bilinele B.O": "574238",
      "Duggaladka B.O": "574239",
      "Jalsur B.O": "574239",
      "Belal B.O": "574240",
      "Kanyadi B.O": "574240",
      "Hirebandady B.O": "574241",
      "Ilanthila B.O": "574241",
      "Ajjibettu B.O": "574324",
      "Kudambettu B.O": "574324",
      "Mavinakatte B.O": "574324",
      "Vittal Mudnoor B.O": "574243",
      "Kadabettu B.O": "574265",
      "Karinje B.O": "574265",
      "Kavalkatte B.O": "574265",
      "Maninalkur B.O": "574265",
      "Niddodi B.O": "574274",
      "Malady B.O": "574224",
      "IRA B.O": "574323",
      "Balthila B.O": "574253",
      "Neralakatte B.O": "574253",
      "Charmadi B.O": "574228",
      "Neria B.O": "574228",
      "Kodimbady B.O": "574325",
      "Golithattu B.O": "574229",
      "Mardala B.O": "574230",
      "Sajipamudu B.O": "574231",
      "Sajipanadu B.O": "574231",
      "Pambethady B.O": "574232",
      "Badagakajekar B.O": "574233",
      "Nainad B.O": "574233",
      "Arambody B.O": "574237",
      "Puchamogru B.O": "574237",
      "Yenekal B.O": "574238",
      "Aletty B.O": "574239",
      "Sonangeri B.O": "574239",
      "Sullia Gandhi Nagar B.O": "574239",
      "Bajathur B.O": "574241",
      "Ramakunja B.O": "574241",
      "Biliyoorkatte B.O": "574243",
      "Nayarmoole B.O": "574243",
      "Odiyoor B.O": "574243",
      "Panakaje B.O": "574224",
      "Kolnadu B.O": "574323",
      "Kulalu B.O": "574323",
      "Salethur B.O": "574323",
      "Borimar B.O": "574253",
      "Budoli B.O": "574253",
      "Chickmudnoor B.O": "574203",
      "Ujirpade B.O": "574203",
      "Biliyoor B.O": "574325",
      "Kadeshwalya B.O": "574325",
      "Peramogru B.O": "574325",
      "Narikombu B.O": "574231",
      "Balpa B.O": "574232",
      "Karikala B.O": "574232",
      "Kenya B.O": "574232",
      "Tenkakajekar B.O": "574233",
      "Kolchar B.O": "574239",
      "Mandekole B.O": "574239",
      "Old Town Ujire B.O": "574240",
      "Koila Cattle Farm(K.C. Farm) B.O": "574241",
      "Mogru B.O": "574241",
      "Kodangai B.O": "574243",
      "Kula B.O": "574243",
      "Mangalapadavu B.O": "574243",
      "Murva B.O": "574243",
      "Paladka B.O": "574226",
      "Nellikar B.O": "574107",
      "Maroor B.O": "574197",
      "Marody B.O": "574236",
      "Kadandale B.O": "574226",
      "Alangar B.O": "574227",
      "Ashwathapura B.O": "574227",
      "Sampige B.O": "574227",
      "Padukonaje B.O": "574236",
      "Kokrady B.O": "574242",
      "Hosabettu B.O": "574227",
      "Kutlur B.O": "574109",
      "Sulkeri B.O": "574109",
      "Perady B.O": "574236",
      "Agrar B.O": "574211",
      "Sarapady B.O": "574211",
      "Sornad B.O": "574211",
      "Kukkujadka B.O": "574212",
      "Manikar B.O": "574212",
      "Perlampady B.O": "574212",
      "Bangady B.O": "574214",
      "Killur B.O": "574214",
      "Navoor(Belt) B.O": "574214",
      "Bolwar B.O": "574201",
      "Peranja B.O": "574197",
      "Thodar B.O": "574227",
      "Kashipatna B.O": "574236",
      "Mantrady B.O": "574236",
      "Andinje B.O": "574242",
      "Bajre B.O": "574242",
      "Nittade B.O": "574242",
      "Savya B.O": "574242",
      "Sharavoor B.O": "574285",
      "Kaikara B.O": "574210",
      "Kedambady B.O": "574210",
      "Kumbra B.O": "574210",
      "Kuriya B.O": "574210",
      "Amtady B.O": "574211",
      "Jakribettu B.O": "574211",
      "Koila B.O": "574211",
      "Balila B.O": "574212",
      "Permanu B.O": "574214",
      "Savanal B.O": "574214",
      "Narimogru B.O": "574202",
      "Punchappady B.O": "574202",
      "Savanur(Puttur) B.O": "574202",
      "Bollaje B.O": "574248",
      "Mundur B.O": "574202",
      "Shanthigodu B.O": "574202",
      "Mottethadka B.O": "574202",
      "Puduvettu B.O": "574216",
      "Nellur Kemraje B.O": "574248",
      "Pailar B.O": "574248",
      "Kukkedy B.O": "574242",
      "Peruvai B.O": "574260",
      "Perabe B.O": "574285",
      "Aramboor B.O": "574314",
      "Thodikana B.O": "574314",
      "Palthady B.O": "574210",
      "Allipade B.O": "574211",
      "Arla B.O": "574211",
      "Kuriyala B.O": "574211",
      "Panjikal B.O": "574211",
      "Kalanja B.O": "574212",
      "Kodiyala B.O": "574212",
      "Peruvaje B.O": "574212",
      "Malavanthige B.O": "574214",
      "Kaimana B.O": "574202",
      "Sarve B.O": "574202",
      "Kayarthadka B.O": "574216",
      "Nidle B.O": "574216",
      "Samedakalapu B.O": "574216",
      "Markanja B.O": "574248",
      "Ubbaradka Mithur B.O": "574248",
      "Gardady B.O": "574217",
      "Kallabettu B.O": "574197",
      "Taccode B.O": "574197",
      "Valpady B.O": "574236",
      "Karimanel B.O": "574242",
      "Mudukodi B.O": "574242",
      "Moodambail B.O": "574260",
      "Darbethadka B.O": "574210",
      "Madav B.O": "574210",
      "Ajilamogru B.O": "574211",
      "Loretto B.O": "574211",
      "Navoor(Bantval) B.O": "574211",
      "Rayee B.O": "574211",
      "Chokkadi B.O": "574212",
      "Kalmadka B.O": "574212",
      "Mupperia B.O": "574212",
      "Mukkur B.O": "574212",
      "Koyyur B.O": "574214",
      "Laila B.O": "574214",
      "Melanthabettu B.O": "574214",
      "Kemminje B.O": "574202",
      "Kudmar B.O": "574202",
      "Aldangady B.O": "574217",
      "Moodumarnad B.O": "574213",
      "Padumarnad B.O": "574213",
      "Balanja B.O": "574217",
      "Daregudde B.O": "574213",
      "Kodmannu B.O": "574143",
      "Pudu B.O": "574143",
      "Kompadavu B.O": "574144",
      "Mogaru B.O": "574144",
      "Kandavara B.O": "574151",
      "Balepuni B.O": "574153",
      "Assaigoli B.O": "574199",
      "Adyar B.O": "575007",
      "Padu B.O": "575029",
      "Kollur B.O": "574141",
      "Kalavara B.O": "574142",
      "Neerude B.O": "574144",
      "Malalipanchayath B.O": "574151",
      "Muduperar B.O": "574151",
      "Kairangala B.O": "574153",
      "Montepadavu B.O": "574153",
      "Nagori B.O": "575007",
      "Mallur B.O": "575029",
      "Kinya B.O": "575023",
      "Talapady B.O": "575023",
      "Moodushedde B.O": "575028",
      "Adyapady B.O": "574142",
      "Chelairu B.O": "574146",
      "Kemral Panchayat B.O": "574146",
      "Koikude B.O": "574146",
      "Panjinadka B.O": "574154",
      "Madhya B.O": "575030",
      "Surinje B.O": "575030",
      "Punaroor B.O": "574150",
      "Kakva B.O": "574154",
      "Karnire B.O": "574154",
      "Krishnapura B.O": "575014",
      "Kolambe B.O": "574142",
      "Mukka B.O": "574146",
      "Sasihithlu B.O": "574146",
      "Chitrapu B.O": "574154",
      "Bala B.O": "575030",
      "Kuthethur B.O": "575030",
      "Kunjathbail B.O": "575015",
      "Nadugodu B.O": "574150",
      "Panjimogaru B.O": "575013",
      "Kavathar B.O": "574154",
      "Mulki East B.O": "574154",
      "Meenakaliya B.O": "575010",
      "Yekkar B.O": "574509",
      "Mangalanthi B.O": "575018",
      "Naringana B.O": "575018",
      "Thumbe B.O": "574143",
      "Valachil B.O": "574143",
      "Iruvail B.O": "574144",
      "Kolavoor B.O": "574144",
      "Kuppepadavu B.O": "574144",
      "Addoor B.O": "574145",
      "Ulaibettu B.O": "574145",
      "Kumpala B.O": "575022",
      "Boliyar B.O": "574153",
      "Chelur B.O": "574153",
      "Konaje B.O": "574199",
      "PACE Campus B.O": "574199",
      "Pavur B.O": "574199",
      "Phajiru B.O": "574199",
      "Bajal B.O": "575007",
      "Jeppinamogaru B.O": "575007",
      "Kannur B.O": "575007",
      "Amblamogaru B.O": "575017",
      "Munnur B.O": "575017",
      "Kudupu B.O": "575028",
      "Elinje B.O": "574141",
      "Pejavara B.O": "574142",
      "Thokur B.O": "574146",
      "Elathur B.O": "574150",
      "Bondel B.O": "575008",
      "MSEZ Colony B.O": "575019",
      "Kenchanakere B.O": "574154",
      "Shimanthoor B.O": "574154",
      "Mermajal B.O": "574143",
      "Muchur B.O": "574144",
      "Sibrikere B.O": "574144",
      "Harekala B.O": "574199",
      "Bondanthila B.O": "575029",
      "Neermarga B.O": "575029",
      "Jokatte B.O": "575011",
      "Kenjar B.O": "574142",
      "Paduperar B.O": "574142",
      "Padupanambur B.O": "574146",
      "Athikaribettu B.O": "574154",
      "Delanthabettu B.O": "575030",
      "Kuthethur Bajav B.O": "575030",
      "Bikkarnakatte B.O": "575008",
      "Sandspit B.O": "575013",
      "Balkunje B.O": "574154",
      "Sadashivanagar B.O": "574154",
      "Puttur(D.K.) H.O": "574201",
      "Kulshekar H.O": "575005",
      "Mangaluru H.O": "575001",
      "Aryapu S.O": "574210",
      "Venur S.O": "574242",
      "Vidyagiri (Moodbidri) S.O": "574227",
      "Bantval S.O": "574211",
      "Bellare S.O": "574212",
      "Shirthady S.O": "574236",
      "Adyanadka S.O": "574260",
      "Alankar S.O": "574285",
      "Aranthodu S.O": "574314",
      "Belvai S.O": "574213",
      "Kodangallu S.O": "574197",
      "Doddathota S.O": "574248",
      "Guruvayanakere S.O": "574217",
      "Kalleri S.O": "574326",
      "Kav S.O": "574223",
      "Derlakatte S.O": "575018",
      "Padil S.O": "575007",
      "Shakthinagar (Dakshina Kannada) S.O": "575016",
      "Someshwar Uchil S.O": "575023",
      "Vamanjoor S.O": "575028",
      "Ashoknagar(MR) S.O": "575006",
      "Baikampady S.O": "575011",
      "Gandhinagar S.O (Dakshina Kannada)": "575003",
      "Kinnigoli S.O": "574150",
      "Konchady S.O": "575008",
      "Kulur S.O": "575013",
      "Mercara Hill S.O": "575002",
      "Panambur S.O": "575010",
      "Srinivasnagar S.O": "575025",
      "Court Hill(Puttur) S.O": "574201",
      "Dharmasthala S.O": "574216",
      "Jodumarga S.O": "574219",
      "Kabaka S.O": "574220",
      "Kadaba S.O (Dakshina Kannada)": "574221",
      "Kalladka S.O": "574222",
      "Kaniyur(Puttur) S.O": "574328",
      "Badagayedapadavu S.O": "574267",
      "Farangipet S.O": "574143",
      "Kinnikambla S.O": "574151",
      "Kotekar S.O": "575022",
      "Pedamale S.O": "575029",
      "Ullal S.O": "575020",
      "Aikala S.O": "574141",
      "Fisheries College S.O": "575002",
      "Haleangady S.O": "574146",
      "Hampankatta S.O": "575001",
      "Katipalla S.O": "575030",
      "Kavur S.O": "575015",
      "Kodiyalbail S.O": "575003",
      "Leewell S.O": "575001",
      "Mulki Bazar S.O": "574154",
      "Madanthyar S.O": "574224",
      "Mundaje S.O": "574228",
      "Nellyadi S.O": "574229",
      "Guthigar S.O": "574218",
      "Ishwaramangala S.O": "574313",
      "Kokkada S.O": "574198",
      "Kurunjibag S.O": "574327",
      "Manchi S.O": "574323",
      "Nekkilady(34) S.O": "574325",
      "Vittal S.O": "574243",
      "Vogga S.O": "574265",
      "Kallamundkur S.O": "574274",
      "Panja S.O": "574232",
      "Sathya Sai Vihar S.O": "574235",
      "Siddakatte S.O": "574237",
      "Sullia S.O": "574239",
      "Ujire S.O": "574240",
      "Belthangady S.O": "574214",
      "Darbe(Puttur) S.O": "574202",
      "Kanyana S.O": "574279",
      "Mani S.O": "574253",
      "Nehrunagar(Puttur DK) S.O": "574203",
      "Nettana S.O": "574230",
      "S.D.M.C.Ujire S.O": "574240",
      "Subramanya S.O": "574238",
      "Uppinangady S.O": "574241",
      "Vamadapadavu S.O": "574324",
      "Ganjimat S.O": "574144",
      "Kurnad S.O": "574153",
      "Mangalagangothri S.O": "574199",
      "Bajpe Airport S.O": "574142",
      "Bajpe S.O": "574142",
      "Balmatta S.O": "575002",
      "Mijar S.O": "574225",
      "Moodbidri S.O": "574227",
      "Naravi S.O": "574109",
      "Panaje S.O": "574259",
      "Mithabail S.O": "574226",
      "Bijai S.O": "575004",
      "Boloor S.O": "575003",
      "Karnad S.O": "574154",
      "Kateel S.O": "574148",
      "Mangaluru Collectorate S.O": "575001",
      "Mulki S.O": "574154",
      "Surathkal S.O": "575014",
      "Gurpur S.O": "574145",
      "Permannur S.O": "575017",
      "District Courts S.O (Dakshina Kannada)": "575003",
      "Falnir S.O": "575001",
      "Kankanady S.O": "575002",
      "Kulai S.O": "575019",
      "Permude S.O": "574509",
      "Panemangalore S.O": "574231",
      "Punjalkatte S.O": "574233"
    },
    "HASSAN": {
      "Aggunda B.O": "573103",
      "Amaragiri Tirupathi B.O": "573103",
      "Belagumba B.O": "573103",
      "Dummenahalli B.O": "573103",
      "Basavaghatta B.O": "573162",
      "Kittankere B.O": "573162",
      "Ponnasamudra B.O": "573103",
      "Shankaranahalli B.O": "573128",
      "Sulekere B.O": "573103",
      "T.Kodihalli B.O": "573103",
      "Talalur B.O": "573103",
      "Kunduru B.O": "573128",
      "Banavara R S B.O": "573112",
      "Basavanahalli B.O": "573136",
      "Shanegere B.O": "573112",
      "Thondiganahalli B.O": "573112",
      "Bendekere B.O": "573103",
      "Hiriyur B.O": "573103",
      "Kondavagilu B.O": "573103",
      "chikkur B.O": "573103",
      "Mylanahalli B.O": "573103",
      "Balaghatta B.O": "573111",
      "Obalapura B.O": "573111",
      "Chaluvanahalli B.O": "573112",
      "Bantenahalli B.O": "573115",
      "Cheekanahalli B.O": "573115",
      "Nagenahalli B.O": "573115",
      "Komaraghatta B.O": "573162",
      "Byadarahalli B.O": "573128",
      "Chowlagala B.O": "573111",
      "Arakere B.O": "573112",
      "Ballur B.O": "573115",
      "Iravalli B.O": "573115",
      "Karagada B.O": "573115",
      "Mandalamane B.O": "573115",
      "Kallanagere B.O": "573103",
      "Kuruvanka B.O": "573103",
      "Maratagere B.O": "573103",
      "Jajur B.O": "573103",
      "Kembalu B.O": "573111",
      "Maraghushivara B.O": "573111",
      "Nagasamudra B.O": "573112",
      "Bennur B.O": "573115",
      "Chikmedur B.O": "573115",
      "Dabbe B.O": "573115",
      "Gendehalli B.O": "573115",
      "Hanike B.O": "573115",
      "Yamasandhi B.O": "573115",
      "Adagur B.O": "573121",
      "Agrahara B.O": "573133",
      "Anekere B.O": "573116",
      "Shiragura B.O": "573115",
      "Dindagur B.O": "573116",
      "Sanyasihalli B.O": "573115",
      "Tolalu B.O": "573115",
      "Gollarahosahalli B.O": "573116",
      "Niduvani B.O": "573210",
      "Jodihandankere B.O": "573217",
      "Jodithattekere B.O": "573217",
      "Dundanayakanahalli B.O": "573128",
      "Ganjigere B.O": "573128",
      "Harihalli B.O": "573129",
      "Hemmige B.O": "573129",
      "Chikkahalli B.O": "573130",
      "Doddabemmathi B.O": "573130",
      "Handarangi B.O": "573130",
      "Markuli B.O": "573212",
      "Mosale B.O": "573212",
      "Muthigehirehalli B.O": "573212",
      "Sathenahalli B.O": "573212",
      "Kadabagala B.O": "573218",
      "Madabalu B.O": "573218",
      "Singapur B.O": "573211",
      "Singodanahalli B.O": "573218",
      "Doddahalli B.O": "573210",
      "Gangur B.O": "573133",
      "Anandur B.O": "573136",
      "Lakkur B.O": "573136",
      "Donigal B.O": "573134",
      "Halebelur B.O": "573134",
      "Nidigere B.O": "573134",
      "Shukravarasanthe B.O": "573134",
      "Kadaga B.O": "573219",
      "Kudrugundi B.O": "573219",
      "Gadenahalli B.O": "573226",
      "Hongere B.O": "573220",
      "Mavanur B.O": "573220",
      "Kumbarahalli B.O": "573137",
      "Uchangi B.O": "573137",
      "Kanagal B.O": "573217",
      "Settihalli B.O": "573128",
      "Rayarakoppal B.O": "573129",
      "Somanahalli B.O": "573136",
      "Kadavina Hosahalli B.O": "573130",
      "Kittane B.O": "573212",
      "Byrapura B.O": "573218",
      "Rudrapatna B.O": "573133",
      "Byakaravalli B.O": "573134",
      "Kumbaradi B.O": "573134",
      "Malali B.O": "573220",
      "Matasagara B.O": "573134",
      "Nittur B.O": "573219",
      "Shanka B.O": "573219",
      "Dyavalapura B.O": "573226",
      "Melagodu B.O": "573226",
      "Antharikshanagar B.O": "573202",
      "Eachalabeedu B.O": "573137",
      "Igoor B.O": "573137",
      "Halebelagola B.O": "573116",
      "Srinivaspura B.O": "573116",
      "Bindenahalli B.O": "573116",
      "Donanakatte B.O": "573117",
      "Dudda B.O": "573118",
      "Heragu B.O": "573118",
      "Valagerahalli B.O": "573131",
      "Heggatta B.O": "573119",
      "Kenkere B.O": "573119",
      "Mududi B.O": "573119",
      "Hebbalu B.O": "573121",
      "Rajanasiriyur B.O": "573121",
      "Sannenahalli B.O": "573121",
      "Deshani B.O": "573122",
      "Doddenahalli B.O": "573122",
      "Handralu B.O": "573122",
      "Kalyadi B.O": "573122",
      "Madanahalli B.O": "573125",
      "Hirisadarahalli B.O": "573144",
      "Kallugundi B.O": "573144",
      "Anathi B.O": "573131",
      "Kuppalli B.O": "573217",
      "Agile B.O": "573128",
      "Hanumanthapura B.O": "573128",
      "Bharathur B.O": "573129",
      "Kabbaligere B.O": "573130",
      "Kadanur B.O": "573130",
      "Kattepura B.O": "573130",
      "Saragur B.O": "573130",
      "Ambuga B.O": "573212",
      "Kowshika B.O": "573212",
      "Chigalli BO": "573212",
      "Hanchur B.O": "573218",
      "Anemahal B.O": "573134",
      "Arekere B.O": "573134",
      "Kadamane B.O": "573134",
      "Kyanahalli B.O": "573134",
      "Maranahalli B.O": "573134",
      "Halekoppalu B.O": "573219",
      "Tejur B.O": "573219",
      "Teranya B.O": "573220",
      "Hosur(SWP) B.O": "573137",
      "Kalale B.O": "573137",
      "Atthihalli B.O": "573131",
      "Baddikere B.O": "573131",
      "Bhuvanahalli B.O": "573131",
      "Kantharajapura B.O": "573135",
      "Kothanghatta B.O": "573135",
      "Kumbenahalli B.O": "573116",
      "Sundahalli B.O": "573135",
      "Vaddarahalli B.O": "573135",
      "Baragur B.O": "573225",
      "Dandiganahalli B.O": "573225",
      "Belluru B.O": "573213",
      "Hunsavalli B.O": "573213",
      "Kadalu B.O": "573213",
      "Kattimallenahalli B.O": "573102",
      "Malalikere B.O": "573102",
      "Abbana B.O": "573214",
      "Bage B.O": "573214",
      "Belagodu B.O": "573214",
      "Kesagodu B.O": "573215",
      "Halasulige B.O": "573127",
      "Ankanayakanahalli B.O": "573120",
      "Ankapura B.O": "573120",
      "Karle B.O": "573120",
      "Uduvare B.O": "573120",
      "Ibbeedu B.O": "573216",
      "Savasihalli B.O": "573216",
      "Ugane B.O": "573216",
      "Anekannambadi B.O": "573210",
      "Tatanahalli B.O": "573210",
      "Hadlahalli B.O": "573123",
      "Hongadahalla B.O": "573123",
      "Mageri B.O": "573123",
      "Valalahalli B.O": "573123",
      "Mavinakere B.O": "573211",
      "Mudalahippe B.O": "573211",
      "Nagarahalli B.O": "573164",
      "Paduvalahippe B.O": "573211",
      "Nelagahalli B.O": "573165",
      "Goddu B.O": "573123",
      "Vanagur B.O": "573123",
      "Beechanahalli B.O": "573211",
      "Doddakadanur B.O": "573211",
      "Haradanahalli B.O": "573211",
      "Keragodu B.O": "573211",
      "S Ankanahalli B.O": "573211",
      "Sravanur R S B.O": "573211",
      "Bylahalli B.O": "573217",
      "Gowdagere B.O": "573116",
      "Nallur B.O": "573116",
      "Tumakuru B.O": "573141",
      "Haralakatte B.O": "573117",
      "Madalu B.O": "573117",
      "Koravangala B.O": "573118",
      "Hullekere B.O": "573119",
      "Gonisomanahalli B.O": "573121",
      "Mathighatta B.O": "573124",
      "Murundi B.O": "573122",
      "Yadapura B.O": "573122",
      "Kolagunda B.O": "573125",
      "Nerlige B.O": "573125",
      "Kamasamudra B.O": "573126",
      "Ramanahalli B.O": "573126",
      "Chagachagere B.O": "573164",
      "Akkanahalli B.O": "573131",
      "Jambur B.O": "573131",
      "Navile B.O": "573131",
      "Santheshivara B.O": "573131",
      "Baralu B.O": "573135",
      "Chalya B.O": "573135",
      "Dammaningala B.O": "573135",
      "Madenur B.O": "573225",
      "Kanive Byadarahalli B.O": "573225",
      "Kanathur B.O": "573213",
      "Kiragadalu B.O": "573213",
      "Malasavara B.O": "573101",
      "Abburmachagowdanahalli B.O": "573102",
      "Aldahalli B.O": "573102",
      "Jodigubbi B.O": "573102",
      "Masarangala B.O": "573102",
      "Mugali B.O": "573214",
      "Hangal B.O": "573113",
      "Ankihalli B.O": "573215",
      "Kushavara B.O": "573215",
      "Malegere B.O": "573215",
      "Tagare B.O": "573215",
      "Sundekere B.O": "573127",
      "Heggadihalli B.O": "573142",
      "Malladevarapura B.O": "573120",
      "Channangihalli B.O": "573120",
      "Hullugundi B.O": "573216",
      "Madihalli B.O": "573216",
      "Yelahanka B.O": "573216",
      "Gulsinda B.O": "573116",
      "Mattanavile B.O": "573116",
      "Sagathavalli B.O": "573116",
      "Masakanahalli B.O": "573141",
      "K Kittankere B.O": "573117",
      "Attavara B.O": "573118",
      "Honnavara B.O": "573118",
      "Yadavanahalli B.O": "573119",
      "Ghattadahalli B.O": "573121",
      "Annaikanahalli B.O": "573122",
      "Kargunda B.O": "573122",
      "Undiganalu B.O": "573122",
      "Balaganchi B.O": "573124",
      "Kirisave B.O": "573124",
      "Sabbanahalli B.O": "573124",
      "Appihalli B.O": "573125",
      "Sankihalli B.O": "573125",
      "Holalkere B.O": "573126",
      "Nagavedi B.O": "573126",
      "Bagivalu B.O": "573211",
      "Agraharabelaguli B.O": "573131",
      "Karehalli B.O": "573131",
      "Bekka B.O": "573135",
      "Dadighatta B.O": "573135",
      "Baldare B.O": "573225",
      "Hirihalli B.O": "573225",
      "Yeliyur B.O": "573225",
      "Karjuvalli B.O": "573213",
      "Madaghatta B.O": "573213",
      "Attihalli B.O": "573123",
      "Hariharapura B.O": "573211",
      "Yelechaganahalli B.O": "573211",
      "Anughatta B.O": "573101",
      "Watehalli B.O": "573101",
      "Ajjur B.O": "573102",
      "Hethagodanahalli B.O": "573102",
      "Honnavalli B.O": "573102",
      "Hullangala B.O": "573102",
      "Marur B.O": "573102",
      "Kuniganahalli B.O": "573214",
      "Belavadi B.O": "573113",
      "Kalenahalli B.O": "573113",
      "Paduvalalu B.O": "573215",
      "Venkatipete B.O": "573215",
      "Norway B.O": "573127",
      "Udevara B.O": "573127",
      "Koratikere B.O": "573142",
      "Hosakoppalu B.O": "573201",
      "Andale B.O": "573216",
      "Doddagaddavalli B.O": "573216",
      "Magge B.O": "573129",
      "Malagalale B.O": "573129",
      "Bidarakka B.O": "573136",
      "Bannur B.O": "573130",
      "Bellame B.O": "573130",
      "Maduranahalli B.O": "573136",
      "Hebbasale B.O": "573134",
      "Heggadde B.O": "573134",
      "Seege B.O": "573219",
      "Yelagunda B.O": "573219",
      "Thannirhalla B.O": "573201",
      "Doddagenigere B.O": "573226",
      "Changadihalli B.O": "573137",
      "Doddakundur B.O": "573137",
      "Janivara B.O": "573116",
      "Kalkere B.O": "573116",
      "Hosahalli B.O": "573141",
      "Kabbali B.O": "573141",
      "Doddapura B.O": "573118",
      "Chatchatahalli B.O": "573121",
      "Cheelanayakanahalli B.O": "573121",
      "Belagihalli B.O": "573124",
      "Honnenahalli B.O": "573124",
      "Jinnenahalli B.O": "573124",
      "Juttanahalli B.O": "573124",
      "Bandur B.O": "573125",
      "D Kodihalli B.O": "573125",
      "Rampura B.O": "573126",
      "Kallusadarahalli B.O": "573144",
      "Sathangere B.O": "573144",
      "Yeraganalu B.O": "573164",
      "Talur B.O": "573213",
      "Votehole Project B.O": "573213",
      "Nandigondanahalli B.O": "573101",
      "Tumbadevanahalli B.O": "573101",
      "Bychanahalli B.O": "573102",
      "Chikarkalgud B.O": "573102",
      "Ganjalgud B.O": "573102",
      "Hebbale B.O": "573102",
      "Mallipatna B.O": "573102",
      "Marithammanahalli B.O": "573102",
      "Jammanahalli B.O": "573214",
      "Hulikallu B.O": "573142",
      "Chilkur B.O": "573216",
      "Devaladakere B.O": "573165",
      "Hadige B.O": "573165",
      "Hurudi B.O": "573165",
      "Kyamanahalli B.O": "573165",
      "Bhoovanahalli B.O": "573211",
      "Doddabyagathavalli B.O": "573211",
      "Doddakunche B.O": "573211",
      "Hassan H.O": "573201",
      "Arsikere H.O": "573103",
      "Jaya Chamaraja Pura S.O": "573126",
      "Agriculture College Campus Dly S.O": "573225",
      "Halebeedu S.O": "573121",
      "Alur S.O (Hassan)": "573213",
      "Ballupet S.O": "573214",
      "District Office S.O": "573201",
      "Hagare S.O": "573216",
      "Keralapura S.O": "573136",
      "Konanur S.O": "573130",
      "Salagame S.O": "573219",
      "Santhepet Hassan S.O": "573201",
      "Shanthigrama S.O": "573220",
      "Arehalli S.O": "573101",
      "Arkalgud S.O": "573102",
      "Hallymysore S.O": "573210",
      "Hemavathinagar S.O": "573202",
      "Holenarsipur S.O": "573211",
      "K R Puram Ext(Hassan) S.O": "573201",
      "Kandali S.O": "573217",
      "Mosale Hosahalli S.O": "573212",
      "Palya S.O": "573218",
      "Ramanathapura S.O": "573133",
      "Boovanahalli S.O": "573226",
      "Arsikere East S.O": "573103",
      "Bageshpura S.O": "573162",
      "Bagur S.O (Hassan)": "573111",
      "Didaga S.O": "573141",
      "Doddamettikurke S.O": "573117",
      "Lalanakere S.O": "573164",
      "Shravanabelagola S.O": "573135",
      "Bykere S.O": "573127",
      "Doddamagge S.O": "573142",
      "Eastern Extn S.O": "573201",
      "Gorur S.O": "573120",
      "Pension Mohalla S.O": "573201",
      "Sakleshpur S.O": "573134",
      "Vidyanagar (Hassan) S.O": "573202",
      "Banavara S.O": "573112",
      "Belur Hassan S.O": "573115",
      "Channarayapatna S.O": "573116",
      "Dudda R S S.O": "573118",
      "Gandasi S.O": "573119",
      "Haranahalli S.O": "573122",
      "Hirisave S.O": "573124",
      "Javagal S.O": "573125",
      "Kanakatte S.O": "573144",
      "Nuggihalli S.O": "573131",
      "Basavapatna S.O (Hassan)": "573113",
      "Bikkodu S.O": "573215",
      "Channapatna Extn S.O": "573201",
      "Gandhibazar S.O (Hassan)": "573201",
      "Hanbalu S.O": "573165",
      "Hethur S.O": "573123",
      "Kattaya S.O": "573128",
      "Kenchammanahosakote S.O": "573129",
      "Yeslur S.O": "573137"
    },
    "DAVANGERE": {
      "Mudahadadi B.O": "577002",
      "Avaragolla B.O": "577589",
      "Kakkaragolla B.O": "577589",
      "Guddadabevinahalli B.O": "577530",
      "Jigali B.O": "577530",
      "Komaranahalli B.O": "577530",
      "Echaghatta B.O": "577534",
      "Kodaganur B.O": "577534",
      "Nalkunda  B.O": "577534",
      "Belavanur B.O": "577002",
      "Bethur B.O": "577002",
      "Kenchenahalli B.O": "577589",
      "Kokkanur B.O": "577530",
      "Naraganahalli B.O": "577534",
      "Shyamanur B.O": "577004",
      "Shyagale B.O": "577002",
      "Kadlebalu B.O": "577589",
      "Govinahalu B.O": "577530",
      "Gulladahalli B.O": "577530",
      "Halivana B.O": "577530",
      "Annapura B.O": "577534",
      "Huchhavvanahalli B.O": "577534",
      "Devarabelakere B.O": "577002",
      "Kadajji B.O": "577002",
      "Kolkunte B.O": "577002",
      "Lokikere B.O": "577002",
      "Tholahunse B.O": "577007",
      "Kumbalur B.O": "577530",
      "Nittur B.O": "577530",
      "Anaberu B.O": "577534",
      "Avaragere B.O": "577003",
      "Nittuvalli B.O": "577004",
      "Mandalur B.O": "577556",
      "Nerligi B.O": "577556",
      "Nirthadi B.O": "577556",
      "Hemmanabethur B.O": "577512",
      "Hulikatte B.O": "577512",
      "Igoor B.O": "577512",
      "Kittur B.O": "577512",
      "Mallekatte B.O": "577512",
      "Basavanakote B.O": "577513",
      "Ramagondanahalli B.O": "577514",
      "Devikere B.O": "577553",
      "Guttidurga B.O": "577553",
      "Rastemachikere B.O": "577553",
      "Medegenaikere B.O": "577553",
      "Kundawada B.O": "577566",
      "Nanditavare B.O": "577601",
      "Gadimakunte B.O": "577528",
      "Hanumanthapura B.O": "577528",
      "Hiremallanahole B.O": "577528",
      "Kanukuppa B.O": "577528",
      "Kenchanahalli B.O": "577528",
      "Siddainakote B.O": "577513",
      "Alur B.O": "577512",
      "Tumbigre B.O": "577512",
      "Gurusiddapura B.O": "577513",
      "Pallaghatta B.O": "577513",
      "Hirethogaleri B.O": "577514",
      "Kurki B.O": "577514",
      "Nandigavi B.O": "577516",
      "Vasana B.O": "577516",
      "Chaduragolla B.O": "577553",
      "Medekerenahalli B.O": "577553",
      "Ballur B.O": "577525",
      "Kanagondanahalli B.O": "577525",
      "Mathi B.O": "577525",
      "Amaravathi B.O": "577601",
      "Guttur B.O": "577601",
      "Harihara Fort B.O": "577601",
      "Anaburu B.O": "577528",
      "Chikkamallanahole B.O": "577528",
      "Hosakere B.O": "577528",
      "Kyasenahalli B.O": "577528",
      "Mustur B.O": "577528",
      "Basavanahal B.O": "577002",
      "Attigere B.O": "577514",
      "Gopanahalu B.O": "577514",
      "Bannikodu B.O": "577219",
      "Bilasanur B.O": "577516",
      "Dulehole B.O": "577516",
      "Kadrinayakanahalli B.O": "577516",
      "Kaidale B.O": "577525",
      "Kukkuwada B.O": "577525",
      "Belludi B.O": "577601",
      "Bharamapuri Extension B.O": "577601",
      "Hanagawadi B.O": "577601",
      "Kalledevarapura B.O": "577528",
      "Sokke B.O": "577528",
      "Hebbal B.O": "577556",
      "Honnur B.O": "577556",
      "Gudahal B.O": "577512",
      "Diddige B.O": "577513",
      "Murikunte B.O": "577513",
      "Kandagal B.O": "577514",
      "Malalkere B.O": "577514",
      "Siramagondanahalli B.O": "577005",
      "Kamalapura B.O": "577516",
      "Sirigere (Harihara) B.O": "577516",
      "Yelehole B.O": "577516",
      "Helekallu B.O": "577553",
      "Mustegerahalli B.O": "577553",
      "CHIKKABUDIHAL BO": "577006",
      "Hlebathi B.O": "577566",
      "Kunibelakere B.O": "577601",
      "Rajanahalli B.O": "577601",
      "Sarathi B.O": "577601",
      "Bharamasamudra B.O": "577528",
      "Donehalli B.O": "577528",
      "Hucchavvanahalli B.O": "577528",
      "Marenahalli B.O": "577528",
      "Salahalli B.O": "577528",
      "Garaga B.O": "577213",
      "Haronahalli B.O": "577213",
      "Joladhall B.O": "577213",
      "Medugondanahalli B.O": "577213",
      "Pandomatti B.O": "577213",
      "Goppenahalli B.O": "577215",
      "Agarabannihatti B.O": "577213",
      "Donihalli B.O": "577213",
      "Rajagondanahalli B.O": "577213",
      "Thippegondanahalli B.O": "577213",
      "Chikkagangoor B.O": "577215",
      "Ajjihalli B.O": "577213",
      "Durvegere B.O": "577213",
      "Mugalihalli B.O": "577213",
      "Tavarekere B.O": "577213",
      "Devarahalli B.O": "577213",
      "Toranaghatta B.O": "577521",
      "Bistuvalli B.O": "577521",
      "Kattigehally B.O": "577521",
      "Yaraganahalu B.O": "577223",
      "Chinnikatte B.O": "577225",
      "Marabanahalli B.O": "577551",
      "Govinakovi B.O": "577230",
      "Kotehal B.O": "577230",
      "Basavanahalli B.O": "577217",
      "Hiregonigere B.O": "577217",
      "Sunkadakatte B.O": "577217",
      "Kumblur B.O": "577219",
      "Yakkanahalli B.O": "577219",
      "Belagutti B.O": "577223",
      "Surahonne B.O": "577223",
      "Ukkadagatri B.O": "581119",
      "Gopagondanahalli B.O": "577217",
      "Hanumasagara B.O": "577217",
      "Masadi B.O": "577217",
      "Chirdoni B.O": "577231",
      "Kathlagere B.O": "577219",
      "Kulambi B.O": "577219",
      "Arekere B.O": "577217",
      "Belimallur B.O": "577217",
      "Taraganahalli B.O": "577217",
      "Bidragadde BO": "577217",
      "Kariganur B.O": "577219",
      "Guddehalli B.O": "577223",
      "Jeenahalli B.O": "577223",
      "Kathige B.O": "577223",
      "Kenchikoppa B.O": "577223",
      "Chattanahalli B.O": "577225",
      "Joga B.O": "577225",
      "Daginakatte B.O": "577551",
      "Punyasthla B.O": "577551",
      "Chilurkadadakatte B.O": "577230",
      "Hebbalagere B.O": "577215",
      "Rudrapura B.O": "577218",
      "Somlapura B.O": "577218",
      "Channeshapura B.O": "577221",
      "Hiremalali B.O": "577221",
      "Medikere B.O": "577552",
      "Tanigere B.O": "577552",
      "Kanchiganahalu B.O": "577215",
      "Kortikere B.O": "577215",
      "Voddanahalu B.O": "577215",
      "Channapura B.O": "577218",
      "Bulsagar B.O": "577221",
      "Belliganoodu B.O": "577552",
      "Doddabbigere B.O": "577552",
      "Hirekogalur B.O": "577552",
      "Kakanur B.O": "577552",
      "Benakanahalli B.O": "577224",
      "Hanumanahalli B.O": "577224",
      "Hosahalli B.O": "577224",
      "Kammaragatte B.O": "577224",
      "Haralahalli B.O": "577230",
      "Arabagatta B.O": "577217",
      "Hathurbalmuri B.O": "577217",
      "Holeharalahalli B.O": "577217",
      "Soratur B.O": "577217",
      "Belalagere B.O": "577231",
      "Mujarehanumanahalli B.O": "577219",
      "Muktenahalli B.O": "577219",
      "Arundi B.O": "577223",
      "Doddethinahalli B.O": "577223",
      "Madanabhavi B.O": "577223",
      "Vaderahathur B.O": "577223",
      "Beeragondanahalli B.O": "577224",
      "Kulaghatte B.O": "577224",
      "Rampura(Honnali) B.O": "577224",
      "Doddaghatta B.O": "577544",
      "Nalkudre B.O": "577544",
      "Neetigere B.O": "577215",
      "Mallapura B.O": "577218",
      "Guddada Kommaranahalli B.O": "577221",
      "Ittige B.O": "577221",
      "Aralikatte B.O": "577552",
      "Kondadahalli B.O": "577552",
      "Siddanamatha B.O": "577552",
      "Kyasinakere B.O": "577224",
      "Karekatte B.O": "577544",
      "Kagathur B.O": "577221",
      "Lingadahalli B.O": "577221",
      "Navilehalu B.O": "577544",
      "Davangere H.O": "577001",
      "Nallur S.O (Davangere)": "577221",
      "Thyavanige S.O": "577544",
      "Chilur S.O": "577230",
      "Kanivebilichi S.O": "577231",
      "Honnali S.O": "577217",
      "Nyamthi S.O": "577223",
      "Channagiri S.O": "577213",
      "Channnagiri Town S.O": "577213",
      "Santhebennur S.O": "577552",
      "Sasvehalli S.O": "577224",
      "Basavapatna S.O (Davangere)": "577551",
      "Hodikere S.O": "577215",
      "Kerebilichi S.O": "577218",
      "Kundur S.O": "577219",
      "Saualanga S.O": "577225",
      "Bidarakere S.O": "577521",
      "Bada S.O": "577514",
      "Devaraj Urs Layout Dvg S.O": "577006",
      "Doddabathi S.O": "577566",
      "Jagalur S.O": "577528",
      "Kondajji S.O": "577589",
      "S.S.Layout S.O": "577004",
      "Southern Extension DVG S.O": "577004",
      "Davangere University Campus S.O": "577007",
      "Anaji S.O": "577512",
      "Barline Road Davanagere S.O": "577001",
      "Nittuvalli SO": "577002",
      "Jayadeva Circle Davanagere S.O": "577002",
      "Krishnarajendra Road DVG S.O": "577001",
      "Malebennur S.O": "577530",
      "Mini Vidhanasoudha S.O": "577001",
      "Vinobhanagara Extn DVG S.O": "577006",
      "Asagodu S.O": "577513",
      "Bhanuvally S.O": "577516",
      "Bilichodu S.O": "577553",
      "Hadadi S.O": "577525",
      "Harihara S.O": "577601",
      "Rajaramnagar Colony  S.O": "577601",
      "Anagodu S.O": "577556",
      "Bapuji Vidyanagara S.O": "577005",
      "Kasturaba Extension S.O": "577002",
      "Mayakonda S.O": "577534",
      "Modi Circle Davanagere S.O": "577004",
      "Rm Yard  Davanagere S.O": "577003",
      "Sks Nagar Davanagere S.O": "577005",
      "Yantrapura Harihara S.O": "577601"
    },
    "KALABURAGI": {
      "Hadagil Haruthi B.O": "585102",
      "Nandikur B.O": "585102",
      "Ptc Naganahalli B.O": "585102",
      "Sannur B.O": "585102",
      "Savalgi B.O": "585102",
      "Srinivasa Saradagi B.O": "585102",
      "Hullur B.O": "585212",
      "Itagi B.O": "585212",
      "Tellur B.O": "585212",
      "Bhairamadgi B.O": "585265",
      "Hasargundagi B.O": "585306",
      "Havnoor B.O": "585265",
      "Hire Heroor B.O": "585265",
      "Jogur B.O": "585265",
      "Gudur B.O": "585213",
      "Harwal B.O": "585310",
      "Hipparga J B.O": "585310",
      "Kattisangavi B.O": "585310",
      "Kolkur B.O": "585310",
      "Nelogi B.O": "585310",
      "Raddewadgi B.O": "585310",
      "Bhimalli B.O": "585311",
      "Dannur B.O": "585311",
      "Yedga B.O": "585312",
      "Dongargaon B.O": "585313",
      "Holkunda B.O": "585313",
      "Jeevanagi B.O": "585313",
      "Jamaga R B.O": "585314",
      "Kotanhipparga B.O": "585314",
      "Bandarwad B.O": "585265",
      "Aralgundagi B.O": "585325",
      "Ballundagi B.O": "585310",
      "Bilwar B.O": "585310",
      "Koodi B.O": "585310",
      "Madri B.O": "585310",
      "Muthkod B.O": "585310",
      "Naribol B.O": "585310",
      "Lad Chincholi B.O": "585311",
      "Pattan B.O": "585311",
      "Suntanur B.O": "585311",
      "Hebbal B.O": "585312",
      "Kalagurthi B.O": "585312",
      "Kodadur B.O": "585312",
      "Kodli B.O": "585312",
      "Kukunda B.O": "585312",
      "Mangalgi B.O": "585312",
      "Chengta B.O": "585313",
      "Kalmood B.O": "585313",
      "Sonth B.O": "585313",
      "Bangarga B.O": "585314",
      "Salgera V K B.O": "585316",
      "Sangunda B.O": "585316",
      "Arjunagi B.O": "585236",
      "Rudrawadi B.O": "585314",
      "Bilgunda B.O": "585316",
      "Hireaurad B.O": "585316",
      "Kurikota B.O": "585316",
      "Lad Mugali B.O": "585316",
      "Mannur B.O": "585217",
      "Shivoor B.O": "585217",
      "Udachan B.O": "585217",
      "Harsoor B.O": "585102",
      "Ankalgi B.O": "585212",
      "Ghangapur Sangam B.O": "585212",
      "Chinamgera B.O": "585265",
      "Sagnoor B.O": "585265",
      "Chik Kallur B.O": "585310",
      "Jeratagi B.O": "585310",
      "Kalhangarga B.O": "585104",
      "Mandewal B.O": "585310",
      "Rasanagi B.O": "585310",
      "Hagargi B.O": "585102",
      "Hire Bennur B.O": "585102",
      "Khandal B.O": "585102",
      "Aurad B.O": "585212",
      "Bidnoor B.O": "585265",
      "Chowdapur B.O": "585265",
      "Desanagi B.O": "585310",
      "Harnoor B.O": "585310",
      "Ijeri B.O": "585310",
      "Kasar Bhosga B.O": "585310",
      "Mudbal B B.O": "585310",
      "Sathkhed B.O": "585310",
      "Soan B.O": "585301",
      "Duttargaon B.O": "585311",
      "Chincholi H B.O": "585312",
      "Rajapur B.O": "585105",
      "Kalmandargi B.O": "585313",
      "Margutti B.O": "585313",
      "Okali B.O": "585313",
      "Rajnal B.O": "585313",
      "Alanga B.O": "585314",
      "Jawalga J B.O": "585314",
      "Bablad B.O": "585316",
      "Belkota B.O": "585316",
      "Madki B.O": "585316",
      "Muddadga B.O": "585316",
      "Hosurwadi B.O": "585217",
      "Yelwar B.O": "585310",
      "Gola B B.O": "585311",
      "Narona B.O": "585311",
      "Bolewad B.O": "585312",
      "Gotur B.O": "585312",
      "Korwar B.O": "585312",
      "Mattimadu B.O": "585312",
      "Chandankera B.O": "585313",
      "Kinnisadak B.O": "585313",
      "Patwada B.O": "585313",
      "Anoor B.O": "585301",
      "Hodlur B.O": "585314",
      "Tadola B.O": "585314",
      "Ambalga B.O": "585316",
      "Belambagi B.O": "585316",
      "Sirchand B.O": "585316",
      "Karajagi B.O": "585217",
      "Bennisiroor B.O": "585236",
      "Chalgera B.O": "585236",
      "Madan Hipparga B.O": "585236",
      "Madiyal B.O": "585236",
      "Kalhipparga B.O": "585322",
      "Ningadahalli B.O": "585236",
      "Yelsangi B.O": "585236",
      "Zalki K B.O": "585236",
      "Arankallur B.O": "585322",
      "Heroor K B.O": "585322",
      "Bhagewadi B.O": "585211",
      "Dandagund B.O": "585211",
      "Dandoti B.O": "585211",
      "Diggaon B.O": "585211",
      "Kardal B.O": "585211",
      "Yergal B.O": "585211",
      "Buragpalli B.O": "585214",
      "Itkal B.O": "585214",
      "Kanagadda B.O": "585214",
      "Madbool B.O": "585317",
      "Malkood B.O": "585317",
      "Dugnoor B.O": "585318",
      "Kadacherla B.O": "585318",
      "Konapur B.O": "585318",
      "Lingampalli B.O": "585318",
      "Kulkunta B.O": "585218",
      "Nalwar Station B.O": "585218",
      "Alhalli B.O": "585211",
      "Rajola B.O": "585211",
      "Kurkunta B.O": "585210",
      "Belgumpa B.O": "585317",
      "Gundagurthi B.O": "585317",
      "Pethsiroor B.O": "585317",
      "Jakanpalli B.O": "585318",
      "Silarkot B.O": "585318",
      "Kollur B.O": "585307",
      "Yergol B.O": "585218",
      "Habal B.O": "585320",
      "Hadalagi B.O": "585236",
      "Zalki.B B.O": "585236",
      "Bhedsoor B.O": "585322",
      "Bhankalga B.O": "585211",
      "Dongaon B.O": "585211",
      "Margol B.O": "585211",
      "Satnoor B.O": "585211",
      "Madkol B.O": "585210",
      "Bennur B.O": "585317",
      "Ivani B.O": "585317",
      "Neelahalli B.O": "585317",
      "Devanur B.O": "585318",
      "Irnapalli B.O": "585318",
      "Kolkunda B.O": "585318",
      "Kanganhalli B.O": "585218",
      "Chintanpalli B.O": "585320",
      "Sirur Darga B.O": "585236",
      "Hoolagera B.O": "585322",
      "Balbatti B.O": "585309",
      "Medak B.O": "585214",
      "Tulmamadi B.O": "585214",
      "Yanagundi B.O": "585214",
      "Bheeranhalli B.O": "585317",
      "Tengli B.O": "585317",
      "Totanhalli B.O": "585317",
      "Chandapur B.O": "585318",
      "Madna B.O": "585318",
      "Motakpalli B.O": "585318",
      "Nadepalli B.O": "585318",
      "Ribbanpalli B.O": "585318",
      "Rampurhalli B.O": "585218",
      "Sannati B.O": "585218",
      "Sugur B.O": "585322",
      "Yagapur B.O": "585218",
      "Kodalhangarga B.O": "585302",
      "Matki B.O": "585302",
      "Savaleshwar B.O": "585302",
      "Telakuni B.O": "585302",
      "Malla B B.O": "585303",
      "Kallur Road B.O": "585305",
      "Miriyan B.O": "585305",
      "Ainapur B.O": "585306",
      "Marpalli B.O": "585306",
      "Yelmamidi B.O": "585306",
      "Chandrampalli B.O": "585307",
      "Hagargundagi B.O": "585308",
      "Kadni B.O": "585308",
      "Naduvinahalli B.O": "585308",
      "Gb Sharannagar B.O": "585103",
      "Kapanoor B.O": "585104",
      "Keriambalga B.O": "585104",
      "Bhopal Tegnoor B.O": "585102",
      "Jidaga B.O": "585302",
      "Bhosga B.O": "585301",
      "Chincholi B.O": "585302",
      "Diksanga B.O": "585301",
      "Revoor B.O": "585301",
      "Kinnisultan B.O": "585302",
      "Koralli B.O": "585302",
      "Tadkal B.O": "585322",
      "Thirth B.O": "585302",
      "Kellur B.O": "585303",
      "Maradgi B.O": "585303",
      "Polakpalli B.O": "585305",
      "Somlingadalli B.O": "585305",
      "Bankepalli B.O": "585306",
      "Khanapur B.O": "585302",
      "Rustumpur B.O": "585306",
      "Salebeeranahalli B.O": "585306",
      "Salgarbasanthpur B.O": "585306",
      "Chimmaidlai B.O": "585307",
      "Neemhosalli B.O": "585307",
      "Firozabad B.O": "585308",
      "Gb Santrashwadi B.O": "585105",
      "Kamalnagar B.O": "585104",
      "Karhari B.O": "585104",
      "Syed Chincholi B.O": "585104",
      "Kanmus B.O": "585302",
      "Mogha.K B.O": "585302",
      "Munalli B.O": "585302",
      "Nirgudi B.O": "585302",
      "Padsavalagi B.O": "585302",
      "Sakkarga B.O": "585302",
      "Salegaon B.O": "585302",
      "Sarasamba B.O": "585302",
      "Anwar B.O": "585305",
      "Garagapalli B.O": "585305",
      "Kunchavaram B.O": "585305",
      "Gadilingadahalli B.O": "585306",
      "Garampalli B.O": "585306",
      "Karakmukli B.O": "585306",
      "Hirekawalga B.O": "585308",
      "Kiranagi B.O": "585308",
      "Saradgi Battad B.O": "585308",
      "Sirnoor B.O": "585308",
      "Tadtegnoor B.O": "585308",
      "Tilgool B.O": "585308",
      "Hirapur B.O": "585103",
      "Sindagi B.O": "585103",
      "Asta B.O": "585104",
      "Chinchansoor B.O": "585104",
      "Ganjankhed B.O": "585104",
      "C J  Colony B.O": "585102",
      "Bhoganhalli B.O": "585301",
      "Kallur B.O": "585301",
      "Nandargi B.O": "585301",
      "Alund Bazar B.O": "585302",
      "Mukramba B.O": "585322",
      "Nagur B.O": "585322",
      "Gola K B.O": "585228",
      "Hongunta B.O": "585228",
      "Malgatti B.O": "585228",
      "Mugalnagaon B.O": "585228",
      "Pala B.O": "585228",
      "Shahabad Kasaba B.O": "585228",
      "Hittal Siroor B.O": "585213",
      "Hunsi Hadgil B.O": "585213",
      "Jawali B.O": "585213",
      "Kognur B.O": "585213",
      "Melkunda B.O": "585213",
      "Kupnoor B.O": "585324",
      "Mogha B.O": "585324",
      "Navadagi B.O": "585324",
      "Pastapur B.O": "585324",
      "Rummangud B.O": "585324",
      "Kuknoor B.O": "585325",
      "Kuralgera B.O": "585325",
      "Sunthan B.O": "585322",
      "Devantegnur B.O": "585228",
      "Hirenandur B.O": "585228",
      "Martur B.O": "585228",
      "Mutga B.O": "585228",
      "Taranhalli B.O": "585228",
      "Bommanhalli B.O": "585213",
      "Madra B B.O": "585213",
      "Hudebeeranahalli B.O": "585324",
      "Kudhalli B.O": "585324",
      "Kadkol B.O": "585325",
      "Wadgera B.O": "585325",
      "Wastari B.O": "585310",
      "Atnoor B.O": "585301",
      "Bellurgi B.O": "585301",
      "Hiregour B.O": "585301",
      "Mallabad B.O": "585301",
      "Bhusanoor B.O": "585302",
      "Jamaga J B.O": "585302",
      "Biriyala B B.O": "585303",
      "Ganwar B.O": "585303",
      "Shadipura B.O": "585305",
      "Venkatapur B.O": "585305",
      "Degalmadi B.O": "585307",
      "Enoli B.O": "585307",
      "Nagaidlai B.O": "585307",
      "Basavapattan B.O": "585308",
      "Sirasgi B.O": "585103",
      "Kb M.B.Nagar B.O": "585105",
      "Kumsi B.O": "585104",
      "Taj Sultanpur B.O": "585104",
      "Kawalga B.O": "585302",
      "Nimbarga B.O": "585213",
      "Gadikeshwar B.O": "585324",
      "Halchera B.O": "585324",
      "Hosalli B.O": "585324",
      "Aloor B.O": "585325",
      "Hangarga K B.O": "585325",
      "Konasirsagi B.O": "585325",
      "Magingera B.O": "585325",
      "Malli B.O": "585325",
      "Jettur B.O": "585320",
      "Ankalga B.O": "585301",
      "Badadal B.O": "585301",
      "Ghattarga B.O": "585301",
      "Hinchgera B.O": "585301",
      "Hire Jewargi B.O": "585301",
      "Hirealgi B.O": "585301",
      "Hallisalgar B.O": "585302",
      "Hebli B.O": "585302",
      "Hiroli B.O": "585302",
      "Bhankur B.O": "585228",
      "Tonasinahalli B.O": "585228",
      "Dhangapur B.O": "585213",
      "Niloor B.O": "585213",
      "Korvi B.O": "585324",
      "Hangarga B B.O": "585325",
      "Kachapur B.O": "585325",
      "Kanameshwar B.O": "585325",
      "Sumbad B.O": "585325",
      "Yelgod B.O": "585325",
      "Karachked B.O": "585320",
      "Rudnoor B.O": "585320",
      "Goudampalli B.O": "585222",
      "Hirealoor B.O": "585222",
      "Sindhanmadu B.O": "585222",
      "Kadboor B.O": "585225",
      "Ladlapur B.O": "585225",
      "Adki B.O": "585222",
      "Benakanhalli B.O": "585222",
      "Bhimanhalli B.O": "585222",
      "Vasavadatta C F B.O": "585222",
      "Belwadgi B.O": "585225",
      "Halkatta B.O": "585225",
      "Keroli B.O": "585320",
      "Koradampalli B.O": "585320",
      "Siroli B.O": "585320",
      "Telkur B.O": "585320",
      "Hirebetgera B.O": "585222",
      "Kalkham B.O": "585222",
      "Ravoor B.O": "585225",
      "Sulhalli B.O": "585225",
      "Chitakanpalli B.O": "585222",
      "Handarki B.O": "585222",
      "Kodla B.O": "585222",
      "Ranjol B.O": "585222",
      "Udgi B.O": "585222",
      "Ingalagi B.O": "585225",
      "Kundanoor B.O": "585225",
      "Kalaburagi H.O": "585101",
      "GB Ggh S.O": "585105",
      "GB N Gunj S.O": "585104",
      "GB RS S.O": "585102",
      "Khajuri S.O (Kalaburagi)": "585314",
      "Mashal S.O": "585217",
      "Ratkal S.O": "585322",
      "Station Ghanagapur S.O": "585213",
      "Chittapur S.O": "585211",
      "Nalwar S.O": "585218",
      "Sedam S.O": "585222",
      "Wadi S.O (Kalaburagi)": "585225",
      "GB Central Bus Stand S.O": "585102",
      "GB Jagath S.O": "585101",
      "GB Mominpura S.O": "585104",
      "GB Shivajinagar S.O": "585104",
      "Mahagaon (Kalaburagi) S.O": "585316",
      "Shahabad ACC S.O": "585229",
      "Malkhed S.O": "585317",
      "Mudhol (Kalaburagi) S.O": "585318",
      "GB Darga S.O": "585104",
      "GB Jnanaganga S.O": "585106",
      "GB Shahabazar S.O": "585101",
      "Ghanagapur T S.O": "585212",
      "Gobbur S.O": "585265",
      "Kalaburagi HCB S.O": "585107",
      "Jewargi S.O": "585310",
      "Sulahpeth S.O": "585324",
      "Yedrami S.O": "585325",
      "Central University of Karnataka,Kad": "585367",
      "Malkhed Road S.O": "585292",
      "Chincholi S.O": "585307",
      "GB Court S.O": "585102",
      "GB M.S.K.Mill S.O": "585103",
      "Kadaganchi S.O": "585311",
      "Kalgi S.O": "585312",
      "Kamalapur S.O (Kalaburagi)": "585313",
      "Nimbal S.O": "585236",
      "Shahabad S.O (Kalaburagi)": "585228",
      "Kurkunta C.F S.O": "585210",
      "Nidgunda S.O": "585320",
      "Andola S.O": "585303",
      "GB Bahamanipura S.O": "585103",
      "Afjalpur S.O": "585301",
      "Alund S.O": "585302",
      "Chandapur S.O (Kalaburagi)": "585305",
      "Chimmanchod S.O": "585306",
      "Farhatabad S.O": "585308"
    },
    "KODAGU": {
      "Athur B.O": "571215",
      "Chennayanakote B.O": "571215",
      "Balliamandur B.O": "571216",
      "Begur B.O": "571216",
      "Bekkesodlur B.O": "571216",
      "Chikkamandur B.O": "571216",
      "Alur Siddapura B.O": "571235",
      "Bemblur B.O": "571235",
      "Dundalli B.O": "571235",
      "Kothur B.O": "571216",
      "Nelji B.O": "571214",
      "Yemmemadu B.O": "571214",
      "Mekur Hoskeri B.O": "571215",
      "Jodubetti B.O": "571216",
      "Kirgur B.O": "571216",
      "Kunda B.O": "571216",
      "Palur B.O": "571214",
      "Halligattu B.O": "571216",
      "Kanur B.O": "571216",
      "Ankanahalli B.O": "571235",
      "Avandur B.O": "571201",
      "Bettageri B.O": "571201",
      "Boikeri B.O": "571201",
      "Cherambane B.O": "571201",
      "Heravanadu B.O": "571201",
      "Karmadu B.O": "571211",
      "Kavadi B.O": "571211",
      "Vontiangadi B.O": "571211",
      "Kadanga B.O": "571212",
      "Kakkabbe B.O": "571212",
      "Karada B.O": "571212",
      "Aruvathoklu B.O": "571213",
      "Kaggodlu B.O": "571201",
      "Makkandur B.O": "571201",
      "Halgunda B.O": "571211",
      "Kalathmadu B.O": "571211",
      "Kottageri B.O": "571219",
      "Karike B.O": "571247",
      "CHES B.O": "571248",
      "Kadagadal B.O": "571248",
      "Balaji B.O": "571213",
      "Devarapura B.O": "571213",
      "Badagarakeri B.O": "571249",
      "Madalapura B.O": "571232",
      "Sirangala B.O": "571232",
      "Rangasamudra B.O": "571234",
      "Valnur B.O": "571234",
      "Manchalli B.O": "571250",
      "Aigoor B.O": "571251",
      "Balamuri B.O": "571252",
      "Hakathur B.O": "571252",
      "Ballamavati B.O": "571214",
      "Hodavada B.O": "571214",
      "Galibeedu B.O": "571201",
      "K. Nidugane B.O": "571201",
      "Made B.O": "571201",
      "Thalathmane B.O": "571201",
      "Bilugunda B.O": "571211",
      "Hosur(Ammathi) B.O": "571211",
      "Kannangala B.O": "571211",
      "Devanur B.O": "571219",
      "K.Chettalli B.O": "571248",
      "Parane B.O": "571212",
      "Yavakapady B.O": "571212",
      "Kaikeri B.O": "571213",
      "Ponnappasanthe B.O": "571213",
      "Birunani B.O": "571249",
      "Bessur B.O": "571231",
      "Kudumangalore B.O": "571232",
      "Basavanahally B.O": "571234",
      "Herur B.O": "571234",
      "Biligeri B.O": "571251",
      "Bethri B.O": "571252",
      "Hoddur B.O": "571252",
      "Maragodu B.O": "571252",
      "Kolakeri B.O": "571214",
      "Dhanugala B.O": "571213",
      "Mayamudi B.O": "571213",
      "Harihara B.O": "571249",
      "Parakatageri B.O": "571249",
      "West Nemmale B.O": "571249",
      "Nirugunda B.O": "571231",
      "Hebbale B.O": "571232",
      "Kanive B.O": "571232",
      "Baichanahally B.O": "571234",
      "Guddehosur B.O": "571234",
      "Harangi Project B.O": "571234",
      "Mullusoge B.O": "571234",
      "Nagarahole B.O": "571250",
      "Garagandur B.O": "571251",
      "Hattihole B.O": "571251",
      "Surlabi B.O": "571251",
      "Kondangeri B.O": "571252",
      "S.Kattemadu B.O": "571252",
      "Kalur B.O": "571201",
      "Kandanakolli B.O": "571201",
      "Kottur B.O": "571201",
      "Koynad B.O": "571201",
      "Nittur B.O": "571219",
      "Chettimani B.O": "571247",
      "Kundacherry B.O": "571247",
      "Sannapulikote B.O": "571247",
      "Arapattu B.O": "571212",
      "Hysodlur B.O": "571249",
      "T.Shettigeri B.O": "571249",
      "Theralu B.O": "571249",
      "Thorenur B.O": "571232",
      "Nanjarayapatna B.O": "571234",
      "Garvale B.O": "571251",
      "Kiragandur B.O": "571251",
      "Kumbur B.O": "571251",
      "Moovathoklu B.O": "571251",
      "Mukkodlu B.O": "571251",
      "Sirangalli B.O": "571251",
      "Balambi(Chembu) B.O": "574234",
      "Sampaje Gate B.O": "574234",
      "Peraje B.O": "574314",
      "Handli B.O": "571235",
      "Mudravalli B.O": "571235",
      "Arecad B.O": "571253",
      "Balagunda B.O": "571236",
      "Bettadahalli B.O": "571236",
      "Thakeri B.O": "571236",
      "Thannirahalla B.O": "571236",
      "Nalkeri B.O": "571217",
      "Andagove B.O": "571237",
      "K.Bychanahalli B.O": "571237",
      "Kanbile B.O": "571237",
      "Mathikad B.O": "571237",
      "Uluguli B.O": "571237",
      "Bhadragola B.O": "571254",
      "Arji B.O": "571218",
      "Bellumadu B.O": "571218",
      "Betoli B.O": "571218",
      "Imangala B.O": "571218",
      "Kakotuparambu B.O": "571218",
      "Kandangala B.O": "571218",
      "Kuttandi B.O": "571218",
      "Engilageri B.O": "571253",
      "Guyya B.O": "571253",
      "Karadigodu B.O": "571253",
      "Maldare B.O": "571253",
      "Abburkatte B.O": "571236",
      "Kumarahalli B.O": "571236",
      "Kundalli B.O": "571236",
      "Badaga B.O": "571217",
      "Attur Nallur B.O": "571237",
      "Haradur B.O": "571237",
      "Horoor B.O": "571237",
      "Hoskote B.O": "571237",
      "Maroor B.O": "571254",
      "Nokya B.O": "571254",
      "Devanageri B.O": "571218",
      "Makutta B.O": "571218",
      "Nalvathoklu B.O": "571218",
      "Nandigunda B.O": "571235",
      "Nidtha B.O": "571235",
      "Gonimarur B.O": "571236",
      "Gowdalli B.O": "571236",
      "Hanagallu B.O": "571236",
      "Hancode B.O": "571236",
      "Kusbur B.O": "571236",
      "Masagodu B.O": "571236",
      "N.Sirangala B.O": "571237",
      "Chembebellore B.O": "571218",
      "Hathur B.O": "571218",
      "K.Boikeri B.O": "571218",
      "Gopalapura B.O": "571235",
      "Malambi B.O": "571235",
      "Abyathmangala B.O": "571253",
      "Badaga Bannagala B.O": "571253",
      "Nelliahudikeri B.O": "571253",
      "Belur somwarpet B.O": "571236",
      "Ganagur B.O": "571236",
      "Shanthalli B.O": "571236",
      "Tholur Shettalli B.O": "571236",
      "Kurchi B.O": "571217",
      "Kallur B.O": "571237",
      "Kedakal B.O": "571237",
      "Kodagarahalli B.O": "571237",
      "Arameri B.O": "571218",
      "B.Shettigeri B.O": "571218",
      "Bittangala B.O": "571218",
      "Heggala B.O": "571218",
      "Kadanur B.O": "571218",
      "Kedamallur B.O": "571218",
      "Mythadi B.O": "571218",
      "Madikeri H.O": "571201",
      "Madikeri Dist. Offices Complex S.O": "571201",
      "Virajpet S.O": "571218",
      "Sampaje S.O": "574234",
      "Cheyandane S.O": "571212",
      "Hudikeri S.O": "571249",
      "Kushalnagar S.O": "571234",
      "Kutta S.O": "571250",
      "Napoklu S.O": "571214",
      "Thithimathi S.O": "571254",
      "Gonikoppal S.O": "571213",
      "Kodlipet S.O": "571231",
      "Kudige S.O": "571232",
      "Shanivarasanthe S.O": "571235",
      "Chettalli S.O": "571248",
      "Madapura S.O": "571251",
      "Pollibetta S.O": "571215",
      "Ponnampet S.O": "571216",
      "Siddapura Kodagu S.O": "571253",
      "Somwarpet S.O": "571236",
      "Ammathi S.O": "571211",
      "Balele S.O": "571219",
      "Bhagamandala S.O": "571247",
      "Murnad S.O": "571252",
      "Srimangala S.O": "571217",
      "Suntikoppa S.O": "571237"
    },
    "CHIKKAMAGALURU": {
      "Bettadahalli B.O": "577228",
      "Doranalu B.O": "577228",
      "Nerlekere B.O": "577228",
      "Amruthapura B.O": "577228",
      "Belenahalli B.O": "577228",
      "Hunsaghatta B.O": "577228",
      "K. Chattnahalli B.O": "577228",
      "Nandi B.O": "577228",
      "Hadikere B.O": "577228",
      "Malalichennenahalli B.O": "577228",
      "Amble B.O": "577101",
      "Anur B.O": "577101",
      "Karthikere B.O": "577101",
      "Marle B.O": "577101",
      "Shanuboganahalli B.O": "577547",
      "Sokke B.O": "577547",
      "Hangaravalli B.O": "577111",
      "Kanathi B.O": "577111",
      "Kelagur B.O": "577111",
      "Kottigehara B.O": "577113",
      "Phalguni B.O": "577113",
      "Balliganur B.O": "577116",
      "G. Yaradakere B.O": "577180",
      "Kalkere B.O": "577123",
      "Hemmakki B.O": "577121",
      "Balur B.O": "577122",
      "Niduvale B.O": "577122",
      "Kuruvangi B.O": "577102",
      "Yemmedoddi B.O": "577548",
      "Hirekolale B.O": "577101",
      "Indavara B.O": "577101",
      "Baggavalli B.O": "577547",
      "Gadihalli B.O": "577547",
      "Guddadamane B.O": "577111",
      "Handi B.O": "577111",
      "Hosahalli B.O": "577113",
      "Basoor B.O": "577116",
      "Vakkalagere B.O": "577180",
      "Kelagur(J) B.O": "577122",
      "Hiremagalur B.O": "577102",
      "Alaghatta B.O": "577548",
      "Jiganehalli B.O": "577548",
      "Tangli B.O": "577548",
      "Muguluvalli B.O": "577101",
      "Antharaghatta B.O": "577547",
      "Bettagere B.O": "577113",
      "Guthi B.O": "577113",
      "Heggudlu B.O": "577113",
      "Hogarehalli B.O": "577116",
      "Kudlur B.O": "577116",
      "Mundre B.O": "577116",
      "Chikkanavangala B.O": "577145",
      "Javoor B.O": "577145",
      "Sunkasale B.O": "577121",
      "Biluvala B.O": "577548",
      "Bisalehalli B.O": "577548",
      "Keresanthe B.O": "577548",
      "Mathighatta B.O": "577548",
      "Nidaghatta B.O": "577548",
      "Yellambalase B.O": "577548",
      "Belavadi B.O": "577146",
      "Eshwarahalli B.O": "577146",
      "Kurubarabudihal B.O": "577146",
      "Jagara B.O": "577130",
      "Joldal B.O": "577130",
      "Bisagnimutt B.O": "577131",
      "Pandaravalli B.O": "577131",
      "Bettadamane B.O": "577132",
      "Gonibeedu B.O": "577132",
      "Gowdahalli B.O": "577132",
      "Hanthur B.O": "577132",
      "Kundur B.O": "577132",
      "Nandipura B.O": "577132",
      "K.R. Pete(Bigganahalli) B.O": "577133",
      "Maravanji B.O": "577182",
      "Niduvalli B.O": "577182",
      "Jannagadde B.O": "577136",
      "Konkalamane B.O": "577136",
      "Huligere B.O": "577138",
      "S. Madapura B.O": "577138",
      "Sindigere B.O": "577146",
      "Bogase B.O": "577130",
      "Daradahalli B.O": "577132",
      "Devarinda B.O": "577132",
      "Kammaragodu B.O": "577132",
      "Kirugunda B.O": "577132",
      "Urubage B.O": "577132",
      "Halasumane B.O": "577133",
      "Muthanagere B.O": "577182",
      "Bidre B.O": "577136",
      "Togarihankal B.O": "577137",
      "Somanahalli B.O": "577138",
      "Mudigere B.O": "577550",
      "Addagadde B.O": "577126",
      "Andagaru B.O": "577126",
      "Belavinakodige B.O": "577126",
      "Berukodige B.O": "577126",
      "Hosakoppa B.O": "577126",
      "Kachakalli B.O": "577126",
      "K.Kelagur B.O": "577179",
      "Thotadur B.O": "577179",
      "Kanabur B.O": "577112",
      "Megaramakki B.O": "577112",
      "Shanthigrama B.O": "577114",
      "Bomlapura B.O": "577120",
      "Melubelare B.O": "577120",
      "Shanuvalli B.O": "577120",
      "Haluvalli B.O": "577124",
      "Seethur B.O": "577127",
      "Mudabagilu B.O": "577134",
      "Muthinakoppa B.O": "577134",
      "Shettykoppa B.O": "577134",
      "Melukoppa Begane B.O": "577139",
      "Nallur B.O": "577139",
      "Rushyashringapura B.O": "577139",
      "Giriyapura B.O": "577550",
      "Katiganere B.O": "577550",
      "Hiregouza B.O": "577168",
      "Lakkammanahalli B.O": "577168",
      "Chikkaballekere B.O": "577140",
      "Udugere B.O": "577140",
      "Halmathur B.O": "577126",
      "Hirekodige B.O": "577126",
      "Narve B.O": "577126",
      "Bannur B.O": "577112",
      "Bilalkoppa B.O": "577114",
      "Herur B.O": "577112",
      "Niluvagilu B.O": "577120",
      "Guddethota B.O": "577123",
      "Ganganakodige B.O": "577124",
      "Marasanige B.O": "577124",
      "Avathi B.O": "577101",
      "Kabbinahalli B.O": "577101",
      "Doddabokikere B.O": "577547",
      "Gejjegondanahalli B.O": "577547",
      "Gullanpet B.O": "577111",
      "Kenjige B.O": "577113",
      "Bislere B.O": "577116",
      "Kamanakere B.O": "577116",
      "Nagaralu B.O": "577175",
      "Megur B.O": "577139",
      "Chikkangala B.O": "577548",
      "Kadurhalli B.O": "577548",
      "Patnagere B.O": "577548",
      "Saraswathipura B.O": "577548",
      "Y. Mallapura B.O": "577548",
      "Kanur B.O": "577127",
      "Konakere B.O": "577127",
      "Gubgal B.O": "577160",
      "Gubbiga (Sutta) B.O": "577134",
      "Madabur B.O": "577134",
      "Gopala B.O": "577144",
      "Karakuchi B.O": "577144",
      "Darekoppa B.O": "577139",
      "Halandur B.O": "577139",
      "Masige B.O": "577139",
      "Nemmar B.O": "577139",
      "Tekkur B.O": "577139",
      "Vidyaranyapura B.O": "577139",
      "Nandibatlu B.O": "577129",
      "Sampigekhan B.O": "577129",
      "Udeva B.O": "577129",
      "Siravase B.O": "577130",
      "Attigundi B.O": "577131",
      "Bidrehalli B.O": "577132",
      "Billurkadidal B.O": "577132",
      "Halase B.O": "577132",
      "Jannapura B.O": "577132",
      "Jogannakere B.O": "577132",
      "Kuduvalli B.O": "577133",
      "Malalur(CKM) B.O": "577133",
      "Vastare B.O": "577133",
      "Anegere B.O": "577182",
      "Ganganahalli B.O": "577182",
      "Honnenahalli B.O": "577182",
      "Cheeranahalli B.O": "577549",
      "Dandur B.O": "577549",
      "Sivane R.S. B.O": "577549",
      "Thyagadakatte B.O": "577549",
      "Asandi B.O": "577550",
      "Begur B.O": "577550",
      "Nagenahalli B.O": "577168",
      "Pillenahalli B.O": "577168",
      "Dayamballi B.O": "577126",
      "Kelakuli B.O": "577126",
      "Kesave B.O": "577126",
      "Suryadevastana B.O": "577126",
      "Melpal B.O": "577112",
      "Hiregadde B.O": "577117",
      "Begar B.O": "577120",
      "Bilagadde B.O": "577120",
      "Kulur B.O": "577123",
      "Lokanathapura B.O": "577123",
      "Huigere B.O": "577160",
      "Baragenahalli B.O": "577144",
      "Bhavikere B.O": "577144",
      "Honnavalli B.O": "577139",
      "Kavadi B.O": "577139",
      "Kerekatte B.O": "577139",
      "Kunchebyle B.O": "577139",
      "Jodimachenahalli B.O": "577146",
      "S. Bidare B.O": "577146",
      "Kallathipura B.O": "577129",
      "Tanigebyle B.O": "577129",
      "Hosahallipet B.O": "577130",
      "Jakkanahalli B.O": "577130",
      "Kaimara B.O": "577131",
      "Kesavinamane B.O": "577131",
      "Baskal B.O": "577132",
      "G. Hosahalli B.O": "577132",
      "Hesgal B.O": "577132",
      "Makonahalli B.O": "577132",
      "Mekanagadde B.O": "577132",
      "Rampura B.O": "577133",
      "Hochihalli B.O": "577182",
      "Kunkanadu B.O": "577182",
      "Banur B.O": "577135",
      "Kadavanthi B.O": "577136",
      "Annigere(Yagati) B.O": "577138",
      "Kanchugal Bidre B.O": "577138",
      "Chikkanallur B.O": "577550",
      "Hirenallur B.O": "577550",
      "Hulikere B.O": "577168",
      "Lakya B.O": "577168",
      "Garje B.O": "577140",
      "Addada B.O": "577126",
      "Bhandigadi B.O": "577126",
      "Gunavanthe B.O": "577126",
      "Melukoppa B.O": "577126",
      "Uttameshwara B.O": "577126",
      "Devagodu B.O": "577112",
      "Kallugudde B.O": "577114",
      "Alageshwara B.O": "577123",
      "Hosur(Koppa) B.O": "577123",
      "DURGADABETTA B O": "577123",
      "Samse B.O": "577124",
      "Jamble BO": "577124",
      "Bellur B.O": "577127",
      "Kattinamane B.O": "577127",
      "Coove B.O": "577160",
      "B.H. Kaimara B.O": "577134",
      "Honnekodige B.O": "577134",
      "Duglapura B.O": "577144",
      "Halasur B.O": "577144",
      "Agalagandi B.O": "577139",
      "Gandaghatta B.O": "577139",
      "Thyavana B.O": "577139",
      "Koppa H.O": "577126",
      "Chikkamagaluru H.O": "577101",
      "Birur S.O": "577116",
      "Chikkamagaluru Fort S.O": "577101",
      "Devanur S.O": "577175",
      "Jyothinagar S.O (Chikkamagaluru)": "577102",
      "Kadur RS S.O": "577548",
      "Mallenahalli S.O": "577131",
      "Mudigere S.O": "577132",
      "Mugthihalli S.O": "577133",
      "Sakrepatna S.O": "577135",
      "Aldur S.O": "577111",
      "Bukkambudhi S.O": "577145",
      "Kadur S.O": "577548",
      "Lingadahalli S.O": "577129",
      "Mallandur S.O": "577130",
      "Panchanahalli S.O": "577182",
      "Porterpet S.O": "577101",
      "Banakal S.O": "577113",
      "Chikkamagaluru District Office S.O": "577101",
      "Chowlahiriyur S.O": "577180",
      "Sangameshwarapete S.O": "577136",
      "C.R.Station S.O": "577117",
      "Santaveri S.O": "577137",
      "Balehonnur S.O": "577112",
      "Horanadu S.O": "577181",
      "Kalasa S.O": "577124",
      "Rangenahalli S.O": "577144",
      "Ajjampura Bazar S.O": "577547",
      "Ajjampura S.O": "577547",
      "Chikkamagaluru ZP S.O": "577102",
      "Hirebyle S.O": "577121",
      "Javali S.O": "577122",
      "Kalasapura S.O": "577146",
      "Ramanahalli S.O": "577101",
      "Sivane S.O": "577549",
      "Sollapura S.O": "577550",
      "Uddeboranahalli S.O": "577168",
      "Basarikatte S.O": "577114",
      "Jayapura S.O": "577123",
      "Kammaradi S.O": "577125",
      "Kudregundi S.O": "577127",
      "Magundi S.O": "577160",
      "Narasimharajapura S.O": "577134",
      "Tarikere S.O": "577228",
      "Singatagere S.O": "577138",
      "Vijayapuram S.O (Chikkamagaluru)": "577101",
      "Yagati S.O": "577140",
      "Balehole S.O": "577179",
      "Hariharapura S.O": "577120",
      "Lakkavalli S.O": "577128",
      "Sringeri S.O": "577139"
    },
    "CHITRADURGA": {
      "Malali B.O": "577515",
      "Marabhaghatta B.O": "577515",
      "Sanehally B.O": "577515",
      "Kabbala B.O": "577597",
      "Kerehosahally B.O": "577597",
      "Thandaga B.O": "577597",
      "Bhahadurghatta B.O": "577519",
      "Halavadara B.O": "577541",
      "Lakshmisagara B.O": "577541",
      "Gavirangapura B.O": "577542",
      "Heggere B.O": "577542",
      "Somenahally B.O": "577542",
      "Vengalapura B.O": "577542",
      "Ayyanahalli BO": "577502",
      "Madanayakanahalli B.O": "577502",
      "Matadakurabarahatty B.O": "577502",
      "Megalahally B.O": "577502",
      "Hunsekatte B.O": "577517",
      "Kadabanakatte B.O": "577517",
      "Harthikote B.O": "577545",
      "Hemadala B.O": "577545",
      "Ikkanur B.O": "577511",
      "Javanagondanahally B.O": "577511",
      "Kariyala B.O": "577511",
      "Talavatti B.O": "577558",
      "Byadareddyhally B.O": "577543",
      "Chikkammanahally B.O": "577543",
      "Ghataparthy B.O": "577543",
      "Kodihally B.O": "577511",
      "Gonuru B.O": "577517",
      "Haikal B.O": "577517",
      "Pitlali B.O": "577511",
      "T. Nagenahally B.O": "577511",
      "Arnakatte B.O": "577511",
      "Bharampura B.O": "577558",
      "Hulithotlu B.O": "577558",
      "Aralihally B.O": "577515",
      "Konguvalli B.O": "577515",
      "Ballalasamudra B.O": "577597",
      "Chowlihalli B.O": "577519",
      "Kurubarahally B.O": "577599",
      "Obalapura B.O": "577542",
      "Guddadarangavanahally B.O": "577502",
      "Rayanahally B.O": "577502",
      "Buddanahatty B.O": "577543",
      "Mannekote B.O": "577543",
      "Valase B.O": "577543",
      "Bangarakkanahally B.O": "577517",
      "Kunabevu B.O": "577517",
      "Mallappanahally B.O": "577545",
      "Halagaladdi B.O": "577596",
      "Khandenahalli B.O": "577596",
      "Kasturirangappanahally B.O": "577511",
      "Ranganathapura B.O": "577511",
      "Guilal B.O": "577558",
      "Suragondanahally B.O": "577558",
      "Kondajji B.O": "577515",
      "Alaghatta B.O": "577541",
      "Kainadu B.O": "577542",
      "S. Nerlakere B.O": "577542",
      "Chikkagondanahally B.O": "577502",
      "Thimmappaiahnahally B.O": "577543",
      "Belaghatta B.O": "577517",
      "Ambalagere B.O": "577545",
      "Rangenahally B.O": "577545",
      "Sidlaiahnakote B.O": "577545",
      "Kanajanahalli B.O": "577596",
      "Devapura B.O": "577527",
      "Doddaghatta B.O": "577598",
      "Lakkihally B.O": "577527",
      "Madderu B.O": "577527",
      "B.G.Kere B.O": "577529",
      "Gowrasamudra B.O": "577529",
      "Konasagara B.O": "577529",
      "Dogganahal B.O": "577531",
      "Kunigali B.O": "577531",
      "Ramaghatta B.O": "577531",
      "Arabhaghatta B.O": "577554",
      "Janthikolalu B.O": "577554",
      "Madakarinayakanakote B.O": "577532",
      "Palavvanahally B.O": "577532",
      "Bukkasagara B.O": "577533",
      "Kanchipura B.O": "577533",
      "Kittadhahal B.O": "577533",
      "Chikkerahally B.O": "577535",
      "Rayapura B.O": "577535",
      "Tumakurulahalli B.O": "577535",
      "Mustalagummi B.O": "577536",
      "Nelagathanahatti B.O": "577536",
      "Aralahalli B.O": "577527",
      "Attimagge B.O": "577527",
      "Madhure B.O": "577527",
      "Maragondanadibba B.O": "577527",
      "Talya B.O": "577527",
      "Devaredduyhally B.O": "577529",
      "Hanumanthanahally B.O": "577529",
      "Hirehally B.O": "577529",
      "Neralahalli B.O": "577529",
      "Burujanaroppa B.O": "577532",
      "Hiremadhure B.O": "577532",
      "Doddatekalavatti B.O": "577533",
      "Guddadaneralakere B.O": "577533",
      "Karpurakatte B.O": "577533",
      "Nagathihally B.O": "577533",
      "Chikkobanahally B.O": "577535",
      "Hangal B.O": "577535",
      "Hirekerehally B.O": "577535",
      "Nagasamudra B.O": "577535",
      "Nerlagunte B.O": "577536",
      "Chitranaikanahalli B.O": "577537",
      "Junjaragunte B.O": "577538",
      "Korlakunte B.O": "577538",
      "Tuppadahalli B.O": "577539",
      "Gunderi B.O": "577526",
      "Vishwanathanahally B.O": "577526",
      "Bokikere B.O": "577527",
      "Devigere B.O": "577527",
      "Gattihosahally B.O": "577527",
      "Kellodu B.O": "577527",
      "Madadakere B.O": "577527",
      "Kengunte B.O": "577531",
      "Shivapura B.O": "577531",
      "Burudekatte B.O": "577554",
      "Hebbali B.O": "577554",
      "Jampannaikanakote B.O": "577532",
      "Sondekere B.O": "577532",
      "Chikkabyaladakere B.O": "577533",
      "Karehalli B.O": "577533",
      "Byrapura B.O": "577535",
      "Siddapura B.O": "577520",
      "Abbaiahnahalli B.O": "577536",
      "Mallurahalli B.O": "577536",
      "N.Mahadevapura B.O": "577536",
      "Doddaullarthi B.O": "577537",
      "Durgavara B.O": "577537",
      "Holalkere R.S B.O": "577526",
      "Malenahalli B.O": "577526",
      "Narayanagondanahally B.O": "577526",
      "Shivaganaga B.O": "577526",
      "Honnenahalli B.O": "577527",
      "Hunavinadu B.O": "577527",
      "Janakal B.O": "577527",
      "Dummi B.O": "577531",
      "Kalkere B.O": "577531",
      "Annivala B.O": "577554",
      "Bosedevarahatti B.O": "577536",
      "Gowdagere B.O": "577536",
      "Mylanahally B.O": "577537",
      "Renukapura B.O": "577537",
      "Thippareddyhally B.O": "577537",
      "Doddachelur B.O": "577538",
      "Gosikere B.O": "577538",
      "Gangasamudra B.O": "577539",
      "R. Nulenur B.O": "577539",
      "Talakatta B.O": "577539",
      "Dadagur B.O": "577540",
      "Devasamudra B.O": "577540",
      "Murudi B.O": "577540",
      "Thimmalapura B.O": "577540",
      "Basavasivanakere B.O": "577541",
      "Byalahal B.O": "577541",
      "Chikkabennur B.O": "577541",
      "Doddiganahal B.O": "577541",
      "Donehalli B.O": "577537",
      "Katammadevarakote B.O": "577537",
      "Doddabeeranahally B.O": "577538",
      "P. Mahadevapura B.O": "577538",
      "Siddeswaranadurga B.O": "577538",
      "Thimmanayakanakote B.O": "577538",
      "Rangapura B.O": "577539",
      "Santhgudda B.O": "577540",
      "Alagawadi B.O": "577541",
      "Channammanagathihally B.O": "577538",
      "Chowlur B.O": "577538",
      "Marikunte B.O": "577538",
      "Suranahally B.O": "577538",
      "Gowdihalli B.O": "577539",
      "Singenahally B.O": "577539",
      "Talikatte B.O": "577539",
      "Jagirbuddenahally B.O": "577540",
      "Thammenahally B.O": "577540",
      "Venkatapura B.O": "577540",
      "Palya B.O": "577520",
      "Hullehal B.O": "577521",
      "Adanur B.O": "577526",
      "Sanikere B.O": "577522",
      "Somaguddu B.O": "577522",
      "Yadalaghatta B.O": "577522",
      "Dandinakurubarahatti B.O": "577524",
      "Kolahalli B.O": "577557",
      "T.Nulenur B.O": "577557",
      "Tekalavatti B.O": "577557",
      "Upparigenahalli B.O": "577557",
      "Sugur B.O": "577546",
      "Beeranahally B.O": "577599",
      "Ganaikanahally B.O": "577599",
      "Gowdanahally B.O": "577598",
      "Halmadenahalli B.O": "577598",
      "Peelali B.O": "577598",
      "Yalanadu B.O": "577598",
      "Yelladakere B.O": "577598",
      "Isamudra B.O": "577519",
      "Chikkapura B.O": "577520",
      "Kadleguddu B.O": "577520",
      "Muddapura B.O": "577521",
      "Yelagodu B.O": "577521",
      "Taralabalu Circle B.O": "577518",
      "Belagere B.O": "577522",
      "Hulikunte B.O": "577522",
      "Kaparahally B.O": "577522",
      "Nagaramgere B.O": "577522",
      "Ramajogihally B.O": "577522",
      "Pagadalabande B.O": "577522",
      "Hireyemmiganur B.O": "577523",
      "Kodagavalli B.O": "577523",
      "Dyamavvanahally B.O": "577524",
      "Kurumaradikere B.O": "577524",
      "Amruthapura B.O": "577557",
      "Doddakittadahalli B.O": "577557",
      "Byadarahally B.O": "577546",
      "Maskal B.O": "577546",
      "Venkalgudda B.O": "577546",
      "Gownahally B.O": "577599",
      "Metikurke B.O": "577599",
      "Alur B.O": "577598",
      "Huvinahole B.O": "577598",
      "Uduvally B.O": "577598",
      "Gilikenahalli B.O": "577526",
      "Kogunde B.O": "577519",
      "Hirekandawadi B.O": "577518",
      "Kalaghatta B.O": "577518",
      "Dodderi B.O": "577522",
      "Gopanahalli B.O": "577522",
      "Haravigondanahalli B.O": "577522",
      "Hottappanahalli B.O": "577522",
      "Karikere B.O": "577522",
      "Chikkandawadi B.O": "577523",
      "Chikkayemmiganur B.O": "577523",
      "Madikerepura B.O": "577524",
      "Annehal B.O": "577555",
      "Hullur B.O": "577555",
      "Pandarahally B.O": "577555",
      "Sondekola B.O": "577555",
      "Vanivilasapura B.O": "577599",
      "Dindavara B.O": "577598",
      "Hampanur B.O": "577519",
      "Kalgere B.O": "577519",
      "Kolahalu B.O": "577519",
      "Bommenahalli B.O": "577520",
      "Hireguntanur B.O": "577520",
      "Muthugadur B.O": "577518",
      "Balenahalli B.O": "577522",
      "Jajur B.O": "577522",
      "Meerasabihally B.O": "577522",
      "Nannivala B.O": "577522",
      "Gonjiganur B.O": "577523",
      "Kadur B.O": "577523",
      "Ingaladahal B.O": "577524",
      "Kyadigere B.O": "577524",
      "Toparamalige B.O": "577524",
      "Chitrahally B.O": "577557",
      "Echagatta B.O": "577557",
      "Abbinahole B.O": "577546",
      "Myaklurahally B.O": "577599",
      "Babbur Farm B.O": "577598",
      "Kasavanahally B.O": "577598",
      "Beesanahally B.O": "577526",
      "Chitradurga H.O": "577501",
      "Aimangala S.O": "577558",
      "Bndurga S.O": "577518",
      "Challakere S.O": "577522",
      "Chickjajur S.O": "577523",
      "Chitradurga  Fort S.O": "577501",
      "Bagur S.O (Chitradurga)": "577515",
      "Belagur S.O": "577597",
      "Chitradurga  Dist Office S.O": "577501",
      "Adivala S.O": "577511",
      "Bheemasamudra S.O": "577520",
      "Doddasiddavvanahalli S.O": "577524",
      "H.D.Pura S.O": "577557",
      "Hariyabbe S.O": "577546",
      "Obalapura S.O": "577537",
      "Parasurampura S.O": "577538",
      "Ramagiri S.O (Chitradurga)": "577539",
      "Rampura S.O (Chitradurga)": "577540",
      "Jayachamarajendra Extn. S.O": "577502",
      "Bharamasagara S.O": "577519",
      "Challakere Bazar S.O": "577522",
      "Chitradurga  Collegeroad S.O": "577501",
      "Godabanahal S.O": "577555",
      "Holalkere S.O": "577526",
      "Kanaka Circle Chitradurga S.O": "577501",
      "Kondlahalli S.O": "577529",
      "Mallappanahalli S.O": "577554",
      "Maradihalli S.O": "577532",
      "Mathodu S.O": "577533",
      "Nayakanahatti S.O": "577536",
      "Station Road chitradurga S.O": "577502",
      "Hiriyur S.O": "577598",
      "Srirampura S.O": "577542",
      "Thallak S.O": "577543",
      "Turuvanur S.O": "577517",
      "Chitradurga Chickpet S.O": "577501",
      "Hiriyur  Sugar Factory S.O": "577599",
      "Hosadurga S.O": "577527",
      "Malladihalli S.O": "577531",
      "Molakalmuru S.O": "577535",
      "Sirigere S.O (Chitradurga)": "577541",
      "Yerabally S.O": "577545",
      "Dharmapura S.O": "577596"
    },
    "MYSURU": {
      "Kodagahalli B.O": "571101",
      "Maliyur B.O": "571101",
      "Srirampura B.O": "570008",
      "Hanchya BO": "570019",
      "Barse B.O": "571102",
      "Bhuvanahalli B.O": "571102",
      "Gorahalli B.O": "571102",
      "Konasur B.O": "571102",
      "Bolanahalli B.O": "571103",
      "Chikkabeechanahalli B.O": "571103",
      "Kyathanahalli B.O": "570026",
      "Martikyathanahalli B.O": "570026",
      "Channamgere B.O": "571617",
      "Haleyur B.O": "571617",
      "Mullur B.O": "571121",
      "Chikkeriyur B.O": "571125",
      "Kunthanabelathur B.O": "571125",
      "Maddur B.O": "571125",
      "Arjunahalli B.O": "571601",
      "Guluvina Attiguppe B.O": "571601",
      "Gurur B.O": "570008",
      "Naganahalli B.O": "571114",
      "Koorgalli B.O": "570018",
      "Haradur B.O": "571102",
      "Kothavalli B.O": "571102",
      "Melur B.O": "571604",
      "Manuganahalli B.O": "571103",
      "Shanuboganahalli B.O": "571103",
      "Kailasapura B.O": "571104",
      "Koppa B.O": "571104",
      "Ankanahalli B.O": "571604",
      "Hadya B.O": "571315",
      "Kolur B.O": "571617",
      "Kuppe B.O": "571617",
      "Chikkadaganahalli B.O": "571610",
      "Thondalu B.O": "571610",
      "Munjanahalli B.O": "571601",
      "Matakere B.O": "571121",
      "Metikuppe B.O": "571114",
      "Nisana Belathur B.O": "571114",
      "Hareenahalli B.O": "571105",
      "Maradur B.O": "571105",
      "Nallurpala B.O": "571105",
      "Ambalare B.O": "571102",
      "Attigodu B.O": "571102",
      "Nilavadi B.O": "571102",
      "Sangarasettihalli B.O": "571102",
      "Halebeedu B.O": "571103",
      "Alanahalli B.O": "570026",
      "Doddamaragowdanahalli B.O": "570026",
      "G B Sargur B.O": "570026",
      "Hosakote B.O": "571617",
      "Karthalu B.O": "571617",
      "Kittur B.O": "571617",
      "Hyrige B.O": "571125",
      "Jampanahalli B.O": "571125",
      "Kanchamalli B.O": "571125",
      "Kolagala B.O": "571125",
      "Hosa Agrahara B.O": "571601",
      "Kanchinakere B.O": "571601",
      "Annur B.O": "571114",
      "Antharasanthe B.O": "571114",
      "Chakkodanahalli B.O": "571114",
      "Hebbalaguppe B.O": "571114",
      "Hirehalli B.O": "571114",
      "Hosaholalu B.O": "571114",
      "Jakkahalli B.O": "571114",
      "Bannikuppe B.O": "571105",
      "Beeramballi B.O": "571116",
      "N Begur B.O": "571116",
      "Ayyarahalli B.O": "571311",
      "Doddakanya B.O": "571311",
      "Hadajana B.O": "571311",
      "Doddakamaravalli B.O": "571187",
      "Harave B.O": "571134",
      "Hirekyathanahalli B.O": "571134",
      "Kothegala B.O": "571121",
      "Marchahalli B.O": "571602",
      "Sindhuvalli B.O": "571311",
      "Dornahalli B.O": "571602",
      "Hebbalu B.O": "571602",
      "Hosur Kallahalli B.O": "571602",
      "Kaggere B.O": "571602",
      "Kellur B.O": "571108",
      "Makodu B.O": "571108",
      "Thammadahalli B.O": "571108",
      "Ballur B.O": "571604",
      "Hanchipura B.O": "571121",
      "M C Thalalu B.O": "571121",
      "Moleyur B.O": "571121",
      "Anandur B.O": "571130",
      "Madigahalli B.O": "571101",
      "Mavathur B.O": "571602",
      "Siddapura B.O": "571602",
      "Tippur B.O": "571602",
      "Gandanahalli B.O": "571603",
      "Kamplapura B.O": "571107",
      "Kandegala B.O": "571107",
      "Malangi B.O": "571442",
      "Mutthur B.O": "571107",
      "Dharmapura B.O": "571189",
      "Hundimala B.O": "571189",
      "Karimuddanahalli B.O": "571189",
      "Paduvakote B.O": "571189",
      "Singaramaranahalli B.O": "571189",
      "Haradanahalli B.O": "571314",
      "Honnenahalli B.O": "571106",
      "Sigavalu B.O": "571604",
      "Thandre B.O": "571604",
      "Beeravalu B.O": "571121",
      "Thumbasoge B.O": "571121",
      "Nagawala B.O": "571130",
      "S Hemmanahalli B.O": "571130",
      "Neralakuppe B.O": "571106",
      "Kallahalli B.O": "571105",
      "Somanahalli B.O": "571105",
      "Uddur B.O": "571105",
      "Bidarahalli B.O": "571116",
      "Mandakalli B.O": "571311",
      "Someshwarapura B.O": "571311",
      "Rajanabilugali B.O": "571187",
      "Basavarajapura B.O": "571602",
      "Chandagala B.O": "571602",
      "Kalenahalli B.O": "571602",
      "Alanahlli B.O": "571107",
      "Hebbathur B.O": "571107",
      "Poonadahalli B.O": "571107",
      "Aswalu B.O": "571189",
      "Coimbatore Colony B.O": "571189",
      "Arenahalli B.O": "571108",
      "Kelaganahalli B.O": "571108",
      "Chikkanayakanahalli B.O": "571604",
      "Mundur B.O": "571604",
      "Hadanur B.O": "571121",
      "Itna B.O": "571121",
      "Nanjipura B.O": "571121",
      "Daddakallahalli B.O": "571130",
      "Mydanahalli B.O": "571130",
      "Tattekere B.O": "571106",
      "Doddamulagodu B.O": "571101",
      "Heggur B.O": "571101",
      "Rayanakere B.O": "570008",
      "Udbur B.O": "570008",
      "Siddalingapura B.O": "570003",
      "Ramanahalli B.O": "570019",
      "Bettadathunga B.O": "571102",
      "Chapparadahalli B.O": "571102",
      "Chikkanerale B.O": "571102",
      "Komalapura B.O": "571102",
      "Gagenahalli B.O": "571103",
      "Hussainpura B.O": "571103",
      "Kergalli B.O": "570026",
      "Mallahalli B.O": "570026",
      "Hanasoge B.O": "571617",
      "Hosur B.O": "571617",
      "Chakkur B.O": "571125",
      "Madapura B.O": "571315",
      "Bheriya B.O": "571601",
      "Galigekere B.O": "571601",
      "Doddabyranakuppe B.O": "571114",
      "Kollegowdanahalli B.O": "571114",
      "Kotige Yedathore B.O": "571114",
      "Chilkunda B.O": "571105",
      "Gurupura B.O": "571105",
      "Panchavalli B.O": "571105",
      "Malali B.O": "571116",
      "Nerale B.O": "571312",
      "Devalapura B.O": "571311",
      "Taloor B.O": "571311",
      "Halaganahalli B.O": "571187",
      "Honnapura B.O": "571187",
      "Modur B.O": "571134",
      "Byadarahalli B.O": "571602",
      "Kestur(Hunsur) B.O": "571602",
      "Krishnapura B.O": "571602",
      "Natanahalli B.O": "571603",
      "Chowthi B.O": "571107",
      "Hitnehebbagilu B.O": "571107",
      "Nandinathapura B.O": "571107",
      "Ballenahalli B.O": "571189",
      "Shanthipura B.O": "571189",
      "Doddabylalu B.O": "571108",
      "Lakkikuppe B.O": "571604",
      "Ramapura B.O": "571604",
      "Sagare B.O": "571121",
      "Kallur Naganahalli B.O": "571130",
      "Doddahejjur B.O": "571106",
      "Attahlli B.O": "571101",
      "Hanumanalu B.O": "571101",
      "Kethupura B.O": "571101",
      "Rangasamudra B.O": "571101",
      "Turuganur B.O": "571101",
      "Yachenahalli B.O": "571101",
      "Binakanahalli B.O": "571110",
      "Kempainahundi B.O": "571110",
      "Kupya B.O": "571110",
      "Kaliyur B.O": "571442",
      "Horalahalli B.O": "571120",
      "Ukkalagere B.O": "571120",
      "Hiriyur B.O": "571124",
      "Hosa Alagodu B.O": "571124",
      "Hemmige B.O": "571122",
      "M K Hundi B.O": "571110",
      "Thumbala B.O": "571110",
      "Chiduravalli B.O": "571120",
      "Hyakanur B.O": "571124",
      "Karuhatti B.O": "571124",
      "Kiragasur B.O": "571124",
      "Kurubur B.O": "571124",
      "Muguru B.O": "571124",
      "Seehalli B.O": "571101",
      "Doddahebbagilu B.O": "571120",
      "Kolathur B.O": "571120",
      "Vyasarajapura B.O": "571120",
      "Byrapura B.O": "571124",
      "Danaikanapura B.O": "571124",
      "Nilasoge B.O": "571124",
      "Vatalu B.O": "571124",
      "Kukkur B.O": "571122",
      "T Bettahalli B.O": "571122",
      "Kempegowdana Koppalu B.O": "571101",
      "Somanathapura B.O": "571120",
      "Bannahalli Hundi B.O": "571124",
      "Kanahalli B.O": "571124",
      "Thayur B.O": "571124",
      "Kaveripura B.O": "571122",
      "Mavinahallli B.O": "571122",
      "Heggadahalli B.O": "571314",
      "Kadabur B.O": "571314",
      "Kanenur B.O": "571314",
      "Hosakadajetty B.O": "571315",
      "Maduvinahalli B.O": "571315",
      "Kudlapura B.O": "571118",
      "Kugalur B.O": "571118",
      "Navilur B.O": "571118",
      "Halepura B.O": "571312",
      "Hedathale B.O": "571312",
      "Konanur B.O": "571312",
      "Biligere B.O": "571129",
      "Chunchanahalli B.O": "571119",
      "Devanur B.O": "571119",
      "Karya B.O": "571119",
      "Hadinaru B.O": "571302",
      "Maralur B.O": "571302",
      "Kurahatti B.O": "571118",
      "Badanavalu B.O": "571312",
      "Hemmaragala B.O": "571312",
      "Dasanur B.O": "571316",
      "Kalkunda B.O": "571129",
      "Mallupura B.O": "571119",
      "Bokkahalli B.O": "571302",
      "K S Hundi B.O": "571302",
      "Yechagalli B.O": "571302",
      "Chinnadagudihundi B.O": "571312",
      "Gejjiganahalli B.O": "571129",
      "Kupparavalli B.O": "571129",
      "Suttur B.O": "571129",
      "Thumnerale B.O": "571129",
      "Sirmalli B.O": "571314",
      "Hediyala B.O": "571315",
      "Debur B.O": "571314",
      "Katur B.O": "571314",
      "Rampura B.O": "571314",
      "Haginavalu B.O": "571315",
      "Naganapura B.O": "571315",
      "Valagere B.O": "571315",
      "Deveerammanahalli B.O": "571118",
      "Sinduvalli B.O": "571118",
      "Gattavadi B.O": "571312",
      "Vidyapeetha B.O": "571312",
      "Bilugali B.O": "571129",
      "Horalavadi B.O": "571129",
      "S Hoskote B.O": "571129",
      "Alaganchi B.O": "571119",
      "Kirugunda B.O": "571119",
      "Chandrawadi B.O": "571314",
      "Kurihundi B.O": "571314",
      "Devarayasettipura B.O": "571315",
      "Hallare B.O": "571315",
      "Devarasanahalli B.O": "571118",
      "Kasuvinahalli B.O": "571118",
      "Varakodu B.O": "570010",
      "Lalithadripura B.O": "570028",
      "Chamundi Betta B.O": "570010",
      "Keelanapura B.O": "570010",
      "Doora B.O": "570008",
      "Vajamangala B.O": "570028",
      "Duddagere B.O": "570010",
      "Danagalli B.O": "570008",
      "Gopalapura B.O": "570008",
      "Harohalli B.O": "570028",
      "Varuna B.O": "570010",
      "Yadakola B.O": "570010",
      "Gujjegowdanapura B.O": "570008",
      "Jayapura B.O": "570008",
      "Marballi B.O": "570008",
      "Nanjangud H.O": "571301",
      "Mysuru H.O": "570001",
      "Saraswathipuram H.O": "570009",
      "Bannur S.O": "571101",
      "Heggadedevana Kote S.O": "571114",
      "Kadakola S.O": "571311",
      "Kattemalalavadi S.O": "571134",
      "Krishna Raja Nagar S.O": "571602",
      "Mysuru Law Courts S.O": "570005",
      "Saligrama S.O (Mysuru)": "571604",
      "Yelwal S.O": "571130",
      "Hunsur S.O": "571105",
      "Kuvempunagar S.O (Mysuru)": "570023",
      "Hanagodu S.O": "571106",
      "Dattagalli S.O": "570033",
      "Kabini Colony S.O": "571116",
      "Kanagal S.O": "571187",
      "Mirle S.O": "571603",
      "Periyapatna S.O": "571107",
      "Ravandur S.O": "571108",
      "Sri Rampura 2nd Stage S.O": "570034",
      "Infosys Campus S.O": "570027",
      "Jayanagar S.O (Mysuru)": "570014",
      "Kuvempunagar II Stage S.O": "570023",
      "Ramakrishna Nagar S.O (Mysuru)": "570022",
      "Rathnapuri Colony S.O": "571189",
      "Sargur S.O": "571121",
      "Gokulam S.O": "570002",
      "Ittigegud S.O": "570010",
      "Krishnamurthypuram S.O": "570004",
      "Mandimohalla S.O": "570001",
      "Mysuru Fort S.O": "570004",
      "PTC Campus S.O": "570010",
      "Vani Vilas Mohalla S.O": "570002",
      "Gavadagere S.O": "571610",
      "Hampapura (H D Kote) S.O": "571125",
      "Chamundi Extension S.O": "570004",
      "G S Ashram S.O": "570025",
      "Jaya Prakash Nagar S.O": "570031",
      "Krishna Rajendra Circle S.O": "570001",
      "Gargeshwari S.O": "571110",
      "Narasimha Raja Mohalla S.O": "570007",
      "Note Mudran Nagar S.O": "570003",
      "Udayagiri S.O (Mysuru)": "570019",
      "Yadavagiri S.O": "570020",
      "Mysuru Sorting": "570001",
      "Belavadi S.O": "570018",
      "Bettadapura S.O": "571102",
      "Bilikere S.O": "571103",
      "Bogadi S.O": "570026",
      "Bylakuppe S.O": "571104",
      "Chunchunakatte S.O": "571617",
      "T Narasipura S.O": "571124",
      "Nagarle S.O": "571129",
      "Thandavapura S.O": "571302",
      "Old Sosale S.O": "571120",
      "Hullahalli S.O": "571314",
      "Kalale S.O": "571118",
      "Kavalande S.O": "571312",
      "Srikantapuri Extension S.O": "571301",
      "Bannimantap S.O": "570015",
      "Jayalakshmipuram S.O (Mysuru)": "570012",
      "Krishna Raja Mohalla S.O": "570004",
      "Lakshmipuram S.O (Mysuru)": "570004",
      "Vijayanagar III Stage S.O": "570030",
      "Vijayanagar IV Stage S.O": "570032",
      "Hampapura (K R Nagar) S.O": "571601",
      "Talakad S.O": "571122",
      "Hura S.O (Mysuru)": "571315",
      "Tagadur S.O": "571119",
      "Alanahalli S.O": "570028",
      "Hebbal Layout S.O": "570016",
      "Manasagangothri S.O": "570006",
      "Metagalli S.O": "570016",
      "Mysuru South S.O": "570008",
      "Mysuru University S.O": "570005",
      "Shakthinagar S.O": "570029",
      "Shivaraathreeswar Nagar S.O": "570015",
      "Siddarthanagar Nagar S.O": "570011",
      "University Campus S.O (Mysuru)": "570006",
      "Vijaynagar II Stage S.O": "570017"
    },
    "BELAGAVI": {
      "Turkarshigihalli B.O": "591115",
      "Bailur B.O": "590018",
      "Dastikop B.O": "591153",
      "Holenaglapur B.O": "591153",
      "Chikkop B.O": "591119",
      "Yarzarvi B.O": "591119",
      "Ugarkhod B.O": "591115",
      "Hunshikatti B.O": "591153",
      "Kadrolli B.O": "591153",
      "Turmuri B.O": "591153",
      "Markumbi B.O": "591119",
      "Nugganatti B.O": "591119",
      "Sangolli B.O": "591115",
      "Veerapur B.O": "591118",
      "Rudrapur B.O": "591119",
      "Tadsalur B.O": "591119",
      "Tigadolli B.O": "591115",
      "Devara Shigihalli B.O": "591153",
      "Holehosur B.O": "591118",
      "Hirebudnur B.O": "591119",
      "Hanchinal B.O": "591243",
      "Ugargol B.O": "591173",
      "Chandargi B.O": "591114",
      "Chunchnur B.O": "591114",
      "Godachi B.O": "591114",
      "Hanamasagar B.O": "591114",
      "Aratgal B.O": "591117",
      "Madlur B.O": "591117",
      "Shindogi B.O": "591117",
      "Tallur B.O": "591117",
      "Tegghal B.O": "591117",
      "Mabnur BO": "591117",
      "Chipalkatti B.O": "591130",
      "Hoskoti B.O": "591130",
      "Kullur B.O": "591130",
      "Narasapur B.O": "591130",
      "Kagdhal B.O": "591126",
      "Avaradi B.O": "591310",
      "Gonnagar B.O": "591127",
      "Kalhal B.O": "591127",
      "Hirekop B.O": "591114",
      "Kunnal B.O": "591114",
      "Benkatti B.O": "591117",
      "Jakabal B.O": "591117",
      "M D SITE BO": "591126",
      "Bijaguppi B.O": "591130",
      "Udpudi B.O": "591130",
      "Gorbal B.O": "591126",
      "Karikatti B.O": "591126",
      "Kittur (SDT) B.O": "591127",
      "Kadabi B.O": "591129",
      "Madamgeri B.O": "591129",
      "Hulkund B.O": "591114",
      "Sidnal B.O": "591211",
      "Bhandarhalli B.O": "591117",
      "Bannur B.O": "591265",
      "Chilmur B.O": "591130",
      "Tondikatti B.O": "591130",
      "Betsur B.O": "591126",
      "Hireulligeri B.O": "591126",
      "Hooli B.O": "591126",
      "Lakhanayakankoppa BO": "591126",
      "Sangal B.O": "591127",
      "Kodliwad B.O": "591129",
      "Mugalihal B.O": "591106",
      "Sattigeri B.O": "591129",
      "Torangatti B.O": "591114",
      "Torgal B.O": "591114",
      "Goravankolla B.O": "591126",
      "Asundi B.O": "591126",
      "Devalapur B.O": "591102",
      "Harugoppa B.O": "591102",
      "Nagnur B.O": "591241",
      "Budihal B.O": "591317",
      "Pattihal B.O": "591104",
      "Sutgatti B.O": "591147",
      "Aralikatti B.O": "591107",
      "Chikbagewadi B.O": "591109",
      "Giriyal B.O": "591109",
      "Yakkundi B.O": "591111",
      "Gandigwad B.O": "591112",
      "Margankop B.O": "591112",
      "Nichanki B.O": "591115",
      "Hannikeri B.O": "591102",
      "K.K.Koppa B.O": "591109",
      "Mutnal B.O": "591109",
      "Bogur B.O": "591112",
      "Chikmanoli B.O": "591112",
      "Hiremanoli B.O": "591112",
      "Tolgi B.O": "591112",
      "Bailwad B.O": "591102",
      "Chachadi B.O": "591102",
      "Nayanagar B.O": "591102",
      "Vakkund B.O": "591102",
      "Yardal B.O": "591102",
      "Budarkatti B.O": "591104",
      "Dodwad B.O": "591104",
      "Udikeri B.O": "591104",
      "Buranaki B.O": "591106",
      "Mangyankop B.O": "591106",
      "Surpur Kerwad B.O": "591106",
      "Mattikoppa B.O": "591147",
      "Ankalgi B.O": "591109",
      "Bhendigeri B.O": "591109",
      "Goddikurvinkoppa B.O": "591109",
      "Mallur B.O": "591111",
      "Sri Kshetra Sogal B.O": "591111",
      "Hoolikatti (KTR) B.O": "591112",
      "Degaon B.O": "591115",
      "Kittur Channamma School B.O": "591115",
      "Kulvalli B.O": "591115",
      "Hoolikatti B.O": "591126",
      "Horalkatti B.O": "591126",
      "Inamhongal B.O": "591126",
      "Mullur B.O": "591126",
      "Sangreshkop B.O": "591126",
      "Sirsangi B.O": "591126",
      "Sutagatti (SDT) B.O": "591126",
      "Akkisagar B.O": "591129",
      "Rainapur B.O": "591129",
      "Shivapur B.O": "591129",
      "Soppadla B.O": "591129",
      "Inchal B.O": "591102",
      "Lakkundi B.O": "591102",
      "Neginhal B.O": "591102",
      "Govankop B.O": "591104",
      "Hirebellikatti B.O": "591104",
      "Kenganur B.O": "591104",
      "Khudanpur B.O": "591104",
      "Mugbasav B.O": "591104",
      "Kakkeri B.O": "591106",
      "Linganmath B.O": "591106",
      "Badli B.O": "591111",
      "Ingalgi B.O": "591111",
      "Karalkatti B.O": "591111",
      "Ambadgatti B.O": "591112",
      "Basarkod B.O": "591115",
      "Hirenandihalli B.O": "591115",
      "Kalbhavi B.O": "591115",
      "Kittur Somwarpeth B.O": "591115",
      "Amtur B.O": "591102",
      "Anigol B.O": "591102",
      "Gundewadi B.O": "591304",
      "Parthanhalli B.O": "591304",
      "Saptasagar B.O": "591304",
      "Nandgaon": "591304",
      "Darur": "591304",
      "Kodaganur": "591304",
      "Adhalli B.O": "591248",
      "Artal B.O": "591248",
      "Kirangi B.O": "591212",
      "Shirur B.O": "591212",
      "Alaknur B.O": "591220",
      "Khavtkoppa B.O": "591220",
      "Ghatnatti B.O": "591304",
      "Hulagbali B.O": "591304",
      "Sankonahatti B.O": "591304",
      "Badgi B.O": "591248",
      "Katral B.O": "591303",
      "Khilegaon B.O": "591212",
      "Malabad": "591212",
      "Koligudda B.O": "591220",
      "Shegunshi B.O": "591220",
      "Murgundi B.O": "591304",
      "Shirhatti B.O": "591305",
      "Shivayoginagar B.O": "591304",
      "Tirth B.O": "591304",
      "Phadatarwadi B.O": "591248",
      "Yelihadalgi B.O": "591248",
      "Krishna Kittur B.O": "591303",
      "Mole B.O": "591303",
      "Ajur B.O": "591212",
      "Balligeri B.O": "591212",
      "Bevanur B.O": "591212",
      "Hidkal B.O": "591220",
      "Kot B.O": "591254",
      "Arjunwad B.O": "591309",
      "Fulgaddi B.O": "591224",
      "Hunshyal P.G. Cross B.O": "591224",
      "Hunshyal PG B.O": "591224",
      "Waderhatti B.O": "591224",
      "Akkiwat B.O": "591225",
      "Bad B.O": "591225",
      "Dhavaleshwar B.O": "591310",
      "Kemmankol B.O": "591233",
      "Khandratti B.O": "591233",
      "Awarkhod B.O": "591304",
      "Balwad B.O": "591304",
      "Hallihal B.O": "591304",
      "Ingalgaon B.O": "591304",
      "Katgeri B.O": "591304",
      "Sankonhatti B.O": "591304",
      "Abbihal": "591304",
      "Chamakeri B.O": "591248",
      "Kohalli B.O": "591248",
      "Tangadi B.O": "591303",
      "Tavashi B.O": "591212",
      "Sankratti B.O": "591220",
      "Akkatangerhal B.O": "591101",
      "Mallapur KA B.O": "591101",
      "Suldhal B.O": "591101",
      "Hulloli B.O": "591305",
      "Jaganur B.O": "591305",
      "Sarapur B.O": "591305",
      "Maldinni B.O": "591233",
      "Talakatnal B.O": "591233",
      "Hirenandi B.O": "591233",
      "Dharmatti B.O": "591312",
      "Gurlapur B.O": "591312",
      "Munyal B.O": "591312",
      "Kochari B.O": "591340",
      "Ammanagi B.O": "591236",
      "Amminbhavi B.O": "591236",
      "Basapur B.O": "591122",
      "Bugatealur B.O": "591313",
      "Hadalga B.O": "591313",
      "Naganur KM B.O": "591254",
      "Salamwadi B.O": "591254",
      "Badigwad B.O": "591306",
      "Gudas B.O": "591306",
      "Kotabagi B.O": "591306",
      "Pamaldinni B.O": "591306",
      "Badakundri B.O": "591221",
      "Kurni B.O": "591221",
      "Hattialur B.O": "591107",
      "Hukeri Kutchery Road B.O": "591309",
      "Avargol B.O": "591309",
      "Shirgaon B.O": "591214",
      "Sultanpur B.O": "591235",
      "Yadgud B.O": "591309",
      "Koninkeri B.O": "591225",
      "Gosbal B.O": "591227",
      "Honakuppi B.O": "591227",
      "Mannikeri B.O": "591227",
      "Benchinmardi B.O": "591344",
      "Kaitnal B.O": "591344",
      "Venkatapur B.O": "591310",
      "Arabhavimath B.O": "591218",
      "Beerangaddi B.O": "591218",
      "Ghataprabha SF B.O": "591218",
      "Hadiginal B.O": "591218",
      "Nallanatti B.O": "591218",
      "Patagundi B.O": "591312",
      "Shivapur H B.O": "591312",
      "Sankeshwar Bazar B.O": "591314",
      "Sankeshwar College Road B.O": "591314",
      "Sankeshwar Market Yard B.O": "591314",
      "Gutagaddi B.O": "591243",
      "Islampur B.O": "591243",
      "Managutti B.O": "591243",
      "Yaragudri B.O": "591136",
      "Madwal B.O": "591101",
      "Tavag B.O": "591101",
      "Bhartesh Gurukul B.O": "591305",
      "Dhupdal B.O": "591306",
      "Karnataka Health Institute B.O": "591306",
      "Zangatihal B.O": "591306",
      "Ullagaddi Khanapur B.O": "591221",
      "Ghodgeri B.O": "591107",
      "Nirwanhatti B.O": "591107",
      "Bastwad B.O": "591317",
      "Beniwad B.O": "591309",
      "Madihali B.O": "591309",
      "Yelimanoli B.O": "591309",
      "Sangankeri B.O": "591224",
      "Hitni B.O": "591225",
      "Mattiwade B.O": "591229",
      "Kalliguddi B.O": "591227",
      "Tigadi B.O": "591125",
      "Kolvi B.O": "591344",
      "Shiltibhavi B.O": "591344",
      "Maradimath B.O": "591231",
      "Nandgaon B.O": "591231",
      "Sunadholi B.O": "591310",
      "Duradundi B.O": "591218",
      "Melvanki B.O": "591218",
      "Betageri B.O": "591233",
      "Khanatti B.O": "591312",
      "Kamatnur B.O": "591340",
      "Kesti B.O": "591236",
      "Mavanur B.O": "591122",
      "Sutagatti B.O": "591243",
      "Badas Khalsa B.O": "591131",
      "Hirehattiholi B.O": "591131",
      "Kodachwad B.O": "591131",
      "Marikatti B.O": "591125",
      "Navalgatti B.O": "591125",
      "Hosavantmuri B.O": "591156",
      "Belavatti B.O": "591108",
      "Benakanhalli B.O": "591108",
      "Amte B.O": "591345",
      "Golyali": "591345",
      "Handignur B.O": "591143",
      "Kednur B.O": "591143",
      "Kurihal B.O": "591143",
      "Karambal B.O": "591302",
      "Lokali B.O": "591302",
      "Manturge B.O": "591302",
      "Nittur B.O": "591302",
      "Nagaragali B.O": "591301",
      "Tavaragatti B.O": "591301",
      "Chapagaon B.O": "591120",
      "Karalga B.O": "591120",
      "Kasaba Nandgad B.O": "591120",
      "Kapoli B.O": "591120",
      "Desur B.O": "590014",
      "Tarihal B.O": "590020",
      "Mastamardi B.O": "590020",
      "Gojage B.O": "591128",
      "Turamari B.O": "591128",
      "Santibastwad B.O": "590018",
      "Ghataknur B.O": "591123",
      "Halagatti B.O": "591123",
      "Haletorgal B.O": "591123",
      "Sri Kshetra Kengeri B.O": "591119",
      "Myakalmardi B.O": "591121",
      "Avarolli B.O": "591131",
      "Devalatti B.O": "591131",
      "Mardinagalapur B.O": "591125",
      "Marihal B.O": "591103",
      "Sulge ( Yellur) B.O": "590005",
      "Ashte B.O": "590015",
      "Karvinkumpi B.O": "591346",
      "Belagundi B.O": "591108",
      "Olmani B.O": "591345",
      "Bombarge B.O": "591143",
      "Baragaon B.O": "591302",
      "Gunji B.O": "591302",
      "Idalahonda B.O": "591302",
      "Topinkatti B.O": "591302",
      "Godholi B.O": "591301",
      "Halasal B.O": "591120",
      "Halga B.O": "590020",
      "Hebbal B.O": "591120",
      "Wagawade RC B.O": "590014",
      "Basvan Kudchi B.O": "591124",
      "Mutage B.O": "591124",
      "Alarwad B.O": "590020",
      "Bekkinkeri B.O": "591128",
      "Kudarimani B.O": "591128",
      "Navage B.O": "590018",
      "Batakurki B.O": "591123",
      "Channapur B.O": "591123",
      "M Timmapur B.O": "591123",
      "Nandihal B.O": "591123",
      "Oblapur B.O": "591123",
      "Chikkumbi B.O": "591110",
      "Dhaderkoppa B.O": "591110",
      "Gubalgudda B.O": "591306",
      "Shindikurbet B.O": "591306",
      "Market Yard B.O": "591307",
      "Yarnal B.O": "591221",
      "Belvi(Bellumbi) B.O": "591309",
      "Naganur B.O": "591224",
      "Rajapur B.O": "591224",
      "Tukkanatti B.O": "591224",
      "Shippur B.O": "591225",
      "Keshappanatti B.O": "591344",
      "Makkalgeri B.O": "591344",
      "Melmanhatti B.O": "591231",
      "Shivapur K B.O": "591231",
      "Bhairnatti B.O": "591310",
      "Hunshyal P.Y B.O": "591310",
      "Arabhavifarm B.O": "591218",
      "Chiknandi B.O": "591233",
      "Hallur B.O": "591312",
      "Kamaldinni B.O": "591312",
      "Masaguppi B.O": "591312",
      "Borgal B.O": "591236",
      "Karaguppi B.O": "591122",
      "Kundargi B.O": "591122",
      "Urabinatti B.O": "591122",
      "Ankle B.O": "591313",
      "Solapur B.O": "591313",
      "Berranholi B.O": "591243",
      "Narasinghpur B.O": "591243",
      "Yabaratti B.O": "591220",
      "Aralihatti B.O": "591232",
      "Handigund B.O": "591235",
      "Itnal B.O": "591235",
      "Kappalguddi B.O": "591235",
      "Khanadal B.O": "591235",
      "Mahishwadgi B.O": "591240",
      "Nandeshwar B.O": "591240",
      "Radderhatti B.O": "591240",
      "Halhalli B.O": "591265",
      "Kakmari B.O": "591265",
      "Kannal B.O": "591265",
      "Kottalgi B.O": "591265",
      "Molwad B.O": "591316",
      "Ugarbudruk B.O": "591316",
      "Padlihal B.O": "591211",
      "Pangire (A) B.O": "591211",
      "Siddapurwadi B.O": "591213",
      "Yadur B.O": "591213",
      "Shamanewadi B.O": "591214",
      "Hunnargi B.O": "591215",
      "Kunnur B.O": "591215",
      "Mangur B.O": "591215",
      "Chikodi Extension B.O": "591201",
      "Belkud B.O": "591222",
      "Mantur B.O": "591222",
      "Gajminhal B.O": "591121",
      "Hanabaratti B.O": "591121",
      "Madanbhavi B.O": "591121",
      "Murkibhavi B.O": "591121",
      "Kukdolli B.O": "591131",
      "Karadiguddi B.O": "591103",
      "Modge B.O": "591103",
      "Yellur B.O": "590005",
      "Kangrali BK B.O": "590010",
      "Muchandi B.O": "590015",
      "Tummarguddi B.O": "591346",
      "Dharnatti B.O": "591346",
      "Bijagarni B.O": "591108",
      "Rakasakoppa B.O": "591108",
      "Nerse B.O": "591302",
      "Ramgurwadi B.O": "591302",
      "Shiroli B.O": "591302",
      "Bekwad B.O": "591120",
      "Machhe B.O": "590014",
      "Nandihalli B.O": "590014",
      "Sindholi B.O": "591124",
      "Majagaon B.O": "590008",
      "Mandoli B.O": "590008",
      "Idgal B.O": "591123",
      "Sunnal B.O": "591123",
      "Umtar B.O": "591123",
      "Hanamgeri B.O": "591126",
      "Suttatti B.O": "591217",
      "Hanamapur B.O": "591232",
      "Shivanur B.O": "591232",
      "Navalihal B.O": "591287",
      "Palbhavi B.O": "591235",
      "Janwad B.O": "591216",
      "Nagnur  P.K. B.O": "591240",
      "Savadi B.O": "591240",
      "Lakhanapur B.O": "591211",
      "Jodkurli B.O": "591213",
      "Kerur B.O": "591213",
      "Shiradwad B.O": "591214",
      "Adi B.O": "591215",
      "Dhonewadi B.O": "591263",
      "Bhiradi B.O": "591217",
      "Chikodi Road B.O": "591222",
      "Kankanwadi B.O": "591222",
      "Umarani B.O": "591222",
      "Jainapur B.O": "591226",
      "Sankanwadi B.O": "591228",
      "Kudchi Town B.O": "591311",
      "Shirgur B.O": "591311",
      "Chikalwal B.O": "591237",
      "Pangire (B) B.O": "591237",
      "Rampur B.O": "591237",
      "Dhulaganwadi B.O": "591238",
      "Nainglaj B.O": "591238",
      "Haragapur B.O": "591313",
      "Rashing B.O": "591313",
      "Mutwad B.O": "591121",
      "Vannur B.O": "591121",
      "Chikahattiholi B.O": "591131",
      "Bhavihal B.O": "591125",
      "Balekundri Kshetra B.O": "591103",
      "Mavinkatti B.O": "591103",
      "Sulebhavi B.O": "591103",
      "Dhamne B.O": "590005",
      "Kangrali KH B.O": "590010",
      "Khanagaon B.O": "590015",
      "Honaga B.O": "591156",
      "Ambewadi B.O": "591108",
      "Sulage B.O": "591108",
      "Kanakumbi B.O": "591345",
      "Parwad B.O": "591345",
      "Agasage B.O": "591143",
      "Garalgunji B.O": "591302",
      "Nilwade B.O": "591302",
      "Shindolli B.O": "591302",
      "Devarai B.O": "591301",
      "Halashi B.O": "591120",
      "Nanjankodal B.O": "591120",
      "Nilaji B.O": "591217",
      "Kallehal B.O": "591128",
      "Kinaye B.O": "590018",
      "Kalmad B.O": "591123",
      "Mudenur B.O": "591123",
      "Mudkavi B.O": "591123",
      "Salapur B.O": "591123",
      "Achmatti B.O": "591110",
      "Chulaki B.O": "591110",
      "Nagarmunoli B.O": "591222",
      "Karagaon B.O": "591226",
      "Mugali B.O": "591226",
      "Chinchani B.O": "591287",
      "Kuthali B.O": "591287",
      "Gundwad B.O": "591311",
      "Khemalapur B.O": "591311",
      "Parmanandwadi B.O": "591311",
      "Kodni B.O": "591237",
      "Nipani Bazar B.O": "591237",
      "Shirguppi B.O": "591237",
      "Tavandi B.O": "591237",
      "Mavinhunda B.O": "591317",
      "Nandikurli B.O": "591317",
      "Nidagundi B.O": "591317",
      "Bhivashi B.O": "591241",
      "Hadnal B.O": "591241",
      "Kurli B.O": "591241",
      "Alagwadi B.O": "591317",
      "Jalalpur B.O": "591317",
      "Mekhali B.O": "591317",
      "New Diggewadi B.O": "591317",
      "Raibag Vidyalaya B.O": "591317",
      "Kallol B.O": "591244",
      "Zunzurwad B.O": "591230",
      "Masarguppi B.O": "591232",
      "Siddewadi B.O": "591232",
      "Saunsuddi B.O": "591235",
      "Ramtirth B.O": "591265",
      "Mamadapur K L B.O": "591211",
      "Chandur B.O": "591213",
      "Manjari B.O": "591213",
      "Mankapur B.O": "591216",
      "Bhendwad B.O": "591222",
      "Katakbhavi B.O": "591222",
      "Nipnal B.O": "591222",
      "Bambalwad B.O": "591226",
      "Hattarwat B.O": "591226",
      "Vadral B.O": "591226",
      "Yelparhatti B.O": "591311",
      "Arjunnagar B.O": "591237",
      "Gondikuppi B.O": "591237",
      "Shendur B.O": "591237",
      "Walki B.O": "591238",
      "Bekkeri B.O": "591317",
      "Morab B.O": "591317",
      "Raibag R.S. B.O": "591317",
      "Yadrav B.O": "591317",
      "Nej B.O": "591239",
      "Yamagarni B.O": "591241",
      "Malikwad B.O": "591244",
      "Badchi B.O": "591230",
      "Desairhatti B.O": "591230",
      "Jakkarhatti B.O": "591232",
      "Jambagi B.O": "591232",
      "Sambargi B.O": "591232",
      "Vishnuwadi B.O": "591232",
      "Kempwad B.O": "591234",
      "Lokur B.O": "591234",
      "Shedbal R.S. B.O": "591315",
      "Ingali B.O": "591242",
      "Jugul B.O": "591242",
      "Mangavati B.O": "591242",
      "Faridkhanwadi B.O": "591316",
      "Kusnal B.O": "591316",
      "Nasalapur B.O": "591213",
      "Saundatti B.O": "591213",
      "Karadaga B.O": "591263",
      "Barwad B.O": "591263",
      "Chikodi College Road B.O": "591201",
      "Hirekudi B.O": "591247",
      "Kadapur B.O": "591247",
      "Nagral B.O": "591247",
      "Vijaynagar B.O": "591222",
      "Sulgaon B.O": "591229",
      "Hanchinal K.S. B.O": "591229",
      "Jatrat B.O": "591237",
      "Byakud B.O": "591317",
      "Appachiwadi B.O": "591241",
      "Nanadi B.O": "591244",
      "Bailhongal Bazar S.O": "591102",
      "M.K.Hubballi S.F. S.O": "591153",
      "Aluminium Factory S.O": "590010",
      "Bailhongal S.R. Chowk S.O": "591102",
      "Deshnur S.O": "591147",
      "Itagi S.O": "591112",
      "M.K.Hubballi S.O": "591118",
      "Sampgaon S.O": "591125",
      "Angol S.O": "590006",
      "Belagavi College Road S.O": "590001",
      "Belagavi Kapileshwar Road S.O": "590001",
      "Belagavi M. Vadgaon S.O": "590005",
      "Kakati S.O": "591113",
      "Sambra S.O": "591124",
      "Udyambag S.O": "590008",
      "Hudli": "591346",
      "Chidambar Nagar Saundatti S.O": "591126",
      "Nekarpeth Ramdurg S.O": "591123",
      "Salahalli S.O": "591130",
      "Yallammahill S.O": "591173",
      "Belvadi S.O": "591104",
      "Bidi S.O": "591106",
      "Kittur S.O": "591115",
      "Murgod S.O": "591119",
      "Nesargi S.O": "591121",
      "Pariswad S.O": "591131",
      "Belagavi Bus Stand S.O": "590016",
      "Belagavi City S.O": "590001",
      "Belagavi Doordarshan Nagar S.O": "590019",
      "Belagavi Fort S.O": "590016",
      "Bhutaramanahatti S.O": "591156",
      "Jamboti S.O": "591345",
      "Londa S.O": "591301",
      "Peeranwadi S.O": "590014",
      "Ranichannamma Nagar S.O": "590006",
      "Suvarna Soudha Belagavi S.O": "590020",
      "Apmc Saundatti S.O": "591126",
      "Katkol S.O": "591114",
      "Balekundri S.O": "591103",
      "Belagavi Camp S.O": "590001",
      "Hindawadi S.O": "590011",
      "Kanabargi S.O": "590015",
      "Khanapur Town S.O": "591302",
      "Tilakwadi S.O": "590006",
      "Uchgaon S.O": "591128",
      "VTU Campus Belagavi S.O": "590018",
      "Vantmuri Colony Belagavi S. O": "590017",
      "Saundatti S.O": "591126",
      "Sureban S.O": "591127",
      "Hirebagewadi S.O": "591109",
      "Hosur S.O (Belagavi)": "591111",
      "Belagavi Kutchery S.O": "590001",
      "Belagavi MalMaruti Extension S.O": "590017",
      "Belagavi Nehru Nagar S.O": "590010",
      "Belagavi Records MLI S.O": "590009",
      "Belagavi Shahapur S.O": "590003",
      "Belagavi Shivaji Nagar S.O": "590016",
      "Belagavi Vishweswaraih Nagar S.O": "590019",
      "Bhagyanagar S.O (Belagavi)": "590006",
      "Hindalga S.O": "591108",
      "Kadoli S.O": "591143",
      "Khanapur SO Belagavi": "591302",
      "Nandgad S.O": "591120",
      "Hirekumbi S.O": "591110",
      "Manoli S.O": "591117",
      "Ramdurg Town S.O": "591123",
      "Yargatti S.O": "591129",
      "Gokak H.O": "591307",
      "Bailhongal H.O": "591102",
      "Belagavi H.O": "590001",
      "Ramdurg H.O": "591123",
      "Chikodi H.O": "591201",
      "Athani H.O": "591304",
      "Daddi S.O": "591254",
      "Gokak College Road S.O": "591307",
      "Gokak Guruwarpeth S.O": "591307",
      "Hebbal S.O": "591221",
      "Konnur S.O (Belagavi)": "591231",
      "Nerli S.O": "591340",
      "Nidasoshi S.O": "591236",
      "Pachhapur S.O": "591122",
      "Sankeshwar S.O": "591313",
      "Thana Hattargi S.O": "591243",
      "Yamakanmardi S.O": "591246",
      "Mamadapur S.O": "591233",
      "Mudalgi S.O": "591312",
      "Sankeshwar Sugar Factory S.O": "591314",
      "Hidkal Dam S.O": "591107",
      "Bellad Bagewadi S.O": "591305",
      "Ghataprabha RS S.O": "591306",
      "Gokak Fort S.O": "591307",
      "Kaujalgi S.O": "591227",
      "Kulgod S.O": "591310",
      "Lolsur S.O": "591218",
      "Yadwad S.O": "591136",
      "Gokak Falls S.O": "591308",
      "Hukeri S.O": "591309",
      "Kalloli S.O": "591224",
      "Kanagala S.O (Belagavi)": "591225",
      "Khangaon S.O": "591344",
      "Athani Bazar S.O": "591304",
      "Harugeri S.O": "591220",
      "Kagvad S.O": "591223",
      "Kokatnur S.O": "591230",
      "Kognoli S.O": "591229",
      "Raibag S.O": "591317",
      "Yaksamba S.O": "591244",
      "Aigali S.O": "591248",
      "Satti S.O": "591240",
      "Shedbal S.O": "591315",
      "Telsang S.O": "591265",
      "Ugarkhurd S.O": "591316",
      "Ankali S.O": "591213",
      "Bedkihal S.O": "591214",
      "Bhoj S.O": "591263",
      "Borgaon S.O (Belagavi)": "591216",
      "Chikodi Bazar S.O": "591201",
      "Chinchali S.O": "591217",
      "Galataga S.O": "591219",
      "Khadaklat S.O": "591228",
      "Kudchi S.O": "591311",
      "Pattankudi S.O": "591238",
      "Ainapur S.O": "591303",
      "Mangsuli S.O": "591234",
      "Mugalkhod S.O": "591235",
      "Shirguppi S.O": "591242",
      "Benadi S.O": "591215",
      "Chikodi Sugar Factory S.O": "591247",
      "Karoshi S.O": "591226",
      "Nipani Nehru Chowk S.O": "591237",
      "Nipani S.O": "591237",
      "Sadalga S.O": "591239",
      "Saundalga S.O": "591241",
      "Ankalgi S.O": "591101",
      "Anantpur S.O": "591212",
      "Madbhavi S.O": "591232",
      "Akol S.O": "591211",
      "Kabbur S.O": "591222",
      "Kothali S.O": "591287"
    },
    "CHAMARAJANAGARA": {
      "Lokkanahalli B.O": "571440",
      "Madhuvinahalli B.O": "571440",
      "Mudigundam B.O": "571440",
      "Palyam B.O": "571440",
      "Sathegala B.O": "571440",
      "Siddainapura B.O": "571440",
      "Tellanur B.O": "571440",
      "Chikkamallapura B.O": "571440",
      "Kollegal Devangapet B.O": "571440",
      "Kempanapalya B.O": "571440",
      "Kothanur B.O": "571440",
      "Sargur Kollegal B.O": "571440",
      "Udigala B.O": "571313",
      "Uttuvalli B.O": "571313",
      "Bandalli B.O": "571439",
      "Bodimuthanahalli B.O": "571439",
      "Suleripalyam B.O": "571439",
      "Uddanur B.O": "571439",
      "Punajanur B.O": "571127",
      "Alur B.O": "571117",
      "Channalingadahalli B.O": "571443",
      "Mangalam B.O": "571443",
      "Alahalli B.O": "571442",
      "Hoogiam B.O": "571444",
      "Chamarajanagara Pwd Colony B.O": "571342",
      "Chandakavadi B.O": "571342",
      "Hebbasur B.O": "571342",
      "Ganaganur B.O": "571124",
      "Honnur B.O": "571441",
      "Irasavadi B.O": "571441",
      "Kestur Yelandur B.O": "571441",
      "Doddarayapet B.O": "571313",
      "Somvarpet B.O": "571313",
      "Amachavadi B.O": "571127",
      "Ankasettypura B.O": "571127",
      "Arakalavadi B.O": "571127",
      "Attagulipura B.O": "571127",
      "Venkatainachatra B.O": "571127",
      "Yanaganahalli B.O": "571127",
      "Yeraganahlli B.O": "571127",
      "Masanapura B.O": "571117",
      "Saragur Chamarajanagara B.O": "571117",
      "Indiaganatha B.O": "571320",
      "Kunaganahalli B.O": "571442",
      "Kunthur B.O": "571442",
      "Kudlur B.O": "571342",
      "Manchapura B.O": "571444",
      "Nagavalli B.O": "571342",
      "Kannagala B.O": "571115",
      "Kastur Chamarajanagara B.O": "571115",
      "Kempanapura B.O": "571115",
      "Odeyarapalyam B.O": "571457",
      "Yeragamballi B.O": "571441",
      "Belachalavadi B.O": "571109",
      "Chikkati B.O": "571109",
      "Nitre B.O": "571109",
      "Raghavapura B.O": "571109",
      "Somahallli B.O": "571109",
      "Berambadi B.O": "571111",
      "Bettahalli B.O": "571111",
      "Bheemanabeedu B.O": "571111",
      "Bnnithalapura B.O": "571111",
      "Hasaguli B.O": "571111",
      "Hongalli B.O": "571111",
      "Hundipura B.O": "571111",
      "Kannegala B.O": "571111",
      "Veeranapura B.O": "571111",
      "Kalanahundi B.O": "571128",
      "Kalpura B.O": "571128",
      "Maleyur B.O": "571128",
      "Attikane B.O": "571313",
      "Bedaguli B.O": "571313",
      "Heggotara B.O": "571313",
      "Madapura B.O": "571313",
      "Ellemela B.O": "571439",
      "Saggiam B.O": "571439",
      "Doddamole B.O": "571127",
      "Mukanapalya B.O": "571127",
      "Gulipura B.O": "571117",
      "Jyothigowdanapura B.O": "571117",
      "Doddinduvadi B.O": "571443",
      "Singanallur B.O": "571443",
      "Gopinatham B.O": "571490",
      "Agara B.O": "571442",
      "Hosamalangi B.O": "571442",
      "Kinakanahalli B.O": "571442",
      "Uttamballi B.O": "571442",
      "Kodimole B.O": "571342",
      "Kyathadevaragudi B.O": "571342",
      "Mangala B.O": "571126",
      "Banahalli B.O": "571124",
      "B R Hills B.O": "571441",
      "Gowdahalli B.O": "571441",
      "Maddur Yelandur B.O": "571441",
      "Heggadahalli B.O": "571109",
      "Horeyala B.O": "571109",
      "Kotekere B.O": "571109",
      "Annurkeri B.O": "571111",
      "Baragi B.O": "571111",
      "Bommalapura B.O": "571111",
      "Kundakere B.O": "571111",
      "Nenekatte B.O": "571111",
      "Devarahalli B.O": "571126",
      "Kaniyanapura B.O": "571126",
      "Badanaguppe B.O": "571313",
      "Chamarajanagara Bazar B.O": "571313",
      "Kellamballi B.O": "571313",
      "Mariyala B.O": "571313",
      "Shivapura B.O": "571111",
      "Ajjipura B.O": "571439",
      "Goreyur B.O": "571439",
      "Managahalli B.O": "571439",
      "Bisalavadi B.O": "571127",
      "Honnahalli B.O": "571127",
      "Honganur B.O": "571117",
      "Kotamballi B.O": "571117",
      "Kannur B.O": "571443",
      "Marukotai B.O": "571490",
      "Chilukavadi B.O": "571442",
      "Mullur B.O": "571442",
      "Dinnahalli B.O": "571444",
      "Minya B.O": "571444",
      "Hondarabalu B.O": "571342",
      "Bhogapura B.O": "571115",
      "Kavudavadi B.O": "571115",
      "Mahanthalapura B.O": "571115",
      "Bailur B.O": "571457",
      "Parasegowdanapalya B.O": "571457",
      "Ambale B.O": "571441",
      "Ganiganur B.O": "571441",
      "Komaranapura B.O": "571441",
      "Shivakalli B.O": "571441",
      "Yelandur Balepete B.O": "571441",
      "Hirikati B.O": "571109",
      "Kallahalli B.O": "571109",
      "Kulugana B.O": "571109",
      "Thondavadi B.O": "571109",
      "Maddur B.O": "571111",
      "Kaligowdanahalli B.O": "571126",
      "Puttanapura B.O": "571126",
      "Yeriyur B.O": "571111",
      "Kabbahalli B.O": "571109",
      "Alathur B.O": "571111",
      "Bachahalli B.O": "571111",
      "Chikkatuppur B.O": "571111",
      "Kodasoge B.O": "571111",
      "Sindanapura B.O": "571111",
      "Bandipura B.O": "571126",
      "Aralikatte B.O": "571128",
      "Ummathur B.O": "571316",
      "Kelasur B.O": "571123",
      "Kilagere B.O": "571123",
      "Kothalavadi B.O": "571123",
      "Muduguru B.O": "571123",
      "Paduguru B.O": "571123",
      "Bagali B.O": "571316",
      "Chirakanahalli B.O": "571123",
      "Kaggala B.O": "571123",
      "Lakkur B.O": "571123",
      "Doddalathur B.O": "571320",
      "Heggavady B.O": "571316",
      "Balachavadi B.O": "571123",
      "Berthahallli B.O": "571123",
      "Kurahatti Hosur B.O": "571320",
      "Vadakhalla BO": "571320",
      "Nanjedevanapura B.O": "571128",
      "Thammadahalli B.O": "571128",
      "Mudnakudu B.O": "571128",
      "Bendravadi B.O": "571312",
      "Chikkahomma B.O": "571316",
      "Demahalli B.O": "571316",
      "Jannur B.O": "571316",
      "Bommanahalli B.O": "571123",
      "Depapura B.O": "571123",
      "Vaddagere B.O": "571123",
      "Marthalli B.O": "571320",
      "Ponnachi B.O": "571320",
      "Mukkadahalli B.O": "571128",
      "Sagade B.O": "571128",
      "Sivasamudram B.O": "571430",
      "Kollegal H.O": "571440",
      "Chamarajanagara S.O": "571313",
      "Kagalavadi S.O": "571117",
      "Kamakerai S.O": "571443",
      "Kollegal Southern Extension S.O": "571440",
      "Mahadeshwara Malai S.O": "571490",
      "Mamballi S.O": "571442",
      "Ramapuram Ghat S.O": "571444",
      "Ramasamudra S.O (Chamrajnagar)": "571342",
      "Tibetan Settlement S.O": "571457",
      "Begur S.O": "571109",
      "Hangala S.O": "571126",
      "Hanur S.O": "571439",
      "Haradanahalli S.O": "571127",
      "Zilla Adalitha Bhavan S.O": "571313",
      "Santhemaranahalli S.O": "571115",
      "Yelandur S.O": "571441",
      "Kuderu S.O (Chamrajnagar)": "571316",
      "Gundlupet Bazar S.O": "571111",
      "Gundlupet S.O": "571111",
      "Harave S.O": "571128",
      "Tirukanambi S.O": "571123",
      "Cowdalli S.O": "571320"
    },
    "RAMANAGARA": {
      "Bachenahatti B.O": "562120",
      "Kalari B.O": "562120",
      "Kalludevanahalli B.O": "562120",
      "Avverahalli B.O": "562159",
      "Bilagumba B.O": "562120",
      "Kutgal B.O": "562159",
      "Kabbal B.O": "562126",
      "Lakkenahalli B.O": "562127",
      "Manniganahalli B.O": "562127",
      "Harisandra B.O": "562128",
      "Baginigere B.O": "562131",
      "Biskur B.O": "562131",
      "Chakrabhavi B.O": "562120",
      "Kempasagara B.O": "562120",
      "Malligemetlu B.O": "562121",
      "Akkur B.O": "562138",
      "Anjanapura B.O": "562159",
      "Lakkojanahalli B.O": "562159",
      "Harobele B.O": "562126",
      "Kadahalli B.O": "562126",
      "Marikuppe B.O": "562127",
      "Motagondanahalli B.O": "562127",
      "Narasandra B.O": "562127",
      "Udukunte B.O": "562127",
      "Yennegere B.O": "562127",
      "Manchanabele B.O": "562128",
      "Mayaganahalli B.O": "562128",
      "Gejjagaraguppe B.O": "562120",
      "Harthi B.O": "562120",
      "Mathikere B.O": "562120",
      "Sathanur B.O": "562120",
      "Banavasi B.O": "562121",
      "Guttalahunase B.O": "562121",
      "Kallanakupppe B.O": "562121",
      "Doddagangawadi B.O": "562159",
      "Jalamangala B.O": "562159",
      "Kailancha B.O": "562159",
      "Krishnapuradoddi B.O": "562159",
      "Attihalli B.O": "562126",
      "Banavadi B.O": "562127",
      "Byalakere B.O": "562127",
      "Agalakote B.O": "562120",
      "Kalya B.O": "562120",
      "Thaggikuppe B.O": "562120",
      "Terubeedi B.O": "562121",
      "Ankanahalli B.O": "562159",
      "Bannikuppe B.O": "562159",
      "Yerehalli B.O": "562159",
      "Jayapura": "562159",
      "Chikkalahalli B.O": "562126",
      "Honniganahalli B.O": "562126",
      "Gudemaranahalli B.O": "562127",
      "Madigondanahalli B.O": "562127",
      "Hagalahalli B.O": "562128",
      "Doddasomanahalli B.O": "562131",
      "Gangonahalli B.O": "562131",
      "Doddamudigere B.O": "562131",
      "Ajjanahalli B.O": "561201",
      "Karlamangala B.O": "561201",
      "Attimagere B.O": "561201",
      "Lakshmipura B.O": "561201",
      "Hullenahalli B.O": "562131",
      "Sankighatta B.O": "562131",
      "Madabal B.O": "561201",
      "Thimmasandra B.O": "561201",
      "Lalaghatta B.O": "562160",
      "Malur B.O": "562160",
      "Abbur B.O": "562108",
      "Nagavara B.O": "562108",
      "Ittmadu B.O": "562109",
      "K.Karenahalli B.O": "562109",
      "Shanumangala B.O": "562109",
      "Attikuppe B.O": "562112",
      "Cheelur B.O": "562112",
      "Girenahalli B.O": "562112",
      "Tattekere B.O": "562112",
      "Ambadahalli B.O": "562138",
      "Kodamballi B.O": "562138",
      "Neralur B.O": "562138",
      "Sogala B.O": "562138",
      "Chakkere B.O": "562160",
      "Chakkalur B.O": "562160",
      "Mudugere B.O": "562160",
      "Rampura B.O": "562160",
      "Sulleri B.O": "562160",
      "Bevurmandya B.O": "562108",
      "Gowdagere B.O": "562108",
      "Honnayakanahalli B.O": "562108",
      "Kanva B.O": "562108",
      "Kanchugaranahalli B.O": "562109",
      "Manchanayakanahalli B.O": "562109",
      "Kudlur B.O": "562160",
      "Marchanahalli B.O": "562160",
      "Kyasapura B.O": "562108",
      "Mankunda B.O": "562108",
      "Byramangala B.O": "562109",
      "Hosur B.O": "562109",
      "Gottigehalli B.O": "562112",
      "Kaggala Halli B.O": "562112",
      "Medamaranahalli B.O": "562112",
      "T.Hosahalli B.O": "562112",
      "Garakahalli B.O": "562138",
      "Iggalur B.O": "562138",
      "Singarajipura B.O": "562138",
      "Yelethotadahalli B.O": "562138",
      "Alahalli B.O": "562117",
      "Kottagalu B.O": "562117",
      "Marale B.O": "562117",
      "Narayanapura B.O": "562117",
      "Herandyappanahalli B.O": "562119",
      "Hunasanahalli B.O": "562119",
      "Adarangi B.O": "561101",
      "Marasandra B.O": "561101",
      "Mylanayakanahalli B.O": "562160",
      "Shettihalli B.O": "562160",
      "Thagachagere B.O": "562160",
      "Makali B.O": "562108",
      "Mogenahalli B.O": "562108",
      "Ganakal B.O": "562109",
      "Hejjala B.O": "562109",
      "Manchegowdanapalya B.O": "562109",
      "Uragapura B.O": "562109",
      "Jakkasandra B.O": "562112",
      "Karikaldoddi B.O": "562112",
      "Kolliganahalli B.O": "562112",
      "Aralalasandra B.O": "562138",
      "Jagadapura B.O": "562138",
      "Virupakshipura B.O": "562138",
      "Achalu B.O": "562117",
      "Chikkamuduvadi B.O": "562117",
      "Kallahalli B.O": "562117",
      "Marlebekuppe B.O": "562117",
      "Shivanahalli B.O": "562117",
      "Alanatha B.O": "562119",
      "Hanchaguli B.O": "562119",
      "Hosadurga B.O": "562119",
      "Kolagondanahalli B.O": "562119",
      "Hulikal B.O": "561101",
      "Mayasandra B.O": "561101",
      "Sugganahalli B.O": "561101",
      "Thorebekuppe B.O": "562117",
      "Tungani B.O": "562117",
      "Venkatarayanadoddi B.O": "562117",
      "Yadamaranahalli B.O": "562117",
      "Bannimakodalu B.O": "562119",
      "Bijjahalli B.O": "562119",
      "Doddakabballi B.O": "562119",
      "Gollahalli B.O": "562119",
      "Ganalu B.O": "562117",
      "H.Kothanuru B.O": "562117",
      "Helagahalli B.O": "562117",
      "Horalagallu B.O": "562117",
      "Kurupet B.O": "562117",
      "Malgal B.O": "562117",
      "Hukunda B.O": "562119",
      "Mullahalli B.O": "562119",
      "Sirigiripura B.O": "561101",
      "Channapatna H.O": "562160",
      "Bidadi S.O": "562109",
      "GCEC Ramanagara S.O": "562159",
      "Government Silk Farm S.O": "562161",
      "Kanakapura Bazar S.O": "562117",
      "Kodihalli S.O": "562119",
      "Ramanagaram S.O": "562159",
      "Honganur S.O": "562138",
      "Ijoor Ramangaram S.O": "562159",
      "Kudur S.O": "561101",
      "Bevur S.O (Ramanagar)": "562108",
      "Harohalli S.O": "562112",
      "Kanakapura S.O": "562117",
      "Magadi S.O": "562120",
      "Maralavadi S.O": "562121",
      "Sathanur S.O": "562126",
      "Solur S.O": "562127",
      "Sugganahalli S.O": "562128",
      "Thippasandra S.O": "562131",
      "Veeregowdanadoddi S.O": "561201",
      "Channapatna Bazar S.O": "562160"
    },
    "BENGALURU URBAN": {
      "Huskur B.O": "560099",
      "Lakshmipura B.O": "562162",
      "Kadabagere B.O": "562130",
      "Kithanahalli B.O": "562130",
      "Sondekoppa B.O": "562130",
      "Hullegowdanahalli B.O": "562162",
      "Makali B.O": "562162",
      "Shivanapura B.O": "562162",
      "Cholanayakanahally B.O": "562120",
      "Dommasandra B.O": "562125",
      "Kugur B.O": "562125",
      "Neriga B.O": "562125",
      "Madavara B.O": "562162",
      "Mathahalli B.O": "562162",
      "Handenahalli B.O": "562125",
      "Chunchanakuppe B.O": "562130",
      "Arakere B.O": "562163",
      "Doddagubbi B.O": "560077",
      "Mallathahalli B.O": "560056",
      "Mount St Joseph B.O": "560076",
      "Sakalavara B.O": "560083",
      "Attur B.O": "560064",
      "Chudenapura B.O": "560060",
      "Agara B.O": "560034",
      "Ragihalli B.O": "560083",
      "Singanayakanahalli B.O": "560064",
      "Jakkur B.O": "560064",
      "Rajanakunte B.O": "560064",
      "Bapagrama B.O": "560091",
      "Indalawadi B.O": "562106",
      "Samandur B.O": "562106",
      "Sidihoskote B.O": "562106",
      "Vanakanahalli B.O": "562106",
      "Vidyanagara B.O": "562157",
      "Kalkere B.O": "560083",
      "Kumbalgodu Gollahalli B.O": "560074",
      "Ramohalli B.O": "560074",
      "Haragadde B.O": "560105",
      "Bolare B.O": "560116",
      "Silvepura B.O": "560090",
      "Byatha B.O": "560089",
      "Guddanahalli B.O": "562106",
      "Marasur B.O": "562106",
      "Thammanayakanahalli B.O": "562106",
      "Byagadadenahalli B.O": "562106",
      "Neralur B.O": "562107",
      "Bandikodigehalli B.O": "562149",
      "Chikkajala B.O": "562157",
      "Tarahunise B.O": "562157",
      "Panathur B.O": "560087",
      "Shivakote B.O": "560089",
      "Nelakadiranahalli B.O": "560073",
      "Bidaraguppe B.O": "562107",
      "Kannur B.O": "562149",
      "Hunasamaranahalli B.O": "562157",
      "Hennagara B.O": "560105",
      "Singasandra B.O": "560068",
      "Somanhalli B.O": "560116",
      "Thattekuppe B.O": "560116",
      "Thataguni B.O": "560082",
      "Kakolu B.O": "560089",
      "Bestamaranahalli B.O": "562106",
      "Mayasandra B.O": "562107",
      "Yadavanahalli B.O": "562107",
      "Doddajala B.O": "562157",
      "Bidrahalli B.O": "560049",
      "Dasanapura B.O": "562162",
      "Hulimangala B.O": "560105",
      "Kallubalu B.O": "560105",
      "Taralu B.O": "560116",
      "Hoodi B.O": "560048",
      "Gunjur B.O": "560087",
      "Amruthahalli B.O": "560092",
      "Byatarayanapura B.O": "560092",
      "Kodigehalli B.O": "560092",
      "Doddanekkundi B.O": "560037",
      "Aluru B.O": "562162",
      "Bengaluru G.P.O.": "560001",
      "Basavanagudi H.O": "560004",
      "Jalahalli H.O": "560013",
      "Rajajinagar H.O": "560010",
      "H A L II Stage H.O": "560008",
      "R T Nagar H.O": "560032",
      "Jayanagar H.O": "560041",
      "C V Raman Nagar S.O": "560093",
      "Halasur Bazar S.O": "560008",
      "Kadugodi S.O": "560067",
      "Krishnarajapuram R S S.O": "560016",
      "Vimanapura S.O": "560017",
      "Kannamangala S.O": "560115",
      "Bengaluru International Airport S.O": "560300",
      "Bengaluru Foreign Post S.O": "560001",
      "Fraser Town S.O": "560005",
      "Kothanur S.O": "560077",
      "Legislators Home S.O": "560001",
      "Mahatma Gandhi Road S.O": "560001",
      "Agram S.O": "560007",
      "Bhattarahalli S.O": "560049",
      "Doorvaninagar S.O": "560016",
      "Mahadevapura S.O": "560048",
      "Bellandur S.O": "560103",
      "Devasandra S.O": "560036",
      "Indiranagar S.O (Bengaluru)": "560038",
      "Krishnarajapuram S.O": "560036",
      "Kundalahalli S.O": "560037",
      "Marathahalli Colony S.O": "560037",
      "N A L S.O": "560017",
      "Ramamurthy Nagar S.O": "560016",
      "Vartur S.O": "560087",
      "Viveknagar S.O (Bengaluru)": "560047",
      "Whitefield S.O": "560066",
      "Anandanagar S.O": "560024",
      "Benson Town S.O": "560046",
      "BSF Campus Yelahanka S.O": "560063",
      "G K V K S.O": "560065",
      "Hebbal Kempapura S.O": "560024",
      "P and T Colony Kavalbyrasandra S.O": "560032",
      "Training Command IAF S.O": "560006",
      "Banaswadi S.O": "560043",
      "HighCourt S.O": "560001",
      "Kalyananagar S.O": "560043",
      "Richmond Town S.O": "560025",
      "Air Force Hospital S.O": "560007",
      "Austin Town S.O": "560047",
      "Domlur S.O": "560071",
      "E P I P S.O": "560066",
      "Jeevanbhimanagar S.O": "560075",
      "New Thippasandra S.O": "560075",
      "Rameshnagar S.O": "560037",
      "Doddanekkundi SO": "560037",
      "CRPF Campus Yelahanka S.O": "560064",
      "ISRO Anthariksha Bhavan S.O": "560094",
      "J C Nagar S.O": "560006",
      "Sahakaranagar S.O": "560092",
      "Yelahanka S.O": "560064",
      "Yelahanka Satellite Town S.O": "560064",
      "Arabic College S.O": "560045",
      "Dr. Shivarama Karanth Nagar S.O": "560077",
      "Lingarajapuram S.O": "560084",
      "Maruthi Sevanagar S.O": "560033",
      "Museum Road S.O": "560025",
      "A F Station Yelahanka S.O": "560063",
      "H A Farm S.O": "560024",
      "R M V Extension II Stage S.O": "560094",
      "Sadashivanagar S.O": "560080",
      "CMP Centre And School S.O": "560025",
      "Dr. Ambedkar Veedhi S.O": "560001",
      "H K P Road S.O": "560051",
      "Jalavayuvihar S.O": "560043",
      "Rajbhavan S.O": "560001",
      "Basaveshwaranagar S.O": "560079",
      "K H B Colony S.O": "560079",
      "Magadi Road S.O": "560023",
      "Mahalakshmipuram Layout S.O": "560086",
      "Nagarbhavi S.O": "560072",
      "Swimming Pool Extn S.O": "560003",
      "Vyalikaval Extn S.O": "560003",
      "Deepanjalinagar S.O": "560026",
      "HSR Layout S.O": "560102",
      "Kengeri S.O": "560060",
      "St. Johns Medical College S.O": "560034",
      "Thyagarajnagar S.O": "560070",
      "B Sk II Stage S.O": "560070",
      "Banashankari III Stage S.O": "560085",
      "Banashankari S.O": "560050",
      "Bannerghatta Road S.O": "560076",
      "Jigani S.O": "560105",
      "Mico Layout S.O": "560076",
      "Padmanabhnagar S.O": "560070",
      "State Bank Of Mysuru Colony S.O": "560050",
      "Begur": "560114",
      "Chandapura S.O": "560081",
      "CPC ITD BNPL booking HUB": "560500",
      "Tavarekere S.O (Bengaluru)": "562130",
      "Sivan Chetty Gardens S.O": "560042",
      "Achitnagar S.O": "560107",
      "Chikkabidarkal S.O": "560073",
      "Msrit S.O": "560054",
      "Peenya I Stage S.O": "560058",
      "Peenya Small Industries S.O": "560058",
      "Vidyaranyapura S.O": "560097",
      "Industrial Estate S.O (Bengaluru)": "560010",
      "Malleswaram S.O": "560003",
      "Srirampuram S.O": "560021",
      "Viswaneedam S.O": "560091",
      "Bettahalsur S.O": "562157",
      "Madanayakanahalli S.O": "562162",
      "Sarjapura S.O": "562125",
      "Adugodi S.O": "560030",
      "Chamrajpet S.O (Bengaluru)": "560018",
      "Koramangala S.O": "560034",
      "Koramangala VI Bk S.O": "560095",
      "Kumbalagodu S.O": "560074",
      "Mavalli S.O": "560004",
      "Rajarajeshwarinagar S.O": "560098",
      "Sampangiramnagar S.O": "560027",
      "Shanthinagar S.O": "560027",
      "Ashoknagar S.O (Bengaluru)": "560050",
      "Electronics City S.O": "560100",
      "Chikkabanavara S.O": "560090",
      "Jalahalli East S.O": "560013",
      "Jalahalli West S.O": "560015",
      "Sri Chowdeshwari S.O": "560054",
      "Yeswanthpura S.O": "560022",
      "BAGALGUNTE S.O": "560073",
      "St. Thomas Town S.O": "560084",
      "Vasanthanagar S.O": "560001",
      "CMM Court Complex S.O": "560001",
      "Herohalli S.O": "560091",
      "Hessarghatta S.O": "560088",
      "Laggere S.O": "560058",
      "Nagasandra S.O (Bengaluru)": "560073",
      "Bengaluru City S.O": "560002",
      "Bengaluru Dist Offices Bldg S.O": "560009",
      "Chandra Lay Out S.O": "560040",
      "Kamakshipalya S.O": "560079",
      "Malleswaram West S.O": "560055",
      "Girinagar S.O (Bengaluru)": "560085",
      "Gottigere S.O": "560083",
      "JP Nagar VIII phase S.O": "560076",
      "Kumaraswamy Layout S.O": "560111",
      "Madivala S.O": "560068",
      "Udaypura S.O": "560082",
      "Pattanagere P.O": "560098",
      "Bnagalore Viswavidalaya S.O": "560056",
      "Carmelram S.O": "560035",
      "Chickpet S.O": "560053",
      "Gaviopuram Extension S.O": "560004",
      "Governmemnt Electric Factory S.O": "560026",
      "Pampamahakavi Road S.O": "560004",
      "Rv Niketan S.O": "560059",
      "Ullalu Upanagar S.O": "560110",
      "Channasandra PO": "560098",
      "Anjanapura S.O": "560108",
      "Bommanahalli S.O (Bengaluru)": "560068",
      "Dasarahalli(Srinagar) S.O": "560050",
      "Dharmaram College S.O": "560029",
      "Doddakallasandra S.O": "560062",
      "Subramanyapura S.O": "560061",
      "Tilaknagar S.O (Bengaluru)": "560041",
      "Kaggalipura P.O": "560116",
      "Jayanagar East S.O": "560041",
      "Nandinilayout S.O": "560096",
      "Rajajinagar IVth Block S.O": "560010",
      "Vijayanagar East S.O": "560040",
      "Vijayanagar S.O (Bengaluru)": "560040",
      "Attibele S.O": "562107",
      "Gayathrinagar S.O": "560021",
      "Hampinagar S.O": "560104",
      "K. G. Road S.O": "560009",
      "Palace Guttahalli S.O": "560003",
      "Seshadripuram S.O": "560020",
      "West of Chord Road II stage S.O": "560086",
      "Kodigehalli S.O": "560112",
      "Nagarbhavi II Stage PO": "560072",
      "Anekal S.O": "562106",
      "Bagalur S.O (Bengaluru)": "562149",
      "Vidhana Soudha S.O": "560001",
      "Horamavu S.O": "560113",
      "Bengaluru Corporation Building S.O": "560002",
      "Koramangala I Block S.O": "560034",
      "Nayandahalli S.O": "560026",
      "Wilson Garden S.O": "560027",
      "Goripalya SO": "560018",
      "Bannerghatta S.O": "560083",
      "Bommasandra Industrial Estate S.O": "560099",
      "Chikkalasandra S.O": "560061",
      "Hessarghatta Lake S.O": "560089",
      "Mathikere S.O": "560054",
      "Peenya Dasarahalli S.O": "560057",
      "Science Institute S.O": "560012",
      "J P Nagar S.O": "560078",
      "Jayangar III Block S.O": "560011",
      "JP Nagar III Phase S.O": "560078",
      "Kathriguppe S.O": "560085",
      "Madhavan Park S.O": "560011",
      "Tavarekere S.O": "560029",
      "Thalaghattapura S.O": "560109",
      "Yelachenahalli S.O": "560078",
      "Konanakunte S.O": "560062",
      "Yeshwanthpur Bazar S.O": "560022"
    },
    "BENGALURU RURAL": {
      "Hadonahalli B.O": "561205",
      "Tubugere B.O": "561205",
      "Begur B.O": "562122",
      "Gollahalli B.O": "562123",
      "Honnasandra B.O": "562123",
      "Jakkanahalli B.O": "562123",
      "Chikkanahalli B.O": "562130",
      "Gantiganahalli B.O": "561205",
      "Hindiganala B.O": "562122",
      "Korati B.O": "562122",
      "Arasinakunte B.O": "562123",
      "Mahadevapura B.O": "562123",
      "Bendiganahalli B.O": "562129",
      "Nelavagilu B.O": "562122",
      "Shivanapura B.O": "562122",
      "Tavarekere B.O": "562122",
      "Mandigere B.O": "562123",
      "Mylanahalli B.O": "562123",
      "Theppadabeguru B.O": "562123",
      "Yentiganahalli B.O": "562123",
      "Ibasapura B.O": "562129",
      "Reddihalli B.O": "562129",
      "Heggadahalli B.O": "561205",
      "Bylanarasapura B.O": "562122",
      "K.Satyavara B.O": "562122",
      "Budihal B.O": "562123",
      "Madalakote B.O": "562123",
      "Mallarabanavadi B.O": "562123",
      "Bettakote B.O": "562129",
      "Soladevanahalli B.O": "562130",
      "Venkatagirikote B.O": "562164",
      "Bijjawara B.O": "562164",
      "Bidalur B.O": "562164",
      "Basettihalli B.O": "562163",
      "Doddatumkur B.O": "562163",
      "Doddabele B.O": "562132",
      "Manne B.O": "562132",
      "Niduvanda B.O": "562132",
      "Harohalli B.O": "562135",
      "Koira B.O": "562164",
      "Konnagatta B.O": "562163",
      "Shivapura B.O": "562163",
      "Veerapura B.O": "562163",
      "Kalalaghatta B.O": "562132",
      "Obalapura B.O": "562132",
      "Mandibele B.O": "562135",
      "Narayanapura B.O": "562135",
      "Karahalli B.O": "562164",
      "Channarayapatna B.O": "562135",
      "Sulikere B.O": "560060",
      "Hegganahalli B.O": "562110",
      "Jalige B.O": "562110",
      "Kundana B.O": "562110",
      "Sadahalli B.O": "562110",
      "Uganavadi B.O": "562110",
      "Heggunda B.O": "562111",
      "Kuluvanahalli B.O": "562111",
      "Lakkur B.O": "562111",
      "Narasipura B.O": "562111",
      "Aralumallige B.O": "561203",
      "Gundamgere B.O": "561203",
      "Hanabe B.O": "561203",
      "Hosahalli B.O": "561203",
      "Kanasavadi B.O": "561203",
      "Arudi B.O": "561204",
      "Hoskote Indl. Area B.O": "562114",
      "Kattigenahalli B.O": "562114",
      "Kolathur B.O": "562114",
      "Kumbalahalli B.O": "562114",
      "Lakkondanahalli B.O": "562114",
      "Doddasanne B.O": "562110",
      "Vishwanathapura B.O": "562110",
      "Devarahosahalli B.O": "562111",
      "Kambalu B.O": "562111",
      "Maralakunte B.O": "562111",
      "Shivagange B.O": "562111",
      "Antharahalli B.O": "561203",
      "Kodigehalli B.O": "561203",
      "Sri Subramanyaghati B.O": "561203",
      "Doddahejjaji B.O": "561204",
      "Sasalu B.O": "561204",
      "Syakaladevanapura B.O": "561204",
      "Hasigala B.O": "562114",
      "Jadigenahalli B.O": "562114",
      "Kembliganahalli B.O": "562114",
      "Mugabala B.O": "562114",
      "Vagata Agrahara B.O": "562114",
      "Kalkunte B.O": "560117",
      "Alurduddanahalli B.O": "562110",
      "Anneshwara B.O": "562110",
      "Aradeshanahalli B.O": "562110",
      "Kannamangala B.O": "561203",
      "Baragenahalli B.O": "562111",
      "Kadalappanahalli B.O": "561204",
      "Kadanur B.O": "561204",
      "Koligere B.O": "561204",
      "Purushanahalli B.O": "561204",
      "Doddagattiganabbe B.O": "562114",
      "Doddanallala B.O": "562114",
      "Yeliyur B.O": "562110",
      "Arebommanahalli B.O": "562111",
      "Billanakote B.O": "562111",
      "Yelekyathanahalli B.O": "562111",
      "Mallathahalli B.O": "561203",
      "Rajaghatta B.O": "561203",
      "Thippur B.O": "561203",
      "Bhaktharahalli B.O": "561204",
      "Hulikunte B.O": "561204",
      "Rameshwara B.O": "561204",
      "Sakkaaregollahalli B.O": "561204",
      "Jodidasarahalli B.O": "562114",
      "Devanagundi B.O": "560117",
      "Muthsandra B.O": "560087",
      "Medimallasandra B.O": "560117",
      "Naduvathi B.O": "560067",
      "Samethanahalli B.O": "560117",
      "Mandur B.O": "560049",
      "Virgonagar S.O": "560049",
      "Doddadunnasandra S.O": "560117",
      "Melekote S.O": "561205",
      "Nandagudi S.O": "562122",
      "Tyamagondlu S.O": "562132",
      "Dodballapura S.O": "561203",
      "Hoskote S.O": "562114",
      "Nelamangala S.O": "562123",
      "Sulebele S.O": "562129",
      "Budigere S.O": "562165",
      "Dobbespet S.O": "562111",
      "Dodballapura Bazar S.O": "561203",
      "Devanahalli S.O": "562110",
      "Doddabelavangala S.O": "561204",
      "Vijayapura S.O": "562135",
      "Avathi S.O": "562164",
      "Nagadenahalli S.O": "562163"
    },
    "GADAG": {
      "Kotumachagi B.O": "582111",
      "Konchigeri B.O": "582112",
      "Suganhalli B.O": "582112",
      "Vadavi B.O": "582112",
      "Harogeri B.O": "582113",
      "Jantli B.O": "582113",
      "Kognur B.O": "582112",
      "Tarikoppa B.O": "582112",
      "Bardur B.O": "582113",
      "Gujamagadi B.O": "582102",
      "Hirekoppa B.O": "582102",
      "Huilgol B.O": "582102",
      "Kadadi B.O": "582102",
      "Doni B.O": "582103",
      "Gadag Gangapurpeth B.O": "582103",
      "Nagavi B.O": "582103",
      "Papanashi B.O": "582103",
      "Singatarayanakeri B.O": "582103",
      "Asuti B.O": "582203",
      "Holemannur B.O": "582203",
      "Shagoti B.O": "582205",
      "Halligudi B.O": "582115",
      "Balaganur B.O": "582102",
      "Gadag J T College B.O": "582102",
      "Kanaginahal B.O": "582102",
      "Attikatti B.O": "582103",
      "Kadampur B.O": "582103",
      "Kalasapur B.O": "582103",
      "Malasamudra B.O": "582103",
      "Gogeri B.O": "582114",
      "Malvad B.O": "582203",
      "Belhod B.O": "582204",
      "Lingdhal B.O": "582204",
      "Kurthkoti B.O": "582205",
      "Kodikoppa B.O": "582111",
      "Bannikoppa B.O": "582112",
      "Rantur B.O": "582112",
      "Hirewaddatti B.O": "582113",
      "Mewundi B.O": "582113",
      "Yaklaspur B.O": "582113",
      "D S Hadagali B.O": "582102",
      "Kuradagi B.O": "582102",
      "Advisomapur B.O": "582103",
      "Harti B.O": "582103",
      "Kanvi B.O": "582103",
      "Chilzeri B.O": "582114",
      "Kuntoji B.O": "582114",
      "Hungundi B.O": "582203",
      "Holehadagali": "582203",
      "Anturbentur B.O": "582205",
      "Jakkali B.O": "582111",
      "Hebbal B.O": "582112",
      "Hullur B.O": "582209",
      "Itagi B.O": "582211",
      "Koujageri B.O": "582202",
      "Y S Hadagali B.O": "582202",
      "Yavagal B.O": "582202",
      "Pethalur B.O": "582113",
      "Venkatapur B.O": "582113",
      "Yeribeleri B.O": "582102",
      "Neeralagi B.O": "582102",
      "Beldhadi B.O": "582103",
      "Binkadkatti B.O": "582103",
      "Nidgundi B.O": "582114",
      "Rajur B.O": "582114",
      "Rampur B.O": "582114",
      "Chickhandigol B.O": "582205",
      "Hosahalli B.O": "582205",
      "Hatalgeri B.O": "582115",
      "Timmapur B.O": "582115",
      "Battur B.O": "582116",
      "Futgaon Badni B.O": "582116",
      "Surangi B.O": "582116",
      "Neelgund B.O": "582117",
      "Yatanhalli B.O": "582117",
      "Bidinhal B.O": "582118",
      "Hammigi B.O": "582118",
      "Nidagundikoppa B.O": "582119",
      "Banhatti B.O": "582207",
      "Surkod B.O": "582207",
      "Hirekoppa": "582207",
      "Hirehal B.O": "582209",
      "Somanakatti B.O": "582209",
      "Kurhatti B.O": "582209",
      "Yelisirur B.O": "582120",
      "Lakkalkatti B.O": "582211",
      "Harlapur B.O": "582115",
      "Adrahalli B.O": "582116",
      "Doddur B.O": "582116",
      "Balehosur B.O": "582116",
      "Magadi B.O": "582117",
      "Bidarahalli B.O": "582118",
      "Chickwaddatti B.O": "582118",
      "Hadli B.O": "582207",
      "Menasigi B.O": "582207",
      "Raddernagnur B.O": "582207",
      "Chicknargund B.O": "582207",
      "Kanakikoppa B.O": "582207",
      "Hiremannur B.O": "582209",
      "Hosalli B.O": "582209",
      "Savadi B.O": "582209",
      "Honniganur": "582209",
      "Chebbi B.O": "582120",
      "Sortur B.O": "582120",
      "Sarjapur B.O": "582211",
      "Adarkatti B.O": "582116",
      "Chinchali B.O": "582117",
      "Madhalli B.O": "582117",
      "Bagewadi B.O": "582118",
      "Halkeri B.O": "582119",
      "Jigalur B.O": "582209",
      "Kotbal B.O": "582209",
      "Madalgeri B.O": "582209",
      "Mallapur B.O": "582209",
      "Mugali B.O": "582209",
      "Kadkol B.O": "582120",
      "Machenhalli B.O": "582120",
      "Shirahatti Haripur B.O": "582120",
      "Shiratti Kuktchery B.O": "582120",
      "Nagendragad B.O": "582211",
      "Hallikeri B.O": "582115",
      "Gojanur B.O": "582116",
      "Kundralli B.O": "582116",
      "Lakshmeshwar Court B.O": "582116",
      "Ramgeri B.O": "582116",
      "Yelavatti B.O": "582117",
      "Hesrur B.O": "582118",
      "Kalakeri B.O": "582118",
      "Korlahalli B.O": "582118",
      "Mundwad B.O": "582118",
      "Nagarahalli B.O": "582118",
      "Shingatalur B.O": "582118",
      "Maranabasari B.O": "582119",
      "Bhairanhatti B.O": "582207",
      "Jagapur B.O": "582207",
      "Shirol B.O": "582207",
      "Arahunsi B.O": "582209",
      "Chikamannur B.O": "582209",
      "Shantageri B.O": "582211",
      "Mushigeri B.O": "582211",
      "Gadag H.O": "582101",
      "Dambal S.O": "582113",
      "Gadag Betgeri S.O": "582102",
      "Gadag Extension S.O": "582101",
      "Gajendragad S.O": "582114",
      "Hombal S.O": "582204",
      "Shiratti S.O": "582120",
      "Hulkoti S.O": "582205",
      "Mulgund S.O": "582117",
      "Nargund Bazar S.O": "582207",
      "Nargund S.O": "582207",
      "Ron Taluk Kut S.O": "582209",
      "Abbigeri S.O": "582111",
      "Gadag City S.O": "582103",
      "Gadag Mulgund Naka S.O": "582103",
      "Holealur S.O": "582203",
      "Mundargi S.O": "582118",
      "Ron S.O": "582209",
      "Shigli S.O": "582210",
      "Sudi S.O": "582211",
      "Bellatti S.O": "582112",
      "Belvanki S.O": "582202",
      "Gadag Bazar S.O": "582101",
      "Gadag Cotton Market S.O": "582101",
      "Konnur S.O (Gadag)": "582206",
      "Lakkundi S.O": "582115",
      "Lakshmeshwar S.O": "582116",
      "Naregal S.O": "582119"
    },
    "BALLARI": {
      "Bandihatti B.O": "583102",
      "Kakarlathota B.O": "583102",
      "Siriganahalli B.O": "583137",
      "Yedihalli B.O": "583137",
      "Enigi B.O": "583224",
      "Kittanur B.O": "583224",
      "Muthukuru B.O": "583224",
      "Telugoli B.O": "583224",
      "Kadathi B.O": "583137",
      "Sreedharagadda B.O": "583103",
      "Talur B.O": "583123",
      "P D Halli B.O": "583111",
      "Sidiginamola B.O": "583111",
      "Y.Kaggallu B.O": "583111",
      "Yalpi B.O": "583111",
      "Swamihalli B.O": "583112",
      "Yaradammanahalli B.O": "583112",
      "Laxmipura B.O": "583113",
      "Nelludi B.O": "583113",
      "Oruvai B.O": "583113",
      "Somalapura B.O": "583113",
      "Appayyanahalli B.O": "583130",
      "Bellighatta B.O": "583130",
      "Chandrashekharapura B.O": "583130",
      "Gandabommanahalli B.O": "583130",
      "Nadanga B.O": "583114",
      "Nagarahal B.O": "583114",
      "Vattamuruvani B.O": "583114",
      "Anthapura B.O": "583152",
      "Eriangalgi B.O": "583115",
      "Haraginadoni B.O": "583115",
      "Yelubenchi B.O": "583115",
      "Dammuru B.O": "583155",
      "Basarakodu B.O": "583224",
      "Bhairapura B.O": "583154",
      "Kanchagar Belagal B.O": "583121",
      "Kotehal Sugur B.O": "583121",
      "Nagalapura B.O": "583123",
      "Herkal B.O": "583122",
      "Nadavi B.O": "583122",
      "Nittur B.O": "583213",
      "Anajigere B.O": "583125",
      "Allipur B.O": "583104",
      "Ibrahimpura B.O": "583102",
      "Kammarchedu B.O": "583102",
      "Kolagallu B.O": "583104",
      "Yettinabudihal B.O": "583102",
      "Asundi B.O": "583103",
      "Machihalli B.O": "583137",
      "Yarabalu B.O": "583137",
      "Chilagodu B.O": "583224",
      "Talavagalu B.O": "583137",
      "Byasidgeri B.O": "583224",
      "Halakundi B.O": "583102",
      "Somasamudra B.O": "583155",
      "Jalibenchi B.O": "583103",
      "Korlagundi B.O": "583103",
      "Siriwara Kappagal B.O": "583103",
      "Joladarashi B.O": "583111",
      "Karekallu B.O": "583111",
      "Motalakunta B.O": "583112",
      "Ittigi Muddapura B.O": "583113",
      "Kottal B.O": "583113",
      "Srikanthapura B.O": "583130",
      "Bevinamarada Sugur B.O": "583114",
      "Ittigihal B.O": "583114",
      "Ravihal B.O": "583114",
      "B Belagal B.O": "583115",
      "Rajapura B.O": "583152",
      "Mustagatta B.O": "583116",
      "Vaddatti B.O": "583116",
      "Bennikallu B.O": "583212",
      "Dasaranagenahalli B.O": "583117",
      "Karichedu B.O": "583117",
      "Sindhavalam B.O": "583117",
      "Sushilanagar B.O": "583119",
      "Buduguppa B.O": "583154",
      "Darur B.O": "583154",
      "Sanavasapura B.O": "583120",
      "Agricultural Research Centre B.O": "583121",
      "Bagewadi B.O": "583121",
      "Kenchanagudda B.O": "583121",
      "Raravi B.O": "583121",
      "Arliganur B.O": "583121",
      "Devinagara B.O": "583122",
      "Hirekeriginalli B.O": "583124",
      "Kakkabevinahalli B.O": "583103",
      "Sanganakal B.O": "583103",
      "Chaganur B.O": "583111",
      "K Veerapura B.O": "583111",
      "Gollalingammanahalli B.O": "583112",
      "Subbarayanahalli B.O": "583112",
      "H Veerapura B.O": "583113",
      "Kallukamba B.O": "583113",
      "Hulikunta B.O": "583130",
      "Thimmanahalli B.O": "583130",
      "Chickbellary B.O": "583114",
      "Kottalachinta B.O": "583114",
      "Tasalakudlur B.O": "583114",
      "Chickanthapura B.O": "583152",
      "Siddammanahalli B.O": "583115",
      "D Kaggal B.O": "583155",
      "Genikihal B.O": "583116",
      "Belachinta B.O": "583117",
      "Bhairadevanahalli B.O": "583117",
      "Moka Gonehal B.O": "583117",
      "Taranagar B.O": "583119",
      "Byloor B.O": "583120",
      "H Hosahalli B.O": "583154",
      "Bandrahalu B.O": "583121",
      "Kudadarahal B.O": "583121",
      "Kuruvalli B.O": "583121",
      "Balakundi B.O": "583122",
      "Udegolam B.O": "583122",
      "Uppara Hosahalli B.O": "583122",
      "Kurekuppa B.O": "583123",
      "Vaddu B.O": "583123",
      "Bandri B.O": "583124",
      "Ragimasalawada B.O": "583137",
      "Singrihalli B.O": "583137",
      "Bannigola B.O": "583224",
      "M S Kota B.O": "583102",
      "Park Road B.O": "583102",
      "Rupangudi B.O": "583102",
      "Shankarabanda B.O": "583102",
      "Bisalahalli B.O": "583103",
      "Gududur B.O": "583103",
      "Handihal Gududur B.O": "583103",
      "Shastri Nagar B.O": "583103",
      "Channapatna B.O": "583113",
      "K.Rayapura B.O": "583130",
      "Mahadevapura B.O": "583130",
      "Ramadurga B.O": "583130",
      "Shidigallu B.O": "583130",
      "Agasanur B.O": "583114",
      "Basarahalli B.O": "583114",
      "Beeravalli B.O": "583114",
      "Janekunta B.O": "583115",
      "Metriki B.O": "583152",
      "Veniveerapura B.O": "583115",
      "Vittalapura B.O": "583152",
      "Badanahatti B.O": "583116",
      "Chanahal B.O": "583155",
      "Erragudi B.O": "583117",
      "Gotur B.O": "583117",
      "Hirehadligi    B.O": "583117",
      "Jalihal B.O": "583117",
      "Bhujanganagar B.O": "583119",
      "Dawlatpur B.O": "583119",
      "Krishna Nagar B.O": "583119",
      "Nandihalli B.O": "583119",
      "Havinal B.O": "583120",
      "Konchigere B.O": "583120",
      "Mannur Sugur B.O": "583120",
      "Muddatanur B.O": "583120",
      "Sindhigere B.O": "583120",
      "Uttanur B.O": "583154",
      "Chanakanur B.O": "583121",
      "Desanur B.O": "583121",
      "Halekota B.O": "583122",
      "Nidugurthi B.O": "583124",
      "Geddalagatta B.O": "583135",
      "Hansi B.O": "583135",
      "Hireheggadahal B.O": "583135",
      "Jarimale B.O": "583135",
      "Kakkuppi B.O": "583135",
      "Kuppinakere B.O": "583135",
      "Thimmalapura B.O": "583134",
      "Nagarakatte B.O": "583136",
      "Nimbalgere B.O": "583136",
      "Toolahalli B.O": "583136",
      "Byluvaddigere B.O": "583223",
      "Bendigere B.O": "583137",
      "Chirastahalli B.O": "583137",
      "Amalapura B.O": "583135",
      "Badeladuku B.O": "583135",
      "Moraba B.O": "583135",
      "Uramma Temple B.O": "583135",
      "Nandibanda B.O": "583222",
      "Vyasanakere B.O": "583222",
      "Mangapura B.O": "583136",
      "Gadiganur B.O": "583223",
      "Kariganur B.O": "583223",
      "Alagilawada B.O": "583137",
      "Amaradevaragudda B.O": "583135",
      "Chowdapura B.O": "583135",
      "Shivapura B.O": "583135",
      "Dananayakanakere B.O": "583222",
      "Gunda B.O": "583222",
      "Hampa Patna B.O": "583222",
      "Kalapura B.O": "583136",
      "Dharmasagara B.O": "583223",
      "Kakubal B.O": "583223",
      "Duggavati B.O": "583137",
      "Chilakanahatti B.O": "583222",
      "Danapura B.O": "583222",
      "G Nagalapura B.O": "583222",
      "Halagapura B.O": "583222",
      "Harakanahalu B.O": "583131",
      "Gundagatti B.O": "583137",
      "Chatnihalli B.O": "583125",
      "Halli Kere B.O": "583125",
      "Kadabagere B.O": "583125",
      "Ramagatta B.O": "583125",
      "Sattur B.O": "583125",
      "Tavadur B.O": "583125",
      "Uchangidurga B.O": "583125",
      "Bennihalli B.O": "583127",
      "Sasvihalli B.O": "583127",
      "Huralihal B.O": "583126",
      "Jummobanahalli B.O": "583126",
      "M B Ayyanahalli B.O": "583126",
      "Siddapura B.O": "583126",
      "Suladahalli B.O": "583126",
      "Agrahara B.O": "583128",
      "Bommagatta B.O": "583128",
      "Metri B.O": "583129",
      "New Daroji B.O": "583129",
      "Old Daroji B.O": "583129",
      "Srirama Rangapura B.O": "583129",
      "Suggenahalli B.O": "583129",
      "Marebbihal B.O": "583212",
      "Neelagunda B.O": "583213",
      "Tavaragundi B.O": "583213",
      "Garbhagudi  B.O": "583213",
      "Enigi Basapura B.O": "583214",
      "G Kodihalli B.O": "583214",
      "Kaddi Rampura B.O": "583239",
      "Adavihalli B.O": "583131",
      "Bagali B.O": "583131",
      "Hirebannimatti B.O": "583216",
      "Makarabbi B.O": "583216",
      "Mannur Masalawada B.O": "583216",
      "Kuruvathi B.O": "583217",
      "Kenchamallanahalli B.O": "583218",
      "Lokikere B.O": "583218",
      "Ananthashayanagudi B.O": "583201",
      "Nelkudri B.O": "583220",
      "Sonna B.O": "583220",
      "Venkatapura B.O": "583221",
      "Ambli B.O": "583134",
      "Haralu B.O": "583134",
      "Kanchikere B.O": "583125",
      "Kyarakatte B.O": "583125",
      "Aladahalli B.O": "583127",
      "Amaravathi B.O": "583211",
      "Nagenahalli B.O": "583211",
      "Sovenahalli B.O": "583214",
      "Tumbaraguddi B.O": "583128",
      "Tyagadahal B.O": "583128",
      "Kadlebalu B.O": "583212",
      "Malvi B.O": "583212",
      "Upparagatta B.O": "583212",
      "Varlahalli B.O": "583212",
      "Hakkandi B.O": "583214",
      "Kulahalli B.O": "583131",
      "Madlagere B.O": "583131",
      "Nandibevoor B.O": "583131",
      "Hiremagalagere B.O": "583125",
      "Madihalli B.O": "583125",
      "Pothalakatta B.O": "583125",
      "Mattihalli B.O": "583127",
      "Banvikal B.O": "583126",
      "Harakabhavi B.O": "583126",
      "Kumati B.O": "583126",
      "Makanadaku B.O": "583126",
      "Jiginihalli B.O": "583128",
      "Shaliyappanahalli B.O": "583128",
      "Devasamudra B.O": "583129",
      "Ankasamudra B.O": "583212",
      "Chintrapalli B.O": "583212",
      "Pinjaraheggadehal B.O": "583212",
      "Uluvathi B.O": "583212",
      "Ittigudi B.O": "583213",
      "Kunchur B.O": "583213",
      "Gaddikere B.O": "583214",
      "Hiremallanakere B.O": "583214",
      "Kondanayakanahalli B.O": "583239",
      "Kanvihalli B.O": "583131",
      "Upparagere B.O": "583131",
      "Karadi Ayyanahalli B.O": "583216",
      "Budanur B.O": "583217",
      "Harvi B.O": "583217",
      "Imdapura B.O": "583218",
      "Katriki Halli B.O": "583218",
      "Beerabbi B.O": "583216",
      "Hagaranur B.O": "583216",
      "Tamalapura B.O": "583216",
      "Dasanahalli B.O": "583217",
      "Alur Kudligi B.O": "583218",
      "Bailtumbaraguddi B.O": "583218",
      "Hirekumblagunta B.O": "583218",
      "Hudem B.O": "583218",
      "Huvinahadagali Bazar B.O": "583219",
      "Kombli B.O": "583219",
      "Mudenur B.O": "583219",
      "Nagatibasapura B.O": "583219",
      "Sogi B.O": "583219",
      "Thippapura B.O": "583219",
      "Uttangi B.O": "583219",
      "Alabur B.O": "583220",
      "Kampli Fort B.O": "583132",
      "Kanvi Thimmalapura B.O": "583132",
      "Muddapura B.O": "583132",
      "Ramasagara B.O": "583132",
      "Hyalya B.O": "583134",
      "Jolada Kudligi B.O": "583134",
      "K Ayyanahalli B.O": "583134",
      "Tayanakanahalli B.O": "583218",
      "Devagondanahalli B.O": "583219",
      "Navali B.O": "583219",
      "Uppanayakanahalli B.O": "583219",
      "Varakanahalli B.O": "583219",
      "Kogali B.O": "583220",
      "Morigere B.O": "583220",
      "Bukkasagara B.O": "583132",
      "Gangammanahalli B.O": "583134",
      "Rampura B.O": "583134",
      "Hosakote B.O": "583125",
      "Kammathahalli B.O": "583125",
      "Nichavvanahalli B.O": "583125",
      "Punabhagatta B.O": "583125",
      "Hagarigudihalli B.O": "583127",
      "Mydur B.O": "583127",
      "Nichapura B.O": "583127",
      "Chiratagundu B.O": "583126",
      "Gundumunugu B.O": "583126",
      "Kadekola B.O": "583126",
      "Meenakere B.O": "583126",
      "Devara Mallapura B.O": "583128",
      "Kalingere B.O": "583128",
      "Chikkajayaganur B.O": "583129",
      "Hampadevanahalli B.O": "583129",
      "Anekal B.O": "583212",
      "Bachigondanahalli B.O": "583212",
      "Dasamapura B.O": "583212",
      "Nanyapura B.O": "583212",
      "Arasanahalu B.O": "583213",
      "Kallahalli B.O": "583213",
      "Bannikallu B.O": "583214",
      "Kalvi B.O": "583214",
      "Malpanagudi B.O": "583239",
      "Goverahalli B.O": "583131",
      "Hulikatti B.O": "583131",
      "Togarikatti B.O": "583131",
      "Hirekolachi B.O": "583216",
      "Kattebennur B.O": "583216",
      "Magala B.O": "583216",
      "Hyarada B.O": "583217",
      "Mylar B.O": "583217",
      "Hulikere B.O": "583218",
      "Kanamadugu B.O": "583218",
      "Poojarahalli B.O": "583218",
      "Dasarahalli B.O": "583219",
      "Holagundi B.O": "583219",
      "Nandi Halli B.O": "583219",
      "Mahajanadahalli B.O": "583220",
      "Musuvinalli Kalahalli B.O": "583220",
      "Belugoduhal B.O": "583132",
      "Kampli Sugar  Factory B.O": "583132",
      "Sanapura B.O": "583132",
      "Chapparada Halli B.O": "583134",
      "Doopadahalli B.O": "583134",
      "Hagari Gajapura B.O": "583134",
      "K Gajapura B.O": "583134",
      "Ballari Brucepettah S.O": "583101",
      "Ballari District Court S.O": "583101",
      "Ballari Gandhinagar S.O": "583103",
      "Chellakurki S.O": "583111",
      "Sandur S.O": "583119",
      "Sirigere S.O(Ballari)": "583120",
      "Arasikere S.O": "583125",
      "Chigatere S.O": "583127",
      "Chitwadgi S.O": "583211",
      "Ballari Herialukadam S.O": "583101",
      "Ballari M V Nagar S.O": "583103",
      "Ballari Patel Nagar S.O": "583101",
      "Ballari Satyanarayanapet S.O": "583101",
      "Ballari Fort S.O": "583102",
      "Emmiganur S.O": "583113",
      "Hatcholi S.O": "583114",
      "Siruguppa Sadashivanagar S.O": "583121",
      "Toranagallu S.O": "583123",
      "Shankar Hill Town Colony S.O.": "583153",
      "Karur SO": "583154",
      "Ballari Cantonment S.O": "583104",
      "Ballari Jnanasagara S.O": "583105",
      "Ballari Parvathi Nagar S.O": "583103",
      "Moka S.O": "583117",
      "Kolur S.O": "583155",
      "Chikkajogihalli S.O": "583126",
      "Choranur S.O": "583128",
      "Ballari City S.O": "583101",
      "Ballari Cowl Bazar S.O": "583102",
      "Ballari Thermal Power Station S.O": "583152",
      "D T Ship S.O": "583118",
      "Deogiri S.O": "583112",
      "Gudekota S.O": "583130",
      "Kudathini S.O": "583115",
      "Kurugodu S.O": "583116",
      "Lakshmipura Sandur S.O": "583119",
      "Sanjay Gandhi Nagar S.O": "583104",
      "Siruguppa S.O": "583121",
      "Tekkalakota S.O": "583122",
      "Vidyanagar S.O(Ballari)": "583275",
      "Yeshwantnagar S.O(Ballari)": "583124",
      "Devalapura S.O(Ballari)": "583129",
      "Hosapete H.O": "583201",
      "Ballari H.O": "583101",
      "H B Halli Town S.O": "583212",
      "Hagaribommanahalli S.O": "583212",
      "Halavagalu S.O": "583213",
      "Harapanahalli Joshi Street S.O": "583131",
      "Holalu S.O": "583217",
      "Hosapete N C C S.O": "583203",
      "Huvinahadagali S.O": "583219",
      "Kudligi S.O": "583135",
      "Mariammanahalli S.O": "583222",
      "Oojein S.O": "583136",
      "Thambrahalli S.O": "583224",
      "Hampasagara S.O": "583214",
      "K U Campus S.O": "583276",
      "Kamalapura S.O": "583221",
      "Kampli Bazar S.O": "583132",
      "Kottur Bazar S.O": "583134",
      "Kottur S.O(Ballari)": "583134",
      "Teligi S.O": "583137",
      "Harapanahalli Town S.O": "583131",
      "Hosahalli S.O": "583218",
      "Hosapete J P Nagar S.O": "583201",
      "Hosapete Patel Nagar S.O": "583201",
      "Kampli S.O": "583132",
      "Hampi Power House S.O": "583215",
      "Hampi S.O": "583239",
      "Harapanahalli S.O": "583131",
      "Hirehadagali S.O": "583216",
      "Hosapete Ranipet S.O": "583201",
      "Ittigi S.O": "583220",
      "Papinayakanahalli S.O": "583223",
      "T B Dam S.O": "583225"
    },
    "DHARWAD": {
      "Shinganalli B.O": "580011",
      "Kalkeri B.O": "580007",
      "Kelageri B.O": "580007",
      "Mugad B.O": "580007",
      "Ramapur B.O": "580007",
      "Banagitti Gudihal B.O": "580114",
      "Yerikoppa B.O": "580114",
      "Kurabagatti B.O": "581105",
      "Dastikoppa B.O": "581204",
      "Tambur B.O": "581204",
      "Tumarikoppa B.O": "581204",
      "Kotur B.O": "580011",
      "Chikkamalligawad B.O": "580007",
      "Dharwad Farm B.O": "580007",
      "Dharwad Gtc B.O": "580007",
      "Honnapur B.O": "580007",
      "Shirkol B.O": "580112",
      "Shivalli B.O": "580112",
      "Kittur B.O": "582201",
      "Kondikoppa B.O": "582201",
      "Saswihalli B.O": "582201",
      "Gopankoppa B.O": "580023",
      "Nalawadi B.O": "580023",
      "Baradwad B.O": "581195",
      "Majjigudda B.O": "582201",
      "Rottigawad B.O": "581195",
      "Kamadolli B.O": "581113",
      "Shirur B.O": "581201",
      "Belavatgi B.O": "582208",
      "Tadahal B.O": "582208",
      "Yamanur B.O": "582208",
      "Guddadhulikatti B.O": "580024",
      "Katnur B.O": "580024",
      "Malali B.O": "580024",
      "Yerebudhihal B.O": "581117",
      "Kallur B.O": "581206",
      "Pudakalakatti B.O": "581206",
      "Yadwad B.O": "581206",
      "Basapur B.O": "582201",
      "Hallikeri B.O": "582201",
      "Harlapur B.O": "581107",
      "Ingalahalli B.O": "581209",
      "Shiraguppi B.O": "580023",
      "Yeraguppi B.O": "580023",
      "Mattigatti B.O": "580028",
      "Sherewad B.O": "580028",
      "Umachagi B.O": "581195",
      "Gudenakatti B.O": "581113",
      "Hirenarthi B.O": "581113",
      "Alagawadi B.O": "582208",
      "Arekurahatti B.O": "582208",
      "Jawoor B.O": "582208",
      "Shelwadi B.O": "582208",
      "Tirlapur B.O": "582208",
      "Anchatageri B.O": "580024",
      "Karadikoppa B.O": "580024",
      "Mummigatti B.O": "580011",
      "Tegur B.O": "580011",
      "Kavalgeri B.O": "580006",
      "Kambarganavi B.O": "580007",
      "Kyarakoppa B.O": "580007",
      "Managundi B.O": "580007",
      "Sadhankeri B.O": "580007",
      "Kotabagi B.O": "581105",
      "Halligeri B.O": "580118",
      "Belavantar B.O": "581204",
      "Devikoppa B.O": "581204",
      "Kudalagi B.O": "581204",
      "Tabakadhonnihalli B.O": "581204",
      "Tavarageri B.O": "581204",
      "Lokur B.O": "581206",
      "Bhadrapur B.O": "582201",
      "Yaliwal B.O": "581207",
      "Kalas B.O": "581107",
      "Ballarwad B.O": "581209",
      "Manakawad B.O": "581209",
      "Shishuvinahalli B.O": "581209",
      "Byahatti B.O": "580023",
      "Hallihal B.O": "580023",
      "Sulla B.O": "580023",
      "Nulvi B.O": "580028",
      "Adaragunchi B.O": "580028",
      "Devanur B.O": "581113",
      "Hireharakuni B.O": "581113",
      "Bagadageri B.O": "581196",
      "Amargol B.O": "582208",
      "Hebbal B.O": "582208",
      "Ibrahimpur B.O": "582208",
      "Naganur B.O": "582208",
      "Tuppadkurahatti B.O": "582208",
      "Belagali B.O": "580024",
      "Ramankoppa B.O": "580024",
      "Hiregunjal B.O": "581117",
      "Aravatagi B.O": "580007",
      "Navalur B.O": "580009",
      "Rayapur B.O": "580009",
      "Narendra B.O": "580005",
      "G Basavanakoppa B.O": "580114",
      "Gambhyapur B.O": "580114",
      "Hirehonnihalli B.O": "580114",
      "Kanavihonnapur B.O": "580114",
      "Madhanabhavi B.O": "581105",
      "Tadakod B.O": "581105",
      "Devarahubballi B.O": "580118",
      "Nigadi B.O": "580118",
      "Salakinkoppa B.O": "580118",
      "Bammigatti B.O": "581204",
      "Begur B.O": "581204",
      "Biravalli B.O": "581204",
      "Jinnur B.O": "581204",
      "Kalakundi B.O": "581204",
      "Mukkal B.O": "581204",
      "Muttagi B.O": "581204",
      "Sulikatti B.O": "581204",
      "Hebballi B.O": "580112",
      "Maradagi B.O": "580112",
      "Agadi B.O": "581207",
      "Betdur B.O": "581207",
      "Chebbi B.O": "581207",
      "Varur B.O": "581207",
      "Goudageri B.O": "581107",
      "Kusugal B.O": "580023",
      "Mantur B.O": "580023",
      "Ingalgi B.O": "580028",
      "Kubihal B.O": "580028",
      "Amragol B.O": "580025",
      "B K Tarlagatta B.O": "581113",
      "Chakalabbi B.O": "581113",
      "Ganjigatti B.O": "581196",
      "Surashettikoppa B.O": "581196",
      "Kamadenu B.O": "581196",
      "Ugginakeri B.O": "581196",
      "Datnal B.O": "582208",
      "Gudisagar B.O": "582208",
      "Halekusugal B.O": "582208",
      "Kalwad B.O": "582208",
      "Naiknur B.O": "582208",
      "Shanawad B.O": "582208",
      "Rayanal B.O": "580024",
      "Pashupatihal B.O": "581117",
      "Benachi B.O": "581103",
      "Kadabagatti B.O": "581103",
      "Byalal B.O": "581201",
      "Harobelvadi B.O": "581201",
      "Karadigudda B.O": "581201",
      "Kabbenur B.O": "581201",
      "Marewad B.O": "581201",
      "Dharwad H.O": "580001",
      "Hubballi H.O": "580020",
      "Dharwad K.C.Park S.O": "580008",
      "Dharwad Kutchery S.O": "580001",
      "Dharwad Sattur S.O": "580009",
      "Kalghatagi S.O": "581204",
      "Morab S.O": "580112",
      "Uppinabetageri S.O": "581206",
      "Annigeri S.O": "582201",
      "Hebsur S.O": "581209",
      "Hubballi KMC S.O": "580021",
      "Hubballi Mangalwar Peth S.O": "580020",
      "Hubballi Moorsavirmath S.O": "580028",
      "Hubballi Nekarnagar S.O": "580024",
      "Hubballi Siddharoodnagar S.O": "580024",
      "Hubballi Tabibland S.O": "580020",
      "Alnavar S.O": "581103",
      "Amminabhavi S.O": "581201",
      "Dharwad High Court S.O": "580011",
      "Dharwad Line Bazar S.O": "580001",
      "Dharwad M B Nagar S.O": "580008",
      "Dharwad M J Nagar S.O": "580006",
      "Dharwad S D M E college S.O": "580002",
      "Dharwad Saptapur S.O": "580001",
      "Dharwad City S.O": "580001",
      "Dharwad K V V S.O": "580003",
      "Dharwad Narayanpur S.O": "580008",
      "Dharwad R S S.O": "580007",
      "Aralikatti S.O": "581207",
      "Hubballi Udyamnagar S.O": "580030",
      "Hubballi Unkal S.O": "580031",
      "Hubballi Vijayanagar S.O": "580032",
      "Koliwad S.O": "581195",
      "Kundgol S.O": "581113",
      "Saunshi S.O": "581117",
      "COURT COMPLEX HUBBALLI": "580021",
      "Hubballi Tarihal Indl. Estate S.O": "580026",
      "Hubballii Traffic Island S.O": "580029",
      "Hubballi Vidyanagar S.O": "580021",
      "Hubballi Vinobanagar S.O": "580020",
      "Mishrikoti S.O": "581196",
      "Gokul S.O": "580027",
      "Dharwad Saraswatpur S.O": "580002",
      "Dharwad Vidyagiri S.O": "580004",
      "Garag S.O": "581105",
      "Hulkoppa S.O": "580118",
      "Annegeri Market S.O": "582201",
      "Bhairidevarkoppa S.O": "580025",
      "Hubballi Bharat Mill S.O": "580029",
      "Hubballi Gandhi Nagar S.O": "580030",
      "Hubballi Mv Galli S.O": "580028",
      "Hubballi Navanagar S.O": "580025",
      "Old Hubballi S.O": "580024",
      "Hubballi Akashaya Colony": "580030",
      "Dharwad Kalyan Nagar S.O": "580007",
      "Dharwad Market S.O": "580001",
      "Dharwad Tejaswi Nagar S.O": "580002",
      "Dharwad U A S S.O": "580005",
      "Dhumwad S.O": "580114",
      "Gudgeri S.O": "581107",
      "Hubballi Bankapur Chowki S.O": "580028",
      "Hubballi Bengeri S.O": "580023",
      "Hubballi Eng College S.O": "580031",
      "Hubballi Keshwapur S.O": "580023",
      "Hubballi Sarafkatta S.O": "580020",
      "Navalgund S.O": "582208"
    },
    "BAGALKOTE": {
      "Cholachagudd B.O": "587201",
      "Jakanur B.O": "587201",
      "Kabbalgerii B.O": "587201",
      "Kirsur B.O": "587111",
      "Mallapur B.O": "587111",
      "Muchakandi B.O": "587111",
      "Haveli B.O": "587103",
      "Choudapur B.O": "587115",
      "Hiremalgavi B.O": "587115",
      "Huvanur B.O": "587115",
      "Sangam B.O": "587115",
      "Ilal B.O": "587202",
      "Mangalgudda B.O": "587202",
      "Murdi B.O": "587202",
      "Wadageri B.O": "587202",
      "Parvati B.O": "587203",
      "Togunshi B.O": "587203",
      "Haunsnur B.O": "587203",
      "Bevinmatti B.O": "587112",
      "Hadagalli B.O": "587112",
      "Chikmuchalgudda B.O": "587201",
      "Halkurki B.O": "587201",
      "Hullikeri B.O": "587201",
      "Katarki B.O": "587201",
      "Nilgund B.O": "587201",
      "Shivayogmandir B.O": "587201",
      "Achanur B.O": "587111",
      "Bennur B.O": "587111",
      "Niralkeri B.O": "587206",
      "Bhairmatti B.O": "587115",
      "Bodanaikanadinni B.O": "587115",
      "Ganjihal B.O": "587115",
      "Bhimangad B.O": "587202",
      "Hanapur B.O": "587203",
      "Kutkankeri B.O": "587203",
      "Belgal B.O": "587112",
      "Chittargi B.O": "587112",
      "Hiremagi B.O": "587112",
      "Hebballi B.O": "587201",
      "Khyad B.O": "587201",
      "Lakhamapur B.O": "587201",
      "Pattadkal B.O": "587201",
      "Yankanchi B.O": "587201",
      "Benkatti B.O": "587111",
      "Bevinmattti B.O": "587111",
      "Kadlimatti B.O": "587111",
      "Mugalolli B.O": "587111",
      "Shigikeri B.O": "587111",
      "Gandhinagar B.O": "587103",
      "Dhanakshirur B.O": "587114",
      "Hirenasabi B.O": "587114",
      "Bhagavati B.O": "587115",
      "Bisaldinni B.O": "587115",
      "Hallur B.O": "587115",
      "Gaddankeri B.O": "587102",
      "Kadampur B.O": "587102",
      "Yadhalli B.O": "587102",
      "Haladoor B.O": "587203",
      "Layadgundi B.O": "587203",
      "Hulaginal B.O": "587112",
      "Iddalgi B.O": "587112",
      "Rakkasagi B.O": "587112",
      "Adagal B.O": "587201",
      "Bachingudd B.O": "587201",
      "Muttalgeri B.O": "587201",
      "Nandikeshwar B.O": "587201",
      "Shirbadagi B.O": "587201",
      "Yaragoppa B.O": "587201",
      "Chikhodlur B.O": "587111",
      "Honnakatti B.O": "587111",
      "Illal B.O": "587111",
      "Jadramkunti B.O": "587111",
      "Guddadmallapur B.O": "587114",
      "Hosur B.O": "587207",
      "Jalihal B.O": "587114",
      "Herkal B.O": "587102",
      "Sorakoppa B.O": "587102",
      "Kataraki B.O": "587204",
      "Siddapur B.O": "587117",
      "Yadahalli B.O": "587313",
      "Kankanwadi B.O": "587119",
      "Madarkhandi B.O": "587119",
      "Maigur B.O": "587119",
      "Muttur B.O": "587119",
      "Shurpali B.O": "587119",
      "Sokanadagi B.O": "587204",
      "Chikkur B.O": "587122",
      "Nandgaon B.O": "587312",
      "Baragi B.O": "587313",
      "Ningapur B.O": "587313",
      "Rugi B.O": "587313",
      "Shirol B.O": "587313",
      "Uttur B.O": "587313",
      "Rampur B.O": "587314",
      "Gothe B.O": "587330",
      "Kajibilgi B.O": "587330",
      "Kalabilagi B.O": "587330",
      "Kannolli B.O": "587330",
      "Takkalki B.O": "587330",
      "Golbhavi B.O": "587315",
      "Halingali B.O": "587315",
      "Govankoppa B.O": "587155",
      "Kittali B.O": "587155",
      "Narasapur B.O": "587155",
      "Katagur B.O": "587207",
      "Sutagundar B.O": "587207",
      "Chilapur B.O": "587124",
      "Tallikeri B.O": "587124",
      "Simikeri B.O": "587104",
      "Algur B.O": "587301",
      "Chingundi B.O": "587301",
      "Kolur B.O": "587301",
      "Mundagnur B.O": "587301",
      "Todalbagi B.O": "587301",
      "Nagaral B.O": "587116",
      "Alur S.K. B.O": "587155",
      "Kelur B.O": "587124",
      "Hulyal B.O": "587301",
      "Hunshikatti B.O": "587301",
      "Kavatagi B.O": "587301",
      "Kumbarhal B.O": "587301",
      "Kunchanur B.O": "587301",
      "Linganur B.O": "587301",
      "Kulali B.O": "587113",
      "Malali B.O": "587113",
      "Mugalkhod B.O": "587113",
      "Janmatti B.O": "587116",
      "Kundaragi B.O": "587204",
      "Mannikeri B.O": "587116",
      "Tolmatti B.O": "587116",
      "Badagi B.O": "587117",
      "Hanchinal B.O": "587117",
      "Teggi B.O": "587117",
      "Kadakol B.O": "587119",
      "Kalahalli B.O": "587119",
      "Shiraguppi B.O": "587204",
      "Khajjidoni B.O": "587204",
      "Tulsigeri B.O": "587204",
      "Mareguddi B.O": "587121",
      "Kasabajambgi B.O": "587122",
      "Muddapur B.O": "587122",
      "Varchagal B.O": "587122",
      "Chimmad B.O": "587312",
      "Bidari B.O": "587313",
      "Chichakhandi B.K. B.O": "587313",
      "Malapur B.O": "587313",
      "Metgudd B.O": "587313",
      "Vantigodi B.O": "587313",
      "Gadyal B.O": "587330",
      "Jambagi B.O": "587330",
      "Tungal B.O": "587330",
      "Sasalatti B.O": "587315",
      "Anagwadi B.O": "587116",
      "Dhavaleshwar B.O": "587312",
      "Honnihal B.O": "587116",
      "Kandgal B.O": "587154",
      "Koppa S K B.O": "587204",
      "Lingapur B.O": "587116",
      "Muttaldinni B.O": "587116",
      "Sunag B.O": "587116",
      "Tummarmatti B.O": "587116",
      "Bisnal B.O": "587117",
      "Albal B.O": "587119",
      "Kadapatti B.O": "587119",
      "Tubachi B.O": "587119",
      "Chikshellikeri B.O": "587204",
      "Udagatti B.O": "587204",
      "Mantur B.O": "587121",
      "Melligeri B.O": "587121",
      "Dadnatti B.O": "587122",
      "Kadarkoppa B.O": "587122",
      "Petlur B.O": "587122",
      "Chichakandi  K.D. B.O": "587313",
      "Gulgal Jambgi B.O": "587313",
      "Machakanur B.O": "587313",
      "Mirji B.O": "587313",
      "Vajjarmatti B.O": "587313",
      "Madabhavi B.O": "587316",
      "Adihudi B.O": "587330",
      "Hanagandi B.O": "587315",
      "Tamadaddi B.O": "587315",
      "Chikkalki B.O": "586113",
      "Sulla B.O": "587155",
      "Bilkerur B.O": "587207",
      "Chikmyageri B.O": "587207",
      "Aihole B.O": "587124",
      "Jagadal B.O": "587311",
      "Navalagi B.O": "587311",
      "Yallatti B.O": "587311",
      "Yandigeri B.O": "587206",
      "Belavalakoppa B.O": "587155",
      "Kakanur B.O": "587155",
      "Mamatgeri B.O": "587155",
      "Hiregulbal B.O": "587207",
      "Nainegali B.O": "587207",
      "Murnal B.O": "587104",
      "Chikpadasalagi B.O": "587301",
      "Hirepadasalagi B.O": "587301",
      "Naganur B.O": "587301",
      "Asangi B.O": "587311",
      "Kulahalli B.O": "587311",
      "Sorgaon B.O": "587113",
      "Algundi B.O": "587204",
      "Arakeri B.O": "587116",
      "Badagandi B.O": "587116",
      "Girisagar B.O": "587116",
      "Rolli B.O": "587116",
      "Sonna B.O": "587116",
      "Bantanur B.O": "587122",
      "Devanal B.O": "587204",
      "Kaladgi  Bazar B.O": "587204",
      "Amalzeri B.O": "587121",
      "Budni B.O": "587121",
      "Gani B.O": "587121",
      "Halagali B.O": "587121",
      "Hebbal B.O": "587122",
      "Kesargoppa B.O": "587312",
      "Ingalagi B.O": "587313",
      "Jeergal B.O": "587313",
      "Marapur B.O": "587316",
      "Saidapur B.O": "587316",
      "Bidari (Jkd) B.O": "586125",
      "Kamaldinni Village B.O": "587118",
      "Marol B.O": "587118",
      "Gorbal B.O": "587154",
      "Herur B.O": "587154",
      "Hirekodagali B.O": "587154",
      "Amarawadgi B.O": "587125",
      "Banakanadoni B.O": "587125",
      "Budihal S.K. B.O": "587125",
      "Chinnapur B.O": "587125",
      "Karadi B.O": "587125",
      "Kodihal B.O": "587125",
      "Nandwadgi B.O": "587125",
      "Surlikal B.O": "587120",
      "Agasankoppa B.O": "587206",
      "Anawal B.O": "587206",
      "Chinchalkatti B.O": "587206",
      "Hoolgeri B.O": "587206",
      "Kainkatti B.O": "587206",
      "Kerakalmatti B.O": "587206",
      "Mushtigeri B.O": "587206",
      "Nirbudihal B.O": "587206",
      "Amaravati B.O": "587118",
      "Chitwadgi B.O": "587118",
      "Nagur B.O": "587118",
      "Timmapur B.O": "587118",
      "Jammaldinni B.O": "587154",
      "Balkundi B.O": "587125",
      "Chikkadapur B.O": "587125",
      "Jalkamaladinni B.O": "587125",
      "Kamblihal B.O": "587125",
      "Chikmagi B.O": "587120",
      "Muganur B.O": "587120",
      "Haligeri B.O": "587206",
      "Narenur B.O": "587206",
      "Havaragi B.O": "587118",
      "Hirebadwadgi B.O": "587118",
      "Hireotageri B.O": "587154",
      "Tumba B.O": "587154",
      "Hirebudihal B.O": "587205",
      "Kagalgomba B.O": "587205",
      "Kelawadi B.O": "587205",
      "Ugalwat B.O": "587206",
      "Dhannur B.O": "587118",
      "Ramwadgi B.O": "587118",
      "Hiresingangutti B.O": "587154",
      "Moratageri B.O": "587154",
      "Kadiwal B.O": "587125",
      "Kadiwal Kallapur B.O": "587120",
      "Ramthal B.O": "587120",
      "Hangaragi B.O": "587205",
      "Jammankatti B.O": "587205",
      "Sulikeri B.O": "587205",
      "Jalgeri B.O": "587206",
      "Radder Timmapur B.O": "587206",
      "Savalagi S.O": "587330",
      "Terdal S.O": "587315",
      "HIPPARGI SO": "587331",
      "Bagalkot H.O": "587101",
      "Jamkhandi H.O": "587301",
      "Hungund Bazar S.O": "587118",
      "Ilkal  Alampurpet S.O": "587154",
      "Kamatgi S.O": "587120",
      "Kerur S.O": "587206",
      "Belagali S.O": "587113",
      "Bilgi S.O (Bagalkot)": "587116",
      "Guledgudd S.O": "587203",
      "Katageri S.O": "587205",
      "Bagalkot DC Complex": "587103",
      "Bagalkot UHS Campus S.O": "587104",
      "Shirur S.O": "587156",
      "Mahalingpur Town S.O": "587312",
      "Mudhol (Bagalkot) S.O": "587313",
      "Mudhol Extension S.O": "587313",
      "Lokapur S.O": "587122",
      "Gudur S.O (Bagalkot)": "587202",
      "Hungund S.O": "587118",
      "Ilkal Gandhi Chowk. S.O": "587125",
      "Kulgeri Cross S.O": "587155",
      "Rampur S.O (Bagalkot)": "587207",
      "Banahatti S.O": "587311",
      "Banahatti Somaarpeth S.O": "587311",
      "Jamkhandi Girishanagar S.O": "587301",
      "Kaladgi S.O": "587204",
      "Ilkal S.O": "587125",
      "Sulebhavi S.O": "587124",
      "Galagali S.O": "587117",
      "Hunnur S.O": "587119",
      "Jamkhandi  B.S.R. S.O": "587301",
      "Konnur S.O (Bagalkot)": "587121",
      "Mahalingpur S.O": "587312",
      "Sameerwadi S.O": "587316",
      "Rabkavi S.O": "587314",
      "Rabkavi Town S.O": "587314",
      "Badami Extension S.O": "587201",
      "Badami S.O": "587201",
      "Belur S.O (Bagalkot)": "587114",
      "Bevur S.O (Bagalkot)": "587115",
      "Amingad S.O": "587112",
      "Bagalkot Alokudyog S.O": "587111",
      "Gaddankeri Cross S.O": "587102",
      "Bagalkot B.H.School S.O": "587101",
      "Bagalkot Navanagar S.O": "587103"
    },
    "YADGIR": {
      "Chamnal B.O": "585309",
      "Hoskera B.O": "585309",
      "Rajapur B.O": "585309",
      "Ukkinal B.O": "585309",
      "Budur B.O": "585214",
      "Kakalwar B.O": "585214",
      "Keshwar B.O": "585214",
      "Kotgera B.O": "585214",
      "Kolihal B.O": "585215",
      "Munirbommanahalli B.O": "585216",
      "Nagnoor B.O": "585216",
      "Parasanhalli B.O": "585216",
      "Yelgi B.O": "585216",
      "Peth Ammapur B.O": "585224",
      "Rukmapur B.O": "585290",
      "Shelgi B.O": "585224",
      "Sugur B.O": "585224",
      "Balkal B.O": "585319",
      "Chatnalli B.O": "585319",
      "Laxmipur B.O": "585304",
      "Yewoor B.O": "585309",
      "Chepatla B.O": "585214",
      "Chintakunta B.O": "585214",
      "Narayanpur B.O": "585214",
      "Kakkera B.O": "585215",
      "Agni B.O": "585216",
      "Chincholi B.O": "585216",
      "Goudagera B.O": "585216",
      "Malla B B.O": "585216",
      "Yenniwadgera B.O": "585237",
      "Aldal B.O": "585290",
      "Hunsihole B.O": "585290",
      "Kavadimatti B.O": "585224",
      "Mangalore B.O": "585224",
      "Tinthani B.O": "585290",
      "Idloor B.O": "585315",
      "Yelsetti B.O": "585315",
      "Gundagurthi B.O": "585319",
      "Kurkunda B.O": "585319",
      "Kongandi B.O": "585304",
      "Sharadahalli B.O": "585304",
      "Budnoor B.O": "585309",
      "Wanadurga B.O": "585309",
      "Chandarki B.O": "585214",
      "Gajarkot B.O": "585214",
      "Motanhalli B.O": "585214",
      "Najarapur B.O": "585214",
      "Putpak B.O": "585214",
      "Hebbal B B.O": "585215",
      "Arkera J B.O": "585216",
      "Hadnoor B.O": "585216",
      "Hiremudnoor B.O": "585216",
      "Malagatti B.O": "585216",
      "Hagaratgi B.O": "585237",
      "Marnal B.O": "585237",
      "Bachimatti B.O": "585290",
      "Godihal B.O": "585290",
      "Jalibenchi B.O": "585224",
      "Kanhalli B.O": "585224",
      "Konhal B.O": "585290",
      "Wagingera B.O": "585224",
      "Ajalapur B.O": "585315",
      "Jaigram B.O": "585315",
      "Venkasambra B.O": "585315",
      "TOTLOOR BO": "585315",
      "Tadibidi B.O": "585319",
      "Hemnoor B.O": "585304",
      "Kollur B.O": "585304",
      "Manikgiri B.O": "585214",
      "M. T palli B.O": "585214",
      "Yadlapur B.O": "585214",
      "Malnoor B.O": "585215",
      "Srinivasapur B.O": "585215",
      "Vajjal B.O": "585215",
      "Alhal B.O": "585216",
      "Amlihal B.O": "585216",
      "Hegganadoddi B.O": "585216",
      "Kembhavi Sanjeev Nagar B.O": "585216",
      "Bappargi B.O": "585237",
      "Bardevanal B.O": "585237",
      "Budihal B.O": "585237",
      "Joganbhavi B.O": "585237",
      "Baichbal B.O": "585224",
      "Bonal B.O": "585290",
      "Devapur B.O": "585290",
      "Devatkal B.O": "585290",
      "Kalebelgundi B.O": "585315",
      "Karanagi B.O": "585315",
      "Nandepalli B.O": "585315",
      "Nasalwai B.O": "585315",
      "Kadamgera B.O": "585319",
      "Khanapur B.O": "585319",
      "Diggi B.O": "585287",
      "Maddarki B.O": "585287",
      "Jamalapur B.O": "585291",
      "Mudbal B.O": "585287",
      "Birnoor B.O": "585304",
      "Hothpeth B.O": "585287",
      "Geddalmari B.O": "585291",
      "Kamanatagi B.O": "585291",
      "Belgera B.O": "585321",
      "Chintapalli B.O": "585321",
      "Jinkera B.O": "585321",
      "Konekal B.O": "585321",
      "Tatalgera B.O": "585321",
      "Yempad B.O": "585321",
      "Devargonal B.O": "585220",
      "Rastapur B.O": "585323",
      "Balched B.O": "585221",
      "Killankera B.O": "585221",
      "Mungal B.O": "585221",
      "Aikur B.O": "585223",
      "Doranhalli B.O": "585223",
      "Hattigudur B.O": "585223",
      "Konkal B.O": "585355",
      "Shivapur B.O": "585355",
      "Hedgimadra B.O": "585202",
      "Kavalur B.O": "585202",
      "Mundarga B.O": "585202",
      "Algera B.O": "585321",
      "Anpur B.O": "585321",
      "Arkera K B.O": "585321",
      "Ashnal B.O": "585321",
      "Ganganal B.O": "585323",
      "Belgumpa B.O": "585221",
      "Duppalli B.O": "585221",
      "Hireanur B.O": "585221",
      "Kadechur B.O": "585221",
      "Adilapur B.O": "585223",
      "Bilhar B.O": "585355",
      "Allipur B.O": "585202",
      "Babalad B.O": "585202",
      "Bandhalli B.O": "585202",
      "Halagera B.O": "585202",
      "Ullesugur B.O": "585202",
      "Waddanhalli B.O": "585202",
      "Workanhalli B.O": "585202",
      "Gunjanur B.O": "585321",
      "Kandkur B.O": "585321",
      "Minaspur B.O": "585321",
      "Paspul B.O": "585321",
      "Yelhar B.O": "585321",
      "Baddepalli B.O": "585221",
      "Anabi B.O": "585223",
      "Hayyal B B.O": "585223",
      "Hayyal K B.O": "585223",
      "Hurusgundagi B.O": "585223",
      "Ibrahimpur B.O": "585223",
      "Madarkal B.O": "585223",
      "Rotnadagi B.O": "585355",
      "Tumkur B.O": "585202",
      "Hattikuni B.O": "585202",
      "Hongera B.O": "585202",
      "Katagi Shahapur B.O": "585202",
      "Thanagundi B.O": "585202",
      "Chinnakar B.O": "585321",
      "Ghanpur B.O": "585321",
      "Kannekollur B.O": "585323",
      "Badiyal B.O": "585221",
      "Balichakra B.O": "585221",
      "Kanekal B.O": "585221",
      "Malhar B.O": "585221",
      "Shettihalli B.O": "585221",
      "Ekchinti B.O": "585223",
      "Hallisagar B.O": "585223",
      "Sirwal B.O": "585223",
      "Bendebembli B.O": "585355",
      "Chennur B.O": "585355",
      "Arkera B B.O": "585202",
      "Gulsaram B.O": "585202",
      "Koilur B.O": "585202",
      "Mudnal B.O": "585202",
      "Yadgiri H.O": "585201",
      "Bheemarayanagudi S.O": "585287",
      "Hunasgi S.O": "585215",
      "Madhwar S.O": "585315",
      "Rajankollur S.O": "585291",
      "Saidapur S.O (Yadgir)": "585221",
      "Shahapur S.O (Yadgir)": "585223",
      "Shorapur S.O": "585224",
      "Yadgiri Station S.O": "585202",
      "Yadgiri Town S.O": "585201",
      "Gogi S.O": "585309",
      "Gurmitkal S.O": "585214",
      "Kumbarpeth S.O": "585290",
      "Shorapur Town S.O": "585224",
      "Wadgera S.O": "585355",
      "Kembhavi S.O": "585216",
      "Naikal S.O": "585319",
      "Narayanpur S.O (Yadgir)": "585219",
      "Rangampeth S.O": "585220",
      "Bijaspur S.O": "585304",
      "Kodekal S.O": "585237",
      "Ramasamudra S.O (Yadgir)": "585321",
      "Sagar S.O": "585323",
      "Shahapur Town S.O": "585223"
    },
    "SHIVAMOGGA": {
      "Bhadra Colony B.O": "577301",
      "Mavinakere B.O": "577245",
      "Bandigudda B.O": "577301",
      "Gangur BO": "577301",
      "Arhatolalu B.O": "577243",
      "Hanagawadi B.O": "577243",
      "Mydolalau B.O": "577243",
      "Devarahalli B.O": "577301",
      "Sanyasikodamaggi B.O": "577243",
      "Antharagange B.O": "577245",
      "Siddapura BO": "577301",
      "Jayanagar Nd B.O": "577204",
      "Hulikal B.O": "577425",
      "Sydarakallahalli B.O": "577243",
      "Kambadahal Hosur B.O": "577115",
      "Doddagoppenahalli B.O": "577302",
      "Gonibeedu B.O": "577115",
      "Hiriyur B.O": "577302",
      "Sunnadahalli B.O": "577245",
      "Hunasakatte Junction B.O": "577115",
      "Umblebylu B.O": "577115",
      "Talale B.O": "577426",
      "Talagunda B.O": "577428",
      "Heche B.O": "577429",
      "Kuppagadde B.O": "577429",
      "Yelagere B.O": "577433",
      "Mutugoppe B.O": "577434",
      "Padavagodu B.O": "577434",
      "Guddekere B.O": "577411",
      "Kommanahalu B.O": "577225",
      "Kunchenahalli B.O": "577225",
      "Dooravasapura B.O": "577432",
      "Heggodu B.O": "577432",
      "Kadathur B.O": "577432",
      "Kuruvalli Ndt B.O": "577432",
      "Untoorkatte B.O": "577432",
      "Kadekal B.O": "577203",
      "Mathur B.O": "577203",
      "Urgadur B.O": "577203",
      "Abbalagere B.O": "577204",
      "Halugadde B.O": "577426",
      "Haihole B.O": "577202",
      "Mandli B.O": "577202",
      "Bharathipura B.O": "577432",
      "Ramakrishnapura B.O": "577432",
      "Sankadahole B.O": "577432",
      "Guthi Yedehalli B.O": "577226",
      "Kannangi B.O": "577226",
      "Kote Gangur B.O": "577204",
      "Aralapura B.O": "577414",
      "Mandaghatta B.O": "577211",
      "Kattehakklu B.O": "577415",
      "Melige B.O": "577415",
      "Thirthamathur B.O": "577415",
      "Anjanapura B.O": "577214",
      "Chikjogihalli B.O": "577214",
      "Kalmane B.O": "577214",
      "Hadonahalli B.O": "577216",
      "Hansawadi B.O": "577216",
      "Bidarehalli B.O": "577436",
      "Kadasur B.O": "577436",
      "Demlapura B.O": "577422",
      "Sindhuvadi B.O": "577220",
      "Huruli B.O": "577413",
      "Nalur B.O": "577424",
      "Malavagoppa B.O": "577222",
      "Sogane B.O": "577222",
      "Harohithlu B.O": "577426",
      "Kenchanala B.O": "577426",
      "Gajanur B.O": "577202",
      "Beguvalli B.O": "577226",
      "Hanagere B.O": "577226",
      "Guddekoppa B.O": "577414",
      "Nonabur B.O": "577414",
      "Salur(Thirthahalli) B.O": "577414",
      "Thenginakoppa B.O": "577414",
      "Malur B.O": "577433",
      "Harogulige B.O": "577415",
      "Heddur B.O": "577415",
      "Bidare B.O": "577222",
      "Holebenavalli B.O": "577222",
      "Hosudi B.O": "577222",
      "Narasapura B.O": "577428",
      "Sunnadakoppa B.O": "577428",
      "Tadasanahalli B.O": "577428",
      "Chandragutti B.O": "577429",
      "Gudavi B.O": "577429",
      "Arasalu B.O": "577426",
      "Bellur(Hosanagar) B.O": "577426",
      "Hosahalli B.O": "577202",
      "Basavani B.O": "577432",
      "Chakkodabylu B.O": "577432",
      "Malalur B.O": "577432",
      "Seebinakere B.O": "577432",
      "Kuduvalli B.O": "577226",
      "Navile B.O": "577204",
      "Aralasurali B.O": "577414",
      "Sirigere B.O": "577211",
      "Mahishi B.O": "577232",
      "Kendalbailu B.O": "577411",
      "Veerannana   Benavalli B.O": "577211",
      "Kudumallige B.O": "577232",
      "Kukke B.O": "577232",
      "Shedgaru B.O": "577415",
      "Purudal B.O": "577205",
      "Churchugundi B.O": "577214",
      "Gama B.O": "577214",
      "Harogoppa B.O": "577214",
      "Issur B.O": "577214",
      "Bullapura B.O": "577216",
      "Madakechilur B.O": "577216",
      "Suguru B.O": "577216",
      "Kammachi B.O": "577436",
      "Muniyur B.O": "577436",
      "Hadigallu B.O": "577422",
      "Keshavapura B.O": "577422",
      "Saru B.O": "577422",
      "Halaga B.O": "577220",
      "Singanabidre B.O": "577220",
      "Halagalale B.O": "577429",
      "Halesorab B.O": "577429",
      "Tavanandi B.O": "577429",
      "Kolagi B.O": "577433",
      "Tattur B.O": "577433",
      "B.Dodderi B.O": "577434",
      "Madasurlingadahalli B.O": "577434",
      "Masthikatte B.O": "577425",
      "Udugani B.O": "577428",
      "Kanle B.O": "577430",
      "Marathur B.O": "577430",
      "Syduru B.O": "577430",
      "Tadagalale B.O": "577430",
      "Barur B.O": "577431",
      "Brahmanamanchale B.O": "577431",
      "Hosagadde B.O": "577411",
      "Kawrihaklu B.O": "577411",
      "Sanda B.O": "577428",
      "Bennur B.O": "577429",
      "Harishi B.O": "577429",
      "Kodakani B.O": "577429",
      "Mavali B.O": "577429",
      "Hiremane B.O": "577430",
      "Neechadi B.O": "577431",
      "Harige B.O": "577433",
      "Udri B.O": "577433",
      "Hosabale B.O": "577434",
      "Malalagadde B.O": "577434",
      "Nisrani B.O": "577434",
      "Shigga B.O": "577434",
      "B.Beeranahalli B.O": "577227",
      "Dasarakallahalli B.O": "577227",
      "Yedehalli B.O": "577227",
      "Donabaghatta B.O": "577229",
      "Siriyur B.O": "577229",
      "Arabilichi B.O": "577233",
      "Belur(Sagar) B.O": "577401",
      "Malve B.O": "577401",
      "Hakkere Maradavalli BO": "577401",
      "Hosur anandapuram B.O": "577412",
      "Melinasampalli B.O": "577412",
      "Agasanahalli B.O": "577413",
      "Sidlipura B.O": "577227",
      "Thallikatte B.O": "577227",
      "Sasaravalli B.O": "577401",
      "Suntikoppa B.O": "577401",
      "Achapura B.O": "577412",
      "Gilalagundi B.O": "577412",
      "Gouthmapura B.O": "577412",
      "Harathalu B.O": "577412",
      "Ullur B.O": "577412",
      "Bharangi B.O": "577413",
      "Chadaravalli B.O": "577453",
      "Genasinakuni B.O": "577453",
      "Bheemanakone B.O": "577417",
      "Hebbarige B.O": "577417",
      "Varadamoola B.O": "577417",
      "Haniya B.O": "577418",
      "Melinabesige B.O": "577418",
      "Nagarakodige B.O": "577418",
      "Sonale B.O": "577418",
      "Kerehalli B.O": "577419",
      "Jog Falls View B.O": "577435",
      "Bhanukuli B.O": "577421",
      "Iduvani B.O": "577421",
      "Kogar B.O": "577421",
      "Linganamakki B.O": "577421",
      "Malali B.O": "577425",
      "Nilskal B.O": "577425",
      "Nagodi B.O": "577452",
      "Amatekoppa B.O": "577427",
      "Baganakatte B.O": "577427",
      "Begur(Shikaripur) B.O": "577427",
      "Kappanahalli B.O": "577427",
      "Hirekasavi B.O": "577428",
      "Kortikere B.O": "577428",
      "Kuskur B.O": "577428",
      "Mallapura(Sorab) B.O": "577413",
      "Muguru B.O": "577413",
      "Brahmanakappige B.O": "577453",
      "Maluru B.O": "577453",
      "Tumary B.O": "577453",
      "Byranakoppa B.O": "577416",
      "Kotethariga B.O": "577418",
      "Talagadde B.O": "577419",
      "Talavata B.O": "577421",
      "Chordi B.O": "577423",
      "Hebbige B.O": "577452",
      "K.B.Circle B.O": "577452",
      "Bhadrapura B.O": "577427",
      "Hosagodnakoppa B.O": "577427",
      "Maravalli B.O": "577427",
      "Muddanahalli B.O": "577427",
      "Bilavani B.O": "577428",
      "Chikjambur B.O": "577428",
      "Manchikoppa B.O": "577428",
      "Hosa Agrahara B.O": "577415",
      "Makkimane B.O": "577415",
      "Ambligola B.O": "577214",
      "Arasinagere B.O": "577214",
      "Salur B.O": "577214",
      "Gondichatnahalli B.O": "577216",
      "Haramaghatta B.O": "577216",
      "Heddaripura B.O": "577436",
      "Humchadakatte B.O": "577436",
      "Karunapura B.O": "577424",
      "Sirur B.O": "577424",
      "Kachinakatte B.O": "577222",
      "Santhekadur B.O": "577222",
      "Agaradahalli B.O": "577227",
      "Kudli B.O": "577227",
      "Hamsagaru B.O": "577401",
      "Kugve B.O": "577401",
      "Masur(Sagar) B.O": "577401",
      "Shiravanthe B.O": "577401",
      "Yedjigalamane B.O": "577401",
      "Haridravathi B.O": "577412",
      "Maruthipura B.O": "577412",
      "Moody B.O": "577413",
      "Byacodu B.O": "577453",
      "Hulidevarabana B.O": "577453",
      "Sullali B.O": "577453",
      "Purappemane B.O": "577417",
      "Bheemanakere B.O": "577418",
      "Koduru B.O": "577418",
      "Mumbar B.O": "577418",
      "Sakunavalli B.O": "577419",
      "Telagunda B.O": "577419",
      "Aralagodu B.O": "577421",
      "Nagavalli B.O": "577421",
      "Balekoppa B.O": "577423",
      "Mathimane B.O": "577425",
      "Ryave B.O": "577425",
      "Mathikai B.O": "577452",
      "Ambaragoppa B.O": "577427",
      "Hosur(Shikaaripur) B.O": "577427",
      "Kagenahalli B.O": "577427",
      "Kittadahalli B.O": "577427",
      "Mattikote B.O": "577427",
      "Hirejambur B.O": "577428",
      "Kadenandihalli B.O": "577428",
      "Mallenahalli B.O": "577428",
      "Pillanagere B.O": "577227",
      "Settihalli B.O": "577227",
      "Bilki BO": "577229",
      "Arakere B.O": "577233",
      "Aralihalli B.O": "577233",
      "Kallihal B.O": "577233",
      "Kagodu B.O": "577401",
      "Kalmane(Sagar) B.O": "577401",
      "Keladi B.O": "577401",
      "Khandika B.O": "577401",
      "Hirenallur BO": "577401",
      "Yedur B.O": "577432",
      "Nanditale B.O": "577412",
      "Kubatur B.O": "577413",
      "Samanavalli B.O": "577413",
      "Tallur B.O": "577413",
      "Yennekoppa B.O": "577413",
      "Ambaragodlu B.O": "577453",
      "Kongavalli B.O": "577416",
      "Dyavanahalli B.O": "577419",
      "Gendla B.O": "577419",
      "Thuppur B.O": "577423",
      "Gulladahalli B.O": "577427",
      "Nelavagilu B.O": "577427",
      "Suragihalli B.O": "577427",
      "Jakkinakoppa B.O": "577427",
      "Agraharamuchadi B.O": "577428",
      "Belagavi B.O": "577428",
      "Biliki B.O": "577428",
      "Shivamogga H.O": "577201",
      "Sagar H.O": "577401",
      "Bhadravati H.O": "577301",
      "Anaveri S.O": "577243",
      "Bhadravathi Jannapura S.O": "577301",
      "Bhadravathi Railway Stn S.O": "577301",
      "KVV Shankaraghattta S.O": "577451",
      "Honnesara S.O": "577417",
      "Hosanagar S.O": "577418",
      "Jog Falls S.O": "577435",
      "Shiralakoppa S.O": "577428",
      "Agumbe S.O": "577411",
      "Bejjavalli S.O": "577232",
      "Bhadravathi Paper Town S.O": "577302",
      "APMC Yard Shikaripura Town S.O": "577427",
      "Avinahalli S.O": "577453",
      "Kumsi S.O": "577423",
      "Nagara Shimoga SO": "577425",
      "Shikaripur S.O": "577427",
      "Arga S.O": "577414",
      "Ayanur S.O": "577211",
      "Devangi S.O": "577415",
      "Hithla S.O": "577214",
      "Ripponpet S.O": "577426",
      "Shivamogga Ambedkarnagar S.O": "577201",
      "Shivamogga Market S.O": "577202",
      "Barandur S.O": "577245",
      "Bhadra Reservoir Project S.O": "577115",
      "Bhadravathi Old Town S.O": "577301",
      "Holehonner S.O": "577227",
      "Kawalgundi S.O": "577229",
      "Gandinagar sagar S.O": "577401",
      "Harnahalli S.O": "577416",
      "Nittur S.O (Shivamogga)": "577452",
      "Ulavi S.O": "577434",
      "Humcha S.O": "577436",
      "Megaravalli S.O": "577424",
      "Tudur S.O": "577226",
      "Vidyanagar Shivamogga S.O": "577203",
      "Vinobanagar Shivamogga S.O": "577204",
      "Gopala Extension S.O": "577205",
      "Mandagadde S.O": "577220",
      "Marketyard APMC Shivamogga S.O": "577204",
      "Ravindranagr shimoga S.O": "577201",
      "Shivamogga Kote S.O": "577202",
      "Shivamogga Railway Station S.O": "577201",
      "Thirthahalli S.O": "577432",
      "Bhadravathi Hudco Colony S.O": "577301",
      "Bhadravathi New Model Colony S.O": "577301",
      "Kudligere S.O": "577233",
      "Anandapuram S.O (Shivamogga)": "577412",
      "Anavatti S.O": "577413",
      "Jade S.O": "577419",
      "Kargal Colony S.O": "577421",
      "Sagar Bazar S.O": "577401",
      "Sagar Market Road S.O": "577401",
      "Sorab S.O": "577429",
      "Talaguppa S.O": "577430",
      "Thagarthi S.O": "577431",
      "Togarsi S.O": "577433",
      "Holalur S.O": "577216",
      "Konandur S.O": "577422",
      "Krishnarajendrapete shimoga S.O": "577202",
      "Nidige S.O": "577222",
      "Shivamogga District Office S.O": "577201",
      "Shivamogga Doddapete S.O": "577202",
      "Thirthahalli Town S.O": "577432"
    },
    "VIJAYAPURA": {
      "Amargol B.O": "586129",
      "Kunchaganur B.O": "586129",
      "Takkalki B.O": "586216",
      "Surgihalli B.O": "586215",
      "Alur B.O": "586129",
      "Devur B.O": "586129",
      "Golasangi B.O": "586216",
      "Hangargi B.O": "586216",
      "Kolur Lt B.O": "586129",
      "Yargal (TGD) B.O": "586129",
      "Angadgeri B.O": "586216",
      "Bhuyar B.O": "586111",
      "Almatti R.S. B.O": "586201",
      "Chimmalagi B.O": "586201",
      "Vandal B.O": "586201",
      "Huvinhalli B.O": "586202",
      "Kalhalli B.O": "586202",
      "Kurabathalli B.O": "586202",
      "Madanahalli B.O": "586202",
      "Dyaberi B.O": "586112",
      "Jambagi B.O": "586112",
      "Arjunagi B.O": "586217",
      "Kakhandki B.O": "586113",
      "Kumathe B.O": "586113",
      "Nidoni B.O": "586113",
      "Shirbur BO": "586113",
      "Jevoor B.O": "586204",
      "Manankalgi B.O": "586204",
      "Taddewadi B.O": "586204",
      "Zalki B.O": "586204",
      "Ingaleshwar B.O": "586203",
      "Kankal B.O": "586203",
      "Minchanal Lt B.O": "586108",
      "Benal B.O": "586201",
      "Korahalli B.O": "586202",
      "Rampur B.O": "586202",
      "Nagathan B.O": "586112",
      "Shirakanhalli B.O": "586112",
      "Tadavalga B.O": "586209",
      "Hebbalatti B.O": "586113",
      "Hokkundi B.O": "586113",
      "Jainapur B.O": "586113",
      "Tiganibidari B.O": "586113",
      "Uppaladinni B.O": "586113",
      "Godihal B.O": "586204",
      "Jeerankalgi B.O": "586205",
      "Jigjivani B.O": "586204",
      "Kadkol B.O": "586203",
      "Kannal B.O": "586119",
      "Masabinal B.O": "586203",
      "Gunki B.O": "586108",
      "Honaganhalli B.O": "586108",
      "Torvi B.O": "586108",
      "Ittangihal B.O": "586104",
      "Jalgeri B.O": "586104",
      "Lohagaon B.O": "586104",
      "Madhbhavi B.O": "586104",
      "Yatnal B.O": "586104",
      "Darga (Vijayapura) B.O": "586103",
      "Ghonasagi B.O": "586114",
      "Hubnur B.O": "586114",
      "Kanamadi B.O": "586114",
      "Somadevarhatti B.O": "586114",
      "Umrani B.O": "586205",
      "Kadlewad (PA) B.O": "586206",
      "Kumshi B.O": "586206",
      "Harnal B.O": "586115",
      "Ingalgi B.O": "586209",
      "Kannolli B.O": "586115",
      "Kokatnur B.O": "586115",
      "Hosur BO": "586113",
      "Hittinhalli (LT) B.O": "586215",
      "Tenihalli B.O": "586215",
      "Handargal B.O": "586129",
      "Hunakunti B.O": "586129",
      "Kandaganur B.O": "586129",
      "Kolur B.O": "586129",
      "Madari B.O": "586129",
      "Nebageri B.O": "586129",
      "Rakkasagi B.O": "586129",
      "Sarur B.O": "586129",
      "Mulawad B.O": "586108",
      "Arkeri B.O": "586104",
      "Siddapur B.O": "586104",
      "Bhutnal B.O": "586103",
      "Babanagar B.O": "586114",
      "Hattalli B.O": "586205",
      "Revatgaon B.O": "586205",
      "Shiradon B.O": "586205",
      "Bommanahalli B.O": "586214",
      "Budihal Ph B.O": "586115",
      "Alur (Indi) B.O": "586209",
      "Gubbewad (Indi) B.O": "586111",
      "Ghani B.O": "586201",
      "Hikkangutti B.O": "586202",
      "Kadni B.O": "586202",
      "Honnalli B.O": "586128",
      "Kenginal B.O": "586112",
      "Bellubbi B.O": "586113",
      "Mamadapur B.O": "586113",
      "Nagaral B.O": "586113",
      "KANABUR B.O": "586113",
      "Anjutgi B.O": "586209",
      "Loni BK B.O": "586204",
      "Nimbargi B.O": "586204",
      "Aralichandi B.O": "586203",
      "Bisnal B.O": "586203",
      "Donur B.O": "586203",
      "Ivanagi B.O": "586203",
      "Narasalagi B.O": "586203",
      "Yalwar B.O": "586203",
      "Karjol B.O": "586108",
      "Tonshyal B.O": "586108",
      "Ainapur B.O": "586104",
      "Hegadihal B.O": "586108",
      "Hirebevanur B.O": "586111",
      "Manur B.O": "586111",
      "Gundagi B.O": "586202",
      "Aheri B.O": "586112",
      "Aliyabad B.O": "586112",
      "Benakanhalli B.O": "586112",
      "Yakkundi B.O": "586113",
      "JAMBAGI  B.O": "586113",
      "Bhairwadgi B.O": "586203",
      "Byalal B.O": "586203",
      "Dindwar B.O": "586203",
      "Rabinal B.O": "586203",
      "Katakanhalli B.O": "586108",
      "Utnal B.O": "586108",
      "Havinal B.O": "586205",
      "Nivargi B.O": "586205",
      "Muttagi B.O": "586216",
      "Dashyal B.O": "586130",
      "Dhanyal B.O": "586130",
      "Ukkali B.O": "586108",
      "Halahalli B.O": "586205",
      "Sankh B.O": "586205",
      "Umaraj B.O": "586205",
      "Devar Navadagi B.O": "586206",
      "Bommanjogi B.O": "586115",
      "Koulagi B.O": "586216",
      "Dhannargi B.O": "586130",
      "Mannur B.O": "586216",
      "Honawad B.O": "586130",
      "Kotyal B.O": "586130",
      "M.Devarhatti B.O": "586130",
      "Tajpur B.O": "586130",
      "Otihal B.O": "586115",
      "Gundkarajagi B.O": "586116",
      "Hallur B.O": "586116",
      "Padekanur B.O": "586116",
      "Vanahalli B.O": "586116",
      "Arjanal B.O": "586207",
      "Dhulkhed B.O": "586207",
      "Hingani B.O": "586207",
      "Bablad B.O": "586125",
      "Ballolli B.O": "586117",
      "Byakod (BGW) B.O": "586208",
      "Hunshyal B.O": "586208",
      "Lingadalli BO": "586209",
      "Makhanapur B.O": "586119",
      "Shanti Kutir B.O": "586119",
      "Tidgundi B.O": "586119",
      "Asangi Khurd B.O": "586210",
      "Kondguli B.O": "586120",
      "Mannur B.O KORWAR": "586120",
      "Yalgod B.O": "586120",
      "Masuti B.O": "586121",
      "Talewad B.O": "586121",
      "Nimbal B.O": "586211",
      "Aheri (Sindgi) B.O": "586123",
      "Bagalur B.O": "586123",
      "Bavur B.O": "586212",
      "Nagur B.O": "586212",
      "Nerabenchi B.O": "586212",
      "Shivapur B.O": "586212",
      "Yarzeri B.O": "586212",
      "Hiremural B.O": "586124",
      "Hebbal B.O": "586213",
      "Hullur B.O": "586213",
      "Khedgi B.O": "586217",
      "Nadkhurd B.O": "586217",
      "Rodagi B.O": "586217",
      "Halagani B.O": "586125",
      "Kambagi B.O": "586125",
      "Khatijapur B.O": "586125",
      "Asantapur B.O": "586128",
      "Balaganur B.O": "586214",
      "Bannihatti Pa B.O": "586128",
      "Madbal B.O": "586128",
      "Malghan B.O": "586121",
      "Sungthan B.O": "586128",
      "B.Salwadgi B.O": "586214",
      "Banthanal B.O": "586215",
      "Markabbinhalli B.O": "586115",
      "Satihal B.O": "586115",
      "Lingadahalli B.O": "586116",
      "Rudgi B.O": "586116",
      "Bhairungi B.O": "586207",
      "Channegaon B.O": "586207",
      "Deginal B.O": "586117",
      "Nandargi B.O": "586117",
      "K.Salwadgi B.O": "586208",
      "Wadwadgi B.O": "586208",
      "Aski B.O": "586118",
      "Tilgul B.O": "586118",
      "Shirnal B.O": "586119",
      "Baluti B.O": "586210",
      "Madikeshwar B.O": "586116",
      "Bhatgunki B.O": "586207",
      "Halladgennur B.O": "586210",
      "Siddanath B.O": "586210",
      "Hanchli B.O": "586120",
      "Nimbal R.S. B.O": "586211",
      "Padnur B.O": "586211",
      "Hitinhalli B.O": "586122",
      "Nandihal B.O": "586122",
      "Bankalgi B.O": "586123",
      "Gabsavalgi B.O": "586123",
      "Nagavi B.O": "586123",
      "Muddebihal Fort NDBO": "586212",
      "Ingalgeri B.O": "586212",
      "Mukihal B.O": "586212",
      "Hulagbal B.O": "586124",
      "Nagarbetta B.O": "586124",
      "Hullur Lt B.O": "586213",
      "Yalgur B.O": "586213",
      "Mirgi B.O": "586217",
      "Shirshyad B.O": "586217",
      "Devapur B.O": "586125",
      "Devar Gennur B.O": "586125",
      "Sangapur Sh B.O": "586125",
      "Hadagali B.O": "586127",
      "Kaggod B.O": "586127",
      "Bandal B.O": "586128",
      "Borgi B.O": "586128",
      "Golgeri B.O": "586128",
      "Gubbewad B.O": "586128",
      "Sasabal B.O": "586128",
      "Bilebhavi B.O": "586214",
      "Tamadaddi B.O": "586214",
      "Chikrugi B.O": "586215",
      "Basanal B.O": "586117",
      "Halagunaki B.O": "586209",
      "Savalsang B.O": "586117",
      "Budihal; B.O": "586208",
      "Binjalbhavi B.O": "586118",
      "Hunsyal (SDG) B.O": "586118",
      "Kerutgi B.O": "586118",
      "Kesaratti B.O": "586118",
      "Hangargi B.O 586210": "586210",
      "Kupakaddi B.O": "586210",
      "Kurabardinni B.O 586210": "586210",
      "Mattihal B.O": "586210",
      "Ronihal B.O": "586210",
      "Jalwad B.O": "586120",
      "Kalgurki B.O": "586121",
      "Ahirsang B.O": "586211",
      "Bargudi B.O": "586211",
      "Hanjagi B.O": "586209",
      "Goravgundgi B.O": "586123",
      "Bidarkundi B.O": "586212",
      "Devar Hulagbal B.O": "586212",
      "Hagargond B.O": "586212",
      "Kavadimatti B.O": "586212",
      "Bijjur B.O": "586124",
      "Balabatti B.O": "586213",
      "Budihal Pn B.O": "586213",
      "Kanmuchnal B.O": "586125",
      "Shegunshi B.O": "586125",
      "Mulasavalgi B.O": "586127",
      "Padaganur B.O": "586127",
      "Yambatnal B.O": "586127",
      "Chandkavathe B.O": "586128",
      "Ganihar B.O": "586128",
      "Khainur B.O": "586128",
      "Khanapur B.O": "586128",
      "Chabanur B.O": "586214",
      "Gadisomanal B.O": "586214",
      "Hirur B.O": "586214",
      "Kodaganur B.O": "586214",
      "Minajagi B.O": "586214",
      "Navadagi B.O": "586214",
      "Peerapur B.O": "586214",
      "Phattepur B.O": "586214",
      "Hachyal B.O": "586215",
      "Hiremasali B.O": "586215",
      "Hirerugi B.O": "586209",
      "Balwat B.O": "586116",
      "Basarkod B.O": "586116",
      "Agasanal B.O": "586117",
      "Chowdihal B.O": "586209",
      "Domanal B.O": "586117",
      "Hadalsang B.O": "586117",
      "Inchageri B.O": "586117",
      "Kapanimbargi B.O": "586117",
      "Satalgaon (PB) B.O": "586204",
      "Konnur B.O": "586208",
      "Somanal B.O": "586208",
      "Algur B.O": "586118",
      "Bekinal B.O": "586118",
      "Neeralgi B.O": "586118",
      "Baratgi B.O": "586119",
      "Madasanal B.O": "586119",
      "Halerolli B.O": "586210",
      "Hanamapur B.O": "586210",
      "Bibi ingalgi B.O": "586120",
      "Handiganur B.O": "586120",
      "Chik Bevanur B.O": "586209",
      "Indi Road B.O": "586209",
      "Hattarkihal B.O": "586122",
      "Jumanal B.O": "586122",
      "Yarnal B.O": "586122",
      "Bhantanur B.O": "586123",
      "Kakkalmeli B.O": "586123",
      "Yargal B.O": "586123",
      "Hadalgeri B.O": "586212",
      "Jammaldinni B.O": "586212",
      "Kuntoji B.O": "586212",
      "Madinal B.O": "586212",
      "Nagabenal B.O": "586124",
      "Abbihal B.O": "586213",
      "Itagi B.O": "586213",
      "Kalgi B.O": "586213",
      "Golsar B.O": "586217",
      "Satalgaon B.O": "586217",
      "Teggihalli B.O": "586217",
      "Vibhuthalli B.O": "586217",
      "Bolachikkalki (JKD) B.O": "586125",
      "Gunadal B.O": "586125",
      "Majre Sangapur B.O": "586125",
      "Ankalgi B.O": "586127",
      "Honnutgi B.O": "586127",
      "Byakod B.O": "586128",
      "Chick Sindgi B.O": "586128",
      "Somjal B.O": "586128",
      "Yankanchi B.O": "586128",
      "Bhantanur (TKT) B.O": "586214",
      "Maileshwar B.O": "586214",
      "Sasanur B.O": "586214",
      "Tumbagi B.O": "586214",
      "Chattarki B.O": "586215",
      "Gornal B.O": "586215",
      "Vijayapura H.O": "586101",
      "Vijayapura Jorapur Peth S.O": "586101",
      "Devangaon S.O": "586206",
      "Korwar S.O": "586120",
      "Lachyan S.O": "586211",
      "Moratgi S.O": "586123",
      "Bardol S.O (Vijayapura(KAR))": "586204",
      "Vijayapura Bazar S.O": "586101",
      "Vijayapura Jalanagar S.O": "586109",
      "Vijayapura Tajbavadi S.O": "586101",
      "Almatti  Damsite S.O": "586201",
      "Almel S.O": "586202",
      "Atharga S.O": "586112",
      "Vijayapura Amc S.O": "586108",
      "Vijayapura Kutchery S.O": "586101",
      "B.L.D.E.A Campus SO": "586103",
      "Halsangi S.O": "586207",
      "Horti S.O": "586117",
      "Huvin Hippargi S.O": "586208",
      "Kalkeri S.O": "586118",
      "Kolhar S.O (Vijayapura(KAR))": "586210",
      "Agarkhed S.O": "586111",
      "Bableshwar S.O": "586113",
      "Basavan Bagewadi S.O": "586203",
      "Vijayapura Market Yard S.O": "586101",
      "Vijayapura Railway Station S.O": "586104",
      "Bijjargi S.O": "586114",
      "Devar Hippargi S.O": "586115",
      "Dhavalgi S.O": "586116",
      "Chadchan S.O": "586205",
      "Indi S.O": "586209",
      "Kannur S.O": "586119",
      "Kudgi S.O": "586121",
      "Mangoli S.O": "586122",
      "Muddebiahl S.O": "586212",
      "Nidgundi S.O": "586213",
      "Telgi S.O": "586216",
      "Tikota S.O": "586130",
      "Nalatwad S.O": "586124",
      "Shivangi S.O": "586127",
      "Salotgi S.O": "586217",
      "Tangadgi S.O": "586129",
      "Sarwad S.O": "586125",
      "Sindgi S.O": "586128",
      "Talikoti S.O": "586214",
      "Tamba S.O": "586215"
    },
    "KOPPAL": {
      "Kolur B.O": "583285",
      "Ojanhalli B.O": "583238",
      "Bisarahalli B.O": "583285",
      "Jumlapur B.O": "583278",
      "Ballutagi B.O": "583278",
      "Gotagi B.O": "583278",
      "Gangavathi ARS B.O": "583227",
      "Hosahalli B.O": "583234",
      "Budgumpa B.O": "583229",
      "Kumbalavati B.O": "583281",
      "Yelbunchi B.O": "583281",
      "Yergera B.O": "583281",
      "Nilogal B.O": "583280",
      "Lakamapur B.O": "583238",
      "Mallapur B.O": "583227",
      "Sangapur B.O": "583227",
      "Chickjanthkal B.O": "583227",
      "Kesarhatti B.O": "583227",
      "Guladahalli B.O": "583228",
      "Malgatti B.O": "583280",
      "Chickdankankal B.O": "583283",
      "Jeeral B.O": "583283",
      "Sulekal B.O": "583283",
      "Kardoni B.O": "583229",
      "Mailapur B.O": "583229",
      "Yerdoni B.O": "583229",
      "Arkeri B.O": "583230",
      "Kalkeri B.O": "583283",
      "Madinur B.O": "583230",
      "Binhal B.O": "583232",
      "Mandalgera B.O": "583232",
      "Yerihanchinal B.O": "583232",
      "Chikenkoppa B.O": "583232",
      "Masbihanchinal B.O": "583232",
      "Chalgera B.O": "583277",
      "Gumgera B.O": "583277",
      "Hirebaganal B.O": "583228",
      "Hiregonnagar": "583280",
      "Hirekhed B.O": "583283",
      "Hulihyder B.O": "583283",
      "Chellur B.O": "583229",
      "Nandihalli B.O": "583229",
      "Somapur B.O": "583232",
      "Tondihal B.O": "583232",
      "Yediapur B.O": "583232",
      "Hireanadihal B.O": "583277",
      "Mainhalli B.O": "583285",
      "Muddaballi B.O": "583238",
      "Neeralgi B.O": "583285",
      "Kadekoppa B.O": "583278",
      "Madapur B.O": "583278",
      "Muddalgundi B.O": "583278",
      "Anegundi B.O": "583227",
      "Ayodhya B.O": "583227",
      "Basavanadurga B.O": "583227",
      "Karkihalli B.O": "583228",
      "Kunikera B.O": "583228",
      "Kunkanpalli B.O": "583228",
      "Kutaganahalli B.O": "583228",
      "Benakanhal B.O": "583281",
      "Gudadurkal B.O": "583281",
      "Hoolgera B.O": "583281",
      "Kabbargi B.O": "583281",
      "Gudadur B.O": "583280",
      "Tuggaldona B.O": "583280",
      "Chickmendinhal B.O": "583283",
      "Gouripur B.O": "583283",
      "Bevinhal B.O": "583229",
      "Bsavanna Camp B.O": "583229",
      "Nowli B.O": "583229",
      "Hulkihal B.O": "583229",
      "Marlanhalli B.O": "583229",
      "Sankanoor B.O": "583284",
      "Ballutgi B.O": "583284",
      "Halwagali B.O": "583226",
      "Kawaloor B.O": "583226",
      "Hasgal B.O": "583287",
      "Hirewaddarkal B.O": "583237",
      "Vankalkunta B.O": "583237",
      "Taralakatti B.O": "583237",
      "Bahaddurbandi B.O": "583238",
      "Halagera B.O": "583238",
      "Handral B.O": "583285",
      "Mangaluru B.O": "583230",
      "Ryavanki B.O": "583230",
      "Sirur B.O": "583230",
      "Balgeri B.O": "583232",
      "Itagi B.O": "583232",
      "Katarki B.O": "583285",
      "Tadakal B.O": "583238",
      "Bichkal B.O": "583278",
      "Jalihal B.O": "583278",
      "Mudenur B.O": "583278",
      "Kyadiguppa B.O": "583278",
      "Heroor B.O": "583227",
      "Indargi B.O": "583228",
      "Mukkumpi B.O": "583228",
      "Bandargallu B.O": "583281",
      "Katapur B.O": "583281",
      "Mannerhal B.O": "583281",
      "Yerigonal B.O": "583281",
      "Bilekal B.O": "583280",
      "Habbalkatti B.O": "583280",
      "Chickkabommanhal B.O": "583283",
      "Muslapur B.O": "583283",
      "Oolenur B.O": "583229",
      "Hirebidnal B.O": "583230",
      "Benkal B.O": "583232",
      "Dyampur B.O": "583232",
      "Malekoppa B.O": "583232",
      "Adavibhavi B.O": "583277",
      "Bandi B.O": "583277",
      "Gandhal B.O": "583277",
      "Kalalbandi B.O": "583277",
      "Kandakur B.O": "583277",
      "Marli B.O": "583268",
      "Kilarhatti B.O": "583279",
      "Sanganhal B.O": "583236",
      "Basapatna B.O": "583235",
      "Karmudi B.O": "583284",
      "Hiremyageri B.O": "583284",
      "Bochenhalli B.O": "583226",
      "Hunsihal B.O": "583237",
      "Kamnoor B.O": "583287",
      "Lebgeri B.O": "583287",
      "Betgera B.O": "583285",
      "Hatti B.O": "583226",
      "Tigri B.O": "583226",
      "Gunhal B.O": "583237",
      "Hirebommanhal B.O": "583237",
      "Murdi B.O": "583237",
      "Vanageri B.O": "583237",
      "Bannikoppa B.O": "583238",
      "Hirebannigol B.O": "583277",
      "Konsagar B.O": "583277",
      "Koradkera B.O": "583277",
      "Talavagera B.O": "583277",
      "Yeddoni B.O": "583277",
      "Agalkera B.O": "583234",
      "Bandiharlapur B.O": "583234",
      "Hitnal B.O": "583234",
      "Shivapur B.O": "583234",
      "Danapur B.O": "583268",
      "Gundur Camp B.O": "583282",
      "Mushtoor B.O": "583282",
      "Siddapur B.O": "583282",
      "Singanhal B.O": "583282",
      "Udamkal B.O": "583235",
      "Venkatgiri B.O": "583235",
      "Dammur B.O": "583236",
      "Gadgeri B.O": "583236",
      "Malaksamudra B.O": "583236",
      "Hiremannapur B.O": "583277",
      "Lingadhalli B.O": "583277",
      "Hirearlihalli": "583277",
      "Vanagera B.O": "583277",
      "Bevinhalli B.O": "583234",
      "Sanapur B.O": "583234",
      "Hanwal B.O": "583268",
      "Hoskera B.O": "583268",
      "Bargoor B.O": "583282",
      "Menedal B.O": "583279",
      "Ghattreddihal": "583226",
      "Chilakmukhi B.O": "583287",
      "Kudrimoti B.O": "583287",
      "MataldinniB.O": "583237",
      "Bhanapur B.O": "583238",
      "Gondbal B.O": "583238",
      "Agoli B.O": "583235",
      "Chickmyageri B.O": "583236",
      "Kallur B.O": "583236",
      "Rajoor B.O": "583236",
      "Talkeri B.O": "583277",
      "Hebbal B.O": "583268",
      "Jangamarakalgudi B.O": "583268",
      "Gundur B.O": "583282",
      "Kalamalli B.O": "583279",
      "Navalhalli B.O": "583279",
      "Huliyapur": "583279",
      "Arhal B.O": "583235",
      "Chickbenkal B.O": "583235",
      "Koppal H.O": "583231",
      "Bhagyanagar S.O (Koppal)": "583238",
      "Gangavati Hireejankal S.O": "583227",
      "Hanamsagar S.O": "583281",
      "Hanumanhal S.O": "583280",
      "Karatgi S.O": "583229",
      "Munirabad S.O": "583233",
      "Yelburga S.O": "583236",
      "Mudhol S.O": "583284",
      "Gangavathi S.O": "583227",
      "Gangavati Cbs Gunj S.O": "583227",
      "Gangavati M V Circle S.O": "583227",
      "Tavargera S.O": "583279",
      "Mukkumpi BO": "583235",
      "Irkalgad S.O": "583287",
      "Alawandi S.O": "583226",
      "Bewoor S.O": "583237",
      "Kanakgiri S.O": "583283",
      "Koppal Bazar S.O": "583231",
      "Koppal G S Gunj S.O": "583231",
      "Koppal R S S.O": "583231",
      "Kuknoor S.O": "583232",
      "Kushtagi S.O": "583277",
      "Munirabad RS S.O": "583234",
      "Pragathinagar S.O": "583268",
      "Dotihal S.O": "583278",
      "Gangavati Bazar S.O": "583227",
      "Gangavati Julynagar S.O": "583227",
      "Ginigera S.O": "583228",
      "Kinhal S.O": "583230",
      "Kusthagi Kut S.O": "583277",
      "Sriramnagar S.O (Koppal)": "583282",
      "Hiresindogi S.O": "583285"
    },
    "UDUPI": {
      "Kukkundur West B.O": "576117",
      "Tellar B.O": "576117",
      "Borkatte B.O": "574107",
      "Kukkuje B.O": "574108",
      "Varanga B.O": "574108",
      "Idu B.O": "574109",
      "Bola B.O": "574110",
      "Kallya B.O": "574110",
      "Renjala B.O": "574114",
      "Attur B.O": "576117",
      "Hirgana B.O": "576117",
      "Hosmar B.O": "574107",
      "Kadthala B.O": "574108",
      "Vishwasnagar B.O": "574108",
      "Kuntady B.O": "574244",
      "Nakre B.O": "576117",
      "Nooralbettu B.O": "574107",
      "Ellare B.O": "574108",
      "Doopadakatte B.O": "574110",
      "Durga B.O": "576117",
      "Kedinje B.O": "574110",
      "Parappadi B.O": "574110",
      "Ninjoor B.O": "574244",
      "Irvathur B.O": "574114",
      "Mala B.O": "574122",
      "Manjalthar B.O": "574122",
      "Nallur B.O": "574122",
      "Belanje B.O": "576112",
      "Chara B.O": "576112",
      "Kuchur B.O": "576112",
      "Vanjarakatte B.O": "574129",
      "Yennehole B.O": "574101",
      "Yerlapady B.O": "574102",
      "Kabbinale B.O": "576112",
      "Mudradi B.O": "576112",
      "Belady B.O": "574129",
      "Andar B.O": "574101",
      "Hadiangady B.O": "574101",
      "Hermunde B.O": "574101",
      "Gundyadka B.O": "574102",
      "Kanajar B.O": "574102",
      "Nire B.O": "574102",
      "Sitanadi B.O": "576112",
      "Someshwara B.O": "576112",
      "Hiriangady B.O": "574104",
      "Jarkala B.O": "574101",
      "Kervashe B.O": "574122",
      "Shivapura B.O": "576112",
      "Ampar BO": "576211",
      "Mayyadi BO": "576214",
      "Mudlakatte BO": "576217",
      "Ajrihara BO": "576283",
      "Kenchanur BO": "576283",
      "Koderi BO": "576219",
      "Asodu BO": "576222",
      "Hunsemakki BO": "576222",
      "Souda BO": "576222",
      "Vakwadi BO": "576257",
      "Kulanje BO": "576227",
      "Rattadi BO": "576227",
      "Jansale BO": "576229",
      "Ullur BO": "576229",
      "Hemmadi BO": "576230",
      "Kanyana BO": "576230",
      "Kundabarandadi BO": "576235",
      "Chittoor BO": "576233",
      "Mudur BO": "576233",
      "Nujadi BO": "576233",
      "Halladiharkadi BO": "576210",
      "Kavadi BO": "576210",
      "Shiriyara BO": "576210",
      "Aroor BO": "576213",
      "Haradi BO": "576213",
      "Matapadi BO": "576213",
      "Santhekattekalathur BO": "576215",
      "Panchanbettu BO": "576113",
      "Pernankila BO": "576113",
      "Kodibengre BO": "576218",
      "Nanchar BO": "576234",
      "Kotathattu BO": "576221",
      "Manur BO": "576221",
      "Vandar BO": "576223",
      "Athradi BO": "576107",
      "Bhairanje BO": "576107",
      "Anagalli BO": "576211",
      "Balkur BO": "576211",
      "Ardi BO": "576212",
      "Gummahola BO": "576212",
      "Golihole BO": "576214",
      "Paduvari BO": "576214",
      "Gulvadi BO": "576283",
      "Yedamoge BO": "576282",
      "Kirimanjeshwara BO": "576219",
      "Moodumata BO": "576219",
      "Beejadi BO": "576222",
      "Haladi76 BO": "576222",
      "Salvadi BO": "576222",
      "Yadyadimathyadi BO": "576222",
      "Krodabailur BO": "576227",
      "Machattu BO": "576227",
      "Hallihole BO": "576229",
      "Kamalashile BO": "576229",
      "Devalkunda BO": "576230",
      "Herikudru BO": "576230",
      "Kedur BO": "576231",
      "Shenapura BO": "576235",
      "Bijur BO": "576232",
      "Harkur BO": "576233",
      "Jadkal BO": "576233",
      "Mudmunda BO": "576233",
      "Barkur Town BO": "576210",
      "Bennekudru BO": "576210",
      "Hosala BO": "576210",
      "Saibarkatte BO": "576210",
      "Baikadi BO": "576213",
      "Chanthar BO": "576213",
      "Neelavara BO": "576213",
      "Kudi BO": "576113",
      "Badanidiyur BO": "576115",
      "Nalkur BO": "576234",
      "Belur Devasthanabettu BO": "576221",
      "Janvarkatte BO": "576223",
      "Nadur BO": "576223",
      "Patla BO": "576107",
      "Kolalagiri BO": "576105",
      "Tenkabettu BO": "576105",
      "Airody BO": "576226",
      "Kodi Kanyana BO": "576226",
      "Hejmadikodi BO": "574103",
      "Kalathur South BO": "574106",
      "Mallar BO": "574106",
      "Doddanagudde BO": "576102",
      "Innanje BO": "576122",
      "Halnadu BO": "576211",
      "Japthi BO": "576211",
      "Kandlur BO": "576211",
      "Hengavalli BO": "576212",
      "Hiliyana BO": "576212",
      "Madamakki BO": "576212",
      "Hosadu BO": "576247",
      "Heranjal BO": "576219",
      "Kalthod BO": "576219",
      "Kergal BO": "576219",
      "Haladi28 BO": "576222",
      "Badakere BO": "576224",
      "Maravanthe BO": "576224",
      "Ragihaklu BO": "576224",
      "Amasebail BO": "576227",
      "Korgi BO": "576231",
      "Hadavu BO": "576235",
      "Hakladi BO": "576235",
      "Tarapathi BO": "576232",
      "Idurkunhady BO": "576233",
      "Keradi BO": "576233",
      "Melhosur BO": "576233",
      "Hanehalli BO": "576210",
      "Heskethur BO": "576210",
      "Yedthadi BO": "576210",
      "Herur BO": "576213",
      "Kumragodu BO": "576213",
      "Hoode BO": "576115",
      "Tenkanidiyur BO": "576106",
      "Kudrukere BO": "576108",
      "Thottam BO": "576108",
      "Avarse BO": "576223",
      "Muddumane BO": "576223",
      "Herga BO": "576107",
      "Hirebettu BO": "576107",
      "Kukkehalli BO": "576124",
      "Shiroor BO": "576124",
      "Uppur BO": "576105",
      "Majur BO": "574106",
      "Padur BO": "574106",
      "Uliyaragoli BO": "574106",
      "Manipura BO": "576120",
      "Marne BO": "576120",
      "Santhur BO": "574111",
      "Bada BO": "574117",
      "Paniyur BO": "574117",
      "Admar BO": "574119",
      "Kemmundel BO": "574119",
      "Kavradi BO": "576211",
      "Shedimane BO": "576212",
      "Taggarshe BO": "576214",
      "Yedthare BO": "576214",
      "Yelajith BO": "576214",
      "Kodi BO": "576217",
      "Koni BO": "576217",
      "Karkunje BO": "576283",
      "Kodladi BO": "576283",
      "Hardallimandalli BO": "576222",
      "Kakkunje BO": "576222",
      "Molahalli BO": "576222",
      "Kattebelthur BO": "576230",
      "Nada BO": "576230",
      "Uppinakudru BO": "576230",
      "Ultoor BO": "576231",
      "Alur BO": "576233",
      "Kunjal BO": "576213",
      "Salikeri BO": "576213",
      "Haluvalli BO": "576215",
      "Karje BO": "576215",
      "Bellarpadi BO": "576113",
      "Guddeangadi BO": "576113",
      "Baidabettu BO": "576234",
      "Kadur BO": "576234",
      "Kenjur BO": "576234",
      "Badagabettu BO": "576107",
      "Arekandige BO": "576124",
      "Havanje BO": "576124",
      "Bellampalli BO": "576124",
      "Achladi BO": "576225",
      "Kelarkalabettu BO": "576105",
      "Puttur BO": "576105",
      "Yedabettu BO": "576226",
      "Nittur BO": "576103",
      "Avral BO": "574103",
      "Manipura West BO": "574105",
      "Kattingere BO": "576120",
      "Padebettu BO": "574111",
      "Halasinakatte BO": "574113",
      "Herur92 BO": "574115",
      "Kodupanjimar BO": "574116",
      "Mattar BO": "574116",
      "Sooda BO": "574116",
      "Bhantakal BO": "574115",
      "Belapu BO": "574117",
      "Bannadi BO": "576225",
      "Karkada BO": "576225",
      "Parampalli BO": "576225",
      "Kadekar BO": "576103",
      "Kidiyur BO": "576103",
      "Kunjargiri BO": "574105",
      "Mattu BO": "574105",
      "Subhash Nagar BO": "574105",
      "Manchikodi BO": "576102",
      "Shivalli BO": "576102",
      "Chitpadi BO": "576101",
      "Kukkikatte BO": "576101",
      "Nandikur BO": "574111",
      "Yellur BO": "574113",
      "Kuthyar BO": "574116",
      "Padubelle BO": "574116",
      "Pernal BO": "574116",
      "Alevoor BO": "574118",
      "Korangrapadi BO": "574118",
      "Kuthpadi BO": "574118",
      "Pithrodi BO": "574118",
      "Paduyermal BO": "574119",
      "Nandalike B.O": "576111",
      "Bolakodi B.O": "576121",
      "Sacherigudde B.O": "576121",
      "Inna B.O": "576121",
      "Karkala H.O": "574104",
      "Manipal HO": "576104",
      "Kundapura HO": "576201",
      "Udupi HO": "576101",
      "Nitte S.O": "574110",
      "Sanur S.O": "574114",
      "Gujjadi SO": "576247",
      "Hosangadi SO": "576282",
      "Kollur SO": "576220",
      "Barkur SO": "576210",
      "Palli S.O": "574244",
      "Hanglur SO": "576217",
      "Siddapura Udupi SO": "576229",
      "Hungarcutta SO": "576218",
      "Kallianapura SO": "576114",
      "Kemmannu SO": "576115",
      "Kaup SO": "574106",
      "Moodubelle SO": "576120",
      "Pangala SO": "576122",
      "Pilar SO Udupi": "574113",
      "Udupi Courts SO": "576101",
      "Kukkundur S.O": "576117",
      "Kokkarne SO": "576234",
      "Kota SO": "576221",
      "Mandarthi SO": "576223",
      "Santhekatte SO": "576105",
      "Bannanje SO": "576101",
      "Kunjibettu SO": "576102",
      "Palimar SO": "574112",
      "Shankarapura SO": "574115",
      "Shirva SO": "574116",
      "Uchila SO": "574117",
      "Hattiangadi SO": "576283",
      "Khambadakone SO": "576219",
      "Kumbhashi SO": "576257",
      "Shankaranarayana SO": "576227",
      "Tallur SO Udupi": "576230",
      "Tekkatte SO": "576231",
      "Parkala SO": "576107",
      "Saligrama SO Udupi": "576225",
      "Sasthan SO": "576226",
      "Ambalapadi SO": "576103",
      "KatapadiUdupi SO": "574105",
      "Padubidri SO": "574111",
      "Uppunda SO": "576232",
      "Cherkadi SO": "576215",
      "Belmannu S.O": "576111",
      "Trasi SO": "576235",
      "Vandse SO": "576233",
      "Koteshwara SO": "576222",
      "Kundapura Market SO": "576201",
      "Navunda SO": "576224",
      "Shiruru Udupi SO": "576228",
      "Brahmavara SO": "576213",
      "Dist Offices Complex Manipal SO": "576104",
      "Hiriadka SO": "576113",
      "Krodashrama SO": "576106",
      "Malpe SO": "576108",
      "Perdur SO": "576124",
      "Hejmadi SO": "574103",
      "Mission Compound SO KARNATAKA CIRCLE": "576101",
      "Udyavara SO": "574118",
      "Yermal SO": "574119",
      "Byndoor SO": "576214",
      "Gandhimaidan SO": "576201",
      "Ganguli SO": "576216",
      "Ajekar S.O": "574101",
      "Bajegoli S.O": "574122",
      "Miyar S.O": "574107",
      "Hebri S.O": "576112",
      "Karkala Bazar S.O": "574104",
      "Basrur SO": "576211",
      "Bailur S.O": "574102",
      "Kanthavara S.O": "574129",
      "Karkala West S.O": "574104",
      "Muniyal S.O": "574108",
      "Mundkur S.O": "576121",
      "Belve SO": "576212"
    },
    "MANDYA": {
      "Hanakere B.O": "571404",
      "Kachigere B.O": "571404",
      "Ummadahalli B.O": "571404",
      "Kannali B.O": "571404",
      "G Nagathihalli B.O": "571811",
      "Kanchanahalli B.O": "571811",
      "Madapura B.O": "571423",
      "Mandagere B.O": "571423",
      "Sollepura B.O": "571423",
      "Tenginaghatta B.O": "571423",
      "Uginahalli B.O": "571423",
      "Alagodu B.O": "571807",
      "Ballenahalli B.O": "571812",
      "Doddapalya B.O": "571807",
      "Agraharabachahalli B.O": "571426",
      "Bandihole B.O": "571426",
      "Haralahalli B.O": "571426",
      "Valagerememenesa B.O": "571426",
      "Vittalapura B.O": "571426",
      "Haravu B.O": "571427",
      "Rampura B.O": "571427",
      "Yenneholekoppal B.O": "571427",
      "Kadalagere B.O": "571431",
      "Nyamanahalli B.O": "571431",
      "Shamboonahalli B.O": "571431",
      "Kalludevanahalli B.O": "571432",
      "Kanthapura B.O": "571432",
      "Mannahalli B.O": "571432",
      "Mulukatte B.O": "571432",
      "Chinya B.O": "571431",
      "Doddabyadarahalli B.O": "571434",
      "Halebeedu B.O": "571434",
      "Hiremarali B.O": "571434",
      "B.Gowdagere B.O": "571404",
      "Budanur B.O": "571404",
      "Gendehosahalli B.O": "571415",
      "Bheemanahalli B.O": "571445",
      "Devaramallanayakanahalli B.O": "571445",
      "Melapura B.O": "571477",
      "Anegola B.O": "571423",
      "Margonahalli B.O": "571423",
      "Jakkanahalli B.O": "571807",
      "M.Settahalli B.O": "571807",
      "Ballekere B.O": "571415",
      "Chattamgere B.O": "571426",
      "Rayasamudra B.O": "571426",
      "Sindaghatta B.O": "571426",
      "Jodikaradahalli B.O": "571432",
      "Kennalu B.O": "571435",
      "Nelamane B.O": "571435",
      "Alpahalli B.O": "571431",
      "Belur mandya B.O": "571404",
      "Bidarahalli B.O": "571422",
      "Chikkankanahalli B.O": "571415",
      "Haradanahalli B.O": "571445",
      "Thattihalli B.O": "571445",
      "Chowdenahalli B.O": "571423",
      "Ikkanahalli B.O": "571423",
      "Kundur B.O": "571423",
      "T.M.Hosur B.O": "571807",
      "Makavalli B.O": "571426",
      "Modur B.O": "571426",
      "Murukanahalli B.O": "571426",
      "Beereshwarapura B.O": "571432",
      "Bramhadevarahalli B.O": "571432",
      "Paduvalapatna B.O": "571432",
      "T Channapura B.O": "571432",
      "Thattekere B.O": "571432",
      "Bogadi B.O": "571432",
      "Sanaba B.O": "571455",
      "Bindenahalli B.O": "571445",
      "Doddachikkanahalli B.O": "571445",
      "Kudagabalu B.O": "571445",
      "Hebbadihundi B.O": "571477",
      "Nagoonahalli B.O": "571477",
      "Hirekalale B.O": "571423",
      "Sasalu B.O": "571423",
      "K.Settahalli B.O": "571807",
      "Maralagala B.O": "571807",
      "Byrapura B.O": "571426",
      "Seelenere B.O": "571426",
      "Tendekere B.O": "571426",
      "Aralakuppe B.O": "571427",
      "Balighatta B.O": "571431",
      "Bommanayakanahalli B.O": "571432",
      "Doddayagati B.O": "571432",
      "Mylarapatna B.O": "571432",
      "Palagrahara B.O": "571432",
      "Thuppadamadu B.O": "571432",
      "Kurubarabettahalli B.O": "571435",
      "Mahadevapura B.O": "571415",
      "Doddagarudanahalli B.O": "571416",
      "Gudigenahalli B.O": "571416",
      "Boppegowdanapura B.O": "571417",
      "Hosahalli B.O": "571606",
      "Belathur B.O": "571419",
      "Keelaghatta B.O": "571419",
      "Hagalahalli B.O": "571422",
      "Kadukothanahalli B.O": "571422",
      "Karadakere B.O": "571422",
      "S I Honnalagere B.O": "571422",
      "Yadaganahalli B.O": "571422",
      "Cheeranahalli B.O": "571403",
      "Agasanapura B.O": "571475",
      "Gowdagere B.O": "571475",
      "Huskur B.O": "571475",
      "Chandagalu B.O": "571405",
      "Chikkaballi B.O": "571446",
      "Dundanahalli B.O": "571476",
      "Huthagere B.O": "571476",
      "Toresettihalli B.O": "571476",
      "Anasale B.O": "571424",
      "Kalkuni B.O": "571424",
      "Haralakere B.O": "571425",
      "Kowdlay Koppa B.O": "571425",
      "Halehalli B.O": "571425",
      "Bevinahalli B.O": "571478",
      "Sadholalu B.O": "571428",
      "Chottanahalli B.O": "571430",
      "Kandegala B.O": "571430",
      "Madahalli B.O": "571430",
      "Nidaghatta B.O": "571430",
      "Settihalli B.O": "571430",
      "Alur maddur B.O": "571433",
      "Bellur B.O": "571433",
      "Ravani B.O": "571463",
      "Hosur mandya B.O": "571402",
      "Sathnur B.O": "571402",
      "Yeliyur B.O": "571402",
      "Dudda mandya B.O": "571405",
      "Goravale B.O": "571405",
      "Madechakanahalli B.O": "571405",
      "Alambavadikaval B.O": "571605",
      "Somanahalli B.O": "571429",
      "Somanathapura B.O": "571605",
      "Kadabahalli B.O": "571448",
      "Palahalli B.O": "571606",
      "Kambadahalli B.O": "571416",
      "Mayigonahalli B.O": "571802",
      "Dinka B.O": "571812",
      "Kanaganamaradi B.O": "571434",
      "Manikanahalli B.O": "571434",
      "Sunkathonnur B.O": "571434",
      "Tonnur B.O": "571434",
      "Hubbanahalli B.O": "571436",
      "Jaginakere B.O": "571436",
      "Malagur B.O": "571436",
      "Thiruganahalli B.O": "571436",
      "Tadagavadi B.O": "571415",
      "Vadiyandanahalli B.O": "571415",
      "Machegowdanahalli B.O": "571416",
      "Mudagandur B.O": "571416",
      "Muthegere B.O": "571416",
      "Maraliga B.O": "571419",
      "Shivaraguda Vidya Peeta B.O": "571419",
      "Madarahalli B.O": "571422",
      "Soonagahalli B.O": "571403",
      "Torekadanahalli B.O": "571421",
      "Hodaghatta B.O": "571450",
      "Honnaikanahalli B.O": "571450",
      "Maragowdanahalli B.O": "571446",
      "Mallinaikanahalli B.O": "571476",
      "Navile B.O": "571476",
      "Abalavadi B.O": "571425",
      "Bekkalale B.O": "571425",
      "Bidarakote B.O": "571425",
      "Bommanahalli B.O": "571425",
      "Dasanadoddi B.O": "571430",
      "Dugganahalli B.O": "571430",
      "Gajanur B.O": "571430",
      "Hebbani B.O": "571430",
      "Buhalli B.O": "571463",
      "Chikkahebbagilu B.O": "571463",
      "Mallinathapura B.O": "571463",
      "Bevkal B.O": "571405",
      "Shivalli B.O": "571405",
      "Alenahalli B.O": "571605",
      "Beeraballi B.O": "571605",
      "Chakenahalli B.O": "571418",
      "Dadaga B.O": "571418",
      "Doddajataka B.O": "571418",
      "Doddabala B.O": "571802",
      "Honnavara B.O": "571802",
      "Mavinakere B.O": "571812",
      "Ranganathapura B.O": "571436",
      "Neralakere B.O": "571415",
      "Benahatti B.O": "571416",
      "G Malligere B.O": "571416",
      "Konasale B.O": "571419",
      "Niluvagilu B.O": "571419",
      "Doddarasinakere B.O": "571422",
      "Honnayakanahalli B.O": "571422",
      "Kyathaghatta B.O": "571422",
      "Menasagere B.O": "571422",
      "Induvalu B.O": "571403",
      "Thaggahalli B.O": "571403",
      "Dhangur B.O": "571475",
      "Byadarahalli B.O": "571421",
      "Nittur Kodiahalli B.O": "571421",
      "Yathambadi B.O": "571421",
      "Halakere B.O": "571450",
      "Hebbaralu B.O": "571476",
      "Hittanahalli B.O": "571424",
      "Gulur B.O": "571425",
      "Hosagavi B.O": "571425",
      "Thaggahalli koppa B.O": "571425",
      "Santhekasalagere B.O": "571478",
      "Valagerehalli B.O": "571428",
      "Kundur Malavalli B.O": "571430",
      "Nelamakanahalli B.O": "571430",
      "Netkallu B.O": "571430",
      "Athgur B.O": "571433",
      "Sargur B.O": "571463",
      "Chamanahalli B.O": "571429",
      "Gopalapura B.O": "571402",
      "Kommerahalli B.O": "571402",
      "Yelechakanahalli B.O": "571402",
      "Gandalu B.O": "571405",
      "Hullenahalli B.O": "571405",
      "Maranachakanahalli BO": "571405",
      "Maduvinakodi B.O": "571605",
      "Alisandra B.O": "571448",
      "Mudalamellahalli B.O": "571448",
      "Hulikere B.O": "571448",
      "Arni B.O": "571418",
      "Bilagunda B.O": "571418",
      "Bidarakere B.O": "571802",
      "Sathenahalli B.O": "571802",
      "Bannangadi B.O": "571812",
      "Ganjigere B.O": "571812",
      "Ragimudanahalli B.O": "571455",
      "Kalenahalli B.O": "571402",
      "Mahadeshwarapura B.O": "571434",
      "Pattasomanahalli B.O": "571434",
      "Tirumalasagara Chatra B.O": "571434",
      "Koratigere B.O": "571436",
      "Kodiyala B.O": "571415",
      "Bebi B.O": "571416",
      "Dyavapatna B.O": "571417",
      "Kaggalipura B.O": "571417",
      "Kodagahalli B.O": "571417",
      "Hosakere B.O": "571419",
      "Chikkarasinakere B.O": "571422",
      "Madenahalli B.O": "571422",
      "Kirgandur B.O": "571403",
      "Konanahalli B.O": "571403",
      "Kembuthagere B.O": "571475",
      "Nanjegowdanadoddi B.O": "571475",
      "Dadamahalli B.O": "571421",
      "Dalavoykodihalli B.O": "571421",
      "Lingapatna B.O": "571421",
      "Nittur Halasahalli B.O": "571421",
      "Hallegere B.O": "571446",
      "Hulivana B.O": "571446",
      "K Gowdagere B.O": "571446",
      "Mikkere B.O": "571424",
      "Sujjalur B.O": "571424",
      "Nambinayakanahalli B.O": "571425",
      "Gamanahalli B.O": "571478",
      "Lokasara B.O": "571478",
      "Mangala B.O": "571478",
      "Gejjalagere B.O": "571428",
      "Goravanahalli B.O": "571428",
      "Malagaranahalli B.O": "571428",
      "Nagarakere B.O": "571428",
      "Ragibommanahalli B.O": "571430",
      "Talagavadi B.O": "571430",
      "Honnalagere B.O": "571433",
      "Kadalur B.O": "571433",
      "Kulagere B.O": "571433",
      "Thyloor B.O": "571433",
      "Desihalli B.O": "571429",
      "Hemmanahalli B.O": "571429",
      "H Malligere B.O": "571402",
      "Holalu B.O": "571402",
      "Hullikere B.O": "571405",
      "Mallenahalli B.O": "571405",
      "Hariharapura B.O": "571605",
      "Jainahalli B.O": "571605",
      "Anchechittanahalli B.O": "571448",
      "Gondenahalli B.O": "571448",
      "Honnenahalli B.O": "571418",
      "Kalinganahalli B.O": "571418",
      "Nelligere B.O": "571418",
      "Lalanakere B.O": "571802",
      "Bachahalli B.O": "571812",
      "Kanaganahalli B.O": "571455",
      "Kanivekoppal B.O": "571455",
      "Narayanapura B.O": "571455",
      "Aghalaya B.O": "571436",
      "Billenahalli B.O": "571436",
      "Doddasomanahalli B.O": "571436",
      "Nayakanahalli B.O": "571436",
      "Mandya H.O": "571401",
      "Srirangapatna H.O": "571438",
      "Maddur S.O (Mandya)": "571428",
      "Malavalli S.O": "571430",
      "Mandya District S.O": "571401",
      "Nidaghatta S.O": "571433",
      "Purigali S.O": "571463",
      "Kikkeri S.O": "571423",
      "Kyathanahalli S.O": "571427",
      "Nagamangala S.O": "571432",
      "Pandavapura S.O": "571434",
      "Santhebachahalli S.O": "571436",
      "Bharathinagar S.O": "571422",
      "Kiragavalu S.O": "571424",
      "Malavalli Extn S.O": "571430",
      "Mandya Ashoknagar S.O": "571401",
      "Mandya Gandhinagar S.O": "571401",
      "Sugar Town S.O": "571402",
      "Balagangadaranathnagar S.O": "571448",
      "Chunchanahalli S.O": "571811",
      "Devalapura S.O (Mandya)": "571445",
      "Kirangoor S.O": "571807",
      "Krishnarajapete S.O": "571426",
      "Melukote S.O": "571431",
      "Acetate Town S.O": "571404",
      "Arakere S.O": "571415",
      "Keelara S.O": "571450",
      "Keragodu S.O": "571446",
      "Kestur S.O": "571476",
      "V C Farm S.O": "571405",
      "Akkihebbal S.O": "571605",
      "Bellur S.O": "571418",
      "Bindiganavile S.O": "571802",
      "Bukkinakere S.O": "571812",
      "Ganjam S.O": "571477",
      "Pandavapura R S S.O": "571435",
      "Basaralu S.O": "571416",
      "Belakavadi S.O": "571417",
      "Besagarahalli S.O": "571419",
      "Guthal Colony S.O": "571403",
      "Hadli S.O": "571475",
      "Halagur S.O": "571421",
      "Koppa mandya S.O": "571425",
      "Kottatti S.O": "571478",
      "Mandya Azadnagar S.O": "571401",
      "Mandya Shankarnagar S.O": "571401",
      "Shivapura Maddur S.O": "571429",
      "Belagola S.O": "571606",
      "Chinakurali S.O": "571455",
      "Krishnaraja Sagar S.O": "571607"
    },
    "UTTARA KANNADA": {
      "Mangalwada B.O": "581356",
      "Bankanal B.O": "581358",
      "Kagal B.O": "581351",
      "Kavalakki B.O": "581361",
      "Kharwa B.O": "581361",
      "Mutta B.O": "581361",
      "Betkuli B.O": "581333",
      "Marukeri B.O": "581320",
      "Soppinahosalli B.O": "581323",
      "Gersoppa B.O": "581384",
      "Nagarbastikeri B.O": "581384",
      "Boppanalli B.O": "581358",
      "Dasankoppa B.O": "581358",
      "Hebbatti B.O": "581358",
      "Bisgod B.O": "581359",
      "Chandguli B.O": "581359",
      "Dehalli B.O": "581359",
      "Aralwada B.O": "581356",
      "Havagi B.O": "581356",
      "Madnalli B.O": "581356",
      "Kusur B.O": "581411",
      "Andagi B.O": "581358",
      "Isloor B.O": "581358",
      "Balgar B.O": "581359",
      "Balgimane B.O": "581359",
      "Geral B.O": "581359",
      "Hutkhanda B.O": "581359",
      "Magod Colony B.O": "581359",
      "Herangadi B.O": "581334",
      "Jalavalli B.O": "581334",
      "Kadle B.O": "581334",
      "Samsi B.O": "581334",
      "Valki B.O": "581335",
      "Hadavalli B.O": "581320",
      "Hadil B.O": "581320",
      "Heble B.O": "581320",
      "Jali B.O": "581320",
      "Bhagwati B.O": "581363",
      "Balvalli B.O": "581315",
      "Bandal B.O": "581315",
      "Janmane B.O": "581315",
      "Khursi B.O": "581315",
      "Manjguni B.O": "581315",
      "Kyadgi B.O": "581322",
      "Wajgod B.O": "581322",
      "Ammankoppa B.O": "581329",
      "Sambrani B.O": "581329",
      "Tattigeri B.O": "581329",
      "Teginhalli B.O": "581329",
      "Hostota B.O": "581331",
      "Bakkal B.O": "581336",
      "Balegadde B.O": "581336",
      "Mundalli B.O": "581320",
      "Muttolli B.O": "581320",
      "Konalli B.O": "581323",
      "Mallapur B.O": "581400",
      "Kudrige B.O": "581384",
      "Baad B.O": "581351",
      "Hubbangeri B.O": "581351",
      "Chikkankod B.O": "581361",
      "Holegadde B.O": "581327",
      "Lukkeri B.O": "581330",
      "Kujalli B.O": "581332",
      "Kimani B.O": "581333",
      "Paduvani B.O": "581333",
      "Areangadi B.O": "581334",
      "Hosakuli B.O": "581334",
      "Kelagina Mudkani B.O": "581334",
      "Mugva Surkatte B.O": "581334",
      "Salkod B.O": "581334",
      "Mavinkurve B.O": "581320",
      "Nagre B.O": "581335",
      "Valgalli B.O": "581332",
      "Yettinbail B.O": "581333",
      "Durgakeri B.O": "581334",
      "Upponi B.O": "581334",
      "Hodkeshirur B.O": "581338",
      "Kekkar B.O": "581338",
      "Madgeri B.O": "581338",
      "Navilgone B.O": "581338",
      "Algeri B.O": "581314",
      "Halvalli B.O": "581314",
      "Heggar R.C. B.O": "581314",
      "Keni B.O": "581314",
      "Ramanguli B.O": "581314",
      "Sunksal B.O": "581314",
      "Hattikeri B.O": "581316",
      "Shejwad B.O": "581306",
      "Bolshitta B.O": "581328",
      "Ulga B.O": "581328",
      "Wailwada B.O": "581339",
      "Awara Road B.O": "581302",
      "Arge B.O": "581308",
      "Gotnibag B.O": "581345",
      "Kanasgiri B.O": "581352",
      "Hadav B.O": "581353",
      "Belse B.O": "581357",
      "Shirur B.O": "581357",
      "Hanehalli B.O": "581319",
      "Belke B.O": "581320",
      "Santgal B.O": "581323",
      "Santeguli B.O": "581323",
      "Sanikatta B.O": "581326",
      "Tadri B.O": "581326",
      "Targod B.O": "581402",
      "Muttalmuri B.O": "581356",
      "Malalgaon B.O": "581358",
      "Kannadgal B.O": "581359",
      "Kannigeri B.O": "581359",
      "Kegdal B.O": "581363",
      "Ragihosalli B.O": "581315",
      "Bhasi B.O": "581318",
      "Korlakatta B.O": "581318",
      "Umblekoppa B.O": "581318",
      "Itgi B.O": "581322",
      "Sovinkoppa B.O": "581322",
      "Bazarkunang B.O": "581121",
      "Barchi B.O": "581325",
      "Plywood Colony B.O": "581325",
      "Gundolli B.O": "581329",
      "Jange B.O": "581329",
      "Yedoga B.O": "581329",
      "Hallibail B.O": "581331",
      "Gorte B.O": "581320",
      "Konar B.O": "581320",
      "Yelvadikavur B.O": "581320",
      "Saralgi B.O": "581384",
      "Aghanashini B.O": "581351",
      "Holangadde B.O": "581351",
      "Dhareshwar B.O": "581327",
      "Jognikatte B.O": "581327",
      "Masur B.O": "581330",
      "Kalbag B.O": "581332",
      "Urkeri B.O": "581332",
      "Brahmur B.O": "581333",
      "Nagur B.O": "581333",
      "Bhaskeri B.O": "581334",
      "Mugva B.O": "581334",
      "Nilkod B.O": "581440",
      "Molkod B.O": "581335",
      "Agsur B.O": "581314",
      "Kalleswar B.O": "581314",
      "Tenkankeri B.O": "581314",
      "Gopshitta B.O": "581317",
      "Harwada B.O": "581316",
      "Sakalben B.O": "581316",
      "Baad(KWR) B.O": "581306",
      "Shirwad B.O": "581306",
      "Halge Joog B.O": "581328",
      "Kadra Bazar B.O": "581396",
      "Siddar B.O": "581339",
      "S S Auditorium B.O": "581301",
      "Gaongeri B.O": "581345",
      "Devbag B.O": "581352",
      "Hichkad B.O": "581353",
      "Manjuguni B.O": "581353",
      "Kadime B.O": "581319",
      "Sagadgeri B.O": "581319",
      "Kakkalli B.O": "581336",
      "Mathadeval B.O": "581336",
      "Arbail B.O": "581337",
      "Gullapur B.O": "581337",
      "Hunswad B.O": "581356",
      "Nandikatta B.O": "581411",
      "Kupgadde B.O": "581358",
      "D.T.Road B.O": "581359",
      "Angod B.O": "581359",
      "Hunshettikoppa B.O": "581359",
      "Nandolli B.O": "581359",
      "Sahasralli B.O": "581359",
      "Kulgi B.O": "581363",
      "Navilgar B.O": "581315",
      "Sampkhanda B.O": "581315",
      "Gudnapur B.O": "581318",
      "Unchalli B.O": "581318",
      "Chapparmane B.O": "581322",
      "Gubgod B.O": "581322",
      "Gund B.O": "581325",
      "Pradhani B.O": "581325",
      "Aveda B.O": "581365",
      "Chibbalgeri B.O": "581329",
      "Kalginkoppa B.O": "581329",
      "Murakwada B.O": "581329",
      "Balekoppa B.O": "581331",
      "Manigar B.O": "581331",
      "Nilkund B.O": "581331",
      "Itguli B.O": "581336",
      "Kodangadde B.O": "581336",
      "Mensi B.O": "581336",
      "Bare B.O": "581337",
      "Kalache B.O": "581337",
      "Virnoli B.O": "581363",
      "Madralli B.O": "581318",
      "Narur B.O": "581318",
      "Onikeri B.O": "581318",
      "Sugavi B.O": "581318",
      "Alvalli B.O": "581322",
      "Dodmane B.O": "581322",
      "Alur B.O": "581325",
      "Mudgeri B.O": "581360",
      "Baleguli B.O": "581314",
      "Bobruwada B.O": "581314",
      "Dongri B.O": "581314",
      "Shirkuli B.O": "581314",
      "Basgod B.O": "581353",
      "Belambar B.O": "581353",
      "Kodsani B.O": "581357",
      "Adigon B.O": "581319",
      "Aggargon B.O": "581319",
      "Dubbanshashi B.O": "581319",
      "Navayat Colony B.O": "581320",
      "Bazarkunchanalli B.O": "581329",
      "Belvatgi B.O": "581329",
      "Kawalwada B.O": "581329",
      "Kesrolli B.O": "581329",
      "N.S.Koppa B.O": "581329",
      "Hukli B.O": "581331",
      "Hullunde B.O": "581331",
      "Kanchikai B.O": "581331",
      "Sonda B.O": "581336",
      "Vanalli B.O": "581336",
      "Kodlagadde B.O": "581337",
      "Mavinmane B.O": "581337",
      "Hosali B.O": "581360",
      "Balni B.O": "581317",
      "Bhaire B.O": "581317",
      "Gotegali B.O": "581317",
      "Hankon B.O": "581317",
      "Hotegali B.O": "581317",
      "Bhavikeri B.O": "581321",
      "Amdalli B.O": "581324",
      "Mudga B.O": "581324",
      "Todur B.O": "581324",
      "Todur Camp B.O": "581324",
      "Kinnar B.O": "581339",
      "Devalmakki B.O": "581400",
      "Kaiga Workers Colony B.O": "581400",
      "Kerwadi B.O": "581400",
      "Vasarkudrige B.O": "581357",
      "Nadumaskeri B.O": "581319",
      "Vandur B.O": "581341",
      "Manaki B.O": "581362",
      "Achve B.O": "581344",
      "Andle B.O": "581344",
      "Gundbala B.O": "581344",
      "Adukal B.O": "581348",
      "Alvekodi(BKTL) B.O": "581354",
      "Katgar B.O": "581354",
      "Bengre Ulman B.O": "581421",
      "Mathadhittal B.O": "581421",
      "Konkar B.O": "581341",
      "Kelaginoor B.O": "581342",
      "Kallabbe B.O": "581362",
      "Kodambale B.O": "581362",
      "Uppinapattan B.O": "581362",
      "Alvekodi(KMT) B.O": "581343",
      "Mogta B.O": "581344",
      "Ulware B.O": "581344",
      "Talamakki B.O": "581348",
      "Balkur B.O": "581423",
      "Kelagin Idgunji B.O": "581423",
      "Bargi B.O": "581440",
      "Bailur B.O": "581350",
      "Asu B.O": "581129",
      "Shingargaon B.O": "581129",
      "Devisara B.O": "581340",
      "Hasargod B.O": "581340",
      "Kangod B.O": "581355",
      "Karajgi B.O": "581340",
      "Nidgod B.O": "581340",
      "Hosalli B.O": "581412",
      "Kurli B.O": "581346",
      "Chavatti B.O": "581347",
      "Ummachgi B.O": "581347",
      "Bachanki B.O": "581349",
      "Chavadalli B.O": "581349",
      "Gunjavati B.O": "581349",
      "Mainalli B.O": "581349",
      "Herur B.O": "581450",
      "Matttigar B.O": "581450",
      "Barur B.O": "581403",
      "Devanalli B.O": "581403",
      "Kulve B.O": "581403",
      "Mundganmane B.O": "581403",
      "Bengre B.O": "581421",
      "Koppa B.O": "581421",
      "Pavinkurve B.O": "581341",
      "Kasarkod Tonka B.O": "581342",
      "Handigon B.O": "581362",
      "Katgal B.O": "581362",
      "Murur B.O": "581362",
      "Torke B.O": "581344",
      "Gunavante B.O": "581348",
      "Manki Banasale B.O": "581348",
      "Beranki B.O": "581423",
      "Kodani B.O": "581423",
      "Antravalli B.O": "581440",
      "Anantwadi B.O": "581350",
      "Nagoda B.O": "581186",
      "Ajjibal B.O": "581340",
      "Kodsaramuttalli B.O": "581340",
      "Shelur B.O": "581340",
      "Yedalli B.O": "581340",
      "Madnoor B.O": "581412",
      "Hanumapur B.O": "581346",
      "Hittlalli B.O": "581347",
      "Kampli B.O": "581347",
      "Andalgi B.O": "581349",
      "Hungund B.O": "581349",
      "Hegnoor B.O": "581450",
      "Heepnalli B.O": "581403",
      "Adukatta B.O": "581355",
      "Avarguppa B.O": "581355",
      "Kaunchur B.O": "581355",
      "Kondli B.O": "581355",
      "Mavingundi B.O": "581355",
      "Tyarsi B.O": "581355",
      "Bachgaon BO": "581402",
      "Maratikoppa B.O": "581401",
      "Arsapur B.O": "581402",
      "Bommanalli B.O": "581402",
      "Kalve B.O": "581402",
      "Kundargi B.O": "581402",
      "Puttanmane B.O": "581402",
      "Shivalli B.O": "581403",
      "Bidrakan B.O": "581355",
      "Golgod B.O": "581355",
      "Gunjagod B.O": "581355",
      "Harsikatta B.O": "581355",
      "Karkisaval B.O": "581355",
      "Shiralgi B.O": "581355",
      "Chipgi B.O": "581402",
      "Dodnalli B.O": "581402",
      "Hemmadi B.O": "581402",
      "Hulgol B.O": "581402",
      "Kadbal B.O": "581402",
      "Ternamakki B.O": "581421",
      "Apsarkonda B.O": "581342",
      "Hosapattan B.O": "581342",
      "Halkar B.O": "581362",
      "Honmav B.O": "581343",
      "Hillur B.O": "581344",
      "Magod B.O": "581423",
      "Melina Mannige B.O": "581423",
      "Divgi B.O": "581440",
      "Kodkani B.O": "581440",
      "Adkalli B.O": "581340",
      "Balesara B.O": "581340",
      "Thyagli B.O": "581340",
      "Ulvi B.O": "581187",
      "Bhedasgaon B.O": "581346",
      "Dharma Colony B.O": "581346",
      "Katur B.O": "581346",
      "Hasangi B.O": "581347",
      "Shirnal B.O": "581347",
      "Chigalli B.O": "581349",
      "Indoor B.O": "581349",
      "Neharunagar B.O": "581349",
      "Gandhinagar B.O": "581403",
      "Hegadekatta B.O": "581403",
      "Hunsekoppa B.O": "581403",
      "Akkunji B.O": "581355",
      "Bedkani B.O": "581355",
      "Godlabeel B.O": "581355",
      "Halgeri B.O": "581355",
      "Telangeri B.O": "581337",
      "Vajralli B.O": "581337",
      "Chapoli B.O": "581186",
      "Hudsa B.O": "581186",
      "Karanjoida B.O": "581186",
      "Kodsar B.O": "581340",
      "Sampagod B.O": "581340",
      "Anshi B.O": "581187",
      "Kalasai B.O": "581187",
      "Nujji B.O": "581187",
      "Oralgi B.O": "581346",
      "Pala B.O": "581346",
      "Sarkuli B.O": "581450",
      "Tudguni B.O": "581450",
      "Urtota B.O": "581450",
      "Akheti B.O": "581453",
      "Anmod B.O": "581453",
      "Tinaighat B.O": "581453",
      "Nejjur B.O": "581355",
      "Ravindranagar B.O": "581355",
      "Siddapurcourts B.O": "581355",
      "Koligar B.O": "581402",
      "Melinonikeri B.O": "581402",
      "Salkani B.O": "581402",
      "Kolsirsi B.O": "581355",
      "Manmane B.O": "581355",
      "Hosapete B.O": "581401",
      "Bhirumbe B.O": "581402",
      "Chipgeri B.O": "581402",
      "Husri B.O": "581402",
      "Manjavalli B.O": "581402",
      "Sirsi H.O": "581401",
      "Karwar H.O": "581301",
      "Kumta H.O": "581343",
      "Ankola S.O": "581314",
      "Karwar Naval Base S.O": "581308",
      "Kodibag S.O": "581303",
      "Majali S.O": "581345",
      "Nandangadda S.O": "581304",
      "Shetgeri S.O": "581353",
      "Vandige S.O": "581357",
      "Angadi S.O (Uttara Kannada)": "581360",
      "Asnoti S.O": "581317",
      "Chendiye S.O": "581324",
      "Halge S.O": "581328",
      "Kadwad S.O": "581339",
      "Kaiga S.O": "581400",
      "Karwar Baitkhol S.O": "581302",
      "Sirsi Courts S.O": "581401",
      "Yellapur Bazar S.O": "581359",
      "Belekeri S.O": "581321",
      "Sadashivgad S.O": "581352",
      "Karwar Market S.O": "581301",
      "Sirsi Market S.O": "581402",
      "Tergaon S.O": "581356",
      "Tibetan Colony S.O": "581411",
      "Yellapur S.O": "581359",
      "Aversa S.O": "581316",
      "Binaga S.O": "581307",
      "Habbuwada S.O": "581306",
      "Kadra S.O": "581396",
      "Siddapur S.O": "581355",
      "Yekkambi S.O": "581358",
      "Bankikodla S.O": "581319",
      "Gudeangadi S.O": "581351",
      "Honavar S.O": "581334",
      "Kadtoka S.O": "581338",
      "Kaikini S.O": "581421",
      "Karki S.O": "581341",
      "Kumta Kanara College Road S.O": "581362",
      "Kumta Kutchery S.O": "581343",
      "Melin Idgunji S.O": "581423",
      "Mirjan S.O": "581440",
      "Shirali Bazar S.O": "581354",
      "Bhatkal Bazar S.O": "581320",
      "Bhatkal S.O": "581320",
      "Hegde S.O": "581330",
      "Hiregutti S.O": "581333",
      "Ambewadi S.O (Uttara Kannada)": "581325",
      "Dandeli Bazar S.O": "581325",
      "Dandeli S.O": "581325",
      "Kansur S.O": "581340",
      "Kumbarwada S.O": "581187",
      "Nilekani S.O": "581403",
      "Ambikanagar S.O": "581363",
      "Haliyal S.O": "581329",
      "Hulekal S.O": "581336",
      "Idgundi S.O": "581337",
      "Kirwatti S.O": "581412",
      "Mundgod S.O": "581349",
      "Neggu S.O": "581450",
      "Madangeri S.O": "581344",
      "Manki S.O": "581348",
      "Gersoppa Jyothinagar S.O": "581384",
      "Castlerock S.O": "581121",
      "Dandeli Paper Mills S.O": "581325",
      "Heggarni S.O": "581331",
      "Malgi S.O": "581346",
      "Ramnagar S.O (Uttara Kannada)": "581453",
      "Aminalli S.O": "581315",
      "Banavasi S.O": "581318",
      "Herwatta S.O": "581332",
      "Hosad S.O": "581335",
      "Murdeshwar S.O": "581350",
      "Shirali S.O": "581354",
      "Chandavar S.O": "581323",
      "Gokarn S.O": "581326",
      "Hadinbal S.O": "581361",
      "Haldipur S.O": "581327",
      "Kasarkod S.O": "581342",
      "Prabhatnagar S.O": "581334",
      "Bilgi S.O (Uttara Kannada)": "581322",
      "Channammacircle S.O": "581325",
      "Ganeshgudi S.O": "581365",
      "Jagalbet S.O": "581129",
      "Joida S.O": "581186",
      "Manchikeri S.O": "581347"
    },
    "KOLAR": {
      "Somayajalapalli B.O": "563138",
      "Mothakapalli B.O": "563136",
      "Yedaruru B.O": "563138",
      "Alambadi Jothenahalli B.O": "563147",
      "Chaldiganahalli B.O": "563126",
      "Gandlahalli B.O": "563126",
      "Gummareddipura B.O": "563126",
      "BATHALAHALLI B.O": "563129",
      "Bodagurki B.O": "563129",
      "Tamatamakanahalli B.O": "563129",
      "Arehalli B.O": "563101",
      "Chenjimale B.O": "563157",
      "Kolar Gulpet B.O": "563101",
      "KURUGAL B.O": "563157",
      "H.Hosakote B.O": "563130",
      "Hurulagere B.O": "563130",
      "Jayamangala B.O": "563163",
      "Vokkaleri B.O": "563130",
      "Yeshvanthapura B.O": "563130",
      "Baliganahalli B.O": "563139",
      "Dinnahalli B.O": "563139",
      "Nayakarahalli B.O": "563126",
      "Nukkanahalli B.O": "563126",
      "THORADEVANDAHALLI B.O": "563126",
      "Doddurukarapanahalli B.O": "563162",
      "Mavahalli B.O": "563162",
      "Soregowdanakote B.O": "563162",
      "Hanumanahalli B.O": "563127",
      "KOTHAMANGALA B.O": "563127",
      "Oorkunte Mittur B.O": "563127",
      "Addagal B.O": "563161",
      "Byraganahalli B.O": "563161",
      "Marasanapalli B.O": "563161",
      "Yadaganahalli B.O": "563161",
      "Balamande B.O": "563129",
      "Medihala B.O": "563157",
      "Rajakallahalli B.O": "563157",
      "Sugatur B.O": "563101",
      "Thotli B.O": "563101",
      "Bavanahalli B.O": "563130",
      "Byranahalli B.O": "563130",
      "Doddakadathur B.O": "563130",
      "Hongenahalli B.O": "563130",
      "Kurudumale B.O": "563131",
      "Thippedoddi B.O": "563132",
      "Doddavalagamdi B.O": "563120",
      "Kurgepalli B.O": "563134",
      "Mudimadagu B.O": "563134",
      "Yarramavaripalli B.O": "563134",
      "Ganeshpuram B.O": "563122",
      "Parandahalli B.O": "563122",
      "Kasettipalli B.O": "563135",
      "Kotaballapalli B.O": "563135",
      "Maniganapalli B.O": "563135",
      "Ronur B.O": "563135",
      "Chamarahalli B.O": "563103",
      "Shapur B.O": "563103",
      "Shillengere B.O": "563103",
      "Thimmaravathanahalli B.O": "563136",
      "Vegamadagu B.O": "563136",
      "Halepalya B.O": "563137",
      "Huladenahalli B.O": "563137",
      "Kondasettihalli B.O": "563137",
      "Holur B.O": "563126",
      "Muduvadi B.O": "563126",
      "VOLAGERANAHALLI B.O": "563126",
      "Hunkunda B.O": "563162",
      "Yelagondahalli B.O": "563127",
      "DONIMADAGU B.O": "563129",
      "Gullahalli B.O": "563147",
      "Kongarahalli B.O": "563129",
      "Thoppanahalli B.O": "563129",
      "KYALANUR B.O": "563157",
      "Maderahalli B.O": "563101",
      "K N sanitorium B.O": "563101",
      "Alambadi B.O": "563163",
      "Lakkur B.O": "563163",
      "Araleri B.O": "563130",
      "Kudenoor B.O": "563130",
      "Santhehalli B.O": "563130",
      "THYAVANAHALLI B.O": "563130",
      "Dadinayakanadoddi B.O": "563139",
      "Suggondahalli B.O": "563139",
      "Gokunte B.O": "563131",
      "H.Gollahalli B.O": "563131",
      "Kappalamadagu B.O": "563131",
      "VIRUPAKSHI B.O": "563131",
      "Amblical B.O": "563132",
      "Mustoor B.O": "563116",
      "Rajendrahalli B.O": "563132",
      "Arabikothnur B.O": "563133",
      "DODDAVALLABHI B.O": "563133",
      "NARASAPURA INDUSTRIAL AREA B O": "563133",
      "Doddachinnahalli B.O": "563120",
      "Jakkarasanakuppa B.O": "563121",
      "KANGANDLAHALLI B.O": "563121",
      "Peddapalli B.O": "563121",
      "Balthamari B.O": "563134",
      "Pathanelavanki B.O": "563135",
      "Hassandahalli B.O": "563139",
      "Gundlapalya BO": "563139",
      "Angondahalli B.O": "563131",
      "Balla B.O": "563131",
      "Byrakur B.O": "563131",
      "Koladevi B.O": "563131",
      "MATTAKANNASANDRA B.O": "563131",
      "Alangur B.O": "563132",
      "G.Marandahalli B.O": "563132",
      "Padmaghatta B.O": "563132",
      "Belamaranahalli B.O": "563133",
      "Chakarasanahalli B.O": "563133",
      "Y.Hosakote B.O": "563125",
      "Jannaghatta B.O": "563126",
      "Nambihalli B.O": "563126",
      "Velagalaburre B.O": "563126",
      "Karahalli B.O": "563162",
      "Avani B.O": "563127",
      "Sulur B.O": "563133",
      "J. Thimmasandra B.O": "563135",
      "Kallur B.O": "563135",
      "Kembodi B.O": "563103",
      "Shanubhoganahalli B.O": "563103",
      "Devalapalli B.O": "563138",
      "Hogalagere B.O": "563138",
      "Mudiyanur B.O": "563127",
      "UTHANUR B.O": "563127",
      "DODDAPONNANDAHALLI B.O": "563129",
      "KETHAGANAHALLI B.O": "563129",
      "Madderi B.O": "563157",
      "Matnahalli B.O": "563101",
      "Begihosahalli B.O": "563101",
      "Muduvathi B.O": "563101",
      "Madivala B.O": "563130",
      "Settikothanur B.O": "563130",
      "Shivarapatna B.O": "563130",
      "Hebbani B.O": "563131",
      "SOMESHWARAPALYA B.O": "563131",
      "Gudipalli B.O": "563132",
      "Ghattakamadenahalli B.O": "563121",
      "Kammasandra B.O": "563121",
      "KYASAMBALLI B.O": "563121",
      "Srinivsasandra B.O": "563121",
      "Jinkalavaripalli B.O": "563134",
      "Manchineelakote B.O": "563134",
      "Lakshmipura B.O": "563135",
      "Pugurkote B.O": "563135",
      "Ronurthimmasandra B.O": "563135",
      "Harati B.O": "563103",
      "Emmenatha B.O": "563136",
      "Kuppampalya B.O": "563136",
      "Nidaramangala B.O": "563137",
      "Thoralakki B.O": "563137",
      "Karamangala B.O": "563114",
      "Magondhi B.O": "563147",
      "S. Madamangala B.O": "563114",
      "Yelesandra B.O": "563147",
      "Gattamadamangala B.O": "563113",
      "Kempapura B.O": "563113",
      "Hudukula B.O": "563114",
      "Inorahosahalli B.O": "563114",
      "TADIGOLLUL B.O": "563135",
      "Huthur B.O": "563103",
      "Kamadenahalli B.O": "563103",
      "Kannasandra B.O": "563136",
      "Mallanayakanahalli B.O": "563136",
      "Nellahalli B.O": "563137",
      "Nutuve B.O": "563137",
      "Agara B.O": "563138",
      "Imarakunte B.O": "563138",
      "Doddakambali B.O": "563113",
      "Hulibele B.O": "563114",
      "CHIKKA ANGONDAHALLI B.O": "563114",
      "Gannerahalli B.O": "563116",
      "Gollahalli B.O": "563116",
      "Kadripura B.O": "563116",
      "N.G. Hulkur B.O": "563116",
      "Ramasagara B.O": "563116",
      "Sundarapalya B.O": "563116",
      "Hulkur B.O": "563116",
      "Vengasandra B.O": "563116",
      "Kolar H.O": "563101",
      "Bangarpet Bazar S.O": "563114",
      "Beml Nagar S.O": "563115",
      "Bethamangala S.O": "563116",
      "Championreefs S.O": "563117",
      "Deshihalli Bangarpet S.O": "563162",
      "Gownipalli S.O": "563161",
      "Kolar Extension S.O": "563101",
      "Masthi S.O": "563139",
      "Mulbagal Bazar S.O": "563131",
      "Mulbagal S.O": "563131",
      "Narasapura S.O": "563133",
      "Oorgaumpet S.O": "563121",
      "Tayalur S.O": "563136",
      "Andersonpet S.O": "563113",
      "Beml Nagar Colony S.O": "563115",
      "Bharathnagar S.O": "563115",
      "Kolar Bazar S.O": "563101",
      "Kolar Gandhi Nagar S.O": "563101",
      "Malur Railway Station S.O": "563160",
      "Tamaka S.O": "563103",
      "Apmcyard Bangarpet S.O": "563114",
      "Bangarpet S.O": "563114",
      "Kamasamudra S.O": "563129",
      "Kolar Doddapet S.O": "563101",
      "Malur S.O": "563130",
      "Nangli S.O": "563132",
      "Oorgaum S.O": "563120",
      "Yeldur S.O": "563138",
      "Chikkathirupathi S.O": "563163",
      "VEMAGAL SO": "563157",
      "Coromandel S.O": "563118",
      "Dalasanur S.O": "563126",
      "Devarayasamudra S.O": "563127",
      "Kolar Hospital Circle S.O": "563101",
      "Marikuppam S.O": "563119",
      "Rayalpadu S.O": "563134",
      "ROBERTSONPET MDG": "563122",
      "Srinivaspur S.O": "563135",
      "Tekal S.O": "563137",
      "BUDIKOTE SO": "563147"
    },
    "TUMAKURU": {
      "Yelerampura B.O": "572129",
      "Bellavi B.O": "572107",
      "Halanur B.O": "572107",
      "Ganjalagunte B.O": "572132",
      "Hosakere B.O": "572222",
      "Kodagadala B.O": "572132",
      "Kotagarlahalli B.O": "572132",
      "Neralekere B.O": "572132",
      "Nitrahalli B.O": "572132",
      "Rantavalalu B.O": "572132",
      "Settihalli B.O": "572102",
      "SSIT Campus B.O": "572105",
      "Bedathur B.O": "572133",
      "Obalapura B.O": "572106",
      "Oorkere B.O": "572106",
      "Yadaladaku B.O": "572135",
      "Yenjalagere B.O": "572135",
      "Srirangapura B.O": "572136",
      "Tirumani B.O": "572136",
      "Vallur B.O": "572136",
      "Yaguvapalli B.O": "572136",
      "Pathaganahalli B.O": "572129",
      "Bugudanahalli B.O": "572107",
      "Doddanaravangala B.O": "572107",
      "Bijawara B.O": "572132",
      "Doddaveeragondanahalli B.O": "572132",
      "Kyathagondanahalli B.O": "572133",
      "Hemdore B.O": "572135",
      "Vajarahalli B.O": "572135",
      "Hussainpura B.O": "572136",
      "Nagalamadike B.O": "572136",
      "Bommathanahalli B.O": "561202",
      "Byadanur B.O": "561202",
      "Rajavanthi B.O": "561202",
      "Dommathamari B.O": "561202",
      "Kotagudda B.O": "561202",
      "Sasalakunte B.O": "561202",
      "Badakanahalli B.O": "572175",
      "Byalya B.O": "572175",
      "Mavathur B.O": "572129",
      "Belagumba B.O": "572104",
      "Haralur B.O": "572104",
      "Channenahalli B.O": "572107",
      "Chinakavajra B.O": "572132",
      "Vaderahalli B.O": "572132",
      "Melekote B.O": "572105",
      "Lakshmipura B.O": "572133",
      "Reddihalli B.O": "572133",
      "Arakere B.O": "572130",
      "Nadur B.O": "572135",
      "Veeraganahalli B.O": "572135",
      "Kyathaganakere B.O": "572136",
      "Rayacherlu B.O": "572136",
      "Budibetta B.O": "561202",
      "Kanivenahalli B.O": "561202",
      "Kodamadagu B.O": "561202",
      "Neelammanahalli B.O": "561202",
      "Rangasamudra B.O": "561202",
      "Sailapura B.O": "561202",
      "Virupasamudra B.O": "561202",
      "Irakasandra B.O": "572117",
      "Mallekavu B.O": "572129",
      "Theetha B.O": "572129",
      "Thumbadi B.O": "572129",
      "Vaddagere B.O": "572129",
      "Vajjanakurke B.O": "572129",
      "Devarayapatna B.O": "572104",
      "Kattige Gollahalli B.O": "572104",
      "Kesaramadu B.O": "572104",
      "Mydala B.O": "572104",
      "Swandenahalli B.O": "572104",
      "Mallasandra B.O": "572107",
      "Siddarthanagar B.O": "572107",
      "Chinnenahalli B.O": "572133",
      "Hanumanthapura B.O": "572133",
      "Beladhara B.O": "572106",
      "Dibbur B.O": "572106",
      "Bevinahalli B.O": "572135",
      "Chengavara B.O": "572135",
      "Dwaranakunte B.O": "572135",
      "Bettadakelaginahalli B.O": "572136",
      "Gowdatti B.O": "561202",
      "Gummaghatta B.O": "561202",
      "Gundlahalli B.O": "561202",
      "Lingadahalli B.O": "561202",
      "Naliganahalli B.O": "561202",
      "Ponnasamudra B.O": "561202",
      "Roppa B.O": "561202",
      "Soolanaikanahalli B.O": "561202",
      "Venkatapura B.O": "561202",
      "Channanakunte B.O": "572137",
      "Manangi B.O": "572139",
      "Kestur B.O": "572138",
      "Seethakal B.O": "572140",
      "Hadavanahalli B.O": "572211",
      "Kondli B.O": "572211",
      "Keelara B.O": "572111",
      "Markonahalli B.O": "572111",
      "C.Kodagihalli B.O": "572213",
      "Chengavi B.O": "572213",
      "Hindiskere B.O": "572213",
      "Idagur B.O": "572213",
      "Ankasandra B.O": "572117",
      "C.Nandihalli B.O": "572117",
      "Gowripura B.O": "572117",
      "Heggere B.O": "572215",
      "Hullekere B.O": "572215",
      "Kondajji B.O": "572215",
      "Adagur B.O": "572216",
      "N.Hosahalli B.O": "572211",
      "Halagere B.O": "572111",
      "Jinnagara B.O": "572111",
      "Kadasettihalli B.O": "572111",
      "Volagerepura B.O": "572111",
      "Anekere B.O": "572212",
      "Kuppalu B.O": "572114",
      "Rajathadripura B.O": "572114",
      "Naranahalli B.O": "572213",
      "Seegehalli B.O": "572213",
      "Kodiyala B.O": "572117",
      "Manchaladore B.O": "572117",
      "Talekoppa B.O": "572117",
      "Barasidlahalli B.O": "572214",
      "Honnebagi B.O": "572214",
      "Thirthapura B.O": "572214",
      "Beechanahalli B.O": "572215",
      "Chikkamalur B.O": "572175",
      "Doddahosahalli B.O": "572175",
      "Gondhihalli B.O": "572175",
      "Kodlapura B.O": "572175",
      "Huildore B.O": "572137",
      "Kotta B.O": "572137",
      "Madalur B.O": "572137",
      "Mekerahalli B.O": "572137",
      "Melkunte B.O": "572137",
      "Rathnasandra B.O": "572137",
      "Dyagerahalli B.O": "572139",
      "Gowdagere B.O": "572130",
      "Hunsehalli B.O": "572139",
      "Lakshmisagara B.O": "572139",
      "Maddakkanahalli B.O": "572139",
      "Kuramkote B.O": "572138",
      "Negalala B.O": "572138",
      "Devarayanadurga B.O": "572140",
      "Hiredoddavadi B.O": "572140",
      "Pothaganahalli B.O": "572141",
      "Siddapura B.O": "572141",
      "Thippaiahnadurga B.O": "572141",
      "Honnagondanahalli B.O": "572137",
      "Kadavigere B.O": "572137",
      "Magodu B.O": "572137",
      "Thuppadakona B.O": "572137",
      "Hosur B.O": "572139",
      "Kabbigere B.O": "572138",
      "Byatha B.O": "572140",
      "Chikkahalli B.O": "572141",
      "Maridasanahalli B.O": "572141",
      "Doddaguni B.O": "572211",
      "Bettahalli B.O": "572111",
      "Holalagunda B.O": "572111",
      "K.Honnamachanahalli B.O": "572111",
      "Sanaba B.O": "572111",
      "Yadavanne B.O": "572111",
      "Aralaguppe B.O": "572212",
      "Kunikenahalli B.O": "572212",
      "Neeragunda B.O": "572212",
      "Thoremavinahalli B.O": "572212",
      "Beerasandra B.O": "572114",
      "Karadi B.O": "572114",
      "Kibbanahalli B.O": "572114",
      "Kondlighatta B.O": "572114",
      "Thuilahalli B.O": "572213",
      "Sathenahalli B.O": "572117",
      "Godekere B.O": "572214",
      "Malligehalli B.O": "572214",
      "Machenahalli B.O": "572215",
      "Pura B.O": "572215",
      "Vajrapura Colony B.O": "572211",
      "Paduvagere B.O": "572111",
      "Malagondanahalli B.O": "572114",
      "Ankalakoppa B.O": "572213",
      "Mavinahalli B.O": "572213",
      "S.Kodagehalli B.O": "572213",
      "Bidare B.O": "572117",
      "Madenahalli B.O": "572216",
      "Jayachamarajapura B.O": "572214",
      "Dombaranahalli B.O": "572215",
      "Dunda B.O": "572215",
      "Kondavadi B.O": "572175",
      "Bandakunte B.O": "572137",
      "Guligenehalli B.O": "572137",
      "Syagadadu B.O": "572137",
      "Yeliyur B.O": "572126",
      "SIT Campus B.O": "572102",
      "Dasalakunte B.O": "572138",
      "Devalapura B.O": "572138",
      "Kempanadodderi B.O": "572138",
      "Anupanahalli B.O": "572140",
      "Aregujjanahalli B.O": "572140",
      "Kolala B.O": "572140",
      "Yelachigere B.O": "572140",
      "Jalodu B.O": "572141",
      "Chikkonahalli B.O": "572216",
      "Galaga B.O": "572216",
      "Gopalapura B.O": "572216",
      "Singonahalli B.O": "572127",
      "Thippur B.O": "572216",
      "Baragihalli B.O": "572119",
      "Baragur B.O": "572119",
      "Doddayennegere B.O": "572119",
      "Naduvanahalli B.O": "572119",
      "Soralamavu B.O": "572119",
      "Dasudi B.O": "572218",
      "Chowdanakuppe B.O": "572123",
      "Halevoor B.O": "572123",
      "Hosahalli B.O": "572112",
      "Kenchanahalli B.O": "572123",
      "Kodavathi B.O": "572123",
      "Tavarekere B.O": "572122",
      "Ujjini B.O": "572123",
      "Yelekadakalu B.O": "572123",
      "Barakanalu B.O": "572228",
      "Ippadi B.O": "572126",
      "Kathrighatta B.O": "572126",
      "Seenappanahalli B.O": "572126",
      "Bidanagere B.O": "572130",
      "Doddamavathur B.O": "572130",
      "Herur B.O": "572216",
      "Kithanagamangala B.O": "572130",
      "Mugalur B.O": "572221",
      "Muthugadahalli B.O": "572221",
      "Galigekere B.O": "572222",
      "Turuganur B.O": "572134",
      "Tuvekere B.O": "572134",
      "Thandaga B.O": "572224",
      "Vignasanthe B.O": "572224",
      "Samige Road Railway Station. B.O": "572225",
      "Sampige hosahalli B.O": "572225",
      "Talavaranahalli B.O": "572225",
      "Dugudihalli B.O": "572226",
      "Kuppur B.O": "572226",
      "Bhyranayakanahalli B.O": "572201",
      "Dasarighatta B.O": "572201",
      "Echanur B.O": "572201",
      "Halkurike B.O": "572201",
      "Honnavalli Road B.O": "572201",
      "Gonitumkur B.O": "572227",
      "Guddenahalli B.O": "572227",
      "Kodagihally B.O": "572227",
      "Sidadaragal B.O": "572112",
      "Thimmalapura B.O": "572112",
      "Ramalingapura B.O": "572115",
      "Madapura B.O": "572216",
      "Kengalapura B.O": "572119",
      "Hulihalli B.O": "572217",
      "Ramanahalli B.O": "572228",
      "Bellara B.O": "572218",
      "Thirumalapura B.O": "572218",
      "Yelanadu B.O": "572218",
      "Bandihalli B.O": "572223",
      "P.Honnamachanahalli B.O": "572123",
      "Koppa B.O": "572142",
      "K.Mathighatta B.O": "572220",
      "Yeradakatte B.O": "572115",
      "Mangalawada B.O": "572116",
      "Mugadalabetta B.O": "572116",
      "Nyayadagunte B.O": "572116",
      "Shyamarayanapalya B.O": "572116",
      "Gubbi Hosahalli B.O": "572216",
      "Mukanahallipatna B.O": "572216",
      "Nagasandra gubbi B.O": "572216",
      "Puradakatte B.O": "572119",
      "Baluvaneralu B.O": "572217",
      "Ganadal B.O": "572218",
      "Hoisalakatte B.O": "572218",
      "Kenkere B.O": "572218",
      "Belavatha B.O": "572219",
      "Byadigere B.O": "572219",
      "Doddakunnala B.O": "572219",
      "Ajjenahalli B.O": "572220",
      "Bittagondanahalli B.O": "572220",
      "Doddagoraghatta B.O": "572220",
      "K.Kallahalli B.O": "572220",
      "Chikkabidare B.O": "572228",
      "Muddenahalli B.O": "572228",
      "Sadarahalli B.O": "572228",
      "Kothagere B.O": "572130",
      "Madikehalli B.O": "572130",
      "Dasihalli B.O": "572221",
      "Doddamalligere B.O": "572221",
      "Doddasettikere B.O": "572221",
      "Talakere B.O": "572221",
      "Vittalapura B.O": "572221",
      "Jiddigere B.O": "572134",
      "Adalagere B.O": "572223",
      "N.Mathighatta B.O": "572223",
      "Thyagatur B.O": "572223",
      "Gungurumale B.O": "572224",
      "Hunseghatta B.O": "572224",
      "Kanathur B.O": "572224",
      "Masavanaghatta B.O": "572224",
      "Kalkere B.O": "572221",
      "Ramachandrapura B.O": "572201",
      "Huthri B.O": "572126",
      "Yalagalawadi B.O": "572126",
      "Modur B.O": "572130",
      "Tarikere B.O": "572130",
      "Jadeya B.O": "572221",
      "Kanakoor B.O": "572221",
      "Nagalapura B.O": "572221",
      "Alalaghatta B.O": "572222",
      "Hagalawadi B.O": "572222",
      "Shivapura B.O": "572222",
      "Hodalur B.O": "572223",
      "Albur B.O": "572224",
      "Bajagur B.O": "572224",
      "Sugur B.O": "572224",
      "Attikatte B.O": "572225",
      "Navile B.O": "572226",
      "Thammadihalli B.O": "572226",
      "Belagarahali B.O": "572201",
      "Gurugadahalli B.O": "572201",
      "Kallegowdanapalya B.O": "572201",
      "Mathihalli B.O": "572201",
      "Muniyur B.O": "572227",
      "Doddamadure B.O": "572142",
      "Tippur B.O": "572142",
      "Dabbeghatta B.O": "572227",
      "Karpenahalli B.O": "572112",
      "Lakkenahalli B.O": "572216",
      "Thadakalur B.O": "572113",
      "Ganadahunse B.O": "572115",
      "Gujjanadu B.O": "572116",
      "Nagavalli B.O": "572118",
      "Bhaktharahalli B.O": "572120",
      "Siravara B.O": "572120",
      "Arasapura B.O": "572121",
      "Bommaladevipura B.O": "572121",
      "Thogarighatta B.O": "572121",
      "Garani B.O": "572124",
      "Thadi B.O": "572124",
      "Gopaladeverahalli B.O": "572125",
      "Tarur B.O": "572125",
      "Gundagal B.O": "572127",
      "Kalidevapura B.O": "572127",
      "Shravandanahalli B.O": "572127",
      "Sorekunte B.O": "572128",
      "A.Venkatapura B.O": "572129",
      "Hanchihalli B.O": "572129",
      "Ammanaghatta B.O": "572216",
      "Prabhuvanahalli B.O": "572216",
      "Chowlakatte B.O": "572119",
      "Mathighatta B.O": "572119",
      "Niruvagal B.O": "572119",
      "Gudigondanahalli B.O": "572217",
      "Kamalapura B.O": "572217",
      "Dabbegunte B.O": "572218",
      "Nidasale B.O": "572123",
      "R.Byadarahalli B.O": "572123",
      "Belaguli B.O": "572228",
      "Thimmanahalli B.O": "572228",
      "Bettahallimutt B.O": "572126",
      "Sondalagere B.O": "572126",
      "Begur B.O": "572130",
      "Bilidevalaya B.O": "572130",
      "Gunnagere B.O": "572130",
      "Kaggere B.O": "572130",
      "Nadumavinapura B.O": "572130",
      "Santhmavathur B.O": "572130",
      "Mavinakere B.O": "572221",
      "Soravanahalli B.O": "572221",
      "Bettadahalli B.O": "572222",
      "Somalapura B.O": "572222",
      "Handanahalli B.O": "572223",
      "Haradagere B.O": "572223",
      "Aremallenahalli B.O": "572224",
      "Ganganaghatta B.O": "572224",
      "Nagaraghatta B.O": "572224",
      "Nellikere B.O": "572224",
      "Marasettihalli B.O": "572225",
      "Sasalu B.O": "572122",
      "Halepalya B.O": "572201",
      "Kotanayakanahalli B.O": "572201",
      "Madenur B.O": "572201",
      "Aralikere B.O": "572227",
      "Dwaranahalli B.O": "572227",
      "Madihalli B.O": "572227",
      "Chandragiri B.O": "572112",
      "Kavanadala B.O": "572112",
      "Hulikunte B.O": "572129",
      "Ragalahalli B.O": "572113",
      "Hunsekatte B.O": "572115",
      "Arsikere B.O": "572116",
      "Thimmalanayakanabetta B.O": "572116",
      "Niduvalalu B.O": "572120",
      "Taredakuppe B.O": "572120",
      "Rampura B.O": "572121",
      "Sompura B.O": "572121",
      "Yelkur B.O": "572124",
      "Bhupasandra B.O": "572125",
      "Brahamasandra B.O": "572125",
      "Chikkanahalli B.O": "572121",
      "Chikkadalavatta B.O": "572127",
      "Suddekunte B.O": "572127",
      "Brahmasandra B.O": "572128",
      "Chikkatotlukere B.O": "572128",
      "Haldodderi B.O": "572128",
      "Hunjanal B.O": "572128",
      "Rangapura B.O": "572201",
      "Sarthavalli B.O": "572201",
      "Tadasur B.O": "572201",
      "Benakanakere B.O": "572227",
      "Dodderi B.O": "572112",
      "Hanumanahalli B.O": "572112",
      "Jakkenahalli B.O": "572112",
      "Badamaranahalli B.O": "572113",
      "Chikkabanagere B.O": "572113",
      "Chirathahalli B.O": "572113",
      "Handikunte B.O": "572113",
      "Jangamarahalli B.O": "572116",
      "Kannamedi B.O": "572116",
      "Kilarlahalli B.O": "572116",
      "Kondethimmanahalli B.O": "572116",
      "Kothur B.O": "572116",
      "Kyathaganahalli B.O": "572116",
      "Madde B.O": "572116",
      "Ariyur B.O": "572118",
      "Chikkasarangi B.O": "572118",
      "Kambathanahalli B.O": "572118",
      "Makanahalli B.O": "572118",
      "Dawoodsab Palya B.O": "572120",
      "Kanakuppe B.O": "572120",
      "Kodlahalli B.O": "572121",
      "Kyashavara B.O": "572121",
      "Hullenahalli B.O": "572122",
      "Maskal B.O": "572122",
      "Mulkunte B.O": "572122",
      "Naruganahalli B.O": "572122",
      "Bramhasamudra B.O": "572124",
      "Janakaloti B.O": "572124",
      "Kataveeranahalli B.O": "572125",
      "Kuntegowdanahalli B.O": "572125",
      "Kadagathur B.O": "572127",
      "Mydanahalli B.O": "572127",
      "Parthihalli B.O": "572127",
      "Agrahara B.O": "572129",
      "Bukkapatna B.O": "572129",
      "Dasarahalli B.O": "572129",
      "Doddasaggere B.O": "572129",
      "Palasandra B.O": "572118",
      "Kembalalu B.O": "572120",
      "Singonahally B.O": "572120",
      "Honsigere B.O": "572122",
      "Thippapura B.O": "572124",
      "Dodda Agrahara B.O": "572125",
      "Halenahalli B.O": "572125",
      "Seebi Agrahara B.O": "572125",
      "Talagunda B.O": "572125",
      "Vaddanahalli B.O": "572125",
      "Doddamalur B.O": "572127",
      "Teriyur B.O": "572127",
      "Nelahal B.O": "572128",
      "Tiptur H.O": "572201",
      "Tumakuru H.O": "572101",
      "Dandinashivara S.O": "572215",
      "Mayasandra S.O": "572221",
      "Yediyur S.O (Tumakuru)": "572142",
      "Badavanahalli S.O": "572112",
      "Bukkapatna S.O": "572115",
      "Ittakadibbanahalli S.O": "572124",
      "Kallambella S.O": "572125",
      "Kora S.O (Tumakuru)": "572128",
      "Koratagere S.O": "572129",
      "M C Campus Tumakuru S.O": "572107",
      "Palavalli S.O": "572136",
      "Pavagada Fort S.O": "561202",
      "TUMAKURU UNIVERSITY CAMPUS S.O": "572103",
      "Tavarekere S.O (Tumakuru)": "572139",
      "Tumakuru City S.O": "572101",
      "Western Extn S.O": "572101",
      "Amruthur S.O": "572111",
      "Ammasandra S.O": "572211",
      "Chikkanayakanahalli S.O": "572214",
      "Gubbi S.O": "572216",
      "Honnavalli S.O": "572217",
      "Huliyar S.O": "572218",
      "K R Extn Tiptur S.O": "572201",
      "Kadaba S.O (Tumakuru)": "572219",
      "Kallur S.O (Tumakuru)": "572220",
      "Kandikere S.O": "572228",
      "Kempanahalli S.O": "572126",
      "Kunigal S.O": "572130",
      "Nonavinakere S.O": "572224",
      "Sampige S.O": "572225",
      "Turuvekere S.O": "572227",
      "Baragur S.O": "572113",
      "Channakeshavapura S.O": "572116",
      "Gandhinagar S.O Tumakuru": "572102",
      "Gokula Extn Koratagere S.O": "572129",
      "Gulur S.O": "572118",
      "Holavanahalli S.O": "572121",
      "Honnudike S.O": "572122",
      "Madhugiri S.O": "572132",
      "Puravara S.O": "572175",
      "R M Yard Madhugiri S.O": "572132",
      "S G Extn Tumakuru S.O": "572102",
      "JYOTHINAGARA SIRA S.O": "572137",
      "Urdigere S.O": "572140",
      "Chelur S.O (Tumakuru)": "572117",
      "Handanakere S.O": "572119",
      "Huliyur Durga S.O": "572123",
      "K R S Agrahara Kunigal S.O": "572130",
      "Mooganayakana Kote S.O": "572222",
      "Nagasandra S.O (Tumakuru)": "572134",
      "Nittur S.O (Tumakuru)": "572223",
      "Settikere S.O": "572226",
      "Hebbur S.O": "572120",
      "Jayanagar Extn Tumakuru  S.O": "572102",
      "Kodigenahalli S.O": "572127",
      "Kyathasandra S.O": "572104",
      "Northren Extension S.O": "572106",
      "P. W. D. Colony (Madhugiri) S.O": "572132",
      "Pavagada S.O": "561202",
      "Y N Hoskote S.O": "572141",
      "Hirehalli S.O": "572168",
      "Banasandra S.O": "572212",
      "Biligere S.O": "572114",
      "Chandrashekarapura S.O": "572213",
      "Gubbi Bazar S.O": "572216",
      "Kuvempunagara S.O": "572103",
      "Maralur S.O": "572105",
      "Medigeshi S.O": "572133",
      "P N Halli S.O": "572135",
      "Siddaganga Mutt S.O": "572104",
      "Sira S.O": "572137",
      "Someswarapuram S.O": "572102",
      "Tovinakere S.O": "572138"
    },
    "RAICHUR": {
      "Kardigudda B.O": "584123",
      "Madlapur B.O": "584123",
      "Malladagudda B.O": "584123",
      "Hanamapur B.O": "584202",
      "Hirapur B.O": "584202",
      "Chickbudur B.O": "584126",
      "Itgi B.O": "584126",
      "Jagatkal B.O": "584126",
      "Amdhihal B.O": "584125",
      "Atkur B.O": "584102",
      "Chandrabanda B.O": "584102",
      "Katlatkur B.O": "584102",
      "Askihal B.O": "584104",
      "Dinni B.O": "584104",
      "Halkawatgi B.O": "584127",
      "Hirelakkihal B.O": "584127",
      "Nagarahal B.O": "584127",
      "Nawli B.O": "584127",
      "Deosugur B.O": "584170",
      "Gorebal B.O": "584127",
      "Hanchinal Camp B.O": "584128",
      "Jalihal B.O": "584128",
      "Jalihal Camp B.O": "584128",
      "Kolbal B.O": "584128",
      "Kurkunda B.O": "584128",
      "Madsirwar B.O": "584128",
      "Yeddaldoddi B.O": "584128",
      "Kalasa Hosahalli B.O": "584132",
      "Chicksugur B.O": "584134",
      "Janekal B.O": "584123",
      "Konapur Pet B.O": "584123",
      "Korvi B.O": "584123",
      "Hampanahal B.O": "584124",
      "Nagarabenchi B.O": "584124",
      "Jookur B.O": "584202",
      "Rajoli B.O": "584202",
      "Hirebudur B.O": "584126",
      "Gudihal B.O": "584125",
      "Kannal B.O": "584125",
      "Maliabad B.O": "584103",
      "Mitti Malkapur B.O": "584103",
      "Singanodi B.O": "584102",
      "Merchthal B.O": "584104",
      "Rampur B.O": "584104",
      "Gonwatla B.O": "584127",
      "Ganjahalli B.O": "584170",
      "Yadlapur B.O": "584170",
      "Hediginahal B.O": "584128",
      "Mallapur B.O": "584128",
      "Roudkunda B.O": "584128",
      "Virupapur B.O": "584128",
      "Alkod B.O": "584129",
      "Jambaladinni B.O": "584129",
      "Kyadigera B.O": "584129",
      "Nawalkal B.O": "584129",
      "Huttigudda B.O": "584132",
      "Kalmangi B.O": "584132",
      "Waddepalli B.O": "584135",
      "Gonhal B.O": "584134",
      "Hembarhal B.O": "584134",
      "Jagir Venkatapur B.O": "584134",
      "Udamgal B.O": "584133",
      "Rabbanakal B.O": "584123",
      "Gudadur B.O": "584124",
      "Medikinhal B.O": "584124",
      "Purtipli B.O": "584202",
      "Turkondana B.O": "584202",
      "Mustoor B.O": "584123",
      "Sunkeshwarhal B.O": "584126",
      "Jakkarmadu B.O": "584125",
      "K. Mariammanahalli B.O": "584125",
      "Kansavi B.O": "584125",
      "Nagalapur B.O": "584125",
      "Upparnandihal B.O": "584125",
      "Kuruvapur B.O": "584102",
      "Yapaladinni B.O": "584102",
      "Nelhal B.O": "584104",
      "Chitapur B.O": "584127",
      "Sajjalagudda B.O": "584127",
      "Kadlur B.O": "584170",
      "Alabanur B.O": "584128",
      "Amarapur B.O": "584128",
      "Harapur B.O": "584128",
      "Pagadadinni B.O": "584128",
      "Tidigol B.O": "584128",
      "Valaballary B.O": "584128",
      "Ballutgi B.O": "584129",
      "Kadadinni B.O": "584129",
      "Kurkundi B.O": "584129",
      "Madigera B.O": "584129",
      "Gunjahalli B.O": "584132",
      "Umloti B.O": "584132",
      "Sagamkunta B.O": "584135",
      "Heggasanahalli B.O": "584134",
      "Hosapete B.O": "584134",
      "Puchaldinni B.O": "584133",
      "Nakkunda B.O": "584123",
      "Nanjaladinni B.O": "584124",
      "Talekhan B.O": "584124",
      "Shivangi B.O": "584126",
      "Ashihal B.O": "584125",
      "Bannigol B.O": "584125",
      "Khairwadgi B.O": "584125",
      "Makapur B.O": "584125",
      "Mattur B.O": "584125",
      "Arlihalli B.O": "584128",
      "Badarli B.O": "584128",
      "Channahalli B.O": "584128",
      "Sasalmari Camp B.O": "584128",
      "Sidrampur B.O": "584128",
      "Sindhanur Camp B.O": "584128",
      "Somalapur B.O": "584128",
      "Uppaldoddi B.O": "584128",
      "Heera B.O": "584129",
      "Jadaladinni B.O": "584129",
      "Lakkamdinni B.O": "584129",
      "Mallat B.O": "584129",
      "Nagadadinni B.O": "584129",
      "Gunda B.O": "584132",
      "Hirebhergi B.O": "584132",
      "Hogarnal B.O": "584132",
      "Dongarampur B.O": "584135",
      "Ghanmur B.O": "584135",
      "Korthakunda B.O": "584135",
      "Kudlur B.O": "584135",
      "Jegarkal B.O": "584134",
      "Manslapur B.O": "584134",
      "Merchad B.O": "584134",
      "Yeganur B.O": "584134",
      "Julumgera B.O": "584133",
      "Kamalapur B.O": "584133",
      "Lingankhan Doddi B.O": "584133",
      "Manjerla B.O": "584133",
      "Dondambli B.O": "584111",
      "Gopalpura B.O": "584111",
      "Jeerbandi B.O": "584111",
      "Joldhadgi B.O": "584111",
      "Madarkal B.O": "584113",
      "Maladakal B.O": "584113",
      "Ramdurga B.O": "584113",
      "Bichal B.O": "584140",
      "Gandhal B.O": "584116",
      "Idapanur B.O": "584140",
      "Yerdona B.O": "584115",
      "C.S. Farm B.O": "584143",
      "Chickkotnakal B.O": "584143",
      "Diddgi B.O": "584138",
      "Tadakal B.O": "584138",
      "Kelagina Irabgera B.O": "584111",
      "Kopparu B.O": "584111",
      "Kothadoddi B.O": "584111",
      "Huda B.O": "584167",
      "Mukkunda B.O": "584167",
      "Bommanahal B.O": "584113",
      "Sultanpur B.O": "584113",
      "Alkur B.O": "584140",
      "Mirzapur B.O": "584140",
      "Upparhal B.O": "584140",
      "Devarabhupur B.O": "584139",
      "Yelagatta B.O": "584139",
      "Honnahalli B.O": "584115",
      "Hutti Village B.O": "584115",
      "Bendarganekal B.O": "584116",
      "Galag B.O": "584116",
      "Hosur B.O": "584143",
      "Potnal B.O": "584143",
      "Kapgal B.O": "584118",
      "Athnur B.O": "584136",
      "Ganekal B.O": "584136",
      "Murhanpur B.O": "584136",
      "Chickhesarur B.O": "584120",
      "Halapur B.O": "584120",
      "Hirehanagi B.O": "584120",
      "Markam Dinni B.O": "584120",
      "Watgal B.O": "584120",
      "Ankasdoddi B.O": "584122",
      "Benchmardi B.O": "584122",
      "Gonwar B.O": "584143",
      "Huvinbhavi B.O": "584122",
      "Chickalparvi B.O": "584123",
      "Harvi B.O": "584123",
      "Hirekottanakal B.O": "584123",
      "Neermanvi B.O": "584118",
      "Amingad B.O": "584120",
      "Bagalwad B.O": "584120",
      "Pamankallur B.O": "584120",
      "Gorkal B.O": "584203",
      "Sunkeshwar B.O": "584203",
      "Maraladinni B.O": "584122",
      "Yeachnal B.O": "584122",
      "Aldhal B.O": "584123",
      "Gowdhan Bhavi B.O": "584138",
      "Arkera B.O": "584111",
      "Karigudda B.O": "584111",
      "Konchapli B.O": "584111",
      "Nagoli B.O": "584111",
      "Budiwal Camp B.O": "584167",
      "Kengal B.O": "584167",
      "Salgunda B.O": "584167",
      "Arshangi B.O": "584113",
      "Hireraikumpi B.O": "584113",
      "Khanapur B.O": "584113",
      "Gillesugur B.O": "584140",
      "Talmari B.O": "584140",
      "Gowdur B.O": "584139",
      "Hirenaganur B.O": "584115",
      "Medinapur B.O": "584115",
      "Chinchodi B.O": "584116",
      "Kharabdinni B.O": "584143",
      "Hokrani B.O": "584118",
      "Machanur B.O": "584118",
      "Ganadinni B.O": "584136",
      "Udbal B.O": "584138",
      "Singapur B.O": "584167",
      "Uppal B.O": "584167",
      "Shavantagera B.O": "584113",
      "Nilogal B.O": "584136",
      "Anwari B.O": "584120",
      "Toranadinni B.O": "584120",
      "Aroli B.O": "584203",
      "Garaladinni B.O": "584203",
      "Rajalbanda B.O": "584203",
      "Anehosur B.O": "584122",
      "Byagawat B.O": "584123",
      "Gudadinni B.O": "584123",
      "Kota B.O": "584139",
      "Chincharki B.O": "584115",
      "Gajjalagatta B.O": "584115",
      "Rodalabanda B.O": "584115",
      "Vandli B.O": "584115",
      "Herundi B.O": "584116",
      "Hosur Siddapur B.O": "584116",
      "Mundargi B.O": "584116",
      "Sunnadakal B.O": "584116",
      "R.H. Colony B.O": "584143",
      "Ragalparvi B.O": "584143",
      "Ramatnal B.O": "584143",
      "Yapalparvi B.O": "584143",
      "Kalapur B.O": "584122",
      "Kalli Lingasugur B.O": "584122",
      "Karadkal B.O": "584122",
      "Kasba Lingasugur B.O": "584122",
      "Mavinabhavi B.O": "584122",
      "Neeralkera B.O": "584122",
      "Santekallur B.O": "584122",
      "Sarjapur B.O": "584122",
      "Raichur H.O": "584101",
      "Gunjahalli S.O": "584140",
      "Maski S.O": "584124",
      "Raichur Jawahar Nagar S.O": "584103",
      "Raichur Patel Road S.O": "584103",
      "Turvihal S.O": "584132",
      "Yeramarus Camp S.O": "584135",
      "Kallur S.O (Raichur)": "584118",
      "Kowthal S.O": "584120",
      "Raichur Mukram Gunj S.O": "584102",
      "Raichur Naya Bazar S.O": "584101",
      "Rodalbanda S.O": "584127",
      "Hutti S.O": "584115",
      "Jalahalli S.O": "584116",
      "Jawalgera S.O": "584143",
      "Kurdi S.O": "584203",
      "Lingasugur Katchery S.O": "584122",
      "Lingasugur S.O": "584122",
      "Matmari S.O": "584202",
      "Mudgal S.O": "584125",
      "Raichur Nijalingappa Nagar S.O": "584101",
      "Raichur R.S. S.O": "584101",
      "Raichur Saath Katchery S.O": "584101",
      "Shaktinagar S.O (Raichur)": "584170",
      "Sirwar S.O": "584129",
      "Yergera S.O": "584133",
      "Balaganur S.O": "584138",
      "Deodurga S.O": "584111",
      "Dhadesugur S.O": "584167",
      "Gabbur S.O": "584113",
      "Gurgunta S.O": "584139",
      "Kalmala S.O": "584136",
      "Manvi S.O": "584123",
      "Mosarkal S.O": "584126",
      "Raichur UAS S.O": "584104",
      "Sindhanur S.O": "584128",
      "Yeramarus S.O": "584134"
    },
    "HAVERI": {
      "Hullatti B.O": "581203",
      "Kalagonda B.O": "581111",
      "Tavaragi B.O": "581111",
      "Handiganur B.O": "581213",
      "Konanatambigi B.O": "581213",
      "Attigeri B.O": "581126",
      "Makanur B.O": "581123",
      "Nadiharalalli B.O": "581123",
      "Guddadamadapur B.O": "581210",
      "Tadakanahalli B.O": "581210",
      "Aremallapur B.O": "581115",
      "Budapanahalli B.O": "581115",
      "Honnatti B.O": "581115",
      "Kakol B.O": "581115",
      "Doddagubbi B.O": "581116",
      "Kanavisiddageri B.O": "581116",
      "Uppunashi B.O": "581148",
      "Hiremaralihalli B.O": "581118",
      "Ichangi B.O": "581237",
      "Kaliwal B.O": "581237",
      "Teggihalli B.O": "581118",
      "Gangebhavi B.O": "581205",
      "Hiremallur B.O": "581205",
      "Mugali B.O": "581205",
      "KJVV Gotagodi B.O": "581205",
      "Attikatti B.O": "581120",
      "Kusanur B.O": "581120",
      "Chikkabbar B.O": "581119",
      "Kotihal B.O": "581119",
      "Alalageri B.O": "581198",
      "Ingalgondi B.O": "581111",
      "Negalur B.O": "581213",
      "Basanal B.O": "581126",
      "Mantrodi B.O": "581126",
      "Kolur B.O": "581112",
      "Mudenur B.O": "581123",
      "Veerapur B.O": "581210",
      "Konanatambagi B.O": "581211",
      "Asundi B.O": "581115",
      "Chikkuravatti B.O": "581115",
      "Kajjari B.O": "581115",
      "Kudapali B.O": "581115",
      "Kadur B.O": "581116",
      "Makari B.O": "581116",
      "Neregal B.O": "581148",
      "Wardi B.O": "581148",
      "Huvinashigli B.O": "581118",
      "Kurubaramallur B.O": "581118",
      "Naikerur B.O": "581237",
      "Tallihalli B.O": "581118",
      "Yalivigi B.O": "581118",
      "Bannur B.O": "581205",
      "Hirebendigeri B.O": "581205",
      "Niralagi B.O": "581108",
      "Chikkabasur B.O": "581120",
      "Kirawadi B.O": "581120",
      "Kuppelur B.O": "581119",
      "Kalledevaru B.O": "581198",
      "Hommaradi B.O": "581110",
      "Kabbur B.O": "581110",
      "Kaginelli B.O": "581110",
      "Kanavalli B.O": "581110",
      "Kallapur B.O": "581102",
      "Kunimellihalli B.O": "581202",
      "Narayanapur B.O": "581202",
      "Yalawatti B.O": "581203",
      "Mallur B.O": "581106",
      "Masanagi B.O": "581106",
      "Hosur B.O": "581193",
      "Bilahalli B.O": "581208",
      "Kunchur B.O": "581208",
      "Ukkund B.O": "581208",
      "Gondi B.O": "581104",
      "Mantagi B.O": "581104",
      "Mudur B.O": "581104",
      "Aralikatti B.O": "581109",
      "Suttakoti B.O": "581109",
      "Yettinahalli B.O": "581109",
      "Halagi B.O": "581213",
      "Kittur B.O": "581213",
      "Hiremugadur B.O": "581112",
      "Kalasur B.O": "581112",
      "Nalavagal B.O": "581123",
      "Anaji B.O": "581210",
      "Belur B.O": "581211",
      "Airani B.O": "581115",
      "Hanumapur B.O": "581115",
      "Haranagiri B.O": "581115",
      "Hirebidari B.O": "581115",
      "Chikkayadachi B.O": "581116",
      "Didagur B.O": "581148",
      "Herur B.O": "581148",
      "Hirehullal B.O": "581148",
      "Hattimattur B.O": "581118",
      "Hesarur B.O": "581237",
      "Huralikoppi B.O": "581118",
      "Jallapur B.O": "581118",
      "Hiremanakatti B.O": "581205",
      "Hosaniralagi B.O": "581205",
      "Kabanur B.O": "581205",
      "Kamanahalli B.O": "581205",
      "Shiggaon Bzr B.O": "581205",
      "Hallur B.O": "581119",
      "Hirekabbar B.O": "581119",
      "Kerimattihalli B.O": "581110",
      "Nelogal B.O": "581110",
      "Balambid B.O": "581101",
      "Kalvekallapur B.O": "581101",
      "Kanchinegalur B.O": "581101",
      "Anandavan B.O": "581128",
      "Budagatti B.O": "581128",
      "Sheshagiri B.O": "581102",
      "Andalagi B.O": "581203",
      "Hotanahalli B.O": "581203",
      "Hungund B.O": "581203",
      "Bisalalli B.O": "581106",
      "Chinnamulagund B.O": "581106",
      "Chinnikatti B.O": "581106",
      "Belivigi B.O": "581108",
      "Havanur B.O": "581108",
      "Kuragund B.O": "581108",
      "Antravalli B.O": "581208",
      "Chikkamagnur B.O": "581208",
      "Itagi B.O": "581123",
      "Joisaraharalalli B.O": "581208",
      "Manakur B.O": "581208",
      "Nesvi B.O": "581208",
      "Araleshwar B.O": "581104",
      "Baichavalli B.O": "581104",
      "Balihalli B.O": "581104",
      "Savasagi B.O": "581199",
      "Shirgod B.O": "581104",
      "Divigihalli B.O": "581109",
      "Hirekonati B.O": "581109",
      "Kod B.O": "581109",
      "Kummur B.O": "581109",
      "Dudihalli B.O": "581111",
      "Gundagatti B.O": "581111",
      "Hadrihalli B.O": "581111",
      "Yalagach B.O": "581213",
      "Chillurbadni B.O": "581126",
      "Choudal B.O": "581126",
      "Karadagi B.O": "581126",
      "Kyalakonda B.O": "581126",
      "Shishuvinhal B.O": "581126",
      "Hiremorab B.O": "581210",
      "Hosakatti B.O": "581210",
      "Medur B.O": "581210",
      "Nagavand B.O": "581210",
      "Choudadanapur B.O": "581115",
      "Devaragudda B.O": "581115",
      "Gudgur B.O": "581115",
      "Hanumanamatti B.O": "581115",
      "Magod B.O": "581115",
      "Ranebennur Eng college B.O": "581115",
      "Sunakalbidari B.O": "581115",
      "Shiragambi B.O": "581116",
      "Challal B.O": "581118",
      "Dombaramattur B.O": "581118",
      "Savanur Bzr B.O": "581118",
      "Shirabadagi B.O": "581118",
      "Siddapur B.O": "581237",
      "Hireanaji B.O": "581120",
      "Hirebasur B.O": "581120",
      "Kachavi B.O": "581120",
      "Kelavarakoppa B.O": "581120",
      "Madlur B.O": "581120",
      "Satenhalli B.O": "581120",
      "Sudambi B.O": "581120",
      "Lingadahalli B.O": "581119",
      "Malanayakanhalli B.O": "581119",
      "Nittur B.O": "581119",
      "Gundenhalli B.O": "581198",
      "Chikkalingadahalli B.O": "581110",
      "Devagiri B.O": "581110",
      "Devihosur B.O": "581110",
      "Haveri V.N. B.O": "581110",
      "Kallihal B.O": "581110",
      "Suraleshwar B.O": "581102",
      "Halebankapur B.O": "581202",
      "Kundur B.O": "581202",
      "Shidenur B.O": "581106",
      "Tadas B.O": "581106",
      "Kamadod B.O": "581145",
      "Karur B.O": "581145",
      "Chandapur B.O": "581193",
      "Konanakeri B.O": "581193",
      "Kunnur B.O": "581193",
      "Kusagur B.O": "581208",
      "Hirur B.O": "581104",
      "Chikkerur B.O": "581111",
      "Karagudri B.O": "581199",
      "Konanakoppa B.O": "581104",
      "Kopparshikoppa B.O": "581104",
      "Buradikatti B.O": "581111",
      "Aladakatti B.O": "581110",
      "Hedigonda B.O": "581110",
      "Ijarilakmapur B.O": "581110",
      "Katenhalli B.O": "581110",
      "Kurubagonda B.O": "581110",
      "Maranbid B.O": "581101",
      "Akkialur Bazar B.O": "581102",
      "Havanagi B.O": "581102",
      "Shadaguppi B.O": "581102",
      "Naganur B.O": "581202",
      "Tevaramellihalli B.O": "581202",
      "Kadaramandalagi B.O": "581106",
      "Keravadi B.O": "581106",
      "Basapur B.O": "581108",
      "Kancharagatti B.O": "581108",
      "Benakankonda B.O": "581208",
      "Hediyal B.O": "581208",
      "Chikkaunshihosur B.O": "581104",
      "Hirekanagi B.O": "581104",
      "Masanakatti B.O": "581199",
      "Sammasagi B.O": "581104",
      "Aladgeri B.O": "581109",
      "Betakerur B.O": "581109",
      "Muttur B.O": "581109",
      "Channalli` B.O": "581111",
      "Haveri H.O": "581110",
      "Akkialur S.O": "581102",
      "Hangal S.O": "581104",
      "Haveri B.S. S.O": "581110",
      "Karajagi S.O (Haveri)": "581112",
      "Kumarapattanam S.O": "581123",
      "Ranebennur S.O": "581115",
      "Tadas S.O": "581212",
      "Motebennur S.O": "581198",
      "Adur S.O (Haveri)": "581101",
      "Bankapur S.O": "581202",
      "Bommanahalli S.O (Haveri)": "581203",
      "Byadgi S.O": "581106",
      "Chalageri S.O": "581145",
      "Dhundashi S.O": "581193",
      "Haunsabhavi S.O": "581109",
      "Haveri Bazar S.O": "581110",
      "Hirekerur S.O": "581111",
      "Hulgur S.O": "581126",
      "Masur S.O (Haveri)": "581210",
      "Ranebennur Bzr S.O": "581115",
      "Rattihalli S.O": "581116",
      "Shiggaon S.O": "581205",
      "Guttal S.O": "581108",
      "Haveri R.N. S.O": "581110",
      "Hosaritti S.O": "581213",
      "Sangur S.O": "581148",
      "Tilavalli S.O": "581120",
      "Belagalapete S.O.": "581199",
      "Agadi S.O": "581128",
      "Byadgi N.N. S.O": "581106",
      "Halageri S.O": "581208",
      "Medleri S.O": "581211",
      "Ranebennur Extn S.O": "581115",
      "Savanur S.O": "581118",
      "Tumminakatti S.O": "581119",
      "Kadkol S.O": "581237"
    },
    "CHIKKABALLAPURA": {
      "Oolavadi B.O": "563125",
      "Konapalli B.O": "563125",
      "Mylandahalli B.O": "563125",
      "N. Kothur B.O": "563125",
      "Nadampalli B.O": "563125",
      "Ammanallur B.O": "563128",
      "Talagavara B.O": "563128",
      "GUDAMARLAHALLI B.O": "563146",
      "Settihalli B.O": "563125",
      "Ullappanahalli B.O": "563125",
      "Yenigadale B.O": "563125",
      "Chinnsandra B.O": "563125",
      "Hirekattigenahalli B.O": "563128",
      "Kagathi B.O": "563146",
      "Peddur B.O": "563146",
      "Yagavakote B.O": "563146",
      "Gorthapalli B.O": "561207",
      "Hosahudya B.O": "561207",
      "Kotegal B.O": "563125",
      "Mindigal B.O": "563125",
      "T. Gollahalli B.O": "563125",
      "Bommekallu B.O": "563128",
      "Santhekallahalli B.O": "563128",
      "Immareddipalli B.O": "563146",
      "Nandiganahalli B.O": "563146",
      "Billur B.O": "563124",
      "Palyakere B.O": "563124",
      "Rasicheruvu B.O": "563124",
      "Kethenahalli B.O": "562101",
      "Namagondlu B.O": "561206",
      "Chandandur B.O": "561208",
      "Doddakurugodu B.O": "561208",
      "Hampasandra B.O": "561210",
      "Ullodu B.O": "561209",
      "Kenkere B.O": "561210",
      "Halehalli B.O": "561211",
      "Jarabandahalli B.O": "561211",
      "BHAKTHARAHALLI B.O": "562102",
      "HEMARALAHALLI B.O": "562102",
      "Nagamangala B.O": "562102",
      "Doddamarali B.O": "562103",
      "Srirampura B.O": "562103",
      "Naremaddepalli B.O": "561212",
      "Somenahalli B.O": "562104",
      "Tirumani B.O": "562104",
      "Devaramallur B.O": "562105",
      "Pallicherlu B.O": "562105",
      "Gadare Bommasandra B.O": "561213",
      "Jeelakunte B.O": "561228",
      "Nakkalahalli B.O": "561228",
      "Venkatapura B.O": "562102",
      "Avalagurki B.O": "562101",
      "Dibbur B.O": "562101",
      "GANGARAKALVE B.O": "562101",
      "Gerehalli B.O": "562101",
      "Jathavara B.O": "562101",
      "Maralakunte B.O": "562101",
      "Nandi Hills B.O": "562101",
      "Patrenahalli B.O": "562101",
      "Gangasandra B.O": "561208",
      "H. Nagasandra B.O": "561208",
      "Halaganahalli B.O": "561208",
      "Hirebidanur B.O": "561208",
      "Melya B.O": "561208",
      "Vidurashwatha B.O": "561208",
      "Yidagur B.O": "561208",
      "Haleupparahalli B.O": "561210",
      "Sonaganahalli B.O": "561210",
      "Varlakonda B.O": "562104",
      "Ablodu B.O": "562105",
      "Alipura B.O": "561213",
      "Kamaganahalli B.O": "561213",
      "Pothenahalli B.O": "561213",
      "Taridalu B.O": "561213",
      "Thondebhavi Old Town B.O": "561213",
      "Huduguru B.O": "561206",
      "Bychapura B.O": "561208",
      "Beechaganahalli B.O": "561209",
      "Cholasettyhalli B.O": "561209",
      "Chowtakuntapalli B.O": "561209",
      "Dapparthi B.O": "561209",
      "Kurudi B.O": "561210",
      "Ramapura B.O": "561210",
      "Balakuntanahalli B.O": "561211",
      "Bislahalli B.O": "561211",
      "Pura B.O": "561211",
      "Varavani B.O": "561211",
      "Keshavara B.O": "562102",
      "Malamachanahalli B.O": "562102",
      "Kalavara B.O": "562103",
      "Kandavara B.O": "562103",
      "Kondenahalli B.O": "562103",
      "Kuduvathi B.O": "562103",
      "Somanathapura B.O": "561212",
      "Tholapalli B.O": "561212",
      "JILIPIGARIPALLI B.O": "561212",
      "CHIKKAPAYALAGURKI B.O": "562104",
      "Hirenagavalli B.O": "562104",
      "Mandikallu B.O": "562104",
      "S.Devaganahalli B.O": "562104",
      "Anemadagu B.O": "562105",
      "Basettihalli B.O": "562105",
      "Kothnur B.O": "562105",
      "Kundlagurki B.O": "562105",
      "Thippenahalli B.O": "562103",
      "Alakapura B.O": "561213",
      "Gundlakothur B.O": "561228",
      "Chenchurayanapalli B.O": "561207",
      "Chendur B.O": "561207",
      "Naravalapalli B.O": "561207",
      "NEERAGANTIPALLI B.O": "561207",
      "Paragodu B.O": "561207",
      "Thimmampalli B.O": "561207",
      "Chakavelu B.O": "563124",
      "Puligal B.O": "563124",
      "Ajjavara B.O": "562101",
      "Gundlagurki B.O": "562101",
      "Kanganahalli B.O": "562101",
      "MANCHANABELE B.O": "562101",
      "Muddenahalli B.O": "562101",
      "Kadabur B.O": "561206",
      "Chikkakurugodu B.O": "561208",
      "Kalludi B.O": "561208",
      "Ramapatna B.O": "561209",
      "Kadalaveni B.O": "561210",
      "Gowdagere B.O": "561211",
      "Posettihalli B.O": "561211",
      "Cheemangala B.O": "562102",
      "Jangamkote B.O": "562102",
      "Mallur B.O": "562102",
      "Agalagurki B.O": "562103",
      "Aruru B.O": "562104",
      "Sadali B.O": "562104",
      "Someshwara B.O": "562104",
      "Yelegere B.O": "562104",
      "Dibburhalli B.O": "562105",
      "Bevinahalli B.O": "561213",
      "Gadre B.O": "561213",
      "Kallinayakanahalli B.O": "561213",
      "Nagaragere B.O": "561228",
      "Thokalahalli B.O": "561228",
      "Mallasandra B.O": "561207",
      "Maraganakunte B.O": "561207",
      "Mittemari B.O": "561207",
      "Julapalya B.O": "563159",
      "Mittahalli B.O": "563159",
      "Papathimmanahalli B.O": "563159",
      "Anoor B.O": "563125",
      "Chilakalanerpu B.O": "563125",
      "Doddaganjur B.O": "563125",
      "Mudlagollahalli B.O": "563123",
      "Yenumalapadi B.O": "563123",
      "Ganjigunte B.O": "563125",
      "Kallahalli B.O": "563125",
      "Gulur B.O": "561207",
      "Kothakote B.O": "561207",
      "Nallappareddipalli B.O": "561207",
      "Yallampalli B.O": "561207",
      "Raghuttahalli B.O": "563123",
      "E. Thimmasandra B.O": "563159",
      "Korlaparthi B.O": "563159",
      "Polinayakanahalli B.O": "563159",
      "Chandrahalli B.O": "563125",
      "Kencharlahalli B.O": "563125",
      "Irgampalli B.O": "563123",
      "Kadadanamari B.O": "563123",
      "Kodigal B.O": "563123",
      "Chickballapur H.O": "562101",
      "Gudibanda S.O (Kolar)": "561209",
      "Peresandra S.O": "562104",
      "Chintamani Market S.O": "563125",
      "Chintamani S.O": "563125",
      "Bagepalli S.O": "561207",
      "Sidlagatta Bazar S.O": "562105",
      "Thondebhavi S.O": "561213",
      "Town Hall Sqaure S.O": "562101",
      "Vatadahosahalli S.O": "561228",
      "Batlahalli S.O": "563123",
      "Burudugunte S.O": "563159",
      "Chintamani Bazar S.O": "563125",
      "Chelur S.O (Kolar)": "563124",
      "Chickballapur Mandy Bazarr S.O": "562101",
      "Gauribidanur S.O": "561208",
      "Melur S.O (Kolar)": "562102",
      "Nandi S.O (Kolar)": "562103",
      "Pathapalya S.O": "561212",
      "SUBBARAYANAPET S.O": "562101",
      "Dn Palya S.O": "561206",
      "Gauribidanur Bzr S.O": "561208",
      "Hossur S.O": "561210",
      "MANCHENAHALLI S.O": "561211",
      "Sidlaghatta S.O": "562105",
      "Murugamale S.O": "563146",
      "Kaiwara S.O": "563128"
    }
  },
  "MADHYA PRADESH": {
    "Niwari": {
      "Kudar B.O": "472445",
      "Bhitari B.O": "472445",
      "Shaktibheron B.O": "472445",
      "Papawani B.O": "472337",
      "Kulua B.O": "472442",
      "Mudara B.O": "472442",
      "Pohakhas B.O": "472442",
      "Sunoniya B.O": "472246",
      "Ladwari B.O": "472336",
      "Sakerabhadaran B.O": "472336",
      "Ubora B.O": "472445",
      "Astari B.O": "472447",
      "Beersagar B.O": "472337",
      "Kakwni B.O": "472337",
      "Binwara B.O": "472442",
      "Harsmau B.O": "472442",
      "Chakarpur B.O": "472246",
      "Kumarra B.O": "472246",
      "Mohanpura B.O": "472246",
      "Dumduma B.O": "472336",
      "Jer B.O": "472336",
      "Khiston B.O": "472336",
      "Bijore B.O": "472445",
      "Luharguwn B.O": "472337",
      "Simra B.O": "472337",
      "Asati B.O": "472442",
      "Gidkhini B.O": "472442",
      "Bangain B.O": "472246",
      "Jugiyai B.O": "472246",
      "Madore B.O": "472246",
      "Pratappura B.O": "472246",
      "Banjaripura B.O": "472336",
      "Jeoramora B.O": "472336",
      "Madia B.O": "472336",
      "Naguwan B.O": "472336",
      "Thona B.O": "472445",
      "Sendri BO": "472445",
      "Bahera B.O": "472447",
      "Guawali B.O": "472447",
      "Puchikarguwan B.O": "472445",
      "Ghoogsi B.O": "472447",
      "Jikhanguwan B.O": "472447",
      "Bhopalpur B.O": "472337",
      "Jerakhas B.O": "472337",
      "Basoba B.O": "472246",
      "Bhelsa B.O": "472246",
      "Dhilla B.O": "472246",
      "Birorakhet B.O": "472336",
      "Chomokhas B.O": "472336",
      "Daretha B.O": "472336",
      "Patharam B.O": "472445",
      "Prithvipur S.O": "472336",
      "Teharka S.O": "472447",
      "Taricharkala S.O": "472445",
      "Jeron S.O": "472337",
      "Niwari S.O": "472442",
      "Orchha S.O": "472246"
    },
    "PANNA": {
      "Barsobha B.O": "488059",
      "Deoriranwana B.O": "488059",
      "Pali B.O": "488059",
      "Bilgarhi B.O": "488059",
      "Itwankala B.O": "488059",
      "Hardwahi B.O": "488059",
      "Baharasar B.O": "488441",
      "Badwara B.O": "488333",
      "Bhilsain B.O": "488333",
      "Gurdinpurwa B.O": "488222",
      "Khora B.O": "488222",
      "Garhi padariya B.O": "488050",
      "Richhora B.O": "488059",
      "Sungraha B.O": "488448",
      "Dahlan  Chowki BO": "488001",
      "Dwari B.O": "488001",
      "Kunjwan B.O": "488001",
      "Mandla B.O": "488001",
      "Tarajharukuwan B.O": "488001",
      "Hathkuri B.O": "488446",
      "Simarakala B.O": "488446",
      "Kachori B.O": "488448",
      "Lamtara B.O": "488448",
      "Sarangpur B.O": "488448",
      "BANAULI B.O": "488442",
      "Barkheda B.O": "488442",
      "Jhaladumari B.O": "488443",
      "Khamariya B.O": "488442",
      "Itwan Khas B.O": "488001",
      "Jamuniyai B.O": "488001",
      "Janakpur B.O": "488001",
      "Karhi B.O": "488446",
      "Murachh B.O": "488446",
      "Narayanpura B.O": "488446",
      "Raiguwan B.O": "488446",
      "Simari B.O": "488446",
      "Tikariya B.O": "488446",
      "Ama B.O": "488448",
      "Bori B.O": "488448",
      "Rampur B.O": "488448",
      "Dhanwara B.O": "488442",
      "Ganjabdagaon B.O": "488443",
      "Hirapur B.O": "488442",
      "Banahari Kala B.O": "488220",
      "Deogaon B.O": "488220",
      "Hardi B.O": "488220",
      "Madhavganj B.O": "488220",
      "Selona B.O": "488220",
      "Sabdua B.O": "488220",
      "Jharkuwan Khurd B.O": "488441",
      "Kamtana B.O": "488441",
      "Sunwani Kala B.O": "488441",
      "Bhitrimutmuri B.O": "488333",
      "Dadwaria B.O": "488333",
      "Kalda B.O": "488333",
      "Pondi B.O": "488333",
      "Kiratpur B.O": "488222",
      "Manipur B.O": "488222",
      "Nayagaon B.O": "488222",
      "Baramajhguwan B.O": "488220",
      "Barkola B.O": "488220",
      "Bhapatpura Kurmiyana B.O": "488220",
      "Bira B.O": "488220",
      "Nawasta B.O": "488220",
      "Padaraha B.O": "488220",
      "Pharswaha B.O": "488220",
      "Pista B.O": "488220",
      "Boda B.O": "488441",
      "Jijgaon B.O": "488441",
      "Pagara B.O": "488441",
      "Piperwaha B.O": "488441",
      "Badagaon B.O": "488333",
      "Girwara B.O": "488333",
      "Jigdaha B.O": "488333",
      "Patnatamoli B.O": "488333",
      "Saleha B.O": "488333",
      "Sundara B.O": "488333",
      "Lahargawan B.O": "488059",
      "Mudwari B.O": "488059",
      "Nachnora B.O": "488050",
      "Paderi B.O": "488050",
      "Sakariya B.O": "488050",
      "Umari B.O": "488059",
      "Ahirgawan B.O": "488001",
      "Bargarhi Camp B.O": "488001",
      "Laxmipur B.O": "488001",
      "Majhgawan Diamond Mines  B.O": "488001",
      "Pahadi khera B.O": "488001",
      "Ramkheria B.O": "488001",
      "Samana B.O": "488050",
      "Manaur B.O": "488001",
      "Birsinghpur B.O": "488446",
      "Sikarpura B.O": "488446",
      "Khamariya Bori B.O": "488448",
      "Nanchand B.O": "488448",
      "Purena B.O": "488441",
      "Adhrod B.O": "488443",
      "Baghwar B.O": "488443",
      "Bagrod B.O": "488443",
      "Madwa B.O": "488442",
      "Maharajganj B.O": "488442",
      "Mohendra B.O": "488442",
      "Mahod B.O": "488442",
      "Patnakala B.O": "488442",
      "Aramganj B.O": "488220",
      "Bilha B.O": "488050",
      "Patnakalan B.O": "488059",
      "Sathniya B.O": "488059",
      "Brijpur B.O": "488001",
      "Diya B.O": "488001",
      "Harduwa Camp B.O": "488001",
      "Jaswantpura B.O": "488001",
      "Itain B.O": "488446",
      "Kriishangarh B.O": "488446",
      "Padariyakala B.O": "488446",
      "Bisani B.O": "488448",
      "Gajanda B.O": "488448",
      "Rohaniya B.O": "488448",
      "Sudore B.O": "488448",
      "Bari B.O": "488442",
      "Deori B.O": "488442",
      "JarguwanB.O": "488443",
      "Kariya B.O": "488442",
      "Baroli B.O": "488220",
      "Chandora B.O": "488220",
      "Deorabhapatpur B.O": "488220",
      "Kunwarpur B.O": "488220",
      "Singhpur B.O": "488220",
      "Maheba B.O": "488441",
      "Tai B.O": "488441",
      "Birwahi B.O": "488333",
      "Ganj B.O": "488333",
      "Kathbariya B.O": "488333",
      "Syamardada B.O": "488333",
      "Amerchhi B.O": "488222",
      "Makhanpur B.O": "488222",
      "Nandanpura B.O": "488222",
      "Nardaha B.O": "488222",
      "Barrach B.O": "488059",
      "Dharampur S.O": "488222",
      "Simariya S.O": "488442",
      "Amanganj S.O": "488441",
      "Gunour S.O": "488059",
      "Kakrehti S.O": "488050",
      "Panna MDG S.O": "488001",
      "Shahnagar S.O": "488448",
      "Ajaigarh S.O": "488220",
      "Devendra Nagar S.O": "488333",
      "Panna Collectrate S.O": "488001",
      "Pawai S.O": "488446",
      "Raipura S.O": "488443"
    },
    "SEONI": {
      "Jhinjhrai B.O.": "480997",
      "Jam B.O": "480661",
      "Amgaon B.O": "480661",
      "Chawadi B.O": "480661",
      "Pipardahi B.O": "480661",
      "Jaitpur Kala B.O": "480661",
      "Mugwani Kala B.O": "480661",
      "Chakki Khamariya B.O": "480661",
      "Gorakhpur B.O": "480886",
      "Jhiri B.O": "480887",
      "Madhi B.O": "480887",
      "Darasikala B.O": "480771",
      "Neewari B.O": "480771",
      "Dighori B.O": "480882",
      "Gohana B.O": "480882",
      "Kalarbanki B.O": "480882",
      "Dharnakala B.O": "480667",
      "Khami B.O": "480996",
      "Khunt B.O": "480667",
      "Malara B.O": "480667",
      "Nandora B.O": "480667",
      "Pathadeori B.O": "480888",
      "Sanaidongari B.O": "480888",
      "Ghotkheda B.O": "480997",
      "Kindarai B.O": "480997",
      "Manegaon B.O": "480997",
      "Begarwani B.O": "480999",
      "Chutka B.O": "480990",
      "Hinotiya B.O": "480990",
      "Khairi B.O": "480990",
      "Bandeli B.O": "480994",
      "Dhutera B.O": "480991",
      "Dokarranjhi B.O": "480991",
      "Lopa B.O": "480991",
      "Chandarpur B.O": "480880",
      "Patan B.O": "480887",
      "Pindrai  Buttey B.O": "480880",
      "Bamhanwada B.O": "480886",
      "Deorikala B.O": "480886",
      "Gangai B.O": "480886",
      "Purwamal B.O": "480886",
      "Sirmangani B.O": "480886",
      "Durenda B.O": "480996",
      "Jewnara B.O": "480996",
      "Suktara B.O": "480661",
      "Tighra B.O": "480661",
      "Badalpar B.O": "480661",
      "Marbodi B.O": "480661",
      "Sillore B.O": "480661",
      "Bordai B.O": "480661",
      "Belpeth B.O": "480661",
      "Chamari(khurd) B.O": "480887",
      "Mohgaon Kachhi B.O": "480887",
      "Amagarh B.O": "480771",
      "Dhapara B.O": "480771",
      "Tikari B.O": "480771",
      "Bakodi B.O": "480882",
      "Bhongakheda B.O": "480882",
      "Pondi jaharmau B.O": "480882",
      "Bamhani B.O": "480667",
      "Borikala B.O": "480667",
      "Jeonara B.O": "480667",
      "Kesalekala B.O": "480667",
      "Pindraikala B.O": "480667",
      "Bakoda Seoni B.O": "480884",
      "Sadak Seoni B.O": "480884",
      "Ghurwara B.O": "480888",
      "Khut khamaria B.O": "480888",
      "Ataria B.O": "480997",
      "Bewhari B.O": "480997",
      "Salhepani B.O": "480997",
      "Piparia Bhasunda B.O": "480999",
      "Bhoma B.O": "480990",
      "Piparia Bhoma B.O": "480990",
      "Udepani B.O": "480990",
      "Dobh B.O": "480994",
      "Gangatola B.O": "480994",
      "Keolari Kheda B.O": "480994",
      "Kohka B.O": "480994",
      "Kumhada B.O": "480994",
      "Khapa Bazar B.O": "480991",
      "Turia B.O": "480881",
      "Karanpur B.O": "480886",
      "Mohgaon Kala B.O": "480886",
      "Khursara B.O": "480996",
      "Rumal B.O": "480996",
      "Palari chhidiya B.O": "480661",
      "Rajola B.O": "480661",
      "Binjhawada B.O": "480661",
      "Fulara B.O": "480661",
      "Gopalganj B.O": "480661",
      "Hathnapur B.O": "480661",
      "Karirat B.O": "480661",
      "Parasiya B.O": "480887",
      "Dondiwada B.O": "480771",
      "Gokalpur B.O": "480771",
      "Nayegaon B.O": "480771",
      "Aloniya B.O": "480882",
      "Bakhari B.O": "480882",
      "Antara B.O": "480667",
      "Ashta B.O": "480667",
      "Atari B.O": "480667",
      "Behrai B.O": "480667",
      "Salhe khurd B.O": "480667",
      "Salhekosmi B.O": "480667",
      "Bhimgarh B.O": "480884",
      "Bhimgarh Project B.O": "480884",
      "Deogaon B.O": "480884",
      "Hardoli B.O": "480884",
      "Baigapiparia B.O": "480888",
      "Banjari B.O": "480888",
      "Dankakadi B.O": "480888",
      "Dargada B.O": "480888",
      "Jhurki B.O": "480997",
      "Kedarpur B.O": "480997",
      "Khamaria Bazar B.O": "480997",
      "Paddikona B.O": "480997",
      "Pahadi B.O": "480997",
      "Barelaghat B.O": "480999",
      "Baroda B.O": "480999",
      "Ganeri B.O": "480999",
      "Ghatpipariya B.O": "480999",
      "Chhindbarri B.O": "480990",
      "Chhui B.O": "480990",
      "Baghai B.O": "480994",
      "Gwaria B.O": "480994",
      "Tinduwa B.O": "480994",
      "Pipariya Kala B.O": "480991",
      "Sarekha B.O": "480991",
      "Khandasa B.O": "480881",
      "Pindrai B.O": "480881",
      "Piparwani B.O": "480881",
      "Riddi B.O": "480881",
      "Kareli B.O": "480886",
      "Khamaria Gosai B.O": "480886",
      "Jhittarra B.O": "480996",
      "Pandiwada B.O": "480996",
      "Pandiya Chhapara B.O": "480996",
      "Sarekha Kala B.O": "480996",
      "Sonkhar B.O": "480996",
      "Vijaypani B.O": "480661",
      "Bamhodi B.O": "480661",
      "Sindaria B.O": "480661",
      "Imaliya Raitwar B.O": "480887",
      "Birholi B.O": "480771",
      "Sukla B.O": "480771",
      "Takhalakala B.O": "480771",
      "Banki B.O": "480882",
      "Chandori(khurd) B.O": "480882",
      "Sihora BO": "480882",
      "Budhenakala B.O": "480667",
      "Dhobisarra B.O": "480661",
      "Gondegaon B.O": "480667",
      "Kekdai B.O": "480667",
      "Poniya B.O": "480667",
      "Anjania B.O": "480884",
      "Sunwara B.O": "480884",
      "Deori B.O": "480888",
      "Khairnara B.O": "480888",
      "Nagandeori B.O": "480888",
      "Chargaon B.O": "480888",
      "Balpur B.O": "480997",
      "Barela B.O": "480997",
      "Diwari B.O": "480997",
      "Khatiya B.O": "480997",
      "Sikara B.O": "480997",
      "Mehta B.O": "480999",
      "Sajpani dhanora B.O": "480999",
      "Kanhan Piparia B.O": "480990",
      "Baglai B.O": "480994",
      "Chhinda B.O": "480994",
      "Khairlanji B.O": "480994",
      "Kharsaru B.O": "480994",
      "Tali B.O": "480994",
      "Kudari Maghgaon B.O": "480991",
      "Panjara B.O": "480991",
      "Ramli B.O": "480880",
      "Ganesh Ganj B.O": "480886",
      "Sihora B.O": "480886",
      "Banathar B.O": "480996",
      "Mohbarra B.O": "480996",
      "Sakri B.O": "480996",
      "Seoni H.O": "480661",
      "Bandol S.O": "480882",
      "Barghat S.O": "480667",
      "Keolari S.O": "480994",
      "Khawasa S.O (Seoni)": "480881",
      "Korai S.O": "480880",
      "Lakhnadon S.O": "480886",
      "Seoni Barapathar S.O": "480661",
      "Ugli S.O": "480996",
      "Chhapara S.O": "480884",
      "Kanhiwada S.O": "480990",
      "Seoni City S.O": "480661",
      "Dhuma S.O": "480888",
      "Adegaon S.O": "480887",
      "Ari S.O": "480771",
      "Ghansore S.O": "480997",
      "Kahani S.O": "480999",
      "Khairapalari S.O": "480991"
    },
    "RAISEN": {
      "Panjra B.O": "464770",
      "Amkheda B.O": "464573",
      "Hinotia Mahalpur B.O": "464573",
      "Lilgawan B.O": "464573",
      "Mudiakheda B.O": "464573",
      "Bishankhedi B.O": "464993",
      "Dewatia B.O": "464993",
      "Iklama B.O": "464993",
      "Premtalab B.O": "464993",
      "Salkani B.O": "464993",
      "Barkheda R.S B.O": "464993",
      "Banskheda B.O": "464661",
      "Mendki B.O.": "464661",
      "Ucher B.O": "464661",
      "Ashapuri B.O": "464993",
      "Polaha B.O": "462046",
      "Ankalpur B.O": "464993",
      "Bhojpur B.O": "464993",
      "Pipaliapuaria B.O": "464770",
      "Narwar B.O": "464573",
      "Tarawali I B.O": "464573",
      "Satalapur B.O": "462046",
      "Bilakhedi B.O": "464993",
      "Dahod B.O": "464993",
      "Noorganj B.O": "464993",
      "Uradmau B.O": "464770",
      "Chandpur B.O": "464573",
      "Kanth B.O": "464573",
      "Gulgaon B.O": "464661",
      "Pathari B.O": "464551",
      "Bankhedi B.O": "464573",
      "Andol B.O": "464551",
      "Sanchet B.O": "464551",
      "Gudawal B.O": "464551",
      "Karhod B.O": "464551",
      "Khandera B.O": "464551",
      "Manpur B.O": "464551",
      "Collectorate Raisen B.O": "464551",
      "Amrawad B.O": "464665",
      "Gadarwas B.O.": "464665",
      "Harsili B.O": "464665",
      "Kanwar B.O": "464665",
      "Sankheda B.O": "464665",
      "Kuchwada B.O": "464672",
      "Kundali B.O": "464672",
      "SIMARIYAKHURD B.O": "464672",
      "Aliganj B.O": "464668",
      "Bagalwada B.O": "464668",
      "Kotpar Ganesh B.O.": "464668",
      "Karamwada B.O": "464668",
      "Umraoganj B.O": "464551",
      "Makhni B.O": "464551",
      "Nand B.O": "464551",
      "Sewasini B.O": "464551",
      "Bankhedi Baramad  B.O": "464551",
      "Keolajhir B.O": "464665",
      "Keeratpur B.O": "464672",
      "Doomar B.O": "464668",
      "Untiyakala B.O": "464668",
      "Bhainsa B.O": "464570",
      "Bhureru B.O": "464881",
      "Chandoria B.O": "464881",
      "Chandwad B.O": "464881",
      "Rajpura B.O": "464881",
      "Sumer B.O": "464881",
      "Magardha B.O": "464668",
      "Maheshwar B.O": "464668",
      "Markhedatappa B.O": "464881",
      "Mundlachawal B.O": "464881",
      "Naigadhiya B.O": "464570",
      "Padajhir B.O": "464881",
      "Richawar B.O": "464774",
      "Timrawan B.O": "464774",
      "Agariakalan B.O": "464884",
      "Bamhorigodad B.O": "464884",
      "Genhuras B.O": "464884",
      "Chiklod B.O": "464990",
      "Begania B.O": "464671",
      "Anghora B.O": "464776",
      "Kaniwada B.O": "464776",
      "Kenkda B.O": "464776",
      "Berkhedi B.O": "464651",
      "Deewanganj B.O": "464651",
      "Jamunia B.O": "464651",
      "Mehgaon B.O": "464651",
      "Muar B.O": "464886",
      "Sainkheda B.O": "464886",
      "Bagaspur B.O": "464986",
      "Champaner B.O": "464986",
      "Chorakamrora B.O": "464986",
      "Bhadon B.O": "464770",
      "Chatter B.O": "464770",
      "Choras B.O": "464770",
      "Tarawali II B.O": "464551",
      "Dabraimalia B.O": "464551",
      "Murelkhurd B.O": "464551",
      "Salera B.O": "464551",
      "Sadalatpur B.O": "464551",
      "Bharkatchh B.O": "464665",
      "Khapariyakalan B.O": "464665",
      "Kutnasir B.O": "464665",
      "Mokalwada B.O": "464665",
      "Dimada B.O": "464668",
      "Kamtone B.O": "464668",
      "Panjrakashiram B.O": "464668",
      "Udaigiri B.O": "464668",
      "Bamhorititore B.O": "464570",
      "Begumganj Tahsil B.O": "464881",
      "Dhuwaj B.O": "464881",
      "Gulwada B.O": "464570",
      "Kunda B.O": "464570",
      "Parsora B.O": "464881",
      "Pipaliabicholi B.O": "464570",
      "Ratanhari B.O": "464570",
      "Aliwada B.O": "464774",
      "Chikhli B.O": "464774",
      "Jaithari B.O": "464886",
      "Pratapgarh B.O": "464886",
      "Deoriganj B.O": "464884",
      "Tamot B.O": "464990",
      "Chhabara B.O": "464671",
      "Noornagar B.O": "464671",
      "Rajwada B.O": "464671",
      "Pagneshwar B.O": "464651",
      "Semra Jagir B.O": "464651",
      "Bamhoriwardha B.O": "464886",
      "Chicholi B.O": "464886",
      "Siyarmau B.O": "464886",
      "Khapariakhapa B.O": "464986",
      "Palakmati B.O": "464986",
      "Bamhoribhuari B.O": "464770",
      "Ghanabahedia B.O": "464770",
      "Sunhera B.O": "464881",
      "Sunwaha B.O": "464570",
      "Tulsipar B.O": "464672",
      "Barkhanda B.O": "464774",
      "Berua B.O": "464886",
      "Beekalpur B.O": "464886",
      "Booda B.O": "464774",
      "Jujharpur B.O": "464884",
      "Papda B.O": "464884",
      "Rampurakalan B.O": "464884",
      "Samnapurkalan B.O": "464884",
      "Bhondiya B.O": "464671",
      "Satehri B.O": "464776",
      "Thala B.O": "464776",
      "Kheri B.O": "464886",
      "Menhgwankalan B.O": "464886",
      "Kewatpiparia B.O": "464770",
      "Ketoghan B.O": "464770",
      "Noniabareli B.O": "464770",
      "Bangawan B.O": "464551",
      "RAF Camp Hinotia B.O": "464551",
      "Kharwai B.O": "464551",
      "Paimat B.O": "464551",
      "Mungalia B.O": "464551",
      "Badikalan B.O": "464665",
      "Gugalwada B.O": "464665",
      "Mankapur B.O": "464665",
      "Nanpone B.O": "464665",
      "Akola B.O": "464668",
      "Bagpiparia B.O": "464668",
      "Chainpur B.O": "464668",
      "Mangrole B.O": "464668",
      "Samnapur B.O": "464668",
      "Badgawan B.O": "464881",
      "Beerpur B.O": "464881",
      "KhajuriaBaramadGari B.O": "464881",
      "Markhedagulab B.O": "464570",
      "Padariarajdhar B.O": "464570",
      "Umarkhoh B.O": "464881",
      "Gorakhpur B.O": "464774",
      "Katak B.O": "464774",
      "Padraikalan B.O": "464774",
      "Andhiyari B.O": "464884",
      "Garhi B.O": "464884",
      "Hardot B.O": "464884",
      "Tekapargarhi B.O": "464884",
      "Chandlakhedi B.O": "464990",
      "Murahari B.O": "464990",
      "Jamgarh B.O": "464671",
      "Ramkhiria B.O": "464776",
      "Parwaria B.O": "464651",
      "Amapani B.O": "464886",
      "Chunhetia B.O": "464886",
      "Sodarpur B.O": "464886",
      "Intkhedi B.O": "464986",
      "Manjooshkalan B.O": "464986",
      "Barhakalan B.O": "464770",
      "Boras B.O": "464770",
      "Gaibiyan B.O": "464770",
      "Raisen H.O": "464551",
      "Khargone S.O": "464671",
      "Panjra S.O": "464776",
      "Silwani S.O": "464886",
      "Bamhori S.O": "464672",
      "Goharganj S.O": "464990",
      "Udaipura S.O": "464770",
      "Badi S.O": "464665",
      "Begumganj S.O": "464881",
      "Deori S.O (Raisen)": "464774",
      "Gairatganj S.O": "464884",
      "Sultanganj SO": "464570",
      "Bareli S.O": "464668",
      "Salamatpur Mandi S.O": "464651",
      "Sultanpur S.O (Raisen)": "464986",
      "Dehgaon S.O": "464573",
      "Sanchi S.O": "464661",
      "Mandideep S.O": "462046",
      "Obedullaganj S.O": "464993"
    },
    "DHAR": {
      "Sodpur B.O": "454010",
      "Talwada B.O": "454331",
      "Lingwa B.O": "454335",
      "Lohari B.O": "454335",
      "Nanoda B.O": "454335",
      "Bhangarh B.O": "454116",
      "Bhopawar B.O": "454111",
      "Jolana B.O": "454111",
      "Khareli B.O": "454111",
      "Labriya B.O": "454111",
      "Ledgaon B.O": "454111",
      "Salwa B.O": "454111",
      "Sarai B.O": "454010",
      "Bhavria B.O": "454335",
      "Kadmal B.O": "454335",
      "Limbol B.O": "454335",
      "Narmadanagar B.O": "454335",
      "Kunwarsi B.O": "454774",
      "Sagore B.O": "454774",
      "Bimrod B.O": "454116",
      "Chhadawad B.O": "454116",
      "Chikhalda B.O": "454335",
      "Sulawad B.O": "454774",
      "Dhulet B.O": "454116",
      "Gumanpura B.O": "454116",
      "Kunjrota B.O": "454116",
      "Mohankheda B.O": "454116",
      "Timaichi B.O": "454116",
      "Tirla B.O": "454116",
      "TIRLA B.O": "454001",
      "Deshwalia B.O": "454335",
      "Konda B.O": "454335",
      "Mandvi B.O": "454335",
      "Piplia B.O": "454335",
      "Sirsi B.O": "454335",
      "Khandwa B.O": "454774",
      "Mandlawada B.O": "454774",
      "Chalnimata B.O": "454116",
      "Dattigaon B.O": "454116",
      "Narwali B.O": "454116",
      "Ringnod B.O": "454116",
      "Badodiya B.O": "454111",
      "Barmandal B.O": "454111",
      "Bola B.O": "454111",
      "Khutpala B.O": "454111",
      "Phulgawdi B.O": "454111",
      "Piparani B.O": "454116",
      "Barkheda B.O": "454111",
      "Manasa B.O": "454001",
      "Nagora B.O": "454001",
      "Labrawada B.O": "454001",
      "Nagda B.O": "454001",
      "Padlya B.O": "454001",
      "Tisgaon B.O": "454001",
      "Utawad B.O": "454001",
      "Anarad B.O": "454001",
      "Biloda B.O": "454001",
      "Nalcha B.O": "454001",
      "Tornod B.O": "454001",
      "Balendi B.O": "454441",
      "Bandedi B.O": "454441",
      "Chalni B.O": "454441",
      "Chotya Balod B.O": "454441",
      "Dhamanna B.O": "454660",
      "Dholana B.O": "454660",
      "Dotrya B.O": "454660",
      "Ghatgara B.O": "454660",
      "Ghatbori B.O": "454221",
      "Longsari B.O": "454221",
      "Pipariapani B.O": "454221",
      "Bharudpura B.O": "454552",
      "Bhavaniabujurg B.O": "454552",
      "Sakalda B.O": "454449",
      "Tawlai B.O": "454449",
      "Umarban B.O": "454449",
      "Zirvi B.O": "454449",
      "Kod B.O": "454665",
      "Semlia B.O": "454665",
      "Ambada B.O": "454331",
      "Loni B.O": "454331",
      "Talanpur B.O": "454331",
      "Talwadi B.O": "454331",
      "Ajanda B.O": "454446",
      "Chiklya B.O": "454001",
      "Kesur B.O": "454001",
      "Chilur B.O": "454001",
      "Kalsada B.O": "454001",
      "Sultanpur B.O": "454001",
      "Dasai B.O": "454441",
      "Hatod B.O": "454441",
      "Takraoda B.O": "454441",
      "Bakhatgarh B.O": "454660",
      "Bhainsola B.O": "454660",
      "Panchakwasa B.O": "454660",
      "Sandla B.O": "454660",
      "Tanda B.O": "454221",
      "Bad chapra B.O": "454773",
      "Kalsoda khurd B.O": "454773",
      "Balwari B.O": "454552",
      "Dudhi B.O": "454552",
      "Sundrel B.O": "454552",
      "Lunherabujurg B.O": "454449",
      "Pipaldagadi B.O": "454449",
      "Gajnod B.O": "454665",
      "Khandigara B.O": "454665",
      "Shergarh B.O": "454665",
      "Ali B.O": "454331",
      "Badwaniya B.O": "454331",
      "Kundara B.O": "454331",
      "Padiyal B.O": "454331",
      "Baglia B.O": "454446",
      "Barda B.O": "454446",
      "Kachroda B.O": "454001",
      "Sadalpur B.O": "454001",
      "Gulwa B.O": "454001",
      "Gunawad B.O": "454001",
      "Kherod B.O": "454001",
      "Dhamanda B.O": "454441",
      "Salkanpur B.O": "454001",
      "Gardawad B.O": "454001",
      "Dedla B.O": "454001",
      "Khiledi B.O": "454441",
      "Kheda B.O": "454660",
      "Multhan B.O": "454660",
      "Dehri B.O": "454221",
      "Dighthan B.O": "454773",
      "Dahiwar B.O": "454552",
      "Gujri B.O": "454552",
      "Keshvi B.O": "454441",
      "Sagwal B.O": "454441",
      "Baloda B.O": "454660",
      "Chhayan B.O": "454660",
      "Kachibadoda B.O": "454660",
      "Rajod B.O": "454660",
      "Tilgara B.O": "454660",
      "Akhada B.O": "454221",
      "Ekalduna B.O": "454773",
      "Lebadchowki B.O": "454773",
      "Bikhron B.O": "454552",
      "Dhani B.O": "454552",
      "Khalghat B.O": "454552",
      "Tarapur B.O": "454552",
      "Kothada B.O": "454449",
      "Pagara B.O": "454449",
      "Chhokla B.O": "454665",
      "Kadod B.O": "454665",
      "Dahi B.O": "454331",
      "Dholiya B.O": "454331",
      "Haldi B.O": "454331",
      "Susari B.O": "454331",
      "Awaldaman B.O": "454446",
      "Bakaner B.O": "454446",
      "Balipur B.O": "454446",
      "Piplaj B.O": "454552",
      "Semalda B.O": "454552",
      "Bohrala B.O": "454449",
      "Kalibawdi B.O": "454449",
      "Bamandakalan B.O": "454665",
      "Bhatbamanda B.O": "454665",
      "Bidwal B.O": "454665",
      "Dharamrai B.O": "454331",
      "Gajgota B.O": "454331",
      "Girwaniya B.O": "454331",
      "Kapsi B.O": "454331",
      "Ajandikot B.O": "454446",
      "Bilda B.O": "454446",
      "Palwada B.O": "454001",
      "Bagdi B.O": "454001",
      "Kot Bhidota B.O": "454001",
      "Ahoo B.O": "454001",
      "Bijur B.O": "454001",
      "Jetpura B.O": "454001",
      "Mohanpura B.O": "454001",
      "Borud B.O": "454446",
      "Jeerabad B.O": "454446",
      "Jotpur B.O": "454446",
      "Kachhawada B.O": "454446",
      "Kalwani B.O": "454446",
      "Mirjapur B.O": "454446",
      "Panwa B.O": "454446",
      "Pipli B.O": "454446",
      "Singhana B.O": "454446",
      "Ekalwara B.O": "454446",
      "Jajamkhedi B.O": "454446",
      "Khandlai B.O": "454446",
      "Luneherasadak B.O": "454446",
      "Nagur B.O": "454446",
      "Rantalab B.O": "454446",
      "Tonki B.O": "454446",
      "Kunjrod B.O": "454010",
      "Bachanpur B.O": "454010",
      "Bilodakhurd B.O": "454010",
      "Gandhwani B.O": "454446",
      "Jatpura B.O": "454446",
      "Karoli B.O": "454446",
      "Kuwad B.O": "454446",
      "Kuradia B.O": "454010",
      "Lunhera B.O": "454010",
      "Dhar H.O": "454001",
      "Bagh S.O": "454221",
      "Dhar Collectorate S.O": "454001",
      "Kukshi S.O": "454331",
      "Manawar S.O": "454446",
      "Amjhera S.O": "454441",
      "Badnawar S.O": "454660",
      "Dehri Ghata Billod S.O": "454773",
      "Dhamnod S.O": "454552",
      "Nisarpur S.O": "454335",
      "Dharampuri S.O": "454449",
      "Pithampur Sector III S.O": "454774",
      "Sardarpur S.O (Dhar)": "454111",
      "Kanwan S.O": "454665",
      "Mandu S.O": "454010",
      "Pithampur S.O": "454775",
      "Rajgarh (Dhar) S.O": "454116"
    },
    "KHARGONE": {
      "Lohari B.O": "451001",
      "Balsamund B.O": "451228",
      "Bamandi B.O": "451228",
      "Borawa B.O": "451228",
      "Pipalgaon B.O": "451228",
      "Satkut B.O": "451228",
      "Makshi B.O": "451224",
      "Matmur B.O": "451224",
      "Katkut B.O": "451115",
      "Mukhatyra B.O": "451115",
      "Navghatkhedi B.O": "451115",
      "Ratanpur B.O": "451332",
      "Mehatwada B.O": "451224",
      "Bablai B.O": "451221",
      "Choli B.O": "451221",
      "Choti Khargone B.O": "451221",
      "Dhargaon B.O": "451221",
      "Pitnagar B.O": "451113",
      "Rodia B.O": "451113",
      "Kanapur B.O": "451113",
      "Rahatkot B.O": "451113",
      "Behrampur B.O": "451331",
      "Bhatalpura B.O": "451331",
      "Deola B.O": "451331",
      "Lalkheda B.O": "451331",
      "Nargaon B.O": "451331",
      "Piprad B.O": "451331",
      "Bahadarpur B.O": "451441",
      "Banher B.O": "451441",
      "Bhagwanpur B.O": "451441",
      "Mongargaon B.O": "451441",
      "Kamodwada B.O": "451335",
      "Khamkheda B.O": "451335",
      "Mohammadpur B.O": "451335",
      "Vithnera B.O": "451335",
      "Abhapuri B.O": "451332",
      "Shivana B.O": "451332",
      "Mangral Khurd B.O": "451001",
      "Bamkhal B.O": "451001",
      "Kukdhal B.O": "451001",
      "Temrani B.O": "451001",
      "Pandhaniya B.O": "451001",
      "Bawi B.O": "451220",
      "Methawa B.O": "451220",
      "Amlatha B.O": "451228",
      "Balkhad B.O": "451228",
      "Choti Kasrawad B.O": "451228",
      "Ojhara B.O": "451228",
      "Ashapur B.O": "451224",
      "Itawadi B.O": "451224",
      "Karondiya B.O": "451221",
      "Somakhedi B.O": "451221",
      "Balakwada B.O": "451001",
      "Adhawan B.O": "451001",
      "Barud Tanda B.O": "451001",
      "Sinkheda B.O": "451001",
      "Ghatyabedi B.O": "451220",
      "Vani B.O": "451220",
      "Bagod B.O": "451220",
      "Bhudari B.O": "451220",
      "Badi B.O": "451228",
      "Bhulgaon B.O": "451113",
      "Banjhar B.O": "451331",
      "Kaldha B.O": "451331",
      "Shakargaon B.O": "451331",
      "Dhulkot B.O": "451441",
      "Sirwel B.O": "451441",
      "Dasnawal B.O": "451442",
      "Rehgaon B.O": "451335",
      "Chiriya B.O": "451332",
      "Helapadawa B.O": "451332",
      "Balwada B.O": "451115",
      "Barjhar B.O": "451115",
      "Jagatpura B.O": "451115",
      "Jethway B.O": "451115",
      "Tharwar B.O": "451115",
      "Umaria Chowki B.O": "451115",
      "Bagda Bujurg B.O": "451113",
      "Ahirkheda B.O": "451113",
      "Bamnala B.O": "451331",
      "Sundrel B.O": "451331",
      "Tinsya B.O": "451331",
      "Penpur B.O": "451441",
      "Pipaljhopa B.O": "451441",
      "Umarkhali B.O": "451441",
      "Multhan B.O": "451335",
      "Thibgaon B.O": "451335",
      "Badel B.O": "451115",
      "Jhigadi B.O": "451115",
      "Kithud B.O": "451115",
      "Nandia B.O": "451115",
      "Naya B.O": "451115",
      "Mardana B.O": "451113",
      "Rawerkhedi B.O": "451113",
      "Khedi Bujurg B.O": "451113",
      "Chhirwa B.O": "451113",
      "Birul B.O": "451331",
      "Kanjhar B.O": "451331",
      "Sagur Bhagur B.O": "451331",
      "Saikhedi B.O": "451331",
      "Bhilgaon B.O": "451228",
      "Dogawa B.O": "451228",
      "Regwa B.O": "451228",
      "Badwell B.O": "451224",
      "Kharadi B.O": "451224",
      "Kavdiya B.O": "451221",
      "Thangaon B.O": "451221",
      "Goradia B.O": "451332",
      "Balwadi B.O": "451001",
      "Siptan B.O": "451001",
      "Chandanpuri B.O": "451001",
      "Singun B.O": "451001",
      "Nagjhiri B.O": "451001",
      "Selda B.O": "451331",
      "Bhagyapur B.O": "451441",
      "Damkheda B.O": "451441",
      "Kabri B.O": "451441",
      "Samarpat B.O": "451441",
      "Andad B.O": "451335",
      "Dayalpura B.O": "451335",
      "Ghugharya Khedi B.O": "451335",
      "Igriya B.O": "451332",
      "Baruphatak B.O": "451449",
      "Temla B.O": "451001",
      "Kothakhurd B.O": "451001",
      "Piprata B.O": "451001",
      "Anjangaon B.O": "451113",
      "Badgaon B.O": "451113",
      "Padlya B.O": "451220",
      "Kogawan B.O": "451225",
      "Nandra B.O": "451225",
      "Ali Bujurg B.O": "451111",
      "Bhanbarad B.O": "451111",
      "Golwadi B.O": "451442",
      "Raibidpur B.O": "451440",
      "Shri Khandi B.O": "451440",
      "Baddiya B.O": "451225",
      "Katargaon B.O": "451225",
      "Dhakalgaon B.O": "451111",
      "Dodwan B.O": "451111",
      "Chitawal B.O": "451442",
      "Dongargaon B.O": "451442",
      "Ghegaon B.O": "451442",
      "Lehaku B.O": "451442",
      "Khadakwani B.O": "451660",
      "Khal Bujurg B.O": "451660",
      "Satrati B.O": "451660",
      "Talakpura B.O": "451440",
      "Machalpur B.O": "451225",
      "Pathrad B.O": "451225",
      "Sejgaon B.O": "451225",
      "Hirapur B.O": "451111",
      "Khangwada B.O": "451111",
      "Rasgaon B.O": "451442",
      "Gandhawal B.O": "451440",
      "Likhi B.O": "451440",
      "Nandgaon B.O": "451440",
      "Pipari B.O": "451440",
      "Aurangpura B.O": "451001",
      "Chainpur B.O": "451332",
      "Bhampura B.O": "451225",
      "Kodlya Khedi B.O": "451225",
      "Badud B.O": "451111",
      "Baswa B.O": "451111",
      "Satajana B.O": "451111",
      "Keli B.O": "451442",
      "Lonara B.O": "451442",
      "Satawad B.O": "451440",
      "Surpala B.O": "451440",
      "Khargone H.O": "451001",
      "Barwaha S.O": "451115",
      "Karhi S.O": "451220",
      "Dariya Mahal S.O": "451115",
      "Bedia S.O": "451113",
      "Bistan S.O": "451441",
      "Gogawa S.O": "451335",
      "Jhirnia S.O": "451332",
      "Khargone Municipal Col. S.O": "451001",
      "Bhikangaon S.O": "451331",
      "Maheshwar S.O": "451224",
      "Piplya Buzurg S.O": "451225",
      "Segaon S.O (West Nimar)": "451442",
      "Kasrawad S.O": "451228",
      "Mandleshwar S.O": "451221",
      "Nimarkhedi S.O": "450551",
      "Khargone Tawnhall S.O": "451001",
      "Sanawad S.O": "451111",
      "Un S.O (West Nimar)": "451440"
    },
    "JABALPUR": {
      "Tilsani B.O": "482001",
      "Baghraji B.O": "482001",
      "Gangai Padaria B.O": "482001",
      "Khajri B.O": "482004",
      "Maharajpur B.O": "482004",
      "Dhanwahi B.O": "482001",
      "Piparia B.O": "482001",
      "Amkhera B.O": "482004",
      "Imlai B.O": "483220",
      "Dehri Khurd B.O": "482001",
      "Dhanpuri B.O": "483001",
      "Luhkari B.O": "482001",
      "Temarbhita B.O": "482001",
      "Subhash Nagar B.O": "482004",
      "Deori Patpara B.O": "483001",
      "Hinotia Bhoi B.O": "483001",
      "Junwani Kalan B.O": "483225",
      "Neemkheda B.O": "483225",
      "Kua B.O": "483225",
      "Lamkana B.O": "483225",
      "Makura B.O": "483225",
      "Ponda B.O": "483225",
      "Umaria Jujhari B.O": "483225",
      "Darshni B.O": "483225",
      "Nimas B.O": "483225",
      "Gangai Bijori B.O": "482003",
      "Ghat Piparia B.O": "482003",
      "Lamheta Ghat B.O": "482003",
      "Nichi B.O": "482003",
      "Agasaud B.O": "482002",
      "Archha B.O": "482002",
      "Belkhadu B.O": "482002",
      "Boria B.O": "483105",
      "Murrai B.O": "483105",
      "Badkhera B.O": "483110",
      "Chaurai Kala B.O": "483110",
      "Dadargawan B.O": "483110",
      "Khirhani B.O": "483220",
      "Singod B.O": "483220",
      "Urdua Kala B.O": "483220",
      "Khairi B.O": "483113",
      "Konikala B.O": "483113",
      "Kymori B.O": "483113",
      "Nunsar B.O": "483113",
      "Barbati B.O": "482021",
      "Gauraiyaghat B.O": "482021",
      "Kailwas B.O": "483222",
      "Khamaria Neemkheda B.O": "482021",
      "Pindrai Barha B.O": "482021",
      "Gadar Pipariya B.O": "483119",
      "Gubra Kala B.O": "483119",
      "Magarmuha B.O": "483119",
      "Mankedi B.O": "483119",
      "Gwarighat B.O": "482008",
      "Perfect Pottories B.O": "482008",
      "Bandha B.O": "483222",
      "Bela B.O": "483222",
      "Gandhi Gram B.O": "483222",
      "Ramkhiria B.O": "483222",
      "Sahajpura B.O": "483222",
      "Anghora B.O": "483336",
      "Marha B.O": "483225",
      "Mureth B.O": "483225",
      "Phanwani B.O": "483225",
      "Khukkham B.O": "483001",
      "Padwar B.O": "483001",
      "Sahajpuri B.O": "482056",
      "Sukri B.O": "482051",
      "Baroda Chhedi B.O": "483053",
      "Umaria Kudari B.O": "483001",
      "Reewan B.O": "482051",
      "Tinsi B.O": "482051",
      "Amahinota B.O": "483053",
      "Majhita B.O": "483053",
      "Dharampura B.O": "482003",
      "Tilwara Ghat B.O": "482003",
      "Gohalpur B.O": "482002",
      "Mangela B.O": "482002",
      "Surtalai B.O": "482002",
      "Sunderpur B.O": "482005",
      "Gauri B.O": "483110",
      "Harduli B.O": "483110",
      "Supawara B.O": "483110",
      "Badkheda B.O": "483220",
      "Padaria B.O": "483220",
      "Umaria Choubey B.O": "483220",
      "Badhaiyakheda B.O": "483113",
      "Katra Belkheda B.O": "483113",
      "Sagada Jhapni B.O": "482021",
      "Bheeta B.O": "483119",
      "Chhaparhat B.O": "483119",
      "Pawla B.O": "483119",
      "Sahajpur B.O": "483119",
      "Harsinghi B.O": "483222",
      "Jhansi B.O": "483222",
      "Jhingrai B.O": "483222",
      "Lakhanpur B.O": "483222",
      "Harrai B.O": "482051",
      "Kaladehi B.O": "482051",
      "Mohas B.O": "482051",
      "Nigri B.O": "482051",
      "Tripuri B.O": "483053",
      "Chargawan B.O": "482003",
      "Gangai Badkheda B.O": "482003",
      "Simaria B.O": "482002",
      "Sukha B.O": "482002",
      "Jhirmila B.O": "483110",
      "Kastara B.O": "483110",
      "Kosam Dongari B.O": "483110",
      "Rampuri Turka B.O": "483110",
      "Salaiya B.O": "483110",
      "Sarauli B.O": "483110",
      "Baroda B.O": "483220",
      "Chhartarpur B.O": "483220",
      "Kaladumar B.O": "483220",
      "Riyana B.O": "483113",
      "Sakra B.O": "483113",
      "Sarond B.O": "483113",
      "Udna B.O": "483113",
      "Basendi B.O": "483119",
      "Belkheda B.O": "483119",
      "Sahshan B.O": "483119",
      "Umaria Patan B.O": "483119",
      "Ghat Simaria B.O": "483222",
      "Mohaniya B.O": "483222",
      "Pondikala (A) B.O": "483222",
      "Sukha Bharatpur B.O": "482003",
      "Karmeta B.O": "482002",
      "Pachkuiyan B.O": "482002",
      "Nirandpur B.O": "483105",
      "Sonpur B.O": "482005",
      "Ghughara B.O": "483110",
      "Jhiria B.O": "483110",
      "Mahagawan B.O": "483220",
      "Raipura B.O": "483220",
      "Sarsawa B.O": "483220",
      "Umaria Pathra B.O": "483220",
      "Gadaghat B.O": "483113",
      "Bhaironghat Pipariya B.O": "483119",
      "Bhuwara B.O": "483119",
      "Natwara B.O": "483119",
      "Ramkhiria Thutha B.O": "483119",
      "Bargi  IPC B.O": "482008",
      "Hirday Nagar B.O": "483222",
      "Khinni B.O": "483222",
      "Silua B.O": "483222",
      "Pola B.O": "483336",
      "Ranital B.O": "483336",
      "Hinota B.O": "483336",
      "Khirhani Kalan B.O": "483334",
      "Kumhi Satdhara B.O": "483334",
      "Nunji B.O": "483334",
      "Indrana B.O": "483336",
      "Khitola B.O": "483336",
      "Umaria Dhirha B.O": "483336",
      "Khand B.O": "483336",
      "Patori B.O": "483336",
      "Agaria Tikaria B.O": "483334",
      "Bhandra B.O": "483334",
      "Kumhi Khurd B.O": "483334",
      "Singhuli B.O": "483334",
      "Jabalpur H.O": "482001",
      "Adhartal S.O": "482004",
      "Engineering College S.O (Jabalpur)": "482011",
      "Garha Phatak S.O": "482002",
      "Bai Ka Bagicha S.O": "482001",
      "Bargi Nagar S.O": "482056",
      "Ganjipura S.O": "482002",
      "Gokulpur S.O": "482011",
      "Anand Nagar S.O (Jabalpur)": "482004",
      "Barela S.O": "483001",
      "Dixitpura S.O": "482002",
      "Garha S.O (Jabalpur)": "482003",
      "Bargi S.O": "482051",
      "Bheraghat S.O": "483053",
      "Bilhari S.O": "482020",
      "Garha Bazar S.O": "482003",
      "Gupteshwar S.O": "482001",
      "Hanumantal S.O": "482002",
      "I.T.I. S.O": "482002",
      "Jabalpur City S.O": "482002",
      "Jabalpur Factory S.O": "482011",
      "Kasturba Nagar S.O (Jabalpur)": "482001",
      "Medical College S.O (Jabalpur)": "482003",
      "Miloniganj S.O": "482002",
      "Motinala S.O": "482002",
      "Polipathar S.O": "482008",
      "R.F.R.C. S.O": "482021",
      "Richhai S.O": "482010",
      "Saraswati Vihar S.O": "482001",
      "Telegraph Work Shop S.O": "482002",
      "Gurandi Bazar S.O": "482002",
      "Hathital S.O": "482001",
      "Khamaria S.O (Jabalpur)": "482005",
      "Kundam S.O": "483110",
      "Shahpura (Jabalpur) S.O": "483119",
      "High Court S.O (Jabalpur)": "482001",
      "Howbagh S.O": "482001",
      "Kutchery S.O (Jabalpur)": "482001",
      "Nagar Nigam S.O": "482002",
      "Panagar S.O (Jabalpur)": "483220",
      "Sihora Khitola Bazar S.O": "483225",
      "Prem Nagar S.O (Jabalpur)": "482001",
      "Regimental Bazar S.O": "482001",
      "Vehicle Factory S.O": "482009",
      "Wright Town S.O": "482002",
      "Jabalpur Cantt S.O": "482001",
      "Jeewan Bima Nigam S.O": "482001",
      "Jonesganj S.O": "482002",
      "Kanchanpur S.O (Jabalpur)": "482004",
      "Katangi S.O (Jabalpur)": "483105",
      "Lordganj S.O": "482002",
      "Napier Town S.O": "482001",
      "Patan S.O (Jabalpur)": "483113",
      "Ranjhi Azad Nagar S.O": "482005",
      "Shobhapur S.O": "482009",
      "Vidyut Nagar S.O (Jabalpur)": "482008",
      "Gosalpur S.O": "483222",
      "Majholi S.O": "483336",
      "Saroli Majhgawan S.O": "483334",
      "Sihora(MP) S.O": "483225"
    },
    "SEHORE": {
      "Siradi B.O": "466651",
      "Sonthi B.O": "466651",
      "Khandwa B.O": "466651",
      "Jasmat B.O": "466120",
      "Muktarnagar B.O": "466651",
      "Dhuradakalan B.O": "466120",
      "Khajuriya Kasam B.O": "466120",
      "Nougaon B.O": "466120",
      "Mograram B.O": "466001",
      "Semradangi B.O": "466001",
      "Sehore Englishpura B.O": "466001",
      "Sehore Ganjbajariya B.O": "466001",
      "Bijlone B.O": "466001",
      "Barkheda Hasan B.O": "466665",
      "Ashta Fort B.O": "466116",
      "Bager B.O": "466116",
      "Bamuliyabhati B.O": "466116",
      "Barkheda B.O": "466116",
      "Bhoura B.O": "466116",
      "Chhapar B.O": "466116",
      "Dabri B.O": "466115",
      "Harrajkhedi B.O": "466116",
      "Kannod B.O": "466116",
      "Nandner B.O": "466448",
      "Dhabla B.O": "466111",
      "Heerapur B.O": "466111",
      "Uljhawan B.O": "466111",
      "Chhatri B.O": "466661",
      "Jharkheda B.O": "466661",
      "Bhaukhedi B.O": "466115",
      "Bishankhedi B.O": "466115",
      "Bordikalan B.O": "466115",
      "Brijisnagar B.O": "466115",
      "Ramnagar BO": "466115",
      "Murawar B.O": "466221",
      "Bedakhedi B.O": "466114",
      "Chupadiya B.O": "466114",
      "Chhipaner B.O": "466331",
      "Chinch B.O": "466331",
      "Dhoulpur B.O": "466331",
      "Digwad B.O": "466331",
      "Panchore B.O": "466331",
      "Amirganj B.O": "466446",
      "Khadli B.O": "466446",
      "Kheri B.O": "466115",
      "Mardanpur B.O": "466446",
      "Akola B.O": "466554",
      "Jatakheda B.O": "466001",
      "Baktal B.O": "466001",
      "Khamaliya B.O": "466001",
      "Badiyakhedi B.O": "466001",
      "Naplakhedi B.O": "466001",
      "Bijori B.O": "466001",
      "Charnal B.O": "466665",
      "Aroliya B.O": "466116",
      "Khachrod B.O": "466116",
      "Mugli B.O": "466116",
      "Panguradiya B.O": "466445",
      "Aamon B.O": "466448",
      "Bamulia B.O": "466111",
      "Veerpur Kolardem B.O": "466111",
      "Aarya B.O": "466115",
      "Dolatpur B.O": "466115",
      "Jhalki B.O": "466115",
      "Bhanwarikalan B.O": "466221",
      "Molukhedi B.O": "466114",
      "Baijnath B.O": "466125",
      "Loraskhurd B.O": "466125",
      "Balagaon B.O": "466331",
      "Bhadakui B.O": "466331",
      "Itarshi B.O": "466331",
      "Nandgaon B.O": "466331",
      "Satrana B.O": "466331",
      "Semalpani B.O": "466331",
      "Semrikatkuna B.O": "466446",
      "Dobi B.O": "466554",
      "Jawaharkheda B.O": "466554",
      "Jait B.O": "466554",
      "Khajuriyakalan B.O": "466651",
      "Janpur Bavdiya B.O": "466001",
      "Sehore Rak B.O": "466001",
      "Mahodiya B.O": "466001",
      "Hasnabad B.O": "466001",
      "Nipaniya B.O": "466001",
      "Chandbad  Jageer B.O": "466665",
      "Muskara B.O": "466113",
      "Alipur Ashta B.O": "466116",
      "Dupadiya B.O": "466116",
      "Khadi B.O": "466116",
      "Kurawar B.O": "466116",
      "Lasudliya Vijaysinh": "466116",
      "Jontala B.O": "466448",
      "Kulaskalan B.O": "466111",
      "Khaikheda B.O": "466661",
      "Paatan B.O": "466661",
      "Deevadia B.O": "466115",
      "Guradi B.O": "466115",
      "Narsinghkheda B.O": "466115",
      "Arniyagaji B.O": "466221",
      "Kajlaas B.O": "466221",
      "Borkheda B.O": "466331",
      "Nipaniakalan B.O": "466114",
      "Sewda B.O": "466125",
      "Guradiyavarma B.O": "466118",
      "Chhitgaonmoji B.O": "466331",
      "Dimawar B.O": "466331",
      "Kurinayapura B.O": "466331",
      "Ladkui B.O": "466331",
      "Rithwad B.O": "466331",
      "Sonthiya B.O": "466331",
      "Chakaldi B.O": "466446",
      "Manjharkui B.O": "466446",
      "Salkanpur B.O": "466446",
      "Baneta B.O": "466554",
      "Pilikarar B.O": "466445",
      "Paraswada B.O": "466554",
      "Bairagarhkhuman B.O": "466651",
      "Kachnariya B.O": "466651",
      "Bayan B.O": "466445",
      "Budni Ghat B.O": "466445",
      "Jahajpura B.O": "466445",
      "Joshipur B.O": "466445",
      "Mundlakhurd B.O": "466001",
      "Pachama B.O": "466001",
      "Sehore Town B.O": "466001",
      "Mungavli B.O": "466001",
      "Magarda B.O": "466665",
      "Dhamnda B.O": "466113",
      "Foodra B.O": "466116",
      "Hakimabad B.O": "466116",
      "Aabidabad B.O": "466111",
      "Jamoniya Fathepur B.O": "466115",
      "Semlijadid B.O": "466115",
      "Torniya B.O": "466115",
      "Gavakheda B.O": "466114",
      "Lasudiakhas B.O": "466114",
      "Gwali B.O": "466118",
      "Baibori B.O": "466331",
      "Basudev B.O": "466331",
      "Gillor B.O": "466331",
      "Gopalpur B.O": "466331",
      "Nimota B.O": "466331",
      "Piplaani B.O": "466331",
      "Sudamapuri B.O": "466331",
      "Tiladiya B.O": "466331",
      "Soyat B.O": "466446",
      "Dungariya B.O": "466554",
      "Sardarnagar B.O": "466554",
      "Sehore H.O": "466001",
      "Ahmedpur S.O (Sehore)": "466665",
      "Baktara S.O": "466448",
      "Jawar S.O (Sehore)": "466221",
      "Kotri S.O (Sehore)": "466114",
      "Shahganj S.O (Sehore)": "466554",
      "Ashta S.O": "466116",
      "Ichawar S.O": "466115",
      "Maina S.O": "466125",
      "Rehti S.O": "466446",
      "Sehore Mandi S.O": "466001",
      "Amlaha S.O": "466113",
      "Bilkisganj S.O": "466111",
      "Shyampur S.O (Sehore)": "466651",
      "Doraha S.O (Sehore)": "466661",
      "Budhni T.N. S.O": "466445",
      "Metwada S.O": "466118",
      "Nasrllaganj S.O": "466331",
      "Sehore City S.O": "466001",
      "Siddikganj S.O": "466120"
    },
    "SHAJAPUR": {
      "Dhillod B.O": "465001",
      "Dupada B.O": "465001",
      "Sunhera B.O": "465001",
      "Bhaisrod B.O": "465223",
      "Hadlaya Kala B.O": "465223",
      "Kethlay B.O": "465223",
      "Burlay B.O": "465226",
      "Burnavad B.O": "465226",
      "Karju B.O": "465226",
      "Tikon B.O": "465226",
      "Panch  Dehria B.O": "465335",
      "Siloda B.O": "465335",
      "Pochaner B.O": "465337",
      "Dasta Khedi B.O": "465220",
      "Devla Bihar B.O": "465220",
      "Bharad B.O": "465001",
      "Panwadi B.O": "465001",
      "Morta B.O": "465001",
      "Mohmmadkheda B.O": "465223",
      "Ranibarod B.O": "465223",
      "Dudhana B.O": "465226",
      "Khoriaama B.O": "465226",
      "Mandoda B.O": "465226",
      "BERCHHA TOWN B.O": "465110",
      "Chakrod B.O": "465335",
      "Berchha Datar B.O": "465337",
      "Khamlya B.O": "465337",
      "Lasuldiya Gori B.O": "465337",
      "Pipliyanagar B.O": "465337",
      "Ranayal B.O": "465337",
      "Ghunsi B.O": "465220",
      "Lahori B.O": "465220",
      "Jhokar B.O": "465106",
      "Khatsur B.O": "465116",
      "Chitawad B.O": "465227",
      "Kevda Khedi B.O": "465227",
      "Dehandi B.O": "465333",
      "Bijana B.O": "465001",
      "Gopipur B.O": "465001",
      "Uchod B.O": "465223",
      "Kumariakhas B.O": "465226",
      "Mohana B.O": "465226",
      "Tilawad  Govind B.O": "465110",
      "Amlay B.O": "465335",
      "Dhabla  Ghosi B.O": "465335",
      "Behraval B.O": "465337",
      "Bhuria Khajuria B.O": "465337",
      "Kamalpur B.O": "465337",
      "Lasuldiya Malak B.O": "465337",
      "Ugli B.O": "465337",
      "Bolai B.O": "465220",
      "Gulana B.O": "465220",
      "Ladavad B.O": "465220",
      "Bhaisaygarh B.O": "465339",
      "Devli B.O": "465116",
      "Mortakhevdi B.O": "465116",
      "Kadwala B.O": "465227",
      "Killoda B.O": "465227",
      "Arniya  Kalan B.O": "465333",
      "Ala Umrod B.O": "465001",
      "Abhaypur B.O": "465001",
      "Sajod B.O": "465001",
      "Patlawada B.O": "465223",
      "Polaikhrud B.O": "465223",
      "Nipaniyakarju B.O": "465226",
      "Bardiason B.O": "465110",
      "Choslakulmi B.O": "465110",
      "Dendla B.O": "465110",
      "Khoria Nayta B.O": "465110",
      "Ranth Bhanwar B.O": "465110",
      "Dhabla Dheer B.O": "465337",
      "Farad B.O": "465337",
      "Jabdiya Bheel B.O": "465337",
      "Kalapipal Gaon B.O": "465337",
      "Mansaya B.O": "465337",
      "Nandni B.O": "465337",
      "Khardonkala B.O": "465339",
      "Khardonkhurd B.O": "465339",
      "Mohammadpur Machnai B.O": "465339",
      "Semliya B.O": "465339",
      "Kapaliya B.O": "465106",
      "Loharkheda B.O": "465227",
      "Madana B.O": "465227",
      "Manglaj B.O": "465227",
      "Alisiriya B.O": "465333",
      "Bhilkhedi B.O": "465333",
      "Mayapur  Mangrola B.O": "465333",
      "Rolakhedi B.O": "465333",
      "Tilawadmena B.O": "465333",
      "Khadi B.O": "465113",
      "PADLIYA B.O": "465118",
      "BINAYA B.O": "465118",
      "Nipania  Dhakar B.O": "465113",
      "Simrol B.O": "465113",
      "Raipur B.O": "465333",
      "ARNIAKHURD B.O": "465118",
      "Makodi B.O": "465113",
      "PAGRAWADKALAN B.O": "465118",
      "Shajapur H.O": "465001",
      "Polai Kalan S.O": "465116",
      "Shajapur  Town S.O": "465001",
      "Shujalpur  Mandi S.O": "465333",
      "Kalisindh S.O": "465220",
      "Khokra Kalan S.O": "465339",
      "Akodia S.O": "465223",
      "Barodia Kumaria S.O": "465226",
      "Kalapipal S.O": "465337",
      "Maksi S.O": "465106",
      "Shajapur Kutchery S.O": "465001",
      "Shujalpur  City S.O": "465333",
      "Sundersi S.O": "465113",
      "Berchha S.O": "465110",
      "Jamner S.O (Shajapur)": "465335",
      "Salsalai S.O": "465227",
      "AWANTIPUR BARODIYA": "465118"
    },
    "AGAR MALWA": {
      "Bapcha B.O": "465550",
      "Palda B.O": "465441",
      "Sirpoi B.O": "465441",
      "Tanodiya B.O": "465441",
      "AGARCANTT B.O": "465441",
      "GUNDIKALA B.O": "465441",
      "Kohadiya B.O": "465230",
      "Pilwas B.O": "465445",
      "Pipliaset B.O": "465445",
      "Takhala B.O": "465445",
      "Bijanagri B.O": "465441",
      "Mahudiya B.O": "465441",
      "Nipaniya Hanuman B.O": "465441",
      "Palkhedi B.O": "465441",
      "Madkota B.O": "465550",
      "Hargankhedi B.O": "465230",
      "Mathurakhedi B.O": "465230",
      "Badagaon B.O": "465445",
      "Dharola B.O": "465445",
      "BIJNAKHEDI B.O": "465445",
      "Malwasa B.O": "465441",
      "Piploankala B.O": "465441",
      "Lotiakrishna B.O": "465550",
      "SUDWAS B.O": "465550",
      "Choma Dak Bangla B.O": "465230",
      "Bhandavad B.O": "465445",
      "Bhesoda B.O": "465445",
      "Suigaon B.O": "465445",
      "KHELAGAON B.O": "465445",
      "Biyana B.O": "465441",
      "Gata B.O": "465441",
      "Ghurasiya B.O": "465441",
      "Lala B.O": "465441",
      "Nipaniabajnath B.O": "465441",
      "Amba B.O": "465550",
      "Jhalara B.O": "465550",
      "Pachlana B.O": "465230",
      "Shivgarh B.O": "465230",
      "Gondalmau B.O": "465445",
      "Goyla B.O": "465445",
      "Dehriyakulmi B.O": "465449",
      "Dogargaon B.O": "465449",
      "Barda  Raoji B.O": "465447",
      "Gangapur B.O": "465447",
      "Semalkhedi B.O": "465447",
      "Shyampura B.O": "465447",
      "Gelana B.O": "465447",
      "Laturi  Gehlot B.O": "465447",
      "Modi B.O": "465447",
      "Payli B.O": "465447",
      "Saliakhedi B.O": "465449",
      "Soyat  Khurd B.O": "465449",
      "Loharia B.O": "465449",
      "Amla B.O": "465447",
      "Chhapariya B.O": "465447",
      "Nalkheda S.O": "465445",
      "Agar Malwa S.O": "465441",
      "Barode S.O": "465550",
      "Soyat Kalan S.O": "465449",
      "Kanad S.O": "465230",
      "Susner S.O": "465447"
    },
    "DINDORI": {
      "Gaura Kanhari B.O": "481778",
      "Badaigarh B.O": "481990",
      "Bilgaon B.O": "481990",
      "Ghutalwa B.O": "481990",
      "Padariya Kala B.O": "481880",
      "Raypura B.O": "481880",
      "Sakka B.O": "481880",
      "Simariya B.O": "481880",
      "Bondar B.O": "481884",
      "Chanda B.O": "481883",
      "Khargahna B.O": "481882",
      "Bhusanda B.O": "481884",
      "Gopalpur B.O": "481884",
      "Jhanki B.O": "481884",
      "Karanjia B.O": "481884",
      "Mendakhar B.O": "481884",
      "Parsel B.O": "481884",
      "Nighori B.O": "481778",
      "Sigholi Mohgaon B.O": "481778",
      "Ajawar B.O": "481879",
      "Duhania B.O": "481879",
      "Ghusia B.O": "481879",
      "Marwari B.O": "481879",
      "Sarastal B.O": "481879",
      "Chandwahi B.O": "481990",
      "Guraiya B.O": "481990",
      "Kohani Deori B.O": "481990",
      "Thonda B.O": "481990",
      "Madiyaras B.O": "481880",
      "Mudki B.O": "481880",
      "Majhiyakhar B.O": "481882",
      "Sukulpura B.O": "481882",
      "Jugdehi B.O": "481884",
      "Bilgarha B.O": "481885",
      "Chandrani B.O": "481778",
      "Salheghori B.O": "481778",
      "Dullopur B.O": "481879",
      "Jamgaon B.O": "481879",
      "Rakhi Rampuri B.O": "481879",
      "Kachhari B.O": "481990",
      "Kanheri B.O": "481990",
      "Sarvahi B.O.": "481883",
      "Amarpur B.O": "481880",
      "Chhanta B.O": "481880",
      "Kamrasoda B.O": "481880",
      "Kukarramath B.O": "481880",
      "Newsapondi B.O": "481880",
      "Bachchhargaon B.O": "481882",
      "Lalpur B.O": "481882",
      "Mohtara B.O": "481882",
      "Bichhia B.O": "481885",
      "Bamni B.O": "481778",
      "Jadasurang B.O": "481778",
      "Junwani B.O": "481778",
      "Khutia B.O": "481778",
      "Margaon B.O": "481778",
      "Amani Piparia B.O": "481879",
      "Amera B.O": "481879",
      "Barchha B.O": "481879",
      "Darri Mohgaon B.O": "481879",
      "Silhari B.O": "481879",
      "Tendumer Mohtara B.O": "481879",
      "Tikari Pipari B.O": "481879",
      "Vikrampur B.O": "481879",
      "Kachharimal B.O": "481990",
      "Karondi B.O": "481990",
      "Manikpur B.O": "481990",
      "Piparia Kasturi B.O": "481990",
      "Raipura B.O": "481990",
      "Sangrampur B.O": "481990",
      "Bhaiswahi B.O": "481880",
      "Deori Mal B.O": "481880",
      "Dhanwasi B.O": "481880",
      "Kisalpuri B.O": "481880",
      "Patangarh B.O": "481884",
      "Raitwar B.O": "481884",
      "Rusha Raitwar B.O": "481884",
      "Kathotiya B.O": "481672",
      "Rai B.O": "481672",
      "Matiyari B.O": "481672",
      "Parapani B.O": "481672",
      "Sarasdoli B.O": "481672",
      "Mehadwani B.O": "481672",
      "Chhirpani B.O": "481672",
      "Dhamni B.O": "481672",
      "Harratola B.O": "481672",
      "Shahpur S.O (Dindori)": "481879",
      "Gorakhpur S.O": "481884",
      "Samnapur S.O": "481778",
      "Bajag S.O": "481883",
      "Dindori S.O (Dindori)": "481880",
      "Gadasarai S.O": "481882",
      "Shahpura Niwas S.O": "481990"
    },
    "MANDLA": {
      "Bhimdongari B.O": "481996",
      "Tatri B.O": "481768",
      "Ramhepur B.O": "481664",
      "Salwah B.O": "481664",
      "Silghiti B.O": "481664",
      "Gaurachhapar B.O": "481776",
      "Gokulthana B.O": "481776",
      "Itka B.O": "481776",
      "Chhapra B.O": "481885",
      "Gwara B.O": "481771",
      "Maneri B.O": "481885",
      "Piparia Niwas B.O": "481885",
      "Bamnhi Bhawal B.O": "481662",
      "Barwahi B.O": "481666",
      "Bijegaon B.O": "481662",
      "Pandiwada B.O": "481662",
      "Chhapartala B.O": "481996",
      "Khaloundi B.O": "481996",
      "Rajo B.O": "481996",
      "Indri B.O": "481768",
      "Rata B.O": "481768",
      "Gajraj B.O": "481664",
      "Patan B.O": "481664",
      "Malara Bichhua B.O": "481665",
      "Chubhawal B.O": "481663",
      "Munu B.O": "481663",
      "Singarpur B.O": "481663",
      "Jamgaon B.O": "481776",
      "Bamhani B.O": "481885",
      "Deorikala B.O": "481885",
      "Borgaon B.O": "481666",
      "Kalpi B.O": "481666",
      "Udaipur B.O": "481666",
      "Deori Nainpur B.O": "481668",
      "Kanhadgaon B.O": "481668",
      "Bharweli B.O": "481668",
      "Bijegaon Colony B.O": "481668",
      "Bilgaon B.O": "481661",
      "Dhangaon B.O": "481996",
      "Kudela B.O": "481996",
      "Poundibaharmunda B.O": "481996",
      "Kanha National Park B.O": "481768",
      "Rampuri B.O": "481768",
      "Bhaishwahi B.O": "481664",
      "Khajari B.O": "481664",
      "Badhar B.O": "481665",
      "Manadehi B.O": "481665",
      "Machhala B.O": "481663",
      "Umardih B.O": "481663",
      "Amgaon B.O": "481885",
      "Chirai Dongri B.O": "481662",
      "Kudameli B.O": "481662",
      "Poninagrar B.O": "481666",
      "Dithori B.O": "481668",
      "Pathasihora B.O": "481668",
      "Ghagha B.O": "481661",
      "I.T.I. B.O": "481661",
      "Ahmadpur B.O": "481998",
      "Bhartipur B.O": "481666",
      "Tabalpani B.O": "481995",
      "Surhali B.O": "481672",
      "Mangali B.O": "481996",
      "Mawai B.O": "481996",
      "Meda B.O": "481996",
      "Motinala B.O": "481996",
      "Naharganj B.O": "481996",
      "Chichgaon B.O": "481768",
      "Palasunder B.O": "481768",
      "Bamni Deohara B.O": "481664",
      "Deogaon B.O": "481663",
      "Kauwadongri B.O": "481663",
      "Thanamgaon B.O": "481885",
      "kappamal B.O": "481885",
      "Lawarmundia B.O": "481666",
      "Patha B.O": "481662",
      "Piparia (B) B.O": "481666",
      "Raiwada B.O": "481668",
      "Madhupuri B.O": "481661",
      "Badi Khairi B.O": "481661",
      "Bakori B.O": "481661",
      "Madhopur B.O": "481998",
      "Suktara B.O": "481998",
      "Limarua B.O": "481771",
      "Silgi B.O": "481771",
      "Barai B.O": "481995",
      "Mainpuri B.O": "481995",
      "Naijhar(Pondi) B.O": "481995",
      "Thonda B.O": "481995",
      "Poundi Jhurki B.O": "481672",
      "Binjhia B.O": "481661",
      "Padri Patpara B.O": "481661",
      "Kindari B.O": "481661",
      "Poundi Linga B.O": "481661",
      "Aurai B.O": "481998",
      "Mand B.O": "481998",
      "Lafra B.O": "481771",
      "Mugdara B.O": "481771",
      "Anjani B.O": "481995",
      "Danitola B.O": "481995",
      "Koko B.O": "481995",
      "Sahjar B.O": "481672",
      "Bineka B.O": "481661",
      "Khari B.O": "481661",
      "Padmi B.O": "481661",
      "Phoolsagar B.O": "481661",
      "Dhenko B.O": "481771",
      "Jaharmau B.O": "481771",
      "Kakaiya B.O": "481771",
      "Dhadibhanpur B.O": "481995",
      "Ghutas B.O": "481995",
      "Keolari B.O": "481995",
      "Khatola B.O": "481995",
      "Chandwara B.O": "481661",
      "Katra B.O": "481661",
      "Semarkhapa B.O": "481661",
      "Mohania Patpara B.O": "481661",
      "Purwa B.O": "481661",
      "Ramnagar B.O": "481661",
      "Hirdenagar B.O": "481661",
      "Mandla H.O": "481661",
      "Bhuabichhia S.O": "481995",
      "Maharajpur S.O (Mandla)": "481665",
      "Beejadandi S.O": "481666",
      "Chabi S.O": "481672",
      "Padariyanarayan Ganj S.O": "481662",
      "Bamni S.O": "481771",
      "Chiraidongri S.O": "481768",
      "Ghughri S.O": "481664",
      "Nainpur S.O": "481776",
      "Niwas S.O": "481885",
      "Padaw Mandla S.O": "481661",
      "Pindrai S.O": "481668",
      "Anjania S.O": "481998",
      "Mohgaon S.O": "481663",
      "Sijhora S.O": "481996"
    },
    "TIKAMGARH": {
      "Patha B.O": "472001",
      "Karikhas B.O": "472001",
      "Narguda B.O": "472001",
      "Dunda B.O": "472010",
      "Samarra B.O": "472010",
      "Airora B.O": "472111",
      "Dikoli Chowk B.O": "472111",
      "Majna B.O": "472001",
      "Dhajrai B.O": "472001",
      "Ajnore B.O": "472010",
      "Gukhrai B.O": "472111",
      "Sunderpur B.O": "472001",
      "Mawai B.O": "472221",
      "Papaura B.O": "472001",
      "Amarpur B.O": "472010",
      "Darguwan B.O": "472010",
      "Sapon B.O": "472010",
      "Umari B.O": "472010",
      "Hiranagar B.O": "472001",
      "Maharajpur B.O": "472001",
      "Khaira B.O": "472001",
      "Kakarwaha B.O": "472010",
      "Lar B.O": "472010",
      "Baisa B.O": "472111",
      "Dewarda B.O": "472111",
      "Hatta B.O": "472111",
      "Ramnagar B.O": "472339",
      "Bamhori kala B.O": "472118",
      "Chandera B.O": "472118",
      "Jarua B.O": "472118",
      "Kanera B.O": "472118",
      "Chandpura B.O": "472115",
      "Chaubara B.O": "472115",
      "Chhidari B.O": "472115",
      "Deri B.O": "472115",
      "Ramnagar Bujurg B.O": "472115",
      "Sarkanpur B.O": "472115",
      "Aston B.O": "472005",
      "Bamhori Barana B.O": "472331",
      "Bari B.O": "472331",
      "Kachhiyaguda B.O": "472331",
      "IqbalPura B.O": "472101",
      "Mogna B.O": "472101",
      "Nandanwara B.O": "472101",
      "Ghoorakhas B.O": "472221",
      "Guna B.O": "472221",
      "Gurha B.O": "472221",
      "Pali B.O": "472221",
      "Para B.O": "472221",
      "Bahadurpur B.O": "472001",
      "Nanhi tehtri B.O": "472111",
      "Ranipura B.O": "472111",
      "Ahar B.O": "472111",
      "Barmadang B.O": "472339",
      "Dhamanakhas B.O": "472339",
      "Muhara B.O": "472118",
      "Banne Bujraj B.O": "472115",
      "Futer B.O": "472115",
      "Malguwn B.O": "472115",
      "Pathrguwan B.O": "472115",
      "Khiriya Naka B.O": "472005",
      "Kheron B.O": "472331",
      "Marguwna B.O": "472331",
      "Dargain Kala B.O": "472101",
      "Gor B.O": "472101",
      "Mastapur B.O": "472101",
      "Barana B.O": "472221",
      "Laron B.O": "472221",
      "Magrai B.O": "472221",
      "Narayanpura B.O": "472111",
      "Sujanpura B.O": "472111",
      "Bachhora B.O": "472339",
      "Bijron B.O": "472339",
      "Bairwar khas B.O": "472118",
      "Kalera B.O": "472118",
      "Karmora B.O": "472118",
      "Pahadibujurg B.O": "472118",
      "Kunwarpura B.O": "472118",
      "Bhanpura B.O": "472115",
      "Dohochak B.O": "472115",
      "Gouna B.O": "472115",
      "Gora B.O": "472115",
      "Matol B.O": "472115",
      "Purenia B.O": "472115",
      "Sijora B.O": "472115",
      "Judawan B.O": "472005",
      "Pahadi Tilwaran B.O": "472005",
      "Maheba chak B.O": "472331",
      "Nuna B.O": "472331",
      "Bandha B.O": "472101",
      "Barethikhas B.O": "472101",
      "Alampura B.O": "472221",
      "Budore B.O": "472221",
      "Deoraha B.O": "472221",
      "Kachhora B.O": "472221",
      "Jewar B.O": "472447",
      "Uparakhas B.O": "472447",
      "Toriya B.O": "472221",
      "Kailpura B.O": "472111",
      "Nayagaon B.O": "472111",
      "Budera B.O": "472111",
      "Bhelsi B.O": "472111",
      "Nibora B.O": "472118",
      "Paitpura B.O": "472118",
      "Ramgarh B.O": "472118",
      "Sagarwara B.O": "472118",
      "Shah B.O": "472118",
      "Hirapur B.O": "472115",
      "J.M. Khargapur B.O": "472115",
      "Kudila B.O": "472115",
      "Satguwa B.O": "472331",
      "Siyawanikha B.O": "472331",
      "Acharra B.O": "472101",
      "Simarakhurd B.O": "472221",
      "Tanga B.O": "472221",
      "Tikamgarh H.O": "472001",
      "Badagaon S.O": "472010",
      "Baldeogarh S.O": "472111",
      "Jatara S.O": "472118",
      "Khargapur S.O": "472115",
      "Palera S.O": "472221",
      "Tikamgarh Collectrate S.O": "472001",
      "Tikamgarh Purani Tehari S.O": "472001",
      "Digoda S.O": "472339",
      "Lidhora S.O": "472331",
      "Kundeshwar S.O": "472005",
      "Mohangarh S.O": "472101",
      "Tikamgarh City S.O": "472001"
    },
    "NARSINGHPUR": {
      "Kashikhedi B.O": "487330",
      "Suatala B.O": "487330",
      "Tendukheda B.O": "487770",
      "Bhanda B.O": "487334",
      "Bilgua B.O": "487334",
      "Bilthari B.O": "487334",
      "Deedhori B.O": "487551",
      "Gadarwarars B.O": "487551",
      "Imliya(Pipria) B.O": "487551",
      "Siregaon B.O": "487551",
      "Ponia B.O": "487118",
      "Mallahapipria B.O": "487114",
      "Mekh B.O": "487114",
      "Mohas B.O": "487114",
      "Murghakheda B.O": "487114",
      "Simribadi B.O": "487114",
      "Themi B.O": "487114",
      "Bhugwara B.O": "487221",
      "Jobha B.O": "487221",
      "Karelibasti B.O": "487221",
      "Kodhsa B.O": "487221",
      "Attayasa B.O": "487555",
      "Bahmorikala B.O": "487555",
      "Richhai B.O": "487330",
      "Gangai B.O": "487770",
      "Imlia (Kadhely) B.O": "487334",
      "Gotitoriya B.O": "487770",
      "Sukhakhedi B.O": "487770",
      "Beekor B.O": "487334",
      "Chhatarpur B.O": "487334",
      "Bharheta B.O": "487551",
      "Bikrampur B.O": "487118",
      "Chandankheda B.O": "487441",
      "Devnagar(Purana) B.O": "487118",
      "Gohchar B.O": "487118",
      "Jamunia B.O": "487118",
      "Jhotshwar B.O": "487118",
      "Kamod B.O": "487118",
      "Kanjai B.O": "487118",
      "Surwari B.O": "487118",
      "Umria B.O": "487118",
      "Dongargaon B.O": "487114",
      "Mohad B.O": "487221",
      "Pipria(Linga) B.O": "487221",
      "Ricchawar B.O": "487555",
      "Deori B.O": "487330",
      "Magdhgula B.O": "487661",
      "Mehragaon B.O": "487661",
      "Deguwa B.O": "487441",
      "Dungria(Hemra) B.O": "487441",
      "Gaghrolakala B.O": "487441",
      "Garha B.O": "487441",
      "Kalyanpur B.O": "487441",
      "Khulri B.O": "487441",
      "Bhansapara B.O": "487110",
      "Hiranpur B.O": "487330",
      "Middli B.O": "487330",
      "Padhriya B.O": "487330",
      "Bhama B.O": "487334",
      "Jamada B.O": "487551",
      "Kathotiya B.O": "487551",
      "Nandner B.O": "487551",
      "Barhata B.O": "487118",
      "Belkhedi B.O": "487118",
      "Gundhari B.O": "487118",
      "Khamriya B.O": "487118",
      "Nagwara B.O": "487118",
      "Rakhi B.O": "487118",
      "Simaria B.O": "487118",
      "Jhamar B.O": "487114",
      "Nayagaon B.O": "487114",
      "Karapgaon B.O": "487221",
      "Khursuru B.O": "487221",
      "Madesur B.O": "487221",
      "Ratikararkalas B.O": "487221",
      "Lilwani B.O": "487555",
      "Palohabada B.O": "487555",
      "Sadumar B.O": "487555",
      "Dhilwar B.O": "487337",
      "Banskheda B.O": "487661",
      "Piparia B.O": "487661",
      "Sirsiri B.O": "487661",
      "Amada B.O": "487881",
      "Barhabada B.O": "487881",
      "Kherua B.O": "487881",
      "Singpur B.O": "487881",
      "Chirchra B.O": "487441",
      "Harrai B.O": "487441",
      "Panari B.O": "487441",
      "Ranipiparia B.O": "487110",
      "Usri B.O": "487110",
      "Bhatera B.O": "487555",
      "Bohani B.O": "487555",
      "Imjhira B.O": "487337",
      "Kacharkona B.O": "487337",
      "Piparpani B.O": "487661",
      "Rampura B.O": "487661",
      "Sokalpur B.O": "487661",
      "Bairagarh B.O": "487881",
      "Basuria B.O": "487881",
      "Dungria B.O": "487881",
      "Bhourjhir B.O": "487441",
      "Raipur B.O": "487441",
      "Gorakhpur B.O": "487110",
      "Kapoori B.O": "487110",
      "Amgaonchhota B.O": "487551",
      "Khursipar B.O": "487551",
      "Bagaspur B.O": "487118",
      "Bedu B.O": "487118",
      "Imliya B.O": "487118",
      "Kareli kala B.O": "487118",
      "Lathgaon B.O": "487118",
      "Sarra B.O": "487118",
      "Srinagar B.O": "487118",
      "Ghatpandrai B.O": "487114",
      "Sakal B.O": "487114",
      "Batesra B.O": "487221",
      "Kathotia B.O": "487221",
      "Rakai(Pipria) B.O": "487221",
      "Shahpur B.O": "487221",
      "Chirriya B.O": "487555",
      "Narwara B.O": "487555",
      "BHORA B.O": "487337",
      "Banwari B.O": "487661",
      "Dethpoun B.O": "487661",
      "Neemawar B.O": "487661",
      "Tumra B.O": "487661",
      "Maregaon B.O": "487881",
      "SAHAWAN B.O": "487881",
      "Heerapur B.O": "487441",
      "Neejore B.O": "487441",
      "Kosamkheda B.O": "487110",
      "Dhamna B.O": "487001",
      "Khamtara B.O": "461001",
      "Chinki B.O": "487001",
      "Bahoripar B.O": "487001",
      "Chawarkheda B.O": "487001",
      "Bachai B.O": "487001",
      "Nayakheda B.O": "487001",
      "Nayakheda Bansadehi B.O": "487225",
      "Chhitapar B.O": "487330",
      "Khurpa B.O": "487001",
      "Mungwani B.O": "487001",
      "Dangidhana B.O": "487001",
      "Khamria B.O": "487001",
      "Badhwar B.O": "487225",
      "Barhachhota B.O": "487225",
      "Imlia Boghora B.O": "487225",
      "Bhamni B.O": "487330",
      "Bilhera B.O": "487330",
      "Bitli B.O": "487330",
      "Umaria(Chinki) B.O": "487001",
      "Rampiparia B.O": "487001",
      "Magrdha B.O": "487001",
      "Kerpani B.O": "487001",
      "Niwari B.O": "487225",
      "Chawarpatha B.O": "487330",
      "Dudwara B.O": "487001",
      "Itwarabazar B.O": "487001",
      "Kherinaka B.O": "487001",
      "Devnagarnaya B.O": "487001",
      "Narsinghpur H.O": "487001",
      "Karakbel S.O": "487114",
      "Sainkheda S.O (Narsinghpur)": "487661",
      "Sali Choka Road S.O": "487881",
      "Gotegaon S.O": "487118",
      "Chichli S.O": "487770",
      "Kareli S.O": "487221",
      "Kaudia S.O": "487555",
      "Sihora S.O (Narsinghpur)": "487441",
      "Amgaon Bada S.O": "487225",
      "Barman S.O": "487330",
      "Dobhi S.O (M.P Circle)": "487334",
      "Gadarwara S.O": "487551",
      "Jawaharganj Gadarwara S.O": "487551",
      "Sagoni Tendukheda S.O": "487337",
      "Singhpur S.O (Narsinghpur)": "487110"
    },
    "CHHINDWARA": {
      "Rakhikol B.O": "480555",
      "Bhamodi B.O": "480449",
      "Badsalaiya B.O": "480224",
      "Bargi B.O": "480224",
      "Basuriya B.O": "480224",
      "Ankhiya B.O": "480551",
      "Bamanwara Junnardeo B.O": "480551",
      "Hirdagarh B.O": "480551",
      "Dungaria B.O": "480551",
      "Rangari B.O": "480108",
      "Sawarni B.O": "480108",
      "Pandharakhedi B.O": "480105",
      "Kohka B.O": "480557",
      "Bhandargondi B.O": "480334",
      "Mangurli B.O": "480334",
      "Mordongari Pandhurna B.O": "480334",
      "Rajora Kalan B.O": "480334",
      "Baghbardia B.O": "480441",
      "Rawanwara B.O": "480441",
      "Banabakoda B.O": "480109",
      "Koparwari B.O": "480109",
      "Bhajipani B.O": "480449",
      "Darbai B.O": "480449",
      "Jatachhapar B.O": "480449",
      "Banka B.O": "480224",
      "Batkakhapa B.O": "480224",
      "Ojhaldhana B.O": "480224",
      "Barelipar B.O": "480551",
      "Chikhalmau B.O": "480551",
      "Saonga B.O": "480108",
      "Nandewani B.O": "480105",
      "Lehgadua B.O": "480557",
      "Paijanwara B.O": "480557",
      "Ambada Pandhurna B.O": "480334",
      "Changoba B.O": "480334",
      "Dhaodikhapa B.O": "480334",
      "Lendori B.O": "480334",
      "Nandanwani B.O": "480334",
      "Siratha B.O": "480334",
      "Chhinda B.O": "480441",
      "Palatwara B.O": "480441",
      "Sirgora B.O": "480441",
      "Ridhora Parasia B.O": "480441",
      "Pindrai B.O": "480109",
      "Badnoor B.O": "480331",
      "Lawaghoghari B.O": "480331",
      "Paunar Saoribazar B.O": "480331",
      "Devi B.O": "480106",
      "Jobnikhapa B.O": "480106",
      "Ramakona B.O": "480106",
      "Chicholi Vad B.O": "480337",
      "Hiwara Senadwar B.O": "480337",
      "Bhula Mohgaon B.O": "480223",
      "Dhadhra B.O": "480223",
      "Kaparwari B.O": "480223",
      "Sarna B.O": "480223",
      "Dhusawani B.O": "480559",
      "Jhontkalan B.O": "480559",
      "Lotiya B.O": "480559",
      "Nagri B.O": "480559",
      "Chichkheda B.O": "480338",
      "Chikhalikalan Umaranala B.O": "480107",
      "Lohangi Raiyat B.O": "480107",
      "Ubhegaon B.O": "480107",
      "Sonakhar B.O": "480001",
      "Gangiwara B.O": "480001",
      "Gurraiya B.O": "480001",
      "Rohnakalan B.O": "480001",
      "Bohnakheri B.O": "480001",
      "Barahira B.O": "480221",
      "Chhui B.O": "480221",
      "Pounar Amarwara B.O": "480221",
      "Khamarpani B.O": "480111",
      "Khamra B.O": "480111",
      "Moya B.O": "480111",
      "Munganapar B.O": "480111",
      "Tumragarhi B.O": "480111",
      "Banskheda B.O": "480110",
      "Dilawar Mohgaon B.O": "480110",
      "Top B.O": "480110",
      "Umrad B.O": "480110",
      "Bamhanwara Chourai B.O": "480115",
      "Binjhawara B.O": "480115",
      "Gopalpur B.O": "480115",
      "Kapurdha B.O": "480115",
      "Parsoli Chourai B.O": "480115",
      "Pipariya Mansingh B.O": "480115",
      "Ramgarh B.O": "480115",
      "Rampur B.O": "480555",
      "Nandan B.O": "480555",
      "Bheda B.O": "480224",
      "Bhumka B.O": "480224",
      "Madai B.O": "480224",
      "Datla B.O": "480551",
      "Hanotiya B.O": "480551",
      "Jamkunda B.O": "480551",
      "Navegaon B.O": "480551",
      "Rajadi Pipla B.O": "480105",
      "Belgaon B.O": "480557",
      "Dungaria Titra B.O": "480557",
      "Pandhurna Gujari B.O": "480334",
      "Parsoli Pandhurna B.O": "480334",
      "Ringankhapa B.O": "480334",
      "Umreth B.O": "480441",
      "Urdhan B.O": "480441",
      "Kamthi B.O": "480331",
      "Kanhargaon B.O": "480331",
      "Kaudia B.O": "480331",
      "Mainikhapa B.O": "480331",
      "Mordongari Saoribazar B.O": "480331",
      "Mujawar B.O": "480331",
      "Palakhed B.O": "480331",
      "Lohangi B.O": "480106",
      "Nimni B.O": "480106",
      "Langha B.O": "480337",
      "Rajana B.O": "480337",
      "Saikheda B.O": "480337",
      "Bankanaganpur B.O": "480001",
      "Boria B.O": "480001",
      "Kundalikalan B.O": "480001",
      "Machagora B.O": "480001",
      "Khajari B.O": "480001",
      "Jhilmili B.O": "480001",
      "Markawara B.O": "480221",
      "Petdeori B.O": "480221",
      "Pipariya Rajguru B.O": "480221",
      "Tendanimal BO": "480221",
      "Badgaon Chand B.O": "480110",
      "Sitapar B.O": "480115",
      "Ambada Eklehra B.O": "480449",
      "Palachourai B.O": "480449",
      "Dhanora Jagir B.O": "480224",
      "Gourpani B.O": "480224",
      "Partapur B.O": "480224",
      "Ratamati B.O": "480224",
      "Surlakhapa B.O": "480224",
      "Bhatodia Khurd B.O": "480551",
      "Ghoti B.O": "480108",
      "Kabarpipla B.O": "480108",
      "Khairitaygoan B.O": "480108",
      "Paradsinga Lodhikheda B.O": "480108",
      "Pagara B.O": "480557",
      "Dadimeta B.O": "480334",
      "Dhanora Pandhurna B.O": "480334",
      "Kondhali B.O": "480334",
      "Dighawani B.O": "480441",
      "Gajandoha B.O": "480441",
      "Jhurre Mines B.O": "480441",
      "Khirsadoh B.O": "480441",
      "Ambamali B.O": "480331",
      "Pradhan Ghoghari B.O": "480331",
      "Rajada B.O": "480331",
      "Amladepot B.O": "480106",
      "Berdi B.O": "480106",
      "Bhimalgondi B.O": "480106",
      "Hiwarkhedi B.O": "480223",
      "Jamuniya Singodi B.O": "480223",
      "Jhirlinga B.O": "480223",
      "Badegaon B.O": "480223",
      "Bangaon Singodi B.O": "480223",
      "Chawalpani B.O": "480559",
      "Chhindi Tamia B.O": "480559",
      "Etawa Tamia B.O": "480559",
      "Jhirpa B.O": "480559",
      "Khedikalan B.O": "480338",
      "Lingajatlapur B.O": "480338",
      "Marud B.O": "480338",
      "Pendoni B.O": "480338",
      "Rajegaon B.O": "480107",
      "Bisapur B.O": "480001",
      "Pindraikalan B.O": "480001",
      "Imlikheda B.O": "480001",
      "Mothar B.O": "480001",
      "Ghoghari B.O": "480221",
      "Kudwari B.O": "480221",
      "Richheda B.O": "480221",
      "Seja B.O": "480221",
      "Dhanegaon B.O": "480111",
      "Kadaiya B.O": "480111",
      "Pathari B.O": "480111",
      "Harnakhedi B.O": "480110",
      "Kuhiya B.O": "480110",
      "Barkuhi B.O": "480447",
      "Khuntpipariya B.O": "480115",
      "Panjara B.O": "480115",
      "Sankh B.O": "480115",
      "Sitajhir B.O": "480115",
      "Dungariabhardagarh B.O": "480555",
      "Ghorawari Khurd B.O": "480555",
      "Keolari B.O": "480223",
      "Manegaon B.O": "480223",
      "Meghaseoni B.O": "480223",
      "Sihoramadka B.O": "480223",
      "Bamni B.O": "480559",
      "Bijori B.O": "480559",
      "Kursidhana B.O": "480559",
      "Muttor B.O": "480559",
      "Sangakheda B.O": "480559",
      "Sidholi B.O": "480559",
      "wadegaon B.O": "480338",
      "Jam umaranala B.O": "480107",
      "Mahalpur B.O": "480107",
      "Mau B.O": "480107",
      "Parasgaon B.O": "480107",
      "Bhutai B.O": "480331",
      "Karaghat Kamthi B.O": "480331",
      "Kohat B.O": "480331",
      "Borgaon Sausar B.O": "480106",
      "Jamsaoli B.O": "480106",
      "Ranpeth B.O": "480106",
      "Anjangaon B.O": "480337",
      "Ghoghari Sahani B.O": "480337",
      "Banka Mukasa B.O": "480223",
      "Chania Kalan B.O": "480223",
      "Delakhari B.O": "480559",
      "Jamuniya Tamia B.O": "480559",
      "Mahuljhir B.O": "480559",
      "Bangaon Teegaon B.O": "480338",
      "Etawa Teegaon B.O": "480338",
      "Pipalpani B.O": "480338",
      "Sarangbihri B.O": "480107",
      "Turkikhapa B.O": "480107",
      "Sillewani B.O": "480107",
      "Linga B.O": "480001",
      "Hirawadi B.O": "460663",
      "Umaria Isra B.O": "480001",
      "Mankadehi B.O": "480001",
      "Partala B.O": "480001",
      "Markahandi B.O": "480001",
      "Nonia Karbal B.O": "480001",
      "Paladone B.O": "480001",
      "Dhasanwara B.O": "480221",
      "Jungawani B.O": "480221",
      "Saliwara Sharda B.O": "480221",
      "Sonpur B.O": "480221",
      "Deori B.O": "480111",
      "Ghorad B.O": "480111",
      "Gumgaon B.O": "480110",
      "Meghdone B.O": "480110",
      "Badela B.O": "480115",
      "Khireti B.O": "480115",
      "Kunda B.O": "480115",
      "Samaswara B.O": "480115",
      "Siregaon B.O": "480115",
      "Ghorawari Kalan B.O": "480555",
      "Chhindwara H.O": "480001",
      "Bichhua S.O": "480111",
      "Damua S.O": "480555",
      "Eklehra S.O": "480449",
      "Piplanarayanwar S.O": "480109",
      "Saori Bazaar S.O": "480331",
      "Sausar S.O": "480106",
      "Tamia S.O": "480559",
      "TB Senetorium S.O": "480001",
      "CHANDANGAON SO": "480003",
      "Chitanvisganj S.O": "480001",
      "Gualbra Chhindwara S.O": "480001",
      "Junnardeo S.O": "480551",
      "Teegaon S.O": "480338",
      "Chandametta S.O": "480447",
      "Harrai S.O": "480224",
      "Singodi S.O": "480223",
      "Umaranala S.O": "480107",
      "MOHKHED SO": "480112",
      "Amarwara S.O": "480221",
      "Chand S.O": "480110",
      "Chourai S.O": "480115",
      "Lodhikheda S.O": "480108",
      "Mohgaon Haveli S.O": "480105",
      "Newton Chikhali S.O": "480557",
      "Pandhurna S.O": "480334",
      "Parasia S.O": "480441",
      "Seoni Sausar S.O": "480337"
    },
    "HOSHANGABAD": {
      "Narmal School Hoshangabad B.O": "461001",
      "Sawalkheda B.O": "461001",
      "Aari B.O": "461661",
      "Bachwada B.O": "461661",
      "Khidia B.O": "461775",
      "Maf Babai B.O": "461661",
      "Tal Keshri B.O": "461661",
      "Hirankheda B.O": "461221",
      "Manwara B.O": "461661",
      "Samon B.O": "461661",
      "Babri B.O": "461221",
      "Bhamedi Dev B.O": "461221",
      "Bhiladia B.O": "461221",
      "Chotlay B.O": "461221",
      "GORA B.O": "461001",
      "Raipur BO": "461001",
      "Rohna B.O": "461001",
      "Chaplasar B.O": "461001",
      "Sangakheda Kalan B.O": "461001",
      "Baikhedi B.O": "461001",
      "Hasalpur B.O": "461001",
      "Jasalapur B.O": "461001",
      "Nimsadia B.O": "461001",
      "Sirwar B.O": "461661",
      "Tamcharu B.O": "461661",
      "Baghwara B.O": "461221",
      "Chatarkheda B.O": "461221",
      "Datwasa B.O": "461221",
      "Sukkarwara B.O": "461001",
      "Beekor B.O": "461661",
      "Budhni B.O": "461661",
      "Ganera B.O": "461661",
      "Gujjarwada B.O": "461661",
      "Pathada B.O": "461221",
      "Dangarhai B.O": "461990",
      "Doomer B.O": "461990",
      "Machherakala B.O": "461990",
      "Palia Pipria B.O": "461990",
      "Mohari B.O": "461116",
      "Anhai B.O": "461990",
      "Bachawani B.O": "461990",
      "Gondalwara B.O": "461990",
      "Isharpur B.O": "461990",
      "Rehatwara B.O": "461990",
      "Samnapur B.O": "461990",
      "Singhpur B.O": "461990",
      "Umradha B.O": "461990",
      "Dawakhurd B.O": "461116",
      "Panjara Kalan B.O": "461001",
      "Mangrol  B.O": "461001",
      "Gunora B.O": "461001",
      "Anchalkheda B.O": "461661",
      "Bajjarwada B.O": "461661",
      "Jawali B.O": "461661",
      "Kajal Khedi B.O": "461661",
      "PRtaku B.O": "461111",
      "Rampur B.O": "461775",
      "Saheli B.O": "461111",
      "Saket B.O": "461111",
      "Silwani B.O": "461111",
      "Bhatti B.O": "461115",
      "Bhilakhedi B.O": "461115",
      "Tangna B.O": "461115",
      "Teekhard B.O": "461115",
      "Kherikala B.O": "461775",
      "Matkuli B.O": "461775",
      "Posera B.O": "461775",
      "Punor B.O": "461775",
      "Sahelwara B.O": "461775",
      "Sandia B.O": "461775",
      "Semritala B.O": "461775",
      "Babadiabhau B.O": "461223",
      "Bharlay B.O": "461223",
      "Bisonikala B.O": "461223",
      "Guradia B.O": "461223",
      "Pipliakala B.O": "461223",
      "Roopadeh B.O": "461223",
      "Sivpur B.O": "461223",
      "Bankhedi Reva B.O": "461771",
      "Pipliya Kala B.O": "461551",
      "Bagda Tawa B.O": "461111",
      "Ghatli B.O": "461111",
      "Managaon B.O": "461111",
      "Sukhtawa B.O": "461111",
      "Jamani B.O": "461115",
      "Khaparkheda B.O": "461775",
      "Mokhalwara B.O": "461775",
      "Taronkala B.O": "461775",
      "Pamli B.O": "461668",
      "Sangakhedakhurd B.O": "461668",
      "Bhainsadeh B.O": "461223",
      "Luchgaon B.O": "461223",
      "Nandarwada B.O": "461223",
      "Shobhapur B.O": "461771",
      "Khapriya B.O": "461221",
      "Lodhdi B.O": "461221",
      "Rehda B.O": "461221",
      "Chandon B.O": "461111",
      "Fatehpur B.O": "461990",
      "Malhanwara B.O": "461990",
      "Pipar Pani B.O": "461990",
      "Singhodi B.O": "461990",
      "Misrod B.O": "461116",
      "Semri Khurd B.O": "461116",
      "Bichuwa B.O": "461111",
      "Gajpur B.O": "461111",
      "Gurra B.O": "461111",
      "Kesla B.O": "461111",
      "Luharia B.O": "461111",
      "Pathrota B.O": "461111",
      "Sadhpura B.O": "461111",
      "Sankheda B.O": "461111",
      "Son Talai B.O": "461111",
      "Malothar B.O": "461115",
      "Mehragaon B.O": "461115",
      "Garhaghat B.O": "461775",
      "Machha B.O": "461775",
      "Pachlawara B.O": "461775",
      "Surelakala B.O": "461775",
      "Reshalpur B.O": "461110",
      "Simrodha B.O": "461668",
      "B.Jamani B.O": "461223",
      "Bakabedi B.O": "461223",
      "Bharonpur B.O": "461223",
      "Naharkolakala B.O": "461223",
      "Pagdhal B.O": "461223",
      "Bhatgaon B.O": "461771",
      "Niwari B.O": "461771",
      "Satwasa B.O": "461221",
      "Somalwada B.O": "461221",
      "Tili Awnali B.O": "461221",
      "Jamunia B.O": "461990",
      "Junheta B.O": "461990",
      "Kanhwar B.O": "461990",
      "Karpa B.O": "461990",
      "Bamhangaon B.O": "461116",
      "Tigria B.O": "461116",
      "Dandiwada B.O": "461111",
      "Jujharpur B.O": "461111",
      "Kala Akhar B.O": "461111",
      "Taku B.O": "461111",
      "Baharpur B.O": "461668",
      "Chourahet B.O": "461668",
      "Archnagaon B.O": "461223",
      "Jhaklay B.O": "461223",
      "Kothra B.O": "461223",
      "Bhokhedi Kala B.O": "461771",
      "Dhikwada B.O": "461771",
      "Kalmeshra B.O": "461771",
      "Kamtee B.O": "461771",
      "Dhekna B.O": "461228",
      "Hoshangabad H.O": "461001",
      "Sohagpur R.S. S.O": "461771",
      "OFE Itarsi S.O": "461122",
      "Pachmarhi Cantt S.O": "461881",
      "Pachmarhi S.O": "461881",
      "Seoni Malwa S.O": "461223",
      "Sp Mills Hoshangabad S.O": "461005",
      "Piparia S.O": "461775",
      "Powarkheda S.O": "461110",
      "Semri Harchand S.O": "461668",
      "Surajganj Itarsi S.O": "461111",
      "Tawa Nagar S.O": "461551",
      "Babai S.O (Hoshangabad)": "461661",
      "Itarsi S.O": "461111",
      "NYC Itarsi S.O": "461115",
      "Bankhedi S.O": "461990",
      "Cpe Itarsi S.O": "461114",
      "Hoshangabad City S.O": "461001",
      "Banapura S.O": "461221",
      "Dolaria S.O": "461116",
      "Mangalwara Piparia S.O": "461775",
      "Of Itarsi S.O": "461446"
    },
    "DAMOH": {
      "Bangaon B.O": "470661",
      "Samnapur B.O": "470880",
      "Sanga B.O": "470880",
      "Sarra B.O": "470880",
      "Sarsawagali B.O": "470880",
      "Suhela B.O": "470880",
      "Taradehi B.O": "470880",
      "Marutal B.O": "470661",
      "Belai B.O": "470661",
      "Bhuri B.O": "470661",
      "Khajri B.O": "470661",
      "Umri B.O": "470661",
      "Ballarpur B.O": "470664",
      "Banwar B.O": "470664",
      "Ghat Pipariya B.O": "470664",
      "Kumhari B.O": "470664",
      "Majhguya Hansraj B.O": "470664",
      "Patna Bhangarh B.O": "470664",
      "Pipariya Tikari B.O": "470664",
      "Salaiya B.O": "470664",
      "Agara B.O": "470673",
      "Bakayan B.O": "470673",
      "Kaithora B.O": "470673",
      "Khaderi B.O": "470673",
      "Deori Fatehpur B.O": "470775",
      "Fatehpur B.O": "470775",
      "Ludhora B.O": "470775",
      "Raneh B.O": "470775",
      "Sigrampur B.O": "470881",
      "Singpur B.O": "470881",
      "Chirola B.O": "470675",
      "Bamorimala B.O": "470663",
      "Kevlari B.O": "470666",
      "Kindroh B.O": "470666",
      "Lakhroni B.O": "470666",
      "Nandrai B.O": "470666",
      "Dhangaur Kalan B.O": "470880",
      "Hinoti Putrighat B.O": "470880",
      "Jhlaun B.O": "470880",
      "Muharai B.O": "470775",
      "Patnaraja B.O": "470880",
      "Bisnakheda B.O": "470661",
      "Mudia B.O": "470661",
      "Jortala B.O": "470661",
      "Bijadongary B.O": "470661",
      "Emlai B.O": "470661",
      "Kuakheda B.O": "470661",
      "Semra Madia B.O": "470661",
      "Pashwaha B.O": "470664",
      "Hathana B.O": "470672",
      "Sarkhadi B.O": "470672",
      "Tindua B.O": "470673",
      "Bandha B.O": "470775",
      "Bardha B.O": "470775",
      "Bari Kanora B.O": "470775",
      "Baroda Kalan B.O": "470775",
      "Hinota Kalan B.O": "470775",
      "Kanti B.O": "470775",
      "Kuakheda Bazi B.O": "470775",
      "Rasilpur B.O": "470775",
      "Sadpur B.O": "470775",
      "Sankuiya  B.O": "470775",
      "Amakheda B.O": "470771",
      "Anu B.O": "470771",
      "Chaurai Kalumar B.O": "470881",
      "Gubra Kalan B.O": "470881",
      "Karanpura B.O": "470881",
      "Kodakalan B.O": "470881",
      "Piparia Champat B.O": "470675",
      "Kishunganj B.O": "470675",
      "Kalehrakheda B.O": "470663",
      "Lakhni B.O": "470663",
      "Chewala B.O": "470772",
      "Deodongra B.O": "470772",
      "Kudai B.O": "470772",
      "Kundalpur B.O": "470772",
      "Abhana B.O": "470661",
      "Khamriya Mojilal B.O": "470661",
      "Khojakhedi B.O": "470661",
      "Ghatera B.O": "470664",
      "Hardua Mangarh B.O": "470664",
      "Emaliya Lanji B.O": "470672",
      "Ajni B.O": "470673",
      "Kerwana B.O": "470673",
      "Mangola B.O": "470673",
      "Bhaisa B.O": "470775",
      "Bhiloni B.O": "470775",
      "Gaisabad B.O": "470775",
      "Kuarpur B.O": "470775",
      "Luhari B.O": "470775",
      "Muraj B.O": "470775",
      "Rajpura B.O": "470775",
      "Kandipur B.O": "470771",
      "Kusmi Mangarh B.O": "470881",
      "Podimangarh B.O": "470881",
      "Aslana B.O": "470675",
      "Chaupra B.O": "470663",
      "Road B.O": "470663",
      "Bamanpura B.O": "470772",
      "Bhartala B.O": "470772",
      "Padrai B.O": "470772",
      "Bilani B.O": "470666",
      "Jerath B.O": "470666",
      "Satpara B.O": "470666",
      "Bansa Kalan B.O": "470666",
      "Dinari B.O": "470880",
      "Madankheda B.O": "470880",
      "Pura B.O": "470880",
      "Salwada B.O": "470880",
      "Tejgarh B.O": "470880",
      "Bakeni B.O": "470661",
      "Sadguya B.O": "470661",
      "Badagaon B.O": "470661",
      "Jujhar B.O": "470664",
      "Pateriya B.O": "470664",
      "Balakot B.O": "470672",
      "Kumeriya B.O": "470672",
      "Phutera Kalan B.O": "470673",
      "Bhatia B.O": "470775",
      "Binti B.O": "470775",
      "Kaikheda B.O": "470775",
      "Madiyado B.O": "470775",
      "Magron B.O": "470775",
      "Pandajhir B.O": "470775",
      "Sojna B.O": "470775",
      "Teoriya B.O": "470775",
      "Gunji B.O": "470771",
      "Bhajiya B.O": "470881",
      "Korta B.O": "470881",
      "Patnakuya B.O": "470881",
      "Mankaura B.O": "470675",
      "Sitanagar B.O": "470675",
      "Harduya Sadak B.O": "470663",
      "Mojipura B.O": "470663",
      "Sakha B.O": "470663",
      "Barkhera Bais B.O": "470772",
      "Botrai B.O": "470666",
      "Sukha B.O": "470666",
      "Deori Jmadar B.O": "470880",
      "Khamriya Ajitpur B.O": "470880",
      "Ramgarh B.O": "470880",
      "Damoh H.O": "470661",
      "Bandakpur S.O": "470664",
      "Damoh City S.O": "470661",
      "Damoh Collectrate S.O": "470661",
      "Damoh Phutera Ward S.O": "470661",
      "Hatta S.O (Damoh)": "470775",
      "Bansa Tarkheda S.O": "470672",
      "Damoh Civil Ward S.O": "470661",
      "Hatta Bazariya S.O": "470775",
      "Hindoriya S.O": "470771",
      "Jabera S.O": "470881",
      "Nohata S.O": "470663",
      "Tendukheda S.O": "470880",
      "Patera S.O": "470772",
      "Batiagarh S.O": "470673",
      "Damoh Bazaria S.O": "470661",
      "Damoh R S S.O": "470661",
      "Narsingarh S.O": "470675",
      "Pathariya S.O": "470666"
    },
    "VIDISHA": {
      "Khari B.O": "464001",
      "Sihod B.O": "464001",
      "Ahemadpur B.O": "464001",
      "Bhadarbadagaon B.O": "464001",
      "Hansua B.O": "464001",
      "Lashkarpur B.O": "464001",
      "Ambanagar B.O": "464221",
      "Amkhedasukha B.O": "464221",
      "Khander B.O": "464221",
      "Kharpari B.O": "464221",
      "Pawai B.O": "464220",
      "Sojna B.O": "464220",
      "Boodibagrod B.O": "464331",
      "Dhamnod B.O": "464331",
      "Karela B.O": "464226",
      "Khamtala B.O": "464226",
      "Pauanala B.O": "464226",
      "Barbai B.O": "464224",
      "Roshanpiparia B.O": "464224",
      "Shekhpur B.O": "464224",
      "Anandpur B.O": "464114",
      "Javti B.O": "464114",
      "Kacchikheda B.O": "464114",
      "Mundela B.O": "464114",
      "Deokhajuri B.O": "464258",
      "Gadla B.O": "464258",
      "Simarhar B.O": "464001",
      "Mohanakhejda B.O": "464001",
      "Tharr B.O": "464001",
      "Mirzapur B.O": "464001",
      "Gamakhar B.O": "464221",
      "Ghatera B.O": "464221",
      "Kakroada B.O": "464221",
      "Kirwaya B.O": "464221",
      "Markheda B.O": "464221",
      "Barrighat B.O": "464220",
      "Gunnotha B.O": "464331",
      "Indarwas B.O": "464331",
      "Mohammadgarh B.O": "464331",
      "Balabarkheda B.O": "464226",
      "Bishanpur B.O": "464224",
      "Kurwai kaithora B.O": "464224",
      "Murwas B.O": "464114",
      "Nagore B.O": "464258",
      "Seo B.O": "464258",
      "Babli B.O": "464337",
      "Murahar B.O": "464337",
      "Kothicharkalan B.O": "464113",
      "Satpada B.O": "464113",
      "Thanner B.O": "464113",
      "Agrabarkheda B.O": "464111",
      "Bamori Shala B.O": "464228",
      "Banshkhedi Aspal B.O": "464228",
      "BHONRIYA B.O": "464228",
      "Sankalkheda Khurd B.O": "464113",
      "Barkhedajagir B.O": "464111",
      "Dangarwada B.O": "464111",
      "Chitawar B.O": "464228",
      "Dehri B.O": "464228",
      "Jaitpur B.O": "464228",
      "Parsora B.O": "464228",
      "Atarikhejda B.O": "464001",
      "Chirodia B.O": "464001",
      "Sonthar B.O": "464001",
      "Siyasi B.O": "464001",
      "Dudhawari B.O": "464240",
      "Kulhar B.O": "464240",
      "Bareth B.O": "464221",
      "Bhidwasan B.O": "464221",
      "Masoodpur B.O": "464221",
      "Muradpur B.O": "464221",
      "Phupher B.O": "464221",
      "Satpadahat B.O": "464221",
      "Sirnota B.O": "464221",
      "Udaipur B.O": "464221",
      "Uhar B.O": "464221",
      "Andiakala B.O": "464220",
      "Chatholi B.O": "464228",
      "Mungwara B.O": "464220",
      "Mainwada B.O": "464334",
      "Manora B.O": "464331",
      "Pipraha B.O": "464334",
      "Chhirkheda B.O": "464226",
      "Karaiyahat B.O": "464228",
      "Lachayra B.O": "464224",
      "Layra B.O": "464224",
      "Mehalua B.O": "464224",
      "Naukund B.O": "464224",
      "Okhlikheda B.O": "464114",
      "Shaharkheda B.O": "464114",
      "Sunkher B.O": "464114",
      "Unarsikala B.O": "464114",
      "Hinotia B.O": "464258",
      "Ravan B.O": "464258",
      "Ahemadnagar B.O": "464113",
      "Pipaldhar B.O": "464113",
      "Sader B.O": "464111",
      "Sangul B.O": "464111",
      "Wardha B.O": "464111",
      "Deepnakheda B.O": "464228",
      "Garentha B.O": "464228",
      "Jhandwa B.O": "464228",
      "Jhookarhoj B.O": "464228",
      "Mugalsarai B.O": "464228",
      "Ambar B.O": "464001",
      "Uadaigiri B.O": "464001",
      "Naulas B.O": "464001",
      "Imalia B.O": "464001",
      "Serwasa B.O": "464240",
      "Anchda B.O": "464221",
      "Biladhana B.O": "464221",
      "Chhuletha B.O": "464221",
      "Johad B.O": "464221",
      "Mahoo B.O": "464221",
      "Atasemar B.O": "464220",
      "SUMER R.S. B.O": "464220",
      "Haidargarh B.O": "464331",
      "Khamkheda B.O": "464334",
      "Barro B.O": "464226",
      "Bhonrasa B.O": "464224",
      "Dhuan B.O": "464224",
      "Piklone B.O": "464224",
      "Danwas B.O": "464114",
      "Mahoti B.O": "464114",
      "Muraria B.O": "464114",
      "Rusallisahu B.O": "464114",
      "Sankalkheda Kala B.O": "464258",
      "Bandraotha B.O": "464337",
      "Bhalbamora B.O": "464337",
      "Beenjh B.O": "464113",
      "Bichiya B.O": "464111",
      "Bhagwantpur B.O": "464228",
      "Ghatwar B.O": "464228",
      "Rusallidama B.O": "464228",
      "Tal B.O": "464228",
      "Toribagrod B.O": "464228",
      "Semalkhedi B.O": "464228",
      "Unarsikhurd B.O": "464228",
      "Siyalpur B.O": "464228",
      "Vidisha H.O": "464001",
      "Basoda City S.O": "464221",
      "Gulabganj S.O": "464220",
      "Gyraspur S.O": "464331",
      "Shamshabad S.O (Vidisha)": "464111",
      "Nateran S.O": "464258",
      "Pathari S.O (Vidisha)": "464337",
      "Pipalkheda S.O": "464113",
      "Sironj S.O": "464228",
      "Vidisha Mandi S.O": "464001",
      "Tyonda S.O": "464334",
      "Ganjbasoda S.O": "464221",
      "Khamkheda S.O": "464226",
      "Kurwai S.O": "464224",
      "Lateri S.O": "464114",
      "Sironj City S.O": "464228",
      "Vidisha Collectorate S.O": "464001",
      "Vidisha S.A.T.I. S.O": "464001"
    },
    "REWA": {
      "Dewas B.O": "486441",
      "Doha B.O": "486441",
      "Hardi Badi B.O": "486441",
      "Hatwa B.O": "486123",
      "Busaul B.O": "486445",
      "Harrai  Badi B.O": "486445",
      "Jadua B.O": "486445",
      "Jhalwar B.O": "486445",
      "Kakredi B.O": "486445",
      "Khamaria Chaubey B.O": "486445",
      "Baraon B.O": "486331",
      "Delhi B.O": "486111",
      "Bhamra B.O": "486445",
      "Hardua B.O": "486445",
      "Purwa B.O": "486341",
      "Tighara B.O": "486445",
      "Panni B.O": "486333",
      "Naudhiya B.O": "486341",
      "Kulbaheria B.O": "486333",
      "Padar B.O": "486333",
      "Sitapur B.O": "486333",
      "Kushwar B.O": "486445",
      "Badraon B.O": "486448",
      "Belwa Badgaiyan B.O": "486441",
      "Deora B.O": "486441",
      "Jamu B.O": "486441",
      "Chakdahi B.O": "486445",
      "Kumhra Judwani B.O": "486445",
      "Ragauli B.O": "486445",
      "Chachai B.O": "486448",
      "Mado B.O": "486441",
      "Matima B.O": "486441",
      "Hinauta B.O": "486446",
      "Kapsa B.O": "486446",
      "Farahada B.O": "486333",
      "Ratangawan B.O": "486333",
      "Bara B.O": "486445",
      "Jodauri B.O": "486441",
      "Shahpur B.O": "486331",
      "Sujwar B.O": "486441",
      "Tilkhan B.O": "486441",
      "Ataria B.O": "486445",
      "Sukwar B.O": "486446",
      "Basahat B.O": "486226",
      "Chandai B.O": "486226",
      "Chaura B.O": "486226",
      "Hardoli B.O": "486556",
      "Kota B.O": "486556",
      "Madri B.O": "486117",
      "Moharba B.O": "486446",
      "Purani Jagir B.O": "486446",
      "Kakarha B.O": "486226",
      "Mangi B.O": "486226",
      "Sonauri B.O": "486226",
      "Nipania B.O": "486006",
      "Dondar B.O": "486556",
      "Bharigawan B.O": "486341",
      "Judmaniya B.O": "486341",
      "Kanchanpur B.O": "486447",
      "Kandaila B.O": "486441",
      "Nadna B.O": "486441",
      "Palhan B.O": "486441",
      "Sansarpur B.O": "486441",
      "Bahuribandh B.O": "486446",
      "Birkham B.O": "486446",
      "Hardi Saon B.O": "486446",
      "Rahat B.O": "486446",
      "Rupauli B.O": "486446",
      "Atraila B.O": "486447",
      "Dhakhara B.O": "486226",
      "Padri B.O": "486448",
      "Raipur Sonauri B.O": "486226",
      "Khaira B.O": "486006",
      "Amwa B.O": "486446",
      "Khadda B.O": "486446",
      "Badagaon B.O": "486553",
      "Majhigawan B.O": "486440",
      "Sohagi B.O": "486226",
      "Umari Govindpur B.O": "486226",
      "Rausar B.O": "486006",
      "Tamarabasi B.O": "486006",
      "Akauri B.O": "486223",
      "Ghooman B.O": "486556",
      "Kotwa B.O": "486556",
      "Panwar B.O": "486556",
      "Dhangan B.O": "486341",
      "Bhatlo B.O": "486550",
      "Dihiya B.O": "486550",
      "Madwa B.O": "486550",
      "Supiya B.O": "486550",
      "Tikar B.O": "486550",
      "Hardi B.O": "486553",
      "Jaldar B.O": "486553",
      "Karaundi B.O": "486553",
      "Khajuha Kala B.O": "486553",
      "Pantibadi B.O": "486553",
      "Rithi B.O": "486553",
      "Lasa B.O": "486335",
      "Majhgawan B.O": "486335",
      "Baba Ki Barauli B.O": "486223",
      "Bhanigawan B.O": "486223",
      "Bhungawan B.O": "486223",
      "Champagarh B.O": "486223",
      "Khajha B.O": "486223",
      "Patiyari B.O": "486223",
      "Sitlaha B.O": "486223",
      "Bholgarh B.O": "486450",
      "Kachoor B.O": "486450",
      "Hinauti B.O": "486117",
      "Jamui B.O": "486117",
      "Kalwari B.O": "486117",
      "Sarai Unmulan B.O": "486117",
      "Sonversa B.O": "486117",
      "Dubahai Khurd B.O": "486111",
      "Gangeo B.O": "486111",
      "Ghopi B.O": "486111",
      "Madhi B.O": "486111",
      "Mahmoodpur B.O": "486111",
      "Nawagaon B.O": "486111",
      "Pachpahra B.O": "486111",
      "Kuiyakala B.O": "486123",
      "Phool B.O": "486331",
      "Rajadhau B.O": "486331",
      "Vasigada B.O": "486331",
      "Jodhpur B.O": "486338",
      "Sagara B.O": "486338",
      "Saraisenger B.O": "486338",
      "Silpari B.O": "486338",
      "Dhawaiya B.O": "486114",
      "Gorgaon B.O": "486114",
      "Mahsua B.O": "486114",
      "Naudhia B.O": "486114",
      "Kanauja B.O": "486005",
      "Amiliya B.O": "486115",
      "Bandhwa B.O": "486115",
      "Phulha B.O": "486115",
      "Amilki B.O": "486550",
      "Neega B.O": "486550",
      "Badwar B.O": "486553",
      "Bhita B.O": "486553",
      "Mahsaon B.O": "486553",
      "Biradei B.O": "486335",
      "Dhawa  Tiwariyan B.O": "486335",
      "Patehara B.O": "486331",
      "Andwa B.O": "486223",
      "Gada 137 B.O": "486223",
      "Janakhai B.O": "486223",
      "Koniyakala B.O": "486223",
      "Parasiya B.O": "486223",
      "Bihra B.O": "486450",
      "Bans B.O": "486117",
      "Kashiyargaon B.O": "486117",
      "Bakshera B.O": "486440",
      "Sagra B.O": "486440",
      "Sirsa B.O": "486111",
      "Barati B.O": "486123",
      "Dighwar B.O": "486123",
      "Shukulgawan B.O": "486550",
      "Ulahikhurd B.O": "486123",
      "Bahuti B.O": "486331",
      "Damodar  Garh B.O": "486331",
      "Mudaria B.O": "486331",
      "Bhaluha B.O": "486340",
      "Deorihangaon B.O": "486340",
      "Barahula B.O": "486447",
      "Jonha B.O": "486447",
      "Konigadehara B.O": "486447",
      "Look B.O": "486447",
      "Pathat B.O": "486447",
      "Barahadi B.O": "486114",
      "Budhiya B.O": "486114",
      "Padra B.O": "486114",
      "Sura B.O": "486114",
      "Umari B.O": "486448",
      "Ajgarha B.O": "486003",
      "Laxmanpur B.O": "486005",
      "Badhara B.O": "486445",
      "Dagardua B.O": "486115",
      "Handia B.O": "486115",
      "Kharra B.O": "486115",
      "Paharkha B.O": "486115",
      "Paikangaon B.O": "486115",
      "Dubgawan B.O": "486111",
      "Hata B.O": "486335",
      "Kailashpur B.O": "486335",
      "Khodwani B.O": "486335",
      "Naunkala B.O": "486335",
      "Panti B.O": "486335",
      "Tangha B.O": "486223",
      "Unchi Auni B.O": "486223",
      "Kankar B.O": "486117",
      "Khair B.O": "486440",
      "Kharhari B.O": "486440",
      "Majhiyar B.O": "486440",
      "Dwari B.O": "486123",
      "Khaira Kankesra B.O": "486123",
      "Khatkhari B.O": "486331",
      "Misirgawan B.O": "486331",
      "Pahadi B.O": "486331",
      "Deorisengran B.O": "486340",
      "Korigawan B.O": "486340",
      "Rampur  Teonther B.O": "486340",
      "Shivrajpur B.O": "486340",
      "Chaukhandi B.O": "486447",
      "Deokhar B.O": "486447",
      "Babaiya B.O": "486445",
      "Badagaon  Kothar B.O": "486445",
      "Parasi B.O": "486115",
      "Tikuri Unmulan B.O": "486115",
      "Bansa B.O": "486550",
      "Barsaita B.O": "486553",
      "Patauta B.O": "486553",
      "Bijhauli B.O": "486335",
      "Dhausad B.O": "486335",
      "Piprahi B.O": "486335",
      "Gada 138 B.O": "486223",
      "Kuthila B.O": "486223",
      "Negura B.O": "486223",
      "Jay Pee Puram B.O": "486450",
      "Maddepur B.O": "486450",
      "Paipakhara B.O": "486450",
      "Garhwa B.O": "486117",
      "Gondari B.O": "486117",
      "Keoti B.O": "486117",
      "Lalgaon B.O": "486117",
      "Bagadha Pidhihan B.O": "486440",
      "Katki B.O": "486440",
      "Mankahari B.O": "486440",
      "Sathini B.O": "486440",
      "Deogaon B.O": "486111",
      "Joraut B.O": "486111",
      "Raghurajgarh B.O": "486111",
      "Teoni B.O": "486111",
      "Padariya B.O": "486123",
      "Suji B.O": "486123",
      "Tamradesh B.O": "486123",
      "Baheradabar B.O": "486331",
      "Barahata B.O": "486331",
      "Bichharahta B.O": "486331",
      "Gauri B.O": "486331",
      "Patulkhi B.O": "486331",
      "Bhir B.O": "486340",
      "Basrehi B.O": "486447",
      "Itma B.O": "486447",
      "Pariharinpurwa B.O": "486447",
      "Purauna B.O": "486447",
      "Duara B.O": "486338",
      "Belwapaikan B.O": "486114",
      "Ramnai B.O": "486114",
      "Raura B.O": "486114",
      "Sursa B.O": "486114",
      "Ratahara B.O": "486003",
      "Sonaura B.O": "486003",
      "Khaur B.O": "486005",
      "Lohi B.O": "486005",
      "Chaukhadda B.O": "486220",
      "Garhi   Soharwa B.O": "486220",
      "Gondkala B.O": "486220",
      "Janeh B.O": "486220",
      "Sarui B.O": "486220",
      "Dulahara B.O": "486448",
      "Mau B.O": "486448",
      "Amilkoni B.O": "486220",
      "Chandpur B.O": "486220",
      "Soharwa B.O": "486220",
      "Pathari B.O": "486448",
      "Rajgarh B.O": "486448",
      "Sadahana B.O": "486448",
      "Kotrakala B.O": "486220",
      "Kharihan B.O": "486448",
      "Anjora B.O": "486220",
      "Rehi B.O": "486220",
      "Rewa H.O": "486001",
      "Baikunthpur S.O": "486441",
      "Chak S.O": "486226",
      "Dabhaura S.O": "486556",
      "Deotalab S.O": "486341",
      "Mauganj S.O": "486331",
      "Rewa APSU S.O": "486003",
      "Chorahata S.O": "486006",
      "Govindgarh S.O (Rewa)": "486550",
      "Gurh S.O": "486553",
      "Jawa S.O": "486223",
      "Laxmanpur S.O (Rewa)": "486440",
      "Naigarhi S.O": "486340",
      "Raghunathganj S.O": "486338",
      "Beeda S.O": "486446",
      "Garh S.O": "486115",
      "Hanumana S.O": "486335",
      "Manikwar S.O": "486123",
      "Dhera S.O": "486333",
      "Jaypee Nagar S.O": "486450",
      "Katra S.O (Rewa)": "486117",
      "Mangawan S.O": "486111",
      "Patehara S.O": "486447",
      "Raipur Karchulion S.O": "486114",
      "Rewa Bansagar Coloney S.O": "486005",
      "Rewa Chirahula S.O": "486001",
      "Rewa Venkat Bhawan S.O": "486001",
      "Rewa Medical College S.O": "486001",
      "Semariya S.O": "486445",
      "Sirmour S.O": "486448",
      "Teonthar S.O": "486220",
      "Rewa Bicchiya Road S.O": "486001",
      "Rewa City S.O": "486004",
      "Rewa Engineering College S.O": "486002",
      "Rewa Ghoghar Mohalla S.O": "486001",
      "Rewa Uprahaty S.O": "486001",
      "Rewa Chauhatta S.O": "486001"
    },
    "BALAGHAT": {
      "Arambha B.O": "481335",
      "Bhendara B.O": "481335",
      "Chikhla Bandh B.O": "481335",
      "Khadkhadi B.O": "481335",
      "Bamhani B.O": "481449",
      "Pulputta B.O": "481449",
      "Tekadi B.O": "481449",
      "Bhanderi B.O": "481105",
      "Gudma B.O": "481116",
      "Jatta B.O": "481105",
      "Lood B.O": "481105",
      "Songudda B.O": "481105",
      "Birsola B.O": "481331",
      "Chillod B.O": "481331",
      "Deeni B.O": "481331",
      "Ladsada B.O": "481331",
      "Mangejhari B.O": "481331",
      "Piparia Bhandi B.O": "481331",
      "Thanegaon B.O": "481331",
      "Lalpur B.O": "481335",
      "Lawni B.O": "481335",
      "Digdha B.O": "481449",
      "Hardoli B.O": "481449",
      "Paraswaraghat B.O": "481449",
      "Roopjhar B.O": "481105",
      "Jhaliwada B.O": "481331",
      "Kaydi B.O": "481331",
      "Khamariya Bazar B.O": "481331",
      "Koste B.O": "481331",
      "Mendki B.O": "481331",
      "Neelji B.O": "481331",
      "Koylari B.O": "481449",
      "Lingapounar B.O": "481449",
      "Mahkepar B.O": "481449",
      "Miragpur B.O": "481449",
      "Nandi B.O": "481449",
      "Sonpuri B.O": "481105",
      "Garra B.O": "481001",
      "Deori B.O": "481449",
      "Amai B.O": "481335",
      "Bakera B.O": "481335",
      "Ghoti B.O": "481441",
      "Kothurna B.O": "481335",
      "Navegaon 3 B.O": "481335",
      "Salebardi B.O": "481335",
      "Goreghat B.O": "481449",
      "Pouniya B.O": "481449",
      "Sukli B.O": "481449",
      "Dora B.O": "481105",
      "Kiniya Kandai B.O": "481105",
      "Pondi B.O": "481117",
      "Badgaon B.O": "481222",
      "Kaspur B.O": "481331",
      "Mehndiwada B.O": "481331",
      "Newargaon B.O": "481441",
      "Samnapur B.O": "481001",
      "Gongalai B.O": "481001",
      "Kumhari B.O": "481001",
      "Mukki B.O": "481111",
      "Dhansua B.O": "481102",
      "Bakal B.O": "481051",
      "Bijatola B.O": "481051",
      "Ramrama B.O": "481332",
      "Saongi R.S. B.O": "481332",
      "Sirpur B.O": "481332",
      "Sijhora B.O": "481117",
      "Khara B.O": "481226",
      "Mauda B.O": "481226",
      "Mohgaon khurd B.O": "481226",
      "Newargaon Kala B.O": "481226",
      "Devalgaon B.O": "481224",
      "Kulpa B.O": "481224",
      "Kumharikala B.O": "481224",
      "Miriya B.O": "481224",
      "Mohgaon Dhapera B.O": "481001",
      "Amgaon B.O": "481111",
      "Kalegaon B.O": "481111",
      "Khurmundi B.O": "481111",
      "Ameda B.O": "481222",
      "Chalisbodi B.O": "481102",
      "Damoh B.O": "481051",
      "Kachnari B.O": "481051",
      "Saletekari B.O": "481051",
      "Agri B.O": "481332",
      "Katanjhari B.O": "481332",
      "Jaitpuri B.O": "481117",
      "Pandutala B.O": "481117",
      "Chikhla B.O": "481226",
      "Kariadand B.O": "481226",
      "Seoni Sarad B.O": "481226",
      "Manegaon B.O": "481051",
      "Tumsar B.O": "481445",
      "Bhandarbodi B.O": "481337",
      "Kachekhani B.O": "481337",
      "Khairi B.O": "481337",
      "Saori B.O": "481337",
      "Kandrikala B.O": "481115",
      "Laweri B.O": "481115",
      "Pala B.O": "481115",
      "Temni B.O": "481115",
      "Jam B.O": "481445",
      "Khari B.O": "481441",
      "Nagpura B.O": "481441",
      "Ghunadi B.O": "481551",
      "Nagarwada R.S. B.O": "481551",
      "Bolegaon B.O": "481222",
      "Maneri B.O": "481222",
      "Pathargaon B.O": "481222",
      "Janpur B.O": "481116",
      "Karhu B.O": "481116",
      "Bhikewada B.O": "481556",
      "Dongariya B.O": "481556",
      "Kurenda B.O": "481556",
      "Roshna B.O": "481001",
      "Banera B.O": "481445",
      "Katedara B.O": "481445",
      "Katera B.O": "481445",
      "Mowad B.O": "481337",
      "Bhanegaon B.O": "481115",
      "Borgaon B.O": "481115",
      "Dahedi B.O": "481115",
      "Bakoda B.O": "481441",
      "Bori B.O": "481441",
      "Dadiya B.O": "481441",
      "Gudru R.S. B.O": "481551",
      "Kochewada B.O": "481551",
      "Mohgaon Batua B.O": "481551",
      "Moriya B.O": "481551",
      "Bisoni B.O": "481222",
      "Nikkum B.O": "481116",
      "Linga B.O": "481001",
      "Thema B.O": "481556",
      "Kanki B.O": "481001",
      "Majhgaon B.O": "481111",
      "Piparia B.O": "481111",
      "Sarekha B.O": "481111",
      "Boda B.O": "481111",
      "Garra Tola B.O": "481051",
      "Kinia B.O": "481051",
      "Tingipur B.O": "481051",
      "Jarah Mohgaon B.O": "481332",
      "Kukarra B.O": "481117",
      "Keshalewada B.O": "481226",
      "Mate B.O": "481226",
      "Saleteka B.O": "481337",
      "Bahela B.O": "481224",
      "Ghansa B.O": "481224",
      "Ladsa B.O": "481224",
      "Sadra B.O": "481224",
      "Agasi B.O": "481445",
      "Khamaria B.O": "481445",
      "Selwa B.O": "481445",
      "Kumhali B.O": "481337",
      "Shankar Pipariya B.O": "481337",
      "Hirri B.O": "481115",
      "Kinhi B.O": "481115",
      "Bagholi B.O": "481556",
      "Kanjai B.O": "481441",
      "Magardarra B.O": "481001",
      "Birwa B.O": "481111",
      "Kareli B.O": "481111",
      "Mandai B.O": "481051",
      "Relwahi B.O": "481051",
      "Kochewahi B.O": "481332",
      "Alna B.O": "481117",
      "Beni B.O": "481331",
      "Budhi B.O": "481226",
      "Hatta Road B.O": "481226",
      "Atri B.O": "481337",
      "Bhaurgarh B.O": "481337",
      "Fulchur B.O": "481337",
      "Katori B.O": "481337",
      "Mohjhari B.O": "481115",
      "Nakshi B.O": "481115",
      "Rajegaon B.O": "481115",
      "Ramgarhi B.O": "481115",
      "Rankakodi B.O": "481115",
      "Sewati B.O": "481115",
      "Sihora B.O": "481441",
      "Padriganj R.S B.O": "481551",
      "Kalimati B.O": "481222",
      "Newarwahi B.O": "481222",
      "Risewara B.O": "481222",
      "Sawari B.O": "481222",
      "Sonarkakodi B.O": "481222",
      "Dewarbeli B.O": "481222",
      "Mohgaon (B) B.O": "481116",
      "Bhidi B.O": "481556",
      "Charegaon R.S. B.O": "481551",
      "Nandora B.O": "481222",
      "Karamsara B.O": "481116",
      "Chandana B.O": "481556",
      "Kharpadia B.O": "481556",
      "Balaghat H.O": "481001",
      "Budbuda S.O": "481332",
      "Karanja S.O (Balaghat)": "481224",
      "Kirnapur S.O": "481115",
      "Rampaily S.O": "481335",
      "Sarekha kosmi S.O": "481001",
      "Tirodi S.O": "481449",
      "Ukwa S.O": "481105",
      "Bharveli S.O": "481102",
      "Birsa S.O": "481051",
      "Lamta S.O": "481551",
      "Lanji S.O": "481222",
      "Malanjkhand S.O": "481116",
      "Baihar S.O": "481111",
      "Hatta S.O (Balaghat)": "481226",
      "Katangi S.O (Balaghat)": "481445",
      "Khairlanji S.O": "481337",
      "Paraswada S.O": "481556",
      "Waraseoni S.O": "481331",
      "Balaghat City S.O": "481001",
      "Garhi S.O (Balaghat)": "481117",
      "Lalbarra S.O": "481441"
    },
    "SIDHI": {
      "Bhadaura B.O": "486669",
      "Bhuimad B.O": "486669",
      "Gijwar B.O": "486669",
      "Juri B.O": "486669",
      "Pathraula B.O": "486669",
      "Tikri B.O": "486669",
      "Bhagohar B.O": "486666",
      "Karmai B.O": "486666",
      "Karwahi B.O": "486666",
      "Medra B.O": "486666",
      "Pand B.O": "486666",
      "Amiliha B.O": "486775",
      "Kusmi B.O": "486669",
      "Mahkhor B.O": "486669",
      "Danga B.O": "486666",
      "Gajri B.O": "486666",
      "Pondi Bastua B.O": "486666",
      "Saleha B.O": "486666",
      "Tala B.O": "486666",
      "Umaria B.O": "486666",
      "Ukarha B.O": "486771",
      "Tansar B.O": "486669",
      "Chamradol B.O": "486666",
      "Chingwah B.O": "486666",
      "Khadaura B.O": "486666",
      "Kota B.O": "486666",
      "Pokhra B.O": "486675",
      "Pondi Jodauri B.O": "486669",
      "Barmani B.O": "486666",
      "Kamachh B.O": "486666",
      "Lurghuti B.O": "486666",
      "Naudhiya B.O": "486661",
      "Barambaba B.O": "486661",
      "Kukrijhar B.O": "486661",
      "Raiduaria B.O": "486776",
      "Dhanha B.O": "486771",
      "Kudia B.O": "486775",
      "Madha B.O": "486775",
      "Maura B.O": "486775",
      "Amilia B.O": "486670",
      "Baghor B.O": "486670",
      "Mahrajpur B.O": "486661",
      "Barbandha B.O": "486675",
      "Banjari B.O": "486661",
      "Madwa B.O": "486661",
      "Padkhuri B.O": "486661",
      "Amarpur B.O": "486675",
      "Chandwahi B.O": "486675",
      "Amlai B.O": "486776",
      "Budgauna B.O": "486776",
      "Naikin B.O": "486776",
      "Patna B.O": "486776",
      "Badhaura B.O": "486771",
      "Badkhara B.O": "486771",
      "Kamarjee B.O": "486771",
      "Chaufal B.O": "486661",
      "Panwar B.O": "486661",
      "Padri B.O": "486675",
      "Bagad B.O": "486776",
      "Chorgadhi B.O": "486776",
      "Badokhar B.O": "486771",
      "Chakdaur B.O": "486771",
      "Dihuli B.O": "486771",
      "Jhalwar B.O": "486771",
      "Kapuri B.O": "486771",
      "Lakauda B.O": "486771",
      "Mohania B.O": "486771",
      "Salaiya B.O": "486771",
      "Gordaha B.O": "486775",
      "Gujder B.O": "486775",
      "Kandhwar B.O": "486775",
      "Bichhi B.O": "486670",
      "Chitwaria B.O": "486670",
      "Kulakwar B.O": "486670",
      "Sudwar B.O": "486670",
      "Teekar B.O": "486670",
      "Karaundia B.O": "486771",
      "Padainia B.O": "486661",
      "Kuchwahi B.O": "486675",
      "Bamuri B.O": "486670",
      "Khoh Gandhi Gram B.O": "486661",
      "Kochila B.O": "486661",
      "Upni B.O": "486661",
      "Paraswar B.O": "486675",
      "Amarwah B.O": "486661",
      "Hadbado B.O": "486661",
      "Jamuar B.O": "486675",
      "Kubri B.O": "486675",
      "Baghwari B.O": "486661",
      "Laua B.O": "486675",
      "Nakjhar B.O": "486675",
      "Piprohar B.O": "486661",
      "Kolhudih B.O": "486771",
      "Kushmahar B.O": "486771",
      "Kuspari B.O": "486771",
      "Mawai B.O": "486771",
      "Sanda B.O": "486771",
      "Semaria Pondi B.O": "486771",
      "Tikatkala B.O": "486771",
      "Khaddi B.O": "486775",
      "Ghoghra B.O": "486670",
      "Hinauti B.O": "486670",
      "Karauli Khurd B.O": "486670",
      "Pahadi B.O": "486670",
      "Sonbarsha B.O": "486670",
      "Supela B.O": "486670",
      "Bamhani B.O": "486661",
      "Patulkhi B.O": "486675",
      "Baghwar B.O": "486776",
      "Raghunathpur B.O": "486776",
      "Baghaun B.O": "486771",
      "Dadhia B.O": "486771",
      "Hanumangarh B.O": "486771",
      "Hatwakhas B.O": "486771",
      "Pachokhar B.O": "486771",
      "Bhitri B.O": "486775",
      "Jhanjh B.O": "486775",
      "Mamdar B.O": "486775",
      "Bithauli B.O": "486670",
      "Kodaura B.O": "486670",
      "Belha B.O": "486675",
      "Khuteli B.O": "486675",
      "Gadababan Singh B.O": "486661",
      "Sarda B.O": "486675",
      "Tarka B.O": "486675",
      "Sidhi H.O": "486661",
      "Bahri S.O": "486675",
      "Bharatpur S.O (Sidhi)": "486776",
      "Majauli S.O": "486666",
      "Rampur Naikin S.O": "486775",
      "Sihawal S.O": "486670",
      "Churhat S.O": "486771",
      "Madwas S.O": "486669",
      "Sidhi Collectorate S.O": "486661"
    },
    "SATNA": {
      "Deora B.O": "485115",
      "Laulachh B.O": "486445",
      "Bihra B.O": "486445",
      "Chitgarh B.O": "486445",
      "Golahata B.O": "486445",
      "Obra B.O": "485775",
      "Paraswahi B.O": "485775",
      "Bitma B.O": "485226",
      "Domhai B.O": "485226",
      "Khanch B.O": "485226",
      "Lakhanwah B.O": "485226",
      "Remari B.O": "485226",
      "Bamhauri B.O": "485221",
      "Chund Khurd B.O": "485221",
      "Hatia B.O": "485221",
      "Amkui B.O": "485551",
      "Pahadi B.O": "485771",
      "Kumhari B.O": "485447",
      "Jhali B.O": "485666",
      "Kailashpur Ashram B.O.": "485334",
      "Nawagaon B.O": "485226",
      "Pilikothi B.O": "485334",
      "Kripalpur Harijan Tola B.O": "485113",
      "Sarain B.O": "485113",
      "Itma B.O": "485881",
      "Pondi B.O": "485771",
      "Baraundha B.O": "485331",
      "Bhiamau B.O": "485331",
      "Khohi B.O": "485331",
      "Kondar B.O": "485551",
      "Lalitpur B.O": "486550",
      "Pindra B.O": "485331",
      "Bathia B.O": "485111",
      "Bhenda B.O": "485774",
      "Narwarkala B.O": "485774",
      "Amdarikala B.O": "485446",
      "Ginjara B.O": "485446",
      "Babupur B.O": "485775",
      "Barakhurd B.O": "485881",
      "Ganjas B.O": "485881",
      "Gorhai B.O": "485881",
      "Gulwargujara B.O": "485881",
      "Hinauti B.O": "485881",
      "Lakhaha B.O": "485775",
      "Madhi B.O": "485775",
      "Aber B.O": "485226",
      "Badkhera B.O": "485226",
      "Pagar Khurd B.O": "485226",
      "Pratappur B.O": "485226",
      "Rajarwara B.O": "485441",
      "Sukwaha B.O": "485226",
      "Tighra B.O": "485226",
      "Tihai B.O": "485226",
      "Mehuti B.O": "485221",
      "Dureha B.O": "485551",
      "Gudha B.O": "485551",
      "Jhingodar B.O": "485551",
      "Bhikhampur B.O": "485778",
      "Bigaudi B.O": "485778",
      "Pathara B.O": "485778",
      "Barahana B.O": "485666",
      "Bhainswar B.O": "485666",
      "Mauhar B.O": "485666",
      "Pawaiya B.O": "485666",
      "Raipur B.O": "485666",
      "Birnai B.O": "485113",
      "Ichaul B.O": "485771",
      "Chua B.O": "485331",
      "Hiraundi B.O": "485331",
      "Jhari B.O": "485331",
      "Kailashpur B.O": "485331",
      "Nakaila B.O": "485331",
      "Nardaha B.O": "485331",
      "Dubehi B.O": "485774",
      "Hinauta Kala B.O": "485774",
      "Jariyari B.O": "485774",
      "Kulgarhi B.O": "485446",
      "Patwara B.O": "485446",
      "Rajapur B.O": "485446",
      "Semarwara B.O": "485446",
      "Shyamnagar B.O": "485446",
      "Surdaha B.O": "485446",
      "Deodaha B.O": "485881",
      "Jathaha B.O": "485881",
      "Karra B.O": "485881",
      "Raikwar B.O": "485775",
      "Shivpurwa B.O": "485775",
      "Sonaura Kothar B.O": "485775",
      "Itma Kothar": "485775",
      "Garhwa Kala B.O": "485112",
      "Goraiya B.O": "485881",
      "Khamaria B.O": "485112",
      "Kunwa B.O": "485112",
      "Ghorkat B.O": "485226",
      "Jamuani B.O": "485226",
      "Jhakhaura B.O": "485226",
      "Kalbalia B.O": "485226",
      "Chandai B.O": "485221",
      "Hati B.O": "485221",
      "Khutha B.O": "485221",
      "Kitha B.O": "485221",
      "Mednipur B.O": "485221",
      "Chunha B.O": "485551",
      "Ramgarh B.O": "485778",
      "Tala B.O": "485778",
      "Bamhraula B.O": "485666",
      "Belhata B.O": "485113",
      "Sonwari B.O": "485771",
      "Tighrakala B.O": "485771",
      "Arjunpur B.O": "485331",
      "Pathar Kachhar B.O": "485331",
      "Patna B.O": "485331",
      "Bhatigawan B.O": "485774",
      "Dhaurahara B.O": "485441",
      "Belhai B.O": "485881",
      "Chandwar B.O": "485881",
      "Chhirhai B.O": "485881",
      "Gorsari B.O": "485881",
      "Harrai B.O": "485881",
      "Mauhari Katra B.O": "485775",
      "Pal B.O": "485775",
      "Ramasthan B.O": "485112",
      "Bairahana B.O": "485226",
      "Karigohi B.O": "485226",
      "Kotar B.O": "485226",
      "Dagdiha B.O": "485221",
      "Majhgawa B.O": "485221",
      "Nayagaon B.O": "485221",
      "Marhikala B.O": "485551",
      "Semari B.O": "485551",
      "Gora B.O": "485778",
      "Majhgawan B.O": "485778",
      "Deorikala B.O": "485666",
      "Patihar B.O": "485666",
      "Hardua B.O": "485334",
      "Gada B.O": "485113",
      "Mand B.O": "485113",
      "Sakaria B.O": "485113",
      "Sharda Mata Mandir B.O": "485771",
      "Barua B.O": "485331",
      "Chitahara B.O": "485331",
      "Kelhaura B.O": "485331",
      "Mahtain B.O": "485331",
      "Shahpur B.O": "485331",
      "Singhpur B.O": "485331",
      "Budherua B.O": "485774",
      "Gobri B.O": "485774",
      "Jura B.O": "485774",
      "Magraura B.O": "485774",
      "Mukundpur B.O": "486550",
      "Atra B.O": "485446",
      "Gangwaria B.O": "485446",
      "Hardua Kala B.O": "485446",
      "Rahikwara B.O": "485446",
      "Argat B.O": "485881",
      "Dighiakala B.O": "485881",
      "Govindpur B.O": "485881",
      "Kandwari B.O": "485881",
      "New Deorajnagar B.O": "485881",
      "Saria B.O": "485881",
      "Sonadi B.O": "485881",
      "Jamuna B.O": "485115",
      "Semaria B.O": "485115",
      "Bihara B.O": "485111",
      "Padkhuri B.O": "485111",
      "Richhahari B.O": "485111",
      "Latagaon B.O": "485772",
      "Madai B.O": "485447",
      "Kadsara B.O": "485447",
      "Karhi Kala B.O": "485447",
      "Khamharia Khurd B.O": "485447",
      "Raund B.O": "485447",
      "Umarahat B.O": "485447",
      "Usrar B.O": "485447",
      "Moodha B.O": "485441",
      "Raigaon B.O": "485441",
      "Sitpura B.O": "485441",
      "Bihata B.O": "485661",
      "Karhikala B.O": "485661",
      "Mankisar B.O": "485881",
      "Bela B.O": "485115",
      "Jhiriya B.O": "485115",
      "Silpari B.O": "485115",
      "Tapa B.O": "485115",
      "Teondhari B.O": "485115",
      "Chhibaura B.O": "485111",
      "Deomaudaldal B.O": "485111",
      "Sijehata B.O": "485111",
      "Satna Siding B.O": "485114",
      "Ajmain B.O": "485772",
      "Satna Kanwarnagar B.O": "485005",
      "Chorwari B.O": "485447",
      "Bachwai B.O": "485441",
      "Mirgauti B.O": "485881",
      "Sagauni B.O": "485881",
      "Sulkhama B.O": "485881",
      "Aira B.O": "485115",
      "Jhand B.O": "485115",
      "Kakalpur B.O": "485115",
      "Karhilami B.O": "485115",
      "Mahudar B.O": "485115",
      "Barti B.O": "485111",
      "Janardanpur B.O": "485111",
      "Kandaila B.O": "485111",
      "Bharjuna Kala B.O": "485114",
      "Amatara B.O": "485772",
      "Bhadanpur B.O": "485772",
      "Ama B.O": "485447",
      "Shivrajpur B.O": "485447",
      "Bandhi B.O": "485441",
      "Berma B.O": "485773",
      "Kharemseda B.O": "485775",
      "Kharwahi B.O": "485775",
      "Bharhut B.O": "485001",
      "Loharaura B.O": "485001",
      "Bhumkahar B.O": "485001",
      "Mahadeva B.O": "485001",
      "Binaika B.O": "485773",
      "Itahara B.O": "485773",
      "Beeda B.O": "485775",
      "Kakra Karhi B.O": "485775",
      "Pithurabad B.O": "485001",
      "Sabhaganj B.O": "485773",
      "Bhatnawara B.O": "485001",
      "Rampur Gandhi Gram B.O": "485001",
      "Bagha B.O": "485001",
      "Kusendi B.O": "485773",
      "Pakaria B.O.": "485773",
      "Ahirgaon B.O": "485775",
      "Asrar B.O": "485775",
      "Majhtolwa B.O": "485881",
      "Marjadpur B.O": "485881",
      "Baheliabaht B.O": "485115",
      "Chormari B.O": "485115",
      "Jhinna B.O": "485115",
      "Krishngarh B.O": "485115",
      "Bairiha B.O": "485111",
      "Bakia B.O": "485111",
      "Ganjan B.O": "485111",
      "Badera B.O": "485772",
      "Dhanwahi B.O": "485772",
      "Badkhar B.O": "485005",
      "Basudha B.O": "485447",
      "Pangara B.O": "485447",
      "Barethiya B.O": "485441",
      "Hilaundha B.O": "485441",
      "Itmanaditeer B.O": "485001",
      "Patura B.O": "485001",
      "Lagargawan B.O": "485001",
      "Satna Mukhtiyarganj B.O.": "485775",
      "Ghunwara B.O": "485773",
      "Jhukehi B.O": "485773",
      "Semara B.O": "485773",
      "Chorhata B.O": "485775",
      "Khajuri Tal B.O": "485775",
      "Satna H.O": "485001",
      "Kathaha S.O": "485778",
      "M G  G V chitrakoot S.O": "485334",
      "Nagod S.O": "485446",
      "Ramvan S.O": "485111",
      "Singhpur S.O (Satna)": "485447",
      "Sohawal S.O": "485441",
      "Unchehara S.O": "485661",
      "Amarpatan S.O": "485775",
      "Jaso S.O": "485551",
      "Madhogarh S.O (Satna)": "485113",
      "Maihar S.O": "485771",
      "Ramnagar S.O (Satna)": "485881",
      "Sarlanagar S.O": "485772",
      "Amadara S.O": "485773",
      "Babupur S.O": "485112",
      "Birsinghpur S.O": "485226",
      "Jaitwara S.O": "485221",
      "Kothi S.O (Satna)": "485666",
      "Nadan S.O": "485774",
      "Rampur Baghelan S.O": "485115",
      "Sagmania S.O": "485114",
      "Satna Civil Line S.O": "485001",
      "Satna Jawahar Nagar S.O": "485001",
      "Satna Semaria Chowk S.O": "485001",
      "Majhgawan S.O": "485331",
      "Satna Birla Vikas S.O": "485005",
      "Satna Tikuria Tola S.O": "485001"
    },
    "SINGRAULI": {
      "Darbari B.O": "486881",
      "Purail B.O": "486881",
      "Sarai B.O": "486881",
      "Saraundha B.O": "486881",
      "Tingudi B.O": "486881",
      "Dhauhani B.O": "486669",
      "Pokhra B.O": "486892",
      "Geer B.O": "486881",
      "Amo B.O": "486881",
      "Banjari B.O": "486669",
      "Rajaniya B.O": "486669",
      "Mahuagaon B.O": "486669",
      "Nigri B.O": "486669",
      "Dudhmania B.O": "486892",
      "Gondwali B.O": "486892",
      "Karaila B.O": "486892",
      "Pachaur B.O": "486886",
      "Pateri B.O": "486892",
      "Pipra B.O": "486892",
      "Chandwar B.O": "486881",
      "Chatainiha B.O": "486881",
      "Dhonga B.O": "486881",
      "Jhakhrawal B.O": "486881",
      "Barka B.O": "486669",
      "Jhara B.O": "486669",
      "Karda B.O": "486669",
      "Niwas B.O": "486669",
      "Badkud B.O": "486882",
      "Keontali B.O": "486882",
      "Khurmucha B.O": "486882",
      "Sakaria B.O": "486882",
      "Churkee B.O": "486889",
      "Jhingurdah B.O": "486889",
      "Bindul B.O": "486886",
      "Jarha B.O": "486886",
      "Karsualal B.O": "486886",
      "Rajmilan B.O": "486886",
      "Tiyara B.O": "486886",
      "Gangi B.O": "486882",
      "Gopla B.O": "486882",
      "Khaidar B.O": "486882",
      "Naikahwa B.O": "486882",
      "Suda B.O": "486882",
      "Singrauli R.S. B.O": "486889",
      "Daga Bargawan B.O": "486886",
      "Mada B.O": "486886",
      "Odgadi B.O": "486886",
      "Piprakhurand B.O": "486886",
      "Kachnimamla B.O": "486887",
      "Bairdah B.O": "486882",
      "Bardi B.O": "486882",
      "Deora B.O": "486882",
      "Dharauli B.O": "486882",
      "Lamsarai B.O": "486882",
      "Misirgrawan B.O": "486882",
      "Rajabar B.O": "486882",
      "Khanua B.O": "486886",
      "Khutar B.O": "486886",
      "Makrohar B.O": "486886",
      "Ghoghra B.O": "486882",
      "Jhagrauha B.O": "486882",
      "Karthua B.O": "486882",
      "Khatai B.O": "486882",
      "Korsar B.O": "486882",
      "Bandha B.O": "486886",
      "Jamgadhi B.O": "486886",
      "Pondi Naugai B.O": "486886",
      "Shahpur B.O": "486886",
      "Gorbi S.O": "486892",
      "Jiawan S.O": "486881",
      "Vindhyanagar S.O": "486885",
      "Nigahi Project S.O": "486884",
      "Amlori Project S.O": "486887",
      "Chitrangi S.O": "486882",
      "Dudhichua Project S.O": "486888",
      "Jayant Colliery S.O": "486890",
      "Singrauli Colliery S.O": "486889",
      "Waidhan S.O": "486886"
    },
    "CHHATARPUR": {
      "Chauka B.O": "471301",
      "Dikoli B.O": "471301",
      "Kheron B.O": "471301",
      "Matgawan B.O": "471301",
      "Galan B.O": "471111",
      "Tila B.O": "471111",
      "Badagaon B.O": "471405",
      "Deri B.O": "471315",
      "Gaharwar B.O": "471315",
      "Nandgain Kala B.O": "471315",
      "Pahadgaon B.O": "471315",
      "Bamhori Pura B.O": "471510",
      "Dhadari B.O": "471001",
      "Kayan B.O": "471311",
      "Kharduti B.O": "471311",
      "Maharajganj B.O": "471311",
      "Melwar B.O": "471311",
      "Sadawa B.O": "471311",
      "Sendpa B.O": "471311",
      "Basari B.O": "471105",
      "Hatawaha B.O": "471405",
      "Jatashankar B.O": "471405",
      "Jetpur B.O": "471405",
      "Khariyani B.O": "471405",
      "Kupishahpura B.O": "471405",
      "Bamhori B.O": "471318",
      "Deopur B.O": "471318",
      "Garhi Semra B.O": "471318",
      "Balkora B.O": "471525",
      "Banjari B.O": "471525",
      "Bansiya B.O": "471525",
      "Belahari B.O": "471525",
      "Gohani B.O": "471525",
      "Goyra B.O": "471525",
      "Hathohan B.O": "471525",
      "Dhamna B.O": "471101",
      "Semariya B.O": "471313",
      "Angore B.O": "471301",
      "Bardwha B.O": "471301",
      "Kararaganj B.O": "471111",
      "Bandhikala B.O": "471315",
      "Jeoraha B.O": "471510",
      "Mudahara B.O": "471510",
      "Patha B.O": "471510",
      "Aktonha B.O": "471515",
      "Dhawad B.O": "471606",
      "Katehra B.O": "471515",
      "Paharapurwa B.O": "471606",
      "Udaipura B.O": "471606",
      "Baraha B.O": "471516",
      "Khaddi B.O": "471516",
      "Panchampur B.O": "471515",
      "Ragoli B.O": "471408",
      "Budrakh B.O": "471501",
      "Maniya B.O": "471501",
      "Bilahri B.O": "471201",
      "Doni  (P) B.O": "471201",
      "Doriya B.O": "471201",
      "Maheba B.O": "471201",
      "Lalpur B.O": "471625",
      "Nahdora  B.O": "471625",
      "Lakhanguwan B.O": "471408",
      "Nandgain Battain B.O": "471408",
      "Kalani B.O": "471001",
      "Bamni B.O": "471311",
      "Rajpura B.O": "471311",
      "Karri B.O": "471105",
      "Kharrohi B.O": "471105",
      "Otapurwa B.O": "471105",
      "Salaiya B.O": "471315",
      "Chandora B.O": "471510",
      "Chitehari B.O": "471510",
      "Prakash bamhori B.O": "471510",
      "Rampur B.O": "471201",
      "Tehanga B.O": "471515",
      "Thakurra B.O": "471516",
      "Bara B.O": "471501",
      "Banchhora B.O": "471201",
      "Jhinjhan B.O": "471201",
      "Vikarampur B.O": "471625",
      "Padariya B.O": "471408",
      "Dharampura B.O": "471405",
      "Kherakala B.O": "471405",
      "Nayatal B.O": "471405",
      "Pipat B.O": "471405",
      "Nenagiri B.O": "471318",
      "Pondi B.O": "471318",
      "Bhawanipur B.O": "471515",
      "Churiyari B.O": "471525",
      "Katiya B.O": "471515",
      "Kandela B.O": "471525",
      "Ramjhala B.O": "471525",
      "Singhpur B.O": "471525",
      "Imlaha B.O": "471101",
      "Selon B.O": "471101",
      "Kurraha B.O": "471411",
      "Ujara B.O": "471411",
      "Ramtoriya B.O": "471313",
      "Niwari B.O": "471001",
      "Saura B.O": "471001",
      "Dargawan B.O": "471311",
      "Deoran B.O": "471311",
      "Dhangawan B.O": "471311",
      "Dhimarwara B.O": "471311",
      "Ganj B.O": "471105",
      "Ghoora B.O": "471105",
      "Jamtuli B.O": "471105",
      "Pahara B.O": "471516",
      "Shahgarh B.O": "471405",
      "Junwani B.O": "471405",
      "Surajpur Kala B.O": "471405",
      "Saidara B.O": "471318",
      "Sunwaha B.O": "471318",
      "Kotheha B.O": "471525",
      "Mahyawa B.O": "471525",
      "Naharpur B.O": "471525",
      "Sarwai B.O": "471525",
      "Bari B.O": "471411",
      "Nuna B.O": "471411",
      "Bamnora B.O": "471313",
      "Barethi B.O": "471313",
      "Bhagwan B.O": "471313",
      "Budore B.O": "471301",
      "Gorakh Pura B.O": "471313",
      "Kutora B.O": "471313",
      "Panwari B.O": "471313",
      "Sewar B.O": "471313",
      "Alipura B.O": "471111",
      "Churwari B.O": "471111",
      "Panotha B.O": "471315",
      "Didwara B.O": "471510",
      "Gurhakala B.O": "471515",
      "Lakheri B.O": "471606",
      "Muderi B.O": "471606",
      "Gahwara B.O": "471516",
      "Ghoorchitehri B.O": "471515",
      "Gudhora B.O": "471515",
      "Manuriya B.O": "471516",
      "Nathpur B.O": "471501",
      "Seondi B.O": "471501",
      "Sighpur B.O": "471501",
      "Tatam B.O": "471501",
      "Barakiratpura B.O": "471201",
      "Garroli B.O": "471201",
      "Sukwan B.O": "471201",
      "Tidani B.O": "471201",
      "Daharra B.O": "471625",
      "Khajuwa B.O": "471625",
      "Kurela B.O": "471625",
      "Bandani B.O": "471408",
      "Bhera B.O": "471408",
      "Darguwan B.O": "471408",
      "Gatheora B.O": "471001",
      "Bagouta B.O": "471001",
      "Sarkana B.O": "471313",
      "Atrar B.O": "471301",
      "Imaliya B.O": "471111",
      "Kenthokar B.O": "471111",
      "Sarsed B.O": "471111",
      "Achatta B.O": "471315",
      "Behata B.O": "471315",
      "Abhau B.O": "471510",
      "Badora Kala B.O": "471510",
      "Kherakasar B.O": "471510",
      "Beniganj B.O": "471606",
      "Tikuri B.O": "471606",
      "Bagmau B.O": "471515",
      "Chandpura B.O": "471516",
      "Hanukhera B.O": "471516",
      "Persania B.O": "471515",
      "Sijai B.O": "471515",
      "Dumra B.O": "471501",
      "Mankari B.O": "471501",
      "Bangain B.O": "471201",
      "Dhamora B.O": "471201",
      "Lugasi B.O": "471201",
      "Mau Sahnia B.O": "471201",
      "Willa B.O": "471625",
      "Himmatpura B.O": "471408",
      "NEGUWAN B.O": "471408",
      "Bajna B.O": "471311",
      "Bandha B.O": "471311",
      "Kheri B.O": "471105",
      "Amronia B.O": "471405",
      "Deora B.O": "471405",
      "Kishangarh B.O": "471405",
      "Panagar B.O": "471405",
      "Ranital B.O": "471405",
      "Deori B.O": "471318",
      "Maddeora B.O": "471318",
      "Newar B.O": "471318",
      "Bachhon B.O": "471525",
      "Chhati Bamhori B.O": "471525",
      "Hinota B.O": "471525",
      "Khadeha B.O": "471525",
      "Ranguwan B.O": "471101",
      "Urdmau B.O": "471411",
      "Chhatarpur H.O": "471001",
      "Badamalehara S.O": "471311",
      "Bijawar S.O": "471405",
      "Chandra Nagar S.O": "471101",
      "Chhatarpur CB S.O": "471001",
      "Gaurihar S.O": "471516",
      "Ishanagar S.O": "471315",
      "Nowgong S.O": "471201",
      "Chandla S.O": "471525",
      "Ghaura S.O": "471313",
      "Harpalpur S.O": "471111",
      "Khajuraho S.O": "471606",
      "Panna Naka Chhatarpur S.O": "471001",
      "Bamitha S.O": "471105",
      "Buxwaha S.O": "471318",
      "Satai S.O": "471408",
      "Gadimalehara S.O": "471411",
      "Gulganj S.O": "471301",
      "Jujhar Nagar S.O": "471510",
      "Laundi S.O": "471515",
      "Maharajpur S.O": "471501",
      "Rajnagar S.O": "471625"
    },
    "BHOPAL": {
      "Raipur B.O": "462101",
      "Ratua Ratanpur B.O": "462101",
      "Sukaliya B.O": "462101",
      "Tarawali Kalan B.O": "462101",
      "Dhaturiya B.O": "463111",
      "Dungariya B.O": "463111",
      "Kulhoar B.O": "463111",
      "Bilakho B.O": "462120",
      "Garha Jangeer B.O": "462120",
      "Barkheda Nathu B.O": "462044",
      "Jhagaria Khurd B.O": "462044",
      "SOS BALGRAM B.O": "462022",
      "Kolua Khurd B.O": "462022",
      "Jamunia Kalan B.O": "462022",
      "Khajuri Sadak B.O": "462030",
      "Kurana B.O": "462036",
      "Tara Sewaniya B.O": "462036",
      "Tumada B.O": "462030",
      "Kalara B.O": "462101",
      "Khukharia B.O": "462101",
      "Kotra Chopra B.O": "462101",
      "Kutkipura B.O": "462101",
      "Arwaliya B.O": "462038",
      "Islam Nagar B.O": "462038",
      "Khamkheda B.O": "462038",
      "Kolukhedi B.O": "462120",
      "Mangal Garh B.O": "462120",
      "Naya Samund B.O": "462120",
      "Balampur B.O": "462010",
      "Imaliya B.O": "462010",
      "Pipaliya Jaheerpeer B.O": "462010",
      "Sukhi Sewania B.O": "462010",
      "Amarawat Kalan B.O": "462042",
      "Bagroda B.O": "462047",
      "Bawadia Kalan B.O": "462026",
      "Sohaya B.O": "463111",
      "Eintkhedi B.O": "462038",
      "Runaha B.O": "462120",
      "Sindhora B.O": "462120",
      "Ratibad B.O": "462044",
      "Mungaliya Hatt B.O": "462036",
      "Basai B.O": "463106",
      "Barkheda Baramad B.O": "462101",
      "Gunga B.O": "462101",
      "Kuthar B.O": "462101",
      "Bawachiya B.O": "463111",
      "Jamusarkalan B.O": "463111",
      "Meghra Kalan B.O": "463111",
      "Bairagarh Chichali B.O": "462042",
      "Mungalia Chhap B.O": "462044",
      "Sewaniya Gond B.O": "462044",
      "Palas Indus Town BO": "462047",
      "Kokta B.O": "462022",
      "Bhouri B.O": "462030",
      "Phanda B.O": "462030",
      "Khitwas B.O": "463106",
      "Laloi B.O": "463106",
      "Pipal Khedi B.O": "463106",
      "Bairagarh Kalan B.O": "462030",
      "Nayapura B.O": "462030",
      "Parwaliya Sadak B.O": "462036",
      "Tila Khedi B.O": "462030",
      "Balachoan B.O": "463106",
      "Sonkachh B.O": "463106",
      "Dhamarra B.O": "462101",
      "Harra Kheda B.O": "462101",
      "Bhopal G.P.O.": "462001",
      "Bhel H.O": "462022",
      "C.T.T.Nagar H.O": "462003",
      "IISER Bhouri S.O": "462066",
      "Itwara S.O": "462001",
      "Jahangirabad S.O (Bhopal)": "462008",
      "Dillod S.O": "462101",
      "Berasia Road S.O": "462001",
      "Chhola Road S.O": "462001",
      "3 EME Centre S.O": "462031",
      "Airport S.O": "462030",
      "Bairagarh S.O": "462030",
      "Gandhi Medical College S.O": "462001",
      "Gandhi Nagar (Bhopal) S.O": "462036",
      "Barkhedi S.O": "462008",
      "Berasia Bhopal S.O": "463106",
      "Chandbad S.O": "462010",
      "Hamidia Road S.O": "462001",
      "Barkheda H.E. S.O": "462022",
      "H.E. Hospital S.O": "462024",
      "Misord S.O": "462047",
      "Regional College S.O": "462002",
      "Satpura S.O": "462004",
      "Shivaji Nagar S.O (Bhopal)": "462016",
      "Suraj Nagar S.O": "462044",
      "Trilanga S.O": "462039",
      "AIIMS S.O": "462020",
      "Sikandri Sarai S.O": "462010",
      "Nariyalkheda S.O": "462100",
      "Anand Nagar S.O (Bhopal)": "462022",
      "Ayodhaya Nagar S.O": "462041",
      "Govindpura S.O": "462023",
      "M.A.C.T. S.O": "462003",
      "Tulsi Nagar S.O": "462003",
      "Vallabh Bhawan S.O": "462004",
      "Vidya Vihar S.O": "462002",
      "IBD Hallmark city kolar road": "462040",
      "Lalariya S.O": "463111",
      "M.L. Nagar S.O": "462038",
      "Nishatpura S.O": "462010",
      "Peoples Campus S.O": "462037",
      "RGPV S.O": "462033",
      "S.I. Line S.O": "462001",
      "Kolar Road S.O": "462042",
      "M.P. Vidhan Sabha S.O": "462004",
      "R.S.Market S.O": "462016",
      "R.S.Nagar S.O": "462016",
      "Shastri Nagar S.O (Bhopal)": "462003",
      "Shiksha Mandal S.O": "462011",
      "University S.O (Bhopal)": "462026",
      "Jumerati S.O": "462001",
      "Nazirabad S.O": "462120",
      "Old Secretriate S.O": "462001",
      "Shahajahanabad S.O": "462001",
      "Arera Hills S.O": "462027",
      "Bag Mungalia S.O": "462043",
      "Bangrasia S.O": "462045",
      "Kamla Nagar S.O (Bhopal)": "462003",
      "MP Bhoj Open University S.O": "462016",
      "Raj Bhawan S.O (Bhopal)": "462003"
    },
    "NEEMUCH": {
      "Dadoli B.O": "458220",
      "Lasur B.O": "458220",
      "Dhardi B.O": "458228",
      "Tal B.O": "458228",
      "Ramnagar B.O": "458220",
      "Semali Chandrawat B.O": "458220",
      "Bhatkheda B.O": "458441",
      "Kankria Talai B.O": "458226",
      "Luharia B.O": "458226",
      "Bangred B.O": "458220",
      "Modi B.O": "458220",
      "Morwan B.O": "458220",
      "Jhantla B.O": "458228",
      "Kadwasa B.O": "458228",
      "Jamuniya Kala B.O": "458441",
      "Umar B.O": "458226",
      "Dhamnia B.O": "458220",
      "Janakpur B.O": "458220",
      "Dhangaon B.O": "458228",
      "Kojya B.O": "458228",
      "Khadawda B.O": "458116",
      "Piplia Ghota B.O": "458116",
      "Tamoti B.O": "458116",
      "Devari Khawasa B.O": "458113",
      "Khajuri B.O": "458113",
      "Kundla B.O": "458113",
      "Moya B.O": "458113",
      "Nalkheda B.O": "458113",
      "Nalwa B.O": "458113",
      "Bardia B.O": "458110",
      "Bhatkhedi B.O": "458110",
      "Naya Malaheda B.O": "458110",
      "Bhamesar B.O": "458118",
      "Booj B.O": "458118",
      "Chandrapura B.O": "458118",
      "Devran B.O": "458118",
      "Majiria B.O": "458118",
      "Garwada Alori B.O": "458226",
      "Jat B.O": "458226",
      "Aankali B.O": "458113",
      "Kunchrod B.O": "458339",
      "Chukani B.O": "458110",
      "Jaliner B.O": "458110",
      "Kanjarda B.O": "458110",
      "Kesharpura B.O": "458468",
      "Aantri B.O": "458113",
      "Barthun B.O": "458113",
      "Chaplana B.O": "458113",
      "Chaldu B.O": "458339",
      "Chokadi B.O": "458110",
      "Hadi Piplia B.O": "458110",
      "Jamunia B.O": "458110",
      "Piplia Raoji B.O": "458110",
      "Bordia Kalan B.O": "458553",
      "Baisala B.O": "458118",
      "Jannod B.O": "458118",
      "Dorai B.O": "458226",
      "Bhadva B.O": "458113",
      "Denthal B.O": "458113",
      "Alheda Jagir B.O": "458110",
      "Hanspur B.O": "458110",
      "Khedali B.O": "458110",
      "Parda B.O": "458110",
      "Bhadana B.O": "458118",
      "Dudhlai B.O": "458118",
      "Bharbhadia B.O": "458441",
      "Neemuch R.S. B.O": "458441",
      "Newad B.O": "458441",
      "Palsoda B.O": "458441",
      "Kanawati B.O": "458441",
      "Malkheda B.O": "458441",
      "Revali Devali B.O": "458441",
      "Daroo B.O": "458441",
      "Meghpura B.O": "458330",
      "Suwakheda B.O": "458330",
      "Harkia Khal B.O": "458336",
      "Chachor B.O": "458116",
      "Piplone B.O": "458441",
      "Rabdia B.O": "458441",
      "Tarapur B.O": "458330",
      "Hanumantia B.O": "458116",
      "Thadoli": "458441",
      "Kanakheda B.O": "458441",
      "Amawali Jagir B.O": "458441",
      "Sirkheda B.O": "458441",
      "Bhadwamata B.O": "458441",
      "Neemuch Jawahar Nagar B.O": "458441",
      "Javi B.O": "458441",
      "Athana B.O": "458330",
      "Harwar B.O": "458336",
      "Lasudia B.O": "458118",
      "Athva B.O": "458226",
      "Deeken B.O": "458226",
      "Borkhedi Panedi B.O": "458441",
      "Chitakheda B.O": "458441",
      "Karadia Maharaj B.O": "458441",
      "Bisalwasa Kalan B.O": "458441",
      "Sawan B.O": "458441",
      "Chhayan B.O": "458441",
      "Bawal Nai B.O": "458330",
      "Saroda B.O": "458330",
      "Barlai B.O": "458116",
      "Danta B.O": "458116",
      "Neemuch H.O": "458441",
      "Baghana Neemuch S.O": "458441",
      "Khor S.O": "458470",
      "Kukdeshwar S.O": "458116",
      "Jeeran S.O": "458336",
      "Jawad S.O": "458330",
      "Neemuch Ghanta Ghar S.O": "458441",
      "Ratangarh S.O": "458226",
      "Singoli S.O": "458228",
      "Nayagaon C F S.O": "458468",
      "Neemuch City S.O": "458441",
      "Mahagarh S.O": "458113",
      "Manasa S.O": "458110",
      "Neemuch Victoria Barracks S.O": "458441",
      "Rampura S.O (Neemuch)": "458118",
      "Sarwania Maharaj S.O": "458220"
    },
    "JHABUA": {
      "Baodibadi B.O": "457661",
      "Rajla B.O": "457661",
      "Rotla B.O": "457661",
      "Khedi B.O": "457661",
      "Chhayan Paschim B.O": "457770",
      "Ghughri B.O": "457770",
      "Pithanpur B.O": "457661",
      "Kalmoda B.O": "457661",
      "Kardawad Badi B.O": "457661",
      "Rehanda B.O": "457661",
      "Dhekal B.O": "457661",
      "Amargarh B.O": "457770",
      "Bherogarh B.O": "457770",
      "Bodayta B.O": "457770",
      "Sarangi B.O": "457770",
      "Kukdipada B.O": "457772",
      "Sagwa B.O": "457772",
      "Semlia B.O": "457772",
      "Antarwelia B.O": "457779",
      "Barvet B.O": "457773",
      "Dehandi Chhoti B.O": "457773",
      "Kardawad B.O": "457773",
      "Jhaknawda B.O": "457775",
      "Kumarkhedi B.O": "457775",
      "Paledi B.O": "457775",
      "Umarkot B.O": "457775",
      "Mohankot B.O": "457775",
      "Harinagar B.O": "457777",
      "Kakanwani B.O": "457777",
      "Sajelimaljisath B.O": "457777",
      "Shivgarh B.O": "457777",
      "Karwad B.O": "457770",
      "Panchpiplia B.O": "457770",
      "Narela B.O": "457772",
      "Kachaldara B.O": "457779",
      "Kheda B.O": "457779",
      "Kodli B.O": "457773",
      "Bolasa B.O": "457775",
      "Hamirgarh B.O": "457775",
      "Andharwad B.O": "457993",
      "Samoi B.O": "457993",
      "Bedawa B.O": "457777",
      "Khalkhandwi B.O": "457777",
      "Miyati B.O": "457777",
      "Parwalia B.O": "457777",
      "Udaigarh R.S.  B.O": "457777",
      "Devjhiri Panda B.O": "457661",
      "Rama B.O": "457661",
      "Kundanpur B.O": "457661",
      "Karangarh B.O": "457770",
      "Mandan B.O": "457770",
      "Mathmath B.O": "457770",
      "Mohanpura B.O": "457770",
      "Guwali B.O": "457779",
      "Hatyadeli B.O": "457779",
      "Madrani B.O": "457779",
      "Panchkui B.O": "457779",
      "Rambhapur B.O": "457779",
      "Sad B.O": "457779",
      "Ramgarh B.O": "457773",
      "Rupgarh B.O": "457773",
      "Khardubadi B.O": "457661",
      "Machhlia B.O": "457661",
      "Pitol B.O": "457661",
      "Bhimfalia B.O": "457661",
      "Pipliya B.O": "457661",
      "Chapaner B.O": "457770",
      "Gangakhedi B.O": "457770",
      "Rampuria B.O": "457770",
      "Bhamel B.O": "457772",
      "Makodia B.O": "457772",
      "Agral B.O": "457779",
      "Bhagor B.O": "457779",
      "Kajlidungari B.O": "457779",
      "Kalyanpura B.O": "457779",
      "Anantkhedi B.O": "457773",
      "Baodi B.O": "457773",
      "Dhaturia B.O": "457775",
      "Jamli B.O": "457775",
      "Tarkhedi B.O": "457775",
      "Ban B.O": "457993",
      "Bajranggarh B.O": "457777",
      "Khajuri B.O": "457777",
      "Talawali B.O": "457777",
      "Temria B.O": "457773",
      "Bani B.O": "457775",
      "Bekalda B.O": "457775",
      "Kanjwanikhas B.O": "457993",
      "Mandlinathu B.O": "457993",
      "Matasula B.O": "457993",
      "Mordundia B.O": "457993",
      "Balwasa B.O": "457777",
      "Bhimkund B.O": "457777",
      "Devigarh B.O": "457777",
      "Morjhari B.O": "457777",
      "Para B.O": "457661",
      "Jhabua H.O": "457661",
      "Raipuria S.O": "457775",
      "Jhabua Collectorate S.O": "457661",
      "Meghnagar S.O": "457779",
      "Petlawad S.O": "457773",
      "Bamnia S.O": "457770",
      "Khawasa S.O (Jhabua)": "457772",
      "Ranapur S.O": "457993",
      "Thandla S.O": "457777"
    },
    "ALIRAJPUR": {
      "Badaundwa B.O": "457887",
      "Walwai B.O": "457887",
      "Badisardi B.O": "457887",
      "Bardala B.O": "457887",
      "Malwai B.O": "457887",
      "Ajanda B.O": "457887",
      "Fata B.O": "457887",
      "CHOTABHAVTA B.O": "457887",
      "Ambadaberi B.O": "457887",
      "Ambari B.O": "457887",
      "Bokadia B.O": "457887",
      "Badakhuntaja B.O": "457882",
      "Barzar B.O": "457882",
      "Ghodamandan B.O": "457882",
      "Jheeran B.O": "457882",
      "Bhilkhedi B.O": "457990",
      "Borjhad B.O": "457990",
      "Chhotaitara B.O": "457990",
      "Kanwada B.O": "457990",
      "Bakhatgarh B.O": "457888",
      "Amankunwa B.O": "457882",
      "Mathna B.O": "457882",
      "Ringol B.O": "457882",
      "Khattali B.O": "457990",
      "Thandla B.O": "457990",
      "Umda B.O": "457990",
      "Kanakakad B.O": "457993",
      "Andharkanch B.O": "457888",
      "Mathwad B.O": "457888",
      "Pipliawat B.O": "457888",
      "Silota B.O": "457888",
      "Laxmani B.O": "457887",
      "Nanpur B.O": "457887",
      "Sejgaon B.O": "457887",
      "Titi B.O": "457887",
      "Sorwa B.O": "457887",
      "Vadi B.O": "457887",
      "Kolyabardi B.O": "457990",
      "Kundalwasa B.O": "457990",
      "Ublet B.O": "457990",
      "Undari B.O": "457990",
      "Dhyana B.O": "457885",
      "Kachhala B.O": "457885",
      "Kadwal B.O": "457885",
      "Motibadoi B.O": "457885",
      "Borkua B.O": "457887",
      "Haraswat B.O": "457887",
      "Amkhut B.O": "457887",
      "MEDA B.O": "457882",
      "Sejawad B.O": "457882",
      "Badaguda B.O": "457990",
      "Bori B.O": "457990",
      "Dabdi B.O": "457990",
      "Khandala B.O": "457990",
      "Udaygarh Kanas B.O": "457990",
      "Attha B.O": "457888",
      "Umrali B.O": "457888",
      "Chhaktala B.O": "457888",
      "Darkali B.O": "457888",
      "Foolmal B.O": "457888",
      "Walpur B.O": "457888",
      "Chandpur B.O": "457887",
      "Jobat S.O": "457990",
      "Alirajpur S.O": "457887",
      "Katthiwada S.O": "457885",
      "Bhabhra S.O": "457882",
      "Sondwa S.O": "457888"
    },
    "BARWANI": {
      "Temala B.O": "451881",
      "Mortalai B.O": "451881",
      "Rakhibujurg B.O": "451881",
      "Bhatki B.O": "451881",
      "Uchawad B.O": "451556",
      "Surana B.O": "451556",
      "Limbi B.O": "451551",
      "Panchpula(N) B.O": "451551",
      "Pati B.O": "451551",
      "Piplaj B.O": "451551",
      "Semali B.O": "451551",
      "Baghadi B.O": "451449",
      "Rui B.O": "451449",
      "Nisarpur B.O": "451881",
      "Malfa B.O": "451881",
      "Bandhara Bujurg B.O": "451770",
      "Balkuwan B.O": "451556",
      "Bilwa Road B.O": "451556",
      "Lonsara Khurd B.O": "451556",
      "Mohipura B.O": "451556",
      "Talwada Deb B.O": "451556",
      "Borlay B.O": "451551",
      "Kasrawad (S) B.O": "451551",
      "Sondul B.O": "451551",
      "Balsamund B.O": "451449",
      "Baswi B.O": "451449",
      "Ojhar B.O": "451449",
      "Anjarada B.O": "451551",
      "Attarsambha B.O": "451551",
      "Bawangaja B.O": "451551",
      "Bhawati B.O": "451551",
      "Bokrata B.O": "451551",
      "Talun Khurd B.O": "451551",
      "Bhorwada B.O": "451449",
      "Ghusgaon B.O": "451449",
      "Indrapur B.O": "451449",
      "Khajuri B.O": "451449",
      "Nagalwadi B.O": "451449",
      "Rangaon Road B.O": "451449",
      "Gandhawal B.O": "451551",
      "Sajwani B.O": "451551",
      "Silawad B.O": "451551",
      "Salikalan B.O": "451449",
      "Jahur B.O": "451881",
      "Sali B.O": "451556",
      "Talwada Bujurg B.O": "451556",
      "Barda B.O": "451556",
      "Fatyapur B.O": "451556",
      "Koradiya B.O": "451556",
      "Mandwada B.O": "451556",
      "Bakwadi B.O": "451449",
      "Dondwada B.O": "451770",
      "Jalgone B.O": "451770",
      "Badgaon B.O": "451447",
      "Haribad B.O": "451447",
      "Balwadi B.O": "451666",
      "Jamathi B.O": "451666",
      "Kunjari B.O": "451666",
      "Mahitgaon B.O": "451666",
      "Malwan B.O": "451666",
      "Nawalpura B.O": "451666",
      "Warla B.O": "451666",
      "Brahamngaon B.O": "451660",
      "Ghatwa B.O": "451660",
      "Pipari Bujurg B.O": "451447",
      "Rangaon Deb B.O": "451447",
      "Revaja B.O": "451447",
      "Sangaon B.O": "451447",
      "Bhakarli B.O": "451666",
      "Chachariya B.O": "451666",
      "Segwal B.O": "451660",
      "Junapani B.O": "451770",
      "Moida B.O": "451770",
      "Chikliya B.O": "451447",
      "Palsud B.O": "451447",
      "Sustikheda B.O": "451447",
      "Wajhar B.O": "451447",
      "Chatli B.O": "451666",
      "Diwaniya B.O": "451666",
      "Jogwada B.O": "451666",
      "Shahpura B.O": "451666",
      "Chichali (N) B.O": "451660",
      "Lakhangaon B.O": "451660",
      "Maltar B.O": "451660",
      "Mehgaon Deb B.O": "451660",
      "Dhanora B.O": "451666",
      "Bhoinda B.O": "451660",
      "Khurrampura B.O": "451660",
      "Kuwan B.O": "451660",
      "Nimarani B.O": "451660",
      "Kansul B.O": "451770",
      "Niwali B.O": "451770",
      "Danod B.O": "451447",
      "Matali B.O": "451447",
      "Menimata B.O": "451447",
      "Upla B.O": "451447",
      "Achli B.O": "451666",
      "Bawdad B.O": "451666",
      "Dhawali B.O": "451666",
      "Dugani B.O": "451666",
      "Goi B.O": "451666",
      "Jhopali B.O": "451666",
      "Solwan B.O": "451666",
      "Chichali (D) B.O": "451660",
      "Dawana B.O": "451660",
      "Deola B.O": "451660",
      "Maral Sarovar B.O": "451660",
      "Anjad S.O": "451556",
      "Julwania S.O": "451449",
      "Rajpur Barwani S.O": "451447",
      "Thikari S.O": "451660",
      "Barwani S.O": "451551",
      "Pansemal S.O": "451770",
      "Khetia S.O": "451881",
      "Sendhwa S.O": "451666"
    },
    "BETUL": {
      "Sehra B.O": "460001",
      "Mandai Bujurg B.O": "460001",
      "Bhogiteda B.O": "460001",
      "Mathani Betul B.O": "460001",
      "Gargud B.O": "460110",
      "Hidli B.O": "460110",
      "Jamthi B.O": "460110",
      "Bagholi B.O": "460004",
      "Bharkawari B.O": "460004",
      "Sohagpur B.O": "460004",
      "Barhapur B.O": "460220",
      "Belkund B.O": "460220",
      "Bothi B.O": "460220",
      "Chandu B.O": "460220",
      "Khandara B.O": "460001",
      "Kolgaon B.O": "460001",
      "Garha B.O": "460001",
      "Sillot B.O": "460001",
      "Temni Betul BO": "460001",
      "Ambada Amladepot B.O": "460553",
      "Morandhana B.O": "460553",
      "Andharia B.O": "460551",
      "Parsodi Amla B.O": "460551",
      "Toranwara B.O": "460551",
      "Pusli B.O": "460110",
      "Saongi Athnair B.O": "460110",
      "Wadali B.O": "460110",
      "Gondigoula B.O": "460004",
      "Badgaon Bhaisdehi B.O": "460220",
      "Gudgaon B.O": "460220",
      "Temni Bhaisdehi B.O": "460220",
      "Badgaon Bordehi B.O": "460554",
      "Bijadehi B.O": "460330",
      "Chikhali Chicholi B.O": "460330",
      "Chirapatla B.O": "460330",
      "Chudia B.O": "460330",
      "Godhna B.O": "460330",
      "Chikhalikalan Dunawa B.O": "460663",
      "Dahua B.O": "460663",
      "Sarai B.O": "460663",
      "Selgaon B.O": "460225",
      "Bisnoor B.O": "460668",
      "Etawa Masod B.O": "460668",
      "Gehubarsa B.O": "460668",
      "Hiwarkhed B.O": "460668",
      "Karpa B.O": "460661",
      "Khedlibazar B.O": "460661",
      "Kujba B.O": "460661",
      "Mahatpur B.O": "460661",
      "Mathani Multai B.O": "460661",
      "Mohi B.O": "460661",
      "Shaktigarh B.O": "460449",
      "Ashta B.O": "460666",
      "Bagoda B.O": "460666",
      "Birul Bazar B.O": "460666",
      "Datora B.O": "460666",
      "Yenkheda B.O": "460557",
      "Desawari B.O": "460440",
      "Dhapoda B.O": "460440",
      "Kachhar B.O": "460440",
      "Kundi B.O": "460440",
      "Pahawari B.O": "460440",
      "Kunkhedi B.O": "460220",
      "Majarwani B.O": "460220",
      "Palasya B.O": "460220",
      "Sakli B.O": "460220",
      "Kurasna B.O": "460330",
      "Mohda B.O": "460330",
      "Path B.O": "460330",
      "Patri B.O": "460330",
      "Ghatbiroli B.O": "460663",
      "Ghatpipariya B.O": "460663",
      "Jam Dunawa B.O": "460663",
      "Ranipur B.O": "460443",
      "Sitakamath B.O": "460443",
      "Borgaon Machchhi B.O": "460225",
      "Chunaloma B.O": "460225",
      "Jhallar B.O": "460225",
      "Shirdi B.O": "460668",
      "Barai B.O": "460661",
      "Hathanapur B.O": "460661",
      "Joulkheda B.O": "460661",
      "Sandia B.O": "460661",
      "Sarra B.O": "460661",
      "Tiwarkhed B.O": "460665",
      "Umari B.O": "460665",
      "Taikheda B.O": "460666",
      "Goula B.O": "460557",
      "Khedicourt B.O": "460557",
      "Pouni B.O": "460557",
      "Batkidoh B.O": "460440",
      "Chikhalpati B.O": "460440",
      "Pathai B.O": "460440",
      "Nimpani Padhar B.O": "460001",
      "Jeen B.O": "460001",
      "Borgaon BO": "460001",
      "Anwaria Amla B.O": "460551",
      "Jambada B.O": "460551",
      "Kanojia B.O": "460551",
      "Khapakhateda B.O": "460551",
      "Kutkhedi B.O": "460551",
      "Lalawadi B.O": "460551",
      "Ratedakalan B.O": "460551",
      "Jawara Athnair B.O": "460110",
      "Mandvi B.O": "460110",
      "Tembhurni B.O": "460110",
      "Kothalkund B.O": "460220",
      "Sawalmendha B.O": "460220",
      "Chhipanya Pipariya B.O": "460554",
      "Awaria Chicholi B.O": "460330",
      "Dhanora Adarsh B.O": "460330",
      "Kesia B.O": "460330",
      "Malajpur B.O": "460330",
      "Pathakheda B.O": "460330",
      "Ratanpur B.O": "460330",
      "Barkhed B.O": "460663",
      "Gubrel B.O": "460663",
      "Khairwani B.O": "460663",
      "Lilajhir B.O": "460663",
      "Amla B.O": "460225",
      "Bansnerkala B.O": "460225",
      "Saongi masod B.O": "460668",
      "Chandora Khurd B.O": "460661",
      "Chouthia B.O": "460661",
      "Narkhed B.O": "460661",
      "Parmandal B.O": "460661",
      "Sonegaon B.O": "460661",
      "Yenus B.O": "460661",
      "Shobhapur Colloery B.O": "460449",
      "Wandli B.O": "460665",
      "Mangonakhurd B.O": "460665",
      "Chhindkheda B.O": "460666",
      "Pohar B.O": "460557",
      "Sasundra B.O": "460557",
      "Badalpur B.O": "460440",
      "Bhoura B.O": "460440",
      "Chopna B.O": "460440",
      "Salimet B.O": "460440",
      "Temru B.O": "460440",
      "Chandbaheda B.O": "460001",
      "Jogli B.O": "460001",
      "Bharat Bharti B.O": "460001",
      "Chikhali BO": "460001",
      "Lakhapur B.O": "460553",
      "Nahiya B.O": "460553",
      "Ramli B.O": "460551",
      "Umaria B.O": "460551",
      "Dehgud B.O": "460110",
      "Dhanora Athnair B.O": "460110",
      "Mendha Chhindwad B.O": "460110",
      "Satner B.O": "460110",
      "Barahvi B.O": "460004",
      "Jawara Betulbazar B.O": "460004",
      "Bakud B.O": "460220",
      "Dhamangaon B.O": "460220",
      "Khamla B.O": "460220",
      "Khomai B.O": "460220",
      "Seoni B.O": "460220",
      "Thapoda B.O": "460220",
      "Barangwari B.O": "460554",
      "Kalmeshwara B.O": "460554",
      "Bhimpur B.O": "460330",
      "Chunahajuri B.O": "460330",
      "Dudhiya B.O": "460330",
      "Ghisibagla B.O": "460330",
      "Jhapal B.O": "460330",
      "Pipariyagurwa B.O": "460330",
      "Chhindi Dunawa B.O": "460663",
      "Kathi B.O": "460663",
      "Ridhora Dunawa B.O": "460663",
      "Sipawa B.O": "460663",
      "Dharakhoh B.O": "460443",
      "Vijaygaram B.O": "460225",
      "Ragadgaon B.O": "460668",
      "Sahangaon B.O": "460668",
      "Chichanda B.O": "460661",
      "Chilhati B.O": "460661",
      "Morkha B.O": "460661",
      "Paradsinga Multai B.O": "460661",
      "Sonora B.O": "460661",
      "Amdhana B.O": "460449",
      "Salaiya B.O": "460449",
      "Amraoti Ghat B.O": "460665",
      "Mangonakalan B.O": "460665",
      "Bihargaon B.O": "460666",
      "Dhabla B.O": "460666",
      "Hirdi B.O": "460666",
      "Semjhira B.O": "460557",
      "Bhaiyawari B.O": "460440",
      "Hirapur B.O": "460440",
      "Silpati B.O": "460440",
      "Rondha B.O": "460001",
      "Badora B.O": "460001",
      "Sakadehi B.O": "460001",
      "Bhadus B.O": "460001",
      "Dabri BO": "460330",
      "Dodramau BO": "460330",
      "Damjipura BO": "460330",
      "Mohta BO": "460330",
      "Betul H.O": "460001",
      "Amla Depot S.O": "460553",
      "Athanair S.O": "460110",
      "Bhainsdehi S.O": "460220",
      "Masod S.O": "460668",
      "Multai Bazaar S.O": "460661",
      "Vikasnagar Betul S.O": "460001",
      "Betul Bazaar S.O": "460004",
      "Bordehi S.O": "460554",
      "Dunawa S.O": "460663",
      "Kothi Bazaar S.O": "460001",
      "Prabhat Pattan S.O": "460665",
      "Amla S.O": "460551",
      "Betul Ganj S.O": "460001",
      "Chicholi S.O": "460330",
      "Khedisaoligarh S.O": "460225",
      "Rai Amla S.O": "460666",
      "Sarni S.O": "460447",
      "Shahpur S.O (Betul)": "460440",
      "Ghoradongari S.O": "460443",
      "Multai S.O": "460661",
      "Pathakheda S.O": "460449",
      "Sainkheda S.O (Betul)": "460557"
    },
    "BHIND": {
      "Dharai B.O": "477001",
      "Ethar B.O": "477001",
      "Baran Khurd B.O": "477332",
      "Arusi B.O": "477449",
      "Gangepura B.O": "477449",
      "Adokhar B.O": "477227",
      "Girwasa B.O": "477446",
      "Rurai B.O": "477446",
      "Chomho B.O": "477111",
      "Tarsokhar B.O": "477111",
      "Ahorli Kali B.O": "477111",
      "Jamsara B.O": "477111",
      "Khadit B.O": "477111",
      "Badepura B.O": "477566",
      "Chandupura B.O": "477001",
      "Goara B.O": "477001",
      "Daboha B.O": "477001",
      "Bharoli B.O": "477332",
      "Nunheta B.O": "477332",
      "Mehra B.O": "477227",
      "Kanathar B.O": "477227",
      "Parghana B.O": "477227",
      "Akhdewa B.O": "477446",
      "Bindwa (Attair) B.O": "477111",
      "Ridoli B.O": "477111",
      "Kanera B.O": "477111",
      "Sapad B.O": "477566",
      "Barthara B.O": "477447",
      "Bijpur B.O": "477447",
      "Andhiyari B.O": "477447",
      "Raipur Jakholi B.O": "477447",
      "Bhagwasa B.O": "477116",
      "Charetha B.O": "477116",
      "Aino B.O": "477116",
      "Birkhadi Dang B.O": "477116",
      "Khaneta (Gohad S.O) B.O": "477116",
      "Akloni B.O": "477660",
      "Ingosa Raipur B.O": "477660",
      "Bahera B.O": "477660",
      "Mehdoli B.O": "477660",
      "Rohini Jagir B.O": "477445",
      "Rahawali B.O": "477445",
      "Lalpura B.O": "477445",
      "Gyanpura B.O": "477566",
      "Sankari B.O": "477566",
      "Dharampura B.O": "477447",
      "Pariksha B.O": "477447",
      "Baraua B.O": "477447",
      "Chipawali B.O": "477447",
      "Mihoni B.O": "477447",
      "Chitora B.O": "477116",
      "Pipahadi B.O": "477116",
      "Endori B.O": "477116",
      "Jhankari B.O": "477116",
      "Rai Ki Pali B.O": "477116",
      "Sukand B.O": "477660",
      "Sikroda B.O": "477660",
      "Goar Khurd B.O": "477660",
      "Mahua (Lahar So) B.O": "477445",
      "MATIAVALI B.O": "477445",
      "Sundarpura B.O": "477445",
      "Heerapura (lahar) B.O": "477445",
      "Jamuhan B.O": "477445",
      "Garhpara B.O": "477001",
      "Gopalpura B.O": "477001",
      "Pidora B.O": "477335",
      "Lawan B.O": "477001",
      "Bara Kalan B.O": "477332",
      "Kachongara B.O": "477332",
      "Kheria Sindh B.O": "477227",
      "Sada B.O": "477227",
      "Semara B.O": "477227",
      "Pratappura B.O": "477111",
      "Balarpura B.O": "477111",
      "Seetaram Ki Lawan B.O": "477116",
      "Suhans B.O": "477116",
      "Chandokhar B.O": "477116",
      "Kathama Hazi B.O": "477116",
      "Sondha B.O": "477116",
      "Aroli B.O": "477660",
      "Kripe Ka Pura B.O": "477660",
      "Manhad B.O": "477660",
      "Nunhad B.O": "477660",
      "Pawai B.O": "477660",
      "Badokhari B.O": "477445",
      "Bhatpura B.O": "477445",
      "Ajnar B.O": "477445",
      "Jamna B.O": "477001",
      "USHANAGAR COLONY B.O": "477001",
      "Heera Lalka Pura B.O": "477332",
      "Sihunda B.O": "477332",
      "Kurthar B.O": "477449",
      "Gaheli B.O": "477227",
      "Anto B.O": "477227",
      "Chiruli B.O": "477446",
      "Jalalpura (Aswar So)B.O": "477446",
      "Akon B.O": "477111",
      "Ahoroli Ghat B.O": "477111",
      "Udotgarh (Attair) B.O": "477111",
      "Jori Kotwal B.O": "477111",
      "Kharika B.O": "477111",
      "Bhawanpura (Barhi) B.O": "477566",
      "Nai Garhi B.O": "477566",
      "Amaha B.O": "477447",
      "Devari B.O": "477447",
      "Muraoli B.O": "477447",
      "Piparsana B.O": "477116",
      "Khitoli B.O": "477116",
      "Gohad Choraha B.O": "477116",
      "Pali Darman B.O": "477116",
      "Harikhsa B.O": "477660",
      "Sunarpura B.O": "477660",
      "Parosa B.O": "477660",
      "Kachnav Kalan B.O": "477660",
      "Pali B.O": "477660",
      "Peepari B.O": "477660",
      "Barha B.O": "477445",
      "Mehra Bujurg B.O": "477445",
      "Kanchanpur B.O": "477117",
      "Sherpur B.O": "477117",
      "Baderabhoota B.O": "477222",
      "Dehgoun B.O": "477222",
      "Gingarkhi B.O": "477557",
      "Konhar B.O": "477557",
      "Baranso B.O": "477557",
      "Ajnodha B.O": "477557",
      "Gijurra B.O": "477557",
      "Machand B.O": "477441",
      "Biswari B.O": "477441",
      "Didi B.O": "477105",
      "Jawasa B.O": "477105",
      "Babedi B.O": "477105",
      "Simrao B.O": "477105",
      "Dulhangan B.O": "477555",
      "Bhagwasi B.O": "477555",
      "Birkhadi Chachai B.O": "477335",
      "Nondha B.O": "477335",
      "Nadna B.O": "477335",
      "Sanwai B.O": "477333",
      "NayaGaon B.O": "477333",
      "Akaha B.O": "477331",
      "Bilao B.O": "477331",
      "Tudila B.O": "477117",
      "BHAUNPURA (Malanpur) B.O": "477117",
      "Barahed(Malanpur)B.O": "477117",
      "Ghamori B.O": "477222",
      "Soni B.O": "477557",
      "Jarsena B.O": "477557",
      "Barhad B.O": "477557",
      "Katrol B.O": "477557",
      "Sayana B.O": "477557",
      "Simar B.O": "477557",
      "Bohara B.O": "477441",
      "Achalpura B.O": "477441",
      "Jaitpura Gudha B.O": "477441",
      "Pachokhara B.O": "477441",
      "Banthari B.O": "477441",
      "Lapwaha B.O": "477441",
      "Chandokh B.O": "477441",
      "Siyawali B.O": "477105",
      "Paragoun B.O": "477105",
      "Masuri B.O": "477105",
      "Kishupura B.O": "477555",
      "Kosad B.O": "477555",
      "Aheti B.O": "477555",
      "Janora B.O": "477555",
      "Surpura B.O": "477555",
      "Rama B.O": "477555",
      "Nibsai B.O": "477335",
      "Gorai B.O": "477335",
      "Indurkhi B.O": "477335",
      "Jaitpur Madhi B.O": "477335",
      "Bahadurpura B.O": "477335",
      "Kakahara B.O": "477333",
      "Tehangur B.O": "477333",
      "Jakhmoli B.O": "477333",
      "Atarsuma B.O": "477333",
      "Sarwa B.O": "477117",
      "Barona B.O": "477117",
      "Nonera B.O": "477117",
      "Ratwa B.O": "477222",
      "Ujhaawl B.O": "477222",
      "Chenkuri B.O": "477222",
      "Rathiyankapura B.O": "477557",
      "Kathma B.O": "477557",
      "Senthari B.O": "477557",
      "Muratpura B.O": "477441",
      "Rari B.O": "477441",
      "Asnet B.O": "477441",
      "Barahet (Mihona)B.O": "477441",
      "Katha B.O": "477441",
      "Jampura B.O": "477105",
      "Bagulari B.O": "477105",
      "Bijora B.O": "477555",
      "Sakaraya B.O": "477555",
      "Rarua B.O": "477335",
      "Sarsai B.O": "477333",
      "Pulawali B.O": "477331",
      "Kanawar B.O": "477331",
      "Meesa B.O": "477331",
      "Pandari B.O": "477331",
      "VAISHPURA B.O": "477445",
      "Rayat pura B.O": "477117",
      "Ghirongi B.O": "477117",
      "Gurikha B.O": "477117",
      "Guhisar B.O": "477222",
      "Kiti B.O": "477222",
      "Baroli B.O": "477222",
      "Jamdara B.O": "477222",
      "Birgawan B.O": "477557",
      "Gutor B.O": "477557",
      "Pachera B.O": "477557",
      "Gona Hardaspur B.O": "477557",
      "Baghora B.O": "477557",
      "Jouri Brahman B.O": "477557",
      "Bonapura B.O": "477441",
      "Raipura B.O": "477441",
      "Larol B.O": "477441",
      "Charthar B.O": "477105",
      "Udhotpura (N.Z.)B.O": "477105",
      "Jari B.O": "477105",
      "Bhadakur B.O": "477555",
      "RANI BIRGAWAN  B.O": "477555",
      "Chachar B.O": "477555",
      "Mangarh B.O": "477335",
      "Mehda B.O": "477335",
      "Mehdwa B.O": "477335",
      "Lahroli B.O": "477333",
      "Kot B.O": "477333",
      "Bajhai B.O": "477331",
      "Donchara B.O": "477331",
      "Bhind H.O": "477001",
      "Attair S.O": "477111",
      "Daboh S.O": "477447",
      "Rawatpura sarkar ashram S.O": "477450",
      "Akoda S.O": "477332",
      "Attair Road Bhind S.O": "477001",
      "Mehgoun S.O": "477557",
      "Sagra S.O (Bhind": "477333",
      "Amayan S.O": "477227",
      "Bhind Kutchary S.O": "477001",
      "Bhind Mandi S.O": "477001",
      "Gohad S.O": "477116",
      "Gormi S.O": "477660",
      "Lahar S.O": "477445",
      "Mihona S.O": "477441",
      "Phoop S.O": "477555",
      "Nai Zameen Bhind S.O": "477105",
      "Raun S.O": "477335",
      "Umri S.O (Bhind": "477331",
      "Alampur S.O (Bhind": "477449",
      "Aswar S.O": "477446",
      "Barhi S.O (Bhind": "477566",
      "Housing Colony Bhind S.O": "477001",
      "Malanpur S.O": "477117",
      "Mau S.O": "477222"
    },
    "GWALIOR": {
      "Supaoli B.O": "474006",
      "Utila B.O": "474006",
      "Sirsod B.O": "474006",
      "Bilhati Kalan B.O": "474006",
      "Jaderuakalan B.O": "474006",
      "Wahangikhurd B.O": "474006",
      "Hastinapur B.O": "475002",
      "Tiholi B.O": "475002",
      "Bhadroli B.O": "474005",
      "Baraua B.O": "474005",
      "Karahi B.O": "475330",
      "Nayagaon B.O": "475330",
      "Ummegarh B.O": "475330",
      "Badagaon B.O": "475330",
      "Bijoli B.O": "474006",
      "Ratwai B.O": "474006",
      "Jakhara B.O": "475002",
      "Senthri B.O": "474020",
      "Girgaon B.O": "474020",
      "Renhat B.O": "475330",
      "Sabrai B.O": "475330",
      "Jakhoda B.O": "475330",
      "Simariatanka B.O": "475330",
      "Dhuan B.O": "475330",
      "Ghatigaon B.O": "475330",
      "Beru B.O": "475005",
      "Akbai B.O": "475005",
      "Ladhwaya B.O": "475005",
      "Kalyani B.O": "475005",
      "Jamahar B.O": "474005",
      "Susera B.O": "474005",
      "Bahadurpur B.O": "474020",
      "Aron B.O": "475330",
      "Panihar B.O": "475330",
      "Barai B.O": "475330",
      "Chiruli B.O": "475005",
      "Bandholi B.O": "474006",
      "Parsen B.O": "474006",
      "Tankoli B.O": "475002",
      "Rangawan B.O": "475002",
      "Dabka B.O": "475330",
      "Patai B.O": "475330",
      "Dorar B.O": "475330",
      "Itm B.O": "474001",
      "Tighra B.O": "474001",
      "Tilak Nagar B.O": "474001",
      "Barki Saray B.O": "475001",
      "Chirpura B.O": "475001",
      "Deori B.O": "475220",
      "Jhadoli B.O": "475220",
      "Kheda B.O": "475220",
      "Bajana B.O": "475220",
      "Rahi B.O": "475220",
      "Dubha B.O": "475220",
      "Bagwai B.O": "475220",
      "Itma B.O": "475220",
      "Chinor B.O": "475110",
      "Maina B.O": "475110",
      "Bhaisnari B.O": "475110",
      "Mehgaon B.O": "475115",
      "Simaria Tal B.O": "475110",
      "Jiwaji Ganj B.O": "474001",
      "Janaktal B.O": "474010",
      "I.P.S Gwalior B.O": "474001",
      "Rora B.O": "475001",
      "Bhori B.O": "475001",
      "Urwa B.O": "475001",
      "Airaya B.O": "475001",
      "Billowa B.O": "475001",
      "Karahiya B.O": "475220",
      "Gohinda B.O": "475220",
      "Gadajar B.O": "475220",
      "Sankhini B.O": "475220",
      "Gharsondi B.O": "475110",
      "Salwai B.O": "475110",
      "Bhegana B.O": "475110",
      "Maharajpur B.O": "475110",
      "Mudia Pahad B.O": "474001",
      "Jorasi B.O": "475001",
      "Badori B.O": "475001",
      "Kachhaua B.O": "475001",
      "Amrol B.O": "475001",
      "Ladera B.O": "475001",
      "Mastura B.O": "475220",
      "Harsi B.O": "475220",
      "Kariyawati B.O": "475220",
      "Kerua B.O": "475220",
      "Dabra Gaon B.O": "475110",
      "Ajaypur B.O": "474001",
      "Banwar B.O": "475001",
      "Par B.O": "475001",
      "Mauch B.O": "475001",
      "Richharikalan B.O": "475220",
      "Mohan Garh B.O": "475220",
      "Shigharan B.O": "475220",
      "Chandpur B.O": "475110",
      "Khediraimal B.O": "475110",
      "Piproua B.O": "475110",
      "Samaya B.O": "475110",
      "Barotha B.O": "475110",
      "Chhimak B.O": "475110",
      "Shankarpur B.O": "474010",
      "Gijjora B.O": "475115",
      "Putti B.O": "475115",
      "Kethoda B.O": "475115",
      "Jigsoli B.O": "474010",
      "Laxmiganj  Mandi B.O": "474010",
      "Odhpura B.O": "474010",
      "Purani Chhawani B.O": "474010",
      "Sukhapatha B.O": "475115",
      "Bhageh B.O": "475115",
      "Kitora B.O": "475115",
      "Kuleth B.O": "474010",
      "Sigora B.O": "474010",
      "Badera Bujurg B.O": "475115",
      "Hathnora B.O": "475115",
      "Shukalhari B.O": "475115",
      "Morar H.O": "474006",
      "Lashkar H.O": "474001",
      "Antri S.O (Gwalior": "475001",
      "Bhitarwar S.O": "475220",
      "Dabra S.O": "475110",
      "Defence Colony S.O (Gwalior": "474002",
      "J.A. Hospital S.O": "474009",
      "Kampoo S.O": "474001",
      "Moti Jheel S.O": "474010",
      "Tekanpur S.O": "475005",
      "V.N. Marg S.O": "474001",
      "Lashkar City S.O": "474009",
      "S.P. Ashram S.O": "474012",
      "Naya Bazar S.O (Gwalior": "474009",
      "Phalka Bazar S.O": "474009",
      "Pichhore Gird S.O": "475115",
      "Shinde Ki Chhawani S.O": "474001",
      "Behat S.O (Gwalior": "475002",
      "Mohna S.O": "475330",
      "Birla Nagar S.O": "474004",
      "Dharamshala D.D. Nagar S.O": "474005",
      "Gwalior R.S. S.O": "474002",
      "Jiwaji University S.O": "474011",
      "Maharajpura A.F. S.O": "474020",
      "Moti Mahal S.O": "474007",
      "New High Court S.O": "474011",
      "R.B. Colony Gwalior S.O": "474002",
      "Shakti Nagar S.O (Gwalior": "474002",
      "R. K. Puri Gwalior SO": "474011",
      "AB VIII TM Gwalior S.O": "474015",
      "Gwalior Fort S.O": "474008",
      "Gwalior Residency S.O": "474005",
      "Hazira Chowk S.O": "474003",
      "Industrial Estate Gwalior S.O": "474002",
      "Morar Town S.O": "474006",
      "GWALIOR CITY SO": "474003"
    },
    "SHAHDOL": {
      "Chhatwai B.O": "484001",
      "Mithori B.O": "484001",
      "Nawalpur B.O": "484001",
      "Padmaniakhurd B.O": "484001",
      "Bhuibandh B.O": "484001",
      "Bandhwabada B.O": "484001",
      "Senduri B.O": "484001",
      "Singhpur B.O": "484001",
      "Bahgarh B.O": "484224",
      "Rampur B.O": "484224",
      "Chachai B.O": "484776",
      "Chauri B.O": "484001",
      "Dhari No. 2 B.O": "484776",
      "Jagmal B.O": "484776",
      "Barachh B.O": "484774",
      "Barkachh B.O": "484774",
      "Basahi B.O": "484774",
      "Mau B.O": "484774",
      "Naudhiya B.O": "484774",
      "Tikhwa B.O": "484774",
      "Deori B.O": "484110",
      "Karkati B.O": "484110",
      "Kathautia B.O": "484110",
      "Khairaha B.O": "484110",
      "Kudri B.O": "484110",
      "Pongari B.O": "484001",
      "Batura B.O": "484116",
      "Bholhara B.O": "484774",
      "Bijha B.O": "484774",
      "Chhuhi B.O": "484774",
      "Sarsi B.O": "484774",
      "Tagawar B.O": "484774",
      "Tihki B.O": "484774",
      "Amraha B.O": "484110",
      "Bartara B.O": "484110",
      "Saraikapa B.O": "484110",
      "Aswari B.O": "484770",
      "Palsau B.O": "484770",
      "Bansa B.O": "484771",
      "Masira B.O": "484771",
      "Mithi B.O": "484771",
      "Kadaudi B.O": "484669",
      "Khairahni B.O": "484669",
      "Lafda B.O": "484669",
      "Sakhi B.O": "484669",
      "Tikuri B.O": "484669",
      "Karkat B.O": "484770",
      "Khannaudhi B.O": "484770",
      "Lodi B.O": "484770",
      "Malmathar B.O": "484770",
      "Nawangaon B.O": "484770",
      "Pailwah B.O": "484770",
      "Bansukli B.O": "484771",
      "Chhakta B.O": "484771",
      "Chitraon B.O": "484771",
      "Khand B.O": "484771",
      "Kubra B.O": "484771",
      "Chuhiri B.O": "484669",
      "Deogarh B.O": "484669",
      "Dhurwar B.O": "484001",
      "Pachgaon B.O": "484001",
      "Patasi B.O": "484001",
      "Jodhpur B.O": "484001",
      "Bargawan B.O": "484117",
      "Keshwahi B.O": "484224",
      "Bakeli Colloney B.O": "484776",
      "Saman B.O": "484776",
      "Bhanni B.O": "484774",
      "Dhondha B.O": "484774",
      "Kharpa B.O": "484774",
      "Papaundh B.O": "484774",
      "Pathrehi B.O": "484774",
      "Sapta B.O": "484774",
      "Bemhori B.O": "484110",
      "Bodri B.O": "484110",
      "Rajendranagar Colony B.O": "484110",
      "Samatpur B.O": "484110",
      "Barkoda B.O": "484770",
      "Diyapipar B.O": "484770",
      "Tetki B.O": "484770",
      "Amjhor B.O": "484771",
      "Giruibadi B.O": "484771",
      "Kanadikhurd B.O": "484771",
      "Nagnaudi B.O": "484771",
      "Kolhua B.O": "484669",
      "Rasmohni B.O": "484669",
      "Uchehra B.O": "484669",
      "Sohagpur B.O": "484001",
      "Balbahra B.O": "484224",
      "Khamhidol B.O": "484224",
      "Malya B.O": "484224",
      "Budwa B.O": "484776",
      "Janakpur B.O": "484776",
      "Akhetpur B.O": "484774",
      "Baraundha B.O": "484774",
      "Bhamraha B.O": "484774",
      "Khadda B.O": "484774",
      "Kuan B.O": "484774",
      "Papaudh B.O": "484774",
      "Papderi B.O": "484774",
      "Pathratha B.O": "484774",
      "Pondireusa B.O": "484774",
      "Biruhli B.O": "484110",
      "Channaudi B.O": "484110",
      "Lalpur B.O": "484110",
      "Rungta Colliery B.O": "484110",
      "Bareli B.O": "484770",
      "Chandela B.O": "484770",
      "Amdih B.O": "484771",
      "Darain B.O": "484771",
      "Deora B.O": "484771",
      "Karki B.O": "484771",
      "Sidhi B.O": "484771",
      "Thengreha B.O": "484771",
      "Kudeli B.O": "484669",
      "Shahdol H.O": "484001",
      "Amlai Paper Mills S.O": "484117",
      "Bansagar S.O": "484776",
      "Dhanpuri Colliery S.O": "484114",
      "Gohparu S.O": "484770",
      "Shahdol R.S. S.O": "484001",
      "Jaisinghnagar S.O": "484771",
      "Jaitpur S.O (Shahdol)": "484669",
      "Burhar S.O": "484110",
      "Shahdol Bus Stand S.O": "484001",
      "Beohari S.O": "484774",
      "Dhanpuri S.O": "484114",
      "Shahdol Gharola S.O": "484001"
    },
    "BURHANPUR": {
      "Ichhapur B.O": "450445",
      "Khamni B.O": "450445",
      "Mohad B.O": "450445",
      "Chandani B.O": "450221",
      "Haidarpur B.O": "450221",
      "Palasur B.O": "450221",
      "Dapora B.O": "450445",
      "Phophanar B.O": "450445",
      "Turakgurada B.O": "450445",
      "Bhatkheda B.O": "450221",
      "Dabhiyakheda B.O": "450221",
      "Ghagharla B.O": "450221",
      "Siwal B.O": "450221",
      "Chapora B.O": "450445",
      "Dhamangaon B.O": "450445",
      "Nachankheda B.O": "450445",
      "Sangrampur B.O": "450445",
      "Bahadarpur B.O": "450331",
      "Biroda B.O": "450331",
      "Bodarli B.O": "450331",
      "Asirgarh B.O": "450331",
      "Dhulkot B.O": "450331",
      "Loni B.O": "450331",
      "Patonda B.O": "450331",
      "Sarola B.O": "450331",
      "Bori Bujurg B.O": "450331",
      "Daryapur B.O": "450331",
      "Gulai B.O": "450331",
      "Mahalgurada B.O": "450331",
      "Raitalai B.O": "450332",
      "Sheikhpur B.O": "450332",
      "Sheikhpura B.O": "450332",
      "Nawara B.O": "450221",
      "Bambhada B.O": "450445",
      "Bhawasa B.O": "450445",
      "Borsar B.O": "450445",
      "Dedtalai B.O": "450332",
      "Manjrodkala B.O": "450332",
      "Paretha B.O": "450332",
      "Ambada B.O": "450331",
      "Basad B.O": "450331",
      "Dargah e hakimi B.O": "450331",
      "Doifodia B.O": "450331",
      "Nimbola B.O": "450331",
      "Sirpur B.O": "450331",
      "Nagjhiri B.O": "450332",
      "Tukaithad B.O": "450332",
      "Hasinabad B.O": "450331",
      "Jainabad B.O": "450331",
      "Jasondi B.O": "450331",
      "Pipalpani B.O": "450332",
      "Burhanpur City S.O": "450331",
      "Burhanpur Rajpura S.O": "450331",
      "Burhanpur S.O": "450331",
      "Khaknar S.O": "450332",
      "Shahpur (Nimar) S.O": "450445",
      "Nepanagar S.O": "450221",
      "Burhanpur R.S. S.O": "450331",
      "Shahbazar Burhanpur S.O": "450331"
    },
    "SAGAR": {
      "Sanai B.O": "464240",
      "Sesai Saji B.O": "470441",
      "Khaijra Mafi B.O": "470119",
      "Mahuna Gujar B.O": "470119",
      "Manki Salaiya B.O": "470119",
      "Meerkhedi B.O": "470119",
      "Chhirari B.O": "470227",
      "Kasal Pipariya B.O": "470227",
      "Khairana B.O": "470227",
      "Muhli B.O": "470235",
      "Pamakhedi B.O": "470004",
      "Narwa B.O": "470339",
      "Papet B.O": "470339",
      "Rurawan B.O": "470339",
      "Tigoda B.O": "470339",
      "Mardanpur B.O": "470120",
      "Masurhai B.O": "470120",
      "Sattadhana B.O": "470120",
      "Barodia Kala B.O": "470441",
      "Khiriya Kala B.O": "470441",
      "Rond B.O": "470441",
      "Chandrapur B.O": "470119",
      "Jhila B.O": "470119",
      "Parasari Kalan B.O": "470119",
      "Baleh B.O": "470227",
      "Chandpur B.O": "470227",
      "Pipariya Kachhi B.O": "470227",
      "Bilagram B.O": "470339",
      "Hirapur B.O": "470339",
      "Bhapel B.O": "470120",
      "Tila Buzurg B.O": "470120",
      "Deori Naharmau B.O": "470221",
      "Besra B.O": "470441",
      "Amarmau B.O": "470339",
      "Manjala B.O": "470669",
      "Gorakhurd B.O": "470669",
      "Thikari B.O": "470120",
      "Chatubhata B.O": "470221",
      "Mokalpur B.O": "470221",
      "Udaypura Tiwari B.O": "470221",
      "Parsone B.O": "470441",
      "Semra Lodhi B.O": "470441",
      "Hirankheda B.O": "470119",
      "Barkheda Sikandar B.O": "470227",
      "Sawal Khiriya B.O": "470227",
      "Anantpura B.O": "470227",
      "Gambhiriyia B.O": "470004",
      "Sidguya B.O": "470004",
      "Khataura Kalan B.O": "470339",
      "Khera Udaet B.O": "470669",
      "Bhaisa B.O": "470120",
      "Ghambhiriyahat B.O": "470120",
      "Kanera Gaund B.O": "470120",
      "Ratona B.O": "470120",
      "Bidwas B.O": "470221",
      "Baheriya Sahani B.O": "470001",
      "Bararu B.O": "470001",
      "Padaria B.O": "470021",
      "Girwar B.O": "470021",
      "Baraj B.O": "470335",
      "Barayatha B.O": "470335",
      "Jagthar B.O": "470335",
      "Neemon B.O": "470335",
      "Patauya B.O": "470335",
      "Bahrol B.O": "470442",
      "Khurai Thawari B.O": "470051",
      "Mahuyakheda B.O": "470051",
      "Bhangarh B.O.": "470113",
      "Dehri B.O": "470113",
      "Bina Deori B.O": "470226",
      "Shyampura B.O": "470001",
      "Sironja B.O": "470001",
      "Ghoghra Khurd B.O": "470335",
      "Gugra B.O": "470335",
      "Mehar B.O": "470442",
      "Pidruya B.O": "470442",
      "Pithoriya B.O": "470442",
      "Sagoni B.O": "470442",
      "Bardha B.O": "470113",
      "Barha B.O": "470226",
      "Beldhana B.O": "470226",
      "Bamori Bika B.O": "470228",
      "Hilgan B.O": "470228",
      "Patna Buzurg B.O": "470228",
      "Bichiya B.O": "470232",
      "Chapra B.O": "470232",
      "Chulla B.O": "470232",
      "Haldi B.O": "470232",
      "Patna Khurai B.O": "470223",
      "Rampur B.O": "470223",
      "Sarkhadi B.O": "470117",
      "Toda Tarafdar B.O": "470125",
      "Jalandhar B.O": "470115",
      "Jerai B.O": "470115",
      "Kanera Neekhar B.O": "470115",
      "Naryaoliedso B.O": "470115",
      "Chakeri Bineka B.O": "470337",
      "Chhapri B.O": "470337",
      "Kerwana B.O": "470337",
      "Sahawan B.O": "470337",
      "Ghana B.O": "470235",
      "Gutori Pana B.O": "470235",
      "Jhiriya Adharpur B.O": "470235",
      "Baroda Sagar B.O": "470001",
      "Dugasara B.O": "470021",
      "Sanodha B.O": "470021",
      "Bhaidakhas B.O": "470335",
      "Binaka B.O": "470335",
      "Kandwa B.O": "470335",
      "Magardha B.O": "470335",
      "Naindhara B.O": "470335",
      "Mahuna B.O": "470335",
      "Baxwaha B.O": "470051",
      "Chitora B.O": "470051",
      "Katangi B.O": "470051",
      "Kanjiya B.O": "470113",
      "Karo R.S. B.O": "470113",
      "Korja B.O": "470113",
      "Piprasar B.O": "470113",
      "Agasaud B.O": "470113",
      "Bijora B.O": "470226",
      "Maharajpur B.O": "470226",
      "Muyarkhas B.O": "470226",
      "Padarai Buzurg B.O": "470226",
      "Rasena B.O": "470226",
      "Kumarai B.O": "470232",
      "Sewas B.O": "470232",
      "Ranguwan B.O.": "470232",
      "Jaitpur Kachya B.O": "470223",
      "Karaiya B.O": "470125",
      "Padarai B.O": "470125",
      "Tada B.O": "470669",
      "Gadola Jawahar B.O": "470118",
      "Naukheda B.O": "470118",
      "Pathariya Jogan B.O": "470118",
      "Dhanora B.O": "470117",
      "Gadola Jageer B.O": "470117",
      "Atta B.O": "470441",
      "Khaira B.O": "470117",
      "Silodha B.O": "470117",
      "Jaitpur B.O": "470226",
      "Jhamra B.O": "470226",
      "Simariya B.O": "470226",
      "Singpur Sadguya B.O": "470226",
      "Tinsi B.O": "470228",
      "Pipariaya Pachara B.O": "470232",
      "Umra B.O": "470232",
      "Jaitpur Doga B.O": "470223",
      "Madi Jamuniya B.O": "470223",
      "Bansa B.O": "470125",
      "Dungariya B.O": "470125",
      "Chandamau B.O": "470115",
      "Isurwara B.O": "470115",
      "Peepra B.O": "470115",
      "Sahajpur B.O": "470235",
      "Basari B.O": "470232",
      "Bharchha B.O": "470118",
      "Barodiya Nongar B.O": "470117",
      "Nirtala B.O": "470117",
      "Teora B.O": "470117",
      "Rajuya B.O": "470001",
      "Sothiya B.O": "470001",
      "Parsoriya B.O": "470021",
      "Bara B.O": "470335",
      "Baretha B.O": "470335",
      "Uldan B.O": "470335",
      "Laloai B.O": "470442",
      "Newtna B.O": "470442",
      "Rajwas B.O": "470442",
      "Semra hat B.O": "470442",
      "Samnapur B.O": "470051",
      "Bildho B.O": "470113",
      "Dewal B.O": "470113",
      "Dongar Salaiya B.O": "470226",
      "Singpur B.O": "470226",
      "Baroda Rehli B.O": "470228",
      "Chanauya Buzurg B.O": "470232",
      "Gunjora B.O": "470232",
      "Udaypura B.O": "470232",
      "Baheriya Kalan B.O": "470223",
      "Agariya B.O": "470125",
      "Gehuras B.O": "470125",
      "Bidwasan B.O": "470115",
      "Dhana Naryaoli B.O": "470115",
      "Chauka B.O": "470235",
      "Kevlari Kalan B.O": "470235",
      "Patha B.O": "470235",
      "Bamnora B.O": "470118",
      "Khaijra Harchand B.O": "470117",
      "Mukarampur B.O": "470117",
      "Satnai B.O": "470117",
      "Sagar Cantt H.O": "470001",
      "Bamora S.O": "470021",
      "Banda Nagar S.O": "470335",
      "Bina S.O": "470113",
      "Garhakota Nadipar S.O": "470232",
      "Kesli S.O": "470235",
      "Malthone S.O": "470441",
      "Rahatgarh S.O": "470119",
      "Rehli S.O": "470227",
      "Sagar Rajakhedi S.O": "470004",
      "DALPATPUR S.O.": "470340",
      "Banda Belai S.O": "470335",
      "Bandri S.O": "470442",
      "Bilahra Raja S.O": "470051",
      "Bina Bazaria S.O": "470113",
      "Khimlasa S.O": "470118",
      "Khurai S.O": "470117",
      "Sagar Luxmipura S.O": "470002",
      "Sagar Sadar Bazar S.O": "470002",
      "Sagar Tilli S.O": "470001",
      "Sihora S.O (Sagar)": "470120",
      "Deori S.O (Sagar)": "470226",
      "Dhana S.O": "470228",
      "Gaurjhamar S.O": "470223",
      "Jaisinagar S.O": "470125",
      "Karrapur S.O": "470337",
      "Nai Gallamandi S.O": "470002",
      "Sagar Collectrate S.O": "470001",
      "Sagar Gopalganj S.O": "470001",
      "Sagar Makronia Camp S.O": "470004",
      "Sagar Subhash Nagar S.O": "470002",
      "Shahgarh S.O (Sagar)": "470339",
      "Surkhi S.O": "470221",
      "Bina BORL S.O": "470124",
      "Deori Nadipar S.O": "470226",
      "Garhakota S.O": "470229",
      "Jaruakheda S.O": "470115",
      "Khurai City S.O": "470117",
      "Sagar Bada Bazar S.O": "470002",
      "Sagar City S.O": "470002",
      "Sagar Bhuteshwar S.O": "470002",
      "Sagar University S.O": "470003",
      "Shahpur Magrone S.O": "470669",
      "Bamora R.S S.O": "464240"
    },
    "RAJGARH": {
      "Bhagoura B.O": "465693",
      "Bhanpura B.O": "465693",
      "Jhadla B.O": "465667",
      "Mana B.O": "465667",
      "Mundlabarol B.O": "465667",
      "Badgaon B.O": "465693",
      "Kodkaya B.O": "465693",
      "Limboda B.O": "465687",
      "Pipliya Kulmi B.O": "465693",
      "Jamuniaganesh B.O": "465667",
      "Pilukhedi B.O": "465667",
      "Ghoghatpur B.O": "465693",
      "Polkheda B.O": "465693",
      "Hinotiya B.O": "465685",
      "Nipaniyagarhi B.O": "465685",
      "Bhatkheda B.O": "465689",
      "Khajurigokul B.O": "465689",
      "Bhojpur B.O": "465679",
      "Dhablikalan B.O": "465679",
      "Kulikheda B.O": "465679",
      "Papdel B.O": "465679",
      "Sameli B.O": "465679",
      "Chidlavania B.O": "465687",
      "Leemachouhan B.O": "465687",
      "Borkheda Jageer B.O": "465667",
      "Kaaned B.O": "465677",
      "Todi B.O": "465677",
      "Budhwariya Bazar B.O": "465691",
      "Dhatarawda B.O": "465691",
      "Kotrikalan B.O": "465667",
      "Tindoniya B.O": "465667",
      "Lakhoni B.O": "465693",
      "Ramgarh B.O": "465693",
      "Taleni B.O": "465697",
      "Bisoniya B.O": "465677",
      "Napanera B.O": "465677",
      "Choma B.O": "465680",
      "Iklera B.O": "465680",
      "Padlyadan B.O": "465680",
      "Jaitpurakalan B.O": "465691",
      "Kashikhedi B.O": "465691",
      "Bhaisana B.O": "465685",
      "Dhabla B.O": "465685",
      "Rosala B.O": "465685",
      "Mohan B.O": "465689",
      "Naanndni B.O": "465689",
      "Nataram B.O": "465689",
      "Bhumariya B.O": "465679",
      "Dolaj B.O": "465679",
      "Hinotya B.O": "465679",
      "Jamoniya B.O": "465679",
      "Khilchipur Town B.O": "465679",
      "Banskheda B.O": "465687",
      "Bhayana B.O": "465687",
      "Chosla B.O": "465687",
      "Sadavta B.O": "465687",
      "Semli B.O": "465687",
      "Kunwar Kotri B.O": "465685",
      "Mandawar B.O": "465685",
      "Biaora Kalan B.O": "465689",
      "Barol B.O": "465679",
      "Sadiakunwa B.O": "465679",
      "Semlikalan B.O": "465679",
      "Bakhed B.O": "465687",
      "Dhamnda B.O": "465687",
      "Panda B.O": "465687",
      "Badnagar B.O": "465667",
      "Bablda B.O": "465687",
      "Sonkheda B.O": "465687",
      "Geelakhedi B.O": "465667",
      "Jamoniyagop B.O": "465667",
      "Padlyamatatji B.O": "465697",
      "Tikod B.O": "465697",
      "Amlaar B.O": "465680",
      "Bailas B.O": "465677",
      "Barbakhurram B.O": "465680",
      "Seenkaturkipura B.O": "465680",
      "Kharpa B.O": "465691",
      "Paroliya B.O": "465691",
      "Pipliyakalan B.O": "465691",
      "Tamoliya B.O": "465691",
      "Gindorhaat B.O": "465677",
      "Haasrod B.O": "465677",
      "Mau B.O": "465697",
      "Naahli B.O": "465680",
      "Gagorani B.O": "465691",
      "Jhaadmau B.O": "465691",
      "Amlabe B.O": "465693",
      "Aandalheda B.O": "465669",
      "Bagwaaj B.O": "465669",
      "Chhota Bairasia B.O": "465669",
      "Gangahoni B.O": "465669",
      "Baredi B.O": "465683",
      "Bhatkhedi B.O": "465683",
      "Bheelvadiya B.O": "465683",
      "Udankhedi B.O": "465683",
      "Koopa B.O": "465697",
      "Padhana B.O": "465697",
      "Aagar B.O": "465669",
      "Ganiyari B.O": "465669",
      "Lakhanvaas B.O": "465669",
      "Narmalschool B.O": "465669",
      "Dehri Kalan B.O": "465683",
      "Karanvas B.O": "465683",
      "Purankhedi B.O": "465683",
      "Sultaniya B.O": "465683",
      "Bhainswamataji B.O": "465697",
      "Gopalpura B.O": "465697",
      "Sonkatch B.O": "465669",
      "Padlyaanjna B.O": "465683",
      "Paniya B.O": "465683",
      "Piplyarasoda B.O": "465683",
      "Sarali B.O": "465683",
      "Ashareta B.O": "465697",
      "Balodi B.O": "465697",
      "Biaora Mandu B.O": "465697",
      "Piplodi B.O": "465661",
      "Kotra B.O": "465669",
      "Lashkarpur B.O": "465669",
      "Mawasa B.O": "465669",
      "Sawasijageer B.O": "465669",
      "Bokdi B.O": "465683",
      "Haluhedikalan B.O": "465683",
      "Sustani B.O": "465683",
      "Gulawta B.O": "465697",
      "Kila Amargarh B.O": "465661",
      "Sawasda B.O": "465661",
      "Rajgarh(Bia) Town B.O": "465661",
      "Baiheda B.O": "465674",
      "Kachnariya B.O": "465674",
      "Khajuriya B.O": "465674",
      "Pipalheda B.O": "465674",
      "Kalipeeth B.O": "465661",
      "Chatukheda B.O": "465661",
      "Barkheda B.O": "465674",
      "Barnwa B.O": "465674",
      "Biaora R.S. B.O": "465674",
      "Dhakora B.O": "465674",
      "Khuri B.O": "465674",
      "Madhumilan Sintax B.O": "465674",
      "Karedi B.O": "465661",
      "Hirankhedi B.O": "465661",
      "Juna Biaora B.O": "465674",
      "Moya B.O": "465674",
      "Jhanjhadpur B.O": "465661",
      "Padlikhati B.O": "465661",
      "Aamliyahat B.O": "465674",
      "Kachari B.O": "465674",
      "Malawar B.O": "465674",
      "Parsuliya B.O": "465674",
      "Rajgarh(Bia) H.O": "465661",
      "Khujner S.O": "465687",
      "Machalpur S.O": "465693",
      "Sarangpur S.O": "465697",
      "Suthalia S.O": "465677",
      "Biaora S.O": "465674",
      "Boda S.O": "465685",
      "Chhapiheda S.O": "465689",
      "Narsinghgarh S.O": "465669",
      "Pachore S.O": "465683",
      "Kurawar S.O (Rajgarh)": "465667",
      "Rajgarh Bus Stand S.O": "465661",
      "Talen S.O": "465680",
      "Khilchipur S.O": "465679",
      "Zeerapur S.O": "465691"
    },
    "RATLAM": {
      "Dhamnod B.O": "457001",
      "Umar B.O": "457001",
      "Banjali B.O": "457001",
      "Dhanasuta B.O": "457001",
      "Kangsi B.O": "457001",
      "Nayan B.O": "457001",
      "Basindra B.O": "457001",
      "Bibrod B.O": "457001",
      "Naugawa B.O": "457001",
      "Devla B.O": "457001",
      "Harthali B.O": "457001",
      "Pipalkhunta B.O": "457001",
      "Jadwasakalan B.O": "457001",
      "Dilipnagar B.O": "457001",
      "Shivgarh B.O": "457001",
      "Malwasi B.O": "457001",
      "Palas B.O": "457001",
      "Shivpur B.O": "457001",
      "Titari B.O": "457001",
      "Sejawata B.O": "457001",
      "Isarthuni B.O": "457001",
      "Lunera B.O": "457001",
      "Mundri B.O": "457001",
      "Palsodi B.O": "457001",
      "Kaneri B.O": "457001",
      "Itawakhurd B.O": "457001",
      "Malwasa B.O": "457001",
      "Bhatibarodia B.O": "457001",
      "Bildi B.O": "457001",
      "Bangrod B.O": "457001",
      "Tambolia B.O": "457001",
      "Nagra B.O": "457001",
      "Barkhedakalan B.O": "457114",
      "Ghatalia B.O": "457001",
      "Raoti B.O": "457001",
      "Ranisingh B.O": "457001",
      "Dhaturia B.O": "457114",
      "Kanadia B.O": "457114",
      "Bajranggarh B.O": "457555",
      "Bhadankala B.O": "457555",
      "Chandragarh B.O": "457555",
      "Chhaoni Dodia B.O": "457555",
      "Dantodia B.O": "457441",
      "Jhalwa B.O": "457226",
      "Lasudia B.O": "457226",
      "Luhari B.O": "457226",
      "Rewas B.O": "457226",
      "Rojana B.O": "457226",
      "Uparwada B.O": "457226",
      "Uplai B.O": "457226",
      "Talidana B.O": "457340",
      "Lasudiya Surajmal B.O": "457119",
      "Luni B.O": "457119",
      "Mandawal B.O": "457119",
      "Minawada B.O": "457119",
      "Amleta B.O": "457222",
      "Barbodna B.O": "457222",
      "Baroda B.O": "457222",
      "Bhadwasa B.O": "457222",
      "Baraylamataji B.O": "457331",
      "Borkheda B.O": "457331",
      "Martandganj B.O": "457336",
      "Rola B.O": "457336",
      "Karia B.O": "457550",
      "Khokhra B.O": "457550",
      "Kunda B.O": "457550",
      "Sakraoda B.O": "457550",
      "Maukhedi B.O": "457333",
      "Bardiagoyal B.O": "457118",
      "Bhutia B.O": "457118",
      "Karwakhedi B.O": "457118",
      "Kharuakhurd B.O": "457118",
      "Kachhalia B.O": "457118",
      "Bhim B.O": "457114",
      "Khajuri Devda B.O": "457114",
      "Richha B.O": "457114",
      "Talod B.O": "457114",
      "Amarpurkala B.O": "457555",
      "Thikria B.O": "457555",
      "Itawakalan B.O": "457441",
      "Rattagarh B.O": "457441",
      "Hanumaniya B.O": "457339",
      "Moriya B.O": "457339",
      "Pingrala B.O": "457339",
      "Chourasi Barayla B.O": "457226",
      "Sarsi B.O": "457226",
      "Mamatkheda B.O": "457340",
      "Maota B.O": "457340",
      "Gunawad B.O": "457222",
      "Kanderwasa B.O": "457222",
      "Semlia B.O": "457222",
      "Hatnara B.O": "457331",
      "Asawati B.O": "457336",
      "Gondishankar B.O": "457336",
      "Mandvi B.O": "457336",
      "Aamba B.O": "457550",
      "Advania B.O": "457550",
      "Ambapada B.O": "457550",
      "Sarwan B.O": "457550",
      "Ranigaon B.O": "457333",
      "Riyawan B.O": "457333",
      "Hatpiplia B.O": "457118",
      "Jamuniashankar B.O": "457118",
      "Lodh B.O": "457118",
      "Mundlakala B.O": "457118",
      "UNI B.O": "457118",
      "Bhojakhedi B.O": "457114",
      "Sherpurkhurd B.O": "457114",
      "Vikramgarh B.O": "457114",
      "Devli B.O": "457555",
      "Gadhigamna B.O": "457555",
      "Jambukhadan B.O": "457555",
      "Kelkachh B.O": "457555",
      "Kherda B.O": "457555",
      "Kundanpur B.O": "457555",
      "Dharad B.O": "457441",
      "Dhikwa B.O": "457441",
      "Sarwad B.O": "457441",
      "Simlaoda B.O": "457441",
      "Chiklana B.O": "457339",
      "Piplia Jodha B.O": "457339",
      "Barawada B.O": "457226",
      "Naveli B.O": "457340",
      "Ranayra B.O": "457340",
      "Negarda B.O": "457222",
      "Palduna B.O": "457222",
      "Dhamedi B.O": "457331",
      "Guderkheda B.O": "457331",
      "Sherpur B.O": "457331",
      "Madhopur B.O": "457118",
      "Palsoda B.O": "457001",
      "Patan B.O": "457114",
      "Piplia Sisodia B.O": "457114",
      "Rajapura mataji B.O": "457555",
      "Birmawal B.O": "457441",
      "Mangrol B.O": "457441",
      "Pritamnagar B.O": "457441",
      "Jadwasa B.O": "457339",
      "Husaintekri B.O": "457226",
      "Lalakheda B.O": "457226",
      "Bahadurpur Jagir B.O": "457226",
      "Mundlaram B.O": "457340",
      "Kasari B.O": "457119",
      "Nipania Leela B.O": "457119",
      "Thambguradiya B.O": "457119",
      "Dhonswas B.O": "457222",
      "Hasanpalia B.O": "457222",
      "Panched B.O": "457222",
      "Nandleta B.O": "457331",
      "Banwada B.O": "457336",
      "Kalalia B.O": "457336",
      "Amargarh B.O": "457550",
      "Bodina B.O": "457550",
      "Panchewa B.O": "457333",
      "Sujapur B.O": "457333",
      "Gulbalod B.O": "457118",
      "Karadia B.O": "457118",
      "Panthpiploda B.O": "457118",
      "PIR HINGORIYA B.O": "457118",
      "Ratlam H.O": "457001",
      "Sukheda S.O": "457333",
      "Tal S.O": "457118",
      "Ringnod S.O": "457336",
      "Sailana S.O": "457550",
      "Ratlam Surajpole S.O": "457001",
      "Bajna S.O (Ratlam)": "457555",
      "Jaora Kutchery S.O": "457226",
      "Piploda S.O": "457331",
      "Ratlam City S.O": "457001",
      "Ratlam Rly Colony S.O": "457001",
      "Alote S.O": "457114",
      "Jaora Choupati S.O": "457226",
      "KALUKHEDA S.O": "457340",
      "Ratlam Ghatla Colony S.O": "457001",
      "Bilpank S.O": "457441",
      "Jaora S.O": "457226",
      "Kharwa kalan S.O": "457119",
      "Dhodhar RS S.O": "457339",
      "Namli S.O": "457222",
      "Ratlam Collectorate S.O": "457001",
      "Ratlam Jawahar Nagar S.O": "457001",
      "Ratlam Kasara Bazar S.O": "457001",
      "Ratlam Stn.Road S.O": "457001"
    },
    "DATIA": {
      "Basturi B.O": "475682",
      "Mangrol B.O": "475682",
      "Berchha B.O": "475682",
      "Sirsa B.O": "475682",
      "Dirolipar B.O": "475682",
      "Khamroli B.O": "475682",
      "Ruhera B.O": "475682",
      "Targuan B.O": "475671",
      "Udina B.O": "475336",
      "Rasulpura B.O": "475682",
      "Hinotia B.O": "475685",
      "Uprai B.O": "475685",
      "Sunari B.O": "475685",
      "Atreta B.O": "475673",
      "Toda B.O": "475673",
      "Badokhari B.O": "475673",
      "Sadwara B.O": "475671",
      "Aser B.O": "475671",
      "Ikara B.O": "475671",
      "Sohan B.O": "475336",
      "Udi B.O": "475336",
      "Gondan B.O": "475336",
      "Devai B.O": "475682",
      "Gyara B.O": "475682",
      "Atra B.O": "475682",
      "Raori B.O": "475685",
      "Pachokhara B.O": "475675",
      "Baron Kalan B.O": "475685",
      "Bhadona B.O": "475685",
      "Ingui B.O": "475673",
      "Kudari B.O": "475673",
      "Parsoda Baman B.O": "475673",
      "Parsoda Khurd B.O": "475673",
      "Marseni Khurd B.O": "475673",
      "Kusoli B.O": "475671",
      "Kamad B.O": "475671",
      "Sersa B.O": "475671",
      "Richhar B.O": "475671",
      "Neemdanda B.O": "475682",
      "Nehla B.O": "475682",
      "Sitapur B.O": "475685",
      "Bargain B.O": "475685",
      "Diguwan B.O": "475673",
      "Bhaguapura B.O": "475673",
      "Senguwan B.O": "475673",
      "Parasari B.O": "475671",
      "Noner B.O": "475686",
      "Orina B.O": "475686",
      "Bhagor B.O": "475686",
      "Bilhati B.O": "475335",
      "Berachh B.O": "475335",
      "Udgawan B.O": "475686",
      "Murera B.O": "475686",
      "Khiria Saheb B.O": "475335",
      "Sarsai B.O": "475335",
      "Kulariya B.O": "475335",
      "Softa B.O": "475335",
      "Erai B.O": "475686",
      "Jigna B.O": "475686",
      "Chhata B.O": "475686",
      "Kurthara B.O": "475686",
      "Sanora B.O": "475686",
      "Tendot B.O": "475335",
      "Badera Sopan B.O": "475335",
      "Chandrol B.O": "475335",
      "Bichhodana B.O": "475335",
      "Nunwaha B.O": "475686",
      "Salon A B.O": "475335",
      "Pandokhar B.O": "475335",
      "Pipraua Kalan B.O": "475335",
      "Singhpura B.O": "475335",
      "Khiria Ghonghu B.O": "475661",
      "Lamkana B.O": "473665",
      "Sehdora B.O": "473665",
      "Salethara B.O": "475335",
      "Lahar Haveli B.O": "475335",
      "Larayata B.O": "475661",
      "DurgaPur B.O": "475661",
      "Gohana B.O": "475661",
      "Bilhari B.O": "473665",
      "Basai B.O": "475661",
      "Bardhuwan B.O": "475661",
      "Beekar B.O": "475661",
      "Datia Civil Line B.O": "475661",
      "Makdari B.O": "475661",
      "Kumhedi B.O": "475661",
      "Renda B.O": "475661",
      "Nichroli B.O": "475661",
      "Karkhada B.O": "475661",
      "Baswaha B.O": "475661",
      "Bahadurpur B.O": "475661",
      "Dursada B.O": "475661",
      "Imalia B.O": "475661",
      "Bharoli B.O": "475675",
      "Tori B.O": "475336",
      "Buhara B.O": "475661",
      "Sirol B.O": "475661",
      "Padari B.O": "475675",
      "Kuleth B.O": "475675",
      "Lanch B.O": "475675",
      "Roora B.O": "475675",
      "Uchad B.O": "475675",
      "Jouri B.O": "475336",
      "Talgaon B.O": "475336",
      "Jhujharpur B.O": "475661",
      "Rarua Rai B.O": "475675",
      "Joura B.O": "475675",
      "Joniya B.O": "475675",
      "Sikri B.O": "475675",
      "Jigniya B.O": "475675",
      "Bhitari B.O": "475336",
      "Naya Kheda B.O": "475661",
      "Derachirula B.O": "475661",
      "Satlon B.O": "475661",
      "Kamrari B.O": "475661",
      "Semai B.O": "475661",
      "Silori B.O": "475661",
      "Dabhera B.O": "475675",
      "Murgawan B.O": "475675",
      "Piproua B.O": "475675",
      "Uchia B.O": "475675",
      "Bhalka B.O": "475336",
      "Khiria Alam B.O": "475336",
      "Kamlapuri B.O": "475336",
      "Bhansda Khurd B.O": "473660",
      "Sonagir S.O": "475685",
      "Datia RSI": "475661",
      "Baroni Datia S.O": "475686",
      "Bhandair S.O": "475335",
      "Indergarh S.O (Datia": "475675",
      "Salon B. S.O": "475336",
      "Unnao S.O": "475671",
      "Datia Bada Bazar S.O": "475661",
      "Datia S.O": "475661",
      "Tharet S.O": "475673",
      "Datia Rajgarh S.O": "475661",
      "Seondha S.O": "475682"
    },
    "SHEOPUR": {
      "Sahasram B.O": "476332",
      "Bangrod B.O": "476332",
      "SARARI B.O": "476355",
      "Sunswada B.O": "476355",
      "Peda B.O": "476355",
      "Awada B.O": "476339",
      "Jalalpura (Sheopur So) B.O": "476337",
      "Javdeshwar B.O": "476337",
      "Sonthwa B.O": "476337",
      "Iklod B.O": "476332",
      "Dhondha B.O": "476332",
      "Bargawan B.O": "476355",
      "Tulsef B.O": "476339",
      "Makdawadakalan B.O": "476339",
      "Kanapur B.O": "476337",
      "Jaida Mandi B.O": "476337",
      "Jaini B.O": "476337",
      "Chambal Colony Sheopur B.O": "476337",
      "Javasa B.O": "476337",
      "Kalarna B.O": "476337",
      "Goras B.O": "476355",
      "Khirkhiri B.O": "476355",
      "Silpuri B.O": "476355",
      "Sasaipura B.O": "476355",
      "Pandola B.O": "476339",
      "Ratodhan B.O": "476339",
      "Udhotpura (S.Baroda So)B.O": "476339",
      "Bukhari B.O": "476339",
      "Tillipur B.O": "476337",
      "Girdharpur B.O": "476337",
      "Dhodhar": "476337",
      "Manpur B.O": "476337",
      "Asida B.O": "476337",
      "Bagadiya B.O": "476337",
      "Gohta B.O": "476332",
      "Magradha B.O": "476332",
      "Arrod B.O": "476332",
      "Radep B.O": "476339",
      "Filozpura B.O": "476339",
      "Premsar B.O": "476337",
      "Soi Kalan B.O": "476337",
      "Nagda B.O": "476337",
      "Dantarda Kalan B.O": "476337",
      "Gurunawda B.O": "476337",
      "Kemarakalan B.O": "476335",
      "Heerapura (Beerpur)B.O": "476335",
      "Tarra Kalan B.O": "476335",
      "Agra B.O": "476332",
      "Dord B.O": "476332",
      "Balawani B.O": "476335",
      "Raghunathpur B.O": "476335",
      "Ghunghas B.O": "476335",
      "Chimalwani B.O": "476332",
      "Gadi B.O": "476332",
      "Shyampur B.O": "476335",
      "Ochhapura B.O": "476335",
      "Gohar B.O": "476335",
      "Gaswani B.O": "476332",
      "Kathon B.O": "476332",
      "Beerpur S.O": "476335",
      "Sheopur Baroda S.O": "476339",
      "Sheopur S.O": "476337",
      "Bijaipur S.O (Sheopur": "476332",
      "Karhal S.O (Sheopur": "476355"
    },
    "MORENA": {
      "Baghpura B.O": "476134",
      "Jakhona B.O": "476134",
      "Sirmorkapura B.O": "476134",
      "Alapur B.O": "476221",
      "Dhorera B.O": "476221",
      "Nitehara B.O": "476221",
      "Parsota B.O": "476221",
      "Bisnori B.O": "476221",
      "Chera B.O": "476221",
      "Dipera B.O": "476224",
      "Mirghan B.O": "476554",
      "Sikrodi (Khadiahar) B.O": "476554",
      "Purawas Khurd B.O": "476554",
      "Budhara B.O": "476115",
      "Gadhiya B.O": "476115",
      "Nagra (Porsa S.O)B.O": "476115",
      "Rajodha B.O": "476115",
      "Santhon B.O": "476115",
      "Dondari B.O": "476115",
      "Atar B.O": "476229",
      "Jalalgarh B.O": "476229",
      "Kulholi B.O": "476229",
      "Tentra B.O": "476229",
      "Bamsoli B.O": "476229",
      "Kuthiyana B.O": "476134",
      "Aisa B.O": "476134",
      "Imliya B.O": "476221",
      "Narhela B.O": "476221",
      "Hathariya B.O": "476221",
      "Dhamkan B.O": "476221",
      "Kondera B.O": "476224",
      "Khutiyanihar B.O": "476224",
      "Singroli B.O": "476224",
      "Pachekha B.O": "476224",
      "Ahroli B.O": "476224",
      "Reejhoni B.O": "476224",
      "Lallu Basai B.O": "476554",
      "Navali Badagoun B.O": "476554",
      "Pariksha B.O": "476554",
      "Sihoniya B.O": "476554",
      "Gopi B.O": "476554",
      "Mamchon B.O": "476228",
      "Lahrra B.O": "476228",
      "Kot Sirthara B.O": "476228",
      "Senthara Badai B.O": "476115",
      "Tareni B.O": "476115",
      "Sangoli B.O": "476115",
      "Kuretha B.O": "476115",
      "Senthara Ahir B.O": "476115",
      "Piparipooth B.O": "476115",
      "Lala ka pura B.O": "476115",
      "Semna B.O": "476229",
      "Devpur Maphi B.O": "476229",
      "Rampurkalan B.O": "476229",
      "Rahu Ka Gaoun B.O": "476229",
      "Mangrol B.O": "476229",
      "Ruar Maina Basai B.O": "476221",
      "Joura city B.O": "476221",
      "Chinnnoni Karera B.O": "476221",
      "Ghuriya Basai B.O": "476221",
      "Sumawali B.O": "476221",
      "BARA B.O": "476221",
      "Nirara B.O": "476224",
      "Sujangadi B.O": "476224",
      "Barrend B.O": "476224",
      "Nepari B.O": "476224",
      "Husainpur B.O": "476224",
      "Bharra B.O": "476224",
      "Jhundpura B.O": "476224",
      "Kolua B.O": "476554",
      "Chichawali B.O": "476554",
      "Datehara B.O": "476554",
      "Manpur Rajpooti B.O": "476554",
      "Kanhar B.O": "476228",
      "Nirar B.O": "476228",
      "Dharmgarh B.O": "476115",
      "Silawali B.O": "476115",
      "Kirranch B.O": "476115",
      "Jotai B.O": "476115",
      "Karsada B.O": "476115",
      "KuKthari B.O": "476115",
      "Kichol B.O": "476115",
      "Hirapura (Sabalgarh)B.O": "476229",
      "Javrol B.O": "476229",
      "Ram Pahadi B.O": "476229",
      "Karari B.O": "476134",
      "Chandpur B.O": "476134",
      "Bilgoun B.O": "476221",
      "Baghel B.O": "476221",
      "Mundrawaja B.O": "476221",
      "Susani B.O": "476221",
      "Itawali B.O": "476221",
      "Madhogarh B.O": "476224",
      "Chinnoni Chambal B.O": "476224",
      "Semai B.O": "476224",
      "Sujarma B.O": "476224",
      "Kurroli B.O": "476224",
      "Bhindosa B.O": "476554",
      "Tilonjari B.O": "476228",
      "Konthar Kalan B.O": "476115",
      "Konthar Khurd B.O": "476115",
      "Bhadawali B.O": "476115",
      "Raja Ka Tor B.O": "476229",
      "Chowki B.O": "476229",
      "Kishorgarh B.O": "476229",
      "Badhrentha B.O": "476229",
      "Kishanpur B.O": "476001",
      "Khaneta B.O": "476001",
      "Mrigpura B.O": "476001",
      "Jeegani B.O": "476001",
      "Nayakpura B.O": "476001",
      "Baretha B.O": "476001",
      "Gospur B.O": "476001",
      "Kamtari B.O": "476111",
      "Adhanpur B.O": "476111",
      "Jaloni B.O": "476111",
      "Johan B.O": "476111",
      "Bareh B.O": "476111",
      "Chand ka pura B.O": "476111",
      "Kasmada B.O": "476111",
      "Mahua (Ambah So)B.O": "476111",
      "Kishroli B.O": "476111",
      "Ratan Basai B.O": "476111",
      "Rithona B.O": "476111",
      "Ruar B.O": "476111",
      "Panchampura B.O": "476219",
      "Sukhpura B.O": "476219",
      "Tilawali B.O": "476219",
      "Nahar Dhonki B.O": "476219",
      "Nand Gangoli B.O": "476219",
      "Arhela B.O": "476219",
      "Mungwali": "476001",
      "Shivlal Ka Pura B.O": "476001",
      "Kheda Mevda B.O": "476001",
      "Lalorkalan B.O": "476001",
      "Dikhatpura B.O": "476001",
      "Mahasukh ka pura B.O": "476111",
      "Rached B.O": "476111",
      "Barbai B.O": "476111",
      "Malbasai B.O": "476111",
      "Thara B.O": "476111",
      "Bindwa Ambah B.O": "476111",
      "Gadhia Raipur B.O": "476111",
      "Mohanpur B.O": "476219",
      "Nandpura B.O": "476219",
      "Khitora B.O": "476219",
      "Kotwal B.O": "476001",
      "Hingona B.O": "476001",
      "Jarah B.O": "476001",
      "Mata Basaiya B.O": "476001",
      "Sihori B.O": "476001",
      "Runhera B.O": "476111",
      "Laljeet ka pura B.O": "476111",
      "Goth B.O": "476111",
      "Ummedgarh Bansi B.O": "476219",
      "Hadwansi B.O": "476219",
      "Pawaya B.O": "476444",
      "Pipersewa B.O": "476444",
      "Jaitpur B.O": "476444",
      "Jai Nagar B.O": "476444",
      "Paroli B.O": "476444",
      "Padhawali B.O": "476444",
      "Rithorakalan B.O": "476444",
      "Kharagpur B.O": "476444",
      "Khandoli B.O": "476001",
      "Hetampur B.O": "476001",
      "Joura Khurd B.O": "476001",
      "Nagra (Morena H.O) B.O": "476001",
      "Morena Goun B.O": "476001",
      "Mudiakheda B.O": "476001",
      "Parikshit Ka Pura B.O": "476111",
      "Bijaygarh B.O": "476111",
      "Ludhawali B.O": "476111",
      "Nayapura B.O": "476111",
      "Usaith B.O": "476111",
      "Khandkapura B.O": "476111",
      "Rupahati B.O": "476111",
      "Amliheda B.O": "476111",
      "Gudha Chambal B.O": "476219",
      "Galetha B.O": "476219",
      "Kumheri B.O": "476219",
      "Chaina B.O": "476219",
      "Devgarh B.O": "476219",
      "Sikrodi B.O": "476444",
      "Noorabad B.O": "476444",
      "Dhanela B.O": "476444",
      "Morena H.O": "476001",
      "Ambah S.O": "476111",
      "Banmore S.O": "476444",
      "Distt. Court Morena S.O": "476001",
      "Gopalpura Morena S.O": "476001",
      "Ambah Road Morena S.O": "476001",
      "Kelaras S.O": "476224",
      "Khadiahar S.O": "476554",
      "Morena Mandi S.O": "476001",
      "Porsa S.O": "476115",
      "Sabalgarh S.O": "476229",
      "Baghchini S.O": "476219",
      "Joura S.O": "476221",
      "Pahadgarh S.O": "476228",
      "Ambah Ganj S.O": "476111",
      "Dimni S.O": "476134",
      "Morena City S.O": "476001"
    },
    "SHIVPURI": {
      "Kalipahadi Meda B.O": "473880",
      "Naraua B.O": "473880",
      "Labheda B.O": "473995",
      "Nand B.O": "473995",
      "Pipro B.O": "473995",
      "Pipal Kheda B.O": "473995",
      "Piproda Ubari B.O": "473995",
      "Rahi B.O": "473995",
      "Budhonrajapur B.O": "473995",
      "Malaoni B.O": "473995",
      "Dabiakala B.O": "473995",
      "Semri B.O": "473995",
      "Bhesrawan B.O": "473775",
      "Galthuni B.O": "473775",
      "Chharch B.O": "473775",
      "Jhiri B.O": "473775",
      "Ranthkheda B.O": "473775",
      "Sunaj B.O": "473781",
      "Mathna B.O": "473781",
      "Veera B.O": "473781",
      "Badarwas B.O": "473995",
      "Garentha B.O": "473995",
      "Kherwas B.O": "473995",
      "Deokheda B.O": "473995",
      "Mahadeva B.O": "473775",
      "Piparghar B.O": "473775",
      "Parichha B.O": "473775",
      "Bagwasa B.O": "473775",
      "Dulhara B.O": "473775",
      "Mada B.O": "473781",
      "Padora B.O": "473781",
      "Sajai B.O": "473781",
      "Khadicha B.O": "473662",
      "Behgawa B.O": "473662",
      "Karar Kheda B.O": "473995",
      "Rewai B.O": "473995",
      "Kachhauwa B.O": "473995",
      "Harinagar B.O": "473995",
      "Gajora B.O": "473995",
      "Singhniwas B.O": "473551",
      "Raishree B.O": "473551",
      "Gangora B.O": "473551",
      "Piparsama B.O": "473551",
      "Chak Kamalpur B.O": "473551",
      "Sirsaud B.O": "473670",
      "Lukwasa B.O": "473885",
      "Atalpur B.O": "473885",
      "Muhari Kala B.O": "473585",
      "Pipra B.O": "473585",
      "Khatka B.O": "473793",
      "Ainchwara B.O": "473793",
      "Nadora B.O": "473793",
      "Chhitipur B.O": "473665",
      "Khudawli B.O": "473665",
      "Dabra Dinara B.O": "473665",
      "Damron Kalan B.O": "473665",
      "Rajgarh B.O": "473774",
      "Bamra B.O": "473775",
      "Bhatnawar B.O": "473775",
      "Amhara B.O": "473781",
      "Pachaoli B.O": "473781",
      "Pahada Khurd B.O": "473781",
      "Karahi B.O": "473662",
      "Sunari B.O": "473662",
      "Dhihala B.O": "473662",
      "Garibarod B.O": "473551",
      "Theh B.O": "473551",
      "Khandi B.O": "473551",
      "Subhashpura B.O": "473551",
      "Bamhari B.O": "473551",
      "Dholagarh B.O": "473551",
      "Budadongar B.O": "473885",
      "Bamore B.O": "473885",
      "Kafar B.O": "473585",
      "Bijrawan B.O": "473585",
      "Kali Pahari B.O": "473585",
      "Khirkit B.O": "473585",
      "Gopalpura B.O": "473793",
      "Rai B.O": "473774",
      "Benhta B.O": "473774",
      "Sakhnor B.O": "473774",
      "Ganeshkheda B.O": "473670",
      "Karya B.O": "473774",
      "Chakrana B.O": "473775",
      "Mehloni B.O": "473775",
      "Akajhiri B.O": "473781",
      "Kutwara B.O": "473781",
      "Khareh B.O": "473781",
      "Bamore Kalan B.O": "473781",
      "Jhanda B.O": "473662",
      "Chhitri B.O": "473662",
      "Bansgarh B.O": "473662",
      "Doni B.O": "473662",
      "Papredu B.O": "473662",
      "Karsena B.O": "473551",
      "Satanwada B.O": "473551",
      "Bara B.O": "473551",
      "Karmaj Kalan B.O": "473551",
      "Surwaya B.O": "473551",
      "Barodi Sadak B.O": "473551",
      "Tharra Darroni B.O": "473551",
      "Tongra B.O": "473551",
      "Bhangarh B.O": "473551",
      "Kanker B.O": "473865",
      "Barai B.O": "473885",
      "Kyara B.O": "473585",
      "Bilwara Mata B.O": "473793",
      "Jorai B.O": "473793",
      "Burda B.O": "473793",
      "Kharai Jalim B.O": "473793",
      "Thanra B.O": "473665",
      "Dhand B.O": "473665",
      "Kalipahadi Mathure B.O": "473665",
      "Kuchlon B.O": "473665",
      "Khorghar B.O": "473551",
      "Kunwarpur B.O": "473551",
      "Munderi B.O": "473551",
      "Kota B.O": "473551",
      "Purani Basti B.O": "473551",
      "Bharsula B.O": "473585",
      "Achhroni B.O": "473585",
      "Kakraua B.O": "473793",
      "Gondari B.O": "473793",
      "Gajigarh B.O": "473793",
      "Algi B.O": "473665",
      "Himmatpur B.O": "473665",
      "Dabarbhat B.O": "473665",
      "Salaiya Damron B.O": "473665",
      "Kharai B.O": "473774",
      "Mohra B.O": "473774",
      "Deharwara B.O": "473774",
      "Kilawani B.O": "473774",
      "Lewa B.O": "473774",
      "Amola B.O": "473660",
      "Badora B.O": "473660",
      "Chinod B.O": "473660",
      "Bangawan B.O": "473660",
      "Salaiya B.O": "473660",
      "Machaoli B.O": "473660",
      "Silanagar B.O": "473660",
      "Gudar B.O": "473990",
      "Silpura B.O": "473990",
      "Bhonti B.O": "473670",
      "Umri Kala B.O": "473670",
      "Sonher B.O": "473880",
      "Sesai B.O": "473774",
      "Teela B.O": "473660",
      "Narahi B.O": "473660",
      "Mungaoli B.O": "473660",
      "Kumhrraondi B.O": "473990",
      "Pura B.O": "473990",
      "Peeronth B.O": "473770",
      "Bhadauta B.O": "473770",
      "Endar B.O": "473770",
      "Khatora B.O": "473770",
      "Sehore B.O": "473865",
      "Mohini B.O": "473865",
      "Naoli B.O": "473670",
      "Pipra Pichhore B.O": "473670",
      "Chhirwaha B.O": "473670",
      "Rampur Dhamkan B.O": "473880",
      "Amolpatha B.O": "473880",
      "Karotha B.O": "473660",
      "Samoha B.O": "473660",
      "Sinawalkala B.O": "473990",
      "Dabia Jagan B.O": "473990",
      "Bijroni B.O": "473770",
      "Barod B.O": "473770",
      "Ramgarh B.O": "473770",
      "Dhigwas B.O": "473865",
      "Dargawa B.O": "473670",
      "Kakraua Thuni B.O": "473670",
      "Tharkheda B.O": "473880",
      "Dehrog B.O": "473774",
      "Lalpur B.O": "473660",
      "Sad B.O": "473660",
      "Chamraua B.O": "473990",
      "Deokho B.O": "473990",
      "Mehroli B.O": "473990",
      "Aijwara B.O": "473770",
      "Madwasa B.O": "473770",
      "Hateda B.O": "473865",
      "Dhala B.O": "473670",
      "Bamore Damron B.O": "473670",
      "Badera B.O": "473670",
      "Khod B.O": "473670",
      "Shergarh B.O": "473880",
      "Jujhai B.O": "473880",
      "Shivpuri H.O": "473551",
      "Karera S.O": "473660",
      "Narwar S.O (Shivpuri": "473880",
      "Shivpuri City S.O": "473551",
      "T.C.Karera S.O": "473662",
      "Badarwas S.O": "473885",
      "Bamorkalan S.O": "473585",
      "Dinara S.O (Shivpuri": "473665",
      "I.T.B.P Shivpuri S.O": "473551",
      "Jagatpur S.O (Shivpuri": "473774",
      "Khaniyadhana S.O": "473990",
      "Manpura S.O": "473670",
      "Pichhore S.O": "473995",
      "Rannod S.O": "473781",
      "V.R.Colony Shivpuri S.O": "473551",
      "Kolaras S.O": "473770",
      "Berad S.O": "473793",
      "Collectorate Bhawan Shiv S.O": "473551",
      "Katthamil Shivpuri S.O": "473638",
      "Magroni S.O": "473865",
      "Pohari S.O": "473775"
    },
    "DEWAS": {
      "Bairagarh B.O": "455001",
      "Harnoada B.O": "455116",
      "Lasudia Brahmin B.O": "455116",
      "Ranyal Kalan B.O": "455116",
      "Nipania B.O": "455001",
      "Gorba B.O": "455116",
      "Jamoniya B.O": "455116",
      "Jiyajigarh B.O": "455116",
      "Lasudia Kulmi B.O": "455116",
      "Mundladangi B.O": "455116",
      "Nandel B.O": "455116",
      "Kelod B.O": "455001",
      "Siya B.O": "455001",
      "Vijayganj Mandi B.O": "455001",
      "Barotha B.O": "455001",
      "Agurli B.O": "455227",
      "Bhamori B.O": "455227",
      "Udaynagar B.O": "455227",
      "Tigariya Goga B.O": "455111",
      "Jamgod B.O": "455115",
      "Arlaoda B.O": "455223",
      "Deogarh B.O": "455223",
      "Sunwani Gopal B.O": "455001",
      "Bangarda B.O": "455001",
      "Dattotar Mandi B.O": "455001",
      "Salamkhedi B.O": "455001",
      "Tonk kala B.O": "455001",
      "Chapda B.O": "455227",
      "Guradiya kala B.O": "455227",
      "Pipri B.O": "455227",
      "Punjapura B.O": "455227",
      "Nagda B.O": "455111",
      "Tigriya Chota B.O": "455111",
      "Kokhriya B.O": "455115",
      "Sadikheda B.O": "455115",
      "Sanwanrsi B.O": "455115",
      "Khajuriabina B.O": "455223",
      "Mankund B.O": "455223",
      "Maukheda B.O": "455223",
      "Nanukheda B.O": "455223",
      "Neori B.O": "455223",
      "Tappa Suklia B.O": "455223",
      "Bagankheda B.O": "455332",
      "Bamnikhurd B.O": "455332",
      "Baodi Kheda B.O": "455332",
      "Sonkhedi B.O": "455332",
      "Thuria B.O": "455332",
      "Vikrampur B.O": "455332",
      "Chandrakeshar Dam B.O": "455440",
      "Godna B.O": "455440",
      "Loharda B.O": "455440",
      "Surmania B.O": "455440",
      "Barkheda Soma B.O": "455221",
      "Chandwana B.O": "455336",
      "Chichli Rajor B.O": "455336",
      "Ganora B.O": "455336",
      "Kshipra B.O": "455001",
      "Randankhedi B.O": "455001",
      "Mundaheda B.O": "455001",
      "Patlawada B.O": "455001",
      "Agrod B.O": "455116",
      "Aalri B.O": "455001",
      "Bangar B.O": "455001",
      "Bilawali B.O": "455001",
      "Singawada B.O": "455001",
      "Binjana B.O": "455001",
      "Kalma B.O": "455001",
      "Kamlapur B.O": "455227",
      "Matmor B.O": "455227",
      "Pandutalab B.O": "455227",
      "Anwalia Piplia B.O": "455115",
      "Kalwar B.O": "455332",
      "Bedgaon B.O": "455440",
      "Bhesun B.O": "455440",
      "Bijwad B.O": "455440",
      "Chaubapipliya B.O": "455221",
      "Dehriya Sahu B.O": "455221",
      "Zikrakheda B.O": "455221",
      "Sulgaon B.O": "455336",
      "Tiwdiya B.O": "455336",
      "Umariya B.O": "455336",
      "Eklera B.O": "455339",
      "Kolari B.O": "455339",
      "Murjhal B.O": "455339",
      "Sandalpur B.O": "455339",
      "Atwas B.O": "455459",
      "Dangarakheda B.O": "455459",
      "Dhasad B.O": "455459",
      "Mohai B.O": "455459",
      "Khutkheda B.O": "455118",
      "Limboda B.O": "455223",
      "Bahirawad B.O": "455332",
      "Kusmania B.O": "455332",
      "Patrani B.O": "455332",
      "Jinwani B.O": "455440",
      "Sundrel B.O": "455440",
      "Double Chowki B.O": "455221",
      "Sannod B.O": "455221",
      "Bhandariya B.O": "455336",
      "Jiyagaon B.O": "455336",
      "Nanasa B.O": "455336",
      "Sukardi B.O": "455336",
      "Burada B.O": "455339",
      "Anabad B.O": "455118",
      "Garhkhajuria B.O": "455118",
      "Harangaon B.O": "455336",
      "Bijalgaon B.O": "455339",
      "Bisakhedi B.O": "455118",
      "Chaubara Jagir B.O": "455118",
      "Daulatpur B.O": "455118",
      "Deoguradia B.O": "455118",
      "Kheriyajagir B.O": "455118",
      "Amona B.O": "455116",
      "Pandajagir B.O": "455118",
      "Pipalrawa B.O": "455118",
      "Talod B.O": "455118",
      "Balon B.O": "455116",
      "Bhutia Bujurg B.O": "455116",
      "Chaubara Dhira B.O": "455116",
      "Rajoda B.O": "455001",
      "Padliya B.O": "455001",
      "Khareli B.O": "455001",
      "Chidawad B.O": "455001",
      "Siroliya B.O": "455001",
      "Chandupura B.O": "455227",
      "Pankunwa B.O": "455227",
      "Ratanpur B.O": "455227",
      "Churlai Badi B.O": "455115",
      "Amlataj B.O": "455223",
      "Barkheda Purvaiya B.O": "455223",
      "Amla B.O": "455332",
      "Dokakui B.O": "455332",
      "Katkut B.O": "455332",
      "Omkara B.O": "455332",
      "Piplani B.O": "455332",
      "Panigaon B.O": "455440",
      "Patadi B.O": "455221",
      "Raghogarh B.O": "455221",
      "Ajnas B.O": "455336",
      "Kankariya B.O": "455336",
      "Pipalkota B.O": "455336",
      "Richhi B.O": "455336",
      "Deepgaon B.O": "455339",
      "Khal B.O": "455339",
      "Piplianankar B.O": "455339",
      "Sawasada B.O": "455339",
      "Baijagwada B.O": "455459",
      "Khiroda B.O": "455459",
      "Babai B.O": "455118",
      "Gandharvpuri B.O": "455118",
      "Kankakhajuriya B.O": "455118",
      "Nipaniya Hur hur B.O": "455118",
      "Polai B.O": "455118",
      "Eklera Mataji B.O": "455116",
      "Dewas H.O": "455001",
      "Balgarh S.O": "455111",
      "Bhonrasa S.O": "455115",
      "Dewas Bhavanisagar S.O": "455001",
      "Dewas Industrial Estate S.O": "455001",
      "Hatpipliya S.O": "455223",
      "Karnawad S.O": "455221",
      "Sonkutch S.O": "455118",
      "Dewas Bank Note Press S.O": "455001",
      "Kantaphod S.O": "455440",
      "Dewas Bada Bazar S.O": "455001",
      "Nemawar S.O": "455339",
      "Tonkhurd S.O": "455116",
      "Bagli S.O": "455227",
      "Dewas Radhaganj S.O": "455001",
      "Kannod S.O": "455332",
      "Khategaon S.O": "455336",
      "Satwas S.O": "455459"
    },
    "MANDSAUR": {
      "Lasudia Ila B.O": "458669",
      "Bhagor B.O": "458389",
      "Manpura B.O": "458389",
      "Sedaramata B.O": "458389",
      "Dhikola B.O": "458002",
      "Multanpura B.O": "458002",
      "Sabakheda B.O": "458002",
      "Bajkhedi B.O": "458558",
      "Jhalara B.O": "458558",
      "Sunthi B.O": "458558",
      "Nagari B.O": "458669",
      "Nandwel B.O": "458669",
      "Nimbod B.O": "458669",
      "Patlawad B.O": "458669",
      "Richalal Muha B.O": "458669",
      "Sarsod B.O": "458669",
      "Dalawda B.O": "458389",
      "Deepakheda B.O": "458389",
      "Gogarpura B.O": "458002",
      "Gujarda B.O": "458002",
      "Guradia Deda B.O": "458002",
      "Guradia Lalmuha B.O": "458002",
      "Jawasia B.O": "458002",
      "Jhangria B.O": "458389",
      "Lawari B.O": "458389",
      "Bhalot B.O": "458002",
      "Dhariya Khedi B.O": "458002",
      "Aera B.O": "458558",
      "Kachnara B.O": "458558",
      "Motipura B.O": "458558",
      "Ranayara B.O": "458556",
      "Khajuri Nag B.O": "458389",
      "Amlawad B.O": "458002",
      "Bhardawad B.O": "458002",
      "Kayampur  B.O": "458558",
      "Khajuri Goud B.O": "458558",
      "Khanderia Kachar B.O": "458558",
      "Khatia Khedi B.O": "458558",
      "Kotda Bahadur B.O": "458558",
      "Nataram B.O": "458558",
      "Khilchipura B.O": "458002",
      "Jaggakhedi B.O": "458895",
      "Rewas Devra B.O": "458002",
      "Vishnia Dak Bunglow B.O": "458558",
      "Aankali Deewan B.O": "458883",
      "Sunthod B.O": "458339",
      "Jharda B.O": "458553",
      "Somia B.O": "458553",
      "Botalganj B.O": "458664",
      "Kachria Chandrawat B.O": "458664",
      "Kanghatti B.O": "458664",
      "Lunaheda B.O": "458664",
      "Bahi Parshwanath B.O": "458664",
      "Paheda B.O": "458339",
      "Admalya B.O": "458553",
      "Balaguda B.O": "458664",
      "Munderi B.O": "458664",
      "Soni B.O": "458664",
      "Hamirgarh B.O": "458775",
      "Kalakot B.O": "458775",
      "Kanwla B.O": "458775",
      "Nimthur B.O": "458775",
      "Satalkhedi B.O": "458778",
      "Bani B.O": "458888",
      "Bhaugarh B.O": "458667",
      "Dhamnar B.O": "458667",
      "Antralia B.O": "458775",
      "Babulda B.O": "458775",
      "Bhensoda Town B.O": "458778",
      "Dhuan Khedi B.O": "458778",
      "Osara B.O": "458778",
      "Akodara B.O": "458667",
      "Dhabla Madho Singh B.O": "458775",
      "Lotkhedi B.O": "458775",
      "Sandalpur B.O": "458775",
      "Sandhara B.O": "458775",
      "Sandla B.O": "458775",
      "Dalauda Rail B.O": "458667",
      "Elachi B.O": "458667",
      "Semalia Heera B.O": "458667",
      "Barkheda Loya B.O": "458880",
      "Bolia B.O": "458880",
      "Denthali Bujurg B.O": "458880",
      "Khajuri Runda B.O": "458880",
      "Akya Umaheda B.O": "458669",
      "Hatunia B.O": "458883",
      "Ladusa B.O": "458667",
      "Nandawta B.O": "458667",
      "Reenda B.O": "458667",
      "Kunchrod B.O": "458895",
      "Sihor B.O": "458895",
      "Bardia Istamurar B.O": "458880",
      "Khadawda B.O": "458880",
      "Paoti B.O": "458880",
      "Dhandhora B.O": "458669",
      "Fatehgarh B.O": "458667",
      "Karju B.O": "458667",
      "Afzalpur B.O": "458895",
      "Lodh B.O": "458895",
      "Maliya Kherkheda B.O": "458895",
      "Panpur B.O": "458895",
      "Piplia Karadia B.O": "458895",
      "C.C. Camp B.O": "458771",
      "Kotda Bujurg B.O": "458880",
      "Kurlasi B.O": "458880",
      "Piplia Jatti B.O": "458880",
      "Dhabla Mohan B.O": "458883",
      "Khajuri Panth B.O": "458883",
      "Lasudia B.O": "458883",
      "Melkheda B.O": "458883",
      "Khejdia B.O": "458990",
      "Kheta Kheda B.O": "458990",
      "Ajaypur B.O": "458888",
      "Angari B.O": "458888",
      "Borkhedi B.O": "458888",
      "Ghasoi B.O": "458888",
      "Guradia Vijay B.O": "458888",
      "Kantia B.O": "458888",
      "Tarnod B.O": "458888",
      "Tonkada B.O": "458888",
      "Dhabla B.O": "458556",
      "Asawati B.O": "458883",
      "Baghunia B.O": "458883",
      "Barkehda Nayak B.O": "458883",
      "Chandwasa B.O": "458883",
      "Sagoria B.O": "458883",
      "Shamgarh Gaon B.O": "458883",
      "Tolakhedi B.O": "458883",
      "Umria Baloda B.O": "458883",
      "Mahua B.O": "458990",
      "Saktali B.O": "458990",
      "Dhabla Bhagwan B.O": "458888",
      "Dhalpat B.O": "458888",
      "Dobra B.O": "458556",
      "Dorwada B.O": "458556",
      "Hingoria B.O": "458556",
      "Piplia Jodha B.O": "458556",
      "Sanjeet B.O": "458556",
      "Sarwania B.O": "458556",
      "Bhundia B.O": "458883",
      "Dhabla Deval B.O": "458883",
      "Parasali Tirth B.O": "458883",
      "Basai B.O": "458990",
      "Kheda B.O": "458990",
      "Rathana B.O": "458990",
      "Titrod B.O": "458990",
      "Devpura Bamni B.O": "458888",
      "Dhodhar B.O": "458888",
      "Kishorepura B.O": "458888",
      "Runija B.O": "458888",
      "Barkheda Dangi B.O": "458556",
      "Khadpalia B.O": "458556",
      "Limbavas B.O": "458556",
      "Barkheda Dev Dungari B.O": "458339",
      "Harsol B.O": "458553",
      "Barkheda Panth B.O": "458664",
      "Devari B.O": "458664",
      "Lasudia Rathor B.O": "458664",
      "Semali B.O": "458664",
      "Kaithuli B.O": "458775",
      "Kukdeshwara B.O": "458775",
      "Naoli B.O": "458775",
      "Prempuria B.O": "458775",
      "Borda B.O": "458778",
      "Badwan B.O": "458667",
      "Dhundharka B.O": "458667",
      "Garoda B.O": "458667",
      "Patela B.O": "458667",
      "Sagwali B.O": "458667",
      "Gujar Bardia B.O": "458895",
      "Jhawal B.O": "458895",
      "Udpura B.O": "458895",
      "Bardia Amra B.O": "458880",
      "Barkheda Gangasa B.O": "458880",
      "Chiknia B.O": "458880",
      "Dhalmu B.O": "458880",
      "Kharkheda B.O": "458880",
      "Sathkheda B.O": "458880",
      "Behpur B.O": "458669",
      "Khajuria Sarang B.O": "458669",
      "Dhabla Gujar B.O": "458883",
      "Parasali Ghata B.O": "458883",
      "Bilantri B.O": "458990",
      "Dhiknia B.O": "458990",
      "Rawta B.O": "458990",
      "Champakhedi B.O": "458888",
      "Kurawan B.O": "458888",
      "Suwasara Gaon B.O": "458888",
      "Billod B.O": "458556",
      "Magrana B.O": "458556",
      "Takrawad B.O": "458556",
      "Mandsaur H.O": "458001",
      "Mandsaur City S.O": "458002",
      "Mandsaur Nai Abadi S.O": "458001",
      "Bhanpura S.O": "458775",
      "Garoth S.O": "458880",
      "Kachnara Flag S.O": "458669",
      "Mandsaur Fort S.O": "458002",
      "Shri Ramtekri Mandsaur S.O": "458001",
      "Budha S.O": "458556",
      "Bhensoda Mandi S.O": "458778",
      "Gandhi Sagar S.O": "458771",
      "Shamgarh S.O": "458883",
      "Sitamau S.O": "458990",
      "Malhargarh S.O": "458339",
      "Narayangarh S.O (Mandsaur)": "458553",
      "Piplia S.O": "458664",
      "Dalauda S.O": "458667",
      "Degaon Mali S.O": "458895",
      "Laduna S.O": "458389",
      "Nahargarh S.O": "458558",
      "Suwasara Mandi S.O": "458888"
    },
    "EAST NIMAR": {
      "Barud B.O": "450771",
      "Nishania B.O": "450116",
      "Piplani B.O": "450116",
      "Somgaon B.O": "450110",
      "Sonkhedi B.O": "450116",
      "Billod B.O": "450116",
      "Bothiya B.O": "450116",
      "Lahadpur B.O": "450116",
      "Mojwadi B.O": "450116",
      "Attar B.O": "450551",
      "Goul B.O": "450551",
      "Kesun B.O": "450551",
      "Dabhi B.O": "450661",
      "Diwal B.O": "450661",
      "Goradiya B.O": "450661",
      "Indhawadi B.O": "450114",
      "Kumthi B.O": "450337",
      "Dagadkhedi B.O": "450116",
      "Gadbadi B.O": "450116",
      "Jaitapur B.O": "450116",
      "Killod B.O": "450116",
      "Kukshi Raiyat B.O": "450116",
      "Kharwa B.O": "450661",
      "Khatla B.O": "450661",
      "Mitawal B.O": "450661",
      "Kelwakhurd B.O": "450114",
      "Borisaray B.O": "450116",
      "Chanera B.O": "450116",
      "Harsud R.S. B.O": "450116",
      "Malud B.O": "450116",
      "Nazarpura B.O": "450116",
      "Atud B.O": "450551",
      "Kalmukhi B.O": "450551",
      "Khutla B.O": "450551",
      "Sulgaon B.O": "450551",
      "Ghatakhedi B.O": "450661",
      "Gujarkhedi B.O": "450114",
      "Aabud B.O": "450337",
      "Suktanagar B.O": "450337",
      "Temi Khurd B.O": "450001",
      "Ahmedpur Khaigaon B.O": "450001",
      "Amulla B.O": "450001",
      "Badgaon Mali B.O": "450001",
      "Dongargaon B.O": "450001",
      "Bhagwanpura B.O": "450051",
      "Borkheda Kalan B.O": "450110",
      "Borkheda Singaji B.O": "450110",
      "Roshiya B.O": "450771",
      "Adakheda B.O": "450117",
      "Gulai B.O": "450117",
      "Jamnapur B.O": "450117",
      "Jalwa Bujurg B.O": "450112",
      "Jamkota B.O": "450112",
      "Purani B.O": "450112",
      "Sindhkhal B.O": "450112",
      "Padlya B.O": "450117",
      "Sihada B.O": "450001",
      "Bhamgarh B.O": "450001",
      "Dharampuri B.O": "450001",
      "Badgaon Gujar B.O": "450001",
      "Temi Kalan B.O": "450001",
      "Kohdar B.O": "450001",
      "Devla B.O": "450001",
      "Bhairukheda B.O": "450771",
      "Deshgaon B.O": "450771",
      "Kondawat B.O": "450771",
      "Balwada B.O": "450881",
      "Gandhwa B.O": "450881",
      "Bangarda B.O": "450551",
      "Bhomwada B.O": "450551",
      "Boradi B.O": "450551",
      "Dhangaon B.O": "450551",
      "Ghoghalgaon B.O": "450551",
      "Malgaon B.O": "450551",
      "Matpur B.O": "450551",
      "Mohana B.O": "450551",
      "Netangaon B.O": "450551",
      "Arud B.O": "450661",
      "Aulia B.O": "450661",
      "Bilud B.O": "450661",
      "Kalanka B.O": "450661",
      "Borgaon Bujurg B.O": "450337",
      "Khirala B.O": "450337",
      "Saiyadpur B.O": "450337",
      "Piplod B.O": "450881",
      "Sahejla B.O": "450991",
      "Selda B.O": "450991",
      "Awliya B.O": "450117",
      "Bhaganwa B.O": "450117",
      "Phiphari B.O": "450117",
      "Sendhwal B.O": "450117",
      "Devalikalan B.O": "450051",
      "Sirpur B.O": "450051",
      "Gulgaon Raiyat B.O": "450112",
      "Borgaon Khurd B.O": "450001",
      "Rajur B.O": "450001",
      "Taklikalan B.O": "450001",
      "Bhojakhedi B.O": "450771",
      "Chirwel B.O": "450771",
      "Haraswada B.O": "450771",
      "Sirsod B.O": "450771",
      "Surgaonjoshi B.O": "450771",
      "Taklimori B.O": "450771",
      "Padawa Khandwa B.O": "450001",
      "Gudi B.O": "450881",
      "Karpur B.O": "450881",
      "Khidgaon B.O": "450881",
      "Kumtha B.O": "450881",
      "Kehlari B.O": "450991",
      "Kolgaon B.O": "450991",
      "Mandla B.O": "450991",
      "Rangaon B.O": "450991",
      "Kalamkhurd B.O": "450117",
      "Khokaria B.O": "450117",
      "Kotha B.O": "450117",
      "Nagotar B.O": "450117",
      "Patajan B.O": "450117",
      "Bhagawa B.O": "450554",
      "Mortakka B.O": "450554",
      "Thapna B.O": "450554",
      "Bagmar B.O": "450001",
      "Piplya Tahar B.O": "450001",
      "Khedi B.O": "450001",
      "Mokalgaon B.O": "450771",
      "Sirra B.O": "450771",
      "Bamanda B.O": "450881",
      "Rajgadh B.O": "450881",
      "Singot B.O": "450881",
      "Bhakrada B.O": "450991",
      "Rohini B.O": "450991",
      "Sanvkheda B.O": "450991",
      "Ashapur B.O": "450117",
      "Dhawadi B.O": "450117",
      "Roshni B.O": "450117",
      "Sunderdev B.O": "450117",
      "Sukva B.O": "450051",
      "Guyada B.O": "450112",
      "Khandwa H.O": "450001",
      "Bir S.O (East Nimar)": "450110",
      "Chhegaon Makhan S.O": "450771",
      "Ganesh Talai Khandwa S.O": "450001",
      "Narmada Nagar S.O (East Nimar)": "450119",
      "Rustampur S.O": "450337",
      "Jaswadi S.O": "450881",
      "Khalwa S.O": "450117",
      "Khandwa Ratagarh S.O": "450001",
      "Mandhata Omkareshwar S.O": "450554",
      "Naya Harsud S.O": "450116",
      "Pandhana S.O": "450661",
      "Punasa S.O": "450114",
      "Vidhya Nagar Khandwa S.O": "450001",
      "Mundi S.O": "450112",
      "Ghaspura Khandwa S.O": "450001",
      "Jawar S.O (East Nimar)": "450991",
      "Kharkalan S.O": "450051"
    },
    "KATNI": {
      "Dhangawan B.O": "483225",
      "Pahrua B.O": "483225",
      "Dharwara B.O": "483440",
      "Padwar B.O": "483440",
      "Biharia B.O": "483332",
      "Mahner B.O": "483332",
      "Piparia Sahlawan B.O": "483332",
      "Deora Kala B.O": "483775",
      "Gouraha B.O": "483775",
      "Talad B.O": "483225",
      "Chhapra B.O": "483440",
      "Deorimawai B.O": "483440",
      "Dheemarkheda B.O": "483332",
      "Dhoreshar B.O": "483332",
      "Khalari B.O": "483332",
      "Murwari B.O": "483332",
      "Pondi Kala (B) B.O": "483332",
      "Sagona B.O": "483332",
      "Basadi B.O": "483501",
      "Kuthla B.O": "483501",
      "Nigehra B.O": "483501",
      "Bhainswahi B.O": "483501",
      "Jhinjhari B.O": "483501",
      "Katni Rubber B.O": "483501",
      "Tilgawan B.O": "483501",
      "Gulwara B.O": "483501",
      "Khamtara Paharua B.O": "483773",
      "Parsel B.O": "483773",
      "Rohniya B.O": "483773",
      "Rampatan B.O": "483330",
      "Khamaria (Bakal) B.O": "483331",
      "Mohtara B.O": "483331",
      "Patori B.O": "483331",
      "Sihundi B.O": "483331",
      "Jagua B.O": "483770",
      "Kuteshwar Mines B.O": "483770",
      "Kuthiya Mahgawan B.O": "483770",
      "Nadavan B.O": "483770",
      "Pipariya Kalan B.O": "483770",
      "Kharkhari B.O": "483880",
      "Bandhi B.O": "483440",
      "Khirhani BO": "483440",
      "Kondia B.O": "483440",
      "Jhinna Piparia B.O": "483332",
      "Mangela Deori B.O": "483332",
      "Pindrai B.O": "483332",
      "Piparia Shukla B.O": "483332",
      "Ghunnaur B.O": "483775",
      "Gudeha B.O": "483775",
      "Nanhwara Kala B.O": "483775",
      "Bhoola B.O": "483440",
      "Chargawan B.O": "483440",
      "Piparia Paroha B.O": "483440",
      "Teori B.O": "483440",
      "Guhawal B.O": "483775",
      "Hantala B.O": "483775",
      "Jiwara B.O": "483775",
      "Kundrehi B.O": "483775",
      "Singodi B.O": "483775",
      "Ganeshpur B.O": "483501",
      "Kailwara Kala B.O": "483501",
      "Science College B.O": "483501",
      "Hirapur Kaudia B.O": "483501",
      "Bhadora B.O": "483501",
      "Kanhwara B.O.": "483501",
      "Badkhera B.O": "483225",
      "Hardua B.O": "483501",
      "Deori Guda B.O": "483773",
      "Khamaria B.O": "483773",
      "Rupondh B.O": "483773",
      "Kakrehta B.O": "483330",
      "Pathradi Piparia B.O": "483330",
      "Imalaiya B.O": "483331",
      "Chhindai Pipariya B.O": "483770",
      "Dukaria B.O": "483770",
      "Hadarhata B.O": "483770",
      "Khitoli B.O": "483770",
      "Kumharwara B.O": "483770",
      "Salaiya Sihora B.O": "483770",
      "Bamhangawan B.O": "483880",
      "Harraiya B.O": "483880",
      "Jamuwani Kalan B.O": "483880",
      "Katangi Kala B.O": "483501",
      "Nanhwara Sejha B.O": "483501",
      "Dithwara B.O": "483501",
      "Majhgawan B.O": "483501",
      "Mohas B.O": "483501",
      "Bilhari B.O": "483501",
      "Deodongra B.O": "483501",
      "Deogaon B.O": "483501",
      "Ghughara B.O": "483501",
      "Bhajia B.O": "483773",
      "Bhudsa B.O": "483773",
      "Gatakheda B.O": "483330",
      "Hathiagarh B.O": "483330",
      "Adarsh Gram Dhabaiya B.O": "483770",
      "Baranmahagawan B.O": "483770",
      "Bujbuja B.O": "483770",
      "Itoura B.O": "483770",
      "Kannaur B.O": "483770",
      "Ubra B.O": "483770",
      "Amraiyapar B.O": "483880",
      "Jobi Kalan B.O": "483880",
      "Kahangaon B.O": "483880",
      "Karitalai B.O": "483880",
      "Mehgaon B.O": "483880",
      "Chapna B.O": "483501",
      "Kailwara Khurd B.O": "483501",
      "Chaka B.O": "483501",
      "Juhla B.O": "483501",
      "Sugwan B.O": "483501",
      "Deori Hatai B.O": "483501",
      "Nitarra B.O": "483501",
      "Hathkuri B.O": "483501",
      "Bijouri B.O": "483773",
      "Katariya B.O": "483773",
      "Vilayat Kalan B.O": "483773",
      "Koodan B.O": "483330",
      "Pondi B.O": "483330",
      "Chadankheda B.O": "483331",
      "Gairtalai B.O": "483770",
      "Karela B.O": "483770",
      "Kua B.O": "483770",
      "Mangal Nagar B.O": "483504",
      "Diwan Siding B.O": "483880",
      "Padkhuri B.O": "483880",
      "Badera B.O": "483501",
      "Kanti B.O": "483501",
      "Badgaon B.O": "483990",
      "Baklehata B.O": "483990",
      "Bharatpur B.O": "483990",
      "Tehkari B.O": "483990",
      "Bachaiya B.O": "483225",
      "Padarbhata B.O": "483442",
      "Piprondh B.O": "483442",
      "Ponia B.O": "483442",
      "Raipura B.O": "483442",
      "Khamaria Jhanda B.O": "483990",
      "Anterved B.O": "483334",
      "Dasarman B.O": "483334",
      "Gaura Khamaria B.O": "483334",
      "Kachhargaon B.O": "483334",
      "Pali B.O": "483334",
      "Silondi B.O": "483334",
      "Bichua B.O": "483442",
      "Amagawan B.O": "483990",
      "Godana B.O": "483990",
      "Hardwara B.O": "483990",
      "Patauha B.O": "483990",
      "Bargi B.O": "483225",
      "Kulhua Badkhera B.O": "483442",
      "Sansarpur B.O": "483442",
      "Dang B.O": "483990",
      "Gurjikala B.O": "483990",
      "Katni H.O": "483501",
      "Katni Collectorate S.O": "483501",
      "Katni Madhav Nagar S.O": "483504",
      "Badwara S.O": "483773",
      "Katni Bazar S.O": "483501",
      "Niwar S.O": "483442",
      "Sleemnabad S.O": "483440",
      "Umaria Pan S.O": "483332",
      "Kymore S.O": "483880",
      "Bahori Band S.O": "483330",
      "Barhi S.O (Katni)": "483770",
      "Katni Bhatta Mohalla S.O": "483501",
      "Katni Cement Factory S.O": "483504",
      "Katni New Yard S.O": "483501",
      "Katni Purani Basti S.O": "483501",
      "Rithi S.O": "483990",
      "Vijayraghavgarh S.O": "483775",
      "Bakal S.O": "483331",
      "Katni Ordinance Factory S.O": "483504",
      "Katni R.S. S.O": "483501"
    },
    "GUNA": {
      "Barkhrda Hat B.O": "473101",
      "Khamkheda B.O": "473101",
      "Parwah B.O": "473105",
      "Babrikheda B.O": "473105",
      "Hamirpur B.O": "473105",
      "Kapasi B.O": "473105",
      "Rampur B.O": "473101",
      "Patondi B.O": "473115",
      "Penchi B.O": "473115",
      "Satanpur B.O": "473249",
      "Muhalpur B.O": "473249",
      "Jhagar B.O": "473105",
      "Johri B.O": "473105",
      "Padon B.O": "473105",
      "Magroda B.O": "473105",
      "Bapcha Lahriya B.O": "473115",
      "Kotra B.O": "473115",
      "Konya Kala B.O": "473115",
      "Umarthana B.O": "473118",
      "Bataoda B.O": "473222",
      "Torai B.O": "473287",
      "Jamner B.O": "473287",
      "Bhadora B.O": "473113",
      "Umri B.O": "473113",
      "Badi Ukawad B.O": "473287",
      "Shahpur B.O": "473287",
      "Todra B.O": "473287",
      "Jangru B.O": "473287",
      "Khutiyawad B.O": "473113",
      "Magrana B.O": "473113",
      "Nehgawa B.O": "473113",
      "Ukawad B.O": "473113",
      "Dharnawda B.O": "473110",
      "Ghatavda B.O": "473101",
      "Baneh B.O": "473105",
      "Sirsi B.O": "473105",
      "Markimahu B.O": "473105",
      "Kushepur B.O": "473105",
      "Rampurcolony B.O": "473105",
      "Sonkhara B.O": "473105",
      "Barkheda Khurd B.O": "473115",
      "Murela B.O": "473115",
      "Teligaon B.O": "473115",
      "Sanai B.O": "473222",
      "Mrigwas B.O": "473222",
      "Gehunkheda B.O": "473249",
      "Barkheda Gird B.O": "473249",
      "Garha B.O": "473105",
      "Ramnagar B.O": "473226",
      "Fatehgarh B.O": "473105",
      "Paranth B.O": "473105",
      "Bishanwada B.O": "473105",
      "Ramdi B.O": "473115",
      "Lakhanwas B.O": "473115",
      "Rani Khejra B.O": "473115",
      "Barod B.O": "473222",
      "Parkana B.O": "473287",
      "Barsat B.O": "473287",
      "Dongar Motipur B.O": "473287",
      "Vijaypur B.O": "473111",
      "Dongar Vijaypur B.O": "473111",
      "Bhamawad B.O": "473111",
      "Awan B.O": "473226",
      "Kherai B.O": "473226",
      "Muradpur B.O": "473110",
      "Dorana B.O": "473110",
      "Gaori B.O": "473287",
      "Nasirpur B.O": "473287",
      "Dhamnar B.O": "473113",
      "Hinotia B.O": "473113",
      "Jhajhon B.O": "473101",
      "Mawan B.O": "473001",
      "Khiriya Dangi B.O": "473101",
      "Bhador B.O": "473101",
      "Dehri Kala B.O": "473101",
      "Mudra Mata B.O": "473101",
      "Mudra Khurd B.O": "473101",
      "Khejra B.O": "473001",
      "Ramgir Kala B.O": "473101",
      "Panwari Hat B.O": "473101",
      "Haripur B.O": "473001",
      "Pagara B.O": "473001",
      "Saleh B.O": "473101",
      "Sehrog B.O": "473101",
      "Guna H.O": "473001",
      "Guna Cantt S.O": "473001",
      "Guna Collectorate S.O": "473001",
      "Bamori S.O": "473105",
      "Binaganj S.O": "473115",
      "Gail Complex S.O": "473112",
      "Guna City S.O": "473001",
      "Kumbhraj S.O": "473222",
      "Myana S.O": "473113",
      "Raghogarh S.O": "473226",
      "Ruthiyai S.O": "473110",
      "Bajranggarh S.O": "473249",
      "Chachauda S.O": "473118",
      "Maksudangarh S.O": "473287",
      "N.F.L.Vijaipur S.O": "473111",
      "Aroun S.O": "473101",
      "Guna Bazar S.O": "473001"
    },
    "HARDA": {
      "Adampur B.O": "461331",
      "Balagaon B.O": "461331",
      "Gahal B.O": "461331",
      "Harda Khurd B.O": "461331",
      "Khamlai B.O": "461331",
      "Nimgaon B.O": "461331",
      "Piplia B.O": "461331",
      "Rehtakala B.O": "461331",
      "Kheda B.O": "461331",
      "Mahandgaon B.O": "461331",
      "Makdai B.O": "461331",
      "Masangaon B.O": "461331",
      "Nandara B.O": "461331",
      "Rolgaon B.O": "461331",
      "Sonatalai B.O": "461331",
      "Sukhras B.O": "461331",
      "Bajania B.O": "461228",
      "Samardha B.O": "461228",
      "Shodalpur B.O": "461228",
      "Tajpur B.O": "461228",
      "Temagaon B.O": "461228",
      "Charuwa B.O": "461441",
      "Chokwdi B.O": "461441",
      "Dhanwara B.O": "461441",
      "Mandla B.O": "461441",
      "Mourgarhi B.O": "461441",
      "Ramtek B.O": "461441",
      "Somgaonkala B.O": "461441",
      "Bichhapur B.O": "461228",
      "Chhepaner B.O": "461228",
      "Jhardpa B.O": "461228",
      "Magardha B.O": "461228",
      "Nosar B.O": "461228",
      "Pokhrani B.O": "461228",
      "Jinwania B.O": "461331",
      "Kamtada B.O": "461331",
      "Palasner B.O": "461331",
      "Ranhai Kala B.O": "461331",
      "Ridge Gaon B.O": "461331",
      "Uda B.O": "461331",
      "Bediakala B.O": "461441",
      "Temlawadi B.O": "461441",
      "Bhadugaon B.O": "461228",
      "Charkheda B.O": "461228",
      "Pantalai B.O": "461228",
      "Rahatgaon B.O": "461228",
      "Avgaonkala B.O": "461331",
      "Bedi B.O": "461331",
      "Bhunnas B.O": "461331",
      "Handia B.O": "461331",
      "Chhipawad B.O": "461441",
      "Deepgaon B.O": "461441",
      "Kudabamafi B.O": "461441",
      "Phokharni B.O": "461441",
      "Pratapura B.O": "461441",
      "Pehtakala B.O": "461441",
      "Chhidgaon B.O": "461228",
      "Gondgaonkala B.O": "461228",
      "Jhadbeeda B.O": "461228",
      "Jiggaonkhurd B.O": "461228",
      "Maniakhedi B.O": "461228",
      "Nayagaon B.O": "461228",
      "Timarni S.O": "461228",
      "SIRALI SO": "461335",
      "Khirkiyan R.S. S.O": "461441",
      "Harda R.S. S.O": "461331",
      "Harda S.O": "461331"
    },
    "ANUPPUR": {
      "Dhangawan B.O": "484330",
      "Dhurwasin B.O": "484224",
      "Funga B.O": "484224",
      "Jamudi B.O": "484224",
      "Kelhauri B.O": "484116",
      "Audhera B.O": "484224",
      "Mediaras B.O": "484224",
      "Pasla B.O": "484224",
      "Piparia B.O": "484224",
      "Bijuri Colliery B.O": "484440",
      "Katkona B.O": "484440",
      "Kothi B.O": "484440",
      "Thangaon B.O": "484440",
      "Harad B.O": "484444",
      "Deogawan B.O": "484334",
      "Jamgaon B.O": "484334",
      "Jheek Bijuri B.O": "484334",
      "Kartora B.O": "484334",
      "Lamatola B.O": "484334",
      "Nigwani B.O": "484334",
      "Amgawan B.O": "484887",
      "Thodaha B.O": "484334",
      "Urtan B.O": "484334",
      "Beldongari B.O": "484881",
      "Benibari B.O": "484881",
      "Chhilhiyamar B.O": "484881",
      "Bilaspur B.O": "484886",
      "Khati B.O": "484886",
      "Umania B.O": "484887",
      "Anuppur Basti B.O": "484224",
      "Bamhani B.O": "484881",
      "Khoh B.O": "484224",
      "Baitola B.O": "484440",
      "Gaurela B.O": "484330",
      "Latar B.O": "484444",
      "Barbaspur B.O": "484224",
      "Chukan B.O": "484447",
      "Pasan B.O": "484336",
      "Beliabadi B.O": "484334",
      "Khodri B.O": "484334",
      "Payari B.O": "484334",
      "Rupaula B.O": "484334",
      "Basantpur B.O": "484881",
      "Dhirutola B.O": "484881",
      "Girari B.O": "484881",
      "Karanpathar B.O": "484881",
      "Karpa B.O": "484881",
      "Lakhaura B.O": "484881",
      "Seorichandas B.O": "484881",
      "Bangawan B.O": "484446",
      "Semra B.O": "484446",
      "Pondi B.O": "484113",
      "Achalpur B.O": "484881",
      "Kachhratola B.O": "484881",
      "Tulra B.O": "484881",
      "Ufrikala B.O": "484881",
      "Dola B.O": "484446",
      "Jheemar Colliery B.O": "484446",
      "Malga B.O": "484447",
      "Ramnagar Colliery B.O": "484446",
      "Cholna B.O": "484113",
      "Lapta B.O": "484113",
      "Damehri B.O": "484881",
      "Jarha B.O": "484881",
      "Jeelang B.O": "484881",
      "Khamraundh B.O": "484334",
      "Beed B.O": "484113",
      "Patnakalan B.O": "484116",
      "Bhejari B.O": "484887",
      "Johila Project B.O": "484887",
      "Khurkhuridadar B.O": "484886",
      "Chhilpa B.O": "484224",
      "Dulhara B.O": "484224",
      "Sonmauhari B.O": "484224",
      "Baherabandh B.O": "484440",
      "Gorsi B.O": "484330",
      "Laharpur B.O": "484330",
      "Bhad B.O": "484447",
      "Badra Colliery B.O": "484334",
      "Biltukari B.O": "484334",
      "Reusa B.O": "484334",
      "Tengha B.O": "484334",
      "Amdari B.O": "484881",
      "Dhunmaniya B.O": "484881",
      "Ghoghari B.O": "484881",
      "Karaundi B.O": "484887",
      "Koilari B.O": "484881",
      "Lamsarai B.O": "484881",
      "Amai Colliery S.O": "484116",
      "Anuppur S.O": "484224",
      "Jamuna Colliery S.O": "484444",
      "Kotma Colliery S.O": "484336",
      "Rajendragram S.O": "484881",
      "Rajnagar Colliery S.O": "484446",
      "Venkatnagar S.O": "484113",
      "Jaithari S.O": "484330",
      "Bijuri S.O": "484440",
      "Chachai S.O": "484220",
      "Kotma S.O": "484334",
      "Amarkantak S.O": "484886",
      "Amadand S.O": "484447",
      "S.K. Nagar S.O": "484120",
      "Igntu Amarkantak S.O.": "484887"
    },
    "UMARIA": {
      "Shahpur B.O": "484001",
      "Banka B.O": "484660",
      "Baroda B.O": "484660",
      "Harrwah B.O": "484660",
      "Amiliha B.O": "484001",
      "Raipur B.O": "484551",
      "Mangthar B.O": "484551",
      "Semra B.O": "484665",
      "Kanchanpur B.O": "484555",
      "Parsel B.O": "484555",
      "Balhaud B.O": "484665",
      "Gobarde B.O": "484665",
      "Baskuta B.O": "484555",
      "Gopalpur B.O": "484555",
      "Jarha B.O": "484555",
      "Salaiya B.O": "484001",
      "Checheria B.O": "484551",
      "Ghunghuti B.O": "484551",
      "Akhdar B.O": "484660",
      "Kaudiya B.O": "484660",
      "Narwar B.O": "484660",
      "Pathari B.O": "484555",
      "Pinaura B.O": "484555",
      "Bandhwatola B.O": "484551",
      "Sundardadar B.O": "484551",
      "Badwar B.O": "484661",
      "Bharaula B.O": "484661",
      "Bharewa B.O": "484664",
      "Bhundi B.O": "484661",
      "Mudgudi B.O": "484664",
      "Padkhuri B.O": "484664",
      "Padwar B.O": "484664",
      "Saraswahi B.O": "484661",
      "Naugawan B.O": "484665",
      "Kohka B.O": "484555",
      "Nowrrozabad  R. S. B.O": "484555",
      "Rahta B.O": "484555",
      "Amarpur B.O": "484664",
      "Baderi B.O": "484661",
      "Chansura B.O": "484664",
      "Karkeli B.O": "484661",
      "Kothari B.O": "484664",
      "Tikuri B.O": "484664",
      "Dhamokhar B.O": "484661",
      "Dhanwar B.O": "484661",
      "Indwar B.O": "484664",
      "Jhall B.O": "484664",
      "Jobi B.O": "484664",
      "Kachharwar B.O": "484661",
      "Majmanikala B.O": "484661",
      "Umaria Bakeli B.O": "484664",
      "Bakeli B.O": "484001",
      "Bilaspur B.O": "484660",
      "Lorha B.O": "484660",
      "Obra B.O": "484660",
      "Pathrahta B.O": "484660",
      "Bijauri B.O": "484665",
      "Kathar B.O": "484665",
      "Kudri B.O": "484555",
      "Badchhad B.O": "484664",
      "Chilhari B.O": "484664",
      "Khalaundh B.O": "484664",
      "Mahroi B.O": "484661",
      "Nigahri B.O": "484661",
      "Panpatha B.O": "484664",
      "Bandhavgarh National Park S.O": "484664",
      "Birsinghpur Pali S.O": "484551",
      "Umaria S.O": "484661",
      "Chandia S.O": "484660",
      "Manpur S.O (Umaria)": "484665",
      "Nowrozabad S.O": "484555"
    },
    "ASHOKNAGAR": {
      "Raosar Jagir B.O": "473885",
      "Mudra Bhadra B.O": "473331",
      "Rijoda B.O": "473331",
      "Berkhedi Tumen B.O": "473331",
      "Ratikheda B.O": "473331",
      "Athaikheda B.O": "473331",
      "Dhekan B.O": "473331",
      "Hyder B.O": "473331",
      "Patkheda B.O": "473331",
      "Khirkatanka B.O": "473446",
      "Pranpur B.O": "473446",
      "Hansari B.O": "473446",
      "Mahidpur B.O": "473335",
      "Dhakoni B.O": "473335",
      "Endore B.O": "473335",
      "Saraskhedi B.O": "473335",
      "Parsol B.O": "473335",
      "Rajtala B.O": "473335",
      "Kasbarenj B.O": "473443",
      "Amrod B.O": "473332",
      "Chhapar B.O": "473332",
      "Depalkhedi B.O": "473332",
      "Parkana B.O": "473444",
      "Achalgarh B.O": "473444",
      "Mathner B.O": "473330",
      "Pipri B.O": "473330",
      "Masidpur B.O": "473101",
      "Khajuriya Kala B.O": "473331",
      "Kukretha B.O": "473331",
      "Narayanpur B.O": "473331",
      "Rajpur B.O": "473331",
      "Tumen B.O": "473331",
      "Tarai B.O": "473446",
      "Dungasara B.O": "473332",
      "Mohanpur B.O": "473446",
      "Kadwaya B.O": "473335",
      "Babrod B.O": "473445",
      "Onder B.O": "473445",
      "Kirola B.O": "473443",
      "Keshopur B.O": "473440",
      "Singhada B.O": "473440",
      "Jheela B.O": "473330",
      "Renjha B.O": "473330",
      "Bhesarwas B.O": "473331",
      "Kachnar B.O": "473331",
      "Semrahat B.O": "473331",
      "Kariyya Rai B.O": "473331",
      "Raosar B.O": "473331",
      "Dangora Foot B.O": "473331",
      "Badera B.O": "473446",
      "Maholi B.O": "473446",
      "Nayakheda B.O": "473446",
      "Vikrampur B.O": "473446",
      "Mahuan B.O": "473335",
      "Bamnawar B.O": "473335",
      "Derkha B.O": "473335",
      "Chhapra B.O": "473335",
      "Janghar B.O": "473335",
      "Khiriyadewat B.O": "473335",
      "Madaukhedi B.O": "473443",
      "Malhargarh B.O": "473443",
      "Sigon B.O": "473440",
      "Tamasha B.O": "473440",
      "Pathari B.O": "473444",
      "Jalalpur B.O": "473330",
      "Seji B.O": "473330",
      "Bilakhedi B.O": "473331",
      "Barodia B.O": "473331",
      "Garroli B.O": "473331",
      "Bamora B.O": "473331",
      "Shri Anandpur B.O": "473331",
      "Naoni B.O": "473446",
      "Thubon B.O": "473446",
      "Pipresra B.O": "473335",
      "Dhurra B.O": "473335",
      "Gahora B.O": "473335",
      "Damdama B.O": "473445",
      "Gaduli B.O": "473445",
      "Bilheru B.O": "473443",
      "Jaleshwar B.O": "473332",
      "Garenthi B.O": "473440",
      "Dongra B.O": "473444",
      "Pilighata B.O": "473330",
      "Bagulya B.O": "473330",
      "Raje Bamora B.O": "473330",
      "Ashoknagar H.O": "473331",
      "Piprai S.O": "473440",
      "Ashoknagar Collectorate S.O": "473331",
      "Chanderi S.O": "473446",
      "Mungaoli S.O": "473443",
      "Naisarai S.O": "473332",
      "Sehrai S.O": "473444",
      "Shadora S.O": "473330",
      "Subash Ganj Ashoknagar S.O": "473331",
      "Esagarh S.O": "473335",
      "Bahadurpur S.O": "473445"
    },
    "UJJAIN": {
      "Khajuria B.O": "456665",
      "Akasoda B.O": "456222",
      "Khandoda B.O": "456222",
      "Nimboda B.O": "456222",
      "Amla B.O": "456771",
      "Bangred B.O": "456771",
      "Peerjhalar B.O": "456771",
      "Kamthana B.O": "456313",
      "Madawda B.O": "456313",
      "Bhatisuda B.O": "456331",
      "Dhabla  Hardu B.O": "456550",
      "Mahudi B.O": "456550",
      "Nazarpur B.O": "456550",
      "Parsoli B.O": "456550",
      "Birakhedi B.O": "456771",
      "Lohana B.O": "456771",
      "Molana B.O": "456771",
      "Bhikampur B.O": "456313",
      "Chirola  Chhota B.O": "456313",
      "Jagoti B.O": "456550",
      "Jalwa B.O": "456550",
      "Jhitarkhedi B.O": "456550",
      "Keson B.O": "456550",
      "Tulaheda B.O": "456550",
      "Chikli B.O": "456222",
      "Dangwada B.O": "456222",
      "Ghudawan B.O": "456222",
      "Harnawada B.O": "456222",
      "Nalva B.O": "456222",
      "Asawata B.O": "456771",
      "Nandiyasi B.O": "456313",
      "Narsingarh B.O": "456313",
      "Durgapura B.O": "456331",
      "Mehatvas B.O": "456331",
      "Dungarkheda B.O": "456550",
      "Ghonsla B.O": "456550",
      "Bamnapati B.O": "456222",
      "Ingoria B.O": "456222",
      "Kharsod Khurd B.O": "456222",
      "Sijavta B.O": "456222",
      "Barnagar  Bunglow B.O": "456771",
      "Jalodia B.O": "456771",
      "Palduna B.O": "456771",
      "Piplu B.O": "456771",
      "Chirola B.O": "456313",
      "Kharsodkalan B.O": "456313",
      "Malikhedi B.O": "456550",
      "Pat B.O": "456550",
      "Baghera B.O": "456770",
      "Jawasia Kumar B.O": "456770",
      "Kanardi B.O": "456770",
      "Bhatkhedi B.O": "456224",
      "Run Kheda B.O": "456224",
      "Kadoudiya B.O": "456668",
      "Roopakhedi B.O": "456668",
      "Semliya B.O": "456443",
      "Shakkar  Khedi B.O": "456443",
      "Banbana B.O": "456335",
      "Bolasa B.O": "456664",
      "Kachnariya B.O": "456664",
      "Matana  Kalan B.O": "456664",
      "Nauganwa B.O": "456664",
      "Piploda  Dwarkadhish B.O": "456664",
      "Aslavada B.O": "456337",
      "Badagaon B.O": "456776",
      "Jahagirpur B.O": "456337",
      "Lekoda Anjana B.O": "456337",
      "Badkummed B.O": "456661",
      "Harsodhan B.O": "456661",
      "Goyalabujurg B.O": "456003",
      "Panbihar B.O": "456006",
      "Panthpiplai B.O": "456006",
      "Ujjainiya B.O": "456550",
      "Aajmabad B.O": "456441",
      "Lalgarh B.O": "456441",
      "Lotiyajunarda B.O": "456441",
      "Makla B.O": "456441",
      "Rnayarapeer B.O": "456441",
      "Buranabad B.O": "456224",
      "Chapakhedi B.O": "456224",
      "Chapaner B.O": "456224",
      "Kesaria B.O": "456224",
      "Bappiya B.O": "456440",
      "Tutiya  Khedi B.O": "456440",
      "Khedakhajuria B.O": "456443",
      "Mahu B.O": "456443",
      "Rohil  Khurd B.O": "456335",
      "Aajdawada B.O": "456776",
      "Nogaova B.O": "456665",
      "Sumrakheda B.O": "456665",
      "KARANJ B.O": "456665",
      "KATHBAROD B.O": "456665",
      "Kaliadeh B.O": "456003",
      "Rooi B.O": "456003",
      "Amodiya B.O": "456006",
      "Chintaman Jawasia B.O": "456006",
      "Lekoda B.O": "456006",
      "Navakheda B.O": "456006",
      "Ratadia B.O": "456006",
      "Ujjain  Factory B.O": "456006",
      "MANGROLA  B.O": "456006",
      "Undasa B.O": "456006",
      "NINORA B.O": "456006",
      "SURASA B.O": "456006",
      "Paslod B.O": "456221",
      "Gogakheda B.O": "456441",
      "Kachria B.O": "456441",
      "Nainawad B.O": "456770",
      "BERCHHI B.O": "456770",
      "Akya  Jagir B.O": "456224",
      "Bhainsoda B.O": "456224",
      "Pachlasi B.O": "456224",
      "Shrivatsa B.O": "456224",
      "Etawa B.O": "456668",
      "Nanded B.O": "456668",
      "Tilawad B.O": "456668",
      "Delchi  Buzurg B.O": "456440",
      "Jhutawad B.O": "456440",
      "Dharakheda B.O": "456443",
      "Barkheda  Pitramal B.O": "456335",
      "Chandesara B.O": "456664",
      "Palsoda Makdavan B.O": "456337",
      "Suwasa B.O": "456337",
      "Khedavada B.O": "456776",
      "Chadawad B.O": "456665",
      "Kagdikaradia B.O": "456006",
      "Kaluheda B.O": "456006",
      "Talod B.O": "456006",
      "Barkheda Madan B.O": "456221",
      "Indokh B.O": "456441",
      "Kundikheda B.O": "456441",
      "Karedimataji B.O": "456770",
      "Samgi B.O": "456770",
      "Batlawdi B.O": "456224",
      "Ghinoda B.O": "456224",
      "Kanwas B.O": "456224",
      "Kapeli B.O": "456668",
      "Berchha B.O": "456440",
      "Sagwali B.O": "456440",
      "Barkheda  Buzurg B.O": "456443",
      "Chitavad B.O": "456443",
      "Hatai B.O": "456335",
      "Rupeta B.O": "456335",
      "Makdavan B.O": "456337",
      "Sandla B.O": "456337",
      "Baloda Lakkha B.O": "456776",
      "Sundarabad B.O": "456776",
      "Bichrod B.O": "456665",
      "Kaytha B.O": "456665",
      "Sodang B.O": "456003",
      "Jethal B.O": "456006",
      "Karohan B.O": "456006",
      "Pipliahama B.O": "456006",
      "Takwasa B.O": "456006",
      "Alot Jagir B.O": "456221",
      "Bedavan B.O": "456221",
      "Ujjain H.O": "456001",
      "Barnagar Town S.O": "456771",
      "Birlagram  Nagda S.O": "456331",
      "Kanasia S.O": "456770",
      "Narwar S.O (Ujjain)": "456664",
      "Ujjain  Bherugarh S.O": "456003",
      "Ujjain  Kothi S.O": "456010",
      "Ujjain  Madhonagar S.O": "456010",
      "Ujjain  Rishi Nagar S.O": "456010",
      "UJJAIN RAMGHATMARG": "456006",
      "UJJAIN NAYAPURA": "456006",
      "UJJAIN NANAKHEDA": "456010",
      "Ghattia S.O": "456550",
      "Khachraud Rs S.O": "456224",
      "Nagda S.O": "456335",
      "Ujjain Vikram University S.O": "456010",
      "Baledi S.O": "456222",
      "Bhatpachlana S.O": "456313",
      "Makdone S.O": "456668",
      "Nagda  Town S.O": "456335",
      "Runija S.O": "456776",
      "Ujjain  Gujrati  Samaj S.O": "456006",
      "Barnagar S.O": "456771",
      "Jharda S.O": "456441",
      "Khachraud S.O": "456224",
      "Mehidpur  Road S.O": "456440",
      "Mehidpur S.O": "456443",
      "Piploda  Baghla S.O": "456337",
      "Tajpur S.O (Ujjain)": "456661",
      "Tarana S.O": "456665",
      "Ujjain  City S.O": "456006",
      "Ujjain  M.L.Nagar S.O": "456010",
      "Unhel S.O": "456221"
    },
    "INDORE": {
      "Kalaria B.O": "453001",
      "Kalibillod B.O": "453001",
      "Karadia B.O": "453001",
      "Machal B.O": "453001",
      "Jalodia Gyan B.O": "453220",
      "Kanwasa B.O": "453220",
      "Mendakwas B.O": "453220",
      "Palda B.O": "452020",
      "Banedia B.O": "453115",
      "Gokulpur B.O": "453115",
      "Limbodapar B.O": "453115",
      "Murkheda B.O": "453115",
      "Jamburdi Hapsi B.O": "453112",
      "Palakhedi B.O": "453112",
      "Bachhoda B.O": "453220",
      "Bhilbadoli B.O": "453220",
      "Girota B.O": "453220",
      "Alwasa B.O": "453111",
      "Baghana B.O": "453111",
      "Kalmer B.O": "453111",
      "Datoda B.O": "452020",
      "Kampel B.O": "452020",
      "Kelod kartal B.O": "452020",
      "Buranakhedi B.O": "452016",
      "Dudhia B.O": "452016",
      "Jhalaria B.O": "452016",
      "Sivani B.O": "452016",
      "Kanadia B.O": "452016",
      "Khudel B.O": "452016",
      "Semlia Chau B.O": "452016",
      "Piwdai B.O": "452020",
      "Bhagora B.O": "453441",
      "Bhatkhedi B.O": "453441",
      "Kelod B.O": "453441",
      "Rangwasa B.O": "453001",
      "Tihi B.O": "453331",
      "Atawda B.O": "453001",
      "Bisnawada B.O": "453001",
      "Rolai B.O": "453001",
      "Agra B.O": "453115",
      "Sumtha B.O": "453115",
      "Chhadoda B.O": "453220",
      "Farkoda B.O": "453220",
      "Jamburdi Sarwar B.O": "453111",
      "Joshi Guradia B.O": "452020",
      "Pipalda B.O": "452020",
      "Tillor Khurd B.O": "452020",
      "Dakachiya B.O": "453771",
      "Hasalpur B.O": "453661",
      "Khedi Sihod B.O": "453661",
      "Amba Chandan B.O": "453441",
      "Bai B.O": "453441",
      "Chordia B.O": "453441",
      "Dharnaka B.O": "453441",
      "Harsola B.O": "453441",
      "Mhowgaon B.O": "453441",
      "Umria B.O": "453331",
      "Ajnod B.O": "453551",
      "Baloda Takun B.O": "453551",
      "Barlai Jagir B.O": "453771",
      "Kadwali Bujurg B.O": "453771",
      "Lasudia B.O": "453771",
      "Panod B.O": "453771",
      "Todi B.O": "453771",
      "Phaphund B.O": "453661",
      "Yeshwant Nagar B.O": "453661",
      "Badgonda B.O": "453441",
      "Kishanganj B.O": "453441",
      "Kodariya B.O": "453441",
      "Men B.O": "453441",
      "Pigdambar B.O": "453331",
      "Badodia Khan B.O": "453551",
      "Solsinda B.O": "453551",
      "Fatehabad Chandrawati Ganj B.O": "453551",
      "Jindakheda B.O": "453551",
      "Kachaliya B.O": "453551",
      "Kudana B.O": "453551",
      "Rajoda B.O": "453551",
      "Baolia khurd B.O": "452016",
      "Bicholi Mardana B.O": "452016",
      "Sanawadia B.O": "452016",
      "Aurangpura B.O": "453001",
      "Dhannad B.O": "453001",
      "Maithwada B.O": "453001",
      "Sagdod B.O": "453001",
      "Attaheda B.O": "453115",
      "Neori B.O": "453115",
      "Chambal B.O": "453220",
      "Palia B.O": "453111",
      "Machala B.O": "452020",
      "Pedmi B.O": "452020",
      "Tillor Bujurg B.O": "452020",
      "Kamadpur B.O": "453661",
      "Khurdi B.O": "453661",
      "Choral B.O": "453441",
      "Gawli Palasia B.O": "453441",
      "Gujarkheda B.O": "453441",
      "Jamli B.O": "453441",
      "Chhitoda B.O": "453551",
      "Guran B.O": "453551",
      "Kankaria pal B.O": "453551",
      "Indore Nagar H.O": "452007",
      "Indore G.P.O.": "452001",
      "Army Head Quarter S.O": "452006",
      "Bijasan Road S.O": "452005",
      "Gurunanak Chauk S.O": "452007",
      "Indore Cloth Market S.O": "452002",
      "Indore Courts S.O": "452007",
      "Indore R.S.S.Nagar S.O": "452011",
      "Indore Ram Bagh S.O": "452007",
      "Sanwer Link Road Indore S.O": "452010",
      "Vijay Nagar S.O": "452010",
      "Simrol S.O": "453552",
      "Indore City 2 S.O": "452002",
      "Indore Collectorate S.O": "452007",
      "Indore DDU Nagar S.O": "452010",
      "Indore Kumar Khadi S.O": "452015",
      "Indore Siyaganj S.O": "452007",
      "Lokmanya Nagar Indore S.O": "452009",
      "Nanda Nagar S.O": "452011",
      "Sudama Nagar S.O": "452009",
      "Vallabhnagar S.O (Indore)": "452003",
      "Indore Pardesipura S.O": "452003",
      "Industrial Estate S.O (Indore)": "452015",
      "Indore Nipaniya SO": "452010",
      "Shri Aurobindo S.O": "453555",
      "Rasalpura S.O": "453446",
      "Sanwer S.O": "453551",
      "Indore Khajrana S.O": "452016",
      "Indore Manorama Ganj S.O": "452001",
      "Betma S.O": "453001",
      "Radio Colony Indore S.O": "452001",
      "Rajendra Nagar S.O (Indore)": "452012",
      "Indore CGO Complex S.O": "452001",
      "Indore Kanadia Road S.O": "452016",
      "Indore Takshashila S.O": "452001",
      "Indore Uchchanyayalay S.O": "452001",
      "Khatiwala Tank S.O": "452014",
      "Hatod S.O": "453111",
      "IIM CAMPUS RAO S.O": "453556",
      "Rao S.O": "453331",
      "Depalpur S.O": "453115",
      "Gandhinagar S.O (Indore)": "453112",
      "Gautampura S.O": "453220",
      "Mhow Cantt S.O": "453441",
      "Dongargaon S.O": "453441",
      "Mhow S.O": "453441",
      "Kasturbagram S.O": "452020",
      "Manglia S.O": "453771",
      "Manpur S.O (Indore)": "453661",
      "Indore Cat S.O": "452013",
      "Indore Tillaknagar S.O": "452018",
      "Indore Tukoganj S.O": "452001"
    }
  },
  "JHARKHAND": {
    "BOKARO": {
      "NDC B.S.CITY": "827016",
      "Rahawan BO": "825325",
      "Kander BO": "829117",
      "Chuttey BO": "825315",
      "Kuruknalo BO": "825315",
      "Telo BO": "828403",
      "Hossir BO": "829111",
      "Saram BO": "829111",
      "Dania BO": "829112",
      "Nerki BO": "829112",
      "Turio BO": "829132",
      "Kanjkiro BO": "829107",
      "Narayanpur BO": "827013",
      "Armo B.O": "829107",
      "Narra BO": "828403",
      "Penk BO": "829112",
      "Chatrochatti BO": "825315",
      "Hurlung BO": "825312",
      "Gunjardih BO": "829132",
      "Guniato BO": "829107",
      "Kurumba BO": "828403",
      "Hardiamo BO": "829111",
      "Barkipunu BO": "829112",
      "Kharki BO": "829112",
      "Khanbhra B.O": "829112",
      "Chalkari BO": "829114",
      "Amlo BO": "829104",
      "Parasbani BO": "828403",
      "Taranari BO": "828403",
      "Taranga BO": "828403",
      "Angwali BO": "825102",
      "Palamu BO": "825102",
      "Siyari B.O": "829111",
      "Khetko BO": "829113",
      "Arjuwa BO": "829121",
      "Potso BO": "829144",
      "Surhi BO": "829144",
      "Tantri BO": "829144",
      "Mirzapur BO": "829121",
      "Mungasarla BO": "829121",
      "Rohar BO": "829121",
      "Makoli BO": "829144",
      "Pichari BO": "829144",
      "Champi BO": "829123",
      "Bedkaro BO": "829127",
      "Dantoo BO": "829121",
      "Ordana BO": "829121",
      "Chirudih BO": "829144",
      "Nawadih BO": "827013",
      "Ulgada BO": "829123",
      "Kurpania B.O": "829127",
      "Hazari BO": "829128",
      "Chandipur BO": "829121",
      "Chargi BO": "829121",
      "Uttasara BO": "829121",
      "Argamo BO": "829144",
      "Birni BO": "829144",
      "Chapri BO": "829144",
      "Lakrakhanda BO": "827010",
      "Makdumpur BO": "827010",
      "Mango BO": "827010",
      "Amdiha BO": "828134",
      "Banstore BO": "828134",
      "Kumirdoba BO": "828134",
      "Rangamatia BO": "828134",
      "Nawdiha BO": "828134",
      "Barajore BO": "828134",
      "Sabra BO": "828134",
      "Bijulia BO": "827013",
      "Chiksia BO": "827013",
      "Kashi Jharia BO": "827013",
      "Sardaha BO": "827013",
      "MIRDHA BO": "827013",
      "KAMALDIH BO": "827013",
      "Nayavan BO": "827013",
      "Kumhri BO": "827013",
      "Kandra BO": "827013",
      "Chando BO": "829301",
      "Gangjori BO": "829301",
      "Bhaski BO": "827302",
      "Tangtona BO": "827302",
      "Garri BO": "827302",
      "Shiv babudih BO": "828303",
      "Sonabad BO": "827010",
      "Sijua BO": "827010",
      "Chainpur BO": "827010",
      "Silphore BO": "828134",
      "Badhadih BO": "828134",
      "Kusum kiary BO": "828134",
      "Bagula BO": "828134",
      "Laghla BO": "828134",
      "Chas Bazar BO": "827013",
      "Dudhigajar BO": "827013",
      "Jamagoria BO": "827013",
      "CHANDAHA BO": "827013",
      "Pathuria BO": "829301",
      "Bagda BO": "827302",
      "Jogidih BO": "828303",
      "Mahal BO": "828303",
      "Ghatiali BO": "827010",
      "Jaridih BO": "827010",
      "Sibandih BO": "827010",
      "Chandra BO": "828134",
      "Galgaltand BO": "828134",
      "Gamhariya BO": "828134",
      "Ghagri BO": "828134",
      "Kanak Chas BO": "828134",
      "Koria BO": "828134",
      "Turidih BO": "828134",
      "Kherabera BO": "828134",
      "Phosro BO": "828134",
      "Adrakuri BO": "827013",
      "BPindragoria BO": "827013",
      "Kurra BO": "827013",
      "Olgora BO": "827013",
      "Pindrajora BO": "827013",
      "TUPRA BO": "827013",
      "GOPALPUR BO": "827013",
      "Chakulia BO": "827013",
      "Belunja BO": "827013",
      "Madhunia BO": "827013",
      "Arajoo BO": "829301",
      "Bahadurpur BO": "829301",
      "Bandhdih BO": "829301",
      "Hissim BO": "827302",
      "Khaira Chatar BO": "827302",
      "Manjura BO": "827302",
      "Pirgul BO": "827302",
      "Ponda BO": "827302",
      "Deogram BO": "828303",
      "Kunduari BO": "827010",
      "Radhanagar BO": "827010",
      "Artah BO": "828134",
      "Barmasia BO": "828134",
      "Jhalbarda BO": "828134",
      "Kumar Daga BO": "828134",
      "Pundru BO": "828134",
      "Alkusa BO": "827013",
      "Batbinore BO": "827013",
      "KRCentre BO": "827013",
      "Khamarbendi BO": "827013",
      "Pupunkee Ashram BO": "827013",
      "Satanpur BO": "827013",
      "SIYALJORI BO": "827013",
      "BRAHMANDWARIKA BO": "827013",
      "Bhandaro BO": "827013",
      "Baroo BO": "829301",
      "Chilgada BO": "829301",
      "Durgapur BO": "827302",
      "Karma BO": "827302",
      "Baidmara BO": "827009",
      "Bokaro Steel City HO": "827001",
      "Right Bank Tenughat SO": "829123",
      "Swang Colliery SO": "829128",
      "Peterbar SO": "829121",
      "TTPSLalpania SO": "829149",
      "Phusro Bazar SO": "829144",
      "Sunday Bazar SO": "829127",
      "Tenughat Dam SO": "829129",
      "Chas SO Bokaro": "827013",
      "Kasmar SO": "827302",
      "Sector IX SO": "827009",
      "SectorVI SO": "827006",
      "Chandan Kiyari SO": "828134",
      "Sector IV SO": "827004",
      "SectorI SO": "827001",
      "Chira Chas SO": "827015",
      "Balidih SO": "827014",
      "Civil Court Area Bokaro SO": "827001",
      "Garga Check Post SO": "827013",
      "Marafari Colony SO": "827012",
      "Bhojudih SO": "828303",
      "Bhandaridah SO": "829132",
      "Chandrapura SO": "828403",
      "Dhori SO": "825102",
      "Gomia SO": "829111",
      "IEGomia SO": "829112",
      "Jarangdih Colliery SO": "829113",
      "Kathara SO": "829116",
      "BSCity RS SO": "827010",
      "Jaina SO": "829301",
      "Sector III SO": "827003",
      "Bermo SO": "829104",
      "Dugdha Coal washery SO": "828404",
      "Jaridih Bazar SO": "829114",
      "Bokaro Thermal SO": "829107"
    },
    "CHATRA": {
      "KATIA BO": "825103",
      "Kasiadih BO": "825321",
      "Khadaiya BO": "825321",
      "Manatu BO": "825321",
      "Salga BO": "825321",
      "Saradhu BO": "825321",
      "Pachra BO": "825321",
      "Sildag BO": "825103",
      "Sabano BO": "825103",
      "Chattibariatu BO": "825321",
      "Dhangada BO": "825321",
      "Raham BO": "825321",
      "Benti BO": "825321",
      "Kabra BO": "825321",
      "Khuntikewal BO": "825414",
      "Bachra North B.O": "829201",
      "Bundu BO": "829201",
      "Serendag BO": "825103",
      "Hedum BO": "825103",
      "Bahera BO": "825321",
      "Peto BO": "825321",
      "Koyed BO": "825321",
      "Padumpur BO": "825321",
      "Gosaidih BO": "825414",
      "Uaraili BO": "825414",
      "Bargaon BO": "825408",
      "Karni BO": "825408",
      "Loram BO": "825408",
      "Mandhania BO": "825408",
      "Mayapur BO": "825408",
      "Mayurhand BO": "825408",
      "Pitiz BO": "825408",
      "Petadari BO": "825408",
      "Pindra BO": "825403",
      "Sahi BO": "825403",
      "Dumrikala BO": "825403",
      "Karailibar BO": "825403",
      "Sikid BO": "825403",
      "Sidki BO": "825403",
      "Yadavnagar BO": "825404",
      "Barura BO": "825404",
      "Ghourdaud BO": "825404",
      "Gajwa BO": "825404",
      "Humajam BO": "825404",
      "Daihar BO": "825408",
      "Dwaritelaiya BO": "825408",
      "Gangpur BO": "825408",
      "Gidhour BO": "825408",
      "Peltol BO": "825408",
      "Karma BO": "825401",
      "Madagada BO": "825408",
      "Meral BO": "825408",
      "Malakpur BO": "825408",
      "Pandni BO": "825408",
      "Bihiasarhachiya BO": "825403",
      "Dantar BO": "825403",
      "Hiring BO": "825403",
      "Chandrikala BO": "825404",
      "Margarah BO": "825404",
      "Monya BO": "825404",
      "Delho BO": "825103",
      "Berhna BO": "825408",
      "Dhauthawa BO": "825408",
      "Navadih Damol BO": "825408",
      "Pathalgada BO": "825408",
      "Charu BO": "825408",
      "Joldiha  BO": "825408",
      "Nongaon BO": "825408",
      "Kedlikala BO": "825403",
      "Kurkheta BO": "825403",
      "Salaiya BO": "825403",
      "Bichkila BO": "825404",
      "Chatti Anatpur BO": "825404",
      "Kaura BO": "825404",
      "Narayanpur BO": "825404",
      "Barhi BO": "825404",
      "Sikidag BO": "825404",
      "Chopey BO": "825103",
      "Chatra Bazar BO": "825401",
      "Haphuwa BO": "825401",
      "Kuba BO": "825401",
      "Mktama BO": "825401",
      "Pandeypura BO": "825401",
      "Kendinagar BO": "825401",
      "Bakchuma BO": "825401",
      "Jajlo BO": "825401",
      "Kamta BO": "825401",
      "Kanhachatti BO": "825401",
      "Tapej BO": "825401",
      "Tatra BO": "825401",
      "Barhmana BO": "825401",
      "Gorhai BO": "825401",
      "Amjhar BO": "825408",
      "Barisakhi BO": "825408",
      "Parsauni BO": "825408",
      "Pathra BO": "825408",
      "Bariatu BO": "825408",
      "Dhuna BO": "825408",
      "Pahra BO": "825408",
      "Sonki BO": "825408",
      "Kobna BO": "825403",
      "Daha BO": "825403",
      "Manjhgawan BO": "825411",
      "Gerua BO": "825404",
      "Jogiara BO": "825404",
      "Kunda BO": "825404",
      "Baudhadih BO": "825404",
      "Bagra BO": "825103",
      "Aurugerua BO": "825414",
      "Baluri BO": "825401",
      "Kolhaiya BO": "825401",
      "Laralutudag BO": "825401",
      "Nawadih Panari BO": "825401",
      "Tikar BO": "825401",
      "Tulbul BO": "825401",
      "Ara BO": "825401",
      "Bengokala BO": "825401",
      "Dariatu BO": "825401",
      "Lem BO": "825401",
      "Lengwa BO": "825401",
      "Paradih BO": "825401",
      "Jabra BO": "825103",
      "Piri BO": "825103",
      "Shivrajpur BO": "825103",
      "Banasandi BO": "825103",
      "Dadi BO": "825103",
      "Ichak BO": "825103",
      "Gandharia BO": "825401",
      "Pagar BO": "825103",
      "Lawalong BO": "825103",
      "Shila BO": "825103",
      "Tutilawa BO": "825103",
      "Hurnali BO": "825103",
      "Kolkole BO": "825103",
      "Edla BO": "825103",
      "Baraini BO": "825401",
      "Ghanghari BO": "825401",
      "Unta BO": "825401",
      "Darha BO": "825401",
      "Dewaria BO": "825401",
      "Jangi BO": "825401",
      "Kataiya BO": "825401",
      "Tilhet BO": "825401",
      "Damodoia BO": "825401",
      "Dunduwa BO": "825103",
      "Nawada BO": "825103",
      "Pundra BO": "825103",
      "Rimi BO": "825103",
      "Simaria SO": "825103",
      "Tandwa SO Chatra": "825321",
      "NTPC North Karanpura SO": "825415",
      "Pratappur SO Chatra": "825404",
      "Bachra SO": "829201",
      "Chatra SO Chatra": "825401",
      "Jori SO": "825403",
      "Itkhori SO": "825408",
      "Hunterganj SO": "825414"
    },
    "RAMGARH": {
      "BHANDRA BO": "829143",
      "Manjhala chumba BO": "829101",
      "Shah Colony BO": "829101",
      "Bicha BO": "829143",
      "Baridih BO": "829102",
      "Lapanga Colliery BO": "829105",
      "Sondimra BO": "829110",
      "Sosokala BO": "829110",
      "Sutari BO": "829110",
      "Toiyar BO": "829110",
      "Karma BO": "829117",
      "Terpa BO": "829118",
      "Sankul BO": "825411",
      "Chainpur BO": "825330",
      "Souda Basti BO": "829133",
      "Hesla BO": "829101",
      "Sirka Nd BO": "829101",
      "Sundernagar BO": "829106",
      "Barkipona BO": "825101",
      "Gandkey BO": "825101",
      "Gossa BO": "825101",
      "Ichatu BO": "825101",
      "Kurum BO": "825101",
      "Lari BO": "825101",
      "Potamdag BO": "825101",
      "Soso BO": "825101",
      "Kulhi BO": "825101",
      "Barlanga BO": "829110",
      "Betulkala BO": "829110",
      "Chari BO": "829110",
      "Laiyo BO": "825325",
      "Hesagarha BO": "825316",
      "Mandu BO": "825316",
      "Digwar BO": "829117",
      "Palani BO": "829119",
      "Talatand BO": "829119",
      "Honhey BO": "829150",
      "Sandi BO": "829150",
      "Mahuatand BO": "829134",
      "Tirla BO": "829134",
      "Arakanta BO": "829134",
      "Belsagra BO": "825330",
      "Rabodh BO": "825330",
      "Barka Chumba BO": "829101",
      "Gegda BO": "829143",
      "Pali BO": "829105",
      "Deoria Bargaon BO": "829106",
      "Kaitha BO": "825101",
      "Kundrukala BO": "825101",
      "Borobing BO": "825101",
      "Bariatu BO": "829110",
      "Korrambey BO": "829110",
      "Maganpur BO": "829110",
      "Murpa BO": "829110",
      "Saram BO": "829110",
      "Saradih BO": "829110",
      "Jainagar BO": "829118",
      "Patratu Diesel Colony ND BO": "829118",
      "Hafua BO": "829119",
      "Koto BO": "829119",
      "Bhuchungdih BO": "829150",
      "Bargaon BO": "829134",
      "Hesalong BO": "829101",
      "Chaingada BO": "829103",
      "Teliyatu BO": "829102",
      "Sanki BO": "829105",
      "Jawaharnagar BO": "829106",
      "Chhatar BO": "825101",
      "Harhadkander BO": "825101",
      "Jamira BO": "825101",
      "Korchey BO": "825101",
      "Dari BO": "829109",
      "Banda BO": "829110",
      "Hesapora BO": "829110",
      "Kumhardaga BO": "829110",
      "Sangrampur BO": "829110",
      "Kedlanagar BO": "825325",
      "Bharechnagar BO": "829117",
      "Hariharpur BO": "829119",
      "Sikani BO": "829150",
      "Marangmarcha BO": "829150",
      "Banji BO": "825314",
      "Ramgarh Cantt HO": "829122",
      "Tapin SO": "825326",
      "Chittarpur SO": "825101",
      "Gola SO Ramgarh": "829110",
      "Prc SO": "829130",
      "Bhadaninagar SO": "829105",
      "Giddi C SO": "829109",
      "Kedla SO": "825325",
      "Kuju SO": "825316",
      "Marar SO": "829117",
      "Patratu SO": "829118",
      "Patratu TPS SO": "829119",
      "Ramgarh Project SO": "829150",
      "Ramgarh SO Ramgarh": "829122",
      "Religarha SO": "829129",
      "Sarubera SO": "829134",
      "Sounda D SO": "829133",
      "Src SO": "829131",
      "Ghatotand SO": "825314",
      "Argada SO": "829101",
      "Balkudra SO": "829143",
      "Barkakana SO": "829102",
      "Bhurkunda Bazar SO": "829106",
      "Giddi A SO": "829108",
      "Barkakana NTS SO": "829103",
      "Bhurkunda SO": "829135",
      "Topa Coliery SO": "825330",
      "Sayal SO": "829125",
      "Sounda C SO": "829126"
    },
    "PALAMU": {
      "Tilo BO": "822123",
      "Bhatwaliya BO": "822132",
      "Musikhap BO": "822132",
      "Gharatia BO": "822132",
      "Kajru Khurd BO": "822132",
      "Fulia": "822132",
      "KajruKala": "822132",
      "Kutmu BO": "822132",
      "Murma Kala BO": "822132",
      "Ratnag BO": "822132",
      "Dihariya BO": "822132",
      "Sildilli": "822132",
      "Mahudand": "822132",
      "Tisibar BO": "822132",
      "Dalakala": "822132",
      "Ghasidag": "822132",
      "Gari BO": "822124",
      "Rajhara Colliery BO": "822124",
      "Tukbera": "822124",
      "Guri": "822124",
      "Khamdih BO": "822126",
      "Basna BO": "822124",
      "Bhandar BO": "822124",
      "Pandu BO": "822124",
      "Pandwa": "822124",
      "Polpol BO": "822126",
      "Bohita": "822126",
      "Ponchi": "822126",
      "Kadhwan BO": "822124",
      "Kanda BO": "822124",
      "Lalgarh BO": "822124",
      "Nawgarha BO": "822124",
      "Sigsigi BO": "822124",
      "Tolera BO": "822124",
      "Radba": "822124",
      "Bakoriya BO": "822126",
      "Dhawadih BO": "822126",
      "Bari": "822126",
      "Rebaratu": "822126",
      "Ketat Kala BO": "822124",
      "Jhabar BO": "822126",
      "Sikki Kala BO": "822126",
      "Dulsulma": "822126",
      "Lahlahe": "822126",
      "Lagma BO": "822133",
      "Kadalkurmi BO": "822120",
      "Satbahini BO": "822120",
      "Latpauri": "822120",
      "Champi Kala BO": "822122",
      "Dandar Kala BO": "822122",
      "Dhub BO": "822122",
      "Dwarika BO": "822122",
      "Naudiha": "822122",
      "Nawadih": "822122",
      "Pagar Khurd": "822122",
      "Pakariya": "822122",
      "Chetma BO": "822123",
      "Dipauwa BO": "822123",
      "Dulhi BO": "822123",
      "Gahar Pathara BO": "822123",
      "Chak BO": "822123",
      "Loinga BO": "822123",
      "Naudiha-2": "822123",
      "Rangeya": "822123",
      "Saguna": "822123",
      "Silidliya Khurd": "822123",
      "Sole": "822123",
      "Suntha": "822123",
      "Purabdiha BO": "822110",
      "Rajhara RS BO": "822110",
      "Ramgarh BO": "822110",
      "Majhgawan": "822110",
      "Neura": "822110",
      "Shahpur South": "822110",
      "Naudiha Bazar BO": "822113",
      "Naudiha Khajuri BO": "822113",
      "Khairadohar BO": "822113",
      "Kharagpur BO": "822113",
      "Munkeri BO": "822113",
      "Sakaldipa BO": "822113",
      "Chiru": "822113",
      "Hutukdag": "822113",
      "Cherai-2": "822113",
      "Masihani": "822113",
      "Pindrahi": "822113",
      "Sohdagkhurd": "822113",
      "I E Sudna BO": "822102",
      "Singra Khurd BO": "822102",
      "Pokhraha Khurd": "822102",
      "Sudna West": "822102",
      "Kosiara BO": "822115",
      "Pansa BO": "822115",
      "Babhandih": "822115",
      "Kurhat Kataiya BO": "822131",
      "Alinagar BO": "822116",
      "Kamgarpur BO": "822116",
      "Poldihjagdishpur BO": "822116",
      "Karkatta": "822113",
      "Kurmipur": "822116",
      "Ashehar BO": "822118",
      "Rajwadih BO": "822118",
      "Sangbar BO": "822118",
      "Nawa Bazar BO": "822113",
      "Pachmo BO": "822113",
      "Sarsot BO": "822113",
      "Telari BO": "822113",
      "Udaigarh BO": "822113",
      "Murumdag": "822113",
      "Sahpur": "822113",
      "Sua BO": "822102",
      "Baralota South": "822102",
      "Jonr": "822102",
      "Kauria": "822102",
      "Redma South": "822102",
      "Sarja": "822102",
      "Bilashpur BO": "822115",
      "Chaukri BO": "822115",
      "Kabrakhurd BO": "822115",
      "Kalapahad": "822116",
      "Lotaniya": "822116",
      "Gentha BO": "822118",
      "Gurha BO": "822118",
      "Kazi Pakri BO": "822118",
      "Kundri BO": "822118",
      "Manjhigaon BO": "822118",
      "Jamune": "822118",
      "Kotkhas": "822118",
      "Kurain Patra": "822118",
      "Rajhara": "822118",
      "Selari": "822118",
      "Tariya": "822118",
      "Udaipura": "822118",
      "Babhandih BO": "822113",
      "Chaparwar BO": "822113",
      "Dali BO": "822113",
      "Kauwal BO": "822113",
      "Manjhauli BO": "822113",
      "Namudag BO": "822113",
      "Pipra BO": "822113",
      "Saraidih BO": "822113",
      "Dhakcha": "822113",
      "Tal BO": "822122",
      "Tetrain BO": "822122",
      "Udaipur BO": "822122",
      "Hotai": "822122",
      "Naudiha BO": "822123",
      "Palhe Kala BO": "822123",
      "Pandeypura BO": "822123",
      "Roll BO": "822123",
      "Sirma BO": "822123",
      "Dumri": "822123",
      "Maghouli": "822123",
      "Chando BO": "822110",
      "Harinamar BO": "822110",
      "Ausane": "822110",
      "Bansdih": "822110",
      "Bansdih Khurd": "822110",
      "Barawn": "822110",
      "Basariakala": "822110",
      "Bedma Babhandih": "822110",
      "Bodi": "822110",
      "Budhibir": "822110",
      "Chorhat": "822110",
      "Hutar": "822110",
      "Taridih": "822113",
      "Kachanpur": "822113",
      "Kumikalan": "822113",
      "Madwa": "822113",
      "Chiyanki BO": "822102",
      "Jogiyahi Tola BO": "822102",
      "Karimandih BO": "822115",
      "Kukahi BO": "822115",
      "Sadeya": "822115",
      "Halka BO": "822131",
      "Satgawa BO": "822131",
      "Kajrat Nawadih BO": "822116",
      "Kusha BO": "822116",
      "Mahuari BO": "822116",
      "Sabano BO": "822116",
      "Utari Road BO": "822116",
      "Kosi": "822116",
      "Bansdih BO": "822118",
      "Basaura BO": "822118",
      "Gurua BO": "822118",
      "Pathakpagar BO": "822118",
      "Sagalim BO": "822118",
      "Tarhasi BO": "822118",
      "Darudih": "822118",
      "Goindi": "822118",
      "Ghotua": "822118",
      "Hartua": "822118",
      "Juru": "822118",
      "Pipra Khurd": "822118",
      "Bishunpur BO": "822113",
      "Cherai BO": "822113",
      "Dagra BO": "822113",
      "Gulabjhari BO": "822113",
      "Dinadag": "822113",
      "Khodi": "822113",
      "Goradih BO": "822120",
      "Kolhua Sonbarsa": "822120",
      "Baliari BO": "822122",
      "Kasmar BO": "822122",
      "Loharsi BO": "822122",
      "Karar": "822122",
      "Maran": "822122",
      "Lalgarha": "822113",
      "Sildag": "822113",
      "Imamnagar Barewa": "822115",
      "Kulahia": "822131",
      "Semarwar": "822131",
      "Barahi BO": "822116",
      "Dangwar BO": "822116",
      "DaruaBeni BO": "822116",
      "Joga jamdiha BO": "822116",
      "Jhargara BO": "822116",
      "Latheya BO": "822116",
      "Badepur": "822116",
      "Bairaon": "822116",
      "jamua": "822116",
      "Champi BO": "822118",
      "Dhangaon BO": "822118",
      "Phulang BO": "822118",
      "Sildiliya BO": "822118",
      "Thakuraidabra BO": "822118",
      "Arka": "822118",
      "Nuru": "822122",
      "Panki West": "822122",
      "Sunri": "822122",
      "Baidakala BO": "822123",
      "Kishunpur BO": "822123",
      "Manatu BO": "822123",
      "Murma": "822123",
      "Pachkeria": "822123",
      "Sataua": "822123",
      "Utaki": "822123",
      "Mahugawan BO": "822110",
      "Nawadih S BO": "822110",
      "Semra BO": "822110",
      "Taleya Babhadih BO": "822110",
      "Kankari": "822110",
      "Rampur": "822110",
      "Uldanda": "822110",
      "Ambabar BO": "822122",
      "Konwai BO": "822122",
      "Hurlaung": "822122",
      "Kelwa": "822122",
      "Ratanpur": "822122",
      "Kankekala BO": "822123",
      "Lami Patra BO": "822123",
      "Nawa Jaipur BO": "822123",
      "Padma BO": "822123",
      "Chhechhauri": "822123",
      "Janghasi": "822123",
      "Kajri": "822123",
      "Mahulia": "822123",
      "Semri": "822123",
      "Katual BO": "822110",
      "Narsingh Pur BO": "822110",
      "Salatua BO": "822110",
      "Shahpur BO": "822110",
      "Jhariwa": "822110",
      "Khura Kalan": "822110",
      "Rabda": "822110",
      "Daltonganj HO": "822101",
      "Daltonganj Bazar SO": "822101",
      "Harihar Ganj SO Palamau": "822131",
      "Satbarwa SO": "822126",
      "Belwatikar Nd SO": "822101",
      "Daltonganj Kutchary SO": "822101",
      "Japla C F SO": "822117",
      "Patan SO Palamau": "822123",
      "Daltonganj College SO": "822102",
      "Haidar Nagar SO": "822115",
      "Hamidganj SO": "822101",
      "Japla SO": "822116",
      "Raj Chainpur SO": "822110",
      "Rehala SO": "822124",
      "Bishrampur SO Palamau": "822132",
      "Chhatarpur SO": "822113",
      "Lesliganj SO": "822118",
      "Mohammad Ganj SO": "822120",
      "Panki SO Palamau": "822122"
    },
    "HAZARIBAGH": {
      "MALKOLA BO": "825405",
      "DAPOK BO": "825405",
      "Sankul BOc": "825411",
      "Kolhaukala BO": "825413",
      "Selhara BO": "825406",
      "Hearanganj BO": "825302",
      "Banahappa BO": "825313",
      "Bedam BO": "825313",
      "Harlipeto BO": "825313",
      "Khambhwa BO": "825313",
      "Dharampur BO": "825313",
      "Dharbanga BO": "825313",
      "Dumraon BO": "825402",
      "Kariatpur BO": "825402",
      "Punai BO": "825402",
      "Ratanpur BO": "825402",
      "Barkakala BO": "825402",
      "Darha BO": "825402",
      "Karimati BO": "825402",
      "Rolla BO": "825303",
      "Sitagarha BO": "825303",
      "Gurhet BO": "825303",
      "Jihu BO": "825411",
      "Kutipisi BO": "825411",
      "Bihari BO": "825411",
      "Romi BO": "825319",
      "Katkamsandi BO": "825319",
      "Lupung BO": "825319",
      "Sultana BO": "825319",
      "Kanchanpur BO": "825319",
      "Pandeybara BO": "825406",
      "Barhmoria BO": "825406",
      "Chourdaha BO": "825406",
      "Kadgawankala BO": "825406",
      "Morangi BO": "825302",
      "Rewali BO": "825302",
      "Bhelwara BO": "825312",
      "Singhrawan BO": "825406",
      "Belahi BO": "825406",
      "Kadma BO": "825302",
      "Lilanagar BO": "825302",
      "Gadokhar BO": "825302",
      "Tatijharia BO": "825313",
      "Dumar BO": "825313",
      "Dadighaghar BO": "825411",
      "Dantokhurd BO": "825411",
      "Bahimar BO": "825319",
      "Danr BO": "825319",
      "Partanga BO": "825313",
      "Bhusai BO": "825402",
      "Sindur BO": "825402",
      "Parsatari BO": "825409",
      "Jagdishpur BO": "825406",
      "Saraiya BO": "825411",
      "Surajpura BO": "825411",
      "Achaljamo BO": "825322",
      "Pabra BO": "825319",
      "Bargada BO": "825319",
      "Deochanda BO": "825405",
      "Rasoiyadhamna BO": "825405",
      "Dulmaha  BO": "825405",
      "karso BO": "825405",
      "Badam BO": "825311",
      "Harli BO": "825311",
      "Keredari BO": "825311",
      "Pandu BO": "825311",
      "Gondalpur BO": "825311",
      "Urimari BO": "825311",
      "Ango BO": "825311",
      "Talswar BO": "825311",
      "Barwan BO": "825323",
      "Berokala BO": "825323",
      "Manaiya BO": "825323",
      "Devo BO": "825323",
      "Tuiyo BO": "825323",
      "Jarwa BO": "825336",
      "Nagarbarsot BO": "825405",
      "khodahar BO": "825405",
      "Garikala BO": "825311",
      "Gossaibalia BO": "825311",
      "Chandaul BO": "825311",
      "Barkangango BO": "825323",
      "khaira BO": "825323",
      "Bhandro BO": "825323",
      "Uchaghana BO": "825312",
      "Jobar BO": "825312",
      "Kharna BO": "825312",
      "Nagi BO": "825312",
      "Sarukhudar BO": "825312",
      "Jagarnath Dham BO": "825317",
      "Silwarkalan BO": "825317",
      "Bela BO": "825406",
      "Brindawan BO": "825406",
      "Rampur BO": "825406",
      "Babhanbay BO": "825302",
      "Jordag BO": "825302",
      "Nagrichurchu BO": "825302",
      "Nawada BO": "825312",
      "Salgawan BO": "825302",
      "Jharpo BO": "825313",
      "Maheshra BO": "825313",
      "Bharajo BO": "825313",
      "Bariath BO": "825402",
      "Deokuli BO": "825402",
      "Tilra BO": "825402",
      "Merkurikhured BO": "825402",
      "Chandwar BO": "825303",
      "Oria BO": "825303",
      "Pelawal BO": "825319",
      "Sahpur BO": "825319",
      "Kusumbha BO": "825319",
      "Gouriakarma BO": "825405",
      "Jhurjhuri BO": "825405",
      "Chepakala BO": "825311",
      "Garsulla BO": "825311",
      "Mahungaikala BO": "825311",
      "Sirma BO": "825311",
      "Potanga BO": "825311",
      "Chuglamo BO": "825323",
      "Gangpacho BO": "825323",
      "Kalhabad BO": "825323",
      "Kapka BO": "825323",
      "Banaso BO": "825312",
      "Basaria BO": "825406",
      "Dadpur BO": "825406",
      "Kewal BO": "825405",
      "Padaria BO": "825405",
      "konra BO": "825405",
      "Ranichuhan BO": "825405",
      "Ambajit BO": "825311",
      "Hewai BO": "825311",
      "Kandaber BO": "825311",
      "Sanrh BO": "825311",
      "Sikri BO": "825311",
      "Belkapi BO": "825323",
      "Chechkapi BO": "825323",
      "Shiladih BO": "825323",
      "KURCHUNO B.O.": "825323",
      "Govindpur Kala BO": "825312",
      "Hendegarha BO": "825336",
      "Lohandi BO": "825406",
      "Narchahi BO": "825406",
      "Hindgir BO": "829209",
      "Hazaribagh HO": "825301",
      "Bara Bazar SO Hazaribag": "825301",
      "Bishungarh SO Hazaribag": "825312",
      "Boddam Bazar SO": "825301",
      "Chouparan SO": "825406",
      "Daroo SO": "825313",
      "Konardam SO": "825315",
      "Barkatha SO": "825323",
      "College More SO": "825302",
      "Distt Board SO": "825301",
      "Ichak SO": "825402",
      "Barkagaon SO": "825311",
      "Charhi SO": "825336",
      "Padma SO": "825411",
      "Reformatory School SO": "825319",
      "Barhi SO Hazaribag": "825405",
      "BSF Meru SO": "825317",
      "Korrah SO": "825303",
      "Pethiatand SO": "825301"
    },
    "GARHWA": {
      "Chandani BO": "822112",
      "Batto BO": "822129",
      "Lohargara BO": "822129",
      "Arangi BO": "822112",
      "Bongasi BO": "822114",
      "Karuakala BO": "822114",
      "Gonda BO": "822133",
      "Mandra BO": "822120",
      "Kushdand BO": "822121",
      "Tharakiya BO": "822121",
      "Kailan BO": "822129",
      "Azadnagar BO": "822129",
      "Rapura BO": "822129",
      "Bisunpur BO": "822114",
      "GN Mahila College BO": "822114",
      "Pratappur BO": "822114",
      "Tahle BO": "822114",
      "Sohbaria BO": "822133",
      "Baherwa BO": "822120",
      "Gurhakala BO": "822124",
      "Jaharsarai BO": "822134",
      "Rampur BO": "822134",
      "Sakhuikala BO": "822129",
      "Rejo BO": "822133",
      "Bhandar BO": "822121",
      "Khala BO": "822121",
      "Kumbakhurd BO": "822121",
      "Sukhbana BO": "822125",
      "Barwadih BO": "822125",
      "Bijka BO": "822125",
      "Kawaldag BO": "822129",
      "Jhura BO": "822114",
      "Kitasoti BO": "822114",
      "Karkoma BO": "822133",
      "Bhajaniya BO": "822120",
      "Dumarsota BO": "822120",
      "Koljhinki BO": "822121",
      "Pipardih BO": "822121",
      "Kharaundhi BO": "822112",
      "Parsodih BO": "822112",
      "Partikushwani BO": "822112",
      "Raji BO": "822112",
      "Kupa B.O": "822112",
      "Amrora BO": "822112",
      "Ketar BO": "822112",
      "Kariwadih BO": "822112",
      "Mukundpur B.O": "822112",
      "Pandariya B.O": "822112",
      "Sinduria B.O": "822112",
      "Chapri BO": "822112",
      "Makri BO": "822112",
      "Pipra BO": "822112",
      "Baligarh B.O": "822112",
      "Sisri B.O": "822112",
      "Arsalli South B.O": "822112",
      "Arsali BO": "822112",
      "Jhagra Khand BO": "822112",
      "Pachadumar BO": "822112",
      "Torelawa BO": "822112",
      "Basani B.O": "822112",
      "Danda BO": "822124",
      "Bardiha BO": "822134",
      "Karamdih": "822134",
      "Manpur": "822125",
      "Sondag": "822125",
      "Belchampa BO": "822124",
      "Bhikhahi BO": "822124",
      "Raksi": "822125",
      "Karuie BO": "822134",
      "Dwandkara BO": "822134",
      "Jatro Banjari": "822134",
      "Ataula BO": "822134",
      "Harigawan BO": "822134",
      "Salga": "822134",
      "Tehri": "822125",
      "Sangrahekala BO": "822124",
      "Kharsota": "822134",
      "Sukhandi": "822134",
      "Chutiya": "822134",
      "Talasbaria": "822134",
      "Karke": "822133",
      "Padua": "822133",
      "Khoridih": "822133",
      "Sangbaria": "822133",
      "Kandi BO": "822120",
      "Kushha BO": "822120",
      "Lamarikala BO": "822120",
      "Sonaura BO": "822120",
      "Jamui BO": "822121",
      "Mahdeiya BO": "822121",
      "Baligarh BO": "822125",
      "Barwadih": "822125",
      "Bulka": "822125",
      "Khardiha": "822125",
      "Madgari (Chapia)": "822125",
      "Dumariya BO": "822114",
      "Hoor BO": "822114",
      "Tildag BO": "822114",
      "Obra": "822114",
      "Hasandag BO": "822133",
      "Dandai BO": "822133",
      "Meral East": "822133",
      "Tenar": "822133",
      "Tisartetuka": "822133",
      "Belhath BO": "822120",
      "Hariharpur BO": "822120",
      "Chataniya": "822120",
      "Ranadih": "822120",
      "Birbal BO": "822121",
      "Adar BO": "822114",
      "Chinia BO": "822114",
      "Ranka bauliya BO": "822114",
      "Soh BO": "822114",
      "Chiraunjia": "822114",
      "Dubey Marhatiya": "822114",
      "Pipra": "822114",
      "Ursugi": "822114",
      "Belhara BO": "822114",
      "Kalyanpur BO": "822114",
      "Ranicheri BO": "822114",
      "Ranpura BO": "822114",
      "Chhattarpur": "822114",
      "Jata": "822114",
      "Pharathiya": "822114",
      "Ranka": "822114",
      "Sundipur BO": "822115",
      "Jarhi BO": "822133",
      "Deogana BO": "822133",
      "Banka BO": "822133",
      "Raro BO": "822133",
      "Balekhar BO": "822133",
      "Bahiyarkala": "822133",
      "Biktam": "822133",
      "Manjhiaon BO": "822120",
      "Morway BO": "822120",
      "Adhaura BO": "822121",
      "Amba Khorya  BO": "822121",
      "Bhojpur BO": "822121",
      "Chitbishram BO": "822121",
      "Garbandh": "822121",
      "Jangipur": "822121",
      "Ganiarikala BO": "822128",
      "Kocheya BO": "822128",
      "Marwania BO": "822128",
      "Silidag BO": "822128",
      "Sonehara BO": "822128",
      "Tandwa BO": "822128",
      "Tatidiri BO": "822128",
      "Kanjia BO": "822125",
      "Karso BO": "822125",
      "Khajutia Barwadih BO": "822125",
      "Nawa Bhandaria BO": "822125",
      "Tamge Kala BO": "822125",
      "Dudhwal": "822125",
      "Bahahara": "822125",
      "Phakiradih": "822125",
      "Harhe": "822125",
      "Anraj Nawadih BO": "822114",
      "Doll BO": "822114",
      "Nawada BO": "822114",
      "Okhargara BO": "822114",
      "Peska BO": "822114",
      "Achla": "822114",
      "Chama": "822114",
      "Jhotar": "822114",
      "Mahuliya": "822114",
      "Parihara": "822114",
      "Bana BO": "822133",
      "Latdag BO": "822133",
      "Lawahikalan": "822133",
      "Ohargara West": "822133",
      "Tasrar": "822133",
      "Jainagra BO": "822120",
      "Shivpur BO": "822120",
      "Halwanta Kala BO": "822121",
      "Katharkala BO": "822121",
      "Ahirpurwa": "822121",
      "Hetarkala": "822121",
      "Bulka BO": "822128",
      "Gamharia BO": "822128",
      "Pipri Kala BO": "822128",
      "Bisunpura": "822128",
      "Sarang": "822128",
      "Bairiya BO": "822125",
      "Bargarh BO": "822125",
      "Ramkanda BO": "822125",
      "SEWADIH BO": "822125",
      "Beta": "822125",
      "Janewa": "822125",
      "Katra": "822125",
      "Madgari (Kanjea)": "822125",
      "Dhurki BO": "822121",
      "Bilaspur": "822121",
      "Checharia": "822121",
      "Bhagodih BO": "822128",
      "Rohila BO": "822128",
      "Bahiyarkhurd": "822128",
      "HardagKalan": "822128",
      "Patihari": "822128",
      "Bandu BO": "822125",
      "Godarmana BO": "822125",
      "Paraswar BO": "822125",
      "Sribishrampur BO": "822125",
      "Udaipur BO": "822125",
      "Chete": "822125",
      "Kachanpur": "822125",
      "Khapro": "822125",
      "Bhawnathpur TownShip SO": "822129",
      "Nagar Utari SO": "822121",
      "Ramna SO Garhwa": "822128",
      "Ranka Raj SO": "822125",
      "Manjhiaon SO": "822134",
      "Bhawnathpur SO": "822112",
      "Garhwa SO": "822114",
      "Meral SO": "822133"
    },
    "JAMTARA": {
      "Gokula BO": "815352",
      "Kurta BO": "815352",
      "Mohanpur BO": "815352",
      "Ranitanr BO": "815352",
      "Pathrodih BO": "815352",
      "Sabanpur BO": "815352",
      "Sinduri BO": "815352",
      "Afzalpur BO": "815355",
      "Baragholjore BO": "815355",
      "Sitamurhi BO": "815355",
      "Tesjuria BO": "815355",
      "Babupur BO": "815359",
      "Charakmara BO": "815359",
      "Satki BO": "815359",
      "Sudrakshipur BO": "815359",
      "Kewatjali BO": "815354",
      "Krishnapur BO": "815355",
      "Kuldangal BO": "815355",
      "Saraskunda BO": "815355",
      "Kalajhariya BO": "815352",
      "Kurwa BO": "815352",
      "Narayanpur BO": "815352",
      "Sitalpur BO": "815352",
      "Amba BO": "815359",
      "Bagdehri BO": "815359",
      "Tilabad BO": "815359",
      "Sahardal BO": "815354",
      "Tarrah BO": "815354",
      "Karaiya BO": "815355",
      "Manihari BO": "815355",
      "Khajuree BO": "815359",
      "Laykapur BO": "815359",
      "Nagri BO": "815359",
      "Palajuri BO": "815359",
      "Chandra Dhipa BO": "815354",
      "Kelahi BO": "815354",
      "Debjore BO": "815355",
      "Kalipahari BO": "815355",
      "Sagjoria BO": "815355",
      "Bena BO": "815351",
      "Bindapathar BO": "815351",
      "Dhandra BO": "815351",
      "Gundali Pahari BO": "815351",
      "Kanki BO": "815351",
      "Mejhia BO": "815351",
      "Sonbad BO": "815351",
      "Tarni BO": "815351",
      "Amdiha BO": "815352",
      "Geria BO": "815351",
      "Guhiyazori BO": "815351",
      "Mohana Bank BO": "815351",
      "Noni BO": "815351",
      "Pabia BO": "815351",
      "Panjania BO": "815351",
      "Chainpur BO": "815352",
      "D Nayadih BO": "815352",
      "Asanchua BO": "815351",
      "Bagdaha BO": "815351",
      "Bewa BO": "815351",
      "Dakhin Bahal BO": "815351",
      "Harirakha BO": "815351",
      "Kasitar BO": "815351",
      "Pattajori Kajra BO": "815351",
      "Tilaki BO": "815351",
      "Bagrudih BO": "815352",
      "Amjora Koiridih BO": "815352",
      "Chalna Dhobna BO": "815351",
      "Chapuria BO": "815351",
      "Chirudih Bakudih BO": "815351",
      "Chitra BO": "815351",
      "Koiri Jamua BO": "815351",
      "Ladhna BO": "815351",
      "Manghladih BO": "815351",
      "Dewalbari BO": "815352",
      "Babanbandhi BO": "814166",
      "Dhasania BO": "814166",
      "JKhairbani BO": "814166",
      "Jamjori BO": "814166",
      "Kairabani BO": "814166",
      "TKGram BO": "814166",
      "Jamtara Court SO": "815351",
      "Mihijam SO": "815354",
      "Jamtara SO": "815351",
      "Karmatar SO": "815352",
      "Kundahit SO": "815359",
      "Nala SO": "815355",
      "Fatehpur SO Jamtara": "814166"
    },
    "GODDA": {
      "Bapugram BO": "814165",
      "Bharta Chak BO": "814154",
      "Dighi BO": "814154",
      "Ghoothi BO": "814154",
      "Kasba BO": "814154",
      "Doi BO": "814160",
      "Gorikitta BO": "814160",
      "Bandanbar BO": "814147",
      "Burhi Kura BO": "814153",
      "Chatra BO": "814153",
      "Dama BO": "814153",
      "China Dhab BO": "814156",
      "Kurmichak BO": "814156",
      "Nunbatta BO": "814156",
      "Lohandia Bazar BO": "814165",
      "Sarbhanga BO": "814165",
      "Bhanjpur BO": "814154",
      "Dharmodih BO": "814154",
      "Hanwara BO": "814154",
      "Koila BO": "814154",
      "Kushmara BO": "814154",
      "Naraini BO": "814154",
      "Adamdour BO": "814160",
      "Bajitpur BO": "814160",
      "Dariapur BO": "814160",
      "Dighisiwanpur BO": "814160",
      "Bhadharia BO": "814147",
      "Kero Bazar BO": "814147",
      "Tardiha BO": "814147",
      "Agiyamore BO": "814153",
      "Baghmara BO": "814153",
      "Ghanghrabandh BO": "814153",
      "Kairadih BO": "814153",
      "P Barmasiya BO": "814153",
      "Salaiya BO": "814153",
      "Bans Jori BO": "814156",
      "Ghatiyari BO": "814156",
      "Kamaldouri BO": "814165",
      "Madhurai BO": "814165",
      "Anjana BO": "814154",
      "Mal Bhandaridih BO": "814154",
      "Naya Nagar BO": "814154",
      "Amour BO": "814160",
      "Belbadda BO": "814160",
      "Dewanchak BO": "814160",
      "Marpa BO": "814160",
      "Barmasiya BO": "814147",
      "Ghat Kuruwa BO": "814147",
      "Pipra BO": "814147",
      "Raja Bhitaa BO": "814147",
      "Asarimadhuri BO": "814153",
      "Danrey Katchery BO": "814153",
      "Deodawr BO": "814153",
      "Hariyari BO": "814153",
      "Padampur BO": "814153",
      "Pasai BO": "814153",
      "Raghunathpur Lathibari BO": "814153",
      "Chandanahat BO": "814156",
      "Sundmara BO": "814156",
      "Barasimra BO": "814165",
      "Gajanda BO": "814165",
      "Gorhia BO": "814165",
      "Kushmil BO": "814154",
      "Logain BO": "814154",
      "Mohanpur BO": "814133",
      "Nunajore BO": "814154",
      "Kasbadudhanichak BO": "814160",
      "Lakarmara BO": "814160",
      "Pratappur BO": "814160",
      "Surni BO": "814160",
      "Tularambhuska BO": "814160",
      "Kerwarbelsar BO": "814147",
      "Khariani BO": "814147",
      "Kusumghati BO": "814147",
      "Lahati BO": "814147",
      "Parspani BO": "814147",
      "Damruhat BO": "814153",
      "Kathaun BO": "814153",
      "Latta BO": "814153",
      "Mohani BO": "814153",
      "Nawdiha BO": "814153",
      "Pindra Hat BO": "814153",
      "Paharpur BO": "814156",
      "Sunder Pahari BO": "814156",
      "Itahari BO": "813206",
      "Sukhari BO": "813206",
      "Amlo BO": "814133",
      "Fasia BO": "814133",
      "Gandhigram BO": "814133",
      "Ghatkusmani BO": "814133",
      "Gumma BO": "814133",
      "Lohbandha BO": "814133",
      "Maheshpur BO": "814133",
      "Motia BO": "814133",
      "Nepura BO": "814133",
      "Dubrajpur BO": "814133",
      "Gangtaklan BO": "814133",
      "Godda College BO": "814133",
      "Haripur Gorbana BO": "814133",
      "Kouribahiar BO": "814133",
      "Latauna BO": "814133",
      "Lukluki BO": "814133",
      "Pathra BO": "814133",
      "Chapri BO": "813208",
      "Deobandha BO": "814133",
      "Ghatdumariya BO": "814133",
      "Makhni BO": "814133",
      "Malini BO": "814133",
      "Malrampur BO": "814133",
      "Motiya Dumariya BO": "814133",
      "Saidapur BO": "814133",
      "Sarba BO": "814133",
      "Simarda BO": "814133",
      "Ramla Dikwani BO": "814133",
      "Baksara BO": "814133",
      "Basantpur BO": "814133",
      "Hilaway BO": "814133",
      "Jaminipaharpur BO": "814133",
      "Khatnai BO": "814133",
      "Korkaghat BO": "814133",
      "Barain BO": "825322",
      "Biswaskhani BO": "814155",
      "Kadma BO": "814155",
      "Mokalchak BO": "814155",
      "Laxmipur Bhojichak BO": "814155",
      "Maheshtikri BO": "814155",
      "Maliachak BO": "814155",
      "Rupni BO": "814155",
      "Sahapur Beldiha BO": "814155",
      "Samri BO": "814155",
      "Sanour BO": "814155",
      "K Parsa BO": "814155",
      "Kaitha BO": "814155",
      "Parariya BO": "814155",
      "Azampakariya BO": "814155",
      "Bisambharchak BO": "814155",
      "Parua BO": "814155",
      "Maniarkajral BO": "813208",
      "Bahdurchak BO": "813208",
      "Bhagmara BO": "813208",
      "Chanda BO": "813208",
      "Sripurbazar BO": "813208",
      "Thakurgangti BO": "813208",
      "Bhagaiwa BO": "813208",
      "Rangachak BO": "813208",
      "Dhamni BO": "816102",
      "Beniadih BO": "813208",
      "Boarijore BO": "813208",
      "Mordiha BO": "813208",
      "Godda SO": "814133",
      "Pathergama SO": "814147",
      "Poraiyahat SO": "814153",
      "Mahgama SO": "814154",
      "Sarouni Bazar SO": "814156",
      "Basantrai SO": "814155",
      "Lalmatia Colliery SO": "814165",
      "Meharma SO": "814160"
    },
    "DEOGHAR": {
      "Madankatha BO": "815357",
      "Siktiya BO": "815357",
      "Chanddih BO": "814143",
      "Tapoban BO": "814143",
      "Bamangama BO": "815353",
      "Bara Chapra BO": "815353",
      "Barawan BO": "815353",
      "Dhamni BO": "815353",
      "Haripur Kolwa BO": "815353",
      "Jagdishpur BO": "815353",
      "Karanjo BO": "815353",
      "Koiridih BO": "814152",
      "Baratanr BO": "815357",
      "Baskupi BO": "815357",
      "AK Bad BO": "814143",
      "Baramsoli BO": "815357",
      "Kukraha BO": "815357",
      "Ranidih BO": "815357",
      "Bagjora BO": "815353",
      "Burhai BO": "815353",
      "Margomunda BO": "815353",
      "Upper Bahiyar BO": "815353",
      "Daluraidih BO": "814152",
      "Ghorlas BO": "814152",
      "Ramudih BO": "814152",
      "Bamandiha BO": "814149",
      "Choudri Nawadih BO": "814149",
      "Phulchuan BO": "814149",
      "Pahariya BO": "814150",
      "Purjori BO": "814150",
      "Baijukura BO": "814143",
      "Charpa BO": "815353",
      "Ojhadih BO": "815353",
      "Sirsa BO": "815353",
      "Debipur BO": "814152",
      "K Banskola BO": "814152",
      "Punasi BO": "814152",
      "Charak Mara BO": "814149",
      "Sabaijore BO": "814149",
      "Paharidih BO": "814150",
      "Paway BO": "814150",
      "Maniyarpur BO": "814152",
      "Dumaria BO": "814149",
      "Hussainabad BO": "815353",
      "Kasathi BO": "815353",
      "Kushmaha BO": "815353",
      "Patharda BO": "815353",
      "Pathrol BO": "815353",
      "Ramchandrapur BO": "815353",
      "Saptar BO": "815353",
      "Baghmari BO": "814152",
      "Barkikharkhar BO": "814152",
      "Bhojpur BO": "814152",
      "Gopibandh BO": "814149",
      "Jhagrahi BO": "814149",
      "Lakhoria BO": "814150",
      "Madhuban BO": "814150",
      "Manigarhi BO": "814150",
      "Nanhidih BO": "814150",
      "Rakti BO": "814150",
      "Sonaraithari BO": "814150",
      "Tilakpur BO": "814150",
      "M Bsnsbutla BO": "814150",
      "Sakrigali BO": "814114",
      "Rarhiya BO": "814113",
      "Rikhiya BO": "814113",
      "T Balasi BO": "814113",
      "Vidyapith BO": "814113",
      "Jhallar BO": "814120",
      "Kenmankathi BO": "814142",
      "Madhopur BO": "814142",
      "Malhara BO": "814157",
      "Kusmaha BO": "814113",
      "Gurukul Vidyapith BO": "814114",
      "Mathurapur BO": "814114",
      "Dabar Gram BO": "814142",
      "Bichgarha Kusumdih BO": "814113",
      "Maladih BO": "814114",
      "Morney BO": "814120",
      "Banka BO": "814142",
      "Deopur BO": "814142",
      "Sangrampur Lorhiya BO": "814114",
      "Simra BO": "814114",
      "T Basdiha BO": "814120",
      "Jhillighat BO": "814157",
      "Chulhiya BO": "814157",
      "Jamunia BO": "814157",
      "Kharagdiha BO": "814157",
      "Ajnaridudhani BO": "814146",
      "Jamua BO": "814146",
      "Karrasal BO": "814146",
      "Sagarbanga BO": "814146",
      "Sarsa BO": "814146",
      "Talghara BO": "814146",
      "Baijnathpur BO": "814146",
      "Asna BO": "814146",
      "Bansbutia BO": "814146",
      "Dubrajpur BO": "814146",
      "Garsara BO": "814146",
      "Kunjora BO": "814146",
      "Basaha BO": "814146",
      "Birajpur BO": "814146",
      "Chaglajore BO": "814146",
      "BDeoghar HO": "814112",
      "Deoghar College SO": "814113",
      "Jasidih SO": "814142",
      "Dehijore SO": "814157",
      "Ghormara SO": "814120",
      "Hindipith SO": "814115",
      "Jhaunsagarhi SO": "814112",
      "Madhupur SO": "815353",
      "Sarath SO": "814149",
      "Satsang SO": "814116",
      "B MANDIR SO": "814112",
      "Deosang BT SO": "814114",
      "Rohani SO": "814152",
      "Sarwan SO": "814150",
      "Palojori SO": "814146",
      "Deoghar Court SO": "814112",
      "Karogram SO": "815357",
      "Kunda SO Deoghar": "814143",
      "Madhupur Bazar SO": "815353"
    },
    "LATEHAR": {
      "Mandal BO": "822111",
      "Ganeshpur BO": "829202",
      "Holong BO": "829202",
      "Murupa BO": "829202",
      "Phulsu BO": "829202",
      "Seregara BO": "829202",
      "Serendag BO": "829202",
      "Dahunawada BO": "829202",
      "Betla National Park BO": "822111",
      "Chhencha BO": "822111",
      "Huttar Coliewary BO": "822111",
      "Mayapur BO": "822111",
      "Aan BO": "829203",
      "Bari BO": "829203",
      "Banhardi B.O": "829203",
      "Balubhang BO": "829202",
      "Chedra BO": "829202",
      "Chiru BO": "829202",
      "Ichak BO": "829202",
      "Salaiya B.O": "829202",
      "Salve B.O": "829202",
      "Tasu B.O": "829202",
      "Toti B.O": "829202",
      "Hutap BO": "829203",
      "Kamta BO": "829203",
      "Malhan BO": "829203",
      "Besra BO": "829202",
      "Herhanj BO": "829202",
      "Jhabar BO": "829202",
      "Basiya B.O": "829202",
      "Chetag  B.O": "829202",
      "Rajwar B.O": "829202",
      "Saraidih Pokhari BO": "822111",
      "Darha BO": "829202",
      "Garhgoma BO": "829202",
      "Marang Loiya BO": "829202",
      "Sibla BO": "829202",
      "Amarwadih B.O": "829202",
      "Bhagya B.O": "829202",
      "Latu B.O": "829202",
      "Morwaikala BO": "822111",
      "Barikhap BO": "822112",
      "Bhaisadon BO": "829203",
      "Sasang BO": "829203",
      "Alaudia B.O": "829203",
      "Chakla BO": "829203",
      "Damodar BO": "829203",
      "Roll BO": "829203",
      "Serak BO": "829203",
      "Manika BO": "822126",
      "Matlong BO": "822126",
      "Ranki Kala BO": "822126",
      "Jamho": "822126",
      "Barwaiya BO": "822126",
      "Palheya BO": "822126",
      "Bishunbandh": "822126",
      "Sinjo": "822126",
      "Donki": "822126",
      "Namudag": "822126",
      "Bandua": "822126",
      "Dundu": "822126",
      "Durup BO": "822119",
      "Hami BO": "822119",
      "Rajdanda BO": "822119",
      "Auxi BO": "822119",
      "Lat BO": "829204",
      "Mundu BO": "829204",
      "Barkadih B.O": "829204",
      "Kuchila B.O": "829204",
      "Ukamar B.O": "829204",
      "Labarpur BO": "829207",
      "Ledhpa BO": "829207",
      "Makka BO": "829207",
      "Nawagarh BO": "829207",
      "Parsahi B.O": "829207",
      "Sishi B.O": "829207",
      "Tarwadih B.O": "829207",
      "Chatakpur BO": "822119",
      "Parhatoli B.O": "822119",
      "Champa B.O": "822119",
      "Jamira B.O": "829203",
      "Kerh BO": "829204",
      "Kumandih BO": "829204",
      "Rud B.O": "829204",
      "Balu BO": "829206",
      "Temki BO": "829206",
      "Demu BO": "829207",
      "Richughuta BO": "829207",
      "Dhankara B.O": "829207",
      "Arahans BO": "822119",
      "Dadhu B.O": "829203",
      "Karwai BO": "829204",
      "Kottam BO": "829204",
      "Ladhup B.O": "829203",
      "Bariyatu Jagir BO": "829206",
      "Jalim BO": "829206",
      "Mongor BO": "829206",
      "Pandeypura BO": "829206",
      "Sarju BO": "829207",
      "Ganeshpur B.O": "829207",
      "Barahi BO": "822119",
      "Chainpur B.O": "822119",
      "Barwatoli B.O": "829203",
      "Boda B.O": "829203",
      "Chetar B.O": "829203",
      "Baresandh BO": "829204",
      "Chungru BO": "829204",
      "Garu BO": "829204",
      "Hethpochra BO": "829206",
      "Kaima BO": "829206",
      "Kura BO": "829206",
      "Murup BO": "829206",
      "Udaipura BO": "829206",
      "Dihi B.O": "829206",
      "Nawari B.O": "829206",
      "Sasang B.O": "829206",
      "Orsa BO": "822119",
      "Rengai B.O": "822119",
      "Nindra BO": "829208",
      "Landupsenha BO": "835213",
      "Balumath SO": "829202",
      "Latehar Hsgii SO": "829206",
      "Chandwa SO": "829203",
      "Latehar Rsso SO": "829207",
      "Mahuwadand SO": "822119",
      "Netarhat SO": "835218",
      "Chhipadohar SO": "829204",
      "Barwadih SO": "822111"
    },
    "DUMKA": {
      "Harokha Aswari BO": "814151",
      "M Chikaniya BO": "814151",
      "Nawadih BO": "814151",
      "Raoundhya BO": "814151",
      "Samaymatha BO": "814151",
      "Gadijhopa BO": "814151",
      "Jokela BO": "814151",
      "Kendua BO": "814151",
      "Chilra BO": "814151",
      "Dighi BO": "814151",
      "Barkundi BO": "814151",
      "Chandubathan BO": "814151",
      "Chihutia BO": "814151",
      "Dhamni BO": "814151",
      "Rangamission BO": "814111",
      "Hariharpur BO": "814120",
      "Karma BO": "814120",
      "Rajan Amar Kunda BO": "814120",
      "Kaladumaria BO": "814120",
      "Sahara BO": "814120",
      "Jardaha BO": "814120",
      "Dumariahat BO": "814120",
      "Gadibahirkunda BO": "814120",
      "Bargo BO": "814120",
      "Satpahari BO": "814120",
      "Simarjore BO": "814120",
      "Bahjrikunda BO": "814120",
      "Gundlidangal BO": "814146",
      "TDDumaria BO": "814146",
      "Pratappur BO": "816118",
      "Rangalia BO": "814148",
      "Bhaturia BO": "814102",
      "Chhoti Ranbahiyar BO": "814102",
      "Kairasol BO": "814102",
      "Kakni Pathria BO": "814102",
      "Asanbani BO": "816118",
      "RB Palasi BO": "816118",
      "Kendhghatta BO": "814110",
      "Kolharia BO": "814110",
      "Kusumghatta BO": "814110",
      "Upparbahal BO": "814110",
      "Baragamharia BO": "814146",
      "Garapathar BO": "814146",
      "Golbandha BO": "814146",
      "Jarwadi BO": "814146",
      "Nachangaria BO": "814146",
      "Pindari BO": "814146",
      "Tarajora BO": "814146",
      "Kumirdaha BO": "814148",
      "Patjore BO": "814148",
      "Bandarjora BO": "814102",
      "Gamharia BO": "814102",
      "Ghaghri BO": "814102",
      "Mahubana BO": "814102",
      "Sushni BO": "814102",
      "Barmasia BO": "816118",
      "Dhanbasa BO": "816118",
      "Saraidaha BO": "816118",
      "Asanjore BO": "814110",
      "Goari BO": "814110",
      "Jama BO": "814110",
      "Lattabar BO": "814110",
      "Maharo BO": "814110",
      "Pargodih BO": "814146",
      "Jai Haripur BO": "814148",
      "Pathra BO": "814148",
      "Ranigram BO": "814148",
      "Amarapahari BO": "814102",
      "Danro BO": "814102",
      "Piprakarudih BO": "814102",
      "Sinduria BO": "814102",
      "Bara Banjhi BO": "814102",
      "Bankijore BO": "816118",
      "Dhaka BO": "816118",
      "PP Kadma BO": "816118",
      "Simaljore BO": "816118",
      "Amlachatar BO": "814110",
      "Dudhani BO": "814141",
      "Goasol BO": "814110",
      "Lilatari BO": "814110",
      "Majhiandih BO": "814110",
      "Puranadumka BO": "814110",
      "Teliachak BO": "814110",
      "Uppersitwa BO": "814110",
      "Bhirabpur BO": "814146",
      "Bhutokoria BO": "814146",
      "Chikania BO": "814146",
      "Khairabani BO": "814146",
      "Amjora BO": "814148",
      "Dumra BO": "814148",
      "Sukjora BO": "814148",
      "Tangdaha BO": "814148",
      "Bariranbahiyar BO": "814102",
      "Bhalsumar BO": "814102",
      "Khudimerkho BO": "814102",
      "Lakhanpur BO": "814102",
      "Kharu Kadma BO": "816118",
      "Kolhabadar BO": "816118",
      "Mohal Pahari BO": "816118",
      "Bando Haripur BO": "814110",
      "Barapalasi BO": "814110",
      "Chaila Pathar BO": "814110",
      "Nakrapahari BO": "814110",
      "Nischintpur BO": "814110",
      "Nonihatwari BO": "814110",
      "Sapchalla BO": "814110",
      "Shikarpur BO": "814110",
      "Siktia BO": "814118",
      "Singhni BO": "814118",
      "Pakiriya BO": "814158",
      "Rajbandh BO": "814158",
      "P Jaratikar BO": "814141",
      "Kalajhar BO": "814103",
      "Kolha BO": "814103",
      "Pusaldih BO": "814103",
      "Saldaha BO": "814103",
      "Sarsabad BO": "814103",
      "T Daldali BO": "814103",
      "Gandrakhpur BO": "814119",
      "Gugisimal BO": "814119",
      "K Baskichowk BO": "814119",
      "Kumrabad BO": "814119",
      "Pahrudih BO": "814119",
      "Banskuli BO": "814144",
      "Bilkandi BO": "814144",
      "Brindabani BO": "814144",
      "Ranibahal BO": "814144",
      "Bagjhopa BO": "814118",
      "Dhamnilata BO": "814118",
      "Catupara BO": "816103",
      "Tasaria BO": "814166",
      "K Madhuwadih BO": "814158",
      "Machkicha BO": "814158",
      "Siltha BO": "814158",
      "Simalduma BO": "814158",
      "Amba Jarowadih BO": "814141",
      "Raikinari BO": "814141",
      "B Narganj BO": "814103",
      "Dharampur BO": "814103",
      "Kadma BO": "814103",
      "Masania BO": "814103",
      "Gando BO": "814119",
      "Ghasipur BO": "814119",
      "Kathalia BO": "814119",
      "Makrampur BO": "814119",
      "Pattabari BO": "814119",
      "Ghormala Hunja BO": "814144",
      "Jaitara BO": "814144",
      "Manik Dih BO": "814144",
      "Sadipur BO": "814144",
      "Haripur BO": "814118",
      "Laximipur BO": "814118",
      "Kajladaha BO": "816103",
      "Maluti BO": "816103",
      "Manjhladih BO": "816103",
      "Pakdaha BO": "816103",
      "Sarasdangal BO": "816103",
      "K Bhoktadih BO": "814166",
      "Amra Nawadih BO": "814158",
      "Bhurkunda BO": "814158",
      "Chainpur Kairabani BO": "814158",
      "Beldaha BO": "814141",
      "Amgachi BO": "814103",
      "Astajora BO": "814103",
      "Asansol BO": "814119",
      "Bagnal BO": "814144",
      "Amarpur BO": "814145",
      "B Mahadeogarh BO": "814145",
      "Thakur Nahar BO": "814145",
      "Karipahari BO": "816117",
      "Karudih BO": "816117",
      "Dhanbai BO": "814145",
      "Kakania BO": "814145",
      "Petsar BO": "814145",
      "Baratanr BO": "814118",
      "Chamrabahiar BO": "814118",
      "Banspahari BO": "816103",
      "Daldali BO": "816103",
      "Pinargaria BO": "816103",
      "Gumro BO": "814166",
      "Dhogariya BO": "814158",
      "Karbindha BO": "814158",
      "Tharihat BO": "814158",
      "Banwara BO": "814141",
      "Bishanpur BO": "814141",
      "Bara Sarwapani BO": "814103",
      "Gopikandar BO": "814103",
      "Gamra BO": "814119",
      "Morbhanga BO": "814119",
      "Karikadar BO": "814144",
      "Bouria BO": "814145",
      "Bhadwari BO": "814145",
      "Kanjo BO": "814145",
      "Khutahari BO": "814145",
      "Khutan BO": "814145",
      "Kurumpahari BO": "814145",
      "Lakarbank BO": "814145",
      "Hasdiha BO": "814145",
      "Jamjori Birnia BO": "814145",
      "Patgora BO": "814145",
      "Sultanatikar BO": "814145",
      "Dumka HO": "814101",
      "Bandarjori SO": "814101",
      "Kurwa SO": "814119",
      "Shikaripara SO": "816118",
      "Shivpahar SO": "814110",
      "Benagaria SO": "816103",
      "Guhiajori SO": "814158",
      "Jarmundi SO": "814141",
      "Kathikund SO": "814103",
      "Massanjore SO": "814144",
      "Ranga Masalia SO": "814167",
      "SPCollege SO": "814101",
      "Saraiyahat SO": "814151",
      "Basukinathdham SO": "814118",
      "Dumka Court SO": "814101",
      "Nonihat SO": "814145",
      "Raghunathpur SO Dumka": "814148",
      "Ramgarah SO": "814102"
    },
    "PAKUR": {
      "Balidanga BO": "814111",
      "TFathepur BO": "814111",
      "Baskandri BO": "814111",
      "Salpatra BO": "814111",
      "Dumrchir BO": "814111",
      "Patharghatta BO": "814111",
      "Rajapurkolkipara BO": "814111",
      "Raj Daha BO": "816117",
      "Lagdum BO": "816117",
      "Moglabandh BO": "816117",
      "Paliadaha BO": "816117",
      "Phuljhijhri BO": "816117",
      "Baraghaghri BO": "816102",
      "Litipara BO": "816104",
      "Mohulbona BO": "816104",
      "Padarkola BO": "816104",
      "Surajbera BO": "816104",
      "Gaganpahari BO": "816105",
      "Kistonagar BO": "816105",
      "Askandha BO": "816106",
      "Barkiari BO": "816106",
      "Ganpura BO": "816103",
      "Bichmahal BO": "816104",
      "Dhoadanga BO": "816104",
      "Bathandanga BO": "816106",
      "Khanpur BO": "816106",
      "Rollagram BO": "816106",
      "Sahargram BO": "816106",
      "Simlongcolliery BO": "816102",
      "Birkitty BO": "816106",
      "Debinagar BO": "816106",
      "Dharamkhanpara BO": "816106",
      "Khagra BO": "816106",
      "M Raohipur BO": "816106",
      "Daldali BO": "816107",
      "Illami BO": "816107",
      "Kalidaspur BO": "816107",
      "Malpahari Koerisiding BO": "816107",
      "Manirampur BO": "816107",
      "Balidih BO": "816117",
      "Chengadanga BO": "816107",
      "Jhikarhati BO": "816107",
      "Mohanpur BO": "816107",
      "Nagarnabi BO": "816107",
      "Prithinagar BO": "816107",
      "Deopur BO": "816107",
      "Barasinghpur BO": "816117",
      "Bondiga BO": "816117",
      "Dangapara BO": "816104",
      "Dulmidanga BO": "816104",
      "Talpahari BO": "816104",
      "Makdampur BO": "816106",
      "Sagberia BO": "816106",
      "Tarapur BO": "816106",
      "Bhawnipur BO": "816107",
      "Sangrampur BO": "816107",
      "Sitapahari BO": "816107",
      "Sitishnager BO": "816107",
      "Torai BO": "816107",
      "Khagachua BO": "816117",
      "Khaksa BO": "816117",
      "Gandhaipur BO": "816107",
      "Narottempur BO": "816107",
      "Rashpur BO": "816107",
      "Bannabgram BO": "816117",
      "Chowkisal BO": "816117",
      "Maheshpur Raj SO": "816106",
      "Pakur SO": "816107",
      "Hiranpur SO": "816104",
      "Kotalpokhar SO": "816105",
      "Pakur RS SO": "816107",
      "Amrapara SO": "814111",
      "Pakuria SO": "816117"
    },
    "SAHEBGANJ": {
      "BKadma BO": "816102",
      "PKBazar BO": "816102",
      "Palasgachi BO": "816108",
      "Phudkipur BO": "816108",
      "Piyarpur BO": "816108",
      "Udhwa BO": "816108",
      "Balapokhar BO": "816109",
      "Sarkanda BO": "816129",
      "Bara Durgapur BO": "816116",
      "Kajigoun BO": "816108",
      "Narayanpur BO": "816108",
      "Barajirwabari BO": "816109",
      "Mangalhat English BO": "816129",
      "Brindaban BO": "816116",
      "BB Mangladih BO": "816110",
      "Bishanpur BO": "816110",
      "Lakhipur BO": "816110",
      "Mahasinghpur BO": "816108",
      "Narayanpur East Diara BO": "816108",
      "Baluagairah BO": "816109",
      "Bara Madansahi BO": "816109",
      "Hariprasad Diara BO": "816109",
      "Rampur BO": "816109",
      "Karanpura BO": "816129",
      "Banskola BO": "816110",
      "Bartalla BO": "816110",
      "Ghatiari BO": "816110",
      "Choukidhab BO": "816108",
      "Jamnager BO": "816108",
      "Banjhi BO": "816109",
      "Ganga Prasad Diara BO": "816109",
      "Hazipur Bari Kodarjana BO": "816109",
      "Mahadeo Ganj BO": "816109",
      "Maharajpur BO": "816109",
      "Jonka BO": "816116",
      "Kalyanchak BO": "816116",
      "Barmasia BO": "816102",
      "Aglio BO": "816101",
      "Ranigram BO": "816101",
      "Reshore BO": "816101",
      "Hatigarah BO": "816120",
      "Motipahari BO": "816120",
      "Telo BO": "816120",
      "Binodpur BO": "816105",
      "Jambad BO": "816105",
      "Mandro BO": "813208",
      "JKumarjori BO": "816102",
      "Phulbanga BO": "816102",
      "Baradighi BO": "816101",
      "Masna BO": "816101",
      "Chotabangama BO": "816120",
      "Mayur Kola BO": "816105",
      "Bhognadih BO": "816102",
      "Borbandh BO": "816102",
      "Kusmaha BO": "816102",
      "Atapur BO": "816101",
      "Ganeshpur BO": "816101",
      "Goalkhor BO": "816101",
      "Ishlampur BO": "816101",
      "Jampur BO": "816101",
      "Kankjol BO": "816101",
      "Radhanager BO": "816101",
      "Srikund BO": "816101",
      "Arjunpur BO": "816104",
      "Labri BO": "816102",
      "Rohra BO": "816102",
      "Talbaria BO": "816102",
      "Bakudih BO": "816101",
      "Begamganj BO": "816101",
      "Chandsaher BO": "816101",
      "Kathalbari BO": "816101",
      "Kelabari BO": "816101",
      "Palasbona BO": "816101",
      "Sridhardira BO": "816101",
      "Aprol BO": "816120",
      "Patharia BO": "816105",
      "Barhait SO": "816102",
      "Borio SO": "816120",
      "Kassim Bazar SO": "816108",
      "Pathna SO": "816110",
      "Sahibganj Court SO": "816109",
      "Sakrigali Ghat SO": "816115",
      "Taljhari SO": "816129",
      "Tinpahar RS SO": "816116",
      "Mirzachowki SO": "813208",
      "Rajmahal SO": "816108",
      "Sahibganj SO": "816109",
      "Barharwa SO Sahibganj": "816101",
      "Sahibganj College SO": "816109"
    },
    "KODERMA": {
      "Gurio BO": "825413",
      "Bagro BO": "825418",
      "Galwati BO": "825418",
      "Kheshmi BO": "825418",
      "Kubri BO": "825418",
      "Sharmatand BO": "825109",
      "Sudan BO": "825109",
      "Khargo BO": "825109",
      "Chandwara BO": "825409",
      "Karma BO": "825409",
      "Dhabtham BO": "825409",
      "Gajhandi BO": "825409",
      "Hirodih BO": "825409",
      "Deobour BO": "825410",
      "Makatpur BO": "825318",
      "Nawadih BO": "825318",
      "Nawagarh Chatti BO": "825318",
      "Padaria BO": "825318",
      "Marchoi BO": "825132",
      "Nandudih BO": "825132",
      "Pasnaur BO": "825132",
      "Madhopur BO": "825132",
      "Arkhango BO": "825418",
      "Taranakho BO": "825418",
      "Dagarnawa BO": "825418",
      "Sapahi BO": "825407",
      "Bangakhalar BO": "825407",
      "Sewatand BO": "825109",
      "KENDUA 2 B.O": "825109",
      "Inderwa BO": "825410",
      "Khalakthambi BO": "825410",
      "Chopnadih BO": "825318",
      "Jamu BO": "825318",
      "Masmohna BO": "825418",
      "Nawalshahi BO": "825418",
      "Baheradih BO": "825407",
      "Dhorakola BO": "825407",
      "Masnodih BO": "825407",
      "Chaubey BO": "825109",
      "Maskedih BO": "825109",
      "ALAGDIHA B.O.": "825109",
      "Pathaldiha BO": "825410",
      "Gorhand BO": "825318",
      "Mahugain BO": "825318",
      "Jogidih BO": "825132",
      "Murukmanai BO": "825418",
      "Phulwaria BO": "825418",
      "Dhab BO": "825407",
      "Chalkusa BO": "825109",
      "Dandadih BO": "825109",
      "Naitand BO": "825109",
      "Bekobar BO": "825409",
      "Gomobarwadih BO": "825409",
      "Kanko BO": "825409",
      "Lokai BO": "825410",
      "Dasarokhurd BO": "825318",
      "Parsabad BO": "825318",
      "Bansudih BO": "825132",
      "Khuta BO": "825132",
      "Mirganj BO": "825132",
      "Domchanch SO": "825407",
      "Koderma Thermal Power Station SO": "825421",
      "Jhumari Telaiya Bazar SO": "825409",
      "Kodarma SO": "825410",
      "Markacho SO": "825318",
      "Satgawan SO": "825132",
      "Domchanch Bazar SO": "825418",
      "Jainagar SO Koderma": "825109",
      "Telaiya Dam SO": "825413",
      "Jhumri Telaiya SO": "825409"
    },
    "DHANBAD": {
      "RUPAN": "828109",
      "Damodarpur BO": "826004",
      "Kalyanpur BO": "826004",
      "Bagdigi BO": "828110",
      "Amtal BO": "828111",
      "Bhagabandh BO": "828111",
      "Bhagatdih BO": "828111",
      "Dobari BO": "828111",
      "Lakarka BO": "828113",
      "Roam BO": "828113",
      "Tilaiya BO": "828113",
      "FATAMAHUL": "828113",
      "Silibari BO": "828203",
      "Kirkend BO": "828116",
      "Ramnagar Garh BO": "828305",
      "Pathergoria BO": "828305",
      "Karitand BO": "828129",
      "Lalpur BO": "828129",
      "Barwa BO": "828205",
      "Benagoria BO": "828204",
      "Birsinghpur BO": "828205",
      "Debiana BO": "828205",
      "Madanpur BO": "828205",
      "BARIO": "828109",
      "Angarpathra BO": "828113",
      "Bagdaha BO": "826006",
      "Rajpura BO": "828203",
      "Daldali BO": "828204",
      "Galfarbari BO": "828204",
      "Kesarkural BO": "828204",
      "Ledaharia BO": "828204",
      "MADANDI": "828205",
      "Chandore BO": "828121",
      "Brahmandiha BO": "828402",
      "Ratanpur  BO": "828109",
      "Nagnagar BO": "826004",
      "Daludih BO": "826006",
      "Kharni BO": "826006",
      "Tisra BO": "828115",
      "Burragarh BO": "828117",
      "Bara Putki BO": "828116",
      "BARWATANR": "828109",
      "Murradih BO": "826004",
      "Yadavpur BO": "826004",
      "Gopalichak BO": "828111",
      "Birajpur BO": "826006",
      "Kankomath BO": "828113",
      "Panjania BO": "826006",
      "Suranga BO": "828115",
      "Balihari BO": "828116",
      "Gonudih BO": "828116",
      "Madhuban BO": "828131",
      "SINGRA": "828305",
      "Urma BO": "828204",
      "Kaliasole BO": "828205",
      "Moradih BO": "828205",
      "Poddardih BO": "828205",
      "Kujama BO": "828131",
      "Rampur BO": "828304",
      "KANDRA": "828305",
      "BHURKUNRABARI": "828204",
      "Barbendia BO": "828205",
      "Dumaria BO": "828205",
      "Pandra BO": "828205",
      "Thaparnagar BO": "828205",
      "Singhdaha BO": "828402",
      "Singhdih BO": "828402",
      "Tantri BO": "828402",
      "Bhadrichak BO": "828121",
      "Sahubahiyar BO": "828402",
      "Srirampur BO": "828402",
      "Dumdumi BO": "828402",
      "Madaidih BO": "828402",
      "NERO": "828402",
      "LOKBAD": "828402",
      "Guakola BO": "828142",
      "Baghmara Bazar BO": "828306",
      "Baghmara BO": "828201",
      "Moko BO": "828201",
      "BARADAHA": "828201",
      "Kankanee BO": "828101",
      "Horladih BO": "828301",
      "Amlabad Colliery BO": "828302",
      "Dumarkunda BO": "828202",
      "Sarsapahari BO": "828202",
      "MADHUBAN": "828307",
      "Ambona BO": "828201",
      "Ankduara BO": "828201",
      "Sendra BO": "828101",
      "Bhutgoria BO": "828301",
      "Chanchpottery BO": "828202",
      "Keshalpur BO": "828114",
      "Matari BO": "828114",
      "Khario BO": "828306",
      "Pochari BO": "828306",
      "Ramakunda BO": "828306",
      "Karmatand BO": "828201",
      "Khanoodih BO": "828307",
      "Jhagrahi BO": "828125",
      "Kharkharee BO": "828125",
      "TARGA": "828125",
      "Pargha BO": "828201",
      "Pindrahat BO": "828201",
      "Salpatra BO": "828201",
      "Salukchapra BO": "828201",
      "Kalimela BO": "828112",
      "Pradhankhanta BO": "828114",
      "Maheshpur BO": "828125",
      "Gharbar BO": "828201",
      "Palani BO": "828201",
      "Pradhan Khanta BO": "828201",
      "Bowakalan BO": "828104",
      "Merrah BO": "828202",
      "CHAITA": "828401",
      "CHARAK BO": "828142",
      "Chipkia BO": "828109",
      "Dhoria Mahubani BO": "828109",
      "Fatehpur BO": "828109",
      "Katania Ojhadih BO": "828109",
      "Keska BO": "828109",
      "Latani BO": "828109",
      "Ludharia BO": "828142",
      "Maharajganj BO": "828109",
      "Maniadih BO": "828142",
      "Bastacola BO": "828106",
      "Bhendra BO": "828401",
      "Ghunghusa BO": "828401",
      "Gortoppa BO": "828109",
      "Jangalpur BO": "828109",
      "Nagarkiary BO": "828109",
      "Purnadih BO": "828142",
      "Sarkardih BO": "828109",
      "KHESHMI": "828401",
      "Bagsuma BO": "828109",
      "Bhitia BO": "828109",
      "G Raghunathpur BO": "828109",
      "Jhiluwa BO": "828109",
      "Maira Nawatand BO": "828109",
      "Hariharpur BO": "828401",
      "Bardohi BO": "828109",
      "Jhinaki BO": "828142",
      "Pokharia BO": "828109",
      "SUNDARPAHARI BO": "828142",
      "Ukma BO": "828142",
      "Dhanbad HO": "826001",
      "Jamadoba SO": "828112",
      "Nawagarh SO Dhanbad": "828306",
      "Bansjora SO": "828101",
      "BCCl Township SO": "826005",
      "Bhuli SO": "828104",
      "Cmrs SO": "826001",
      "Indian School Of Mines SO": "826004",
      "Katras Bazar SO": "828114",
      "Sonardih SO": "828125",
      "Tundoo SO": "828128",
      "ACC Colony SO": "828124",
      "Amlapara Jharia SO": "828111",
      "Baliapur SO": "828201",
      "Bhowra SO": "828302",
      "Dhanbad Bazar SO": "826001",
      "Fri SO": "828108",
      "Jagjivan Nagar SO": "826003",
      "Jealgora SO": "828110",
      "Khasjeena Gora SO": "828115",
      "Moonidih SO": "828129",
      "Mugma SO": "828204",
      "Sijua SO": "828121",
      "Sindri SO": "828122",
      "Sudamdih SO": "828126",
      "KGAshram SO": "826008",
      "Centralized Delivery Office PO": "826007",
      "Housing Colony SO": "826007",
      "Bhelatand SO": "828103",
      "Chasnalla SO": "828135",
      "Chirkunda SO": "828202",
      "KkPolytechnic SO": "826009",
      "NDC DHANBAD": "826011",
      "Jharia SO": "828111",
      "Kustore SO": "828117",
      "Kusunda SO": "828116",
      "Lodna SO Dhanbad": "828131",
      "Malkera SO": "828304",
      "Manaitand SO": "826001",
      "Patherdih SO": "828119",
      "SIT SO": "828123",
      "Saharpura SO": "828122",
      "BARWADDA S.O": "826010",
      "Jitpur SO": "828309",
      "Nudkhurkee SO": "828307",
      "BPolytechnic SO": "828130",
      "Bhaga SO": "828301",
      "Bhulan Bararee SO": "828133",
      "Cmpf SO": "826001",
      "DSE SO": "826001",
      "Dhanbad Hirapur SO": "826001",
      "Govindpur SO Dhanbad": "828109",
      "Jharia Bazar SO": "828111",
      "Katrasgarh SO": "828113",
      "Dhansar SO": "828106",
      "Domgarh SO": "828107",
      "Gomoh SO": "828401",
      "Jharia Manbad SO": "828111",
      "Kumardhubi SO": "828203",
      "Mohuda SO": "828305",
      "Nirsa Chatti SO": "828205",
      "Patherdih Coal Washery SO": "828132",
      "Shramik Nagar SO": "828105",
      "Topchanchi SO": "828402",
      "Maithon Dam SO": "828207",
      "Motinagar SO Dhanbad": "828120",
      "Naya Bazar Wasseypur SO": "826001",
      "Panchet Dam SO": "828206",
      "Saraidhela SO": "828127",
      "Rajganj SO": "826006",
      "Tundi SO": "828142"
    },
    "RANCHI": {
      "Baburamdih BO": "835225",
      "Baredih BO": "835204",
      "Chirudih BO": "835225",
      "TTMankidih BO": "835102",
      "Tati BO": "835102",
      "Parasi BO": "835225",
      "Tetla BO": "835102",
      "Tutikinawadih BO": "835102",
      "Amlesha BO": "835225",
      "Haramlohar BO": "835225",
      "Jilingserenge BO": "835225",
      "Landupdih BO": "835225",
      "Mankidih BO": "835225",
      "Rargaon BO": "835225",
      "BBNawadih BO": "835102",
      "Chokahatu BO": "835225",
      "Janumpiri BO": "835225",
      "Jargo BO": "835225",
      "Lungtu BO": "835225",
      "Pundidiri BO": "835225",
      "Burhadih BO": "835204",
      "Danadih BO": "835204",
      "Edramhatu BO": "835204",
      "Jareya BO": "835204",
      "Churgi B.O": "835204",
      "Tau B.O": "835204",
      "Halmad BO": "835101",
      "Champadih BO": "835234",
      "Rahe BO": "835204",
      "Reladih BO": "835204",
      "Sonahatu BO": "835204",
      "Tiril BO": "834004",
      "Mahugaon BO": "835234",
      "Hundru BO": "834003",
      "Henjed BO": "835204",
      "Humta BO": "835204",
      "Kanchi BO": "835204",
      "Nawadih BO": "829208",
      "Taimara BO": "835204",
      "Hotlo B.O": "835204",
      "Hakedag BO": "835101",
      "Tetebandrampur BO": "835101",
      "Balalong BO": "834004",
      "Pundag BO": "834004",
      "Late BO": "835234",
      "Burhakhukhra BO": "835214",
      "Chaingara BO": "835214",
      "Murupiri BO": "835214",
      "Sons BO": "835214",
      "Sosai BO": "835214",
      "Umedanda BO": "835214",
      "Buti BO": "834012",
      "Ichadag BO": "835219",
      "Sandi BO": "835219",
      "Subarnrekha Hydai Project BO": "835219",
      "Bindhani BO": "835303",
      "Chinarpurio BO": "835303",
      "Patrachauli BO": "835303",
      "Bariatu BO": "834009",
      "Chipra BO": "835222",
      "Marwa BO": "835222",
      "Daladli BO": "835222",
      "Sundil B.O": "835222",
      "Jamudag BO": "835204",
      "Lowahatu BO": "835204",
      "Sataki BO": "835204",
      "Kuchu BO": "835219",
      "Lagam BO": "835101",
      "Lodhma BO": "834004",
      "Sithio BO": "834004",
      "Koisera BO": "835234",
      "Lapung BO": "835234",
      "Pokta BO": "835234",
      "Chanho BO": "835214",
      "Choreya BO": "835214",
      "Karge BO": "835214",
      "Karkara BO": "835214",
      "Makka BO": "835214",
      "Chakma BO": "835214",
      "Kaimbo BO": "835214",
      "Sero BO": "835325",
      "Chandwe BO": "835217",
      "Hotwar BO": "834012",
      "Hundur BO": "835217",
      "Irba BO": "835217",
      "Palu BO": "835219",
      "Pancha BO": "835219",
      "Kuli BO": "835303",
      "Murma Nayasarai BO": "835303",
      "Saparam BO": "835303",
      "Kurgi B.O": "835303",
      "Bajpur B.O": "835222",
      "Burmu BO": "835214",
      "Mahuajari BO": "835214",
      "Patratu BO": "835214",
      "Sarle BO": "835214",
      "Susaimuru BO": "835214",
      "Kedal B.O": "835217",
      "Baxidih BO": "835219",
      "Raghunathpur BO": "835214",
      "Tala BO": "835214",
      "Tangar BO": "835214",
      "Chakla BO": "835219",
      "Chandra BO": "835219",
      "Dahu BO": "835219",
      "Anandi B.O": "835219",
      "Halhu BO": "835303",
      "Chete B.O": "835303",
      "Lame Baragaon BO": "834009",
      "Hurhuri BO": "835222",
      "Kamre BO": "835222",
      "Katamkuli BO": "835222",
      "Katulahna BO": "835222",
      "Simlia BO": "835222",
      "Dumardaga B.O": "834012",
      "Chutupalu BO": "835219",
      "Hendevelli BO": "835219",
      "Sadma BO": "835219",
      "Sikidiri BO": "835219",
      "Barsa BO": "835303",
      "Gutua BO": "835303",
      "Katarpa BO": "835303",
      "Bijjulia BO": "835222",
      "Guru BO": "835222",
      "Malsering BO": "835222",
      "Urugutu BO": "835222",
      "Patal B.O": "829209",
      "Baruhatu BO": "835204",
      "Churi East B.O": "829209",
      "Bamne B.O": "829209",
      "Churi North B.O": "829209",
      "Adalahatu BO": "835204",
      "Ambajharia BO": "835204",
      "Lali BO": "834010",
      "Hurua B.O": "834010",
      "Chandaghasi B.O": "834010",
      "Bantahazam BO": "835102",
      "Barenda BO": "835102",
      "Pandadih BO": "835102",
      "Barwadag BO": "835102",
      "Dowaru BO": "835102",
      "Jhabri BO": "835102",
      "Jamchuajaria BO": "834010",
      "Rajaulatu BO": "834010",
      "Hahap B.O": "834010",
      "Bansiya BO": "835102",
      "Barachagru BO": "835102",
      "Goradih BO": "835102",
      "Lota BO": "835102",
      "Patrahatu BO": "835102",
      "Deogaon BO": "835202",
      "Etta BO": "835202",
      "Kesha BO": "835202",
      "Nehalu BO": "835202",
      "Banapiri BO": "835205",
      "Chittarkota BO": "835205",
      "Murma BO": "835205",
      "Nagra BO": "835205",
      "Purio BO": "835205",
      "Turmuli BO": "835205",
      "Beyasi BO": "835301",
      "Sakra BO": "835301",
      "Silagain BO": "835301",
      "Boreya BO": "834006",
      "Hussir BO": "834006",
      "Kumharia BO": "834006",
      "Lapra B.O": "829208",
      "Bara Ghaghra BO": "834010",
      "Khijri BO": "834010",
      "Tetri BO": "834010",
      "Ajaygarh BO": "835102",
      "Piska BO": "835102",
      "Pogra BO": "835102",
      "Dolaicha BO": "835202",
      "Latratu B.O": "835202",
      "Gurgaon BO": "835205",
      "Jaherbargari BO": "835205",
      "Soba BO": "835205",
      "Bade B.O": "835205",
      "Kadru BO": "834002",
      "Nibaranpur BO": "834002",
      "Charkidumri BO": "835301",
      "Mandru BO": "835301",
      "Loyo B.O": "835301",
      "Gagi BO": "834006",
      "Ichapiri BO": "834006",
      "Kokdoro BO": "834006",
      "Pithoria BO": "834006",
      "Chama BO": "829205",
      "Diwan Nagar BO": "829205",
      "Mayapur B.O": "829205",
      "Hutap B.O": "829205",
      "Gargaon BO": "835202",
      "Hatu Ghaghra BO": "835202",
      "Kakaria BO": "835202",
      "Tuko BO": "835202",
      "Murto BO": "835301",
      "Narkopi BO": "835301",
      "Ranikhatanga BO": "835301",
      "Tikratoli BO": "835301",
      "Korambe BO": "835301",
      "Murkuni BO": "835301",
      "Jaria BO": "835202",
      "Khatri Khatanga BO": "835202",
      "Khukhra BO": "835202",
      "Paharkandaria BO": "835202",
      "Baraudi BO": "835205",
      "Ginjothakurgaon BO": "835205",
      "Pali BO": "835205",
      "Bisahakhatanga BO": "835301",
      "Tangarbasli BO": "835301",
      "Tutlo B.O": "835301",
      "Bukru BO": "834006",
      "Churi Madhay B.O": "829210",
      "Tumang B.O": "829205",
      "Bishrampur B.O": "829205",
      "Bukbuka B.O": "829205",
      "Churi South B.O": "829205",
      "Rarha B.O": "834006",
      "Binja BO": "835214",
      "Satakanadu BO": "834006",
      "Sarjamdih BO": "835225",
      "Ulidih BO": "835225",
      "Kurkutta B.O": "835225",
      "Bongaibera BO": "835103",
      "Childag BO": "835103",
      "Chatra B.O": "835103",
      "Hulhundu BO": "835221",
      "Arsande B.O": "834006",
      "Ulilohar BO": "835225",
      "Bisa BO": "835103",
      "Maheshpur BO": "835103",
      "Mahilong BO": "835103",
      "Nawagarh BO": "835103",
      "Dahusodang BO": "835221",
      "Pandri BO": "835213",
      "Sukurhutu BO": "834006",
      "Hurdag BO": "835221",
      "Vijaygiri BO": "835225",
      "Kundla B.O": "835225",
      "Angara BO": "835103",
      "Jon RS BO": "835103",
      "Medha BO": "835103",
      "Sugnu BO": "835103",
      "Rugari BO": "835225",
      "Salgadih BO": "835225",
      "Getalsud BO": "835103",
      "Hesal BO": "835103",
      "Rajadera BO": "835103",
      "Baram BO": "835103",
      "Asro BO": "835203",
      "Ranchi GPO": "834001",
      "Doranda HO": "834002",
      "AG Jharkhand SO": "834002",
      "Chotamuri SO": "835101",
      "Hatia SO Ranchi": "834003",
      "HEC Adm Bldg SO": "834004",
      "HEC Expert Hostel SO": "834004",
      "Tatisilway SO": "835103",
      "Church Road SO": "834001",
      "Hindpiri SO": "834001",
      "Indrapuri Colony SO": "834001",
      "Mandar SO Ranchi": "835214",
      "Nagjua SO": "835325",
      "Neori Vikas Vidyalaya SO": "835217",
      "Old Commissioner Compound SO": "834001",
      "Nodal Mechanized Delivery Office SO": "834013",
      "Buti Chowk S.O": "834012",
      "Khalari SO": "829205",
      "Dhurwa SO": "834004",
      "Hinoo SO": "834002",
      "Jagarnath Nagar Colony SO": "834004",
      "Ranchi Airport SO": "834002",
      "Silli SO": "835102",
      "Adalhatu SO": "834008",
      "Bero SO": "835202",
      "Brambe SO": "835205",
      "Harmu Housing Colony SO": "834002",
      "Ncdc SO": "834001",
      "Ormanjhi SO": "835219",
      "Dakra Colliery SO": "829210",
      "Ray SO": "829209",
      "Bundu SO": "835204",
      "Hindustan Steel Colony SO": "834002",
      "Jharkhand High Court SO": "834002",
      "Namkum SO": "834010",
      "Railway Colony Hatia SO": "834003",
      "Satellite Colony SO": "834004",
      "Sail City S.O": "834007",
      "Itki SO": "835301",
      "Kanke Road SO": "834008",
      "Mc Cluskiganj SO": "829208",
      "Ashok Nagar SO Ranchi": "834002",
      "HEC Colony SO": "834004",
      "Jharkhand Vidhan Sabha SO": "834004",
      "Tamar SO": "835225",
      "Tupudana SO": "835221",
      "SEMBO S.O": "834014",
      "Chutia SO": "834001",
      "Hehal SO": "834005",
      "Kanke SO": "834006",
      "Kantatoli SO": "834001",
      "Lalpur SO Ranchi": "834001",
      "Mesra SO": "835215",
      "Morabadi SO": "834008",
      "Ranchi Agriculture College SO": "834006",
      "Ranchi Court SO": "834001",
      "Ranchi Veterinary College SO": "834006",
      "Krishnapuri S O": "834011",
      "Kokar SO": "834001",
      "Lower Bazar SO": "834001",
      "New Area Marabadi SO": "834008",
      "Piskanagri SO": "835303",
      "Ranchi Medical College Campus SO": "834009",
      "Ranchi Medical College SO": "834009",
      "Ranchi University SO": "834008",
      "Ratu SO": "835222",
      "Argora SO": "834001"
    },
    "KHUNTI": {
      "Jojohatu BO": "835225",
      "Kochasindri BO": "835225",
      "Arki BO": "835225",
      "Kota BO": "835225",
      "Norhi BO": "835225",
      "Doreya BO": "835225",
      "Bikwadag BO": "835234",
      "Govindpur Road BO": "835234",
      "Jariagarh BO": "835234",
      "Chhata BO": "835209",
      "Kone BO": "835209",
      "Kurse BO": "835209",
      "Larta BO": "835209",
      "Ghunsuli BO": "835210",
      "Jaltanda BO": "835210",
      "Jurdag BO": "835210",
      "Koilselda BO": "835210",
      "Landup BO": "835210",
      "Kandir BO": "835216",
      "Mahil BO": "835216",
      "Sarwada BO": "835216",
      "Selda BO": "835216",
      "Kudlum B.O": "835209",
      "Kachhabari B.O": "835209",
      "Anigara BO": "835210",
      "Belwadag BO": "835210",
      "Bhandra BO": "835210",
      "Bichna BO": "835210",
      "Saparom BO": "835210",
      "Sirum BO": "835210",
      "G Jaltanda BO": "835210",
      "Bamhani BO": "835216",
      "Binda Bazar BO": "835216",
      "Birbanki BO": "835216",
      "Lapa BO": "835234",
      "Birda BO": "835209",
      "Sangor BO": "835209",
      "Bamarja B.O": "835209",
      "Sungi B.O": "835209",
      "Ethe BO": "835210",
      "Gutjora BO": "835210",
      "Hakadua BO": "835210",
      "Maranghada BO": "835210",
      "Saiko BO": "835210",
      "Ghaghra BO": "835216",
      "Jate BO": "835216",
      "Bingaon BO": "835209",
      "Tilmi BO": "835209",
      "Angrabari BO": "835210",
      "Birhu BO": "835210",
      "Phudi BO": "835210",
      "Burju BO": "835216",
      "Kochang BO": "835216",
      "Barudih B.O": "835216",
      "Rumutkel B.O": "835216",
      "Barinijkil B.O": "835225",
      "Jaipur BO": "835227",
      "Patpur BO": "835227",
      "Tamba B.O": "835227",
      "Barda BO": "835227",
      "Dumangdiri BO": "835227",
      "Icha BO": "835227",
      "Marcha BO": "835227",
      "Sundari BO": "835227",
      "Tirla BO": "835227",
      "Barkuli B.O": "835227",
      "Hathudani BO": "835221",
      "Murhi B.O": "835221",
      "Tarasiladon BO": "835221",
      "Ulihatu BO": "835225",
      "Dorma BO": "835227",
      "Kasmar BO": "835227",
      "Khatanga BO": "835227",
      "Diyankel B.O": "835227",
      "Dundigara BO": "835221",
      "Ambapakhna BO": "835227",
      "Raisimla BO": "835227",
      "Rania BO": "835227",
      "Sarbo BO": "835227",
      "Sode BO": "835227",
      "Khunti SO": "835210",
      "Murhu SO": "835216",
      "Govindpur SO Ranchi": "835234",
      "Karra SO": "835209",
      "Torpa SO": "835227"
    },
    "GIRIDIH": {
      "Atkadih BO": "825322",
      "Adwara BO": "825322",
      "Dhargulli BO": "825322",
      "Gorhar BO": "825322",
      "Hesla BO": "825322",
      "Jarmuney BO": "825322",
      "Kapilo BO": "825322",
      "Barkitand BO": "815312",
      "Budhudih BO": "815312",
      "Chapuadih BO": "815312",
      "Purri BO": "815312",
      "Rata Bahiyar BO": "815312",
      "Siyatand BO": "815312",
      "Bharkhar BO": "825106",
      "Chainpur BO": "825106",
      "Choudhary Bandh BO": "825106",
      "Pordag BO": "825106",
      "Burhiadih BO": "815302",
      "Chaitadih BO": "815302",
      "Daridih BO": "815302",
      "Gadi Sermpur BO": "815302",
      "Balgo BO": "815318",
      "Charghara BO": "815318",
      "Chittardih BO": "815318",
      "Chatro BO": "815314",
      "Bandhkharo BO": "825322",
      "Barwadih BO": "825322",
      "Dondlo BO": "825322",
      "Khetko Murmu BO": "825322",
      "Kushmarja B.O": "825322",
      "Ahilyapur BO": "815312",
      "Gadi Sirsia BO": "815312",
      "Parwatpur BO": "815312",
      "Phuljharia BO": "815312",
      "Sonardih BO": "815312",
      "Beko BO": "825106",
      "Jamtara BO": "825106",
      "Bendro BO": "815313",
      "Charki BO": "815313",
      "Sankh BO": "815313",
      "Baddiha BO": "825412",
      "Motieda BO": "815302",
      "Sirsia BO": "815302",
      "Udnabad BO": "815302",
      "Galagi BO": "825167",
      "Roshnatunda BO": "825167",
      "Telkhara BO": "825167",
      "Aura BO": "825322",
      "Balak BO": "825322",
      "Khurchutta BO": "815312",
      "Luppi BO": "815312",
      "Maheshmunda BO": "815312",
      "Mahuwar B.O": "815312",
      "Akdonikala BO": "815311",
      "Karharbari BO": "815311",
      "Matrukha BO": "815311",
      "Kahuwai BO": "815313",
      "Malda BO": "815313",
      "Manjhney BO": "815313",
      "Pihra BO": "815313",
      "Gadar B.O": "815313",
      "Taratand BO": "815302",
      "Laxmantunda BO": "825167",
      "Nagri BO": "825167",
      "Poraiya BO": "825167",
      "Dumma BO": "815318",
      "Ghoranji BO": "815314",
      "Choutha BO": "825322",
      "Alagdiha B.O": "825322",
      "Badwara BO": "815312",
      "Chhotki Kharagdiha BO": "815312",
      "Gadi Nawdiha BO": "815312",
      "Gandey BO": "815312",
      "Mundro BO": "825320",
      "Phulchi BO": "815312",
      "Tiklato BO": "815312",
      "Chino BO": "825106",
      "Kulgo BO": "825106",
      "Tengrakhurd B.O": "825106",
      "Birney BO": "815313",
      "Serua B.O": "815313",
      "Serampur Colliery BO": "815302",
      "Barmasia BO": "825167",
      "Bati BO": "815318",
      "Tara BO": "815318",
      "Bairia BO": "815314",
      "Khariodih BO": "815314",
      "Manikbad BO": "815314",
      "Dhuraita BO": "815315",
      "Kurhobindo BO": "815315",
      "Salaidih B.O": "815314",
      "Bedodih B.O": "815314",
      "Tilakdih B.O": "815314",
      "Sankho BO": "815315",
      "Chikandih BO": "815314",
      "Deori BO": "815314",
      "Chahal B.O": "815314",
      "Lokai BO": "815317",
      "Papilo BO": "815317",
      "Mansadih B.O": "815317",
      "Chunglo BO": "815318",
      "Jeruadih BO": "815318",
      "Jagsemar BO": "815314",
      "Machchali BO": "815314",
      "Mandro BO": "815314",
      "Pobi BO": "815315",
      "Bairiabad BO": "815316",
      "Khairidih BO": "825324",
      "Khurjio BO": "825324",
      "Manjhiladih BO": "825324",
      "Rupaidih BO": "825324",
      "Margoda B.O": "825324",
      "Atki BO": "825108",
      "Bishunpur BO": "825108",
      "Chilga BO": "825108",
      "Khukhara BO": "825108",
      "Dariadih BO": "825412",
      "Khori Mahua BO": "825412",
      "Kisgo BO": "825412",
      "Murna BO": "825412",
      "Sabalpur BO": "825320",
      "Bhandari BO": "815317",
      "Chandouri BO": "815317",
      "Kishutand BO": "815317",
      "Kharkhari B.O": "815317",
      "Lataki BO": "815315",
      "Berhabad BO": "815316",
      "Handadih BO": "815316",
      "Karma BO": "815316",
      "Pesham BO": "815316",
      "Balia BO": "815316",
      "Dwarpahari BO": "815316",
      "Leda BO": "815316",
      "Senadoni BO": "815316",
      "Janata Jaridih BO": "825324",
      "Keshodih BO": "825324",
      "Harladih BO": "825108",
      "Sobaranpur BO": "825108",
      "Ambatand BO": "825412",
      "Argali BO": "825412",
      "Hemrodih BO": "825412",
      "Khijursota BO": "825412",
      "Orkhar BO": "825412",
      "Sapamaran BO": "825412",
      "Bagodih BO": "825320",
      "Keshwari BO": "825320",
      "Naitand BO": "825320",
      "Khijuri BO": "815317",
      "Bajto BO": "815316",
      "Ranikhawa BO": "815316",
      "Padarmania B.O": "815316",
      "Gando BO": "825324",
      "Jawaharnagar BO": "825324",
      "Saranda BO": "825324",
      "Chhachhando BO": "825108",
      "Khudisar BO": "825108",
      "Kumharlalo BO": "825108",
      "Palganj BO": "825108",
      "Palmo BO": "825108",
      "Kudko B.O": "825108",
      "Doranda BO": "825412",
      "Jamdar BO": "825412",
      "Murkhari BO": "825412",
      "Rema BO": "825412",
      "Simaria BO": "825412",
      "Khatauri B.O": "825412",
      "Ghutia Pesra BO": "825320",
      "Persia BO": "825320",
      "Gumgi BO": "815317",
      "Kathkoko BO": "815317",
      "Bangrakala BO": "825324",
      "Dabri BO": "825324",
      "Gadi Bharkatha BO": "825324",
      "Barotand BO": "825412",
      "Bhandaro BO": "825412",
      "Karihari BO": "825412",
      "Khaskari BO": "825320",
      "Koiridih BO": "825320",
      "Mandramo BO": "825320",
      "Giridih HO": "815301",
      "Makatpur SO": "815301",
      "Mirzaganj SO": "815315",
      "Suriya SO": "825320",
      "Tisri SO": "815317",
      "Palounjia SO": "825324",
      "Pirtand SO": "825108",
      "Shikherjee SO": "825329",
      "Pachamba SO": "815316",
      "Rajdhanwarf SO": "825412",
      "Bengabad SO": "815312",
      "Ganwan SO": "815313",
      "Isri Bazar SO": "825167",
      "Kharagdiha SO": "815314",
      "Bagodar SO": "825322",
      "Barganda SO": "815301",
      "Beniadih SO": "815311",
      "Giridih  Town SO": "815302",
      "Dumri SO": "825106",
      "Giridih Bazar SO": "815301",
      "Jamua SO Giridh": "815318"
    },
    "WEST SINGHBHUM": {
      "Pronger BO": "835216",
      "Bandgaon BO": "835216",
      "Leyangi BO": "835216",
      "Hesadih BO": "835216",
      "Kendu BO": "833102",
      "Surguru BO": "833102",
      "Hatnatorang BO": "833102",
      "Salai BO": "833106",
      "Gangda BO": "833106",
      "Bara BO": "833103",
      "Unchibita BO": "833102",
      "Chandri BO": "833102",
      "Gulkera BO": "833102",
      "Bharania BO": "833102",
      "Chotanagra BO": "833106",
      "Kalaiya BO": "832302",
      "Bari BO": "833103",
      "Tuniagajpur BO": "833103",
      "Toklo BO": "833102",
      "Landupada BO": "833102",
      "Hurangda BO": "833102",
      "Itihasa BO": "833102",
      "Kairam BO": "833103",
      "Bila BO": "833103",
      "Tebo BO": "835216",
      "Nalita BO": "833102",
      "Kulitorang BO": "833102",
      "Hoyahatu BO": "833102",
      "Itore BO": "833102",
      "Swania BO": "835216",
      "Arahasa BO": "833103",
      "Tarkatkocha BO": "833103",
      "Kundiadhar BO": "833214",
      "NAshram BO": "833214",
      "Chainpur Khas BO": "833102",
      "Chirubera BO": "833102",
      "Gopinathpur BO": "833102",
      "Hathia BO": "833102",
      "Jamid BO": "833102",
      "Keraikela BO": "833102",
      "Barajamni BO": "833214",
      "Benisagar BO": "833214",
      "Bensakaranjia BO": "833214",
      "Karanjia BO": "833214",
      "Khairpal BO": "833214",
      "Baraiburu BO": "833221",
      "Nakti BO": "833102",
      "Roladih BO": "833102",
      "Baipee BO": "833102",
      "Bhalupani BO": "833102",
      "Hesalkuti BO": "833102",
      "Kera BO": "833102",
      "Lotapahar BO": "833102",
      "Mahulpani BO": "833102",
      "Otar BO": "833102",
      "Kebra BO": "833103",
      "Sarugara BO": "833103",
      "Balandia BO": "833214",
      "Dhobadhobin BO": "833214",
      "Jamdih BO": "833214",
      "Kumardungi BO": "833214",
      "Majhgaon BO": "833214",
      "Punga BO": "833214",
      "Ruia BO": "833214",
      "DIRIBURU BO": "833221",
      "Jharjharia BO": "833102",
      "Sarjamhatu BO": "833102",
      "Pokharpi BO": "833203",
      "Naogaon BO": "833215",
      "Surjabasa BO": "833215",
      "Rengrahatu BO": "833215",
      "Barposh BO": "833104",
      "Dumrita BO": "833104",
      "Posiata BO": "833104",
      "Kaida BO": "833104",
      "Binju BO": "833104",
      "Rundhikocha BO": "833104",
      "Makranda BO": "833104",
      "Kadajamda BO": "833218",
      "Pataita BO": "833218",
      "Dudhbila BO": "833218",
      "Asantalia BO": "833105",
      "Kuira BO": "833105",
      "Balijori BO": "833105",
      "Golmunda BO": "833105",
      "Andhari BO": "833214",
      "Balibandh BO": "833214",
      "Jaintgarh BO": "833214",
      "Khairbandh BO": "833214",
      "Khurpose BO": "833214",
      "Dalki BO": "833215",
      "Purnapani BO": "833215",
      "Tonto BO": "833204",
      "Bamebasa BO": "833215",
      "Nimdih BO": "833215",
      "Baikera BO": "833104",
      "Patherbasa BO": "833104",
      "Rajanand Pur BO": "833104",
      "Dimduli BO": "833104",
      "Tomdel BO": "833104",
      "Jharbera BO": "833104",
      "Lailor BO": "833104",
      "Joteya BO": "833218",
      "Bhalurungi BO": "833105",
      "Lonjo BO": "833105",
      "Kadamdiha  BO": "833105",
      "Parsagar Keshna BO": "833214",
      "Sindri Guiya BO": "833214",
      "Todanghatu BO": "833203",
      "Sringgesia BO": "833215",
      "Kenjra BO": "833215",
      "Kondwa BO": "833215",
      "Bundu BO": "833215",
      "Robkera BO": "833104",
      "Barakenduda BO": "833104",
      "Nandpur BO": "833104",
      "Kotgarh BO": "833218",
      "Mahudi BO": "833218",
      "Jarakel BO": "833105",
      "Dewanbir BO": "833105",
      "Barananda BO": "833203",
      "Kasira BO": "833203",
      "Barajhinkpani BO": "833215",
      "Kudahatu BO": "833215",
      "Nurda BO": "833215",
      "Urkia BO": "833104",
      "Digha BO": "833104",
      "Kolpotka BO": "833104",
      "Harta BO": "833104",
      "Jojo Camp BO": "833217",
      "Balijharan BO": "833217",
      "Porahat BO": "833105",
      "Asura BO": "833202",
      "Singhpokharia BO": "833202",
      "Kelende  BO": "833202",
      "Tuibir  BO": "833202",
      "Barusai BO": "833214",
      "SONAPOSI  B.O.": "833214",
      "Sonaposi BO": "833214",
      "Choya BO": "833215",
      "Bhonda BO": "833214",
      "Parsa BO": "833214",
      "Barachiru BO": "833204",
      "Bhoya BO": "833204",
      "Chittimitti BO": "833204",
      "Dholadih BO": "833204",
      "Ghagri BO": "833204",
      "Kathbari BO": "833204",
      "Khuntpani BO": "833204",
      "Kursi BO": "833204",
      "Ulirajbasa BO": "833204",
      "Tentra BO": "833204",
      "Tentera BO": "833204",
      "Maluka BO": "833203",
      "Gumuria BO": "833214",
      "CHOTA MAHULDIYA  B.O.": "833214",
      "CHOTA RAIKAMAN   B.O.": "833214",
      "Chhota Mahuldiha BO": "833214",
      "Bhangaon BO": "833214",
      "Chhota Raikaman BO": "833214",
      "Kusmunda BO": "833214",
      "Bagabilla BO": "833204",
      "Baralagia BO": "833204",
      "Gitilipi BO": "833204",
      "Khedchalan BO": "833204",
      "Kokcho BO": "833204",
      "Purunia BO": "833204",
      "Sarda BO": "833204",
      "Tantnagar BO": "833204",
      "DOPAI B.O.": "833204",
      "Pandabir BO": "833204",
      "Harila BO": "833204",
      "Padsa BO": "833204",
      "Khaspokhria BO": "833204",
      "KHASHPOKHERIYA   B.O.": "833204",
      "Simbiya BO": "833204",
      "Kochra BO": "833203",
      "Gudri BO": "835227",
      "Sindriguia BO": "833214",
      "Dikubalkand  BO": "833214",
      "Baliaposi  BO": "833214",
      "Barkella BO": "833204",
      "Barkundia BO": "833204",
      "Bharbharia BO": "833204",
      "Kheriatangar BO": "833204",
      "Baraguira BO": "833204",
      "Tekrahatu BO": "833204",
      "Bara Torlo BO": "833204",
      "Angardih BO": "833204",
      "RUIDIH B.O.": "833204",
      "Ruidih BO": "833204",
      "Ipilsingi BO": "833204",
      "Karlajodi BO": "833204",
      "Siyaljora BO": "833214",
      "TBDumuria BO": "833214",
      "ANGARPADA   B.O.": "833214",
      "Patajaint BO": "833214",
      "Angarpada BO": "833214",
      "Kumirta BO": "833214",
      "Asanpat BO": "833214",
      "Bera Mundui BO": "833214",
      "Baralagra BO": "833204",
      "Guira BO": "833204",
      "Gulia BO": "833204",
      "Nakahasa BO": "833204",
      "Narsanda BO": "833204",
      "Pandrasali BO": "833204",
      "Pilka BO": "833204",
      "Roro BO": "833204",
      "Baduri BO": "833204",
      "Chaibasa HO": "833201",
      "Bari Bazar SO": "833201",
      "Chakradharpur Colony SO": "833102",
      "Danguaposi SO": "833212",
      "Jagannathpur SO": "833203",
      "Chakradharpur Bazar SO": "833102",
      "Goilkera SO": "833103",
      "Gua SO": "833213",
      "Jhinkpani SO": "833215",
      "Meghahatuburu SO": "833223",
      "Sonua SO": "833105",
      "Barajamda SO": "833221",
      "Chakradharpur SO": "833102",
      "Chiria SO": "833106",
      "Hatgamaria SO": "833214",
      "Noamundi Bazar SO": "833218",
      "Tata College Chaibasa SO": "833202",
      "JMP Chowk SO": "833204",
      "Kiriburu Base Camp SO": "833222",
      "Manoharpur SO West Singhbhum": "833104",
      "Noamundi SO": "833217"
    },
    "GUMLA": {
      "Rendwa BO": "835234",
      "Puso BO": "835302",
      "Sahijana BO": "835302",
      "Birkera BO": "835232",
      "Karida BO": "835232",
      "Konkel BO": "835232",
      "Pulung BO": "835232",
      "Bhikhampur BO": "835230",
      "Chiraiyan BO": "835230",
      "Majhgaon BO": "835230",
      "Rajawal BO": "835230",
      "Armai BO": "835220",
      "Bilingbira BO": "835220",
      "Karondi BO": "835232",
      "Kondra BO": "835232",
      "Parsa BO": "835232",
      "Raidih BO": "835232",
      "Silam BO": "835232",
      "Sursang BO": "835232",
      "Khetli BO": "835230",
      "Lawabar BO": "835230",
      "Baghima BO": "835220",
      "Pugu B.O": "835220",
      "Arko BO": "835224",
      "Bargaon BO": "835224",
      "Bhurso BO": "835224",
      "Karounda BO": "835224",
      "Khora BO": "835224",
      "Murgu BO": "835224",
      "Silaphari B.O": "835224",
      "Gunia BO": "835233",
      "Kharka BO": "835233",
      "Kotam BO": "835233",
      "Nawadih BO": "835233",
      "Asani BO": "835233",
      "Koleng BO": "835220",
      "Lotwa BO": "835220",
      "Marda BO": "835220",
      "Tapkara BO": "835220",
      "Bangru B.O": "835220",
      "Chharda BO": "835224",
      "Jura BO": "835224",
      "Olmunda BO": "835224",
      "Shiwnathpur BO": "835224",
      "Sogra BO": "835224",
      "Basua BO": "835233",
      "Ghatgaon BO": "835233",
      "Sakarpur Gamharia BO": "835233",
      "Amgaon BO": "835232",
      "Kemte BO": "835232",
      "Telgaon BO": "835232",
      "Pibo B.O": "835232",
      "Bhagitoli BO": "835230",
      "Dina BO": "835230",
      "Larango BO": "835302",
      "Kobja B.O": "835232",
      "Fasia B.O": "835232",
      "Jobhipath BO": "835218",
      "Dumarapath BO": "835218",
      "Govindpur BO": "835230",
      "Dhedhouli BO": "835220",
      "Dumardih BO": "835220",
      "Keshipara BO": "835220",
      "Nathpur BO": "835220",
      "Obera Sundarpur BO": "835220",
      "Pojenga BO": "835220",
      "Sundaridih BO": "835220",
      "Tangaria BO": "835220",
      "Karanj BO": "835224",
      "Karkari BO": "835224",
      "Nagar BO": "835224",
      "Hisri BO": "835230",
      "Kaliga BO": "835220",
      "Kurum BO": "835220",
      "Malai BO": "835220",
      "Murkunda BO": "835220",
      "Taisera BO": "835220",
      "Datia BO": "835224",
      "Nagpheni BO": "835224",
      "Patia BO": "835224",
      "Sakrauli BO": "835224",
      "kraundajor BO": "835224",
      "Pandaria B.O": "835224",
      "Dumba B.O": "835224",
      "Anjan BO": "835233",
      "Phori BO": "835233",
      "Pimpi BO": "835227",
      "Kamdara BO": "835227",
      "Latra BO": "835227",
      "Banaghutu BO": "835229",
      "Gangara BO": "835229",
      "Gara BO": "835229",
      "Konbirnawatoli BO": "835229",
      "Tetra B.O": "835229",
      "Mahadeo Chegri BO": "835203",
      "Pabeya BO": "835203",
      "Turiamba BO": "835203",
      "Narwa BO": "835231",
      "Janawal BO": "835206",
      "Katkahi BO": "835206",
      "Kereng BO": "835206",
      "Tongo BO": "835206",
      "Dewaki BO": "835208",
      "Icha BO": "835208",
      "Naudiha BO": "835208",
      "Kulburu BO": "835201",
      "Marwai BO": "835231",
      "Salemnawatoli BO": "835231",
      "Sarango BO": "835231",
      "Sato BO": "835231",
      "Arangi BO": "835208",
      "Belagara BO": "835208",
      "Gamharia BO": "835208",
      "Kugaon BO": "835208",
      "Shivsoreng BO": "835208",
      "Totambi BO": "835208",
      "Ramtolaya BO": "835227",
      "Salegutu BO": "835227",
      "Sarita BO": "835227",
      "Longa BO": "835229",
      "Lungtu BO": "835229",
      "Moreng BO": "835229",
      "Danikera BO": "835203",
      "Adar BO": "835231",
      "Harup BO": "835231",
      "Jamti BO": "835231",
      "Jori BO": "835231",
      "Bendora BO": "835206",
      "Harra BO": "835206",
      "Hesag BO": "835206",
      "Putrungi BO": "835206",
      "Sikri BO": "835206",
      "Srinagar BO": "835206",
      "Puto BO": "835208",
      "Itam BO": "835211",
      "Rampur BO": "835211",
      "Pakra RS BO": "835227",
      "Pokla RS BO": "835227",
      "Surhu BO": "835227",
      "Banai BO": "835229",
      "Haphu BO": "835229",
      "Kumhari BO": "835229",
      "Mamarla BO": "835229",
      "Sukurda BO": "835229",
      "Amalia BO": "835203",
      "Marasili BO": "835203",
      "Banari BO": "835231",
      "Jokarigutwa BO": "835231",
      "Ruki BO": "835231",
      "Barwenagar BO": "835206",
      "Jamgain BO": "835206",
      "Jari BO": "835206",
      "Kanshir BO": "835206",
      "Kurumgarh BO": "835206",
      "Luru BO": "835206",
      "Tabela BO": "835206",
      "Tusgaon BO": "835206",
      "Hutar BO": "835208",
      "Gumla HO": "835207",
      "Basia SO": "835229",
      "Sisai SO Gumla": "835224",
      "Bharno SO": "835203",
      "Ghaghra SO": "835208",
      "Kartick Oraon College SO": "835207",
      "Nawagarh SO Gumla": "835232",
      "Chainpur SO Gumla": "835206",
      "Gumla Bazar SO": "835207",
      "Toto SO": "835233",
      "Bishunpur SO": "835231",
      "Noadih SO": "835230",
      "Palkot SO": "835220"
    },
    "LOHARDAGA": {
      "Kakargarh BO": "835214",
      "Kairo BO": "835325",
      "Narauli BO": "835325",
      "Tati BO": "835325",
      "Gajni BO": "835325",
      "Kharta BO": "835325",
      "Sinjo BO": "835325",
      "Gitilgarh BO": "835214",
      "Hanhat BO": "835214",
      "Akashi BO": "835325",
      "Baragain BO": "835325",
      "Bhitta BO": "835325",
      "Mahuary BO": "835325",
      "Gageya BO": "835302",
      "Hisri BO": "835302",
      "Juria BO": "835302",
      "Koarambe BO": "835302",
      "Alaundi B.O": "835302",
      "Tigra B.O": "835302",
      "Bhawro BO": "835301",
      "Harmu BO": "835302",
      "Hasapiri BO": "835302",
      "Hesway BO": "835302",
      "Hirhi BO": "835302",
      "Irga RS BO": "835302",
      "Jorisaheda BO": "835302",
      "Kisko BO": "835302",
      "Nagra BO": "835302",
      "Narinawadih BO": "835302",
      "Pesrar BO": "835302",
      "Manho B.O": "835302",
      "Dundru BO": "835302",
      "Kujra BO": "835302",
      "Masmano BO": "835302",
      "Rampur BO": "835302",
      "Senha BO": "835302",
      "Balsota BO": "835301",
      "Mungo BO": "835302",
      "Nigni BO": "835302",
      "Semardih BO": "835302",
      "Sithio BO": "835302",
      "Tisiya BO": "835302",
      "Semra BO": "835301",
      "Daru BO": "835302",
      "Bhatkhijri BO": "835302",
      "Butisenha BO": "835302",
      "Chiri BO": "835213",
      "Lowagain BO": "835213",
      "Arru BO": "835302",
      "Badla BO": "835302",
      "Charhu BO": "835302",
      "Jhikochatti BO": "835203",
      "Opa BO": "835213",
      "Barkichanpi B.O": "835213",
      "Arkosa BO": "835302",
      "Jamgain BO": "835203",
      "Chapijhario BO": "835213",
      "Henjla BO": "835213",
      "Kurse BO": "835213",
      "Pandra BO": "835213",
      "Bagru Hills BO": "835302",
      "Bagru Mines BO": "835302",
      "Kurag BO": "835231",
      "Chandujima BO": "835213",
      "Jingi BO": "835213",
      "Salgi BO": "835213",
      "Hesal B.O": "835213",
      "Arya BO": "835302",
      "Bagha BO": "835302",
      "Bhandra BO": "835302",
      "Lohardaga Court SO": "835302",
      "Lohardaga SO": "835302",
      "Kuru SO": "835213",
      "Lohardaga Bazar SO": "835302"
    },
    "SIMDEGA": {
      "Jokbahar BO": "835223",
      "Kulukera BO": "835223",
      "Meromdega BO": "835223",
      "Tumdega BO": "835223",
      "Bolba BO": "835226",
      "Karramunda BO": "835226",
      "Kodapani BO": "835226",
      "Piriyapoch BO": "835226",
      "Koranjo BO": "835226",
      "Bagdega BO": "835223",
      "Pithra BO": "835223",
      "Sewai BO": "835223",
      "Taisera BO": "835212",
      "Baliajor BO": "835226",
      "Bansjor BO": "835226",
      "Behrinbasa BO": "835226",
      "Kereya BO": "835226",
      "Basain BO": "835223",
      "Bombalkera BO": "835223",
      "Gorarjora BO": "835223",
      "Keshalpur BO": "835223",
      "Khuntitoli BO": "835223",
      "Kinkel BO": "835223",
      "Kochedega BO": "835223",
      "Samsera BO": "835226",
      "Targa BO": "835226",
      "Urta BO": "835226",
      "Gutbahar BO": "835223",
      "Hethma BO": "835223",
      "Kersai BO": "835223",
      "Konaskela BO": "835223",
      "Malsera BO": "835223",
      "Tupudega Pandripani BO": "835223",
      "Jampani BO": "835226",
      "Kundurmunda BO": "835226",
      "Kurmia BO": "835226",
      "Taraboga BO": "835226",
      "Banki BO": "835201",
      "Jitutoli BO": "835201",
      "Kurkura BO": "835201",
      "Orga BO": "835201",
      "Sikorda BO": "835201",
      "Keonddih BO": "835228",
      "Tamra BO": "835228",
      "Deobahar BO": "835235",
      "Konbegi BO": "835235",
      "Agharma BO": "835211",
      "Baribringa BO": "835211",
      "Konmerla BO": "835211",
      "Kolemdega BO": "835211",
      "B  Biura BO": "835212",
      "Konjoba BO": "835212",
      "Dumardih BO": "835212",
      "Rengari BO": "835235",
      "Ch Munda BO": "835212",
      "Dhori BO": "835212",
      "Gariajore BO": "835212",
      "Kutunjia BO": "835201",
      "Latakel BO": "835201",
      "Raikera BO": "835201",
      "Bhelwadih BO": "835228",
      "Garja BO": "835235",
      "Kjijra BO": "835235",
      "Jaldega BO": "835211",
      "Lasia BO": "835211",
      "Tutikel BO": "835211",
      "Bongram BO": "835211",
      "Turbunga B.O": "835211",
      "Domtoli B.O": "835211",
      "Khinda BO": "835212",
      "Kutmakochar BO": "835212",
      "Genmer BO": "835201",
      "Gerda BO": "835201",
      "Hatinghore BO": "835201",
      "Hurda BO": "835201",
      "Lachragarh BO": "835201",
      "Lamgarh BO": "835201",
      "Kuruskela BO": "835228",
      "Pakardanr BO": "835228",
      "Phulwartangar BO": "835228",
      "Sikariatand BO": "835228",
      "Konpala BO": "835235",
      "Lathakhaman BO": "835235",
      "Barsloya BO": "835211",
      "Barwadih BO": "835211",
      "Bongera BO": "835211",
      "Boroseta BO": "835211",
      "Lombai BO": "835211",
      "Sahpur BO": "835211",
      "Sukhajharia BO": "835211",
      "Gatadih BO": "835212",
      "Bano SO": "835201",
      "Thethaitangar SO": "835226",
      "Gotra SO": "835235",
      "Biru SO": "835228",
      "Kolebira SO": "835211",
      "Kurdeg SO": "835212",
      "Simdega SO": "835223"
    },
    "SARAIKELA KHARSAWAN": {
      "Galudih BO": "833101",
      "Gopidih BO": "833101",
      "Barabamboo BO": "833102",
      "Jojokurma BO": "833102",
      "Padampur BO": "833101",
      "Kuchai BO": "833216",
      "Seraikella Block BO": "833219",
      "Tablapur BO": "833219",
      "Munda Tand BO": "833220",
      "Narayanpur BO": "833220",
      "Arwan BO": "833216",
      "Dalbhanga BO": "833216",
      "Kendua BO": "833220",
      "Raidih BO": "833220",
      "Sindhukopa BO": "833220",
      "Bansa BO": "832404",
      "Buruhatu BO": "832404",
      "Chipri BO": "832404",
      "Deoltand BO": "832404",
      "Chhota Bandi BO": "833216",
      "Pathermara BO": "833219",
      "Burudih BO": "832108",
      "Dugni BO": "833220",
      "Nengtasai BO": "833220",
      "Sindri BO": "833220",
      "Bamni BO": "832401",
      "Jugilong BO": "832401",
      "Tilla BO": "832401",
      "Ghatdulmi BO": "832404",
      "Ichagarh BO": "832404",
      "Jhabri BO": "832404",
      "Khunti BO": "832404",
      "Baramari BO": "832108",
      "Tumung BO": "832107",
      "Dudra BO": "831002",
      "Itagarh BO": "831002",
      "Ichadih BO": "832403",
      "Soro BO": "832403",
      "Kolabira BO": "833220",
      "Madhupur BO": "832401",
      "Bareda BO": "832401",
      "Bhadudih BO": "832401",
      "Chainpur BO": "832401",
      "Chelgu BO": "832401",
      "Nimdih BO": "832401",
      "Simagunda BO": "832401",
      "Moisara BO": "832404",
      "Sidhdih BO": "832404",
      "Tamari BO": "832404",
      "Tuta BO": "832404",
      "Nowagarh BO": "832108",
      "Adardih BO": "832401",
      "Bamni Chaliyama BO": "832401",
      "Ghoraling BO": "832401",
      "Kanderbera BO": "832401",
      "Suksari BO": "832401",
      "Tankocha BO": "832401",
      "Bandu BO": "832404",
      "Gaurangkocha BO": "832404",
      "Hesakocha BO": "832404",
      "Kashidih BO": "832404",
      "Lepatand BO": "832404",
      "Nadisai BO": "832404",
      "Tikar BO": "832404",
      "Urmal BO": "832404",
      "Dugdha BO": "832108",
      "Hudu BO": "832402",
      "Kapali BO": "831012",
      "Choura BO": "832403",
      "Janum BO": "832403",
      "Muru BO": "832403",
      "Keshargaria BO": "833204",
      "Govindpur BO": "831002",
      "Rajnagar BO": "831002",
      "Rola BO": "831002",
      "Shirum BO": "832403",
      "Situ BO": "832403",
      "Icha BO": "833204",
      "Jhalak BO": "833204",
      "Kendamundi BO": "832107",
      "Dulmi BO": "832403",
      "Kukru BO": "832403",
      "Seraikella SO": "833219",
      "Chandil SO": "832401",
      "NIT SO": "831014",
      "Chowka SO": "832404",
      "Gamharia SO": "832108",
      "Kharsawangarh SO": "833216",
      "Sini SO": "833220",
      "Kandra SO Seraikelakharsawan": "832402",
      "Tiruldih SO": "832403",
      "Amda SO": "833101",
      "Adityapur Industrial Area SO": "832109",
      "Adityapur SO": "831013"
    },
    "EAST SINGHBUM": {
      "Arong BO": "832101",
      "Bamdole BO": "832101",
      "Jamshola BO": "832101",
      "Jarapal BO": "832101",
      "Joypura BO": "832101",
      "Kesharda BO": "832101",
      "Khandamouda BO": "832101",
      "Kumardubi BO": "832101",
      "Malua BO": "832101",
      "Angarpara BO": "832101",
      "Chitreshwar BO": "832101",
      "Darkhuli BO": "832101",
      "Guhiapal BO": "832101",
      "Mouda BO": "832101",
      "Benda BO": "832101",
      "Damjuri BO": "832101",
      "Dandudih BO": "832101",
      "Gamharia BO": "832101",
      "Kaimi BO": "832101",
      "Matihana BO": "832101",
      "Murakati BO": "832101",
      "Sakra BO": "832101",
      "Baragaria BO": "832101",
      "Chandrapur BO": "832101",
      "Chhota Porulia BO": "832101",
      "Ghaspada BO": "832101",
      "Kaima BO": "832101",
      "Ram Chandra Pur BO": "832101",
      "Bankata BO": "832101",
      "BANMAKRI BO": "832101",
      "Jugitupa BO": "832301",
      "Arjunbera BO": "832302",
      "Baliaguri BO": "832302",
      "Balijuri BO": "832302",
      "Mohulishole BO": "832302",
      "Murathakura BO": "832302",
      "Nutangarh BO": "832302",
      "Panduda BO": "832302",
      "Kanas BO": "832302",
      "Forest Block BO": "832302",
      "Bankati BO": "832303",
      "Barajuri BO": "832303",
      "Chukripara BO": "832303",
      "Butgora BO": "832102",
      "Dhirol BO": "832102",
      "Kendadangri BO": "832301",
      "Lodhasholi BO": "832301",
      "Manusmuria BO": "832301",
      "Mural BO": "832301",
      "Chingra BO": "832301",
      "Hariniya  BO": "832301",
      "Purnapani BO": "832301",
      "Bhalki BO": "831002",
      "Gurabanda BO": "832302",
      "Matiabandhi BO": "832302",
      "Pitajuri BO": "832302",
      "Shyam Sunderpur BO": "832302",
      "Malkudi BO": "832302",
      "Haldajuri BO": "832303",
      "Kendadih BO": "832303",
      "Gopalpur BO": "832303",
      "Benashol BO": "832303",
      "Amlatola BO": "832102",
      "Bengo BO": "832102",
      "Kalikapur BO": "832102",
      "Suklara BO": "832304",
      "Ulda BO": "832301",
      "Hirachuni BO": "831012",
      "Pipla BO": "831012",
      "Belajuri BO": "831012",
      "Bara Asti BO": "832104",
      "Bhagabandhi BO": "832104",
      "Kumarshol BO": "832104",
      "Palasbani BO": "832104",
      "Parulia BO": "832104",
      "Meria BO": "832104",
      "Kuilisuta BO": "832104",
      "Jorsiya BO": "832105",
      "Kumir BO": "832105",
      "Lachhipur BO": "832105",
      "Rakha Mines BO": "832106",
      "BKutung BO": "831002",
      "Bara Deoli BO": "831002",
      "Haludbani BO": "831002",
      "Juri BO": "831002",
      "Khairpal BO": "831002",
      "Sarjamda BO": "831002",
      "Chhota Govindpur BO": "831004",
      "Laojora BO": "832112",
      "Madhavpur BO": "832112",
      "Kantaboni BO": "832302",
      "Kokpara BO": "832302",
      "Dobha BO": "832303",
      "Edelbera BO": "832303",
      "Mohanpur BO": "832303",
      "Surda Mines BO": "832303",
      "Banasoli BO": "832301",
      "Baramara BO": "832301",
      "Bardikanpur BO": "832301",
      "Bend BO": "832301",
      "Sardiha BO": "832301",
      "Pathara BO": "832301",
      "Amlagora BO": "832301",
      "Bhandaru BO": "832301",
      "Kalidaspur BO": "832301",
      "Sonahatu BO": "832301",
      "Bhaduakocha BO": "832301",
      "Jamuwa BO": "832301",
      "Gohaldangra BO": "832302",
      "Kaliam BO": "832302",
      "Rautara BO": "832302",
      "Singhpura BO": "832302",
      "Asna BO": "832303",
      "Jhantijharna BO": "832303",
      "Karaduba BO": "832303",
      "Pungora BO": "832303",
      "Luabasa BO": "831004",
      "Asanboni BO": "832102",
      "Bhatin BO": "832102",
      "Dorkasai BO": "832102",
      "Manpur BO": "832102",
      "Rajdoha BO": "832102",
      "Kesharpur BO": "832304",
      "Bankisole BO": "832104",
      "Barabotla BO": "832104",
      "Bangurda BO": "832105",
      "Bidra BO": "832105",
      "Kamalpur BO": "832105",
      "Kasmar BO": "832105",
      "Laylan BO": "832105",
      "Dighi BO": "832105",
      "Gitilata BO": "832107",
      "Haludpukur BO": "831002",
      "Jumal BO": "831002",
      "Karandih BO": "831002",
      "Potka BO": "831002",
      "Tangrain BO": "831002",
      "Ghorabandha BO": "831004",
      "Hurlung BO": "831004",
      "Chhota Bangurda BO": "832112",
      "Kuiani BO": "832112",
      "Balibandh BO": "832301",
      "Bhalukbinda BO": "832301",
      "Gandanata BO": "832301",
      "Kalapathar BO": "832301",
      "Katushole BO": "832301",
      "Rupuskundi BO": "832301",
      "Simdi BO": "832301",
      "Barakurshi BO": "832304",
      "Beko BO": "832304",
      "Bhilaipahari BO": "831012",
      "Dumuria BO": "832104",
      "Kharida BO": "832104",
      "Khairbani BO": "832104",
      "Bara Kanjia BO": "832104",
      "Kantashol BO": "832104",
      "Chirudih BO": "832105",
      "Gobarghusi BO": "832105",
      "Matigora BO": "832106",
      "CoOp  College BO": "831001",
      "Bagbera BO": "831002",
      "Chakri BO": "831002",
      "Harhargutu BO": "831002",
      "Rasun Chopa BO": "831002",
      "Sangrain BO": "831002",
      "Barachirka BO": "832112",
      "Beldih BO": "832112",
      "Koira BO": "832112",
      "Pokharia BO": "832112",
      "Hathibinda BO": "832102",
      "Dhobani  BO": "832102",
      "Kuldiha BO": "832102",
      "Chorinda BO": "832304",
      "Hendaljuri BO": "832304",
      "Badia BO": "832104",
      "Kantasole BO": "832104",
      "Bankuchia BO": "832105",
      "Pagda BO": "832105",
      "Rasik Nagar BO": "832105",
      "Mahulbani BO": "832105",
      "Sisda BO": "832105",
      "Shankarda BO": "832107",
      "Kitadih BO": "831002",
      "Kowali BO": "831002",
      "Narda BO": "831002",
      "Paharpur BO": "832112",
      "Jamshedpur HO": "831001",
      "Azadnagar SO": "831012",
      "Ghatsila SO": "832303",
      "Indranagar SO": "831004",
      "Kadma SO": "831005",
      "Mahulia SO": "832304",
      "Mango SO": "831012",
      "Rakha Copper Project SO": "832106",
      "Sundarnagar SO": "832107",
      "Tatanagar SO": "831002",
      "Nodal Delivery Centre Jamshedpur": "831021",
      "Hata Chowk SO": "832113",
      "Agrico SO": "831009",
      "Baharagora SO": "832101",
      "Burma Mines SO": "831007",
      "Dhalbhumgarh SO": "832302",
      "Kalimati Market SO": "831004",
      "Narwa Mines  SO": "832111",
      "Patamda SO": "832105",
      "Sakchi Court SO": "831001",
      "Sakchi SO": "831001",
      "Telco Works SO": "831004",
      "Birsanagar SO": "831019",
      "Jadugoda Mines SO": "832102",
      "Jugsalai SO": "831006",
      "N M L SO": "831007",
      "Sonari SO East Singhbhum": "831011",
      "Telco GM Office SO": "831004",
      "Telco Plaza Market SO": "831004",
      "Pardih": "831020",
      "Baridih Colony SO": "831017",
      "Bistupur Bazar SO": "831001",
      "Chakulia SO": "832301",
      "Gobindpur Housing Colony SO": "831015",
      "Golmuri SO": "831003",
      "MGM Medical College SO": "831012",
      "Mosabani Mines SO": "832104",
      "Moubhandar SO": "832103",
      "Rahargora SO": "831016",
      "Boram SO": "832112",
      "Civil Court SO": "831001"
    }
  },
  "ODISHA": {
    "CUTTACK": {
      "Gopapur B.O": "754031",
      "Ichhapur B.O": "754295",
      "Jhajia B.O": "754031",
      "Jodumuhan B.O": "754031",
      "Mangarajpur B.O": "754028",
      "Sankarpur B.O": "754028",
      "Kayalpada B.O": "754027",
      "Mancheswar B.O": "754027",
      "Champeswar B.O": "754037",
      "Ekdal B.O": "754037",
      "Godibandha B.O": "754037",
      "Padamal B.O": "754037",
      "Karanji B.O": "754022",
      "Kairapari B.O": "754022",
      "Safa B.O": "754022",
      "Uchapada B.O": "754022",
      "Bhera B.O": "754290",
      "Chasakhanda B.O": "754290",
      "Khuntakata B.O": "754295",
      "Mugagahira B.O": "754031",
      "Dalijoda Berhampur B.O": "754028",
      "Gurudijhatia B.O": "754028",
      "Kakhadi B.O": "754027",
      "Adheigundi B.O": "754037",
      "Rusipada B.O": "754037",
      "Bainchuan B.O": "754022",
      "Bhatimunda B.O": "754022",
      "Ragadipada B.O": "754031",
      "Sankhameri B.O": "754031",
      "Sasang B.O": "754031",
      "Agrahat B.O": "754028",
      "Badasamantarapur B.O": "754028",
      "Chhagaon B.O": "754028",
      "Birol B.O": "754025",
      "Nakhara B.O": "754025",
      "Salagaon B.O": "754025",
      "Tilda B.O": "754290",
      "Karadibandha B.O": "754031",
      "Mahulia B.O": "754031",
      "Singhanathpitha B.O": "754031",
      "Gobara B.O": "754028",
      "Kumarpur B.O": "754028",
      "Dhurusia B.O": "754027",
      "Samsarpur B.O": "754295",
      "Harianta B.O": "754025",
      "Narpada B.O": "754025",
      "Balijhari B.O": "754037",
      "Ratapat B.O": "754037",
      "Sagar B.O": "754037",
      "Siaria B.O": "754037",
      "Bhagatpur B.O": "754022",
      "Garudagaon B.O": "754022",
      "Alara B.O": "754032",
      "Balisahi B.O": "754032",
      "O M P B.O": "753004",
      "SAMITANGA B.O": "754131",
      "NIMPUR B.O": "754021",
      "BODHAPUR B.O": "754130",
      "JASAPADA B.O": "754130",
      "PRAHARRAJPUR B.O": "754130",
      "Debabumi B.O": "754032",
      "Saradhapur B.O": "754032",
      "Kankadajodi B.O": "754035",
      "Bhimrajpur B.O": "754201",
      "Kukudanga B.O": "754201",
      "Odasingh B.O": "754201",
      "Badanauput B.O": "754030",
      "Viruda B.O": "754030",
      "Arakhapatna B.O": "754295",
      "Mahakalbasta B.O": "754295",
      "Gholapur B.O": "754295",
      "Bisnupur B.O": "754295",
      "Jenapada B.O": "754295",
      "Kadalibadi B.O": "754295",
      "Gopamathura B.O": "754031",
      "Kulailo B.O": "754295",
      "Oranda B.O": "754295",
      "Bali B.O": "754295",
      "Karikol B.O": "754295",
      "Tarading B.O": "754295",
      "Bhairapur B.O": "754200",
      "Satyabhamapur B.O": "754200",
      "Tentol B.O": "754200",
      "Bangirisingha B.O": "754031",
      "Dasarathipur B.O": "754031",
      "Megha B.O": "754295",
      "Radhakishorepur B.O": "754295",
      "Subarnapur B.O": "754295",
      "Sahangagopalpur B.O": "754295",
      "Gopinathpur B.O": "754200",
      "Mahasingpur B.O": "754200",
      "Kusupur B.O": "754205",
      "TARITO B.O": "754131",
      "TOTAPADA B.O": "754131",
      "ARILO B.O": "754130",
      "DAMODARPUR B.O": "754130",
      "Patapur B.O": "754008",
      "Beliapal B.O": "754031",
      "Gadapokhari B.O": "754031",
      "Bandhahuda B.O": "754032",
      "Nukhapada B.O": "754032",
      "Regeda B.O": "754032",
      "Abhimanpur B.O": "754035",
      "Jaripada B.O": "754201",
      "Ramakrishnapur B.O": "754201",
      "Achalkote B.O": "754030",
      "Bandalo B.O": "754030",
      "Puruna Tigiria B.O": "754030",
      "Lalitgiri B.O": "754205",
      "KHENTALO B.O": "754131",
      "PURUNAHAT SASAN B.O": "754131",
      "KOSIDA B.O": "754130",
      "Sipura B.O": "754205",
      "Khatbin Sahi B.O": "753008",
      "AYATPUR B.O": "754131",
      "BARDA B.O": "754131",
      "Phulpada B.O": "754032",
      "Nimasahi B.O": "754032",
      "Nuapatna B.O": "754032",
      "Lekhanpur B.O": "754201",
      "Malasasan B.O": "754201",
      "Mohana B.O": "754201",
      "Mohanpur B.O": "754201",
      "Jillinda B.O": "754032",
      "Jodumu B.O": "754032",
      "Kamaladiha B.O": "754032",
      "Kokalaba B.O": "754032",
      "Paikabarabati B.O": "754032",
      "Baunsput B.O": "754030",
      "Bindhanima B.O": "754030",
      "Gadadharpur B.O": "754030",
      "Panchagaon B.O": "754030",
      "Banki Tulasipur B.O": "754008",
      "Kandarai B.O": "754295",
      "Bentapada B.O": "754295",
      "Chakada B.O": "754295",
      "Dhaipur B.O": "754295",
      "Dorada B.O": "754295",
      "Bhatapada B.O": "754200",
      "Madhyakachha B.O": "754200",
      "Anlo B.O": "754010",
      "Uaradha B.O": "754010",
      "Mahajanpur B.O": "754200",
      "Padmapur B.O": "754200",
      "Badakambilo B.O": "754031",
      "Damangadia B.O": "754031",
      "Banamalipur B.O": "754031",
      "Brahmapura B.O": "754008",
      "Dhansarpatna  B.O": "754008",
      "Durgapur B.O": "754008",
      "Ghasiput B.O": "754008",
      "Bilipada B.O": "754008",
      "B Harirajpur B.O": "754008",
      "Narganga B.O": "754008",
      "Bidanasi B.O": "753014",
      "Nuagaon B.O": "754004",
      "Ragadi B.O": "754008",
      "Pathuriapada B.O": "754008",
      "B G P Pur B.O": "754005",
      "Belgachhia B.O": "754005",
      "Badamulei B.O": "754018",
      "Raipur Cuttack B.O": "754001",
      "Telengapentha B.O": "754001",
      "Sailo Jharpada B.O": "754003",
      "Noda B.O": "754105",
      "Uttaran B.O": "754105",
      "Kantapada B.O": "754002",
      "CHAMPATIPUR B.O": "754206",
      "GHANTALO B.O": "754209",
      "Govindpur Ramachandrapur B.O": "754007",
      "Gayalbanka B.O": "754007",
      "Puinchha B.O": "754009",
      "Pathapur B.O": "754007",
      "Kantakai B.O": "754009",
      "Krishnapallipatna B.O": "754009",
      "Rajib B.O": "754009",
      "KULASUKARAPADA B.O": "754209",
      "KUSUNPUR B.O": "754207",
      "TAROTASASAN B.O": "754209",
      "LENDURA B.O": "754203",
      "GOPINATHPUR B.O": "754203",
      "Mahidharpara B.O": "754001",
      "Bramhanda B.O": "754003",
      "Sadar Harianta B.O": "754003",
      "Eranch B.O": "754105",
      "Naraj B.O": "754006",
      "Bilasuni B.O": "754004",
      "Jallarpur B.O": "754004",
      "Madhab B.O": "754004",
      "Pahanga B.O": "754004",
      "GOKAN B.O": "754206",
      "BAGHUNI B.O": "754209",
      "HARIRAJPUR B.O": "754209",
      "KATIKATA B.O": "754209",
      "SUKARPADA B.O": "754209",
      "BHAKUDA B.O": "754204",
      "KUMUDAJAIPUR B.O": "754204",
      "MULABASANTA B.O": "754204",
      "Bhagabanpur B.O": "754293",
      "Orikanta B.O": "754293",
      "KHANDASAHI B.O": "754207",
      "NATKAI B.O": "754207",
      "SAHANIAJPUR B.O": "754207",
      "MANOHARPUR B.O": "754202",
      "SISUA B.O": "754202",
      "KOOD B.O": "754221",
      "Dulhanpur B.O": "754007",
      "Talabasta B.O": "754007",
      "Bania  B.O": "754009",
      "CHAYANPAL B.O": "754204",
      "DHARMADASPUR B.O": "754204",
      "KUHUNDA B.O": "754204",
      "NURTANGA B.O": "754204",
      "RAHANIA B.O": "754204",
      "MADHUPUR B.O": "754204",
      "Charirakaba B.O": "754293",
      "OSTAPUR B.O": "754207",
      "OLAKANA B.O": "754207",
      "HALADIA B.O": "754207",
      "BODAMUNDAI B.O": "754202",
      "CHHANIPUR B.O": "754202",
      "Sailo Badbail B.O": "754018",
      "Kothapatna B.O": "754001",
      "G.Nahalpur B.O": "754003",
      "Kulashree B.O": "754105",
      "Godisahi B.O": "754006",
      "Bagalsahi B.O": "754004",
      "Kapasi B.O": "754004",
      "Khandol B.O": "754002",
      "OSANGA B.O": "754206",
      "AGYANPUR B.O": "754209",
      "BASUDEVPUR B.O": "754204",
      "GOTARA B.O": "754207",
      "JHADESWARPUR B.O": "754207",
      "PITHAPARA B.O": "754207",
      "JIGNIPUR B.O": "754202",
      "PATAPUR B.O": "754202",
      "Kendupalli B.O": "754009",
      "Pandalam B.O": "754009",
      "Patasundarpur B.O": "754018",
      "Postal B.O": "754018",
      "Gobabasta B.O": "754001",
      "Banra B.O": "754006",
      "B B Garh B.O": "754004",
      "Karanga B.O": "754004",
      "Krushnaprasad B.O": "754004",
      "PODAMARAI B.O": "754206",
      "BODHANGA B.O": "754207",
      "GOPALPUR B.O": "754207",
      "GOUDAGOP B.O": "754207",
      "SUNAKHANDI B.O": "754202",
      "BADAGOTHA B.O": "754221",
      "BHIMDASPUR B.O": "754221",
      "Kuspangi B.O": "754007",
      "Padanpur B.O": "754007",
      "Annuary B.O": "754009",
      "Baideswar B.O": "754009",
      "Balabhadrapur B.O": "754009",
      "Jharkata B.O": "754112",
      "Paramahansa B.O": "754100",
      "Sidheswarpur B.O": "754100",
      "Sankhatras B.O": "753011",
      "Urali B.O": "753011",
      "Badabhuin B.O": "754295",
      "Kandarpur B.O": "754100",
      "PALLISAHI B.O": "754221",
      "SUKLESWAR B.O": "754221",
      "Kalapada B.O": "754112",
      "Sarichuan B.O": "754112",
      "Khalarda B.O": "753011",
      "KUSUMBI B.O": "754221",
      "MIRZAPUR B.O": "754221",
      "Bhanpur B.O": "753011",
      "Khandeita B.O": "753011",
      "PIKOL B.O": "754221",
      "Dadhibabanpur B.O": "754112",
      "Jhinkiria Berhampur B.O": "754112",
      "Fakirpada B.O": "754100",
      "Gatiroutpatna B.O": "754100",
      "Uttampur B.O": "753011",
      "Balarampur B.O": "754295",
      "Kusumandal Gopinathpur B.O": "754134",
      "Sirlonabagram B.O": "754132",
      "Babujang B.O": "754134",
      "Benirampur B.O": "754134",
      "Dharibil B.O": "754134",
      "Uttarkul B.O": "754134",
      "Gadijanga B.O": "754134",
      "Chandinchowk H.O": "753002",
      "Cuttack G.P.O.": "753001",
      "Athagarh H.O": "754029",
      "Rajendra Nagar S.O (Cuttack)": "753010",
      "Tulasipur S.O": "753008",
      "JAGATPUR S.O": "754021",
      "Sikharpur S.O": "753003",
      "KISHORENAGAR S.O": "754131",
      "NDC Cuttack": "753016",
      "Ravenshaw University S.O": "753003",
      "Shelter Chhak S.O": "753008",
      "SOMPUR S.O": "754130",
      "Adaspur S.O": "754011",
      "Bairoi S.O": "754010",
      "Binod Bihari S.O": "753002",
      "Govindpur S.O (Cuttack)": "754003",
      "Sector ll CDA, Cuttack S.O": "753015",
      "CISF Mundali S.O": "754013",
      "Chhatra Bazar S.O": "753003",
      "Gandhi Bhawan S.O (Cuttack)": "753001",
      "Jobra S.O": "753003",
      "Banki College S.O": "754008",
      "Kanika Rajbati S.O": "753008",
      "Madhupatna S.O": "753010",
      "Madhusudan Nagar S.O (Cuttack)": "753008",
      "Malgodown S.O": "753003",
      "Nimasahi S.O": "753001",
      "Pattapole S.O": "753001",
      "Barang S.O": "754005",
      "Prajatantra S.O": "753002",
      "KUANPAL S.O": "754204",
      "Lemalo S.O": "754293",
      "Sri Aurobinda Marg S.O": "753013",
      "Dompara S.O": "754007",
      "SALIPUR COLLEGE S.O": "754202",
      "SALIPUR S.O": "754202",
      "Bentakar S.O": "754112",
      "Biribati S.O": "754100",
      "Cantonment Road S.O": "753001",
      "Gopalpur S.O (Cuttack)": "753011",
      "Industrial Estate S.O (Cuttack)": "753010",
      "MAHANADI VIHAR S.O": "753003",
      "Kalyani Nagar S.O": "753013",
      "Kazibazar S.O": "753001",
      "Mangalabag S.O": "753001",
      "Nayabazar S.O (Cuttack)": "753004",
      "O G Press S.O": "753010",
      "Maniabandha S.O": "754034",
      "Avinab Bidanasi S.O": "753014",
      "Bramhansailo S.O": "754018",
      "Choudhury Bazar S.O": "753001",
      "Dagarpara S.O": "753002",
      "Kasarda S.O": "754105",
      "Niali S.O": "754004",
      "Swaraj Ashram S.O": "753002",
      "Telenga Bazar S.O": "753009",
      "KENDUPATNA S.O": "754203",
      "SUNGRA S.O": "754221",
      "NUAPALAMHAT S.O": "752120",
      "A D Market S.O": "753012",
      "Bajrakabari Road S.O": "753001",
      "College Square S.O (Cuttack)": "753003",
      "Dargha Bazar S.O": "753001",
      "O S E S.O": "753007",
      "Rameswar S.O": "754201",
      "Tigiria S.O": "754030",
      "Khuntuni S.O": "754297",
      "Banki S.O": "754008",
      "Kalapathar S.O": "754009",
      "Fulnakhara S.O": "754001",
      "Kafla S.O": "753002",
      "Orissa High Court S.O": "753002",
      "Mundali Colony S.O": "754006",
      "Rajabagicha S.O": "753009",
      "Sundargram S.O": "754002",
      "MAHANGA S.O": "754206",
      "ASURESWAR S.O": "754209",
      "NISCHINTAKOILI S.O": "754207",
      "C R R I S.O (Cuttack)": "753006",
      "Chauliaganj S.O": "753004",
      "Khannagar S.O": "753012",
      "Medical College S.O (Cuttack)": "753007",
      "Meria Bazar S.O": "753001",
      "KALARABANKA S.O": "754298",
      "Kanpur S.O": "754037",
      "Kapaleswar S.O": "754071",
      "Kotasahi S.O": "754022",
      "Narasinghpur S.O": "754032",
      "Nuapatna S.O": "754035",
      "Athagarh Bazar S.O": "754295",
      "Athagarh College S.O": "754029",
      "Charbatia S.O": "754028",
      "Choudwar S.O": "754025",
      "Daulatabad S.O (Cuttack)": "754026",
      "Bahugram S.O": "754200",
      "Barambagarh S.O": "754031",
      "Chasapara S.O": "754027",
      "Choudwar Bazar S.O": "754025",
      "Mouda S.O": "754290"
    },
    "BARGARH": {
      "KARANDOLA": "768033",
      "Kusanpuri B.O": "768029",
      "Lenda B.O": "768029",
      "Mahada B.O": "768029",
      "Jhikijhiki B.O": "768030",
      "Kanakbira B.O": "768030",
      "Kesaipali B.O": "768030",
      "Nilji B.O": "768030",
      "Nuagarh B.O": "768030",
      "Sakuda B.O": "768030",
      "Kudopali B.O": "768104",
      "Manpur B.O": "768104",
      "Papanga B.O": "768104",
      "Resam B.O": "768104",
      "Kumbho B.O": "768045",
      "Ruchida B.O": "768045",
      "Badbausen B.O": "768032",
      "CHARPALI": "768032",
      "GUNTHIAPALI": "768032",
      "Karlasantara B.O": "768052",
      "Dangabahal B.O": "768037",
      "Gourenmunda B.O": "768037",
      "Jagalpat B.O": "768037",
      "Kalangapali B.O": "768034",
      "Kuchipali B.O": "768034",
      "Ammthi B.O": "768042",
      "Bhainsadhara B.O": "768042",
      "Bhandarpuri B.O": "768042",
      "Jokhipali B.O": "768048",
      "Majhipali B.O": "768048",
      "BANIACHAL": "768048",
      "Chendeikela B.O": "768050",
      "Kundakhai B.O": "768035",
      "CHIKHILI": "768035",
      "Bartunda B.O": "768039",
      "Bhengrajpur B.O": "768039",
      "Bhubaneswarpur B.O": "768039",
      "Mithapali B.O": "768039",
      "Lakhamara B.O": "768036",
      "Mahulpali B.O": "768029",
      "Purena B.O": "768036",
      "Talmenda B.O": "768103",
      "Kumbhari B.O": "768029",
      "Nileswar B.O": "768029",
      "Remta B.O": "768029",
      "Bichuan B.O": "768030",
      "Gopalpur B.O": "768030",
      "Kharsal B.O": "768030",
      "Tejgola B.O": "768030",
      "Areigudi B.O": "768104",
      "Baramkela B.O": "768104",
      "Chichinda B.O": "768033",
      "Bhainatora B.O": "768045",
      "Kapasira B.O": "768045",
      "Pahandi B.O": "768032",
      "Saipali B.O": "768032",
      "Samalaipadar B.O": "768032",
      "Sirgida B.O": "768032",
      "Banjipali B.O": "768052",
      "KHOLA": "768052",
      "Jamutbahal B.O": "768037",
      "Saradhapali B.O": "768037",
      "Jharpali B.O": "768103",
      "Ganiapali B.O": "768049",
      "Sargibahal B.O": "768049",
      "Bilaspur B.O": "768042",
      "Dhaba B.O": "768042",
      "Jamseth B.O": "768050",
      "Diptipur B.O": "768035",
      "Palsada B.O": "768039",
      "KERMELABAHAL": "768039",
      "Badikata B.O": "768036",
      "Boden B.O": "768036",
      "Burkel B.O": "768036",
      "Sareikela B.O": "768036",
      "Bakti B.O": "768103",
      "Dekulba B.O": "768103",
      "Lupursingha B.O": "768103",
      "Bausenmura B.O": "768033",
      "Chhuriapali B.O": "768033",
      "Jatla B.O": "768033",
      "Satlama B.O": "768029",
      "Tulandi B.O": "768029",
      "Bhatli badmal B.O": "768030",
      "Ainlapali B.O": "768104",
      "Kubedega B.O": "768104",
      "Bandhapali B.O": "768032",
      "Jaring B.O": "768032",
      "Kharmunda B.O": "768032",
      "Pada B.O": "768032",
      "Tamdei B.O": "768052",
      "Uttam B.O": "768052",
      "Jamutpali B.O": "768037",
      "Petupali B.O": "768034",
      "Sanimal B.O": "768034",
      "Chandibhata B.O": "768042",
      "Gourmal B.O": "768042",
      "Guthuguda B.O": "768042",
      "Laudidhara B.O": "768042",
      "Shakti B.O": "768042",
      "Jhitiki B.O": "768050",
      "Chantipali B.O": "768035",
      "CHHETGAON": "768039",
      "Dahigaon B.O": "768036",
      "Dahita B.O": "768036",
      "Jagdalpur B.O": "768036",
      "K. Katabahal B.O": "768036",
      "Saplahar B.O": "768036",
      "Arjunda B.O": "768103",
      "Bhoipali B.O": "768103",
      "Burda B.O": "768103",
      "Jhilminda B.O": "768103",
      "Kuruan B.O": "768103",
      "Chakarkend B.O": "768033",
      "Garbhona B.O": "768033",
      "Govindpur B.O": "768033",
      "J. Sirgida B.O": "768033",
      "Kangaon B.O": "768033",
      "Lebidi B.O": "768033",
      "Patakulunda B.O": "768029",
      "TUMGAON": "768029",
      "Chadeigaon B.O": "768030",
      "Hatisar B.O": "768030",
      "Mulbar B.O": "768030",
      "Routpara B.O": "768030",
      "Sulsulia B.O": "768030",
      "Barapadar B.O": "768104",
      "Sunalarambha B.O": "768104",
      "Bara B.O": "768045",
      "Kandapala B.O": "768045",
      "Badapali B.O": "768032",
      "Patharla B.O": "768032",
      "Sarandapali B.O": "768032",
      "Dungri B.O": "768052",
      "Lakhanpur B.O": "768052",
      "Kathaumal B.O": "768037",
      "Birjam B.O": "768034",
      "Jhar B.O": "768034",
      "Talpadar B.O": "768034",
      "Phalsapali B.O": "768049",
      "Bijadhol B.O": "768042",
      "Guderpali B.O": "768035",
      "Salepali B.O": "768035",
      "Mondiadhipa B.O": "768039",
      "Temri B.O": "768039",
      "Bheunria B.O": "768036",
      "Budamal B.O": "768036",
      "Kansingha B.O": "768036",
      "Khaliapali B.O": "768036",
      "Talpali B.O": "768036",
      "Sankhirda B.O": "768103",
      "Talsirgida B.O": "768103",
      "Kadobahal B.O": "768102",
      "Tampersara B.O": "768102",
      "Deshbhatli B.O": "768102",
      "Kultatukura B.O": "768102",
      "Babebira B.O": "768027",
      "Banhar B.O": "768027",
      "Bugbuga B.O": "768027",
      "Tope B.O": "768027",
      "Dang B.O": "768038",
      "Deogaon B.O": "768038",
      "Gudesira B.O": "768038",
      "Birmal B.O": "768029",
      "Kainsir B.O": "768029",
      "Lachida B.O": "768027",
      "Larasara B.O": "768027",
      "Lastala B.O": "768027",
      "Paharsirgida B.O": "768027",
      "Banda B.O": "768038",
      "N. Jampali B.O": "768038",
      "Urduna B.O": "768038",
      "Agalpur B.O": "768029",
      "B. Tileimal B.O": "768029",
      "Behera B.O": "768029",
      "Janged B.O": "768027",
      "Kulunda B.O": "768027",
      "Manapada B.O": "768027",
      "B. Katapali B.O": "768038",
      "Banda kharmunda B.O": "768038",
      "Beherapali B.O": "768038",
      "Jamurda B.O": "768038",
      "Bagbadi B.O": "768029",
      "Bhatigaon B.O": "768029",
      "Kantapali barpali B.O": "768032",
      "Hirlipali B.O": "768027",
      "Janhapada B.O": "768027",
      "Saranda B.O": "768027",
      "Bargarh bargaon B.O": "768038",
      "Bhadigaon B.O": "768038",
      "Halupali B.O": "768038",
      "Kamgaon B.O": "768038",
      "Bijayapali B.O": "768029",
      "Gopeipali B.O": "768029",
      "Kebad B.O": "768029",
      "Dulampur B.O": "768111",
      "Rusuda B.O": "768115",
      "Sialkhandata B.O": "768115",
      "Sarkanda B.O": "768033",
      "Tabada B.O": "768033",
      "Barhaguda B.O": "768040",
      "Dhanger B.O": "768040",
      "Gaisama B.O": "768040",
      "Kalapani B.O": "768040",
      "Khandatha B.O": "768040",
      "Pandikipali B.O": "768033",
      "Rengali B.O": "768033",
      "Tungibandhali B.O": "768033",
      "Adagaon B.O": "768040",
      "Sarsara B.O": "768040",
      "Madhupur B.O": "768033",
      "Negimunda B.O": "768033",
      "Lahanda B.O": "768111",
      "Mahule B.O": "768115",
      "Kumelsingha B.O": "768111",
      "Silet B.O": "768111",
      "Panimura B.O": "768033",
      "Khuntapali B.O": "768040",
      "Bargarh H.O": "768028",
      "Bheden S.O": "768104",
      "Bhukta S.O": "768045",
      "Bijepur S.O": "768032",
      "Ghess S.O": "768034",
      "Bargarh Court S.O": "768028",
      "Dunguri Lsq Colony Campus S.O": "768052",
      "Gaisilet S.O": "768037",
      "Melchhamunda S.O": "768035",
      "Paikmal S.O": "768039",
      "Rajborasamber S.O": "768036",
      "Ambabhana S.O": "768031",
      "Attabira S.O": "768027",
      "Bhatli S.O": "768030",
      "Mandosil S.O": "768050",
      "Jamla S.O": "768049",
      "Jharbandh S.O": "768042",
      "Laumunda S.O": "768048",
      "Remunda S.O": "768103",
      "Bardol S.O (Bargarh)": "768038",
      "Bargarh Bazar S.O": "768028",
      "Barpali S.O": "768029",
      "Sohella S.O": "768033",
      "Tora S.O": "768040",
      "Renaglipali Canal  Colony  SO": "768053",
      "Gondturum S.O": "768115",
      "Larambha S.O": "768102",
      "Godbhaga S.O": "768111"
    },
    "DHENKANAL": {
      "Pabitranagar S.O": "759151",
      "Kantioputasahi B.O": "759026",
      "Kusumjodi B.O": "759026",
      "Kotagara B.O": "759026",
      "Kantiokateni B.O": "759026",
      "Rainrusinghpur B.O": "759026",
      "Khalibereni B.O": "759128",
      "Akhuapal B.O": "759146",
      "Gengutia B.O": "759013",
      "Kulei B.O": "759146",
      "Manikmara B.O": "759146",
      "Bamuan B.O": "759026",
      "Sanjapada B.O": "759128",
      "Gangijodi B.O": "759026",
      "Ichhabatipur B.O": "759026",
      "Kantapal B.O": "759028",
      "Saranga B.O": "759146",
      "Aluajharan B.O": "759026",
      "Sogar B.O": "759026",
      "Tumusinga B.O": "759026",
      "Dudurkote B.O": "759020",
      "Giridharaprasad B.O": "759020",
      "Hatura B.O": "759020",
      "Kalanda B.O": "759020",
      "Kamadhenukote B.O": "759015",
      "Kankadahad Sadar B.O": "759015",
      "Kottam B.O": "759015",
      "Mangalpur B.O": "759015",
      "Sarakpatana B.O": "759015",
      "Anantapur B.O": "759017",
      "Anlajhari B.O": "759017",
      "Balibo B.O": "759017",
      "Bhusal B.O": "759017",
      "Chandipal B.O": "759017",
      "Korian B.O": "759013",
      "Mahisapat B.O": "759013",
      "Balarampur B.O": "759025",
      "Siminai B.O": "759025",
      "Bidharpur B.O": "759016",
      "Kalunigoda B.O": "759016",
      "Kansara B.O": "759022",
      "Baunsapal B.O": "759018",
      "Bhagirathipur B.O": "759018",
      "Jayapurakateni B.O": "759018",
      "Muktapasi B.O": "759018",
      "Pipala B.O": "759018",
      "Samatangi B.O": "759018",
      "Saruali B.O": "759018",
      "Bam B.O": "759028",
      "Kantol B.O": "759028",
      "Kerjoli B.O": "759028",
      "Tariniposi B.O": "759028",
      "Kaluria B.O": "759014",
      "Mahapada B.O": "759014",
      "Bankual B.O": "759023",
      "Bhairpur B.O": "759023",
      "Anal B.O": "759024",
      "Baligoroda B.O": "759039",
      "Birasal B.O": "759039",
      "Jagannathpur B.O": "759039",
      "Krishnachandrapur B.O": "759020",
      "Thokar B.O": "759020",
      "Bhaliabolkateni B.O": "759015",
      "Chandrasekharaprasad B.O": "759015",
      "Dhirapatna B.O": "759015",
      "Ghatipiri B.O": "759015",
      "Rendapatana B.O": "759017",
      "Bajichowk B.O": "759013",
      "Bampa B.O": "759025",
      "Baulpur B.O": "759025",
      "Indipur B.O": "759025",
      "Kapilash B.O": "759016",
      "Kashipur B.O": "759016",
      "Mandar B.O": "759016",
      "Mathatentulia B.O": "759016",
      "Nihalprasad B.O": "759016",
      "Santhapur B.O": "759016",
      "Sorisiapada B.O": "759016",
      "Belatikiri B.O": "759027",
      "Gahamkhunti B.O": "759027",
      "Kaimati B.O": "759027",
      "Mahulapada B.O": "759027",
      "Bedapada B.O": "759019",
      "Chandpur B.O": "759019",
      "Dhalapur B.O": "759019",
      "Saanda B.O": "759019",
      "Batagaon B.O": "759018",
      "Badanagena B.O": "759014",
      "Banasingh B.O": "759014",
      "Chirulei B.O": "759014",
      "Neulpoi B.O": "759014",
      "Dighi B.O": "759023",
      "Gobinda Bidyadharpur B.O": "759023",
      "Gorodia B.O": "759023",
      "Khurusia B.O": "759023",
      "Beruanpal B.O": "759121",
      "Chintapokhari B.O": "759121",
      "Haladiabahal B.O": "759121",
      "Kamalanga B.O": "759121",
      "Bhejia B.O": "759029",
      "Chandapur B.O": "759029",
      "Damal B.O": "759120",
      "Kandarsinga B.O": "759120",
      "Kankadasoda B.O": "759120",
      "Kankili B.O": "759120",
      "Kantor B.O": "759120",
      "Khaliborei B.O": "759021",
      "Kunua B.O": "759021",
      "Nuabag B.O": "759021",
      "Baruan B.O": "759024",
      "Garh Nrusinghaprasad B.O": "759024",
      "Jamunakote B.O": "759024",
      "Kharagprasad B.O": "759121",
      "Kusupanga B.O": "759121",
      "Nimabahali B.O": "759121",
      "Ambapalas B.O": "759029",
      "Badakamar B.O": "759120",
      "Lodhani B.O": "759120",
      "Roda B.O": "759120",
      "Pitiri B.O": "759120",
      "Baisingha B.O": "759039",
      "Kanheipal B.O": "759039",
      "Makuakateni B.O": "759039",
      "Chitalpur B.O": "759020",
      "Karanda B.O": "759020",
      "Panchapada B.O": "759020",
      "Ranjagol B.O": "759020",
      "Govindprasad B.O": "759015",
      "Kalanga B.O": "759015",
      "Ekatali B.O": "759017",
      "Ramakrishnapur B.O": "759017",
      "Barada B.O": "759016",
      "Shankarpur B.O": "759013",
      "Belapada B.O": "759025",
      "Gundichapada B.O": "759025",
      "Kandabindha B.O": "759025",
      "Kasiadihi B.O": "759025",
      "Lauloi B.O": "759016",
      "Letheka B.O": "759016",
      "Nuagarh B.O": "759016",
      "Sadangi B.O": "759016",
      "Nadiali B.O": "759027",
      "Babandha B.O": "759019",
      "Bangursinga B.O": "759019",
      "Kumusi B.O": "759019",
      "Khajuria B.O": "759018",
      "Malapura B.O": "759018",
      "Bainsia B.O": "759014",
      "Kendupada B.O": "759014",
      "Khankar B.O": "759014",
      "Radhadeipur B.O": "759014",
      "Guneibil B.O": "759023",
      "Jineilo B.O": "759023",
      "Odisha B.O": "759024",
      "Bido B.O": "759121",
      "Kadala B.O": "759121",
      "Kankalu B.O": "759121",
      "Patala B.O": "759121",
      "Basoi B.O": "759120",
      "Biribolei B.O": "759029",
      "Dashipur B.O": "759029",
      "Ghagarmunda B.O": "759029",
      "Kuturia B.O": "759029",
      "Mundeilo B.O": "759120",
      "Chhotapada B.O": "759021",
      "Kalingapal B.O": "759021",
      "Khatakhura B.O": "759039",
      "Maruabil B.O": "759039",
      "Raibol B.O": "759039",
      "Badalo B.O": "759020",
      "Kakudibhag B.O": "759015",
      "Kalikaprasad B.O": "759015",
      "Dhalapada B.O": "759017",
      "Mahulapal B.O": "759017",
      "Chaulia B.O": "759013",
      "Kankadpal B.O": "759013",
      "Saptasajya B.O": "759013",
      "Tarava B.O": "759013",
      "Brahmaniapal B.O": "759025",
      "Gunadei B.O": "759025",
      "Sadasivapur B.O": "759025",
      "Khankira B.O": "759016",
      "Pingua B.O": "759016",
      "Raitala B.O": "759016",
      "Baladiabandha B.O": "759027",
      "Manipur B.O": "759027",
      "Talabarkote B.O": "759027",
      "Balaramprasad B.O": "759019",
      "Nadhara B.O": "759019",
      "Baunsapokhari B.O": "759022",
      "Kamarda B.O": "759018",
      "Kanapura B.O": "759018",
      "Mahulpal B.O": "759018",
      "Motta B.O": "759018",
      "Sibulapasi B.O": "759018",
      "Kandhara B.O": "759028",
      "Karagola B.O": "759028",
      "Kabera Madhapur B.O": "759014",
      "Karamul B.O": "759014",
      "Jiral B.O": "759023",
      "Surapratapapur B.O": "759024",
      "Kantimili B.O": "759121",
      "Paikapurunakote B.O": "759121",
      "Sibapur B.O": "759121",
      "Badajhara B.O": "759120",
      "Barihapur B.O": "759120",
      "Garh Palasuni B.O": "759029",
      "Jhili B.O": "759029",
      "Kuanlo B.O": "759120",
      "Pangatira B.O": "759029",
      "Patamandir B.O": "759120",
      "Buhalipal B.O": "759021",
      "Gandanali B.O": "759021",
      "Dhenkanal H.O": "759001",
      "Angul H.O": "759122",
      "Igit Sarang S.O": "759146",
      "Badasuanlo S.O": "759039",
      "Bhuban S.O": "759017",
      "Hindol Road R.S. S.O": "759019",
      "Jubuli Town S.O": "759001",
      "Kamakhyanagar S.O": "759018",
      "Meramandali S.O": "759121",
      "Anlabereni S.O": "759026",
      "Balimi S.O": "759020",
      "Dhenkanal R S S.O": "759013",
      "Gadasila S.O": "759025",
      "Govindpur S.O (Dhenkanal)": "759027",
      "Hindol S.O": "759022",
      "Mahimagadi S.O": "759014",
      "Mathakargola S.O": "759024",
      "Bhapur S.O (Dhenkanal)": "759015",
      "Kankadahad S.O": "759028",
      "Rasol S.O": "759021",
      "Dhenkanal College S.O": "759001",
      "Gondiapatna S.O": "759016",
      "Marthapur S.O": "759023",
      "Parjang S.O": "759120",
      "Mahabirod S.O": "759029"
    },
    "ANUGUL": {
      "Gadasila B.O": "759147",
      "Gurujanguli B.O": "759101",
      "Thakurgarh B.O": "759125",
      "Gotamara B.O": "759128",
      "Kalandapal B.O": "759128",
      "Garh Taras B.O": "759129",
      "Hamamira B.O": "759129",
      "Khinda B.O": "759129",
      "Kumursinga B.O": "759129",
      "Nuakheta B.O": "759129",
      "Kukurpeta B.O": "759124",
      "Machhakuta B.O": "759124",
      "Podapada B.O": "759124",
      "Ghantapada B.O": "759103",
      "Gobara B.O": "759103",
      "Gopalprasad B.O": "759103",
      "Padmabatipur B.O": "759103",
      "Solada B.O": "759103",
      "Badkerjang B.O": "759143",
      "Golabandha B.O": "759143",
      "Ankula B.O": "759132",
      "Balanga B.O": "759132",
      "Saradhapur B.O": "759100",
      "Tikarapada B.O": "759132",
      "Rainali B.O": "759125",
      "Basantapur B.O": "759141",
      "Balaramprasad B.O": "759128",
      "Budhapanka B.O": "759128",
      "Baragounia B.O": "759129",
      "Bedasasan B.O": "759129",
      "Sankapur B.O": "759129",
      "Kusakila B.O": "759124",
      "Kumunda B.O": "759103",
      "Tentulei B.O": "759103",
      "Kumanda B.O": "759143",
      "Jagannathpur B.O": "759104",
      "Karadagadia B.O": "759132",
      "Paratara B.O": "759132",
      "Purunakote B.O": "759132",
      "Kansamunda B.O": "759117",
      "Nalam B.O": "759117",
      "Odasha B.O": "759118",
      "Sankhamur B.O": "759118",
      "Jarada B.O": "759117",
      "Kanteikolia B.O": "759127",
      "Kothabhuin B.O": "759127",
      "Pedipathar B.O": "759127",
      "Tapdhol B.O": "759127",
      "Ugi B.O": "759127",
      "Nisha B.O": "759130",
      "Santarabandha B.O": "759130",
      "Kukudang B.O": "759123",
      "Natada B.O": "759123",
      "Dimiria B.O": "759119",
      "Phapanda B.O": "759119",
      "Iswarnagar B.O": "759119",
      "Himitira B.O": "759126",
      "Raniakata B.O": "759126",
      "Kuluma B.O": "759105",
      "Arkil B.O": "759100",
      "Burukuna B.O": "759100",
      "Kankili B.O": "759100",
      "Parabil B.O": "759100",
      "Tubey B.O": "759132",
      "Badatribida B.O": "759117",
      "Derang B.O": "759117",
      "Sanatribida B.O": "759117",
      "Dalak B.O": "759117",
      "Hanumanpur B.O": "759117",
      "Durgapur B.O": "759100",
      "Katada B.O": "759127",
      "Luhamunda B.O": "759127",
      "Papsara B.O": "759127",
      "Kulad B.O": "759145",
      "Sakasingha B.O": "759123",
      "Turang B.O": "759123",
      "RANIGODA BO": "759123",
      "Khemla B.O": "759119",
      "Sahara Gurjang B.O": "759119",
      "Saida B.O": "759119",
      "Ambapal B.O": "759126",
      "Angapada B.O": "759126",
      "Kalyanpur B.O": "759126",
      "Bajrakote B.O": "759105",
      "Balipasi B.O": "759105",
      "Ekagharia B.O": "759100",
      "Gaham B.O": "759100",
      "Gurujang B.O": "759100",
      "Kandhalo B.O": "759100",
      "Puruna Manitiri B.O": "759125",
      "Sanahulla B.O": "759125",
      "Barasahi B.O": "759141",
      "Bonda B.O": "759128",
      "Garh Santiri B.O": "759128",
      "Nuahata B.O": "759128",
      "Basala B.O": "759129",
      "Dhokuta B.O": "759129",
      "Inkarabandha B.O": "759129",
      "Manapur B.O": "759129",
      "Pokatunga B.O": "759129",
      "Talagarh B.O": "759129",
      "Balipatta B.O": "759124",
      "Nuapada B.O": "759124",
      "Tentuloi B.O": "759124",
      "Bhejigotha B.O": "759125",
      "Bileinali B.O": "759125",
      "Paiksahi B.O": "759125",
      "Kantapada B.O": "759125",
      "Lunahandi B.O": "759125",
      "Madhapur B.O": "759125",
      "Maimura B.O": "759125",
      "Kanaloi B.O": "759141",
      "Nuagaon B.O": "759141",
      "Patakumunda B.O": "759141",
      "Patrapada B.O": "759141",
      "Pipalabahal B.O": "759141",
      "Sapoinali B.O": "759141",
      "Tangiri B.O": "759141",
      "Arahat B.O": "759128",
      "Badakhali B.O": "759128",
      "Tulasipal B.O": "759128",
      "Badakantakul B.O": "759129",
      "Balasinga B.O": "759129",
      "Baluakata B.O": "759129",
      "Ballahar Chhak B.O": "759104",
      "Santhapada B.O": "759104",
      "Hensamul B.O": "759103",
      "Kalamchhuin B.O": "759103",
      "Kangula B.O": "759132",
      "Khalari B.O": "759132",
      "Khandahatta B.O": "759132",
      "Nandapur B.O": "759132",
      "Badasada B.O": "759118",
      "Barkotia B.O": "759118",
      "Injidi B.O": "759118",
      "Kunjam B.O": "759118",
      "Bimalabeda B.O": "759127",
      "Dandasinga B.O": "759127",
      "Para B.O": "759127",
      "Brahmanbil B.O": "759130",
      "Changudia B.O": "759130",
      "Kurudol B.O": "759123",
      "Chasagurjang B.O": "759119",
      "Jamardihi B.O": "759119",
      "Jharabeda B.O": "759119",
      "Seegarh B.O": "759119",
      "Siarimalia B.O": "759119",
      "Kiakata B.O": "759126",
      "Nakchi B.O": "759126",
      "Oskapalli B.O": "759126",
      "Sanjamura B.O": "759126",
      "Tusar B.O": "759126",
      "Rengali B.O": "759105",
      "Susuba B.O": "759105",
      "Samal B.O": "759100",
      "Seepur B.O": "759100",
      "Talcher R.S. B.O": "759100",
      "Badajarada B.O": "759103",
      "Danra B.O": "759103",
      "Karnapur B.O": "759103",
      "Jarasingha B.O": "759143",
      "Parang B.O": "759143",
      "Badakera B.O": "759132",
      "Champatimunda B.O": "759132",
      "Purunagarh B.O": "759132",
      "Rantalei B.O": "759132",
      "Badagundari B.O": "759117",
      "Bijigol B.O": "759117",
      "Kakudia B.O": "759117",
      "Poipal B.O": "759117",
      "Munduribeda B.O": "759118",
      "Rajdang B.O": "759118",
      "Handapa B.O": "759127",
      "Jarapada B.O": "759127",
      "Jeranga Dehuri Sahi B.O": "759127",
      "Korada B.O": "759127",
      "Tainsi B.O": "759127",
      "Tukuda B.O": "759127",
      "Kampsala B.O": "759130",
      "Raijharan B.O": "759130",
      "Kandasar B.O": "759145",
      "Kuio B.O": "759123",
      "Bandhabhuin B.O": "759119",
      "Karadapal B.O": "759119",
      "Nagira B.O": "759119",
      "Baradiha B.O": "759119",
      "Bamur B.O": "759126",
      "Ghosar B.O": "759126",
      "Kadalimunda B.O": "759126",
      "Urukela B.O": "759126",
      "Gandamala B.O": "759105",
      "Podagarh B.O": "759105",
      "Biru B.O": "759100",
      "Dharampur B.O": "759100",
      "Handidhua B.O": "759100",
      "Kantiapasi B.O": "759100",
      "Radharamanpur B.O": "759100",
      "Jamudoli B.O": "759125",
      "Kampala B.O": "759125",
      "Kandhapada B.O": "759125",
      "Nagaon B.O": "759125",
      "Krutibaspur B.O": "759125",
      "Kudugaon B.O": "759125",
      "Luhasinga B.O": "759125",
      "Ambasarmunda B.O": "759125",
      "Aida B.O": "759125",
      "Maidharpur B.O": "759022",
      "Phulapada B.O": "759022",
      "Bagedia S.O": "759141",
      "Chhendipada S.O": "759124",
      "Dera S.O": "759103",
      "Deulbera Colliery S.O": "759102",
      "Hakimpada S.O": "759143",
      "Jindal Nagar S.O": "759111",
      "Kaniha S.O": "759117",
      "Khamar S.O": "759118",
      "Samal Barrage Township S.O": "759037",
      "JARAPADA S.O": "759149",
      "Balanda S.O": "759116",
      "Chainpal Colony S.O": "759104",
      "Kosala S.O": "759130",
      "Pallahara S.O": "759119",
      "Rajkishorenagar S.O": "759126",
      "Angul Bazar S.O": "759122",
      "Athamallik S.O": "759125",
      "Deepasikha S.O": "759147",
      "Kishoreganj S.O": "759127",
      "Talcher Town S.O": "759107",
      "Vikrampur S.O": "759106",
      "Talmul S.O": "759040",
      "Banarpal S.O": "759128",
      "Bantala S.O": "759129",
      "Hulurisinga S.O": "759132",
      "Nalconagar S.O": "759145",
      "Nehru Satabdi Nagar(Bharatpu) S.O": "759148",
      "P.T.C.,Angul S.O": "759123",
      "Rengali Dam Site S.O": "759105",
      "Talcher S.O": "759100",
      "Talcher Thermal S.O": "759101"
    },
    "JAJAPUR": {
      "Bandalo B.O": "754023",
      "Arakhpur B.O": "754296",
      "Bantala B.O": "754024",
      "Chasakhanda B.O": "755013",
      "Chhatrapara B.O": "755013",
      "Kuanlo B.O": "755013",
      "GobindpurSidhagiri B.O": "754023",
      "Kaitha B.O": "754023",
      "Sakuntalapur B.O": "754296",
      "Masudpur B.O": "755043",
      "Bamdevpur B.O": "755014",
      "Barikul B.O": "755014",
      "Katikata B.O": "755014",
      "Kuanrapur B.O": "755014",
      "SALAPADA B.O": "754082",
      "Samsarpur B.O": "754023",
      "Bidyadharpur B.O": "754296",
      "Koudikol B.O": "754296",
      "Hatsahi B.O": "755043",
      "Malapara B.O": "755043",
      "Aunri B.O": "755013",
      "Nehapara B.O": "755014",
      "Uttangara B.O": "755014",
      "Bada Damodarpur B.O": "755016",
      "Namtara B.O": "755016",
      "Olei Chandanpur B.O": "755016",
      "Bhurunga B.O": "755017",
      "Udaypur B.O": "755017",
      "Amploba B.O": "755018",
      "Kuhika B.O": "755018",
      "Lembo B.O": "755018",
      "Achyut Basant B.O": "754205",
      "Barada Cuttack B.O": "754205",
      "Raipur B.O": "754292",
      "Narangochha B.O": "755036",
      "Brahamanigaon B.O": "755027",
      "Guhali B.O": "755027",
      "Bari Kalamatia B.O": "755003",
      "Ramachandrapur B.O": "755003",
      "Dulakhapatna B.O": "755025",
      "Ranigoda B.O": "755025",
      "Tulasipur B.O": "755025",
      "Ratalang B.O": "755004",
      "Deoda B.O": "755005",
      "Haripur B.O": "755005",
      "Bandhamunda B.O": "755062",
      "Sridharpur B.O": "755062",
      "Duburi B.O": "755026",
      "Ollalo B.O": "755026",
      "Pingal B.O": "755026",
      "Jahanpur B.O": "755007",
      "Kodandpur B.O": "755007",
      "Banamalipur B.O": "755008",
      "Kadampal B.O": "755008",
      "Mirzapur B.O": "755008",
      "Oddisso Andeigoda B.O": "755008",
      "Aruha B.O": "755024",
      "Andhari B.O": "755019",
      "Janha B.O": "755019",
      "Patranga B.O": "755019",
      "Ragadi B.O": "755019",
      "Balarampur Talagada B.O": "755023",
      "Endal B.O": "755023",
      "Purunabaulamal B.O": "755023",
      "Sarada Mukundapur B.O": "755023",
      "Kutchery Gaon B.O": "755009",
      "Mangarajpur B.O": "755009",
      "Samantarapur B.O": "755009",
      "Sherpur B.O": "755010",
      "Ransol B.O": "755028",
      "Kantar B.O": "755022",
      "Ramakrishnapur B.O": "755022",
      "Tulati B.O": "755022",
      "Kanikapara B.O": "755011",
      "Khannagar B.O": "755011",
      "Bachhalo B.O": "755012",
      "Banshipur B.O": "755012",
      "Kalyanpur B.O": "755012",
      "Bhubaneswarpur B.O": "755043",
      "BARUNIA B.O": "754082",
      "Kalakala B.O": "754082",
      "BAJAPURA B.O": "754023",
      "Rudrapur B.O": "755005",
      "Barithengada B.O": "754024",
      "Chandital B.O": "754024",
      "Bhuinpur B.O": "755043",
      "Kamagarh B.O": "755043",
      "Rurhiya B.O": "755043",
      "Alakundanuagaon B.O": "755013",
      "Biripatta B.O": "755013",
      "Dolagram Damodarpur B.O": "755013",
      "Uttarkulhat B.O": "755013",
      "Udranga B.O": "755014",
      "Abdalpur B.O": "755016",
      "Bangra B.O": "755016",
      "Chhatisdebil B.O": "755017",
      "Hasinpur B.O": "755017",
      "Kankadapal B.O": "755018",
      "Mangalpur B.O": "755018",
      "Sansailo B.O": "755018",
      "Chandia B.O": "754292",
      "Kalashree Gopalpur B.O": "754292",
      "Ardaulia B.O": "755036",
      "Kamalpur B.O": "755036",
      "Bodua B.O": "755027",
      "Kumbhuka B.O": "755027",
      "Dharpur B.O": "755003",
      "Sahupara B.O": "755003",
      "Angalo B.O": "755004",
      "Talabandha B.O": "755004",
      "Golkunda B.O": "755005",
      "Isanpur B.O": "755005",
      "Darpanigarh B.O": "755044",
      "Jharanga B.O": "755062",
      "KHANDARA B.O": "755062",
      "Kalinga Nagar B.O": "755026",
      "Jakhapura B.O": "755026",
      "Pankapal Sasan B.O": "755026",
      "Khosalpur B.O": "755006",
      "Merdakatia Chhak B.O": "755006",
      "Haladidiha B.O": "755016",
      "Hatasahi Kutchery B.O": "755016",
      "Jari B.O": "755016",
      "Kujhalo B.O": "755017",
      "M.D.Jemapur B.O": "755017",
      "Haripur Jemadeipur B.O": "755018",
      "Hatibari B.O": "755018",
      "Nalipur B.O": "754205",
      "Baniapal B.O": "755027",
      "Sasanda B.O": "755027",
      "Sayedpur B.O": "755027",
      "Nathapur B.O": "755003",
      "Rajapur B.O": "755003",
      "Gopalpur Taranda B.O": "755025",
      "Mukundapur B.O": "755025",
      "Tarakote B.O": "755025",
      "Angalo Madhusudanpur B.O": "755004",
      "Barapada B.O": "755004",
      "Kantipur B.O": "755004",
      "Kapila B.O": "755004",
      "Abhimanyu Balia B.O": "755005",
      "Arabal B.O": "755005",
      "Bandhadihi B.O": "755005",
      "Mirchandpur B.O": "755062",
      "Rahasoi B.O": "755062",
      "Manitira B.O": "755026",
      "Nadiabhanga B.O": "755026",
      "Ranagundi B.O": "755026",
      "Salijanga B.O": "755026",
      "Jayantara B.O": "755006",
      "Aranga Purusottampur B.O": "755007",
      "Badabiruan B.O": "755015",
      "Laxminagar B.O": "755015",
      "Pahanga B.O": "755015",
      "Sribantapur B.O": "755015",
      "Bainsiria B.O": "755017",
      "Erabanka B.O": "755017",
      "Atta B.O": "755018",
      "Damodarpur B.O": "755018",
      "Palei B.O": "754205",
      "Saudia B.O": "754292",
      "Ratnagiri B.O": "754214",
      "Barchana B.O": "754296",
      "Mallikapur B.O": "755036",
      "Mohantypatna B.O": "755036",
      "Balibili B.O": "755003",
      "Mandari B.O": "755003",
      "Meduakul B.O": "755003",
      "Janakanalkul B.O": "755005",
      "Janapada B.O": "755005",
      "Jhalpada B.O": "755005",
      "Kakudikuda B.O": "755005",
      "Siha B.O": "755044",
      "Kapasichhaka B.O": "755062",
      "Markandapur B.O": "755062",
      "Gobarghati B.O": "755026",
      "Khurunti B.O": "755026",
      "Kumbhiragadia B.O": "755026",
      "Nandipur B.O": "755006",
      "Pubasahi B.O": "755006",
      "Lalbag B.O": "755007",
      "Nakhei B.O": "755007",
      "Nathsahi B.O": "755007",
      "Simulia B.O": "755007",
      "Naguan B.O": "755019",
      "Pachhikote B.O": "755019",
      "Baidyarajpur B.O": "755007",
      "Kaima B.O": "755008",
      "Kalan B.O": "755008",
      "Kotapur B.O": "755008",
      "Kundapatna B.O": "755008",
      "Prathamakhandi B.O": "755008",
      "Singhapur B.O": "755008",
      "Chitri Gobardhanpur B.O": "755019",
      "Dala B.O": "755019",
      "Dankarisahi B.O": "755019",
      "Gobardhanpur B.O": "755019",
      "Taharpur B.O": "755019",
      "Patuli B.O": "755019",
      "Antia B.O": "755023",
      "Badabanta B.O": "755009",
      "Bahdalpur B.O": "755009",
      "Derakundi B.O": "755051",
      "Haripur Hat B.O": "755009",
      "Votka B.O": "755051",
      "Kaliapani B.O": "755028",
      "Kansa B.O": "755028",
      "Dhaneswar B.O": "755022",
      "Palatpur B.O": "755011",
      "Paripada Nizampur B.O": "755011",
      "Sanakuanlo B.O": "755011",
      "Balamukulihat B.O": "755012",
      "Taranga Sagarpur B.O": "755006",
      "Khairabad B.O": "755007",
      "Areikana B.O": "755008",
      "Barabati B.O": "755008",
      "Nahangapatna B.O": "755008",
      "Neulpur B.O": "755024",
      "Thannual B.O": "755024",
      "Aswasthapal B.O": "755019",
      "Kiajhar B.O": "755019",
      "Nachhipura B.O": "755019",
      "Rachhipur B.O": "755019",
      "Ranipada B.O": "755019",
      "Batijoda B.O": "755023",
      "Garhmadhupur B.O": "755023",
      "Marjitpur B.O": "755023",
      "Rekhideipur B.O": "755023",
      "Adampur B.O": "755051",
      "Khanditar B.O": "755051",
      "Madhubanhat B.O": "755051",
      "Rakabi Bazar B.O": "755009",
      "Sadanandapur B.O": "755051",
      "Purbakote B.O": "755022",
      "Kamardihi B.O": "755011",
      "Kayan B.O": "755011",
      "Fatehpur B.O": "755012",
      "Ranpur B.O": "755012",
      "Jabara B.O": "755015",
      "Kabatabandha B.O": "755023",
      "Madhusudanpur B.O": "755023",
      "Mahisara B.O": "755023",
      "Mugupal B.O": "755009",
      "Rajendrapur B.O": "755009",
      "Anikana B.O": "755010",
      "Chingudipal B.O": "755028",
      "Khadianga B.O": "755049",
      "Krushnapur Sasan B.O": "755049",
      "Dhanipur B.O": "755011",
      "Dubakana B.O": "755011",
      "Iswarpur B.O": "755011",
      "Tina B.O": "755012",
      "Beruda B.O": "755043",
      "Uchaabali B.O": "758025",
      "Bangarkota B.O": "758025",
      "Jajpur H.O": "755001",
      "Ankula S.O": "755001",
      "Bari Cuttack S.O": "755003",
      "Dharmasala S.O": "755008",
      "Ferro Chrome Project S.O": "755020",
      "Jenapur S.O": "755023",
      "Kalaringatta S.O": "755028",
      "Kantigadia S.O": "755049",
      "Mangalpur S.O (Jajapur)": "755011",
      "Sankhachilla S.O": "755015",
      "Singhpur S.O (Jajapur)": "755016",
      "Sobra S.O": "755019",
      "Sujanpur S.O (Jajapur)": "755017",
      "Brahmabarada S.O": "755005",
      "Dangadi S.O": "755026",
      "Debidwar S.O": "755007",
      "Jajpur Bazar S.O": "755001",
      "Jajpur Road RS S.O": "755019",
      "Jaraka S.O": "755050",
      "Rambag S.O": "755014",
      "Rasulpur S.O": "755051",
      "Barundai S.O": "755025",
      "Chitalo S.O": "755062",
      "Kabirpur S.O": "755009",
      "Korei S.O": "755022",
      "Panikoili S.O": "755043",
      "Sukinda S.O": "755018",
      "Balichandrapur S.O": "754205",
      "Charinangal S.O": "754292",
      "Ahiyas S.O": "755036",
      "Arei S.O": "755027",
      "Binjharpur S.O": "755004",
      "Chandikhol S.O": "755044",
      "Dasarathpur S.O": "755006",
      "Dolipur S.O": "755019",
      "Haridaspur S.O": "755024",
      "Jajpur College S.O": "755001",
      "Kaipara S.O": "755010",
      "Mashra S.O": "755012",
      "Pritipur S.O": "755013",
      "SUNGUDA S.O": "754296",
      "BYREE S.O": "754082",
      "Dhanmandal S.O": "754024",
      "CHHATIA S.O": "754023"
    },
    "KENDRAPARA": {
      "Deulatara B.O": "755016",
      "Damarpur B.O": "754217",
      "Srirampalpatna B.O": "754217",
      "Dasipur B.O": "754219",
      "Podamarai Alakana B.O": "754219",
      "Sansidha Mangarajpur B.O": "754218",
      "Padmapur B.O": "754253",
      "Kalaspur B.O": "754239",
      "Baghilo Bamanpur B.O": "754208",
      "Bhagabatpur B.O": "754208",
      "Janhimula B.O": "754208",
      "Benipur B.O": "754292",
      "Kadaliban B.O": "754222",
      "Gogua B.O": "754222",
      "Penthapal B.O": "754240",
      "Chanchol B.O": "754210",
      "Mahal B.O": "754210",
      "Sorisia B.O": "754210",
      "Jagulaipara B.O": "754220",
      "Nuahat B.O": "754289",
      "Aliabad B.O": "754214",
      "Baragaon Mahakalpara B.O": "754214",
      "Kutranga B.O": "754214",
      "Rout Sahi B.O": "754214",
      "Dangamal B.O": "754248",
      "Talachua B.O": "754248",
      "Yunus Nagar B.O": "754248",
      "Bachharai B.O": "754244",
      "Mahendinagar B.O": "754244",
      "Sana Jaria B.O": "754216",
      "Chakroda B.O": "754223",
      "Bharatpur B.O": "754223",
      "Purusottampur B.O": "754212",
      "Bhatapada [r] B.O": "754246",
      "Keradagada B.O": "754246",
      "Barakanda B.O": "754224",
      "Gojabandha B.O": "754224",
      "Karanja B.O": "754224",
      "Kiarbanka B.O": "754224",
      "Maliancha B.O": "754224",
      "Ashram Balikuda B.O": "754213",
      "Jadupur B.O": "754213",
      "Sasanipada B.O": "754213",
      "Talasanga B.O": "754213",
      "Areikana B.O": "754231",
      "Baruna B.O": "754227",
      "Manapur B.O": "754227",
      "Ainipara B.O": "754215",
      "Aragal B.O": "755061",
      "Erdang Natra B.O": "755061",
      "Beltal B.O": "754215",
      "Bilikana (Gopalpur) B.O": "754215",
      "Patrapur B.O": "754215",
      "Sahira B.O": "754215",
      "Sikudi B.O": "754220",
      "Taras B.O": "754220",
      "Badanaukana B.O": "754225",
      "Dera B.O": "754225",
      "Gopalpur Rajnagar B.O": "754225",
      "Junapangara B.O": "754225",
      "Alailo B.O": "754212",
      "Anduli B.O": "754212",
      "Deulipara B.O": "754212",
      "Kalapara B.O": "754212",
      "Nembra B.O": "754212",
      "Kusiapal B.O": "754250",
      "Kasananta B.O": "754215",
      "Manikapatna B.O": "754215",
      "Singiri B.O": "754215",
      "Bharigada B.O": "754220",
      "Giria B.O": "754220",
      "Jaynagar B.O": "754220",
      "Katna B.O": "754220",
      "Siko B.O": "754220",
      "Bhitaragarh B.O": "754225",
      "Gupti B.O": "754225",
      "Kandira B.O": "754225",
      "Satabhaya B.O": "754225",
      "Angulai B.O": "754212",
      "Balipal B.O": "754212",
      "Rajgarh B.O": "754212",
      "Belarpur B.O": "754250",
      "Gopaljewpatna B.O": "754250",
      "Gulnagar B.O": "754250",
      "Panasudha B.O": "754250",
      "Pandiri B.O": "754250",
      "Jamdhar B.O": "754250",
      "Bira Nilakanthapur B.O": "754250",
      "Kapaleswar B.O": "754250",
      "Chandan Nagar B.O": "754217",
      "Dosia B.O": "754217",
      "Terohi B.O": "754217",
      "Mendhapur B.O": "754219",
      "Nihala B.O": "754219",
      "Baluria B.O": "754218",
      "Sanamanga B.O": "754218",
      "Padanipal B.O": "754239",
      "Jahangar B.O": "754208",
      "Basupur B.O": "754222",
      "Kora B.O": "754222",
      "Andara B.O": "754240",
      "Pakhyat B.O": "754210",
      "Chatrachakada B.O": "754289",
      "Laxminarayanpur B.O": "754289",
      "Amathpur B.O": "754214",
      "Chhoti B.O": "754214",
      "Malapatna B.O": "754215",
      "Narsinghpur Dihasahi B.O": "754215",
      "Badamulabasanta B.O": "754215",
      "Khadianta B.O": "754215",
      "Achyutpur B.O": "754220",
      "Barunadiha B.O": "754220",
      "Dalikainda B.O": "754220",
      "Koilipur B.O": "754246",
      "Pimpudi B.O": "754220",
      "Kurunti B.O": "754225",
      "Ayaba B.O": "754212",
      "Bagada B.O": "754212",
      "Thauri B.O": "754212",
      "Barua B.O": "754250",
      "Fakirabad B.O": "754250",
      "Tilotamadeipur B.O": "754250",
      "Nikirai B.O": "754214",
      "Manjulapalli B.O": "754248",
      "Rangani B.O": "754248",
      "Pentha B.O": "754244",
      "Jigiran B.O": "754216",
      "Aitipur B.O": "754223",
      "Kantia B.O": "754223",
      "Bandhapatna B.O": "754246",
      "Jagannathpur Sasan B.O": "754246",
      "Baradanga B.O": "754224",
      "Kansar Badadandua B.O": "754224",
      "Kharinasi B.O": "754224",
      "Kochila B.O": "754224",
      "Nantar B.O": "754224",
      "Naupada B.O": "754213",
      "Pikarali B.O": "754213",
      "Silipur B.O": "754213",
      "Mahu B.O": "754231",
      "Chhadesh B.O": "754227",
      "Nuagaon B.O": "754227",
      "Pundalo B.O": "754228",
      "Amber B.O": "754215",
      "Mohanpur B.O": "755004",
      "Dadhibamanpur B.O": "755061",
      "Badapalli B.O": "754217",
      "Balabhadrapur B.O": "754217",
      "Kakharuni B.O": "754217",
      "Babar B.O": "754245",
      "Badihi B.O": "754245",
      "Chakada Gogua B.O": "754245",
      "Amrutamanohi B.O": "754218",
      "Nuapada B.O": "754218",
      "Palei Derakundi B.O": "754208",
      "Sabalanga Kanipara B.O": "754208",
      "Palasingha B.O": "754222",
      "Kandiahat B.O": "755016",
      "Oudapada B.O": "754217",
      "Sasan B.O": "754217",
      "Balakati B.O": "754219",
      "Sitaleswar B.O": "754219",
      "Mandia B.O": "754253",
      "Kurujanga B.O": "754208",
      "Taradapal B.O": "754240",
      "Gahaga Narasinghpur B.O": "754210",
      "Harianka B.O": "754210",
      "Indalo B.O": "754210",
      "Janra Barimul B.O": "754210",
      "Balia Bibhutipara B.O": "754289",
      "Alapua B.O": "754214",
      "Ghadiamal B.O": "754248",
      "Krishnanagar B.O": "754248",
      "Bandhakata B.O": "754244",
      "Nadia Barei B.O": "754223",
      "Raichand B.O": "754223",
      "Aripada B.O": "754223",
      "Bijayanagar B.O": "754224",
      "Jamboo B.O": "754224",
      "Jasuapalli B.O": "754224",
      "Pegarpara B.O": "754227",
      "Ghagra B.O": "754214",
      "Gommu B.O": "754214",
      "Kampagarh B.O": "754214",
      "Kolangiri B.O": "754214",
      "Palli Raghunathpur B.O": "754214",
      "Nalitapatia B.O": "754248",
      "Raghunathpur K Patna B.O": "754244",
      "Gunupur B.O": "754216",
      "Gopei B.O": "754223",
      "Balia B.O": "754224",
      "Ramnagar Refugee Colony B.O": "754224",
      "Suniti B.O": "754224",
      "Teragaon B.O": "754224",
      "Badakula B.O": "754213",
      "Balana B.O": "754213",
      "Dumuka B.O": "754213",
      "Garjanga B.O": "754213",
      "Atal B.O": "754231",
      "Bahmanda B.O": "754227",
      "Akhua Dakhini B.O": "754228",
      "Baliapatna B.O": "754215",
      "Bankeswar B.O": "754215",
      "Madhuban B.O": "755061",
      "Palimi B.O": "755061",
      "Sandhapalli B.O": "754215",
      "Sekhpur B.O": "754215",
      "Ayatan B.O": "754220",
      "Baradia B.O": "754220",
      "Mahulia B.O": "754225",
      "Mantiri B.O": "754212",
      "Ostapur B.O": "754212",
      "Alati Bharatpur B.O": "754250",
      "NARSINGHPUR B.O": "754207",
      "P.Srichandanpur B.O": "754162",
      "Pailo B.O": "754162",
      "Gatanai B.O": "754141",
      "Tikhiri B.O": "754141",
      "Antei B.O": "754162",
      "Kadamchhanda B.O": "754135",
      "Balisuan B.O": "754141",
      "Bamara Cuttack B.O": "754153",
      "Naindipur B.O": "754153",
      "M.G Khamar B.O": "754141",
      "Patalipank B.O": "754141",
      "Pakhad B.O": "754153",
      "Kalabuda B.O": "754153",
      "Tikanpur B.O": "754153",
      "Badagaon B.O": "754250",
      "Barakolikhala B.O": "754142",
      "Korua B.O": "754134",
      "Kudanagari B.O": "754134",
      "Narada B.O": "754134",
      "Putling B.O": "754134",
      "Bhagabanpur B.O": "754134",
      "Tentol B.O": "754134",
      "Talakusuma B.O": "754134",
      "Batira B.O": "754140",
      "Nischintasasan B.O": "754134",
      "Sana Adhanga B.O": "754134",
      "Kendrapara H.O": "754211",
      "Danpur S.O (Kendrapara)": "754210",
      "Derabish S.O": "754289",
      "Indupur S.O": "754214",
      "Alba S.O": "754217",
      "Aul S.O": "754219",
      "Batipada S.O": "754218",
      "Bhuinpur S.O": "754239",
      "Chandol S.O": "754208",
      "Chaudakulat S.O": "754222",
      "Iswarpur S.O": "754248",
      "Jaria S.O (Kendrapara)": "754216",
      "Barpada S.O": "754245",
      "Bedari S.O": "754253",
      "Govindpur Kutchery S.O": "755061",
      "Dandisahi S.O": "754240",
      "Jampara S.O": "754244",
      "GARADPUR S.O": "754153",
      "TYANDAKURA S.O": "754134",
      "Namouza S.O": "754231",
      "Patakura S.O (Kendrapara)": "754228",
      "Pattamundai College S.O": "754215",
      "Rajkanika S.O": "754220",
      "Madanpur S.O (Kendrapara)": "754246",
      "Marsaghai S.O": "754213",
      "Pattamundai S.O": "754215",
      "Rajnagar S.O (Kendrapara)": "754225",
      "Mahakalpara S.O": "754224",
      "Tinimuhani S.O": "754211",
      "Karilopatna S.O": "754223",
      "Kendrapara College S.O": "754211",
      "Keshpur Bazar S.O": "754211",
      "Olavar S.O": "754227",
      "Sribaldevjew S.O": "754212",
      "Thakurpatna S.O": "754250"
    },
    "BHADRAK": {
      "Arjunpur Brahmachari Patna B.O": "755036",
      "Gopabandhunagar B.O": "755036",
      "Dehurianandapur B.O": "755006",
      "Kantapari B.O": "755006",
      "Bankamuhani B.O": "755007",
      "Mamadulla B.O": "755006",
      "Solempur B.O": "755007",
      "Paramanandapur B.O": "756132",
      "Korkora B.O": "756116",
      "Langudi B.O": "756116",
      "Lunia B.O": "756116",
      "Nandore B.O": "756116",
      "Rajmukundapur B.O": "756116",
      "Nerada B.O": "756122",
      "Olaga B.O": "756138",
      "Bishnupurbindha B.O": "756116",
      "Khaparpada B.O": "756116",
      "Fatepur B.O": "756137",
      "Anijo B.O": "756115",
      "Mohantipada B.O": "756115",
      "Sandado B.O": "756115",
      "Manjuri B.O": "756122",
      "Batula B.O": "756138",
      "Sathibankuda B.O": "756138",
      "Bidyadharpur B.O": "756139",
      "Talapada B.O": "756139",
      "Balabhadrapur B.O": "756116",
      "Kalai B.O": "756116",
      "Talagopabindha B.O": "756116",
      "Kasimpur B.O": "756137",
      "Kumbharia B.O": "756122",
      "Bhuinpur B.O": "756138",
      "Nandapur B.O": "756127",
      "Anandabazar B.O": "756116",
      "Sriganga B.O": "756116",
      "Susua B.O": "756116",
      "Korua B.O": "756137",
      "Sahidnagar B.O": "756116",
      "Gadiali B.O": "756137",
      "Govindapur B.O": "756137",
      "Gopinath Tejpur B.O": "756115",
      "Prachinagar B.O": "756181",
      "Babalpur B.O": "756121",
      "Naami B.O": "756121",
      "Tesinga B.O": "756121",
      "Jaleswarpur B.O": "756132",
      "Kuda B.O": "756132",
      "Nalgunda B.O": "756132",
      "Sailendrapalli B.O": "756132",
      "Balimunda B.O": "756164",
      "Bedeipur B.O": "756164",
      "Barunai B.O": "756167",
      "Hengupati B.O": "756131",
      "Smantraipur B.O": "756131",
      "Badabarchikayan B.O": "756135",
      "Kadabaranga B.O": "756135",
      "Balanta B.O": "756111",
      "Sahada Sabrang B.O": "756123",
      "Samian B.O": "756123",
      "Bhatapada B.O": "756130",
      "Dhulipada B.O": "756130",
      "Jalanga B.O": "756181",
      "Mouda B.O": "756181",
      "Tihiri B.O": "756181",
      "Goudunipokhari B.O": "756132",
      "Harekrishnapur B.O": "756132",
      "Nuagaon Ichhapur B.O": "756132",
      "Karanjamal B.O": "756164",
      "Karanpalli B.O": "756164",
      "Sanahavelisahi B.O": "756164",
      "Arjunbindha B.O": "756131",
      "Balimeda B.O": "756131",
      "Bamanbindha B.O": "756131",
      "Barsar B.O": "756131",
      "Chandrakat Bindha B.O": "756131",
      "Ghatapur B.O": "756131",
      "Kheranga B.O": "756131",
      "Mudusuli B.O": "756131",
      "Pirhat B.O": "756131",
      "Rajgharpokhari B.O": "756131",
      "Rambhila B.O": "756111",
      "Andrai B.O": "756123",
      "Golapokhari B.O": "756130",
      "Kanpada B.O": "756130",
      "Kolha B.O": "756130",
      "Matiasahi B.O": "756130",
      "Patnamishrapur B.O": "756130",
      "Saya B.O": "756130",
      "Sindol B.O": "756130",
      "Bandalo B.O": "756121",
      "Deopada B.O": "756121",
      "Madhupur B.O": "756132",
      "Mousudha Bazar B.O": "756132",
      "Rampur B.O": "756132",
      "Baincha B.O": "756164",
      "Tiadisahi B.O": "756131",
      "Odanga B.O": "756135",
      "Olanga B.O": "756135",
      "Saramara B.O": "756135",
      "Atto B.O": "756123",
      "Erada B.O": "756123",
      "Bahabalpur B.O": "756130",
      "Balichaturi B.O": "756130",
      "Haladia B.O": "756129",
      "Kandaragadia B.O": "756129",
      "Subudhia B.O": "756129",
      "Galagandapur B.O": "756163",
      "Geltua B.O": "756181",
      "Kulana B.O": "756121",
      "Chardia B.O": "756113",
      "Karanpokhari B.O": "756132",
      "Madhapur B.O": "756132",
      "Nalagohira B.O": "756132",
      "Bansada Kuamara B.O": "756164",
      "Govindpur B.O": "756164",
      "Govindpur Hanspat B.O": "756131",
      "Jamjodi B.O": "756131",
      "Sahapur B.O": "756131",
      "Bodakpatna B.O": "756135",
      "Champulipada B.O": "756111",
      "Kalasuni B.O": "756111",
      "Rahanja B.O": "756111",
      "Goramati B.O": "756123",
      "BARANGA B.O": "756123",
      "Baro B.O": "756130",
      "Chabispara Sasan B.O": "756130",
      "Mangalpur B.O": "756130",
      "Biriadia B.O": "756129",
      "Keshpur B.O": "756128",
      "Kubera B.O": "756163",
      "Aharapada B.O": "756128",
      "Kalyani B.O": "756118",
      "Bhadrak Bypass B.O": "756181",
      "Gelpur B.O": "756181",
      "Hatapur B.O": "756129",
      "Narendrapur B.O": "756129",
      "Panchutikiri B.O": "756129",
      "Totapada B.O": "756129",
      "Bhuianwash B.O": "756163",
      "Bilana B.O": "756163",
      "Bodak B.O": "756163",
      "Nuahat B.O": "756118",
      "Andiapat B.O": "756129",
      "Ghanteswar Baliapal B.O": "756129",
      "Raipur B.O": "756129",
      "Jaipur B.O": "756163",
      "Ambiligaon B.O": "756118",
      "Garadapur B.O": "756181",
      "Adia B.O": "756114",
      "Dolapadi B.O": "756114",
      "Kantia B.O": "756114",
      "Sendtira B.O": "756114",
      "Ramakrishnapur B.O": "756113",
      "Ichhada B.O": "756112",
      "Naguan B.O": "756112",
      "Piripur B.O": "756112",
      "Bhairabpur B.O": "756125",
      "Biras B.O": "756125",
      "Radhaballavpur B.O": "756125",
      "Barandua B.O": "756168",
      "Malada B.O": "756120",
      "Kiapada B.O": "756165",
      "Goladia B.O": "756133",
      "Orasahi B.O": "756133",
      "Ugratara B.O": "756133",
      "Bandhagaon B.O": "756101",
      "Baralpokhari B.O": "756101",
      "Saraswati B.O": "756171",
      "Bandhatia B.O": "756117",
      "Kurigaon B.O": "756117",
      "Betaligaon B.O": "756119",
      "Pangata B.O": "756119",
      "Sahusahi B.O": "756119",
      "Serpur B.O": "756127",
      "Nuagaon B.O": "756162",
      "Gopaljew Sugo B.O": "756124",
      "Lunga B.O": "756124",
      "Andhia B.O": "756114",
      "Bangarpadi B.O": "756114",
      "Begana B.O": "756114",
      "Chhayalsingh B.O": "756114",
      "Tarago B.O": "756114",
      "Tillo Barasahi B.O": "756114",
      "Kaupur B.O": "756113",
      "Nalgira B.O": "756113",
      "Bahudarada B.O": "756112",
      "Nalanga B.O": "756112",
      "Patuli B.O": "756112",
      "Silandi B.O": "756144",
      "Adhuan B.O": "756125",
      "Arandua B.O": "756125",
      "Bedeipurpal B.O": "756125",
      "Baligaon B.O": "756133",
      "Bentalpur B.O": "756133",
      "Bijayanagar B.O": "756133",
      "Amroli B.O": "756101",
      "Dosinga B.O": "756171",
      "Kaithkhola B.O": "756171",
      "Kishore Prasad B.O": "756171",
      "D.B. Colony B.O": "756117",
      "Dakhinabad B.O": "756117",
      "Dobal B.O": "756117",
      "Jahangir B.O": "756117",
      "Padhani B.O": "756117",
      "Palikiri B.O": "756117",
      "Rameswarpur B.O": "756117",
      "Sohara B.O": "756117",
      "Jitanaga B.O": "756127",
      "Moharampur B.O": "756127",
      "Amrutpur B.O": "756129",
      "Alauti B.O": "756113",
      "Andheipalli B.O": "756112",
      "Todanga B.O": "756112",
      "Gobindpur B.O": "756112",
      "K K Pur B.O": "756125",
      "Mandari B.O": "756125",
      "Sanakrishnapur B.O": "756125",
      "Narasinghpur B.O": "756168",
      "Rahania B.O": "756120",
      "Sarasada B.O": "756120",
      "Bouljoda B.O": "756133",
      "Panchpada B.O": "756133",
      "Sukleswar B.O": "756133",
      "Tentulidihi B.O": "756133",
      "Chandigaon B.O": "756101",
      "Kudabarua B.O": "756101",
      "Saragadia B.O": "756101",
      "Brahmanpal B.O": "756119",
      "Khadimahara B.O": "756119",
      "Nadigaon B.O": "756119",
      "Pandarbatia B.O": "756119",
      "Sanalpur B.O": "756119",
      "Shyamsundarpur B.O": "756119",
      "Sunderpur B.O": "756119",
      "Suryapur B.O": "756119",
      "Ganjeibari B.O": "756127",
      "Ichhapur B.O": "756127",
      "Padamapur B.O": "756124",
      "Barahapur B.O": "756046",
      "Jagannathpur Bachhada B.O": "756046",
      "Adalpanka B.O": "756114",
      "Ganijang B.O": "756114",
      "Padhanpara B.O": "756114",
      "Ramachandrapur B.O": "756114",
      "Bhagibindha B.O": "756112",
      "Jalamandua B.O": "756112",
      "Kenduapada B.O": "756112",
      "R N Betra B.O": "756112",
      "Apanda B.O": "756144",
      "Binayakpur B.O": "756125",
      "Chudamani B.O": "756125",
      "Matipaka B.O": "756125",
      "Aruha B.O": "756168",
      "Bachhipur B.O": "756165",
      "Gopalpur B.O": "756133",
      "Banitia B.O": "756101",
      "Narasinghpurhat B.O": "756171",
      "Kumarpur B.O": "756046",
      "Padhuan B.O": "756046",
      "Angeipal B.O": "756117",
      "Chudakuti Palasa B.O": "756117",
      "Khadipada B.O": "756117",
      "Narayanpur B.O": "756117",
      "Bamkura B.O": "756119",
      "Sahaspur B.O": "756119",
      "Suan B.O": "756162",
      "Albaga B.O": "756124",
      "Guagadia B.O": "756124",
      "Bhadrak H.O": "756100",
      "Aradi S.O": "756138",
      "Arnapal S.O": "756116",
      "Basantia S.O (Bhadrak)": "756144",
      "Betada S.O": "756168",
      "Bhadrak Naya Bazar S.O": "756100",
      "Charampa S.O": "756101",
      "Ertal S.O": "756124",
      "Ghosrabazar S.O": "756100",
      "Madhabnagar S.O": "756181",
      "Manjuri Road S.O": "756121",
      "Naikanidihi S.O": "756164",
      "Nangamahalla S.O": "756100",
      "Paliabindha S.O": "756167",
      "Uttarbahini S.O": "756100",
      "Akhuapada S.O": "756122",
      "Asurali S.O": "756137",
      "Bhadrak Banka Bazar S.O": "756100",
      "Bhandari Pokhari S.O": "756120",
      "Brahmanigaon S.O": "756165",
      "Ghanteswar S.O": "756129",
      "Guamal S.O": "756163",
      "Gujidarada S.O": "756128",
      "Arsa S.O": "756139",
      "Basudevpur S.O (Bhadrak)": "756125",
      "Bhadrak College S.O": "756100",
      "Bhadrak Court S.O": "756100",
      "Chandbali S.O": "756133",
      "Eram S.O": "756162",
      "Pirahatbazar S.O": "756131",
      "Prabodhpur S.O": "756125",
      "Randiahat S.O": "756135",
      "Ranital S.O (Bhadrak)": "756111",
      "Salandi Colony S.O": "756100",
      "Tihidi S.O": "756130",
      "B T Pur S.O": "756115",
      "Bant S.O": "756114",
      "Barapada S.O": "756113",
      "Barikpur Bazar S.O": "756112",
      "Basudevpur College S.O": "756125",
      "Bhadrak Puruna Bazar S.O": "756100",
      "Bhadrak R S S.O": "756101",
      "Chandbali Bazar S.O": "756133",
      "Dhamara S.O": "756171",
      "Dhamnagar S.O": "756117",
      "Dhusuri S.O": "756119",
      "Dolasahi S.O": "756127",
      "Kothar S.O": "756118",
      "Kuans S.O": "756100",
      "Motto S.O": "756132",
      "Sabrang S.O": "756123"
    },
    "JHARSUGUDA": {
      "VSS AIRPORT SO": "768204",
      "N. Adhapara B.O": "768234",
      "Pandri B.O": "768234",
      "Ektali B.O": "768202",
      "Gudigaon B.O": "768202",
      "Markuta B.O": "768202",
      "Sripura B.O": "768202",
      "Sulahi B.O": "768202",
      "Bhatlaida B.O": "768213",
      "Jhirlapali B.O": "768213",
      "Malidihi B.O": "768213",
      "Badmal B.O": "768202",
      "Mudrajore B.O": "768213",
      "Niktimal B.O": "768213",
      "Badbahal B.O": "768227",
      "Sadamal B.O": "768214",
      "Aintapali B.O": "768215",
      "Sahaspur B.O": "768215",
      "Sarangloi B.O": "768215",
      "Sudang B.O": "768215",
      "Panchpara B.O": "768204",
      "Talmal B.O": "768204",
      "Talpatia B.O": "768204",
      "Kapilapur B.O": "768226",
      "M. Katapali B.O": "768226",
      "Mochida B.O": "768226",
      "Remta B.O": "768226",
      "Bhalupatra B.O": "768220",
      "Bhimjore B.O": "768220",
      "Tileimal B.O": "768221",
      "Ramella B.O": "768211",
      "Kirmira B.O": "768220",
      "Babuchipidihi B.O": "768221",
      "Kuarmal B.O": "768221",
      "Pankenpada B.O": "768221",
      "Dalgaon B.O": "768211",
      "Rampella B.O": "768211",
      "Jorabaga B.O": "768217",
      "Kudaloi B.O": "768217",
      "Ubuda B.O": "768217",
      "I B B.O": "768216",
      "Lamptibahal B.O": "768216",
      "Loisingh B.O": "768216",
      "Rajpur B.O": "768216",
      "Sarandamal B.O": "768211",
      "Gandghara B.O": "768216",
      "Sunari B.O": "768234",
      "Arda B.O": "768202",
      "H. Katapali B.O": "768202",
      "Paramanandapur B.O": "768213",
      "Bagmunda B.O": "768219",
      "Kadamdihi B.O": "768219",
      "Thebra B.O": "768219",
      "Durlaga B.O": "768204",
      "Attabira B.O": "768226",
      "Kanaktara B.O": "768226",
      "R. Kudapali B.O": "768225",
      "Rampaluga Reneda B.O": "768234",
      "Hirma B.O": "768202",
      "Raghunathpali B.O": "768213",
      "Samasingha B.O": "768213",
      "Bhaurkhol B.O": "768219",
      "Kudabaga B.O": "768219",
      "Charpali B.O": "768226",
      "Kandheikela B.O": "768226",
      "Katabaga B.O": "768225",
      "Naxapali B.O": "768220",
      "Charpali barpali B.O": "768211",
      "Banjari B.O": "768217",
      "Chandinimal B.O": "768216",
      "Chichinda B.O": "768216",
      "Jharsuguda H.O": "768201",
      "Belpahar S.O": "768218",
      "K.M. Road Jharsuguda S.O": "768202",
      "Laikera S.O": "768215",
      "Bagdehi S.O": "768220",
      "Brajarajnagar S.O": "768216",
      "Industrial Estate Jharsuguda S S.O": "768203",
      "Itps Banaharpali S.O": "768234",
      "Kolabira S.O": "768213",
      "Bandhbahal Colony S.O": "768211",
      "Belpahar Rs S.O": "768217",
      "Lakhanpur S.O Jharsuguda": "768219",
      "Sr Jharsuguda S.O": "768201",
      "Orient Colliery Brajarajnagar S.O": "768233",
      "Panchgaon S.O": "768226",
      "Rampur Colliery S.O": "768225",
      "Sarbahal S.O": "768201",
      "Sr Brajarjanagar SO": "768216",
      "O.M.P. Line Jharsuguda S.O": "768204"
    },
    "PURI": {
      "Subhas Chandra Bose Chowk NDTSO": "752001",
      "Baliguali S.O": "752004",
      "Rasulpur": "752119",
      "Mahadevbasta": "752107",
      "Suhagur": "752107",
      "Charanapada": "752106",
      "Alipingala": "752106",
      "Bindha": "752104",
      "Mangalpur": "752104",
      "Sarada": "752111",
      "Derunia": "752119",
      "Risol": "752119",
      "Terundia": "752106",
      "Viligram": "752106",
      "Haripur": "752104",
      "Kairi": "752104",
      "Kanti": "752104",
      "Sunugoradi": "752114",
      "Baulanga": "752107",
      "Desthali": "752107",
      "Bhogasalada": "752106",
      "Bishnupur": "752106",
      "Dighalo": "752106",
      "Binayakpur": "752104",
      "Rainsol": "752104",
      "Siula": "752104",
      "Sompur": "752104",
      "Biswalpada": "752114",
      "Dakhinradas": "752114",
      "Ratilo": "752114",
      "Renghalo": "752114",
      "Sagada": "752114",
      "Khandasahi": "752119",
      "Sorava": "752107",
      "Arisandha": "752106",
      "Bantugram": "752106",
      "Nahantara": "752106",
      "Salanga": "752106",
      "Taradapada": "752106",
      "Govindpur": "752104",
      "Dhaleswar": "752114",
      "Manijanga": "752114",
      "Olikana": "752114",
      "Bhanpur": "752114",
      "Nuapatna B.O": "754004",
      "Basantapur B.O": "752017",
      "Gadisagoda B.O": "752017",
      "Garhbadaput B.O": "752017",
      "Garhbalabhadrapur B.O": "752017",
      "Kalapadar B.O": "752017",
      "Gopinathpur B.O": "752010",
      "Gorual B.O": "752002",
      "Khadipada B.O": "752002",
      "Biraramachandrapur B.O": "752014",
      "Nua Someswarpur B.O": "752014",
      "Balapur B.O": "752046",
      "Baralabalunkeswar B.O": "752046",
      "Dangohiri": "752104",
      "Gualigorada B.O": "752045",
      "Badas B.O": "752017",
      "Garhmatiapada B.O": "752017",
      "Jagannathpur B.O": "752017",
      "Nandigoda B.O": "752017",
      "Sirei B.O": "752017",
      "Biraharekrushnapur B.O": "752002",
      "Markandeswar Sahi B.O": "752002",
      "Alagum B.O": "752014",
      "Biswanathpur B.O": "752014",
      "Dahan B.O": "752014",
      "Mula Alasa B.O": "752014",
      "Sriramachandrapur B.O": "752014",
      "Birapurusottampur B.O": "752046",
      "Kothasahi B.O": "752046",
      "Sangalaisasana": "752104",
      "Lalitapahandi B.O": "752045",
      "Charishree B.O": "752045",
      "Dubaipur B.O": "752045",
      "Mahura B.O": "752045",
      "Badagaon B.O": "752002",
      "Baliguali B.O": "752002",
      "Garhbhingura B.O": "752002",
      "Mahapur B.O": "752002",
      "Mahodadhi B.O": "752002",
      "Balipada B.O": "752014",
      "Biragobindapur B.O": "752014",
      "Ola B.O": "752014",
      "Raichakradharpur B.O": "752014",
      "Sandarahat B.O": "752014",
      "Sarangajodi B.O": "752014",
      "Teisipur B.O": "752046",
      "Bantalsingh": "752104",
      "Parakena B.O": "752045",
      "Alibada B.O": "752017",
      "Garhsahi B.O": "752017",
      "Khandahata B.O": "752017",
      "Santidham B.O": "752017",
      "Tipuri B.O": "752017",
      "Baniasahi B.O": "752002",
      "Bantaligram B.O": "752002",
      "Chhaitana B.O": "752002",
      "Sasana Damodarpur B.O": "752002",
      "Talajanga B.O": "752002",
      "Brahmanapada B.O": "752014",
      "Sukal B.O": "752014",
      "Deypursasan B.O": "752046",
      "Pattanaikia B.O": "752046",
      "Badajhad B.O": "752032",
      "Nuasasana": "752104",
      "Dandamakundpur": "752104",
      "Biripali B.O": "767040",
      "AMARESWAR B.O": "752120",
      "BAHARANA B.O": "752120",
      "Nuagarh": "752109",
      "Bakugram": "752105",
      "Dipideuli": "752105",
      "Nuagopalpur": "752105",
      "Sahadapada": "752105",
      "Jaleswarpada": "752118",
      "Kundeihat": "752118",
      "Garhrupas": "752110",
      "Kusupur": "752110",
      "Rebena Nuagaon B.O": "752011",
      "Satapada B.O": "752010",
      "Bijayaramachandrapur B.O": "752012",
      "Birabalabhadrapur B.O": "752012",
      "Biranarasinghpur B.O": "752012",
      "Muninda B.O": "752015",
      "Sadangoi B.O": "752015",
      "Singhbrahmapur B.O": "752015",
      "Trilochanpur B.O": "752015",
      "Palank B.O": "752011",
      "Ganganarayanpur B.O": "752012",
      "Kanheibidyadharpur B.O": "752012",
      "Rua B.O": "752012",
      "Ghoradia B.O": "752015",
      "Kalyanpur B.O": "752015",
      "Uchhupur": "752105",
      "Erbong": "752116",
      "Bhodar": "752113",
      "Alasahi": "752109",
      "Jharling": "752109",
      "Namaro": "752109",
      "Patalda": "752109",
      "Sisua": "752109",
      "Kusumber": "752109",
      "Jopan": "752105",
      "Kamakantia": "752105",
      "Kumarpada": "752105",
      "Badaninigaon": "752121",
      "Dovar": "752121",
      "Ohal": "752121",
      "Siaro": "752121",
      "Mahalpada": "752116",
      "Chhanijanga": "752113",
      "Tentuligaon": "752113",
      "Alichar": "752110",
      "Ganeswarpur": "752110",
      "Manapada B.O": "752011",
      "Alasana B.O": "752012",
      "Pratappurusottampur B.O": "752012",
      "Siruli B.O": "752012",
      "Tadasaramahansapur B.O": "752012",
      "Balaramapurgarh B.O": "752045",
      "Baliput B.O": "752045",
      "Laxminarayanpur B.O": "752100",
      "Nagar": "752109",
      "Udaypur": "752109",
      "Dandipur": "752105",
      "Nuasantha": "752105",
      "Rupadeipur": "752105",
      "Saraswatipur": "752105",
      "Garhchandpur": "752105",
      "Rahangagorada": "752121",
      "Kotang": "752118",
      "Garhkarmala": "752116",
      "Tulasipur": "752113",
      "Khadiso": "752110",
      "Nuagaonbadabhuin B.O": "752010",
      "Palli B.O": "752011",
      "Birapratappur B.O": "752012",
      "Garhmrugasira B.O": "752012",
      "Jorakani B.O": "752015",
      "Motari B.O": "752015",
      "Hantuka B.O": "752013",
      "Kerandipur B.O": "752013",
      "Bilaspur B.O": "752016",
      "Indipurdeuli B.O": "752016",
      "Ambapada B.O": "752011",
      "Bhubanapur B.O": "752010",
      "Brahmania B.O": "752011",
      "Garhkokala B.O": "752011",
      "Kusubenti B.O": "752011",
      "Ghanapana B.O": "752013",
      "Arisala B.O": "752016",
      "Badagualipada B.O": "752016",
      "Nalibasanta B.O": "752016",
      "Praharajpur B.O": "752016",
      "Bhagabanpur B.O": "752010",
      "Chhatabar B.O": "752011",
      "Chilikanuapada B.O": "752011",
      "Jenapur B.O": "752016",
      "Khellore B.O": "752016",
      "Sirpurusottampur B.O": "752016",
      "Arakhakuda B.O": "752010",
      "Bentapur B.O": "752011",
      "Kandagoda B.O": "752011",
      "Khajuria B.O": "752011",
      "Kapileswarpur B.O": "752013",
      "Rahadamalla B.O": "752013",
      "Abhayamukhi Ramachandrapur B.O": "752016",
      "Bhimpur B.O": "752016",
      "Hakapada B.O": "752016",
      "Berhampur B.O": "752010",
      "Bhandarikuda B.O": "752011",
      "Chapamanika B.O": "752011",
      "Dimirisena B.O": "752011",
      "Garhrodanga B.O": "752011",
      "Malud B.O": "752030",
      "Ramlenka B.O": "752030",
      "Godiput Matiapada B.O": "752050",
      "Harirajpur B.O": "752050",
      "Baku B.O": "752019",
      "Odal B.O": "752019",
      "Olhan B.O": "752019",
      "Raigurupur B.O": "752019",
      "Garhkharad B.O": "752019",
      "Bajrakote B.O": "752030",
      "Nagapur": "752110",
      "Narua": "752110",
      "Siso": "752110",
      "Bhairipur": "752110",
      "Patapur": "752108",
      "Patasundarpur": "752108",
      "Balidokan": "752111",
      "Kesharpur B.O": "752019",
      "Mallagaon": "752110",
      "kahala": "752108",
      "Kurujanga": "752111",
      "Sial B.O": "752030",
      "Titipa B.O": "752030",
      "Bhandisahi": "752108",
      "Othaka": "752108",
      "Chitreswari": "752111",
      "Dhanitri": "752111",
      "Junei": "752111",
      "Tampalo": "752110",
      "Gambharipada": "752108",
      "Krushnanagarpatna": "752108",
      "Karamanga": "752111",
      "Khalkatapatna": "752111",
      "Matiapada": "752111",
      "Puri H.O": "752001",
      "Konark": "752111",
      "Lataharan": "752119",
      "Nayahat": "752107",
      "Nimapara": "752106",
      "Rench": "752114",
      "Gop": "752110",
      "Astarang": "752109",
      "Balanga SO": "752105",
      "Chandanpur S.O": "752012",
      "D. A. G. S.O": "752002",
      "Delang S.O": "752015",
      "Kalikadevisahi S.O": "752001",
      "Police Line S.O (Puri)": "752002",
      "Puri Seabeach S.O": "752001",
      "Singhadwar S.O": "752001",
      "Srivihar S.O": "752003",
      "Bamanal": "752121",
      "Bangurigaon": "752118",
      "Balisahi S.O": "752001",
      "Kanas S.O": "752017",
      "Kundhebentasahi S.O": "752001",
      "Labanikhiachhak S.O": "752001",
      "Sakhigopal S.O": "752014",
      "Satasankha S.O": "752046",
      "Kakatpur": "752108",
      "Birtung": "752116",
      "B S Nagar S.O": "752002",
      "Baselisahi S.O": "752001",
      "Basudevpur S.O (Puri)": "752013",
      "Gabakunda S.O": "752045",
      "Jagannath Ballav S.O": "752001",
      "Puri Station Road S.O": "752002",
      "S C S College S.O": "752001",
      "Swargadwar S.O": "752001",
      "Parikudgarh SO": "752032",
      "Pipili SO": "752104",
      "Dola Bedi Chhak NDT": "752106",
      "Panaspada S.O": "752010",
      "Brahmakundi": "752113",
      "Berboi S.O": "752016",
      "Brahmagiri S.O": "752011",
      "Manikarnika S.O": "752001"
    },
    "KHORDHA": {
      "Itipur B.O": "751002",
      "Kausalyaganga B.O": "751002",
      "Kuha B.O": "751002",
      "Bankual B.O": "751002",
      "Badalasasan": "752106",
      "Rajas": "752114",
      "Mancheswar B.O": "751017",
      "Mancheswar R S B.O": "751017",
      "Sisupalgarh B.O": "751002",
      "Sundarpada B.O": "751002",
      "Gopinathpur B.O": "751002",
      "Kalyanpur Sasan B.O": "751002",
      "Palasahi": "752114",
      "Dara B.O": "754005",
      "Daruthenga B.O": "754005",
      "Chandaka B.O": "754005",
      "Gandarpur B.O": "754005",
      "Chhatrapada B.O": "752038",
      "Sagadabhanga B.O": "752038",
      "Abhimanpur B.O": "752021",
      "Badapari B.O": "752023",
      "Mangalajodi B.O": "752023",
      "Patiamal B.O": "752023",
      "Ghiakhala B.O": "752030",
      "Achyutpur B.O": "752021",
      "Goudapatna B.O": "752038",
      "Bhusundapur B.O": "752021",
      "Kamaguru B.O": "752021",
      "Haripur B.O": "752066",
      "Chandeswar B.O": "752023",
      "Pariorada B.O": "752023",
      "Nariso B.O": "754004",
      "Kalyanpur B.O": "752056",
      "Kusumi B.O": "752021",
      "Sundarpur B.O": "752021",
      "Tankol B.O": "752021",
      "Mukundadaspur": "752104",
      "Raghunathpur B.O": "754005",
      "Banguary B.O": "754001",
      "Barimunda B.O": "754001",
      "Gediapalli B.O": "752061",
      "Badaberena B.O": "752061",
      "Bhuasunipatna B.O": "752061",
      "Brahman Suanlo B.O": "752100",
      "Jhinti Sasan B.O": "752100",
      "Jagannathpur B.O": "752101",
      "Naharakanta B.O": "752101",
      "Biswanathpur B.O": "752102",
      "Mahukhanda B.O": "752102",
      "Prataprudrapur B.O": "752102",
      "Majhihara B.O": "752103",
      "Andharua B.O": "751003",
      "Ghatikia B.O": "751003",
      "Jadupur B.O": "751019",
      "Bhainchua B.O": "752100",
      "Benupur B.O": "752101",
      "Chanahat B.O": "752102",
      "Darada B.O": "752102",
      "Dolakasati B.O": "752102",
      "Turintira B.O": "752102",
      "Patrapada B.O": "751019",
      "Sarakantara B.O": "751019",
      "Sarakana B.O": "752100",
      "Satyabhamapur B.O": "752100",
      "Sisilo B.O": "752100",
      "Trahi Achyut Nagar B.O": "752100",
      "Brahmanasarangi B.O": "752102",
      "Raghuagorada B.O": "752102",
      "Sasan B.O": "752102",
      "Amankud B.O": "752103",
      "Bhakarsahi B.O": "752103",
      "Bhanranizigarh B.O": "752103",
      "Deulidharpur B.O": "752103",
      "Kalinga Vihar B.O": "751019",
      "Garh Srirampur B.O": "752100",
      "Jayapur B.O": "752101",
      "Athantar B.O": "752102",
      "Garidipanchana B.O": "752102",
      "Kakarudrapur B.O": "752102",
      "Nuapada B.O": "752102",
      "Abhayamukhi B.O": "752103",
      "Kantapada B.O": "752103",
      "Padmapur B.O": "752103",
      "Bharatpur B.O": "751003",
      "Malipada B.O": "752018",
      "Aiginia B.O": "751019",
      "Aiims Ndbo": "751019",
      "Ankulachati B.O": "752030",
      "Balidihi B.O": "752031",
      "Bheteswar B.O": "752031",
      "Dibyasinghpur B.O": "752031",
      "Godabaris Mahavidyalaya B.O": "752031",
      "Routapada B.O": "752062",
      "Bankoi B.O": "752066",
      "Baradangi B.O": "752066",
      "Tangisahi B.O": "752066",
      "Baulabandha B.O": "752034",
      "Haripursasan B.O": "752034",
      "Motta B.O": "752020",
      "Nidhipur B.O": "752020",
      "Raipur B.O": "752020",
      "Angarpada B.O": "752054",
      "Dandichhatabar B.O": "752054",
      "Kantabad B.O": "752054",
      "Pangarsingh B.O": "752061",
      "Simor B.O": "752061",
      "Turumal B.O": "752050",
      "Godikilo B.O": "752038",
      "Khanat B.O": "752030",
      "Rahanbeli B.O": "752030",
      "Singheswar B.O": "752030",
      "Badasereipur B.O": "752031",
      "Pratap B.O": "752031",
      "Sahaspur B.O": "752031",
      "Saliadam B.O": "752031",
      "Barikilo B.O": "752062",
      "Gopalipada B.O": "752066",
      "Kalanga B.O": "752066",
      "Manikagoda B.O": "752066",
      "Mordabadi B.O": "752066",
      "Patabandha B.O": "752066",
      "Sampur B.O": "752066",
      "Ayatapur B.O": "752035",
      "Banpur Odagaon B.O": "752035",
      "Damiabarabara B.O": "752035",
      "Harichandanpur B.O": "752035",
      "Niladriprasad B.O": "752035",
      "Kulei B.O": "752034",
      "Nachuni B.O": "752034",
      "Birakesharpur B.O": "752020",
      "Gangapada B.O": "752054",
      "Kantia B.O": "752050",
      "Bhimpur Padanpur B.O": "752050",
      "NISER B.O": "752050",
      "Baradihi B.O": "752027",
      "Biribadi B.O": "752027",
      "Brajamohanpur B.O": "752018",
      "Nijigarhtapang B.O": "752018",
      "Nilgiripatna B.O": "752019",
      "Paikatigiria B.O": "752057",
      "Saradhapur B.O": "752057",
      "Sarua B.O": "752057",
      "Daleiput B.O": "752056",
      "Kaipadar B.O": "752056",
      "Kunjuri B.O": "752027",
      "Panabaraj B.O": "752056",
      "Chhamundiapalli B.O": "752064",
      "Deuli B.O": "752064",
      "Manibandha B.O": "752064",
      "Sanapadar B.O": "752064",
      "Madanpur B.O": "752054",
      "Mahura B.O": "752054",
      "Mendhasala B.O": "752054",
      "Paikerapur B.O": "752054",
      "Soran B.O": "752027",
      "Garhnial B.O": "752057",
      "Gurujanga B.O": "752057",
      "Haladia B.O": "752057",
      "Keranga B.O": "752057",
      "Bangida B.O": "752056",
      "Thanapalli B.O": "752061",
      "Anda B.O": "752060",
      "Garhsanput B.O": "752060",
      "Badakul B.O": "752030",
      "Bhimpur B.O": "752031",
      "Kumaranga B.O": "752031",
      "Narendrapur B.O": "752031",
      "Sanahantuad B.O": "752031",
      "Dingar B.O": "752062",
      "Goda B.O": "752062",
      "Kadab B.O": "752062",
      "Parichhala B.O": "752062",
      "Arakhapalli B.O": "752066",
      "Dabardhuapatna B.O": "752066",
      "Panchugaon B.O": "752035",
      "Nairi B.O": "752034",
      "Chhanagiri B.O": "752020",
      "Golabai B.O": "752020",
      "Olasingh B.O": "752020",
      "Kaimatia B.O": "752054",
      "Retanga R.S. B.O": "752054",
      "Badatota B.O": "752050",
      "Kudiari B.O": "752050",
      "Panchagaon B.O": "752050",
      "Jaripada B.O": "752022",
      "Hadapada B.O": "752018",
      "Ramchandi B.O": "752018",
      "Bhatapada B.O": "752019",
      "Lendu B.O": "752019",
      "Bagheitangi B.O": "752057",
      "Kumarbasta B.O": "752057",
      "Mukunda Prasad B.O": "752057",
      "Pubusahi B.O": "752057",
      "Tartua B.O": "752057",
      "Dalatola B.O": "752056",
      "Gudum B.O": "752056",
      "Karadgadia B.O": "752056",
      "Asaral B.O": "752064",
      "Kotapalla B.O": "752061",
      "Malipadar B.O": "752061",
      "Podadihi B.O": "752061",
      "Chhatipur B.O": "752060",
      "Haldiapada B.O": "752060",
      "Belapada B.O": "752030",
      "Antarkiari B.O": "752031",
      "Badhantuad B.O": "752031",
      "Punjiama Sasan B.O": "752031",
      "Chakapada B.O": "752062",
      "Garhmanitri B.O": "752062",
      "Narayanipada B.O": "752062",
      "Dighiri B.O": "752066",
      "Sagargaon B.O": "752066",
      "Baradiharikunda B.O": "752034",
      "Salapdihi B.O": "752034",
      "Sunakhala B.O": "752034",
      "Damanbhuin B.O": "752020",
      "Haja B.O": "752020",
      "Rameswar B.O": "752020",
      "Palaspur B.O": "752054",
      "Arugul B.O": "752050",
      "Bhogada B.O": "752061",
      "Kusumati B.O": "752050",
      "Taraboi B.O": "752050",
      "Muktapur B.O": "752057",
      "Nalipada Arjunpur B.O": "752057",
      "Dadhimachhagadia B.O": "752056",
      "Arikama B.O": "752064",
      "Botalama B.O": "752038",
      "Kalarahanga B.O": "751024",
      "Khurda H.O": "752055",
      "Bhubaneswar G.P.O.": "751001",
      "Laxmisagar S.O (Khorda)": "751006",
      "Rajbhawan S.O (Khorda)": "751008",
      "Rasulgarh S.O": "751010",
      "Regional Research Laboratory S.O": "751013",
      "Suryanagar S.O (Khorda)": "751003",
      "N.M.D Parcel Centre Bhubaneswar": "751026",
      "BARAMUNDA NDC": "751033",
      "Harachandi Sahi S.O": "751002",
      "Mancheswar Railway  Colony S.O": "751017",
      "Nayapalli S.O": "751012",
      "RASULGARH NDC": "751034",
      "PAHAL S.O": "751032",
      "A G S.O": "751001",
      "Acharya Vihar S.O": "751022",
      "G.G.P.Colony S.O": "751025",
      "I R C Village S.O": "751015",
      "K I I T S.O": "751024",
      "Kalpana Square S.O": "751006",
      "Khandagiri S.O": "751030",
      "Osap Campus S.O": "751017",
      "Pokhariput S.O": "751020",
      "S.E Rly.Proj. Complex S.O": "751023",
      "Saheed Nagar S.O": "751007",
      "Sainik School S.O (Khorda)": "751005",
      "Satyanagar S.O (Khorda)": "751007",
      "Utkal University S.O": "751004",
      "V S S Nagar S.O": "751007",
      "Patia S.O": "751031",
      "Bhola S.O": "754012",
      "Banamalipur S.O": "752103",
      "Bapujee Nagar S.O": "751009",
      "Bhatpatna S.O": "752115",
      "Bhubaneswar Court S.O": "751014",
      "Budheswari Colony S.O": "751006",
      "C R P Lines S.O": "751011",
      "Aerodrome Area S.O": "751020",
      "Ashok Nagar S.O (Khorda)": "751009",
      "Badagarh Brit Colony S.O": "751018",
      "Bhoinagar S.O": "751022",
      "Baghamari S.O": "752061",
      "Bajpur S.O": "752060",
      "Balugaon S.O": "752030",
      "Bolagarh S.O": "752066",
      "Orissa Engineering College S.O": "752050",
      "Siko S.O": "752038",
      "Tangi S.O": "752023",
      "Balianta S.O": "752101",
      "Balipatna S.O": "752102",
      "Baramunda Colony S.O": "751003",
      "Bhimatangi ND S.O": "751002",
      "Balugaon Bazar Nd S.O": "752030",
      "Banpur  S.O (Khorda)": "752031",
      "Jankia S.O": "752020",
      "Janla S.O": "752054",
      "Jatni S.O": "752050",
      "Kuhuri S.O": "752027",
      "Loco Settlement S.O": "752050",
      "Narangarh S.O": "752018",
      "P N College S.O": "752057",
      "Retang Colony S.O": "752050",
      "Singipur S.O": "752021",
      "Kedargouri S.O": "751002",
      "Madhusudan Nagar S.O (Khorda)": "751022",
      "Old Town S.O (Khorda)": "751002",
      "Odisha  Assembly S.O": "751001",
      "Sailashree Vihar S.O": "751021",
      "Santarapur S.O": "751002",
      "Udyan Marg S.O": "751009",
      "International Business Centre": "751027",
      "Mahalaxmivihar S.O": "751029",
      "Tamando S.O": "751028",
      "Chandra Sekhar Pur S.O": "751016",
      "Dumduma Housing Board Colony S.O": "751019",
      "Begunia S.O": "752062",
      "Gangadharpur S.O": "752034",
      "Kaluparaghat S.O": "752022",
      "Khurda Road Rs S.O": "752050",
      "Pallahat S.O": "752056",
      "Pichikuli S.O": "752064",
      "Airport S.O (Khorda)": "751020",
      "B J B Nagar S.O": "751014",
      "Balakati S.O": "752100",
      "Bhubaneswar Secretariate S.O": "751001",
      "Gambharimunda S.O": "752035",
      "Navalbasechilika  S.O": "752037",
      "Nirakarpur S.O": "752019",
      "Rajabazar Nd S.O": "752050"
    },
    "SUNDARGARH": {
      "Sansarphal B.O": "754217",
      "Kurga B.O": "770002",
      "Meghdega B.O": "770002",
      "Sanpatrapali B.O": "770020",
      "B.Sankara B.O": "770014",
      "Jhamankera B.O": "770033",
      "Jhunmur B.O": "770033",
      "Kadobahal B.O": "770033",
      "Badgogua B.O": "770038",
      "Bhaludungri B.O": "770038",
      "Bandhabhuin B.O": "770051",
      "S.Bolang B.O": "770051",
      "Sarsara B.O": "770051",
      "Tendra B.O": "770051",
      "Tikayatpali B.O": "770051",
      "Dalaisara B.O": "770044",
      "Jangra B.O": "770044",
      "Kuliposh B.O": "770044",
      "Sihidia B.O": "770044",
      "Gobira B.O": "770039",
      "Damkuda B.O": "770014",
      "Deogaon B.O": "770014",
      "Jaisor B.O": "770014",
      "Lulkidihi B.O": "770074",
      "Rouldega B.O": "770074",
      "Sagbahal B.O": "770074",
      "Sagjore B.O": "770074",
      "Bilaigarh B.O": "770011",
      "Kuarboga B.O": "770011",
      "Nialipali B.O": "770011",
      "Tangarpali B.O": "770011",
      "Darlipali B.O": "770072",
      "J.Raiboga B.O": "770072",
      "Jhargaon B.O": "770072",
      "Kanaktura B.O": "770072",
      "Kalosihiria B.O": "770039",
      "Kumjharia B.O": "770039",
      "K.Bolang B.O": "770040",
      "Kalaiposh B.O": "770040",
      "Tumkela B.O": "770040",
      "Khutgaon B.O": "770036",
      "Kulenbahal B.O": "770036",
      "Hamirpur B.O": "770002",
      "Katra B.O": "770002",
      "Panchmahala B.O": "770002",
      "Kiakachhar B.O": "770020",
      "Kukridihi B.O": "770020",
      "Diamunda B.O": "770021",
      "Raidihi B.O": "770014",
      "Jamuna B.O": "770014",
      "Kurumkel B.O": "770014",
      "Tangargaon B.O": "770014",
      "Barhadema B.O": "770074",
      "Kantabahal B.O": "770074",
      "Tilia B.O": "770074",
      "Tumlia B.O": "770074",
      "Gambharidihi B.O": "770011",
      "Badbonga B.O": "770072",
      "Nuadihi B.O": "770072",
      "Santoshpur B.O": "770036",
      "Tulsikani B.O": "770036",
      "Udusu B.O": "770036",
      "Asurchapal B.O": "769043",
      "Garjan B.O": "769043",
      "Karmabahal B.O": "769042",
      "Luakera B.O": "769009",
      "Bhutuda B.O": "770041",
      "A.Jambahal B.O": "770033",
      "Indrapur B.O": "770051",
      "Kardega B.O": "770033",
      "Majhapara B.O": "770022",
      "Salangabahal B.O": "770033",
      "Jakaikela B.O": "770038",
      "Narendra B.O": "770038",
      "Kantapali B.O": "770043",
      "Lachada B.O": "770043",
      "Balanda B.O": "770031",
      "Laing B.O": "770034",
      "Ushra Colony B.O": "770034",
      "Barghat B.O": "770037",
      "Gopinathpur B.O": "770051",
      "Lalei B.O": "770044",
      "Mahulpada B.O": "770044",
      "Dengula Ashram B.O": "770048",
      "Padampur B.O": "770039",
      "Bimlagarh B.O": "770040",
      "Darjing B.O": "770040",
      "Jamdihi B.O": "770040",
      "Nandapara B.O": "770040",
      "Sankhaposh B.O": "770040",
      "Sayamba B.O": "770040",
      "Barsuan B.O": "770036",
      "Birkera B.O": "770037",
      "Lahanda B.O": "769042",
      "Kacharu B.O": "769003",
      "B.Karuabahal B.O": "770015",
      "Sikajore B.O": "770015",
      "Telijore B.O": "770015",
      "Tildega B.O": "770015",
      "Tileikani B.O": "770015",
      "Bhoipali B.O": "770016",
      "Ekma B.O": "770016",
      "Salbira B.O": "770016",
      "Sankraposh B.O": "770016",
      "Tiklipara B.O": "770016",
      "Beheramunda B.O": "770075",
      "Kanakjore B.O": "770002",
      "Rasrajpur B.O": "770002",
      "Tasladihi B.O": "770002",
      "Aleikera B.O": "770020",
      "Baurimundagaon B.O": "770020",
      "Kulba B.O": "770020",
      "Rajpur B.O": "770020",
      "Ratanpur B.O": "770020",
      "Aunlabahal B.O": "770021",
      "Kalamegha B.O": "770021",
      "Kuturma B.O": "770021",
      "Ranpur B.O": "770014",
      "Sapdagar B.O": "770014",
      "Sashyakala B.O": "770041",
      "Tarkera B.O": "770033",
      "JAIDEGA B.O": "770033",
      "Satkuta B.O": "770038",
      "Talita B.O": "770038",
      "Bonaikela B.O": "770043",
      "Jamdar B.O": "770043",
      "Jarda B.O": "770043",
      "Kansar B.O": "770043",
      "Chikatmati B.O": "770031",
      "Simdega B.O": "770014",
      "Belsara B.O": "770011",
      "Chungimati B.O": "770034",
      "Laing Colony B.O": "770034",
      "Jhirdapali B.O": "770051",
      "Kasada B.O": "770051",
      "Kulkuta B.O": "770051",
      "Phuljhar B.O": "770044",
      "Ruguda B.O": "770044",
      "Patmunda B.O": "770048",
      "Gopna B.O": "770040",
      "Roxy B.O": "770040",
      "Bad Dalki B.O": "770037",
      "Banki Bazar B.O": "770037",
      "Dalki B.O": "770033",
      "Kaplas B.O": "770033",
      "Kokerama B.O": "770033",
      "Ajaikela B.O": "770036",
      "Bagdega B.O": "770036",
      "Bangerkela B.O": "770036",
      "Kunmendra B.O": "770033",
      "Raiboga B.O": "770033",
      "Kandrikela B.O": "770038",
      "Pandrisila B.O": "770038",
      "Kundheidiha B.O": "770043",
      "Mayurdima B.O": "770043",
      "Beldihi B.O": "770031",
      "Dumerjore B.O": "770034",
      "Gilli B.O": "770051",
      "Karamdihi B.O": "770002",
      "Govindpur B.O": "770051",
      "Kurda B.O": "770044",
      "Mahuldiha B.O": "770044",
      "Ratakhandi B.O": "770039",
      "Badapurnapani B.O": "770040",
      "Chordhara B.O": "770040",
      "Khariabahal B.O": "770040",
      "Kundheikela B.O": "770040",
      "Sardhapur B.O": "770040",
      "Topadihi B.O": "770040",
      "Bhalulata B.O": "770036",
      "Jareikela B.O": "770017",
      "Jabaghat B.O": "769042",
      "Gangpurgarh B.O": "770020",
      "Kiralaga B.O": "770014",
      "Kusumura B.O": "770014",
      "Bandega B.O": "770074",
      "Hutupani B.O": "770074",
      "Jharbeda B.O": "770070",
      "Chhatenpali B.O": "770011",
      "Jhariapali B.O": "770011",
      "Kiripsira B.O": "770011",
      "Beheradihi B.O": "770015",
      "Kaintara B.O": "770015",
      "Kurei B.O": "770015",
      "Sahanamara B.O": "770015",
      "Aludega B.O": "770016",
      "Bamdera B.O": "770016",
      "Kumbahal B.O": "770016",
      "Lamti B.O": "770016",
      "Pamra B.O": "770016",
      "Rungaon B.O": "770016",
      "Balinga B.O": "770076",
      "Duduka B.O": "770076",
      "Tikilipara B.O": "770076",
      "Badsalepali B.O": "770022",
      "Gadiajore B.O": "770022",
      "Kulta B.O": "770022",
      "G. Tumulia B.O": "770024",
      "Rohini B.O": "770075",
      "Sanghumunda B.O": "770013",
      "Baladmal B.O": "770073",
      "Bhedabahal B.O": "770073",
      "Pudajalanga B.O": "770073",
      "Badbahal B.O": "770019",
      "Daldali B.O": "770019",
      "Biringatoli B.O": "770018",
      "Dahijira B.O": "770018",
      "Kusumdegi B.O": "770018",
      "Panchora B.O": "770018",
      "Alapaka B.O": "770012",
      "Dandpani B.O": "770012",
      "Patuadihi B.O": "770012",
      "Sarafgarh B.O": "770012",
      "Alanda B.O": "770017",
      "Garbhana B.O": "770017",
      "Bandhpali B.O": "770002",
      "Chhotasargi B.O": "770002",
      "Khatkurbahal B.O": "770018",
      "Koronga B.O": "770018",
      "Latalaga B.O": "770018",
      "Tudalaga B.O": "770018",
      "Giringkela B.O": "770012",
      "Gundiadihi B.O": "770012",
      "Karanjkhol B.O": "770012",
      "Kulabira B.O": "770012",
      "Mosabira B.O": "770012",
      "Kesramal B.O": "770017",
      "Kutunia B.O": "770017",
      "Malidihi B.O": "770017",
      "Birkaldihi B.O": "770015",
      "Deobhubanpur B.O": "770015",
      "Dhamakpur B.O": "770015",
      "Gaikanpali B.O": "770015",
      "Khampur B.O": "770015",
      "Kinikibandha B.O": "770015",
      "Itma B.O": "770016",
      "Jarangloi B.O": "770016",
      "Kureiboga B.O": "770016",
      "Kustuna B.O": "770016",
      "Sahajbahal B.O": "770016",
      "SUMURA B.O": "770076",
      "Karla B.O": "770022",
      "Ledhimong B.O": "770022",
      "Philingibahal B.O": "770022",
      "Salangabud B.O": "770022",
      "Jharpalam B.O": "770024",
      "R.Ratansara B.O": "770024",
      "Topria B.O": "770024",
      "Durubaga B.O": "770013",
      "Garjanjore B.O": "770013",
      "Kendudihi B.O": "770013",
      "Baragad B.O": "770073",
      "Kopsingha B.O": "770073",
      "Lankahuda B.O": "770073",
      "SUBALAYA B.O": "770073",
      "Jamtalia B.O": "770019",
      "Kinjirma B.O": "770019",
      "Mangaspur B.O": "770019",
      "Remanda B.O": "770019",
      "Dandjamira B.O": "770018",
      "Gairbahal B.O": "770018",
      "Kahapani B.O": "770018",
      "Gyanpali B.O": "770023",
      "Katang B.O": "770023",
      "R.Kukuda B.O": "770023",
      "Suanjore B.O": "770012",
      "Suarijore B.O": "770012",
      "Surguda B.O": "770012",
      "Telendihi B.O": "770012",
      "Bandhabal B.O": "770015",
      "Khamarimunda B.O": "770015",
      "Kinjirkela B.O": "770015",
      "Rampur B.O": "770015",
      "Barangakachhar B.O": "770016",
      "Phulbari B.O": "770016",
      "Barpali B.O": "770076",
      "Birbira B.O": "770022",
      "Lahandabud B.O": "770022",
      "Bileimunda B.O": "770024",
      "Daghora B.O": "770075",
      "Tangardihi B.O": "770075",
      "Kuchedega B.O": "770013",
      "Bhasma B.O": "770019",
      "Deuli B.O": "770019",
      "Amgova B.O": "770018",
      "N.Jharen B.O": "770018",
      "Bailama B.O": "770012",
      "Dumabahal B.O": "770012",
      "Laikera B.O": "770012",
      "Rajbahal B.O": "770012",
      "Buchukupara B.O": "770017",
      "G. Mahulpali B.O": "770002",
      "Sole B.O": "768228",
      "Jadakudar B.O": "770037",
      "Manko B.O": "770037",
      "Ramjodi B.O": "770037",
      "Tainsar B.O": "770037",
      "Tamra B.O": "770037",
      "Luaram B.O": "770035",
      "Nuagaon B.O": "770035",
      "Surda B.O": "770035",
      "Tainda B.O": "770035",
      "Chandrapur B.O": "770037",
      "Jharbeda Banki B.O": "770037",
      "Birda B.O": "770037",
      "Chandiposh B.O": "770037",
      "Patua B.O": "770037",
      "KUCHEITA B.O": "770037",
      "Barilepta B.O": "770035",
      "Kandarkela B.O": "770035",
      "Jhartarang B.O": "769004",
      "Bolani B.O": "770037",
      "Kumakela B.O": "770037",
      "Pankadihi B.O": "770037",
      "Sargigarh B.O": "770037",
      "Chitapedi B.O": "770035",
      "Limida B.O": "770035",
      "Vedvyas B.O": "769004",
      "Sundargarh H.O": "770001",
      "Uditnagar H.O": "769012",
      "Rourkela H.O": "769001",
      "Jagda S.O": "769042",
      "Rourkela - 11 S.O": "769011",
      "Rourkela - 6 S.O": "769006",
      "Rourkela - 13 S.O": "769013",
      "Rourkela - 8 S.O": "769008",
      "Rourkela - 9 S.O": "769009",
      "Sector - 15 S.O": "769003",
      "Sector - 16 S.O": "769003",
      "Bisra Road S.O": "769001",
      "Bisra S.O": "770036",
      "Fertilizer Township S.O": "769007",
      "Jhirpani S.O": "769042",
      "Gopalpur S.O (Sundergarh)": "770024",
      "Kirei S.O": "770073",
      "Kundukela S.O": "770019",
      "Lanjiberna S.O": "770023",
      "Loco Colony Bandomunda S.O": "770032",
      "Rourkela - 10 S.O": "769010",
      "Rourkela - 14 S.O": "769014",
      "Rourkela - 2 S.O": "769002",
      "Rourkela - 3 S.O": "769003",
      "Rourkela -16 S.O": "769016",
      "Bonaigarh S.O": "770038",
      "Civil Township S.O": "769004",
      "Kuarmunda S.O": "770039",
      "Lahunipara S.O": "770040",
      "Ranibandha S.O": "770017",
      "Regent Market S.O": "770001",
      "Sankara S.O": "770020",
      "Ujalpur S.O": "770011",
      "NTPC  Darlipali SO": "770025",
      "Bargaon (Sundergarh) S.O": "770016",
      "Basundhara S.O": "770076",
      "Dharuadihi S.O": "770022",
      "Hemgir Road S.O": "770075",
      "Kutra S.O": "770018",
      "Brahmani Tarang S.O": "769004",
      "Gurundia S.O": "770043",
      "Kalinga Vihar S.O": "769015",
      "Kenaveta S.O": "770051",
      "Koira S.O": "770048",
      "PIET MANDIAKUDAR": "770034",
      "Tensa S.O": "770042",
      "Subdega S.O": "770014",
      "Tunmura S.O": "770070",
      "Sector - 7 S.O": "769003",
      "Biramitrapur S.O": "770033",
      "Kalta S.O": "770052",
      "Kalunga S.O": "770031",
      "Lathikata S.O": "770037",
      "Purnapani S.O": "770035",
      "Rourkela - 15 S.O": "769015",
      "Rourkela - 4 S.O": "769004",
      "Balisankara S.O": "770015",
      "Hemgir S.O": "770013",
      "Rajgangpur S.O": "770017",
      "Rangadhipa S.O": "770002",
      "Sundargarh Court S.O": "770001",
      "Bandomunda S.O": "770032",
      "Daily Market S.O": "769001",
      "Jalda S.O": "769043",
      "Rourkela - 5 S.O": "769005",
      "Rourkela - 7 S.O": "769007",
      "Sector - 2 S.O": "769006",
      "Sector - 5 S.O": "769002",
      "Sector - 6 S.O": "769002",
      "Dengibhadi S.O": "770001",
      "Lephripara S.O": "770012",
      "Mahesdihi S.O": "770001",
      "Sargipali S.O": "770021",
      "Talsara S.O": "770074",
      "Zincnagar S.O": "770072",
      "Barsuan S.O": "770041",
      "Basanti Colony S.O": "769012",
      "Damdapara S.O": "770033",
      "Hatibari S.O": "770046",
      "Jail Road S.O (Sundergarh)": "769004",
      "KANSBAHAL": "770034",
      "Katchery Road S.O": "769012",
      "Khuntgaon S.O": "770044"
    },
    "KENDUJHAR": {
      "Odapada B.O": "755019",
      "Balibaruan B.O": "755019",
      "Sanamasinabila B.O": "758029",
      "Santrapur B.O": "758029",
      "Gadadharpur B.O": "758027",
      "Manata B.O": "758027",
      "Mukundapur Patna B.O": "758027",
      "Nusuriposi B.O": "758027",
      "Rajabandha B.O": "758027",
      "Tara B.O": "758027",
      "Balibarei B.O": "758023",
      "Podasingidi B.O": "758023",
      "Kaduadiha B.O": "758028",
      "Kuntla B.O": "758028",
      "Badarampas B.O": "758083",
      "Saleikana B.O": "758084",
      "Saruali B.O": "758084",
      "Tana B.O": "758084",
      "Bansapani B.O": "758034",
      "Khandabandha B.O": "758034",
      "Kalinga B.O": "758044",
      "Kanjiasula B.O": "758044",
      "Kasipal B.O": "758031",
      "Nandapur B.O": "758044",
      "Rangamatia B.O": "758044",
      "Raruanguda B.O": "758044",
      "Sologuda B.O": "758044",
      "Uchhabali B.O": "758044",
      "Dhanurjaypur Haramatha B.O": "758040",
      "Jalasuanpatna B.O": "758025",
      "Kanpur B.O": "758078",
      "Keshudurapal B.O": "758025",
      "Samukanandi B.O": "758025",
      "Toraniapal B.O": "758025",
      "Dimirimunda B.O": "758014",
      "Haladharpur B.O": "758014",
      "Karagola B.O": "758022",
      "Samana B.O": "758022",
      "Atasahi B.O": "758015",
      "Kolimati B.O": "758015",
      "Sailong B.O": "758015",
      "Badajamposi B.O": "758027",
      "Balipokhari B.O": "758027",
      "Dhangadadiha B.O": "758027",
      "Kendudiha B.O": "758027",
      "Kusunpur B.O": "758027",
      "Dhenka B.O": "758023",
      "Sadha B.O": "758023",
      "Badasialimal B.O": "758028",
      "Gandadiha B.O": "758028",
      "Jiranga B.O": "758028",
      "Pitapiti B.O": "758028",
      "Sunapentha B.O": "758028",
      "Inchola B.O": "758083",
      "Orali B.O": "758083",
      "Binjabahal B.O": "758084",
      "Nuadihi B.O": "758084",
      "Baxibarigaon B.O": "758079",
      "Mishramala B.O": "758079",
      "Balibandha B.O": "758031",
      "Kaunrikala(B) B.O": "758031",
      "Raikala B.O": "758031",
      "Bhanda B.O": "758044",
      "Gundunia B.O": "758044",
      "Padmapur B.O": "758013",
      "Nelung B.O": "758002",
      "Bhandaridiha B.O": "758025",
      "Radhikadeipur B.O": "758032",
      "Tarimul B.O": "758025",
      "Banabir B.O": "758081",
      "Kolhabarapada B.O": "758036",
      "Kudipasa B.O": "758014",
      "Toranipokhari B.O": "758029",
      "Ambagadia B.O": "758022",
      "Jambhara B.O": "758022",
      "Mugupur B.O": "758022",
      "Sankho B.O": "758022",
      "Sulana B.O": "758022",
      "Bada Ektali B.O": "758015",
      "Khaliamenta B.O": "758015",
      "Naduan B.O": "758015",
      "Santoshpur B.O": "758015",
      "Ambo B.O": "758022",
      "Bancho B.O": "758022",
      "Biridi B.O": "758022",
      "Girigaon B.O": "758022",
      "Biragobindapur B.O": "758015",
      "Dhakotha B.O": "758015",
      "Gohira B.O": "758015",
      "Kanto B.O": "758015",
      "Trilochanpur B.O": "758015",
      "Kundapitha B.O": "758027",
      "Khajuribani B.O": "758079",
      "Tentlaposi B.O": "758079",
      "Chipinda B.O": "758031",
      "Handibhanga B.O": "758031",
      "Kandraposi B.O": "758031",
      "Khuntapada B.O": "758045",
      "Malda B.O": "758031",
      "Baiganpal B.O": "758027",
      "Bandakanda Haladharpur B.O": "758027",
      "Barahatipura B.O": "758027",
      "Bangore B.O": "758023",
      "Badanuagaon B.O": "758028",
      "Bhawanarpur B.O": "758028",
      "Chakradharpur B.O": "758028",
      "Hundapalasapal B.O": "758028",
      "Pithagola B.O": "758028",
      "Tambahara B.O": "758028",
      "Thakurapada B.O": "758028",
      "Chhenapadi B.O": "758083",
      "Mareigaon B.O": "758083",
      "Chhamunda B.O": "758084",
      "Hunda B.O": "758079",
      "Junga B.O": "758079",
      "Masinajodi B.O": "758079",
      "Somagiri B.O": "758079",
      "Arsala B.O": "758031",
      "Kanjipani B.O": "758018",
      "Kathabaunsuli B.O": "758031",
      "Khendra B.O": "758031",
      "Parajanpur B.O": "758031",
      "Silisuan B.O": "758031",
      "Bichakundi B.O": "758034",
      "Gurutuan B.O": "758034",
      "Bankia B.O": "758044",
      "Chauthia B.O": "758044",
      "Pokharia B.O": "758044",
      "Ghutur B.O": "758002",
      "Ranki B.O": "758002",
      "Baripal B.O": "758025",
      "Daradipal B.O": "758025",
      "Kochianandi B.O": "758025",
      "Damahuda B.O": "758081",
      "Badaposi B.O": "758014",
      "Nahabeda B.O": "758031",
      "Palasapanga B.O": "758031",
      "Jajanga B.O": "758034",
      "Badanai B.O": "758044",
      "Bodapalasa B.O": "758002",
      "Balarampur B.O": "758025",
      "Balipal B.O": "758025",
      "Khalapal B.O": "758025",
      "Gholkunda B.O": "758081",
      "Goras B.O": "758081",
      "Khadikapada B.O": "758081",
      "Mirigikhoji B.O": "758081",
      "Bolaniposi B.O": "758014",
      "Dimba B.O": "758014",
      "Danar B.O": "756121",
      "Gedma B.O": "756121",
      "Dimiria B.O": "756121",
      "Sadanga B.O": "756121",
      "Salinia B.O": "756121",
      "Jadichatar B.O": "758017",
      "Kalikaprasad B.O": "758047",
      "Kandra B.O": "758047",
      "Naradapur B.O": "758047",
      "Nayakrihsnapur B.O": "758047",
      "Nischintapur B.O": "758047",
      "Parsala B.O": "758047",
      "Kapundi B.O": "758016",
      "Raidiha B.O": "758016",
      "Tanda B.O": "758016",
      "Tavasarua B.O": "758016",
      "Khalana B.O": "758043",
      "Machhala B.O": "758043",
      "Madhukeshari B.O": "758043",
      "Nandabara B.O": "758043",
      "Pandua B.O": "758043",
      "Patsura B.O": "758043",
      "Bimala B.O": "758076",
      "Birabarpur Nuagaon B.O": "758076",
      "Kaliahata B.O": "758076",
      "Karamangi B.O": "758076",
      "Khuntapingu B.O": "758045",
      "Malarpada B.O": "758045",
      "Badagambharia B.O": "758017",
      "Murusuan B.O": "758017",
      "Balabhadrapur B.O": "758087",
      "Basudevpur B.O": "758047",
      "Rajia B.O": "758047",
      "Bholapada B.O": "758016",
      "Gujitangiri B.O": "758016",
      "Bhaluka B.O": "758043",
      "Jalasuan B.O": "758043",
      "Ramachandrapur B.O": "758043",
      "Panchupally B.O": "758020",
      "Tolankapada B.O": "758020",
      "Podanga B.O": "758076",
      "Raisuan Patkholi B.O": "758076",
      "Guptaganga B.O": "758018",
      "Dumuria B.O": "758030",
      "Tangarpada B.O": "758030",
      "Baliparbata B.O": "758026",
      "Doblapal B.O": "758019",
      "Purunaghati B.O": "758021",
      "Salabani B.O": "758021",
      "Bileipada B.O": "758038",
      "Kasia(KA) B.O": "758035",
      "Serenda B.O": "758035",
      "Revanapalaspal B.O": "758080",
      "Kainta B.O": "758041",
      "Panchapokharia B.O": "758041",
      "Sarei B.O": "758041",
      "Sunaposi B.O": "758041",
      "Kahaliagadia B.O": "758078",
      "Manoharpur B.O": "758021",
      "Padua B.O": "758032",
      "Rasabantala B.O": "758032",
      "Taramakanta B.O": "758085",
      "Raigoda B.O": "758085",
      "Singpur B.O": "758085",
      "Dabuna B.O": "758086",
      "Basantapur B.O": "758086",
      "Binida B.O": "758087",
      "Purumunda B.O": "758087",
      "Rutisila B.O": "758087",
      "Kantiapada B.O": "758017",
      "Kendeiposi B.O": "758017",
      "Silida B.O": "758017",
      "Amalanigoda B.O": "758047",
      "Anseikala B.O": "758047",
      "Nuagaon B.O": "758013",
      "Birikala B.O": "758038",
      "Daduan B.O": "758038",
      "Deojhar B.O": "758038",
      "Kolhahundula B.O": "758038",
      "Thakurani B.O": "758035",
      "Billa B.O": "758080",
      "Chilikdhara B.O": "758080",
      "Karadapal B.O": "758080",
      "Masinajoda B.O": "758080",
      "Kansa B.O": "758082",
      "Tangiriapal B.O": "758082",
      "Chamakpur B.O": "758041",
      "Dhobakuchuda B.O": "758041",
      "Jagannathpur Ashram B.O": "758041",
      "Soso B.O": "758078",
      "Bholabeda B.O": "758029",
      "Chinamaliposi B.O": "758029",
      "Kathabari B.O": "758029",
      "Katrabeda B.O": "758029",
      "Poipani B.O": "758029",
      "Badabaliposi B.O": "758016",
      "Baratania B.O": "758016",
      "Alati B.O": "758043",
      "Batto B.O": "758043",
      "Bhaganai B.O": "758043",
      "Bailo B.O": "758020",
      "Belabahali B.O": "758020",
      "Purujoda B.O": "758076",
      "Barhagarh B.O": "758018",
      "Bayakumutia B.O": "758018",
      "Champei B.O": "758018",
      "Pandadar B.O": "758018",
      "Erendei B.O": "758030",
      "Gobarbeda B.O": "758030",
      "Mushakhari B.O": "758030",
      "Saraskela B.O": "758030",
      "Goda B.O": "758019",
      "Karadangi B.O": "758019",
      "Khuntapada Charigarh B.O": "758019",
      "Oriya B.O": "758019",
      "Talapada B.O": "758019",
      "Kankada B.O": "758046",
      "Khireitangiri B.O": "758046",
      "Putugaon B.O": "758046",
      "Baikala B.O": "758045",
      "Jamuda B.O": "758045",
      "Khajirapat B.O": "758045",
      "Baria B.O": "758032",
      "Baunsuli B.O": "758032",
      "Kushakala B.O": "758085",
      "Kadakala B.O": "758085",
      "Kumundi (KHA) B.O": "758085",
      "Nayakote B.O": "758085",
      "Chormalda B.O": "758086",
      "Guruda B.O": "758086",
      "Palasa (KHA) B.O": "758086",
      "Jharbeda B.O": "758087",
      "Taneipal B.O": "758021",
      "Taratara B.O": "758021",
      "Bhadrasahi B.O": "758035",
      "Bhuyanroida B.O": "758035",
      "Jamudalak B.O": "758041",
      "Sasanga B.O": "758041",
      "Bidyadharpur B.O": "758078",
      "Padhiaripally B.O": "758078",
      "Muktapur B.O": "758029",
      "Palanghati B.O": "758029",
      "Pipilia B.O": "758029",
      "Chakundapal B.O": "758017",
      "Jamunaposi B.O": "758017",
      "Basira B.O": "758047",
      "Gumura B.O": "758047",
      "Taduabahal B.O": "758047",
      "Begna B.O": "758016",
      "Jata B.O": "758019",
      "Budhikapudi B.O": "758046",
      "Jyotipur B.O": "758046",
      "Sadangi B.O": "758046",
      "Silipada B.O": "758045",
      "Badaneuli B.O": "758032",
      "Bhuinpur B.O": "758032",
      "Gidhibas B.O": "758032",
      "Jally B.O": "758032",
      "Sarasinga B.O": "758032",
      "Tukudiha B.O": "758032",
      "Karangadihi B.O": "758085",
      "Baragoda B.O": "758085",
      "Urumunda B.O": "758085",
      "Balada B.O": "758086",
      "Silijoda B.O": "758086",
      "Panasadiha B.O": "758021",
      "Raitola B.O": "758021",
      "Guali B.O": "758035",
      "Nalda B.O": "758035",
      "Sagadapata B.O": "758080",
      "Balagoda B.O": "758037",
      "Alutuma B.O": "758082",
      "Kadagadia B.O": "758041",
      "Barigaon B.O": "758078",
      "Raighati B.O": "758078",
      "Ketanga B.O": "758029",
      "Digiposi B.O": "758016",
      "Tendra B.O": "758016",
      "Garabandagoda B.O": "758043",
      "Kendukhunta B.O": "758043",
      "Madanpur B.O": "758043",
      "Purunabandagoda B.O": "758043",
      "Taruan B.O": "758043",
      "Purunia B.O": "758020",
      "Tukuna B.O": "758020",
      "Akula B.O": "758076",
      "Bhimkand B.O": "758076",
      "Sunduria B.O": "758076",
      "Kuanr B.O": "758018",
      "Brahmanideo B.O": "758030",
      "Deoladiha B.O": "758019",
      "Chemana B.O": "758046",
      "Childa B.O": "758046",
      "Phulkanlei B.O": "758046",
      "Asanpat B.O": "758032",
      "Badadumuria B.O": "758032",
      "Bhodaposi B.O": "758032",
      "Bhulda B.O": "758032",
      "Kaunrikala(A) B.O": "758032",
      "Niundi B.O": "758032",
      "Silitia B.O": "758032",
      "Jatra B.O": "758085",
      "Fuljhar B.O": "758085",
      "Belda B.O": "758086",
      "Badapichhula B.O": "758087",
      "Patilo B.O": "758087",
      "Dhrupada B.O": "758013",
      "Kusumita B.O": "758013",
      "Mahadeijoda B.O": "758013",
      "Raghunathpur B.O": "758014",
      "Bauripada B.O": "758013",
      "Birakishorepur B.O": "758013",
      "Mandua B.O": "758014",
      "Gobardhan B.O": "758013",
      "Kempasada B.O": "758013",
      "Sankir B.O": "758013",
      "Maidankela B.O": "758014",
      "Sirishpal B.O": "758014",
      "Kadagarh B.O": "758013",
      "Sendkap B.O": "758013",
      "Tikarpada B.O": "758013",
      "Angarua B.O": "758021",
      "Bankhidi B.O": "758021",
      "Gayalamunda B.O": "758021",
      "Kantipal B.O": "758021",
      "Badapadana B.O": "758021",
      "Kodapada B.O": "758021",
      "Baladuan B.O": "758021",
      "Baunsagarh B.O": "758021",
      "Kathakata B.O": "758021",
      "Keonjhargarh H.O": "758001",
      "Jhumpura S.O": "758031",
      "Keonjhar Bazar S.O": "758002",
      "Keonjhar Court S.O": "758001",
      "Matkambeda S.O": "758036",
      "Rajanagar S.O": "758017",
      "Suakati S.O": "758018",
      "Banspal S.O": "758085",
      "Bamebari S.O.": "758086",
      "Jagamohanpur S.O": "758084",
      "Madhapur S.O": "758001",
      "Naranpur S.O": "758014",
      "Raisuan S.O": "758013",
      "Sirigida S.O": "758076",
      "Talapada S.O": "758026",
      "Turumunga S.O": "758046",
      "Pandapada S.O": "758087",
      "Hadagarh S.O": "758023",
      "Harichandanpur S.O": "758028",
      "Janghira S.O": "758079",
      "Joda S.O": "758034",
      "Keonjhar New Markt S.O": "758001",
      "Keonjhar Science College S.O": "758001",
      "Kiriburu Hill Top S.O": "758040",
      "Machhagarh S.O": "758081",
      "Remuli S.O": "758047",
      "Saharpada S.O": "758016",
      "Salapada S.O": "758020",
      "Ukhunda S.O": "758032",
      "Baneikala S.O": "758038",
      "Brahmanipal S.O": "758082",
      "Champua S.O": "758041",
      "Dhanurjaypur S.O": "758078",
      "Dhenkikote S.O": "758029",
      "Anandapur S.O (Kendujhar)": "758021",
      "Barbil S.O": "758035",
      "Bhagamunda S.O": "758080",
      "Ghatagaon S.O": "758027",
      "Bolani S.O": "758037",
      "Ghasipura S.O": "758015",
      "Anandapur College S.O": "758021",
      "Fakirpur S.O": "758022",
      "Hatadihi S.O": "758083",
      "Karanjia S.O (Kendujhar)": "758044",
      "Keonjhar Atopur S.O": "758002",
      "Keonjhar Mining School S.O": "758001",
      "Kushaleswar S.O": "758025",
      "Sainkul S.O": "758043",
      "Sundara Shiv Mandir S.O": "758035",
      "Swampatna S.O": "758030",
      "Telkoi S.O": "758019",
      "Udayapur S.O": "758045"
    },
    "JAGATSINGHAPUR": {
      "Dihatartanga B.O": "754114",
      "ALANDO B.O": "754130",
      "Alipingal B.O": "754294",
      "Taradapada B.O": "754294",
      "Palasol B.O": "754294",
      "Sabhamul B.O": "754114",
      "B.Jankoti B.O": "754114",
      "Mohiuddinpur B.O": "754294",
      "Nabapatna B.O": "754114",
      "Kundeswar B.O": "754107",
      "Puran B.O": "754102",
      "Rambhadeipur B.O": "754102",
      "Tarikund B.O": "754102",
      "Alabol B.O": "754108",
      "Alavar B.O": "754108",
      "Alikanta B.O": "754108",
      "Odisso B.O": "754294",
      "Ashrampatana B.O": "754109",
      "Chanarpur B.O": "754107",
      "Goudunipadia B.O": "754107",
      "Bagalpur B.O": "754102",
      "Chasikhand B.O": "754102",
      "Baigani B.O": "754108",
      "Kalio B.O": "754108",
      "Kortal B.O": "754109",
      "Palli B.O": "754294",
      "Madhusudanpursasan B.O": "754114",
      "Punanga B.O": "754294",
      "Nati B.O": "754294",
      "Ghodansa B.O": "754107",
      "Jamugaon B.O": "754107",
      "Baredia B.O": "754102",
      "Baharana B.O": "754108",
      "Sitahlo B.O": "754294",
      "Palasa B.O": "754114",
      "Adhangagarh B.O": "754102",
      "Ichhapur B.O": "754108",
      "Naradia B.O": "754108",
      "Parahat B.O": "754108",
      "Garhbisunpur B.O": "754110",
      "Japabhuan B.O": "754139",
      "Jirailo B.O": "754139",
      "Kanipada B.O": "754139",
      "Kunjakothi B.O": "754139",
      "Kotian B.O": "754106",
      "Mahilo B.O": "754106",
      "Mudupur B.O": "754106",
      "Nandan B.O": "754106",
      "Peteipur B.O": "754106",
      "Sarana B.O": "754106",
      "Sidhal B.O": "754106",
      "Begunia B.O": "754136",
      "Govindpur B.O": "754136",
      "Harisinghpur B.O": "754136",
      "Samantarapur B.O": "754162",
      "Sudarsan B.O": "754162",
      "Bhutmundai B.O": "754141",
      "Chatua B.O": "754141",
      "Dhinkia B.O": "754141",
      "Rahana  B.O": "754119",
      "Gopalpur B.O": "754104",
      "Radhanga B.O": "754104",
      "Rahadinga B.O": "754104",
      "Redhua B.O": "754104",
      "S.Basandhara B.O": "754111",
      "Olarah B.O": "754110",
      "Panchapalli B.O": "754110",
      "Nowgang B.O": "754109",
      "Ambiki B.O": "754139",
      "Baijanga B.O": "754106",
      "Katara B.O": "754106",
      "Kuradha B.O": "754136",
      "Sardola B.O": "754136",
      "Bishanpur B.O": "754135",
      "Jhimani B.O": "754141",
      "Nuagaon B.O": "754141",
      "Ambasal B.O": "754119",
      "Apandara B.O": "754119",
      "Baramundali B.O": "754119",
      "Marichapur B.O": "754119",
      "Tentulibelari B.O": "754119",
      "Badamundilo B.O": "754114",
      "Bachhalo B.O": "754113",
      "Nandigram B.O": "754113",
      "Shikhar B.O": "754113",
      "Parbatipur B.O": "754111",
      "Ukundara B.O": "754111",
      "Sompur Benahar B.O": "754110",
      "Galadhari B.O": "754109",
      "Bhitarandhari B.O": "754139",
      "Khorat B.O": "754106",
      "Krushnadaspur B.O": "754106",
      "Mulugaon B.O": "754106",
      "Kabalpur B.O": "754136",
      "Malanda B.O": "754136",
      "Amberi B.O": "754162",
      "Bilaspur B.O": "754162",
      "Balia B.O": "754141",
      "Balitutha B.O": "754141",
      "Paradeepgarh B.O": "754141",
      "Anantapur B.O": "754119",
      "Khalagaon B.O": "754119",
      "Oskana B.O": "754119",
      "Saibirikantilo B.O": "754114",
      "Dedhasurdeuli B.O": "754104",
      "Purunabasanta B.O": "754104",
      "Rasulpur B.O": "754104",
      "Sanra B.O": "754104",
      "Angeswarpada B.O": "754113",
      "Korua B.O": "754113",
      "Rohia B.O": "754113",
      "Sangrampur B.O": "754108",
      "Tertang B.O": "754108",
      "Hajipur B.O": "754111",
      "Kulakaijanga B.O": "754111",
      "Madhyasasan B.O": "754111",
      "Goda B.O": "754110",
      "Janakadeipur B.O": "754110",
      "Kanjiakan B.O": "754110",
      "Titira B.O": "754110",
      "Sagadailo BO": "754294",
      "Chasapada B.O": "754106",
      "Tentulipada B.O": "754136",
      "Gopiakud B.O": "754141",
      "Mangarajpur B.O": "754141",
      "Paradeeplock B.O": "754141",
      "S.Nalakani B.O": "754141",
      "Taladanda B.O": "754141",
      "Adhanga B.O": "754119",
      "Bansa B.O": "754113",
      "Bodal B.O": "754113",
      "Deriki B.O": "754113",
      "Anolipatna B.O": "754140",
      "Kiadingiri B.O": "754140",
      "Arodei B.O": "754138",
      "Pipalamadhaba B.O": "754160",
      "Tandikul B.O": "754138",
      "Tulang B.O": "754138",
      "Adheikul B.O": "754132",
      "Alla B.O": "754132",
      "Samanga B.O": "754132",
      "Porgadei B.O": "754160",
      "Ibrisingh B.O": "754138",
      "Jhankad B.O": "754138",
      "Nimol B.O": "754138",
      "Lankapada B.O": "754134",
      "Paida B.O": "754138",
      "Dagrpada B.O": "754160",
      "Dainlo B.O": "754137",
      "Dhanua B.O": "754137",
      "Gorada B.O": "754160",
      "Gothina B.O": "754132",
      "Sadeipur B.O": "754132",
      "Borikhi B.O": "754140",
      "Lathanga B.O": "754140",
      "Pankapal B.O": "754140",
      "Jaipur B.O": "754133",
      "Patenigaon B.O": "754133",
      "Dhunpur B.O": "754138",
      "Garam B.O": "754138",
      "Pokhariapada B.O": "754138",
      "Srirampur B.O": "754138",
      "Narijanga B.O": "754137",
      "Tarajanga B.O": "754137",
      "Tentoi B.O": "754113",
      "Purana Odapada B.O": "754132",
      "GADAMA B.O": "754132",
      "Bharalo B.O": "754140",
      "Gobardhanpur B.O": "754160",
      "Kothamula  B.O": "754140",
      "Mahimadeipur B.O": "754140",
      "Pandua B.O": "754140",
      "Potanai B.O": "754140",
      "Nuapada B.O": "754133",
      "Bhiranga B.O": "754138",
      "Dihasahi B.O": "754138",
      "S. Hazipur B.O": "754138",
      "Salamanga B.O": "754138",
      "Sankheswar B.O": "754137",
      "Jagatsinghpur H.O": "754103",
      "Kaduapada S.O": "754106",
      "Mandasahi S.O": "754114",
      "Alanahat S.O": "754107",
      "Biridiroad S.O": "754111",
      "Kanakpur S.O": "754136",
      "Kujang S.O": "754141",
      "Madhuban S.O (Jagatsinghapur)": "754142",
      "Nalibar S.O": "754104",
      "Ppl Township S.O": "754145",
      "Svm College S.O": "754103",
      "Tirtol S.O": "754137",
      "Anakhia S.O": "754102",
      "Balikuda S.O": "754108",
      "Borikina S.O": "754110",
      "Kolar S.O": "754162",
      "Machhagaon S.O": "754119",
      "Manijanga S.O": "754160",
      "Naugaonhat S.O": "754113",
      "Raghunathpur S.O (Jagatsinghapur)": "754132",
      "Tiran S.O": "754138",
      "Tarpur S.O": "754133",
      "IOCL(Paradeep) S.O": "754141",
      "Atharbanki Rly Colony S.O": "754120",
      "Chatra S.O (Jagatsinghapur)": "754294",
      "Debidol S.O": "754109",
      "Ersama S.O": "754139",
      "Krishnanandapur S.O": "754135",
      "Paradip S.O": "754142",
      "Rahama S.O": "754140",
      "Sector 21 S.O": "754143"
    },
    "BALESHWAR": {
      "Khan Nagar B.O": "756060",
      "Attapur B.O": "756045",
      "Bainanda Mangarajpur B.O": "756045",
      "Badapokhari B.O": "756047",
      "Bana Bishnupur B.O": "756047",
      "Dagarpada B.O": "756047",
      "Dalanga B.O": "756047",
      "Dhitpura B.O": "756030",
      "Kuldiha B.O": "756030",
      "Mohammad Nagar B.O": "756030",
      "Vellora B.O": "756030",
      "Bishnupur B.O": "756051",
      "Ghantiary B.O": "756026",
      "Jamkunda B.O": "756026",
      "Panchurukhi B.O": "756026",
      "Rasalpur B.O": "756079",
      "Nilpura B.O": "756079",
      "Alalbindha B.O": "756036",
      "Baitpur B.O": "756036",
      "Batagramghat B.O": "756036",
      "Deulahat B.O": "756036",
      "Angula B.O": "756045",
      "Kedarpur B.O": "756045",
      "Sajanpur B.O": "756045",
      "Simulia B.O": "756045",
      "Singa Khunta B.O": "756045",
      "Ranasahi B.O": "756002",
      "Janhia B.O": "756045",
      "Sabira R.S. B.O": "756045",
      "Sarsankha B.O": "756045",
      "Wada B.O": "756045",
      "Sargaon B.O": "756027",
      "Achutipur B.O": "756047",
      "Kurunta B.O": "756047",
      "Sampei B.O": "756047",
      "Gudikhal B.O": "756030",
      "Badasimulia B.O": "756026",
      "Rella B.O": "756026",
      "Khalabadia B.O": "756038",
      "Pithapur B.O": "756038",
      "Bajitpur B.O": "756085",
      "Aruhabruti B.O": "756079",
      "Barbatia B.O": "756079",
      "Kothia B.O": "756022",
      "Guneibasan B.O": "756036",
      "Dwarika B.O": "756044",
      "Kalyani B.O": "756044",
      "Maharudrapur B.O": "756044",
      "Talakurunia B.O": "756044",
      "Alumeda B.O": "756027",
      "Bahabalpur B.O": "756027",
      "Chhanua B.O": "756027",
      "Dublagadi B.O": "756027",
      "Panchupada B.O": "756027",
      "Sartha B.O": "756027",
      "Mituani B.O": "756048",
      "Rairamchandrapur B.O": "756086",
      "Chakajagannathpur B.O": "756043",
      "Kasba Jaipur B.O": "756043",
      "Sundarpur B.O": "756059",
      "Balia Farm B.O": "756056",
      "Dharaganj B.O": "756020",
      "Kans B.O": "756020",
      "Sathilabalbalia B.O": "756020",
      "Tikirapal B.O": "756020",
      "Dahapada B.O": "756003",
      "Sarugaon B.O": "756049",
      "Chhatrapur B.O": "756058",
      "Hatsahi B.O": "756040",
      "Podasul B.O": "756040",
      "Siadimal B.O": "756040",
      "Bankeswar B.O": "756021",
      "Bhimpur B.O": "756021",
      "Gududapatna B.O": "756019",
      "Kanrali B.O": "756019",
      "Khirachora Gopinath B.O": "756019",
      "Somnathpur B.O": "756019",
      "Kharadiha B.O": "756041",
      "Narayanapur B.O": "756041",
      "Tenda B.O": "756041",
      "Barun Singh B.O": "756060",
      "Gudupai B.O": "756025",
      "Parkhi B.O": "756025",
      "Sahada B.O": "756080",
      "Asuria B.O": "756047",
      "Gandibed B.O": "756047",
      "Srikona B.O": "756025",
      "Aruhabad B.O": "756044",
      "Jagannathpur B.O": "756044",
      "Karanjabindha B.O": "756044",
      "Ambapunja B.O": "756027",
      "Buanl B.O": "756027",
      "Chaksartha B.O": "756027",
      "Digdha B.O": "756027",
      "Nagram B.O": "756027",
      "Odangi B.O": "756027",
      "Olipur B.O": "756027",
      "Arjunpur B.O": "756048",
      "Fatehpur B.O": "756048",
      "Mahatipur B.O": "756048",
      "Alasuan B.O": "756043",
      "Boita B.O": "756043",
      "Jirtal B.O": "756043",
      "Machhua B.O": "756020",
      "Mahispata B.O": "756020",
      "Narasingpur B.O": "756020",
      "Nimpal B.O": "756020",
      "Rasaslpur B.O": "756020",
      "Chasakhand B.O": "756003",
      "Sahupada B.O": "756003",
      "Sindhia B.O": "756003",
      "Arabandha B.O": "756058",
      "Jamuna B.O": "756058",
      "Kishorchandrapur B.O": "756058",
      "Kahalia B.O": "756040",
      "Mirigini B.O": "756040",
      "Shyamsundarpur B.O": "756040",
      "Jaydev Kasba B.O": "756021",
      "Kuanrpur B.O": "756021",
      "Armala B.O": "756019",
      "Badapal B.O": "756019",
      "Gobindpur B.O": "756019",
      "Lachman Khunta B.O": "756028",
      "Nalabahar B.O": "756028",
      "Nuagaon B.O": "756024",
      "Routpada B.O": "756028",
      "Garadihi B.O": "756041",
      "Gopalpur B.O": "756041",
      "Jadibali B.O": "756041",
      "Jamudiha B.O": "756041",
      "Jageswarpada B.O": "756044",
      "Srijang B.O": "756044",
      "Jhinkiria B.O": "756027",
      "Solpata B.O": "756027",
      "Nachhipur B.O": "756048",
      "Sarkana B.O": "756048",
      "Kuligaon B.O": "756043",
      "Padagaon B.O": "756043",
      "Sarsatia B.O": "756043",
      "Chhanapur B.O": "756056",
      "Genguti B.O": "756056",
      "Bhounriabad B.O": "756020",
      "Durgadevi B.O": "756020",
      "Singiri B.O": "756020",
      "Fulwar kaswa B.O": "756003",
      "Haripur B.O": "756115",
      "Bhimpura B.O": "756003",
      "Khairagobindapur B.O": "756049",
      "Srirampur B.O": "756029",
      "Pithahat B.O": "756058",
      "Uppardiha B.O": "756058",
      "Dhobasila B.O": "756040",
      "Dahisada B.O": "756045",
      "Hatikhulia B.O": "756045",
      "Kesharipur B.O": "756045",
      "Kudei Nadigaon B.O": "756045",
      "Mahu Muhana B.O": "756045",
      "Mangalapur B.O": "756045",
      "Mulisingh B.O": "756045",
      "Radhaballavpur B.O": "756045",
      "Manikula B.O": "756002",
      "Panjibag B.O": "756002",
      "Puruna Balasore B.O": "756002",
      "Chasipada B.O": "756030",
      "Asti B.O": "756026",
      "Badhapal B.O": "756026",
      "Paschima Bad B.O": "756026",
      "Adangapantei B.O": "756038",
      "Bartana B.O": "756086",
      "Iswarpur B.O": "756042",
      "Jayarampur B.O": "756038",
      "Baiganabadia B.O": "756079",
      "Barada B.O": "756134",
      "Chakrada B.O": "756022",
      "Makhanpur B.O": "756047",
      "Manipur B.O": "756047",
      "Saundia B.O": "756047",
      "Gopinathpur B.O": "756036",
      "Dalua B.O": "756026",
      "Jharapimpal B.O": "756026",
      "Malaruan B.O": "756038",
      "Naskarpur B.O": "756085",
      "Nayapalli B.O": "756079",
      "Kothapada B.O": "756022",
      "Mukulisi B.O": "756022",
      "Haridaspur B.O": "756036",
      "Bardhanpur B.O": "756021",
      "Inchudi B.O": "756021",
      "Januganj B.O": "756019",
      "Kashimpur B.O": "756019",
      "Udambar B.O": "756019",
      "Anko B.O": "756028",
      "Hatiadiha B.O": "756028",
      "Kalakad B.O": "756041",
      "Matiali B.O": "756041",
      "Telipal B.O": "756041",
      "Bahala B.O": "756060",
      "Hidigaon B.O": "756025",
      "Antara B.O": "756134",
      "Badanuagaon B.O": "756115",
      "Srirampur Road B.O": "756023",
      "Gop B.O": "756087",
      "Ambliatha B.O": "756087",
      "Sikharpur B.O": "756087",
      "Pandasuni B.O": "756044",
      "Rahaniaganj B.O": "756044",
      "Nachinta B.O": "756043",
      "Panpana B.O": "756043",
      "Pratapada B.O": "756043",
      "Guapal B.O": "756059",
      "Kaithagadia B.O": "756059",
      "Nahanga B.O": "756059",
      "Pani Chhatra B.O": "756059",
      "BASANTAPUR BO": "756056",
      "Begunia B.O": "756020",
      "Patna B.O": "756020",
      "Pundala B.O": "756020",
      "Badasindhia B.O": "756003",
      "Ghodapada B.O": "756003",
      "Nijampur B.O": "756003",
      "Reserve Police Line B.O": "756003",
      "Aghirapada B.O": "756049",
      "Darkholi B.O": "756049",
      "Tentulia B.O": "756058",
      "Naraharipur B.O": "756019",
      "Chandarpada B.O": "756134",
      "Jalanga Gandibed B.O": "756134",
      "Garasang B.O": "756134",
      "Mirjapur B.O": "756134",
      "Ratina B.O": "756115",
      "Kalaspur B.O": "756166",
      "Nikhira B.O": "756023",
      "Chamara Gaon B.O": "756087",
      "Lakhananath Road B.O": "756087",
      "Mathuranath B.O": "756087",
      "Malipal B.O": "756087",
      "Alalpur B.O": "756087",
      "Gourgadi B.O": "756111",
      "Govindapur B.O": "756126",
      "Markona B.O": "756126",
      "Maitapur B.O": "756111",
      "Mohammadpur B.O": "756126",
      "Rudhunga B.O": "756126",
      "Sahigaon B.O": "756126",
      "Anandapur B.O": "756126",
      "Bari B.O": "756126",
      "Bariha B.O": "756126",
      "Bati B.O": "756126",
      "Jamjhadi B.O": "756126",
      "Alda B.O": "757082",
      "Arakhpur B.O": "756182",
      "Damodarpur B.O": "756182",
      "Kanchpada B.O": "756166",
      "Parbatipur B.O": "756166",
      "Ramakrishnapur B.O": "756166",
      "Srimantapur B.O": "756166",
      "Chalunigaon B.O": "756168",
      "Kanheibindha B.O": "756168",
      "Khirkona B.O": "756168",
      "Kalama B.O": "756033",
      "Kankei B.O": "756033",
      "Mahuduma B.O": "756033",
      "Chalanti B.O": "756086",
      "Chhamouza B.O": "756086",
      "Mohammad Nagarpatna B.O": "756086",
      "Rajpur B.O": "756086",
      "Gilajodi B.O": "756081",
      "Nabra B.O": "756081",
      "Naikudi B.O": "756081",
      "Paunsakuli B.O": "756081",
      "Putura B.O": "756081",
      "Remu B.O": "756081",
      "Tadada B.O": "756081",
      "Baharda B.O": "756035",
      "Dakhinanadbani B.O": "756035",
      "Nachinda B.O": "756035",
      "Budhakusumi B.O": "756034",
      "Ikida B.O": "756034",
      "Kamarsalia B.O": "756034",
      "Jambhirai B.O": "756024",
      "Kashafal B.O": "756024",
      "Mandhatabazar B.O": "756024",
      "Nadbani B.O": "756024",
      "Dagra B.O": "756083",
      "Dangapita B.O": "756083",
      "Jagai B.O": "756083",
      "Balanga B.O": "756046",
      "Kandagaridi B.O": "756042",
      "Kochiakoili B.O": "756042",
      "Santragadia Bazar B.O": "756042",
      "Saud B.O": "756042",
      "Thalasada B.O": "756042",
      "Jamalpur B.O": "756086",
      "Khadikapada B.O": "756029",
      "Kushadiha (A) B.O": "756029",
      "Uitikiri B.O": "756029",
      "Santhapada B.O": "756055",
      "Sirapur B.O": "756055",
      "Khanabad B.O": "756033",
      "Khuard B.O": "756033",
      "Badhan B.O": "756080",
      "Keshpura B.O": "756086",
      "Chakaisab B.O": "756035",
      "Chandakusumi B.O": "756035",
      "Dahunda B.O": "756035",
      "Madhupura B.O": "756035",
      "Mahagab B.O": "756035",
      "Putina B.O": "756035",
      "Upla Hat B.O": "756035",
      "Khalina B.O": "756034",
      "Badas B.O": "756083",
      "Bagada B.O": "756083",
      "Gadasahi Baliapal B.O": "756023",
      "Tentei B.O": "756046",
      "Rupkhand B.O": "756051",
      "Gandasthapur B.O": "756042",
      "Dandika B.O": "756029",
      "Haladiapada B.O": "756029",
      "Machhadiha B.O": "756029",
      "Mathani B.O": "756029",
      "Sadanandapur B.O": "756029",
      "Ghasua B.O": "756055",
      "Balaramgadi B.O": "756025",
      "Kabataghati B.O": "756033",
      "Munutunia B.O": "756033",
      "Raibania B.O": "756033",
      "Kainagari B.O": "756080",
      "Machhada B.O": "756080",
      "Panasha B.O": "756080",
      "Salikotha B.O": "756086",
      "Dundukut B.O": "756081",
      "Barbatia Bazar B.O": "756039",
      "Balim B.O": "756035",
      "Belda B.O": "756035",
      "Durpal B.O": "756035",
      "Karihanda B.O": "756035",
      "Kusuda B.O": "756035",
      "Purusottampur B.O": "754223",
      "Ambadiha B.O": "756034",
      "Kasida B.O": "756034",
      "Khuluda B.O": "756034",
      "Balarampur B.O": "756024",
      "Panchupalli B.O": "756024",
      "Saudi B.O": "756024",
      "Betagadia B.O": "756083",
      "Chaumukh B.O": "756083",
      "Aliha B.O": "756182",
      "Baghua B.O": "756182",
      "Jamatkula B.O": "756083",
      "Beladandia B.O": "756023",
      "Debhog B.O": "756023",
      "Jathia B.O": "756023",
      "Kumbhari B.O": "756023",
      "Machharanka Simulia B.O": "756023",
      "Kuruda soro B.O": "756046",
      "Pakhar B.O": "756046",
      "Sankhapodadiha B.O": "756046",
      "Baharda Bazar B.O": "756029",
      "Barunagadia B.O": "756029",
      "Bidyadharpur B.O": "756029",
      "Kushadiha (B)church B.O": "756029",
      "Gud B.O": "756046",
      "Kharsahapur B.O": "756046",
      "Sahaspura B.O": "756046",
      "Bidubazar B.O": "756042",
      "Dhobachakurai B.O": "756029",
      "Mandrukula B.O": "756029",
      "Pandurangi B.O": "756029",
      "Mankidia B.O": "756033",
      "Olmara B.O": "756033",
      "Nimpada B.O": "756080",
      "Paiksida B.O": "756086",
      "Baliapati B.O": "756081",
      "Udayganjapatna B.O": "756039",
      "Baunsadiha B.O": "756035",
      "Dubsahi B.O": "756035",
      "Kachuadi B.O": "756035",
      "Khairda B.O": "756035",
      "Kotisahi B.O": "756035",
      "Demuria B.O": "756034",
      "Masanbaria B.O": "756034",
      "Badakuruda B.O": "756024",
      "Bolang B.O": "756024",
      "Baliapal Narayanpur B.O": "756083",
      "Chandamani B.O": "756083",
      "Karanja B.O": "756083",
      "Baliapal Katisahi B.O": "756023",
      "Belli B.O": "756023",
      "Ghantua B.O": "756023",
      "Khalamuhani B.O": "756023",
      "Nepura B.O": "756023",
      "Kumarjalina B.O": "756036",
      "Mankunda B.O": "756036",
      "Narayanpur B.O": "756036",
      "Sukhsandhapatna B.O": "756036",
      "Sultanpur B.O": "756036",
      "Kumarmuli B.O": "756036",
      "Naranmohantypadia B.O": "756037",
      "Sankhari B.O": "756037",
      "Sardhapur B.O": "756037",
      "Tukurihazira B.O": "756037",
      "Ashabandha B.O": "756033",
      "Jaleswarpur B.O": "756036",
      "Nimatpur B.O": "756036",
      "Soharia B.O": "756036",
      "Sugo B.O": "756084",
      "Bichitrapur B.O": "756037",
      "Baradiha B.O": "756033",
      "Nishanpur B.O": "756036",
      "Pasarbindha B.O": "756036",
      "Tarapur B.O": "756036",
      "Netua B.O": "756084",
      "Ausha B.O": "756037",
      "Nafrai B.O": "756037",
      "Bhandarikuli B.O": "756033",
      "Chudamanipur B.O": "756033",
      "Balasore H.O": "756001",
      "Jaleswar H.O": "756032",
      "Avana S.O": "756051",
      "Bahanaga S.O": "756042",
      "Fakirmohan College S.O": "756001",
      "Issannagar S.O": "756001",
      "Khantapada S.O": "756043",
      "Kuruda S.O": "756056",
      "Makalpur S.O": "756003",
      "Mitrapur S.O": "756020",
      "Mobarakpur S.O": "756045",
      "Raj Berhampur S.O": "756058",
      "Raj Nilgiri S.O": "756040",
      "Rupsa S.O": "756028",
      "Sahid Park S.O": "756003",
      "Sajanagarh S.O": "756041",
      "Soro Bazar S.O": "756045",
      "Soro College S.O": "756045",
      "Dungura S.O": "756182",
      "Simulia Bazar S.O": "756126",
      "Balasore Court S.O": "756001",
      "Barabati S.O": "756003",
      "Gopalpur S.O (Balasore)": "756044",
      "Haldipada S.O": "756027",
      "Khaira S.O (Baleswar)": "756048",
      "Kupari S.O": "756059",
      "Remuna S.O": "756019",
      "Sahadevkhunta S.O": "756001",
      "Sergarh S.O": "756060",
      "Sunhat S.O": "756002",
      "Baliapal S.O": "756026",
      "Dahamunda S.O": "756079",
      "Ada S.O": "756134",
      "Darada S.O": "756022",
      "Dhansimulia S.O": "756084",
      "Nayabazar Jaleswar S.O": "756032",
      "Turigaria S.O": "756047",
      "VYASAVIHAR S.O": "756089",
      "Bhograi S.O": "756038",
      "Hatigarh S.O (Baleswar)": "756033",
      "Irda S.O": "756080",
      "Jaleswar Railway Station S.O": "756086",
      "Jamsuli S.O": "756081",
      "Kakhra S.O": "756039",
      "Kamarda S.O": "756035",
      "Nampo S.O": "756034",
      "Nangaleswar S.O": "756024",
      "Pratappur S.O (Baleswar)": "756083",
      "Anantapur S.O (Baleswar)": "756046",
      "Azimabad S.O": "756001",
      "Balasore RS S.O": "756001",
      "Basta S.O": "756029",
      "Simulia S.O": "756126",
      "Chandipur S.O": "756025",
      "Oupada S.O": "756049",
      "Soro S.O": "756045",
      "Soro RS SO": "756045",
      "Amarda Road S.O": "756030",
      "Chandaneswar S.O": "756085",
      "Lakhananath S.O": "756087",
      "Chakabarahapur S.O": "756055",
      "Motiganj S.O (Baleswar)": "756003",
      "Nayabazar Balasore S.O": "756001",
      "Nilgiri College S.O": "756040",
      "Rasalpur S.O": "756021",
      "Sovarampur S.O": "756001",
      "Srikanthapur S.O": "756001",
      "Dehurda S.O": "756036",
      "Fulbani S.O": "756037",
      "Singla S.O": "756023",
      "Chormara S.O": "756088",
      "Balikhanda S.O": "756166"
    },
    "NAYAGARH": {
      "Gobardhan Prasad B.O": "752063",
      "Golapokhari B.O": "752063",
      "Kainfulia B.O": "752063",
      "Karabar B.O": "752063",
      "Nimani B.O": "752063",
      "Singarpalli B.O": "752082",
      "Duda B.O": "752089",
      "Baunsabati B.O": "752063",
      "Chakradharprasad B.O": "752063",
      "Nilakantheswarpur B.O": "752063",
      "Padmabati B.O": "752063",
      "Champagarh B.O": "752024",
      "Kerandatangi B.O": "752024",
      "Ghugudipada B.O": "752084",
      "Beruanbadi B.O": "752082",
      "Chadeyapalli B.O": "752089",
      "Kankanamendhi B.O": "752089",
      "Bijipur B.O": "752063",
      "Fategarh B.O": "752063",
      "Rakama B.O": "752063",
      "Tarabalo B.O": "752063",
      "B M S Nivas B.O": "752024",
      "Kandhanayagarh B.O": "752024",
      "Badasilinga B.O": "752084",
      "Gumi B.O": "752082",
      "Kaptapalli B.O": "752082",
      "Kujamendhi B.O": "752089",
      "Kulurukumpa B.O": "752089",
      "Nuagaon B.O": "752089",
      "Poda Sahi B.O": "752089",
      "Badasahara B.O": "752063",
      "Salapada B.O": "752063",
      "Tikiripada B.O": "752063",
      "Jamusahi B.O": "752079",
      "Neliguda B.O": "752084",
      "Srirampur B.O": "752084",
      "Takera B.O": "752084",
      "Chhamundia B.O": "752085",
      "Karadapada B.O": "752085",
      "Baulasahi B.O": "752092",
      "Bhaliadihi B.O": "752092",
      "Badabaramul B.O": "752025",
      "Bandhamunda B.O": "752025",
      "Nakithana B.O": "752025",
      "Baunsiapada B.O": "752068",
      "Champatipur B.O": "752068",
      "Gadadharprasad B.O": "752068",
      "Bodas B.O": "752077",
      "Gohiripada B.O": "752077",
      "Jadunathpur B.O": "752077",
      "K .Sikharpur B.O": "752077",
      "Kalapangi B.O": "752077",
      "Kiajhar B.O": "752077",
      "Komand B.O": "752090",
      "Balaramaprasad B.O": "752085",
      "Kishoreprasad B.O": "752085",
      "Raitadholamara B.O": "752085",
      "Dimisar B.O": "752092",
      "Mahatapalla B.O": "752025",
      "Badpandusar B.O": "752068",
      "Gunthuni B.O": "752068",
      "Saradhapur B.O": "752068",
      "Madhapur B.O": "752078",
      "Barabati B.O": "752077",
      "Bhagabanpur B.O": "752077",
      "Salajharia B.O": "752077",
      "Giridipalli B.O": "752090",
      "Madanpur B.O": "752090",
      "Gobindapurpanta B.O": "752093",
      "Jagannathprasad B.O": "752077",
      "Koska B.O": "752093",
      "Kumbharapada B.O": "752093",
      "Dihagaon B.O": "752093",
      "Nuapada B.O": "752093",
      "Badagotha B.O": "752094",
      "Chahali B.O": "752094",
      "Kendudhipi B.O": "752079",
      "Barapalli B.O": "752070",
      "Gambharidihi B.O": "752079",
      "Lenkudipada B.O": "752070",
      "Padmadeipur B.O": "752070",
      "Sikrida B.O": "752083",
      "Nandighore B.O": "752081",
      "Ranganipatna B.O": "752081",
      "Gourangapur B.O": "752026",
      "Khairapalli B.O": "752026",
      "Taria B.O": "752026",
      "Kulasar B.O": "752065",
      "Baunsagadia B.O": "752080",
      "Hariharpur B.O": "752080",
      "Bhogabadi B.O": "752091",
      "Malisar B.O": "752094",
      "Similisahi B.O": "752091",
      "Khatia B.O": "752079",
      "Khuntabandha B.O": "752079",
      "Lathipara B.O": "752079",
      "Machhipada B.O": "752070",
      "Malisahi B.O": "752070",
      "Dimiripali B.O": "752083",
      "Jakeda B.O": "752083",
      "Khalamada B.O": "752083",
      "Korada B.O": "752083",
      "Baunsagada B.O": "752026",
      "Brajarajpur B.O": "752026",
      "Narasinghpur B.O": "752026",
      "Badakumari B.O": "752065",
      "Kansada B.O": "752065",
      "Pancharida B.O": "752080",
      "Poibadi B.O": "752091",
      "Pokharigochha B.O": "752091",
      "Subalaya B.O": "752091",
      "Patanda B.O": "752085",
      "Rasanga B.O": "752085",
      "Damasahi B.O": "752092",
      "Sinduria B.O": "752025",
      "Harakrushnapur B.O": "752068",
      "Badabanpur B.O": "752078",
      "Dhanchangada B.O": "752078",
      "Baigania B.O": "752077",
      "Baladianuagaon B.O": "752077",
      "Banmalipurpatna B.O": "752077",
      "Singhapada B.O": "752077",
      "Rohibanka B.O": "752090",
      "Sunamuhin B.O": "752090",
      "Paradhip": "752094",
      "Darpanarayanpur B.O": "752079",
      "Ekiri B.O": "752079",
      "Notar B.O": "752079",
      "Golagola B.O": "752070",
      "Gotisahi B.O": "752070",
      "Kalyanpur B.O": "752070",
      "Kridaspur B.O": "752070",
      "Udayapur B.O": "752083",
      "Banthapur B.O": "752081",
      "Gaudaput B.O": "752081",
      "Kaibalyapur B.O": "752081",
      "Korapitha B.O": "752081",
      "Kurumabankatara B.O": "752081",
      "Balabhadrapur B.O": "752026",
      "Basudia B.O": "752026",
      "Natimi B.O": "752026",
      "Pimpal B.O": "752026",
      "Sarangadharpur B.O": "752026",
      "Barasahi B.O": "752080",
      "Sikharpur B.O": "752080",
      "Tumandi B.O": "752084",
      "Belapadapatna B.O": "752085",
      "Rajingi B.O": "752085",
      "Jasodapur B.O": "752025",
      "Jharapada B.O": "752025",
      "Mayurjhalia B.O": "752025",
      "Biruda B.O": "752068",
      "Sidhamula B.O": "752078",
      "Benagadia B.O": "752077",
      "Khalisahi B.O": "752077",
      "Purusottamprasad B.O": "752077",
      "Dandor B.O": "752090",
      "Adakata B.O": "752093",
      "Durdura B.O": "752094",
      "Kalikaprasad B.O": "752079",
      "Kesharpur B.O": "752079",
      "Balugaon B.O": "752070",
      "Bhatasahi B.O": "752070",
      "Nabaghanapur B.O": "752070",
      "Sampada B.O": "752083",
      "Rabera B.O": "752081",
      "Sakeri B.O": "752081",
      "Garhbanikilo B.O": "752026",
      "Lodhachua B.O": "752026",
      "Narendrapur B.O": "752065",
      "Surukabadi B.O": "752065",
      "Binayakpur B.O": "752080",
      "Kajaliapalli B.O": "752080",
      "Khamarasahi B.O": "752091",
      "Tendabadi B.O": "752091",
      "Nayagarh H.O": "752069",
      "Banigochha S.O": "752089",
      "Chandapur S.O (Nayagarh)": "752024",
      "Godipada S.O": "752092",
      "Kantilo S.O": "752078",
      "Madhyakhand S.O": "752093",
      "Odagaon S.O": "752081",
      "Bahadajhola S.O": "752082",
      "Nayagarh College S.O": "752069",
      "Rajsunakhala S.O": "752065",
      "Sarankul S.O": "752080",
      "Daspalla S.O": "752084",
      "Gopalpur S.O (Nayagarh)": "752025",
      "Mahipur S.O": "752094",
      "Nayagarh Bazar S.O": "752070",
      "Rajranpur S.O": "752026",
      "Bhapur S.O (Nayagarh)": "752063",
      "Gania S.O": "752085",
      "Itamati S.O": "752068",
      "Khandapadagarh S.O": "752077",
      "Kural S.O": "752090",
      "Mandhatapur S.O": "752079",
      "Nuagaon S.O (Nayagarh)": "752083",
      "Satpatna S.O": "752091",
      "Sinduria S.O": "752069"
    },
    "NUAPADA": {
      "Amguda B.O": "766111",
      "Bhainsadani B.O": "766111",
      "Damjhar B.O": "766111",
      "Boirgaon B.O": "766111",
      "Budhikomna B.O": "766106",
      "Gandamer B.O": "766106",
      "Jhagrahi B.O": "766106",
      "Kandetara B.O": "766106",
      "Godfurla B.O": "766105",
      "Lakhana B.O": "766105",
      "Darlimunda B.O": "766105",
      "Agren B.O": "766106",
      "Kureswar B.O": "766106",
      "Nuagaon B.O": "766106",
      "Rajna B.O": "766106",
      "Amnara B.O": "766105",
      "Jatgarh B.O": "766105",
      "Kutenchuan B.O": "766105",
      "Panchampur B.O": "766105",
      "Sahajat B.O": "766105",
      "Sialati B.O": "766105",
      "Bharuamunda B.O": "766108",
      "Chatiaguda B.O": "766108",
      "Jharbandh B.O": "766108",
      "Nuapada B.O": "766108",
      "Singjhar B.O": "766108",
      "Darlipara B.O": "766105",
      "Dharambandha B.O": "766105",
      "Sarbang B.O": "766105",
      "Kendumunda B.O": "766108",
      "Kusumjore B.O": "766108",
      "Nangalbod B.O": "766108",
      "Nilji B.O": "766108",
      "Mahulibhata B.O": "766105",
      "Maraguda B.O": "766105",
      "Motanuapada B.O": "766105",
      "Tanwat B.O": "766105",
      "Gochhaguda B.O": "766108",
      "Godal B.O": "766108",
      "Gorla B.O": "766108",
      "Hatibandha B.O": "766108",
      "Dumerpani B.O": "766104",
      "Gotma B.O": "766104",
      "Jenjera B.O": "766104",
      "Goimundi B.O": "766107",
      "Khasbahal B.O": "766107",
      "Palsada B.O": "766107",
      "Sargadi B.O": "766107",
      "Kodomeri B.O": "766104",
      "Bhojpur B.O": "766107",
      "Chindaguda B.O": "766107",
      "Nehena B.O": "766107",
      "Tukla B.O": "766107",
      "Bhella B.O": "766106",
      "Konabira B.O": "766106",
      "Michhapali B.O": "766106",
      "Pendraban B.O": "766106",
      "Sunabeda B.O": "766106",
      "Tikrapara B.O": "766106",
      "Jampani B.O": "766105",
      "Kendubahara B.O": "766105",
      "Kurumpuri B.O": "766105",
      "Paraskhol B.O": "766105",
      "Saipala B.O": "766105",
      "Silva B.O": "766105",
      "Tarbod B.O": "766105",
      "Chalana B.O": "766108",
      "Karanbahali B.O": "766108",
      "Mangarapalli B.O": "766104",
      "Badi B.O": "766107",
      "Badmaheswar B.O": "766107",
      "Ranimunda B.O": "766118",
      "Timanpur B.O": "766108",
      "Khaira B.O": "766111",
      "Litisargi B.O": "766111",
      "Babebir B.O": "766118",
      "Bargaon B.O": "766107",
      "Kirkita B.O": "766118",
      "Makhapadar B.O": "766118",
      "Pharsara B.O": "766111",
      "Gondabahali B.O": "766118",
      "Jayabahal B.O": "766118",
      "Kirejhola B.O": "766111",
      "Nagpada B.O": "766111",
      "Karangamal B.O": "766118",
      "Kendupati B.O": "766118",
      "Saradhapur B.O": "766118",
      "Biromal B.O": "766104",
      "Bisora B.O": "766104",
      "Beltukri B.O": "766104",
      "Bhanpur B.O": "766104",
      "Kuliabandh B.O": "766104",
      "Parkod B.O": "766104",
      "Bhuliasikun B.O": "766107",
      "Karlakot B.O": "766111",
      "Sunapur B.O": "766111",
      "Birighat B.O": "766118",
      "Lanji B.O": "766118",
      "Larka B.O": "766118",
      "Amsena B.O": "766104",
      "Bhaleswer B.O": "766104",
      "Sinhapalli S.O": "766108",
      "Khariar S.O": "766107",
      "Khariar Road S.O": "766104",
      "Nawapara Tanwat S.O": "766105",
      "Duajhar S.O": "766118",
      "Khariar  Pattnaik Para S.O": "766107",
      "Komna S.O": "766106",
      "Boden S.O": "766111"
    },
    "KALAHANDI": {
      "Gudialipadar B.O": "766002",
      "Kamthana B.O": "766002",
      "Kutrukhamar B.O": "766002",
      "Nandol B.O": "766002",
      "Nishanpur B.O": "766002",
      "Bandhapari B.O": "766020",
      "Champadeipur B.O": "766020",
      "Kankutru B.O": "766020",
      "Rajpur B.O": "766014",
      "Dudkathenga B.O": "766028",
      "Dadpur B.O": "766002",
      "Kalam B.O": "766002",
      "Sagada B.O": "766002",
      "Uditnarayanpur B.O": "766002",
      "Kuliamal B.O": "766002",
      "Dungrigaon B.O": "766020",
      "Siuni B.O": "766028",
      "Deypur B.O": "766013",
      "Duarsani B.O": "766002",
      "Jugsaipatna B.O": "766002",
      "Karlaguda B.O": "766002",
      "Medinipur B.O": "766002",
      "Tikrapara B.O": "766002",
      "Bengaon B.O": "766020",
      "Gopinathpur B.O": "766026",
      "Lakhbahali B.O": "766020",
      "Badpodaguda B.O": "766028",
      "Bardanga B.O": "766028",
      "Badbatua B.O": "766002",
      "Bundelguda B.O": "766002",
      "Paramanandapur B.O": "766002",
      "Risigaon B.O": "766002",
      "Lanji B.O": "766020",
      "Nangalbeda B.O": "766020",
      "Pokharibandh B.O": "766020",
      "Dhansara B.O": "766019",
      "Gambhariguda B.O": "766019",
      "Kandabutra B.O": "766019",
      "Kashibahal B.O": "766019",
      "Kumjore B.O": "766019",
      "Temera B.O": "766019",
      "Uchhula B.O": "766011",
      "Alatara B.O": "766102",
      "Joradobra B.O": "766102",
      "Kandrei B.O": "766102",
      "Nandagaon B.O": "766023",
      "Mahulpatna B.O": "766026",
      "Ranibanhal B.O": "766026",
      "Ghantamal B.O": "766110",
      "Lanjigarhroad B.O": "766110",
      "Madhupur B.O": "766110",
      "Santapur B.O": "766110",
      "Barbandha B.O": "766100",
      "Ghodabandha B.O": "766100",
      "Sergarh B.O": "766100",
      "Ladugaon B.O": "766019",
      "Mahima B.O": "766019",
      "Madanpur B.O": "766102",
      "Manikera B.O": "766102",
      "Mohangiri B.O": "766102",
      "Muding B.O": "766102",
      "Nunpur B.O": "766102",
      "Chakuli B.O": "766023",
      "Choriagarh B.O": "766023",
      "Deundi B.O": "766023",
      "Goudchendia B.O": "766023",
      "Kamarda B.O": "766100",
      "Kerbandi B.O": "766100",
      "Dhanarpur B.O": "766103",
      "Gotamunda B.O": "766103",
      "Bandhagaon B.O": "766029",
      "Chichia B.O": "766029",
      "Daspur B.O": "766029",
      "Dhamanpur B.O": "766029",
      "Kathkura B.O": "766037",
      "Kerokuda B.O": "766011",
      "Kundabandha B.O": "766011",
      "Pastikudi B.O": "766011",
      "Tulapada B.O": "766100",
      "Jayantpur B.O": "766103",
      "Kadalimunda B.O": "766103",
      "Sankenduguda B.O": "766103",
      "Gajabahal B.O": "766031",
      "Pourkela B.O": "766031",
      "Rinja B.O": "766031",
      "Palam B.O": "766101",
      "Rupra B.O": "766101",
      "Siripur B.O": "766101",
      "Kumbhari B.O": "766029",
      "Badchhatrang B.O": "766037",
      "Birikot B.O": "766037",
      "Kerpai B.O": "766037",
      "Melkundel B.O": "766037",
      "Nakrundi B.O": "766037",
      "Ranidumer B.O": "766037",
      "Sidhipadar B.O": "766037",
      "Sirmasaka B.O": "766037",
      "Adhamunda B.O": "766011",
      "Badchergaon B.O": "766011",
      "Chahagaon B.O": "766011",
      "Chahaka B.O": "766011",
      "Ainli B.O": "766019",
      "Cowdola B.O": "766019",
      "Majhiguda B.O": "766019",
      "Rengalpali B.O": "766019",
      "Gandamer B.O": "766016",
      "Basantapada B.O": "766027",
      "Chatrapur B.O": "766027",
      "Borpadar B.O": "766102",
      "Gochadangen B.O": "766102",
      "Turchi B.O": "766102",
      "Baldiamal B.O": "766023",
      "Habaspur B.O": "766023",
      "Maliguda B.O": "766023",
      "S.Kundamal B.O": "766023",
      "Kiding B.O": "766110",
      "Panimunda B.O": "766110",
      "Bagpur B.O": "766100",
      "Bhurtigarh B.O": "766100",
      "Gunangbeda B.O": "766100",
      "Chhanchanbahali B.O": "766103",
      "Negiguda B.O": "766103",
      "Teresinga B.O": "766031",
      "Bhimkela B.O": "766101",
      "Muskuti B.O": "766101",
      "Sarian B.O": "766101",
      "Takarla B.O": "766101",
      "Dumerguda B.O": "766029",
      "Kankeri B.O": "766029",
      "Sandhikuliari B.O": "766029",
      "Dumerpadar B.O": "766037",
      "Gunpur B.O": "766037",
      "Purunaguma B.O": "766037",
      "Chancher B.O": "766011",
      "Gokuleswar B.O": "766011",
      "Kikia B.O": "766011",
      "Thuapadar B.O": "766011",
      "Chikilli B.O": "766019",
      "Dengaguda B.O": "766019",
      "Phupgaon B.O": "766019",
      "Bijepur B.O": "766027",
      "Malijubang B.O": "766027",
      "Dengakarlakhunta B.O": "766102",
      "Ekatara B.O": "766102",
      "Pandapadar B.O": "766102",
      "Regeda B.O": "766102",
      "Urladani B.O": "766102",
      "Kalopala B.O": "766023",
      "Mathura B.O": "766023",
      "Palas B.O": "766023",
      "Ghutrukhal B.O": "766026",
      "Bhanpur B.O": "766100",
      "Karmel B.O": "766100",
      "Mandel B.O": "766100",
      "Behera B.O": "766103",
      "Beheraguda B.O": "766103",
      "Khuntia B.O": "766103",
      "Sargulmalpada B.O": "766031",
      "Gigina B.O": "766101",
      "Farang B.O": "766029",
      "Kirkakani B.O": "766029",
      "Rengsapali B.O": "766029",
      "Tipiguda B.O": "766029",
      "Gopalpur B.O": "766037",
      "Kaniguma B.O": "766037",
      "Karlapat B.O": "766037",
      "Cheliamal B.O": "766011",
      "Karlapada B.O": "766011",
      "Phatkamal B.O": "766011",
      "Leter B.O": "766036",
      "Mahalinga B.O": "766036",
      "Palna B.O": "766036",
      "Moter B.O": "766017",
      "Ranmal B.O": "766017",
      "Ainlajore B.O": "766015",
      "Brahmanchhendia B.O": "766015",
      "Gadiajore B.O": "766015",
      "Ghumer B.O": "766015",
      "Rourahaldi B.O": "766015",
      "Chapria B.O": "766016",
      "Sanchergaon B.O": "766016",
      "Kegaon B.O": "766016",
      "Baner B.O": "766018",
      "Mangalpur B.O": "766018",
      "Atigaon B.O": "766014",
      "Bhainriguda B.O": "766014",
      "Chilguda B.O": "766014",
      "Kaliakundal B.O": "766014",
      "Talmala B.O": "766014",
      "Dasigaon B.O": "766013",
      "Mandal B.O": "766013",
      "Hatikhoj B.O": "766012",
      "Kantisir B.O": "766012",
      "Pipalpadar B.O": "766012",
      "Matia B.O": "766036",
      "Boden B.O": "766015",
      "Khairpadar B.O": "766015",
      "Tambachhoda B.O": "766015",
      "Tarapur B.O": "766015",
      "Khaliakani B.O": "766016",
      "Manjhari B.O": "766016",
      "Naktikani B.O": "766016",
      "Udesurung B.O": "766016",
      "Ainlabhata B.O": "766018",
      "Badkarlakote B.O": "766018",
      "Karmeli B.O": "766018",
      "Bhejipadar B.O": "766014",
      "Brahmaniguda B.O": "766014",
      "Budhidhara B.O": "766014",
      "Chichiaguda B.O": "766014",
      "Chingersar B.O": "766014",
      "Matigaon B.O": "766014",
      "Meriabandhali B.O": "766014",
      "Bandhakona B.O": "766013",
      "Churagaon B.O": "766013",
      "Paruaguda B.O": "766013",
      "Boria B.O": "766012",
      "Boringpadar B.O": "766012",
      "Kashrupada B.O": "766012",
      "Laitara B.O": "766012",
      "Sirol B.O": "766012",
      "Tonsir B.O": "766012",
      "Tundla B.O": "766012",
      "Turlakhaman B.O": "766012",
      "Barbhata B.O": "766036",
      "Bargaon B.O": "766036",
      "Dumuria B.O": "766036",
      "Kanduljhar B.O": "766036",
      "Arebeda B.O": "766017",
      "Bandigaon B.O": "766017",
      "Dahagaon B.O": "766017",
      "Dalguma B.O": "766017",
      "Dungariguda B.O": "766017",
      "Badfurla B.O": "766015",
      "Bagad B.O": "766015",
      "Badkutru B.O": "766018",
      "Bijmara B.O": "766018",
      "Bimla B.O": "766018",
      "Dhansuli B.O": "766018",
      "Koligaon B.O": "766014",
      "Malgund B.O": "766014",
      "Mundraguda B.O": "766013",
      "Pandigaon B.O": "766013",
      "Belkhandi B.O": "766012",
      "Nunmath B.O": "766012",
      "Paralsinga B.O": "766012",
      "Sirjapali B.O": "766012",
      "Artal B.O": "766036",
      "Kuhura B.O": "766036",
      "Madiguda B.O": "766036",
      "Salebhata B.O": "766036",
      "Musapali B.O": "766017",
      "Sargiguda B.O": "766017",
      "Chhilipa B.O": "766015",
      "Rajmoter B.O": "766015",
      "Brundabahal B.O": "766016",
      "Khaliapalli B.O": "766016",
      "Badpujhariguda B.O": "766018",
      "Bhainripalli B.O": "766018",
      "Khaliabhata B.O": "766018",
      "Paikendumundi B.O": "766018",
      "Banijora B.O": "766014",
      "Dedarha B.O": "766014",
      "Kaleigaon B.O": "766014",
      "Purnasar B.O": "766014",
      "Mingur B.O": "766013",
      "Padampur B.O": "766013",
      "Kandel B.O": "766012",
      "Kandel Road B.O": "766012",
      "Patharla B.O": "766012",
      "Rengali B.O": "766012",
      "Bhawanipatna H.O": "766001",
      "Sosia S.O": "766029",
      "Bhawanipatna Engineering College SO": "766003",
      "Utkela S.O": "766011",
      "Thuamul Rampur S.O": "766037",
      "Charbahal S.O": "766017",
      "Golamunda S.O": "766016",
      "Narla Road S.O": "766110",
      "Rupra Road S.O": "766101",
      "Jaipatna S.O": "766018",
      "Kalampur S.O": "766013",
      "Kesinga RS S.O": "766012",
      "Parla S.O": "766103",
      "Risida S.O": "766031",
      "Dharamgarh S.O": "766015",
      "Junagarh S.O": "766014",
      "Kesinga JM Pada S.O": "766012",
      "Koksara S.O": "766019",
      "Mahichala S.O": "766023",
      "Borda S.O": "766036",
      "Kesinga S.O": "766012",
      "Lanjigarh S.O": "766027",
      "Madanpur Rampur S.O": "766102",
      "Mukhiguda S.O": "766026",
      "Narla S.O": "766100",
      "Bhawanipatna Naktiguda S.O": "766001",
      "Bhawanipatna B.B.Pada S.O": "766001",
      "Bhawanipatna CollegeSquare S.O": "766001",
      "Bhawanipatna Collectorate S.O": "766001",
      "Bhawanipatna G.Chowk S.O": "766002",
      "Biswanathpur S.O": "766020",
      "Karlamunda S.O": "766032",
      "Ampani S.O": "766028",
      "Bhawanipatna Stadium S.O": "766001"
    },
    "GAJAPATI": {
      "Loba B.O": "761016",
      "Mangarajpur B.O": "761016",
      "Parimal B.O": "761016",
      "Randiba B.O": "761016",
      "Tabarasingi B.O": "761016",
      "Kujasingi B.O": "761213",
      "Kumulusingi B.O": "761213",
      "Marlaba B.O": "761213",
      "B.Sitapur B.O": "761201",
      "Jeeba B.O": "761201",
      "Jogipadu B.O": "761201",
      "Bomika B.O": "761211",
      "Karasandha B.O": "761211",
      "Madhusudanpur B.O": "761211",
      "Mochamera B.O": "761211",
      "Sambalapur (GM) B.O": "761016",
      "Birujango B.O": "761213",
      "Kerandi B.O": "761201",
      "Sidhamadango B.O": "761201",
      "Agarkhandi B.O": "761211",
      "Bagusola B.O": "761211",
      "R Sitapur B.O": "761211",
      "Sailada B.O": "761211",
      "Kakasingi B.O": "761016",
      "Ramagiri B.O": "761016",
      "Sabarapalli B.O": "761016",
      "Jallango B.O": "761213",
      "Karadasingi B.O": "761213",
      "Jammi B.O": "761201",
      "Tarangada B.O": "761201",
      "Ariba B.O": "761211",
      "Batisiripur B.O": "761211",
      "Namagari B.O": "761211",
      "Patikota B.O": "761211",
      "Ranadevi B.O": "761211",
      "Parisola B.O": "761213",
      "Puturupada B.O": "761016",
      "Ranipeta B.O": "761201",
      "Tampakaviti B.O": "761211",
      "Dhadhiambo B.O": "761017",
      "Mahendragada B.O": "761017",
      "Baghmari B.O": "761017",
      "Sabara B.O": "761215",
      "Ambajhari B.O": "761207",
      "Tumula B.O": "761207",
      "Bhuskudi B.O": "761210",
      "Baijhola B.O": "761206",
      "Goribandha B.O": "761206",
      "Siali B.O": "761206",
      "Devadala B.O": "761208",
      "Gaiba B.O": "761208",
      "Malasapadar B.O": "761015",
      "Pindkii B.O": "761015",
      "Koinpur B.O": "761212",
      "Laxmipur B.O": "761212",
      "Rasibad B.O": "761212",
      "Khajuripada B.O": "761214",
      "Aligonda B.O": "761217",
      "Guluba B.O": "761217",
      "Mandimera B.O": "761217",
      "Betarsingi B.O": "761016",
      "Gondahati B.O": "761215",
      "Goppilli Rampa B.O": "761215",
      "Kinchilingi B.O": "761215",
      "Labanyagada B.O": "761215",
      "Khandava B.O": "761206",
      "Kinigam B.O": "761206",
      "Kolia B.O": "761206",
      "Valada B.O": "761206",
      "Badakhani B.O": "761015",
      "Laduru B.O": "761015",
      "Liligada B.O": "761015",
      "Engarsingi B.O": "761212",
      "Gangabad B.O": "761212",
      "Sansada B.O": "761212",
      "Talamunda B.O": "761212",
      "Panigonda B.O": "761217",
      "Anguru B.O": "761016",
      "Attarsingi B.O": "761016",
      "Singipur B.O": "761215",
      "Badakolkote B.O": "761207",
      "Krishnachandrapur B.O": "761207",
      "Munisingi B.O": "761207",
      "Seranga B.O": "761207",
      "Jangalpadu B.O": "761210",
      "Saradapur B.O": "761210",
      "Tatipati B.O": "761210",
      "Bhupati Laxmipur B.O": "761206",
      "Hadubhangi B.O": "761208",
      "K.Sitapur B.O": "761208",
      "Parida B.O": "761208",
      "Sinkulipadar B.O": "761015",
      "P.Govindapur B.O": "761015",
      "Gayaljuba B.O": "761212",
      "Jeerango B.O": "761212",
      "Badapada B.O": "761214",
      "Gulli B.O": "761214",
      "Jhalarasingi B.O": "761214",
      "Keradango B.O": "761214",
      "Birikote B.O": "761217",
      "Damadua B.O": "761217",
      "Karchabadi B.O": "761217",
      "Anagha B.O": "761016",
      "Jeerango Colony B.O": "761017",
      "Ranalai B.O": "761017",
      "Sialilati B.O": "761017",
      "Adhagam B.O": "761215",
      "Pedakotturu B.O": "761215",
      "Ajayagada B.O": "761207",
      "Ashrayagada B.O": "761207",
      "Sindhiba B.O": "761207",
      "Gosani B.O": "761210",
      "Badigam B.O": "761206",
      "Kitingi B.O": "761206",
      "Bapenbadi B.O": "761208",
      "Luhagudi B.O": "761015",
      "Mudumudia B.O": "761015",
      "Dambala B.O": "761212",
      "Kuruguba B.O": "761212",
      "Lalusahi B.O": "761212",
      "Pothara B.O": "761212",
      "Tabarada B.O": "761214",
      "Nalaghat B.O": "761217",
      "Katamaha B.O": "761217",
      "Chellagada B.O": "761016",
      "Badasindhiba B.O": "761017",
      "Chandiput B.O": "761017",
      "Chelligada B.O": "761017",
      "Darba B.O": "761017",
      "Antaraba B.O": "761017",
      "Parlakhemundi H.O": "761200",
      "Mohana S.O.": "761015",
      "Odava S.O": "761217",
      "Rayagada S.O": "761213",
      "Garabandha S.O": "761215",
      "Hospital Road S.O Gajapati": "761200",
      "Narayanapur S.O (Gajapati)": "761212",
      "Nuagada S.O": "761214",
      "R.Udayagiri S.O": "761016",
      "Station Road Paralakhemundi S.O": "761201",
      "Chandragiri S.O": "761017",
      "Gumma S.O Gajapati": "761207",
      "Gurandi S.O": "761210",
      "Paralakhemundi Bus Stand S.O": "761200",
      "Chitrakar Street S.O": "761200",
      "Kashinagar S.O Gajapati": "761206",
      "Kharada S.O": "761208",
      "Uppalada S.O": "761211",
      "Jangam Street": "761200"
    },
    "MAYURBHANJ": {
      "Bamada B.O": "756028",
      "Chinchlagadia B.O": "756030",
      "Baunsdiha B.O": "757038",
      "Jarak B.O": "757038",
      "Saleibeda B.O": "757038",
      "Talpada B.O": "757026",
      "Dharamdihi B.O": "757053",
      "Lupung B.O": "757053",
      "Tongabilla B.O": "757036",
      "Khandabandh B.O": "757038",
      "Mahuldiha B.O": "757038",
      "Mituani B.O": "757038",
      "Padiabeda B.O": "757038",
      "Patarapada B.O": "757026",
      "Salchua B.O": "757038",
      "Jirei B.O": "757053",
      "Maghua B.O": "757053",
      "Pandupani B.O": "757053",
      "Bharandia B.O": "757038",
      "Keshdiha B.O": "757038",
      "Satkosia B.O": "757038",
      "Taramara B.O": "757038",
      "Badpalasa B.O": "757053",
      "Changua B.O": "757053",
      "Sanbhundu B.O": "757053",
      "Champajhar B.O": "757038",
      "Digdhar B.O": "757038",
      "Hatigoda B.O": "757038",
      "Baddalima B.O": "757053",
      "Bhagabandi B.O": "757053",
      "Gendagadia B.O": "757026",
      "Singtia B.O": "757026",
      "Sapanchua B.O": "757074",
      "Talakunda B.O": "757074",
      "Durgapur B.O": "757082",
      "Kanchisole B.O": "757025",
      "Sialighati B.O": "757025",
      "Chadada B.O": "757026",
      "Dhanghera B.O": "757087",
      "Patsanipur B.O": "757087",
      "Dardara B.O": "757014",
      "Kakharusole B.O": "757014",
      "Bhairangisole B.O": "757018",
      "Gholmuhan B.O": "757018",
      "Idar B.O": "757018",
      "Nichuapada B.O": "757018",
      "Patpur B.O": "757041",
      "Chuhat B.O": "757021",
      "Dhemnasole B.O": "757021",
      "Astajharan B.O": "757075",
      "Chandrapur B.O": "757087",
      "Salbani B.O": "757075",
      "Gosaingaon B.O": "757082",
      "Kalama B.O": "757082",
      "Kantipur B.O": "757082",
      "Kandana B.O": "757023",
      "Lunia B.O": "757023",
      "Nuhamalia B.O": "757023",
      "Paktia B.O": "757084",
      "Pokpoka B.O": "757093",
      "Jugal B.O": "757052",
      "Raikama B.O": "757052",
      "Sansa B.O": "757052",
      "Badkhaladi B.O": "757040",
      "Golagadia B.O": "757040",
      "Mirigothana B.O": "757040",
      "Peragari B.O": "757040",
      "Badkaranjia B.O": "757019",
      "Kendudiha B.O": "757026",
      "Khuntapal B.O": "757020",
      "Ranibandh B.O": "757026",
      "Badfeni B.O": "757074",
      "Agria B.O": "757025",
      "Bartana B.O": "757025",
      "Dalki B.O": "757025",
      "Nuagaon B.O": "757030",
      "Hatisahi B.O": "757087",
      "Kundabai B.O": "757087",
      "Kuabuda B.O": "757014",
      "Kusumasole B.O": "757014",
      "Marangtandi B.O": "757014",
      "Kapoi B.O": "757018",
      "Maigaon B.O": "757018",
      "Makunda B.O": "757018",
      "Musagadia B.O": "757018",
      "Anlakuda B.O": "757021",
      "Nuagaon talakchuin B.O": "757021",
      "Sarasposi B.O": "757021",
      "Kamalasole B.O": "757075",
      "Kamali B.O": "757075",
      "Khanua B.O": "757075",
      "Lakhanasahi B.O": "757075",
      "Balka B.O": "757082",
      "Badfera B.O": "757023",
      "Badmundhabani B.O": "757023",
      "Futukisole B.O": "757023",
      "Khalapada B.O": "757023",
      "Badchatra B.O": "757086",
      "Belbaria B.O": "757086",
      "Bhursani B.O": "757086",
      "Khadiasole B.O": "757086",
      "Aldia Bartana B.O": "757052",
      "Anla B.O": "757052",
      "Totapada B.O": "757052",
      "KURADHIKA B.O.": "757052",
      "Jaida B.O": "757041",
      "Sanbisole B.O": "757040",
      "Badmamundia B.O": "757019",
      "Baldiha Khunta B.O": "757019",
      "Badpathara B.O": "757074",
      "Bahalda B.O": "757074",
      "BANDHAGODA": "757074",
      "Gobapal B.O": "757025",
      "Kuliana Barsahi B.O": "757025",
      "Paunsia B.O": "757025",
      "Rangapani B.O": "757025",
      "Sakua B.O": "757025",
      "Arpata B.O": "757083",
      "C.Mangalpur B.O": "757083",
      "Daundia B.O": "757083",
      "Patisari B.O": "757083",
      "Ambikadeipur B.O": "757087",
      "Athapara B.O": "757087",
      "Balichhatra B.O": "757087",
      "Sridamchandrapur B.O": "757087",
      "Baghuasole B.O": "757014",
      "Bhugudakata B.O": "757014",
      "Saragchhida B.O": "757014",
      "Tadki B.O": "757014",
      "Bholaghati B.O": "757018",
      "Chandabilla B.O": "757018",
      "Chhatna B.O": "757018",
      "Dhansole B.O": "757018",
      "Ambadali B.O": "757075",
      "Palasia B.O": "757082",
      "Kujidihi B.O": "757023",
      "Sanmundhabani B.O": "757023",
      "Padmapur Deuli B.O": "757086",
      "Khadikapada B.O": "757052",
      "Machhapada B.O": "757052",
      "Merda B.O": "757052",
      "Paika Sahi B.O": "757052",
      "Raghavpur B.O": "757052",
      "Jambani B.O": "757040",
      "Kaladahi B.O": "757040",
      "Deulia B.O": "757026",
      "Suhagpura B.O": "757026",
      "Bangra B.O": "757074",
      "Tangana B.O": "757074",
      "Aguad B.O": "757025",
      "Kochilakhunta B.O": "757025",
      "Tentuligaon B.O": "757083",
      "Gadigaon B.O": "757018",
      "Gayalkata B.O": "757014",
      "Keutunimari B.O": "757014",
      "Anua B.O": "757018",
      "Bhaliadiha B.O": "757018",
      "Paramananda B.O": "757018",
      "Sunahaja B.O": "757018",
      "Chaksuliapada B.O": "757021",
      "Kanimahuli B.O": "757021",
      "Bireswarpur B.O": "757075",
      "Itamundia B.O": "757075",
      "Narankhunta B.O": "757075",
      "Hempur B.O": "757082",
      "Dhenkinenjia B.O": "757023",
      "Keshrasole B.O": "757023",
      "Kui B.O": "757023",
      "Badsole B.O": "757086",
      "Jalda B.O": "757086",
      "Kuanrdihi B.O": "757086",
      "Rajaloka B.O": "757086",
      "Dumurdiha B.O": "757105",
      "Pokhardiha B.O": "757093",
      "Sankhabhanga B.O": "757107",
      "Bhudurbani B.O": "757052",
      "Hatijhari B.O": "757052",
      "Saitpur B.O": "757052",
      "Tilapada B.O": "757052",
      "Badgudugudia B.O": "757040",
      "Badsimulia B.O": "757040",
      "Chuinposi B.O": "757040",
      "Goudagaon B.O": "757040",
      "Mankadapada B.O": "757040",
      "Parasbani B.O": "757040",
      "Atanati B.O": "757019",
      "Mangalpur B.O": "757055",
      "Purnachandrapur B.O": "757055",
      "Sarisa B.O": "757055",
      "Purinda B.O": "757100",
      "Dengam B.O": "757104",
      "Dahikoti B.O": "757100",
      "Badkhiripada B.O": "757028",
      "Khuntapur B.O": "757028",
      "Bedhakudar B.O": "757032",
      "Gosanipal B.O": "757032",
      "Manbhanj B.O": "757032",
      "Patharkham B.O": "757032",
      "Puruna Pani B.O": "757032",
      "Chhelia B.O": "757026",
      "Gayalmara B.O": "757104",
      "Muktapur B.O": "757100",
      "Purikhunta B.O": "757100",
      "Ambagadia B.O": "757028",
      "Mahulpatna B.O": "757028",
      "Nachhipuria B.O": "757028",
      "Dighi B.O": "757032",
      "Ghatkuanri B.O": "757032",
      "Katra Chandan Pur B.O": "757032",
      "B. Chhelia B.O": "757026",
      "Saria B.O": "757100",
      "Patalipura B.O": "757028",
      "Purunia B.O": "757028",
      "Raghupur B.O": "757028",
      "Singlamundali B.O": "757028",
      "Danadar B.O": "757032",
      "Dhobanisole B.O": "757032",
      "Nafree B.O": "757032",
      "Nischinta B.O": "757032",
      "Hirapur B.O": "757019",
      "Silaghati B.O": "757019",
      "Brahmanmara B.O": "757084",
      "Dharampura B.O": "757084",
      "Naupada B.O": "757084",
      "Nuhajhalia B.O": "757084",
      "Badjod B.O": "757029",
      "Bhalia B.O": "757029",
      "Jamsole B.O": "757029",
      "Karamsole B.O": "757029",
      "Tasarda B.O": "757029",
      "Haldia (Baripada) B.O": "757105",
      "Goudruma B.O": "757030",
      "Kudiapal B.O": "757030",
      "Budama R.S. B.O": "757081",
      "Kesharpur B.O": "757081",
      "Kothabila B.O": "757081",
      "Sankucha B.O": "757081",
      "Baradihi B.O": "757085",
      "Jaipur B.O": "757085",
      "Bhuasuni B.O": "757092",
      "Sarisapal B.O": "757092",
      "Shyamsundarpur B.O": "757092",
      "Bankisole B.O": "757107",
      "Kainfulia B.O": "757107",
      "Rajabasa B.O": "757107",
      "Bijipur B.O": "757017",
      "Nankua B.O": "757017",
      "Chakulia B.O": "757020",
      "Rakhinisahi B.O": "757020",
      "Harekrushnapur B.O": "757073",
      "Rangiam B.O": "757073",
      "Chakradharpur B.O": "757077",
      "Kolialam B.O": "757077",
      "Haripur B.O": "757055",
      "Chaturi B.O": "757102",
      "Sirathali B.O": "757102",
      "Badbhalia B.O": "757084",
      "Baddhenkia B.O": "757084",
      "Chadheigaon B.O": "757084",
      "Hatikote B.O": "757029",
      "Jamdapal B.O": "757029",
      "Sureidihi B.O": "757029",
      "Sikidia B.O": "757027",
      "Talakadada B.O": "757027",
      "Aniapal B.O": "757105",
      "Asanjoda B.O": "757105",
      "Baiganbaria B.O": "757105",
      "Panisapada B.O": "757055",
      "Bholagadia B.O": "757104",
      "Badchhuruni B.O": "757100",
      "Tarakothi B.O": "757100",
      "Bidukudia B.O": "757028",
      "Kadalia B.O": "757028",
      "Asana B.O": "757033",
      "Bankati B.O": "757032",
      "Teldihudi B.O": "757101",
      "Jharia B.O": "757016",
      "M. Kanpur B.O": "757016",
      "Patagadia B.O": "757016",
      "Majhigadia B.O": "757106",
      "Raipal B.O": "757106",
      "Belam B.O": "757024",
      "Jadunathpur B.O": "757024",
      "Tangasole B.O": "757024",
      "Bagbuda B.O": "757051",
      "Mahulbarei B.O": "757051",
      "Gour Chandra Pur B.O": "757079",
      "Rajat Nagar B.O": "757079",
      "Ekdali B.O": "757031",
      "Pandra Rolasahi B.O": "757031",
      "Balidiha B.O": "757049",
      "Chandanpur B.O": "757017",
      "Palpala Ambadali B.O": "757049",
      "Rangamatia B.O": "757049",
      "Baghra B.O": "757022",
      "Darudihi B.O": "757022",
      "Saradiha B.O": "757079",
      "Baghra Road B.O": "757003",
      "Damodar Pur B.O": "757003",
      "Dughdha B.O": "757041",
      "Jualia B.O": "757041",
      "Basilapir B.O": "757047",
      "Jhipabandh B.O": "757047",
      "Soroda Jashipur B.O": "757054",
      "Kulgi B.O": "757046",
      "Moronda B.O": "757046",
      "Soso B.O": "757046",
      "Banakati B.O": "757019",
      "Raihari B.O": "757048",
      "Baneikala B.O": "757033",
      "Bautibeda B.O": "757033",
      "N.B.Pokharia B.O": "757033",
      "Sunajodia B.O": "757033",
      "Hatia B.O": "757042",
      "Mahadevdihi B.O": "757042",
      "Aharbandh B.O": "757050",
      "Kusumi B.O": "757050",
      "Purunaghati B.O": "757050",
      "Shyamsundar B.O": "757050",
      "Jarkani B.O": "757045",
      "Pasana B.O": "757045",
      "Tendra B.O": "757045",
      "Baunsnali B.O": "757034",
      "Chheligudhudi B.O": "757034",
      "Indupur B.O": "757037",
      "Kendumundi B.O": "757037",
      "Kuliposi B.O": "757037",
      "Kushpada B.O": "757037",
      "Patbil B.O": "757037",
      "Bakla B.O": "757091",
      "Matiagarh B.O": "757091",
      "Brahmaniposi B.O": "757035",
      "Budhigambharia B.O": "757035",
      "Khuntapada B.O": "757035",
      "Haldia B.O": "757039",
      "Jhadghosada B.O": "757039",
      "Kumbhirda B.O": "757039",
      "Pandarsil B.O": "757039",
      "Talgaon B.O": "757045",
      "Baria B.O": "757036",
      "Bhandagaon B.O": "757019",
      "Tikarpada B.O": "757019",
      "Gouduniduba B.O": "757084",
      "Marudihi B.O": "757084",
      "Dantiamuhan B.O": "757029",
      "Dhanpur B.O": "757029",
      "Gendapokhari B.O": "757030",
      "Jagannathkhunta B.O": "757030",
      "Kathsirsi B.O": "757030",
      "Koilisuta B.O": "757030",
      "Parulia B.O": "757030",
      "Pathuri B.O": "757030",
      "Patihinja B.O": "757030",
      "Pathurikata B.O": "757085",
      "Srinathpur B.O": "757085",
      "Taradasole B.O": "757085",
      "Budhikhamari B.O": "757029",
      "Hinjili B.O": "757092",
      "Jaldiha B.O": "757092",
      "Kanchhinda B.O": "757092",
      "Kundulia B.O": "757033",
      "Sanfutuka B.O": "757107",
      "Mirigidari B.O": "757017",
      "Jhinkiria B.O": "757020",
      "Manida B.O": "757020",
      "N. Chhotraipur B.O": "757020",
      "Podadiha B.O": "757077",
      "Potaldiha B.O": "757077",
      "Sarbanghati B.O": "757077",
      "Orachandbilla B.O": "757103",
      "Pasuda B.O": "757102",
      "Sainkula B.O": "757102",
      "Bairatpur B.O": "757101",
      "Dihirakul B.O": "757101",
      "Bachhuripal B.O": "757016",
      "Debsole B.O": "757016",
      "Bajratundi B.O": "757024",
      "Palasbani B.O": "757051",
      "Pokharia B.O": "757022",
      "Ratila B.O": "757051",
      "Silfodi B.O": "757051",
      "Kalamgodia B.O": "757079",
      "Labanyadeipur B.O": "757079",
      "Nedam B.O": "757079",
      "Sankachimbila B.O": "757031",
      "Kisandahi B.O": "757049",
      "Dhatika B.O": "757022",
      "Mahabila B.O": "757022",
      "Saluadahar B.O": "757022",
      "Ufalgadia B.O": "757022",
      "Kainsari B.O": "757041",
      "Khaladi B.O": "757041",
      "Kathbharia B.O": "757047",
      "Talakpokhari B.O": "757047",
      "Badkedam B.O": "757054",
      "Bhitaramda B.O": "757054",
      "Dolsara B.O": "757054",
      "Binjhua B.O": "757046",
      "Tamalbandh B.O": "757046",
      "Goudadiha B.O": "757003",
      "Raikad Jharan B.O": "757003",
      "Sripad Ganja B.O": "757003",
      "Ambadiha B.O": "757048",
      "Badsingaria B.O": "757041",
      "Bahubandh B.O": "757041",
      "Salmundali B.O": "757041",
      "Dundu B.O": "757046",
      "Gambharia B.O": "757046",
      "Indukhali B.O": "757046",
      "Badamtalia B.O": "757048",
      "Damudigoda B.O": "757048",
      "Majhigaon B.O": "757033",
      "Manada B.O": "757033",
      "Sudarsanpur B.O": "757042",
      "Sundhal B.O": "757106",
      "Tarana B.O": "757054",
      "Chakidi B.O": "757034",
      "Dhalabani B.O": "757034",
      "Durdura B.O": "757034",
      "Gudugudia B.O": "757034",
      "Jamukeswar B.O": "757034",
      "Bhadubeda B.O": "757037",
      "Bhanra B.O": "757037",
      "Chitraposi B.O": "757037",
      "Ghagarda B.O": "757037",
      "Rasamtala B.O": "757037",
      "Angarpada B.O": "757035",
      "Baidyanath B.O": "757035",
      "Raikala B.O": "757035",
      "Khiching B.O": "757039",
      "Nuabeda B.O": "757039",
      "Dari B.O": "757036",
      "Dudhiani B.O": "757036",
      "Hatibari B.O": "757036",
      "Rugudi B.O": "757036",
      "Salarapada B.O": "757036",
      "Ambapunja B.O": "757030",
      "Dhangudisole B.O": "757081",
      "Dudhiasole B.O": "757081",
      "Khairbani B.O": "757081",
      "Patharchakuli B.O": "757107",
      "Deopara B.O": "757017",
      "Kuradiha B.O": "757017",
      "Badampur B.O": "757020",
      "Baincha Nuagaon B.O": "757020",
      "Baladia B.O": "757020",
      "Barkand B.O": "757020",
      "Bhaduasole B.O": "757073",
      "Khuruntia B.O": "757073",
      "Mahulia B.O": "757073",
      "Tukpalasia B.O": "757073",
      "Badkhaman B.O": "757077",
      "Gobra B.O": "757016",
      "Padmapokhari B.O": "757106",
      "Kadualbandh B.O": "757024",
      "Kerko Baiganbaria B.O": "757024",
      "Paikabasa B.O": "757024",
      "Talanda B.O": "757024",
      "Bagjhumpa B.O": "757031",
      "Gandipani B.O": "757031",
      "Chhadkata B.O": "757049",
      "Haldibani B.O": "757049",
      "Jagannathpur B.O": "757049",
      "Kendua B.O": "757049",
      "Sindurgoura B.O": "757049",
      "Sirishbani B.O": "757049",
      "Golamundhakata B.O": "757032",
      "Pandhada B.O": "757032",
      "Luhakani B.O": "757048",
      "Luhasila B.O": "757048",
      "Sargoda B.O": "757048",
      "Khadambeda B.O": "757033",
      "Nuagaon kurkutia B.O": "757033",
      "Sanjambilla B.O": "757033",
      "Sanpurunapani B.O": "757033",
      "Sargoda Jashipur B.O": "757033",
      "Badgaon B.O": "757092",
      "Badmouda B.O": "757042",
      "Badra B.O": "757042",
      "Bhimkhanda B.O": "757042",
      "Tikhia B.O": "757042",
      "Bhalubasa B.O": "757050",
      "Chuapani B.O": "757050",
      "Hesda B.O": "757050",
      "Kumudasole B.O": "757050",
      "Suleipat B.O": "757050",
      "Ukam B.O": "757050",
      "Uparbeda B.O": "757050",
      "Badkuleibira B.O": "757045",
      "Astakuanr B.O": "757034",
      "Podagarh B.O": "757034",
      "Kerkera B.O": "757037",
      "San Deuli B.O": "757037",
      "Bhanjkia B.O": "757091",
      "Ektali B.O": "757091",
      "Gadapalasa B.O": "757091",
      "Jharbeda B.O": "757091",
      "Sirakuli B.O": "757091",
      "Tilakothi B.O": "757091",
      "Ghagarbeda B.O": "757035",
      "Hindala B.O": "757035",
      "Jamuti B.O": "757035",
      "Righa B.O": "757035",
      "Arjunbilla B.O": "757039",
      "Badterenti B.O": "757039",
      "Bramarposi B.O": "757039",
      "Chaturanjali B.O": "757039",
      "Chanchbani B.O": "757036",
      "Moto B.O": "757036",
      "Bakartala B.O": "757036",
      "Bala B.O": "757036",
      "Karkachia B.O": "757019",
      "Fania B.O": "757084",
      "Kaduani B.O": "757033",
      "Asanbani B.O": "757029",
      "Gangraj B.O": "757105",
      "Kantapal B.O": "757105",
      "Digar Astia B.O": "757030",
      "Ghodapal B.O": "757030",
      "Kalabadia B.O": "757030",
      "Nabedhi B.O": "757030",
      "Sansarasposi B.O": "757030",
      "Nodhana B.O": "757081",
      "Debgaon B.O": "757085",
      "Labania B.O": "757092",
      "Bhudrubani B.O": "757107",
      "Garudnesa B.O": "757107",
      "Nakhra B.O": "757017",
      "Narangaon B.O": "757017",
      "Pruthunathpur B.O": "757017",
      "Salgaon B.O": "757017",
      "Bhatchhatar B.O": "757020",
      "Ghodabandha  Khuntapal B.O": "757020",
      "Rukuni B.O": "757020",
      "Hill Block   24 B.O": "757077",
      "Manikpur B.O": "757048",
      "Madhopur B.O": "757103",
      "Sanbelakuti B.O": "757102",
      "Dimagadia B.O": "757101",
      "Kamardiha B.O": "757016",
      "Mahulpankha B.O": "757106",
      "Baunsbilla B.O": "757024",
      "Gudialbandh B.O": "757024",
      "Uthani Nuagaon B.O": "757024",
      "Kherna B.O": "757051",
      "Murunia B.O": "757051",
      "Unchagaon B.O": "757051",
      "Dewan Bahali B.O": "757079",
      "Katuria B.O": "757079",
      "Baunsda B.O": "757031",
      "Bhaluki B.O": "757049",
      "Kochilaghaty B.O": "757049",
      "Poda astia B.O": "757049",
      "Saratchandrapur B.O": "757049",
      "Bari B.O": "757022",
      "Singda B.O": "757022",
      "Dakoipodadiha B.O": "757003",
      "Bhimtali B.O": "757041",
      "Kutling B.O": "757041",
      "Nayarangamatia B.O": "757041",
      "Dova B.O": "757047",
      "Jorda B.O": "757047",
      "Padhia B.O": "757047",
      "Basingi B.O": "757046",
      "Purunapani B.O": "757050",
      "Badnalua B.O": "757033",
      "Anlajo R.S. B.O": "757042",
      "Guhaldangri B.O": "757042",
      "Kukudimundi B.O": "757042",
      "Sanpakhana B.O": "757042",
      "Pratapgarh B.O": "757050",
      "Halda B.O": "757045",
      "Khairpal B.O": "757045",
      "Barehipani B.O": "757034",
      "Moudi B.O": "757034",
      "ALKUDAR": "757034",
      "Ghosada B.O": "757037",
      "Kendujiani B.O": "757037",
      "Nedhuapal B.O": "757037",
      "Begunia B.O": "757091",
      "M.Beuinria B.O": "757091",
      "Neuti B.O": "757091",
      "Budamara B.O": "757035",
      "Denua B.O": "757035",
      "Naksara B.O": "757035",
      "Galusahi B.O": "757039",
      "Jamunti B.O": "757039",
      "Singada B.O": "757039",
      "Barakamuda B.O": "757036",
      "Batpalasa B.O": "757036",
      "Pantho B.O": "757036",
      "Brahmapura B.O": "757055",
      "Rairangpur H.O": "757043",
      "Baripada H.O": "757001",
      "Bahanada Sathilo S.O": "757100",
      "Bangriposi S.O": "757032",
      "Baripada Municipal Market S.O": "757001",
      "Barsahi S.O": "757026",
      "Belgadia S.O": "757002",
      "Bhimda S.O": "757083",
      "Jharpokharia S.O": "757086",
      "Jugpura S.O": "757052",
      "Khunta S.O": "757019",
      "Kuchei S.O": "757105",
      "Kuliana S.O": "757030",
      "Mantri S.O": "757017",
      "Puruna Baripada S.O": "757102",
      "Rasgovindpur S.O": "757016",
      "Saraskana S.O": "757051",
      "Shirsa S.O": "757031",
      "Suliapada S.O": "757022",
      "Udala Bazar S.O": "757041",
      "Bahalda Rd RS S.O": "757054",
      "Bijatala S.O": "757048",
      "Bisoi S.O": "757033",
      "Karanjia S.O (Mayurbhanj)": "757037",
      "Mahuldiha S.O": "757043",
      "Bahanada S.O": "757104",
      "Baisinga S.O": "757028",
      "Basipitha S.O": "757074",
      "Bhanjpur S.O": "757002",
      "Brundaban Chandrapur S.O": "757087",
      "Garhdeulia S.O": "757082",
      "Garia S.O (Mayurbhanj)": "757023",
      "Kostha S.O": "757084",
      "Kushalda S.O": "757085",
      "Nalagaja S.O": "757073",
      "Pratappur S.O (Mayurbhanj)": "757103",
      "Sarat S.O": "757079",
      "Anladuva S.O": "757043",
      "Hatbadra S.O": "757050",
      "Karanjia Bazar S.O": "757037",
      "Tato S.O": "757036",
      "Ambikasahi S.O": "757001",
      "Baripada Court S.O": "757001",
      "Betnoti S.O": "757025",
      "Bijay Ramchandrapur S.O": "757002",
      "Deulasahi S.O": "757001",
      "Kumbharmundakata S.O": "757081",
      "Kusumbandi S.O": "757092",
      "Laxmiposi S.O": "757107",
      "Radho S.O": "757101",
      "Salchua S.O": "757106",
      "Takatpur S.O": "757003",
      "Badampahar S.O": "757047",
      "Gorumahisani S.O": "757042",
      "Karanjia Court S.O": "757037",
      "Karanjia Golei S.O": "757037",
      "Thakurmunda S.O": "757038",
      "Sukruli S.O": "757039",
      "Tiring S.O": "757053",
      "Amarda S.O": "757055",
      "Baripada Bazar S.O": "757001",
      "Baripada Hospital S.O": "757001",
      "Baripada R.S. S.O": "757001",
      "Chandua Ashram S.O": "757014",
      "Chitrada S.O": "757018",
      "Deuli S.O": "757021",
      "Dukura S.O": "757075",
      "Joka S.O (Mayurbhanj)": "757093",
      "Kaptipada S.O": "757040",
      "Krushnachandrapur S.O": "757029",
      "Kuamara S.O": "757027",
      "Moroda S.O": "757020",
      "Nudadiha S.O": "757077",
      "Palabani Chhak S.O": "757001",
      "Sankerko S.O": "757024",
      "Shyamakhunta S.O": "757049",
      "Tulasichoura S.O": "757001",
      "Udala College S.O": "757041",
      "Udala S.O": "757041",
      "Bahalda S.O": "757046",
      "Jamda S.O (Mayurbhanj)": "757045",
      "Jashipur S.O": "757034",
      "Khairi Jashipur S.O": "757091",
      "Rairangpur Bazar S.O": "757043",
      "Rairangpur R.S S.O": "757043",
      "Raruan S.O": "757035"
    },
    "SONEPUR": {
      "Gajbandh B.O": "767019",
      "Jullunda B.O": "767019",
      "Kartang B.O": "767019",
      "Mahada B.O": "767019",
      "Sankara B.O": "767019",
      "Seledi B.O": "767019",
      "Silati B.O": "767019",
      "Amarpali B.O": "767018",
      "Bagbar B.O": "767018",
      "Hillung B.O": "767018",
      "Beheramal B.O": "767023",
      "Cherupali B.O": "767023",
      "Chinajuri B.O": "767023",
      "Digsira B.O": "767023",
      "Sargul B.O": "767023",
      "Bhimtikra B.O": "767019",
      "Mahadevpali B.O": "767019",
      "Sindurpur B.O": "767019",
      "Jatesingha B.O": "767018",
      "Kalapathar B.O": "767018",
      "Khandahata B.O": "767018",
      "Kumarkeli B.O": "767018",
      "Ichhapur B.O": "767023",
      "Samaleichuan B.O": "767023",
      "Sohela B.O": "767023",
      "Bhandar B.O": "767019",
      "Meghla B.O": "767019",
      "Jaloi B.O": "767018",
      "Kadodar B.O": "767018",
      "Kotsamalai B.O": "767018",
      "Luthurpank B.O": "767018",
      "Karlajuri B.O": "767023",
      "Sukha B.O": "767023",
      "Tamamura B.O": "767023",
      "Bausuni B.O": "767019",
      "Kamalpur B.O": "767018",
      "Kenghriapali B.O": "767018",
      "Mursundhi B.O": "767018",
      "Pitamahul B.O": "767018",
      "S.Mahada B.O": "767018",
      "Subalaya B.O": "767018",
      "Bankipali B.O": "767023",
      "Kutasingha B.O": "767068",
      "Matiapali B.O": "767068",
      "Ranisarda B.O": "767020",
      "Lupursingha B.O": "767068",
      "Rengali B.O": "767068",
      "Bisimunda B.O": "767017",
      "Khambeswaripali B.O": "767017",
      "Brahmani B.O": "767016",
      "Dubula B.O": "767016",
      "Khari B.O": "767016",
      "Sargaj B.O": "767016",
      "Thelkomunda B.O": "767016",
      "Chadeipank B.O": "767062",
      "Jhartarbha B.O": "767016",
      "Kamsara B.O": "767016",
      "Maradoguchha B.O": "767016",
      "Menda B.O": "767016",
      "Narayanpur B.O": "767016",
      "Pua B.O": "767016",
      "Harinapali B.O": "767062",
      "Hikudi B.O": "767062",
      "Naikpada B.O": "767062",
      "Nakdei B.O": "767062",
      "Babupali B.O": "767045",
      "Bankigirdi B.O": "767045",
      "Lingamarni B.O": "767045",
      "Sarasmal B.O": "767045",
      "Mayurudan B.O": "767017",
      "S. Kalapathar B.O": "767017",
      "Arjunda B.O": "767016",
      "B.Sibtala B.O": "767016",
      "Badbhainro B.O": "767016",
      "Raksa B.O": "767062",
      "Sindhol B.O": "767062",
      "Deulpadar B.O": "767020",
      "Badkarle B.O": "767045",
      "R. Mayabarha B.O": "767045",
      "Singhijuba B.O": "767045",
      "Baidyanath B.O": "767017",
      "Khaliapali B.O": "767017",
      "Charbhata B.O": "767016",
      "Singhari B.O": "767016",
      "Tullunda B.O": "767016",
      "Dharamsala B.O": "767062",
      "Panchamahala B.O": "767062",
      "S.Patrapali B.O": "767062",
      "Dungripali S.O": "767023",
      "Birmaharajpur S.O": "767018",
      "Ghodaghatpara S.O": "767017",
      "Lachhipur S.O": "767068",
      "Sonepur S.O (Sonapur)": "767017",
      "Ullunda S.O": "767062",
      "Sonepur Badbazar S.O": "767017",
      "Sonepur Rampur S.O": "767045",
      "Binka S.O": "767019",
      "Spinning Mills S.O": "767017",
      "Tarbha Bazar S.O": "767016",
      "Tarbha S.O": "767016"
    },
    "BALANGIR": {
      "Budula B.O": "767022",
      "Goimund B.O": "767040",
      "Mahakhand B.O": "767040",
      "Khalipathar B.O": "767026",
      "Bhundimuhan B.O": "767048",
      "Jhankarpali B.O": "767065",
      "Kusang B.O": "767065",
      "Kushmel B.O": "767065",
      "Rengali B.O": "767028",
      "Sahajbahal B.O": "767024",
      "Sibtala B.O": "767024",
      "Sikachhida B.O": "767029",
      "Sikuan B.O": "767029",
      "Bharsuja B.O": "767061",
      "Dhanpur B.O": "767046",
      "Ghunesh B.O": "767038",
      "Mahulpati B.O": "767038",
      "Malpara B.O": "767038",
      "Sunamudi B.O": "767041",
      "Rusuda B.O": "767067",
      "Salepali B.O": "767067",
      "Udar B.O": "767067",
      "Uparjhar B.O": "767067",
      "Kandhenjhula B.O": "767027",
      "Chuliphunka B.O": "767040",
      "Jharial B.O": "767040",
      "Khaira B.O": "767040",
      "Bahabal B.O": "767026",
      "Kapani B.O": "767026",
      "Salandi B.O": "767026",
      "Dumerpita B.O": "767048",
      "Mudghat B.O": "767048",
      "Chhatamakhana B.O": "767065",
      "Mirdhapali B.O": "767065",
      "Sadeipali B.O": "767065",
      "Bidighat B.O": "767024",
      "G.S. Dungripali B.O": "767024",
      "Dhandamal B.O": "767029",
      "Pandesara B.O": "767061",
      "Bender B.O": "767038",
      "Fulkimunda B.O": "767038",
      "Tankapani B.O": "767038",
      "Badbahal B.O": "767067",
      "Kultapara B.O": "767067",
      "Gambhari B.O": "767027",
      "Belpara B.O": "767040",
      "Kapalabhata B.O": "767040",
      "Bagdor B.O": "767026",
      "Khairmal B.O": "767026",
      "Mandal B.O": "767026",
      "Mayabarha B.O": "767048",
      "Ramchandrapur B.O": "767048",
      "Barpudigia B.O": "767024",
      "Fatkara B.O": "767024",
      "Desandh B.O": "767029",
      "Kudasingha B.O": "767029",
      "Jharnipali B.O": "767061",
      "Roth B.O": "767061",
      "Jamut B.O": "767046",
      "Baddakala B.O": "767038",
      "Dholmandal B.O": "767038",
      "Gourgoth B.O": "767067",
      "Mahalei B.O": "767067",
      "Dedarha B.O": "767027",
      "Nagaon B.O": "767020",
      "Rinbachan B.O": "767022",
      "Bhalumunda B.O": "767040",
      "Mundpadar B.O": "767040",
      "Sanmula B.O": "767040",
      "Dumabhata B.O": "767026",
      "Ghagurli B.O": "767026",
      "Jurabandh B.O": "767026",
      "Kanut B.O": "767026",
      "Sarmuhan B.O": "767026",
      "Sulekela B.O": "767026",
      "Tikrapara B.O": "767026",
      "Jhinkidungri B.O": "767026",
      "Taliudar B.O": "767065",
      "Baidipali B.O": "767024",
      "Badbandh B.O": "767029",
      "Bandhpara B.O": "767029",
      "Bhutiarbahal B.O": "767029",
      "Kandhkelgaon B.O": "767029",
      "Landapathar B.O": "767029",
      "Mursingh B.O": "767029",
      "Ghuna B.O": "767046",
      "Arjunpur B.O": "767067",
      "Barbahal B.O": "767027",
      "Damaipali B.O": "767027",
      "Darlipali B.O": "767027",
      "Matikhai B.O": "767027",
      "Pandamunda B.O": "767027",
      "Bichhubahali B.O": "767039",
      "Chaulsukha B.O": "767039",
      "Dhamandanga B.O": "767039",
      "Khagsa B.O": "767039",
      "Khujenbahali B.O": "767039",
      "Kukurahad B.O": "767039",
      "Luhasingha B.O": "767027",
      "Chatuanka B.O": "767039",
      "Ghunsar B.O": "767032",
      "Maharapadar B.O": "767028",
      "Nandupala B.O": "767028",
      "Kuskela B.O": "767066",
      "Agalapali B.O": "767020",
      "Sakma B.O": "767020",
      "Bankel B.O": "767037",
      "Chalki B.O": "767037",
      "Ganrei B.O": "767037",
      "Gudighat B.O": "767037",
      "Barpadar B.O": "767041",
      "Damkipali B.O": "767025",
      "Ghasian B.O": "767025",
      "Juba B.O": "767025",
      "B.Fatkara B.O": "767002",
      "Bhaler B.O": "767002",
      "Bubel B.O": "767002",
      "Khujenpali B.O": "767002",
      "Kamarlaga B.O": "767032",
      "Kuanrgaon B.O": "767032",
      "Padiabahal B.O": "767028",
      "Turla B.O": "767028",
      "Jagua B.O": "767066",
      "Marlad B.O": "767066",
      "Badimunda B.O": "767020",
      "Burda B.O": "767020",
      "Manhira B.O": "767020",
      "Pardhiapali B.O": "767020",
      "Sargad B.O": "767020",
      "Ichhapara B.O": "767037",
      "Patrapali B.O": "767037",
      "Kutmunda B.O": "767041",
      "Tendapadar B.O": "767041",
      "Balipata B.O": "767025",
      "Batharla B.O": "767025",
      "Gangasagar B.O": "767025",
      "K. Larambha B.O": "767025",
      "Kendumundi B.O": "767025",
      "Mundomahul B.O": "767025",
      "Khursel": "767025",
      "Ankriapadar B.O": "767002",
      "Bahalpadar B.O": "767002",
      "Kharjura B.O": "767002",
      "Patharla B.O": "767002",
      "Budhabahal B.O": "767032",
      "Khasbahal B.O": "767032",
      "Bakti B.O": "767021",
      "Mursundhi B.O": "767021",
      "Budhipadar B.O": "767021",
      "Bhursaguda B.O": "767035",
      "Alanda B.O": "767033",
      "Chantipala B.O": "767033",
      "Ghantabahali B.O": "767033",
      "Luthurbandh B.O": "767033",
      "Siker B.O": "767033",
      "Totopara B.O": "767033",
      "Deulgudi B.O": "767030",
      "Nuapara B.O": "767030",
      "Bileisarda B.O": "767071",
      "Kumbhari B.O": "767032",
      "Bendra B.O": "767021",
      "Rampur B.O": "767021",
      "Katarkela B.O": "767033",
      "Lebda B.O": "767033",
      "Maingaon B.O": "767033",
      "Rigdol B.O": "767033",
      "Sirul B.O": "767033",
      "Badangomunda B.O": "767030",
      "Kapsila B.O": "767030",
      "Dhandamunda B.O": "767028",
      "Udiapali B.O": "767028",
      "Naren B.O": "767066",
      "Sihini B.O": "767066",
      "Hirapur B.O": "767020",
      "Jogisarda B.O": "767020",
      "Kandajuri B.O": "767020",
      "Tentulikhunti B.O": "767037",
      "Ulba B.O": "767041",
      "Padhel B.O": "767025",
      "Phatamunda B.O": "767025",
      "Solbandh B.O": "767025",
      "Tamia B.O": "767025",
      "Bharatbahal BO": "767025",
      "Daspur B.O": "767002",
      "Kurul B.O": "767002",
      "Mahimunda B.O": "767002",
      "Makundpur B.O": "767002",
      "Randa B.O": "767002",
      "Ampali B.O": "767032",
      "Gandpatrapali B.O": "767032",
      "Dedgaon B.O": "767035",
      "Jamkhunta B.O": "767035",
      "Kursud B.O": "767035",
      "Parasara B.O": "767035",
      "Titisilet B.O": "767035",
      "Bijepur B.O": "767033",
      "Binekela B.O": "767033",
      "Badbanki B.O": "767060",
      "Kuibahal B.O": "767060",
      "Mahulbahali B.O": "767060",
      "Samra B.O": "767030",
      "Tandigaon B.O": "767030",
      "Sauntpur B.O": "767071",
      "Ainlasari BO": "767071",
      "Sargul B.O": "767039",
      "Bhanpur B.O": "767028",
      "Telenpali B.O": "767028",
      "Adabahal B.O": "767066",
      "Badibahal B.O": "767020",
      "Badtika B.O": "767020",
      "Khaliapali B.O": "767020",
      "Badsaimara B.O": "767037",
      "Haldi B.O": "767037",
      "Malisira B.O": "767037",
      "Chanabahal BO": "767037",
      "Deulgaon B.O": "767041",
      "Bagmund B.O": "767025",
      "Banaimunda B.O": "767025",
      "Khuntsamalei B.O": "767025",
      "Dangabahal BO": "767025",
      "Atgaon B.O": "767002",
      "Chhatapipal B.O": "767002",
      "Gaintala B.O": "767002",
      "Jamgaon B.O": "767002",
      "Malmunda B.O": "767002",
      "Manoharpur B.O": "767002",
      "Belgaon B.O": "767032",
      "Bhadra B.O": "767032",
      "Deng B.O": "767032",
      "Karamtala B.O": "767032",
      "Siskela B.O": "767032",
      "Patuapali B.O": "767021",
      "Chandotara B.O": "767035",
      "Salebarat B.O": "767035",
      "Bairasar B.O": "767016",
      "Desil B.O": "767033",
      "Goilbhadi B.O": "767033",
      "Lenjha B.O": "767033",
      "Banjipadar BO": "767033",
      "Salemudga B.O": "767060",
      "Dahimal B.O": "767030",
      "Durgapali B.O": "767071",
      "Pipirda B.O": "767071",
      "Balangir H.O": "767001",
      "Bhatipara S.O": "767042",
      "Deogaon S.O (Balangir)": "767029",
      "Duduka S.O": "767061",
      "Jogimunda S.O": "767027",
      "Kholan S.O": "767066",
      "Marwari Bazar S.O": "767001",
      "Patnagarh Bazar S.O": "767025",
      "Harisankar Road S.O": "767038",
      "Hatpadapara S.O": "767033",
      "Khaprakhol S.O": "767028",
      "Turekela S.O": "767060",
      "Of Badmal S.O": "767070",
      "Rugudi Para S.O": "767001",
      "Talpalipara S.O": "767001",
      "Tikrapara S.O": "767001",
      "Titilagarh Court S.O": "767033",
      "Puintala S.O": "767071",
      "College Square S.O (Balangir)": "767002",
      "Jarasingha S.O": "767067",
      "Kantabanji Bazar S.O": "767039",
      "Loisingha S.O": "767020",
      "Patnagarh S.O": "767025",
      "Saintala S.O": "767032",
      "Sudpara S.O": "767001",
      "Tusra S.O": "767030",
      "Bhainsa S.O (Balangir)": "767048",
      "Chandanbhati S.O": "767065",
      "Churapali S.O": "767024",
      "Gudvella S.O": "767046",
      "Kantabanji S.O": "767039",
      "Muribahal S.O": "767037",
      "P.Rampur S.O": "767041",
      "Rajendra College S.O (Balangir)": "767002",
      "Salebhata S.O": "767021",
      "Sindhekela S.O": "767035",
      "Titilagarh Bazar S.O": "767033",
      "Titilagarh S.O": "767033",
      "Agalpur S.O": "767022",
      "Banganmura S.O": "767040",
      "Belpara S.O": "767026",
      "Balangir Court S.O": "767001",
      "Balangir RS S.O": "767001"
    },
    "KANDHAMAL": {
      "Titrapanga B.O": "762029",
      "Talarimaha B.O": "762022",
      "Dutimendi B.O": "762012",
      "Bandapipili B.O": "762105",
      "Marlang B.O": "762105",
      "Ora B.O": "762105",
      "Srirampur B.O": "762105",
      "Mediakia B.O": "762109",
      "Pusangia B.O": "762109",
      "Bapalamendi B.O": "762010",
      "Jhagadapata B.O": "762027",
      "Gunjibadi B.O": "762102",
      "Burbinaju B.O": "762112",
      "Petapanga B.O": "762112",
      "Kasinipadar B.O": "762011",
      "Nuapadar B.O": "762011",
      "Rabingia B.O": "762110",
      "Sripalla B.O": "762011",
      "Gedingia B.O": "762101",
      "Gundhani B.O": "762101",
      "Mandakia B.O": "762101",
      "Manikeswar B.O": "762101",
      "Katadi B.O": "762106",
      "Minia B.O": "762029",
      "Pakanagaon B.O": "762029",
      "Arapaju B.O": "762012",
      "Judabali B.O": "762105",
      "Kutiguda B.O": "762105",
      "Dankuni B.O": "762027",
      "R Nuagaon B.O": "762027",
      "Balligada B.O": "762102",
      "Adasikupa B.O": "762112",
      "Gardingia B.O": "762112",
      "Luhuringia B.O": "762112",
      "Bisipada B.O": "762011",
      "Dimbiriguda B.O": "762011",
      "Kelapada B.O": "762011",
      "Kiamunda B.O": "762011",
      "Majhipada B.O": "762011",
      "Ratanga B.O": "762011",
      "Sadingia B.O": "762011",
      "Sakhipada B.O": "762011",
      "Seskajodi B.O": "762011",
      "Gudrikia B.O": "762101",
      "Sikaketa B.O": "762101",
      "Sugudabadi B.O": "762101",
      "Gandagaon B.O": "762019",
      "Kainjhar B.O": "762019",
      "Padangi B.O": "762106",
      "Siringia B.O": "762106",
      "Beheragaon B.O": "762010",
      "Breka B.O": "762010",
      "Tentuligarh B.O": "762010",
      "Belghar B.O": "762107",
      "Bhandrangi B.O": "762107",
      "Ganjuguda B.O": "762029",
      "Rasimendi B.O": "762029",
      "Kurmingia B.O": "762022",
      "Baikumpa B.O": "762012",
      "Dalapada B.O": "762012",
      "Lambabadi B.O": "762012",
      "Sakadi B.O": "762012",
      "Madaguda B.O": "762105",
      "Paikadharakote B.O": "762105",
      "Salkibudaguda B.O": "762105",
      "Dangesiguda B.O": "762109",
      "Parampanga B.O": "762109",
      "Dharampur B.O": "762102",
      "Kanjamendi B.O": "762102",
      "Kudutuli B.O": "762102",
      "Jajespanga B.O": "762011",
      "Muselipanga B.O": "762011",
      "Pabingia B.O": "762011",
      "Tellapali B.O": "762011",
      "Bakingia B.O": "762101",
      "Chanchedi B.O": "762101",
      "Deegi B.O": "762101",
      "Mandasaru B.O": "762101",
      "Padunbadi B.O": "762101",
      "Guttingia B.O": "762106",
      "Bandaguda B.O": "762106",
      "Arabaka B.O": "762010",
      "Katimaha B.O": "762010",
      "Bilamala B.O": "762107",
      "Jalespata B.O": "762107",
      "Mandalapadar B.O": "762107",
      "Magadangia B.O": "762106",
      "Paderipada B.O": "762106",
      "Badimunda B.O": "762010",
      "Mruskusahi B.O": "762010",
      "Pikaradi B.O": "762010",
      "Jhiripani B.O": "762107",
      "Lankagada B.O": "762107",
      "Keredi B.O": "762029",
      "Balumaha B.O": "762022",
      "Duguripadi B.O": "762022",
      "Dutipada B.O": "762012",
      "Gudari B.O": "762012",
      "Ranapatuli B.O": "762012",
      "Durgapanga B.O": "762105",
      "Gugurumaha B.O": "762105",
      "Subarnagiri B.O": "762105",
      "Balimusti B.O": "762109",
      "Bataguda B.O": "762109",
      "Biringia B.O": "762109",
      "Dadakangia B.O": "762109",
      "Demisingia B.O": "762102",
      "Lethingia B.O": "762102",
      "Lokebadi B.O": "762102",
      "Sirtiguda B.O": "762102",
      "Bandhagarh B.O": "762011",
      "Bhrungijodi B.O": "762011",
      "PANGA UPARSHI BO": "762011",
      "Bandha B.O": "762101",
      "Beredakia B.O": "762101",
      "Dadingia B.O": "762101",
      "Kajuri B.O": "762101",
      "Lamungia B.O": "762101",
      "Bariguda B.O": "762106",
      "Banegaon B.O": "762106",
      "Bastingia B.O": "762010",
      "Gumma B.O": "762107",
      "Mundigarh B.O": "762107",
      "Sirla B.O": "762107",
      "Pasara B.O": "762028",
      "Balandapada B.O": "762002",
      "Dakpala B.O": "762002",
      "Jamjhari B.O": "762002",
      "Paheraju B.O": "762002",
      "Sainipadar B.O": "762002",
      "Tikiripada B.O": "762002",
      "Danekbadi B.O": "762104",
      "Simanbadi B.O": "762104",
      "Sraniketa B.O": "762104",
      "Gadaguda B.O": "762100",
      "Bellapadar B.O": "762028",
      "Brahmanpad B.O": "762028",
      "Chahali B.O": "762028",
      "Ghatiguda B.O": "762028",
      "Krandibali B.O": "762002",
      "Loisingi B.O": "762002",
      "Badangia B.O": "762104",
      "Kerubadi B.O": "762104",
      "Kirikuti B.O": "762104",
      "Kumbharabadi B.O": "762104",
      "Terabadi B.O": "762104",
      "Batimunda B.O": "762002",
      "Dadaki B.O": "762002",
      "Gochhapada B.O": "762002",
      "Salaguda B.O": "762110",
      "Sudreju B.O": "762002",
      "Sudrukumpa B.O": "762002",
      "Talapada B.O": "762002",
      "Badabanga B.O": "762104",
      "Pangali B.O": "762104",
      "Parthamaha B.O": "762104",
      "Siangbali B.O": "762104",
      "Nediguda B.O": "762028",
      "Rupagaon B.O": "762028",
      "Katringia B.O": "762002",
      "Pokhari B.O": "762002",
      "Tudipaju B.O": "762002",
      "Bhramarabadi B.O": "762104",
      "Dasingbadi B.O": "762104",
      "Greenbadi B.O": "762104",
      "Sonepur B.O": "762104",
      "Tekangia B.O": "762104",
      "Dadapada B.O": "762100",
      "Rattingia B.O": "762100",
      "Sirki B.O": "762100",
      "Badabhuin B.O": "762029",
      "Balaskumpa B.O": "762029",
      "Gressingia B.O": "762100",
      "Nilungia B.O": "762100",
      "Rudangia B.O": "762100",
      "Sudhipada B.O": "762100",
      "Adasipada B.O": "762029",
      "Boida B.O": "762029",
      "Raikala B.O": "762100",
      "Raipalli B.O": "762100",
      "Kanbageri B.O": "762100",
      "Kathingia B.O": "762100",
      "Lingagarh B.O": "762100",
      "Mallickpodi B.O": "762100",
      "Tiangia B.O": "762100",
      "Pukulingia B.O": "762100",
      "Karada B.O": "761151",
      "Bediketa B.O": "762103",
      "Budaguda B.O": "762103",
      "Dandapadar B.O": "762103",
      "Gumikia B.O": "762103",
      "Parigada B.O": "762103",
      "Sainipada B.O": "762103",
      "Allanjuri B.O": "762021",
      "Kumbharigaon B.O": "762021",
      "Tamangi B.O": "762021",
      "Khamankhole B.O": "762110",
      "Melsikia B.O": "762110",
      "Sautikia B.O": "762110",
      "Sindrigaon B.O": "762103",
      "Tillory B.O": "762103",
      "Minjapanka B.O": "762021",
      "Salimagochha B.O": "762021",
      "Saramuli B.O": "762021",
      "Budrukia B.O": "762103",
      "Burangia B.O": "762103",
      "Demingia B.O": "762103",
      "Kachhabali B.O": "762103",
      "Kudupanga B.O": "762103",
      "Mahasingi B.O": "762103",
      "Pakari B.O": "762103",
      "Gudikia B.O": "762021",
      "Hatimunda B.O": "762021",
      "Jhinjiriguda B.O": "762021",
      "Kasabasa B.O": "762021",
      "Kattingia B.O": "762021",
      "Pokharibandha B.O": "762110",
      "Sarkipada B.O": "762110",
      "Sudra B.O": "762110",
      "Tikarabaju B.O": "762110",
      "Badagaon B.O": "762103",
      "Boudingia B.O": "762103",
      "Rutungia B.O": "762103",
      "Samanbadi B.O": "762103",
      "Gadapur B.O": "762021",
      "Mahagudi B.O": "762021",
      "Mandipanka B.O": "762021",
      "Sangadama B.O": "762021",
      "Tajungia B.O": "762021",
      "Balakia B.O": "762110",
      "Kutikia B.O": "762110",
      "Indragada B.O": "761125",
      "Ranaba B.O": "761108",
      "Phulbani H.O": "762001",
      "Chakapada S.O": "762028",
      "Linepada S.O": "762027",
      "Paburia S.O": "762112",
      "Sarangada S.O": "762106",
      "Kalinga S.O": "762022",
      "Kothagarh S.O": "762105",
      "Masterpada S.O": "762001",
      "Nuagaon S.O (Kandhamal)": "762102",
      "Ollenbatch Nagar S.O": "762001",
      "Penjisahi (TPO 1135) S.O": "762001",
      "Bamunigaon S.O (Kandhamal)": "762021",
      "Barakhama S.O": "762110",
      "Court Street G Udayagiri S.O": "762100",
      "Gumagarh S.O": "762029",
      "Sankarakhole S.O": "762019",
      "Balliguda S.O": "762103",
      "Contractorpada S.O": "762002",
      "Daringbadiso S.O": "762104",
      "G.Udayagiri S.O": "762100",
      "Khajuripada S.O": "762012",
      "Kurtamgarh S.O": "762109",
      "Madikunda S.O": "762001",
      "Nuasahi S.O": "762103",
      "Phiringia S.O": "762011",
      "Phulbani Bazar S.O": "762001",
      "Raikia S.O": "762101",
      "Tikabali S.O": "762010",
      "Tumudibandha S.O": "762107"
    },
    "BOUDH": {
      "Kumari B.O": "762020",
      "Mahallickpada B.O": "762020",
      "Adenigarh B.O": "762023",
      "Karanjakata B.O": "762023",
      "Ranipathar B.O": "762023",
      "Srimal B.O": "762017",
      "Talagaon B.O": "762012",
      "Jogindrapur B.O": "762016",
      "Tundmal B.O": "762016",
      "Tileswar B.O": "762013",
      "Mallickpada B.O": "762020",
      "Sankulei B.O": "762020",
      "Gundribida B.O": "762023",
      "Baragochha B.O": "762016",
      "Bilaspur B.O": "762016",
      "Damamunda B.O": "762016",
      "Gudvellipadar B.O": "762016",
      "Khairmal B.O": "762016",
      "Padarpada B.O": "762016",
      "Sagada B.O": "762016",
      "Khandahata B.O": "762013",
      "Ramgarh B.O": "762013",
      "Bandhapathar B.O": "762026",
      "Birigarh B.O": "762026",
      "Dhadalapada B.O": "762026",
      "Kharabhuin B.O": "762020",
      "Kusanga B.O": "762020",
      "Laxmanpur B.O": "762023",
      "Gadiapada B.O": "762012",
      "Madhapur B.O": "762012",
      "Balanda B.O": "762013",
      "Salki B.O": "762026",
      "Badhigaon B.O": "762026",
      "Baghiapada B.O": "762026",
      "Tikiripada B.O": "762026",
      "Arakhapadar B.O": "762020",
      "Bhejigora B.O": "762020",
      "Chhatranga B.O": "762020",
      "Satakhanda B.O": "762020",
      "Badachhapalli B.O": "762017",
      "Baragaon B.O": "762017",
      "Narayan Prasad B.O": "762017",
      "Sanachhapalli B.O": "762017",
      "Baringi B.O": "762012",
      "Gandapaju B.O": "762012",
      "Gandisara B.O": "762012",
      "Sundhipadar B.O": "762016",
      "Badabandha B.O": "762013",
      "Dhalapur B.O": "762013",
      "Khuntiapada B.O": "762026",
      "Palaspat B.O": "762014",
      "Dahya B.O": "762015",
      "Gundulia B.O": "762015",
      "Nuapalli B.O": "762018",
      "Rusibandha B.O": "762015",
      "Telibandha B.O": "762014",
      "Badiketa B.O": "762015",
      "Bahira B.O": "762015",
      "Kampara B.O": "762015",
      "Kankala B.O": "762015",
      "Kasurbandha B.O": "762015",
      "Manupalli B.O": "762015",
      "Ainlapalli B.O": "762015",
      "Ambajhari B.O": "762015",
      "Sangochhapada B.O": "762015",
      "Sangrampur B.O": "762015",
      "Tilapanga B.O": "762015",
      "Tetelenga B.O": "762014",
      "Balakira B.O": "762015",
      "Juramunda B.O": "762015",
      "Mundipadar B.O": "762015",
      "Roxa B.O": "762015",
      "Ambagaon B.O": "762018",
      "Kultajore B.O": "762018",
      "Fased B.O": "762018",
      "Masinagora B.O": "762018",
      "Uden B.O": "762018",
      "Uma B.O": "762018",
      "Khatakhatia B.O": "762030",
      "Rundimahal B.O": "762030",
      "Devgarh B.O": "762024",
      "Brahmanpalli B.O": "762014",
      "Khamariapada B.O": "762014",
      "Khuntabandha B.O": "762014",
      "Barapadar B.O": "762030",
      "Gabjore B.O": "762030",
      "Khaliapalli B.O": "762030",
      "Kelakata B.O": "762024",
      "Mathura B.O": "762024",
      "Rambhikata B.O": "762024",
      "Butupalli B.O": "762014",
      "Charada B.O": "762014",
      "Marjakud B.O": "762014",
      "Mundapada B.O": "762014",
      "Lokapada B.O": "762030",
      "Bamanda B.O": "762024",
      "Bilabadi B.O": "762024",
      "Biramchandrapur B.O": "762024",
      "Jagati B.O": "762014",
      "Janhapanka B.O": "762014",
      "Laxmiprasad B.O": "762014",
      "Dapalla B.O": "762030",
      "Similipadar B.O": "762030",
      "Karadi B.O": "762024",
      "Lunibahal B.O": "762024",
      "Sampoch B.O": "762024",
      "Balasinga B.O": "762014",
      "Kamira B.O": "762014",
      "Murusundhi B.O": "762014",
      "Baghiabahal S.O": "762030",
      "Harabhanga S.O": "762020",
      "Jhadrajing S.O": "762023",
      "Biranarasinghpur S.O": "762024",
      "Boudh Court S.O": "762014",
      "Boudhraj S.O": "762014",
      "Bounsoni S.O": "762015",
      "Sarsara S.O": "762026",
      "Boudhbazar S.O": "762014",
      "Kantamal S.O": "762017",
      "Ghantapada S.O": "762018",
      "Mallisahi S.O": "762014",
      "Manamunda S.O": "762016",
      "Purunakatak S.O": "762013"
    },
    "GANJAM": {
      "Baritola B.O": "761055",
      "Phasiguda B.O": "761055",
      "Dekahli B.O": "761042",
      "Jaccaro B.O": "761042",
      "Karapada B.O": "761026",
      "Ambagaon B.O": "761012",
      "Ankuli B.O": "760010",
      "Koturu B.O": "761009",
      "R.Suvani B.O": "761009",
      "Sonepur B.O": "761009",
      "Surala B.O": "761009",
      "Mantridi B.O": "761008",
      "Mendrajpur B.O": "761008",
      "Ganju B.O": "761002",
      "Kallipalli B.O": "761002",
      "Narayanapur B.O": "761209",
      "Upalaputti B.O": "761002",
      "Ladigam B.O": "760003",
      "Markandi B.O": "760003",
      "Padmapur B.O": "761109",
      "Phulta B.O": "760003",
      "Jarada Ankuli B.O": "761005",
      "Suanakhala B.O": "761005",
      "Sunareddy B.O": "761005",
      "Tumbagada B.O": "761005",
      "Ch.Tikarapada B.O": "761209",
      "Hukuma B.O": "761108",
      "Kampa Khumbajhari B.O": "761209",
      "Badiosta B.O": "761054",
      "Goutami B.O": "761054",
      "Bendalia B.O": "760002",
      "Badapur B.O": "760007",
      "Rangailunda B.O": "760007",
      "Nimakhandi Pentho B.O": "761055",
      "Jagamohanapur B.O": "761010",
      "Krushanapur B.O": "761010",
      "Pitatoli B.O": "761010",
      "Chudangapur B.O": "761012",
      "Kusapada B.O": "761012",
      "Jhatipadar B.O": "761009",
      "Indrakhi B.O": "761008",
      "Konisi B.O": "761008",
      "Shiala B.O": "761008",
      "Badaputi B.O": "761002",
      "Haladiapadar B.O": "760003",
      "Gundra B.O": "761005",
      "B.Nuagam B.O": "761006",
      "Totipuram B.O": "761006",
      "Bharampur B.O": "761209",
      "Mandarada B.O": "761209",
      "Puhundi B.O": "761209",
      "Tinigharia B.O": "761209",
      "Gopinathpur B.O": "761009",
      "Gurunthi B.O": "761001",
      "Jhadankuli B.O": "761001",
      "B.L.N.Pur B.O": "761032",
      "Badakhajahari B.O": "761011",
      "L.N.Pur B.O": "761011",
      "Golanda B.O": "761007",
      "Jharipadar B.O": "761007",
      "Kelua B.O": "761004",
      "Moisanpur B.O": "761004",
      "Singipur B.O": "761014",
      "Padadigi B.O": "761037",
      "Humuri B.O": "761026",
      "Podapadar B.O": "761026",
      "Rajpur B.O": "761026",
      "Arakhapur B.O": "761117",
      "Ankushpur B.O": "761100",
      "Baulojholi B.O": "761100",
      "Bhabinipur B.O": "761001",
      "Borigam B.O": "761001",
      "Krupasindhupur B.O": "761001",
      "Lochapada B.O": "761001",
      "Godagovindapur B.O": "761011",
      "B.Turubudi B.O": "761007",
      "Boripadar B.O": "761007",
      "Chaitanyapur B.O": "761007",
      "Santoshpur B.O": "761027",
      "Kharnipada B.O": "761037",
      "Tandipur B.O": "761037",
      "Bupilingi B.O": "761026",
      "Karatoli B.O": "761026",
      "Rukunigam B.O": "761026",
      "Sarabhimpur B.O": "761026",
      "Birikote B.O": "761132",
      "Brhamanapadar B.O": "761132",
      "Landajuali B.O": "761122",
      "Munigadi B.O": "761122",
      "Dhumchai B.O": "761140",
      "G.Nuagam B.O": "761140",
      "Tholadi B.O": "761131",
      "Turumu B.O": "761131",
      "Dadarlunda B.O": "761132",
      "Gundribadi B.O": "761132",
      "Kendupadar B.O": "761122",
      "K.Berhampur B.O": "761140",
      "Patulisahi B.O": "761140",
      "Tilisinghi B.O": "761131",
      "Buduli B.O": "761132",
      "Nalihada B.O": "761054",
      "Banthapalli B.O": "761105",
      "Gadasamantarapur B.O": "761055",
      "Khamarigam B.O": "761055",
      "Panada B.O": "761055",
      "Manikyapur B.O": "761107",
      "G.Rambha B.O": "761132",
      "Benapata B.O": "761122",
      "Kamagada B.O": "761122",
      "Dihapadhala B.O": "761140",
      "Inginathi B.O": "761140",
      "Mundapata B.O": "761042",
      "Kalabada B.O": "761010",
      "Nuagaon B.O": "761010",
      "Ankorada B.O": "761012",
      "Gokarnapur B.O": "761012",
      "Maulabhanja B.O": "761012",
      "Dura B.O": "760010",
      "Kaviti Suvani B.O": "761009",
      "Konika B.O": "761008",
      "Kotharasingi B.O": "761008",
      "Sunadei B.O": "761008",
      "Boxipalli B.O": "761002",
      "Venkataraipur B.O": "761002",
      "Daspur B.O": "760003",
      "Keluapalli B.O": "760003",
      "Rangipur B.O": "760003",
      "Dengapadar B.O": "761146",
      "Sidheswara B.O": "761054",
      "Dakhinpur B.O": "760002",
      "Lathi B.O": "760002",
      "Mohuda B.O": "760002",
      "Puruna Berhampur B.O": "760002",
      "Badakusasthali B.O": "760007",
      "Bahadurpeta B.O": "760007",
      "Narendrapur B.O": "761103",
      "Sahadev Tikirapada B.O": "761055",
      "Badadumbala B.O": "761042",
      "Ballijodi B.O": "761042",
      "Badapalanka B.O": "761010",
      "Chikitipentho B.O": "761010",
      "Kolathia B.O": "761010",
      "Kottilingi B.O": "761010",
      "Madhabandha B.O": "761010",
      "Ramchandrapur B.O": "761010",
      "Rampa B.O": "761010",
      "Sahaspur B.O": "761115",
      "Haripur B.O": "761009",
      "Biswanathpur B.O": "761008",
      "Chikarada B.O": "761008",
      "Govindanagar B.O": "761008",
      "Panchama B.O": "761008",
      "Rondha B.O": "761008",
      "Sasanapadar B.O": "761008",
      "Ambapur B.O": "761005",
      "Andanda B.O": "761005",
      "Burutal B.O": "761005",
      "Bansola B.O": "761006",
      "Barango B.O": "761006",
      "Gudipadar B.O": "761006",
      "Kesaripada B.O": "761006",
      "Raijhola B.O": "761100",
      "Satapahandia B.O": "761100",
      "Palasi B.O": "761001",
      "Banamali B.O": "761011",
      "Dabarsingi B.O": "761011",
      "Dauni B.O": "761011",
      "Narendrappur B.O": "761007",
      "Odasingi B.O": "761007",
      "Talasingi B.O": "761007",
      "Badabaranga B.O": "761004",
      "Bhimpur B.O": "761004",
      "Samantiapalli B.O": "761004",
      "Chanamari B.O": "761014",
      "Kansamari B.O": "761014",
      "P.Govindapur B.O": "761014",
      "Patiguda B.O": "761014",
      "Gothagam B.O": "761146",
      "Agastinuagam B.O": "761026",
      "Badamadhapur B.O": "761026",
      "Chikati Badapur B.O": "761005",
      "Guma Dalaba B.O": "761209",
      "S.B.Jagadevpur B.O": "761209",
      "Talapada B.O": "761030",
      "Turubudi B.O": "761209",
      "Dayapalli B.O": "761100",
      "Ollarigada B.O": "761100",
      "Hugulapata B.O": "761001",
      "Jagadalapur B.O": "761001",
      "Goudagam B.O": "761011",
      "Guhalpur B.O": "761007",
      "Kaithkhandi B.O": "761007",
      "Khambarigam B.O": "761004",
      "Nuapentho B.O": "761037",
      "S.B.Pentho B.O": "761037",
      "Chikalakhandi B.O": "761026",
      "Kalyanapur B.O": "761026",
      "Pallibandha B.O": "761026",
      "Pottalmpur B.O": "761026",
      "Badamahuri B.O": "761041",
      "Bhutsarasingi B.O": "761041",
      "Mohaguda B.O": "761132",
      "Kanabhaga B.O": "761140",
      "Baulagam B.O": "761026",
      "Mahanadapur B.O": "761026",
      "Municipentho B.O": "761026",
      "Ramanabadi B.O": "761151",
      "Merikote B.O": "761109",
      "Sandhikendu B.O": "761109",
      "U. Dantilingi B.O": "761151",
      "Balarampur B.O": "761109",
      "Borada B.O": "761109",
      "Badakholi B.O": "761116",
      "Baradabilli B.O": "761107",
      "D.Singipur B.O": "761107",
      "Kharia B.O": "761111",
      "Erendra B.O": "761013",
      "P.Jagannathpur B.O": "761013",
      "Mahachhai B.O": "761103",
      "Tankachhai B.O": "761103",
      "Bandhaguda B.O": "761106",
      "K.Karadakana B.O": "761106",
      "Kullagada B.O": "761106",
      "Genja B.O": "761108",
      "Surada Bazar B.O": "761108",
      "Bahadapadar B.O": "761125",
      "Bishnuchakra B.O": "761117",
      "Hatiota B.O": "761117",
      "Rumagada B.O": "761117",
      "Aladi B.O": "761120",
      "Jhadabhumi B.O": "761120",
      "Bonka B.O": "761119",
      "Subalaya B.O": "761111",
      "Gangapur B.O": "761104",
      "Patrapalli B.O": "761119",
      "Udhra B.O": "761119",
      "Betarasingi B.O": "761118",
      "Golamundala B.O": "761118",
      "Kanachhai B.O": "761118",
      "Pangidi B.O": "761118",
      "Harigada B.O": "761141",
      "Bangarada B.O": "761123",
      "Nunipadasasan B.O": "761123",
      "Palakasandha B.O": "761123",
      "G.Dengapadar B.O": "761124",
      "Kullangi B.O": "761124",
      "Nettanga B.O": "761124",
      "Kadua B.O": "761121",
      "Baunsalundi B.O": "761133",
      "Biranchipur B.O": "761143",
      "Baaruda B.O": "761131",
      "Balisahi B.O": "761131",
      "Guzurali B.O": "761131",
      "Badabaraba B.O": "761151",
      "Gazalbadi B.O": "761151",
      "Ekalpur B.O": "761109",
      "Rai Bandha B.O": "761109",
      "Dhaninja B.O": "761116",
      "Sidhanoi B.O": "761116",
      "Baharpur B.O": "761107",
      "Bethuara B.O": "761107",
      "Saurachachina B.O": "761031",
      "Badagochha B.O": "761151",
      "Bhagabanpur B.O": "761151",
      "Gaudagotha B.O": "761109",
      "Sidhapur B.O": "761109",
      "Pandiapathara B.O": "761116",
      "Gobindapur B.O": "761146",
      "Thuruburai B.O": "761146",
      "Kalasandhapur B.O": "761111",
      "Kotinada B.O": "761111",
      "P.Ramachandrapur B.O": "761013",
      "Brahmanchhai B.O": "761103",
      "Kachakhandi B.O": "761106",
      "Kumarpani B.O": "761106",
      "Gopalpursasan B.O": "761108",
      "Dumakumpa B.O": "761125",
      "Khamaredi B.O": "761125",
      "Gahangu B.O": "761117",
      "Karadabadi (A) B.O": "761117",
      "B.D.Pur B.O": "761120",
      "Khamarpalli B.O": "761120",
      "Ambapua B.O": "761104",
      "B.L.S.Pur B.O": "761119",
      "Kirapalli B.O": "761119",
      "Pratapur B.O": "761119",
      "Bhamsyali B.O": "761118",
      "Golia B.O": "761118",
      "Kanasukha B.O": "761118",
      "Sankuru B.O": "761118",
      "Kupati B.O": "761141",
      "Pailipada B.O": "761123",
      "Benipalli B.O": "761124",
      "Kaliaguda B.O": "761124",
      "Chandipadar B.O": "761003",
      "Gondala B.O": "761003",
      "Sahapur B.O": "761003",
      "Tanganapalli B.O": "761003",
      "Palur B.O": "761027",
      "Badapalli B.O": "761029",
      "Bikrampur B.O": "761029",
      "Panditgam B.O": "761029",
      "Bania B.O": "761030",
      "Syamsundarpur B.O": "761030",
      "Beruanbadi B.O": "761032",
      "Chingudikhola B.O": "761032",
      "Mardakote B.O": "761032",
      "Phasi B.O": "761032",
      "Chamakhandi B.O": "761045",
      "Sindurapur B.O": "761045",
      "Athagadapatna B.O": "761105",
      "Gochabadi B.O": "761105",
      "Jakara B.O": "761105",
      "Khanduru B.O": "761105",
      "Madhupalli B.O": "761105",
      "Badarampalli B.O": "761019",
      "Komanda B.O": "761019",
      "Badabaragam B.O": "761018",
      "Hottapur B.O": "761018",
      "Taratrini Hills B.O": "761018",
      "Madhuruchua B.O": "761028",
      "Polango B.O": "761028",
      "Sabulia B.O": "761028",
      "Biribatia B.O": "761031",
      "Borida B.O": "761031",
      "Kanchana B.O": "761031",
      "Naikanipalli B.O": "761031",
      "Dhobadipatapur B.O": "761003",
      "Jagannathpur B.O": "761003",
      "Laxmipur B.O": "761003",
      "Haripur Burudi B.O": "761027",
      "Mallada B.O": "761027",
      "Aitipur B.O": "761029",
      "Khajapalli B.O": "761029",
      "Koirasi B.O": "761029",
      "Kendupata B.O": "761030",
      "Kushadhipa B.O": "761030",
      "Mathura B.O": "761105",
      "Digapada B.O": "761032",
      "Gouradeipur B.O": "761032",
      "Madhabarida B.O": "761124",
      "Dubuduba B.O": "761133",
      "Malaspadar B.O": "761133",
      "Baliapata B.O": "761131",
      "Kalingapadar B.O": "761131",
      "Khetamundali B.O": "761131",
      "Sriramchandrapur B.O": "761045",
      "Chatamundali B.O": "761043",
      "Kalidaspur B.O": "761043",
      "Morabai B.O": "761043",
      "Pandarakhalli B.O": "761043",
      "Bhabarada B.O": "761105",
      "Budhamba B.O": "761105",
      "Pandiripada B.O": "761105",
      "Polasara Nimina B.O": "761105",
      "Alladigam B.O": "761019",
      "Jamuni B.O": "761018",
      "Kinigam B.O": "761018",
      "Angaragam B.O": "761035",
      "Badakhairakhama B.O": "761035",
      "Burujhuri Nuagam B.O": "761035",
      "Rama Sanarayanpur B.O": "761041",
      "Bellagam B.O": "761105",
      "Konheipur B.O": "761029",
      "Langaleswar B.O": "761029",
      "Pathara B.O": "761104",
      "Barasara B.O": "761030",
      "Chikili B.O": "761030",
      "Jagilipadar B.O": "761032",
      "Kodala Bus Stand B.O": "761032",
      "Mardamekha B.O": "761032",
      "Mathasarasingi B.O": "761032",
      "Mundala B.O": "761032",
      "Bada Aryapalli B.O": "761045",
      "Banabulapalli B.O": "761045",
      "Tentulia B.O": "761105",
      "Poirasi B.O": "761019",
      "Purushottampur Nbs B.O": "761018",
      "Ranajhali B.O": "761018",
      "Sikula B.O": "761018",
      "Biruligada B.O": "761028",
      "Dimiria B.O": "761028",
      "Golagandapalli B.O": "761028",
      "Kanaka B.O": "761028",
      "Kumaripari B.O": "761035",
      "Sandhamula B.O": "761035",
      "Sankuda B.O": "761035",
      "Humuki B.O": "761111",
      "Jayapur B.O": "761111",
      "Kaniary B.O": "761111",
      "Kumbhari B.O": "761111",
      "Nalabanta B.O": "761111",
      "Baramundalli B.O": "761106",
      "Dasamundali B.O": "761106",
      "Dhabalpur B.O": "761106",
      "Dhanantara B.O": "761106",
      "Mahupadar B.O": "761106",
      "S.Gopalpur B.O": "761106",
      "Amrutulu B.O": "761108",
      "B.Kotibadi B.O": "761108",
      "Badabadangi B.O": "761108",
      "Sanakodanda B.O": "761125",
      "Lalsingh B.O": "761125",
      "Mandar B.O": "761117",
      "Mangalpur B.O": "761115",
      "Nimapadar B.O": "761120",
      "Patadhar B.O": "761120",
      "Kudutei B.O": "761119",
      "Adipur B.O": "761118",
      "Kholakhalli B.O": "761118",
      "Manitara B.O": "761118",
      "Motabadi B.O": "761118",
      "Badaborasingi B.O": "761124",
      "Badapada B.O": "761124",
      "Alasuguma B.O": "761121",
      "Chamunda B.O": "761121",
      "Gandadhara B.O": "761121",
      "Kadapada B.O": "761121",
      "Gamundi B.O": "761133",
      "Lembhai B.O": "761131",
      "Masabadi B.O": "761131",
      "Rudhapadar B.O": "761131",
      "Tarasinghi B.O": "761131",
      "G.D.Palli B.O": "761111",
      "Jahada B.O": "761107",
      "Janibilli B.O": "761107",
      "Balisira B.O": "761115",
      "J.Balabhadrapur B.O": "761013",
      "Khallingi B.O": "761013",
      "Mahanala B.O": "761013",
      "Podingi B.O": "761103",
      "Ramachandrapur B.O": "761103",
      "Tanhara B.O": "761103",
      "Takarada B.O": "761143",
      "K.Jatabadi B.O": "761108",
      "Lathipada B.O": "761108",
      "Palakatu B.O": "761108",
      "Ratnapur B.O": "761108",
      "Sarabadi B.O": "761108",
      "Sorisbilli B.O": "761108",
      "Antarapada B.O": "761117",
      "Bhatakhali B.O": "761117",
      "Pantikhari B.O": "761119",
      "B.Pankalbadi B.O": "761118",
      "Dhunkapada B.O": "761118",
      "Gaudiabarada B.O": "761118",
      "Golabandha B.O": "761118",
      "Sodak B.O": "761118",
      "Badangi B.O": "761141",
      "Domuhani B.O": "761141",
      "Bori B.O": "761123",
      "K.Nuagada B.O": "761123",
      "Khairaputi B.O": "761123",
      "Khetribarapur B.O": "761123",
      "Kumpapada B.O": "761121",
      "Kumundi B.O": "761121",
      "Panchabhuti B.O": "761121",
      "Rauti B.O": "761121",
      "Samarbandha B.O": "761121",
      "B.Karadabadi B.O": "761143",
      "Karasinghi B.O": "761143",
      "Dholapita B.O": "761131",
      "Gayaganda B.O": "761131",
      "Gerada B.O": "761131",
      "Golapada B.O": "761131",
      "Pustapur B.O": "761031",
      "Tirida B.O": "761031",
      "Baghala B.O": "761003",
      "Bhabandha B.O": "761003",
      "Sunathara B.O": "761003",
      "Bhejiput B.O": "761029",
      "Bhikapada B.O": "761029",
      "Tentuliapalli B.O": "761029",
      "Badhinuapalli B.O": "761030",
      "Balunkeswarapur B.O": "761030",
      "Danapur B.O": "761032",
      "Bhikaripalli B.O": "761045",
      "Kanamana B.O": "761045",
      "Sialia B.O": "761104",
      "Sunapalli B.O": "761104",
      "Sunarijhola BO": "761104",
      "S.Ambagam B.O": "761101",
      "Samarjhola B.O": "761101",
      "Chandulli B.O": "761102",
      "Nandiko B.O": "761102",
      "Sikiri B.O": "761102",
      "Barida B.O": "761104",
      "Bolosara B.O": "761104",
      "Ghodapolan B.O": "761104",
      "Jhadabai B.O": "761104",
      "Adapada B.O": "761144",
      "Dengadi B.O": "761144",
      "Jharapari B.O": "761114",
      "Kusuraba B.O": "761114",
      "Dhaugam B.O": "761111",
      "Haridapadar B.O": "761111",
      "Antarigam B.O": "761043",
      "Chirakipadasasan B.O": "761105",
      "Kalambo B.O": "761105",
      "Badachakada B.O": "761019",
      "Khajipalli B.O": "761019",
      "Chingudighai B.O": "761018",
      "Gnagadahani B.O": "761018",
      "Soma B.O": "761018",
      "Khandadeuli B.O": "761028",
      "Paladhuapalli B.O": "761028",
      "Talasara B.O": "761035",
      "Kokolamba B.O": "761131",
      "Jagamohan B.O": "761114",
      "Jhadabandha B.O": "761114",
      "Alipur B.O": "761111",
      "Babanpur B.O": "761111",
      "Balichhai B.O": "761111",
      "Baragam B.O": "761111",
      "Saba B.O": "761107",
      "Debabhumi B.O": "761115",
      "Ralaba B.O": "761102",
      "B.Nuapalli B.O": "761104",
      "Hindola B.O": "761104",
      "Paikajamuna B.O": "761104",
      "Durabandha B.O": "761101",
      "P.Padmanabhapur B.O": "761101",
      "Sapuapalli B.O": "761101",
      "Kurla B.O": "761144",
      "Nuagada B.O": "761107",
      "Rugumu B.O": "761107",
      "Suramani B.O": "761107",
      "Kharida B.O": "761102",
      "Putiapadar B.O": "761102",
      "Baliasara B.O": "761104",
      "Gudiali B.O": "761104",
      "Jarada B.O": "761104",
      "Badakhandi B.O": "761101",
      "Makarjhola B.O": "761101",
      "Saru B.O": "761101",
      "Kaudia B.O": "761144",
      "Badula B.O": "761114",
      "A.K.Deuli B.O": "761111",
      "Aska H.O": "761110",
      "Bhanjanagar H.O": "761126",
      "Berhampur(GM) H.O": "760001",
      "Chatrapur H.O": "761020",
      "Matikhalo S.O": "761045",
      "Minchinipatana S.O": "761028",
      "Purushottampur S.O": "761018",
      "Sumandala S.O": "761035",
      "Khallikote RS S.O": "761029",
      "Khallikote S.O": "761030",
      "Kodala S.O": "761032",
      "Polosara S.O": "761105",
      "Rambha S.O": "761028",
      "Sitarampalli S.O": "761020",
      "Kodala Tahasil Colony S.O": "761032",
      "Pandia S.O": "761043",
      "Pratapur S.O (Ganjam)": "761019",
      "Hinjlicut College Road S.O": "761102",
      "Kabisuryanagar S.O": "761104",
      "Kanchuru S.O": "761101",
      "Brajanagar": "760001",
      "Badakhemundi Street S.O": "760001",
      "Bhapur Bazar S.O": "760001",
      "Bijipur S.O": "760001",
      "Engineering School S.O": "760010",
      "Gandhinagar S.O (Ganjam)": "760001",
      "Gatebazar S.O": "760001",
      "Girisola S.O": "761009",
      "Goilundi S.O": "760004",
      "Pattapur S.O": "761013",
      "Pitala S.O": "761103",
      "Golanthara S.O": "761008",
      "Hillpatna S.O": "760005",
      "Jayantipur S.O": "761006",
      "Military Lines S.O": "760001",
      "Padmanavapur S.O": "761007",
      "Panigrahipentho S.O": "760006",
      "Patrapur S.O": "761004",
      "Sriram Nagar S.O": "760002",
      "AMBAPUA SO": "760011",
      "Badakharida S.O": "761041",
      "Bhatakumarada S.O": "761003",
      "Kanisi Hat S.O.": "761008",
      "Digapahandi S.O": "761012",
      "Khallikote College S.O": "760001",
      "Nimakhandi S.O": "761001",
      "Nuapada S.O": "761011",
      "Pudamari S.O": "761014",
      "Sankarapur S.O": "760006",
      "Surangi S.O": "761037",
      "Ganjam S.O": "761026",
      "Chatrapur Bazar S.O": "761020",
      "Seragada S.O": "761106",
      "T.O.Road S.O": "761110",
      "Bellaguntha S.O": "761119",
      "Bhanjanagar Bazar S.O": "761126",
      "Jillundi S.O": "761133",
      "Mujjagada S.O": "761132",
      "Nimina S.O": "761122",
      "Tanarada S.O": "761140",
      "Aska College Square S.O": "761111",
      "Aska Junction S.O": "761110",
      "Badagada S.O": "761109",
      "Banadevi Patna S.O": "761104",
      "Gopinath Patna S.O": "761104",
      "Hinjilicut S.O": "761102",
      "Konkarada S.O": "761144",
      "B D Sahi Bellagunhta S.O": "761119",
      "Baragam S.O": "761120",
      "Buguda S.O": "761118",
      "Gallery S.O": "761141",
      "Karachulli S.O": "761143",
      "Ballipada S.O": "761054",
      "Berhampur University S.O": "760007",
      "Bomokei S.O": "761042",
      "Courtpeta S.O": "760004",
      "Digapahandi Tahasil Colony S.O": "761012",
      "Golabandha S.O": "761052",
      "Gopalpur S.O (Ganjam)": "761002",
      "Jaradagada S.O": "761005",
      "Bhetonoi S.O": "761116",
      "Gunthapada S.O": "761115",
      "Khambeswari Patna S.O": "761110",
      "Mundamarai S.O": "761114",
      "Bhanjanagar  College S.O": "761126",
      "Bhejiput S.O": "761126",
      "Jagannath Prasad S.O": "761121",
      "Asura Bandha S.O": "761151",
      "Burupada S.O": "761146",
      "Kukudakhandi S.O": "761100",
      "Beguniapada S.O": "761031",
      "Humma S.O": "761027",
      "Jayashree S.O": "761025",
      "Baidyanathpur S.O": "760004",
      "Berhampur City S.O": "760002",
      "Bissmagiri S.O": "761055",
      "Chikiti S.O": "761010",
      "Godavarishanagar S.O": "760001",
      "Gosaninuagam S.O": "760003",
      "Industrial Estates S.O": "760008",
      "Khariaguda S.O": "761209",
      "Lanjipalli S.O": "760008",
      "Medical College S.O (Ganjam)": "760004",
      "Nabeen S.O": "760009",
      "Park Street S.O": "760002",
      "Premnagar S.O (Ganjam)": "760002",
      "Dharakote S.O": "761107",
      "Nuagam S.O": "761111",
      "Raghunath Nagar S.O (Ganjam)": "761110",
      "Sunambo Street S.O": "761110",
      "Surada S.O": "761108",
      "Badakodanda S.O": "761125",
      "Ballipadar S.O": "761117",
      "Bhanjamargo S.O": "761126",
      "Gangapur (Ganjam) S.O": "761123",
      "Gobara S.O": "761124",
      "Kullada S.O": "761131"
    },
    "SAMBALPUR": {
      "J.Rengali B.O": "768105",
      "Keshapali B.O": "768105",
      "Lipinda B.O": "768105",
      "Mochibahal B.O": "768105",
      "BHALIAKATA": "768105",
      "Kadaligarh B.O": "768106",
      "Kisinda B.O": "768106",
      "Similipal B.O": "768106",
      "Tribanpur B.O": "768106",
      "BHARTAPUR": "768106",
      "GOGUA": "768106",
      "Daincha B.O": "768106",
      "Girischandrapur B.O": "768106",
      "Luhapank B.O": "768106",
      "Sarapali B.O": "768106",
      "Salebhata B.O": "768109",
      "Dhankauda B.O": "768006",
      "Tabla B.O": "768200",
      "Tamperkela B.O": "768200",
      "Batgaon B.O": "768106",
      "Charmal B.O": "768106",
      "Ghosaramal B.O": "768106",
      "A.Katapali B.O": "768006",
      "Garmunda B.O": "768006",
      "Sankarma B.O": "768006",
      "Bishalkhinda B.O": "768200",
      "Jamadarpali B.O": "768200",
      "R.Badmal B.O": "768105",
      "Jamujori B.O": "768106",
      "Kelloballam B.O": "768106",
      "R.Badbahal B.O": "768106",
      "Bareipali B.O": "768006",
      "Sangramal B. Camp B.O": "768200",
      "Talab B.O": "768200",
      "Kukudapali B.O": "768200",
      "Parmanpur B.O": "768200",
      "Jorabaga B.O": "768228",
      "Kabribahal B.O": "768228",
      "Khalbilung B.O": "768228",
      "Lariapali B.O": "768228",
      "Mahulpali B.O": "768228",
      "Salebhadi B.O": "768227",
      "Sanmundaloi B.O": "768227",
      "Tainsar B.O": "768227",
      "Turei-niktimal B.O": "768227",
      "Binjipali B.O": "768214",
      "Katarbaga B.O": "768212",
      "Khinda B.O": "768212",
      "Kilasama B.O": "768212",
      "Kurla B.O": "768212",
      "Lapanga B.O": "768212",
      "Patrapali B.O": "768212",
      "Bilung B.O": "768228",
      "Chhatabar B.O": "768228",
      "Nuadihi B.O": "768228",
      "Talsara B.O": "768228",
      "Ardabahal B.O": "768222",
      "Bauriguda B.O": "768222",
      "Gochhara B.O": "768222",
      "Godrapara B.O": "768107",
      "Hardipali B.O": "768222",
      "Kuleigarh B.O": "768222",
      "Kuturchuan B.O": "768222",
      "Lad B.O": "768222",
      "Laigura B.O": "768222",
      "Paruabhadi B.O": "768222",
      "Banke B.O": "768227",
      "Basupali B.O": "768212",
      "Ghichamura B.O": "768212",
      "Batemura B.O": "768005",
      "Chaurpur B.O": "768005",
      "Themra B.O": "768005",
      "Kabrapali B.O": "768112",
      "Kharsanmal B.O": "768112",
      "Badrama B.O": "768107",
      "Bamandagarh B.O": "768107",
      "Chinimahul B.O": "768107",
      "Sarda B.O": "768107",
      "Shirod B.O": "768107",
      "Tikiba B.O": "768107",
      "Tikilipada B.O": "768107",
      "Bansajal B.O": "768105",
      "Bargaon B.O": "768113",
      "Dakra B.O": "768113",
      "Sahaspur B.O": "768113",
      "Salesingha B.O": "768113",
      "Kulundi B.O": "768112",
      "Mudhenapali B.O": "768112",
      "N.Barangamal B.O": "768112",
      "Nuaburda B.O": "768112",
      "Fasimal B.O": "768107",
      "Gundurchuan B.O": "768107",
      "Birsinghgarh B.O": "768105",
      "Bamphei B.O": "768221",
      "Bamrabasti B.O": "768221",
      "Baunslaga B.O": "768221",
      "Burbuda B.O": "768221",
      "Ghunghuti B.O": "768221",
      "Uchakapat B.O": "768221",
      "Badumermunda B.O": "768221",
      "Nuapali B.O": "768224",
      "Ragba B.O": "768224",
      "Baliturei B.O": "768228",
      "M. Balanda B.O": "768228",
      "P. Niktimal B.O": "768228",
      "Sargidihi B.O": "768228",
      "Uttargaon B.O": "768228",
      "Baxma B.O": "768222",
      "Chandinimal B.O": "768222",
      "Dhudipali B.O": "768222",
      "Khandakata B.O": "768222",
      "Purunapani B.O": "768222",
      "Satkama B.O": "768222",
      "Subarnapali B.O": "768222",
      "Gosainpara B.O": "768227",
      "Kuntara B.O": "768227",
      "Kinaloi B.O": "768214",
      "Bomaloi B.O": "768212",
      "Jharghati Colony B.O": "768212",
      "Kalamati B.O": "768025",
      "CHIPLIMA BO": "768025",
      "Amkuni B.O": "768113",
      "Maltigunderpur B.O": "768005",
      "Rasanpur B.O": "768005",
      "Sindurpank B.O": "768005",
      "Badasahir B.O": "768112",
      "Dangarpara B.O": "768112",
      "Tampargarh B.O": "768112",
      "Bhatpura B.O": "768107",
      "Bhojpur B.O": "768107",
      "Jamumal B.O": "768107",
      "Katarkela B.O": "768107",
      "Gadgadbahal B.O": "768105",
      "Godloisingh B.O": "768105",
      "Dangajore B.O": "768224",
      "Gardega B.O": "768224",
      "Kinabaga B.O": "768224",
      "Pindapathar B.O": "768224",
      "Sagra B.O": "768224",
      "Babu Nikitimal B.O": "768228",
      "Routbahal B.O": "768228",
      "Turei B.O": "768228",
      "Bhoipali B.O": "768222",
      "Kindira B.O": "768222",
      "Ramtileimal B.O": "768222",
      "Telitileimal B.O": "768222",
      "K. Jamankira B.O": "768227",
      "Laidaguma B.O": "768227",
      "Kenadhipa B.O": "768214",
      "K. Jhankarpali B.O": "768212",
      "Basantpur B.O": "768025",
      "KUD GUNDERPUR": "768025",
      "Baduapali B.O": "768113",
      "Jhankarpali B.O": "768005",
      "Maneswar B.O": "768005",
      "Baham B.O": "768112",
      "Jayantapur B.O": "768112",
      "Padiabahal B.O": "768112",
      "MEGHPAL": "768112",
      "Barhamundi B.O": "768107",
      "Chakuliabahal B.O": "768107",
      "Katangapani B.O": "768107",
      "Mahalingkudar B.O": "768107",
      "Basiapara B.O": "768105",
      "Chhamunda B.O": "768105",
      "Hatibari B.O": "768105",
      "Badapada B.O": "768221",
      "Kechhopani B.O": "768221",
      "Kuturimal B.O": "768221",
      "Rangiatikira B.O": "768221",
      "Sambalpur H.O": "768001",
      "Laida S.O": "768214",
      "Kuchinda S.O": "768222",
      "Garposh S.O": "768224",
      "Kesaibahal S.O": "768228",
      "Kusumi S.O": "768227",
      "Bamra S.O": "768221",
      "Dhama S.O": "768113",
      "Jharuapara S.O": "768001",
      "Jyoti Vihar Burla S.O": "768019",
      "Khetrajpur S.O": "768003",
      "Mudipara S.O": "768002",
      "Remed S.O": "768006",
      "C.A. Chiplima S.O": "768025",
      "Gourpali S.O": "768112",
      "Hirakud S.O": "768016",
      "Sasan Rs S.O": "768200",
      "Golebazar S.O": "768001",
      "Jamankira S.O": "768107",
      "Jujumura S.O": "768105",
      "Medical College Burla S.O": "768017",
      "Naktideul S.O": "768118",
      "Rengali SO": "768212",
      "Ainthapali S.O": "768004",
      "Budharaja S.O": "768004",
      "Dhanupali S.O": "768005",
      "Engineering College Burla S.O": "768018",
      "Gosala Chowk S.O": "768025",
      "Jagruti Vihar Burla S.O": "768020",
      "Rairakhol S.O": "768106",
      "Sambalpur Court S.O": "768001",
      "Bss Nagar S.O": "768001",
      "Burla S.O": "768017",
      "Thelkuli S.O": "768210"
    },
    "DEOGARH": {
      "Tentelabahal B.O": "768119",
      "Tileibani B.O": "768119",
      "Kantabahal B.O": "768109",
      "Karlaga B.O": "768109",
      "Malehipada B.O": "768109",
      "Tungamal B.O": "768109",
      "Utunia B.O": "768109",
      "K.Tainsar B.O": "768119",
      "Tabada B.O": "768119",
      "Budido B.O": "768109",
      "Dashgharia B.O": "768109",
      "Kundheigola B.O": "768109",
      "Naulipara B.O": "768109",
      "ADAS": "768109",
      "PARA": "768109",
      "Rengalbeda B.O": "768119",
      "Sarpal B.O": "768109",
      "Tarang B.O": "768109",
      "Tinkbir B.O": "768109",
      "Tuhilamal B.O": "768109",
      "GUNDIAPALI": "768119",
      "Aunli B.O": "768109",
      "Gambharipali B.O": "768109",
      "Lulang B.O": "768109",
      "Palsama B.O": "768109",
      "KHOLHABASA": "768108",
      "Danra B.O": "768110",
      "KALIAPAL": "768110",
      "JHARAKANDHAL": "768110",
      "Balam B.O": "768108",
      "Basaloi B.O": "768108",
      "Dantaribahal B.O": "768108",
      "Jhargogua B.O": "768108",
      "Kandhal B.O": "768108",
      "Laimura B.O": "768108",
      "Gursang B.O": "768110",
      "Kadopada B.O": "768110",
      "KALANDA": "768108",
      "Dimirikuda B.O": "768107",
      "GAMDAM": "768107",
      "Nuadihi B.O": "768108",
      "Parposi B.O": "768108",
      "Suguda B.O": "768108",
      "Dholpara B.O": "768121",
      "Kansar B.O": "768121",
      "Ambagaon B.O": "768110",
      "Bamparda B.O": "768110",
      "Madhyapur B.O": "768110",
      "Saruali B.O": "768110",
      "Dandasingha B.O": "768108",
      "Kantapali B.O": "768108",
      "Rambhei B.O": "768108",
      "Barghat B.O": "768121",
      "Balanda B.O": "768110",
      "Balani B.O": "768110",
      "Charimancha B.O": "768110",
      "Kalla B.O": "768110",
      "Saida B.O": "768110",
      "Bhatsingh B.O": "768108",
      "Ganganan B.O": "768108",
      "Khilei B.O": "768108",
      "BIJAYANAGAR": "768108",
      "Purunagarh S.O": "768119",
      "Gohira Dam Site S.O": "768121",
      "Barkote S.O": "768110",
      "Deogarh S.O (Debagarh)": "768108",
      "Reamal S.O": "768109"
    },
    "MALKANGIRI": {
      "Padmagiri B.O": "764045",
      "Panchabati B.O": "764045",
      "Tumusapalli B.O": "764045",
      "Birlaxmipur B.O": "764044",
      "Chedenga B.O": "764044",
      "Kiyanga B.O": "764044",
      "Kottapali B.O": "764044",
      "Mekka B.O": "764044",
      "Mariwada B.O": "764045",
      "Pedakonda B.O": "764045",
      "Udupa B.O": "764045",
      "Dudameta B.O": "764045",
      "Bhejaguda B.O": "764044",
      "Chaulmendi B.O": "764044",
      "Dungiaput B.O": "764044",
      "Kutunipalli B.O": "764044",
      "Chalanguda B.O": "764045",
      "Goudaguda B.O": "764045",
      "Dalapatiguda B.O": "764044",
      "Gongola B.O": "764044",
      "Govindpalli B.O": "764044",
      "Mohupadar B.O": "764044",
      "Naikaguda B.O": "764044",
      "Jharapalli B.O": "764045",
      "Korukonda B.O": "764045",
      "Tamasa B.O": "764045",
      "Tandiki B.O": "764045",
      "Ambaguda B.O": "764044",
      "Kartanpalli B.O": "764044",
      "Mendukuli B.O": "764044",
      "Andrapali B.O": "764052",
      "Panasput B.O": "764052",
      "Populuru B.O": "764052",
      "Badapoda B.O": "764052",
      "Nuaguda B.O": "764052",
      "Bapanpali B.O": "764047",
      "Manyamkonda B.O": "764047",
      "Venkatpallam B.O": "764047",
      "Undrukonda B.O": "764045",
      "Tigal B.O": "764045",
      "Badapadar B.O": "764052",
      "Boiliguma B.O": "764052",
      "Doraguda B.O": "764052",
      "Relageda B.O": "764052",
      "Bhejangiwada B.O": "764047",
      "Girikanpalli B.O": "764047",
      "Gampakonda B.O": "764047",
      "Kongurukonda B.O": "764047",
      "Badigeta B.O": "764045",
      "Chintalwada B.O": "764045",
      "Kadamguda B.O": "764046",
      "Rasbeda B.O": "764046",
      "Kudumuluguma B.O": "764046",
      "Somnathpur B.O": "764046",
      "Mudulipada B.O": "764046",
      "Mundiguda B.O": "764046",
      "Parkonmala B.O": "764046",
      "Potrel B.O": "764051",
      "Tarlakota B.O": "764051",
      "Muduliguda B.O": "764051",
      "PURUNA CHINTAPALLI B.O.": "764051",
      "B.Mamidi B.O": "764051",
      "Chitapari B.O": "764051",
      "Dyke 1 B.O": "764051",
      "Nilakhambari B.O": "764051",
      "Gunthawada B.O": "764052",
      "Kurmanur B.O": "764052",
      "Motteru B.O": "764047",
      "Nallagunthi B.O": "764047",
      "Niliguda B.O": "764047",
      "Simlibamchha B.O": "764047",
      "Jodamba B.O": "764052",
      "Papermetla B.O": "764052",
      "Kopatuti B.O": "764052",
      "Maranpalli B.O": "764047",
      "Podia B.O": "764047",
      "Anantapali B.O": "764087",
      "Maharajpalli B.O": "764087",
      "Motu B.O": "764087",
      "Tandabai B.O": "764087",
      "Bhubanpalli B.O": "764087",
      "Talarai B.O": "764047",
      "Podaghat B.O": "764046",
      "Kambeda B.O": "764051",
      "Nakamamidi B.O": "764051",
      "Malavaram B.O": "764087",
      "Parajabadapada B.O": "764044",
      "Pandripani B.O": "764044",
      "Temurupali B.O": "764044",
      "Udilibeda B.O": "764044",
      "SERPALLI B.O": "764044",
      "Salimi B.O": "764044",
      "Madakapadar B.O": "764044",
      "Bodili B.O": "764086",
      "Gurakhunta B.O": "764086",
      "Sikhapali B.O": "764086",
      "Pedawada B.O": "764044",
      "Markapalli B.O": "764044",
      "Kamarpalli B.O": "764044",
      "Chitrangpali B.O": "764086",
      "Gumuka B.O": "764086",
      "Pongam B.O": "764044",
      "Bhandari Pangam B.O": "764044",
      "Metapoka B.O": "764086",
      "Khairaput S.O": "764046",
      "Balimela S.O": "764051",
      "Chitrakonda S.O": "764052",
      "Lachipeta S.O": "764087",
      "Mathili S.O": "764044",
      "Saradhapalli S.O": "764086",
      "Kalimela S.O": "764047",
      "Malkangiri S.O": "764045",
      "Malkangiri Colony S.O": "764048"
    },
    "KORAPUT": {
      "Guneipada B.O": "764040",
      "Godihanjar B.O": "764040",
      "Bhaminiput B.O": "764005",
      "Ghumar B.O": "764058",
      "Asana B.O": "764002",
      "Banuaguda B.O": "764002",
      "Bilaput B.O": "764041",
      "Parajabedapadar B.o": "764028",
      "Binjili B.O": "764058",
      "Chandili B.O": "764058",
      "Raniput B.O": "764005",
      "Bhusanguda B.O": "764002",
      "D.Paunsi B.O": "764002",
      "Dhanpur B.O": "764002",
      "Kaliagam B.O": "764002",
      "Kundura B.O": "764002",
      "Attanda B.O": "764041",
      "Badel B.O": "764041",
      "Batasena B.O": "764058",
      "Bhansuli B.O": "764058",
      "Bodaput B.O": "764043",
      "Chipakhor B.O": "764043",
      "Tentuligumma B.O": "764043",
      "Kathapoda B.O": "764043",
      "Dandabadi B.O": "764043",
      "Dasamanthpur B.O": "764043",
      "Gondal B.O": "764043",
      "Haladikund B.O": "764043",
      "Kollar B.O": "764043",
      "Majhiguda B.O": "764043",
      "Mosigam B.O": "764043",
      "Lima B.O": "764002",
      "Umuri B.O": "764021",
      "Badajiuna B.O": "764002",
      "Chandrapoda B.O": "764043",
      "Chikima B.O": "764043",
      "Dhamanahandi B.O": "764058",
      "Ghotarla B.O": "764058",
      "Chhatarla B.O": "764058",
      "Soguru B.O": "764081",
      "Tikarpada B.O": "764081",
      "Anta B.O": "764005",
      "Digapur B.O": "764005",
      "Bagderi B.O": "764002",
      "Bhejahandi B.O": "764002",
      "Karimiti B.O": "764002",
      "Girla B.O": "764058",
      "Kerla B.O": "764058",
      "Modeigaon B.O": "764058",
      "Anchala B.O": "764056",
      "Mathalput B.O": "763008",
      "Lulla B.O": "764028",
      "Murkur B.O": "764028",
      "Pindapadar B.O": "764028",
      "Bilangsil B.O": "765013",
      "Muttahandi B.O": "764058",
      "Sunarbelli (Nuagaon) B.O": "764058",
      "Guali B.O": "764058",
      "Jalahanjar B.O": "764081",
      "Tusuba B.O": "764081",
      "Phampuni B.O": "764002",
      "Rondapalli B.O": "764002",
      "Taraput B.O": "764002",
      "Phupugam B.O": "764076",
      "Balel B.O": "764041",
      "Baligam B.O": "764043",
      "Doraguda B.O": "764043",
      "Kenduguda B.O": "764043",
      "Mohuli B.O": "764043",
      "Ramgiri B.O": "764043",
      "Chirma B.O": "764058",
      "Sadaranga B.O": "764058",
      "Ukiapalli B.O": "764058",
      "Badigada B.O": "764040",
      "Benasur B.O": "764056",
      "Chitra B.O": "764056",
      "Malda B.O": "764056",
      "Sasahandi B.O": "764056",
      "Litiguda B.O": "763008",
      "Chanabeda B.O": "764028",
      "Girliguma B.O": "764028",
      "Chikambo B.O": "764028",
      "Champi B.O": "765013",
      "Goudaguda B.O": "765013",
      "Pipalpadar B.O": "765013",
      "Narigam B.O": "764057",
      "Ranaspur B.O": "764057",
      "Hardoli B.O": "764056",
      "Jayantgiri B.O": "764056",
      "Kabidi B.O": "764056",
      "Konagam B.O": "764056",
      "Panasaguda B.O": "764056",
      "Porli B.O": "764056",
      "Pujariput B.O": "764056",
      "Raniguda B.O": "764056",
      "Bhitarguda B.O": "763008",
      "Deoghati B.O": "764011",
      "Kakirigumma B.O": "765013",
      "Kusumguda B.O": "765013",
      "Munjanga B.O": "765013",
      "Semlaguda B.O": "764057",
      "Haridaguda B.O": "764057",
      "Duarsuni B.O": "764057",
      "Bijapur B.O": "764056",
      "Gujaniguda B.O": "764056",
      "Kosaguda B.O": "764056",
      "Nuagaon B.O": "764039",
      "Sanparia B.O": "764056",
      "Sorgiguda B.O": "764056",
      "Charangul B.O": "764036",
      "Dambaguda B.O": "764028",
      "Burja B.O": "765013",
      "Gadiaguda B.O": "765013",
      "Odiapentha B.O": "765013",
      "Panchada B.O": "765013",
      "Upperkutinga B.O": "765013",
      "Balipeta B.O": "764014",
      "Jogipalur B.O": "764014",
      "Khumbari B.O": "764014",
      "Podapadar B.O": "764014",
      "Raisingi B.O": "764038",
      "Wandergada B.O": "764038",
      "Maliput B.O": "764039",
      "Ondrangi B.O": "764039",
      "Sorada B.O": "764039",
      "Sunki B.O": "764039",
      "Rajput B.O": "764036",
      "Nandaka B.O": "764036",
      "B.Maliput B.O": "764037",
      "Bheja B.O": "764037",
      "Guntaput B.O": "764037",
      "Hakimput B.O": "764037",
      "Bijaghati B.O": "764014",
      "A.Malkangiri B.O": "764021",
      "Dumuriput B.O": "764021",
      "Kendar B.O": "764021",
      "Suku B.O": "764021",
      "Balda B.O": "764038",
      "Chatwa B.O": "764038",
      "Ampawalli B.O": "764039",
      "Sadam B.O": "764039",
      "Sambai B.O": "764039",
      "D.Padar B.O": "764036",
      "Dudhari B.O": "764036",
      "P.Muthai B.O": "764036",
      "Pakjhola B.O": "764036",
      "Toyaput B.O": "765013",
      "Kasandi B.O": "764037",
      "Kumargandhana B.O": "764037",
      "Pithaguda B.O": "764037",
      "Subai B.O": "764037",
      "T.Padar B.O": "764014",
      "Nandigam B.O": "764021",
      "Gadapadar B.O": "764003",
      "Peta B.O": "764003",
      "Tankua B.O": "764003",
      "Kaploda B.O": "764027",
      "Umbel B.O": "764037",
      "Kathargada B.O": "764057",
      "Bobia B.O": "764055",
      "Hadia B.O": "764055",
      "Garidi B.O": "764027",
      "Jabaguda B.O": "764027",
      "Kabirbadi B.O": "764027",
      "Kanagam B.O": "764027",
      "Munja B.O": "764057",
      "Golur B.O": "764038",
      "Kularsingi B.O": "764038",
      "Deopotangi B.O": "764039",
      "Kotiya B.O": "764039",
      "Peturu B.O": "764039",
      "Ralegada B.O": "764039",
      "Hataguda B.O": "764036",
      "Kunduli B.O": "764036",
      "Podagada B.O": "765013",
      "Kadamguda B.O": "764037",
      "Khurjee B.O": "764037",
      "Malbelagam B.O": "764037",
      "Simla B.O": "764037",
      "T.Thuba B.O": "764037",
      "T.Gumandi B.O": "764014",
      "Mahadeiput B.O": "764021",
      "Mastiput B.O": "764021",
      "P.Phulbeda B.O": "764021",
      "Manbar B.O": "764021",
      "Hatibari B.O": "764038",
      "Panthulunga B.O": "764038",
      "Chendika B.O": "764039",
      "Gangarajpur B.O": "764039",
      "Pukali B.O": "764039",
      "Turia B.O": "764039",
      "K.Guda B.O": "764036",
      "Khudi B.O": "764036",
      "Renga B.O": "764036",
      "Ondrahal B.O": "764042",
      "Dabuguda B.O": "764003",
      "Haradaput B.O": "764055",
      "Konga B.O": "764055",
      "Almonda B.O": "764027",
      "Borigi B.O": "764027",
      "Nilabadi B.O": "764027",
      "Sadabari B.O": "764027",
      "Kutrabeda B.O": "764027",
      "Benagaon B.O": "764057",
      "Champapadar B.O": "764057",
      "Gumuda B.O": "764057",
      "Upperkanti B.O": "764036",
      "Upperdural B.O": "764042",
      "Dongerchinchi B.O": "764003",
      "Jamunda B.O": "764055",
      "Kusumi B.O": "764055",
      "Kumbharput B.O": "764027",
      "Padavalda B.O": "764027",
      "Ranjiput B.O": "764027",
      "Langalabeda B.O": "764027",
      "Kumbhaganda B.O": "764027",
      "Bodigaon B.O": "764057",
      "Kamta B.O": "764057",
      "Kumuli B.O": "764057",
      "Jeypore(K) H.O": "764001",
      "Koraput H.O": "764020",
      "Jeypore(K) R.S. S.O": "764002",
      "Lamtaput S.O": "764081",
      "Bhairabsinghpur S.O": "764057",
      "Dasamanthpur S.O": "764028",
      "Kolab Nagar S.O": "764011",
      "Nandapur S.O": "764037",
      "Padwa S.O (Koraput)": "764038",
      "Sector VII(Sunabeda) S.O": "763002",
      "Sunabeda 2 S.O": "763002",
      "Bariniput S.O": "764006",
      "Jayanagar S.O (Koraput)": "764005",
      "Borigumma S.O": "764056",
      "Koraput R.S. S.O": "764021",
      "Laxmipur (Koraput) S.O": "765013",
      "Nad, Sunabeda S.O": "763004",
      "Omp Line S.O": "764021",
      "Sunabeda 1 S.O": "763001",
      "B.D.Pur S.O": "764001",
      "Jeypore(K) Civil Court S.O": "764001",
      "Jeypore(K) Koraput Road S.O": "764001",
      "Jolaput S.O": "764041",
      "Machhkund S.O": "764040",
      "Onukadeli S.O": "764042",
      "Sriram Nagar S.O": "764001",
      "Bandhugam S.O": "764027",
      "D.P.Camp, Sunabeda S.O": "763003",
      "Damanjodi S.O": "763008",
      "Semiliguda S.O": "764036",
      "Boipariguda S.O": "764043",
      "Jeypore(K) Irrigation Colony S.O": "764004",
      "Kotpad S.O": "764058",
      "Prasadraopeta S.O": "764003",
      "Ambaguda S.O": "764055",
      "Koraput Collectorate S.O": "764020",
      "Narayanpatna S.O": "764014",
      "Pottangi S.O": "764039",
      "R Zone(Sunabeda) S.O": "763002"
    },
    "NABARANGPUR": {
      "Banuaguda B.O": "764076",
      "Bokadabeda B.O": "764072",
      "Medana B.O": "764072",
      "Phupugaon B.O": "764002",
      "Badatemra B.O": "764076",
      "B.M.Semla B.O": "764075",
      "Basini B.O": "764075",
      "Kondapuri B.O": "764075",
      "Kotagaon B.O": "764075",
      "Bajraguda B.O": "764061",
      "Patiki B.O": "764077",
      "Patkhalia B.O": "764077",
      "Jabaguda B.O": "764072",
      "Digisalpa B.O": "764078",
      "Dohona B.O": "764078",
      "J.B.Guda B.O": "764078",
      "Maliguda B.O": "764078",
      "Nandahandi B.O": "764078",
      "R.Jaganathpur B.O": "764078",
      "Ekamba B.O": "764076",
      "Palia B.O": "764076",
      "Parajadeopalli B.O": "764085",
      "Betal B.O": "764075",
      "Chhatahandi B.O": "764075",
      "Dongra B.O": "764075",
      "Ekori B.O": "764075",
      "Jhadakusumi B.O": "764075",
      "Majhidhanua B.O": "764061",
      "Motigaon B.O": "764061",
      "Panduguda B.O": "764061",
      "Rajoda B.O": "764061",
      "Kundei B.O": "764088",
      "Jadapara B.O": "764088",
      "Jodinga B.O": "764088",
      "Khuduku B.O": "764088",
      "Deobharandi B.O": "764088",
      "Kontagam B.O": "764049",
      "Mohara B.O": "764077",
      "Kamta B.O": "764049",
      "Patraput B.O": "764049",
      "Jamadapada B.O": "764077",
      "Melgam B.O": "764077",
      "Palsapara B.O": "764077",
      "Amlabhata B.O": "764049",
      "Dhondra B.O": "764049",
      "Anakabeda B.O": "764077",
      "Dalbeda B.O": "764077",
      "Dandamunda B.O": "764077",
      "Rajkote B.O": "764077",
      "Saradhapur B.O": "764077",
      "Chatiguda B.O": "764072",
      "Checherguda B.O": "764072",
      "Dhamanaguda B.O": "764072",
      "Dongriguda B.O": "764072",
      "Koragam B.O": "764072",
      "Mohendri B.O": "764072",
      "Bhikhya B.O": "764076",
      "Chitabeda B.O": "764076",
      "Chocha B.O": "764076",
      "Attigaon B.O": "764075",
      "B.Gumuda B.O": "764075",
      "Badambeda B.O": "764061",
      "Ghadadhanua B.O": "764061",
      "Sanameda B.O": "764061",
      "Temera B.O": "764061",
      "Baigam B.O": "764072",
      "Borigaon B.O": "764072",
      "Ghodakhuntia B.O": "764072",
      "Junapani B.O": "764072",
      "Manigam B.O": "764072",
      "Singisari B.O": "764072",
      "Belagaon B.O": "764076",
      "Badaolama B.O": "764075",
      "Belanga B.O": "764075",
      "Kutubai B.O": "764075",
      "Bhamuni B.O": "764061",
      "Kukudisemla B.O": "764061",
      "Kaudala B.O": "764088",
      "Hatabharandi B.O": "764088",
      "Parchipara B.O": "764088",
      "Bharanpur B.O": "764049",
      "Jhariguma B.O": "764049",
      "Beheramunda B.O": "764077",
      "Gambhariguda B.O": "764077",
      "Kolimunda B.O": "764077",
      "Ambadola B.O": "764063",
      "Aunli B.O": "764063",
      "Baragam B.O": "764063",
      "Rangamatiguda B.O": "764063",
      "Kurlughati B.O": "764059",
      "Majhiguda B.O": "764071",
      "Mantriguda B.O": "764059",
      "Dengaguda B.O": "764071",
      "Hirli B.O": "764071",
      "Jatabal B.O": "764071",
      "Maidalpur B.O": "764071",
      "Naktiguda B.O": "764071",
      "Kumuli B.O": "764074",
      "Sonepur B.O": "764074",
      "Bhejaguda B.O": "764070",
      "Adhikariguda B.O": "764073",
      "Hirapur B.O": "764073",
      "Jamranda B.O": "764073",
      "Porsola B.O": "764063",
      "Agnipur B.O": "764059",
      "Badakumuli B.O": "764059",
      "Baghsiuni B.O": "764059",
      "Bikrampur B.O": "764059",
      "Biriguda B.O": "764071",
      "Nuakote B.O": "764071",
      "Patri B.O": "764071",
      "Pendikote B.O": "764071",
      "Semla B.O": "764071",
      "Debagaon B.O": "764074",
      "Ganjapara B.O": "764074",
      "Gona B.O": "764074",
      "Pandripakna B.O": "764074",
      "Manchagaon B.O": "764070",
      "Pujariguda B.O": "764063",
      "Benara B.O": "764073",
      "Bokoda B.O": "764073",
      "Burja B.O": "764073",
      "Chikalpadar B.O": "764073",
      "Dhodra B.O": "764073",
      "Bhatigam B.O": "764063",
      "Jujhari B.O": "764063",
      "Sindhigaon B.O": "764063",
      "Kangra B.O": "764059",
      "Cherchata B.O": "764071",
      "Tumberla B.O": "764071",
      "Bharsundi B.O": "764074",
      "Bubei B.O": "764074",
      "Mohanda B.O": "764074",
      "Sarguli B.O": "764074",
      "Khuntipadar B.O": "764070",
      "Mentri B.O": "764070",
      "Badabasini B.O": "764073",
      "Badakumari B.O": "764073",
      "Bhamini B.O": "764073",
      "Khanda B.O": "764073",
      "Sunabeda B.O": "764073",
      "Bhatrasiuni B.O": "764063",
      "Dengapadar B.O": "764063",
      "Sanamasigaon B.O": "764063",
      "Sindhiguda B.O": "764063",
      "Jambaguda B.O": "764059",
      "Kukudabai B.O": "764059",
      "Taragaon B.O": "764059",
      "Mokiya B.O": "764071",
      "Sirisi B.O": "764071",
      "Ushigaon B.O": "764071",
      "Kurbeda B.O": "764074",
      "Naktisimla B.O": "764074",
      "Charmula B.O": "764070",
      "Badabharandi B.O": "764073",
      "Beheda B.O": "764073",
      "Murtuma B.O": "764073",
      "Sirliguda B.O": "764073",
      "Chandahandi S.O": "764077",
      "Jharigam S.O": "764076",
      "Kodinga S.O": "764075",
      "Nabarangpur Bazar S.O": "764059",
      "Raighar S.O": "764074",
      "Turudihi": "764088",
      "Anchalgumma S.O": "764049",
      "Kosagumuda S.O": "764061",
      "Papadahandi S.O": "764071",
      "Tentulikhunti S.O": "764070",
      "Umerkote Bazar S.O": "764073",
      "Dabugam S.O": "764072",
      "Khatiguda S.O": "764085",
      "Dongerbheja S.O": "764078",
      "Mirganiguda S.O": "764063",
      "Nabarangpur S.O": "764059",
      "Umerkote S.O": "764073"
    },
    "RAYAGADA": {
      "Khillingrai B.O": "765025",
      "Tabalaguda B.O": "765025",
      "Gulunthi B.O": "765029",
      "K.Kota B.O": "765029",
      "Kinarimada B.O": "765029",
      "Kondajam B.O": "765029",
      "Rekhapadar B.O": "765029",
      "Pitamahal B.O": "765002",
      "Sulava B.O": "765002",
      "Dumuriguda B.O": "765018",
      "Tembaguda B.O": "765025",
      "Nuaguda B.O": "765025",
      "Bankili B.O": "765029",
      "Bhoimada B.O": "765029",
      "G.Gulumunda B.O": "765029",
      "Gogupada B.O": "765029",
      "Gajigaon B.O": "765002",
      "J.D.Pentho B.O": "765002",
      "K.Gumma B.O": "765002",
      "Kumbhikota B.O": "765002",
      "Buduni B.O": "765018",
      "Derigam B.O": "765024",
      "G.Laxmipur B.O": "765024",
      "Naira B.O": "765024",
      "Jagdalpur B.O": "765020",
      "Jarapa B.O": "765020",
      "Kumudabali B.O": "765020",
      "Kutraguda B.O": "765020",
      "Akhusingi B.O": "765025",
      "Ambabadi B.O": "765025",
      "Paikapada B.O": "765018",
      "Bhamini B.O": "765024",
      "Bichikote B.O": "765024",
      "Jathili B.O": "765025",
      "Karini B.O": "765025",
      "Khambariguda B.O": "765025",
      "Dohikhal B.O": "765020",
      "Hanumanthpur B.O": "765020",
      "M.Patraguda B.O": "765020",
      "Biripadar B.O": "765025",
      "Guluguda B.O": "765025",
      "Khilapadar B.O": "765025",
      "Perupanga B.O": "765025",
      "Hatikhamba B.O": "765029",
      "Katiki B.O": "765029",
      "Panichatra B.O": "765029",
      "S.Dhamini B.O": "765029",
      "B.Haluva B.O": "765002",
      "Halva B.O": "765002",
      "Kerada B.O": "765002",
      "Kutuli B.O": "765002",
      "S.S.Khal B.O": "765002",
      "Todama B.O": "765002",
      "Limapadar B.O": "765024",
      "Dangasorada B.O": "765020",
      "Hatamuniguda B.O": "765020",
      "Laxmipur B.O": "765020",
      "T.Padar B.O": "765020",
      "Godiabandha B.O": "765025",
      "Indupur B.O": "765025",
      "B.Gotiguda B.O": "765019",
      "Batalpur B.O": "765019",
      "Bethiapada B.O": "765019",
      "Chatikona B.O": "765019",
      "H.Donga B.O": "765019",
      "Kurli B.O": "765019",
      "Mundakota B.O": "765019",
      "Murtuli B.O": "765019",
      "P.Dokuluguda B.O": "765019",
      "Penta B.O": "765019",
      "Piskapanga B.O": "765019",
      "Sahada B.O": "765019",
      "Chalakamba B.O": "765033",
      "Ghanatri B.O": "765033",
      "Laba B.O": "765033",
      "Dhepaguda B.O": "765026",
      "Kinalodi B.O": "765026",
      "Kodama B.O": "765026",
      "Pendili B.O": "765026",
      "Antamoda B.O": "765017",
      "Raghubari B.O": "765021",
      "Serjholi B.O": "764062",
      "Jhigidi B.O": "765019",
      "K.Dhamuni B.O": "765019",
      "Asada B.O": "765026",
      "Godiakhal B.O": "765022",
      "Jaltar B.O": "765022",
      "Kharlingi B.O": "765022",
      "Kulusingi B.O": "765022",
      "Dondili B.O": "765017",
      "G.Seshkhal B.O": "765017",
      "Jilunda B.O": "765017",
      "Karubai B.O": "765017",
      "Sikarpai B.O": "765017",
      "Pujariguda B.O": "765016",
      "Sunakhandi B.O": "765016",
      "Adajori B.O": "765015",
      "Bankamba BO": "765015",
      "Bilamala B.O": "765015",
      "Kodipari B.O": "765015",
      "Kuchipadar B.O": "765015",
      "Siripai B.O": "765015",
      "Sunger B.O": "765015",
      "B.Bandili B.O": "765020",
      "Bhairabguda B.O": "765020",
      "Kothapeta B.O": "765017",
      "Mirabali B.O": "765017",
      "Bankamba B.O": "765015",
      "D.Panga B.O": "765016",
      "Gorakhpur B.O": "765015",
      "Kampara B.O": "765015",
      "Panchali B.O": "765015",
      "Podapari B.O": "765015",
      "Renga B.O": "765015",
      "Sankarada B.O": "765015",
      "Tikiri B.O": "765015",
      "Turaighati B.O": "765015",
      "Buthingi B.O": "765023",
      "Chandrapur B.O": "765020",
      "Ichhapur B.O": "765021",
      "Dumurineli B.O": "765019",
      "Kachapai B.O": "765019",
      "Konabai B.O": "765019",
      "Patraguda B.O": "765019",
      "Bhimpur B.O": "765033",
      "Tiitmari B.O": "765033",
      "Badapankal B.O": "765026",
      "Khariguda B.O": "765026",
      "M.Khillingrai B.O": "765026",
      "Chinasari B.O": "765022",
      "Puttasingi B.O": "765022",
      "Sagada B.O": "765022",
      "Tolana B.O": "765022",
      "B.Khillapadar B.O": "765017",
      "Dangaladi B.O": "765017",
      "Komtalpeta B.O": "765017",
      "Pipalguda B.O": "765017",
      "Sirigumma B.O": "765017",
      "G.Padar B.O": "765034",
      "Korapa B.O": "765016",
      "Polama B.O": "765016",
      "Singari B.O": "765016",
      "Chandgiri B.O": "765015",
      "Dongasil B.O": "765015",
      "Mandibisi B.O": "765015",
      "Naktiguda B.O": "765015",
      "Neelamguda B.O": "765023",
      "Panasaguda B.O": "765023",
      "Agula B.O": "765020",
      "Dukum B.O": "765019",
      "Durgi B.O": "765019",
      "K.Golmi B.O": "765019",
      "Kankubadi B.O": "765019",
      "Bagusala B.O": "765033",
      "Khaira B.O": "765033",
      "Bellamguda B.O": "765026",
      "Bijapur B.O": "765026",
      "Karlaghati B.O": "765026",
      "Madhuban B.O": "765026",
      "Sanahuma B.O": "765026",
      "Siriguda B.O": "765026",
      "Regada B.O": "765022",
      "Taribili B.O": "765022",
      "B.Alubadi B.O": "765017",
      "Budaguda B.O": "765017",
      "Kolnara B.O": "765017",
      "Majhiguda B.O": "765017",
      "Suri B.O": "765017",
      "Marma B.O": "765034",
      "Jaganathpur B.O": "765016",
      "Narayanpur B.O": "765016",
      "Chandragiri B.O": "765015",
      "Godibali B.O": "765015",
      "Maikanch B.O": "765015",
      "Mansugaon B.O": "765015",
      "Omadingi B.O": "765023",
      "Penakham B.O": "765023",
      "Budubali B.O": "765020",
      "Rayagada(K) H.O": "765001",
      "Ambadola S.O": "765021",
      "Bikrampur S.O": "764062",
      "Bissamcuttack S.O": "765019",
      "J.K.Pur S.O": "765017",
      "Muniguda S.O": "765020",
      "Padmapur S.O": "765025",
      "Rayagada College S.O": "765001",
      "Rayagada S.F. S.O": "765002",
      "Ukkamba S.O": "765024",
      "Gunupur S.O": "765022",
      "Rayagada Gandhinagar S.O": "765001",
      "Dambasora S.O": "765033",
      "J.K.Pur Bazar S.O": "765017",
      "Jaganathpur S.O": "765034",
      "K.Singhpur S.O": "765016",
      "Kashipur S.O": "765015",
      "Kujendri S.O": "765023",
      "Ramanaguda S.O": "765029",
      "Therubali S.O": "765018",
      "Gudari S.O": "765026",
      "Marathiguda S.O": "765022",
      "R K Nagar, Rayagada S.O": "765001",
      "Rayagada Bazar S.O": "765001"
    }
  },
  "MAHARASHTRA": {
    "AMRAVATI": {
      "Bhatkuli S.O": "444602",
      "Jasapur B.O": "444704",
      "Kharala B.O": "444704",
      "Madhan B.O": "444704",
      "Rithpur B.O": "444704",
      "Khallar B.O": "444803",
      "Kulangana B.O": "444717",
      "Wastapur B.O": "444717",
      "Ratnapur B.O": "444702",
      "Bhokarbardi B.O": "444719",
      "Dabida B.O": "444719",
      "Dhulghat Rly B.O": "444719",
      "Zilpi B.O": "444719",
      "Sarfapur B.O": "444809",
      "Parasapur B.O": "444808",
      "Sindi BK B.O": "444808",
      "Chikhali B.O": "444813",
      "Chourakund B.O": "444813",
      "Hatru B.O": "444813",
      "Raipur B.O": "444813",
      "Belaj B.O": "444723",
      "Tondgaon B.O": "444723",
      "Tuljapur Gadhi B.O": "444723",
      "Tonglabad B.O": "444803",
      "Sanglood B.O": "444706",
      "Warud Bk B.O": "444706",
      "Churni B.O": "444807",
      "Gangarkheda B.O": "444807",
      "Shahapur B.O": "444807",
      "Kokarda B.O": "444803",
      "Jamli B.O": "444717",
      "Tambursonda B.O": "444717",
      "Bijudhawadi B.O": "444702",
      "Khairi Tembhru B.O": "444702",
      "Kutanga B.O": "444702",
      "Ranitamboli B.O": "444702",
      "Tembli B.O": "444702",
      "Titamba B.O": "444702",
      "Dabka B.O": "444719",
      "Dhulghat Road B.O": "444719",
      "Sadrabadi B.O": "444719",
      "Karanja Bahiram B.O": "444809",
      "Kurha B.O": "444709",
      "Borala B.O": "444704",
      "Kushta BK B.O": "444808",
      "Tawlar B.O": "444808",
      "Harisal B.O": "444813",
      "Rahu B.O": "444813",
      "Tarubanda B.O": "444813",
      "Kawitha B.O": "444723",
      "Talegaon Mohana B.O": "444723",
      "Arala B.O": "444803",
      "Chincholi Shinghane B.O": "444803",
      "Khaspur B.O": "444803",
      "Takli B.O": "444801",
      "Thilori B.O": "444803",
      "Antargaon B.O": "444706",
      "Pimplod B.O": "444706",
      "Sasan Ramapur B.O": "444706",
      "Umri Mamadabad B.O": "444706",
      "Doma B.O": "444807",
      "Katkumbha B.O": "444807",
      "Salona B.O": "444807",
      "Ambapati B.O": "444717",
      "Telkhar B.O": "444717",
      "Bairagad B.O": "444702",
      "Bobdo B.O": "444702",
      "Kusumkot B.O": "444702",
      "Mandwa B.O": "444702",
      "Shirpur B.O": "444702",
      "Khaparkheda B.O": "444719",
      "Sawalikheda B.O": "444719",
      "Kharpi B.O": "444809",
      "Kakda B.O": "444808",
      "Kolha B.O": "444808",
      "Sonapur B.O": "444808",
      "Wadgaon Fatepur B.O": "444808",
      "Nanduri B.O": "444813",
      "Kural B.O": "444723",
      "Pimpri B.O": "444723",
      "Babhli B.O": "444803",
      "Kanholi B.O": "444803",
      "Kumbhargaon B.O": "444803",
      "Mahuli Dhande B.O": "444803",
      "Ramtirth B.O": "444803",
      "Shivar B.O": "444803",
      "Adula Bazar B.O": "444706",
      "Bhamod B.O": "444706",
      "Nandrun B.O": "444706",
      "Wadnergangai B.O": "444706",
      "Sonori B.O": "444704",
      "Maheriam B.O": "444807",
      "Motha B.O": "444807",
      "Badnapur B.O": "444717",
      "Gaurkheda Bazar B.O": "444717",
      "kadhav B.O": "444702",
      "Chakarda B.O": "444702",
      "Chatwabod B.O": "444702",
      "Dahenda B.O": "444702",
      "Dharan Mahu B.O": "444702",
      "Diya B.O": "444702",
      "Duni B.O": "444702",
      "Hirabambai B.O": "444702",
      "Susarda B.O": "444719",
      "Morgad B.O": "444808",
      "Pandhari B.O": "444808",
      "Dhamodi B.O": "444803",
      "Gaiwadi B.O": "444803",
      "Itki Antargaon B.O": "444803",
      "Kalashi B.O": "444803",
      "Kamalpur Taroda B.O": "444803",
      "Lehegaon B.O": "444803",
      "Nalwada B.O": "444803",
      "Nimbhari B.O": "444803",
      "Samda B.O": "444803",
      "Jainpur B.O": "444706",
      "Lotwada B.O": "444706",
      "Kati B.O": "444906",
      "Linga B.O": "444906",
      "Loni B.O": "444908",
      "Pauni B.O": "444906",
      "Asadpur B.O": "444806",
      "Narayanpur B.O": "444806",
      "Talni Purna B.O": "444806",
      "Wasni Bzk B.O": "444806",
      "Gawhan B.O": "444705",
      "Kalgawhan B.O": "444705",
      "Kapustalni B.O": "444901",
      "Karla B.O": "444904",
      "Khondgaon B.O": "444705",
      "Nimkhed Bazar B.O": "444705",
      "Pusla B.O": "444906",
      "Roshankheda B.O": "444906",
      "Udapur B.O": "444906",
      "Bhilona B.O": "444806",
      "Bopapur B.O": "444806",
      "Cotton Market B.O": "444806",
      "Gaurkheda B.O": "444806",
      "Haram B.O": "444806",
      "Rasegaon B.O": "444806",
      "Bhandaraj B.O": "444705",
      "Dahigaon Reche B.O": "444705",
      "Lakhad B.O": "444705",
      "Vihigaon B.O": "444705",
      "Surali B.O": "444720",
      "Wani B.O": "444720",
      "Belora B.O": "444704",
      "Dahigaonpura B.O": "444704",
      "Surli B.O": "444906",
      "Tembhurkheda B.O": "444906",
      "Bordi B.O": "444806",
      "Borgaon Peth B.O": "444806",
      "Chamak BK B.O": "444806",
      "Kandli B.O": "444806",
      "Kohana B.O": "444806",
      "Malhara B.O": "444806",
      "Yeota B.O": "444806",
      "Adgaon Navapur B.O": "444705",
      "Chincholi BK B.O": "444705",
      "Dhanegaon B.O": "444705",
      "Gawandgaon B.O": "444705",
      "Jawala BK B.O": "444705",
      "Songaon B.O": "444705",
      "Ghatladki B.O": "444720",
      "Vishroli B.O": "444720",
      "Rajura Bazar B.O": "444906",
      "Sawangi B.O": "444906",
      "Asegaon Purna B.O": "444806",
      "Bhugaon B.O": "444806",
      "Dhoter Kheda B.O": "444806",
      "Rajna Purna B.O": "444806",
      "Salepur B.O": "444806",
      "Chausala B.O": "444705",
      "Hantoda B.O": "444705",
      "Murha B.O": "444705",
      "Sategaon B.O": "444705",
      "Takarkheda More B.O": "444705",
      "Turkhed B.O": "444705",
      "Deurwada B.O": "444704",
      "Pimpalkhuta B.O": "444904",
      "Virul Ronghe B.O": "444709",
      "Wadgaon Rajdi B.O": "444709",
      "Shivangaon B.O": "444902",
      "Sirasgaon Mozar B.O": "444902",
      "Talegaon Thakur B.O": "444902",
      "Bargaon B.O": "444908",
      "Benoda B.O": "444908",
      "Isambari B.O": "444908",
      "Ittamgaon B.O": "444908",
      "Amla B.O": "444802",
      "Chendakapur B.O": "444802",
      "Nanded BK B.O": "444802",
      "Shingnapur B.O": "444802",
      "Wathoda Sh. B.O": "444802",
      "Dighi B.O": "444711",
      "Nimbhora Bodkhe B.O": "444711",
      "Ambada EB.O": "444905",
      "Ladki B.O": "444905",
      "Nimbhi B.O": "444905",
      "Yawali Dongar B.O": "444905",
      "Yerla B.O": "444905",
      "Hiwarkhed B.O": "444905",
      "Mangrul Chawala B.O": "444708",
      "Mokhad B.O": "444708",
      "Phubgaon B.O": "444708",
      "Sawaner B.O": "444708",
      "Katsur B.O": "444915",
      "Kekatpur B.O": "444901",
      "Mahuli Jahagir B.O": "444901",
      "Mangrul Bhilasp B.O": "444901",
      "Salora Khurd B.O": "444901",
      "Sirasgaon B.O": "444901",
      "Dapori Khurd B.O": "444707",
      "Katpur B.O": "444707",
      "Talegaon B.O": "444707",
      "Dhanodi B.O": "444906",
      "Shendurjana Dha B.O": "444710",
      "Wadhona B.O": "444709",
      "Kawadgavan B.O": "444903",
      "Nimbhora Delwad B.O": "444903",
      "Alangaon B.O": "444801",
      "Ashti B.O": "444801",
      "Chincholi Kale B.O": "444801",
      "Takarkheda B.O": "444801",
      "Talwel B.O": "444801",
      "Virshi B.O": "444801",
      "Gadegaon B.O": "444906",
      "Gavandkund B.O": "444906",
      "Haturna B.O": "444801",
      "Jamthi Ganeshpur B.O": "444906",
      "Kasarkheda B.O": "444709",
      "Kawali B.O": "444709",
      "Tiwara B.O": "444709",
      "Mozri B.O": "444902",
      "Shendola BK B.O": "444902",
      "Karajgaon (Gandhighar) B.O": "444908",
      "Darapur B.O": "444802",
      "Nimboli B.O": "444711",
      "Chincholi Gawal B.O": "444905",
      "Khanapur B.O": "444905",
      "Khopada B.O": "444905",
      "Pala B.O": "444905",
      "Chikhali Vaidya B.O": "444708",
      "Salod B.O": "444708",
      "Yenas B.O": "444708",
      "Yeoti B.O": "444708",
      "Dewara B.O": "444915",
      "Vichori B.O": "444915",
      "Lahegaon B.O": "444707",
      "Rajurwadi B.O": "444707",
      "Khairi B.O": "444804",
      "Yesurna B.O": "444804",
      "Satnoor B.O": "444907",
      "Teosa Ghat B.O": "444907",
      "Shendurjana Bazar B.O": "444903",
      "Werkhed B.O": "444903",
      "Dhamori Kasba B.O": "444801",
      "Jalka Hirapur B.O": "444801",
      "Pusda B.O": "444801",
      "Saur B.O": "444801",
      "Waigaon B.O": "444801",
      "Bhemdi B.O": "444906",
      "Marda B.O": "444709",
      "Murtizapur Taro B.O": "444709",
      "Sawanga B.O": "444908",
      "Ashtoli B.O": "444905",
      "Chikhal Savangi B.O": "444905",
      "Dapori B.O": "444905",
      "Khed B.O": "444905",
      "Taroda B.O": "444905",
      "Udkhed B.O": "444905",
      "Wathoda Naya B.O": "444905",
      "Shivani Rasulpu B.O": "444708",
      "Sultanpur Nandu B.O": "444708",
      "Veni Ganeshpur B.O": "444708",
      "Adgaon B.O": "444915",
      "Brahmanwada Gov B.O": "444901",
      "Dawargaon B.O": "444901",
      "Porgawhan B.O": "444707",
      "Sawarkheda B.O": "444707",
      "Shirkhed B.O": "444707",
      "Nirul B.O": "444804",
      "Rama B.O": "444804",
      "Sawalapur B.O": "444804",
      "Waki Raipur B.O": "444804",
      "Khartalegaon B.O": "444801",
      "Mhaispur B.O": "444801",
      "Nandura Bl B.O": "444801",
      "Naya Akola B.O": "444801",
      "Rewasa B.O": "444801",
      "Amner B.O": "444906",
      "Kamnapur Ghusal B.O": "444709",
      "Pimpal Vihir B.O": "444902",
      "Shendola KH B.O": "444902",
      "Aloda B.O": "444908",
      "Jamgaon B.O": "444908",
      "Mangruli B.O": "444908",
      "Hartala B.O": "444802",
      "Markanda B.O": "444802",
      "Zada B.O": "444711",
      "Kolvihir B.O": "444905",
      "Pardi B.O": "444701",
      "Shingori B.O": "444905",
      "Bori B.O": "444708",
      "Dhamak B.O": "444708",
      "Dhanora Mogal B.O": "444708",
      "Rajura B.O": "444708",
      "Yerad B.O": "444708",
      "Dewara Antora B.O": "444915",
      "Dhamangaon B.O": "444707",
      "Kawathal B.O": "444707",
      "Vishnora B.O": "444707",
      "Satargaon B.O": "444701",
      "Verha B.O": "444903",
      "Jawala Shahpur B.O": "444801",
      "Shirala B.O": "444801",
      "Chandas Wathoda B.O": "444906",
      "Ekdara B.O": "444906",
      "Hirur B.O": "444704",
      "Asra B.O": "444602",
      "Tapovan B.O": "444602",
      "Uttamsara B.O": "444602",
      "Wadgaon Mahore B.O": "444602",
      "Hiwara BK B.O": "444701",
      "Januna B.O": "444701",
      "Kajna B.O": "444701",
      "Lohgaon B.O": "444701",
      "Pimpalgaon Nipa B.O": "444701",
      "Wadura B.O": "444701",
      "Yerandgaon B.O": "444701",
      "Bhankheda Khurd B.O": "444904",
      "Palaskhed B.O": "444904",
      "Pohara B.O": "444904",
      "Satephal B.O": "444904",
      "Anjansingi B.O": "444709",
      "Anjanwati B.O": "444709",
      "Jalka Patache B.O": "444709",
      "Juna Dhamangaon B.O": "444709",
      "Ganori B.O": "444602",
      "Kathora B.O": "444602",
      "Kawatha B.O": "444602",
      "Khalkoni B.O": "444602",
      "Nimbha B.O": "444602",
      "Parlam B.O": "444602",
      "Anjangaon Bari EB.O": "444701",
      "Loni Takli B.O": "444701",
      "Manjri Masla B.O": "444701",
      "Nandsawangi B.O": "444701",
      "Papal B.O": "444701",
      "Ghuikhed B.O": "444904",
      "Jalka Jagtap B.O": "444904",
      "Kalamgaon B.O": "444904",
      "Kawatha Kadu B.O": "444904",
      "Sirasgaon Korde B.O": "444904",
      "Sonora BK B.O": "444904",
      "Chinchpur B.O": "444709",
      "Dabhada B.O": "444709",
      "Deogaon B.O": "444709",
      "Hirpur B.O": "444709",
      "Bhatkuli B.O": "444602",
      "Dadhi B.O": "444602",
      "Rahatgaon B.O": "444602",
      "SRPF Camp B.O": "444602",
      "Dabha B.O": "444701",
      "Dhanora Fasi B.O": "444701",
      "Phulamala B.O": "444701",
      "Pimpri Nipani B.O": "444701",
      "Sarsi Kothoda B.O": "444701",
      "Takli BK B.O": "444701",
      "Baggi B.O": "444904",
      "Dhanora Mhali B.O": "444904",
      "Manjarkhed B.O": "444904",
      "Nimgavan B.O": "444904",
      "Sawangi Magrapur B.O": "444904",
      "Bhatkkuli Ranak B.O": "444709",
      "Borgaon Dhande B.O": "444709",
      "Borgaon Dharmale": "444602",
      "Ganoja Devi B.O": "444602",
      "Sayat B.O": "444602",
      "Dahigaon B.O": "444701",
      "Dhanora Gurav B.O": "444701",
      "Mahuli Chor B.O": "444701",
      "Palasmandal B.O": "444701",
      "Wadhona Ramnath B.O": "444701",
      "Amla Vishweshwar B.O": "444904",
      "Jawala B.O": "444904",
      "Malkhed B.O": "444904",
      "Mardi B.O": "444904",
      "Ashoknagar B.O": "444709",
      "Borda B.O": "444709",
      "Paratwada H.O": "444805",
      "Amravati H.O": "444601",
      "Dhamangaon R.S. S.O": "444709",
      "Nandgaon Peth S.O": "444901",
      "Old Cotton Market S.O": "444601",
      "Tiosa S.O": "444903",
      "V.M.V. (Amravati) S.O": "444604",
      "Warud S.O": "444906",
      "Anjangaon S.O": "444705",
      "Brahmanwada Thadi S.O": "444720",
      "Karajgaon S.O": "444809",
      "Ambapeth S.O": "444601",
      "Dhamangaon Town S.O": "444709",
      "Jarud S.O": "444908",
      "Mangrul Dastgir S.O": "444711",
      "Purna Nagar S.O": "444804",
      "Sant GadgebabaAmravatiUniversityS.O": "444602",
      "Shivaji Nagar S.O (Amravati)": "444603",
      "Achalpur City S.O": "444806",
      "Daryapur S.O": "444803",
      "Dhamangaon Gadhi S.O": "444717",
      "Pathrot S.O": "444808",
      "Sirasgaon Kasba S.O": "444810",
      "Yeoda S.O": "444706",
      "Badnera S.O": "444701",
      "Bhaji Bazar Amravati S.O": "444601",
      "Congress Nagar S.O (Amravati)": "444606",
      "Gokul Market S.O": "444606",
      "Gurukunj Ashram S.O": "444902",
      "H. V. Nagar S.O": "444605",
      "Nerpingalai S.O": "444707",
      "Rajapeth S.O": "444601",
      "Sai Nagar S.O": "444607",
      "Walgaon Road Tso Amravati S.O": "444601",
      "Chandur Bazar S.O": "444704",
      "Chhota Bazar S.O": "444805",
      "Daryapur Town S.O": "444803",
      "Dharni S.O": "444702",
      "Kalamkhar S.O": "444719",
      "Semadoh S.O": "444813",
      "Sirajgaon Band S.O": "444723",
      "Surji  (Anjangaon) S.O": "444705",
      "Amravati Camp S.O": "444602",
      "Badnera Town S.O": "444701",
      "Chandur Railway S.O": "444904",
      "Kholapur S.O": "444802",
      "Morshi S.O": "444905",
      "Nandgaon Khandeshwar S.O": "444708",
      "Rukhmini Nagar S.O": "444606",
      "Shendurjana Ghat S.O": "444907",
      "Talegaon Dashasar S.O": "444710",
      "Walgaon S.O": "444801",
      "Yawali S.O": "444915",
      "Chikhaldara S.O": "444807"
    },
    "CHANDRAPUR": {
      "Subai B.O": "442905",
      "Tembhuwahi B.O": "442905",
      "Vihirgaon B.O": "441215",
      "Warud Road B.O": "442905",
      "Haramba B.O": "441225",
      "Vir R.S. B.O": "442905",
      "Keroda B.O": "441225",
      "Londholi B.O": "441225",
      "Pendhari Maktha B.O": "441225",
      "Rajgad B.O": "441225",
      "Vyahad BK B.O": "441225",
      "Amadi Beguide B.O": "442906",
      "Arjuni B.O": "442906",
      "Ashta B.O": "442906",
      "Belgaon B.O": "442906",
      "Saori B.O": "442906",
      "Wadadha B.O": "442906",
      "Waigaon Tukum B.O": "442906",
      "Kondha B.O": "442503",
      "Khatgaon B.O": "441222",
      "Waneri B.O": "441222",
      "Bond B.O": "441221",
      "Govindpur B.O": "441221",
      "Kanhalgaon Sonule B.O": "441221",
      "Kitali Bormal B.O": "441221",
      "Sawargaon B.O": "442904",
      "Wadhona B.O": "441221",
      "Kanhalgaon B.O": "442916",
      "Kodsi B.O": "442916",
      "Dongargaon B.O": "441212",
      "Dongargaon Khadi B.O": "442907",
      "Ekarjuna B.O": "442907",
      "Jamni B.O": "442907",
      "Nandori B.O": "442907",
      "Panjurni B.O": "442907",
      "Sembal B.O": "442907",
      "Waghnakh B.O": "442907",
      "Yergawhan (Dewada) B.O": "442905",
      "Bothali B.O": "442906",
      "Jibgaon B.O": "441225",
      "Kawathi B.O": "441225",
      "Chargaon BK B.O": "442906",
      "Khadsangi B.O": "442906",
      "Viloda B.O": "442906",
      "Jamsala B.O": "441222",
      "Kinhi B.O": "441206",
      "Alwahi B.O": "441221",
      "Nanded B.O": "441221",
      "Kadholi B.O": "442905",
      "Matha B.O": "442916",
      "Naranda B.O": "442916",
      "Rupapet B.O": "442916",
      "Chikani B.O": "442907",
      "Kosarsar B.O": "442907",
      "Tembhurda B.O": "442907",
      "Dabgaon Maktha B.O": "442918",
      "Mokhala B.O": "441225",
      "Nilsani Pedgaon B.O": "441225",
      "Samda Buzruk B.O": "441225",
      "Vyhad Khurd B.O": "441225",
      "Bhendala B.O": "442906",
      "Chandankheda B.O": "442906",
      "Chora B.O": "442906",
      "Sakhara Rajapur B.O": "442906",
      "Segaon KD B.O": "442906",
      "Kuchana B.O": "442503",
      "Gramsevak Trg B.O": "441222",
      "Kalamgaon Ganna B.O": "441222",
      "Ladbori B.O": "441222",
      "Balapur B.O": "441221",
      "Mangrul B.O": "441221",
      "Palasgaon Khurd B.O": "441221",
      "Sonurli BK B.O": "441221",
      "Ushral Mendha B.O": "441221",
      "Dhanoli B.O": "442916",
      "Mandwa B.O": "442916",
      "Pardi B.O": "441205",
      "Yergavhan B.O": "442916",
      "Charur Khati B.O": "442907",
      "Dahegaon B.O": "442907",
      "Khambada B.O": "442904",
      "MADHELI B.O.": "442907",
      "Nagri B.O": "442907",
      "Soit B.O": "442907",
      "Dewada Khurd B.O": "442918",
      "Fiskuti B.O": "441225",
      "Kapsi B.O": "441225",
      "Chargaon KD B.O": "442906",
      "Gulgaon B.O": "442906",
      "Mudholi B.O": "442906",
      "Sagra B.O": "442906",
      "Wahangaon B.O": "442906",
      "Patala B.O": "442503",
      "Mohali Naleshwar B.O": "441222",
      "Palasgaon Jat B.O": "441222",
      "Kothada B.O": "442916",
      "Pipri (Naranda) B.O": "442916",
      "Seraj  B.O": "442916",
      "Sonurli B.O": "442916",
      "Kasargatta B.O": "442918",
      "Jamtukam B.O": "442918",
      "Vansadi BO": "442916",
      "Dhanora Pipri B.O": "442505",
      "Shengaon B.O": "442908",
      "Aksapur B.O": "442702",
      "Gojoli Maktha B.O": "442702",
      "Nawegaon More B.O": "442702",
      "Sonapur Deshpande B.O": "442702",
      "Borgaon B.O": "442702",
      "Wadkuli B.O": "442702",
      "Chakdarur B.O": "442702",
      "Chintaldhaba B.O": "442702",
      "Dhaba B.O": "442702",
      "Dhamangaon B.O": "442702",
      "Lathi B.O": "442702",
      "Vithalwada B.O": "442702",
      "Nandgaon Podey B.O": "442507",
      "Mhatardevi": "442505",
      "Ghatkul B.O": "442702",
      "Karanji B.O": "442702",
      "Likhithwada B.O": "442702",
      "Talodhi Bhangaram B.O": "442702",
      "Wadholi B.O": "442702",
      "Khutala Mokasa B.O": "442904",
      "Motegaon B.O": "442904",
      "Meha BK B.O": "441215",
      "Navegaon Lonkhairi B.O": "441212",
      "Pedgaon B.O": "441212",
      "Bhedoda B.O": "442905",
      "Chincholi B.O": "442905",
      "Pandharpauni B.O": "442905",
      "Sasti B.O": "442905",
      "Wasera B.O": "441223",
      "Adegaon B.O": "442904",
      "Kajalsar B.O": "442904",
      "Kewada Mokasa B.O": "442904",
      "Antargaon B.O": "441223",
      "Bormala B.O": "441215",
      "Gewara BK B.O": "441215",
      "Nimgaon B.O": "441215",
      "Aheri B.O": "442905",
      "Arvi B.O": "442905",
      "Chunala B.O": "442905",
      "Dewada B.O": "442905",
      "Sondo B.O": "442905",
      "Pendhari B.O": "442904",
      "Sirpur B.O": "442904",
      "Wadsi B.O": "442904",
      "Palebarsa B.O": "441215",
      "Tambegadimendha B.O": "441215",
      "Chikhali B.O": "441212",
      "Gowari B.O": "442905",
      "Lakhadkot B.O": "442905",
      "Nalfadi B.O": "442905",
      "Pachgaon B.O": "442905",
      "Mhasali B.O": "442904",
      "Gunjewahi B.O": "441215",
      "Nifandra B.O": "441215",
      "Saradpar B.O": "441212",
      "Chandanwahi B.O": "442905",
      "Charli B.O": "442905",
      "Sakhari B.O": "442905",
      "Sindhi B.O": "442905",
      "Bhatala B.O": "442914",
      "Palasgaon B.O": "442701",
      "Tohogaon B.O": "442701",
      "Umari Potdar B.O": "442701",
      "Salori B.O": "442914",
      "Awalapur B.O": "442917",
      "Virur Gadegaon B.O": "442917",
      "Pipari (Dixit) B.O": "441226",
      "Sakharwahi B.O": "442902",
      "Sumthana B.O": "442902",
      "Visapur B.O": "442701",
      "Dighori B.O": "441226",
      "Bhejgaon B.O": "441226",
      "Futana B.O": "441226",
      "Chinora B.O": "442914",
      "Junona B.O": "442403",
      "Dudholi Bamini B.O": "442701",
      "Manora B.O": "442701",
      "Nandgaon B.O": "441223",
      "Surla B.O": "441226",
      "Jena B.O": "442902",
      "Pirli B.O": "442902",
      "Awalgaon B.O": "441206",
      "Arher Nawargaon B.O": "441206",
      "Jugnala B.O": "441206",
      "Mudza B.O": "441206",
      "Nanhori B.O": "441206",
      "Waigaon B.O": "441206",
      "Mel B.O": "442402",
      "Payali Bhatali B.O": "442404",
      "Nokewada B.O": "442908",
      "Uparwahi B.O": "442908",
      "Bhisi B.O": "442903",
      "Kolara Tukum B.O": "442903",
      "Madnapur B.O": "442903",
      "Pimpalneri B.O": "442903",
      "Sathgaon B.O": "442903",
      "Chaugaon B.O": "441206",
      "Halda B.O": "441206",
      "Hardoli B.O": "441206",
      "Kalamgaon B.O": "441206",
      "Khed B.O": "441206",
      "Mohorli B.O": "442404",
      "Baradkinhi B.O": "441206",
      "Kahali B.O": "441206",
      "Kurza B.O": "441206",
      "Maushi B.O": "441206",
      "Nilaj B.O": "441206",
      "Paradgaon B.O": "441206",
      "Pimpalgaon B.O": "441206",
      "Bakhardi B.O": "442908",
      "Bhari B.O": "442908",
      "Bhoygaon B.O": "442908",
      "Jiwati B.O": "442908",
      "Khirdi B.O": "442908",
      "Patan B.O": "442908",
      "Pudiyal Mohada B.O": "442908",
      "Mahalgaon Kalu B.O": "442903",
      "Malewada B.O": "442903",
      "Mangalgaon B.O": "442903",
      "Masal B.O": "442903",
      "Jambhulghat B.O": "442903",
      "Metepar B.O": "442903",
      "Navtala B.O": "442903",
      "Shiora B.O": "442903",
      "Talodhi Naik B.O": "442903",
      "Ambenri B.O": "442903",
      "Khemjai B.O": "442914",
      "Nanda B.O": "442917",
      "Kothari B.O": "442701",
      "Ghodpeth B.O": "442902",
      "Kacharala B.O": "442902",
      "Chichpalli B.O": "441224",
      "Chimda B.O": "441224",
      "Kelzar B.O": "441224",
      "Kolsa B.O": "441224",
      "Maroda B.O": "441224",
      "Mindhala B.O": "441205",
      "Navegaon Pandav B.O": "441205",
      "Navkhala B.O": "441205",
      "Vilam B.O": "441205",
      "Gadbori B.O": "441223",
      "Adyal Tekadi B.O": "441206",
      "Gangalwadi B.O": "441206",
      "Kirmitimendha B.O": "441206",
      "Mendki B.O": "441206",
      "Marda B.O": "442402",
      "Durgapur B.O": "442404",
      "Padmapur Rayatwari B.O": "442404",
      "Lakhampur B.O": "442908",
      "Nandpa B.O": "442908",
      "Tekamandava B.O": "442908",
      "Yellapur B.O": "442908",
      "Amboli B.O": "442903",
      "Doma B.O": "442903",
      "Hirapur B.O": "442903",
      "Jamgaon Komti B.O": "442903",
      "Palasgaon Piparda B.O": "442903",
      "Shankarpur B.O": "442903",
      "Borda B.O": "441224",
      "Somnath Prakala B.O": "441224",
      "Kanpa B.O": "441205",
      "Kotgaon B.O": "441205",
      "Sheoni B.O": "441223",
      "Gowardhan B.O": "441226",
      "Padoli B.O": "442406",
      "Chiroli B.O": "441224",
      "Mangali Arab B.O": "441205",
      "Mohali Mokasa B.O": "441205",
      "Paharni B.O": "441205",
      "Girgaon B.O": "441223",
      "Tadali B.O": "442406",
      "Chinchala B.O": "441224",
      "Dongargaon BK B.O": "441205",
      "Navegaon Hundeshwari B.O": "441205",
      "Nachanbhatti B.O": "441223",
      "Ratnapur B.O": "441223",
      "Chandrapur H.O": "442401",
      "Saoli S.O": "441225",
      "Segaon S.O (Chandrapur)": "442906",
      "Shashtrinagar S.O": "442401",
      "Shivjinagar S.O": "442503",
      "Sindewahi S.O": "441222",
      "Talodhi Balapur S.O": "441221",
      "Warora S.O": "442907",
      "Korpana SO": "442916",
      "Pombhurna S.O": "442918",
      "Anandwan S.O": "442914",
      "Bhadrawati S.O": "442902",
      "Cementnagar S.O": "442502",
      "Chandrapur TPS S.O": "442404",
      "Chimur S.O": "442903",
      "Chandrapur City S.O": "442402",
      "H.L.C. S.O": "442507",
      "Pathanpura S.O": "442402",
      "Babupeth S.O": "442403",
      "Ballarpur S.O": "442701",
      "Rajoli S.O (Chandrapur)": "441212",
      "Rajura (M) S.O": "442905",
      "MIDC (P) S.O": "442406",
      "Mul S.O": "441224",
      "Nawargaon S.O": "441223",
      "Neri S.O": "442904",
      "Pathari S.O (Chandrapur)": "441215",
      "Awalpur Cement Project S.O": "442917",
      "Ballarpur Paper Mill S.O": "442901",
      "Bembal S.O": "441226",
      "Bramhapuri S.O": "441206",
      "Chandrapur Ord Fact S.O": "442501",
      "Chandur S.O (Chandrapur)": "442908",
      "Ghugus Colliery S.O": "442505",
      "Gondpipri S.O": "442702",
      "Nagbhid S.O": "441205"
    },
    "OSMANABAD": {
      "Nilegaon B.O": "413603",
      "Omerga Chivari B.O": "413603",
      "Shahapur B.O": "413603",
      "Sukta B.O": "413504",
      "Uloop B.O": "413504",
      "Walwad B.O": "413504",
      "Wanjarwadi B.O": "413504",
      "Dhanuri B.O": "413604",
      "Ekurga B.O": "413604",
      "Jakekur B.O": "413604",
      "Kaldeo Nimbala B.O": "413604",
      "Upla (M) B.O": "413582",
      "Kamegaon B.O": "413582",
      "Wadgaon (S) B.O": "413582",
      "Ghatangri B.O": "413582",
      "Rajuri B.O": "413582",
      "Sanja B.O": "413582",
      "Chivari B.O": "413603",
      "Itkal B.O": "413603",
      "Keshegaon B.O": "413506",
      "Bamniwadi B.O": "413506",
      "Patoda B.O": "413506",
      "Ashta B.O": "413504",
      "Jamb B.O": "413504",
      "Mankeshwar B.O": "413504",
      "Sawargaon B.O": "413504",
      "Songiri B.O": "413504",
      "Ware Wadgaon B.O": "413504",
      "Balsur B.O": "413604",
      "Koral B.O": "413604",
      "Salegaon B.O": "413604",
      "Tavshigad B.O": "413604",
      "Sarola Bk B.O": "413582",
      "Ansurda B.O": "413582",
      "Darphal B.O": "413582",
      "Medsinga B.O": "413582",
      "Alani B.O": "413582",
      "Ruibhar B.O": "413582",
      "Samudrawani B.O": "413582",
      "Katgaon B.O": "413603",
      "Khudawadi B.O": "413603",
      "Yeoti B.O": "413509",
      "Bamni B.O": "413506",
      "Takviki B.O": "413506",
      "Antarwali B.O": "413504",
      "Jawala (Nizamudin) B.O": "413504",
      "Pathrud B.O": "413504",
      "Sirsav B.O": "413504",
      "Ashta (Kasar) B.O": "413604",
      "Makani B.O": "413604",
      "Nipani B.O": "413534",
      "Wathoda B.O": "413510",
      "Chilwadi B.O": "413582",
      "Ambejavalge B.O": "413582",
      "Surdi B.O": "413582",
      "Bavi B.O": "413582",
      "Padoli B.O": "413510",
      "Shingoli B.O": "413582",
      "Waruda B.O": "413582",
      "Mendha B.O": "413582",
      "Gad (Sonegaon) B.O": "413582",
      "Kangara B.O": "413506",
      "Chinchpur Dhage B.O": "413504",
      "Deolali B.O": "413508",
      "Ganegaon B.O": "413504",
      "Hadongri B.O": "413504",
      "Pat Sangvi B.O": "413504",
      "Toramba B.O": "413604",
      "Naigaon B.O": "413510",
      "Hagloor B.O": "413601",
      "Kakramba B.O": "413601",
      "Tirth kh. B.O": "413601",
      "Wadgaon Lakh B.O": "413601",
      "Ghodki B.O": "413503",
      "Kunthalgiri B.O": "413503",
      "Pardi B.O": "413503",
      "Saramkundi B.O": "413503",
      "Wadgaon Jahagir B.O": "413405",
      "Gojwada B.O": "413525",
      "Gour B.O": "413525",
      "Pangaon (YRM) B.O": "413525",
      "Sapnai B.O": "413525",
      "Terkheda B.O": "413525",
      "Barul B.O": "413601",
      "Dharur B.O": "413601",
      "Tirth Bk. B.O": "413601",
      "Wadgaon Deo. B.O": "413601",
      "Dasmegaon B.O": "413503",
      "Izora B.O": "413503",
      "Pimpalgaon Lingi B.O": "413503",
      "Tandulwadi (Vasi) B.O": "413503",
      "Wagholi (YDS) B.O": "413405",
      "Indapur B.O": "413525",
      "Ratnapur B.O": "413525",
      "Deosinga B.O": "413601",
      "Gandhora B.O": "413601",
      "Mangrool (TJR) B.O": "413601",
      "Salgara Divti B.O": "413601",
      "Satephal B.O": "413405",
      "Kadaknathwadi B.O": "413525",
      "Arali Bk. B.O": "413601",
      "Arali Khurd B.O": "413601",
      "Kilaj B.O": "413601",
      "Kumbhari B.O": "413601",
      "Nanduri B.O": "413601",
      "Chorakhali B.O": "413405",
      "Kasbe Tadvale B.O": "413405",
      "Bavi (YRM) B.O": "413525",
      "Dahiphal B.O": "413525",
      "Wagholi B.O": "413582",
      "Kajala B.O": "413582",
      "Pimpari B.O": "413582",
      "Pohner B.O": "413582",
      "Kini B.O": "413582",
      "Chikhali B.O": "413582",
      "Harwargaon B.O": "413507",
      "Moha B.O": "413507",
      "Para B.O": "413507",
      "Pimpalgaon (Kothawale) B.O": "413507",
      "Sarola Mandva B.O": "413507",
      "Nagur B.O": "413608",
      "Deokurali B.O": "413623",
      "Pimpla Khurd B.O": "413623",
      "Kothali B.O": "413605",
      "Sundarwadi B.O": "413605",
      "Achler B.O": "413602",
      "Borgaon (NLD) B.O": "413602",
      "Hangarga (NLD) B.O": "413602",
      "Sindgaon (NLD) B.O": "413602",
      "TBSSK Naldurg B.O": "413602",
      "Nai Chakur B.O": "413606",
      "Narangwadi B.O": "413606",
      "Peth Sangvi B.O": "413606",
      "Sastur B.O": "413606",
      "Turori B.O": "413606",
      "Loni B.O": "413502",
      "Wakadi B.O": "413502",
      "Wangi Bk. B.O": "413502",
      "Awad Shirpura B.O": "413528",
      "Chinchpur Bk. B.O": "413505",
      "Domgaon B.O": "413505",
      "Kukadgaon B.O": "413505",
      "Shelgaon(Sonari) B.O": "413505",
      "Tandulwadi (Sonari) B.O": "413505",
      "Palsap B.O": "413509",
      "Tugaon B.O": "413508",
      "Yenegur B.O": "413604",
      "Dhorala B.O": "413508",
      "Ghatpimpri B.O": "413534",
      "Lanjeshwar B.O": "413534",
      "Pakhrud B.O": "413534",
      "Borda B.O": "413507",
      "Deodhanora B.O": "413507",
      "Govindpur B.O": "413507",
      "Karanjkalla B.O": "413507",
      "Khamaswadi B.O": "413507",
      "Sawargaon Kati B.O": "413624",
      "Bhatangli B.O": "413608",
      "Hipparga Rava B.O": "413608",
      "Kasti Bk. B.O": "413608",
      "Mardi B.O": "413608",
      "Sangvi Kati B.O": "413623",
      "Sangvi Mardi B.O": "413623",
      "Lohgaon B.O": "413602",
      "Morta B.O": "413602",
      "Nandgaon B.O": "413602",
      "Wagdari (NLD) B.O": "413602",
      "Gunjoti B.O": "413606",
      "Kadher B.O": "413606",
      "Kasagi B.O": "413606",
      "Kawatha (OMG) B.O": "413606",
      "Antargaon B.O": "413502",
      "Kapilapuri B.O": "413502",
      "Khasapuri B.O": "413502",
      "Khasgaon B.O": "413502",
      "Lakhangaon B.O": "413526",
      "Pimpalgaon Kamleshwari B.O": "413526",
      "Ambhi B.O": "413505",
      "Anala B.O": "413505",
      "Arani B.O": "413509",
      "Bukanwadi B.O": "413509",
      "Hingalajwadi B.O": "413509",
      "Jagaji B.O": "413509",
      "Apsinga B.O": "413601",
      "Khamgaon B.O": "413508",
      "Malkaranja B.O": "413508",
      "Andora B.O": "413507",
      "Bhatsirpura B.O": "413507",
      "Jawala Kh. B.O": "413507",
      "Mandva B.O": "413507",
      "Massa Khandeshwari B.O": "413507",
      "Hipperga Sayad B.O": "413608",
      "Karajkheda B.O": "413608",
      "Wadgaon (G) B.O": "413608",
      "Suratgaon B.O": "413623",
      "Tamalwadi B.O": "413623",
      "Belamb B.O": "413605",
      "Chincholi Bhuyar B.O": "413605",
      "Jalkot (NLD) B.O": "413602",
      "Bedga B.O": "413606",
      "Diggi B.O": "413606",
      "Kolsur B.O": "413606",
      "Kunhali B.O": "413606",
      "Malgi B.O": "413606",
      "Trikoli B.O": "413606",
      "Arangaon B.O": "413502",
      "Bawachi B.O": "413502",
      "Ida Pida B.O": "413502",
      "Pach Pimpla B.O": "413502",
      "Pimpalwadi B.O": "413502",
      "Hatola B.O": "413526",
      "Kothala B.O": "413528",
      "Kandari B.O": "413505",
      "Bhandarwadi B.O": "413509",
      "Irla B.O": "413509",
      "Kond B.O": "413509",
      "Sumbha B.O": "413509",
      "Khed B.O": "413508",
      "Itkur B.O": "413507",
      "Kanherwadi B.O": "413507",
      "Lohata (East) B.O": "413507",
      "Mangrool B.O": "413507",
      "Selu B.O": "413507",
      "Masla Khurd B.O": "413624",
      "Jewali B.O": "413608",
      "Kanegaon B.O": "413608",
      "Sindphal B.O": "413623",
      "Wadgaon Kati B.O": "413623",
      "Aloor B.O": "413605",
      "Bhusani B.O": "413605",
      "Kesar Javalga B.O": "413605",
      "Dastapur B.O": "413602",
      "Horti B.O": "413602",
      "Salgara Maddi B.O": "413602",
      "Aurad B.O": "413606",
      "Chincholi Jahagir B.O": "413606",
      "Madaj B.O": "413606",
      "Mulaj B.O": "413606",
      "Talmod B.O": "413606",
      "Asu B.O": "413502",
      "Shirala B.O": "413502",
      "Girwali B.O": "413526",
      "Ghargaon B.O": "413528",
      "Ranjani B.O": "413528",
      "Sawargaon (Shiradhon) B.O": "413528",
      "Donja B.O": "413505",
      "Rohkal B.O": "413505",
      "Watephal B.O": "413505",
      "Nitali B.O": "413509",
      "Wanewadi B.O": "413509",
      "Osmanabad H.O": "413501",
      "Bhoom S.O": "413504",
      "Lohara S.O": "413608",
      "Yedshi S.O": "413405",
      "Andora S.O": "413603",
      "Bhavani Mandir Tuljapur S.O": "413601",
      "Dhoki S.O": "413508",
      "Kati S.O": "413624",
      "Omerga Bazar S.O": "413606",
      "Osmanabad Town S.O": "413501",
      "Ter S.O": "413509",
      "Vidyanagar S.O (Osmanabad)": "413501",
      "Bembli S.O": "413506",
      "Dalimb S.O": "413604",
      "Kallam S.O": "413507",
      "Naldurg S.O": "413602",
      "Omerga S.O": "413606",
      "Pargaon S.O": "413526",
      "Tuljapur S.O": "413601",
      "Anandnagar S.O (Osmanabad)": "413582",
      "Ieet S.O": "413534",
      "Malumbra S.O": "413623",
      "Murum S.O": "413605",
      "Paranda S.O": "413502",
      "Shiradhon S.O": "413528",
      "Sonari S.O (Osmanabad)": "413505",
      "Mily Colony S.O": "413501",
      "Vashi S.O (Osmanabad)": "413503",
      "Yermala S.O": "413525"
    },
    "SATARA": {
      "Ambale B.O": "415014",
      "Avarde B.O": "415014",
      "Bambawade B.O": "415014",
      "Murud B.O": "415014",
      "Nune B.O": "415022",
      "Pal B.O": "415014",
      "Belawade Haveli B.O": "415109",
      "Charegaon B.O": "415109",
      "Korivale B.O": "415109",
      "Marali(Chore) B.O": "415109",
      "Talbid B.O": "415109",
      "Tasavade B.O": "415109",
      "Thomase B.O": "415109",
      "Urul B.O": "415109",
      "Ambawade B.O": "415013",
      "Bannawadi Colony B.O": "415124",
      "Shapur B.O": "415115",
      "Shirawade B.O": "415115",
      "Dare Khurd B.O": "415020",
      "Raigaon B.O": "415020",
      "Saigaon B.O": "415020",
      "Kanur B.O": "412804",
      "Mol (Diskal) B.O": "415504",
      "Karnawadi B.O": "412802",
      "Loham B.O": "412802",
      "Morve B.O": "412802",
      "Shivajinagar B.O": "412802",
      "Chanchali B.O": "415021",
      "Jamb Khurd B.O": "415021",
      "Shendurjane B.O": "412803",
      "Borjaiwadi B.O": "415501",
      "Chimangaon B.O": "415501",
      "Ekambe B.O": "415501",
      "Bamnoli Tarf Kudal B.O": "415514",
      "Bhiwadi B.O": "415514",
      "Vihe B.O": "415114",
      "Ghot B.O": "415014",
      "Kadavebudruk B.O": "415014",
      "Savarghar B.O": "415014",
      "Vajroshi B.O": "415014",
      "Chore B.O": "415109",
      "Kalgaon(Umbraj) B.O": "415109",
      "Shirgaon(Umbraj) B.O": "415109",
      "Vadgaon B.O": "415109",
      "Mandave B.O": "415519",
      "Pingali BK B.O": "415506",
      "Karve B.O": "415124",
      "Kodoli(Karad) B.O": "415124",
      "Varunji B.O": "415124",
      "Vadoli Nileshwar B.O": "415115",
      "Ghadgewadi B.O": "415537",
      "Kharshi B.O": "415514",
      "Morghar B.O": "415020",
      "Majgaon B.O": "415520",
      "Kulakjai B.O": "415503",
      "Ranashingwadi B.O": "415503",
      "Shripalvan B.O": "415503",
      "Dhawad Wadi B.O": "412802",
      "Bhurkawadi B.O": "415505",
      "Dharpudi B.O": "415505",
      "Bhadale B.O": "415021",
      "Kikali B.O": "415530",
      "Kanher Khed B.O": "415501",
      "Kumathe B.O": "415501",
      "Lhasurne B.O": "415501",
      "Rui B.O": "415501",
      "Vardhangad B.O": "415501",
      "Humgaon B.O": "415514",
      "Valuth B.O": "415514",
      "Bhosare B.O": "415527",
      "Dhoroshi B.O": "415014",
      "Jalav B.O": "415014",
      "Rahude B.O": "415014",
      "Tondoshi B.O": "415014",
      "Indoli B.O": "415109",
      "Korti B.O": "415109",
      "Gursale B.O": "415506",
      "Padegaon B.O": "415521",
      "Kapil Goleshwar B.O": "415124",
      "Khodshi B.O": "415124",
      "Kapshi B.O": "415537",
      "Mahigaon B.O": "415020",
      "Mardhe B.O": "415020",
      "Virmade B.O": "415020",
      "Varne B.O": "415019",
      "Koparde B.O": "415518",
      "Venegaon B.O": "415518",
      "Vetane B.O": "415503",
      "Bawada B.O": "412802",
      "Kanheri B.O": "412802",
      "Daruj B.O": "415505",
      "Ambawade S Koregaon B.O": "415021",
      "Hivare B.O": "415021",
      "Bhose B.O": "415501",
      "Chinchaner S. Nimb B.O": "415501",
      "Jamb Budruk B.O": "415501",
      "Katahapur B.O": "415501",
      "Nigadi B.O": "415501",
      "Hateghar B.O": "415514",
      "Karandi (Kudal) B.O": "415514",
      "Sanpane B.O": "415514",
      "Songaon B.O": "415523",
      "Vihe Vasahat B.O": "415114",
      "Kalambe B.O": "415022",
      "Maloshi B.O": "415014",
      "Perale B.O": "415109",
      "Shirsawadi B.O": "415506",
      "Tadavale(Vaduj) B.O": "415506",
      "Wakeshwar B.O": "415506",
      "Mundhe B.O": "415124",
      "Parle B.O": "415124",
      "Saidapur B.O": "415124",
      "Vadgaon Haveli B.O": "415124",
      "Vahagaon B.O": "415124",
      "Chachegaon B.O": "415122",
      "Yeravale B.O": "415122",
      "Koparde Haveli B.O": "415115",
      "Adarki Khurd B.O": "415537",
      "Bibi B.O": "415537",
      "Kameri B.O": "415019",
      "Khojewadi B.O": "415518",
      "Pande B.O": "415515",
      "Lalgun B.O": "415503",
      "Rajapuri(Budh) B.O": "415503",
      "Shinde Khurd B.O": "415503",
      "Chandak B.O": "415536",
      "Gulumb B.O": "415536",
      "Ahire B.O": "412802",
      "Asawali B.O": "412802",
      "Atit B.O": "415519",
      "Jakhangaon B.O": "415505",
      "Jamb(Khatav) B.O": "415505",
      "Jamb (Kikali) B.O": "415530",
      "Shirambe B.O": "415501",
      "Shirdhon B.O": "415501",
      "Tandulwadi B.O": "415501",
      "Triputi B.O": "415501",
      "Sarjapur B.O": "415514",
      "Somardi B.O": "415514",
      "Ambheri B.O": "415511",
      "Vele B.O": "415517",
      "Nandal B.O": "415528",
      "Malgaon B.O": "415011",
      "Palashi (Vaduth) B.O": "415011",
      "Wadhe B.O": "415011",
      "Bhade B.O": "415526",
      "Bholi B.O": "415526",
      "Loni B.O": "415527",
      "Deur B.O": "415524",
      "Tadawale B.O": "415524",
      "Taliye B.O": "415524",
      "Degaon Shirgaon B.O": "412803",
      "Eksare B.O": "412803",
      "Kadegaon B.O": "412803",
      "Khanapur B.O": "412803",
      "Mandhardev B.O": "412803",
      "Vyahali B.O": "412803",
      "Vyajawadi B.O": "412803",
      "Shindewadi B.O": "412801",
      "Rawadi BK B.O": "415528",
      "Nandgaon B.O": "415107",
      "Ambavade S Wagholi B.O": "415011",
      "Arale B.O": "415011",
      "Patkhal B.O": "415011",
      "Arvi B.O": "415116",
      "Nagzari B.O": "415116",
      "Bichukale B.O": "415524",
      "Bhanang B.O": "415022",
      "Kanher akale B.O": "415022",
      "Vele (Kamthi) B.O": "415022",
      "Bhogaon B.O": "412803",
      "Borgaon BK B.O": "412803",
      "Dhavadi B.O": "412803",
      "Ozarde B.O": "412803",
      "Pasarni B.O": "412803",
      "Shirgaon B.O": "412803",
      "Vasole B.O": "412803",
      "Borgaon  Agricultural School B.O": "415519",
      "Sartale B.O": "415513",
      "Dapavadi B.O": "412805",
      "Dahivad B.O": "415013",
      "Kari B.O": "415013",
      "Rajapuri B.O": "415013",
      "Thoseghar B.O": "415013",
      "Andrud B.O": "415523",
      "Barad B.O": "415523",
      "Gunavare B.O": "415523",
      "Nimblak B.O": "415523",
      "Pawar Wadi B.O": "415523",
      "Sonavadi B.O": "415523",
      "Tardaf B.O": "415523",
      "Karanjkhop B.O": "415525",
      "Wagholi B.O": "415525",
      "Katgun B.O": "415502",
      "Ner B.O": "415502",
      "Borgaon B.O": "415519",
      "Nhavi BK B.O": "415511",
      "Hol B.O": "415522",
      "Khed(Wadhe) B.O": "415003",
      "Bhatmarali B.O": "415002",
      "Karandi B.O": "415002",
      "Kondave Satara B.O": "415002",
      "Yevateshwar B.O": "415002",
      "Dhumalwadi B.O": "415010",
      "Naigaon B.O": "415525",
      "Koriwale B.O": "415209",
      "Navadi B.O": "415209",
      "Dervan B.O": "415520",
      "Padloshi B.O": "415520",
      "Bijawadi B.O": "415508",
      "Mohi B.O": "415508",
      "Ranand B.O": "415508",
      "Marali B.O": "415211",
      "Dhamni B.O": "415112",
      "Janugadewadi B.O": "415112",
      "Kalgaon B.O": "415112",
      "Mahind B.O": "415112",
      "Maldan B.O": "415112",
      "Sanbur B.O": "415112",
      "Vanzole B.O": "415112",
      "Virali B.O": "415540",
      "Pimpari (K.Khatav) B.O": "415507",
      "Kasur B.O": "415103",
      "Kolewadi B.O": "415103",
      "Potale B.O": "415103",
      "Padali Ninam B.O": "415519",
      "Saspade B.O": "415519",
      "Shendre B.O": "415519",
      "Vechale B.O": "415519",
      "Asale B.O": "415513",
      "Chindhawali B.O": "415513",
      "Banghar B.O": "415013",
      "Rajale B.O": "415523",
      "Rajuri B.O": "415523",
      "Sangavi B.O": "415523",
      "Sarde B.O": "415523",
      "Upalave B.O": "415523",
      "Vakhari B.O": "415523",
      "Vathar Nimbalkar B.O": "415523",
      "Sap B.O": "415511",
      "Sasurve B.O": "415511",
      "Surali B.O": "415511",
      "Andhari B.O": "415002",
      "Mhavshi B.O": "415206",
      "Munawale B.O": "415002",
      "Petri B.O": "415002",
      "Tetali B.O": "415002",
      "Jalgaon B.O": "415010",
      "Khed (Nandgiri) B.O": "415010",
      "Tadavale S. Koregaon B.O": "415010",
      "Trimali B.O": "415510",
      "Divashi BK B.O": "415209",
      "Sonaichi Wadi B.O": "415209",
      "Jalagewadi B.O": "415520",
      "Keloli B.O": "415520",
      "Andhali B.O": "415508",
      "Bidal B.O": "415508",
      "Mandrulkole B.O": "415112",
      "Mendh B.O": "415112",
      "Salave B.O": "415112",
      "Shantinagar B.O": "415112",
      "Gondavale KHD B.O": "415540",
      "Naravane B.O": "415540",
      "Palshi (Man) B.O": "415540",
      "Pimpri (Man) B.O": "415540",
      "Pachvad B.O": "415312",
      "Banpuri B.O": "415112",
      "Bombale B.O": "415507",
      "Dhondewadi (K. Khatav) B.O": "415507",
      "Galmewadi B.O": "415103",
      "Gharewadi B.O": "415103",
      "Kalawade B.O": "415539",
      "Kasarshirambe B.O": "415539",
      "Nandalapur B.O": "415539",
      "Narayanwadi B.O": "415539",
      "Mandrul Haveli B.O": "415205",
      "Nadoli B.O": "415205",
      "Nisare B.O": "415205",
      "Antavadi B.O": "415106",
      "Morale B.O": "415102",
      "Holichagaon B.O": "415538",
      "Nimsod B.O": "415538",
      "Shenawadi B.O": "415538",
      "Devapur B.O": "415509",
      "Paryanti B.O": "415509",
      "Patole Khadaki B.O": "415509",
      "Pulkoti B.O": "415509",
      "Tarukh B.O": "415103",
      "Rasati B.O": "415207",
      "Atake B.O": "415539",
      "Adul B.O": "415205",
      "Belawade KH B.O": "415205",
      "Yerphale B.O": "415205",
      "Nigadi Masur B.O": "415106",
      "Riswad B.O": "415106",
      "Shamgaon B.O": "415106",
      "Chorade B.O": "415538",
      "Divad B.O": "415509",
      "Hajarmachi B.O": "415105",
      "Karavadi B.O": "415105",
      "Wagheri B.O": "415105",
      "Jinti (Ond) B.O": "415111",
      "Salshirambe B.O": "415111",
      "Tulsan B.O": "415111",
      "Yenpe B.O": "415111",
      "Bondri B.O": "415206",
      "Dixi B.O": "415206",
      "Pimpaloshi B.O": "415206",
      "Tamkane B.O": "415206",
      "Goregaon Vangi B.O": "415512",
      "Vadgaon J.S B.O": "415512",
      "Rethare BK B.O": "415108",
      "Shere B.O": "415108",
      "Tambave B.O": "415114",
      "Kalaj B.O": "415528",
      "Nimbhore B.O": "415528",
      "Asagaon Vasahat B.O": "415011",
      "Pimpode KH B.O": "415011",
      "Kiroli B.O": "415116",
      "Vikhale B.O": "415312",
      "Dhawadshi B.O": "415022",
      "Bopardi B.O": "412803",
      "Chikhali B.O": "412803",
      "Dhom B.O": "412803",
      "Menavali B.O": "412803",
      "Parkhandi B.O": "412803",
      "Vaigaon B.O": "412803",
      "Velang B.O": "412803",
      "Jaigaon B.O": "415510",
      "Tembu B.O": "415105",
      "Viravade B.O": "415105",
      "Undale B.O": "415111",
      "Yelgaon B.O": "415111",
      "Marul B.O": "415206",
      "Mendhoshi B.O": "415206",
      "Morgiri B.O": "415206",
      "Natoshi B.O": "415206",
      "Kalambi B.O": "415512",
      "Ladegaon B.O": "415512",
      "Palashi B.O": "415512",
      "Rajachekurle B.O": "415512",
      "Arewadi B.O": "415114",
      "Beldare B.O": "415114",
      "Gamewadi B.O": "415114",
      "Mhopre B.O": "415114",
      "Asia Plato B.O": "412805",
      "Bhilar B.O": "412805",
      "Khingar B.O": "412805",
      "Rohot B.O": "415013",
      "Dhaval B.O": "415523",
      "Dhudhebavi B.O": "415523",
      "Girvi B.O": "415523",
      "Gokhali B.O": "415523",
      "Khunte B.O": "415523",
      "Shindenagar B.O": "415523",
      "Somanthali B.O": "415523",
      "Vidani B.O": "415523",
      "Nandawal B.O": "415525",
      "Randulabad B.O": "415525",
      "Rautwadi B.O": "415525",
      "Sarkalwadi. B.O": "415525",
      "Khatgun B.O": "415502",
      "Visapur B.O": "415502",
      "Apshinge (Rahimatpur) B.O": "415511",
      "Are B.O": "415002",
      "Asangaon B.O": "415002",
      "Palshi B.O": "412801",
      "Wing (Shirwal) B.O": "412801",
      "Surawadi B.O": "415528",
      "Kashil B.O": "415519",
      "Nisrale B.O": "415519",
      "Mhasve B.O": "415513",
      "Udtare B.O": "415513",
      "Ranjani B.O": "412805",
      "Boposhi B.O": "415013",
      "Gajavadi B.O": "415013",
      "Nitral B.O": "415013",
      "Banavadi B.O": "415011",
      "Borkhal B.O": "415011",
      "Revadi B.O": "415011",
      "Shivthar B.O": "415011",
      "Dahigaon B.O": "415524",
      "Morawale B.O": "415022",
      "Abhepuri B.O": "412803",
      "Akoshi B.O": "412803",
      "Asare B.O": "412803",
      "Baleghar B.O": "412803",
      "Gopuj B.O": "415510",
      "Nanegaon BK B.O": "415520",
      "Nanegaon KH B.O": "415520",
      "Shingnapur B.O": "415508",
      "Tondale B.O": "415508",
      "Ambavade KHD B.O": "415112",
      "Gudhe B.O": "415112",
      "Dhondewadi B.O": "415104",
      "Padal B.O": "415507",
      "Palasgaon B.O": "415507",
      "Kumbhargaon B.O": "415103",
      "Mane Wadi B.O": "415103",
      "Saikade B.O": "415103",
      "Talmavale B.O": "415103",
      "Bopoli B.O": "415207",
      "Govare B.O": "415105",
      "Helwak B.O": "415207",
      "Navaja B.O": "415207",
      "Ambrule B.O": "415205",
      "Chikhali(Masur) B.O": "415106",
      "Helgaon B.O": "415106",
      "Kavathe. B.O": "415106",
      "Kival B.O": "415106",
      "Vadjal B.O": "415509",
      "Varkute Mhasvad B.O": "415509",
      "Ghogaon B.O": "415111",
      "Mhasoli B.O": "415111",
      "Savade B.O": "415111",
      "Ghosatawadi B.O": "415206",
      "Keral B.O": "415206",
      "Kokisare B.O": "415206",
      "Kusawade B.O": "415206",
      "Khubi B.O": "415108",
      "Sajjangad B.O": "415013",
      "Asu B.O": "415523",
      "Javli B.O": "415523",
      "Nirgudi B.O": "415523",
      "Pimprad B.O": "415523",
      "Saskal B.O": "415523",
      "Thathavada B.O": "415523",
      "Vadale B.O": "415523",
      "Anapatwadi B.O": "415525",
      "Sonke B.O": "415525",
      "Dhamner B.O": "415511",
      "Pimpari B.O": "415511",
      "Velu B.O": "415511",
      "Jinti B.O": "415522",
      "Kshetra Mahuli B.O": "415003",
      "Bamanoli B.O": "415002",
      "Jakatwadi B.O": "415002",
      "Kumthe B.O": "415002",
      "Ambedare Bk B.O": "415002",
      "Bhaktawadi B.O": "415010",
      "Javale B.O": "412801",
      "Garwade B.O": "415209",
      "Sajur B.O": "415209",
      "Chavanwadi B.O": "415521",
      "Dadholi B.O": "415520",
      "Malawadi B.O": "415508",
      "Mardi B.O": "415508",
      "Pangari B.O": "415508",
      "Vavarhire B.O": "415508",
      "Sonawade B.O": "415211",
      "Jinti. B.O": "415112",
      "Kuthare B.O": "415112",
      "Umarkanchan B.O": "415112",
      "Nandoshi B.O": "415510",
      "Yenkul B.O": "415507",
      "Yeralwadi B.O": "415507",
      "Chikhalewadi B.O": "415103",
      "Kadhane B.O": "415103",
      "Khale B.O": "415103",
      "Yenke B.O": "415103",
      "Agashivnagar B.O": "415539",
      "Belawade BK B.O": "415539",
      "Vathar KH B.O": "415539",
      "Chopadi B.O": "415205",
      "Nade B.O": "415205",
      "Paparde B.O": "415205",
      "Sangvad B.O": "415205",
      "Konegaon B.O": "415106",
      "Padali Masur B.O": "415106",
      "Vadoli Bhikeshwar B.O": "415106",
      "Chitali B.O": "415538",
      "Dhuldev B.O": "415509",
      "Injabav B.O": "415509",
      "Kukudwad B.O": "415509",
      "Varkute Malawadi B.O": "415509",
      "Surli B.O": "415105",
      "Nandgaon (Ond) B.O": "415111",
      "Yeoti B.O": "415111",
      "Ambrag B.O": "415206",
      "Bibi(Patan) B.O": "415206",
      "Divashi Khrud B.O": "415206",
      "Kusrund B.O": "415206",
      "Sadawaghapur B.O": "415206",
      "Yerad B.O": "415206",
      "Yeliv B.O": "415512",
      "Rethare KH B.O": "415108",
      "Shenoli B.O": "415108",
      "Sakurdi B.O": "415114",
      "Vasantgad B.O": "415114",
      "Varud B.O": "415527",
      "Gove B.O": "415015",
      "Kidgaon B.O": "415015",
      "Nagewadi B.O": "415015",
      "Varye B.O": "415015",
      "Khed BK B.O": "415521",
      "Koparde (Lonand) B.O": "415521",
      "Pimpre BK B.O": "415521",
      "Birmani B.O": "412806",
      "Birwadi B.O": "412806",
      "Gavdoshi B.O": "412806",
      "Gogave B.O": "412806",
      "Taldeo B.O": "412806",
      "Tapola B.O": "412806",
      "Alewadi B.O": "415012",
      "Asani B.O": "415012",
      "Mhate BK B.O": "415012",
      "Mamurdi B.O": "415012",
      "Mohat. B.O": "415012",
      "Salpe B.O": "415521",
      "Tambave (Lonand) B.O": "415521",
      "Harchandi B.O": "412806",
      "Kumbhroshi B.O": "412806",
      "Met Gutad B.O": "412806",
      "Pratapgad B.O": "412806",
      "Sonat B.O": "412806",
      "Zanzwad B.O": "412806",
      "Kedambe B.O": "415012",
      "Kelghar B.O": "415012",
      "Kusumbi B.O": "415012",
      "Kodoli B.O": "415004",
      "Mouje Tasgaon B.O": "415004",
      "Nigadi Tarf B.O": "415004",
      "Vilaspur Satara B.O": "415004",
      "Bharatgaon Wadi B.O": "415519",
      "Bhatghar B.O": "412206",
      "Kokrale B.O": "415527",
      "Andori B.O": "415521",
      "Mariaichiwadi B.O": "415521",
      "Sherechiwadi B.O": "415521",
      "Apati B.O": "412806",
      "Kshetra Mahabaleshwar. B.O": "412806",
      "Machutar B.O": "412806",
      "Velapur B.O": "412806",
      "Nidhal B.O": "415023",
      "Dund B.O": "415012",
      "Gavadi B.O": "415012",
      "Varoshi B.O": "415012",
      "Chinchaner Vandan B.O": "415004",
      "Gojegaon B.O": "415004",
      "Kindawadi B.O": "415004",
      "Kumathe Nagache B.O": "415527",
      "Aradgaon B.O": "415521",
      "Hingangaon B.O": "415521",
      "Padali (Lonand) B.O": "415521",
      "Saswad (Lonand) B.O": "415521",
      "Sukhed B.O": "415521",
      "Ahir B.O": "412806",
      "Hatlot B.O": "412806",
      "Kuroshi B.O": "412806",
      "Petpar B.O": "412806",
      "Bibhavi B.O": "415012",
      "Ganje B.O": "415012",
      "Degaon Tambe B.O": "415004",
      "Jihe B.O": "415004",
      "Satara H.O": "415001",
      "Karad H.O": "415110",
      "Chaphal S.O": "415520",
      "Dahivadi S.O": "415508",
      "Daulat Nagar S.O (Satara)": "415211",
      "Karadcity S.O": "415110",
      "Kole S.O (Satara)": "415103",
      "Malkapur Karad S.O": "415539",
      "Mangalwar Peth Karad S.O": "415110",
      "Market Yard Karad S.O": "415110",
      "Marul Haveli S.O": "415212",
      "Mayani S.O": "415102",
      "Ogalewadi S.O": "415105",
      "Ond S.O": "415111",
      "Pusesavali S.O": "415512",
      "Supane S.O": "415114",
      "Vaduj Town S.O": "415506",
      "Yashvantnagar S.O": "415115",
      "Bhuinj S.O": "415515",
      "Dhebewadi S.O": "415112",
      "Kale S.O (Satara)": "415104",
      "Mhasvad S.O": "415509",
      "Tarale S.O": "415014",
      "Umbraj S.O": "415109",
      "Adarki BK S.O": "415537",
      "Angapur Vandan S.O": "415019",
      "Apshinge S.O": "415518",
      "Bavdhan S.O": "412804",
      "Budh S.O": "415503",
      "Budhawar Naka Satara S.O": "415002",
      "Kenjal S.O": "415536",
      "Koregaon S.O": "415501",
      "Aundh S.O": "415510",
      "Kaledhon S.O": "415312",
      "Katarkhatav S.O": "415507",
      "Mhasurne S.O": "415538",
      "Patan S.O (Satara)": "415206",
      "Shivnagar S.O": "415108",
      "Tilak Path Karad S.O": "415110",
      "Vaduj S.O": "415506",
      "Vidyanagar Karad S.O": "415124",
      "Wing S.O": "415122",
      "Anewadi S.O": "415020",
      "Khandala Bavada S.O": "412802",
      "Khatav S.O": "415505",
      "Kuroli Sidheshwar S.O": "415527",
      "Limbgove S.O": "415015",
      "MIDC Satara S.O": "415004",
      "Bahule S.O": "415209",
      "Gondavale BK S.O": "415540",
      "Koyna S.O": "415207",
      "Malharpeth Karad S.O": "415205",
      "Masur S.O (Satara)": "415106",
      "Diskal Mol S.O": "415504",
      "Kavathe S.O": "415516",
      "Kisanveernagar S.O": "415530",
      "Koregaon City S.O": "415501",
      "Kudal S.O (Satara)": "415514",
      "Mahimangad S.O": "415023",
      "Mangalwar Peth Satara S.O": "415002",
      "Market yarad Phaltan S.O": "415523",
      "Panchgani S.O": "412805",
      "Phaltan S.O": "415523",
      "Phulenagar Wai S.O": "412803",
      "Sakharwadi S.O": "415522",
      "Shirval S.O": "412801",
      "Targaon S.O": "415107",
      "Vathar Kiroli S.O": "415116",
      "Wai City S.O": "412803",
      "Yadogopal Peth S.O": "415002",
      "Nagthane S.O": "415519",
      "Pusegaon S.O": "415502",
      "Rahimatpur S.O": "415511",
      "Satara City S.O": "415002",
      "Satararoad S.O": "415010",
      "Shukarwar Peth Phaltan S.O": "415523",
      "Taradgaon S.O": "415528",
      "Vathar S.O": "415524",
      "Lonand S.O": "415521",
      "Pachvad S.O": "415513",
      "Pimpode BK S.O": "415525",
      "Shahupuri Satara S.O": "415002",
      "Wai S.O": "412803",
      "Kinhai S.O": "415021",
      "Kolki S.O (Satara)": "415523",
      "Mahableshwar S.O": "412806",
      "Medha S.O": "415012",
      "Parali S.O": "415013",
      "Sangamnagar Satara S.O": "415003",
      "Surur S.O": "415517",
      "Vaduth S.O": "415011",
      "Vathar BK S.O": "415526",
      "Vennanagar S.O": "415022"
    },
    "GADCHIROLI": {
      "Ankisa B.O": "442504",
      "Arda B.O": "442504",
      "Rangaapalli B.O": "442504",
      "Regunta B.O": "442504",
      "Sironcha Mal B.O": "442504",
      "Tekada B.O": "442504",
      "Vyankatapura B.O": "442705",
      "Ramanoorpur B.O": "442504",
      "Kotapalli B.O": "442504",
      "Somanpalli B.O": "442504",
      "Bhakrondi B.O": "441217",
      "Subhashgram B.O": "442918",
      "Gomani B.O": "442918",
      "Asaralli B.O": "442504",
      "Janampalli B.O": "442504",
      "Narkada B.O": "442504",
      "Vedmahim B.O": "442504",
      "Pentipaga B.O": "442504",
      "Medaram B.O": "442504",
      "Madaram B.O": "442504",
      "Kurundi B.O": "441217",
      "Sawalkheda B.O": "441217",
      "Sukala B.O": "441217",
      "Palasgaon B.O": "441217",
      "Bamni B.O": "442605",
      "Jinganur B.O": "442504",
      "Narayanpur B.O": "442504",
      "Randhampetha B.O": "442504",
      "Tummnor B.O": "442504",
      "Kochampalli B.O": "442504",
      "Kopela B.O": "442504",
      "Teklamotala B.O": "442504",
      "Angara B.O": "441217",
      "Delanwadi B.O": "441217",
      "Sirshi B.O": "441217",
      "Muska B.O": "441217",
      "Khadki B.O": "441217",
      "Navezari B.O": "441217",
      "Vasantpur B.O": "442919",
      "Korla Mal B.O": "442504",
      "Moyabinpetta B.O": "442504",
      "Nagram B.O": "442504",
      "Narsihapalli B.O": "442504",
      "Rameshgudam B.O": "442504",
      "Gommalkonda B.O": "442504",
      "Sirkanda B.O": "442504",
      "Pattagudam B.O": "442504",
      "Ghati B.O": "441217",
      "Kadholi B.O": "441217",
      "Manapur B.O": "441217",
      "Salebatti B.O": "441217",
      "Khambala B.O": "441217",
      "Nawargaon B.O": "441217",
      "Semana B.O": "442605",
      "Kotgad(Kotgal) B.O": "442605",
      "Chapalwada B.O": "442604",
      "Regadi B.O": "442604",
      "Likhatwada B.O": "442604",
      "Dhamrancha B.O": "442709",
      "Madetukum B.O": "442605",
      "Vihirgoan B.O": "442605",
      "Wakdi B.O": "442605",
      "Bhadbhidi B.O": "442604",
      "Chakpetala B.O": "442604",
      "Challewada B.O": "442709",
      "Dechalipeta B.O": "442709",
      "Hirapur B.O": "442605",
      "Rajaram B.O": "442709",
      "Bedgaon B.O": "441209",
      "Bethakathi B.O": "441209",
      "Chandagad B.O": "441209",
      "Girgaon(Gilgaon) B.O": "442605",
      "Makepalli B.O": "442604",
      "Vikaspalli B.O": "442604",
      "Gudigudam B.O": "442709",
      "Marpalli B.O": "442709",
      "Armurkasa B.O": "441209",
      "Botekasa B.O": "441209",
      "Jimalgatta B.O": "442709",
      "Kokdi B.O": "441207",
      "Kondali B.O": "441207",
      "Deulgoan B.O": "441207",
      "Chatgaon B.O": "442606",
      "Chavela B.O": "442606",
      "Dudhmala B.O": "442606",
      "Gatta B.O": "442704",
      "Muramgaon B.O": "442606",
      "Koregaon B.O": "441207",
      "Sawangi B.O": "441207",
      "Gurnoli BO": "441207",
      "Artondi BO": "441207",
      "Jarawandi B.O": "442606",
      "Mendhatola B.O": "442606",
      "Pendhari B.O": "442606",
      "Khedi B.O": "442606",
      "Jappi B.O": "442606",
      "Sawanga B.O": "442606",
      "Bhapada B.O": "442606",
      "Durgapur B.O": "442606",
      "Lekha B.O": "442606",
      "Udera B.O": "442704",
      "Gurupalli B.O": "442704",
      "Bodhali B.O": "442605",
      "Deloda B.O": "442605",
      "Jepra B.O": "442605",
      "Maushi Khamb B.O": "442605",
      "Nagrinavegaon B.O": "442605",
      "Porla B.O": "442605",
      "Karpundi B.O": "442605",
      "Dibhana B.O": "442605",
      "Devipur Camp BO": "442605",
      "Vihirgaon B.O": "441207",
      "Visora B.O": "441207",
      "Wadegaon B.O": "441207",
      "Tulsi B.O": "441207",
      "Mohali B.O": "442606",
      "Sawargaon B.O": "442606",
      "Sode B.O": "442606",
      "Girola BO": "442606",
      "Pulkhal B.O": "442606",
      "Morchul B.O": "442606",
      "Arjuni B.O": "442606",
      "Bhimpur B.O": "442606",
      "Ghotsur B.O": "442704",
      "Gogaon B.O": "442605",
      "Guruwala B.O": "442605",
      "Jambhali B.O": "442605",
      "Wadadha B.O": "442605",
      "Yeoli B.O": "442605",
      "Kosami B.O": "442606",
      "Sakhera B.O": "442606",
      "Koregoan B.O": "442606",
      "Jambhali (b)  B.O": "442606",
      "Kurumwada B.O": "442606",
      "Nimgaon B.O": "442604",
      "Pauni B.O": "442604",
      "Jivangatta B.O": "442704",
      "Kasansur B.O": "442704",
      "Kothami B.O": "442704",
      "Ambeshioni B.O": "442605",
      "Amirza B.O": "442605",
      "Kaneri B.O": "442605",
      "Mudza B.O": "442605",
      "Murmadi B.O": "442605",
      "Pardikupi B.O": "442605",
      "Shioni B.O": "442605",
      "Indaram B.O": "442705",
      "Khamancheru B.O": "442705",
      "Lagam B.O": "442705",
      "Mahagaon BK B.O": "442705",
      "Venkatraopetta B.O": "442705",
      "Kothari B.O": "442705",
      "Kasampeth B.O": "442703",
      "Nagepalli B.O": "442703",
      "Chamorshi BK BO": "441208",
      "Kasawi BO": "441208",
      "Pathargota B.O": "441208",
      "Ankhoda B.O": "442707",
      "Chandankhedi B.O": "442707",
      "Chaudampalli B.O": "442707",
      "Chittaranjan B.O": "442707",
      "Yenapur B.O": "442707",
      "Chinchpundi B.O": "442705",
      "Kristapur B.O": "442703",
      "Churmura B.O": "441208",
      "Deulgaon B.O": "441208",
      "Thanegaon B.O": "441208",
      "Ganpur Rayatwari B.O": "442707",
      "Koparalli B.O": "442707",
      "Mudholi Chak No. Ii B.O": "442707",
      "Manne Rajaram B.O": "442710",
      "Permelli B.O": "442710",
      "Tadgaon B.O": "442710",
      "Bori B.O": "441209",
      "Devalmari B.O": "442705",
      "Chutuguntha B.O": "442705",
      "Govindpur B.O": "442703",
      "Jogisakhara B.O": "441208",
      "Adapalli B.O": "442707",
      "Jairampur B.O": "442707",
      "Konsari B.O": "442707",
      "Thakri B.O": "442707",
      "Kandoli B.O": "442710",
      "Kurud B.O": "442603",
      "Shankarpur BO": "441207",
      "Dubbaguda B.O": "442710",
      "Palle B.O": "442710",
      "Kudakodi B.O": "442710",
      "Kodari B.O": "442710",
      "Yechali B.O": "442710",
      "Gothankandi B.O": "442710",
      "Malankodur B.O": "442710",
      "PALI B.O": "442710",
      "Irasgumme B.O": "442710",
      "Arenda B.O": "442710",
      "Amgaon (Mal) B.O": "442603",
      "Murkhada Chak B.O": "442603",
      "Pavimuranda B.O": "442603",
      "Sonapur B.O": "442603",
      "Gilgaon(zamindari) B.O": "442603",
      "Andhali B.O": "441207",
      "Tekla B.O": "442710",
      "Halewar B.O": "442710",
      "Kunghada B.O": "442603",
      "Lakhamapur  Bori B.O": "442603",
      "Markanda Deo B.O": "442603",
      "Yedanur B.O": "442603",
      "Dhargaon B.O": "442603",
      "Wakdijuni B.O": "442603",
      "Dongarmendha BO": "441207",
      "Heti B.O": "442606",
      "Karwafa B.O": "442606",
      "Rangi B.O": "442606",
      "Yerkad B.O": "442606",
      "Japtalai B.O": "442606",
      "Gyaraptti B.O": "442606",
      "Ranveli B.O": "442606",
      "Toyagondi B.O": "442606",
      "Nawargoan B.O": "442606",
      "Palasgav B.O": "442606",
      "Mohgoan B.O": "442606",
      "Burgi B.O": "442704",
      "Geda B.O": "442704",
      "Todsa B.O": "442704",
      "Tumurgunda B.O": "442704",
      "Sewari B.O": "442704",
      "Churchura B.O": "442605",
      "Sakhara B.O": "442605",
      "Wasa B.O": "442605",
      "Darli BO": "442605",
      "Katali  Hitachal  BO": "442605",
      "Talodhi Mokasa B.O": "442603",
      "Vishnupur B.O": "442603",
      "Wagholi B.O": "442603",
      "Ramala B.O": "442603",
      "Kalamgaon B.O": "442603",
      "Chikhli B.O": "441207",
      "Gewardha B.O": "441207",
      "Dampur B.O": "442705",
      "Wangepalli B.O": "442705",
      "Vatra B.O": "442705",
      "Estapur B.O": "442705",
      "Elgur B.O": "442703",
      "Medpalli B.O": "442703",
      "Arsoda B.O": "441208",
      "Shioni BK B.O": "441208",
      "Wasala B.O": "441208",
      "Gundapalli B.O": "442707",
      "Kalinagar B.O": "442707",
      "Khudirampalli B.O": "442707",
      "Markhanda (K) B.O": "442707",
      "Adyal B.O": "442707",
      "Kurumwelli B.O": "442710",
      "Talegaon B.O": "441209",
      "Chilamtola B.O": "441209",
      "Dawadi B.O": "441209",
      "Shendepar B.O": "441209",
      "Kulkuli B.O": "441209",
      "Bamani B.O": "441209",
      "Kanewada B.O": "442710",
      "Yermana B.O": "442710",
      "Koti B.O": "442710",
      "Laheri B.O": "442710",
      "Bhendala B.O": "442603",
      "Murkhada B.O": "442603",
      "Murmuri B.O": "442603",
      "Navegaon Rayatwari B.O": "442603",
      "Potegaon B.O": "442603",
      "Walsara B.O": "442603",
      "Fharada B.O": "442603",
      "Malleramal B.O": "442603",
      "Sakela B.O": "442603",
      "Haldimal B.O": "442603",
      "Amgaon Buti B.O": "441207",
      "Malewada B.O": "441209",
      "Masali B.O": "441209",
      "Nanhi B.O": "441209",
      "Palasgad B.O": "441209",
      "Jambhulkheda BO": "441209",
      "Dadapur BO": "441209",
      "Lendaritola BO": "441209",
      "Khobramendha B.O": "441209",
      "Antargav B.O": "441209",
      "Chotimadai(ChotiMadhe) B.O": "441209",
      "Gajegoan B.O": "441209",
      "Maldugi B.O": "441209",
      "Charbhatti B.O": "441209",
      "Korchi B.O": "441209",
      "Ramgarh B.O": "441209",
      "Sursundi B.O": "441209",
      "Yengalkheda B.O": "441209",
      "Motgoan(Mohgoan) B.O": "441209",
      "Kohaka B.O": "441209",
      "Antargaon B.O": "441209",
      "Ganuli B.O": "441209",
      "Moushi B.O": "441209",
      "Gothangaon B.O": "441209",
      "Kotgul B.O": "441209",
      "Kotra B.O": "441209",
      "Purada B.O": "441209",
      "Sonsari B.O": "441209",
      "Tuchanhar(Tutekanhar) B.O": "441209",
      "Kulgondi(Fulgondi) B.O": "441209",
      "Morkekasa(Markekasa) B.O": "441209",
      "Chirchedi B.O": "441209",
      "Dongargav B.O": "441209",
      "Mulchera SO": "442919",
      "Sironcha S.O": "442504",
      "Vairagadh S.O": "441217",
      "Navegaon SO": "442605",
      "Aheri S.O": "442705",
      "Allapalli S.O": "442703",
      "Ghot S.O": "442604",
      "Bhamragadh S.O": "442710",
      "Chamorshi S.O": "442603",
      "Gadchiroli Coll S.O": "442605",
      "Gadchiroli S.O": "442605",
      "Kamlapur S.O (Gadchiroli)": "442709",
      "Armori S.O": "441208",
      "Ashti S.O (Gadchiroli)": "442707",
      "Desaiganj S.O": "441207",
      "Dhanora S.O": "442606",
      "Ettapalli S.O": "442704",
      "Kurkheda S.O": "441209"
    },
    "LATUR": {
      "Atola B.O": "413524",
      "Bholegaon B.O": "413524",
      "Kharosa B.O": "413521",
      "Kokalgaon B.O": "413521",
      "Shivani Lakh B.O": "413521",
      "Sihdhakhed B.O": "413521",
      "Harwadi B.O": "413527",
      "Kharola B.O": "413527",
      "Morwad B.O": "413527",
      "Poharegaon B.O": "413527",
      "Sindhgaon B.O": "413527",
      "Ankulga Sayed B.O": "413544",
      "Dhamangaon B.O": "413514",
      "Sakol B.O": "413544",
      "Harangul BK B.O": "413531",
      "Harangul KH B.O": "413531",
      "Hasegaon B.O": "413531",
      "Hippalgaon B.O": "413514",
      "Holi B.O": "413531",
      "Jewali B.O": "413531",
      "Sawargaon B.O": "413517",
      "Wasangaon B.O": "413531",
      "Awalkonda B.O": "413517",
      "Lohara B.O": "413517",
      "Loni B.O": "413517",
      "Malewadi B.O": "413517",
      "Malkapur B.O": "413517",
      "Mogha B.O": "413517",
      "Togri B.O": "413517",
      "Tondar B.O": "413517",
      "Tondchira B.O": "413517",
      "Sindala Shivpur B.O": "413524",
      "Gunjarga B.O": "413521",
      "Jewari B.O": "413521",
      "Rathoda B.O": "413521",
      "Yelnoor B.O": "413521",
      "Lambota B.O": "413530",
      "Shirol Wanjarwada B.O": "413530",
      "Bittergaon B.O": "431522",
      "Borgaon Dargi B.O": "413527",
      "Gharsoli B.O": "413527",
      "Motegaon B.O": "413527",
      "Wangdhari B.O": "413527",
      "Halki B.O": "413544",
      "Lakadjawalga B.O": "413544",
      "Thergaon B.O": "413524",
      "Ujlamb B.O": "413524",
      "Dhanora B.O": "413523",
      "Madansuri B.O": "413521",
      "Nanand B.O": "413521",
      "Talikhed B.O": "413521",
      "Kelgaon B.O": "413530",
      "Bhokrama B.O": "413527",
      "Mahapur B.O": "413527",
      "Hismabad B.O": "413544",
      "Kallambgaon B.O": "413544",
      "Hadolti B.O": "413514",
      "Wanjarwada B.O": "413514",
      "Bori B.O": "413531",
      "Gangapur B.O": "413531",
      "Kasarkheda B.O": "413531",
      "Kawa B.O": "413531",
      "Peth B.O": "413531",
      "Banshelki B.O": "413517",
      "Her B.O": "413517",
      "Kallur B.O": "413517",
      "Kumtha KH B.O": "413517",
      "Nalgir B.O": "413517",
      "Somnathpur B.O": "413517",
      "Handargulli B.O": "413518",
      "Nawani B.O": "413518",
      "Janwal B.O": "413529",
      "Yerola B.O": "413544",
      "Chera B.O": "413514",
      "Walsangi B.O": "413514",
      "Chincholi Pan B.O": "413531",
      "Gaur B.O": "413531",
      "Katgaon B.O": "413531",
      "Khadgaon B.O": "413531",
      "Pakharsangvi B.O": "413531",
      "Takali B.O": "413517",
      "Daithana B.O": "413517",
      "Dongarshelki B.O": "413517",
      "Karadkhed B.O": "413517",
      "Nagalgaon B.O": "413517",
      "Shirol Janapur B.O": "413517",
      "Kini Yeladevi B.O": "413518",
      "Shelgaon B.O": "413518",
      "Sukani B.O": "413518",
      "Shivankhed B.O": "413529",
      "Satala B.O": "413523",
      "Dhalegaon B.O": "413523",
      "Kaban Sangvi B.O": "413524",
      "Rapka B.O": "413524",
      "Abulga BK B.O": "413521",
      "Ansarwada B.O": "413521",
      "Bhutmugali B.O": "413521",
      "Hadga B.O": "413521",
      "Shedol B.O": "413521",
      "Shivani Kothal B.O": "413521",
      "Ambegaon Masalga B.O": "413530",
      "Kate Javalga B.O": "413530",
      "Kadepur B.O": "431522",
      "Kamkheda B.O": "431522",
      "Patharwadi B.O": "431522",
      "Talni B.O": "431522",
      "Ghansargaon B.O": "413527",
      "Ajni (BK) B.O": "413544",
      "Akulga Rani B.O": "413544",
      "Jagalpur (BK) B.O": "413514",
      "Kumtha (BK) B.O": "413514",
      "Sawargaon Thot B.O": "413514",
      "Waigaon B.O": "413514",
      "Babhalgaon B.O": "413531",
      "Bhatangali B.O": "413531",
      "Bokangaon B.O": "413531",
      "Lodga B.O": "413531",
      "Manjara SK B.O": "413531",
      "Shivani BK B.O": "413531",
      "Sonwati B.O": "413531",
      "Sugaon B.O": "413531",
      "Dawangaon B.O": "413517",
      "Devarjan B.O": "413517",
      "Dhondi Hipperga B.O": "413517",
      "Dighol B.O": "413517",
      "Rawangaon B.O": "413517",
      "Rohina B.O": "413517",
      "Sambhu Omerga B.O": "413517",
      "Gudsur B.O": "413518",
      "Halli B.O": "413518",
      "Sugaon Mahalang B.O": "413529",
      "Zari B.O": "413529",
      "Koshtgaon B.O": "413523",
      "Sawargaon Rokda B.O": "413515",
      "Tirth B.O": "413515",
      "Chinchondi B.O": "413522",
      "Halgara B.O": "413522",
      "Budhada B.O": "413520",
      "De Vtala B.O": "413520",
      "Haregaon B.O": "413520",
      "Korangala B.O": "413520",
      "Matola B.O": "413520",
      "Ekurga B.O": "413511",
      "Gadwad B.O": "413511",
      "Tandulja B.O": "413511",
      "Tawarajkheda B.O": "413511",
      "Mohnal B.O": "413513",
      "Omerga Court B.O": "413513",
      "Telgaon B.O": "413513",
      "Bolegaon B.O": "413519",
      "Kawathali B.O": "413519",
      "Lasona B.O": "413519",
      "Atnoor B.O": "413532",
      "Deulwadi B.O": "413532",
      "Gutti B.O": "413532",
      "Devangra B.O": "413581",
      "Ganjur B.O": "413581",
      "Mahalangra B.O": "413581",
      "Badur B.O": "413607",
      "Chincali (S) B.O": "413607",
      "Hasori BK B.O": "413607",
      "Ganga Hipparga B.O": "413515",
      "Makani B.O": "413522",
      "Malegaon B.O": "413522",
      "Sawari B.O": "413522",
      "Tadmugali B.O": "413522",
      "Bhada B.O": "413520",
      "Borphal B.O": "413520",
      "Nagarsoga B.O": "413520",
      "Hipperga Kajala B.O": "413515",
      "Parchanda B.O": "413515",
      "Borsuri B.O": "413522",
      "Halsi B.O": "413522",
      "Hosur B.O": "413522",
      "Almala B.O": "413520",
      "Ashiv B.O": "413520",
      "Khuntegaon B.O": "413520",
      "Shivli B.O": "413520",
      "Taka B.O": "413520",
      "Ujani B.O": "413520",
      "Uti (BK) B.O": "413520",
      "Bheta B.O": "413511",
      "Jawala (BK) B.O": "413511",
      "Murud Akola B.O": "413511",
      "Ramegaon B.O": "413511",
      "Rameshwar B.O": "413511",
      "Chapoli B.O": "413513",
      "Hipalner B.O": "413513",
      "Dawan Hipperga B.O": "413519",
      "Sarola B.O": "413520",
      "Chikurda B.O": "413511",
      "Chincholi Ballalnath B.O": "413511",
      "Wagholi B.O": "413511",
      "Wanjarkheda B.O": "413511",
      "Gurnal B.O": "413519",
      "Helamb B.O": "413519",
      "Honali B.O": "413519",
      "Sangam B.O": "413519",
      "Talegaon B.O": "413519",
      "Mangrul B.O": "413516",
      "Ravankola B.O": "413532",
      "Nelwad B.O": "413607",
      "Tambala B.O": "413607",
      "Talani B.O": "413516",
      "Chikhali B.O": "413523",
      "Gondgaon B.O": "413519",
      "Wadmurambi B.O": "413519",
      "Mal Hipperga B.O": "413532",
      "Patoda B.O": "413532",
      "Kasasr Belkunda B.O": "413607",
      "Mudgad Ramling B.O": "413607",
      "Usturi B.O": "413607",
      "Karla B.O": "413516",
      "Kini Thot B.O": "413516",
      "Nadi Hatterga B.O": "413516",
      "Andori B.O": "413523",
      "Chincholi Tapse B.O": "413516",
      "Javali B.O": "413516",
      "Killari S F B.O": "413516",
      "Lamjana B.O": "413516",
      "Mogara B.O": "413516",
      "Nandurga B.O": "413516",
      "Khandali B.O": "413515",
      "Sanghvi B.O": "413515",
      "Hangarga B.O": "413522",
      "Kalmugali B.O": "413522",
      "Belkund B.O": "413520",
      "Jawalga Pomodevi B.O": "413520",
      "Selu B.O": "413520",
      "Tungi(BK) B.O": "413520",
      "Gategaon B.O": "413511",
      "Nevali B.O": "413511",
      "Shirala B.O": "413511",
      "Anjansonda B.O": "413513",
      "Gharani B.O": "413513",
      "Boral B.O": "413519",
      "Chavani Hipperga B.O": "413519",
      "Dhanegaon B.O": "413519",
      "Javalga B.O": "413519",
      "Walandi B.O": "413519",
      "Ghonshi B.O": "413532",
      "Kodli B.O": "413532",
      "Tiruka B.O": "413532",
      "Ashta B.O": "413581",
      "Hari Javalga B.O": "413607",
      "Hatterga Halsi B.O": "413607",
      "Korali B.O": "413607",
      "Shiradhon B.O": "413607",
      "Latur H.O": "413512",
      "JJJKSSK Nalegaon S.O": "413581",
      "Kasarsirsi S.O": "413607",
      "Killari S.O": "413516",
      "Nalegaon S.O": "413524",
      "Pangaon S.O (Latur)": "431522",
      "Ahmedpur S.O (Latur)": "413515",
      "Chakur S.O": "413513",
      "Deoni S.O": "413519",
      "Hatte Road Latur S.O": "413512",
      "Jalkot S.O": "413532",
      "Murud S.O": "413510",
      "Nilanga S.O": "413521",
      "Tilaknagar Latur S.O": "413531",
      "Udgir S.O": "413517",
      "Aurad Shahajani S.O": "413522",
      "Kingaon S.O": "413523",
      "MIDC Latur S.O": "413531",
      "Nitoor S.O": "413530",
      "Shirur Anantpal S.O": "413544",
      "Wadwal Nagnath S.O": "413529",
      "Ausa S.O": "413520",
      "Borgaon S.O (Latur)": "413511",
      "Labour Colony Latur S.O": "413512",
      "Latur Bazar S.O": "413512",
      "Latur RS S.O": "413512",
      "Ramnagar Latur S.O": "413531",
      "Renapur S.O": "413527",
      "Shirur Tajband S.O": "413514",
      "Udgirganj S.O": "413517",
      "Wadhona S.O": "413518"
    },
    "AKOLA": {
      "Mohala B.O": "444101",
      "Panaj B.O": "444101",
      "Popatkheda B.O": "444101",
      "Punda B.O": "444101",
      "Ruikhed B.O": "444101",
      "Sawara B.O": "444101",
      "Umara B.O": "444101",
      "Chondhi B.O": "444511",
      "Viwara B.O": "444511",
      "Khirpuri B.O": "444302",
      "Dhabha B.O": "444401",
      "Kajaleshwar B.O": "444107",
      "Kanheri Sarap B.O": "444401",
      "Deoli B.O": "444102",
      "Dhotardi B.O": "444102",
      "Hatola B.O": "444405",
      "Jamakeshwar B.O": "444405",
      "Kurum B.O": "444106",
      "Madhapuri B.O": "444106",
      "Ramtek B.O": "444106",
      "Kawasa BK B.O": "444101",
      "Kutasa B.O": "444101",
      "Palsod B.O": "444101",
      "Wadali Deshmukh B.O": "444101",
      "Kanheri Gawali B.O": "444302",
      "Alanda B.O": "444401",
      "Lohgad B.O": "444401",
      "Rajankhed B.O": "444401",
      "Jambha B.O": "444102",
      "Kanshioni  B.O": "444102",
      "Kolambi B.O": "444102",
      "Pailpada B.O": "444102",
      "Sanglood B.O": "444102",
      "Rail B.O": "444111",
      "Malkapur B.O": "444004",
      "Chittalwadi B.O": "444103",
      "Wari B.O": "444103",
      "Dongargaon B.O": "444311",
      "Wagha B.O": "444405",
      "Zodga B.O": "444405",
      "Rajnapur Khinkhini  B.O": "444106",
      "Shelubazar Mana B.O": "444106",
      "Hatgaon B.O": "444107",
      "Balegaon B.O": "444117",
      "Pathardi B.O": "444117",
      "Durgwada B.O": "444107",
      "Ghota B.O": "444107",
      "Kanadi B.O": "444107",
      "Lakhpuri B.O": "444107",
      "Mahagaon B.O": "444107",
      "Mangrul Kambe B.O": "444107",
      "Nimbha B.O": "444107",
      "Morgaon Sadijan B.O": "444311",
      "Babhulgaon B.O": "444501",
      "Hirpur B.O": "444107",
      "Kherda Vilegaon B.O": "444107",
      "Sonori B.O": "444107",
      "Hata B.O": "444311",
      "Ural B.O": "444311",
      "Bhandaraj B.O": "444501",
      "Khirkund B.O": "444101",
      "Warud Jaulka B.O": "444101",
      "Charangaon B.O": "444511",
      "Batwadi B.O": "444302",
      "Dagadparwa B.O": "444401",
      "Punoti KD B.O": "444401",
      "Vizora B.O": "444401",
      "Yeranda B.O": "444401",
      "Anvi B.O": "444102",
      "Goregaon B.O": "444102",
      "Kaulkhed B.O": "444102",
      "Nipana B.O": "444102",
      "Palso Badhe B.O": "444102",
      "Hingani KD B.O": "444103",
      "Babhulgaon Jahangir B.O": "444104",
      "Titwa B.O": "444405",
      "Bapori B.O": "444106",
      "Borta B.O": "444106",
      "Pohi B.O": "444106",
      "Ghungshi B.O": "444107",
      "Kanzara B.O": "444107",
      "Kinkhed B.O": "444111",
      "Sirso B.O": "444107",
      "Wai Pargane Mana B.O": "444107",
      "Andura B.O": "444311",
      "Kazikhed B.O": "444311",
      "Channi B.O": "444501",
      "Deori B.O": "444101",
      "Kalwadi B.O": "444101",
      "Ridhora B.O": "444302",
      "Vyala B.O": "444302",
      "Dahigaon Gawande B.O": "444102",
      "Kurankhed B.O": "444102",
      "Morgaon Kakad B.O": "444102",
      "Jaulkhed B.O": "444111",
      "Keliveli B.O": "444111",
      "Chandur B.O": "444004",
      "Khandala B.O": "444109",
      "Saundala B.O": "444103",
      "Talegaon Bazar B.O": "444103",
      "Gudadhi B.O": "444005",
      "Umari B.O": "444005",
      "Midc Shivar B.O": "444104",
      "Shioni  B.O": "444104",
      "Januna B.O": "444405",
      "Kothali B.O": "444405",
      "Bramhi B.O": "444106",
      "Hivara Mana B.O": "444106",
      "Jamathi  B.O": "444106",
      "Anbhora B.O": "444107",
      "Bhatori B.O": "444107",
      "Bahadura B.O": "444311",
      "Karanja Ramzanpur B.O": "444311",
      "Lohara B.O": "444311",
      "Mokha B.O": "444311",
      "Chatari B.O": "444501",
      "Deulgaon Bramhan B.O": "444501",
      "Digras B.O": "444501",
      "Gawandgaon B.O": "444501",
      "Khetri B.O": "444501",
      "Malrajura B.O": "444501",
      "Malsoor B.O": "444501",
      "Bhendi Mahal B.O": "444407",
      "Apoti B.O": "444003",
      "Dapura B.O": "444003",
      "Donwada B.O": "444003",
      "Goregaon KD B.O": "444006",
      "Kapshi  B.O": "444006",
      "Lonagra B.O": "444006",
      "Sindkhed B.O": "444006",
      "Sukoda B.O": "444006",
      "Adsul B.O": "444108",
      "Danapur B.O": "444108",
      "Morgaon Bhakre B.O": "444109",
      "Morzadi B.O": "444109",
      "Pimpalkhuta B.O": "444501",
      "Sasti B.O": "444501",
      "Shirla Andhare B.O": "444501",
      "Umara Balapur B.O": "444501",
      "Chikhalgaon B.O": "444006",
      "Rajanda B.O": "444006",
      "Sangvi Kd B.O": "444006",
      "Belkhed B.O": "444108",
      "Bhamberi B.O": "444108",
      "Hanwadi B.O": "444108",
      "Kheldeshpande B.O": "444108",
      "Malegaon Bazar B.O": "444108",
      "Manabda B.O": "444108",
      "Raundala B.O": "444108",
      "Wadi Adampur B.O": "444108",
      "Warud B.O": "444108",
      "Gaigaon B.O": "444109",
      "Hatrun B.O": "444109",
      "Kalambi Mahagaon B.O": "444109",
      "Khanapur B.O": "444501",
      "Tandali B.O": "444501",
      "Borgaon KD B.O": "444407",
      "Rahit B.O": "444407",
      "Ghusar B.O": "444003",
      "Mhaisang B.O": "444003",
      "Khambora B.O": "444006",
      "Mhaispur B.O": "444006",
      "Nimbhora B.O": "444006",
      "Nimbi Malokar B.O": "444006",
      "Ugawa B.O": "444006",
      "Dahigaon B.O": "444108",
      "Panchgavhan B.O": "444108",
      "Degaon B.O": "444502",
      "Kasura B.O": "444109",
      "Manarkhed B.O": "444109",
      "Paras B.O": "444109",
      "Sawargaon B.O": "444501",
      "Tulanga BK B.O": "444501",
      "Kherda Bhagai B.O": "444407",
      "Patur Nandapur B.O": "444407",
      "Mhatodi B.O": "444003",
      "Wadad B.O": "444003",
      "Agar B.O": "444006",
      "Gandhigram B.O": "444006",
      "Mazod B.O": "444006",
      "Patkhed B.O": "444006",
      "Wairat Rajapur B.O": "444006",
      "Ghodegaon B.O": "444108",
      "Ner B.O": "444108",
      "Ukali Bazar B.O": "444108",
      "Manjari B.O": "444109",
      "Nimkarda B.O": "444109",
      "Adgaon KD B.O": "444126",
      "Akoli Jahangir B.O": "444101",
      "Akolkhed B.O": "444101",
      "Assegaon Bazar B.O": "444101",
      "Danori Panori B.O": "444101",
      "Pimpri Kd B.O": "444126",
      "Bhaurad B.O": "444002",
      "Chandikapur B.O": "444101",
      "Jalgaon Nahate B.O": "444126",
      "Sirsoli B.O": "444126",
      "Gajanan Nagar B.O": "444002",
      "Bordi B.O": "444101",
      "Chohatta B.O": "444101",
      "Akola H.O": "444001",
      "Akot Kut S.O": "444101",
      "Borgaon Manju S.O": "444102",
      "Murtizapur City S.O": "444107",
      "Nimba S.O": "444311",
      "Patur S.O": "444501",
      "Telhara S.O (Akola)": "444108",
      "Vidyutnagar Paras S.O": "444109",
      "Wholesale Kirana Market Sub Post Office, Akola": "444007",
      "Balapur S.O": "444302",
      "Gandhinagar Akola S.O": "444004",
      "Hiwarkhed Ruprao S.O": "444103",
      "Jatharpeth Akola S.O": "444005",
      "Kaulkhed S.O": "444004",
      "Mundgaon S.O": "444117",
      "Akola City S.O": "444002",
      "Akot S.O": "444101",
      "Dahihanda S.O": "444111",
      "Murtizapur S.O": "444107",
      "Pinjar S.O": "444407",
      "Ranpisenagar Akola S.O": "444001",
      "Shivaji Park Akola S.O": "444003",
      "Tajnapeth Akola S.O": "444006",
      "Adgaon Bk S.O": "444126",
      "Alegaon S.O": "444511",
      "Barshitakli S.O": "444401",
      "Krishinagar Akola S.O": "444104",
      "Mahan S.O": "444405",
      "Mana S.O": "444106",
      "Ramdaspeth Akola S.O": "444001",
      "Rpts Akola S.O": "444002",
      "Vadegaon S.O": "444502"
    },
    "NAGPUR": {
      "Narsala B.O": "441204",
      "Borkhedi B.O": "441108",
      "Khairi Akashwani B.O": "441401",
      "Ashta B.O": "441108",
      "Pipla B.O": "441204",
      "Bhandewadi B.O": "441104",
      "Kapsi BK B.O": "441104",
      "Bela B.O": "441108",
      "Dongargaon B.O": "441108",
      "Khapri B.O": "441108",
      "Gumgaon B.O": "441122",
      "Salaidhabha B.O": "441122",
      "Deoli Kalbande B.O": "440023",
      "Dhamna B.O": "440023",
      "Lava B.O": "440023",
      "Waddhamna B.O": "440023",
      "Rama B.O": "441108",
      "Rui B.O": "441108",
      "Kanholibara B.O": "441110",
      "Mohgaon B.O": "441110",
      "Shiwa Sawanga B.O": "440023",
      "Padri Thana B.O": "441108",
      "Pipra B.O": "441108",
      "Ridhora B.O": "441103",
      "Amgaon Deori B.O": "441110",
      "Takalghat B.O": "441122",
      "Gondkhairi B.O": "440023",
      "Umri Wagh B.O": "440023",
      "Vyahad Bzk B.O": "440023",
      "Sawangi Asola B.O": "441108",
      "Kawdas B.O": "441110",
      "Mondha B.O": "441110",
      "Wanadongri B.O": "441110",
      "Adegaon B.O": "440023",
      "Bazargaon B.O": "440023",
      "Dawlameti B.O": "440023",
      "Tinkheda B.O": "441304",
      "Bharsingi B.O": "441305",
      "Digras BK B.O": "441305",
      "Maywadi B.O": "441305",
      "Rohna B.O": "441305",
      "Itgaon B.O": "441105",
      "Mahuli B.O": "441105",
      "Aroli B.O": "441106",
      "Kachurwahi B.O": "441106",
      "Khat B.O": "441106",
      "Khairgaon B.O": "441303",
      "Belona B.O": "441304",
      "Kharsoli B.O": "441304",
      "Yerla (Dhote) B.O": "441305",
      "Dahegaon Joshi B.O": "441105",
      "Chanpa B.O": "441113",
      "Dahegaon Rangari B.O": "441113",
      "Pipla Dakbanglow B.O": "441113",
      "Takli Bhansali B.O": "441113",
      "Raulgaon B.O": "441502",
      "Mohadi Dalvi B.O": "441304",
      "Jamgaon BK B.O": "441305",
      "Khapa Ghudan B.O": "441305",
      "Lohari Sawanga B.O": "441305",
      "Khandala B.O": "441105",
      "Nayakund B.O": "441105",
      "Bhandarbodi B.O": "441106",
      "Bhondewada B.O": "441106",
      "Chacher B.O": "441106",
      "Dudhala B.O": "441103",
      "Indora B.O": "441106",
      "Khairi Bijewada B.O": "441106",
      "Mahadula (Ramtek) B.O": "441106",
      "Khangaon B.O": "441302",
      "Dorli Bhandwalkar B.O": "441306",
      "Pipla Kewalram B.O": "441306",
      "Pachgaon B.O": "441204",
      "Surgaon B.O": "441204",
      "Bamhni B.O": "441501",
      "Mangrud B.O": "441203",
      "Nand B.O": "441203",
      "Tarna B.O": "441203",
      "Tarsa B.O": "441106",
      "Mohgaon Bhadade B.O": "441306",
      "Sindhi Umri B.O": "441306",
      "Sonoli B.O": "441306",
      "Champa B.O": "441204",
      "Kalamna B.O": "441204",
      "Matkazari B.O": "441204",
      "Godhani B.O": "441203",
      "Kargaon B.O": "441203",
      "Makardhokda B.O": "441203",
      "Navegaon Sadhu B.O": "441203",
      "Musewadi B.O": "441106",
      "Nimkheda B.O": "441106",
      "Satak B.O": "441106",
      "Seoni B.O": "441106",
      "Adasa B.O": "441107",
      "Telkamathi B.O": "441107",
      "Umri B.O": "441107",
      "Waghoda B.O": "441107",
      "Besur B.O": "441214",
      "Hiwra Hiwri B.O": "441214",
      "Mahalgaon B.O": "441214",
      "Vihirgaon B.O": "441204",
      "Dawha B.O": "441203",
      "Pahani Chinchala B.O": "441203",
      "Seo B.O": "441203",
      "Shirpur B.O": "441203",
      "Shiwapur B.O": "441203",
      "Bhishnoor B.O": "441305",
      "Thaturwada B.O": "441305",
      "Navegaon Khairi B.O": "441105",
      "Waki B.O": "441113",
      "Babdeo B.O": "441106",
      "Kavikulguru Nagar B.O": "441106",
      "Kodamendhi B.O": "441106",
      "Morgaon B.O": "441106",
      "Nagardhan B.O": "441106",
      "Gaimukh Nanda B.O": "441107",
      "Malegaon B.O": "441107",
      "Telgaon B.O": "441107",
      "Masora B.O": "441306",
      "Yenikoni B.O": "441306",
      "Salaigodhni B.O": "441204",
      "Udasa B.O": "441204",
      "Aptur B.O": "441203",
      "Bhagwanpur B.O": "441203",
      "Adyar Dupache B.O": "441201",
      "Jaoli B.O": "441201",
      "Malewada B.O": "441201",
      "Thutanbori B.O": "441201",
      "Dawsa B.O": "441301",
      "Kharbadi B.O": "441301",
      "Mendhala B.O": "441301",
      "Ramthi B.O": "441301",
      "Thadipauni B.O": "441301",
      "Thugaon Deo B.O": "441301",
      "Manegaon Tek B.O": "441401",
      "Lohgad B.O": "441302",
      "Virkhandi B.O": "441201",
      "Dhapewada B.O": "441501",
      "Ghorad B.O": "441501",
      "Kalambi B.O": "441501",
      "Ubali B.O": "441501",
      "Ajni B.O": "441401",
      "Belda B.O": "441401",
      "Karwahi B.O": "441401",
      "Khumari B.O": "441401",
      "Ranala B.O": "441401",
      "Rewral B.O": "441401",
      "Salwa B.O": "441401",
      "Tangla B.O": "441401",
      "Menda B.O": "441201",
      "Mokhebardi B.O": "441201",
      "Tas B.O": "441201",
      "Walni B.O": "441501",
      "Gondegaon B.O": "441404",
      "Borda B.O": "441401",
      "Kandri B.O": "441401",
      "Mansar B.O": "441401",
      "Pauni B.O": "441401",
      "Dhawlapur B.O": "441302",
      "Ladgaon B.O": "441302",
      "Metpanjra B.O": "441302",
      "Murti B.O": "441302",
      "Yenwa B.O": "441302",
      "Walni Colliery B.O": "441102",
      "Ambadi B.O": "441202",
      "Deoli Kalan B.O": "441202",
      "Marni B.O": "441202",
      "Salva B.O": "441202",
      "Silli B.O": "441202",
      "Temsana B.O": "441202",
      "Jiwnapur B.O": "441210",
      "Sirsi Navegaon B.O": "441210",
      "Tekepar B.O": "441210",
      "Veltur B.O": "441210",
      "Wagh B.O": "441210",
      "Dhanla B.O": "441104",
      "Gowri B.O": "441104",
      "Gumthala B.O": "441104",
      "Marodi B.O": "441104",
      "Khairi Dhalgaon B.O": "441112",
      "Mangsa B.O": "441112",
      "Khubala B.O": "441101",
      "Kodegaon B.O": "441101",
      "Kothurna B.O": "441101",
      "Nagalwadi B.O": "441101",
      "Wakodi B.O": "441101",
      "Hingna Barabhai B.O": "441102",
      "Gumthi B.O": "441111",
      "Lonkhairi B.O": "441111",
      "Navegaon Chinchghat B.O": "441202",
      "Navegaon Isapur B.O": "441202",
      "Titur B.O": "441202",
      "Ambhora B.O": "441210",
      "Channa B.O": "441210",
      "Donger Mauda B.O": "441210",
      "Fegad B.O": "441210",
      "Pardi Deshmukh B.O": "441502",
      "Badegaon B.O": "441101",
      "Bina B.O": "441102",
      "Tamaswadi B.O": "441102",
      "Khursapar B.O": "441103",
      "Dighori Kale B.O": "441202",
      "Adam B.O": "441210",
      "Gohna B.O": "441210",
      "Bhugaon B.O": "441104",
      "Niharwani B.O": "441104",
      "Kohli B.O": "441502",
      "Pipla Kinkhede B.O": "441502",
      "Naxi B.O": "441201",
      "Datewadi B.O": "441301",
      "Fetri B.O": "441501",
      "Mahurzari B.O": "441501",
      "Uparwahi B.O": "441501",
      "Deolapar B.O": "441401",
      "Hiwra Bazar B.O": "441401",
      "Patharai B.O": "441401",
      "Pipariya B.O": "441401",
      "Wadamba B.O": "441401",
      "Isapur Khurd B.O": "441302",
      "Zilpa B.O": "441302",
      "Mendhepathar B.O": "441302",
      "Bichwa B.O": "441101",
      "Kachari Sawanga B.O": "441103",
      "Masod B.O": "441103",
      "Chapegadi B.O": "441202",
      "Dodma B.O": "441202",
      "Musalgaon B.O": "441202",
      "Rajola B.O": "441202",
      "Gothangaon B.O": "441210",
      "Kujba B.O": "441210",
      "Pachkhedi B.O": "441210",
      "Chirwa B.O": "441104",
      "Mathni B.O": "441104",
      "Ungaon B.O": "441104",
      "Wadoda B.O": "441104",
      "Dorli Bhingare B.O": "441502",
      "Nagpur City H.O": "440002",
      "Nagpur GPO": "440001",
      "Kamthi H.O": "441001",
      "Manewada Road S.O": "440024",
      "Nayapura S.O": "440002",
      "Panchsheel Nagar S.O": "440017",
      "Raje Raghujinagar S.O": "440024",
      "Abhyankar Nagar S.O": "440010",
      "BESA Road S.O": "440037",
      "Bureau Of Mines S.O": "440001",
      "Congress Nagar S.O (Nagpur)": "440012",
      "Jaitala S.O": "440036",
      "Laxmi Nagar S.O (Nagpur)": "440022",
      "Mohan Nagar S.O (Nagpur)": "440001",
      "Nagpur Airport S.O": "440005",
      "Narendra Nagar S.O (Nagpur)": "440015",
      "Neeri S.O": "440020",
      "Netaji Market S.O": "440012",
      "Shankar Nagar S.O": "440010",
      "Vayusena Nagar S.O": "440007",
      "Vivekanand Nagar S.O": "440015",
      "Ajni S.O": "440003",
      "Ayodhya Nagar S.O": "440024",
      "Ganjipeth S.O": "440018",
      "Imamwada S.O": "440003",
      "Mahal S.O (Nagpur)": "440032",
      "Medical College S.O (Nagpur)": "440003",
      "Borgaon Road S.O": "440013",
      "Gokulpeth S.O": "440010",
      "Kasturchand Park S.O": "440001",
      "Katolroad S.O": "440013",
      "Khamla S.O": "440025",
      "Mankapur S.O (Nagpur)": "440030",
      "Patwardhan Ground S.O": "440012",
      "Samartha Nagar S.O": "440015",
      "A.D. Project S.O": "440021",
      "Bori S.O (Nagpur)": "441108",
      "Indl.Area Nagpur S.O": "440016",
      "MIDC Nagpur S.O": "440016",
      "Wadi S.O (Nagpur)": "440023",
      "Jalalkheda S.O": "441301",
      "Kamthi City SO": "441001",
      "Khaperkheda S.O": "441102",
      "Narkher S.O": "441304",
      "Patansaongi S.O": "441113",
      "SRPF S.O": "440016",
      "Hanuman Nagar S.O": "440024",
      "Jaripatka S.O": "440014",
      "Kalmna Market Yard S.O": "440035",
      "Mahatma Fule Bazar S.O": "440018",
      "Mhalginagar S.O": "440034",
      "Parvati Nagar S.O": "440027",
      "Uppalwadi S.O": "440026",
      "Vishwakarma Nagar S.O": "440027",
      "Bezonbagh S.O": "440014",
      "C.R.P.F. Nagpur S.O": "440019",
      "Coal Estate S.O": "440001",
      "Dhantoli S.O": "440012",
      "Giripeth S.O": "440010",
      "Hitavada S.O": "440012",
      "Khare Town S.O": "440010",
      "Ranapratap Nagar S.O": "440022",
      "Ravi Nagar S.O": "440001",
      "Seminary Hills S.O": "440006",
      "Sitabuldi S.O": "440012",
      "Trimurti Nagar S.O": "440022",
      "University Campus S.O (Nagpur)": "440033",
      "V R C E S.O": "440010",
      "Kamthi Colliery S.O": "441404",
      "Kanhan Pipri S.O": "441401",
      "Kondhali S.O": "441103",
      "Mauda S.O": "441104",
      "Mohpa S.O": "441502",
      "Paradsinga S.O": "441305",
      "Sawargaon S.O": "441306",
      "Sillewara Project S.O": "441109",
      "Umred Bazar S.O": "441203",
      "Umred Project S.O": "441204",
      "Umred S.O": "441203",
      "Godhani S.O": "441123",
      "Dattawadi S.O": "440023",
      "Bhiwapur S.O": "441201",
      "Kalmeshwar S.O": "441501",
      "Katol S.O": "441302",
      "Koradi Tps S.O": "441111",
      "Mandhal S.O": "441210",
      "Midc Kalmeshwar S.O": "441501",
      "Mowad S.O": "441303",
      "Ramtek S.O": "441106",
      "Saoner S.O": "441107",
      "Sirsi S.O (Nagpur)": "441214",
      "Bagadganj S.O": "440008",
      "Dighori Naka S.O": "440024",
      "Dr.Ambedkar Marg S.O": "440017",
      "Mominpura S.O": "440018",
      "Nandavan Colony S.O": "440024",
      "Nadt Campus S.O": "440030",
      "Sadar Bazar S.O (Nagpur)": "440001",
      "Shradhananpeth S.O": "440022",
      "Ujwal Nagar S.O (Nagpur)": "440025",
      "Hingna S.O": "441110",
      "Industrial Area Butibori S.O": "441122",
      "Kelod S.O": "441112",
      "Khapa S.O": "441101",
      "Kuhi S.O": "441202",
      "Parseoni S.O": "441105"
    },
    "NANDURBAR": {
      "Bhadvad B.O": "425416",
      "Dhong B.O": "425416",
      "Mograni B.O": "425416",
      "Shegave B.O": "425416",
      "Srawani B.O": "425416",
      "Kakadkhut B.O": "425419",
      "Aslod B.O": "425444",
      "Shahane B.O": "425444",
      "Fattepur B.O": "425432",
      "Kansai B.O": "425432",
      "Ranipur B.O": "425432",
      "Bhangarapani B.O": "425452",
      "Dab B.O": "425452",
      "Gaman B.O": "425452",
      "Dhamdai B.O": "425412",
      "Kothali KH B.O": "425412",
      "Nandarkhe B.O": "425412",
      "Sindgavhan B.O": "425412",
      "Sundarde Digar B.O": "425412",
      "Vasalai B.O": "425412",
      "Khokse B.O": "425418",
      "Khadki B.O": "425416",
      "Mothi Kadvan B.O": "425416",
      "Nizampur Digar B.O": "425416",
      "Shehi B.O": "425416",
      "Bamangaon B.O": "425419",
      "Gavhali B.O": "425419",
      "Bhorchak B.O": "425416",
      "Talamba B.O": "425419",
      "Karjot B.O": "425444",
      "Vadgaon B.O": "425444",
      "Toranmal B.O": "425432",
      "Bhagdari B.O": "425452",
      "Kathi B.O": "425452",
      "Pimpalkhuta B.O": "425452",
      "Vadfali B.O": "425426",
      "Dhulwad B.O": "425412",
      "June Mohide B.O": "425412",
      "Karajkupa B.O": "425412",
      "Khondamali B.O": "425412",
      "Kolda B.O": "425412",
      "Sutare B.O": "425412",
      "Thanepada B.O": "425412",
      "Umarde KH B.O": "425412",
      "Raingaon B.O": "425418",
      "Raipur B.O": "425418",
      "Moramba B.O": "425419",
      "Chandsaily B.O": "425444",
      "Javde TH B.O": "425444",
      "Chikhali BK B.O": "425432",
      "Javde TB B.O": "425432",
      "Kudhavad B.O": "425432",
      "Bhone B.O": "425412",
      "Borale B.O": "425412",
      "Gujarbhavali B.O": "425412",
      "Korit B.O": "425412",
      "Lahan shahada B.O": "425412",
      "Pachorabari B.O": "425412",
      "Shinde B.O": "425412",
      "Songirpada B.O": "425412",
      "Vikharan B.O": "425412",
      "Karanji KH B.O": "425418",
      "Khekada B.O": "425418",
      "Nagziri B.O": "425418",
      "Dogegaon B.O": "425416",
      "Karanjali B.O": "425416",
      "Kholvihir B.O": "425416",
      "Raisingpur B.O": "425419",
      "Chirkhan B.O": "425444",
      "Lakadkot B.O": "425432",
      "Pimpri B.O": "425432",
      "Rampur B.O": "425432",
      "Mojapada B.O": "425452",
      "Arditara B.O": "425412",
      "Ashte B.O": "425412",
      "Bhaler B.O": "425412",
      "Dhanora B.O": "425412",
      "Dhekwad B.O": "425412",
      "Natavad B.O": "425412",
      "Palashi B.O": "425412",
      "Patonda B.O": "425412",
      "Pimplod B.O": "425412",
      "Samsherpur B.O": "425412",
      "Waghale B.O": "425412",
      "Dhaite B.O": "425418",
      "Dhanarat B.O": "425418",
      "Gadat B.O": "425418",
      "Navagaon B.O": "425418",
      "Jamane B.O": "425415",
      "Velli B.O": "425415",
      "Tulaja B.O": "425442",
      "Bandhare B.O": "425417",
      "Kolde B.O": "425417",
      "Bijari B.O": "425414",
      "Dhanaje B.O": "425414",
      "Katri B.O": "425414",
      "Talai B.O": "425414",
      "Mohida B.O": "425442",
      "Anjane B.O": "425417",
      "Mandvi BK B.O": "425414",
      "Radikalam B.O": "425414",
      "Rajabardi B.O": "425414",
      "Sisa B.O": "425414",
      "Survani B.O": "425414",
      "Rajale B.O": "425408",
      "Shanimandal B.O": "425408",
      "Vaindane B.O": "425408",
      "Kharvad B.O": "425442",
      "Lakhapur B.O": "425442",
      "Sonare Digar B.O": "425417",
      "Chikhali B.O": "425414",
      "Chulvad B.O": "425414",
      "Kakarda B.O": "425423",
      "Kharde KH B.O": "425408",
      "Ankushvihir B.O": "425415",
      "RajMohi B.O": "425415",
      "Mod B.O": "425442",
      "Talve B.O": "425442",
      "Gangapur B.O": "425417",
      "Patibedaki B.O": "425417",
      "Khuntamodi B.O": "425414",
      "Mundalvad B.O": "425414",
      "Nihali B.O": "425408",
      "Sulvade B.O": "425409",
      "Vardhe B.O": "425409",
      "Pratappur B.O": "425413",
      "Rajvira B.O": "425413",
      "Shirve B.O": "425413",
      "Vanyavihir B.O": "425413",
      "Kukaval B.O": "425423",
      "Torkheda B.O": "425423",
      "Khanapur B.O": "425426",
      "Mubarakpur B.O": "425409",
      "Padalda B.O": "425409",
      "Amlad B.O": "425413",
      "Amoni B.O": "425413",
      "Davlipada B.O": "425426",
      "Damrkheda B.O": "425422",
      "Katharde Digar B.O": "425422",
      "Dongargaon B.O": "425424",
      "Bahyane B.O": "425411",
      "Chaupale B.O": "425411",
      "Anarad B.O": "425410",
      "Brahmanpuri B.O": "425409",
      "Dhurkheda B.O": "425409",
      "Kalmadi B.O": "425409",
      "Lonkheda B.O": "425409",
      "M Mohida B.O": "425409",
      "Mohida TH B.O": "425409",
      "Ambapur B.O": "425409",
      "Raikhed B.O": "425409",
      "Shirud digar B.O": "425409",
      "Modalpada B.O": "425413",
      "Nalgavhan B.O": "425413",
      "Bamkheda T.T. B.O": "425423",
      "Jainagar B.O": "425423",
      "Kondhaval B.O": "425423",
      "Bandharpada B.O": "425426",
      "Bharadu B.O": "425426",
      "Vaijali B.O": "425422",
      "Kavlith B.O": "425424",
      "Manjare B.O": "425411",
      "Kalamboo B.O": "425410",
      "Bhade B.O": "425409",
      "Kalsadi B.O": "425409",
      "Shelti B.O": "425409",
      "Sonwad B.O": "425409",
      "Chinoda B.O": "425413",
      "Nala B.O": "425413",
      "Fes B.O": "425423",
      "Chitvi B.O": "425426",
      "Haldani B.O": "425426",
      "Nandarkheda B.O": "425422",
      "Gogapur B.O": "425424",
      "Koparli B.O": "425411",
      "Wavad B.O": "425411",
      "Biladi T.S B.O": "425410",
      "Kahatul B.O": "425409",
      "Londhare B.O": "425409",
      "Chinchpada S.O": "425417",
      "Dhadgaon S.O": "425414",
      "Khandbara S.O": "425416",
      "Mandana S.O": "425444",
      "Nandurbar Kutchery S.O": "425412",
      "Purushottam Nagar S.O": "425424",
      "Visarwadi S.O": "425426",
      "Akkalkuwa S.O": "425415",
      "Borad S.O": "425442",
      "Nandurbar S.O": "425412",
      "Shahada Town S.O": "425409",
      "Taloda S.O": "425413",
      "Vadali S.O (Nandurbar)": "425423",
      "Nandurbar Bazar S.O": "425412",
      "Prakasha S.O": "425422",
      "Sarangkheda S.O": "425410",
      "Khapar S.O": "425419",
      "Mhasawad S.O (Nandurbar)": "425432",
      "Molgi S.O": "425452",
      "Navapur S.O": "425418",
      "Ranala S.O": "425411",
      "Shahada S.O": "425409"
    },
    "DHULE": {
      "Morane Pr Ner B.O": "424302",
      "Talvade B.O": "424311",
      "Velhane B.O": "424311",
      "Pashta B.O": "425404",
      "Varud B.O": "425404",
      "Ambode B.O": "424318",
      "Navara navari B.O": "424318",
      "Khandalai B.O": "424303",
      "Khori B.O": "424305",
      "Mhasale B.O": "424305",
      "Nadse B.O": "424310",
      "Vitai B.O": "424310",
      "Deur Bk B.O": "424302",
      "Kheda B.O": "424302",
      "Nandre B.O": "424302",
      "Junawane B.O": "424311",
      "Vinchur B.O": "424311",
      "Kamkheda B.O": "425404",
      "Varshi B.O": "425404",
      "Mohadi dangri B.O": "424318",
      "Satarne B.O": "424318",
      "Bhadane B.O": "424303",
      "Bhamer B.O": "424305",
      "Chadvel B.O": "424305",
      "Tikhi B.O": "424311",
      "Khudane B.O": "424305",
      "Malpur B.O": "425408",
      "Pratappur B.O": "424310",
      "Chaugaon B.O": "424302",
      "Udane B.O": "424302",
      "Borvihir B.O": "424311",
      "Narvhal B.O": "424311",
      "Nimgul B.O": "425408",
      "Ajande KH B.O": "425404",
      "Shirdhane B.O": "424303",
      "Vani B.O": "424318",
      "Vishvanath B.O": "424318",
      "Lonkhedi B.O": "424303",
      "Akhade B.O": "424305",
      "Amkhel B.O": "424305",
      "Brahamanvel B.O": "424305",
      "Tembhe B.O": "424306",
      "Wakvad B.O": "425428",
      "Amrale B.O": "425407",
      "Divi B.O": "425407",
      "Jakhane B.O": "425407",
      "Nimdale B.O": "424002",
      "Padalda B.O": "424002",
      "Valvadi B.O": "424002",
      "Agriculture College B.O": "424004",
      "Arvi B.O": "424006",
      "Laling B.O": "424006",
      "Kumar Nagar B.O": "424002",
      "Nagaon B.O": "424005",
      "Bamhane B.O": "425408",
      "Dhamane B.O": "425408",
      "Hatti KH B.O": "425408",
      "Kharde BK B.O": "425408",
      "Kurukwade B.O": "425408",
      "Methi B.O": "425408",
      "Kalkheda B.O": "424301",
      "Varkheda B.O": "424301",
      "Burzad B.O": "424307",
      "Behed B.O": "424310",
      "Dighave B.O": "424310",
      "Ajande BK B.O": "425403",
      "Mudawad B.O": "425403",
      "Padhavad B.O": "425403",
      "Zende Anjan B.O": "425428",
      "Savaimukti B.O": "425407",
      "Chinchwar B.O": "424002",
      "Gondur B.O": "424002",
      "Mehergaon B.O": "424002",
      "Nakane B.O": "424002",
      "Ramwadi B.O": "424002",
      "Rami B.O": "424307",
      "Tavkheda B.O": "425408",
      "Vikhran B.O": "425408",
      "Ajang B.O": "424301",
      "Chinchkheda B.O": "424301",
      "Umarde B.O": "425428",
      "Khalane B.O": "425407",
      "Rohane B.O": "425407",
      "Salve B.O": "425407",
      "Phophare B.O": "424002",
      "Vadjai B.O": "424002",
      "War B.O": "424002",
      "Purmepada B.O": "424006",
      "Sadgaon B.O": "424006",
      "Dondaicha Town B.O": "425408",
      "Indave B.O": "425408",
      "Karle B.O": "425408",
      "Deobhane B.O": "424307",
      "Dhanur B.O": "424307",
      "Lamkani B.O": "424307",
      "Lonkheda B.O": "424307",
      "Nandane B.O": "424307",
      "Chhail B.O": "424310",
      "Ganeshpur B.O": "424310",
      "Kodid B.O": "425428",
      "Malkatar B.O": "425428",
      "Dangurne B.O": "425407",
      "Shevade B.O": "425407",
      "Tamthare B.O": "425407",
      "Babhulvadi B.O": "424002",
      "Dahyane B.O": "424002",
      "Morane laling B.O": "424002",
      "Nihalod B.O": "424002",
      "Dhadre B.O": "424006",
      "Old Dhule B.O": "424002",
      "Aichale B.O": "425408",
      "Daul B.O": "425408",
      "Kodade B.O": "425408",
      "Suray B.O": "425408",
      "Mukti B.O": "424301",
      "Boris B.O": "424307",
      "Chilane B.O": "425406",
      "Ahilyapur B.O": "425405",
      "Balde B.O": "425405",
      "Bhatpure B.O": "425405",
      "Lauki B.O": "425405",
      "Piloda B.O": "425405",
      "Rohini B.O": "425405",
      "Gorane B.O": "424309",
      "Tarhadi T.T. B.O": "425427",
      "Tarhadkasbe B.O": "425427",
      "Tekvade B.O": "425427",
      "Varul B.O": "425406",
      "Jogshelu B.O": "425406",
      "Mahalpur B.O": "425406",
      "Patan B.O": "425406",
      "Ranjane B.O": "425406",
      "Sonewadi B.O": "425406",
      "Jatode B.O": "425405",
      "Khambale B.O": "425405",
      "Sukwad B.O": "425405",
      "Sule B.O": "425405",
      "Untavad B.O": "425405",
      "Varzadi B.O": "425405",
      "Wadi B.O": "425405",
      "Hendrun B.O": "424308",
      "Moghan B.O": "424308",
      "Mordad B.O": "424308",
      "Nandale B.O": "424308",
      "Pimparkheda B.O": "424309",
      "Waghadi Bk B.O": "424309",
      "Walkheda B.O": "424309",
      "Wathode B.O": "425421",
      "Runmaili B.O": "424305",
      "Bhadne B.O": "424304",
      "Dhandarne B.O": "425406",
      "Virdel B.O": "425406",
      "Ambe B.O": "425405",
      "Dahivad B.O": "425405",
      "Gidhade B.O": "425405",
      "Holnantha B.O": "425405",
      "Lakdya Hanuman B.O": "425405",
      "Palasner B.O": "425405",
      "Sangvi B.O": "425405",
      "Savalde B.O": "425405",
      "Chikase B.O": "424306",
      "Dangshirvade B.O": "424306",
      "Degaon B.O": "424306",
      "Deshshirwade B.O": "424306",
      "Ashtane B.O": "424304",
      "Balsane B.O": "424304",
      "Bodgaon B.O": "424304",
      "Dhamnar B.O": "424304",
      "Dusane B.O": "424304",
      "Perejpur B.O": "424304",
      "Rainpada B.O": "424304",
      "Rohod B.O": "424304",
      "Shewali B.O": "424304",
      "Titane B.O": "424305",
      "Vehergaon B.O": "424305",
      "Shevge B.O": "424306",
      "Sukapur B.O": "424306",
      "Umarpatta B.O": "424306",
      "Umbharti B.O": "424306",
      "Datarti B.O": "424304",
      "Devjipada B.O": "424304",
      "Kharadbari B.O": "424304",
      "Mauje chadvel B.O": "424304",
      "Wasardi B.O": "425405",
      "Borkund B.O": "424308",
      "Babhalaj B.O": "425421",
      "Bhorkheda B.O": "425421",
      "Manjrod B.O": "425421",
      "Balkuwa B.O": "425427",
      "Hol B.O": "425406",
      "Kadane B.O": "425406",
      "Varpada B.O": "425406",
      "Dabhashi B.O": "425405",
      "Gartad B.O": "425405",
      "Karvand B.O": "425405",
      "Khamkheda B.O": "425405",
      "Waghadi B.O": "425405",
      "Dhamangaon B.O": "424308",
      "Waypur B.O": "424309",
      "Hisale B.O": "425421",
      "Tonde B.O": "425421",
      "Arthe B.O": "425427",
      "Bhamte B.O": "425427",
      "Vaskhedi B.O": "424305",
      "Kudashi B.O": "424306",
      "Pimpalgaon B.O": "424306",
      "Shendwad B.O": "424306",
      "Warsa B.O": "424306",
      "Chaupale B.O": "424304",
      "Dahivel B.O": "424304",
      "Ghodade B.O": "424304",
      "Kalambhir B.O": "424304",
      "Navapada B.O": "424304",
      "Tamasvadi B.O": "424304",
      "Vasmar B.O": "424304",
      "Balhane B.O": "424306",
      "Dhadne B.O": "424306",
      "Jebapur B.O": "424306",
      "Pankheda B.O": "424306",
      "Samode B.O": "424306",
      "Shenpur B.O": "424306",
      "Chinchkhede B.O": "424304",
      "Kakani B.O": "424304",
      "Kavthe B.O": "424304",
      "Mhasdi B.O": "424304",
      "Pinjarzadi B.O": "424304",
      "S.F.BHADNE B.O": "424304",
      "Shirsole B.O": "424304",
      "Vardhane B.O": "424304",
      "Dhule H.O": "424001",
      "Boradi S.O": "425428",
      "Dhule City S.O": "424001",
      "Dhule Collectorate S.O": "424001",
      "Dhule Deopur S.O": "424002",
      "Kusumba S.O": "424302",
      "Mohadi Laling S.O": "424311",
      "Nardana S.O": "425404",
      "Songir S.O": "424309",
      "Upper Shirpur S.O": "425405",
      "Betawad S.O": "425403",
      "Dhule Chaini Road S.O": "424001",
      "Dhule Market Yard S.O": "424004",
      "Dhule Vidya Nagari S.O": "424005",
      "Fagana S.O": "424301",
      "Mandi shirpur S.O": "425405",
      "Ner S.O": "424303",
      "Shirud S.O": "424308",
      "Chimthana S.O": "425407",
      "Dhule Pramod Nagar S.O": "424002",
      "Dhule Station Road S.O": "424001",
      "Naval Nagar S.O": "424318",
      "Pimpalner S.O": "424306",
      "Dhule Jaihind Colony S.O": "424002",
      "Dhule Midc S.O": "424006",
      "Dondaicha S.O": "425408",
      "Kapadna S.O": "424307",
      "Kasara S.O (Dhule)": "424310",
      "Nizampur S.O (Dhule)": "424305",
      "Sakri (Dhule) S.O": "424304",
      "Shindkheda S.O": "425406",
      "Shirpur S.O": "425405",
      "Thalner S.O": "425421",
      "Vikharan (Shirpur) S.O": "425427"
    },
    "JALGAON": {
      "Ganeshpur B.O": "424119",
      "Mamurabad B.O": "425002",
      "Shirsoli B.O": "425002",
      "Nimb B.O": "425402",
      "Dahigaon B.O": "425301",
      "Vitner B.O": "425116",
      "Kurangi B.O": "425115",
      "Chandsar B.O": "425103",
      "Ringangaon B.O": "425103",
      "Zurkheda B.O": "425103",
      "Sonwad B.O": "425104",
      "Savkheda Bk B.O": "425002",
      "Bohare B.O": "425402",
      "Dangri B.O": "425402",
      "Kalamsare B.O": "424204",
      "Bornar B.O": "425116",
      "Jalke B.O": "425116",
      "Dongaon B.O": "425302",
      "Kadholi B.O": "425103",
      "Kharchi B.O": "425103",
      "Pimpalkotha B.O": "425103",
      "Borkheda B.O": "424119",
      "Hingona BK B.O": "425104",
      "Satkheda B.O": "425104",
      "Dhamangaon B.O": "424106",
      "Idgaon B.O": "425002",
      "Kinod B.O": "425002",
      "Mohadi B.O": "425114",
      "Karankheda B.O": "425402",
      "Vavadade B.O": "425116",
      "Bambrud  ( R ) B.O": "425115",
      "Maheji B.O": "425115",
      "Pahan B.O": "425115",
      "Varad Kh B.O": "425115",
      "Anjanvihire B.O": "424105",
      "Chorgaon B.O": "425103",
      "Ravanje Bk B.O": "425103",
      "Kanalda B.O": "425002",
      "Kathora B.O": "425301",
      "Nandra B.O": "425002",
      "Phupnagari B.O": "425002",
      "Asankheda B.O": "425115",
      "Pathari B.O": "425115",
      "Samner B.O": "425115",
      "Vadli B.O": "425115",
      "Varad Bk B.O": "425103",
      "Devpimpri B.O": "425114",
      "Kekat Nimbhora B.O": "425114",
      "Hated B.O": "425107",
      "Nagalwadi B.O": "425107",
      "Sanpule B.O": "425107",
      "Vardi B.O": "425107",
      "Vele B.O": "425107",
      "Chincholi Pimpri B.O": "424208",
      "Godri B.O": "424208",
      "Mandve K H B.O": "424207",
      "Tondapur B.O": "424207",
      "Gondkhed B.O": "424206",
      "Khadki B.O": "424206",
      "Moykheda B.O": "424206",
      "Samrod B.O": "424206",
      "Takali B.O": "424206",
      "Malkheda B.O": "424204",
      "Palaskheda Mirache B.O": "425114",
      "Rotwad B.O": "425105",
      "Sunasgaon B.O": "425309",
      "Bhokari B.O": "425107",
      "Chahardi B.O": "425107",
      "Ghadvel B.O": "425107",
      "Khachane B.O": "425107",
      "Kurvel B.O": "425107",
      "Tawase B.O": "425107",
      "Umarti B.O": "425107",
      "Vadti B.O": "425107",
      "Paldhi Pahur B.O": "424205",
      "Lahasar B.O": "424206",
      "Londhari B.O": "424206",
      "Maldabhadi B.O": "424206",
      "Moygaon B.O": "424206",
      "Waghari B.O": "424206",
      "Lasur B.O": "425107",
      "Mamalde B.O": "425107",
      "Melane B.O": "425107",
      "Satrasen B.O": "425107",
      "Virwade B.O": "425107",
      "Vishnapur B.O": "425107",
      "Kasba Pimpri B.O": "424208",
      "Tornala B.O": "424208",
      "Wakod B.O": "424205",
      "Dondwade B.O": "424204",
      "Gondedaon B.O": "424204",
      "Lihedigar B.O": "424204",
      "Hiwarkheda B.O": "425114",
      "Chunchale B.O": "425302",
      "Gorgavale B.O": "425107",
      "Kolambe B.O": "425107",
      "Nimgavhan B.O": "425107",
      "Vaijpur Settelement B.O": "425107",
      "Deulgaon B.O": "424208",
      "Shengole B.O": "424207",
      "Garkheda B.O": "424206",
      "Kasali B.O": "424206",
      "Nachankheda B.O": "424206",
      "Shahpur B.O": "424206",
      "Mengaon B.O": "424204",
      "Shelgaon B.O": "424206",
      "Hatale B.O": "424119",
      "Beldarwadi B.O": "424119",
      "Ozar B.O": "424119",
      "Hingona Kh B.O": "424102",
      "Waghali B.O": "424102",
      "Vadgaon Ambe B.O": "424202",
      "Nimbhora B.O": "424105",
      "Pimpali B.O": "425420",
      "Bharvas B.O": "425401",
      "Dahivad B.O": "424106",
      "Devgaon B.O": "425303",
      "KolPimpri B.O": "425401",
      "Mudi B.O": "425401",
      "Ranaiche B.O": "425401",
      "Shirsale B.O": "425401",
      "Dhanwad B.O": "425003",
      "Umale B.O": "425003",
      "Mathgavan B.O": "425105",
      "Pastane Bk B.O": "425105",
      "Sakre B.O": "425105",
      "Sarbete B.O": "425105",
      "Bambhori B.O": "425002",
      "Kharjai B.O": "424119",
      "Patne B.O": "424119",
      "Talonde Digar B.O": "424119",
      "Kherde B.O": "424119",
      "Shirasgaon B.O": "424119",
      "Vadgaon Lambe B.O": "424119",
      "Ranjangaon B.O": "424119",
      "Tandulwadi B.O": "424102",
      "Chinchapura B.O": "424203",
      "Kurhad B.O": "424202",
      "Lohari Bk B.O": "424202",
      "Shindad Bk B.O": "424202",
      "Dodhwad B.O": "425420",
      "Gandhali B.O": "425420",
      "Jalod B.O": "425420",
      "Kalali B.O": "425420",
      "Shirud B.O": "425401",
      "Taskheda B.O": "425401",
      "vavade B.O": "425401",
      "Shahapur B.O": "425401",
      "Tarsod B.O": "425003",
      "Bholane B.O": "425113",
      "Nanded B.O": "425105",
      "Savkheda B.O": "425105",
      "Shelave B.O": "425105",
      "Takarkheda B.O": "425105",
      "Avhane B.O": "425002",
      "Vade B.O": "424119",
      "Sangvi B.O": "425304",
      "Saygaon B.O": "424119",
      "Takali PD B.O": "424119",
      "Loni B.O": "424207",
      "Dhanora B.O": "425105",
      "Panchak B.O": "425303",
      "Vadgaon B K B.O": "425303",
      "Chikali B.O": "425304",
      "Kurha Hardo B.O": "425310",
      "Manur B.O": "425310",
      "Muktal B.O": "425310",
      "Sakegaon B.O": "425201",
      "Betawad B.O": "425310",
      "Ghankheda B.O": "425310",
      "Viroda B.O": "425503",
      "Balwadi B.O": "425507",
      "Dhamodi B.O": "425507",
      "Vitve B.O": "425507",
      "Lohare B.O": "425504",
      "Parambi B.O": "425327",
      "Vadhoda B.O": "425327",
      "Amoda B.O": "425002",
      "Nhavi B.O": "425524",
      "Chinchol B.O": "425306",
      "Nimkhedi KH B.O": "425306",
      "Dasnoor B.O": "425506",
      "Abhoda B.O": "425508",
      "Therola B.O": "425508",
      "Vivra B.O": "425508",
      "Nadgaon B.O": "425310",
      "Nandra Haveli B.O": "425310",
      "Fekari B.O": "425307",
      "Hambardi B.O": "425503",
      "Nimdya B.O": "425504",
      "PAL B.O": "425504",
      "Rozoda B.O": "425504",
      "Shindi B.O": "424119",
      "Surwade B K B.O": "425311",
      "Varadsim B.O": "425311",
      "Waghur Dam Colony B.O": "425311",
      "Hartala B.O": "425306",
      "Karkee B.O": "425306",
      "Melsangve B.O": "425306",
      "Jalgaon K H B.O": "425309",
      "Khirwad B.O": "425508",
      "Morgaon Kh B.O": "425508",
      "Padala B.O": "425508",
      "Patondi B.O": "425508",
      "Punkheda B.O": "425508",
      "Rasalpur B.O": "425508",
      "Adgaon B.O": "425111",
      "Chincholi B.O": "425003",
      "Dambhurni B.O": "425302",
      "Mangrul B.O": "425111",
      "Bidgaon B.O": "425303",
      "Duskheda B.O": "425203",
      "Kandari B.O": "425003",
      "Engaon B.O": "425310",
      "Harankheda B.O": "425310",
      "Kapuswadi B.O": "425310",
      "Salshingi B.O": "425310",
      "Kanhale B.O": "425307",
      "Padalsa B.O": "425503",
      "Ainpur B.O": "425507",
      "Kusumbe B K B.O": "425504",
      "Gojore B.O": "425311",
      "Mondhale B.O": "425111",
      "Nimkhedi BK B.O": "425327",
      "Pimprala B.O": "425327",
      "Changdeo B.O": "425306",
      "Ghodasgaon B.O": "425306",
      "Naigaon B.O": "425302",
      "Pimpri Nandu B.O": "425306",
      "Uchande B.O": "425306",
      "Upkhed B.O": "424119",
      "Khadki bk B.O": "424119",
      "Dhar B.O": "425401",
      "Eklahare B.O": "425401",
      "Galwade BK B.O": "425401",
      "Jaitpir B.O": "425401",
      "Janve B.O": "425401",
      "Kavpimpri B.O": "425401",
      "Londhave B.O": "425401",
      "Patonda B.O": "425401",
      "Phapore B.O": "425401",
      "Kusumbe Kh B.O": "425003",
      "Kadgaon B.O": "425003",
      "Dheku B.O": "425105",
      "Kharde B.O": "425105",
      "Rajwad B.O": "425105",
      "Ahirwadi B.O": "425508",
      "Khanapur B.O": "425508",
      "Waghod B.O": "425508",
      "Kingaon B.O": "425302",
      "Khardi B.O": "425303",
      "Anjale B.O": "425304",
      "Nimgaon B.O": "425304",
      "Raipur B.O": "425203",
      "Jamthi B.O": "425310",
      "Kolhadi B.O": "425310",
      "Ranjani B.O": "425310",
      "Shelwad B.O": "425310",
      "Kumbharkheda B.O": "425505",
      "Khadke B.O": "425307",
      "Sakari B.O": "425307",
      "Bamnod B.O": "425503",
      "Hingona B.O": "425503",
      "Marul B.O": "425503",
      "Savkheda B K B.O": "425504",
      "Utkheda B.O": "425504",
      "Chorwad B.O": "425111",
      "Kinhi B.O": "425311",
      "Charthana B.O": "425327",
      "Anturli B.O": "424201",
      "Kothali B.O": "425306",
      "Ruikheda B.O": "425306",
      "Ajnad B.O": "425508",
      "Kherala B.O": "425508",
      "Tambole B.O": "424119",
      "Kargaon B.O": "424119",
      "Vadale  Vadli B.O": "424102",
      "Pilode B.O": "425420",
      "AmbaPimpri B.O": "425401",
      "Chaubari B.O": "425401",
      "Dangar Bk B.O": "425401",
      "Hedave B.O": "425401",
      "Javkheda B.O": "425401",
      "Lon BK B.O": "425401",
      "Mandal B.O": "425401",
      "Nagaon B.O": "425401",
      "Pimpale B.O": "425401",
      "Bhone B.O": "425105",
      "Jambhore B.O": "425105",
      "Kurhe Kh B.O": "425105",
      "Salve B.O": "425105",
      "Bhokar B.O": "425002",
      "Khadgaon B.O": "424206",
      "Palaskheda B.O": "424206",
      "Vadji B.O": "424105",
      "Pimparkhed B.O": "424105",
      "Jirali B.O": "425113",
      "Shevage B.O": "425113",
      "Amadade B.O": "424105",
      "Mahindale B.O": "424105",
      "Khadke Bk B.O": "425109",
      "Khadke Kh B.O": "425109",
      "Takali Bk B.O": "424103",
      "Talai B.O": "425110",
      "Vankothe B.O": "425110",
      "Gudhe B.O": "424107",
      "Bahal B.O": "424107",
      "Pimpalgaon K H B.O": "425305",
      "Talvel B.O": "425305",
      "Vazarkheda B.O": "425305",
      "Bhaur B.O": "424106",
      "Akhatwade B.O": "424104",
      "Badarkha Hardo B.O": "424104",
      "Anturli Bk B.O": "424201",
      "Anturli Kh B.O": "424201",
      "Veruli Kh B.O": "424201",
      "Wadi B.O": "424201",
      "Bahute B.O": "425111",
      "Bole B.O": "425111",
      "Dhul Pimpri B.O": "425111",
      "Hol Pimpri B.O": "425111",
      "Karmad B.O": "425111",
      "Korpavali B.O": "425301",
      "Satod Kolwad B.O": "425301",
      "Vadri B.O": "425301",
      "Ghodgaon B.O": "425108",
      "Kochur B.O": "425502",
      "Maskawad B.O": "425502",
      "Tandalwadi B.O": "425502",
      "Waghoda B K B.O": "425502",
      "Tahakali B.O": "425308",
      "Fulgaon B.O": "425305",
      "Kazipura B.O": "425108",
      "Mauje Hingona B.O": "425108",
      "Vadhode B.O": "425108",
      "Mundane B.O": "425111",
      "Shirasmani B.O": "425111",
      "Shivare Digar B.O": "425111",
      "Undirkhede B.O": "425111",
      "Bilakhed B.O": "424119",
      "Toli B.O": "425112",
      "Savkheda Hol B.O": "425109",
      "Toli Kh B.O": "425109",
      "Padmalay B.O": "425109",
      "Brahmanshevge B.O": "424108",
      "Ghodegaon B.O": "424108",
      "Hatgaon B.O": "424108",
      "Malshevge B.O": "424108",
      "Talegaon B.O": "424108",
      "Gondgaon B.O": "424103",
      "Savde B.O": "424103",
      "Juwardi B.O": "424107",
      "Khadki Sim B.O": "424106",
      "Vadgaon Kh B.O": "424104",
      "Bambrud Bk B.O": "424201",
      "Khadakdeola B.O": "424201",
      "Khedgaon ( N ) B.O": "424201",
      "Lohara B.O": "424201",
      "Nimbhori B.O": "424201",
      "Satgaon B.O": "424201",
      "Mhasave B.O": "425111",
      "Lonje B.O": "424119",
      "Umbarkhed B.O": "424119",
      "Pilkhod B.O": "424119",
      "Bhilali B.O": "425113",
      "Khedgaon Kh B.O": "424105",
      "Picharde B.O": "424105",
      "Shivani B.O": "424105",
      "Bhatkheda B.O": "425109",
      "Hanamantkheda B.O": "425109",
      "Lon Pirache B.O": "424103",
      "Farkande B.O": "425110",
      "Daskebardi B.O": "424107",
      "Kalmadu B.O": "424106",
      "Londhe B.O": "424106",
      "Nagardeola RS B.O": "424104",
      "Vadgaon Bk B.O": "424104",
      "Girad B.O": "424201",
      "Pardhade B.O": "424201",
      "Dholi B.O": "425111",
      "Palaskheda Sim B.O": "425111",
      "Sarve B.O": "425111",
      "Tehu B.O": "425111",
      "Titvi B.O": "425111",
      "Bhoras B.O": "424119",
      "Naygaon B.O": "425302",
      "Waghoda K H B.O": "425502",
      "Gate B.O": "425501",
      "Velhale B.O": "425305",
      "Moharala B.O": "425301",
      "Viravali K H B.O": "425301",
      "Anwarde K H B.O": "425108",
      "Walaki B.O": "425108",
      "Manvel B.O": "425302",
      "Waghzira B.O": "425302",
      "Bhavarkheda B.O": "425109",
      "Borgaon BK B.O": "425109",
      "Utran B.O": "425109",
      "Vikharan B.O": "425109",
      "Rohini B.O": "424108",
      "Kolgaon B.O": "424103",
      "Udhali B.O": "425501",
      "Kahurkheda B.O": "425308",
      "Achegaon B.O": "425305",
      "Atraval B.O": "425301",
      "Ganpur B.O": "425108",
      "Velode B.O": "425108",
      "Pimpri Bk B.O": "424103",
      "Nipane B.O": "425110",
      "Pohare B.O": "424107",
      "Jamda B.O": "424106",
      "Kunzar B.O": "424106",
      "Varkhede BK B.O": "424106",
      "Balad B.O": "424104",
      "Neri B.O": "424104",
      "Galan B.O": "424201",
      "Goradkheda B.O": "424201",
      "Kasampura B.O": "424201",
      "Lohatar B.O": "424201",
      "Sarole Bk B.O": "424201",
      "Tarkheda B.O": "424201",
      "Sadavan B.O": "425111",
      "Tamaswadi B.O": "425111",
      "Deoli B.O": "424119",
      "Waghadu B.O": "424119",
      "Tarwade B.O": "424119",
      "Chalisgaon H.O": "424101",
      "Bhusawal H.O": "425201",
      "Jalgaon H.O": "425001",
      "Adavad S.O": "425303",
      "Bhusawal Ordnance Factory S.O": "425203",
      "Bodwad S.O": "425310",
      "Faizpur S.O": "425503",
      "Varangaon Ord.Factory S.O": "425308",
      "Bhusawal Athawade Bazar S.O": "425201",
      "Chinawal S.O": "425505",
      "Deepnagar S.O": "425307",
      "M.S.S.K.Faizpur S.O": "425524",
      "Nashirabad S.O": "425309",
      "Thorgavan S.O": "425501",
      "Bhalod S.O (Jalgaon)": "425304",
      "Bhusawal Shivaji Nagar S.O": "425201",
      "Muktainagar S.O": "425306",
      "Nimbhora S.O": "425506",
      "Raver S.O": "425508",
      "Varangaon S.O": "425305",
      "Bhusawal Kutchery S.O": "425201",
      "Khirdi S.O": "425507",
      "Khiroda S.O": "425504",
      "Kurha S.O": "425311",
      "Kurha kakoda S.O": "425327",
      "Old Muktainagar S.O": "425306",
      "Sakali S.O": "425302",
      "Savda S.O": "425502",
      "Yawal S.O": "425301",
      "Deogaon S.O (Jalgaon)": "425112",
      "Hirapur S.O": "424108",
      "Nagardeola S.O": "424104",
      "Parola SO": "425111",
      "Amalgaon S.O": "425420",
      "Asoda S.O": "425101",
      "Bhadli BK S.O": "425102",
      "Marwad S.O": "425402",
      "Nandra Pachora S.O": "425115",
      "Jalgaon Premnagar S.O": "425001",
      "Pimprala SO": "425002",
      "Chalisgaon R S S.O": "424101",
      "Neri BK S.O": "425114",
      "Chopda S.O": "425107",
      "Pahur S.O": "424205",
      "Fattepur S.O": "424208",
      "Jamner S.O": "424206",
      "Bahadarpur S.O (Jalgaon)": "425113",
      "Bhadgaon S.O": "424105",
      "Kajgaon S.O (Jalgaon)": "424103",
      "Khedgaon S.O (Jalgaon)": "424107",
      "Pachora S.O": "424201",
      "Patonda S.O": "424102",
      "Amalner Pratap Nagar S.O": "425401",
      "Audyogik Vasahat Jalgaon S.O": "425003",
      "Jalgaon Bazar S.O": "425001",
      "Jalgaon Collectorate S.O": "425001",
      "M.J.College Jalgaon S.O": "425002",
      "Chalisgaon Town S.O": "424101",
      "Erandol S.O": "425109",
      "Kasoda S.O": "425110",
      "Mehunbare S.O": "424106",
      "Pimpalgaon S.O": "424203",
      "Varkhedi S.O": "424202",
      "Amalner S.O (Jalgaon)": "425401",
      "Wakadi S.O": "424207",
      "Shendurni S.O": "424204",
      "Akulkheda S.O": "425108",
      "Jalgaon Kawarnagar S.O": "425001",
      "Mhasawad S.O (Jalgaon)": "425116",
      "Paldhi S.O": "425103",
      "Pimpri Khurd S.O": "425104",
      "Chalisgaon Adarsha Nagar S.O": "424101",
      "C.T. Mill Road S.O": "424119",
      "Vivekanand nagar Pachora S.O": "424201",
      "Dharangaon S.O": "425105",
      "Jalgaon Peth S.O": "425001",
      "N M University Jalgaon S.O": "425004",
      "Jalgaon Navi Peth S.O": "425001"
    },
    "YAVATMAL": {
      "Akoli B.O": "445207",
      "Chalbardi B.O": "445302",
      "Umari Road B.O": "445302",
      "Deodhari B.O": "445306",
      "Arali B.O": "445305",
      "Satpalli B.O": "445305",
      "Chikhali Camp B.O": "445204",
      "Moha B.O": "445001",
      "Mokhad B.O": "445204",
      "Gujari B.O": "445402",
      "Chikparam B.O": "445307",
      "Sakhra Kolgaon B.O": "445307",
      "Adegaon B.O": "445210",
      "Belura B.O": "445215",
      "Pimpri B.O": "445302",
      "Saikheda B.O": "445302",
      "Shibala B.O": "445302",
      "Sonbardi B.O": "445302",
      "Bansi B.O": "445204",
      "Bhandari B.O": "445204",
      "Bhojla B.O": "445204",
      "Brahmangaon B.O": "445206",
      "Kali Daulat Khan B.O": "445204",
      "Kasola B.O": "445204",
      "Kondri B.O": "445204",
      "Wanwarla B.O": "445204",
      "Sawangi Perka B.O": "445402",
      "Undari B.O": "445402",
      "Wadhona Bazar B.O": "445402",
      "Warud JR B.O": "445402",
      "Zadgaon B.O": "445402",
      "Kurai B.O": "445307",
      "Fetra B.O": "445215",
      "Gaul, Khurd B.O": "445215",
      "Januna B.O": "445215",
      "Khandala B.O": "445215",
      "Sukli Jehangir B.O": "445206",
      "Vidul B.O": "445206",
      "Dahegaon B.O": "445308",
      "Khairi B.O": "445308",
      "Harshi B.O": "445215",
      "Khadakdari B.O": "445215",
      "Lakhi Jehangir B.O": "445215",
      "Kharus BK B.O": "445206",
      "Marsul B.O": "445206",
      "Chahand B.O": "445308",
      "Munzala B.O": "445308",
      "Bhalar B.O": "445304",
      "Mukutban B.O": "445304",
      "Nandepera B.O": "445304",
      "Both B.O": "445302",
      "Wai B.O": "445302",
      "Chikhalwardha B.O": "445306",
      "Jamb B.O": "445002",
      "Kurli B.O": "445230",
      "Sunna B.O": "445305",
      "Gahuli B.O": "445204",
      "Jamb Bazar B.O": "445204",
      "Lewa B.O": "445204",
      "Mohadi B.O": "445204",
      "Pophali B.O": "445204",
      "Jalka B.O": "445402",
      "Ayata B.O": "445106",
      "Bhansara B.O": "445106",
      "Bori Khurd B.O": "445215",
      "Mandawa B.O": "445215",
      "Mop Jawala B.O": "445215",
      "Sandawa B.O": "445215",
      "Dhanora Sachaldev B.O": "445206",
      "Marlegaon B.O": "445206",
      "Belora B.O": "445105",
      "Pimpalapur B.O": "445308",
      "Naigaon B.O": "445101",
      "Palsoni B.O": "445304",
      "Rajur B.O": "445304",
      "Rasa B.O": "445304",
      "Ukni B.O": "445304",
      "Wanzari B.O": "445304",
      "Jodmoha B.O": "445002",
      "Kinhi B.O": "445002",
      "Wadgaon P.S. B.O": "445002",
      "Dhanora B.O": "445402",
      "Marki B.O": "445324",
      "Punwat B.O": "445304",
      "Suknegaon B.O": "445304",
      "Chinchghat B.O": "445002",
      "Lasina B.O": "445002",
      "Lohara B.O": "445002",
      "Talegaon B.O": "445002",
      "Borda B.O": "445304",
      "Mendholi B.O": "445304",
      "Nerad Purad B.O": "445304",
      "Sakharadara B.O": "445304",
      "Shirpur B.O": "445304",
      "Borgaon B.O": "445002",
      "Ghodkhindi B.O": "445002",
      "M.I.D.C. B.O": "445002",
      "Sawargad B.O": "445002",
      "Umarsara B.O": "445002",
      "Dharna B.O": "445302",
      "Karanji B.O": "445302",
      "Kelapur B.O": "445302",
      "Mangurda B.O": "445302",
      "Matharjun B.O": "445302",
      "Pahapal B.O": "445302",
      "Tadsawali B.O": "445306",
      "Waghar Takli B.O": "445306",
      "Zatala B.O": "445306",
      "Chanakha B.O": "445305",
      "Dhoki B.O": "445305",
      "Hiwara B.O": "445204",
      "Jamni Dhundi B.O": "445204",
      "Parwa B.O": "445204",
      "Pedhi B.O": "445204",
      "Pohandul B.O": "445204",
      "Apti Rampur B.O": "445402",
      "Chikhali Kelapur B.O": "445402",
      "Datodi B.O": "445106",
      "Palsi B.O": "445211",
      "Umri Kap B.O": "445106",
      "Velabai B.O": "445307",
      "Dhansal B.O": "445215",
      "Dongargaon B.O": "445215",
      "Manikdoh B.O": "445215",
      "Pardi Limbi B.O": "445215",
      "Rohda B.O": "445215",
      "Sawargaon Gore B.O": "445215",
      "Shelu BK B.O": "445215",
      "Belkhed B.O": "445206",
      "Chatari B.O": "445206",
      "Deosari B.O": "445206",
      "Ghonsa B.O": "445304",
      "Kayar B.O": "445304",
      "Kona B.O": "445304",
      "Mandar B.O": "445304",
      "Mohurli B.O": "445304",
      "Zamkola B.O": "445304",
      "Bhari B.O": "445002",
      "Bhosa B.O": "445002",
      "Madkona B.O": "445002",
      "Madni B.O": "445002",
      "Murzadi B.O": "445002",
      "Nanza B.O": "445002",
      "Wadgaon Road B.O": "445002",
      "Waghapur B.O": "445002",
      "Yawali B.O": "445002",
      "Patan B.O": "445324",
      "Kolambi B.O": "445109",
      "Pahur Naskari B.O": "445109",
      "Pardi Naskari B.O": "445109",
      "Chikhli Izara B.O": "445103",
      "Dabhadi B.O": "445103",
      "Lonbehel B.O": "445103",
      "Dabha (Pahur) B.O": "445101",
      "Dighi B.O": "445101",
      "Falegaon B.O": "445101",
      "Sarul B.O": "445101",
      "Veni (Kotha) B.O": "445101",
      "Borgaon (Linga ) B.O": "445201",
      "Bhandegaon B.O": "445202",
      "Bhulai B.O": "445202",
      "Chikhali Ramnath B.O": "445202",
      "Dhamangaon Deo B.O": "445202",
      "Darati B.O": "445207",
      "Jeoli B.O": "445207",
      "Korta B.O": "445207",
      "Lakh Rayachi B.O": "445203",
      "Mal Hivara B.O": "445203",
      "Sakhara Wai B.O": "445203",
      "Tembhi B.O": "445230",
      "Akpuri B.O": "445301",
      "Anji (Nrusinha) B.O": "445301",
      "Ghoti B.O": "445301",
      "Sayat Kharda B.O": "445301",
      "Asegaon Devi B.O": "445001",
      "Kapra Methad B.O": "445001",
      "Karalgaon B.O": "445001",
      "Sawar B.O": "445001",
      "Shembal Pimpri B.O": "445209",
      "Loni B.O": "445323",
      "Mhasola B.O": "445105",
      "Dhotra B.O": "445401",
      "Pimpri Buti B.O": "445109",
      "Talni B.O": "445109",
      "Rani Dhanora B.O": "445103",
      "Sheloo B.O": "445103",
      "Kharda B.O": "445101",
      "Pahur (Dabha) B.O": "445101",
      "Rani Amravati B.O": "445101",
      "Jawalgaon B.O": "445201",
      "Ladkhed B.O": "445201",
      "Fubgaon Kharbi B.O": "445202",
      "Khopadi BK B.O": "445202",
      "Ramgaon Rameshwar B.O": "445202",
      "Shendri (Bk) B.. B.O": "445202",
      "Deurwada B.O": "445203",
      "Kalgaon B.O": "445203",
      "Singad B.O": "445203",
      "Tuptakli B.O": "445203",
      "Bhavani Jahagir B.O": "445230",
      "Ningnoor B.O": "445230",
      "Pandhurna Khurd B.O": "445301",
      "Rajurwadi B.O": "445301",
      "Lohara Izara B.O": "445209",
      "Pimpalgaon Raja B.O": "445401",
      "Sawargaon B.O": "445401",
      "Satefal B.O": "445210",
      "Tarnoli B.O": "445210",
      "Mudana B.O": "445205",
      "Sawana B.O": "445205",
      "Wadad B.O": "445205",
      "Buranda B.O": "445303",
      "Chinchala B.O": "445303",
      "Chinchmandal B.O": "445303",
      "Chinchoni Botoni B.O": "445303",
      "Narsala B.O": "445303",
      "Dabha B.O": "445323",
      "Taroda B.O": "445211",
      "Chikhali Kanhoba B.O": "445102",
      "Kharadgaon B.O": "445102",
      "Arjuna B.O": "445105",
      "Hiwari B.O": "445105",
      "Sonegaon B.O": "445401",
      "Hatola B.O": "445210",
      "Hudi B.O": "445205",
      "Morath B.O": "445205",
      "Arambhi B.O": "445110",
      "Khedbid B.O": "445110",
      "Hiwra Majra B.O": "445303",
      "Kumbha B.O": "445303",
      "Pendhari B.O": "445303",
      "Sagnapur B.O": "445303",
      "Bangaon B.O": "445102",
      "Brahmanwada B.O": "445102",
      "Malkhed BK B.O": "445102",
      "Sirasgaon Pandhari B.O": "445102",
      "Watfali B.O": "445102",
      "Sakur B.O": "445103",
      "Sukli B.O": "445103",
      "Ashti B.O": "445101",
      "Veni Kasba B.O": "445101",
      "Watkhed B.O": "445101",
      "Mozar Izara B.O": "445201",
      "Shelodi B.O": "445201",
      "Tiwasa B.O": "445201",
      "Mang Kinhi B.O": "445202",
      "Bittergaon B.O": "445207",
      "Dehni B.O": "445203",
      "Vithala B.O": "445203",
      "Saikhada BK B.O": "445301",
      "Sakhra Khurd B.O": "445301",
      "Shiroli B.O": "445301",
      "Shivani B.O": "445301",
      "Nakapardi B.O": "445105",
      "Rui B.O": "445105",
      "Amboda B.O": "445205",
      "Gunj B.O": "445205",
      "Daheli B.O": "445110",
      "Deurwadi Lad B.O": "445110",
      "Gondegaon B.O": "445110",
      "Haru B.O": "445110",
      "Mardi B.O": "445303",
      "Pisgaon B.O": "445303",
      "Wegaon B.O": "445303",
      "Pahur Izara B.O": "445323",
      "Runza B.O": "445323",
      "Sawarkheda B.O": "445323",
      "Wardh B.O": "445323",
      "Kolura B.O": "445102",
      "Malked Khurd B.O": "445102",
      "Mangala Devi B.O": "445102",
      "Manikwada B.O": "445102",
      "Mozar B.O": "445102",
      "Patharot B.O": "445102",
      "Salod B.O": "445109",
      "Borgaon Vitholi B.O": "445103",
      "Kawatha Bazar B.O": "445103",
      "Mahalungi B.O": "445103",
      "Ganori B.O": "445101",
      "Gharfal B.O": "445101",
      "Kotamba B.O": "445101",
      "Pachkhed B.O": "445101",
      "Pardi (Sawlapur) B.O": "445101",
      "Pimpalkhuta B.O": "445101",
      "Chikani B.O": "445201",
      "Kamathwada B.O": "445201",
      "Wadgaon Gadhwe B.O": "445201",
      "Karajgaon B.O": "445202",
      "Lakh Khind B.O": "445202",
      "Pimpalkhuta (R) B.O": "445202",
      "Talegaon Deshmukh B.O": "445202",
      "Krishnapur B.O": "445207",
      "Harsul B.O": "445203",
      "Kandali B.O": "445203",
      "Mokh B.O": "445203",
      "Tiwari B.O": "445203",
      "Vasant Nagar B.O": "445203",
      "Mowada B.O": "445301",
      "Patapangra B.O": "445301",
      "Yelabara B.O": "445301",
      "Asola B.O": "445001",
      "Sawargaon Bunglow B.O": "445209",
      "Bhamb Raja B.O": "445105",
      "Katri B.O": "445401",
      "Kanha B.O": "445205",
      "Mohatoli B.O": "445110",
      "Chopan B.O": "445303",
      "Jalka Road B.O": "445303",
      "Mhaisdodka B.O": "445303",
      "Nawargaon B.O": "445303",
      "Dongarkharda B.O": "445323",
      "Metikheda B.O": "445323",
      "Ajanti B.O": "445102",
      "Chikhali Domga B.O": "445102",
      "Pimpri Kalga B.O": "445102",
      "Uttarwadhona B.O": "445102",
      "Yavatmal H.O": "445001",
      "Babhulgaon S.O": "445101",
      "Fulsavangi S.O": "445230",
      "Govt Poly (Yavatmal) S.O": "445001",
      "Mahagaon (Yavatmal) S.O": "445205",
      "Mahagaon Kasba S.O": "445110",
      "Maregaon Road S.O": "445303",
      "Pandharkawda S.O": "445302",
      "Pusad S.O": "445204",
      "Sawali Sadoba S.O": "445106",
      "Sindhola Mines S.O": "445307",
      "Wadki S.O": "445308",
      "Bori Arab S.O": "445201",
      "Chhoti Gujri (Yavatmal) S.O": "445001",
      "Lohi S.O": "445210",
      "Mulawa S.O": "445211",
      "P.N.C. Pusad S.O": "445216",
      "Patanbori S.O": "445305",
      "Soot Girni S.O": "445215",
      "Tilakwadi (Yavatmal) S.O": "445001",
      "Akola Bazar S.O": "445109",
      "Darwha S.O": "445202",
      "Dhanki S.O (Yavatmal)": "445207",
      "Digras S.O": "445203",
      "Issapur S.O": "445209",
      "Jatra Road(Wani) S.O": "445304",
      "Mohda S.O": "445323",
      "Postal Colony (Yavatmal) S.O": "445001",
      "Ralegaon S.O": "445402",
      "Wani S.O": "445304",
      "Yavatmal Town S.O": "445001",
      "Zillla Parishad (Yavatmal) S.O": "445002",
      "Zari Jamni S.O": "445324",
      "Akhada Ward(Pandharkawada) S.O": "445302",
      "Arni S.O": "445103",
      "Awdhutwadi (Yavatma)l S.O": "445001",
      "Ghatanji S.O": "445301",
      "Jawala S.O (Yavatmal)": "445105",
      "Kalamb S.O (Yavatmal)": "445401",
      "Ner Parsopant S.O": "445102",
      "Parwa S.O": "445306",
      "Umarkhed S.O": "445206"
    },
    "NASHIK": {
      "Dalwat B.O": "423502",
      "Gosrane B.O": "423502",
      "Pimple KH B.O": "423502",
      "Bokte B.O": "423402",
      "Undirwadi B.O": "423402",
      "Dighwad B.O": "423101",
      "Vadbare B.O": "423101",
      "Mungse B.O": "423201",
      "Kapshi B.O": "423102",
      "Bordaivat B.O": "423502",
      "Chankapur B.O": "423502",
      "Angulgaon B.O": "423402",
      "Saygaon B.O": "423402",
      "Suregaon Rasta B.O": "423402",
      "Adgaon B.O": "422003",
      "Bhatgaon B.O": "423401",
      "Bhutayane B.O": "423101",
      "Daraswadi B.O": "423101",
      "Devargaon B.O": "422203",
      "Ganur B.O": "423101",
      "Hiwarkheda B.O": "423101",
      "Talwade B.O": "423101",
      "Vitave B.O": "423101",
      "Matane B.O": "423102",
      "Desgaon B.O": "423502",
      "Jaidhar B.O": "423502",
      "Jopul B.O": "422209",
      "Kazisangvi B.O": "423101",
      "Neminagar B.O": "423101",
      "Shelu B.O": "423101",
      "Dhavaleshwar B.O": "423201",
      "Patne B.O": "423201",
      "Bhaur B.O": "423102",
      "Kharde Wakhari B.O": "423102",
      "Malwadi B.O": "423102",
      "Kanashi B.O": "423502",
      "Kothare B.O": "423502",
      "Kundane B.O": "423502",
      "Ozar B.O": "423502",
      "Mangrul B.O": "423101",
      "Pate B.O": "423101",
      "Puri B.O": "423101",
      "Sogras B.O": "423101",
      "Aghar BK B.O": "423201",
      "Dahiwad B.O": "423102",
      "Khuntewadi B.O": "423102",
      "Vadgaon Pingala B.O": "422502",
      "Kherwadi R.S B.O": "422201",
      "Belatgavhan B.O": "422401",
      "Khadked B.O": "422402",
      "Khed B.O": "422402",
      "Waki B.O": "422402",
      "Barnes High School B.O": "422401",
      "Sanjegaon B.O": "422402",
      "Shevgedang B.O": "422402",
      "Tringalwadi B.O": "422402",
      "Murambi B.O": "422403",
      "Paste B.O": "422113",
      "Marhal BK B.O": "422606",
      "Nirhale B.O": "422606",
      "Jaigaon B.O": "422102",
      "Pimpalgaon Nipani B.O": "422102",
      "Shinde B.O": "422102",
      "Bhendali B.O": "422210",
      "Karanjaon B.O": "422210",
      "Shingwe B.O": "422210",
      "Dhondbhar B.O": "422103",
      "Dubera B.O": "422103",
      "Sonambe B.O": "422103",
      "Tamaswadi B.O": "422103",
      "Mithsagare B.O": "422104",
      "Sayale B.O": "422104",
      "Pathardi B.O": "422010",
      "Indore B.O": "422202",
      "Nilwandi B.O": "422202",
      "Ojharkhed B.O": "422204",
      "Vani Khurd B.O": "422202",
      "Walkhed B.O": "422202",
      "Ware B.O": "422202",
      "Dondegaon B.O": "422203",
      "Dugaon B.O": "423104",
      "Shivde B.O": "422502",
      "Kaluste B.O": "422402",
      "Kavnai B.O": "422402",
      "Aswali R.S B.O": "422403",
      "Bharvir BK B.O": "422403",
      "Bhavali Khurd B.O": "422403",
      "Gondedumala B.O": "422403",
      "Nandgaon B.O": "422305",
      "Taked BK B.O": "422403",
      "Talegaon (Igatpuri) B.O": "422403",
      "Wadivarhe B.O": "422403",
      "Bhojapur B.O": "422606",
      "Dapur B.O": "422606",
      "Brahmanwade B.O": "422212",
      "Lonarwadi B.O": "422103",
      "Mhalsakore B.O": "422103",
      "Nimgaon (Sinnar) B.O": "422103",
      "Pimpale B.O": "422103",
      "Somthane B.O": "422103",
      "Wavi Harsh B.O": "422214",
      "Gulvanch B.O": "422112",
      "Musalgaon B.O": "422112",
      "Belgaon Tarhale B.O": "422403",
      "Dhamangaon B.O": "422403",
      "Mukane B.O": "422403",
      "Waghare B.O": "422403",
      "Chas B.O": "422606",
      "Dodi B.O": "422606",
      "Kankuri B.O": "422606",
      "Wadgaon B.O": "422203",
      "Waghera B.O": "422203",
      "Shirasgaon (Peint) B.O": "422204",
      "Thanapada (Peint) B.O": "422204",
      "Kaudasar B.O": "422007",
      "Nanashi B.O": "422007",
      "Pahuchibari B.O": "422007",
      "Palasvihir B.O": "422007",
      "Police Training School B.O": "422007",
      "Dhakambe B.O": "422004",
      "Khatwad B.O": "422004",
      "Pimpalnare B.O": "423111",
      "Amba B.O": "422207",
      "Khadak Sukena B.O": "422207",
      "Darnasangvi B.O": "422003",
      "Mungsara B.O": "422003",
      "Devsane B.O": "422202",
      "Devthan B.O": "422202",
      "Nalwadpada B.O": "422202",
      "Nigdol B.O": "422202",
      "Sapte B.O": "422203",
      "Vilwandi B.O": "422203",
      "Dalpatpur B.O": "422204",
      "Deodongra B.O": "422204",
      "Jategaon BK B.O": "422204",
      "Kalmuste B.O": "422204",
      "Ambode B.O": "422007",
      "Ambupada B.O": "422007",
      "Jahule B.O": "422007",
      "Jalkhed B.O": "422007",
      "Korahte B.O": "422207",
      "Mohadi B.O": "422207",
      "Wadali Nazik B.O": "422207",
      "Jambutke B.O": "422003",
      "Lakhalgaon B.O": "422003",
      "Bhuvan B.O": "422208",
      "Borwat B.O": "422208",
      "Shenit B.O": "422502",
      "Jogalthembi B.O": "422102",
      "Naigaon B.O": "422102",
      "Baragaonpimpri B.O": "422103",
      "Konambe B.O": "422103",
      "Madhmeshwar B.O": "422103",
      "Panchale B.O": "422103",
      "Thangaon B.O": "423401",
      "Oney B.O": "422302",
      "Devgaon B.O": "422214",
      "Pathare B.O": "422104",
      "Pimplad B.O": "422306",
      "Bhanwad B.O": "422202",
      "Kazimale B.O": "422202",
      "Khedle B.O": "422202",
      "Koshimbe B.O": "422202",
      "Nalwadi B.O": "422202",
      "Palkhed Bandhara B.O": "422202",
      "Pimparkhed B.O": "424109",
      "Gangamhalungi B.O": "422203",
      "Malegaon B.O": "422203",
      "Bhonsala Military School B.O": "422013",
      "Berwal B.O": "422204",
      "Chinchwade B.O": "422204",
      "Kharshet B.O": "422204",
      "Kharwal B.O": "422204",
      "Nachlondi B.O": "422204",
      "Boys Town B.O": "422007",
      "Gandole B.O": "422007",
      "Mahaje B.O": "422007",
      "Janori B.O": "422207",
      "Shirasgaon B.O": "422207",
      "Ambegaon B.O": "422003",
      "Chitegaon B.O": "422003",
      "Makhmalabad B.O": "422003",
      "Odha B.O": "422003",
      "Rasegaon B.O": "422003",
      "Waghdad Dam B.O": "422003",
      "Amba (Peint) B.O": "422208",
      "Hatrundi (Peint) B.O": "422208",
      "Kopurli B.O": "422208",
      "Nirgude B.O": "422208",
      "Khirad B.O": "422211",
      "Umbarpada B.O": "422211",
      "Kathipada B.O": "422211",
      "Torangan B.O": "422212",
      "Anjneri B.O": "422213",
      "Mahiravani B.O": "422213",
      "Talegaon Anjneri B.O": "422213",
      "Maledumala B.O": "422215",
      "Pandane B.O": "422215",
      "Shivre B.O": "422215",
      "Pimpri B.O": "422302",
      "Pandurli B.O": "422502",
      "Dhondmal B.O": "422208",
      "Gonde B.O": "422606",
      "Kumbhale B.O": "422208",
      "Malegaon (Peint) B.O": "422208",
      "Mhasgan B.O": "422208",
      "Usthale B.O": "422208",
      "Alangun B.O": "422211",
      "Bhormal B.O": "422211",
      "Borgaon B.O": "422211",
      "Salbhoye B.O": "422211",
      "Sarad B.O": "422211",
      "Shribhuvan B.O": "422211",
      "Alwand B.O": "422212",
      "Ahiwantwadi B.O": "422215",
      "Bhatode B.O": "422215",
      "Chausale B.O": "422215",
      "Gangapur B.O": "422222",
      "Vinchuri dalvi B.O": "422502",
      "Vadner Dumala B.O": "422401",
      "Wadala B.O": "422006",
      "Khairgaon B.O": "422402",
      "Korapgaon B.O": "422402",
      "Wasali B.O": "422402",
      "Datli B.O": "422112",
      "Khopadi BK B.O": "422112",
      "Mundhegaon B.O": "422403",
      "Khambale B.O": "422606",
      "Chincholi B.O": "422102",
      "Jakhori B.O": "422102",
      "Palse B.O": "422102",
      "Vadzire B.O": "422102",
      "Chatori B.O": "422210",
      "Devpur B.O": "422103",
      "Manegaon B.O": "422103",
      "Patole B.O": "422103",
      "Vadangli B.O": "422103",
      "Kirtangali BO": "422103",
      "Dixi B.O": "422302",
      "Kotamgaon B.O": "422306",
      "Dahiwadi B.O": "422104",
      "Pangri BK B.O": "422104",
      "Shaha B.O": "422104",
      "Warwandi B.O": "423102",
      "Askheda B.O": "423303",
      "Sompur B.O": "423303",
      "Athambe B.O": "423501",
      "Desrane B.O": "423501",
      "Narul B.O": "423501",
      "Pimpalgaon Khamb B.O": "422010",
      "Vilholi B.O": "422010",
      "Awankhed B.O": "422202",
      "Karanjwan B.O": "422202",
      "Lakhmapur B.O": "422202",
      "Madkijamb B.O": "422202",
      "Pade B.O": "422202",
      "Titwe B.O": "422202",
      "Kochargaon B.O": "422203",
      "Rohile B.O": "422203",
      "Udhoji Maratha Boarding B.O": "422013",
      "Amlon B.O": "422204",
      "Chinchohol B.O": "422204",
      "Kulwandi B.O": "422204",
      "Barhe B.O": "422007",
      "Haste B.O": "422215",
      "Mankhed B.O": "422007",
      "Rakshasbhuvan B.O": "422007",
      "Akrale B.O": "422004",
      "Mhasrul B.O": "422004",
      "Talegaon(Dindori) B.O": "422004",
      "Jaulke B.O": "422207",
      "Kokangaon B.O": "422207",
      "Ashewadi B.O": "422003",
      "Chachadgaon B.O": "422003",
      "Dari B.O": "422003",
      "Madsangvi B.O": "422003",
      "Matori B.O": "422003",
      "Pimpri sayyed B.O": "422003",
      "Umrala B.O": "422003",
      "Asarbari B.O": "422208",
      "Meshi B.O": "423102",
      "Jalgaon Galane B.O": "423202",
      "Karanjali B.O": "422208",
      "Kohor B.O": "422208",
      "Mangone B.O": "422208",
      "Surgane (Peint) B.O": "422208",
      "Kukudane B.O": "422211",
      "Satkhamb B.O": "422211",
      "Umbarthan B.O": "422211",
      "Samundi B.O": "422212",
      "Talegaon (Trimbak) B.O": "422212",
      "Mavdi B.O": "422215",
      "Pimplus B.O": "422302",
      "Bubli B.O": "422211",
      "Hatgad B.O": "422211",
      "Hatrundi (Surgana) B.O": "422211",
      "Hatti B.O": "423117",
      "Mani B.O": "422211",
      "Mohpada B.O": "422211",
      "Palsan B.O": "422211",
      "Pangarne B.O": "422211",
      "Amboli B.O": "422212",
      "Aswali Harsh B.O": "422212",
      "Velunje B.O": "422212",
      "Zarwad B.O": "422212",
      "Khambala Anjeri B.O": "422213",
      "Pimpalgaon Bahula B.O": "422213",
      "Pimpalgaon Garudeshwar B.O": "422213",
      "Paregaon B.O": "422215",
      "Pimpri  achala B.O": "422215",
      "Agaskhind B.O": "422502",
      "Lahavit B.O": "422502",
      "Nanegaon B.O": "422502",
      "Pimpalgaon Dukra B.O": "422502",
      "Sakur B.O": "422502",
      "Rameshwar B.O": "423102",
      "Wajgaon B.O": "423102",
      "Wakhari B.O": "423106",
      "Pimpalgaon D B.O": "423202",
      "Tandulwadi B.O": "423303",
      "Deopur B.O": "422308",
      "Kumbhardi B.O": "422308",
      "Nandurdi B.O": "422308",
      "Ranwad B.O": "422308",
      "Ganore B.O": "423501",
      "Manur B.O": "423501",
      "Mokbhangi B.O": "423501",
      "Nanduri B.O": "423501",
      "Khedlezung B.O": "422305",
      "Pimpalgaon Wakhari B.O": "423102",
      "Bramanpade B.O": "423303",
      "Bej B.O": "423501",
      "Nivane B.O": "423501",
      "Rajapur B.O": "423403",
      "Pachore BK B.O": "422306",
      "Redgaon KH B.O": "422306",
      "Deoghat B.O": "423105",
      "Kalwadi B.O": "423105",
      "Karanjgavan B.O": "423105",
      "Tehare B.O": "423105",
      "Kanadgaon B.O": "423104",
      "Katarni B.O": "423104",
      "Khadgaon B.O": "423104",
      "Kundalgaon B.O": "423104",
      "Mamdapur B.O": "423403",
      "Matulthan B.O": "423403",
      "Kotbel B.O": "423204",
      "Shirpurwade B.O": "423204",
      "Tembhe B.O": "423204",
      "Bangaon B.O": "423106",
      "Bhalur B.O": "423106",
      "Dheku KH B.O": "423106",
      "Girnadam B.O": "423106",
      "Hiswal KH B.O": "423106",
      "Kalamdari B.O": "423106",
      "Kasari B.O": "423106",
      "Mohegaon B.O": "423106",
      "Chandanpuri B.O": "423212",
      "Khayde B.O": "423212",
      "Naitale B.O": "422303",
      "Shivare B.O": "422303",
      "Khalap B.O": "423301",
      "Lohoner B.O": "423301",
      "Mulane B.O": "423301",
      "Bopegaon B.O": "422205",
      "Shindwad B.O": "422205",
      "Tisgaon B.O": "423110",
      "Vahegaon Sal B.O": "422306",
      "Dahiwal B.O": "423105",
      "Padalde B.O": "423105",
      "Sayne BK B.O": "423105",
      "Tokade B.O": "423105",
      "Vajirkheda B.O": "423105",
      "Harnul B.O": "423104",
      "Malegaon Karyat B.O": "423104",
      "Nimon B.O": "423104",
      "Dhamode B.O": "423403",
      "Khirmani B.O": "423204",
      "Sarde B.O": "423204",
      "Utrane B.O": "423204",
      "Bolthan B.O": "423106",
      "Hiswal BK B.O": "423106",
      "Jategaon B.O": "423106",
      "Mandwad B.O": "423106",
      "Malgaon B.O": "423212",
      "Nimbayati B.O": "423212",
      "Kundewadi B.O": "422303",
      "Nandur Madhmeshwar B.O": "422303",
      "Ahergaon B.O": "422209",
      "Sakorewani B.O": "422209",
      "Ajmer Saundana B.O": "423301",
      "Arai B.O": "423301",
      "Jorandigar B.O": "423301",
      "Khamkheda B.O": "423301",
      "Kikwari KH B.O": "423301",
      "Nitane B.O": "423301",
      "Tilwan B.O": "423301",
      "Vasol B.O": "423301",
      "Erandgaon B.O": "423208",
      "Antapur B.O": "423302",
      "Pimpalkotha B.O": "423302",
      "Salher B.O": "423302",
      "Kumbharde B.O": "423110",
      "Kanmandale B.O": "423117",
      "Chinchave Galane B.O": "423206",
      "Shirasmani B.O": "423501",
      "Pilkos B.O": "423501",
      "Visapur B.O": "423501",
      "Brahmangaon B.O": "423213",
      "Dhandri B.O": "423213",
      "Shemli B.O": "423213",
      "Chinchgavan B.O": "423105",
      "Khadki B.O": "423105",
      "Soygaon B.O": "423203",
      "Ankai B.O": "423104",
      "Daregaon B.O": "423104",
      "Wakad B.O": "422305",
      "Erandgaon Jeur B.O": "423401",
      "Mukhed B.O": "422209",
      "Patoda B.O": "423401",
      "Galane B.O": "423205",
      "Palasdare B.O": "423205",
      "Vithewadi B.O": "423301",
      "Morenagar B.O": "423301",
      "Aghar KH B.O": "423208",
      "Bhilwad B.O": "423302",
      "Daswel B.O": "423302",
      "Golwad B.O": "423302",
      "Mulher B.O": "423302",
      "Rishabhgiri B.O": "423302",
      "Chinchave B.O": "423110",
      "Girnare B.O": "423110",
      "Dhulgaon B.O": "423401",
      "Somthandesh B.O": "423401",
      "Vikharni B.O": "423401",
      "Tingri B.O": "423205",
      "Bharam B.O": "423401",
      "Chinchondi B.O": "423401",
      "Deshmane B.O": "423401",
      "Nimgaon Madh B.O": "423401",
      "Savargaon B.O": "423106",
      "Shirasgaon Lauki B.O": "423401",
      "Astane B.O": "423205",
      "Chikhalohal B.O": "423205",
      "Dongrale B.O": "423205",
      "Sapthshringigarh B.O": "423501",
      "Bahaduri B.O": "422205",
      "Sonjamb B.O": "422205",
      "Varkheda B.O": "422205",
      "Mahalpatane B.O": "423213",
      "Takali KH B.O": "422306",
      "Kukane B.O": "423105",
      "Ronzane B.O": "423105",
      "Sherul B.O": "423105",
      "Vadgaon B.O": "423105",
      "Jalgaon Nimbayati B.O": "423104",
      "Nagapur B.O": "423104",
      "Raipur B.O": "423104",
      "Vanjarwadi B.O": "423104",
      "Khirdisathe B.O": "423403",
      "Kusur B.O": "423403",
      "Ambasan B.O": "423204",
      "Dyane B.O": "423204",
      "Borale B.O": "423106",
      "Jamdhari B.O": "423106",
      "Vehelgaon B.O": "423106",
      "Jalgaon KH B.O": "424109",
      "Pardhadi B.O": "424109",
      "Mehune B.O": "423212",
      "Sakuri B.O": "423212",
      "Gajarwadi B.O": "422303",
      "Sarolethadi B.O": "422303",
      "Chinchkhed B.O": "422209",
      "Dhondgavan B.O": "422209",
      "Karsul B.O": "422209",
      "Materewadi B.O": "422209",
      "Pachorewani B.O": "422209",
      "Umbarkhed B.O": "422209",
      "Vaygaon B.O": "423108",
      "Akhatwade B.O": "423301",
      "Kandane B.O": "423301",
      "Karanjad B.O": "423301",
      "Khamtane B.O": "423301",
      "Munjwad B.O": "423301",
      "Vanoli B.O": "423301",
      "Virgaon B.O": "423301",
      "Kaulana B.O": "423208",
      "Savkarwadi B.O": "423208",
      "Aliyabad B.O": "423302",
      "Otur B.O": "423501",
      "Waghamba B.O": "423302",
      "Khadak Malegaon B.O": "422304",
      "Dongargaon B.O": "422305",
      "Khadakjamb B.O": "423117",
      "Kashti B.O": "423206",
      "Virane B.O": "423206",
      "Deogaon B.O": "422305",
      "Rui B.O": "422305",
      "Angangaon B.O": "423401",
      "Jalgaon Neur B.O": "423401",
      "Nagda B.O": "423401",
      "Pimpalgaon Jalal B.O": "423401",
      "Kaulane B.O": "423205",
      "Rajmane B.O": "423205",
      "Pale BK B.O": "423501",
      "Sakora B.O": "423501",
      "Ravalji B.O": "423501",
      "Shingve B.O": "423104",
      "Talegaon Rui B.O": "423104",
      "Uswad B.O": "423104",
      "Vadgaon Pangu B.O": "423104",
      "Kusmadi B.O": "423403",
      "Chirai B.O": "423204",
      "Pokhari B.O": "423106",
      "Sakore B.O": "423106",
      "Vadali BK B.O": "423106",
      "Chandora B.O": "424109",
      "Yesgaon B.O": "423212",
      "Dhrangaon Veer B.O": "422303",
      "Kathargaon B.O": "422303",
      "Kothure B.O": "422303",
      "Dawachwadi B.O": "422209",
      "Jawalkewani B.O": "422209",
      "Lonwadi B.O": "422209",
      "Palkhed B.O": "422209",
      "Aundane B.O": "423301",
      "Chaugaon B.O": "423301",
      "Chaundana B.O": "423301",
      "Dangsaundane B.O": "423301",
      "Karhe B.O": "423301",
      "Kelzar B.O": "423301",
      "Kersane B.O": "423301",
      "Savki  Lohoner B.O": "423301",
      "Talwadedigar B.O": "423301",
      "Thengoda B.O": "423301",
      "Shirsondi B.O": "423208",
      "Sonaj B.O": "423208",
      "Takali B.O": "423208",
      "Zadi B.O": "423208",
      "Vanasgaon B.O": "422304",
      "Bhayale B.O": "423117",
      "Dhodamba B.O": "423117",
      "Redgaon BK B.O": "423111",
      "Shirwade B.O": "423111",
      "Khakurdi B.O": "423206",
      "Pohane B.O": "423206",
      "Vadel B.O": "423206",
      "Valwade B.O": "423206",
      "Gondegaon B.O": "422305",
      "Malegaon H.O": "423203",
      "Nashik H.O": "422001",
      "Nashik Road H.O": "422101",
      "MUHS S.O": "422004",
      "Satpur Township S.O": "422007",
      "Bhagur S.O": "422502",
      "Devlali Bazar S.O": "422401",
      "Panchvati S.O": "422003",
      "Surgana S.O": "422211",
      "Trimbak S.O": "422212",
      "Trimbak Vidya Mandir S.O": "422213",
      "Vani S.O": "422215",
      "Ghoti S.O": "422402",
      "I.A. Musalgaon Sinnar S.O": "422112",
      "Nashik City S.O": "422001",
      "Ojhar A.F. Stn. S.O": "422221",
      "Peint S.O": "422208",
      "Chandori S.O": "422201",
      "Gandhi Nagar (Nashik) S.O": "422006",
      "Meri Colony S.O": "422004",
      "Nashik Main Road S.O": "422001",
      "Ojhar S.O": "422206",
      "Ojhar T.S. S.O": "422207",
      "Puria Park S.O": "422003",
      "Sawarkar Nagar S.O": "422013",
      "Trimurti Chowk S.O": "422008",
      "Ycm Open Univesity S.O": "422222",
      "B.S. Nagar S.O": "422301",
      "Devlali Air Force S.O": "422501",
      "Devlali S.O": "422401",
      "Ind. Est. Malegaon Sinnar S.O": "422113",
      "Nashik Road Camp S.O": "422102",
      "Sinnar S.O": "422103",
      "Upnagar S.O": "422006",
      "Nandurshingote S.O": "422606",
      "Nehru Nagar S.O (Nashik)": "422101",
      "Saykheda S.O": "422210",
      "Idgaon Devlali S.O": "422101",
      "India Security Press S.O": "422101",
      "Sukena S.O": "422302",
      "Wavi S.O": "422104",
      "Abhona S.O": "423502",
      "Igatpuri S.O": "422403",
      "TP Station Eklahre S.O": "422105",
      "Vaitarna Nagar S.O": "422214",
      "Chandwad S.O": "423101",
      "Jaikheda S.O": "423303",
      "Malegaon Camp S.O": "423105",
      "Manmad S.O": "423104",
      "Market Yard Malegaon S.O": "423203",
      "Nagarsul S.O": "423403",
      "G.S.S.K. S.O": "423202",
      "Nampur S.O": "423204",
      "Niphad S.O": "422303",
      "Ravalgaon S.O": "423108",
      "Andarsul S.O": "423402",
      "Dabhadi S.O": "423201",
      "Devla S.O": "423102",
      "K.K.Nagar S.O (Nashik)": "422308",
      "Kalwan S.O": "423501",
      "Khedgaon S.O (Nashik)": "422205",
      "Lakhamapur S.O": "423213",
      "Lasalgaon S.O": "422306",
      "Manmad Shiwaji Chouk S.O": "423104",
      "Nandgaon S.O": "423106",
      "Satana S.O": "423301",
      "Ugaon S.O": "422304",
      "Umrana S.O": "423110",
      "Vadner Bhairav S.O": "423111",
      "Zodga S.O": "423205",
      "Ashok Nagar S.O (Nashik)": "422012",
      "Budhwar Peth S.O": "422001",
      "Dindori S.O (Nashik)": "422202",
      "Girnara S.O": "422203",
      "Industrial Estate S.O (Nashik)": "422007",
      "Kalaram Mandir S.O": "422003",
      "Naydongri S.O": "424109",
      "Sangmeshwar Malegaon S.O": "423203",
      "Satana Market S.O": "423301",
      "Saundana S.O": "423208",
      "Vinchur S.O": "422305",
      "Jeevan Prakash S.O": "422002",
      "Taharabad S.O": "423302",
      "Yeola S.O": "423401",
      "Ambad A.S. S.O": "422010",
      "Dwarka Corner S.O": "422011",
      "Harsul S.O": "422204",
      "Vadali Bhoi S.O": "423117",
      "Vadner Malegaon S.O": "423206",
      "Yeola Kutcheri Road S.O": "423401",
      "Malegaon City S.O": "423203",
      "Malegaon Nayapura Ward S.O": "423203",
      "Nimgaon S.O": "423212",
      "Pimpalgaon Baswant S.O": "422209",
      "Cidco Colony S.O (Nashik)": "422009",
      "Gole Colony S.O": "422002",
      "H P T College S.O": "422005",
      "Indira Nagar S.O (Nashik)": "422009"
    },
    "WASHIM": {
      "Jaipur B.O": "444507",
      "Pardi Asra B.O": "444507",
      "Pimpalgaon B.O": "444507",
      "Bembla B.O": "444110",
      "Bhamb B.O": "444110",
      "Loni Arab B.O": "444105",
      "Manabha B.O": "444105",
      "Poha B.O": "444105",
      "Shaha B.O": "444105",
      "Mungla B.O": "444503",
      "Nagardas B.O": "444503",
      "Nandhana B.O": "444503",
      "Pangri Kute B.O": "444503",
      "Yekamba B.O": "444503",
      "Kalambeshwar B.O": "444503",
      "Kenwad B.O": "444503",
      "Gaiwal B.O": "444403",
      "Girda B.O": "444403",
      "Giroli B.O": "444403",
      "Hivra BK B.O": "444403",
      "Sawali B.O": "444507",
      "Warala B.O": "444507",
      "Kalamba Bodkhe B.O": "444409",
      "Dhanaj BK B.O": "444110",
      "Hinganwadi B.O": "444110",
      "Jamb B.O": "444105",
      "Umbarda Bazar B.O": "444105",
      "Amkheda B.O": "444503",
      "Dawha B.O": "444503",
      "Amana B.O": "444503",
      "Medshi B.O": "444503",
      "Dhamni B.O": "444403",
      "Kawathal B.O": "444403",
      "Sakhardoh B.O": "444403",
      "Shendurjana B.O": "444403",
      "Bhuli B.O": "444404",
      "Karli B.O": "444505",
      "Kondoli B.O": "444404",
      "Umari B.O": "444404",
      "Waigaul B.O": "444404",
      "Asola KD B.O": "444404",
      "Pohara Devi B.O": "444404",
      "Rui B.O": "444404",
      "Shendona B.O": "444404",
      "Talap BK B.O": "444404",
      "Waroli B.O": "444404",
      "Umara Shamshuddin B.O": "444507",
      "Arak B.O": "444409",
      "Dhanaj KD B.O": "444110",
      "Ladegaon B.O": "444110",
      "Kherda B.O": "444105",
      "Sukali B.O": "444105",
      "Wai Pargane Mangrulpir B.O": "444105",
      "Jaulka B.O": "444503",
      "Anchal B.O": "444503",
      "Kinhiraja  B.O": "444503",
      "Pangra Bandi B.O": "444503",
      "Dongarkinhi B.O": "444503",
      "Dabha B.O": "444403",
      "Fulumari B.O": "444403",
      "Kasola B.O": "444403",
      "Mendra B.O": "444403",
      "Poti B.O": "444403",
      "Shegi B.O": "444403",
      "Dapura Kd B.O": "444404",
      "Karkheda B.O": "444404",
      "Kupta B.O": "444404",
      "Tornala B.O": "444505",
      "Vitholi B.O": "444404",
      "Wara Jahangir B.O": "444409",
      "Falegaon B.O": "444409",
      "Dhanora KD B.O": "444409",
      "Pimpri Modak B.O": "444110",
      "Vilegaon B.O": "444110",
      "Yawardi B.O": "444105",
      "Yeota B.O": "444504",
      "Zodga B.O": "444105",
      "Marsul B.O": "444503",
      "Rajura B.O": "444503",
      "Pangri Navghare B.O": "444503",
      "Kothari B.O": "444403",
      "Mohari B.O": "444403",
      "Palodi B.O": "444403",
      "Parwa B.O": "444403",
      "Poghat B.O": "444403",
      "Dhanora Ghatge  B.O": "444404",
      "Dhawanda B.O": "444404",
      "Gawha  B.O": "444404",
      "Inzori B.O": "444404",
      "Wakad B.O": "444506",
      "Gobhani B.O": "444504",
      "Gowardhan B.O": "444504",
      "Karanji B.O": "444504",
      "Keshavnagar B.O": "444504",
      "Masalapen B.O": "444504",
      "Navali B.O": "444504",
      "Netansa B.O": "444504",
      "Bhatumara B.O": "444505",
      "Chinchamba Bhar B.O": "444506",
      "Loni Sm B.O": "444506",
      "Mahagaon B.O": "444506",
      "Mandwa B.O": "444506",
      "Mop B.O": "444506",
      "Mothegaon B.O": "444506",
      "Chikhali B.O": "444510",
      "Hivara Rohila B.O": "444510",
      "Koyali BK B.O": "444510",
      "Sawargaon Jire B.O": "444510",
      "Pardi Tad B.O": "444402",
      "Pedgaon B.O": "444402",
      "Sonala B.O (Washim)": "444402",
      "Tarhala B.O": "444402",
      "Kata B.O": "444505",
      "Kokalgaon B.O": "444505",
      "Mohoja B.O": "444505",
      "Tamsi B.O": "444505",
      "Tandali BK B.O": "444505",
      "Tandali Shewai B.O": "444505",
      "Tondgaon B.O": "444505",
      "Sawad B.O": "444506",
      "Shelukhadse B.O": "444506",
      "Adoli B.O": "444510",
      "Kanzara B.O": "444402",
      "Wanoja B.O": "444402",
      "Lehani B.O": "444504",
      "Mangul Zanak B.O": "444504",
      "Wasari B.O": "444504",
      "Dhumka B.O": "444505",
      "Kalamba Mahali B.O": "444505",
      "Soyata B.O": "444505",
      "Yeranda B.O": "444505",
      "Bhar B.O": "444506",
      "Kawatha Naik B.O": "444506",
      "Assegaon Pen B.O": "444510",
      "Haral B.O": "444510",
      "Nagthana B.O": "444510",
      "Vyad B.O": "444510",
      "Yeoti B.O": "444510",
      "Chinchambapen B.O": "444504",
      "Khandala Shinde B.O": "444504",
      "Linga Kotwal B.O": "444504",
      "Tiwali B.O": "444504",
      "Kajalamba B.O": "444505",
      "Kekatumara B.O": "444505",
      "Chivara B.O": "444505",
      "Pardi Takmore B.O": "444505",
      "Ukali Jahangir B.O": "444505",
      "Asegaon S.O": "444409",
      "Kamargaon S.O (Washim)": "444110",
      "Mangrulpir S.O": "444403",
      "Manora S.O (Washim)": "444404",
      "Rithad S.O": "444510",
      "Shelubazar S.O": "444402",
      "Shirpur S.O": "444504",
      "Washim S.O": "444505",
      "Ansing S.O": "444507",
      "Karanja S.O (Washim)": "444105",
      "Washim City S.O": "444505",
      "Gurumandir Karanja S.O": "444105",
      "Malegaon S.O": "444503",
      "Risod S.O": "444506"
    },
    "AHMEDNAGAR": {
      "Bhoyare Pathar B.O": "414005",
      "Chas B.O": "422610",
      "Ghospuri B.O": "414005",
      "Chombhut B.O": "414305",
      "Padali Ale B.O": "414305",
      "Arangaon Dumala B.O": "413702",
      "Belwandi S.F. B.O": "413702",
      "Deodaithan B.O": "413702",
      "Rajapur B.O": "422605",
      "Khampimpri B.O": "414503",
      "Bhatodi B.O": "414201",
      "Narayan Doho B.O": "414201",
      "Sandve B.O": "414201",
      "Sarolabadhi B.O": "414201",
      "Kangoni B.O": "414607",
      "Agadgaon B.O": "414002",
      "Darewadi B.O": "414002",
      "Kapurwadi B.O": "414002",
      "Ruichattisi B.O": "414002",
      "Astagaon B.O": "414005",
      "Bhorwadi B.O": "414005",
      "Sarola Kasar B.O": "414005",
      "Darodi B.O": "414305",
      "Loni Mavala B.O": "414305",
      "Loni Vyanknath B.O": "413702",
      "Padali Ranjangaon B.O": "413702",
      "Ukkadgaon B.O": "413702",
      "Kambi B.O": "414503",
      "Mungi B.O": "414503",
      "Kauthe B.O": "414701",
      "Takali Kazi B.O": "414201",
      "Lohgaon B.O": "413712",
      "Bhandgaon B.O": "414103",
      "Burhan Nagar B.O": "414002",
      "Gunwadi B.O": "414002",
      "Kaudgaon B.O": "413201",
      "Shiradhon B.O": "414002",
      "Akolner B.O": "414005",
      "Pimpalgaon Kauda B.O": "414005",
      "Kalas B.O": "414305",
      "Shekte B.O": "414504",
      "Dhavalgaon B.O": "413702",
      "Mhase B.O": "413702",
      "Chapadgaon B.O": "414401",
      "Hatgaon B.O": "414503",
      "Mehekari B.O": "414002",
      "Nagardeola B.O": "414002",
      "Nimbodi B.O": "413201",
      "Watephal B.O": "414002",
      "Kamargaon B.O": "414005",
      "Nepti B.O": "414005",
      "Nimgaon Wagha B.O": "414005",
      "Gaikwad Jalgaon B.O": "414504",
      "Pargaon Sudrik B.O": "413702",
      "Pimpri Kolandar B.O": "413702",
      "Thakur Pimpalgaon B.O": "414503",
      "Rastapur B.O": "414606",
      "Singave Tukai B.O": "414607",
      "Agasti SSK B.O": "422601",
      "Deothan B.O": "422601",
      "Sangvi B.O": "422601",
      "Dadh BK B.O": "413714",
      "Kokangaon B.O": "414401",
      "Shedgaon B.O": "413701",
      "Warwandi B.O": "413738",
      "Mamdapur B.O": "413737",
      "Rajuri B.O": "413204",
      "Bhamathan B.O": "413739",
      "Bhokar B.O": "413739",
      "Dhokari B.O": "422601",
      "Gardani B.O": "422601",
      "Kumbhephal B.O": "422601",
      "Padoshi B.O": "422601",
      "Tahakari B.O": "422601",
      "Thugaon BK B.O": "422601",
      "Tirdhe B.O": "422601",
      "Zarekathi B.O": "413714",
      "Panodi B.O": "413738",
      "Dhamangaon Awari B.O": "422601",
      "Ekdara B.O": "422601",
      "Muthalane B.O": "422601",
      "Rumbhodi B.O": "422601",
      "Samsherpur B.O": "422601",
      "Savargaon Pat B.O": "422601",
      "Nimgaon Jali B.O": "413714",
      "Kharshinde B.O": "413738",
      "Pimpri Lauki B.O": "413738",
      "Khirdi B.O": "413725",
      "Khokar B.O": "413739",
      "Kamalpur B.O": "413725",
      "Subhashwadi B.O": "413720",
      "Malvadgaon B.O": "413739",
      "Shirasgaon B.O": "423603",
      "Nanaj Dumala B.O": "422611",
      "Nipani Vadgaon B.O": "413739",
      "Pachegaon B.O": "413725",
      "Khandala Nandur B.O": "413720",
      "Keli Rumhanwadi B.O": "422601",
      "Khirvire B.O": "422601",
      "Kombhalane B.O": "422601",
      "Tambhol B.O": "422601",
      "Ambi B.O": "413715",
      "Ukkalgaon B.O": "413715",
      "Usthal Dumala B.O": "414609",
      "Taklimiya B.O": "413716",
      "Jawale Baleshwar B.O": "422620",
      "Sarole Pathar B.O": "422620",
      "Malewadi B.O": "413718",
      "Undirgaon B.O": "413718",
      "Karegaon B.O": "413717",
      "Chincholi Bk B.O": "413710",
      "Galnimb B.O": "414603",
      "Mahegaon Deshmukh B.O": "423602",
      "Sangvi Bhusar B.O": "423602",
      "Chandekasare B.O": "423601",
      "Madhi BK B.O": "423601",
      "Ravande B.O": "423601",
      "Karandi B.O": "414303",
      "Palsunde B.O": "422610",
      "Pimpalgaon Khad B.O": "422610",
      "Georai B.O": "414604",
      "Tarwadi B.O": "414604",
      "Kawathe Kamaleshwar B.O": "422611",
      "Paregaon BK B.O": "422611",
      "Khedle Kajali B.O": "414603",
      "Murme (Deogad) B.O": "414603",
      "Ramdoh B.O": "414603",
      "Varkhed B.O": "414603",
      "Bherdapur B.O": "413721",
      "Naur B.O": "413707",
      "Korhale B.O": "423107",
      "Sakuri B.O": "423107",
      "Guha B.O": "413706",
      "Tambhere B.O": "413706",
      "Amarapur B.O": "414505",
      "Avane BK B.O": "414505",
      "Sultanpur KHD B.O": "414505",
      "Susare B.O": "414505",
      "Kondhwad B.O": "413705",
      "Vavrath B.O": "413705",
      "Bhandardara B.O": "422604",
      "Lavhali Otur B.O": "422604",
      "Manhere B.O": "422604",
      "Sakirwadi B.O": "422604",
      "Udadawane B.O": "422604",
      "Wakadi B.O": "414604",
      "Bhojade B.O": "413708",
      "Kanhegaon B.O": "413708",
      "Mandve Kd B.O": "422622",
      "Pimpalgaon Depa B.O": "422622",
      "Ganore B.O": "422605",
      "Jawale Kadlag B.O": "422605",
      "Kanoli B.O": "422605",
      "Belapur Kd B.O": "413715",
      "Belapur Badgi B.O": "422602",
      "Bhojdari B.O": "422602",
      "Jalgaon B.O": "413723",
      "Nimgaon Khairi B.O": "413723",
      "Karwadi B.O": "423604",
      "Maygaon Devi B.O": "423607",
      "Kalas Bk B.O": "422603",
      "Nimgaon Bk B.O": "422603",
      "Pemgiri B.O": "422603",
      "Aklapur B.O": "422620",
      "Dolasane B.O": "422620",
      "Savargaon Ghule B.O": "422620",
      "Varudi Pathar B.O": "422620",
      "Dharangaon B.O": "423601",
      "Jeur Kumbhari B.O": "423601",
      "Kokamthan B.O": "423601",
      "Bramhanwada B.O": "422610",
      "Dhamngaon Pat B.O": "422610",
      "Waghapur B.O": "422605",
      "Dedgaon B.O": "414604",
      "Deogaon B.O": "422604",
      "Bhalgaon B.O": "414113",
      "Salabatpur B.O": "414603",
      "Suregaon B.O": "413703",
      "Toka B.O": "414603",
      "Malunja BK B.O": "413721",
      "Malunja Kd B.O": "413721",
      "Pathare Kd B.O": "413721",
      "Tisgaon B.O": "413712",
      "Astgaon B.O": "423107",
      "Mhaisgaon B.O": "413706",
      "Taharabad B.O": "413706",
      "Mulanagar B.O": "413722",
      "Baragaon Nandur B.O": "413705",
      "Manjari B.O": "413705",
      "Manori B.O": "413705",
      "Chitalvedhe B.O": "422604",
      "Ukkhalgaon B.O": "413703",
      "Jawkhede Khalsa B.O": "414505",
      "Kasar Pimpalgaon B.O": "414505",
      "Padali B.O": "414505",
      "Dhamanvan B.O": "422604",
      "Ghatghar B.O": "422604",
      "Muthkhel B.O": "422604",
      "Padalane B.O": "422604",
      "Pimpalgaon Nakvinda B.O": "422604",
      "Pimparkane B.O": "422604",
      "Waki B.O": "422604",
      "Waranghushi B.O": "422604",
      "Wari B.O": "413708",
      "Maldad B.O": "422608",
      "Ambhore B.O": "422605",
      "Chandanapuri B.O": "422605",
      "Chikani B.O": "422605",
      "Chikhali B.O": "413728",
      "Nimgaon Tembhi B.O": "422605",
      "Pimpalgaon Matha B.O": "422605",
      "Pimpalgaon Nipani B.O": "422605",
      "Pimparane B.O": "422605",
      "Lonkarwasti B.O": "423603",
      "Padhegaon B.O": "423603",
      "Samvatsar B.O": "423603",
      "Malunja B.O": "422605",
      "Nimaj B.O": "422605",
      "Godhegaon B.O": "423603",
      "Matapur B.O": "413717",
      "Kolhar Kd B.O": "413710",
      "Rampur B.O": "413710",
      "Kolgaon Thadi B.O": "423602",
      "Kumbhari B.O": "423602",
      "Malegaon Thadi B.O": "423602",
      "Yesgaon B.O": "423601",
      "Keli Kotul B.O": "422610",
      "Kohane B.O": "422610",
      "Lingdeo B.O": "422610",
      "Chinchpur BK B.O": "413736",
      "Gogalgaon B.O": "413736",
      "Hasanapur B.O": "413736",
      "Lohare Mirpur B.O": "413736",
      "Chincholi Gurav B.O": "422611",
      "Mukindpur B.O": "414603",
      "Jawalke B.O": "423605",
      "Ranjangaon Deshmukh B.O": "423605",
      "Sonewadi B.O": "423605",
      "Kangar B.O": "413706",
      "Kolewadi B.O": "413706",
      "Tandulwadi B.O": "413705",
      "Valan B.O": "413705",
      "Jambut B.O": "422622",
      "Kuthe Malkapur B.O": "422622",
      "Dongargaon B.O": "422605",
      "Jorve B.O": "422605",
      "Kolhewadi B.O": "422605",
      "Kuran B.O": "422605",
      "Savargaon Tal B.O": "422605",
      "Sukewadi B.O": "422605",
      "Vadgaon Pan B.O": "422605",
      "Virgaon B.O": "422605",
      "Pimplwadi B.O": "423109",
      "Rui B.O": "423109",
      "Narsali B.O": "413715",
      "Umbargaon B.O": "413715",
      "Badgi B.O": "422602",
      "Chitali B.O": "413723",
      "Gondegaon B.O": "413723",
      "Manjur B.O": "423604",
      "Musalwadi B.O": "413716",
      "Nanduri Dumala B.O": "422603",
      "Vadgaon Landaga B.O": "422603",
      "Kothe BK B.O": "422620",
      "Nandur Khandarmal B.O": "422620",
      "Fatyabad B.O": "413710",
      "Velapur B.O": "423602",
      "Bramhangaon B.O": "423601",
      "Derde Korhale B.O": "423601",
      "Kopargaon Bet B.O": "423601",
      "Murshatpur B.O": "423601",
      "Takali B.O": "423601",
      "Ambhol B.O": "422610",
      "Pangari B.O": "422610",
      "Satewadi B.O": "422610",
      "Jeur B.O": "414604",
      "Telkudgaon B.O": "414604",
      "Nimon B.O": "422611",
      "Jalke Kd B.O": "414603",
      "Nevasa Bk B.O": "414603",
      "Lakh B.O": "413721",
      "Kelwad B.O": "423107",
      "Pimpri Nirmal B.O": "423107",
      "Chikalthan B.O": "413706",
      "Kanadgaon B.O": "413706",
      "Varshinde B.O": "413706",
      "Aradgaon B.O": "413705",
      "Jambhali B.O": "413705",
      "Chinchale B.O": "413705",
      "Bari B.O": "422604",
      "Chinchavane B.O": "422604",
      "Katalapur B.O": "422604",
      "Malegaon B.O": "414502",
      "Maveshi B.O": "422604",
      "Ranad Bk B.O": "422604",
      "Shenit B.O": "422604",
      "Vithe B.O": "422604",
      "Ekrukhe B.O": "413719",
      "Dhotre B.O": "413708",
      "Shingave B.O": "413708",
      "Hivargaon Pathar B.O": "422622",
      "Mandve Bk B.O": "422622",
      "Nandur Nimba Daitya B.O": "414113",
      "Dhorje B.O": "413728",
      "Ghargaon B.O": "413728",
      "Gundegaon B.O": "414101",
      "Dighi B.O": "414401",
      "Ghogargaon B.O": "413725",
      "Guravpimpri B.O": "414401",
      "Khandvi B.O": "414401",
      "Nimgaon Gangarda B.O": "414401",
      "Pategaon B.O": "414401",
      "Mahalaxmi Hiware B.O": "414501",
      "Maka B.O": "414501",
      "Fakrabad B.O": "413205",
      "Ghodegaon B.O": "413205",
      "Yeli B.O": "414113",
      "Ghotvi B.O": "413728",
      "Pisorekhand B.O": "414101",
      "Ralegan B.O": "414101",
      "Karjune Khare B.O": "414111",
      "Babhulgaon Khalsa B.O": "414401",
      "Diksal B.O": "414401",
      "Kaundane B.O": "414401",
      "Patewadi B.O": "414401",
      "Khospuri B.O": "414501",
      "Nimbe Nandur B.O": "414501",
      "Shingave Keshav B.O": "414501",
      "Chondi B.O": "413205",
      "Pimparkhed B.O": "413205",
      "CHOBHEWADI": "413205",
      "Loni Haveli B.O": "414302",
      "Padali Darya B.O": "414302",
      "Pimprijalsen B.O": "414302",
      "Akhegaon Titarfa B.O": "414102",
      "Akola B.O": "414102",
      "Chichpur Pangul B.O": "414102",
      "Mohote B.O": "414102",
      "Pimpalgaontappa B.O": "414102",
      "Chilwadi B.O": "414403",
      "Jssk B.O": "414403",
      "Bhatkudgaon B.O": "414502",
      "Joharapur B.O": "414502",
      "Ranegaon B.O": "414502",
      "Samangaon B.O": "414502",
      "Tajnapur B.O": "414502",
      "Adhalgaon B.O": "413701",
      "Takali Kadewalit B.O": "413701",
      "Tandali Dumala B.O": "413701",
      "Limpangaon B.O": "413726",
      "Mhasane B.O": "414302",
      "Pimpalner B.O": "414302",
      "Chinchpur Ijde B.O": "414102",
      "Pagori Pimpalgaon B.O": "414102",
      "Sakegaon B.O": "414102",
      "Takali Manur B.O": "414102",
      "Baradgaon Sudrik B.O": "414403",
      "Bhambora B.O": "414403",
      "Ladjalgaon B.O": "414502",
      "Rakshi B.O": "414502",
      "Shahar Takali B.O": "414502",
      "Shingori B.O": "414502",
      "Hiwargaon Pawasa B.O": "422605",
      "Khandgaon B.O": "422605",
      "Nilwande B.O": "422605",
      "Nimgaon Bhojapur B.O": "422605",
      "Samnapur B.O": "422605",
      "Dahigaon Bolka B.O": "423603",
      "Karanji Bk B.O": "423603",
      "Laxmiwadi B.O": "423109",
      "Nimbhere B.O": "413711",
      "Pathre Bk B.O": "413711",
      "Belpimpalgaon B.O": "413725",
      "Mali Chinchore B.O": "414602",
      "Tamaswadi B.O": "414602",
      "Deulgaon Sidhhi B.O": "414006",
      "Meherabad B.O": "414006",
      "Walki B.O": "414006",
      "Babhurdi B.O": "413703",
      "Chamburdi B.O": "413703",
      "Pimpalgaon Pisa B.O": "413703",
      "Kharwandi B.O": "414602",
      "Baburdi Ghumat B.O": "414006",
      "Hivare Zare B.O": "414006",
      "Khandala B.O": "414006",
      "Vadgaon Tandali B.O": "414006",
      "Dhamori B.O": "413704",
      "Katrad B.O": "413704",
      "Khandgaon Lohsar B.O": "414106",
      "Majle Chincholi B.O": "414106",
      "Mandve B.O": "414106",
      "Nivdunga B.O": "414106",
      "Shirapur B.O": "414106",
      "Khadamba B.O": "413704",
      "Sade B.O": "413704",
      "Rui Chhatrapati B.O": "413703",
      "Sarolasomvanshi B.O": "413703",
      "Kendal BK B.O": "414105",
      "Apdhup B.O": "414301",
      "Dhotre BK B.O": "414304",
      "Palaspur B.O": "414304",
      "Pokhari Kanher B.O": "414304",
      "Savargaon B.O": "414304",
      "Vankute B.O": "414304",
      "Vangdari B.O": "413726",
      "Khedle Permananda B.O": "414105",
      "Shani Shinganapur B.O": "414105",
      "Jategaon B.O": "413204",
      "Vaghunde KH B.O": "414301",
      "Vasunde B.O": "414304",
      "Bhangaon B.O": "413728",
      "Kotul B.O": "413728",
      "Wadali B.O": "413728",
      "Dehere B.O": "414111",
      "Nimblak B.O": "414111",
      "Chande BK B.O": "414401",
      "Kombli B.O": "414401",
      "Thergaon B.O": "414401",
      "Dhorjalgaon B.O": "414501",
      "Mohoj BK B.O": "414501",
      "Vagholi B.O": "414501",
      "Bavi B.O": "413205",
      "Dhondpargaon B.O": "413205",
      "Halgaon B.O": "413205",
      "Devi Bhoyare B.O": "414306",
      "Vadner BK B.O": "414306",
      "Babulwade B.O": "414302",
      "Panoli B.O": "414302",
      "Vadzire B.O": "414302",
      "Alhanwadi B.O": "414102",
      "Mohojdeoda B.O": "414102",
      "Nipani Jalgaon B.O": "414102",
      "Tondoli B.O": "414102",
      "Jalalpur B.O": "414403",
      "Khednagar B.O": "414403",
      "Akhatwade B.O": "414502",
      "Bhavinimgaon B.O": "414502",
      "Hasnapur B.O": "414502",
      "Samsud Erandgaon B.O": "414502",
      "Khanapur  BO B.O": "414502",
      "Pedgaon B.O": "413701",
      "Takali Lonar B.O": "413701",
      "Madhe Wadgaon B.O": "413726",
      "Brahmni B.O": "414105",
      "Hanga B.O": "414301",
      "Narayan Gavan B.O": "414301",
      "Valvane B.O": "414301",
      "Khadakwadi B.O": "414304",
      "Nandur Pathar B.O": "414304",
      "Chichondi Shiral B.O": "414106",
      "Ghatshiras B.O": "414106",
      "Karanji B.O": "414106",
      "Kolhar B.O": "414106",
      "Shiral B.O": "414106",
      "Vaiju Babhulgaon B.O": "414106",
      "Ranjangaondevi B.O": "414602",
      "Bhoyare Gangarda B.O": "413703",
      "Erandoli B.O": "413703",
      "Nibavi B.O": "413703",
      "Ranjangaon B.O": "413703",
      "Karajgaon B.O": "414105",
      "Umbra B.O": "414105",
      "Palve BK B.O": "414301",
      "Karjule Hariya B.O": "414304",
      "Palashi B.O": "414304",
      "Devrai B.O": "414106",
      "Deulgaon B.O": "413728",
      "Shingave Naik B.O": "414111",
      "Vadgaon Gupta B.O": "414111",
      "Vilad B.O": "414111",
      "Mahijalgaon B.O": "414401",
      "Nimgaon Daku B.O": "414401",
      "Gunore B.O": "414306",
      "Savali Vihir BK B.O": "423109",
      "Savali Vihir Farm B.O": "423109",
      "Jawala B.O": "414306",
      "Parner SSK B.O": "414306",
      "Ralegan Therpal B.O": "414306",
      "Chincholi B.O": "414302",
      "Ganjibhoyare B.O": "414302",
      "Punewadi B.O": "414302",
      "Ralegan Siddhi B.O": "414302",
      "Vadegavan B.O": "414302",
      "Vadner Haveli B.O": "414302",
      "Jatdeola B.O": "414102",
      "Koradgaon B.O": "414102",
      "Manikdaundi B.O": "414102",
      "Wadgaon B.O": "414102",
      "Dahigaon B.O": "414502",
      "Deotakli B.O": "414502",
      "Ghotan B.O": "414502",
      "Golegaon B.O": "414502",
      "Kharadgaon B.O": "414502",
      "Sultanpur BK B.O": "414502",
      "Vadule BK B.O": "414502",
      "Varur BK B.O": "414502",
      "Chandgaon B.O": "413701",
      "Hiradgaon B.O": "413701",
      "Math Pimpari B.O": "413726",
      "Takali Khatgaon B.O": "414103",
      "Javala B.O": "413201",
      "Kusadgaon B.O": "413201",
      "Moha B.O": "413201",
      "Naigaon B.O": "413201",
      "Malangi B.O": "414402",
      "Rehekuri B.O": "414402",
      "Shinde B.O": "414402",
      "Takali Khandeshwari B.O": "414402",
      "Sonegaon B.O": "413204",
      "Telanghashi B.O": "413204",
      "Daithane Gunjal B.O": "414103",
      "Dhawalpuri B.O": "414103",
      "Goregaon B.O": "414103",
      "Hingangaon B.O": "414103",
      "Kinhi B.O": "414303",
      "Pimpalgaon Rotha B.O": "414303",
      "Benwadi B.O": "414402",
      "Bitkewadi B.O": "414402",
      "Chincholi Kaldat B.O": "414402",
      "Durgaon B.O": "414402",
      "Chimbhale B.O": "414701",
      "Nimgaon Khalu B.O": "414701",
      "Midsangavi B.O": "414113",
      "Munguswade B.O": "414113",
      "BHALWANI BO": "414103",
      "Hiware Korda B.O": "414103",
      "Sakat B.O": "413201",
      "Pimpalgaon Malvi B.O": "414601",
      "Shendi B.O": "414601",
      "Gargundi B.O": "414303",
      "Ambi Jalgaon B.O": "414402",
      "Kuldharan B.O": "414402",
      "Loni Masadpur B.O": "414402",
      "Ajnuj B.O": "414701",
      "Hangewadi B.O": "414701",
      "Yelapane B.O": "414701",
      "Dighol B.O": "413204",
      "Bhutetakali B.O": "414113",
      "Malkup B.O": "414103",
      "Arangaon B.O": "413201",
      "Patoda B.O": "413201",
      "Pimpalgaon Ujjani B.O": "414601",
      "Alsunde B.O": "414402",
      "Bahirobawadi B.O": "414402",
      "Koregoan B.O": "414402",
      "Ahmednagar H.O": "414001",
      "Shrirampur H.O": "413709",
      "Pohegaon S.O": "423605",
      "Rahuri Factory S.O": "413706",
      "Sangamner SK S.O": "422608",
      "Rahuri MPKV S.O": "413722",
      "Rahuri Town S.O": "413705",
      "Rajur S.O": "422604",
      "Shirdi S.O": "423109",
      "Takalibhan S.O": "413725",
      "Vadala Mahadeo S.O": "413739",
      "Rahuri S.O": "413705",
      "Ranjangaon Kd S.O": "413719",
      "Sakarwadi S.O": "413708",
      "Shinganapur S.O": "423603",
      "Songaon S.O": "413711",
      "Tilaknagar S.O (Ahmed Nagar)": "413720",
      "Talegaon Dighe S.O": "422611",
      "Bhingar S.O": "414002",
      "Bhingar Wes S.O": "414002",
      "Jamkhed S.O": "413201",
      "Jeur S.O (Ahmed Nagar)": "414601",
      "Kharda S.O": "413204",
      "M.G.Udyan S.O": "414001",
      "Mandavgan S.O": "414101",
      "Miri S.O": "414501",
      "Sarjepura S.O": "414001",
      "Sonai S.O (Ahmed Nagar)": "414105",
      "Takali Dhokeshwar S.O": "414304",
      "Ahmednagar City S.O": "414001",
      "Ahmednagar R.S. S.O": "414005",
      "Balamtakali S.O": "414504",
      "Belwandi S.O": "413702",
      "Chichondi Patil S.O": "414201",
      "Jamgaon S.O": "414103",
      "Kanhur S.O": "414303",
      "Karjat S.O (Ahmed Nagar)": "414402",
      "Nanaj S.O (Ahmed Nagar)": "413205",
      "Nighoj S.O": "414306",
      "Shevgaon S.O": "414502",
      "Supa S.O (Ahmed Nagar)": "414301",
      "Vahannagar S.O": "414006",
      "Ahmednagar Camp S.O": "414002",
      "Alkuti S.O": "414305",
      "Anandibazar S.O": "414001",
      "Chanda S.O": "414606",
      "Ghodegaon S.O (Ahmed Nagar)": "414607",
      "Kashti S.O": "414701",
      "Mirajgaon S.O": "414401",
      "MIRC S.O": "414110",
      "Parner S.O": "414302",
      "Pathardi S.O": "414102",
      "Shrigonda S.O": "413701",
      "Vadalamission S.O": "414602",
      "Vambori S.O": "413704",
      "Visapur S.O (Ahmed Nagar)": "413703",
      "Vridheshwar SSK S.O": "414505",
      "Bodhegaon S.O": "414503",
      "Kharwandi Kasar S.O": "414113",
      "Kolgaon S.O": "413728",
      "MIDC (ANR) S.O": "414111",
      "Rashin S.O": "414403",
      "Savedi Road S.O": "414003",
      "Shrigonda SSK S.O": "413726",
      "Tisgaon S.O": "414106",
      "Pravaranagar S.O": "413712",
      "Puntamba S.O": "413707",
      "Rahata S.O": "423107",
      "Sakur S.O": "422622",
      "Sangamner S.O": "422605",
      "Akole S.O": "422601",
      "Deolali Pravara S.O": "413716",
      "Kopargaon S.O": "423601",
      "Loni Kd S.O": "413713",
      "Ashvi BK S.O": "413714",
      "Belapur S.O": "413715",
      "Ganeshnagar S.O (Sangamner)": "422605",
      "Ghargaon S.O": "422620",
      "Kukana S.O": "414604",
      "Ashvi Kd S.O": "413738",
      "Babhleshwar S.O": "413737",
      "Bhende SK S.O": "414605",
      "Bhanashivara S.O": "414609",
      "Bota S.O": "422602",
      "Changdeonagar S.O": "413723",
      "Gondhavani S.O": "413709",
      "Kolhar S.O (Ahmed Nagar)": "413710",
      "Kotul S.O": "422610",
      "Nevasa S.O": "414603",
      "Padhegaon S.O": "413721",
      "Chasnali S.O": "423604",
      "Dhamori S.O": "423607",
      "Dhandharphal S.O": "422603",
      "Harigaon S.O": "413718",
      "Karegaon Factory S.O": "413717",
      "Kolpewadi S.O": "423602",
      "Loni Bk S.O": "413736"
    },
    "HINGOLI": {
      "Bour B.O": "431701",
      "Kandali B.O": "431701",
      "Kille Wadgaon B.O": "431701",
      "Kondhur B.O": "431701",
      "Kurtadi B.O": "431701",
      "Shewala B.O": "431701",
      "Dhawanda Kasba B.O": "431701",
      "Dongarkada B.O": "431701",
      "Jawala Panchal B.O": "431701",
      "Pangra Shinde B.O": "431701",
      "Potra B.O": "431701",
      "Salva B.O": "431701",
      "Sukli Veer B.O": "431701",
      "Yedsi B.O": "431701",
      "Yelegaon Gawali B.O": "431701",
      "Dongargaon Pool B.O": "431701",
      "Mssk Dongarkada B.O": "431701",
      "Rameshwar Tanda B.O": "431701",
      "Waranga B.O": "431701",
      "Yelki B.O": "431701",
      "Bolda B.O": "431701",
      "Sindagi B.O": "431701",
      "Sirli B.O": "431701",
      "Wapti B.O": "431701",
      "Adgaon B.O": "431513",
      "Borisawant B.O": "431705",
      "Siddheshwar B.O": "431705",
      "Siddheshwar Camp B.O": "431705",
      "Yehlegaon Solanke B.O": "431705",
      "Amba B.O": "431512",
      "Gunda B.O": "431705",
      "Karanjala B.O": "431705",
      "Purjal B.O": "431705",
      "Sendursena B.O": "431705",
      "Hayatnagar B.O": "431512",
      "Hatala B.O": "431703",
      "Aral B.O": "431512",
      "Chondi B.O": "431512",
      "Kautha B.O BASMATH": "431512",
      "Khandegaon B.O": "431512",
      "Pardi BK B.O": "431512",
      "Palsi B.O": "431703",
      "Sawana B.O": "431703",
      "Ganjapur B.O": "431513",
      "Kanergaon B.O": "431513",
      "Khandala B.O": "431513",
      "Sawad B.O": "431513",
      "Sawargaon B.O": "431513",
      "Sirsam BK B.O": "431513",
      "Ukhali B.O": "431509",
      "Undegaon B.O": "431509",
      "Lakh B.O": "431702",
      "Masod B.O": "431702",
      "Jawala BK B.O": "431703",
      "Kendra BK B.O": "431703",
      "Bhandegaon B.O": "431513",
      "Chincholi B.O": "431513",
      "Narsi Namdev B.O": "431513",
      "Paheni B.O": "431513",
      "Phalegaon B.O": "431513",
      "Salna B.O": "431509",
      "Babhali B.O": "431702",
      "Hingani B.O": "431702",
      "Wakodi B.O": "431702",
      "Hatta B.O AUNDHA": "431705",
      "Jawala Bazar B.O": "431705",
      "Sawangi BK B.O": "431705",
      "Shirad Shahapur B.O": "431705",
      "Darefal B.O": "431512",
      "Girgaon B.O": "431512",
      "Kadoli B.O": "431703",
      "Basamba B.O": "431513",
      "Bhatsawangi B.O": "431513",
      "Pedgaon B.O": "431513",
      "Pusegaon B.O": "431513",
      "Daudgaon B.O": "431509",
      "Gojegaon B.O": "431509",
      "Gaul B.O": "431702",
      "Nandapur B.O KALAMNURI": "431702",
      "Sandas B.O": "431702",
      "Yelegaon (T) B.O": "431702",
      "Digras B.O": "431705",
      "Golegaon Camp B.O": "431705",
      "Lohara BK B.O": "431705",
      "Lohgaon B.O": "431705",
      "Murtijapur Sawangi B.O": "431705",
      "Nahad B.O": "431705",
      "Kurunda B.O": "431512",
      "Ajegaon B.O": "431703",
      "Babhulgaon B.O": "431703",
      "Mazod B.O": "431703",
      "Adol B.O": "431513",
      "Khudaj B.O": "431513",
      "Malhiwara B.O": "431513",
      "Chincholi Niloba B.O": "431509",
      "Ghoda B.O": "431702",
      "Khanapur Chitta B.O": "431702",
      "Kharwad B.O": "431702",
      "Pimpaldari B.O KALAMNURI": "431702",
      "Chuncha B.O": "431712",
      "Bhankheda B.O": "431542",
      "Datala B.O": "431542",
      "Hatta B.O SENGAON": "431542",
      "Pankanhergaon B.O": "431542",
      "Sakhra B.O": "431542",
      "Sapatgaon B.O": "431542",
      "Shegaon B.O": "431542",
      "Jaipur B.O SENGAON": "431542",
      "Warud Chakrapani B.O": "431542",
      "Kautha B.O SENGAON": "431542",
      "Sindagikhamba B.O": "431542",
      "Goregaon S.O (Hingoli)": "431703",
      "Kalamnuri S.O": "431702",
      "Mangalwara Hingoli S.O": "431513",
      "Sengaon S.O": "431542",
      "Akhada Balapur S.O": "431701",
      "Basmathnagar S.O": "431512",
      "Hingoli S.O": "431513",
      "Basmathnagar Town S.O": "431512",
      "Aundha Nagnath S.O": "431705"
    },
    "JALNA": {
      "P. Dhamangaon B.O": "431507",
      "Pande Pokhari B.O": "431507",
      "Raigavan B.O": "431507",
      "Golegaon B.O": "431507",
      "Loni B.O": "431507",
      "K. Hadgaon B.O": "431507",
      "Panewadi B.O": "431204",
      "Parner B.O": "431204",
      "Sheoga B.O": "431204",
      "Tadhadgaon B.O": "431204",
      "Pimpalgaon Saste B.O": "431212",
      "Dhasala B.O": "431202",
      "Kandhari (Bk) B.O": "431202",
      "Keligavahan B.O": "431202",
      "Roshangaon B.O": "431202",
      "Shelgaon B.O": "431502",
      "Somthana B.O": "431202",
      "Kathora B.O": "431114",
      "Warud BK B.O": "431206",
      "Mahora B.O": "431206",
      "Warud KH B.O": "431206",
      "Navha B.O": "431213",
      "Helas B.O": "431504",
      "Idoli B.O": "431504",
      "K. Sawangi B.O": "431504",
      "Kendhali B.O": "431504",
      "Pimparkheda B.O": "431504",
      "Talni B.O": "431504",
      "Amba B.O": "431501",
      "Babultara B.O": "431501",
      "Akani B.O": "431504",
      "Devgaon B.O": "431504",
      "Kirla B.O": "431504",
      "Pangri Gosavi B.O": "431501",
      "Shrishti B.O": "431501",
      "Warphal B.O": "431501",
      "Bhakarwadi B.O": "431154",
      "Wakulni B.O": "431154",
      "Dahipuri B.O": "431204",
      "Parda": "431204",
      "Mahakala B.O": "431212",
      "Chikangaon B.O": "431202",
      "Avana B.O": "431114",
      "Danapur B.O": "431114",
      "Pahtepur B.O": "431114",
      "Wadi BK B.O": "431114",
      "Walsa Wadala B.O": "431114",
      "Machindra Chincholi B.O": "431209",
      "Tirthpuri B.O": "431209",
      "Sipora Ambhora B.O": "431206",
      "Bellora B.O": "431501",
      "Hatdi B.O": "431501",
      "Jaipur B.O": "431501",
      "Pirkalyan B.O": "431213",
      "Wakhari B.O": "431213",
      "Dahifal B.O": "431504",
      "Pangri BK B.O": "431504",
      "Uswad B.O": "431504",
      "Anandwadi B.O": "431501",
      "Ghungurde Hadgaon B.O": "431212",
      "Gondi B.O": "431212",
      "Akola (Niklak) B.O": "431202",
      "Babhulgaon B.O": "431114",
      "Sawangi A B.O": "431114",
      "Sipora B.O": "431114",
      "Soegaon Devi B.O": "431114",
      "Surangali B.O": "431114",
      "Bodkha BK B.O": "431209",
      "Dhakephal B.O": "431209",
      "Khapardev Hivra B.O": "431209",
      "Bharaj B.O": "431206",
      "Janephal B.O": "431206",
      "Khasgaon B.O": "431206",
      "Dudhna Kelgaon B.O": "431213",
      "Golapangri B.O": "431213",
      "Gondegaon B.O": "431213",
      "Jamwadi B.O": "431213",
      "Pir Pimpalgaon B.O": "431213",
      "Revgaon B.O": "431213",
      "Guru Pimpri B.O": "431204",
      "Hastepokhari B.O": "431204",
      "Rani Unchegaon B.O": "431204",
      "Zirpi B.O": "431204",
      "Patharwala B.O": "431212",
      "Shahagad B.O": "431212",
      "Deogaon Kusali B.O": "431202",
      "Georai(Bazar) B.O": "431202",
      "Nanegaon B.O": "431202",
      "Saigaon (Dongargaon) B.O": "431202",
      "Kosgaon B.O": "431114",
      "Paradh B.O": "431114",
      "Pimpalgaon R B.O": "431114",
      "Hasnabad B.O": "431114",
      "Ramasgaon B.O": "431209",
      "Kajala B.O": "431213",
      "Pachan Wadgaon B.O": "431213",
      "Waghrul B.O": "431213",
      "Lingasa B.O": "431501",
      "Patoda Mav B.O": "431501",
      "Rohina B.O": "431501",
      "Vaidya Wadgaon B.O": "431501",
      "Watur B.O": "431501",
      "Pimparkheda (Bk) B.O": "431211",
      "Kandharai Partur B.O": "431207",
      "Adgaon B.O": "431132",
      "Jalgaon B.O": "431112",
      "Tanda Bazar B.O": "431135",
      "Hivra  Kabli B.O": "431208",
      "Kumbharzari B.O": "431208",
      "Bhatepuri B.O": "431214",
      "Seoli B.O": "431214",
      "Jam Samarth B.O": "431211",
      "Mangrul B.O": "431211",
      "Karadgaon B.O": "431207",
      "Karla B.O": "431207",
      "Paradggaon B.O": "431207",
      "Warud Tangde B.O": "431132",
      "Anwa B.O": "431112",
      "Dhakalgaon B.O": "431205",
      "Nalewadi B.O": "431205",
      "Borgaon B.O": "431214",
      "Hastepimpalgaon B.O": "431214",
      "Anterwali Tembhi B.O": "431211",
      "Hivra Roshangaon B.O": "431207",
      "Walsawangi B.O": "431132",
      "Tapowan Gondhan B.O": "431208",
      "Shahapur B.O": "431205",
      "Sukhapuri B.O": "431205",
      "Maujpuri B.O": "431214",
      "Jamkhed B.O": "431121",
      "Chinchkheda B.O": "431121",
      "Dongaon B.O": "431121",
      "Rohilagad B.O": "431121",
      "Dongaon": "431215",
      "Gunj BK B.O": "431211",
      "Raja Takli B.O": "431211",
      "Hiswan B.O": "431207",
      "Jiradgaon B.O": "431207",
      "Shelud B.O": "431132",
      "Akola B.O": "431208",
      "Sonakpimpalgaon B.O": "431205",
      "Chitili Putli B.O": "431214",
      "Manegaon B.O": "431214",
      "Pimalgaon Kolte B.O": "431134",
      "Utwad B.O": "431214",
      "Nalni B.O": "431215",
      "Chandai Eco B.O": "431215",
      "Tadegaon B.O": "431215",
      "Sawargaon Hadap B.O": "431214",
      "Chikhali B.O": "431215",
      "Dabhadi B.O": "431215",
      "Dahyala B.O": "431137",
      "Ner B.O": "431214",
      "Pathrud B.O": "431214",
      "Longaon B.O": "431215",
      "Walsa Khalsa B.O": "431215",
      "Javkheda BK B.O": "431215",
      "Kedarkheda B.O": "431215",
      "Mapegaon B.O": "431502",
      "Osmanpur B.O": "431502",
      "Patoda B.O": "431503",
      "Shindekelgaon B.O": "431214",
      "Bawne Pangri B.O": "431215",
      "Delegavan B.O": "431215",
      "Khandavi B.O": "431502",
      "Jalna H.O": "431203",
      "Ghansawangi S.O": "431209",
      "Rakhiv Police Bal Jalna S.O": "431203",
      "Ramnagar S.O": "431214",
      "Ambad Bazar S.O": "431204",
      "Ambika Market Jalna S.O": "431203",
      "Midc Jalna S.O": "431213",
      "Old Jalna S.O": "431213",
      "Ranjani S.O (Jalna)": "431207",
      "Rajur": "431215",
      "Ankush Nagar S.O": "431212",
      "Collectorate Complex Jalna S.O": "431213",
      "Jaffrabad S.O": "431206",
      "Jalna Mondha S.O": "431203",
      "Jalna Railway Station S.O": "431213",
      "Tembhurni S.O (Jalna)": "431208",
      "Wadigodri S.O": "431205",
      "Mantha S.O": "431504",
      "Satona S.O": "431502",
      "Ashti S.O (Jalna)": "431507",
      "Partur S.O": "431501",
      "Ambad S.O": "431204",
      "Badnapur S.O": "431202",
      "Bhokardan S.O": "431114",
      "Kumbhar Pimpalgaon S.O": "431211"
    },
    "RATNAGIRI": {
      "Mumbake B.O": "415727",
      "Panhalje B.O": "415727",
      "Natunagar B.O": "415640",
      "Tulshi Khurd B.O": "415640",
      "Udhale Budruk B.O": "415640",
      "Alsure B.O": "415709",
      "Boraj B.O": "415709",
      "Dhamani B.O": "415611",
      "Hedali B.O": "415709",
      "Saveni B.O": "415709",
      "Shingri B.O": "415709",
      "Shiv Budruk B.O": "415709",
      "Shivtar B.O": "415709",
      "Susheri B.O": "415709",
      "Pimpli Khurd B.O": "415604",
      "Tiware B.O": "416705",
      "Amdave B.O": "415203",
      "Chinchghar B.O": "415709",
      "Takede B.O": "415203",
      "Tulshi B.O": "415203",
      "Kaundhar Tamhane B.O": "415702",
      "Umroli B.O": "415208",
      "Zombadi B.O": "415702",
      "Ambitgaon B.O": "415641",
      "Savnas B.O": "415727",
      "Kondivali B.O": "415709",
      "Koregaon B.O": "415709",
      "Mandva B.O": "415709",
      "Mani B.O": "415709",
      "Sanglat B.O": "415709",
      "Anari B.O": "415604",
      "Chinchghari B.O": "415604",
      "Dhamnavane B.O": "415604",
      "Nandivase B.O": "415604",
      "Ovali B.O": "415604",
      "Bijghar B.O": "415715",
      "Kulvandi B.O": "415715",
      "Kumbhad B.O": "415715",
      "Shindi B.O": "415715",
      "Satvingaon B.O": "415708",
      "Avashi B.O": "415722",
      "Aravali B.O": "415608",
      "Dhamapur B.O": "415608",
      "Kalambushi B.O": "415608",
      "Mandivali B.O": "415203",
      "Mhapral B.O": "415203",
      "Soveli B.O": "415203",
      "Gimvi B.O": "415702",
      "Kalamundi B.O": "415702",
      "Pophlavane B.O": "415727",
      "Shirshi B.O": "415727",
      "Chinchavali B.O": "415640",
      "Ashti B.O": "415709",
      "Jamage B.O": "415716",
      "Morvande B.O": "415709",
      "Murde B.O": "415709",
      "Sakhroli B.O": "415709",
      "Tisangi B.O": "415709",
      "Akale B.O": "415604",
      "Dalvatane B.O": "415604",
      "Kadwad B.O": "415604",
      "Kanhe B.O": "415604",
      "Moravane B.O": "415604",
      "Uchat B.O": "415715",
      "Pimploli B.O": "415202",
      "Asgani B.O": "415708",
      "Ayani B.O": "415708",
      "Gunade B.O": "415722",
      "Songaon B.O": "415722",
      "Ambav B.O": "415804",
      "Burambad B.O": "415608",
      "Karjuve B.O": "415608",
      "Kokare B.O": "415608",
      "Narduve B.O": "415608",
      "Dhutroli B.O": "415203",
      "Kumbale B.O": "415203",
      "Tanali B.O": "415702",
      "Kutra B.O": "415607",
      "Rajivili B.O": "415607",
      "Yegaon B.O": "415607",
      "Palvan B.O": "415641",
      "Mugij B.O": "415716",
      "Shirkhal B.O": "415716",
      "Padve B.O": "415613",
      "Bamnoli B.O": "415804",
      "Nirvhal B.O": "415701",
      "Waghivare B.O": "415701",
      "Agave B.O": "415616",
      "Dervan B.O": "415606",
      "Bhom B.O": "415628",
      "Donavali B.O": "415628",
      "Kapre B.O": "415628",
      "Bahiravali B.O": "415727",
      "Kashedi B.O": "415640",
      "Ambaye B.O": "415709",
      "Nandgaon (Khed) B.O": "415709",
      "Tala Mandva B.O": "415709",
      "Tise B.O": "415709",
      "Adre B.O": "415604",
      "Kalkavane B.O": "415604",
      "Vehele B.O": "415604",
      "Shirgaon B.O": "415715",
      "Tide B.O": "415202",
      "Valote B.O": "415202",
      "Kotavali B.O": "415722",
      "Sheldi B.O": "415722",
      "Kase B.O": "415608",
      "Kondivare B.O": "415608",
      "Murdav B.O": "415608",
      "Nayashi B.O": "415608",
      "Dahagaon B.O": "415203",
      "Gharadi B.O": "415203",
      "Kutgiri B.O": "415702",
      "Ubhale B.O": "415702",
      "Kumbharkhani B.O": "415607",
      "Pachambe B.O": "415607",
      "Murtavade B.O": "415641",
      "Pate Pillavali B.O": "415641",
      "Turambav B.O": "415641",
      "Vahal B.O": "415641",
      "Satere Tarf Natu B.O": "415716",
      "Peve B.O": "415719",
      "Borgaon B.O": "415701",
      "Miravane B.O": "415701",
      "Vadad B.O": "415701",
      "Asurda B.O": "415606",
      "Mandki B.O": "415606",
      "Gondhale B.O": "415628",
      "Khopad B.O": "415628",
      "Posare B.O": "415628",
      "Kalsur Koundhar B.O": "415724",
      "Palpene B.O": "415724",
      "Dhakmoli B.O": "415641",
      "Kalambat B.O": "415712",
      "Pilavali B.O": "415641",
      "Veer B.O": "415641",
      "Kondmala B.O": "415606",
      "Kosbi B.O": "415606",
      "Mudhe Tarf Sawarda B.O": "415606",
      "Chikhali B.O": "415609",
      "Maldoli B.O": "415628",
      "Talavade B.O": "416712",
      "Shirambe B.O": "415641",
      "Tondali B.O": "415641",
      "Omali B.O": "415628",
      "Mundhe B.O": "415602",
      "Talsar B.O": "415602",
      "Malan B.O": "415724",
      "Pangari Tarf Velamb B.O": "415724",
      "Sondeghar B.O": "415716",
      "Visapur B.O": "415716",
      "Chiveli B.O": "415701",
      "Ghude B.O": "415701",
      "Katroli B.O": "415701",
      "Malghar B.O": "415701",
      "Anjanvel B.O": "415634",
      "Dahivali Budruk B.O": "415606",
      "Durgawadi B.O": "415606",
      "Furus B.O": "415606",
      "Biwali B.O": "415628",
      "Karjikar Mohalla B.O": "415628",
      "Karambavane B.O": "415628",
      "Kharvate B.O": "416705",
      "Tamhanmala B.O": "415628",
      "Kumbharli B.O": "415602",
      "Patpanhale B.O": "415724",
      "Pomendi B.O": "415724",
      "Nivsar B.O": "415803",
      "Shirambavali B.O": "415803",
      "Chandor B.O": "415616",
      "Ganeshgule B.O": "415616",
      "Burambe Wadi B.O": "416702",
      "Devache Gothane B.O": "416702",
      "Juwathi B.O": "416702",
      "Kaneri B.O": "416702",
      "Kelavali B.O": "416702",
      "Kuveshi B.O": "416702",
      "Mithgavane B.O": "416702",
      "Moroshi B.O": "416702",
      "Pangare B.O": "416702",
      "Panhale Tarf Saundal B.O": "416702",
      "Sasale B.O": "416702",
      "Solgaon B.O": "416702",
      "Talgaon B.O": "416702",
      "Tavsal B.O": "415613",
      "Watad B.O": "415613",
      "Deole Ghera Prachitgad B.O": "415611",
      "Fungus B.O": "415611",
      "Lowale B.O": "415611",
      "Basani B.O": "415629",
      "Kasarveli B.O": "415629",
      "Yerdav B.O": "416704",
      "Ghativale B.O": "415803",
      "Kankadi B.O": "415803",
      "Mavlange B.O": "415616",
      "Nakhare B.O": "415616",
      "Nirul B.O": "415616",
      "Angale B.O": "416702",
      "Ansure B.O": "416702",
      "Dongar B.O": "416702",
      "Goval B.O": "416702",
      "Kotapur B.O": "416702",
      "Mosam B.O": "416702",
      "Padave B.O": "416702",
      "Sakhar B.O": "415718",
      "Taral B.O": "416702",
      "Vilye B.O": "416702",
      "Kudali B.O": "415613",
      "Devade B.O": "415801",
      "Murshi B.O": "415801",
      "Golavali B.O": "415611",
      "Pirandavane B.O": "415617",
      "Washi Tarf Sangmeshwar B.O": "415611",
      "Argaon B.O": "415643",
      "Kurang B.O": "415643",
      "Shiravali B.O": "415643",
      "Velamb B.O": "415724",
      "Nigundal B.O": "415719",
      "Parchuri B.O": "415637",
      "Phansu B.O": "415711",
      "Tetavali B.O": "415711",
      "Devhare B.O": "415208",
      "Gothe B.O": "415208",
      "Nigadi B.O": "415208",
      "Shipole B.O": "415208",
      "Pomendi Budruk B.O": "415612",
      "Tembye B.O": "415612",
      "Tonade B.O": "415612",
      "Kolambe B.O": "415612",
      "Degaon B.O": "415711",
      "Pangari Tarf Haveli B.O": "415711",
      "Bankot B.O": "415208",
      "Sakhari Agar B.O": "415729",
      "Kelye B.O": "415612",
      "Chinchkhari B.O": "415612",
      "Antravali B.O": "415610",
      "Kalambaste B.O": "415605",
      "Dhamanse B.O": "415620",
      "Kalzondi B.O": "415620",
      "Vetoshi B.O": "415617",
      "Govil B.O": "416701",
      "Hardakhale B.O": "416701",
      "Indavati B.O": "416701",
      "Isavali B.O": "416701",
      "Khavadi B.O": "416701",
      "Khorninko B.O": "416701",
      "Kondye B.O": "415620",
      "Korle B.O": "416701",
      "Bhoke B.O": "415639",
      "Ambolgad B.O": "415806",
      "Gothane Doniwade B.O": "416705",
      "Kalsavali B.O": "416705",
      "Ajiwali B.O": "416704",
      "Bagave Wadi B.O": "416704",
      "Kolamb B.O": "416704",
      "Miland B.O": "416704",
      "Moor B.O": "416704",
      "Phansop B.O": "415612",
      "Anjanari B.O": "415803",
      "Choravane B.O": "415718",
      "Math B.O": "415803",
      "Nanij B.O": "415803",
      "Wanke B.O": "415803",
      "Dhaulwali B.O": "416702",
      "Dhopeshwar B.O": "416702",
      "Donivade B.O": "416702",
      "Hasol Tarf Saundal B.O": "416702",
      "Madban B.O": "416702",
      "Prindavan B.O": "416702",
      "Upale B.O": "416712",
      "Katali Sagave B.O": "416709",
      "Kirbet B.O": "415801",
      "Ozare Budruk B.O": "415801",
      "Tiware Medhe Tarfe Devale": "415801",
      "Purye Tarfe Devale": "415801",
      "Muchari B.O": "415611",
      "Rajwadi B.O": "416707",
      "Shembavane B.O": "415611",
      "Sonavade B.O": "415611",
      "Terye B.O": "415611",
      "Adavali B.O": "415802",
      "Kochari B.O": "415802",
      "Salpe B.O": "415802",
      "Kondge B.O": "415643",
      "Ringane B.O": "415643",
      "Dabhole B.O": "415803",
      "Khanu B.O": "415803",
      "Sathare Bambar B.O": "415803",
      "Golap B.O": "415616",
      "Mervi B.O": "415616",
      "Purnagad B.O": "415616",
      "Bhalavali B.O": "416702",
      "Kodavali B.O": "416702",
      "Kumbhavade B.O": "416702",
      "Nanar B.O": "416702",
      "Niveli B.O": "416702",
      "Shivane Khurd B.O": "416702",
      "Walye B.O": "416702",
      "Jambhari B.O": "415613",
      "Bhadkamba B.O": "415801",
      "Dingni B.O": "415611",
      "Kurdhunda B.O": "415611",
      "Mabhale B.O": "415611",
      "Kalbadevi B.O": "415629",
      "Panhale B.O": "415643",
      "Waghangaon B.O": "415643",
      "Vhel B.O": "415643",
      "Vilavade B.O": "415643",
      "Waked B.O": "415643",
      "Sakhari Budruk B.O": "415724",
      "Sakhari Trishul B.O": "415724",
      "Karul B.O": "415719",
      "Mundhar B.O": "415719",
      "Asond B.O": "415711",
      "Bhopan B.O": "415711",
      "Dabhil B.O": "415711",
      "Velas B.O": "415208",
      "Someshwar B.O": "415612",
      "Dande Adom B.O": "415612",
      "Pomendi Khurd B.O": "415612",
      "Holi B.O": "415805",
      "Masrang B.O": "415609",
      "Tural B.O": "415609",
      "Karbhatale B.O": "415610",
      "Nayari B.O": "415610",
      "Umare B.O": "415610",
      "Kespuri B.O": "415620",
      "Kolisare B.O": "415620",
      "Pochari B.O": "415620",
      "Rai B.O": "415620",
      "Ranpat B.O": "415620",
      "Tarval B.O": "415620",
      "Roon B.O": "416701",
      "Satavali B.O": "416701",
      "Vadgaon B.O": "416701",
      "Zapade B.O": "416701",
      "Nachane B.O": "415639",
      "Niwali B.O": "415639",
      "Pangari B.O": "415719",
      "Phansavane B.O": "415610",
      "Tiware Ghera Prachitgad B.O": "415610",
      "Chafe B.O": "415620",
      "Chave B.O": "415620",
      "Ori B.O": "415620",
      "Varawade B.O": "415620",
      "Bhambed B.O": "416701",
      "Kelambe B.O": "416701",
      "Kuve B.O": "416701",
      "Palu B.O": "416701",
      "Vangule B.O": "416701",
      "Veravali Khurd B.O": "416701",
      "Nivendi B.O": "415615",
      "Karbude B.O": "415639",
      "Mirjole B.O": "415639",
      "Kolwan Chuna B.O": "416705",
      "Karak B.O": "416704",
      "Parule B.O": "416704",
      "Savdav B.O": "416704",
      "Yelvan B.O": "416704",
      "Shringarpur B.O": "415610",
      "Tambedi B.O": "415610",
      "Deud B.O": "415620",
      "Manjare B.O": "415620",
      "Nevare B.O": "415620",
      "Bapere B.O": "416701",
      "Golawashi B.O": "416701",
      "Javade B.O": "416701",
      "Majal B.O": "416701",
      "Prabhanvalli B.O": "416701",
      "Veravali Budruk B.O": "416701",
      "Ganpatipule B.O": "415615",
      "Ghodavali B.O": "415639",
      "Khedashi B.O": "415639",
      "Ozare B.O": "416705",
      "Jawalethar B.O": "416704",
      "Kolwan Khadi B.O": "416704",
      "Raypatan B.O": "416704",
      "Wadavali B.O": "416705",
      "Haral B.O": "416704",
      "Hatade B.O": "416704",
      "Kajirda B.O": "416704",
      "Karavali B.O": "416704",
      "Oshivale B.O": "416704",
      "Saundal B.O": "416704",
      "Soliwade B.O": "416704",
      "Tamhane B.O": "415804",
      "Shir B.O": "415724",
      "Kolbandre B.O": "415711",
      "Panhale Kazi B.O": "415711",
      "Wavghar B.O": "415711",
      "Mirya B.O": "415612",
      "Phansavale B.O": "415612",
      "Bhatye B.O": "415612",
      "Ambdas B.O": "415605",
      "Kadavali B.O": "415605",
      "Teru B.O": "415605",
      "Pali(CPN) B.O": "415605",
      "Kaluste B.O": "415605",
      "Kajurli B.O": "415726",
      "Khodade B.O": "415726",
      "Walope B.O": "415605",
      "Parshuram B.O": "415605",
      "Kalvande B.O": "415605",
      "Pacheri Sada B.O": "415726",
      "Sada Jambhari B.O": "415726",
      "Kelne B.O": "415605",
      "Dhamandevi B.O": "415605",
      "Pedhe B.O": "415605",
      "Bhelsai B.O": "415605",
      "Chirni B.O": "415605",
      "Musad B.O": "415605",
      "Asore B.O": "415726",
      "Bhatgaon B.O": "415726",
      "Khadpoli B.O": "415603",
      "Kolambe(S) B.O": "415637",
      "Ukshi B.O": "415637",
      "Koldhe B.O": "416712",
      "Kurtade B.O": "416712",
      "Veral B.O": "415621",
      "Patgaon B.O": "415804",
      "Sangave B.O": "415804",
      "Sayale B.O": "415804",
      "Dale B.O": "415805",
      "Karla B.O": "415612",
      "Kondsur Budruk B.O": "416707",
      "Talekante B.O": "415637",
      "Vandri B.O": "415637",
      "Devihasol B.O": "416713",
      "Pendkhale B.O": "416713",
      "Bhade B.O": "416712",
      "Harcheri B.O": "416712",
      "Kurne B.O": "416712",
      "Lavgan B.O": "416712",
      "Tike B.O": "416712",
      "Angavali B.O": "415804",
      "Maral B.O": "415804",
      "Nive Budruk B.O": "415804",
      "Sadavali B.O": "415804",
      "Ujgaon B.O": "415804",
      "Velvand B.O": "415619",
      "Majgaon": "415612",
      "Vadad Hasol B.O": "416713",
      "Asage B.O": "416712",
      "Beni Budruk B.O": "416712",
      "Ibrahimpattan B.O": "416712",
      "Khanavali B.O": "416712",
      "Kot B.O": "416712",
      "Meghi B.O": "415807",
      "Belari Budruk B.O": "415804",
      "Hativ B.O": "415804",
      "Karambele Tarf Devale B.O": "415804",
      "Kasar Kolwan B.O": "415804",
      "Katavali B.O": "415804",
      "Kirduve B.O": "415804",
      "Kosumb B.O": "415804",
      "Kundi B.O": "415804",
      "Waingane B.O": "415804",
      "Washi Tarf Devrukh B.O": "415804",
      "Gavade Ambere B.O": "415626",
      "Shivar Ambere B.O": "415626",
      "Charveli B.O": "415619",
      "Kapad Gaon B.O": "415619",
      "Bhile B.O": "415605",
      "Kamathe B.O": "415605",
      "Kapsal B.O": "415605",
      "Kolawali B.O": "415726",
      "Masu B.O": "415726",
      "Kasheli B.O": "416707",
      "Dasur B.O": "416713",
      "Shivane Budruk B.O": "416713",
      "Gavane B.O": "416712",
      "Harche B.O": "416712",
      "Punas B.O": "416712",
      "Waghrat B.O": "416712",
      "Chafavali B.O": "415807",
      "Ambavali B.O": "415804",
      "Harpude B.O": "415804",
      "Karli B.O": "415804",
      "Morde B.O": "415804",
      "Ozare Khurd B.O": "415804",
      "Tulsani B.O": "415804",
      "Vanzole B.O": "415804",
      "Dorle B.O": "415626",
      "Panval B.O": "415619",
      "Zare Wadi B.O": "415619",
      "Kolke Wadi B.O": "415603",
      "Pedhambe B.O": "415603",
      "Astan B.O": "415730",
      "Devghar B.O": "415730",
      "Mohane B.O": "415730",
      "Sukivili B.O": "415621",
      "Karanjgaon B.O": "415720",
      "Umbarghar B.O": "415706",
      "Dehen B.O": "415712",
      "Jalgaon B.O": "415712",
      "Kherdi B.O": "415712",
      "Pachavali B.O": "415712",
      "Nandivili B.O": "415730",
      "Adkhaltari B.O": "415714",
      "Ilne B.O": "415714",
      "Agarwaingani B.O": "415712",
      "Chickalgaon B.O": "415712",
      "Ladghar B.O": "415712",
      "Matwan B.O": "415712",
      "Pisai B.O": "415712",
      "Sarang B.O": "415712",
      "Shirsoli B.O": "415712",
      "Varnoshi Tarf Panchanadi B.O": "415712",
      "Velvi B.O": "415712",
      "Kurwal Jawali B.O": "415718",
      "Asgoli B.O": "415703",
      "Dhopave B.O": "415703",
      "Jamsud B.O": "415703",
      "Kotluk B.O": "415703",
      "Sapirili B.O": "415718",
      "Wave B.O": "415718",
      "Dayal B.O": "415710",
      "Poynar B.O": "415710",
      "Chindravale B.O": "415728",
      "Ghera Rasalgad B.O": "415730",
      "Humbri B.O": "415730",
      "Mahalunge B.O": "415730",
      "Ade B.O": "415714",
      "Nilavane B.O": "415621",
      "Oni navase B.O": "415706",
      "Kadivali B.O": "415712",
      "Karanjani B.O": "415712",
      "Kolthare B.O": "415712",
      "Nante B.O": "415712",
      "Palavani B.O": "415712",
      "Sakhloli B.O": "415712",
      "Talsure B.O": "415712",
      "Tangar B.O": "415712",
      "Kasai B.O": "415718",
      "Posare Budruk B.O": "415718",
      "Are B.O": "415703",
      "Palshet B.O": "415703",
      "Varveli B.O": "415703",
      "Asud B.O": "415713",
      "Murud B.O": "415713",
      "Narvan B.O": "415728",
      "Waghambe B.O": "415728",
      "Panchnadi B.O": "415712",
      "Tadil B.O": "415712",
      "Umbarle B.O": "415712",
      "Talvat B.O": "415718",
      "Pimpar B.O": "415703",
      "Veldur B.O": "415703",
      "Karde B.O": "415713",
      "Paj B.O": "415713",
      "Dodavali B.O": "415728",
      "Umrath B.O": "415728",
      "Kalamani Khurd B.O": "415730",
      "Sukondi B.O": "415714",
      "Kalamani Budruk B.O": "415621",
      "Kangwai B.O": "415712",
      "Kudavale B.O": "415712",
      "Ratnagiri H.O": "415612",
      "Chiplun H.O": "415605",
      "Adur S.O (Ratnagiri)": "415705",
      "Ambavali S.O": "415730",
      "Bharane S.O": "415621",
      "Dhamanand S.O": "415718",
      "Karji S.O": "415727",
      "Khed City S.O": "415709",
      "Khopi S.O": "415715",
      "Latwan S.O": "415202",
      "Margatamhane S.O": "415702",
      "Niwali (CPN) S.O": "415641",
      "Rampur S.O (Ratnagiri)": "415701",
      "Sawarda S.O": "415606",
      "Vakavali S.O": "415711",
      "Veshvi S.O": "415208",
      "Adivare S.O": "416707",
      "Devadhe S.O": "416712",
      "Jaitapur S.O": "415805",
      "Kasba S.O (Ratnagiri)": "415610",
      "Khalgaon S.O": "415620",
      "Pachal S.O (Ratnagiri)": "416704",
      "Ratnagiri Collectorate S.O": "415612",
      "Sakharpa S.O": "415801",
      "Shivaji Nagar (RTG) S.O": "415612",
      "Tilak Memorial (RTG) S.O": "415612",
      "Dabhol S.O": "415706",
      "Harnai S.O": "415713",
      "Kelshi S.O": "415717",
      "Kherdi S.O": "415604",
      "Mandangad S.O": "415203",
      "Panderi S.O": "415214",
      "Shringartali S.O": "415724",
      "Talavali S.O": "415719",
      "Devale S.O": "415807",
      "Jaigad S.O": "415614",
      "Kadwai S.O": "415609",
      "MIDC (RTG) S.O": "415639",
      "Oni S.O": "416705",
      "Sagave S.O": "416709",
      "Sangmeshwar S.O": "415611",
      "Burondi S.O": "415720",
      "Khavati S.O": "415640",
      "Lavel S.O": "415708",
      "Lote S.O (Ratnagiri)": "415722",
      "Makhajan S.O": "415608",
      "Nandgaon (CPN) S.O": "415607",
      "Pophali S.O": "415601",
      "RGPPL Anjanvel S.O": "415634",
      "Ambed Budruk S.O": "415637",
      "Bhoo S.O": "416713",
      "Devrukh S.O": "415804",
      "Gavkhadi S.O": "415626",
      "Hatkhamba S.O": "415619",
      "Kotawada S.O": "415617",
      "Kuvarbav S.O": "415639",
      "Lanja S.O": "416701",
      "Pali (RTG) S.O": "415803",
      "Pawas S.O": "415616",
      "Saitavada S.O": "415613",
      "Shiposhi S.O": "415802",
      "Abaloli S.O": "415726",
      "Alore S.O": "415603",
      "Anjarla S.O": "415714",
      "Dapoli S.O": "415712",
      "Furus S.O": "415710",
      "Guhagar S.O": "415703",
      "Hedavi S.O": "415728",
      "Khed (RTG) S.O": "415709",
      "Markandi S.O": "415605",
      "Palgad S.O": "415716",
      "Shiral S.O": "415628",
      "Shirgaon (CPN) S.O": "415602",
      "Welneshwar S.O": "415729",
      "Malgund S.O": "415615",
      "Nata S.O": "415806",
      "Rajapur S.O (Ratnagiri)": "416702",
      "Shirgaon (RTG) S.O": "415629",
      "Watul S.O": "415643"
    },
    "BULDHANA": {
      "Nandra Koli B.O": "443002",
      "Padali B.O": "443002",
      "Pangri B.O": "443002",
      "Dongar Khandala B.O": "443002",
      "Mamulwadi B.O": "443401",
      "Mominabad B.O": "443401",
      "Bharosa B.O": "443201",
      "Satgaon Bhusari B.O": "443201",
      "Palaskhed Daulat B.O": "443201",
      "Sakegaon B.O": "443201",
      "Dabhadi B.O": "443102",
      "Ghirni B.O": "443102",
      "Makodi B.O": "443102",
      "Mendhali B.O": "443102",
      "Umali B.O": "443102",
      "Hatedi B.O": "443106",
      "Jamb B.O": "443106",
      "Masrul B.O": "443106",
      "Mhasla BK B.O": "443106",
      "Bhadola B.O": "443002",
      "Dongarshewali B.O": "443002",
      "Kelwad B.O": "443002",
      "Madh B.O": "443002",
      "Pimpalgaon Sarai B.O": "443002",
      "Sagwan B.O": "443002",
      "Shelsur B.O": "443002",
      "Dahid B.O": "443002",
      "Dhotra Bhangoji B.O": "443002",
      "Dhanora Vitali B.O": "443401",
      "Ancharwadi B.O": "443201",
      "Antri Khedekar B.O": "443201",
      "Borgaon Kakde B.O": "443201",
      "Deulgaon Dhangar B.O": "443201",
      "Eklara B.O": "443201",
      "Gangalgaon B.O": "443201",
      "Isrul B.O": "443201",
      "Mendgaon B.O": "443201",
      "Mera Khurd B.O": "443201",
      "Sawargaon Dukare B.O": "443201",
      "Bhadgani B.O": "443102",
      "Pimpri Gawali B.O": "443102",
      "Sarola Maroti B.O": "443102",
      "Talni B.O": "443102",
      "Warkhed B.O": "443102",
      "Digras BK B.O": "443206",
      "Tuljapur B.O": "443204",
      "Chandol B.O": "443106",
      "Dhamangaon B.O": "443106",
      "Satgaon Mhasla B.O": "443106",
      "Deulghat B.O": "443002",
      "Kesapur B.O": "443002",
      "Kinhola B.O": "443002",
      "Raipur B.O": "443002",
      "Sakhali B.O": "443002",
      "Sao B.O": "443002",
      "Gummi B.O": "443002",
      "Kolwad B.O": "443002",
      "Shirpur B.O": "443002",
      "Sundarkhed B.O": "443002",
      "Warwand B.O": "443304",
      "Yelgaon B.O": "443002",
      "Jigaon B.O": "443401",
      "Kawhala B.O": "443201",
      "Kolara B.O": "443201",
      "Savkhed Nagare B.O": "443201",
      "Shelgaon Atol B.O": "443201",
      "Godri B.O": "443201",
      "Khandala Makardhwaj B.O": "443201",
      "Pimpalgaon BK B.O": "443206",
      "Saramba B.O": "443206",
      "Dighi B.O": "443401",
      "Ambashi B.O": "443201",
      "Andhera B.O": "443201",
      "Dahigaon B.O": "443201",
      "Hatni B.O": "443201",
      "Mera BK B.O": "443201",
      "Peth B.O": "443201",
      "Sawana B.O": "443201",
      "Belad B.O": "443102",
      "Pophali B.O": "443102",
      "Shelgaon Bazar B.O": "443102",
      "Shiradhon B.O": "443102",
      "Aland B.O": "443206",
      "Mehuna B.O": "443206",
      "Singaon Jahagir B.O": "443204",
      "Umbarkhed B.O": "443204",
      "Dhalsawangi B.O": "443106",
      "Dudha B.O": "443106",
      "Sawangi Tekale B.O": "443206",
      "Borakhedi Bawra B.O": "443204",
      "Khallad Gavhan B.O": "443204",
      "Saokhed Bhoi B.O": "443204",
      "Bhadgaon B.O": "443106",
      "Panhera Khedi B.O": "443104",
      "Mhaiswadi B.O": "443112",
      "Tadulwadi B.O": "443112",
      "Bhendwad B.O": "443402",
      "Jamod B.O": "443402",
      "Sawargaon B.O": "443402",
      "Khamkhed B.O": "443101",
      "Wadaji B.O": "443101",
      "Wadner Bholaji B.O": "443101",
      "Rohinkhed B.O": "443103",
      "Shemba B.O": "443103",
      "Dahigaon M B.O": "443404",
      "Malegaon B.O": "443404",
      "Narkhed B.O": "443404",
      "Wadi B.O": "443404",
      "Yerli B.O": "443404",
      "Malkapur Pangra B.O": "443202",
      "Waghala B.O": "443202",
      "Warud B.O": "443106",
      "Dasarkhed B.O": "443112",
      "Kherda B.O": "444203",
      "Madakhed B.O": "443402",
      "Rudhana B.O": "443402",
      "Bhalegaon B.O": "443101",
      "Deodhaba B.O": "443101",
      "Dudhalgaon BK B.O": "443101",
      "Didola B.O": "443101",
      "Nipana B.O": "444306",
      "Panhera Wadoda B.O": "443101",
      "Pimpalgaon Devi B.O": "443101",
      "Borakhedi B.O": "443103",
      "Jaipur B.O": "443103",
      "Takarkhed B.O": "443103",
      "Alampur B.O": "443404",
      "Bhumrala B.O": "443202",
      "Bibi B.O": "443202",
      "Daregaon B.O": "443202",
      "Gunj B.O": "443202",
      "Adgaon Raja B.O": "443203",
      "Dawargaon B.O": "443203",
      "Hiwarkhed B.O": "443203",
      "Kingaon Raja B.O": "443203",
      "Narvel B.O": "443112",
      "Vivara B.O": "443112",
      "Zodga B.O": "443112",
      "Chawara B.O": "443402",
      "Shelapur B.O": "443101",
      "Sindkhed Lapali B.O": "443101",
      "Khaira B.O": "443103",
      "Kharbadi B.O": "443103",
      "Kothali B.O": "443103",
      "Nimkhed B.O": "443103",
      "Khumgaon B.O": "443404",
      "Naigaon B.O": "443404",
      "Nandura Town B.O": "443404",
      "Shelgaon Mukund B.O": "443404",
      "Wasadi BK B.O": "443404",
      "Shendurjan B.O": "443202",
      "Sindi B.O": "443202",
      "Korhala Bazar  B.O": "443104",
      "Chikhali B.O": "443112",
      "Harsoda B.O": "443112",
      "Asalgaon B.O": "443402",
      "Niwana B.O": "443402",
      "Sungaon B.O": "443402",
      "Wadshingi B.O": "443402",
      "Awha Yunuspur B.O": "443101",
      "Harankhed B.O": "443101",
      "Jambhuldhaba B.O": "443101",
      "Liha BK B.O": "443101",
      "Talkhed B.O": "443101",
      "Advihir B.O": "443103",
      "Rajur B.O": "443103",
      "Pimpalgaon Nath B.O": "443103",
      "Bhota B.O": "443404",
      "Nimgaon B.O": "443404",
      "Kingaon Jattu B.O": "443202",
      "Sawadad B.O": "443202",
      "Wadgaon Mali B.O": "443202",
      "Zotinga B.O": "443202",
      "Rokdiya Nagar B.O": "444203",
      "Sagoda B.O": "444203",
      "Janori Nipana B.O": "444203",
      "Jawala BK B.O": "444203",
      "Manasgaon B.O": "444203",
      "Chincholi Karfarma B.O": "444203",
      "Nagzari B.O": "444203",
      "Zadegaon B.O": "444203",
      "Bawanbir B.O": "444204",
      "Ladnapur B.O": "444204",
      "Bhongaon B.O": "444203",
      "Takli Viro B.O": "444203",
      "Banoda Eklara B.O": "444204",
      "Katel Kolad B.O": "444204",
      "Tunki B.O": "444204",
      "Shioni Taka B.O": "443203",
      "ATALI": "444303",
      "BOTHA KAJI": "444303",
      "GARADGAON": "444303",
      "GONDHANAPUR": "444303",
      "KINHI MAHADEO": "444303",
      "GHAROD": "444303",
      "HIWARKHED": "444303",
      "JALAMB": "444303",
      "ROHNA": "444303",
      "SHAHAPUR": "444303",
      "SHIRLA NEMANE": "444303",
      "TEMBHURNA": "444303",
      "Karwand B.O": "444301",
      "Mangrul Navghare B.O": "444301",
      "Takarkhed Helga B.O": "444301",
      "Changephal B.O": "443308",
      "Jambhora B.O": "443308",
      "Deulgaon Sakharsha B.O": "443304",
      "Hiwara Khurd B.O": "443304",
      "Gandhari B.O": "443302",
      "Jambhul B.O": "443302",
      "Anjani B.O": "443301",
      "Chincholi Bore B.O": "443301",
      "Deulgaon Kol B.O": "443301",
      "Deulgaon Mali B.O": "443301",
      "Kalyana B.O": "443301",
      "Khalegaon B.O": "443301",
      "Lawhala B.O": "443301",
      "Loni Gaoli B.O": "443301",
      "Pimpalgaon Unda B.O": "443301",
      "Pimpri Khandare B.O": "443301",
      "Dadulgaon B.O": "443403",
      "Bodkha B.O": "444202",
      "Kankanwada B.O": "444202",
      "BORI ADGAON": "444303",
      "AWAR": "444303",
      "CHITODA": "444303",
      "LOKHANDA": "444303",
      "LONI": "444303",
      "PALSHI": "444303",
      "PIMPRI GAWALI": "444303",
      "Isoli B.O": "444301",
      "Belgaon B.O": "443303",
      "Gohogaon B.O": "443303",
      "Shelgaon Deshmukh B.O": "443303",
      "Raheri BK B.O": "443308",
      "Sonoshi B.O": "443308",
      "Amboda B.O": "444312",
      "Lanjud B.O": "444312",
      "M.I.D.C. (Khamgaon) B.O": "444312",
      "Pangra Dole B.O": "443302",
      "Sultanpur B.O": "443302",
      "Tambola B.O": "443302",
      "Anjani Khurd B.O": "443301",
      "Rajegaon B.O": "443301",
      "Shioni Pisa B.O": "443301",
      "Somthana B.O": "443301",
      "Kavthal B.O": "444201",
      "Kodri B.O": "444201",
      "Wankhed B.O": "444201",
      "Warwat Khanderao B.O": "444201",
      "Gadegaon Khurd B.O": "443403",
      "Khandvi B.O": "443403",
      "Borjawala B.O": "444306",
      "Dhorapgaon B.O": "444306",
      "Ghanegaon B.O": "444306",
      "Palsi Zanshi B.O": "444202",
      "Warwat Bakal B.O": "444202",
      "Saokhed Tejan B.O": "443203",
      "Umrad B.O": "443203",
      "ANTRAJ": "444303",
      "GANESHPUR": "444303",
      "GAVHAN": "444303",
      "HINGANA KAREGAON": "444303",
      "KALEGAON": "444303",
      "LAKHANWADA": "444303",
      "VIHIGAON": "444303",
      "WAZAR": "444303",
      "AMBETAKALI": "444303",
      "Chinchpur B.O": "444301",
      "Toranwada B.O": "444301",
      "Aregaon B.O": "443303",
      "Vishvi B.O": "443303",
      "Wardadi BK B.O": "443308",
      "Sutala BK B.O": "444312",
      "Sarshiv B.O": "443304",
      "Hirdao B.O": "443302",
      "Raigaon B.O": "443302",
      "Veni B.O": "443302",
      "Wadhao B.O": "443302",
      "Bhosa B.O": "443301",
      "Chaigaon B.O": "443301",
      "Ghatbori B.O": "443301",
      "Naigaon Duttapur B.O": "443301",
      "Pimpri Mali B.O": "443301",
      "Sonati B.O": "443301",
      "Adol BK B.O": "443403",
      "Dhanora Mahasidha B.O": "443403",
      "Parkhed B.O": "444306",
      "Adsul B.O": "444203",
      "LASURA KD": "444303",
      "UNDRI": "444303",
      "WARNA": "444303",
      "Dhotra Naik B.O": "444301",
      "Pangarkhed B.O": "443303",
      "Tadshioni B.O": "443308",
      "Pahurjira B.O": "444312",
      "Pimpri Deshmukh B.O": "444312",
      "Kalambeshwar B.O": "443304",
      "Uti B.O": "443304",
      "Nandra B.O": "443302",
      "Shara B.O": "443302",
      "Titvi B.O": "443302",
      "Wadgaon Tejan B.O": "443302",
      "Antri Deshmukh B.O": "443301",
      "Bramhapuri B.O": "443301",
      "Hiwara BK B.O": "443301",
      "Mola B.O": "443301",
      "Shendla B.O": "443301",
      "Ukali B.O": "443301",
      "Jastgaon B.O": "444201",
      "Palsi Supo B.O": "443403",
      "Bhalegaon Bazar B.O": "444306",
      "Jalka Bhadang B.O": "444306",
      "Poraj B.O": "444306",
      "Alsana B.O": "444203",
      "Buldana H.O": "443001",
      "Khamgaon H.O": "444303",
      "Chandur Biswa S.O": "443401",
      "Cotton Market Chikhli S.O": "443201",
      "Datala S.O": "443102",
      "Dharangaon S.O (Buldhana)": "443112",
      "Sindkhed Raja S.O": "443203",
      "Amdapur S.O": "444301",
      "Matergaon S.O": "444304",
      "Sangrampur S.O (Buldhana)": "444202",
      "Shegaon S.O": "444203",
      "Bhajisath Nandura S.O": "443404",
      "Deulgaon Mahi S.O": "443206",
      "Dhamangaon Badhe S.O": "443104",
      "Malkapur S.O (Buldhana)": "443101",
      "G.S.College Khamgaon S.O": "444312",
      "Mehkar S.O": "443301",
      "Chaitanya Wadi S.O": "443002",
      "Malkapur City S.O": "443101",
      "Motala S.O": "443103",
      "Dongaon S.O": "443303",
      "Dusarbid S.O": "443308",
      "Janephal S.O": "443304",
      "Paturda S.O": "444201",
      "Pimpalgaon Kale S.O": "443403",
      "Pimpalgaon Raja S.O": "444306",
      "Sonala S.O": "444204",
      "Chikhli S.O (Buldhana)": "443201",
      "Deulgaon Raja S.O": "443204",
      "Dhad S.O": "443106",
      "Jalgaon S.O": "443402",
      "Nandura S.O": "443404",
      "Sakhar Kherda S.O": "443202",
      "Kelanagar S.O": "444303",
      "Lonar S.O": "443302"
    },
    "SINDHUDURG": {
      "Ambegaon B.O": "416519",
      "Otavane B.O": "416511",
      "CHARATHA B.O": "416511",
      "Malewad B.O": "416518",
      "Salgaon B.O": "416519",
      "Netarde B.O": "416511",
      "Sasoli B.O": "416511",
      "Wafoli B.O": "416511",
      "Dingane B.O": "416511",
      "Nerur B.O": "416525",
      "Ayee B.O": "416512",
      "Mangeli B.O": "416512",
      "Pikule B.O": "416512",
      "Talavane B.O": "416513",
      "Degave B.O": "416511",
      "Talkat B.O": "416511",
      "Vilvade B.O": "416511",
      "Kudase B.O": "416512",
      "Usap B.O": "416512",
      "Zarebambar Vasahat B.O": "416512",
      "Digas B.O": "416521",
      "Nirukhe B.O": "416521",
      "Varde B.O": "416521",
      "Sangeli B.O": "416531",
      "Bibavane B.O": "416520",
      "Ghavanale B.O": "416520",
      "Goveri B.O": "416520",
      "Hirlok B.O": "416520",
      "Vadivaravde B.O": "416520",
      "Vetal Bambarde B.O": "416520",
      "Kas B.O": "416514",
      "Kavathani B.O": "416514",
      "Vados B.O": "416519",
      "Vasoli B.O": "416519",
      "Ajgaon B.O": "416518",
      "Aravli B.O": "416518",
      "Asoli B.O": "416518",
      "Vetore B.O": "416516",
      "Bhadgaon Budruk B.O": "416521",
      "Shirshinge B.O": "416531",
      "Ghotagewadi B.O": "416549",
      "Kunkeri B.O": "416518",
      "Insuli B.O": "416511",
      "Niravade B.O": "416518",
      "Karivade B.O": "416531",
      "Majgaon B.O": "416518",
      "Nhaveli B.O": "416518",
      "Kalane B.O": "416511",
      "Kolzar B.O": "416511",
      "Kumbral B.O": "416511",
      "Morgaon B.O": "416511",
      "Sateli Traf Bhedshi B.O": "416512",
      "Shirange B.O": "416512",
      "Konal B.O": "416549",
      "Bambuli B.O": "416520",
      "Keravade B.O": "416520",
      "Khutvalwadi B.O": "416520",
      "Mandkuli B.O": "416520",
      "Tendoli B.O": "416520",
      "Tulsuli B.O": "416520",
      "Nigude B.O": "416514",
      "Satose B.O": "416514",
      "Dukanwad B.O": "416519",
      "Gothos B.O": "416519",
      "Shivapur B.O": "416519",
      "Karliwadi B.O": "416523",
      "Mhapan B.O": "416522",
      "Dhakore B.O": "416518",
      "Tiravade B.O": "416604",
      "Matond B.O": "416529",
      "Khanoli B.O": "416516",
      "Ubhadanda B.O": "416516",
      "Choukul B.O": "416550",
      "Bhalaval B.O": "416511",
      "Sarmale B.O": "416511",
      "Tambuli B.O": "416511",
      "Zolambe B.O": "416511",
      "Ghotage B.O": "416632",
      "Maneri B.O": "416512",
      "Parme B.O": "416512",
      "Amboli B.O": "416550",
      "Kolamb B.O": "416626",
      "Avalegaon B.O": "416521",
      "Tervan Medhe B.O": "416549",
      "Mulde B.O": "416520",
      "Pawashi B.O": "416520",
      "Sarambal B.O": "416520",
      "Sonavade B.O": "416632",
      "MADURA B.O": "416514",
      "Mahadevache Kervade B.O": "416519",
      "Naneli B.O": "416519",
      "Narur B.O": "416519",
      "Nileli B.O": "416519",
      "Bhogave B.O": "416523",
      "Khavane B.O": "416522",
      "Kochara B.O": "416522",
      "Hodavade B.O": "416529",
      "Pendhryachiwadi B.O": "416529",
      "Adeli B.O": "416516",
      "Ansur B.O": "416516",
      "Asolipal B.O": "416516",
      "Wainganiwadi B.O": "416516",
      "Kavathi B.O": "416524",
      "Talekhol B.O": "416512",
      "Vazare B.O": "416512",
      "Pinguli B.O": "416528",
      "Pangrad B.O": "416521",
      "Verle B.O": "416531",
      "Ker B.O": "416549",
      "Andurla B.O": "416520",
      "Bav B.O": "416520",
      "Kelus B.O": "416520",
      "Madyachiwadi B.O": "416520",
      "Terse Bambarde B.O": "416520",
      "Aros B.O": "416514",
      "Sherla B.O": "416514",
      "Kaleli B.O": "416519",
      "Nivaje B.O": "416519",
      "Terawalewadi B.O": "416523",
      "Niwatiwadi B.O": "416522",
      "Tak B.O": "416518",
      "Wadkhol B.O": "416518",
      "Dabholi B.O": "416516",
      "Math B.O": "416516",
      "Vajarat B.O": "416516",
      "Chendavan B.O": "416524",
      "Danoli B.O": "416550",
      "Sarjekot Miryabanda B.O": "416626",
      "Devbag B.O": "416605",
      "Wairy Bhutnath B.O": "416605",
      "Palsamb B.O": "416614",
      "Waingani B.O": "416614",
      "Pokharan B.O": "416628",
      "Kupavade B.O": "416632",
      "Dabhole B.O": "416612",
      "Bharni B.O": "416632",
      "Bidwadi B.O": "416602",
      "Gopuri B.O": "416602",
      "Halval B.O": "416602",
      "Harkul Budruk B.O": "416602",
      "Humbrat B.O": "416602",
      "Janavali B.O": "416602",
      "Kasaral B.O": "416602",
      "Otav B.O": "416602",
      "Hiwale B.O": "416603",
      "Khotale B.O": "416603",
      "Osargaon B.O": "416603",
      "Ovaliye B.O": "416603",
      "Kunkavale B.O": "416604",
      "Mogarne B.O": "416604",
      "Revandi B.O": "416626",
      "Devli B.O": "416605",
      "Kandalgaon B.O": "416608",
      "Khaida B.O": "416608",
      "Kunde B.O": "416628",
      "Salel B.O": "416605",
      "Mithmumbari B.O": "416612",
      "Tembavli B.O": "416612",
      "Kasavan B.O": "416602",
      "Main B.O": "416602",
      "Nagve B.O": "416602",
      "Chafekhol B.O": "416604",
      "Golvan B.O": "416604",
      "Bandivade B.O": "416608",
      "Soundale B.O": "416804",
      "Thakurwadi B.O": "416804",
      "Tarkarli B.O": "416605",
      "Adavli B.O": "416614",
      "Chindar Bazar B.O": "416614",
      "Hirlewadi B.O": "416614",
      "Pirawadi B.O": "416614",
      "Dhamapur B.O": "416605",
      "Baparde B.O": "416613",
      "Waniwade B.O": "416613",
      "Ilye B.O": "416612",
      "Kunkeshwar B.O": "416612",
      "Shirval B.O": "416620",
      "Asrondi B.O": "416602",
      "Karanje B.O": "416602",
      "Sakedi B.O": "416602",
      "Tarandale B.O": "416602",
      "Varavade B.O": "416602",
      "Hedul B.O": "416603",
      "Waingavde B.O": "416603",
      "Nandos B.O": "416604",
      "Varad B.O": "416604",
      "Kunkavan B.O": "416703",
      "Nadgive B.O": "416703",
      "Nanivade B.O": "416703",
      "Malond B.O": "416608",
      "Poip B.O": "416608",
      "Hindale B.O": "416630",
      "Poyare B.O": "416630",
      "Mahalunge B.O": "416811",
      "Patgaon B.O": "416811",
      "Damre B.O": "416601",
      "Ghonsari B.O": "416601",
      "Tondavali B.O": "416626",
      "Nirom B.O": "416616",
      "Sandave B.O": "416616",
      "Dariste B.O": "416609",
      "Asalda B.O": "416610",
      "Koloshi B.O": "416610",
      "Dabhachiwadi B.O": "416812",
      "Oros Budruk B.O": "416812",
      "Are B.O": "416611",
      "Gadhitamhane B.O": "416611",
      "Kinjavade B.O": "416611",
      "Gavane B.O": "416801",
      "Het B.O": "416813",
      "Pural B.O": "416805",
      "Achirne B.O": "416810",
      "Kumbhavade B.O": "416609",
      "Jambhavade B.O": "416810",
      "Pendhari B.O": "416811",
      "Pomburla B.O": "416811",
      "Karul B.O": "416601",
      "Kurli B.O": "416601",
      "Wagheri B.O": "416601",
      "Nardave B.O": "416609",
      "Natal B.O": "416609",
      "Kuvale B.O": "416610",
      "Salshi B.O": "416610",
      "Ran Bambuli B.O": "416812",
      "Gavrai B.O": "416534",
      "Talgaon B.O": "416534",
      "Talavade B.O": "416611",
      "Torsole B.O": "416611",
      "Valivande B.O": "416611",
      "Ozaram B.O": "416801",
      "Shidavane B.O": "416801",
      "Waghivare B.O": "416801",
      "Arule B.O": "416810",
      "Gadmath B.O": "416810",
      "Karulbavada B.O": "416810",
      "Sadure B.O": "416810",
      "Sangulwadi B.O": "416810",
      "Nerle B.O": "416810",
      "Girye B.O": "416806",
      "Devsu B.O": "416550",
      "Nemale B.O": "416516",
      "Sonurli B.O": "416518",
      "Akeri B.O": "416519",
      "Upale B.O": "416813",
      "Pendur B.O": "416604",
      "Korla B.O": "416703",
      "Tithavli B.O": "416703",
      "Veral B.O": "416608",
      "Lore i B.O": "416601",
      "Lore II B.O": "416601",
      "Budhavale B.O": "416616",
      "Gothane B.O": "416616",
      "Kirlos B.O": "416616",
      "Math Budruk B.O": "416616",
      "Anav B.O": "416812",
      "Humarmala B.O": "416812",
      "Kotkamte B.O": "416611",
      "Wargaon B.O": "416801",
      "Napne B.O": "416813",
      "Bhuibavda B.O": "416813",
      "Akhavane B.O": "416813",
      "Kusur B.O": "416813",
      "Kumbharmath B.O": "416605",
      "Bilwas B.o": "416608",
      "Chindar B.O": "416614",
      "Gaudwadi B.O": "416614",
      "Trimbak B.O": "416614",
      "Amberi B.O": "416605",
      "Kalse B.O": "416605",
      "Nandrukh B.O": "416605",
      "Taramumbari B.O": "416613",
      "Katta B.O": "416612",
      "Shivdav B.O": "416620",
      "Aynal B.O": "416602",
      "Kalmath B.O": "416602",
      "Nandgaon B.O": "416602",
      "Savdav B.O": "416602",
      "Shirvande B.O": "416602",
      "Bordave B.O": "416603",
      "Kurangavane B.O": "416703",
      "Deulwada B.O": "416608",
      "Masde B.O": "416608",
      "Tambaldeg B.O": "416615",
      "Dahibav B.O": "416630",
      "Munge B.O": "416630",
      "Waghotan B.O": "416804",
      "Burambavade B.O": "416811",
      "Manche B.O": "416811",
      "Belnekhurd B.O": "416601",
      "Harkul Khurd B.O": "416601",
      "Rathivade B.O": "416616",
      "Shravan B.O": "416616",
      "Bhirvande B.O": "416609",
      "Digavle B.O": "416609",
      "Hadpid B.O": "416610",
      "Pandur B.O": "416812",
      "Padve B.O": "416534",
      "Khudi B.O": "416611",
      "Kasarde B.O": "416801",
      "Nad B.O": "416801",
      "Mangavli B.O": "416813",
      "Nadan B.O": "416805",
      "Khambale B.O": "416810",
      "Kokisara B.O": "416810",
      "Nadhavade B.O": "416810",
      "Madkhol B.O": "416531",
      "Zarap B.O": "416519",
      "Kolgaon B.O": "416519",
      "Malgaon B.O": "416608",
      "Malvan H.O": "416606",
      "Sawantwadi H.O": "416510",
      "Ambrad S.O": "416628",
      "Devgad S.O": "416613",
      "Jambhavade S.O": "416632",
      "Kalsuli S.O": "416620",
      "Kasal S.O": "416603",
      "Sangve S.O": "416609",
      "Talera S.O (Sindhudurg)": "416801",
      "Aronda S.O": "416513",
      "Banda S.O (Sindhudurg)": "416511",
      "Dodamarg S.O": "416512",
      "Industrial Area Pinguli S.O": "416528",
      "Kadaval S.O": "416521",
      "Kudal Audyogik Samuha S.O": "416550",
      "Vengurla S.O": "416516",
      "Katta S.O": "416604",
      "Mithbav S.O": "416615",
      "Mutat S.O": "416803",
      "Padel S.O": "416804",
      "Phondaghat S.O": "416601",
      "Sindhudurgnagari MDG S.O": "416812",
      "Vada S.O (Sindhudurg)": "416805",
      "Vaibhavwadi S.O": "416810",
      "Vijaydurg S.O": "416806",
      "Konalkatta Colony S.O": "416549",
      "Parula S.O": "416523",
      "Redi S.O": "416517",
      "Shiroda S.O (Sindhudurg)": "416518",
      "Achara S.O": "416614",
      "Jamsande S.O": "416612",
      "Masura S.O": "416608",
      "Phanasgaon S.O": "416811",
      "Talebazar S.O": "416611",
      "Tirlot S.O": "416807",
      "Kalmist S.O": "416531",
      "Kudal S.O (Sindhudurg)": "416520",
      "Satarda S.O": "416514",
      "Pat S.O": "416522",
      "Tulas S.O": "416515",
      "Vengurla Camp S.O": "416516",
      "Walaval S.O": "416524",
      "Chouke S.O": "416605",
      "Hadi S.O": "416626",
      "Kankavli S.O": "416602",
      "Kharepatan S.O": "416703",
      "Mond S.O": "416623",
      "Naringre S.O": "416630",
      "Ramgad S.O": "416616",
      "Shirgaon S.O": "416610",
      "Sukalwadi S.O": "416534",
      "Umbarde S.O": "416813",
      "Deulwada Nerur S.O": "416525",
      "Mangaon S.O (Sindhudurg)": "416519",
      "Talavade S.O": "416529"
    },
    "NANDED": {
      "Martoli B.O": "431718",
      "Jarikot B.O": "431808",
      "Ambadi B.O": "431804",
      "Digadi B.O": "431804",
      "Kupti B.O": "431803",
      "Loni B.O": "431704",
      "Nagzari B.O": "431804",
      "Pandhara B.O": "431804",
      "Rajgad B.O": "431804",
      "Digras B.O": "431713",
      "Karegaon B.O": "431708",
      "Raiwadi B.O": "431708",
      "Sawargaon B.O": "431712",
      "Shewadi B.O": "431708",
      "Sunegaon B.O": "431708",
      "Papalwadi B.O": "431721",
      "Wai B.O": "431721",
      "Dattmanjari B.O": "431721",
      "Anmal B.O": "431721",
      "Hadsani B.O": "431721",
      "Bhorad B.O": "431721",
      "Asoli B.O": "431721",
      "Hardaf B.O": "431712",
      "Lakhamapur B.O": "431721",
      "Gondwadsa B.O": "431721",
      "Wadsa B.O": "431721",
      "Dahelitanda B.O": "431805",
      "Darsangvi B.O": "431811",
      "Dundra B.O": "431805",
      "Jarur B.O": "431805",
      "Kanki B.O": "431805",
      "Khambala B.O": "431805",
      "Kothari B.O": "431811",
      "Singoda B.O": "431805",
      "Umri B.O": "431805",
      "Unakdev B.O": "431805",
      "Rohipimpalgaon B.O": "431806",
      "Khatgaon B.O": "431736",
      "Ravankola B.O": "431719",
      "Ravi B.O": "431719",
      "Bhendegaon KH B.O": "431715",
      "Billali B.O": "431715",
      "Honwadaj B.O": "431715",
      "Jahur B.O": "431715",
      "Kalambar B.O": "431746",
      "Kerur B.O": "431715",
      "Shirur Dabhade B.O": "431715",
      "Umardari B.O": "431715",
      "Koklegaon B.O": "431741",
      "Krushnur B.O": "431709",
      "Kuntur B.O": "431709",
      "Manoor B.O": "431807",
      "Patoda B.O": "431811",
      "Rui BK B.O": "431709",
      "Rui B.O": "431721",
      "Shirad B.O": "431743",
      "Shirur B.O": "431743",
      "Narangal B.O": "431723",
      "Shelgaon B.O": "431807",
      "Adampur B.O": "431736",
      "Alandi B.O": "431736",
      "Atkali B.O": "431736",
      "Sawali B.O": "431710",
      "Aitala B.O": "431808",
      "Ghoti B.O": "431804",
      "Mandava B.O": "431804",
      "Maregaon B.O": "431804",
      "Mungashi B.O": "431804",
      "Nichpur B.O": "431804",
      "Hungunda B.O": "431711",
      "Bolka B.O": "431742",
      "Guntur B.O": "431742",
      "Dagadgaon B.O": "431708",
      "Dongargaon B.O": "431708",
      "Lohrala B.O": "431708",
      "Penoor B.O": "431708",
      "Risangaon B.O": "431708",
      "Sonkhed B.O": "431708",
      "Machindrapardi B.O": "431721",
      "Ivaleshwar B.O": "431721",
      "Tulshi B.O": "431721",
      "Daheli B.O": "431805",
      "Jawarala B.O": "431805",
      "Karanji B.O": "431805",
      "Lingi B.O": "431805",
      "Nirala B.O": "431805",
      "Sattiguda B.O": "431805",
      "Dongaon B.O": "431806",
      "Mendka B.O": "431806",
      "Mugat B.O": "431806",
      "Punegaon B.O": "431806",
      "Sawarmal B.O": "431719",
      "Ambulga B.O": "431714",
      "Bomnali B.O": "431715",
      "Hatral B.O": "431715",
      "Kharabkhandgaon B.O": "431715",
      "Pala B.O": "431715",
      "Wadgaon B.O": "431715",
      "Dhanora B.O": "431810",
      "Kahala B.O": "431709",
      "Narsi B.O": "431709",
      "Sangvi B.O": "431709",
      "Waka B.O": "431709",
      "Bhategaon B.O": "431743",
      "Koli B.O": "431743",
      "Pewa B.O": "431743",
      "Dahikalamba B.O": "431707",
      "Telki B.O": "431707",
      "Thadihiparga B.O": "431731",
      "Alur B.O": "431723",
      "Tamlur B.O": "431723",
      "Hipparga Mal. B.O.": "431736",
      "Walag B.O": "431718",
      "Bolsa B.O": "431807",
      "Kamthala B.O": "431804",
      "Malkapur B.O": "431804",
      "Mohapur B.O": "431804",
      "Sindgi B.O": "431804",
      "Wanola B.O": "431804",
      "Arjapur B.O": "431711",
      "Machnur B.O": "431711",
      "Hadoli B.O": "431742",
      "Betsangavi B.O": "431708",
      "Malegaon B.O": "431708",
      "Anjankhed B.O": "431721",
      "Malakaguda B.O": "431721",
      "Saiphal B.O": "431721",
      "Padsa B.O": "431721",
      "Ashta B.O": "431721",
      "Hingani B.O": "431721",
      "Chinchkhed B.O": "431805",
      "Nagapur B.O": "431805",
      "Palsi B.O": "431805",
      "Sarkhani B.O": "431805",
      "Sindkhed B.O": "431805",
      "Daregaon B.O": "431806",
      "Malkautha B.O": "431806",
      "Niwgha B.O": "431806",
      "Barhali B.O": "431715",
      "Chandola B.O": "431715",
      "Kundrala B.O": "431715",
      "Rajura BK B.O": "431715",
      "Ravangaon B.O": "431715",
      "Shikara B.O": "431715",
      "Vasantnagar B.O": "431715",
      "Wasur B.O": "431715",
      "Yeoti B.O": "431715",
      "Degaon B.O": "431719",
      "Ghungarala B.O": "431709",
      "Sujlegaon B.O": "431709",
      "Hastara B.O": "431743",
      "Unchegaon B.O": "431712",
      "Joshisangavi B.O": "431707",
      "Shiradhone B.O": "431707",
      "Umara B.O": "431707",
      "Bolegaon B.O": "431731",
      "Nandur B.O": "431723",
      "Wannali B.O": "431723",
      "Kinala B.O": "431736",
      "Ramtirth B.O": "431736",
      "Bhopala B.O.": "431736",
      "Loha B.O": "431713",
      "Pathrad B.O": "431713",
      "Talegaon B.O": "431807",
      "Umri(J) B.O": "431713",
      "Waipana B.O": "431713",
      "Lakshminagar B.O": "431605",
      "Maralak B.O": "431605",
      "Nerli B.O": "431605",
      "Pimpalgaon B.O": "431805",
      "Karla B.O": "431807",
      "Vishnupuri B.O": "431606",
      "Wadepuri B.O": "431606",
      "Balegaon B.O": "431807",
      "Bijegaon B.O": "431807",
      "Gortha B.O": "431807",
      "Somthana B.O": "431807",
      "Jambhala B.O": "431713",
      "Taroda BK B.O": "431605",
      "Bitnal B.O": "431807",
      "Golegaon B.O": "431714",
      "Sindhi B.O": "431807",
      "Chikana B.O": "431808",
      "Malborgaon B.O": "431804",
      "Wadoli B.O": "431804",
      "Nehrunagar B.O": "431742",
      "Adgaon B.O": "431708",
      "Ashtoor B.O": "431708",
      "Berli B.O": "431708",
      "Malakoli B.O": "431708",
      "Madnapur B.O": "431721",
      "Gondegaon B.O": "431721",
      "Bondgavan B.O": "431805",
      "Pathari B.O": "431805",
      "Raipurtanda B.O": "431805",
      "SakrunaikTanda B.O": "431805",
      "Chikala B.O": "431806",
      "Halni B.O": "431719",
      "Berli BK B.O": "431715",
      "Betmogara B.O": "431715",
      "Dapaka G B.O": "431715",
      "Undri B.O": "431715",
      "Talani B.O": "431743",
      "Kiwala B.O": "431707",
      "Shewala B.O": "431723",
      "Sugaon B.O": "431722",
      "Bijur B.O": "431736",
      "Kesrali B.O": "431736",
      "Takli B.O": "431736",
      "Barbada B.O": "431602",
      "Dhoki B.O": "431602",
      "Kakandi B.O": "431602",
      "Rahati B.O": "431602",
      "Waghi B.O": "431602",
      "Ghogari B.O": "431713",
      "Kandli B.O": "431713",
      "Wadi BK B.O": "431605",
      "Bothi B.O": "431807",
      "Waghalwada B.O": "431807",
      "Kaudgaon B.O": "431602",
      "Limbgaon B.O": "431602",
      "Wajegaon B.O": "431602",
      "Kapsi B.O": "431602",
      "Martala B.O": "431602",
      "Asarjan B.O": "431606",
      "Lahan B.O": "431704",
      "Nandusa B.O": "431750",
      "Bhoshi B.O": "431745",
      "Shemboli B.O": "431745",
      "Katkalamba B.O": "431746",
      "Halda B.O": "431746",
      "Kandli KH B.O": "431801",
      "Laglud B.O": "431801",
      "Pandhurana B.O": "431801",
      "Theraban B.O": "431801",
      "Belkoni Kh B.O": "431710",
      "Chinchala B.O": "431710",
      "Kolheborgaon B.O": "431710",
      "Lohgaon B.O": "431710",
      "Bodhadi KH B.O": "431810",
      "Dogargaon B.O": "431810",
      "Pardi KH B.O": "431810",
      "MIDC B.O": "431603",
      "Khanapur B.O": "431717",
      "Kangthi B.O": "431809",
      "Manjram B.O": "431722",
      "Navandi B.O": "431722",
      "Dahegaon B.O": "431811",
      "Ashti B.O": "431712",
      "Banchincholi B.O": "431712",
      "Palsa B.O": "431712",
      "Walki B.O": "431803",
      "Wazar B.O": "431741",
      "Kamari B.O": "431802",
      "Pawana B.O": "431802",
      "Sarsam B.O": "431802",
      "Gondemahagaon B.O": "431803",
      "Kancholi B.O": "431803",
      "Kosmet B.O": "431803",
      "Talhari B.O": "431803",
      "Wartala B.O": "431716",
      "Bori BK B.O": "431714",
      "Ghodaj B.O": "431714",
      "Pethwadaj B.O": "431714",
      "Phulwal B.O": "431714",
      "Gojegaon B.O": "431718",
      "Halli B.O": "431718",
      "Nimgaon B.O": "431704",
      "Pardi Makta B.O": "431704",
      "Warwant B.O": "431746",
      "Deoshi B.O": "431801",
      "Deothana B.O": "431801",
      "Matul B.O": "431801",
      "Sonari B.O": "431801",
      "Karla Kalam B.O": "431710",
      "Kasrali B.O": "431710",
      "Laghul B.O": "431710",
      "Jaldhara B.O": "431810",
      "Kopra B.O": "431810",
      "Dhanegaon B.O": "431603",
      "Tuppa B.O": "431603",
      "Motarga B.O": "431717",
      "Chincholi B.O": "431809",
      "Dugaon B.O": "431809",
      "Khandgaon B.O": "431722",
      "Kolambi B.O": "431722",
      "Ratoli B.O": "431722",
      "Shaniwarpeth B.O": "431811",
      "Baradshewala B.O": "431712",
      "Chinchgavan B.O": "431712",
      "Choramba B.O": "431712",
      "Manur B.O": "431741",
      "Jawalgaon B.O": "431802",
      "Khadki B.O": "431802",
      "Mangrul B.O": "431802",
      "Pota BK B.O": "431802",
      "Siranjani B.O": "431802",
      "Virsani B.O": "431802",
      "Kolhari B.O": "431803",
      "Paroti B.O": "431803",
      "Shivani B.O": "431803",
      "Nandgaon B.O": "431803",
      "Dapka Raja B.O": "431716",
      "Kamjalga B.O": "431716",
      "P. Sawargaon B.O": "431716",
      "Gonar B.O": "431714",
      "Hadoli J B.O": "431714",
      "Panbhoshi B.O": "431714",
      "Pangara B.O": "431714",
      "Umraj B.O": "431714",
      "Kawalgaon B.O": "431718",
      "Malegaon Makta B.O": "431718",
      "Markhel B.O": "431718",
      "Chabhara B.O": "431704",
      "Delub B.O": "431750",
      "Kamtha B.O": "431750",
      "Wakad B.O": "431745",
      "Chikhali B.O": "431803",
      "Mangalsangavi B.O": "431746",
      "Bembari B.O": "431801",
      "Moghali B.O": "431801",
      "Palaj B.O": "431801",
      "Arli B.O": "431710",
      "Bamni B.O": "431710",
      "Badur B.O": "431710",
      "Talni B.O": "431710",
      "Thara B.O": "431810",
      "Ballur B.O": "431717",
      "Chondi B.O": "431717",
      "Degaon BK B.O": "431717",
      "Eklara B.O": "431717",
      "Hawarga B.O": "431717",
      "Gaglegaon B.O": "431809",
      "Salegaon B.O": "431809",
      "Yetala B.O": "431809",
      "Andbori B.O": "431803",
      "Pimparkhed B.O": "431712",
      "Dudhad B.O": "431802",
      "Apparaopeth B.O": "431803",
      "Bhishi B.O": "431803",
      "Mulzara B.O": "431803",
      "Nandgaon Tanda B.O": "431803",
      "Bachoti B.O": "431714",
      "Kasarkheda B.O": "431750",
      "Barasgaon B.O": "431745",
      "Dabhad B.O": "431745",
      "Kautha B.O": "431746",
      "Sawaleshwar B.O": "431746",
      "Kini B.O": "431801",
      "Belkoni BK B.O": "431710",
      "Dongaon KH B.O": "431710",
      "Ritha B.O": "431810",
      "Singarwadi B.O": "431810",
      "Bhayegaon B.O": "431717",
      "Hottal B.O": "431717",
      "Tadkhel B.O": "431717",
      "Hussa B.O": "431809",
      "Mangnali B.O": "431809",
      "Raher B.O": "431809",
      "Marwali B.O": "431722",
      "Mugaon B.O": "431722",
      "Tembhurni B.O": "431722",
      "Bendi B.O": "431811",
      "Gorlegaon B.O": "431712",
      "Kawana B.O": "431712",
      "Manatha B.O": "431712",
      "Talang B.O": "431712",
      "Bhutan Hipparga B.O": "431741",
      "Kunmarpalli B.O": "431741",
      "Shilvani B.O": "431741",
      "Sawana B.O": "431802",
      "Gondjevali B.O": "431803",
      "Iregaon B.O": "431803",
      "Malakjamb B.O": "431803",
      "Totamba B.O": "431803",
      "Bahadarpura B.O": "431714",
      "Gaul B.O": "431714",
      "Panshewadi B.O": "431714",
      "Shekapur B.O": "431714",
      "Nanded H.O": "431601",
      "Barul S.O": "431746",
      "Biloli S.O": "431710",
      "Bodhadi S.O": "431810",
      "Degloor S.O": "431717",
      "Dharmabad S.O": "431809",
      "Gadga S.O": "431722",
      "Hadgaon S.O": "431712",
      "Himayatnagar S.O": "431802",
      "Islapur S.O": "431803",
      "Kurula S.O": "431742",
      "Loha S.O": "431708",
      "Malegaon S.O": "431750",
      "Mandvi S.O (Nanded)": "431805",
      "Nanded Town S.O": "431601",
      "Niwgha S.O": "431743",
      "Sagroli S.O": "431731",
      "Taroda Road Nanded S.O": "431605",
      "Umri S.O": "431807",
      "Yeshwantnagar  Nanded S.O": "431602",
      "Ardhapur S.O": "431704",
      "Chaitanynagar Nanded  S.O": "431605",
      "Hanegaon S.O": "431741",
      "Itwara Nanded S.O": "431604",
      "Kandhar S.O": "431714",
      "Karkheli S.O": "431808",
      "Kundalwadi S.O": "431711",
      "Millgate Nanded S.O": "431601",
      "Mukhed S.O": "431715",
      "Nayamondha Nanded S.O": "431602",
      "Osmannagar S.O (Nanded)": "431707",
      "Sachkhand Nanded S.O": "431601",
      "Shahapur S.O (Nanded)": "431723",
      "Shivajinagar S.O (Nanded)": "431602",
      "Tamsa S.O": "431713",
      "Cidco Nanded S.O": "431603",
      "Degloor Town S.O": "431717",
      "Gokunda S.O": "431811",
      "Jamb B K S.O": "431716",
      "Shankarnagar S.O": "431736",
      "SRTMU Nanded S.O": "431606",
      "Ashoknagar S.O (Nanded)": "431605",
      "Barad S.O": "431745",
      "Bhokar S.O": "431801",
      "Chauphala S.O": "431604",
      "Karadkhed S.O": "431718",
      "Karimabad Nanded S.O": "431604",
      "Kinwat S.O": "431804",
      "Mahore S.O (Nanded)": "431721",
      "Mudkhed Station S.O": "431806",
      "Mukramabad S.O": "431719",
      "Naigaon S.O (Nanded)": "431709"
    },
    "SOLAPUR": {
      "Sapatane ( Bhose ) B.O": "413208",
      "Jamgaon B.O": "413209",
      "Undargaon B.O": "413209",
      "Vadshinge B.O": "413209",
      "Chikmahud B.O": "413306",
      "Gardi B.O": "413306",
      "Khavaspur B.O": "413306",
      "Mahim B.O": "413306",
      "Anjangaon Umate B.O": "413209",
      "Ridhore B.O": "413250",
      "Tandulwadi B.O": "413310",
      "Padasali B.O": "413208",
      "Pimpalkhunte B.O": "413208",
      "Mahatpur B.O": "413209",
      "Uplai Budruk B.O": "413209",
      "Uplai Khurd B.O": "413209",
      "Katphal B.O": "413306",
      "Kolegaon B.O": "413213",
      "Lotewadi B.O": "413306",
      "Sangvi Budruk B.O": "413216",
      "Shaval B.O": "413216",
      "Shiraval B.O": "413216",
      "Umarge B.O": "413216",
      "Satan Dudhani B.O": "413216",
      "Shripat Pimpari B.O": "413401",
      "Sondare B.O": "413401",
      "Khamgaon B.O": "413401",
      "Tadvale B.O": "413208",
      "Darfal B.O": "413209",
      "Achakdani B.O": "413306",
      "Gaigavan B.O": "413306",
      "Babhulgaon B.O": "413304",
      "Chumb B.O": "413409",
      "Mandegaon B.O": "413409",
      "Bagehalli B.O": "413216",
      "Hattikanbus B.O": "413216",
      "Kini B.O": "413216",
      "Motyal B.O": "413216",
      "Londewadi B.O": "413214",
      "Malikpeth B.O": "413214",
      "Khandvi B.O": "413401",
      "Gulpoli B.O": "413401",
      "Jamgaon  (Agalgaon) B.O": "413401",
      "Malvandi B.O": "413401",
      "Upalai  ( Thonge ) B.O": "413401",
      "Upale Dhumala B.O": "413401",
      "Pitapur B.O": "413226",
      "Chungi B.O": "413226",
      "Babalad B.O": "413220",
      "Ruddewadi B.O": "413220",
      "Bhalgaon B.O": "413406",
      "Javalgaon B.O": "413406",
      "Kanbus (Gangadhar) B.O": "413215",
      "Ankoli B.O": "413253",
      "Ghodeshwar B.O": "413253",
      "Koravali B.O": "413253",
      "Ankalge B.O": "413219",
      "Mundewadi B.O": "413219",
      "Tadwal  (Hotagi) B.O": "413219",
      "Mangrul B.O": "413219",
      "Torni B.O": "413217",
      "Kandalgaon B.O": "413221",
      "Bhandar Kavathe B.O": "413221",
      "Degaon  ( Valuj ) B.O": "413410",
      "Dhokbabhulgaon B.O": "413213",
      "Savaleshwar B.O": "413213",
      "Wadwal B.O": "413213",
      "Ghatane B.O": "413213",
      "Haidra B.O": "413227",
      "Navindgi B.O": "413227",
      "Valuj B.O": "413222",
      "Khuneshwar B.O": "413222",
      "Padsali B.O": "413222",
      "Ranmasale B.O": "413222",
      "Ghanegaon B.O": "413403",
      "Ukadgaon B.O": "413404",
      "Gormale B.O": "413404",
      "Yeoti B.O": "413248",
      "Deodi B.O": "413324",
      "Kumathe B.O": "413224",
      "Hagloor B.O": "413002",
      "Arali B.O": "413305",
      "Boramani B.O": "413002",
      "Kasegaon B.O": "413304",
      "Mardi B.O": "413002",
      "Aurad B.O": "413008",
      "Takali B.O": "413008",
      "Kategaon B.O": "413409",
      "Udagi B.O": "413216",
      "Hanjagi B.O": "413216",
      "Kajikanbus B.O": "413216",
      "Salgar B.O": "413216",
      "Bitle B.O": "413214",
      "Wakav B.O": "413214",
      "Kuslumb B.O": "413401",
      "Shendri B.O": "413401",
      "Surdi B.O": "413401",
      "Bhatambre B.O": "413401",
      "Halduge B.O": "413401",
      "Jamgaon  (Pangari) B.O": "413401",
      "Malegaon B.O": "413401",
      "Pimpalgaon B.O": "413401",
      "Tadsoundane B.O": "413401",
      "Hannur B.O": "413226",
      "Ratanjan B.O": "413406",
      "Aherwadi B.O": "413215",
      "Sohale B.O": "413253",
      "Mhaisalge B.O": "413219",
      "Antroli B.O": "413221",
      "Wangi B.O": "413221",
      "Auj B.O": "413221",
      "Gunjegaon B.O": "413305",
      "Khairao B.O": "413410",
      "Bale B.O": "413255",
      "Pakani B.O": "413255",
      "Sayyed Virwade B.O": "413213",
      "Yawali B.O": "413213",
      "Gotewadi B.O": "413213",
      "Kadabgaon B.O": "413227",
      "Kauthali B.O": "413222",
      "Masale Chaudhari B.O": "413222",
      "Darfalgavadi B.O": "413222",
      "Shelgaon B.O": "413222",
      "Kalambwadi B.O": "413403",
      "Chikharde B.O": "413404",
      "Ghari B.O": "413404",
      "Pokharapur B.O": "413248",
      "Konheri B.O": "413248",
      "Ingalgi B.O": "413002",
      "Musti B.O": "413002",
      "Belati B.O": "413002",
      "Darganhalli B.O": "413002",
      "Kavathe B.O": "413002",
      "Soregaon B.O": "413008",
      "Mouje Tadvale B.O": "413412",
      "Nandani B.O": "413008",
      "Raleras B.O": "413402",
      "Chare B.O": "413409",
      "Umbarge B.O": "413409",
      "Basalegaon B.O": "413216",
      "Boroti B.O": "413216",
      "Chikkehalli B.O": "413216",
      "Wafale B.O": "413214",
      "Anjangaon  Khilobache B.O": "413214",
      "Deogaon B.O": "413401",
      "Gadegaon B.O": "413304",
      "Barhanpur B.O": "413226",
      "Mugali B.O": "413220",
      "Sinnur B.O": "413220",
      "Hattij B.O": "413406",
      "Hotgigaon B.O": "413215",
      "Ichgaon B.O": "413253",
      "Jeur  (Akkalkot) B.O": "413219",
      "Kavhe B.O": "413252",
      "Korphale B.O": "413401",
      "Dahitne B.O": "413226",
      "Dombarjawalge B.O": "413226",
      "Kurnoor B.O": "413226",
      "Malegaon (Vairag) B.O": "413406",
      "Suler Jawalage B.O": "413215",
      "Virvade B.O": "413253",
      "Malkavathe B.O": "413221",
      "Nimbargi B.O": "413221",
      "Vinchur B.O": "413221",
      "Mendhapur B.O": "413304",
      "Anawali B.O": "413304",
      "Bhandishegaon B.O": "413304",
      "Puluj B.O": "413304",
      "Adhiv BO": "413304",
      "Ambe B.O": "413304",
      "Bagechiwadi B.O": "413101",
      "Sangramnagar BO": "413101",
      "Adhegaon B.O": "413212",
      "Nandeshwar B.O": "413322",
      "Redde B.O": "413322",
      "Dongargaon B.O": "413305",
      "Hangirge B.O": "413309",
      "Kedgaon B.O": "413202",
      "Kondhej B.O": "413202",
      "Nimbhore B.O": "413202",
      "Wangi i B.O": "413202",
      "Zare B.O": "413202",
      "Bardi B.O": "413302",
      "Borgaon (Kml) B.O": "413203",
      "Jategaon B.O": "413203",
      "Mangi B.O": "413203",
      "Takli Rasin B.O": "413203",
      "Kusur B.O": "413221",
      "Hiraj B.O": "413255",
      "Kegaon B.O": "413255",
      "Kondi B.O": "413255",
      "Kumbhari B.O": "413006",
      "Ekrukhe B.O": "413213",
      "Kurul B.O": "413213",
      "Narkhed B.O": "413213",
      "Lamboti B.O": "413213",
      "Shirapur (Solapur) B.O": "413213",
      "Tambole B.O": "413213",
      "Vadala B.O": "413222",
      "Akolekati B.O": "413222",
      "Darfalbibi B.O": "413222",
      "Kalman B.O": "413222",
      "Karamba B.O": "413222",
      "Nari B.O": "413404",
      "Takali Sikandar B.O": "413248",
      "Hiware B.O": "413324",
      "Khandali B.O": "413113",
      "Umedpur B.O": "413002",
      "Barur B.O": "413008",
      "Hattur B.O": "413008",
      "Honmurgi B.O": "413008",
      "Irle B.O": "413412",
      "Yavali B.O": "413412",
      "Korsegaon B.O": "413219",
      "Nagore B.O": "413217",
      "Kardehalli B.O": "413006",
      "Mulegaon B.O": "413006",
      "Gaudgaon B.O": "413227",
      "Tolnur B.O": "413227",
      "Sakat B.O": "413403",
      "Bavi B.O": "413301",
      "Kari B.O": "413404",
      "Pandhari B.O": "413404",
      "Mundhewadi B.O": "413304",
      "Ozewadi B.O": "413304",
      "Phulchincholi B.O": "413304",
      "Suste B.O": "413304",
      "Chale B.O": "413304",
      "Pandharechiwadi B.O": "413304",
      "Wakhari B.O": "413304",
      "Ranjani B.O": "413304",
      "Chakore B.O": "413101",
      "Kondbhav B.O": "413101",
      "Malewadi B.O": "413101",
      "Waki B.O": "413309",
      "Chikhalthan B.O": "413202",
      "Dahigaon ( Karmala ) B.O": "413202",
      "Kumbhej B.O": "413202",
      "Shelgaon Kekan B.O": "413202",
      "Tulshi B.O": "413302",
      "Devlali B.O": "413203",
      "Kolegaon ( E) B.O": "413203",
      "Korti B.O": "413304",
      "Kumbhargaon B.O": "413203",
      "Bhogewadi B.O": "413223",
      "Upalwate B.O": "413223",
      "Akulgaon B.O": "413208",
      "Kurdu B.O": "413208",
      "Laul B.O": "413208",
      "Shirale B.O": "413404",
      "Aundhi B.O": "413248",
      "Patkul B.O": "413248",
      "Papari B.O": "413324",
      "Tikekarwadi B.O": "413224",
      "Pathari B.O": "413002",
      "Ule B.O": "413002",
      "Degaon B.O": "413002",
      "Dongaon B.O": "413002",
      "Honsal B.O": "413002",
      "Tirhe B.O": "413002",
      "Dahitane B.O": "413412",
      "Veet B.O": "413203",
      "Sogaon B.O": "413206",
      "Methawade B.O": "413317",
      "Sangewadi B.O": "413317",
      "Shetphal B.O": "413317",
      "Bhutashte B.O": "413208",
      "Chincholi B.O": "413307",
      "Sarkoli B.O": "413304",
      "Tungat B.O": "413304",
      "Degaon (PPR) B.O": "413304",
      "Shelve B.O": "413304",
      "Hole B.O": "413315",
      "Patwardhan Kuroli B.O": "413315",
      "Shevate B.O": "413315",
      "Kadlas B.O": "413309",
      "Lonvire B.O": "413309",
      "Pare B.O": "413309",
      "Sonand B.O": "413309",
      "Bhalvani B.O": "413319",
      "Bitergaon ( Wangi ) B.O": "413202",
      "Shetphal ( Jeur ) B.O": "413202",
      "Umrad B.O": "413202",
      "Wangi  IIi B.O": "413202",
      "Anjandoh B.O": "413203",
      "Phisare B.O": "413203",
      "Pothare B.O": "413203",
      "Rajuri B.O": "413307",
      "Raogaon B.O": "413203",
      "Bohali B.O": "413317",
      "Dhyati (E) B.O": "413317",
      "Manjari B.O": "413317",
      "Shirbhavi B.O": "413317",
      "Sonka B.O": "413304",
      "Tawashi B.O": "413304",
      "Rople BK B.O": "413304",
      "Tarapur B.O": "413304",
      "Gopalpur B.O": "413304",
      "Siddhewadi B.O": "413304",
      "Hunnur B.O": "413322",
      "Nimboni B.O": "413322",
      "Shirnandgi B.O": "413322",
      "Alegaon B.O": "413309",
      "Gherdi B.O": "413309",
      "Kandar B.O": "413202",
      "Kugaon B.O": "413202",
      "Sangavi ( BK) B.O": "413202",
      "Umbare (Karkam ) B.O": "413302",
      "Awati B.O": "413203",
      "Gulsade B.O": "413203",
      "Jinti B.O": "413203",
      "Karanje B.O": "413203",
      "Pande B.O": "413203",
      "Sawadi B.O": "413203",
      "Vihal B.O": "413203",
      "Wadshivane B.O": "413223",
      "Washimbe B.O": "413206",
      "Save B.O": "413317",
      "Gaudwadi B.O": "413314",
      "Pachegaon (BK) B.O": "413314",
      "Bhosare B.O": "413208",
      "Dhavlas B.O": "413208",
      "Mandki B.O": "413107",
      "Andhalgaon B.O": "413305",
      "Borale B.O": "413305",
      "Siddhapur B.O": "413305",
      "Huljanti B.O": "413319",
      "Shivangi B.O": "413319",
      "Gholasgaon B.O": "413218",
      "Safale B.O": "413218",
      "Donaj B.O": "413319",
      "Nandur B.O": "413319",
      "Salgar BK B.O": "413319",
      "Talsangi B.O": "413319",
      "Aran B.O": "413301",
      "Sarole B.O": "413402",
      "Dhamangaon B.O": "413402",
      "Sasure B.O": "413402",
      "Karjal B.O": "413228",
      "Shingadgaon B.O": "413228",
      "Badole BK B.O": "413218",
      "Bhurikavathe B.O": "413218",
      "Medad B.O": "413107",
      "Tarangphal B.O": "413107",
      "Laxmi dahiwadi B.O": "413305",
      "Lendave Chinchali B.O": "413305",
      "Dharmapuri B.O": "413109",
      "Ekshiv B.O": "413109",
      "Gursale B.O": "413304",
      "Achegaon B.O": "413228",
      "Dhotri B.O": "413228",
      "Limbichincholi B.O": "413228",
      "Ajnale B.O": "413308",
      "Balwadi B.O": "413308",
      "Barloni B.O": "413252",
      "Bitergaon B.O": "413252",
      "Purandawade B.O": "413111",
      "Kamalapur B.O": "413307",
      "Medshingi B.O": "413307",
      "Pachegaon B.O": "413307",
      "Waki(Sangola) B.O": "413307",
      "Yelmarmangewadi B.O": "413307",
      "Jambhood B.O": "413112",
      "Lavang B.O": "413112",
      "Phalwani B.O": "413306",
      "Tambave B.O": "413108",
      "Islampur B.O": "413107",
      "Bramhapuri B.O": "413305",
      "Marapur B.O": "413305",
      "Patkhal B.O": "413305",
      "Dahigaon B.O": "413109",
      "Borgaon B.O": "413112",
      "Gogaon B.O": "413218",
      "Kurbavi B.O": "413109",
      "Phondshiras B.O": "413109",
      "Pimpri B.O": "413109",
      "Jainwadi B.O": "413310",
      "Palashi B.O": "413310",
      "Upari B.O": "413310",
      "Nerle B.O": "413251",
      "Akola Wasud B.O": "413307",
      "Shivane B.O": "413307",
      "Akumbhe B.O": "413211",
      "Bembale B.O": "413211",
      "Warwade B.O": "413211",
      "Bondle B.O": "413113",
      "Khudus B.O": "413113",
      "Maloli B.O": "413113",
      "Mahalung B.O": "413112",
      "Wagholi(E) B.O": "413112",
      "Kanhapuri B.O": "413211",
      "Paniv B.O": "413113",
      "Morochi B.O": "413109",
      "Phadtari B.O": "413109",
      "Shindewadi B.O": "413109",
      "Chinke B.O": "413308",
      "Bhalwani B.O": "413310",
      "Dahiwali B.O": "413210",
      "Sapatane T B.O": "413210",
      "Bhamburdi B.O": "413111",
      "Mandave B.O": "413111",
      "Varkute B.O": "413251",
      "Ekhatpur B.O": "413307",
      "Junoni B.O": "413307",
      "Wadhegaon B.O": "413307",
      "Watambre B.O": "413307",
      "Malkhambi B.O": "413112",
      "Nevare B.O": "413112",
      "Ghoti B.O": "413251",
      "Nimgaon B.O": "413113",
      "Ughadewadi B.O": "413113",
      "Lonand B.O": "413109",
      "Palasmandal B.O": "413109",
      "Chopadi B.O": "413308",
      "Chandapuri B.O": "413310",
      "Mauje Ujani B.O": "413210",
      "Nimgaon T B.O": "413210",
      "Girvi B.O": "413111",
      "Salase B.O": "413251",
      "Hatid B.O": "413307",
      "Udanwadi B.O": "413307",
      "Akole(KH) B.O": "413211",
      "Parite B.O": "413211",
      "Pandharpur H.O": "413304",
      "Solapur H.O": "413001",
      "SRPF Camp Solapur S.O": "413008",
      "Wagadari S.O": "413218",
      "Akkalkot S.O": "413216",
      "Barshi S.O": "413401",
      "Jule Solapur S.O": "413004",
      "Maindargi S.O": "413217",
      "Market Yard Barshi S.O": "413401",
      "Market Yard Solapur S.O": "413005",
      "Mohol S.O": "413213",
      "Nanaj S.O (Solapur)": "413222",
      "Navi Peth Solapur S.O": "413001",
      "Pangri S.O": "413404",
      "Shivshahi S.O": "413224",
      "Daji Peth S.O": "413005",
      "Gaudgaon S.O": "413406",
      "Hotgi S.O": "413215",
      "K.V.Nagar Barshi S.O": "413411",
      "Kamati Khurd S.O": "413253",
      "Karajagi S.O (Solapur)": "413219",
      "Midc Solapur S.O": "413006",
      "Pangaon S.O (Solapur)": "413403",
      "Sakhar Peth S.O": "413005",
      "Shetphal S.O": "413324",
      "Sidheswar Peth S.O": "413001",
      "Solapur Mkt. S.O": "413002",
      "Solapur City S.O": "413007",
      "Solapur Vidyapeeth S.O": "413255",
      "Vairag S.O": "413402",
      "Nai Zindagi S.O": "413224",
      "Angar S.O": "413214",
      "Chapalgaon S.O": "413226",
      "Dudhani S.O": "413220",
      "Subhash Nagar Barshi S.O": "413401",
      "Gurunanak Nagar S.O": "413003",
      "Indiranagar S.O (Solapur)": "413004",
      "Mandrup S.O": "413221",
      "Manegaon S.O": "413410",
      "Medical College S.O (Solapur)": "413003",
      "Midc Chincholi S.O": "413255",
      "Nagansur S.O": "413227",
      "Pennur S.O": "413248",
      "Sadar Bazar S.O (Solapur)": "413003",
      "Jawala S.O (Solapur)": "413309",
      "Jeur S.O (Solapur)": "413202",
      "Karkam S.O": "413302",
      "Karmala Town ( Karmala) S.O": "413203",
      "Kem S.O": "413223",
      "Malinagar S.O": "413108",
      "Mangalvedha Town S.O": "413305",
      "Navi Peth (Pandharpur) S.O": "413304",
      "Ropla ( Kvd ) S.O": "413252",
      "Sadashivenagar S.O": "413111",
      "Sangola Town (Sangola) S.O": "413307",
      "Velapur S.O": "413113",
      "Yeshwantnagar S.O (Solapur)": "413118",
      "Tulsidas Nagar S.O": "413412",
      "Valsang S.O": "413228",
      "Agalgaon S.O": "413409",
      "Ashok Chowk S.O": "413006",
      "Ashti S.O (Solapur)": "413303",
      "Bazarpeth Mohol S.O": "413213",
      "Dayanand College S.O": "413002",
      "Jawaharlal Nehru Vastigrah S.O": "413001",
      "Mangalwar Peth S.O (Solapur)": "413002",
      "Akluj S.O": "413101",
      "Kole S.O (Solapur)": "413314",
      "Mahisgaon S.O": "413250",
      "Malsiras S.O": "413107",
      "Mangalvedha S.O": "413305",
      "Manishanagar(Pandharpur) S.O": "413304",
      "Marwade S.O": "413319",
      "Piliv S.O": "413310",
      "Shreepur S.O": "413112",
      "Tembhurni S.O (Solapur)": "413211",
      "Bhosa (K) S.O": "413315",
      "Kurduvadi S.O": "413208",
      "Madha S.O": "413209",
      "Mahadawar( Pandharpur) S.O": "413304",
      "Mahud S.O": "413306",
      "Natepute S.O": "413109",
      "Nazara S.O": "413308",
      "Sade S.O": "413251",
      "Bhimanagar S.O": "413212",
      "Bhosa (M) S.O": "413322",
      "Karmala S.O": "413203",
      "Kettur II S.O": "413206",
      "Khardi S.O": "413317",
      "Modnimb S.O": "413301",
      "Pimpelner S.O": "413210",
      "Sangola S.O": "413307"
    },
    "BHANDARA": {
      "Gosi BK B.O": "441903",
      "Kitadi B.O": "441903",
      "Jamb B.O": "441914",
      "Kandri B.O": "441914",
      "Salaikhurd B.O": "441914",
      "Mohdura B.O": "441906",
      "Betara B.O": "441905",
      "Koka B.O": "441905",
      "Hardoli B.O": "441909",
      "Kharashi B.O": "441805",
      "Belati B.O": "441908",
      "Masal B.O": "441908",
      "Palora B.O": "441905",
      "Soni Chapral B.O": "441803",
      "Amgaon Dighori B.O": "441804",
      "Dhargaon B.O": "441804",
      "Gadegaon B.O": "441804",
      "Chandori B.O": "441802",
      "Dawadipar B.O": "441924",
      "Nerla B.O": "441903",
      "Pimpalgaon Nipani B.O": "441903",
      "Shahpur B.O": "441906",
      "Kothurna B.O": "441905",
      "Mohgaon Devi B.O": "441905",
      "Neri B.O": "441905",
      "Barwa B.O": "441805",
      "Chikhla Basti B.O": "441907",
      "Lobhi B.O": "441907",
      "Moharna B.O": "441803",
      "Pimpalgaon Kohli B.O": "441803",
      "Kesalwada B.O": "441804",
      "Pimpalgaon Sadak B.O": "441804",
      "Kardha B.O": "441924",
      "Kanhalgaon B.O": "441910",
      "Khapri B.O": "441910",
      "Kodurli B.O": "441910",
      "Mandesar B.O": "441909",
      "Minshi B.O": "441924",
      "Bhuyar B.O": "441910",
      "Itan B.O": "441910",
      "Sawarla B.O": "441910",
      "Kurza B.O": "441903",
      "Bela B.O": "441906",
      "Pipri B.O": "441906",
      "Thana Petrol Pump B.O": "441906",
      "Mandvi B.O": "441905",
      "Mundri BK B.O": "441905",
      "Navegaon BK B.O": "441905",
      "Chikhala B.O": "441907",
      "Dongri BK B.O": "441907",
      "Nakadongri B.O": "441907",
      "Akot B.O": "441908",
      "Bhawad B.O": "441908",
      "Sarandi B.O": "441908",
      "Bhagdi B.O": "441803",
      "Kudegaon B.O": "441803",
      "Opera B.O": "441803",
      "Gunthara B.O": "441804",
      "Lakhori B.O": "441804",
      "Dongargaon B.O": "441909",
      "Kanalgaon B.O": "441909",
      "Manegaon B.O": "441924",
      "Matora B.O": "441924",
      "Silli B.O": "441924",
      "Bhendala B.O": "441910",
      "Mangli B.O": "441910",
      "Chinchal B.O": "441903",
      "Erli Khandar B.O": "441903",
      "Pardi B.O": "441805",
      "Ashti B.O": "441907",
      "Rengepar B.O": "441804",
      "Salebhata B.O": "441804",
      "Amgaon Adarsh Pauni B.O": "441910",
      "Asgaon B.O": "441910",
      "Irli BK B.O": "441910",
      "Walni B.O": "441910",
      "Gondumri B.O": "441806",
      "Gurdha B.O": "441809",
      "Kolari B.O": "441809",
      "Miregaon B.O": "441809",
      "Murmadi B.O": "441809",
      "Palandur(Chauras) B.O": "441809",
      "Amgaon BK B.O": "441802",
      "Bampewada B.O": "441802",
      "Yekodi (Sakoli) B.O": "441802",
      "Chulhad B.O": "441915",
      "Mohgaon Khadan B.O": "441915",
      "Kardi B.O": "441912",
      "Yerli B.O": "441912",
      "Alesure B.O": "441912",
      "Channa B.O": "441809",
      "Kanheri B.O": "441809",
      "Seloti B.O": "441809",
      "Shioni B.O": "441809",
      "Khandala B.O": "441802",
      "Lawri Umri B.O": "441802",
      "Sendurwafa B.O": "441802",
      "Wadad B.O": "441802",
      "Garra Bageda B.O": "441912",
      "Khapa B.O": "441912",
      "Umarwada B.O": "441912",
      "Pindkepar B.O": "441802",
      "Sangadi B.O": "441802",
      "Sasra B.O": "441802",
      "Madgi B.O": "441913",
      "Chincholi (Tumsar) B.O": "441912",
      "Bhugaon B.O": "441809",
      "Kumbhali B.O": "441802",
      "Malutola B.O": "441802",
      "Satalwada B.O": "441802",
      "Virshi B.O": "441802",
      "Bapera B.O": "441915",
      "Wahani B.O": "441915",
      "Devada Bzk B.O": "441913",
      "Lendezari B.O": "441912",
      "Mitewani B.O": "441912",
      "Bhandara H.O": "441904",
      "Bhandara Of S.O": "441906",
      "Dighori S.O": "441805",
      "Gobarwahi S.O": "441907",
      "Bhandara Town S.O": "441904",
      "Pauni S.O": "441910",
      "Sakoli S.O": "441802",
      "Sihora S.O (Bhandara)": "441915",
      "Adyar S.O (Bhandara)": "441903",
      "Andhalgaon S.O": "441914",
      "Bhandara Road S.O": "441905",
      "Lakhandur S.O": "441803",
      "Pahela S.O": "441924",
      "Tumsar Road S.O": "441913",
      "Konda Kosra S.O": "441908",
      "Lakhni S.O": "441804",
      "Mohadi S.O": "441909",
      "Pohra S.O": "441809",
      "Tumsar S.O": "441912"
    },
    "SANGLI": {
      "Audumbar B.O": "416303",
      "Bhilwadi R.S. B.O": "416303",
      "Kumbhari B.O": "416403",
      "Sanmadi B.O": "416404",
      "Shinganhalli B.O": "416404",
      "Sindur B.O": "416404",
      "Walekhindi B.O": "416404",
      "Karoli  T B.O": "416405",
      "Kokale B.O": "416405",
      "Kuchi B.O": "416405",
      "Kundalapur B.O": "416405",
      "Agran Dhulgaon B.O": "416411",
      "Alkud  (S) B.O": "416411",
      "Kuktoli B.O": "416418",
      "Sidhnath B.O": "416412",
      "Sordi B.O": "416412",
      "Tikundi B.O": "416412",
      "Bastawade B.O": "416311",
      "Dongarsoni B.O": "416311",
      "Jarandi B.O": "416311",
      "Borgaon B.O": "416419",
      "Jaigavan B.O": "416419",
      "Landgewadi B.O": "416419",
      "Malangaon B.O": "416419",
      "Borgaon (T) B.O": "416312",
      "Chinchani (T) B.O": "416312",
      "Dhavali (T) B.O": "416312",
      "Ankale B.O": "416402",
      "Khalati B.O": "416402",
      "Dhavadwadi B.O": "416403",
      "Dorli B.O": "416403",
      "Nagaj B.O": "416403",
      "Antral B.O": "416404",
      "Banali B.O": "416404",
      "Billur B.O": "416404",
      "Kunikonnur B.O": "416404",
      "Nigdi Khurd B.O": "416404",
      "Vajrawad B.O": "416404",
      "Yelvi B.O": "416404",
      "Hingangaon B.O": "416405",
      "Jakhapur B.O": "416405",
      "Langarpeth B.O": "416405",
      "Shinganapur B.O": "416405",
      "Dongarwadi B.O": "416407",
      "Kognoli B.O": "416418",
      "Asangi J B.O": "416412",
      "Boblad K B.O": "416412",
      "Banur B.O": "416311",
      "Khujgaon B.O": "415405",
      "Vadgaon B.O": "416311",
      "Balagavade B.O": "416312",
      "Gaurgaon B.O": "416312",
      "Manjarde B.O": "416312",
      "Ped B.O": "416312",
      "Khatav B.O": "416401",
      "Tavadarwadi B.O": "416303",
      "Baj B.O": "416402",
      "Chorochi B.O": "416403",
      "Ghorpadi B.O": "416403",
      "Gugwad B.O": "416404",
      "Mendhigiri B.O": "416404",
      "Revnal B.O": "416404",
      "Shegaon B.O": "416404",
      "Umarani B.O": "416404",
      "Valsang B.O": "416404",
      "Ghatnandre B.O": "416405",
      "Irali B.O": "416405",
      "Nangole B.O": "416405",
      "Tisangi B.O": "416405",
      "Narwad B.O": "416409",
      "Lonarwadi B.O": "416411",
      "Asangi K B.O": "416412",
      "Daribadachi B.O": "416412",
      "Anjani B.O": "416311",
      "Dahiwadi B.O": "416311",
      "Alkud (M) B.O": "416419",
      "Arawade B.O": "416312",
      "Bendri B.O": "416312",
      "Biranwadi B.O": "416312",
      "Nimani B.O": "416312",
      "Lingnoor B.O": "416401",
      "Shindewadi B.O": "416401",
      "Jirgyal B.O": "416402",
      "Washan B.O": "416402",
      "Agalgaon B.O": "416403",
      "Arewadi B.O": "416403",
      "Kerewadi B.O": "416403",
      "Kosari B.O": "416403",
      "Avandhi B.O": "416404",
      "Basargi B.O": "416404",
      "Bevnur B.O": "416404",
      "Muchandi B.O": "416404",
      "Dhalewadi B.O": "416405",
      "Gundewadi B.O": "416407",
      "Ankalagi B.O": "416412",
      "Siddhewadi Savalaj B.O": "416311",
      "Bhose B.O": "416420",
      "Dhulgaon B.O": "416420",
      "Karanje B.O": "416312",
      "Limb B.O": "416312",
      "Lode B.O": "416312",
      "Nimblak B.O": "416312",
      "Punadi (T) B.O": "416312",
      "Turchi B.O": "416312",
      "Madgyal B.O": "416413",
      "Sonyal B.O": "416413",
      "Utagi B.O": "416413",
      "Vhaspet B.O": "416413",
      "Payappachiwadi B.O": "416414",
      "Vaddi B.O": "416414",
      "Siddhewadi B.O": "416414",
      "Bolwad B.O": "416414",
      "Mallewadi B.O": "416414",
      "Mouje Digraj B.O": "416415",
      "Brahmanal B.O": "416415",
      "Vasgade B.O": "416415",
      "Ladegaon B.O": "415401",
      "Mirajwadi B.O": "416301",
      "Tung B.O": "416301",
      "Vibhutwadi B.O": "415301",
      "Zare B.O": "415301",
      "Nagaon B.O": "416302",
      "Shigaon B.O": "416302",
      "Dhavali B.O": "416302",
      "Mangrul B.O": "415402",
      "Kavaji Khotwadi B.O": "416304",
      "Shelakbav B.O": "415305",
      "Shivani B.O": "415305",
      "Tondoli B.O": "415305",
      "Bellondagi B.O": "416413",
      "Boblad Jadar B.O": "416413",
      "Borgi(Khurd) B.O": "416413",
      "Girgaon B.O": "416413",
      "Khalsa Dhamni B.O": "416314",
      "Banewadi BO": "416414",
      "Bedag B.O": "416414",
      "Belanki B.O": "416414",
      "Samdolii B.O": "416415",
      "Sangaliwadi B.O": "416415",
      "Karnal B.O": "416415",
      "Yelavi B.O": "416415",
      "Gotkhindi B.O": "416301",
      "Devwadi B.O": "415412",
      "Kande B.O": "415412",
      "Mangale B.O": "415412",
      "Ambak B.O": "415303",
      "Chinchani Ambak B.O": "415303",
      "Ramapur B.O": "415303",
      "Awalai B.O": "415315",
      "Lingiware B.O": "415315",
      "Nerli B.O": "415304",
      "Shalgaon B.O": "415304",
      "Hingangaon Khurd B.O": "415305",
      "Saholi B.O": "415305",
      "Upale Mayani B.O": "415305",
      "Hivtad B.O": "415306",
      "Shetphale B.O": "415306",
      "Tadawale B.O": "415306",
      "Kanchanpur B.O": "416306",
      "Ghanand B.O": "415308",
      "Punadi T/F Walwa B.O": "416308",
      "Ramanandnagar B.O": "416308",
      "Kupwad B.O": "416436",
      "Waiphale B.O": "416312",
      "Yamgarwadi B.O": "416312",
      "Balgaon B.O": "416413",
      "Suslad B.O": "416413",
      "Hatnur B.O": "416314",
      "Kalambi B.O": "416414",
      "Shipur B.O": "416414",
      "Yerandoli B.O": "416414",
      "Ankali B.O": "416415",
      "Inam Dhamni B.O": "416415",
      "Dhagewadi B.O": "415401",
      "Karve B.O": "415311",
      "Mardwadi B.O": "416301",
      "Pokharni B.O": "416301",
      "Kautholi B.O": "415301",
      "Nimbavade B.O": "415301",
      "Bhadkimbe B.O": "416302",
      "Koregaon B.O": "416302",
      "Bichud B.O": "415302",
      "Rethare Harnaksha B.O": "415302",
      "Masuchiwadi B.O": "415413",
      "Bisur B.O": "416304",
      "Thanapude B.O": "415412",
      "Sonkire B.O": "415303",
      "Sonsal B.O": "415303",
      "Malwadi B.O": "416315",
      "Shivajinagar B.O": "415304",
      "Belavade B.O": "415305",
      "Hanmant Vadiye B.O": "415305",
      "Vangi B.O": "415305",
      "Yedenipani B.O": "415403",
      "Gomewadi B.O": "415306",
      "Kumatha B.O": "416306",
      "Sultangade B.O": "415307",
      "Nelkaranji B.O": "415308",
      "Valvan B.O": "415308",
      "Amnapur BO": "416308",
      "Nagarale B.O": "416308",
      "Yelapur B.O": "415405",
      "Ghogaon B.O": "416309",
      "Jondhalkhindi B.O": "415309",
      "Valuj B.O": "415309",
      "Vejegaon B.O": "415310",
      "Savarde B.O": "416408",
      "Andhali B.O": "416310",
      "Manikwadi B.O": "415407",
      "Surul B.O": "415407",
      "Tambave B.O": "415404",
      "Hivare B.O": "415307",
      "Mohi B.O": "415307",
      "Chincholi B.O": "415405",
      "Nathawade B.O": "415405",
      "Gavan B.O": "416408",
      "Karoli (M) B.O": "416408",
      "Bambavade B.O": "415410",
      "Morale B.O": "416310",
      "Rajapur B.O": "416310",
      "Sawantpur B.O": "416310",
      "Red B.O": "415407",
      "Sakharale B.O": "415414",
      "Antri Budruk B.O": "415408",
      "Aundhi B.O": "415408",
      "Shirashi B.O": "415408",
      "Tadavale B.O": "415408",
      "Wakurde BK B.O": "415408",
      "Wakurde Khurd B.O": "415408",
      "Ainwadi B.O": "415311",
      "Alsund B.O": "415311",
      "Salshinge B.O": "415311",
      "Yetgaon B.O": "415311",
      "Nagthane B.O": "416313",
      "Karanguli B.O": "415415",
      "Savali B.O.": "416436",
      "Bhood B.O": "415309",
      "Bhendavade B.O": "415310",
      "Bhikavadi BK B.O": "415310",
      "Chikhalhol B.O": "415310",
      "Valkhad B.O": "415310",
      "Kalamwadi B.O": "415406",
      "Ozarde B.O": "415407",
      "Bhatshirgaon B.O": "415408",
      "Ingrul B.O": "415408",
      "Kandur B.O": "415408",
      "Natoli B.O": "415408",
      "Nigadi B.O": "415408",
      "Padalichiwadi B.O": "415408",
      "Phuphire B.O": "415408",
      "Aitawade Khurd B.O": "415409",
      "Bahe B.O": "415409",
      "Kapuskhed B.O": "415409",
      "Narsinhpur B.O": "415409",
      "Dhavaleshwar B.O": "415311",
      "Gardi B.O": "415311",
      "Ghoti Khurd B.O": "415311",
      "Hingangade B.O": "415311",
      "Jadhavwadi B.O": "415311",
      "Khambale B.O": "415311",
      "Pachumbri B.O": "415410",
      "Panumbre Turf Shirala B.O": "415410",
      "Kanegaon B.O": "415411",
      "Kurlap B.O": "415411",
      "Tandulwadi B.O": "415411",
      "Biur B.O": "415408",
      "Dhamavade B.O": "415408",
      "Punvat B.O": "415408",
      "Sagaon B.O": "415408",
      "Shirte B.O": "415409",
      "Bhalavani B.O": "415311",
      "Chinchani Mangrul B.O": "415311",
      "Kherade B.O": "415311",
      "Nevari B.O": "415311",
      "Renavi B.O": "415311",
      "Kalundre B.O": "415415",
      "Takave B.O": "415410",
      "Nandre B.O": "416415",
      "Kundalwadi B.O": "415411",
      "Arala B.O": "415415",
      "Vasumbe (T) B.O": "416312",
      "Hatnoli B.O": "416314",
      "Padali B.O": "416314",
      "Deshing B.O": "416414",
      "Khanderajuri B.O": "416414",
      "Kharshing B.O": "416414",
      "Tanang B.O": "416414",
      "Haripur B.O": "416415",
      "Padmale B.O": "416415",
      "Karanjawade B.O": "415401",
      "Bavachi B.O": "416301",
      "Karandwadi B.O": "416301",
      "Madgule B.O": "415301",
      "Killemachindragad B.O": "415302",
      "Shirasgaon B.O": "415303",
      "Vadgaon Mohite B.O": "415303",
      "Digraj Kasaba Agri School B.O": "416305",
      "Tadsar B.O": "415304",
      "Vihapur B.O": "415304",
      "Amarapur B.O": "415305",
      "Hingangaon Bk B.O": "415305",
      "Vadiye Raibag B.O": "415305",
      "Itkare B.O": "415403",
      "Tujarpur B.O": "415403",
      "Banpuri B.O": "415306",
      "Upalavi B.O": "416306",
      "Palashi B.O": "415307",
      "Balavadi (KHN) B.O": "415307",
      "Gharniki B.O": "415308",
      "Pimpri Budruk B.O": "415308",
      "Burli B.O": "416308",
      "Dudhondi B.O": "416308",
      "Charan B.O": "415405",
      "Meni B.O": "415405",
      "Panumbre Turf Warun B.O": "415405",
      "Balavadi(Bhalavani) B.O": "416309",
      "Bamnoli B.O": "416436",
      "Devikhindi B.O": "415309",
      "Vasumbe B.O": "415309",
      "Rethare Dharan B.O": "415407",
      "Chikhali B.O": "415408",
      "Karmala B.O": "415408",
      "Rile B.O": "415408",
      "Tupari B.O": "415313",
      "Yedemachindra B.O": "415409",
      "Bamani B.O": "415311",
      "Bhikawadi Kurd B.O": "415311",
      "Nagewadi B.O": "415311",
      "Pare B.O": "415311",
      "Revangaon B.O": "415311",
      "Junekhed B.O": "416313",
      "Sonavade B.O": "415415",
      "Bahadurwadi B.O": "415411",
      "Miraj H.O": "416410",
      "Sangli H.O": "416416",
      "Guruwar Peth,tasgaon S.O": "416312",
      "Jath S.O": "416404",
      "Malgaon S.O": "416407",
      "Miraj Audyogik Vasahat S.O": "416410",
      "Tasgaon M.D.G S.O": "416312",
      "Umadi S.O": "416413",
      "Borgaon S.O (Sangli)": "415413",
      "Chikurde S.O": "415412",
      "Devrashtra S.O": "415303",
      "Bhilavadi S.O": "416303",
      "Daphalapur S.O": "416402",
      "Govt.Medical College Miraj S.O": "416410",
      "Sankh S.O": "416412",
      "Savlaj S.O": "416311",
      "Soni S.O": "416420",
      "Visapur S.O (Sangli)": "416314",
      "Ankalkhop S.O": "416316",
      "Budhgaon S.O": "416304",
      "Dudhgaon S.O": "416315",
      "Factory Area Sangli S.O": "416416",
      "Govt. Colony S.O": "416415",
      "Kameri S.O": "415403",
      "Kavathe Ekand S.O": "416307",
      "Kharsundi S.O": "415308",
      "Kirloskarwadi S.O": "416308",
      "Kupwad MIDC Area S.O": "416436",
      "Lengare S.O": "415309",
      "Manerajuri S.O": "416408",
      "Nerla S.O": "415406",
      "Takari S.O": "415313",
      "Vite City S.O": "415311",
      "Willingdon College Sangli S.O": "416415",
      "Yelur S.O": "415411",
      "Arag S.O": "416401",
      "Brahmanpuri Miraj S.O": "416410",
      "Dhalgaon S.O": "416403",
      "Kavathe Mahankal S.O": "416405",
      "Digraj Kasaba S.O": "416305",
      "Kadegaon S.O": "415304",
      "Kadepur S.O": "415305",
      "Kavalapur S.O": "416306",
      "Khanapur S.O (Sangli)": "415307",
      "Mahuli S.O (Sangli)": "415310",
      "R K Extension Sangli S.O": "416416",
      "Shirala S.O": "415408",
      "Walwa S.O": "416313",
      "Warnavati Vasahat S.O": "415415",
      "Wategaon S.O": "415410",
      "Ranjani S.O (Sangli)": "416411",
      "Salgare S.O": "416418",
      "Shaniwar Peth Miraj S.O": "416410",
      "Wanlsswadi S.O": "416414",
      "Subhashnagar S.O": "416437",
      "Bagani S.O": "416302",
      "Bilashi S.O": "415402",
      "Ganpati Peth Sangli S.O": "416416",
      "Kargani S.O": "415306",
      "Kasegaon S.O": "415404",
      "Kavathe Piran S.O": "416417",
      "Kokrud S.O": "415405",
      "Kundal S.O (Sangli)": "416309",
      "Market Yard Sangli S.O": "416416",
      "Palus S.O": "416310",
      "S S K Sakharale S.O": "415414",
      "S S K Sangli S.O": "416416",
      "Khanbhag,sangli At Midc Miraj S.O": "416410",
      "Mhaisal S.O": "416409",
      "Miraj Station Road S.O": "416410",
      "Shirdhon S.O": "416419",
      "Aitawade BK S.O": "415401",
      "Ashte S.O": "416301",
      "Atpadi S.O": "415301",
      "Bhavaninagar S.O (Sangli)": "415302",
      "Dighanchi S.O": "415315",
      "Gajanan Mills Sangli S.O": "416416",
      "Madhavnagar S.O": "416406",
      "Peth S.O (Sangli)": "415407",
      "Sangli City S.O": "416416",
      "Urun Islampur S.O": "415409",
      "Vite S.O": "415311"
    },
    "AURANGABAD": {
      "Bhendala B.O": "431110",
      "Kaigaon B.O": "431135",
      "Nevargaon B.O": "431110",
      "Balegaon B.O": "431116",
      "Chikatgaon B.O": "431116",
      "Janephal B.O": "431116",
      "Gadhepimpalgaon B.O": "423701",
      "Hingoni B.O": "423701",
      "Jambhargaon B.O": "423701",
      "Jategaon B.O": "431111",
      "Katepimpalgaon B.O": "423701",
      "Rotegaon R.S. B.O": "423701",
      "Sirasgaon B.O": "423701",
      "Ambelohal B.O": "431133",
      "Jikthan B.O": "431133",
      "Warzadi B.O": "431154",
      "Gadhejalgaon B.O": "431154",
      "Naigavhan B.O": "431154",
      "Balapur B.O": "431117",
      "Sheoga": "431154",
      "Hanumantkheda B.O": "431150",
      "Tidka B.O": "431150",
      "Wadgaon Tigji B.O": "431150",
      "Ghatnanadra B.O": "431113",
      "Khandala B.O": "431116",
      "Loni KH B.O": "431116",
      "Talwada B.O": "431116",
      "Tunki B.O": "431116",
      "Bhagur B.O": "423701",
      "Chinchadgaon B.O": "423701",
      "Ladgaon B.O": "423701",
      "Nagamthan B.O": "423701",
      "Pendapur B.O": "431133",
      "Shendurwada B.O": "431133",
      "Turkabad B.O": "431133",
      "Khumbhephal B.O": "431154",
      "Gondegaon B.O": "431150",
      "Charner B.O": "431113",
      "Kolhi B.O": "431116",
      "Akoli Wadgaon B.O": "423701",
      "Bhaggaon B.O": "423701",
      "Veergaon B.O": "423701",
      "Wanjargaon B.O": "423701",
      "Solegaon B.O": "431133",
      "Talpimpri B.O": "431133",
      "Tembhapuri B.O": "431133",
      "Warudkazi B.O": "431154",
      "Dudhad B.O": "431154",
      "Ladsawangi B.O": "431154",
      "Karmad B.O": "431154",
      "Relgaon B.O": "431113",
      "Talni B.O": "431113",
      "Wangi Khurd B.O": "431113",
      "Biloni B.O": "431116",
      "Parala B.O": "431116",
      "Wakla B.O": "431116",
      "Chandgon B.O": "423701",
      "Chorwaghalgaon B.O": "423701",
      "Mahalgaon B.O": "423701",
      "Maleghogargaon B.O": "423701",
      "Kasoda B.O": "431133",
      "Sawkheda B.O": "431133",
      "Georai Kuber B.O": "431154",
      "Golatgaon B.O": "431154",
      "Amthana B.O": "431113",
      "Borgaon Bazar B.O": "431113",
      "Deulgaon Bazar B.O": "431113",
      "Tisgaon B.O": "431102",
      "Warkheda B.O": "431109",
      "Andhaner B.O": "431103",
      "Aurala B.O": "431103",
      "Bahirgaon B.O": "431103",
      "Jaitapur B.O": "431103",
      "Jaitkheda B.O": "431103",
      "Nagad B.O": "431103",
      "Rail B.O": "431103",
      "Gadana B.O": "431101",
      "Golegaon B.O": "431112",
      "Lasurgaon B.O": "423702",
      "Ajantha Caves B.O": "431118",
      "Jamthi B.O": "431118",
      "Palaskheda B.O": "431118",
      "Modha BK B.O": "431112",
      "Palod B.O": "431112",
      "Nillod B.O": "431135",
      "Upali B.O": "431135",
      "Warud KH B.O": "431135",
      "Bahulkheda B.O": "431120",
      "Jarandi B.O": "431120",
      "Kalandrabad (Kasabkheda) B.O": "431102",
      "Palaswadi B.O": "431102",
      "Pimpri B.O": "431102",
      "Bilda B.O": "431008",
      "Jatwada B.O": "431008",
      "Tuljapur Sawangi B.O": "431008",
      "Banshendra B.O": "431103",
      "Hatnoor B.O": "431103",
      "Kagazipura B.O": "431101",
      "Khirdi B.O": "431101",
      "Anwi B.O": "431112",
      "Rahemabad B.O": "431112",
      "Undangaon B.O": "431112",
      "Borgaon Kasari B.O": "431135",
      "Gavli Tanda B.O": "431135",
      "Gevrai Shami B.O": "431135",
      "Manjri B.O": "431109",
      "Wahegaon B.O": "431148",
      "Adgaon Sarak B.O": "431008",
      "Chouka B.O": "431008",
      "Palshi (Shahar) B.O": "431008",
      "Bramhani B.O": "431103",
      "Chikhalthan B.O": "431103",
      "Eta B.O": "431103",
      "Kalimath B.O": "431103",
      "Kolwadi B.O": "431103",
      "Saigavan B.O": "431103",
      "Tapargaon": "431102",
      "Wadner B.O": "431103",
      "SULTANPUR B.O": "431152",
      "Gajgaon B.O": "423702",
      "Ghodegaon B.O": "423702",
      "Kankori B.O": "423702",
      "Madni B.O": "431132",
      "AMBHAI B.O": "431113",
      "Hatti B.O": "431112",
      "Mangrul B.O": "431112",
      "Bankinhola B.O": "431135",
      "Adul Budruk B.O": "431121",
      "Apegaon B.O": "431107",
      "Issarwadi B.O": "431148",
      "Borsar(Bhingi) B.O": "423703",
      "Dhondalgaon B.O": "423703",
      "Kanhori B.O": "431111",
      "Bharamba B.O": "431104",
      "Nachanwel B.O": "431104",
      "Palshi BK B.O": "431104",
      "Agarwadgaon B.O": "431110",
      "Malunja B.O": "431109",
      "Singhi B.O": "431109",
      "Ganori B.O": "431008",
      "Amba (Upla) B.O": "431103",
      "Chapaner B.O": "431103",
      "Jehur B.O": "431103",
      "Mundwadi B.O": "431103",
      "Wadali B.O": "431103",
      "Takali Raje Rai B.O": "431101",
      "YESGAON B.O": "431152",
      "Gawali Shivra B.O": "423702",
      "Jalgaon B.O": "423702",
      "Sawaladbara B.O": "431118",
      "Dhavda B.O": "431132",
      "Badod Pan B.O": "431112",
      "Halda B.O": "431112",
      "Kelgaon B.O": "431112",
      "Liha Khedi B.O": "431112",
      "Kerhala B.O": "431135",
      "Palshi B.O": "431135",
      "Mehaboobkheda B.O": "423702",
      "Rahegaon B.O": "423702",
      "Ranjagaon Pol B.O": "423702",
      "Ektuni B.O": "431121",
      "Gevarai BK B.O": "431121",
      "Khadgaon B.O": "431121",
      "Thergaon B.O": "431121",
      "Dawarwadi B.O": "431107",
      "Harshi B.O": "431107",
      "Nander B.O": "431107",
      "Rahatgaon B.O": "431107",
      "Narayangaon B.O": "431148",
      "Nalegaon B.O": "423703",
      "Palkheda B.O": "423703",
      "Parsoda Sk B.O": "423703",
      "Savandgaon B.O": "423703",
      "BODKHA B.O": "431152",
      "Nandra B.O": "431111",
      "Pimparkheda B.O": "431104",
      "Khamgaon B.O": "431151",
      "Aland B.O": "431134",
      "Marsawali B.O": "431134",
      "Takli Kolta B.O": "431134",
      "Waladgaon B.O": "431136",
      "Bokud Jalgaon B.O": "431105",
      "Dhkephal B.O": "431105",
      "Lohgaon B.O": "431105",
      "Shekta B.O": "431154",
      "Chittepimpalgaon B.O": "431007",
      "Khodegaon B.O": "431007",
      "Pimpri Raja B.O": "431007",
      "Nagapur B.O": "431147",
      "Nevpur B.O": "431147",
      "Wakod B.O": "431147",
      "Garaj B.O": "431115",
      "Devlana B.O": "431102",
      "Galle Borgaon B.O": "431102",
      "Sidhanath Wadgaon B.O": "423702",
      "Sillegaon B.O": "423702",
      "Yesgaon B.O": "423702",
      "Bhivgaon B.O": "423703",
      "PADALI B.O": "431152",
      "Pal B.O": "431111",
      "Wanegaon B.O": "431111",
      "Waregaon B.O": "431111",
      "Adgaon B.O": "431104",
      "Basadi B.O": "431104",
      "Hasta B.O": "431104",
      "Nimbhora B.O": "431104",
      "Babra B.O": "431151",
      "Lonwadi B.O": "431151",
      "Nidhona B.O": "431151",
      "Daulatabad B.O": "431002",
      "Gevarai B.O": "431002",
      "Maliwada B.O": "431002",
      "Takali Kadim B.O": "431002",
      "Borgaon Arj B.O": "431134",
      "Pir Bawada B.O": "431134",
      "Georai Payga": "431134",
      "Balanagar B.O": "431105",
      "Dhorkingaon B.O": "431105",
      "Dhupkheda B.O": "431105",
      "Karkin B.O": "431105",
      "Shevta B.O": "431105",
      "Hiradpuri B.O": "431137",
      "Adgaon BK B.O": "431007",
      "Naregaon B.O": "431007",
      "Ghat Shendra B.O": "431147",
      "Jamdi Jahangir B.O": "431147",
      "Karanjkheda B.O": "431147",
      "Babhulgaon (Pirachi) B.O": "431115",
      "Padegaon B.O": "431002",
      "Lakhegaon B.O": "431105",
      "Porgaon B.O": "431105",
      "Ranjangaon Pan B.O": "431105",
      "Shekta": "431154",
      "Takali Ambad B.O": "431137",
      "Ghardon B.O": "431007",
      "Kachner B.O": "431007",
      "Dahegaon B.O": "423703",
      "Lamangaon B.O": "431115",
      "Manur B.O": "431115",
      "Pokhari B.O": "431115",
      "Borsar BK B.O": "431102",
      "Pimpalgaon Diwashi B.O": "423702",
      "Antarwali Khandi B.O": "431121",
      "Gharegaon Ektuni B.O": "431121",
      "Kadethan B.O": "431121",
      "Parundi B.O": "431121",
      "Dongaon": "423702",
      "Changatpuri B.O": "431107",
      "Wadwali B.O": "431107",
      "Katpur B.O": "431148",
      "Pimpalwadi (Pirachi) B.O": "431148",
      "Karanjgaon B.O": "423703",
      "Shivrai B.O": "423703",
      "Dhamangaon B.O": "431111",
      "Kingaon B.O": "431111",
      "Pathri B.O": "431111",
      "Pimpalgaon Gangdev B.O": "431111",
      "SHIRODI KH. B.O": "431152",
      "Mahora B.O": "431104",
      "Sarola B.O": "431104",
      "Bodhegaon B.O": "431151",
      "Khamgaon": "431215",
      "Assegaon B.O": "431002",
      "Nakshtrawadi B.O": "431002",
      "Ghanegaon B.O": "431136",
      "Chitegaon B.O": "431105",
      "Mulani Wadgaon B.O": "431105",
      "Nilajgaon B.O": "431105",
      "Navgaon B.O": "431137",
      "Bhalgaon B.O": "431007",
      "Umarkheda B.O": "431147",
      "Lakhani B.O": "431115",
      "Mali Wadgaon B.O": "431115",
      "Tadpimpalgaon B.O": "431115",
      "Debhegaon B.O": "431102",
      "Ellora Caves B.O": "431102",
      "Aurangabad (MH) H.O": "431001",
      "Aurangabad Cantonment S.O": "431002",
      "Aurangabad City S.O": "431001",
      "Aurangabad Railway Station S.O": "431005",
      "Chikalthana S.O": "431007",
      "Dr. B.A. Marathwada University S.O": "431004",
      "Chikalthana Industrial Area S.O": "431006",
      "Chincholi Limbaji S.O": "431147",
      "Fazalpura S.O": "431001",
      "Begumpura S.O": "431004",
      "Bidkingaon S.O": "431105",
      "Bihamandwa S.O": "431137",
      "Deogaon Rangari S.O": "431115",
      "Andhari S.O": "431151",
      "Badod Bazar S.O": "431134",
      "Bajaj Nagar Midc Waluj S.O": "431136",
      "Cidco Colony S.O (Aurangabad)": "431003",
      "Ellora S.O": "431102",
      "Harsool S.O": "431008",
      "Kannad S.O": "431103",
      "Phulmbri S.O": "431111",
      "Pishore S.O": "431104",
      "Samarthnagar S.O": "431001",
      "Shahaganj S.O (Aurangabad)": "431001",
      "Shivar S.O": "431116",
      "Gangapur (Aurangabad MH) S.O": "431109",
      "High Court Building S.O (Aurangabad)": "431005",
      "Khuldabad S.O": "431101",
      "Medical College S.O (Aurangabad)": "431001",
      "Osmanpura S.O": "431005",
      "Paithan S.O": "431107",
      "Parsoda S.O": "423703",
      "Saraswati Colony S.O": "431001",
      "Airport, Chikalthana S.O": "431007",
      "Kanchanwadi SO": "431011",
      "Banoti S.O": "431150",
      "Vaijapur S.O": "423701",
      "Ajantha S.O": "431117",
      "Bharadi S.O": "431113",
      "Shivna S.O": "431132",
      "Soegaon S.O": "431120",
      "Garkheda S.O": "431009",
      "Kranti Chowk S.O": "431005",
      "Nizamganj S.O": "431003",
      "Satara Parisar S.O": "431010",
      "Session Court S.O (Aurangabad)": "431005",
      "Vaijapur Town S.O": "423701",
      "Waluj S.O": "431133",
      "Shendra MIDC Area S.O": "431154",
      "Sillod Sakhar Karkhana S.O": "431135",
      "Lasur Station S.O": "423702",
      "Pachod S.O": "431121",
      "Paithan Sakhar Karkhana S.O": "431148",
      "Raghunath Nagar S.O (Aurangabad)": "431110",
      "SAWANGI BAZAR S.O": "431152",
      "Phardapur S.O": "431118",
      "Sillod S.O": "431112"
    },
    "PUNE": {
      "Khed Shivapur B.O": "412205",
      "Sarole B.O": "412205",
      "Shivare B.O": "412205",
      "Varye BK B.O": "412205",
      "Pimpri Sandas B.O": "412216",
      "Vadgaon Peer B.O": "410510",
      "Kusgaon B.O": "412205",
      "Kikvi B.O": "412205",
      "Nhavi B.O": "413132",
      "Velu B.O": "412205",
      "Fulgaon B.O": "412216",
      "Lonikand B.O": "412216",
      "Ambavane B.O": "412213",
      "Kusgaon BK B.O": "410401",
      "Chandoli BK B.O": "410503",
      "Karegaon B.O": "410512",
      "Hivare BK B.O": "410504",
      "Jambhali BK B.O": "412213",
      "Kamthadi B.O": "412213",
      "Karandi Khedebare B.O": "412213",
      "Karanjawane B.O": "412209",
      "Kelawade B.O": "412213",
      "Alegaon B.O": "413801",
      "Andhalgaon B.O": "412211",
      "Ghotondi B.O": "413120",
      "Patas B.O": "412219",
      "Amdabad B.O": "412218",
      "Kanhur B.O": "412218",
      "Taklihaji B.O": "412218",
      "Narodi B.O": "410503",
      "Vadgaon Kashimbeg B.O": "410503",
      "Jambhut B.O": "410504",
      "Khodad B.O": "410504",
      "Pargaon Tarfe Ala B.O": "410504",
      "Valati B.O": "410504",
      "Yedgaon B.O": "410504",
      "Degaon B.O": "412213",
      "Hatve BK B.O": "412213",
      "Kolwadi B.O": "412110",
      "Manjal Asani B.O": "412213",
      "Sakhar B.O": "412213",
      "Ganegaon Dumala B.O": "412211",
      "Vadgaon Rasai B.O": "412211",
      "Kapurhol B.O": "412205",
      "Kenjal B.O": "412205",
      "Shindewadi B.O": "412205",
      "Alandi Chorachi B.O": "412201",
      "Kadam Wak Wasti B.O": "412201",
      "Kunjirwadi B.O": "412201",
      "Roti B.O": "412219",
      "Malegaon IRR Colony B.O": "413115",
      "Pimpalgaon Mahalunge B.O": "410503",
      "Kurkumbh B.O": "413802",
      "Khamundi B.O": "410504",
      "Ozar B.O": "410504",
      "Pimparkhed B.O": "410504",
      "Pimpri Pendhar B.O": "410504",
      "Ranjani B.O": "410504",
      "Tambad B.O": "412213",
      "Wangani B.O": "412213",
      "Winzer B.O": "412213",
      "Mandavgan Farata B.O": "412211",
      "Ranjangaon Sandas B.O": "412211",
      "Sadalgaon B.O": "412211",
      "Tandali B.O": "412211",
      "Kalyan B.O": "412205",
      "Ketkavale B.O": "412205",
      "Kondhanpur B.O": "412205",
      "Taparewadi B.O": "412205",
      "Perne B.O": "412216",
      "Vadhu BK B.O": "412216",
      "Savindane B.O": "410510",
      "Kangaon B.O": "412219",
      "Chincholi B.O": "413130",
      "Kawtha B.O": "412218",
      "Landewadi B.O": "410503",
      "Manjari BK B.O": "412307",
      "Nimgaon Bhogi B.O": "412220",
      "Murti Modhave B.O": "412304",
      "Nimgaon Sava B.O": "410504",
      "Dapode B.O": "412213",
      "Gunjawane B.O": "412213",
      "Kurungwadi B.O": "412213",
      "Margasni B.O": "412213",
      "Amble B.O": "412211",
      "Uralgaon B.O": "412211",
      "Tondal B.O": "412312",
      "Pabe B.O": "412212",
      "Nimsakhar B.O": "413114",
      "Nirwangi B.O": "413114",
      "Bhandgaon B.O": "413103",
      "Delwadi B.O": "412214",
      "Kasurdi B.O": "412214",
      "Antroli B.O": "412212",
      "Anthurne B.O": "413114",
      "Khorochi B.O": "413114",
      "Rangaon B.O": "413114",
      "Shirsatwadi B.O": "413114",
      "Khamgaon BK B.O": "412214",
      "Rahu Pimpalgaon B.O": "412214",
      "Rule B.O": "412107",
      "Belawade B.O": "412108",
      "Kashing B.O": "412108",
      "Male B.O": "412206",
      "Shere B.O": "412108",
      "Bhugaon B.O": "412115",
      "Ghotavade B.O": "412115",
      "Gurholi B.O": "412104",
      "Waghapur B.O": "412104",
      "Ghotawadi B.O": "410505",
      "Kanhersar B.O": "410505",
      "Kurkundi B.O": "410505",
      "Retwadi B.O": "410505",
      "Ganegaon Khalasa B.O": "412209",
      "Chambli B.O": "412301",
      "Garade B.O": "412301",
      "Shivari B.O": "412301",
      "Sonari B.O": "412301",
      "Gangapur KH B.O": "410516",
      "Golegaon B.O": "412210",
      "Shirasgaonkata B.O": "412210",
      "Khandaj B.O": "413116",
      "Bhondave Wadi B.O": "412204",
      "Dhamane B.O": "410506",
      "Urse B.O": "410506",
      "Burunjwadi B.O": "412208",
      "Hivare B.O": "412301",
      "Sanaswadi B.O": "412208",
      "Varale B.O": "410507",
      "Bori Aindi B.O": "412202",
      "Koregaon Mul B.O": "412202",
      "Bhorgiri B.O": "412402",
      "Eklahare B.O": "412402",
      "Korhale KH B.O": "412103",
      "Inglun B.O": "410502",
      "Khandi B.O": "412106",
      "Vadeshwar B.O": "412106",
      "Pingori B.O": "412305",
      "Hargude B.O": "412311",
      "Kurwandi B.O": "410512",
      "Pargaon Tarfe Khed B.O": "410512",
      "Thugaon B.O": "410512",
      "Uruli Devachi B.O": "412308",
      "Vadki B.O": "412308",
      "Kandali B.O": "412412",
      "Umbraj B.O": "412412",
      "Vadgaon Kandali B.O": "412412",
      "Kolawade B.O": "412115",
      "Lawale B.O": "412115",
      "Muthe B.O": "412115",
      "Sangrun B.O": "412115",
      "Uravade B.O": "412115",
      "Kude BK B.O": "410505",
      "Nimgaon Khed B.O": "410505",
      "Pait B.O": "410505",
      "Pimpri BK B.O": "413103",
      "Shiroli B.O": "410505",
      "Kondhapuri B.O": "412209",
      "Nimgaon Mahalungi B.O": "412209",
      "Varude B.O": "410505",
      "Khalad B.O": "412301",
      "Kodit B.O": "412301",
      "Panawadi B.O": "412301",
      "Pangare B.O": "412301",
      "Karhati B.O": "412204",
      "Takali Bhima B.O": "412208",
      "Vithalwadi B.O": "412208",
      "Avhat B.O": "412402",
      "Bhoyare B.O": "412106",
      "Dahitane B.O": "412207",
      "Koregaon Bhivar B.O": "412207",
      "Rahu B.O": "412207",
      "Telewadi B.O": "412207",
      "Vadebholhai B.O": "412207",
      "Kadethan B.O": "412215",
      "Koyali B.O": "410501",
      "Mahalunge Ingale B.O": "410501",
      "Vasuli B.O": "410501",
      "Nighoje B.O": "410501",
      "Beam Wirelee Station B.O": "413801",
      "Malthan B.O": "413801",
      "Shirapur B.O": "413801",
      "Salumbre B.O": "412101",
      "Bhimashankar B.O": "410509",
      "Phulawade B.O": "410509",
      "Rajpur B.O": "410509",
      "Amondi B.O": "412408",
      "Vardade B.O": "411025",
      "Hingangaon B.O": "413106",
      "Kalthan B.O": "413106",
      "Javalarjun B.O": "412303",
      "Kothale B.O": "412303",
      "Aptale B.O": "410502",
      "Devale B.O": "410502",
      "Nirgude B.O": "413130",
      "Rajur B.O": "410502",
      "Kohinde BK B.O": "412404",
      "Saburdi B.O": "412404",
      "Vetale B.O": "412404",
      "Mahalunge Padwal B.O": "410515",
      "Karanjgaon B.O": "410405",
      "Galandwadi B.O": "412203",
      "Khutbhav B.O": "412203",
      "Dhangavadi B.O": "412205",
      "Gogalwadi(E) B.O": "412205",
      "Lasurna B.O": "413114",
      "Mahur B.O": "412311",
      "Mandhar B.O": "412311",
      "Khechare B.O": "412108",
      "Kolwan B.O": "412108",
      "Kondhawale B.O": "412108",
      "Kule B.O": "412108",
      "Pomgaon B.O": "412108",
      "Ambarvet B.O": "412115",
      "Andgaon B.O": "412115",
      "Naygaon B.O": "412110",
      "Pargaon Memane B.O": "412104",
      "Pisarve B.O": "412104",
      "Rajuri B.O": "412411",
      "Amboli B.O": "410502",
      "Chinchoshi B.O": "410505",
      "Dawadi B.O": "410505",
      "Donda B.O": "410505",
      "Yeniye BK B.O": "410505",
      "Bhivadi B.O": "412301",
      "Bhivari B.O": "412301",
      "Bopgaon B.O": "412301",
      "Kuran B.O": "410511",
      "Inamgaon B.O": "412210",
      "Karda B.O": "412210",
      "Nimone B.O": "412210",
      "Nirvi B.O": "412210",
      "Hol B.O": "412306",
      "Karanje B.O": "412306",
      "Murum B.O": "412306",
      "Waki B.O": "412306",
      "Bebedhol B.O": "410506",
      "Chandkhed B.O": "410506",
      "Jategaon BK B.O": "412208",
      "Karandi B.O": "412208",
      "Kasari B.O": "412208",
      "Mukhai B.O": "412208",
      "Ambale B.O": "410507",
      "Ambi B.O": "410507",
      "Induri B.O": "410507",
      "Umbre Navlakh B.O": "410507",
      "Vishnupuri B.O": "410507",
      "Sahajpurwadi B.O": "412202",
      "Shindavane B.O": "412202",
      "Shriprayagdham B.O": "412202",
      "Kharoshi B.O": "412402",
      "Naiphad B.O": "412402",
      "Shirgaon B.O": "412206",
      "Tokawade B.O": "412402",
      "Kanhe B.O": "412106",
      "Takawe BK B.O": "412106",
      "Daundaj B.O": "412305",
      "Harni B.O": "412305",
      "Jeur B.O": "412305",
      "Hingniberdi B.O": "413801",
      "Asane B.O": "410509",
      "Gohe BK B.O": "410509",
      "Donje B.O": "411025",
      "Khanapur Haveli B.O": "411025",
      "Osade B.O": "411025",
      "Mavdi Kade Pathar B.O": "412303",
      "Nazare Kade Pathar B.O": "412303",
      "Pandheshwar B.O": "412303",
      "Pimpri B.O": "412303",
      "Ranmala B.O": "412303",
      "Walunj B.O": "412303",
      "Khanapur B.O": "412206",
      "Khangaon B.O": "410502",
      "Kusur B.O": "410502",
      "Manikdoh B.O": "410502",
      "Karunj B.O": "410405",
      "Malawali B.O": "410405",
      "Nane B.O": "410405",
      "Takave KH B.O": "410405",
      "Alande B.O": "412205",
      "Pimpalgaon Tarfe Chakan B.O": "410501",
      "Shive B.O": "410501",
      "Bibi B.O": "410513",
      "Kadadhe B.O": "410513",
      "Tiwai Hills B.O": "410513",
      "Boribyal B.O": "413801",
      "Deulgaonraja B.O": "413801",
      "Girim B.O": "413801",
      "Gopalwadi B.O": "413801",
      "Nanvij B.O": "413801",
      "Kiwale B.O": "410505",
      "Ravet B.O": "412101",
      "Sadumbre B.O": "412109",
      "Kondhwal B.O": "410509",
      "Kushire BK B.O": "410509",
      "Girawali B.O": "412408",
      "Pimpalgaon Tarfe Ghoda B.O": "412408",
      "Sal B.O": "412408",
      "Bijawadi B.O": "413106",
      "Kurwande B.O": "410402",
      "Anjanavale B.O": "410502",
      "Godre B.O": "410502",
      "Tambe B.O": "410502",
      "Utchil B.O": "410502",
      "Vadaj B.O": "410502",
      "Yenere B.O": "410502",
      "Audar B.O": "412404",
      "Chas B.O": "410515",
      "Bet Narayan Maharaj B.O": "412203",
      "Bori Paradhi B.O": "412203",
      "Nangaon B.O": "412203",
      "Padvi B.O": "412203",
      "Dapodi B.O": "412203",
      "Anantnagar Nigade B.O": "412205",
      "Arvi(Haveli) B.O": "412205",
      "Kodapur B.O": "412212",
      "Varoti BK B.O": "412212",
      "Kalamb B.O": "413114",
      "Redni B.O": "413114",
      "Shelgaon B.O": "413114",
      "Nathachi Wadi B.O": "412214",
      "Yavat R S B.O": "412214",
      "Shirkoli B.O": "412107",
      "Tav B.O": "412107",
      "Dawanewadi B.O": "412311",
      "Kaldari B.O": "412311",
      "Bhadas B.O": "412108",
      "Nandgaon B.O": "412108",
      "Shivali B.O": "410406",
      "Kolvadi B.O": "412412",
      "Bhukum B.O": "412115",
      "Khamboli B.O": "412115",
      "Rihe B.O": "412115",
      "Malshiras B.O": "412104",
      "Tekawade B.O": "412104",
      "Gulani B.O": "410505",
      "Palu B.O": "410505",
      "Sandbhorwadi(Exptl) B.O": "410505",
      "Vaphgaon B.O": "410505",
      "Bhamburde B.O": "412209",
      "Diwa B.O": "412301",
      "Pimple B.O": "412301",
      "Vanpuri B.O": "412301",
      "Chinchani Camp B.O": "412210",
      "Babhurdi B.O": "412204",
      "Adhale BK B.O": "410506",
      "Kasarsai B.O": "410506",
      "Shiavane B.O": "410506",
      "Dhanore B.O": "412105",
      "Kamdhenunagar B.O": "412202",
      "Dehane B.O": "412402",
      "Korhale BK B.O": "412103",
      "Late B.O": "412103",
      "Sate B.O": "412106",
      "Ashtapur B.O": "412207",
      "Kesnand B.O": "412207",
      "Walki B.O": "412207",
      "Mandki B.O": "412305",
      "Rakh B.O": "412305",
      "Kuruli B.O": "410501",
      "Vadgaon Ghenanad B.O": "410501",
      "Waki BK B.O": "410501",
      "Kalewadi B.O": "411017",
      "Adivare B.O": "410509",
      "Bhorghar B.O": "410509",
      "Jambhori B.O": "410509",
      "Pokhari B.O": "410509",
      "Taleghar B.O": "410509",
      "Tirpad B.O": "410509",
      "Ranjane B.O": "411025",
      "Kalashi B.O": "413106",
      "Vadapuri B.O": "413106",
      "Belsar B.O": "412303",
      "Kolvihire B.O": "412303",
      "Sakurde B.O": "412303",
      "Ballalwadi B.O": "410502",
      "Chavand B.O": "410502",
      "Khadkumbe(Exptl) B.O": "410502",
      "Khamgaon B.O": "410502",
      "Nimgiri B.O": "410502",
      "Parunde B.O": "410502",
      "Saygaon B.O": "412404",
      "Washere B.O": "412404",
      "Sakore B.O": "410515",
      "Karla B.O": "410405",
      "Vehergaon B.O": "410405",
      "Khopodi B.O": "412203",
      "Khor B.O": "412203",
      "Pargaon B.O": "412203",
      "Bhongavali B.O": "412205",
      "Vyahali B.O": "413120",
      "Madh B.O": "412409",
      "Netwad B.O": "412409",
      "Dhamari B.O": "412403",
      "Kambaleshwar B.O": "413110",
      "Kadve B.O": "412107",
      "Kambegi B.O": "412107",
      "Kuran BK B.O": "412107",
      "Pargaon Tarfe Madh B.O": "412409",
      "Pimpalgaon Joga B.O": "412409",
      "Rohokadi B.O": "412409",
      "Taleran B.O": "412409",
      "Udapur B.O": "412409",
      "Kati B.O": "413120",
      "Varkute KH B.O": "413120",
      "Khandobachi Wadi B.O": "412102",
      "Nimbut B.O": "412102",
      "Chilewadi B.O": "412409",
      "Dholwad B.O": "412409",
      "Dingore B.O": "412409",
      "Hivare KH B.O": "412409",
      "Manappawasti B.O": "413110",
      "Shirasane B.O": "413110",
      "Dalaj B.O": "413132",
      "Loni Deokar B.O": "413132",
      "Dhakale B.O": "413110",
      "Mangaon B.O": "412107",
      "Gulunche B.O": "412102",
      "Khubi B.O": "412409",
      "Mandave B.O": "412409",
      "Kendur B.O": "412403",
      "Agoti B.O": "413132",
      "Loni Bhapkar B.O": "413110",
      "Mudhale B.O": "413110",
      "Kashedi B.O": "412107",
      "Mose KH B.O": "412107",
      "Thergaon B.O": "411033",
      "Kondhwa KH B.O": "411048",
      "Kondhwa Lh B.O": "411048",
      "Talawade B.O": "411062",
      "Gunjalwadi B.O": "412401",
      "Pimpalgaon Tarfa Narayangaon B.O": "412401",
      "Nirgudsar B.O": "412406",
      "Pargaon Tarfe Avasari B.O": "412406",
      "Saval B.O": "413133",
      "Barhanpur B.O": "413102",
      "Dorlewadi B.O": "413102",
      "Nirawaghaj B.O": "413102",
      "Pimpali B.O": "413102",
      "Tandulwadi B.O": "413102",
      "Undawadi K P B.O": "413102",
      "Sarati B.O": "413103",
      "Shetphal Haveli B.O": "413103",
      "Watluj B.O": "413105",
      "Titeghar B.O": "412206",
      "Utroli B.O": "412206",
      "Vadgaon Dalache B.O": "412206",
      "Bori BK B.O": "412411",
      "Charoli BK B.O": "412105",
      "Chimbli B.O": "412105",
      "Markal B.O": "412105",
      "Moshi B.O": "412105",
      "Lakhangaon B.O": "412406",
      "Gawadewadi B.O": "412405",
      "Karkhel B.O": "413102",
      "Medad B.O": "413102",
      "Undawadi Supa B.O": "413102",
      "Nalavane B.O": "412410",
      "Sakori Tarfe Belha B.O": "412410",
      "Belawadi B.O": "413104",
      "Bori B.O": "413104",
      "Dhekalwadi B.O": "413104",
      "Kazad B.O": "413104",
      "Dhanori B.O": "411015",
      "Marunji B.O": "411057",
      "Wakad B.O": "411057",
      "Vadgaon Shinde B.O": "411047",
      "Mundhva B.O": "411036",
      "Kuravali B.O": "413104",
      "Sansar B.O": "413104",
      "Sapkalwadi B.O": "413104",
      "Kalas B.O": "413105",
      "Khanote B.O": "413105",
      "Madanwadi B.O": "413130",
      "Malad B.O": "413102",
      "Parwadi B.O": "413130",
      "Varodi KH B.O": "412206",
      "Gadad B.O": "410501",
      "Kalus B.O": "410501",
      "Khalumbre B.O": "410501",
      "Bari BK B.O": "412206",
      "Bazarwadi B.O": "412206",
      "Bhutonde B.O": "412206",
      "Chikhalgaon B.O": "412206",
      "Harnas B.O": "412206",
      "Hirdoshi B.O": "412206",
      "Jogwadi B.O": "412206",
      "Nazare B.O": "412206",
      "Nere B.O": "412206",
      "Pangari B.O": "412206",
      "Pasure B.O": "412206",
      "Solu B.O": "412105",
      "Savargaon B.O": "412401",
      "Vadgaon Sahani B.O": "412401",
      "Katfal B.O": "413133",
      "Gunawadi B.O": "413102",
      "Jhargadwadi B.O": "413102",
      "Sangvi B.O": "413102",
      "Songaon B.O": "413102",
      "Lakhewadi B.O": "413103",
      "Survad B.O": "413103",
      "Ane B.O": "412410",
      "Udhat B.O": "413104",
      "Rajegaon B.O": "413105",
      "Tathawade B.O": "411033",
      "9 DRD B.O": "411014",
      "Kondhwa BK B.O": "411048",
      "Bavdhan B.O": "411021",
      "Shivane B.O": "411023",
      "Sus B.O": "411021",
      "Ambegaon BK B.O": "411046",
      "Shetfalgade B.O": "413130",
      "Ambavade B.O": "412206",
      "Niranarshingpur B.O": "413211",
      "Mandvi BK B.O": "411023",
      "Apti B.O": "412206",
      "Karandi BK B.O": "412206",
      "Karnawad B.O": "412206",
      "Mahude BK B.O": "412206",
      "Malewadi B.O": "412206",
      "Rayari B.O": "412206",
      "Sangavi B.O": "412206",
      "Shind B.O": "412206",
      "Venavadi B.O": "412206",
      "Bahul B.O": "410501",
      "Alephata B.O": "412411",
      "Vadgaon Anand B.O": "412411",
      "Jalgaon Kadepathar B.O": "413102",
      "Karawaghaj B.O": "413102",
      "Mekhali B.O": "413102",
      "Shiravali B.O": "413102",
      "Shirsuphal B.O": "413102",
      "Bhodani B.O": "413103",
      "Mangrul B.O": "412410",
      "Katyachiwadi B.O": "413104",
      "Tavshi B.O": "413104",
      "Khadaki B.O": "413130",
      "Kudje B.O": "411023",
      "Uttamnagar B.O": "411023",
      "Baner B.O": "411045",
      "Ravangaon B.O": "413130",
      "Ambade B.O": "412206",
      "Ambeghar B.O": "412206",
      "Kanakwadi B.O": "412206",
      "Kari B.O": "412206",
      "Natambi B.O": "412206",
      "Pisavare B.O": "412206",
      "Sangamner B.O": "412206",
      "Velvand B.O": "412206",
      "Ambethan B.O": "410501",
      "Bhose B.O": "410501",
      "Jambe B.O": "411033",
      "Punawale B.O": "411033",
      "Pune City H.O": "411002",
      "Pune H.O": "411001",
      "Shivajinagar H.O": "411005",
      "Baramati H.O": "413102",
      "Bhavaninagar S.O (Pune)": "413104",
      "Chakan S.O": "410501",
      "I.A.T S.O": "411025",
      "Lonavala S.O": "410401",
      "Loni Dhamani S.O": "410510",
      "Midc Kurkumbh S.O": "413802",
      "Morgaon S.O": "412304",
      "Bibvewadi S.O": "411037",
      "Hadapsar S.O": "411028",
      "Belha S.O": "412410",
      "Bhigwan S.O": "413130",
      "Cod Dehu Road S.O": "412101",
      "Dasve Lavasa S.O": "412112",
      "Dhamani S.O": "410508",
      "Ins Shivaji Lonavale S.O": "410402",
      "Jejuri S.O": "412303",
      "Kadus S.O": "412404",
      "Kaivalyadham S.O": "410403",
      "Kalamb S.O (Pune)": "410515",
      "Koregaon Bhima S.O": "412216",
      "Madhukarnagar Patas S.O": "412219",
      "Malegaon BK S.O": "413115",
      "Midc Ranjangaon Ganpati S.O": "412220",
      "Nasrapur S.O": "412213",
      "Ordanance Dep Talegaon Dabhade S.O": "410506",
      "Congress House Road S.O": "411005",
      "Dhankawadi S.O": "411043",
      "Govt. Polytechnic S.O": "411016",
      "Khadakwasla R.S. S.O": "411024",
      "N.D.A. Khadakwasla S.O": "411023",
      "Rashtra Bhasha Bhavan S.O": "411030",
      "Bhosarigoan S.O": "411039",
      "Chikhali S.O": "411062",
      "Chinchwad East S.O": "411019",
      "Dapodi Bazar S.O": "411012",
      "Dapodi S.O": "411012",
      "Hadpsar I.E. S.O": "411013",
      "Baner DSO (Pune)": "411069",
      "Airport S.O (Pune)": "411032",
      "Bhosari I.E. S.O": "411026",
      "C D A (O) S.O": "411001",
      "Dighi Camp S.O": "411015",
      "Dr.B.A. Chowk S.O": "411001",
      "East Khadki S.O": "411003",
      "Gondhale Nagar S.O": "411028",
      "Khadki Bazar S.O": "411003",
      "Khadki S.O": "411003",
      "Market Yard S.O (Pune)": "411037",
      "Mohamadwadi S.O": "411060",
      "N.W. College S.O": "411001",
      "Pimpri P F S.O": "411018",
      "Pune New Bazar S.O": "411001",
      "Vishrantwadi S.O": "411015",
      "Akurdi S.O": "411035",
      "Ammunition Factory Khadki S.O": "411003",
      "Aundh Camp S.O": "411027",
      "C M E S.O": "411031",
      "Chinchwadgaon S.O": "411033",
      "Dunkirk lines S.O": "411014",
      "Avasari BK S.O": "412406",
      "Bawada S.O": "413103",
      "Bhigwan R S S.O": "413105",
      "Bhor S.O": "412206",
      "Daund S.O": "413801",
      "Dehu S.O": "412109",
      "Dimbhe Colony S.O": "410509",
      "Indapur S.O": "413106",
      "Kamshet S.O": "410405",
      "Kedgaon S.O (Pune)": "412203",
      "Khandala S.O": "410301",
      "Manjari Farm S.O": "412307",
      "Ordnance Factory Dehu Road S.O": "412101",
      "Rajgurunagar S.O": "410505",
      "S R P F Daund S.O": "413801",
      "Theur S.O": "412110",
      "Yavat S.O": "412214",
      "Baramati MIDC S.O": "413133",
      "Chas S.O (Pune)": "410513",
      "Dehu Road Cantt S.O": "412101",
      "Ghodegaon S.O (Pune)": "412408",
      "Indapur Bazar S.O": "413106",
      "Junnar S.O": "410502",
      "Khed Shivapur Baug S.O": "412205",
      "Lonavala Bazar S.O": "410401",
      "Loni Kalbhor S.O": "412201",
      "Malthan S.O": "412218",
      "Manchar S.O": "410503",
      "Narayangaon S.O": "410504",
      "Nhavare S.O": "412211",
      "Nimgaon Ketki S.O": "413120",
      "Nira R S S.O": "412102",
      "Otur S.O": "412409",
      "Paud S.O": "412108",
      "Pawananagar S.O": "410406",
      "Peth S.O (Pune)": "410512",
      "Phursungi S.O": "412308",
      "Saswad S.O": "412301",
      "Shinoli S.O": "410516",
      "Pabal S.O": "412403",
      "Palasdeo S.O": "413132",
      "Pandare S.O": "413110",
      "Panshet S.O": "412107",
      "Pimpalwandi S.O (Pune)": "412412",
      "R P T S Khandala S.O": "410302",
      "Supa S.O (Pune)": "412204",
      "Vada S.O (Pune)": "412402",
      "Veer S.O": "412312",
      "Ghorpuri Bazar S.O": "411001",
      "H.E. Factory S.O": "411003",
      "Infotech  Park (Hinjawadi) S.O": "411057",
      "Lohogaon S.O": "411047",
      "Nehrunagar S.O (Pune)": "411018",
      "Rupeenagar S.O": "411062",
      "Velhe S.O": "412212",
      "Shiroli B K S.O": "410511",
      "Shivnagar S.O": "413116",
      "Someshwarnagar S.O": "412306",
      "Talegaon Dabhade S.O": "410506",
      "Urulikanchan S.O": "412202",
      "Vagholi S.O": "412207",
      "Valha S.O": "412305",
      "Walchandnagar S.O": "413114",
      "Shikrapur S.O": "412208",
      "Parinche S.O": "412311",
      "Pirangut S.O": "412115",
      "Rajewadi S.O": "412104",
      "Ranjangaon Ganpati S.O": "412209",
      "Shirur S.O (Pune)": "412210",
      "Sopannagar S.O": "412301",
      "Talegaon Dhamdhere S.O": "412208",
      "Armament S.O": "411021",
      "Ex. Serviceman Colony S.O": "411038",
      "Karvenagar S.O": "411052",
      "Kasba Peth S.O": "411011",
      "Katraj S.O": "411046",
      "Model Colony S.O": "411016",
      "Nana Peth S.O": "411002",
      "Narayan Peth S.O": "411030",
      "Parvati Gaon S.O": "411009",
      "Parvati S.O": "411009",
      "Rasta Peth S.O": "411011",
      "Shaniwar Peth S.O (Pune)": "411030",
      "Shivajinagar S.O (Pune)": "411005",
      "Swargate S.O": "411042",
      "Nanded S.O (Pune)": "411068",
      "Iaf Station S.O": "411032",
      "Kasarwadi S.O": "411034",
      "M.Phulenagar S.O": "411019",
      "Masulkar Colony S.O": "411018",
      "Mundhva AV S.O": "411036",
      "P.C.N.T. S.O": "411044",
      "Pimpri Colony S.O": "411017",
      "Pimpri Waghire S.O": "411017",
      "Pune Cantt East S.O": "411001",
      "Sangavi S.O": "411027",
      "T.V. Nagar S.O": "411037",
      "Yamunanagar S.O": "411044",
      "Yerwada S.O": "411006",
      "Yerwada T.S. S.O": "411006",
      "Talegaon G H S.O": "410507",
      "Vadgaon Nimbalkar S.O": "412103",
      "Vadgaon S.O (Pune)": "412106",
      "Varvand S.O": "412215",
      "Baramati Court S.O": "413102",
      "Sachapir Street S.O": "411001",
      "Salisbury Park S.O": "411037",
      "Srpf S.O": "411022",
      "Vadgaon Sheri S.O": "411014",
      "Vidyanagar S.O (Pune)": "411032",
      "Wanowarie S.O": "411040",
      "Maan S.O": "411057",
      "Anandnagar S.O (Pune)": "411051",
      "Bajirao Road S.O": "411002",
      "Bhavani Peth S.O": "411042",
      "Bhusari Colony S.O": "411038",
      "Botanical Garden S.O (Pune)": "411020",
      "Deccan Gymkhana S.O": "411004",
      "Film Institute S.O": "411004",
      "Guruwar Peth S.O": "411042",
      "Lokmanyanagar S.O": "411030",
      "Mangalwar Peth S.O (Pune)": "411011",
      "S.P. College S.O": "411030",
      "S.S.C.Exam Board S.O": "411005",
      "Shivaji Housing Society S.O": "411016",
      "Shukrawar Peth S.O (Pune)": "411002",
      "Warje S.O": "411058",
      "Aundh S.O (Pune)": "411067",
      "A.R. Shala S.O": "411004",
      "Ala S.O (Pune)": "412411",
      "Avsari KH S.O": "412405",
      "Indrayaninagar S.O": "411026",
      "N I B M S.O": "411048",
      "Pimple Gurav S.O": "411061",
      "Sasanenagar S.O": "411028",
      "Viman nagar S.O": "411014",
      "Alandi Devachi S.O": "412105",
      "Arvi S.O (Pune)": "412401",
      "Aundh T.S. S.O": "411007",
      "Baner Road S.O": "411008",
      "Ganeshkhind S.O": "411007",
      "Ghorpade Peth S.O": "411042",
      "Kothrud S.O": "411038",
      "N.C.L. Pune S.O": "411008",
      "N.I.A. S.O": "411045",
      "Navsahyadri S.O": "411052",
      "Range Hills S.O": "411020",
      "Raviwar Peth S.O": "411002",
      "Sadashiv Peth S.O": "411030",
      "Swargate Chowk S.O": "411042",
      "Vadgaon Budruk S.O": "411041",
      "Sinhgad Technical Education Society": "411041"
    },
    "RAIGAD": {
      "Pangloli BO": "402101",
      "Sanderi BO": "402101",
      "Dahivad BO": "402302",
      "Dapoli BO": "402302",
      "Wawanje B.O": "410208",
      "Bokadvira B.O": "400702",
      "Chanje B.O": "400702",
      "Karanja B.O": "400702",
      "ONGC dronagiri B.O": "400702",
      "Kelevane B.O": "410206",
      "Nhava B.O": "410206",
      "Vaje B.O": "410206",
      "Vasheni B.O": "410206",
      "Lodhivali B.O": "410206",
      "Ulwa B.O": "410206",
      "Wavarle B.O": "410206",
      "Chirner B.O": "410206",
      "Jui B.O": "410206",
      "Kundevahal B.O": "410206",
      "Morbe B.O": "410206",
      "VAHAL B.O": "410206",
      "PARGAON B.O": "410206",
      "Navghar B.O": "400707",
      "Chinchwali B.O": "410201",
      "Dahivali T.Need B.O": "410201",
      "Gaulwadi B.O": "410201",
      "Gaurkamath B.O": "410201",
      "Kashele B.O": "410201",
      "Khandas B.O": "410201",
      "Kondivade B.O": "410201",
      "Mora B.O": "400704",
      "Shelu B.O": "410101",
      "Vakas B.O": "410101",
      "Pashane B.O": "410101",
      "Mazgaon B.O": "410220",
      "Vashivali B.O": "410220",
      "Nigade BO": "402302",
      "Wagholi BO": "402302",
      "Jamgaon BO": "402308",
      "Vile BO": "402308",
      "Jite BO": "402120",
      "Mangrun BO": "402302",
      "Sarve BO": "402403",
      "Walan Budruk BO": "402302",
      "Wadwali BO": "402403",
      "Kolmandla BO": "402114",
      "Patnus BO": "402308",
      "Bhave BO": "402302",
      "Walan Khurd BO": "402302",
      "Baple BO": "402203",
      "Chinchoti BO": "402203",
      "Malyan BO": "402203",
      "Lipniwave BO": "402101",
      "Kudli BO": "402308",
      "Dhamane BO": "402302",
      "Mohot BO": "402302",
      "Waki Budruk BO": "402302",
      "Adgaon BO": "402403",
      "Velas BO": "402403",
      "Agrav BO": "402203",
      "Kegaon B.O": "400702",
      "Sheva B.O": "400702",
      "Jasai B.O": "410206",
      "Wavandhal B.O": "410206",
      "Koproli B.O": "410206",
      "Jci Kamothe B.O": "410206",
      "Nere B.O": "410206",
      "Beed Budruk B.O": "410201",
      "Humgaon B.O": "410201",
      "Kadav B.O": "410201",
      "Koshane B.O": "410201",
      "Nandgaon B.O": "410201",
      "Pathraj B.O": "410201",
      "Salokh T.Need B.O": "410201",
      "Mangaon T.Varedi B.O": "410101",
      "Poshir B.O": "410101",
      "Chikhale B.O": "410221",
      "Poyanje B.O": "410221",
      "Apta B.O": "410207",
      "Sajgaon B.O": "410203",
      "Navde B.O": "410208",
      "Taloja B.O": "410208",
      "Wakan BO": "402303",
      "Kurdus BO": "402108",
      "Kusumbale BO": "402108",
      "Navedar Navgaon BO": "402208",
      "Varse BO": "402116",
      "Dhamansai BO": "402109",
      "Khaire Khurd BO": "402109",
      "Shedsai BO": "402109",
      "Tambadi BO": "402109",
      "Somatane B.O": "410206",
      "Sugawe B.O": "410201",
      "Tiware B.O": "410201",
      "Vengaon B.O": "410201",
      "Borgaon B.O": "410101",
      "Dahivali T.Varedi B.O": "410101",
      "Barapada B.O": "410221",
      "Sai B.O": "410221",
      "Shirdhon B.O": "410221",
      "Gulsunde B.O": "410207",
      "Donwat B.O": "410203",
      "Devichapada B.O": "410208",
      "Koynavale B.O": "410208",
      "Mahargul BO": "402303",
      "Paithan BO": "402303",
      "Palchil BO": "402303",
      "Sadavali BO": "402303",
      "Sakhar BO": "402303",
      "Shahapur BO": "402108",
      "Dhokawade BO": "402208",
      "Zirad BO": "402208",
      "Kihim BO": "402208",
      "Sasawane BO": "402208",
      "Borlimandla BO": "402202",
      "Korlai BO": "402202",
      "Vikram Baug BO": "402202",
      "Walke BO": "402202",
      "Ashtami BO": "402109",
      "Bhalgaon BO": "402109",
      "Chanera BO": "402109",
      "Virjoli BO": "402109",
      "Chawk B.O": "410206",
      "Adai B.O": "410206",
      "Awre B.O": "410206",
      "Dighode B.O": "410206",
      "GAVHAN": "410206",
      "Jaskhar B.O": "400707",
      "Ambivali B.O": "410201",
      "Bhivpuri Camp B.O": "410201",
      "Gundge B.O": "410201",
      "Jambrung B.O": "410201",
      "Kirwali B.O": "410201",
      "Mandavane B.O": "410201",
      "Nasarapur B.O": "410201",
      "Palasdari B.O": "410201",
      "Savroli B.O": "410202",
      "Kalamb B.O": "410101",
      "Manivali B.O": "410101",
      "Ajivali B.O": "410221",
      "Palaspe B.O": "410221",
      "Khambewadi B.O": "410203",
      "Vavoshi B.O": "410203",
      "Padghe B.O": "410208",
      "Tondra B.O": "410208",
      "Awas BO": "402208",
      "Mapgaon BO": "402208",
      "Ghosale BO": "402109",
      "Khargaon BO": "402109",
      "Medha BO": "402109",
      "Nhave BO": "402109",
      "Pingalsai BO": "402109",
      "Sanegaon BO": "402109",
      "Usar BO": "402203",
      "Nagloli BO": "402404",
      "Adhi BO": "402103",
      "Nandvi BO": "402103",
      "Panhalghar BO": "402103",
      "Usarghar BO": "402103",
      "Wadvali BO": "402103",
      "Agardanda BO": "402401",
      "Majgaon BO": "402401",
      "Usroli BO": "402401",
      "Devkanhe BO": "402304",
      "Pugaon BO": "402304",
      "Kamarle BO": "402209",
      "Narangi BO": "402209",
      "Chandhave Budruk BO": "402301",
      "Gondale BO": "402301",
      "Kotheri BO": "402301",
      "Bamnoli BO": "402104",
      "Palasgaon Khurd BO": "402104",
      "Khamgaon BO": "402105",
      "Salvinde BO": "402105",
      "Kamble Tarfe Birwadi BO": "402309",
      "Konzar BO": "402305",
      "Pachad BO": "402305",
      "Tetghar BO": "402305",
      "Wagheri BO": "402305",
      "Koste Khurd BO": "402120",
      "Dahigaon BO": "410205",
      "Hatond BO": "410205",
      "Khavali BO": "410205",
      "Mahagaon BO": "402112",
      "Pachhapur BO": "410205",
      "Siddheshwar BO": "410205",
      "Ambeghar BO": "402107",
      "Ramraj BO": "402203",
      "Devali BO": "402103",
      "Harkol BO": "402103",
      "Kashid BO": "402401",
      "Nandgaon BO": "410205",
      "Rajpuri BO": "402401",
      "Savli BO": "402401",
      "Shighare BO": "402401",
      "Vihoor BO": "402401",
      "Hashiware BO": "402209",
      "Ambivali BO": "402301",
      "Lohare BO": "402303",
      "Ombali BO": "402303",
      "Turbhe Khurd BO": "402303",
      "Shahabaj BO": "402108",
      "Chondhi BO": "402208",
      "Chandgaon BO": "402109",
      "Chordhe BO": "402109",
      "Kokban BO": "402109",
      "Sarsoli BO": "402109",
      "Shenwai BO": "402109",
      "Chochinde BO": "402301",
      "Dharavali BO": "402301",
      "Kalavali BO": "402301",
      "Lonshi BO": "402104",
      "Pen Tarfe Tale BO": "402104",
      "Talegaon Tarfe Goregaon BO": "402104",
      "Unegaon BO": "402104",
      "Majgaon Tamhane BO": "402105",
      "Mendadi BO": "402105",
      "Pabhare BO": "402105",
      "Talavade BO": "402105",
      "Varvatane BO": "402105",
      "Rajewadi BO": "402309",
      "Degaon BO": "402117",
      "Amtem BO": "402106",
      "Savrat BO": "402305",
      "Taloshi BO": "402305",
      "Varandoli BO": "402305",
      "Govele BO": "402122",
      "Jasawali BO": "402110",
      "Vadghar BO": "402110",
      "Bhanang BO": "402111",
      "Muthavali Tarfe Tala BO": "402112",
      "Wavediwali BO": "402112",
      "Taliye BO": "402306",
      "Pangari BO": "402307",
      "Chikhlap BO": "402105",
      "Shekhadi BO": "402113",
      "Chandore BO": "402122",
      "Bhoste BO": "402110",
      "Borghar Haveli BO": "402111",
      "Mandad BO": "402111",
      "Wali BO": "402109",
      "Galsure BO": "402110",
      "Hareshwar BO": "402110",
      "Vadshetvave BO": "402110",
      "Pitsai BO": "402111",
      "Rahatad BO": "402111",
      "Talegaon BO": "402111",
      "Tokarde BO": "402111",
      "Wighawali BO": "402112",
      "Jui Budruk BO": "402115",
      "Ravdhal BO": "402115",
      "Walang BO": "402115",
      "Barasgaon BO": "402306",
      "Kumbheshivthar BO": "402306",
      "Mazeri BO": "402306",
      "Padvi BO": "402306",
      "Ambavade BO": "402307",
      "Kavale BO": "402307",
      "Khandpoli BO": "410205",
      "Mahal Mirya Dongar BO": "410205",
      "Mangaon Budruk BO": "410205",
      "Nadsur BO": "410205",
      "Gadab BO": "402107",
      "Gagode Budruk BO": "402107",
      "Hamrapur BO": "402107",
      "Shirki BO": "402107",
      "Tarankhop BO": "402107",
      "Vadhav BO": "402107",
      "Vadkhal BO": "402107",
      "Varsai BO": "402107",
      "Ainghar BO": "402126",
      "Deopur BO": "402303",
      "Devla BO": "402303",
      "Kondhavi BO": "402303",
      "Dabhol BO": "402102",
      "TolBudruk BO": "402102",
      "Kudgaon BO": "402402",
      "Lonere BO": "402103",
      "Mangarul BO": "402103",
      "Chinchwali Tarfe Atone BO": "402304",
      "Veshvi BO": "402209",
      "Dadar BO": "402107",
      "Sawarsai BO": "402107",
      "Adavale Budruk BO": "402303",
      "Chambhargani BO": "402303",
      "Dhamandevi BO": "402303",
      "Golegani BO": "402303",
      "Kotwal Budruk BO": "402303",
      "Varsoli BO": "402209",
      "Kurul BO": "402209",
      "Karanjadi BO": "402301",
      "Kinjaloli Budruk BO": "402301",
      "Mumurshi BO": "402301",
      "Nagaon BO": "402103",
      "Natondi BO": "402301",
      "Revtale BO": "402301",
      "Sav BO": "402301",
      "Sawad BO": "402301",
      "Underi BO": "402301",
      "Vahoor BO": "402301",
      "Kavil Vahal BO": "402104",
      "Usar Khurd BO": "402104",
      "Gondghar BO": "402105",
      "Kolwat BO": "402105",
      "Kamble Tarfe Mahad BO": "402309",
      "Kusgaon BO": "402309",
      "Akshi BO": "402204",
      "Bamangaon BO": "402204",
      "Bense BO": "402106",
      "Pigonde BO": "402106",
      "Wakanfata BO": "402106",
      "Khardi BO": "402305",
      "Kolose BO": "402305",
      "Bhale BO": "402120",
      "Borwadi BO": "402120",
      "Atone BO": "410205",
      "Bhairav BO": "410205",
      "Bharje BO": "410205",
      "Chive BO": "410205",
      "Kandale BO": "402107",
      "Kasu BO": "402107",
      "Kharpale BO": "402107",
      "Koproli BO": "402107",
      "Ransai BO": "402107",
      "Manjaravane BO": "402122",
      "Ranawali BO": "402110",
      "Saigaon BO": "402110",
      "Ratwad BO": "402112",
      "Narvan BO": "402115",
      "Tamhane BO": "402307",
      "Aravi BO": "402113",
      "Sudkoli BO": "402203",
      "Veer BO": "402102",
      "Bharadkhol BO": "402404",
      "Dandguri BO": "402404",
      "Purar BO": "402103",
      "Khamb BO": "402304",
      "Talawali Terfe Diwali BO": "402304",
      "Khandale BO": "402209",
      "Saral BO": "402209",
      "Kemburli BO": "402301",
      "Kurle BO": "402301",
      "Hodgaon BO": "402104",
      "Kharavali BO": "402104",
      "Tempale BO": "402104",
      "Kelte BO": "402105",
      "Kharsai BO": "402105",
      "Dahivali BO": "402117",
      "Palas BO": "402106",
      "Achloli BO": "402305",
      "Mandle BO": "402305",
      "Sandoshi BO": "402305",
      "Shirawali BO": "402120",
      "Ghotawade BO": "410205",
      "Jambhulpada BO": "410205",
      "Navghar BO": "410205",
      "Parali BO": "410205",
      "Ravalje BO": "410205",
      "Tiware BO": "410205",
      "Balavali BO": "402107",
      "Dolvi BO": "402107",
      "Johe BO": "402107",
      "Kamarli BO": "402107",
      "Pabal BO": "402107",
      "Rave BO": "402107",
      "Sonkhar BO": "402107",
      "Washi BO": "402107",
      "Borghar BO": "402303",
      "Divil BO": "402303",
      "Kapade Budruk BO": "402303",
      "Panvel H.O": "410206",
      "Alibag HO": "402201",
      "N.S.Karanja S.O": "400704",
      "Shilphata S.O": "410203",
      "Bagmandla SO": "402114",
      "Borlipanchatan SO": "402403",
      "Nate SO": "402305",
      "RCF Thal SO": "402208",
      "Taloja A.V. S.O": "410208",
      "Uran S.O": "400702",
      "Jnpt S.O": "400707",
      "Khanda Colony S.O": "410206",
      "Khopoli Power House S.O": "410204",
      "Matheran S.O": "410102",
      "Chaul SO": "402203",
      "Chimbhave SO": "415213",
      "Dasgaon SO": "402102",
      "Dighi SO": "402402",
      "Navipeth Mahad SO": "402301",
      "Poynad SO": "402108",
      "Roha AV SO": "402116",
      "Roha SO": "402109",
      "Salvadnaka Mahad No Dly SO": "402301",
      "Talashet SO": "402112",
      "Upper Tudil SO": "402115",
      "Varandh SO": "402306",
      "Patalganga S.O": "410220",
      "KAMOTHE S.O": "410209",
      "Karjat S.O (Raigarh(MH))": "410201",
      "Khalapur S.O": "410202",
      "Kharghar S.O": "410210",
      "Mohopada S.O": "410222",
      "Neral S.O": "410101",
      "Rasayani S.O": "410207",
      "Birwadi SO": "402302",
      "Goregaon SO RaigarhMH": "402103",
      "Midc Mahad SO": "402309",
      "Nagaon SO": "402204",
      "Nagothane SO": "402106",
      "Nizampur SO RaigarhMH": "402120",
      "Poladpur SO": "402303",
      "Tala SO RaigarhMH": "402111",
      "Jagdish Nagar S.O": "410216",
      "Kalamboli Node S.O": "410218",
      "Khopoli S.O": "410203",
      "Ambet SO": "402101",
      "Bhira SO RaigarhMH": "402308",
      "Diveagar SO": "402404",
      "Janjira Murud SO": "402401",
      "Kolad SO": "402304",
      "Kurul RCF Colony SO": "402209",
      "Mahad SO": "402301",
      "Mangaon SO RaigarhMH": "402104",
      "Mhasla SO": "402105",
      "Morba SO": "402117",
      "Pali SO RaigarhMH": "410205",
      "PCTS Nagothane SO": "402125",
      "Pen SO": "402107",
      "Pipenagar SO": "402126",
      "Revdanda SO": "402202",
      "Sai SO": "402122",
      "Shriwardhan SO": "402110",
      "Thal SO RaigarhMH": "402207",
      "Vinhere SO": "402307",
      "Walwati SO": "402113",
      "Ongc Complex,panvel S.O": "410221",
      "Panvel City S.O": "410206"
    },
    "PARBHANI": {
      "Kausadi B.O": "431508",
      "Nivali B.O": "431508",
      "Borwand BK B.O": "431521",
      "Dhasadi B.O": "431521",
      "Borda B.O": "431514",
      "Dongarpimpla B.O": "431514",
      "Mardasgaon B.O": "431514",
      "Naikota B.O": "431514",
      "Wadgaon B.O": "431514",
      "Dhanora B.O": "431509",
      "Gadadgavan B.O": "431509",
      "Kavi B.O": "431509",
      "Pachalegaon B.O": "431509",
      "Waghi B.O": "431509",
      "Dhengali Pimpalgaon B.O": "431505",
      "Tadborgaon B.O": "431505",
      "Brahmangaon B.O": "431402",
      "Kalgaon B.O": "431402",
      "Pimpri Deshmukh B.O": "431402",
      "Pethpimpalgaon B.O": "431720",
      "Sailu B.O": "431720",
      "Salapuri B.O": "431521",
      "Badwani B.O": "431514",
      "Mahatpuri B.O": "431514",
      "Makhani B.O": "431514",
      "Wazur B.O": "431514",
      "Asegaon B.O": "431509",
      "Bhogaon Devi B.O": "431509",
      "Bhosi B.O": "431509",
      "Borkini B.O": "431509",
      "Kolha B.O": "431505",
      "Manoli B.O": "431505",
      "Palodi B.O": "431505",
      "Lohgaon B.O": "431402",
      "Majlapur B.O": "431402",
      "Mirkhel B.O": "431402",
      "Chandaj B.O": "431508",
      "Kok B.O": "431508",
      "Pokharni B.O": "431521",
      "Umari B.O": "431521",
      "Devalgaon Dudhate B.O": "431514",
      "Gaundgaon B.O": "431514",
      "Malewadi B.O": "431514",
      "Muli B.O": "431514",
      "Kawada B.O": "431509",
      "Pachegaon B.O": "431509",
      "Pungala B.O": "431509",
      "Shewadi B.O": "431509",
      "Vassa B.O": "431509",
      "Karanji B.O": "431505",
      "Kothala B.O": "431505",
      "Rudhi B.O": "431505",
      "Ukkalgaon B.O": "431505",
      "Dhar B.O": "431402",
      "Karegaon B.O": "431402",
      "Pethshivani B.O": "431720",
      "Pharkanda B.O": "431720",
      "Pimpalgaon Gayke B.O": "431508",
      "Simangaon B.O": "431508",
      "Waghi Bobde B.O": "431508",
      "Bharaswada B.O": "431521",
      "Dharasur B.O": "431521",
      "Harangul B.O": "431514",
      "Isad B.O": "431514",
      "Khali B.O": "431514",
      "Kodri B.O": "431514",
      "Pimpaldari B.O": "431514",
      "Pimprizola B.O": "431514",
      "Raorajura B.O": "431514",
      "Suppa B.O": "431514",
      "Ukhali B.O GANGAKHED": "431514",
      "Charthana B.O": "431509",
      "Itoli B.O": "431509",
      "Jamb BK B.O": "431509",
      "Jogwada B.O": "431509",
      "K Adgaon B.O": "431509",
      "Pangri B.O": "431509",
      "Warud B.O": "431509",
      "Devalgaon Awchar B.O": "431505",
      "Zari B.O": "431505",
      "Asola B.O": "431402",
      "Nandkheda B.O": "431402",
      "Pingali B.O": "431402",
      "Singanapur B.O": "431402",
      "Tadkalas B.O": "431402",
      "Taroda B.O": "431402",
      "Kerwadi B.O": "431720",
      "Shikh Rajura B.O": "431720",
      "Gunj KH B.O": "431506",
      "Kansur B.O": "431506",
      "Kasapuri B.O": "431506",
      "Rampuri KH B.O": "431506",
      "Renakhali B.O": "431506",
      "Renapur B.O": "431506",
      "Bhogaon B.O": "431537",
      "Jamb B.O": "431537",
      "Hamdapur B.O": "431541",
      "Kekar Jawala B.O": "431541",
      "Kinhola B.O RAMPURI BK SO": "431541",
      "Limba B.O": "431516",
      "Dhangar Takli B.O": "431511",
      "Erandeshwar B.O": "431511",
      "Gaur B.O": "431511",
      "Katneshwar B.O": "431511",
      "Kawalgaon B.O": "431511",
      "Waghala B.O": "431541",
      "Banvas B.O": "431536",
      "Chatori B.O": "431536",
      "Ghantangra B.O": "431536",
      "Nava B.O": "431536",
      "Devalgaon Gat B.O": "431503",
      "Gomewakdi B.O": "431503",
      "Chikalthana B.O": "431503",
      "Dasala B.O": "431503",
      "Khadka B.O": "431516",
      "Narwadi B.O": "431516",
      "Shelgaon B.O": "431516",
      "Sirshi BK B.O": "431516",
      "Wazar B.O": "431510",
      "Bobde Takli B.O": "431540",
      "Dudhgaon B.O": "431540",
      "Nandapur B.O": "431540",
      "Sadegaon B.O": "431540",
      "Kundi B.O": "431503",
      "Moregaon B.O": "431503",
      "Sonna B.O": "431503",
      "Sawali BK B.O": "431510",
      "Sawangi Bhambale B.O": "431510",
      "Dongargaon B.O": "431506",
      "Hadgaon B.O": "431506",
      "Nathra B.O": "431506",
      "Pathargavan B.O": "431506",
      "Pimpalgaon B.O PEDGAON": "431537",
      "Aherwadi B.O": "431511",
      "Mategaon B.O": "431511",
      "Pimpla Lokhande B.O": "431511",
      "Mangrul B.O": "431541",
      "Rametakli B.O": "431541",
      "Sirsam B.O": "431536",
      "Ukkadgaon B.O": "431536",
      "Aherborgaon B.O": "431503",
      "Gugali Dhamangaon B.O": "431503",
      "Kupta B.O": "431503",
      "Bhahulgaon B.O": "431506",
      "Khavane Pimpri B.O": "431506",
      "Wadi B.O": "431506",
      "Mandakhali B.O": "431537",
      "Chudawa B.O": "431511",
      "Rawalgaon B.O": "431503",
      "Dighol Islampur B.O": "431516",
      "Bamni B.O": "431510",
      "Kehal B.O": "431510",
      "Arvi B.O": "431402",
      "Takli Kumbhakarna B.O": "431402",
      "Neel B.O": "431511",
      "Mudgal B.O": "431516",
      "Vita B.O": "431516",
      "Tandulwadi B.O": "431536",
      "Ballur B.O": "431503",
      "Hatnoor B.O": "431503",
      "Kanegaon B.O": "431516",
      "Ambarwadi B.O": "431510",
      "Pimpalgaon Kajale B.O": "431510",
      "Parbhani H.O": "431401",
      "Gangakhed S.O": "431514",
      "Manwath S.O": "431505",
      "Sailu Town S.O": "431503",
      "Station Parbhani S.O": "431401",
      "Yeldari S.O": "431510",
      "Jintur S.O": "431509",
      "Palam S.O": "431720",
      "Pedgaon S.O": "431537",
      "Purna S.O": "431511",
      "Ranisawargaon S.O": "431536",
      "Sailu S.O": "431503",
      "Zari S.O": "431540",
      "Bori S.O (Parbhani)": "431508",
      "Daithana S.O": "431521",
      "Mau Parbhani S.O": "431402",
      "Naya Mondha Parbhani S.O": "431401",
      "Parbhani Town S.O": "431401",
      "Kranti Chowk Parbhani S.O": "431401",
      "Manwath Town S.O": "431505",
      "Pathri S.O": "431506",
      "Rampuri BK S.O": "431541",
      "Shivajinagar Parbhani S.O": "431401",
      "Sonpeth S.O": "431516"
    },
    "THANE": {
      "Airoli B.O": "400708",
      "Darave B.O": "400706",
      "Balegaon B.O": "421402",
      "Thakurli B.O": "421201",
      "Vihigaon B.O": "421602",
      "Wadi B.O": "421306",
      "Kharid B.O": "421403",
      "Badlapur E.D. B.O": "421503",
      "Kishore B.O": "421401",
      "Kolthan B.O": "421401",
      "Talegaon B.O": "421401",
      "Vaholi B.O": "421103",
      "Alyani B.O": "421601",
      "Chande B.O": "421601",
      "Chondhe Colony B.O": "421601",
      "Dalkhan B.O": "421601",
      "Dhasai B.O": "421601",
      "Khutghar B.O": "421601",
      "Sakadbav B.O": "421601",
      "Saralambe B.O": "421601",
      "Tansa B.O": "421601",
      "Vashind E.D. B.O": "421601",
      "Tapasenagar B.O": "400608",
      "Anjur B.O": "421302",
      "Dabhad B.O": "421302",
      "Kharbav B.O": "421302",
      "Lonad B.O": "421302",
      "Vadpe B.O": "421302",
      "Mal B.O": "421402",
      "Palu B.O": "421402",
      "Shiroshi B.O": "421402",
      "Mugaon B.O": "421403",
      "Sogaon B.O": "421403",
      "Pimpaloli B.O": "421301",
      "Vangani B.O": "421503",
      "Yeranjad B.O": "421503",
      "Khadavali B.O": "421605",
      "Moroshi B.O": "421401",
      "Narivali B.O": "421401",
      "Mamnoli B.O": "421103",
      "Rayate B.O": "421103",
      "Asangaon B.O": "421601",
      "Atgaon B.O": "421601",
      "Aware B.O": "421601",
      "Kharade B.O": "421601",
      "Khardi B.O": "421601",
      "Vehloli K B.O": "421601",
      "Amane B.O": "421302",
      "Angaon B.O": "421302",
      "Dighashi B.O": "421302",
      "Dugad B.O": "421302",
      "Kalher B.O": "421302",
      "Shelar B.O": "421302",
      "Dahisar B.O": "400612",
      "Dawale B.O": "400612",
      "Tokawade B.O": "421402",
      "Vaishakhare B.O": "421402",
      "Shirol B.O": "421602",
      "Dwarli B.O": "421306",
      "Mangrul B.O": "421306",
      "Kharivali B.O": "421403",
      "Malegaon B.O": "421403",
      "Manjarli B.O": "421503",
      "Phalegaon B.O": "421605",
      "Titwala B.O": "421605",
      "Khoni B.O": "421204",
      "Padle B.O": "421204",
      "Kasegaon B.O": "421401",
      "Mhasa B.O": "421401",
      "Milhe B.O": "421401",
      "Patgaon B.O": "421401",
      "Saralgaon B.O": "421401",
      "Sasne B.O": "421401",
      "Sayale B.O": "421401",
      "Jambhul B.O": "421505",
      "Andad B.O": "421601",
      "Gunde B.O": "421601",
      "Kalamgaon B.O": "421601",
      "Sawaroli B.O": "421601",
      "Shenwa B.O": "421601",
      "Shere B.O": "421601",
      "Shirgaon B.O": "421601",
      "Vehloli B.O": "421601",
      "Pachhapur B.O": "421302",
      "Paye B.O": "421302",
      "Rehnal B.O": "421302",
      "Shantinagar E.D. B.O": "421302",
      "Birwadi B.O": "421603",
      "Mokhawane B.O": "421602",
      "Vashala B.O": "421602",
      "Pisavli B.O": "421306",
      "Gegaon B.O": "421403",
      "Thune B.O": "421403",
      "Chargaon B.O": "421503",
      "Nilje B.O": "421204",
      "Atali B.O": "421102",
      "Manivali B.O": "421102",
      "Khutal Baragaon B.O": "421401",
      "Majgaon B.O": "421401",
      "Shivale B.O": "421401",
      "Tulai B.O": "421401",
      "Varap B.O": "421103",
      "Aghai B.O": "421601",
      "Ambarje B.O": "421601",
      "Dolkhamb B.O": "421601",
      "Lenad Khurd B.O": "421601",
      "Nadgaon B.O": "421601",
      "Piwali B.O": "421601",
      "Sakurli B.O": "421601",
      "Tembhurli B.O": "421601",
      "Vaitarna B.O": "421601",
      "Vehele B.O": "421601",
      "Shrirangnagar B.O": "400608",
      "Chimbipada B.O": "421302",
      "Chinchwali B.O": "421302",
      "Dunge B.O": "421302",
      "Kunde B.O": "421302",
      "Mahapoli B.O": "421302",
      "Vadavali B.O": "421302",
      "Chitalsar Manpada B.O": "400607",
      "Vedhe B.O": "401204",
      "Diwa B.O": "400612",
      "Kausa B.O": "400612",
      "Kon B.O": "421311",
      "Pimplas B.O": "421311",
      "Rai B.O": "401101",
      "Waklan B.O": "400612",
      "Kashi B.O": "401107",
      "Dongari B.O": "401106",
      "Ghodbander B.O": "401107",
      "Thane H.O": "400601",
      "Kalyan City H.O": "421301",
      "Ghansoli S.O": "400701",
      "Millenium Business Park S.O": "400710",
      "Nerul Node III S.O": "400706",
      "Turbhe Market S.O": "400703",
      "Vashi Sec 26 S.O": "400703",
      "Ambernath S.O": "421501",
      "Bus Terminus": "421002",
      "Dombivali I.A. S.O": "421203",
      "Kalyan D.C. S.O": "421301",
      "Kalyan Rs S.O": "421301",
      "Katemanivali S.O": "421306",
      "Kulgaon S.O": "421503",
      "Murbad S.O": "421401",
      "Ramnagar S.O (Thane)": "421201",
      "Ulhasnagar 4 S.O": "421004",
      "Bhiwandi S.O": "421308",
      "Kalwa S.O": "400605",
      "Naupada S.O (Thane)": "400602",
      "Sandozbaugh S.O": "400607",
      "Ghodbunder Road": "400615",
      "Bhaji Market S.O": "421002",
      "Bhatsanagar S.O": "421603",
      "Dombivali S.O": "421201",
      "Ganeshwadi S.O (Thane)": "421306",
      "Kansai S.O": "421501",
      "Mohone S.O": "421102",
      "Netaji Bazar S.O": "421505",
      "Ulhasnagar 1": "421002",
      "K.U.Bazar S.O": "400703",
      "Sanpada S.O": "400705",
      "Vashi VII S.O": "400703",
      "Airoli S.O": "400708",
      "Kopar Khairne S.O": "400709",
      "Ulhasnagar 5 S.O": "421005",
      "Kopri Colony S.O": "400603",
      "Mumbra S.O": "400612",
      "Padgha S.O": "421101",
      "Shastrinagar S.O (Thane)": "421302",
      "Thane Bazar S.O": "400601",
      "Thane R.S. S.O": "400601",
      "Vidyashram S.O": "421305",
      "Ambernath South S.O": "421501",
      "Kasara S.O (Thane)": "421602",
      "O.E.Ambernath S.O": "421502",
      "Shahapur S.O (Thane)": "421601",
      "Apna Bazar S.O": "400610",
      "Balkum S.O": "400608",
      "Dandekarwadi S.O": "421302",
      "Gokhale Road S.O (Thane)": "400602",
      "Kasarvadavali S.O": "400615",
      "Thane East S.O": "400603",
      "Belapur Node   III S.O": "400614",
      "Belapur Node  V S.O": "400614",
      "Konkan Bhavan S.O": "400614",
      "Additional Ambernath S.O": "421506",
      "Dhasai S.O": "421402",
      "Kinholi S.O": "421403",
      "Manda S.O": "421605",
      "Manpada S.O": "421204",
      "Shahad S.O": "421103",
      "Station Road Unr 3 S.O": "421002",
      "Subhash Road S.O (Thane)": "421301",
      "Tilaknagar S.O (Thane)": "421201",
      "Ulhasnagar 2 S.O": "421002",
      "Vishnunagar S.O": "421202",
      "Jekegram S.O": "400606",
      "Saravali S.O": "421311",
      "Wagle I.E. S.O": "400604",
      "Nerul Node II S.O": "400706",
      "Nerul Sec 48 S.O": "400706",
      "Turbhe S.O": "400703",
      "Vashi S.O (Thane)": "400703",
      "Mira Road S.O": "401107",
      "Ganeshpuri S.O": "401206",
      "Bhayander West S.O": "401101",
      "Mira S.O": "401107",
      "Uttan S.O": "401106",
      "Vajreshwari S.O": "401204"
    },
    "PALGHAR": {
      "Dapoli": "401405",
      "Rase B.O": "410501",
      "Khupri B.O": "421312",
      "Met B.O": "421312",
      "Nehroli B.O": "421312",
      "Palsai B.O": "421312",
      "Uchat B.O": "421312",
      "Chamble B.O": "421312",
      "Kondhale B.O": "421312",
      "Chikhal Dongre B.O": "401301",
      "Kophrad B.O": "401301",
      "Umela B.O": "401202",
      "Bhuigaon B.O": "401201",
      "Dandi B.O": "401501",
      "Kumbhawali B.O": "401501",
      "Mahagaon B.O": "401501",
      "Murbe B.O": "401501",
      "Jamshet B.O": "401602",
      "Karaj Gaon B.O": "401602",
      "Waki B.O": "421303",
      "Jamsar B.O": "401603",
      "Karhe B.O": "401603",
      "Nyhale Budruk B.O": "401603",
      "Pimpalshet B.O": "401603",
      "Bandhan B.O": "401403",
      "Bhopoli B.O": "401403",
      "Kev B.O": "401403",
      "Govade B.O": "401403",
      "Morhanda B.O": "401604",
      "Vashala B.O": "401604",
      "Tembhode B.O": "401405",
      "Shirgaon": "401405",
      "Gass B.O": "401203",
      "Acchad B.O": "401606",
      "Dabhadi B.O": "401606",
      "Dhundalwadi B.O": "401606",
      "Dahisar Tarapur B.O": "401502",
      "Tandulwadi B.O": "401102",
      "Tembhikhodave B.O": "401102",
      "Abje B.O": "401204",
      "Asangaon B.O": "401103",
      "Bavada B.O": "401103",
      "Bolinj B.O": "401303",
      "Khaniwade B.O": "401303",
      "Abitghar B.O": "421303",
      "Khariwali B.O": "421303",
      "Kone B.O": "421303",
      "Parali B.O": "421303",
      "Pik B.O": "421303",
      "Holi Bazar B.O": "401201",
      "Kaular Budruk B.O": "401201",
      "Saloli B.O": "401201",
      "Shigaon B.O": "401501",
      "Borigaon B.O": "401701",
      "Tanashi B.O": "401503",
      "Vadhavan B.O": "401503",
      "Agawan B.O": "401602",
      "Ashagad B.O": "401602",
      "Charoti B.O": "401602",
      "Nikane B.O": "401602",
      "Badapokharan B.O": "401601",
      "Narpad B.O": "401601",
      "Dengachimet B.O": "401603",
      "Dhanoshi B.O": "401603",
      "Sakharshet B.O": "401603",
      "Valvande B.O": "401603",
      "Kasa Budruk B.O": "401607",
      "Rankol B.O": "401607",
      "Kelwa Road B.O": "401401",
      "Somta B.O": "401403",
      "Maswan B.O": "401403",
      "Dolhara B.O": "401604",
      "Poshera B.O": "401604",
      "Katale B.O": "401405",
      "Kochai B.O": "401606",
      "Modgaon B.O": "401606",
      "Uplat B.O": "401606",
      "Vevji B.O": "401606",
      "Zari B.O": "401606",
      "Parnali B.O": "401504",
      "Navghar B.O": "401102",
      "Dhekale B.O": "401102",
      "Dahisar tymanor B.O": "401102",
      "Gokhiware B.O": "401208",
      "Juchandra B.O": "401208",
      "Kaman B.O": "401208",
      "Pelhar B.O": "401208",
      "Dadade B.O": "401605",
      "Khoste B.O": "401605",
      "Medhi B.O": "401605",
      "Ondhe B.O": "401605",
      "Parol B.O": "401303",
      "Tilher B.O": "401303",
      "Alonde B.O": "421303",
      "Gargoan B.O": "421303",
      "Hamarapur B.O": "421303",
      "Kalambe B.O": "421303",
      "Kanchad B.O": "421303",
      "Khaire Ambiwali B.O": "421303",
      "Sonale B.O": "421303",
      "Tuse B.O": "421303",
      "Utawali B.O": "421303",
      "Varale B.O": "421303",
      "Mulgaon B.O": "401201",
      "Akkarpatti B.O": "401501",
      "Nandgaon Tarapur B.O": "401501",
      "Borsheti": "401501",
      "Umroli": "401501",
      "Varor B.O": "401503",
      "Bapugaon B.O": "401602",
      "Chikhale B.O": "401602",
      "Saiwan B.O": "401303",
      "Urse B.O": "401602",
      "Dabheri B.O": "401603",
      "Khuded B.O": "401603",
      "Nyhale Khurdh B.O": "401603",
      "Shiroshi B.O": "401603",
      "Tawa B.O": "401607",
      "Kurze B.O": "401606",
      "Ase B.O": "401604",
      "Chas B.O": "401604",
      "Gomghar B.O": "401604",
      "Khodale B.O": "401604",
      "Nandore B.O": "401405",
      "Kharekuran B.O": "401405",
      "Umrale B.O": "401203",
      "Girgaon B.O": "401606",
      "Salwad B.O": "401504",
      "Kudan B.O": "401502",
      "Edwan B.O": "401102",
      "Pargaon B.O": "401102",
      "Virathan Budruk B.O": "401102",
      "Kelthan B.O": "401204",
      "Chandigaon B.O": "401103",
      "Rajawali B.O": "401208",
      "Satiwali B.O": "401208",
      "Chandansar B.O": "401303",
      "Baliwali B.O": "421303",
      "Gorhe B.O": "421303",
      "Mala B.O": "421303",
      "Moj B.O": "421303",
      "Posheri B.O": "421303",
      "Vilkos B.O": "421303",
      "Vatar B.O": "401301",
      "Girij B.O": "401201",
      "Bategaon B.O": "401501",
      "Navapur B.O": "401501",
      "Sarawali B.O": "401501",
      "Ganjad B.O": "401602",
      "Kainad B.O": "401602",
      "Ranshet B.O": "401602",
      "Sawata B.O": "401602",
      "Dehere B.O": "401603",
      "Kogade B.O": "401603",
      "Nandgaon B.O": "401603",
      "Pathardi B.O": "401603",
      "Sakhare B.O": "401603",
      "Zap B.O": "401603",
      "Talawada B.O": "401607",
      "Veti B.O": "401607",
      "Audhani B.O": "401403",
      "Durves B.O": "401403",
      "Kondhan B.O": "401403",
      "Beriste B.O": "401604",
      "Karegaon B.O": "401604",
      "Khoch B.O": "401604",
      "Udhale B.O": "401604",
      "Kalamb B.O": "401304",
      "Naigaon B.O": "401207",
      "Veur B.O": "401405",
      "Nihe B.O": "401405",
      "Nala B.O": "401203",
      "Dhaniwari B.O": "401606",
      "Dongri B.O": "401606",
      "Udhave B.O": "401606",
      "Ghiwali B.O": "401502",
      "Vengani B.O": "401502",
      "Agarwadi B.O": "401102",
      "Datiware B.O": "401102",
      "Usarani B.O": "401102",
      "Khaniwali B.O": "401204",
      "Gowane B.O": "401103",
      "Sasun Navghar B.O": "401208",
      "Valiv B.O": "401208",
      "Sukhasale B.O": "401605",
      "Bhatane B.O": "401303",
      "Dahisar T V  B.O": "401303",
      "Mandvi B.O": "401303",
      "Dahe B.O": "421303",
      "Malwada B.O": "421303",
      "Maniwali B.O": "421303",
      "Palghar H.O": "401404",
      "Kudus S.O": "421312",
      "Agashi S.O": "401301",
      "Arnala S.O": "401302",
      "Bassein Road S.O": "401202",
      "Dahanu S.O": "401601",
      "Gholvad S.O": "401702",
      "Kasa S.O": "401607",
      "Bordi S.O": "401701",
      "Dahanu Road S.O": "401602",
      "Jawhar S.O": "401603",
      "Manor S.O": "401403",
      "Tarapur App S.O": "401504",
      "Tarapur Ti S.O": "401506",
      "Vangaon S.O": "401103",
      "Vasai Road E S.O": "401202",
      "Virar East S.O": "401305",
      "Kelwa S.O (Thane)": "401401",
      "Kosbad hill S.O": "401703",
      "Nirmal S.O (Thane)": "401304",
      "Papdi S.O": "401207",
      "Satpati S.O": "401405",
      "Sopara S.O": "401203",
      "Umbarpada S.O": "401102",
      "Vasai East IE S.O": "401208",
      "Vikramgad S.O": "401605",
      "Boisar S.O": "401501",
      "Chinchani S.O": "401503",
      "Nallosapare E S.O": "401209",
      "Tarapur S.O (Thane)": "401502",
      "Virar S.O": "401303",
      "Bassein S.O": "401201",
      "Bhayander East S.O": "401105",
      "Dahanu TPS S.O": "401608",
      "Kelwa mahim S.O": "401402",
      "Mokhada S.O": "401604",
      "Talasari S.O": "401606",
      "Wada S.O": "421303"
    },
    "WARDHA": {
      "Nalwadi BO": "442001",
      "Ajansara B.O": "442307",
      "Daroda B.O": "442307",
      "Pohana B.O": "442307",
      "Taroda B.O": "442102",
      "Shekapur Bai B.O": "442307",
      "Yerala B.O": "442307",
      "Arvi Chhoti B.O": "442307",
      "Pipri B.O": "442307",
      "Paunoor B.O": "442001",
      "Talegaon Talatule B.O": "442001",
      "Paloti B.O": "442001",
      "Seloo Kate B.O": "442001",
      "Sukali Bai B.O": "442001",
      "Chincholi Dange B.O": "442201",
      "Khubgaon B.O": "442201",
      "Nandpur B.O": "442201",
      "Nimboli B.O": "442201",
      "Wadhona B.O": "442201",
      "Talegaon(SP) B.O": "442201",
      "Bharaswara B.O": "442202",
      "Sahur B.O": "442202",
      "Agargaon B.O": "442101",
      "Kangaon B.O": "442101",
      "Nagzari B.O": "442101",
      "Padegaon B.O": "442101",
      "Chincholi B.O": "442203",
      "Khandala B.O": "442301",
      "Mangrul Dasoda B.O": "442301",
      "Nandori B.O": "442301",
      "Pardi (Nagaji) B.O": "442301",
      "Washi B.O": "442301",
      "Nara B.O": "442203",
      "Sindi Vihiri B.O": "442203",
      "Kachnoor B.O": "442106",
      "Masod B.O": "442106",
      "Dahegaon Dhande B.O": "442306",
      "Sonora B.O": "442306",
      "Rasulabad B.O": "442302",
      "Sorta B.O": "442302",
      "Pipri Meghe B.O": "442001",
      "Yelakeli B.O": "442001",
      "Zadgaon Gosavi B.O": "442001",
      "Akoli B.O": "442001",
      "Borgaon Meghe B.O": "442001",
      "Dahegaon Gawande B.O": "442001",
      "Salod Hirapur B.O": "442001",
      "Sirasgaon Bazar B.O": "442304",
      "Pardi B.O": "442201",
      "Sarwadi B.O": "442201",
      "Sawali BK B.O": "442201",
      "Takarkheda B.O": "442201",
      "Borgaon Tumni B.O": "442202",
      "Dahegaon Gosavi B.O": "442001",
      "Dahegaon Miskin B.O": "442001",
      "Dattapur B.O": "442001",
      "Dhotra B.O": "442304",
      "Dahegaon Mustafa B.O": "442201",
      "Deorwara B.O": "442201",
      "Jalgaon B.O": "442201",
      "Jamalpur B.O": "442201",
      "Bhidi B.O": "442101",
      "Chikni B.O": "442101",
      "Selsura B.O": "442101",
      "Sonegaon Abaji B.O": "442101",
      "Wabgaon B.O": "442101",
      "Shegaon Kund B.O": "442301",
      "Wagholi B.O": "442301",
      "Dhanoli B.O": "442203",
      "Junapani B.O": "442203",
      "Kakda B.O": "442203",
      "Kandegaon B.O": "442306",
      "Rohani B.O": "442306",
      "Delwadi B.O": "442202",
      "Khadki B.O": "442202",
      "Lahan Arvi B.O": "442202",
      "Tarasawanga B.O": "442202",
      "Wadala B.O": "442202",
      "Gaul B.O": "442101",
      "Giroli B.O": "442101",
      "Khangaon B.O": "442101",
      "Mozari B.O": "442101",
      "Nandora Dafre B.O": "442101",
      "Dongargaon B.O": "442301",
      "Jam B.O": "442301",
      "Kajalsara B.O": "442301",
      "Kandhali B.O": "442301",
      "Sawali Wagh B.O": "442301",
      "Sawali Khurd B.O": "442203",
      "Thanegaon B.O": "442203",
      "Umri B.O": "442203",
      "Dahegaon Gondi B.O": "442106",
      "Malegaon Theka B.O": "442106",
      "Panwadi B.O": "442106",
      "Pimpalkhuta B.O": "442106",
      "Vijaygopal B.O": "442306",
      "Borgaon Hatla B.O": "442302",
      "Dhanodi Bahaddarpur B.O": "442302",
      "Kaotha B.O": "442302",
      "Pipri Pargothan B.O": "442302",
      "Waigaon Nipani B.O": "442001",
      "Waifad B.O": "442001",
      "Anji B.O": "442001",
      "Bhankheda B.O": "442304",
      "Goji B.O": "442304",
      "Bokenagar B.O": "442201",
      "Chistur B.O": "442201",
      "Jasapur B.O": "442201",
      "Neri Mirzapur B.O": "442201",
      "Wardhamaneri B.O": "442201",
      "Antora B.O": "442202",
      "Bhishnoor B.O": "442202",
      "Manikwara B.O": "442202",
      "GOPURI BO": "442001",
      "Andori B.O": "442101",
      "Kapsi B.O": "442101",
      "Pimpalgaon Lute B.O": "442101",
      "Shirpur B.O": "442101",
      "Watkhed B.O": "442101",
      "Bela B.O": "442301",
      "Kora B.O": "442301",
      "Nimbha B.O": "442301",
      "BHOSA BO": "442301",
      "Kajali B.O": "442203",
      "Kannamwargram B.O": "442203",
      "Kasarkheda B.O": "442106",
      "Inzhala B.O": "442306",
      "Rohana B.O": "442302",
      "Virul B.O": "442302",
      "MANDWA BO": "442001",
      "Kelzar B.O": "442104",
      "Khapari B.O": "442104",
      "Kotamba B.O": "442104",
      "Mahabala B.O": "442104",
      "Salaipevath B.O": "442104",
      "Surgaon B.O": "442104",
      "Bothuda B.O": "442102",
      "Hamdapur B.O": "442102",
      "Junona B.O": "442102",
      "Kharangna Gode B.O": "442102",
      "Ghorad B.O": "442104",
      "Hingani B.O": "442104",
      "Juwadi B.O": "442104",
      "Mandgaon B.O": "442102",
      "Waigaon Gond B.O": "442305",
      "Waigaon Haldya B.O": "442305",
      "Bori B.O": "442104",
      "Seldoha B.O": "442104",
      "Kopra B.O": "442102",
      "Girad B.O": "442305",
      "Rehaki Kala B.O": "442104",
      "Sukli Station B.O": "442104",
      "Zadsi B.O": "442104",
      "Madni Karanji B.O": "442102",
      "Wardha H.O": "442001",
      "Cotton Market S.O": "442003",
      "Hindinagar S.O": "442003",
      "Hinganghat S.O": "442301",
      "Indira Market Wardha S.O": "442001",
      "Karanja S.O (Wardha)": "442203",
      "Nachangaon S.O": "442306",
      "Paunar S.O": "442111",
      "Sindi S.O": "442105",
      "Allipur S.O (Wardha)": "442304",
      "Ramnagar Wardha S.O": "442001",
      "Wadner S.O": "442307",
      "Hinganghat Town S.O": "442301",
      "Kharangna S.O": "442106",
      "Manas Mandir Wardha S.O": "442001",
      "Pulgaon S.O": "442302",
      "Seloo S.O": "442104",
      "Wardha Market S.O": "442001",
      "YAC Wardha S.O": "442001",
      "Sawangi Meghe SO": "442107",
      "Arvi S.O (Wardha)": "442201",
      "Ashti S.O (Wardha)": "442202",
      "Deoli S.O (Wardha)": "442101",
      "MGIHU S.O": "442001",
      "Pulgaon Camp S.O": "442303",
      "Samudrapur S.O": "442305",
      "Sewagram S.O": "442102"
    },
    "KOLHAPUR": {
      "Navkud B.O": "416506",
      "Dindnerli B.O": "416207",
      "Kavane B.O": "416207",
      "Mhalunge B.O": "416207",
      "Nandgaon B.O": "416230",
      "Shivdav B.O": "416210",
      "Gorambe B.O": "416216",
      "Karnur B.O": "416216",
      "Kenavade B.O": "416216",
      "Vandur B.O": "416216",
      "Vhannur B.O": "416216",
      "Kasari B.O": "416218",
      "Madyal B.O": "416218",
      "Mugali B.O": "416551",
      "Arjunwad B.O": "416120",
      "Danwad B.O": "416107",
      "Chandur B.O": "416138",
      "Rui B.O": "416138",
      "Majale B.O": "416109",
      "Savarde B.O": "416109",
      "Manawale B.O": "416209",
      "Mangnoor B.O": "416209",
      "Pimpalgaon B.O": "416209",
      "Shengaon B.O": "416209",
      "Basarge BK B.O": "416506",
      "Hasur Sasgiri B.O": "416506",
      "Terni B.O": "416506",
      "DARYACHE VADGAON": "416207",
      "Anap Khurd B.O": "416210",
      "Mhasrang B.O": "416210",
      "Patgaon B.O": "416210",
      "Vengrul B.O": "416210",
      "Mhakave B.O": "416216",
      "Belewadi Kalamma B.O": "416218",
      "Hasur Khurd B.O": "416218",
      "Tamnakwada B.O": "416218",
      "Basarge B.O": "416507",
      "Shiradwad B.O": "416143",
      "Chipri B.O": "416101",
      "Tamadalage B.O": "416101",
      "Umalwad B.O": "416101",
      "Male B.O": "416118",
      "Savarde T/F Satave B.O": "416114",
      "Kavathesar B.O": "416111",
      "Rajapur B.O": "416106",
      "Aurwad B.O": "416104",
      "Bubnal B.O": "416104",
      "Kanwad B.O": "416103",
      "Shirti B.O": "416103",
      "Buvache Vathar B.O": "416112",
      "Ghunki B.O": "416112",
      "Karanjphen B.O": "416230",
      "Khupire B.O": "416205",
      "Kolik B.O": "416205",
      "Panutre B.O": "416205",
      "Bachani B.O": "416221",
      "Kurukali B.O": "416001",
      "Mhalsavade B.O": "416001",
      "Bandiwade B.O": "416230",
      "Pal B.O": "416209",
      "Palshivane B.O": "416209",
      "Sonarwadi B.O": "416209",
      "Tikkewadi B.O": "416209",
      "Waghapur B.O": "416209",
      "Bugadikatti B.O": "416506",
      "Kawlikatti B.O": "416506",
      "Manwad B.O": "416506",
      "Nandanwad B.O": "416506",
      "Narewadi B.O": "416506",
      "Randivewadi B.O": "416203",
      "Rendal B.O": "416203",
      "Adoli B.O": "416210",
      "Kondoshi B.O": "416210",
      "Mathgaon B.O": "416210",
      "Navale B.O": "416210",
      "Tambale B.O": "416210",
      "Tambyachiwadi B.O": "416210",
      "Vesarde B.O": "416210",
      "Mouje Sangaon B.O": "416216",
      "Pimpalgaon KH B.O": "416216",
      "Sulkud B.O": "416216",
      "Baleghol B.O": "416218",
      "Khochi B.O": "416110",
      "Ghosarwad B.O": "416107",
      "Tilwani B.O": "416138",
      "Alate B.O": "416109",
      "Akiwat B.O": "416106",
      "Bastwad B.O": "416106",
      "Herwad B.O": "416106",
      "Manjarewadi B.O": "416106",
      "Yadrav B.O": "416146",
      "Jambhali B.O": "416121",
      "Shirdhon B.O": "416121",
      "Takawade B.O": "416121",
      "Ghalwad B.O": "416103",
      "Khidrapur B.O": "416108",
      "Latwade B.O": "416112",
      "Vathar T/F vadgaon B.O": "416112",
      "Panori B.O": "416231",
      "Uchgaon B.O": "416005",
      "Majgaon B.O": "416205",
      "Mhasurli B.O": "416205",
      "Pat Panhala B.O": "416205",
      "Pisatri B.O": "416205",
      "Pohale T/F Borgaon B.O": "416205",
      "Punal B.O": "416205",
      "Sadoli Khalsa B.O": "416001",
      "Savarde Dumala B.O": "416001",
      "Chinchwad B.O": "416119",
      "Kavatheguland B.O": "416105",
      "Shedshal B.O": "416105",
      "Lat B.O": "416143",
      "Rangoli B.O": "416143",
      "Danoli B.O": "416101",
      "Jaisingpur R.S. B.O": "416101",
      "Kothali B.O": "416001",
      "Nimshirgaon B.O": "416101",
      "Arale B.O": "416114",
      "Kakhe B.O": "416114",
      "Mohare B.O": "416114",
      "Dharangutti B.O": "416102",
      "Haroli B.O": "416102",
      "Kutwad B.O": "416103",
      "Rajapurwadi B.O": "416108",
      "Takaliwadi B.O": "416108",
      "Ambap B.O": "416112",
      "Bhadole B.O": "416112",
      "Bhendwade B.O": "416112",
      "Chavare B.O": "416112",
      "June Pargaon B.O": "416113",
      "Nave Pargaon B.O": "416113",
      "Herla B.O": "416005",
      "Bajar Bhogaon B.O": "416205",
      "Dhundwade B.O": "416205",
      "Kasba Thane B.O": "416205",
      "Kisrul B.O": "416205",
      "Malapude B.O": "416205",
      "Sule B.O": "416503",
      "Yavluj B.O": "416205",
      "Ghanavade B.O": "416001",
      "Haldi B.O": "416001",
      "Hasur Dumala B.O": "416001",
      "Nadhavade B.O": "416209",
      "Phanaswadi B.O": "416209",
      "Kadalage B.O": "416506",
      "Yenechavandi B.O": "416506",
      "Chuye B.O": "416207",
      "Nigave Khalasa B.O": "416207",
      "Sheloli B.O": "416210",
      "Kasaba Sangaon B.O": "416216",
      "Lingnur Dumala B.O": "416216",
      "Bolavi B.O": "416218",
      "Kardyal B.O": "416218",
      "Vadgaon B.O": "416218",
      "Dholgarwadi B.O": "416507",
      "Narande B.O": "416110",
      "Nej B.O": "416110",
      "Sajani B.O": "416138",
      "Korochi B.O": "416109",
      "Minche B.O": "416109",
      "Udgaon B.O": "416101",
      "Sambhajipur BO": "416101",
      "Satave B.O": "416114",
      "Terwad B.O": "416106",
      "Alas B.O": "416104",
      "Shahapur B.O": "416121",
      "Tardal B.O": "416121",
      "Hasur B.O": "416103",
      "Kini B.O": "416112",
      "Manapadale B.O": "416112",
      "Talasande B.O": "416112",
      "Jakhale B.O": "416113",
      "Kate Bhogaon B.O": "416205",
      "Padal B.O": "416205",
      "Parkhandale B.O": "416213",
      "Vetawade B.O": "416205",
      "Are B.O": "416001",
      "Malyachi Shiroli B.O": "416001",
      "Borgaon B.O": "416230",
      "Tudiye B.O": "416507",
      "Ainapur B.O": "416526",
      "Hosur B.O": "416508",
      "Kalkundri B.O": "416508",
      "Rajagoli KH B.O": "416508",
      "Koparde B.O": "416204",
      "Kowade B.O": "416503",
      "Maligre B.O": "416503",
      "Sarambalwadi B.O": "416503",
      "Gajapur B.O": "415101",
      "Karungale B.O": "415101",
      "Parali Ninai B.O": "415101",
      "Warul B.O": "415101",
      "Yelvan Jugai B.O": "415101",
      "Perid BO": "415101",
      "Minche BK B.O": "416223",
      "Jatharwadi B.O": "416122",
      "P. Shiroli B.O": "416122",
      "Tasgaon B.O": "416122",
      "Malage BK B.O": "416219",
      "Arjunwadi B.O": "416504",
      "Nangnoor B.O": "416551",
      "Halsawade B.O": "416202",
      "Sangavade B.O": "416202",
      "Chokak B.O": "416118",
      "Mangaon B.O": "416507",
      "Arjuni B.O": "416235",
      "Bhedasgaon B.O": "416214",
      "Shirale T/Ff Warun B.O": "416214",
      "Sondoli B.O": "416214",
      "Ambarde B.O": "416215",
      "Molawade B.O": "416215",
      "Shirala B.O": "416215",
      "Ekondi B.O": "416232",
      "Shendur B.O": "416232",
      "Aralgundi B.O": "416220",
      "Dhamane B.O": "416220",
      "Honyali B.O": "416220",
      "Mahagond B.O": "416220",
      "Zulpewadi B.O": "416220",
      "Vhanali B.O": "416221",
      "Walwa KH B.O": "416221",
      "Hiralge B.O": "416526",
      "Dukkarwadi B.O": "416507",
      "Hajgoli B.O": "416507",
      "Jangamhatti B.O": "416507",
      "Kanur Khurd B.O": "416507",
      "Mhalunge Khalsa B.O": "416507",
      "Shivanage Lakkikatte B.O": "416507",
      "Sundi B.O": "416507",
      "Ningudage B.O": "416526",
      "Sangrul B.O": "416204",
      "Wakare B.O": "416204",
      "Malatwadi B.O": "416508",
      "Nittur B.O": "416508",
      "Amshi Dumala B.O": "416204",
      "Bhamate B.O": "416204",
      "Batkangale B.O": "416503",
      "Hebbal Jaldyal B.O": "416503",
      "Kanoli B.O": "416503",
      "Kolindre B.O": "416503",
      "Nilpan B.O": "416223",
      "Top B.O": "416122",
      "Nidhori B.O": "416219",
      "Savarde BK B.O": "416219",
      "Sonali B.O": "416219",
      "Yamage B.O": "416219",
      "Kanadewadi B.O": "416504",
      "Kine B.O": "416504",
      "Sambre B.O": "416504",
      "Shippur T/F Nesari B.O": "416504",
      "Atigre B.O": "416118",
      "Bastavade B.O": "416235",
      "Hamidwada B.O": "416235",
      "Khadakewada B.O": "416235",
      "Koulage B.O": "416235",
      "Pimpalgaon BK B.O": "416235",
      "Sonage B.O": "416235",
      "Tekoli B.O": "416215",
      "Ukoli B.O": "416215",
      "Ardal B.O": "416220",
      "Bahirewadi B.O": "416220",
      "Belawale BK B.O": "416221",
      "Khebavade B.O": "416221",
      "Karambali B.O": "416526",
      "Kudnur B.O": "416508",
      "Mhalewadi B.O": "416508",
      "Mungurwadi B.O": "416503",
      "Man B.O": "415101",
      "Shirgaon B.O": "416211",
      "Vishalgad Amba B.O": "415101",
      "Bhativade B.O": "416223",
      "Hedawade B.O": "416223",
      "Jarali B.O": "416551",
      "Khandal B.O": "416551",
      "Ambavade B.O": "416201",
      "Rakshi B.O": "416201",
      "Vasagade B.O": "416202",
      "Anur B.O": "416235",
      "Kotoli (Warna) B.O": "416214",
      "Rethare B.O": "416214",
      "Shimpe B.O": "416214",
      "Ukhalu B.O": "416214",
      "Virale B.O": "416214",
      "Bamani B.O": "416232",
      "Chimane B.O": "416220",
      "Mumewadi B.O": "416220",
      "Shipur T/F Ajara B.O": "416220",
      "Shinoli KH B.O": "416507",
      "Surute B.O": "416507",
      "Turkewadi B.O": "416507",
      "Kini(CHD) B.O": "416508",
      "Teurwadi B.O": "416508",
      "Khatangale B.O": "416204",
      "Lakudwadi B.O": "416503",
      "Mangnoor T/F Sawantwadi B.O": "416503",
      "Chandoli B.O": "415101",
      "Kadave B.O": "415101",
      "Kolwan B.O": "416223",
      "Minche KH B.O": "416223",
      "Kaneri B.O": "416234",
      "Nerli B.O": "416234",
      "Nagaon B.O": "416122",
      "Shiye B.O": "416122",
      "Karanjivane B.O": "416219",
      "Mouje Haladi B.O": "416219",
      "Hadalage B.O": "416504",
      "Watangi B.O": "416504",
      "Ingali B.O": "416202",
      "Banage B.O": "416235",
      "Chikhali B.O": "416229",
      "Surupali B.O": "416235",
      "Akurle B.O": "416214",
      "Kapshi B.O": "416214",
      "Shittur T/F Warun B.O": "416214",
      "Arul B.O": "416215",
      "Panundre B.O": "416215",
      "Shankarwadi B.O": "416232",
      "Halewadi B.O": "416220",
      "Masewadi B.O": "416220",
      "Sake B.O": "416221",
      "Ghotavade B.O": "416230",
      "Kaneri (Panhala) B.O": "416230",
      "Kololi B.O": "416230",
      "Gudal B.O": "416211",
      "Kaulav B.O": "416211",
      "Kodavade B.O": "416211",
      "Shirse B.O": "416211",
      "Phejiwade B.O": "416212",
      "Rhe Works B.O": "416212",
      "Sarawade B.O": "416212",
      "Savarde Patankar B.O": "416212",
      "Kandgaon B.O": "416011",
      "Washi B.O": "416011",
      "Talandage B.O": "416236",
      "Yalgud B.O": "416236",
      "Kasar Kandgaon B.O": "416505",
      "Kitawade B.O": "416505",
      "Madilage B.O": "416505",
      "Pernoli B.O": "416505",
      "Bhuye B.O": "416229",
      "Dewale B.O": "416213",
      "Pishavi B.O": "416213",
      "Mudhal B.O": "416208",
      "Talashi B.O": "416208",
      "Thikpurli B.O": "416208",
      "Titave B.O": "416208",
      "Hindgaon B.O": "416509",
      "Nandavade B.O": "416509",
      "Satavane B.O": "416509",
      "Umgaon B.O": "416509",
      "Hanimnal B.O": "416501",
      "Hasur Champu B.O": "416501",
      "Hebbal B.O": "416501",
      "Bhadgaon B.O": "416502",
      "Channe Kuppi B.O": "416502",
      "Sangashi B.O": "416206",
      "Tirpan B.O": "416230",
      "Awali BK B.O": "416211",
      "Dhamod B.O": "416211",
      "Durgamanwad B.O": "416211",
      "Piral B.O": "416211",
      "Tarsambale B.O": "416211",
      "Hanmantwadi B.O": "416010",
      "Padali Khurd B.O": "416010",
      "Pachgaon B.O": "416013",
      "Kasarwada B.O": "416212",
      "Padali B.O": "416212",
      "Shiroli (Sonyachi) B.O": "416212",
      "Bahireshwar B.O": "416011",
      "Beed B.O": "416011",
      "Bhadvan B.O": "416505",
      "Hativade B.O": "416505",
      "Sohale B.O": "416505",
      "Kerle B.O": "416229",
      "Nigave Dumala B.O": "416229",
      "Charan B.O": "416213",
      "Gogave B.O": "416213",
      "Shittur Turf Malkapur B.O": "416213",
      "Thergaon B.O": "416213",
      "Baradwadi B.O": "416208",
      "Adkur B.O": "416509",
      "Amroli B.O": "416509",
      "Hera B.O": "416509",
      "Naganwadi B.O": "416509",
      "Patne B.O": "416552",
      "Hitni B.O": "416501",
      "Badyachiwadi B.O": "416502",
      "Inchnal B.O": "416502",
      "Kadgaon Gadhinglaj B.O": "416502",
      "Mandukali B.O": "416206",
      "Shenawade B.O": "416206",
      "Gadmudshingi B.O": "416119",
      "Barve B.O": "416209",
      "Rashivade B.O": "416211",
      "Balinge B.O": "416010",
      "Girgaon B.O": "416013",
      "Akanur B.O": "416212",
      "Yerandol B.O": "416505",
      "Porle Turf Thane B.O": "416229",
      "Vadange B.O": "416229",
      "Varange Padali B.O": "416229",
      "Wadi Ratnagiri B.O": "416229",
      "Awali B.O": "416213",
      "Borivade B.O": "416213",
      "Borpadale B.O": "416213",
      "Salshi B.O": "416213",
      "Undarwadi B.O": "416208",
      "Ibrahimpur B.O": "416509",
      "Isapur B.O": "416509",
      "Keravade B.O": "416509",
      "Ambewadi B.O": "416552",
      "Date B.O": "416552",
      "Halkarni (Chandgad) B.O": "416552",
      "Nilji B.O": "416501",
      "Gajargaon B.O": "416502",
      "Gijawane B.O": "416502",
      "Vadarage Majare B.O": "416502",
      "Asandoli B.O": "416206",
      "Aslaj B.O": "416206",
      "Borbet B.O": "416206",
      "Gariwade B.O": "416206",
      "Karadwadi B.O": "416209",
      "Koor B.O": "416209",
      "Tisangi B.O": "416206",
      "Valivade B.O": "416119",
      "Gangapur B.O": "416209",
      "Kalnakwadi B.O": "416209",
      "Waghave B.O": "416230",
      "Awali KH B.O": "416211",
      "Pungaon B.O": "416211",
      "Tarale B.O": "416211",
      "Koge B.O": "416010",
      "Shingnapur B.O": "416010",
      "Dajipur B.O": "416212",
      "Nartavade B.O": "416212",
      "Solankur B.O": "416212",
      "Ujalaiwadi B.O": "416004",
      "Gavase B.O": "416509",
      "Vite B.O": "416505",
      "Kerli B.O": "416229",
      "Pohale Turf Alate B.O": "416229",
      "Bhadale B.O": "416213",
      "Save B.O": "416213",
      "Supatre B.O": "416213",
      "Arjunwada B.O": "416208",
      "Boravade B.O": "416208",
      "Turambe B.O": "416208",
      "Kurani Buzawade B.O": "416509",
      "Nagave B.O": "416509",
      "Mutnal B.O": "416501",
      "Atyal B.O": "416502",
      "Harali BK B.O": "416502",
      "Katali B.O": "416206",
      "Salvan B.O": "416206",
      "Madilage BK B.O": "416209",
      "Kolhapur H.O": "416003",
      "Ichalkaranji H.O": "416115",
      "Kolhapur City H.O": "416012",
      "Shukrawar Peth S.O (Kolhapur)": "416002",
      "Ambewadi S.O (Kolhapur)": "416229",
      "Ruikar Colony S.O": "416005",
      "Sane Guruji Vasahat S.O": "416011",
      "Shaniwar Peth S.O (Kolhapur)": "416002",
      "Shivaji University S.O": "416004",
      "5 Star MIDC Kagal S.O": "416236",
      "Ajara S.O": "416505",
      "Shivaji Veedyapeeth Marg S.O": "416008",
      "Chandgad S.O": "416509",
      "DSF Halkarni S.O": "416552",
      "Shahupuri S.O": "416001",
      "Shivaji Peth S.O": "416012",
      "Bambavada S.O": "416213",
      "Bidri S.O": "416208",
      "Dundage S.O": "416501",
      "Gadhinglaj Tilakpath S.O": "416502",
      "Gandhinagar S.O (Kolhapur)": "416119",
      "Gargoti S.O": "416209",
      "Kapshi S.O": "416218",
      "Karve S.O": "416507",
      "Kasba Bavada S.O": "416006",
      "Kuditre S.O": "416204",
      "Mahagaon (Kolhapur) S.O": "416503",
      "Murgud S.O": "416219",
      "Panhala S.O": "416201",
      "Rukadi S.O": "416118",
      "Tillarinagar S.O": "416527",
      "Uttur S.O": "416220",
      "Halkarni S.O": "416506",
      "Hupari S.O": "416203",
      "Koulage S.O": "416526",
      "Malkapur S.O (Kolhapur)": "415101",
      "Nool S.O": "416551",
      "Pattankodoli S.O": "416202",
      "Gadhinglaj Shivaji Chowk S.O": "416502",
      "Ispurli S.O": "416207",
      "Mhasve S.O": "416223",
      "Nesari S.O": "416504",
      "Sidhnerli S.O": "416232",
      "Walwa Bk S.O": "416221",
      "Sarud S.O": "416214",
      "R K Nagar Ichalkaranji S.O": "416121",
      "Shivajinagar Ichalkaranji S.O": "416115",
      "Udyog Nagar Ichalkaranji S.O": "416115",
      "Warnanagar S.O": "416113",
      "Tatyasaheb Kore Nagar SO": "416113",
      "Kolhapur RS S.O": "416001",
      "Mangalwar Peth S.O (Kolhapur)": "416012",
      "Radhanagari S.O": "416212",
      "Rankala S.O": "416012",
      "Hatkalangada S.O": "416109",
      "ICO Spinning Mills S.O": "416143",
      "Kapadmarket Ichalkaranji S.O": "416115",
      "Kumbhoj S.O": "416111",
      "Nandani S.O": "416102",
      "Takali S.O": "416108",
      "Gur Market Yard S.O": "416005",
      "Kalamba S.O": "416007",
      "Kale S.O (Kolhapur)": "416205",
      "Phulewadi S.O": "416010",
      "Pratibhanagar S.O": "416008",
      "Gadhinglaj S.O": "416502",
      "Gaganbavada S.O": "416206",
      "Kadgaon Gargoti S.O": "416210",
      "Kagal S.O": "416216",
      "Kowad S.O": "416508",
      "MIDC Gokul Shirgaon S.O": "416234",
      "MIDC Shiroli S.O": "416122",
      "Sadashivnagar S.O": "416235",
      "Shahuwadi S.O": "416215",
      "Kodoli S.O": "416114",
      "Kurundwad S.O": "416106",
      "Vadgaon S.O (Kolhapur)": "416112",
      "Kabnur SO": "416138",
      "Bhendegalli S.O": "416002",
      "Kotoli S.O": "416230",
      "Laxmipuri S.O": "416002",
      "R K Nagar S.O (Kolhapur)": "416013",
      "Dattawad S.O": "416107",
      "Akiwate Industrial Estate S.O": "416144",
      "Ganganagar Ichalkaranji S.O": "416116",
      "Bahubali S.O": "416110",
      "Dattanagar S.O": "416120",
      "Jawaharnagar Ichalkaranji S.O": "416115",
      "Jaysingpur S.O": "416101",
      "Narsobawadi S.O": "416104",
      "Parvati Industrial Estate S.O": "416146",
      "Shirol S.O": "416103",
      "Babujamal S.O": "416012",
      "Dudhganganagar S.O": "416231",
      "Parite S.O": "416211",
      "Rajarampuri S.O": "416008",
      "Ganeshwadi S.O (Kolhapur)": "416105"
    },
    "MUMBAI": {
      "Elephanta Caves Po BO": "400021",
      "Dadar H.O": "400014",
      "Mumbai GPO": "400001",
      "Mumbai Central H.O": "400008",
      "Kalbadevi H.O": "400002",
      "Mahim H.O": "400016",
      "J.J.Hospital S.O": "400008",
      "Jacob Circle S.O": "400011",
      "Kamathipura S.O": "400008",
      "Malabar Hill S.O": "400006",
      "Central Building SO": "400020",
      "Colaba Bazar SO": "400005",
      "MPT SO": "400001",
      "Grant Road S.O": "400007",
      "Haji Ali S.O": "400034",
      "S V Marg S.O": "400007",
      "Tardeo S.O": "400007",
      "Tulsiwadi S.O": "400034",
      "BPC  Jacob Circle S.O": "400011",
      "Asvini SO": "400005",
      "Churchgate SO": "400020",
      "Holiday Camp SO": "400005",
      "Nariman Point SO": "400021",
      "New Yogakshema SO": "400021",
      "Stock Exchange SO": "400001",
      "Town Hall SO Mumbai": "400001",
      "M A Marg S.O": "400008",
      "N.S.Patkar Marg S.O": "400007",
      "Rajbhavan S.O (Mumbai)": "400035",
      "Tajmahal SO": "400001",
      "Charni Road S.O": "400004",
      "Chaupati S.O": "400004",
      "Bhawani Shankar Rd S.O": "400028",
      "Dharavi Road S.O": "400017",
      "Mori Road S.O": "400016",
      "New Prabhadevi Road S.O": "400025",
      "Prabhadevi S.O": "400025",
      "Ranade Road S.O": "400028",
      "Shivaji Park S.O (Mumbai)": "400028",
      "Worli S.O": "400018",
      "Bharat Nagar S.O (Mumbai)": "400007",
      "Chinchpokli S.O": "400011",
      "Dr Deshmukh Marg S.O": "400026",
      "Gowalia Tank S.O": "400026",
      "Haines Road S.O": "400011",
      "Bazargate SO": "400001",
      "Colaba SO": "400005",
      "High Court Building SO Mumbai": "400032",
      "Mantralaya SO Mumbai": "400032",
      "Secretariate SO": "400032",
      "VWTC SO": "400005",
      "Girgaon S.O": "400004",
      "Madhavbaug S.O": "400004",
      "Marine Lines S.O": "400020",
      "Bhawani Shankar S.O": "400028",
      "Century Mill S.O": "400030",
      "Dharavi S.O": "400017",
      "Mahim East S.O": "400016",
      "Worli Colony S.O": "400030",
      "Worli Naka S.O": "400018",
      "Cumballa Hill S.O": "400026",
      "Opera House S.O": "400004",
      "S. C. Court S.O": "400002",
      "Thakurdwar S.O": "400002",
      "Kapad Bazar S.O": "400016",
      "S V S Marg S.O": "400028",
      "Worli Sea Face S.O": "400030",
      "Cumballa Sea Face S.O": "400026",
      "Falkland Road S.O": "400008",
      "Delisle Road S.O": "400013",
      "Gokhale Road S.O (Mumbai)": "400028",
      "Mahim Bazar S.O": "400016",
      "Worli Police Camp S.O": "400030",
      "Agripada S.O": "400011",
      "Sion SO": "400022",
      "Transit Camp SO": "400022",
      "BEST STaff Quarters S.O": "400012",
      "Cotton Exchange S.O": "400033",
      "Mandvi S.O (Mumbai)": "400003",
      "Null Bazar S.O": "400003",
      "V J B Udyan S.O": "400027",
      "C G S Colony S.O": "400037",
      "Dadar Colony S.O": "400014",
      "Naigaon S.O (Mumbai)": "400014",
      "Wadala S.O": "400031",
      "Wadala Truck Terminal S.O": "400037",
      "CHINCHBUNDER S.O": "400009",
      "Chamarbaug S.O": "400012",
      "Dockyard Road S.O": "400010",
      "Masjid S.O": "400003",
      "Mazgaon Dock S.O": "400010",
      "Parel Rly Work Shop S.O": "400012",
      "Princess Dock S.O": "400009",
      "V K Bhavan S.O": "400010",
      "B P T Colony S.O": "400037",
      "Kidwai Nagar S.O (Mumbai)": "400031",
      "Chunabhatti SO": "400022",
      "Matunga SO": "400019",
      "Antop Hill S.O": "400037",
      "Haffkin Institute S.O": "400012",
      "Wadala Rs S.O": "400031",
      "Ambewadi S.O (Mumbai)": "400004",
      "Noor Baug S.O": "400009",
      "Parel S.O": "400012",
      "Raoli Camp SO": "400022",
      "B.P.Lane S.O": "400003",
      "Kalachowki S.O": "400033",
      "L B S N E collage S.O": "400033",
      "Lal Baug S.O": "400012",
      "Mazgaon Road S.O": "400010",
      "Reay Road S.O": "400033",
      "Sewri S.O": "400015",
      "Tank Road S.O": "400033",
      "Parel Naka S.O": "400012"
    },
    "BEED": {
      "Gangamasla B.O": "431131",
      "Mangrul B.O": "431131",
      "Nithrud B.O": "431131",
      "Sadola B.O": "431131",
      "Sonnathadi B.O": "431131",
      "Chakarwadi B.O": "431125",
      "Kalsambar B.O": "431125",
      "Dharmapuri B.O": "431515",
      "Dhangarjawalka B.O": "414204",
      "Rohatwadi B.O": "414204",
      "Tambarajuri B.O": "414204",
      "Pangri B.O": "431530",
      "Dongar Patoda B.O": "414205",
      "Pargaon Shiras B.O": "414205",
      "Rakshas Bhuwan Tamba B.O": "413249",
      "Yellamb Bhrahmanath B.O": "413249",
      "Harkinnimgaon B.O": "431129",
      "Rajegaon B.O": "431129",
      "Warola B.O": "431129",
      "Deo Pimpri B.O": "431130",
      "Gulaj B.O": "431130",
      "Tintarwani B.O": "431130",
      "Belamba B.O": "431530",
      "Kauthali B.O": "431530",
      "Chichala B.O": "431144",
      "Harichanra Pimpri B.O": "431144",
      "Manjrath B.O": "431131",
      "Pathrood B.O": "431131",
      "Purshottampuri B.O": "431131",
      "Rajewadi B.O": "431131",
      "Kanherwadi B.O": "431515",
      "Khodwa Sawargaon B.O": "431515",
      "Mandva B.O": "431515",
      "Mirwat B.O": "431515",
      "Pachangri B.O": "414204",
      "Pargaon Ghumra B.O": "414204",
      "Belura B.O": "431128",
      "Khalapuri B.O": "414205",
      "Khokarmoha B.O": "414205",
      "Arvi B.O": "413249",
      "Bhendtakli B.O": "431129",
      "Hiwara B.O": "414202",
      "Ardha Pimpri B.O": "431130",
      "Bangali Pimpla B.O": "431130",
      "Borgaon BK B.O": "431130",
      "Pimpalgoan Gadhe B.O": "431530",
      "Chardari B.O": "431124",
      "Kuppa B.O": "431144",
      "Pahadi Pargaon B.O": "431124",
      "Anandgaon B.O": "431131",
      "Yellambghat B.O": "431125",
      "Nandagaul B. O.": "431515",
      "Domri B.O": "414204",
      "Muggaon B.O": "414204",
      "Therla B.O": "414204",
      "Vaidyakinhi B.O": "414204",
      "Waghira B.O": "414204",
      "Dongarkinhi B.O": "413229",
      "Naigaon B.O": "431518",
      "Raimoha B.O": "414205",
      "Ghatshilpargaon B.O": "413249",
      "Gomalwada B.O": "413249",
      "Loni B.O": "414202",
      "Manur B.O": "413249",
      "Rui B.O": "431129",
      "Takarwan B.O": "431129",
      "Waghora B.O": "431129",
      "Khalegaon B.O": "431130",
      "Malegaon KHD B.O": "431130",
      "Mategoan B.O": "431130",
      "Matori B.O": "431130",
      "Rakashasbhuwan Shani B.O": "431130",
      "Tokwadi B.O": "431530",
      "Pimparkhed B.O": "431144",
      "Upali B.O": "431144",
      "Badibadi B.O": "431131",
      "Laul B.O": "431131",
      "Sandas Chincholi B.O": "431131",
      "Telgoan B.O": "431131",
      "Manjarsumba B.O": "431125",
      "Dadahari Wadgaon B.O": "431515",
      "Halam B.O": "431515",
      "Bensur B.O": "414204",
      "Daskhed B.O": "414204",
      "Parner B.O": "414204",
      "Sautada B.O": "414204",
      "Jatnandur B.O": "413229",
      "Karegaon B.O": "413229",
      "Pimpalgaon Dhas B.O": "413229",
      "Murshadpur B.O": "414205",
      "Nirgudi B.O": "414205",
      "Sakshal Pimpri B.O": "414205",
      "Padali B.O": "413249",
      "Warni B.O": "413249",
      "Rampuri B.O": "431129",
      "Shirasdevi B.O": "431129",
      "Wahegaon Amla B.O": "431129",
      "Chaklamba B.O": "431130",
      "Ghogas Pargaon B.O": "431130",
      "Nimgaon Mayamba B.O": "431130",
      "Shekta B.O": "431130",
      "Nagapur B.O": "431530",
      "Devala B.O": "431144",
      "Ghatsawali B.O": "431144",
      "Kuslamb B.O": "413207",
      "Pimpalner B.O": "431153",
      "Sawargaon Ghat B.O": "413207",
      "Adas B.O": "431517",
      "Apegaon B.O": "431517",
      "Hatola B.O": "431517",
      "Hoal B.O": "431517",
      "Somnath Borgaon B.O": "431517",
      "Yelda B.O": "431517",
      "Patoda B.O.": "431523",
      "Radi B.O": "431523",
      "Jogeswari Pargaon B.O": "414203",
      "Matkuli B.O": "414203",
      "Nagtala B.O": "414203",
      "Patsara B.O": "414203",
      "Sawargaon B.O": "414203",
      "Sawaleswar Paithan B.O": "431518",
      "Kurla B.O": "431153",
      "Shivni B.O": "431153",
      "Mahalas Jawala B.O": "431153",
      "Nalwandi B.O": "431153",
      "Palwan B.O": "431153",
      "Anjanwati B.O": "431126",
      "Borkhed B.O": "431126",
      "Hingni BK B.O": "431128",
      "Limbaganesh B.O": "431126",
      "Naholi B.O": "431126",
      "Moha B.O": "431128",
      "Antarwali BK B.O": "431127",
      "Bagpimpalgoan B.O": "431127",
      "Bhogalgaon B.O": "431127",
      "Reoki B.O": "431127",
      "Dhamangaon B.O": "414202",
      "Dhanora B.O": "414202",
      "Dongargan B.O": "414202",
      "Ghatapimpri B.O": "414202",
      "Kuntephal Pundi B.O": "414202",
      "Saratewadgoan B.O": "414202",
      "Suleman Deola B.O": "414202",
      "Khilad B.O": "414208",
      "Shiral B.O": "414208",
      "Lahuri B.O": "431123",
      "Malegaon B.O": "431123",
      "Mangwadgaon B.O": "431123",
      "Massajog B.O": "431123",
      "Salegaon B.O": "431123",
      "Shindi B.O": "431123",
      "Kittiadgaon B.O": "431142",
      "Phulepimpalgoan B.O": "431142",
      "Anjandoha B.O": "431124",
      "Asardoha B.O": "431124",
      "Bhogalwadi B.O": "431124",
      "Chikhalbeed B. O.": "431144",
      "Kari B.O": "431124",
      "Adgaon B. O.": "431153",
      "Jawalgaon B.O": "431517",
      "Ladewadgaon B.O": "431517",
      "Lokhandi Sawargaon B.O": "431517",
      "Deola B.O": "431523",
      "Dhanora  BO": "431523",
      "Ashta Harinarayan B.O": "414203",
      "Bhalwani B.O": "414203",
      "Brahmagaon B.O": "414203",
      "Doithan B.O": "414203",
      "Tadsonna B.O": "431153",
      "Chartha B.O": "431153",
      "Pimpalwadi B.O": "431153",
      "Morgaon B.O": "431126",
      "Pimpalgaon Ghat B.O": "431126",
      "Shirurghat B.O": "431126",
      "Waghebabhulgaon B.O": "431126",
      "Mohkhed B.O": "431128",
      "Pimpri BK B.O": "431128",
      "Pattiwadgaon B.O": "431519",
      "Poos B.O": "431519",
      "Salunkwadi B.O": "431519",
      "Hirapur B.O": "431143",
      "Kolgaon B.O": "431143",
      "Madalmohi B.O": "431143",
      "Padalsingi B.O": "431143",
      "Ambhora B.O": "414202",
      "Takli Amiya B.O": "414202",
      "Wadgaon Daula B.O": "414202",
      "Kelsangvi B.O": "414208",
      "Chandan Sawargaon B.O": "431123",
      "CHINCHOLI MALI B O": "431123",
      "Dahiphal Wadmauli B.O": "431123",
      "Deogaon B.O": "431123",
      "Kalamamba B.O": "431123",
      "Tambwa B.O": "431123",
      "Vida B.O": "431123",
      "Warapgoan B.O": "431123",
      "Kotan B.O": "413207",
      "Bardapur B.O": "431517",
      "Dongar Pimpla B.O": "431517",
      "Pimpla Dhaiguda B.O": "431517",
      "Sonwala B.O": "431517",
      "Yusuf Wadgaon B.O": "431517",
      "Suggaon B.O": "431523",
      "Jamgoan B.O": "414203",
      "Khadkat B.O": "414203",
      "Welturi B.O": "414203",
      "Borisawargaon B.O": "431518",
      "Jawalban B. O.": "431518",
      "Mauj B.O": "431153",
      "Pali B.O": "431153",
      "Kawadgaon B.O": "431153",
      "Malapuri B.O": "431153",
      "Antharwan Pimpri B.O": "431153",
      "Nathapur B.O": "431153",
      "Devi Babhulgoan B.O": "431126",
      "Khadkighat B.O": "431126",
      "Lonighat B.O": "431126",
      "Nandurghat B.O": "431126",
      "Goverdhan Hiwara B.O": "431128",
      "Sirsala B.O": "431128",
      "Umri B.O": "431128",
      "Daithan B.O": "431127",
      "Jategaon B.O": "431127",
      "Raj Pimpri B.O": "431127",
      "Talnewadi B.O": "431127",
      "Girwali B.O": "431519",
      "Ujani B.O": "431519",
      "Ranjani B.O": "431143",
      "Shirasmarg B.O": "431143",
      "Deolali B.O": "414202",
      "Devinimgaon B.O": "414202",
      "Pimpla B.O": "414202",
      "Waghluj B.O": "414202",
      "Nimgaon Choba B.O": "414208",
      "Kumbephal B.O": "431123",
      "Sarni Sangvi B.O": "431123",
      "Sonasangvi B.O": "431123",
      "Undri B.O": "431123",
      "Ambewadgaon B.O": "431124",
      "Chinchvan B. O.": "431144",
      "Choramba B.O": "431124",
      "Chikhali B.O": "414203",
      "Chanai B.O": "431517",
      "Dighol Amba B.O": "431517",
      "Warwati B.O": "431517",
      "Saigaon B.O": "431523",
      "Beed Sangvi B.O": "414203",
      "Gangadevi B.O": "414203",
      "Karhewadgaon B.O": "414203",
      "Matawali B.O": "414203",
      "Takalsingi B.O": "414203",
      "Dhanegaon Camp B.O": "431518",
      "Borphadi B.O": "431153",
      "Khalwatnimgaon B.O": "431153",
      "Kadiwadgaon B.O": "431153",
      "Dhekanmoha B.O": "431153",
      "Parbhani Kesapuri B.O": "431153",
      "Kamkheda B.O": "431153",
      "Jeba Pimpri B.O": "431126",
      "Palshingan B.O": "431126",
      "Pothra B.O": "431126",
      "Deodahiphal B.O": "431128",
      "Pohner B.O": "431128",
      "Wangi B.O": "431128",
      "Dhondrai B.O": "431127",
      "Kekat Pangri B.O": "431127",
      "Ruithal B.O": "431127",
      "Talwada B.O": "431127",
      "Aherwahegaon B.O": "431143",
      "Khandvi B.O": "431143",
      "Pachegaon B.O": "431143",
      "Phulsangvi B.O": "431143",
      "Sushi B.O": "431143",
      "Dadegaon B.O": "414202",
      "Deulgaon Ghat B.O": "414202",
      "Ruinalkol B.O": "414202",
      "Wahira B.O": "414202",
      "Belgaon B.O": "414208",
      "Kerul B.O": "414208",
      "Borgaon B.O": "431123",
      "Jiwachiwadi B.O": "431123",
      "Kalegoanghat B.O": "431123",
      "Takli B.O": "431123",
      "Yeota B.O": "431123",
      "Chondi B.O": "431124",
      "Ghagarwada B.O": "431124",
      "Beed H.O": "431122",
      "Ashti S.O (Beed)": "414203",
      "Bansorala S.O": "431518",
      "Beed ST Stand S.O": "431153",
      "Chousala S.O": "431126",
      "Kada S.O (Beed)": "414202",
      "Pimpalwandi S.O (Beed)": "413229",
      "Umapur S.O": "431130",
      "Vssk Pangri S.O": "431530",
      "Wadwani S.O": "431144",
      "Amalner S.O (Beed)": "413207",
      "Court Road S.O": "431122",
      "JBSSK GADI S.O": "431143",
      "Kadasakhar S.O": "414208",
      "Majalgaon S.O": "431131",
      "MARKET YARD S.O (Beed)": "431122",
      "MEDICAL COLLEGE  S.O": "431517",
      "Nehru chowk S.O": "431515",
      "Parli Vaijinath S.O": "431515",
      "Patoda S.O (Beed)": "414204",
      "Ambajogai S.O": "431517",
      "Dindrood S.O": "431128",
      "Gevrai S.O": "431127",
      "Ghatnandur S.O": "431519",
      "Kesapuri Camp S.O": "431142",
      "Naiknoor S.O": "431125",
      "Rajuri Navgan S.O": "414205",
      "Shirur S.O (Beed)": "413249",
      "YCC Ambajogai S. O": "431517",
      "Ambasakhar S.O": "431523",
      "DHONDIPURA S.O": "431122",
      "Kaij S.O": "431123",
      "Kille Dharur S.O": "431124",
      "M.GANJ S.O": "431122",
      "Parli Tps S.O": "431520",
      "Talkhed S.O": "431129"
    },
    "GONDIA": {
      "Datora B.O": "441614",
      "Dongargaon B.O": "441614",
      "Gangazari B.O": "441614",
      "Kachewani B.O": "441614",
      "Kalimati B.O": "441902",
      "Katangi BK B.O": "441801",
      "Kosamthondi B.O": "441801",
      "Pandhari B.O": "441801",
      "Pimpalgaon Khambi B.O": "441702",
      "Pratapgarh B.O": "441702",
      "Rajori (Bharnoli) B.O": "441702",
      "Dawwa B.O": "441807",
      "Dongargaon Sadak B.O": "441807",
      "Khajari Dongargaon B.O": "441807",
      "Mohadi B.O": "441807",
      "Tilli Mohgaon B.O": "441807",
      "Parsodi B.O": "441806",
      "Murdada B.O": "441911",
      "Navezari B.O": "441911",
      "Paraswada B.O": "441601",
      "Sarandi B.O": "441911",
      "Kudwa B.O": "441614",
      "Mohgaon BK B.O": "441614",
      "Nagpura B.O": "441614",
      "Pandharbodi B.O": "441614",
      "Sitepar B.O": "441614",
      "Tanda B.O": "441614",
      "Khodseoni B.O": "441801",
      "Soni B.O": "441801",
      "Bondegaon (Surban) B.O": "441702",
      "Dhabetekdi B.O": "441702",
      "Ghonadi B.O": "441702",
      "Parsodi Rayatwadi B.O": "441702",
      "Kawarabandh B.O": "441916",
      "Latori B.O": "441916",
      "Lohara B.O": "441902",
      "Bopabodi B.O": "441806",
      "Dhapewada B.O": "441911",
      "Gangla B.O": "441911",
      "Gond Mohadi B.O": "441911",
      "Gumdhawada B.O": "441911",
      "Dawaniwada B.O": "441614",
      "Kati (Birsola) B.O": "441614",
      "Ratnara B.O": "441614",
      "Gankhaira B.O": "441801",
      "Gidhadi B.O": "441801",
      "Hirapur B.O": "441801",
      "Mundipar (Ishwar) B.O": "441801",
      "Pathri (Gondia) B.O": "441801",
      "Bhivkhidki B.O": "441702",
      "Gothangaon B.O": "441702",
      "Palandur Zamindari B.O": "441702",
      "Palasgaon B.O": "441806",
      "Tukum Narayan B.O": "441702",
      "Chopa B.O": "441807",
      "Mundipar B.O": "441807",
      "Tedha B.O": "441807",
      "Dhanoli B.O": "441916",
      "Pipariya B.O": "441916",
      "Tirkhedi B.O": "441916",
      "Arjuni (Tirora) B.O": "441911",
      "Karti BK B.O": "441911",
      "Kodelohara B.O": "441911",
      "Mundikota B.O": "441911",
      "Sukhali Dakaram B.O": "441911",
      "Anjora B.O": "441902",
      "Suplipar B.O": "441902",
      "Thana B.O": "441902",
      "Tigaon B.O": "441902",
      "Bakti B.O": "441701",
      "Bondgaon Devi B.O": "441701",
      "Etikheda B.O": "441701",
      "Dawki B.O": "441901",
      "Kadikasa B.O": "441901",
      "Kokodi B.O": "441901",
      "Batana B.O": "441601",
      "Chutiya B.O": "441601",
      "Garra B.O": "441601",
      "Phulchur B.O": "441601",
      "Rajegaon B.O.": "441601",
      "Rawanwadi B.O": "441601",
      "Dandegaon B.O": "441614",
      "Dasgaon Khurd B.O": "441614",
      "Kotra B.O": "441902",
      "Makkatola B.O": "441902",
      "Pandharwani B.O": "441902",
      "Phukimeta B.O": "441902",
      "Murdoli B.O": "441901",
      "Shirpurbagh Colony B.O": "441901",
      "Khamari B.O": "441601",
      "Satona B.O": "441601",
      "Berdipar B.O": "441614",
      "Boda B.O": "441614",
      "Bijepar B.O": "441902",
      "Saoli Dongargaon B.O": "441902",
      "Satgaon B.O": "441902",
      "Mohgaon R.S. B.O": "441701",
      "Zarpada B.O": "441701",
      "Alewada B.O": "441901",
      "Chichgarh B.O": "441901",
      "Futana B.O": "441901",
      "Banathar B.O": "441601",
      "Chipiya B.O": "441601",
      "Gondia Khurd B.O": "441601",
      "Karanja B.O.": "441601",
      "Khatiya B.O": "441601",
      "Navegaon Kalan B.O": "441601",
      "Tumkheda Khurd B.O": "441601",
      "Adasi B.O": "441614",
      "Chirchal Bandh B.O": "441614",
      "Dhakni B.O": "441614",
      "Shejgaon B.O": "441614",
      "Yekodi (Gondia) B.O": "441614",
      "Bhasgaon B.O": "441801",
      "Ghoti B.O": "441801",
      "Hirdamali B.O": "441801",
      "Kurhadi B.O": "441801",
      "Timezari B.O": "441801",
      "Barabhati B.O": "441702",
      "Channa B.O": "441702",
      "Kesori B.O": "441702",
      "Parastola B.O": "441702",
      "Bamni B.O": "441807",
      "Shenda B.O": "441807",
      "Darekasa B.O": "441916",
      "Pauldauna B.O": "441916",
      "Sonpuri B.O": "441916",
      "Chikhali B.O": "441911",
      "Kokna B.O": "441806",
      "Indora Khurd B.O": "441911",
      "Kawalewada B.O": "441911",
      "Kesalwada B.O": "441911",
      "Lakhegaon B.O": "441911",
      "Thanegaon B.O": "441911",
      "Wadegaon B.O": "441911",
      "Borkanhar B.O": "441902",
      "Kattipar B.O": "441902",
      "Purada B.O": "441902",
      "Sarkartola B.O": "441902",
      "Korambitola B.O": "441701",
      "Wadegaon R.S. B.O": "441701",
      "Borgaon B.O": "441901",
      "Nilaj B.O": "441901",
      "Asoli BO": "441601",
      "Girola B.O": "441601",
      "Kamtha B.O.": "441601",
      "Kawlewada B.O": "441601",
      "Nagra B.O": "441601",
      "Nagrakatangi B.O": "441601",
      "Sawri B.O": "441601",
      "Gondia H.O": "441601",
      "Amgaon S.O": "441902",
      "Gondia Bazar S.O": "441601",
      "Gondia City S.O": "441614",
      "Salekasa S.O": "441916",
      "Arjuni Morgaon S.O": "441701",
      "Deori S.O (Gondia)": "441901",
      "Goregaon S.O (Gondia)": "441801",
      "Sadak Arjuni S.O": "441807",
      "Tirora S.O": "441911",
      "Navegaon Bandh S.O": "441702",
      "Soundad S.O": "441806"
    },
    "MUMBAI SUBURBAN": {
      "Chembur HO": "400071",
      "Andheri H.O": "400053",
      "Borivali HO": "400091",
      "Kurla North SO": "400070",
      "Nehru Nagar SO": "400024",
      "Netaji Nagar SO": "400070",
      "Andheri Railway Station S.O": "400058",
      "Bandra West S.O": "400050",
      "Bandra(East) S.O": "400051",
      "Chakala Midc S.O": "400093",
      "International Airport S.O": "400099",
      "Juhu S.O": "400049",
      "Sahar P and T Colony S.O": "400099",
      "Vakola S.O": "400055",
      "Barve Nagar SO": "400084",
      "FCI SO": "400074",
      "Govandi SO": "400088",
      "Nehru Road SO Mumbai": "400080",
      "Powai Iit SO": "400076",
      "Psm Colony SO": "400079",
      "RANagar SO": "400075",
      "Usha Nagar SO": "400078",
      "Mazgaon S.O": "400010",
      "Charkop SO": "400067",
      "Dahisar RS SO": "400068",
      "Jogeshwari West SO": "400102",
      "Kandivali West SO": "400067",
      "Liberty Garden SO": "400064",
      "Motilal Nagar SO": "400104",
      "Kandivali RS SO": "400067",
      "Aareymilk Colony SO": "400065",
      "Sakinaka SO": "400072",
      "Audit Bhavan S.O": "400051",
      "Azad Nagar S.O (Mumbai)": "400053",
      "Hanuman Road S.O": "400057",
      "Khar Colony S.O": "400052",
      "Khar Delivery S.O": "400052",
      "Marol Naka S.O": "400059",
      "Nagardas Road S.O": "400069",
      "Vidyanagari S.O": "400098",
      "Anushakti Nagar SO": "400094",
      "Best Staff Colony SO": "400075",
      "Bhandup Complex SO": "400082",
      "Bhandup East SO": "400042",
      "Bhandup West SO": "400078",
      "Chembur Extension SO": "400074",
      "Chembur Rs SO": "400089",
      "DM Colony SO": "400043",
      "Ghatkopar West SO": "400086",
      "Mulund Dd Road SO": "400080",
      "Mulund East SO": "400081",
      "Mulund West SO": "400080",
      "Nahur SO": "400080",
      "Rajawadi SO": "400077",
      "Rifle Range SO": "400086",
      "SB Road SO": "400080",
      "Daulat Nagar SO Mumbai": "400066",
      "Goregaon East SO": "400063",
      "Jogeshwari East SO": "400060",
      "Kandivali East SO": "400101",
      "Kharodi SO": "400095",
      "Malad SO": "400064",
      "Rani Sati Marg SO": "400097",
      "Vihar Road SO": "400072",
      "Airport S.O (Mumbai)": "400099",
      "B.N. Bhavan S.O": "400051",
      "Marol Bazar S.O": "400059",
      "Santacruz Central S.O": "400054",
      "Santacruz P and T  Colony S.O": "400029",
      "Vesava S.O": "400061",
      "Vileeparle (East) S.O": "400057",
      "Vileparle(West) S.O": "400056",
      "Mhada Colony SO": "400081",
      "Bangur Nagar SO": "400104",
      "Borivali East SO": "400066",
      "Borivali West SO": "400092",
      "Dahisar SO": "400068",
      "Mandapeshwar SO": "400103",
      "Orlem SO": "400064",
      "Sharma Estate SO": "400063",
      "NITIE SO": "400087",
      "PH Colony SO": "400078",
      "Pant Nagar SO": "400075",
      "Sahakar Bhavan SO": "400086",
      "Shivaji Nagar SO Mumbai": "400043",
      "TFDonar SO": "400088",
      "Tagore Nagar SO": "400083",
      "Trombay SO": "400088",
      "Kurla West SO": "400070",
      "A I Staff Colony S.O": "400029",
      "Andheri East S.O": "400069",
      "Danda S.O": "400052",
      "Goregaon RS SO": "400104",
      "Goregaon SO Mumbai": "400104",
      "Ins Hamla SO": "400095",
      "Malad East SO": "400097",
      "Malad West Dely SO": "400064",
      "Nagari Niwara SO": "400065",
      "Oshiwara SO": "400102",
      "Rajendra Nagar SO Mumbai": "400066",
      "S R P F Camp SO": "400065",
      "S KNagar SO": "400066",
      "H.M.P. School S.O": "400058",
      "IRLA S.O": "400056",
      "J.B. Nagar S.O": "400059",
      "Kherwadi S.O": "400051",
      "Santacruz(East) S.O": "400055",
      "Santacruz(West) S.O": "400054",
      "Seepz S.O": "400096",
      "V.P. Road S.O": "400052",
      "Vileparle Railway Station S.O": "400057",
      "Bandra W eCOM  Nodal Delivery Centre": "400051",
      "BARC SO": "400085",
      "Bhandup Ind Estate SO": "400078",
      "JM Road SO": "400078",
      "Kannamwar Nagar SO": "400083",
      "Mahul Road SO": "400074",
      "Mulund Colony SO": "400082",
      "Tilak Nagar SO Mumbai": "400089",
      "Vikhroli SO": "400079"
    }
  },
  "GUJARAT": {
    "SABAR KANTHA": {
      "ZAHIRABAD B.O": "383002",
      "KUKDI B.O": "383422",
      "ADAPUR B.O": "383030",
      "Jambudi BO": "383001",
      "Nava BO": "383305",
      "Khed BO": "383001",
      "Sahebapura BO": "383001",
      "Pural BO": "383001",
      "Savgadh BO": "383001",
      "Gadhoda BO": "383001",
      "Hapa BO": "383001",
      "Kankrol BO": "383001",
      "Katwad BO": "383001",
      "Agiol BO": "383001",
      "Viravada BO": "383001",
      "Vishwamangalam BO": "383001",
      "Parabada BO": "383001",
      "Bavsar BO": "383001",
      "Berna BO": "383001",
      "Chandarni BO": "383001",
      "Hadiol BO": "383001",
      "Navalpur BO": "383001",
      "Tajpuri BO": "383001",
      "Hathoj BO": "383235",
      "Kuba Dharol BO": "383235",
      "Mahor BO": "383235",
      "Medh BO": "383235",
      "Nadri BO": "383235",
      "Raheda BO": "383235",
      "Gadha BO": "383010",
      "Himatpur BO": "383010",
      "Jamla BO": "383010",
      "Nava Revas BO": "383450",
      "Badol BO": "383434",
      "Chandap BO": "383434",
      "Gajipur BO": "383434",
      "Parosada BO": "383460",
      "Kesharganj BO": "383235",
      "Rajpur BO": "383460",
      "Virpur BO": "383230",
      "Kanpur BO": "383450",
      "Siyasan BO": "383450",
      "Rampur Fudeda BO": "383434",
      "Ravol BO": "383434",
      "Androkha BO": "383460",
      "Atarsumba BO": "383460",
      "Bhankhara BO": "383460",
      "Chandvasa BO": "383460",
      "Vasai BO": "383460",
      "Therasana BO": "383235",
      "Vasan BO": "383235",
      "Kapoda BO": "383010",
      "Lolasan BO": "383010",
      "Mesan BO": "383450",
      "Gulabpura BO": "383434",
      "Kava BO": "383434",
      "Nalseri BO": "383460",
      "Padela BO": "383460",
      "Sarsav BO": "383460",
      "Vandhol BO": "383460",
      "Vadoth BO": "383235",
      "Kaniol BO": "383010",
      "Likhi BO": "383010",
      "Mudeti BO": "383450",
      "Golwada BO": "383434",
      "Kamalpur BO": "383205",
      "Abhapur BO": "383460",
      "Kelava BO": "383460",
      "Navagam Dhanela BO": "383460",
      "Saroli BO": "383460",
      "Ukhala Dungri BO": "383460",
      "Sheri BO": "387305",
      "Galodiya BO": "383275",
      "Kalol Kampa BO": "383275",
      "Khergadh BO": "383275",
      "Tandaliya BO": "383275",
      "Vaghela Derol BO": "383275",
      "Vankda BO": "383462",
      "Damavas BO": "383275",
      "Chandrana BO": "383422",
      "Delwada BO": "383255",
      "Dalani Muvadi BO": "383205",
      "Jenpur BO": "383205",
      "Tajpur BO": "383205",
      "Agiya BO": "383270",
      "Nava Mota BO": "383270",
      "Ratanpur BO": "383430",
      "Mathasulia BO": "383276",
      "Sampad BO": "383120",
      "Ambawada BO": "383210",
      "Mahadevpura BO": "383210",
      "Chamthan BO": "383246",
      "Masota BO": "383246",
      "Boria Bechraji BO": "383215",
      "Ghadi BO": "383215",
      "Semalia BO": "383215",
      "Ujedia BO": "383215",
      "Deshotar BO": "383230",
      "Finchod BO": "383230",
      "Oda BO": "383230",
      "Babsar BO": "383235",
      "Gadu BO": "383235",
      "Dantral BO": "383422",
      "Ganer BO": "383422",
      "Petachhapra BO": "383422",
      "Vinchhi BO": "383422",
      "Bobha BO": "383205",
      "Ghadkan BO": "383205",
      "Sitwada BO": "383205",
      "Unchha BO": "383205",
      "Vadrad BO": "383205",
      "Ambaigadha BO": "383270",
      "Gadhada Shamlaji BO": "383270",
      "Kheroj BO": "383270",
      "Ganva BO": "383422",
      "Kalikankar BO": "383422",
      "Kotda BO": "383422",
      "Karol BO": "383205",
      "Majra BO": "383205",
      "Oran BO": "383205",
      "Pallachar BO": "383205",
      "Nada BO": "383270",
      "Nana Sembalia BO": "383270",
      "Panch Mahuda BO": "383270",
      "Tembada BO": "383270",
      "Adpodra BO": "383276",
      "Vagdi BO": "383276",
      "Dalpur BO": "383120",
      "Hajipur BO": "383120",
      "Itavadi BO": "383246",
      "Jorajini Muvadi BO": "383215",
      "Kherol BO": "383215",
      "Mahiyal BO": "383215",
      "Mudhasana BO": "383215",
      "Maniyor BO": "383230",
      "Masal BO": "383230",
      "Bhandval BO": "383235",
      "Dantroli BO": "383235",
      "Dhamadi Gadu BO": "383235",
      "Dobhada BO": "383235",
      "Poshina BO": "383421",
      "Sabli BO": "383421",
      "Prempur BO": "383225",
      "Singa BO": "383225",
      "Sadha BO": "383030",
      "Shravana BO": "383030",
      "Dadarda BO": "383305",
      "Kabodara BO": "383305",
      "Lavari BO": "383305",
      "Madhavgadh BO": "383305",
      "Mota Chekhla BO": "383305",
      "Nana Chekhla BO": "383305",
      "Bhavangadh BO": "383430",
      "Gambhirpura BO": "383430",
      "Lei BO": "383430",
      "Bhadresar BO": "383110",
      "Daramali BO": "383110",
      "Dungri BO": "383110",
      "Mangadh BO": "383110",
      "Choriwad BO": "383440",
      "Chulla BO": "383440",
      "Juna Chamu BO": "383440",
      "Kalvan BO": "383440",
      "Bahediya BO": "383255",
      "Dharoi BO": "383255",
      "Padardi BO": "383255",
      "Chikhla BO": "383255",
      "Gadi BO": "383462",
      "Jaleti BO": "383462",
      "Pal BO": "383462",
      "Ajavas BO": "383422",
      "Ambamahuda BO": "383422",
      "Pipliya BO": "383422",
      "Salera BO": "383422",
      "Sembalia Poshina BO": "383422",
      "Tadhivedi BO": "383422",
      "Balisana BO": "383205",
      "Poglu BO": "383205",
      "Vadvasa BO": "383205",
      "Vaghpur BO": "383205",
      "Bandiyana Talav BO": "383270",
      "Dan Mahudi BO": "383270",
      "Demti BO": "383270",
      "Dotad BO": "383270",
      "Gundel BO": "383270",
      "Matoda BO": "383270",
      "Unchi Dhanal BO": "383270",
      "Moyad BO": "383120",
      "Nananpur BO": "383210",
      "Nikoda BO": "383210",
      "Rampur A BO": "383210",
      "Takhatgadh BO": "383210",
      "Vaghrota BO": "383210",
      "Kundol Pal BO": "383246",
      "Amrapur BO": "383215",
      "Poyda BO": "383215",
      "Bolundra S BO": "383230",
      "Budheli BO": "383230",
      "Chhapi BO": "383230",
      "Punsari BO": "383307",
      "Ranipura BO": "383307",
      "Sagpur BO": "383307",
      "Lambadiya BO": "383270",
      "Mota Baval BO": "383270",
      "Patadiya BO": "383270",
      "Rajendranagar BO": "383276",
      "Piludra BO": "383120",
      "Fatepur Mota BO": "383210",
      "Mauchha BO": "383210",
      "Zinzva BO": "383210",
      "Chitrodi BO": "383246",
      "Kanadar BO": "383246",
      "Doltabad BO": "383215",
      "Gora Anjana BO": "383215",
      "Salatpur BO": "383215",
      "Valiampura BO": "383215",
      "Falasan BO": "383230",
      "Kesharpura BO": "383230",
      "Asai BO": "383235",
      "Hatharva BO": "383235",
      "BolundraR BO": "383421",
      "Mota Kotda BO": "383421",
      "Arsodia BO": "383225",
      "Kabso BO": "383225",
      "Dhundhar BO": "383030",
      "Manorpur BO": "383030",
      "Antroli BO": "383305",
      "Mohanpur BO": "383305",
      "Padusan BO": "383305",
      "Tajpur Camp BO": "383305",
      "Mathasur BO": "383430",
      "Panol BO": "383430",
      "Umedpura BO": "383430",
      "Navanagar BO": "383220",
      "Sachodar BO": "383110",
      "Bhutiya BO": "383440",
      "Kathvavdi BO": "383440",
      "Khedva BO": "383255",
      "Sitol BO": "383255",
      "Baleta BO": "383462",
      "Chithoda BO": "383462",
      "Dharapur BO": "383421",
      "Eklara BO": "383225",
      "Pethapur BO": "383225",
      "Hathrol BO": "383030",
      "Vavdi BO": "383030",
      "Aniod BO": "383305",
      "Badodara BO": "383305",
      "Modhuka BO": "383305",
      "Motesari BO": "383305",
      "Barvav BO": "383430",
      "Laloda BO": "383430",
      "Limbhoi BO": "383430",
      "Surpur BO": "383430",
      "Khedavada BO": "383220",
      "Aroda BO": "383110",
      "Chadasana BO": "383110",
      "Kotda Nana BO": "383110",
      "Rudardi BO": "383110",
      "Pratapgadh Kampa BO": "383440",
      "Didhiya BO": "383255",
      "Gota BO": "383255",
      "Nichi Dhanal BO": "383255",
      "Paroya BO": "383255",
      "Navi Metral BO": "383255",
      "Biladia BO": "383462",
      "Chitariya BO": "383462",
      "Limda BO": "383462",
      "Karanpur BO": "383030",
      "Pedhmala BO": "383030",
      "Rupal BO": "383030",
      "Ranasan BO": "383305",
      "Varvada BO": "383305",
      "Netramali BO": "383430",
      "Pratappura BO": "383430",
      "Sabalwad BO": "383430",
      "Sapawada BO": "383430",
      "Dedhrota BO": "383220",
      "Derol BO": "383220",
      "Kadoli BO": "383220",
      "Kanai BO": "383220",
      "Kanda BO": "383220",
      "Padhara BO": "383255",
      "Valaran BO": "383255",
      "Vartol BO": "383255",
      "Vasana BO": "383255",
      "Zanzva panai BO": "383255",
      "Dadhvav BO": "383462",
      "Dantod BO": "383462",
      "Bhanpur BO": "383410",
      "Ganthiol BO": "383410",
      "Sherpur BO": "383410",
      "Ankala BO": "383410",
      "Diyoli BO": "383410",
      "Goral BO": "383410",
      "Mankdi BO": "383240",
      "Punasan BO": "383240",
      "Hunj BO": "383240",
      "Meditimba BO": "383240",
      "Kukadia BO": "383410",
      "Lalpur BO": "383410",
      "Ada Hathrol BO": "383240",
      "Bankhor BO": "383240",
      "Himmatpur BO": "383240",
      "Himatnagar HO": "383001",
      "Bamna SO": "383240",
      "Chitroda SO": "383421",
      "Gambhoi SO": "383030",
      "Idar SO": "383430",
      "Idar Town SO": "383430",
      "Salal SO": "383120",
      "Talod SO": "383215",
      "Umedgadh SO": "383230",
      "Vaktapur SO": "383010",
      "Badoli SO": "383410",
      "Harsol SO": "383305",
      "Himatnagar Station Road SO": "383002",
      "Kodiawada SO": "383462",
      "Laxmipura Sabarkantha SO": "383275",
      "Poshina SO": "383422",
      "Radhiwad SO": "383270",
      "Vadali SO Sabarkantha": "383235",
      "Vasai SO": "383450",
      "Boria SO Sabarkantha": "383006",
      "Ilol SO": "383220",
      "Jadar SO": "383110",
      "Kadiadra SO": "383440",
      "Sonasan SO": "383210",
      "Talod M Y SO": "383215",
      "Verabar SO": "383434",
      "Vijaynagar SO": "383460",
      "Davad SO": "383225",
      "Hajipura SO": "383001",
      "Khedbrahma SO": "383255",
      "Prantij SO": "383205",
      "Raigadh SO": "383276"
    },
    "AHMADABAD": {
      "Kathwada GIDC S.O": "382430",
      "Ambli BO": "382463",
      "Kasindra BO": "382465",
      "Navapura BO": "382210",
      "Kubadthal BO": "382430",
      "Pasunj BO": "382430",
      "Bhavda BO": "382433",
      "Ranodra BO": "382433",
      "Vadod BO": "382433",
      "Pardhol BO": "382330",
      "Girmatha BO": "382425",
      "Muktipur BO": "382425",
      "Geratpur BO": "382435",
      "Ghuma BO": "380058",
      "Shela BO": "382465",
      "Bakrol BO": "382430",
      "Bhat BO": "382210",
      "Fatewadi BO": "382210",
      "Undrel BO": "382433",
      "Bilasia BO": "382330",
      "Vehlal BO": "382330",
      "Paldi Kankaj BO": "382425",
      "Pirana BO": "382425",
      "Gyaspur BO": "382405",
      "Lambha BO": "382405",
      "Telav BO": "382210",
      "Vishalpur BO": "382210",
      "Bhuvaldi BO": "382430",
      "Kanbha BO": "382430",
      "Kathwada BO": "382430",
      "Chamla BO": "382433",
      "Chaulaj BO": "382433",
      "Kaniyel BO": "382433",
      "Abasana BO": "382120",
      "Dabhsar BO": "382120",
      "Sadatpura BO": "382120",
      "Sangpura BO": "382120",
      "Sinaj BO": "382120",
      "Ughroj BO": "382120",
      "Vithlpura BO": "382120",
      "Khasta BO": "382460",
      "Kothadia BO": "382460",
      "Mota Tradia BO": "382460",
      "Zanzarka BO": "382460",
      "Aniali Bhimji BO": "382460",
      "Bhangadh BO": "382455",
      "Hebatpur BO": "382455",
      "Khun BO": "382455",
      "Mingalpur BO": "382455",
      "Andej BO": "382115",
      "Nedharad BO": "382115",
      "Madrisana BO": "382145",
      "Moti Rantai BO": "382145",
      "Ingoli BO": "382265",
      "Varna BO": "382265",
      "Vataman BO": "382265",
      "Virdi BO": "382265",
      "Gangad BO": "382240",
      "Kalyangadh BO": "382240",
      "Kesardi BO": "382240",
      "Nani Boru BO": "382230",
      "Rohika BO": "382230",
      "Shiyal BO": "382230",
      "Jetalpur BO": "382427",
      "Ode BO": "382427",
      "Timba BO": "382425",
      "Vasai BO": "382425",
      "Dhamatvan BO": "382435",
      "Harniav BO": "382435",
      "Saijpur BO": "382405",
      "Shahwadi BO": "382405",
      "Chandkheda BO": "382424",
      "Kolat BO": "382210",
      "Sanathal BO": "382210",
      "Kujad BO": "382430",
      "Zanu BO": "382430",
      "Chandial BO": "382433",
      "Mahijada BO": "382425",
      "Miroli BO": "382425",
      "Gamdi BO": "382435",
      "Hirapur BO": "382435",
      "Gunjala BO": "382120",
      "Jalisana BO": "382120",
      "Kukvav BO": "382120",
      "Marusana BO": "382120",
      "Nadishala BO": "382120",
      "Rudatal BO": "382120",
      "Zanzarva BO": "382120",
      "Adval BO": "382460",
      "Bajarda BO": "382460",
      "Chhasiana BO": "382460",
      "Salasar BO": "382460",
      "Bavaliary BO": "382455",
      "Fatepur BO": "382465",
      "Gamph BO": "382465",
      "Kamiala BO": "382465",
      "Pipli BO": "382465",
      "Sobhasan BO": "382145",
      "Bagodara BO": "382230",
      "Bhurkhi BO": "382230",
      "Dhingada BO": "382230",
      "Mithapur BO": "382230",
      "Dalod BO": "382130",
      "Jeska BO": "382250",
      "Parabadi BO": "382250",
      "Ashoknagar BO": "382140",
      "Bhadana BO": "382140",
      "Charel BO": "382110",
      "Daduka BO": "382110",
      "Asalgam BO": "382150",
      "Bhojwa BO": "382150",
      "Chandranagar BO": "382150",
      "Daslana BO": "382150",
      "Dumana BO": "382150",
      "Khudad BO": "382150",
      "Kokta BO": "382150",
      "Rahemalpur BO": "382150",
      "Rangpur BO": "382150",
      "Sachana BO": "382150",
      "Sarsavadi BO": "382150",
      "Thori Thumbha BO": "382150",
      "Thuleta BO": "382150",
      "Iawa Vasna BO": "382170",
      "Jholapur BO": "382170",
      "Khoda BO": "382170",
      "Ramol BO": "382449",
      "Vanch BO": "382449",
      "Jagatpur BO": "382470",
      "Kali BO": "382470",
      "Ognaj BO": "380060",
      "Kelia  Vasna BO": "382225",
      "Ambaliara BO": "382225",
      "Sherpura BO": "382225",
      "Siawada BO": "382170",
      "Daran BO": "382220",
      "Dehgamda BO": "382220",
      "Nanodara BO": "382220",
      "Rajoda BO": "382220",
      "Gogla BO": "382463",
      "Dadhana BO": "382120",
      "Gamanpura BO": "382120",
      "Odhav BO": "382120",
      "Gunjar BO": "382460",
      "Khadol BO": "382460",
      "Padana BO": "382460",
      "Vasna BO": "382460",
      "Sandhida BO": "382455",
      "Buranpur BO": "382465",
      "Panchham BO": "382465",
      "Garodia BO": "382115",
      "Balsasan BO": "382145",
      "Chuval Dangarva BO": "382145",
      "Sunvala BO": "382145",
      "Simej BO": "382265",
      "Baldana BO": "382240",
      "Deo Dholera BO": "382240",
      "Rupgadh BO": "382240",
      "Arnej BO": "382230",
      "Bholad BO": "382230",
      "Durgi BO": "382230",
      "Jakhada BO": "382230",
      "Moti Boru BO": "382230",
      "Utelia BO": "382230",
      "Nana Ubhada BO": "382130",
      "Navagam BO": "382130",
      "Nayakpur BO": "382130",
      "Sitapur BO": "382130",
      "Solgam BO": "382130",
      "Vanpardi BO": "382130",
      "Tagadi BO": "382250",
      "Bhankoda BO": "382140",
      "Chhaniar BO": "382140",
      "Goraj BO": "382110",
      "Jamp BO": "382110",
      "Kaneti BO": "382110",
      "Kundal BO": "382450",
      "Kunvar BO": "382110",
      "Moti  Kishol BO": "382110",
      "Pimpan BO": "382110",
      "Rethal BO": "382110",
      "Upardal BO": "382110",
      "Vinchhiya BO": "382110",
      "Hansalpur BO": "382150",
      "Hirapura BO": "382150",
      "Jakwada BO": "382150",
      "Jalampur BO": "382150",
      "Vansva BO": "382150",
      "Vanthal BO": "382150",
      "Bakrana BO": "382170",
      "Khorajnanoda BO": "382170",
      "Vasna  Iawa BO": "382170",
      "Hathijan BO": "382445",
      "Gota BO": "382481",
      "Lapkaman BO": "380060",
      "Sahij BO": "382225",
      "Vautha BO": "382225",
      "Transad BO": "382225",
      "Dadusar BO": "382225",
      "Navda BO": "382450",
      "Rampura BO": "382450",
      "Rojid BO": "382450",
      "Chhabasar BO": "382220",
      "Ranesar BO": "382220",
      "Rasam BO": "382220",
      "Gorasu BO": "382463",
      "Sodhi BO": "382463",
      "Valinda BO": "382463",
      "Chandisar BO": "382260",
      "Devtimoti BO": "382213",
      "Vejalka BO": "382230",
      "Dhedasana BO": "382130",
      "Endla BO": "382130",
      "Kunpur BO": "382130",
      "Rakhiana BO": "382130",
      "Sher BO": "382130",
      "Varmor BO": "382130",
      "Zinzar BO": "382250",
      "Ghatisana BO": "382140",
      "Kanz BO": "382140",
      "Panar BO": "382140",
      "Pandharpura BO": "382140",
      "Sihor BO": "382140",
      "Ukardi BO": "382140",
      "Galsana BO": "382245",
      "Makhiav BO": "382110",
      "Dhakdi BO": "382150",
      "Ghoda BO": "382150",
      "Joshipura BO": "382150",
      "Kamijala BO": "382150",
      "Karakthal BO": "382150",
      "Kumarkhan BO": "382150",
      "Melaj BO": "382150",
      "Thori Mubarak BO": "382150",
      "Trent BO": "382150",
      "Vadgas BO": "382150",
      "Dodar BO": "382170",
      "Kalana BO": "382170",
      "Khodiyar BO": "382421",
      "Zundal BO": "382421",
      "Tragad BO": "382470",
      "Ranoda BO": "382225",
      "Sindharej BO": "382225",
      "Kadvasan BO": "382130",
      "Ribadi BO": "382130",
      "Vinzuvada BO": "382130",
      "Akru BO": "382250",
      "Unchadi BO": "382250",
      "Devpura BO": "382140",
      "Kointia BO": "382140",
      "Shivpura BO": "382140",
      "Vagad BO": "382245",
      "Fangadi BO": "382110",
      "Mankol BO": "382110",
      "Vekaria BO": "382110",
      "Goraiya BO": "382150",
      "Junapadhar BO": "382150",
      "Kankravadi BO": "382150",
      "Manipur BO": "382150",
      "Gatrad BO": "382449",
      "Ogan BO": "382150",
      "Shahpur BO": "382150",
      "Ukhlod BO": "382150",
      "Vani BO": "382150",
      "Zezra BO": "382150",
      "Bol BO": "382170",
      "Chharodi BO": "382170",
      "Bhadaj BO": "382722",
      "Rampur BO": "382225",
      "Valdhera BO": "382225",
      "Nesda BO": "382225",
      "Khambhada BO": "382450",
      "Bhayla BO": "382220",
      "Chiada BO": "382220",
      "Kocharia BO": "382220",
      "Modasar BO": "382220",
      "Rupal BO": "382220",
      "Sari BO": "382220",
      "Kadipur BO": "382463",
      "Otaria Sarvodaya Ashram BO": "382463",
      "Sangasar BO": "382463",
      "Kavitha BO": "382260",
      "Matoda BO": "382213",
      "Vasna  Chacharvadi BO": "382213",
      "Ambareli BO": "382225",
      "Jalalpur Vajifa BO": "382225",
      "Sathal BO": "382225",
      "Sarandi BO": "382225",
      "Khamidana BO": "382450",
      "Salangpur  Hanuman BO": "382450",
      "Vadhela BO": "382450",
      "Adroda BO": "382220",
      "Dhanwada BO": "382220",
      "Kerala BO": "382220",
      "Nani Devti BO": "382220",
      "Salajada BO": "382220",
      "Sankod BO": "382220",
      "Otaria BO": "382463",
      "Saroda BO": "382260",
      "Badarkha BO": "382260",
      "Moraiya BO": "382213",
      "Dekawada BO": "382120",
      "Vinchhan BO": "382120",
      "Jaliya BO": "382460",
      "Kharad BO": "382460",
      "Rayka BO": "382460",
      "Rojka BO": "382460",
      "Panchhi BO": "382455",
      "Dhanala BO": "382465",
      "Loliya BO": "382465",
      "Chekhla BO": "382115",
      "Bamroli BO": "382145",
      "Bhoyani BO": "382145",
      "Telavi BO": "382145",
      "Ganol BO": "382265",
      "Pisawada BO": "382265",
      "Bamsara BO": "382240",
      "Dholi BO": "382240",
      "Gundi Sarvodaya Ashram BO": "382230",
      "Jawaraj BO": "382230",
      "Sargwala BO": "382230",
      "Dholi Bhal BO": "363423",
      "Vivekanandnagar BO": "382445",
      "Vinzol BO": "382445",
      "Shilaj BO": "380059",
      "Hadalbhal BO": "363423",
      "Revdibazar HO": "380002",
      "Ahmedabad GPO": "380001",
      "Navrangpura HO": "380009",
      "Azad Society SO": "380015",
      "Bodakdev SO": "380054",
      "Jivraj Park SO": "380051",
      "Nava Vadaj SO": "380013",
      "Chandkheda Society Area SO": "382424",
      "D Cabin SO": "380019",
      "Darpan Society SO": "380009",
      "Gandhi Ashram SO Ahmedabad": "380027",
      "I I M SO": "380015",
      "Kabir Chowk SO": "380005",
      "B D Cell Ahmedabad City": "380009",
      "Ellisbridge SO": "380006",
      "Jodhpur Char Rasta SO": "380015",
      "Manekbag SO": "380015",
      "Memnagar SO": "380052",
      "Motera SO": "380005",
      "Anandnagar SO Ahmedabad": "380007",
      "Bopal SO": "380058",
      "Ghatlodia SO": "380061",
      "Gujarat University SO": "380009",
      "Juhapura SO": "380055",
      "Naranpura Vistar SO": "380013",
      "Narayannagar SO": "380007",
      "Navjivan SO": "380014",
      "O N G C SO": "380005",
      "Polytechnic SO Ahmedabad": "380015",
      "S A C SO": "380015",
      "Sabarmati SO": "380005",
      "Sarkhej Road SO": "380007",
      "Shardanagar SO": "380007",
      "Stadium Marg SO": "380013",
      "Ghuma S.O": "380058",
      "Asarwa Chakla SO": "380016",
      "Cantonment SO": "380004",
      "Dudheshwar Tavdipura SO": "380004",
      "I E Bapunagar SO": "380024",
      "Kathwada Maize Product SO": "382430",
      "Kuha SO": "382433",
      "Odhav Industrial Estate SO": "382415",
      "Public Office SO Ahmedabad": "380016",
      "Saijpur Bogha SO": "382345",
      "Saraspur SO": "380018",
      "Amraiwadi SO": "380026",
      "Bavla SO": "382220",
      "Bordibazar Viramgam SO": "382150",
      "Chaloda SO": "382260",
      "Katosan Road SO": "382145",
      "Virochannagar SO": "382170",
      "Changodar SO": "382213",
      "Detroj SO": "382120",
      "Dhandhuka SO": "382460",
      "Viramgam SO": "382150",
      "Dholka SO": "382225",
      "Fedra SO": "382465",
      "Lothal Bhurkhi RS SO": "382230",
      "Dariapur SO Ahmedabad": "380001",
      "District Court SO Ahmedabad": "380001",
      "Gheekanta Road SO": "380001",
      "Jawahar Chowk SO": "380008",
      "Khokhara Mehmadabad SO": "380008",
      "Paldi SO Ahmedabad": "380007",
      "Railway Colony SO Ahmedabad": "380019",
      "Civil Hospital SO": "380016",
      "Krishnanagar SO Ahmedabad": "382345",
      "Kubernagar B A SO": "382340",
      "N C Market SO": "380002",
      "Naroda SO": "382330",
      "Noblenagar SO": "382340",
      "Railwaypura SO": "380002",
      "Foreign Post Office Ahmedabad": "380004",
      "Bareja SO Ahmedabad": "382425",
      "Behrampura SO": "380022",
      "Jamalpur SO Ahmedabad": "380001",
      "Khadia SO": "380001",
      "L G Hospital SO": "380008",
      "Maninagar SO": "380008",
      "Nandej SO": "382435",
      "Narol SO": "382405",
      "Raikhad SO": "380001",
      "Vatva SO": "382445",
      "Mandal SO Ahmedabad": "382130",
      "Bhat SO": "382428",
      "Manek Chowk SO": "380001",
      "Raipur SO Ahmedabad": "380001",
      "S A Mills SO": "380008",
      "Jantanagar SO": "382449",
      "Vatva Industrial Estate SO": "382445",
      "Sola H B C SO": "380063",
      "Vadaj SO": "380013",
      "Asarwa Ext South SO": "380024",
      "Girdharnagar SO": "380004",
      "Kubernagar SO": "382340",
      "Madhupura Market SO": "380004",
      "Naroda S A SO": "382330",
      "Odhav SO": "382415",
      "Rajpur Gomtipur SO": "380021",
      "Rakhial Udyog Vistar SO": "380023",
      "Sukhrampura SO": "380023",
      "T B Nagar SO": "382350",
      "DELIVERY HUB AHMEDABAD": "380003",
      "Aslali SO": "382427",
      "Bhairavnath Road SO": "380028",
      "Calico Mills SO": "380022",
      "Gandhi Road SO Ahmedabad": "380001",
      "Gita Mandir Road SO": "380022",
      "Isanpur SO": "382443",
      "Khanpur SO Ahmedabad": "380001",
      "M D Marg SO": "380022",
      "Municipal Corporation SO": "380001",
      "Digvijaynagar SO": "382470",
      "Gujrat High Court SO": "380060",
      "Thaltej SO": "380059",
      "Ranip SO": "382480",
      "Sarkhej SO": "382210",
      "Shastrinagar SO Ahmedabad": "380013",
      "Thaltej Road SO": "380054",
      "Bapunagar SO": "380024",
      "Delhi Gate SO Ahmedabad": "380004",
      "Gomtipur SO": "380021",
      "Khodiyarnagar SO": "382350",
      "Meghaningar SO": "380016",
      "N C Mills SO": "382345",
      "Naroda I E SO": "382330",
      "Naroda Road SO": "382345",
      "Sardarnagar SO": "382475",
      "Shahibag SO": "380004",
      "Shahpur SO Ahmedabad": "380004",
      "Nikol SO": "380049",
      "Ctm Char Rasta SO": "380026",
      "Daxini Society SO": "380008",
      "Ghodasar SO Ahmedabad": "380050",
      "Lal Darwaja SO": "380001",
      "Shah Alam Roza SO": "380028",
      "Vasisthnagar SO": "380008",
      "Vastral SO": "382418",
      "Bavla Market Yard SO": "382220",
      "Bhadiad SO": "382463",
      "Dholera SO": "382455",
      "Godhavi SO": "382115",
      "Kauka SO": "382265",
      "Koth SO": "382240",
      "Rampura SO Ahmedabad": "382140",
      "Sanand SO": "382110",
      "Nirnaynagar SO": "382481",
      "Sola SO": "380060",
      "Dr Baou SO": "382481",
      "Chandlodia SO": "382481"
    },
    "MAHESANA": {
      "Anand Bhankhri B.O": "384330",
      "Rangpurda B.O": "384440",
      "Himmatpura B.O": "384330",
      "Kanthravi BO": "384260",
      "Pali BO": "384260",
      "Charol BO": "382120",
      "Chandrasan BO": "382170",
      "Varetha BO": "384325",
      "Vithoda BO": "384325",
      "Kharod BO": "384540",
      "Mandali BO": "384130",
      "Gambhu BO": "384412",
      "ALODA B.O": "384005",
      "NUGAR B.O": "384005",
      "PALODAR B.O": "384005",
      "Sundarpur BO": "384560",
      "Bhatvas BO": "384330",
      "Bhimpura BO": "384330",
      "Tarangaji Temple BO": "384330",
      "Vaghawadi BO": "384335",
      "Valasana BO": "384335",
      "Dabhi BO": "384170",
      "Ranchhodpura BO": "384170",
      "Sihi BO": "384170",
      "Sunok BO": "384170",
      "Upera BO": "384170",
      "Kahipur BO": "384355",
      "Karbatia BO": "384355",
      "Sabalpur BO": "384355",
      "Bhavsor BO": "384570",
      "Bilia BO": "384570",
      "Devpura BO": "384570",
      "Falu BO": "384570",
      "Bhalak BO": "384315",
      "Denap BO": "384315",
      "Gunja BO": "384315",
      "Dagavadia BO": "384530",
      "Devda BO": "384530",
      "Kelisana BO": "384530",
      "Meu BO": "384465",
      "Ambasan BO": "384435",
      "Jantral BO": "384560",
      "Madhi BO": "384560",
      "Gothada BO": "384330",
      "Kothasana BO": "384330",
      "Gorisana BO": "384335",
      "Karsanpura BO": "384335",
      "Sardarpur BO": "384340",
      "Borisana Kadi BO": "384441",
      "Aithor BO": "384170",
      "Amudh BO": "384170",
      "Bhankhar BO": "384170",
      "Khatoda BO": "384355",
      "Malekpur Vad BO": "384355",
      "Ransipur BO": "384570",
      "Laxmipura BO": "384315",
      "Paladi BO": "384315",
      "Sokhda BO": "384530",
      "Charadu BO": "384465",
      "Motap BO": "384412",
      "Vijapurda BO": "384412",
      "Martoli BO": "384430",
      "Ankaliyara BO": "384330",
      "Bedasma Mumanvas BO": "384330",
      "Mothibhalu BO": "384330",
      "Ambavada BO": "384335",
      "Madhasana BO": "384335",
      "Unad BO": "384335",
      "Vasai BO": "384340",
      "Adrajmerdabo BO": "384441",
      "Fuletra BO": "384441",
      "Thol BO": "384441",
      "Hajipur BO": "384170",
      "Vanagala BO": "384170",
      "Bamanva BO": "384355",
      "Chhabalia BO": "384355",
      "Molipur BO": "384355",
      "Undani BO": "384355",
      "Pudgam BO": "384310",
      "Tarabh BO": "384310",
      "Dabhala BO": "384565",
      "Titodan BO": "384565",
      "Hirpura BO": "384570",
      "Kot BO": "384570",
      "Navasangpur BO": "384570",
      "Rampur Kot BO": "384570",
      "Kamana BO": "384315",
      "Kuvasana BO": "384315",
      "Ralisana BO": "384315",
      "Saduthala BO": "384315",
      "Vadasan BO": "384530",
      "Saldi BO": "384465",
      "Boriavi BO": "384435",
      "Kanoda BO": "384412",
      "Ranela BO": "384412",
      "CHHATHIARDA B.O": "384005",
      "Khanusa BO": "384550",
      "Katosan BO": "384430",
      "Virsoda BO": "384430",
      "Fudeda BO": "384560",
      "Khanderaopura BO": "382115",
      "Bhalusana BO": "384330",
      "Sartanpur BO": "384330",
      "Timba BO": "384330",
      "Sobhasan BO": "384001",
      "Undhai BO": "384335",
      "Umari BO": "384340",
      "Manipur BO": "384441",
      "Vamaj BO": "384441",
      "Dasaj BO": "384170",
      "Karli BO": "384170",
      "Maktupur BO": "384170",
      "Tundav BO": "384170",
      "Badarpur BO": "384355",
      "Gundrasan BO": "384355",
      "Sultanpur BO": "384355",
      "Khandosan BO": "384310",
      "Padharia BO": "384565",
      "Aglod BO": "384570",
      "Ghantu Dhanpura BO": "384570",
      "Jepur BO": "384570",
      "Pedhamali BO": "384570",
      "Ranasan BO": "384570",
      "Gothva BO": "384315",
      "Jaska BO": "384315",
      "Kansa BO": "384315",
      "Rajgadh BO": "384315",
      "Rangakui BO": "384315",
      "Daran BO": "384445",
      "Jagnathpura BO": "384140",
      "Sagthala BO": "384325",
      "Jeshangpura BO": "384445",
      "Khavad BO": "384445",
      "Chada BO": "384325",
      "Chotia BO": "384325",
      "Dabhoda BO": "384325",
      "Rasulpur BO": "384325",
      "Kanzari BO": "384445",
      "Kolad BO": "384445",
      "Lhor BO": "384445",
      "Medha BO": "384445",
      "Vadharoda BO": "384445",
      "Chansol BO": "384325",
      "Dalisana BO": "384325",
      "Davol BO": "384325",
      "Keshimpa BO": "384325",
      "Mahiyal BO": "384325",
      "Mandropur BO": "384325",
      "Moti Hirvani BO": "384325",
      "Dharampur BO": "384445",
      "Vekra BO": "384445",
      "Balad BO": "384325",
      "Dabhad BO": "384325",
      "Nanivada BO": "384325",
      "Gadha BO": "384001",
      "Virta BO": "384001",
      "Dela BO": "384001",
      "Jornang BO": "384455",
      "Tundali BO": "384455",
      "Asjol BO": "384410",
      "Bamosana BO": "384120",
      "Bhatasan BO": "384450",
      "Devrasan BO": "384460",
      "Mevad BO": "384460",
      "Kherva BO": "384001",
      "Kansarakui BO": "384001",
      "Mitha BO": "384001",
      "Piludra BO": "384001",
      "Chaluva BO": "384455",
      "Dholasan BO": "384455",
      "BALIYASAN BO": "384455",
      "Deloli BO": "384410",
      "Nadasa BO": "384410",
      "Dodiwada BO": "384415",
      "Bokarwada BO": "384120",
      "Ganeshpura BO": "384450",
      "Jhulasan BO": "384450",
      "Khodamali BO": "384360",
      "Akhaj BO": "384460",
      "Punasan BO": "384460",
      "Sanganpur BO": "384460",
      "Mudarda BO": "384421",
      "Kharvada BO": "384305",
      "Balasar BO": "384440",
      "Karannagar BO": "384440",
      "Kundal BO": "384440",
      "Sujatpura BO": "384440",
      "Mulsan BO": "384460",
      "Khadalpur BO": "384421",
      "Manknaj BO": "384421",
      "Lacjjadi BO": "384305",
      "Magroda BO": "384305",
      "Savala BO": "384001",
      "Tareti BO": "384001",
      "Nagalpur BO": "384001",
      "Udalpur BO": "384001",
      "Bhasaria BO": "384455",
      "Dhanali BO": "384455",
      "Maguna BO": "384410",
      "Palaj BO": "384410",
      "Dethali BO": "384415",
      "Kalri BO": "384415",
      "Khambhei BO": "384415",
      "Venpura BO": "384415",
      "Butta Paldi BO": "384120",
      "Vishol BO": "384135",
      "Ghumasan BO": "384450",
      "Juni Sedhavi BO": "384450",
      "Kaiyal BO": "384450",
      "Hadol BO": "384360",
      "Pamol BO": "384520",
      "Bhesana BO": "384421",
      "Jakasana BO": "384421",
      "Dadhial BO": "384305",
      "Adundra BO": "384440",
      "Kaswa BO": "384440",
      "Sarsav BO": "384440",
      "Suraj BO": "384440",
      "Basana BO": "384001",
      "Meghaliasana BO": "384001",
      "Vadosan BO": "384001",
      "Dhamanva BO": "384001",
      "Gorad BO": "384001",
      "Sametra BO": "384001",
      "Lakhvad BO": "384001",
      "Rantej BO": "384410",
      "Ambala BO": "384415",
      "Chadasana BO": "384415",
      "Dedana BO": "384415",
      "Delvada Khant BO": "384415",
      "Sampawada BO": "384415",
      "Shankhalpur BO": "384415",
      "Surpura BO": "384415",
      "Davada BO": "384120",
      "Jetalvasana BO": "384120",
      "Moti Dau BO": "384120",
      "Varvada BO": "384135",
      "Karjisan BO": "384450",
      "Mathasul BO": "384450",
      "Nandasan BO": "384450",
      "Vadasma BO": "384450",
      "Vadu BO": "384450",
      "Malosan BO": "384515",
      "Tatosan BO": "384520",
      "Diwanpura BO": "384421",
      "Budasan BO": "384440",
      "Deusana BO": "384440",
      "Indrad BO": "384440",
      "Jasalpur BO": "384440",
      "Lunasan BO": "384440",
      "Nagrasan BO": "384440",
      "Nani Kadi BO": "384440",
      "Rajpur BO": "384440",
      "Sadra BO": "384440",
      "Vidaj BO": "384440",
      "Visatpur BO": "384440",
      "Lunva BO": "384130",
      "Agol BO": "384445",
      "Untva BO": "384440",
      "Bhunav BO": "384130",
      "Machhava BO": "384130",
      "Bavlu BO": "384445",
      "Mahervada BO": "384130",
      "Mahesana HO": "384001",
      "Ganpat Vidyanagar SO": "384012",
      "Jagudan SO": "384460",
      "Kadi Mkt Yard SO": "384440",
      "Kalyanpura SO": "384445",
      "Kheralu SO": "384325",
      "Kukarwada SO": "384530",
      "Langhnaj SO": "384465",
      "Linch SO": "384435",
      "Sipor SO": "384335",
      "Umta SO": "384320",
      "Unava SO": "384160",
      "Vasai Dabhala SO": "384565",
      "Brahmanwada SO": "384135",
      "Dharoi DSC SO": "384360",
      "Gavada SO": "384515",
      "Gerita Kolavda RS SO": "384520",
      "Jhotana SO": "384421",
      "Santhal SO": "384430",
      "Thol I E SO": "384441",
      "Unjha Umiya Mataji SO": "384170",
      "Vadnagar SO": "384355",
      "Valam SO": "384310",
      "Dangarwa SO": "384450",
      "Kada SO Mahesana": "384305",
      "Ladol SO": "384540",
      "Mahesana Bazar SO": "384001",
      "Mahesana Railway Colony SO": "384002",
      "Modhera SO": "384412",
      "PANCHOT S.O": "384005",
      "Sardarpur SO Mahesana": "384560",
      "Sundhia SO": "384345",
      "Vijapur Bazar SO": "384570",
      "Vijapur SO": "384570",
      "Visnagar Station Road SO": "384315",
      "Gozaria SO": "384470",
      "Kadi SO": "384440",
      "Kahoda SO": "384130",
      "Kamli SO": "384140",
      "Mahesana I E SO": "384002",
      "Mahesana JSM SO": "384001",
      "Mahesana Ongc Colony SO": "384003",
      "Pilvai SO": "384550",
      "Satlasana SO": "384330",
      "Sudasana SO": "384340",
      "Unjha Kotkuva SO": "384170",
      "Unjha SO": "384170",
      "Visnagar Market Yard SO": "384315",
      "Visnagar SO": "384315",
      "Bhandu SO": "384120",
      "Ambaliasan SO": "384455",
      "Becharaji SO": "384415",
      "Balol SO": "384410"
    },
    "BANAS KANTHA": {
      "Sanesada B.O": "385320",
      "CHODUNGARI B.O": "385505",
      "DHUNSOL BO": "385535",
      "Navi Sendhani B.O": "385421",
      "Manpuria BO": "385135",
      "Sarotra BO": "385135",
      "Motimahudi BO": "385545",
      "Panthawada BO": "385545",
      "Runi BO": "385320",
      "Vachhadal BO": "385545",
      "Viruna BO": "385545",
      "Nandotra BO": "385421",
      "Dungrasan BO": "385550",
      "Kakar BO": "385550",
      "Raviyana BO": "385550",
      "Umbari BO": "385550",
      "Benap BO": "385570",
      "Bharadva BO": "385570",
      "Kharia BO": "385555",
      "Motajampur BO": "385555",
      "Changda BO": "385565",
      "Charda BO": "385565",
      "Dodgam BO": "385565",
      "Moti Pavad BO": "385565",
      "Piluda BO": "385565",
      "Dhuva BO": "385540",
      "Jhabadia BO": "385540",
      "Lunpur BO": "385540",
      "Basu BO": "385520",
      "Changa BO": "385555",
      "Changwada BO": "385520",
      "Meta BO": "385520",
      "Bhadli Jhat BO": "385545",
      "Bhandotra BO": "385545",
      "Bhatram BO": "385545",
      "Dhaniawada BO": "385545",
      "Dalwana BO": "385421",
      "Gathaman BO": "385001",
      "Bhagal J BO": "385001",
      "Lunva BO": "385001",
      "Bamnoj BO": "385110",
      "Sagrosana BO": "385001",
      "Chadotar BO": "385001",
      "Sadarpur BO": "385001",
      "Dhanpura BO": "385001",
      "Hasanpur BO": "385001",
      "Malan BO": "385001",
      "Bhagal P BO": "385001",
      "Karjoda BO": "385001",
      "Koteshwar BO": "385110",
      "Ranpur BO": "385110",
      "Balodhan BO": "385320",
      "Eta BO": "385320",
      "Jasanwada BO": "385320",
      "Radka BO": "385320",
      "Tanvad BO": "385320",
      "Uchosan BO": "385320",
      "Vajapur Juna BO": "385320",
      "Mudetha BO": "385530",
      "Kushkal BO": "385510",
      "Bavalchudi BO": "385210",
      "Mahi BO": "385210",
      "Teniwada BO": "385210",
      "Bhatamalmoti BO": "385010",
      "Ranavas BO": "385010",
      "Dhanali BO": "385120",
      "Gorad BO": "385120",
      "Kukadi BO": "385120",
      "Moria N BO": "385120",
      "Mumanvas BO": "385120",
      "Pethapur BO": "385120",
      "Sandhosi BO": "385120",
      "Vijlasan BO": "385120",
      "Bhadlikotha BO": "385505",
      "Bhilachal BO": "385505",
      "Jada BO": "385330",
      "Jasali BO": "385330",
      "Ludra BO": "385330",
      "Dholia BO": "385135",
      "Kapasia BO": "385135",
      "Alwada BO": "385545",
      "Arkhi BO": "385545",
      "Kuchawada BO": "385545",
      "Mandal BO": "385545",
      "Vachhol BO": "385545",
      "Kodram BO": "385421",
      "Navisana BO": "385421",
      "Pepol BO": "385421",
      "Vansol BO": "385421",
      "Hoda BO": "385001",
      "Vadhana BO": "385001",
      "Vasan BO": "385001",
      "Malana BO": "385001",
      "Ratanpur Lokniketan BO": "385001",
      "Sangra BO": "385001",
      "Vagda BO": "385001",
      "Virampur BO": "385001",
      "Hathidra BO": "385001",
      "Jagana BO": "385001",
      "Sanali BO": "385110",
      "Sembalpani BO": "385110",
      "Kuvala BO": "385320",
      "Mitha BO": "385320",
      "Balodhar BO": "385530",
      "Chhatrala BO": "385530",
      "Lorwada BO": "385530",
      "Peplu BO": "385530",
      "Khodla BO": "385550",
      "Vaghrol BO": "385510",
      "Vedancha BO": "385510",
      "Bhakhari BO": "385566",
      "Kuvarshi BO": "385120",
      "Vasi BO": "385120",
      "Dantiwada BO": "385505",
      "Dhagadia BO": "385110",
      "Hadad BO": "385110",
      "Jamru BO": "385110",
      "Jodhsar BO": "385110",
      "Panchha BO": "385110",
      "Barvala BO": "385320",
      "Chatra BO": "385320",
      "Chembuva BO": "385320",
      "Dhrechana BO": "385320",
      "Ruvel BO": "385320",
      "Soneth BO": "385320",
      "Suthar Nesdi BO": "385320",
      "Tervada BO": "385320",
      "Varasada BO": "385320",
      "Bhakhar moti BO": "385510",
      "Dangia BO": "385510",
      "Majadar BO": "385210",
      "Manpura BO": "385210",
      "Pasvadal BO": "385210",
      "Pirojpura BO": "385210",
      "MALOSANA BO": "385210",
      "Saghankshetra BO": "385010",
      "Jaswant Gadh BO": "385120",
      "Jitpur BO": "385120",
      "Kundel BO": "385120",
      "Navovas BO": "385120",
      "Punjpur BO": "385120",
      "Rangpur BO": "385120",
      "Golvi BO": "385330",
      "Nokha BO": "385330",
      "Jegol BO": "385505",
      "Odhava BO": "385505",
      "Dhanakwada BO": "385330",
      "Duchakwada BO": "385330",
      "Forna BO": "385330",
      "Paldi BO": "385330",
      "Balundra BO": "385135",
      "Jethi BO": "385135",
      "Khardosan BO": "385540",
      "Vasna BO": "385540",
      "Badarpura BO": "385520",
      "Takarwada BO": "385520",
      "Anapur Chhota BO": "385545",
      "Bapla BO": "385545",
      "Gundri BO": "385545",
      "Jhat BO": "385545",
      "Kumar BO": "385545",
      "Bhalgam BO": "385560",
      "Kaleda BO": "385421",
      "Panchada BO": "385421",
      "Vesa BO": "385421",
      "Kidotar BO": "385130",
      "Bukoli BO": "385550",
      "Khoda BO": "385565",
      "Manpur BO": "385550",
      "Chekhla BO": "385550",
      "Kunvarva BO": "385550",
      "Laxmipura BO": "385550",
      "Raner BO": "385550",
      "Limbuni BO": "385570",
      "Isarva BO": "385555",
      "Vada BO": "385555",
      "Chudmer BO": "385565",
      "Jamda BO": "385565",
      "Madal BO": "385565",
      "Sanavia BO": "385565",
      "Vadgamda BO": "385565",
      "Dhota BO": "385421",
      "Ghodiyal BO": "385421",
      "Gidasan BO": "385421",
      "Pilucha BO": "385421",
      "Rupal BO": "385421",
      "Sendhani BO": "385421",
      "Sisrana BO": "385421",
      "Dabhela BO": "385130",
      "Kamboi BO": "385550",
      "Khimana BO": "385550",
      "Zalmor BO": "385550",
      "Chala BO": "385570",
      "JALOYA BO": "385570",
      "Jakhel BO": "385555",
      "Kasara BO": "385555",
      "Bevta BO": "385565",
      "Kamali BO": "385565",
      "Khengarpura BO": "385565",
      "Malupur BO": "385565",
      "Mota Mesra BO": "385565",
      "Padardi BO": "385550",
      "Kumbharkha BO": "385570",
      "Mamana BO": "385570",
      "Radosan BO": "385570",
      "Aganwada BO": "385555",
      "Nathpura BO": "385555",
      "Asodar BO": "385565",
      "Bhordu BO": "385565",
      "Dudhva BO": "385565",
      "Lalpur BO": "385565",
      "Luvana BO": "385565",
      "Undrana BO": "385565",
      "Dhandha BO": "385001",
      "Moria  P BO": "385001",
      "Jalotra BO": "385001",
      "Lalawada BO": "385001",
      "Garambadi BO": "385320",
      "Katav BO": "385320",
      "Madhpura BO": "385320",
      "Morvada BO": "385320",
      "Ujanwada BO": "385320",
      "Undai BO": "385320",
      "Khentva BO": "385530",
      "Nesdajuna BO": "385530",
      "Kumbhalmer BO": "385510",
      "Madana Dangia  BO": "385510",
      "Mota BO": "385510",
      "Edrana BO": "385210",
      "Timbachudi BO": "385210",
      "Antroli BO": "385010",
      "Bhutedi BO": "385010",
      "Dalpura BO": "385120",
      "Gangva BO": "385120",
      "Mankadi BO": "385120",
      "Motasada BO": "385120",
      "Bhakodar BO": "385505",
      "Bhesana BO": "385330",
      "Chibhada BO": "385330",
      "Jalodha BO": "385330",
      "Kotarwada BO": "385330",
      "Bhadrewadi BO": "385560",
      "Jasleni BO": "385410",
      "Magarwada BO": "385410",
      "Bukna BO": "385575",
      "Dethli BO": "385575",
      "Dharadhara BO": "385575",
      "Tithgam BO": "385575",
      "Vavdi BO": "385575",
      "Vami BO": "385565",
      "Mandla BO": "385560",
      "Valpura BO": "385560",
      "Asara BO": "385575",
      "Baluntri BO": "385575",
      "Jelana BO": "385575",
      "Kundaliya BO": "385575",
      "Madka BO": "385575",
      "Valadar BO": "385565",
      "Siya BO": "385560",
      "Tatiyana BO": "385560",
      "Badargadh BO": "385410",
      "Gola BO": "385410",
      "Baiyak BO": "385575",
      "Bhachali BO": "385575",
      "Golgam BO": "385575",
      "Lodrani BO": "385575",
      "Morikha BO": "385575",
      "Padar BO": "385560",
      "Totana BO": "385560",
      "Chhaniyana BO": "385410",
      "Semodra BO": "385410",
      "Bhatvar BO": "385575",
      "Dendava BO": "385575",
      "Padan BO": "385575",
      "Vasarda BO": "385575",
      "Chalva BO": "385330",
      "Lavana BO": "385330",
      "Rantila BO": "385330",
      "Dhakha BO": "385310",
      "Jiwana BO": "385310",
      "Kherola BO": "385310",
      "Lavara BO": "385310",
      "Malotra BO": "385310",
      "Morthal BO": "385310",
      "Nandla BO": "385310",
      "Nani BO": "385310",
      "Nenava BO": "385310",
      "Pechhadal BO": "385310",
      "Bhorol BO": "385566",
      "Idhata BO": "385566",
      "Karbun BO": "385566",
      "Mavsari BO": "385566",
      "Savapura BO": "385566",
      "Sherau BO": "385566",
      "Tadav BO": "385566",
      "Vaghasan BO": "385566",
      "Bhoyan BO": "385535",
      "Chekra BO": "385535",
      "Disa MY Pedal BO": "385535",
      "Ghada BO": "385535",
      "Raiya BO": "385330",
      "Ravel BO": "385330",
      "Dugdol BO": "385310",
      "Ghana BO": "385310",
      "Ghodasar BO": "385310",
      "Jadia BO": "385310",
      "Rah BO": "385310",
      "Ramsan BO": "385310",
      "Saral BO": "385310",
      "Sia BO": "385310",
      "Thavar BO": "385310",
      "Vinchhivadi BO": "385310",
      "Zenal BO": "385310",
      "Akoli BO": "385566",
      "Agthala BO": "385535",
      "Asarda BO": "385535",
      "Bhachalva BO": "385535",
      "Katarva BO": "385535",
      "Kotda BO": "385535",
      "Kuda BO": "385535",
      "Lakhani BO": "385535",
      "Mahadevia BO": "385535",
      "Soni BO": "385330",
      "Surana BO": "385330",
      "Vatamjuna BO": "385330",
      "Bhanjana BO": "385310",
      "Duva BO": "385310",
      "Vakha BO": "385330",
      "Bhatib BO": "385310",
      "Dharnodhar BO": "385310",
      "Jadi BO": "385310",
      "Kuvarla BO": "385310",
      "Raviya BO": "385310",
      "Chuva BO": "385566",
      "Gadsisar BO": "385566",
      "Rampura BO": "385566",
      "Sapreda BO": "385566",
      "Bhadramali BO": "385535",
      "Jetda BO": "385535",
      "Kansari BO": "385535",
      "Odhava D BO": "385535",
      "Rampura Disa BO": "385535",
      "Thervada BO": "385535",
      "Tintoda BO": "385535",
      "Dalwada BO": "385515",
      "Ranpur Vvas BO": "385535",
      "Rasana Mota BO": "385535",
      "Robas Moti BO": "385535",
      "Samau BO": "385535",
      "Vasana Vatam BO": "385535",
      "Jadiali BO": "385310",
      "Samarvada BO": "385310",
      "Valer BO": "385310",
      "Daiyap BO": "385566",
      "Naroli BO": "385566",
      "Sanval BO": "385566",
      "Baiwada BO": "385535",
      "Bhadath BO": "385535",
      "Jherda BO": "385535",
      "Kapramota BO": "385535",
      "Malgadh BO": "385535",
      "Vithodar BO": "385535",
      "Patosan BO": "385515",
      "Salla BO": "385515",
      "Samdhi BO": "385515",
      "Nagfana BO": "385535",
      "Rajpur Disa BO": "385535",
      "Saviyana BO": "385535",
      "Varnoda BO": "385535",
      "Kumbhasan BO": "385515",
      "Madana BO": "385515",
      "Sasam BO": "385515",
      "Velavapura BO": "385535",
      "Palanpur HO": "385001",
      "Danta Bhavangadh SO": "385120",
      "Deodar SO": "385330",
      "Kanodar SO": "385520",
      "Shri Amirgadh SO": "385130",
      "Tharad SO": "385565",
      "Bhabhar SO": "385320",
      "Chhapi SO": "385210",
      "Chitrasani SO": "385010",
      "Disa Bazar SO": "385535",
      "Disa Mukhya Dak Ghar SO": "385535",
      "Gadh SO": "385515",
      "Khimat SO": "385545",
      "Memadpur SO": "385421",
      "Palanpur Ganjbazar SO": "385001",
      "Palanpur Kamalpura SO": "385001",
      "Palanpur Kirtistambh SO": "385001",
      "Sihori SO": "385550",
      "Suigam SO": "385570",
      "Un SO Banaskantha": "385560",
      "Ambaji SO": "385110",
      "Bhildi SO": "385530",
      "Chandisar SO": "385510",
      "Dantiwada Colony SO": "385505",
      "Dhanera SO": "385310",
      "Dhima SO": "385566",
      "Palanpur Delhigate SO": "385001",
      "Thara SO": "385555",
      "Iqbalgadh SO": "385135",
      "Junadisa SO": "385540",
      "Sardar Krishinagar SO": "385506",
      "Vadgam SO": "385410",
      "Vav SO": "385575"
    },
    "GANDHINAGAR": {
      "Antoli B.O": "382315",
      "Dantali B.O": "382122",
      "Suja na Muvada B.O": "382315",
      "Sughad BO": "382424",
      "Limbadia BO": "382330",
      "Nana Chiloda BO": "382330",
      "Rancharada BO": "382115",
      "Medra BO": "382330",
      "Vavol BO": "382016",
      "Sargasan BO": "382421",
      "Chiskari BO": "382308",
      "Harsoli BO": "382305",
      "Kadodara BO": "382305",
      "Karoli BO": "382305",
      "Shertha BO": "382423",
      "Piplaj BO": "382315",
      "Dharisana BO": "382315",
      "Jindva BO": "382315",
      "Juval BO": "382220",
      "Devkaran Na Muvada BO": "382308",
      "Ghamij BO": "382308",
      "Motipura BO": "382308",
      "Chandrala BO": "382321",
      "Chekhala Pagi BO": "382321",
      "Giyod BO": "382321",
      "Alampur BO": "382042",
      "Lekawada BO": "382042",
      "Dhanap BO": "382355",
      "Galudan BO": "382355",
      "Isanpurmota BO": "382355",
      "Lavarpur BO": "382355",
      "Prantiya BO": "382355",
      "Anguthala BO": "382305",
      "Salki BO": "382305",
      "Vadvasa BO": "382305",
      "Vasna Rathod BO": "382305",
      "Navanagar BO": "382315",
      "Patna Kuva BO": "382315",
      "Sampa BO": "382315",
      "Kolavada BO": "382028",
      "Kasturba Vidyalaya BO": "382426",
      "Raysan BO": "382426",
      "Ambapur BO": "382421",
      "Por BO": "382421",
      "Baria BO": "382308",
      "Kanipur BO": "382308",
      "Siawada BO": "382308",
      "Nana Jalundra BO": "382321",
      "Chiloda BO": "382355",
      "Palaj BO": "382355",
      "Shiholi Moti BO": "382355",
      "Valad BO": "382355",
      "Harkhji Na Muvada BO": "382305",
      "Jalia No Math BO": "382305",
      "Lavad BO": "382305",
      "Mota Jalundra BO": "382305",
      "Jamiyatpura BO": "382423",
      "Pindarda BO": "382610",
      "Indroda BO": "382007",
      "Randesan BO": "382426",
      "Kudasan BO": "382421",
      "Simandhar City BO": "382010",
      "Hilol BO": "382308",
      "Isanpurdodia BO": "382308",
      "Palundra BO": "382308",
      "Vasna  Sogthi BO": "382308",
      "Halisa BO": "382321",
      "Vasnachaudhary BO": "382321",
      "Basan BO": "382355",
      "Dashela BO": "382355",
      "Magodi BO": "382355",
      "Shahpur BO": "382355",
      "Vadodara BO": "382355",
      "Amrajinamuvada BO": "382305",
      "Bardolikoti BO": "382305",
      "Nandol BO": "382305",
      "Sanoda BO": "382305",
      "Khanpur BO": "382315",
      "Masang Moti BO": "382315",
      "Sametri BO": "382315",
      "Udan BO": "382315",
      "Juval Rupavati BO": "382220",
      "Kadjodara BO": "382315",
      "Lihoda BO": "382315",
      "Rakhial BO": "382315",
      "Sahebji Na  Muvada BO": "382315",
      "Madhavgadh BO": "382320",
      "Tintoda BO": "382422",
      "Serisa BO": "382725",
      "Solaiya BO": "382810",
      "Ambod BO": "382845",
      "Bapupura BO": "382845",
      "Boru BO": "382845",
      "Golthara BO": "382735",
      "Isand BO": "382740",
      "Limbodra BO": "382650",
      "Palsana BO": "382725",
      "Ramnagar BO": "382725",
      "Borisana BO": "382725",
      "Hajipur BO": "382725",
      "Vadsar Air Force BO": "382722",
      "Ajol BO": "382810",
      "Bilodra BO": "382810",
      "Delvada BO": "382810",
      "Rangpur BO": "382835",
      "Badpura BO": "382845",
      "Dholakuva BO": "382845",
      "Manekpura BO": "382845",
      "Amja BO": "382735",
      "Khoraj BO": "382735",
      "Paliyed  Veda BO": "382735",
      "Dhamasana BO": "382740",
      "Mokhasan BO": "382740",
      "Veda BO": "382855",
      "Jakhora BO": "382320",
      "Mubarakpura BO": "382650",
      "Amrapur Gram Bharti BO": "382650",
      "Jaspur BO": "382725",
      "Jethlaj BO": "382722",
      "Chadasana BO": "382810",
      "Lakroda BO": "382835",
      "Fatepura BO": "382845",
      "Jamla BO": "382735",
      "Kotha BO": "382735",
      "Dingucha BO": "382740",
      "Anodia BO": "382855",
      "Mahudi BO": "382855",
      "Dolarana Vasna BO": "382320",
      "Adrajmoti BO": "382640",
      "Vasan BO": "382650",
      "Aluva BO": "382650",
      "Bhoyan Rathod BO": "382422",
      "Pundrasan BO": "382422",
      "Vadsar BO": "382722",
      "Bhoyan  Moti BO": "382725",
      "Khatraj I E BO": "382722",
      "Balva BO": "382721",
      "Piyaj BO": "382725",
      "Saij BO": "382725",
      "Vihar BO": "382810",
      "Padusma BO": "382810",
      "Samau BO": "382810",
      "Ridrol BO": "382835",
      "Varsoda BO": "382835",
      "Indrapura BO": "382845",
      "Itadar BO": "382845",
      "Kharana BO": "382845",
      "Parbatpura BO": "382845",
      "Parsa BO": "382845",
      "Pratapnagar BO": "382845",
      "Vagosana BO": "382845",
      "Soja BO": "382735",
      "Veda   Paliyed BO": "382735",
      "Khadat BO": "382855",
      "Gandhinagar Gujarat HO": "382010",
      "Kalol HO": "382721",
      "Gandhinagar Sector 24 SO": "382024",
      "Gandhinagar Sector 30 SO": "382030",
      "Gandhinagar Sector 9 SO": "382007",
      "Chhala SO": "382321",
      "Randheja SO": "382620",
      "Sadra SO": "382320",
      "Vidhansabha SO": "382010",
      "Gift City SO": "382355",
      "Charada SO": "382810",
      "Nardipur SO": "382735",
      "Pansar SO": "382740",
      "Gandhinagar Sector 16 SO": "382016",
      "Gandhinagar Sector 17 SO": "382016",
      "Gandhinagar Sector 19 SO": "382021",
      "Gandhinagar Sector 22 SO": "382021",
      "Gandhinagar Sector 23 SO": "382024",
      "Bahiyal SO": "382308",
      "BSF GANDHINAGAR SO": "382045",
      "Jawaharmarket Dehgam SO": "382305",
      "Pethapur SO": "382610",
      "Sardhav SO": "382640",
      "Thermal Power Station SO": "382041",
      "Unava  Balva SO": "382650",
      "Kalol Society Area SO": "382721",
      "Mansa Bazar SO": "382845",
      "Pundhara SO": "382855",
      "Gandhinagar Sector 7 SO": "382007",
      "Dehgam SO": "382305",
      "Kasturinagar SO": "382423",
      "Uvarsad SO": "382422",
      "Koba SO": "382426",
      "Kalol Gandhi Road SO": "382721",
      "Kalol Industrial Estate SO": "382725",
      "Lodra SO": "382835",
      "Mansa SO Gandhi Nagar": "382845",
      "Gandhinagar Sector 21 SO": "382021",
      "Gandhinagar Sector 28 SO": "382028",
      "Gandhinagar Sector 29 SO": "382030",
      "Gandhinagar Sector 6 SO": "382006",
      "Gandhinagar Sector 8 SO": "382007",
      "Adalaj SO": "382421",
      "CRPF Campus G Nagar SO": "382042",
      "Dabhoda SO": "382355",
      "New Sachivalaya Complex SO": "382010",
      "Rakhial RS SO": "382315",
      "Rupal SO": "382630",
      "Chhatral SO": "382729",
      "Santej SO": "382722"
    },
    "PATAN": {
      "Jesda BO": "384241",
      "Kunvar BO": "384241",
      "Sipur BO": "384241",
      "Tuvad BO": "384241",
      "D RS BO": "385340",
      "Gochnath BO": "385340",
      "Javantri BO": "385340",
      "Masali BO": "385340",
      "Nani Pipli BO": "385340",
      "Subapura BO": "385340",
      "Matpur BO": "384275",
      "Ruvavi BO": "384275",
      "Dudkha BO": "384245",
      "Gajdinpura BO": "384245",
      "Kanij BO": "384245",
      "Varana BO": "384245",
      "Dantisana BO": "384246",
      "Padla BO": "384246",
      "Madhutra BO": "385350",
      "Piprana BO": "385350",
      "Bepadar BO": "384272",
      "Sampra BO": "384272",
      "Bilia BO": "384240",
      "Meloj BO": "384151",
      "Tavadia BO": "384151",
      "Agichana BO": "385360",
      "Gotarka BO": "385360",
      "Jakhel BO": "385360",
      "Korda BO": "385360",
      "Zandala BO": "385360",
      "Endla BO": "384285",
      "Khareda BO": "384285",
      "Vadu BO": "384285",
      "Vayad BO": "384285",
      "Khijdiyari BO": "384241",
      "Kunvarad BO": "384241",
      "Allahabad BO": "385340",
      "Dharvadi BO": "385340",
      "Ganjisar BO": "385340",
      "Kamalpur D BO": "385340",
      "Memdavad BO": "385340",
      "Santhli BO": "385340",
      "Sinad BO": "385340",
      "Norta BO": "384275",
      "Samoda BO": "384151",
      "Adgam BO": "384245",
      "Anvarpura BO": "384245",
      "Chandur Nani BO": "384245",
      "Daudpur BO": "384245",
      "Gujarwada BO": "384245",
      "Samsherpura BO": "384245",
      "Dhanora BO": "384246",
      "Panchasar BO": "384246",
      "Charanka BO": "385350",
      "Dhokavada BO": "385350",
      "Jakhotra BO": "385350",
      "Chandravati BO": "384151",
      "Kholvada BO": "384151",
      "Sedrana BO": "384151",
      "Umru BO": "384151",
      "Chhamichha BO": "384221",
      "Abiyana BO": "385360",
      "Babra BO": "385360",
      "Gokhantar BO": "385360",
      "Sidhada BO": "385360",
      "Zazam BO": "385360",
      "Dharusan BO": "384285",
      "Jangral BO": "384285",
      "Raviyana BO": "384285",
      "Vahana BO": "384285",
      "Chandur Moti BO": "384241",
      "Bhilot BO": "385340",
      "Chalvada BO": "385340",
      "Kamalpur S BO": "385340",
      "Koliwada BO": "385340",
      "Nanpura BO": "385340",
      "Radhanpur Rly Colony BO": "385340",
      "Satun BO": "385340",
      "Borsan BO": "384275",
      "Ganget BO": "384275",
      "Islampura BO": "384275",
      "Amrapuara BO": "384245",
      "Baspa BO": "384245",
      "Bhadrada BO": "384245",
      "Dadar BO": "384245",
      "Detrana BO": "385350",
      "Garambadi BO": "385350",
      "Vadhana BO": "384151",
      "Vanasan BO": "384151",
      "Varsila BO": "384151",
      "Maniyari BO": "384221",
      "Mithi Gariyal BO": "384221",
      "Takodi BO": "384221",
      "Bamroli BO": "385360",
      "Dholakda BO": "385360",
      "Gadha BO": "385360",
      "Gadsai BO": "385360",
      "Zekhada BO": "385360",
      "Abluva BO": "384285",
      "Bhatsan BO": "384285",
      "Bhilvan BO": "384285",
      "Charup BO": "384285",
      "Lolada BO": "384241",
      "Loteshwar BO": "384241",
      "Memna BO": "384241",
      "Ranod BO": "384241",
      "Taranagar BO": "384241",
      "Arjansar BO": "385340",
      "Bandhvad BO": "385340",
      "Lodra BO": "385340",
      "Lotia BO": "385340",
      "Moti Pipli BO": "385340",
      "Sander BO": "384275",
      "Sankhari BO": "384275",
      "Vasai BO": "384275",
      "Mandvi BO": "384245",
      "Mota Joravarpura BO": "384245",
      "Nayka BO": "384245",
      "Rafu BO": "384245",
      "Ranavada BO": "384245",
      "Ved BO": "384245",
      "Zilvana BO": "384245",
      "Bolera BO": "384246",
      "Par BO": "385350",
      "Vahuva BO": "385350",
      "Goliwada BO": "384272",
      "Undra BO": "384272",
      "Veloda BO": "384272",
      "Dethli BO": "384151",
      "Gangalasan BO": "384151",
      "Ganvada BO": "384151",
      "Khali BO": "384151",
      "Mudana BO": "384151",
      "Nagvasana BO": "384151",
      "Nandotri BO": "384151",
      "Nedra BO": "384151",
      "Jarusha BO": "385360",
      "Kilana BO": "385360",
      "Khodana BO": "384285",
      "Kimbuva BO": "384285",
      "Koita BO": "384285",
      "Laxmipura BO": "384285",
      "Morpa BO": "384285",
      "Muna BO": "384285",
      "Aghar BO": "384265",
      "Dharpur BO": "384265",
      "Kansa BO": "384265",
      "Kalyana BO": "384265",
      "Dunawada BO": "384265",
      "Rampura BO": "384265",
      "Kamliwada BO": "384265",
      "Sagodiya BO": "384265",
      "Der BO": "384110",
      "Kani BO": "384110",
      "Brahmanwada BO": "384220",
      "Zilia BO": "384225",
      "Boratwada BO": "384240",
      "Dhadhana BO": "384240",
      "Ekalva BO": "384240",
      "Jamanpur BO": "384240",
      "Jasomav BO": "384240",
      "Nana BO": "384240",
      "Nava Manka BO": "384240",
      "Piplana BO": "384240",
      "Ravad BO": "384240",
      "Ravindra BO": "384240",
      "Roda BO": "384240",
      "Pindharpura BO": "384229",
      "Katra Samal BO": "384265",
      "Sujnipur BO": "384265",
      "Ajimana BO": "384265",
      "Kotavad BO": "384265",
      "Mesar BO": "384265",
      "Khorsam BO": "384220",
      "Mithi Vavdi BO": "384220",
      "Ruppur BO": "384220",
      "Sevala BO": "384220",
      "Chaveli BO": "384225",
      "Keshni BO": "384225",
      "Kathi BO": "384240",
      "Khakhal BO": "384240",
      "Kukrana BO": "384240",
      "Matrota BO": "384240",
      "Vansa BO": "384240",
      "Vejawada BO": "384240",
      "Dindrol BO": "384290",
      "Methan BO": "384290",
      "Metrana BO": "384290",
      "Mudvada BO": "384290",
      "Adiya BO": "384255",
      "Khanpur Rajkuva BO": "384255",
      "Khari Vavdi BO": "384255",
      "Mitha Dharva BO": "384229",
      "Palasar BO": "384229",
      "Dhanawada BO": "384265",
      "Kunwara BO": "384265",
      "Vamaiya BO": "384265",
      "Dasawada BO": "384265",
      "Rajpur BO": "384265",
      "Anawada BO": "384265",
      "Dhanodharda BO": "384220",
      "Jakhana BO": "384220",
      "Danodarda BO": "384225",
      "Pimpal BO": "384225",
      "Aritha BO": "384240",
      "Jasvantpura BO": "384240",
      "Katra BO": "384240",
      "Kumbhana BO": "384240",
      "Sarval BO": "384240",
      "Vaghel BO": "384240",
      "Sahesa BO": "384290",
      "Itoda BO": "384230",
      "Sodhav BO": "384230",
      "Chandrumana BO": "384255",
      "Sankra BO": "384255",
      "Odhva BO": "384265",
      "Pachakvada BO": "384265",
      "Hansapur BO": "384265",
      "Nayta BO": "384265",
      "Dharnoj BO": "384265",
      "Vadli BO": "384265",
      "Runi BO": "384265",
      "Dharmoda BO": "384220",
      "Jitoda BO": "384220",
      "Sunsar BO": "384225",
      "Juna Manka BO": "384240",
      "Tarora BO": "384240",
      "Vagosan BO": "384240",
      "Delmal BO": "384230",
      "Khari Ghariayal BO": "384220",
      "Tambolia BO": "384230",
      "Kureja BO": "384255",
      "Patan HO": "384265",
      "Harij SO": "384240",
      "Kamboi SO": "384230",
      "Patan H N G University SO": "384265",
      "Patan Siddhraj Road SO": "384265",
      "Patan Three Gate SO": "384265",
      "Sankheshwar SO": "384246",
      "Santalpur SO": "385350",
      "Sidhpur Jafri Baug SO": "384151",
      "Vadavali SO": "384221",
      "Kakoshi SO": "384290",
      "Kungher SO": "384255",
      "Lanva SO": "384229",
      "Mujpur SO": "384241",
      "Radhanpur SO": "385340",
      "Sidhpur Jam Chakla SO": "384151",
      "Sidhpur Market Yard SO": "384151",
      "Wagdod SO": "384285",
      "Balisana SO": "384110",
      "Chanasma SO": "384220",
      "Dhinoj SO": "384225",
      "Manund SO": "384260",
      "Patan Rajkawada SO": "384265",
      "Sidhpur SO": "384151",
      "Varahi SO": "385360",
      "Patan City SO": "384265",
      "Radhanpur Rajgadhi SO": "385340",
      "Ranuj SO": "384275",
      "Sami SO": "384245",
      "Sariyad SO": "384272"
    },
    "NARMADA": {
      "Navapura BO": "393140",
      "Taropa BO": "393140",
      "Timbi BO": "393140",
      "Boridra BO": "393145",
      "Jior BO": "393150",
      "Mangrol BO": "393150",
      "Sehrav BO": "393150",
      "Tankari BO": "393150",
      "Khardipada BO": "393130",
      "Navra BO": "393140",
      "Amletha BO": "393140",
      "Dholar BO": "393140",
      "Kandroj BO": "393140",
      "Vaghodia BO": "393140",
      "Bhadam BO": "393145",
      "Gamkuva BO": "393140",
      "Nava Rajuvadia BO": "393140",
      "Vaghetha BO": "393140",
      "Virpore BO": "393140",
      "Bitada BO": "393145",
      "Kareli BO": "393151",
      "Kothi BO": "393151",
      "Mithivav BO": "393151",
      "Orpa BO": "393151",
      "Pantalavdi BO": "393151",
      "Vagharali BO": "393151",
      "Vaviala BO": "393151",
      "Panchla BO": "393151",
      "Almawadi BO": "393130",
      "Akteshwar BO": "393151",
      "Khadagada BO": "393151",
      "Songam BO": "393151",
      "Undava BO": "393151",
      "Zariawadi BO": "393151",
      "Babda BO": "393130",
      "Panuda BO": "393130",
      "Garudeshwar BO": "393151",
      "Pichhipura BO": "393151",
      "Suka BO": "393151",
      "Mandala BO": "393130",
      "Zak BO": "393130",
      "Kantharpura BO": "391120",
      "Puchhpura BO": "391120",
      "Rengan BO": "391120",
      "Vadia BO": "391120",
      "Vandh BO": "391120",
      "Vyadhar BO": "391120",
      "Savli BO": "391120",
      "Shira BO": "391120",
      "Kamsoli BO": "391120",
      "Moria BO": "391120",
      "Ambalia BO": "391120",
      "Bujetha BO": "391120",
      "Nalia BO": "391120",
      "Agar BO": "391120",
      "Chudeshwar BO": "391120",
      "Gamod BO": "391120",
      "Namaria BO": "391120",
      "Alwa BO": "391120",
      "Bhadarwa BO": "391120",
      "Uchad BO": "391120",
      "Fatepura BO": "391120",
      "Jalodra BO": "391120",
      "Dhamnacha BO": "393145",
      "Jesalpore BO": "393145",
      "Fulvadi BO": "393145",
      "Gadit BO": "393145",
      "Gopalpura BO": "393145",
      "Hajarpura BO": "393145",
      "Bhoramli BO": "393050",
      "Borda BO": "393050",
      "Mahupada BO": "393050",
      "Moti Devrupan BO": "393050",
      "Pat BO": "393050",
      "Patnamau BO": "393050",
      "Kolvan BO": "393025",
      "Langdi BO": "393025",
      "Nevdiamba BO": "393025",
      "Palaswada BO": "393025",
      "Patna BO": "393145",
      "Vavdi BO": "393145",
      "Chopadvav BO": "393050",
      "Godada BO": "393050",
      "Mahunipada BO": "393050",
      "Sorapada BO": "393050",
      "Ubharia BO": "393050",
      "Dhavliver BO": "393025",
      "Kherpada BO": "393025",
      "Umarva BO": "393120",
      "Rundh BO": "393145",
      "Samaria BO": "393145",
      "Sisodra BO": "393145",
      "Sunderpura BO": "393145",
      "Devsaki BO": "393050",
      "Kuilivel BO": "393050",
      "Vajpur BO": "393050",
      "Ambagam BO": "393025",
      "Dhanpore BO": "393145",
      "Ori BO": "393145",
      "Poicha BO": "393145",
      "Thali BO": "393145",
      "Amiyar BO": "393050",
      "Khopi BO": "393050",
      "Rozdev BO": "393050",
      "Tawal BO": "393050",
      "Barktura BO": "393025",
      "Jaoli BO": "393025",
      "Rajnivad BO": "393025",
      "Dabhvan BO": "393041",
      "Gangapur BO": "393041",
      "Jargam BO": "393041",
      "Kakadpada BO": "393041",
      "Mota Sukamba BO": "393040",
      "Pansar BO": "393040",
      "Piplod BO": "393040",
      "Samarpada BO": "393040",
      "Solia BO": "393040",
      "Limdi BO": "393151",
      "Chikda BO": "393041",
      "Kevdi BO": "393041",
      "Moskut BO": "393041",
      "Sabuti BO": "393041",
      "Ghantoli BO": "393040",
      "Kanbudi BO": "393040",
      "Pangam BO": "393040",
      "Patvali BO": "393040",
      "Samot BO": "393040",
      "Sukvel BO": "393040",
      "Bhilvashi BO": "393151",
      "Indravarna BO": "393151",
      "Zarwani BO": "393151",
      "Kukdada BO": "393041",
      "Nani Bedvan BO": "393041",
      "Umran BO": "393041",
      "Juna Mosada BO": "393040",
      "Khokhraumar BO": "393040",
      "Zarnawadi BO": "393040",
      "Gora BO": "393151",
      "Besna BO": "393040",
      "Bogaj BO": "393040",
      "Dumkhal BO": "393040",
      "Fulsar BO": "393040",
      "Chopdi BO": "393040",
      "Vora BO": "391120",
      "Vagheli BO": "391120",
      "Vanmala BO": "391120",
      "Sevada BO": "391120",
      "Utavali BO": "391120",
      "Vajiria BO": "391120",
      "DEVALIYA B.O": "391120",
      "Tilakwada SO": "391120",
      "Dediapada SO": "393040",
      "Kevadia Colony SO": "393151",
      "Ambawadi SO Bharuch": "393041",
      "Lachharas SO": "393150",
      "Selamba SO": "393025",
      "Rajpipla SO": "393145",
      "Pratap Nagar SO Narmada": "393140",
      "Sagbara SO": "393050"
    },
    "BHARUCH": {
      "Narnavi BO": "392165",
      "Haldarva BO": "392011",
      "Kisnad BO": "392220",
      "Ravidra BO": "394115",
      "Goratia BO": "393115",
      "Sarsa BO": "393115",
      "Simalia BO": "392220",
      "Vadkhunta BO": "393115",
      "Vanakpore BO": "393115",
      "Vankol BO": "393115",
      "Sayan BO": "393030",
      "Shera BO": "393030",
      "Vaghvan BO": "393030",
      "Valner BO": "393030",
      "Asarma BO": "394810",
      "Bojadra BO": "392150",
      "Dabha BO": "392150",
      "Dolia BO": "392150",
      "Kalak BO": "392150",
      "Khanpurdeh BO": "392150",
      "Vavli BO": "392150",
      "Anadhara BO": "393110",
      "Dadheda BO": "393110",
      "Dharoli BO": "393110",
      "Gundecha BO": "393110",
      "Padal BO": "393110",
      "Padvania BO": "393110",
      "Ranipura BO": "393110",
      "Vansi BO": "392160",
      "Kangam BO": "392170",
      "Kimoj BO": "392170",
      "Nahar BO": "392170",
      "Vadadla BO": "392130",
      "Amleshwar BO": "392012",
      "Bhersam BO": "392012",
      "Dashan BO": "392012",
      "Dehgam BO": "392170",
      "Haldar BO": "392210",
      "Segva BO": "392210",
      "Shahpura BO": "392210",
      "Sindhot BO": "392210",
      "Sitpon BO": "392210",
      "Kantharia BO": "392015",
      "Chasvad BO": "393130",
      "Kavachia BO": "393130",
      "Kelvikuva BO": "393130",
      "Kharetha BO": "393130",
      "Goladra BO": "392165",
      "Janiadra BO": "392165",
      "Kamboli BO": "392220",
      "Kothi Vantarsa BO": "392220",
      "Alunj BO": "394115",
      "Bhadi BO": "394115",
      "Godadra BO": "394115",
      "Kharod BO": "394115",
      "Tavdi BO": "393140",
      "Jespore BO": "393115",
      "Kadvali BO": "393115",
      "Mota Sorva BO": "393115",
      "Pipadhra BO": "393115",
      "Razalwada BO": "393115",
      "Paniadra BO": "392165",
      "Pipalia BO": "392020",
      "Simartha BO": "392220",
      "Pardi Idris BO": "394115",
      "Sanjali BO": "393120",
      "Jarsad BO": "393115",
      "Simadhra BO": "393115",
      "Umadhara BO": "393115",
      "Malanpur BO": "393030",
      "Raima BO": "393030",
      "Dora BO": "392230",
      "Karena BO": "392230",
      "Mangrol BO": "392110",
      "Ochhan BO": "392140",
      "Sisodra BO": "394810",
      "Sunevkalla BO": "394810",
      "Magnad BO": "392150",
      "Nobar BO": "392150",
      "Nodhna BO": "392150",
      "Vehelam BO": "392150",
      "Kurla BO": "392160",
      "Runad BO": "392170",
      "Bhadkodra BO": "393002",
      "Chhidra BO": "392155",
      "Navetha BO": "392012",
      "Rahad BO": "392012",
      "Saladra BO": "392012",
      "Kavitha BO": "392210",
      "Kuvadar BO": "392210",
      "Sherpura BO": "392015",
      "Arethi BO": "393130",
      "Atkhol BO": "393130",
      "Baladva BO": "393130",
      "Moriana BO": "393130",
      "Valpore BO": "393130",
      "Kadodra BO": "392165",
      "Limdi BO": "392165",
      "Kudadra BO": "393030",
      "Danda BO": "392230",
      "Dhamrad BO": "394810",
      "Parvat BO": "394810",
      "Ankhi BO": "392150",
      "Kava BO": "392150",
      "Tundaj BO": "392150",
      "Uber BO": "392150",
      "Umra BO": "392150",
      "Ambos BO": "393110",
      "Limodra BO": "393110",
      "Motamalpur BO": "393110",
      "Siyali BO": "393110",
      "Uchedia BO": "393110",
      "Manubar BO": "392160",
      "Sigam BO": "392170",
      "Jantran BO": "392155",
      "Malpur BO": "392155",
      "Bhadbhut BO": "392012",
      "Hinglot BO": "392012",
      "Vilayat BO": "392012",
      "Bharthana BO": "392210",
      "Hingalla BO": "392210",
      "Jhangar BO": "392210",
      "Samlod BO": "392210",
      "Varedia BO": "392210",
      "Paguthan BO": "392015",
      "Umraj BO": "392015",
      "Anjoli BO": "393130",
      "Bilothi BO": "393130",
      "Dattanagar BO": "393130",
      "Kantipada BO": "393130",
      "Koyli Mandvi BO": "393130",
      "Mauza BO": "393130",
      "Thava BO": "393130",
      "Kansia BO": "393010",
      "Vamleshwar BO": "393030",
      "Balota BO": "394810",
      "Obha BO": "394810",
      "Amanpur BO": "392150",
      "Bhodar BO": "392150",
      "Karmad BO": "392150",
      "Uchhad BO": "392150",
      "Mortalav BO": "393110",
      "Navagam Borjai BO": "393110",
      "Talodra BO": "393110",
      "Vasna BO": "393110",
      "Kaliari BO": "392155",
      "Sambha BO": "392155",
      "Argama BO": "392012",
      "Bhuva BO": "392012",
      "Vora Samni BO": "392012",
      "Dabhali BO": "392210",
      "Jhanor BO": "392210",
      "Karjan BO": "392210",
      "Luvara BO": "392130",
      "Nandeval BO": "392015",
      "Chandravan BO": "393130",
      "Kambodia BO": "393130",
      "Mota Jambuda BO": "393130",
      "Andada BO": "393010",
      "Samor BO": "393010",
      "Dhanturia BO": "393020",
      "Chaklad BO": "392035",
      "Kobla BO": "392035",
      "Mangleshwar BO": "392030",
      "Bamalla BO": "393120",
      "Indore BO": "393120",
      "Keshvan BO": "392140",
      "Kolavna BO": "392140",
      "Vahial BO": "392140",
      "Bharadia BO": "393135",
      "Chikhli BO": "393135",
      "Dholgam BO": "393135",
      "Dolatpur BO": "393135",
      "Kamalia BO": "393135",
      "Luna BO": "393135",
      "Mela BO": "393135",
      "Piludra BO": "391810",
      "Pungam BO": "393020",
      "Kervada BO": "392025",
      "Keshlu BO": "392025",
      "Padaria BO": "392025",
      "Kavli BO": "392180",
      "Nada BO": "392040",
      "Adol BO": "392240",
      "Fichwada BO": "393120",
      "Raisingpura BO": "393120",
      "Velugam BO": "393120",
      "Kalam BO": "393030",
      "Roza Tankaria BO": "392140",
      "Saran BO": "392140",
      "Bhilod BO": "393135",
      "Dungri BO": "393135",
      "Kara BO": "393135",
      "Rajgadh BO": "393135",
      "Hajat BO": "393020",
      "Matied BO": "393020",
      "Sakkarpore BO": "393020",
      "Anor BO": "392025",
      "Ghamnad BO": "392025",
      "Karela BO": "392025",
      "Tanchha BO": "392025",
      "Manjola BO": "392035",
      "Miamatar BO": "392035",
      "Devla BO": "392040",
      "Islampur BO": "392040",
      "Madafar BO": "392040",
      "Kapat BO": "393120",
      "Panetha BO": "393120",
      "Sarsad BO": "393120",
      "Kothia BO": "392140",
      "Mosam BO": "392140",
      "Ora BO": "392140",
      "Pahaj BO": "392140",
      "Saykha BO": "392140",
      "Sutrel BO": "392140",
      "Trankal BO": "392140",
      "Naldhari BO": "393135",
      "Pathar BO": "393135",
      "Sodgam BO": "393135",
      "Tavra BO": "392011",
      "Nangal BO": "393020",
      "Kurchan BO": "392025",
      "Samoj BO": "392180",
      "Angareshwar BO": "392030",
      "Nikora BO": "392030",
      "Kahan BO": "392240",
      "Asha BO": "393120",
      "Haripura BO": "393120",
      "Jamboi BO": "393120",
      "Wali BO": "393120",
      "Chanchvel BO": "392140",
      "Gandhar BO": "392140",
      "Muler BO": "392140",
      "Vasti Khandali BO": "392140",
      "Bhenskhetar BO": "393135",
      "Desad BO": "393135",
      "Kabirgam BO": "393135",
      "Limet BO": "393135",
      "Umargam BO": "393135",
      "Sevad BO": "393135",
      "Siludi BO": "393135",
      "Panjroli BO": "394120",
      "Buva BO": "392110",
      "Itola BO": "392110",
      "Machhasra BO": "392110",
      "Dadhal BO": "393001",
      "Diwa BO": "393001",
      "Kondh BO": "393001",
      "Navitothidra BO": "393105",
      "Manad BO": "392130",
      "Mahudhala BO": "392020",
      "Kareli BO": "391810",
      "Vedach BO": "391810",
      "Ankalva BO": "393030",
      "Asta BO": "393030",
      "Badodra BO": "393030",
      "Kharach BO": "394120",
      "Advala BO": "392110",
      "Nahier BO": "392110",
      "Pursa BO": "392110",
      "Avadar BO": "393001",
      "Jitali BO": "393001",
      "Kapalsadi BO": "393001",
      "Kharchi BO": "393001",
      "Kosamdi BO": "393001",
      "Sengpore BO": "393001",
      "Vataria BO": "393001",
      "Kaladra BO": "392130",
      "Lakhigam BO": "392130",
      "Kothi BO": "392020",
      "Parkhet BO": "392020",
      "Bhamadia BO": "393125",
      "Itakla BO": "393125",
      "Kahanva BO": "391810",
      "Ambheta BO": "392130",
      "Kantiajal BO": "393030",
      "Achhod BO": "392110",
      "Ninam BO": "392110",
      "Govali BO": "393001",
      "Kapodra BO": "393002",
      "Kararvel BO": "393001",
      "Piraman BO": "393001",
      "Umarwada BO": "393001",
      "Galenda BO": "392130",
      "Khojbal BO": "392130",
      "Rahiad BO": "392130",
      "Vegni BO": "392130",
      "Kasva BO": "392130",
      "Derol BO": "392020",
      "Pariej BO": "392020",
      "Gundia BO": "393125",
      "Jabugam BO": "393125",
      "Rajpara BO": "393125",
      "Vadfalia BO": "393125",
      "Katpore BO": "393030",
      "Shrikothi BO": "392110",
      "Boidra BO": "393001",
      "Borbhathabet BO": "393001",
      "Mandva Buzarg BO": "393001",
      "Motali BO": "393001",
      "Selod BO": "393001",
      "Akhod BO": "392130",
      "Atali BO": "392130",
      "Eksal BO": "392130",
      "Nandida BO": "392130",
      "Kasad BO": "392020",
      "Kelod BO": "392020",
      "Tham BO": "392020",
      "Tralsa BO": "392020",
      "Vahalu BO": "392020",
      "Mokhdi BO": "393125",
      "Sabaria BO": "393125",
      "Tuna BO": "393125",
      "Digas BO": "393030",
      "Bharuch HO": "392001",
      "Gajera SO": "391810",
      "Jambusar SO": "392150",
      "Bhalod SO Vadodara": "393105",
      "Dayadra SO": "392020",
      "Jhagadia SO": "393110",
      "Karmad SO": "392160",
      "LBChakla SO": "392001",
      "Nabipur SO": "392210",
      "Ilav SO": "394810",
      "Ankleshwar IE SO": "393002",
      "Ankleshwar RS SO": "393001",
      "Bharuch RS SO": "392001",
      "Dahej SO": "392130",
      "Dehali SO": "393125",
      "Gayatri Nagar SO Gujrat Circle": "392001",
      "Hansot SO": "393030",
      "Ikhar SO": "392230",
      "Jambusar Bazar SO": "392150",
      "Kavi SO": "392170",
      "Kora SO Bharuch": "392155",
      "Maktampur SO": "392012",
      "Amod SO": "392110",
      "Avidha SO": "393017",
      "Bharuch City SO": "392001",
      "Narmada Nagar SO Bharuch": "392015",
      "Palej SO": "392220",
      "Sarod SO": "392180",
      "Jolva SO": "392135",
      "Netrang SO": "393130",
      "Pakhajan SO": "392165",
      "Panch Fanas SO": "392001",
      "Panoli SO": "394115",
      "Sindhvai SO": "392001",
      "Ankleshwar SO": "393001",
      "Tankaria SO": "392240",
      "Vagra SO": "392140",
      "Sajod SO": "393020",
      "Sarbhan SO": "392035",
      "ONGC Colony SO": "393010",
      "Rajpardi SO": "393115",
      "Samni SO": "392025",
      "Tankari SO": "392040",
      "Umalla SO": "393120",
      "Urja Nagar SO": "392215",
      "Valia SO": "393135",
      "Zadeshwar SO": "392011",
      "Shuklatirth SO": "392030"
    },
    "VADODARA": {
      "Matroj BO": "392220",
      "Mesrad BO": "392220",
      "Pachhiapura BO": "392220",
      "Saring BO": "392220",
      "Koliyad BO": "392220",
      "Sansrod BO": "392220",
      "Sathod BO": "391110",
      "Simalia BO": "391110",
      "Sitpur BO": "391110",
      "Vasai BO": "391110",
      "Avakhal BO": "391250",
      "Anandi BO": "391110",
      "Dharmpuri BO": "391110",
      "Karalipura BO": "391110",
      "Karnet BO": "391110",
      "Kukad BO": "391110",
      "Chhanbhoi BO": "391250",
      "Deroli BO": "391250",
      "Kukas BO": "391250",
      "Anguthan BO": "391107",
      "Bhilapur BO": "391107",
      "Malsar BO": "391115",
      "Mandva BO": "391105",
      "Borbar BO": "391107",
      "Dholar BO": "391107",
      "Palaswada BO": "391107",
      "Bhilodia BO": "391110",
      "Pansoli BO": "391110",
      "Diver BO": "391250",
      "Manjrol BO": "391250",
      "Mindhol BO": "391250",
      "Timbarva BO": "391250",
      "Ambali BO": "391760",
      "Mota Fofalia BO": "391115",
      "Fartikui BO": "391107",
      "Meghakui BO": "391107",
      "Vanadara BO": "391107",
      "Chanvada BO": "391110",
      "Wadhwana BO": "391110",
      "Achisara BO": "391250",
      "Bavaria BO": "391250",
      "Malpur BO": "391250",
      "Ranapur BO": "391250",
      "Utraj BO": "391250",
      "Kanjetha BO": "391115",
      "Surasamal BO": "391115",
      "Zanzad BO": "391115",
      "Kadadhara BO": "391107",
      "Kundhela BO": "391107",
      "Naria BO": "391107",
      "Samsabad BO": "391107",
      "Bithli BO": "391105",
      "Karnali BO": "391105",
      "Nana Karala BO": "391105",
      "Sagwa BO": "391105",
      "Simli BO": "391105",
      "Vadaj BO": "391105",
      "Moletha BO": "391105",
      "Vaniad BO": "391105",
      "Puniad BO": "391110",
      "Barkal BO": "391105",
      "Mota Karala BO": "391105",
      "Nanderia BO": "391105",
      "Sanor BO": "391105",
      "Tentalav BO": "391105",
      "Goraj BO": "391761",
      "Valva BO": "391761",
      "Vedpur BO": "391761",
      "Gangadia BO": "391520",
      "Vadia BO": "391520",
      "Vemar BO": "391240",
      "Latwa BO": "391530",
      "Limdi BO": "391530",
      "Narpura BO": "391530",
      "Gothda BO": "391770",
      "Ampad BO": "391101",
      "Khanda BO": "391760",
      "Kuvarvada BO": "391760",
      "Limda BO": "391760",
      "Madheli BO": "391760",
      "Pipli BO": "391445",
      "Sadhi BO": "391445",
      "Lilod BO": "393105",
      "Oz BO": "393105",
      "Rarod BO": "393105",
      "Khervadi BO": "391761",
      "Kuvarpura BO": "391220",
      "Juna Samlaya BO": "391520",
      "Karchia BO": "391520",
      "Motipura BO": "391520",
      "Pipalchhat BO": "391530",
      "Sihora BO": "391440",
      "Karmaliyapura BO": "391761",
      "Kamalpura BO": "391520",
      "Ranipura BO": "391520",
      "Chhaliar BO": "391530",
      "Dhantej BO": "391530",
      "Rajupura BO": "391445",
      "Vasia BO": "391530",
      "Lanchanpura BO": "391770",
      "Muval BO": "391430",
      "Pilol BO": "391745",
      "Anjesar BO": "391775",
      "Ganpatpura BO": "391210",
      "Gutal BO": "391760",
      "Pipalia BO": "391760",
      "Sangadol BO": "391760",
      "Kiya BO": "392310",
      "Husepura BO": "391445",
      "Sarasavani BO": "391445",
      "Amreshwar BO": "391761",
      "Mevli BO": "391770",
      "Nahra BO": "391770",
      "Rasulpur BO": "391770",
      "Vintoz BO": "391770",
      "Gotri BO": "391101",
      "Pisai BO": "391110",
      "Mota  Habipura BO": "391110",
      "Shirola BO": "391110",
      "Koral BO": "393105",
      "Ropa BO": "393105",
      "Asoj BO": "391510",
      "Vasna Kotaria BO": "391745",
      "Bahutha BO": "391775",
      "Ghodadara BO": "391760",
      "Junarampura BO": "391760",
      "Raval BO": "391760",
      "Vasvel BO": "391760",
      "Motimanekpur BO": "391761",
      "Remeshwarpura BO": "391761",
      "Saidal BO": "391761",
      "Gardhia BO": "391520",
      "Nani Bhadol BO": "391520",
      "Pasva BO": "391520",
      "Pandu BO": "391530",
      "Vaktapura BO": "391530",
      "Poicha BO": "391780",
      "Prathampura BO": "391780",
      "Vasanpura BO": "391770",
      "Tadiyapura BO": "391770",
      "Lamdapura BO": "391775",
      "Namisara BO": "391775",
      "Sayar BO": "393105",
      "Vadadla BO": "391445",
      "Gabhirpura BO": "391761",
      "Subhelav BO": "391775",
      "Alva BO": "391760",
      "Chipad BO": "391760",
      "Falod BO": "391760",
      "Vejalpura BO": "391760",
      "Vesania BO": "391760",
      "Vyara Antoli BO": "391760",
      "Virpur BO": "391445",
      "Antoli BO": "391761",
      "Ankhol BO": "390019",
      "Harni BO": "390022",
      "Jambua BO": "390014",
      "Danteshwar BO": "390004",
      "Kapurai BO": "390004",
      "Ranjit Nagar BO": "391780",
      "Vakaner BO": "391780",
      "Rania BO": "391780",
      "Dashrath BO": "391740",
      "Atali BO": "391244",
      "Chhanchava BO": "391244",
      "Oslam BO": "391244",
      "Itwad BO": "391774",
      "Vejpur BO": "391774",
      "Ajwa Compound BO": "391510",
      "Bhaniara BO": "391510",
      "Indrad BO": "391510",
      "Kotambi BO": "391510",
      "Sadra BO": "391430",
      "Amodar BO": "390019",
      "Dena BO": "390022",
      "Virod BO": "390022",
      "Vyankatpura BO": "391510",
      "Dhavat BO": "391210",
      "Karmal BO": "391210",
      "Tithor BO": "391450",
      "Shahpura BO": "391220",
      "Angadh BO": "391330",
      "Undera BO": "391330",
      "Abhol BO": "391421",
      "Masar BO": "391421",
      "Anastu BO": "391240",
      "Chorbhuj BO": "391240",
      "Kanbha BO": "391240",
      "Kurai BO": "391240",
      "Sampa BO": "391240",
      "Sokhdaradhu BO": "391240",
      "Virjai BO": "391240",
      "Pindappa BO": "391430",
      "Chansad BO": "391440",
      "Darapura BO": "391440",
      "Mahuvad BO": "391440",
      "Narshihpura BO": "391440",
      "Itola RS BO": "391243",
      "Ramnath BO": "391243",
      "Sankarda BO": "391350",
      "Ambada BO": "391445",
      "Anti BO": "391445",
      "Dhaniavi BO": "390014",
      "Tarsali BO": "390009",
      "Amaliyara BO": "390022",
      "Vadsar BO": "390010",
      "Tandalja BO": "390012",
      "Karchiya BO": "391310",
      "Karodia BO": "391310",
      "Bill BO": "391410",
      "Chapad BO": "391410",
      "Raipura BO": "391410",
      "Ajod BO": "391740",
      "Bachar BO": "391244",
      "Lakodara BO": "391244",
      "Valavav BO": "391774",
      "Vankaneda BO": "391774",
      "Adiran BO": "391510",
      "Kamrol BO": "391510",
      "Khakharia BO": "391510",
      "Rasulabad BO": "391510",
      "Sarnej BO": "391510",
      "Tulsipura BO": "391510",
      "Chhatral BO": "391210",
      "Mandala BO": "391210",
      "Nana Fofalia BO": "391210",
      "Parikha BO": "391210",
      "Ankodia BO": "391330",
      "Kotna BO": "391330",
      "Sherkhi BO": "391330",
      "Gosindra BO": "391240",
      "Handod BO": "391240",
      "Gametha BO": "391430",
      "Gavasad BO": "391430",
      "Jalalpura BO": "391430",
      "Kanda BO": "391430",
      "Dodka BO": "391340",
      "Fazalpur BO": "391340",
      "Nandesari BO": "391340",
      "Goriyad BO": "391440",
      "Jaspura BO": "391440",
      "Luna BO": "391440",
      "Mahmadpura BO": "391440",
      "Dhanora BO": "391510",
      "Manglej BO": "391243",
      "Sundarpura BO": "391243",
      "Vadsala BO": "391243",
      "Amla BO": "391445",
      "Bhadara BO": "391445",
      "Mokshi BO": "391780",
      "Natwar Nagar BO": "391780",
      "Gorwa BO": "390003",
      "Sisva BO": "391740",
      "Samra BO": "391244",
      "Saniad BO": "391244",
      "Dajipura BO": "391774",
      "Merakuva BO": "391774",
      "Motivarnoli BO": "391774",
      "Pratappura BO": "391774",
      "Ganeshpura BO": "391510",
      "Ghantiyal BO": "391510",
      "Mudhela BO": "391510",
      "Navagam BO": "391510",
      "Panchdevla BO": "391510",
      "Rahkui BO": "391510",
      "Chokari BO": "391450",
      "Jiyatalavdi BO": "391220",
      "Menpura BO": "391220",
      "Sampla BO": "391421",
      "Kurali BO": "391240",
      "Manpur BO": "391240",
      "Methi BO": "391240",
      "Miyagam BO": "391240",
      "Pingalvada BO": "391240",
      "Mobha BO": "391430",
      "Raika BO": "391340",
      "Ekelbara BO": "391440",
      "Ghayaj BO": "391440",
      "Sangma BO": "391440",
      "Sejakuva BO": "391440",
      "Tajpura BO": "391440",
      "Umaraya BO": "391440",
      "Vishrampura BO": "391440",
      "Varnama BO": "391243",
      "Chikhodara BO": "390009",
      "Bakrol BO": "390019",
      "Kumetha BO": "390019",
      "Nimetha BO": "390019",
      "Sayajipura BO": "390019",
      "Kelanpur BO": "390004",
      "Tatarpura BO": "390004",
      "Samiyala BO": "391410",
      "Dumad BO": "391740",
      "Bharthana BO": "391244",
      "Simri BO": "391244",
      "Urad BO": "391244",
      "Himmatpura BO": "391774",
      "Jambugoral BO": "391774",
      "Kadchhala BO": "391774",
      "Varsada BO": "391774",
      "Champaner Road BO": "391510",
      "Kheda Karmasiya BO": "391510",
      "Lilora BO": "391510",
      "Rajpura BO": "391510",
      "Gandhara BO": "391210",
      "Nada BO": "391210",
      "Vemardi BO": "391210",
      "Dudhwada BO": "391450",
      "Majatan BO": "391450",
      "Lingsthali BO": "391220",
      "Patarveni BO": "391220",
      "Ruvand BO": "391220",
      "Sindhrot BO": "391330",
      "Brahamanvashi BO": "391421",
      "Bodka BO": "391240",
      "Juni Jathardi BO": "391240",
      "Kambola BO": "391240",
      "Karamdi BO": "391240",
      "Sambhoi BO": "391240",
      "Chitral BO": "391430",
      "Kural BO": "391430",
      "Sanpur BO": "391430",
      "Vanchhara BO": "391430",
      "Dabhasa BO": "391440",
      "Dabka BO": "391440",
      "Latipura BO": "391440",
      "Mujpur BO": "391440",
      "Sandha BO": "391440",
      "Vadu BO": "391440",
      "Itola BO": "391243",
      "Sarar BO": "391243",
      "Baman Gam BO": "391243",
      "Padmala BO": "391350",
      "Bhoj BO": "391445",
      "Chandod SO": "391105",
      "Thuwavi SO": "391107",
      "Fatepura SO Vadodara": "390006",
      "Madanzampa SO": "390001",
      "Sharadnagar SO": "390009",
      "Wadi SN Road SO": "390017",
      "Waghodia Road SO": "390025",
      "Desar SO": "391774",
      "Mobha Road SO": "391430",
      "Petrochemical  T Ship SO": "391345",
      "Ranu SO": "391445",
      "Sayajiganj SO": "390020",
      "Manjusar GIDC": "391776",
      "Atladara SO": "390012",
      "Chhani Rd SO": "390024",
      "Chhani SO Vadodara": "391740",
      "Choranda SO": "391244",
      "Jarod SO": "391510",
      "Jawahar Nagar SO Vadodara": "391320",
      "Kandari SO": "391210",
      "Akota SO": "390020",
      "Bajwa SO": "391310",
      "Bhaily SO": "391410",
      "Chemical Industries SO": "390003",
      "Industrial Estate Vadodara SO": "390016",
      "Nandesari Ind Estate SO": "391340",
      "Sevasi SO": "391101",
      "Subhanpura SO": "390023",
      "Kayavahron SO": "391220",
      "Masar Road SO": "391421",
      "Miyagam Karjan SO": "391240",
      "POR SO": "391243",
      "Rustampura SO Vadodara": "391761",
      "Sandasal SO": "391530",
      "T B Sanatorium SO": "390021",
      "Dabhoi RS SO": "391110",
      "Sadhli SO": "391250",
      "Karelibaug SO": "390018",
      "Mandvi SO Vadodara": "390001",
      "Manjalpur SO": "390011",
      "Pratapnagar SO Vadodara": "390004",
      "Harni Colony SO": "390022",
      "Khanderao Market SO": "390001",
      "MI Estate SO": "390010",
      "Soma Talav SO": "390025",
      "Sinor SO": "391115",
      "Ajwa Road SO": "390019",
      "Makarpura SO": "390014",
      "Maneja SO": "390013",
      "Ongc Col SO": "390009",
      "Tundav SO": "391775",
      "Valan SO": "392310",
      "District Court S.O.": "390007",
      "Alkapuri SO": "390007",
      "Bhadarwa SO": "391780",
      "Fartilizer Nagar SO": "391750",
      "Karkhadi SO": "391450",
      "Koyali SO": "391330",
      "Padra SO": "391440",
      "Racecourse SO": "390007",
      "Ranoli SO Vadodara": "391350",
      "Samlaya R S SO": "391520",
      "Savli SO": "391770",
      "Sokhda SO": "391745",
      "Vaghodia SO": "391760",
      "Vidhyut Nagar Colony SO": "390007",
      "Fateganj HO": "390002",
      "Dabhoi HO": "391110",
      "Vadodara HO": "390001"
    },
    "ANAND": {
      "Demol BO": "387710",
      "Vadadla BO": "388430",
      "Dugari BO": "388625",
      "Galiana BO": "388625",
      "Manaj BO": "388150",
      "Manpura BO": "388150",
      "Runaj BO": "388150",
      "Sundra BO": "388150",
      "Rangaipura BO": "388450",
      "Isnav BO": "388460",
      "Amiyad BO": "388570",
      "Kalitalavadi BO": "388170",
      "Kanisa BO": "388170",
      "Virol BO": "387240",
      "Manghrol BO": "387210",
      "Khanpur BO": "388365",
      "Dhuvaran BO": "388610",
      "Golana BO": "388625",
      "Khaksar BO": "388625",
      "Vainaj BO": "388625",
      "Rohini BO": "388625",
      "Kasari BO": "388590",
      "Vadeli BO": "388590",
      "Dahevan BO": "388550",
      "Dali BO": "388550",
      "Kalu BO": "388550",
      "Kanbha BO": "388550",
      "Daheda BO": "388620",
      "Jinaj BO": "388620",
      "Laxmipura BO": "388620",
      "Rangpur BO": "388620",
      "Shakarpur BO": "388620",
      "Ghunteli BO": "388440",
      "Ardi BO": "388450",
      "Bhavanipura BO": "388450",
      "Davalpura BO": "388450",
      "Kasor BO": "388205",
      "Bhalada BO": "387240",
      "Gada BO": "387240",
      "Simarda BO": "388480",
      "Indranaj BO": "388180",
      "Isarvada BO": "388180",
      "Jichka BO": "388180",
      "Kanavada BO": "388180",
      "Mitli BO": "388180",
      "Lambhvel BO": "387310",
      "Bhadkad BO": "387380",
      "Chuva BO": "388140",
      "Dharmajranoli BO": "388430",
      "Pachegam BO": "388625",
      "Pandad BO": "388625",
      "Kathana BO": "388550",
      "Budhej BO": "388620",
      "Lunej BO": "388620",
      "Malu BO": "388620",
      "Nagra BO": "388620",
      "Padgol BO": "388440",
      "Jalla BO": "388150",
      "Khadana BO": "388160",
      "Dantali BO": "388450",
      "Fangani BO": "388450",
      "Kanzat BO": "388170",
      "Timba BO": "388170",
      "Balinta BO": "387240",
      "Devataj BO": "387240",
      "Palol BO": "387240",
      "Golel BO": "388480",
      "Rupiapura BO": "388480",
      "Virol [simarda BO": "388480",
      "Chagada BO": "388180",
      "Hadeva BO": "388180",
      "Kasbara BO": "388180",
      "Milarampura BO": "388180",
      "Deva BO": "387380",
      "Vansol BO": "387115",
      "Dabhasi BO": "388140",
      "Rudel BO": "388140",
      "Bhurakui BO": "388430",
      "Khadodhi BO": "388610",
      "Naviakhol BO": "388625",
      "Vadgam BO": "388625",
      "Nana Kalodara BO": "388630",
      "Badalpur BO": "388550",
      "Kankapura BO": "388550",
      "Metpur BO": "388620",
      "Petli BO": "387220",
      "Amod BO": "388160",
      "Mariampura BO": "388450",
      "Saijpur BO": "388570",
      "Mobha BO": "388170",
      "Untvada BO": "388170",
      "Trambovad BO": "387240",
      "Gorad BO": "388180",
      "Mahiyari BO": "388180",
      "Kherda BO": "388365",
      "Khorvad BO": "388365",
      "Pratappura BO": "388365",
      "Bechri BO": "388220",
      "Khada BO": "387530",
      "Verakhadi BO": "388365",
      "Pansora BO": "388220",
      "Ratanpura BO": "388220",
      "Gopalpura BO": "388370",
      "Padra BO": "388180",
      "Bhatpura BO": "388220",
      "Rajupura BO": "388306",
      "Ghora BO": "388220",
      "Khankhanpur BO": "388220",
      "Hamidpura BO": "388220",
      "Lingda BO": "388220",
      "Kalamsar BO": "388640",
      "Khatnal BO": "388640",
      "Ravli BO": "387375",
      "Sanjaya BO": "387375",
      "Bamanva BO": "388580",
      "Jalsan BO": "388580",
      "Ralej BO": "388640",
      "Finav BO": "388580",
      "Jantral BO": "388580",
      "Vatadara BO": "388580",
      "Moraj BO": "388180",
      "Varsada BO": "388180",
      "Piploi BO": "388640",
      "Vatra BO": "388640",
      "Banejada BO": "388580",
      "Sansej BO": "388180",
      "Bhuvel BO": "388640",
      "Jalundh BO": "388640",
      "Ambali BO": "388307",
      "Valasan BO": "388325",
      "Ramnagar BO": "388340",
      "Khandhli BO": "388560",
      "Pamol BO": "388560",
      "Khadol BO": "388350",
      "Ambav KanthariaBO": "388307",
      "Asodar BO": "388307",
      "Kahanvadi BO": "388307",
      "Gana BO": "388345",
      "Bajipura BO": "388210",
      "Ravlapura BO": "388360",
      "Amrol BO": "388307",
      "Bhetasi BO": "388307",
      "Mujkuva BO": "388307",
      "Rasnol BO": "388335",
      "Singlav BO": "388560",
      "Ahima BO": "388210",
      "Bharoda BO": "388210",
      "Dholi BO": "388365",
      "Tranol BO": "388335",
      "Meghva BO": "388345",
      "Jitodia BO": "388345",
      "Dedarda BO": "388560",
      "Dehmi BO": "388560",
      "Shili BO": "388210",
      "Sundalpura BO": "388210",
      "Sureli BO": "388210",
      "Ajupura BO": "388360",
      "Bilpad BO": "388520",
      "Pipli BO": "388530",
      "Sarol BO": "388530",
      "Sisva BO": "388530",
      "Valvod BO": "388530",
      "Ashipura BO": "388205",
      "Badapura BO": "388205",
      "Dagjipura BO": "388205",
      "Jakhala BO": "388205",
      "Dhundakuva BO": "388130",
      "Kasumbad BO": "388540",
      "Bedva BO": "388320",
      "Vaghashi BO": "388320",
      "Gamdi BO": "388320",
      "Sundan BO": "388305",
      "Joshikuva BO": "388510",
      "Gambhira BO": "388520",
      "Kothiakhad BO": "388520",
      "Kathol BO": "388530",
      "Ashi BO": "388130",
      "Morad BO": "388130",
      "Nisraya BO": "388540",
      "Vera BO": "388540",
      "Hadgood BO": "388110",
      "Asarma BO": "388510",
      "Chamara BO": "388520",
      "Navapura BO": "388520",
      "Gajna BO": "388530",
      "Khedasa BO": "388530",
      "Kanbhaipura BO": "388205",
      "Agas BO": "388130",
      "Sinhol BO": "388130",
      "Vasna BO": "388540",
      "Kinkhlod BO": "388510",
      "Kosindra BO": "388510",
      "Navakhal BO": "388510",
      "Umeta BO": "388510",
      "Jol BO": "388315",
      "Khankuva BO": "388205",
      "Untkhari BO": "388205",
      "Porda BO": "388130",
      "Sandesar BO": "388130",
      "Surkuva BO": "388130",
      "Bodal BO": "388540",
      "Davol BO": "388540",
      "Anand HO": "388001",
      "Adas SO": "388305",
      "Anklav SO": "388510",
      "Boria SO Anand": "388130",
      "Khambholej SO": "388330",
      "Kunjrav SO": "388335",
      "Napad SO": "388350",
      "Sardarganj   Anand SO": "388001",
      "Alarsa SO": "388543",
      "Amuldairy  Anand SO": "388001",
      "Bhalej SO": "388205",
      "Chikhodra SO": "388320",
      "Kantharia SO": "388307",
      "Kavitha SO": "388545",
      "Mogri SO": "388345",
      "Samarkha SO": "388360",
      "Sarsa SO": "388365",
      "Umreth SO": "388220",
      "Vasad SO": "388306",
      "Vithal Udyognagar SO": "388121",
      "Bakrol SO": "388315",
      "Bamangam SO": "388520",
      "Bhadran SO": "388530",
      "District Court SO Anand": "388001",
      "Karamsad SO": "388325",
      "Napa SO": "388560",
      "Thamna SO Anand": "388215",
      "Vadod SO": "388370",
      "Vallabh  Vidyanagar SO": "388120",
      "Ajarpura SO": "388310",
      "Anand Agri Inst  Anand SO": "388110",
      "Anand Town  Anand SO": "388001",
      "Chitari Bazar SO": "388620",
      "Dhuvaran Power Station SO": "388610",
      "Gudel SO": "388625",
      "Jharola SO": "388590",
      "Pith Baza Khambhat SO": "388620",
      "Borsad SO": "388540",
      "Mogar SO": "388340",
      "Navli SO": "388355",
      "Ode SO": "388210",
      "Veternary College  Anand SO": "388001",
      "Ras SO": "388570",
      "Sunav SO": "388470",
      "Sundarna SO": "388480",
      "Dabhou SO": "387210",
      "Kansari SO": "388630",
      "Malataj SO": "387220",
      "Palaj SO": "388465",
      "Petlad RS SO": "388450",
      "Petlad SO": "388450",
      "Piplav SO": "388460",
      "Sayma SO": "388170",
      "Boriavi SO": "387310",
      "Bandhani SO": "388410",
      "Changa SO": "388421",
      "Dharmaj SO": "388430",
      "Khambhat SO": "388620",
      "Mahelav SO": "388440",
      "Nar SO": "388150",
      "Pandoli SO": "388160",
      "Bochasan RS SO": "388140",
      "Kathana RS SO": "388550",
      "Sojitra SO": "387240",
      "Tarapur SO Anand": "388180",
      "Undel SO": "388640",
      "Virsad SO": "388580"
    },
    "KHEDA": {
      "Dhathal BO": "387550",
      "Kaloli BO": "387550",
      "Antroli BO": "387570",
      "Maliataj BO": "387380",
      "Chalali BO": "387115",
      "Kanjoda BO": "387115",
      "Chunel BO": "387330",
      "Heranj BO": "387510",
      "Abvel BO": "387650",
      "Betawada BO": "387650",
      "Bhoja Na Muvada BO": "387650",
      "Telnar BO": "387650",
      "Bamroli BO": "387345",
      "Davda BO": "387350",
      "Chandana BO": "387560",
      "Shetra BO": "387560",
      "Karoli BO": "387335",
      "Mitral BO": "387710",
      "Hariala BO": "387570",
      "Khumarwad BO": "387570",
      "Radhvanaj BO": "387570",
      "Sokhada BO": "387570",
      "Rinchhol BO": "387430",
      "Saraswani BO": "387430",
      "Shatrunda BO": "387430",
      "Singhali BO": "387430",
      "Vansol Sundha BO": "387430",
      "Vanthavali BO": "387430",
      "Vina BO": "387430",
      "Dasalwada BO": "387365",
      "Dethli BO": "387210",
      "Vyas Vasna BO": "387650",
      "Sandhana BO": "387350",
      "Rasikpura BO": "387560",
      "Vasna Buzarg BO": "387560",
      "Rampur BO": "387710",
      "Bharkunda BO": "387430",
      "Khuntaj BO": "387430",
      "Varsang BO": "387560",
      "Navagam BO": "387620",
      "Aklacha BO": "388230",
      "Kesara BO": "387430",
      "Khadol BO": "387365",
      "Manghroli BO": "387115",
      "Valetva BO": "388440",
      "Palaiya BO": "387330",
      "Sodpur BO": "387330",
      "Akhdol BO": "387355",
      "Keriavi BO": "387355",
      "Hathaj BO": "387360",
      "Bamangam BO": "388180",
      "Kaniel BO": "387365",
      "Laval BO": "387380",
      "Surashamal BO": "387115",
      "Sanali BO": "387330",
      "Rajnagar BO": "387345",
      "Bilodara BO": "387002",
      "Tundel BO": "387230",
      "Dumral BO": "387355",
      "Piplata BO": "387355",
      "Marida BO": "387360",
      "Kaprupur BO": "387305",
      "Garmala BO": "387510",
      "Undhela BO": "387510",
      "Sarkhej BO": "387635",
      "Kuna BO": "387110",
      "Modaj BO": "387110",
      "Sankhej BO": "387120",
      "Vasna Margia BO": "387120",
      "Sorna BO": "387620",
      "Sunda BO": "387620",
      "Dampat BO": "387630",
      "Dana BO": "387630",
      "Charan Nikol BO": "387640",
      "Chikhlod BO": "387640",
      "Porda Fagvel BO": "387640",
      "Vadol BO": "387640",
      "Punadra BO": "387610",
      "Vaso BO": "388245",
      "Malvan BO": "388245",
      "Sonaiya BO": "388245",
      "Masra BO": "388215",
      "Ambav Thasra BO": "388250",
      "Dabhali BO": "388250",
      "Pipalwada BO": "388250",
      "Rustampura BO": "388245",
      "Khijalpur BO": "388215",
      "Golaj BO": "388250",
      "Gumadia BO": "388250",
      "Kosam BO": "387610",
      "Nanadara BO": "388250",
      "Nepalpura BO": "388250",
      "Rasulpur BO": "388250",
      "Sandheli BO": "388250",
      "Vadad BO": "388250",
      "Sandesar BO": "387610",
      "Vaghjipur BO": "387610",
      "Silod BO": "387320",
      "Kamla BO": "387320",
      "Mahij BO": "387120",
      "Samadra BO": "387120",
      "Alwa BO": "387620",
      "Aminpura BO": "387620",
      "Bhutia BO": "387620",
      "Danadra BO": "387620",
      "Letar BO": "387620",
      "Savli BO": "387620",
      "Vadali BO": "387620",
      "Vishnupura BO": "387620",
      "Anara BO": "387630",
      "Bhatera BO": "387630",
      "Ghoghawada BO": "387630",
      "Minavada BO": "387630",
      "Sarali BO": "387630",
      "Ladvel BO": "387640",
      "Ajmavatkot BO": "387610",
      "Apruji BO": "387610",
      "Bhailakui BO": "387610",
      "Badarpur BO": "387635",
      "Chhipial BO": "387635",
      "Arera BO": "387320",
      "Degam BO": "387320",
      "Hathnoli BO": "387110",
      "Jaravat BO": "387110",
      "Raska BO": "387120",
      "Ambaliara BO": "387620",
      "Antisar BO": "387620",
      "Bhungalia BO": "387620",
      "Dahiap BO": "387620",
      "Garod BO": "387620",
      "Ghadia BO": "387620",
      "Jher BO": "387620",
      "Kalaji BO": "387620",
      "Chapatiya BO": "387620",
      "Pithai BO": "387630",
      "Porda Bhatera BO": "387630",
      "Khandhli BO": "387510",
      "Ravdavat BO": "387610",
      "Ukardina Muvada BO": "387610",
      "Kakarkhad BO": "387635",
      "Manjipura BO": "388230",
      "Haldarvas BO": "387110",
      "Bidaj BO": "387120",
      "Lali BO": "387120",
      "Dudhathal BO": "387620",
      "Kavath BO": "387620",
      "Thavad BO": "387620",
      "Vaghas BO": "387620",
      "Bhaner BO": "387630",
      "Jamni BO": "387630",
      "Fagvel BO": "387640",
      "Kathana BO": "387640",
      "Mal Itadi BO": "387640",
      "Kharanti BO": "387520",
      "Devki Vansol BO": "387130",
      "Gothaj BO": "387130",
      "Parsantaj BO": "387130",
      "Varsola BO": "387130",
      "Vasna BO": "387340",
      "Jaliya BO": "387335",
      "Koshial BO": "387530",
      "Machhiel BO": "387530",
      "Nadhanpur BO": "387530",
      "Traj BO": "387530",
      "Goblej BO": "387540",
      "Amrapura BO": "387130",
      "Bavra BO": "387130",
      "Rudan BO": "387335",
      "Ruppura BO": "387335",
      "Sastapur BO": "387335",
      "Torania BO": "387335",
      "Undra BO": "387335",
      "Vadthal BO": "387335",
      "Tranja BO": "387530",
      "Kanera BO": "387540",
      "Sonipur BO": "388245",
      "Angadi BO": "388250",
      "Dhundi BO": "388250",
      "Malavada BO": "387520",
      "Khatraj BO": "387130",
      "Mankwa BO": "387130",
      "Sansoli BO": "387130",
      "Vadadla BO": "387130",
      "Dadusar BO": "387335",
      "Nani Khadol BO": "387335",
      "Asamli BO": "387530",
      "Palla BO": "387530",
      "Chhapra BO": "387130",
      "Ghodali BO": "387130",
      "Khadgodhra BO": "388255",
      "Pandvania BO": "388220",
      "Vinzol BO": "388220",
      "Kachchhai BO": "387130",
      "Nenpur BO": "387130",
      "Nizampura BO": "387340",
      "Abhripur BO": "387335",
      "Vansoli BO": "387335",
      "Mahelaj BO": "387530",
      "Sayla BO": "387530",
      "Dharoda BO": "387540",
      "Pariej BO": "388180",
      "Sinjivada BO": "388180",
      "Bhumel BO": "387370",
      "Fatepur BO": "387370",
      "Gutal BO": "387370",
      "Vastana BO": "388180",
      "Rakhial BO": "388225",
      "Vanoti BO": "388225",
      "Chitlav BO": "388230",
      "Nes BO": "388230",
      "Vanoda BO": "388235",
      "Malai BO": "388225",
      "Agarwa BO": "388230",
      "Bhadrasa BO": "388230",
      "Sanadra BO": "388235",
      "Wanghroli BO": "388235",
      "Muliad BO": "388225",
      "Ozarala BO": "388225",
      "Ravalia BO": "388225",
      "Saiyat BO": "388225",
      "Sui BO": "388225",
      "Kuni BO": "388235",
      "Mahi  Itadi BO": "388235",
      "Padal BO": "388235",
      "Dhunadra BO": "388230",
      "Kotlindra BO": "388230",
      "Mithapura Jesapura BO": "388230",
      "Rania BO": "388230",
      "Rozva BO": "388235",
      "Ajupura BO": "388225",
      "Chandasar BO": "388225",
      "Bordi BO": "388225",
      "Chetarsumba BO": "388225",
      "Bhavan  S College BO": "388225",
      "Kheda HO": "387411",
      "Nadiad HO": "387001",
      "Thasra SO": "388250",
      "Timbana Muvada SO": "388235",
      "Wanakbori TPS SO": "388239",
      "Ghodasar SO Kheda": "387110",
      "Dakor SO": "388225",
      "Kalsar SO": "388230",
      "Sevalia  Rs SO": "388245",
      "Kanij SO": "387120",
      "Kapadwanj SO": "387620",
      "Lasundra SO": "387640",
      "Limbasi SO": "387520",
      "Mahudha SO": "387335",
      "Navagam SO": "387540",
      "Torna SO": "387365",
      "Chaklashi SO": "387315",
      "Dumral Bazar SO": "387001",
      "Piplag SO": "387355",
      "Salun SO": "387360",
      "Vadtal SO": "387375",
      "Dabhan SO": "387320",
      "Nirmali SO Kheda": "387650",
      "Methodist Hospital Tso Nad SO": "387002",
      "Patel Society Area Tso Nad SO": "387002",
      "Uttarsanda SO": "387370",
      "Petlad Road SO": "387003",
      "Antisar Gate Kpdvj SO": "387620",
      "Chhipdi SO": "387635",
      "Kathlal SO": "387630",
      "Mahisa SO": "387340",
      "Nayka SO": "387550",
      "Ratanpur SO Kheda": "387570",
      "Ashram Road Nadiad SO": "387001",
      "Kanjari SO": "387325",
      "Pij SO": "387230",
      "SRP Group Area Nadiad SO": "387001",
      "Alina SO": "387305",
      "Alindra Matar SO": "387510",
      "Attarsumba SO": "387610",
      "Mahemdavad SO": "387130",
      "Matar SO": "387530",
      "Palana SO": "387350",
      "Radhu SO": "387560",
      "Ramol SO": "387710",
      "Sinhuj SO": "387430",
      "Vaso SO": "387380",
      "Alindra Nadiad SO": "387115",
      "Desai Vago SO": "387001",
      "Mohlel SO": "387330",
      "Narsanda SO": "387345"
    },
    "NAVSARI": {
      "Machhad BO": "396440",
      "Bodali BO": "396440",
      "Kasbapar BO": "396427",
      "Khanpur BO": "396051",
      "Lakadbari BO": "396051",
      "Satimal BO": "396051",
      "Khundh BO": "396521",
      "Majigam BO": "396521",
      "Maliadhara BO": "396521",
      "Khudvel BO": "396540",
      "Siyada BO": "396540",
      "Sukhabari BO": "396540",
      "Velanpore BO": "396540",
      "Bahej BO": "396040",
      "Chari BO": "396040",
      "Debarpada BO": "396040",
      "Gauri BO": "396040",
      "Jamanpada BO": "396040",
      "Sadadvel BO": "396560",
      "Saraiya BO": "396560",
      "Surkhai BO": "396560",
      "Tankal BO": "396560",
      "Mandavkhadak BO": "396060",
      "Panikhadak BO": "396060",
      "Pipalkhed BO": "396060",
      "Bartad BO": "396051",
      "Bhinar BO": "396436",
      "Dharampuri BO": "396590",
      "Dubalfalia BO": "396580",
      "Khata Amba BO": "396580",
      "Limzar BO": "396580",
      "Mahuvas BO": "396580",
      "Mankunia BO": "396580",
      "Manpur BO": "396580",
      "Kalthan BO": "396406",
      "Kharsad BO": "396406",
      "Moti Karod BO": "396406",
      "Ancheli BO": "396310",
      "Bhatfalia BO": "396310",
      "Chhapar BO": "396310",
      "Taliara BO": "396310",
      "VasanGandevi BO": "396310",
      "Motikakrad BO": "396412",
      "Onjal BO": "396412",
      "Onjal Machhivad BO": "396412",
      "Ajrai BO": "396360",
      "DhanoriGandevi BO": "396360",
      "Duwada BO": "396360",
      "Pera BO": "396418",
      "Supakurel BO": "396418",
      "Tarsadi BO": "396418",
      "Undach Luhar  Falia BO": "396325",
      "Vankal Chikhli BO": "396325",
      "Khaparvada BO": "396110",
      "Balvada BO": "396521",
      "Sadakpore BO": "396521",
      "Samroli BO": "396521",
      "Soldhara BO": "396521",
      "Ranverikhurd BO": "396570",
      "Kaliari BO": "396540",
      "Kakadveri BO": "396040",
      "Naranpore BO": "396040",
      "Toranvera BO": "396040",
      "Vav BO": "396040",
      "ManekporeChikhli BO": "396560",
      "Rethvania BO": "396560",
      "Vaghabari BO": "396560",
      "Singad BO": "396560",
      "Moti Valzar BO": "396560",
      "Dholumber BO": "396560",
      "Dholai Falia BO": "396110",
      "Ghej BO": "396521",
      "Tejlav BO": "396521",
      "Thala BO": "396521",
      "Chapaldhara BO": "396570",
      "Kharoli BO": "396570",
      "AmbachChikhli BO": "396540",
      "Kakadvel BO": "396540",
      "Panaj BO": "396040",
      "Pati BO": "396040",
      "Ruzvani BO": "396040",
      "Vad BO": "396040",
      "Donja BO": "396560",
      "Harangam BO": "396560",
      "Jogvad BO": "396560",
      "Kangvai BO": "396560",
      "Pratap Nagar BO": "396560",
      "Rupvel BO": "396560",
      "Kantasvel BO": "396560",
      "Lakhawadi BO": "396560",
      "Agasi BO": "396060",
      "Dhamdhuma BO": "396060",
      "Dholumber Chikhli BO": "396060",
      "Kelia BO": "396060",
      "Ambapani BO": "396580",
      "Charanwada BO": "396580",
      "Chondha BO": "396580",
      "Godhabari BO": "396580",
      "Jamalia BO": "396580",
      "Kansaria BO": "396580",
      "Raibor BO": "396580",
      "Ranifalia BO": "396580",
      "Umarkui BO": "396580",
      "Sultanpur BO": "396406",
      "Bamanvel BO": "396409",
      "Kalvach BO": "396409",
      "Kalamtha BO": "396310",
      "Lusvada BO": "396310",
      "Mohanpur BO": "396310",
      "Dhaman BO": "396415",
      "Simlak BO": "396415",
      "Chasa BO": "396530",
      "Hansapore BO": "396450",
      "Kolva BO": "396350",
      "ManekporeGadat BO": "396350",
      "Salej BO": "396350",
      "Sonvadi BO": "396350",
      "Vegam BO": "396350",
      "Torangam BO": "396360",
      "Moldhara BO": "396427",
      "Amadpore BO": "396427",
      "Amli Kasba BO": "396427",
      "Viraval BO": "396427",
      "Padgha BO": "396427",
      "Ghodavani BO": "396060",
      "Gholar BO": "396060",
      "Kanbhai BO": "396060",
      "Mogravadi BO": "396060",
      "ZariChikhli BO": "396060",
      "Palgabhan BO": "396590",
      "Sindhai BO": "396590",
      "Boriachh BO": "396580",
      "Ghodmal BO": "396580",
      "Kandha BO": "396580",
      "Kavdej BO": "396580",
      "Motibhamti BO": "396580",
      "Navtad BO": "396580",
      "Vanarasi BO": "396580",
      "Ambheta BO": "396409",
      "Dhamdachha BO": "396310",
      "Kotha BO": "396310",
      "Mendhar BO": "396310",
      "Movasa Falia BO": "396310",
      "Asna BO": "396415",
      "Kalakachha BO": "396415",
      "Sunthvad BO": "396530",
      "Eru BO": "396450",
      "Chhapra BO": "396450",
      "Khakhwada BO": "396350",
      "KhergamGandevi BO": "396360",
      "Sugar Factory BO": "396360",
      "Chovisi BO": "396427",
      "Sagra BO": "396427",
      "Tavdi BO": "396427",
      "Manekpore Tankoli BO": "396427",
      "Jamalpore BO": "396427",
      "Nandarkha BO": "396325",
      "Undach Vania Falia BO": "396325",
      "Vaghrech BO": "396110",
      "Amadhara BO": "396521",
      "Hond BO": "396521",
      "Pipalgabhan BO": "396521",
      "Talavchora BO": "396521",
      "Valoti BO": "396380",
      "Khambhda BO": "396540",
      "Sarvani BO": "396540",
      "Vandervela BO": "396540",
      "Achhavani BO": "396040",
      "Nandhai BO": "396040",
      "Bodvank BO": "396560",
      "Kukeri BO": "396560",
      "Ranverikalla BO": "396560",
      "Vanzana BO": "396560",
      "ZariVansda BO": "396560",
      "Doldha BO": "396560",
      "Godthal BO": "396060",
      "Ravania BO": "396060",
      "Kurelia BO": "396590",
      "Sara BO": "396590",
      "Ambabari BO": "396580",
      "Chorvani BO": "396580",
      "Gangpur BO": "396580",
      "KhambhlaVansda BO": "396580",
      "Molaamba BO": "396580",
      "Navanagar BO": "396580",
      "Upsal BO": "396580",
      "Sarav BO": "396406",
      "Bhatha BO": "396310",
      "Devdha BO": "396310",
      "Machhia Vasan Falia BO": "396310",
      "Masa BO": "396310",
      "Chokhad BO": "396415",
      "Ichhapore BO": "396350",
      "Kesli BO": "396360",
      "PatiGandevi BO": "396360",
      "Bhattai BO": "396427",
      "Endhal BO": "396430",
      "Kadoli BO": "396436",
      "Mangrol BO": "396436",
      "Simalgam BO": "396436",
      "Krishnapur BO": "396460",
      "Nagdhara BO": "396466",
      "Munsad BO": "396463",
      "Anklash BO": "396051",
      "Gandeva BO": "396430",
      "Khaparia BO": "396430",
      "Minkachh BO": "396430",
      "Nogama BO": "396430",
      "Kothamadi BO": "396439",
      "Pethan BO": "396440",
      "Ashtagam BO": "396433",
      "Borsi BO": "396436",
      "Chhinam BO": "396436",
      "Danti BO": "396436",
      "Maroli BO": "396436",
      "Mirzapore BO": "396436",
      "Parujan BO": "396436",
      "Dandi BO": "396439",
      "Samapur BO": "396439",
      "Chijgam BO": "396460",
      "Dabhlai BO": "396466",
      "Kumbhar Falia BO": "396466",
      "Khadsupa BO": "396433",
      "Sarpore Pardi BO": "396433",
      "Delvada Vadoli BO": "396436",
      "Dipla Falia BO": "396436",
      "Magob Bhatha BO": "396436",
      "Ponsra BO": "396436",
      "Umbhrat BO": "396436",
      "Avda Falia BO": "396439",
      "Kanera BO": "396460",
      "Italva BO": "396463",
      "Toli BO": "396469",
      "Arak Sisodra BO": "396475",
      "Parthan BO": "396475",
      "Vejalpore BO": "396475",
      "Mahudi BO": "396466",
      "Sadlav BO": "396463",
      "Adada BO": "396463",
      "Mogar BO": "396463",
      "Ambada BO": "396469",
      "Khergam Ugat BO": "396469",
      "Kurel BO": "396469",
      "Chandravasansupa BO": "396472",
      "Dambher BO": "396472",
      "Mandir BO": "396472",
      "Kuched BO": "396475",
      "Pinsad BO": "396475",
      "Sandalpore BO": "396475",
      "Navsari HO": "396445",
      "Bilimora HO": "396321",
      "Amalsad SO": "396310",
      "Bori Falia SO": "396412",
      "Gandevi SO": "396360",
      "Gurukulsupa SO": "396418",
      "Jalalpore SO": "396421",
      "Kachholi SO": "396370",
      "Karadi SO": "396440",
      "Malesar SO": "396445",
      "Satem SO": "396466",
      "Vedchha SO": "396472",
      "Vesma SO": "396475",
      "Fadvel SO": "396540",
      "Rumla SO": "396060",
      "Aat SO": "396403",
      "Abrama SO": "396406",
      "Eru Ac SO": "396450",
      "Junathana SO": "396445",
      "Kabilpore SO": "396424",
      "Matvad SO": "396439",
      "Ugat SO": "396469",
      "Antalia SO": "396325",
      "Bigri SO": "396110",
      "Chikhli SO Navsari": "396521",
      "Devsar SO": "396380",
      "Rankuva SO": "396560",
      "Alipore SO": "396409",
      "Kaliawadi SO": "396427",
      "Panar SO": "396460",
      "Sisodra SO": "396463",
      "Digendranagar SO": "396570",
      "Khergam SO": "396040",
      "Unai SO": "396590",
      "Vansda SO": "396580",
      "Dabhel SO": "396415",
      "Degam SO": "396530",
      "Gadat SO Navsari": "396350",
      "Khadsupa Boarding SO": "396433",
      "Kharel SO": "396430",
      "Maroli Bazar SO": "396436"
    },
    "AMRELI": {
      "PAVictor BO": "365555",
      "Ringanvalamota BO": "365555",
      "Bhandaria Nana BO": "365601",
      "Chandgadh BO": "365601",
      "Rangpur BO": "365601",
      "Fatepur BO": "365601",
      "Gakharvalamota BO": "365601",
      "Lalavadar BO": "365601",
      "Vathalpur K BO": "365601",
      "Vadera BO": "365610",
      "Vankiya BO": "365635",
      "Charkha BO": "365630",
      "Gadhakda BO": "364522",
      "Jabal BO": "364522",
      "Likhala BO": "364522",
      "Mitiyala BO": "364522",
      "Nanivadal BO": "364522",
      "Thoradi BO": "364522",
      "Janjariyajuna BO": "365440",
      "Kamigadh BO": "365440",
      "Shilana BO": "365440",
      "Kerala S BO": "365440",
      "Ambaradi BO": "365630",
      "Chadiya BO": "365630",
      "Gopalgram BO": "365630",
      "Halariya BO": "365630",
      "Hudli BO": "365630",
      "Dharai BO": "365410",
      "Dared BO": "365435",
      "Derdi J BO": "365435",
      "Harsurpur BO": "365435",
      "Nana Rajkot BO": "365435",
      "Jasvantgadh BO": "365620",
      "Bhingrad BO": "365220",
      "Bhurakhiya BO": "365220",
      "Chhabhadiya BO": "365220",
      "Samdhiyala1 BO": "365555",
      "Babarkot BO": "365540",
      "Khara BO": "365220",
      "Ningla2 BO": "365550",
      "Rabarika BO": "365550",
      "Gadhiya BO": "365640",
      "Gigasan BO": "365640",
      "Govindpur BO": "365640",
      "Khicha BO": "365640",
      "Malsika BO": "365640",
      "Sarasiya BO": "365640",
      "Rabhda BO": "365555",
      "Sajanvav BO": "365555",
      "Lonhtpur BO": "365540",
      "Ishavariya BO": "365601",
      "Bhandriya Mota BO": "365610",
      "Sanosara BO": "365610",
      "Taraktalv BO": "365610",
      "Kariyana BO": "365421",
      "Khakhriya BO": "365421",
      "Khambhala BO": "365421",
      "Kotdapitha BO": "365421",
      "Pansada BO": "365421",
      "Vandliya BO": "365421",
      "Bagoya BO": "364522",
      "Deripipariya BO": "365440",
      "Samdhiyala BO": "365440",
      "Kadaya BO": "365645",
      "Monvel BO": "365645",
      "Dhargni BO": "365630",
      "Amrpur V BO": "365601",
      "Keriyanagas BO": "365601",
      "Sonariya BO": "365601",
      "Gavdka BO": "365610",
      "Rajsathli BO": "365610",
      "Navaniya BO": "365421",
      "Untvad BO": "365421",
      "Vavda BO": "365421",
      "Abhrampara BO": "364522",
      "Ambardi J BO": "364522",
      "Hamapur BO": "365440",
      "Paniya BO": "365440",
      "Lunghiya BO": "365645",
      "Devarajiya BO": "365630",
      "Kerala BO": "364515",
      "Malila BO": "365630",
      "Sajiyavadar BO": "365630",
      "Gamapialiya BO": "365410",
      "Motadevaliya BO": "365410",
      "Virpur BO": "365640",
      "Randhiya BO": "365620",
      "Ambardi BO": "365220",
      "Bhalvav BO": "365220",
      "Dhemal BO": "365220",
      "Eklera BO": "365220",
      "Haripur BO": "365220",
      "Ingoralaj BO": "365220",
      "Thnsa BO": "365220",
      "Raydi BO": "365550",
      "Trakuda BO": "365550",
      "Dalkhaniya BO": "365640",
      "Devla BO": "365640",
      "Morangi BO": "365555",
      "Ditla BO": "365630",
      "Garmali C BO": "365630",
      "Garmali Moti BO": "365630",
      "Jhar BO": "365630",
      "Sarmbhda BO": "365630",
      "Pirkhijadiya BO": "365410",
      "Tramboda BO": "365410",
      "Vavdi D BO": "365410",
      "Ankadianana BO": "365620",
      "Dhangla BO": "365220",
      "Padarsinga BO": "365220",
      "Panchtalvda BO": "365220",
      "Dadali BO": "365550",
      "Jamka BO": "365440",
      "Chanch BO": "365555",
      "Dantardi BO": "365555",
      "Doliya BO": "365555",
      "Kumbhariya BO": "365555",
      "Mangvapal BO": "365601",
      "Chakkargadh BO": "365601",
      "Machyalanana BO": "365601",
      "Devaliya BO": "365601",
      "Jaliya BO": "365610",
      "Pithvajal BO": "365610",
      "Tarvada BO": "365610",
      "Garni BO": "365421",
      "Lunki BO": "365421",
      "Nilvala BO": "365421",
      "Adsang BO": "364522",
      "Luvara BO": "364522",
      "Meriyana BO": "364522",
      "Junihaliyad BO": "365440",
      "Manekvada BO": "365440",
      "Motamandvada BO": "365440",
      "Motamunjiyasar BO": "365440",
      "Chhatadiya BO": "365630",
      "Keriyachad BO": "365630",
      "Ghugharala BO": "365410",
      "Nadala BO": "365410",
      "Barwala Jam BO": "365435",
      "Shekhpipariya BO": "365435",
      "Ingorala2 BO": "365620",
      "Monpur BO": "365620",
      "Ansodar BO": "365220",
      "Bhattvadar BO": "365220",
      "Dhrufaniya BO": "365220",
      "Gundaran BO": "365220",
      "Kanchardi BO": "365220",
      "Narangadh BO": "365220",
      "Shakhpur BO": "365220",
      "Sarakadiya BO": "365550",
      "Talda BO": "365550",
      "Bordi BO": "365640",
      "Dangavadar BO": "365640",
      "Kubda BO": "365640",
      "Kotha Pipariya BO": "365640",
      "Mandal BO": "365555",
      "Lunsapur BO": "365540",
      "Moldi BO": "364521",
      "Bhavrdi BO": "365650",
      "Tatania BO": "365650",
      "Anida BO": "365635",
      "Bhayavadar BO": "365450",
      "Vavdiroad BO": "365450",
      "Jarakhiya BO": "365430",
      "Matirala BO": "365430",
      "Toda BO": "365430",
      "Bhesvadi BO": "365535",
      "Motakankot BO": "365535",
      "Sajnatimba BO": "365535",
      "Bambhaniya BO": "365460",
      "Jikiyali BO": "365635",
      "Nanidhari BO": "365635",
      "Kagvadar B.O": "365730",
      "Barpatoli BO": "365560",
      "Khakhbai BO": "365560",
      "Vadli BO": "365560",
      "Dhareshwar BO": "365560",
      "Rampara": "365560",
      "Karmdadi BO": "365640",
      "Hahtsani BO": "364515",
      "Motazinjuda BO": "364515",
      "Nesdi BO": "364515",
      "Pithvadi BO": "364515",
      "Bhada B.O": "365730",
      "Rohisa B.O": "365730",
      "Dhundhiapipaliya BO": "365480",
      "Meghapipalia BO": "365480",
      "HadalaS BO": "365456",
      "Thavi BO": "364525",
      "Amrutvel BO": "364521",
      "Bhuva BO": "364521",
      "Borala BO": "365650",
      "Junasavar BO": "364521",
      "Gidardi BO": "365650",
      "Khadadhar BO": "365650",
      "Pipalva BO": "365430",
      "Bavada BO": "365535",
      "Ingoraladand BO": "365535",
      "Kutana BO": "365535",
      "Motaujla BO": "365450",
      "Nanikunkavav BO": "365450",
      "Sanala BO": "365450",
      "Sanali BO": "365450",
      "Dudhala BO": "365640",
      "Haripura BO": "365430",
      "Khjadia RS BO": "365430",
      "Luvariya BO": "365430",
      "Shedubhar BO": "365430",
      "Amba BO": "365535",
      "Balelpiparia BO": "365460",
      "Devgam BO": "365460",
      "Pipallag BO": "365455",
      "Nagadhra BO": "365635",
      "Babriyadhar BO": "365560",
      "Bherai BO": "365560",
      "Kadiyali BO": "365560",
      "Katar BO": "365560",
      "Kotadi BO": "365560",
      "Mandardi BO": "365560",
      "Shiyalbet BO": "365560",
      "Khadkala BO": "364521",
      "Simran BO": "364521",
      "Bhad BO": "365650",
      "Umaraia BO": "365650",
      "Amarpur BO": "365450",
      "Barvalabavishi BO": "365450",
      "Keralaj BO": "365430",
      "Rampur BO": "365480",
      "Varsada BO": "365430",
      "Hathigadh BO": "365535",
      "Jatroda BO": "365535",
      "Nanaliliya BO": "365535",
      "Krankach BO": "365535",
      "DadvaRandal BO": "365460",
      "Jihtudi BO": "365460",
      "Jangar BO": "365455",
      "Ingorala Bhad BO": "365635",
      "Lakhapadar BO": "365460",
      "Rughnathpur BO": "365635",
      "Barbtana BO": "365560",
      "Kheralimoti BO": "365560",
      "Motaagariya BO": "365560",
      "Uchaiya BO": "365560",
      "Jira BO": "365640",
      "Khisari BO": "365640",
      "Trambakpur BO": "365640",
      "Charakhadiya BO": "364515",
      "Nananbhmodra BO": "364515",
      "Oliya BO": "364515",
      "Piyava BO": "364515",
      "Nageshri B.O.": "365730",
      "Devalki BO": "365480",
      "Khjuripipalia BO": "365480",
      "Khari BO": "365456",
      "Mavjinjva BO": "365456",
      "Bhmodramota BO": "364525",
      "Vadhera BO": "365540",
      "Adtala BO": "365430",
      "Akala BO": "365430",
      "Saladi BO": "365535",
      "Sanaliya BO": "365535",
      "Barman-nana B.O": "365730",
      "Hemal B.O": "365730",
      "Vavera BO": "365560",
      "Dhar BO": "364515",
      "Motamansa B.O": "365730",
      "Kovaya BO": "365541",
      "Khadkhad BO": "365480",
      "KhijadiaKhan BO": "365480",
      "Santhalibhukhli BO": "365480",
      "Tori BO": "365480",
      "KhijadiaH BO": "365480",
      "Balapur BO": "365456",
      "Fifad BO": "364525",
      "Ghoba BO": "364525",
      "Vanshiyali BO": "364525",
      "Virdi BO": "364525",
      "Vanot BO": "364530",
      "Kanatalav BO": "364515",
      "Karjala BO": "364515",
      "Senjal BO": "364515",
      "Arjansukh BO": "365480",
      "Bantvadevli BO": "365480",
      "Barvalabaval BO": "365480",
      "Khijadiakhara BO": "365456",
      "Najapur BO": "365456",
      "Pithadia BO": "365456",
      "Khalpar BO": "364525",
      "Mekda BO": "364525",
      "Shelana BO": "364525",
      "Bhamar BO": "364530",
      "Dedakadi BO": "364530",
      "Dolti BO": "364530",
      "Hadida BO": "364530",
      "Chikhali BO": "364530",
      "Ghandla BO": "364530",
      "Khasdali BO": "364530",
      "Amreli HO": "365601",
      "Badhada SO": "364522",
      "Chital SO": "365620",
      "Damnagar SO": "365220",
      "Dungar SO": "365555",
      "Lathi SO Amreli": "365430",
      "Motasamdhiyala SO": "365635",
      "Bagasara SR SO": "365440",
      "Chalala SO": "365630",
      "Dhari SR SO": "365640",
      "Khambha SO": "365650",
      "Lunidhar SO": "365460",
      "Savarkundla SO": "364515",
      "Timbi S.O": "365730",
      "Vaghaniya SO": "365456",
      "Vanda SO": "364525",
      "Amreli S R SO": "365601",
      "Babapur SO": "365610",
      "Bagasra SO": "365440",
      "Bhader SO": "365645",
      "Chavand SO": "365435",
      "Dedan SO": "365550",
      "Jafrabad SO Amreli": "365540",
      "Rajula SO": "365560",
      "Vadia SO": "365480",
      "Amreli J P SO": "365601",
      "Babra SO Amreli": "365421",
      "Chamaradi SO": "365410",
      "Dhari SO": "365640",
      "Jira SO": "364521",
      "Kunkavav SO": "365450",
      "Liliya SO": "365535",
      "Motaankadiya SO": "365455",
      "Savar SO": "364515",
      "UTCL Kovaya SO": "365541",
      "Vijpadi SO": "364530"
    },
    "BHAVNAGAR": {
      "Vejodari BO": "364130",
      "Langala BO": "364320",
      "Parvala BO": "364320",
      "Bhandariya BO": "364270",
      "Luvara BO": "364505",
      "Morba BO": "364505",
      "Nani Vavdi BO": "364505",
      "Gadhesar BO": "364130",
      "Nincha Kotda BO": "364130",
      "Kundheli BO": "364140",
      "Nava Sangana BO": "364140",
      "Pavthi BO": "364140",
      "Devgana BO": "364260",
      "Bhankhal BO": "364120",
      "Jaspara BO": "364120",
      "Karmadiya BO": "364145",
      "Kumbhariya BO": "364145",
      "Bhadraval BO": "364150",
      "Habukvad BO": "364150",
      "Lokshala BO": "364150",
      "Padri G BO": "364150",
      "Chogath BO": "364330",
      "Haliyad BO": "364330",
      "Junarampar BO": "364330",
      "Chamardi BO": "364310",
      "Kanpar BO": "364310",
      "Patna Bhal BO": "364310",
      "Bhojpara BO": "364060",
      "Kamlej BO": "364060",
      "Kalsar BO": "364130",
      "Malvav BO": "364130",
      "Raniwada BO": "364130",
      "Sakhvadar BO": "364140",
      "Sankhadasar No1 BO": "364140",
      "Sartanpar BO": "364050",
      "Shobhavad BO": "364140",
      "Tarsara BO": "364140",
      "Unchadi BO": "364140",
      "Bharoli BO": "364120",
      "Bapada BO": "364150",
      "Bela BO": "364150",
      "Royal BO": "364150",
      "Sathra BO": "364290",
      "Timana BO": "364150",
      "Dharuka BO": "364330",
      "Anandpur BO": "364310",
      "Kardej BO": "364060",
      "Sidsar BO": "364060",
      "Valukad BO": "364270",
      "Valar BO": "364130",
      "Alampar BO": "364320",
      "Dadva BO": "364320",
      "Ramanka BO": "364320",
      "Timbi BO": "364320",
      "Gujarda BO": "364505",
      "Mota Charodiya BO": "364505",
      "Panchtobra BO": "364505",
      "Gundala BO": "364260",
      "Jambala BO": "364260",
      "Kharakadi BO": "364260",
      "Pingli BO": "364260",
      "Varal BO": "364260",
      "Kukad BO": "364120",
      "Navagam BO": "364313",
      "Rajpara No 2 BO": "364120",
      "Sankhdasar No2 BO": "364120",
      "Bagdana BO": "364145",
      "Chhapri Juni BO": "364145",
      "Monpar BO": "364313",
      "Ralgon BO": "364145",
      "Vavdi BO": "364230",
      "Lundhara BO": "364310",
      "Navania BO": "364310",
      "Pachhegam BO": "364275",
      "Rajpara BO": "364310",
      "Rojiya BO": "364130",
      "Dharwala BO": "364740",
      "Bhojavadar BO": "364320",
      "Piprali BO": "364320",
      "Samadhiyala BO": "364320",
      "Vadod BO": "364320",
      "Rupavati BO": "364505",
      "Jaliya BO": "364740",
      "Limda H BO": "364740",
      "Ingorala BO": "364320",
      "Ujalvav BO": "364320",
      "Khandhera BO": "364140",
      "Makhania BO": "364140",
      "Mendha BO": "364140",
      "Pasvi BO": "364140",
      "Thadach BO": "364140",
      "Agiyali BO": "364260",
      "Dhundsar BO": "364260",
      "Dharai BO": "364145",
      "Kundhada BO": "364145",
      "Dihor BO": "364150",
      "Lakadiya BO": "364150",
      "Manar BO": "364150",
      "Loliyana BO": "364330",
      "Kalyanpur BO": "364310",
      "Kanthariya BO": "364310",
      "Muldharai BO": "364310",
      "Panvi BO": "364310",
      "Ratanvav BO": "364310",
      "Bhikda BO": "364060",
      "Fariyadka BO": "364060",
      "Bajud BO": "364210",
      "Degvada BO": "364295",
      "Gundarna BO": "364295",
      "Adhewada BO": "364002",
      "Awaniya BO": "364002",
      "Vadalmoti BO": "364530",
      "Ramdhari BO": "364210",
      "Vav BO": "364210",
      "Boda BO": "364295",
      "Galthar BO": "364295",
      "Ukharla BO": "364050",
      "Dayal BO": "364130",
      "Ambla BO": "364210",
      "Kantasar BO": "364295",
      "Loinga BO": "364295",
      "Otha BO": "364295",
      "Nagdhaniba BO": "364050",
      "Sanodar BO": "364050",
      "Concret Jetty BO": "364005",
      "Nari BO": "364004",
      "Akwada BO": "364002",
      "Budhel BO": "364002",
      "Khari BO": "364240",
      "Longdi BO": "364295",
      "Moti Jagdhar BO": "364295",
      "Nana Khuntavada BO": "364295",
      "Morchand BO": "364050",
      "Mota Khokhra BO": "364050",
      "Padva BO": "364050",
      "Malanka BO": "364002",
      "Malpara BO": "364002",
      "Borda BO": "364130",
      "Hipavadli BO": "364525",
      "Katrodi BO": "364525",
      "Piparadi BO": "364525",
      "Thansa BO": "364505",
      "Ranparda BO": "364265",
      "Shivendra Nagar BO": "364265",
      "Thordi BO": "364110",
      "Chok BO": "364510",
      "Lakhanka BO": "364070",
      "Dudheri BO": "364290",
      "Khared BO": "364290",
      "Kumbhan BO": "364250",
      "Lusdi BO": "364290",
      "Madhiya BO": "364290",
      "Vaghnagar BO": "364290",
      "Bila BO": "364280",
      "Kinkariya BO": "364280",
      "Nana Asrana BO": "364280",
      "Sedarda BO": "364280",
      "Ugalvan BO": "364280",
      "Melana BO": "364760",
      "Mokhada BO": "364270",
      "Surnivas BO": "364505",
      "Dedarda BO": "364265",
      "Dudhala BO": "364265",
      "Nanimal BO": "364265",
      "Depla BO": "364510",
      "Morchupna BO": "364510",
      "Hathab BO": "364070",
      "Khadsaliya BO": "364070",
      "Belampur BO": "364290",
      "Bhadra BO": "364290",
      "Gundarni BO": "364290",
      "Nesvad BO": "364290",
      "Rajavadar BO": "364290",
      "Ratol BO": "364290",
      "Tared BO": "364290",
      "Bahadurpur BO": "364270",
      "Dared BO": "364760",
      "Moti Rajasthali BO": "364270",
      "Moti Vavdi BO": "364275",
      "Sandhkhakhara BO": "364275",
      "Surnagar BO": "364275",
      "Timba BO": "364275",
      "Moti Dharai BO": "364313",
      "Pipardi BO": "364230",
      "Ranghola BO": "364230",
      "Budhana BO": "364240",
      "Madhada BO": "364240",
      "Mota Surka BO": "364240",
      "Nesda BO": "364240",
      "Sagwadi BO": "364240",
      "Satpada BO": "364265",
      "Ranigam BO": "364510",
      "Sanala BO": "364510",
      "Zadakla BO": "364510",
      "Naip BO": "364290",
      "Nana Jadra BO": "364290",
      "Bordi BO": "364280",
      "Dudhala No 2 BO": "364280",
      "Goras BO": "364280",
      "Karla BO": "364280",
      "Sarera BO": "364280",
      "Tatania BO": "364280",
      "Hanol BO": "364270",
      "Anida BO": "364270",
      "Bhadavav BO": "364270",
      "Bhutiya BO": "364230",
      "Hathasani BO": "364270",
      "Jaliya Amraji BO": "364270",
      "Jamanvav BO": "364270",
      "Ganeshgadh BO": "364275",
      "Kerala BO": "364135",
      "Reliya BO": "364135",
      "Nonghanvadar BO": "364230",
      "Padapan BO": "364230",
      "Samadhiyala   Mulani BO": "364230",
      "Randola BO": "364240",
      "Usrad BO": "364240",
      "Paldi BO": "364250",
      "Devli BO": "364140",
      "Fulsar BO": "364140",
      "Gorkhi BO": "364140",
      "Velavadar BO": "364313",
      "Damrala BO": "364265",
      "Kanjarda BO": "364265",
      "Panchpipla BO": "364265",
      "Bhumbhli BO": "364110",
      "Ayavej BO": "364510",
      "Chhapariyali BO": "364510",
      "Hoidad BO": "364070",
      "Nava Ratanpar BO": "364070",
      "Dundas BO": "364290",
      "Katpar BO": "364290",
      "Konjli BO": "364290",
      "Mota Zadra BO": "364290",
      "Talgajarda BO": "364290",
      "Bambhania BO": "364280",
      "Mota Asrana BO": "364280",
      "Shantinagar BO": "364280",
      "ANKOLALI BO": "364270",
      "Luvarvav BO": "364270",
      "Nani Rajashtali BO": "364270",
      "Ratanpar BO": "364270",
      "Rohishala BO": "364270",
      "Shetruji Dam BO": "364270",
      "Kharedi BO": "364275",
      "Mangadh BO": "364275",
      "Bhadbhid BO": "364313",
      "Rajgadh BO": "364313",
      "Ishwariya BO": "364230",
      "Bhadli BO": "364240",
      "Ghanghli BO": "364240",
      "Dakana BO": "364140",
      "Kamlol Nani BO": "364140",
      "Nava Sarod BO": "364270",
      "Senjaliya BO": "364270",
      "Vadiya BO": "364270",
      "JaliyaP BO": "364275",
      "Mandvi BO": "364275",
      "Pratappara BO": "364135",
      "Zanjmer BO": "364135",
      "Mevasa BO": "364313",
      "Sanesh BO": "364313",
      "Dhankankunda BO": "364230",
      "Hadmatiya BO": "364230",
      "Reva BO": "364230",
      "Kanad BO": "364240",
      "Pipaliya BO": "364240",
      "HAJIPUR BO": "364140",
      "Nana Surka BO": "364250",
      "Panchvada BO": "364250",
      "Devaliya BO": "364140",
      "Bhavnagar HO": "364001",
      "Alang SBY SO": "364081",
      "Amargadh SO": "364210",
      "Bhadrod SO": "364295",
      "Bhavnagar Gogha Circle SO": "364001",
      "Bhavnagar K Nagar SO": "364001",
      "Bhavnagar Para SO": "364003",
      "Bhavnagar Station Road SO": "364006",
      "Datha SO": "364130",
      "Dhola SO": "364320",
      "Mahuva SO Bhavnagar": "364290",
      "Pithalpur SO": "364135",
      "Tansa SO": "364120",
      "Bhandariya SO": "364050",
      "Bhavnagar BPTI SO": "364002",
      "Bhavnagar Shivaji Circle Area SO": "364001",
      "Gariyadhar SO": "364505",
      "Jesar SO": "364510",
      "Koliyak SO": "364070",
      "Palitana SO": "364270",
      "Palitana SR SO": "364270",
      "Sihor SO": "364240",
      "Songadh SO": "364250",
      "Tana SO": "364260",
      "Bhavnagar Anandnagar SO": "364005",
      "Bhavnagar Khargate SO": "364001",
      "Bhavnagar Kumbharwada SO": "364006",
      "Bhavnagar Nirmalnagar SO": "364001",
      "Bhavnagar Wadva SO": "364001",
      "Gheti SO": "364265",
      "Bhavnagar Bharatnagar SO": "364002",
      "Bhavnagar Chitra SO": "364004",
      "Bhavnagar Takhteshwar SO": "364002",
      "Gogha SO": "364110",
      "Motakhuntavada SO": "364280",
      "Parvadi SO": "364275",
      "Ratanpur Bhal SO": "364313",
      "Sanosara SO": "364230",
      "Talaja SO": "364140",
      "Trapaj SO": "364150",
      "Thaliya SO": "364145",
      "Umrala SO": "364330",
      "Vallabhipur SO": "364310",
      "Vartej SO": "364060"
    },
    "RAJKOT": {
      "Raiya NDT SO": "360005",
      "Pardi BO": "360024",
      "Gundasara BO": "360311",
      "Sandhvaya BO": "360311",
      "Lunivav BO": "360311",
      "Garnara BO": "360311",
      "Khambha BO": "360311",
      "Daiya BO": "360311",
      "Khadvanthali BO": "360311",
      "Semla BO": "360311",
      "Vora Kotda BO": "360311",
      "Charakhadi BO": "360311",
      "Shapar Halar BO": "360024",
      "Baldhoi BO": "360060",
      "Kanesara BO": "360060",
      "KharchiyaJam BO": "360060",
      "Rupavati BO": "360110",
      "Timbdi Arab BO": "360360",
      "Champrajpur BO": "360370",
      "Devki Galol BO": "360370",
      "Kharachiya BO": "360370",
      "Mekha Timbi BO": "360470",
      "Rabarika BO": "360370",
      "Kothi BO": "360060",
      "LakhavadNani BO": "360060",
      "Ambardi BO": "360050",
      "Shivrajgadh BO": "360311",
      "Vachhra BO": "360311",
      "Anida Bhalodi BO": "360311",
      "Hadamtala Kolithad BO": "360311",
      "Kerali BO": "360370",
      "Mandlikpur BO": "360370",
      "Mevasa BO": "360370",
      "Panch Pipla BO": "360370",
      "Pedhla BO": "360370",
      "Pithadia BO": "360370",
      "Premgadh BO": "360370",
      "Ardoi BO": "360030",
      "KothariaTankara BO": "363650",
      "Kundani BO": "360060",
      "Jambudi BO": "360370",
      "Mota Gundala BO": "360370",
      "Samadhiyala BO": "363440",
      "Navagam Chotila BO": "363520",
      "Pipalva BO": "360360",
      "Torania BO": "360360",
      "Derdi BO": "360370",
      "Fareni BO": "360370",
      "Reshamdi Galol BO": "360370",
      "Thana Galol BO": "360370",
      "Charania BO": "365480",
      "Dholara BO": "360022",
      "Khokhaddad BO": "360022",
      "Khakhdabela BO": "360110",
      "Khodapipar BO": "360110",
      "Ukarda BO": "360110",
      "AnandparMorbi BO": "360003",
      "Gauridad BO": "360003",
      "Maliyasan BO": "360003",
      "Sanosara BO": "360003",
      "Kherdi BO": "360002",
      "Devgam BO": "360021",
      "Bhupgadh BO": "360025",
      "Dahisara BO": "360025",
      "Kamalapur BO": "360025",
      "Bedi Tankara BO": "363650",
      "Jamvadi BO": "360311",
      "Bhunava BO": "360311",
      "Mota Mandva BO": "360311",
      "Khirsara Ghed BO": "360450",
      "Sajadiyali BO": "360405",
      "Charel BO": "360452",
      "Meta Khambhaliya B.O": "360465",
      "Chhadvavadar BO": "360410",
      "Pipaliya BO": "360410",
      "Satodad BO": "360405",
      "Vavdi BO": "360004",
      "Bakhalvad BO": "360050",
      "Gadhadia BO": "360050",
      "Kalasar BO": "360050",
      "Dedarva BO": "360360",
      "Juni Sankli BO": "360360",
      "Vadali BO": "360450",
      "KothariaTB Hosp BO": "360022",
      "Magharvada BO": "360023",
      "Mesavada BO": "360023",
      "Rafala BO": "360023",
      "Targhadia BO": "360023",
      "Kuchiyadad BO": "360023",
      "Ziyana BO": "360023",
      "Ishwariya BO": "360110",
      "Khajurdi BO": "360110",
      "Khambhala BO": "360110",
      "Khandheri BO": "360110",
      "Motakhijadia BO": "360110",
      "Sal Pipalia BO": "360110",
      "Sarapdad BO": "360110",
      "Suvag BO": "360110",
      "Thoriyali BO": "360110",
      "Zilariya BO": "360110",
      "Anandpar Navagam BO": "360003",
      "BediRajkot BO": "360003",
      "Mahika BO": "360002",
      "Khirsara BO": "360021",
      "Pal BO": "360004",
      "Gadhdiya BO": "360025",
      "Halenda BO": "360025",
      "Kharechiya BO": "360025",
      "Khandadhar BO": "360311",
      "Hadamtala Shemla BO": "360311",
      "Nana Mandva BO": "360311",
      "Ribda BO": "360311",
      "Trakuda BO": "360311",
      "Devla B.O": "360485",
      "Arni BO": "360450",
      "Gundasari BO": "360452",
      "Bhukhi BO": "360410",
      "Chhatrasa BO": "360410",
      "Kalana BO": "360410",
      "Nagalkhada BO": "360410",
      "Bhadala BO": "360050",
      "Ghela Somnath BO": "360050",
      "Kaduka BO": "360050",
      "Bava Pipaliya BO": "360360",
      "Jetalsar Gam BO": "360360",
      "Rampar Mota BO": "360110",
      "Rampar Pati BO": "360110",
      "Kankot BO": "360005",
      "Mota Mava BO": "360005",
      "Raiya BO": "360005",
      "Bedla BO": "360025",
      "Bhandaria BO": "360025",
      "Bogharavadar BO": "360025",
      "Ghoghavadar BO": "360311",
      "PipaliyaSadak BO": "360311",
      "Vekri BO": "360311",
      "Biliyala BO": "360311",
      "Ramod BO": "360311",
      "Khirasara B.O": "360485",
      "Vadasada B.O": "360485",
      "Vavdi Station B.O": "360485",
      "Ishavariya BO": "360040",
      "Jangvad BO": "360040",
      "Jasapar BO": "360040",
      "Jivapar BO": "360040",
      "Kanpar BO": "360040",
      "Panchavda BO": "360040",
      "Nava Matravad BO": "360450",
      "Timbdi Jam BO": "360450",
      "Baradiya BO": "360452",
      "Moti Khilori B.O": "360465",
      "Raidi BO": "360410",
      "Roghel BO": "360410",
      "Vadodar BO": "360410",
      "Navagam BO": "360320",
      "Dholidhar BO": "360405",
      "Pipardi BO": "360055",
      "Vadod BO": "360050",
      "Bhadli BO": "360050",
      "Moti Parabadi BO": "360360",
      "Nani Parabadi BO": "360360",
      "Anida Vachhra BO": "360070",
      "Champabeda BO": "360070",
      "Bandra BO": "360330",
      "Devchadi BO": "360330",
      "Kamar Kotda BO": "360330",
      "Sardharpur BO": "360375",
      "Vinzivad B.O": "360325",
      "Nani Vavdi BO": "360440",
      "Sodvadar BO": "360440",
      "Kalariya BO": "360490",
      "Khakhijaliya BO": "360490",
      "Nilakha BO": "360490",
      "Pransla BO": "360490",
      "Kagvad BO": "360380",
      "Gadhaka BO": "360020",
      "Padasan BO": "360020",
      "Adbalka BO": "360110",
      "Dungarka BO": "360110",
      "Hadmatiya BO": "360110",
      "Khamta BO": "360110",
      "Motichanol BO": "360110",
      "Nana Khijadia BO": "360110",
      "Targhari BO": "360110",
      "Visaman BO": "360110",
      "JaliyaDhrol BO": "360003",
      "Kagadadi BO": "360003",
      "Khorana BO": "360003",
      "Kotda Nayani BO": "360003",
      "Para  Pipaliya BO": "360006",
      "SRPF GrXIII  Ghanteshwar BO": "360006",
      "Dhulia Domda BO": "360021",
      "Mota Vada BO": "360021",
      "Nagar Pipaliya BO": "360021",
      "Mavdi BO": "360004",
      "Ravki BO": "360004",
      "Hadmatia BO": "360025",
      "Haripar BO": "360025",
      "Juna Rajpipala BO": "360025",
      "Umrali BO": "360311",
      "Rib BO": "360311",
      "Kolithad BO": "360311",
      "Patidad BO": "360311",
      "Chordi BO": "360311",
      "Dadva Mota BO": "360311",
      "Chavandi BO": "360452",
      "Dadar BO": "360452",
      "Khatli BO": "360452",
      "Bhader BO": "360410",
      "Bhola BO": "360410",
      "Chikhaliya BO": "360410",
      "Dudhivadar BO": "360410",
      "Jamnavad BO": "360410",
      "Boria BO": "360405",
      "Dadvi BO": "360405",
      "Gokhlana BO": "360050",
      "Lilapur BO": "360050",
      "Shivrajpur BO": "360050",
      "Akala BO": "360360",
      "Rajapara BO": "360030",
      "Chandli BO": "360035",
      "Bandhiya BO": "360330",
      "Satapar BO": "360330",
      "Shrinathgadh BO": "360330",
      "Hariyasan BO": "360480",
      "Padavla BO": "360480",
      "Dhudasiya B.O": "360325",
      "Dumiyani BO": "360440",
      "Bhankh BO": "360490",
      "Lath BO": "360490",
      "Varjang Jalia BO": "360490",
      "Bildi B.O": "360045",
      "Juna Pipaliya B.O": "360045",
      "Ajmer BO": "360055",
      "Chhasiya BO": "360055",
      "Lakhavad Moti BO": "360055",
      "Khareda BO": "360030",
      "Manekwada BO": "360030",
      "Dalia BO": "360070",
      "Mandan Kundla BO": "360330",
      "Shishak BO": "360330",
      "Zanzmer BO": "360440",
      "Bhimora BO": "360490",
      "Mervadar BO": "360490",
      "Talagana BO": "360490",
      "Vadala BO": "360490",
      "Dodiyala B.O": "360045",
      "Amrapar BO": "360055",
      "Hathasani BO": "360055",
      "Modhuka BO": "360055",
      "Sanali BO": "360055",
      "Bhadva BO": "360030",
      "Chibhda BO": "360035",
      "Kotha Pipalia BO": "360035",
      "Sanganva BO": "360035",
      "Nonghanchora BO": "360070",
      "Bhadajalia BO": "360421",
      "Chichod BO": "360430",
      "Khajurda BO": "360440",
      "Moti Vavdi BO": "360440",
      "Ganod BO": "360490",
      "Ishra BO": "360490",
      "Mojira BO": "360490",
      "Nagvadar BO": "360490",
      "Tanasva BO": "360490",
      "Meghpar B.O": "360045",
      "Ravna B.O": "360045",
      "Sanathali B.O": "360045",
      "Zundala B.O": "360045",
      "Devdhari BO": "360055",
      "Gundala Jas BO": "360055",
      "Khandhevadia BO": "360055",
      "Ori BO": "360055",
      "Vangadhra BO": "360055",
      "Goraiya BO": "363440",
      "Nana Matra BO": "363440",
      "Rajkot HO": "360001",
      "Gondal HO": "360311",
      "Rajkot Bedipara SO": "360003",
      "Rajkot D H College SO": "360001",
      "Rajkot Jn Plot SO": "360001",
      "Rajkot Marketing Yard SO": "360003",
      "Paddhari SO": "360110",
      "Rajkot Bhaktinagar SO": "360002",
      "Rajkot Malviyanagar SO": "360004",
      "Rajkot Udyognagar SO": "360002",
      "Sardhar SO": "360025",
      "Veraval Shapar SO": "360024",
      "Virnagar SO": "360060",
      "Mota Mava SO": "360005",
      "Rajkot Metoda Gidc SO": "360021",
      "Rajkot Popatpara SO": "360001",
      "Rajkot Sau Uni Area SO": "360005",
      "Kasturbadham SO": "360020",
      "KOTHARIA SO Rajkot": "360022",
      "KUVADAVA SO": "360023",
      "Rajkot Madhapar DSO": "360006",
      "Rajkot City SO": "360001",
      "Rajkot Kalavad Road SO": "360001",
      "Rajkot Postal Colony SO": "360004",
      "Rajkot Race Course Road SO": "360001",
      "Rajkot Sorathiawadi SO": "360002",
      "Rajkot Vivekanandnagar SO": "360002",
      "Sapar Veraval SO": "360026",
      "Rajkot Bhomeswar NDT SO": "360006",
      "Mavdi NDTSO": "360004",
      "Rajkot Bedi DSO": "360028",
      "Rajkot Raiya Road SO": "360007",
      "Rajkot Seva Sadan SO": "360001",
      "Rajkot Mochi Bazar SO": "360001",
      "Rajkot Municipal Corporation SO": "360001",
      "Dhank SO": "360460",
      "Gondal Bhojrajpara SO": "360311",
      "Jetalsar Jn SO": "360360",
      "Jetpur FW ND TSO": "360370",
      "Jetpur SO": "360370",
      "Kolki SO Rajkot": "360470",
      "Patanvav SO": "360430",
      "Vinchhiya SO": "360055",
      "Amarnagar S.O": "360485",
      "Atkot SO": "360040",
      "Bhayavadar SO": "360450",
      "Dhoraji GP NDTSO": "360410",
      "Gondal Market Yard SO": "360311",
      "Jasdan SO": "360050",
      "Lodhika SO": "360035",
      "Mengni SO": "360070",
      "Moti Marad SO": "360421",
      "Paneli SO": "360480",
      "Sultanpur S.O": "360325",
      "Supedi SO": "360440",
      "Upleta Lati Plot SO": "360490",
      "Vasavad S.O": "360045",
      "Gomta SO": "360320",
      "Gondal Bhagvatpara SO": "360311",
      "Chitravad SO": "360452",
      "Derdi Kumbaji S.O": "360465",
      "Dhoraji DG ND TSO": "360410",
      "Dhoraji SO": "360410",
      "Gondal Bhuvneshwari Pith SO": "360311",
      "Jamkandorna SO": "360405",
      "Kotda Sangani SO": "360030",
      "Moviya SO": "360330",
      "Navagadh SO": "360375",
      "Virpur SO": "360380"
    },
    "MORBI": {
      "Jivapar BO": "363655",
      "Mitana BO": "363650",
      "Daldi BO": "363621",
      "Ghiyavad BO": "363621",
      "Neknam BO": "363650",
      "Otala BO": "363650",
      "Rohishala BO": "363650",
      "Savadi BO": "363650",
      "Bhimguda BO": "363621",
      "Chandrapur BO": "363621",
      "Kerala BO": "363621",
      "Kherva BO": "363621",
      "Lunsariya BO": "363621",
      "Mahika BO": "363621",
      "Matel BO": "363621",
      "Mesariya BO": "363621",
      "Mota Khijadia BO": "363650",
      "Vachhakapar BO": "363650",
      "Bherda BO": "363621",
      "Kotharia BO": "363621",
      "Kothi BO": "363621",
      "Panchasia BO": "363621",
      "Pipaliya Raj BO": "363621",
      "Valasan BO": "363621",
      "Charadva BO": "363330",
      "Nava Ghanashyamgadh BO": "363330",
      "Ranakpur BO": "363330",
      "Ranmalpur BO": "363330",
      "Jalida BO": "363621",
      "Kankot BO": "363621",
      "Rajavadala BO": "363621",
      "Ranekpar BO": "363621",
      "Ratidevdi BO": "363621",
      "Samadhiyala BO": "363621",
      "Sardharka BO": "363621",
      "Sindhavadar BO": "363621",
      "Tarakiya BO": "363621",
      "Tithva BO": "363621",
      "Jabalpur BO": "363650",
      "Meghpar Zala BO": "363650",
      "Virvav BO": "363650",
      "Arnitimba BO": "363621",
      "Bhalgam BO": "363621",
      "Gariya BO": "363621",
      "Khijadia BO": "363621",
      "Lunsar BO": "363621",
      "Paddhara BO": "363621",
      "Panchdwarka BO": "363621",
      "Vaghasiya BO": "363621",
      "Vardusar BO": "363621",
      "Dhavana BO": "363330",
      "Kadiyana BO": "363330",
      "Merupar BO": "363330",
      "Sapakda BO": "363330",
      "Sundari BO": "363330",
      "Vegadvav BO": "363330",
      "Ghanshyampur BO": "363330",
      "Koparni BO": "363330",
      "Koyba BO": "363330",
      "Mathak BO": "363330",
      "Tikar Ran BO": "363330",
      "Ajitgadh BO": "363330",
      "Devaliya BO": "363330",
      "Kavadiya BO": "363330",
      "Malaniyad BO": "363330",
      "Ratabhe BO": "363330",
      "Derala BO": "363660",
      "Lavanpur BO": "363660",
      "Mota  Bhela BO": "363660",
      "Varsamedi BO": "363660",
      "Vavania BO": "363660",
      "Vaghpar BO": "363630",
      "Bhavpar BO": "363660",
      "Kuntasi BO": "363660",
      "Virparda BO": "363660",
      "Jivaparc BO": "363630",
      "Kumbhariya BO": "363630",
      "Juna Nagdavas BO": "363670",
      "Virvadrka BO": "363670",
      "Bagathala BO": "363641",
      "Chachapar BO": "363641",
      "Ghunda Khanpar BO": "363641",
      "Khanpar BO": "363641",
      "Khevaliya BO": "363641",
      "Nasitpar BO": "363641",
      "Rangpar Bela BO": "363641",
      "Sajanpar BO": "363641",
      "Vankada BO": "363641",
      "Virpar M BO": "363641",
      "Zinkiyali BO": "363641",
      "Gungan BO": "363642",
      "Mahendranagar BO": "363642",
      "Paneli BO": "363642",
      "Sadulkanava BO": "363642",
      "Hirapar BO": "363650",
      "Bodki BO": "363660",
      "Pipaliya BO": "363660",
      "Targhadi BO": "363660",
      "Juna Ghantila BO": "363630",
      "Khakhrechi B.O": "363630",
      "Barvala BO": "363641",
      "Biliya BO": "363641",
      "Ghunda S BO": "363641",
      "Lajai BO": "363641",
      "Lilapar BO": "363641",
      "Jajasar BO": "363670",
      "Khirai BO": "363670",
      "Vadharva BO": "363670",
      "Ghuntu BO": "363641",
      "Khakhrala BO": "363641",
      "Kherda BO": "363641",
      "Nesda K BO": "363641",
      "Rangpar BO": "363641",
      "Shakat Sanala BO": "363641",
      "Jambudiya BO": "363642",
      "Lalpar BO": "363642",
      "Pipli BO": "363642",
      "RavaparNadi BO": "363642",
      "PipaliyaA BO": "360003",
      "Harbatiyali BO": "363650",
      "Manekwada BO": "363641",
      "Nani Vavdi BO": "363641",
      "Nichimandal BO": "363641",
      "Panchasar BO": "363641",
      "Rajpar BO": "363641",
      "Makansar BO": "363642",
      "Bangavadi BO": "363650",
      "Saravad BO": "363660",
      "Kharachia BO": "363655",
      "Gala BO": "363630",
      "Haripar BO": "363630",
      "Sapar BO": "363630",
      "Sultanpur BO": "363630",
      "Vejalpar BO": "363630",
      "Venasar BO": "363630",
      "Motibarar BO": "363670",
      "Nani Barar BO": "363670",
      "Navagam BO": "363670",
      "Sokhda BO": "363670",
      "Hadmatiya BO": "363641",
      "Shri Sardanagar BO": "363641",
      "Thorala BO": "363641",
      "Unchi Mandal BO": "363641",
      "Bhadiyad BO": "363642",
      "Jodjpar Nadi BO": "363642",
      "Rafaleshwar BO": "363642",
      "Fadsar BO": "363655",
      "Kerali BO": "363655",
      "Rajpara BO": "363655",
      "Bela BO": "363655",
      "Dhudkot BO": "363655",
      "Fatsar BO": "363655",
      "Badanpar BO": "363655",
      "Untbet Shampar BO": "363655",
      "Zinzuda BO": "363655",
      "Kidi BO": "363351",
      "Ranjitgadh BO": "363351",
      "Survadar BO": "363351",
      "Susvav BO": "363351",
      "Dhanala BO": "363351",
      "Isanpur BO": "363351",
      "Ingorala BO": "363351",
      "Halvad SO": "363330",
      "Jetpar M SO": "363630",
      "Maliya Miyana SO": "363670",
      "Sakat Sanala SO": "363643",
      "Dahisara SO Rajkot": "363660",
      "Morbi MDG SO": "363641",
      "Morbi Lal Baug SO": "363642",
      "Wankaner SO": "363621",
      "Tankara SO": "363650",
      "Dhuva S.O": "363623",
      "Mayurnagar SO": "363351"
    },
    "BOTAD": {
      "Gundala BO": "364730",
      "Junvadar BO": "364730",
      "Malpara BO": "364730",
      "Mandva BO": "364740",
      "Mota Umarda BO": "364740",
      "Sakhpar Mota BO": "364750",
      "Tatam BO": "364765",
      "Goradka BO": "364765",
      "Lakhanka BO": "364765",
      "Pipaliya BO": "364765",
      "Surka BO": "364765",
      "Ingorala BO": "364730",
      "Limbdiya BO": "364730",
      "Moti Kundal BO": "364730",
      "Pipardi BO": "364730",
      "Dhrufania BO": "364750",
      "Haripar BO": "364750",
      "Reliyana BO": "364750",
      "Salangpur BO": "364750",
      "Padvadar BO": "364730",
      "Patna Malji BO": "364730",
      "Jalalpur BO": "364740",
      "Khopala BO": "364320",
      "Itaria BO": "364750",
      "Kerala BO": "364750",
      "Mandavdhar BO": "364750",
      "Rajpipla BO": "364750",
      "Khijadiya BO": "364730",
      "Rasnal BO": "364730",
      "Anida BO": "364740",
      "Vikaliya BO": "364740",
      "Chabhadia BO": "364320",
      "Bodki BO": "364750",
      "Gadhali BO": "364750",
      "Vavdi BO": "364750",
      "Khadarpar BO": "364120",
      "Adtala BO": "364765",
      "Kundli BO": "382245",
      "Nani Vavdi BO": "382245",
      "Nagnesh BO": "363410",
      "Alau BO": "382255",
      "Refda BO": "382255",
      "Chandarva BO": "382255",
      "Godhavata BO": "382255",
      "Gunda BO": "382255",
      "Khas BO": "382255",
      "Moti Vavdi BO": "382255",
      "Shahpur BO": "382250",
      "Alampur BO": "382245",
      "Aniali  K  BO": "382245",
      "Bodia BO": "382245",
      "Khokarnesh BO": "382245",
      "Umrela BO": "382245",
      "Devaliya BO": "382245",
      "Dharpipla BO": "382245",
      "Keria BO": "382245",
      "Rajpura BO": "382245",
      "Valhia BO": "382450",
      "Chokdi BO": "382250",
      "Charanki BO": "382450",
      "Bagad BO": "382255",
      "Sunderiana BO": "382255",
      "Haddad BO": "364710",
      "Kariyani BO": "364710",
      "Lathidad BO": "364710",
      "Nagalpar BO": "364710",
      "Tajpar BO": "364710",
      "Targhara BO": "364710",
      "Turkha BO": "364710",
      "Zamrala BO": "364710",
      "Salaiya BO": "364710",
      "Bambhan BO": "364710",
      "Bhimdad BO": "364710",
      "Samadhiyala No 2 BO": "364710",
      "Sherthali BO": "364710",
      "Bhadravadi BO": "364710",
      "Dhakania BO": "364710",
      "Rangpur BO": "364710",
      "Samadhiyala No 1 BO": "364710",
      "Sangvadar BO": "364710",
      "Shiyanagar BO": "364760",
      "Zinza Vadar Mota BO": "364760",
      "Gadhadiya BO": "364720",
      "Kumbhara BO": "364720",
      "Sarva BO": "364720",
      "Lakheni BO": "364760",
      "Zinzavadar Nana BO": "364760",
      "Pati BO": "364760",
      "Rohishala BO": "364760",
      "Bodi BO": "364720",
      "Bhadla Nana BO": "364720",
      "Rangpur B.O": "363421",
      "Botad Statoin Road SO": "364710",
      "Gadhada Sn SO": "364750",
      "Dhasa Gam SO": "364730",
      "Dhasa Jn SO": "364740",
      "Botad SO": "364710",
      "Ningala SO": "364760",
      "Paliyad SO": "364720",
      "Ugamedi SO": "364765",
      "Jalila SO": "382255",
      "Polarpur SO": "382250",
      "Ranpur SO": "382245",
      "Barwala Ghelasha SO": "382450"
    },
    "ARVALLI": {
      "Vagheswari BO": "383450",
      "Jumsar BO": "383450",
      "Kishangadh BO": "383450",
      "Nankhi BO": "383450",
      "Malasa BO": "383450",
      "Munai BO": "383450",
      "Sunsar BO": "383450",
      "Bayal Dhankhrol BO": "383316",
      "Bhavanpura Kampa BO": "383316",
      "Mota Kantharia BO": "383251",
      "Panibar BO": "383251",
      "Helodar BO": "383345",
      "Mahiyapur BO": "383345",
      "Rambhoda BO": "383345",
      "Behdaj BO": "383350",
      "Bhemapur BO": "383350",
      "Kaliya Kuva BO": "383350",
      "Jamgadh BO": "383350",
      "Rellawada BO": "383251",
      "Vaghpur BO": "383350",
      "Ambalia BO": "383345",
      "Aniyor Kampa BO": "383345",
      "Banthiwada BO": "383350",
      "Lalpur BO": "383350",
      "Itadi BO": "383316",
      "Moti Chinchano BO": "383316",
      "Ramos BO": "383325",
      "Dahegamda BO": "383251",
      "Gali Semro BO": "383251",
      "Intva BO": "383251",
      "Isari BO": "383251",
      "Kaswada BO": "383345",
      "Mangalpur BO": "383345",
      "Nanawada BO": "383345",
      "Piprana BO": "383345",
      "Satarda BO": "383345",
      "Vavdi BO": "383345",
      "Belyo BO": "383350",
      "Kadvadi BO": "383350",
      "Kasana BO": "383350",
      "Kolundra BO": "383350",
      "Limbodara BO": "383350",
      "Moti Mori BO": "383350",
      "Moti Moydi BO": "383350",
      "Bhachediya BO": "383316",
      "Gadha BO": "383316",
      "Ansol BO": "383251",
      "Kagda Mahuda BO": "383251",
      "NavagamIsri BO": "383251",
      "Aniyor BO": "383345",
      "Faredi BO": "383345",
      "Iploda BO": "383350",
      "Kunol BO": "383350",
      "Patelna Dhundha BO": "383350",
      "Valuna BO": "383350",
      "Amlai BO": "383315",
      "Bherunda BO": "383315",
      "Gajan BO": "383315",
      "Muloj BO": "383315",
      "Pahadpur BO": "383315",
      "Sayra BO": "383315",
      "Rakhiyal BO": "383276",
      "Savela BO": "383340",
      "Devnimori BO": "383355",
      "Dodisara BO": "383355",
      "Napda BO": "383355",
      "Budheli BO": "383246",
      "Jinjudi BO": "383246",
      "Rampuri BO": "383246",
      "Khiloda BO": "383250",
      "Kushki BO": "383250",
      "Moti Bebar BO": "383250",
      "Vanzar BO": "383250",
      "Khilodia BO": "383307",
      "Shangal BO": "383350",
      "Sisodara A BO": "383350",
      "Vasna BO": "383350",
      "Zarda BO": "383350",
      "Madapur Kampa BO": "383315",
      "Mahadevpura Kampa BO": "383315",
      "Mevda BO": "383315",
      "Nathavas BO": "383315",
      "Sakariya BO": "383315",
      "Shinavad BO": "383315",
      "Khambhisar BO": "383276",
      "Medhasan BO": "383276",
      "Jalampur BO": "383340",
      "Odha BO": "383340",
      "Dhambolia BO": "383355",
      "Dhandhasan BO": "383355",
      "Jab Chitaria BO": "383355",
      "Karchha BO": "383355",
      "Kherancha BO": "383355",
      "Palla BO": "383355",
      "Panch Mahudi BO": "383355",
      "Ambabar BO": "383246",
      "Bhanmer BO": "383246",
      "Chorimala BO": "383246",
      "Dhansor BO": "383246",
      "Ubsal BO": "383246",
      "Virpur BO": "383246",
      "Kheradi BO": "383250",
      "Nandisan BO": "383250",
      "Vandhiyol BO": "383250",
      "Ambasar BO": "383307",
      "Panchal BO": "383350",
      "Ramgadhi BO": "383350",
      "Undava BO": "383350",
      "Vaniawada BO": "383350",
      "Badodara BO": "383315",
      "Dugarvada BO": "383315",
      "Ganeshpur BO": "383315",
      "Ramana BO": "383315",
      "Davli BO": "383320",
      "Bordi BO": "383340",
      "Talod BO": "383340",
      "Ode BO": "383355",
      "Sarvoday Kendra BO": "383355",
      "Rayawada BO": "383350",
      "Relyo BO": "383350",
      "Jhalodar BO": "383315",
      "Kau BO": "383315",
      "Kolikhad BO": "383315",
      "Vaniad Kokapur BO": "383315",
      "Budhrasan BO": "383246",
      "Jayla BO": "383246",
      "Raisingpur BO": "383246",
      "Torda BO": "383246",
      "Kudol BO": "383250",
      "Lalinomath BO": "383307",
      "Rajpur BO": "383307",
      "Mau Bhavnath BO": "383245",
      "Mehru BO": "383245",
      "Nandoj BO": "383245",
      "Varthu BO": "383317",
      "Amodara BO": "383310",
      "Boral BO": "383330",
      "Chhabhou BO": "383330",
      "Hirapur BO": "383310",
      "Jasvantpura Kampa BO": "383310",
      "Khadol BO": "383310",
      "Shantipura BO": "383310",
      "Shinol BO": "383310",
      "Ubharan BO": "383335",
      "Rinchvad BO": "383315",
      "Gadhada BO": "383320",
      "Shampur BO": "383320",
      "Hathipura BO": "383340",
      "Indran BO": "383340",
      "Adhera BO": "383250",
      "Bamanvad BO": "383250",
      "Bolundra BO": "383250",
      "Sunokh BO": "383250",
      "Bhutavad BO": "383245",
      "Chiboda BO": "383245",
      "Dholvani BO": "383245",
      "Jeshingpur BO": "383245",
      "Lilchha BO": "383245",
      "Narsoli BO": "383245",
      "Raipur BO": "383245",
      "Desaipura BO": "383330",
      "Madhavgadh BO": "383330",
      "Bhensawada BO": "383310",
      "Bilwania BO": "383310",
      "Dhamania BO": "383310",
      "Khadoda BO": "383310",
      "Kolvada BO": "383310",
      "Naranpura Kampa BO": "383310",
      "Magodi BO": "383335",
      "Tunadar BO": "383335",
      "Khalvad BO": "383245",
      "Nava Bhavnath BO": "383245",
      "Vankaner BO": "383245",
      "Mahadevgram BO": "383317",
      "Moti Isrol BO": "383317",
      "Deroli BO": "383330",
      "Lank BO": "383330",
      "Butal BO": "383310",
      "Kidi BO": "383310",
      "Navi Shinol BO": "383310",
      "Khalikpur BO": "383335",
      "Chunakhan BO": "383245",
      "Vejpur BO": "383245",
      "Rampura Kampa BO": "383260",
      "Dolpur BO": "383310",
      "Sika BO": "383310",
      "Ujleshvar BO": "383310",
      "Badarpura BO": "383335",
      "Barnoli BO": "383335",
      "Bhempoda BO": "383335",
      "Gotapur BO": "383335",
      "Sarsoli BO": "383335",
      "Vankaneda BO": "383335",
      "Vatrakgadh BO": "383260",
      "Bhukhel BO": "383325",
      "Bibinivav BO": "383325",
      "Choila BO": "383325",
      "Dakhneshwar BO": "383325",
      "Ganeshpura BO": "383325",
      "Vantda Bayad BO": "383325",
      "Bhetali BO": "383245",
      "Ambaliara BO": "383325",
      "Limb BO": "383325",
      "Chandrej BO": "383260",
      "Amiapura BO": "383325",
      "Bhundasan BO": "383325",
      "Dabha BO": "383325",
      "Jitpur BO": "383325",
      "Pipodara BO": "383325",
      "Vasnirel BO": "383325",
      "Bhatera BO": "383245",
      "Borditimba BO": "383260",
      "Alwa BO": "383325",
      "Ambagam BO": "383325",
      "Radodara BO": "383325",
      "Ranechi BO": "383325",
      "Tenpur BO": "383325",
      "Untarda BO": "383325",
      "Demai SO": "383330",
      "Dhansura SO": "383310",
      "Gabat SO": "383335",
      "Limbhoi SO": "383316",
      "Malpur SO": "383345",
      "Meghraj SO": "383350",
      "Sathamba SO": "383340",
      "Shamlaji SO": "383355",
      "Takatuka SO": "383246",
      "Dadhalia SO": "383317",
      "Lusadia SO": "383251",
      "Modasa Bazar SO": "383315",
      "Sardoi SO": "383320",
      "Bhiloda Bazar SO": "383245",
      "Bhiloda SO": "383245",
      "Akrund SO": "383260",
      "Bayad SO": "383325",
      "Modasa SO": "383315",
      "Tintoi SO": "383250",
      "Vadagam SO": "383307"
    },
    "SURENDRANAGAR": {
      "Nana Goraiya BO": "363745",
      "Nava Savlas BO": "363745",
      "Gunda BO": "363520",
      "Vadali BO": "363520",
      "Zinzuda BO": "363520",
      "Bhensjal BO": "363410",
      "Borana BO": "363410",
      "Chachka BO": "363410",
      "Chokdi BO": "363410",
      "Kanthariya BO": "363410",
      "Nagadka BO": "363410",
      "Vastadi BO": "363410",
      "Gavana BO": "363750",
      "Kathada BO": "363750",
      "Gangad BO": "363115",
      "Bavli BO": "363310",
      "Surel BO": "363780",
      "KhervaJat BO": "363745",
      "NagadkaJat BO": "363745",
      "Sokhda BO": "363745",
      "Chhalala BO": "363410",
      "Jobala BO": "363410",
      "Dhokalva BO": "363520",
      "Janivadla BO": "363520",
      "Kherana BO": "363520",
      "Moti Moldi BO": "363520",
      "Piyava BO": "363520",
      "Bharada BO": "363310",
      "Kondh BO": "363310",
      "Kuda BO": "363310",
      "Bhadreshi BO": "363040",
      "Chamaraj BO": "363040",
      "Gujarvadi BO": "363040",
      "Velavadar BO": "363040",
      "Khamisana BO": "363040",
      "Anandpur Bhal BO": "363423",
      "Balol BO": "363423",
      "Ratanpar BO": "363020",
      "Odu BO": "363760",
      "Bhadena BO": "363775",
      "Bhadvana BO": "363775",
      "Akhiyana BO": "363745",
      "Degam BO": "363745",
      "Gediya BO": "363745",
      "Pipali BO": "363745",
      "Chiroda BO": "363520",
      "Devsar BO": "363520",
      "Panchvada BO": "363520",
      "Pipaliya Dhora BO": "363520",
      "Pipaliya Dhandhal BO": "363520",
      "Loya BO": "363410",
      "Naviyani BO": "363750",
      "Panva BO": "363750",
      "Ingrodi BO": "363115",
      "Karela BO": "363115",
      "Zadiyana BO": "363780",
      "Kacholiya BO": "363745",
      "MalvanJat BO": "363745",
      "Sedla BO": "363745",
      "Chhatriyala BO": "363410",
      "Minapur BO": "363410",
      "Anandpur Bhadla BO": "363520",
      "Chobari BO": "363520",
      "Dharai BO": "363520",
      "Khatdi BO": "363510",
      "Vaghada BO": "382130",
      "Malanpur BO": "382130",
      "Kherdi BO": "363520",
      "Nava BO": "363520",
      "Rajpara BO": "363520",
      "Reshamiya BO": "363520",
      "Karol BO": "363410",
      "Korda BO": "363410",
      "Laliyad BO": "363410",
      "Mojidad BO": "363410",
      "Olak BO": "363115",
      "Gala BO": "363310",
      "Jasmatpur BO": "363310",
      "Jiva BO": "363310",
      "Kankavati BO": "363310",
      "Methan BO": "363310",
      "Narali BO": "363310",
      "Narichana BO": "363310",
      "Ramgadh BO": "363310",
      "Sara BO": "363310",
      "Sarval BO": "363310",
      "Ravaliyavadar BO": "363040",
      "Enjar BO": "363330",
      "Malod BO": "363020",
      "Munjpar BO": "363020",
      "Ervada BO": "363750",
      "Vadgam BO": "363750",
      "Vanod BO": "363750",
      "Malika BO": "363115",
      "Bhechda BO": "363310",
      "Dhrumath BO": "363310",
      "Haripar BO": "363310",
      "Jesda BO": "363310",
      "Manpar BO": "363310",
      "Soldi BO": "363310",
      "Vavdi BO": "363310",
      "Khodu BO": "363040",
      "Nagra BO": "363040",
      "Devpara BO": "363423",
      "Janshali BO": "363423",
      "Kherali BO": "363020",
      "RAMPARA BO": "363435",
      "Sanosara BO": "363520",
      "Sapar BO": "363520",
      "Khandiya BO": "363410",
      "Kudla BO": "363410",
      "MorvadJuni BO": "363410",
      "Shirvaniya BO": "363410",
      "Bhragupur BO": "363410",
      "Bubvana BO": "363750",
      "Echhvada BO": "363750",
      "Sushiya BO": "363750",
      "Visavadi BO": "363750",
      "Chharad BO": "363115",
      "Hebatpur BO": "363115",
      "DHANKI BO": "363115",
      "Chuli BO": "363310",
      "Gajanvav BO": "363310",
      "Jegadva BO": "363310",
      "Malvan BO": "363310",
      "Thala BO": "363310",
      "Bakarthali BO": "363040",
      "Katuda BO": "363040",
      "Mota Ankevaliya BO": "363040",
      "Kamalpar BO": "363423",
      "Limli BO": "363020",
      "Adalsar BO": "363775",
      "Dervala BO": "363775",
      "Devaliya BO": "363775",
      "Kadu BO": "363775",
      "Kalam BO": "363775",
      "Sadad BO": "363775",
      "Sakar BO": "363775",
      "Ankevaliya BO": "363421",
      "Baldana BO": "363421",
      "Bhathan BO": "363421",
      "Choki BO": "363421",
      "Tokrala BO": "363421",
      "Tuva BO": "363421",
      "Untadi BO": "363421",
      "Bhaduka BO": "363510",
      "Danavada BO": "363510",
      "Bharad BO": "363320",
      "Hampar BO": "363320",
      "Khambhada BO": "363320",
      "Rajcharadi BO": "363320",
      "Gundiyala BO": "363435",
      "Sidhsar BO": "363430",
      "Thoriyali BO": "363430",
      "Vadia BO": "363430",
      "Varsani BO": "363427",
      "Mandasar BO": "363530",
      "Fatepur BO": "363755",
      "Nagvada BO": "363755",
      "Lilapur BO": "363775",
      "Tarmaniya BO": "363775",
      "Bhalgamda BO": "363421",
      "Bhoika BO": "363421",
      "Chachana BO": "363421",
      "Gedi BO": "363421",
      "Mota Timbla BO": "363421",
      "Vadod BO": "363421",
      "Gadhad BO": "363510",
      "Kukda BO": "363510",
      "Shekhpar BO": "363510",
      "Tikar Parmar BO": "363510",
      "Bhojpara BO": "363423",
      "Upariyala BO": "363765",
      "Devcharadi BO": "363320",
      "Ganjela BO": "363320",
      "Fulgram BO": "363435",
      "Gosal BO": "363430",
      "Vakhatpar BO": "363430",
      "Khajeli BO": "363427",
      "Ranagadh BO": "363427",
      "Talsana BO": "363427",
      "Tavi BO": "363427",
      "Dhajala BO": "363440",
      "Sejakpar BO": "363440",
      "Chorvira BO": "363530",
      "Morthala BO": "363530",
      "Vijaliya BO": "363530",
      "Anindra BO": "363110",
      "Bajarangpura BO": "363110",
      "Modhvana BO": "363110",
      "Bala BO": "363030",
      "Kharva BO": "363030",
      "Dhama BO": "363755",
      "Nani Kathechi BO": "363775",
      "Savlana BO": "363775",
      "Zamar BO": "363775",
      "Borna BO": "363421",
      "Katariya BO": "363421",
      "Raska BO": "363421",
      "Vanala BO": "363421",
      "Dudhai BO": "363510",
      "Gautamgadh BO": "363510",
      "Jasapar BO": "363510",
      "Somasar BO": "363510",
      "Umarda BO": "363510",
      "Khambhalav BO": "363423",
      "Bamanva BO": "363765",
      "Goriyavad BO": "363765",
      "Moti Majethi BO": "363765",
      "Savda BO": "363765",
      "Dholi BO": "363320",
      "Dumana BO": "363320",
      "Mota Madhad BO": "363435",
      "Doliya BO": "363430",
      "Juna Jasapar BO": "363430",
      "Ghaghretiya BO": "363427",
      "Dhandhalpur BO": "363440",
      "Ninama BO": "363440",
      "Tarnetar BO": "363530",
      "Ghanad BO": "363110",
      "Nana Ankevaliya BO": "363110",
      "Dedadra BO": "363030",
      "Kothariya BO": "363030",
      "Rajpar BO": "363030",
      "Vadla BO": "363030",
      "Jambu BO": "363421",
      "Samla BO": "363421",
      "Sauka BO": "363421",
      "Digsar BO": "363510",
      "Kalmad BO": "363510",
      "Kuntalpur BO": "363510",
      "Liya BO": "363510",
      "Pandavara BO": "363510",
      "Sarla BO": "363510",
      "Ralol BO": "363423",
      "Chikasar BO": "363765",
      "Jainabad BO": "363765",
      "Jarvala BO": "363765",
      "Porda BO": "363765",
      "Navalgadh BO": "363320",
      "Pratappur BO": "363320",
      "Navaniya BO": "363430",
      "Mulbavla BO": "363427",
      "Natvargadh BO": "363427",
      "Parali BO": "363427",
      "Parnala BO": "363427",
      "Garambhadi BO": "363440",
      "Khintala BO": "363440",
      "Nadala BO": "363440",
      "Navagam Sayla BO": "363440",
      "Noli BO": "363440",
      "Piprali BO": "363440",
      "Ranipat BO": "363530",
      "Songadh BO": "363530",
      "Vagadiya BO": "363530",
      "Pedhda BO": "363110",
      "Memka BO": "363030",
      "Sankali BO": "363030",
      "Timba BO": "363030",
      "Vaghela BO": "363030",
      "Zampodad BO": "363030",
      "Surendranagar HO": "363001",
      "Patdi SO": "363765",
      "Surendranagar Udyognagar SO": "363002",
      "Joravarnagar SO": "363020",
      "Limbdi SO": "363421",
      "Panshina SO": "363423",
      "Sayla SO Surendra Nagar": "363430",
      "Shiyani SO": "363427",
      "Sudamada SO": "363440",
      "Surendranagar MPSC SO": "363002",
      "Wadhwancity SO": "363030",
      "Adariyana SO": "363780",
      "Bajana SO": "363745",
      "Kharaghoda SO": "363760",
      "Wadhwancity Ind Estate SO": "363035",
      "Zinzuwada SO": "363755",
      "Chotila SO": "363520",
      "Chuda SO": "363410",
      "Dasada SO": "363750",
      "VITHALGADH SO": "363115",
      "Dhrangadhra SO": "363310",
      "Dudhrej SO": "363040",
      "Lakhtar SO": "363775",
      "Muli SO": "363510",
      "Rajsitapur SO": "363320",
      "Kholadiyad SO": "363435",
      "Thangadh SO": "363530",
      "Vana SO": "363110",
      "Surendranagar Junction NDTSO": "363001"
    },
    "JUNAGADH": {
      "Anandpur BO": "362263",
      "Dungarpur BO": "362263",
      "Bamnasa Ghed BO": "362625",
      "Matiyana BO": "362625",
      "Mankhetra BO": "362225",
      "Rahij BO": "362225",
      "Shapar BO": "365440",
      "Bhalgam BO": "362620",
      "Vadala Ghed BO": "362625",
      "Sheriaj BO": "362225",
      "Husenabad BO": "362225",
      "Nakra BO": "362625",
      "Sitana BO": "362625",
      "Sultanpur BO": "362225",
      "Ambalia BO": "362625",
      "Ratang BO": "362120",
      "Vadla BO": "362205",
      "Nani Monpari BO": "362120",
      "Dhanfuliya BO": "362205",
      "Mohabatpur BO": "362205",
      "Barula BO": "362255",
      "Ladudi BO": "362255",
      "Akala BO": "362245",
      "Sonardi BO": "362205",
      "Khorasa Gir BO": "362255",
      "Haripur BO": "362150",
      "Monia BO": "362120",
      "Koyali BO": "362205",
      "Achhidra BO": "362255",
      "Chuldi BO": "362255",
      "Jangar BO": "362255",
      "Kothdi BO": "362630",
      "Nandarkha BO": "362630",
      "Maktupur BO": "362225",
      "Kalavad Gir BO": "362130",
      "Khambha Gir BO": "362130",
      "Sherdi BO": "362640",
      "Thaniyana BO": "362640",
      "Zinjri BO": "362640",
      "Antroli BO": "362240",
      "Bamanvada BO": "362240",
      "Kalej BO": "362240",
      "Mekhdi BO": "362240",
      "Sharma BO": "362230",
      "Sultanabad BO": "362630",
      "Tikar BO": "362630",
      "Velva BO": "362630",
      "Dhelana BO": "362225",
      "Loej BO": "362225",
      "Jambuda BO": "362630",
      "Galvav BO": "362630",
      "Kotharia BO": "362630",
      "Koylana Ghed BO": "362630",
      "Sanosara BO": "362630",
      "Jetalvad BO": "362130",
      "Kalsari BO": "362130",
      "Leriya BO": "362130",
      "Motimonpari BO": "362130",
      "Ravni Kuba BO": "362130",
      "Ghodadar BO": "362230",
      "Samarda BO": "362230",
      "Buri BO": "362630",
      "Chandvana BO": "362225",
      "Prempara BO": "362130",
      "Vekariya BO": "362130",
      "Bhindora BO": "362640",
      "Indra BO": "362640",
      "Ajak BO": "362240",
      "Divasa BO": "362240",
      "Nanadarkhi BO": "362240",
      "Chudva BO": "362640",
      "Khadia BO": "362263",
      "Nagichana BO": "362240",
      "Talodra BO": "362240",
      "Bagasara Ghed BO": "362620",
      "Bhadula BO": "362620",
      "Bhathrot BO": "362620",
      "Samega BO": "362620",
      "Vekri BO": "362620",
      "Ivnagar BO": "362015",
      "Bantia BO": "362610",
      "Bodka BO": "362610",
      "Dungri BO": "362610",
      "Kanjha BO": "362610",
      "Butdi BO": "362130",
      "Dhebar BO": "362130",
      "Ghodasan BO": "362130",
      "Dadva BO": "362620",
      "Miti BO": "362620",
      "Plasva BO": "362015",
      "Bhiyal BO": "362310",
      "Sukhpur BO": "362310",
      "Balot BO": "362610",
      "Navda BO": "362610",
      "Vadasada BO": "360490",
      "Deshinga BO": "362620",
      "Kodvav BO": "362620",
      "Marmath BO": "362620",
      "Pajod BO": "362620",
      "Vijapur BO": "362015",
      "Chokli BO": "362310",
      "Mota Kajaliyara BO": "362610",
      "Piplana BO": "362610",
      "Limbuda BO": "362620",
      "Chikhlodra BO": "362650",
      "Meghpur BO": "362610",
      "Santalpur BO": "362610",
      "Zampodad BO": "362610",
      "Jonpur BO": "362222",
      "Mangalpur BO": "362222",
      "Muliyasa BO": "362222",
      "Akha BO": "362222",
      "Manekvada BO": "362222",
      "Tinmas BO": "362222",
      "Chanaka BO": "362020",
      "Kotda Mota BO": "362020",
      "Morvada BO": "362020",
      "Rafalia BO": "362020",
      "Shobha Vadla BO": "362020",
      "Mota Hadmatia BO": "362110",
      "Navapipalia BO": "362110",
      "Budhecha BO": "362250",
      "Khambhaliya BO": "362030",
      "Galiavad BO": "362037",
      "Dhandhusar BO": "362002",
      "Bhatsimroli BO": "362220",
      "Char BO": "362220",
      "Motighansari BO": "362220",
      "Nanighansari BO": "362220",
      "Simrolibava BO": "362220",
      "Kalvani BO": "362227",
      "Pankhan BO": "362227",
      "Ganthila BO": "362215",
      "Magharvada BO": "362215",
      "Amrapur Gir BO": "362245",
      "Galodar BO": "362245",
      "Jalondhar BO": "362245",
      "Kadaya BO": "362245",
      "Vadiya BO": "362245",
      "Kenedipur BO": "362260",
      "Khijadiya BO": "362260",
      "Manpur BO": "362260",
      "Chhodavadi BO": "362030",
      "Mendpara BO": "362030",
      "Juni Chavand BO": "362120",
      "Gundala BO": "362263",
      "Toraniya BO": "362263",
      "Galath BO": "362020",
      "Vichhavad BO": "362020",
      "Bandhala BO": "362110",
      "Arena BO": "362250",
      "Nandarkhi BO": "362002",
      "Ravni BO": "362002",
      "Vadhavi BO": "362002",
      "Fulrama BO": "362220",
      "Khirsara Ghed BO": "362220",
      "Osa BO": "362220",
      "Padodar BO": "362220",
      "Panchala BO": "362220",
      "Pipli BO": "362220",
      "Rangpur BO": "362227",
      "Sondarda BO": "362227",
      "Goladhar BO": "362011",
      "Makhiyala BO": "362011",
      "Avania BO": "362245",
      "Babra Gir BO": "362245",
      "Bhanduri BO": "362245",
      "Dudhala BO": "362245",
      "Motidhanej BO": "362245",
      "Jamka BO": "362263",
      "Nagalpur BO": "362263",
      "Sakhdavadar BO": "362263",
      "Dholva BO": "362020",
      "Hadmatiya Khajuri BO": "362020",
      "Sardarpur BO": "362020",
      "Umrali BO": "362020",
      "Nanakotda BO": "362110",
      "Navania BO": "362110",
      "Khera BO": "362250",
      "Khamdhrol BO": "362037",
      "Bhavnath BO": "362002",
      "Chandigadh BO": "362220",
      "Divrana BO": "362220",
      "Khamidana BO": "362220",
      "Movana BO": "362220",
      "Nunarda BO": "362220",
      "Sandha BO": "362220",
      "Gelana BO": "362227",
      "Meswan BO": "362227",
      "Aniala BO": "362215",
      "Khokharda BO": "362215",
      "Khorasa Ahir BO": "362215",
      "Thanapipli BO": "362215",
      "Jhalansar BO": "362011",
      "Ambecha BO": "362245",
      "Gangecha BO": "362245",
      "Juthal BO": "362245",
      "Matarvaniya BO": "362245",
      "Panidhra BO": "362245",
      "Tarsingda BO": "362245",
      "Alidhra BO": "362260",
      "Gadhali BO": "362260",
      "Khadpipli BO": "362260",
      "Malanka BO": "362260",
      "Bamangadh BO": "362030",
      "Kariya BO": "362030",
      "Baradiya BO": "362120",
      "Barvala Galath BO": "362020",
      "Chuda BO": "362020",
      "Dharigundali Juni BO": "362020",
      "Parabvavdi BO": "362020",
      "Chorvadi BO": "362110",
      "Mangnathpipli BO": "362110",
      "Rameshwar BO": "362110",
      "Virpur BO": "362110",
      "Kathrota BO": "362315",
      "Kukasvada BO": "362250",
      "Sheriyakhan BO": "362250",
      "Visanvel BO": "362250",
      "Ajab BO": "362220",
      "Badodar BO": "362220",
      "Kaneri BO": "362220",
      "Pransli BO": "362220",
      "Akhodad So BO": "362220",
      "Balagam BO": "362220",
      "Bhatiya BO": "362215",
      "Dhrabavad BO": "362215",
      "Nonjanvav BO": "362215",
      "Simasi BO": "362215",
      "Patrapasar BO": "362011",
      "Rajesar BO": "362260",
      "Limadhra BO": "362120",
      "Pikhor BO": "362245",
      "Shergadh BO": "362245",
      "Virdi BO": "362245",
      "Ambala BO": "362260",
      "Chiroda BO": "362260",
      "Datrana BO": "362260",
      "Dedakiyal BO": "362260",
      "Samadhiyala BO": "362260",
      "Hadmatiya  Vishal BO": "362030",
      "Kharachiya V BO": "362030",
      "Chaparda BO": "362120",
      "Dadar BO": "362120",
      "Junagadh HO": "362001",
      "Shil SO": "362240",
      "Sardargadh SO": "362640",
      "Junagadh Agri Campus SO": "362001",
      "Junagadh Azad Chowk SO": "362001",
      "Majevadi SO": "362011",
      "Malia Hatina SO": "362245",
      "RanpurS SO": "362030",
      "Sarsai SO": "362120",
      "ShapurS SO": "362205",
      "Timbavadi SO": "362015",
      "Junagadh Mangnath Road SO": "362001",
      "Junagadh Station Road SO": "362001",
      "Sasan Gir SO": "362135",
      "Bantwa SO": "362620",
      "Mangrol Bundar SO": "362226",
      "Junagadh Sardarbag SO": "362001",
      "Lushala SO": "362215",
      "Mendarda SO": "362260",
      "VanthaliS SO": "362610",
      "Visavadar SO": "362130",
      "Manavadar SO": "362630",
      "Bhesan SO": "362020",
      "Dolatpara SO": "362037",
      "Junagadh Joshipura SO": "362002",
      "Keshod SO": "362220",
      "Kevadra SO": "362227",
      "Sherbaug SO": "362255",
      "Vadal SO": "362310",
      "Mangrol SO Junagadh": "362225",
      "Nanadia SO": "362625",
      "Chorvad SO": "362250",
      "Agatrai SO": "362222",
      "Bagdu SO": "362263",
      "Choki SO": "362315",
      "Bilkha SO": "362110"
    },
    "GIR SOMNATH": {
      "Mandorna BO": "362140",
      "Moruka BO": "362140",
      "Rasulpara BO": "362140",
      "Surva BO": "362140",
      "Vadala BO": "362140",
      "Jasadhar BO": "362560",
      "Hadmatiya BO": "362140",
      "Javantri BO": "362140",
      "Rampara Gir BO": "362140",
      "Ratidhar BO": "362140",
      "Adri BO": "362255",
      "Deda BO": "362255",
      "Vavdi BO": "362255",
      "Bakula Dhanej BO": "362150",
      "Borvav BO": "362150",
      "Chitravad BO": "362150",
      "Dhava BO": "362150",
      "Sangodra BO": "362150",
      "Semarvav BO": "362150",
      "Kindarva BO": "362255",
      "Simar BO": "362550",
      "Vadodara Dodia BO": "362255",
      "Dhamlej BO": "362275",
      "Lodhva BO": "362275",
      "Prasnavada BO": "362275",
      "Rakhej BO": "362275",
      "Gundran BO": "362150",
      "Jepur BO": "362150",
      "Khandheri BO": "362150",
      "Vadodarazala BO": "362275",
      "Gabha BO": "362150",
      "Kodidra BO": "362150",
      "Madhupur Jambur BO": "362150",
      "Chitrod BO": "362135",
      "Sidokar BO": "362255",
      "Singsar BO": "362275",
      "Amblash BO": "362150",
      "Dhramanva BO": "362150",
      "Ghunsiya BO": "362150",
      "Lumbha BO": "362150",
      "Maljinjva BO": "362150",
      "Tulsishyam BO": "362560",
      "Umej BO": "362560",
      "Untvada BO": "362560",
      "Vankia BO": "362560",
      "Varsingpur BO": "362560",
      "Vavarda BO": "362560",
      "Dari BO": "362265",
      "Virpur BO": "362150",
      "Bhacha BO": "362560",
      "Bodidhar BO": "362560",
      "Gangda BO": "362560",
      "Amodra BO": "362560",
      "Bhadiyadhar BO": "362560",
      "Kanakia BO": "362560",
      "Kesariya BO": "362560",
      "Motadesar BO": "362560",
      "Dabhor BO": "362265",
      "Inaj BO": "362268",
      "Kajardi BO": "362560",
      "Kansari BO": "362560",
      "Nathal BO": "362560",
      "Govindpara BO": "362268",
      "Bamnasa Gir BO": "362140",
      "Ukadiya BO": "362150",
      "Ambavad BO": "362560",
      "Kandhi BO": "362560",
      "Samter BO": "362560",
      "Simasi BO": "362560",
      "Naliya Mandvi BO": "362510",
      "Paldi BO": "362510",
      "Bandharda BO": "362565",
      "Sindhaj BO": "362710",
      "Fulka BO": "362530",
      "Jargali BO": "362530",
      "Thordi BO": "362530",
      "Zudvali BO": "362530",
      "Arnej BO": "362720",
      "Chhara BO": "362720",
      "Harmadiya BO": "362720",
      "Kotda BO": "362720",
      "Panadar BO": "362720",
      "Velan BO": "362720",
      "Kajli BO": "362268",
      "Moradiya BO": "362268",
      "Pransli BO": "362268",
      "Umbari BO": "362268",
      "Gharal BO": "362550",
      "Vasoj BO": "362510",
      "Mota Samadhiyala BO": "362565",
      "Nana Samadhiyala BO": "362565",
      "Ugla BO": "362565",
      "Nagadiya B.O": "362565",
      "Chhachhar BO": "362710",
      "Gir Devli BO": "362710",
      "Intvaya BO": "362530",
      "Kodiya BO": "362530",
      "Muldwarka BO": "362720",
      "Vadnagar BO": "362720",
      "Aalidar BO": "362720",
      "Jamanvada BO": "362720",
      "Kaj BO": "362720",
      "Ajotha BO": "362268",
      "Amrapur BO": "362268",
      "Gorakhmadhi BO": "362268",
      "Savni BO": "362268",
      "Solaj BO": "362268",
      "Nava Bandar BO": "362510",
      "Tad BO": "362510",
      "Ambala BO": "362565",
      "Bediya BO": "362565",
      "Sandhnidhar BO": "362710",
      "Fatsar BO": "362530",
      "Jamvala BO": "362530",
      "Khapat BO": "362530",
      "Khilavad BO": "362530",
      "Vadviyala BO": "362530",
      "Kadvasan BO": "362720",
      "Devli BO": "362720",
      "Dolasa BO": "362720",
      "Mitiyaj BO": "362720",
      "Pedhavada BO": "362720",
      "Sarkhadi BO": "362720",
      "Bhalpara BO": "362268",
      "Kadvar BO": "362268",
      "Pikhor BO": "362268",
      "Pranchi BO": "362268",
      "Tobra BO": "362268",
      "Anjar BO": "362510",
      "Kalapan BO": "362510",
      "Kob BO": "362510",
      "Dron BO": "362530",
      "Sanvav BO": "362530",
      "Morvada BO": "362720",
      "Moti Fafdi BO": "362720",
      "Velva BO": "362720",
      "Vithalpur BO": "362720",
      "Lati BO": "362268",
      "Navadra BO": "362268",
      "Rampara BO": "362268",
      "Rangpur BO": "362268",
      "Khatrivada BO": "362550",
      "Motha BO": "362550",
      "Saiyad Rajpara BO": "362550",
      "Girgadhda SO": "362530",
      "Kodinar SO": "362720",
      "Prabhas Patan SO": "362268",
      "Sutrapada SO": "362275",
      "Una SO": "362560",
      "Talala SO": "362150",
      "Veraval Rayon Factory SO": "362265",
      "Veraval SO": "362265",
      "Sanakhda SO": "362550",
      "Dhokadva SO": "362565",
      "Akolvadi SO": "362140",
      "Ambujanagar SO": "362715",
      "Ghantvad SO": "362710",
      "Delvada SO": "362510"
    },
    "PORBANDAR": {
      "Garej BO": "360576",
      "Erda BO": "360576",
      "Gosa BO": "360576",
      "Mitrala BO": "360576",
      "Bhad BO": "360576",
      "Mul Madhavpur BO": "362230",
      "Kadachh BO": "362230",
      "Mander BO": "362230",
      "Pata BO": "362230",
      "Aniyari BO": "360570",
      "Jamboo BO": "360570",
      "Ranabordi BO": "360570",
      "Ranakhirasara BO": "360570",
      "Bhod BO": "360550",
      "Bileshwar BO": "360550",
      "Ratia BO": "360576",
      "Amar BO": "360570",
      "Bapodar BO": "360570",
      "Mokal BO": "360570",
      "Vadvalarana BO": "360570",
      "Dharampur BO": "360550",
      "Balej BO": "362230",
      "Odadar BO": "360576",
      "Tukda Gosa BO": "360576",
      "Bhoddar BO": "360570",
      "Thoyana BO": "360570",
      "Valotra BO": "360570",
      "Amardad BO": "360550",
      "Navibandar BO": "360576",
      "Advana BO": "360590",
      "Kindarkheda BO": "360590",
      "Morana BO": "360590",
      "Amipur BO": "362620",
      "Farer BO": "362620",
      "Kansavad BO": "362620",
      "Mahiyari BO": "362620",
      "Bhavpara BO": "360579",
      "Khapat BO": "360579",
      "Kuchhdi BO": "360579",
      "Visavada BO": "360579",
      "Gokran BO": "362650",
      "Ishwaria BO": "362650",
      "Paswali BO": "362650",
      "Sisli BO": "360590",
      "Sodhana BO": "360590",
      "Kadegi BO": "362620",
      "Bakharla BO": "360579",
      "Degam BO": "360579",
      "Chauta BO": "362650",
      "Bharvada BO": "360590",
      "Khambhodar BO": "360590",
      "Majivana BO": "360590",
      "Modhvada BO": "360590",
      "Vadala Rana BO": "360590",
      "Jamra BO": "362620",
      "Khistri BO": "360579",
      "Miyani BO": "360579",
      "Tukda Miyani BO": "360579",
      "Devda BO": "362650",
      "Khageshri BO": "362650",
      "Mandva BO": "362650",
      "Segras BO": "362650",
      "Boricha BO": "360545",
      "Bhetakadi BO": "360590",
      "Fatana BO": "360590",
      "Malanka BO": "360490",
      "Shingda BO": "360590",
      "Kantol BO": "362620",
      "Kavalka BO": "362620",
      "Nagka BO": "360579",
      "Pandavadar BO": "360579",
      "Ratdi BO": "360579",
      "Chhatrava BO": "362650",
      "Kotda BO": "362650",
      "Mahobatpara BO": "362650",
      "Mal BO": "362650",
      "Moddar BO": "362650",
      "Porbandar HO": "360575",
      "Ranavav Railway Station SO": "360550",
      "Ranakandorana SO": "360570",
      "Ranavav SO": "360550",
      "Bagvadar SO": "360590",
      "Kutiyana S.O": "362650",
      "Adityana SO": "360545",
      "Madhavpur SO": "362230",
      "Bokhira SO": "360579",
      "Porbandar Bhojeshwar SO": "360575",
      "Porbandar Birla Sagar SO": "360576",
      "Porbandar GIDC SO": "360577",
      "Chhaya SO": "360578",
      "Porbandar M G Road SO": "360575"
    },
    "CHHOTAUDEPUR": {
      "Virpur BO": "391165",
      "Zoz BO": "391165",
      "Palasani BO": "391152",
      "Sengpur BO": "391152",
      "Sodhaliya BO": "391152",
      "Vaguma BO": "391152",
      "Wagach BO": "391152",
      "Motibumadi BO": "391135",
      "Muldhar BO": "391135",
      "Segwa Simli BO": "391135",
      "Athadungri BO": "391170",
      "Manka BO": "391170",
      "Navalja BO": "391170",
      "Pipaldi BO": "391170",
      "Kadachhala BO": "391140",
      "Kalidoli BO": "391140",
      "Amroli BO": "391150",
      "Baroli BO": "391150",
      "Bharvada BO": "391150",
      "Chametha BO": "391150",
      "Dhamasiya BO": "391150",
      "Dharsimel BO": "391150",
      "Ghantoli BO": "391150",
      "Kaledia BO": "391150",
      "Kaliyapura BO": "391150",
      "Pochamba BO": "391150",
      "Raipur BO": "391150",
      "Sindhikuva BO": "391150",
      "Tanakhala BO": "391150",
      "Kanalva BO": "391168",
      "Karanjwant BO": "391168",
      "Khatiawant BO": "391168",
      "Manavant BO": "391168",
      "Motaghoda BO": "391168",
      "Mundamore BO": "391168",
      "Aniyadri BO": "391160",
      "Bar BO": "391160",
      "Baravad BO": "391160",
      "Chudel BO": "391160",
      "Devalia BO": "391156",
      "Harakhapur BO": "391160",
      "Jaloda BO": "391156",
      "Kadvad BO": "391160",
      "Kohivav BO": "391160",
      "Pani BO": "391160",
      "Raisingpura BO": "391170",
      "Umarva BO": "391160",
      "Valothi BO": "391160",
      "Bangapura BO": "391145",
      "Bortalav BO": "391145",
      "Nandpur BO": "391145",
      "Picchuwada BO": "391145",
      "Vasan Sevada BO": "391145",
      "Bhaka BO": "391152",
      "Dani BO": "391152",
      "Kharmada BO": "391152",
      "Nalvant BO": "391152",
      "Ambadungar BO": "391170",
      "Saidivasana BO": "391170",
      "Umathi BO": "391170",
      "AMBADUNGAR BO": "391170",
      "Panej BO": "391140",
      "Unada BO": "391140",
      "Vasna BO": "391140",
      "Pala BO": "391150",
      "Rumadia BO": "391168",
      "Sadhli BO": "391168",
      "Sinhada BO": "391168",
      "Singla BO": "391168",
      "Dumali BO": "391156",
      "Dungarvant BO": "391160",
      "Moti  Amroli BO": "391160",
      "Muvada BO": "391160",
      "Palsanda BO": "391156",
      "Garda BO": "391145",
      "Handod BO": "391145",
      "Makni BO": "391145",
      "Pipalsat BO": "391145",
      "Rampura BO": "391145",
      "RangpurZ BO": "391165",
      "Surkheda BO": "391165",
      "Jamli BO": "391152",
      "Moghela BO": "391152",
      "Navagam BO": "391152",
      "Motavanta BO": "391170",
      "Vijli BO": "391170",
      "Athavali BO": "391140",
      "Moradungari BO": "391140",
      "Rajbodeli BO": "391140",
      "Haripura BO": "391150",
      "Jemalgadh BO": "391150",
      "Khapariya BO": "391150",
      "Lavakui BO": "391150",
      "Parvata BO": "391150",
      "Asar BO": "391168",
      "Bhumaswada BO": "391168",
      "Raichha BO": "391168",
      "Rodadha BO": "391168",
      "Bhanpur BO": "391160",
      "Bhilpur BO": "391156",
      "Kanda BO": "391160",
      "Moti  Rasli BO": "391160",
      "Uchapan BO": "391160",
      "Akakheda BO": "391145",
      "Gundicha BO": "391145",
      "Ratanpura BO": "391145",
      "Sanada BO": "391165",
      "Gunata BO": "391165",
      "Manjrol BO": "391110",
      "Kolamba BO": "391152",
      "Vankla BO": "391152",
      "Zer BO": "391152",
      "Pandhara BO": "391135",
      "Sukal BO": "391160",
      "Mankodi BO": "391170",
      "Thadgam BO": "391170",
      "KADIPANI BO": "391170",
      "Chalamali BO": "391140",
      "Sargi BO": "391140",
      "Akona BO": "391150",
      "Dugdha BO": "391150",
      "Goyawant BO": "391150",
      "Jakshi BO": "391150",
      "Kukarda BO": "391150",
      "Bedia BO": "391168",
      "Dungargam BO": "391168",
      "Morangana BO": "391168",
      "Nani Tokri BO": "391168",
      "Rangpur K BO": "391168",
      "Bhensavali BO": "391160",
      "Bhikhapur BO": "391160",
      "Jamba BO": "391160",
      "Kikavada BO": "391160",
      "Mota Amadra BO": "391160",
      "Moti  Beg BO": "391160",
      "Ratanpur BO": "391160",
      "Waghva BO": "391160",
      "Ambapura BO": "391145",
      "Malpur BO": "391145",
      "Sunderpura BO": "391145",
      "Vadeli BO": "391145",
      "Fanta BO": "391125",
      "Hareshwar BO": "391125",
      "Morakhala BO": "391125",
      "Targol BO": "391125",
      "Totarmata BO": "391125",
      "Kanteshwar BO": "391125",
      "Kavitha BO": "391125",
      "Lotia BO": "391125",
      "Chhatrali BO": "391135",
      "Ferkuva BO": "391135",
      "Jabugam BO": "391135",
      "Dhandhoda BO": "391165",
      "Dholi Simal BO": "391165",
      "Dolaria BO": "391165",
      "Ekalbara BO": "391165",
      "Lachharas BO": "391130",
      "Timba BO": "391130",
      "Bhindol BO": "391135",
      "Karali BO": "391135",
      "Modasar BO": "391135",
      "Nana Amadara BO": "391135",
      "Tandalja BO": "391135",
      "Vanta BO": "391135",
      "Ambala BO": "391165",
      "Chisadiya BO": "391165",
      "Ghelawant BO": "391165",
      "Puniavant BO": "391156",
      "Bamroli BO": "391125",
      "Gola Gamdi BO": "391125",
      "Jojwa  RS BO": "391125",
      "Navapura BO": "391125",
      "Khunvad BO": "391130",
      "Sarsinda BO": "391130",
      "Alhadpura BO": "391135",
      "Bordha BO": "391135",
      "Kalarani BO": "391135",
      "Ladod BO": "391135",
      "Saloj BO": "391135",
      "Tadkachhla BO": "391135",
      "Vaniadri BO": "391135",
      "Bhorda BO": "391165",
      "Khadkhad BO": "391165",
      "Padharwant BO": "391165",
      "Kasumbia BO": "391761",
      "Khandiya BO": "391761",
      "Vandarda BO": "391761",
      "Chhuchhapura BO": "391125",
      "Dormar BO": "391125",
      "Chorngala BO": "391130",
      "Deroli BO": "391130",
      "Indral BO": "391130",
      "Sankhandra BO": "391135",
      "Sejwa BO": "391135",
      "Kundal BO": "391165",
      "Mandlava BO": "391165",
      "Mithibor BO": "391165",
      "Anandpura BO": "391761",
      "Malu BO": "391761",
      "Chhotaudepur SO": "391165",
      "Tejgadh SO": "391156",
      "Bahadarpur SO Vadodara": "391125",
      "Gadhboriad SO": "391152",
      "Naswadi SO": "391150",
      "Sankheda SO": "391145",
      "Bodeli SO": "391135",
      "Kawant SO": "391170",
      "Kosindra SO": "391140",
      "Panvad SO": "391168",
      "Pavijetpur SO": "391160",
      "Bhatpur SO": "391130"
    },
    "DEVBHUMI DWARKA": {
      "Tupni BO": "361335",
      "Varvala BO": "361335",
      "Vasai BO": "361335",
      "Sanosari BO": "361320",
      "Satapar BO": "361320",
      "Tankaria BO": "361320",
      "Danta BO": "361305",
      "Dantrana BO": "361305",
      "Haripar BO": "361320",
      "Juvangadh BO": "361305",
      "Kakabhai Sihan BO": "361305",
      "Meghpar Titodi BO": "361305",
      "Movan BO": "361305",
      "Sonardi BO": "361305",
      "Chachlana BO": "361320",
      "Jamdevalia BO": "361320",
      "Jamgadhka BO": "361320",
      "Beraja BO": "361305",
      "Bhatel BO": "361305",
      "Viramdad BO": "361305",
      "Jampar BO": "360510",
      "Maleta BO": "361320",
      "Bajana BO": "361305",
      "Vadatra BO": "361305",
      "Khijdad BO": "361320",
      "Patelka BO": "361320",
      "Ambavadi BO": "361305",
      "Asota Mota BO": "361305",
      "Habardi BO": "361305",
      "Sinhan Aher BO": "361305",
      "Vadalia Sinhan BO": "361305",
      "Chhapar BO": "361306",
      "Dhaturia BO": "361306",
      "Kanakpar BO": "361306",
      "Rozda BO": "360590",
      "Kolva BO": "361306",
      "Devalia BO": "360510",
      "Dhebar BO": "360510",
      "Morzar BO": "360510",
      "Navagam BO": "360510",
      "Pachhtar BO": "360510",
      "Bankodi BO": "361315",
      "Bhatvadia BO": "361315",
      "Juvanpar BO": "361315",
      "Kenedi BO": "361315",
      "Lamba BO": "361315",
      "Mahadevia BO": "361315",
      "Gadu BO": "360590",
      "Bhandaria BO": "361306",
      "Bhinda BO": "361306",
      "Chur BO": "361306",
      "Keshod BO": "361306",
      "Moti Khokhari BO": "361306",
      "Vinzalpar BO": "361306",
      "Bhenakvad BO": "360510",
      "Bhankhokhri BO": "361306",
      "Lalparda BO": "361306",
      "Rajpar BO": "361306",
      "Hathla BO": "360590",
      "Bharatpur BO": "360510",
      "Chokhanda BO": "360510",
      "Gunda BO": "360510",
      "Roziwada BO": "360510",
      "Sai Devalia BO": "360510",
      "Bhopalka BO": "361315",
      "Gaga BO": "361315",
      "Mevasa BO": "360510",
      "Navadra BO": "361315",
      "Ranjitpar BO": "361315",
      "Baradia BO": "361335",
      "Khatumba BO": "361335",
      "Nanabhavda BO": "361335",
      "Rajpara BO": "361335",
      "Bhomiyavadar BO": "360510",
      "Rupamora BO": "360510",
      "Bhogat BO": "361315",
      "Gandhavi BO": "361315",
      "Pindhara BO": "361315",
      "Kuranga BO": "361335",
      "Okhamadhi BO": "361335",
      "Positra BO": "361335",
      "Padli BO": "361345",
      "Ashiyavadar BO": "361325",
      "Gorana BO": "361325",
      "Bharana BO": "361010",
      "Kabarka BO": "360515",
      "Motakalavad BO": "360515",
      "Nagadia BO": "361325",
      "Suryavadar BO": "361325",
      "Kajurada BO": "361010",
      "Motamandha BO": "361010",
      "Ambardi BO": "360515",
      "Bhangor BO": "360515",
      "Manpar BO": "360515",
      "Sonvadia BO": "360515",
      "Zinavari BO": "360515",
      "Arambhada BO": "361345",
      "Chandravada BO": "361325",
      "Khirasara BO": "361325",
      "Beh BO": "361310",
      "Devalia Targhadi BO": "361010",
      "Motavadia BO": "360515",
      "Sanosara BO": "360515",
      "Fot BO": "360510",
      "Rentala Kalavad BO": "360510",
      "Simar BO": "360510",
      "Timbadi BO": "360510",
      "Khakharda BO": "361315",
      "Nandana BO": "361315",
      "Ran BO": "361315",
      "Sidsara BO": "361315",
      "Charakala BO": "361335",
      "Dhinki BO": "361335",
      "Gadhechi BO": "361335",
      "Kalyanpur BO": "361335",
      "Bhimrana BO": "361345",
      "Mojap BO": "361345",
      "Goinj BO": "361310",
      "Samor BO": "361310",
      "Vachalabara BO": "361310",
      "Motigop BO": "360515",
      "Sansori BO": "360515",
      "Jamkalyanpur SO": "361320",
      "Vadinar SO": "361010",
      "Dwarka SO": "361335",
      "Surajkaradi SO": "361347",
      "Bhanvad SO": "360510",
      "Bhatia SO": "361315",
      "Khambhalia SO": "361305",
      "Mithapur SO Jamnagar": "361345",
      "Okha SO": "361350",
      "Raval SO": "361325",
      "Bet SO": "361330",
      "Bhadthar SO": "361306",
      "Salaya SO": "361310",
      "Verad SO": "360515"
    },
    "JAMNAGAR": {
      "Hothijikhadba BO": "360530",
      "Ishwaria BO": "360530",
      "Navanagna BO": "361007",
      "Limbuda BO": "361011",
      "Dhutarpur BO": "361130",
      "Kunad BO": "361250",
      "Lakhtar BO": "361250",
      "Panchdevda Mota BO": "361160",
      "Sarvania BO": "361160",
      "Toda BO": "361160",
      "Umrala BO": "361160",
      "Banga BO": "361013",
      "Matva BO": "361013",
      "Modpar Matva BO": "361013",
      "Jamwali BO": "361160",
      "Kadbal BO": "360530",
      "Sidhsar BO": "360530",
      "Vanavad BO": "360530",
      "Vasantpur BO": "360530",
      "Jaliadevani BO": "361130",
      "Khilosh BO": "361130",
      "Veratia BO": "361130",
      "Chelabedi BO": "361160",
      "Chhatar BO": "361160",
      "Dhundhoraji BO": "361160",
      "Fagas BO": "361160",
      "Machharda BO": "361160",
      "Machhlivad BO": "361160",
      "Motivavdi BO": "361160",
      "Mulila BO": "361160",
      "Dhunia BO": "361280",
      "Modpar BO": "360531",
      "Padana BO": "361280",
      "Pipli BO": "361280",
      "Motimatli BO": "361013",
      "Nagpur BO": "361013",
      "Bhagat Khijadia BO": "360540",
      "Balva BO": "360530",
      "Mahiki BO": "360530",
      "Chavda BO": "361130",
      "Varna BO": "361130",
      "Badanpar BO": "361250",
      "Balambhadi BO": "361160",
      "Bodi BO": "361160",
      "Makrani Sanosara BO": "361160",
      "Nanibhagedi BO": "361160",
      "Navagam BO": "361006",
      "Sanala BO": "361160",
      "Arablush BO": "361280",
      "Daltungi BO": "361280",
      "Rangpur BO": "361280",
      "Beraja Bhalsan BO": "361013",
      "Laloi BO": "361013",
      "Vibhapar BO": "361007",
      "Beraja Fala BO": "361011",
      "Gingni BO": "360530",
      "Kotdabavisi BO": "360530",
      "Patan BO": "360530",
      "Dhudasia BO": "361130",
      "Jaga BO": "361130",
      "Gunatitnagar BO": "361250",
      "Keshiya BO": "361250",
      "Arla BO": "361160",
      "Bhadukiya Mota BO": "361160",
      "Nani Vavdi BO": "361160",
      "Napania Khijadia BO": "361160",
      "Rajasthali BO": "361160",
      "Dabasang BO": "361280",
      "Rasangpar BO": "361280",
      "Haripar BO": "361170",
      "Khankotda BO": "361013",
      "Bamangam BO": "360540",
      "Makajimeghpar BO": "360110",
      "Bhadra BO": "360405",
      "Jamsar BO": "363655",
      "Mavnagam BO": "363655",
      "Hajamchora BO": "361240",
      "Madhapar BO": "361240",
      "Shampar BO": "361240",
      "Changa BO": "361012",
      "Dadia BO": "361012",
      "Harshadpur BO": "361012",
      "Khadkhambhalia BO": "361012",
      "Vankiya BO": "361210",
      "Falla BO": "361120",
      "Hapa RS BO": "361120",
      "Jambuda BO": "361120",
      "Khijadia BO": "361120",
      "Bagadhra BO": "360480",
      "Butavadar BO": "360480",
      "Bada BO": "361110",
      "Kotharia BO": "363655",
      "Dhichada BO": "361006",
      "Lavadia BO": "361012",
      "Naranpur BO": "361012",
      "Vadpanchasara BO": "361012",
      "Bhojabedi BO": "360520",
      "Gorakhadi BO": "360520",
      "Vadala Sethna BO": "360520",
      "Jaiva BO": "361210",
      "Manekpur BO": "361210",
      "Mota Vagudad BO": "361210",
      "Nathuvadala BO": "361210",
      "Morkanda BO": "361120",
      "Theba BO": "361120",
      "Mandasan BO": "360480",
      "Valasan BO": "360480",
      "Khangarka BO": "360110",
      "Amrapar BO": "360490",
      "Paradva BO": "360490",
      "Beraja Pasaya BO": "361110",
      "Jam Dudhai BO": "363655",
      "Manamora BO": "363655",
      "Sachana BO": "361230",
      "Khojaberaja BO": "361012",
      "Motibhalsan BO": "361012",
      "Chirodasang BO": "360520",
      "Hadatoda BO": "361210",
      "Mota Itala BO": "361210",
      "Soyal BO": "361210",
      "Banugar Moti BO": "361120",
      "Khimrana BO": "361120",
      "Rampar BO": "361120",
      "Gagva BO": "361140",
      "Moti Khavdi BO": "361140",
      "Makhakarod BO": "360540",
      "Nana Vadala BO": "360540",
      "Amra BO": "361006",
      "Jivapar BO": "361006",
      "Lakhabaval BO": "361006",
      "Sarmat BO": "361006",
      "Arikhana BO": "361170",
      "Gajana BO": "361170",
      "Meghpur BO": "361220",
      "Anandpur BO": "361162",
      "Satiya BO": "361162",
      "Jamsukhpur BO": "360531",
      "Tarsai BO": "360531",
      "Pipar BO": "360540",
      "Kansumara BO": "361006",
      "Masitia BO": "361006",
      "Vasai BO": "361006",
      "Memana BO": "361170",
      "Nanduri BO": "361170",
      "Navagam Ghed BO": "361008",
      "Kalyanpur BO": "360531",
      "Katkola BO": "360531",
      "Vansjalia B.O": "360531",
      "Kalmeghda BO": "360540",
      "Moridad BO": "360540",
      "Bed BO": "361006",
      "Dharampur BO": "361170",
      "Rafudad nani BO": "361170",
      "Mota Bharudia BO": "361170",
      "Bhensdad BO": "361220",
      "Koyli BO": "361220",
      "Pithad BO": "361220",
      "Bavakhakharia BO": "361162",
      "Pithadia BO": "361162",
      "Sisang BO": "361162",
      "Zakhar BO": "361010",
      "Jasapar BO": "361162",
      "Shiva BO": "360531",
      "Bhavabhi Khijadia BO": "360540",
      "Deri BO": "360540",
      "Moda BO": "361110",
      "Mota Thavaria BO": "361110",
      "Ambala BO": "363655",
      "Bhimkata BO": "363655",
      "Pipartoda BO": "361012",
      "Veraval Moti BO": "361012",
      "Nandana BO": "360520",
      "Sadodar BO": "360520",
      "Samana BO": "360520",
      "Khambhalida Motavas BO": "361210",
      "Kharva BO": "361210",
      "Laiyala BO": "361210",
      "Majoth BO": "361210",
      "Govana BO": "361170",
      "Khadba BO": "361170",
      "Khirasara BO": "361170",
      "Bodka BO": "361220",
      "Gajadi BO": "361220",
      "Jiragadh BO": "361220",
      "Juvanpar BO": "361162",
      "Kotha Bhadukia BO": "361162",
      "Pata Meghpar BO": "361162",
      "Vadala Moti Metana BO": "361162",
      "Singach BO": "361010",
      "Jamnagar HO": "361001",
      "Hadiana SO": "361011",
      "Jamjodhpur SO": "360530",
      "Jodia SO": "361250",
      "Khodiyar Colony SO": "361006",
      "Lal Bunglow SO": "361001",
      "Medical Campus SO": "361008",
      "GIDC PHASE II": "361004",
      "Balachadi SO": "361230",
      "Balambha SO": "361240",
      "Dhrafa SO": "360520",
      "Gulabnagar SO": "361007",
      "Kanalush SO": "361280",
      "Kharedi SO": "360540",
      "Latipur SO": "361220",
      "Aliabada SO": "361110",
      "Amran SO": "363655",
      "Bedi SO": "361009",
      "Chela SO": "361012",
      "Dhrol SO": "361210",
      "Dhuvav SO": "361120",
      "Digvijay Gram SO": "361140",
      "Jamwanthali SO": "361130",
      "Nikava SO": "361162",
      "Satapar S.O": "360531",
      "Aerodromme SO": "361003",
      "Bedeshwar SO": "361002",
      "Digvijay Plot SO": "361005",
      "Jamjodhpur Darbargadh SO": "360530",
      "Kalavad SO": "361160",
      "Khambhalia Gate SO": "361001",
      "Khandhera SO": "361013",
      "Lalpur SO Jamnagar": "361170",
      "Patel Colony SO": "361008",
      "Reliance Greens SO": "361142",
      "Station Road SO Jamnagar": "361001",
      "Udyognagar SO": "361004",
      "Valsura SO": "361150"
    },
    "SURAT": {
      "Orma BO": "394540",
      "Pardi Bhadol BO": "394540",
      "Dihen BO": "395005",
      "Narthan BO": "395005",
      "Sondla Khara BO": "394540",
      "Vadod BO": "394540",
      "Ambheta BO": "395005",
      "Ariana BO": "395005",
      "Bhandut BO": "395005",
      "Bhesan BO": "395005",
      "Bhatpore BO": "394510",
      "Dumasgam BO": "394550",
      "Kadrama BO": "394540",
      "Koba BO": "394540",
      "Lavachha BO": "394540",
      "Suvali BO": "394517",
      "Vansva BO": "394517",
      "Adajan BO": "395009",
      "Palanpur BO": "395009",
      "Bhadol BO": "394540",
      "Bhatgam BO": "394540",
      "Dandi BO": "394540",
      "Erthan BO": "394540",
      "Masma BO": "394540",
      "Rajnagar BO": "394540",
      "Sonsak BO": "394540",
      "Takarma BO": "394540",
      "Vihara BO": "394540",
      "Barbodhan BO": "395005",
      "Ichhapore BO": "394510",
      "Kawas BO": "394510",
      "Pal Bhatha BO": "394510",
      "Kachholi BO": "394235",
      "Kafleta BO": "394235",
      "Popda BO": "394235",
      "Bhagwa BO": "394530",
      "Delasa BO": "394530",
      "Karanj BO": "394110",
      "Jinod B.O": "394530",
      "Damka BO": "394517",
      "Bhatlai BO": "394517",
      "Kamroli BO": "394540",
      "Bhimpore BO": "394550",
      "Rajgari B.O": "394517",
      "Asnad BO": "394540",
      "Ishanpore BO": "394540",
      "Kudiana BO": "394540",
      "Mandroi BO": "394540",
      "Vadadla Tanti BO": "394317",
      "Barasadi BO": "394310",
      "Dastan BO": "394310",
      "Ena BO": "394310",
      "Kos BO": "396510",
      "Kumkotar BO": "396510",
      "Lasanpor BO": "396510",
      "Vareli BO": "394140",
      "Tantithaiya BO": "394305",
      "Timbarva BO": "394305",
      "Moticher BO": "394651",
      "Gangadia BO": "396510",
      "Gavachhi BO": "394140",
      "Bagumara BO": "394305",
      "Karan BO": "394305",
      "Boridra BO": "394125",
      "Dhamdod BO": "394125",
      "Dinod BO": "394125",
      "Dungri BO": "394240",
      "Kothwa BO": "394110",
      "Kudsad BO": "394110",
      "Pipodara BO": "394110",
      "Siyalaj BO": "394110",
      "Vadoli BO": "394350",
      "Varethi BO": "394110",
      "Ankdod BO": "394410",
      "Gijram BO": "394410",
      "Atodara BO": "394130",
      "Bharundi BO": "394130",
      "Sithan BO": "394130",
      "Syadla BO": "394130",
      "Dabholi BO": "395004",
      "Motived BO": "395004",
      "Anita BO": "394110",
      "Kumbharia BO": "395010",
      "Saroli BO": "394520",
      "Bhedvad BO": "394210",
      "Mahuvej BO": "394125",
      "Nandav BO": "394125",
      "Borsad BO": "394112",
      "Mota Borsara BO": "394110",
      "Nani Naroli BO": "394112",
      "Kunvarda BO": "394120",
      "Sava BO": "394120",
      "Harsani BO": "394421",
      "Karjan BO": "394155",
      "Virpur BO": "394155",
      "Tuked BO": "394163",
      "Unteva BO": "394163",
      "Zab BO": "394163",
      "Fali BO": "394163",
      "Bamni BO": "394335",
      "Bhamaiya BO": "394335",
      "Haripura BO": "394335",
      "Ratania BO": "394360",
      "Dhatva BO": "394180",
      "Dungra BO": "394180",
      "Kholeshwar BO": "394180",
      "Kolibharthana BO": "394180",
      "Bartad BO": "394240",
      "Gunesvel BO": "394240",
      "Kantifalia BO": "394340",
      "Amchak BO": "394250",
      "Bilkhadi BO": "394250",
      "Dedvasan BO": "394250",
      "Dadhwada BO": "394160",
      "Tarsada BO": "394160",
      "Umrakh BO": "394345",
      "Shampura BO": "394330",
      "Ambheti BO": "394352",
      "Lakhanpor BO": "394352",
      "Amalsadi BO": "394163",
      "Kani BO": "394350",
      "Vihan BO": "394320",
      "Tundi BO": "394310",
      "Khodamba BO": "394163",
      "Patal BO": "394163",
      "Khanjroli BO": "394335",
      "Masad BO": "394335",
      "Samthan BO": "394335",
      "Nansad BO": "394180",
      "Abrama BO": "394150",
      "Dhoranpardi BO": "394150",
      "Velanja BO": "394150",
      "Balda BO": "394340",
      "Karachka BO": "394340",
      "Orgam BO": "394340",
      "Uva BO": "394340",
      "Kodada BO": "394250",
      "Fulwadi BO": "394160",
      "Goddha BO": "394160",
      "Kakrapargam BO": "394160",
      "Regama BO": "394160",
      "Rupan BO": "394160",
      "Umra BO": "395007",
      "Budia BO": "394210",
      "Deladva BO": "394210",
      "Ghanavad BO": "394445",
      "Keori BO": "394445",
      "Khota Rampura BO": "394445",
      "Digas BO": "394330",
      "Italva BO": "394315",
      "Malekpor BO": "394315",
      "Chhitra BO": "394350",
      "Ranat BO": "394350",
      "Tarsadi BO": "394350",
      "Khanpur BO": "394320",
      "Segva BO": "394130",
      "Nogama BO": "394405",
      "Areth BO": "394170",
      "Munjlav BO": "394140",
      "Jolwa BO": "394305",
      "Mohni BO": "394305",
      "Haldharu BO": "394310",
      "Sarda BO": "394445",
      "Ambawadi BO": "394430",
      "Boria BO": "394430",
      "Dholikui BO": "394250",
      "Lavet BO": "394430",
      "Kosmada BO": "395013",
      "Asarma BO": "394405",
      "Bundha BO": "394440",
      "Chitalda BO": "394440",
      "Choramba BO": "394440",
      "Devgadh BO": "394440",
      "Dharampur BO": "394112",
      "Limodra BO": "394110",
      "Mulad BO": "394110",
      "Bhilvada BO": "394421",
      "Vasravi BO": "394421",
      "Karamla BO": "394130",
      "Morthan BO": "394130",
      "Bamroli BO": "394210",
      "Sania Kande BO": "394210",
      "Unn BO": "394210",
      "Bilvan BO": "394445",
      "Chimipatal BO": "394445",
      "Umarda BO": "394445",
      "Vadpada BO": "394445",
      "Verakui BO": "394430",
      "Pasodara BO": "395013",
      "Vahar BO": "394440",
      "Parvat BO": "395012",
      "Gamtalv Bujrang BO": "394163",
      "Godawadi BO": "394163",
      "Karvali BO": "394163",
      "Kasal BO": "394163",
      "Kharoli BO": "394163",
      "Nandpore BO": "394163",
      "Naren BO": "394163",
      "Kamlapore BO": "394335",
      "Singod BO": "394335",
      "Navipardi BO": "394150",
      "Soyani BO": "394310",
      "Vanisa Pisadi BO": "394310",
      "Amba BO": "394163",
      "Puna BO": "394248",
      "Kosadi BO": "394405",
      "Vadhvania BO": "394335",
      "Navagam BO": "394185",
      "Netrang BO": "394180",
      "Naldhara BO": "394240",
      "Vanskui BO": "394340",
      "Antroli BO": "394325",
      "Manekpor BO": "394340",
      "Surali BO": "394340",
      "Miyapur BO": "394250",
      "Jakhala BO": "394160",
      "Salaiya BO": "394160",
      "Vareth BO": "394160",
      "Delad BO": "394330",
      "Timba BO": "394330",
      "Kanav BO": "394315",
      "Samrod BO": "394315",
      "Goji BO": "394350",
      "Chikhali Dungar BO": "394320",
      "Nagod BO": "394320",
      "Vegi BO": "394170",
      "Bharan BO": "394125",
      "Shah BO": "394421",
      "Gothan BO": "394130",
      "Madhar BO": "394130",
      "Kharvasa BO": "394355",
      "Chavda BO": "394445",
      "Chokhvada BO": "394445",
      "Sarvan Fokdi BO": "394445",
      "Umargot BO": "394445",
      "Utran BO": "394105",
      "Amkhuta BO": "394430",
      "Isanpur BO": "394430",
      "Nandola BO": "394430",
      "Laskana BO": "395013",
      "Sania Hemad BO": "395013",
      "Hathoda BO": "394405",
      "Simodra BO": "394405",
      "Balethi BO": "394440",
      "Godbar BO": "394440",
      "Mandan Boria BO": "394440",
      "Umbharia BO": "394440",
      "Vad BO": "394440",
      "Valak BO": "395013",
      "Luvara BO": "394405",
      "Luharvad BO": "394440",
      "Maldha BO": "394440",
      "Umarzar BO": "394440",
      "Vadi BO": "394440",
      "Godadara BO": "395012",
      "Vatsalyadham BO": "394340",
      "Shekhpur BO": "394250",
      "Ghantoli BO": "394160",
      "Jamankuva BO": "394160",
      "Kim Dungara BO": "394160",
      "Lakhgam BO": "394160",
      "Moritha BO": "394160",
      "Sarkui BO": "394160",
      "Sathvav BO": "394160",
      "Taraj BO": "394315",
      "Ninat BO": "394350",
      "Nizar BO": "394350",
      "Tarbhon BO": "394350",
      "Asta BO": "394320",
      "Bhagvanpura BO": "394246",
      "Kadhaiya BO": "394246",
      "Vadia BO": "394246",
      "Rosvad BO": "394170",
      "Ladvi BO": "394325",
      "Morthana BO": "394325",
      "Dhamkhadi BO": "394248",
      "Samba BO": "394248",
      "Palsod BO": "394355",
      "Rayam BO": "394355",
      "Timbarva Sankri BO": "394355",
      "Vaghecha BO": "394355",
      "Mankna BO": "394325",
      "Niol BO": "394325",
      "Haladva BO": "394248",
      "Mahuvaria BO": "394248",
      "Vaheval BO": "394248",
      "Allu BO": "394620",
      "Kikwad BO": "394620",
      "Dhamdod Lumbha BO": "394355",
      "Khojpardi BO": "394355",
      "Singanpore BO": "395004",
      "Paria BO": "394130",
      "Sandhier BO": "394130",
      "Devadh BO": "394210",
      "Dindoli BO": "394210",
      "Varachhali BO": "395013",
      "Kantva BO": "394405",
      "Limbada BO": "394405",
      "Nasarpur BO": "394440",
      "Tarapur BO": "394440",
      "Segva Chhama BO": "395005",
      "Selut BO": "395005",
      "Bonandh BO": "394230",
      "Gabheni BO": "394230",
      "Vaktana BO": "394230",
      "Bharthana BO": "395007",
      "Khajod BO": "395007",
      "Kosad BO": "394107",
      "Kharvan BO": "394245",
      "Velanpur BO": "394245",
      "Parab BO": "394325",
      "Pinjrat BO": "395005",
      "Kansad BO": "394230",
      "Lingad BO": "394230",
      "Sachin RS BO": "394230",
      "Talangpur BO": "394230",
      "Vanz BO": "394230",
      "Abhva BO": "395007",
      "Sherdi BO": "394520",
      "Bhoria BO": "394248",
      "Kankaria BO": "394248",
      "Afva Isroli BO": "394620",
      "Chhapra Bhatha BO": "394107",
      "Motifalod BO": "394355",
      "Ghadoi BO": "394245",
      "Butwada BO": "394248",
      "Pathron BO": "394620",
      "Sejvad BO": "394620",
      "Akoti BO": "394355",
      "Jokha BO": "394326",
      "Kathodara BO": "394326",
      "Kosmadi BO": "394326",
      "Vesu BO": "395007",
      "Tena B.O": "395005",
      "Eklera BO": "394230",
      "Kanakpur BO": "394230",
      "Umber BO": "394230",
      "Gavier BO": "395007",
      "Magdalla BO": "395007",
      "Kosam BO": "394520",
      "Fulpada BO": "395008",
      "A K Road SO": "395008",
      "PAL SO": "394510",
      "Surat Airport S.O": "394550",
      "Amroli SO": "394107",
      "Anand Mahal Road SO": "395009",
      "Bhagal SO": "395003",
      "Hathuran SO": "394125",
      "Kim Char Rasta SO": "394111",
      "Kim SO": "394110",
      "Kosamba RS SO": "394120",
      "Sayan SO": "394130",
      "Bombay Market SO": "395010",
      "GIPCL SO": "394112",
      "Jhampa SO": "395003",
      "Mota Varachha SO": "394101",
      "Puna Kumbharia SO": "395011",
      "Udhna SO": "394210",
      "Umarpada SO": "394445",
      "Saras SO": "394541",
      "Katargam SO": "395004",
      "Sarthana SO": "395013",
      "Surat City SO": "395003",
      "Utran Power House SO": "394105",
      "Vankal SO": "394430",
      "Varachha Road SO": "395006",
      "Veer Narmad South Gujarat University SO": "395007",
      "Khatodara SO": "395002",
      "Mosali SO": "394421",
      "Mota Miya Mangrol SO": "394410",
      "Surat RS SO": "395003",
      "Surat Textile Market SO": "395002",
      "Velachha SO": "394405",
      "Zankhvav SO": "394440",
      "Limbayat SO": "395012",
      "Nanpura HO": "395001",
      "Surat HO": "395003",
      "Bardoli HO": "394601",
      "Anaval SO": "396510",
      "Baleshwar SO": "394317",
      "Bodhan SO Surat": "394140",
      "Gangadhara RS SO": "394310",
      "Kamrej Char Rasta SO": "394185",
      "Kholvad SO": "394190",
      "Madhi SO": "394340",
      "Mandvi SR SO": "394160",
      "Sugar Factory Bamania SO": "394246",
      "Sugar Factory Bardoli SO": "394601",
      "Tadkeshwar SO": "394170",
      "Vankaner SR SO": "394620",
      "Zervavra SO": "394245",
      "Chalthan SO": "394305",
      "Godsamba SO": "394163",
      "Kamrej SO": "394180",
      "Kathor SO": "394150",
      "Mota SO": "394345",
      "Orna SO": "394330",
      "Puni SO": "394352",
      "Sarbhon SO": "394350",
      "Dumas SO": "394550",
      "Mora SO Surat": "394517",
      "Muglisara SO": "395003",
      "Navyug College SO": "395009",
      "Adityanagar SO": "394516",
      "Althan SO": "395017",
      "Bhatha SO": "394510",
      "Hajira SO": "394270",
      "Kribhconagar SO": "394515",
      "Piplod SO Surat": "395007",
      "Sachin SO": "394230",
      "SVR College SO": "395007",
      "Udhnagam SO": "394210",
      "Ongc Nagar SO": "394518",
      "Variav SO": "394520",
      "Ghala SO": "394155",
      "Kadodara SO": "394327",
      "Mahuva SO Surat": "394250",
      "Sardarbaug Bardoli SO": "394601",
      "Sevni SO": "394320",
      "Varad SO": "394355",
      "Vav Kathodara SO": "394326",
      "Kadod SO": "394335",
      "Kakrapar SO": "394360",
      "Karchelia SO": "394240",
      "Palsana SO Surat": "394315",
      "Umbhel SO": "394325",
      "Valvada SO": "394248",
      "Athwalines SO": "395001",
      "Bhestan SO": "395023",
      "Gopipura SO": "395001",
      "Lajpore SO": "394235",
      "Nandniketan SO": "394270",
      "Olpad SO": "394540",
      "Ramnagar SO Surat": "395009",
      "Govt Medical College SO": "395001",
      "Mor SO": "394530",
      "Pandesara IE SO": "394221",
      "Rander SO": "395005",
      "Sagrampura Putli SO": "395002"
    },
    "PANCH MAHALS": {
      "Manipur C BO": "388713",
      "Padhiyar BO": "388713",
      "Madhvas BO": "389330",
      "Maghasar BO": "389330",
      "Ratanpura BO": "389330",
      "Uchet BO": "389390",
      "Veganpur BO": "388713",
      "Dharapur BO": "389220",
      "Agarwada BO": "389115",
      "Dangaria BO": "389115",
      "Vadodar BO": "389115",
      "Dhinkva BO": "389360",
      "Manchi Haveli BO": "389360",
      "Rayanwadia BO": "389360",
      "Vada Talav BO": "389360",
      "Chhavad BO": "389120",
      "Dhamnod BO": "389120",
      "Mojari BO": "389120",
      "Natapur BO": "389120",
      "Vadelav BO": "389120",
      "Boriavi BO": "389210",
      "Chhanip BO": "389210",
      "Khojalvasa BO": "389210",
      "Padardi BO": "389210",
      "Talavdi BO": "389370",
      "Vaghbod BO": "389370",
      "Moti Kantadi BO": "388710",
      "Eral BO": "389340",
      "Sureli BO": "389210",
      "Vyasda BO": "389340",
      "Vav BO": "389390",
      "Ratanpur R BO": "388713",
      "Tuwa BO": "388713",
      "Bhamaria BO": "389360",
      "Chandranagar BO": "389360",
      "Chelawada BO": "389360",
      "Navakuwa BO": "389360",
      "Bakkhar BO": "389120",
      "Bhamaiya BO": "389120",
      "Mataria Vadi BO": "389120",
      "Mirap BO": "389120",
      "Orvada BO": "389120",
      "Parvadi BO": "389120",
      "Rasulpur BO": "389120",
      "Sarsav BO": "389120",
      "Aniyad BO": "389210",
      "Bhadrala BO": "389210",
      "Gangadiya BO": "389210",
      "Mangliana BO": "389210",
      "Matariya Vyas BO": "389210",
      "Mor BO": "389210",
      "Sajivav BO": "389210",
      "Shekhpur BO": "389210",
      "Tadva BO": "389210",
      "Bapotia BO": "389370",
      "Juni Dhari BO": "388710",
      "Nadisar BO": "388710",
      "Timba Gam BO": "388710",
      "Vachchhesar BO": "388710",
      "Kuwazar BO": "389115",
      "Mataria Vejam BO": "389115",
      "Mekhar BO": "389115",
      "Rajayata BO": "389115",
      "Rampur Kasanpur BO": "389115",
      "Sagawada BO": "389115",
      "Vandeli BO": "389115",
      "Jepura BO": "389360",
      "Jitpura BO": "389340",
      "Rinchhia BO": "389340",
      "Zankharia BO": "389360",
      "Chhogala BO": "389210",
      "Dalwada BO": "389210",
      "Dhandhalpur BO": "389210",
      "Kanteli BO": "389370",
      "Moti Umaravan BO": "389370",
      "Mehlol BO": "389340",
      "Nandarkha BO": "389340",
      "Rampur Jodka BO": "389340",
      "Dhanol BO": "388713",
      "Boru Bakorl BO": "389330",
      "Guneli BO": "389220",
      "Bhandoi BO": "389115",
      "Kadadara BO": "389115",
      "Chapra BO": "389360",
      "Dhankuva BO": "389360",
      "Nathkuwa BO": "389360",
      "Ranjitnagar BO": "389360",
      "Bodidra Buzarg BO": "389120",
      "Erandi BO": "389120",
      "Nada BO": "389120",
      "Vaghjipur BO": "389120",
      "Bodidra Khurd BO": "389210",
      "Boriya BO": "389210",
      "Kavali BO": "389210",
      "Kotha BO": "389210",
      "Nandarva BO": "389210",
      "Palikhanda BO": "389370",
      "Kalyana BO": "388710",
      "Ratanpur Kantdi BO": "388710",
      "Bhalania BO": "389340",
      "Harkundi BO": "389340",
      "Suliyat BO": "389110",
      "Umber BO": "389110",
      "Chopda Buzarg BO": "389110",
      "Metral BO": "389110",
      "Navagam BO": "389365",
      "Bhilod BO": "389341",
      "Medapur BO": "389310",
      "Rabod BO": "389310",
      "Bhadroli Khurd BO": "389320",
      "Kanod BO": "389320",
      "Karada BO": "389320",
      "Nesda BO": "389320",
      "Padhora BO": "389365",
      "Paroli BO": "389365",
      "Rayan Muvada BO": "389365",
      "Saraswa BO": "389365",
      "Motal BO": "389002",
      "Morva  Rena BO": "389002",
      "Ambali BO": "389002",
      "Bahi BO": "389002",
      "Ghansar Muvadi BO": "389350",
      "Madar BO": "389350",
      "Rameshra BO": "389350",
      "Ravalia BO": "389350",
      "Sathrota BO": "389350",
      "Tajpura BO": "389350",
      "Duma BO": "389390",
      "Masabar BO": "389390",
      "Karoli BO": "389341",
      "Sajora BO": "389341",
      "Simalia BO": "389341",
      "Bedhiya BO": "389310",
      "Malav BO": "389310",
      "Sama BO": "389320",
      "Bakrol BO": "389365",
      "Dhaneshawar BO": "389365",
      "Bhuvar BO": "389110",
      "Hareda BO": "389110",
      "Sherpura BO": "389341",
      "Vavkulli BO": "389341",
      "Alwa BO": "389310",
      "Derol Gam BO": "389320",
      "Jantral BO": "389320",
      "Sansoli BO": "389320",
      "Davadra BO": "389365",
      "Farod BO": "389365",
      "Labadadhara BO": "389365",
      "Palla BO": "389365",
      "Samalkuva BO": "389365",
      "Zinzari BO": "389365",
      "Samli BO": "389002",
      "Rena BO": "389002",
      "Dharola BO": "389002",
      "Vadi BO": "389002",
      "Mahulia BO": "389002",
      "Chandrpura BO": "389350",
      "Indral BO": "389350",
      "Motipura BO": "389350",
      "Tarkhanda BO": "389350",
      "Varsda BO": "389350",
      "Kanjipani BO": "389390",
      "Khandivav BO": "389390",
      "Narukot BO": "389390",
      "Mol BO": "389365",
      "Mithali BO": "389002",
      "Govindi BO": "389002",
      "Dhanitra BO": "389002",
      "Kanjri BO": "389350",
      "Ujeti BO": "389350",
      "Vintoz BO": "389350",
      "Jaban BO": "389390",
      "Bor BO": "389380",
      "Gundi BO": "389380",
      "Rinchhvani BO": "389380",
      "Chalali BO": "389341",
      "Goya Sundal BO": "389341",
      "Gunesia BO": "389341",
      "Kandach BO": "389310",
      "Pingli BO": "389320",
      "Satmana BO": "389320",
      "Gamani BO": "389365",
      "Kanpur BO": "389365",
      "Kharkhadi BO": "389365",
      "Kharod BO": "389365",
      "Malu BO": "389365",
      "Vavdi Buzarg BO": "389002",
      "Sampa BO": "389002",
      "Vallavpur BO": "389002",
      "Arad BO": "389350",
      "Baska BO": "389350",
      "Haveli BO": "389390",
      "Hirapur BO": "389390",
      "Godli BO": "389380",
      "Gollav BO": "389380",
      "Damavav BO": "389380",
      "Kantu BO": "389380",
      "Ambakhunt BO": "389380",
      "Saniada BO": "389380",
      "Godhra HO": "389001",
      "Godhra City SO": "389001",
      "Godhra Vorwad SO": "389001",
      "Adadra SO": "389341",
      "Delol SO": "389310",
      "Ghoghmba SO": "389365",
      "Godhra Bhuravav SO": "389002",
      "Halol Bazar SO": "389350",
      "Kakanpur SO": "388713",
      "Kalol SO Panch Mahals": "389330",
      "Sant Road SO": "389120",
      "Vejalpur SO": "389340",
      "Morva Hadaf SO": "389115",
      "Derol R S SO": "389320",
      "Jambughoda SO": "389390",
      "Pavagadh SO": "389360",
      "Shehera SO": "389210",
      "Shivrajpur SO": "389370",
      "Timba Road SO": "388710",
      "Mora SO Panch Mahals": "389110",
      "Godhra Civil Lines SO": "389001",
      "Halol SO": "389350"
    },
    "Mahisagar": {
      "Jhara BO": "389220",
      "Kharol BO": "389220",
      "Hathivan BO": "389220",
      "Thanasavli BO": "389220",
      "Bamroda BO": "389230",
      "Gangta BO": "389230",
      "Gothibada BO": "389230",
      "Madhvas BO": "389230",
      "Nanidenavad BO": "389230",
      "Nasikpur BO": "389230",
      "Sat Talav BO": "389230",
      "Vadagam BO": "389230",
      "Vania Vada Gorada BO": "389235",
      "Agarwada BO": "388270",
      "Champeli BO": "388270",
      "Kadachhala BO": "388270",
      "Lakdi Poyada BO": "388270",
      "Hardaspur BO": "389230",
      "Kakachiya BO": "389230",
      "Kakana Bhesavada BO": "389230",
      "Limadia BO": "389230",
      "Moti Ghoda BO": "389230",
      "Moti Sarsan BO": "389230",
      "Mudavadekh BO": "389230",
      "Nava Muvada BO": "389230",
      "Rambhem Na Muvada BO": "389230",
      "Rampatel Na Muvada BO": "389230",
      "Ranijini Padedi BO": "389230",
      "Viraniya BO": "389230",
      "Kalibel BO": "389235",
      "Movasa BO": "389235",
      "Nanavadadala BO": "389235",
      "Padedi Rampur BO": "389235",
      "Ucharpi BO": "388270",
      "Undra BO": "388270",
      "Ladvel BO": "389220",
      "Rabadia BO": "389220",
      "Bhadrod BO": "389230",
      "Kanesar BO": "389230",
      "Karanta BO": "389230",
      "Khanpur BO": "389230",
      "Bhalada BO": "388270",
      "Charangam BO": "388270",
      "Chori BO": "388270",
      "Dhamod BO": "388270",
      "Dhesia BO": "388270",
      "Chatkabeli BO": "389230",
      "Godhar BO": "389230",
      "Limbodara BO": "389230",
      "Mota Sonela BO": "389230",
      "Naroda BO": "389230",
      "Shamna BO": "389230",
      "Vadina Gorda BO": "389235",
      "Makhalia BO": "389210",
      "Kidia BO": "388270",
      "Kolvan BO": "388270",
      "Namnar BO": "388270",
      "Bhanthala BO": "388255",
      "Felsani BO": "388255",
      "Gadhavada BO": "388255",
      "Janod BO": "388255",
      "Guntheli BO": "388255",
      "Jorapura BO": "388255",
      "Saroda BO": "388255",
      "Vaddala BO": "388255",
      "Navagama BO": "388255",
      "Othwad BO": "388255",
      "Rajpur BO": "388255",
      "Saliawadi BO": "388255",
      "Ladpur BO": "389265",
      "Nani Kharsoli BO": "389265",
      "Siyal BO": "389265",
      "Zinzwa BO": "389265",
      "Kelamul BO": "389265",
      "Kenpur BO": "389110",
      "MotirelW BO": "389110",
      "Saraswa BO": "389110",
      "Vankadi BO": "389110",
      "Kajali BO": "389265",
      "Limdi Doli BO": "389110",
      "Babrol BO": "389260",
      "Ukhreli BO": "389260",
      "Limdi Timba BO": "389232",
      "Pandaravada BO": "389232",
      "Anjanwa BO": "389110",
      "Doli BO": "389110",
      "Gadia BO": "389110",
      "Motikayar BO": "389260",
      "Sangavada BO": "389260",
      "Vanjiakhut BO": "389260",
      "Borvai BO": "389232",
      "Janvad BO": "389260",
      "Kanajra BO": "389260",
      "Padedi Ador BO": "389260",
      "Gothib BO": "389190",
      "Nani Bhugedi BO": "389190",
      "Bablia BO": "389232",
      "Khadodi BO": "389232",
      "Bar BO": "388265",
      "Handia BO": "388265",
      "Wanakbori BO": "388235",
      "Dev BO": "388265",
      "Jetholi BO": "388265",
      "Jodhpur BO": "388265",
      "Kambopa BO": "388265",
      "Kharod BO": "388265",
      "Pansroda BO": "388265",
      "Sutaria BO": "388265",
      "Chitwa BO": "389260",
      "Gada BO": "389260",
      "Hirapur BO": "389260",
      "Sant BO": "389260",
      "Surpur BO": "389260",
      "Timbla BO": "389260",
      "Dadhalia BO": "389250",
      "Limbhola BO": "389250",
      "Nana Rajanpur BO": "389250",
      "Nes Molara BO": "389172",
      "Simalia BO": "389172",
      "Godhar North B.O": "389250",
      "Motirath B.O": "389250",
      "Saraswa North B.O": "389250",
      "Sarsadi B.O": "389250",
      "Vagadia NI Andhari B.O": "389250",
      "Velanwada B.O": "389250",
      "Alela BO": "388265",
      "Bharodi BO": "388260",
      "Debhari BO": "388260",
      "Saradia BO": "388260",
      "Vaghas BO": "388260",
      "Bhatpur BO": "388260",
      "Gandhari BO": "388260",
      "Khata BO": "388260",
      "Ratankuva BO": "388260",
      "Kasodi BO": "388260",
      "Kheroli BO": "388260",
      "Rasulpur BO": "388260",
      "Salaiya BO": "388260",
      "Ankalia B.O": "389250",
      "Munpur B.O": "389250",
      "Pratapgadh Khedapa BO": "389172",
      "Batakvada BO": "389172",
      "Bhanasimal BO": "389172",
      "Bachkaria B.O": "389250",
      "Dhingalwada B.O": "389250",
      "Ditvas B.O": "389250",
      "Ghaswada B.O": "389250",
      "Amthani BO": "389250",
      "Antalwada B.O": "389250",
      "Koydam BO": "388260",
      "Koyla BO": "388260",
      "Kumbharwadi BO": "388260",
      "Limbarwada BO": "388260",
      "Rampura BO": "388260",
      "Birpur SO Kheda": "388260",
      "Vadasinor SO": "388255",
      "Pandva SO": "388265",
      "Vadasinor Town Vadasinor SO": "388255",
      "Santrampur SO": "389260",
      "Diwda Colony SO": "389250",
      "Malekpur SO": "389235",
      "Bakor SO": "389232",
      "Kothamba SO": "389220",
      "Lunawada SO": "389230",
      "Vardhari SO": "388270",
      "Malvan SO": "389265"
    },
    "KACHCHH": {
      "Varadia BO": "370490",
      "Varandi Moti BO": "370490",
      "Ludva BO": "370445",
      "Vadva BO": "370445",
      "Lakhpat BO": "370627",
      "Kotdi M BO": "370450",
      "Poladia BO": "370450",
      "Vidh BO": "370450",
      "Gadpadar BO": "370240",
      "Mithi Rohar BO": "370240",
      "Mokha BO": "370410",
      "Vadala BO": "370410",
      "Vaghura BO": "370410",
      "Mota Bhadia BO": "370455",
      "Don BO": "370465",
      "Durgapur BO": "370465",
      "Pragpar BO": "370415",
      "Toda BO": "370415",
      "Chundi BO": "370430",
      "Dhoravar BO": "370510",
      "Dinara BO": "370510",
      "Kunariya K BO": "370510",
      "Misariado BO": "370510",
      "Loharia BO": "370130",
      "Mindhiara BO": "370130",
      "Pundi BO": "370485",
      "Sarli BO": "370485",
      "Dolatpar BO": "370630",
      "Paneli BO": "370630",
      "Khirsara Vinjhan BO": "370490",
      "Lathedi BO": "370490",
      "Momaymora BO": "370445",
      "Rampar Vekra BO": "370445",
      "Vadasar BO": "370445",
      "Dhareshi BO": "370627",
      "Fulra BO": "370627",
      "Guneri BO": "370627",
      "Bhimasar  BO": "370240",
      "Bhorara BO": "370410",
      "Chhasara BO": "370655",
      "Kundrodi BO": "370410",
      "Moti Sindhodi BO": "370641",
      "Parjau BO": "370641",
      "Merau BO": "370465",
      "Nagalpar Dhindh BO": "370465",
      "Ratadia BO": "370465",
      "Rayan Moti BO": "370465",
      "Salaya Mota BO": "370465",
      "Sherdi BO": "370465",
      "Shirva BO": "370465",
      "Vada BO": "370465",
      "Baraya BO": "370415",
      "Meghpar BO": "370140",
      "Naranpar BO": "370430",
      "Bhirandiara BO": "370510",
      "Mithadi BO": "370510",
      "Hajipir BO": "370605",
      "Jadodar BO": "370605",
      "Jinjay BO": "370605",
      "Rapar Gadhvali BO": "370645",
      "Rava BO": "370645",
      "Sandhav BO": "370645",
      "Vadapadhar BO": "370645",
      "Chapredi BO": "370105",
      "Hajapar BO": "370650",
      "Kotda Reha BO": "370105",
      "Reha BO": "370105",
      "Sapeda BO": "370105",
      "Bada BO": "370475",
      "Bambhadai BO": "370475",
      "Nana Laija BO": "370475",
      "Panchotiya BO": "370475",
      "Todiya BO": "370670",
      "Aiyar BO": "370605",
      "Muru BO": "370605",
      "Ugedi BO": "370605",
      "Bhachunda BO": "370645",
      "Khirsara BO": "370620",
      "Vanku BO": "370645",
      "Ashram Chakar BO": "370105",
      "Lakhond BO": "370105",
      "Ningal BO": "370105",
      "Mapar BO": "370475",
      "Kidiyanagar BO": "370145",
      "Manaba BO": "370145",
      "Thoriyari BO": "370145",
      "Mamuara BO": "370020",
      "Anandpar BO": "370165",
      "Bhitara BO": "370030",
      "Kodki BO": "370030",
      "Kurbai BO": "370030",
      "Naredi BO": "370030",
      "Balachod Moti BO": "370650",
      "Dhanavada BO": "370650",
      "Khanay BO": "370650",
      "Nundhatad BO": "370650",
      "Baroi BO": "370421",
      "Shivlakha BO": "370145",
      "Vallabhapar K BO": "370145",
      "Bhujodi BO": "370020",
      "Dhaneti BO": "370020",
      "Kalyanpar BO": "370165",
      "Sanyra J BO": "370610",
      "Sanosara BO": "370030",
      "Sukhpar Roha BO": "370030",
      "Sumrasar Jat BO": "370030",
      "Bitta BO": "370650",
      "Kanday BO": "370650",
      "Dhrab BO": "370421",
      "Raydhanjar BO": "370490",
      "Sandhan BO": "370490",
      "Vinjhan BO": "370490",
      "Makda BO": "370445",
      "Mau BO": "370445",
      "Virani Gadh BO": "370445",
      "Mudhan BO": "370627",
      "Siyot BO": "370627",
      "Bhojay BO": "370450",
      "Dedhiya BO": "370450",
      "Halapar BO": "370450",
      "Karodiya Mota BO": "370450",
      "Kokalia BO": "370450",
      "Ratadiya BO": "370410",
      "Vovar BO": "370410",
      "Baug BO": "370455",
      "Nana Bhadia BO": "370455",
      "Lala BO": "370641",
      "Manjal H BO": "370465",
      "Maska BO": "370465",
      "Dumado BO": "370510",
      "Gorevali BO": "370510",
      "Hodka BO": "370510",
      "Juna BO": "370510",
      "Bhalot BO": "370130",
      "Bhuvad BO": "370130",
      "Chandia BO": "370130",
      "Chandroda BO": "370130",
      "Kadia Mota BO": "370670",
      "Kadia Nana BO": "370670",
      "Rasalia BO": "370670",
      "Mathal BO": "370605",
      "Ratadia N BO": "370605",
      "Sugaria BO": "370105",
      "Badalpar BO": "370145",
      "Chitrod BO": "370145",
      "Gagodar BO": "370145",
      "Khodasar BO": "370145",
      "Vandh BO": "370485",
      "Virani Nani BO": "370630",
      "Manjal  R  BO": "370490",
      "Suthri BO": "370490",
      "Darshadi BO": "370445",
      "Devpar Gadh BO": "370445",
      "Rajpar BO": "370445",
      "Lakhapar BO": "370425",
      "Nagrecha BO": "370450",
      "Sambharai BO": "370450",
      "Undoth BO": "370450",
      "Khari Rohar BO": "370240",
      "Padana BO": "370240",
      "Bhadreshwar BO": "370410",
      "Hatdi BO": "370410",
      "Luni BO": "370410",
      "Bhadai Moti BO": "370465",
      "Kathda BO": "370465",
      "Karaghogha BO": "370415",
      "Samaghogha BO": "370415",
      "Gajod BO": "370430",
      "Bsf Camp Khavda BO": "370510",
      "Dhrobana BO": "370510",
      "Bharasar BO": "370030",
      "Bhavanipar BO": "370650",
      "Vamoti nani BO": "370650",
      "Balapar b BO": "370650",
      "Nirona BO": "370001",
      "Vang BO": "370001",
      "Hamirpar BO": "370155",
      "Lakhagadh BO": "370155",
      "Sanva BO": "370155",
      "Taga BO": "370155",
      "Sinay BO": "370205",
      "Devalia BO": "370110",
      "Nagalpar BO": "370110",
      "Vira BO": "370110",
      "MEGHPAR BORICHI BO": "370110",
      "Vadzar BO": "370427",
      "Bandhadi BO": "370140",
      "Kadol BO": "370140",
      "Rampar  B BO": "370140",
      "Khari BO": "370510",
      "Kuran BO": "370510",
      "Mathada BO": "370130",
      "Varli BO": "370130",
      "Ukheda BO": "370670",
      "Talwana BO": "370460",
      "Amara BO": "370605",
      "Desalpar N BO": "370605",
      "Nara BO": "370605",
      "Vigodi BO": "370605",
      "Arikhana BO": "370645",
      "Bhanada BO": "370645",
      "Kali Talawali BO": "370105",
      "Mota Bandra BO": "370105",
      "Padhar BO": "370105",
      "Ratnal BO": "370105",
      "Bayath BO": "370475",
      "Bhinsara BO": "370475",
      "Kumbharia BO": "370110",
      "Sany BO": "370145",
      "Nadapa BO": "370020",
      "Anandsar BO": "370610",
      "Jiyapar BO": "370030",
      "Kotda Roha BO": "370030",
      "Mangvana BO": "370030",
      "Roha BO": "370030",
      "Vibhapar BO": "370030",
      "Balachod Nani BO": "370650",
      "Chiyasar BO": "370650",
      "Kanakpar BO": "370650",
      "Kharuva BO": "370650",
      "Vamoti moti BO": "370650",
      "Adani Port BO": "370421",
      "Sadau BO": "370421",
      "Zura BO": "370001",
      "Habay BO": "370001",
      "Kotay BO": "370001",
      "Lodai BO": "370001",
      "Bhutakia BO": "370155",
      "Moda BO": "370155",
      "Palansava BO": "370155",
      "Praghpar BO": "370155",
      "Tuna BO": "370205",
      "Bitta Valadia BO": "370110",
      "Khambhara BO": "370110",
      "Modvadar BO": "370110",
      "Chobari BO": "370140",
      "Chopadva BO": "370140",
      "Kakarva BO": "370140",
      "Kharoi BO": "370140",
      "Kumbharadi BO": "370140",
      "Manfara BO": "370140",
      "Maye BO": "370140",
      "Haripar BO": "370625",
      "Beraja BO": "370405",
      "Deshalpar BO": "370040",
      "Tumbadi BO": "370435",
      "Sumrasar S BO": "370001",
      "Loria BO": "370001",
      "Zinkdi BO": "370001",
      "Kanmer BO": "370155",
      "Khandek BO": "370155",
      "Sukhpar V BO": "370155",
      "Umaiya BO": "370155",
      "Vamka BO": "370135",
      "Sanghad BO": "370205",
      "Satapar BO": "370110",
      "Vidi BO": "370110",
      "Zaru BO": "370110",
      "Bharudia BO": "370140",
      "Chirai BO": "370140",
      "Ner BO": "370140",
      "Shikara BO": "370140",
      "Vondhada BO": "370140",
      "Padampar BO": "370160",
      "Gelda BO": "370405",
      "Pratappar BO": "370405",
      "Kandagara BO": "370435",
      "Pharadi BO": "370435",
      "Goniasar BO": "370485",
      "Nana Asambia BO": "370485",
      "Dhori BO": "370001",
      "Nagor BO": "370001",
      "Bibar BO": "370001",
      "Kunariya BO": "370001",
      "Mirzapar BO": "370001",
      "Bhagadia BO": "370001",
      "Dhrang BO": "370001",
      "Fatehgadh BO": "370155",
      "Ghanithar BO": "370155",
      "Makhel BO": "370155",
      "Mamaymora BO": "370155",
      "Vallabhapar BO": "370155",
      "Halra BO": "370135",
      "Kanthkot BO": "370135",
      "Antarjar BO": "370205",
      "Kidana BO": "370205",
      "Mathak BO": "370205",
      "Sinugara BO": "370110",
      "Tappar BO": "370110",
      "Varsamedi BO": "370110",
      "Bharapar BO": "370660",
      "Tb Sanatorium BO": "370427",
      "Amardi BO": "370140",
      "Chhadwara BO": "370140",
      "Vijapasar BO": "370140",
      "Vondh BO": "370140",
      "Zarpara BO": "370405",
      "Moti Khakhar BO": "370435",
      "Nani Khakhar BO": "370435",
      "Asambia Mota BO": "370485",
      "Dhunai BO": "370485",
      "Navinal BO": "370405",
      "Ramania BO": "370405",
      "Depa BO": "370435",
      "Siracha BO": "370435",
      "Tunda BO": "370435",
      "Godpar BO": "370485",
      "Kojachora BO": "370485",
      "Naranpar R BO": "370615",
      "Jangadia BO": "370655",
      "Sukhpar S BO": "370655",
      "Sanghipuram BO": "370655",
      "Rampar N BO": "370620",
      "Tappar S BO": "370425",
      "Balasar BO": "370165",
      "Davri BO": "370165",
      "Dholavira BO": "370165",
      "Jesda BO": "370165",
      "Kalyanpar Gadhda BO": "370165",
      "Nandasar BO": "370165",
      "Suvai BO": "370165",
      "Tindalva BO": "370165",
      "Umrapar BO": "370165",
      "Vanoi BO": "370165",
      "Meghpar Lakhpat BO": "370625",
      "Gharana BO": "370150",
      "Laliyana BO": "370150",
      "Vayor BO": "370655",
      "Koriyani BO": "370601",
      "ATPS Nani Chher BO": "370601",
      "Dhufi moti BO": "370660",
      "Hamripar BO": "370660",
      "Lakhania BO": "370660",
      "Devisar BO": "370665",
      "Fulay Chhari BO": "370665",
      "Angiya Mota BO": "370675",
      "Aida BO": "370655",
      "Ashapar BO": "370655",
      "Bandiya BO": "370620",
      "Laxmipar N BO": "370620",
      "Kanjara BO": "370425",
      "Vanki BO": "370425",
      "Badargadh BO": "370165",
      "Bela BO": "370165",
      "Dabhunda BO": "370165",
      "Deshalpar V BO": "370165",
      "Kherai BO": "370165",
      "Lodrani BO": "370165",
      "Rav BO": "370165",
      "Sai BO": "370165",
      "Selari BO": "370165",
      "Gadani BO": "370625",
      "Kotda Madh BO": "370625",
      "Baranda BO": "370655",
      "Guvar Moti BO": "370601",
      "Panandhro BO": "370601",
      "Narayan Sarovar BO": "370601",
      "Fotdi BO": "370040",
      "Ratiya BO": "370040",
      "Samtra BO": "370040",
      "Kalatalav BO": "370660",
      "Sujapar BO": "370660",
      "Lakhiyarvira BO": "370665",
      "Nani Aral BO": "370665",
      "Bhadli BO": "370675",
      "Nana Angia BO": "370675",
      "Baniyari BO": "370115",
      "Khokhara BO": "370115",
      "Kanaiyabe BO": "370115",
      "Sukhpar B BO": "370115",
      "Devpar Jakh BO": "370675",
      "Sangnara BO": "370675",
      "Budharmora BO": "370115",
      "Kotda C BO": "370115",
      "Rahpar Khokhara BO": "370115",
      "Goyala Mokhra BO": "370655",
      "Jashapar BO": "370655",
      "Ustiya BO": "370620",
      "Gadhda Khadir BO": "370165",
      "Khengarpar BO": "370165",
      "Mauvana BO": "370165",
      "Nilpar BO": "370165",
      "Trambau BO": "370165",
      "Vijayapar BO": "370165",
      "Bhadra BO": "370625",
      "Madh BO": "370625",
      "Valka Mota BO": "370625",
      "Amaliyara BO": "370150",
      "Jangi BO": "370150",
      "Fulay BO": "370655",
      "Valsara BO": "370655",
      "Mindhiari BO": "370601",
      "Nangia BO": "370660",
      "Aral Moti BO": "370665",
      "Jatavira BO": "370665",
      "Dhavda BO": "370675",
      "Rampar R BO": "370615",
      "Butta BO": "370655",
      "Charopadi Moti BO": "370655",
      "Chhadura BO": "370655",
      "Kervandh BO": "370655",
      "Moti Sudadhro BO": "370655",
      "Rampar Abda BO": "370655",
      "Ganeshpar BO": "370165",
      "Gedi BO": "370165",
      "Janan BO": "370165",
      "Jatavada BO": "370165",
      "Ramvav BO": "370165",
      "Sikarpur BO": "370150",
      "Vandhiya BO": "370150",
      "Akri moti BO": "370655",
      "Ber moti BO": "370655",
      "Dagara BO": "370115",
      "Navagam BO": "370115",
      "Dhamadka BO": "370115",
      "Pipar BO": "370655",
      "Subhashpar BO": "370601",
      "Bara Mota BO": "370660",
      "Hirapar BO": "370665",
      "Javaharnagar BO": "370115",
      "Chandrani BO": "370115",
      "Bhuj HO": "370001",
      "Baladia SO": "370427",
      "Adhoi SO": "370135",
      "Bhuj Din Dayal Nagar SO": "370001",
      "Bhujpur SO": "370405",
      "Daypar SO": "370630",
      "Gadhasisa SO": "370445",
      "Gandhidham SO": "370201",
      "Kandla Free Trade Zone SO": "370230",
      "Kapaya SO": "370415",
      "Koday SO": "370460",
      "Madhapar SO": "370020",
      "Mundra SO": "370421",
      "Nakhatrana SO": "370615",
      "Patri SO": "370425",
      "Ravapar SO": "370625",
      "Virani SO": "370665",
      "Bhachau SO": "370140",
      "Bhimasar SO": "370160",
      "Kachchh University DSO": "370015",
      "Bhuj Ravalwadi SO": "370001",
      "Bidada SO": "370435",
      "Dumara SO": "370490",
      "Gaduli SO": "370627",
      "Ganeshnagar SO Gujrat Circle": "370201",
      "Godhra SO": "370450",
      "Gundala SO": "370410",
      "Kandla Port SO": "370210",
      "Kera SO": "370430",
      "Khavda SO": "370510",
      "Kukma SO": "370105",
      "Lakadia SO": "370145",
      "Manjal SO": "370610",
      "Tera SO": "370660",
      "Adesar SO": "370155",
      "Adipur SO": "370205",
      "Bhuj Darbargadh Chowk SO": "370001",
      "Jakhau SO": "370641",
      "Khedoi SO": "370130",
      "Kothara SO": "370645",
      "Naliya SO": "370655",
      "Sukhpar SO": "370040",
      "New Dudhai SO": "370115",
      "Anjar SO": "370110",
      "Dahisara SO Kachchh": "370485",
      "Gopalpuri SO": "370240",
      "Gundiyali SO": "370455",
      "Kachchh Mandvi SO": "370465",
      "Khombhadi SO": "370670",
      "KotdaN SO": "370605",
      "Laija SO": "370475",
      "Mankuwa SO": "370030",
      "Mothara SO": "370650",
      "Netra SO": "370620",
      "Rahpar SO": "370165",
      "Samkhiyali SO": "370150",
      "Shyamji Krishna Varma Nagar SO": "370601",
      "Udaynagar SO": "370203",
      "Vithon SO": "370675"
    },
    "VALSAD": {
      "Virval BO": "396051",
      "Pitha BO": "396045",
      "Bhagod BO": "396020",
      "Khanda BO": "396051",
      "Murdad BO": "396051",
      "Nadagdhari BO": "396051",
      "Nani Dholdungri BO": "396051",
      "Rajpur Talat BO": "396051",
      "Dhanori BO": "396045",
      "Fanaswada BO": "396045",
      "Kalwada BO": "396045",
      "Khatana BO": "396051",
      "Manaichondi BO": "396051",
      "Muli BO": "396045",
      "Segva BO": "396045",
      "Khajurdi BO": "396035",
      "Saron BO": "396035",
      "Dhamdachi BO": "396035",
      "Palan BO": "396035",
      "Gadi BO": "396051",
      "Hanumatmal BO": "396051",
      "Jamalia BO": "396051",
      "Kangvi BO": "396051",
      "Karanjveri BO": "396051",
      "Velparwa BO": "396125",
      "Deli BO": "396126",
      "Dhodhadkuva BO": "396126",
      "Panas BO": "396126",
      "Samarpada BO": "396126",
      "Amba Jungle BO": "396067",
      "Arnai BO": "396065",
      "Aslona BO": "396067",
      "Astol BO": "396067",
      "Khadakwal BO": "396067",
      "Mandva BO": "396067",
      "Mohpada BO": "396067",
      "Ozarda BO": "396067",
      "Sahuda BO": "396067",
      "Goima BO": "396145",
      "Kherlav BO": "396145",
      "Patel Faliya BO": "396145",
      "Rohina BO": "396145",
      "Anjlav BO": "396055",
      "Bhutsar BO": "396055",
      "Bodlai BO": "396055",
      "Kamparia BO": "396055",
      "Kanjan Hari BO": "396055",
      "Punat BO": "396155",
      "Bhathi Karmbeli BO": "396165",
      "Dungri Udava RS BO": "396185",
      "Kalsar BO": "396185",
      "Khadki BO": "396185",
      "Palsana Pardi BO": "396185",
      "Parnera Pardi BO": "396007",
      "Ambheti BO": "396191",
      "Balitha BO": "396191",
      "Namdha BO": "396191",
      "Ozar BO": "396055",
      "Rata BO": "396191",
      "Ghadoi BO": "396035",
      "Sarodhi BO": "396185",
      "Bhavthan Ambosi BO": "396051",
      "Bopi BO": "396051",
      "Sarai BO": "396130",
      "Babarkhadak BO": "396126",
      "Balohondi BO": "396126",
      "Nevri BO": "396126",
      "Sukhala BO": "396126",
      "Varoli Talat BO": "396126",
      "Barpuda BO": "396067",
      "Chandvegan BO": "396067",
      "Jirval BO": "396067",
      "Moti Vahiyal BO": "396065",
      "Vadoli BO": "396067",
      "Virakset BO": "396067",
      "Kachigam BO": "396055",
      "Nagvas BO": "396235",
      "Ambach Paria BO": "396145",
      "Dumlav BO": "396145",
      "Tarmalia BO": "396145",
      "Kalgam BO": "396140",
      "Gadaria BO": "396055",
      "Rabda BO": "396055",
      "Angam BO": "396155",
      "Dahikhed BO": "396230",
      "Bagwada BO": "396185",
      "Gowada BO": "396170",
      "Kurgam BO": "396055",
      "Segvi BO": "396030",
      "Chandor BO": "396191",
      "Karaya BO": "396191",
      "Pandor BO": "396191",
      "Vatar BO": "396191",
      "Kewada BO": "396035",
      "Tithal BO": "396030",
      "Bildha BO": "396051",
      "Dhodipada BO": "396130",
      "Amdha BO": "396126",
      "Chival BO": "396126",
      "Varna BO": "396126",
      "Burla BO": "396067",
      "Chavshala BO": "396067",
      "Girnala BO": "396067",
      "Kakadkuva BO": "396065",
      "Shildha BO": "396067",
      "Varvath BO": "396067",
      "Borigam BO": "396235",
      "Barai BO": "396145",
      "Kanjan Ranchhod BO": "396055",
      "Navera BO": "396055",
      "Tumb BO": "396150",
      "Tukwada BO": "396185",
      "Dehri BO": "396170",
      "Bhagal BO": "396385",
      "Kosamba Valsad BO": "396030",
      "Valsad  Vankal BO": "396055",
      "Chala BO": "396191",
      "Chhiri BO": "396191",
      "Salvav BO": "396191",
      "Jogvel BO": "396126",
      "Kakadkopar BO": "396126",
      "Chepa BO": "396067",
      "Dabkhal BO": "396067",
      "Divsi BO": "396067",
      "Ghanveri BO": "396067",
      "Ghotan BO": "396067",
      "Saronda BO": "396135",
      "Tadgam BO": "396135",
      "Anklas BO": "396235",
      "Marla BO": "396055",
      "Sanjan Bandar BO": "396150",
      "Tembhi BO": "396150",
      "Vankas BO": "396150",
      "Karajgam BO": "396155",
      "Manda BO": "396155",
      "Chibhadkutch BO": "396230",
      "Palgam BO": "396170",
      "Kakwadi BO": "396385",
      "Malvan BO": "396385",
      "Atak Pardi BO": "396007",
      "Dulsad BO": "396055",
      "Faladhara BO": "396055",
      "Jujwa BO": "396007",
      "Kakadmati BO": "396055",
      "Surwada BO": "396030",
      "Velvach BO": "396007",
      "Chanod Md BO": "396195",
      "Koparli BO": "396191",
      "Morai BO": "396191",
      "Mota Pondha BO": "396191",
      "Chanvai BO": "396020",
      "Magod Dungri BO": "396020",
      "Parnera Urban BO": "396020",
      "Achhari BO": "396105",
      "Karambeli BO": "396105",
      "Mohan BO": "396105",
      "Dungra BO": "396193",
      "Kosamkuwa BO": "396050",
      "Ukta BO": "396050",
      "Endergota BO": "396375",
      "Jesia BO": "396375",
      "Kundi BO": "396375",
      "Tighara BO": "396375",
      "Vasan BO": "396375",
      "Bhadeli BO": "396030",
      "Bhadeli Jagalala BO": "396030",
      "Lilapore BO": "396030",
      "Manekpore BO": "396120",
      "Amli BO": "396125",
      "Pachlai BO": "396125",
      "Parwasa BO": "396125",
      "Sukesh BO": "396125",
      "Umarsadi BO": "396125",
      "Binwada BO": "396020",
      "Magod BO": "396020",
      "Meh BO": "396020",
      "Kalai BO": "396105",
      "Kanadu BO": "396105",
      "Karambeli RS BO": "396105",
      "Malav BO": "396105",
      "Zaroli BO": "396105",
      "Karvad BO": "396193",
      "Baroliya BO": "396050",
      "Bilpudi BO": "396050",
      "Kharvel BO": "396050",
      "Makadban BO": "396050",
      "Tiskari BO": "396050",
      "Dharasana BO": "396375",
      "Gorgam BO": "396375",
      "Jespore BO": "396375",
      "Chharwada BO": "396030",
      "Pardi RS BO": "396125",
      "Sondhal Wada BO": "396125",
      "Sonwada BO": "396375",
      "Sukhlav BO": "396125",
      "Dived BO": "396020",
      "Haria BO": "396020",
      "Dehli BO": "396105",
      "Dhanoli BO": "396105",
      "Jamburi BO": "396105",
      "Nahuli BO": "396105",
      "Nandigam BO": "396105",
      "Lavachha BO": "396193",
      "Moti Tambadi BO": "396193",
      "Kunta BO": "396215",
      "Asura BO": "396050",
      "Avdha BO": "396050",
      "Bamti BO": "396050",
      "Chichozar BO": "396050",
      "Dhamani BO": "396050",
      "Gundia BO": "396050",
      "Veribhavada BO": "396050",
      "Asma BO": "396125",
      "Balda BO": "396125",
      "Kumbharia BO": "396125",
      "Machhiwad BO": "396125",
      "Borlai BO": "396105",
      "Pali BO": "396105",
      "Valvada BO": "396105",
      "Nani Tambadi BO": "396193",
      "Barsol BO": "396050",
      "Barumal BO": "396050",
      "Bhambha BO": "396050",
      "Bhensdara BO": "396050",
      "Pindval BO": "396050",
      "Sidumber BO": "396050",
      "Rola BO": "396375",
      "Shankar Talav BO": "396375",
      "Vaghaldhara BO": "396375",
      "Meghval BO": "396240",
      "Vaghchhipa BO": "396125",
      "Amba Talat SO": "396051",
      "Hanuman Bhagda SO": "396030",
      "Khatalwada SO": "396120",
      "Sarigam SO": "396155",
      "Udvada RS SO": "396185",
      "Umargam IE SO": "396171",
      "Valsad Abrama SO": "396002",
      "Kaprada SO": "396067",
      "Dharampur SO Valsad": "396050",
      "Bhilad SO": "396105",
      "Karad Daman Project SO": "396240",
      "Killa Pardi SO": "396125",
      "Nanivahiyal SO": "396065",
      "Valsad Chhipwad SO": "396001",
      "Valsad Mota Bazar SO": "396001",
      "Valsad Sugar Factory SO": "396007",
      "Vapi SO": "396191",
      "Phansa SO": "396140",
      "Ronvel SO": "396055",
      "Solsumba SO": "396165",
      "Udvada SO": "396180",
      "Untdi SO": "396385",
      "Vapi IE SO": "396195",
      "Atgam SO": "396045",
      "Atul SO": "396020",
      "Dungri SO Valsad": "396375",
      "Kolak SO": "396115",
      "Maroli Sanjan SO": "396130",
      "Nanapondha SO": "396126",
      "Nargol SO": "396135",
      "Pardi Paria SO": "396145",
      "Sanjan SO": "396150",
      "Umargam SO": "396170",
      "Valsad IE SO": "396035",
      "Valsad HO": "396001"
    },
    "TAPI": {
      "Agasvan BO": "394651",
      "Ghata BO": "394651",
      "Khodtalav BO": "394651",
      "Limbarda BO": "394651",
      "Kelkui BO": "394630",
      "Umarkui BO": "394630",
      "Umarkutch BO": "394630",
      "Padamdungri BO": "394635",
      "Panchol BO": "394635",
      "Pathakwadi BO": "394635",
      "Pati BO": "394635",
      "Borisavar BO": "394670",
      "Dhajamba BO": "394670",
      "Kasvav BO": "394633",
      "Mangalia BO": "394633",
      "Palawadi BO": "394633",
      "Vanskui BO": "394651",
      "Kaher BO": "394690",
      "Lotarva BO": "394690",
      "Andhatri BO": "394630",
      "Bahedaraipura BO": "394630",
      "Bedchit BO": "394630",
      "Dadaria BO": "394630",
      "Kalakva BO": "394630",
      "Pelad BO": "394630",
      "Bardipada BO": "394635",
      "Kalamkui BO": "394340",
      "Pipalkuva BO": "394670",
      "Unchamala BO": "394651",
      "Vazarda BO": "394651",
      "Butwada BO": "394690",
      "Degama BO": "394690",
      "Rupvada BO": "394690",
      "Sisor BO": "394651",
      "Vadkui BO": "394651",
      "Bhojpur Najik BO": "394690",
      "Borkhadi BO": "394690",
      "Gheriavav BO": "394630",
      "Vankla BO": "394630",
      "Chunavadi BO": "394635",
      "Pithadara BO": "394635",
      "Ghoda BO": "394670",
      "Mirkot BO": "394670",
      "Ukhalda BO": "394670",
      "Ambia BO": "394633",
      "Jesingpur BO": "394633",
      "Panchpipla BO": "394360",
      "Kanjan BO": "394655",
      "Khurdi BO": "394655",
      "Khutadia BO": "394655",
      "Moramba BO": "394380",
      "Nimbhora BO": "394380",
      "Dhamodla BO": "394340",
      "Rumkitalav BO": "394370",
      "Hindla BO": "394365",
      "Hiravadi BO": "394365",
      "Jamkhadi BO": "394365",
      "Khanjar BO": "394365",
      "Chhapti BO": "394375",
      "Chitpur BO": "394375",
      "Gavan BO": "394375",
      "Haripur BO": "394375",
      "Bedkuvadoor BO": "394360",
      "Balpur BO": "394655",
      "Dhat BO": "394655",
      "Raniamba BO": "394655",
      "Zankhari BO": "394655",
      "Itwai BO": "394380",
      "Mordevi BO": "394250",
      "Khorda BO": "394370",
      "Laxmikheda BO": "394370",
      "Sayla BO": "394370",
      "Amalgundi BO": "394365",
      "Gopalpura BO": "394365",
      "Taparwada BO": "394365",
      "Bhitkhurd BO": "394375",
      "Ghani BO": "394630",
      "Goddha BO": "394630",
      "Virpor BO": "394630",
      "Antapur BO": "394635",
      "Kakadva BO": "394635",
      "Karanjkhed BO": "394635",
      "Umarvavdoor BO": "394635",
      "Kumkuva BO": "394670",
      "Moti Khervan BO": "394670",
      "Dhanturi BO": "394633",
      "Magarkui BO": "394655",
      "Sankli BO": "394655",
      "Amoda BO": "394380",
      "Chirmati BO": "394380",
      "Chokhiamli BO": "394380",
      "Gangtha BO": "394380",
      "Phulwadi BO": "394380",
      "Pisavar BO": "394380",
      "Ghasiamedha BO": "394360",
      "Chhindia BO": "394655",
      "Dolara BO": "394655",
      "Karanjvel BO": "394655",
      "Lakhali BO": "394655",
      "Mirpur BO": "394655",
      "Hathoda BO": "394380",
      "Mataval BO": "394380",
      "Bedkuva BO": "394340",
      "Syadla BO": "394340",
      "Gujarpur BO": "394370",
      "Mubarakpur BO": "394370",
      "Sarvala BO": "394370",
      "Doswada BO": "394365",
      "Gunkhadi BO": "394365",
      "Mota Tarpada BO": "394365",
      "Segupada BO": "394365",
      "Algat BO": "394246",
      "Sadgavan BO": "394380",
      "Bhiljamboli BO": "394370",
      "Bortha BO": "394370",
      "Piplod BO": "394370",
      "Raigadh BO": "394370",
      "Vanka BO": "394370",
      "Veldha BO": "394370",
      "Vyaval BO": "394370",
      "Sadadvel BO": "394365",
      "Malangdev BO": "394716",
      "Jamania BO": "394246",
      "Babarghat BO": "394375",
      "Bhadbhunja BO": "394375",
      "Singpur BO": "394670",
      "Thuti BO": "394670",
      "Vadibhesrot BO": "394670",
      "Magarbara BO": "394375",
      "Narayanpur BO": "394375",
      "Sankarda BO": "394375",
      "Selud BO": "394375",
      "Kanjod BO": "394640",
      "Navafalia BO": "394640",
      "Ranveri BO": "394640",
      "Delvada BO": "394620",
      "Katasvan BO": "394650",
      "Khushalpura BO": "394650",
      "Khabda BO": "394375",
      "Tokarva BO": "394375",
      "Serulla BO": "394680",
      "Bhimpor BO": "394640",
      "Bedkuvanajik BO": "394650",
      "Champavadi BO": "394650",
      "Chikhali Khadka BO": "394650",
      "Paniyari BO": "394650",
      "Dhamodi BO": "394652",
      "Karod BO": "394375",
      "Kuida BO": "394375",
      "Sundarpur BO": "394375",
      "Limbi BO": "394680",
      "Hathuka BO": "394640",
      "Siker BO": "394620",
      "Ambach BO": "394641",
      "Chikhalvav BO": "394650",
      "Kikakui BO": "394650",
      "Nishana BO": "394650",
      "Chikhalda BO": "394652",
      "Bhatwada BO": "394680",
      "Gandhi Vidhyapith BO": "394641",
      "Khanpur BO": "394641",
      "Chikhlinani BO": "394650",
      "Chorvad BO": "394650",
      "Virpur BO": "394650",
      "Mota Bandharpada BO": "394652",
      "Moghvan BO": "394652",
      "Galkuva BO": "394652",
      "Bajipura SO": "394690",
      "Buhari SO": "394630",
      "Kukurmunda SO": "394380",
      "Vyara SO": "394650",
      "Gadat SO Tapi": "394633",
      "Kapura SO": "394655",
      "Uchchhal SO": "394375",
      "Ukai Dam SO": "394680",
      "Valod SO": "394640",
      "Vyara RS SO": "394650",
      "Panwadi SO": "394652",
      "Fort Songadh SO": "394670",
      "Raniamba SO": "394365",
      "Anumala SO": "394651",
      "Centrap Pulp Mill SO": "394660",
      "Dolvan SO": "394635",
      "Nijhar SO": "394370",
      "Vedchhi SO": "394641"
    },
    "DANG": {
      "Borkhal BO": "394710",
      "Chankhal BO": "394710",
      "Chikatia BO": "394710",
      "Chinchli BO": "394710",
      "Nakatia Hanvant BO": "394710",
      "Pandva BO": "394710",
      "Bhavandagad BO": "394710",
      "Dhavlidod BO": "394710",
      "Garakhadi BO": "394710",
      "Morzira BO": "394710",
      "Galkund BO": "394710",
      "Ghadvi BO": "394710",
      "Gondalvihir BO": "394710",
      "Mahalpada BO": "394710",
      "Jakhana BO": "394710",
      "Linga BO": "394710",
      "Bardipada BO": "394715",
      "Chinchinagaontha BO": "394715",
      "Kalibel BO": "394715",
      "Kosimda BO": "394715",
      "Kadmal BO": "394716",
      "Sarovar BO": "394715",
      "Malegaon BO": "394720",
      "Khambhala BO": "394716",
      "Mahal BO": "394716",
      "Singana BO": "394716",
      "Bhalkhet BO": "394715",
      "Khatal BO": "394715",
      "Maheshkatri BO": "394715",
      "Gotiamal BO": "394720",
      "Keshbandh BO": "394716",
      "Lavchali BO": "394716",
      "Tanklipada BO": "394716",
      "Nishana BO": "394716",
      "Pipaldahad BO": "394716",
      "Piplaidevi BO": "394716",
      "Barkhandhia BO": "394730",
      "Chikar BO": "394730",
      "Chikhali Dangs BO": "394730",
      "Dagunia BO": "394730",
      "Manmodi BO": "394730",
      "Vasurna BO": "394730",
      "Dagadiamba BO": "394730",
      "Jhavda BO": "394730",
      "Samgahan BO": "394730",
      "Zaridungarda BO": "394730",
      "Nadagchond BO": "394730",
      "Nanapada BO": "394730",
      "Rambhas BO": "394730",
      "Sakarpatal BO": "394730",
      "Ahwadangs SO": "394710",
      "Pimpri SO": "394715",
      "Saputara SO": "394720",
      "Subir SO": "394716",
      "Waghai SO": "394730"
    },
    "DOHAD": {
      "Bhadkhadabar BO": "389180",
      "Chhayan BO": "389180",
      "Raniyar Kanbi BO": "389180",
      "Simlia BO": "389180",
      "Bar BO": "389140",
      "Khirkhai BO": "389140",
      "Manli BO": "389140",
      "Pania BO": "389140",
      "Pipodra BO": "389140",
      "Rai BO": "389140",
      "Vadela BO": "389140",
      "Bilwani BO": "389180",
      "Kaliarai BO": "389180",
      "Karamba BO": "389180",
      "Kharvani BO": "389180",
      "Malvasi BO": "389180",
      "Sudia BO": "389180",
      "Tandi BO": "389180",
      "Varod BO": "389180",
      "Andheri BO": "389140",
      "Dhadhela BO": "389170",
      "Jada Kheria BO": "389140",
      "Lukhavada BO": "389140",
      "Aasayadi BO": "389130",
      "Amba BO": "389180",
      "Chakalia BO": "389180",
      "Dantia BO": "389140",
      "Karath BO": "389180",
      "Mundaheda BO": "389180",
      "Sutharvansa BO": "389180",
      "Thala BO": "389175",
      "Agara BO": "389175",
      "Bandibar BO": "389140",
      "Kamboi BO": "389140",
      "Kundha BO": "389140",
      "Balaiya BO": "389190",
      "Hindolia BO": "389190",
      "Lakhanpur BO": "389190",
      "Margala BO": "389190",
      "Nani Dhadheli BO": "389190",
      "Nindka BO": "389190",
      "Dasa BO": "389130",
      "Mander BO": "389130",
      "Panchela BO": "389130",
      "Randhikpur BO": "389130",
      "Toyani BO": "389130",
      "Anika BO": "389175",
      "Moli BO": "389175",
      "Rupa Kheda BO": "389190",
      "Vansia Kui BO": "389190",
      "Tarvadia Himat BO": "389154",
      "Tarvadia Vaja BO": "389154",
      "Vankiya BO": "389154",
      "Dungri BO": "389180",
      "Gultora BO": "389180",
      "Parathampur BO": "389180",
      "Pethapur BO": "389180",
      "Budhpur BO": "389140",
      "Dabhada BO": "389140",
      "Jetpur BO": "389170",
      "Chhaparwad BO": "389130",
      "Chundadi BO": "389130",
      "Moti Zari BO": "389130",
      "Patangdi BO": "389130",
      "Valagota BO": "389130",
      "Bhanpur BO": "389175",
      "Methan BO": "389175",
      "Afwa BO": "389190",
      "Bhojela BO": "389190",
      "Javesi BO": "389190",
      "Sagdapada BO": "389190",
      "Machhelai BO": "389130",
      "Rama BO": "389130",
      "Salia BO": "389130",
      "Chamaria BO": "389175",
      "Dhediya BO": "389175",
      "Jhunsa BO": "389175",
      "Baina BO": "389380",
      "Chorbaria BO": "389380",
      "Devirampura BO": "389380",
      "Fangia BO": "389380",
      "Kali Dungri BO": "389380",
      "Nadatod BO": "389380",
      "Singedi BO": "389380",
      "Training College BO": "389380",
      "Udhavala BO": "389380",
      "Virol BO": "389380",
      "Pipero BO": "389382",
      "Zerjitagadh BO": "389146",
      "Bhichor BO": "389172",
      "Dungar BO": "389172",
      "Salara BO": "389172",
      "Mandli BO": "389175",
      "Nenki BO": "389175",
      "Pichhoda BO": "389175",
      "Vansia BO": "389175",
      "Dharadungar BO": "389160",
      "Naghrala BO": "389160",
      "Bharamkheda BO": "389160",
      "Muvalia BO": "389160",
      "Rabdal BO": "389160",
      "Mandor BO": "389155",
      "Nava Nagar BO": "389155",
      "Simlia Buzarg BO": "389155",
      "Vejelav BO": "389152",
      "Chitrodia BO": "389170",
      "Dhavadia BO": "389170",
      "Therka BO": "389170",
      "Simalia Khurd BO": "389154",
      "Bamroli BO": "389380",
      "Bara BO": "389380",
      "Chenpur BO": "389380",
      "Dudhia BO": "389380",
      "Juna Baria BO": "389380",
      "Khandania BO": "389380",
      "Zab BO": "389380",
      "Sajoi BO": "389382",
      "Nava Vadia BO": "389146",
      "Padalia BO": "389146",
      "Pahad BO": "389146",
      "Singapur BO": "389146",
      "Moti Nan Dukan BO": "389172",
      "Moti Rel Purv BO": "389172",
      "Bhathiwada BO": "389160",
      "Kharod BO": "389160",
      "Rentia BO": "389160",
      "Chosala BO": "389160",
      "Navagam BO": "389160",
      "Moti Kharaj BO": "389160",
      "Rozam BO": "389160",
      "Himala BO": "389160",
      "Kharoda BO": "389160",
      "Jambua BO": "389155",
      "Kaliavad BO": "389152",
      "Matva BO": "389152",
      "Nandhelav BO": "389152",
      "Pandadi BO": "389152",
      "Gamdi BO": "389170",
      "Garadu BO": "389170",
      "Hirola BO": "389170",
      "Jafarpura BO": "389170",
      "Kadval BO": "389170",
      "Chandwana BO": "389154",
      "Dasla BO": "389154",
      "Gamla BO": "389154",
      "Itawa BO": "389154",
      "Antela BO": "389380",
      "Moti Khajuri BO": "389380",
      "Nakti BO": "389380",
      "Vadbhet BO": "389380",
      "Ghada BO": "389382",
      "Nalu BO": "389382",
      "Chhalor BO": "389172",
      "Ghughas BO": "389172",
      "Kelia BO": "389380",
      "Ruvabari BO": "389380",
      "Sagtala BO": "389380",
      "Sevania BO": "389380",
      "Agaswani BO": "389382",
      "Bhorva BO": "389382",
      "Dudhamali BO": "389382",
      "Dumka BO": "389382",
      "Kanjeta BO": "389382",
      "Simamoi BO": "389382",
      "Tokarva BO": "389382",
      "Ved BO": "389382",
      "Zabu BO": "389382",
      "Vadvas BO": "389172",
      "Jekot BO": "389160",
      "KaligamGujar BO": "389160",
      "Khredi BO": "389160",
      "Mira Khedi BO": "389160",
      "Tanda BO": "389160",
      "Boriala BO": "389155",
      "Dadur BO": "389155",
      "Gangardi BO": "389155",
      "Panchvada BO": "389155",
      "Patia BO": "389155",
      "Abhlod BO": "389152",
      "Bavka BO": "389152",
      "Bajarwada BO": "389170",
      "Kalijini Saraswani BO": "389170",
      "Kharsana BO": "389170",
      "Mahudi BO": "389170",
      "Munkhosla BO": "389170",
      "Velpura BO": "389170",
      "Kathla BO": "389154",
      "Vangad BO": "389172",
      "Pavdi BO": "389160",
      "Chhapari  BO": "389160",
      "Uchvania BO": "389160",
      "Bordi RS BO": "389160",
      "Bhe BO": "389155",
      "Bhutaradi BO": "389155",
      "Minakyar BO": "389155",
      "Zari Buzarg BO": "389155",
      "Chilakota BO": "389152",
      "Vadva BO": "389152",
      "Fulpura BO": "389170",
      "Shankarpura BO": "389170",
      "Vagela BO": "389170",
      "Agavada BO": "389154",
      "Jalat BO": "389154",
      "Khangela BO": "389154",
      "Dahod HO": "389151",
      "Devgadh Baria SO": "389380",
      "Jhalod SO": "389170",
      "Limkheda SO": "389140",
      "Sukhsar SO": "389190",
      "Jesawada SO": "389152",
      "Piplod SO Dahod": "389130",
      "Dahod RS SO": "389151",
      "Dhanpur SO": "389382",
      "Dudhia SO": "389146",
      "Fatepura SO Dahod": "389172",
      "Garbada SO": "389155",
      "Freelandganj SO": "389160",
      "Katwara SO": "389154",
      "Limdi SO": "389180",
      "Sanjeli SO": "389175"
    }
  },
  "CHHATTISGARH": {
    "KONDAGAON": {
      "Belondi": "494230",
      "Dundabedma": "494230",
      "Baniyagaon": "494230",
      "Khalari B.O": "494347",
      "Kopra B.O": "494347",
      "Marangpuri B.O": "494347",
      "Titirwand B.O": "494347",
      "Heerapur B.O": "494226",
      "Anantpur": "494237",
      "Budra": "494237",
      "Sitali": "494237",
      "Sodma": "494237",
      "Toranga": "494237",
      "Useli B.O": "494230",
      "Rawbeda": "494230",
      "Toskapal": "494230",
      "Banskote B.O": "494347",
      "Kaurgaon B.O": "494347",
      "Salna B.O": "494347",
      "Tenwsa B.O": "494347",
      "Dharli B.O": "494226",
      "Otenda B.O": "494226",
      "Chhinari B.O": "494226",
      "Shampur B.O": "494226",
      "Pidhapal": "494237",
      "Rakashbeda": "494237",
      "Todasi B.O": "494230",
      "Charbhatha": "494230",
      "Chikhli": "494230",
      "Churegaon": "494230",
      "Korkoti": "494230",
      "Bade Rajpur B.O": "494347",
      "Bijapur B.O": "494226",
      "Badesohanga": "494237",
      "Bogadi": "494237",
      "Hadigaon": "494237",
      "Taraibeda B.O": "494230",
      "Chindlibeda": "494230",
      "Garawandi": "494230",
      "Nayanar": "494230",
      "Lihagaon B.O": "494347",
      "Balenga": "494347",
      "Babai B.O": "494226",
      "Amrawati": "494237",
      "Erla": "494237",
      "Karandi": "494237",
      "Torandi": "494237",
      "Hangwa BO": "494226",
      "Kamela BO": "494226",
      "Khachgaon BO": "494226",
      "Kusma BO": "494226",
      "Juganikalar B.O": "494229",
      "Lanjoda B.O": "494229",
      "Katagaon B.O": "494229",
      "Fufgaon": "494229",
      "Chandabeda": "494228",
      "Chichadi": "494228",
      "Amabeda B.O": "494230",
      "Arandi B.O": "494230",
      "Kongud B.O": "494230",
      "Nagarbeda B.O": "494230",
      "Sawala B.O": "494230",
      "Fukagirola BO": "494226",
      "Nilji BO": "494226",
      "Pala BO": "494226",
      "Polang BO": "494226",
      "Bagbeda": "494661",
      "Bhanpuri B.O": "494229",
      "Badedongar B.O": "494228",
      "Bangaon B.O": "494228",
      "Barkai B.O": "494228",
      "Jodekera B.O": "494228",
      "Kotpad B.O": "494228",
      "Lubha B.O": "494228",
      "Manghiatgaon B.O": "494228",
      "Pawda": "494228",
      "Arra B.O": "494230",
      "Badagaon B.O": "494230",
      "Choteodagaon B.O": "494230",
      "Eragaon B.O": "494230",
      "Khetarpal B.O": "494230",
      "Kanga BO": "494226",
      "Khandam BO": "494226",
      "Lakhapuri BO": "494226",
      "Madanar BO": "494226",
      "Temrugaon BO": "494226",
      "Jaitpuri B.O": "494229",
      "Kerawahi B.O": "494229",
      "Randhna B.O": "494228",
      "Urandabeda B.O": "494228",
      "Bhandarwandi": "494228",
      "Madagaon": "494228",
      "Badekhauli B.O": "494230",
      "Cherbeda B.O": "494230",
      "Piprakhas B.O": "494230",
      "Hadeli BO": "494226",
      "Khadpadi BO": "494226",
      "Nawagaon BO": "494226",
      "Rajagaon BO": "494226",
      "Satgaon BO": "494226",
      "Bhandarseoni B.O": "494229",
      "Hirri B.O": "494229",
      "Alor B.O": "494228",
      "Bangoli": "494228",
      "Mohpal": "494228",
      "Banjoda B.O": "494230",
      "Binjhe B.O": "494230",
      "Dhanora B.O": "494230",
      "Sikagaon B.O": "494230",
      "Dnk Colony B.O": "494226",
      "Girola B.O": "494226",
      "Golawand B.O": "494226",
      "Kibaibalenga B.O": "494226",
      "Masora B.O": "494226",
      "Badebendari BO": "494226",
      "Badebhirawand BO": "494226",
      "Adenga B.O": "494331",
      "Kohkameta B.O": "494331",
      "Bamni Bazar B.O": "494226",
      "Bunagaon B.O": "494226",
      "Chipawand B.O": "494226",
      "Joba B.O": "494226",
      "Kongera B.O": "494226",
      "Malakot B.O": "494226",
      "Umargaon B.O": "494226",
      "Bakhara BO": "494226",
      "Bhiragaon-A BO": "494226",
      "Borgaon BO": "494226",
      "Eslanar BO": "494226",
      "Badekanera B.O": "494226",
      "Baniyagaon B.O": "494226",
      "Bayanar B.O": "494226",
      "Chema B.O": "494226",
      "Malgaon B.O": "494226",
      "Mardapal B.O": "494226",
      "Matwal B.O": "494226",
      "Mohlai B.O": "494226",
      "Mulmula B.O": "494226",
      "Chawdang BO": "494226",
      "Chikhalputi BO": "494226",
      "Chimadi BO": "494226",
      "Singanpur B.O": "494331",
      "Bafna B.O": "494226",
      "Banjugani B.O": "494226",
      "Dahikonga B.O": "494226",
      "Kokodi B.O": "494226",
      "Makdi B.O": "494226",
      "Palari B.O": "494226",
      "Sonabal B.O": "494226",
      "Bhiragaon-B BO": "494226",
      "Botikanera BO": "494226",
      "Chilputi BO": "494226",
      "Chotebhirawand BO": "494226",
      "Keshkal S.O": "494331",
      "Kondagaon S.O": "494226",
      "Piprabahigaon S.O": "494230",
      "Makdi SO": "494237",
      "Pharasgaon Camp S.O": "494229",
      "Vishrampuri S.O": "494347",
      "Kondagaon Naka S.O": "494226",
      "Pharasgaon S.O": "494228"
    },
    "BILASPUR": {
      "Kenda BO": "495116",
      "Semariya BO": "495116",
      "Tenganmada BO": "495116",
      "Umariyadadar BO": "495116",
      "Dhuma BO": "495113",
      "Bartori BO": "495224",
      "Sewar BO": "495224",
      "Neora BO": "495112",
      "Hirri BO": "495222",
      "Janji BO": "495550",
      "Mudpar BO": "495550",
      "Bhaisajhar BO": "495113",
      "Bijaypur BO": "495113",
      "Nirtu BO": "495559",
      "Lutra BO": "495559",
      "Harditonakala BO": "495004",
      "Sirgitti BO": "495004",
      "Dhania BO": "495559",
      "Khongsara BO": "495116",
      "Majhgaon BO": "495116",
      "Majhwani BO": "495116",
      "Mithunawagaon BO": "495116",
      "Anda BO": "495224",
      "Bitkuli BO": "495224",
      "Bortara BO": "495224",
      "Sakarra BO": "495220",
      "Bharari BO": "495551",
      "Bharni BO": "495112",
      "Lamer BO": "495112",
      "Tanda BO": "495112",
      "Gatora BO": "495550",
      "Gudi BO": "495550",
      "Billiband BO": "495113",
      "Gobripat BO": "495113",
      "Dagori BO": "495224",
      "Pasid BO": "495224",
      "Muru BO": "495220",
      "Kaudia BO": "495550",
      "Pondi BO": "495442",
      "Amoli BO": "495113",
      "Chhatauna BO": "495116",
      "Khairjhiti BO": "495116",
      "Pudu BO": "495116",
      "Deorikhurd BO": "495004",
      "Baoli BO": "495224",
      "Piraiya BO": "495224",
      "Sarwani BO": "495224",
      "Sagar BO": "495220",
      "Parsada BO": "495113",
      "Ghutku BO": "495112",
      "Pipartarai BO": "495112",
      "Aramsahi BO": "495550",
      "Nargoda BO": "495550",
      "Bansajhal BO": "495113",
      "Bija BO": "495113",
      "Singhri BO": "495442",
      "Dhandhan BO": "495330",
      "Rajpur BO": "495330",
      "Girdhauna BO": "495003",
      "Belsari BO": "495330",
      "Siltara BO": "495330",
      "Seepat BO": "495555",
      "Mochh BO": "495003",
      "Kathakoni BO": "495003",
      "Urtum BO": "495006",
      "Pandhi BO": "495555",
      "Bahatarai BO": "495003",
      "Baimanagoi BO": "495006",
      "Shivtarai BO": "495113",
      "Junapara BO": "495115",
      "Malhar BO": "495551",
      "Sukulkari BO": "495551",
      "Tikari BO": "495551",
      "Jhingatpur BO": "495113",
      "Kargikala BO": "495113",
      "Birkona BO": "495009",
      "Lofandi BO": "495009",
      "Bhatchaura BO": "495551",
      "Darrighat BO": "495551",
      "Deogaon BO": "495551",
      "Manikchauri BO": "495551",
      "Paunsara BO": "495009",
      "Sendri BO": "495009",
      "Bandha BO": "495115",
      "Jondhra BO": "495551",
      "Loharsison BO": "495551",
      "Okhar BO": "495551",
      "Risda BO": "495551",
      "Beltara BO": "495449",
      "Jarondha BO": "495330",
      "Matsagra BO": "495330",
      "Pura BO": "495330",
      "Saida BO": "495003",
      "Bahtarai BO": "495006",
      "Mopka BO": "495006",
      "Kargikhurd BO": "495113",
      "Pali BO": "495113",
      "Salkhanowgaon BO": "495113",
      "Semartal BO": "495009",
      "Gondadih BO": "495551",
      "Koni BO": "495551",
      "Pachpedi BO": "495551",
      "Son BO": "495551",
      "Jali BO": "495449",
      "Jevra BO": "495446",
      "Chapora BO": "495442",
      "Khaira BO": "495442",
      "Sarwandeori BO": "495442",
      "Lakhram BO": "495442",
      "Mohda BO": "495442",
      "Ranigaon BO": "495442",
      "Garwat BO": "495442",
      "Selar BO": "495442",
      "Koni SO": "495009",
      "Mangla SO": "495001",
      "Ramdas Nagar SO": "495004",
      "Ratanpur SO Bilaspur": "495442",
      "Sarkanda Bilaspur SO": "495006",
      "Kilaward Bilaspur SO": "495001",
      "Ujwal Nagar SO Bilaspur": "495555",
      "Takhatpur SO": "495330",
      "Sakri": "495003",
      "South Eastern Coals Limited": "495006",
      "Masturi SO": "495551",
      "Rajkishore Nagar": "495006",
      "Bilaspur BilaspurCGH HO": "495001",
      "Belgahana SO": "495116",
      "Juna Bilaspur SO": "495001",
      "Bilha SO": "495224",
      "Jairam Nagar SO": "495550",
      "Kargi Road SO": "495113",
      "Bilaspur Industrial Estate SO": "495001",
      "Bilaspur RS SO": "495004",
      "Cmd College Bilaspur SO": "495004",
      "Gole Bazar Bilaspur SO": "495001",
      "High Court Bilaspur SO": "495220",
      "Bilaspur Kutchery BilaspurCGHSO": "495001",
      "Chakarbhata Camp SO": "495220",
      "Ganiyari SO": "495112",
      "Hirri Mines SO": "495222"
    },
    "BASTAR": {
      "Gadhiya B.O": "494010",
      "Ghotia B.O": "494010",
      "Mardum B.O": "494010",
      "Narayanpal B.O": "494010",
      "Sudhapal B.O": "494010",
      "Godiyapal B.O": "494010",
      "Takraguda B.O": "494010",
      "Arandwal": "494010",
      "Tirtha": "494010",
      "Badebodenar B.O": "494442",
      "Badekilepal B.O": "494442",
      "Chingpal B.O": "494442",
      "Neganar B.O": "494442",
      "Telemarenga B.O": "494442",
      "Badekadma B.O": "494442",
      "Bastanar-02 B.O": "494442",
      "Burungapal B.O": "494442",
      "Kaknar B.O": "494010",
      "Kapanar B.O": "494442",
      "Mangnar B.O": "494222",
      "Nainnar B.O": "494442",
      "Sadrabodenar B.O": "494442",
      "Badekadma": "494442",
      "Badeparakot": "494442",
      "Jamgaon": "494442",
      "Kamanar": "494442",
      "Mawlibhata": "494442",
      "Nainnar": "494442",
      "Kokawada B.O": "494115",
      "Tirathgarh B.O": "494115",
      "Kumhli B.O": "494010",
      "Kuruspal B.O": "494010",
      "Kuthar B.O": "494010",
      "Chandanpur B.O": "494010",
      "Chhaparbhanpuri  B.O": "494010",
      "Dilmili B.O": "494442",
      "Errakot B.O": "494442",
      "Kumharsandra B.O": "494442",
      "Michnar B.O": "494442",
      "Keshapur B.O": "494442",
      "Alwa B.O": "494442",
      "Bade Kilepal-2 B.O": "494442",
      "Burungpal(Naharmunda) B.O": "494442",
      "Chhindabahar B.O": "494442",
      "Chhotegudra B.O": "494442",
      "Irpa B.O": "494442",
      "Turangur B.O": "494442",
      "Keshapur": "494442",
      "Burungpal(Naharmunda)": "494442",
      "Chhindabahar": "494442",
      "Chhotegudra": "494442",
      "Kapanar": "494442",
      "Soorguda": "494442",
      "Darbha B.O": "494115",
      "Kotamsar B.O": "494115",
      "Garda B.O": "494010",
      "Ratenga B.O": "494010",
      "Sirisguda B.O": "494010",
      "Arandwal B.O": "494010",
      "Badarenga B.O": "494010",
      "Chandanpur": "494010",
      "Godiyapal": "494010",
      "Karekot": "494010",
      "Sadra": "494010",
      "Badekakloor B.O": "494442",
      "Kalepal B.O": "494442",
      "Bade Kilepal-3 B.O": "494442",
      "Keshloor B.O": "494442",
      "Kodenar-2 B.O": "494442",
      "Kodenar-3 B.O": "494442",
      "Koypal B.O": "494442",
      "Mawlibhata B.O": "494442",
      "Palwa B.O": "494442",
      "Soorguda B.O": "494442",
      "Tirthum B.O": "494442",
      "Irpa": "494442",
      "Keshloor": "494442",
      "Koypal": "494442",
      "Rajoor": "494442",
      "Sadrabodenar": "494442",
      "Turangur": "494442",
      "Kukanar B.O": "494115",
      "Leda B.O": "494115",
      "Pakhnar B.O": "494115",
      "Matnar B.O": "494222",
      "Parapur B.O": "494010",
      "Taragaon B.O": "494010",
      "Karekot B.O": "494010",
      "Sadra B.O": "494010",
      "Silakjhodi B.O": "494010",
      "Tirtha B.O": "494010",
      "Badarenga": "494010",
      "Silakjhodi": "494010",
      "Takraguda": "494010",
      "Bastanar B.O": "494442",
      "Chitapur B.O": "494442",
      "Kodenar B.O": "494442",
      "Mutanpal B.O": "494442",
      "Raikot B.O": "494442",
      "Badeparakot B.O": "494442",
      "BIRGALI B.O": "494442",
      "Jamgaon B.O": "494224",
      "Kamanar B.O": "494442",
      "Rajoor B.O": "494442",
      "Alwa": "494442",
      "BIRGALI": "494442",
      "Burungapal": "494442",
      "Kaknar": "494442",
      "Mangnar": "494442",
      "Palwa": "494442",
      "Tirthum": "494442",
      "Kikirpal B.O": "494115",
      "Puspal B.O": "494001",
      "Kotamsar": "494115",
      "Rajnagar B.O": "494222",
      "Sawara B.O": "494222",
      "Badechakwa B.O": "494223",
      "Baghmohlai B.O": "494223",
      "Bhainsgaon B.O": "494223",
      "Chokar B.O": "494223",
      "Tikralohanga B.O": "494223",
      "Kumhali B.O": "494224",
      "Mohlai B.O": "494224",
      "Salemeta B.O": "494224",
      "Satosa B.O": "494224",
      "Sonarpal B.O": "494224",
      "Badejerakhar B.O": "494224",
      "Bakel B.O": "494224",
      "Beosuli B.O": "494224",
      "Chamiya B.O": "494224",
      "Pharsara B.O": "494224",
      "Rajpur B.O": "494224",
      "Karpawand B.O": "494222",
      "Kolawali B.O": "494222",
      "Sargipal B.O": "494222",
      "Bhejripadar B.O": "494222",
      "Mangnar  B.O": "494222",
      "Dubeumargaon B.O": "494223",
      "Khorkosa B.O": "494223",
      "Madhota B.O": "494223",
      "Ghatkawali B.O": "494223",
      "Kudhargaon B.O": "494223",
      "Guria B.O": "494224",
      "Kesarpal B.O": "494224",
      "Usari B.O": "494224",
      "Chhoorawand B.O": "494224",
      "Devda B.O": "494224",
      "Garenga B.O B.O": "494224",
      "Pakhnakongera B.O": "494224",
      "Tikanpal B.O": "494224",
      "Badedeoda B.O": "494222",
      "Kinjoli B.O": "494222",
      "Korta B.O": "494222",
      "Muli B.O": "494222",
      "Pahurbel B.O": "494222",
      "Sandkarmari B.O": "494222",
      "Kodawand B.O": "494222",
      "Pathari B.O": "494222",
      "Iti Bastar B.O": "494223",
      "Kolchur B.O": "494223",
      "Ichhapur B.O": "494223",
      "Madhota  B.O": "494223",
      "Nadisagar B.O": "494223",
      "Garenga B.O": "494224",
      "Jaibel B.O": "494224",
      "Madlapal B.O": "494224",
      "Mundagaon B.O": "494224",
      "Seoni B.O": "494224",
      "Sorgaon B.O": "494224",
      "Cherapur B.O": "494224",
      "Choteamabal B.O": "494224",
      "Gunpur B.O": "494224",
      "Khandsara B.O": "494224",
      "Murkuchi B.O": "494224",
      "Seoni  B.O": "494224",
      "Turpura B.O": "494224",
      "Barda B.O": "494222",
      "Chiurgaon B.O": "494222",
      "Jaitgiri B.O": "494222",
      "Sonpur B.O": "494222",
      "Karpawand  B.O": "494222",
      "Khotalapal B.O": "494222",
      "Lamker B.O": "494223",
      "Mongrapal B.O": "494223",
      "Retawand B.O": "494223",
      "Rotma B.O": "494223",
      "Talur B.O": "494223",
      "Badeamabal B.O": "494224",
      "Baniyagaon B.O": "494224",
      "Bhanpuri Basti B.O": "494224",
      "Chapka B.O": "494224",
      "Badealnar B.O": "494224",
      "Dimrapal B.O": "494001",
      "Fafni B.O": "494224",
      "Kongarpal B.O": "494224",
      "Kumhali  B.O": "494224",
      "Lawagaon B.O": "494224",
      "Munjla B.O": "494224",
      "Kumharawand B.O": "494001",
      "Kurenga B.O": "494001",
      "Titirgaon B.O": "494001",
      "Binta B.O": "494010",
      "Chhaparbhanpuri B.O": "494010",
      "Chitrakote B.O": "494010",
      "Ermur B.O": "494010",
      "Karanji B.O": "494001",
      "Singanpur B.O": "494001",
      "Badedharaur B.O": "494010",
      "Harrakoder B.O": "494441",
      "Badanji B.O": "494010",
      "Belar B.O": "494010",
      "Adawal B.O": "494001",
      "Dhanpunji B.O": "494001",
      "Hatkachora B.O": "494001",
      "Madpal B.O": "494001",
      "Dhaniyalur B.O": "494001",
      "Kaikagarh B.O": "494001",
      "Karkapal B.O": "494001",
      "Kawapal B.O": "494001",
      "Naktisemra B.O": "494001",
      "Takameta B.O": "494001",
      "Talnar B.O": "494221",
      "Karitgaon B.O": "494221",
      "Kudalgaon B.O": "494221",
      "Amaguda B.O": "494001",
      "Bademurma B.O": "494001",
      "Chitaloor B.O": "494001",
      "Markel B.O": "494001",
      "Netanaar B.O": "494001",
      "Chokawada B.O": "494001",
      "Garawandkhurd B.O": "494001",
      "Kakarwada B.O": "494001",
      "Kondaloor B.O": "494001",
      "Palli B.O": "494001",
      "Bademorathpal": "494001",
      "Gumalwada": "494001",
      "Kakarwada": "494001",
      "Potanar": "494001",
      "Ransargipal": "494001",
      "Takameta": "494001",
      "Chotedeoda B.O": "494221",
      "Tarapur B.O": "494221",
      "Dhobigudha B.O": "494221",
      "Babusemra B.O": "494001",
      "Nangur B.O": "494001",
      "Sadgud B.O": "494001",
      "Niyanaar B.O": "494001",
      "Gumalwada B.O": "494001",
      "Parpa B.O": "494001",
      "Ransargipal B.O": "494001",
      "Bhadisgaon": "494001",
      "Garawandkhurd": "494001",
      "Kaikagarh": "494001",
      "Karkapal": "494001",
      "Khamargaon": "494001",
      "Parpa": "494001",
      "Sidmud": "494001",
      "Kachnar B.O": "494221",
      "Ulnar B.O": "494221",
      "Dhodrepal B.O": "494221",
      "Kurandi B.O": "494001",
      "Nagarnaar B.O": "494001",
      "Pandripani B.O": "494001",
      "Bademorathpal B.O": "494001",
      "Bhadisgaon B.O": "494001",
      "Chhotekawali B.O": "494001",
      "Chitalgur B.O": "494001",
      "Khamargaon B.O": "494001",
      "Khutpadar B.O": "494001",
      "Potanar B.O": "494001",
      "Sidmud B.O": "494001",
      "Singanpur  B.O": "494001",
      "Chhotekawali": "494001",
      "Chitalgur": "494001",
      "Chokawada": "494001",
      "Dhaniyalur": "494001",
      "Kawapal": "494001",
      "Khutpadar": "494001",
      "Kondaloor": "494001",
      "Naktisemra": "494001",
      "Palli": "494001",
      "Bajawand B.O": "494221",
      "Kohkapal B.O": "494221",
      "Malgaon B.O": "494221",
      "Nalpawand B.O": "494221",
      "Jagdalpur H.O": "494001",
      "Asna S.O": "494221",
      "Dharampura S.O": "494001",
      "Lohandiguda S.O": "494010",
      "Bakawand S.O": "494222",
      "Jagdalpur Kutchery S.O": "494001",
      "Tongpal S.O": "494115",
      "Bastar S.O": "494223",
      "Bhanpuri S.O": "494224",
      "Jagdalpur Rly Colony S.O": "494001",
      "Jagdalpur Sadar Bzr S.O": "494001",
      "Tokapal Rajoor S.O": "494442"
    },
    "DANTEWADA": {
      "Badebedma B.O": "494552",
      "Bhusaras B.O": "494552",
      "Masenar B.O": "494552",
      "Pedka B.O": "494552",
      "Sameli B.O": "494552",
      "Koriras": "494552",
      "Etepal B.O": "494552",
      "Gadapal B.O": "494552",
      "Shyamgiri B.O": "494552",
      "Surnar B.O": "494552",
      "Gongpal": "494552",
      "Hitawar": "494552",
      "Lendra": "494552",
      "Maharakarka": "494552",
      "Mahrahaurnar": "494552",
      "Neelavaya": "494552",
      "Revali": "494552",
      "Toyalanka": "494552",
      "Gadmiri B.O": "494552",
      "Jabeli B.O": "494552",
      "Mailawada B.O": "494552",
      "Phulpad B.O": "494552",
      "Tikanpal B.O": "494552",
      "Dhanikarka": "494552",
      "Badegudra B.O": "494552",
      "Badelakhapal B.O": "494552",
      "Kuakonda B.O": "494552",
      "Mokhpal B.O": "494552",
      "Palnar B.O": "494552",
      "Telam B.O": "494552",
      "Kalepal": "494552",
      "PADHAPUR B.O": "494553",
      "Gamawada B.O": "494553",
      "Kumharras B.O": "494449",
      "Bhansi B.O": "494553",
      "DHURLI B.O": "494553",
      "BADAKAMELI B.O": "494553",
      "NERLI B.O": "494553",
      "Bache R.S. B.O": "494553",
      "Dugeli B.O": "494553",
      "Pharaspal B.O": "494449",
      "Pondoom B.O": "494449",
      "Teknar B.O": "494449",
      "Dhanikarka B.O": "494552",
      "Dabpal B.O": "494449",
      "Kamaloor B.O": "494449",
      "Kanwalnar B.O": "494449",
      "Katekalyan B.O": "494449",
      "Hitawar B.O": "494552",
      "Kalepal B.O": "494552",
      "Lendra B.O": "494552",
      "MARJUM B.O": "494449",
      "NETAPUR B.O": "494449",
      "Pandewar B.O": "494449",
      "Barsoor B.O": "494441",
      "Jawanga B.O": "494441",
      "BHATPAL B.O": "494441",
      "Chhotetumnar B.O": "494441",
      "Aranpur B.O": "494556",
      "Balpet B.O": "494449",
      "Kawadgaon B.O": "494449",
      "Matenar B.O": "494449",
      "Metapal B.O": "494449",
      "Aranpur  B.O": "494556",
      "Kadampal B.O": "494556",
      "Kurtem B.O": "494556",
      "Madadi B.O": "494556",
      "Koriras B.O": "494552",
      "Mahrahaurnar B.O": "494552",
      "Neelavaya B.O": "494552",
      "Tetam B.O": "494552",
      "JARAM B.O": "494449",
      "Tudparas B.O": "494449",
      "Ghotpal B.O": "494441",
      "BHOGAM B.O": "494449",
      "CHANDENAR B.O": "494449",
      "CHINTALANKA B.O": "494449",
      "CHITALUR B.O": "494449",
      "Chhindnar B.O": "494441",
      "Korgaon B.O": "494441",
      "Ronje B.O": "494441",
      "Shivanandashram B.O": "494441",
      "BADEPANEDA B.O": "494441",
      "KORKOTTI B.O": "494441",
      "MADSE B.O": "494441",
      "Muchnar B.O": "494441",
      "Upet B.O": "494441",
      "HAURNAR": "494441",
      "HIDPAL": "494441",
      "Jodatarai": "494441",
      "Kandoli": "494441",
      "MADSE": "494441",
      "Samlur": "494441",
      "Guphadi B.O": "494556",
      "Kakadi B.O": "494556",
      "Kirandul Hill Top B.O": "494556",
      "Kirandul R.S. B.O": "494556",
      "Kadampal": "494556",
      "Kurtem": "494556",
      "Madadi": "494556",
      "Nahadi": "494556",
      "Heeranar B.O": "494441",
      "Koshalnar B.O": "494441",
      "Bade Tumnar B.O.": "494441",
      "Bagmundi Panera  B.O": "494441",
      "BENGLUR B.O": "494441",
      "HAURNA B.O": "494441",
      "Jodatarai B.O": "494441",
      "NAGUL B.O": "494441",
      "Samlur B.O": "494441",
      "BADEPANEDA": "494441",
      "BHATPAL": "494441",
      "Muchnar": "494441",
      "Upet": "494441",
      "Bangali Camp B.O": "494556",
      "Gondras B.O": "494556",
      "Potali B.O": "494556",
      "Balood B.O": "494449",
      "Kuper B.O": "494449",
      "Parcheli B.O": "494449",
      "Gatam B.O.": "494449",
      "Hiroli B.O": "494556",
      "Kondasawli B.O": "494556",
      "Nahadi B.O": "494556",
      "Gongpal B.O": "494552",
      "Maharakarka B.O": "494552",
      "Revali B.O": "494552",
      "Toyalanka B.O": "494552",
      "Bagmundi Panera B.O": "494441",
      "Gumda B.O": "494441",
      "Karli B.O": "494441",
      "Korlapal B.O": "494441",
      "BADEKARLI B.O": "494441",
      "HIDPAL B.O": "494441",
      "Kandoli B.O": "494441",
      "MUSTALNAR B.O": "494441",
      "BADEKARLI": "494441",
      "KORKOTTI": "494441",
      "NAGUL": "494441",
      "Burgum B.O": "494556",
      "Gumyapal B.O": "494556",
      "Hiroli": "494556",
      "Dantewada S.O": "494449",
      "Nakulnar S.O": "494552",
      "Kirandul S.O": "494556",
      "Bacheli S.O": "494553",
      "Geedam S.O": "494441"
    },
    "JANJGIR-CHAMPA": {
      "Bargawan BO": "495554",
      "Sankar BO": "495552",
      "Kapan BO": "495552",
      "Dongri BO": "495559",
      "Sonthi BO": "495660",
      "Amora BO": "495663",
      "Bhaistara B.O": "495669",
      "Bodsara B.O": "495669",
      "Jarwe B.O": "495669",
      "Khaija B.O": "495669",
      "Kutra BO": "495668",
      "Munund BO": "495668",
      "Sarkhon B.O": "495669",
      "Taga BO": "495668",
      "Changori BO": "495552",
      "Katnai BO": "495552",
      "Kotmisonar BO": "495552",
      "Pandaria BO": "495552",
      "Piparsatti BO": "495552",
      "Bachhaud BO": "495559",
      "Budganan BO": "495559",
      "Konar BO": "495663",
      "Kosa BO": "495663",
      "Pahariya B.O": "495669",
      "Semra BO": "495668",
      "Seoni B.O": "495669",
      "Siud BO": "495668",
      "Sukli BO": "495668",
      "Khamaria BO": "495559",
      "Khisora BO": "495556",
      "Mahuda BO": "495671",
      "Ponch BO": "495559",
      "Rasota BO": "495554",
      "Amoda BO": "495668",
      "Dhaneli BO": "495668",
      "Dharasiv BO": "495668",
      "Dhurkot BO": "495692",
      "Hardi J B.O": "495669",
      "Hardi S BO": "495668",
      "Khokhra BO": "495668",
      "Khokhsa B.O": "495669",
      "Kuthur BO": "495668",
      "Arjuni BO": "495689",
      "Birkoni BO": "495552",
      "Pondidalha BO": "495552",
      "Jawalpur BO": "495559",
      "Mulmula BO": "495663",
      "Akaltari BO": "495668",
      "Banari BO": "495668",
      "Mahant BO": "495668",
      "Pendri BO": "495661",
      "Tilai BO": "495668",
      "Pirda BO": "495691",
      "Aurda BO": "495689",
      "Deori BO": "495689",
      "Jajang BO": "495689",
      "Portha BO": "495689",
      "Raipura BO": "495689",
      "Sakarra BO": "495689",
      "Sonadula BO": "495689",
      "Suloni BO": "495689",
      "Nawapara BO": "495691",
      "Pihrid BO": "495691",
      "Pota BO": "495691",
      "Lavsara BO": "495689",
      "Masaniakala BO": "495689",
      "Nandaurkhurd BO": "495689",
      "Sendri BO": "495690",
      "Singhansara BO": "495689",
      "Sirli BO": "495554",
      "Temar BO": "495689",
      "Kataud BO": "495557",
      "Kera BO": "495557",
      "Dumarpara BO": "495687",
      "Jarwe BO": "495687",
      "Jharna BO": "495687",
      "Kirari BO": "495692",
      "Kikirda BO": "495661",
      "Malda BO": "495661",
      "Parsada BO": "495661",
      "Amandula BO": "495689",
      "Nandaurkala BO": "495689",
      "Nariyara BO": "495691",
      "Singhra BO": "495691",
      "Barpalikala BO": "495689",
      "Gharghodi BO": "495689",
      "Ragja BO": "495689",
      "Choria BO": "495686",
      "Kirit BO": "495557",
      "Misda BO": "495557",
      "Faguram BO": "495695",
      "Kanwali BO": "495695",
      "Kusmul BO": "495695",
      "Tundri BO": "495695",
      "Kamrid BO": "495660",
      "Kapisda BO": "495660",
      "Karnaud BO": "495660",
      "Lakhali BO": "495660",
      "Reda BO": "495692",
      "Sakreli BO": "495688",
      "Sarhar BO": "495687",
      "Siladehi BO": "495661",
      "Gaud BO": "495671",
      "Katrenagar BO": "495671",
      "Bhathali BO": "495557",
      "Nawagarh BO": "495557",
      "Charoda BO": "495695",
      "Sapia BO": "495695",
      "Afrid BO": "495660",
      "Pondishankar BO": "495660",
      "Sarwani BO": "495660",
      "Nagarda BO": "495687",
      "Ghiwra BO": "495661",
      "Bilari BO": "495556",
      "Borda BO": "495556",
      "Bundela BO": "495556",
      "Dhardei BO": "495556",
      "Hasod BO": "495661",
      "Birgahni BO": "495671",
      "Hathnewra BO": "495671",
      "Kosmanda BO": "495671",
      "Khorsi BO": "495556",
      "Salkhan BO": "495556",
      "Tanod BO": "495556",
      "Kuriyari BO": "495556",
      "Loharsi BO": "495556",
      "Kachanda BO": "495690",
      "Rahod BO": "495556",
      "Dongakharod BO": "495554",
      "Kharkhod BO": "495554",
      "Kosir BO": "495554",
      "Pakaria BO": "495553",
      "Tarod BO": "495553",
      "Bhadra BO": "495554",
      "Meu BO": "495554",
      "Kansda BO": "495557",
      "Tusma BO": "495557",
      "Bandora BO": "495695",
      "Singhitarai BO": "495695",
      "Rohda BO": "495660",
      "Basti Baradwar BO": "495687",
      "Darang BO": "495687",
      "Muktaraja BO": "495687",
      "Harethikala BO": "495661",
      "Kaitha BO": "495661",
      "Semaria BO": "495661",
      "Taldeori BO": "495661",
      "Basantpur BO": "495671",
      "Godhna BO": "495556",
      "Sonsari BO": "495553",
      "Bhainso BO": "495554",
      "Kodabhat BO": "495554",
      "Kosla BO": "495554",
      "Sasha BO": "495554",
      "Puchheli BO": "495660",
      "Akoljamora BO": "495692",
      "Amaldiha BO": "495692",
      "Faraswani BO": "495688",
      "Kansa BO": "495688",
      "Kawaljhar BO": "495688",
      "Khondhar BO": "495688",
      "Saraskela BO": "495688",
      "Gatwa BO": "495446",
      "Bade Rabeli BO": "495691",
      "Seoni BO": "495671",
      "Baghod BO": "495692",
      "Barapipar BO": "495692",
      "Gopalpur BO": "495692",
      "Latesara BO": "495692",
      "Madwa BO": "495692",
      "Chhotekatekoni BO": "495688",
      "Churtela BO": "495688",
      "Sukhda BO": "495688",
      "Akalsara BO": "495690",
      "Bhothia BO": "495690",
      "Odekera BO": "495690",
      "Basin BO": "495691",
      "Khemda BO": "495691",
      "Kurda BO": "495691",
      "Pisaud BO": "495671",
      "Balpur BO": "495692",
      "Jawali BO": "495692",
      "Pithampur BO": "495671",
      "Girgira BO": "495692",
      "Pendarwa BO": "495692",
      "Sapos BO": "495692",
      "Churaghata BO": "495688",
      "Deorghata BO": "495688",
      "Sukhapali BO": "495688",
      "Kashigarh BO": "495690",
      "Charpara BO": "495691",
      "Chhapora BO": "495691",
      "Kotmi BO": "495692",
      "Salhe BO": "495692",
      "Pantora BO": "495446",
      "Amgaon BO": "495690",
      "Beladula BO": "495690",
      "Jhalraundha BO": "495690",
      "Katetara BO": "495690",
      "Khajurani BO": "495690",
      "Salni BO": "495690",
      "Thathari BO": "495690",
      "Tusar BO": "495690",
      "Amlidih BO": "495691",
      "Mukta BO": "495691",
      "Bade Seepat BO": "495691",
      "Marghatti BO": "495691",
      "Nariyara SO": "495553",
      "Adbhar SO": "495695",
      "Baradwar SO": "495687",
      "Champa SO": "495671",
      "Dabhra SO": "495688",
      "Chandrapur SO Janjgirchampa": "495692",
      "Malkharoda SO": "495691",
      "Sakti SO": "495689",
      "Saragaon SO": "495686",
      "Kharod SO": "495556",
      "Birra SO": "495661",
      "Jaijaipur SO": "495690",
      "VIDYUT NAGAR LACHHANPUR S.O.": "495669",
      "Naila RS SO": "495668",
      "Pamgarh SO": "495554",
      "Seorinarayan SO": "495557",
      "Bamhni Bazar SO": "495660",
      "Champa RS SO": "495671",
      "Janjgir HO": "495668",
      "Akaltara SO": "495552",
      "Gopal Nagar SO Chattisgarh Circle": "495663",
      "Baloda SO": "495559"
    },
    "MUNGELI": {
      "Badrathakur BO": "495224",
      "Sargaon BO": "495224",
      "Achanakmar BO": "495113",
      "Baitalpur BO": "495224",
      "Padampur BO": "495330",
      "Birgaon BO": "495330",
      "Dashrangpur BO": "495330",
      "Amora BO": "495330",
      "Barela BO": "495330",
      "Jarhagaon BO": "495330",
      "Pharhada BO": "495330",
      "Dindori BO": "495115",
      "Dongariya BO": "495115",
      "Ghanaghat BO": "495115",
      "Salheghori BO": "495115",
      "Sardha BO": "495115",
      "Sukli BO": "495115",
      "Bijatarai BO": "495334",
      "Chakrabhatha BO": "495334",
      "Chhatan BO": "495334",
      "Gidha BO": "495334",
      "Kanteli BO": "495334",
      "Karhi BO": "495334",
      "Lalpur BO": "495334",
      "Manoharpur BO": "495334",
      "Pawanikala BO": "495334",
      "Baigakapa BO": "495115",
      "Barampur BO": "495115",
      "Bodtara BO": "495115",
      "Chilfi BO": "495115",
      "Khaprikala BO": "495115",
      "Khudia BO": "495115",
      "Ramhepur BO": "495115",
      "Chhindbhog BO": "495334",
      "Chirhula BO": "495334",
      "Donda BO": "495334",
      "Nawagaon BO": "495334",
      "Nawaspur BO": "495334",
      "Rajpur S BO": "495334",
      "Terhadhaura BO": "495334",
      "Hathanikala BO": "495334",
      "Goindri BO": "495335",
      "Jareli BO": "495335",
      "Kukusda BO": "495335",
      "Akhrar BO": "495115",
      "Chandeli BO": "495115",
      "Daukapa BO": "495115",
      "Jhajhpurikala BO": "495115",
      "Kotri BO": "495115",
      "Nawadih BO": "495115",
      "Siltara BO": "495335",
      "Sonthi M BO": "495335",
      "Lauda BO": "495335",
      "Pandiyain BO": "495335",
      "Punchheli BO": "495335",
      "Banki BO": "495334",
      "Dharampura BO": "495334",
      "Fasterpur BO": "495334",
      "Khairwar BO": "495334",
      "Kosamtara BO": "495334",
      "Nirjam BO": "495334",
      "Puran BO": "495334",
      "Bhatgaon BO": "495335",
      "Sildaha BO": "495335",
      "Dhangaongosai BO": "495330",
      "Semarsal BO": "495330",
      "Deorhat BO": "495115",
      "Fulwari BO": "495115",
      "Jhapal BO": "495115",
      "Khamhi BO": "495115",
      "Lagra BO": "495115",
      "Surhi BO": "495115",
      "Bhalapur BO": "495334",
      "Bhalukhondhra BO": "495334",
      "Deori BO": "495334",
      "Karesara BO": "495334",
      "Kodwa BO": "495334",
      "Pandarbhattha BO": "495334",
      "Phandwani BO": "495334",
      "Badrabukhari BO": "495335",
      "Mungeli SO": "495334",
      "Patharia SO": "495335",
      "Lormi SO": "495115"
    },
    "KANKER": {
      "Karmoti B.O": "494635",
      "Salhe B.O": "494635",
      "Chichgaon": "494635",
      "Chihro": "494635",
      "Jhitkatola": "494635",
      "Karathi": "494635",
      "Budeli B.O": "494335",
      "Kotalbhatti B.O": "494335",
      "Thema B.O": "494335",
      "Lendara": "494335",
      "Sarwandi B.O": "494335",
      "Chawad B.O": "494334",
      "Aridongri B.O": "494635",
      "Damkasa B.O": "494635",
      "Hatkondal B.O": "494635",
      "Jodekursi B.O": "494635",
      "Traighotiya B.O": "494635",
      "Amakada": "494635",
      "Iragaon": "494635",
      "Parekodo": "494635",
      "Raurwahi": "494635",
      "Shivini": "494635",
      "Samtara B.O": "494335",
      "Saimunda": "494335",
      "Banspattar": "494335",
      "Barheli": "494635",
      "Bhainsakanhar A": "494635",
      "Chwela": "494635",
      "Dabkatta": "494635",
      "Parbhali": "494635",
      "Abhanpur B.O": "494335",
      "Dudhawa B.O": "494335",
      "Largaon Markatola B.O": "494335",
      "Mavlipara B.O": "494335",
      "Lohattar B.O": "494635",
      "Tarhul B.O": "494635",
      "Bogar": "494635",
      "Chindgaon": "494635",
      "Kalangpuri": "494635",
      "Dhanesara B.O": "494335",
      "Ghotiyavahi": "494335",
      "Mode B.O": "494670",
      "Parsoda B.O": "494670",
      "Selegaon B.O": "494670",
      "Sahawada B.O": "494336",
      "Tarasgaon B.O": "494336",
      "Kariha": "494336",
      "Palewa": "494336",
      "Kurna": "494336",
      "Salebhat": "494336",
      "Badal B.O": "494333",
      "Bhansuli B.O": "494333",
      "Jamgaon B.O": "494333",
      "Kishanpuri B.O": "494333",
      "Marwadi B.O": "494333",
      "Barda B.O": "494776",
      "Hanker B.O": "494776",
      "Mixesed Form B.O": "494776",
      "Pratappur B.O": "494776",
      "PV 15 B.O": "494776",
      "Ghodagaon": "494776",
      "Hariharpur": "494776",
      "Jaipur": "494776",
      "Jaishrinagar": "494776",
      "Kalyanpur": "494776",
      "Penkodo": "494776",
      "Shripur": "494776",
      "Shyamnagar": "494776",
      "Dhanelikanhar B.O": "494670",
      "Kanharpuri B.O": "494670",
      "Kottara B.O": "494670",
      "Potgaon B.O": "494670",
      "Sureli B.O": "494670",
      "Bhainsakanhar B.O": "494670",
      "Khartha B.O": "494336",
      "Nathianawagaon B.O": "494336",
      "Tuyegahan B.O": "494336",
      "Devinawagaon B.O": "494333",
      "Dumarpani B.O": "494333",
      "Esebeda B.O": "494776",
      "Baijanpuri B.O": "494670",
      "Tarandul B.O": "494670",
      "Aalbeda": "494670",
      "Andi": "494670",
      "Chinauri B.O": "494336",
      "Haradula B.O": "494336",
      "Jepra B.O": "494336",
      "Amoda B.O": "494333",
      "Bagdongri": "494333",
      "Biranpur": "494333",
      "PV 26 B.O": "494776",
      "PV 38 B.O": "494776",
      "PV 9 B.O": "494776",
      "Chandipur": "494776",
      "Dhorkatta": "494776",
      "Durgapur": "494776",
      "Karekatta": "494776",
      "Machpalli": "494776",
      "Matoli": "494776",
      "Mayapur": "494776",
      "Baikunth Pur": "494776",
      "Lakhanpur": "494776",
      "Purushottamnagar": "494776",
      "Satyanagar": "494776",
      "Bhanbeda B.O": "494670",
      "Hatkarra B.O": "494670",
      "Kodagaon B.O": "494670",
      "Markatola B.O": "494670",
      "Talakurra B.O": "494670",
      "Babudabena": "494670",
      "Khairkeda B.O": "494336",
      "Kotela B.O": "494336",
      "Udkuda B.O": "494336",
      "Dabena B.O": "494333",
      "Geetpahar B.O": "494333",
      "Gondahoor B.O": "494776",
      "Sangam B.O": "494776",
      "Balrampur": "494776",
      "Bhingidar": "494776",
      "Krishnanagar": "494776",
      "Laxmipur": "494776",
      "RamKrishnaPur": "494776",
      "Ravindranagar": "494776",
      "Vanshri Nagar": "494776",
      "Manpur B.O": "494334",
      "Murdongri B.O": "494334",
      "Murvend B.O": "494334",
      "Pidapal B.O": "494334",
      "Puswada B.O": "494334",
      "Chargaon B.O": "494665",
      "Gudabeda B.O": "494665",
      "Koyalibeda B.O": "494665",
      "Panidober B.O": "494665",
      "Pondgaon B.O": "494665",
      "Amagaon BO": "494665",
      "Kanagoan BO": "494665",
      "Kosronda BO": "494665",
      "Masbaras BO": "494665",
      "Talabeda BO": "494665",
      "Temrupani BO": "494665",
      "Kurenar B.O": "494777",
      "Maroda B.O": "494777",
      "Nagaldand B.O": "494777",
      "Padenga B.O": "494777",
      "Dharampur BO": "494777",
      "Asulkhar B.O": "494669",
      "Bhiragaon B.O": "494669",
      "Bagodar B.O": "494334",
      "Chiprel B.O": "494334",
      "Deori B.O": "494334",
      "Dumali B.O": "494334",
      "Hatkongera B.O": "494334",
      "Sidhesar B.O": "494334",
      "Bhainsasur B.O": "494665",
      "Bondanar B.O": "494665",
      "Bulawand BO": "494665",
      "Dadbisalhebhat BO": "494665",
      "Godari BO": "494665",
      "Hindu Binapal BO": "494665",
      "Jethegaon BO": "494665",
      "Kadhai Khodara BO": "494665",
      "Kandadi BO": "494777",
      "Saver BO": "494777",
      "Kodapakha B.O": "494669",
      "Kodekurse B.O": "494669",
      "Kulhadkatta B.O": "494669",
      "Aturgaon B.O": "494334",
      "Bewarti B.O": "494334",
      "Kokpur B.O": "494334",
      "Pataud B.O": "494334",
      "Amodi B.O": "494665",
      "Kamta B.O": "494665",
      "Kodosalhebhat B.O": "494665",
      "Tadoki B.O": "494665",
      "Kaleparas BO": "494665",
      "Kamtera BO": "494665",
      "Mandagaon BO": "494771",
      "PV 92 B.O": "494777",
      "Tekameta B.O": "494777",
      "Shankar Nagar BO": "494777",
      "Vishnupur BO": "494777",
      "Durgkondal B.O": "494669",
      "Kewti B.O": "494669",
      "Bhandardigi BO": "494669",
      "Makdisingrai B.O": "494334",
      "Mardapoti B.O": "494334",
      "Umradah B.O": "494334",
      "Vyas Kongera B.O": "494334",
      "Hurtarai B.O": "494665",
      "Kolar B.O": "494665",
      "Sarandi B.O": "494665",
      "Siksod B.O": "494665",
      "Alparas BO": "494665",
      "Kadme BO": "494665",
      "Kalgaon BO": "494665",
      "Mangta Salhebhat BO": "494665",
      "Porondi BO": "494665",
      "Erpanar B.O": "494777",
      "Panwar B.O": "494777",
      "Rengawahi B.O": "494777",
      "Hanumanpur BO": "494777",
      "Vijaynagar BO": "494777",
      "Vikaspalli BO": "494777",
      "Dangra B.O": "494669",
      "Karaki B.O": "494669",
      "Ghotha BO": "494669",
      "Godpal BO": "494669",
      "Hanpatri BO": "494669",
      "Saradhu Dhamre BO": "494669",
      "Shinhari BO": "494669",
      "Bhilai B.O": "494337",
      "Charbhata B.O": "494337",
      "Dokla B.O": "494337",
      "Jaisakarra B.O": "494337",
      "Junwani B.O": "494334",
      "Puri B.O": "494337",
      "Badejharkatta B.O": "494771",
      "Hamatwahi BO": "494771",
      "Irakbutta BO": "494771",
      "Michgaon Sadhu B.O": "494669",
      "Kanhargaon BO": "494669",
      "Konde BO": "494669",
      "Otekasa BO": "494669",
      "Sonekanhar BO": "494669",
      "Surungdoh BO": "494669",
      "Lilejhar B.O": "494337",
      "Chawadi BO": "494337",
      "Navagaon BO": "494337",
      "Donde B.O": "494771",
      "Khairkatta B.O": "494771",
      "Chikhli BO": "494771",
      "Koygaon BO": "494771",
      "Karramad BO": "494669",
      "Khutgaon BO": "494669",
      "Pevari BO": "494669",
      "Pharaskot BO": "494669",
      "Koliyari B.O": "494337",
      "Gurwandi B.O": "494771",
      "Nedgaon B.O": "494771",
      "Alor BO": "494771",
      "Murabandi BO": "494771",
      "Pachangi BO": "494771",
      "Pittebhodiya BO": "494771",
      "Prem Nagar BO": "494771",
      "Mandri BO": "494334",
      "Pusawand BO": "494334",
      "Bangachar BO": "494669",
      "Chougel BO": "494669",
      "Gudum BO": "494669",
      "Janakpur BO": "494669",
      "Kondrunj BO": "494669",
      "Medo BO": "494669",
      "Sukhai BO": "494669",
      "Anwari B.O": "494337",
      "Kurrutola B.O": "494337",
      "Badegauri BO": "494337",
      "Mayana BO": "494337",
      "Badgaon B.O": "494771",
      "Devpur BO": "494771",
      "Madle BO": "494771",
      "Mangahoor BO": "494771",
      "Yashwantnagar BO": "494771",
      "Anjani BO": "494334",
      "Viveka Nand Nagar BO": "494771",
      "Bhirawahi BO": "494334",
      "Neelegondi BO": "494334",
      "Tultuli BO": "494334",
      "Kanker H.O": "494334",
      "Antagarh S.O": "494665",
      "Charama S.O": "494337",
      "Narharpur S.O": "494333",
      "Pakhanjore Camp S.O": "494776",
      "Sarona S.O": "494335",
      "Bandecolony S.O": "494777",
      "Korar S.O": "494670",
      "Sambalpur S.O": "494635",
      "Bhanupratappur S.O": "494669",
      "Chotekapsi S.O": "494771",
      "Kanker Kutchery S.O": "494334",
      "Lakhanpuri S.O": "494336",
      "Govindpur S.O.": "494332"
    },
    "SUKMA": {
      "Burdi B.O": "494111",
      "Korra B.O": "494111",
      "Sonakuknar B.O": "494111",
      "Urmapal B.O": "494111",
      "Idjepal B.O": "494115",
      "Koleng B.O": "494115",
      "Kundanpal B.O": "494115",
      "Michwar B.O": "494115",
      "Gumadpal B.O": "494115",
      "Tumakpal B.O": "494115",
      "Gadiras B.O": "494111",
      "Jeerampal B.O": "494111",
      "Jhapra B.O": "494111",
      "Kanjipani B.O": "494111",
      "Pakela B.O": "494111",
      "Ramaram B.O": "494111",
      "Gongla B.O": "494111",
      "Ganjenar": "494111",
      "Chandangiri B.O": "494115",
      "Chindawada B.O": "494115",
      "Gorli B.O": "494115",
      "Sautnar B.O": "494115",
      "Bodaras B.O": "494115",
      "Pedaras B.O": "494115",
      "Bodaras": "494115",
      "Talnar B.O": "494111",
      "Chingawaram B.O": "494111",
      "Murtonda B.O": "494111",
      "Ganjenar B.O": "494111",
      "Pendalnar B.O": "494115",
      "Chandragiri B.O": "494115",
      "Bispur B.O": "494115",
      "Bokdaodar": "494115",
      "Badesatti B.O": "494111",
      "Chhindgarh B.O": "494111",
      "Kodripal B.O": "494111",
      "Pondum B.O": "494111",
      "Rokel B.O": "494111",
      "Gongla": "494111",
      "Badegadam B.O": "494115",
      "Hameergarh B.O": "494115",
      "Kunna B.O": "494115",
      "Bokdaodar B.O": "494115",
      "Kakalgur B.O": "494115",
      "Kankapal B.O": "494115",
      "Tahakwada B.O": "494115",
      "Bispur": "494115",
      "Gumadpal": "494115",
      "Kakalgur": "494115",
      "Kankapal": "494115",
      "Pedaras": "494115",
      "Tahakwada": "494115",
      "Tumakpal": "494115",
      "Jagargunda B.O": "494122",
      "Nagaram B.O": "494122",
      "Polampalli  B.O": "494122",
      "Burklanka B.O": "494114",
      "Argatta B.O": "494122",
      "Gondpalli B.O": "494122",
      "Kerlapal B.O": "494122",
      "Polampalli B.O": "494122",
      "Pongabheji B.O": "494122",
      "Chikpal B.O": "494122",
      "Chintagupha B.O": "494122",
      "Dubbatota B.O": "494122",
      "Gogunda B.O": "494122",
      "Gaganpalli B.O": "494114",
      "Banda B.O": "494114",
      "Errabore B.O": "494114",
      "Injeram B.O": "494114",
      "Mehta B.O": "494114",
      "Chintalnar B.O": "494122",
      "Misma B.O": "494122",
      "Sirsitti B.O": "494122",
      "Bheji B.O": "494114",
      "Gollapalli B.O": "494114",
      "Kistaram B.O": "494114",
      "Dornapal S.O": "494122",
      "Konta S.O": "494114",
      "Sukma S.O": "494111"
    },
    "RAJNANDGAON": {
      "Pendri BO": "491441",
      "Arjuni BO": "491441",
      "Dania BO": "491888",
      "Pailimeta BO": "491888",
      "Totalbharri BO": "491445",
      "Rengakathera BO": "491668",
      "Sahaspur BO": "491445",
      "Ataria BO": "491888",
      "Rampur BO": "491557",
      "Purena BO": "491885",
      "Saltikri BO": "491445",
      "Thakurtola BO": "491888",
      "Bundeli BO": "491888",
      "Brahmanbhendi BO": "491668",
      "Dongargaon  BO": "491668",
      "Tatekasa BO": "491557",
      "Dokrabhat BO": "491885",
      "Khudmudi BO": "491885",
      "Kusmi Ataria BO": "491885",
      "Kuthelikala BO": "491885",
      "Gatapar BO": "491885",
      "Ghirgholi BO": "491885",
      "Urtuli BO": "491885",
      "Khobha BO": "491558",
      "Kokpur BO": "491558",
      "Ramtarai BO": "491558",
      "Kolihalamti BO": "491558",
      "Nadiyakhurd BO": "491558",
      "Ramatola BO": "491557",
      "Tendunala BO": "491557",
      "Mahrajpur BO": "491557",
      "Vicharpur Nawagaon BO": "491557",
      "Gidarri BO": "491661",
      "Godalwahi BO": "491661",
      "Kanharpuri BO": "491441",
      "Singhola BO": "491441",
      "Jhitiya BO": "491668",
      "Salhe kusumkasa BO": "491668",
      "Mirche BO": "491668",
      "Keshal BO": "491668",
      "Padmawatipur BO": "491885",
      "Sakha BO": "491885",
      "Udaipur BO": "491885",
      "Kusmi BO": "491885",
      "Asra BO": "491558",
      "Bamhani Charbhata BO": "491558",
      "Aaliwara BO": "491445",
      "Bhandarpur BO": "491445",
      "Ghupsal BO": "491668",
      "Jhadikhairi BO": "491558",
      "Lammeta BO": "491558",
      "Tipangarh BO": "491558",
      "Bagrekasa BO": "491557",
      "Charbhata BO": "491668",
      "Kothitola BO": "491557",
      "Jhinjhari BO": "491557",
      "Lalutola BO": "491557",
      "Nagarkohara BO": "491557",
      "Patekohara BO": "491557",
      "Telibandha BO": "491557",
      "Khursipar BO": "491661",
      "Rudgaon BO": "491661",
      "Umarwahi BO": "491661",
      "Kirgi  BO": "491441",
      "Deokatta BO": "491445",
      "Jatkanhar BO": "491445",
      "Mohara BO": "491445",
      "Murmunda BO": "491445",
      "Barnalakala BO": "491445",
      "Tirpemeta BO": "491668",
      "Maroda BO": "491885",
      "Khapri BO": "491885",
      "Kotara BO": "491885",
      "Bholapur BO": "491558",
      "Gaindatola BO": "491558",
      "Shikari Mahka BO": "491558",
      "Joshilamti BO": "491558",
      "Bital BO": "491558",
      "Kamhera BO": "491558",
      "Markakasa BO": "491558",
      "Bagnadi BO": "491557",
      "Jhithratola BO": "491557",
      "Lalbahadur Nagar BO": "491557",
      "Tappa BO": "491557",
      "Bhagwantola BO": "491557",
      "Burhan Chhapar BO": "491557",
      "Motipur BO": "491665",
      "Munglani BO": "491557",
      "Tilirawar BO": "491557",
      "Khursitikul BO": "491661",
      "Mathaldabri BO": "491661",
      "Laxman Bharda BO": "491661",
      "Chiddo BO": "491445",
      "Dhara BO": "491445",
      "Medha BO": "491445",
      "Musra BO": "491445",
      "Patpar BO": "491445",
      "Bhainsara BO": "491445",
      "Chauthena BO": "491445",
      "Khujji BO": "491661",
      "Maneri  BO": "491661",
      "Amlidih Tolagaon  BO": "491661",
      "Ratapayli  BO": "491661",
      "Arajkund  BO": "491661",
      "Barbaspur  BO": "491661",
      "Parewadih  BO": "491661",
      "Pangrikhurd BO": "491661",
      "Bhothli BO": "491445",
      "Bortalo BO": "491445",
      "Bachherabhatha BO": "491445",
      "Dhandongri BO": "491557",
      "Kalkasa BO": "491444",
      "Mundgaon BO": "491445",
      "Palandur BO": "491445",
      "Dodke BO": "491668",
      "Kusumkasa BO": "491668",
      "Haidalkodo  BO": "491668",
      "Renutola BO": "491668",
      "RAGRA BO": "491885",
      "Bhimpuri BO": "491885",
      "Birodi BO": "491885",
      "Joratari BO": "491885",
      "Junwani BO": "491885",
      "Buchatola BO": "491558",
      "Kallubanjari BO": "491558",
      "Salhetola BO": "491558",
      "Bharritola BO": "491665",
      "Gerughat BO": "491558",
      "Ghotiya BO": "491558",
      "Job BO": "491558",
      "Madian BO": "491557",
      "Sadak Chirchari BO": "491557",
      "Sitagota BO": "491557",
      "Pinkapar BO": "491557",
      "Pirutola BO": "491557",
      "Atargaon BO": "491661",
      "Diwanbhedi BO": "491661",
      "Mahrum BO": "491661",
      "Gungeri Navagaon  BO": "491661",
      "Salhe  BO": "491661",
      "Pendarvani  BO": "491661",
      "Badgaon  BO": "491661",
      "Charbhata B  BO": "491661",
      "Kanpa  BO": "491661",
      "Karmari  BO": "491661",
      "Andi BO": "491445",
      "Dongargarh Rly Colony BO": "491445",
      "Paragaonkhurd BO": "491445",
      "Khallari BO": "491445",
      "Kotnapani BO": "491445",
      "Khaira BO": "491444",
      "Mudhipar BO": "491441",
      "Pandadah BO": "491881",
      "Piparia BO": "491881",
      "Singarghat BO": "491881",
      "Nawagaon BO": "491229",
      "Piplakachhar BO": "491881",
      "Uraidabri BO": "491881",
      "Vikrampur BO": "491881",
      "Aundhi BO": "491229",
      "Salhe BO": "491229",
      "Tumdikasa BO": "491229",
      "Mokasa BO": "491229",
      "Kande BO": "491666",
      "Kumhali BO": "491666",
      "Mukadah BO": "491666",
      "Somatola BO": "491666",
      "Mandla BO": "491881",
      "Aamdani BO": "491881",
      "Achholi BO": "491881",
      "Gahiratola BO": "491881",
      "Gumanpur BO": "491881",
      "Jhikadah BO": "491881",
      "Manpur BO": "491888",
      "Sahaspur Dalli BO": "491444",
      "Sirsahi BO": "491444",
      "Baldeopur BO": "491881",
      "Chicholatolagaon BO": "491881",
      "Deori BO": "491881",
      "Deoribhat BO": "491881",
      "Badhaitola BO": "491881",
      "Bendridih BO": "491881",
      "Damari BO": "491881",
      "Gadaghat BO": "491881",
      "Jurlakhurd BO": "491881",
      "Limtara BO": "491881",
      "Prakashpur BO": "491881",
      "Saliha BO": "491881",
      "Sankra BO": "491881",
      "Tekapar BO": "491881",
      "Dokala BO": "491229",
      "Nedgaon BO": "491229",
      "Seoni BO": "491229",
      "Kadekasa BO": "491229",
      "Bagdongri  BO": "491229",
      "Saroli BO": "491229",
      "Dumartola BO": "491666",
      "Kakaipar BO": "491666",
      "Ramgarh  BO": "491666",
      "Sonbhatta BO": "491444",
      "Thelkadih BO": "491444",
      "Itar BO": "491881",
      "Chagurda BO": "491881",
      "Khairbana BO": "491881",
      "Khajari BO": "491881",
      "Kohkabod BO": "491881",
      "Mudpar BO": "491668",
      "Bhawsha BO": "491229",
      "Dighwadi BO": "491229",
      "Sarkheda BO": "491229",
      "Sitagaon BO": "491229",
      "Fulkodo BO": "491229",
      "Koraldand BO": "491229",
      "Morchul  BO": "491229",
      "Kosmi BO": "491229",
      "Kandadi BO": "491229",
      "Korramtola BO": "491666",
      "Panabaras BO": "491666",
      "Mungadih  BO": "491666",
      "Birjhutola BO": "491666",
      "Kamtha BO": "491881",
      "Katangikhurd BO": "491881",
      "Khamhardih BO": "491881",
      "Madanpur BO": "491881",
      "Sandi BO": "491881",
      "Ghotia BO": "491229",
      "Khadgaon BO": "491229",
      "Kumhari BO": "491229",
      "Teregaon BO": "491229",
      "Tohe BO": "491229",
      "Kaneli BO": "491229",
      "Navagaon  BO": "491441",
      "Kahgaon  BO": "491229",
      "Markeli  BO": "491229",
      "Alkanhar BO": "491666",
      "Gotatola BO": "491666",
      "Umarpal  BO": "491666",
      "Bhainsbod  BO": "491666",
      "Urjhe BO": "491666",
      "Badratola BO": "491668",
      "Sitakasa BO": "491668",
      "Turregarh BO": "491668",
      "Dhangaon BO": "491441",
      "Sinagarpur  BO": "491888",
      "DarbanTola  BO": "491888",
      "Masulgondi  BO": "491888",
      "Sahaspur  BO": "491888",
      "Saraipatera  BO": "491888",
      "Nagaldah BO": "491444",
      "Patewa BO": "491444",
      "Saloni BO": "491444",
      "Uparwah BO": "491444",
      "Baghmarra BO": "491444",
      "Barbaspur BO": "491444",
      "Irai BO": "491444",
      "Baghera BO": "491441",
      "Bajrangpur Nawagaon BO": "491441",
      "Bakal BO": "491441",
      "Dumardihkhurd BO": "491441",
      "Karamtara BO": "491441",
      "Khaprikhurd BO": "491441",
      "Parrikala  BO": "491441",
      "Boirdih  BO": "491441",
      "Sonesarar BO": "491441",
      "Bhathagaon  BO": "491441",
      "Fuljhar  BO": "491441",
      "Dhiri BO": "491441",
      "Torankatta  BO": "491441",
      "Keshala  BO": "491441",
      "Parsashi  BO": "491888",
      "Achanakpur  BO": "491888",
      "Bakarkatta  BO": "491888",
      "Banzarpur  BO": "491888",
      "Mohgaon  BO": "491888",
      "Bijetala BO": "491444",
      "Singarpur BO": "491444",
      "Nachaniya  BO": "491888",
      "kharra  BO": "491888",
      "Biranpur  BO": "491888",
      "Ghotha  BO": "491888",
      "Bhainstara BO": "491444",
      "Gataparkala BO": "491444",
      "Bhothi BO": "491444",
      "Bilhari BO": "491444",
      "Jalbandha BO": "491444",
      "Salhewara BO": "491888",
      "Belgaon  BO": "491888",
      "Khaira  BO": "491888",
      "Bhajidongari  BO": "491888",
      "Golardih  BO": "491888",
      "Samundpani  BO": "491888",
      "Mahrumkala BO": "491444",
      "Charbhatha BO": "491444",
      "Dilapahari BO": "491441",
      "Lakholi BO": "491441",
      "Mangata BO": "491441",
      "Surgi BO": "491441",
      "Tumdilewa BO": "491441",
      "Pendri  BO": "491441",
      "Kanhardabri  BO": "491441",
      "Riwagahan  BO": "491441",
      "Teka  BO": "491441",
      "Dangarh BO": "491665",
      "Wasadi BO": "491665",
      "Bagnara  BO": "491665",
      "Mandavitola BO": "491665",
      "Sangali(Marri) BO": "491665",
      "Chikhli BO": "491668",
      "Chilhati BO": "491668",
      "Dautola BO": "491668",
      "Bharregaon BO": "491441",
      "Bori BO": "491441",
      "Haldi BO": "491441",
      "Padumtara BO": "491441",
      "Tedesara BO": "491441",
      "Ruvatala  BO": "491441",
      "Bharda  BO": "491441",
      "Aargaon  BO": "491441",
      "Bhothipar  BO": "491441",
      "Dhodhiya  BO": "491441",
      "Arajkund BO": "491665",
      "Bhadsena BO": "491665",
      "Marri BO": "491665",
      "Biharikala  BO": "491665",
      "Patanvadwi BO": "491665",
      "Amgaon BO": "491668",
      "Banhardi  BO": "491441",
      "Singpur  BO": "491441",
      "Usribod  BO": "491441",
      "Ranitarai  BO": "491441",
      "Mahud Machandur BO": "491665",
      "Sangali Ambagarh chowki  BO": "491665",
      "Kektitola  BO": "491665",
      "Parsatola  BO": "491665",
      "Devarsur  BO": "491665",
      "Patankhas BO": "491665",
      "Kulhardoh BO": "491665",
      "Belargondi BO": "491668",
      "Bhedikala BO": "491441",
      "Jangalpur BO": "491441",
      "Paneka BO": "491441",
      "Somni BO": "491441",
      "Tumdibod BO": "491441",
      "Sundara BO": "491441",
      "Parasbod  BO": "491441",
      "Magarlota  BO": "491441",
      "Kopedih  BO": "491441",
      "Kasari  BO": "491441",
      "Indamara BO": "491441",
      "Ghorda BO": "491441",
      "Mungaon  BO": "491441",
      "Hardi  BO": "491441",
      "Bhanwarmara  BO": "491441",
      "Dhamansara  BO": "491441",
      "Chachanpahari BO": "491665",
      "Kaudikasa BO": "491665",
      "Piparkhar  BO": "491665",
      "Gaulitola  BO": "491665",
      "Keshla BO": "491665",
      "Butakasa BO": "491665",
      "Taramtola BO": "491665",
      "Bhojtola BO": "491665",
      "Amatola BO": "491668",
      "Chircharikala BO": "491668",
      "Jadutola BO": "491668",
      "Korchatola BO": "491668",
      "Kumarda BO": "491668",
      "Rajnandgaon HO": "491441",
      "Bazar Rajnadngaon SO": "491441",
      "Chhuria SO": "491558",
      "Dongargarh SO": "491445",
      "G G Chowk Rajnandgaon SO": "491441",
      "Khairagarh Raj SO": "491881",
      "Ambagarh Chowki SO": "491665",
      "Dongargaon SO": "491661",
      "Manpur SO": "491229",
      "Rajnandgaon Kutchery SO": "491441",
      "Rajnandgaon Stadium SO": "491441",
      "Chhuikhadan SO": "491885",
      "Bandha Bazar SO": "491668",
      "Chichola SO": "491557",
      "Gandai Pandaria SO": "491888",
      "Ghumka SO": "491444",
      "Mohla SO": "491666"
    },
    "BIJAPUR": {
      "Cherpalli B.O": "494448",
      "Dudheda (Kottaguda) B.O": "494448",
      "GORLA": "494448",
      "MINKAPLLI": "494448",
      "Pegdapalli": "494448",
      "CHERAKDODI": "494448",
      "Chinnakawali B.O": "494448",
      "Kandulnar B.O": "494448",
      "ANGAMPALLI": "494448",
      "KESAIGUDA": "494448",
      "Modakpal B.O": "494448",
      "Pamgal B.O": "494448",
      "Pusgudi B.O": "494448",
      "Sankanpalli B.O": "494448",
      "DAMPAYA": "494448",
      "USKALED": "494448",
      "Lanka": "494661",
      "GORLA B.O": "494448",
      "MINKAPLLI B.O": "494448",
      "Pegdapalli B.O": "494448",
      "ARJUNALI B.O": "494446",
      "DAMMUR B.O": "494446",
      "GOLLAGUDA B.O": "494446",
      "GULLAPENTA B.O": "494446",
      "Badekakler B.O": "494450",
      "Cherpal B.O": "494444",
      "Dhanora B.O": "494444",
      "DAMPAYA B.O": "494448",
      "USKALED B.O": "494448",
      "BAMANPUR B.O": "494446",
      "GOTAIGUDA B.O": "494446",
      "Vadla B.O": "494446",
      "CHERAKDODI B.O": "494448",
      "KESAIGUDA B.O": "494448",
      "BARDALI B.O": "494446",
      "CHIPURBHATTI B.O": "494447",
      "Jarapalli B.O": "494447",
      "Kanchal B.O": "494447",
      "Konndapalli B.O": "494447",
      "Korsaguda B.O": "494447",
      "Gudma B.O": "494444",
      "Kutru B.O": "494444",
      "Lanka B.O": "494444",
      "Pusbaka B.O": "494447",
      "Engpalli B.O": "494447",
      "Kottur B.O": "494447",
      "Lingagiri B.O": "494447",
      "TARREM B.O": "494447",
      "UDTAMALLA B.O": "494447",
      "Mirtur B.O": "494441",
      "Ambeli B.O": "494450",
      "Bechepal B.O": "494450",
      "chinger B.O": "494450",
      "EETAMPAR B.O": "494450",
      "jaigur B.O": "494450",
      "jaiwaram B.O": "494450",
      "keshkutul B.O": "494450",
      "KONDROJI B.O": "494450",
      "madpal B.O": "494450",
      "MARAMETA B.O": "494450",
      "PETHA B.O": "494450",
      "PHULGATTA B.O": "494450",
      "SOMANPALLI B.O": "494450",
      "Tarlaguda B.O": "494446",
      "Tekmetla B.O": "494447",
      "Usoor B.O": "494447",
      "CHINAGELUR B.O": "494447",
      "Chintakonta B.O": "494447",
      "Malempenta B.O": "494447",
      "Painkram B.O": "494447",
      "Palaguda B.O": "494447",
      "Polampalli B.O": "494447",
      "Pujarikanker B.O": "494447",
      "Daroli B.O": "494447",
      "Galgam B.O": "494447",
      "Hirapur B.O": "494447",
      "kottapalli B.O": "494447",
      "Lankapalli B.O": "494447",
      "Nelakaner B.O": "494447",
      "Semaldodi B.O": "494447",
      "Timmapur B.O": "494447",
      "Belnar B.O": "494441",
      "Karkeli B.O": "494444",
      "Pharsegarh B.O": "494444",
      "Ranibodli B.O": "494444",
      "Matwada B.O": "494444",
      "Sagmeta B.O": "494444",
      "Badetungali B.O": "494450",
      "biryabhumi B.O": "494450",
      "BODLI B.O": "494450",
      "CHOTEBODALI B.O": "494450",
      "Edapalli B.O": "494450",
      "fullodi B.O": "494450",
      "Kerpe B.O": "494450",
      "KOTRAPAL B.O": "494450",
      "Mandem B.O": "494450",
      "PATRAPARA B.O": "494450",
      "TAKILOAD B.O": "494450",
      "Tindodi B.O": "494450",
      "Kottaguda B.O": "494446",
      "Rudraram B.O": "494446",
      "Timed B.O": "494446",
      "Putkel B.O": "494447",
      "Nelasnar B.O": "494450",
      "ADAWALI B.O": "494450",
      "Badekakler  B.O": "494450",
      "GUDSHAKAL B.O": "494450",
      "hallur B.O": "494450",
      "HURRAGAWALI B.O": "494450",
      "KETULNAR B.O": "494450",
      "mangalnar B.O": "494450",
      "MANGAPETA B.O": "494450",
      "MURKINAR B.O": "494450",
      "PITEPAL B.O": "494450",
      "Atukpalli B.O": "494446",
      "Sandra B.O": "494444",
      "CHOTEPOTENAR B.O": "494450",
      "DARAPAL B.O": "494450",
      "darbha B.O": "494450",
      "DUNGA B.O": "494450",
      "kodoli B.O": "494450",
      "KOMPALLI B.O": "494450",
      "TALNAR B.O": "494450",
      "USKAPATNAM B.O": "494450",
      "Bareguda B.O": "494446",
      "Chandangiri B.O": "494446",
      "Chandur B.O": "494446",
      "ANGAMPALLI B.O": "494448",
      "Peddakodepal B.O": "494444",
      "BORJE B.O": "494444",
      "DUGOLI B.O": "494444",
      "JAITALOOR B.O": "494444",
      "KADENAR B.O": "494444",
      "KAMKANAR B.O": "494444",
      "MANKELI B.O": "494444",
      "SANTOSHPUR B.O": "494444",
      "TODKA B.O": "494444",
      "MOPHALNAR B.O": "494441",
      "TUMRIGUDA B.O": "494441",
      "TUSHAVAL B.O": "494441",
      "PAHURNAR": "494441",
      "Nemed B.O": "494444",
      "Padeda B.O": "494444",
      "Etpal B.O": "494444",
      "Pidiya B.O": "494444",
      "Pusnar B.O": "494444",
      "Tumnar B.O": "494444",
      "Papanpal B.O": "494444",
      "MIDTE B.O": "494444",
      "NUKANPAL B.O": "494444",
      "REDDI B.O": "494444",
      "BANGAPAL B.O": "494441",
      "GUMALNAR B.O": "494441",
      "GUTOLI B.O": "494441",
      "BENGLUR": "494441",
      "GUMALNAR": "494441",
      "TUMRIGUDA": "494441",
      "TUSHAVAL": "494441",
      "Toynar B.O": "494444",
      "ERAMNAR B.O": "494444",
      "METAPAL B.O": "494444",
      "MORMED B.O": "494444",
      "PADAMUR B.O": "494444",
      "PALNAR B.O": "494444",
      "POTENAR B.O": "494444",
      "BANGAPAL": "494441",
      "GUTOLI": "494441",
      "MUSTALNAR": "494441",
      "Gangaloor B.O": "494444",
      "Kaika B.O": "494444",
      "DAUDITUMNAR B.O": "494444",
      "GAMPUR B.O": "494444",
      "KADER B.O": "494444",
      "MUSALUR B.O": "494444",
      "PODAKORMA B.O": "494444",
      "Pinkonda B.O": "494450",
      "BADESUROKHI B.O": "494441",
      "HANDAWADA B.O": "494441",
      "PAHURNAR B.O": "494441",
      "BADESUROKHI": "494441",
      "HANDAWADA": "494441",
      "MOPHALNAR": "494441",
      "Dharmaram B.O": "494447",
      "Elmidi B.O": "494447",
      "Marudbaka B.O": "494447",
      "Mallepalli B.O": "494447",
      "Murdanda B.O": "494447",
      "Pamed B.O": "494447",
      "Basaguda B.O": "494447",
      "Munjalkanker B.O": "494447",
      "Pakela B.O": "494447",
      "Madded S.O": "494448",
      "Awapalli S.O": "494447",
      "Bhairamgarh S.O": "494450",
      "Bhopalpatnam S.O": "494446",
      "Bijapur S.O": "494444"
    },
    "DHAMTARI": {
      "Ghutkel B.O": "494347",
      "Korra BO": "493770",
      "Kosamsara BO": "493770",
      "Anwari BO": "493770",
      "Bhendra BO": "493770",
      "Dahi BO": "493770",
      "Madeli BO": "493770",
      "Rampur BO": "493770",
      "Semra BO": "493778",
      "Aroud BO": "493773",
      "GJamgoan BO": "493770",
      "Kachna BO": "493770",
      "Banraud BO": "493773",
      "Bhothli BO": "493773",
      "Chanagaon BO": "493773",
      "Dugli BO": "493773",
      "Loharsi BO": "493773",
      "Achhota BO": "493773",
      "Amdi BO": "493773",
      "Chhuhi BO": "493773",
      "Jhuratarai BO": "493773",
      "Karaiha BO": "493773",
      "Keregaon BO": "493773",
      "Singhpur BO": "493773",
      "Tarsiwa BO": "493773",
      "Doma BO": "493770",
      "Joratarai BO": "493770",
      "Silouti BO": "493770",
      "Bazar Kurridih BO": "493773",
      "Borsi BO": "493773",
      "Demar BO": "493773",
      "Gattasilli BO": "493773",
      "Kharenga BO": "493773",
      "Kukrel BO": "493773",
      "Potiadih BO": "493773",
      "Sambalpur BO": "493773",
      "Koliyari B.O": "494337",
      "Achhoti BO": "493663",
      "Barna BO": "493663",
      "Bhatagaon BO": "493663",
      "Kandel BO": "493663",
      "Sankari BO": "493663",
      "Sirri BO": "493663",
      "Kundel BO": "493662",
      "Mohdi BO": "493662",
      "Amali BO": "493778",
      "Belar Bahra BO": "493778",
      "Kaspur BO": "493778",
      "Podagaon BO": "493778",
      "Sankra BO": "493778",
      "Sondur Project BO": "493778",
      "Dhaurabhata BO": "492109",
      "Darra BO": "493885",
      "Megha BO": "493662",
      "Sargi BO": "493662",
      "Belar Bazar BO": "493778",
      "Bhursidongri BO": "493778",
      "Birgudi BO": "493778",
      "Deopur BO": "493778",
      "Dongardulla BO": "493778",
      "Farsia BO": "493778",
      "Khamaria BO": "493778",
      "Hasda BO": "492109",
      "Bhendri BO": "493885",
      "Charmudia BO": "493663",
      "Chhati BO": "493663",
      "Dahdaha BO": "493663",
      "Jhiriya BO": "493663",
      "Mandraud BO": "493663",
      "Marod BO": "493663",
      "Nari BO": "493663",
      "Parkhanda BO": "493663",
      "Belardona BO": "493662",
      "Bhothidih BO": "493662",
      "Girod BO": "493662",
      "Garhdongri BO": "493778",
      "Ghorawad BO": "493778",
      "Bagod BO": "493663",
      "Bhaismundi BO": "493663",
      "Katalbod BO": "493663",
      "Puri BO": "493663",
      "Seonikala BO": "493663",
      "Birjhuli BO": "493662",
      "Kareli Chhoti BO": "493662",
      "Bahigaon BO": "493778",
      "Ghatula BO": "493778",
      "Ghotgaon BO": "493778",
      "Rajpur BO": "493778",
      "Sihawa BO": "493778",
      "Umargaon BO": "493778",
      "Mundibhawar BO": "492109",
      "Pathar BO": "492109",
      "Kareli BO": "493885",
      "Bhatgaon BO": "493776",
      "Darba BO": "493661",
      "Kondapar BO": "493661",
      "RSPColony Gangrel BO": "493776",
      "Dhamtari IWard SO": "493773",
      "Rudri SO": "493776",
      "Bhakhara SO": "493770",
      "Dhamtari DBWard SO": "493773",
      "Magarlod SO": "493662",
      "Nagri SO": "493778",
      "Dhamtari SO": "493773",
      "Kurud SO": "493663"
    },
    "NARAYANPUR": {
      "Belgaon": "494661",
      "Bakulbahi B.O": "494661",
      "Bandapal B.O": "494661",
      "Benur B.O": "494661",
      "Dhaudai B.O": "494661",
      "Edka B.O": "494661",
      "Garpa": "494661",
      "Gome": "494661",
      "Gourdand": "494661",
      "Gudadi": "494661",
      "Koliyari": "494661",
      "Kudhargaon": "494661",
      "Kukdajhor": "494661",
      "Kutull": "494661",
      "Nayanar": "494661",
      "Nelwad": "494661",
      "Toynar": "494661",
      "Devgaon B.O": "494661",
      "Dhanora B.O": "494661",
      "Pharasgaon B.O": "494661",
      "Remawand B.O": "494661",
      "Aalnar": "494661",
      "Badejhamri": "494661",
      "Bamhani": "494661",
      "Bawdi": "494661",
      "Kanhargaon B.O": "494661",
      "Kasturmeta": "494661",
      "Metanar": "494661",
      "Murnar": "494661",
      "Bijli B.O": "494661",
      "Chotedongar B.O": "494661",
      "Orcha B.O": "494661",
      "Badgaon": "494661",
      "Bharanda": "494661",
      "Borawand": "494661",
      "Gomagal": "494661",
      "Jharavahi": "494661",
      "Kange": "494661",
      "Khodgaon": "494661",
      "Madhohnar": "494661",
      "Mandali": "494661",
      "Sonpur": "494661",
      "Tadopal": "494661",
      "Chingnar B.O": "494661",
      "Dandwan B.O": "494661",
      "Gadhbengal B.O": "494661",
      "Kohkameta B.O": "494661",
      "Borand": "494661",
      "Dhurbeda": "494661",
      "Hikul": "494661",
      "Kandadi": "494661",
      "Khadkagaon": "494661",
      "Kodoli": "494661",
      "Mahimagawadi": "494661",
      "Timnar": "494661",
      "Turtha": "494661",
      "Narayanpur S.O (Narayanpur)": "494661"
    },
    "DURG": {
      "Kongiakala BO": "491888",
      "Hirri BO": "491001",
      "Chicha BO": "491001",
      "Jeora Sirsa BO": "491001",
      "Nagpura BO": "491001",
      "Rasmara BO": "491001",
      "Tumakala BO": "491001",
      "Matwari BO": "491221",
      "Aundhi BO": "490021",
      "Janjgiri BO": "490025",
      "Deori BO": "491331",
      "Ghota BO": "491331",
      "Raunda BO": "491331",
      "Nandkatti BO": "491001",
      "Nikum BO": "491221",
      "Risama BO": "491221",
      "Vinayakpur BO": "491221",
      "Gadadih BO": "491221",
      "Biroda BO": "491332",
      "Dargaon BO": "491332",
      "KMohrenga BO": "491332",
      "Auri BO": "490021",
      "Kareli BO": "491331",
      "Pendrawan BO": "491331",
      "Belhari BO": "491223",
      "Anjora BO": "491001",
      "Bhendsar BO": "491001",
      "Nawagaon Purda BO": "491001",
      "Pisegaon BO": "491001",
      "Albaras BO": "491221",
      "Chandkhuri BO": "491221",
      "Kanakote BO": "491221",
      "Machandur BO": "491221",
      "Tirga BO": "491225",
      "Sirsakala BO": "490021",
      "Ranitarai BO": "491223",
      "Surpa BO": "491223",
      "Borai BO": "491001",
      "Hanoda BO": "491001",
      "Litia Semaria BO": "491001",
      "Purda BO": "491001",
      "Temri BO": "491001",
      "Kuthrel BO": "491221",
      "Marra BO": "491221",
      "Pauha BO": "491221",
      "Semaria BO": "491332",
      "Deobaloda BO": "490025",
      "Urla BO": "490025",
      "Barhapur BO": "491331",
      "Ghotwani BO": "491331",
      "Rajpur BO": "491331",
      "Jamgaon R BO": "491223",
      "Nipani Tipani BO": "491223",
      "Dhamna BO": "491223",
      "Karela BO": "491223",
      "Limtara BO": "490042",
      "Oteband BO": "490042",
      "Girhola BO": "490036",
      "Jamgaon BO": "491111",
      "Kesra BO": "491111",
      "Tarra BO": "491111",
      "Teligundra BO": "491111",
      "Newai BO": "491107",
      "Patora BO": "491107",
      "Pauwara BO": "491107",
      "Bori BO": "491001",
      "Dhaur BO": "490024",
      "Karanja Bhilai BO": "490024",
      "Kurud BO": "490024",
      "Nardha BO": "490024",
      "Godhi BO": "490036",
      "Kodia BO": "490036",
      "Batang BO": "491111",
      "Bathena BO": "491111",
      "Gujra BO": "491111",
      "Sankra BO": "491111",
      "Santra BO": "491111",
      "Fekari BO": "491107",
      "Khopli BO": "491107",
      "Selud BO": "491107",
      "Surdung BO": "490024",
      "Kapasda BO": "490042",
      "Medesara BO": "490036",
      "Murmunda BO": "490036",
      "Darbarmokhli BO": "491111",
      "Khamaria BO": "491111",
      "Pahandor BO": "491107",
      "Pahanda BO": "490042",
      "Amleshwar BO": "490042",
      "Ahiwara BO": "490036",
      "Nandini Khundini BO": "490036",
      "Bhansuli BO": "491111",
      "Borid BO": "491111",
      "Devada BO": "491111",
      "Mahudajhit BO": "491111",
      "Batrel BO": "491222",
      "Dundera BO": "491107",
      "Purai BO": "491107",
      "A O Bhilai SO": "490001",
      "I E Bhilai SO": "490026",
      "Jamul Cement Works SO": "490024",
      "Anda SO": "491221",
      "Kasaridih Durg SO": "491001",
      "Khursipar Bhilai SO": "490011",
      "Bhilai Boria SO": "490001",
      "Bhilai East SO": "490021",
      "Bhilai Marshalling Yard SO": "490025",
      "Bhilai West SO": "490009",
      "Borsi SO": "491001",
      "Durg Kutchery SO": "491001",
      "Jawahar Market Bhilai SO": "490001",
      "Bhilai 1 SO": "490001",
      "Civic Centre Bhilai SO": "490006",
      "Durg R S SO": "491001",
      "Durg Sadar Bazar SO": "491001",
      "Durg HO": "491001",
      "IBSB HO": "490001",
      "Kohka Bhilai SO": "490023",
      "Maroda Bhilai SO": "490006",
      "Mohan Nagar Durg SO": "491001",
      "New Khursipar Bhilai SO": "490011",
      "Padmanabhpur Durg SO": "491001",
      "Sector 7 Bhilai SO": "490006",
      "Smriti Nagar Bhilai SO": "490020",
      "Sector 3 Bhilai SO": "490001",
      "Sector 6 Bhilai SO": "490006",
      "Sector 8 Bhilai SO": "490009",
      "Vaishali Nagar Bhilai SO": "490023",
      "Nandini SO": "490036",
      "Nawagaon Bhilai SO": "490006",
      "Patan SO Durg": "491111",
      "Sector 2 Bhilai SO": "490001",
      "Kumhari SO": "490042",
      "Malvia Nagar Durg SO": "491001",
      "Motilal Nehru Nagr Bhilai SO": "490020",
      "S A F Lines Bhilai SO": "490022",
      "Sector 5 Bhilai SO": "490006",
      "Supela Bhilai SO": "490023",
      "Utai SO": "491107",
      "Pulgaon Durg SO": "491001"
    },
    "KABIRDHAM": {
      "Rengakhar BO": "491888",
      "Koko BO": "491336",
      "Marka BO": "491336",
      "Chachedi BO": "491336",
      "Charbhata BO": "491336",
      "Dharamgarh BO": "491336",
      "Gochhia BO": "491336",
      "Gorakhpurkala BO": "491336",
      "Jhironi BO": "491336",
      "Bamhani BO": "491336",
      "Goodha BO": "491336",
      "Indori BO": "491336",
      "Junwani BO": "491995",
      "Kharhatta BO": "491995",
      "Maharjpur BO": "491995",
      "Odiakhurd BO": "491995",
      "Rajanawagaon BO": "491995",
      "Ramhepur BO": "491995",
      "Silhati BO": "491995",
      "Piparia BO": "491995",
      "Singhangarh BO": "491995",
      "Sonbarsa BO": "491995",
      "Sonpuri BO": "491995",
      "Damapur BO": "491559",
      "Kamthee BO": "491559",
      "Kodwagodan BO": "491559",
      "Kukdur BO": "491559",
      "Nanapuri BO": "491559",
      "Saihamalgi BO": "491559",
      "Baijalpur BO": "491995",
      "Bodla BO": "491995",
      "Chilfi BO": "491995",
      "Daihandih BO": "491995",
      "Dharampura BO": "491995",
      "Gaurmati BO": "491995",
      "Khairbana BO": "491995",
      "Koylari BO": "491995",
      "Ranjitpur BO": "491995",
      "Ranvirpur BO": "491995",
      "Bagharra BO": "491559",
      "Kunda BO": "491559",
      "Mahali BO": "491559",
      "Munmuna BO": "491559",
      "Polmi BO": "491559",
      "Madmada BO": "491995",
      "Neurgaon BO": "491995",
      "Pondi BO": "491995",
      "Rakse BO": "491995",
      "Raveli BO": "491995",
      "Sarangpurkhurd BO": "491995",
      "Surajpura BO": "491995",
      "Dullapur BO": "491559",
      "Bharewa BO": "491559",
      "Bodtarakhurd BO": "491559",
      "Khairjhiti BO": "491559",
      "Kisungarh BO": "491559",
      "Kolegaon BO": "491559",
      "Palanasari BO": "491559",
      "Pandatarai BO": "491559",
      "Ruse BO": "491559",
      "Dhobghatti BO": "491559",
      "Mohgaon BO": "491559",
      "Neur BO": "491559",
      "Samnapur BO": "491888",
      "Usarwahi BO": "491888",
      "Kawardha SO": "491995",
      "Dashrangpur SO": "491336",
      "Pandaria SO": "491559",
      "Kawardha Collectorate": "491995",
      "SahasPur Lohara SO": "491996"
    },
    "BALODA BAZAR": {
      "Bareli BO": "493344",
      "Malda BO": "493344",
      "Matia BO": "493344",
      "Latuwa BO": "493332",
      "Pangaon BO": "493332",
      "Bitkuli BO": "493118",
      "Datrengi BO": "493118",
      "Deori BO": "493118",
      "Gurra BO": "493118",
      "Sikari Kesli BO": "493118",
      "Singarpur BO": "493118",
      "Tarenga BO": "493118",
      "Dhansir BO": "493338",
      "Kumhari BO": "493338",
      "Nagarda BO": "492112",
      "Tundri BO": "493338",
      "Mohtara BO": "493344",
      "Pisid BO": "493335",
      "Champa BO": "493332",
      "Khainda BO": "493332",
      "Khatiapati BO": "493332",
      "Kodwa BO": "493118",
      "Gendapali BO": "493222",
      "Junwani BO": "493222",
      "Salonikala BO": "493222",
      "Parsapali BO": "493338",
      "Sutiurkuli BO": "493338",
      "Gadabhata BO": "493196",
      "Bhainsa BO": "493113",
      "Kesda BO": "493113",
      "Borsi BO": "493118",
      "Hatodbazar BO": "493335",
      "Kosamsara BO": "493335",
      "Sinodha BO": "493335",
      "Girod BO": "493344",
      "Damru BO": "493332",
      "Risda BO": "493332",
      "Semradih BO": "493332",
      "Gidhauri BO": "493344",
      "Hasuwa BO": "493344",
      "Jhabdi BO": "493344",
      "Newari BO": "493196",
      "Bharsela Bada BO": "493332",
      "Raseda BO": "493332",
      "Bijradih BO": "493229",
      "Dhaneli BO": "493118",
      "Jaraud BO": "493118",
      "Mopka BO": "493118",
      "Rohra BO": "493118",
      "Deosagar BO": "493222",
      "Durug BO": "493222",
      "Dharasiv BO": "493338",
      "Purgaon BO": "493338",
      "Saliha BO": "493338",
      "Guma BO": "493196",
      "Rawan BO": "493196",
      "Nawapara BO": "493113",
      "Suhela BO": "493195",
      "Amakhoha BO": "493335",
      "Karhi Bazar BO": "493118",
      "Koliha BO": "493118",
      "Nipania BO": "493118",
      "Dhobni BO": "493222",
      "Parsadih BO": "493338",
      "Pauni BO": "493338",
      "Mohbhatta BO": "493113",
      "Jangda BO": "493113",
      "Bhatbhera BO": "493195",
      "Ahilda BO": "493526",
      "Lahod BO": "493526",
      "Deosundra BO": "493228",
      "Kosmandi BO": "493228",
      "Kusmi BO": "493228",
      "Saloni BO": "493228",
      "Bhimbhauri BO": "493551",
      "Sel BO": "493344",
      "Tundra BO": "493344",
      "Sarkhor BO": "493526",
      "Arjuni BO": "493228",
      "Sarwa BO": "493344",
      "Balodi BO": "493228",
      "Chherkapur BO": "493228",
      "Barnawapara BO": "493551",
      "Baya BO": "493551",
      "Datan BO": "493228",
      "Dharashiv BO": "493526",
      "Kohraud BO": "493526",
      "Koyda BO": "493526",
      "Putpura BO": "493228",
      "Sasaha BO": "493228",
      "Sonardeori BO": "493228",
      "Mohra BO": "493225",
      "Bagbuda BO": "493526",
      "Lachhanpur BO": "493526",
      "Marda BO": "493526",
      "Siriadih BO": "493526",
      "Amera BO": "493228",
      "Konari BO": "493228",
      "Rohansi BO": "493228",
      "Karmada BO": "493331",
      "Maldi BO": "493331",
      "Rikokala BO": "492112",
      "Balpur BO": "493559",
      "Manpasar BO": "493559",
      "Pandripali BO": "493559",
      "Damakheda BO": "493101",
      "Gidhpuri BO": "493229",
      "Sisdeori BO": "493229",
      "Telasi BO": "493229",
      "Mopar BO": "493331",
      "Raja Deori BO": "492112",
      "Sonpur BO": "492112",
      "Amodi BO": "493559",
      "Bamhanpuri BO": "493559",
      "Madhaibhata BO": "493559",
      "Pendrawan BO": "493559",
      "Bishrampur BO": "493101",
      "Kamta BO": "493101",
      "Tulsi BO": "493101",
      "Bhawanipur BO": "493229",
      "Charoda BO": "493229",
      "Harinbhatta BO": "493229",
      "Sundrawan BO": "493229",
      "Nawagaon BO": "492112",
      "Raikona BO": "493559",
      "Senduras BO": "493559",
      "Gopalpur BO": "493559",
      "Jara BO": "493229",
      "Jerway BO": "493229",
      "Mudparsandi BO": "493229",
      "Odan BO": "493229",
      "Tonatar BO": "493331",
      "Chandan BO": "492112",
      "Sonakhan BO": "492112",
      "Bhinodi BO": "493559",
      "Dhangaon BO": "493559",
      "Gatadih BO": "493559",
      "Kosamkunda BO": "493559",
      "Bansankra BO": "493101",
      "Chaurenga BO": "493101",
      "Karhul BO": "493101",
      "Bhatapara SO": "493118",
      "Grasim Vihar Rawan SO": "493196",
      "Hathband SO": "493113",
      "Sarsiwa SO": "493559",
      "Baloda Bazar SO": "493332",
      "Katgi SO": "493344",
      "Lawan SO": "493526",
      "Rawan SO": "493331",
      "Bhatapara Sadar Bazar SO": "493118",
      "Bhatgaon SO Raipur": "493222",
      "Hirmi SO": "493195",
      "Kasdol SO": "493335",
      "Pallari SO": "493228",
      "Watgan SO": "493229",
      "Bilaigarh SO": "493338",
      "Simga SO": "493101"
    },
    "MAHASAMUND": {
      "Bhurkoni BO": "493449",
      "Bundeli BO": "493449",
      "Charoda BO": "493449",
      "Tendukona BO": "493449",
      "Baroli BO": "493554",
      "Rasoda BO": "493554",
      "Sirko BO": "493554",
      "Bakma BO": "493449",
      "Bhadrasi BO": "493449",
      "Deori BO": "493449",
      "Kasibahra BO": "493449",
      "Khatti BO": "493445",
      "Khusrupali BO": "493449",
      "Mungaser BO": "493449",
      "Bansula BO": "493554",
      "Bardoli BO": "493554",
      "Salhetarai BO": "493554",
      "Ganjar BO": "493449",
      "Jhara BO": "493449",
      "Khallari BO": "493449",
      "Samhar BO": "493449",
      "Singhi BO": "493449",
      "Arangi BO": "493555",
      "Bamhani BO": "493445",
      "Barnaidadar BO": "493555",
      "Chanat BO": "493555",
      "Patharla BO": "493555",
      "Ghunchapali BO": "493449",
      "Koma BO": "493449",
      "Mongrapali BO": "493449",
      "Shikaripali BO": "493449",
      "Sukhri Dabri BO": "493449",
      "Ankori BO": "493554",
      "Bhukel BO": "493554",
      "Garhphuljhar BO": "493554",
      "Naugadi BO": "493554",
      "Limdarha BO": "493555",
      "Pirda BO": "493555",
      "Ganekera BO": "493554",
      "Belsonda BO": "493445",
      "Birkoni BO": "493445",
      "Garhseoni BO": "493445",
      "Pacheda BO": "493445",
      "Sirpur BO": "493445",
      "Bhithidih BO": "493551",
      "Khatta BO": "493551",
      "Nartora BO": "493551",
      "Sonasilli BO": "493551",
      "Turenga BO": "493551",
      "Jalki BO": "493445",
      "Kamrod BO": "493445",
      "Khamaria BO": "493445",
      "Lafinkhurd BO": "493445",
      "Lahangar BO": "493445",
      "Barekel BO": "493551",
      "Gadbeda BO": "493551",
      "Achanakpur BO": "493445",
      "Bemcha BO": "493445",
      "Dhansuli BO": "493445",
      "Tamora BO": "493445",
      "Tumgaon BO": "493445",
      "Tusda BO": "493445",
      "Jhalap BO": "493551",
      "Kishanpur BO": "493551",
      "Patewa BO": "493551",
      "Raitum BO": "493551",
      "Sukhipali BO": "493551",
      "Bhoring BO": "493445",
      "Joba BO": "493445",
      "Kanekera BO": "493445",
      "Mohandi BO": "493445",
      "Pasid BO": "493445",
      "Malidih BO": "493445",
      "Sorid BO": "493445",
      "Bawankera BO": "493551",
      "Dumarpali BO": "493551",
      "Ghonch BO": "493551",
      "Godbahal BO": "493551",
      "Chhoteloram BO": "492112",
      "Memra BO": "492112",
      "Gerra BO": "493558",
      "Kendudhar BO": "493558",
      "Khoksa BO": "493558",
      "Lambar BO": "493558",
      "Paikin BO": "493558",
      "Putka BO": "493558",
      "Singhanpur BO": "493558",
      "Narra BO": "493448",
      "Badesajapali BO": "493558",
      "Bichhiya BO": "493558",
      "Chattigirola BO": "493558",
      "Kalenda BO": "493558",
      "Kenduwa BO": "493558",
      "Rohina BO": "493558",
      "Singhoda BO": "493558",
      "Salhebhata BO": "493448",
      "Bhotha BO": "493448",
      "Paraswani BO": "492112",
      "Jamhari BO": "493558",
      "Kisdi BO": "493558",
      "Maldamal BO": "493558",
      "Nawagarh BO": "493558",
      "Pajhrapali BO": "493558",
      "Toresingha BO": "493558",
      "Toshgaon BO": "493558",
      "Jamdaraha BO": "493558",
      "Bhagat Deori BO": "492112",
      "Saldih BO": "492112",
      "Thargaon BO": "492112",
      "Amarkot BO": "493558",
      "Baloda BO": "493558",
      "Bhawarpur BO": "493558",
      "Bonda BO": "493558",
      "Pandripani BO": "493558",
      "Patsendri BO": "493558",
      "Kasekera BO": "493448",
      "Hathibahra BO": "493448",
      "Basna SO": "493554",
      "Pithora SO": "493551",
      "Mahasamund SO": "493445",
      "Saraipali SO": "493558",
      "Bagbahra SO": "493449",
      "Komakhan SO": "493448",
      "Jagdishpur SO Mahasamund": "493555",
      "Sankra SO Mahasamund": "492112"
    },
    "RAIPUR": {
      "Chhataud BO": "493116",
      "Madhi BO": "493116",
      "Silyari BO": "493116",
      "Tarpongi BO": "493221",
      "Chikhali BO": "493441",
      "Sarora BO": "493114",
      "Sondra BO": "493221",
      "Samoda BO": "493441",
      "Gukhera BO": "493441",
      "Pathari BO": "493116",
      "Manohara BO": "493116",
      "Tadwa BO": "493116",
      "Deori BO": "493114",
      "Kurra BO": "493221",
      "Tulsi BO": "493195",
      "Dharsiwa BO": "493221",
      "Khairkhut BO": "493221",
      "Tohda BO": "493195",
      "Gullu BO": "493441",
      "Lakholi BO": "493441",
      "Paragaon BO": "493441",
      "Sunderkera BO": "493661",
      "Tamaseoni BO": "493661",
      "Tekari BO": "493661",
      "Bhilai BO": "493441",
      "Chhatera BO": "493441",
      "Farfod BO": "493441",
      "Ganod BO": "493441",
      "Gaurbhat BO": "493441",
      "Adsena BO": "493225",
      "Amsena BO": "493225",
      "Bhainsa BO": "493225",
      "Deortilda BO": "493225",
      "Kanki BO": "493225",
      "Korasi BO": "493225",
      "Kosrangi BO": "493225",
      "Raikhera BO": "493225",
      "Chhapora BO": "493111",
      "Mohdi BO": "493111",
      "Palod BO": "492101",
      "Champa BO": "493114",
      "Kathiai BO": "493225",
      "Khauli BO": "493225",
      "Rakhi BO": "492015",
      "Sejbahar BO": "492015",
      "Akoli BO": "493111",
      "Dondekala BO": "493111",
      "Girod BO": "493111",
      "Piprod BO": "493661",
      "Pond BO": "493661",
      "Rasni BO": "493441",
      "Rewa Lakholi BO": "493441",
      "Bana BO": "493225",
      "Bangoli BO": "493225",
      "Banrasi BO": "493225",
      "Seoni BO": "493661",
      "Uparwara BO": "493661",
      "Bhansoj BO": "493441",
      "Kurud Kutela BO": "493441",
      "Mandhar BO": "493111",
      "Godhi BO": "492101",
      "Kurud Camp BO": "492101",
      "Nawagaon BO": "493885",
      "Beldar Seoni BO": "493225",
      "Ganiyari BO": "493225",
      "Tekarikunda BO": "493225",
      "Deopuri BO": "492015",
      "Nagargaon BO": "493111",
      "Siltara BO": "493111",
      "Tarra BO": "493111",
      "Chand Khuri BO": "492101",
      "Tilda RS BO": "493114",
      "Patewa BO": "493885",
      "Semra BO": "493885",
      "Amodi BO": "493225",
      "Bhandarpuri BO": "493225",
      "Chicholi BO": "493225",
      "Khauna BO": "493225",
      "Mohrenga BO": "493225",
      "Saragaon BO": "493225",
      "Barbanda BO": "493111",
      "GSi BO": "493111",
      "Nardaha BO": "493111",
      "Champaran BO": "493885",
      "Chhachhanpairi BO": "493661",
      "Rajkumar College BO": "492013",
      "Bhurka BO": "493661",
      "Khorpa BO": "493661",
      "Hasda11 BO": "493661",
      "Khola BO": "493661",
      "Kolar BO": "493661",
      "Kurru BO": "493661",
      "PJamgaon BO": "493661",
      "Bendri BO": "493661",
      "Chandi Bazar BO": "493661",
      "Manikchouri BO": "493661",
      "Raipura BO": "492013",
      "Tenduwa BO": "492099",
      "Mathpurena BO": "492013",
      "Khamtarai BO": "492008",
      "Kathia11 BO": "493661",
      "Kendri BO": "493661",
      "Parsada BO": "493661",
      "Raipur HO": "492001",
      "Arang SO": "493441",
      "Birgaon SO": "493221",
      "Kharora SO": "493225",
      "Krishak Nagar SO": "492012",
      "Nawapara Rajim SO": "493881",
      "Neora SO Raipur": "493114",
      "Raipur Kutchery SO": "492001",
      "Ravi Shankar University SO": "492010",
      "Sunder Nagar SO": "492013",
      "Baikunth SO": "493116",
      "Chhotapara SO": "492001",
      "Gudhiyari SO": "492009",
      "Kalibadi SO": "492001",
      "Mana Camp SO": "492015",
      "Mandhar Cement Factory SO": "493111",
      "Raipur Ganj SO": "492009",
      "Science College SO": "492010",
      "Sector  27 Naya Raipur SO": "492018",
      "Dayanand Nagar SO": "492001",
      "Pandri SO": "492004",
      "Purani Basti SO Raipur": "492001",
      "Saddu SO": "492014",
      "Shanker Nagar SO": "492004",
      "Vidhan Sabha SO Raipur": "492005",
      "WRSColony SO": "492008",
      "Abhanpur SO": "493661",
      "Byron Bazar SO": "492001",
      "Mandir Hasod SO": "492101",
      "Mantralaya Raipur SO": "492002",
      "Ravigram SO": "492001",
      "Tatibandh SO": "492099",
      "Urla SO": "492003",
      "Vivekanand Ashram SO": "492001",
      "Mana Basti SO": "492016",
      "IBC Raipur PO": "492017"
    },
    "GARIYABAND": {
      "Khadma BO": "493996",
      "Kosmi BO": "493996",
      "Kotigaon BO": "493996",
      "Lohjhar BO": "493996",
      "Patseoni BO": "493996",
      "Rasela BO": "493996",
      "Seoni BO": "493996",
      "Chichia BO": "493890",
      "Sinapali BO": "493890",
      "Girsul BO": "493890",
      "Khoksara BO": "493890",
      "Latapara BO": "493890",
      "Tikrapara BO": "493890",
      "Ghutkunawapara BO": "493889",
      "Joba BO": "493889",
      "Kochwai BO": "493889",
      "KHURSIPAR BO": "493889",
      "Maroda BO": "493889",
      "Parsuli BO": "493889",
      "Piperchhedi BO": "493889",
      "Ruwad BO": "493889",
      "Litipara BO": "493889",
      "Dhruwagudi BO": "493891",
      "Kandekela BO": "493891",
      "Tetalkhunti BO": "493891",
      "Sargiguda BO": "493891",
      "Kanesar BO": "493996",
      "Paktia BO": "493996",
      "Jhakharpara BO": "493890",
      "Mungijhar BO": "493890",
      "Diwanmuda BO": "493890",
      "Bindranawagarh BO": "493889",
      "Malgaon BO": "493889",
      "Nahargaon BO": "493889",
      "Amlipadar BO": "493891",
      "Mudgelmal BO": "493891",
      "Sitlijor BO": "493890",
      "Urmal BO": "493891",
      "Dulla BO": "493996",
      "Kansinghi BO": "493996",
      "Madeli BO": "493996",
      "Ranipartewa BO": "493996",
      "Kadlimuda BO": "493890",
      "Nistiguda BO": "493890",
      "Barula BO": "493889",
      "Darripara BO": "493889",
      "Madanpur BO": "493889",
      "Sarnabahal BO": "493891",
      "Gaurgaon BO": "493888",
      "Gona BO": "493888",
      "Taurenga BO": "493888",
      "Loharsi BO": "492109",
      "Pond BO": "492109",
      "Borsi BO": "493992",
      "Jamgaon BO": "493992",
      "Tarighat BO": "493992",
      "Kirwai BO": "493885",
      "Indagaon BO": "493888",
      "Jidar BO": "493888",
      "MainpurII BO": "493889",
      "Akalwara BO": "493992",
      "Basin BO": "493992",
      "Belar BO": "493992",
      "Kondkera BO": "493992",
      "Baronda BO": "493885",
      "Beltukri BO": "493885",
      "Sursabandha BO": "493885",
      "Shobha BO": "493888",
      "Atarmara BO": "492109",
      "Parsadakala BO": "493992",
      "Pendra BO": "493992",
      "Parsada BO": "493885",
      "Dhawalpur BO": "493888",
      "Sikaser BO": "493888",
      "Deori BO": "493992",
      "Sorid BO": "493992",
      "Chhura SO": "493996",
      "Kopra SO": "493887",
      "Mainpur SO": "493888",
      "Deobhog SO": "493890",
      "Gariaband SO": "493889",
      "Panduka SO": "492109",
      "Phingeshwar SO": "493992",
      "Gohrapadar SO": "493891",
      "Rajim SO": "493885"
    },
    "KORBA": {
      "Korkoma BO": "495683",
      "Risdi BO": "495683",
      "Bundeli BO": "495683",
      "Godhi BO": "495683",
      "Pasarkhet BO": "495683",
      "Silli BO": "495442",
      "Madanpur BO": "495448",
      "Gursia BO": "495448",
      "Morga BO": "495448",
      "Pachra BO": "495448",
      "Barpali S BO": "495674",
      "Chachia BO": "495674",
      "Champa BO": "495674",
      "Chirra BO": "495674",
      "Rampur BO": "495674",
      "Dadarkhurd BO": "495682",
      "Gidhkunwari BO": "495674",
      "Jilga BO": "495674",
      "Kartalachak BO": "495674",
      "Kudmura BO": "495674",
      "Tuman BO": "495445",
      "Karainara BO": "495671",
      "Banjhiban BO": "495445",
      "Darrabhatha BO": "495445",
      "Jatga BO": "495445",
      "Jalke BO": "495448",
      "Ajgarbahar BO": "495684",
      "Mongra BO": "495447",
      "Dadarkala BO": "495674",
      "Ghinara BO": "495674",
      "Jarwe BO": "495674",
      "Kotmer BO": "495674",
      "Kudurmal BO": "495674",
      "Pidia BO": "495674",
      "Saragbundia BO": "495674",
      "Solwan BO": "495674",
      "Tilkeja BO": "495674",
      "Faraswani BO": "495671",
      "Pali BO": "495448",
      "Rajkamma BO": "495445",
      "Rawa BO": "495445",
      "Nonbirra BO": "495674",
      "Nunera BO": "495449",
      "Ranjana BO": "495449",
      "Shish BO": "495449",
      "Sutarra BO": "495445",
      "Batra BO": "495449",
      "Baksahi BO": "495449",
      "Chaitma BO": "495449",
      "Kapot BO": "495449",
      "Pondilafa BO": "495449",
      "Tiwarta BO": "495449",
      "Bango Dam BO": "495448",
      "Sirmina BO": "495448",
      "Madai BO": "495448",
      "Laad BO": "495448",
      "Garh Uproda BO": "495684",
      "Barpali J BO": "495674",
      "Beharchuwa BO": "495674",
      "Chiknipali BO": "495674",
      "Chorbhatti BO": "495674",
      "Sendripali BO": "495674",
      "Syang BO": "495674",
      "Chicholi BO": "495671",
      "Kothari BO": "495671",
      "Binjhra BO": "495445",
      "Jawali BO": "495445",
      "Tanakhar BO": "495445",
      "Lafa BO": "495449",
      "Patpara BO": "495449",
      "Sukhrikala BO": "495671",
      "Korbi BO": "495448",
      "Mudhali BO": "495446",
      "Chhuri BO": "495450",
      "Gopalpur BO": "495450",
      "Umreli BO": "495671",
      "Birda BO": "495446",
      "Boida BO": "495446",
      "Chainpur BO": "495446",
      "Tarda BO": "495446",
      "Utarda BO": "495446",
      "Bhairotal BO": "495454",
      "Bhilaibazar BO": "495454",
      "Durpa BO": "495454",
      "Gevra Basti BO": "495454",
      "Lainga BO": "495119",
      "Pathiapali BO": "495671",
      "Kanki BO": "495446",
      "Sohagpur BO": "495671",
      "Khamharia BO": "495446",
      "Murli BO": "495446",
      "Gerwa BO": "495450",
      "Pandania BO": "495454",
      "Pasan BO": "495119",
      "Piparia BO": "495119",
      "Pondikala BO": "495119",
      "Karri BO": "495119",
      "Putipakhna BO": "495119",
      "Semra BO": "495119",
      "Bhaisma SO": "495674",
      "Jamnipali SO": "495450",
      "Korba Colliery SO": "495677",
      "Vidyut Nagar Korba SO": "495450",
      "Banki Mongra SO": "495447",
      "Hardi Bazar SO": "495446",
      "Korba Town SO": "495677",
      "Wcl Gevra Project SO": "495452",
      "Dhelwadih": "495444",
      "Katghora SO": "495445",
      "Pali SO Korba": "495449",
      "Balco Nagar Korba SO": "495684",
      "Hasdeo Project Korba SO": "495677",
      "Manikpur Colliery SO": "495682",
      "Vikas Bhawan SO": "495450",
      "PondiUproda SO": "495448",
      "Balgi Project Korba SO": "495455",
      "Kusmunda Colliery SO": "495454",
      "Rajgamar Colliery SO": "495683",
      "Deepika Project Korba": "495452",
      "Korba HO": "495677"
    },
    "BEMETARA": {
      "Karesara BO": "491335",
      "Ninwa BO": "491335",
      "Ranka BO": "491335",
      "Jiya BO": "491335",
      "Matka BO": "491335",
      "Mohrenga BO": "491335",
      "Odia BO": "491335",
      "Thengabhat BO": "491335",
      "Bargaon BO": "491332",
      "Khudmuda BO": "491332",
      "Gadadih BO": "491331",
      "Parpodi BO": "491331",
      "Sahaspur BO": "491331",
      "Kusmi BO": "491332",
      "Sarda BO": "491332",
      "Balsamund BO": "491335",
      "Chandanu BO": "491335",
      "Dadhi BO": "491335",
      "Jhal BO": "491335",
      "Khandsara BO": "491335",
      "Kurda BO": "491335",
      "Lawatara BO": "491332",
      "Lenjwara BO": "491332",
      "Pahanda BO": "491332",
      "Sondh BO": "491332",
      "Bhatagaon BO": "491331",
      "Deokar BO": "491331",
      "Baba Mohtara BO": "491335",
      "Bijabhat BO": "491335",
      "Kanhera BO": "491335",
      "Pendritarai BO": "491335",
      "Anandgaon BO": "491332",
      "Patora BO": "491332",
      "Badnara BO": "491340",
      "Ghursena BO": "491340",
      "Andhiarkhor BO": "491337",
      "Kestara BO": "491993",
      "Mohbhatta BO": "491993",
      "Saldha BO": "491993",
      "Kheda BO": "491340",
      "Putpura BO": "491340",
      "Sambalpur BO": "491340",
      "Temri BO": "491340",
      "Gudheli BO": "490036",
      "Kanwarkapa BO": "491337",
      "Kunwa BO": "491337",
      "Murta BO": "491337",
      "Nandal BO": "491337",
      "Pratappur BO": "491337",
      "Baghul BO": "491337",
      "Deorbija BO": "491993",
      "Deurgaon BO": "491993",
      "Tipani BO": "491338",
      "Maro BO": "491340",
      "Narayanpur BO": "491340",
      "Bhimbhori BO": "490036",
      "Gondgiri BO": "490036",
      "Gadamore BO": "491337",
      "Hardi BO": "491337",
      "Beltara BO": "491993",
      "Bortara BO": "491993",
      "Mohgaon BO": "491993",
      "Parasbod BO": "491993",
      "Hatranka BO": "491338",
      "Kunra BO": "491340",
      "Mau BO": "491340",
      "Nagdha BO": "491340",
      "Hasda BO": "490036",
      "Chirha BO": "491337",
      "Ghoghra BO": "491337",
      "Bargada BO": "491993",
      "Chilfi BO": "491993",
      "Bemetara SO": "491335",
      "Khamaria SO Durg": "491338",
      "Berla SO": "491332",
      "Dhamdha SO": "491331",
      "Nawagarh SO Durg": "491337",
      "Nandghat SO": "491340",
      "Saja SO": "491993"
    },
    "RAIGARH": {
      "Jamgaon BO": "496001",
      "Nawapara BO": "496665",
      "Anjoripali BO": "496661",
      "Aurda BO": "496100",
      "Bade Deogaon BO": "496661",
      "Chhodamines BO": "496661",
      "Kondtarai BO": "496661",
      "Pamgarh BO": "496661",
      "Patrapali BO": "496661",
      "Purena BO": "496661",
      "Robertson BO": "496661",
      "Sondka BO": "496661",
      "Tetla BO": "496100",
      "Banora BO": "496001",
      "Bhagora BO": "496001",
      "Boirdadar BO": "496001",
      "Chhatamura BO": "496001",
      "Jhalmala BO": "496001",
      "Jivri BO": "496001",
      "Jurda BO": "496001",
      "Baturakachhar BO": "496113",
      "Bhainapara BO": "496661",
      "Botalda BO": "496661",
      "Dhimani BO": "496661",
      "Ghaghra BO": "496661",
      "Madanpur BO": "496661",
      "Mauhapali BO": "496661",
      "Naharpali BO": "496661",
      "Jatri BO": "496100",
      "Patelpali BO": "496100",
      "Taparda BO": "496100",
      "Garh umaria BO": "496001",
      "Gorra BO": "496001",
      "Kotarlia BO": "496001",
      "Kukurda BO": "496001",
      "Sambalpuri BO": "496001",
      "Urdana Camp BO": "496001",
      "Gahira BO": "496113",
      "Piprahi BO": "496113",
      "Sonajori BO": "496113",
      "Kataipali D BO": "496113",
      "Bairagi BO": "496118",
      "Kapu BO": "496118",
      "Vijaynagar BO": "496118",
      "Baradoli BO": "496440",
      "Chhichhorumaria BO": "496440",
      "Netnagar BO": "496440",
      "Rengalpali BO": "496440",
      "Tinmini BO": "496440",
      "Gahnajharia BO": "496115",
      "Kodasia BO": "496115",
      "Chhind BO": "496445",
      "Dansara BO": "496445",
      "Pahanda BO": "496445",
      "Sahaspani BO": "496445",
      "Tamtora BO": "496445",
      "Gatadih BO": "496445",
      "Bar BO": "496554",
      "Bonda BO": "496554",
      "Nadigaon BO": "496554",
      "Sankra BO": "496554",
      "Amgaon BO": "496107",
      "Dolesara BO": "496107",
      "Mahloi BO": "496440",
      "Urba BO": "496107",
      "Basnajhar BO": "496661",
      "Bhupdeopur BO": "496661",
      "Binjkot BO": "496661",
      "Dongitarai BO": "496661",
      "Kunkuni BO": "496661",
      "Mura BO": "496661",
      "Sarwani BO": "496661",
      "Loharsingh BO": "496100",
      "Pusalda BO": "496665",
      "Bangursia BO": "496001",
      "Dhanagar BO": "496001",
      "Gerwani BO": "496001",
      "Kantahardi BO": "496001",
      "Kotra BO": "496001",
      "Saraipali BO": "496001",
      "Tarkela BO": "496001",
      "Jhagarpur BO": "496113",
      "Keshla BO": "496113",
      "Narayanpur BO": "496113",
      "Bakaruma BO": "496118",
      "Raimer BO": "496118",
      "Birsingha BO": "496113",
      "Kataklia BO": "496113",
      "Kaya BO": "496113",
      "Laripani BO": "496113",
      "Mukdega BO": "496113",
      "Bahma BO": "496220",
      "Kilkila BO": "496118",
      "Kumarta BO": "496118",
      "Saskoba BO": "496118",
      "Sonpur BO": "496118",
      "Supkalo BO": "496118",
      "Kondpali BO": "496440",
      "Kotasura BO": "496440",
      "Bhedimuda BO": "496115",
      "Choranga BO": "496115",
      "Ghatgaon BO": "496115",
      "Kanakbira BO": "496445",
      "Kedar BO": "496445",
      "Khokhsipali BO": "496445",
      "Kosir BO": "496445",
      "Pasid BO": "496445",
      "Deogaon BO": "496554",
      "Gobarsingha BO": "496554",
      "Lukapara BO": "496554",
      "Manikpur BO": "496554",
      "Rissora BO": "496554",
      "Padigaon BO": "496440",
      "Samkera BO": "496107",
      "Saraitola BO": "496107",
      "Halahuli BO": "496661",
      "Jaimura BO": "496661",
      "Jharadih BO": "496661",
      "Kachhar BO": "496661",
      "Telikot BO": "496661",
      "Tiur BO": "496661",
      "Badebhandar BO": "496100",
      "Bunga BO": "496100",
      "Chikhli BO": "496100",
      "Loing BO": "496001",
      "Nandeli BO": "496001",
      "Naurangpur BO": "496001",
      "Putkapuri BO": "496001",
      "Usrot BO": "496001",
      "Kunjara BO": "496113",
      "Tolge BO": "496113",
      "Tolma BO": "496113",
      "Turtura BO": "496113",
      "Chhapora BO": "496440",
      "Rajkot BO": "496115",
      "Salakia BO": "496115",
      "Dhap BO": "496115",
      "Bansdand BO": "496115",
      "Bhadisar BO": "496445",
      "Chantipali BO": "496445",
      "Kudhari BO": "496445",
      "Mahuadhodha BO": "496445",
      "Rapagula BO": "496445",
      "Salar BO": "496445",
      "Gonda BO": "496445",
      "Madhopali BO": "496445",
      "Panchdhar BO": "496554",
      "Hamirpur BO": "496107",
      "Jarekela BO": "496107",
      "Kolam BO": "496107",
      "Libra BO": "496107",
      "Badehardi BO": "496440",
      "Baghadola BO": "496440",
      "Tadola BO": "496440",
      "Bagudega BO": "496115",
      "Kurra BO": "496115",
      "Mudagaon BO": "496115",
      "Chhote Lendhra BO": "496445",
      "Godihari BO": "496445",
      "Kharri BO": "496445",
      "Paraskol BO": "496445",
      "Tandipar BO": "496445",
      "Amlipali BO": "496445",
      "Bade Nawapara BO": "496554",
      "Barpali BO": "496554",
      "Salheona BO": "496554",
      "Dhourabhata BO": "496107",
      "Milupara BO": "496107",
      "Tangarghat BO": "496107",
      "Dongripali BO": "496551",
      "Faraswani BO": "496551",
      "Malda BO": "496551",
      "Tausir BO": "496551",
      "Barbhouna BO": "496665",
      "Barra BO": "496665",
      "Bojia BO": "496665",
      "Chandrasekharpur BO": "496665",
      "Relo BO": "496665",
      "Jamarga BO": "496116",
      "Khadgaon BO": "496116",
      "Khamhar BO": "496665",
      "Miriguda BO": "496116",
      "Munund BO": "496116",
      "Narkalo BO": "496116",
      "Ongana BO": "496116",
      "Bahirkela BO": "496111",
      "Nawapara Tenda BO": "496111",
      "Porda BO": "496111",
      "Rabo BO": "496111",
      "Kapisda BO": "496450",
      "Kotari BO": "496450",
      "Mudpar BO": "496450",
      "Navrangpur BO": "496450",
      "Pendri BO": "496450",
      "Jashpur BO": "496450",
      "Tarapur BO": "496001",
      "Bengchi BO": "496551",
      "Jhal BO": "496551",
      "Katangpali BO": "496551",
      "Lodhia BO": "496551",
      "Banhar BO": "496665",
      "Dehjari BO": "496665",
      "Gorpar BO": "496665",
      "Boro BO": "496116",
      "Hati BO": "496116",
      "Maharajganj BO": "496116",
      "Ruwaful BO": "496116",
      "Sisringa BO": "496116",
      "Ududa BO": "496116",
      "Bhalumar BO": "496111",
      "Chharratangar BO": "496111",
      "Kotrimal BO": "496111",
      "Kudumkela BO": "496111",
      "Teram BO": "496111",
      "Badegantuli BO": "496450",
      "Bhothli BO": "496450",
      "Reda BO": "496450",
      "Kirodimalnagar BO": "496005",
      "Birnipali BO": "496551",
      "Damdama BO": "496551",
      "Hirri BO": "496551",
      "Karanpali BO": "496551",
      "Lendhra BO": "496551",
      "Bangursuta BO": "496665",
      "Farkanara BO": "496665",
      "Jobi BO": "496665",
      "Kudekela BO": "496665",
      "Behramar BO": "496116",
      "Gersa BO": "496116",
      "Kuma BO": "496116",
      "Shahpur BO": "496116",
      "Sithra BO": "496116",
      "Barod BO": "496111",
      "Chhotegumda BO": "496111",
      "Gharghodi BO": "496111",
      "Samaruma BO": "496111",
      "Bhedwan BO": "496450",
      "Chhote Khaira BO": "496450",
      "Jewara BO": "496450",
      "Timarlaga BO": "496450",
      "Ulkhar BO": "496450",
      "Gorkha BO": "496005",
      "Amjhar BO": "496551",
      "Dabhra BO": "496551",
      "Hattapali BO": "496551",
      "Gurda BO": "496665",
      "Kataipali C BO": "496665",
      "Nagoi BO": "496665",
      "Baisi Colony BO": "496116",
      "Bartapali BO": "496116",
      "Baihamunda BO": "496111",
      "Banai BO": "496111",
      "Dehridih BO": "496111",
      "Deogarh BO": "496111",
      "Raikera BO": "496111",
      "Dahida BO": "496450",
      "Godam BO": "496450",
      "Gudeli BO": "496450",
      "Uchbhitti BO": "496450",
      "Raigarh HO": "496001",
      "Gharghoda SO": "496111",
      "Hardi SO Raigarh": "496450",
      "JSPL Patrapali SO": "496005",
      "Lailunga SO": "496113",
      "Raigarh Sadar Bazar SO": "496001",
      "Tamnar SO": "496107",
      "Urjanagar Telirampur SO": "496108",
      "Baramkela SO": "496551",
      "Chakradharnagar SO": "496001",
      "Chhal SO": "496665",
      "Dharamjaigarh SO": "496116",
      "Kondatarai SO": "496100",
      "Pussore SO": "496440",
      "Raigarh Jute Mill SO": "496001",
      "Saria SO": "496554",
      "Punjipathra SO": "496109",
      "Rajpur RIH SO": "496115",
      "Sarangarh SO": "496445",
      "Kharsia SO": "496661"
    },
    "BALOD": {
      "Gabdi BO": "491225",
      "Hadgahan BO": "491225",
      "Admabad BO": "491226",
      "Gujra BO": "491226",
      "KOBA": "491226",
      "Pond BO": "491226",
      "Tekapar BO": "491226",
      "Ghotia BO": "491228",
      "Mahamaya Mines": "491230",
      "Salhe BO": "491228",
      "Themabujurg BO": "491230",
      "Achholi BO": "491771",
      "Badgaon BO": "491771",
      "Sirri BO": "491221",
      "Tamora BO": "491221",
      "Suregaon BO": "491225",
      "Badbhum BO": "491226",
      "Khapri BO": "491226",
      "Newarikala BO": "491226",
      "Sankra J BO": "491226",
      "Singhola BO": "491226",
      "Gudum Bo": "491230",
      "Khalari BO": "491228",
      "Surdongar": "491230",
      "Kotagaon BO": "491230",
      "Bhanwarmara BO": "491771",
      "Bharda BO": "491771",
      "Kherthabazar BO": "491771",
      "Kholjhar BO": "491771",
      "Nahanda BO": "491771",
      "Sahgaon BO": "491771",
      "Sambalpur BO": "491771",
      "Sanjari BO": "491771",
      "Bhatagaon BO": "491222",
      "Dagania BO": "491221",
      "Bhardakala BO": "491225",
      "Chaurel BO": "491225",
      "Kasahi BO": "491225",
      "Khursuni BO": "491225",
      "Baghmara BO": "491226",
      "Beloda BO": "491226",
      "Belmond BO": "491226",
      "Jamrua BO": "491226",
      "Bharritola Bo": "491230",
      "Bital BO": "491228",
      "Chipra BO": "491228",
      "Kondekasa BO": "491228",
      "Bhimkanhar BO": "491771",
      "Deori BO": "491771",
      "Rahud BO": "491223",
      "Balod Gahan BO": "491227",
      "Darra BO": "491227",
      "Dhaneli BO": "491227",
      "Fagundah BO": "491227",
      "Jamgaon B BO": "491227",
      "Karhi Bhadar BO": "491227",
      "Khundini BO": "491227",
      "Dundera BO": "491225",
      "Kandul BO": "491225",
      "Bhaisbod BO": "491226",
      "Dudhli BO": "491226",
      "Latabod BO": "491226",
      "Taraud BO": "491226",
      "Amadula BO": "491230",
      "Chikhlakasa BO": "491228",
      "Kusumkasa BO": "491228",
      "Narratola BO": "491228",
      "Bhandera BO": "491771",
      "Kamkapar BO": "491771",
      "Achaud BO": "491223",
      "Kalangpur BO": "491223",
      "Ranchirai BO": "491223",
      "Tavera BO": "491223",
      "Barhi BO": "491227",
      "Charwahi BO": "491227",
      "Limora BO": "491227",
      "Gorkapar BO": "491223",
      "Kaneri BO": "491227",
      "Kanwar BO": "491227",
      "Pinkapar BO": "491661",
      "Faradfod BO": "491771",
      "Kodekasa BO": "491771",
      "Tatenga BO": "491771",
      "Kachandur BO": "491223",
      "Kasaunda BO": "491223",
      "Basin BO": "491227",
      "Chitod BO": "491227",
      "Charbhata B.O": "491222",
      "Armarikala BO": "491222",
      "Belaudi BO": "491222",
      "Chandnbirhi BO": "491222",
      "Hardi BO": "491222",
      "Mohara BO": "491222",
      "Naragaon BO": "491227",
      "Nipani BO": "491227",
      "Shantipur BO": "491227",
      "Sonai Dongri BO": "491227",
      "Tarri BO": "491227",
      "Sanoud BO": "491222",
      "Charbhatha": "491222",
      "Mangchua BO": "491665",
      "Rengadabri BO": "491665",
      "Mokha BO": "491227",
      "Arkar BO": "491222",
      "Barbaspur BO": "491222",
      "Pairi BO": "491222",
      "Parsada BO": "491222",
      "Sorar BO": "491227",
      "Mahud BO": "491222",
      "Palari BO": "491222",
      "Rajauli BO": "491222",
      "Arjunda SO": "491225",
      "Gurur SO": "491227",
      "Balod Town SO": "491226",
      "Bazar Dallirajhara SO": "491228",
      "Dallirajhara SO": "491228",
      "Balod SO": "491226",
      "Dondi Lohara SO": "491771",
      "Gunderdehi SO": "491223",
      "Sikosa SO": "491222",
      "Dondi SO": "491230",
      "Mines Office Dallirajhara SO": "491228"
    },
    "Gaurella Pendra Marwahi": {
      "Beljhiria BO": "495118",
      "Karhani BO": "495118",
      "Ratga BO": "495118",
      "Rumga BO": "495118",
      "Semardarri BO": "495118",
      "Seoni BO": "495118",
      "Bagrad BO": "495118",
      "Chadhedi BO": "495118",
      "Choktipani BO": "495117",
      "Neosa BO": "495117",
      "Pakaria BO": "495117",
      "Pendra Road Sanotorium BO": "495117",
      "Darri BO": "495117",
      "Korja BO": "495117",
      "Lalpur BO": "495117",
      "Sadhwani BO": "495117",
      "Amaru BO": "495119",
      "Andi BO": "495119",
      "Bacharwar BO": "495119",
      "Bagadi BO": "495119",
      "Gorakhpur BO": "495117",
      "Keonchi BO": "495117",
      "Khodri BO": "495117",
      "Amarpur BO": "495119",
      "Bansital BO": "495118",
      "Bharridand BO": "495118",
      "Parasi BO": "495118",
      "Usad BO": "495118",
      "Andhiyarkhoh BO": "495117",
      "Jogisar BO": "495117",
      "Piparkhunti BO": "495117",
      "Amadand BO": "495119",
      "Basti Bagra BO": "495119",
      "Kotmi BO": "495119",
      "Kudkai BO": "495119",
      "Nawagaon BO": "495119",
      "Nimdha BO": "495119",
      "Patgawan BO": "495119",
      "Kotgar BO": "495119",
      "Dhobhar BO": "495119",
      "Dongaria BO": "495119",
      "Kudri BO": "495119",
      "Silpahri BO": "495119",
      "Pendra SO": "495119",
      "Marwahi SO": "495118",
      "Pendra Road RS SO": "495117",
      "Pendra Road SO": "495117"
    },
    "SURGUJA": {
      "Raghunathpur BO": "497101",
      "Urdara BO": "497101",
      "Sedam BO": "497101",
      "Udari BO": "497101",
      "Bilaspur BO": "497101",
      "Bhitthikala BO": "497001",
      "Darima BO": "497001",
      "Kakna BO": "497001",
      "Bargawan BO": "497001",
      "Nawanagar BO": "497001",
      "Raghavpuri BO": "497001",
      "Sakholi BO": "497001",
      "Dumardih BO": "497101",
      "Lamgaon BO": "497101",
      "Lundra BO": "497101",
      "Patora BO": "497101",
      "Karjee BO": "497001",
      "Bargidih BO": "497101",
      "Dhourpur BO": "497101",
      "Poksari BO": "497101",
      "Kalyanpur BO": "497001",
      "Nandamali BO": "497001",
      "Sakalo BO": "497001",
      "Sukhari BO": "497001",
      "Mendrakala BO": "497001",
      "Babouli BO": "497101",
      "Chiranga BO": "497101",
      "Kunni BO": "497116",
      "Turna BO": "497116",
      "Guturma BO": "497114",
      "Pent BO": "497114",
      "Bataikela BO": "497111",
      "Bhusu BO": "497111",
      "Girhuldih BO": "497111",
      "Dandgaon BO": "497117",
      "Laxmangarh BO": "497117",
      "Sayar BO": "497117",
      "Argoti BO": "497116",
      "Jamgala BO": "497116",
      "Kamleshwarpur BO": "497111",
      "Katkalo BO": "497111",
      "Kot BO": "497111",
      "Narbadapur BO": "497111",
      "Petla BO": "497111",
      "Deogarh BO": "497111",
      "Khadadorna BO": "497111",
      "Sarga BO": "497111",
      "Kedma BO": "497117",
      "Khamharia BO": "497117",
      "Salka BO": "497117",
      "Lahpatra BO": "497116",
      "Baneya BO": "497114",
      "Jamkani BO": "497114",
      "Ulakia BO": "497114",
      "Dhodhagaon BO": "497111",
      "Jajga BO": "497111",
      "Sur BO": "497111",
      "Jamdih BO": "497117",
      "Kerju BO": "496223",
      "Ambikapur HO": "497001",
      "Ambikapur Nyalaya SO": "497001",
      "Udaipur SO": "497117",
      "Lakhanpur SO Surguja": "497116",
      "Funduldihari SO": "497001",
      "Sitapur SO": "497111",
      "Ambikapur Town SO": "497001",
      "Batouli SO": "497101",
      "Pratapgarh SO": "497114"
    },
    "SURAJPUR": {
      "Darripara BO": "497231",
      "Lanjit BO": "497231",
      "Odgi BO": "497231",
      "Chandramedha BO": "497235",
      "Baijnathpur BO": "497231",
      "Shivprasadnagar BO": "497231",
      "Dawna BO": "497235",
      "Banja BO": "497231",
      "Basdei BO": "497231",
      "Sirsi BO": "497231",
      "Chungudi BO": "497235",
      "Jarhi BO": "497235",
      "Ajabnagar BO": "497001",
      "Karwan BO": "497001",
      "Latori BO": "497001",
      "Silphili BO": "497001",
      "Songara BO": "497001",
      "Kewra BO": "497223",
      "Khadgaonkala BO": "497223",
      "Koteya BO": "497223",
      "Lolki BO": "497223",
      "Madanpur BO": "497333",
      "Nawaparakalan BO": "497333",
      "Patrapali BO": "497333",
      "Mahgai BO": "497117",
      "Gangikot BO": "497226",
      "Karanji BO": "497226",
      "Ramnagar BO": "497226",
      "Paraswarkhurd BO": "497223",
      "Jajawal BO": "497223",
      "Ramkola BO": "497223",
      "Rewti BO": "497223",
      "Batra BO": "497226",
      "Jainagar BO": "497226",
      "Kumda Colly BO": "497226",
      "Chandoura BO": "497223",
      "Dharampur BO": "497223",
      "Govindpur BO": "497223",
      "Ganeshpur BO": "497333",
      "Tiwragudi BO": "497333",
      "Umeshwarpur BO": "497333",
      "Dedri BO": "497229",
      "Ketka BO": "497229",
      "Krishnapur BO": "497229",
      "Moharsop BO": "497225",
      "Nagoi BO": "497225",
      "Salka BO": "497235",
      "Kandrai BO": "497226",
      "Bhedia BO": "497223",
      "Karsi BO": "497223",
      "Masga BO": "497223",
      "Deonagar BO": "497333",
      "Kanchanpur BO": "497333",
      "Premnagar BO": "497333",
      "Patnakot BO": "497229",
      "Bakalo BO": "497333",
      "Bhuvneshwarpur BO": "497333",
      "Parshurampur BO": "497333",
      "Salhi BO": "497229",
      "Biharpur BO": "497225",
      "Khod BO": "497225",
      "Tara BO": "497117",
      "Bhaiyathan SO": "497231",
      "Bhatgaon Colly SO": "497235",
      "Bishrampur SO Surguja": "497226",
      "Pratappur SO Surguja": "497223",
      "Surajpur SO": "497229",
      "Ramanujnagar SO": "497333"
    },
    "BALRAMPUR": {
      "Arabalrampur BO": "497001",
      "Dhandhapur BO": "497001",
      "Bardar BO": "497119",
      "Barion BO": "497001",
      "Parsa BO": "497001",
      "Chando BO": "497119",
      "Sendur BO": "497119",
      "Shahpur BO": "497119",
      "Baghima BO": "497001",
      "Kundikala BO": "497001",
      "Baskepi BO": "497119",
      "Maharajganj BO": "497119",
      "Karoundha BO": "497224",
      "Madguri BO": "497224",
      "Sabag BO": "497224",
      "Samri BO": "497224",
      "Umko BO": "497224",
      "Jigdi BO": "497118",
      "Kamari BO": "497118",
      "Chaki BO": "497220",
      "Sulsuli BO": "497225",
      "Kesari BO": "497225",
      "Dumarkholi BO": "497224",
      "Larima BO": "497224",
      "Bartikala BO": "497223",
      "Bhendri BO": "497223",
      "Jhalaria BO": "497118",
      "Bhulsikala BO": "497224",
      "Gajadharpur BO": "497224",
      "Jamirapath BO": "497224",
      "Rehda BO": "497224",
      "Kerta BO": "497223",
      "Chalgalikhas BO": "497223",
      "Dawra BO": "497118",
      "Dipadih BO": "497118",
      "Durgapur BO": "497118",
      "Ghughari BO": "497118",
      "Pasta BO": "497118",
      "Parsagudi BO": "497118",
      "Shankargarh BO": "497118",
      "Sewari BO": "497118",
      "Sihar BO": "497118",
      "Chandranagar BO": "497220",
      "Chhattarpur BO": "497220",
      "Chiniya BO": "497220",
      "Mitgai BO": "497220",
      "Ramchandrapur BO": "497220",
      "Sanawal BO": "497220",
      "Tatapani BO": "497220",
      "Birendranagar BO": "497225",
      "Gudru BO": "497225",
      "Janakpur BO": "497225",
      "Karamdiha BO": "497225",
      "Jawaharnagar BO": "497224",
      "Katima BO": "497224",
      "Ranhat BO": "497223",
      "Karra BO": "497118",
      "Lurgikala BO": "497118",
      "Narsinghpur BO": "497118",
      "Annapara BO": "497220",
      "Dolangi BO": "497220",
      "Ganjar BO": "497220",
      "Lodha BO": "497220",
      "Vijaynagar BO": "497220",
      "Basantpur BO": "497225",
      "Mahewa BO": "497225",
      "Pasupatipur BO": "497225",
      "Raghunathnagar BO": "497225",
      "Gopalpur BO": "497118",
      "Jhingo BO": "497118",
      "Kothali BO": "497118",
      "Manoharpur BO": "497118",
      "Aragahi Camp BO": "497220",
      "Krishnanagar BO": "497220",
      "Balangi BO": "497225",
      "Pendri BO": "497225",
      "Salwahi BO": "497225",
      "Kusmi SO": "497224",
      "Ramanujganj SO": "497220",
      "Wadrafnagar SO": "497225",
      "Balrampur SO": "497119",
      "Rajpur SIJ SO": "497118"
    },
    "KOREA": {
      "Mansukh BO": "497335",
      "Patrapali BO": "497335",
      "Banjaridand BO": "497335",
      "Barbaspur BO": "497335",
      "Budhar BO": "497335",
      "Chhinddand BO": "497335",
      "Kasra BO": "497335",
      "Nagar BO": "497335",
      "Udhanapur BO": "497449",
      "Banshipur BO": "497339",
      "Katgodi BO": "497339",
      "Kunwarpur BO": "497778",
      "Khamrodh BO": "497778",
      "Kotadol BO": "497778",
      "Mandisarai BO": "497778",
      "Gelhapani BO": "497559",
      "Kachhod BO": "497442",
      "Bseam Colly BO": "497447",
      "Bardar BO": "497449",
      "Koda BO": "497449",
      "Sons BO": "497449",
      "Deogarh BO": "497778",
      "Kamarjee BO": "497778",
      "Ramgarh BO": "497778",
      "Badsara BO": "497331",
      "Mahora BO": "497331",
      "Ranai BO": "497331",
      "Chirmi BO": "497449",
      "Devadand BO": "497449",
      "Katkona BO": "497449",
      "Rajouli BO": "497339",
      "Sonhat BO": "497339",
      "Baharasi BO": "497778",
      "Bhagwanpur BO": "497778",
      "Chanti BO": "497778",
      "Kathotiya BO": "497442",
      "Kelhari BO": "497442",
      "Nagpur BO": "497442",
      "Dumaria BO": "497331",
      "Gangoti BO": "497331",
      "Girjapur BO": "497331",
      "Katkona Colly BO": "497331",
      "Pondi BO": "497449",
      "Tamdand BO": "497449",
      "Ghaghra BO": "497778",
      "Kanjia BO": "497778",
      "Singrouli BO": "497778",
      "Ghutra BO": "497442",
      "Pandavpara BO": "497331",
      "Sarbhoka BO": "497331",
      "Tejpur BO": "497331",
      "Churcha Colly SO": "497339",
      "Godripara SO": "497555",
      "Jhagrakhand Colly SO": "497446",
      "Khadgawan SO": "497450",
      "West Jhagrakhand Colly SO": "497447",
      "West Chirimiri SO": "497773",
      "Korea Colly SO": "497559",
      "Manendragarh SO": "497442",
      "Baikunthpur SO": "497335",
      "Chirimiri Colly SO": "497449",
      "Janakpur SO": "497778",
      "Kurasia Colly SO": "497553",
      "Patna SO": "497331",
      "Haldibadi SO": "497451",
      "Sonawani Colly SO": "497557",
      "South Jhagrakhand Colly SO": "497448"
    },
    "JASHPUR": {
      "Pongro BO": "496223",
      "Sangibhawna BO": "496223",
      "Nakbar BO": "496223",
      "Nariyardand BO": "496223",
      "Barangjor BO": "496225",
      "Behrakhar BO": "496225",
      "Kandora BO": "496225",
      "Kurkunga BO": "496225",
      "Surangpani BO": "496113",
      "Pandaripani BO": "496242",
      "Pangsuwa BO": "496220",
      "Ghaghra BO": "496330",
      "Irai BO": "496330",
      "Karadari BO": "496330",
      "Sajapani BO": "496223",
      "Harradand BO": "496225",
      "Jamchuwan BO": "496225",
      "Kunjara BO": "496225",
      "Lodhma BO": "496225",
      "Bansajhal BO": "496245",
      "Bagbahar BO": "496220",
      "Jamargi BO": "496220",
      "Kadro BO": "496220",
      "Kotba BO": "496220",
      "Kukurbhuka BO": "496220",
      "Harri BO": "496330",
      "Kesra BO": "496330",
      "Diwanpur BO": "496118",
      "Palidih BO": "496118",
      "Tamta BO": "496118",
      "Gala BO": "496115",
      "Dobh BO": "496336",
      "Pandrapath BO": "496336",
      "Sardhapath BO": "496336",
      "Kandaibahar BO": "496227",
      "Kersai BO": "496227",
      "Saraipani BO": "496223",
      "Gorea BO": "496225",
      "Jokbahla BO": "496225",
      "Narayanpur BO": "496225",
      "Ranpur BO": "496225",
      "Pithama BO": "496113",
      "Ankira BO": "496245",
      "Bhelwan BO": "496245",
      "Jamjhor BO": "496220",
      "Kokiakhar BO": "496220",
      "Kolhejharia BO": "496220",
      "Kukurgaon BO": "496220",
      "Bhimsela BO": "496330",
      "Gharjiabandhan BO": "496118",
      "Pakargaon BO": "496118",
      "Sureshpur BO": "496118",
      "Semarkachhar BO": "496223",
      "Ghatmunda BO": "496225",
      "Ginabahar BO": "496225",
      "Kaliba BO": "496225",
      "Raikera BO": "496224",
      "Dumaria BO": "496245",
      "Konpara BO": "496245",
      "Tumla BO": "496245",
      "Buldega BO": "496220",
      "Chiknipani BO": "496220",
      "Farsatoli BO": "496220",
      "Sekharpur BO": "496220",
      "Bildegi BO": "496220",
      "Asta BO": "496330",
      "Gajma BO": "496330",
      "Karmitikra BO": "496118",
      "Sukrapara BO": "496118",
      "Dumarkona BO": "496336",
      "Ekamba BO": "496336",
      "Purainbandha BO": "496227",
      "Singibahar BO": "496227",
      "Tildega BO": "496118",
      "Bahora BO": "496336",
      "Champakhudia BO": "496336",
      "Saraitoli BO": "496336",
      "Sonkyari BO": "496336",
      "Sulesha BO": "496336",
      "Jambahar BO": "496227",
      "Lathbora BO": "496227",
      "Pasia BO": "496224",
      "Rauni BO": "496224",
      "Sarabkombo BO": "496224",
      "Kalaru BO": "496331",
      "Bandarchuwan BO": "496223",
      "Bataikela BO": "496223",
      "Chongaribahar BO": "496223",
      "Lukhi BO": "496330",
      "Kamarima BO": "496336",
      "Kewai BO": "496336",
      "Nanhesar BO": "496336",
      "Kurdeg BO": "496224",
      "Kurrog BO": "496224",
      "Musgutri BO": "496224",
      "Pirai BO": "496224",
      "Rengle BO": "496224",
      "Kastura BO": "496334",
      "Makribandha BO": "496334",
      "Patratoli BO": "496338",
      "Khutgaon BO": "496242",
      "Lodam BO": "496338",
      "Gamharia BO": "496331",
      "Jaria BO": "496331",
      "Sogda BO": "496331",
      "Chheraghoghara BO": "496223",
      "Deori BO": "496223",
      "Ghughari BO": "496224",
      "Karma BO": "496224",
      "Jaikari BO": "496334",
      "Keradih BO": "496334",
      "Bhagora BO": "496242",
      "Bada Karonja BO": "496338",
      "Lokhandi BO": "496338",
      "Paiku BO": "496338",
      "Arra BO": "496331",
      "Ichkela BO": "496331",
      "Sitonga BO": "496331",
      "Chetba BO": "496223",
      "Jumaikela BO": "496223",
      "Khutera BO": "496223",
      "Bachhraon BO": "496224",
      "Bhitghara BO": "496224",
      "Bimda BO": "496224",
      "Durgapara BO": "496224",
      "Jhinki BO": "496224",
      "Marol BO": "496224",
      "Bangurkela BO": "496334",
      "Basantala BO": "496334",
      "Charaidand BO": "496334",
      "Dandadih BO": "496334",
      "Simda BO": "496334",
      "Menderbahar BO": "496242",
      "Sahaspur BO": "496242",
      "Pilkhi BO": "496338",
      "Portenga BO": "496338",
      "Kasira BO": "496331",
      "Kharsota BO": "496331",
      "Komdo BO": "496331",
      "Dokada BO": "496223",
      "Ghoghar BO": "496223",
      "Kunkuri SO": "496225",
      "Ludeg SO": "496220",
      "Sanna SO": "496336",
      "Duldula SO": "496334",
      "Gholeng SO": "496338",
      "Manora SO Jashpur": "496330",
      "Pathalgaon SO": "496118",
      "Tapkara SO": "496227",
      "Farsabahar SO": "496242",
      "Kansabel SO": "496223",
      "Lawakera SO": "496245",
      "Bagicha SO": "496224",
      "Jashpurnagar SO": "496331"
    }
  },
  "TAMIL NADU": {
    "TIRUCHIRAPPALLI": {
      "ETTARAI S.O.": "639103",
      "Ariyur BO": "621702",
      "Konnagudi BO": "621702",
      "Sengaraiyur BO": "621702",
      "Alangudi Mahajanam BO": "621702",
      "Athigudi BO": "621702",
      "Manakkal BO": "621703",
      "Nagar BO": "621703",
      "Sathamangalam BO": "621703",
      "Sivankoil BO": "621703",
      "Thirumangalam BO": "621703",
      "Kuhur BO": "621703",
      "Manthurai BO": "621703",
      "Ikkaraikosikurichi B.O": "621314",
      "Seegampatti B.O": "621312",
      "Pillupatti B.O": "621314",
      "Sevalpatti B.O": "621314",
      "Chithanatham B.O": "621312",
      "Adhigaram B.O": "621314",
      "Karaipatti B.O": "621314",
      "Palayapalayam B.O": "621314",
      "Kannudayanpatti B.O": "621312",
      "Kanjanaickenpatti B.O": "621314",
      "Thethur B.O": "621314",
      "Uthukuli B.O": "622102",
      "Vembanur B.O": "622102",
      "Karumakavundanpatti B.O": "621307",
      "Malayadipatti B.O": "621307",
      "Nallampillai B.O": "621307",
      "Poosaripatti B.O": "621307",
      "Vengaikurichi B.O": "621307",
      "T.Idayapatti B.O": "621308",
      "Alagagoundanpatti B.O": "621310",
      "Anampatti B.O": "621312",
      "Keelarasur BO": "621653",
      "Alundalaipur BO": "621651",
      "Peruvalappur BO": "621651",
      "Thinniam BO": "621706",
      "Sembarai BO": "621706",
      "Kovandakurichi BO": "621711",
      "Kumulur BO": "621712",
      "Pallapuram BO": "621712",
      "Edayathimangalam BO": "621218",
      "Alambadi BO": "621722",
      "Aniyapur B.O": "621307",
      "A.Pudupatti B.O": "621308",
      "Tirunellipatti B.O": "621310",
      "Karumalai B.O": "621310",
      "Varakuppai BO": "621651",
      "Mettupatti BO": "621706",
      "Mullal BO": "621706",
      "Sirumayankudi BO": "621706",
      "Punjai Sangentai BO": "621711",
      "Vandalaigudalur BO": "621711",
      "Unaiyur B.O": "622102",
      "Alambakkam BO": "621711",
      "Nathamangudi BO": "621711",
      "Pudurpalayam BO": "621711",
      "Agalanganallur BO": "621712",
      "Pudur Uthamanur BO": "621712",
      "Thachankurichi BO": "621712",
      "Periavarsili BO": "621218",
      "Tirumanamedu BO": "621218",
      "Jiyapuram BO": "639101",
      "Sevalur B.O": "621306",
      "Andavarkovil B.O": "621306",
      "Chettiapatti B.O": "621307",
      "Vellalapatti B.O": "621211",
      "Ayanporuvai B.O": "621308",
      "Kodumbapatti B.O": "621308",
      "Valanadu B.O": "621308",
      "Endapuli B.O": "621310",
      "Karuppur (Manaparai) B.O": "621310",
      "Firka Kilaiyur B.O": "621312",
      "Malvoy Kannanur BO": "621652",
      "Kanakiliyanallur BO": "621651",
      "Sirukalappur BO": "621651",
      "Vadugarpet BO": "621651",
      "Melaperungavur BO": "621218",
      "Melavalady BO": "621218",
      "Karungulam B.O": "621315",
      "Nadupatti B.O": "621315",
      "Periya Anaikaraipatti B.O": "621315",
      "KSathanur BO": "620021",
      "Pulangulathupatti BO": "620009",
      "Perugamani BO": "639115",
      "Manalodai B.O": "621002",
      "Pudur B.O": "621002",
      "T.Sathanur B.O": "621004",
      "Karattampatti B.O": "621014",
      "Singalandapuram B.O": "621014",
      "Omandur B.O": "621006",
      "Peramangalam B.O": "621006",
      "T.Narasingapuram B.O": "621008",
      "Venkatesapuram B.O": "621008",
      "Neiveli B.O": "621217",
      "T pudupatti B.O": "621217",
      "Arachi B.O": "621214",
      "Puthur B.O": "621011",
      "Sirugamani BO": "639115",
      "Kannakudi BO": "621711",
      "Venkatachalapuram BO": "621711",
      "Edangimangalam BO": "621712",
      "Peruvalanallur BO": "621712",
      "Esanakorai BO": "621218",
      "Kulamanickam BO": "621722",
      "Kumaravadi B.O": "621302",
      "Thottiapatti B.O": "621305",
      "Muthapudayanpatti B.O": "621306",
      "Thanneerpallam B.O": "621011",
      "Top Sengattupatti B.O": "621011",
      "Venkatachalapuram B.O": "621011",
      "Sircarpalayam BO": "620010",
      "Koppu BO": "639103",
      "Kilakurichi BO": "620011",
      "Asoor BO": "620015",
      "Ayyampatti BO": "620015",
      "Thuvakudi BO": "620015",
      "Navalpattu BO": "620016",
      "Navalurkottapattu BO": "620009",
      "Paganur BO": "620009",
      "Malliampattu BO": "620102",
      "Pallakadu BO": "620102",
      "Sirathope BO": "620102",
      "Natarajapuram BO": "620013",
      "Pathalapettai BO": "620013",
      "Vengur BO": "620013",
      "Kodiyalam BO": "639115",
      "Salainagar BO": "620003",
      "Padiripatti B.O": "621306",
      "Amayapuram B.O": "621307",
      "Avarampatti B.O": "621307",
      "Kalingapatti B.O": "621308",
      "Thenur (Manaparai) B.O": "621308",
      "Kannivadugapatti B.O": "621310",
      "Maniyankurichi B.O": "621310",
      "Thavalaveeranpatti B.O": "621311",
      "Malvoy BO": "621652",
      "Melarasur BO": "621652",
      "Tappay BO": "621651",
      "Sembulichampatti B.O": "621002",
      "Sengattupatti B.O": "621002",
      "Sorathur B.O": "621002",
      "T.Renganathapuram B.O": "621002",
      "Nettavelampatti B.O": "621003",
      "Naduvalur B.O": "621004",
      "Angiyam B.O": "621210",
      "Kargudi B.O": "621210",
      "Karikali B.O": "621210",
      "Pillapalayam B.O": "621210",
      "Abinimangalam B.O": "621007",
      "Edumalai B.O": "621007",
      "Govindapuram B.O": "621008",
      "Kalingamudayanpatti B.O": "621008",
      "Thiruthalaiyur B.O": "621217",
      "Porathakudi B.O": "621302",
      "V.Periyapatti B.O": "621302",
      "Valayapatti (Manaparai) B.O": "621302",
      "Elamanam B.O": "621302",
      "Mutalvarapatti B.O": "621305",
      "Paluvanji B.O": "621305",
      "Piranpatti  (Manaparai) B.O": "621305",
      "Tadakkavundanpatti B.O": "621305",
      "K.Periyapatti B.O": "621306",
      "Samudram B.O": "621312",
      "Velakkanatham B.O": "621217",
      "Devanur B.O": "621214",
      "Vadamalaipatti B.O": "621214",
      "Valasiramani B.O": "621214",
      "T.Baderpettai B.O": "621012",
      "T.Murungaipatti B.O": "621012",
      "Thalugaimangapattipudur B.O": "621012",
      "Kalpatti B.O": "621315",
      "Ponnaiar Dam B.O": "621315",
      "Mekkudi BO": "639101",
      "Fathimanagar BO": "620012",
      "Nagamangalam BO": "620012",
      "Palanganangudi BO": "620025",
      "Kamarajanagar BO": "620010",
      "Inampuliyur BO": "639103",
      "Kilakalkandarkottai BO": "620011",
      "Allur BO": "620101",
      "Valavandankottai BO": "620015",
      "Pudukottai BO": "639112",
      "Pirattiyur BO": "620009",
      "Inamkulathur BO": "620009",
      "Adavathur BO": "620102",
      "Uyyakondanthirumalai BO": "620102",
      "Arasangudi BO": "620013",
      "Malaiadivaram BO": "620013",
      "Inamponnambalapatti B.O": "621315",
      "Kannuthu B.O": "621315",
      "Pudukkottai (Vaiyampatti) B.O": "621315",
      "Thoppanaickenpatti B.O": "621315",
      "Manikandam BO": "620012",
      "Suriyur BO": "620025",
      "Ariyamangalam BO": "620010",
      "Ettarai BO": "639103",
      "Alathur BO": "620011",
      "Kambarasampettai BO": "620101",
      "Tirunedungulam BO": "620015",
      "Ariyavur BO": "620009",
      "Kumaravayalur BO": "620102",
      "Maruthandakurichi BO": "620102",
      "Thayanur BO": "620102",
      "Koothappar BO": "620013",
      "Gundur BO": "620007",
      "Maruvathur B.O": "621002",
      "Vengadathanur B.O": "621002",
      "Alathudayanpatti B.O": "621003",
      "B.Mettur B.O": "621003",
      "Maradi B.O": "621003",
      "Pachaperumalpatti B.O": "621003",
      "Muthiyampalayam B.O": "621004",
      "M.Karuppampatti B.O": "621220",
      "Adhanur B.O": "621014",
      "Kaliyampatti B.O": "621014",
      "Mambarai B.O": "621006",
      "Thinnanur B.O": "621006",
      "Murukkur B.O": "621008",
      "Oddampatti B.O": "621008",
      "Jadamangalam B.O": "621214",
      "Mahadevi B.O": "621214",
      "Urakkarai B.O": "621214",
      "Naganallur B.O": "621012",
      "Mohavanur B.O": "621302",
      "Palayakottai B.O": "621302",
      "Marungapuri B.O": "621305",
      "Alipatti B.O": "621306",
      "Pannankombu B.O": "621306",
      "Thinnakonam B.O": "621202",
      "Kuthur B.O": "621216",
      "Thalakudi B.O": "621216",
      "Thiruvasi B.O": "621216",
      "Amur B.O": "621204",
      "Sithambur B.O": "621204",
      "Vathalai Gudalur B.O": "621204",
      "Nedungur B.O": "621105",
      "Periyakurukkai B.O": "621105",
      "Siruganur B.O": "621105",
      "Tirupattur B.O": "621105",
      "Unniyur B.O": "621207",
      "Neeliampatti B.O": "621208",
      "Poolancheri B.O": "621208",
      "Sergudi B.O": "621208",
      "Surampatti B.O": "621208",
      "Alagiamanavalam B.O": "621005",
      "Rajampalayam B.O": "621005",
      "M.Pudupatti B.O": "621211",
      "Mettupatti B.O": "621211",
      "Arasalur B.O": "621203",
      "Thirunarayanapuram B.O": "621203",
      "Konalai B.O": "621105",
      "Chinnapallipalayam B.O": "621207",
      "Nagaiyanallur B.O": "621207",
      "Silaipillaiyarputhur B.O": "621207",
      "Ammangudi B.O": "621208",
      "Konappampatti B.O": "621208",
      "Kariyamanickam B.O": "621005",
      "Thiruvengimalai B.O": "621209",
      "Valavandhi B.O": "621211",
      "Todaiyur B.O": "621213",
      "Odayalampudur B.O": "621215",
      "Uthamaseri B.O": "620005",
      "Poonampalayam B.O": "621009",
      "Sirupathur B.O": "621009",
      "Kottaiyur B.O": "621001",
      "Reddiapatti B.O": "621001",
      "Perur B.O": "621205",
      "Valaiyeduppu B.O": "621205",
      "Iyyampalayam B.O": "621206",
      "Kattanampatti B.O": "621206",
      "Veeramanipatti B.O": "621202",
      "Velur ayyampalayam B.O": "621202",
      "M.Puthur B.O": "621203",
      "Kaduvetti B.O": "621207",
      "Kidaram B.O": "621207",
      "Murungai B.O": "621207",
      "Murungai Kalathur B.O": "621207",
      "Tattamangalam B.O": "621005",
      "Tirupanjili B.O": "621005",
      "Valaiyur B.O": "621005",
      "Alagarai B.O": "621209",
      "Srinivasanallur B.O": "621209",
      "Sittalarai B.O": "621211",
      "Thumbalam B.O": "621211",
      "Neikuppai B.O": "621111",
      "R.Valavanur B.O": "621111",
      "Tholurpatti B.O": "621215",
      "Varadarajapuram B.O": "621215",
      "Yelurpatti B.O": "621215",
      "Jayankondam B.O": "621205",
      "Mangalam B.O": "621205",
      "Mavilipatti B.O": "621205",
      "Devarappampatti B.O": "621206",
      "K.Palayam B.O": "621206",
      "Kurichi B.O": "621002",
      "Nagalapuram B.O": "621002",
      "Sellipalayam B.O": "621002",
      "Balakrishnampatti B.O": "621003",
      "Viswambalsamudram B.O": "621003",
      "Kilakunnupatti B.O": "621004",
      "Alagapuri B.O": "621210",
      "Ammapatti B.O": "621014",
      "Kalladipatti B.O": "621014",
      "Moovanur B.O": "621006",
      "Tiruthiamalai B.O": "621006",
      "Natham Balasamudram B.O": "621203",
      "Okkarai B.O": "621008",
      "Perumalpalayam B.O": "621008",
      "Thandalai B.O": "621217",
      "Jambumadai B.O": "621214",
      "Nachilipatti B.O": "621011",
      "Sobanapuram B.O": "621011",
      "Koppampatti B.O": "621012",
      "N.Poolampatti B.O": "621302",
      "Pannipatti B.O": "621302",
      "Kallupatti B.O": "621305",
      "Yagapuram B.O": "621305",
      "Evur B.O": "621202",
      "Devimangalam B.O": "621112",
      "Pallividai B.O": "621112",
      "Cholanganallur B.O": "621213",
      "Kilianallur B.O": "621213",
      "Pukkathurai B.O": "621213",
      "Melur B.O": "620006",
      "Arangoor B.O": "621215",
      "Minnathampatti B.O": "621215",
      "Sangampatti B.O": "621001",
      "Senappanallur B.O": "621001",
      "Sirunavalur B.O": "621001",
      "Vishalakshi Ammal Samudram B.O": "621001",
      "Ponnusangampatti B.O": "621206",
      "Kinathur B.O": "621002",
      "Poigaipatti B.O": "621306",
      "Ootathur B.O": "621109",
      "Seedevimangalam B.O": "621109",
      "Sundaikkai B.O": "621202",
      "Nochiam B.O": "621216",
      "Reddimangudi B.O": "621105",
      "Pidaramangalam B.O": "621207",
      "Sriramasamudram B.O": "621207",
      "Appanallur B.O": "621208",
      "C.Ayyampalayam B.O": "621005",
      "Kalpalayam B.O": "621005",
      "Kovathakudi B.O": "621005",
      "A.A. College B.O": "621211",
      "Marudur B.O": "621112",
      "Sennakarai B.O": "621213",
      "Kamalapuram B.O": "621215",
      "Servaikaranpatti B.O": "621215",
      "Thalamalaipatti B.O": "621215",
      "Tiruvalarsolai B.O": "620005",
      "Kattukulam B.O": "621009",
      "Baderpettai B.O": "621001",
      "Nagamanaickenpatti B.O": "621001",
      "Paithamparai B.O": "621205",
      "Thulayanatham B.O": "621205",
      "Kothampatti B.O": "621206",
      "Veeramachampatti B.O": "621206",
      "Chinnakodunthurai B.O": "621202",
      "Tiruchirappalli HO": "620001",
      "Srirangam H.O": "620006",
      "T.Valaiyur B.O": "621104",
      "Garudamangalam B.O": "621106",
      "Lalgudi HO": "621601",
      "Turaiyur H.O": "621010",
      "Shanamangalam B.O": "621104",
      "Perahambi B.O": "621104",
      "Irungalur S.O": "621105",
      "Manamedu S.O": "621209",
      "Parvathipuram S.O": "621211",
      "Purathakudi S.O": "621111",
      "Srinivasanagar S.O (Tiruchirappalli)": "620005",
      "Uppliapuram S.O": "621011",
      "Vyrichettipalayam S.O": "621012",
      "Kattuputhur S.O": "621207",
      "Kondayampettai S.O": "620005",
      "Musiri S.O": "621211",
      "Renganagar S.O": "620006",
      "Samayapuram S.O": "621112",
      "Sirugambur S.O": "621213",
      "Srirangam North S.O": "620006",
      "Jambunathapuram S.O": "621205",
      "Kannanur S.O": "621206",
      "Kirambur S.O": "621002",
      "Kottapalayam S.O": "621003",
      "Pagalavadi S.O": "621014",
      "Pulivalam S.O (Tiruchirappalli)": "621006",
      "Puthanampatti S.O": "621007",
      "Thandalaiputhur S.O": "621217",
      "Thathiengarpet S.O": "621214",
      "Srirangam West S.O": "620006",
      "Thottiam S.O": "621215",
      "Tiruvanaikoil S.O": "620005",
      "Erakudi S.O": "621001",
      "Kottathur S.O": "621004",
      "Mettupalayam S.O": "621210",
      "Sikkathambur S.O": "621008",
      "Kolakkudi S.O": "621208",
      "Manachanalloor S.O": "621005",
      "Tiruvellerai S.O": "621009",
      "Turaiyur Bus Stand S.O": "621010",
      "Turaiyur Extension S.O": "621010",
      "Balasamudram S.O (Tiruchirappalli)": "621203",
      "Ammamandapam S.O": "620006",
      "EVR Nagar S.O": "620005",
      "Gunasilam S.O": "621204",
      "Ayyampalayam S.O": "621202",
      "Bikshandarkoil S.O": "621216",
      "Ambil SO": "621702",
      "Kallagam SO": "621653",
      "Puvalur SO": "621712",
      "Valady SO": "621218",
      "Ambikapuram SO Tiruchirappalli": "620004",
      "Golden Rock North SO": "620004",
      "Hapf Township SO": "620025",
      "Kamarajapuram BHEL SO": "620014",
      "Kulumani SO": "639103",
      "Mutharasanallur SO": "620101",
      "National Institute of Technology SO": "620015",
      "Pettavaithalai SO": "639112",
      "Ponniah School Buildings SO": "620001",
      "Ramjeenagar SO": "620009",
      "Thuvakudimalai SO": "620022",
      "Tiruchirappalli Collectorate SO": "620001",
      "Tiruchirappalli Townhall SO": "620002",
      "Tamilnadu National Law School SO": "620027",
      "Viragalur SO": "621722",
      "Andanallur SO": "639101",
      "Boiler Project  TR SO": "620014",
      "C Sector BHEL  TR SO": "620014",
      "Jainagar SO Tiruchirappalli": "620013",
      "Jamal Mohamed College SO": "620020",
      "Ordnance Estate  TR SO": "620016",
      "Pappakurichi Kattur SO": "620019",
      "Puthur SO": "620017",
      "Rock Fort SO": "620002",
      "Thiruverumbur SO": "620013",
      "Tiruchirappalli Airport SO": "620007",
      "Kallakudi TR SO": "621651",
      "Administrative OfficeBHEL SO": "620014",
      "Annanagar SO": "620026",
      "Clock Tower SO Tiruchirappalli": "620008",
      "Edamalaipatti Pudur SO": "620012",
      "Khajamalai Colony SO": "620020",
      "Melakalkandarkottai SO": "620011",
      "Palakkarai SO": "620008",
      "Ponnagar SO": "620001",
      "Senthanneerpuram SO": "620004",
      "Somarasampettai SO": "620102",
      "Elangakurichi S.O": "621302",
      "Manaparai S.O": "621306",
      "Palakurichi S.O": "621308",
      "Kovilpatti S.O": "621305",
      "Thiagesaralai S.O": "621312",
      "Vaiyampatti S.O": "621315",
      "Angarai SO": "621703",
      "Kallakudi North SO": "621652",
      "Kattur Puvalur SO": "621706",
      "Subramaniapuram SO Tiruchirappalli": "620020",
      "Sundararajanagar SO": "620020",
      "Teppakulam SO": "620002",
      "Tirupparaithurai SO": "639115",
      "Puthanatham S.O": "621310",
      "Thuvarankurichi S.O": "621314",
      "Pullambadi SO": "621711",
      "Bharathidasan University SO": "620024",
      "Bheemanagar SO": "620001",
      "Craw Ford Colony SO": "620012",
      "Golden Rock Market SO": "620004",
      "Golden Rock SO": "620004",
      "Industrial Colony SO": "620010",
      "KKNagar SO Tiruchirappalli": "620021",
      "Khajanagar SO": "620023",
      "Mannarpuram SO": "620020",
      "P and T Colony SO Tiruchirappalli": "620020",
      "Pushpanagar SO": "620001",
      "Tennur SO": "620017",
      "Thillai Nagar SO": "620018",
      "Tiruchirappalli Cantonment SO": "620001",
      "Tiruchirappalli Fort SO": "620008",
      "Tiruchirappalli RS SO": "620001",
      "Woriur Bazaar SO": "620003",
      "Woriur SO": "620003",
      "Manjampatti S.O": "621307"
    },
    "VILLUPURAM": {
      "Valudareddy S.O": "605403",
      "Sevalapuri BO": "604202",
      "Mahadevimangalam BO": "604210",
      "Pennagar BO": "604210",
      "Sholangunam BO": "604210",
      "Thamanur BO": "604210",
      "Thailapuram BO": "604102",
      "Thensiruvalur BO": "604102",
      "Eraiyanur BO": "604102",
      "Muppuli BO": "604302",
      "Peramandur BO": "604302",
      "Thenpasiyar BO": "604302",
      "Thaludali BO": "604304",
      "Tiruvakkarai BO": "604304",
      "Alathur BO": "604303",
      "Eyyal BO": "604204",
      "Melsevalambadi BO": "604204",
      "Periyanolambai BO": "604204",
      "Siruthalaipoondi BO": "604204",
      "Vadapalai BO": "604204",
      "Melpettai BO": "604307",
      "Semmedu BO": "604153",
      "Sokuppam BO": "604153",
      "Neganur BO": "604202",
      "Chinnanerkunam BO": "604302",
      "Kiledayalam BO": "604302",
      "Padirapuliyur BO": "604304",
      "Perumbakkam BO": "605301",
      "Nadukuppam BO": "604303",
      "Pudupakkam BO": "604303",
      "Thalangadu BO": "604303",
      "Anangur BO": "605103",
      "Annamangalam BO": "604210",
      "Kadali BO": "604210",
      "Omandur BO": "604102",
      "Alagramam BO": "604302",
      "Thenkalavoy BO": "604302",
      "Veliyanur BO": "604304",
      "Anumandai BO": "604303",
      "Kunimedu BO": "604303",
      "Theppirampattu BO": "604204",
      "Aviyur BO": "604203",
      "Pallikulam BO": "604203",
      "Kappai BO": "604205",
      "Thalavanur BO": "604205",
      "Thiruvathikunnam BO": "604205",
      "Athipattu BO": "604152",
      "Thadagam BO": "604152",
      "Ongur BO": "604305",
      "Melsevur BO": "604306",
      "Nolambur BO": "604307",
      "Panchalam BO": "604307",
      "Palapadi BO": "604153",
      "Guduvampoondi BO": "604208",
      "Kallapuliyur BO": "604208",
      "Arugavur BO": "604203",
      "Konai BO": "604205",
      "Kurinjipai BO": "604205",
      "Palapattu BO": "604205",
      "Thaiyur BO": "604205",
      "Nedimoliyanur BO": "604306",
      "Thenputhur BO": "604306",
      "Vengandur BO": "605402",
      "Athur BO": "604307",
      "Ayyanthoppu BO": "604307",
      "Endiyur BO": "604307",
      "Kattalai BO": "604307",
      "Ural BO": "604307",
      "Devandavadi BO": "604208",
      "Devanur BO": "604208",
      "Molasur BO": "604102",
      "Thenkodipakkam BO": "604102",
      "Chendur BO": "604302",
      "Pelakuppam BO": "604302",
      "Singanur BO": "604302",
      "Eraiyur BO": "604304",
      "Kandadu BO": "604303",
      "Mandava BO": "604303",
      "Eyyakunam BO": "604204",
      "Manandal BO": "604204",
      "Sathambadi BO": "604204",
      "Thayanur BO": "604204",
      "Thorapadi BO": "604204",
      "Eachur BO": "604203",
      "Viranamur BO": "604203",
      "Thiruvampattu BO": "604205",
      "Sepettai BO": "604152",
      "Velanthangal BO": "604152",
      "Kiladanur BO": "604305",
      "Kongarapattu BO": "604306",
      "Nallathur BO": "604307",
      "Pakkam BO": "605106",
      "Palavalam BO": "606754",
      "Kuilapalayam BO": "605101",
      "Bommayarpalayam BO": "605104",
      "Kaluperumbakkam BO": "605014",
      "Viranam BO": "605106",
      "Kilpudupattu BO": "605014",
      "Mandagapet BO": "605106",
      "Morattandi BO": "605101",
      "Peruvalur BO": "604208",
      "Naduvanandal BO": "604207",
      "Vairapuram BO": "604207",
      "Karai BO": "605201",
      "Karuvakshi BO": "605201",
      "Konalur BO": "605201",
      "Kalayampoondi BO": "605202",
      "Melkaranai BO": "605202",
      "Nangathur BO": "605202",
      "Porur BO": "605202",
      "Sangeethamangalam BO": "605202",
      "Nannadu BO": "605301",
      "Orukodi BO": "605301",
      "Periyababusamudram BO": "605102",
      "Maragadhapuram BO": "605401",
      "Pidagam BO": "605401",
      "Valudareddy BO": "605401",
      "Salamedu BO": "605401",
      "Akkur BO": "604207",
      "Athipakkam BO": "604207",
      "Dadapuram BO": "604207",
      "Karuvambakkam BO": "604207",
      "Thaniyal BO": "604207",
      "Chinnababusamudram BO": "605102",
      "Pallithennal BO": "605102",
      "Melvailamur BO": "604201",
      "Naranamangalam BO": "604201",
      "Nochalur BO": "604201",
      "Kilsiviri BO": "604301",
      "Perumukkal BO": "604301",
      "Melidayalam BO": "604202",
      "Melmannur BO": "604208",
      "Kattusiviri BO": "604207",
      "Kodiyam BO": "604207",
      "Karattai BO": "604154",
      "Olagapuram BO": "604154",
      "Anaiyeri BO": "605201",
      "Panamalai BO": "605201",
      "VMathur BO": "605107",
      "Konur BO": "605301",
      "Athiyur Thiruvadi BO": "605401",
      "Kandambakkam BO": "605401",
      "Kolathur BO": "604301",
      "Munnur BO": "604301",
      "Nagar BO": "604301",
      "Alankuppam BO": "604301",
      "Omipper BO": "604301",
      "Siruvadi BO": "604301",
      "Vaidapakkam BO": "604301",
      "Anathur BO": "604202",
      "Jayankondam BO": "604202",
      "Kodukkur BO": "605501",
      "Korakeni BO": "605501",
      "Madurapakkam BO": "605501",
      "Tirumangalam BO": "605501",
      "VNerkunam BO": "605501",
      "Vakkur BO": "605501",
      "Pulichapallam BO": "605109",
      "Semangalam BO": "605109",
      "VParangini BO": "605109",
      "Rayapudupakkam BO": "605111",
      "Avanipur BO": "604101",
      "Kilsevur BO": "604101",
      "Kunnapakkam BO": "604101",
      "Pankolathur BO": "604101",
      "Kanakkankuppam BO": "604151",
      "Nayambadi BO": "604151",
      "Padipallam BO": "604151",
      "Perungappur BO": "604151",
      "Kovilporaiyur BO": "604201",
      "Marakonam BO": "604208",
      "Kilmavilangai BO": "604207",
      "Melathipakkam BO": "604207",
      "Nallavur BO": "604154",
      "Athiyur BO": "605201",
      "Ponnankuppam BO": "605201",
      "Kappur BO": "605301",
      "Kondangi BO": "605301",
      "Asokapuri BO": "605203",
      "Kadambur BO": "604206",
      "Kalaiyur BO": "604206",
      "Thalangunam BO": "604201",
      "Adavallikoothan BO": "604301",
      "Vadanerkunam BO": "604301",
      "Melacheri BO": "604202",
      "Arasur B.O": "607107",
      "Enathimangalam B.O": "607107",
      "Sithanangur B.O": "607107",
      "Andrayanur B.O": "605803",
      "T  . Kunnathur B.O": "605803",
      "T  . Pudupalayam B.O": "605803",
      "Kollar BO": "604206",
      "Devanur B.O": "605752",
      "V . Puthur B.O": "605752",
      "Alambadi B.O": "605701",
      "Athiyur Thirukkai B.O": "605701",
      "Malavanthangal B.O": "605701",
      "Melvalai B.O": "605701",
      "Nallapalayam B.O": "605701",
      "Karanai B.O": "605755",
      "Paranur B.O": "605755",
      "S.Kodungal B.O": "605755",
      "Sathiyakandanur B.O": "605755",
      "Amur B.O": "607209",
      "Manakuppam B.O": "607209",
      "Vadamarudur B.O": "605803",
      "Kongarayanur B.O": "607203",
      "Marangiyur B.O": "607203",
      "Paiyur B.O": "607203",
      "Sirumadurai B.O": "607203",
      "Melsithambur BO": "604206",
      "Tivanur BO": "604206",
      "Irumbai BO": "605111",
      "Mutrampattu BO": "605501",
      "Katrampakkam BO": "605109",
      "Olundiyapattu BO": "605109",
      "Devadanampettai BO": "604151",
      "Thenpalai BO": "604151",
      "Kappalambadi BO": "604201",
      "Hemerjickz centre BO": "605111",
      "Poothurai BO": "605111",
      "Radhapuram BO": "605501",
      "Seshanganur BO": "605501",
      "Andapattu BO": "604101",
      "Kalleri BO": "604151",
      "Manalapadi BO": "604151",
      "Periyamur BO": "604151",
      "Thandavasamudram BO": "604151",
      "Idapattu BO": "604201",
      "Kottapoondi BO": "604201",
      "Vilukkam BO": "604206",
      "Kundalapuliyur BO": "605203",
      "Muttathur BO": "605203",
      "Nemur BO": "605203",
      "Vembi BO": "605203",
      "Ariyalur Tirukkai BO": "605402",
      "Karnavur BO": "604302",
      "Kakkanur BO": "605402",
      "Viramur BO": "605402",
      "Pillur BO": "605103",
      "Poyyapakkam BO": "605103",
      "Serndanur BO": "605103",
      "Teli BO": "605302",
      "Orathur BO": "605601",
      "Panayapuram BO": "605601",
      "TMettupalayam BO": "605601",
      "Perani BO": "605651",
      "Pidaripattu BO": "605651",
      "SeKunnatur BO": "605651",
      "Arpisampalayam BO": "605108",
      "Vadakaraithayanur B.O": "605752",
      "Odiyathur B.O": "605701",
      "Sithathur B.O": "605701",
      "Arulavadi B.O": "605755",
      "Kadaganur B.O": "605755",
      "Sennakunam B.O": "605755",
      "Eruvelipattu B.O": "607107",
      "Pavandur B.O": "607209",
      "Arunkurukkai B.O": "605803",
      "Elrampattu B.O": "605803",
      "Emappur B.O": "607203",
      "Kannarampattu B.O": "607203",
      "T  . Edayar B.O": "607203",
      "Adichanur B.O": "605758",
      "Vasanthakrishnapuram B.O": "605758",
      "Gengarampalayam BO": "605108",
      "Kallapattu BO": "605108",
      "Kumarakuppam BO": "605108",
      "Adanur BO": "605402",
      "Panampattu BO": "605103",
      "Kallipattu BO": "605105",
      "Rampakkam BO": "605105",
      "Venkatadri Agaram BO": "605105",
      "Kumulam BO": "605107",
      "Palayam BO": "605107",
      "VNallalam BO": "605651",
      "Kadaperikuppam BO": "605502",
      "Asur BO": "605652",
      "Avadayarpattu BO": "605652",
      "Melakondai BO": "605652",
      "VSathanur BO": "605652",
      "Vidur BO": "605652",
      "Vidur Dam BO": "605652",
      "Modaiyur BO": "604206",
      "Melthaniyalampattu B.O": "607101",
      "Pilrampattu B.O": "605701",
      "Vengamur B.O": "605701",
      "Arcadu B.O": "605755",
      "Ayandur B.O": "605755",
      "Arumpattu B.O": "607107",
      "Semmar B.O": "607107",
      "Saravanapakkam B.O": "607209",
      "C Meyyur B.O": "605803",
      "Edapalayam B.O": "605803",
      "Kottamarudur B.O": "605756",
      "Gramam B.O": "607203",
      "Thaduthatkondur B.O": "607203",
      "Oddampattu B.O": "605758",
      "Brahmadesam BO": "605203",
      "Siruvalai BO": "605402",
      "Thiruvamathur BO": "605402",
      "Tirupachanur BO": "605103",
      "Kalpattu BO": "605302",
      "Mettupalayam BO": "605105",
      "Ayyur Agaram BO": "605601",
      "Kappiyampuliyur BO": "605601",
      "Kilmambattu BO": "605651",
      "Negandur BO": "605651",
      "Salayampalayam BO": "605108",
      "Sithani BO": "605652",
      "VSalai BO": "605652",
      "Kottiyampoondi BO": "605203",
      "Palliandur BO": "605402",
      "Melpathi BO": "605103",
      "Kangiyanur BO": "605302",
      "PVilliyanur BO": "605105",
      "Poovarasankuppam BO": "605105",
      "Chinthamani BO": "605601",
      "Thoravi BO": "605601",
      "Anilady BO": "605651",
      "Naraiyur BO": "605108",
      "VBudur BO": "605108",
      "Pombur BO": "605652",
      "TPudupalayam BO": "605652",
      "Vikravandi RS BO": "605652",
      "Tindivanam HO": "604001",
      "Villupuram HO": "605602",
      "Tiruchitambalam SO": "605111",
      "Vanur SO": "605109",
      "Avalurpet SO": "604201",
      "Mailam SO": "604304",
      "Velur SA SO": "604154",
      "Anniyur SO": "605202",
      "Kanai SO": "605301",
      "Kanjanur SO": "605203",
      "Koliyanur SO": "605103",
      "Mokshakulam SO": "605105",
      "Santhanagopalapuram SO": "605602",
      "Villupuram East SO": "605602",
      "Auroville SO": "605101",
      "Kottakuppam SO": "605104",
      "Akshipakkam SO": "604101",
      "Brahmadesam SO Villupuram": "604301",
      "Illodu SO": "604210",
      "Melmalayanur SO": "604204",
      "Rettanai SO": "604306",
      "Saram  Tindivanam  SO": "604307",
      "Sathyamangalam SO": "604153",
      "Tindivanam Bazaar SO": "604001",
      "Kamala Nagar SO Villupuram": "605602",
      "Kedar SO": "605402",
      "Mundiyambakkam SO": "605601",
      "Valavanur SO": "605108",
      "Vikravandi SO": "605652",
      "Alampoondi SO": "604151",
      "Kiliyanur SO Villupuram": "604102",
      "Minambur SO": "604205",
      "Nallanpillaipetral SO": "604152",
      "Olakkur SO": "604305",
      "Valathi SO": "604208",
      "Vellimedupettai SO": "604207",
      "Kandamangalam SO": "605102",
      "Kilperumbakkam SO": "605602",
      "Mambazhapattu SO": "605302",
      "Pallineliyanur SO": "605107",
      "Periyathatchur SO": "605651",
      "Villupuram Collectorate SO": "605602",
      "Perangiyur S.O": "607107",
      "Thapovanam S.O": "605756",
      "Anathur S.O": "607101",
      "Gingee MDG": "604202",
      "Kutteripattu SO": "604302",
      "Markanum SO": "604303",
      "Melolakkur SO": "604203",
      "Vallam SO": "604206",
      "Ananthapuram SO": "605201",
      "Kandamanadi SO": "605401",
      "Maharajapuram SO": "605602",
      "Valudavur SO": "605502",
      "Villupuram West SO": "605602",
      "Kandachipuram S.O": "605701",
      "Mogaiyur S.O": "605755",
      "Virapandi S.O": "605758",
      "Arakandanallur S.O": "605752",
      "Periyasevalai S.O": "607209",
      "Tiruvennainallur S.O": "607203",
      "Sithalingamadam S.O": "605803"
    },
    "DHARMAPURI": {
      "Dharmapuri Combined Court Building S. O": "636705",
      "Achalavadi B.O": "636903",
      "Agraharam B.O": "636903",
      "Batchapet B.O": "636903",
      "Chellampatti B.O": "636903",
      "Nochikuttai B.O": "636903",
      "Parayapattipudur B.O": "636903",
      "Pereripudur B.O": "636903",
      "Petadampatti B.O": "636903",
      "Adagapadi B.O": "636803",
      "Bedrahalli B.O": "636803",
      "Nagarkudal B.O": "636803",
      "Nettadahalli B.O": "636803",
      "Ranimookanur B.O": "635303",
      "Sillarahalli B.O": "635303",
      "Murukkampatti B.O": "635202",
      "Pulithikarai B.O": "635202",
      "Vathalmalai B.O": "636804",
      "Chikkadornabetta B.O": "636806",
      "Gujjarahalli B.O": "636806",
      "Kandenahalli B.O": "636806",
      "Elavadai B.O": "635305",
      "Gobichettipalayam B.O": "635305",
      "Keragodahalli B.O": "635305",
      "Navalai B.O": "635305",
      "Maniyadahalli B.O": "636807",
      "Pagalahalli B.O": "636807",
      "Hanumanthapuram B.O": "636808",
      "Jertalav B.O": "636808",
      "Kethanahalli B.O": "636808",
      "Kattampatti B.O": "636808",
      "Nammandahalli B.O": "636812",
      "Kombur B.O": "636905",
      "Lakshmapuram B.O": "636905",
      "Mullikadu B.O": "636905",
      "Selliampatti B.O": "636809",
      "Ramakondahalli B.O": "636810",
      "Vattuvanahalli B.O": "636810",
      "Kuppangarai B.O": "635205",
      "Mallikuttai B.O": "635205",
      "Maravadi B.O": "635205",
      "Chinnampalli B.O": "636811",
      "Gendenahalli B.O": "636811",
      "Bairnaickenpatti B.O": "636906",
      "Periyapatti B.O": "636906",
      "Poyyapatti B.O": "636906",
      "Karungalpadi B.O": "636906",
      "Kongavembu B.O": "636902",
      "Mobiripatti B.O": "636902",
      "Chinnankuppam B.O": "636903",
      "Ellapudayampatti B.O": "636903",
      "Kolagampatti B.O": "636903",
      "Sitteri B.O": "636903",
      "Makkanur B.O": "636803",
      "Maniyambadi B.O": "635303",
      "Kongarapatti B.O": "635202",
      "Vedarampatti B.O": "635202",
      "Narthampatti B.O": "636804",
      "Atturnahalli B.O": "636805",
      "Mahendramangalam B.O": "636805",
      "Ammanimallapuram B.O": "636806",
      "Tenkaraikottai B.O": "636904",
      "Gopinathampatti B.O": "635305",
      "Maruthipatti B.O": "635305",
      "Parayapatti B.O": "635305",
      "Sandapatti B.O": "635305",
      "Sitrapatti B.O": "635305",
      "Elagiri B.O": "636807",
      "Palayam B.O": "636807",
      "Belarahalli B.O": "636808",
      "Erranahalli B.O": "636808",
      "P.Chettihalli B.O": "636808",
      "Pappinaickenpatti B.O": "636808",
      "Bairnatham B.O": "636905",
      "Kokkarapatti B.O": "636905",
      "Pattukonampatti B.O": "636905",
      "Venkatasamudram B.O": "636905",
      "Paupparapatti Agraharam B.O": "636809",
      "Palavadi B.O": "636809",
      "Koothapadi B.O": "636810",
      "Gendiganahalli B.O": "635205",
      "Kottumaranahalli B.O": "635205",
      "Matlampatti B.O": "635205",
      "Arakasanahalli B.O": "636811",
      "Moolakkadu B.O": "636352",
      "Andiyur B.O": "636906",
      "Gudalur B.O": "636906",
      "Thambal Ammapet B.O": "636906",
      "Veerappanaickenpatti B.O": "636906",
      "Mathikonpalayam B.O": "636701",
      "Mampatti B.O": "636902",
      "Doddampatti B.O": "636903",
      "Ittiyampatti B.O": "636903",
      "Keeraipatti B.O": "636903",
      "Veppampatti B.O": "636903",
      "Dalavaihalli B.O": "636803",
      "Kadirnaickenahalli B.O": "635303",
      "Venkatadrihalli B.O": "635303",
      "Jakkupatti B.O": "635202",
      "Kelavalli B.O": "635202",
      "Krishnapuram B.O": "635202",
      "Vellalapatti B.O": "635202",
      "Boodanahalli B.O": "636804",
      "Nallasenahalli B.O": "636804",
      "Veppalahalli B.O": "636805",
      "Samanur B.O": "636806",
      "Dasarahalli B.O": "635305",
      "M Velampatti B.O": "635305",
      "Polayampalli B.O": "635305",
      "Balajangamanahalli B.O": "636807",
      "Dokkubothanahalli B.O": "636807",
      "Easalpatti B.O": "636807",
      "Samichettipatti B.O": "636807",
      "Begarahalli B.O": "636808",
      "Dandukaranahalli B.O": "636808",
      "Poduthampatti B.O": "636808",
      "Seeriyanahalli B.O": "636808",
      "Yelangalpatti B.O": "636808",
      "Alamelupuram B.O": "636905",
      "Kalipettai B.O": "636905",
      "Pappambadi B.O": "636905",
      "Pudupatti B.O": "636905",
      "Padi B.O": "636809",
      "Pikkili B.O": "636809",
      "Sogathur B.O": "636809",
      "Hogenakkal B.O": "636810",
      "Manjarahalli B.O": "636810",
      "Kannipatti B.O": "635205",
      "Kovilur B.O": "635205",
      "Modur B.O": "635205",
      "T.Ganikarahalli B.O": "636352",
      "Kathiripatti B.O": "636906",
      "Naripalli B.O": "636906",
      "Vedakattumaduvu B.O": "636906",
      "Velanur B.O": "636906",
      "K.Vetrapatti B.O": "636902",
      "Kalasapadi B.O": "636903",
      "Punganatham B.O": "636803",
      "Somenahalli B.O": "636803",
      "Oblinaickenhalli B.O": "635303",
      "Odasalahalli B.O": "635303",
      "D Thurinjipatti B.O": "635202",
      "Ichambadi B.O": "635202",
      "Mukkanahalli B.O": "635202",
      "Thippampatti B.O": "635202",
      "Vagurappampatti B.O": "635202",
      "Mademangalam B.O": "636804",
      "Mittadinnahalli B.O": "636804",
      "Bommanur B.O": "636805",
      "Jakkasamudram B.O": "636805",
      "Jittandahalli B.O": "636805",
      "M.Maravadi B.O": "636805",
      "Alapuram B.O": "636904",
      "Jammanahalli B.O": "636904",
      "Molayanur B.O": "636904",
      "A.Jettihalli B.O": "636807",
      "Adiyamankottai B.O": "636807",
      "Ichampatti B.O": "636807",
      "Pulikarai B.O": "636808",
      "Sunnampatti B.O": "636808",
      "Tirumalavadi B.O": "636808",
      "A.Pallipatti B.O": "636905",
      "Adikarapatti B.O": "636905",
      "Chettihalli B.O": "636809",
      "Giddanahalli B.O": "636809",
      "Kadagathur B.O": "636809",
      "Onnappagoundanahalli B.O": "636809",
      "Ajjanahalli B.O": "636810",
      "Badrahalli B.O": "636810",
      "Dinnabelur B.O": "636810",
      "Donnakuttahalli B.O": "636810",
      "Nagamarai B.O": "636810",
      "Senganur B.O": "636810",
      "Sunchalnatham B.O": "636810",
      "A.Sappanipatti B.O": "635205",
      "Baisuhalli B.O": "635205",
      "Kalappambadi B.O": "636811",
      "Kammampatti B.O": "636352",
      "Kottapatti B.O": "636906",
      "Sikkalur B.O": "636906",
      "Sittilingi B.O": "636906",
      "Ammapalayam B.O": "636114",
      "Gummanur B.O": "635116",
      "Thimmarayanahalli B.O": "635106",
      "Kothalam B.O": "635106",
      "Bommahalli B.O": "635111",
      "Dindal B.O": "635111",
      "Karagur B.O": "635111",
      "Errasigalahalli B.O": "635106",
      "Devarmukkulam B.O": "635111",
      "Bandarahalli B.O": "635123",
      "Doddampatti R.S. B.O": "635304",
      "Karaikodihalli B.O": "635111",
      "Mukkulam B.O": "635111",
      "Hale Dharmapuri B.O": "636701",
      "Thurinjipatti B.O": "635301",
      "Veppilaimuthampatti B.O": "635301",
      "Mottankurichi B.O": "635302",
      "RAMENAHALLI B.O": "635302",
      "Thalanatham B.O": "635302",
      "Vaguthupatti B.O": "635302",
      "Thokkampatti B.O": "636705",
      "A.Gollahalli B.O": "636704",
      "Akkamanahalli B.O": "636704",
      "Kuppur B.O": "636704",
      "Ungaranahalli B.O": "636705",
      "Venkatenahalli B.O": "636705",
      "Konangihalli B.O": "636813",
      "Manchinayakanahalli B.O": "636813",
      "Mangarai B.O": "636813",
      "Noolahalli B.O": "636813",
      "B Pallipatti B.O": "635301",
      "Solaikottai B.O": "636704",
      "Irumathur B.O": "635201",
      "Anjehalli B.O": "636813",
      "Errapeyanahalli B.O": "636813",
      "Pilparuthi B.O": "635301",
      "Thippireddihalli B.O": "635301",
      "Kandagoundanur B.O": "635302",
      "Mittanoolahalli B.O": "636704",
      "Settikarai B.O": "636704",
      "Bikkampatti B.O": "636813",
      "Erupalli B.O": "636813",
      "Rajagollahalli B.O": "636813",
      "Sathiyanathapuram B.O": "636813",
      "Regadahalli B.O": "635301",
      "Chintalpadi B.O": "635302",
      "Kurubarahalli B.O": "635302",
      "Kethureddipatti B.O": "635302",
      "Dharmapuri H.O": "636701",
      "Karimangalam S.O": "635111",
      "Annasagaram S.O": "636704",
      "Dharmapuri Collectorate S.O": "636705",
      "Dharmapuri R.S S.O": "636701",
      "Indur S.O": "636803",
      "Kambainallore S.O": "635202",
      "Komarasamipatti S.O": "636701",
      "Laligam S.O": "636804",
      "Menisi S.O": "636904",
      "Buddireddipatti S.O": "635302",
      "Eachambadi S.O": "636902",
      "Harur S.O": "636903",
      "Kadathur S.O": "635303",
      "Mallupatti S.O": "636805",
      "Panjapalli S.O": "636812",
      "Periyanahalli S.O": "635205",
      "Vennampatti H.B S.O": "636705",
      "Morappur S.O": "635305",
      "Pappireddipatti S.O": "636905",
      "Perumbalai S.O": "636811",
      "Tirtamalai S.O": "636906",
      "Bommidi S.O": "635301",
      "Dharmapuri South S.O": "636701",
      "Marandahalli S.O": "636806",
      "Paupparapatti S.O": "636809",
      "Pennagaram S.O": "636810",
      "Thoppur S.O": "636352",
      "Biliyanur Agraharam S.O": "636813",
      "Nallampalli S.O": "636807",
      "Palacode S.O": "636808"
    },
    "CHENGALPATTU": {
      "Perumbakkam S.O": "600100",
      "Kadaperi BO": "600047",
      "Irumbuliyur BO": "600045",
      "Kasthuribainagar BO": "600045",
      "Nehrunagar BO": "600044",
      "Rajakilpakkam BO": "600073",
      "LIC Colony BO": "600059",
      "Srinivasanagar East BO": "600063",
      "Old Perungalathur BO": "600063",
      "Thimmavaram BO": "603101",
      "Villiambakkam BO": "603101",
      "Velur BO": "603401",
      "Kannivakkam BO": "603202",
      "Ayapakkam BO": "603102",
      "Suradimangalam BO": "603102",
      "Vayalur BO": "603102",
      "Janakipuram BO": "603303",
      "Malapalayam BO": "603303",
      "Ninnakarai BO": "603203",
      "Kodoovur BO": "603305",
      "Mugaiyur BO": "603305",
      "Nedumaram BO": "603305",
      "Nerkunapattu BO": "603305",
      "Irumbedu BO": "603302",
      "Nainarkuppam BO": "603302",
      "Palaiyur BO": "603302",
      "Panaiyur BO": "603302",
      "Neerpair BO": "603313",
      "Nugumbal BO": "603313",
      "Onambakkam BO": "603313",
      "Kattukaranai BO": "603201",
      "Madhur BO": "603201",
      "Padiri BO": "603201",
      "Adhanur B.O": "603202",
      "Vazhuvadur BO": "603102",
      "Vengapakkam BO": "603102",
      "Melavalam BO": "603303",
      "Pudupattu BO": "603303",
      "Vedavakkam BO": "603303",
      "Kolathur BO": "600048",
      "Kottaikadu BO": "603304",
      "Vedal BO": "603304",
      "Pakkam BO": "603306",
      "Perumbakkam BO": "603302",
      "Thatchur BO": "603306",
      "Zamin Paiyanur BO": "603104",
      "Mullipakkam BO": "603105",
      "Kattudevadur BO": "603313",
      "Kadukkalur BO": "603401",
      "Vannianallur BO": "603401",
      "Kayarambedu BO": "603202",
      "Thangappapuram BO": "603202",
      "Manamai BO": "603102",
      "Reactor Research Centre BO": "603102",
      "Kinar BO": "603303",
      "Malayalipettai BO": "603303",
      "Sembulipuram BO": "603304",
      "Vilambur BO": "603304",
      "Vepancheri BO": "603305",
      "Morapakkam BO": "603306",
      "New Mambakkam BO": "603306",
      "Perur BO": "603104",
      "Peria Irumbedu BO": "603105",
      "Veeranakunnam BO": "603306",
      "Kadambadi BO": "603104",
      "Kokilamedu BO": "603104",
      "Vadakadambadi BO": "603104",
      "Chengattur BO": "603302",
      "Zamin Budur BO": "603302",
      "Vilanganur BO": "603313",
      "Andarkuppam BO": "603401",
      "Puthirankottai BO": "603401",
      "Ramapuram BO": "603201",
      "Karanaipuduchery BO": "603202",
      "Melperumalcheri BO": "603102",
      "Pattaraikalani BO": "603102",
      "Vittilapuram BO": "603102",
      "Kathiricheri BO": "603303",
      "Keelavalam BO": "603303",
      "KinarKandigaiPudur BO": "603303",
      "Kadalur BO": "603305",
      "Seekanankuppam BO": "603305",
      "Arungunam BO": "603306",
      "Murugambakkam BO": "603306",
      "Unamalai BO": "603306",
      "Koothavakkam BO": "603104",
      "Pattipulam BO": "603104",
      "Poonjeri BO": "603104",
      "Kuzhipanthandalam BO": "603105",
      "Seethapuram BO": "603301",
      "Minnal Sithamur BO": "603307",
      "Palayanur BO": "603308",
      "Kalkulam BO": "603312",
      "Lathur BO": "603312",
      "Mugundagiri BO": "603309",
      "Paiyambadi BO": "603309",
      "Perukkaranai BO": "603309",
      "Vallipuram BO": "603405",
      "Sirukundram BO": "603108",
      "Anjur BO": "603204",
      "Appur BO": "603204",
      "Tirukatchur BO": "603204",
      "Nerkunam BO": "603310",
      "Perumberkandigai BO": "603310",
      "Sirumailur BO": "603310",
      "Sirunagar BO": "603310",
      "Illalur BO": "603110",
      "Alathur Industrial Estate BO": "603110",
      "Mamandur BO": "603111",
      "Manapakkam BO": "603111",
      "Meyyur BO": "603111",
      "Ozhalur BO": "603111",
      "Pazhamathur BO": "603111",
      "Tirumani BO": "603111",
      "Sirudavur BO": "603105",
      "Sendivakkam BO": "603319",
      "Sirunagalur BO": "603319",
      "Tiruvandavar BO": "603308",
      "Kolampakkam BO": "603308",
      "Palur BO": "603101",
      "Seevadi BO": "603312",
      "Ponpathirkoodam BO": "603405",
      "Hanumanthapuram BO": "603108",
      "Kalvoy BO": "603108",
      "Nellikuppam BO": "603108",
      "Senneri BO": "603108",
      "Mullikolathur BO": "603109",
      "Oragadam BO": "603109",
      "Pandur BO": "603109",
      "Puliyur BO": "603109",
      "Veerapuram BO": "603109",
      "Pulithivakkam BO": "603314",
      "Vellaputhur BO": "603314",
      "Ozhavetti BO": "603311",
      "Vedanthangal BO": "603314",
      "Panangottur BO": "603209",
      "Kunnavakkam BO": "603002",
      "Pulipakkam BO": "603002",
      "Vadamanipakkam BO": "603307",
      "Budur BO": "603308",
      "Kallabiranpuram BO": "603308",
      "KNelvoy BO": "603312",
      "Anur BO": "603405",
      "Salur BO": "603405",
      "Karumbakkam BO": "603108",
      "Melaiyur BO": "603108",
      "Karunilam BO": "603204",
      "Ayakonamkolathur BO": "603310",
      "Karasangal BO": "603310",
      "Desumugipettai BO": "603109",
      "Irumbulicheri BO": "603109",
      "Thathalur BO": "603109",
      "Venbedu BO": "603110",
      "L.Endathur B.O": "603406",
      "Peria Venmani BO": "603311",
      "Nenmeli BO": "603003",
      "Irumbuli BO": "603301",
      "Kayapakkam BO": "603301",
      "Paranur BO": "603002",
      "Ananthamangalam BO": "603307",
      "Sirudamur BO": "603307",
      "Bukkathurai BO": "603308",
      "Isur BO": "603310",
      "Anaicut BO": "603312",
      "Iranyasidhi BO": "603312",
      "Chitrvadi BO": "603309",
      "Sogandi BO": "603405",
      "Kottamedu BO": "603108",
      "Madayathur BO": "603108",
      "Chettipunniam BO": "603204",
      "Melrosapuram BO": "603204",
      "Ammanambakkam BO": "603004",
      "Edaiyur BO": "603109",
      "Kayar BO": "603110",
      "Meleripakkam BO": "603003",
      "Tiruvadisoolam BO": "603003",
      "Kiliyanagar B.O": "603406",
      "Indalur BO": "603301",
      "Reddipalayam BO": "603101",
      "Nemilichery BO": "600044",
      "Muttukadu BO": "603112",
      "Thiruvidanthai BO": "603112",
      "Mambakkam BO": "600048",
      "Mannivakkam BO": "600048",
      "Navalur BO": "600130",
      "Kattugudalur BO": "603301",
      "Parukkal BO": "603301",
      "Nallambakkam BO": "600127",
      "Otteri Extension BO": "600048",
      "Ottiyambakkam BO": "600130",
      "Pudupakkam BO": "603103",
      "Mappedu BO": "600126",
      "Ponmar BO": "600127",
      "GanapathipuramCMT BO": "600044",
      "Kolapakkam BO": "600127",
      "Tambaram HO": "600045",
      "Chengalpattu HO": "603001",
      "Anakaputhur SO": "600070",
      "Chitlapakkam SO": "600064",
      "Hasthinapuram SO": "600064",
      "Medavakkam  SO": "600100",
      "Pallavaram SO": "600043",
      "Tambaram East SO": "600059",
      "Vandalur SO": "600048",
      "Thazambur": "600130",
      "SITHALAPAKKAM SO": "600131",
      "Chromepet SO": "600044",
      "Kovalam SO Kanchipuram": "603112",
      "Mudichur SO": "600048",
      "Old Pallavaram SO": "600117",
      "Pallikaranai SO": "600100",
      "Selaiyur SO": "600073",
      "Srinivasanagar SO Kanchipuram": "600063",
      "Tirusulam SO": "600043",
      "Keelakattalai SO": "600117",
      "Kelambakkam SO": "603103",
      "Melakkottaiyur SO": "600127",
      "MEPZ Tambaram SO": "600045",
      "Rajajinagar SO Kanchipuram": "600043",
      "Annai Anjugam Nagar SO": "603211",
      "Acharapakkam SO": "603301",
      "Anupuram SO": "603127",
      "Athurchengalpattu SO": "603101",
      "Tambaram Sanatorium SO": "600047",
      "Tambaram West SO": "600045",
      "Bharathipuram SO Kanchipuram": "600044",
      "Christian College Tambaram SO": "600059",
      "Gowriwakkam SO": "600073",
      "Kovilambakkam SO": "600129",
      "Madambakkam SO": "600126",
      "Nagalkeni SO": "600044",
      "Pammal East SO": "600075",
      "Pammal SO": "600075",
      "Polichalur SO": "600074",
      "Radhanagar SO Kanchipuram": "600044",
      "Tambaram IAF SO": "600046",
      "Padur SO": "603103",
      "Chengalpattu MedCollege SO": "603001",
      "Cheyur SO Kanchipuram": "603302",
      "Chithamur SO": "603313",
      "Kattankolathur SO": "603203",
      "Nathamchengalpattu SO": "603002",
      "Padalam SO": "603308",
      "Pudupattinam Colony SO": "603102",
      "Sembakkam SO": "603108",
      "Singaperumalkoil SO": "603204",
      "Tiruporur SO": "603110",
      "Urapakkam SO": "603210",
      "Vallam SO": "603003",
      "Chunampet SO": "603401",
      "Kalpakkam SO": "603102",
      "Kudapakkam SO": "603304",
      "Kuvathur SO": "603305",
      "Manambathi SO": "603105",
      "Maraimalai Nagar SO": "603209",
      "Orathy SO": "603307",
      "Tirukalikundram Bazaar SO": "603109",
      "Tirukalikundram SO": "603109",
      "Venpakkam SO": "603111",
      "Malaivaiyavur SO": "603314",
      "Chengalpattu Bazaar SO": "603002",
      "Chengalpattu Cutcherry SO": "603001",
      "Elapakkam SO": "603201",
      "Gundurchengalpattu SO": "603002",
      "Madurantakam SO": "603306",
      "Polambakkam SO": "603309",
      "Senguntharpettai SO": "603306",
      "Zamin Endathur SO": "603311",
      "Guduvancheri SO": "603202",
      "Karunguli SO": "603303",
      "Mahindra World City SO Kanchipuram": "603004",
      "Mamallapuram SO": "603104",
      "Melmaruvathur SO": "603319",
      "Pavunjur SO": "603312",
      "Ponvilainthakalathur SO": "603405",
      "Thozhupedu SO": "603310"
    },
    "TIRUNELVELI": {
      "Keela Kaduvetti BO": "627152",
      "Melasadayamankulam BO": "627152",
      "Panankulam BO": "627152",
      "Karungulam BO": "627356",
      "Kila Omanallur BO": "627356",
      "Singaneri BO": "627108",
      "Devanallur BO": "627502",
      "Avaraikulam BO": "627133",
      "Perungudi BO": "627133",
      "Kannankulam BO": "627127",
      "Ponnagudi BO": "627151",
      "Paruthipadu BO": "627354",
      "Chinthamani BO": "627355",
      "Kundakulam BO": "627355",
      "Ramakrishnapuram BO": "627355",
      "Kannanallur BO": "627108",
      "Karankadu BO": "627108",
      "Shenbagaramanallur BO": "627108",
      "Idayankulam BO": "627502",
      "Kalladichidambarapuram BO": "627502",
      "Vijayapathi BO": "627104",
      "Padalayarkulam BO": "627501",
      "Pathai BO": "627501",
      "Timmarajapuram BO": "627353",
      "ASatankulam BO": "627151",
      "Kovaikulam BO": "627151",
      "Naduchalaipudur BO": "627107",
      "Alwaneri BO": "627354",
      "Ambalam BO": "627354",
      "Sengulam BO": "627152",
      "Tidiyur BO": "627152",
      "Emankulam BO": "627108",
      "Kadamboduvalvu BO": "627108",
      "Unnankulam BO": "627108",
      "Pushpavanam BO": "627109",
      "Kuthenkuli BO": "627104",
      "Vijaya Achampadu BO": "627652",
      "Kilakku Kalakkadu BO": "627501",
      "Singampathu BO": "627501",
      "Manapadaiveedu BO": "627353",
      "Erukkanthurai BO": "627106",
      "Karuppukatti BO": "627151",
      "Kovilammalpuram BO": "627107",
      "Deivanayagaperi BO": "627354",
      "Tirumalapuram BO": "627355",
      "Alagappapuram BO": "627652",
      "Suviseshapuram BO": "627652",
      "Chidambarapuram BO": "627111",
      "Keelakaruvelankulam BO": "627501",
      "Perumanal BO": "627106",
      "Thottakudi BO": "627151",
      "Salainainarpallivasal BO": "627107",
      "Karandaneri BO": "627152",
      "Singikulam BO": "627152",
      "Taruvai BO": "627356",
      "Battarpuram BO": "627108",
      "Surangudi BO": "627108",
      "Kallikulam BO": "627502",
      "Kalandapanai BO": "627109",
      "Sriregunathapuram BO": "627109",
      "Pudur B.O": "627851",
      "Elankulam BO": "627110",
      "Anaikkarai BO": "627654",
      "Kakkarai BO": "627111",
      "Vadakkuveppilankulam BO": "627109",
      "Panrimalai BO": "627110",
      "Pappankulam BO": "627110",
      "Muvirunthali B.O": "627951",
      "Northachampatti B.O": "627951",
      "Vannikonendal B.O": "627951",
      "Vellapaneri B.O": "628552",
      "Chocknatchiapuram B.O": "627951",
      "Melanarikudi B.O": "627953",
      "Urumankulam BO": "627654",
      "Nakkaneri BO": "627111",
      "Melailanthaikulam B.O": "627951",
      "Uchankulam BO": "627425",
      "Mannarkoil BO": "627413",
      "Kodarankulam BO": "627416",
      "Aladiyur BO": "627421",
      "Mukkudal Vadakku BO": "627601",
      "Oothu BO": "627427",
      "Karisulnthamangalam BO": "627453",
      "Settikulam BO": "627120",
      "Ambasamudram Pothugudi BO": "627413",
      "Therkupappankulam BO": "627416",
      "Urkad BO": "627416",
      "Vairavikulam BO": "627416",
      "Kuniyur BO": "627417",
      "Tana BO": "627425",
      "Harikesavanallur BO": "627426",
      "Kilakulam BO": "627426",
      "Thiruppudaimarudur BO": "627426",
      "Vellankuli BO": "627426",
      "Melakulam BO": "627351",
      "Kasthurirengapuram BO": "627112",
      "Soundarapandiapuram BO": "627113",
      "Jacobpuram BO": "627114",
      "Levinjipuram BO": "627114",
      "Rajakrishnapuram BO": "627114",
      "Nambithalaivanpattaiyam BO": "627115",
      "Navaladi BO": "627657",
      "Samariah  BO": "627657",
      "Danakkarkulam BO": "627116",
      "Sankanankulam BO": "627118",
      "Terku Vijayanarayanam BO": "627118",
      "Venkatarayapuram BO": "627118",
      "Palayapettai BO": "627008",
      "Seliyanallur BO": "627352",
      "Kalakudi BO": "627201",
      "Kattarankulam BO": "627201",
      "Madhavakurichi BO": "627201",
      "Mavadi BO": "627201",
      "Pillayarkulam BO": "627201",
      "Konganthanparai BO": "627007",
      "Reddiarpatti BO": "627007",
      "Palamadai BO": "627359",
      "Pappaiyapuram BO": "627359",
      "Nanjankulam BO": "627357",
      "Naranammalpuram BO": "627357",
      "Narasinganallur BO": "627604",
      "Senthimangalam BO": "627358",
      "Sethurayanputhur BO": "627358",
      "Melapattam BO": "627351",
      "Melaputhaneri BO": "627351",
      "Naduvakkurichi BO": "627351",
      "Rajackamangalam BO": "627101",
      "Thulukkarpatti BO": "627101",
      "Puliyurkurichi BO": "627102",
      "Anaigudi BO": "627651",
      "Mudumothanmozhi BO": "627651",
      "Tiruvembalapuram BO": "627111",
      "Udayathur BO": "627111",
      "Duraikudiyiruppu BO": "627112",
      "A Thirumalapuram BO": "627113",
      "Moolaikadu BO": "627113",
      "Kalikumarapuram BO": "627657",
      "Karaichuthupudur BO": "627657",
      "Kumarapuram BO": "627657",
      "Sembikulam BO": "627116",
      "Achampadu BO": "627117",
      "Anaikulam BO": "627117",
      "Kizhavaneri BO": "627117",
      "Terku Vallioor BO": "627117",
      "Kallur BO": "627010",
      "Kiramangalam BO": "627010",
      "Kodaganallur BO": "627010",
      "Tiruppanikarisalkulam BO": "627010",
      "Krishnapuram BO": "627011",
      "Sivanthipatti BO": "627011",
      "Seethaparpanallur BO": "627012",
      "Pallikottai BO": "627357",
      "Tenkulam BO": "627357",
      "Suttamally Vilakku BO": "627604",
      "Sikkanarasingarayagramam BO": "627001",
      "Cheranmahadevi RS BO": "627414",
      "Thiruviruthanpuli BO": "627414",
      "Pottal BO": "627416",
      "Singampatti BO": "627416",
      "Ayanthiruvaleeswaram BO": "627418",
      "Singamparai BO": "627601",
      "Kabaliparai BO": "627602",
      "Thulukkapatti BO": "627602",
      "Papanasam Upper Dam BO": "627425",
      "Servalar Camp BO": "627425",
      "Attalanallur BO": "627426",
      "Marudur BO": "627351",
      "Sivalaperi BO": "627351",
      "Nallankulam BO": "627101",
      "Sengalakurichi BO": "627102",
      "Tiruvengadanathapuram BO": "627103",
      "Kila Uvari BO": "627651",
      "Kooduthalai BO": "627651",
      "Kuttam BO": "627651",
      "Uvari BO": "627651",
      "Parameswarapuram BO": "627111",
      "Seelathikulam BO": "627112",
      "Kurugapuram BO": "627657",
      "Mannarpuram BO": "627657",
      "Koliyankulam BO": "627116",
      "Uralvoimozhi BO": "627116",
      "Vadalivilai BO": "627117",
      "Vaduganpatti BO": "627010",
      "Vijayaraghava Mudaliar Chatram BO": "627011",
      "Vellalankulam BO": "627012",
      "Alagiapandiapuram BO": "627201",
      "Azhaganeri BO": "627358",
      "Kunnathur BO": "627006",
      "Pattapathu BO": "627006",
      "Vagaikulam BO": "627202",
      "Kottai Karungulam BO": "627112",
      "Palavoor BO": "627114",
      "Sankanapuram BO": "627114",
      "Mahadevankulam BO": "627657",
      "Muthukrishnapuram BO": "627657",
      "Valliammalpuram BO": "627117",
      "Piranjeri BO": "627352",
      "Ettankulam BO": "627201",
      "Kanarpatti BO": "627201",
      "Therkupatti BO": "627201",
      "Karaieruppu BO": "627357",
      "Ramayyanpatti BO": "627358",
      "Melathiru Vengadanathapuram BO": "627006",
      "Karisalpatti BO": "627414",
      "Kottaitheru BO": "627416",
      "Sattupathu BO": "627416",
      "Sadayappapuram BO": "627601",
      "Kodayar Melthangal BO": "627427",
      "Papanasam Project BO": "627425",
      "Sivanthipuram BO": "627425",
      "Kilapattam BO": "627351",
      "Vadukachimadil BO": "627102",
      "Kodaiseri BO": "627103",
      "Koottapanai BO": "627651",
      "Palayankottai HO": "627002",
      "Ambasamudram HO": "627401",
      "Tirunelveli HO": "627001",
      "Devarkulam S.O": "627951",
      "Ambalavanapuram SO": "627425",
      "Gopalasamudram SO": "627451",
      "Melaseval SO": "627452",
      "Papanasam Mills SO": "627422",
      "Pappagudi SO": "627602",
      "Vickramasingapuram SO": "627425",
      "Eruvadi SO": "627103",
      "Kudankulam SO": "627106",
      "Ambasamudram Angadi SO": "627401",
      "Manimuthar Project SO": "627421",
      "Manjolai SO": "627420",
      "Nalumukku SO": "627427",
      "Pattamadai SO": "627453",
      "Anuvijay Township SO": "627120",
      "Ambasamudram East SO": "627401",
      "Agasthiyarpatti SO": "627428",
      "Brahmadesam SO Tirunelveli": "627413",
      "Karaikurichi SO Tirunelveli": "627417",
      "Mukkudal SO": "627601",
      "Viravanallur SO": "627426",
      "Dalapathisamudram SO": "627101",
      "Dohnavur SO": "627102",
      "Idayangudi SO": "627651",
      "Kalakad SO": "627501",
      "Kuttapuli SO": "627127",
      "Cheranmahadevi SO": "627414",
      "Kallidaikurichi SO": "627416",
      "Vadakku Ariyanayagipuram Petta SO": "627603",
      "Burkitmanagaram SO": "627351",
      "Idindakarai SO": "627104",
      "Ittamozhi SO": "627652",
      "K T C Nagar SO": "627011",
      "Kavalkinaru SO": "627105",
      "Kizhanatham SO": "627353",
      "Mulaikaraipatti SO": "627354",
      "Parappadi SO": "627110",
      "Samugarengapuram SO": "627112",
      "Santhinagar SO": "627002",
      "Gandhinagar SO Tirunelveli": "627008",
      "Kulavanickerpuram SO": "627002",
      "Sivakasi Bus Stand SO": "626123",
      "Munnirpallam SO": "627356",
      "Nanguneri SO": "627108",
      "Padmaneri SO": "627502",
      "Pettaikulam SO": "627654",
      "Terkukallikulam SO": "627113",
      "Jawahar Nagar Tirunelveli SO": "627007",
      "Melapalayam BazaarTirunelveli SO": "627005",
      "Palayankottai Courts SO": "627002",
      "Perumalpuram SO": "627007",
      "Sankarnagar SO": "627357",
      "Tirunelveli Collectorate SO": "627009",
      "Tirunelveli Merku SO": "627006",
      "Tirunelveli RS SO": "627001",
      "Tondar Bazar SO": "627006",
      "Vannarpettai SO": "627003",
      "Maharajangar SO": "627011",
      "Manonmaniam Sundaranar Univers SO": "627012",
      "Suttamally SO": "627604",
      "Tachanallur SO": "627358",
      "Ukkirankottai SO": "627202",
      "Mahendragiri SO": "627133",
      "Maruthakulam SO": "627151",
      "Mavadi SO": "627107",
      "Mundradaippu SO": "627152",
      "Radhapuram SO": "627111",
      "Terkukarungulam SO": "627114",
      "Vadakangulam SO": "627116",
      "Vallioor SO": "627117",
      "Industrial Colony Pettai SO": "627010",
      "Manur SO": "627201",
      "Rajavallipuram SO": "627359",
      "Samadanapuram SO": "627002",
      "Tirunelveli Pettai East SO": "627004",
      "Tirunelveli Pettai SO": "627004",
      "Tirunelveli Town SO": "627006",
      "Munanjipatti SO": "627355",
      "Panagudi SO": "627109",
      "Tirukurungudi SO": "627115",
      "Tisayanvillai SO": "627657",
      "Vallioor Perundunilayam SO": "627117",
      "Vijayanarayanam Naval Base SO": "627119",
      "Vijayanarayanam SO": "627118",
      "Gangaikondan SO": "627352",
      "Melapalayam SO Tirunelveli": "627005",
      "Palayankottai High Grounds SO": "627011",
      "Tirunelveli Terku SO": "627006",
      "Viraraghavapuram SO": "627001"
    },
    "ERODE": {
      "Budapadi BO": "638311",
      "Ikkaraithathapalli BO": "638451",
      "Thoppampalayam BO": "638451",
      "Komarapalayam BO": "638108",
      "Kothamangalam BO": "638451",
      "Pudupeerkadavu BO": "638451",
      "Rajannagar BO": "638451",
      "Kesarimangalam BO": "638311",
      "Nerinjipettai BO": "638311",
      "Chinnapallam BO": "638311",
      "Kadappanallur BO": "638311",
      "Sanyasipatti BO": "638311",
      "Doddampalayam BO": "638451",
      "Singampettai BO": "638311",
      "Umareddiyur BO": "638311",
      "Varadhanallur BO": "638311",
      "Gettisamudram Colony BO": "638501",
      "Sankarapalayam BO": "638501",
      "Sembulichampalayam BO": "638501",
      "Varnapuram BO": "638301",
      "Reddipalayam BO": "638504",
      "Kuttipalayam BO": "638312",
      "Paruvachi BO": "638312",
      "Pethampalayam BO": "638116",
      "Mullampatti BO": "638107",
      "Kannadipalayam BO": "638314",
      "Sembadapalayam BO": "638314",
      "Pichandampalayam BO": "638052",
      "Koothampoondi BO": "638315",
      "Nallampatti BO": "638057",
      "Pattakaranpalayam BO": "638057",
      "Koothampalayam BO": "638751",
      "Greynagar BO": "638056",
      "Kambiliyampatti BO": "638056",
      "Elavanatham BO": "638101",
      "Vadugapatti BO": "638101",
      "Pundurai Semur BO": "638115",
      "Basuvapatti BO": "638051",
      "Mukasipidariyur BO": "638051",
      "Ramalingapuram BO": "638051",
      "Avudayarparai BO": "638151",
      "Salaipudur BO": "638151",
      "Komarayeevalasu BO": "638104",
      "Purappalikattuvalasu BO": "638104",
      "Malayampalayam BO": "638154",
      "Kagam BO": "638109",
      "Thattampalayam BO": "638109",
      "Vilakethi BO": "638109",
      "Kasipalayam BO": "638009",
      "Thamaraipalayam BO": "638152",
      "Vallipurathanpalayam BO": "638112",
      "Peria Semur BO": "638004",
      "ASembulichampalayam BO": "638502",
      "Guthialathur BO": "638503",
      "Gundry BO": "638503",
      "Kaliappampalayam BO": "638110",
      "Sokkumaripalayam BO": "638110",
      "Polavakalipalayam BO": "638476",
      "Perumugaipudur BO": "638505",
      "Alukuli BO": "638453",
      "Kottupullampalayam BO": "638453",
      "Gudakkarai BO": "638454",
      "LMPalapalayam BO": "638455",
      "Pandiampalayam BO": "638455",
      "Talguni BO": "638456",
      "Vadakkuthaiyurpalayam BO": "638102",
      "Chennampatti BO": "638504",
      "Komarayanur BO": "638504",
      "Palakuttaipattipudur BO": "638504",
      "Dalavoipettai BO": "638312",
      "Thottipalayam BO": "638312",
      "Vairamangalam BO": "638312",
      "Kadirampatti BO": "638107",
      "Kurichi BO": "638314",
      "Mathur BO": "638314",
      "Mukasipudur BO": "638314",
      "Mylambadi BO": "638314",
      "Pachampalayam BO": "638314",
      "Vellitirupur BO": "638314",
      "Ingur BO": "638052",
      "Karumandisellipalayam BO": "638052",
      "Olapalayam BO": "638052",
      "Periyavettuvapalayam BO": "638052",
      "Appakudal BO": "638315",
      "Oricheri BO": "638315",
      "Perundalaiyur BO": "638315",
      "Sinthagoundenpalayam BO": "638315",
      "Vellalapalayam BO": "638315",
      "Punjaipalatholuvu BO": "638751",
      "Alampalayam BO": "638501",
      "BargurAnthiyur BO": "638501",
      "Ennamangalam BO": "638501",
      "Thavittupalayam BO": "638501",
      "Kalingarayanpalayam Pudur BO": "638301",
      "Gangapuram BO": "638102",
      "Perode BO": "638102",
      "Elavamalai BO": "638316",
      "Kasthurbagram BO": "638101",
      "Koothampatti BO": "638101",
      "Mukasi Hanumanpalli BO": "638101",
      "Palliyuthu BO": "638101",
      "Kandikattuvalasu BO": "638115",
      "Kasbapettai BO": "638115",
      "Desipalayam BO": "638459",
      "Karapadi BO": "638459",
      "Panayampalli BO": "638459",
      "Kavilipalayam BO": "638402",
      "Periyur BO": "638402",
      "Vinnapalli BO": "638402",
      "Germalam BO": "638401",
      "Aralavadi BO": "638461",
      "Gettavadi BO": "638461",
      "Gumtapuram BO": "638461",
      "Tegnarai BO": "638461",
      "Kandappagoundenvalasu BO": "638051",
      "Murungatholuvu BO": "638051",
      "Mulapalayam BO": "638002",
      "Pudur BO": "638002",
      "Muthayeepalayam BO": "638153",
      "Sinniampalayam BO": "638104",
      "Swaminathapuram BO": "638104",
      "Velampalayam BO": "638104",
      "Kolanalli BO": "638154",
      "Vellottamparappu BO": "638154",
      "Kandasamipalayam BO": "638109",
      "Karukkampalayam BO": "638109",
      "Minnapalayam BO": "638109",
      "Thandampalayam BO": "638109",
      "Gnanipalayam BO": "638112",
      "Kanagapuram BO": "638112",
      "Thoranavavi BO": "638110",
      "Kullampalayam BO": "638476",
      "Nagadevampalayam BO": "638476",
      "Kanakkampalayam BO": "638505",
      "KondayampalayamBhavani BO": "638505",
      "Kalingiam BO": "638453",
      "Alathur BO": "638455",
      "Ayyampalayam BO": "638151",
      "Kalichettipalayam Mettupalayam BO": "638455",
      "Sirukalanji BO": "638751",
      "Thippampalayam BO": "638751",
      "Periaveerasangli BO": "638056",
      "Ponmudi BO": "638056",
      "Voipodi BO": "638056",
      "Thuyyampundurai BO": "638115",
      "Velankattuvalasu BO": "638115",
      "Sanarpalayam BO": "638051",
      "Thoppupalayam BO": "638051",
      "Kollampalayam BO": "638002",
      "Lakkapuram BO": "638002",
      "Mannathampalayam BO": "638153",
      "Ichipalayam BO": "638151",
      "Elumathur BO": "638104",
      "Ramanathapuram Pudur BO": "638005",
      "Vengambur BO": "638152",
      "Kavundichipalayam BO": "638112",
      "Pungambadi BO": "638112",
      "Chikkaiah Naicker College BO": "638004",
      "Kilwani BO": "638502",
      "Kuppandampalayam BO": "638502",
      "Savandapur BO": "638502",
      "Karalayam BO": "638503",
      "Kembanaickenpalayam BO": "638503",
      "Kodiveri BO": "638503",
      "Kondapanaickenpalayam BO": "638503",
      "Nanjagoundenpalayam BO": "638476",
      "Pariyur Vellalapalayam BO": "638476",
      "Akkaraikodiveri BO": "638454",
      "Arasur BO": "638454",
      "Salangapalayam BO": "638455",
      "Singanallur KVP BO": "638455",
      "Theethampalayam BO": "638456",
      "Nallur BO": "638459",
      "Nochikuttai BO": "638459",
      "Shenbagapudur BO": "638402",
      "Sundakkampalayam BO": "638402",
      "Uthandiyur BO": "638402",
      "Valipalayam BO": "638402",
      "Ariyappampalayam BO": "638402",
      "Kottuveerampalayam BO": "638401",
      "Ikkarainegamam BO": "638401",
      "Puduvadavalli BO": "638401",
      "Thingalur BO": "638401",
      "Alathucombai BO": "638401",
      "Olalakoil BO": "638460",
      "Chikkahalli BO": "638461",
      "Chimtahalli BO": "638461",
      "Ukkaram BO": "638402",
      "Araipalayam BO": "638401",
      "Bannari BO": "638401",
      "Chikkarasampalayam BO": "638401",
      "Dhimbam BO": "638401",
      "Hassanur BO": "638401",
      "Periakallipatti BO": "641302",
      "Doddagajanur BO": "638461",
      "Gettisamudram BO": "638501",
      "Michaelpalayam BO": "638501",
      "Thamaraikarai BO": "638501",
      "Kuruppanaickenpalayam BO": "638301",
      "Murali BO": "638504",
      "Kadayampatti BO": "638312",
      "Punnam BO": "638312",
      "Kovilpalayam BO": "638116",
      "Pallapalayam BO": "638116",
      "Thaneerpandalpalayam BO": "638116",
      "Vilarasampatti BO": "638107",
      "Kalbhavi BO": "638314",
      "Patlur BO": "638314",
      "Perundurai RS BO": "638052",
      "Brahmadesam BO": "638315",
      "Mettupalayam BO": "638315",
      "Palakarai BO": "638057",
      "Seenapuram BO": "638057",
      "Sullipalayam BO": "638057",
      "Doddapura BO": "638461",
      "Neithalapuram BO": "638461",
      "Kaikolapalayam BO": "638056",
      "Attavanai Hanumanpalli BO": "638101",
      "Veerappampalayam BO": "638101",
      "Nathagoundenpalayam BO": "638115",
      "Solipalayam BO": "638115",
      "Ramalingapuram South BO": "638051",
      "Vairapalayam BO": "638003",
      "Anjur BO": "638151",
      "Panakkahalli BO": "638461",
      "Soosaipuram BO": "638461",
      "Talamalai BO": "638461",
      "Periavattam BO": "638151",
      "Rasampalayam BO": "638151",
      "Injampalli BO": "638104",
      "Nanjai Uttukuli BO": "638104",
      "Ammankoil BO": "638109",
      "Vazhaithottam BO": "638109",
      "Rangampalayam BO": "638009",
      "Kolathupalayam BO": "638152",
      "Vadakkupudupalayam BO": "638152",
      "TMettupalayam BO": "638112",
      "Nagalur BO": "638502",
      "Basuvanapuram BO": "638503",
      "Kalkadambur BO": "638503",
      "Satamugai BO": "638503",
      "Kadukkampalayam BO": "638476",
      "Erangattur BO": "638505",
      "Ayalur BO": "638453",
      "Kadathur Gobi BO": "638454",
      "Odayagoundenpalayam BO": "638454",
      "Odathurai BO": "638455",
      "Periapuliyur BO": "638455",
      "Irugalur BO": "638462",
      "Pattimaniakaranpalayam BO": "638462",
      "Madampalayam BO": "638459",
      "Konamoolai BO": "638402",
      "Komarapalayamsathy BO": "638401",
      "Emmampoondi BO": "638460",
      "Erahanahalli BO": "638461",
      "Mallanguli BO": "638461",
      "Karattupalayam BO": "638457",
      "Kummakalipalayam BO": "638457",
      "Elathur Chettipalayam BO": "638458",
      "Kidarai BO": "638458",
      "Punjaithuraiyampalayam BO": "638506",
      "Varapalayam BO": "638462",
      "Vellankoil BO": "638054",
      "Kongarpalayam BO": "638506",
      "Kuthambi BO": "638055",
      "Nichampalayam BO": "638055",
      "Pudukaraipudur BO": "638313",
      "Koshanam BO": "638458",
      "Pullappanaickenpalayam BO": "638506",
      "Pappampalayam BO": "638055",
      "AnjanurVemandampalayam BO": "638462",
      "Mevani BO": "638313",
      "AlingiamGobi BO": "638457",
      "Polavapalayam BO": "638458",
      "Arakkankottai BO": "638506",
      "Nanjai Puliampatti BO": "638506",
      "Vettayankinar BO": "638055",
      "Bhavani HO": "638301",
      "Gobichettipalayam HO": "638452",
      "Erode HO": "638001",
      "Bhavanisagar SO": "638451",
      "Cholakkadai Street SO": "638656",
      "Erode Collectorate SO": "638011",
      "Erode Fort SO": "638001",
      "Erode Railway Colony SO": "638002",
      "Ganapathipalayam SO": "638153",
      "Melapalayam SO Erode": "638051",
      "Pasur SO": "638154",
      "Vadamugam Vellode SO": "638112",
      "Veerappanchatram SO": "638004",
      "Kallipatti SO": "638505",
      "Nambiyur SO": "638458",
      "Pudupalayam SO Erode": "638476",
      "Tingalur SO": "638055",
      "Vemandampalayam SO": "638462",
      "Edayankattuvalsu SO": "638009",
      "Kodumudi SO": "638151",
      "Unjalur SO": "638152",
      "Athani SO Erode": "638502",
      "Karattadipalayam SO": "638453",
      "Siruvalur SO": "638054",
      "Perundurai Sanitorium SO": "638053",
      "Perundurai West SO": "638052",
      "Erode East SO": "638001",
      "Erode North SO": "638001",
      "Sivagiri SO Erode": "638109",
      "Olagadam SO": "638314",
      "Perundurai SO": "638052",
      "Vasavi College SO": "638316",
      "Surampatti SO": "638009",
      "Thindal SO": "638012",
      "Thuckanaickenpalayam SO": "638506",
      "Nasiyanur SO": "638107",
      "Vijayamangalam SO": "638056",
      "Arachalur SO": "638101",
      "Avalpundurai SO": "638115",
      "Chennimalai SO": "638051",
      "Erode Market SO": "638001",
      "Karungalpalayam SO": "638003",
      "Modakurichi SO": "638104",
      "Peria Agraharam SO": "638005",
      "Dasappagoundenpudur SO": "638503",
      "Getticheyur SO": "638110",
      "Gobichettipalayam East SO": "638452",
      "Gobichettipalayam South SO": "638476",
      "Kasipalayam SO Erode": "638454",
      "Kavindapadi SO": "638455",
      "Kolappalur SO Erode": "638456",
      "Kugalur SO": "638313",
      "Kurumandur SO": "638457",
      "Sathyamangalam SO": "638401",
      "Savakattupalayam SO": "638460",
      "Ammapettai SO": "638311",
      "Anthiyur SO": "638501",
      "Bhavani Kudal SO": "638301",
      "Sakthinagar SO": "638315",
      "Thoppupalayam SO": "638060",
      "Tudupathi SO": "638057",
      "Bhavani Cutcherry SO": "638301",
      "Chittode SO": "638102",
      "Jambai SO": "638312",
      "Kanjikovil SO": "638116",
      "Punjai Puliampatti SO": "638459",
      "Rangasamudram SO": "638402",
      "Sathyamangalam Bazaar SO": "638401",
      "Talavadi SO": "638461",
      "Guruvareddiyur SO": "638504"
    },
    "Tirupathur": {
      "Parandapalli B.O": "635651",
      "Periyakonapattu B.O": "635651",
      "Chinnavattanur B.O": "635655",
      "Chittoor B.O": "635655",
      "Pachal B.O": "635602",
      "Periyakunichi B.O": "635602",
      "Pudukottai B.O": "635602",
      "Agaram(TPT) B.O": "635653",
      "Paniyandapalli B.O": "635651",
      "Malaiyandipatti B.O": "635655",
      "Melpattu B.O": "635655",
      "Nadukuppam B.O": "635655",
      "Nellipattu B.O": "635655",
      "Nellivasalnadu B.O": "635655",
      "Palayapalayam B.O": "635655",
      "Perumpalli B.O": "635655",
      "Puliyur Tpt B.O": "635655",
      "Kakangarai R.S. B.O": "635654",
      "Lakkinaickenpatti B.O": "635654",
      "Natham B.O": "635654",
      "Periyakannalapatti B.O": "635654",
      "Adiyur B.O": "635602",
      "Thornampathy B.O": "635602",
      "Puthagaram B.O": "635651",
      "Kambugudi B.O": "635655",
      "Kilur B.O": "635655",
      "Thagarakuppam B.O": "635655",
      "Sevathur B.O": "635654",
      "Kadirimangalam B.O": "635602",
      "Koratti B.O": "635602",
      "Valayambattu B.O": "635751",
      "Bommikuppam B.O": "635653",
      "Kodumampalli B.O": "635653",
      "Jamnapudur B.O": "635652",
      "Anganathavalasai B.O": "635652",
      "Pudur Nadu B.O": "635655",
      "Chettiappanur B.O": "635751",
      "Devasthanam B.O": "635751",
      "Girisamudram B.O": "635751",
      "Kalendira B.O": "635751",
      "Madavalam B.O": "635653",
      "Rachamangalam B.O": "635653",
      "Selandampalli B.O": "635653",
      "Nayakkanur B.O": "635652",
      "Perambattu B.O": "635652",
      "Simnapudur B.O": "635652",
      "Veppalnatham B.O": "635651",
      "Kilanur B.O": "635655",
      "Kombai B.O": "635655",
      "Christukula Ashram B.O": "635602",
      "Elavampatti B.O": "635602",
      "Karuppanur B.O": "635602",
      "Tirupattur Fort B.O": "635602",
      "Periyapet B.O": "635751",
      "Chinnasamudram B.O": "635653",
      "Kurumbakeri B.O": "635653",
      "Rajapalayam B.O": "635653",
      "Thimmanamuthur B.O": "635653",
      "Kurumberi B.O": "635652",
      "Udayamuthur B.O": "635652",
      "Naickaneri B.O": "635802",
      "Somalapuram B.O": "635802",
      "Thennambattu B.O": "635802",
      "Devalapuram B.O": "635802",
      "Kumaramangalam B.O": "635802",
      "Palur B.O": "635804",
      "Sathambakkam B.O": "635808",
      "Kadhavalam B.O": "635811",
      "Mittalam B.O": "635811",
      "Venkatasamudram B.O": "635811",
      "Kilmurungai B.O": "635812",
      "Naickanur B.O": "635701",
      "Thekkupattu B.O": "635801",
      "Vadakkupattu B.O": "635801",
      "Irunapattu B.O": "635702",
      "Kurusilapattu B.O": "635702",
      "Perumapattu B.O": "635702",
      "Ilayanagaram B.O": "635754",
      "Thumberi B.O": "635754",
      "Pullaneri B.O": "635851",
      "East Badanavadi B.O": "635901",
      "Pallathur B.O": "635901",
      "Periagaram B.O": "635901",
      "Thokkiyam B.O": "635901",
      "Mallagunta B.O": "635852",
      "Vettapattu B.O": "635852",
      "Vellakuttai B.O": "635752",
      "Elagiri B.O": "635853",
      "Mangalam B.O": "635853",
      "Jayapuram B.O": "635651",
      "Alankuppam B.O": "635814",
      "Periyankuppam B.O": "635814",
      "Chinnavarikam B.O": "635811",
      "Peddur B.O": "635701",
      "Vasanthapuram B.O": "635701",
      "Thimmampet B.O": "635801",
      "Gummidigampatti B.O": "635901",
      "Mandalanayanagunda B.O": "635901",
      "Nariyaneri B.O": "635901",
      "Lalapettai B.O": "635710",
      "Marimanikuppam B.O": "635710",
      "Kothakottai B.O": "635752",
      "Nimmiyambattu B.O": "635752",
      "Vallipattu B.O": "635752",
      "Damalerimuthur B.O": "635853",
      "Kottaiyur B.O": "635853",
      "Achamangalam B.O": "635651",
      "Agraharam B.O": "635651",
      "Mukkanur B.O": "635651",
      "Arangaldurgam B.O": "635811",
      "Chinnakarumbur B.O": "635811",
      "Bheemakulam B.O": "635701",
      "Kavalur B.O": "635701",
      "Mandarakuttai B.O": "635701",
      "Avarankuppam B.O": "635801",
      "Chikkanankuppam B.O": "635801",
      "Kodayanchi B.O": "635801",
      "Udayendiram B.O": "635754",
      "Vadacheri B.O": "635754",
      "Mandalavadi B.O": "635851",
      "Reddiyur B.O": "635851",
      "Somanaickenpatti B.O": "635851",
      "Tiriyalam B.O": "635851",
      "Vakkanampatti B.O": "635851",
      "Athurkuppam B.O": "635815",
      "Kethandapatti B.O": "635815",
      "Vinnamangalam B.O": "635807",
      "Nachiarkuppam B.O": "635710",
      "Poongulam B.O": "635710",
      "Athiperumanur B.O": "635852",
      "Jangalapuram B.O": "635852",
      "Bandarapalli B.O": "635854",
      "Kothur B.O": "635854",
      "Mallapalli B.O": "635854",
      "Sorakayalnatham B.O": "635854",
      "Yelagiri Hills B.O": "635853",
      "Gangapuram B.O": "635802",
      "Thottalam B.O": "635804",
      "Nariyambattu B.O": "635808",
      "Karapattu B.O": "635811",
      "Vengili B.O": "635812",
      "Narasingapuram B.O": "635701",
      "Alasandapuram B.O": "635801",
      "Eachangal B.O": "635801",
      "Ramanaickenpettai B.O": "635801",
      "Pallavalli B.O": "635702",
      "Chinnapallikuppam B.O": "635754",
      "Madanancherry B.O": "635754",
      "Kodiyur B.O": "635851",
      "Ponneri B.O": "635851",
      "Chinnakandili B.O": "635901",
      "Periyakasinaickenpatti B.O": "635901",
      "Vaniyambadi R.S B.O": "635751",
      "Kathari B.O": "635852",
      "Nayanacheruvu B.O": "635852",
      "Velakalnatham B.O": "635854",
      "Nilavur B.O": "635853",
      "Chandrapuram B.O": "635651",
      "Tirupattur H.O": "635601",
      "Madanur S.O": "635804",
      "Govindapuram S.O": "635751",
      "Kandili S.O": "635901",
      "Kethandapatti Sugar Mills S.O": "635815",
      "Natrampalli S.O": "635852",
      "Newtown Vaniyambadi S.O": "635752",
      "Pudupettai S.O": "635651",
      "Pudur Vaniyambadi S.O": "635751",
      "Vengalapuram S.O": "635653",
      "Ambur Bazaar S.O": "635802",
      "Ambur S.O": "635802",
      "Oomerabad S.O": "635808",
      "Thuthipattu S.O": "635811",
      "Vadapudupet S.O": "635812",
      "Ambalur S.O": "635801",
      "Tirupattur Bazaar S.O": "635602",
      "Tirupattur TNHB S.O": "635601",
      "Vishamangalam S.O": "635652",
      "Shanankuppam S.O": "635814",
      "Alangayam S.O": "635701",
      "Andiappanur S.O": "635702",
      "Asiriyar Nagar S.O": "635601",
      "Gandhipet   TPT S.O": "635601",
      "Jaffarabad S.O": "635754",
      "Jolarpettai S.O": "635851",
      "Khaderpet S.O": "635751",
      "Pakkirithakka S.O": "635853",
      "Perumalpet S.O": "635751",
      "Minnur S.O": "635807",
      "Mittur S.O": "635710",
      "Pachur S.O": "635854",
      "Sundarampalli S.O": "635654",
      "Vaniyambadi S.O": "635751",
      "Matrapalli S.O": "635655"
    },
    "SIVAGANGA": {
      "SN Pattinam BO": "630411",
      "Uruvati BO": "630411",
      "Thirani BO": "630411",
      "Sokkananthapuram BO": "630411",
      "Akkavayal BO": "630713",
      "Alavidangan BO": "630713",
      "Rajani BO": "630713",
      "Sakkur BO": "630713",
      "Andichoorani BO": "630551",
      "KSukkanurani BO": "630551",
      "Marakathur BO": "630551",
      "Marathur BO": "630551",
      "Muthanendhal BO": "630602",
      "Nettur BO": "630702",
      "Uthamanoor BO": "630702",
      "Mudikarai BO": "630551",
      "Paruthikanmoi BO": "630551",
      "Ariyandipuram BO": "630702",
      "Karunchutti BO": "630702",
      "Keelayur BO": "630702",
      "Kottaiyur BO": "630702",
      "Melayur BO": "630702",
      "North Andakudi BO": "630702",
      "Pallithammam BO": "630551",
      "Varapur B.O": "630410",
      "Sirukudalpatti B.O": "630212",
      "N.Vairavanpatti B.O": "630212",
      "Melapatti B.O": "630502",
      "Kilavayal B.O": "630410",
      "Piranmalai B.O": "630502",
      "Neduvayal B.O": "630410",
      "V.Pudur B.O": "630410",
      "Iraniyur B.O": "630212",
      "Illuppakudi B.O": "630202",
      "Unjanai B.O": "630202",
      "Tiruppakottai B.O": "630303",
      "Vengalore B.O": "630303",
      "Karuthavoorani B.O": "630302",
      "Silambani B.O": "630302",
      "Nemathanpatti B.O": "630103",
      "Velayuthapattinam B.O": "630311",
      "Vanjinipatti B.O": "630201",
      "Kallampatti B.O": "630501",
      "Koratti B.O": "630206",
      "Kovilur B.O": "630307",
      "Kuthalur B.O": "630307",
      "Patharakudi B.O": "630307",
      "Pillayarpatti B.O": "630207",
      "Siravayal B.O": "630207",
      "Konnathanpatti B.O": "630405",
      "Pulankurichi B.O": "630405",
      "Sevvur B.O": "630405",
      "Palavangudi B.O": "630208",
      "Jayankondan B.O": "630108",
      "Peerkalaikadu B.O": "630108",
      "Karisalpatti B.O": "630309",
      "Piranpatti B.O": "630309",
      "Eluvankottai B.O": "630303",
      "Maviduthikottai B.O": "630303",
      "Visalayankottai B.O": "630306",
      "Kalapur B.O": "630501",
      "K.Alagapuri B.O": "630106",
      "Sakkottai B.O": "630108",
      "Kannamangalapatti B.O": "630502",
      "Kirungakottai B.O": "630502",
      "Vengaipatti B.O": "630502",
      "Kattukudipatti B.O": "630410",
      "Mandakudipatti B.O": "630410",
      "Tiruvalandur B.O": "630410",
      "Arakottai B.O": "630303",
      "Kannangudi B.O": "630303",
      "Teralapur B.O": "630303",
      "Ac.School B.O": "630107",
      "Kiliyur B.O": "630312",
      "Neivayal B.O": "630312",
      "Thidakottai B.O": "630312",
      "Surakudi B.O": "630501",
      "Kandanurperumalkoil B.O": "630104",
      "Avanipatti B.O": "630205",
      "Tirukolakudi B.O": "630405",
      "Sakkavayal B.O": "630108",
      "Sithivayal B.O": "630108",
      "Dharmapatti B.O": "630309",
      "Chockalingampudur B.O": "630101",
      "Hanumanthagudi B.O": "630303",
      "Lakshmipuram B.O": "630105",
      "Vadagudi B.O": "630107",
      "Pavanakottai B.O": "630311",
      "T.Nagani B.O": "630312",
      "Kandadevi B.O": "630314",
      "Muraiyur B.O": "630501",
      "Vaiyapuripatti B.O": "630501",
      "Ilayathakudi B.O": "630205",
      "Alangudi B.O": "630307",
      "Thuvaralankanmoi BO": "630551",
      "Melamarungur BO": "630554",
      "Pahaianchan BO": "630554",
      "Silukkapatti BO": "630554",
      "Sathani BO": "630709",
      "Sothugudi BO": "630709",
      "Thayamangalam BO": "630709",
      "Chinnakannanur BO": "630609",
      "Kattikulam BO": "630609",
      "Kilamelgudi BO": "630609",
      "Seikalathur BO": "630609",
      "Kalagathankottai BO": "630710",
      "Athikaram B.O": "630207",
      "Kambanur B.O": "630207",
      "Tuvar B.O": "630405",
      "Mitravayal B.O": "630108",
      "Periakottai B.O": "630108",
      "Musundapatti B.O": "630309",
      "Karaikudi Angadi B.O": "630001",
      "Siramam BO": "630554",
      "Kallurani BO": "630559",
      "Mutharasan BO": "630559",
      "Vembattur BO": "630559",
      "Nagamuguthangudi BO": "630709",
      "SKaraikudi BO": "630609",
      "Saveriarpattinam BO": "630609",
      "Vandal BO": "630710",
      "Kumaravelur BO": "630411",
      "Selliampatti B.O": "622403",
      "Jayankondanilai BO": "625102",
      "Kulathupatti B.O": "621308",
      "Velarendal BO": "630554",
      "Kannamangalam BO": "630709",
      "Kilapasalai BO": "630609",
      "Melapidavur BO": "630609",
      "Samudram BO": "630710",
      "Thogavur BO": "630710",
      "Pulikanmoi BO": "630551",
      "Usilangulam BO": "630554",
      "Indankulam BO": "630709",
      "Melaseithur BO": "630709",
      "Melapasalai BO": "630609",
      "Milaganoor BO": "630609",
      "Muthur BO": "630556",
      "Sathanur BO": "630710",
      "Puliyadithamam BO": "630411",
      "Palayanur BO": "630610",
      "Uluthimadai BO": "630610",
      "Ladanendal BO": "630611",
      "Poovanthi BO": "630611",
      "Mallakottai BO": "630566",
      "ASiruvayal BO": "630305",
      "Veppangulam BO": "630305",
      "Vaiyakalathur BO": "630203",
      "Tirumalaikoneripatti BO": "630552",
      "Alavakottai BO": "630553",
      "Sholapuram BO": "630557",
      "Chockanathapuram BO": "630313",
      "Koothandam BO": "630562",
      "Mudikandam BO": "630562",
      "Padamathur BO": "630562",
      "Sakkandhi BO": "630562",
      "Arumuganagar BO": "630211",
      "Bhramanampatti BO": "630210",
      "Ayyapatti BO": "630211",
      "Kottaiyiruppu BO": "630211",
      "Melarangiam BO": "630611",
      "Sekkakudi BO": "630408",
      "Vilangattur BO": "630408",
      "Ambalathadi BO": "630612",
      "Keeladi BO": "630612",
      "Aralikottai BO": "630566",
      "Padathanpatti BO": "630305",
      "Pilar BO": "630305",
      "Mahibalanpatti BO": "630203",
      "Velangudi BO": "630203",
      "PKarungulam BO": "630204",
      "Pattamangalam BO": "630204",
      "Alagamanagiri BO": "630553",
      "Kalakanmoi BO": "630555",
      "Satharasanpatti BO": "630555",
      "Sengulipatti BO": "630555",
      "Panangudi BO": "630555",
      "Vittaneri BO": "630556",
      "Panangadi BO": "630556",
      "Kanjirangal BO": "630562",
      "Surakulam Pudukottai BO": "630562",
      "Tamarakki BO": "630562",
      "Tirumanjolai BO": "630562",
      "MPudur BO": "630210",
      "Alampatti BO": "630211",
      "Viswanoor BO": "630713",
      "Maranadu BO": "630610",
      "Thanjakur BO": "630610",
      "Vellikurichi BO": "630610",
      "Manalur BO": "630611",
      "Piramanur BO": "630611",
      "Kavathugudi BO": "630408",
      "Konthagai North BO": "630612",
      "Sevarakottai BO": "630305",
      "Naduvikottai BO": "630204",
      "Kattanipatti BO": "630553",
      "Namanur BO": "630553",
      "Nalukottai BO": "630557",
      "Keelakottai BO": "630313",
      "Enathi BO": "630562",
      "Idayamelur BO": "630562",
      "Malampatti BO": "630562",
      "Muthupatti BO": "630562",
      "Periyakannanur BO": "630562",
      "Pillur BO": "630562",
      "Salur BO": "630562",
      "Kattambur BO": "630210",
      "Karaiyur BO": "630211",
      "Nedumaram BO": "630211",
      "Sivaganga HO": "630561",
      "Devakottai H.O": "630302",
      "Karaikudi H.O": "630001",
      "Manamadurai HO": "630606",
      "Kanur BO": "630610",
      "Kothangulam BO": "630610",
      "AMukkulam BO": "630611",
      "Allinagaram BO": "630611",
      "Kalugarkadai BO": "630611",
      "Keelauchani BO": "630408",
      "AKarungulam BO": "630321",
      "Kilapungudi BO": "630305",
      "Kurunthampattu BO": "630305",
      "Alagapuri BO": "630556",
      "Kalayarmangalam BO": "630557",
      "Nagarampatti BO": "630558",
      "Athapadakki BO": "630562",
      "Kanakkangudi BO": "630562",
      "Kandangipatti BO": "630562",
      "Kandani BO": "630562",
      "Satharasankottai BO": "630562",
      "Ranasingapuram BO": "630211",
      "SSKottai BO": "630211",
      "Sevalpatti BO": "630211",
      "TPudupatti BO": "630211",
      "Tirukalapatti BO": "630211",
      "Devakottai Palace S.O": "630302",
      "Devakottai Road S.O": "630005",
      "Kallupatti S.O (Sivaganga)": "630306",
      "Kothamangalam S.O (Sivaganga)": "630105",
      "Pallattur S.O": "630107",
      "Ae.College S.O": "630003",
      "CVmangalam S.O": "630501",
      "Ariyakudi S.O": "630202",
      "Attangudi S.O": "630101",
      "Kanadukathan S.O": "630103",
      "Kallukatti S.O": "630001",
      "Devakottai South S.O": "630302",
      "A.Thekkur S.O": "630201",
      "Amaravathipudur S.O": "630301",
      "Chettinad S.O": "630102",
      "Devakottai Extension S.O": "630303",
      "Devakottai West S.O": "630302",
      "Periyakarai S.O": "630311",
      "Puliyal S.O": "630312",
      "Shanmuganathapuram S.O": "630314",
      "Alagappapuram S.O": "630003",
      "Cecri Campus S.O": "630003",
      "Karaikudi Southstreet S.O": "630002",
      "Kandanur S.O": "630104",
      "Kilasevalpatti S.O": "630205",
      "Nerkuppai S.O": "630405",
      "O.Siruvayal S.O": "630208",
      "Ilayangudi West SO": "630702",
      "Manamadurai Town SO": "630606",
      "Pudur Ilayangudi SO": "630709",
      "Rajagambiram SO": "630609",
      "Suranam SO": "630713",
      "Natarajapuram SO Sivaganga": "630555",
      "Okkur SO": "630557",
      "Sivaganga North SO": "630561",
      "Sm Hospital SO": "630211",
      "Tirupattur Bus Stand SO": "630211",
      "Kalayarkoil SO": "630551",
      "Salaigramam SO": "630710",
      "Tiruppuvanam Pudur SO": "630611",
      "Tiruvegampet SO": "630408",
      "Eriyur SO": "630566",
      "Jawahar Bazaar SO": "630561",
      "Kilapungudi SO": "630552",
      "Madagupatti SO": "630553",
      "Sivaganga Courts SO": "630561",
      "Tirukoshtiyur SO": "630210",
      "Kannar Street SO": "630606",
      "Periakottai SO": "630559",
      "Tiruppachetti SO": "630610",
      "Pottapalayam SO": "630612",
      "Bosenagar SO Sivaganga": "630561",
      "Kallal SO": "630305",
      "Nattarasankottai SO": "630556",
      "Paganeri SO": "630558",
      "Sembanur SO": "630313",
      "Sivaganga Collectorate SO": "630562",
      "Kottaiyur S.O": "630106",
      "Kunnakudi S.O": "630206",
      "Managiri S.O": "630307",
      "Nachiapuram S.O": "630207",
      "Pulidipatti S.O": "630309",
      "Sekkalai S.O": "630002",
      "Senjai S.O": "630001",
      "Ulagampatti S.O": "630410",
      "Viramathi S.O": "630212",
      "Muthupatnam S.O": "630001",
      "Puduvayal S.O": "630108",
      "Singampunari S.O": "630502",
      "Idaikattur SO": "630602",
      "Ilayangudi SO": "630702",
      "Manamadurai RS SO": "630606",
      "Mangalam SO Sivaganga": "630554",
      "Sarakeni SO": "630411",
      "Tiruppuvanam SO": "630611",
      "Vethiyur SO": "630321",
      "Kandavarayanpatti SO": "630203",
      "Kandramanickam SO": "630204",
      "Tirupattur SO": "630211"
    },
    "TUTICORIN": {
      "Kanam B.O": "628201",
      "Melaputhukudi B.O": "628201",
      "Moolakarai B.O": "628201",
      "Kandasamypuram B.O": "628301",
      "Lakshmimanagaram B.O": "628202",
      "Peyanvilai B.O": "628202",
      "Rajamaniapuram B.O": "628202",
      "Punnakayal B.O": "628151",
      "Sendamangalam B.O": "628151",
      "Therku Autoor B.O": "628151",
      "Therikudiyiruppu B.O": "628205",
      "Kulasekarapatnam South B.O": "628206",
      "Madavankurichi B.O": "628206",
      "Sirunadarkudiyiruppu B.O": "628206",
      "Alankinar B.O": "628704",
      "Kalinguvilai B.O": "628704",
      "Anavaradanallur B.O": "628809",
      "Vittilapuram B.O": "628809",
      "Kottarakurichi B.O": "628802",
      "Maramangalam B.O": "628802",
      "Cherakulam B.O": "628622",
      "Kalvoy B.O": "628622",
      "Ramanujampudur B.O": "628622",
      "Vallakulam B.O": "628622",
      "Kurangani B.O": "628623",
      "Sonaganvilai B.O": "628201",
      "Keeranur B.O": "628151",
      "Mukkani B.O": "628151",
      "Thandavankadu B.O": "628206",
      "Sriparangusanallur B.O": "628621",
      "Kombankulam B.O": "628704",
      "Pandarapuram B.O": "628704",
      "Arumugamangalam B.O": "628802",
      "Idaiyarkadu B.O": "628802",
      "Kurukattur B.O": "628623",
      "Mela Autoor B.O": "628151",
      "Omarikadu B.O": "628151",
      "Kayalpatnam Bazaar B.O": "628204",
      "Nathankinar B.O": "628205",
      "Tirupuliyangudi B.O": "628621",
      "Velur B.O": "628621",
      "Pudukulam B.O": "628704",
      "Sankarankudiyiruppu B.O": "628704",
      "Manakad B.O": "628205",
      "Mela Tiruchendur B.O": "628205",
      "Subramaniapuram B.O": "628251",
      "Alanthalai B.O": "628206",
      "Kallamozhi B.O": "628206",
      "Nedungulam B.O": "628704",
      "Pannamparai B.O": "628704",
      "Vijayaramapuram B.O": "628704",
      "Surangudi B.O": "628901",
      "Chinnamalaikundru B.O": "628902",
      "Adanur B.O": "628712",
      "Arungulam B.O": "628712",
      "Pillaiyarnatham B.O": "628721",
      "Ahilandapuram B.O": "628714",
      "Ilavelangal B.O": "628714",
      "Athikulam B.O": "628952",
      "Moortheeswaram B.O": "628952",
      "Pannikulam B.O": "628952",
      "Vellalankottai B.O": "628952",
      "Sholapuram B.O": "628908",
      "Manthithope B.O": "628502",
      "Vijayapuri B.O": "628502",
      "Kilakarandai B.O": "628904",
      "Ilambuvanam B.O": "628902",
      "Kadalai B.O": "628902",
      "Kalugachalapuram B.O": "628902",
      "Thalaikattupuram B.O": "628902",
      "Kappulingampatti B.O": "628714",
      "Tennampatti B.O": "628714",
      "Vadakkuvandanam B.O": "628714",
      "Avalnatham B.O": "628502",
      "Ayyaneri B.O": "628502",
      "Chitrampatti B.O": "628502",
      "East Pandavarmangalam B.O": "628502",
      "Boothalapuram B.O": "628905",
      "Kilaarunachalapuram B.O": "628905",
      "Sankaralingapuram B.O": "628904",
      "Vedapatti B.O": "628904",
      "Irachi B.O": "628720",
      "Kamanaickanpatti B.O": "628720",
      "Velayuthapuram B.O": "628552",
      "Zamindevarkulam B.O": "628721",
      "Bommiahpuram B.O": "628907",
      "Kadalkudi B.O": "628907",
      "Karisalkulam B.O": "628907",
      "Kilavilathikulam B.O": "628907",
      "Venkatesawarapuram B.O": "628552",
      "Melmandai B.O": "628901",
      "Tattaneri B.O": "628901",
      "Sakkammalpuram B.O": "628712",
      "Nambipuram B.O": "628902",
      "Perilovanpatti B.O": "628902",
      "Sindalakarai B.O": "628902",
      "Alampatti B.O": "628503",
      "Kottali B.O": "628714",
      "Kurumalai B.O": "628714",
      "Parivillikottai B.O": "628714",
      "Kilavaippar B.O": "628903",
      "Veppalodai B.O": "628903",
      "Melaseithalai B.O": "628722",
      "Illupaiyurani B.O": "628502",
      "Kovilpatti North B.O": "628502",
      "Attankarai B.O": "628904",
      "Guruvarpatti B.O": "628904",
      "Nagampatti B.O": "628718",
      "L.Venkateswarapuram B.O": "628905",
      "Mettilpatti B.O": "628905",
      "Mudukkalankulam B.O": "628720",
      "Kattalankulam B.O": "628721",
      "Ramachandrapuram B.O": "628907",
      "Vadamalaisamudram B.O": "628907",
      "Karadikulam B.O": "628552",
      "Koppampatti B.O": "628720",
      "Semmapudur B.O": "628720",
      "Alagappapuram B.O": "628703",
      "Kalangaraipatti B.O": "628721",
      "Nachiyarpuram B.O": "628721",
      "Periyasamipuram B.O": "628906",
      "Meenakshipuram B.O": "628718",
      "V.Vedapatti B.O": "628907",
      "Chettikurichi B.O": "628552",
      "K.Sivagnanapuram B.O": "628716",
      "Villiseri B.O": "628716",
      "Vembur B.O": "628905",
      "Karuppur BO": "626205",
      "Masarpatti BO": "626202",
      "Mavilpatti BO": "626202",
      "K.Duraisamypuram B.O": "628712",
      "Sivagnanapuram B.O": "628712",
      "Muthulapuram B.O": "628902",
      "Padanthapuli B.O": "628902",
      "Padanthapuli 2 B.O": "628503",
      "Kuppanapuram B.O": "628714",
      "Ayyanaruthu B.O": "628952",
      "Therkkuilandaikulam B.O": "628952",
      "Pungavarnatham B.O": "628908",
      "Sippikulam B.O": "628903",
      "Vaippar B.O": "628903",
      "Vedanatham B.O": "628722",
      "G.V.N.Kalluri B.O": "628502",
      "Kovilpatti Indl.Estate B.O": "628502",
      "Kovilpatti R.S B.O": "628502",
      "Lingampatti B.O": "628502",
      "Uthupatti B.O": "628502",
      "Duraisamypuram B.O": "628105",
      "Vowalthothi B.O": "628904",
      "Idaiseval B.O": "628716",
      "Achankulam B.O": "628718",
      "Sillankulam B.O": "628718",
      "Maniyakaranpatti B.O": "628905",
      "Sennamareddipatti B.O": "628905",
      "Sivalarpatti B.O": "628905",
      "Palankulam B.O": "628701",
      "Korkai B.O": "628801",
      "Vallavallan B.O": "628801",
      "Kolunthuthattu B.O": "628653",
      "Polayarpuram B.O": "628653",
      "Puchikadu B.O": "628653",
      "Sokkankudiyiruppu B.O": "628653",
      "Nazareth R S B.O": "628616",
      "Oyyangudi B.O": "628616",
      "Kongarayankurichi B.O": "628619",
      "Manakarai B.O": "628619",
      "Pallakurichi B.O": "628703",
      "Periyathalai B.O": "628703",
      "Pitchivilai B.O": "628219",
      "Sundankottai B.O": "628703",
      "Rajapudukudi BO": "627352",
      "Veppankulam BO": "627352",
      "Alwarthope West B.O": "628612",
      "Alwartirunagari West B.O": "628612",
      "Appankoil B.O": "628612",
      "Mirankulam B.O": "628613",
      "Palaniappapuram B.O": "628613",
      "Tattarmadam B.O": "628653",
      "Pothakalanvilai B.O": "628702",
      "Subbarayapuram B.O": "628702",
      "Thoppuvalam B.O": "628702",
      "Thailapuram B.O": "628617",
      "Udayarkulam B.O": "628617",
      "Vellamadam B.O": "628617",
      "Pandaravilai B.O": "628751",
      "Perur B.O": "628620",
      "Tirukkalur B.O": "628612",
      "Ambalaseri B.O": "628701",
      "Karuvelampadu B.O": "628701",
      "Theripanai B.O": "628701",
      "Karunkadal B.O": "628613",
      "Savariarpuram B.O": "628613",
      "Kadayanodaiai B.O": "628614",
      "Naduvakurichi B.O": "628251",
      "Nallur kommadikottai B.O": "628653",
      "Anbinnagaram B.O": "628702",
      "Chinnamadankudiyiruppu B.O": "628617",
      "Kurippankulam B.O": "628617",
      "Pattakarai B.O": "628618",
      "Alwarkarkulam B.O": "628619",
      "Uyarathukudiyiruppu B.O": "628703",
      "Kadakulam B.O": "628656",
      "Ariyanayagipuram B.O": "628621",
      "Athichanallur B.O": "628621",
      "Kodiankulam BO": "627352",
      "Kilakottai Kailasapuram BO": "627352",
      "Chettikulam B.O": "628701",
      "Kattarimangalam B.O": "628613",
      "Puliankulam B.O": "628613",
      "Therkankulam B.O": "628613",
      "Kadashapuram B.O": "628702",
      "Eluvaraimukki B.O": "628617",
      "Pillaiyanmanai B.O": "628617",
      "Katchanavilai B.O": "628618",
      "Arampannai B.O": "628619",
      "Nattathi B.O": "628751",
      "Parakkiramapandi B.O": "628620",
      "Srimoolakarai B.O": "628620",
      "Idaichivilai B.O": "628656",
      "Thatchanvilai B.O": "628656",
      "Athalikulam B.O": "628621",
      "Srivaikuntam H.O": "628601",
      "Kovilpatti H.O": "628501",
      "Tiruchendur H.O": "628215",
      "Tuticorin H.O": "628001",
      "Puraiyur B.O": "628207",
      "Pallipathu B.O": "628218",
      "Kilaramasamypuram B.O": "628210",
      "Idaiyanvilai B.O": "628211",
      "Kovankadu B.O": "628152",
      "Puthukudi 3rd Mile B.O": "628008",
      "Levingipuram B.O": "628008",
      "Pottalurani B.O": "628851",
      "Singathakurichi B.O": "628851",
      "Therkuvirapandiapuram B.O": "628002",
      "Akkanaickenpatti B.O": "628303",
      "Puliyampatti B.O": "628303",
      "Kulasekaranallur B.O": "628401",
      "Nainapuram B.O": "628402",
      "Kulayankarisal B.O": "628103",
      "Melakootudankadu B.O": "628103",
      "Seerkatchi B.O": "628208",
      "Anaiyur B.O": "628210",
      "Kalvilai B.O": "628210",
      "Semmarikulam B.O": "628210",
      "Kuthiraimozhi B.O": "628213",
      "Nadunallumoolaikinar B.O": "628213",
      "Seerudaiyarpuram B.O": "628213",
      "Kootankadu B.O": "628203",
      "Pudumanai B.O": "628203",
      "Settiapathu B.O": "628203",
      "Vedakottaivilai B.O": "628203",
      "Savarimangalam B.O": "628301",
      "Umarikottai B.O": "628301",
      "Maravanmadam B.O": "628101",
      "Periyanayagipuram B.O": "628101",
      "Mappillaiyurani B.O": "628002",
      "Melaarasadi B.O": "628002",
      "Sankaraperi B.O": "628002",
      "Mudittanendal Pudur B.O": "628102",
      "Thimmarajapuraam B.O": "628102",
      "Varthagareddipatti B.O": "628102",
      "Katcheri Dhalavaipuram B.O": "628401",
      "Swaminatham B.O": "628402",
      "Kootampuli B.O": "628103",
      "Keelatattaparai B.O": "628304",
      "Toovipuram B.O": "628002",
      "Vasavappapuram B.O": "628252",
      "Kothalarivilai B.O": "628251",
      "Kollampirambu dalavaipuram B.O": "628104",
      "Murappanad B.O": "628252",
      "Cruz Fernandespuram B.O": "628001",
      "Nallur B.O": "628207",
      "Sethukuvaithan B.O": "628207",
      "Ilanganathapuram B.O": "628210",
      "Lakshmipuram B.O": "628210",
      "Solaikudiyiruppu B.O": "628210",
      "Agaram B.O": "628152",
      "Kalankudiyiruppu B.O": "628203",
      "Meyoor B.O": "628203",
      "Uthiramadankudiyiruppu B.O": "628203",
      "Madathur B.O": "628008",
      "Pudupatti B.O": "628851",
      "Vadakkukariseri B.O": "628851",
      "Dalavaipuram B.O": "628301",
      "Paraikuttam B.O": "628301",
      "Arockiapuram B.O": "628002",
      "Milavittan R S B.O": "628002",
      "Siluvaipatti B.O": "628002",
      "Marudanvalvoo B.O": "628303",
      "Kilamudiman B.O": "628401",
      "Vellaram B.O": "628401",
      "Jambulingapuram B.O": "628402",
      "Pudupatcheri B.O": "628402",
      "Mangalagiri B.O": "628103",
      "Servaikaranmadam B.O": "628103",
      "Sebathiahpuram B.O": "628251",
      "Melatattaparai B.O": "628304",
      "Suganthalai B.O": "628207",
      "Varandiavel B.O": "628207",
      "Jerusalempatnam B.O": "628218",
      "Vallivilai B.O": "628218",
      "Viramanickam B.O": "628212",
      "Amalinagar B.O": "628215",
      "Aniaparanallur B.O": "628851",
      "Pudurpandiapuram B.O": "628002",
      "Athimarapatti B.O": "628005",
      "Mullaakadu B.O": "628005",
      "Puvani B.O": "628303",
      "Savalaperi B.O": "628303",
      "Akilandapuram B.O": "628401",
      "Kollankinar B.O": "628302",
      "Maniyac R.S. B.O": "628302",
      "Muramban B.O": "628302",
      "Therkusilukkanpatti B.O": "628103",
      "Iruvappapuram B.O": "628251",
      "Kattalangulam B.O": "628251",
      "Valasakaran Vilai B.O": "628251",
      "Chockalingapuram B.O": "628104",
      "Kaliyavoor B.O": "628252",
      "Eppodumvendran S.O": "628712",
      "K.R.Nagar S.O": "628503",
      "Kayathar S.O": "628952",
      "Kurukkuchalai S.O": "628722",
      "Lakshmipuram S.O (Tuticorin)": "628502",
      "Nagalapuram S.O (Tuticorin)": "628904",
      "Kadambur S.O (Tuticorin)": "628714",
      "Kulathur (TVL) S.O": "628903",
      "Nalatinputhur S.O": "628716",
      "Pudur S.O": "628905",
      "Turaiyur S.O": "628720",
      "Vanaramutti S.O": "628721",
      "Vembar S.O": "628906",
      "Ariyanayagipuram S.O": "628901",
      "Ettaiyapuram S.O": "628902",
      "Kilairal S.O": "628908",
      "Pasuvandanai S.O": "628718",
      "Kovilpatti Town S.O": "628501",
      "Vilathikulam S.O": "628907",
      "Kalugumalai S.O": "628552",
      "Ammanpuram S.O": "628201",
      "Manaduthandapathu S.O": "628208",
      "Megnanapuram S.O": "628210",
      "Panickanadarkudiyiruppu S.O": "628212",
      "Paramankurichi S.O": "628213",
      "Pazhaiyalkayal S.O": "628152",
      "Chidambaranagar S.O": "628008",
      "Heavy Water Project Colony S.O": "628007",
      "Korampollam S.O": "628101",
      "Millerpuram S.O": "628008",
      "Muthiahpuram S.O": "628005",
      "Polenaickenpettai S.O": "628002",
      "Pudiyamputhur S.O": "628402",
      "Pudukottai S.O": "628103",
      "Tt. Thermal Power Plant S.O": "628004",
      "Tuticorin courts S.O": "628003",
      "Sivagalai S.O": "628753",
      "Autoor S.O": "628151",
      "Kurumbur S.O": "628207",
      "Sahupuram S.O": "628229",
      "Vellalanvilai S.O": "628219",
      "Alagesapuram S.O": "628002",
      "Kailasapuram S.O (Tuticorin)": "628301",
      "Naraikinar S.O": "628303",
      "New Colony S.O (Tuticorin)": "628003",
      "Tuticorin Cathedral S.O": "628001",
      "Tuticorin Central Bus Stand S.O": "628002",
      "Tuticorin Keelur S.O": "628001",
      "Vallanad S.O": "628252",
      "Neivilai S.O": "628618",
      "Pannaivilai S.O": "628751",
      "Seydunganallur S.O": "628809",
      "Siruthondanallur S.O": "628802",
      "Thenthiruperai S.O": "628623",
      "Adaikalapuram S.O": "628217",
      "Manapad S.O": "628209",
      "Mannanvilai S.O": "628218",
      "Udangudi Christianagaram S.O": "628203",
      "Virapandianpatanam S.O": "628216",
      "Melur Tuticorin S.O": "628002",
      "Mudittanendal S.O": "628102",
      "Sawyerpuram S.O": "628251",
      "Sekkarakudi S.O": "628104",
      "Tuticorin Harbour Estate S.O": "628004",
      "Karungulam S.O": "628615",
      "Kommadikottai S.O": "628653",
      "Mudalur S.O": "628702",
      "Mukuperi S.O": "628616",
      "Padmanabamangalam S.O": "628619",
      "Padukkapathu S.O": "628703",
      "Patemanagaram S.O": "628620",
      "Perungulam S.O (Tuticorin)": "628752",
      "Nazareth S.O": "628617",
      "Eral S.O": "628801",
      "Alwartirunagari S.O": "628612",
      "Anandapuram S.O (Tuticorin)": "628701",
      "Asirvathapuram S.O": "628613",
      "Puthantharuvai S.O": "628656",
      "Puthukudi S.O": "628621",
      "Satankulam S.O": "628704",
      "Thathankulam S.O": "628622",
      "Arumuganeri S.O": "628202",
      "Kayalpatnam S.O": "628204",
      "Kayamozhi S.O": "628205",
      "Kulasekarapatnam S.O": "628206",
      "Nalumavadi S.O": "628211",
      "Tiruchendur Devasthanam S.O": "628215",
      "Ellanaickenpatti S.O": "628851",
      "Otapidaram S.O": "628401",
      "Ottanatham S.O": "628302",
      "Taruvaikulam S.O": "628105",
      "Tattaparai S.O": "628304",
      "Thermal Nagagr S.O": "628006",
      "Vadakkur Tuticorin S.O": "628001",
      "Vetrivelpuram S.O": "628001",
      "Victoria Extension Road S.O": "628002",
      "Campbellabad S.O": "628614"
    },
    "TIRUPPUR": {
      "Dharapuram South BO": "638656",
      "Hanumanthapuram BO": "638656",
      "Chinnakkampalayam BO": "638657",
      "Chinnaputhur BO": "638657",
      "Kallivalasu BO": "638657",
      "Kullaipalayam BO": "638657",
      "Thammareddipalayam BO": "638701",
      "Rattalavalasu BO": "638661",
      "Thottiapalayam BO": "638661",
      "Vellavavipudur BO": "638661",
      "Veerajimangalam BO": "638673",
      "Nandavanampalayam BO": "638702",
      "Rudravathi BO": "638702",
      "Sadayapalayam BO": "638702",
      "Erasinampalayam BO": "638106",
      "Kilangundal BO": "638106",
      "Komarapalayam Mulanur BO": "638106",
      "Kottaimulanur BO": "638106",
      "Pichakkalpatti BO": "638106",
      "Puliampatti Mulanur BO": "638106",
      "Rakkiavalasu BO": "638106",
      "Nochipalayam BO": "638706",
      "Vengipalayam BO": "638703",
      "Theethampalayam BO": "638111",
      "Muliampoondi BO": "638111",
      "Nagamanaickenpatti BO": "638111",
      "Puduppai BO": "638111",
      "Senapathipalayam BO": "638111",
      "Uppupalayam BO": "638111",
      "Chitravuthampalayam BO": "638657",
      "Govindapuram BO": "638657",
      "Nanjiampalayam BO": "638657",
      "Kangayam East BO": "638701",
      "Aratholuvu BO": "638701",
      "Olapalayam BO": "638701",
      "Veeranampalayam BO": "638701",
      "Avanashipalayam BO": "638660",
      "Karaiyur BO": "638661",
      "Nallampalayam BO": "638661",
      "Bommanallur BO": "638673",
      "Ponnivadi BO": "638673",
      "Bellampatti BO": "638702",
      "Kokkampalayam BO": "638702",
      "Muthugoundenpalayam BO": "638702",
      "Surianallur BO": "638702",
      "Nathachenniagoundenvalasu BO": "638106",
      "Orathupalayam BO": "638106",
      "Pattuthurai BO": "638106",
      "Vadugapatti BO": "638106",
      "Vellierichal BO": "638105",
      "Thonguttipalayam BO": "641665",
      "Punganthurai BO": "638706",
      "Mettupalayam VELLAKOIL BO": "638111",
      "Mylrangam BO": "638111",
      "Selampalayam BO": "638672",
      "Ponnapuram BO": "638657",
      "Thoppampatti BO": "638657",
      "Kadayur BO": "638701",
      "Keeranur BO": "638701",
      "Kosavampalayam BO": "638701",
      "Mudianerichal BO": "638701",
      "Pappinipachapalayam BO": "638701",
      "Paranjervali BO": "638701",
      "Sivamalai BO": "638701",
      "Nagalingapuram BO": "638660",
      "Nelali BO": "638660",
      "Kalipalayam BO": "638661",
      "Achur BO": "638673",
      "Bagavankoil BO": "638673",
      "Therpatti BO": "638673",
      "Undarapatti BO": "638673",
      "Sammangarai BO": "638106",
      "Alampalayam BO": "638661",
      "Mangalapatti BO": "638105",
      "Marudurai BO": "638108",
      "Mullipuram BO": "638108",
      "Alagumalai BO": "641665",
      "Kandiankoil BO": "641665",
      "Kambiliampatti BO": "638706",
      "Nallimadam BO": "638706",
      "Mudalipalayam BO": "641606",
      "Sengodampalayam BO": "638703",
      "Thayampalayam BO": "638703",
      "Agalaraipalayam BO": "638111",
      "Dasavanaickenpatti BO": "638111",
      "Karuppanvalasu BO": "638111",
      "Goldenpet BO": "641401",
      "Alangiam BO": "638657",
      "Dasarapatti BO": "638657",
      "Gethelrev BO": "638657",
      "Nanjundapuram BO": "638657",
      "Alambadi BO": "638701",
      "Avanashipalayampudur BO": "638701",
      "Nathakattuvalasu BO": "638701",
      "Padiyur BO": "638701",
      "Pothiapalayam BO": "638701",
      "Veeracholapuram BO": "638701",
      "Kurukkapalayam BO": "638660",
      "Mettuvalasu BO": "638661",
      "Peramium BO": "638661",
      "Koneripatti BO": "638673",
      "Manakkadavu BO": "638673",
      "Devarajapatnam BO": "638702",
      "Chinnamarudur BO": "638106",
      "Mambadi BO": "638106",
      "Nathapalayam BO": "638106",
      "Thurambadi BO": "638106",
      "Kuttapalayam BO": "638108",
      "Palayakottai BO": "638108",
      "Peruntholuvu BO": "641665",
      "Sirukinar BO": "638706",
      "Kungarupalayam BO": "638703",
      "Karattupalayam BO": "638111",
      "Lakkamanaickenpatti BO": "638111",
      "Velappanaickenvalasu BO": "638111",
      "Pallapalayam BO": "641663",
      "Chittambalam BO": "641664",
      "Madapur BO": "641664",
      "Velarasikallipalayam BO": "641664",
      "Sircarperiapalayam BO": "641607",
      "TEA Nagar BO": "641606",
      "Poomalur BO": "641663",
      "Samalapuram BO": "641663",
      "Naranapuram BO": "641664",
      "Nathagoundenpalayam BO": "641664",
      "Vadugapalayam BO": "641654",
      "Velarasivadamalaipalayam BO": "641664",
      "Doddampatti BO": "641667",
      "Ganganaikanpalayam BO": "641667",
      "Kattoor palladam BO": "641667",
      "Arasampalayam BO": "641604",
      "Kathankanni BO": "641604",
      "Maruduraiyanvalasu BO": "641604",
      "Karuvampalayam BO": "641604",
      "Ganapathipalayam BO": "641605",
      "Karaipudur BO": "641605",
      "Sukkampalayam BO": "641662",
      "Vadugankalipalayam BO": "641663",
      "Vanjipalayam BO": "641663",
      "Kanakkampalayam BO": "641666",
      "Karunampathi BO": "641666",
      "Pongupalayam BO": "641666",
      "Vavipalayam BO": "641671",
      "Tiruneelakandapuram BO": "641607",
      "Kallampalayam Road BO": "641602",
      "Pandian nagar BO": "641602",
      "Manur BO": "641606",
      "Muthanampalayam BO": "641606",
      "Nachipalayam BO": "641606",
      "Jallipatti B.O": "642112",
      "Solamadevi B.O": "642113",
      "Ganapathipalayam B.O": "642122",
      "Senjellappagoundenpudur B.O": "642122",
      "Sengattupalayam B.O": "642206",
      "Vilamarathupatti B.O": "642207",
      "Pudupalayam B.O": "642205",
      "Vadugapalayam B.O": "642205",
      "Samarayapatti B.O": "642204",
      "Uralpatti B.O": "642204",
      "Agrahara Kannadiputhur B.O": "642111",
      "Pallapalayam B.O": "642112",
      "Ammapatti B.O": "642205",
      "Athukinathupatti B.O": "642206",
      "Munduvelampatti B.O": "642206",
      "Pottikkampalayam B.O": "642206",
      "Devanurpudur B.O": "642207",
      "Erisinampatti B.O": "642207",
      "Ravanapuram B.O": "642207",
      "Udukkampalayam B.O": "642207",
      "Deepalapatti B.O": "642132",
      "Sundakkampalayam B.O": "642132",
      "Dhully B.O": "642112",
      "Manupatti B.O": "642112",
      "Thirumurthi Nagar B.O": "642112",
      "Sarkarkannadipudur B.O": "642113",
      "Doddampatti B.O": "642205",
      "Kongalnagaram B.O": "642205",
      "Kodingium B.O": "642122",
      "Chellappampalayam B.O": "642207",
      "Vallakondapuram B.O": "642207",
      "63 Velampalayam BO": "641663",
      "Agraharaputhur BO": "641663",
      "Anuppapatti BO": "641664",
      "Elavanthi BO": "641664",
      "Panickampatti BO": "641664",
      "Venkitapuram BO": "641664",
      "Ittiveerampalayam BO": "641666",
      "Devanampalayam BO": "641667",
      "Thomaspuram BO": "641654",
      "Mannarai BO": "641607",
      "Puluvapatti BO": "641602",
      "Ugayanur BO": "641605",
      "Nallur BO": "641606",
      "Nambiampalayam BO": "641670",
      "Ramanathapuram BO": "641670",
      "Pongaluravanashi BO": "638459",
      "15 Velampalayam BO": "641652",
      "Sembianallur BO": "641654",
      "Thulukkamuthur BO": "641654",
      "Morattupalayam BO": "638752",
      "Dalavoipalayam BO": "638751",
      "Andigoundanur B.O": "642154",
      "Pukkulam B.O": "642154",
      "Thumbalapatti B.O": "642154",
      "Vedapatti B.O": "642203",
      "Rudrapalayam B.O": "642204",
      "Sircarkathankanni BO": "638752",
      "Pallagoundenpalayam BO": "638056",
      "Maravapalayam BO": "638051",
      "Pothampalayam BO": "638460",
      "Pulipar BO": "638460",
      "Punjaithamaraikulam BO": "638460",
      "Vettuvapalayam BO": "641670",
      "Karukkampalayam BO": "641654",
      "Karukkankattupudur BO": "641654",
      "Kuppandampalayam BO": "641654",
      "Periyayipalayam BO": "641654",
      "Pudupalayam BO": "641654",
      "Velayuthampalayam BO": "641654",
      "Kaikattipudur BO": "641654",
      "Palangarai BO": "641654",
      "Vagatholuvu B.O": "642202",
      "Virugalpatti B.O": "642120",
      "Periapatti B.O": "642201",
      "Jothampatti B.O": "642203",
      "Kadathur B.O": "642203",
      "Kallapuram B.O": "642102",
      "Bodipatti B.O": "642154",
      "Kannamanaickanur B.O": "642154",
      "Kuralkuttai B.O": "642154",
      "Amandakadavoo B.O": "642201",
      "Kottamangalam B.O": "642201",
      "Karatholuvu B.O": "642203",
      "Myvadi B.O": "642203",
      "Nallannagoundanpudur B.O": "642204",
      "Uppilipalayam BO": "641670",
      "Thirumuruganpoondi BO": "641652",
      "Rakkiapalayam BO": "641654",
      "Thekkalur BO": "641654",
      "Virumandampalayam BO": "638812",
      "Anaipalayam BO": "638752",
      "Senapathichettipalayam BO": "638752",
      "Kasthuripalayam BO": "638751",
      "Nadupatti BO": "638056",
      "Kurichikunnathur BO": "638110",
      "Thirumalaigoundenpalayam BO": "638462",
      "Alathur BO": "641655",
      "Iduvoi BO": "641687",
      "Kamanaickenpalayam BO": "641658",
      "Kodangipalayam BO": "641662",
      "Athiyur BO": "638103",
      "Chinniampalayam Kunnathur BO": "638103",
      "Kavuthampalayam BO": "638103",
      "Kuttagam BO": "638462",
      "Thandukaranpalayam BO": "641655",
      "Paruvoi BO": "641658",
      "Kalivelampatti BO": "641662",
      "Kanur BO": "641655",
      "Muriandampalayam BO": "641655",
      "Aingalipalayam BO": "641603",
      "VelampalayamKunnathur BO": "638103",
      "Vellaraveli BO": "638103",
      "Ramachandrapuram B.O": "642120",
      "Elayamuthur B.O": "642154",
      "Kondampatti B.O": "642201",
      "Periakomarapalayam B.O": "642201",
      "Metrathi B.O": "642203",
      "Thungavi B.O": "642203",
      "Kolumam B.O": "642204",
      "Pappankulam B.O": "642204",
      "Sirupuluvapatti BO": "641603",
      "Puliampatti BO": "641658",
      "KAyyampalayam BO": "641662",
      "Mangarasavalayapalayam BO": "641655",
      "Pappankulam BO": "641655",
      "Pichampalayampudur BO": "641603",
      "Andipalayam BO": "641687",
      "Merkupathi BO": "638103",
      "Mandiripalayam BO": "641671",
      "Kannivadi B.O": "639202",
      "Malamedu B.O": "639201",
      "Edakkalpadi B.O": "639202",
      "Sundakkampalayam BO": "638103",
      "Pattampalayam BO": "638458",
      "Suriappampalayam BO": "638458",
      "Sokkanur BO": "638103",
      "Nanjaithalaiyur B.O": "639202",
      "Vallipuram BO": "638103",
      "Arikkaranvalasu B.O": "639201",
      "Velampundi B.O": "639201",
      "Erachapadi B.O": "639202",
      "Dharapuram HO": "638656",
      "Gudimangalam S.O": "642201",
      "Pedappampatti S.O": "642205",
      "Pungamuthur S.O": "642207",
      "Udamalpet South S.O": "642126",
      "Tirupur HO": "641601",
      "Venkatesa Mills S.O": "642128",
      "Udamalpet H.O": "642126",
      "Gandhinagar S.O (Pollachi)": "642154",
      "Amaravathi Nagar S.O": "642102",
      "Kaniyur S.O": "642203",
      "Pulankinar S.O": "642122",
      "Eripalayam S.O": "642126",
      "Komaralingam S.O": "642204",
      "Krishnapuram S.O (Coimbatore)": "642111",
      "Kurichikottai S.O": "642112",
      "Madathukulam S.O": "642113",
      "Pulavadi S.O": "642206",
      "Valavadi S.O": "642132",
      "Dalavoipatnam SO": "638672",
      "Sankarandampalayam SO": "638706",
      "Udhiyur SO": "638703",
      "Veerapandi SO": "641605",
      "Tirupur Collectorate SO": "641604",
      "Kangayam North SO": "638701",
      "Kolathupalayam SO": "638661",
      "Kolinjivadi SO": "638673",
      "Vellakoil Bazaar SO": "638111",
      "Vellakoil SO": "638111",
      "Kangayam SO": "638701",
      "Kundadam SO": "638702",
      "Muthur SO": "638105",
      "Nathakadayur SO": "638108",
      "Pallikalipalayam SO": "641665",
      "Ellisnagar SO": "638657",
      "Koduvoi SO": "638660",
      "Mulanur SO": "638106",
      "Vijayapuram SO": "641606",
      "Kunnathur SO Erode": "638103",
      "Uttukuli Rs SO": "638752",
      "Uttukuli SO": "638751",
      "Anuppapalayam SO": "641652",
      "Avanashi SO": "641654",
      "Cheyur SO": "641655",
      "Karadibavi SO": "641658",
      "Kuppusamynaidupuram SO": "641662",
      "Ngr Road SO": "641664",
      "Perumanallur SO": "641666",
      "Perumanallur Road SO": "641602",
      "Ranganathapuram SO": "641654",
      "Tirupur Cotton Market SO": "641604",
      "Tirupur Bazaar SO": "641604",
      "Iduvampalayam SO": "641687",
      "Mangalam SO": "641663",
      "Tirupur East SO": "641607",
      "Karavalur SO": "641670",
      "Kettanur SO": "641671",
      "Kumarnagar SO": "641603",
      "Tirupur North SO": "641602",
      "Chengapalli SO": "638812",
      "Gandhinagar SO": "641603",
      "Palladam SO": "641664",
      "Pongalur SO": "641667"
    },
    "COIMBATORE": {
      "Allapalayam BO": "641653",
      "Belladi BO": "641104",
      "Chikkarampalayam BO": "641104",
      "Mangalakaraipudur BO": "641104",
      "Annurmettupalayam BO": "641653",
      "Nagammapudur BO": "641653",
      "Nallichettipalayam BO": "641653",
      "Pilliappampalayam BO": "641653",
      "Vadakkalur BO": "641653",
      "Kariampalayam BO": "641653",
      "Paralipower House BO": "641104",
      "Kanjapalli BO": "641653",
      "Komarapalayam BO": "641669",
      "Pasuravanashi BO": "641653",
      "Athappagoundenpudur BO": "641103",
      "Chinthamanipudur BO": "641103",
      "Odderpalayam BO": "641653",
      "Kuppanur BO": "641010",
      "Sokkampalayam BO": "641653",
      "Kamatchipuram BO": "641103",
      "Ravathur BO": "641103",
      "Kadampadi BO": "641401",
      "Marudur BO": "641104",
      "Pillurdam BO": "641104",
      "Purandampalayam BO": "641669",
      "Vadambachery BO": "641669",
      "Chandrapuram BO": "641669",
      "Malayadipalayam BO": "641669",
      "Puliamarathupalayam BO": "641669",
      "Eripatti B.O": "642205",
      "Poosaripatti B.O": "642205",
      "Seelakkampatti B.O": "642205",
      "A.Nagore B.O": "642205",
      "Senjeri BO": "641669",
      "Velappanaickenpalayam BO": "641669",
      "Chennappachettipudur BO": "641659",
      "Vaharayampalayam BO": "641659",
      "Palapatti BO": "641305",
      "Karegoundenpalayam BO": "641697",
      "Muduthurai BO": "638459",
      "Bhujanganur BO": "641113",
      "Akkaraisengapalli BO": "641302",
      "Ichipatti BO": "641668",
      "Kalingal BO": "641402",
      "Muthugoundenpudur BO": "641402",
      "Marappagoundenpudur B.O": "642103",
      "Chinnappampalayam B.O": "642104",
      "Cinchona East B.O": "642106",
      "Periya Kallar B.O": "642106",
      "Dasanaicken Palayam B.O": "642202",
      "Mohavanur B.O": "642202",
      "Palarpathy B.O": "642109",
      "Singarampalayam B.O": "642109",
      "Alagirichettipalayam B.O": "642110",
      "Achipatti B.O": "642002",
      "Kurumbapalayam B.O": "642002",
      "Palanigoundenpudur B.O": "642002",
      "Puliampatti B.O": "642002",
      "Nallamudi B.O": "642117",
      "Vadugapalayam B.O": "642001",
      "Chinna Negamam B.O": "642120",
      "Devenampalayam B.O": "642120",
      "Kakkadavoo B.O": "642120",
      "Kappalankarai B.O": "642120",
      "Thondamuthur B.O": "642123",
      "Murugali Bazaar B.O": "642125",
      "Sheikalmudi B.O": "642125",
      "Akilandapuram B.O": "642004",
      "Karuppampalayam B.O": "642004",
      "Korangumudi B.O": "642127",
      "Manamboli B.O": "642127",
      "Nirar Dam B.O": "642127",
      "Old Valparai B.O": "642127",
      "Thimmankothu B.O": "642005",
      "Thippampatti B.O": "642107",
      "Kadamparai Power House B.O": "642101",
      "Minparai B.O": "642101",
      "Navamalai Camp B.O": "642101",
      "Upper Aliyar Dam B.O": "642101",
      "Athu Pollachi B.O": "642103",
      "Divansapudur B.O": "642103",
      "Ganapathipalayam B.O": "642103",
      "Kaniyurpalladam BO": "641659",
      "Thathur B.O": "642104",
      "Vellamalai B.O": "642130",
      "Vadakkipalayam B.O": "642110",
      "Kanjampatti B.O": "642003",
      "Unjavelampatti B.O": "642003",
      "Vellalapalayam B.O": "642120",
      "Mettubavi B.O": "641202",
      "Urulikkal B.O": "642127",
      "Odayakulam B.O": "642129",
      "Mannur B.O": "642005",
      "Reddiarur B.O": "642007",
      "Kolarpatti B.O": "642107",
      "Lakshmapuram B.O": "642107",
      "Moperipalayam BO": "641659",
      "Dasanur BO": "641305",
      "Kallar BO": "641305",
      "Ellapalayam BO": "641697",
      "Therampalayam BO": "641697",
      "Ambodi BO": "638459",
      "Thekkampatti BO": "641113",
      "Tholampalayam BO": "641113",
      "Vivekanandapuram BO": "641113",
      "Bellaipalayam BO": "641302",
      "Athikadavu BO": "641104",
      "Giddampalayam BO": "641659",
      "Kaduvettipalayam BO": "641659",
      "Pethikuttai BO": "638459",
      "Jadayampalayam BO": "641302",
      "Sinnakallipatti BO": "641302",
      "Thimmanur BO": "641302",
      "Karavalimadapur BO": "641668",
      "Semmandampalayam BO": "641668",
      "Appanaickenpatti BO": "641402",
      "Rasipalayam BO": "641402",
      "Illuppapalayam BO": "641302",
      "Subbarayanpudur BO": "641668",
      "Periapodu B.O": "642103",
      "Kattampatti B.O": "642202",
      "Moongiltholuvu B.O": "642202",
      "Arasampalayam B.O": "642109",
      "Muthur B.O": "642109",
      "Solavampalayam B.O": "642109",
      "Devarayapuram B.O": "642110",
      "Kaliapuram B.O": "642129",
      "Poravipalayam B.O": "642110",
      "T.Kottampatti B.O": "642002",
      "Pollachi West B.O": "642001",
      "Andipalayam B.O": "642120",
      "Kondegoundenpalayam B.O": "642120",
      "Senguttaipalayam B.O": "642120",
      "Zamin Kottampatti B.O": "642123",
      "Topslip B.O": "642133",
      "Pethanaickanur B.O": "642134",
      "Kurunallipalayam B.O": "641202",
      "High Forest B.O": "642127",
      "Pannimade B.O": "642127",
      "Sirukundra B.O": "642127",
      "Vellonie B.O": "642127",
      "Mount Stuart B.O": "642105",
      "Waverly B.O": "642105",
      "Mappillaigoundenpudur B.O": "642005",
      "Ramapattinam B.O": "642005",
      "Thenkumarapalayam B.O": "642107",
      "Velliankadu BO": "641104",
      "Paduvampalli BO": "641659",
      "Nellithurai BO": "641305",
      "Periaputhur BO": "641697",
      "Vadavallikaramadai BO": "641697",
      "Irumborai BO": "638459",
      "Kanuvakarai BO": "638459",
      "Sellappampalayam BO": "638459",
      "Medur BO": "641113",
      "Alancombu BO": "641302",
      "Kannampalayam BO": "641402",
      "Jalakarichal BO": "641658",
      "Jallipatti BO": "641671",
      "Kammalapatti BO": "641671",
      "Vadavedampatti BO": "641671",
      "Lakshminaickenpalayam BO": "641658",
      "JKrishnapuram BO": "641671",
      "Senjeriputhur BO": "641671",
      "Subbegoundenpudur B.O": "642103",
      "Chinnakallar B.O": "642106",
      "Paralai B.O": "642108",
      "Sirukalandai B.O": "642202",
      "Kothavadi B.O": "642109",
      "Nallattipalayam B.O": "642109",
      "Sokkanur B.O": "642109",
      "Thamaraikulam B.O": "642109",
      "Mettupalayam B.O": "642110",
      "Sulakkal B.O": "642110",
      "R.Ponnapuram B.O": "642002",
      "Settiakkapalayam B.O": "642120",
      "Sarkarpathi B.O": "642133",
      "Ramanamudali Pudur B.O": "642134",
      "Kondampatti B.O": "641202",
      "Akkamalai B.O": "642127",
      "Sholayar B.O": "642127",
      "Thalanar B.O": "642105",
      "Devambadi B.O": "642005",
      "Nalluthukuli B.O": "642005",
      "Thalakarai B.O": "642005",
      "Kambalapatti B.O": "642007",
      "Vedasanthur B.O": "642007",
      "Eachanari BO": "641021",
      "Bodipalayam BO": "641105",
      "Pattanam BO": "641016",
      "Kumittipathi BO": "641032",
      "Bogampatti BO": "641658",
      "Siddanaickenpalayam BO": "641658",
      "SAyyampalayam BO": "641671",
      "Talakkarai BO": "641671",
      "Masthigoundenpathi BO": "641032",
      "Meenakshipuram BO": "641032",
      "Keeranatham BO": "641035",
      "Kallipalayam BO": "641107",
      "Oraikkalpalayam BO": "641107",
      "Odayampalayam BO": "641028",
      "Athipalayam BO": "641110",
      "Ettimadai BO": "641112",
      "Vellanaipatti BO": "641048",
      "Sinnanavakkarai BO": "641105",
      "Thirumalayampalayam BO": "641105",
      "Peedampalli BO": "641016",
      "Arisipalayam BO": "641032",
      "Elur BO": "641032",
      "Konavaikalpalayam BO": "641023",
      "Kunnathurpudur BO": "641107",
      "Kuppaipalayam BO": "641107",
      "Masagoundenchettipalayam BO": "641107",
      "Nilambur BO": "641062",
      "Venkitapuram BO": "641062",
      "Mathipalayam BO": "641101",
      "Nathegoundenpudur BO": "641101",
      "Veerapandi Periyanaickenpalaya BO": "641019",
      "Ishana Vihar BO": "641114",
      "Rakkipalayam BO": "641031",
      "Madampatti BO": "641010",
      "Sundakkamuthur BO": "641010",
      "Veerakeralam BO": "641007",
      "Devarayapuram BO": "641109",
      "Kallapalayam BO": "641201",
      "Periyakuyilai BO": "641201",
      "Krishnarayapuram BO": "641006",
      "Madukkarai Cusba BO": "641105",
      "Pichanur BO": "641105",
      "Edayapalayam BO": "641016",
      "Vilankurichi BO": "641035",
      "Kurumbapalayam BO": "641107",
      "Ponnegoundenpudur BO": "641107",
      "Mylampatti BO": "641062",
      "Agraharasamakulam BO": "641110",
      "Tenkarai BO": "641101",
      "Vellakinar BO": "641029",
      "Gudalurcoimbatore BO": "641047",
      "Semmedu BO": "641114",
      "Kondayampalayam BO": "641110",
      "Vellamadai BO": "641110",
      "Vellalapalayam Podanur BO": "641111",
      "Marudamalai BO": "641046",
      "Bilichi BO": "641019",
      "Kavundampalayam BO": "641030",
      "Seeranaickenpalayam BO": "641007",
      "Sundapalayam BO": "641007",
      "Naickenpalayam BO": "641020",
      "Tekkupalayam BO": "641020",
      "Anaikatti BO": "641108",
      "Nanjundapuramtadagam BO": "641108",
      "Pathanjalipuri BO": "641108",
      "Thennamanallur BO": "641109",
      "Viraliyur BO": "641109",
      "Selvapuram BO": "641026",
      "Sengalipalayam BO": "641022",
      "Kalampalayam BO": "641010",
      "Titipalayam BO": "641010",
      "Vedapatti BO": "641007",
      "Veerapanditadagam BO": "641108",
      "Deenampalayam BO": "641109",
      "Ikkarai Boluvampatti BO": "641109",
      "Narasipuram BO": "641109",
      "Thoppampatti BO": "641017",
      "Edayarpalayam BO": "641025",
      "Panapatti BO": "641201",
      "Maniakarampalayam BO": "641006",
      "Sugunapuram BO": "641008",
      "Kandegounden Salai BO": "641105",
      "Palathurai BO": "641105",
      "Pappampatti BO": "641016",
      "Myleripalayam BO": "641032",
      "Valukkuparai BO": "641032",
      "Ganesapuram BO": "641107",
      "Kattampatticoimbatore BO": "641107",
      "Pachapalayam BO": "641107",
      "Kottaipalayam BO": "641110",
      "Madhvarayapuram BO": "641101",
      "Puluvapatti BO": "641101",
      "Samichettipalayam BO": "641047",
      "Siruvani Adivaram BO": "641114",
      "Idigarai BO": "641022",
      "Somayampalayam BO": "641108",
      "Dhaliyur BO": "641109",
      "Jakkirnaickenpalayam BO": "641109",
      "Pannimadai BO": "641017",
      "Coimbatore HO": "641001",
      "Rathinasabapathy Puram HO": "641002",
      "Mettupalayam HO": "641301",
      "Somandurai S.O": "642134",
      "Suleeswaran Patti S.O": "642006",
      "Uthukuli Zamin S.O": "642004",
      "Zamin Muthur S.O": "642005",
      "Pollachi H.O": "642001",
      "Vettaikaran Pudur S.O": "642129",
      "Water Falls Estate S.O": "642105",
      "Gomangalam S.O": "642107",
      "Valparai S.O": "642127",
      "Angalakurichi S.O": "642007",
      "Malayandipattinam S.O": "642114",
      "Vadasithur S.O": "641202",
      "Kangayampalayam SO": "641401",
      "Annur SO": "641653",
      "Arasur SO": "641407",
      "Irugur SO": "641103",
      "Cinchona S.O": "642106",
      "Iyerpadi S.O": "642108",
      "Karamalai Bazaar S.O": "642130",
      "Makkinaicken Patti S.O": "642003",
      "Samathur S.O": "642123",
      "Kinathukadavoo S.O": "642109",
      "Kovilpalayam S.O": "642110",
      "Mahalinga Puram S.O": "642002",
      "Mudis S.O": "642117",
      "Coimbatore Fort SO": "641001",
      "Coimbatore Racecourse SO": "641018",
      "Anaimalai S.O": "642104",
      "Jakkarpalayam S.O": "642202",
      "Pollachi Bazaar S.O": "642001",
      "Sethumadai S.O": "642133",
      "Sholayar Nagar S.O": "642125",
      "Pogalur SO": "641697",
      "Sulur SO": "641402",
      "Sultanpet SO": "641669",
      "Aliyar Nagar S.O": "642101",
      "Ambarampalayam S.O": "642103",
      "N.G.M College S.O": "642001",
      "Karumathampatti SO": "641659",
      "Seeliyur SO": "641113",
      "Sirumugai SO": "641302",
      "Somanur SO": "641668",
      "Mahadevapuram SO": "641305",
      "Negamam S.O": "642120",
      "Coimbatore Courts SO": "641018",
      "Coimbatore Tidel Park SO": "641014",
      "Ganapathy SO": "641006",
      "Kovaipudur SO": "641042",
      "Krishnaswamy Nagar SO": "641045",
      "Malumichampatti SO": "641050",
      "Nanjundapuram SO": "641036",
      "Neelikonampalayam SO": "641033",
      "Ondipudur SO": "641016",
      "Podanur Newtown SO": "641023",
      "Sarkarsamakulam SO": "641107",
      "CBE MplCentral Busstand SO": "641018",
      "Chettipalayam SO": "641201",
      "Chinnavedampatti SO": "641049",
      "Coimbatore Aerodrome SO": "641014",
      "Coimbatore Central SO": "641018",
      "Coimbatore Collectorate SO": "641018",
      "Coimbatore Industrial Estate SO": "641021",
      "Coimbatore West SO": "641001",
      "Kuniamuthur SO": "641008",
      "Othakkalmandapam SO": "641032",
      "Podanur SO": "641023",
      "Ramanathapuram Coimbatore SO": "641045",
      "Vaiyampalayam SO": "641110",
      "Coimbatore Press Colony SO": "641019",
      "Gnanambika Mills SO": "641029",
      "Periyanaickenpalayam SO": "641020",
      "Perur SO Coimbatore": "641010",
      "Vadamadurai Kurudampalayam SO": "641017",
      "Velandipalayam SO": "641025",
      "Coimbatore Bazaar SO": "641001",
      "Commercial Tax Office Building SO": "641018",
      "Gandhimaanagar SO": "641004",
      "Kalapatti SO": "641048",
      "Pappanaickenpalayam SO": "641037",
      "Pappanaickenpalayam West SO": "641037",
      "Ramnagar Coimbatore SO": "641009",
      "Redfields SO": "641018",
      "Siddhapudur SO": "641044",
      "Singanallur SO": "641005",
      "Sukrawarpettai SO": "641001",
      "Gandhipuram SO Coimbatore": "641012",
      "GovtCollege Of Technology SO": "641013",
      "Jothipuram SO": "641047",
      "Karunyanagar SO": "641114",
      "Kavundampalayam Colony SO": "641030",
      "Lawley Road SO": "641003",
      "NGGO Colony SO": "641022",
      "Pappanaickenpudur SO": "641041",
      "RSPuram East SO": "641002",
      "Tudiyalur SO": "641034",
      "Vadavalli SO": "641041",
      "Coimbatore Ukkadam SO": "641008",
      "Madukkarai SO": "641105",
      "Peelamedu East SO": "641004",
      "Peelamedu SO": "641004",
      "Saravanampatti SO": "641035",
      "Sundarapuram SO": "641024",
      "Uppilipalayam SO": "641015",
      "NDC Coimbatore": "641040",
      "Alandurai SO": "641101",
      "Bharathiyar University SO": "641046",
      "Komarapalayam Coimbatore SO": "641026",
      "Rathinapuri SO": "641027",
      "SBInstitute SO": "641007",
      "Tadagam SO": "641108",
      "Tatabad SO": "641012",
      "Telungupalayam SO": "641039",
      "Thondamuthur SO": "641109",
      "Amritanagar SO": "641112",
      "Sinniampalayam SO": "641062",
      "Sowripalayam SO": "641028",
      "Vellalore SO": "641111",
      "Kuppakonanpudur SO": "641038",
      "Narasimhanaickenpalayam SO": "641031",
      "Sahs College SO": "641043",
      "Saibaba Mission SO": "641011",
      "Sri Ramakrishna Vidyalaya SO": "641020",
      "Karamadai SO": "641104"
    },
    "KRISHNAGIRI": {
      "Thumjepalli B.O": "636812",
      "Hanumantheertham B.O": "636902",
      "Katteri B.O": "636902",
      "Keelkuppam B.O": "636902",
      "Bettamugulalam B.O": "636806",
      "Puliampatti B.O": "635206",
      "Beerpalli B.O": "635115",
      "Bikkanahalli B.O": "635115",
      "Billanakuppam B.O": "635115",
      "Kunnathur B.O": "635306",
      "Valipatti B.O": "635306",
      "Andiyur B.O": "635307",
      "Athipadi B.O": "635307",
      "Eggur B.O": "635307",
      "Binnamangalam B.O": "635118",
      "Samanthamalai B.O": "635115",
      "Thippanapalli B.O": "635115",
      "Koppakarai B.O": "635116",
      "Chembarasanapalli B.O": "635117",
      "Chennapalli B.O": "635117",
      "Enusonai B.O": "635117",
      "Kalingavaram B.O": "635117",
      "Nadupatti B.O": "635203",
      "Naickanur B.O": "635307",
      "Periyathallapadi B.O": "635307",
      "Karapattu B.O": "635207",
      "Mannadapatti B.O": "635207",
      "Marampatti B.O": "635207",
      "Mottur B.O": "635112",
      "Chennasandiram B.O": "635121",
      "Chigaramaganapalli B.O": "635121",
      "Doddaubbanur B.O": "635118",
      "Gummalapuram B.O": "635118",
      "Javalagiri B.O": "635118",
      "Thally Kothanur B.O": "635118",
      "Haleseebam B.O": "635119",
      "Pathakota B.O": "635119",
      "Senamavu B.O": "635119",
      "Thuppuganapalli B.O": "635119",
      "Chinnamattarapalli B.O": "635120",
      "Guruvinayanapalli B.O": "635120",
      "Kammampalli B.O": "635120",
      "Maharajakadai B.O": "635120",
      "Dasiripalli B.O": "635121",
      "Gangojikothur B.O": "635121",
      "Manchukondapalli B.O": "635102",
      "Baliganapalli B.O": "635103",
      "Nallore B.O": "635103",
      "Amballi B.O": "635104",
      "Ankinayanapalli B.O": "635104",
      "Gudisadanapalli B.O": "635105",
      "Guttahalli B.O": "635107",
      "Kakkadasam B.O": "635107",
      "Mugalur B.O": "635110",
      "Nagondapalli B.O": "635110",
      "Panchakshipuram B.O": "635110",
      "Begepalli B.O": "635126",
      "Avalapalli B.O": "635109",
      "Thorapalli Agraharam B.O": "635130",
      "Tiruvanapatti B.O": "635304",
      "Periyathalihalli B.O": "635112",
      "Pothapuram B.O": "635112",
      "Bodichipalli B.O": "635113",
      "Bommathathanur B.O": "635113",
      "Peddamelupalli B.O": "635002",
      "Agaram Ittikkal B.O": "635122",
      "Bellarampalli B.O": "635122",
      "Sembadamuthur B.O": "635122",
      "Doddamanchi B.O": "635102",
      "Emakkalnatham B.O": "635104",
      "Kondappanayanapalli B.O": "635104",
      "Madepalli B.O": "635121",
      "Oppadavadi B.O": "635104",
      "A.Settipalli B.O": "635105",
      "Athimugam B.O": "635105",
      "Mudugurukki B.O": "635105",
      "Balathottanapalli B.O": "635107",
      "Bennangur B.O": "635107",
      "Bikkanapalli B.O": "635107",
      "Padiganalam B.O": "635107",
      "Salivaram B.O": "635107",
      "Sandanapalli B.O": "635107",
      "Sarandapalli B.O": "635107",
      "Thadigal B.O": "635107",
      "Orappam B.O": "635108",
      "Sadanapalli B.O": "635108",
      "Periyakaradiyur B.O": "635206",
      "Santhur B.O": "635206",
      "Bimandapalli B.O": "635115",
      "Kurubarahalli B.O": "635115",
      "Baliganur B.O": "635116",
      "Odayandahalli B.O": "635116",
      "Anderipatti B.O": "635306",
      "Ettipatti B.O": "635306",
      "Chappadi B.O": "635117",
      "Koneripalli B.O": "635117",
      "Peddachigaralapalli B.O": "635117",
      "Govindapuram B.O": "635307",
      "Maganurpatti B.O": "635307",
      "Agalakotta B.O": "635118",
      "Shoolingunta B.O": "635118",
      "Agaram B.O": "635204",
      "Upparapatti B.O": "635207",
      "Belavarthi B.O": "635120",
      "Mallinayanapalli B.O": "635120",
      "Peddathalapalli B.O": "635002",
      "Periyakottapalli B.O": "635002",
      "Pothinayanapalli B.O": "635002",
      "Kalvehalli B.O": "635101",
      "Sundekuppam B.O": "635101",
      "Muthur B.O": "635114",
      "Aikondamkothapalli B.O": "635203",
      "Jagadevi B.O": "635203",
      "Kullampatti B.O": "635203",
      "Madarahalli B.O": "635203",
      "Avathavadi B.O": "635204",
      "Papparapatti B.O": "635123",
      "Thatrahalli B.O": "635123",
      "Vadamangalam B.O": "635123",
      "Naralapalli B.O": "635120",
      "Gangaleri B.O": "635122",
      "Kottaiyur B.O": "635102",
      "Mariyalam B.O": "635102",
      "Urigam B.O": "635102",
      "Deveerapalli B.O": "635103",
      "Sevaganapalli B.O": "635103",
      "Bandaseemanur B.O": "635104",
      "Parandapalli B.O": "635206",
      "Kodipalli B.O": "635115",
      "Nedumaruthi B.O": "635115",
      "Doddathimmanahalli B.O": "635116",
      "Badapalli B.O": "635306",
      "Kodamandapatti B.O": "635306",
      "Kumbalam B.O": "635117",
      "Samanapalli B.O": "635117",
      "Kethunaickenpatti B.O": "635307",
      "Mittapalli B.O": "635307",
      "Pavakkal B.O": "635307",
      "Achubala B.O": "635118",
      "Belalam B.O": "635118",
      "Marupalli B.O": "635118",
      "Nochipatti B.O": "635207",
      "Venkatadampatti B.O": "635207",
      "Mekalachinnampalli B.O": "635120",
      "Balanapalli B.O": "635121",
      "Chigaralapalli B.O": "635104",
      "Thummanapalli B.O": "635105",
      "Panakamutulu B.O": "635106",
      "Andevanapalli B.O": "635107",
      "Erudukotta B.O": "635107",
      "Kundukottai B.O": "635107",
      "Noganur B.O": "635107",
      "Balanayanapalli B.O": "635108",
      "Marudepalli B.O": "635108",
      "Gopanapalli B.O": "635110",
      "Bukkasagaram B.O": "635130",
      "Kamandoddi B.O": "635130",
      "Perandapalli B.O": "635130",
      "Venkatesapuram B.O": "635109",
      "Periyakottakulam B.O": "635304",
      "Chowtahalli B.O": "635112",
      "Kadhiripuram B.O": "635112",
      "Thimmapuram B.O": "635112",
      "Bairamangalam B.O": "635113",
      "Karupalli B.O": "635113",
      "Pachappanatti B.O": "635113",
      "Ullukurukki B.O": "635113",
      "Karadiguri B.O": "635002",
      "Peddanapalli B.O": "635002",
      "Gundalapatti B.O": "635101",
      "Kurumpatti B.O": "635101",
      "Devaganapalli B.O": "635114",
      "Athiganur B.O": "635203",
      "Kalarpathi B.O": "635203",
      "Kavandanur B.O": "635203",
      "Perugopanapalli B.O": "635203",
      "Thogarapalli B.O": "635203",
      "Marichettihalli B.O": "635204",
      "Velampatti B.O": "635204",
      "Deveerahalli B.O": "635123",
      "Doddapoovathi B.O": "635122",
      "Ennegolpudur B.O": "635122",
      "Moramadugu B.O": "635122",
      "Seshurajapuram B.O": "635102",
      "Thagatti B.O": "635102",
      "Batlapalli B.O": "635104",
      "Chintagampalli B.O": "635104",
      "Mallapadi B.O": "635104",
      "Venkatasamudram B.O": "635104",
      "Nandimangalam B.O": "635105",
      "Bannihalli B.O": "635106",
      "Anniyalam B.O": "635107",
      "Arasakuppam B.O": "635107",
      "Devarulimangalam B.O": "635107",
      "Gendiganapalli B.O": "635107",
      "Maradanapalli B.O": "635107",
      "Achamangalam B.O": "635108",
      "Kandikuppam B.O": "635108",
      "Achettipalli B.O": "635110",
      "Muduganapalli B.O": "635110",
      "Mookandapalli B.O": "635126",
      "Basthi B.O": "635109",
      "Doripalli B.O": "635130",
      "Kothagondapalli B.O": "635109",
      "Onnalvadi B.O": "635109",
      "M.Vellalapatti B.O": "635304",
      "Jagadab B.O": "635112",
      "Penneswaramadam B.O": "635112",
      "Chennathur B.O": "635109",
      "Muthali B.O": "635109",
      "Anandur B.O": "635304",
      "Salamarathupatti B.O": "635304",
      "Sulakarai B.O": "635304",
      "Malaiyandahalli B.O": "635112",
      "Mittahalli B.O": "635112",
      "Nedungal B.O": "635112",
      "Paiyur B.O": "635112",
      "Iruthalam B.O": "635113",
      "Kundumaranapalli B.O": "635113",
      "Nagamangalam B.O": "635113",
      "Kallukurukki B.O": "635002",
      "Peddabelagondapalli B.O": "635114",
      "Saragapalli B.O": "635114",
      "Nakkalpatti B.O": "635203",
      "Vilangamudi B.O": "635204",
      "Viramalai B.O": "635204",
      "Anakode B.O": "635206",
      "Angampatti B.O": "635206",
      "Mahadevagollahalli B.O": "635206",
      "Jakkeri B.O": "635113",
      "Doddabelur B.O": "635113",
      "Agraharam B.O": "635002",
      "Kanakamutulu B.O": "635002",
      "Chinnappareddipalayam B.O": "635114",
      "Anchoor B.O": "635203",
      "Kannandahalli B.O": "635203",
      "Oddapatti B.O": "635203",
      "Sivampatti B.O": "635203",
      "Baleguli B.O": "635204",
      "Maruderi B.O": "635204",
      "Damodarahalli B.O": "635123",
      "Balethottam B.O": "635206",
      "Arasampatti B.O": "635201",
      "Bendrahalli B.O": "635201",
      "Thathampatti B.O": "635201",
      "Nachikuppam B.O": "635121",
      "Viruppasandiram B.O": "635121",
      "Jingilikadirampatti B.O": "635201",
      "Konegoundanur B.O": "635121",
      "Kottur B.O": "635121",
      "Kuriyanapalli B.O": "635121",
      "Marasandiram B.O": "635121",
      "Neralagiri B.O": "635121",
      "Manavaranapalli B.O": "635121",
      "Nallur B.O": "635121",
      "Krishnagiri H.O": "635001",
      "Berigai S.O": "635105",
      "Elathagiri S.O": "635108",
      "Hosur S.O (Dharmapuri)": "635109",
      "Krishnagiri Collectorate S.O": "635115",
      "Krishnagiri Indl. Estate S.O": "635002",
      "Krishnagiri Project S.O": "635101",
      "Mathagondapalli S.O": "635114",
      "Mathur S.O (Dharmapuri)": "635203",
      "Pochampalli S.O (Krishnagiri)": "635206",
      "Singarapettai S.O": "635307",
      "Thally S.O": "635118",
      "Varattanapalli S.O": "635120",
      "Alapatti S.O": "635122",
      "Kallavi S.O": "635304",
      "Kattinayanapalli S.O": "635001",
      "Shoolagiri S.O": "635117",
      "Uddanapalli S.O": "635119",
      "Bagalur S.O (Krishnagiri)": "635103",
      "Chaparthi S.O": "635106",
      "Denkanikotta S.O": "635107",
      "Dowlatabad S.O": "635001",
      "Hosur East S.O": "635109",
      "Kaveripattinam S.O (Krishnagiri)": "635112",
      "Krishnagiri Courts S.O": "635001",
      "Pannandur S.O": "635123",
      "Ramapuram S.O (Dharmapuri)": "635115",
      "Royakottah S.O": "635116",
      "Samalpatti R.S S.O": "635306",
      "Uttangarai S.O": "635207",
      "Kumudepalli SO": "635130",
      "Anchetty S.O": "635102",
      "Barugur S.O": "635104",
      "Belathur S.O": "635124",
      "Hosur Cattle Farm S.O": "635110",
      "Hosur Indl. Complex S.O": "635126",
      "Kelamangalam S.O": "635113",
      "Nagarasampatti S.O": "635204",
      "Veppanapalli S.O": "635121",
      "Barur S.O": "635201"
    },
    "THE NILGIRIS": {
      "Thengumarahada BO": "638451",
      "Thalakundah B.O": "643005",
      "Munnanad GDS B.O": "643239",
      "Cherambadi Tea Division B.O": "643220",
      "Cherangode B.O": "643220",
      "Seaforth BO": "643226",
      "Glenmorgan B.O": "643237",
      "Periashola B.O": "643226",
      "Doddabetta B.O": "643002",
      "Iduhatti B.O": "643002",
      "Athikunna B.O": "643241",
      "Kunnalady B.O": "643241",
      "Nunthala B.O": "643003",
      "Thangadu Oranali B.O": "643003",
      "Welbeck Estate B.O": "643003",
      "Singara B.O": "643223",
      "Kariashola B.O": "643225",
      "Rockwood Estate B.O": "643225",
      "Pykaradam B.O": "643237",
      "Kenthorai B.O": "643002",
      "T Mynalai B.O": "643002",
      "Ketti Palada B.O": "643215",
      "Shanthur B.O": "643215",
      "Mudugula B.O": "643003",
      "Mavanahalla B.O": "643223",
      "Prospect B.O": "643224",
      "Glenvans B.O": "643226",
      "Yellamalai B.O": "643226",
      "Thummanatti B.O": "643002",
      "Avalanchi Power House B.O": "643209",
      "Bickatti B.O": "643209",
      "Mulligoor B.O": "643209",
      "Nandhatti B.O": "643212",
      "Puliampara B.O": "643212",
      "Sree Madurai B.O": "643212",
      "Lauriston B.O": "643211",
      "Machikolli B.O": "643211",
      "Mudumalai Sanctuary B.O": "643211",
      "Thorapalli B.O": "643211",
      "Kalhatti B.O": "643005",
      "Kokkal B.O": "643005",
      "Sholur B.O": "643005",
      "Ithalar B.O": "643004",
      "Kuruthukuli B.O": "643004",
      "M.Palada B.O": "643004",
      "Choondi B.O": "643211",
      "Adderly B.O": "643102",
      "Burliar B.O": "643102",
      "Hillgrove B.O": "643102",
      "Kotagiri Bazaar B.O": "643217",
      "Billicombai B.O": "643214",
      "Down Hills B.O": "643217",
      "Farm Tea Estate B.O": "643217",
      "Gundada B.O": "643217",
      "Kaikatti B.O": "643217",
      "Thiashoa B.O": "643219",
      "Muthorai B.O": "643004",
      "Parsons Valley B.O": "643004",
      "Cherumulli B.O": "643211",
      "Kargudi B.O": "643211",
      "Nadugani B.O": "643211",
      "Kollimalai Oranalli B.O": "643215",
      "Manihatti B.O": "643003",
      "Moyarcamp B.O": "643223",
      "Bellevue B.O": "643224",
      "T R Bazaar B.O": "643224",
      "Thuneri B.O": "643002",
      "Hubbathalai B.O": "643202",
      "Jegathala B.O": "643202",
      "Katary  R.S. B.O": "643102",
      "St Josephs College B.O": "643102",
      "Vannarpet B.O": "643102",
      "Katary Dam B.O": "643213",
      "Kilinjada B.O": "643213",
      "T.Manihatti B.O": "643214",
      "Aracode B.O": "643216",
      "Kadinamalai B.O": "643216",
      "Kil Kotagiri Bazaar B.O": "643216",
      "Hettakal B.O": "643236",
      "Kengarai B.O": "643236",
      "Doddacombai B.O": "643219",
      "Kil Kundah B.O": "643219",
      "Korakundah B.O": "643219",
      "Araihatty B.O": "643221",
      "Karumbalam B.O": "643102",
      "Sogathorai B.O": "643102",
      "Koderi B.O": "643213",
      "Kagguchi B.O": "643214",
      "Kodanad B.O": "643217",
      "Kukalthorai B.O": "643217",
      "Masakkal B.O": "643217",
      "Nihung B.O": "643217",
      "Kinnakorai B.O": "643219",
      "Manjoor B.O": "643219",
      "Dhavani B.O": "643007",
      "Hullathi B.O": "643007",
      "Yedakadu B.O": "643209",
      "Mullikorai B.O": "643004",
      "Nanjanad B.O": "643004",
      "Athipalli B.O": "643212",
      "Marthoma Nagar B.O": "643211",
      "Padanthorai B.O": "643211",
      "Dunsandle B.O": "643005",
      "Manjacombai Bazaar B.O": "643221",
      "Yedappalli B.O": "643103",
      "Anikorai B.O": "643206",
      "Bengalmattam B.O": "643204",
      "Gurrency B.O": "643102",
      "Hulical B.O": "643102",
      "Kannerimukku B.O": "643217",
      "Konavakorai B.O": "643217",
      "Milidane B.O": "643217",
      "Nedugula B.O": "643217",
      "Thuthurmattam B.O": "643218",
      "Pegumbahalla Camp B.O": "643219",
      "Pilloormattam B.O": "643238",
      "Berhatti B.O": "643231",
      "Ambalamoola B.O": "643240",
      "Chinna Coonoor B.O": "643206",
      "Mayfield B.O": "643207",
      "Halakkarai B.O": "643103",
      "Kunjapanai B.O": "643242",
      "Athigaratti B.O": "643003",
      "Pattavayal B.O": "643240",
      "Ebbanad B.O": "643206",
      "Kayyunni B.O": "643205",
      "Kadanad B.O": "643206",
      "Thoraihatty B.O": "643206",
      "Coonoor H.O": "643101",
      "Udagamandalam H.O": "643001",
      "Aravenu S.O": "643201",
      "Chamraj Estate S.O": "643204",
      "Defence Service Staff College S.O": "643231",
      "Donnington S.O": "643217",
      "Nonsuch S.O": "643238",
      "Konnachal S.O": "643239",
      "Newhope S.O": "643226",
      "Sandynallah S.O": "643237",
      "Devala SO": "643270",
      "Aruvankadu S.O": "643202",
      "Katary S.O": "643213",
      "Kotagiri S.O": "643217",
      "Kundah Bridge S.O": "643219",
      "Wellington Bazaar S.O": "643231",
      "Wellington S.O": "643231",
      "Bitherkad S.O": "643240",
      "Dr. Basuviah Nagar S.O": "643007",
      "Emerald S.O": "643209",
      "Mangorange S.O": "643220",
      "Naduvattam S.O": "643224",
      "Nellakotta S.O": "643225",
      "Pandalur S.O": "643233",
      "St Marys Hill S.O": "643001",
      "Stone House Hill S.O": "643002",
      "Yellanhalli S.O": "643243",
      "Coonoor Bazaar S.O": "643102",
      "Kattabettu S.O": "643214",
      "Kil Kotagiri S.O": "643216",
      "Melur Nilgiris S.O": "643221",
      "Ottupattarai S.O": "643105",
      "Pasteur Institute S.O": "643103",
      "Tuttapallam S.O": "643242",
      "Devarshola S.O": "643207",
      "Fernhill S.O": "643004",
      "Gudalur Bazaar S.O": "643212",
      "Gudalur Nilgiris S.O": "643211",
      "Lovedale S.O": "643003",
      "Coonoor RS S.O": "643102",
      "Kotada Estate S.O": "643236",
      "Kullakamby S.O": "643218",
      "Balacola S.O": "643203",
      "Charing Cross S.O": "643001",
      "Cherambadi S.O": "643205",
      "Denaducombai S.O": "643206",
      "Finger Post S.O": "643006",
      "Indunagar S.O": "643005",
      "Ketti S.O": "643215",
      "Kolapalli S.O": "643253",
      "Masinagudi S.O": "643223",
      "Udagamandalam Market S.O": "643001",
      "Udagamandalam Race Course S.O": "643001",
      "Uppatti S.O": "643241"
    },
    "THIRUVALLUR": {
      "Chandravilasapuram B.O": "631301",
      "Kadananagaram B.O": "631301",
      "Paivalasa B.O": "631302",
      "Peddanagapudi B.O": "631302",
      "Peddaramapuram B.O": "631302",
      "Rangapuram B.O": "631302",
      "V.P.R.Puram B.O": "631302",
      "Vediyangadu B.O": "631302",
      "Veeramangalam B.O": "631302",
      "Karikalavakkam B.O": "602021",
      "Thalakancheri B.O": "602021",
      "Egattur B.O": "631203",
      "Kaivandur B.O": "631203",
      "Krishnasamudram B.O": "631206",
      "Ramasamudram B.O": "631206",
      "Karimbedu B.O": "631207",
      "Narasingapuram B.O": "631402",
      "Majankaranai B.O": "601102",
      "Mukkarambakkam B.O": "601102",
      "Nelvoy B.O": "602023",
      "Thandalam B.O": "601102",
      "Keechalam B.O": "631208",
      "T.T.Kandigai B.O": "631208",
      "Odappai B.O": "602023",
      "Pullarambakkam B.O": "602023",
      "Sandarayanpalayam B.O": "602023",
      "Kasavarajpetta B.O": "631211",
      "Vadattur B.O": "602024",
      "Aranvoyal B.O": "602025",
      "Agooru B.O": "631209",
      "Netterikandigai B.O": "631209",
      "Suryanagaram B.O": "631209",
      "Chinnammapet B.O": "631210",
      "Harichandrapuram B.O": "631210",
      "Kunnavalam B.O": "631210",
      "Goonipalayam B.O": "602026",
      "Thyagapuram B.O": "631301",
      "Karlambakkam B.O": "631202",
      "Kodivalasa B.O": "631202",
      "Thamaraikulam B.O": "631302",
      "Kilanur B.O": "602021",
      "Odikkadu B.O": "602021",
      "Perattur B.O": "602021",
      "Pattaraiperumbudur B.O": "631203",
      "Selai B.O": "631203",
      "Vidaiyur B.O": "631203",
      "Beerakuppam B.O": "631205",
      "Koramangalam B.O": "631205",
      "Thadur B.O": "631205",
      "Buchireddipalli B.O": "631206",
      "Illupur B.O": "602002",
      "Kilnallathur B.O": "602002",
      "Echambadi B.O": "631207",
      "Samanthavada B.O": "631207",
      "Veliagaram B.O": "631207",
      "Kilacheri B.O": "631402",
      "Kannigaipair B.O": "601102",
      "Vadamadurai B.O": "601102",
      "Pandravedu B.O": "631208",
      "Sorakayapeta B.O": "631208",
      "Placepalayam B.O": "602023",
      "Thalavedu B.O": "631212",
      "Karthikeyapuram B.O": "631211",
      "Perumalpattu B.O": "602024",
      "Papparambakkam B.O": "602025",
      "Thozhur B.O": "602025",
      "Murukkambattu B.O": "631209",
      "Srinivasapuram B.O": "631209",
      "Upper Tirutani B.O": "631209",
      "Tirutani Hills B.O": "631209",
      "Athipattu B.O": "631210",
      "Kaverirajapuram B.O": "631210",
      "Kurmavilasapuram B.O": "631210",
      "Veeraraghavapuram B.O": "631210",
      "Mambakkam B.O": "631205",
      "Athimanjeri B.O": "631202",
      "Kothakuppam B.O": "631202",
      "Nochili B.O": "631202",
      "Chanurmallavaram B.O": "631302",
      "Senji B.O": "631203",
      "Illuppur B.O": "631204",
      "Muthukondapuram B.O": "631204",
      "Nabalur B.O": "631204",
      "Ramanjeri B.O": "631204",
      "S.Agraharam B.O": "631205",
      "Sirugumi B.O": "631205",
      "Veerakaverirajapuram B.O": "631205",
      "Nungambakkam B.O": "602002",
      "Polivakkam B.O": "602002",
      "Kolathur B.O": "631207",
      "Konetampet B.O": "631207",
      "Kumararajupeta B.O": "631207",
      "Nediyam B.O": "631207",
      "Kuvam B.O": "631402",
      "Mappedu B.O": "631402",
      "C.N.Kandigai B.O": "631208",
      "Jangalapalli B.O": "631208",
      "Kakalur B.O": "631208",
      "Pettaikandigai B.O": "631208",
      "Alamelumangapuram B.O": "631213",
      "Ponpadi B.O": "631213",
      "Allikuzhi B.O": "602023",
      "Nambakkam B.O": "602023",
      "Timmaboopalapuram B.O": "602023",
      "Vellathukottai B.O": "602023",
      "Adivaragapuram B.O": "631303",
      "Mahankalikapuram B.O": "631301",
      "Chivada B.O": "631201",
      "Nemili B.O": "631201",
      "Balakrishnapuram B.O": "631202",
      "Konasamudram B.O": "631202",
      "Myladumparai B.O": "631302",
      "Srikalikapuram B.O": "631302",
      "Monnavedu B.O": "602021",
      "Pandur B.O": "631203",
      "Pudumavilangai B.O": "631203",
      "Tirupasur B.O": "631203",
      "Arcot B.O": "631204",
      "Kanchipadi B.O": "631204",
      "Nedambaram B.O": "631204",
      "Ramapuram B.O": "631204",
      "Cherukkanur B.O": "631205",
      "T.C.Kandigai B.O": "631205",
      "V.K.N.Kandigai B.O": "631205",
      "Melnallathur B.O": "602002",
      "Punyam B.O": "631207",
      "Sanakuppam B.O": "631207",
      "Venkatarajakuppam B.O": "631207",
      "Kondancheri B.O": "631402",
      "Athivakkam B.O": "601102",
      "Bommarajupeta B.O": "631208",
      "Nedigallu B.O": "631208",
      "Perumanallur B.O": "631208",
      "Savattur B.O": "631208",
      "Devandavakkam B.O": "602023",
      "Neiveli B.O": "602023",
      "Nallathur B.O": "631212",
      "Veeranathur B.O": "631303",
      "Pakkam B.O": "602024",
      "Sivanvoyal B.O": "602024",
      "Veppambattu B.O": "602024",
      "Putlur B.O": "602025",
      "Pattabiramapuram B.O": "631209",
      "Mannur B.O": "631210",
      "Palayanur B.O": "631210",
      "Peddakalakattur B.O": "631210",
      "Vyasapuram B.O": "631210",
      "Palavakkam S.O (TiruvallB.O": "602026",
      "Ammaneri B.O": "631303",
      "Karlapakkam B.O": "602024",
      "Komakkambedu B.O": "602024",
      "Kottamedu B.O": "602024",
      "Tiruninravur B.O": "602024",
      "Kalambakkam B.O": "602025",
      "Koppur B.O": "602025",
      "Velanjeri B.O": "631209",
      "Pakasala B.O": "631210",
      "Tirukandalam B.O": "601103",
      "Kalpattu B.O": "601103",
      "Meyyur B.O": "601103",
      "Poorivakkam B.O": "601103",
      "Sembedu B.O": "601103",
      "Velliyur B.O": "601103",
      "Emrkandigai B.O": "631304",
      "Rajanagaram B.O": "631304",
      "Perandur B.O": "602026",
      "Pondavakkam B.O": "602026",
      "Seethanjeri B.O": "602026",
      "Sulaimeni B.O": "602026",
      "Enambakkam B.O": "601103",
      "Pennaluripeta B.O": "602026",
      "Tharakshi B.O": "602026",
      "Damaraipakkam B.O": "601103",
      "Ulundai B.O": "602105",
      "Balapuram B.O": "631301",
      "Kannur B.O": "602108",
      "Tirupandiyur B.O": "602108",
      "Vayalur B.O": "602105",
      "Devampattu BO": "601201",
      "Edoor BO": "601201",
      "Elavur BO": "601201",
      "Iguvarpalayam BO": "601201",
      "Kallur BO": "601201",
      "Siddharajakandigai BO": "601201",
      "Sirupulalpettai BO": "601201",
      "Sunnambukulam BO": "601201",
      "Tervali BO": "601201",
      "Oragadam BO": "600053",
      "Voyalur BO": "601203",
      "Subbareddypalayam BO": "600120",
      "Vallur BO": "600120",
      "Kolur BO": "601205",
      "Thirupalavanam BO": "601205",
      "Boochiathipattu BO": "600052",
      "Edapalayam BO": "600052",
      "Guruvoyal BO": "600052",
      "Alinjivakkam BO": "600067",
      "Budur BO": "600067",
      "Koduvalli BO": "600055",
      "Palavedu BO": "600055",
      "Panayancheri BO": "601101",
      "Pondavakkam BO": "601101",
      "Kamarajnagar BO": "600057",
      "Tiruvottiyur West BO": "600019",
      "Puduvoyal BO": "601206",
      "Puvalambedu BO": "601206",
      "Roshanagaram BO": "601202",
      "Thanipoondi BO": "601202",
      "Thervoy BO": "601202",
      "Kattur BO": "601203",
      "Neidavoyal BO": "601203",
      "Seemapuram South BO": "601203",
      "Thriuvellavoyal BO": "601203",
      "Aladu BO": "601204",
      "Amoor BO": "601204",
      "Arasur BO": "601204",
      "Krishnapuram BO": "601204",
      "Alamathi BO": "600052",
      "Orakadu BO": "600067",
      "Thiruvengadnagar BO": "600053",
      "Arambakkam BO": "601201",
      "New Gummidipundi BO": "601201",
      "Podiyarankulam BO": "601201",
      "Chinnambedu BO": "601206",
      "Kilmudalambedu BO": "601206",
      "Kannankottai BO": "601202",
      "Vellivoyalchavadi BO": "600103",
      "Vichoor BO": "600103",
      "Jothi Nagar BO": "601203",
      "Nandiambakkam BO": "600120",
      "Panjetti BO": "601204",
      "Reddipalayam BO": "601204",
      "Pammadukulam BO": "600052",
      "Vadakarai BO": "600052",
      "Erumaivettipalayam BO": "600067",
      "Nayar BO": "600067",
      "Rallapadi BO": "601101",
      "Mangavaram BO": "601201",
      "Periaobulapuam BO": "601201",
      "Tondiarpet Rly Colony BO": "600019",
      "Kilikodi BO": "601206",
      "Manellore BO": "601202",
      "Pallavada BO": "601202",
      "Andarkuppam BO": "600103",
      "Anuppampattu BO": "601203",
      "Devadanam BO": "601203",
      "Velur BO": "601203",
      "Medur BO": "601204",
      "Perumbedu BO": "601204",
      "Vilangadupakkam BO": "600052",
      "Jagannathapuram BO": "600067",
      "Gandhinagar BO": "600054",
      "Ayanambakkam BO": "600095",
      "Vanagaram BO": "600095",
      "Sembarambakkam BO": "600123",
      "Puduchatram BO": "600124",
      "Udayarkoil BO": "600124",
      "Numbal BO": "600077",
      "Pandeeswaram BO": "600055",
      "Senneerkuppam BO": "600056",
      "Vellavedu BO": "600124",
      "Mittanamalli BO": "600055",
      "Morai BO": "600055",
      "Paruthipattu BO": "600071",
      "Kolappancheri BO": "600072",
      "Kattupakkam BO": "600056",
      "Kuttambakkam BO": "600124",
      "Kovilpadagai BO": "600062",
      "Malayambakkam BO": "600123",
      "Arignar Anna Nagar BO": "600072",
      "Soranjeri BO": "600072",
      "Voyalanallur BO": "600072",
      "Nemam BO": "600124",
      "Veeraraghavapuram BO": "600077",
      "Vellanur BO": "600062",
      "Kamarajnagar SO": "600071",
      "Poonamallee SO": "600056",
      "Sriramachandra Deemed Uty SO": "600116",
      "Tirumullaivoyal SO": "600062",
      "Pattabiram SO": "600072",
      "Railway Carshed Complex SO": "600062",
      "Tank Factory Avadi SO": "600054",
      "Velnagar Vellanur SO": "600062",
      "Tiruvallur H.O": "602001",
      "CRP camp SO Tiruvallur": "600055",
      "Ikkadu S.O": "602021",
      "Madduru S.O": "631206",
      "Nggo Colony Tiruvallur S.O": "602001",
      "Vijayalakshmipuram SO": "600053",
      "Cvrde SO": "600054",
      "Avadi Camp HO": "600054",
      "Thandarai SO": "600072",
      "Thirumushi SO": "600124",
      "Ammavarikuppam S.O": "631301",
      "Kg Kandigai S.O": "631205",
      "Manavalanagar S.O": "602002",
      "Tirumangalam Road SO": "600049",
      "Redhills SO": "600052",
      "Shanmugapuram SO": "600019",
      "Sholavaram SO": "600067",
      "Avadi IAF SO": "600055",
      "Avadi SO": "600054",
      "Nazarethpettai SO": "600123",
      "Senthilnagar SO": "600062",
      "Thiruverkadu SO": "600077",
      "Athimanjeripeta S.O": "631202",
      "Kakalur Ind Estate S.O": "602003",
      "Kanakammachatram S.O": "631204",
      "Pannur S.O (Kanchipuram)": "602108",
      "Arungolam S.O": "631201",
      "Erumbi S.O": "631302",
      "Kadambathur S.O": "631203",
      "Pallipat S.O": "631207",
      "Perambakkam S.O": "631402",
      "Podaturpeta S.O": "631208",
      "Ponpadi Rs S.O": "631213",
      "Tiruttani S.O": "631209",
      "Poondi S.O": "602023",
      "Poonimangadu S.O": "631212",
      "Ramakrishnarajupeta S.O": "631303",
      "Tiruninravur Rs S.O": "602024",
      "Tirur Cpt S.O": "602025",
      "Tiruvelangadu S.O": "631210",
      "Periapalayam S.O": "601102",
      "Saraswathinagar S.O": "631211",
      "Tiruttanieast S.O": "631209",
      "Uttukottai S.O": "602026",
      "Arni CPT SO": "601101",
      "Gummidipundi SO": "601201",
      "Kaladipet SO": "600019",
      "Vengal S.O": "601103",
      "Vanganur S.O": "631304",
      "Kavarapettai SO": "601206",
      "Mogappair West SO": "600037",
      "Moolakadai SO": "600060",
      "Padianallur SO": "600052",
      "Ponneri SO": "601204",
      "Pulicat SO": "601205",
      "Ernavur SO": "600057",
      "Ponneri Public Office SO": "601204",
      "Ponniammanmedu SO": "600110",
      "Korattur SO": "600050",
      "Madarpakkam SO": "601202",
      "Menambedu SO": "600053",
      "Minjur SO": "601203",
      "North Chennai Thermal PP SO": "600120",
      "Prithivipakkam SO": "600053"
    },
    "TENKASI": {
      "Kulasekaramangalam B.O": "627862",
      "Naduvakurichi B.O": "627862",
      "Pambukoilshandy B.O": "627862",
      "Poigai B.O": "627856",
      "Kalathimadam B.O": "627851",
      "Kuthapanjan B.O": "627851",
      "Maruthamputhur B.O": "627851",
      "Agarakattu B.O": "627852",
      "Nelkattumseval B.O": "627758",
      "Ariyanayagipuram B.O": "627862",
      "Andipatti B.O": "627851",
      "Vellanaikottai B.O": "627758",
      "Ariyur B.O": "627758",
      "Sankanaperi B.O": "627758",
      "Alkondarkulam B.O": "627862",
      "Kilavirasigamani B.O": "627862",
      "Vadanathampatti B.O": "627862",
      "Anjankattalai B.O": "627851",
      "Marandai B.O": "627851",
      "Pudupatti B.O": "627851",
      "Karisalkulam B.O": "627719",
      "Umaithalaivanpatti B.O": "627719",
      "Vellakulam B.O": "627719",
      "Gudalur B.O": "627760",
      "Sambakulam B.O": "628552",
      "Pandapuli B.O": "627753",
      "Paruvakkudi B.O": "627753",
      "Kalappakulam B.O": "627754",
      "Perungottur B.O": "627754",
      "Sathirakondan B.O": "627754",
      "Balapadraramapuram B.O": "627953",
      "Kilanilithanallur B.O": "627953",
      "Komarudappapuram B.O": "627953",
      "Thalaivankottai B.O": "627755",
      "Vadakkupudur B.O": "627755",
      "Veeriruppu B.O": "627755",
      "Ayyapuram B.O": "627805",
      "Chinthamani B.O": "627855",
      "Punniahpuram B.O": "627855",
      "Ichanda B.O": "627857",
      "Vadugapatti B.O": "627757",
      "Viswanathaperi B.O": "627757",
      "Melakalangal B.O": "627860",
      "Melamarudappapuram B.O": "627860",
      "Rukmaniammalpuram B.O": "627860",
      "Naickerpatti B.O": "628552",
      "Pazhankottai B.O": "628552",
      "Perumalpatti B.O": "627753",
      "Perumpattur B.O": "627753",
      "Sennikulam B.O": "627753",
      "Senthattiapuram B.O": "627753",
      "K. Alankulam B.O": "627754",
      "Ramanathapuram(SNL) B.O": "627953",
      "Malayadikurichi B.O": "627755",
      "Nagaram B.O": "627755",
      "Gomathimuthupuram B.O": "627761",
      "Thirumalapuram B.O": "627857",
      "Uthankulam B.O": "627857",
      "Vellalankulam B.O": "627857",
      "Arugankulam B.O": "627757",
      "Devipattinam B.O": "627757",
      "Chatrapatti B.O": "627719",
      "Naranapuram B.O": "627760",
      "Muthammalpuram B.O": "627951",
      "Kulasekaraperi B.O": "627753",
      "Kuvalaikanni B.O": "627753",
      "Reddiapatti B.O": "627753",
      "Srigomathipuram B.O": "627753",
      "Subbulapuram B.O": "627753",
      "Alagunatchiapuram B.O": "627754",
      "Chiambarapuram B.O": "627754",
      "Marukkalankulam B.O": "627953",
      "Periyakoilankulam B.O": "627953",
      "Nochikulam B.O": "627755",
      "Periyur B.O": "627761",
      "Thiruvettanallur B.O": "627855",
      "Valasai B.O": "627857",
      "Duraisamypuram B.O": "627764",
      "Kilakalangal B.O": "627860",
      "Maipparai B.O": "627713",
      "Kalingapatti B.O": "627719",
      "Kurinjakulam B.O": "627719",
      "Ramanathapuram(VSD) B.O": "627760",
      "K.Karisalkulam B.O": "628552",
      "Sayamalai B.O": "628552",
      "Karisathan B.O": "627753",
      "Manalur B.O": "627753",
      "Azhaganeri B.O": "627754",
      "Sevalkulam B.O": "627754",
      "Vagaikulam B.O": "627754",
      "Kurukkalpatti B.O": "627953",
      "Maruthankinar B.O": "627953",
      "Panavadalichatram B.O": "627953",
      "Ramasamipuram B.O": "627755",
      "Vadamalapuram B.O": "627755",
      "Sangupuram B.O": "627761",
      "Thannuthu B.O": "627857",
      "Inamkovilpatti B.O": "627757",
      "Tenmalai B.O": "627757",
      "Karuvanda B.O": "627860",
      "Kurichanpatti B.O": "627860",
      "Alagapuri B.O": "627719",
      "Varaganur BO": "626140",
      "Kulakkattakurichi B.O": "627713",
      "Katana Anaithittam BO": "627412",
      "Merku Alwarkurichi BO": "627412",
      "Sambankulam BO": "627412",
      "Sivasailam BO": "627412",
      "Rengasamudram BO": "627413",
      "Mathapuram BO": "627415",
      "Poolankulam BO": "627415",
      "Servaikaranpatti BO": "627415",
      "Idaikal BO": "627602",
      "Pappangulam BO": "627423",
      "Theertharappapuram BO": "627423",
      "Therku Madathur BO": "627423",
      "Thuppakudi BO": "627423",
      "Manthiyur BO": "627424",
      "Adaichani BO": "627413",
      "Karuthapillaiyur BO": "627418",
      "Ananjaperumal Nadanur BO": "627423",
      "Govindaperi BO": "627424",
      "Kaduvetti BO": "627202",
      "Koviluthu BO": "627415",
      "Pungampatti BO": "627415",
      "Venkatampatti BO": "627415",
      "Odaimarichan BO": "627602",
      "Mudaliarpatti BO": "627423",
      "Sivalarkulam B.O": "627853",
      "Kavalakurichi B.O": "627854",
      "Periyapillaivalasi B.O": "627809",
      "Piranur B.O": "627809",
      "Thenpothai B.O": "627809",
      "Vallam B.O": "627809",
      "Bungalowsurandai B.O": "627859",
      "Kadayalurutti B.O": "627859",
      "Kulayaneri B.O": "627859",
      "Rajagopalaperi B.O": "627861",
      "Vadi B.O": "627861",
      "Veeranam B.O": "627861",
      "Kilankadu B.O": "627852",
      "Nainaragaram B.O": "627804",
      "Kottakulam B.O": "627805",
      "Chockammpatti B.O": "627751",
      "Kasidharmam B.O": "627751",
      "Kumanthapuram B.O": "627751",
      "Sundaresapuram B.O": "627751",
      "Melapavur B.O": "627806",
      "Gunaramanallur B.O": "627814",
      "Kadabokathi B.O": "627814",
      "Mathalamparai B.O": "627814",
      "Venkateswarapuram B.O": "627854",
      "Karisalkudiyiruppu B.O": "627807",
      "Pethanadarpatti B.O": "627808",
      "Sivanadanur B.O": "627808",
      "Tippanampatti B.O": "627808",
      "Parankundrapuram B.O": "627859",
      "Vadakaraikilpidagai B.O": "627812",
      "Kasimajorpuram B.O": "627802",
      "Kuthukalvalasai B.O": "627803",
      "Vellakal B.O": "627806",
      "Pattakurichi B.O": "627814",
      "Mayamankurichi B.O": "627853",
      "Kidarakulam B.O": "627854",
      "Avudaiyanur B.O": "627808",
      "Kattalaikudiyiruppu B.O": "627813",
      "Poolankudiyiruppu B.O": "627813",
      "E.Meenakshipuram B.O": "627859",
      "Achankuttam B.O": "627861",
      "Urmelalagian B.O": "627852",
      "Achanpudur B.O": "627803",
      "Kanakkupillaivalasai B.O": "627803",
      "Kodikurichi B.O": "627804",
      "Boganallur B.O": "627751",
      "Kambapacheri B.O": "627751",
      "Mangalapuram B.O": "627751",
      "Kulasekarapatti B.O": "627806",
      "Rajapandi B.O": "627806",
      "Ayiraperi B.O": "627814",
      "Ayyanarkulam B.O": "627853",
      "Kuruvankottai B.O": "627853",
      "Kidanganeri B.O": "627854",
      "Adaikalapattinam B.O": "627808",
      "Mettur B.O": "627808",
      "Melakrishnaperi B.O": "627808",
      "Karkudi B.O": "627813",
      "Melur B.O": "627809",
      "Anaikulam B.O": "627859",
      "Vavanagaram B.O": "627812",
      "Kaluneerkulam B.O": "627861",
      "Tenkasi H.O": "627811",
      "Sankarankovil H.O": "627756",
      "Athuvazhi S.O": "627760",
      "Panaiyur S.O": "627761",
      "Uthumalai S.O": "627860",
      "Vasudevanallur S.O": "627758",
      "Courtallam S.O": "627802",
      "Kadayanallur Bazar S.O": "627751",
      "Kadayanallur S.O": "627751",
      "Tiruvengadam S.O": "627719",
      "Melanilithanallur S.O": "627953",
      "Sankarankovil Bazaar S.O": "627756",
      "Serndamangalam S.O": "627857",
      "Sivagiri S.O (Tirunelveli)": "627757",
      "Rayagiri S.O": "627764",
      "Alangulam S.O": "627851",
      "Kadayanallur Pettai S.O": "627751",
      "Sambavarvadakarai S.O": "627856",
      "Sengottai RS S.O": "627809",
      "Sengottai S.O": "627809",
      "Kilapavur S.O": "627806",
      "Kizhapuliyur S.O": "627814",
      "Panpuli S.O": "627807",
      "Pavoorchatram S.O": "627808",
      "Surandai S.O": "627859",
      "Virakeralmpudur S.O": "627861",
      "Alwarkurichi SO": "627412",
      "Ravanasamudram SO": "627424",
      "Kila Ambur SO": "627418",
      "Ilyarasanendal S.O": "627713",
      "Kuruvikulam S.O": "627754",
      "Ayikudi S.O": "627852",
      "Idaikal(TKS) S.O": "627804",
      "Ilanji S.O": "627805",
      "Melagaram S.O": "627818",
      "Nallur S.O (Tirunelveli)": "627853",
      "Puliyara S.O": "627813",
      "Pottalpudur SO": "627423",
      "Kadayam SO": "627415",
      "Karivalamvandanallur S.O": "627753",
      "Mullikulam S.O": "627755",
      "Puliyangudi S.O": "627855",
      "Virasigamani S.O": "627862",
      "Elathur S.O (Tirunelveli)": "627803",
      "Krishnapuram (TVL) S.O": "627759",
      "Nettur S.O (Tirunelveli)": "627854",
      "Sundapandiapuram S.O": "627858",
      "Tenkasi RS S.O": "627811",
      "Vadakarai S.O (Tirunelveli)": "627812"
    },
    "KANCHIPURAM": {
      "Sengadu B.O": "602002",
      "Serpananchery BO": "601301",
      "Manimangalam BO": "601301",
      "Malaipattu BO": "601301",
      "Kavanur BO": "603203",
      "Madambakkam BO": "603202",
      "Arumbuliyur BO": "603106",
      "Sathanjeri BO": "603106",
      "Tiruvanaikoil BO": "603106",
      "Edayambudur BO": "603107",
      "Olaiyur BO": "603107",
      "Damal B.O": "631551",
      "Kilakattur B.O": "631502",
      "Kuram B.O": "631502",
      "Melkadirpur B.O": "631502",
      "Olimohamedpet B.O": "631502",
      "Thimamsamudram B.O": "631502",
      "Veliyur B.O": "631502",
      "Melmaduramangalam B.O": "631553",
      "Pichivakkam B.O": "631553",
      "Purisai B.O": "631553",
      "Attuputhur B.O": "631561",
      "Nirvalur B.O": "631561",
      "Puthali B.O": "631603",
      "Vayalakkavur B.O": "631603",
      "Manampathikandigai B.O": "603403",
      "Perunagar B.O": "603403",
      "R.N.Kandigai B.O": "603403",
      "Mathur B.O": "602105",
      "Pondur B.O": "602105",
      "Thandalam B.O": "602105",
      "Thodukadu B.O": "602105",
      "Anambakkam BO": "603107",
      "Chithanakkavur BO": "603107",
      "Vadakkupattu BO": "603204",
      "Venkatapuram BO": "603204",
      "Kattiampandal BO": "603314",
      "Perungozhi BO": "603314",
      "Agaramduli B.O": "603406",
      "Kammalampoondi B.O": "603406",
      "Kavanur Pudhucheri B.O": "603406",
      "Tittalam B.O": "603406",
      "Nathanallur B.O": "631605",
      "Puliambakkam B.O": "631605",
      "Thammanur B.O": "631605",
      "Ekanampet B.O": "631601",
      "Naickenpet B.O": "631601",
      "Krishnapuram B.O": "631551",
      "Musaravakkam B.O": "631551",
      "Alisoor B.O": "603402",
      "Karai B.O": "631552",
      "Parandur B.O": "631552",
      "Siruvakkam B.O": "631552",
      "Arpakkam B.O": "631603",
      "Padur B.O": "631606",
      "Thirumukkudal B.O": "631606",
      "Ullavur B.O": "631606",
      "Echoor B.O": "631604",
      "Kunnam B.O": "631604",
      "Tirupulivanam B.O": "603406",
      "Vadanallur B.O": "603406",
      "Thenambakkam B.O": "631601",
      "Muthavedu B.O": "631551",
      "Govindavadi B.O": "631502",
      "Perumanallur B.O": "631502",
      "Ekanapuram B.O": "631553",
      "Singadivakkam B.O": "631561",
      "Vedal B.O": "631561",
      "Arasanimangalam B.O": "603402",
      "Pennalur B.O": "603402",
      "Siruvallur B.O": "631552",
      "Kavanthandalam B.O": "631603",
      "Kunnavakkam BO": "603107",
      "Porpandal BO": "603107",
      "Valathodu BO": "603107",
      "Seethananjeri BO": "603106",
      "Vitchur BO": "603106",
      "Kilakadi BO": "603107",
      "Nelvoy BO": "603107",
      "Palliagaram BO": "603107",
      "Elutchur BO": "603204",
      "Neyyadupakkam B.O": "631603",
      "Thandarai B.O": "603403",
      "Kandoor B.O": "602108",
      "Maduramangalam B.O": "602108",
      "Mambakkam B.O": "602106",
      "Sinnivakkam B.O": "631604",
      "Maruthuvambadi B.O": "603406",
      "Asoor B.O": "631605",
      "Thimmarajampettai B.O": "631601",
      "Ayyankarkulam B.O": "631502",
      "Kammavarpalayam B.O": "631502",
      "Orikkai B.O": "631502",
      "Sevilimedu B.O": "631502",
      "Sirukaveripakkam B.O": "631502",
      "Chellampattidai B.O": "631553",
      "Kappankottur B.O": "631553",
      "Pullalur B.O": "631553",
      "Valathur B.O": "631553",
      "Rajakulam B.O": "631561",
      "Vaiyavur B.O": "631561",
      "Elaganar B.O": "603402",
      "Hanumanthandalam B.O": "603402",
      "Malayankulam B.O": "631603",
      "Olugarai B.O": "631603",
      "Madhur B.O": "631606",
      "Gunduperumbedu B.O": "602105",
      "Pillaipakkam B.O": "602105",
      "Valarpuram B.O": "602105",
      "Sendamangalam B.O": "602106",
      "Panruti B.O": "631604",
      "Varanavasi B.O": "631604",
      "Malliyankaranai B.O": "603406",
      "Sirungoli B.O": "603406",
      "Avalur B.O": "631605",
      "Uttukadu B.O": "631605",
      "Darkash BO": "600132",
      "Tiruneermalai BO": "600132",
      "Gerugambakkam BO": "600128",
      "Thandalam BO": "600128",
      "Nandambakkam BO": "600069",
      "South Malayambakkam BO": "600069",
      "Paraniputhur BO": "600122",
      "Sirukalathur BO": "600069",
      "Somangalam BO": "600069",
      "Kovur SO Tamilnadu Circle": "600128",
      "Kunnathur SO Kanchipuram": "600069",
      "Enathur S.O": "631561",
      "Kaliyampoondi S.O": "603402",
      "Magaral S.O": "631603",
      "Pattunoolchatram S.O": "602105",
      "Pillayarpalayam S.O": "631501",
      "Sunguvarchatram S.O": "602106",
      "Walajabad S.O": "631605",
      "Balchettychatram S.O": "631551",
      "Big Kanchipuram S.O": "631502",
      "Tirumudivakkam SO": "600132",
      "Irungattukottai S.O": "602117",
      "Little Kanchipuram S.O": "631501",
      "Sankaramutt S.O": "631502",
      "Sriperumbudur S.O": "602105",
      "Uttiramerur S.O": "603406",
      "Kanchipuram H.O": "631501",
      "Padappai SO": "601301",
      "Nandambakkam Kudiyiruppu S.O": "600089",
      "Ayyampettai S.O": "631601",
      "Edayarpakkam S.O": "631553",
      "Kanchipuram Collectorate S.O": "631501",
      "Kanchipuram Cutchery S.O": "631501",
      "Karaipettai S.O": "631552",
      "Mangadu SO": "600122",
      "Manampathi S.O": "603403",
      "Palayaseevaram S.O": "631606",
      "Thenneri S.O": "631604",
      "Thoopul S.O": "631501",
      "Orakattupettai SO": "603106",
      "Salavakkam SO": "603107"
    },
    "TIRUVANNAMALAI": {
      "Nambedu BO": "604505",
      "Narasingapuram BO": "606902",
      "Sevarapundi BO": "606902",
      "Banambattu BO": "606908",
      "Vadamathur BO": "606702",
      "Allialamangalam BO": "606904",
      "Padagam BO": "606904",
      "Arpakkam BO": "606752",
      "Melchengam BO": "606703",
      "Melvanakakambadi BO": "606703",
      "Porkunam BO": "606802",
      "Sorakulathur BO": "606802",
      "Veluganandal BO": "606802",
      "Melpennathur BO": "606704",
      "Oorgoundanur BO": "606710",
      "Pudupattu BO": "606710",
      "Athimoor Tindivanam BO": "606803",
      "Kangeyanur BO": "606803",
      "Karapundi BO": "606803",
      "Vasur BO": "606803",
      "Sathanur BO": "606706",
      "Veppurchekkadi BO": "606706",
      "Malappambadi BO": "606611",
      "Pallikondapattu BO": "606611",
      "Vedanatham BO": "606611",
      "Ayyampalayam BO": "632315",
      "Pandithapattu BO": "606603",
      "Thenmathur BO": "606603",
      "Kilvanakkambadi BO": "606707",
      "Radhapuram BO": "606707",
      "Taradapattu BO": "606707",
      "Athipadi BO": "606708",
      "Bhimarapatti BO": "606708",
      "Melpuludiyur BO": "606709",
      "Pakkiripalayam BO": "606709",
      "Pinjur BO": "606709",
      "Elayankanni BO": "606753",
      "Meyyur BO": "632317",
      "Varagur BO": "606753",
      "Velayampakkam BO": "606753",
      "Inamkariyandal BO": "606604",
      "Kallayee Sorathur BO": "606754",
      "Mansurabad BO": "606902",
      "Thenmahadevamangalam BO": "606908",
      "Kappalur BO": "606751",
      "Kuruvimalai BO": "606751",
      "Alathur BO": "604408",
      "C Nammiandal BO": "606702",
      "Kallarai Padi BO": "606702",
      "Erumpoondi BO": "604601",
      "Kikkalur BO": "604601",
      "Semmiyamangalam BO": "606904",
      "Nookambadi BO": "606752",
      "Vallivagai BO": "606752",
      "Andipattu BO": "606703",
      "Melarvandavadi BO": "606703",
      "Maruthuvambadi BO": "606801",
      "Periyakilambadi BO": "606802",
      "Kilpaliyapattu BO": "606704",
      "Melmudiyanur BO": "606704",
      "Kallathur BO": "606710",
      "Kuppanatham BO": "606710",
      "Perumanam BO": "606806",
      "Veraiyur BO": "606806",
      "Mambattu BO": "606803",
      "Pelasur BO": "606803",
      "Sanikkavadi BO": "606803",
      "Kilkuppam BO": "606705",
      "Pudur Chengam BO": "606705",
      "Kesavapuram BO": "606905",
      "Vellur BO": "606905",
      "Kilnachipattu BO": "606611",
      "Gangapattu BO": "606804",
      "Kattumalayanur BO": "606804",
      "Kuttar BO": "606708",
      "Mottakkal BO": "606708",
      "Pudur Chekkadi BO": "606708",
      "Reddiarpalayam BO": "606708",
      "Arattavadi BO": "606709",
      "Kilnathur BO": "606601",
      "Kolakkaravadi BO": "606805",
      "Kelur BO": "606907",
      "Allikondapattu BO": "606753",
      "Serpapattu BO": "606753",
      "Thenkarimbalur BO": "606753",
      "Adaiyur BO": "606604",
      "Naraiyur BO": "606754",
      "Olaipadi BO": "606754",
      "Siruvallur BO": "606906",
      "Budamangalam BO": "606902",
      "Thatchambadi BO": "606902",
      "Thumbur BO": "606902",
      "Kilpalur BO": "606908",
      "Kalur BO": "606751",
      "Karkonam BO": "606751",
      "Ladavaram BO": "606751",
      "Japthikariandal BO": "606702",
      "Aradapattu BO": "606808",
      "Pulivanandal BO": "606904",
      "Vilapakkam BO": "606904",
      "Kothandavadi BO": "606752",
      "Palanandal BO": "606752",
      "Arasankanni BO": "606703",
      "Elangunni BO": "606703",
      "Devanampattu BO": "606802",
      "Thennagaram BO": "606802",
      "Modaiyur BO": "606902",
      "Palankoil BO": "606751",
      "Pathiyavadi BO": "606751",
      "Pundi Polur BO": "606751",
      "Thenpallipattu BO": "606751",
      "Melpadur BO": "606702",
      "Kolakudi BO": "606808",
      "Parayampattu BO": "606808",
      "Su Andapattu BO": "606808",
      "Su Pappambadi BO": "606808",
      "Mekkalur BO": "604601",
      "Rayampettai BO": "604601",
      "Sirunathur BO": "604601",
      "Valudalangunam BO": "604601",
      "Vedandavadi BO": "606752",
      "Neepathurai BO": "606703",
      "Eraiyur BO": "606704",
      "Melnachipattu BO": "606704",
      "Periyakolapadi BO": "606704",
      "Puliyampatti BO": "606703",
      "Northampoondi BO": "606802",
      "Thorapadi BO": "606704",
      "Vasudevampattu BO": "606704",
      "Kuyilam BO": "606710",
      "Arudirapattu BO": "606806",
      "Chinnakallapadi BO": "606806",
      "Devanur BO": "606806",
      "Potharai BO": "606803",
      "RKunnathur BO": "606803",
      "Thumbakkadu BO": "606803",
      "Tirusur BO": "606803",
      "Karapattu BO": "606705",
      "Padiagraharam BO": "606705",
      "Veeranandal BO": "606705",
      "A K Padavedu BO": "606905",
      "Arjunapuram BO": "606905",
      "Krishnapuram BO": "606905",
      "Kolundampattu BO": "606706",
      "S Sorpanandal BO": "606706",
      "Andampallam BO": "606804",
      "Madurampattu BO": "606804",
      "Thenmudiyanur BO": "606707",
      "Narayanakuppam BO": "606708",
      "P Quilam BO": "606708",
      "Perunkolathur BO": "606708",
      "Kalasthambadi BO": "606805",
      "Ettivadi BO": "606907",
      "Gudalur BO": "606755",
      "Nariyapattu BO": "606753",
      "Palayanur BO": "606753",
      "Kiliyapattu BO": "606604",
      "Neivanatham BO": "606754",
      "Elathur BO": "606906",
      "Kilaiyur BO": "606710",
      "Su Valavetti BO": "606806",
      "Murugapadi BO": "606803",
      "Periagaram BO": "606803",
      "Sengunam BO": "606803",
      "Munnurmangalam BO": "606705",
      "Ramanathapuram BO": "606905",
      "Kanalapadi BO": "606611",
      "Nallavanpalayam BO": "606603",
      "Isukkalikatteri BO": "606804",
      "Kadagaman BO": "606804",
      "Edathanur BO": "606707",
      "Kilsirupakkam BO": "606707",
      "Chinnaimpettai BO": "606708",
      "Malamanjanur BO": "606708",
      "Rayandapuram BO": "606708",
      "Tiruvadathanur BO": "606708",
      "Kariamangalam BO": "606709",
      "Nachipattu BO": "606709",
      "Mallavadi BO": "606805",
      "Athuvambadi BO": "606907",
      "Saduperipalayam BO": "606907",
      "Tirumalai BO": "606907",
      "Perunthuraipattu BO": "606753",
      "Valavachanur BO": "606753",
      "Adiannamalai BO": "606604",
      "Vaipur BO": "606754",
      "Vadavanakkambadi BO": "604505",
      "Elangadu BO": "604408",
      "Kaganam BO": "604410",
      "Pillanthangal BO": "604410",
      "Melsolankuppam BO": "606901",
      "Ammayapattu BO": "604408",
      "Arasur BO": "604408",
      "Kilsathamangalam BO": "604408",
      "Kilvillivalam BO": "604408",
      "Vengalathur BO": "604410",
      "Gangavaram BO": "606901",
      "Kanthapalayam BO": "606901",
      "Kettavarampalayam BO": "606901",
      "Melma BO": "604408",
      "Salukkai BO": "604408",
      "Sennavaram BO": "604408",
      "Thennankur BO": "604408",
      "Thethurai BO": "604408",
      "Veerambakkampudur BO": "604408",
      "Chithathur BO": "604410",
      "Konalur BO": "606755",
      "Kulathur BO": "632311",
      "Rajapalayam BO": "606755",
      "Sanipundi BO": "606755",
      "Sengadu BO": "604505",
      "Manganallur BO": "604408",
      "Ponnur BO": "604408",
      "Shro Navalpakkam BO": "604408",
      "Thenelapakkam BO": "604408",
      "Vengaram BO": "604408",
      "Namandi BO": "604410",
      "Tiruppanangadu BO": "604410",
      "Kidampalayam BO": "606901",
      "Viralur BO": "606901",
      "Chellankuppam BO": "606755",
      "Kilkarippur BO": "606755",
      "Athipattu(T) B.O": "635703",
      "Mandaparai B.O": "635703",
      "Pattaraikadu B.O": "635703",
      "Veerappanur B.O": "635703",
      "Attiyanur B.O": "635703",
      "Gunikanthur B.O": "635703",
      "Kovilur B.O": "635703",
      "Kuttakarai B.O": "635703",
      "Melsilambadi B.O": "635703",
      "Palamarathur B.O": "635703",
      "Athipet B.O": "635703",
      "Kuttathur B.O": "635703",
      "Melpattu (T) B.O": "635703",
      "Nachamalai B.O": "635703",
      "Puliyur (T) B.O": "635703",
      "Brammadesam BO": "632511",
      "Jagirvalavanur BO": "632511",
      "Mullandrum BO": "632512",
      "Saron BO": "606601",
      "Thithandapattu BO": "606701",
      "Valayampattu BO": "606701",
      "Chennasamudram BO": "606701",
      "Vadailluppai BO": "632511",
      "Amirthi B.O": "632102",
      "Eriyur Amirthi B.O": "632102",
      "Nadanur B.O": "632102",
      "Nagalur B.O": "632102",
      "Nammiyambattu B.O": "632102",
      "Kayambattu BO": "606701",
      "Athurai BO": "606902",
      "Kovilandur B.O": "632102",
      "Palaparambattu B.O": "632102",
      "Eriyur B.O": "632103",
      "Vethajipuram BO": "632507",
      "Thennampattu BO": "632511",
      "Poosimalaikuppam BO": "632512",
      "Kilsaranankuppam B.O": "632102",
      "Melkuppachinnanur B.O": "632102",
      "Sozhavaram BO": "631701",
      "Ukkal BO": "631701",
      "Cheyyaturvendran BO": "604401",
      "Elaneerkundram BO": "604401",
      "Perumbalai BO": "604401",
      "Mullipattu BO": "632316",
      "Ragunathapuram BO": "632316",
      "Rattinamangalam BO": "632316",
      "Kilnamandi BO": "604501",
      "Kilputhur BO": "604501",
      "Kunnakampoondi BO": "604501",
      "Thenthinnalur BO": "604501",
      "Vayalur BO": "604501",
      "Vedal BO": "604501",
      "Alividaithangi BO": "604402",
      "Kunnathur BO": "604402",
      "Kuthanur BO": "604402",
      "Kannamangalam Bazaar BO": "632311",
      "Kovilur BO": "604404",
      "Indiravanam BO": "632313",
      "Namathodu BO": "632313",
      "Narayanamangalam BO": "632313",
      "Semmambadi BO": "632313",
      "Agraharapalayam BO": "632314",
      "Ariyapadi BO": "632314",
      "Endal BO": "604502",
      "Chinnaelacheri BO": "631702",
      "Dusi BO": "631702",
      "Pudupalayam BO": "631702",
      "Kodanallur BO": "604405",
      "Osur BO": "604405",
      "Punnai BO": "604405",
      "Arasampattu BO": "606807",
      "Melathangal BO": "606807",
      "Veppambattu BO": "606807",
      "Melnagar BO": "632315",
      "Melmattaivinnamangalam BO": "604503",
      "Irumbedu BO": "604403",
      "Molugampoondi BO": "632317",
      "Embalam BO": "604406",
      "Therasapuram BO": "604406",
      "Sengattankundil BO": "604407",
      "Vinnavadi BO": "604407",
      "Thozhupedu BO": "604409",
      "Vadathinallur BO": "604409",
      "Ayalpadi BO": "604505",
      "Melnemili BO": "604505",
      "Melpathi BO": "604505",
      "Ulagampattu BO": "606801",
      "Kalvasal BO": "606903",
      "Kasthambadi BO": "606903",
      "Mukkurumbai BO": "606903",
      "Nadukuppam BO": "606903",
      "Pulavanpadi BO": "606903",
      "Kuppam BO": "632311",
      "Vallam Kannamangalam BO": "632311",
      "Kilnarma BO": "604403",
      "Kottai BO": "604403",
      "Kuvalai BO": "604403",
      "Ammapalayam BO": "632315",
      "Ananthapuram BO": "632315",
      "Mosavadi BO": "604503",
      "Navalpakkam BO": "604503",
      "VelapadiArni BO": "632317",
      "Puthur BO": "632315",
      "Odalavadi BO": "632326",
      "Thatchur BO": "632326",
      "Nerkunam BO": "604406",
      "Pennattagaram BO": "604406",
      "Senal BO": "604406",
      "Thaiyar BO": "604406",
      "Arugavur BO": "604407",
      "Murukattampundi BO": "604407",
      "Palli BO": "604407",
      "Pappanthangal BO": "604407",
      "Mathur BO": "631701",
      "Anapathur BO": "604401",
      "Erumaivetti BO": "604401",
      "Purisai BO": "604401",
      "Morakaniyanur BO": "606801",
      "Nesal BO": "632316",
      "Vinnamangalamarni BO": "632316",
      "Chitragavur Pudur BO": "604501",
      "Mahamayee Tirumani BO": "604501",
      "Sattapundi BO": "604501",
      "Madipakkam BO": "631701",
      "Palampettai BO": "606801",
      "Vadugasathu BO": "632316",
      "Arunthodu BO": "604501",
      "Thennathur BO": "604501",
      "Sumangali BO": "604402",
      "Kamakkur BO": "606903",
      "Pungambadi BO": "606903",
      "Badur BO": "604403",
      "Salvedu BO": "604403",
      "Velliambakkam BO": "604403",
      "Echur BO": "604404",
      "Sirumur BO": "632314",
      "Vettiyantholuvam BO": "632314",
      "Kadambai BO": "604502",
      "Matam BO": "604502",
      "Amudur BO": "604405",
      "Vazhur BO": "604405",
      "Sedarampattu BO": "632315",
      "Vannankulam BO": "632315",
      "Injimedu BO": "604503",
      "Adanur BO": "632317",
      "Paiyur BO": "632317",
      "Velleri BO": "632317",
      "Arayalam BO": "632326",
      "Japthikarani BO": "604406",
      "Mavalavadi BO": "604406",
      "Avaniapuram BO": "604504",
      "Munugapattu BO": "604504",
      "Kodanagar BO": "604407",
      "Panaiyur BO": "632518",
      "Sattuvanthangal BO": "632511",
      "Kaliyur BO": "604407",
      "Nedumbarai BO": "604407",
      "Maligaipattu BO": "604409",
      "Parasur BO": "604409",
      "Ramakrishnapuram BO": "604402",
      "Vadamanapakkam BO": "604402",
      "Kalasamudram BO": "632311",
      "Adiyanur BO": "604403",
      "Ulundai BO": "604403",
      "Erumbur BO": "604404",
      "Tirumpundi BO": "604404",
      "TellurArni BO": "632313",
      "Srinivasaudayanavaram BO": "632314",
      "Kandavaratti BO": "604502",
      "Melachery BO": "604502",
      "Arasanipalai BO": "631702",
      "Menalur BO": "631702",
      "Vadakalpakkam BO": "631702",
      "Nelliyankulam BO": "604405",
      "Vazhiyur BO": "632315",
      "Alliyandal BO": "604503",
      "Kaduganur BO": "604503",
      "Ragunathasamudram BO": "604503",
      "Mamandur BO": "632317",
      "Kodiyalam BO": "604406",
      "Nallur BO": "604406",
      "Vayalamoor BO": "604406",
      "Anmarudai BO": "604504",
      "Melsishamangalam BO": "604504",
      "Cheyyar BO": "604407",
      "Moranam BO": "604407",
      "Perungulathur BO": "604407",
      "Randam BO": "604407",
      "Korakkai BO": "604409",
      "Mukkur BO": "604409",
      "Tiruvannamalai HO": "606601",
      "Kannamangalam SO": "632311",
      "Kattukanur SO": "632312",
      "Kilkodungalur SO": "604403",
      "Adamangalam SO": "606901",
      "Kadaladi SO Tiruvannamalai": "606908",
      "Arni HO": "632301",
      "Akkur SO Tiruvannamalai": "631701",
      "Anukkavoor SO": "604401",
      "Arunagirichatram SO": "632301",
      "Hasanamapettai SO": "604402",
      "Mamandur Kanchipuram SO": "631702",
      "Nedungunam SO": "606807",
      "Sathiyaviziyanagaram SO": "632317",
      "Tiruvettipuram Cutcherry SO": "604407",
      "Tiruvettipuram SO": "604407",
      "Valkadai SO": "604409",
      "Vallam Arni SO": "604505",
      "Vembakkam SO": "604410",
      "Avur SO": "606755",
      "Chettupattu Polur SO": "606801",
      "Chevur SO": "632316",
      "Kalambur SO": "606903",
      "Kunnathur Arni SO": "632314",
      "Malayur SO": "604502",
      "Saidapettai Arni SO": "632301",
      "Tirumani SO": "604504",
      "Vandavasi SO": "604408",
      "Ayyankulam SO": "606601",
      "Esanyamadam SO": "606604",
      "Arni Fort SO": "632301",
      "Desur SO": "604501",
      "Kilkovalavedu SO": "604404",
      "Kolappalur SO Tiruvannamalai": "632313",
      "Marudadu SO": "604405",
      "Onnupuram SO": "632315",
      "Pernamallur SO": "604503",
      "Susainagar SO": "632326",
      "Tellar SO": "604406",
      "Chengam SO": "606701",
      "Devikapuram SO": "606902",
      "Kalasapakkam SO": "606751",
      "Jamanamarathur S.O": "635703",
      "Somasipadi SO": "606611",
      "Tanipadi SO": "606708",
      "Thukkapettai SO": "606709",
      "Turinjapuram SO": "606805",
      "Vilvarani SO": "606906",
      "Melpallipattu SO": "606703",
      "Pavithiram SO": "606806",
      "Polur SO Tiruvannamalai": "606803",
      "Polur Town SO": "606803",
      "Tandarai SO": "606804",
      "Kanji SO": "606702",
      "Kilpennathur SO": "604601",
      "Sathanurdam SO": "606706",
      "Sriramanashramam SO": "606603",
      "Tiruvannamalai Bazaar SO": "606601",
      "Vadamadimangalam SO": "606907",
      "Mandakolathur SO": "606904",
      "Pachal SO Tiruvannamalai": "606704",
      "Paramanandal SO": "606710",
      "Pudupalayam SO Tiruvannamalai": "606705",
      "Tandarampattu SO": "606707",
      "Thachampattu SO": "606811",
      "Tiruvannamalai RS SO": "606601",
      "Vanapuram SO": "606753",
      "Vengikkal SO": "606604",
      "Vettavalam SO": "606754",
      "Kalnagar SO": "606601",
      "Kattampoondi SO": "606808",
      "Mangalam SO Tiruvannamalai": "606752",
      "Nayudumangalam SO": "606802",
      "Santhavasal SO": "606905"
    },
    "VELLORE": {
      "Appukkal B.O": "632101",
      "Varadalambattu B.O": "632101",
      "Velangadu B.O": "632101",
      "Ganganallur B.O": "632101",
      "Ongapadi B.O": "632101",
      "Unai B.O": "632101",
      "Unai Vaniyambadi B.O": "632101",
      "Ariyur Spinning Mills B.O": "632055",
      "Chinnapalambakkam B.O": "632113",
      "Jardhankollai B.O": "632113",
      "Melmonavur B.O": "632010",
      "Alleri B.O": "632101",
      "Eripudur B.O": "632101",
      "Unai Pallathur B.O": "632101",
      "Naganathi B.O": "632113",
      "Kallapadi B.O": "632601",
      "Kottamitta B.O": "632601",
      "Kosavanpudur B.O": "635803",
      "Perumankuppam B.O": "632201",
      "Agaramcherry B.O": "635804",
      "Karungali B.O": "635804",
      "Gudanagaram B.O": "635806",
      "Melmuttukur B.O": "635806",
      "Dakshinapathapalyaam B.O": "632603",
      "Puttavaripalli B.O": "632603",
      "Sengundram B.O": "632601",
      "Sevur B.O": "632106",
      "Thattaparai B.O": "632601",
      "Thattimanapalli B.O": "632601",
      "Pasumathur B.O": "635803",
      "Sedukarai B.O": "635803",
      "Sethubandai B.O": "635803",
      "Bhuvaneswaripet B.O": "632602",
      "Agaram B.O": "635804",
      "Ramalai B.O": "632601",
      "Veppur B.O": "635803",
      "Vadakkathipatti B.O": "635804",
      "Chendathur B.O": "635805",
      "Melvayathinankuppam B.O": "635805",
      "Ananganallore B.O": "635806",
      "Melmankuppam B.O": "632203",
      "Kottur B.O": "635808",
      "Viludonpalayam B.O": "632603",
      "Erikutti B.O": "635810",
      "Kamalapuram B.O": "635810",
      "Kokkalur B.O": "635810",
      "Devarishikuppam B.O": "632209",
      "Melkavanur B.O": "632209",
      "Chinnathottalam B.O": "635813",
      "Ulli B.O": "635813",
      "Mordhana B.O": "632604",
      "Varadareddipalli B.O": "632603",
      "Veerichettipalli B.O": "632603",
      "Masigam B.O": "635810",
      "Morasapalli B.O": "635810",
      "Sathugudi B.O": "635810",
      "Chennankuppam B.O": "632209",
      "Kanguppam B.O": "632209",
      "Palayakrishnapuram B.O": "632209",
      "Sempalli B.O": "632604",
      "Modikuppam B.O": "632601",
      "Pakkamvenkatapuram B.O": "632601",
      "Kilalathur B.O": "635803",
      "Valayalkarapatti B.O": "635804",
      "Rajakkal B.O": "635805",
      "Rajakuppam B.O": "635806",
      "Kandaneri B.O": "635809",
      "Odiyathur B.O": "635809",
      "Tippasamudram B.O": "635809",
      "Aravatla B.O": "635810",
      "Thollapalli B.O": "635804",
      "Kilpatti B.O": "635805",
      "Pallalakuppam B.O": "635805",
      "Chettikuppam B.O": "635806",
      "Gollamangalam B.O": "635809",
      "Pallikonda Bazaar B.O": "635809",
      "Vettuvanam B.O": "635809",
      "Chinnadamalcheruvu B.O": "635810",
      "Erukkambattu B.O": "635810",
      "Thottithuraimottur B.O": "635810",
      "Machanur B.O": "632209",
      "Pogalur B.O": "635813",
      "Sembedu B.O": "632002",
      "Agraharam B.O": "632604",
      "Kuppireddithangal BO": "632516",
      "Mahimandalam BO": "632516",
      "Periamittoor BO": "632516",
      "Pudur Kaniyanur BO": "632506",
      "Gugainallore BO": "632515",
      "Tempalle BO": "632515",
      "Jaffarapettai B.O": "632006",
      "Arimalai B.O": "632107",
      "Chinnapallikuppam B.O": "632107",
      "Karugambathur B.O": "632013",
      "Senji B.O": "632202",
      "Sozhamur B.O": "632202",
      "Thondanthualsi B.O": "632202",
      "Kattipattu B.O": "632103",
      "Kilkothur B.O": "632103",
      "Alamelumangapuram B.O": "632009",
      "Perumugai B.O": "632009",
      "Christianpet B.O": "632059",
      "Periapudur B.O": "632059",
      "Vandranthangal B.O": "632059",
      "Chitteri B.O": "632002",
      "Budur B.O": "632105",
      "Pulimedu B.O": "632105",
      "Sivanathapuram B.O": "632105",
      "Tellur B.O": "632105",
      "Mudinambattu B.O": "632204",
      "Sathupalayam B.O": "632113",
      "Veppambattu B.O": "632113",
      "Palambattu B.O": "632102",
      "Katpadi Agricultural Farm B.O": "632007",
      "Annangudi B.O": "632202",
      "Arumbakkam B.O": "632202",
      "Serpadi B.O": "632103",
      "Thongumalai B.O": "632103",
      "Kattuputhur B.O": "632058",
      "Kandipedu B.O": "632106",
      "Koranthangal B.O": "632106",
      "Mutharasikuppam B.O": "632106",
      "Edayansathu B.O": "632002",
      "Palamathi B.O": "632002",
      "Angarankuppam B.O": "632204",
      "Brahmapuram B.O": "632014",
      "Kothamangalam B.O": "632104",
      "Marudhavallipalayam B.O": "632104",
      "Seduvalai B.O": "632104",
      "Vallandramam B.O": "632104",
      "Tellai B.O": "632113",
      "Kangeyanallur B.O": "632006",
      "Asanambattu B.O": "632107",
      "Devichettikuppam B.O": "632107",
      "Ramanayanikuppam B.O": "632107",
      "Pallikuppam B.O": "632007",
      "Bomminaickenpalayam B.O": "632202",
      "Karasamangalam B.O": "632202",
      "Melarasambattu B.O": "632103",
      "Peenjamandai B.O": "632103",
      "Vannanthangal B.O": "632103",
      "Rangapuram B.O": "632009",
      "Poigai B.O": "632114",
      "A Kattupadi B.O": "632011",
      "Nelvoy B.O": "632011",
      "Sadupperi B.O": "632002",
      "Elavambadi B.O": "632105",
      "Sekkanur B.O": "632105",
      "Kilmuttukur B.O": "632204",
      "Erayangadu B.O": "632104",
      "Kokkeri BO": "632520",
      "Thengal BO": "632514",
      "Vallimalai BO": "632520",
      "Karnambut BO": "632519",
      "Thuthikadu B.O": "632113",
      "Senur B.O": "632006",
      "Thandalam Krishnapuram B.O": "632006",
      "Pakkampalayam B.O": "632107",
      "Veppankuppam B.O": "632107",
      "Kalambattu B.O": "632202",
      "Panamadangi B.O": "632202",
      "Tirumani B.O": "632202",
      "Nemandapuram B.O": "632103",
      "Pinnathurai B.O": "632103",
      "Poigai Mottur B.O": "632114",
      "Arumparuthi B.O": "632106",
      "Karigiri B.O": "632106",
      "Serkadu B.O": "632106",
      "Thuthipattu B.O": "632011",
      "Govindareddypalayam B.O": "632105",
      "Perumalkuppam BO": "632520",
      "Veppalai BO": "632520",
      "Keerasathu BO": "632514",
      "Kavasambattu B.O": "632204",
      "Kattazhambattu BO": "632312",
      "Sembarayanallur BO": "632519",
      "Kammasamudram BO": "632319",
      "Varagur Pudur BO": "632319",
      "Kilarasampattu BO": "632312",
      "Nanjukondapuram BO": "632312",
      "Ammundi BO": "632519",
      "Eranthangal BO": "632519",
      "Mottakkal BO": "632319",
      "Ponnai SO": "632514",
      "Vennampalle SO": "632516",
      "Vellore H.O": "632001",
      "Gudiyattam H.O": "632602",
      "Melpadi SO": "632520",
      "Tiruvalam SO": "632515",
      "Vellore Sugar Mills SO": "632519",
      "Kammavanpettai SO": "632319",
      "Melalathur S.O": "635806",
      "Erthangal S.O": "632604",
      "Dharanampet S.O": "632601",
      "Kilvayathinankuppam S.O": "632201",
      "Paradarami S.O": "632603",
      "Valathoor S.O": "635813",
      "Gudiyattam Cutcherry S.O": "632602",
      "Gudiyattam South S.O": "632602",
      "Mailpatti S.O": "635805",
      "Melmayil S.O": "632203",
      "Pallikonda S.O": "635809",
      "Ruhsa Campus S.O": "632209",
      "Gudiyattam RS S.O": "635803",
      "Pernambut S.O": "635810",
      "Ariyur S.O (Vellore)": "632055",
      "CHRISTIAN MEDICAL COLLEGE S.O (Vellore)": "632002",
      "Gandhinagar West S.O": "632006",
      "Kaniyambadi S.O": "632102",
      "Kasba S.O (Vellore)": "632001",
      "Katpadi North S.O": "632007",
      "Konavattam S.O": "632013",
      "Ramanaickenpalayam S.O": "632001",
      "Shenbakkam S.O": "632008",
      "T.B. Sanatorium S.O": "632011",
      "Thiruvalluvar University S.O": "632115",
      "Vellore Institute Of Technology S.O": "632014",
      "Virinjipuram S.O": "632104",
      "Bakiyath S.O": "632004",
      "Cholavaram S.O": "632113",
      "Gandhinagar S.O (Vellore)": "632006",
      "Guruvarajapalayam S.O": "632107",
      "Krishnanagar S.O (Vellore)": "632001",
      "Pennathur S.O": "632058",
      "Sathuvachari S.O": "632009",
      "Sullivanpet S.O": "632001",
      "Vaduganthangal S.O": "632204",
      "Vellore Collectorate S.O": "632009",
      "Vellore South S.O": "632001",
      "Virudhambattu S.O": "632006",
      "Abdullapuram S.O": "632010",
      "Bagayam S.O": "632002",
      "Munjurpattu S.O": "632057",
      "Odugathur S.O": "632103",
      "Saidapet S.O (Vellore)": "632012",
      "Sankaranpalayam S.O": "632001",
      "Ussoor S.O": "632105",
      "Velapadi S.O": "632001",
      "Virupakshipuram S.O": "632002",
      "Anaikattu S.O": "632101",
      "CHRISTIAN MEDICAL COLLEGE HOSPITAL S.O": "632004",
      "Katpadi S.O": "632007",
      "Kosapet S.O (Vellore)": "632001",
      "Latteri S.O": "632202",
      "Sainathapuram S.O": "632001",
      "Sathuvachari Extension S.O": "632009",
      "Sathyamangalam (Vellore)S.O": "632114",
      "S.L.R. Sanatorium S.O": "632106",
      "TAMILNADU INDUSTRIAL EXPLOSIVES LTD": "632059",
      "Thorapadi S.O": "632002",
      "Vellore Fort S.O": "632004"
    },
    "DINDIGUL": {
      "Naidupuram BO": "624101",
      "Pallangi BO": "624101",
      "Perumalmalai BO": "624101",
      "Perumpallam BO": "624101",
      "Nallurkadu BO": "624212",
      "Pachalur BO": "624212",
      "Pallathukalvai BO": "624212",
      "Pundi BO": "624103",
      "Attuvampatti BO": "624101",
      "Machur BO": "624101",
      "Shenbaganur BO": "624101",
      "Vadagounji BO": "624101",
      "KRajathanikottai BO": "624206",
      "Oruthattu BO": "624206",
      "Ayyankottai BO": "624211",
      "Sangareddikottai BO": "624211",
      "Kaviakadu BO": "624212",
      "Manjalpirappu BO": "624212",
      "Periyur BO": "624212",
      "Pachamalayankottai BO": "624707",
      "Nariyuthu BO": "624215",
      "Sankarapuram BO": "624215",
      "Sedapatti BO": "624708",
      "Kanalkadu BO": "624216",
      "Pillayarnatham BO": "624403",
      "Sirunaickenpatti BO": "624307",
      "Sandaiyur BO": "624220",
      "Thangachiammapatti BO": "624612",
      "Vagarai BO": "624613",
      "Dasaripatti BO": "624614",
      "Kappalapatti BO": "624614",
      "Kariampatti BO": "624616",
      "Kattakoothanpatti BO": "624215",
      "Kottur BO": "624215",
      "Bodikamanvadi BO": "624708",
      "KSingarakottai BO": "624708",
      "Ottupatti BO": "624708",
      "Palayankottai BO": "624708",
      "Kamanur BO": "624216",
      "Anaipatti BO": "624620",
      "Kullichettipatti BO": "624219",
      "Kunnuvarankottai BO": "624220",
      "Odaipatti BO": "624612",
      "Erramanaickenpatti BO": "624613",
      "Kanakkanpatti BO": "624613",
      "Marichilambu BO": "624613",
      "Manjanaickenpatti BO": "624614",
      "Periyakottai BO": "624306",
      "Veeralapatti BO": "624614",
      "Virupatchi BO": "624614",
      "Jogipatti BO": "624704",
      "Puliyurnatham BO": "624704",
      "Valayapatti BO": "624704",
      "Karikaranpudur BO": "624615",
      "Periyakalayamputhur BO": "624615",
      "Adukkam BO": "624101",
      "Kumburvayal BO": "624101",
      "Vellagavi BO": "624101",
      "Vilpatti BO": "624101",
      "Ammapatti BO": "624622",
      "Jambudarikottai BO": "624206",
      "Moolaiyar BO": "624210",
      "Adalur BO": "624212",
      "KCPatti BO": "624212",
      "Solaikadu BO": "624212",
      "StMarys Estate BO": "624212",
      "Thonimalai BO": "624212",
      "Vengalapatti BO": "624212",
      "Mallayapuram BO": "624707",
      "Paraipatti BO": "624707",
      "Vannampatti BO": "624707",
      "Ramarajapuram BO": "624219",
      "Sithargalnatham BO": "624219",
      "Nadakottai BO": "624220",
      "Rajathanikottai BO": "624220",
      "Theppathupatti BO": "624220",
      "Chinnamandavadi BO": "624612",
      "Kappiliapatti BO": "624612",
      "Palarparundalar Dam BO": "624610",
      "19 Pudur BO": "624614",
      "Boduvarpatti BO": "624614",
      "Polur BO": "624103",
      "Poombarai BO": "624103",
      "Puthuputhur BO": "624103",
      "Melpallam BO": "624101",
      "Palamalai BO": "624101",
      "Prakasapuram BO": "624101",
      "Srinivasapuram BO": "624101",
      "Metturgate BO": "624206",
      "Uthupatti BO": "624206",
      "MVadipatti BO": "624211",
      "Sevugampatti BO": "624211",
      "Kuppammalpatti BO": "624212",
      "Nadupatti BO": "624212",
      "Pandrimalai BO": "624212",
      "Kodanginaickenpatti BO": "624215",
      "Micheal Palayam BO": "624215",
      "Sangalpatty BO": "624215",
      "Senkattampatti BO": "624708",
      "Kodalangadu BO": "624216",
      "Ethilodu BO": "624219",
      "Musuvanuthu BO": "624219",
      "Viralimayanpatti BO": "624220",
      "Mandavadi BO": "624612",
      "Sakkampatti BO": "624612",
      "Amarapundi BO": "624613",
      "Poolampati BO": "624613",
      "Varthamanathi Dam Project BO": "624613",
      "Devathur BO": "624614",
      "Kothayam BO": "624614",
      "Perumalnaickenvalasu BO": "624614",
      "Javadhupatti BO": "624704",
      "Periakuzhipatti BO": "624704",
      "Chinnakalayamputhur BO": "624615",
      "Neikkarapatti BO": "624615",
      "Puthur BO": "624801",
      "Sukkampatti BO": "624709",
      "Mullipadi BO": "624005",
      "Kollapatti BO": "624619",
      "Jambuliapatti BO": "624005",
      "Kovilur BO": "624005",
      "Kulathur BO": "624005",
      "Komberipatti BO": "624801",
      "Saminathapuram B.O": "642113",
      "Sithuvarpatti BO": "624801",
      "Kalanampatti BO": "624710",
      "Alagapuri BO": "624710",
      "Jenankottai BO": "624710",
      "Velvarkottai BO": "624802",
      "Kodangipatti BO": "624710",
      "Kumbur BO": "624103",
      "Puliamarathukottai BO": "624710",
      "Sullerumbu BO": "624710",
      "Thattarapatti BO": "624710",
      "Vallipatti BO": "624710",
      "Kuzhipatti BO": "624202",
      "Devarappanpatti BO": "624204",
      "Nalupulikottai BO": "624619",
      "Murunellikottai BO": "624710",
      "Pudurchettiapatti BO": "624710",
      "Anjukulipatti BO": "624308",
      "Sakkiliankodai BO": "624308",
      "Thimmanallur BO": "624308",
      "Kullalagundu BO": "624201",
      "GThummalapatti BO": "624202",
      "Nuthalapuram BO": "624202",
      "Reddiapatti BO": "624003",
      "Venkatasrikottai BO": "624202",
      "Kilanavayal BO": "624103",
      "Pazhamputhur BO": "624103",
      "Athikombai BO": "624619",
      "Kalanjipatti BO": "624619",
      "Old Oddanchatram BO": "624619",
      "Vadagadu BO": "624619",
      "Kavalapatti BO": "624621",
      "Palakkanuthu BO": "624619",
      "SRGPudur BO": "624619",
      "Narasingapuram BO": "624307",
      "Jothampatti BO": "624308",
      "KAyyapatti BO": "624308",
      "Kanavoipatti BO": "624202",
      "Kanniapuram BO": "624308",
      "Kalladipatti BO": "624201",
      "Malayagondanpatti BO": "624201",
      "Pallapatti BO": "624002",
      "Kattakamanpatti BO": "624202",
      "Kumbaraiyur BO": "624202",
      "Yeluvanampatti BO": "624202",
      "Maruthanathiproject BO": "624204",
      "Nellur BO": "624204",
      "Kavunji BO": "624103",
      "Mannavanur BO": "624103",
      "Pambarpuram BO": "624103",
      "Kethaiyarumbu BO": "624619",
      "Andipatti BO": "624621",
      "Thummalagundu BO": "624802",
      "Koovakkapatti BO": "624710",
      "Nathapatti BO": "624710",
      "Vanikarai BO": "624710",
      "TVadugapatti BO": "624308",
      "Mallanampatti BO": "624202",
      "Old Batlagundu BO": "624202",
      "Poosaripatti BO": "624202",
      "Pulathur BO": "624202",
      "Viralipatti BO": "624709",
      "Sitharevu BO": "624204",
      "Kilavarai BO": "624103",
      "Kookal BO": "624103",
      "Arasappapillaipatti BO": "624619",
      "Kaveriammapatti BO": "624619",
      "Neelamalaikottai BO": "624619",
      "Puduchatram BO": "624619",
      "Veriyappur BO": "624619",
      "RIyyampalayam BO": "624621",
      "Thathanaickenpatti BO": "624621",
      "Thottanampatti BO": "624005",
      "Thottanuthu BO": "624005",
      "Sennamanaickenpatti BO": "624004",
      "Settinaickenpatti BO": "624004",
      "Achanampatti BO": "624702",
      "Chittoor BO": "624702",
      "Paganattam BO": "624702",
      "Ambathurai BO": "624302",
      "Chettiapatti BO": "624302",
      "Alambadimines BO": "624703",
      "Karikali BO": "624703",
      "Mallapuram BO": "624703",
      "Ramagiri BO": "624703",
      "Kulathupatti BO": "624706",
      "Nagayakottai BO": "624706",
      "Vadugampadi BO": "624706",
      "Alamarathupatti BO": "624303",
      "Kalikkampatti BO": "624303",
      "Vakkampatti BO": "624303",
      "Thazhakadai BO": "624003",
      "Nathambazar BO": "624401",
      "Naduvanur BO": "624401",
      "PudurNTM BO": "624401",
      "Alambadi BO": "624620",
      "Chatirapatti BO": "624620",
      "DGudalur BO": "624620",
      "Pandithakaranur BO": "624620",
      "Sriramapuram BO": "624702",
      "Moongilpatti BO": "624402",
      "Sirugudi BO": "624402",
      "Uralipatti BO": "624402",
      "TPanjampatti BO": "624304",
      "Kattupatti BO": "624306",
      "Madur BO": "624306",
      "Markampatti BO": "624306",
      "Vaithilathoppampatti BO": "624306",
      "Agaram BO": "624709",
      "Kallipatti BO": "624709",
      "Malvarpatti BO": "624709",
      "Sellamanthadi BO": "624005",
      "Silaipadi BO": "624005",
      "Kottapatti BO": "624002",
      "Kuttathupatti BO": "624002",
      "MNPatti BO": "624002",
      "Mettupatti BO": "624616",
      "ANadupatti BO": "624302",
      "Kasavanampatti BO": "624705",
      "Palayakannivadi BO": "624705",
      "Pannaipatti BO": "624705",
      "TPudupatti BO": "624705",
      "Thettupatti BO": "624705",
      "Minukampatti BO": "624711",
      "Poonuthu BO": "624711",
      "Viruthalaipatti BO": "624711",
      "Koovanuthu BO": "624003",
      "Avichipatti BO": "624401",
      "Kasampatti BO": "624401",
      "Kosikurichi BO": "624401",
      "Kuttupatti BO": "624401",
      "Punnapatti BO": "624401",
      "Velampatti BO": "624617",
      "Servaikaranpatti BO": "624620",
      "Gurunathanaickanur BO": "624622",
      "KPudukottai BO": "624622",
      "Kamatchipuram BO": "624622",
      "Emakkalapuram BO": "624304",
      "Kolinjipatti BO": "624304",
      "Konapatti BO": "624304",
      "Kosavapatti BO": "624304",
      "Kodagipatti BO": "624403",
      "Kottaipatti BO": "624403",
      "Marambadi BO": "624709",
      "Manakkattur BO": "624403",
      "Kanapadi BO": "624802",
      "Mottanampatti BO": "624802",
      "Singarakottai BO": "624802",
      "Thennampatti BO": "624802",
      "KKeeranur BO": "624616",
      "Chinnakkampatti BO": "624712",
      "Kuthiluppai BO": "624712",
      "Kovilammapatti BO": "624618",
      "Manur BO": "624618",
      "Muthunaickenpatti BO": "624618",
      "Periyamottanuthu BO": "624618",
      "NParaipatti BO": "624005",
      "Padiyur BO": "624005",
      "Ponnimandurai BO": "624002",
      "Sindalagundu BO": "624002",
      "Poothampatti BO": "624702",
      "Perumalkoilpatti BO": "624302",
      "Thozhipatti BO": "624703",
      "Devinaickenpatti BO": "624711",
      "Kuttam BO": "624711",
      "Pillamanaickenpatti BO": "624706",
      "RPudukottai BO": "624706",
      "Usilampatti BO": "624706",
      "Munnilakottai BO": "624303",
      "Sirumalaipudur BO": "624003",
      "Lingavadi BO": "624401",
      "NPudupatti BO": "624401",
      "Sathampadi BO": "624401",
      "Vathipatti BO": "624401",
      "Landakottai BO": "624620",
      "RVellodu BO": "624620",
      "Mangarai BO": "624622",
      "Pappanampatti BO": "624622",
      "Kottaiyur BO": "624402",
      "Ragalapuram BO": "624304",
      "Thavasimadai BO": "624304",
      "Vadakattupatti BO": "624304",
      "Kambiliampatti BO": "624306",
      "Rajakkapatti BO": "624306",
      "Sengurichi BO": "624306",
      "Silvarpatti BO": "624709",
      "Teppakulathupatti BO": "624709",
      "Morepatti BO": "624802",
      "IVadipatti BO": "624616",
      "Paruthiyur BO": "624616",
      "Appanuthu BO": "624617",
      "Rajampatti BO": "624617",
      "Thoppampatti BO": "624617",
      "MaAthappanpatti BO": "624712",
      "Kodaimangalam BO": "624618",
      "Pushpathur BO": "624618",
      "Perumalpudur BO": "624615",
      "Pethanaickenpatti BO": "624615",
      "Thamaraikulam BO": "624615",
      "Kazhutharukkipalayam BO": "624616",
      "Kuttampundi BO": "624616",
      "Porulur BO": "624616",
      "Theethagoundenvalasu BO": "624616",
      "Kottathurai BO": "624617",
      "Melkaraipatti BO": "624617",
      "Perichipalayam BO": "624617",
      "Puliampatti BO": "624617",
      "Soolapuram B.O": "639203",
      "Aranmanaivalasu BO": "624616",
      "Palappanpatti BO": "624616",
      "Tirumalaigoundenvalasu BO": "624616",
      "Sangampalayam BO": "624617",
      "Thummalapatti BO": "624617",
      "Thalaiyuthu BO": "624618",
      "Nallamanarkottai BO": "624005",
      "Thamaraipadi BO": "624005",
      "Hanumantharayankottai BO": "624002",
      "Muthalagupatti BO": "624002",
      "Pithalaipatti BO": "624002",
      "Samiyarpatti BO": "624302",
      "Ulliyakottai BO": "624703",
      "Dharmathupatti BO": "624705",
      "Konur BO": "624705",
      "Kalvarpatti BO": "624711",
      "RKombai BO": "624706",
      "Veerakkal BO": "624303",
      "Adiyanuthu BO": "624003",
      "Nallamanaickenpatti BO": "624003",
      "Sirumalai BO": "624003",
      "Mulaiyur BO": "624401",
      "Nadumandalam BO": "624401",
      "Sethur BO": "624401",
      "Sreerankattupatti BO": "624401",
      "Kottanatham BO": "624620",
      "Tirukoornam BO": "624620",
      "Muthanampattipudur BO": "624622",
      "SVadipatti BO": "624622",
      "Boothagudi BO": "624402",
      "Avilipatti BO": "624304",
      "Marunoothu BO": "624304",
      "Veerasinnnampatti BO": "624304",
      "Sadayampatti BO": "624306",
      "VSKKurumbapatti BO": "624306",
      "Undarpatti BO": "624709",
      "Bojanampatti BO": "624802",
      "Kusavapatti BO": "624802",
      "Pilathu BO": "624802",
      "Nilakottai HO": "624208",
      "Sembatti SO": "624707",
      "Silukkuvarpatti SO": "624215",
      "Balasamudram SO Dindigul": "624610",
      "Chatrapatti SO Dindigul": "624614",
      "Idayakottai SO": "624704",
      "Kalayamputhur SO": "624615",
      "Markkampatti SO": "624712",
      "Dindigul HO": "624001",
      "Palani HO": "624601",
      "Pattiveeranpatti SO": "624211",
      "Tandigudi SO": "624216",
      "Vilampatti SO": "624219",
      "Viruveedu SO": "624220",
      "Narikalpatti SO": "624618",
      "Oddanchatram North SO": "624619",
      "Perumbarai SO": "624212",
      "Ambilikai SO": "624612",
      "Kallimandayam SO": "624616",
      "Palani RS SO": "624601",
      "Palani West SO": "624601",
      "Oddanchatram SO": "624619",
      "Sithayankottai SO": "624708",
      "Ayakudi SO": "624613",
      "KeeranurMA SO": "624617",
      "Palani East SO": "624601",
      "Pappampatti SO": "624621",
      "Palani Bazaar SO": "624601",
      "Palani Devastanam SO": "624601",
      "Angunagar SO": "624001",
      "Attur SO": "624701",
      "Gandhigram SO Dindigul": "624302",
      "Natham SO": "624401",
      "Reddiarchatram SO": "624622",
      "Samudrapatti SO": "624402",
      "Sendurai SO Dindigul": "624403",
      "Tadicombu SO": "624709",
      "Vembarpatti SO": "624308",
      "Kodaikanal Observatory SO": "624103",
      "Chinnalapatti SO": "624301",
      "Dindigul Bus Stand SO": "624003",
      "Dindigul Collectorate SO": "624004",
      "Dindigul East SO": "624003",
      "Eriyodu SO": "624702",
      "NGOColony SO": "624005",
      "Palayam SO": "624620",
      "Ammayanaickanur SO": "624201",
      "Batlagundu SO": "624202",
      "Iyyampalayam SO": "624204",
      "Ambathurai RS SO": "624302",
      "Balakrishnapurampudur SO": "624005",
      "Guziliamparai SO": "624703",
      "Kannivadi SO": "624705",
      "NPanjampatti SO": "624303",
      "Nagalnagar SO": "624003",
      "Kodaikanal SO": "624101",
      "Kodairoad RS SO": "624206",
      "Pannaikadu SO": "624210",
      "Ayyalur SO": "624801",
      "Begampur SO Dindigul": "624002",
      "Dindigul Fort SO": "624001",
      "Kasipalayam SO Dindigul": "624711",
      "Kovilur SO": "624706",
      "Natham East SO": "624401",
      "Natham Koilpatti SO": "624401",
      "Pandianagar SO": "624001",
      "Sanarpatti SO": "624304",
      "Siluvathur SO": "624306",
      "Vadamadurai SO": "624802",
      "Vedasandur SO": "624710",
      "Vellodu SO": "624307",
      "Batlagundu Bazar SO": "624202"
    },
    "THIRUVARUR": {
      "Budamangalam": "610102",
      "Seruvamani B.O": "610205",
      "Meiporul Nagar B.O": "610001",
      "New Street B.O": "610001",
      "Panangudi B.O": "609504",
      "Thuthukudi B.O": "609504",
      "Pudupathur B.O": "610106",
      "Melanammankurichi B.O": "614903",
      "Kilapadugai B.O": "610109",
      "Keeralathur B.O": "610205",
      "Vilamal B.O": "610004",
      "Dakshinamurthi Mutt B.O": "610001",
      "Madapuram B.O": "610001",
      "Selvapuram B.O": "610005",
      "Moongilkudi B.O": "610005",
      "Alivalam B.O": "610106",
      "Thandalai B.O": "610004",
      "Kodikalpalayam B.O": "610001",
      "Visalur B.O": "610005",
      "Salipperi B.O": "610105",
      "Vadagudi B.O": "610105",
      "Anaikuppam B.O": "610105",
      "Nemmeli B.O": "610105",
      "Andankarai B.O": "610203",
      "Alathambadi B.O": "610203",
      "Kurungulam B.O": "609608",
      "Menangudi B.O": "609608",
      "Ubayavedanthapuram B.O": "609608",
      "Tirukottaram B.O": "609603",
      "Velangudi B.O": "609603",
      "Solachery B.O": "613701",
      "Thazhakudi B.O": "613701",
      "Vaipur B.O": "610101",
      "Komal B.O": "610202",
      "Tirukaravasal B.O": "610202",
      "Nallur B.O": "614208",
      "Andankoil B.O": "612804",
      "Chandrasekarapuram B.O": "612804",
      "Melavidayal Ramnagar B.O": "612804",
      "Tholuvur B.O": "612804",
      "Keelapandi B.O": "614703",
      "Kilaperumalai B.O": "614703",
      "Melaperumalai B.O": "614703",
      "Vadiakadu B.O": "614703",
      "Pettai B.O": "614704",
      "Sembadavankadu B.O": "614704",
      "Korukkai B.O": "614711",
      "Thalaikadu B.O": "614711",
      "Pinnathur B.O": "614706",
      "Thillaivilagam B.O": "614706",
      "Kadiacheri B.O": "614715",
      "Manakkondu B.O": "614302",
      "Adichamangalam B.O": "612804",
      "Mappilaikuppam B.O": "610105",
      "Andipalayam B.O": "611101",
      "Semangalam B.O": "611101",
      "Nadapur B.O": "610101",
      "Palayavalam B.O": "610101",
      "Kekkarai B.O": "610003",
      "Devadanam B.O": "614702",
      "Kulamanickam B.O": "614702",
      "Adambar B.O": "610105",
      "Kunnur B.O": "610203",
      "Pichankottagam B.O": "614716",
      "Karpaganatharkulam B.O": "614703",
      "Veppancheri B.O": "614703",
      "Kummattitidal B.O": "614706",
      "Kothamangalam B.O": "614715",
      "Mettupalayam B.O": "614715",
      "Vellur ttp B.O": "614715",
      "Vikkirapandiyam B.O": "610203",
      "Achuthamangalam B.O": "610105",
      "Valkkai B.O": "610105",
      "Manali B.O": "610203",
      "Kiliyur B.O": "614208",
      "Padagacheri B.O": "612804",
      "Nedumbalam B.O": "614703",
      "Ovarur B.O": "614703",
      "Alangadu Uppur B.O": "614704",
      "Kilanammankurichi B.O": "614704",
      "Ezhilur B.O": "614715",
      "Keerakalur B.O": "614715",
      "Vittukatti B.O": "614715",
      "Athisolamangalam B.O": "613701",
      "Erukattur B.O": "610102",
      "Kandodathavanitham B.O": "610102",
      "Amur B.O": "610101",
      "Tirukannamangai B.O": "610104",
      "Kaliyakudi B.O": "609403",
      "Keeranur B.O": "609403",
      "Nedungulam B.O": "609403",
      "Pavattakudi B.O": "609403",
      "Maruduvancheri B.O": "609503",
      "Sarabojirajapuram B.O": "609503",
      "Injikudi B.O": "609405",
      "Tirumeichur B.O": "609405",
      "Koothanur B.O": "609503",
      "Manandakudi B.O": "609503",
      "Adanur(KVN) B.O": "614403",
      "Chettichatram B.O": "614403",
      "Kilamanali B.O": "610103",
      "Tirunattiyathankudi B.O": "610202",
      "A. Kiliyanur B.O": "609403",
      "Pillur B.O": "609403",
      "Vadakarai Alathur B.O": "614302",
      "Sithanvalur B.O": "612804",
      "Ariyalur B.O": "614702",
      "Melamarudur B.O": "614716",
      "Idumbavanam B.O": "614703",
      "Tondiakkadu B.O": "614703",
      "Alangadu B.O": "614704",
      "Kilakadu B.O": "614704",
      "Kovilur B.O": "614704",
      "Thillaivilagam South B.O": "614706",
      "Divammapuram B.O": "614715",
      "Maruvathur B.O": "612802",
      "Terkupattam B.O": "612802",
      "Kallikudi B.O": "611101",
      "Mukundanur B.O": "613701",
      "Ammanur B.O": "610201",
      "Velukudi B.O": "610102",
      "Suranur B.O": "610101",
      "Kalyanamahadevi B.O": "613704",
      "Kattur B.O": "610104",
      "ELVANGARGUDI B.O": "610104",
      "Authur B.O": "610103",
      "Tiruneipair B.O": "610103",
      "Alangudi B.O": "609502",
      "Rayanallur B.O": "614715",
      "Munnavalkottai B.O": "614403",
      "Pudukudi B.O": "612610",
      "Tiruvizhimizhalai B.O": "609501",
      "Vilagam B.O": "609501",
      "Paruthiyur B.O": "612604",
      "Gopalasamudram B.O": "614001",
      "Tanneerkunnam B.O": "614101",
      "Kilapanaiyur B.O": "614708",
      "Pulithikudi B.O": "614708",
      "Sendamangalam(TTP) B.O": "614708",
      "Kilapalam B.O": "614001",
      "Mannargudi South B.O": "614001",
      "Nidamangalam Bazaar B.O": "614404",
      "Perambur B.O": "614404",
      "Muvanallur B.O": "614014",
      "Adangudi B.O": "614103",
      "Segarai B.O": "614103",
      "Nagai B.O": "614016",
      "Nemmeli MNG B.O": "614016",
      "Solapandi B.O": "614016",
      "Elavanur B.O": "614017",
      "Palayakottai B.O": "614017",
      "Serukalathur B.O": "612604",
      "Sidakkamangalam B.O": "612604",
      "Sithadi B.O": "612604",
      "Semmangudi B.O": "612605",
      "Sirupuliyur B.O": "609403",
      "Alathur B.O": "609405",
      "Agarathirumalam B.O": "609503",
      "Sembiyanallur B.O": "609503",
      "Agaraohai B.O": "612601",
      "Melapalayur B.O": "612601",
      "Paravakkarai B.O": "612201",
      "Hanumanthapuram B.O": "613703",
      "Perumalagaram B.O": "613703",
      "Vennavasal B.O": "613703",
      "Kilapalaiyur B.O": "612610",
      "Abivirthiswaram B.O": "613705",
      "Barakadabad B.O": "613705",
      "Ilaiyur B.O": "613705",
      "Engan B.O": "612603",
      "Perumpannaiyur B.O": "612603",
      "Alankottai B.O": "614018",
      "Mavattagudi B.O": "610206",
      "Pullamangalam B.O": "610206",
      "Sendangudi B.O": "610206",
      "Vaduvur Thenpathi B.O": "614019",
      "Vaduvur Vadapathi B.O": "614019",
      "Muniyur B.O": "612802",
      "Vilathur B.O": "612802",
      "Kovilvenni Bazaar B.O": "614403",
      "Nallur TTP B.O": "614717",
      "Renganathapuram B.O": "614717",
      "Thiruvanduthurai B.O": "614717",
      "Mathur NID B.O": "612801",
      "Melamaravathy B.O": "612801",
      "Sathanur PSM B.O": "612801",
      "Pullavarayankudikadu B.O": "614013",
      "Koothanallur East B.O": "614101",
      "Kottugacheri B.O": "614101",
      "Palayanur ktn B.O": "614101",
      "Mangudi B.O": "614710",
      "Marudavanam B.O": "614710",
      "Terkunanallur B.O": "614710",
      "Aravoor B.O": "614404",
      "Chittamalli nid B.O": "614404",
      "Karunavur B.O": "614705",
      "Melavasal B.O": "614014",
      "Mannukkumundan B.O": "614705",
      "Simili B.O": "612603",
      "Srivanjiam B.O": "610107",
      "Vikrapandiyam B.O": "610107",
      "Sithamalli B.O": "614705",
      "Kilapattu B.O": "612803",
      "Melalavandaseri B.O": "612803",
      "Rajappayyanchavadi B.O": "612803",
      "Karuvakurichi B.O": "614018",
      "Mahadevapattinam B.O": "614018",
      "Mukkulam Sathanur B.O": "614018",
      "Thalikottai B.O": "614018",
      "Tirupalakudi B.O": "614018",
      "Kulamangalam B.O": "614019",
      "Govindakudi B.O": "612701",
      "Tiruvidavasal B.O": "613702",
      "Kundalur B.O": "609501",
      "Sarguneswarapuram B.O": "609501",
      "Vishnupuram B.O": "609501",
      "Kalathur B.O": "613703",
      "Oorgudi B.O": "613703",
      "Moolangudi B.O": "612610",
      "Suraikkayur B.O": "612203",
      "Vidayalkaruppur B.O": "612605",
      "Senganur B.O": "610107",
      "Kadalangudi B.O": "609501",
      "Vellakulam B.O": "612601",
      "Kilariam B.O": "613703",
      "Pathur B.O": "613703",
      "Arasavanangadu B.O": "612603",
      "Kandramanickam B.O": "612604",
      "Vadaver B.O": "612604",
      "Pakkamparuthiyur B.O": "610107",
      "Veedhividangan B.O": "610107",
      "Melapanaiyur B.O": "614717",
      "Paingattur B.O": "614717",
      "Vattar B.O": "614717",
      "Kuvalaiveli B.O": "612801",
      "Kalavaikarai B.O": "614001",
      "Idangankottai Keelaiyur B.O": "614013",
      "Kattakudi B.O": "614013",
      "Kothangudi B.O": "614101",
      "Nahangudi B.O": "614101",
      "Sathanur(KTN) B.O": "614101",
      "Kudithangicheri B.O": "614102",
      "Vanakkara Street B.O": "614001",
      "Naruvelikalappal B.O": "614710",
      "Tirukalar B.O": "614710",
      "Manickamangalam B.O": "614404",
      "Narasingamangalam B.O": "614404",
      "Radhanarasimhapuram B.O": "614020",
      "Savalakkaran B.O": "614014",
      "Koopachikottai B.O": "614015",
      "Kezhuvathur B.O": "614705",
      "Puthagaram B.O": "614705",
      "Kalacheri B.O": "612803",
      "Rayapuram B.O": "612803",
      "Sundarakottai B.O": "614016",
      "Melanemmeli B.O": "614018",
      "Peraiyur B.O": "614018",
      "Harischandrapuram B.O": "610206",
      "Neivasal B.O": "614019",
      "Oothucadu B.O": "612701",
      "Avalivanallur B.O": "612802",
      "Kunniyur B.O": "614717",
      "Mannargudi West B.O": "614001",
      "Karaikottai B.O": "614013",
      "Manjanavadi B.O": "614101",
      "Irulneeki B.O": "614708",
      "Karuppakilar B.O": "614708",
      "Vadakovanur B.O": "614102",
      "Mullaivasal B.O": "614404",
      "Narthangudi B.O": "614404",
      "Olimidi B.O": "614404",
      "Tenparai B.O": "614020",
      "Neduvakottai B.O": "614014",
      "Serumangalam B.O": "614014",
      "Melanatham B.O": "614015",
      "Palaiyur B.O": "614705",
      "Devangudi B.O": "612803",
      "Kalanjimodu B.O": "612803",
      "Asesham B.O": "614016",
      "Talayamangalam(MNG) B.O": "614016",
      "Vallur B.O": "614017",
      "Kandithampettai B.O": "614018",
      "Nallikottai B.O": "614018",
      "Periyakuruvadi B.O": "610206",
      "Muvarkottai B.O": "614019",
      "Sadayarkoil B.O": "614019",
      "Tiruvarur H.O": "610001",
      "Mannargudi H.O": "614001",
      "Tiruturaipundi H.O": "614713",
      "Koothanallur S.O": "614101",
      "Kottur S.O (Tiruvarur)": "614708",
      "Lakshmangudi S.O": "614102",
      "Naduvakalappal S.O": "614710",
      "Puvanur S.O": "612803",
      "Ullikottai S.O": "614018",
      "Vaduvur S.O": "614019",
      "Kovilvenni S.O": "614403",
      "Valangaman S.O": "612804",
      "Nidamangalam S.O": "614404",
      "Paravakottai S.O": "614015",
      "Podakudi S.O": "614103",
      "Tirumakottai S.O": "614017",
      "Vadapathimangalam S.O": "610206",
      "Avoor S.O": "612701",
      "Haridwaramangalam S.O": "612802",
      "Adichapuram S.O": "614717",
      "Haridranathi S.O": "614001",
      "Idangankottai Melaiyur S.O": "614013",
      "Peruvazhandan S.O": "614705",
      "Serangolam S.O": "614016",
      "Alangudi NID S.O": "612801",
      "Mannargudi Bazaar S.O": "614001",
      "Painganadu S.O": "614020",
      "Pamani MNG S.O": "614014",
      "Kollumangudi S.O": "609403",
      "Peralam S.O": "609405",
      "Punthottam S.O": "609503",
      "Kollapuram S.O": "609608",
      "Idaiyur S.O": "614702",
      "Jambavanodai S.O": "614738",
      "Pamani TTP S.O": "614711",
      "Udayamarthandapuram S.O": "614706",
      "Vilakudi S.O": "614715",
      "Tiruvidacherry S.O": "610107",
      "Sembangudi S.O": "612603",
      "Sengalipuram S.O": "612604",
      "Eravancheri S.O": "609501",
      "Ammayappan S.O": "613701",
      "Mudikondan S.O": "609502",
      "Nannilam S.O": "610105",
      "Attikkadai S.O": "613702",
      "Kodavasal S.O": "612601",
      "Adiakkamangalam S.O": "611101",
      "Kachanam S.O": "610201",
      "Kulikarai S.O": "613704",
      "Mangudi S.O": "610103",
      "Tirunellikaval S.O": "610205",
      "Tiruvarur Central University": "610005",
      "Kattimodu S.O": "614716",
      "Tiruturaipundi Bazaar S.O": "614713",
      "Kamalapuram S.O (Tiruvarur)": "610102",
      "Kidarankondan S.O": "610003",
      "Manakkal Ayyampet S.O": "610104",
      "Nannilam Cutchery S.O": "610105",
      "Ponnirai S.O": "610203",
      "Pulivalam S.O (Tiruvarur)": "610109",
      "Mavoor S.O (Tiruvarur)": "610202",
      "Thappalampuliyur S.O": "610106",
      "Tiruvarur Collectorate S.O": "610004",
      "Tiruvarur North S.O": "610001",
      "Koradacheri S.O": "613703",
      "Manjakudi S.O": "612610",
      "Sellur S.O (Tiruvarur)": "613705",
      "Mutupet S.O": "614704",
      "Tiruturaipundi R.S. S.O": "614713",
      "Kunnalur S.O": "614703"
    },
    "NAMAKKAL": {
      "Anaipalayam B.O": "637401",
      "Koonavelampatti B.O": "637401",
      "Thengalpalayam B.O": "636301",
      "Melkallupalayam B.O": "637403",
      "Pillanallur B.O": "637403",
      "Iswaramurtipalayam B.O": "636202",
      "Masakalipatti B.O": "637401",
      "Muthukalipatti B.O": "637401",
      "Ayilpatti B.O": "636202",
      "Kosavampalayam B.O": "637201",
      "Molippalli B.O": "637201",
      "Agaram B.O": "637202",
      "Iluppili B.O": "637202",
      "Konnaiyar B.O": "637202",
      "Kothamangalam B.O": "637213",
      "Pilikkalpalayam B.O": "637213",
      "Kondarasampalayam B.O": "637203",
      "Sullipalayam B.O": "637203",
      "Irukkur B.O": "637204",
      "Emappalli B.O": "637214",
      "Elayampalayam B.O": "637205",
      "Kuppandapalayam B.O": "637205",
      "Sathianaickenpalayam B.O": "637205",
      "Karumanur B.O": "637503",
      "Thuthipalayam B.O": "637503",
      "Melsathambur B.O": "637206",
      "Pillur B.O": "637206",
      "Seerampalayam B.O": "638008",
      "Villipalayam B.O": "637207",
      "Selur B.O": "637208",
      "O.Rajapalayam B.O": "637209",
      "Sirumolasi B.O": "637209",
      "Patlur B.O": "637210",
      "Koothampoondi B.O": "637202",
      "Pullagoundanpatti B.O": "637202",
      "Ramapuram B.O": "637202",
      "Kullanaickenpalayam B.O": "638183",
      "Andipalayam B.O": "637214",
      "UnjanaiKavundampalayam B.O": "637205",
      "Vattur B.O": "637205",
      "Palamedu B.O": "637503",
      "Vadugampalayam B.O": "637503",
      "Kirambur B.O": "637207",
      "Kilsattambur B.O": "637207",
      "Konur B.O": "637207",
      "M.Rasampalayam B.O": "637207",
      "Kondalam B.O": "637208",
      "Chinnathambipalayam B.O": "637209",
      "Attavanai Iraiyamangalam B.O": "637210",
      "Goundampalayam B.O": "637210",
      "Molasi B.O": "637210",
      "Anangur B.O": "637304",
      "Modamangalam B.O": "637304",
      "Karichchipalayam B.O": "637201",
      "Kolaram B.O": "637201",
      "Kurukkapuram B.O": "637401",
      "Thottivalasu B.O": "636301",
      "85 R.Komarapalayam B.O": "637403",
      "Agraharam B.O": "637403",
      "Chandrasekarapuram B.O": "637401",
      "Maniyanur B.O": "637201",
      "Kurumbalamahadevi B.O": "637213",
      "Sirunallikovil B.O": "637213",
      "Vadakaraiatur B.O": "637213",
      "Kavundipalayam B.O": "637203",
      "Kunnamalai B.O": "637203",
      "Ramadevan B.O": "637203",
      "Akkaraipatti B.O": "637503",
      "Kolangondai B.O": "637503",
      "Kottapalayam B.O": "637503",
      "Sungakarampatti B.O": "637206",
      "Alampalayam B.O": "638008",
      "Elandakuttai B.O": "638008",
      "Kadachinallur B.O": "638008",
      "Kaliyanur B.O": "638008",
      "SamayaSangiliAgragaram B.O": "638008",
      "Padaivedu B.O": "637303",
      "Pallakkapalayam B.O": "637303",
      "Karumapuram B.O": "637302",
      "Devanankurichi B.O": "637209",
      "Kailasampalayam B.O": "637209",
      "Komarapalayam B.O": "637209",
      "Uppupalayam B.O": "637201",
      "Avanasipatti B.O": "637202",
      "Kilapalayam B.O": "637202",
      "Kunnathur Ayyampalayam B.O": "637213",
      "Sithampoondi B.O": "637203",
      "Periyasolipalayam B.O": "637204",
      "Thidumal B.O": "637204",
      "Kallankattuvalasu B.O": "638183",
      "Animoor B.O": "637214",
      "Thokkavadi B.O": "637215",
      "Pillanatham B.O": "637205",
      "Unjanai B.O": "637205",
      "Mamundi B.O": "637503",
      "Paruttipalli B.O": "637503",
      "Koodacheri B.O": "637206",
      "N.Seerapalli B.O": "637206",
      "Sowdapuram B.O": "638008",
      "Thindamangalam B.O": "637207",
      "Kulakkattupudur B.O": "637208",
      "Vengarai B.O": "637208",
      "Veeranampalayam B.O": "638181",
      "Kolikkalnatham B.O": "637302",
      "Thirumangalam B.O": "637302",
      "Sooriyampalayam B.O": "637209",
      "Zamin Elampalli B.O": "637210",
      "Karuveppampatti B.O": "637304",
      "Moolakurichi B.O": "636142",
      "Munjanur B.O": "637403",
      "Sarkar Nattamangalam B.O": "637403",
      "Kalipatti B.O": "637501",
      "Mangalam B.O": "637501",
      "Perappancholai B.O": "636113",
      "Unanthangal B.O": "636142",
      "Naraikinar B.O": "636118",
      "Shevroy Mines B.O": "636203",
      "Alavaipatty B.O": "637505",
      "Kalkattanur B.O": "637505",
      "Minnakkal Agraharam B.O": "637505",
      "O.Sowdapuram B.O": "637505",
      "Periyakombai B.O": "636113",
      "Shenbagamadevi B.O": "637501",
      "P.Mettur B.O": "636203",
      "R.Komarapalayam B.O": "636203",
      "Palanthinnipatti B.O": "637505",
      "Sappayapuram B.O": "637505",
      "Nachipatti B.O": "636455",
      "Kokkarayanpettai BO": "638007",
      "Pappampalayam BO": "638007",
      "Kattur B.O": "636202",
      "Singiliankombai B.O": "636202",
      "Thandagoundanpalayam B.O": "636202",
      "Oduvankurichi B.O": "637406",
      "Pachudayampalayam B.O": "637406",
      "T.Jedarpalayam B.O": "637406",
      "Vadugam Muniappampalayam B.O": "637407",
      "Kakkaveri B.O": "637408",
      "Kadiranallur B.O": "637412",
      "Kullamanaickenpatti B.O": "637412",
      "Palaniappanur B.O": "637412",
      "Kammalapatti B.O": "636202",
      "Mathuruttu B.O": "636202",
      "Thimmanaickenpatti B.O": "636202",
      "Veppilaipatti B.O": "636202",
      "Sirapalli B.O": "637406",
      "Vellakkalpatti B.O": "637406",
      "Malayampatti B.O": "637407",
      "Pattanam Muniappampalayam B.O": "637407",
      "Pudupalayam B.O": "637408",
      "Bodinaickenpatti B.O": "637405",
      "Arasanatham B.O": "637020",
      "Arur B.O": "637020",
      "Mettupatti B.O": "637020",
      "N.Pudupatti B.O": "637020",
      "Mavureddippatti B.O": "637212",
      "Nallakumarampalayam B.O": "637212",
      "Pirantagam B.O": "637212",
      "Serukkalai B.O": "637212",
      "Marapparai B.O": "637410",
      "Morangam B.O": "637410",
      "Periyamanali B.O": "637410",
      "Kuppuchipalayam B.O": "638182",
      "Nanjai Edaiyar B.O": "638182",
      "Sultanpet B.O": "638182",
      "Ramanadapuram B.O": "637409",
      "Devarayapuram B.O": "637021",
      "Navaladipatti B.O": "637021",
      "Akkalampatti B.O": "637212",
      "Thottiapatti B.O": "637410",
      "Unjapalayam B.O": "638182",
      "Gandhipuram B.O": "637409",
      "Ariyagoundampatti B.O": "637406",
      "Kavundampalayam B.O": "637408",
      "Kamarajnagar B.O": "636202",
      "Karkudalpatti B.O": "636202",
      "Tirumanur B.O": "636202",
      "Moolapallipatti B.O": "637406",
      "Thoppapatti B.O": "637406",
      "Melur B.O": "637407",
      "Vadugam B.O": "637407",
      "Kattanachampatti B.O": "637408",
      "Pattanam B.O": "637408",
      "Pottanam B.O": "637409",
      "Andapuram B.O": "637020",
      "Parali B.O": "637020",
      "Pavitram B.O": "637021",
      "Bommanpatti B.O": "637212",
      "Kodur Mitta B.O": "637212",
      "Thaligai B.O": "637212",
      "Gandhiashram B.O": "637201",
      "Chinnamanali B.O": "637410",
      "Punjai Edayar Kilmugam B.O": "638182",
      "Karadipatti B.O": "637019",
      "Kolathupalayam B.O": "637019",
      "Adukkam B.O": "637411",
      "Gundurnadu B.O": "637411",
      "Kuzhivalavu B.O": "637411",
      "Perakkarainadu B.O": "637411",
      "Periyakovilur B.O": "637411",
      "Thiruppulinadu B.O": "637411",
      "Thuvarapallam B.O": "637411",
      "Valappurnadu B.O": "637411",
      "Valavanthinadu B.O": "637411",
      "Marurpatti B.O": "637019",
      "Minnampalli B.O": "637019",
      "Ariyurcusba B.O": "637411",
      "Ariyurnadu B.O": "637411",
      "Chittoornadu B.O": "637411",
      "Selurnadu B.O": "637411",
      "Sundakattupatti B.O": "637411",
      "Pachudayampattipudur B.O": "637409",
      "Alampatti B.O": "637020",
      "Pavithirampudur B.O": "637021",
      "Elanagar B.O": "637212",
      "Manathi B.O": "637212",
      "Karungalpatti B.O": "637410",
      "Pottireddipatti B.O": "637013",
      "Pudukottai B.O": "637013",
      "Vadavathur B.O": "637013",
      "Varadarajapuram B.O": "637013",
      "Kalangani B.O": "637014",
      "Kannurpatti B.O": "637014",
      "Reddipudur B.O": "637014",
      "Tataiyangarpatti B.O": "637014",
      "Pettapalayam B.O": "637015",
      "Sevitturangampatti B.O": "637015",
      "Chidambarapatti B.O": "637405",
      "Kondamanaickenpatti B.O": "637405",
      "Thummankurichi B.O": "637003",
      "Kalyani B.O": "637018",
      "Musiri B.O": "637018",
      "Navanipallipatti B.O": "637018",
      "S.Uduppam B.O": "637019",
      "Alathurnadu B.O": "637411",
      "Devanurnadu B.O": "637411",
      "Gunduninadu B.O": "637411",
      "Mekkinikadu B.O": "637411",
      "Melkalingampatti B.O": "637411",
      "Kokkalai B.O": "637410",
      "Anichampalayam B.O": "638182",
      "Kalkurichi B.O": "637402",
      "Alanganatham B.O": "637013",
      "Periyapatti B.O": "637002",
      "Reddipatti B.O": "637002",
      "Sanyasikaradu B.O": "637002",
      "Thusur B.O": "637002",
      "Pattathiyankuttai B.O": "637404",
      "Thuthikulam B.O": "637404",
      "Tirumalaipatti B.O": "637404",
      "Bodupatti B.O": "637003",
      "Mudalaipatti B.O": "637003",
      "Aniyapuram B.O": "637017",
      "Talambadi B.O": "637019",
      "Bailnadu B.O": "637411",
      "Edappulinadu B.O": "637411",
      "Navakkadu B.O": "637411",
      "Thinnanurnadu B.O": "637411",
      "Veeraganurpatti B.O": "637411",
      "Akkiampatti B.O": "637409",
      "Kavakkarapatti B.O": "637013",
      "Muthanchetti B.O": "637013",
      "Kanavaipatti B.O": "637002",
      "Kosavampatti B.O": "637002",
      "Vasanthapuram B.O": "637002",
      "Malaveppankuttai B.O": "637404",
      "Ariyur B.O": "637015",
      "Oruvandur B.O": "637015",
      "Palayapalayam B.O": "637405",
      "Siluvampatti B.O": "637003",
      "Vallipuram B.O": "637003",
      "K.Pudupalayam B.O": "637017",
      "S.Vazhavandhi B.O": "637017",
      "Dhathathiripuram B.O": "637018",
      "Elur B.O": "637018",
      "Pachal B.O": "637018",
      "Kadapalli B.O": "637019",
      "Konangipatti B.O": "637013",
      "Ponneri B.O": "637013",
      "Bommasamudram B.O": "637002",
      "Laddivadi B.O": "637002",
      "Naducombai B.O": "637404",
      "Thethukadu B.O": "637404",
      "Valavanthicombai B.O": "637404",
      "Kumaripalayam B.O": "637015",
      "Vettambadi B.O": "637405",
      "Visanam B.O": "637405",
      "Ernapuram B.O": "637003",
      "Pappinaickenpatti B.O": "637003",
      "Manappalli B.O": "637017",
      "Tolur B.O": "637017",
      "E.Pudupatti B.O": "637018",
      "Veppampattiypudur B.O": "637018",
      "Avalnaickenpatty B.O": "637019",
      "Seventhipatti B.O": "621215",
      "Tiruchengodu H.O": "637211",
      "Mullukurichi S.O": "636142",
      "Namakkal H.O": "637001",
      "Attanur S.O": "636301",
      "Gurusamipalayam S.O": "637403",
      "Pudupatti S.O (Salem)": "637407",
      "Rasipuram Bazaar S.O": "637408",
      "Andagalur S.O": "637401",
      "Mangalapuram S.O": "636202",
      "Rasipuram S.O": "637408",
      "Singalandapuram S.O": "637412",
      "Namagiripettai S.O": "637406",
      "Vennandur S.O": "637505",
      "Belukurichi S.O": "637402",
      "Namakkal Bazaar S.O": "637001",
      "Semmedu S.O": "637411",
      "Varagur S.O": "637021",
      "Velagoundampatti S.O": "637212",
      "Elachipalayam S.O": "637202",
      "Jedarpalayam S.O": "637213",
      "Kandampalayam S.O": "637203",
      "KomarapalayamEast S.O": "638183",
      "Komarapalayam S.O": "638183",
      "Kumaramangalam S.O": "637205",
      "Nadandai S.O": "637206",
      "Seetharamapalayam S.O": "637209",
      "Tiruchengodu South S.O": "637211",
      "Velur (Namakkal) S.O": "638182",
      "Cauvery Railway Station SO": "638007",
      "Pallipalayam SO": "638006",
      "Ganesapuram S.O": "637002",
      "Santhaipettaipudur S.O": "637001",
      "Valayapatti S.O (Namakkal)": "637020",
      "Namakkal District Court Buildings S.O": "637003",
      "Solakkadu S.O": "637415",
      "Pothanur S.O": "638181",
      "Thannirpandalpalayam S.O": "637304",
      "Vaiyappamalai S.O": "637410",
      "Muthugapatti S.O": "637405",
      "Nallipalayam S.O": "637003",
      "Namakkal Fort S.O": "637001",
      "Palapatti S.O": "637017",
      "Ramapurampudur S.O": "637001",
      "Sellappampatti S.O": "637019",
      "Chittalandur S.O": "637201",
      "Kapilamalai S.O": "637204",
      "Koottapalli S.O": "637214",
      "Kuchipalayam S.O": "637215",
      "Pallipalayamagraharam S.O": "638008",
      "Solasiramani S.O": "637210",
      "Tiruchengodu North S.O": "637211",
      "Erampatti S.O": "637013",
      "Kalappanaickenpatti S.O": "637404",
      "Karaikurichi S.O (Namakkal)": "637014",
      "Mohanur North S.O": "637015",
      "Mohanur S.O": "637015",
      "Natarajapuram S.O (Namakkal)": "637001",
      "Puduchatram S.O": "637018",
      "Sendamangalam S.O": "637409",
      "Thillaipuram S.O": "637001",
      "Mallasamudram S.O": "637503",
      "Paramathi S.O": "637207",
      "Paundamangalam S.O": "637208",
      "SPB Colony SO": "638010"
    },
    "SALEM": {
      "Banapuram B.O": "636451",
      "Erakondampatti B.O": "636451",
      "Thettigiripatti B.O": "636451",
      "Kannapadi B.O": "636354",
      "Periavadugampatti B.O": "636354",
      "Kosavapatti B.O": "637502",
      "Kuralnatham B.O": "636204",
      "Tippampatti B.O": "636204",
      "Karungalpatti B.O": "636006",
      "Muthampatti B.O": "636503",
      "Mettupatti Karipatti B.O": "636111",
      "Achankuttapatti B.O": "636122",
      "D.Perumapalayam B.O": "636122",
      "Valasaiyur B.O": "636122",
      "Periaseeragapadi B.O": "636308",
      "Maramangalam B.O": "636503",
      "Pattipadi B.O": "636601",
      "Vellakadai B.O": "636602",
      "Adikarai B.O": "636204",
      "Chendrayampalayam B.O": "636111",
      "Teppakuttai B.O": "637502",
      "Andikarai B.O": "636404",
      "Karuppureddiyur B.O": "636404",
      "Doramangalam B.O": "636501",
      "Kuppampatti B.O": "636501",
      "Surapalli B.O": "636501",
      "Jodukuli B.O": "636351",
      "Mukkanur B.O": "636351",
      "V.Kongarapatti B.O": "636351",
      "Dharapuram B.O": "636309",
      "Vellalapatti B.O": "636114",
      "Kurumbarur B.O": "636303",
      "Tharkadusundarapuram B.O": "636303",
      "Mulakkadu B.O": "636452",
      "Koonandiyur B.O": "636458",
      "Amaram B.O": "636451",
      "Kottagoundanpatti B.O": "636011",
      "Mattukaranur B.O": "636011",
      "Dalavaipatti B.O": "636109",
      "Pakkanadu B.O": "636501",
      "Ramireddipatti B.O": "636501",
      "Savariyur B.O": "636501",
      "Selavadai B.O": "636501",
      "Umbilickampatti B.O": "636351",
      "Dinnapatti B.O": "636303",
      "Govindapadi B.O": "636303",
      "Kannamoochi B.O": "636303",
      "Pannavadi B.O": "636303",
      "Swaminathapuram B.O": "636009",
      "Kolnaickenpatti B.O": "636452",
      "Masilapalayam B.O": "636452",
      "M.Pallipatti B.O": "636458",
      "Nariyanur B.O": "636458",
      "M. Perumapalayam B.O": "636111",
      "Akkarapalayam B.O": "636308",
      "Ariyanur B.O": "636308",
      "Bairoji Agraharam B.O": "636308",
      "Keeraikadu B.O": "636601",
      "Kombuthooki B.O": "636601",
      "Vazhavandhi B.O": "636601",
      "Marakottai B.O": "636451",
      "Periasathapadi B.O": "636451",
      "Vellar B.O": "636451",
      "K.Morur B.O": "636354",
      "Kanavaipudur B.O": "636354",
      "Edanganasalai B.O": "637502",
      "Egapuram B.O": "637502",
      "Koneripatti B.O": "636113",
      "Magnesite Mines B.O": "636302",
      "Mamangam B.O": "636302",
      "Bommiyampatti B.O": "636351",
      "Deevattipatti B.O": "636351",
      "Periappatti B.O": "636309",
      "Pottipuram B.O": "636309",
      "Semmandapatti B.O": "636309",
      "Sikkanampatti B.O": "636309",
      "Chettichavadi B.O": "636012",
      "Moongilpadi B.O": "636012",
      "Thathiengarpatti B.O": "636012",
      "Thumbalpatti B.O": "636204",
      "Dadagapatti B.O": "636006",
      "Chinnanur B.O": "636122",
      "Pallipatti B.O": "636122",
      "Poovanur B.O": "636122",
      "Veeranam B.O": "636122",
      "Puthur B.O": "636010",
      "Sengadu B.O": "636601",
      "Thalaisolai B.O": "636601",
      "Vellalagundam B.O": "636111",
      "Kuppanur B.O": "637301",
      "Chinnaseeragapadi B.O": "636308",
      "Kullampatti B.O": "636103",
      "Morasapatti B.O": "637101",
      "Konasamudram B.O": "637102",
      "Kornampatti B.O": "637102",
      "Konerippatti B.O": "637107",
      "Chinnakkavandanur B.O": "637303",
      "Veerachipalayam B.O": "637303",
      "Kasturippatti B.O": "637302",
      "Akkammapettai B.O": "637301",
      "Vellarnaickenpalayam B.O": "637101",
      "Valayakkaranur B.O": "638183",
      "Olakkchinnanur B.O": "637102",
      "Rangampalayam B.O": "637102",
      "Rettipatti B.O": "637102",
      "Kottaichedu B.O": "636601",
      "Alachampalayam B.O": "637101",
      "Chettimankuricchi B.O": "637101",
      "Chettipatti B.O": "636455",
      "Chittoor B.O": "637101",
      "Vellarivelli B.O": "637101",
      "Erumaipatti B.O": "637102",
      "K.Vadugapatti B.O": "637102",
      "Kachchpalli B.O": "637102",
      "Koothampalayam B.O": "637102",
      "Agraharathalaiyur B.O": "637103",
      "Chinnandipalayam B.O": "637103",
      "Mathayanur B.O": "637303",
      "Sanniyasipatti Agraharam B.O": "637303",
      "Chinnathanda B.O": "636303",
      "Savariyarpalayam B.O": "636303",
      "Settiyur B.O": "636303",
      "Sundamettupudur B.O": "637102",
      "Tangayur B.O": "637102",
      "Gudalur B.O": "637103",
      "Irugalur B.O": "637103",
      "Navapatti B.O": "636452",
      "Aranganur B.O": "636451",
      "Bukkampatti B.O": "636451",
      "Kethunaickenpattipudur B.O": "636354",
      "Ramamurthinagar B.O": "636354",
      "Perumagoudampatti B.O": "637502",
      "Saminaickenpatti B.O": "636011",
      "Ayyamperumalpatti B.O": "636302",
      "Adaiyur B.O": "636501",
      "Ilavampatti B.O": "636501",
      "Konreddiyur B.O": "636351",
      "Nadupatti B.O": "636351",
      "Vattakadu B.O": "636012",
      "Karungallur B.O": "636303",
      "Kaveripuram B.O": "636303",
      "Palamalai Hills B.O": "636303",
      "Singiripatti B.O": "636303",
      "Palakadu B.O": "636110",
      "Velur B.O": "636601",
      "Puluthikuttai B.O": "636104",
      "Ramanathapuram B.O": "636104",
      "Sekkadipatti B.O": "636104",
      "Anaiyampatti B.O": "636105",
      "Edappadi B.O": "636105",
      "Kadambur B.O": "636105",
      "Kudamalai B.O": "636105",
      "Mayambadi B.O": "636105",
      "Seeliampatti B.O": "636107",
      "Appammasamudram B.O": "636108",
      "Chokkanathapuram B.O": "636108",
      "Palaniyapuri B.O": "636108",
      "Ramanaickenpalayam B.O": "636108",
      "Pungavadi B.O": "636141",
      "Kamakkapalayam B.O": "636112",
      "Vazhakombai B.O": "636113",
      "Kattukottai B.O": "636121",
      "Athanurpatti B.O": "636115",
      "Kottavadi B.O": "636115",
      "Mannarpalayam Valapady B.O": "636115",
      "Periakrishnapuram B.O": "636115",
      "Vilaripalayam B.O": "636115",
      "Navalur B.O": "636116",
      "Thandanur B.O": "636117",
      "Okkilipatti B.O": "637107",
      "Nagichettipatti B.O": "637302",
      "Manjakalpatti B.O": "637301",
      "Mavelipalayam B.O": "637301",
      "Vadugapatti B.O": "637301",
      "Morur B.O": "637304",
      "Iruppali B.O": "637101",
      "Kurukkapatti B.O": "637101",
      "Samiyampalayam B.O": "638183",
      "Papparapatti B.O": "637501",
      "Rajapalayam B.O": "637501",
      "Gorimedu B.O": "636008",
      "Gajjalnaickenpatti B.O": "636201",
      "Nalikalpatti B.O": "636201",
      "Naduvalur B.O": "636105",
      "Odiyathur B.O": "636105",
      "Arasanatham B.O": "636107",
      "Kalarampatti B.O": "636107",
      "Kiripatti B.O": "636107",
      "Olapadi B.O": "636109",
      "Kallanatham B.O": "636141",
      "Mulluvadi B.O": "636141",
      "Ariyampalayam B.O": "636119",
      "Veeragoundanur B.O": "636119",
      "Tagarapudur B.O": "636110",
      "Navakurichi B.O": "636112",
      "Unathur B.O": "636112",
      "Udayarpalayam B.O": "636113",
      "Mannur B.O": "636114",
      "Sadasivapuram B.O": "636121",
      "Sathapadi B.O": "636121",
      "Singipuram B.O": "636115",
      "Thukkiampalayam B.O": "636115",
      "Kavarpanai B.O": "636116",
      "Vellaiyur B.O": "636116",
      "Panaimadal B.O": "636117",
      "Narasothipatti B.O": "636004",
      "Ayodhiyapattinam East B.O": "636103",
      "Kondappanaickenpatti B.O": "636008",
      "Koil Puthur B.O": "636138",
      "Maniyaragundam B.O": "636138",
      "Sittampatti B.O": "636138",
      "Thekkampattu B.O": "636138",
      "Sanniyasigundu B.O": "636015",
      "Maniyanur B.O": "636010",
      "Neikkarapatti B.O": "636010",
      "Velampatti B.O": "636139",
      "Parapatti B.O": "636203",
      "Santhiyur Attayampatti B.O": "636203",
      "Cauvery Peak B.O": "636602",
      "Naripadi B.O": "636105",
      "Ammampalayam B.O": "636141",
      "Kondayampalli B.O": "636110",
      "Aranoothumalai B.O": "636104",
      "Chandrapillaivalasu B.O": "636104",
      "Manmalai B.O": "636110",
      "Pattuthurai B.O": "636112",
      "Sheepfarm B.O": "636112",
      "Siruvachur B.O": "636112",
      "Kannanderi B.O": "637102",
      "Vaikuntham B.O": "637103",
      "Vellaiyampalayam B.O": "637103",
      "Nedungulam B.O": "637107",
      "Alattur B.O": "637303",
      "Devannacoundanur B.O": "637301",
      "Vengipalayam B.O": "637304",
      "Jangammasamudram B.O": "636113",
      "Sarvoy B.O": "636121",
      "Thenkumarai B.O": "636121",
      "Valayamadevi B.O": "636121",
      "Vaidhyagoundampudur B.O": "636115",
      "Punavasal B.O": "636116",
      "Rajapalayam East B.O": "636116",
      "Thadavur B.O": "636116",
      "A.Komarapalayam B.O": "636117",
      "Masinaickenpatti B.O": "636103",
      "Mettupatti Tadanur B.O": "636103",
      "Tadampatti B.O": "636014",
      "Chinnatirupathy B.O": "636008",
      "Erumapalayam B.O": "636015",
      "Sandaipettai B.O": "636010",
      "Thammanaickenpatti B.O": "636010",
      "Uthamasolapuram B.O": "636010",
      "Sitheri B.O": "636101",
      "Thiaganur B.O": "636101",
      "Veppampoondi B.O": "636101",
      "Nilavarapatti B.O": "636201",
      "Agrahara Nattamangalam B.O": "636106",
      "Minnampalli B.O": "636106",
      "Periyagoundapuram B.O": "636106",
      "Ramalingapuram B.O": "636106",
      "Sarkar Nattamanagalam B.O": "636106",
      "Anuppur B.O": "636139",
      "Ervadi pethampatti B.O": "636203",
      "Mookuthipalayam B.O": "636203",
      "Kandashramam B.O": "636140",
      "Manjakuttai B.O": "636602",
      "Muluvi B.O": "636602",
      "Nagalur B.O": "636602",
      "Piliyur B.O": "636602",
      "Govindampalayam B.O": "636101",
      "Puliyankurichi B.O": "636101",
      "Konanchettiyur B.O": "636104",
      "Kurichi B.O": "636104",
      "Periakuttimaduvu B.O": "636104",
      "Periyeri B.O": "636101",
      "Periakadampatti B.O": "636502",
      "Periasoragai B.O": "636502",
      "Manathal B.O": "636503",
      "Manathal Nallagoundampatti B.O": "636503",
      "Aladipatti B.O": "636104",
      "Chinnamanaickenpalayam B.O": "636104",
      "Chinnasoragai B.O": "636502",
      "Periavanavasi B.O": "636457",
      "Kakapalayam B.O": "637504",
      "Krishnapuram B.O": "636105",
      "Gopalapuram B.O": "636107",
      "Melthombai B.O": "636107",
      "Thandavarayapuram B.O": "636108",
      "Kalpaganur B.O": "636109",
      "Manjini B.O": "636141",
      "Paithur B.O": "636141",
      "Umayalpuram B.O": "636119",
      "Deviakurichi B.O": "636112",
      "Manivilundan Colony B.O": "636112",
      "Varagur B.O": "636112",
      "Nagiampatti B.O": "636113",
      "Edayapatti B.O": "636114",
      "Neyyamalai B.O": "636114",
      "Pappanaickenpatti B.O": "636114",
      "Manivilundan B.O": "636121",
      "Ponnarampatti B.O": "636115",
      "Thamaiyanur B.O": "636115",
      "West Rajapalayam B.O": "636115",
      "Iluppanatham B.O": "636116",
      "Laddivadi B.O": "636116",
      "Kalleripatti B.O": "636117",
      "Puthumariamman Koil B.O": "636003",
      "Chennagiri B.O": "637501",
      "Seelanaickenpatti B.O": "636201",
      "Parapatti Mannarpalayam B.O": "636008",
      "Karumapuram B.O": "636106",
      "Kariyakoil B.O": "636138",
      "Kunnur B.O": "636138",
      "Pagadupattu B.O": "636138",
      "Soolankurichi B.O": "636138",
      "Nattamangalam B.O": "636010",
      "Poolavari Agraharam B.O": "636010",
      "Kolathukombai B.O": "636139",
      "Nirmullikuttai B.O": "636139",
      "Asambur B.O": "636602",
      "Karadiyur B.O": "636602",
      "Semmanatham B.O": "636602",
      "Konagapadi B.O": "636502",
      "Mallikuttai B.O": "636503",
      "Naduvaneri B.O": "637504",
      "Arurpatti B.O": "636502",
      "Pavalathanur B.O": "636502",
      "Amaragundi B.O": "636503",
      "Periyeripatti B.O": "636503",
      "Sanarapatti B.O": "636457",
      "Kalparapatty B.O": "637504",
      "Kandarkulamanickam B.O": "637504",
      "Rakkipatti B.O": "637504",
      "Koppampudur B.O": "636453",
      "Boominaickenpatti B.O": "636304",
      "Pagalpatti B.O": "636304",
      "Pacchanampatti B.O": "636455",
      "Mattukaranpudur B.O": "636305",
      "Sarkaraichettipatti B.O": "636305",
      "Thumbipadi B.O": "636305",
      "Karumalaikudal B.O": "636403",
      "Dasavilakku B.O": "636306",
      "Pappambadi B.O": "636306",
      "Samudram B.O": "636306",
      "Andippatti B.O": "636307",
      "Kandampatti B.O": "636307",
      "Perumampatti B.O": "636307",
      "Mettangadu B.O": "637104",
      "Pullagoundampatti B.O": "637104",
      "Vembaneri B.O": "637105",
      "Sarkar Kollapatti B.O": "636030",
      "Attukaranur B.O": "636304",
      "Chellapillaikuttai B.O": "636304",
      "Semmankudal B.O": "636304",
      "Kanakkampatti B.O": "636454",
      "Panankattur B.O": "636455",
      "Sarakkapillaiyur B.O": "636305",
      "Thinnappatti B.O": "636305",
      "Bodinaickenpatti B.O": "637105",
      "Murungappatti B.O": "636307",
      "Naickenpatti B.O": "636307",
      "Pottaneri B.O": "636453",
      "Maramangalathupatti B.O": "636030",
      "Veerakkal B.O": "636454",
      "Moongilerisettipatti B.O": "636455",
      "Karavalli B.O": "636305",
      "Kurumbapatti B.O": "637105",
      "Guttapatti B.O": "636453",
      "Kullamudayanur B.O": "636453",
      "M.Kalipatti B.O": "636453",
      "Virudasampatti B.O": "636453",
      "Nallagoundampatti B.O": "636304",
      "Mettupatti B.O": "636455",
      "Olaipatti B.O": "636455",
      "Kanjanaickenpatti B.O": "636305",
      "Kongupatti B.O": "636305",
      "Pujaripatti B.O": "636305",
      "Pudusampalli B.O": "636403",
      "Karukkalvadi B.O": "636013",
      "Duddampatti B.O": "636306",
      "Puduppalaiyam B.O": "636306",
      "Dadapuram B.O": "637105",
      "Veerappampalayam B.O": "637105",
      "Tirumalaigiri B.O": "636307",
      "Kaveripatti B.O": "637104",
      "Periyamangalam B.O": "621011",
      "Veppadi B.O": "621110",
      "Salem H.O": "636001",
      "Suramangalam H.O": "636005",
      "Atur H.O": "636102",
      "Aragalur S.O": "636101",
      "Aturbazaar S.O": "636102",
      "Narasingapuram S.O (Salem)": "636108",
      "Belur S.O (Salem)": "636104",
      "Gangavalli S.O": "636105",
      "Pudupet S.O(ATUR)": "636141",
      "Malliakarai S.O": "636107",
      "Pethanaickenpalayam S.O": "636109",
      "Valapady S.O": "636115",
      "Viraganur S.O": "636116",
      "Yethapur S.O": "636117",
      "Ammapettai Salem S.O": "636003",
      "Annadanapatti S.O": "636002",
      "Ayodhiyapattinam S.O": "636103",
      "Dasanaickenpatti S.O": "636201",
      "Kannankurichi S.O": "636008",
      "Mullur S.O": "636203",
      "Salem East S.O": "636001",
      "Salem Fort S.O": "636001",
      "Yercaud S.O": "636601",
      "Allikuttai S.O": "636017",
      "Sendarapatti S.O": "636110",
      "Ulipuram S.O": "636118",
      "Alagapuram S.O": "636004",
      "Fairlands S.O": "636016",
      "Kamaraj Nagar Colony S.O": "636014",
      "Kondalampatti S.O": "636010",
      "Marakkadai S.O": "636004",
      "Maravaneri S.O": "636007",
      "Salem Dt. Court Buildings S.O": "636007",
      "Salem Extension S.O": "636007",
      "Salem South S.O": "636006",
      "Sanjeevarayanpettai S.O": "636006",
      "Sukkampatti S.O": "636122",
      "Veerapandi Salem S.O": "636308",
      "Jagir Ammapalayam S.O": "636302",
      "Mallikundam S.O": "636458",
      "Arisipalayam S.O": "636009",
      "Danishpet S.O": "636354",
      "Gonur S.O": "636404",
      "Kadayampatti S.O": "636351",
      "Kamalapuram S.O (Salem)": "636309",
      "Karuppur S.O": "636012",
      "Metturdam South S.O": "636401",
      "Muthunaickenpatti S.O": "636304",
      "Omalur Cutcherry S.O": "636455",
      "Omalur S.O": "636455",
      "Pannapatti S.O": "636305",
      "Salem Camp S.O": "636456",
      "Metturdam RS S.O": "636402",
      "Metturdam S.O": "636401",
      "Salem Steel Plant S.O": "636013",
      "Sivadapuram S.O": "636307",
      "Vanavasi S.O": "636457",
      "Vembadithalam S.O": "637504",
      "Vadachennimalai S.O": "636121",
      "Gugai S.O": "636006",
      "Karipatti S.O": "636106",
      "Kitchipalayam S.O": "636015",
      "Narayananagar S.O": "636015",
      "Ondikadai S.O": "636602",
      "Peramanur S.O": "636007",
      "Salem Collectorate S.O": "636001",
      "Salem North S.O": "636007",
      "Thillainagar S.O": "636001",
      "Puthiragoundampalayam S.O": "636119",
      "Talaivasal S.O": "636112",
      "Thammampatti S.O": "636113",
      "Thumbal S.O": "636114",
      "Ammapettai Bazaar S.O": "636003",
      "Attayampatti S.O": "637501",
      "Hasthampatti S.O": "636007",
      "Karumanthurai S.O": "636138",
      "Koottathupatti S.O": "636139",
      "Mettu Street S.O": "636001",
      "Odayapatti S.O": "636140",
      "Panamarathupatti S.O": "636204",
      "Ponnammapet S.O": "636001",
      "Salem Bazaar S.O": "636001",
      "Salem Pension Lines S.O": "636006",
      "Seshanchavadi S.O": "636111",
      "Shevapet Bazaar S.O": "636002",
      "Shevapet S.O": "636002",
      "Govt. College Of Engg S.O": "636011",
      "Jalakantapuram S.O": "636501",
      "Kachakaranur S.O": "636302",
      "Leigh Bazaar S.O": "636009",
      "Suramangalam Railway Colony S.O": "636005",
      "Chamrajpet S.O (Salem)": "636451",
      "Elampillai S.O": "637502",
      "Kolathur (Salem)S.O": "636303",
      "Madayankuttai S.O": "636452",
      "Mecheri S.O": "636453",
      "Mettur Thermal Project S.O": "636406",
      "Mohan Nagar S.O (Salem)": "636030",
      "Nangavalli S.O": "636454",
      "Raman Nagar S.O": "636403",
      "Sinnappampatti S.O": "636306",
      "Tharamangalam S.O": "636502",
      "Tholasampatti S.O": "636503",
      "Idappadi S.O": "637101",
      "Thevur S.O (Namakkal)": "637104",
      "Konganapuram S.O": "637102",
      "Poolampatti S.O": "637107",
      "Sankari West S.O": "637303",
      "Sankaridrug S.O": "637301",
      "Vellandivalasai S.O": "637105",
      "Sankaridrug.R.S S.O": "637302",
      "Mc Donalds Choultry S.O": "637103"
    },
    "RAMANATHAPURAM": {
      "Athiyuhtu BO": "623513",
      "Devipattinam South BO": "623514",
      "Idambadal BO": "623515",
      "Kadukkavalasai BO": "623516",
      "Nathamkulapatham BO": "623517",
      "Sundaramudaiyan BO": "623519",
      "Ooranikottai BO": "623308",
      "Sirumalaikottai BO": "623308",
      "Karankadu BO": "623403",
      "Akkamadam BO": "623521",
      "Nainamaraickan BO": "623523",
      "Regunathapuram BO": "623523",
      "Sholandur BO": "623537",
      "Ariyankottai BO": "623525",
      "Avarendal BO": "623525",
      "Pattanamkathan BO": "623503",
      "Arunoothimangalam BO": "623538",
      "Melakidaram BO": "623528",
      "Mv Salt Complex BO": "623528",
      "Kuthakottai BO": "623532",
      "Kothiyarkottai BO": "623531",
      "Kottakudi BO": "623407",
      "Tiruvetriyur BO": "623407",
      "Kiliyur BO": "623530",
      "Nagachi BO": "623534",
      "Marttiyarendal BO": "623533",
      "Kattoorani BO": "623504",
      "Melakottai BO": "623504",
      "Pullangudi BO": "623513",
      "Kanjirangudi BO": "623517",
      "Kumbidumadurai BO": "623517",
      "Andavoorani BO": "623308",
      "Kavalaivendran BO": "623308",
      "Kookudi BO": "623308",
      "Kunjankulam BO": "623308",
      "Puduvalasai BO": "623522",
      "Kalimangundu BO": "623523",
      "Kumbaram BO": "623523",
      "Kalugoorani BO": "623536",
      "Sathankulam BO": "623536",
      "Valantharavai BO": "623536",
      "Naranamangalam BO": "623537",
      "Vellariodai BO": "623524",
      "Kavanur BO": "623525",
      "Sengudi BO": "623525",
      "Uppoor BO": "623525",
      "Vettukulam BO": "623525",
      "Rameswaram Road BO": "623526",
      "Rameswaram East BO": "623526",
      "Kokkurani BO": "623538",
      "Malapanaiyur BO": "623538",
      "Melapudukudi BO": "623532",
      "Methalodai BO": "623532",
      "Pudukoil BO": "623532",
      "Thinaikulam BO": "623532",
      "Pasipattinam BO": "623409",
      "Vattanam BO": "623409",
      "Ekkakudi BO": "623533",
      "Mallal BO": "623533",
      "Surankottai BO": "623504",
      "Therkutharavai BO": "623504",
      "Nilamalagiamangalam BO": "623315",
      "Pananchayal BO": "623315",
      "Muhilthagam BO": "623403",
      "Pudupattinam BO": "623403",
      "Nagarikathan BO": "623404",
      "Olaikuda BO": "623526",
      "Gudalur BO": "623538",
      "Karkathakudi BO": "623538",
      "Valinokkam BO": "623528",
      "Marungoor BO": "623406",
      "Oriyur BO": "623406",
      "Ariyangundu BO": "623529",
      "Anjukottai BO": "623407",
      "Athiyur BO": "623407",
      "Kulathur BO": "623530",
      "Siruvayal BO": "623530",
      "Rettaiyurani BO": "623534",
      "Rajasooriyamadai BO": "623504",
      "Sakkarakottai BO": "623504",
      "Peruvayal BO": "623513",
      "Devipattinam West BO": "623514",
      "Madavanur BO": "623514",
      "Mayakulam BO": "623515",
      "Pirappanvalasai BO": "623516",
      "Kombuthi BO": "623517",
      "Vedalai BO": "623519",
      "Thonithurai BO": "623518",
      "Peruvakottai BO": "623308",
      "Muthupettai BO": "623523",
      "Vannangundu BO": "623523",
      "Sembidaiyarkulam BO": "623536",
      "Vani BO": "623536",
      "PKodikulam BO": "623537",
      "Attangudi BO": "623525",
      "Irudhayapuram BO": "623525",
      "Saveriyarpattinam BO": "623703",
      "Kilakidaram BO": "623528",
      "Pannandai BO": "623528",
      "Sambai BO": "623531",
      "Thinaiyathur BO": "623407",
      "Kurumilangudi BO": "623409",
      "Kavanur TOR BO": "623530",
      "Mangundu BO": "623534",
      "Kalari BO": "623533",
      "Nallirukkai BO": "623533",
      "Peravoor BO": "623504",
      "Sathanur PMK BO": "623706",
      "Kamudakudi BO": "623608",
      "Melaperungarai BO": "623608",
      "Thaduthalankottai BO": "623608",
      "KVeppankulam BO": "623115",
      "Tirumalkanthankottai BO": "623115",
      "Mudaliarpudukulam BO": "623120",
      "Alanganoor BO": "623712",
      "Misal BO": "623712",
      "Vilathur BO": "623706",
      "Bharathinagar PMK BO": "623707",
      "Pidariseri BO": "623608",
      "Pudukudi BO": "623608",
      "Sudiyur BO": "623608",
      "Senkottaipatti BO": "623708",
      "Uchinatham BO": "623115",
      "Kadamangalam BO": "623115",
      "Pammanendal BO": "623115",
      "Thuthinatham BO": "623115",
      "Kuruvadi BO": "623120",
      "Pillaiyarkulam BO": "623120",
      "TVeppankulam BO": "623120",
      "Kakkur BO": "623711",
      "Karumal BO": "623711",
      "Sellur BO": "623712",
      "Sembongudi BO": "623712",
      "Ulaiyur BO": "623712",
      "Venkittankurichi BO": "623712",
      "Paramakudi ITI BO": "623707",
      "Alimadurai BO": "623701",
      "Regunathamadai BO": "623701",
      "Kilaselvanur BO": "623703",
      "Marandai BO": "623703",
      "Melaselvanur BO": "623703",
      "Oppilan BO": "623703",
      "Kilamudimannarkottai BO": "623603",
      "Pakkuvetti BO": "623604",
      "Pasumpon BO": "623604",
      "Valayapukulam BO": "623605",
      "Vilangulathur BO": "623704",
      "Seyyamangalam BO": "623601",
      "Ayinkudi BO": "623401",
      "Govindamangalam BO": "623401",
      "Kalladithidal BO": "623401",
      "Radhanur BO": "623401",
      "Ariyakudi BO": "623527",
      "Bogalur BO": "623527",
      "Kamankottai BO": "623527",
      "Muthuvayal BO": "623527",
      "Pandikanmoi BO": "623527",
      "SKodikulam BO": "623527",
      "T Karungulam BO": "623527",
      "Valanadu BO": "623527",
      "Valasai BO": "623527",
      "Chathurvethamangalam BO": "623705",
      "Gangaikondan BO": "623705",
      "Melakavanur BO": "623706",
      "SKavanur BO": "623706",
      "Sambakulam BO": "623706",
      "Kilaperungarai BO": "623608",
      "Nelmadur BO": "623608",
      "Vengalur BO": "623608",
      "Idivilagi BO": "623115",
      "TPudukottai BO": "623701",
      "Thelichathanallur BO": "623701",
      "Kovilangulam BO": "623603",
      "Mustakurichi BO": "623603",
      "Neeravikarisalkulam BO": "623603",
      "Nerinchipatti BO": "623603",
      "Ramasamypatti BO": "623603",
      "Narippaiyur BO": "623135",
      "Ilanjembur BO": "623704",
      "Keeranur BO": "623704",
      "Kidathirukkai BO": "623704",
      "Melasirupothu BO": "623704",
      "Gopalapattinam BO": "623705",
      "Karadaranthakudi BO": "623705",
      "Vallam BO": "623705",
      "Kilathooval BO": "623706",
      "Kokkarankottai BO": "623115",
      "Mukkaiyur BO": "623120",
      "Pooseri BO": "623711",
      "Vallakulam BO": "623711",
      "Kalaiyur BO": "623712",
      "Valanai BO": "623401",
      "Kilakottai BO": "623527",
      "Ariyanendal BO": "623701",
      "Konnapanendal BO": "623701",
      "Munaivendri BO": "623701",
      "Urapuli BO": "623701",
      "Appanur BO": "623703",
      "SMariyur BO": "623703",
      "Kavadipatti BO": "623603",
      "Kilaramanithi BO": "623603",
      "Sevalpatti BO": "623135",
      "Eluvanur BO": "623605",
      "Koodakulam BO": "623605",
      "Chithrankudi BO": "623704",
      "Pothikulam BO": "623704",
      "Veerambal BO": "623704",
      "Nagaram BO": "623705",
      "M M Pattinam BO": "623706",
      "Melayakudi BO": "623706",
      "Ettivayal BO": "623527",
      "Mennanthi BO": "623527",
      "Kumarakurichi BO": "623701",
      "Vendhoni BO": "623701",
      "Kadugusandai BO": "623703",
      "Periyakulam BO": "623703",
      "TMariyur BO": "623703",
      "Kombuthi KMU BO": "623603",
      "Perumalthevanpatti BO": "623603",
      "Pudukottai BO": "623603",
      "STharaikudi BO": "623135",
      "Sadayaneri BO": "623704",
      "Venneervaikkal BO": "623704",
      "Akkiramesi BO": "623705",
      "PSirahikottai BO": "623705",
      "Uthayakudi BO": "623705",
      "Mudalur BO": "623502",
      "Puthenthal BO": "623502",
      "Muppaiyur BO": "623402",
      "Orikottai BO": "623402",
      "Sevvaipettai BO": "623402",
      "Thoonugudi BO": "623402",
      "Athankarai BO": "623512",
      "Syed Ammal Engineeing College BO": "623502",
      "Natham BO": "623601",
      "Punavasal BO": "623601",
      "Nagaratharkurichi BO": "623601",
      "Nallukurichi BO": "623601",
      "Chithoor BO": "623502",
      "Vairavanendal BO": "623502",
      "Karkalathur BO": "623402",
      "Anaiyur BO": "623601",
      "Melakanniseri BO": "623601",
      "Sadayanendal BO": "623601",
      "Achangulam BO": "623601",
      "Melakodumalur BO": "623601",
      "Ramanathapuram HO": "623501",
      "Paramakudi HO": "623707",
      "Pandugudi SO": "623404",
      "Periyapattinam SO": "623523",
      "Rajasingamangalam SO": "623525",
      "Perungulam SO Ramanathapuram": "623536",
      "Pottagavayal SO": "623537",
      "Pudumadam SO": "623524",
      "Panaikulam SO": "623522",
      "Sathaksalai SO": "623806",
      "Sundarapandiapattinam SO": "623406",
      "Thangachimadam SO": "623529",
      "Tondi SO": "623409",
      "Uchipuli SO": "623534",
      "Rameswaram SO": "623526",
      "Sikkal SO Ramanathapuram": "623528",
      "Thiruppullani SO": "623532",
      "Velipattanam SO": "623504",
      "Vellayapuram SO": "623315",
      "Tirupalaikudi SO": "623531",
      "Tiruvadanai SO": "623407",
      "Ramanathapuram Collectorate SO": "623503",
      "Sanaveli SO": "623538",
      "Toruvalur SO": "623530",
      "Uthirakosamangai SO": "623533",
      "Kottaimedu SO": "623604",
      "Emaneswaram SO": "623701",
      "Kamudi SO": "623603",
      "Kannirajapuram SO": "623135",
      "Mudukulathur SO": "623704",
      "Perunali SO": "623115",
      "Tiruvarangam SO": "623712",
      "Mandapam SO": "623518",
      "Marine Fisheries SO": "623520",
      "Pambur SO": "623706",
      "Paramakudi Bazaar SO": "623707",
      "Teriruveli SO": "623711",
      "Achunthanvayal SO": "623502",
      "Alagankulam SO": "623512",
      "Chitharkottai SO": "623513",
      "Kilakarai SO": "623517",
      "Mandapam Camp SO": "623519",
      "Mangalakudi SO": "623308",
      "Abiramam SO": "623601",
      "Kadaladi SO Ramanathapuram": "623703",
      "Nainarkoil SO": "623705",
      "Parthibanur SO": "623608",
      "Peraiyur SO Ramanathapuram": "623708",
      "Sayalgudi SO": "623120",
      "Chathirakudi SO": "623527",
      "Mandalamanickam SO": "623605",
      "Chinnakeeramangalam SO": "623402",
      "Devipattinam SO": "623514",
      "Ervadi Dargha SO": "623566",
      "Ervadi SO": "623515",
      "Irumeni SO": "623516",
      "Nambuthalai SO": "623403",
      "Pamban SO": "623521",
      "Anandur SO": "623401"
    },
    "CUDDALORE": {
      "Singirikoil BO": "605007",
      "Mathalapattu BO": "605007",
      "Thookkanambakkam BO": "607402",
      "Nallathur BO": "605106",
      "Chellancherry BO": "605106",
      "Vijayamanagaram B.O": "606104",
      "Ma Podaiyur B.O": "606108",
      "Orangur B.O": "606109",
      "Edaiyur B.O": "606302",
      "Nagar B.O": "606302",
      "Kothattai B.O": "608501",
      "Pothiramangalam B.O": "606111",
      "Sathanatham B.O": "606111",
      "Murugangudi B.O": "606105",
      "Pelandurai B.O": "606105",
      "Alathur B.O": "606303",
      "Eluthur B.O": "606303",
      "Kilakalpoondi B.O": "606303",
      "Lakkur B.O": "606303",
      "Thachur B.O": "606303",
      "Nithinatham B.O": "606304",
      "Periyanesalur B.O": "606304",
      "Pillur B.O": "606304",
      "Puvanur B.O": "606104",
      "Alambadi B.O": "606108",
      "Avatti B.O": "606108",
      "Vilangattur B.O": "606302",
      "Kotteri B.O": "607804",
      "Mudanai B.O": "607804",
      "U  Agaram B.O": "607804",
      "Uttangal B.O": "607804",
      "Tholar B.O": "606111",
      "Tiruvattathurai B.O": "606111",
      "Akkanur B.O": "606106",
      "E.Keeranur B.O": "606106",
      "Vagaiyur B.O": "606106",
      "Kaludur B.O": "606304",
      "Poolambadi B.O": "606304",
      "Palayapattinam B.O": "606104",
      "Vallimaduram B.O": "606109",
      "Perambalur B.O": "606302",
      "Seppakkam B.O": "606302",
      "Varambanur B.O": "606302",
      "Gudalur B.O": "606111",
      "Kilimangalam B.O": "606105",
      "Kosapallam B.O": "606105",
      "Perumulai B.O": "606106",
      "Sevveri B.O": "606106",
      "Vaithiyanathapuram B.O": "606303",
      "Adari B.O": "606109",
      "Kattumailur B.O": "606304",
      "Poynapadi B.O": "606108",
      "Malayanur B.O": "606108",
      "Sathiyam B.O": "606302",
      "Sirumangalam B.O": "606302",
      "Avinangudi B.O": "606111",
      "Melur B.O": "606111",
      "Konur B.O": "606105",
      "Kilacheruvoi B.O": "606106",
      "Sirumulai B.O": "606106",
      "Kilinjikuppam BO": "605110",
      "Sivapuri B.O": "608002",
      "Uthamacholamangalam B.O": "608002",
      "Kuriamangalam B.O": "608501",
      "Manikollai B.O": "608501",
      "Manjakuli B.O": "608501",
      "Manjakollai B.O": "608601",
      "Melamanakudi B.O": "608601",
      "Miralur B.O": "608601",
      "Korakkavadi B.O": "606303",
      "Venganur B.O": "606303",
      "N. Naraiyur B.O": "606304",
      "Pasar B.O": "606304",
      "Rettakurichi B.O": "606109",
      "Puvalai B.O": "608601",
      "Kandamangalam B.O": "608301",
      "Karunakaranallur B.O": "608301",
      "M.Kolakudi B.O": "608301",
      "Melapalachanallur B.O": "608301",
      "Sithamalli B.O": "608301",
      "Udayargudi B.O": "608301",
      "K.Alambadi B.O": "608602",
      "Krishnapuram B.O": "608602",
      "Nanjamahathuvazkai B.O": "608102",
      "Ponnanthittu B.O": "608102",
      "Thillaividangan B.O": "608102",
      "Elleri B.O": "608303",
      "Kollimalai Kilpathi B.O": "608303",
      "A.Kuravankuppam B.O": "607802",
      "Ammeri B.O": "607802",
      "Periyakappankulam B.O": "607802",
      "Seplanatham B.O": "607802",
      "Pudaiyur B.O": "608701",
      "Ramapuram B.O": "607003",
      "Sholathiram B.O": "608701",
      "Vadakkupalayam B.O": "608701",
      "Iruppu B.O": "607805",
      "Kattugudalur B.O": "607805",
      "Odappankuppam B.O": "607805",
      "Sorathur B.O": "607805",
      "Gavarappattu B.O": "608002",
      "Jayankondapattinam B.O": "608002",
      "Omampuliyur B.O": "608306",
      "Villiyanallur B.O": "608501",
      "Azhisikudi B.O": "608601",
      "Muthukamatchithottam B.O": "608001",
      "Ennanagaram B.O": "608602",
      "K.Adur B.O": "608602",
      "C.Mutlur B.O": "608102",
      "M.Puliyangudi B.O": "608302",
      "Melaparuthikudi B.O": "608302",
      "Mullangudi B.O": "608302",
      "Pillaiyarthangal B.O": "608303",
      "Tirunaraiyur B.O": "608303",
      "Ayyanur Akkaramangalam B.O": "608201",
      "Odakkanallur B.O": "608201",
      "Pannapattu B.O": "608201",
      "Paradur B.O": "608201",
      "Sakkangudi B.O": "608201",
      "Kanur B.O": "608701",
      "Valasakkadu B.O": "608701",
      "Vallam B.O": "607805",
      "T Gopurapuram B.O": "606003",
      "Dharmanallur B.O": "606103",
      "Periyakottumulai B.O": "606103",
      "Sathapadi B.O": "608601",
      "Chinnaparur B.O": "606104",
      "Idaichittur B.O": "606104",
      "Karnatham B.O": "606104",
      "Konankuppam B.O": "606104",
      "Kargudal B.O": "606003",
      "Ko  Adhanur B.O": "606003",
      "Kuppanatham B.O": "606003",
      "Manavalanallur B.O": "606003",
      "Paravalur B.O": "606003",
      "Sathamangalam B.O": "606003",
      "C Keeranur B.O": "606110",
      "Deevalur B.O": "606110",
      "Sathiyavadi B.O": "606110",
      "Nakkaravanthankudi B.O": "608002",
      "Pichavaram B.O": "608002",
      "Movur B.O": "608306",
      "Puduchatram B.O": "608501",
      "Theethampalayam B.O": "608501",
      "Budavarayanpettai B.O": "608601",
      "Kummidimulai B.O": "608601",
      "Chidambaram North B.O": "608001",
      "Rajendra Cholagam B.O": "608301",
      "Veeranandapuram B.O": "608301",
      "C.Veeracholagam B.O": "608602",
      "Vayalur B.O": "608602",
      "Keelamoongiladi B.O": "608102",
      "Melavanniyur B.O": "608302",
      "Pulamedu B.O": "608302",
      "Temmur B.O": "608302",
      "M.Odaiyur B.O": "608303",
      "Neyvasal B.O": "608303",
      "Melakolakudi B.O": "607802",
      "Melakuppam B.O": "607802",
      "Vadakkuvelur B.O": "607802",
      "C.Sathamangalam B.O": "608201",
      "Kondasamudram B.O": "608701",
      "Palayamkottai Melpathy B.O": "608701",
      "Vanamadevi B.O": "607105",
      "Ariyakoshti B.O": "608502",
      "Samiyarpettai B.O": "608502",
      "Mudapuli B.O": "607805",
      "Reddichavadi BO": "607403",
      "Visoor B.O": "607805",
      "B.Kolakudi B.O": "608704",
      "Kovilampoondi B.O": "608002",
      "Perampattu B.O": "608002",
      "Kunjimedu B.O": "608306",
      "Muttam B.O": "608306",
      "B.Adivaraganallur B.O": "608501",
      "Periyakomatti B.O": "608501",
      "Thatchakadu B.O": "608501",
      "B.Odaiyur B.O": "608601",
      "Kothavacheri B.O": "608601",
      "Arantangi B.O": "608301",
      "Nattarmangalam B.O": "608301",
      "Lalpuram B.O": "608602",
      "Keelanuvampattu B.O": "608102",
      "Pinnathur B.O": "608102",
      "C.Arasur B.O": "608302",
      "Gopalapuram B.O": "606103",
      "Ottimedu B.O": "606103",
      "Therku Vadakku Puthur B.O": "606110",
      "Pali B.O": "606104",
      "Nanjalur B.O": "608302",
      "Suravilandur B.O": "608302",
      "Vannaiyur B.O": "608302",
      "Kollumedu B.O": "608303",
      "Maniadur B.O": "608303",
      "Kottagam B.O": "607802",
      "Mettukkuppam B.O": "607802",
      "Maduranthaganallur B.O": "608201",
      "Vakkur B.O": "608201",
      "Mamangalam B.O": "608701",
      "Perur B.O": "608701",
      "Agaram B.O": "608502",
      "C.Pudupettai B.O": "608502",
      "Kilkangeyankuppam B.O": "607805",
      "Chinnanargunam B.O": "608704",
      "Shandan B.O": "608304",
      "Budangudi B.O": "608702",
      "Kavalakudi B.O": "608702",
      "Kuduveli B.O": "608305",
      "Mogaiyur B.O": "608305",
      "Perungalur B.O": "608305",
      "Vilagam B.O": "608305",
      "Kudimiyankuppam B.O": "607101",
      "Natham B.O": "607101",
      "Pythambadi B.O": "607101",
      "Sirugramam B.O": "607101",
      "Veerraperumanallur B.O": "607101",
      "Sedapalayam B.O": "607003",
      "Arasadikkuppam B.O": "607103",
      "Kiliruppu B.O": "607103",
      "Marungur B.O": "608703",
      "Melmampattu B.O": "607103",
      "Maligaimedu B.O": "607112",
      "Ambalavananpettai B.O": "607301",
      "Anukkampattu B.O": "607301",
      "T.Palayam B.O": "607301",
      "Adur Agaram B.O": "607302",
      "Arangamangalam B.O": "607302",
      "Chinnakannadi B.O": "607302",
      "Guruvappanpettai B.O": "607302",
      "Vehakollai B.O": "607302",
      "Virupakshi B.O": "607302",
      "Elumedu B.O": "607104",
      "Kalinjikuppam B.O": "607104",
      "Kongarayanur B.O": "607104",
      "Sholavalli B.O": "607105",
      "Vanpakkam B.O": "607105",
      "Kanisapakkam B.O": "607106",
      "Lakshminarayanapuram B.O": "607106",
      "Maligampattu B.O": "607106",
      "Karumbur B.O": "607108",
      "Oraiyur B.O": "607108",
      "Thattampalayam B.O": "607205",
      "Sathankuppam B.O": "607004",
      "Nathapattu B.O": "607109",
      "Erumbur B.O": "608704",
      "Marudur B.O": "608704",
      "M.Adhanur B.O": "608304",
      "Melakadambur B.O": "608304",
      "Nandesswaramangalam B.O": "608702",
      "Valakollai B.O": "608702",
      "Vattathur B.O": "608702",
      "Poondi B.O": "608703",
      "Rajendra Pattinam B.O": "608703",
      "Sri Adivaraganallur B.O": "608703",
      "Sri Pudur B.O": "608703",
      "Ammapettai B.O": "608401",
      "Athipatu B.O": "608401",
      "Karuppur B.O": "608401",
      "Salianthoppu B.O": "608401",
      "Periyakuppam B.O": "608801",
      "Poochimedu B.O": "608801",
      "Poovanikkuppam B.O": "608801",
      "Silambimangalam B.O": "608801",
      "Theerthanagiri B.O": "608801",
      "Edayarkuppam B.O": "607102",
      "Pachayankuppam B.O": "607003",
      "Akkarai Gori B.O": "607003",
      "Sellankuppam B.O": "607003",
      "Vasantharayanpalayam B.O": "607003",
      "Puliyur B.O": "607301",
      "Samattikuppam B.O": "607301",
      "Subramaniyapuram B.O": "607301",
      "Venkatampettai B.O": "607302",
      "Tirukandeeswaram B.O": "607105",
      "Sathipattu B.O": "607106",
      "Akkadavalli B.O": "607205",
      "Kattamuthupalayam B.O": "607205",
      "Sundaravandi B.O": "607401",
      "Karunguli B.O": "607303",
      "Maruvai B.O": "607303",
      "Moolakuppam B.O": "607303",
      "M.Pudur B.O": "607004",
      "Gunamangalam B.O": "607109",
      "Kalaiyur B.O": "607109",
      "Periyanellikkollai B.O": "608704",
      "Chettithangal B.O": "608304",
      "Eyyalur B.O": "608304",
      "Sirukattur B.O": "608304",
      "Agara Alambadi B.O": "608702",
      "Kumarakudi B.O": "608702",
      "Kunamangalam B.O": "608703",
      "Nagarapadi B.O": "608703",
      "Srinedunjeri B.O": "608703",
      "Alkondanatham B.O": "608305",
      "Kothavasal B.O": "608305",
      "Terkuviruthangam B.O": "608305",
      "Vaiyur B.O": "608401",
      "Andarmullipallam B.O": "607101",
      "Aviyanur B.O": "607101",
      "Manamthavizhnthaputhur B.O": "607101",
      "Pallavarayanatham B.O": "607102",
      "Silambinathanpettai B.O": "607102",
      "Annavalli B.O": "607003",
      "Vellakarai B.O": "607003",
      "Erumanur B.O": "606003",
      "Mathur B.O": "606104",
      "Thoravalur B.O": "606003",
      "Kathazhai B.O": "606103",
      "Nadukkuppam B.O": "607103",
      "Melkavrapattu B.O": "607112",
      "Suba Uppalavadi B.O": "607006",
      "Krishnankuppam B.O": "607301",
      "Madanagopalapuram B.O": "607301",
      "Thondamanatham B.O": "607301",
      "Vasanankuppam B.O": "607301",
      "Kalkunam B.O": "607302",
      "Pethanaickenkuppam B.O": "607302",
      "Perumalnaickenpalayam B.O": "607104",
      "Kilmampattu B.O": "607106",
      "Semokottai B.O": "607106",
      "Siruvathur B.O": "607106",
      "Enathirimangalam B.O": "607108",
      "Capperquary B.O": "607005",
      "Sangolikuppam B.O": "607005",
      "Pulavanur B.O": "607205",
      "Varinjipakkam B.O": "607205",
      "Serakuppam B.O": "607303",
      "Vanathirayapuram B.O": "607303",
      "Marudadu B.O": "607109",
      "Vellapakkam B.O": "607109",
      "Kilapalaiyur B.O": "606103",
      "Sathukudal B.O": "606110",
      "Karmangudi B.O": "606110",
      "Ko Pavalangudi B.O": "606104",
      "Mukhasaparur B.O": "606104",
      "Sethuvarayankuppam B.O": "606203",
      "Aladi B.O": "606115",
      "Palakollai B.O": "606115",
      "Ambapuram B.O": "608704",
      "Vadathalaikulam B.O": "608704",
      "Valayamadevi B.O": "608704",
      "Kanjankollai B.O": "608304",
      "Mudikandanallur B.O": "608702",
      "Nangudi B.O": "608702",
      "Veeramudayanatham B.O": "608702",
      "Kavanur B.O": "608703",
      "Kozhai B.O": "608703",
      "Sri Vakkaramari B.O": "608703",
      "Kandakumaran B.O": "608305",
      "Vadakkumangudi B.O": "608401",
      "Adinarayananpuram B.O": "608801",
      "Thiyagavalli B.O": "608801",
      "Alagaperumalkuppam B.O": "607101",
      "Badrakottai B.O": "607102",
      "N.Moolakuppam B.O": "607102",
      "Naduveerappattu B.O": "607102",
      "Palur B.O": "607102",
      "Kodukkanpalayam B.O": "607003",
      "Valisodanaipalayam B.O": "607003",
      "Siruthondamadevi B.O": "607103",
      "Pagandai B.O": "607112",
      "Gundu Uppalavadi B.O": "607006",
      "Ayikuppam B.O": "607301",
      "Kundiyamallur B.O": "607301",
      "Valudalampattu B.O": "607301",
      "Kilur B.O": "607302",
      "Sornavur Melpathi B.O": "607104",
      "Kilarungunam B.O": "607105",
      "Gudithangi B.O": "607105",
      "Anguchettipalayam B.O": "607106",
      "Panikuppam B.O": "607106",
      "Semmedu B.O": "607106",
      "Tiruvamur B.O": "607106",
      "Bandarakottai B.O": "607108",
      "Poondiyankuppam B.O": "607005",
      "Kandrakottai B.O": "607205",
      "Kumaramangalam B.O": "607205",
      "Padirikuppam B.O": "607401",
      "Tirumanikuzhi B.O": "607401",
      "Vadakuthu B.O": "607303",
      "Alaginatham B.O": "607109",
      "S. Naraiyur B.O": "606301",
      "Irulakurichi B.O": "606115",
      "Cuddalore H.O": "607001",
      "Vriddhachalam H.O": "606001",
      "Chidambaram H.O": "608001",
      "Chidambaram Cutcherry S.O": "608001",
      "Chidambaram West S.O": "608001",
      "Kattumannarkoil S.O": "608301",
      "Keerapalayam S.O": "608602",
      "Neyveli Second Mines S.O": "607802",
      "Neyveli Thermal Bus Stand S.O": "607807",
      "Pinnalur S.O": "608704",
      "Reddiyur S.O": "608304",
      "Kammapuram S.O": "606103",
      "Mangalur S.O": "606108",
      "Nallur S.O (Cuddalore)": "606302",
      "Vriddhachalam Cutchery S.O": "606001",
      "Sirupakkam S.O": "606109",
      "Srimushnam S.O": "608703",
      "Alapakkam S.O": "608801",
      "Cuddalore Old Town S.O": "607003",
      "Kadambuliyur S.O": "607103",
      "Annamalainagar S.O": "608002",
      "Kullanchavadi S.O": "607301",
      "Sipcot Cuddalore S.O": "607005",
      "Tiruppadiripuliyur Bazaar S.O": "607002",
      "Annamalai University S.O": "608002",
      "Bhuvanagiri S.O": "608601",
      "Block 18, Neyveli S.O": "607803",
      "Block 5, Neyveli S.O": "607803",
      "Chidambaram East S.O": "608001",
      "Killai S.O": "608102",
      "Komaratchi S.O": "608302",
      "Neyveli 3 S.O": "607803",
      "Parangipettai S.O": "608502",
      "Perperiyankuppam S.O": "607805",
      "Vallampadugai S.O": "608401",
      "Gandhi Nagar S.O (Cuddalore)": "607308",
      "Kilkavarappattu S.O": "607112",
      "Kondur S.O": "607006",
      "Manjakkuppam S.O": "607001",
      "Nellikuppam Bazaar S.O": "607105",
      "Panruti East S.O": "607106",
      "Panruti West S.O": "607106",
      "Tiruvendhipuram S.O": "607401",
      "Vadalur S.O": "607303",
      "Oomangalam S.O": "607804",
      "Pennadam R.S. S.O": "606111",
      "Tittagudi S.O": "606106",
      "Toludur S.O": "606303",
      "Veppur (SA) S.O": "606304",
      "Ayangudi S.O": "608306",
      "Block 1, Neyveli S.O": "607801",
      "Block 10,neyveli S.O": "607801",
      "Block 24, Neyveli S.O": "607801",
      "Block 26, Neyveli S.O": "607803",
      "Neyveli 2 S.O": "607802",
      "Orathur S.O": "608201",
      "Chinnapanaickenpalayam S.O": "607102",
      "Cuddalore Ot Bazaar S.O": "607003",
      "Fort St.David S.O": "607001",
      "Melpattambakkam S.O": "607104",
      "Puthupet (CDL) S.O": "607108",
      "Vandipalayam S.O": "607004",
      "Budamur S.O": "606003",
      "Karuvepilankurichi S.O": "606110",
      "Mangalam (SA) S.O": "606104",
      "Pennadam S.O": "606105",
      "Vriddhachalam Bazaar S.O": "606001",
      "B.Mutlur S.O": "608501",
      "Block 29, Neyveli S.O": "607807",
      "Lalpet S.O": "608303",
      "Neyveli 1 S.O": "607801",
      "Neyveli II Thermal Station S.O": "607807",
      "Palayamkottai(CDL) S.O": "608701",
      "Sethiathope S.O": "608702",
      "T.Nedunjeri S.O": "608305",
      "Cuddalore Court Buildings S.O": "607001",
      "Cuddalore Port S.O": "607003",
      "Cuddalore Public Offices S.O": "607001",
      "Kurinjipadi S.O": "607302",
      "Nellikkuppam S.O": "607105",
      "Panruti S.O": "607106",
      "Semmandalam S.O": "607001",
      "Tirupadiripuliyur S.O": "607002",
      "Tiruppadiripuliyur West S.O": "607002",
      "Tiruthuraiyur S.O": "607205",
      "Varakalpattu S.O": "607109"
    },
    "KALLAKURICHI": {
      "Asakalathur B.O": "606204",
      "Eyyanur B.O": "606204",
      "Maligaimedu B.O": "606204",
      "Mandagapadi B.O": "606205",
      "Pasar B.O": "606205",
      "Seedevi B.O": "606205",
      "Kilakkadu B.O": "606401",
      "Perumbur B.O": "606401",
      "Soundaravallipalayam B.O": "606401",
      "Vanjikuli B.O": "606401",
      "Sithalur B.O": "606206",
      "Timmalai B.O": "606206",
      "Vengaivadi B.O": "606206",
      "Kanaiyar B.O": "606107",
      "Moolasamudram B.O": "606107",
      "Eduthavainatham B.O": "606207",
      "Olagiyanallur B.O": "606204",
      "Komalur B.O": "606205",
      "La  Gudalur B.O": "606205",
      "Munivalai B.O": "606205",
      "Sathaputhur B.O": "606205",
      "Arasampattu B.O": "606401",
      "Kosapadi B.O": "606401",
      "Pootai B.O": "606401",
      "Poykunam B.O": "606401",
      "Thekkampattu B.O": "606401",
      "Prithivimangalam B.O": "606206",
      "Tiyagai B.O": "606206",
      "Vadathorasalur B.O": "606206",
      "Pu.Mambakkam B.O": "606107",
      "Pu killanur B.O": "606107",
      "Pu konalavadi B.O": "606107",
      "Puliyur B.O": "606107",
      "Perumangalam B.O": "606204",
      "S. Ohaiyur B.O": "606204",
      "Thensiruvalur B.O": "606204",
      "Thenthorasalur B.O": "606204",
      "Sikkadu B.O": "606205",
      "Pudupalapattu B.O": "606401",
      "Serapattu B.O": "606401",
      "Vengodu B.O": "606401",
      "Palayasiruvangur B.O": "606206",
      "Pallagacherry B.O": "606206",
      "Peelamedu B.O": "606206",
      "Periyamampattu B.O": "606206",
      "Anganur B.O": "606107",
      "Semmanangur B.O": "606107",
      "Vellaiyur B.O": "606107",
      "Kachirapalayam B.O": "606207",
      "Karadichittur B.O": "606207",
      "Iriyur B.O": "606204",
      "Nurolai B.O": "606205",
      "Mottampatti B.O": "606401",
      "Vellarikadu B.O": "606401",
      "Madur B.O": "606206",
      "Sulankurichi B.O": "606206",
      "Veeracholapuram B.O": "606206",
      "Vilakkur B.O": "606206",
      "Edaikkal B.O": "606107",
      "Madiyanur B.O": "606107",
      "Chellampattu B.O": "606207",
      "Eruvaipattinam B.O": "606207",
      "Pottiyam B.O": "606207",
      "Manmalai B.O": "606207",
      "Mattaparai B.O": "606207",
      "Madavacherry B.O": "606207",
      "Madhur B.O": "606209",
      "Malliyapadi B.O": "606207",
      "Mathur B.O": "606207",
      "Kariyalur B.O": "606209",
      "Vengur B.O": "605751",
      "Eduthanur B.O": "605802",
      "Elayanarkuppam B.O": "605802",
      "Sirpadanallur B.O": "605802",
      "Sirpanandal B.O": "605802",
      "Karadi B.O": "605766",
      "Kuvanur B.O": "605766",
      "T Athipakkam B.O": "605759",
      "Thagadi B.O": "605766",
      "Perumbakkam B.O": "607204",
      "Sendanadu B.O": "607204",
      "Vanampattu B.O": "607204",
      "Kodumathi B.O": "606209",
      "Kottapudur B.O": "606209",
      "Maniyampalayam B.O": "606209",
      "Uppur B.O": "606209",
      "Kaduvanur B.O": "605801",
      "Maiyanur B.O": "605801",
      "Periyakolliyur B.O": "605801",
      "Cholavandipuram B.O": "605751",
      "Memalur B.O": "605751",
      "Devaradiyarkuppam B.O": "605754",
      "Jambai B.O": "605754",
      "Aruthangudi B.O": "605766",
      "Tiruppalapandal B.O": "605766",
      "Eswarakandanallur B.O": "607204",
      "Irundai B.O": "607204",
      "Madapattu B.O": "607204",
      "Venkatampettai B.O": "606207",
      "Arampoondi B.O": "606209",
      "Mundiyur B.O": "606209",
      "Nochimedu B.O": "606209",
      "Vazhapadi B.O": "606209",
      "Pakkam B.O": "605801",
      "Kattu Edaiyur B.O": "605751",
      "Padiyandal B.O": "605751",
      "Kangeyanur B.O": "605754",
      "Murukkambadi B.O": "605754",
      "Keelathalanur B.O": "605766",
      "Kuladeepamangalam B.O": "605756",
      "Kizakkumarudur B.O": "607204",
      "Parikkal B.O": "607204",
      "Somasipalayam B.O": "607101",
      "Innadu B.O": "606209",
      "Thoradipattu B.O": "606209",
      "Endal B.O": "605801",
      "Tholuvanthangal B.O": "605801",
      "Pazhangur B.O": "605751",
      "Tiruvarangam B.O": "605802",
      "Kazhumalam B.O": "605754",
      "Sangiyam B.O": "605754",
      "Valayampattu B.O": "607107",
      "T  . Kolathur B.O": "607209",
      "Deviagaram B.O": "605766",
      "Kattupaiyur B.O": "605766",
      "Madam B.O": "605759",
      "Vilandai B.O": "605756",
      "Periyakuppam B.O": "607204",
      "Sendamangalam B.O": "607204",
      "Eranji B.O": "606305",
      "Gurupeedapuram B.O": "606305",
      "Pethanur B.O": "606201",
      "Pinnalavadi B.O": "607202",
      "Pu malayanur B.O": "607202",
      "Tiruppayar B.O": "606305",
      "Kaniyamur B.O": "606201",
      "Melnariyappanur B.O": "606201",
      "Moongilpadi B.O": "606201",
      "Siruvathur B.O": "606201",
      "Thengiyanatham B.O": "606201",
      "Kunjaram B.O": "607201",
      "Attur B.O": "606102",
      "Kiliyur B.O": "606102",
      "Kuvagam B.O": "606102",
      "Ma kunnathur B.O": "606102",
      "Thachur B.O": "606213",
      "Thenkeeranur B.O": "606213",
      "B. Arulambadi B.O": "605702",
      "Pudu Uchimedu B.O": "606203",
      "Varanjaram B.O": "606203",
      "Virugavur B.O": "606203",
      "Anumanandal B.O": "606301",
      "Karunthalakurichi B.O": "606301",
      "Kugaiyur B.O": "606301",
      "V  Mamandur B.O": "606301",
      "Koo kallakurichi B.O": "606115",
      "Arur B.O": "606402",
      "Lakkinayakkanpatti B.O": "606402",
      "Mookanur B.O": "606402",
      "Sembiamadevi B.O": "607202",
      "Adaiyur B.O": "607201",
      "Ellaigramam B.O": "607201",
      "Adhanur B.O": "606102",
      "Nathamur B.O": "606102",
      "Agarakottalam B.O": "606213",
      "Nallathur B.O": "606213",
      "Olagankathan B.O": "606213",
      "Siruvangur B.O": "606213",
      "Pounjipattu B.O": "605702",
      "Kilapattu B.O": "606208",
      "Manjaputhur B.O": "606208",
      "Nedumanur B.O": "606208",
      "S.Kolathur B.O": "606402",
      "Viriyur B.O": "606402",
      "Ammakalathur B.O": "606204",
      "Koothakudi B.O": "606305",
      "Parindal B.O": "606305",
      "Dagamtheerthapuram B.O": "606201",
      "Melur B.O": "606201",
      "Paithanthurai B.O": "606201",
      "Thottiyam B.O": "606201",
      "Kuvadu B.O": "607201",
      "Periyakurukkai B.O": "607201",
      "Nannaram B.O": "606102",
      "Pandur B.O": "606102",
      "Kudiraichandal B.O": "606213",
      "Somandargudi B.O": "606213",
      "Vilambar B.O": "606213",
      "Brammakundam B.O": "605702",
      "Melsiruvallur B.O": "605702",
      "Alathur B.O": "606208",
      "Kongarayapalayam B.O": "606203",
      "Mudiyanur B.O": "606203",
      "Pakkampadi B.O": "606301",
      "V  Alambalam B.O": "606301",
      "Ninnaiyur B.O": "606305",
      "T.Mavidanthal B.O": "606305",
      "Ammaiagaram B.O": "606201",
      "Pandiyankuppam B.O": "606201",
      "Vettiperumalagaram B.O": "606201",
      "Senkurichi B.O": "606115",
      "Pudupattu B.O": "606402",
      "Rangappanur B.O": "606402",
      "Pugaipatti B.O": "607202",
      "Pallavadi B.O": "607201",
      "Orathur B.O": "606102",
      "Velur B.O": "606102",
      "K.Alambalam B.O": "606213",
      "Neelamangalam B.O": "606213",
      "Thandalai B.O": "606213",
      "Irudayampattu B.O": "605702",
      "Michaelpuram B.O": "605702",
      "Porasapattu B.O": "605702",
      "Vadaponparappi B.O": "605702",
      "Cholampattu B.O": "606208",
      "Malaikottalam B.O": "606203",
      "Porasakurichi B.O": "606203",
      "Thottapadi B.O": "606301",
      "Puthirampattu B.O": "606402",
      "Ravathanallur B.O": "606402",
      "Kallakurichi H.O": "606202",
      "Tirukkoyilur H.O": "605757",
      "Asanur S.O": "606305",
      "Elavanasur S.O": "607202",
      "Moongilthuraipattu S.O": "605702",
      "Vellimalai S.O": "606209",
      "Manampoondi S.O": "605759",
      "Kalamarudur S.O": "606102",
      "Murarbad S.O": "606208",
      "Tiyagadrug S.O": "606206",
      "Vadakkanandal S.O": "606207",
      "Ariyalur (Villupuram) S.O": "605801",
      "Kadambur S.O (Villupuram)": "605802",
      "Manalurpet S.O": "605754",
      "Santhapettai S.O": "605766",
      "Tirukkoyilur Bazaar S.O": "605757",
      "Chinnasalem S.O": "606201",
      "Nagalur S.O": "606203",
      "Nainarpalayam S.O": "606301",
      "Rishivandiyam S.O": "606205",
      "Ulundurpet Busstand S.O": "606107",
      "Ulundurpet S.O": "606107",
      "Ariyur S.O (Villupuram)": "605751",
      "Eraiyur S.O (Villupuram)": "607201",
      "Kallakurichi South S.O": "606213",
      "Padur S.O": "606115",
      "Pandalam S.O (Villupuram)": "606402",
      "Pukkiravari S.O": "606204",
      "Sankarapuram (Villupuram) S.O": "606401",
      "Tirunavalur S.O": "607204"
    },
    "Ariyalur": {
      "Kunamangalam BO": "621701",
      "Nagamangalam BO": "621701",
      "Sripurandan BO": "621701",
      "Pungangudi BO": "621701",
      "Sathambadi BO": "621701",
      "Ulliakudi BO": "621701",
      "Periyanagalur BO": "621704",
      "Telur BO": "621704",
      "Valajanagaram BO": "621704",
      "Varanavasi BO": "621704",
      "Thuthur BO": "621701",
      "Hasthinapuram BO": "621704",
      "Kavanur BO": "621704",
      "Vilangudi BO": "621704",
      "Alathiyur BO": "621719",
      "Govindaputhur BO": "621701",
      "Kadambur BO": "621701",
      "Kasankottai BO": "621701",
      "Pattanamkurichi BO": "621801",
      "Siruvalur BO": "621704",
      "Subbarayapuram BO": "621704",
      "Thavuthaikulam BO": "621704",
      "Kodukkur BO": "621719",
      "Muthuvancheri BO": "621701",
      "Periyattirukonam BO": "621701",
      "Sundakudi BO": "621701",
      "Inamattur BO": "621704",
      "Periyavenmani BO": "621704",
      "Adhanakurichi BO": "621719",
      "Edayakurichi BO": "621719",
      "Vanavanallur BO": "612901",
      "Periyavalayam BO": "621802",
      "Kokkudi BO": "621653",
      "Methal BO": "621653",
      "Palanganatham BO": "621651",
      "Ayanathur BO": "621705",
      "Kadugur BO": "621705",
      "Anikduichan BO": "621803",
      "Silambur BO": "608901",
      "Karuppilakattalai BO": "621707",
      "Malathankulam BO": "621707",
      "Vettiyur BO": "621707",
      "Devamangalam BO": "612902",
      "Solamadevi BO": "612902",
      "Manapathur BO": "621709",
      "Kattagaram BO": "612903",
      "Melanikuli BO": "612903",
      "Vangudi BO": "612903",
      "Marudur BO": "621710",
      "PKudikadu BO": "621710",
      "Sirukalathur BO": "621710",
      "Anandavadi BO": "621718",
      "Poyyadhanallur BO": "621718",
      "Neivanam BO": "621714",
      "Vanjinapuram BO": "621714",
      "Irugaiyur BO": "612904",
      "Karaikurichi BO": "612904",
      "Keelamichaelpatti BO": "612904",
      "Koilesanai BO": "621851",
      "Venganur BO": "621851",
      "Elakurichi BO": "621715",
      "Sullangudi BO": "621715",
      "Kilaveli BO": "621804",
      "Palayakudi BO": "621804",
      "Pilichikuli BO": "621804",
      "Kilaneduvoi BO": "621805",
      "Kandiankollai BO": "621806",
      "Manakudayan BO": "621719",
      "Periyakurichi BO": "621719",
      "Thular BO": "621719",
      "Dalavoy BO": "621730",
      "Sannasinallur BO": "621730",
      "Siluppanur BO": "621730",
      "Kidaramkondan BO": "612901",
      "Kollapuram BO": "612901",
      "Meikavalputhur BO": "612901",
      "Pichanur BO": "612901",
      "Thaluthalaimedu BO": "612901",
      "Vanarathirayankuppam BO": "612901",
      "Chinnavalayam BO": "621802",
      "Kaluvanthondi BO": "621802",
      "Srinivasapuram BO": "621705",
      "Tamaraikulam BO": "621705",
      "Eravangudi BO": "621803",
      "Kalleri BO": "621803",
      "Kattathur BO": "621803",
      "Attukurichi BO": "608901",
      "Ayyur BO": "608901",
      "Nagampandal BO": "608901",
      "Olaiyur BO": "608901",
      "Anganur BO": "621709",
      "Alathipallam BO": "612903",
      "Ayyappanaickenpettai BO": "612903",
      "Kilamaligai BO": "621710",
      "Ameenabad BO": "621713",
      "Annanagar BO": "621713",
      "Govindapuram BO": "621713",
      "Adhikudikadu BO": "621714",
      "Elangaicheri BO": "621714",
      "Nakkambadi BO": "621714",
      "Naduvalur BO": "612904",
      "Thengachiperumalnatham BO": "612904",
      "Arungal BO": "621707",
      "Edayathangudi BO": "621707",
      "Karuppur Senapathy BO": "621707",
      "Suthamalli BO": "621707",
      "Udayanatham BO": "612902",
      "Padanilai BO": "612903",
      "Pappakudi BO": "612903",
      "Saluppai BO": "612903",
      "Sedankudikadu BO": "621710",
      "Therkupatti BO": "621710",
      "Vallam BO": "621710",
      "Manakkal Ariyalur BO": "621713",
      "Pottaveli BO": "621718",
      "Sennivanam BO": "621718",
      "Vellur BO": "621718",
      "Unjini BO": "621714",
      "Idanganni BO": "612904",
      "Kaduvettankurichi BO": "612904",
      "Irumbilikurichi BO": "621804",
      "Kumiliam BO": "621804",
      "Managethi BO": "621804",
      "Paranam BO": "621804",
      "Parukkal BO": "621804",
      "Zamin Suthamalli BO": "621804",
      "Pilakurichi BO": "621806",
      "Pudukudi BO": "621806",
      "Ayuthakalam BO": "612901",
      "Kilakudiyiruppu BO": "621802",
      "Sengunthapuram BO": "621802",
      "Poondi BO": "621653",
      "Lingathadimedu BO": "621705",
      "O Koothur BO": "621705",
      "Kumiliankuli BO": "621803",
      "Vettiarvettu BO": "621803",
      "Aranmanaikurichi BO": "621851",
      "Ilandaikudam BO": "621851",
      "Kilakolathur BO": "621715",
      "Kovilur BO": "621715",
      "Kuruvadi BO": "621715",
      "Tiruppeyar BO": "621715",
      "Tattanur BO": "621804",
      "Udayarpalayam West BO": "621804",
      "Vanathirayanpattinam BO": "621804",
      "Venmankondan BO": "621804",
      "Thennur BO": "621805",
      "Tirukalappur BO": "621805",
      "Devanur BO": "621806",
      "ZMelur BO": "621803",
      "Alagapuram BO": "608901",
      "Rangiam BO": "608901",
      "Kilaiyur BO": "621707",
      "Anaikudam BO": "612902",
      "Kodali BO": "612902",
      "Ayantattanur BO": "621709",
      "Solankudikadu BO": "621709",
      "Ilayaperumanallur BO": "612903",
      "Kundaveli BO": "612903",
      "Muthuservaimadam BO": "612903",
      "Kuvagam BO": "621710",
      "Maruvathur BO": "621710",
      "Iluppaiyur BO": "621718",
      "Kulumur BO": "621714",
      "Nallampalayam BO": "621714",
      "Kargudi BO": "612904",
      "Kottiyal BO": "612904",
      "Vazhaikurichi BO": "612904",
      "Kandirathitham BO": "621851",
      "PudukkottaiTirumalaivadi BO": "621851",
      "Alagiamanavalam BO": "621715",
      "Kamarasavalli BO": "621715",
      "Kilakavattankurichi BO": "621715",
      "Manjamedu Karaipakkam BO": "621715",
      "Edayar BO": "621804",
      "Nayanganaipiriyal BO": "621804",
      "TSolankurichi BO": "621804",
      "Periakrishnapuram BO": "621805",
      "Ilaiyur BO": "621806",
      "Nagalkuli BO": "621806",
      "Kuruvalapparkoil BO": "612901",
      "Angarayanallur BO": "621802",
      "Karadikulam BO": "621802",
      "Sannavur BO": "621651",
      "Manakudi BO": "621705",
      "Ottakoil BO": "621705",
      "Koovathur BO": "621803",
      "Kulathur BO": "621803",
      "Vadugarpalayam BO": "621803",
      "Vizhapallam BO": "621803",
      "Sriraman B.O": "608703",
      "Namangunam B.O": "621716",
      "Ariyalur Bazaar SO": "621704",
      "Asaveerankudikadu SO": "621719",
      "Kodalikaruppur SO": "612902",
      "Thathampettai Palur SO": "612904",
      "Ulkottai SO": "612905",
      "Reddipalayam SO": "621731",
      "Ariyalur Cement Factory SO": "621729",
      "Cement Nagar Dalavoy SO": "621730",
      "JC Puram West SO": "621802",
      "Kallathur Thandalai SO": "621803",
      "Kavarapalayam SO": "608901",
      "Ponparappi SO": "621710",
      "Rayambaram SO": "621718",
      "Udayarpalayam SO Ariyalur": "621804",
      "Variyankaval SO": "621806",
      "Andimadam SO": "621801",
      "Gangaikondacholapuram SO": "612901",
      "Kallankurichi SO": "621705",
      "Kilapaluvur SO": "621707",
      "Mathur SO Ariyalur": "621709",
      "Rajajinagar SO Ariyalur": "621713",
      "Sendurai SO Ariyalur": "621714",
      "Thirumazhapadi SO": "621851",
      "Tirumanur SO": "621715",
      "Varadarajampettai SO": "621805",
      "Ambapur SO": "621701",
      "Ariyalur Ariyalur SO": "621704",
      "Jayamkondacholapuram SO": "621802",
      "Minsuritti SO": "612903"
    },
    "NAGAPATTINAM": {
      "Pillali B.O": "609704",
      "Tirupugalur B.O": "609704",
      "Tiruvoimur B.O": "610204",
      "Ettukudi B.O": "610204",
      "Andakudi B.O": "610106",
      "Sigar B.O": "610106",
      "Koilkannapur B.O": "610207",
      "Kolapadu B.O": "610207",
      "Koorathangudi B.O": "610207",
      "Terkupanaiyur B.O": "610207",
      "Tiruchenkattangudi B.O": "609704",
      "Melavazhakarai B.O": "610204",
      "Kilvelur Bazar B.O": "611104",
      "Kodiyampalayam B.O": "608002",
      "Kohur B.O": "611104",
      "Iluppur B.O": "611105",
      "Kurukathi B.O": "611105",
      "Serunallur B.O": "611105",
      "Akkaraipettai B.O": "611106",
      "Vadakkupoigainallur B.O": "611106",
      "Alathur B.O": "609604",
      "Avaranipuducherri B.O": "611108",
      "Orathur B.O": "611108",
      "Puliyur B.O": "611108",
      "Killukudi B.O": "611109",
      "Polagam B.O": "609702",
      "Venmanachery B.O": "611103",
      "Tirukannangudi B.O": "611104",
      "Athipuliyur B.O": "611105",
      "Eravancherry B.O": "611105",
      "Palpannaichery B.O": "611003",
      "Panangudi B.O": "611002",
      "Mohanur B.O": "611109",
      "Palakurichi B.O": "611109",
      "Kameswaram B.O": "611110",
      "Karapidagai B.O": "611110",
      "Tirupundi South B.O": "611110",
      "Gopurajapuram B.O": "609703",
      "Pragramam B.O": "609703",
      "Prathabaramapuram B.O": "611111",
      "Vellapallam B.O": "611112",
      "Vilundamavadi B.O": "611112",
      "Mutharasapuram B.O": "610201",
      "Vadamalaimanakadu B.O": "614716",
      "Maracheri B.O": "614711",
      "Umbalacheri B.O": "614711",
      "Marudur Vadakku Sethi B.O": "614714",
      "Panchanathikulam East B.O": "614714",
      "Panchanathikulam Nadu Sethi B.O": "614714",
      "Uvoimedu B.O": "614714",
      "Manakudi B.O": "614712",
      "Pirinjimulai B.O": "614712",
      "Suramangalam B.O": "610201",
      "Tirupayathangudi B.O": "610101",
      "Madapuram B.O": "611103",
      "Pattamangalam B.O": "611104",
      "Aliyur B.O": "611104",
      "Muttam B.O": "611002",
      "Okkur B.O": "611002",
      "Sengamangalam B.O": "611108",
      "Erayangudi B.O": "611109",
      "Sembianmahadevi B.O": "611109",
      "Vadugachery B.O": "611109",
      "Ervadi B.O": "609702",
      "Vailankanni West B.O": "611111",
      "Naluvedapathy B.O": "611112",
      "Pudupalli B.O": "611112",
      "Kakkalani B.O": "611101",
      "Pakkamkottur B.O": "609701",
      "Vadagarai B.O": "609701",
      "Kottarakudi B.O": "610101",
      "Sithaimur B.O": "610203",
      "Adanur B.O": "614707",
      "Ayakkarambalam I Sethi B.O": "614707",
      "Kadinavayal B.O": "614707",
      "Rajapuram B.O": "614806",
      "Katripulam B.O": "614808",
      "Nagakudaiyan B.O": "614808",
      "Pushpavanam B.O": "614809",
      "Sembodai B.O": "614809",
      "Thethakudi Therkusethi B.O": "614809",
      "Thethakudivadakkusethi B.O": "614809",
      "Aymazhai B.O": "611102",
      "Chinnathumbur B.O": "611102",
      "Nirthanamangalam": "611102",
      "Pannal B.O": "614707",
      "Kariyapattinam R.S B.O": "614806",
      "Thennampulam B.O": "614806",
      "Kodiakkadu B.O": "614807",
      "Neivilakku B.O": "614808",
      "Arunthavambulam B.O": "614711",
      "Nathapallam B.O": "614711",
      "Thulasapuram B.O": "614711",
      "Marudur Therkusethi B.O": "614714",
      "Panchanathikulam B.O": "614714",
      "Thulajapattinam B.O": "614714",
      "Vanduvancheri B.O": "614714",
      "Talanayar IV Sethi B.O": "614712",
      "Arkattuthurai B.O": "614809",
      "Periyakuthagai B.O": "614809",
      "Yadhavapuram B.O": "614809",
      "Agasthiampalli B.O": "614810",
      "Alangudichery B.O": "609703",
      "P.Kondagai B.O": "609703",
      "Serudur B.O": "611111",
      "Kilathanjavur B.O": "610101",
      "Virkudi B.O": "610101",
      "Solavidyapuram B.O": "611103",
      "Palaiyur B.O": "611106",
      "Melavanjore B.O": "611002",
      "Narimanam B.O": "611002",
      "Perunkadambanur B.O": "611108",
      "Poravacherry B.O": "611108",
      "Kilathanilapadi B.O": "611109",
      "Radhamangalam B.O": "611109",
      "Marungur B.O": "609702",
      "Seeyathamangai B.O": "609702",
      "Seshamoolai B.O": "609702",
      "Ambal B.O": "609503",
      "Papakoil B.O": "611102",
      "Ayakkarambalam III Sethi B.O": "614707",
      "Karuppanpulam B.O": "614707",
      "Avarikadu B.O": "614806",
      "Chettipulam B.O": "614806",
      "Pirandiankarai B.O": "614806",
      "Senbagarayanallur B.O": "614806",
      "Thanikottagam B.O": "614716",
      "Panayadikuthagai B.O": "614808",
      "Aymoor B.O": "614711",
      "Neermulai B.O": "614711",
      "Annapettai B.O": "614714",
      "Talanayar III Sethi B.O": "614712",
      "Vadugur B.O": "614712",
      "Kallimodu B.O": "614809",
      "Maraignanallur B.O": "614810",
      "Agara Kondagai B.O": "609703",
      "Terkupoigainallur B.O": "611111",
      "Koilpathu B.O": "611112",
      "Karaiyur B.O": "610101",
      "Karunkanni B.O": "611103",
      "Vayalur B.O": "612201",
      "Nagapattinam H.O": "611001",
      "Durgashariff S.O": "611002",
      "Nagapattinam Bazaar S.O": "611001",
      "Nagore S.O": "611002",
      "Kilvelur S.O": "611104",
      "Kodiakkarai S.O": "614807",
      "Kuruvapulam S.O": "614808",
      "Takattur S.O": "614714",
      "Vedaraniam S.O": "614810",
      "Manjakollai S.O": "611106",
      "Andanapettai S.O": "611102",
      "Kilaiyur (Tiruvarur) S.O": "611103",
      "Kuthur S.O": "611105",
      "Nagapattinam Collectorate S.O": "611003",
      "Kariyapattinam S.O": "614806",
      "Sikkal S.O (Nagapattinam)": "611108",
      "Tittachery S.O": "609703",
      "Kangalanchery S.O": "610101",
      "Thevur S.O (Nagapattinam)": "611109",
      "Tirupundi S.O": "611110",
      "Sannanallur S.O": "609504",
      "Tirukuvalai S.O": "610204",
      "Valivalam S.O": "610207",
      "Tirukannapuram S.O": "609704",
      "Tirumarugal S.O": "609702",
      "Vailankanni S.O": "611111",
      "Velippalayam S.O": "611001",
      "Talanayar Agraharam S.O": "614712",
      "Topputhurai S.O": "614809",
      "Nagore South S.O": "611002",
      "Vettaikaraniruppu S.O": "611112",
      "Enangudi S.O": "609701",
      "Ayakkarambalam Ii Sethi S.O": "614707"
    },
    "THANJAVUR": {
      "Orathur B.O": "613602",
      "Pookkara Street B.O": "613001",
      "Mohamed Bunder B.O": "613201",
      "Tiruchottuthurai B.O": "613202",
      "Kurungulam B.O": "613303",
      "Thethuvasalpatti B.O": "613303",
      "Arisikara Street B.O": "613001",
      "Thanjavur South B.O": "613001",
      "Kulichapattu B.O": "613501",
      "Melakalakudi B.O": "613501",
      "Kovilur (Pundi Tj) B.O": "613502",
      "Kumilakudi B.O": "613502",
      "Nallavanniyankudikadu B.O": "613502",
      "Vendayampatti B.O": "613402",
      "Kilathiruppanthuruthi B.O": "613103",
      "Ichangudi B.O": "613204",
      "Peramur B.O": "613204",
      "Ponavasal B.O": "613204",
      "Royampettai B.O": "613204",
      "Michaelpatti B.O": "613104",
      "Srinivasapuram B.O": "613009",
      "Pulavarnatham B.O": "613501",
      "Konerirajapuram B.O": "613101",
      "Varagur B.O": "613101",
      "Puduchatram B.O": "613105",
      "Vishnampettai B.O": "613105",
      "Jambugambalpuram B.O": "613502",
      "Melavasthachavadi B.O": "613005",
      "Kambayarnatham B.O": "613504",
      "Saliamangalam Bazaar B.O": "613504",
      "Manayeripatti B.O": "613402",
      "MGM Sanatorium B.O": "613402",
      "Palayapatti South B.O": "613402",
      "State Bank Colony B.O": "613004",
      "Marungulam B.O": "613006",
      "Vilar B.O": "613006",
      "Mukasakaduveli B.O": "613203",
      "Thiruvalampozhil B.O": "613103",
      "Thiruvaiyaru Thiyagaraja Colony B.O": "613204",
      "Veeramangudi B.O": "613204",
      "Vilangudi B.O": "613204",
      "Mekalathur B.O": "613102",
      "Sholagampatti B.O": "613102",
      "Elangadu TPL B.O": "613104",
      "Nemam B.O": "613104",
      "Vallam Pudur B.O": "613401",
      "Pillaiyarpatti B.O": "613403",
      "Palliagraharam B.O": "613003",
      "Tittai B.O": "613003",
      "Kalimedu B.O": "613002",
      "Sakkarasamandam B.O": "613002",
      "Aimbadumelnagaram B.O": "613101",
      "Allur B.O": "613101",
      "Inayathukkanpatti B.O": "613005",
      "Ganapathi Nagar B.O": "613007",
      "Arsuthipattu B.O": "613504",
      "Irumbuthalai B.O": "613504",
      "Kalancheri B.O": "613504",
      "Achampatti B.O": "613402",
      "Pudukudi B.O": "613402",
      "Manojipatti B.O": "613004",
      "Maruvur B.O": "613203",
      "Sathanur B.O": "609802",
      "Vaidyanathanpettai B.O": "613203",
      "Indalur B.O": "613102",
      "Kachamangalam B.O": "613102",
      "Kandamangalam B.O": "613104",
      "Kuthur B.O": "613104",
      "Maharajapuram B.O": "612503",
      "Chennampatti B.O": "613403",
      "Palanjore B.O": "614701",
      "Kannugudi Kilpathi B.O": "614901",
      "Pachiyur B.O": "614902",
      "Pinnaiyur B.O": "614902",
      "Poyyundarkottai B.O": "614902",
      "Sethurayankudikadu B.O": "614902",
      "Karambakadu B.O": "614802",
      "Marungapallam B.O": "614802",
      "Ilangadu B.O": "614903",
      "Kalyanaodai B.O": "614903",
      "Karuppur B.O": "609807",
      "Siramelkudi B.O": "614903",
      "Eripurakarai B.O": "614701",
      "Magilankottai B.O": "614701",
      "Nambivayal B.O": "614615",
      "Sandangadu B.O": "614615",
      "Sembalur B.O": "614901",
      "Sendankadu B.O": "614901",
      "Paingal B.O": "614623",
      "Cholapuram B.O": "614902",
      "Adirampattinam R.S B.O": "614701",
      "Rajamadam B.O": "614701",
      "Kilamangalam B.O": "614615",
      "Alampallam B.O": "614901",
      "Enathikarambai B.O": "614623",
      "Kakkaraikottai B.O": "614902",
      "Vadakkur B.O": "614902",
      "Sethubavachatram B.O": "614802",
      "Virayankottai B.O": "614802",
      "Andami B.O": "614903",
      "Pulavanji B.O": "614903",
      "Sarabendrarajanpattinam B.O": "614723",
      "Azhiavaikal B.O": "614904",
      "Valappakudi B.O": "613104",
      "Nagathi B.O": "613205",
      "Annappanpettai B.O": "613003",
      "Gudalur B.O": "613003",
      "Paruthikottai B.O": "614904",
      "Adambai B.O": "614602",
      "Nainankulam B.O": "614602",
      "Veppankulam B.O": "614906",
      "Kannandangudi B.O": "614625",
      "Orantharayankudikadu B.O": "614625",
      "Chokkanathapuram B.O": "614803",
      "Kandithampattu B.O": "614904",
      "Kasanadupudur B.O": "614904",
      "Kilauluvur B.O": "614904",
      "Kilavastachavadi B.O": "614904",
      "Sydambalpuram B.O": "614904",
      "Anaikadu B.O": "614602",
      "Kurichi B.O": "614602",
      "Maliyakadu B.O": "614602",
      "Mudalseri B.O": "614602",
      "Ponnavarayankottai B.O": "614602",
      "Pallikondan B.O": "614602",
      "Vendakottai B.O": "614906",
      "Kakkarai B.O": "614625",
      "Kannanthangudi Melaiyur B.O": "614625",
      "Kavarapattu B.O": "614625",
      "Pallathur B.O": "614803",
      "Royandur B.O": "613602",
      "Vennamangalam B.O": "613602",
      "Uthamanallur B.O": "613201",
      "Ponnavarai BO": "613201",
      "Tirukanurpatti B.O": "613303",
      "Raramuthirakottai B.O": "613501",
      "Sendalai B.O": "613101",
      "Vellamperambur B.O": "613101",
      "Koviladi TPL B.O": "613105",
      "Tiruchinampoondi B.O": "613105",
      "Palliyur B.O": "613504",
      "Suliyakottai B.O": "613504",
      "Muthandipatti B.O": "613402",
      "Rayamundanpatti B.O": "613402",
      "Ramanathapuram B.O": "613004",
      "Mukasa Nanjikottai B.O": "613006",
      "Parangivettikadu B.O": "614626",
      "Tirunallur Ond B.O": "614626",
      "Kalathur B.O": "612802",
      "Punaikuthikadu B.O": "614804",
      "Pudukottai Ullur B.O": "614701",
      "Enadi B.O": "614615",
      "Kannugudi B.O": "614901",
      "Mullurpattikadu B.O": "614901",
      "Ammaiyandi B.O": "614623",
      "Eachankottai B.O": "614902",
      "Karukadipatti B.O": "614902",
      "Sillathur Ktu B.O": "614902",
      "Vettikadu B.O": "614902",
      "Nadiyam B.O": "614802",
      "Umattanad B.O": "614802",
      "Kadanthankudi B.O": "614903",
      "Madukkur North B.O": "614903",
      "Periyakottai B.O": "614903",
      "Vikramam B.O": "614903",
      "Alagiyanayakipuram B.O": "614723",
      "Rendampulikadu B.O": "614723",
      "Nadur B.O": "614904",
      "Pulavankadu B.O": "614625",
      "Puvathur B.O": "614625",
      "Punavasal B.O": "614803",
      "Siruvalakadu B.O": "614803",
      "Ambalapattu B.O": "614626",
      "Ambalapattu North B.O": "614626",
      "Cholagankarai B.O": "614626",
      "Karambayam B.O": "614626",
      "Mudachikadu B.O": "614804",
      "Palaya Peravurni B.O": "614804",
      "Pinnavasal B.O": "614804",
      "AthikottaiB.O": "614906",
      "Moothakurichi B.O": "614906",
      "Okkanad Kilaiyur B.O": "614625",
      "Vellur ond B.O": "614626",
      "Karuppamanai B.O": "614804",
      "Mavadukurichi B.O": "614804",
      "Anaikudi B.O": "612105",
      "Someswarapuram B.O": "613204",
      "Tiruppayanam B.O": "613204",
      "Seyyamangalam B.O": "613102",
      "Mullakudi B.O": "613104",
      "Palamaneri B.O": "613104",
      "Renganathapuram B.O": "613104",
      "Tirumalaisamudram B.O": "613401",
      "Thanjavur Housing Unit B.O": "613007",
      "Ravusapatti B.O": "613403",
      "Arkadu B.O": "613205",
      "Kadakadappai B.O": "613003",
      "Ramapuram B.O": "613003",
      "Andikadu B.O": "614723",
      "Panchanathikottai B.O": "614904",
      "Ponnapur B.O": "614904",
      "Alivalam B.O": "614602",
      "Naduvikottai B.O": "614602",
      "Pannavayal B.O": "614602",
      "Neduvakottai B.O": "614625",
      "Okkanadumelaiyur B.O": "614625",
      "Thennamanad B.O": "614625",
      "Kattayankadu B.O": "614803",
      "Peikarambankottai B.O": "614626",
      "Kalagam B.O": "614804",
      "Kalanivasal B.O": "614804",
      "Idaiyiruppu B.O": "614302",
      "Mattayanthidal B.O": "614302",
      "Ombathuveli B.O": "614302",
      "Vembakudi B.O": "614303",
      "Kangeyampatti B.O": "613602",
      "Marudakudi B.O": "613602",
      "Attivetti B.O": "614613",
      "Sengapaduthankadu B.O": "614613",
      "Siruvaviduthi B.O": "614628",
      "Vengarai B.O": "614628",
      "Vettuvakottai B.O": "614614",
      "Tirumangalakottai B.O": "614905",
      "Thambikottai B.O": "614704",
      "Thambikottai Melakadu B.O": "614704",
      "Adanur B.O": "612301",
      "Agaramangudi B.O": "614303",
      "Neduntheru B.O": "614210",
      "Kalumangalam B.O": "613602",
      "Ammanichatram B.O": "614612",
      "Rudrachinthamani B.O": "614612",
      "Vilankulam B.O": "614612",
      "Soorapallam B.O": "614602",
      "Idayathi B.O": "614628",
      "Akkaraivattam B.O": "614614",
      "Kaduvettividuthi B.O": "614614",
      "Uranipuram B.O": "614614",
      "Sornakadu B.O": "614804",
      "Mudukadu B.O": "614612",
      "Kamatchinayakkanpalayam B.O": "614602",
      "Kasangadu B.O": "614613",
      "Manjavayal B.O": "614613",
      "Parakkalakottai B.O": "614613",
      "Thuvarankurichi B.O": "612001",
      "Kollaikadu B.O": "614628",
      "Thaligaividuthi B.O": "614614",
      "Tirumandangudi B.O": "612301",
      "Tiruvaikavur B.O": "612301",
      "Kavalur B.O": "614303",
      "Odayalur B.O": "612804",
      "Thillaiyambur B.O": "612804",
      "Kallaperambur B.O": "613601",
      "Vannarapettai B.O": "613601",
      "Aiyanapuram B.O": "613602",
      "Chitrakudi B.O": "613602",
      "Tirumangalakottai Kilayur B.O": "614905",
      "Maravakadu B.O": "614704",
      "Sarukkai B.O": "614203",
      "Sathyamangalam B.O": "614203",
      "Umayalpuram B.O": "614203",
      "Devarayanpettai B.O": "614204",
      "Manangorai B.O": "614206",
      "Mathur AYP B.O": "614206",
      "Soolamangalam B.O": "614206",
      "Tandankorai B.O": "614206",
      "Ilangarkudi B.O": "614203",
      "Karuppur KBS B.O": "614203",
      "Arundavapuram B.O": "614402",
      "Puliyakudi B.O": "614402",
      "Puthur AME B.O": "614402",
      "Vaiyacheri B.O": "614206",
      "Tyagasamudram B.O": "612301",
      "Sengamangalam B.O": "614804",
      "Manakadu B.O": "614612",
      "Tiruvattevan B.O": "614612",
      "Pattukottai R.S. B.O": "614602",
      "Mannangadu B.O": "614613",
      "Vattakudi B.O": "614613",
      "Kallurnikadu B.O": "614628",
      "Neyvelivadapathi B.O": "614628",
      "Vengarai East B.O": "614628",
      "Padirankottai B.O": "614614",
      "Unjividuthi B.O": "614614",
      "Tirumangalakottai West B.O": "614905",
      "Kalvirayanpettai B.O": "613601",
      "Tennangudi B.O": "613601",
      "Avarampatti B.O": "613602",
      "Umbalapadi B.O": "614203",
      "Tirukoilpathu B.O": "614402",
      "Maruthuvakudi B.O": "612101",
      "Melaiyur B.O": "612101",
      "Tirunilakudi B.O": "612101",
      "Valayapettai B.O": "612702",
      "Poundarigapuram B.O": "612202",
      "Rendankattalai B.O": "612202",
      "Tiyagarajapuram B.O": "609802",
      "Kumaramangalam B.O": "612602",
      "Mathur B.O": "612602",
      "Thukkachi B.O": "612602",
      "Tirunaraiyur B.O": "612602",
      "Krishnapuram B.O": "612401",
      "Palavathankattalai B.O": "612401",
      "Marudanallur B.O": "612402",
      "Sengarangudi Pudur B.O": "612203",
      "Madalampettai B.O": "612001",
      "Thandanthottam B.O": "612202",
      "Sivapuram B.O": "612401",
      "Tiruvidaimarudur West B.O": "612104",
      "Devanancheri B.O": "612501",
      "Nirathanallur B.O": "612501",
      "Mullangudi B.O": "612502",
      "Konulampallam B.O": "609807",
      "Tirumangaicherry B.O": "609807",
      "Gangadarapuram B.O": "612302",
      "Swamimalai East B.O": "612302",
      "Tiruvalanjuli B.O": "612302",
      "Palakudi B.O": "612102",
      "Paruthikudi B.O": "612102",
      "Injikollai B.O": "612605",
      "Paruthicherri B.O": "612605",
      "Sannapuram B.O": "612204",
      "Tepperumanallur B.O": "612204",
      "Ammachathiram B.O": "612103",
      "Umamaheswarapuram B.O": "612103",
      "Kallur B.O": "612503",
      "Manambadi B.O": "612503",
      "Kanjanur B.O": "609804",
      "Manalur B.O": "614202",
      "Tiruloki B.O": "609804",
      "Kaniyakurichi B.O": "614017",
      "Sokkanavur B.O": "614017",
      "Murthiambalpuram B.O": "614019",
      "Talayamangalam(VDR) B.O": "614019",
      "Valamarkottai B.O": "614019",
      "Vandayariruppu B.O": "614019",
      "Koorchi B.O": "612504",
      "Manikudi B.O": "612504",
      "Odayarkoil B.O": "614402",
      "Kovathagudi B.O": "614301",
      "Nariyanur B.O": "614301",
      "Koildevarayanpettai B.O": "614204",
      "Papanasam West B.O": "614205",
      "Uthamadhanapuram B.O": "614205",
      "Avaniapuram B.O": "612101",
      "Koohur B.O": "612602",
      "Cholanmaligai B.O": "612703",
      "Korukkai Thottam B.O": "612402",
      "Visalur B.O": "612402",
      "Nagarasampettai B.O": "612605",
      "Ayyavadi B.O": "612204",
      "Mahadana Street B.O": "612104",
      "Kadichambadi B.O": "612501",
      "Thathuvancheri B.O": "612502",
      "Kamakshipuram B.O": "609807",
      "Kovilacherri B.O": "612503",
      "Marathurai B.O": "609204",
      "Mattiyur B.O": "612504",
      "Sickinaickanpettai B.O": "612504",
      "Eraharam B.O": "612303",
      "Innambur B.O": "612303",
      "Kilakurichi B.O": "614015",
      "Kattur B.O": "614019",
      "Chinnakadaitheru B.O": "614401",
      "Puthur PSM B.O": "614202",
      "Ullikadai B.O": "614202",
      "Aduthurai Bazar B.O": "612101",
      "Govindapuram B.O": "612101",
      "Mallapuram B.O": "612201",
      "Krishnarayar Agraharam B.O": "612001",
      "Ullur B.O": "612001",
      "Ammangudi B.O": "612202",
      "Tirukodikaval B.O": "609802",
      "Kothangudi B.O": "612602",
      "Pampappadaiyur B.O": "612703",
      "Teynampadugai B.O": "612703",
      "Annalagraharam B.O": "612401",
      "Oppiliappankoil B.O": "612204",
      "Andalampettai B.O": "612104",
      "Tiruvidaimarudur R.S. B.O": "612104",
      "Aralur B.O": "612106",
      "Asoor B.O": "612501",
      "Kallapuliyur B.O": "612501",
      "Kilakattur B.O": "609807",
      "Atthiyur B.O": "612503",
      "Baburajapuram B.O": "612302",
      "Kottaiyur B.O": "612302",
      "Suriyanarkoil B.O": "612102",
      "Senganur B.O": "612504",
      "Virakkan B.O": "612504",
      "Tiruvisalur B.O": "612105",
      "Mahimalai B.O": "614401",
      "Iluppakorai B.O": "614202",
      "Arasapattu B.O": "614019",
      "Ragavambalpuram B.O": "614019",
      "Ukkadai B.O": "614401",
      "Ayyampet R.S B.O": "614211",
      "Papanasam H.O": "614205",
      "Melakaveri H.O": "612002",
      "Thanjavur H.O": "613001",
      "Kumbakonam H.O": "612001",
      "Pattukottai H.O": "614601",
      "Sengipatti S.O": "613402",
      "Tamil University S.O": "613010",
      "Ammapet S.O": "614401",
      "Ayyampet S.O": "614201",
      "Melattur S.O (Thanjavur)": "614301",
      "Pandaravadai S.O": "614204",
      "Vadakkumangudi S.O": "614303",
      "Alakkudi S.O": "613601",
      "Budalur S.O": "613602",
      "Karuntattankudi S.O": "613002",
      "Mariammancoil S.O": "613501",
      "Nadukaveri S.O": "613101",
      "Raja Serfoji Govt College S.O": "613005",
      "Saliamangalam S.O": "613504",
      "Chakrapalli S.O": "614211",
      "Ganapathi Agraharam S.O": "614202",
      "Papanasam Public Office S.O": "614205",
      "Pasupathikoil S.O": "614206",
      "Rajaghiri S.O": "614207",
      "Sundaraperumalkoil S.O": "614208",
      "Tirukkarugavur S.O": "614302",
      "Kandiyur S.O": "613202",
      "Poondi TPL S.O": "613105",
      "Rajappa Nagar S.O": "613007",
      "Kokkeri S.O": "614402",
      "Valoothoor S.O": "614210",
      "Co operative Buildings S.O": "613009",
      "Irudayapuram S.O": "613001",
      "Kalyanapuram S.O": "613201",
      "Kurungulam Melpathi S.O": "613303",
      "Manambuchavadi S.O": "613001",
      "Pundi TJ S.O": "613502",
      "Sri Pushpam College S.O": "613503",
      "Kabistalam S.O": "614203",
      "Papanasam Bazaar S.O": "614205",
      "Pullabudangudi S.O": "612301",
      "Thanjavur Bazaar S.O": "613001",
      "Thillaisthanam S.O": "613203",
      "Thanjavur East Gate S.O": "613001",
      "Thanjavur City S.O": "613001",
      "Thanjavur Collectorate S.O": "613001",
      "Thanjavur East S.O": "613001",
      "Thanjavur North Gate S.O": "613008",
      "Thanjavur Medical College S.O": "613004",
      "Thanjavur West S.O": "613009",
      "Thiruppanthuruthi S.O": "613103",
      "Thiruvaiyaru S.O": "613204",
      "Tirukattupalli S.O": "613104",
      "Vallam East S.O": "613403",
      "Thanjavur Pandt Colony S.O": "613006",
      "Thogur S.O": "613102",
      "Vallam TJ S.O": "613403",
      "Vediapuram S.O": "613205",
      "Voc Nagar S.O": "613007",
      "Tirunageswaram S.O": "612204",
      "Pandanallur S.O": "609807",
      "Sholapuram S.O": "612503",
      "Swamimalai S.O": "612302",
      "Tirupirambiyam S.O": "612303",
      "Veppathur S.O": "612105",
      "Tiruchirai S.O": "612605",
      "Tiruvidamarudur S.O": "612104",
      "Tirupanandal S.O": "612504",
      "Tippirajapuram S.O": "612402",
      "Koranattukkaruppur S.O": "612501",
      "Lower Anicut S.O": "612502",
      "TJ Busstand S.O": "613001",
      "Vennar Bank S.O": "613003",
      "Tirupuvanam S.O": "612103",
      "Kadiramangalam S.O": "612106",
      "Thuhili S.O": "609804",
      "Tirumangalakudi S.O": "612102",
      "Kumbakonam City S.O": "612001",
      "Narasinganpettai S.O": "609802",
      "Patteeswaram S.O": "612703",
      "Aduthurai S.O": "612101",
      "Murukkangudi S.O": "612202",
      "Kumbakonam Bazar S.O": "612001",
      "Kumbakonam Cutchery S.O": "612001",
      "Kumbakonam East S.O": "612001",
      "Natchar Koil S.O": "612602",
      "Sakkottai S.O": "612401",
      "Tirukattupalli East S.O": "613104",
      "Tirumalaisamudram East S.O": "613401",
      "TJ Co operative Housing Colony S.O": "613007",
      "Kuruvikarambai S.O": "614802",
      "Darasuram S.O": "612702",
      "Kumbakonam Market S.O": "612001",
      "Madukkur S.O": "614903",
      "Perumagalur S.O": "614612",
      "Tiruchitrambalam S.O": "614628",
      "Adirampattinam S.O": "614701",
      "Aladikkumulai S.O": "614615",
      "Alathur S.O": "614901",
      "Avanam S.O": "614623",
      "Peravurni S.O": "614804",
      "Tamarankottai S.O": "614613",
      "Tiruvonam S.O": "614614",
      "Kottaitheru S.O": "614902",
      "Melauluvur S.O": "614904",
      "Nattuchalai S.O": "614906",
      "Ottangadu S.O": "614803",
      "Srinivasapuram S.O (Thanjavur)": "614602",
      "Vadaseri S.O": "614905",
      "Mallipattinam S.O": "614723",
      "Nadimuthunagar S.O": "614602",
      "Orattanad S.O": "614625",
      "Pappanad S.O": "614626"
    },
    "PUDUKKOTTAI": {
      "Athankaraipatti B.O": "614902",
      "Mudalipatti B.O": "622409",
      "Melur B.O": "622507",
      "Malaiyur B.O": "622301",
      "Mangottai B.O": "622301",
      "Pathampatti B.O": "622301",
      "Ponnanviduthi B.O": "622301",
      "Vichchur B.O": "614617",
      "Kummangulam B.O": "622301",
      "Vellalaviduthi B.O": "613301",
      "Eganivayal B.O": "614616",
      "Kammangadu B.O": "614616",
      "Kundagavayal B.O": "614616",
      "Ayingudi B.O": "614801",
      "Vallavari B.O": "614801",
      "Vennavalkudi B.O": "622201",
      "Kattumavadi B.O": "614630",
      "Krishnajipattinam B.O": "614630",
      "Singavanam B.O": "614630",
      "Vettanur B.O": "614630",
      "Thodaiyur B.O": "622501",
      "Vellanur B.O": "622501",
      "Manganur B.O": "613301",
      "Mattangal B.O": "613301",
      "Mohanur B.O": "613301",
      "Pudunagar B.O": "613301",
      "Sundampatti B.O": "613301",
      "Veladipatti B.O": "613301",
      "Karukkakurichi B.O": "622302",
      "Keerathur B.O": "622302",
      "Avanathankottai B.O": "614624",
      "Tirunalur B.O": "614624",
      "Melanilaivayal B.O": "622202",
      "Alavayal B.O": "622401",
      "Jegathapattinam B.O": "614619",
      "Karakathikottai B.O": "614619",
      "Vilapatti B.O": "622504",
      "Sevalur B.O": "622402",
      "Thondamanallur B.O": "622515",
      "Kanadu B.O": "614621",
      "Poyyadanallur B.O": "614621",
      "Pudur pdk B.O": "622103",
      "Veerapatti B.O": "622103",
      "Kottur B.O": "622404",
      "Kulamangalam B.O": "614624",
      "Rarapuram B.O": "622404",
      "Andakulam B.O": "622203",
      "Chockanathapatti B.O": "622203",
      "Killanur B.O": "622203",
      "SanthaNathapuram B.O": "622005",
      "Hirudayapuram B.O": "622505",
      "Vilathupatti B.O": "622101",
      "L.N.Puram B.O": "614616",
      "Melapattu B.O": "614616",
      "Puduvakottai B.O": "614616",
      "Kilapanaiyur B.O": "622201",
      "Mirattunilai B.O": "622201",
      "Ennai B.O": "622102",
      "Irundirapatti B.O": "622102",
      "Kilikudi B.O": "622102",
      "Kadampatti B.O": "622302",
      "Kallakottai B.O": "622302",
      "K.Rasiamangalam B.O": "622301",
      "Kalabam B.O": "614629",
      "Pallathividuthi B.O": "622301",
      "Pudukkottaividuthi B.O": "622301",
      "Sooranviduthi B.O": "622301",
      "Chittannavasal B.O": "622101",
      "Madianallur B.O": "622101",
      "Raghunathapuram B.O": "622302",
      "Merpanaikadu West B.O": "614624",
      "Nagaram B.O": "614624",
      "Panangulam B.O": "614624",
      "Periyalur B.O": "614624",
      "Poovaimanagar B.O": "614624",
      "Letchumanapatti B.O": "622502",
      "Nanjur B.O": "622502",
      "Odayalipatti B.O": "622502",
      "Odugampatti B.O": "622502",
      "Sengalur B.O": "622502",
      "Srinivasanagar B.O": "622502",
      "Kongudi B.O": "622202",
      "Kulathur B.O": "622202",
      "Kallur kilanilai B.O": "622209",
      "Nedungudi B.O": "622209",
      "Vambarampatti B.O": "622209",
      "Athanur B.O": "622503",
      "Kattubawa Pallivasal B.O": "622503",
      "Ammachatram B.O": "622504",
      "Kannangudi B.O": "622504",
      "Themmavur B.O": "622203",
      "Idaiyur B.O": "614629",
      "Maramadakki B.O": "614622",
      "Palayavanam B.O": "614622",
      "Mangalanadu B.O": "614805",
      "Alinjiyendal B.O": "614618",
      "Venkatakulam B.O": "622303",
      "Vanakkankadu B.O": "622304",
      "Kesarapatti B.O": "622411",
      "Perumanadu B.O": "622104",
      "Pulvayal B.O": "622104",
      "Theravur B.O": "621316",
      "Velur B.O": "621316",
      "Viralur B.O": "621316",
      "Oliyamangalam B.O": "621308",
      "Padirakudi B.O": "614629",
      "Thiruppunavasal B.O": "614629",
      "R.Palakurichi B.O": "622407",
      "Vegupatti B.O": "622407",
      "Mullur B.O": "622004",
      "Rajapatti B.O": "622004",
      "Vadavalam B.O": "622004",
      "Aharapatti B.O": "622003",
      "Kadayakudi B.O": "622003",
      "Tiruvappur B.O": "622003",
      "Kuruvikondanpatti B.O": "622409",
      "Namanasamudram B.O": "622422",
      "Peraiyur B.O": "622422",
      "Kodivayal B.O": "614805",
      "Melathaniyam B.O": "622002",
      "Nallur B.O": "622002",
      "Palayanerinjikudi B.O": "622002",
      "Perunjunai B.O": "622002",
      "Kulathupatti B.O": "622507",
      "Thulayanur B.O": "622507",
      "Poovalur B.O": "614618",
      "Vilanur B.O": "614618",
      "Kaikurichi B.O": "622303",
      "Tirukkattalai B.O": "622303",
      "Anavayal B.O": "622304",
      "Gudalur B.O": "622412",
      "Lembalakudi B.O": "622412",
      "Melapanaiyur B.O": "622412",
      "V.Lakshmipuram B.O": "622412",
      "Kodumbalur B.O": "621316",
      "Kunnathur B.O": "621316",
      "Meppoodakudi B.O": "621316",
      "Mullaiyur B.O": "621316",
      "Irumbanadu B.O": "622204",
      "Karuvur B.O": "622204",
      "Kurungalur B.O": "622204",
      "Okkur Perunthamarai B.O": "622204",
      "Narthamalai B.O": "622101",
      "Aliyanilai B.O": "614616",
      "Edaiyathur B.O": "614616",
      "Nakudi B.O": "614616",
      "Thondaimanendal B.O": "614616",
      "Thanjur Tirumayam B.O": "622201",
      "Karaikottai B.O": "614630",
      "Puthambur B.O": "622501",
      "Satyamangalam B.O": "622501",
      "Komapuram B.O": "613301",
      "Thachankurichi B.O": "613301",
      "Valavampatti B.O": "613301",
      "Malaikudipatti B.O": "622102",
      "Kulandiranpattu B.O": "622302",
      "Pilaviduthi B.O": "622302",
      "Erukkalakkottai B.O": "614624",
      "Kothamangalam B.O": "614624",
      "Poovathakudi B.O": "614624",
      "Kalamavur B.O": "622502",
      "Killukkottai B.O": "622502",
      "Tiruppur B.O": "622502",
      "Kummangudi B.O": "622202",
      "Vadakattupatti B.O": "622202",
      "N.Shanmuganathapuri B.O": "622503",
      "Nagarapatti B.O": "622401",
      "Thenur B.O": "622401",
      "Odukkur B.O": "622504",
      "Tirumalairayapuram B.O": "622504",
      "Valamangalam B.O": "622504",
      "Panayapatti B.O": "622402",
      "Sundaram B.O": "622402",
      "Ganesh Nagar B.O": "622001",
      "Edayathimangalam B.O": "614620",
      "Avur B.O": "622515",
      "Mathur B.O": "622515",
      "Neerpalani B.O": "622515",
      "Tirukkalambur B.O": "622403",
      "Venthanpatti B.O": "622403",
      "Arasanagaripattinam B.O": "614621",
      "Muthukuda B.O": "614621",
      "Talanur B.O": "614621",
      "Adanakottai B.O": "622203",
      "Ganapathipuram B.O": "622203",
      "Manaviduthi B.O": "622203",
      "Vathanakottai B.O": "622203",
      "Oonaiyur B.O": "622505",
      "Kannanur B.O": "622409",
      "Arputhapuram B.O": "622506",
      "Sengirai B.O": "622506",
      "Thekkattur B.O": "622506",
      "Kovilur Alangudi B.O": "622301",
      "Kuppakudi B.O": "622301",
      "Sambattividuthi B.O": "622301",
      "Tuvar B.O": "622301",
      "Kilakurichi B.O": "622101",
      "Mangudi B.O": "622101",
      "Kurumbur B.O": "614622",
      "Thanthani B.O": "614622",
      "Karaiyur B.O": "622002",
      "Maravamadurai B.O": "622002",
      "Sadayampatti B.O": "622002",
      "Amaradakki B.O": "614618",
      "Perumarudur B.O": "614618",
      "Kothakottai B.O": "622303",
      "Vamban Colony B.O": "622303",
      "Kadukkakadu B.O": "622304",
      "Mullankurichi B.O": "622304",
      "Pullanviduthi B.O": "622304",
      "Kudumianmalai B.O": "622104",
      "Poruvai B.O": "621316",
      "Thengaithinnipatti B.O": "621316",
      "Muslim Street B.O": "614616",
      "Memangalam B.O": "614616",
      "Panjatti B.O": "614616",
      "Ratnakottai B.O": "614616",
      "Veeramangalam B.O": "614616",
      "Kulavaipatti B.O": "622201",
      "Onangudi B.O": "622201",
      "Bramanavayal B.O": "614630",
      "Rajakulathur B.O": "622501",
      "Akkachipatti B.O": "613301",
      "Kovilur (Gandarvakottai) B.O": "613301",
      "Vembanpatti B.O": "613301",
      "Kothirapatti B.O": "622102",
      "Rappusal B.O": "622102",
      "Ambukoil B.O": "622302",
      "Marudakonviduthi B.O": "622302",
      "Pallavarampatti B.O": "622302",
      "Tirumananjeri B.O": "622302",
      "Kasimpudupet B.O": "614624",
      "Merpanaikadu B.O": "614624",
      "Kilaiyur B.O": "622502",
      "Kunnandarkoil B.O": "622502",
      "Valaramanickam B.O": "622202",
      "Kilanilai rayavaram B.O": "622209",
      "P.Alagapuri B.O": "622503",
      "Melamelanilai B.O": "622401",
      "Semboodi B.O": "622401",
      "Bayamariyanendal B.O": "614619",
      "Puliyur B.O": "622504",
      "Uppiliyakudi B.O": "622504",
      "Arasamalai B.O": "622402",
      "Manalur B.O": "614620",
      "Vellore B.O": "614620",
      "Mandaiyur B.O": "622515",
      "Varpattu B.O": "622403",
      "Minnathur B.O": "622203",
      "Vaithur B.O": "622203",
      "Varappur B.O": "622203",
      "Gandhinagar B.O": "622001",
      "Adambur B.O": "614629",
      "Thiyathur B.O": "614629",
      "Ambalpuram B.O": "622005",
      "Attangudi B.O": "622003",
      "Vanniampatti B.O": "622003",
      "Panangudi B.O": "622505",
      "Perungudi B.O": "622506",
      "Arayapatti B.O": "614622",
      "Chidambaraviduthi B.O": "614622",
      "Sunayakadu B.O": "614622",
      "Amarasimhendrapuram B.O": "614805",
      "Idaiyathur B.O": "622002",
      "Kilathaniyam B.O": "622002",
      "Sipcot pdk B.O": "622002",
      "Pilivalam B.O": "622507",
      "Pandipathiram B.O": "614618",
      "Perunavalur B.O": "614618",
      "Poovarasakudi B.O": "622303",
      "Vallathirakottai B.O": "622303",
      "Vamban B.O": "622303",
      "Kottaikadu B.O": "622304",
      "Mangadu B.O": "622304",
      "Neduvasal B.O": "622304",
      "Parambur B.O": "622104",
      "Erasanayakkanpatti B.O": "621316",
      "Perambur B.O": "621316",
      "Rajagiri B.O": "621316",
      "Sithakoor B.O": "622204",
      "Rasalipatti B.O": "621312",
      "Minaveli B.O": "621305",
      "Pudukkottai H.O": "622001",
      "Kilanilai S.O": "622202",
      "Kilanilaikottai S.O": "622209",
      "Melasivapuri S.O": "622403",
      "Nachandupatti S.O": "622404",
      "Pudukkottai Bus Stand S.O": "622001",
      "Pudukkottai Ind. Estate S.O": "622004",
      "Pudukkottai Pub Offices S.O": "622001",
      "Tirugokarnam S.O": "622002",
      "Tirupperunthurai S.O": "614618",
      "Illuppur S.O": "622102",
      "Karambakudi S.O": "622302",
      "Keeramangalam S.O": "614624",
      "Keeranur S.O": "622502",
      "Mathur Ind. Estate S.O": "622515",
      "Mimisal S.O": "614621",
      "Muckanamalaipatti S.O": "622103",
      "Pudupatti S.O (Pudukkottai)": "622407",
      "Rangiem S.O": "622409",
      "Rayavaram S.O (Pudukkottai)": "622506",
      "Sivapuram S.O": "622422",
      "Subramaniapuram S.O (Pudukkottai)": "614805",
      "Tiruvarankulam S.O": "622303",
      "Vadakadu S.O": "622304",
      "Valayapatti S.O (Pudukkottai)": "622411",
      "Vayalogam S.O": "622104",
      "Cauvery Nagar S.O": "622501",
      "Konapet S.O": "622503",
      "Kulathur S.O (Pudukkottai)": "622504",
      "Machuvadi S.O": "622001",
      "Manamelkudi S.O": "614620",
      "Perungalur S.O": "622203",
      "Ponbethi S.O": "614629",
      "Ponnamaravathy S.O": "622407",
      "Pudukkottai Collectorate S.O": "622005",
      "Pudukkottai East S.O": "622001",
      "Ghandarvakottai S.O": "613301",
      "Koppanapatti S.O": "622401",
      "Kottaipattinam S.O": "614619",
      "Kulipirai S.O": "622402",
      "Pillaithannirpandal S.O": "622001",
      "Rajagopalapuram S.O": "622003",
      "Ramachandrapuram S.O (Pudukkottai)": "622505",
      "Tirumayam S.O": "622507",
      "Viralimalai S.O": "621316",
      "Yembal S.O": "622204",
      "Silattur S.O": "614622",
      "Virachilai S.O": "622412",
      "Annavasal S.O": "622101",
      "Arantangi S.O": "614616",
      "Bhuvaneswarinagar S.O": "622001",
      "Arantangi Fort S.O": "614616",
      "Alangudi S.O": "622301",
      "Arimalam S.O": "622201",
      "Attani S.O": "614630",
      "Ammapattinam S.O": "614617",
      "Arasarkulam S.O": "614801"
    },
    "KARUR": {
      "Kondangipatti BO": "639005",
      "Thukkachi BO": "638151",
      "Karvazhi BO": "638151",
      "Pondilingapuram BO": "638151",
      "Kavalkaranpatti B.O": "621313",
      "Keelaveliyur B.O": "621313",
      "Rachandarthirumalai B.O": "621313",
      "Thondamanginam B.O": "621313",
      "Vadaseri B.O": "621313",
      "Kunnagoundanpatti B.O": "639120",
      "Kuppachipatti B.O": "639120",
      "Mathagiri B.O": "621313",
      "Porundalur B.O": "621313",
      "Alathur (Kulittalai) B.O": "621313",
      "Chinniyampalayam B.O": "639120",
      "Kazhugur B.O": "639120",
      "Kalladai B.O": "621313",
      "Puthur B.O": "621313",
      "Periyamathiagudalur B.O": "639202",
      "Thokkupattipudur B.O": "639202",
      "Elavanur B.O": "639202",
      "Punnam B.O": "639136",
      "Nagampalli B.O": "639109",
      "Manavasi B.O": "639108",
      "Renganathapuram B.O": "639108",
      "Kallai B.O": "639110",
      "Kurichi B.O": "639110",
      "Nallur B.O": "639110",
      "Poyyamani B.O": "639110",
      "Keeranur B.O": "639119",
      "Pappakkapatti B.O": "639119",
      "Potharavuthanpatti B.O": "639119",
      "Vayalur B.O": "639119",
      "Mavathur B.O": "621311",
      "Sembianatham B.O": "621311",
      "Sevapur B.O": "621311",
      "Chinnakariyampatti B.O": "639201",
      "Nambagoundanur B.O": "639201",
      "Rajapuram B.O": "639201",
      "Hiranyamangalam B.O": "639107",
      "Mettumarudur B.O": "639107",
      "Panickampatti B.O": "639107",
      "Parali B.O": "639107",
      "Thannirpalli B.O": "639107",
      "Valayalkaranpudur B.O": "639108",
      "Savarimedu B.O": "639110",
      "Adhanur B.O": "621311",
      "Chinnampatti B.O": "621311",
      "D.Idayapatti B.O": "621311",
      "Kadavur B.O": "621311",
      "Nanjaikalakurichi B.O": "639201",
      "Rengapalayam B.O": "639202",
      "Uttupatti B.O": "639202",
      "Pethachinagar B.O": "639203",
      "Moolimangalam B.O": "639136",
      "Punnamchatram B.O": "639136",
      "Kathalapatti B.O": "639007",
      "Venjamangudalur B.O": "639109",
      "A.Meenakshivalasu B.O": "639207",
      "Ganesapuram B.O": "639107",
      "Kattalai B.O": "639108",
      "Nachalur B.O": "639110",
      "Neidalur South B.O": "639110",
      "Rengachipatti B.O": "639110",
      "Veeriyapalayam B.O": "639119",
      "P.Udayapatti B.O": "639119",
      "Palaviduthi B.O": "621311",
      "Singampatti B.O": "621311",
      "Sathiyamangalam B.O": "639120",
      "Karuppapillaipudur B.O": "639205",
      "Kottapatti B.O": "639205",
      "Athipalayam B.O": "639111",
      "Kattumunnur B.O": "639111",
      "Kuppam B.O": "639111",
      "Punjaipugalur B.O": "639113",
      "Punjaithottakurichi B.O": "639113",
      "West Orathai B.O": "639113",
      "Vedichipalayam B.O": "639114",
      "Kodanthur B.O": "639206",
      "Sukkaliyur B.O": "639003",
      "Kuppachipalayam B.O": "639116",
      "Minnampalli B.O": "639116",
      "Vangal East B.O": "639116",
      "Nadayanur B.O": "639117",
      "Noyyal B.O": "639117",
      "Mushtakinathupatti B.O": "639118",
      "Chinthalavadi B.O": "639105",
      "Mettumahadhanapuram B.O": "639105",
      "Rakkampatti B.O": "639120",
      "Naganur B.O": "639120",
      "Mudalaipatti BO": "639103",
      "Athur B.O": "639008",
      "Poolampalayam B.O": "639008",
      "Kanakkuvelampatti B.O": "639201",
      "Pungambadi B.O": "639201",
      "Punjaikalakurichi B.O": "639201",
      "Anangur B.O": "639202",
      "Ammapatti B.O": "639203",
      "Zamin Athur B.O": "639203",
      "Emur B.O": "639007",
      "Varikkapatti B.O": "639109",
      "Karuppur B.O": "639108",
      "Innungur B.O": "639110",
      "Neidalur B.O": "639110",
      "Muthurengampatti B.O": "639119",
      "Vellapatti Zamin B.O": "639119",
      "Alamarathupatti B.O": "639207",
      "Kovilur B.O": "639207",
      "Lingamanaickenpatti B.O": "639207",
      "Kurikkaranvalasu B.O": "639205",
      "Pappanaickenpatti B.O": "639205",
      "Nadanthai North B.O": "639111",
      "Renganathampettai B.O": "639004",
      "Senapiratti B.O": "639004",
      "Dalavapalayam B.O": "639113",
      "Koyampalli B.O": "639114",
      "Veerarakkiam B.O": "639114",
      "Pallamarudapatti B.O": "639002",
      "Pallapalayam B.O": "639002",
      "Pavithram B.O": "639002",
      "Koonampatti B.O": "639206",
      "Malaikovil B.O": "639206",
      "Appipalayam B.O": "639003",
      "Kakkavadi B.O": "639003",
      "Chinnamookkanankurichi B.O": "639118",
      "Manmangalam B.O": "639006",
      "Vennamalai B.O": "639006",
      "Kaniyalampatti B.O": "621301",
      "Kurinikulathupatti B.O": "621301",
      "Manjanaickenpatti B.O": "621301",
      "Varavanai B.O": "621301",
      "Munayanur B.O": "639102",
      "Palayajeyankondam B.O": "639102",
      "Sengal B.O": "639102",
      "Tirukkampuliyur B.O": "639102",
      "Kulittalai Periyapalam B.O": "639104",
      "Timmachipuram B.O": "639105",
      "Vadiyam B.O": "639105",
      "Sivayam B.O": "639120",
      "Kosur B.O": "639120",
      "Servaikaranpatti B.O": "621315",
      "Thaliyampatti B.O": "639120",
      "Modakkur B.O": "639207",
      "Perityamanjuveli B.O": "639207",
      "Sandapadi B.O": "639207",
      "Inunganur B.O": "639205",
      "Sellivalasu B.O": "639205",
      "Sendamangalam B.O": "639205",
      "Ariyur B.O": "639111",
      "Munnur B.O": "639111",
      "Nedungur B.O": "639111",
      "Nerur B.O": "639004",
      "Panjamadevi B.O": "639004",
      "S.Vellalapatti B.O": "639004",
      "Kadambankurichi B.O": "639113",
      "Nanniyur B.O": "639113",
      "Melapalayam B.O": "639114",
      "Somur B.O": "639114",
      "Mudiganam B.O": "639002",
      "Thumbivadi B.O": "639002",
      "Viswanathapuri B.O": "639002",
      "Gudalur B.O": "639206",
      "Muthanampalayam B.O": "639206",
      "Periyathirumangalam B.O": "639206",
      "Manavadi B.O": "639005",
      "Paganatham B.O": "639005",
      "Thoranakkalpatti B.O": "639003",
      "Semangi B.O": "639117",
      "Chellandipatti B.O": "639118",
      "Jegadabi B.O": "639118",
      "Kalaiyapatti B.O": "621301",
      "Kilasakkarakottai B.O": "621301",
      "Manjapulipatti B.O": "621301",
      "Mylampatti B.O": "621301",
      "Veeranampatti B.O": "621301",
      "Mahadhanapuram B.O": "639102",
      "Manathattai B.O": "639104",
      "Karuveppanaikenpettai B.O": "639105",
      "Punavasipatti B.O": "639105",
      "Ponnagoundanur B.O": "639207",
      "Velanchettiyur B.O": "639207",
      "Verisinampatti B.O": "639207",
      "Rengamalaipudupatti B.O": "639205",
      "Velampadi B.O": "639205",
      "Karudayampalayam B.O": "639111",
      "Palaiyur B.O": "639004",
      "East Thavittupalayam B.O": "639113",
      "Nanjaipugalur B.O": "639113",
      "Puliyur B.O": "639114",
      "Uppidamangalam B.O": "639114",
      "Chinnavangalampalayam B.O": "639206",
      "Karunellivalasu B.O": "639206",
      "Monjanur B.O": "639206",
      "Mookanankurichi B.O": "639005",
      "Puthambur B.O": "639003",
      "Thalapatti B.O": "639003",
      "Vettamangalam B.O": "639117",
      "K.Pitchampatti B.O": "639118",
      "Porani B.O": "639118",
      "Kadaparai B.O": "639006",
      "Kovakulam B.O": "639102",
      "Manickapuram B.O": "639102",
      "K.Pudupatti B.O": "639105",
      "Karuppathur B.O": "639105",
      "Kuppureddipatti B.O": "639105",
      "Kulittalai H.O": "639104",
      "Karur H.O": "639001",
      "Andankoil S.O": "639008",
      "Aravakurichi S.O": "639201",
      "Chinnadharapuram S.O": "639202",
      "Ramakrishnapuram S.O": "639001",
      "Velayuthampalayam S.O": "639117",
      "Vengamedu S.O": "639006",
      "Nungavaram S.O": "639110",
      "Isanatham S.O": "639203",
      "Karur Collectorate S.O": "639007",
      "Pallapatti Bazaar S.O": "639207",
      "Pugalur Sugar Factory S.O": "639113",
      "Velliyanai S.O": "639118",
      "Marudur S.O": "639107",
      "Vaiganallur S.O": "639120",
      "Kagtithapuram S.O": "639136",
      "Karur West S.O": "639001",
      "Moolapatti S.O": "639109",
      "Paramathi (Karur) S.O": "639111",
      "Thanthonimalai S.O": "639005",
      "Krishnarayapuram S.O": "639102",
      "Panjapatti S.O": "639119",
      "Thogaimalai S.O": "621313",
      "Gandhigramam S.O": "639004",
      "Pallapatti S.O (Karur)": "639205",
      "Pasupathipalayam S.O": "639004",
      "Puliyur Cement Factory S.O": "639114",
      "Sengunthapuram S.O": "639002",
      "Tennilai S.O": "639206",
      "Tirumanilaiyur S.O": "639003",
      "Vangal S.O": "639116",
      "Chinthamanipatti S.O": "621301",
      "Kulittalai Bazaar S.O": "639104",
      "Lalapet S.O": "639105",
      "Mayanur S.O": "639108",
      "Tharagampatti S.O": "621311"
    },
    "KANNIYAKUMARI": {
      "Kattimancode B.O": "629801",
      "Kumarapuram B.O": "629164",
      "Arumanallur B.O": "629851",
      "Palkulam B.O": "629851",
      "Mathiasnagar B.O": "629852",
      "Putheri B.O": "629001",
      "Kurumpanai B.O": "629251",
      "Monikettipottal B.O": "629501",
      "South Soorankudy B.O": "629501",
      "Leepuram B.O": "629702",
      "Therku Thamaraikulam B.O": "629701",
      "Kalpadi B.O": "629204",
      "Chenbagaramanputhur B.O": "629301",
      "Anandanadarkudy B.O": "629201",
      "Santhapuram B.O": "629201",
      "Pottakulam B.O": "629401",
      "Variyoor B.O": "629401",
      "Derisanamcope B.O": "629851",
      "Kadukkarai B.O": "629851",
      "Keeriparai B.O": "629851",
      "North Soorankudy B.O": "629501",
      "Pazhavilai B.O": "629501",
      "Saral Agasteeswaram B.O": "629203",
      "James Town B.O": "629401",
      "Ratnapuram B.O": "629851",
      "Thadikarankonam B.O": "629851",
      "Isanthimangalam B.O": "629852",
      "Pozhikkarai B.O": "629501",
      "Puthenthurai B.O": "629501",
      "Rajakkamangalam B.O": "629502",
      "Vembanur B.O": "629801",
      "Anjugramam B.O": "629401",
      "Andirapuram B.O": "629851",
      "Maramalai B.O": "629851",
      "Tittivilai B.O": "629852",
      "Kodimunai B.O": "629251",
      "Vaniyakudi B.O": "629251",
      "Kesavanputhenthurai B.O": "629501",
      "Mangavilai B.O": "629501",
      "Rajakkamangalamthurai B.O": "629501",
      "Kovalam B.O": "629702",
      "Vivekanandapuram B.O": "629702",
      "Edalakudy B.O": "629002",
      "Irulappapuram B.O": "629002",
      "Azhikkal B.O": "629202",
      "Alancode B.O": "629802",
      "Kallukoottam B.O": "629802",
      "Melamanakudy B.O": "629602",
      "Nallur B.O": "629704",
      "Sasthankcoilvilai B.O": "629704",
      "Terur B.O": "629704",
      "Thamaraikulam B.O": "629704",
      "Erachakulam B.O": "629901",
      "Vellamadam B.O": "629302",
      "Chunkankadai B.O": "629003",
      "Kaniyakulam B.O": "629003",
      "Parvathipuram B.O": "629003",
      "Ilanchirai B.O": "629152",
      "Malamary B.O": "629152",
      "Meppalai B.O": "629152",
      "Pathukani B.O": "629101",
      "Maruthurkurichi B.O": "629158",
      "Marthandamthurai B.O": "629160",
      "Urambu B.O": "629160",
      "Vallavilai B.O": "629160",
      "Cherupallur B.O": "629161",
      "Thiruthuvapuram B.O": "629163",
      "Mukkampala B.O": "629164",
      "Nallur marthandam B.O": "629165",
      "Nattalam B.O": "629165",
      "Viricode B.O": "629165",
      "Chemparuthivilai B.O": "629166",
      "Anducode B.O": "629168",
      "Kanjikuzhi B.O": "629169",
      "Keralapuram B.O": "629174",
      "Azhakamparai B.O": "629252",
      "Kulasekharapuram B.O": "629403",
      "Erumbukadu B.O": "629004",
      "Nesamony Nagar B.O": "629001",
      "Lekshmipuram B.O": "629802",
      "Ritapuram B.O": "629159",
      "Melakrishnanputhur B.O": "629601",
      "Pallam B.O": "629601",
      "Therekalpudur B.O": "629901",
      "Thirupathisaram B.O": "629901",
      "Peruvilai B.O": "629003",
      "Kumaracoil B.O": "629180",
      "Chitharal B.O": "629151",
      "Karod B.O": "629151",
      "Manjalumoodu B.O": "629151",
      "Cheruvallur B.O": "629152",
      "Adaikkakuzhi B.O": "629153",
      "Chathancode B.O": "629153",
      "Sooriacode B.O": "629153",
      "Mullanginavilai B.O": "629157",
      "Pottetty B.O": "629157",
      "Theruvukadai B.O": "629157",
      "Tholayavattai B.O": "629157",
      "Eravipudurkadai B.O": "629158",
      "Enayam B.O": "629193",
      "Enayamputhenthurai B.O": "629193",
      "Ramanthurai B.O": "629193",
      "Maniankuzhi B.O": "629161",
      "Ponmanai B.O": "629161",
      "Thiruvarambu B.O": "629161",
      "Madichel B.O": "629163",
      "Gnaramvilai B.O": "629165",
      "Alagiamandapam B.O": "629167",
      "Kozhiporvilai B.O": "629167",
      "Kuzhicode B.O": "629167",
      "Thickurichy B.O": "629168",
      "Kannumamoodu B.O": "629170",
      "Manivilai B.O": "629170",
      "Painkulam B.O": "629173",
      "Vizhunthaiyambalam B.O": "629173",
      "Attur B.O": "629177",
      "Chenkody B.O": "629177",
      "Moovattumugham B.O": "629177",
      "Veeyannur B.O": "629177",
      "Santhaiyadi B.O": "629703",
      "Kadiyapattanam B.O": "629252",
      "Eraviputhur B.O": "629402",
      "Kumarapuramthoppur B.O": "629402",
      "Kurunthencode B.O": "629802",
      "Thalakulam B.O": "629802",
      "Bethelpuram B.O": "629803",
      "Krishnancoil B.O": "629001",
      "Alanchi B.O": "629159",
      "Sahayanagar B.O": "629159",
      "Devakulam B.O": "629704",
      "Vazhukkamparai B.O": "629704",
      "Mekkode B.O": "629804",
      "Madavalayam B.O": "629302",
      "Manakarai B.O": "629180",
      "Ramavarmanchirai B.O": "629152",
      "Kulapuram B.O": "629153",
      "Malayadi B.O": "629153",
      "Alancholai B.O": "629101",
      "Netta B.O": "629101",
      "Mulankuzhi B.O": "629162",
      "Mangarai B.O": "629157",
      "Kannanore B.O": "629158",
      "Fathima Nagar B.O": "629160",
      "Manalodai B.O": "629161",
      "Mahadanapuram B.O": "629702",
      "Peyankuzhi B.O": "629809",
      "Potraiyadi B.O": "629703",
      "Mondaikad B.O": "629252",
      "Kannattuvilai B.O": "629802",
      "Konamkadu B.O": "629803",
      "Thengamputhur B.O": "629602",
      "Asiramam B.O": "629704",
      "Chemponvilai B.O": "629804",
      "Ramapuram B.O": "629302",
      "Madathattuvilai B.O": "629180",
      "Mancode B.O": "629152",
      "Vellachiparai B.O": "629152",
      "Meenachel B.O": "629153",
      "Arukani B.O": "629101",
      "Maruthemparai B.O": "629101",
      "Nithiravilai B.O": "629154",
      "Irenipuram B.O": "629162",
      "Kirathur B.O": "629160",
      "Palavilai B.O": "629160",
      "Chittardam Colony B.O": "629161",
      "Tiruparappu B.O": "629161",
      "Vendalicode B.O": "629161",
      "Maruthencode B.O": "629163",
      "Vanniyur B.O": "629163",
      "Velimalai B.O": "629164",
      "Kallankuzhi B.O": "629166",
      "Puliyurkurichi B.O": "629175",
      "Elavuvilai B.O": "629171",
      "Munchirai B.O": "629171",
      "Methukummal B.O": "629172",
      "Pechchipparai B.O": "629161",
      "Thumbode B.O": "629161",
      "Padanthalumoodu B.O": "629163",
      "Verkilambi B.O": "629166",
      "Mulachel B.O": "629175",
      "Alampara B.O": "629170",
      "Killiyoor B.O": "629171",
      "Vencode B.O": "629171",
      "Poothurai B.O": "629176",
      "Aruvikkarai B.O": "629177",
      "Mangalakunnu B.O": "629178",
      "Nagercoil H.O": "629001",
      "Thuckalay H.O": "629175",
      "Ammandivilai S.O": "629204",
      "Aralvaymoli S.O": "629301",
      "Asaripallam S.O": "629201",
      "Bhoothapandy S.O": "629852",
      "Colachel S.O": "629251",
      "Friday Market S.O": "629203",
      "Kottar S.O": "629002",
      "Kottaram S.O": "629703",
      "Manavalakurichi S.O": "629252",
      "Muttom S.O": "629202",
      "Neyyoor West S.O": "629803",
      "Palapalam S.O": "629159",
      "Thickanamcode S.O": "629804",
      "Vadasery S.O": "629001",
      "Kaliakkavilai S.O": "629153",
      "Kaliyal S.O": "629101",
      "Kappukadu S.O": "629162",
      "Mekkamandapam S.O": "629166",
      "Pacode S.O": "629168",
      "Palukal S.O": "629170",
      "Pudukadai S.O": "629171",
      "S.T.Mankad S.O": "629172",
      "Agasteeswaram S.O": "629701",
      "Azhakappapuram S.O": "629401",
      "Catherin Booth Hospital S.O": "629001",
      "Ganapathipuram S.O": "629502",
      "Kandanvilai S.O": "629810",
      "Maravankudiyiruppu S.O": "629002",
      "Marungoor S.O": "629402",
      "Mayiladi S.O": "629403",
      "Nagercoil Bazaar S.O": "629001",
      "Parakkai S.O": "629601",
      "Villukuri S.O": "629180",
      "Kappiyarai S.O": "629156",
      "Karinkal S.O": "629157",
      "Kollangodu S.O": "629160",
      "Kuzhithurai West S.O": "629163",
      "Manalikarai S.O": "629164",
      "Mettukadai S.O": "629175",
      "Padmanabhapuram Fort S.O": "629175",
      "Thuthur S.O": "629176",
      "Tiruvattar S.O": "629177",
      "Aloor S.O": "629801",
      "Azhakiapandipuram S.O": "629851",
      "Kanniyakumari S.O": "629702",
      "Karankad S.O": "629809",
      "Nagercoil West S.O": "629001",
      "Thovalai S.O": "629302",
      "Vetturnimadam S.O": "629003",
      "Arumanai S.O": "629151",
      "Idaikkode S.O": "629152",
      "Kanjiracode S.O": "629155",
      "Kattathurai S.O": "629158",
      "Kulasekharam S.O": "629161",
      "Marthandam North S.O": "629165",
      "Marthandam S.O": "629165",
      "Mulagumoodu S.O": "629167",
      "Palliyadi S.O": "629169",
      "Thengapattanam S.O": "629173",
      "Thiruvithancode S.O": "629174",
      "Unnamalakada S.O": "629179",
      "Colachel Port S.O": "629251",
      "Eathamozhi S.O": "629501",
      "Nagercoil Collectorate S.O": "629001",
      "Nagercoil Industrial Estate S.O": "629004",
      "Nagercoil Town S.O": "629001",
      "Neyyoor S.O": "629802",
      "Oluganacheri S.O": "629001",
      "Puthalam S.O": "629602",
      "Suchindrum S.O": "629704",
      "Thazhakudy S.O": "629901",
      "Vadiveeswaram S.O": "629001",
      "Kanjampuram S.O": "629154",
      "Keezhkulam S.O": "629193",
      "Kodayarkilthangal S.O": "629102",
      "Kuzhithurai S.O": "629163",
      "Marthandam Bridge S.O": "629165",
      "Udayamarthandam S.O": "629178"
    },
    "VIRUDHUNAGAR": {
      "VMuthulingapuram BO": "626119",
      "Mamsapuram BO": "626124",
      "Maraneri BO": "626124",
      "Vilampatti BO": "626124",
      "Athikulam BO": "626135",
      "Nachiyarkoil BO": "626135",
      "Inamkarisalkulam BO": "626125",
      "Vaithilingapuram BO": "626125",
      "Kunnur South BO": "626126",
      "Edirkottai BO": "626131",
      "Kallamanaickenpatti BO": "626131",
      "Kangarseval BO": "626131",
      "Karisalpatti BO": "626201",
      "Panayadipatti BO": "626201",
      "Sankarapandiapuram BO": "626201",
      "Sengundrapuram BO": "626103",
      "Thailapuram BO": "626149",
      "Padanthal BO": "626203",
      "Settudayanpatti BO": "626203",
      "Surangudi BO": "626203",
      "Thungareddiapatti BO": "626203",
      "Mulliseval BO": "626205",
      "NSubbiahpuram BO": "626205",
      "Vadamalaikurichi BO": "626002",
      "Anuppankulam BO": "626189",
      "Meenampatti BO": "626189",
      "Mudalipatti BO": "626189",
      "Naranapuram BO": "626189",
      "SRamachandrapuram BO": "626126",
      "Salvarpatti BO": "626128",
      "Anaikuttam BO": "626130",
      "MPudupatti BO": "626130",
      "Sengamalanachiapuram BO": "626130",
      "Vadamalapuram BO": "626130",
      "Kundayiruppu BO": "626131",
      "Mullipatti BO": "626005",
      "Valliyur BO": "626005",
      "Vellur BO": "626005",
      "Pavali BO": "626103",
      "Karisalkulam BO": "626149",
      "Kottaiyur BO": "626149",
      "Melathulukkankulam BO": "626109",
      "Kosugundu BO": "626202",
      "Nathathupatti BO": "626202",
      "Avudayapuram BO": "626204",
      "Kottaiyur Gurusamy koil BO": "626204",
      "A Pudupatti BO": "626204",
      "TSedapatti BO": "626204",
      "ARamalingapuram BO": "626203",
      "Venkatachalapuram BO": "626203",
      "Inamreddiapatti BO": "626003",
      "Meesalur BO": "626003",
      "Sippiparai B.O": "627713",
      "Guhanparai BO": "626140",
      "Sithurajapuram BO": "626189",
      "Boovanathapuram BO": "626124",
      "Kakkivadanpatti BO": "626124",
      "Pillayarnatham BO": "626125",
      "Vetrilaiyurani BO": "626128",
      "Alamarathupatti BO": "626130",
      "Vijayakarisalkulam BO": "626131",
      "MepcoEnggCollege BO": "626005",
      "Kadaneri BO": "626149",
      "Alagianallur BO": "626109",
      "Periaperali BO": "626109",
      "Chockalingapuram BO": "626108",
      "Thulukkapatti RS BO": "626204",
      "Gollapatti BO": "626203",
      "Naduvapatti BO": "626203",
      "Nalli BO": "626205",
      "Kokkalanjeri BO": "626002",
      "Soolakkarai BO": "626003",
      "Muthulapuram BO": "626119",
      "Sinnakamanpatti BO": "626189",
      "Viswanatham BO": "626189",
      "Anaiyur BO": "626124",
      "Injar BO": "626124",
      "Meenakshipuram BO": "626111",
      "Subramaniapuram BO": "626128",
      "Pudukottai BO": "626103",
      "Ilandaikulam BO": "626149",
      "Villipathiri BO": "626109",
      "Irukkangudi BO": "626202",
      "Appayanaickenpatti BO": "626127",
      "Thulukkapatti BO": "626204",
      "Mettamalai BO": "626203",
      "Othayal Mettupatti BO": "626203",
      "Odaipatti BO": "626205",
      "Chatrareddiapatti BO": "626002",
      "Pattampudur BO": "626003",
      "Pulvoikarai BO": "630611",
      "Rajapalayam HO": "626117",
      "Vadhuvarpatti BO": "626134",
      "Chithumoondradaippu BO": "626106",
      "Mudukkankulam BO": "626106",
      "Mustakurichi BO": "626106",
      "Pampatti BO": "626106",
      "Mandapasalai BO": "626118",
      "Maravarperungudi BO": "626118",
      "Pungamarathupatti BO": "626118",
      "RKallumadam BO": "626118",
      "Isali BO": "626607",
      "Maraikulam BO": "626607",
      "Nalur BO": "626607",
      "Siruvanur BO": "626607",
      "Amanakkunatham BO": "626112",
      "TMeenakshipuram BO": "626112",
      "Koppusithampatti BO": "626113",
      "Iluppaiyur BO": "626129",
      "Karendal BO": "626129",
      "Panaiyur BO": "626129",
      "Tamilpadi BO": "626129",
      "Ramalingapuram BO": "626102",
      "Samsigapuram BO": "626102",
      "Lakshmipuram BO": "626127",
      "Melanmarainadu BO": "626127",
      "Mangalam BO": "626138",
      "Moovaraivendran BO": "626138",
      "PSallipatti BO": "626138",
      "Achankulam BO": "626141",
      "Mallipudur BO": "626141",
      "Achanthavirthan BO": "626137",
      "Nathikudi BO": "626137",
      "PRamachandrapuram BO": "626137",
      "Virudhunagar HO": "626001",
      "Aruppukottai HO": "626101",
      "Pappakudi BO": "626134",
      "Manthoppu BO": "626104",
      "Chatrapuliyankulam BO": "626106",
      "Kattangudi BO": "626107",
      "Thummusinnampatti BO": "626118",
      "Alagapuri BO": "626607",
      "Ulagudi BO": "626607",
      "Kullursandai BO": "626004",
      "Kurundamadam BO": "626112",
      "Sengulam BO": "626114",
      "Thoppalakarai BO": "626114",
      "Aviyur BO": "626115",
      "Kurandi BO": "626115",
      "P Thottiankulam BO": "626129",
      "Kattanur BO": "630610",
      "Valacheri BO": "630611",
      "Irunjirai BO": "626612",
      "Nallamanaickenpatti BO": "626102",
      "Kilavikulam BO": "626139",
      "Sivalingapuram BO": "626136",
      "Thombakulam BO": "626136",
      "Puthur BO": "626111",
      "Chockanathanpudur BO": "626121",
      "Ayankollangondan BO": "626142",
      "Sundararajapuram BO": "626142",
      "Alangulam BO": "626127",
      "Sethunarayanapuram BO": "626132",
      "Ayanathampatti BO": "626138",
      "Villupanur BO": "626138",
      "TManagaseri BO": "626141",
      "Saminatham BO": "626141",
      "Chidambarapuram BO": "626134",
      "Allalaperi BO": "626106",
      "Vairavanangoor BO": "626106",
      "Vedanatham BO": "626118",
      "Sukkilanatham BO": "626112",
      "Vellayapuram BO": "626112",
      "Sudhamadam BO": "626114",
      "Kuchampatti BO": "626129",
      "Sennilaikudi BO": "626129",
      "Dharmam BO": "626612",
      "Peruvelangudi BO": "626612",
      "Nathampatti BO": "626102",
      "Solapuram BO": "626139",
      "Vadakarai BO": "626136",
      "Melapattamkarisalkulam BO": "626110",
      "Pottalpatti BO": "626111",
      "Devadanam BO": "626121",
      "Krishnapuram BO": "626142",
      "Valayapatti BO": "626127",
      "Seshapuram BO": "626116",
      "Nedungulam BO": "626138",
      "Sivakasi HO": "626123",
      "Perunjalai Pudupatti BO": "626104",
      "Vakkanangundu BO": "626104",
      "Kalayar Karisalkulam BO": "626105",
      "Puliyuran BO": "626105",
      "Ramasamy Nagar BO": "626105",
      "Sembatti BO": "626105",
      "Malaipatti BO": "626004",
      "Mettugundu BO": "626004",
      "Periavallikulam BO": "626004",
      "Sennelgudi BO": "626004",
      "KChettikulam BO": "626114",
      "Kilgudi BO": "626114",
      "Poolangal BO": "626114",
      "Vadakkunatham BO": "626114",
      "Kambikudi BO": "626115",
      "Aladipatti BO": "626129",
      "Anaikulam BO": "626129",
      "Gopalapuram BO": "626136",
      "RReddiapatti BO": "626136",
      "Khansapuram BO": "626133",
      "Pilavakkaldam BO": "626133",
      "Therkuvenganallur BO": "626142",
      "Zaminkollangondan BO": "626142",
      "Aruppukottai West SO": "626101",
      "Kalkurichi SO": "626104",
      "MReddiapatti SO": "626118",
      "Narikudi SO": "626607",
      "Palavanatham SO": "626004",
      "Pandalgudi SO": "626113",
      "Athipatti SO": "626161",
      "Kummapatti SO": "626133",
      "Rajapalayam Ambalapuli Bazzar SO": "626117",
      "Settiyarpatti SO": "626122",
      "Sundaranachiarpuram SO": "626142",
      "Sevalpatti SO": "626140",
      "Srivilliputhur SO": "626125",
      "Thayilpatti SO": "626128",
      "Aruppukottai East SO": "626101",
      "Aruppukottai Nehru Maidanam SO": "626101",
      "Kariapatti SO": "626106",
      "Chatrapatti SO Virudhunagar": "626102",
      "Dhalavaipuram SO": "626188",
      "Kilarajakularaman SO": "626136",
      "Kumarasamy Raja Nagar SO": "626108",
      "Muhavur SO": "626111",
      "Rajapalayam Bazzar SO": "626117",
      "Tamilnadu Cements Alangulam SO": "626127",
      "Watrap SO": "626132",
      "Malli SO": "626141",
      "Sivakasi R S SO": "626123",
      "Srivilliputhur Court Complex SO": "626135",
      "Srivilliputhur North SO": "626125",
      "Nenmeni SO": "626202",
      "Ramasamy Raja Nagar SO": "626204",
      "Sattur West SO": "626203",
      "Virudhunagar Collectorate SO": "626002",
      "Tiruthangal SO": "626130",
      "Kamaraj Nagar SO": "626001",
      "Maharajapuram SO": "626149",
      "Mallanginar SO": "626109",
      "Virudhunagar Bazaar SO": "626001",
      "Virudhunagar Bus Stand SO": "626001",
      "Virudhunagar Extension SO": "626001",
      "Aruppukottai Court SO": "626101",
      "Kallurani SO": "626105",
      "Paralachi SO": "626114",
      "Sethu Institute of Technology SO": "626115",
      "Viracholan SO": "626612",
      "Pudupalayam SO Virudhunagar": "626117",
      "Rajapalayam Bus Stand SO": "626117",
      "Kunnur SO": "626138",
      "Pillayarkulam SO": "626137",
      "Sankaralingapuram SO": "626119",
      "Sivakasi Bazzar SO": "626123",
      "Sivakasi West SO": "626124",
      "Sundarapandiam SO": "626126",
      "Amathur SO": "626005",
      "Virudhunagar Industrial Estate SO": "626003",
      "Virudhunagar North SO": "626001",
      "Kooraikundu SO": "626001",
      "Aruppukottai Bazzar SO": "626101",
      "Chettikurichi SO": "626134",
      "Kovilangulam SO": "626107",
      "Palayampatti SO": "626112",
      "Tiruchuli SO": "626129",
      "Cholapuram South SO": "626139",
      "Mohamed Sahibpuram SO": "626110",
      "Seithur SO": "626121",
      "W Pudupatti SO": "626116",
      "Madavarvilagam SO": "626125",
      "Sivakasi East SO": "626189",
      "Vembakottai SO": "626131",
      "Elayirampannai SO": "626201",
      "Erichanatham SO": "626103",
      "Sattur SO": "626203",
      "Uppathur SO": "626205",
      "Virudhunagar Town SO": "626001"
    },
    "Ranipet": {
      "Perunkanchi BO": "631102",
      "Rendadi BO": "631102",
      "Somasamudram BO": "631102",
      "Talikkal BO": "631102",
      "Thathireddipalle BO": "632516",
      "Kalmelkuppam BO": "632501",
      "Ladavaram BO": "632503",
      "Muppathuvetti BO": "632503",
      "Pudupadi BO": "632503",
      "Velur Kalavai BO": "632506",
      "Manthangal BO": "632404",
      "Puliyankannu BO": "632404",
      "Thengal BO": "632404",
      "Vanapadi BO": "632404",
      "Sambasivapuram BO": "632507",
      "Varagur BO": "632507",
      "Venkatapuram BO": "632507",
      "Alapakkam BO": "632508",
      "Kadaperi BO": "632508",
      "Vembi BO": "632518",
      "Arapakkam BO": "632517",
      "Esayanur BO": "632511",
      "Natteri BO": "632511",
      "Mohamedpet BO": "632512",
      "Nambarai BO": "632512",
      "Jambukulam BO": "631102",
      "Karikkal BO": "631102",
      "Arigilapadi BO": "631151",
      "Iluppaithandalam BO": "631151",
      "Katrambakkam BO": "632501",
      "Marudhalam BO": "632501",
      "Thalangai BO": "632501",
      "Vangur BO": "632501",
      "Velam BO": "632501",
      "Kilvisharam BO": "632509",
      "Karikkanthangal BO": "632506",
      "Mazharyur BO": "632506",
      "Mecheri BO": "632506",
      "Melnathambakkam BO": "632506",
      "Vellambi BO": "632506",
      "Thiruparkadal BO": "632508",
      "Thuraiperumbakkam BO": "632508",
      "Ekambaranallur BO": "632405",
      "Jawaharpuram BO": "632503",
      "Durgam BO": "632512",
      "Seekarajapuram BO": "632515",
      "Mambakkam BO": "632318",
      "Sattur BO": "632521",
      "Tajpura BO": "632521",
      "Uppupettai BO": "632521",
      "Thenkadapanthangal BO": "632513",
      "Asamandhur BO": "632502",
      "Kattupakkam BO": "632502",
      "Meleri BO": "632502",
      "Melkalathur BO": "632502",
      "Polipakkam BO": "632505",
      "Pulivalam BO": "632505",
      "Seyyoor BO": "631004",
      "Kondakuppam BO": "632520",
      "Akkachikuppam BO": "632510",
      "Tirumalpur BO": "631051",
      "Kilvenbakkam BO": "631051",
      "Karnavur BO": "631052",
      "Melapulam BO": "631052",
      "Pillaipakkam BO": "631052",
      "Vasur BO": "632514",
      "Ayipedu BO": "631102",
      "Surai BO": "632505",
      "Kilkuppam B.O": "631004",
      "Chitteri BO": "631003",
      "Kainoor BO": "631003",
      "Kilandur BO": "631003",
      "Kumpinipet BO": "631003",
      "Vadamambakkam BO": "631003",
      "Valaikulam BO": "631003",
      "Gudalur BO": "632510",
      "Kunnathur BO": "632510",
      "Attupakkam BO": "631051",
      "Sendamangalam BO": "631051",
      "Perumbulipakkam BO": "632531",
      "Sirukarumbur BO": "632531",
      "Nagavedu BO": "631002",
      "Perumuchi BO": "631002",
      "Sirunamalli BO": "631002",
      "Kesavanankuppam BO": "631102",
      "Kondapalayam BO": "631102",
      "Vangupattu BO": "631102",
      "Kadambainallore BO": "631151",
      "Uriyur BO": "631151",
      "Neelakandarayanpattai BO": "632501",
      "Palayamangadu BO": "632503",
      "Agaram BO": "632506",
      "Arumbakkam BO": "632506",
      "GBNagar BO": "632506",
      "Anaimallur BO": "632507",
      "Punganur BO": "632507",
      "Pagaveli BO": "632508",
      "Seri BO": "632508",
      "Ayilam BO": "632509",
      "Senganavaram BO": "632518",
      "Kilminnal BO": "632517",
      "Nandiyalam BO": "632517",
      "Puttuthakku BO": "632517",
      "Ananthangal BO": "632511",
      "Pulivalam Sunaipattu BO": "632511",
      "Sathambakkam BO": "632513",
      "Valluvambakkam BO": "632513",
      "Kilveedhi BO": "632502",
      "Mahendravadi BO": "632502",
      "Ayal BO": "632505",
      "Palayapalayamottur BO": "632505",
      "Puliyamangalam BO": "631004",
      "Mittapettai BO": "631101",
      "Perungalathur BO": "631003",
      "Chengalnatham BO": "632520",
      "Paranji BO": "632510",
      "Pallur BO": "631051",
      "Kalathur BO": "632531",
      "Ammanur BO": "631002",
      "Jagirthandalam BO": "631052",
      "Peruvalayam BO": "631052",
      "Reddivalam BO": "631052",
      "Manamadurai BO": "632502",
      "Govindacherrykuppam BO": "632505",
      "Kilveeranam BO": "632505",
      "Kavanur BO": "631004",
      "Mosur BO": "631004",
      "Kizhavanam BO": "631101",
      "Nandiveduthangal BO": "631101",
      "Anaipakkam BO": "631003",
      "Ichiputhur BO": "631003",
      "Kilpakkam BO": "631003",
      "Mudur BO": "631003",
      "Thanigaipolur BO": "631003",
      "Paravathur BO": "632510",
      "Ganapathipuram BO": "631051",
      "Kilvenkatapuram BO": "631051",
      "Sayanavaram BO": "631051",
      "Ayarpadi BO": "632531",
      "Kilandurai BO": "631002",
      "Parithiputhur BO": "631002",
      "Ulianallore BO": "631052",
      "Palayanur BO": "632512",
      "Melapudupakkam BO": "632318",
      "Soraiyur BO": "632318",
      "Anandhalai BO": "632513",
      "Gudimallur BO": "632513",
      "Poondi BO": "632513",
      "Irungur BO": "604407",
      "Kodakkal BO": "631102",
      "Pandianallore BO": "631102",
      "Mangattucherry BO": "631151",
      "Sagayathottam BO": "631151",
      "Ozhughur BO": "632501",
      "Periasengadu BO": "632501",
      "Valayathur BO": "632504",
      "Federation Buildings BO": "632509",
      "Chennasamudram BO": "632506",
      "Kaniyanur BO": "632506",
      "Rottukadai BO": "632508",
      "Sumaithangi BO": "632508",
      "Arungundram BO": "632509",
      "Melakuppam BO": "632517",
      "Gundaleri BO": "632512",
      "Paradarami BO": "632512",
      "Thirumalaicheryy BO": "632513",
      "Vannivedu BO": "632513",
      "Banavaram SO": "632505",
      "Minnal SO": "632510",
      "Palanipet SO": "631002",
      "Sholingur Bazaar SO": "631102",
      "Suraksha Cisf Campus SO": "631152",
      "Arcot SO": "632503",
      "Mukundarayapuram SO": "632405",
      "Pennagar SO": "632518",
      "Sakkaramallur SO": "632511",
      "Valapandal SO": "632318",
      "Walajapet Bazaar SO": "632513",
      "Ranipet HO": "632401",
      "Anvardhikhanpet SO": "632502",
      "Ekhunagar SO": "631004",
      "Jothinagar SO": "631003",
      "Sholingur SO": "631102",
      "Takkolam SO": "631151",
      "Winterpet SO": "631005",
      "Bhel Ranipet SO": "632406",
      "Damarapakkam SO": "632504",
      "Navalpur SO": "632401",
      "Ranipet Bazar SO": "632401",
      "Ratnagiri Kilminnal SO": "632517",
      "Arakkonam HO": "631001",
      "Ashoknagar SO Vellore": "631001",
      "Ocheri SO": "632531",
      "Arcot Bazaar SO": "632503",
      "Arcot West SO": "632503",
      "Hakeemnagar SO": "632509",
      "Karai SO": "632404",
      "Melvisharam SO": "632509",
      "Guruvarajpet SO": "631101",
      "Ins Rajali SO": "631006",
      "Namali SO": "631051",
      "Panapakkam SO": "631052",
      "Ammoor SO": "632501",
      "Kalavai SO": "632506",
      "Kavanur SO": "632507",
      "Kaveripak SO": "632508",
      "Vilapakkam SO": "632521",
      "Ranipet Industrial Estate SO": "632403",
      "Timiri SO": "632512",
      "Walajapet SO": "632513"
    },
    "THENI": {
      "Annanji B.O": "625531",
      "Buthipuram B.O": "625531",
      "Uppukottai B.O": "625534",
      "Venkatachalapuram B.O": "625534",
      "Bodidasanpatti B.O": "625536",
      "P.Dharmathupatti B.O": "625536",
      "Pullimankombai B.O": "625536",
      "T.V.Renganathapuram B.O": "625536",
      "Agamalai B.O": "625605",
      "Jeyamangalam B.O": "625603",
      "Melmangalam B.O": "625603",
      "Koilpatti B.O": "625562",
      "Vaigaiproject B.O": "625562",
      "Gopalapuram B.O": "625534",
      "Koduvilarpatti B.O": "625534",
      "Ethakovil B.O": "625536",
      "Rajagopalanpatti B.O": "625536",
      "Thimmarasanayakanur B.O": "625536",
      "Murugamalainagar B.O": "625605",
      "Ammatchiapuram B.O": "625531",
      "Kodangipatti B.O": "625531",
      "Gullapuram B.O": "625562",
      "Rengasamudram B.O": "625562",
      "Kottur B.O": "625534",
      "Tadichery B.O": "625534",
      "T.Kallipatti B.O": "625605",
      "Kunnur B.O": "625531",
      "Vaigaidamsite B.O": "625562",
      "Srirengapuram B.O": "625534",
      "Upparpatti B.O": "625534",
      "Erasakkanayakanur B.O": "625515",
      "Kanniservaipatti B.O": "625515",
      "Kujjanur B.O": "625515",
      "Seelayampatti B.O": "625515",
      "Karunagamuthanpatti B.O": "625516",
      "Kullappagoundanpatti B.O": "625516",
      "Surulipatti B.O": "625516",
      "Venniar Estate B.O": "625519",
      "Melasindalachery B.O": "625524",
      "Pallavarayanpatti B.O": "625524",
      "Pulikuthi B.O": "625524",
      "Suruliyar Lower Camp B.O": "625525",
      "Anamalayanpatti B.O": "625526",
      "Bodimettu B.O": "625582",
      "Bodinayakanur R.S. B.O": "625582",
      "Central Station B.O": "625582",
      "Sindalacherry B.O": "625530",
      "T.Meenatchipuram B.O": "625530",
      "Thamminayakanpatti B.O": "625530",
      "Hanumanthanpatti B.O": "625533",
      "U.Ammapatti B.O": "625533",
      "Ammapatti B.O": "625512",
      "Kanniappapillaipatti B.O": "625512",
      "Bomminayakanpatti B.O": "625602",
      "Erumalainayakanpatti B.O": "625602",
      "G.Usilampatti B.O": "625517",
      "Govindagaram B.O": "625517",
      "Marikundu B.O": "625517",
      "Okkaraipatti B.O": "625517",
      "Kombaitholu B.O": "625579",
      "Kumananthozhu B.O": "625579",
      "Mayiladumparai B.O": "625579",
      "Moolakadai B.O": "625579",
      "Poosanuthu B.O": "625579",
      "Varushanadu B.O": "625579",
      "Koolayanur B.O": "625515",
      "Markeyankottai B.O": "625515",
      "Muthulapuram B.O": "625515",
      "Keelagudalur B.O": "625518",
      "Dharmapuri B.O": "625520",
      "Narayanathevanpatti B.O": "625521",
      "Vellaiyammalpuram B.O": "625540",
      "B.Ammapatti B.O": "625528",
      "Pottipuram B.O": "625528",
      "B.Meenakshipuram B.O": "625582",
      "Dombcherry B.O": "625582",
      "Kottagudi B.O": "625582",
      "Krishnampatti B.O": "625530",
      "Sankarapuram B.O": "625530",
      "Kothapatti B.O": "625512",
      "Palacombai B.O": "625512",
      "Silvarpatti B.O": "625602",
      "G.Kallupatti B.O": "625203",
      "Kovilparai B.O": "625579",
      "Siraparai B.O": "625579",
      "Endapuli B.O": "625604",
      "Kuppinayakanpatti B.O": "625520",
      "Poomalaikundu B.O": "625520",
      "Seepalakottai B.O": "625540",
      "Sukkangalpatti B.O": "625540",
      "Rasingapuram B.O": "625528",
      "Silamalai B.O": "625528",
      "Kurangani B.O": "625582",
      "Melachokkanathapuram B.O": "625582",
      "Rajadhani B.O": "625512",
      "Rosanampatti B.O": "625512",
      "Shunmugasundarapuram B.O": "625512",
      "Theppampatti B.O": "625512",
      "Manjalar Dam B.O": "625602",
      "Sathakoilpatti B.O": "625602",
      "Thummagundu B.O": "625579",
      "Alagapuri B.O": "625523",
      "Nallakaruppanpatti B.O": "625604",
      "Megamalai B.O": "625515",
      "Angoorpal B.O": "625518",
      "Manalar B.O": "625519",
      "Jangalpatti B.O": "625520",
      "Gokilapuram B.O": "625526",
      "Nagalapuram B.O": "625528",
      "Anaikaraipatti B.O": "625582",
      "Kamarajapuram B.O": "625582",
      "Lakshminayakanpatti B.O": "625530",
      "Kothaloothu B.O": "625512",
      "Mottanuthu B.O": "625512",
      "A.Vadipatti B.O": "625602",
      "Athankaraipatti B.O": "625517",
      "Thekkampatti B.O": "625517",
      "Thangammalpuram B.O": "625579",
      "Saruthupatti B.O": "625523",
      "Chinnaovalapuram B.O": "625515",
      "Bodinayakanur H.O": "625513",
      "Periyakulam H.O": "625601",
      "Appipatti B.O": "625515",
      "C.Pudupatti S.O": "625556",
      "Cumbum S.O (Theni)": "625516",
      "Gandhinagar (Cumbum) S.O": "625516",
      "Pannaipuram S.O": "625524",
      "Thevaram S.O": "625530",
      "Uthamapalayam West S.O": "625533",
      "Allinagaram S.O": "625531",
      "Bangalamedu S.O": "625531",
      "Palanichettipatti S.O": "625531",
      "T.Nagar (Theni) S.O": "625531",
      "Chinnamanur S.O": "625515",
      "Kamayakoundanpatti S.O": "625521",
      "Periyar Project S.O": "625525",
      "Uthamapalayam Bazar S.O": "625533",
      "Aundipatti S.O": "625512",
      "Genguvarpatti S.O": "625203",
      "Kadamalaikundu S.O": "625579",
      "Varadharajnagar S.O": "625562",
      "Veerapandi S.O (Theni)": "625534",
      "Gudalur S.O": "625518",
      "Highwavys S.O": "625519",
      "Kombai S.O": "625522",
      "Odaipatti S.O": "625540",
      "Royappanpatti S.O": "625526",
      "Subburajnagar S.O": "625582",
      "Uthamapalayam S.O": "625533",
      "Devadanapatti S.O": "625602",
      "Gandamanayakanur S.O": "625517",
      "Lakshmipuram S.O (Theni)": "625523",
      "Periyakulam East S.O": "625604",
      "T.Subbulapuram S.O": "625536",
      "Tamarakulam S.O": "625605",
      "Kamatchipuram S.O": "625520",
      "Sillamarathupatti S.O": "625528",
      "Periyakulam Bazaar S.O": "625601",
      "Theni S.O": "625531",
      "Vadagarai S.O": "625601",
      "Vadugapatti S.O": "625603"
    },
    "MADURAI": {
      "Sithalai BO": "625706",
      "Thangalacheri BO": "625706",
      "Tirali BO": "625706",
      "AVellalapatti BO": "625301",
      "Kallandiri BO": "625301",
      "Kidaripatti BO": "625301",
      "Kalimangalam BO": "625020",
      "Karuppayurani BO": "625020",
      "Varichiyur BO": "625020",
      "Kachirayanpatti BO": "625101",
      "Kambur BO": "625101",
      "Kunnarampatti BO": "625101",
      "Mangalampatti BO": "625101",
      "Muthusamypatti BO": "625102",
      "Ayyapatti BO": "625103",
      "Karuvanur BO": "625014",
      "Tirumalpuram BO": "625014",
      "Tiruppalai BO": "625014",
      "Arukkampatti BO": "625105",
      "Rajakkur BO": "625107",
      "Tirumoghur BO": "625107",
      "Uthangudi BO": "625107",
      "Chittampatti BO": "625122",
      "Narsingampatti BO": "625122",
      "Thummagundu B.O": "625529",
      "Tidiyan B.O": "625529",
      "Veppanuthu B.O": "625529",
      "Meikilarpatti B.O": "625532",
      "Nakkalapatti B.O": "625532",
      "Ayyanarkulam B.O": "625537",
      "Eravarpatti B.O": "625537",
      "Kalluthu B.O": "625537",
      "Budamangalam BO": "625108",
      "Kodukkampatti BO": "625108",
      "Poonjuthi BO": "625110",
      "Therkilamur BO": "625110",
      "Alampatti BO": "625706",
      "Kangeyanatham BO": "625706",
      "Karadikal BO": "625706",
      "Ponnamangalam BO": "625706",
      "Urappanur BO": "625706",
      "Vagaikulam BO": "625017",
      "Veeraperumalpuram BO": "625706",
      "Vidathakulam BO": "625706",
      "Thanakkankulam BO": "625006",
      "Vilacheri BO": "625006",
      "MPuliyankulam BO": "625707",
      "Kulamangalam BO": "625017",
      "Andarkottaram BO": "625020",
      "Kongampatti BO": "625102",
      "Chockalingapuram BO": "625103",
      "Manappachery BO": "625103",
      "Pallapatti BO": "625103",
      "Pandangudi BO": "625103",
      "Anuppanady BO": "625009",
      "Chintamani BO": "625009",
      "Arumbanur BO": "625104",
      "Ettimangalam BO": "625105",
      "Kesampatti BO": "625105",
      "Pattur BO": "625105",
      "Kallampatti BO": "625106",
      "Navinipatti BO": "625106",
      "Pudusukkampatti BO": "625106",
      "Suragundu BO": "625106",
      "Puliankulam BO": "625201",
      "Sakkimangalam BO": "625201",
      "Ambalakaranpatti BO": "625109",
      "Kottanathampatti BO": "625109",
      "Vadugapatti B.O": "625532",
      "M.Kallupatti B.O": "625535",
      "Mallapuram B.O": "625535",
      "Seelnayakanpatti B.O": "625535",
      "Sulapuram B.O": "625535",
      "Perungamanallur B.O": "625527",
      "Poosalapuram B.O": "625527",
      "AAmmapatti BO": "625706",
      "Arasapatti BO": "625706",
      "Nedungulam BO": "625706",
      "SPNatham BO": "625706",
      "Lalapuram BO": "625707",
      "Mangulam BO": "625301",
      "Pulipatti BO": "625301",
      "Buthagudi BO": "625017",
      "Vandiyur BO": "625020",
      "Othakoilpatti BO": "625101",
      "Vanjinagaram BO": "625101",
      "Malampatti BO": "625102",
      "Pottapatti BO": "625103",
      "Surapatti BO": "625103",
      "Panaiyur BO": "625009",
      "Viradhanur BO": "625009",
      "Kodikulam BO": "625514",
      "Sennagarampatti BO": "625105",
      "Arittapatti BO": "625106",
      "Kilaiyur BO": "625106",
      "Pathinettangudi BO": "625106",
      "Puduthamaraipatti BO": "625107",
      "TVellalapatti BO": "625122",
      "Alagichipatti BO": "625109",
      "Kurichipatti BO": "625109",
      "Thaniyamangalam BO": "625109",
      "Sembarani B.O": "625527",
      "Kalappanpatti B.O": "625529",
      "Poruppumettupatti B.O": "625529",
      "Boothipuram B.O": "625532",
      "Pothampati B.O": "625532",
      "Vagurani B.O": "625532",
      "Valandur B.O": "625532",
      "Kuravagudi B.O": "625537",
      "Thimmanatham B.O": "625537",
      "E.Kottapatty B.O": "625535",
      "Thadayampatti B.O": "625535",
      "S.Kottaipatti B.O": "625527",
      "Nilaiyur BO": "625005",
      "Achampatti BO": "625501",
      "Melakottai BO": "625706",
      "Royapalayam BO": "625706",
      "Sathangudi BO": "625706",
      "Sevarakottai BO": "625706",
      "Chitoor BO": "625707",
      "Appantiruppathi BO": "625301",
      "Lakshmipuram BO": "625301",
      "Mathur BO": "625301",
      "Kattathevanpatti B.O": "625529",
      "T.Uchapatti B.O": "625529",
      "Ariyapatti B.O": "625532",
      "Doddappanayakanur B.O": "625532",
      "Nattamangalam B.O": "625532",
      "Pappapatti B.O": "625537",
      "Vellamalaipatti B.O": "625537",
      "Jothilnayakanur B.O": "625535",
      "T.Ramanathapuram B.O": "625535",
      "Tirumanickam B.O": "625535",
      "Uthapuram B.O": "625535",
      "Anaiyur HB Colony BO": "625017",
      "Sakkudi BO": "625020",
      "Nattarmangalam BO": "625101",
      "Sekkipatti BO": "625101",
      "Sokkampatti BO": "625103",
      "Thonthilingapuram BO": "625103",
      "Valaicheripatti BO": "625103",
      "Samanatham BO": "625009",
      "Viraganur BO": "625009",
      "Chatrapatti BO": "625014",
      "Kancharampettai BO": "625014",
      "Velichanatham BO": "625014",
      "Vowalthottam BO": "625104",
      "Kottagudi BO": "625106",
      "Kathakinaru BO": "625107",
      "Ilamanur BO": "625201",
      "Poosaripatti BO": "625122",
      "Vellaripatti BO": "625122",
      "Attapatti BO": "625108",
      "Saruguvalayapatti BO": "625109",
      "Uranganpatti BO": "625109",
      "Athipatti B.O": "625705",
      "Kuduseri B.O": "625705",
      "Thullukuttinayakanur B.O": "625705",
      "Vandari B.O": "625705",
      "Veppampatti B.O": "625705",
      "Allikundam B.O": "625527",
      "Athikaripatti B.O": "625527",
      "Kuppalnatham B.O": "625527",
      "Manuthu B.O": "625527",
      "T.Krishnapuram B.O": "625705",
      "Chinnakattalai B.O": "625527",
      "Kethuvarpatti B.O": "625705",
      "Palaiyur B.O": "625705",
      "Vandapuli B.O": "625705",
      "Erumarpatti B.O": "625527",
      "Errampatti BO": "625501",
      "Kallanai BO": "625501",
      "Kuttimeichanpatti BO": "625501",
      "Mettupatti BO": "625501",
      "Vavidaimaruthur BO": "625501",
      "AKokkulam BO": "625514",
      "Chellampatti BO": "625514",
      "Chettikulam BO": "625514",
      "Jothimanickam BO": "625514",
      "Nadumudalaikulam BO": "625514",
      "Nachikulam BO": "625205",
      "Chatravellalapatti BO": "625503",
      "Paravai BO": "625402",
      "Siruvalai BO": "625402",
      "Thenur BO": "625402",
      "Sithalangudi BO": "625221",
      "Thiruvalavayanallur BO": "625221",
      "Melakkal BO": "625234",
      "Royapuram BO": "625234",
      "Tiruvedagam West BO": "625234",
      "Avalsurampatti BO": "625701",
      "Sivanandanagar BO": "625008",
      "Thoppur BO": "625008",
      "Madakkulam BO": "625003",
      "Deivanayagapuram BO": "625703",
      "Koovalapuram BO": "625703",
      "Pappayapuram BO": "625703",
      "Sandaiyur BO": "625703",
      "Silamalaipatti BO": "625703",
      "Kudakoil BO": "625022",
      "MSubbulapuram BO": "625702",
      "Nallamaram BO": "625702",
      "Silarpatti BO": "625702",
      "Ayyur BO": "625501",
      "Valasai BO": "625501",
      "Kinnimangalam BO": "625514",
      "Kovilangulam BO": "625514",
      "Melanachikulam BO": "625205",
      "Kochadai BO": "625016",
      "Sendamangalam BO": "625503",
      "Vayalur BO": "625402",
      "Ayyankottai BO": "625221",
      "Kondayampatti BO": "625221",
      "Podumbu BO": "625018",
      "Kachirayiruppu BO": "625234",
      "Kodimangalam BO": "625234",
      "Andipatti BO": "625218",
      "Kachakatti BO": "625218",
      "KSennampatti BO": "625701",
      "Marudangudi BO": "625701",
      "Mangalrevu BO": "625703",
      "Periyapoolampatti BO": "625703",
      "Kusavangundu BO": "625022",
      "Nallur BO": "625022",
      "SNCollege BO": "625022",
      "Karaikeni BO": "625702",
      "Vannivelampatti BO": "625702",
      "AThottiapatti BO": "625704",
      "Sowdarpatti BO": "625704",
      "Harveypatti BO": "625005",
      "Mudalaikulam BO": "625514",
      "Irumbadi BO": "625205",
      "Virattipathu BO": "625016",
      "Kadupatti BO": "625207",
      "Nariampatti BO": "625207",
      "Sakkarappanaickanur BO": "625207",
      "Vikramangalam BO": "625207",
      "Erkudi Achampathu BO": "625019",
      "Pulluthu BO": "625019",
      "Thuvariman BO": "625019",
      "Kodangipatti BO": "625503",
      "Thenpalanji BO": "625021",
      "Vadapalanji BO": "625021",
      "Pandiarajapuram BO": "625218",
      "Vilangudi BO": "625018",
      "Vadakkampatti BO": "625701",
      "Vellakulam BO": "625701",
      "Kappalur BO": "625008",
      "Koothiyargundu BO": "625008",
      "Solanguruni BO": "625022",
      "TKokkulam BO": "625022",
      "Tirumal BO": "625022",
      "Valayankulam BO": "625022",
      "Valayapatti BO": "625022",
      "Koppinaickanpatti BO": "625702",
      "MPudupatti BO": "625702",
      "Velambur BO": "625702",
      "Ganjampatti BO": "625708",
      "Pappanaickenpatti BO": "625708",
      "Solaipatti BO": "625708",
      "Appakarai BO": "625704",
      "Kilavaneri BO": "625704",
      "Madipanur BO": "625704",
      "Sengapadai BO": "625704",
      "APudupatti BO": "625501",
      "Alagapuri BO": "625501",
      "Karumathur BO": "625514",
      "Ponmeni BO": "625016",
      "Ayyankuruvithurai BO": "625207",
      "Mannadimangalam BO": "625207",
      "Thenkarai BO": "625207",
      "Kilakuyilkudi BO": "625019",
      "Vadivelkarai BO": "625019",
      "Muduvarpatti BO": "625503",
      "Tettur BO": "625503",
      "Vellayampatti BO": "625503",
      "Thodaneri BO": "625402",
      "Kalvelipatti BO": "625221",
      "Mariammalkulam BO": "625221",
      "Kumaram BO": "625018",
      "Keelamathur BO": "625234",
      "Kulasekarankottai BO": "625218",
      "Kuraiyur BO": "625701",
      "Odaipatti BO": "625701",
      "Austinpatti BO": "625008",
      "PThottiapatti BO": "625703",
      "Melauppiligundu BO": "625022",
      "Perungudi BO": "625022",
      "Jari Usilampatti BO": "625702",
      "Kadaneri BO": "625702",
      "Alappalacheri BO": "625704",
      "Sithireddipatti BO": "625704",
      "Madurai HO": "625001",
      "Arasaradi HO": "625016",
      "Tallakulam HO": "625002",
      "Alanganallur SO": "625501",
      "Ellis Nagar SO": "625016",
      "Samayanallur SO": "625402",
      "Thanichiyam SO": "625221",
      "Palamedu SO": "625503",
      "Ss Colony SO": "625016",
      "Thathaneri SO": "625018",
      "Vadipatti SO": "625218",
      "Visalakshi Nagar SO": "625018",
      "Avaniapuram SO": "625012",
      "Usilampatti S.O": "625532",
      "Sedapatti S.O": "625527",
      "Sindhupatti S.O": "625529",
      "Usilampatti Pettai S.O": "625532",
      "Yelumalai S.O": "625535",
      "Checkanurani SO": "625514",
      "Madurai Railway Divl Office SO": "625016",
      "Mullipallam SO": "625207",
      "Nagamalai SO": "625019",
      "Palkalai Nagar SO": "625021",
      "Tiruvedagam SO": "625234",
      "Gnanaolivupuram SO": "625016",
      "Karupatti SO": "625205",
      "Mudakkuchalai SO": "625016",
      "Shanthi Nagar SO": "625018",
      "Sholavandan SO": "625214",
      "Alagappa Nagar SO": "625003",
      "Uthappanayakanur S.O": "625537",
      "Saptur S.O": "625705",
      "Palanganatham SO": "625003",
      "Pandian Nagar SO": "625006",
      "Petchiamman Paditurai SO": "625001",
      "TPudupatti SO": "625704",
      "Tvs Nagar SO": "625003",
      "Alagarkoil SO": "625301",
      "Anaiyur SO": "625017",
      "Gandhi Nagar MA SO": "625020",
      "KPudur SO": "625007",
      "Krishnapuram Colony SO": "625014",
      "Ma Reserve Lines SO": "625014",
      "Madurai Agricultural College SO": "625104",
      "Melur SO Madurai": "625106",
      "Narimedu SO": "625002",
      "Othakadai SO": "625107",
      "South Gate SO": "625001",
      "Surveyor Colony SO": "625007",
      "Jaihindpuram SO": "625011",
      "Madurai Bazaar SO": "625001",
      "Madurai West SO": "625001",
      "Pasumalai SO": "625004",
      "Peraiyur SO Madurai": "625703",
      "TKallupatti SO": "625702",
      "TKunnathur SO": "625708",
      "Tirumangalam South SO": "625706",
      "Town Hall Road SO": "625001",
      "Keerathurai SO": "625001",
      "Kilavalavu SO": "625102",
      "Madras High Court Madurai Bench SO": "625023",
      "Madurai Courts SO": "625020",
      "Karuthapuliyanpatti SO": "625106",
      "Pudur Bazaar SO": "625007",
      "Sellur SO Madurai": "625002",
      "Therkutheru SO": "625122",
      "Thumbaipatti SO": "625108",
      "Tiruvadur SO": "625110",
      "Yanaikkal SO": "625001",
      "Kappalur IndlEstate SO": "625008",
      "Thiruparankundram SO": "625005",
      "Tirunagar SO": "625006",
      "Villapuram SO": "625012",
      "Villur SO": "625707",
      "Anna Nagar SO Madurai": "625020",
      "Karungalakudi SO": "625101",
      "Kottampatti SO": "625103",
      "Madurai Palace SO": "625001",
      "Meenambalpuram SO": "625002",
      "Melavlavu SO": "625105",
      "Silaiman SO": "625201",
      "Sokkikulam SO": "625002",
      "Tallakulam Housing Board Colon SO": "625020",
      "Thiagarajar College SO": "625009",
      "Vellalur SO": "625109",
      "Kalligudi SO": "625701",
      "Postal Training Centre SO": "625022",
      "Pudunagar SO": "625706",
      "Subramaniapuram SO Madurai": "625011",
      "Thiagarajar Engg College SO": "625015",
      "Tirumangalam SO": "625706",
      "Ma Munichalai Road SO": "625009",
      "Ma Race Course SO": "625002",
      "Ma Rajaji Hospital SO": "625020",
      "Madurai Bibikulam SO": "625002",
      "Madurai Corporation Building SO": "625002",
      "Madurai North SO": "625014",
      "Vilakkuthoon SO": "625001"
    },
    "MAYILADUTHURAI": {
      "Mappadugai B.O": "609003",
      "Mayiladuthurai West B.O": "609003",
      "Kalukkanimuttam B.O": "609203",
      "Korukkai B.O": "609203",
      "Pandur B.O": "609203",
      "Chandrapadi B.O": "609307",
      "Erukkattanchery B.O": "609307",
      "Iluppur B.O": "609308",
      "Nalluchery B.O": "609308",
      "Manakudi B.O": "609118",
      "Molaiyur B.O": "609118",
      "Tirunandriyur B.O": "609118",
      "Vallalagaram B.O": "609118",
      "Manickapangu B.O": "609313",
      "Anaikaranchatram South B.O": "609102",
      "Madervelur B.O": "609102",
      "Nallanayagapuram B.O": "609102",
      "Madanam B.O": "609104",
      "Pachaiperumal Nallur B.O": "609104",
      "Semmangudi(SRK) B.O": "609104",
      "Kaveripattinam Beach B.O": "609105",
      "Kilasattanathapuram B.O": "609106",
      "Nangur B.O": "609106",
      "Neipathur B.O": "609106",
      "Thennampattinam B.O": "609106",
      "Kunnam B.O": "609108",
      "Perambur (AKC) B.O": "609108",
      "Sodiyakudi B.O": "609108",
      "Tirumailadi B.O": "609108",
      "Manigramam B.O": "609114",
      "Radhanallur (TVG) B.O": "609114",
      "Athukudi B.O": "609117",
      "Idaikudi vadapathy B.O": "609117",
      "Pagasalai B.O": "609117",
      "Keeranallur B.O": "609115",
      "Radhanallur  (SRK) B.O": "609115",
      "Vettangudi B.O": "609115",
      "Chittarkadu B.O": "609003",
      "Koranad South B.O": "609003",
      "Dharmapuram B.O": "609001",
      "Mayiladuthurai North B.O": "609001",
      "Memathur B.O": "609309",
      "Parasalur B.O": "609309",
      "Tiruchempalli B.O": "609309",
      "Buthanur B.O": "609312",
      "Eduthukatti B.O": "609312",
      "Kodangudi B.O": "609314",
      "Mahendrapalli B.O": "609101",
      "Palayapalayam B.O": "609101",
      "Palayar B.O": "609101",
      "Talanayar Vsk B.O": "609201",
      "Umayalpathi B.O": "609104",
      "Neidavasal B.O": "609105",
      "Kilaperumpallam B.O": "609107",
      "Annamperumalkoil B.O": "609109",
      "Karaimedu B.O": "609109",
      "Kattiyaniruppu B.O": "609109",
      "Koilthirukolakkal B.O": "609111",
      "Kovilpathu B.O": "609111",
      "Sirkali East B.O": "609111",
      "Sirkali West B.O": "609111",
      "Koolaiyar B.O": "609113",
      "Karkoil B.O": "609112",
      "Mannipallam B.O": "609112",
      "Seithur Srk B.O": "609112",
      "Pulavanur B.O": "609205",
      "Elathur B.O": "609116",
      "Kilmathur B.O": "609116",
      "Nemmeli(SRK) B.O": "609116",
      "Pattavilagam B.O": "609116",
      "Manalmedu East B.O": "609202",
      "Peruncheri B.O": "609404",
      "Sholampettai B.O": "609003",
      "Nallathukudi B.O": "609001",
      "Velampudukudi B.O": "609306",
      "Aruvapadi B.O": "609203",
      "Kanganamputhur B.O": "609203",
      "Villiyanallur B.O": "609801",
      "Porayar Market B.O": "609307",
      "Arupathy B.O": "609309",
      "Alaveli B.O": "609118",
      "Arapallam B.O": "609101",
      "Kothandapuram B.O": "609101",
      "Puliyanthurai B.O": "609101",
      "Thandavankulam B.O": "609101",
      "Hanumanthapuram B.O": "609102",
      "Kannukiniyanar Koil B.O": "609104",
      "Puduthurai B.O": "609106",
      "Tirunagari B.O": "609106",
      "Talachangadu B.O": "609107",
      "Gopalasamudram B.O": "609108",
      "Sembadaniruppu B.O": "609109",
      "Vilanthida Samudram B.O": "609111",
      "Tiruvidaikali B.O": "609310",
      "Tirumeignanam B.O": "609311",
      "Kondathur B.O": "609117",
      "Punganur B.O": "609117",
      "Kiloy B.O": "609202",
      "Mudikondanallur B.O": "609309",
      "Manganallur B.O": "609404",
      "Pattamangalam B.O": "609001",
      "Tiruvilandur B.O": "609001",
      "Tiruvilayattam B.O": "609306",
      "Arulmozhithevan B.O": "609203",
      "Kaliyappanallur B.O": "609307",
      "Porayar R.S. B.O": "609307",
      "Kalahasthinapuram B.O": "609309",
      "Alakkudi B.O": "609101",
      "Kodakkaramoolai B.O": "609101",
      "Pudupattinam B.O": "609101",
      "Vanagiri B.O": "609105",
      "Perunthottam B.O": "609106",
      "Melaperumpallam B.O": "609107",
      "Natarajapillai Chavadi B.O": "609107",
      "Erukkur B.O": "609108",
      "Tiruvali B.O": "609109",
      "Arappakkam B.O": "609111",
      "Tittai (SRK) B.O": "609111",
      "Sendamangalam B.O": "609310",
      "Siddamalli B.O": "609205",
      "Vaithiswarankoil West B.O": "609117",
      "Edamanal B.O": "609115",
      "Maruthampallam B.O": "609301",
      "Kanjanagaram B.O": "609304",
      "Karuvazhakarai B.O": "609304",
      "Keelamaruthandanallur B.O": "609103",
      "Elayalur B.O": "609302",
      "Valuvur B.O": "609401",
      "Tirumananjeri B.O": "609801",
      "Athur B.O": "609204",
      "Tiruchitrambalam B.O": "609204",
      "Vadamattam B.O": "612201",
      "Mandai B.O": "612203",
      "Kanjivoy B.O": "612203",
      "Nakkampadi B.O": "612203",
      "Namasivayapuram B.O": "609811",
      "Tirumangalam B.O": "609811",
      "Gangadarapuram B.O": "609805",
      "Anniyur B.O": "612201",
      "Edakiam B.O": "609805",
      "Kozhaiyur B.O": "609805",
      "Alangudi B.O": "609801",
      "Moovalur B.O": "609806",
      "Madirimangalam B.O": "609801",
      "Palayagudalur B.O": "609801",
      "Maraiyur B.O": "609806",
      "Vanathirajapuram B.O": "609806",
      "Mamakudi B.O": "609301",
      "Umayalpuram B.O": "609301",
      "Kidarankondan B.O": "609304",
      "Melapathi B.O": "609304",
      "Kalamanallur B.O": "609301",
      "Mathur B.O": "609301",
      "Muthur B.O": "609302",
      "Kattuchery B.O": "609303",
      "Perambur B.O": "609402",
      "Sirkali H.O": "609110",
      "Mayiladuthurai H.O": "609001",
      "Akkur S.O (Nagapattinam)": "609301",
      "Elandangudi S.O": "609401",
      "Koranad S.O": "609001",
      "Manalmedu S.O": "609202",
      "Manganallur Bazaar S.O": "609404",
      "Mayiladuthurai Bazaar S.O": "609001",
      "Sembanarkoil S.O": "609309",
      "Solasakkaranallur S.O": "609118",
      "Tirukkalachery S.O": "609312",
      "Kaveripattinam S.O (Nagapattinam)": "609105",
      "Mangamadam S.O": "609106",
      "Sattanathapuram S.O": "609109",
      "Tillaiyadi S.O": "609310",
      "Tirumullaivasal S.O": "609113",
      "Komal S.O": "609805",
      "Kuttalam S.O": "609801",
      "Terizhandur S.O": "609808",
      "Arangakudi S.O": "609302",
      "Kilaiyur S.O": "609304",
      "Mayiladuthurai R.S S.O": "609003",
      "Achalpuram S.O": "609101",
      "Ilanthope S.O": "609201",
      "Kadavasal S.O": "609104",
      "Tiruvalaputhur S.O": "609205",
      "Vaithiswarankoil S.O": "609117",
      "Kali S.O": "609811",
      "Tiruvavaduthurai S.O": "609803",
      "Anandatandavapuram S.O": "609103",
      "Ayappadi S.O": "609303",
      "Kiliyanur S.O (Nagapattinam)": "609402",
      "Mayiladuthurai Cutchery S.O": "609001",
      "Mayiladuthurai South S.O": "609001",
      "Porayar S.O": "609307",
      "Sankaranpandal S.O": "609308",
      "Vadakarai S.O (Nagapattinam)": "609314",
      "Melaiyur TVG S.O": "609107",
      "Tirucadaiyur S.O": "609311",
      "Tirupungur S.O": "609112",
      "Valluvakudi S.O": "609116",
      "Varisapathu Vadagal S.O": "609115",
      "Mannampandal S.O": "609305",
      "Nalladai S.O": "609306",
      "Nidur S.O": "609203",
      "Tarangambadi S.O": "609313",
      "Anaikaranchatram S.O": "609102",
      "Puthur (SRK) S.O": "609108",
      "Sirkali Thenpathi S.O": "609111",
      "Tiruvengadu S.O": "609114",
      "Kuttalam East S.O": "609801",
      "Malliyam S.O": "609806",
      "Tirumeniarkoil S.O": "609204",
      "Tiruvalangadu S.O": "609810",
      "Konerirajapuram S.O": "612201",
      "Palaiyur S.O": "612203"
    },
    "PERAMBALUR": {
      "Elambalur B.O": "621220",
      "Koneripalayam B.O": "621220",
      "Nochiam B.O": "621220",
      "Sillakudi BO": "621653",
      "Allinagaram BO": "621713",
      "Peraiyur BO": "621713",
      "Aranarai B.O": "621220",
      "Kalarampatti B.O": "621101",
      "Iluppaikudi BO": "621713",
      "Koothur BO": "621713",
      "Pilimisai BO": "621713",
      "Pudunaduvalur B.O": "621220",
      "Kannapadi B.O": "621114",
      "Tenur B.O": "621114",
      "Ladapuram B.O": "621101",
      "Puduammapalayam B.O": "621118",
      "Viralipattipudur B.O": "621118",
      "Gudalur BO": "621713",
      "Kilamathur BO": "621713",
      "Nochikulam BO": "621713",
      "Adaikkampatti B.O": "621118",
      "Siruvayalur B.O": "621118",
      "Alambadi B.O": "621107",
      "Agaramsigur B.O": "621108",
      "Ogalur B.O": "621108",
      "S.Aduthurai B.O": "621108",
      "Thirumanthurai B.O": "621108",
      "Vadakkalur B.O": "621108",
      "Ayilur B.O": "621113",
      "Puduvettakudi B.O": "621716",
      "Brammadesam B.O": "621115",
      "Elumur B.O": "621115",
      "Fathimapuram B.O": "621115",
      "Vembavur B.O": "621116",
      "Venganur B.O": "621116",
      "Perumathur B.O": "621717",
      "Vaithiyanathapuram B.O": "621717",
      "Kadambur B.O": "621110",
      "Eraiyur B.O": "621113",
      "Siruganpur B.O": "621113",
      "Kavulpalayam B.O": "621220",
      "Kadur B.O": "621716",
      "Kilaperambalur B.O": "621716",
      "Vayalur B.O": "621716",
      "Karianur B.O": "621117",
      "Pimbalur B.O": "621117",
      "Thiruvalandurai B.O": "621117",
      "Kilapuliyur B.O": "621115",
      "Ranjankudi B.O": "621115",
      "Krishnapuram B.O": "621116",
      "Thondapadi B.O": "621116",
      "Andikurumbalur B.O": "621717",
      "Kilumathur B.O": "621717",
      "Olaipadi B.O": "621717",
      "Perali B.O": "621708",
      "Senjeri B.O": "621107",
      "Tirupayar B.O": "621107",
      "Alathur Gate B.O": "621109",
      "Periyammapalayam B.O": "621110",
      "Sengonam B.O": "621220",
      "Vasistapuram B.O": "621716",
      "Vayalapadi B.O": "621716",
      "Nuthapur B.O": "621117",
      "Pandagapadi B.O": "621117",
      "Pasumbalur B.O": "621117",
      "Peraiyur B.O": "621117",
      "Thevaiyur B.O": "621115",
      "Anukkur B.O": "621219",
      "Sithali B.O": "621708",
      "Varagur B.O": "621708",
      "Palayam B.O": "621107",
      "Athiyur B.O": "621108",
      "Pennakonam B.O": "621108",
      "Karai B.O": "621109",
      "Therani B.O": "621109",
      "Naranamangalam B.O": "621109",
      "Kalpadi B.O": "621113",
      "Varagupadi B.O": "621113",
      "Nallarikkai B.O": "621716",
      "Kaikalathur B.O": "621117",
      "Nerkunam B.O": "621117",
      "Pillankulam B.O": "621117",
      "Ayikudi B.O": "621115",
      "P.Mettupalayam B.O": "621115",
      "Sirukudal B.O": "621115",
      "Neikuppai B.O": "621116",
      "Nannai B.O": "621717",
      "Paravai B.O": "621717",
      "Vadakkumadevi B.O": "621219",
      "Ammapalayam S.O": "621101",
      "Madanagopalapuram S.O": "621212",
      "A.Mettur B.O": "621103",
      "Panampatti B.O": "621103",
      "Velur B.O": "621104",
      "Murukkankudi B.O": "621133",
      "Sirumathur B.O": "621133",
      "Kolathur B.O": "621106",
      "Maruvathur ariyalur B.O": "621708",
      "Melamathur B.O": "621708",
      "Perambalur H.O": "621212",
      "Kolakkanatham S.O": "621106",
      "Padalur S.O": "621109",
      "Melapuliyur B.O": "621101",
      "Puduattur B.O": "621101",
      "Viswagudi B.O": "621102",
      "Thondamandurai B.O": "621103",
      "Kilakanavai B.O": "621104",
      "Asoor B.O": "621708",
      "Odhiyam B.O": "621708",
      "Annamangalam S.O": "621102",
      "Chettikulam S.O": "621104",
      "Kurumbalur S.O": "621107",
      "Labbaikudikadu S.O": "621108",
      "Thaluthalai B.O": "621103",
      "Vengalam B.O": "621103",
      "Nattarmangalam B.O": "621104",
      "Adhanur B.O": "621708",
      "Moongilpadi B.O": "621708",
      "Nakkasalem S.O": "621118",
      "Arasalur B.O": "621102",
      "Bommanapadi B.O": "621104",
      "C.Mavilingai B.O": "621104",
      "Chathiramanai B.O": "621104",
      "Sathanur B.O": "621106",
      "Ilandaikuli B.O": "621708",
      "Kurumbapalayam B.O": "621708",
      "Arumbavur S.O": "621103",
      "Eraiyur S.O (Perambalur)": "621133",
      "Kunnam S.O (Perambalur)": "621708",
      "Perambalur Collectorate S.O": "621212",
      "T.Kalathur S.O": "621114",
      "Poolambadi S.O": "621110",
      "Valikondapuram S.O": "621115",
      "Veppur S.O": "621717",
      "Yesanai S.O": "621219",
      "Veppanthattai S.O": "621116",
      "Siruvachur S.O": "621113",
      "Thoramangalam S.O": "621220",
      "Tungapuram S.O": "621716",
      "V.Kalathur S.O": "621117"
    },
    "CHENNAI": {
      "Erukkancheri BO": "600118",
      "Rv Nagar BO": "600118",
      "Lakshmipuram BO": "600099",
      "Srinivasanagar BO": "600049",
      "Vadaperumbakkam BO": "600060",
      "Rajajinagar BO": "600049",
      "Athipattu BO": "600058",
      "Manapakkam BO": "600125",
      "Ayapakkam BO": "600077",
      "Alapakkam BO": "600116",
      "Park Town H.O": "600003",
      "MADRAS ELECTRICITY SYSTEM": "600002",
      "ETHIRAJ SALAI": "600008",
      "Mugalivakkam SO": "600125",
      "Vadapalani S.O": "600026",
      "West Mambalam S.O": "600033",
      "St Thomas Mount HO": "600016",
      "Chennai G.P.O.": "600001",
      "Ambattur HO": "600053",
      "Kilpauk Medical College S.O": "600010",
      "Kumaran Nagar S.O": "600082",
      "Madras Medical College S.O": "600003",
      "Perambur North S.O": "600011",
      "Chennai Airport S.O": "600016",
      "Mylapore H.O": "600004",
      "Thygarayanagar H.O": "600017",
      "Ekkaduthangal S.O": "600032",
      "Injambakkam S.O": "600115",
      "Madipakkam South S.O": "600091",
      "Meenambakkam S.O": "600016",
      "Nilamangai Nagar S.O": "600088",
      "Oggiamthoraipakkam S.O": "600097",
      "Palavakkam S.O (Kanchipuram)": "600041",
      "Perungudi S.O": "600096",
      "Rajbhavan S.O (Chennai)": "600022",
      "Velacheri S.O": "600042",
      "Dr Ambedkar Law Univeristy": "600096",
      "Mannady S.O (Chennai)": "600001",
      "Mint Building S.O": "600001",
      "Rayapuram S.O": "600013",
      "Tondiarpet Bazaar S.O": "600081",
      "Washermanpet East S.O": "600021",
      "EGMORE MDO": "600008",
      "Saligramam S.O": "600093",
      "Anna Nagar East S.O": "600102",
      "Anna Nagar Western Extn S.O": "600101",
      "Aynavaram S.O": "600023",
      "Chetput S.O": "600031",
      "Arumbakkam North": "600106",
      "Puliyanthope S.O": "600012",
      "Shenoy Nagar S.O": "600030",
      "Venkatesapuram S.O": "600012",
      "Vyasar Nagar Colony S.O": "600039",
      "Adambakkam S.O": "600088",
      "Adyar S.O (Chennai)": "600020",
      "Ashoknagar S.O (Chennai)": "600083",
      "Indian Institute Of Technology S.O": "600036",
      "Kalaignar Karunanidhi Nagar S.O": "600078",
      "Karapakkam S.O": "600097",
      "Madipakkam S.O": "600091",
      "Nanganallur S.O": "600061",
      "Tiruvottiyur SO": "600019",
      "Anna Road H.O": "600002",
      "Maduravoyal SO": "600095",
      "Porur SO": "600116",
      "Tidel Park S.O": "600113",
      "Tiruvanmiyur S.O": "600041",
      "Ram Nagar": "600091",
      "Fort St George S.O": "600009",
      "Govt Stanley Hospital S.O": "600001",
      "High Court Building S.O (Chennai)": "600104",
      "Sowcarpet NDSO": "600001",
      "Tondiarpet West S.O": "600081",
      "EGMORE NDSO": "600008",
      "World University Service Centre": "600031",
      "Valasaravakkam S.O": "600087",
      "Virugambakkam S.O": "600092",
      "Aminjikarai S.O": "600030",
      "Anna Nagar S.O (Chennai)": "600040",
      "Arumbakkam S.O": "600106",
      "Flowers Road S.O": "600084",
      "Icf Colony S.O": "600038",
      "Periyar Nagar S.O": "600082",
      "Kilpauk S.O": "600010",
      "Koyambedu S.O": "600107",
      "Nerkundram S.O": "600107",
      "Engineering College S.O (Chennai)": "600025",
      "Guindy Industrial Estate S.O": "600032",
      "Guindy North S.O": "600015",
      "Kasturibai Nagar S.O": "600020",
      "Kotturpuram S.O": "600085",
      "Pazhavanthangal S.O": "600061",
      "Shastri Nagar S.O (Chennai)": "600020",
      "TTTI Taramani S.O": "600113",
      "Flower Bazaar": "600001",
      "Tondiarpet S.O": "600081",
      "Washermanpet S.O": "600021",
      "Chintadripet": "600002",
      "G K M Colony S.O": "600082",
      "Perambur Barracks S.O": "600012",
      "Perambur S.O": "600011",
      "Villivakkam SO": "600049",
      "Ripon Buildings S.O": "600003",
      "Sembiam S.O": "600011",
      "Vepery S.O": "600007",
      "Vyasarpadi S.O": "600039",
      "Alandur(Reopened W.E.F.6.6.05) S.O": "600016",
      "Besantnagar S.O": "600090",
      "Jafferkhanpet S.O": "600083",
      "Rajaji Bhavan S.O": "600090",
      "Ramapuram S.O (Kanchipuram)": "600089",
      "Sholinganallur S.O": "600119",
      "Valmiki Nagar S.O": "600041",
      "Neelangarai S.O": "600115",
      "Raja Annamalaipuram S.O": "600028",
      "Alwarthirunagar S.O": "600087",
      "Mambalam R.S. S.O": "600033",
      "Parthasarathykoil SO": "600005",
      "Nungambakkam High Road S.O": "600034",
      "DPI S.O": "600006",
      "Nandanam S.O": "600035",
      "Chepauk S.O": "600005",
      "Vivekananda College Madras S.O": "600004",
      "Choolaimedu S.O": "600094",
      "Hindi Prachar Sabha S.O": "600017",
      "Nungambakkam MDO": "600034",
      "Kodambakkam S.O": "600024",
      "Ramakrishna Nagar S.O (Chennai)": "600028",
      "Koyambedu Wholesale Market Complex": "600107",
      "Saidapet S.O (Chennai)": "600015",
      "Ennore Thermal Station SO": "600057",
      "Madras University S.O": "600005",
      "Royapettah S.O": "600014",
      "Teynampet S.O": "600018",
      "Tiruvallikeni S.O": "600005",
      "Greams Road S.O": "600006",
      "Thygarayanagar North ND S.O": "600017",
      "Gopalapuram S.O (Chennai)": "600086",
      "Lloyds Estate S.O": "600014",
      "Mandaveli S.O": "600004",
      "Pr. Accountant General S.O": "600018",
      "Loyola College S.O": "600034",
      "Shastri Bhavan S.O": "600006",
      "Teynampet West S.O": "600006",
      "Thygarayanagar South NDS.O": "600017",
      "Kolathur SO": "600099",
      "Madhavaram Milk Colony SO": "600051",
      "Madhavaram SO Tiruvallur": "600060",
      "Ambattur Indl Estate SO": "600058",
      "Pozhal SO": "600066",
      "Kodungaiyur SO": "600118",
      "Manali New Town SO": "600103",
      "Manali SO Tiruvallur": "600068",
      "Mogappair SO": "600037",
      "Padi SO": "600050",
      "Korattur RS SO": "600076"
    }
  },
  "WEST BENGAL": {
    "NADIA": {
      "Brittihuda B.O": "741123",
      "Bansberia BO": "741122",
      "Gopalpur Ghat BO": "741122",
      "Rampur BO": "741161",
      "Arabpur BO": "741122",
      "Kulgachi BO": "741161",
      "Nrisinghapur BO": "741404",
      "Hogal Beria BO": "741122",
      "Joyrampur BO": "741122",
      "Dompukuria BO": "741123",
      "Hridaypur BO": "741123",
      "Kalyandaha BO": "741123",
      "Lakshmipur BO": "741123",
      "Kachharia Para BO": "741122",
      "Natna Patabuka BO": "741122",
      "Bagberia BO": "741123",
      "Charuitipi BO": "741123",
      "Kanainagar BO": "742121",
      "Nadia Sundalpur BO": "741122",
      "Charatala BO": "741123",
      "Dakshin Bahirgachhi BO": "741123",
      "Darappur BO": "741223",
      "Gouripur BO": "741223",
      "Bhagirathisilpaashram BO": "741248",
      "Mollabelia BO": "741249",
      "Haradham BO": "741255",
      "Churni Raghunathpur BO": "741501",
      "Purbanowpara BO": "741501",
      "Bapukinagar BO": "741121",
      "Benali BO": "741502",
      "Bhayna BO": "741502",
      "Haldipara BO": "741502",
      "Kumari Ramnagar BO": "741502",
      "Patikabari BO": "741126",
      "Taraknagar BO": "741502",
      "Gede BO": "741503",
      "Chowgacha BO": "741222",
      "Itaberia BO": "741151",
      "Fulia Boyra BO": "741402",
      "Habibpur BO": "741402",
      "Gangsara Majhergram BO": "741238",
      "Gopinagar BO": "741238",
      "Betna BO": "741505",
      "Gobindapur BO": "741505",
      "Tangra BO": "741506",
      "Mathurapur BO": "741507",
      "Taldaha BO": "741507",
      "Dhantala BO": "741202",
      "Jm Nokari BO": "741202",
      "CHUNARIPARA BO": "741201",
      "Ramnagar  BO": "741201",
      "Bablagobindapur BO": "741404",
      "Barajiakur BO": "741404",
      "Ghoralia BO": "741404",
      "Majerchar BO": "741251",
      "Rajarmath BO": "741223",
      "Silinda BO": "741223",
      "Chanduria BO": "741248",
      "Narapatipara BO": "741248",
      "Rautari BO": "741248",
      "Fatepur BO": "741249",
      "Simhat BO": "741249",
      "Eruli BO": "741253",
      "Muraghachacolony BO": "741502",
      "Ranaghat Baidyapur BO": "741256",
      "Byaspur BO": "741127",
      "Tarapur BO": "741402",
      "Bathangachi BO": "741507",
      "Bhajanghat BO": "741507",
      "Fatepur Majdia BO": "741507",
      "Ranaghat Bazar BO": "741201",
      "Ranaghat Rupashreepally BO": "741201",
      "Khandakhola BO": "741404",
      "Ramnagarchar BO": "741404",
      "Santipur College BO": "741404",
      "Balia BO": "741223",
      "Hinghnara BO": "741223",
      "Narayanpur BO": "741249",
      "Panpur BO": "741249",
      "Nandighat BO": "741255",
      "Arbandi BO": "741121",
      "Bhaduri BO": "741121",
      "Mamjaon BO": "741121",
      "Haritala BO": "741502",
      "Mayurhat BO": "741502",
      "Nabarupdaha BO": "741502",
      "Bijoypur BO": "741503",
      "Raghu Nandan Pur BO": "741503",
      "Chitrasali BO": "741151",
      "Gazipur BO": "741402",
      "Panpara BO": "741402",
      "Debagram BO": "741238",
      "Daharbuincha BO": "741505",
      "Digambarpur BO": "741508",
      "Gazna BO": "741507",
      "Putikhali BO": "741507",
      "Gayeshpur Hazratala BO": "741404",
      "Bagchi Jamsherpur SO": "741122",
      "Bara Andulia SO": "741124",
      "Betai SO": "741163",
      "Ghurni SO": "741103",
      "Karimpur SO": "741152",
      "Haripurnadia BO": "741404",
      "Barabazar BO": "741404",
      "Kuthirpara BO": "741404",
      "Assannagar SO": "741161",
      "Aminbazar SO": "741101",
      "Bhimpur SO": "741167",
      "Bowbazar SO Nadia": "741101",
      "Dayer Bazar SO": "741164",
      "Golapati SO": "741101",
      "Joania Bhaluka SO": "741317",
      "Kathuriapara SO": "741101",
      "Krishnanagar Court SO": "741101",
      "Bhagyabantapur BO": "713502",
      "Ranabanda BO": "741123",
      "Talukhuda BO": "741123",
      "Baniakhari BO": "741124",
      "Chhoto Andulia BO": "741124",
      "Nadia Bishnupur BO": "741103",
      "Radhanagar BO": "741103",
      "Sonda BO": "741103",
      "Sutia BO": "741103",
      "Senpara BO": "741152",
      "Thanarpara BO": "741152",
      "Amiya Narayanpur BO": "741165",
      "Barbakpur BO": "741165",
      "Fajil Nagar BO": "741165",
      "Rahamatpur BO": "741165",
      "Jhitkipota BO": "741102",
      "Kalamari BO": "741102",
      "Kalirhat BO": "741102",
      "Rajapur BO": "741125",
      "Shondanga BO": "741125",
      "Tatla BO": "741222",
      "Chinchuria BO": "741126",
      "Dhananjoypur BO": "741126",
      "Gotepara BO": "741126",
      "Harinarayanpur BO": "741126",
      "Nakashipara BO": "741126",
      "Radhanagar Colony BO": "741126",
      "Sonadanga BO": "741126",
      "Dalimoula BO": "741140",
      "Nowpara BO": "741140",
      "Panditpur BO": "741140",
      "Rupdaha BO": "741140",
      "Chandanpur BO": "741162",
      "Dadupur Nadia BO": "741162",
      "Motiroybnadh BO": "741302",
      "Bharatpur BO": "741181",
      "Radhakantapur BO": "741181",
      "Bakshipur BO": "741155",
      "Baur BO": "741155",
      "Bhawanipur BO": "741155",
      "Binod Nagar BO": "741155",
      "Gopinathpur BO": "741155",
      "Shyamnagar BO": "741155",
      "Barachand Ghar BO": "741156",
      "Dhawapara BO": "741156",
      "Molandi BO": "741156",
      "Sahebnagar BO": "741156",
      "Bablari BO": "741316",
      "Fakirdanga BO": "741316",
      "Mahisura BO": "741316",
      "Amghata BO": "741315",
      "Gadigachha BO": "741315",
      "Mahesganj BO": "741315",
      "Kalipur BO": "741245",
      "BIJOYNAGAR BO": "741245",
      "Haripukuria BO": "741257",
      "Kasthadanga BO": "741257",
      "Mahadevpur BO": "741257",
      "Nimtala Bazar BO": "741257",
      "Ballavpara BO": "713502",
      "Pipragachhi BO": "741123",
      "Matchpota BO": "741124",
      "Shibpur BO": "741124",
      "Teghari BO": "741124",
      "Chhitkadaspara BO": "741163",
      "Ichhapur BO": "741164",
      "Mahatpur BO": "741164",
      "Gobrapota BO": "741103",
      "Maliapota BO": "741103",
      "Putimari BO": "741103",
      "Aluipara BO": "741317",
      "Baliadanga BO": "741152",
      "Natiadanga BO": "741152",
      "Pipulberia BO": "741152",
      "Gopalpur BO": "741165",
      "Mrigi BO": "741165",
      "Tarakganj BO": "741165",
      "Dogachhi BO": "741102",
      "Kechuadanga BO": "741158",
      "Hanspukuria BO": "741160",
      "Khaspur BO": "741160",
      "Natna BO": "741160",
      "Raghunathpur BO": "741160",
      "Bahadurpur BO": "741125",
      "Bholadanga BO": "741126",
      "Birpur BO": "741126",
      "Jugpur Colony BO": "741126",
      "Uttar Bahirgachhi BO": "741126",
      "Ushidpur BO": "741301",
      "Akanda Danga BO": "741137",
      "Arbetai BO": "741137",
      "Dingel BO": "741137",
      "Haranagar BO": "741137",
      "Madandanga BO": "741137",
      "Senpur BO": "741137",
      "Kandoa BO": "741138",
      "Juranpur BO": "741150",
      "Kamarhati BO": "741154",
      "Saligram BO": "741154",
      "Bareya BO": "741156",
      "Chhoto Nalda BO": "741156",
      "Panchdara Abhaynagar BO": "741156",
      "Bhurulia BO": "741157",
      "Rudrapara BO": "741302",
      "Bamunpukur BO": "741313",
      "Kadambagachi BO": "741222",
      "Poradanga BO": "741222",
      "Ananda Nagar BO": "741245",
      "Chandamari BO": "741245",
      "Mahakhola BO": "741123",
      "Petuabhanga BO": "741124",
      "Sakdaha BO": "741167",
      "Madhabpur BO": "741164",
      "Tilakpur BO": "741164",
      "Goaldaha BO": "741103",
      "Jahangirpur BO": "741103",
      "Patharghata BO": "741103",
      "Taranipur BO": "741103",
      "Joania BO": "741317",
      "Bajitpur BO": "741152",
      "Paschim Dogachi BO": "741152",
      "Goas BO": "741165",
      "Kishorepur BO": "741165",
      "Nandanpur BO": "741165",
      "Topla BO": "741165",
      "Bhatjangla BO": "741102",
      "Jalalkhali BO": "741102",
      "Joypur BO": "741102",
      "Natunbazar BO": "741102",
      "Kalinga BO": "741166",
      "Raghunathpur Ramnagar BO": "741158",
      "Chanderghat BO": "741160",
      "Nischintapur BO": "741160",
      "Anandanagar BO": "741125",
      "Mayakole BO": "741125",
      "Bandbelgaon BO": "741126",
      "Malumgachha BO": "741126",
      "Taibichara BO": "741126",
      "Akandaberia BO": "741137",
      "Ashachia BO": "741137",
      "Dhubinagadi BO": "741137",
      "Ghoraikhetra BO": "741137",
      "Kamari BO": "741137",
      "Sapjola BO": "741137",
      "Billwagram BO": "741138",
      "Manikdihi BO": "741150",
      "Udaychandrapur BO": "741162",
      "Baliadanga Faridpur BO": "741153",
      "Ghateswar BO": "741154",
      "Rukunpur BO": "741154",
      "Suksagar BO": "741154",
      "Barnia BO": "741156",
      "Barui Para BO": "741156",
      "Bahirchara BO": "741316",
      "Idrakpur BO": "741316",
      "Deuli BO": "741222",
      "Kamalpuredso BO": "741222",
      "Sanyalchar BO": "741222",
      "Ghoragacha BO": "741245",
      "Saguna BO": "741245",
      "Dighalgram BO": "741257",
      "Charsarhati BO": "741251",
      "Noapara BO": "741255",
      "Barbaria BO": "741501",
      "Hatbahirgachi BO": "741501",
      "Panchberia BO": "741501",
      "Shibnarayanpur BO": "741501",
      "Boalia BO": "741121",
      "Chandandaha BO": "741121",
      "Chandra BO": "741121",
      "Khamarshumulia BO": "741121",
      "Bhairabchandrapur BO": "741502",
      "Chupria BO": "741502",
      "Garapotanadia BO": "741502",
      "Santinagar BO": "741502",
      "Ulashi BO": "741502",
      "Dayabari BO": "741256",
      "Shibnibas BO": "741509",
      "Chapri BO": "741151",
      "Baranberia BO": "741504",
      "Daluabari BO": "741504",
      "2noNatunfulia BO": "741402",
      "Belemath BO": "741402",
      "Buincha BO": "741402",
      "Ghola BO": "741238",
      "Humaniapota BO": "741238",
      "Naserkuli BO": "741238",
      "Uzirpukuria BO": "741238",
      "Kamgachi BO": "741254",
      "Joyghata BO": "741508",
      "Maheshpur BO": "741508",
      "Nadiasumalia BO": "741508",
      "Durgapur BO": "741506",
      "Swarnakhali BO": "741506",
      "Chapra BO": "741202",
      "Halalpurkrishnapur BO": "741202",
      "Hijuli BO": "741202",
      "Matikumra Kutirpara BO": "741202",
      "Mahaprabhupara BO": "741201",
      "Bagachra BO": "741404",
      "Bangaljhi SO": "741123",
      "Padmamala BO": "741123",
      "Hatisala BO": "741124",
      "Haripur Chhitka BO": "741163",
      "Karuigachi BO": "741163",
      "Lalbazar BO": "741163",
      "Berij BO": "741103",
      "Bhanderkhola BO": "741103",
      "Char Sambhu Nagar BO": "741103",
      "Dhopatta BO": "741103",
      "Charmuktarpur BO": "741152",
      "Dhoradaha BO": "741152",
      "Dighalkandi BO": "741152",
      "Khanpur BO": "741152",
      "Darermath BO": "741158",
      "Chhatina BO": "741160",
      "Iswarchandrapur BO": "741160",
      "Jitpur BO": "741160",
      "Krishna Chandrapur BO": "741160",
      "Notiapota BO": "741160",
      "Arpara BO": "741126",
      "Bikrampur BO": "741126",
      "Bara Atagi BO": "741137",
      "Bilkumari BO": "741137",
      "Mahurapur BO": "741137",
      "Majhergram BO": "741137",
      "Palit Behgia BO": "741137",
      "Tentulberia BO": "741138",
      "Bara Kul Beria BO": "741150",
      "Basarkhola BO": "741150",
      "Charchua Danga BO": "741153",
      "Bahirgachhi BO": "741154",
      "Digha BO": "741154",
      "Gachha BO": "741154",
      "Palsunda BO": "741156",
      "Ganja Danga BO": "741313",
      "Nidaya BO": "741313",
      "Dighra BO": "741222",
      "Ghetugachi BO": "741222",
      "Jasra BO": "741222",
      "Bedibhavan BO": "741250",
      "Alaipur BO": "741245",
      "Krishnanagar HO": "741101",
      "Birohiedso BO": "741245",
      "Haringhat River Research Insti BO": "741246",
      "Kalyani HO": "741235",
      "Nabadwip HO": "741302",
      "Ranaghat HO": "741201",
      "Charmaniknagar BO": "713519",
      "Char Brahmanagar SO": "741301",
      "Dhubulia SO": "741139",
      "Kaliganj SO": "741150",
      "Kasiadanga SO": "741162",
      "Khidirpur Bethuadahari SO": "741126",
      "Plassey Sugar Mill SO": "741157",
      "Pratapnagar SO Nadia": "741302",
      "Swarupganj SO": "741315",
      "Tehatta SO": "741160",
      "Bethuadahari SO": "741126",
      "Buroshibtala SO Nadia": "741302",
      "Dharmada SO": "741138",
      "Kolerdanga SO": "741302",
      "Palashipara SO": "741155",
      "Poramatala Road SO": "741302",
      "Tegharipara SO": "741302",
      "Bidhanpark SO": "741235",
      "Nazirpur SO Nadia": "741165",
      "Saktinagar SO": "741102",
      "Seemanagar SO": "741166",
      "Shikarpur SO Nadia": "741158",
      "Ukilpara SO": "741101",
      "Belpukur SO": "741125",
      "Dearapara SO": "741302",
      "Dhubulia T B Hospital SO": "741140",
      "Matiari SO": "741153",
      "Plassey SO": "741156",
      "Barajaguli SO": "741221",
      "Krishnanagar Road RS SO": "741101",
      "Krishnanagar RS SO": "741101",
      "Roypara SO": "741101",
      "Debagram SO": "741137",
      "Muragachha SO": "741154",
      "Nabadwip Bazar SO": "741302",
      "Nabadwip Dham RS SO": "741302",
      "Paglachandi SO": "741181",
      "Sreemayapur SO": "741313",
      "Buddhapark SO": "741235",
      "Nadia School Board SO": "741101",
      "Gandhi Memorial Hospital SO": "741235",
      "Madanpur SO Nadia": "741245",
      "Nagarukhra SO": "741257",
      "Simurali SO": "741248",
      "Kalyani Court SO": "741235",
      "Anishmali SO": "741253",
      "Badkulla SO": "741121",
      "Chotobazar SO": "741201",
      "Khalboalia SO": "741508",
      "Nasra SO": "741202",
      "Ranaghat College SO": "741201",
      "Sutragarh SO": "741404",
      "Taherpur SO": "741159",
      "Chakdah SO": "741222",
      "Kalyani University SO": "741235",
      "Kataganj SO": "741250",
      "Khosbasmahalla SO": "741222",
      "Krishivisyavidyalaya SO": "741252",
      "Lalpur SO Nadia": "741222",
      "Purbabishnupur SO": "741223",
      "Anulia SO": "741255",
      "Ashanandapara Street SO": "741404",
      "Bagula SO": "741502",
      "Biswaspara SO": "741201",
      "Coopers Camp SO": "741232",
      "Dignagar SO": "741401",
      "Duttapulia SO": "741504",
      "Krishnakalitala SO": "741404",
      "Ranaghat Court SO": "741201",
      "Ranaghat RS SO": "741201",
      "Santipur RS SO": "741404",
      "Santipur SO": "741404",
      "Siddheswaritala SO": "741201",
      "Nagendranagar SO": "741101",
      "Kalyani RS SO": "741235",
      "Netajisubhas Sanatorium SO": "741251",
      "Arangahta SO": "741501",
      "Birnagar SO": "741127",
      "Chandannagar SO Nadia": "741509",
      "Dhakshinpara SO": "741151",
      "Gangnapur SO": "741238",
      "Hanskhali SO": "741505",
      "Gayeshpur SO": "741234",
      "Ghoshpara SO Nadia": "741235",
      "Kalyani Hospital SO": "741235",
      "Mohanpur SO Nadia": "741246",
      "Subarnapur SO": "741249",
      "Banpur SO Nadia": "741503",
      "Begopara SO": "741256",
      "Fulia Colony SO": "741402",
      "Kalinarayanpur SO": "741254",
      "Krishnaganj SO": "741506",
      "Majdia SO": "741507",
      "Pritinagar SO": "741247",
      "Shyamchandpara SO": "741404"
    },
    "MEDINIPUR WEST": {
      "Prasadchak BO": "721232",
      "Attrakhi BO": "721149",
      "Barbasi BO": "721149",
      "Patnabazar BO": "721156",
      "Talbandhi BO": "721156",
      "Buriapat BO": "721260",
      "Kharigeria BO": "721260",
      "Mohoboni BO": "721260",
      "Saiyadbali BO": "721260",
      "Kundalpal BO": "721140",
      "Bansda Palashi BO": "721160",
      "Jashorajpur BO": "721160",
      "Radhachandanpur BO": "721160",
      "Dianpur BO": "721242",
      "Laxmipur BO": "721242",
      "Moulaparamanandapur BO": "721242",
      "Paikmajita BO": "721242",
      "Chaulkuri BO": "721144",
      "Dhamsai BO": "721144",
      "Fatechak BO": "721144",
      "Kiamacha BO": "721253",
      "Nalbana BO": "721253",
      "Guiadaha BO": "721253",
      "Nayabasat BO": "721253",
      "Sanatorium Digri BO": "721253",
      "Chechua Gobinda Nagar BO": "721146",
      "Kuthikonarpur BO": "721232",
      "Manoharpur BO": "721232",
      "Hariharpur BO": "721136",
      "Kankra Atmaram BO": "721136",
      "Dhaneswarpur BO": "721166",
      "Khunkhunia BO": "721166",
      "Hatsultanpur BO": "721149",
      "Janardanpur BO": "721149",
      "Pachra BO": "721149",
      "Tentulmuriuttar BO": "721149",
      "Akalpoush BO": "721156",
      "Ghoshdiha BO": "721156",
      "Magra BO": "721156",
      "Amdangra BO": "721260",
      "Garhsenapatya BO": "721260",
      "Sirsa BO": "721260",
      "Toria BO": "721260",
      "Aknageria BO": "721140",
      "Jamna BO": "721140",
      "Kantachowki BO": "721140",
      "Naya BO": "721140",
      "Dingal BO": "721160",
      "Srinagar BO": "721242",
      "Barjagu BO": "721144",
      "Bishnupur Bazar BO": "721144",
      "Khagrageria BO": "721144",
      "Lokepith Bishnupur BO": "721144",
      "Uttar Eral BO": "721144",
      "Ghoshkira BO": "721253",
      "Khamarbarh BO": "721253",
      "Mangalbandhi BO": "721253",
      "Kantadaraja BO": "721232",
      "Mangrul BO": "721232",
      "Marhmaheshpur BO": "721232",
      "Natuk Jaykrishnapur BO": "721232",
      "Barati BO": "721136",
      "Bhagirathpur BO": "721136",
      "Bikrampur BO": "721136",
      "Chakbajit BO": "721136",
      "Khelna BO": "721166",
      "Madanmohanchak BO": "721166",
      "Narma BO": "721166",
      "Uchitpur BO": "721166",
      "Kanikha BO": "721149",
      "Krishnanagar BO": "721149",
      "Kuliara BO": "721149",
      "Mahatabnagar BO": "721149",
      "Paparara BO": "721149",
      "Sainthal BO": "721149",
      "Aloke Kendra BO": "721156",
      "Bharatpur BO": "721156",
      "Biswanathpur Patna BO": "721156",
      "Boulasini BO": "721156",
      "Amuria BO": "721260",
      "Bandipur BO": "721260",
      "Belyamaharajpur BO": "721260",
      "Karkai BO": "721140",
      "Khirai BO": "721140",
      "Krishnapriya BO": "721140",
      "Mundumari BO": "721140",
      "Radhakrishnapur BO": "721140",
      "Raghunath Chak BO": "721140",
      "Nedhua Bazar BO": "721144",
      "Rambhadrapur BO": "721144",
      "Ruinan BO": "721144",
      "Akchara BO": "721253",
      "Barpara BO": "721253",
      "Duki BO": "721253",
      "Dwarigeria BO": "721253",
      "Maharajpur BO": "721232",
      "Golegram BO": "721136",
      "Kalikageria BO": "721136",
      "Math Bishnupur BO": "721136",
      "Shanrpur BO": "721136",
      "Badalpur BO": "721166",
      "Chakmakrampur BO": "721149",
      "Jagul BO": "721149",
      "Jhikuria BO": "721156",
      "Panchgeria BO": "721156",
      "Chandur BO": "721260",
      "Golar BO": "721260",
      "Khalakpur BO": "721260",
      "Supaparsuri BO": "721260",
      "Uriasai BO": "721260",
      "Barageria BO": "721140",
      "Maligram BO": "721140",
      "Uttarbarh BO": "721140",
      "Duan BO": "721160",
      "Turia BO": "721160",
      "Deopur Amdan BO": "721242",
      "Ranimadhabpur BO": "721242",
      "Tatarpur BO": "721242",
      "Andulia BO": "721144",
      "Barsahara BO": "721144",
      "Kapasda BO": "721144",
      "Kharika BO": "721144",
      "Narayanbarh BO": "721144",
      "Kadra BO": "712122",
      "Kiaboni BO": "721253",
      "Nadasuli BO": "721253",
      "Fatepur BO": "721146",
      "Ranbonia BO": "721135",
      "Parhdaha BO": "721157",
      "Puichhara BO": "721157",
      "Saharda BO": "721131",
      "Sabong Shyamsundarpur BO": "721155",
      "Amritpur BO": "721150",
      "Ghoshpur BO": "721150",
      "Jayantinarayanchak BO": "721150",
      "Jhalka BO": "721150",
      "Kalagram BO": "721150",
      "Routa BO": "721150",
      "Sarisakhola BO": "721150",
      "Balarampur BO": "721301",
      "Banpatna BO": "721301",
      "Barachu BO": "721301",
      "Bargokulpur BO": "721301",
      "Jakpur BO": "721301",
      "Khatranga BO": "721301",
      "Lakhichak BO": "721301",
      "Keshia BO": "721157",
      "Ragpur BO": "721131",
      "Kerur BO": "721155",
      "Narangadihi BO": "721155",
      "Tilantapara BO": "721155",
      "Amrakuchi BO": "721150",
      "Jhentla BO": "721150",
      "Kismat Angua BO": "721150",
      "Mugbasan BO": "721150",
      "Parsura BO": "721150",
      "Barkola BO": "721301",
      "Boicha BO": "721301",
      "Pratappur BO": "721301",
      "Routmoni BO": "721301",
      "Lakshmanpur BO": "721222",
      "Chaklachipur BO": "721232",
      "Barida BO": "721135",
      "Palshya BO": "721301",
      "Irpala BO": "721222",
      "Kuran BO": "721222",
      "Alui BO": "721232",
      "Harinagar BO": "721232",
      "Hematpur BO": "721232",
      "Hiradharpur BO": "721232",
      "Salgeria BO": "721157",
      "Dangalsa BO": "721131",
      "Gobardhanpur BO": "721131",
      "Harishpur BO": "721305",
      "Matkatpur BO": "721305",
      "Ramnagar Gopinathpur BO": "721305",
      "Bagnabarh BO": "721155",
      "Balpai BO": "721155",
      "Beluria BO": "721155",
      "Bhemua BO": "721155",
      "Hiradihi BO": "721301",
      "Shaymraipur BO": "721301",
      "Shyamchak BO": "721301",
      "Agar BO": "721222",
      "Dingal Kamargeria BO": "721232",
      "Gohaldanga BO": "721232",
      "Kankabati BO": "721232",
      "Dandipur BO": "721222",
      "Hodal Srirampur BO": "721232",
      "Jara BO": "721232",
      "Binandapur BO": "721135",
      "Tilaboni Mahisamunda BO": "721135",
      "Eriamara BO": "721157",
      "Kantore BO": "721157",
      "Pindrui BO": "721131",
      "Amda BO": "721133",
      "Gaganeswar BO": "721133",
      "Ganasarisa BO": "721133",
      "Lengamara BO": "721133",
      "Singaijamuna BO": "721133",
      "Lakhibari BO": "721155",
      "Perua BO": "721155",
      "Ajodhya Nagar BO": "721150",
      "Mahisda BO": "721150",
      "Panchkhuri BO": "721150",
      "Benapur BO": "721301",
      "Changual BO": "721301",
      "Rakhajangle BO": "721301",
      "Sankoa BO": "721301",
      "Old Kharagpur BO": "721301",
      "Sultanpur BO": "721222",
      "Birsingha BO": "721222",
      "Chowka BO": "721232",
      "Bhasra BO": "721133",
      "Borah BO": "721133",
      "Chakla BO": "721133",
      "Sukharole BO": "721133",
      "Kotepada BO": "721426",
      "Lalitapur BO": "721426",
      "Paragana BO": "721426",
      "Adasimla BO": "721467",
      "Bonai BO": "721467",
      "Chak Islampur BO": "721457",
      "Dobaria BO": "721457",
      "Nilda BO": "721457",
      "Sautia BO": "721457",
      "Uttar Asda BO": "721443",
      "Benadiha BO": "721133",
      "Kukai BO": "721133",
      "Markanda BO": "721133",
      "Rautarapur BO": "721133",
      "Santrapur BO": "721133",
      "Uttar Dumurkhola BO": "721133",
      "Baghasti BO": "721133",
      "Jamsole BO": "721133",
      "June Belda BO": "721133",
      "Kushgeria BO": "721133",
      "Nachhipur BO": "721133",
      "Chhatorkole BO": "721467",
      "Duria BO": "721467",
      "Kalasbarh BO": "721467",
      "Akpura BO": "721457",
      "Anikola BO": "721457",
      "Barangi BO": "721457",
      "Brahamankhalisa BO": "721443",
      "Goura BO": "721146",
      "Hatsarberia BO": "721146",
      "Routara BO": "721147",
      "Saidpur BO": "721147",
      "Shalboni Raghunathpur BO": "721147",
      "Shyamchandpur BO": "721147",
      "Ellaboni BO": "721102",
      "Gurguripal BO": "721102",
      "Garh Haripur BO": "721443",
      "Keut Khalisa BO": "721443",
      "Kakrajit BO": "721426",
      "Murabani BO": "721426",
      "Saorapin BO": "721426",
      "Barachara BO": "721467",
      "Kolanda BO": "721467",
      "Rautarabari BO": "721467",
      "Sarta BO": "721467",
      "Borai BO": "721457",
      "Dhuipada BO": "721457",
      "Remu BO": "721457",
      "Bandhuchak BO": "721443",
      "Lalat BO": "721443",
      "Laudangri BO": "721445",
      "Sarrang BO": "721426",
      "Sonakonia BO": "721426",
      "Uttar Ranibarh BO": "721426",
      "Chandkutibatikati BO": "721467",
      "Kumarda BO": "721457",
      "Matibaruan BO": "721457",
      "Renjura BO": "721443",
      "Mirzapur Belda BO": "721445",
      "Porolda BO": "721445",
      "Rajnagar BO": "721436",
      "Tanua BO": "721436",
      "Bahurupa BO": "721437",
      "Barakalankai BO": "721437",
      "Kalara BO": "721146",
      "Panchberia BO": "721146",
      "Bhoudi BO": "721147",
      "Dherua BO": "721102",
      "Monidaha BO": "721102",
      "Sirisdanga BO": "721102",
      "Siromoni BO": "721102",
      "Birbira BO": "721437",
      "Dibarpanda BO": "721437",
      "Tentuliabhumjan BO": "721437",
      "Khatnagar BO": "721451",
      "Kutki BO": "721451",
      "Palsandapur BO": "721451",
      "Tararui BO": "721451",
      "Gochhati BO": "721148",
      "Jagannathpur BO": "721641",
      "Panchgechhia BO": "721148",
      "Nischintapur BO": "721148",
      "Kashinathpur BO": "721641",
      "Sreebora BO": "721130",
      "Kultikrighatal BO": "721153",
      "Maguria BO": "721153",
      "Shyamganj BO": "721153",
      "Arit BO": "721148",
      "Palaspai BO": "721146",
      "Mataldanga BO": "721102",
      "Sonakhali BO": "721146",
      "Jatrabishnupur BO": "721147",
      "Abash BO": "721102",
      "Chandra BO": "721102",
      "Nayagram Benasuli BO": "721102",
      "Tantigeria BO": "721102",
      "Charkabani BO": "721513",
      "Dharenda BO": "721304",
      "Hariatara BO": "721304",
      "Manglapur BO": "721121",
      "Nohari BO": "721121",
      "Balakrouth BO": "721641",
      "Dudhkumrarhat BO": "721130",
      "Chaipat BO": "721148",
      "Mahatapur BO": "721516",
      "Rangametia BO": "721145",
      "Sakpara BO": "721145",
      "Dhamcha BO": "721121",
      "Sahapur BO": "721641",
      "Satpota BO": "721153",
      "Kushbasan BO": "721445",
      "Chhoto Srikrishnapur BO": "721435",
      "Begunia BO": "721436",
      "Kanthalia BO": "721437",
      "Konarpur BO": "721437",
      "Kotaigarh BO": "721437",
      "Lohabaranchak BO": "721437",
      "Makrampurbazar BO": "721437",
      "Sansadgopinathpur BO": "721437",
      "Bakurpada BO": "721451",
      "Deulinekurseni BO": "721451",
      "Garhmonoharpur BO": "721451",
      "Sitapur BO": "721154",
      "Keshiary SO": "721133",
      "Nimpura SO": "721304",
      "Garhbeta SO": "721127",
      "Hijli SO": "721306",
      "Kharagpur SO": "721301",
      "Midnapore DSB SO": "721101",
      "Satbankura SO": "721253",
      "Shalboni SO": "721147",
      "Vidyasagar University SO": "721102",
      "Dhaniapara BO": "721513",
      "Demouli BO": "721145",
      "Agra BO": "721121",
      "Betjharia BO": "721121",
      "Makli BO": "721121",
      "Mayta BO": "721121",
      "Patharpara BO": "721121",
      "Asda BO": "721445",
      "Babla BO": "721445",
      "Garh Radhanagar BO": "721445",
      "Sauri BO": "721445",
      "Susinda BO": "721445",
      "Turkagarh BO": "721445",
      "Jenkapur BO": "721435",
      "Salikotha BO": "721435",
      "Amarda BO": "721436",
      "Mohanpur Market BO": "721436",
      "Fulgeria BO": "721437",
      "Khurshi BO": "721437",
      "Nankarmaguria BO": "721437",
      "Saluka BO": "721437",
      "Tentulmuri BO": "721437",
      "Kashimpur BO": "721451",
      "Kalaikunda A F SO": "721303",
      "Ballichak SO": "721124",
      "Chandrakona SO": "721201",
      "Dharma SO West Midnapore": "721101",
      "Hoomgarh SO": "721157",
      "Inda SO": "721305",
      "Kharagpur New Settlement SO": "721301",
      "Khirpai SO": "721232",
      "Marhtala SO": "721156",
      "Midnapore Court SO": "721101",
      "Radhamohanpur SO": "721160",
      "Kalukhanra BO": "721152",
      "Sijgeria BO": "721139",
      "Upalda BO": "721152",
      "Ekarukhi BO": "721445",
      "Purunda BO": "721445",
      "Sabra BO": "721445",
      "Turka Garh BO": "721445",
      "Koria BO": "721435",
      "Talda Ratanchak BO": "721435",
      "Paroi BO": "721436",
      "Siyalsai BO": "721436",
      "Bhadrakali BO": "721437",
      "Handlarajgarh BO": "721437",
      "Jhanjianankar BO": "721437",
      "Rampura BO": "721437",
      "Keshrambha BO": "721451",
      "Maljamuna BO": "721451",
      "Uchudiha BO": "721451",
      "Moupal BO": "721516",
      "Pirakata BO": "721516",
      "Satpati BO": "721516",
      "Khemasuli BO": "721513",
      "Dobati BO": "721121",
      "Fatesingpur BO": "721121",
      "Jagardanga BO": "721121",
      "Jirapara BO": "721121",
      "Midnapore HO": "721101",
      "Kamargeria BO": "721122",
      "Kongarer Ayma BO": "721122",
      "Antala BO": "721124",
      "Pasang BO": "721124",
      "Amsole BO": "721201",
      "Dhanyagachi BO": "721201",
      "Jayantipur BO": "721201",
      "Kalla BO": "721201",
      "Kuanpur BO": "721201",
      "Rajganj BO": "721201",
      "Jhakra BO": "721201",
      "Bhuta BO": "721211",
      "Brahmanbasan BO": "721211",
      "Chetua Makrampur BO": "721211",
      "Harekrishnapur BO": "721211",
      "Narajole BO": "721211",
      "Samat BO": "721211",
      "Sankarpur BO": "721211",
      "Arjuni BO": "721126",
      "Keoshi BO": "721126",
      "Fulberia BO": "721127",
      "Krishnapur BO": "721127",
      "Sanmura BO": "721127",
      "Uttarbil BO": "721127",
      "Dihiramnagar BO": "721212",
      "Doriayodhya BO": "721212",
      "Mansuka BO": "721212",
      "Anandapur SO West Midnapore": "721122",
      "Boxibazar SO": "721101",
      "Debra Bazar SO": "721126",
      "Ghatal Bazar SO": "721212",
      "Ghatal SO": "721212",
      "Gole Bazar SO": "721301",
      "Kharagpur Work Shop SO": "721301",
      "Kharar SO West Midnapore": "721222",
      "Lowada SO": "721136",
      "Lutunia SO": "721166",
      "Madpur SO": "721149",
      "Midnapore Police Line SO": "721101",
      "Mohar SO": "721161",
      "Natunbazar SO West Midnapore": "721101",
      "Neradeul SO": "721260",
      "Sabang SO": "721144",
      "Jotenarayan BO": "721139",
      "Narayanchak BO": "721154",
      "Barateghari BO": "721122",
      "Chakshyampur BO": "721124",
      "Darra BO": "721124",
      "Guruganj BO": "721124",
      "Jhanjia BO": "721124",
      "Bala BO": "721201",
      "Banka BO": "721201",
      "Benachapra BO": "721201",
      "Dadpur BO": "721211",
      "Dharampur BO": "721211",
      "Panchmaro Pratappur BO": "721212",
      "Ratneswar Bati BO": "721212",
      "Bhadutala BO": "721129",
      "Karnagarh BO": "721129",
      "Talbagicha BO": "721306",
      "Chhotonakdona BO": "721157",
      "Harirampur BO": "721211",
      "Jotebani BO": "721211",
      "Chaklahana BO": "721126",
      "Chaknarsing BO": "721126",
      "Dhamtore BO": "721126",
      "Pakuria BO": "721126",
      "Malbandi BO": "721127",
      "Panikotor BO": "721127",
      "Pathartoria BO": "721127",
      "Raskundu BO": "721127",
      "Gopmahal BO": "721212",
      "Jaynagar BO": "721212",
      "Kaijuri BO": "721212",
      "Kamalpur Sriramnagar BO": "721212",
      "Khanjapur BO": "721212",
      "Dhekia SO": "721304",
      "Salua SO": "721145",
      "Amlagora SO": "721121",
      "Daspur SO": "721211",
      "Goaltore SO": "721128",
      "Godapeasal SO": "721129",
      "Habibpur SO West Midnapore": "721101",
      "Jalchak SO": "721155",
      "Keshpur SO": "721150",
      "Kharagpur Technology SO": "721302",
      "Mathurakati SO": "721301",
      "Midnapore Collectorate SO": "721101",
      "Midnapore Sitala SO": "721101",
      "Pingla SO": "721140",
      "Ramjibanpur SO": "721242",
      "Reserve Bank Nm Ltd SO": "721132",
      "Sekendari SO": "721146",
      "Bagri Krishnanagar BO": "721121",
      "Duria Radhaballav BO": "721122",
      "Kanasole BO": "721122",
      "Kotai BO": "721122",
      "Brahmansasan BO": "721124",
      "Kalikadihi BO": "721124",
      "Bhagabantapur BO": "721201",
      "Chhatraganj BO": "721201",
      "Dhyamkuria BO": "721201",
      "Ghatmura BO": "721201",
      "Kalakari BO": "721201",
      "Korasia BO": "721201",
      "Mahespur Murakata BO": "721201",
      "Tenpur BO": "721201",
      "Chakpurusottampur BO": "721211",
      "Harirajpur BO": "721211",
      "Radhakantapur BO": "721211",
      "Sagarpur BO": "721211",
      "Uttardhankhal BO": "721211",
      "Chhota Bhagabanpur BO": "721126",
      "Mukshudpur BO": "721126",
      "Dhadika BO": "721127",
      "Gopalsole BO": "721127",
      "Sandhipur BO": "721127",
      "Sanpdaha BO": "721127",
      "Benai BO": "721212",
      "Dirghagram BO": "721212",
      "Jotekanuram Garh BO": "721212",
      "Keshabchak BO": "721212",
      "Khasbarh BO": "721212",
      "Andharia Bandri Sole BO": "721128",
      "Gohaldihi BO": "721129",
      "Kashijora BO": "721129",
      "Hijli Cooperative BO": "721306",
      "Sahaspur BO": "721122",
      "Andharnayan BO": "721201",
      "Keshadal BO": "721201",
      "Khirati BO": "721201",
      "Kiageria BO": "721201",
      "Pandua BO": "721201",
      "Barhgobinda BO": "721211",
      "Bhangabandh BO": "721211",
      "Chetua Rajnagar BO": "721211",
      "Kalmijore BO": "721211",
      "Molighati BO": "721211",
      "Chandeabila Khudiasole BO": "721127",
      "Kharkusma BO": "721127",
      "Balidanga BO": "721212",
      "Nimtala BO": "721212",
      "Panna BO": "721212",
      "Radhanagar BO": "721212",
      "Ranichak BO": "721212",
      "Ranir Bazar Simulia BO": "721212",
      "Rathipur BO": "721212",
      "Doulatchak BO": "721212",
      "Bulanpur BO": "721128",
      "Debagram BO": "721128",
      "Pingboni BO": "721128",
      "Beuncha BO": "721129",
      "Amjore BO": "721157",
      "Amlasuli BO": "721157",
      "Akanda BO": "721424",
      "Chakmahima BO": "721424",
      "Kanpur BO": "721424",
      "Saljora BO": "721424",
      "Thakurchak BO": "721424",
      "Angua BO": "721426",
      "Jamirapalgarh BO": "721426",
      "Chhotochatla BO": "721424",
      "Dhalbelun BO": "721424",
      "Dhangarpara BO": "721424",
      "Gaita BO": "721424",
      "Uparjagatpur BO": "721424",
      "Banjhatia BO": "721426",
      "Baita Bazar SO": "721420",
      "Gomunda SO": "721457",
      "Mohanpur SO West Midnapore": "721436",
      "Menkapur SO": "721435",
      "Belda SO": "721424",
      "Dantan SO": "721426",
      "Jahalda SO": "721443",
      "Khakurda SO": "721445",
      "Khalina BO": "721424",
      "Lalnagar BO": "721424",
      "Phandar BO": "721424",
      "Belmula BO": "721426",
      "Chaulia BO": "721426",
      "Gazipur BO": "721426",
      "Dasagram SO": "721467",
      "Bakhrabad BO": "721424",
      "Kashipur BO": "721424",
      "Reripur BO": "721424",
      "Tarua BO": "721424",
      "Bamanda BO": "721426",
      "Kheput SO": "721148",
      "Khukurdaha SO": "721641",
      "Narayangarh SO West Midnapore": "721437",
      "Nekurseni SO": "721451",
      "Joteghanashyam SO": "721153"
    },
    "MEDINIPUR EAST": {
      "Chabukiauttarbarh BO": "721144",
      "Paschimbarh BO": "721144",
      "Taladiha BO": "721144",
      "Dakhinkasimnagar BO": "721632",
      "Dayaldasi BO": "721632",
      "Kalyanpur BO": "721632",
      "Haripur BO": "721631",
      "Kendamari BO": "721631",
      "Naynan BO": "721631",
      "Brindabanpur BO": "721633",
      "Chaknan BO": "721633",
      "Ektarpur BO": "721633",
      "Gopinathpur BO": "721633",
      "Dakshinmoyna BO": "721629",
      "Moynakalagachia BO": "721629",
      "Kumarara BO": "721632",
      "Sitalpur BO": "721632",
      "Amgachia BO": "721631",
      "Durgapur BO": "721631",
      "Nilpur BO": "721631",
      "Priyanagar BO": "721631",
      "Baroj BO": "721633",
      "Gurgram BO": "721633",
      "Kotebarh BO": "721633",
      "Amdan BO": "721131",
      "Kalidan BO": "721131",
      "Srikantha BO": "721629",
      "Tilkhoja BO": "721629",
      "Rampur BO": "721631",
      "Samsabad BO": "721631",
      "Sarberia BO": "721631",
      "Khagdabirgram BO": "721633",
      "Mahespur BO": "721452",
      "Murisai BO": "721452",
      "Purbadakshinmoyna BO": "721629",
      "Kalyanchak BO": "721632",
      "Daudpurnandi BO": "721631",
      "Garhchakraberia BO": "721631",
      "Osmanchak BO": "721631",
      "Parulbari BO": "721631",
      "Rajaramchak BO": "721631",
      "Atattar BO": "721633",
      "Kandapasra BO": "721633",
      "Paschim Manikpur BO": "721452",
      "Chandanpur BO": "721439",
      "Ghatua Purusottampur BO": "721438",
      "Kalyanpur Tentulmuri BO": "721447",
      "Chatla BO": "721448",
      "Amarpur BO": "721439",
      "Gokulpur BO": "721439",
      "Brindaban Chak BO": "721641",
      "Kumarpur BO": "721654",
      "Amritberia BO": "721628",
      "Kurpai BO": "721649",
      "Nakibasan BO": "721649",
      "Simulia BO": "721649",
      "Uttar Sautanchak BO": "721649",
      "Kekai BO": "721439",
      "Ballyagobindapur BO": "721440",
      "Alankarpur BO": "721441",
      "Haldia Patna BO": "721441",
      "Aswathapur BO": "721446",
      "Chandanpurhat BO": "721446",
      "Dhandalibarh BO": "721452",
      "Junboni BO": "721452",
      "Uttar Badalpur BO": "721452",
      "Kultikri Aranga BO": "721448",
      "Negua BO": "721448",
      "Shipur BO": "721448",
      "Argora BO": "721439",
      "Ayma Barbaria BO": "721439",
      "Bulakipur BO": "721439",
      "Naipur BO": "721439",
      "North Biswanathpur BO": "721439",
      "Satbahini BO": "721439",
      "Chakbhabani BO": "721440",
      "Pania BO": "721440",
      "Srirampur BO": "721440",
      "Damodarpur BO": "721446",
      "Jasteghori BO": "721446",
      "Basudebpur BO": "721452",
      "Bhajachauli BO": "721452",
      "Uttar Kanpur BO": "721453",
      "Sarada BO": "721427",
      "Saripur BO": "721428",
      "Chhatri BO": "721429",
      "Kharuigarh BO": "721429",
      "Rasan BO": "721429",
      "Ajoya BO": "721430",
      "Dekhali BO": "721430",
      "Krishnanagar Contai BO": "721430",
      "Tikashi BO": "721430",
      "Mustafapur BO": "721443",
      "Khagda BO": "721452",
      "Kasbagola BO": "721447",
      "Telami BO": "721447",
      "Chorpalia BO": "721448",
      "Dubda BO": "721448",
      "Garia BO": "721448",
      "Juki BO": "721448",
      "Khurutia BO": "721448",
      "Jhawgeria BO": "721441",
      "Mandar BO": "721441",
      "Kandagram BO": "721446",
      "Mirgoda BO": "721446",
      "Sadihat BO": "721446",
      "Sadikpur BO": "721446",
      "Sahara BO": "721446",
      "Raichak BO": "721642",
      "Jasora BO": "721641",
      "Jiakhali BO": "721641",
      "Madhusudanchak BO": "721655",
      "Jamitya BO": "721134",
      "Kharui BO": "721134",
      "Baroda BO": "721658",
      "Dhekua BO": "721658",
      "Barabhuniakhali BO": "721652",
      "Jalpai BO": "721652",
      "Baruttarhingli BO": "721654",
      "Iswardahajalpai BO": "721654",
      "Kalikakundu BO": "721654",
      "Ghasipur BO": "721628",
      "Gopalpur BO": "721628",
      "Kanchanpur BO": "721628",
      "Kapasaria BO": "721628",
      "Keshabpur BO": "721628",
      "Madhyahingli BO": "721628",
      "Rambag BO": "721628",
      "Barsimulbari BO": "721659",
      "Iswarpur BO": "721659",
      "Kakra BO": "721659",
      "Khanyadihi BO": "721641",
      "Narayandari BO": "721655",
      "Porachingra BO": "721655",
      "Dhankar BO": "721458",
      "Barada Bazar BO": "721448",
      "Chirulia BO": "721448",
      "Jumki BO": "721448",
      "Alamchak Belda BO": "721439",
      "Kanakpur BO": "721439",
      "Makrampur BO": "721439",
      "Gobra BO": "721441",
      "Hirapur BO": "721441",
      "Bishnupur BO": "721446",
      "Bolkhusda BO": "721446",
      "Ranisai BO": "721446",
      "Biswanathpur BO": "721452",
      "Arror BO": "721134",
      "Golapchak BO": "721658",
      "Dakshindamodarpur BO": "721652",
      "Motilalchak BO": "721652",
      "Dakshinchak BO": "721654",
      "Dwariberia BO": "721654",
      "Bamunia BO": "721628",
      "Champi BO": "721628",
      "Rajarampur BO": "721628",
      "Ashutiabarh BO": "721659",
      "Brajalalchak BO": "721659",
      "Paschimpatna BO": "721659",
      "Sultanpurbazar BO": "721659",
      "Ballukhat BO": "721137",
      "Joybalarampur BO": "721137",
      "Chakjiandighi BO": "721649",
      "Kakgechia BO": "721649",
      "Changra BO": "721629",
      "Srikrishnapur BO": "721659",
      "Barnan BO": "721137",
      "Burarihat BO": "721137",
      "Hogla BO": "721137",
      "Jawfullybibichak BO": "721137",
      "Manikabasan BO": "721453",
      "Paldhui BO": "721453",
      "Amtalia BO": "721427",
      "Bhawanichak BO": "721427",
      "Ghoraghata BO": "721427",
      "Kulanjara BO": "721427",
      "Payamedinipur BO": "721428",
      "Bartana BO": "721429",
      "Kaithore BO": "721429",
      "Khar BO": "721429",
      "Barabari South BO": "721430",
      "Chingurdania BO": "721430",
      "Mohati BO": "721430",
      "Subdi BO": "721430",
      "Barabatia BO": "721443",
      "Baratala BO": "721431",
      "Boga BO": "721431",
      "Gopichak BO": "721431",
      "Kartickkhali BO": "721431",
      "Biswas BO": "721636",
      "Bakcha BO": "721642",
      "Kalikadari BO": "721642",
      "Paikbheri BO": "721601",
      "Baharpota BO": "721151",
      "Sitalaparamanandapur BO": "721151",
      "Dakshin Narikelda BO": "721648",
      "Uttarsonamui BO": "721648",
      "Barbasudevpur BO": "721645",
      "Gobindapurbajitpur BO": "721645",
      "Naikuri BO": "721653",
      "Geondab BO": "721657",
      "Pitambarchak BO": "721657",
      "Deulpota BO": "721603",
      "Rain BO": "721130",
      "Muradpur BO": "721625",
      "Ashutia BO": "721626",
      "Baraibarh BO": "721626",
      "Madhabpur BO": "721626",
      "Paschimnaichanpur BO": "721642",
      "Sulani BO": "721158",
      "Naba Anantapur BO": "721601",
      "Nabatajpur BO": "721601",
      "Deriachak BO": "721151",
      "Namalbarh BO": "721151",
      "Sagarbarh BO": "721151",
      "Siddha BO": "721151",
      "Ramtarakhat BO": "721151",
      "Dakshinsrikrishnapur BO": "721648",
      "Purba Madhabpur BO": "721453",
      "Uttar Gobindapur BO": "721453",
      "Uttar Amtalia BO": "721427",
      "Baranihary BO": "721429",
      "Barida Bazar BO": "721429",
      "Lakhi BO": "721430",
      "Uttar Kalamdan BO": "721430",
      "Kasaria BO": "721431",
      "Ganjanarayanpur BO": "721648",
      "Mayachar BO": "721648",
      "Mirpur BO": "721648",
      "Basudevpur BO": "721602",
      "Khanjanchak BO": "721602",
      "Jagatpur BO": "721603",
      "Natshal BO": "721603",
      "Rajaniganj BO": "721603",
      "Hanubhunia BO": "721625",
      "Gobindapur BO": "721627",
      "Nilkunthia BO": "721627",
      "Lakshmanchak BO": "721431",
      "Medakhali BO": "721431",
      "Nijkasba BO": "721431",
      "Pankhai BO": "721431",
      "Satkhanda Sahebnagar BO": "721431",
      "Chauddachulli BO": "721432",
      "Deulpota Keshabchak BO": "721432",
      "Raipur Paschimbarh BO": "721401",
      "Barmakhal BO": "721434",
      "Banamalichatta BO": "721449",
      "Ichhabari BO": "721444",
      "Kanaidighi BO": "721444",
      "Kayemgeria BO": "721444",
      "Sarpai BO": "721444",
      "Aurai BO": "721427",
      "Jamua Sankarpur BO": "721427",
      "Namaldiha BO": "721427",
      "Benachakri BO": "721429",
      "Erenda BO": "721429",
      "Susunia BO": "721429",
      "Bansgora Bazar BO": "721430",
      "Dakshin Kalamdan BO": "721430",
      "Jukhia Bazar BO": "721430",
      "Thakurnagar BO": "721430",
      "Radhaballavpur BO": "721627",
      "Teghorijoteviram BO": "721627",
      "Dhanyaghar BO": "721643",
      "Purbagopalchak BO": "721656",
      "Nazirbaza5r BO": "721655",
      "Tiorkhali BO": "721655",
      "Amalhara BO": "721134",
      "Dorokashipur BO": "721658",
      "Bargodagodar BO": "721652",
      "Basanchak BO": "721654",
      "Hadia BO": "721654",
      "Basulia BO": "721628",
      "Garhkamalpur BO": "721628",
      "Alinan BO": "721137",
      "Bainchberia BO": "721649",
      "Hijalberia BO": "721649",
      "Kulberia BO": "721649",
      "Asnan BO": "721642",
      "Goramahal BO": "721642",
      "Kiarana BO": "721642",
      "Kishorechak BO": "721642",
      "Lalpur BO": "721601",
      "Mahammadpur BO": "721601",
      "Balughata BO": "721645",
      "Barabari BO": "721645",
      "Raghurampur BO": "721645",
      "Chakdwipa BO": "721645",
      "Haridaspur BO": "721653",
      "Salikagarchak BO": "721653",
      "Charabarh BO": "721626",
      "Garbari BO": "721626",
      "Sukrullapur BO": "721626",
      "Tajpur BO": "721656",
      "Dhalhara BO": "721636",
      "Gobradan BO": "721642",
      "Mirzanagar BO": "721642",
      "Illaspur BO": "721601",
      "Srikantapur BO": "721601",
      "Harasankar BO": "721151",
      "Uttarjianda BO": "721151",
      "Barakamarda BO": "721648",
      "Barbajitpur BO": "721645",
      "Barghasipur BO": "721657",
      "Hatiberia BO": "721657",
      "Purbasrirampur BO": "721603",
      "Saluka BO": "721130",
      "Haldia Port BO": "721607",
      "Kulbari BO": "721625",
      "Nandapur BO": "721625",
      "Bahadurpur BO": "721626",
      "Barbaria BO": "721626",
      "Uttarkotebarh BO": "721626",
      "Bahichard BO": "721627",
      "Khejuri BO": "721431",
      "Kunjapur BO": "721431",
      "Deshdattabarh BO": "721450",
      "Jhawa BO": "721450",
      "Paschim Bamunia BO": "721450",
      "Haludbari BO": "721432",
      "Jahanabad BO": "721432",
      "Takapura BO": "721432",
      "Dhangaon BO": "721401",
      "Kantai BO": "721401",
      "Majna BO": "721433",
      "Majnaberia BO": "721633",
      "Pairachali BO": "721633",
      "Narghat Laban Satyagraha BO": "721633",
      "Bijoyramchak BO": "721152",
      "Chakradhaban BO": "721152",
      "Harijhama BO": "721152",
      "Maguri Jagannathchak BO": "721152",
      "Pratappur BO": "721152",
      "Arisanda BO": "721139",
      "Dehati BO": "721139",
      "Bibhisanpur BO": "721458",
      "Noonhanda BO": "721458",
      "Panchahari BO": "721458",
      "Totanala BO": "721458",
      "Goleghat BO": "721139",
      "Patanda BO": "721139",
      "Changrachak BO": "721644",
      "Gourangachak BO": "721644",
      "Ramchakmoyna BO": "721644",
      "Sudampur BO": "721644",
      "Purba Itara BO": "721634",
      "Dobandi BO": "721647",
      "Paschimchilka BO": "721647",
      "Bheturia BO": "721650",
      "Monoharpur BO": "721650",
      "Rajnagar Baharjola BO": "721651",
      "Sulochanarambhadrapur BO": "721651",
      "Agadoro BO": "721635",
      "Gokulnagar BO": "721646",
      "Mandarpur BO": "721433",
      "Sisusadan BO": "721433",
      "Tagaria BO": "721433",
      "Dhankrabanka BO": "721434",
      "Maisali BO": "721434",
      "Panchuria BO": "721434",
      "Analberia BO": "721444",
      "Gangadharchak BO": "721444",
      "Arankiarana SO": "721642",
      "Baishnabchak SO": "721158",
      "Hour SO": "721131",
      "Katka Debichak BO": "721431",
      "Barabantalia BO": "721450",
      "Dakshin Dauki BO": "721450",
      "Kamarda Bazar BO": "721432",
      "Tengunia BO": "721401",
      "Haipur BO": "721433",
      "Saridaspur BO": "721434",
      "Taghari BO": "721434",
      "Daisai BO": "721449",
      "Basudebberia BO": "721444",
      "Dakhin Sandalpur BO": "721444",
      "Dighadari BO": "721444",
      "Kumirda BO": "721444",
      "Paushi BO": "721444",
      "Bankibheri BO": "721458",
      "Keunchia BO": "721431",
      "Ramchak BO": "721431",
      "Sillyaberia BO": "721431",
      "Gopalnagar Hat BO": "721139",
      "Keshapat BO": "721139",
      "Dalpara BO": "721139",
      "Donachak BO": "721644",
      "Deulia BO": "721154",
      "Baharganj BO": "721432",
      "Serkhanchak BO": "721432",
      "Namal BO": "721401",
      "Battala BO": "721433",
      "Maitana BO": "721433",
      "Karaldanimakbarh BO": "721449",
      "Darua BO": "721401",
      "Dhanghara BO": "721444",
      "Panichiary BO": "721444",
      "Bhimeswaribazar BO": "721458",
      "Ururi BO": "721458",
      "Dumdun BO": "721152",
      "Lakshyakuri BO": "721152",
      "Maguri Uttarsai BO": "721152",
      "Meghadangar BO": "721152",
      "Bakulda BO": "721139",
      "Kishorepur BO": "721139",
      "Naranda BO": "721139",
      "Ratulia BO": "721139",
      "Uttarmechogram BO": "721139",
      "Dakshin Changrachak BO": "721644",
      "Payag BO": "721154",
      "Dabuapukur BO": "721634",
      "Purbachilka BO": "721647",
      "Akandabari BO": "721650",
      "Gholpukuria BO": "721650",
      "Putputia BO": "721651",
      "Bhuniaraychak BO": "721635",
      "Dorokrishnanagar BO": "721635",
      "Shibramnagar BO": "721635",
      "Kiakhali BO": "721646",
      "Simulkundu BO": "721646",
      "Asadtala BO": "721656",
      "Boyal BO": "721656",
      "Demarihat BO": "721172",
      "Bara Gokul Nagar BO": "721152",
      "Shyam Sundarpur Patna BO": "721139",
      "Chapda BO": "721154",
      "Dhuliapur BO": "721634",
      "Kalagechhia Bara BO": "721634",
      "Barakurmarchak BO": "721647",
      "Etamogra BO": "721628",
      "Keshabpurjalpai BO": "721628",
      "Debipur BO": "721650",
      "Abasbari SO": "721637",
      "Balidangri SO": "721139",
      "Bargabhima SO": "721636",
      "Garh Krishna Nagar BO": "721650",
      "Kamalpur BO": "721650",
      "Shibrampur BO": "721650",
      "Bargoda BO": "721651",
      "Purbasrikrishnapur BO": "721635",
      "Tabakhali BO": "721635",
      "Tajnagar BO": "721635",
      "Sonachura BO": "721646",
      "Amratala BO": "721656",
      "Bhekutia BO": "721656",
      "Manuchak BO": "721656",
      "Bhagwanpur SO East Midnapore": "721601",
      "Jaigirchak BO": "721644",
      "Sajinagechhia BO": "721154",
      "Mahadole BO": "721634",
      "Sundarnagar BO": "721634",
      "Amdabad BO": "721650",
      "Birulia BO": "721650",
      "Khodambari BO": "721650",
      "Runkinipur BO": "721650",
      "Changrakalaganda BO": "721651",
      "Anantapur BO": "721635",
      "Dorojoynagar BO": "721635",
      "Kalicharanpur BO": "721646",
      "Saudkhali BO": "721646",
      "Baraghuni BO": "721656",
      "Bhogpur SO East Midnapore": "721151",
      "Tamluk HO": "721636",
      "Contai HO": "721401",
      "Barhat BO": "721454",
      "Madanmohanpur BO": "721454",
      "Selmabad BO": "721454",
      "Itaberia BO": "721456",
      "Kalsi BO": "721456",
      "Mathura BO": "721456",
      "Bahitrakunda BO": "721401",
      "Balageria BO": "721422",
      "Bathuary BO": "721422",
      "Keutgeria BO": "721422",
      "Khejurda BO": "721422",
      "Bodhra BO": "721423",
      "Deuli BO": "721423",
      "Satilapur BO": "721423",
      "Bankiput BO": "721442",
      "Chapatala BO": "721442",
      "Bhaghadari BO": "721425",
      "Mugberia BO": "721425",
      "Dadanpatrabarh BO": "721455",
      "Pichabani BO": "721455",
      "Daudpur BO": "721401",
      "Arjunnagar BO": "721456",
      "Bamanbarh BO": "721456",
      "Baraudaypur BO": "721456",
      "Brajaballavpur BO": "721456",
      "Astichak BO": "721422",
      "Bidurpur BO": "721422",
      "Hatbaincha BO": "721422",
      "Pirijkhanbarh BO": "721422",
      "Urdhabpur BO": "721422",
      "Baikunthapur BO": "721442",
      "Basuli Bazar BO": "721425",
      "Baksispur BO": "721401",
      "Mahisagote BO": "721401",
      "Pailachhanpur BO": "721401",
      "Amarshi SO": "721454",
      "Basantia SO East Midnapore": "721442",
      "Digha New Township SO": "721463",
      "Kalagachia SO East Midnapore": "721432",
      "Monoharchak SO": "721406",
      "Argoal SO": "721456",
      "Hatgopalpur BO": "721454",
      "Katranka BO": "721454",
      "Saulabheri BO": "721454",
      "Manikjore BO": "721456",
      "Sukhakhola BO": "721456",
      "Fuleswar BO": "721401",
      "Durmuth BO": "721405",
      "Jamualachimpur BO": "721422",
      "Kajli BO": "721422",
      "Uttartajpur BO": "721422",
      "Gopalchak BO": "721423",
      "Karanji BO": "721423",
      "Narandia BO": "721423",
      "Narkuli BO": "721423",
      "Dholmari BO": "721442",
      "Safiabad BO": "721442",
      "Uttarharaschak BO": "721442",
      "Purbaradhapur BO": "721425",
      "Udbadal BO": "721425",
      "Islampur BO": "721455",
      "Kalindi BO": "721455",
      "Kalindi Teghari BO": "721455",
      "Sabajput BO": "721401",
      "Damodarpur Contai BO": "721401",
      "Balisai SO": "721423",
      "Chaulkhola SO": "721455",
      "Deulbarh SO": "721427",
      "Digha SO East Midnapore": "721428",
      "Egra Kasba SO": "721429",
      "Janka SO": "721431",
      "Junput SO": "721450",
      "Khalisabhanga SO": "721433",
      "Balighai SO": "721422",
      "Bhupatinagar SO": "721425",
      "Egra SO": "721429",
      "Marisda SO": "721449",
      "Athilagori SO": "721405",
      "Contai Bazar SO": "721403",
      "Contai Super Market SO": "721402",
      "Depal SO": "721453",
      "Haria SO": "721430",
      "Karkuli SO": "721404",
      "Manglamaro SO": "721434",
      "Alukaranbarh BO": "721454",
      "Jabda BO": "721456",
      "Lalua BO": "721456",
      "Ajodhyapur BO": "721401",
      "Alangiri BO": "721420",
      "Jerthan BO": "721420",
      "Atbati BO": "721422",
      "Bhatda BO": "721422",
      "Naskarpur BO": "721422",
      "Dakhin Badalpur BO": "721423",
      "Shyampur BO": "721423",
      "Benichak BO": "721442",
      "Dariapur BO": "721442",
      "Bayenda BO": "721425",
      "Dumandari BO": "721425",
      "Bhuniajibarh BO": "721455",
      "Dakshin Kalyanpur BO": "721455",
      "Silampur BO": "721455",
      "Srirampur Contai BO": "721401",
      "Nayaput BO": "721401",
      "Panchetgarh SO": "721438",
      "Pratapdighi SO": "721440",
      "Satmile SO": "721452",
      "Durgachak Colony SO": "721602",
      "Kismatbajkul SO": "721655",
      "Palpara SO East Midnapore": "721458",
      "Lakshya SO": "721654",
      "Moyna SO": "721629",
      "Parbatipur SO": "721636",
      "Byabattarhat SO": "721648",
      "Durgachak SO": "721602",
      "Chaitannyapur SO": "721645",
      "Chanserpur SO": "721653",
      "Debhog SO": "721657",
      "Gopalnagar SO East Midnapore": "721130",
      "HIT SO": "721606",
      "Haldia OR SO": "721606",
      "Haldia SO": "721604",
      "Hanschara SO": "721625",
      "Kolaghat RS SO": "721134",
      "Ktpp TS SO": "721171",
      "Mahisadal SO": "721628",
      "Nonakuribazar SO": "721172",
      "Raghunathbari SO": "721634",
      "Nachinda Bazar SO": "721444",
      "Paniparul SO": "721448",
      "Patashpur SO": "721439",
      "Sagareswar SO": "721446",
      "Ramchandrapur SO East Midnapore": "721647",
      "Rangibasan SO": "721624",
      "Srirampur Mid SO": "721651",
      "Tekhalibazar SO": "721646",
      "Haldia TS SO": "721607",
      "Kajlagarh SO": "721626",
      "Kolaghat SO": "721134",
      "Kumarchak SO": "721652",
      "Mechada SO": "721137",
      "Mirikpur SO": "721649",
      "Nandakumar SO": "721632",
      "Narghat SO": "721633",
      "Padumbasan SO": "721636",
      "Panskura SO": "721139",
      "Pulsita SO": "721154",
      "Reapara SO": "721650",
      "Salgechhia SO": "721636",
      "Sankarara SO": "721636",
      "Panchrol SO": "721447",
      "Ramnagar SO East Midnapore": "721441",
      "Geonkhali SO": "721603",
      "Kelomal SO": "721627",
      "Khanchi SO": "721643",
      "Kolaghat Natun Bazar SO": "721134",
      "Ktpp SO": "721137",
      "Kukrahati SO": "721658",
      "Mathchandipur SO": "721659",
      "Nandigram SO": "721631",
      "Paikpari SO": "721134",
      "Panskura RS SO": "721152",
      "Paramanandapur SO": "721644",
      "Sutahata SO": "721635",
      "Terapakhia SO": "721656"
    },
    "MURSHIDABAD": {
      "Manikahar BO": "742163",
      "Milki BO": "742163",
      "Dutta Barutia BO": "742401",
      "Gidgram BO": "742401",
      "Chabghati BO": "742201",
      "Khatua BO": "742122",
      "Nagra BO": "742122",
      "Patkeldanga BO": "742122",
      "Tanti Birol BO": "742235",
      "Debaipur BO": "742135",
      "Diar Fatepur BO": "742135",
      "Kalukhali BO": "742135",
      "Mahisasthali BO": "742135",
      "Nashipur Balagachi BO": "742135",
      "Dogachi BO": "742202",
      "Tinpukuria BO": "742202",
      "Gangaprasad BO": "742213",
      "AMAIPARA BO": "742123",
      "AMDAHARA BO": "742123",
      "Khandua BO": "742148",
      "Krishnapur Dinupara BO": "742148",
      "Krishnapur BO": "742148",
      "Manikchak BO": "742148",
      "Maya BO": "742148",
      "Bilcolony BO": "742184",
      "Chanak BO": "742184",
      "Panchgram BO": "742184",
      "Kadamtala BO": "742224",
      "Kashimnagar BO": "742224",
      "Kharati BO": "742226",
      "Megha Siara BO": "742226",
      "Moregram BO": "742226",
      "Nimgram Beluri BO": "742226",
      "Noapara BO": "742226",
      "Moshimpur BO": "742163",
      "Palitpara BO": "742163",
      "Malihati BO": "742401",
      "Salu BO": "742401",
      "Sunuti BO": "742401",
      "Ujunia BO": "742401",
      "Koregram BO": "742404",
      "Puropara BO": "742201",
      "Adibasi Beldanga BO": "742122",
      "Dasturhat BO": "742122",
      "Sahapurbarala BO": "742122",
      "Dakshingramsabitri BO": "742235",
      "Ghorshala BO": "742122",
      "Jarur BO": "742235",
      "Bahadurpur BO": "742135",
      "Bhagabangola Sundarpur BO": "742135",
      "Jajriachar Dumuria BO": "742135",
      "Amtala Mobile BO": "742202",
      "Anantapur BO": "742202",
      "Arjunpur   BO": "742202",
      "Bahagalpur BO": "742202",
      "Chakshyapur BO": "742202",
      "Kankuria BO": "742202",
      "Kuli BO": "742202",
      "Lalpur BO": "742202",
      "Mahadebnagar BO": "742202",
      "Bagdabra BO": "742212",
      "Beniagram BO": "742212",
      "Adikantanagar BO": "742227",
      "Dafarpur BO": "742227",
      "Diar Raninagar BO": "742227",
      "Bahadurpur Roypur BO": "742223",
      "Chandni Chak Hat BO": "742223",
      "Fatullapur BO": "742223",
      "Gangin BO": "742223",
      "Naya Bahadurpur BO": "742223",
      "Nurpur BO": "742223",
      "Raghunathpur BO": "742223",
      "Sadekpur BO": "742223",
      "Khodarampur BO": "742213",
      "Kulgachi BO": "742213",
      "KOLAN RADHAKANTAPUR BO": "742123",
      "SADEKBAG BO": "742123",
      "SRIPAT SINGH COLLEGE BO": "742123",
      "Ashariadaha BO": "742148",
      "Bajupur Madhupur BO": "742148",
      "Bansgara BO": "742148",
      "Barjumla BO": "742148",
      "Upar Fatepur BO": "742148",
      "Balia BO": "742237",
      "Kabilpur BO": "742237",
      "Karaya BO": "742237",
      "Kherur BO": "742237",
      "Pasla BO": "742184",
      "Rasulpur BO": "742184",
      "Singer BO": "742184",
      "Targram BO": "742184",
      "Bazarshaw BO": "742163",
      "Lohadaha BO": "742163",
      "Sompara BO": "742163",
      "Dechapra BO": "742401",
      "Gulhatia BO": "742401",
      "Kharera BO": "742401",
      "Salinda BO": "742401",
      "Sarmastipur BO": "742404",
      "Hasanpur BO": "742302",
      "Parulia BO": "742201",
      "Gobardhandanga BO": "742122",
      "Singheswari Gouripur BO": "742122",
      "Sendajamur BO": "742235",
      "Uttar Ramna BO": "742235",
      "Diar Shyampur BO": "742135",
      "Hanumanta Nagar BO": "742135",
      "Jibanpur BO": "742135",
      "Kantanagar BO": "742135",
      "Nayakharida Babupur BO": "742135",
      "Rampur BO": "742113",
      "Bhabanipur BO": "742202",
      "Momrejpur BO": "742202",
      "Ratanpur BO": "742202",
      "Farakka BO": "742212",
      "Tildanga BO": "742212",
      "Pasai BO": "742227",
      "Choa BO": "742166",
      "Lochanmati Dangapara BO": "742166",
      "Mridadpur BO": "742304",
      "Nazirpur BO": "742189",
      "Nutan Durgapur BO": "742304",
      "Choapara BO": "742305",
      "DPareshpur BO": "742305",
      "Godagari BO": "742305",
      "Telkar Dafarpur BO": "742187",
      "Tikiapara BO": "742187",
      "Dhulari BO": "742308",
      "Harudanga BO": "742308",
      "Kangali Mondalpara BO": "742308",
      "Bundainagar BO": "742175",
      "Pareshnathpur BO": "742175",
      "Rajnagar BO": "742227",
      "Jhowbona BO": "742175",
      "Bamnabad BO": "742306",
      "Char Rajapur BO": "742306",
      "Charmunsipara BO": "742306",
      "Dudsar BO": "742174",
      "Jhikra BO": "742174",
      "Jadupur BO": "742405",
      "Kamnagar BO": "742405",
      "Kanthalia BO": "742405",
      "Karna Subarna BO": "742405",
      "Loharpur BO": "742224",
      "Naskarpur BO": "742224",
      "Laskarpur BO": "742151",
      "Sadar Nashipur BO": "742151",
      "Siteshnagar BO": "742151",
      "Bhola BO": "742226",
      "Bokhara BO": "742226",
      "Ramna Sekhdighi BO": "742227",
      "Ahiran BO": "742223",
      "Alampur BO": "742223",
      "Kanupur BO": "742223",
      "Barasimul BO": "742213",
      "Dayarampur BO": "742213",
      "Giria BO": "742213",
      "Kashiadanga BO": "742213",
      "Lalkhandiar BO": "742213",
      "Ramdebpur BO": "742213",
      "Bhandara BO": "742123",
      "Bilbora Kopra BO": "742148",
      "Paharpur BO": "742148",
      "Pilky BO": "742237",
      "Garorah BO": "742184",
      "Kanfala BO": "742184",
      "Chachanda BO": "742224",
      "Dafahat BO": "742224",
      "Nimtita Joykrishnapur BO": "742224",
      "Boyar BO": "742226",
      "Dohali Dangapara BO": "742226",
      "Pundi BO": "742226",
      "Samsabad BO": "742226",
      "Garaimari BO": "742303",
      "Khairamari BO": "742303",
      "Kuchiamora BO": "742303",
      "Kupila BO": "742303",
      "PTRasulpur BO": "742303",
      "Raipur BO": "742303",
      "Godhanpara BO": "742304",
      "Gokul Gobindapur BO": "742304",
      "Gopinathpur Madhyapara BO": "742304",
      "Madanpur BO": "742304",
      "Faridpur BO": "742303",
      "Mominpur BO": "742303",
      "Boxipur BO": "742303",
      "Gaznipur BO": "742166",
      "Padmanavpur BO": "742166",
      "Ramkrishnapur BO": "742166",
      "Sahazadpur BO": "742166",
      "Swaruppur BO": "742166",
      "Tartipur BO": "742166",
      "Goas BO": "742304",
      "Kaladanga BO": "742304",
      "Malibari BO": "742304",
      "Paikmari BO": "742304",
      "Tenka Raipur BO": "742304",
      "Joykrishnapur BO": "742305",
      "Gopinathpur BO": "742134",
      "Jahankosha BO": "742149",
      "Durgapur BO": "742187",
      "Joykrishnapur Gangarampur BO": "742187",
      "Rainda BO": "742187",
      "Borderpara BO": "742308",
      "Jinnatpara BO": "742308",
      "Katlamari BO": "742308",
      "Nabipur BO": "742308",
      "Ramnagar Dk BO": "742308",
      "Trimohini BO": "742175",
      "Debipur BO": "742134",
      "Rajapur BO": "742306",
      "Charmahula BO": "742405",
      "Gobindapur BO": "742405",
      "Kodla BO": "742405",
      "Bipra Sekhar BO": "742168",
      "Nabadurga BO": "742168",
      "Bahara BO": "742138",
      "Chhatina Kandi BO": "742138",
      "Kandi Balia BO": "742138",
      "Rasorah BO": "742138",
      "Ekpaharia Sayedpur BO": "742132",
      "Gramshalika BO": "742132",
      "Kantur BO": "742132",
      "Satitara BO": "742132",
      "Masla BO": "742301",
      "Sahapur BO": "742301",
      "Dupukuria BO": "742163",
      "Kadkhali BO": "742163",
      "Kagram BO": "742401",
      "Makhaltore BO": "742401",
      "Prosadpur BO": "742401",
      "Raigram BO": "742401",
      "Miyan BO": "742404",
      "Daharpar BO": "742201",
      "Mohasail BO": "742201",
      "Diara BO": "742122",
      "Ghugridanga BO": "742122",
      "Mianpur BO": "742235",
      "Akheriganj BO": "742135",
      "Fulpur BO": "742135",
      "Habaspur BO": "742135",
      "Khamer Diar BO": "742135",
      "Shyampur Nutanpara BO": "742135",
      "Dalelpara BO": "742113",
      "Bhasai Paikar BO": "742202",
      "Jafraganj BO": "742202",
      "Malancha BO": "742202",
      "Nayansukh BO": "742202",
      "Bewa BO": "742212",
      "Srimantapur BO": "742212",
      "Nutanganj BO": "742227",
      "Ajgarpara BO": "742223",
      "Labanchoa BO": "742223",
      "Kalabagh BO": "742213",
      "Khamra BO": "742213",
      "Mithipur BO": "742213",
      "Rajput Teghari BO": "742213",
      "Sanmatinagar BO": "742213",
      "Sekhalipur BO": "742148",
      "Gurah BO": "742184",
      "Alamsahi BO": "742224",
      "Jagtai BO": "742224",
      "Sagia BO": "742151",
      "Aheripara BO": "742226",
      "Dhanpatganj BO": "742226",
      "Harhari BO": "742226",
      "Suki BO": "742226",
      "Ekghoria Khanqua BO": "742132",
      "Fatepur BO": "742132",
      "Alugram BO": "742301",
      "Sehalai BO": "742301",
      "Sijgram BO": "742301",
      "Ganthla BO": "742136",
      "Gobor Hati BO": "742136",
      "Hazarpur Nabagram BO": "742136",
      "Rajarampur Monoharpur BO": "742140",
      "Ayra BO": "742147",
      "Sadal BO": "742159",
      "Godapara BO": "742161",
      "Godda Sighari BO": "742161",
      "Harishchandrapur BO": "742161",
      "Hastinapur BO": "742161",
      "Kaliganj BO": "742305",
      "Muradpur Arji BO": "742305",
      "Sahebrampur BO": "742305",
      "Sarkarpara BO": "742305",
      "Udaynagar Colony BO": "742305",
      "Kunjaghata BO": "742103",
      "Khoshbagh BO": "742149",
      "Kurmitola BO": "742149",
      "BSahazadpur BO": "742187",
      "Basudebkhali BO": "742187",
      "Jhikarhati BO": "742168",
      "Kharjuna BO": "742168",
      "Kuli Kandi BO": "742168",
      "Kundal BO": "742168",
      "Kunia BO": "742168",
      "Andulia BO": "742138",
      "Senai BO": "742132",
      "Amlai BO": "742301",
      "BSherpur BO": "742301",
      "Binodia BO": "742301",
      "Khoyra BO": "742301",
      "Mahurul Anantapur BO": "742136",
      "Benipur BO": "742140",
      "Choatore BO": "742140",
      "Gangedda BO": "742140",
      "Gunanandabati BO": "742140",
      "Gayespur BO": "742147",
      "Jasohari BO": "742147",
      "Kirtipur BO": "742147",
      "Mahisar BO": "742147",
      "Atai BO": "742159",
      "Polsanda BO": "742159",
      "Ramchandrapur BO": "742159",
      "Sabaldaha BO": "742159",
      "Sahi Sherpur BO": "742159",
      "Sankarpur BO": "742159",
      "Uttar Gopinathpur BO": "742159",
      "Bilaspur BO": "742303",
      "Gangadaspara BO": "742303",
      "Lakshminathpur BO": "742303",
      "Par Raghunathpur BO": "742303",
      "Sadi Khan Diar BO": "742303",
      "Protappur BO": "742166",
      "Rukunpur BO": "742166",
      "Sankarpur Dharampur BO": "742166",
      "Sripur BO": "742166",
      "Harharia Chak BO": "742304",
      "Huda Herampur BO": "742304",
      "Lochanpur BO": "742304",
      "Maricha BO": "742304",
      "Sarangpur BO": "742304",
      "Tezsinghapur BO": "742304",
      "Harekrishnapur BO": "742305",
      "Saidabad BO": "742103",
      "Bhattabati BO": "742149",
      "Jafrabad BO": "742149",
      "Talgachi BO": "742149",
      "Goaljan BO": "742187",
      "Mukundapur BO": "742187",
      "Babultali BO": "742308",
      "Mohanganj BO": "742308",
      "Natial BO": "742308",
      "Beharia BO": "742175",
      "Sonatikuri BO": "742175",
      "Kazipara BO": "742306",
      "Saheb Nagar BO": "742306",
      "Shibnagar BO": "742306",
      "Dakatiapota BO": "742174",
      "Chourigacha BO": "742405",
      "Sabitrinagar BO": "742405",
      "Srikrishnapur BO": "742405",
      "Belgram BO": "742168",
      "Mahishgram BO": "742168",
      "Brahmanpara BO": "742138",
      "Jemo BO": "742138",
      "Mahadia BO": "742138",
      "Jugsara BO": "742132",
      "Kurulia BO": "742132",
      "Mahura Kandi BO": "742132",
      "Masundi BO": "742301",
      "Sayed Kulut BO": "742301",
      "Talgram BO": "742301",
      "Amritakunda BO": "742136",
      "Jibanti BO": "742136",
      "Mahalandi BO": "742136",
      "Jajan BO": "742140",
      "Nutangram BO": "742140",
      "Eroali BO": "742147",
      "Gurulia BO": "742147",
      "Khargram Hospital BO": "742147",
      "Margram BO": "742147",
      "Bhalkundi BO": "742159",
      "Joypur BO": "742159",
      "Kashidanga Mohammadpur BO": "742159",
      "Omarpur BO": "731222",
      "Sidhori BO": "731222",
      "Kanaighat BO": "731222",
      "Bhalanagar BO": "742121",
      "Nowda BO": "742121",
      "Pardiar BO": "742121",
      "Lokenathpur BO": "742189",
      "Nischintapur BO": "742165",
      "Nutanpararaipur BO": "742165",
      "Rajdharpara BO": "742165",
      "Shibnagar Laskarpur BO": "742406",
      "Ghoramara BO": "742133",
      "Hareknagar BO": "742133",
      "Bagore BO": "742136",
      "Khosbaspur BO": "742136",
      "Kumar Shanda BO": "742136",
      "Kolla BO": "742140",
      "Purandarpur BO": "742140",
      "Badua BO": "742147",
      "Haripur BO": "742147",
      "Indrani BO": "742159",
      "Chaitpur BO": "742161",
      "Chandpur BO": "742121",
      "Garibpur BO": "742121",
      "Mohammadpur BO": "742121",
      "Patikabari BO": "742121",
      "Jalalpur BO": "742189",
      "Kashipur Murshidabad  BO": "742189",
      "Rampara BO": "742189",
      "Takipur BO": "742189",
      "Kalitaladiar BO": "742165",
      "Bhagirathpur BO": "742406",
      "Madhurkul BO": "742406",
      "Bishannagar BO": "742133",
      "Debkunda BO": "742133",
      "Kazisaha BO": "742133",
      "Madda BO": "742133",
      "Maniknagar BO": "742133",
      "Bezpara Saluadanga BO": "742134",
      "Chaitanyapur BO": "742134",
      "Jhunka BO": "742134",
      "Mahula BO": "742134",
      "Pulinda BO": "742134",
      "Banjetia BO": "742102",
      "Boaliadanga BO": "742102",
      "Muktinagar BO": "742102",
      "Nowdapanur BO": "742102",
      "Etore BO": "742104",
      "Baligokulpur BO": "742302",
      "Boincuitala BO": "742302",
      "Gudhia BO": "742302",
      "Haribhanga BO": "742302",
      "Kalitala BO": "742133",
      "Kapasdanga BO": "742133",
      "Naupukuria BO": "742133",
      "Bhadur BO": "742134",
      "Khidirpur BO": "742134",
      "Rameswarpur BO": "742134",
      "Sujapur BO": "742134",
      "Bishnupur Kalibari BO": "742102",
      "Gazdharpara BO": "742102",
      "Hatinagar BO": "742102",
      "Nograjole BO": "742102",
      "Bhairabpur BO": "742302",
      "Moktarpur BO": "742302",
      "Pomaipur BO": "742302",
      "Tentulia BO": "742302",
      "Harowa BO": "731221",
      "Bahutali BO": "731222",
      "Bangsabati BO": "731221",
      "Raturi BO": "731221",
      "Jagaipur BO": "742121",
      "Jitpur BO": "742121",
      "Madhupur BO": "742121",
      "Andulberia Colony BO": "742189",
      "Bikalnagar BO": "742189",
      "Dadpur BO": "742189",
      "Majhyampur BO": "742189",
      "Brindabanpur BO": "742406",
      "Juranpur BO": "742406",
      "Kushberia BO": "742406",
      "Kedarchandpur BO": "742133",
      "Chatai BO": "742302",
      "Chhaighari BO": "742302",
      "Dangapara BO": "742302",
      "Gangadhari BO": "742121",
      "Goghata BO": "742121",
      "Raipurmirpur BO": "742121",
      "Andulberia BO": "742189",
      "Joynagar BO": "742189",
      "Kumarpur BO": "742189",
      "Balarampore Colony BO": "742165",
      "Jagannathpur BO": "742165",
      "Aminabad BO": "742406",
      "Juginda BO": "742406",
      "Begunbari BO": "742133",
      "Dalua BO": "742133",
      "Mahishmara BO": "742133",
      "Mirzapur SO MurshidabBO": "742133",
      "Nowpara Simulia BO": "742134",
      "Sundipur BO": "742102",
      "Chotobathan BO": "742104",
      "Kiriteswari BO": "742104",
      "BDurlavpur BO": "742302",
      "Chatra BO": "742302",
      "Kurnnarun BO": "742161",
      "Maliandi BO": "742161",
      "Mandra BO": "742161",
      "Nonadanga BO": "731241",
      "Amtala SO": "742121",
      "Muniadihi BO": "742161",
      "Rajhat BO": "742161",
      "Shibrambati BO": "742161",
      "Sundarpur BO": "742161",
      "Bachra BO": "742163",
      "Jawhari BO": "742161",
      "Mahadebbati BO": "742161",
      "Marut BO": "742161",
      "Tarapur BO": "742161",
      "Sagarpara SO": "742306",
      "Satui SO": "742405",
      "Chaltia SO": "742407",
      "Andi SO": "742168",
      "Kandi Court SO": "742137",
      "Saktipur SO": "742163",
      "Talibpur SO": "742402",
      "Tenya SO": "742404",
      "Shaikhpara SO": "742409",
      "Sargachi Ashram SO": "742408",
      "REJINAGAR SO": "742410",
      "Barwan SO Murshidabad": "742132",
      "Nagar SO Murshidabad": "742159",
      "Panchthupi SO": "742161",
      "Salar SO": "742401",
      "Aurangabad SO Murshidabad": "742201",
      "Azimganj SO": "742122",
      "Farakka Barrage SO": "742212",
      "Gofurpur SO": "742213",
      "Mackenzi Park SO": "742225",
      "Raghunathganj Bazar SO": "742225",
      "Sarbangapur SO": "742174",
      "Bagdanga SO": "742138",
      "Bharatpur SO Murshidabad": "742301",
      "Gokarna SO": "742136",
      "Jemo Rajbati SO": "742140",
      "Kandi Bazar SO": "742137",
      "Barala SO": "742235",
      "Bhagabangola SO": "742135",
      "Debipur SO": "742113",
      "Jangipur SO": "742213",
      "Dhuliyan SO": "742202",
      "Fultala SO": "742225",
      "Jangipur Barrage SO": "742223",
      "Lalgola SO": "742148",
      "Manigram SO": "742237",
      "Nabarun SO": "742236",
      "Ntpc Farakka SO": "742236",
      "Palsandamore SO": "742238",
      "Rajarampur SO": "742151",
      "Sagardighi SO": "742226",
      "Debiparulia BO": "731244",
      "Nayagram BO": "731219",
      "Bali BO": "741156",
      "Shyamnagar Murshidabad BO": "741156",
      "Tungi BO": "741156",
      "Shimulia BO": "713123",
      "Dakshinkhanda BO": "713123",
      "Kandi Bus Stand SO": "742137",
      "Khargram SO": "742147",
      "Chotkalia SO": "742213",
      "Farakka Project SO": "742212",
      "Gankar SO": "742227",
      "Jiaganj SO": "742123",
      "Nabagram SO Murshidabad": "742184",
      "Nimtita SO": "742224",
      "Chunakhali Nimtala SO": "742102",
      "Hariharpara SO": "742166",
      "Madhupur Colony SO": "742101",
      "Nashipur Rajbati SO": "742160",
      "Barua SO": "742189",
      "Beldanga SO": "742133",
      "Berhampore Station Road SO": "742101",
      "Bhabta SO": "742134",
      "Daihatta Road SO": "742103",
      "Khagra SO": "742103",
      "Radharghat SO": "742187",
      "Raninagar SO": "742308",
      "Sabdarnagar SO": "742175",
      "Daulatabad SO Murshidabad": "742302",
      "Dumkal SO": "742303",
      "Indraprastha SO": "742103",
      "Kansari Bazar SO": "742101",
      "Lalbagh SO Murshidabad": "742149",
      "Murshidabad SO": "742149",
      "SSSen Road SO": "742101",
      "Banwaribad Raj SO": "713123",
      "Berhampore WB HO": "742101",
      "Kandi HO": "742137",
      "Raghunathganj HO": "742225",
      "Baruipara SO Murshidabad": "742165",
      "Basantpur SO Murshidabad": "742406",
      "Berhampore Civil Court SO": "742101",
      "Cossimbazar Raj SO": "742102",
      "DLSSJdham SO": "742104",
      "District School Board SO Murshidabad": "742101",
      "Gorabazar SO": "742101",
      "Islampore SO": "742304",
      "Jalangi SO": "742305",
      "Laldighi SO": "742101",
      "Roshanbagh SO": "742164",
      "Hatkalua BO": "713129"
    },
    "PURBA BARDHAMAN": {
      "Genrai BO": "713152",
      "Hedogora BO": "713152",
      "Karotia BO": "713152",
      "Panduk BO": "713152",
      "Amarun BO": "713125",
      "Amarun Bazar BO": "713125",
      "Hargram BO": "713125",
      "Pachim Kharampur BO": "713125",
      "Palar BO": "713125",
      "Poshla BO": "713520",
      "Berenda BO": "713126",
      "Goligram BO": "713126",
      "Khurul BO": "713127",
      "Mandarbati BO": "713127",
      "Chakmuria BO": "713406",
      "Ura BO": "713406",
      "Jaypur BO": "713128",
      "Pichkuri BO": "713128",
      "Suhari BO": "713407",
      "Sukur BO": "713407",
      "Sah Hossainpur BO": "713408",
      "Sanktia BO": "713408",
      "Amar BO": "713141",
      "Belan BO": "713428",
      "Mollasarul BO": "713428",
      "Purangaon BO": "713428",
      "Serorai BO": "713428",
      "Habaspur BO": "713401",
      "Aogram BO": "713121",
      "Debpur BO": "713121",
      "Sanchalida BO": "713121",
      "Goda Annada BO": "713122",
      "Tehatta BO": "713122",
      "Akalpoush BO": "713122",
      "Ausgram BO": "713152",
      "Boro Balaram BO": "713124",
      "Natumohanpur BO": "713124",
      "Bamsore BO": "713520",
      "Dhenria BO": "713520",
      "Fulgram BO": "713125",
      "Shyamnabagram BO": "713125",
      "Kuldiha BO": "713153",
      "Nrisinghapur BO": "713126",
      "Jharul BO": "713403",
      "Kasba BO": "713403",
      "Nurkona BO": "713403",
      "Paraj BO": "713403",
      "Joteram BO": "713104",
      "Rayan BO": "713104",
      "Runkini Mahalla BO": "713404",
      "Sonargaria BO": "713404",
      "Joykrishnapur BO": "713406",
      "Pursa BO": "713406",
      "Pursura BO": "713406",
      "Deasa Aligram BO": "713128",
      "Deoradanga BO": "713128",
      "Hatkirtinagar BO": "713128",
      "Jadabganj BO": "713128",
      "Rairamchandrapur BO": "713128",
      "Sarulia BO": "713128",
      "Uniatatarpur BO": "713128",
      "Balgona BO": "713407",
      "Bonogram BO": "713407",
      "Nabastha BO": "713407",
      "Berugram BO": "713408",
      "Jotsriram BO": "713408",
      "Surekanla BO": "713408",
      "Bamunara BO": "713131",
      "Chanak BO": "713131",
      "Kalanpur BO": "713131",
      "Gohagram BO": "713428",
      "Mohara BO": "713428",
      "Bakta BO": "713428",
      "Masagram BO": "713401",
      "Panchra BO": "713401",
      "Ratanpur BO": "713121",
      "Sahebganj BO": "713121",
      "Anukhal BO": "713122",
      "Singerkone BO": "713122",
      "Chhorahattala BO": "713152",
      "Belna BO": "713124",
      "Deriapur BO": "713124",
      "Basuda BO": "713125",
      "Bhatakul BO": "713520",
      "Chandipur Kanpur BO": "713125",
      "Kalapahari BO": "713520",
      "Sunur BO": "713125",
      "Nasigram BO": "713125",
      "Parisha BO": "713153",
      "Narayanpur BO": "713127",
      "Baikunthapur BO": "713104",
      "Bishnubati BO": "713404",
      "Monoharsujapur BO": "713406",
      "Digha BO": "713128",
      "Gonpur BO": "713128",
      "Orgram BO": "713128",
      "Shibda BO": "713128",
      "Somaipur BO": "713128",
      "Begut BO": "713407",
      "Kuchut BO": "713407",
      "Sodda BO": "713407",
      "Anguna BO": "713408",
      "Paratal BO": "713408",
      "Sadipur BO": "713408",
      "Gatistha BO": "713131",
      "Palita BO": "713132",
      "Irkona BO": "713428",
      "Masidpur BO": "713428",
      "Kenna BO": "713401",
      "Sanchra BO": "713401",
      "Muratipur BO": "713121",
      "Badla BO": "713122",
      "Bhuera BO": "713152",
      "Uttarramnagar BO": "713152",
      "Kalanabagram BO": "713124",
      "Balgona Tulshidanga BO": "713520",
      "Hossainpur BO": "713125",
      "Kherur BO": "713125",
      "Barabelun BO": "713125",
      "Kurumba BO": "713126",
      "Saha Basantapur BO": "713126",
      "Gramdighi BO": "713127",
      "Mohanpur BO": "713127",
      "Dwarnari BO": "713403",
      "Ramgopalpur BO": "713403",
      "Moukhira BO": "731214",
      "Fagupur BO": "713104",
      "Jaragram BO": "713404",
      "Bahirghanna BO": "713406",
      "Goligrammathurapur BO": "713406",
      "Uchhagram BO": "713406",
      "Bhuri B.O": "713406",
      "Dignagar BO": "713128",
      "Genna Deriapur BO": "713128",
      "Keleti BO": "713128",
      "Mahata BO": "713128",
      "Paligram BO": "713128",
      "Shar BO": "713128",
      "Kashiara BO": "713407",
      "Sonapalashi BO": "713407",
      "Bahadurpur BO": "713408",
      "Kamargoria BO": "713408",
      "Parbatpur BO": "713408",
      "Lakhuria BO": "713131",
      "Bahabpur BO": "713146",
      "Ghosh BO": "713146",
      "Hatsridharpur BO": "713146",
      "Paharhati BO": "713146",
      "Keotara BO": "713166",
      "Reora Gopalpur BO": "713166",
      "Chandrahati BO": "713102",
      "Chotobelun BO": "713102",
      "Kaligram BO": "713102",
      "Korar BO": "713102",
      "Kshetia BO": "713102",
      "Nishchintapur BO": "713142",
      "Rupsa BO": "713142",
      "Bhandardihi BO": "713426",
      "Samanti BO": "713426",
      "Barapalashan BO": "713426",
      "Eral BO": "713144",
      "Pratappur BO": "713144",
      "Bhojpur BO": "713145",
      "Kasa BO": "713145",
      "Maldanga BO": "713145",
      "Bagila BO": "713146",
      "Rajganj Asthal BO": "713102",
      "Aduria BO": "713148",
      "Debsala BO": "713148",
      "Rondia BO": "713420",
      "Saknara BO": "713421",
      "Maheshdanga BO": "713151",
      "Bhaita BO": "713149",
      "Dewania BO": "713422",
      "Ibrahambadsonadanga BO": "713422",
      "Mangalpur BO": "713422",
      "Raigram BO": "713422",
      "Bohar BO": "713422",
      "Amila BO": "713423",
      "Bujrukhdighi BO": "713423",
      "Chagram BO": "713423",
      "Keshabpur BO": "713423",
      "Chandipur Berugram BO": "713142",
      "Gopalbera BO": "713427",
      "Kamarkita BO": "713426",
      "Kasthakurumba BO": "713426",
      "Malamba BO": "713426",
      "Ramchandrapur BO": "713426",
      "Baidyapur Shibtala BO": "712410",
      "Abhirampur BO": "713144",
      "Samantapara BO": "713144",
      "Bhalki BO": "713144",
      "Lohar BO": "713145",
      "Putsuri BO": "713145",
      "Singhali BO": "713145",
      "Tarasusunia BO": "713145",
      "Chandrapur BO": "713145",
      "Ukhrid BO": "713142",
      "Suata BO": "713144",
      "Amrargarh BO": "713144",
      "Denur BO": "713145",
      "Kaigram BO": "713145",
      "Kalui BO": "713145",
      "Daminya Kabikankan BO": "712413",
      "Oari BO": "713142",
      "Sasanga BO": "713142",
      "Faridpur BO": "713426",
      "Susunia BO": "713426",
      "Untia BO": "713426",
      "Khandaridanga BO": "713144",
      "Kolkol BO": "713144",
      "Maro BO": "713144",
      "Muidipur BO": "712410",
      "Amarpur BO": "712410",
      "Gotan BO": "712410",
      "Asanpur BO": "713145",
      "Golatun BO": "713145",
      "Belkas BO": "713102",
      "Bhita BO": "713102",
      "Kanchannagar BO": "713102",
      "Mahachanda BO": "713102",
      "Mirjapur BO": "713102",
      "Bharatpur BO": "713148",
      "Barabainan BO": "713421",
      "Jamna BO": "713422",
      "Jhikra BO": "713422",
      "Kulut BO": "713422",
      "Kusumgram BO": "713422",
      "Madhyagram BO": "713422",
      "Mamudpur BO": "713422",
      "Piplon BO": "713422",
      "Purguna BO": "713422",
      "Chotobainan BO": "713423",
      "Guir BO": "713423",
      "Kaiti BO": "713423",
      "Konakrishnapur BO": "713423",
      "Burar BO": "713424",
      "Golgram BO": "713424",
      "Bara Mahesh BO": "713146",
      "Gontar BO": "713146",
      "Jabui BO": "713146",
      "Jaugram BO": "713166",
      "Kulingram BO": "713166",
      "Jamar BO": "713102",
      "Karjanachati BO": "713102",
      "Kubajpur BO": "713102",
      "Lakurdi BO": "713102",
      "Chotoramchandrapur BO": "713148",
      "Sonai BO": "713148",
      "Chanchai BO": "713151",
      "Khagrakaranda BO": "713149",
      "Bitra BO": "713422",
      "Kanpur BO": "713422",
      "Khandraparulia BO": "713422",
      "Sontla BO": "713422",
      "Khalishpur BO": "713422",
      "Bowai BO": "713423",
      "Keunta BO": "713423",
      "Torkona BO": "713423",
      "Madabdihi BO": "713424",
      "Meral BO": "713424",
      "Palashan BO": "713424",
      "Sagrai BO": "713424",
      "Shyamdasbati BO": "713424",
      "Huria BO": "713424",
      "Bajekumarpur BO": "713427",
      "Pahalanpur BO": "713427",
      "Agardanga BO": "713123",
      "Murgram BO": "713123",
      "Ankra BO": "713502",
      "Kalikapur BO": "713502",
      "Karajgram BO": "713502",
      "Painta BO": "713427",
      "Kachutia BO": "713123",
      "Keuguri BO": "713123",
      "Mougram BO": "713123",
      "Pachundi BO": "713123",
      "Sankai BO": "713123",
      "Bera BO": "713502",
      "Chanduli BO": "713502",
      "Deasin BO": "713502",
      "Panuhat BO": "713502",
      "Krishnadebpur BO": "713405",
      "Simlon BO": "713405",
      "Medgachi BO": "713405",
      "Sahajpur BO": "713405",
      "Nibhujibazar BO": "713405",
      "Koyar BO": "713423",
      "Saranga BO": "713423",
      "Jubila BO": "713424",
      "Madanagar BO": "713424",
      "Machkanda BO": "713103",
      "Telua BO": "713424",
      "Kamalpur BO": "713103",
      "Saloon BO": "713103",
      "Eklakhi BO": "713427",
      "Kendur BO": "713427",
      "Sherpur BO": "713427",
      "Baharan BO": "713123",
      "Gangatikuri BO": "713123",
      "Sitahati BO": "713123",
      "Agradwip RS BO": "713502",
      "Islampur BO": "713502",
      "Musthuli BO": "713502",
      "Nandai BO": "713405",
      "Hatbele BO": "713409",
      "Baramitrapara BO": "713409",
      "Amgoria BO": "713129",
      "Satinandi BO": "713141",
      "Shyamsundarpur BO": "713141",
      "Takipur BO": "713141",
      "Astogoria BO": "713405",
      "Bagnapara BO": "713409",
      "Purba Satgachia BO": "712512",
      "Gram Kulti BO": "712146",
      "Gramchagram BO": "712146",
      "Barakashiara BO": "713141",
      "Belgram BO": "713141",
      "Bhaghar BO": "713141",
      "Sanko BO": "713141",
      "Talit BO": "713141",
      "Belar Bhurkunda BO": "713427",
      "Baharkuli BO": "712146",
      "Pindira BO": "712146",
      "Biruha BO": "713146",
      "Baror BO": "713146",
      "Chotkhanda BO": "713146",
      "Debipur RS BO": "713146",
      "Debipur BO": "713146",
      "Kalibele BO": "713146",
      "Nimo BO": "713146",
      "Radhakantapur BO": "713146",
      "Sasinara BO": "713146",
      "Sultanpur BO": "713146",
      "Abujhati BO": "713166",
      "Dhuluk BO": "713166",
      "Ilsara BO": "713166",
      "Kurmun BO": "713102",
      "Kota BO": "713148",
      "Kamarhati BO": "713421",
      "Pasanda BO": "713421",
      "Tajpur BO": "713421",
      "Palla BO": "713151",
      "Palla RS BO": "713151",
      "Begpur BO": "713422",
      "Bhagra BO": "713422",
      "Bijur BO": "713422",
      "Karanda BO": "713422",
      "Katshihi BO": "713422",
      "Kuley BO": "713422",
      "Narugram BO": "713424",
      "Nole BO": "713424",
      "Rambati BO": "713424",
      "Sahajpur Hattala BO": "713424",
      "Sankari BO": "713424",
      "Teandul BO": "713424",
      "Bolpur BO": "713103",
      "Bontir BO": "713103",
      "Hijalna BO": "713103",
      "Belari BO": "713141",
      "Bhota BO": "713141",
      "Simdal BO": "713141",
      "Bhada BO": "713141",
      "Arjuna BO": "712146",
      "Katwa HO": "713130",
      "Bara Balgona BO": "713141",
      "Chandul BO": "713141",
      "Khano BO": "713141",
      "Pachkula BO": "713141",
      "Mohisgoria BO": "712402",
      "Siptai BO": "712308",
      "Agriculture Farm SO": "713101",
      "Ajhapur SO": "713401",
      "Aruar SO": "713121",
      "Bhatkunda SO": "713153",
      "Burdwan District School Board SO": "713101",
      "Burdwan Medical College SO": "713104",
      "Burdwan University SO": "713104",
      "Chakdighi SO": "713404",
      "Chotonilpur SO": "713103",
      "Golapbag SO": "713104",
      "Hatgobindapur SO": "713407",
      "Ichlabad SO": "713103",
      "Kasemnagar SO": "713131",
      "Khandaghosh SO": "713142",
      "Kotalhat SO": "713102",
      "Memari Bazar SO": "713146",
      "Nutanpalli SO": "713101",
      "Panagar Bazara SO": "713148",
      "Saktigarh SO Bardhaman": "713149",
      "Sankharipukur SO": "713103",
      "Shyamsundar SO": "713424",
      "Bahirsarbamangala SO": "713101",
      "Baidyapur SO": "713122",
      "Budbud SO": "713403",
      "Burdwan Rajbati SO": "713104",
      "Gushkara New Town SO": "713128",
      "Harisava SO": "713104",
      "Jamalpur SO Bardhaman": "713408",
      "Kamalakanta Kalibari SO": "713102",
      "Nabagram SO Bardhaman": "713166",
      "Panagar SO Bardhaman": "713420",
      "Rasulpur SO": "713151",
      "Sarbamangala Bari SO": "713101",
      "Sadhanpur SO": "713101",
      "Nityanandapur SO": "713520",
      "Burdwan HO": "713101",
      "Balindar BO": "712134",
      "Amadpur SO": "713154",
      "Bajepratappur NDDF SO": "713101",
      "Bamunpara SO": "713146",
      "Bhedia SO": "713126",
      "Burdwan Bar Library SO": "713101",
      "Khana Jn SO": "713141",
      "Mandalgram SO": "713426",
      "Mankar SO": "713144",
      "Satgachia SO": "713422",
      "Sadarghat SO": "713103",
      "Bannabagram SO": "713152",
      "Barsul Unnayani SO": "713124",
      "Bhatar SO": "713125",
      "Bonpas SO": "713127",
      "Burdwan Rs SO": "713101",
      "Galsi SO": "713406",
      "Ghordourchati SO": "713103",
      "Gushkara SO": "713128",
      "Monteswar SO": "713145",
      "Memari SO": "713146",
      "Nutanganj SO": "713102",
      "Raina SO": "713421",
      "Ranisayar SO": "713101",
      "Sehara SO": "713423",
      "Sripalli SO": "713103",
      "Uchalan SO": "713427",
      "Atuhatpara SO": "713130",
      "Masundi BO": "713129",
      "Sadipur Berugram BO": "713129",
      "Barapurulia BO": "713140",
      "Nabagram BO": "713140",
      "Bhalgram BO": "713132",
      "Chakulia BO": "713132",
      "Jabagram BO": "713143",
      "Khirgram BO": "713143",
      "Mathrun BO": "713132",
      "Pindira Boura BO": "713132",
      "Puini BO": "713143",
      "Purbakhanpur Bamunpara BO": "713145",
      "Jhilu BO": "713147",
      "Purbo Noaapara BO": "713147",
      "Belerhat BO": "713512",
      "Patuli Station Bazar BO": "713512",
      "Chupi BO": "713513",
      "Jahannagar BO": "713513",
      "Mukshinpara BO": "713513",
      "Raipur BO": "713519",
      "Gourdanga BO": "713514",
      "Berampur BO": "713150",
      "Bileswar BO": "713150",
      "Mustafapur BO": "713150",
      "Ankhona BO": "713129",
      "Bamundi BO": "713129",
      "Chakta BO": "713129",
      "Ehiapur BO": "713129",
      "Deara Radhanagar BO": "713409",
      "Gurpara BO": "713140",
      "Barashyambazar BO": "713132",
      "Bazar Bankapashi BO": "713143",
      "Jamra BO": "713143",
      "Jogeswardihi BO": "713143",
      "Karui BO": "713143",
      "Kaithan BO": "713143",
      "Kulai BO": "713132",
      "Nigun BO": "713143",
      "Shimulia Danga BO": "713143",
      "Dirghapara BO": "713515",
      "Nowapara BO": "713515",
      "Akabpur BO": "713515",
      "Lakshmipur BO": "713512",
      "Mertala BO": "713513",
      "Minapur BO": "713513",
      "Moail BO": "713513",
      "Parulia BO": "713513",
      "Raidogachia BO": "713513",
      "Sutra BO": "713513",
      "Khatundi BO": "713129",
      "Kowarpur BO": "713132",
      "Kutirpara BO": "713519",
      "Multikrishnanagar BO": "713514",
      "Sribati BO": "713514",
      "Alampur BO": "713150",
      "Khajurdihi BO": "713150",
      "Kosigram BO": "713150",
      "Ketugram SO": "713140",
      "Samudragarh SO": "713519",
      "Singhi SO": "713514",
      "Bhaduripara SO": "713409",
      "Dhatrigram SO": "713405",
      "Kalna Court SO": "713409",
      "Kalna SO": "713409",
      "Katwa Station Bazar SO": "713130",
      "Koychor SO": "713143",
      "Nadanghat SO": "713515",
      "Purbasthali SO": "713513",
      "Srikhanda SO": "713150",
      "Majigram SO": "713132",
      "Katwa Bazar SO": "713130",
      "Katwa College SO": "713130",
      "Nutanhat SO": "713147",
      "Kantadihi BO": "713129",
      "Khanji BO": "713129",
      "Rajoor BO": "713129",
      "Srigopalpur BO": "713129",
      "Srigram BO": "713129",
      "Roundi Srirampur BO": "713140",
      "Shibloon BO": "713140",
      "Gidhgram BO": "713143",
      "Gobordhanpur BO": "713143",
      "Palsona BO": "713143",
      "Panjua BO": "713143",
      "Saragram BO": "713143",
      "Thangapara BO": "713143",
      "Khurtuba BO": "713147",
      "Kunda BO": "713147",
      "Mongalkote BO": "713147",
      "Palishgram BO": "713147",
      "Agradwip BO": "713512",
      "Chatni BO": "713512",
      "Hapania BO": "713512",
      "Biswaramba BO": "713513",
      "Chakbamongaria BO": "713513",
      "Haldinawapara BO": "713513",
      "Amul BO": "713514",
      "Sudpur BO": "713150",
      "Dainhat SO": "713502",
      "Kandara SO": "713129",
      "Narayanapur SO Bardhaman": "713512",
      "Patuli SO": "713512",
      "Komarpur BO": "713129",
      "Nirol BO": "713140",
      "Auria BO": "713143",
      "Boinchee BO": "713132",
      "Kuara BO": "713143",
      "Purba Gopalpur BO": "713143",
      "Athghara BO": "713147",
      "Jhaudanga BO": "713512",
      "Majida BO": "713512",
      "Tamaghata BO": "713512",
      "Ukhra Sarangpur BO": "713512",
      "Kasthashali BO": "713513",
      "Chakshanjadi BO": "713124",
      "Dupsa BO": "713519",
      "Nasaratpur BO": "713519",
      "Kurchi BO": "713514",
      "Okarsa BO": "713514",
      "Bandhmura BO": "713150",
      "Churpuni BO": "713150",
      "Srirampur SO Nadia": "741316",
      "Bidyanagar SO": "741319",
      "Adrahati SO": "713428"
    },
    "BANKURA": {
      "Gholkunda BO": "722152",
      "Ladda Brahmandiha BO": "722152",
      "Mandarboni BO": "722152",
      "Punisole BO": "722152",
      "Natungram BO": "722152",
      "Bamuntore BO": "722153",
      "Pachhandapur BO": "722153",
      "Dheko BO": "721504",
      "Harinarayanpur Dharampur BO": "721504",
      "Muramouli BO": "721504",
      "Parardanga BO": "722152",
      "Digpar BO": "722122",
      "Gokulnagar BO": "722122",
      "Joykrinhspur BO": "722122",
      "Ajodhya BO": "722122",
      "Latbeliara BO": "722157",
      "Karrah BO": "722132",
      "Papurdihi BO": "722132",
      "Barikul BO": "722162",
      "Fulsusunia BO": "722162",
      "Barkona BO": "722133",
      "Durlavpur BO": "722133",
      "Ukhradihi BO": "722133",
      "Mandalkuli BO": "722134",
      "Nutangarh BO": "722134",
      "Tapta Damdi BO": "722134",
      "Ambikanagar BO": "722135",
      "Dabri BO": "722135",
      "Rol BO": "722205",
      "Biur BO": "722205",
      "Chandga Palashi BO": "722205",
      "Bagdiha BO": "722136",
      "Chakaltore BO": "722136",
      "Gossainpur BO": "722122",
      "Garhdubrajpur BO": "722132",
      "Gouripur BO": "722132",
      "Jalahari BO": "722132",
      "Mankanali BO": "722132",
      "Susunia BO": "722132",
      "Westsanabandh BO": "722132",
      "Moulasole BO": "722162",
      "Amarkanan BO": "722133",
      "Akhuapal BO": "722134",
      "Amchura BO": "722134",
      "Basudebpur BO": "722134",
      "Kharigeria BO": "722134",
      "Satpatta BO": "722134",
      "Shyamsundarpur BO": "722134",
      "Jote Joyrampur Mirjapur BO": "722154",
      "Karakberia Sadhuadal BO": "722154",
      "Puddi BO": "722135",
      "Routara BO": "722135",
      "Rudra BO": "722135",
      "Barachingra BO": "722136",
      "Bhalukgenjar BO": "722136",
      "Bhatra BO": "722136",
      "Boga BO": "722136",
      "Cheliama Sunukpahari BO": "722136",
      "Hatagram BO": "722136",
      "Keliapathar BO": "722136",
      "Keshbandi BO": "722136",
      "Nabadeulvera BO": "722136",
      "Molian BO": "722136",
      "Guniada BO": "722136",
      "Jhariakocha BO": "722136",
      "Saluipahari BO": "722136",
      "Chourabaid BO": "722136",
      "Gholgoria BO": "722136",
      "Kantapahari BO": "722136",
      "Louda BO": "722136",
      "Nischintapur BO": "722136",
      "Kantabari BO": "722122",
      "Muninagar BO": "722122",
      "Rahagram BO": "722122",
      "Raibaghini BO": "722122",
      "Salda BO": "722122",
      "Bhara BO": "722157",
      "Chumosina BO": "722157",
      "Ichharia BO": "722157",
      "Lokhesole BO": "722157",
      "Chandra BO": "722132",
      "Kesiara BO": "722133",
      "Kukhrajhore BO": "722133",
      "Kultuka BO": "722133",
      "Kusthalia BO": "722133",
      "Salroha BO": "722133",
      "Gobindadham BO": "722133",
      "Ranipur BO": "722133",
      "Pali BO": "722134",
      "Parkura Anara BO": "722134",
      "Bansichandipur BO": "722154",
      "Basubati BO": "722154",
      "Bhagaldighi BO": "722154",
      "Gunpura BO": "722135",
      "Hijlitilabani BO": "722135",
      "Jhilimili BO": "722135",
      "Kamo BO": "722135",
      "Behar BO": "722205",
      "Charigram BO": "722205",
      "Sashpur BO": "722205",
      "Karisunda BO": "722205",
      "Kusmuri BO": "722205",
      "Purusottampur BO": "722136",
      "Layekpara BO": "722151",
      "Amritpara BO": "722207",
      "Birsinghpur BO": "722207",
      "Nabasan BO": "722207",
      "Nutanbalarampur BO": "722207",
      "Saralia BO": "722152",
      "Harmasra BO": "722152",
      "Gopalpur BO": "722136",
      "Palashboni BO": "722152",
      "Biborda BO": "722152",
      "Khalagram BO": "722152",
      "Ratanpur  BO": "722152",
      "Khichka BO": "722151",
      "Hamirhati BO": "722207",
      "Kundapuskarani BO": "722207",
      "Rapatganj BO": "722207",
      "Dipara BO": "722207",
      "Chingani BO": "722152",
      "Khulyamuri BO": "722152",
      "Pratappur BO": "722152",
      "Paharpur BO": "722205",
      "Lurka BO": "721504",
      "Chakdaha BO": "722122",
      "Dwarika BO": "722122",
      "Gopalnagar BO": "722122",
      "Janta BO": "722122",
      "Uliara BO": "722122",
      "Layekbandh BO": "722157",
      "Panchal BO": "722157",
      "Dudhya BO": "722162",
      "Melera BO": "722162",
      "Bisinda BO": "722133",
      "Kapista BO": "722133",
      "Lachhmanpur BO": "722133",
      "Banasuria BO": "722133",
      "Motgoda BO": "722134",
      "Siromonipur BO": "722134",
      "Arkama BO": "722140",
      "Asurali BO": "722154",
      "Bethuala BO": "722135",
      "Dhagara BO": "722135",
      "Muchikata BO": "722135",
      "Nabachiada BO": "722135",
      "Rajkhamar BO": "722205",
      "Kharrah BO": "722205",
      "Mangalpur BO": "722205",
      "Rasulpur BO": "722205",
      "Dubarajpur BO": "722136",
      "Puara BO": "722136",
      "Sunrichitra BO": "722136",
      "Bijpur BO": "713142",
      "Jirabaid BO": "722151",
      "Kadma BO": "722151",
      "Mukundapur BO": "722151",
      "Nemaipur BO": "722151",
      "Pathardoba BO": "722151",
      "Puipal BO": "722151",
      "Kushadwip BO": "722207",
      "Machdoba BO": "722207",
      "Majirdanga BO": "722207",
      "Radhamohanpur BO": "722207",
      "Ranpur BO": "722207",
      "Hadal Narayanpur BO": "722207",
      "Chakshyampur BO": "722152",
      "Chhagulia BO": "722152",
      "Supur BO": "722121",
      "Machatora BO": "722151",
      "Putiadaha BO": "722151",
      "Gopikantapur BO": "722207",
      "Kochdihi BO": "722207",
      "Manikbazar BO": "722207",
      "Bonbirsingha BO": "722207",
      "Dhansimla BO": "722207",
      "Fulmati BO": "722152",
      "Nachna BO": "722152",
      "Baidyanathpur BO": "722140",
      "Somsar BO": "713142",
      "Baliara B.O": "722144",
      "Hirapur BO": "722152",
      "Hamirpur BO": "722206",
      "Majurdanga BO": "722206",
      "Patit BO": "722206",
      "Jagadalla BO": "722146",
      "Birkham BO": "722148",
      "Murakati Saltora BO": "722149",
      "Peardoba BO": "722149",
      "Gossindihi BO": "722158",
      "Murlu BO": "722158",
      "Gangnala BO": "722150",
      "Jamboni BO": "722150",
      "Baricha BO": "722151",
      "Hatkrishnanagar BO": "722206",
      "Jamkuri BO": "722206",
      "Kabirchak BO": "722206",
      "Kakatia BO": "722206",
      "Parulia BO": "722206",
      "Bhagabandh BO": "722146",
      "Bhikurdihi BO": "722146",
      "Kumidya BO": "722146",
      "Ghagra Haludkanali BO": "722148",
      "Kadmagarh BO": "722148",
      "Mitha Am BO": "722148",
      "Puranpani BO": "722148",
      "Douni BO": "722149",
      "Mamra BO": "722149",
      "Motukbani BO": "722158",
      "Baragarrah BO": "722150",
      "Chingra BO": "722150",
      "Choutar BO": "722150",
      "Penchara Deuli BO": "722150",
      "Sukhadali BO": "722150",
      "Hetyagora BO": "722151",
      "Jiabandi BO": "722164",
      "Morar BO": "722164",
      "Ghutgoria BO": "722202",
      "Barbendya BO": "722203",
      "Chhandar BO": "722203",
      "Dhabani BO": "722203",
      "Ramharipur BO": "722203",
      "Salbedia BO": "722203",
      "Dighi BO": "722121",
      "Gossainjanara BO": "722121",
      "Gourbazar BO": "722121",
      "Kayabaid BO": "722121",
      "Nayada BO": "722121",
      "Rampur BO": "722121",
      "Silpajambedia BO": "722121",
      "Amral BO": "722122",
      "Basantimela BO": "722122",
      "Beliadangarpara BO": "722122",
      "Khorsee BO": "722201",
      "Ratra BO": "722201",
      "Barkura BO": "722203",
      "Jagannathpur BO": "722203",
      "Bansidih BO": "722121",
      "Bauridihi BO": "722121",
      "Gunnath BO": "722121",
      "Hatirampur BO": "722121",
      "Masanjhar BO": "722121",
      "Mosiara BO": "722121",
      "Salna BO": "722206",
      "Patpur BO": "722147",
      "Sindri Am BO": "722148",
      "Tungcharar BO": "722148",
      "Moukura BO": "722150",
      "Penchakola BO": "722150",
      "Dighalgram BO": "722201",
      "Gangarampur Bamnia BO": "722201",
      "Shitla BO": "722202",
      "Unara Jambedia BO": "722202",
      "Dadhimukha BO": "722203",
      "Godardihi BO": "722203",
      "Pirraboni BO": "722203",
      "Araldihi BO": "722121",
      "Bankata BO": "722121",
      "Hirbandh BO": "722121",
      "Kenety BO": "722206",
      "Pandua BO": "722206",
      "Andharthole BO": "722146",
      "Kalpathar BO": "722146",
      "Helna Susunia BO": "722146",
      "Akkhuta BO": "722148",
      "Deuli BO": "722148",
      "Methana BO": "722149",
      "Satmouli BO": "722149",
      "Bishjore BO": "722158",
      "Kanuri BO": "722158",
      "Shyampur BO": "722158",
      "Dumurtore BO": "722150",
      "Garhgaria BO": "722150",
      "Bondubrajpur BO": "722151",
      "Bhedua BO": "722151",
      "Bikrampur BO": "722151",
      "Mandra BO": "722201",
      "Trisalan BO": "722201",
      "Muktatore BO": "722202",
      "Bhattapara BO": "722203",
      "Brindabanpur BO": "722203",
      "Bhalukbasa BO": "722121",
      "Brajarajpur BO": "722121",
      "Jiorda BO": "722121",
      "Bhojda BO": "722121",
      "Simlabandh BO": "722121",
      "Anur BO": "722161",
      "Gopinathpur BO": "722161",
      "Sihar BO": "722161",
      "Gogra BO": "722137",
      "Jamtora BO": "722137",
      "Jorehira BO": "722137",
      "Kharbona BO": "722137",
      "Mantumra BO": "722137",
      "Ahanda BO": "722173",
      "Brahmandiha BO": "722173",
      "Fulkusma Khattagram BO": "722173",
      "Sonardanga BO": "722173",
      "Belsulia BO": "722138",
      "Dhara BO": "722138",
      "Hetia BO": "722138",
      "Hijaldiha BO": "722138",
      "Moynapur BO": "722138",
      "Darsole BO": "722140",
      "Dhadanga BO": "722140",
      "Dundar BO": "722140",
      "Gobarda BO": "722140",
      "Shyambazar BO": "722140",
      "Paksara BO": "722140",
      "Amdahi BO": "722141",
      "Aswinkota BO": "722141",
      "Bhagalpur BO": "722141",
      "Manohar BO": "722142",
      "Metali BO": "722142",
      "Nityanandapur BO": "722142",
      "Arabani BO": "722144",
      "Garh Kotalpur BO": "722144",
      "Gorasole BO": "722144",
      "Kostia BO": "722144",
      "Mankhamar BO": "722144",
      "Alijhara BO": "722137",
      "Besora BO": "722137",
      "Chamtagora BO": "722137",
      "Sihika BO": "722137",
      "Natherdanga BO": "722173",
      "Ayma BO": "722138",
      "Kuchiakole BO": "722138",
      "Routhkhanda BO": "722138",
      "Anchuri Salboni BO": "722102",
      "Saldiha Pithabaid BO": "722139",
      "Biharjuria BO": "722155",
      "Junbedia BO": "722155",
      "Sirsara BO": "722155",
      "Purandapur BO": "722155",
      "Narrah BO": "722155",
      "MAYAKANAN": "722155",
      "Chaka BO": "722140",
      "Haludkanali BO": "722140",
      "Jamda BO": "722140",
      "Kankradara BO": "722140",
      "Kharidungri BO": "722140",
      "Muragram BO": "722140",
      "Tiring BO": "722140",
      "Dashere BO": "722141",
      "Deshra BO": "722141",
      "Sehas BO": "722141",
      "Parsola BO": "722160",
      "Krishnanagar BO": "722202",
      "Bakulia BO": "722143",
      "Benabaid BO": "722143",
      "Pairasole BO": "722143",
      "Sadhana Rangamati BO": "722143",
      "Sripatpurnia BO": "722143",
      "Makorkole BO": "722144",
      "Murakata BO": "722144",
      "Nakaijuri BO": "722144",
      "Pearberia BO": "722208",
      "Tajpur Purakona BO": "722208",
      "Mandalgram BO": "722156",
      "Amrul BO": "722206",
      "Betur BO": "722206",
      "Ranga BO": "722136",
      "Tajpurgram BO": "722161",
      "Budhanpur BO": "722137",
      "Dhaban BO": "722137",
      "Kamalpur BO": "722137",
      "Danga Barabendya BO": "722173",
      "Saldiha BO": "722173",
      "Baital BO": "722138",
      "Jujur BO": "722138",
      "Shyamnagar BO": "722138",
      "Bonkati BO": "722102",
      "Satyayatan BO": "722139",
      "Sanbandha BO": "722155",
      "Bhuakana BO": "722140",
      "Hetiasole BO": "722140",
      "Kashipur BO": "722140",
      "Sonagara BO": "722140",
      "Kesia BO": "722140",
      "Balitha BO": "722141",
      "Darapur BO": "722141",
      "Karakberia BO": "722141",
      "Samantakhanda BO": "722141",
      "Pukhuria BO": "722160",
      "Chousal BO": "722142",
      "Ardhagram BO": "722143",
      "Bharakalibari BO": "722143",
      "Salma BO": "722143",
      "Thakurbari Ramchandrapur BO": "722143",
      "Agarda BO": "722144",
      "Damodarbati BO": "722144",
      "Jamjuri BO": "722144",
      "Majdiha BO": "722144",
      "Medinipurgram BO": "722144",
      "Nabajibanpur BO": "722144",
      "Bhutsahar BO": "722156",
      "Akhrasole BO": "722206",
      "Ghoradanga BO": "722206",
      "Arrah BO": "722137",
      "Magura BO": "722138",
      "Baidyalokhesole BO": "722139",
      "Bhalaidiha BO": "722139",
      "Jambedia BO": "722139",
      "Mandalkesra BO": "722139",
      "Chhatarkanali BO": "722155",
      "Kanchanpur BO": "722155",
      "Sendra BO": "722155",
      "Bhadul BO": "722155",
      "Harialgara BO": "722155",
      "Nagri BO": "722140",
      "Pairaguri BO": "722140",
      "Raidihi BO": "722140",
      "Dehuapara BO": "722141",
      "Kankatabati BO": "722141",
      "Lego BO": "722141",
      "Laugram BO": "722141",
      "Madhanmohanpur BO": "722141",
      "Panua BO": "722141",
      "Bon Sarenga BO": "722160",
      "Dahala BO": "722160",
      "Doldere BO": "722160",
      "Moidhara BO": "722160",
      "Tilabani BO": "722160",
      "Banjora BO": "722142",
      "Brindabanpur Barsal BO": "722142",
      "Dangmejhia BO": "722143",
      "Japamali BO": "722143",
      "Kansara BO": "722143",
      "Pabra BO": "722143",
      "Nikunjapur BO": "722144",
      "Ranikhamar BO": "722144",
      "Teleberia BO": "722144",
      "Lodna BO": "722144",
      "Palashdanga BO": "722208",
      "Radhakantapur BO": "722208",
      "Balsi BO": "722206",
      "Bamira BO": "722206",
      "Bankisole BO": "722206",
      "Belut BO": "722206",
      "Bankura HO": "722101",
      "Mejhia SO": "722143",
      "Ranibandh SO": "722148",
      "Sarenga SO": "722150",
      "Tiluri SO": "722153",
      "Mejia Th Power Station SO": "722183",
      "Nutanchati SO": "722101",
      "Pakhanna SO": "722208",
      "Pilgrim Road SO": "722101",
      "Rajagram SO": "722146",
      "Ramsagar SO": "722147",
      "Saltora SO": "722158",
      "Sonamukhi SO Bankura": "722207",
      "Bankadaha SO": "722164",
      "Bheduasole SO": "722121",
      "Feder Road SO": "722101",
      "Hatasuria SO": "722204",
      "Jhantipahari SO": "722137",
      "Joypur SO": "722138",
      "Kenduadihi SO": "722102",
      "Lakshmisagar SO": "722160",
      "Akui SO": "722201",
      "Beliatore SO": "722203",
      "Bonradhanagar SO": "722157",
      "Fulkusma SO": "722162",
      "Gorabari SO": "722135",
      "Indpur SO": "722136",
      "Kesiakole SO": "722155",
      "Lokepur SO": "722102",
      "Maliara SO": "722142",
      "Onda SO": "722144",
      "Panchmura SO": "722156",
      "Patrasayer SO": "722206",
      "Rasikganj SO": "722122",
      "Sabrakone SO": "722149",
      "Simlapal SO": "722151",
      "Sonamukhi Rath Tala SO": "722207",
      "Taldangra SO": "722152",
      "Bankura  DSB SO": "722101",
      "Bishnupur SO Bankura": "722122",
      "Garhraipur SO": "722134",
      "Gelia SO": "722154",
      "Jayrambati SO": "722161",
      "Jorda SO": "722173",
      "Kenjakura SO": "722139",
      "Khatra SO": "722140",
      "Kotalpur SO": "722141",
      "Lalbazar SO Bankura": "722101",
      "Barjora SO": "722202",
      "Bishnupur Stn Rd SO": "722122",
      "Chhatna SO": "722132",
      "Gangajalghati SO": "722133",
      "Indas SO": "722205",
      "Lalbandh SO": "722122"
    },
    "BIRBHUM": {
      "Pachhiara BO": "731124",
      "Sirsha BO": "731124",
      "Paikuni BO": "731214",
      "Madhaipur BO": "731126",
      "Paruliahazrapur BO": "731126",
      "Patadanga BO": "731126",
      "Rajganj BO": "731126",
      "Jahidpur BO": "731125",
      "Kankartala BO": "731125",
      "Kendragoria BO": "731125",
      "Nabasan BO": "731125",
      "Nakrakonda BO": "731125",
      "Rasa BO": "731125",
      "Sagarbhanga BO": "731125",
      "Sakodda BO": "731215",
      "Saraswatibazar BO": "731215",
      "Thupsara BO": "731215",
      "Koreya BO": "731302",
      "Palsa BO": "731302",
      "Patnil BO": "731302",
      "Jatra BO": "731124",
      "Loba BO": "731124",
      "Hansra BO": "731214",
      "Koyra BO": "731214",
      "Latbhabanipur BO": "731214",
      "Paschimnarayanpur BO": "731214",
      "Payer BO": "731214",
      "Ganeshpur BO": "731126",
      "Babuijore BO": "731125",
      "Barhra BO": "731125",
      "Bhadulia BO": "731125",
      "Gannaserandi BO": "731215",
      "Aligram BO": "731302",
      "Brahmandihi BO": "731302",
      "Brahmanpara BO": "731302",
      "Abadanga BO": "731303",
      "Bhalas BO": "731303",
      "Janubazar BO": "731124",
      "Joydevkenduli BO": "731124",
      "Khandagram BO": "731124",
      "Kota BO": "731124",
      "Niramoy Sanetorium Giridangaed BO": "731124",
      "Chunpalasi BO": "731214",
      "Dumrut BO": "731214",
      "Ghurisha BO": "731214",
      "Matikona BO": "731214",
      "Ushardihi BO": "731214",
      "Bhabanipur BO": "731126",
      "Ghatdurlavpur BO": "731126",
      "Rautara BO": "731126",
      "Tabadumra BO": "731126",
      "Geruapahari BO": "731125",
      "Brahmankhanda BO": "731215",
      "Daronda Ranipara BO": "731302",
      "Debagram Anaipur BO": "731302",
      "Sonarkundu BO": "731243",
      "Dantura BO": "731221",
      "Dadpur BO": "731223",
      "Swadhinpur BO": "731223",
      "Srirampur BO": "731222",
      "Kanserhat BO": "731121",
      "Kurmitha BO": "731121",
      "Mangaldihi BO": "731121",
      "Netaipur BO": "731121",
      "Ikra Hazrapur BO": "731201",
      "Kheyerpara BO": "731201",
      "Konarpur BO": "731201",
      "Kuchuighata BO": "731201",
      "Hatserandi BO": "731240",
      "Baram BO": "731103",
      "Itagoria BO": "731103",
      "Narasinghapur BO": "731103",
      "Raipur BO": "731204",
      "Rupaspur BO": "731123",
      "Bhurkuna BO": "731102",
      "Ganra BO": "731124",
      "Ghoratori BO": "731124",
      "Jhirul BO": "731124",
      "Kandighi BO": "731124",
      "Dhalla BO": "731214",
      "Sunmuni BO": "731214",
      "Gohaliara BO": "731126",
      "Nagari BO": "731126",
      "Patharchapuri BO": "731126",
      "Sajina BO": "731126",
      "Tantipara BO": "731126",
      "Hazratpur BO": "731125",
      "Pursundi BO": "731125",
      "Bandar BO": "731215",
      "Belai BO": "731215",
      "Srikrishnapur BO": "731215",
      "Daskalgram BO": "731302",
      "Dhrubabati BO": "731302",
      "Fewgram BO": "731302",
      "Nurpur BO": "731302",
      "Bautia BO": "731243",
      "Chilinpur BO": "731243",
      "Harioka BO": "731243",
      "Bonha BO": "731221",
      "Mitrapur BO": "731221",
      "Panchahar BO": "731221",
      "Tirogram BO": "731221",
      "Beliamritunjoypur BO": "731223",
      "Kusumba BO": "731223",
      "Chakaipur BO": "731223",
      "Bonorampur BO": "731222",
      "Bansanka BO": "731121",
      "Gargaria BO": "731121",
      "Panrui BO": "731121",
      "Chowhatta BO": "731201",
      "Hatia BO": "731201",
      "Laghosa BO": "731201",
      "Nimgoria BO": "731201",
      "Jalandi BO": "731240",
      "Pafuri BO": "731240",
      "Panchsowa BO": "731240",
      "Junidpur BO": "731103",
      "Langulia BO": "731103",
      "Tapaspur BO": "731104",
      "Muluk BO": "731204",
      "Rajatpur BO": "731204",
      "Charkolgram BO": "731301",
      "Sauta BO": "731301",
      "Lokpur BO": "731123",
      "Panditpur BO": "731123",
      "Chakdaha BO": "731102",
      "Haraipur BO": "731102",
      "Kamadpur BO": "731303",
      "Maheshpur BO": "731303",
      "Kusumi BO": "731218",
      "Mohurapur BO": "731218",
      "Kapista BO": "731127",
      "Joypur BO": "731130",
      "Kurulmetia BO": "731130",
      "Beliakuricha BO": "731234",
      "Deriapur BO": "731234",
      "Gadadharpur RS BO": "731234",
      "Kunuri BO": "731234",
      "Mathpalsa BO": "731234",
      "Nowaparamahadipa BO": "731234",
      "Satpalsa BO": "731234",
      "Uchpur BO": "731234",
      "Belatisultanpur BO": "731236",
      "Bergram BO": "731236",
      "Kasba BO": "731236",
      "Nachansaha BO": "731236",
      "Sattore BO": "731236",
      "BITM BO": "731236",
      "BHATRA BO": "731304",
      "PUSHULIA BO": "731304",
      "Bipratikuri BO": "731303",
      "Dwarka BO": "731303",
      "Gopalpur BO": "731303",
      "Kurumba BO": "731303",
      "Thiba BO": "731303",
      "Baidyanathpur BO": "731127",
      "Baliharpur BO": "731127",
      "Bishnupurkulkuri BO": "731127",
      "Charicha BO": "731127",
      "Deucha BO": "731132",
      "Harinsingha BO": "731132",
      "Kabilpur BO": "731132",
      "Nischintapur Jagatpur BO": "731132",
      "Churar BO": "731133",
      "Paigora BO": "731133",
      "Ranipathar BO": "731133",
      "Ikra BO": "731129",
      "Majhigram BO": "731129",
      "Aligarh BO": "731130",
      "Lauberia BO": "731130",
      "Bagdola BO": "731234",
      "Barasija BO": "731234",
      "Basudevpur BO": "731234",
      "Gunutia BO": "731234",
      "Hatora BO": "731234",
      "Jiwe BO": "731234",
      "Kumarpur BO": "731234",
      "Ulkunda BO": "731234",
      "Uttarbonogram BO": "731234",
      "Monoharpur BO": "731236",
      "KAZIPARA BO": "731304",
      "LANGALHATA BO": "731304",
      "Gaganpur BO": "731221",
      "Hilora BO": "731221",
      "Barapahari BO": "731223",
      "Ambhua BO": "731222",
      "Bandhaipur BO": "731222",
      "Bhabanipur Bhatra BO": "731222",
      "Bataspur BO": "731201",
      "Belia BO": "731201",
      "Bhoromorekol BO": "731201",
      "Nirisha BO": "731201",
      "Paharpur BO": "731201",
      "Purbasiur BO": "731201",
      "Sindurtopa BO": "731201",
      "Banagram BO": "731240",
      "Bangachhatra BO": "731240",
      "Gheedaha BO": "731240",
      "Singhee BO": "731240",
      "Baraalunda BO": "731103",
      "Chinpai BO": "731104",
      "Sahapur BO": "731104",
      "Adityapur BO": "731204",
      "Bagdowra BO": "731204",
      "Bolpur Court BO": "731204",
      "Kuchligopalpur BO": "731204",
      "Sitapur BO": "731204",
      "Barha BO": "731301",
      "Belhati BO": "731301",
      "Uchkaran BO": "731301",
      "Ukrandi BO": "731301",
      "Bhabanandapur BO": "731243",
      "Haridaspur BO": "731243",
      "Jajigram BO": "731221",
      "Kasimnagar BO": "731221",
      "Narayanpur BO": "731223",
      "Bonmohurapur BO": "731222",
      "Boruagopalpur BO": "731222",
      "Bakreswar BO": "731123",
      "Balijuri BO": "731123",
      "Joplai BO": "731123",
      "Kukutia BO": "731123",
      "Lakshmi Narayan Pur BO": "731123",
      "Kanspai BO": "731102",
      "Mohubona BO": "731102",
      "Panuria BO": "731102",
      "Ishakpur BO": "731303",
      "Chhamna BO": "731218",
      "Chhototurigram BO": "731218",
      "Daspalsa BO": "731218",
      "Kaleswar BO": "731218",
      "Kotasur BO": "731218",
      "Rampur BO": "731127",
      "Sarenda BO": "731127",
      "Sehelaraipur BO": "731127",
      "Seherakuri BO": "731127",
      "Damdama BO": "731129",
      "Dholtikuri BO": "731129",
      "Laujore BO": "731130",
      "Muktipur BO": "731130",
      "Ranigram BO": "731130",
      "Dohira BO": "731234",
      "Fulur BO": "731234",
      "Ramnagar BO": "731234",
      "Rangaipur BO": "731234",
      "Bheramari BO": "731236",
      "Bishnukhanda BO": "731236",
      "Rajgramgram BO": "731222",
      "Batikar BO": "731121",
      "Sikarpur BO": "731121",
      "Talibpur BO": "731121",
      "Bagrakonda BO": "731201",
      "Bhalkuti BO": "731201",
      "Chotosangra BO": "731201",
      "Dewas Chandpur BO": "731201",
      "Kurumsha BO": "731201",
      "Mahodory BO": "731201",
      "Uttarkhayerbuni BO": "731201",
      "Nahina BO": "731240",
      "Sansat BO": "731240",
      "Khantanga BO": "731103",
      "Kukhudihi BO": "731103",
      "Albandha BO": "731204",
      "Darpasila BO": "731204",
      "Laldaha BO": "731204",
      "Sian BO": "731204",
      "Supur BO": "731204",
      "Mohanpur BO": "731301",
      "Pakurhans BO": "731301",
      "Metela BO": "731123",
      "Peruagopalpur BO": "731123",
      "Changuria BO": "731102",
      "Januri BO": "731102",
      "Delora BO": "731124",
      "Indus BO": "731303",
      "Kuniara BO": "731303",
      "Purbakadipur BO": "731303",
      "Tatinapara BO": "731303",
      "Brahmanbahara BO": "731218",
      "Kanutia BO": "731218",
      "Kuliara BO": "731218",
      "Parulia BO": "731218",
      "Amjolpahari BO": "731127",
      "Debagramchuramali BO": "731127",
      "Nimdaspur BO": "731127",
      "Puranagram BO": "731132",
      "Gadadharpur BO": "731129",
      "Kundira BO": "731130",
      "Chautara BO": "731234",
      "Derpur BO": "731234",
      "Gorola BO": "731234",
      "Kundala BO": "731234",
      "Majiara BO": "731234",
      "Pathai BO": "731234",
      "Daranda BO": "731236",
      "Digha BO": "731236",
      "BUNIA BO": "731304",
      "Sahora BO": "731234",
      "Saugram BO": "731234",
      "Paruldanga BO": "731235",
      "Benuria BO": "731236",
      "Khanjanpur BO": "731236",
      "Ruppur BO": "731236",
      "Barakartickchungri BO": "731202",
      "Atla BO": "731233",
      "Tarapur BO": "731233",
      "Koyemba BO": "731241",
      "Bhadista BO": "731238",
      "Pakhuria BO": "731245",
      "Sanakpur BO": "731245",
      "Bujung BO": "731242",
      "Bandhkhola BO": "731237",
      "Bara BO": "731237",
      "Dighalgram BO": "731216",
      "Dwaruri BO": "731216",
      "Gonpur BO": "731216",
      "Beliapalsa BO": "731219",
      "Bhimpur BO": "731219",
      "Bipranandigram BO": "731219",
      "Dhananjoypur BO": "731219",
      "Dumurgram BO": "731219",
      "Mustofadanga BO": "731220",
      "Ayas BO": "731243",
      "Dakshingram SO": "731245",
      "Joykrishnapur BO": "731202",
      "Laha BO": "731202",
      "Tentulia BO": "731244",
      "Dekhuria BO": "731233",
      "Poprasahapur BO": "731233",
      "Sandhyajole BO": "731233",
      "Goalmal BO": "731238",
      "Jogai BO": "731238",
      "Kusmore BO": "731238",
      "Begunia BO": "731245",
      "Khemedda BO": "731245",
      "Sardha BO": "731242",
      "Gopalchak BO": "731237",
      "Kantagoria BO": "731237",
      "Bharkata BO": "731216",
      "Kastogoria BO": "731216",
      "Mohula BO": "731216",
      "Sonj BO": "731216",
      "Bahadurpur BO": "731219",
      "Kahinagar BO": "731219",
      "Kalahapur BO": "731219",
      "Kathia BO": "731219",
      "Debagram BO": "731220",
      "Bishnupur SO Birbhum": "731244",
      "Chandipur Tarapith SO": "731233",
      "Kaitha BO": "731220",
      "Kogram BO": "731220",
      "Chandpara SO": "731241",
      "Chatra SO Birbhum": "731238",
      "Mahajanpatty SO": "731224",
      "Abinashpur SO": "731121",
      "Ahmadpur SO": "731201",
      "BCollectorate SO": "731101",
      "Baruipara SO Birbhum": "731101",
      "BkTPP SO": "731104",
      "Bolpur Ukilpatty SO": "731204",
      "Khujutipara SO": "731215",
      "Kirnahar SO": "731302",
      "MdBazar Town Ship SO": "731132",
      "Rakhakalitala SO": "731234",
      "Sainthia SO": "731234",
      "Sriniketan SO": "731236",
      "Dakhalbati BO": "731202",
      "Kaluha BO": "731202",
      "Barsal BO": "731233",
      "Chakpara BO": "731233",
      "Majkhanda BO": "731233",
      "Sandhigorabazar BO": "731233",
      "Dunigram BO": "731241",
      "Duria BO": "731238",
      "Khanpur BO": "731238",
      "Sultanpur BO": "731238",
      "Birchandrapur BO": "731245",
      "Ghoshgram BO": "731245",
      "Anantapurkanaipur BO": "731242",
      "Gopegram BO": "731242",
      "Bhadrapur BO": "731237",
      "Jesthabhabanipur BO": "731237",
      "Dabuk BO": "731216",
      "Damra BO": "731216",
      "Katigram BO": "731216",
      "Sekpur BO": "731216",
      "Amdole BO": "731219",
      "Edrakpur BO": "731219",
      "Kanakpur BO": "731219",
      "Barla BO": "731220",
      "Modhura BO": "731220",
      "Tejhati BO": "731220",
      "Banior BO": "731243",
      "Mallickpur BO": "731202",
      "Margram BO": "731202",
      "Ningha BO": "731202",
      "Budhigram BO": "731244",
      "Gug BO": "731233",
      "Karkaria BO": "731233",
      "Kharbona BO": "731233",
      "Kharun BO": "731233",
      "Bishore BO": "731238",
      "Chhatina BO": "731238",
      "Rudranagar BO": "731238",
      "Turigram BO": "731245",
      "Krishnapur BO": "731237",
      "Noapara BO": "731237",
      "Salisanda BO": "731237",
      "Sitalgram BO": "731237",
      "Ujirpur BO": "731237",
      "Kanachi BO": "731216",
      "Makdamnagar BO": "731216",
      "Muruli Dangal BO": "731216",
      "Taloan BO": "731216",
      "Tarachua BO": "731216",
      "Malaypur BO": "731219",
      "Ramchandrapur BO": "731219",
      "Ruprampur BO": "731219",
      "Diha BO": "731220",
      "Gosainpur BO": "731220",
      "Kalitha BO": "731220",
      "Paikpara BO": "731220",
      "Baswa SO Birbhum": "731202",
      "Lohapur SO": "731237",
      "Mallarpur SO": "731216",
      "Nischintapur SO": "731224",
      "Paikar SO": "731221",
      "Rajgaon SO": "731222",
      "Bolpur Bazar SO": "731204",
      "Bolpur Trisulapatty SO": "731204",
      "Hatjanbazar SO": "731102",
      "Iswarpurndtso SO": "731201",
      "Labpur Mastali SO": "731303",
      "Labpur SO": "731303",
      "Mayureswar SO": "731218",
      "MdBazar SO": "731127",
      "Purundarpur SO": "731129",
      "Sainthia Bazar SO": "731234",
      "Santiniketan SO": "731235",
      "Sonatoresuri SO": "731101",
      "Suribazar SO": "731101",
      "Rampurhat HO": "731224",
      "Murarai SO": "731219",
      "Nalhati SO": "731220",
      "Nalhati Township SO": "731243",
      "R K Sikshapith SO": "731223",
      "ChNanoor SO": "731301",
      "Dubrajpur SO": "731123",
      "Hetampur Rajbati SO": "731124",
      "Jangaldubrajpur SO": "731123",
      "Khoyrasole SO": "731125",
      "Panchrahat SO": "731133",
      "Pranabanandapally SO": "731101",
      "Suricollege SO": "731101",
      "Kurumgram SO": "731242",
      "Railpar SO Birbhum": "731224",
      "Bahiri SO": "731240",
      "Barabagan SO": "731103",
      "Bolpur SO": "731204",
      "Illambazar SO": "731214",
      "Karidhya SO": "731126",
      "Rajnagar SO Birbhum": "731130",
      "Suri Dist School Board SO": "731101",
      "Suri HO": "731101",
      "KURUNNAHAR SO": "731304",
      "Brahmanigram BO": "713129",
      "Gandhpur BO": "713143"
    },
    "MALDAH": {
      "Deonapur BO": "742202",
      "Laskarpur BO": "732205",
      "Amarsinghi BO": "732139",
      "Batna BO": "732139",
      "Chorolmoni BO": "732139",
      "Gangadevi BO": "732139",
      "KB Jhowbona BO": "732209",
      "Sahabattola BO": "732209",
      "Baluachara BO": "732206",
      "Bamangram BO": "732206",
      "Gayeshbari BO": "732206",
      "Bhatolchandipur BO": "732140",
      "Boroi BO": "732140",
      "Ramsimul BO": "732140",
      "Baldiapukur BO": "732139",
      "Bhado BO": "732139",
      "Chandmoni BO": "732139",
      "Gopalpur BO": "732209",
      "Milki BO": "732209",
      "Chaspara BO": "732206",
      "Chhoto Sujapur BO": "732206",
      "Fatehkhani BO": "732206",
      "Jamirghata Sarkarpara BO": "732206",
      "Karbona BO": "732139",
      "Kashimpur BO": "732139",
      "Sonarai BO": "732139",
      "Sripur BO": "732139",
      "Bhabanipur BO": "732209",
      "Madhugaht Filature Estate BO": "732206",
      "Mosimpur BO": "732206",
      "Sherpur BO": "732206",
      "Chandipur BO": "732140",
      "Jabra BO": "732140",
      "Kushida BO": "732140",
      "Paro BO": "732140",
      "Uttar Mahadipur BO": "732216",
      "Madhaipur BO": "732142",
      "Rahimpur BO": "732202",
      "Khairtola BO": "732203",
      "Nazirpur BO": "732203",
      "Nurpur BO": "732203",
      "Uttar Chandipur BO": "732203",
      "Bangitola BO": "732207",
      "Hamidpur BO": "732207",
      "Jitnagar BO": "732207",
      "Uttar Lakshmipur BO": "732207",
      "Gour BO": "732103",
      "Fulbari BO": "732103",
      "Popra BO": "732141",
      "Adina Station BO": "732128",
      "Jharpukhuria BO": "732128",
      "Magurai BO": "732128",
      "Araji Jalsa BO": "732138",
      "Dalla Madhyapara BO": "732138",
      "Pannapur BO": "732138",
      "Patul BO": "732138",
      "Mirjatpur BO": "732204",
      "Pukhuria BO": "732204",
      "Bahirkap BO": "732205",
      "Kahala BO": "732205",
      "Damaipur BO": "732139",
      "Jitarpur BO": "732139",
      "Kandaran BO": "732139",
      "Pirpur BO": "732209",
      "Bakharpur BO": "732206",
      "Jalalpur BO": "732206",
      "Jadupur BO": "732206",
      "Sayedpur BO": "732206",
      "Bangrua BO": "732140",
      "Bishanpur BO": "732140",
      "Umakantatola BO": "732216",
      "Sahapur BO": "732142",
      "Chowki Mirdadpur BO": "732202",
      "Dallutola BO": "732202",
      "Dharampur BO": "732202",
      "Enayetpur BO": "732202",
      "Janakiramtola BO": "732202",
      "Mohana BO": "732202",
      "Bakdukra Anantalalpur BO": "732203",
      "Bhutni BO": "732203",
      "Birampur BO": "732207",
      "Damodartola BO": "732207",
      "Debipur Achintala BO": "732207",
      "Gangaprasad BO": "732207",
      "Khaskol Chandipur BO": "732207",
      "Meherapur BO": "732207",
      "Kamalabari BO": "732103",
      "Dhumadighi BO": "732128",
      "Jagdala BO": "732138",
      "Kamaldanga BO": "732138",
      "Khutadaha BO": "732138",
      "Brahmangram BO": "732204",
      "Ekborna BO": "732204",
      "Goraksha BO": "732204",
      "Khoilsona BO": "732204",
      "Araidanga BO": "732204",
      "Bhgabanpur BO": "732210",
      "Char Sujapur Mandai BO": "732210",
      "Krishnapur BO": "732210",
      "Lakshmipur BO": "732124",
      "Nandalalpur BO": "732210",
      "Habibpur BO": "732122",
      "Singabad BO": "732122",
      "Arbora BO": "732123",
      "Bhingole BO": "732123",
      "Birosthali BO": "732123",
      "Debiganj BO": "732123",
      "Malatipur BO": "732123",
      "Rasulpur BO": "732123",
      "Sadarpur BO": "732123",
      "Badnagra BO": "732124",
      "Deotala BO": "732124",
      "Dhaoel BO": "732124",
      "Hatimari BO": "732124",
      "Ichahar BO": "732124",
      "Parail BO": "732124",
      "Baghua BO": "732125",
      "Daulatnagar BO": "732125",
      "Dhangara BO": "732125",
      "Fatehpur BO": "732125",
      "Khopakati BO": "732125",
      "Mahanandatola BO": "732125",
      "Mahendrapur BO": "732125",
      "Malior BO": "732125",
      "Bairgachi BO": "732102",
      "Kadamtali BO": "732102",
      "Maliha BO": "732102",
      "Pirganj BO": "732102",
      "Rajadighi BO": "732102",
      "Rajapur BO": "732102",
      "Alinagar BO": "732201",
      "Purba Bahadurpur BO": "732201",
      "Rajnagar BO": "732201",
      "Ramnagar BO": "732201",
      "Chandrapara BO": "732126",
      "Galimpur BO": "732126",
      "Goalpara BO": "732126",
      "Kushmai BO": "732126",
      "Chamagram BO": "732127",
      "Srirampur BO": "732216",
      "Sirshi BO": "732121",
      "Madapur BO": "732208",
      "Bedrabad BO": "732210",
      "Chakbahadurpur BO": "732210",
      "Gopalpurhat BO": "732122",
      "Kendpukur BO": "732122",
      "Manikora BO": "732122",
      "Nakail BO": "732122",
      "Hatinda BO": "732123",
      "Ishadpur BO": "732123",
      "Malikan BO": "732123",
      "Mallikpara BO": "732123",
      "Bachamari BO": "732142",
      "Nageswarpur BO": "732142",
      "Purbasaidpur BO": "732202",
      "Lalbathani BO": "732203",
      "Noaborar Jaigir BO": "732203",
      "Jagannathpur Rathbari BO": "732207",
      "Jotgopal Kagmari BO": "732207",
      "Jugaltola BO": "732207",
      "Kajigram Chandipur BO": "732103",
      "Harkharkha BO": "732128",
      "Jote Basanta BO": "732128",
      "Asrafpur BO": "732138",
      "Dohil BO": "732138",
      "Masheshpur BO": "732138",
      "Parbatidanga BO": "732138",
      "Baharal BO": "732205",
      "Kamalpur BO": "732205",
      "Ahora BO": "732124",
      "Arjunpur BO": "732124",
      "Katikandar BO": "732124",
      "Khanta BO": "732124",
      "Barduary BO": "732125",
      "Jagannathpur BO": "732125",
      "Miahat BO": "732125",
      "Pipla BO": "732125",
      "Sultannagar BO": "732125",
      "Dakshin Alinagar BO": "732102",
      "Mahakalbona BO": "732102",
      "Sambalpur Tal BO": "732102",
      "Bahadurpur BO": "732201",
      "Bholaichak BO": "732201",
      "Joyenpur BO": "732201",
      "Nabinagar BO": "732201",
      "Shersahi BO": "732201",
      "Sukdevpur BO": "732201",
      "Bheba BO": "732126",
      "Motiharpur BO": "732126",
      "Naikanda BO": "732126",
      "Charbabupur BO": "732127",
      "Palgachhi BO": "732127",
      "Akandabaria BO": "732216",
      "Jaluabadhal Mallikpara BO": "732216",
      "Sukdevtola BO": "732203",
      "Suksena BO": "732203",
      "Panchanandapur BO": "732207",
      "Sripur Colony BO": "732207",
      "Kanchantar BO": "732103",
      "Rajbati Ramnagar BO": "732103",
      "Jatradanga BO": "732141",
      "Alal BO": "732128",
      "Balia Nawabganj BO": "732128",
      "Barkol BO": "732128",
      "Budhia BO": "732128",
      "Arapur BO": "732128",
      "Ahil BO": "732138",
      "Binodpur BO": "732138",
      "Dharmadanga BO": "732138",
      "Dighalbar BO": "732138",
      "Purba Ranipur BO": "732138",
      "Rahutara BO": "732138",
      "Sapmari BO": "732138",
      "Bamongola BO": "732138",
      "Balupur BO": "732205",
      "Banikantatala BO": "732205",
      "Bilaimari BO": "732205",
      "Debipur BO": "732205",
      "Serpur Mukdumpur BO": "732123",
      "Singhia BO": "732123",
      "Akalpur BO": "732124",
      "Katna BO": "732124",
      "Malipara BO": "732124",
      "Mayna BO": "732124",
      "Molladighi BO": "732124",
      "Mudapur BO": "732124",
      "Salaidanga BO": "732124",
      "Shivajinagar BO": "732124",
      "Hardamnagar BO": "732125",
      "New Sadlichak BO": "732125",
      "Gandhinagar BO": "732121",
      "Mahadevpur BO": "732121",
      "Koklamari BO": "732208",
      "Nagharia BO": "732208",
      "Agra Harishchandrapur BO": "732122",
      "Khoribari BO": "732122",
      "Kotalpur BO": "732122",
      "Hazarat Jalalpur BO": "732123",
      "Ismailpur BO": "732123",
      "Paraninagar BO": "732123",
      "Talbangrua BO": "732125",
      "Talgachhi BO": "732125",
      "Talgramhat BO": "732125",
      "Talsur BO": "732125",
      "Koilabad BO": "732102",
      "Kumarganj RS BO": "732102",
      "Kutubganj BO": "732102",
      "Kutubsahar BO": "732102",
      "Charianantapur BO": "732201",
      "Dakshin Lakshmipur BO": "732201",
      "Dallugram BO": "732201",
      "Duisatabighi BO": "732201",
      "Golapganj BO": "732201",
      "Haruchak BO": "732201",
      "Jotparam BO": "732201",
      "Sabdalpur BO": "732201",
      "Sahabazpur BO": "732201",
      "Uttar Dariapur BO": "732201",
      "Nawada BO": "732216",
      "South Kadamtala BO": "732216",
      "Babupur BO": "732124",
      "Bagsarai BO": "732124",
      "Panchpara BO": "732124",
      "Taherpur BO": "732124",
      "Bansdol Daulatpur BO": "732125",
      "Bhaluka Bazar BO": "732125",
      "Dahua BO": "732125",
      "Kariali BO": "732125",
      "Maniknagar BO": "732125",
      "Milangarh BO": "732125",
      "Sambalpur BO": "732125",
      "Harishchandrapur Bazar BO": "732125",
      "Haripur BO": "732102",
      "Katlamari BO": "732102",
      "Maharajpur BO": "732102",
      "Raninagar BO": "732102",
      "Alipur BO": "732201",
      "Baliadanga BO": "732201",
      "Khaschandpur BO": "732201",
      "Nayagram BO": "732201",
      "Shashani BO": "732201",
      "Sultanganj BO": "732201",
      "Mulaibari BO": "732126",
      "Noorganj BO": "732126",
      "Santoshpur BO": "732126",
      "Kharba BO": "732126",
      "Gurutola BO": "732127",
      "Kadamtala BO": "732216",
      "Dobakhokshan BO": "733124",
      "Nalagola BO": "733124",
      "Gouramari BO": "732121",
      "Atgama BO": "732208",
      "Niamatpur BO": "732208",
      "Phulbaria BO": "732208",
      "Sattari BO": "732208",
      "Jagjibanpur BO": "732122",
      "Kanturka BO": "732122",
      "Jagannathpur Maltola BO": "732123",
      "Kupadaha BO": "733142",
      "Madnabati BO": "733124",
      "Malda HO": "732101",
      "Amrity SO": "732208",
      "Baluchar SO": "732101",
      "Bansbari SO": "732101",
      "Chanchal SO": "732123",
      "District School Board SO Malda": "732101",
      "Kotwali SO Malda": "732144",
      "Mathurapur SO Malda": "732203",
      "Mirchak SO": "732101",
      "Pubarun SO": "732215",
      "Rabindra Avenue SO": "732101",
      "Baishnabnagar SO": "732210",
      "Gajol SO": "732124",
      "Harishchandrapur SO": "732125",
      "Jhaljhalia Railway Colony SO": "732102",
      "Kaliachak SO": "732201",
      "Kaligaon SO": "732126",
      "Khejuriaghat SO": "732127",
      "Pakuahat SO": "732138",
      "Ratua SO": "732205",
      "Samsi SO": "732139",
      "Bulbulchandi SO": "732122",
      "Mahadipur SO": "732216",
      "Malda Court SO": "732101",
      "Mangalbari SO": "732142",
      "Mothabari SO": "732207",
      "Mukdumpur SO": "732103",
      "Netaji Subhas Road SO": "732101",
      "Rathbari SO": "732101",
      "Sujapur SO": "732206",
      "Aiho SO": "732121",
      "Manikchak SO": "732202",
      "Narayanpur SO Malda": "732141",
      "Old Malda SO": "732128",
      "Paranpur SO": "732204",
      "Sarbamangalapally SO": "732101",
      "Sovanagar SO": "732209",
      "Tulsihatta SO": "732140"
    },
    "COOCHBEHAR": {
      "Jatamari BO": "736146",
      "Jorepatki BO": "736146",
      "Kismat Dasgram BO": "736169",
      "Kuchni BO": "736169",
      "Rakhalmari BO": "736169",
      "Tiadaha BO": "736169",
      "Chhatoa BO": "736156",
      "Deocharai BO": "736156",
      "Konamali Khapaidanga BO": "736156",
      "Maruganj BO": "736156",
      "Bajejama Pakhihaga BO": "736145",
      "Hatiram Salbari BO": "736145",
      "Masanpath BO": "736145",
      "Kanfata BO": "736146",
      "Kawardera BO": "736146",
      "Kurshamari BO": "736146",
      "Pachagarh BO": "736146",
      "Airani Chitalia BO": "736156",
      "Bhelapeta BO": "736156",
      "Mahishmuri BO": "736172",
      "Nutanbash BO": "736145",
      "Phulbari BO": "736145",
      "Barogharia Garkuta BO": "736146",
      "Bhangamore BO": "736146",
      "Khalishamari BO": "736146",
      "Shikarpur BO": "736146",
      "Khagrabari BO": "736179",
      "Mahish Bathan BO": "736179",
      "Barasakdal BO": "736169",
      "Baikunthapur BO": "736156",
      "Chhatbarachauki BO": "736156",
      "Dawaguri BO": "736156",
      "Krishnapur BO": "736156",
      "Natabari BO": "736156",
      "Shibpur BO": "736172",
      "Baranatabari BO": "736145",
      "Pakhihaga BO": "736145",
      "Andaran Pakhihaga BO": "736146",
      "Gadaler Kuthi BO": "736146",
      "Mahishcharu BO": "736146",
      "South Bhangamore BO": "736146",
      "Kharija Kakribari BO": "736179",
      "Takagachh BO": "736179",
      "Bhelakopa BO": "736156",
      "Chakchaka BO": "736156",
      "Charaljani BO": "736156",
      "Pestarjhar BO": "736156",
      "Bagdokra BO": "735304",
      "Alokjhari BO": "735224",
      "Upen Chowki Kuchlibari BO": "735304",
      "Shoulmari BO": "735224",
      "Fulkadabri BO": "735304",
      "Unishbisha BO": "736171",
      "Rashidanga BO": "736170",
      "Barogodaikhora BO": "736172",
      "Kuchlibari BO": "735304",
      "Niztaraf BO": "735304",
      "Brahamattar Kuchilibari BO": "735304",
      "Kharkharia BO": "735304",
      "N U C Kuchlibari BO": "735304",
      "Paschim Hemkumari BO": "735122",
      "Uchalpukuri BO": "735303",
      "Patakamari BO": "736171",
      "Dudherkuthi Dewanbash BO": "736170",
      "Guriahati BO": "736170",
      "Bhawairthana BO": "736172",
      "Chhoto Salbari BO": "736172",
      "Kalika Bazar BO": "736170",
      "Dewankot Jayduar BO": "736172",
      "Madhyam Madhusudan BO": "736172",
      "Sutarpara BO": "736171",
      "Tapurhat BO": "736170",
      "Baradhaperchatra BO": "736172",
      "Shilghagri BO": "736131",
      "Durganagar BO": "736168",
      "Hokadaha BO": "736168",
      "Khatamari BO": "736168",
      "Bhatlaguri BO": "736133",
      "Bokalirmath BO": "736133",
      "Kaljani BO": "736133",
      "Khapaidanga BO": "736133",
      "Purba Gopalpur BO": "736133",
      "Siddheswari BO": "736133",
      "Bhulki BO": "736134",
      "Borodanga BO": "736134",
      "Brahmanir Chauki BO": "736134",
      "Nazirhat BO": "736134",
      "Ruerkuthi BO": "736134",
      "Salmara BO": "736134",
      "Koalidaha BO": "736135",
      "Matalhat BO": "736135",
      "Kalpani BO": "736171",
      "Khattimari BO": "736171",
      "Khochabarihat BO": "736121",
      "Bakla BO": "736131",
      "Chhitbaralaukuthi BO": "736131",
      "Uttar Falimari BO": "736131",
      "Nandina BO": "736168",
      "Sukarurkuthi BO": "736168",
      "Chaudanga BO": "736133",
      "Gopalpur BO": "736133",
      "Balairhat BO": "736134",
      "Bhetaguri BO": "736134",
      "Chekadera BO": "736134",
      "Dighaltari BO": "736134",
      "Jiranpur BO": "736134",
      "Moamari BO": "736134",
      "Panisala BO": "736134",
      "Souldhukri BO": "736134",
      "Karala BO": "736135",
      "Petla BO": "736135",
      "Putimari BO": "736135",
      "Debottar Boxiganj BO": "735122",
      "Fatehmamud BO": "735122",
      "Buraburi BO": "735303",
      "Dhulia Baldihati BO": "735303",
      "Dhulia Khalisa BO": "735303",
      "Dhulia Uchalpukuri BO": "735303",
      "Kholta BO": "736121",
      "Marichbari BO": "736121",
      "Balakuthi BO": "736131",
      "Falimari BO": "736131",
      "Rasikbil BO": "736131",
      "Chanderkuthi BO": "736168",
      "Tharaikhana BO": "736168",
      "Chagalber BO": "736133",
      "Kheti BO": "735210",
      "Atpukuria Nayahat BO": "735211",
      "Balasunder BO": "735211",
      "Fulbari BO": "735210",
      "Bagribarihat BO": "735122",
      "Bara Haldibari BO": "735122",
      "Hatiduba BO": "736133",
      "Nayarhat BO": "736133",
      "Dhumpur Balasi BO": "736134",
      "Gheghirhat BO": "736134",
      "Haribhanga BO": "736134",
      "Khutamara BO": "736134",
      "Pushnadanga BO": "736134",
      "Balakandi BO": "736135",
      "Chhoto Atiabari BO": "736135",
      "Jarabari BO": "736135",
      "Kawrai BO": "736135",
      "Natkobarihat BO": "736135",
      "Ratinandan Konamukta Payesthi BO": "736135",
      "Singimari Madnakura BO": "736135",
      "Baroshoulmari BO": "735211",
      "Kushiarbari BO": "735211",
      "Ramthenga BO": "735211",
      "Bhotebari BO": "735301",
      "Doradabri BO": "735301",
      "Kamat Changrabandha BO": "735301",
      "Ranirhat BO": "735301",
      "Tengramari BO": "735210",
      "Lotapata BO": "735211",
      "Singijani BO": "735211",
      "Daripattani BO": "735122",
      "Dewanganj BO": "735122",
      "Hemkumari BO": "735122",
      "Uttar Daribash BO": "735122",
      "Ashokebari BO": "735303",
      "Bairagirhat BO": "735303",
      "Barogopalpur BO": "735303",
      "Giladanga BO": "735303",
      "Keshoribari BO": "735303",
      "Thunkirjhar BO": "735303",
      "Boxiganj BO": "735122",
      "Bamunia West BO": "735303",
      "Bhogramguri BO": "735303",
      "Joresimuli BO": "735303",
      "Panigram BO": "735303",
      "Bhainskuthi BO": "736131",
      "Bhanukumari BO": "736131",
      "Nakarkhana BO": "736131",
      "Chowdhurihat BO": "736168",
      "Ambari BO": "736133",
      "Sonari BO": "736133",
      "Uttar Ambari BO": "736133",
      "Jorai BO": "736207",
      "Rampur BO": "736207",
      "Kamat Seoraguri BO": "736134",
      "Kumarganj BO": "736134",
      "Mansab Seoraguri BO": "736134",
      "Bara Atiabari BO": "736135",
      "Baranachina BO": "736135",
      "Baravita BO": "736135",
      "Bhagni Parti BO": "736135",
      "Bhalka Putimari BO": "736135",
      "Bhutkura BO": "736135",
      "Gitaldaha Atiabari BO": "736135",
      "Gitaldaha BO": "736135",
      "Gobrasara BO": "736135",
      "Jamadarerbash BO": "736135",
      "Subachanirpath BO": "736135",
      "Bairati BO": "736157",
      "Bhogmara BO": "736157",
      "Patchhara BO": "736157",
      "Madhupur BO": "736165",
      "Patlakhawa BO": "736165",
      "Jatigara BO": "736167",
      "Golenawhati BO": "736158",
      "Nagarlal Bazar BO": "736158",
      "Andaran Fulbari BO": "736160",
      "Andaranfulbari West BO": "736159",
      "Balaghat BO": "736159",
      "Barashalbari BO": "736159",
      "Chilakhana BO": "736159",
      "Ghogarkuthi BO": "736159",
      "Kamat Fulbari BO": "736159",
      "Langalgram BO": "736159",
      "Shalbari BO": "736159",
      "Maghpala BO": "736157",
      "Matiarkuthi BO": "736157",
      "Sajerpar Ghoramara BO": "736165",
      "Sukhdhanerkuthi BO": "736165",
      "Chorekhata BO": "736167",
      "Kajlikura BO": "736167",
      "Nakarjan BO": "736167",
      "Panikhawa BO": "736167",
      "Bamanpara BO": "736158",
      "Chhat Fulbari BO": "736160",
      "Uttar Andaranfulbari BO": "736160",
      "Debagram BO": "736159",
      "Dhadial BO": "736159",
      "Dhalpal BO": "736159",
      "Dorkochengtimari BO": "736159",
      "Jhaljhali BO": "736159",
      "Cooch Behar HO": "736101",
      "Talliguri BO": "736156",
      "Angerkata Paradubi BO": "736157",
      "Chilkirhat BO": "736157",
      "Patpishu BO": "736157",
      "Mara Nadir Kuthi BO": "736165",
      "Rajarhat BO": "736165",
      "Chamta BO": "736167",
      "Dhumerkhata BO": "736167",
      "Kismat Adabari BO": "736167",
      "Baramaricha BO": "736158",
      "Lalbazar PartII BO": "736158",
      "Bilshi BO": "736160",
      "Balabhut BO": "736159",
      "Balapukuri BO": "736159",
      "Bhurkush BO": "736159",
      "Chhatrampur BO": "736159",
      "Colony Chamta BO": "736159",
      "Dwiperpar BO": "736159",
      "Harirhat BO": "736159",
      "Jaigir Chilakhana BO": "736159",
      "Jhaokuthi BO": "736159",
      "Akrarhat Bandar BO": "736157",
      "Domuka Nayarhat BO": "736157",
      "Elajanerkuthi BO": "736157",
      "Putimari Fuleswari BO": "736157",
      "Shildanga BO": "736157",
      "Chandanchaura BO": "736165",
      "Chhoto Khairatibari BO": "736165",
      "Dhangdhinguri BO": "736165",
      "East Sakunibala BO": "736165",
      "Holongerkuthi BO": "736165",
      "Kalmati BO": "736176",
      "Khochabari BO": "736176",
      "Brahmottar Chatra BO": "736167",
      "Silduar BO": "736167",
      "Purba Sitalkuchi BO": "736158",
      "Barokodali BO": "736159",
      "Begarkhata BO": "736159",
      "Bhandijelash BO": "736159",
      "Kashidanga BO": "736159",
      "Mansai BO": "736159",
      "Nagurhat BO": "736159",
      "Uttar Ghogarkuthi BO": "736159",
      "Bamanhat SO": "736168",
      "Bangchatra SO": "736101",
      "Bakshirhat SO": "736131",
      "Baneswar SO": "736133",
      "Cooch Behar Bazar SO": "736101",
      "Cooch Behar New Town SO": "736101",
      "Jamaldah SO": "735303",
      "Mekhliganj SO": "735304",
      "Cooch Behar Railway Station SO": "736101",
      "Dinhata Bazar SO": "736135",
      "Ghughumari SO": "736170",
      "Gossanimari SO": "736145",
      "Nigamnagar SO": "736169",
      "Sitalkuchi SO": "736158",
      "Tufanganj SO": "736159",
      "Durgabari Subhash Pally SO": "736101",
      "Gunjabari SO": "736101",
      "New Cooch Behar SO": "736179",
      "Nishiganj SO": "736157",
      "Patakura SO Cooch Behar": "736101",
      "Pundibari SO": "736165",
      "Dewanhat SO": "736134",
      "Dinhata SO": "736135",
      "Ghoksadanga SO": "736171",
      "Gossairhat Bandar SO": "736172",
      "Kharimala Khagrbari SO": "736101",
      "Sahebganj SO Cooch Behar": "736176",
      "Tufanganj New Town SO": "736160",
      "Haldibari SO": "735122",
      "Mathabhanga SO": "736146",
      "Nilkuthi SO": "736156",
      "Sitaihat SO": "736167",
      "Changrabandha SO": "735301"
    },
    "Alipurduar": {
      "Purba Satali BO": "735214",
      "Satali Mandal Para BO": "735214",
      "Uttar Mendabari BO": "735214",
      "Chuniajhora BO": "736201",
      "Nimti Domohani BO": "735217",
      "GANGUTIA TG": "735217",
      "Dakshin Kamaskhyaguri BO": "736202",
      "Dakshin Nararthali BO": "736202",
      "Kaijali Basti BO": "736201",
      "Kartik Choupathi BO": "736201",
      "Raidak BO": "736201",
      "Chuapara BO": "735217",
      "Shilbarihat BO": "736204",
      "Sonapur BO": "736204",
      "Khoardanga BO": "736202",
      "Lalchandpur BO": "736202",
      "Uttar Nararthali BO": "736202",
      "Uttar Parokata BO": "736202",
      "Dakshin Chakoakheti BO": "736204",
      "Dakshin Kamsingram BO": "736204",
      "Nathuatari BO": "736204",
      "Salkumarhat BO": "736204",
      "Sidhabari BO": "736204",
      "Jaigaon BO": "736182",
      "Dakshin Satali BO": "735214",
      "Madhubagan BO": "735215",
      "Atiabaribagan BO": "735217",
      "Brajerkuthi BO": "736202",
      "Purba Khalisamari BO": "736202",
      "Telepara BO": "736202",
      "Barodaldali BO": "736203",
      "Pukurigram BO": "736203",
      "Jogendranagar BO": "736204",
      "Kalabaria BO": "736204",
      "Uttar Simlabari BO": "736204",
      "Dakshin Latabari BO": "735214",
      "Paschim Satali BO": "735214",
      "Garopara BO": "735217",
      "Rajabhat Tea Estate BO": "735217",
      "Chikliguri BO": "736202",
      "Marakhata BO": "736202",
      "Hemaguri BO": "736203",
      "Jaldapara BO": "736204",
      "Kalipur BO": "736204",
      "Promodenagar BO": "735216",
      "Madhya Khayerbari BO": "735220",
      "Madhya Madarihat BO": "735220",
      "Shibnathpur BO": "735220",
      "Totopara BO": "735220",
      "Garganda BO": "735228",
      "Lankaparahat BO": "735228",
      "M R Bazna BO": "735213",
      "Badaitari BO": "735220",
      "Huntapara BO": "735220",
      "Makrapara BO": "735228",
      "Alinagar BO": "735216",
      "Nabanagar BO": "735216",
      "Deogaon BO": "735213",
      "Rangalibazna BO": "735213",
      "Choto Salkumar BO": "735220",
      "Khowchand Para BO": "735220",
      "Mujnai BO": "735228",
      "Banchukamari BO": "736122",
      "Bholardabri BO": "736123",
      "Majherdabri BO": "736123",
      "Bararangrash BO": "736121",
      "Boragari BO": "736121",
      "Bundapani BO": "735204",
      "Ethelbari Crossing BO": "735204",
      "Gopaldashat BO": "736121",
      "Paschim Khalisamari BO": "736121",
      "Uttarpatkapara BO": "736121",
      "Baruipara BO": "736207",
      "Damanpur BO": "736123",
      "Bhatibari BO": "736121",
      "Birpara Alipurduar BO": "736121",
      "Kumarijan BO": "736121",
      "Panchkolguri BO": "736121",
      "Paschim Shalbari BO": "736121",
      "Soudpara BO": "736121",
      "Tapshikhata BO": "736121",
      "Nangdala BO": "735204",
      "Parangerpar BO": "735211",
      "Talukertari BO": "735211",
      "Dimdima BO": "735204",
      "Jogendra Pur BO": "735211",
      "Tasati BO": "735204",
      "Tukra Jateswar BO": "735204",
      "Beltoli Bhandani BO": "735211",
      "Bhutnirghat BO": "735211",
      "Chuakhola BO": "735211",
      "Dakshin Parengarpar BO": "735211",
      "Raichenga BO": "735211",
      "Satpukuria BO": "735211",
      "Khagenhat BO": "735204",
      "Narsingpur BO": "735204",
      "Baganbari BO": "735211",
      "Dalimpur BO": "735211",
      "Mairadanga BO": "735211",
      "Ghagra BO": "736122",
      "Chalnirpak BO": "736121",
      "Chaparerpar BO": "736121",
      "Dakshin Patkapara BO": "736121",
      "Gharghariahat BO": "736121",
      "Hatidhura BO": "736121",
      "Purba Shalbari BO": "736207",
      "Radhanagar BO": "736207",
      "Bakshaduar BO": "735227",
      "Bhelukdabri BO": "736208",
      "Jasodanga BO": "736208",
      "Chepani BO": "736206",
      "Damsibad BO": "736206",
      "Dhaolajhora BO": "736206",
      "Bindipara BO": "736208",
      "Dakshin Dhalkar BO": "736208",
      "Dakshin Mahakalguri BO": "736206",
      "Kohinoor Tea Estate BO": "736206",
      "Panbari BO": "736206",
      "Majidkhana BO": "736208",
      "Tatpara BO": "736208",
      "Bakla Schooldanga BO": "736206",
      "Baniadabri BO": "736206",
      "Baniagaon BO": "736206",
      "Paschim Chepani BO": "736206",
      "Taleshwarguri BO": "736206",
      "Turturi BO": "736206",
      "Jainti BO": "735227",
      "Uttar Shibkhata BO": "736208",
      "Barachaukirbash BO": "736206",
      "Kadampur BO": "736206",
      "Alipurduar Junction SO": "736123",
      "Alipurduar Court SO": "736122",
      "Alipurduar New Town SO": "736121",
      "Barobisha SO": "736207",
      "Alipurduar SO": "736121",
      "Hatipotha SO": "736201",
      "Mathurabagan SO": "736204",
      "Rajabhatkhawa SO": "735227",
      "Madarihat SO": "735220",
      "Ramjhora SO": "735228",
      "Birpara SO": "735204",
      "Gopal Bagan SO": "735213",
      "Kalchini SO": "735217",
      "Kamaskhyaguri SO": "736202",
      "New Lands SO": "736205",
      "Dalshingpara SO": "735208",
      "Hamiltonganj SO": "735214",
      "Kumargramduar SO": "736203",
      "Panabasti SO": "735226",
      "Salsalabari SO": "736208",
      "Birpara Bazar SO": "735204",
      "Jateswar SO": "735216",
      "Falakata SO": "735211",
      "Hasimara SO": "735215",
      "New Market Jaigaon SO": "736182",
      "Saontalpur SO": "736206"
    },
    "24 PARAGANAS SOUTH": {
      "Burul BO": "743318",
      "Chak Kashipur BO": "743318",
      "Chak Alampur BO": "743318",
      "Chak Enayetnagar BO": "743503",
      "Chak Haturia BO": "743503",
      "Chandandaha BO": "743503",
      "Chandi BO": "743503",
      "Haranandapur BO": "743503",
      "Kalsa BO": "743503",
      "Kanganberia BO": "743503",
      "Makhna BO": "743503",
      "Mestakhali BO": "743503",
      "Pairachali BO": "743503",
      "Paschim Chamni BO": "743503",
      "Ramchandranagar BO": "743399",
      "Bakrabad BO": "743503",
      "Sukdebpur BO": "743503",
      "Amjharahat BO": "743329",
      "Atharobanki BO": "743329",
      "Bhangankhali BO": "743329",
      "Kanthalberia BO": "743329",
      "Khalisakhali BO": "743329",
      "Narayantala BO": "743329",
      "Nikarighata BO": "743329",
      "Paschim Dighirpar BO": "743329",
      "Phulmalancha BO": "743329",
      "Chandaneswar BO": "743330",
      "Gorerhat BO": "743372",
      "Keyatala BO": "743372",
      "Khakurdaha BO": "743372",
      "Gocharan BO": "743372",
      "Sarberia BO": "743372",
      "Bhagabatipur BO": "743399",
      "Bhatia BO": "743399",
      "Uttar Birampur BO": "743399",
      "Bhadura BO": "743504",
      "Gopalpurhat BO": "743504",
      "Jamira BO": "743504",
      "Karaiberia BO": "743504",
      "Kalatalahat BO": "743504",
      "Rajarampur BO": "743504",
      "Sadhurhat BO": "743504",
      "Sherpur BO": "743513",
      "Dhanurhat BO": "743336",
      "Dhopahat Krishnapur BO": "743336",
      "Dulalpur BO": "743336",
      "Gabberia BO": "743336",
      "Jadabpurhat BO": "743336",
      "Jeliabati BO": "743336",
      "Nilambarpur BO": "743336",
      "Panchnan BO": "743336",
      "Uttar Ballavpur BO": "743336",
      "Nodakhali BO": "743318",
      "Andharmanik BO": "743503",
      "Dakshin Bagi BO": "743503",
      "Dakshin Gouripur BO": "743503",
      "Domdoma BO": "743503",
      "Ghanashyambati BO": "700137",
      "Hentalkhali BO": "700137",
      "Sarengabad BO": "700137",
      "Shyampur BO": "700137",
      "Golabari BO": "743329",
      "Herobhanga BO": "743329",
      "Kalikatala BO": "743329",
      "Kalikapur BO": "743330",
      "Chimta BO": "743378",
      "Dakshin Radhanagar BO": "743378",
      "Kalidaspur BO": "743378",
      "Kumirmari BO": "743378",
      "Paschim Radhanagar BO": "743378",
      "Puinjali BO": "743378",
      "Nabagram BO": "743372",
      "Srikrishnanagar BO": "743372",
      "Surajapurhat BO": "743372",
      "Tasarala BO": "743372",
      "Chandipur BO": "743399",
      "Dakshin Jagadishpur BO": "743399",
      "Durganagar BO": "743399",
      "Harindanga BO": "743399",
      "Harinkhola BO": "743399",
      "Imamuddipur BO": "743399",
      "Jumainaskar BO": "743399",
      "Konchfal BO": "743399",
      "Ramdebpur BO": "743399",
      "Anatarampur BO": "743504",
      "Belsinga BO": "743504",
      "Seorahati BO": "743504",
      "Banganagar BO": "743513",
      "Anchna BO": "743336",
      "Anwarpur BO": "743336",
      "Dongaria BO": "743318",
      "Mayapur BO": "743318",
      "Rania Gobindapur BO": "743318",
      "Balakhali BO": "743503",
      "Betberia BO": "743503",
      "Chandpala BO": "743503",
      "Dakshin Alipore BO": "743503",
      "Dighirpar Bazar BO": "743503",
      "Dosatina BO": "743503",
      "Gandhabaduli BO": "743503",
      "Ghorahata Mukundapur BO": "743503",
      "Kanyanagar BO": "743503",
      "Rania BO": "700154",
      "Buinta BO": "700137",
      "Uttar Raipur BO": "700137",
      "Bawali BO": "700137",
      "Charavidya BO": "743329",
      "Dongajora BO": "743329",
      "Jogendranagar BO": "743329",
      "Joyramkhali BO": "743329",
      "Kailashnagar BO": "743329",
      "Madhukhali BO": "743329",
      "Meraganj BO": "743329",
      "Uttar Moukhali BO": "743329",
      "Kustia BO": "743330",
      "Pratapnagar BO": "743330",
      "Tarda Kapasati BO": "743330",
      "Amtali Bazar BO": "743378",
      "Nathpara BO": "743378",
      "Purba Radhanagar BO": "743378",
      "Banasundaria BO": "743372",
      "Satjelia BO": "743370",
      "Satyanarayanpur BO": "743370",
      "Uttardanga BO": "743370",
      "Madhya Shibpur BO": "743372",
      "Punpua BO": "743372",
      "Bohalberia BO": "743399",
      "Dakshin Gangadharpur BO": "743399",
      "Malaya BO": "743399",
      "Shibnagar BO": "743399",
      "Srinarayanpur BO": "743399",
      "Chaberia BO": "743504",
      "Nainan BO": "743504",
      "Panarhat BO": "743504",
      "Sahararhat BO": "743504",
      "Aushberia BO": "743513",
      "Chaluary BO": "743513",
      "Jafarpur BO": "743513",
      "Serakole BO": "743513",
      "Baidyahat BO": "743336",
      "Bidyadharpur BO": "743336",
      "Ramlochanpur BO": "743336",
      "Siddheswarpur BO": "743336",
      "Sadhu Pur BO": "743370",
      "Santi Gachi BO": "743370",
      "Amtala BO": "743337",
      "Chaltaberia BO": "743337",
      "Charaghata BO": "743337",
      "Monipur Banstala BO": "743337",
      "Shyamnagar Gobindapur BO": "743337",
      "Bakultala BO": "743349",
      "Purnachandrapur BO": "743349",
      "Radhaballavpur BO": "743349",
      "Ramnagarabad BO": "743349",
      "Saratpally BO": "743349",
      "Sridurgapur BO": "743349",
      "Mirpur Daulatpur BO": "743610",
      "Moukhali BO": "743610",
      "Multi BO": "743610",
      "Purandarpur Math BO": "743610",
      "Raskhali BO": "743610",
      "Jalkhura BO": "700141",
      "Maheshtala Gobindapur BO": "700141",
      "Raipur BO": "700141",
      "Vivekanandapur BO": "700141",
      "Gangrai BO": "700145",
      "Mallickpore BO": "700145",
      "Khojkhidir BO": "743354",
      "Purkaitpara BO": "743354",
      "Radhakantapur BO": "743354",
      "Tajpur BO": "743354",
      "Dakshin Bijoynagar BO": "743338",
      "Gopalganj Hat BO": "743338",
      "Jalaberia BO": "743338",
      "Dhalua BO": "700152",
      "Gopalkata BO": "743611",
      "Jhowkhali BO": "743611",
      "Begampur BO": "743387",
      "Brindakhali BO": "743387",
      "Dhapdhapi BO": "743387",
      "Baikunthapur BO": "743383",
      "Bhubaneswari Bazar BO": "743383",
      "Goalara BO": "743383",
      "Heramba Gopalpur BO": "743383",
      "Jata Jogendrapur BO": "743383",
      "Kankandighi BO": "743383",
      "Hadia BO": "700150",
      "Uchhepota BO": "700150",
      "Bazarberia BO": "743395",
      "Chaitanyapur BO": "743395",
      "Chandpur BO": "743395",
      "Belegachi BO": "743376",
      "Bhalleya BO": "743376",
      "Chandkhali BO": "743376",
      "Chatra Maldari BO": "743337",
      "Futigoda BO": "743337",
      "Mayahauri BO": "743337",
      "Rajapur Karabeg BO": "743337",
      "Tilpi BO": "743337",
      "Dhosa BO": "743337",
      "Baburchak BO": "743349",
      "Chuprijhara BO": "743349",
      "Dakshin Raipur No 3 BO": "743349",
      "Deulbari BO": "743349",
      "Khari BO": "743349",
      "Madhabpur BO": "743349",
      "Pakurtala BO": "743349",
      "Purba Sonatikari BO": "743349",
      "Sonatikary BO": "743349",
      "Kautala BO": "743349",
      "Indrapala BO": "743610",
      "Kundarali BO": "743610",
      "Sankarpur BO": "743610",
      "Tentulia BO": "743610",
      "Ashuti BO": "700141",
      "Chakjot Shibrampur BO": "700141",
      "Dakshin Gobindapur BO": "700145",
      "Dahakanda BO": "743354",
      "Nalua BO": "743354",
      "Panapukur BO": "743354",
      "Saratnagar BO": "743354",
      "Bakultalahat BO": "743338",
      "Japtala BO": "743338",
      "Kholakhali Hat BO": "743338",
      "Thakurchak BO": "743338",
      "Chunakhali BO": "743611",
      "Bhangar Chaltaberia BO": "743502",
      "Bhangar Gobindapur  BO": "743502",
      "Bhangar Narayanpur BO": "743502",
      "Bantra BO": "743337",
      "Bele Durganagar BO": "743337",
      "Kamaria BO": "743337",
      "Kripakhali BO": "743337",
      "Maydah BO": "743337",
      "Barashi BO": "743349",
      "Baribhanga Abad BO": "743349",
      "Biswanathpur BO": "743349",
      "Digambarpur BO": "743349",
      "Gheri Keorakhali BO": "743349",
      "Gheri Raipur BO": "743349",
      "Gurudaspur BO": "743349",
      "Kailaspur BO": "743349",
      "Madhya Gurguria BO": "743349",
      "Madhya Monirtat BO": "743349",
      "Manirtat BO": "743349",
      "Meherpur BO": "743349",
      "Bhubankhali BO": "743349",
      "Baharu Ramkrishnapur BO": "743610",
      "Chakparan Kantakhali BO": "743610",
      "Dhamua BO": "743610",
      "Durgapur Baruipur BO": "743610",
      "Balarampur BO": "743354",
      "Ghoradah BO": "743354",
      "Gilarchat BO": "743354",
      "Kayalerchak BO": "743354",
      "Lalpur BO": "743373",
      "Bonhooghly BO": "700103",
      "Nepalganj BO": "700103",
      "Chhotrisher Hat BO": "743338",
      "Koabati BO": "743338",
      "Kultali BO": "743338",
      "Naskarpara Jalaberia BO": "743338",
      "Purba Ranaghata BO": "743338",
      "Taltala BO": "743338",
      "Tangrabichi BO": "743338",
      "Bat Tali BO": "743611",
      "South Ramnagar BO": "743387",
      "Baruipur Bazar BO": "743387",
      "Achintanagar BO": "743383",
      "Kedarpur BO": "743383",
      "Kishorimohanpur BO": "743383",
      "Nagendrapur BO": "743383",
      "Narayanipur BO": "743383",
      "Paschim Jata BO": "743383",
      "Paschim Sripatinagar BO": "743383",
      "Pranballavpur BO": "743395",
      "Kamakshyapur BO": "743611",
      "Purba Boyarsingh BO": "743611",
      "Ramgopalpur BO": "743387",
      "Sitakundu BO": "743387",
      "Purba Nischintapur BO": "700138",
      "Dakshin Kashinagar BO": "743383",
      "Damkal BO": "743383",
      "Kuemuri BO": "743383",
      "Nagenabad BO": "743383",
      "Purba Dwarikapur BO": "743383",
      "Uttar Kankandighi BO": "743383",
      "Kamrabad BO": "700150",
      "Nayabad BO": "700150",
      "RAMKRISHNA PALLY BO": "700150",
      "Digberia BO": "743395",
      "Mandir Bazar BO": "743395",
      "Debisabad BO": "743376",
      "Beonta BO": "743502",
      "Chandibari BO": "743502",
      "Dharmatala Panchuria BO": "743502",
      "Kulberia BO": "743502",
      "Shankshar BO": "743502",
      "Muchisa BO": "743377",
      "Sonaria Naiya BO": "743377",
      "Narayanpur BO": "743363",
      "Harbhangi BO": "743329",
      "Hironmoypur BO": "743312",
      "Joygopalpur Natunhat BO": "743312",
      "Nafarganj BO": "743312",
      "Sonakhali BO": "743312",
      "Khagramuri BO": "700140",
      "Dakshin Raipur BO": "743318",
      "Kamra BO": "743318",
      "Poali BO": "743318",
      "Bargagan Gohalia BO": "743503",
      "Bhataria BO": "743503",
      "Charashyamdas BO": "743503",
      "Doulatabad BO": "743503",
      "Gotalahat Krishnapur BO": "743503",
      "Kaikhali Boinchbati BO": "743503",
      "Uttar Kasthamahal BO": "743503",
      "Bawali Chandipur BO": "700137",
      "Boria BO": "743368",
      "Daharani BO": "743329",
      "Kachiamara BO": "743329",
      "Kumrakhali BO": "743329",
      "Matherdighi BO": "743329",
      "Tengrakhali BO": "743329",
      "Titkumar BO": "743329",
      "Noridana BO": "743330",
      "Amtali BO": "743378",
      "Bara Mollakhali BO": "743378",
      "Kumirmari Narendrapur BO": "743378",
      "Taranagar BO": "743399",
      "Baharu BO": "743372",
      "Kashimpur BO": "743372",
      "Dingelpota BO": "700151",
      "Bahirchak BO": "743399",
      "Bhajna Benepara BO": "743399",
      "Bhagabanpur BO": "743399",
      "Raghudebpur BO": "743399",
      "Ramchandrapur BO": "743399",
      "Siddhiberia BO": "743399",
      "Bishra BO": "743504",
      "Dostipur BO": "743504",
      "Mohirampur BO": "743504",
      "Puratan Ramgarh BO": "743504",
      "Hasimnagar BO": "743513",
      "Iyarpur BO": "743513",
      "Pikhira BO": "743513",
      "Sitalatala Rajarampur BO": "743513",
      "Barakaipukur BO": "743336",
      "Bireswarpur BO": "743336",
      "Gazipur BO": "743336",
      "Purba Chandpur BO": "743336",
      "Roypur Dayarampur BO": "743336",
      "Amgachia BO": "700104",
      "Rasapunja BO": "700104",
      "Doltalaghola BO": "743376",
      "Memanpur Chandannagar BO": "700139",
      "Beramara BO": "743609",
      "Maheshdari BO": "743609",
      "Bardrone BO": "743332",
      "Bhubannagar BO": "743347",
      "Dakshin Khasiabad BO": "743347",
      "Ganeshpur Baikunthapur BO": "743347",
      "Gangadharganj BO": "743347",
      "Harendranagar BO": "743347",
      "Paschim Surendranagar BO": "743347",
      "Rajnagar BO": "743347",
      "Belpukur BO": "743348",
      "Dakshin Rajarampur BO": "743348",
      "Ramkrishnapur BO": "743351",
      "Sitarampur BO": "743351",
      "Alida BO": "743355",
      "Benipur BO": "743355",
      "Dhanyaghata BO": "743355",
      "Kadipukur BO": "743355",
      "Maitala BO": "743355",
      "Mallick Pratap BO": "743355",
      "Gokarnee BO": "743355",
      "Ghoramara Mandirtala BO": "743356",
      "Dakshin Chandannagar BO": "743357",
      "Ganeshnagar BO": "743357",
      "Kusumtala BO": "743357",
      "Madanganj BO": "743357",
      "Basar BO": "743374",
      "Ramnagar Shibpur BO": "743374",
      "Shibkalinagar BO": "743374",
      "Surjanagar BO": "743374",
      "Baradapur BO": "743371",
      "Buraburirtat BO": "743371",
      "Daspur BO": "743371",
      "Gobindapur Abad BO": "743371",
      "Kamdebpur BO": "743371",
      "Krishnadaspur BO": "743371",
      "Bamankhali BO": "743373",
      "Chemaguri BO": "743373",
      "Dakshin Haradhanpur BO": "743373",
      "Kamalpur BO": "743609",
      "Khasmahal BO": "743373",
      "Khansahebabad BO": "743373",
      "Natendrapur BO": "743373",
      "Prasad Pur BO": "743373",
      "Sagar Bag Bazar BO": "743373",
      "Sapkhali BO": "743373",
      "Sumatinagar BO": "743373",
      "Abdalpur BO": "743368",
      "Goanara Gobindapur BO": "743368",
      "Maheswara BO": "743368",
      "Noorpur BO": "743368",
      "Bali Hatkhola BO": "743370",
      "Chargheri BO": "743370",
      "Parash Moni BO": "743370",
      "Rangabelia BO": "743370",
      "Banerjee Chak BO": "743337",
      "Ramchandrapur Chak Thakurani BO": "700104",
      "Bhangar Raghunathpur BO": "743502",
      "Bhojerhat BO": "743502",
      "Iswaripur BO": "743502",
      "Joypur  BO": "743502",
      "Kantatala BO": "743502",
      "Mallikati BO": "743502",
      "Aryapara BO": "743377",
      "Chowl Khola BO": "743377",
      "Kalaria BO": "743363",
      "Anandabad BO": "743312",
      "Bharatgarh BO": "743312",
      "Dakshin Mokamberia BO": "743312",
      "Jyotishpur BO": "743312",
      "Mokamberia BO": "743312",
      "Chatakalikapur BO": "700140",
      "Jagannathnagar BO": "700140",
      "Nungi BO": "700140",
      "Par Bangla BO": "700140",
      "Paschim Rameswarpur BO": "700140",
      "Amlamethi BO": "743370",
      "Arampur BO": "743370",
      "Bijoynagar BO": "743370",
      "Jalghara BO": "743609",
      "Kalash BO": "743609",
      "Daria BO": "743332",
      "Ghatakpur BO": "743332",
      "Gumukberia BO": "743332",
      "Mahishamuri BO": "743332",
      "Durba Chati BO": "743347",
      "Fatickpur BO": "743347",
      "Ganeshpur 1st Gheri BO": "743347",
      "Ganeshpur 4th Gheri BO": "743347",
      "Jaharpur BO": "743347",
      "Mrinalnagar BO": "743347",
      "Muchikata Baikunthapur BO": "743347",
      "Mundapara Kashiabad BO": "743347",
      "Jamtala BO": "743348",
      "Keoratala BO": "743348",
      "Seoratala BO": "743348",
      "Enayetpur BO": "743351",
      "Dhanpota BO": "743355",
      "Haripur BO": "743357",
      "Jugdia BO": "743355",
      "Morapai BO": "743355",
      "Purba Ramnathpur BO": "743355",
      "Sangrampur Hat BO": "743355",
      "Tekpanja BO": "743355",
      "Urel Chandpur BO": "743355",
      "Srinagar Makarpara BO": "743374",
      "Banashyamnagar BO": "743371",
      "Bhagabatpur Project": "743371",
      "Choto Banashyamnagar BO": "743371",
      "Madhabnagar Durgagobindapur BO": "743371",
      "Rakhal Pur BO": "743371",
      "Rakshashkhali BO": "743371",
      "Ramganga BO": "743371",
      "Shibgobindapur BO": "743371",
      "Sridharnagar BO": "743371",
      "Purba Gopalnagar BO": "743395",
      "Ramakantanagar BO": "743395",
      "Satghara Debipur BO": "743395",
      "Suta Becha BO": "743395",
      "Beniabow BO": "743613",
      "Uttarsitaram Pur BO": "743371",
      "Companir Char BO": "743373",
      "Kalitala Daspur BO": "743373",
      "Kirtankhali BO": "743373",
      "Mrityunjoynagar BO": "743373",
      "Nagendraganj BO": "743373",
      "Narayanibad BO": "743373",
      "Sagar Chandipur BO": "743373",
      "Sagar Fulbari BO": "743373",
      "Basuldanga BO": "743368",
      "Nawasa BO": "743368",
      "Netra BO": "743368",
      "Panchagram Singhberia BO": "743368",
      "Chitraganj BO": "743337",
      "Dara BO": "743337",
      "Dewanchak BO": "743337",
      "Khaizamara BO": "743337",
      "Sastitala BO": "743337",
      "Boyergodi BO": "743349",
      "Chapla BO": "743349",
      "Dakshin Durgapur BO": "743349",
      "Dakshin Shibpur BO": "743349",
      "Katamari BO": "743349",
      "Kumarpur BO": "743349",
      "Madhusudanchak BO": "743349",
      "Nandakumarpur BO": "743349",
      "Paschim Radhaballavpur BO": "743349",
      "Purandarpur BO": "743349",
      "Hotor BO": "743610",
      "Kalinagar BO": "743610",
      "South Mohanpur BO": "743610",
      "Boga Noapara BO": "700141",
      "Gonipur BO": "700141",
      "Bamangachi BO": "700145",
      "Bairagir Chak BO": "743354",
      "Batiswar BO": "743354",
      "Ghoserpole BO": "743354",
      "Krishnachandrapur BO": "743354",
      "Nayabad Rajpur BO": "743354",
      "Paschim Kultali BO": "743354",
      "Uttar Lakshminarayanpur BO": "743354",
      "Baishata BO": "743338",
      "Boinchbati BO": "743338",
      "Kaikhali Ashram BO": "743338",
      "Keorakhali BO": "743338",
      "Batakhali Chandipur BO": "743611",
      "Bodra BO": "743502",
      "Kalahazra BO": "743312",
      "Masjidbati BO": "743312",
      "Matgaran BO": "743312",
      "Akra Krishnanagar BO": "700140",
      "Kashipur BO": "743345",
      "Krishnanagar BO": "743345",
      "Bahirkunja BO": "743318",
      "Paulpur BO": "743611",
      "Sambhunagar BO": "743611",
      "Kumarhat BO": "743387",
      "Sikharbali BO": "743387",
      "Achhipur BO": "700138",
      "Benjanharia BO": "700138",
      "Binodpur Ambikanagar BO": "743383",
      "Debipur BO": "743383",
      "Jata BO": "743383",
      "Kumrapara BO": "743383",
      "Lakshmi Janardanpur BO": "743383",
      "Purba Sridharpur BO": "743383",
      "Chowhati BO": "700149",
      "Khayada BO": "700150",
      "Kecharkur Gopalnagar BO": "743395",
      "Chhayani BO": "743376",
      "Dhalirbati BO": "743376",
      "Dulki BO": "743370",
      "Harishpur Ramnagar BO": "743370",
      "Jahar Colony BO": "743370",
      "Kachukhali BO": "743370",
      "Lahiri Pur BO": "743370",
      "Luxbagan BO": "743370",
      "Manmathanagar M BO": "743370",
      "Nahazari BO": "700104",
      "Pailanhat BO": "700104",
      "Khaskumrakhali BO": "743376",
      "Nagartala BO": "743376",
      "Thakuraniberia BO": "743376",
      "Rangilabad BO": "743609",
      "Narayanpur Gouripur BO": "743332",
      "Ramanandapur BO": "743332",
      "Sultanpur BO": "743332",
      "Uttar Rajarampur BO": "743332",
      "Akshoynagar BO": "743347",
      "Bijannagar BO": "743347",
      "Budhakhali BO": "743347",
      "Dakshin Gopalnagar BO": "743347",
      "Kakdwip Kalinagar BO": "743347",
      "Manmathapur BO": "743347",
      "Uttar Gopalnagar BO": "743347",
      "Tengrarchar BO": "743348",
      "Khonkarbazar BO": "743355",
      "Lakshmikantapur BO": "743355",
      "Magrahat Shyampur BO": "743355",
      "Maheshpur BO": "743355",
      "Baliara BO": "743357",
      "Debnagar BO": "743357",
      "Durgapur Tekarbazar BO": "743357",
      "Dwariknagar BO": "743357",
      "Namkhana Radhanagar BO": "743357",
      "Patibunia BO": "743357",
      "Rajnagar Biswambhar BO": "743357",
      "Shibrampur BO": "743357",
      "Freser Ganj BO": "743357",
      "Dakshin Rajnagar BO": "743374",
      "Gazirmahal Chitamari BO": "743374",
      "Manicknagar BO": "743374",
      "Ramtanunagar BO": "743374",
      "Ramratanpur BO": "743374",
      "Dhablat Shibpur BO": "743373",
      "Dihimathurapur Gobindapur BO": "743373",
      "Harinbari BO": "743373",
      "Jibantala BO": "743373",
      "Kachuberia BO": "743373",
      "Mandirtala BO": "743373",
      "Sagar Bishnupur BO": "743373",
      "Muri Ganga BO": "743373",
      "Gangasagar BO": "743373",
      "Chandnagar BO": "743368",
      "Darikrishna Nagar BO": "743368",
      "Kodalia Shibpur BO": "743368",
      "Morigachi BO": "743368",
      "Bamunia  BO": "743502",
      "Chakborali BO": "743502",
      "Deuli BO": "743502",
      "Krishnamati BO": "743502",
      "Shanpukur BO": "743502",
      "Uttar Madhabpur BO": "743502",
      "Patharberia BO": "743377",
      "Gourdaha BO": "743363",
      "Jharkhali Bazar BO": "743312",
      "Shibganj BO": "743312",
      "Bangla BO": "700140",
      "Dayapur BO": "743370",
      "Jamespur BO": "743370",
      "Kachukhali  Ramnagar Bazar BO": "743370",
      "Pakhiralaya BO": "743370",
      "Jibantala Sarangabad BO": "743376",
      "Daulatpur BO": "700139",
      "Dodalia BO": "743609",
      "Kuldia BO": "743609",
      "Maheshwara BO": "743609",
      "Naria BO": "743609",
      "Barandari Bagaria BO": "743332",
      "Manoharpur BO": "743332",
      "Radhanagar BO": "743332",
      "Uttar Mukundapur BO": "743332",
      "Bamanagar BO": "743347",
      "Bishalakshmipur BO": "743347",
      "Gobindarampur BO": "743347",
      "Pukurberia BO": "743347",
      "Takipurabad BO": "743347",
      "Paschim Gopalnagar BO": "743351",
      "Shyambasurchak BO": "743351",
      "Bamna BO": "743355",
      "Kalikapota BO": "743355",
      "Maitirhat BO": "743355",
      "Magrahat Shyamnagar BO": "743355",
      "Bagdanga BO": "743357",
      "Chandanpiri BO": "743357",
      "Debnibas BO": "743357",
      "Lakshmipur Pabartak BO": "743357",
      "Maharajganj BO": "743357",
      "Shibnagar Abad BO": "743357",
      "Aswathtala BO": "743374",
      "Dakshin Chandipur BO": "743374",
      "Madhabnagar BO": "743374",
      "Raghunathpur BO": "743374",
      "Tepakhali BO": "743374",
      "Brajaballav Pur BO": "743371",
      "Indrapur BO": "743371",
      "Jogindrapur BO": "743371",
      "Khetramohan Pur BO": "743371",
      "Beguakhali BO": "743373",
      "Chakfuldubi BO": "743373",
      "Haradhan Pur BO": "743373",
      "Khasramkarchak BO": "743373",
      "Mahendraganj BO": "743373",
      "Radhakrishnapur BO": "743373",
      "Sagar Barabari BO": "743373",
      "Sagar Krishna Nagar BO": "743373",
      "Sagar Shibpur BO": "743373",
      "Mansadwip BO": "743373",
      "Amira BO": "743368",
      "Kamarpole BO": "743368",
      "Kholakhali BO": "743368",
      "Mathur BO": "743368",
      "Mukundapur BO": "743368",
      "Patra BO": "743368",
      "Hatisala BO": "700135",
      "Polarhat BO": "700135",
      "Satbhaya BO": "700135",
      "Paikan BO": "700135",
      "Sonepur BO": "700135",
      "Uttar Kashipur BO": "700135",
      "Machibhanga BO": "700135",
      "Pakka Polarhat BO": "700135",
      "Pithapukuria BO": "700135",
      "Shyamnagar BO": "700135",
      "Narabunia BO": "743425",
      "Kensilly BO": "743375",
      "Masat BO": "743375",
      "Rasa Dogacha BO": "743375",
      "Kuleswar BO": "743375",
      "Nazra BO": "743375",
      "Sarachi BO": "743375",
      "Uttar Kusum BO": "743375",
      "Baruipur HO": "700144",
      "Baneswarpur BO": "743375",
      "Borijpur BO": "743375",
      "Boinchberia BO": "743375",
      "Diamond Harbour HO": "743331",
      "Ghateswar SO": "743336",
      "Kashinagar SO South 24 Parganas": "743349",
      "Madarat SO": "743610",
      "Mathura Pur SO": "743354",
      "Narendrapur SO": "700103",
      "Panchpota SO": "700152",
      "Pujali SO": "700138",
      "Subhas Gram SO": "700147",
      "Kakdwip SO": "743347",
      "Kulpi SO": "743351",
      "Mud Point SO": "743356",
      "Fatehpur SO South 24 Parganas": "743513",
      "Gosaba SO": "743370",
      "Harinavi SO": "700148",
      "Joynagar Majilpur SO": "743337",
      "Kalibari Temple SO": "700070",
      "Kamda Hari SO": "700084",
      "Kodalia SO": "700146",
      "Mahestala SO": "700141",
      "Mathurapur RS SO": "743354",
      "Piyali Town SO": "743387",
      "Rajpur SO South 24 Parganas": "700149",
      "Sonarpur SO": "700150",
      "South Garia SO": "743613",
      "Fakir Chand College SO": "743331",
      "Hatuganj SO": "743332",
      "Magrahat SO": "743355",
      "Nam Khana SO": "743357",
      "IIM Joka SO": "700104",
      "Joka SO": "700104",
      "Garia SO South 24 Parganas": "700084",
      "Malancha Mahinagar SO": "700145",
      "Raidighi SO": "743383",
      "Rajpur Bazar SO": "700149",
      "Santosh Pur Maheshtalaso SO": "700142",
      "Dakshin Hazi Pur SO": "743331",
      "Karanjali SO": "743348",
      "Nishchinta Pur SO": "743374",
      "Pathar Pratima SO": "743371",
      "Falta SO": "743504",
      "Garia Garden SO": "700084",
      "Laskar Pur SO": "700153",
      "Nimpith Ashram SO": "743338",
      "Pathan Khali SO": "743611",
      "Purba Putiary SO": "700093",
      "Sarkarpool SO": "700143",
      "South Bishnupur SO": "743395",
      "Taldi SO": "743376",
      "Vivekananda Pally SO": "700139",
      "Diamond Harbour CC SO": "743331",
      "Diamond Harbour New Town SO": "743331",
      "Diamond Harbour RS SO": "743331",
      "Hansuri SO": "743609",
      "Rudra Nagar SO": "743373",
      "Sarisha SO": "743368",
      "Usthi SO": "743375",
      "Canning Town Ferry Ghat SO": "743329",
      "Bhangar SO": "743502",
      "Basanti SO": "743312",
      "Batanagar SO": "700140",
      "Birlapur SO": "743318",
      "Boral SO": "700154",
      "Canning Town SO": "743329",
      "Bakrahat SO": "743377",
      "Bishnupur SO South 24 Parganas": "743503",
      "Brahmapur SO": "700096",
      "Budge Budge SO Hsgii SO": "700137",
      "Dakshin Jagatdal SO": "700151",
      "Bansra SO": "743363",
      "Bijoyganj Bazar SO": "743345",
      "Budge Budge Natun Bazar SO": "700137",
      "Champahati SO": "743330",
      "Chhoto Mollakhali SO": "743378",
      "Dakshin Barasat SO": "743372",
      "Dholahat SO": "743399"
    },
    "Jhargram": {
      "Dumuria Sirisboni BO": "721135",
      "Keshiapada BO": "721135",
      "Baharadari BO": "721143",
      "Bonpura BO": "721143",
      "Kankrajhore BO": "721501",
      "Kodapura BO": "721501",
      "Odalchua BO": "721501",
      "Orali BO": "721501",
      "Patharchakri BO": "721501",
      "Daichakuria BO": "721503",
      "Bhaturkadamdiha BO": "721503",
      "Kanimohuli BO": "721503",
      "Kismatjamboni BO": "721503",
      "Parsuli BO": "721503",
      "Harda BO": "721504",
      "Jashpur BO": "721504",
      "Amlatora BO": "721505",
      "Benasuli BO": "721505",
      "Dharsa BO": "721505",
      "Parihati BO": "721505",
      "Asui BO": "721506",
      "Athangi BO": "721506",
      "Bakra BO": "721506",
      "Chhatinasole BO": "721506",
      "Dhansole BO": "721506",
      "Ghatiara BO": "721506",
      "Bakrachak BO": "721135",
      "Pathra BO": "721135",
      "Narda BO": "721143",
      "Aguibil BO": "721501",
      "Bamundiha BO": "721501",
      "Banspahari BO": "721501",
      "Chakadoba BO": "721501",
      "Tulibarh BO": "721503",
      "Muraboni BO": "721504",
      "Tilaboni BO": "721504",
      "Kapgari BO": "721505",
      "Khatkhura BO": "721505",
      "Basanda BO": "721506",
      "Patina BO": "721506",
      "Phulbani BO": "721506",
      "Sumitrapur BO": "721506",
      "Chhorda BO": "721135",
      "Laudaha BO": "721135",
      "Andhari BO": "721143",
      "Bachhurkhoyar BO": "721143",
      "Borsole BO": "721501",
      "Charakpahari BO": "721501",
      "Chandri BO": "721503",
      "Akanischintapur BO": "721504",
      "Bhandaru BO": "721504",
      "Korkora BO": "721504",
      "Ranarani BO": "721504",
      "Dubra BO": "721505",
      "Ergoda BO": "721505",
      "Bhila BO": "721506",
      "Charchita BO": "721506",
      "Kendugari BO": "721506",
      "Mahulboni BO": "721506",
      "Sibadumuria BO": "721506",
      "Swargachira BO": "721506",
      "Janaghati BO": "721506",
      "Saria BO": "721506",
      "Bamal BO": "721516",
      "Belatikri BO": "721516",
      "Dharampur BO": "721516",
      "Tufuria Kamalpur BO": "721159",
      "Chunpara BO": "721135",
      "Andhari Maubhandar BO": "721143",
      "Bhulaveda BO": "721501",
      "Sandapara BO": "721501",
      "Thakurnpahari BO": "721501",
      "Balidiha BO": "721503",
      "Chichra BO": "721503",
      "Ghutia BO": "721503",
      "Andharia BO": "721504",
      "Dumuria BO": "721505",
      "Kadodiha BO": "721505",
      "Alampur BO": "721506",
      "Asanboni BO": "721506",
      "Chamarbandh BO": "721506",
      "Kortia BO": "721506",
      "Narasimul BO": "721506",
      "Rambhagawan BO": "721506",
      "Sasra BO": "721506",
      "Bhimpur BO": "721516",
      "Kalaimuri BO": "721516",
      "Banskuthi BO": "721125",
      "Dolgram BO": "721125",
      "Kuldiha BO": "721125",
      "Paika BO": "721125",
      "Nekrasole BO": "721159",
      "Chilkipada BO": "721125",
      "Dhumsai BO": "721125",
      "Morchi BO": "721125",
      "Nagripada BO": "721125",
      "Kalmapukhuria BO": "721159",
      "Nayagram BO": "721159",
      "Chandabila BO": "721125",
      "Jharia BO": "721159",
      "Banisole BO": "721125",
      "Baranegui BO": "721125",
      "Dokra BO": "721125",
      "Satpautia BO": "721125",
      "Amdoi BO": "721513",
      "Barkand Ramchandrapur BO": "721513",
      "Burimole BO": "721513",
      "Bodhna BO": "721514",
      "Jhargram Rajbati BO": "721514",
      "Jorakhali BO": "721514",
      "Pukuria BO": "721514",
      "Bhangabandh BO": "721515",
      "Bhelaidiha BO": "721515",
      "Aguiboni BO": "721517",
      "Amdapal BO": "721517",
      "Belia Bhutkahalia BO": "721517",
      "Jhariabandhgora BO": "721517",
      "Jorananda BO": "721517",
      "Jugdiha BO": "721517",
      "Kaima BO": "721517",
      "Ragra BO": "721517",
      "Nepura BO": "721121",
      "Sijua BO": "721121",
      "Kharikasuli BO": "721516",
      "Chingurkasa BO": "721513",
      "Dudhkundi BO": "721513",
      "Joypur BO": "721513",
      "Kharbandi BO": "721513",
      "Montipa Mohanpur BO": "721513",
      "Rajabasa BO": "721513",
      "Sindurgoura BO": "721513",
      "Bandgora BO": "721514",
      "Garh Salboni BO": "721514",
      "Chhotosukjora BO": "721515",
      "Sahari BO": "721515",
      "Baghuasole BO": "721517",
      "Gurmabhamal BO": "721517",
      "Jahanpur BO": "721517",
      "Kalinja BO": "721517",
      "Kharikamathani SO": "721159",
      "Chilkigarh SO": "721503",
      "Dahijuri SO": "721504",
      "Raghunathpur SO West Midnapore": "721507",
      "Sevayatan SO": "721514",
      "Madhupur BO": "721516",
      "Gajasimul BO": "721513",
      "Khalseuli BO": "721513",
      "Noharia BO": "721513",
      "Birihandi BO": "721514",
      "Binpur BO": "721514",
      "Diasi BO": "721515",
      "Muniada BO": "721515",
      "Ambi BO": "721517",
      "Balipal BO": "721517",
      "Beliabera BO": "721517",
      "Dhadangri BO": "721517",
      "Kanpursalbani BO": "721517",
      "Laupara BO": "721517",
      "Rantua BO": "721517",
      "Kukrakhupi BO": "721517",
      "Banpukuria BO": "721121",
      "Kantapahari BO": "721121",
      "Lachipur BO": "721121",
      "Gopi Ballavpur SO": "721506",
      "Lalgarh SO West Midnapore": "721516",
      "Silda SO": "721515",
      "Netai BO": "721516",
      "Purnapani BO": "721516",
      "Jhantibandh BO": "721513",
      "Kismat Dhangori BO": "721513",
      "Lodhasuli BO": "721513",
      "Mahim Nischinda BO": "721513",
      "Ashakanthi BO": "721515",
      "Malincha BO": "721517",
      "Petbindi BO": "721517",
      "Baligeria SO": "721125",
      "Kultikri SO": "721135",
      "Gidni SO": "721505",
      "Jamda SO West Midnapore": "721507",
      "Manikpara SO": "721513",
      "Tapsia SO": "721517",
      "Ramgarh SO West MidnapoBO": "721128",
      "Rohini SO": "721143",
      "Belpahari SO": "721501",
      "Jhargram HO": "721507"
    },
    "24 PARAGANAS NORTH": {
      "Fokirtakia Sarberiahat BO": "743329",
      "Jeliakhali Paschimkhanda BO": "743329",
      "Rampur BO": "743329",
      "Agarhati BO": "743329",
      "Barajonepur BO": "743145",
      "Chandua BO": "743145",
      "Majhipara BO": "743145",
      "Saliadaha BO": "743145",
      "Keotia BO": "743126",
      "Gurdah BO": "743127",
      "Mondalpara BO": "743127",
      "Chandpur Leningarh BO": "700110",
      "D P Nagar BO": "700083",
      "Arjunpur BO": "700059",
      "Chakpanchuria BO": "700156",
      "Daudpur Hatkhola BO": "743611",
      "Gabberia Daudpur BO": "743611",
      "Palashi BO": "743145",
      "Kushdanga BO": "743126",
      "Narayanpur BO": "700136",
      "Padmalavpur BO": "743126",
      "Puranandapally BO": "743165",
      "Beraberia BO": "700121",
      "Suryapur BO": "700121",
      "Purbabidyadharpur BO": "743127",
      "Kamarganti BO": "743502",
      "Kulti Lock Gate BO": "743502",
      "Sonapukur BO": "743502",
      "Jugberia BO": "700110",
      "Basudebpur BO": "700083",
      "Ghuni BO": "743426",
      "Hatgacha BO": "700156",
      "Mahishbathan BO": "700156",
      "Hishabi BO": "743221",
      "Baksha BO": "743232",
      "Chandpur BO": "700135",
      "Malidah BO": "743232",
      "Barnaberia BO": "743235",
      "Kalupur BO": "743235",
      "Puratan Bongaon BO": "743235",
      "Jesur Jeoldanga BO": "743233",
      "Laxmipul BO": "743234",
      "Baikara BO": "743245",
      "Dogachhia Monmohanpur BO": "743245",
      "Goalbathan BO": "743245",
      "Kaipukuria BO": "743245",
      "Mothuadham Mondalpara BO": "743245",
      "Barghoria BO": "743247",
      "Charghat BO": "743247",
      "Kapileswarpur BO": "743247",
      "Chakla BO": "743424",
      "Secondranagar BO": "743424",
      "Beliaghata Bridge BO": "743423",
      "Bhasila BO": "743423",
      "Sasan BO": "743423",
      "Dharampur BO": "743249",
      "Jaleswar BO": "743249",
      "Ambikapur Mamudpur BO": "743251",
      "Asharu BO": "743251",
      "Bagangram BO": "743251",
      "Iswarigacha BO": "743222",
      "Sabdalpur BO": "743222",
      "Mudiahat BO": "700128",
      "Boyra BO": "743232",
      "Dinabandhunagar BO": "743235",
      "Adhata BO": "743221",
      "Bhagyamantapur BO": "700128",
      "Kirtipur BO": "700128",
      "Madanpur Krishnapur BO": "700128",
      "Hatkurulia BO": "743232",
      "Mamabhagina BO": "743232",
      "Mashyampur BO": "743232",
      "Nakpul BO": "743235",
      "Panchita BO": "743235",
      "Paschim Malikberia BO": "743702",
      "Sethpur BO": "743234",
      "Talsa BO": "743234",
      "Duma BO": "743245",
      "Jhikra BO": "743245",
      "Kahankia BO": "743245",
      "Kharua Rajapur BO": "743245",
      "Bohara BO": "743294",
      "Naksha BO": "743294",
      "Nimdaria BO": "743294",
      "Chandipur BO": "743247",
      "Deara BO": "743247",
      "Kanchdaha BO": "743247",
      "Chowrashi BO": "743424",
      "Rampur Bhatpara BO": "743249",
      "Baliadanga BO": "743251",
      "Beara BO": "743251",
      "Karnamadhabpur BO": "700113",
      "Patulia BO": "700119",
      "Bharatpur BO": "743251",
      "Malancha BO": "743425",
      "Madral BO": "743126",
      "Panchanantala BO": "700113",
      "Sewli Telinipara BO": "700121",
      "Paltapara BO": "743127",
      "Bandipur BO": "700119",
      "Kalyannagar Cooperative Colony BO": "700112",
      "Jyangra BO": "700159",
      "Raghunathpur BO": "743428",
      "Ghoshpur BO": "743289",
      "Sadhanpur Uludanga BO": "743221",
      "Angrail BO": "743235",
      "Balisa Chowmatha BO": "743702",
      "Boaldah BO": "743235",
      "Dharampukuria BO": "743235",
      "Dogachia BO": "743702",
      "Ballavpur BO": "743245",
      "Dhakuria kalibari BO": "743245",
      "Digha BO": "743248",
      "Sashadanga BO": "743245",
      "Salua BO": "743247",
      "Hadipur BO": "743424",
      "Baidyapur BO": "743423",
      "Golabari Bazar BO": "743423",
      "Kaliani BO": "743423",
      "Karua Chandpur BO": "743423",
      "Majlishpur BO": "743423",
      "Parulia BO": "743423",
      "Fazilpur BO": "743423",
      "Ramnathpur BO": "743423",
      "Adikashimpur BO": "743248",
      "Bamangachi BO": "743248",
      "Colony Simulia BO": "743249",
      "Ganti BO": "700132",
      "Dakshin Panchpota BO": "743251",
      "Gazipur BO": "743251",
      "Gobrapur BO": "743251",
      "Ghatbaor BO": "743235",
      "Joypul BO": "743234",
      "Rowtara BO": "743234",
      "Chhekathi BO": "743245",
      "Jhowdanga BO": "743245",
      "Natungram BO": "743235",
      "Tentulberia BO": "743245",
      "Ramchandrapur Khaspur BO": "743247",
      "Gobila BO": "743424",
      "Kachua BO": "743424",
      "Belpur BO": "743423",
      "Gobardhanpur BO": "743423",
      "Sandalia BO": "743423",
      "Sohai Kumarpur BO": "743423",
      "Amankandi BO": "743249",
      "Ghonja BO": "743249",
      "Natagram BO": "743249",
      "Amdobe BO": "743251",
      "Ghatpatila BO": "743251",
      "Dattapara BO": "743286",
      "Gokulpur BO": "743286",
      "Kantabagan BO": "743286",
      "Nirman BO": "743286",
      "Sultanpur BO": "700051",
      "New Town Action Area I SO": "700163",
      "Krishnachandapur BO": "743251",
      "Gobardanga Ichapur BO": "743252",
      "Sarkarpara Kuthipara BO": "743252",
      "Satberia BO": "743262",
      "Habra Srinagar BO": "743263",
      "Janaphul BO": "743263",
      "Berbari BO": "743270",
      "Balti BO": "743273",
      "Gobinda Pur BO": "743273",
      "Hakimpur BO": "743273",
      "Gunrajpur BO": "743273",
      "Jangalpur BO": "743438",
      "Parpatna BO": "743438",
      "Rajballavpur BO": "743289",
      "Uludanga BO": "743289",
      "Ram Shankarpur BO": "743290",
      "Taranipur BO": "743273",
      "Aharampur BO": "700131",
      "Sajirhat BO": "700131",
      "Kamdevpur BO": "700125",
      "Khilkapur BO": "700125",
      "Belta BO": "743701",
      "Chhoygharia BO": "743405",
      "Akandakeshari BO": "700135",
      "Kamduni BO": "700135",
      "Patharghata BO": "700135",
      "Dariapur BO": "743711",
      "Srikrishnapur BO": "743711",
      "Chikanpara BO": "743287",
      "Minakhan BO": "743425",
      "Andharmanik BO": "743401",
      "Gutri BO": "743249",
      "Jagadishpur BO": "743251",
      "Murighata BO": "743251",
      "Gaipur BO": "743252",
      "Alambazar SO": "700035",
      "Bonhooghly SO": "700108",
      "Dumdum SO": "700028",
      "Kolkata Airport SO": "700052",
      "Kuthighat Road SO": "700036",
      "Ordnance Factory SO": "700028",
      "Rajabagan SO": "700028",
      "Bairampur BO": "743262",
      "Barrackpore Sripally BO": "743262",
      "Mediahat BO": "743262",
      "Akaipur BO": "743710",
      "Gadpukuria BO": "743710",
      "Panchberia BO": "743710",
      "Manicktala BO": "743263",
      "Putia BO": "743263",
      "Salua Govt Colony BO": "743263",
      "Purandarpur BO": "743273",
      "East Udayrajpur BO": "700129",
      "Udayrajpur BO": "700129",
      "Sech Bhawan SO": "700091",
      "Sreebhumi SO": "700048",
      "New Town Action Area III": "700160",
      "New Town Action Area II SO": "700161",
      "Mirhati BO": "700125",
      "Noapara Madhavpur BO": "700125",
      "Lauhati BO": "700135",
      "Rajarhat Bishnupur BO": "700135",
      "Bediapara SO": "700077",
      "Bengal Immunity SO": "700036",
      "Deshbandhu Road SO": "700035",
      "Durganagar SO": "700065",
      "ISI PO SO": "700108",
      "Jugipara Satganchi SO": "700028",
      "Kamalapur SO": "700028",
      "Mall Road SO": "700080",
      "Netaji Colony SO": "700090",
      "Rajarhat Deara BO": "700135",
      "Rohanda BO": "700135",
      "Sikharpur BO": "700135",
      "Thoara BO": "743297",
      "Bena BO": "743401",
      "Buruj BO": "743401",
      "Nayabastia BO": "743401",
      "Simulia Durgapur BO": "743401",
      "Abadkuliadanga BO": "743456",
      "Amodpur BO": "743456",
      "Nurpur BO": "743456",
      "Mominpur BO": "743291",
      "Rajendrapur BO": "743291",
      "Nehalpur BO": "743437",
      "Aziznagar BO": "743425",
      "Bamanpukur BO": "743425",
      "Chowhata BO": "743425",
      "Joygram BO": "743425",
      "Kumarjole BO": "743425",
      "Raikhan BO": "743425",
      "Rabindra Nagar SO": "700065",
      "Karnalkora BO": "743412",
      "Makhalgachha BO": "743422",
      "Paikparahat BO": "743422",
      "Bachra Mohanpur BO": "743456",
      "Chimtakachari BO": "743456",
      "Kharampur BO": "743456",
      "Murarisaha BO": "743456",
      "Begampur BO": "743437",
      "Bhabanipur BO": "743270",
      "Ghona BO": "743445",
      "Kharupala BO": "743425",
      "Barunhat BO": "743426",
      "Chakpatli BO": "743426",
      "Ichhapur Abad BO": "743426",
      "Simulia Kalibari BO": "743426",
      "Bhanderkhali BO": "743439",
      "Choto Sahebkhali BO": "743439",
      "Deuli Pukuria BO": "743439",
      "Lebukhali BO": "743439",
      "Malekangumti BO": "743439",
      "Parghumti BO": "743439",
      "Patghara BO": "743439",
      "Samsernagar BO": "743439",
      "Sridharkati BO": "743439",
      "Banshtala BO": "743435",
      "Dharamberia BO": "743435",
      "Rupmari BO": "743435",
      "Merudandi BO": "743292",
      "Shibhati BO": "743292",
      "Aturia BO": "743427",
      "Gandharbapur BO": "743427",
      "Choto Sehara BO": "743442",
      "Dheknamari BO": "743442",
      "Kalinagar Hat BO": "743442",
      "South Sikarigheri BO": "743442",
      "Bhanga Tushkhali BO": "743446",
      "Dakshin Korakati BO": "743446",
      "Sithalia BO": "743446",
      "Tushkhali BO": "743446",
      "Gobardanga SO": "743252",
      "Goribpur SO": "743710",
      "Guma SO": "743704",
      "Helencha Colony SO": "743270",
      "Kalyangarh SO": "743272",
      "Khantura SO": "743273",
      "Maslandapur SO": "743289",
      "Nabapally SO": "700126",
      "Palla SO": "743701",
      "Rajarhat SO": "700135",
      "Subhashnagar SO North 24 Parganas": "743235",
      "Basirhat Bazar SO": "743411",
      "Bhabla SO": "743422",
      "Champapukur SO": "743291",
      "Dhanyakuria SO": "743437",
      "Haroa SO": "743425",
      "Hasnabad SO": "743426",
      "Sandeshkhali SO": "743446",
      "Hasnabad Rampur BO": "743439",
      "Jogeshganj BO": "743439",
      "Kothabari BO": "743435",
      "Purba  Khejurberia BO": "743435",
      "Eojnagar BO": "743293",
      "Gokna BO": "743293",
      "Kachua Swarupnagar BO": "743293",
      "Bajitpur BO": "743427",
      "Barabankra BO": "743427",
      "Bhojpara BO": "743427",
      "Kaijuri BO": "743427",
      "Paschim Palta BO": "743427",
      "Sikrakulingram BO": "743428",
      "Baunia Abad BO": "743442",
      "Bermajur BO": "743442",
      "Boyermari BO": "743442",
      "Khariahatabad BO": "743442",
      "Mathbari Abad BO": "743442",
      "Nalkora BO": "743442",
      "Nityaberia BO": "743442",
      "Durgamandap BO": "743446",
      "Joygopalpur BO": "743446",
      "Khulna BO": "743446",
      "KORAKATI BO": "743446",
      "Manipur BO": "743446",
      "Purba Atapur BO": "743446",
      "Paschim Monipur BO": "743446",
      "Pathsimulia BO": "743251",
      "Sundarpur BO": "743251",
      "Tangra Colony BO": "743251",
      "Akrampur BO": "743263",
      "Bergoom BO": "743263",
      "Fultala BO": "743263",
      "Kulia BO": "743270",
      "Kumarkhola BO": "743270",
      "Nataberia BO": "743297",
      "Kumra Kashipur BO": "743271",
      "Sonakenia BO": "743271",
      "Kankpul BO": "743272",
      "Samudrapur BO": "743272",
      "Amudia BO": "743273",
      "Media BO": "743273",
      "Nityanandakati BO": "743273",
      "Panchpota BO": "743273",
      "Ramnagar BO": "743273",
      "Saguna BO": "743273",
      "Sakdah Jadabpur BO": "743273",
      "Sutia Barasat BO": "743273",
      "Atghara BO": "743438",
      "Kamdevkati BO": "743438",
      "Mandra BO": "743438",
      "Korachandigarh BO": "700130",
      "Taldharia Kapasia BO": "700130",
      "Bodai BO": "700126",
      "Jagannathpur BO": "700126",
      "Bhandarkhola BO": "743701",
      "Chowberia BO": "743290",
      "Dighari BO": "743290",
      "Hingli BO": "743290",
      "Bagu BO": "700135",
      "Kadampukur BO": "700135",
      "Matiagachha BO": "700135",
      "Mongalganj BO": "743297",
      "Naldugri BO": "743297",
      "Beraberi BO": "743711",
      "Kanchiara BO": "743711",
      "Masunda BO": "743711",
      "Basirhat RS BO": "743412",
      "Dandirhat BO": "743412",
      "Dhaltitha BO": "743412",
      "Biramnagar BO": "743422",
      "Gotra BO": "743422",
      "Sangrampur BO": "743422",
      "Jirakpur BO": "743422",
      "Chaital BO": "743456",
      "Garakupi BO": "743456",
      "Mallickgheri BO": "743456",
      "Fulbariabad BO": "743456",
      "Gouribhoj BO": "743445",
      "Sadarpur Behala BO": "743445",
      "Bhurkunda BO": "743426",
      "Ghosalbati BO": "743426",
      "Chandanpur BO": "743439",
      "Dakshin Hatgachha BO": "743439",
      "Banglani BO": "743286",
      "Tentulia BO": "743286",
      "Dakshin Bagundi BO": "743429",
      "Paschim Madhyampur BO": "743429",
      "Kanaikati BO": "743439",
      "Paschim Sridharkati BO": "743439",
      "Purba Deuli BO": "743439",
      "South Charalkhali BO": "743439",
      "Amberia BO": "743435",
      "Bankra Dabar BO": "743435",
      "Bankra BO": "743435",
      "Sandeler Bil BO": "743435",
      "Takimamudpur BO": "743435",
      "Badartala BO": "743292",
      "Gachha BO": "743292",
      "Punra BO": "743427",
      "Safirabad SC Ghosh Rd BO": "743427",
      "Sayestanagar BO": "743427",
      "Zafarpur BO": "743428",
      "Ghoshpara BO": "743442",
      "Jhupkhali BO": "743442",
      "Atapur BO": "743446",
      "Bowthakurani BO": "743446",
      "Karanga BO": "743251",
      "Kaniara BO": "743251",
      "Mahananda Para BO": "743251",
      "Ranihati BO": "743251",
      "Nakpul Kuchlia BO": "743252",
      "Shimulia BO": "743262",
      "Prithiba BO": "743704",
      "Ganadipayan BO": "743263",
      "Hatthuba BO": "743263",
      "Baneswarpur BO": "743270",
      "Sendanga BO": "743272",
      "East Bishnupur BO": "743273",
      "Simulpur BO": "743289",
      "Malikapur BO": "700126",
      "Satashi BO": "743290",
      "Kodalia Agapur BO": "700131",
      "Kadambagachi BO": "700125",
      "Kazipara BO": "700125",
      "Sonekpur BO": "743701",
      "Sulka Durgapur BO": "743701",
      "Khalitpur BO": "743405",
      "Kashinathpur BO": "700135",
      "Colony Ramchandra Pur BO": "743287",
      "Jasaikati BO": "743401",
      "Rudrapur BO": "743401",
      "Taragunia BO": "743401",
      "Harishpur BO": "743412",
      "Kathur BO": "743422",
      "Pifa BO": "743422",
      "Dakshin Bhebia BO": "743456",
      "Nimichi BO": "743456",
      "Arbelia BO": "743437",
      "Matia BO": "743437",
      "Amta BO": "743445",
      "Chaita BO": "743445",
      "Adampur BO": "743425",
      "Atpukur BO": "743425",
      "Dhuturdah BO": "743425",
      "Khalisadi BO": "743425",
      "Khasbalanda BO": "743425",
      "Uchildah BO": "743425",
      "Rameswarpur BO": "743426",
      "Sulkuniabad BO": "743426",
      "Kuliagarh BO": "743166",
      "Madarpur BO": "743166",
      "Mamudpur BO": "743166",
      "Ganganagar SO North 24 Parganas": "700132",
      "Gopalnagar SO North 24 Parganas": "743262",
      "Haripur SO North 24 Parganas": "743223",
      "Hijalpukuria SO": "743271",
      "Korarbagan SO": "743235",
      "Nahata SO": "743290",
      "Baduria SO": "743401",
      "Basirhat College SO": "743412",
      "Dulduli Mathbari BO": "743439",
      "Hemnagar BO": "743439",
      "Kalitala BO": "743439",
      "Madhabkati BO": "743439",
      "Paschim Parghumti BO": "743439",
      "Sahebkhali BO": "743439",
      "Uttar Malikanghumti BO": "743439",
      "Bishpur BO": "743435",
      "Kanchanpur BO": "743435",
      "Panitor BO": "743292",
      "Bhaduria BO": "743427",
      "Goaldah BO": "743427",
      "Khorgachi BO": "743427",
      "Model Belghoria BO": "743427",
      "Srinagar BO": "743428",
      "Dakshin Akhratala BO": "743442",
      "Ghotihara BO": "743442",
      "Kanmari BO": "743442",
      "Purba Sankardaha BO": "743442",
      "Duchnikhali BO": "743446",
      "Dwarirjangal BO": "743446",
      "Sukduani BO": "743446",
      "Debalaya SO": "743424",
      "Duttapukur SO": "743248",
      "Habra SO": "743263",
      "Hridaypur SO": "700127",
      "Motiganj SO North 24 Parganas": "743235",
      "Newbarrackpur SO": "700131",
      "Petrapole SO": "743405",
      "Rajarhat Gopalpur SO": "700136",
      "Rajibpur SO": "743702",
      "Ram Nagar Road SO": "743235",
      "Sethpukur SO": "700124",
      "Sindrani SO": "743297",
      "Bhebia SO": "743456",
      "Hatgachha SO": "743439",
      "Hingalganj SO": "743435",
      "Jadurhati SO": "743293",
      "Swarupnagar SO": "743286",
      "Taki SO": "743429",
      "Desh Bandhu Nagar SO": "700059",
      "Hatiara SO": "700157",
      "Nowbhanga SO": "700105",
      "Dum Dum Park SO": "700055",
      "Krishnapur SO North 24 Parganas": "700102",
      "New Town SO": "700156",
      "Prafulla Kanan SO": "700101",
      "Bithari BO": "743286",
      "Sanrapul BO": "743286",
      "Kishor Nagar Jalalpur BO": "743429",
      "Nabadiganta IT SO": "700091",
      "Patipukur SO": "700048",
      "Purbachal SO": "700097",
      "Gouranganagar SO": "700162",
      "Ashokegarh SO": "700108",
      "Baranagar SO": "700036",
      "Health Institute SO": "700065",
      "Kendriya Vihar SO": "700052",
      "Kolkata Airport  Po SO": "700052",
      "Kumarpara SO": "700028",
      "Nagerbazar SO": "700028",
      "Noapara SO": "700090",
      "Purba Sinthee SO": "700030",
      "Sethbagan SO": "700030",
      "Subhas Nagar SO": "700065",
      "Joygopalpur Korakati Milanbazar BO": "743446",
      "Soladana BO": "743429",
      "Takipur BO": "743429",
      "Dumdum Road SO": "700074",
      "Jawpore SO": "700074",
      "Jessore Road SO": "700080",
      "Motijheel SO": "700074",
      "Sadhana Ausudhalaya Road SO": "700048",
      "Shyam Nagar Dum Dum SO": "700055",
      "Baguiati Super Market SO": "700059",
      "Ghola BO": "700111",
      "Jetia BO": "743135",
      "Deganga SO": "743423",
      "Gaighata SO": "743249",
      "Ganrapota SO": "743251",
      "Habra Prafulla Nagar SO": "743268",
      "Kolsur SO": "743438",
      "Madhyamgram Bazar SO": "700130",
      "Madhyamgram SO": "700129",
      "Michealnagar SO": "700133",
      "Noapara SO North 24 Parganas": "700125",
      "Suria SO": "743711",
      "Thakurnagar SO": "743287",
      "Gopalpur SO North 24 Parganas": "743445",
      "Itinda SO": "743292",
      "Katiahat SO": "743427",
      "Kholapota SO": "743428",
      "Nazat Hatkhola SO": "743442",
      "Taki Market SO": "743429",
      "Kalindi Housing Estate SO": "700089",
      "Labony Estate SO": "700064",
      "Lake Town SO North 24 Parganas": "700089",
      "Aswini Nagar SO": "700159",
      "Bidhan Nagar CK Market SO": "700091",
      "Bidhan Nagar SO": "700064",
      "Bidhan Nagar AE Market SO": "700064",
      "Bidhan Nagar IB Market SO": "700106",
      "Bangur Avenue SO": "700055",
      "Belgharia HO": "700056",
      "Barasat HO": "700124",
      "Basirhat HO": "743411",
      "Barrackpore HO": "700120",
      "Bidhannagr CC Block SO": "700064",
      "Bangaon SO North 24 Parganas": "743235",
      "Bira Ballavepara SO": "743234",
      "Chhoto Jagulia SO": "743294",
      "Dakshin Chatra SO": "743247",
      "Arkhali Amdanga SO": "743221",
      "Badu SO North 24 Parganas": "700128",
      "Bangaon Bazar SO": "743235",
      "Asoknagar SO": "743222",
      "Banipur SO North 24 Parganas": "743233",
      "Abdalpur SO": "700155",
      "Asoknagar Rs SO": "743222",
      "Bagdah SO": "743232",
      "Bangaon RS SO": "743235",
      "Barasat Bazar SO": "700124",
      "Champaberia SO": "743235",
      "Chand Para Bazar SO": "743245",
      "Kankinara SO": "743126",
      "Lalkuthi SO": "743135",
      "Nayapally SO": "700120",
      "Titagarh SO": "700119",
      "Vivekananda Math SO": "700120",
      "Ariadaha SO": "700057",
      "Belgharia Mohini Mills SO": "700056",
      "Birati SO": "700051",
      "Panihati SO": "700114",
      "Rajbari Colony SO": "700081",
      "Sukchar SO North 24 Parganas": "700115",
      "Surya Sen Nagar SO": "700117",
      "Texmaco SO": "700056",
      "Rani Park SO": "700056",
      "Anandamath SO": "743144",
      "Athpur SO": "743128",
      "Bagermore SO": "743145",
      "Bhatpara SO": "743123",
      "Binodnagar SO": "743145",
      "Garulia SO": "743133",
      "Ghosh Para Road SO": "700120",
      "Golghar SO WB Circle": "743125",
      "Ichapur Rifle Factory SO": "743144",
      "Kanchrapara Loco Shop SO": "743145",
      "Monirampore SO": "700120",
      "Nilganj Bazaar SO": "700121",
      "Nonachandanpukur SO": "700122",
      "Orderly Bazar SO": "700120",
      "Panpara SO North 24 Parganas": "700123",
      "Shyamnagar SO North 24 Parganas": "743127",
      "Sodepur SO": "700110",
      "Talpukur SO": "700123",
      "Bijoypur SO": "700110",
      "Dakshineswar SO": "700076",
      "East Belghoria SO": "700083",
      "Italghacha SO": "700079",
      "Jeliapara SO": "700117",
      "Kamarhati SO": "700058",
      "Khardah SO": "700117",
      "Nandan Nagar SO": "700083",
      "Nimta SO": "700049",
      "Rahara SO": "700118",
      "Ramchandra Pur SO": "700110",
      "South Belgharia SO": "700056",
      "Tirtha Bharati SO": "700110",
      "Udaipur SO": "700049",
      "Barrackpore RS SO": "700123",
      "Chandmari Road SO": "743145",
      "Gupter Bagan SO": "743125",
      "Halishahar SO": "743134",
      "Ichapur Nawabganj SO": "743144",
      "Kanchrapara SO": "743145",
      "Kowgachi SO": "743127",
      "Muktarpur SO": "743123",
      "Mulajore SO": "743127",
      "Nabanagar SO": "743136",
      "PSBureau SO": "743144",
      "Pinkal SO": "743133",
      "Ghola Bazar SO": "700111",
      "Pansila SO": "700112",
      "Rathtala SO": "700056",
      "Anandapuri SO": "700122",
      "Barrackpore Bazar SO": "700120",
      "Barrackpore GovtHousing SO": "700120",
      "Bengal Enamel SO": "743122",
      "ESD M SO": "743124",
      "Gorifa SO": "743166",
      "Jaffarpur SO": "700122",
      "Kantadhar SO": "743144",
      "Kelabagan SO": "743194",
      "Metal  Steel Factory SO": "743144",
      "Naihati Anandabazar SO": "743165",
      "Naihati SO": "743165",
      "Natagarh SO": "700113",
      "Ramghat SO North 24 Parganas": "743166",
      "Ramlakshi Busti Lane SO": "743194",
      "Agarpara SO": "700109",
      "BDSopan SO": "700116",
      "Bangodaya SO": "700114",
      "Bisharpara SO": "700158",
      "Elias Road SO": "700058",
      "Nilachal SO": "700134",
      "Nowdapara SO": "700057",
      "Sodepur GHE SO": "700110",
      "Bishalakshi Ghat SO": "700119",
      "Bramhasthan SO": "700119",
      "Dogachia SO": "743130",
      "Feeder Road SO": "743127",
      "Fingapara SO": "743129",
      "Hazinagar SO": "743135",
      "Ichapur SO": "743144",
      "Jagatdal SO": "743125",
      "Kampa SO": "743193"
    },
    "PASCHIM BARDHAMAN": {
      "Birudiha BO": "713148",
      "Baltoria BO": "713324",
      "Santa BO": "713325",
      "Baraboni BO": "713334",
      "Birkulti BO": "713334",
      "Basudevpur Jemari BO": "713335",
      "Taltore BO": "713336",
      "Patmohana BO": "713371",
      "Ethora BO": "713359",
      "Nischinta BO": "713373",
      "Malandighi BO": "713212",
      "Rajbandh BO": "713212",
      "Nadiha BO": "713211",
      "Dhabani BO": "713205",
      "Pratappur BO": "713204",
      "Andalgram BO": "713321",
      "Dakhin Khanda BO": "713321",
      "Gangutia BO": "713333",
      "Sitalpur BO": "713333",
      "Churulia BO": "713334",
      "Chelod BO": "713339",
      "Damra BO": "713339",
      "Mohishila BO": "713339",
      "Nuni BO": "713341",
      "Kapista BO": "713315",
      "Roshna BO": "713315",
      "Pariharpur BO": "713373",
      "Sripur BO": "713373",
      "Bhiringi BO": "713203",
      "Amlajora BO": "713212",
      "Bamunara BO": "713212",
      "Gopinathpur BO": "713211",
      "Dharampur BO": "713325",
      "Kalajhoria BO": "713325",
      "Shivpur BO": "713330",
      "Mandalpur BO": "713336",
      "Aldihi BO": "713359",
      "Samdi BO": "713359",
      "Baradhemo BO": "713359",
      "Old Sitarampur BO": "713359",
      "Asanboni BO": "713360",
      "Chinakuri BO": "713360",
      "Burdwan Arrah BO": "713212",
      "Gopalpur BO": "713212",
      "Shibpur BO": "713212",
      "Ramnagar BO": "713324",
      "Hirapur B.O": "713325",
      "Radhanagar BO": "713325",
      "Majhiara BO": "713330",
      "Bogra BO": "713332",
      "Bhanora BO": "713334",
      "Kelejora BO": "713334",
      "Achra BO": "713335",
      "Seakulberia BO": "713335",
      "Rotibati BO": "713339",
      "Lalbazar BO": "713343",
      "Bidyanandapur BO": "713371",
      "Jamgram BO": "713315",
      "Bejdih BO": "713359",
      "Lalganj BO": "713359",
      "Raghunathchak BO": "713359",
      "Kankhaya BO": "713373",
      "Kuldiha BO": "713212",
      "Rakshitpur BO": "713212",
      "Kamalpur BO": "713204",
      "Fuljhore BO": "713206",
      "Jemua BO": "713206",
      "Amrai BO": "713203",
      "BAKTARNAGAR BO": "713321",
      "Bhuri BO": "713378",
      "Balijuri BO": "713385",
      "Jamgora BO": "713385",
      "Gogla BO": "713381",
      "Kendra BO": "713346",
      "Ikrah BO": "713362",
      "Khandra BO": "713363",
      "Egara BO": "713323",
      "Nupur BO": "713323",
      "Bilpahari BO": "713378",
      "Chinchuria BO": "713378",
      "Khottadihi BO": "713378",
      "Amritnagar BO": "713358",
      "Bansra BO": "713358",
      "Bijpur BO": "713358",
      "Nimcha BO": "713358",
      "Bahadurpur BO": "713362",
      "Hijalgora BO": "713362",
      "Ichapur BO": "713363",
      "Nabagram BO": "713363",
      "Sarpi BO": "713363",
      "Moira Colliery BO": "713321",
      "Srirampur BO": "713321",
      "Siduli BO": "713322",
      "Benali BO": "713337",
      "Satgram BO": "713337",
      "Madhusudhanpur BO": "713338",
      "Parascole BO": "713338",
      "Jhanjra BO": "713385",
      "Amdahi BO": "713381",
      "Patsora BO": "713363",
      "Sankarpur BO": "713363",
      "Madanpur BO": "713321",
      "Jemahari BO": "713337",
      "Sonepur BO": "713378",
      "Nakrakonda BO": "713385",
      "Gourbazar BO": "713381",
      "Ramnagar Gram BO": "713346",
      "Semallya BO": "713346",
      "Jote Janki BO": "713362",
      "Kumardihi BO": "713363",
      "Bankati BO": "713148",
      "Shilampur BO": "713148",
      "Trilokchandrapur BO": "713148",
      "Kanksa BO": "713148",
      "Durgapur HO": "713201",
      "Raniganj HO": "713347",
      "Asansol HO": "713301",
      "Amladahi SO": "713331",
      "Begunia Bazar SO": "713324",
      "Chittaranjan SO": "713331",
      "Chotodighari SO": "713326",
      "Domahani Bazar SO": "713334",
      "Jhingri Mohallah SO": "713302",
      "Mithani SO": "713371",
      "Neamatpur SO": "713359",
      "Asansol Court SO": "713304",
      "Charanpur SO": "713330",
      "Chittaranjan TS SO": "713365",
      "Dakhin Dhadka SO": "713302",
      "Disergarh SO": "713333",
      "Kalla Central Hospital SO": "713340",
      "Kanyapur SO": "713341",
      "Kumarpur SO": "713304",
      "Nandi SO Bardhaman": "713344",
      "Palashbagan SO": "713302",
      "Railpar SO Bardhaman": "713302",
      "Rupnarayanpur Bazar SO": "713386",
      "Simjuri SO": "713331",
      "Sripur Bazar SO Bardhaman": "713373",
      "Ushagram SO": "713303",
      "Burnpur Mkt SO": "713325",
      "Burnpur SO": "713325",
      "Kalipahari SO": "713339",
      "Kalyaneshwari SO": "713369",
      "Kulti SO": "713343",
      "Narsinghbandh SO": "713325",
      "Radhanagar Rly Colony SO": "713372",
      "Salanpur SO": "713357",
      "Suryanagar SO Bardhaman": "713361",
      "Benachity Market SO": "713204",
      "Benachity SO": "713213",
      "Rahmatdanga SO": "713325",
      "Rambandhutalaw SO": "713303",
      "Ramkrishna Mission SO": "713305",
      "Santinagar SO Bardhaman": "713325",
      "U C Danga SO": "713304",
      "City Centre SO": "713216",
      "Durgapur Abl Township SO": "713206",
      "BBCollege SO": "713303",
      "Barakar SO": "713324",
      "Devchandnagar SO": "713332",
      "Hill View SO": "713304",
      "Hindustan Cables SO": "713335",
      "Hutton Road SO": "713301",
      "Jamuriahat SO": "713336",
      "Kendua SO": "713343",
      "Mohishila Colony SO": "713303",
      "Ningha SO": "713370",
      "Panuria SO": "713315",
      "Rambandh SO": "713325",
      "SBGorai Road SO": "713301",
      "SDHospital SO": "713303",
      "Sitarampur SO": "713359",
      "Sunderchak SO": "713360",
      "Amrabati SO": "713214",
      "Angadpur SO": "713215",
      "Bidhannagar SO": "713212",
      "Durgapur Bidhannagar Postal Colony SO": "713212",
      "Durgapur Sepco Township SO": "713205",
      "Kenda SO": "713342",
      "Laudoha SO": "713385",
      "Ukhra Puratanhattala SO": "713363",
      "Durgapur Heavy Engg Plant SO": "713210",
      "Durgapur Re College SO": "713209",
      "Durgapur Steel Project SO": "713203",
      "Durgapur Steel Town East SO": "713205",
      "V K Nagar SO": "713210",
      "Andal SO": "713321",
      "Bidhanbag SO": "713337",
      "Haripur SO Bardhaman": "713378",
      "Nutandanga SO": "713381",
      "Toposi SO": "713362",
      "Ukhra SO": "713363",
      "Durgapur Alloy Steel Project SO": "713208",
      "Durgapur DSP SB SO": "713203",
      "Durgapur RS SO": "713201",
      "Durgapur Sagarbhanga Colony SO": "713211",
      "Durgapur Rabindra Pally SO": "713201",
      "Bahula SO": "713322",
      "Dhandadihi SO": "713376",
      "Kajoragram SO": "713338",
      "Pandaveshwar SO": "713346",
      "Durgapur ASP SB SO": "713208",
      "Durgapur Brick Field SO": "713215",
      "Durgapur Coke Oven Colony SO": "713202",
      "Durgapur CRPF Camp SO": "713214",
      "Durgapur Mg Avenue SO": "713209",
      "Durgapur Steel Town West SO": "713204",
      "Durgapur Thermal Power Station SO": "713207",
      "Oyaria SO": "713217",
      "Andal South Bazar SO": "713321",
      "Ballavpur SO": "713323",
      "Kharsuli Bazar SO": "713347",
      "Parasea SO": "713384",
      "Searsole Rajbari SO": "713358"
    },
    "HOWRAH": {
      "Gabberia BO": "711322",
      "Jalabiswanathpur BO": "711322",
      "Nayachak BO": "711322",
      "Jallabaj BO": "711314",
      "Kharuberia BO": "711314",
      "Mollahat BO": "711314",
      "Bairakurchi BO": "711226",
      "Bahira BO": "711316",
      "Baniban BO": "711316",
      "Fuleswar BO": "711316",
      "Kaijuri BO": "711316",
      "Kantaberia BO": "711316",
      "Kushberia BO": "711413",
      "RAJKHOLA BO": "711316",
      "Baganda BO": "711315",
      "Bhekutal BO": "711315",
      "Gutinagari BO": "711315",
      "Anandanagar BO": "711227",
      "Joypur Bill BO": "711205",
      "Betai BO": "711401",
      "Islampur BO": "711401",
      "Jhinkra BO": "711401",
      "Joypur Fakirdas BO": "711401",
      "Santoshnagar BO": "711401",
      "Thalia BO": "711401",
      "Gangadharpur BO": "711302",
      "Jhorehat BO": "711302",
      "Mashila BO": "711302",
      "Bainan BO": "711303",
      "Bangalpur BO": "711303",
      "Chakur BO": "711303",
      "Chitnan BO": "711303",
      "Deulti BO": "711303",
      "Khadinan BO": "711303",
      "Kantapukur BO": "711303",
      "Olanpara BO": "711303",
      "Panitras BO": "711303",
      "Ramchandrapur SO HowrBO": "711303",
      "Sumda BO": "711303",
      "Guzarpur BO": "711314",
      "Pichaldaha BO": "711314",
      "Banitala BO": "711316",
      "Basudebpur BO": "711316",
      "Birshibpur BO": "711316",
      "Jaduberia BO": "711316",
      "Alipur BO": "711315",
      "Belari BO": "711315",
      "Dakshin Hirapur BO": "711315",
      "Dakshin Ramchandrapur BO": "711315",
      "Chamrail BO": "711114",
      "Bhandargacha BO": "711401",
      "Deora BO": "711401",
      "Ghoshpur BO": "711401",
      "Jhamtia BO": "711401",
      "Udang BO": "711401",
      "Chandrapur BO": "711401",
      "Joynagar BO": "711302",
      "Jujursa BO": "711302",
      "Kendua BO": "711302",
      "Kuldanga BO": "711302",
      "Prasastha BO": "711302",
      "Subhararah BO": "711302",
      "Unsani BO": "711302",
      "Dakshin Santoshpur BO": "711404",
      "Mansinghpur BO": "711404",
      "Biprannapara BO": "711411",
      "Keshabpur BO": "711411",
      "Kanupat Majhpara BO": "711412",
      "Sonatala BO": "711412",
      "Sarenga BO": "711309",
      "Dafarpur BO": "711405",
      "Narna BO": "711405",
      "Nalpur BO": "711310",
      "Radhanagar BO": "711310",
      "Khalna BO": "711413",
      "Mato BO": "711408",
      "Baidyanathpur BO": "711312",
      "Naul BO": "711312",
      "Ramnagar BO": "711312",
      "Gourangachak BO": "711410",
      "Kanpur BO": "711410",
      "Paikpara BO": "711410",
      "Amaragori BO": "711401",
      "Anulia BO": "711401",
      "Baramahara BO": "711401",
      "Khasmahal Balichak BO": "711401",
      "Khorop BO": "711401",
      "Khosalpur BO": "711401",
      "Kumarchak BO": "711401",
      "Nowpara BO": "711401",
      "Panpur BO": "711401",
      "Rashpur BO": "711401",
      "Saltighat Gujarpur BO": "711401",
      "Dakhin Durgapur BO": "711301",
      "Deoly BO": "711301",
      "Dihimandal Ghat BO": "711301",
      "Jhumjhumi BO": "711301",
      "Kotra BO": "711301",
      "Argori BO": "711302",
      "Dhulagori BO": "711302",
      "Barunda BO": "711303",
      "Bhatora BO": "711303",
      "Mahishrekha BO": "711303",
      "Mankur BO": "711303",
      "Mellock BO": "711303",
      "Munshidanga BO": "711403",
      "Kolora BO": "711411",
      "Rudrapur BO": "711411",
      "Wadipur BO": "711411",
      "Dasbhaga BO": "711307",
      "Uttar Mansri BO": "711412",
      "Baluhati BO": "711405",
      "South Joychanditala BO": "711405",
      "Santoshpur BO": "711310",
      "Narit BO": "711413",
      "Sarda BO": "711413",
      "Sauria BO": "711413",
      "Tajpur BO": "711413",
      "Gobindapur Shibtala BO": "711414",
      "Naskarpur BO": "711414",
      "Polgustia BO": "711414",
      "Nibra BO": "711409",
      "Salap BO": "711409",
      "Tentulkuli BO": "711409",
      "Ajodhyahat BO": "711312",
      "Amardah BO": "711312",
      "Bachhri BO": "711312",
      "Bargarchumuk BO": "711312",
      "Ganeshpur BO": "711312",
      "Hallyan BO": "711312",
      "Kulitapara BO": "711312",
      "Kultikari BO": "711312",
      "Debandi BO": "711410",
      "Penro BO": "711410",
      "Sealdanga BO": "711410",
      "Sibnarayanchak BO": "711410",
      "Beldubi BO": "711322",
      "Belkulai BO": "711322",
      "Bikihakola BO": "711322",
      "Dhamsia BO": "711322",
      "Raghudevpur BO": "711322",
      "Chaturbhujkati BO": "711313",
      "Ramchandrapur Bo Sank BO": "711313",
      "Dharsa BO": "711104",
      "Dingakhola BO": "711314",
      "Gobindapur BO": "711314",
      "Gurepole BO": "711314",
      "Harali BO": "711226",
      "Joka BO": "711226",
      "Rampur BO": "711226",
      "Singti Sibpur BO": "711226",
      "Brindabanpur BO": "711316",
      "Latibpur BO": "711316",
      "Samruk BO": "711316",
      "Sijberia BO": "711316",
      "Sundarpur BO": "711316",
      "Gohalberia BO": "711315",
      "Kanjiakhali BO": "711315",
      "Khurigachi BO": "711315",
      "Madhabpur BO": "711315",
      "Abhoynagar BO": "711205",
      "Durgapur BO": "711205",
      "Bagua BO": "711401",
      "Barda BO": "711401",
      "Joypur BO": "711401",
      "Kankrol BO": "711401",
      "Sonamui BO": "711401",
      "Tulsiberia BO": "711401",
      "Radhapur BO": "711301",
      "Duillya BO": "711302",
      "Gondalpara BO": "711302",
      "New Kolora BO": "711302",
      "Bakshi BO": "711303",
      "Bankura BoHowrah BO": "711303",
      "Birampur BO": "711303",
      "Deul Gram BO": "711303",
      "Khajutti BO": "711303",
      "Kasmali BO": "711303",
      "Orphuli BO": "711303",
      "Pirpur BO": "711303",
      "Hantal Anantabati BO": "711404",
      "Nijbalia BO": "711404",
      "Deulpur BO": "711411",
      "Jalalshi BO": "711411",
      "Khalisani BO": "711307",
      "Nonakundu BO": "711405",
      "Parbatipur BO": "711405",
      "Uttar Jharpardah BO": "711405",
      "Hirapur BO": "711310",
      "Raghudebbati BO": "711310",
      "Ula BO": "711310",
      "Siddheswar BO": "711414",
      "Antila BO": "711312",
      "Bantul BO": "711312",
      "Bargram BO": "711312",
      "Dakshin Radhanagar BO": "711312",
      "Nakol BO": "711312",
      "Rabibhag BO": "711312",
      "Dhurkhali BO": "711410",
      "Garbalia BO": "711410",
      "Harishpur BO": "711410",
      "Pantihal BO": "711410",
      "Banharishpur BO": "711322",
      "Dhunki BO": "711322",
      "Gobardhanbati BO": "711322",
      "Nabghara BO": "711322",
      "Tehatta BO": "711322",
      "Sankrail Dakshinpara BO": "711313",
      "Dakshin Shibpur BO": "711314",
      "Kalidaha BO": "711314",
      "Shibganj BO": "711314",
      "Gaza BO": "711226",
      "Sonagachi BO": "711226",
      "Dulopur BO": "711316",
      "Hatgacha BO": "711316",
      "Karatberia BO": "711316",
      "Khariamoynapur BO": "711316",
      "Balichaturi BO": "711315",
      "Dhulasimla BO": "711315",
      "Jagadishpur BO": "711315",
      "Kashmul BO": "711315",
      "Nabagram Sikipur BO": "711315",
      "Lakshmanpur BO": "711114",
      "Chakpara BO": "711204",
      "Agunshi BO": "711303",
      "Harop BO": "711303",
      "Haturia BO": "711303",
      "Joargori BO": "711303",
      "Kalyanpur BO": "711303",
      "Nawpala BO": "711303",
      "Samta BO": "711303",
      "Subsit BO": "711303",
      "Uttar Batora BO": "711303",
      "Bhandardaha BO": "711411",
      "Khantora BO": "711411",
      "Khasmora BO": "711411",
      "Raichak BO": "711412",
      "Podra BO": "711109",
      "Dakshin Jhapardaha BO": "711405",
      "Burikhali BO": "711310",
      "Rameswarnagar BO": "711310",
      "Sahapur BO": "711310",
      "Benapur Chandanapara BO": "711312",
      "Rupasgori BO": "711312",
      "Sasati BO": "711312",
      "Uttar Durgapur BO": "711312",
      "Khila BO": "711410",
      "Manikura BO": "711410",
      "Mansuka BO": "711410",
      "Samabaypalli SO": "711205",
      "Sapuipara SO": "711206",
      "Dihibhursut BO": "712408",
      "Jagriti SO": "711106",
      "Kona SO": "711114",
      "Liluah SO": "711204",
      "Ghole BO": "712401",
      "MBRoad SO": "711201",
      "Qumaresh SO": "711106",
      "Shibtala Liluah SO": "711204",
      "Netajigarh SO": "711108",
      "Jagadishpurhat SO": "711115",
      "Howrah HO": "711101",
      "Salkia HO": "711106",
      "Amta SO": "711401",
      "Andul Road SO": "711103",
      "Bagnan SO": "711303",
      "Baksara SO": "711110",
      "Bargachia SO": "711404",
      "Bataitala SO": "711103",
      "Chengail SO": "711308",
      "Cows Ghat Rd SO": "711102",
      "Danesh SkLane SO": "711109",
      "Delta Mil SO": "711309",
      "Fortgloster SO": "711310",
      "Goaberia SO": "711109",
      "Howrah RS SO": "711101",
      "Jagatballavpur SO": "711408",
      "Kadamtala SO Howrah": "711101",
      "Old Jagacha SO": "711112",
      "Pancharul SO": "711225",
      "Santragachi SO": "711104",
      "Uluberia RS SO": "711316",
      "Bhattanagar SO": "711203",
      "Dasnagar SO": "711105",
      "Dharmatala Rd SO": "711106",
      "Howrah VicCotMill SO": "711107",
      "Banipur SO Howrah": "711304",
      "Bankra SO": "711403",
      "Begri SO": "711411",
      "Chatterjee Hat SO": "711104",
      "Chitrasenpur SO": "711412",
      "DGRoad SO": "711103",
      "Dinabandhu Instt SO": "711102",
      "Gazipur SO": "711413",
      "Gip Colony SO": "711112",
      "Ichapur Rd SO": "711104",
      "Keorapara SO": "711102",
      "Kulgachia SO": "711306",
      "Mugkalyan SO": "711312",
      "Olabibitala SO": "711104",
      "Panchanantala Road SO": "711101",
      "Panchla SO": "711322",
      "Ramkrishnapur SO": "711101",
      "Sankrail SO": "711313",
      "Sarat Chatterjee Rd SO": "711104",
      "Shyampur SO Howrah": "711314",
      "Paniara S.O": "711331",
      "Bhairab Dutta Lane SO": "711106",
      "Ghoshpara SO Howrah": "711227",
      "Anantapur SO Howrah": "711301",
      "Baisnabpara Bazar SO": "711102",
      "Balitikuri SO": "711113",
      "Circular Rd SO": "711104",
      "Khurut Rd SO": "711101",
      "Makardaha SO": "711409",
      "Radhadasi SO": "711317",
      "Ramrajatala SO": "711104",
      "Sibpur Bazar SO": "711102",
      "Bally Goswami Rd SO": "711201",
      "Bally SO": "711201",
      "Daws Temple Rd SO": "711205",
      "Ghusuri SO": "711107",
      "Howrah Loco Depot SO": "711106",
      "Andul mouri SO": "711302",
      "BGarden SO": "711103",
      "Bakultala SO": "711109",
      "Bauria SO": "711305",
      "Belgachia Mansatala SO": "711105",
      "Bharat Cooperative SO": "711313",
      "Chackasi SO": "711307",
      "Chakraberia SO": "711104",
      "Domjur SO": "711405",
      "Jagacha SO": "711111",
      "Maju SO": "711414",
      "Munshirhat SO": "711410",
      "Pachalbazar SO": "711101",
      "Ross Road SO": "711101",
      "Sibpur SO": "711102",
      "TMG Lane SO": "711102",
      "Udaynarayanpur SO": "711226",
      "Uluberia SO": "711315",
      "AGuha Road SO": "711204",
      "ARoadBamungachi SO": "711106",
      "Bamungachi SO": "711106",
      "Belur Bazar SO": "711202",
      "Belur Math SO": "711202",
      "Hooghly Dock SO": "711106"
    },
    "DINAJPUR UTTAR": {
      "Chapore BO": "733208",
      "Gohara BO": "733208",
      "Nando BO": "733208",
      "Tarial BO": "733208",
      "Bahin BO": "733134",
      "Bhitiar BO": "733134",
      "Madhupur Barduari BO": "733134",
      "Raipur BO": "733134",
      "Bhaispitta BO": "733207",
      "Gharugachh BO": "733207",
      "Bidyanandapur BO": "733208",
      "Bhebra BO": "733208",
      "Khikirtola BO": "733208",
      "Harigram BO": "733134",
      "Khalshi BO": "733134",
      "Chandanidanga BO": "733207",
      "Chargharia BO": "733207",
      "Chopra BO": "733207",
      "Daspara BO": "733207",
      "Debijhora BO": "733207",
      "Dighabanahat BO": "733207",
      "Gendagachh BO": "733207",
      "Hasua Samadhimath BO": "733143",
      "Kamlai BO": "733143",
      "Basian BO": "733156",
      "Laxmonia BO": "733156",
      "Maharajahat BO": "733156",
      "Bazargaon BO": "733201",
      "Lalganj BO": "733201",
      "Maheshpur BO": "733201",
      "Shikarpur BO": "733201",
      "Paschim Manoharpur BO": "733123",
      "Tenohari BO": "733123",
      "Bekidanga BO": "733143",
      "Bhagnail BO": "733143",
      "Bharatpur BO": "733156",
      "Bhatolhat BO": "733156",
      "Rashokhowahat BO": "733201",
      "Sripur BO": "733201",
      "Birghai BO": "733123",
      "Gorahar BO": "733123",
      "Hatia BO": "733123",
      "Ital BO": "733123",
      "Amalia BO": "733208",
      "Ikarchala BO": "733208",
      "Kaniabhita BO": "733208",
      "Pokhoria BO": "733208",
      "Baharail BO": "733134",
      "Bhogram BO": "733134",
      "Bilashpur BO": "733134",
      "Samaspur BO": "733134",
      "Sasan BO": "733134",
      "Subhashganj BO": "733134",
      "Taherpur BO": "733134",
      "Khunia BO": "733207",
      "Kuchilagoan BO": "733207",
      "Lakshipur BO": "733207",
      "Manikpur BO": "733207",
      "Narayanpur BO": "733207",
      "Sujali BO": "733207",
      "Durlavpur BO": "733143",
      "Hatgachhi BO": "733143",
      "Khokshan BO": "733156",
      "Panchbhaya BO": "733156",
      "Chakulia Hat BO": "733208",
      "Goalgoan BO": "733208",
      "Sakuntala BO": "733208",
      "Thakurbari BO": "733208",
      "Bamangram BO": "733134",
      "Bangalbari BO": "733134",
      "Lohanda BO": "733134",
      "Panishalahat BO": "733134",
      "Asharubasti BO": "733207",
      "Kaimari BO": "733207",
      "Molani BO": "733207",
      "Patnaur BO": "733201",
      "Bariol BO": "733123",
      "Keotal BO": "733123",
      "Rupahar BO": "733123",
      "Paraharipur BO": "733143",
      "Parbatipur BO": "733143",
      "Parergram BO": "733143",
      "Sonapur BO": "733143",
      "Chainagar BO": "733156",
      "Kantore BO": "733156",
      "Andharia BO": "733201",
      "Jagadishpur BO": "733201",
      "Khurka BO": "733201",
      "Magnavita BO": "733201",
      "Bahar BO": "733210",
      "Goti BO": "733210",
      "Lalkuri BO": "733210",
      "Malkunda BO": "733210",
      "Sahapur BO": "733210",
      "Solpara BO": "733210",
      "Amaljhari BO": "733202",
      "BurhijagirBO": "733202",
      "State Farm Colony BO": "733202",
      "Chavote BO": "733128",
      "Chhayghara BO": "733128",
      "Gulandar BO": "733128",
      "Kapasia BO": "733128",
      "Marnai BO": "733128",
      "Nomunia BO": "733128",
      "Krishnabati BO": "733129",
      "Kunor BO": "733129",
      "Madhabpur BO": "733129",
      "Betna BO": "733210",
      "Debiganj BO": "733210",
      "Jharbari BO": "733210",
      "Runia BO": "733156",
      "Dimrulla BO": "733202",
      "Gunjaria Bazar BO": "733202",
      "Jagtagaon BO": "733202",
      "Kalanagin BO": "733202",
      "Panchdimthi BO": "733202",
      "Srikrishnapur Colony BO": "733202",
      "Joyhat BO": "733128",
      "Tilna BO": "733128",
      "Bhelai BO": "733129",
      "Dhankoil Hat BO": "733129",
      "Tungail Bilpara BO": "733129",
      "Galia BO": "733209",
      "Hassan BO": "733209",
      "Sayedpur Bhamantali BO": "733209",
      "Kamartore BO": "733215",
      "Sawdhan BO": "733215",
      "Tungidighi BO": "733215",
      "Bhabanbari BO": "733210",
      "Hatkholasahapur BO": "733210",
      "Khagore BO": "733210",
      "Kichaktola BO": "733210",
      "Dhantala BO": "733202",
      "Dulalibhita BO": "733202",
      "Matikundahat BO": "733202",
      "Sonapur Hat BO": "733202",
      "Churaman BO": "733128",
      "Kalaibari BO": "733128",
      "Patirajpur BO": "733128",
      "Radhanagar BO": "733128",
      "Dalimgaon BO": "733129",
      "Faridpur BO": "733129",
      "Puria BO": "733129",
      "Radhikapur BO": "733129",
      "Tamchari Mathbari BO": "733129",
      "Asuragarh BO": "733209",
      "Bagdob BO": "733209",
      "Monora BO": "733209",
      "Surjapur BO": "733209",
      "Doarin BO": "733215",
      "Dadhikotbari BO": "733130",
      "Mirual BO": "733130",
      "Raghunathpur BO": "733129",
      "Bharna BO": "733209",
      "Nizampur BO": "733209",
      "Simalia BO": "733209",
      "Domohana BO": "733215",
      "Madargachhi BO": "733215",
      "Hemtabad BO": "733130",
      "Baramajlishpur BO": "733210",
      "Barbilla BO": "733210",
      "Bhendabari BO": "733210",
      "Dehar BO": "733210",
      "Gendabari BO": "733210",
      "Goagaon BO": "733210",
      "Goalin BO": "733210",
      "Sandhiya BO": "733125",
      "Haptiagachh BO": "733202",
      "Khunti BO": "733202",
      "Kodaldaha BO": "733202",
      "Larukhoa Gobindapur BO": "733202",
      "Baidara BO": "733128",
      "Akhanagar BO": "733129",
      "Baghan BO": "733129",
      "Bhanail BO": "733129",
      "Malgaon BO": "733129",
      "Manoharpur BO": "733129",
      "Mudafat BO": "733129",
      "Tarangapur BO": "733129",
      "Hatwar BO": "733209",
      "Majlishpur BO": "733209",
      "Altapur BO": "733215",
      "Fatepur Hat BO": "733132",
      "Majhihar BO": "733132",
      "Raiganj Town SO": "733134",
      "Rashbehari Market SO": "733134",
      "Ramganj SO North Dinajpur": "733207",
      "Sudarshanpur SO": "733134",
      "Raiganj SO": "733134",
      "Kanki SO": "733209",
      "Karandighi SO": "733215",
      "Karnojora SO": "733130",
      "Dalkhola SO": "733201",
      "Itahar SO": "733128",
      "Panjipara SO": "733208",
      "Debinagar SO": "733123",
      "Industrial Market SO": "733134",
      "Islampur Court SO": "733202",
      "Kaliyaganj Collegepara SO": "733129",
      "Mahendraganj SO North Dinajpur": "733129",
      "Mohanbati SO": "733134",
      "Raiganj Bandar SO": "733134",
      "Atrai SO": "733158",
      "Bhupalpur SO": "733143",
      "Bindole SO": "733156",
      "Goalpokher SO": "733210",
      "Islampur SO North Dinajpur": "733202",
      "Kaliyaganj SO": "733129"
    },
    "DINAJPUR DAKSHIN": {
      "Batun BO": "733133",
      "Gobindapur BO": "733133",
      "Fulbari BO": "733140",
      "Janchi BO": "733140",
      "Panchagram BO": "733140",
      "Chakbaliram BO": "733127",
      "Daralhat BO": "733127",
      "Kamdebbati BO": "733127",
      "Mahadebpur BO": "733127",
      "Telighata BO": "733127",
      "Thakurpurahat BO": "733145",
      "Bolla BO": "733158",
      "Amritakhanda Hat BO": "733103",
      "Biswanathpur BO": "733121",
      "Karai BO": "733121",
      "Nilgambhir BO": "733121",
      "Barakashipur BO": "733102",
      "Dakra BO": "733102",
      "Khanpur BO": "733133",
      "Nazirpur BO": "733133",
      "Radhakrishnapur BO": "733133",
      "Sayedpur BO": "733133",
      "Bandighi BO": "733140",
      "Deor BO": "733140",
      "Pransagar BO": "733140",
      "Holidana BO": "733127",
      "Laskarhat BO": "733127",
      "Ramchandrapur BO": "733127",
      "Tilon BO": "733127",
      "Jamalpur BO": "733145",
      "Kamarpara BO": "733145",
      "Powrahar BO": "733145",
      "Baul BO": "733158",
      "Amrail BO": "733103",
      "Banshihari BO": "733121",
      "Cheragipara BO": "733121",
      "Dikul BO": "733121",
      "Bharila BO": "733102",
      "Bhatra BO": "733102",
      "Belbari BO": "733124",
      "Bijoyshree BO": "733103",
      "Dakshin Shibrampur BO": "733103",
      "Khidirpur BO": "733103",
      "Sarangram BO": "733103",
      "Joredighi BO": "733121",
      "Karkha BO": "733121",
      "Kushkari BO": "733121",
      "Sudarshannagar BO": "733121",
      "Jalghar BO": "733102",
      "Kuaran BO": "733102",
      "Radhanagar BO": "733102",
      "Ramkrishnapur BO": "733140",
      "Ajmatpur BO": "733127",
      "Balapur BO": "733127",
      "Gopalbati BO": "733145",
      "Bedoypur BO": "733103",
      "Birohini BO": "733103",
      "Nunail BO": "733103",
      "Badalpur BO": "733121",
      "Manohali BO": "733142",
      "Beltara BO": "733133",
      "Mahanaj BO": "733140",
      "Banial BO": "733127",
      "Karaichenchra BO": "733127",
      "Patkola BO": "733127",
      "Chingishpur BO": "733145",
      "Durgapur BO": "733121",
      "Kalikamora BO": "733121",
      "Mahipal BO": "733121",
      "Sihole BO": "733121",
      "Gofanagar BO": "733102",
      "Khaspur BO": "733102",
      "Rajua BO": "733102",
      "Chenchra BO": "733124",
      "Jalalpur BO": "733124",
      "Laxmitola BO": "733124",
      "Nandanpur BO": "733124",
      "Angina BO": "733141",
      "Ashokegram BO": "733141",
      "Bhagabatipur BO": "733141",
      "Kumarganj BO": "733141",
      "Kuraha BO": "733141",
      "Narayanpur BO": "733141",
      "Samjhia BO": "733141",
      "Fatepur BO": "733126",
      "Trimohini BO": "733126",
      "Kaldighi BO": "733124",
      "Purba Mollapara BO": "733124",
      "Rajibpur BO": "733124",
      "Sarbamangala BO": "733124",
      "Chandganj BO": "733141",
      "Dangarhat BO": "733141",
      "Panitara BO": "733141",
      "Bairhatta BO": "733125",
      "Kanaipur BO": "733125",
      "Pundari BO": "733125",
      "Aminpur BO": "733132",
      "Chaksukdebpur BO": "733142",
      "Gurail BO": "733142",
      "Joypur BO": "733142",
      "Jahangirpur BO": "733124",
      "Kantabari BO": "733124",
      "Narai BO": "733124",
      "Raghabpur BO": "733124",
      "Bholanathpur BO": "733141",
      "Churail Krishnapur BO": "733141",
      "Mahipur BO": "733141",
      "Safanagar BO": "733141",
      "Bagichapur BO": "733125",
      "Maliandighi BO": "733125",
      "Hili Aftair BO": "733126",
      "Basoil BO": "733132",
      "Chousa BO": "733132",
      "Nahit BO": "733132",
      "Sahapur Jharbari BO": "733132",
      "Bhikahar BO": "733142",
      "Arajipanishalahat BO": "733132",
      "Berail BO": "733132",
      "Parameshwarpur BO": "733132",
      "Sarala BO": "733132",
      "Basuria BO": "733142",
      "Kardah BO": "733142",
      "Champatali BO": "733124",
      "Ratanpur BO": "733124",
      "Sukdebpur BO": "733124",
      "Debipur BO": "733141",
      "Jakhirpur BO": "733141",
      "Balihara BO": "733125",
      "Bartakigram BO": "733125",
      "Danagram BO": "733125",
      "Daulatpur South DinajpurBO": "733125",
      "Saiyadpur Nayapara BO": "733125",
      "Singadaha BO": "733125",
      "Baragarm BO": "733128",
      "Dehaband BO": "733132",
      "Manikore BO": "733132",
      "Sibkrishnapur BO": "733132",
      "Usha Haranhat BO": "733132",
      "Uttar Karanji BO": "733132",
      "Uttar Para BO": "733132",
      "Balurghat HO": "733101",
      "Tapan SO": "733127",
      "BaraRaghunathpur SO": "733103",
      "Beltala Park SO": "733103",
      "Chakbhabani SO": "733101",
      "Hili SO": "733126",
      "Kushmandi SO": "733132",
      "Patiram SO": "733133",
      "Rampur SO South Dinajpur": "733140",
      "School Para SO": "733101",
      "Teor SO": "733145",
      "Nayabazar SO South Dinajpur": "733142",
      "Balurghat Market SO": "733101",
      "Buniadpur SO": "733121",
      "Chakvrigu SO": "733102",
      "Harirampur SO": "733125",
      "Khadimpur SO": "733101",
      "Narayanpur SO South Dinajpur": "733101",
      "District School Board SO South Dinajpur": "733103",
      "Gangarampur SO": "733124",
      "Gopalganj SO": "733141"
    },
    "HOOGHLY": {
      "Pandugram BO": "712122",
      "Muktarpur Belekusma BO": "712616",
      "Ramnagar Mobarakpur BO": "712616",
      "Salepur BO": "712616",
      "Bhalia BO": "712615",
      "Golta BO": "712615",
      "Asudkhola BO": "712611",
      "Bhurkunda BO": "712611",
      "Khatul BO": "712611",
      "Salikona BO": "712611",
      "Mriga Chatra BO": "712602",
      "Naisarai BO": "712602",
      "Santoshpur BO": "712602",
      "Tirol BO": "712602",
      "Ratanpur BO": "712614",
      "Singrapur BO": "712614",
      "Sunia BO": "712614",
      "Beniajole BO": "712613",
      "Dihi Bagnan BO": "712613",
      "Duadanda BO": "712613",
      "Ghoshpur BO": "712613",
      "Baradigrui BO": "712412",
      "Narayanpur BO": "712412",
      "Tantisal BO": "712412",
      "Mandaran BO": "712612",
      "Paschimpara BO": "712612",
      "Satberia BO": "712612",
      "Sripur BO": "712612",
      "Hirapur BO": "712406",
      "Dihiboira BO": "712413",
      "Hatbasantapur BO": "712413",
      "Mostafapur BO": "712416",
      "Palaspai BO": "712416",
      "Sabalsingpur BO": "712417",
      "Patuligram BO": "712501",
      "Fului BO": "712122",
      "Santipur BO": "712122",
      "Shyambazar BO": "712122",
      "Tilari BO": "712122",
      "Dahia Kanda BO": "712616",
      "Dhulepur BO": "712616",
      "Radhaballavpur BO": "712616",
      "Karui BO": "712615",
      "Bhadur BO": "712602",
      "Maigram BO": "712602",
      "Nachipur BO": "712414",
      "Debkhanda BO": "712614",
      "Nakunda BO": "712614",
      "Kupsit BO": "712613",
      "Thakuranichak BO": "712613",
      "Chandraban BO": "712412",
      "Hiatpur BO": "712412",
      "Tarahat BO": "712612",
      "Kedarpur BO": "712406",
      "Routhkhana BO": "712406",
      "Chunait BO": "712413",
      "Balaichak BO": "712416",
      "Chingra BO": "712416",
      "Mar0khana BO": "712417",
      "Purba Krishnapur BO": "712415",
      "Jirat BO": "712501",
      "Panchpara BO": "712501",
      "Jharia BO": "712122",
      "Aslahari BO": "712616",
      "Daharkunda BO": "712617",
      "Kishorepur BO": "712617",
      "Mahisgot BO": "712617",
      "Mayalbandipur BO": "712617",
      "Alati BO": "712414",
      "Baikunthapur BO": "712414",
      "Kulbatpur BO": "712414",
      "Raghubati BO": "712614",
      "Nangulpara BO": "712406",
      "Pole BO": "712406",
      "Sonatikri BO": "712406",
      "Arandi BO": "712413",
      "Bachhanari BO": "712413",
      "Bairakanpur BO": "712413",
      "Keshabpur BO": "712413",
      "Madhabpur BO": "712413",
      "Madhurpur BO": "712413",
      "Ganderpukur BO": "712409",
      "Harishnagar BO": "712409",
      "Jamdara BO": "712410",
      "Keshabchak BO": "712410",
      "Samserpur BO": "712410",
      "Balarambati BO": "712409",
      "Basubati BO": "712409",
      "Dewanbheri BO": "712409",
      "Soaluk BO": "712410",
      "Talpur BO": "712410",
      "Teghari BO": "712410",
      "Parabagnan BO": "712413",
      "Dharasimul BO": "712416",
      "Harishchak BO": "712416",
      "Bonhijli BO": "712417",
      "Bhuerah BO": "712415",
      "Hati BO": "712415",
      "Jasar BO": "712415",
      "Ektarpur BO": "712123",
      "Inchura Bazar BO": "712123",
      "Selampur BO": "712122",
      "Damodarpur BO": "712616",
      "Kumursha BO": "712616",
      "Saora BO": "712616",
      "Chuadanga BO": "712617",
      "Gujrat BO": "712617",
      "Manikpat BO": "712617",
      "Moloypur BO": "712615",
      "Senai BO": "712611",
      "Bajua BO": "712602",
      "Gobindapur BO": "712602",
      "Ghargohal BO": "712414",
      "Nimdangi BO": "712414",
      "Kantali BO": "712614",
      "Laluka BO": "712614",
      "Paba BO": "712614",
      "Jagatnagar BO": "712409",
      "Pilkhan BO": "712613",
      "Kaiba BO": "712412",
      "Mainan BO": "712406",
      "Patul BO": "712406",
      "Udaypur BO": "712406",
      "Balundi BO": "712413",
      "Dakshin Rasulpur BO": "712413",
      "Balpai BO": "712416",
      "Chakhayatpur BO": "712416",
      "Ranjitbati BO": "712416",
      "Jagatpur BO": "712417",
      "Nandanpur BO": "712417",
      "Harinkhola BO": "712415",
      "Pratapnagar SO HooghBO": "712415",
      "Ragpur BO": "712415",
      "Basna BO": "712501",
      "Milangarh BO": "712501",
      "Debanandapur BO": "712123",
      "Manaspur BO": "712123",
      "Mirjapur Bankipur BO": "712409",
      "Paltagarh BO": "712409",
      "Singherbheri BO": "712409",
      "Bhangamora BO": "712410",
      "Bhata BO": "712410",
      "Bishnupur BO": "712410",
      "Duttapur BO": "712410",
      "Kumrul BO": "712410",
      "Madpur BO": "712410",
      "Rasulpur BO": "712410",
      "Dihiratanpur BO": "712409",
      "Gopalnagar Harharia BO": "712409",
      "Jalaghata BO": "712409",
      "Karicharbheri BO": "712409",
      "Baligori BO": "712410",
      "Kashipur BO": "712410",
      "Ketera BO": "712410",
      "Sainta BO": "712410",
      "Shyampur BO": "712410",
      "Aniya BO": "712706",
      "Dakshindihi BO": "712706",
      "Dearah BO": "712223",
      "Ramnagar BO": "712410",
      "Antpur BO": "712408",
      "Paschimtajpur BO": "712706",
      "Chandanpur BO": "712223",
      "Nasibpur BO": "712223",
      "Pahalampur BO": "712223",
      "Kumarpara BO": "712223",
      "Furfura BO": "712706",
      "Ilahipur BO": "712706",
      "Chinamore BO": "712223",
      "Mohistikri BO": "712223",
      "Mollasimla BO": "712223",
      "Saradapally BO": "712124",
      "Ankriserampore BO": "712401",
      "Dalapatipur BO": "712403",
      "Dwarhatta BO": "712403",
      "Katsara BO": "712102",
      "Sogandha BO": "712102",
      "Dedhara BO": "712302",
      "Kankrakuli BO": "712302",
      "Mazinan BO": "712302",
      "Rudrani BO": "712302",
      "Digra BO": "712512",
      "Krishanbatichar BO": "712512",
      "Rabindranagar BO": "712103",
      "Radhanagar BO": "712147",
      "Dumurdaha BO": "712515",
      "Pakri BO": "712148",
      "Patna BO": "712148",
      "Ramnathpur BO": "712148",
      "Sarai BO": "712149",
      "Satithan BO": "712149",
      "Makalpur BO": "712305",
      "Nagbal BO": "712305",
      "Hawakhana BO": "712403",
      "Kharsarai BO": "712304",
      "Monirampur BO": "712304",
      "Lakshmanpur BO": "712404",
      "Mundalika BO": "712404",
      "Prasadpur BO": "712404",
      "Jejur BO": "712405",
      "Kaikala BO": "712405",
      "Kalachara BO": "712702",
      "Masjid Lane BO": "712202",
      "Mankundu GovtColony BO": "712139",
      "Bandhpur BO": "712701",
      "Haripur BO": "712701",
      "Jangalpara Bazar BO": "712701",
      "Bamunari BO": "712250",
      "Mollerberh BO": "712250",
      "Kinkarbati BO": "712407",
      "Rashidpur BO": "712408",
      "Kumarganj BO": "713427",
      "GOPINAGAR BO": "712402",
      "Kananadi BO": "712302",
      "Bakuliagram BO": "712512",
      "Jolekul BO": "712303",
      "Sankarpur BO": "712303",
      "Mohipalpur BO": "712146",
      "Chatosarsa BO": "712147",
      "Bighati BO": "712124",
      "Chopa BO": "712308",
      "Gurbari BO": "712308",
      "Akna BO": "712148",
      "Digsui BO": "712148",
      "Sultangacha BO": "712148",
      "Aymanawabpur BO": "712149",
      "Dwarbasini BO": "712149",
      "Magura BO": "712149",
      "Mohanad BO": "712149",
      "Alipur BO": "712305",
      "Danrpur BO": "712305",
      "Goswamimalipara BO": "712305",
      "Porabazar BO": "712305",
      "Sinhet BO": "712305",
      "Chandpur BO": "712152",
      "Balipur BO": "712401",
      "Chiladangi BO": "712401",
      "Parshyampur BO": "712401",
      "Jangalpara BO": "712401",
      "Chakundi BO": "712310",
      "Mrigala BO": "712311",
      "Mora BO": "712403",
      "Chikranda BO": "712304",
      "Dilakash BO": "712404",
      "Krishnanagar BO": "712404",
      "Palpara BO": "712138",
      "Bajitpur BO": "712405",
      "Malia BO": "712405",
      "Paniseola BO": "712405",
      "Simla BO": "712203",
      "Bandipur BO": "712407",
      "Beraberi BO": "712407",
      "Nutangram BO": "712249",
      "Poshpur BO": "712408",
      "Chenchua BO": "712402",
      "Boso BO": "712302",
      "Hazipur BO": "712302",
      "Lokabati BO": "712302",
      "Aidakismat BO": "712512",
      "Dhobapara BO": "712512",
      "Palasi BO": "712303",
      "BIKRAMNAGORE BALI BO": "712103",
      "Jamgram BO": "712146",
      "KHANYAN BO": "712147",
      "Baneswarpur BO": "712515",
      "Kharua BO": "712308",
      "POLBA BO": "712148",
      "Talandu BO": "712148",
      "Amra BO": "712149",
      "BELOON BO": "712149",
      "Hanral BO": "712149",
      "Khajurdaha BO": "712149",
      "Megshar BO": "712149",
      "Panchgora BO": "712149",
      "Tinna BO": "712149",
      "Harit BO": "712305",
      "Pawnan BO": "712305",
      "Dabra BO": "712152",
      "Nanda BO": "712124",
      "Astara BO": "712401",
      "Binagram BO": "712401",
      "Pursurah BO": "712401",
      "Garalgacha BO": "712311",
      "Basuri BO": "712403",
      "Paschimgopinathpur BO": "712403",
      "Baksha BO": "712304",
      "Dingalhati BO": "712404",
      "Kulakash BO": "712404",
      "Satghara BO": "712404",
      "Noapara BO": "712138",
      "Bahirkhand BO": "712405",
      "Brahmanpara BO": "712405",
      "Musapur BO": "712405",
      "Bahirserampore BO": "712203",
      "Akuni BO": "712701",
      "Bhagabatipur BO": "712701",
      "Nawabpur BO": "712701",
      "Bajemalia BO": "712407",
      "Chitrasali BO": "712407",
      "Pargopalnagar BO": "712407",
      "Guti BO": "712408",
      "Charpur BO": "712706",
      "Antisara BO": "712223",
      "Belumilki BO": "712223",
      "Anandanagar BO": "712409",
      "Baratajpur BO": "712306",
      "Baruipara BO": "712306",
      "Bora BO": "712306",
      "Borai BO": "712306",
      "Gangadharpur Bazar BO": "712306",
      "Panchgharabazar BO": "712306",
      "Aimapaharpur BO": "712401",
      "Gholdigrui BO": "712401",
      "Moktarpur BO": "712401",
      "Ramnarayanpur BO": "712401",
      "Naity BO": "712702",
      "Kristorampur BO": "712702",
      "Kumirmorah BO": "712702",
      "Jagalgori BO": "712403",
      "Baganda BO": "712404",
      "Jarura BO": "712138",
      "Rajendra Avenue BO": "712245",
      "Raghunathpur BO": "712245",
      "Barabahera BO": "712246",
      "Nimdanga BO": "712402",
      "Routhpur BO": "712402",
      "Sahabazar BO": "712402",
      "BELMURI BO": "712302",
      "Naldanga BO": "712123",
      "Somra BO": "712123",
      "Mandra BO": "712301",
      "Barul BO": "712134",
      "Raijamna BO": "712134",
      "Balidaha BO": "712303",
      "Bhastara BO": "712303",
      "Cheragram BO": "712303",
      "Ghosla BO": "712303",
      "Brindabanpur BO": "712146",
      "Gajinadaspur BO": "712146",
      "Haridaspur BO": "712147",
      "Hoera BO": "712147",
      "Barunanpara BO": "712148",
      "Gopalpur BO": "712513",
      "Bhitasin BO": "712149",
      "Ranagarh BO": "712149",
      "Rosna BO": "712149",
      "Ati BO": "712305",
      "Babnan BO": "712305",
      "Gobarara BO": "712305",
      "Melki BO": "712152",
      "Jayer BO": "712152",
      "Rajhat BO": "712123",
      "New Chandpur BO": "712301",
      "Bhonpur BO": "712134",
      "Bilsara BO": "712134",
      "Hanraldaspur BO": "712134",
      "Hatni BO": "712134",
      "Haripur Chak BO": "712407",
      "Kamarkundu BO": "712407",
      "Rahimpur BO": "712408",
      "Chawk Bansberia BO": "712502",
      "Alipur Nayanagar BO": "712301",
      "Dakshin Basudebpur BO": "712301",
      "SIMLAGARH BO": "712135",
      "Kamdebpur BO": "712102",
      "Dharampur BO": "712105",
      "Ghoradaha BO": "721212",
      "Bagnan Chaitanyabati BO": "712301",
      "Kanui Banka BO": "712301",
      "Berela BO": "712134",
      "Insura BO": "712134",
      "KAMARPARABAZAR BO": "712105",
      "Kanakshally BO": "712105",
      "Arambagh HO": "712601",
      "Chinsurah HO": "712101",
      "Serampore HO": "712201",
      "Bandar BO": "721212",
      "Talbona BO": "712134",
      "Ballaldighi BO": "712135",
      "Jangipara SO": "712404",
      "Kalbazar SO": "712201",
      "Kanaipur SO": "712234",
      "Konnagar SO": "712235",
      "Mallickpara SO": "712203",
      "Manicktala Bazar SO": "712201",
      "Mankundu SO": "712139",
      "Rajbalhat SO": "712408",
      "Seakhala SO": "712706",
      "Serampore Court SO": "712201",
      "Tarakeswar Math SO": "712410",
      "Telinipara SO": "712125",
      "Khalisani SO": "712138",
      "Kundughat SO": "712136",
      "Mahesh 1 SO": "712202",
      "Makhla SO": "712245",
      "Rishra SO": "712248",
      "Sheoraphuli SO": "712223",
      "K G R S Path SO": "712124",
      "Mahesh 2 SO": "712248",
      "Masat SO": "712701",
      "Morepukur SO": "712250",
      "Nabagram SO Hooghly": "712246",
      "Nalikul SO": "712407",
      "Singur SO": "712409",
      "Khamarchandi SO": "712405",
      "Prabasnagar SO": "712249",
      "Rajabazar SO Hooghly": "712125",
      "Tarakeswar SO": "712410",
      "Uttarpara Bazar SO": "712258",
      "Uttarpara SO": "712258",
      "DANKUNI HOUSING COMPLEX SO": "712311",
      "Balidewanganj SO": "712616",
      "Batanal SO": "712615",
      "Goghat SO": "712614",
      "Balagarh SO": "712501",
      "Baidyabati SO": "712222",
      "Champadanga SO": "712401",
      "Champdani SO": "712222",
      "Angus SO": "712221",
      "Boraichanditala SO": "712136",
      "Chandannagar Barasat SO": "712136",
      "Chanditala SO": "712702",
      "Chatra SO Hooghly": "712204",
      "Chaulpatty SO": "712410",
      "Dankuni SO": "712311",
      "Hindmotor SO": "712233",
      "Bhadrakali SO": "712232",
      "Bhadreswar SO": "712124",
      "Dankuni Coal Complex SO": "712310",
      "Gondalpara SO": "712137",
      "Janai SO": "712304",
      "Baradangal SO": "712617",
      "Chandur SO Hooghly": "712602",
      "Gourhati SO": "712613",
      "Khanakul SO": "712406",
      "Natibpur SO": "712416",
      "Netaji Mahavidyalaya SO": "712601",
      "Rajhati Bandar SO": "712417",
      "Saidpur SO Hooghly": "712415",
      "Bhandarhati SO": "712301",
      "Chinsurah Bazar SO": "712101",
      "Guptipara SO": "712512",
      "Kapasdanga Roybazarcolony SO": "712103",
      "Keotalatbagan SO": "712104",
      "Khanpur SO Hooghly": "712308",
      "Pipulpati SO": "712103",
      "Rameswarpur SO": "712152",
      "Tribeni SO": "712503",
      "Boinchigram SO": "712135",
      "Buroshibtala SO Hooghly": "712105",
      "Chinsurah RS SO": "712102",
      "Dasghara SO": "712402",
      "Dhaniakhali SO": "712302",
      "Khamargachi SO": "712515",
      "Magra SO": "712148",
      "Nayasarai SO": "712513",
      "Pandua SO": "712149",
      "Sandeswartala JC SO": "712101",
      "Tamlipara SO": "712103",
      "Arambagh Court SO": "712601",
      "Bangurpark SO": "712248",
      "Begampur SO Hooghly": "712306",
      "Chandannagar RS SO": "712136",
      "Chandannagar SO Hooghly": "712136",
      "Criper Road SO": "712235",
      "Gandhisarak SO": "712248",
      "Haripal SO": "712403",
      "Helan SO": "712412",
      "Kamarpukur SO": "712612",
      "Krishnapur SO Hooghly": "712601",
      "Mayapur SO Hooghly": "712413",
      "Natunbazar SO Hooghly": "712601",
      "Addconagar SO": "712121",
      "Bandel Junction SO": "712123",
      "Chinsurah Court SO": "712101",
      "Ilsobamondalai SO": "712146",
      "Pratappur SO Hooghly": "712101",
      "Puinan SO": "712305",
      "Sripur Bazar SO Hooghly": "712514",
      "Badanganj SO": "712122",
      "Bengai SO": "712611",
      "Deulpara SO": "712414",
      "Bansberia Bazar SO": "712502",
      "Bansberia SO": "712502",
      "Boinchi SO": "712134",
      "Btps SO Hooghly": "712503",
      "Chandrahati SO": "712504",
      "Gurap SO": "712303",
      "Hooghly SO": "712103",
      "Itachuna SO": "712147",
      "Sahaganj SO": "712104",
      "Shibpur Bansberia SO": "712502"
    },
    "JALPAIGURI": {
      "Balaram BO": "735135",
      "Bhutkidangapara BO": "735135",
      "Futkipara BO": "735135",
      "Dhawlaguri BO": "735224",
      "Ulladabri BO": "735224",
      "Uttar Saptibari BO": "735224",
      "Dhapganj BO": "735132",
      "Garalbari BO": "735132",
      "Uttar Dhantala BO": "735132",
      "Dangapara BO": "735133",
      "Debithakurbari BO": "735133",
      "Karjeepara BO": "735133",
      "Kukurjan BO": "735133",
      "Patkata BO": "735133",
      "Satkhamar BO": "735133",
      "Shikarpur BO": "735133",
      "Fatapukur BO": "735134",
      "Karbala BO": "735202",
      "Ambaribagan BO": "735207",
      "Chaulhati BO": "735102",
      "Payachari BO": "735135",
      "Sahudangirhat BO": "735135",
      "Amguri Bazar BO": "735224",
      "Banesh Jn BO": "735224",
      "Benkandi BO": "735224",
      "Jabramali BO": "735224",
      "Jalpesh Mandir BO": "735224",
      "Madhabdanga BO": "735224",
      "Madhya Khagrabari BO": "735224",
      "Purba Duramari BO": "735233",
      "Kadobarihat BO": "735132",
      "Kamatpara BO": "735132",
      "Tahasildarbari BO": "735133",
      "Kathalguri BO": "735202",
      "Mogolkata BO": "735202",
      "Red Bank BO": "735202",
      "Sadhupur Chengmari BO": "735205",
      "Batabari BO": "735206",
      "Ananda Pur BO": "735218",
      "Chapadanga BO": "735218",
      "Chakmoulani BO": "735219",
      "Kajoldighi BO": "735219",
      "Panbari BO": "735219",
      "Indong BO": "735223",
      "Champaguri BO": "735225",
      "Jiti BO": "735225",
      "Dumchipara BO": "735228",
      "Kharia BO": "735102",
      "Menghora BO": "735135",
      "Monuaganj BO": "735135",
      "Bhangamali BO": "735224",
      "Churabhander BO": "735224",
      "Nutan Bazar BO": "735224",
      "Bamoni BO": "735233",
      "Garialtari BO": "735233",
      "Brajapur BO": "735132",
      "Malkanipara Nayahat BO": "735132",
      "Seerampara BO": "735132",
      "Bhaktipara BO": "735133",
      "Mantadari BO": "735133",
      "Saraswatipur Bagan BO": "735133",
      "Nakugach BO": "735134",
      "Sawdavita BO": "735134",
      "Debpara BO": "735202",
      "Haihaipathar BO": "735230",
      "Khairanti BO": "735218",
      "Malhati BO": "735218",
      "Ramsaihat BO": "735219",
      "Boalmari BO": "735122",
      "Khayerbari BO": "735122",
      "Manikganjhat BO": "735122",
      "Satkura BO": "735122",
      "Dakhin Dhulagaon BO": "735216",
      "Debnagar BO": "735102",
      "Mohitnagar BO": "735102",
      "Kunderdighi BO": "735135",
      "Mohanvita BO": "735135",
      "Bhangerhat BO": "735224",
      "Dakshin Mouamari BO": "735224",
      "Saptibari BO": "735224",
      "Tekatuli BO": "735224",
      "Lakshmikantapara BO": "735233",
      "Berubari BO": "735132",
      "Kuripara BO": "735132",
      "Mandalghat BO": "735132",
      "Belacoba BO": "735133",
      "Milanpally BO": "735133",
      "Gadra BO": "735134",
      "Sahebpara BO": "735134",
      "Panpara BO": "735101",
      "Chanda Company BO": "734501",
      "Angrabhasa BO": "735202",
      "Kalabari Bagan BO": "735202",
      "Neora BO": "735230",
      "Mathachulka BO": "735206",
      "Chengmari BO": "735218",
      "Kathambari BO": "735218",
      "Purbadalaigaon BO": "735218",
      "Patharjhora BO": "735222",
      "Bataigole Bazaar BO": "735221",
      "Rungamatee BO": "735229",
      "East Bhaktinagar BO": "734007",
      "Satellite Township BO": "734015",
      "Dharampur BO": "735305",
      "Helapakri BO": "735305",
      "Jorepakri BO": "735305",
      "Padamati BO": "735305",
      "Putimari BO": "735305",
      "Talma BO": "735121",
      "Vivekananda Pally BO": "735121",
      "Gossairhat BO": "735210",
      "Jharsalbari BO": "735210",
      "Jurapani BO": "735210",
      "Kalirhat BO": "735210",
      "Kathapara BO": "735210",
      "Bakali BO": "735305",
      "Bhuskadanga BO": "735305",
      "Bahadur BO": "735121",
      "Paharpur BO": "735121",
      "Rangdhamali BO": "735121",
      "Dakhin Khattimari BO": "735210",
      "Daukimari BO": "735210",
      "Paschim Mallick Para BO": "735210",
      "Salbari BO": "735210",
      "Bagjan BO": "735302",
      "Pradhanpara BO": "735212",
      "Sakoajhora BO": "735212",
      "Ghugumali BO": "734006",
      "Haidarpara BO": "734006",
      "Dabgram BO": "734004",
      "Kailashpur BO": "735218",
      "Rajadanga BO": "735218",
      "Oodlabari BO": "735222",
      "Sulkapara BO": "735225",
      "Pangasahebbari BO": "735121",
      "Altagram Magurmari BO": "735210",
      "Bairatiguri BO": "735210",
      "Barogharia BO": "735210",
      "Dakshin Khyerbari BO": "735210",
      "Vidyashram BO": "735210",
      "Boulbari BO": "735302",
      "Kumarpara BO": "735302",
      "Singimari BO": "735302",
      "Kharija Berubari BO": "735122",
      "Barakamat BO": "735305",
      "Dangapara Ashram BO": "735305",
      "Barapatia Natunbas BO": "735121",
      "Kantipara BO": "735121",
      "Bhandani BO": "735210",
      "Patkidaha BO": "735210",
      "Sajnapara BO": "735212",
      "Bhabani Nagar BO": "735122",
      "Fulbarihat BO": "734015",
      "Kachua BO": "735122",
      "Jalpaiguri HO": "735101",
      "Mal HO": "735221",
      "Jpg College Para SO": "735101",
      "Kadamtala SO Jalpaiguri": "735101",
      "Kamarvita SO": "735135",
      "Nathuahat SO": "735233",
      "Prasannanagar SO": "735133",
      "Rajganj SO": "735134",
      "Chamurchi SO": "735207",
      "Gajoldoba SO": "735234",
      "Matelli SO": "735223",
      "Panwar Busty SO": "735221",
      "Lake Town SO Darjiling": "734007",
      "Rabindra Sarani SO": "734006",
      "Saktigarh SO Jalpaiguri": "734001",
      "Bhaktinagar SO": "734007",
      "Bhotepatty SO": "735305",
      "Jpg Court SO": "735101",
      "Jpg Hindustan Ins SO": "735101",
      "JpgGovt Engg College SO": "735102",
      "Mohantapara SO": "735101",
      "Pandapara Kalibari SO": "735132",
      "Race Cource Para SO": "735101",
      "Rajbari Para SO": "735101",
      "Baradighi SO": "735230",
      "Binnaguri SO": "735203",
      "Carron SO": "735205",
      "Manabari SO": "735222",
      "Sailihat SO": "735229",
      "Dhupguri SO": "735210",
      "Mahananda Project SO": "734015",
      "Rath Khola SO": "734001",
      "Subashpally SO": "734001",
      "Gairkata SO": "735212",
      "Jpg Dist School Board SO": "735101",
      "Maynaguri SO": "735224",
      "Senpara SO": "735101",
      "Bagrakote SO": "734501",
      "Banarhat SO": "735202",
      "Nagrakata SO": "735225",
      "Danguajhar SO": "735121",
      "Dinbazar SO": "735101",
      "Desbandhupara SO": "734004",
      "Vivekanandapally SO": "734001",
      "Jalpaiguri Bank SO": "735101",
      "Silpasamiti Para SO": "735101",
      "West Congress Para SO": "735101",
      "Binnaguri Cantt SO": "735232",
      "Chalsa SO": "735206",
      "Damdim SO": "735209",
      "Krantihat SO": "735218",
      "Lataguri SO": "735219",
      "Siliguri Road SO": "734001",
      "Adarpara SO": "735101",
      "Bowbazar SO Jalpaiguri": "735101",
      "Domohani SO": "735302"
    },
    "KOLKATA": {
      "Chowbaga BO": "700105",
      "Kolkata University SO": "700073",
      "Lalbazar SO": "700001",
      "Treasury Building SO": "700001",
      "Sinthee SO": "700050",
      "Ram Krishna Samadhi Road SO": "700054",
      "Sales Tax Building SO": "700015",
      "Seal Lane SO": "700015",
      "Taltala SO": "700014",
      "Tangra SO": "700015",
      "Tiljala SO": "700039",
      "Khengrapatti SO": "700001",
      "New Secretariat Building SO": "700001",
      "Reserve Bank Building SO": "700001",
      "Strand Road SO": "700007",
      "Telephone Bhawan SO": "700001",
      "West Bengal Governors Camp SO": "700062",
      "Cossipore Gun Factory SO": "700002",
      "Tala SO": "700002",
      "College Square SO": "700007",
      "R N Mukherjee Road SO": "700001",
      "Radhabazar SO": "700001",
      "Writers Building SO": "700001",
      "Indian Research SO": "700002",
      "Kolkata Armed Police SO": "700002",
      "Northern Avenue SO": "700037",
      "Postal Stores Depot SO": "700002",
      "Satchasipara SO": "700002",
      "South Sinhee SO": "700050",
      "Jhowtala SO": "700017",
      "Joramandir SO": "700010",
      "KG Bose Sarani SO": "700085",
      "Kankurgachi SO": "700054",
      "Narkeldanga SO": "700011",
      "Park Circus SO": "700017",
      "Subhash Sarabor SO": "700010",
      "Vip Nagar SO": "700100",
      "Circus Avenue SO": "700017",
      "Cmda Abasan SO": "700054",
      "Dhapa SO": "700105",
      "Intally SO": "700014",
      "Parsibagan SO": "700009",
      "Phulbagan SO": "700054",
      "Colootala  SO": "700073",
      "Council House Street SO": "700001",
      "Customs House  SO": "700001",
      "Tiretta Bazar SO": "700073",
      "West Bengal Assembly PO": "700001",
      "Belgachia Road SO": "700037",
      "Belgachia SO": "700037",
      "Ghugudanga SO": "700030",
      "Paikpara SO": "700002",
      "RGKar Medical College SO": "700004",
      "Raja Ram Mohan Sarani SO": "700009",
      "Sankaritola SO": "700012",
      "Tiljala Bazar SO": "700039",
      "Topsia SO": "700039",
      "Tollygunge HO": "700033",
      "Kolkatta GPO": "700001",
      "Gobinda Khatick Road SO": "700046",
      "Linton Street SO": "700014",
      "Picnic Garden SO": "700039",
      "Elliot Road SO": "700016",
      "Esplanade SO": "700069",
      "Little Russel Street SO": "700071",
      "Russel Street SO": "700071",
      "Shakespeare Sarani SO": "700017",
      "Chittaranjan Avenue SO Kolkata": "700073",
      "Fort William SO": "700021",
      "Income Tax Building SO": "700069",
      "Middleton Row SO": "700071",
      "Princep Street SO": "700072",
      "Bamboovila SO": "700014",
      "Baghajatin SO": "700086",
      "Bhawanipore SO": "700025",
      "Bosepukur Road SO": "700042",
      "EKT SO": "700107",
      "Garcha Road SO": "700019",
      "Haridevpur SO": "700082",
      "KMHospital SO": "700020",
      "KPRoy Lane SO": "700031",
      "Kalighat SO": "700026",
      "Lansdowne Market SO": "700025",
      "Naktala SO": "700047",
      "Regent Park SO": "700040",
      "Baishnab Ghata Patuli Township SO": "700094",
      "PURBACHAL MAIN ROAD SO": "700078",
      "Bakery Road SO": "700022",
      "Ballygunge SO": "700019",
      "Ballygunge Sc College SO": "700019",
      "Bijoygarh SO": "700032",
      "Ganguly Bagan SO": "700047",
      "Garia BT SO": "700047",
      "Haltu SO": "700078",
      "KPBazar SO Kolkata": "700082",
      "LRSarani SO": "700020",
      "Lake Gardens SO": "700045",
      "Panchasayar SO": "700094",
      "RKSeva Pratisthan SO": "700026",
      "Ramkrishna Park SO": "700025",
      "Regent Estate SO": "700092",
      "Madurdaha SO": "700107",
      "Sakuntala Park SO": "700061",
      "Abinash Chaowdhury Lane SO": "700046",
      "Bengal Chemical SO": "700054",
      "Bowbazar SO Kolkata": "700012",
      "Dharmatala SO": "700013",
      "Madrassa SO": "700016",
      "Sooterkin Street SO": "700072",
      "Dhakuria SO": "700031",
      "Gokhel Road SO": "700020",
      "Golf Green SO": "700095",
      "Hastings SO": "700022",
      "Indrani Park SO": "700033",
      "Kalikapur SO": "700099",
      "Kasba SO Kolkata": "700042",
      "Pgh Shah Road SO": "700032",
      "Raipur Jorabagan Road SO": "700047",
      "Russa SO": "700040",
      "Sahanagar SO Kolkata": "700026",
      "Santoshpur Avenue SO": "700075",
      "Southern Market SO": "700026",
      "TCRoad SO": "700033",
      "Viveknagar SO Kolkata": "700075",
      "Alipore HO": "700027",
      "AJCBose Road SO": "700020",
      "Ballygunge RS SO": "700019",
      "Garfa SO": "700075",
      "Gariahat Market SO": "700019",
      "Golpark SO": "700019",
      "Jadavgarh SO": "700078",
      "Jadavpur University SO": "700032",
      "Jodhpur Park SO": "700068",
      "Keoratala SO": "700026",
      "Mukundapur SO": "700099",
      "Netaji Nagar SO Kolkata": "700040",
      "Paschim Putiari SO": "700041",
      "Santoshpur SO": "700075",
      "Sirity SO": "700041",
      "Park Street HO": "700016",
      "Beleghata HO": "700010",
      "Bediadanga SO": "700039",
      "Barabazar H O": "700007",
      "Cossipore HO": "700002",
      "Asylum Lane SO": "700014",
      "Hindustan Building SO": "700072",
      "New Market SO": "700087",
      "Pollock Street SO": "700073",
      "Yogayog Bhawan SO": "700012",
      "Girish Avenue SO": "700003",
      "Badartala SO": "700044",
      "KCMills SO": "700024",
      "Kalagachia SO Kolkata": "700063",
      "Kolkata Mint SO": "700053",
      "Rabindra Nagar SO Kolkata": "700018",
      "Sarsoona SO": "700061",
      "Alipore Bodyguard Line SO": "700027",
      "Barisha SO": "700008",
      "Behala Municipal Market SO": "700034",
      "Bidhangarh SO": "700066",
      "Dover Lane SO": "700029",
      "Jairampur SO Kolkata": "700061",
      "Kalimandir SO": "700026",
      "Hatkhola SO": "700005",
      "Kalakar Street SO": "700007",
      "Manicktala SO": "700006",
      "Ultadanga Main Road SO": "700067",
      "Amrita Bazar Patrika SO": "700003",
      "Archana SO": "700007",
      "Bidhan Sarani SO": "700006",
      "Jorasanko SO": "700006",
      "Lily Biscuit SO": "700067",
      "Simla SO": "700006",
      "Vaishya Sabha SO": "700007",
      "Kasthadanga SO": "700061",
      "Mahendra Banerjee Road SO": "700060",
      "Mominpur SO": "700027",
      "Panchanantala SO": "700034",
      "Paschim Barisha SO": "700063",
      "Rash Behari Avenue SO": "700029",
      "Sahapur SO": "700038",
      "Senhati SO": "700034",
      "Alipore Civil Court SO": "700027",
      "Brahma Samaj Road SO": "700034",
      "Garden Reach SO": "700024",
      "Alipore Dist Board S.O": "700027",
      "Jayshree Park SO": "700034",
      "Khiddirpore SO": "700023",
      "PGReach SO": "700024",
      "Sarat Bose Road SO": "700029",
      "Sonai SO Kolkata": "700043",
      "Taratala Road SO": "700088",
      "Thakurpukur SO": "700063",
      "Sammilani Mahavidyalaya SO": "700094",
      "Bartala SO": "700018",
      "Behala SO": "700034",
      "Brace Bridge SO": "700088",
      "Chetla SO": "700027",
      "Kalabagan SO": "700053",
      "Lake Market SO": "700029",
      "Mansatala SO": "700023",
      "NRAvenue SO": "700053",
      "Natioinal Library SO": "700027",
      "New Alipore SO": "700053",
      "Parnasree Pally SO": "700060",
      "Rajabagan Dock Yard SO": "700044",
      "South Eastern Railway SO": "700043",
      "TGRoad SO": "700024",
      "Watgunge SO": "700023",
      "Pathuriaghata SO": "700006",
      "Ultadanga SO": "700004",
      "Dakshin Behala SO": "700061",
      "Telecom Factory S.O": "700088",
      "Raja J.N.Market S.O": "700023",
      "Sahitya Parisad SO": "700006",
      "Shyambazar Mail SO": "700004",
      "Ahiritola SO": "700005",
      "Baghbazar SO": "700003",
      "Beadon Street SO": "700006",
      "Bansdroni SO": "700070",
      "2CBPO": "900099"
    },
    "PURULIA": {
      "Madhukunda BO": "723121",
      "Monihara BO": "723121",
      "Chorpahari BO": "723121",
      "Gagnabad BO": "723121",
      "Ghatrangamati BO": "723121",
      "Kalapathar SO PuruliBO": "723121",
      "Nutangram BO": "723121",
      "Saltore BO": "723121",
      "Senera BO": "723121",
      "Hura Keshabpur BO": "723104",
      "Biltora BO": "723126",
      "Chuna BO": "723126",
      "Mamurjore BO": "723126",
      "Pithajore BO": "723126",
      "Ajodhya Hill BO": "723152",
      "Charida BO": "723152",
      "Matha Forest BO": "723143",
      "Bundwan Uttar BO": "723128",
      "Dhengakend BO": "723130",
      "Jabla BO": "723128",
      "Jangidiri BO": "723128",
      "Pirrah BO": "723128",
      "Simultard BO": "723128",
      "Dhadkidih BO": "723127",
      "Roladih BO": "723127",
      "Ankro BO": "723129",
      "Kumra BO": "723129",
      "Lata BO": "723129",
      "Pargelia BO": "723129",
      "Palma Penchara BO": "723102",
      "Durku BO": "723102",
      "Barabendya BO": "723201",
      "Durma BO": "723201",
      "Hatimuri BO": "723201",
      "Pipratard BO": "723201",
      "Thakursima BO": "723201",
      "Uparbatri BO": "723201",
      "Bishpuria BO": "723130",
      "Kaliabasa BO": "723130",
      "Lara BO": "723130",
      "Rakab BO": "723130",
      "Tanginayada BO": "723130",
      "Arjunjora BO": "723148",
      "Murulia BO": "723121",
      "Narayanpur BO": "723121",
      "Siyada BO": "723121",
      "Sonathali Ashram BO": "723121",
      "Bagalia BO": "723126",
      "Chowkibera BO": "723215",
      "Pundag BO": "723215",
      "Dava Torang BO": "723152",
      "Koreng BO": "723152",
      "Madla BO": "723152",
      "Ranga BO": "723152",
      "Bansa BO": "723128",
      "Batikara BO": "723148",
      "Chandra BO": "723128",
      "Deshra BO": "723148",
      "Dhakakendu BO": "723128",
      "Konapara BO": "723128",
      "Kuda BO": "723128",
      "Kuruktopa BO": "723128",
      "Mahara BO": "723128",
      "Matha BO": "723128",
      "Metyala BO": "723128",
      "Mohandih BO": "723128",
      "Badaldih BO": "723127",
      "Bamundiha BO": "723127",
      "Dhelat Bamu BO": "723127",
      "Dumurdih BO": "723127",
      "Fuljhore BO": "723127",
      "Hizla BO": "723127",
      "Sukurhutu BO": "723127",
      "Bogra BO": "723145",
      "Chhirudi Radhanagar BO": "723129",
      "Gangamanna BO": "723129",
      "Hetyakole BO": "723129",
      "Kuilapal BO": "723129",
      "Kotloi BO": "723102",
      "Hinjuri Shyampur BO": "723201",
      "Kadampur BO": "723201",
      "Rangamati BO": "723201",
      "Srirampur BO": "723201",
      "Tanasi BO": "723201",
      "Tatuara BO": "723201",
      "Dhabani BO": "723130",
      "Dhabani Radhamohanpur BO": "723129",
      "Kustore BO": "723130",
      "Daldali BO": "723130",
      "Pirorgoria BO": "723131",
      "Ratiadih Nowadih BO": "723212",
      "Sarengdih BO": "723212",
      "Saridih BO": "723212",
      "Suisa BO": "723212",
      "Tunturi BO": "723212",
      "Bagalmari BO": "723147",
      "Baghra BO": "723147",
      "Chharrah BO": "723147",
      "Dumdumi BO": "723147",
      "Beko BO": "723121",
      "Bhamuria BO": "723121",
      "Bortoria BO": "723121",
      "Chalmara Puapur BO": "723121",
      "Pabra BO": "723121",
      "Parbedia BO": "723121",
      "Rajra Shibtola BO": "723121",
      "Rampur BO": "723121",
      "Sanka BO": "723121",
      "Sutabai BO": "723121",
      "Hatikundar BO": "723104",
      "Choutala Bhagabandh BO": "723126",
      "Fushrabad BO": "723126",
      "Jalika BO": "723126",
      "Jhapra BO": "723126",
      "Kalajore BO": "723126",
      "Kaluhar BO": "723126",
      "Kustaur BO": "723126",
      "Lipania BO": "723126",
      "Ghatbera BO": "723153",
      "Ghorabandha Sindri BO": "723152",
      "Hurumda BO": "723152",
      "Uttamdih BO": "723152",
      "Gopalnagar BO": "723128",
      "Amrabera BO": "723127",
      "Nischintapur BO": "723127",
      "Puriara BO": "723127",
      "Rupapetya BO": "723127",
      "Rajagram BO": "723129",
      "Sagasupurari BO": "723129",
      "Simulia BO": "723102",
      "Chakaltore BO": "723102",
      "Gobindapur BO": "723102",
      "Arsha BO": "723201",
      "Uparkahan BO": "723201",
      "Chatumadar BO": "723130",
      "Chhirudi Chandanpur BO": "723130",
      "Mehi BO": "723130",
      "Mekhyada BO": "723130",
      "Nayadih BO": "723130",
      "Pabrapahari BO": "723130",
      "Chakalta BO": "723130",
      "Banbaligara BO": "723148",
      "Banjora BO": "723128",
      "Arrah BO": "723121",
      "Chapri BO": "723121",
      "Digha BO": "723121",
      "Gourangdih BO": "723121",
      "Kalidaha BO": "723121",
      "Neturia BO": "723121",
      "Rangametya BO": "723121",
      "Sunuri BO": "723121",
      "Anara BO": "723126",
      "Belma BO": "723126",
      "Jorberia BO": "723126",
      "Malthore BO": "723126",
      "Nadiha BO": "723126",
      "Sonaijuri BO": "723126",
      "Tentulda BO": "723126",
      "Chitmu BO": "723215",
      "Birgram BO": "723152",
      "Burda BO": "723152",
      "Chatarmahul BO": "723145",
      "Kushaldih BO": "723152",
      "Pathardih BO": "723152",
      "Shaharjuri BO": "723152",
      "Bijoydih BO": "723128",
      "Damda BO": "723128",
      "Jambad BO": "723128",
      "Jitujuri BO": "723128",
      "Majhihira BO": "723128",
      "Rajnowagarh BO": "723128",
      "Panipathar BO": "723128",
      "Banbahal BO": "723103",
      "Fatepur Sindri BO": "723127",
      "Herbona BO": "723127",
      "Jilling BO": "723127",
      "Sarberia BO": "723127",
      "Agaibil BO": "723129",
      "Barakadam BO": "723129",
      "Dhadka BO": "723129",
      "Jitan BO": "723129",
      "Kunchia BO": "723129",
      "Mamro BO": "723129",
      "Bhandarpuara BO": "723102",
      "Dorodih BO": "723102",
      "Beldih BO": "723102",
      "Chakirbon BO": "723102",
      "Barametyala BO": "723201",
      "Chapaitard BO": "723201",
      "Hargara BO": "723201",
      "Tunta BO": "723201",
      "Uparjari BO": "723201",
      "Agardih BO": "723130",
      "Hadalda BO": "723130",
      "Rakhera BO": "723130",
      "Anaijambad BO": "723148",
      "Torang BO": "723212",
      "Golamara BO": "723147",
      "Barabhum SO": "723127",
      "Dulminadiha SO": "723102",
      "Hura SO Puruliya": "723130",
      "Hutmura SO": "723148",
      "Jhalda SO": "723202",
      "Jiudaru SO": "723213",
      "Manbazar SO": "723131",
      "Namopara SO": "723103",
      "Panchakotraj SO": "723132",
      "Puncha SO": "723151",
      "Bagdisha BO": "723148",
      "Kulgora BO": "723104",
      "Khamar BO": "723202",
      "Mahatomara BO": "723202",
      "Mosina BO": "723202",
      "Murguma BO": "723202",
      "Bamni BO": "723131",
      "Bamnia BO": "723213",
      "Kalabani BO": "723104",
      "Lakhanpur BO": "723104",
      "Bara Urma BO": "723153",
      "Chatuhansa BO": "723153",
      "Bari BO": "723131",
      "Jamtoria BO": "723131",
      "Jawrah BO": "723131",
      "Jharbagda BO": "723131",
      "Jorabari BO": "723131",
      "Polmi BO": "723131",
      "Purdaha BO": "723131",
      "Ratiakocha BO": "723131",
      "Taldabra BO": "723131",
      "Belkuri BO": "723149",
      "Chakra BO": "723149",
      "Ghanga BO": "723149",
      "Talberia BO": "723156",
      "Kanali BO": "723103",
      "Ramamoti BO": "723103",
      "Ranibandh BO": "723103",
      "Shibdih BO": "723103",
      "Simla BO": "723132",
      "Chitra BO": "723155",
      "Badra BO": "723151",
      "Napara Baragram BO": "723151",
      "Pakbirra BO": "723151",
      "Tatari BO": "723151",
      "Godibera BO": "723133",
      "Marbedia BO": "723133",
      "Ketika BO": "723102",
      "Berada BO": "723143",
      "Bhabanipur BO": "723143",
      "Biramdih BO": "723143",
      "Salboni BO": "723143",
      "Shyamnagar BO": "723143",
      "Supurdih BO": "723143",
      "Tentlow BO": "723143",
      "Achkoda BO": "723145",
      "Barrah BO": "723145",
      "Aharrah BO": "723154",
      "Hensla BO": "723154",
      "Jhunjka BO": "723154",
      "Nowadhi BO": "723212",
      "Pathahensal BO": "723212",
      "Adra Market SO": "723121",
      "Anara RS SO": "723126",
      "Bagmundi SO": "723152",
      "Balakdih SO": "723128",
      "Tulin SO": "723212",
      "Chepra BO": "723148",
      "Haramjanga BO": "723148",
      "Kudlung BO": "723148",
      "Kulabahal BO": "723148",
      "Bagbinda BO": "723202",
      "Goria BO": "723202",
      "Hetgugui BO": "723202",
      "Pathjhalda BO": "723202",
      "Dumru BO": "723213",
      "Karkara BO": "723213",
      "Simni BO": "723213",
      "Manguria Lalpur BO": "723130",
      "Patuara BO": "723153",
      "Boro BO": "723131",
      "Chhota Sagan BO": "723131",
      "Dhagora BO": "723131",
      "Dighi BO": "723131",
      "Kashidih BO": "723131",
      "Kumari BO": "723131",
      "Pealsole BO": "723131",
      "Penchara BO": "723131",
      "Kukurgoria BO": "723149",
      "Nadiara BO": "723149",
      "Sihali BO": "723149",
      "Raghabpur BO": "723149",
      "Bhul BO": "723103",
      "Dabar Balarampur BO": "723103",
      "Golbera BO": "723103",
      "Malancha BO": "723132",
      "Udaipur BO": "723155",
      "Bhagabandh BO": "723151",
      "Gholkurd BO": "723151",
      "Gopalpur BO": "723151",
      "Napara BO": "723151",
      "Pichasi BO": "723102",
      "Ralibera BO": "723102",
      "Gunera BO": "723133",
      "Madhutati BO": "723133",
      "Naragoria BO": "723133",
      "Nutandih BO": "723133",
      "Upansankra BO": "723133",
      "Ekra BO": "723143",
      "Kurni BO": "723143",
      "Nekra BO": "723143",
      "Joradih BO": "723145",
      "Nanduka BO": "723145",
      "Deoli BO": "723146",
      "Satra BO": "723154",
      "Atna BO": "723212",
      "Gagi BO": "723212",
      "Kalimati BO": "723212",
      "Dapang BO": "723148",
      "Khairipihira Rangadih BO": "723148",
      "Lodhurka BO": "723148",
      "Hensahatu BO": "723202",
      "Ichag BO": "723202",
      "Kalma BO": "723202",
      "Pandua BO": "723202",
      "Rigid BO": "723202",
      "Bararola BO": "723213",
      "Ghagra BO": "723213",
      "Majhidih BO": "723213",
      "Sidhi BO": "723213",
      "Timangda BO": "723213",
      "Kusumjoria BO": "723104",
      "Jabarrah BO": "723148",
      "Adra SO": "723121",
      "Alangidanga SO": "723101",
      "Chowkbazar SO Puruliya": "723101",
      "Manguria SO": "723149",
      "Murardih SO": "723156",
      "Para SO": "723155",
      "Raghunathpur SO Puruliya": "723133",
      "Rangadih SO": "723143",
      "Santaldih SO": "723145",
      "Sirkabad SO": "723154",
      "Bhangra BO": "723148",
      "Chanchra BO": "723148",
      "Sindri Chas Road BO": "723103",
      "Sindurpur BO": "723148",
      "Begunkodar BO": "723202",
      "Brajapur BO": "723202",
      "Chekya BO": "723202",
      "Durgi BO": "723202",
      "Karmatard BO": "723213",
      "Khatanga BO": "723213",
      "Kochahatu BO": "723213",
      "Mutukura BO": "723213",
      "Nowahatu BO": "723213",
      "Oldih BO": "723213",
      "Ropo BO": "723213",
      "Khairipihira BO": "723104",
      "Raigara BO": "723153",
      "Raotora Bhagabandh BO": "723153",
      "Sagma BO": "723153",
      "Suklara BO": "723153",
      "Belgoria BO": "723131",
      "Bishri BO": "723131",
      "Bonra BO": "723121",
      "Kutni BO": "723131",
      "Pairachali BO": "723131",
      "Pedda BO": "723131",
      "Senera Amra BO": "723149",
      "Baligara BO": "723149",
      "Dimdiha BO": "723103",
      "Garafushra BO": "723103",
      "Gengara BO": "723103",
      "Ghagarjuri BO": "723103",
      "Bansraya BO": "723132",
      "Damankiary BO": "723132",
      "Gamarkuri BO": "723132",
      "Sankra BO": "723155",
      "Tentulhiti BO": "723155",
      "Bagda BO": "723151",
      "Kundurka BO": "723151",
      "Lakhra BO": "723151",
      "Loulara BO": "723151",
      "Menidih BO": "723151",
      "Chitora BO": "723102",
      "Agaibari BO": "723133",
      "Babugram BO": "723133",
      "Nildih BO": "723133",
      "Santuri BO": "723133",
      "Raibandh BO": "723131",
      "Ramkanali BO": "723142",
      "Namsole BO": "723143",
      "Rukni BO": "723145",
      "Baragoria BO": "723145",
      "Darpa BO": "723212",
      "Iloo BO": "723212",
      "Jargo BO": "723212",
      "Mudali BO": "723153",
      "Puara BO": "723153",
      "Bargoria BO": "723131",
      "Dangardih BO": "723131",
      "Khiriduara BO": "723131",
      "Kurarbaid BO": "723131",
      "Sindhraidih BO": "723131",
      "Shyampur BO": "723131",
      "Chainpur BO": "723149",
      "Lagda BO": "723149",
      "Natua BO": "723149",
      "Baragram BO": "723103",
      "Chirka BO": "723103",
      "Seja BO": "723132",
      "Tara BO": "723132",
      "Bhawridih BO": "723155",
      "Dubra BO": "723155",
      "Bhutam BO": "723151",
      "Pundru BO": "723102",
      "Bhurkundabari BO": "723133",
      "Gorsika BO": "723133",
      "Mangalda BO": "723133",
      "Rakshatpur BO": "723133",
      "Tarabari BO": "723131",
      "Bhikari Chelyama BO": "723143",
      "Dhanudih BO": "723143",
      "Gerua BO": "723143",
      "Radha Gobindapur BO": "723143",
      "Ichhar BO": "723145",
      "Moutore BO": "723145",
      "Bahara BO": "723146",
      "Chelyama BO": "723146",
      "Thumba Jhalda BO": "723154",
      "Karmadih BO": "723212",
      "Pusti BO": "723212",
      "Purulia RS SO": "723101",
      "Sainik School SO Puruliya": "723104",
      "Santaldih TP SO": "723146",
      "Baglata SO": "723215",
      "Bundwan SO": "723129",
      "Garjaipur SO": "723201",
      "Jubli Compound SO": "723101",
      "Kantadih SO": "723153",
      "Ramchandrapur Ashram SO": "723142",
      "Vivekananda Nagar SO": "723147",
      "Purulia HO": "723101"
    },
    "KALIMPONG": {
      "Rango BO": "735206",
      "Maipatey Gaon BO": "735231",
      "Todaygaon BO": "734503",
      "Kumai BO": "735206",
      "Gairibas BO": "734503",
      "Samsing BO": "735223",
      "Lolay BO": "734301",
      "Samthar BO": "734301",
      "Seokbir BO": "734301",
      "Yangmakum Pambu BO": "734301",
      "Burmeck": "734315",
      "Rousay Bazar BO": "734316",
      "Ahlay BO": "735231",
      "Chibo Busty BO": "734301",
      "Sinji BO": "734301",
      "Suruk BO": "734301",
      "Tashiding BO": "734301",
      "Echhey B.O": "734301",
      "Kagay Bazar BO": "734311",
      "Sakyong BO": "734311",
      "Mahakal Dara BO": "734316",
      "Swansay BO": "734316",
      "Upper Dalapchand BO": "734316",
      "Lohapool BO": "734008",
      "Pudung BO": "734301",
      "Sindebong BO": "734316",
      "Rambhi B.O": "734008",
      "Chhumirchin Manchu BO": "734314",
      "Nimbong BO": "734314",
      "Pagag Gumpa BO": "734314",
      "Santook Mirik BO": "734314",
      "Tendrabong BO": "734314",
      "Kafer BO": "734314",
      "Gitdubling BO": "734314",
      "Pabring Tar BO": "734314",
      "Lava B.O": "734314",
      "Topkhana SO": "734316",
      "Bong Busty SO": "734301",
      "Kalimpong MDG": "734301",
      "Fagu SO Darjeeling": "735231",
      "Munsong SO": "734315",
      "Jaldhaka Hydel Project SO": "734503",
      "7th Mile Kalimpong SO": "734301",
      "Algarah SO": "734314",
      "Bankimpark SO": "734301",
      "Kalimpong Bazar SO": "734301",
      "Pedong SO": "734311",
      "Tista Bridge SO": "734312"
    },
    "DARJEELING": {
      "Pulbazar B.O": "734201",
      "Bloom Field BO": "734102",
      "Chhotapubong BO": "734102",
      "Ambeok BO": "735231",
      "Tumbayok BO": "734201",
      "Marybong BO": "734102",
      "Risheehat BO": "734102",
      "Ambootia BO": "734203",
      "Badamtam BO": "734105",
      "Malat Bazar BO": "734215",
      "Bannersberg BO": "734104",
      "Singtam BO": "734104",
      "Jamdar Vitta BO": "734217",
      "Rangbang BO": "734216",
      "Geile Banjyang BO": "734226",
      "Balasun BO": "734209",
      "Tamsing Dhura BO": "734209",
      "Batasia BO": "734221",
      "Tinchuley BO": "734222",
      "Bar Dara BO": "734312",
      "Bagora BO": "734224",
      "Chowpukuria BO": "734014",
      "Tarbandha BO": "734014",
      "Putung BO": "734423",
      "Rangali BO": "734429",
      "Bhajanpurjote BO": "734427",
      "Lower Soureni BO": "734214",
      "Seeyok BO": "734214",
      "School Gaon BO": "734313",
      "New Rangia BO": "734013",
      "Hardigachh BO": "734434",
      "Lensipokhari BO": "734434",
      "Singbulli BO": "734218",
      "Champasari BO": "734003",
      "Gumba BO": "734102",
      "Lingia BO": "734102",
      "Lamahatta BO": "734213",
      "Maney Dara BO": "734213",
      "School Dhura BO": "734213",
      "Dhajea BO": "734215",
      "DP Side BO": "734226",
      "Nalichor BO": "734209",
      "Ringtong BO": "734209",
      "Rangmook BO": "734209",
      "Dooteriah B.O": "734209",
      "Maneybhanjeng BO": "734221",
      "Mim BO": "734221",
      "Plungdung BO": "734221",
      "Gayabari BO": "734223",
      "Norbung BO": "734223",
      "Lower Chongtong BO": "734102",
      "Pussimbing BO": "734102",
      "Tamsang BO": "734102",
      "Mahanadi BO": "734203",
      "Mineral Spring BO": "734105",
      "Singritam BO": "734213",
      "Mangarjung BO": "734215",
      "Teesta Valley BO": "734226",
      "Moonda Koti BO": "734209",
      "Rangbull B.O": "734209",
      "Margarets Hope BO": "734224",
      "Gossaipur BO": "734014",
      "Madati BO": "734426",
      "Sahabad BO": "734426",
      "Adhikari BO": "734427",
      "Nemai BO": "734010",
      "Gopaldhara BO": "734214",
      "Okaity BO": "734214",
      "Ranju Valley BO": "734313",
      "Kantivitta BO": "734434",
      "Sittong BO": "734008",
      "Kalijhora B.O": "734008",
      "New Chumta BO": "734009",
      "Gayanganga BO": "734426",
      "Kalachandgach BO": "734426",
      "Bilakshu BO": "734427",
      "Tharjhorabagan BO": "734427",
      "Duptin10 BO": "734214",
      "Nijbari BO": "734434",
      "Rangapani BO": "734434",
      "Chathat B.O": "734434",
      "Baikunthapur BO": "734008",
      "Latpanchar BO": "734008",
      "Simkuna BO": "734102",
      "Rajbari BO": "734103",
      "Singla BO": "734104",
      "Soom BO": "734104",
      "Udaigram BO": "734104",
      "Tukver B.O": "734104",
      "Selimbong BO": "734216",
      "Deorali BO": "734220",
      "Chunbhati BO": "734223",
      "Peshok BO": "734312",
      "Takling BO": "734312",
      "Pani Ghatta BO": "734423",
      "Buraganj BO": "734426",
      "Chitalghatta BO": "734426",
      "Thurbo BO": "734214",
      "Soureni Bazar B.O": "734214",
      "Badrajote BO": "734429",
      "Shelphu BO": "734008",
      "Jyotinagar BO": "734005",
      "Gulma BO": "734009",
      "Simulbari BO": "734009",
      "Ranidanga BO": "734012",
      "Dulaljote BO": "734429",
      "Hatighisa BO": "734429",
      "Darjeeling HO": "734101",
      "Bansbotey BO": "734201",
      "Kolbong BO": "734201",
      "Lodhomahat BO": "734201",
      "Rimbick BO": "734201",
      "Dara Goan BO": "734201",
      "Jhepi BO": "734201",
      "Kaijalia BO": "734201",
      "Siliguri HO": "734001",
      "Goke Bazar BO": "734201",
      "Relling BO": "734201",
      "Lama Goan BO": "734201",
      "Lopchu SO": "734213",
      "Pankhabari SO": "734217",
      "Bhanugram SO": "734101",
      "Bhutia Busty SO": "734101",
      "Bijanbari SO": "734201",
      "Darjeeling Bazar SO": "734101",
      "Kurseong MDG": "734203",
      "Nagrispur SO": "734215",
      "North Point SO": "734104",
      "Pokhriabong SO": "734216",
      "Sukhiapokhari SO": "734221",
      "Siliguri Bazar SO": "734005",
      "Siliguri Junction SO": "734001",
      "Siliguri New Market SO": "734001",
      "Sukna SO": "734009",
      "Salbari SO": "734002",
      "Bidhannagar SO": "734425",
      "Rangli Rangliot SO": "734226",
      "Rose Bank SO": "734101",
      "StMarys Hill SO": "734220",
      "Takdah SO": "734222",
      "Tindharia SO": "734223",
      "Mungpoo SO": "734313",
      "Phansidewa SO": "734434",
      "Phuguri SO": "734218",
      "Salugarah SO": "734008",
      "Siliguri Town SO": "734004",
      "Darjeeling Court SO": "734101",
      "Dowhill SO": "734204",
      "Dumaram Busty SO": "734203",
      "Sonada SO": "734209",
      "Bagdogra SO": "734014",
      "Mahananda Bridge SO": "734001",
      "Matigara SO": "734010",
      "Naksalbari SO": "734429",
      "North Bengal University SO": "734013",
      "Sevoke Road SO": "734001",
      "Sushrut Nagar SO": "734012",
      "Ghoom SO": "734102",
      "Jalapahar SO": "734103",
      "Lebong SO": "734105",
      "Tung SO": "734224",
      "Bagdogra Air Port SO": "734421",
      "Belgachi SO": "734423",
      "Bendubi SO": "734424",
      "Kadamtala SO Darjiling": "734011",
      "Kamala Bagan SO": "734426",
      "Khoribari SO": "734427",
      "Mirik SO": "734214",
      "Pradhan Nagar SO": "734003"
    }
  },
  "HIMACHAL PRADESH": {
    "KANGRA": {
      "Minjhgram BO": "176200",
      "Kutheri BO": "176200",
      "Hangloh BO": "176059",
      "Ansuhi BO": "176217",
      "Tundo BO": "176217",
      "Sudher BO": "176217",
      "Pantehar BO": "176057",
      "Rakkar BO": "176057",
      "Sidhbari BO": "176057",
      "Sidhpur BO": "176057",
      "Sukkar BO": "176057",
      "Chaloh BO": "176204",
      "Dhar BO": "176033",
      "Sakoh BO": "176082",
      "Sarah BO": "176213",
      "Dharoon BO": "176205",
      "Jaunta BO": "176205",
      "Mastgarh BO": "176205",
      "Aundh BO": "176202",
      "Gahin Lagore BO": "176202",
      "Gurchal BO": "176202",
      "Gadiara BO": "176065",
      "Kural BO": "176083",
      "Lathial BO": "176058",
      "Hadal Uparli BO": "176211",
      "Khawara BO": "176211",
      "Kukher BO": "176211",
      "Bhalli BO": "176206",
      "Bhanala BO": "176206",
      "Sihun BO": "176206",
      "Gheen BO": "176029",
      "Trippal BO": "176029",
      "Hori Devi BO": "176022",
      "Kandor BO": "176022",
      "Kothandal BO": "176022",
      "Chhughera BO": "176056",
      "Kholi BO": "176056",
      "Panjlehar BO": "176056",
      "Rajiana BO": "176029",
      "Balol BO": "176037",
      "Chandrot BO": "176037",
      "Luhna BO": "176037",
      "Sarotri BO": "176037",
      "Kuther BO": "176225",
      "Nadoli BO": "176225",
      "Soldha BO": "176225",
      "Kherian BO": "176028",
      "Kot Palahari BO": "176200",
      "Jia BO": "176059",
      "Lahla BO": "176059",
      "Gharoh BO": "176217",
      "Baleer BO": "176403",
      "Basantpur BO": "176403",
      "Bhadroya BO": "176403",
      "Tota Rani BO": "176216",
      "Fatu Ka Bag BO": "176204",
      "Dhaneti Bhurian BO": "176051",
      "Gurial BO": "176051",
      "Sukhara Choudrian BO": "176051",
      "Ghallian BO": "176029",
      "Golwan BO": "176022",
      "Samloti BO": "176056",
      "Sehund BO": "176056",
      "Kotla Mangwal BO": "176204",
      "Rappar BO": "176204",
      "Tika Dagla BO": "176204",
      "Dole BO": "176210",
      "Thehar BO": "176210",
      "Chanaur BO": "176401",
      "Ghandran BO": "176401",
      "Panjhara BO": "176051",
      "Talara BO": "176051",
      "Balugloa BO": "176029",
      "Darkata BO": "176029",
      "Palera BO": "176029",
      "Thakurdawara BO": "176029",
      "Barot Banal BO": "176022",
      "Chhater Jogian BO": "176022",
      "Gadrana BO": "176022",
      "Makroli BO": "176022",
      "Kaled BO": "176056",
      "Rounkhar BO": "176056",
      "Bassi BO": "176214",
      "Salol BO": "176214",
      "Indpur BO": "176401",
      "Kathgarh BO": "176401",
      "Bhaleta BO": "176201",
      "Hatli Jamwala BO": "176200",
      "Tika Nagrota BO": "176200",
      "Bhagotla BO": "176059",
      "Chamiara BO": "176217",
      "Manoh BO": "176217",
      "Chhanni BO": "176403",
      "Mohatli BO": "176403",
      "Paral BO": "176403",
      "Dhoran BO": "176060",
      "Jharet Jaggian BO": "176060",
      "Kareri BO": "176216",
      "Attarah BO": "176204",
      "Gheta BO": "176204",
      "Lapiana BO": "176210",
      "Pargore BO": "176210",
      "Bhugnara BO": "176201",
      "Gandwal BO": "176201",
      "Geora BO": "176201",
      "Raja Ka Bagh BO": "176201",
      "Dah BO": "176402",
      "Raja Khasa BO": "176402",
      "Bahi Pathiar BO": "176205",
      "Bhattoo Samula BO": "176064",
      "Panapar BO": "176064",
      "Sarkari Sidhpur BO": "176064",
      "Nangal BO": "176058",
      "Durgella BO": "176206",
      "Harnera BO": "176206",
      "Bhapoo BO": "176401",
      "Samlet BO": "176401",
      "Baranda BO": "176201",
      "Lodhwan BO": "176201",
      "Rit Lower BO": "176201",
      "Bhojpur BO": "176402",
      "Danni BO": "176203",
      "Bhagsu Nath BO": "176219",
      "Khushi Nagar BO": "176202",
      "Sadwan BO": "176202",
      "Pharer BO": "176064",
      "Agahar BO": "176058",
      "Hatli BO": "176058",
      "Riali BO": "176058",
      "Daraman BO": "176206",
      "Dohb BO": "176206",
      "Rehlu BO": "176206",
      "Rirkmar BO": "176206",
      "Salli BO": "176206",
      "Bagga BO": "176225",
      "Dadh BO": "176052",
      "Kardiana BO": "176052",
      "Lartah BO": "176051",
      "Banne Di  Hatti BO": "176029",
      "Bhangwar BO": "176029",
      "Dohag BO": "176029",
      "Naushara BO": "176029",
      "Dhiala BO": "176022",
      "Larhoon BO": "176022",
      "Madholi BO": "176022",
      "Parol BO": "176022",
      "Ram Nagar BO": "176022",
      "Dhaloon BO": "176056",
      "Lily BO": "176056",
      "Serathana BO": "176056",
      "Sadun Bargran BO": "176037",
      "Thana Bargan BO": "176037",
      "Maherana BO": "176214",
      "Shamirpur BO": "176214",
      "Khail BO": "176200",
      "Arth Jhikli BO": "176059",
      "Bagora BO": "176059",
      "Gopalpur BO": "176059",
      "Rakh BO": "176059",
      "Dodhamb BO": "176217",
      "Tharu BO": "176217",
      "Mand Manjwan BO": "176403",
      "Olehrian BO": "176403",
      "Surajpur BO": "176403",
      "Thakurdwara BO": "176102",
      "Ghaneta BO": "176060",
      "Dal Lake BO": "176216",
      "Balakh BO": "176204",
      "Dainkwan BO": "176204",
      "Sourhra Mohhala BO": "176204",
      "Bharup Lahar BO": "176210",
      "Manai BO": "176210",
      "Bhogarwan BO": "176401",
      "Malahari BO": "176401",
      "Surarwan BO": "176401",
      "Baduhi BO": "176201",
      "Basa Baziran BO": "176201",
      "Khanni BO": "176201",
      "Thore BO": "176201",
      "Chowki BO": "176084",
      "Kopra BO": "176202",
      "Ballah BO": "176064",
      "Bahadpur BO": "176058",
      "Diana BO": "176058",
      "Tatwali BO": "176058",
      "Boh BO": "176206",
      "Darini BO": "176206",
      "Saddun BO": "176206",
      "Bhonka BO": "176225",
      "Kandgawal Tikker BO": "176061",
      "Bindravan BO": "176061",
      "Dharer BO": "176125",
      "Ghartholi BO": "176125",
      "Mandher BO": "176125",
      "Ustehar BO": "176125",
      "Paplah BO": "176073",
      "Deogram BO": "176067",
      "Balakrupi BO": "176082",
      "Bheri BO": "176082",
      "Jangal BO": "176082",
      "Mahankal BO": "176125",
      "Phattahar BO": "176125",
      "Sakri BO": "176125",
      "Sansal BO": "176125",
      "Sehal BO": "176125",
      "Boda Lower BO": "176083",
      "Kasba Punner BO": "176083",
      "Kothi BO": "176088",
      "Mungal Galoo BO": "176088",
      "Nanwar BO": "176088",
      "Salehra BO": "176088",
      "Sansai BO": "176088",
      "Kharuhal BO": "176092",
      "Mundhi BO": "176092",
      "Kallon BO": "176086",
      "Lahat BO": "176086",
      "Rit BO": "176086",
      "Tarela BO": "176086",
      "Balahra BO": "176098",
      "Dhupkiara BO": "176096",
      "Kosri BO": "176096",
      "Kotlu BO": "176096",
      "Bharwana BO": "176103",
      "Biara BO": "176103",
      "Haded BO": "176115",
      "Badiarkhar BO": "176081",
      "Jhikli Bheth BO": "176081",
      "Dagoh BO": "176076",
      "Atiala Dai BO": "176083",
      "Man Simble BO": "176083",
      "Simbal BO": "176071",
      "Gunehar BO": "176077",
      "Bhirri BO": "176088",
      "Dhandhol BO": "176128",
      "Boda Lauhanti BO": "176092",
      "Gaggal Khas BO": "176101",
      "Kahanpat BO": "176101",
      "Harrot BO": "176095",
      "Uttrapur BO": "176095",
      "Ashapuri BO": "176094",
      "Draman BO": "176094",
      "Suan BO": "176094",
      "Chhenchheri BO": "176086",
      "Bhatwan BO": "176098",
      "Kuhan BO": "176098",
      "Talwar BO": "176096",
      "Rakker BO": "176063",
      "Kona BO": "176107",
      "Rohan BO": "176093",
      "Sapruhal BO": "176093",
      "Dehan BO": "176102",
      "Gharana BO": "176084",
      "Malahu BO": "176087",
      "Tikker Indorian BO": "176087",
      "Ghar BO": "176103",
      "Saliana BO": "176103",
      "Kharanal BO": "176115",
      "Haler BO": "176091",
      "Kakrain BO": "176085",
      "Raipur BO": "176085",
      "Bachhwai BO": "176107",
      "Lower Averi BO": "176081",
      "Zandpur BO": "176081",
      "Dagera BO": "176107",
      "Galoti BO": "176107",
      "Sadun BO": "176107",
      "Sai BO": "176107",
      "Banuri BO": "176061",
      "Bahi BO": "176125",
      "Bhatu BO": "176125",
      "Deol BO": "176125",
      "Dhanag BO": "176125",
      "Bandahu BO": "176073",
      "Majhera BO": "176076",
      "Kailashpur BO": "176076",
      "Malnoo BO": "176083",
      "Drug BO": "176071",
      "Khopa BO": "176128",
      "Kudail BO": "176128",
      "Nagehar BO": "176128",
      "Bhadrol BO": "176101",
      "Dain BO": "176101",
      "Netru BO": "176095",
      "Tammber BO": "176095",
      "Vijaypur BO": "176095",
      "Tikkri Duhki BO": "176063",
      "Trehal BO": "176063",
      "Arla BO": "176102",
      "Barram Khurd BO": "176097",
      "Maila BO": "176089",
      "Majhoti BO": "176089",
      "Rananagar BO": "176089",
      "Balota BO": "176084",
      "Purba BO": "176084",
      "Sarhoot BO": "176084",
      "Bhoura BO": "176087",
      "Nadli BO": "176103",
      "Garla Dai BO": "176085",
      "Nanaon BO": "176085",
      "Rajehar BO": "176061",
      "Menjha BO": "176061",
      "Jagrup Nagar BO": "176082",
      "Gandhi Gram BO": "176125",
      "Mahalpat BO": "176125",
      "Nohra BO": "176125",
      "Thara BO": "176125",
      "Makol BO": "176076",
      "Bari BO": "176051",
      "Punner BO": "176083",
      "Ramehar BO": "176052",
      "Jhamoon BO": "176088",
      "Matyal BO": "176088",
      "Gawal BO": "176128",
      "Garh Jamula BO": "176092",
      "Marhoon BO": "176092",
      "Gaggal Kholi BO": "176101",
      "Paniali BO": "176101",
      "Karanghat BO": "176095",
      "Nahlana BO": "176094",
      "Baidapatt BO": "176086",
      "Jaind BO": "176086",
      "Jharundi BO": "176098",
      "Maharajnagar BO": "176096",
      "Upper Lambagaon BO": "176096",
      "Rajot BO": "176063",
      "Sagoor BO": "176063",
      "Sanhoon BO": "176093",
      "Saloh BO": "176102",
      "Kiarban BO": "176084",
      "Thandole BO": "176087",
      "Andreta BO": "176103",
      "Tatehal BO": "176103",
      "Kandral BO": "176115",
      "Uttrala BO": "176115",
      "Harsi BO": "176091",
      "Salan BO": "176107",
      "Chamukha BO": "177033",
      "Sri Chamunda Mandir BO": "176052",
      "Chandpur BO": "176061",
      "Nachhir BO": "176061",
      "Sungal Tea Estate BO": "176061",
      "Saperu BO": "176061",
      "Bhadraina BO": "176061",
      "Bandla Tea Estate BO": "176061",
      "Narwana BO": "176052",
      "Geeta Peeth BO": "176061",
      "Chowki Khalet BO": "176061",
      "Paddar BO": "176052",
      "Patti BO": "176067",
      "Kamlehar BO": "176061",
      "Kandi BO": "176054",
      "Paisa BO": "177114",
      "Chanouta BO": "177103",
      "Suhin BO": "177108",
      "Gathutar BO": "176033",
      "Nandpur Bhatoli BO": "176033",
      "Amb Pathiar BO": "176031",
      "Baggi BO": "176031",
      "Fakloh BO": "176031",
      "Lagroo Abrol BO": "176031",
      "Salihar BO": "176031",
      "Sihorpain BO": "176031",
      "Surani BO": "176031",
      "Dola Khariana BO": "176030",
      "Gharna BO": "176030",
      "Nahlian BO": "176030",
      "Suder Lahar BO": "176030",
      "Silh BO": "176036",
      "Aloh BO": "177034",
      "Behar Kuthera BO": "177111",
      "Khanpur BO": "177111",
      "Chaplah BO": "177043",
      "Jandaur BO": "176501",
      "Riri BO": "176501",
      "Beh BO": "177105",
      "Gheori BO": "177105",
      "Bathra BO": "177112",
      "Lower Tipri BO": "177112",
      "Sakout BO": "176001",
      "Nandehar BO": "176001",
      "Oie BO": "176054",
      "Palra BO": "176054",
      "Dhasoli BO": "176021",
      "Kulthi BO": "176038",
      "Jagnoli BO": "176025",
      "Khatiar BO": "176025",
      "Polian BO": "176025",
      "Ichhi BO": "176209",
      "Nagan Pat BO": "176209",
      "Sahaura BO": "176209",
      "Chatwana Lahroo BO": "176023",
      "Darkati BO": "176023",
      "Ghar Jarot BO": "176023",
      "Kawari BO": "176047",
      "Momta BO": "176047",
      "Uppli Kothi BO": "176047",
      "Ludret BO": "176027",
      "Bajrehar BO": "176208",
      "Basnoor BO": "176208",
      "Dhanotu BO": "176208",
      "Ladwara BO": "176208",
      "Khabli BO": "177114",
      "Kasba Jagir BO": "177106",
      "Chalali BO": "177103",
      "Karoa BO": "177103",
      "Maniala BO": "177108",
      "Sehri BO": "177108",
      "Bilaspur BO": "176033",
      "Mehwa BO": "176028",
      "Lower Ghallour BO": "176031",
      "Gummer BO": "176031",
      "Kathog BO": "176031",
      "Bharoli BO": "176036",
      "Choukath BO": "176036",
      "Gagruhi BO": "176036",
      "Karyara BO": "177117",
      "Dhawala BO": "177117",
      "Nalsuha BO": "177104",
      "Sunhet BO": "177104",
      "Lag Baliana BO": "177107",
      "Gural Dhar BO": "177111",
      "Bharoli Jadid BO": "177043",
      "Chauli BO": "177043",
      "Kuhna BO": "177043",
      "Sarad Dogri BO": "177043",
      "Amroh BO": "176501",
      "Majhin BO": "176032",
      "Rajal BO": "176001",
      "Kangra Town BO": "176001",
      "Boharkawaloo BO": "176001",
      "Jassai BO": "176054",
      "Kharat BO": "176054",
      "Sidhpur Ghar BO": "176021",
      "Takoli Girthan BO": "176021",
      "Baroona BO": "176025",
      "Lohara BO": "176053",
      "Gher BO": "177114",
      "Lag BO": "177106",
      "Maira Bani BO": "177108",
      "Nagrota Nahan BO": "177108",
      "Maleta Bongta BO": "176028",
      "Adhwani BO": "176036",
      "Digger BO": "176036",
      "Barwara BO": "177117",
      "Naleti BO": "177104",
      "Chudrer BO": "177104",
      "Nihari BO": "177034",
      "Kaloha BO": "177043",
      "Saleti BO": "177043",
      "Ghati Bilwan BO": "176501",
      "Sialkar BO": "176032",
      "Seul BO": "177112",
      "Matour BO": "176001",
      "Zamanabad BO": "176001",
      "Mandal BO": "176001",
      "Dhagwar BO": "176001",
      "Jheol BO": "176001",
      "Dangerh BO": "176054",
      "Harnota BO": "176021",
      "Maira BO": "176021",
      "Gadroli BO": "176053",
      "Sunhara BO": "176053",
      "Bhadiara BO": "176209",
      "Chalwara BO": "176023",
      "Harsar BO": "176023",
      "Kharota BO": "176023",
      "Matlahar BO": "176023",
      "Dadoli BO": "176026",
      "Bhadrer BO": "176047",
      "Massal BO": "176047",
      "Jarot BO": "176027",
      "Katora BO": "176027",
      "Rajol BO": "176208",
      "Jambal BO": "177113",
      "Tiambal BO": "177113",
      "Gurnwar BO": "177106",
      "Rail BO": "177106",
      "Bagli BO": "176209",
      "Beehan BO": "177103",
      "Bangoli BO": "176028",
      "Bhatoli Phakorian BO": "176028",
      "Sudhangal BO": "176036",
      "Bara BO": "177104",
      "Tikkar BO": "177034",
      "Barikalan BO": "176055",
      "Niar BO": "177112",
      "Nandrool BO": "176001",
      "Samela BO": "176001",
      "Kachhiari BO": "176001",
      "Ghurkari BO": "176001",
      "Ghiana Kalan BO": "176001",
      "Kohala BO": "176001",
      "Airla BO": "176054",
      "Jakhara BO": "176021",
      "Dhamer BO": "176038",
      "Jalari BO": "176038",
      "Janyankar BO": "176038",
      "Sathana BO": "176025",
      "Sihal BO": "176053",
      "Sunet BO": "176053",
      "Bandi BO": "176209",
      "Chetru BO": "176209",
      "Barana BO": "176047",
      "Chari BO": "176047",
      "Hatwas BO": "176047",
      "Amlela BO": "176027",
      "Barial BO": "176027",
      "Yoljharer BO": "176208",
      "Bhallad BO": "176023",
      "Har BO": "176023",
      "Jhonkha Ratial BO": "176023",
      "Makrahan BO": "176023",
      "Nana BO": "176023",
      "Pharian BO": "176023",
      "Bhater BO": "176026",
      "Masroor BO": "176026",
      "Spail BO": "176026",
      "Baldhar BO": "176047",
      "Jalot BO": "176047",
      "Malan BO": "176047",
      "Pathiar BO": "176047",
      "Dargia Sakri BO": "176027",
      "Katholi BO": "176027",
      "Nerti BO": "176208",
      "Tatwani BO": "176208",
      "Dahab BO": "176051",
      "Kothikohar BO": "175013",
      "Baragraon BO": "175013",
      "Deot BO": "175013",
      "Lohardi BO": "175013",
      "Samnoli BO": "177110",
      "Sawana BO": "177110",
      "Palampur HO": "176061",
      "Dehra HO": "177101",
      "Kangra HO": "176001",
      "Dharamsala HO": "176215",
      "Dadasiba SO": "177106",
      "Dhaliara SO": "177103",
      "Chachian SO": "176059",
      "Harchakian SO": "176210",
      "Indora SO": "176401",
      "Khaniara SO": "176218",
      "Kotla SO Kangra": "176205",
      "Kotwali Bazar Dharamsala SO": "176215",
      "Ghamroor SO": "176502",
      "Haripur SO": "176028",
      "Pirsaluhi SO": "177034",
      "Pragpur SO": "177107",
      "Daulatpur SO Kangra": "176038",
      "Gaggal SO": "176209",
      "Jawali SO": "176023",
      "Nagrota Bagwan SO": "176047",
      "Rait SO": "176208",
      "Ranital SO Kangra": "176029",
      "Sunehar SO": "176056",
      "Nehran Pukhar SO": "177104",
      "Bhadwar SO": "176200",
      "Damtal SO": "176403",
      "Dari SO": "176057",
      "Gangtha SO": "176204",
      "Hpbose Dharamsala SO": "176213",
      "Mcleodganj SO": "176219",
      "Niazpur SO": "176202",
      "Charri SO": "176217",
      "Ladori SO": "176203",
      "Bankhandi SO": "177114",
      "Garli SO": "177108",
      "Jawalamukhi SO": "176031",
      "Kohala SO": "176036",
      "Qusba Kotla SO": "177111",
      "Rakkar SO": "177043",
      "Thill SO": "176055",
      "Thore SO": "177105",
      "Raja Ka Talab SO": "176051",
      "Sunhi SO": "176037",
      "Tiara SO": "176214",
      "Chanour SO": "177113",
      "Ghallour SO": "176066",
      "Guler SO": "176033",
      "Khundian SO": "176030",
      "Muhal SO": "177117",
      "Sansarpur Terrace SO": "176501",
      "Tipri SO": "177112",
      "Dhameta SO": "176025",
      "Fatehpur SO Kangra": "176053",
      "Lanj SO": "176026",
      "Nagrota Surian SO": "176027",
      "Rehan SO": "176022",
      "Tihri SO": "176032",
      "Baroh SO": "176054",
      "Bharmar SO": "176021",
      "Tanda SO": "176002",
      "Darang SO": "176060",
      "Dharamsala Cantt SO": "176216",
      "Jassur SO": "176201",
      "Kandrori SO": "176402",
      "Rey SO": "176058",
      "Shahpur Kangra SO": "176206",
      "Alampur SO Kangra": "176082",
      "Bhawana SO": "176076",
      "Bhullanaso SO": "176071",
      "Lahru SO": "176098",
      "Lambagaon SO": "176096",
      "Malkher SO": "176093",
      "Molag SO": "176089",
      "Noura SO": "176084",
      "Nurpur SO": "176202",
      "Auc Palampur SO": "176062",
      "Bhawarna SO": "176083",
      "Chadhiar SO": "176088",
      "Chobin SO": "176128",
      "Ghuggar SO": "176061",
      "Maranda SO": "176102",
      "Sullah SO": "176085",
      "Thural SO": "176107",
      "Paraur SO": "176064",
      "Rajhoon SO": "176065",
      "Saliali SO": "176211",
      "Baijnath SO Kangra": "176125",
      "Bairhgat SO": "176073",
      "Daroh SO": "176092",
      "Duhak SO": "176075",
      "Jalag SO": "176094",
      "Khera SO": "176086",
      "Majherna SO": "176063",
      "Paprola SO": "176115",
      "Sanghole SO": "176091",
      "Rajpur SO": "176067",
      "Ram Nagar Dharamsala SO": "176215",
      "Tilokpur SO Kangra": "176225",
      "Yol Camp SO": "176052",
      "Bir SO Kangra": "176077",
      "Dheera SO": "176101",
      "Jaisinghpur SO Kangra": "176095",
      "Marera SO": "176097",
      "Pahra SO": "176087",
      "Panchrukhi SO": "176103",
      "Taragarh Kangra SO": "176081"
    },
    "HAMIRPUR": {
      "Harsour BO": "174305",
      "Bhakreri BO": "174305",
      "Pathliar BO": "174305",
      "Nara BO": "174309",
      "Loharda BO": "174304",
      "Chanruhi BO": "177024",
      "Hanoh BO": "177024",
      "Aghar BO": "176041",
      "Jhiralari BO": "176041",
      "Kharwar BO": "176041",
      "Ropari BO": "176041",
      "Bihru BO": "176040",
      "Ghangot BO": "176039",
      "Amroh BO": "177020",
      "Baroh BO": "177024",
      "Bhukkar BO": "177024",
      "Baliah Khurd BO": "174305",
      "Lagmanwin BO": "177118",
      "Knoh BO": "174304",
      "Sour BO": "176041",
      "Town Bharari Devi BO": "176041",
      "Dadwin BO": "176040",
      "Dhangota BO": "176040",
      "Mangnoti BO": "176040",
      "Pairwin BO": "176040",
      "Biar BO": "177119",
      "Ghumarli BO": "177119",
      "Samman Kothi BO": "177119",
      "Loharli BO": "176039",
      "Bajrol BO": "177028",
      "Badehra BO": "177040",
      "Panyali Jattan BO": "177040",
      "Sanahi BO": "177040",
      "Himmer BO": "177025",
      "Sarahkar BO": "177027",
      "Ghaloon BO": "177042",
      "Hathol BO": "177041",
      "Pansai BO": "177041",
      "Balh Uttap BO": "177026",
      "Phahal BO": "177026",
      "Gahli Kohlwin BO": "174405",
      "Kakrot BO": "176048",
      "Chowki Jamwalan BO": "177020",
      "Khiah BO": "177020",
      "Baloh BO": "177029",
      "Bharthian BO": "177029",
      "Chamned BO": "177029",
      "Kaloor BO": "177033",
      "Nain BO": "176039",
      "Phagoti BO": "176039",
      "Raili Jajri BO": "176039",
      "Mair BO": "174405",
      "Batarli Upperli BO": "174312",
      "Chhatoli Rajputan BO": "174312",
      "Karsai BO": "174312",
      "Beh Bassaral BO": "177041",
      "Gwal Pathar BO": "177041",
      "Jansooh BO": "177041",
      "Bahal BO": "177026",
      "Badehar BO": "176048",
      "Changar BO": "174505",
      "Dudhana BO": "177026",
      "Dhanwin BO": "177401",
      "Tal BO": "177401",
      "Fatehpur BO": "177042",
      "Sudhial BO": "177042",
      "Bauru BO": "177028",
      "Bherda BO": "177028",
      "Khanouli BO": "177028",
      "Dimmi BO": "177025",
      "Tikkar BO": "177025",
      "Karara BO": "177027",
      "Nareli BO": "177020",
      "Dugli BO": "177029",
      "Bharmoti BO": "177033",
      "Ree BO": "177007",
      "Tarpohal BO": "176109",
      "Bafrin BO": "177029",
      "Jhanjiani BO": "174305",
      "Dhamrol BO": "177024",
      "Beri BO": "176041",
      "Kathiana BO": "176041",
      "Patta BO": "176041",
      "Balh Bihal BO": "176040",
      "Deotsidh BO": "176039",
      "Mehal BO": "177401",
      "Batran BO": "177042",
      "Kheri BO": "176109",
      "Jandru BO": "177028",
      "Dho BO": "177025",
      "Majhog Sultani BO": "177020",
      "Bela BO": "177033",
      "Thathwani BO": "177501",
      "Rangar BO": "176111",
      "Dangri BO": "177048",
      "Majhiar BO": "177038",
      "Bir Bagehra BO": "176110",
      "Kanerar BO": "176110",
      "Barara BO": "177023",
      "Barin BO": "177023",
      "Mansai BO": "177006",
      "Baragoan BO": "176049",
      "Dakhyora BO": "176049",
      "Dhabiri BO": "176049",
      "Lafran BO": "176049",
      "Baroti BO": "176042",
      "Dain BO": "176042",
      "Samtana Kalan BO": "176042",
      "Ropa BO": "177001",
      "Bhira BO": "177001",
      "Jhaniara BO": "177001",
      "Badhani BO": "177601",
      "Chamboh BO": "177601",
      "Samirpur BO": "177601",
      "Lahar BO": "177044",
      "Dhirwin BO": "176045",
      "Jakhyol BO": "176045",
      "Balduhak BO": "177048",
      "Booni Nohngi BO": "177048",
      "Kitpal BO": "177038",
      "Patnaun BO": "177023",
      "Thana Bajuri BO": "177023",
      "Banalag BO": "177022",
      "Bhater BO": "177022",
      "Lag Devi BO": "177022",
      "Kaswar BO": "174312",
      "Ukhali BO": "176042",
      "Kohdra BO": "174311",
      "Sohari BO": "174311",
      "Daruhi BO": "177001",
      "Bari BO": "177001",
      "Dugha BO": "177001",
      "Kakriar BO": "177001",
      "Jhaniari BO": "177001",
      "Jeehan BO": "177044",
      "Karaur BO": "177301",
      "Dungrin BO": "176045",
      "Aman BO": "177501",
      "Dhail BO": "176111",
      "Nalahi BO": "176111",
      "Jol Sappar BO": "177048",
      "Charot BO": "176110",
      "Gawardu BO": "177023",
      "Utpur BO": "177022",
      "Kohla BO": "177033",
      "Chamiana BO": "176111",
      "Chauri BO": "176111",
      "Jol Lambri BO": "176111",
      "Putrial BO": "177045",
      "Tira BO": "176110",
      "Thana BO": "176110",
      "Tipper BO": "174312",
      "Khuthrin BO": "176043",
      "Sathwin BO": "176049",
      "Karohta BO": "176044",
      "Kirwin BO": "174311",
      "Kulehra BO": "174311",
      "Masiana BO": "177001",
      "Nalti BO": "177001",
      "Bohni BO": "177001",
      "Mohin BO": "177001",
      "NERI BO": "177001",
      "Choru BO": "177044",
      "Jhalan BO": "177301",
      "Karot BO": "176108",
      "Tikkari Manhasan BO": "176045",
      "Jharlog BO": "176043",
      "Saned BO": "176043",
      "Sulkhan BO": "176043",
      "Karer BO": "174311",
      "Khagal BO": "177001",
      "Jijwin BO": "176045",
      "Ludder Mahadev BO": "176045",
      "Nagrota Gazian BO": "176045",
      "Tarkwari BO": "176045",
      "Barsar HO": "174305",
      "Hamirpur HO HP Circle": "177001",
      "Bahanwin SO": "177118",
      "Maharal SO": "176049",
      "Mundkhar SO": "176044",
      "Gandhi Chowk Hamirpur SO": "177001",
      "Jalari SO": "177042",
      "Bijhari SO": "176040",
      "Bumbloo SO": "177119",
      "Chakmoh SO": "176039",
      "Galore SO": "177026",
      "Kashmir SO": "177006",
      "Ladraur SO": "176043",
      "Didwin SO": "177401",
      "Kakkar SO": "177028",
      "Bahina SO": "174309",
      "Bani SO HamirpurHP": "174304",
      "Bhareri SO": "177024",
      "Dhaneta SO": "177041",
      "Jahu SO": "176048",
      "Jaure Amb SO": "174312",
      "Mehre SO": "174305",
      "Salauni SO": "174311",
      "Awah Devi SO": "177601",
      "Bagwara SO": "177021",
      "Basaral SO": "177301",
      "Bhoranj SO": "176045",
      "Govt Degree College Hamirpur SO": "177005",
      "Jangal Beri SO": "176109",
      "Kangoo SO": "177040",
      "Bhota SO": "176041",
      "Dhaned SO": "174505",
      "Hareta SO": "174405",
      "Mair SO": "176042",
      "Bara SO HamirpurHP": "177044",
      "Bhaleth SO": "176108",
      "Chabutra SO": "177007",
      "Kanjian SO": "177025",
      "Lambloo SO": "177029",
      "Parol SO": "177501",
      "Tauni Devi SO": "177023",
      "Uhal SO": "177022",
      "Rangas SO": "177048",
      "Sera SO": "177038",
      "Kot SO HamirpurHP": "177027",
      "Kuthera SO": "177020",
      "Rail SO": "177045",
      "Nadaun SO": "177033",
      "NIT Hamirpur SO": "177005",
      "Patlander SO": "176111",
      "Sujanpur Tira SO": "176110"
    },
    "LAHUL AND SPITI": {
      "Gemour BO": "175132",
      "Tandi BO keylong": "175132",
      "Kolang BO KEYLONG": "175132",
      "Koksar BO": "175140",
      "Mooring BO": "175139",
      "Chimrat BO": "175142",
      "Salugran BO": "175142",
      "Samdoh BO": "175132",
      "Jispa BO": "175132",
      "Peokar BO": "175132",
      "Thirot BO": "175139",
      "Karpat BO": "175142",
      "Kordang BO": "175132",
      "Mooling BO": "175132",
      "Jobrang BO": "175133",
      "Shansha BO": "175133",
      "Goshal BO": "175132",
      "Malang BO": "175132",
      "Yurnath BO": "175132",
      "Sissu BO": "175140",
      "Tindi BO": "175142",
      "Trilokinath BO": "175142",
      "Demul BO": "172114",
      "Hikkam BO": "172114",
      "Gulling BO": "172117",
      "Lalung BO": "172113",
      "Hansa BO": "172114",
      "Hull BO": "172114",
      "Gue BO": "172111",
      "Dhanker BO": "172113",
      "Kee Gompa BO": "172114",
      "Kibber BO": "172114",
      "Lara BO": "172114",
      "Losser BO": "172114",
      "Rangrik BO": "172114",
      "Samdoo BO": "172111",
      "Mud BO": "172117",
      "Mane BO": "172113",
      "Keylong HO": "175132",
      "Kaza SO": "172114",
      "Sagnam SO": "172117",
      "Tabo SO": "172113",
      "Jahalman SO": "175139",
      "Gondhla SO": "175140",
      "Lote SO Lahul  Spiti": "175133",
      "Udaipur SO HP Circle": "175142"
    },
    "MANDI": {
      "Dhamerh BO": "175106",
      "Khalwan BO": "175106",
      "Ghat BO": "175123",
      "Khunachi BO": "175123",
      "Ghaniar BO": "175106",
      "Khuhan BO": "175106",
      "Gadagushaini BO": "175123",
      "Panjain BO": "175106",
      "Pehad BO": "175040",
      "Behna BO": "175006",
      "Kummi BO": "175006",
      "Barswan BO": "175036",
      "Kathyaun BO": "175036",
      "Kothi BO": "175036",
      "Meramasit BO": "175036",
      "Khan BO": "175049",
      "Pingla BO": "175049",
      "Thona BO": "175049",
      "Tikkar BO Jamani": "175049",
      "Bhararu BO": "175015",
      "Chalarag BO": "175015",
      "Chimnu BO": "175015",
      "Drahal BO": "175015",
      "Tullah BO": "175015",
      "Khalanoo BO": "175003",
      "Mohanghati BO": "175032",
      "Ropri Kalehru BO": "175032",
      "Giun BO": "175040",
      "Gahar BO": "175049",
      "Balhjoli BO": "175015",
      "Harabagh BO": "175015",
      "Jhatingri BO": "175015",
      "Segli BO": "175005",
      "Lagdhar BO": "175003",
      "Pandol BO": "175032",
      "Tikroo BO": "175032",
      "Baroti BO": "175030",
      "Dhawali BO": "175040",
      "Kot BO Dharampur": "175040",
      "Kurati BO": "175014",
      "Hari Behna BO": "175007",
      "Dasehra BO": "175036",
      "Leda BO": "175036",
      "Bhadarwar BO": "175049",
      "Gehra BO": "175049",
      "Bassi BO": "175029",
      "Bihun BO": "175015",
      "Dohag BO": "175015",
      "Dul BO": "175015",
      "Gumma BO": "175015",
      "Jalpehar BO": "175015",
      "Kuthera BO": "175015",
      "Katindi BO": "175005",
      "Tihri BO": "175005",
      "Kot BO Kotli": "175003",
      "Saletar BO": "175003",
      "Samrahan BO": "175003",
      "Balhkwar BO": "175016",
      "Shiah BO": "175141",
      "Prainsainthal BO": "175032",
      "Tramat BO": "175032",
      "Sidhpur BO": "175040",
      "Taurjajar BO": "175040",
      "Jhamerh BO": "175014",
      "Sakroha BO": "175006",
      "Tikkar BO": "175006",
      "Langna BO": "175015",
      "Majharnoo BO": "175015",
      "Makreri BO": "175015",
      "Nohali BO": "175015",
      "Thara BO": "175015",
      "Urla BO": "175015",
      "Batheri BO": "175005",
      "Bhargaon BO": "175003",
      "Dawahan BO": "175003",
      "Khadyad BO": "175003",
      "Basona BO": "175016",
      "Karsal BO": "175016",
      "Khaddar BO": "175016",
      "Nanawan BO": "175001",
      "Talyahar BO": "175001",
      "Drang BO": "175001",
      "Paddal BO": "175001",
      "Bir BO": "175001",
      "Majhwar BO": "175001",
      "Padhiun BO": "175001",
      "Randhara BO": "175001",
      "Balu BO": "175121",
      "Thachi BO": "175121",
      "Thalout BO": "175121",
      "Guran BO": "175121",
      "Bahnu BO": "175033",
      "Barin BO": "175033",
      "Khudla BO": "175033",
      "Narola BO": "175033",
      "Upper Bhambla BO": "175004",
      "Ahju BO": "175032",
      "Gangoti BO": "175032",
      "Ghamiroo BO": "175032",
      "Rehardhar BO": "175001",
      "Tandu BO": "175001",
      "Alathu BO": "175001",
      "Sadyana BO": "175001",
      "Dudar BO": "175001",
      "Nagwain BO": "175121",
      "Somnachi BO": "175121",
      "Balhara BO": "175033",
      "Jahmet BO": "175033",
      "Dhalwan BO": "175004",
      "Bijni BO": "175001",
      "Bari Gumanu BO": "175001",
      "Pali BO": "175001",
      "Tarnoh BO": "175001",
      "Tilli BO": "175001",
      "Tandgalu BO": "175001",
      "Kotkamradha BO": "175121",
      "Panarsa BO": "175121",
      "Chowk BO": "175033",
      "Bardhan BO": "175013",
      "Thaltukhod BO": "175013",
      "Khajoor BO": "175016",
      "Binga BO": "175050",
      "Saklana BO": "175050",
      "Galma BO": "175008",
      "Khakhariana BO": "175008",
      "Pairi BO": "175008",
      "Ratti BO": "175008",
      "Ghambhar Khad BO": "175023",
      "Kalkhar BO": "175023",
      "Patrighat BO": "175023",
      "Reur BO": "175023",
      "Baloh BO": "175052",
      "Baryara BO": "175052",
      "Sehli BO Saigaloo": "175052",
      "Bathera BO": "175034",
      "Cholangarh BO": "176090",
      "Maseran BO": "175024",
      "Nabahi Devi BO": "175024",
      "Paunta BO": "175024",
      "Rissa BO": "175024",
      "Ropari BO": "175024",
      "Surajpur Bari BO": "175024",
      "Ghararu BO": "175026",
      "Nalyana BO": "175026",
      "Tanihar BO": "175026",
      "Lohara BO": "175027",
      "Rajgarh BO": "175027",
      "Rajwari BO": "175027",
      "Jugahan BO": "175002",
      "Kaloud BO": "175002",
      "Devdhar BO": "175029",
      "Moviseri BO": "175029",
      "Nagchala BO": "175021",
      "Bag BO": "175032",
      "Tikri Sidhwani BO": "175004",
      "Mandal BO": "175021",
      "Golwan BO": "175032",
      "Kotmorse BO": "175001",
      "Boching BO": "175013",
      "Barsu BO": "175021",
      "Gutkar BO": "175021",
      "Kolang BO": "175016",
      "Panjalag BO": "175016",
      "Samour BO": "175050",
      "Troh BO": "175008",
      "Chukku BO": "175012",
      "Kathog BO": "175012",
      "Deori BO": "175124",
      "Nandi BO": "175124",
      "Shiva BO": "175124",
      "Jandhrukalan BO": "175042",
      "Sardhwar BO": "175023",
      "Thinagaloo BO": "175023",
      "Darwar BO": "175025",
      "Longni BO": "175025",
      "Trifalghat BO": "175034",
      "Lower Dhalara BO": "176090",
      "Lower Ghanala BO": "176090",
      "Fatehpur BO": "175024",
      "Khalardu BO": "175024",
      "Paplog BO": "175024",
      "Kanaid BO": "175019",
      "Brikhmani BO": "175027",
      "Dabhan BO": "175027",
      "Bagachanogi BO": "175035",
      "Matroo BO": "175032",
      "Rahla BO": "175125",
      "Badhu BO": "175045",
      "Kot BO Chachiot": "175028",
      "Jambla BO": "175030",
      "Taleli BO": "175030",
      "Parwara BO": "175029",
      "Brokhari BO": "175031",
      "Chathri BO": "175047",
      "Sangalwara BO": "175047",
      "Bakhrot BO": "175011",
      "Mahog BO": "175011",
      "Ootpur BO": "175016",
      "Simas BO": "175016",
      "Kamlahkhas BO": "175050",
      "Tanehar BO": "175050",
      "Balt BO": "175008",
      "Sadhyani BO": "175008",
      "Balh BO": "175012",
      "Gawali BO": "175012",
      "Bandhi BO": "175124",
      "Saroa BO": "175124",
      "Sarkidhar BO": "175023",
      "Bachwan BO": "175034",
      "Dhurkhari BO": "175034",
      "Tourkhola BO": "176090",
      "Kangu Ka Gehra BO": "175026",
      "Khoda BO": "175026",
      "Sadhot BO": "175037",
      "Chunahan BO": "175027",
      "Diyargi BO": "175027",
      "Surah BO": "175027",
      "Syanji BO": "175027",
      "Kandha BO": "175035",
      "Kapahi BO": "175002",
      "Shala BO": "175028",
      "Kanda Churag  BO": "175010",
      "Kelodhar BO": "175029",
      "Sayanj BO": "175029",
      "Chowki BO": "175031",
      "Bihani BO": "175047",
      "Ruhamani BO": "175047",
      "Bhanera BO": "175011",
      "Banthal BO": "175011",
      "Kunho BO": "175011",
      "Kufri BO": "175012",
      "Kunnu BO": "175012",
      "Padhwan BO": "175012",
      "Ropa BO": "175012",
      "Silhbadhani BO": "175012",
      "Sudhar BO": "175012",
      "Gharan BO": "175124",
      "Kalhani BO": "175124",
      "Kholanal BO": "175124",
      "Mahogi BO": "175124",
      "Basantpur BO": "175042",
      "Darpa BO": "175042",
      "Gharwasra BO": "175025",
      "Sari BO": "175025",
      "Kasmaila BO": "175034",
      "Kot BO Samaila": "175034",
      "Jhangi BO": "176090",
      "Kothwan BO": "176090",
      "Kujabalh BO": "176090",
      "Bararta BO": "175024",
      "Brang BO": "175024",
      "Shikawari BO": "175035",
      "Shillibagi BO": "175035",
      "Thanashiva BO": "175035",
      "Silhanu BO": "175045",
      "Sukkibain BO": "175045",
      "Nalag BO": "175030",
      "Bara BO": "175029",
      "Rohanda BO": "175031",
      "Mehndi BO": "175011",
      "Teban BO": "175011",
      "Balag BO": "175038",
      "Thanda Pani BO": "175046",
      "Pressi BO": "175046",
      "Batwara BO": "175017",
      "Dhawal BO": "175017",
      "Sudhan BO": "175017",
      "Chambi BO": "175018",
      "Churad BO": "175018",
      "Alsindi BO": "175009",
      "Cheuni BO": "175048",
      "Jarol BO Thunag": "175048",
      "Sunah Lamba Thach BO": "175048",
      "Seghli BO": "175029",
      "Jahal BO": "175039",
      "Ghiri BO": "175031",
      "Jhungi BO": "175031",
      "Movi Devi Galoo BO": "175031",
      "Paura Kothi BO": "175031",
      "Chauridhar BO": "175011",
      "Gowalpur BO": "175011",
      "Kaw BO": "175011",
      "Khenyol BO": "175011",
      "Nanj BO": "175011",
      "Sainj Bagra BO": "175011",
      "Katwachi BO": "175046",
      "Ghanghnoo BO": "175018",
      "Kangoo BO": "175018",
      "Bagshar BO": "175009",
      "Hara BO": "175009",
      "Sapnot BO": "175010",
      "Seri BO": "175011",
      "Soma Kothi BO": "175011",
      "Surahan Suket BO": "175011",
      "Rakol BO": "175038",
      "Seri Kothi BO": "175038",
      "Maloh BO": "175018",
      "Sehli BO": "175018",
      "Upper Behli BO": "175018",
      "Vayala BO": "175018",
      "Balindi BO": "175010",
      "Behli BO": "175009",
      "Doghari BO": "175009",
      "Mahun BO": "175010",
      "Pokhi BO": "175011",
      "Sankar Dehra BO": "175011",
      "Jarol BO": "175018",
      "Mahadev BO": "175018",
      "Salwana BO": "175018",
      "Dharmour Kheel BO": "175010",
      "Jassal BO": "175009",
      "Sakra BO": "175009",
      "Shorshan BO": "175010",
      "Mandi HO": "175001",
      "Sunder Nagar Township HO": "175019",
      "Baldwara SO": "175033",
      "Bhangrotu SO": "175021",
      "Cholthra SO": "175037",
      "Gagal SO": "175006",
      "Gurkotha SO": "175036",
      "Ladbharole SO": "175016",
      "Mangwain Mohalla SO": "175001",
      "Padhar SO": "175012",
      "Rakhoh SO": "175042",
      "Sajao Pipluso SO": "175025",
      "Sarkaghat SO": "175024",
      "Shanan Power House SO": "175015",
      "Baggi SO": "175027",
      "Bagsaid SO": "175035",
      "Nihri SO": "175038",
      "Tattapani SO": "175009",
      "Barot SO": "175013",
      "Chauntra SO": "175032",
      "Jamni SO": "175049",
      "Joginder Nagar SO": "175015",
      "Khaliar SO": "175001",
      "Kotli SO": "175003",
      "Ner Chowk SO": "175008",
      "Saigaloo SO": "175052",
      "Sandhole SO": "176090",
      "Seoh SO": "175051",
      "Bhojpur SO Mandi": "175002",
      "Chachiot SO": "175028",
      "Purana Nagar SO": "175019",
      "Slapper SO": "175017",
      "Chail Chowk SO": "175045",
      "Balichowki SO": "175106",
      "Aut SO": "175121",
      "Bhambla SO": "175004",
      "Drubbal SO": "175014",
      "Gopalpur SO Mandi": "175007",
      "Jail Road SO Mandi": "175001",
      "Marhi SO": "175050",
      "Purani Mandi SO": "175001",
      "Rewalsar SO": "175023",
      "Tihra SO": "175026",
      "Kamand SO": "175075",
      "Churag SO": "175010",
      "Gohar SO": "175029",
      "Jaidevi SO": "175031",
      "Karsog SO": "175011",
      "Sunder Nagar1 SO": "175018",
      "Dharampur SO Mandi": "175040",
      "Kataula SO": "175005",
      "Pandoh SO": "175124",
      "Samaila SO": "175034",
      "Gumma (Mandi) S.O": "175020",
      "Dehar SO": "175030",
      "Jachh SO": "175039",
      "Janjehli SO": "175047",
      "Pangna SO": "175046",
      "Thunag SO": "175048"
    },
    "KULLU": {
      "Bhekhali BO": "175101",
      "Palchan BO": "175103",
      "Bachoot BO": "175123",
      "Deotha BO": "175123",
      "Gushaini BO": "175123",
      "Chakurtha BO": "175106",
      "Chehni BO": "175123",
      "Chettar BO": "175123",
      "Gaidhar BO": "175123",
      "Jibhi BO": "175123",
      "Kararsu BO": "175101",
      "Puid BO": "175101",
      "Kais BO": "175101",
      "Vashisht BO": "175103",
      "Bahu BO": "175123",
      "Manglore BO": "175123",
      "Peej BO": "175101",
      "Bharai BO": "175101",
      "Bari BO": "175101",
      "Neoli BO": "175138",
      "Seobag BO": "175138",
      "Barua BO": "175103",
      "Kotla BO": "175106",
      "Panihar BO": "175106",
      "Thatibir BO": "175106",
      "Anah BO": "175123",
      "Bathad BO": "175123",
      "Chanon BO": "175123",
      "Kalwari BO": "175123",
      "Doghari BO Bhutti": "175102",
      "Shalang BO": "175102",
      "Karjan BO": "175136",
      "Khakhnal BO": "175143",
      "Jalugraon BO": "175105",
      "Kasol BO": "175105",
      "Baragaon BO": "175129",
      "Dyar BO": "175141",
      "Prini BO": "175143",
      "Malana BO": "175105",
      "Manikaran BO": "175105",
      "Pangaon BO": "175129",
      "Dugilag BO": "175102",
      "Dhara BO": "175105",
      "Kasladi BO": "175105",
      "Dobhi BO": "175129",
      "Patlikulh BO": "175129",
      "Shirad BO": "175128",
      "Bajahara BO": "175134",
      "Banogi BO": "175134",
      "Bhalan BO": "175134",
      "Kharihar BO": "175126",
      "Mohal BO": "175126",
      "Larji BO": "175121",
      "Thela BO": "175141",
      "Barshaini BO": "175105",
      "Bradha BO": "175105",
      "Fozal BO": "175129",
      "Archandi BO": "175104",
      "Chhiyal BO": "175131",
      "Kalath BO": "175131",
      "Bandrole BO": "175128",
      "Dhaugi BO": "175134",
      "Madana BO": "175134",
      "Reila BO": "175134",
      "Salwar BO": "175134",
      "Bran BO": "175131",
      "Biasar BO": "175128",
      "Brehin BO": "175134",
      "Kanoun BO": "175134",
      "Suchain BO": "175134",
      "Purani Manali BO": "175131",
      "Raman BO": "175130",
      "Majhan BO": "175134",
      "Mohani BO": "175123",
      "Nohanda BO": "175123",
      "Palach BO": "175123",
      "Sarchi BO": "175123",
      "Pujali BO": "175123",
      "Jia BO": "175125",
      "Khokhan BO": "175125",
      "Neol BO": "175125",
      "Bhalyani BO": "175102",
      "Tandi BO": "172033",
      "Bajaura BO": "175125",
      "Chheur BO": "175125",
      "Hurla BO": "175125",
      "Piplage BO": "175125",
      "Luhri BO": "172001",
      "Khanag BO": "172026",
      "Khunn BO": "172026",
      "Kothi BO": "172026",
      "Shawad BO": "172026",
      "Jaon BO": "172002",
      "Ghatu BO": "172023",
      "Tunan BO": "172001",
      "Kamand BO": "172026",
      "Karana BO": "172026",
      "Sarahan BO": "172002",
      "Kandagai BO": "172025",
      "Koil BO": "172023",
      "Urtu BO": "172023",
      "Sojha BO": "175123",
      "Tung BO": "175123",
      "Bhrain BO": "175125",
      "Sachiyani BO": "175125",
      "Poshna BO": "172001",
      "Deori BO": "172026",
      "Digerh BO": "172026",
      "Nigan BO": "172026",
      "Beoni BO": "172002",
      "Deem BO": "172002",
      "Nishani BO": "172002",
      "Dehar BO": "172025",
      "Kushwa BO": "172201",
      "Duhad BO": "172026",
      "Kandugad BO": "172026",
      "Lagouti BO": "172026",
      "Peog BO": "172026",
      "Shamani BO": "172002",
      "Gad BO": "172032",
      "Olwa BO": "172025",
      "Sush BO": "172025",
      "Kharga BO": "172201",
      "Sargha BO": "172201",
      "Jadoli BO": "172023",
      "Sharvi BO": "172023",
      "Durah BO": "172033",
      "Kullu HO": "175101",
      "Banjar SO": "175123",
      "Haripur SO Kullu": "175136",
      "Katrain SO": "175129",
      "Manali SO Kullu": "175131",
      "Sainj SO": "175134",
      "Dalash SO": "172025",
      "Anni SO": "172026",
      "Arsu SO": "172002",
      "Chowai SO": "172032",
      "Akhara Bazar SO": "175101",
      "Babeli SO": "175138",
      "Bhutti SO": "175102",
      "Jaree SO": "175105",
      "Larenkelo SO": "175104",
      "Naggar SO": "175130",
      "Raison SO": "175128",
      "Sultanpur SO Kullu": "175101",
      "Bahang SO": "175103",
      "Bhuntar SO": "175125",
      "Jagatsukh SO": "175143",
      "Shamshi SO": "175126",
      "Nirmand SO": "172023",
      "Nither SO": "172033",
      "Garsa SO": "175141"
    },
    "BILASPUR": {
      "Dobha BO": "174001",
      "Rishikesh BO": "174024",
      "Tatoh BO": "174001",
      "Chhakoh BO": "174001",
      "Badaghat BO": "174029",
      "Baloh BO": "174029",
      "Baragoan BO": "174029",
      "Malagan BO": "174029",
      "Sunhani BO": "174029",
      "Bhakra BO": "174201",
      "Matla BO": "174034",
      "Thuran BO": "174034",
      "Bhager BO": "174021",
      "Balh Churani BO": "174003",
      "Salaon BO": "174028",
      "Makri BO": "174201",
      "Rani Kotla BO": "174033",
      "Suin Surhar BO": "174033",
      "Malraon BO": "174035",
      "Bhulswai BO": "174026",
      "Barota BO": "174027",
      "Lanjta BO": "174027",
      "Taroun BO": "174027",
      "Koserian BO": "174030",
      "Naghiar BO": "174030",
      "Kothipura BO": "174001",
      "Deoth BO": "174001",
      "Noa BO": "174001",
      "Brahampukhar BO": "174001",
      "Kallar BO": "174001",
      "Sai Kharsi BO": "174001",
      "Harnora BO": "174036",
      "Salnoo BO": "174013",
      "Lehri BO": "174002",
      "Lakhnoo BO": "174015",
      "Dhaloh BO": "174029",
      "Kaphara BO": "174029",
      "Gawalthi BO": "174201",
      "Tarsooh BO": "174201",
      "Bari Majherwin BO": "174021",
      "Loharwin BO": "174021",
      "Takrera BO": "174021",
      "Tantha BO": "174026",
      "Bhatwara BO": "174028",
      "Marhana BO": "174028",
      "Dhani Pukher BO": "174017",
      "Balghar BO": "174031",
      "Ser BO": "174031",
      "Bharoli Kalan BO": "174035",
      "Panoh BO": "174004",
      "Talwara BO": "174026",
      "Bhapral BO": "174027",
      "Gandhalwin BO": "174027",
      "Nakrana BO": "174310",
      "Dhoun Kothi BO": "174012",
      "Kutehla BO": "174011",
      "Gangloh BO": "174030",
      "Jaddu BO": "174030",
      "Beri Razadian BO": "174001",
      "Behna Jattan BO": "174024",
      "Lakhanpur BO": "174001",
      "Chharol BO": "174001",
      "Nanawan BO": "174013",
      "Kaulan Wala Toba BO": "174002",
      "Majri BO": "174002",
      "Chhat BO": "174029",
      "Ghandhir BO": "174029",
      "Kanphara BO": "174201",
      "Saloa BO": "174201",
      "Dangar BO": "174023",
      "Amarpur BO": "174021",
      "Naswal BO": "174021",
      "Samoh BO": "174021",
      "Majhwar BO": "174003",
      "Kot BO": "174028",
      "Pantehra BO": "174028",
      "Rohal BO": "174031",
      "Rohin BO": "174004",
      "Nalti BO": "174026",
      "Talyana BO": "174026",
      "Pater BO": "174026",
      "Domehar BO": "174027",
      "Gahar BO": "174027",
      "Janali BO": "174310",
      "Swahan BO": "174310",
      "Dagsech BO": "174032",
      "Bauhat Kasol BO": "174012",
      "Jamli BO": "174011",
      "Tanbol BO": "174011",
      "Gharan BO": "174030",
      "Jhabola BO": "174030",
      "Bandla BO": "174001",
      "Bamta BO": "174001",
      "Binola BO": "174001",
      "Deoli BO": "174001",
      "Karloti BO": "174029",
      "Kotlu Brahmana BO": "174029",
      "Dahad BO": "174034",
      "Jabloo BO": "174034",
      "Dabla BO": "174021",
      "Kothi BO": "174021",
      "Bararhin BO": "174003",
      "Chalehli BO": "174003",
      "Marotan BO": "174017",
      "Paploa BO": "174017",
      "Salwar BO": "174017",
      "Bhater Nichli BO": "174004",
      "Chandpur BO": "174004",
      "Malyaur BO": "174004",
      "Hawan BO": "174003",
      "Ladda BO": "174026",
      "Massour BO": "174026",
      "Morsinghi BO": "174026",
      "Sikroha BO": "174032",
      "Soldha BO": "174032",
      "Zakatkhana BO": "174011",
      "Daslehra BO": "174030",
      "Bilaspur Bilaspur HP HO": "174001",
      "Bassi Kehloor SO": "174002",
      "Bilaspur Kty SO": "174001",
      "Dadhol SO": "174023",
      "Hatwar SO": "174028",
      "Jukhala SO": "174033",
      "Kuthera BLP SO": "174026",
      "New Bilaspur Town Ship SO": "174001",
      "NTPC Jamthal SO": "174036",
      "Swarghat SO": "174011",
      "Ghumarwin SO": "174021",
      "Jejwin SO": "174017",
      "Kandraur SO": "174004",
      "Naina Devi SO": "174310",
      "Raghunath Pura SO": "174005",
      "Auhar SO": "174024",
      "Berthin SO": "174029",
      "Bhakra Dam SO": "174201",
      "Geharwin SO": "174034",
      "Lehri Sarail SO": "174027",
      "Panjgain SO": "174012",
      "Raura Sector Bilaspur SO": "174001",
      "Barmana SO": "174013",
      "Behal SO": "174015",
      "Harlog SO": "174003",
      "Jhandutta SO": "174031",
      "Kalol SO Bilaspur HP": "174035",
      "Namhol SO": "174032",
      "Tallai SO": "174030"
    },
    "UNA": {
      "Bhiambi BO": "177038",
      "Charatghar BO": "174315",
      "Jakhera BO": "174315",
      "Nangran BO": "174315",
      "Raipur Sahoran BO": "174315",
      "Suri BO": "177210",
      "Ispur BO": "177207",
      "Badhera BO": "177209",
      "Kanger BO": "177209",
      "Sanouli BO": "174301",
      "Nakroh BO": "177213",
      "Bhadauri BO": "177220",
      "Budhan BO": "174308",
      "Chamiari BO": "174308",
      "Tanoh BO": "174308",
      "Ganu BO": "174319",
      "Bhatoli BO": "174315",
      "Changer B.O": "174315",
      "Sapauri BO": "177210",
      "Khad BO": "177207",
      "Jadla BO": "177208",
      "Kuthar Beet BO": "174503",
      "Khanpur BO": "174301",
      "Bhindla BO": "177039",
      "Mandli BO": "174321",
      "Katauhar Kalan BO": "177211",
      "Kathiari BO": "177211",
      "Kadh BO": "177213",
      "Baliwal BO": "177220",
      "Dhundla BO": "174308",
      "Saloh Beri BO": "174319",
      "Chaksarai BO": "177210",
      "Polian Purohitan BO": "177210",
      "Ripoh Misran BO": "177210",
      "Kuthera Jaswalan BO": "177206",
      "Guglehar BO": "177208",
      "Loharli BO": "177208",
      "Lalri BO": "174507",
      "Nangal Khurd BO": "174507",
      "Paloh BO": "177039",
      "Makrer BO": "174321",
      "Paroian BO": "174321",
      "Churru BO": "177211",
      "Nandpur BO": "177211",
      "Takarala BO": "177211",
      "Deoli BO": "177212",
      "Nangal Jarialan BO": "177212",
      "Sagnai BO": "177212",
      "Bhanjal BO": "177213",
      "Dharampur BO": "177220",
      "Palakwah BO": "177220",
      "Sainsowal BO": "177220",
      "Kohdra BO": "174308",
      "Malangar BO": "174308",
      "Jawar BO": "177210",
      "Mairi BO": "177210",
      "Rajpur Jaswan BO": "177210",
      "Mawa Sindhian BO": "177206",
      "Nagnoli BO": "177208",
      "Polian Beet BO": "174503",
      "Chulhari BO": "177031",
      "Ajauli BO": "174301",
      "Bathri BO": "174507",
      "Bathu BO": "174507",
      "Chhatarpur BO": "174301",
      "Kuneran BO": "177219",
      "Balh BO": "174321",
      "Bhadwar BO": "174321",
      "Chhaproh BO": "174321",
      "Khurwain BO": "174321",
      "Panjoa Ladoli BO": "177211",
      "Butt Kalan BO": "174507",
      "Jankaur BO": "174303",
      "Lamlehri BO": "174303",
      "Panoh BO": "174303",
      "Teuri BO": "174303",
      "Chowar BO": "177203",
      "Kalruhi BO": "177203",
      "Kataur Khurd BO": "177203",
      "Kuthera Kherla BO": "177203",
      "Saloi BO": "177203",
      "Arlu BO": "174307",
      "Kinoo BO": "177109",
      "Lohara BO": "177109",
      "Suhin BO": "177109",
      "Diara BO": "174316",
      "Hamboli BO": "174316",
      "Amboa BO": "177204",
      "Babehar BO": "177204",
      "Bhadarkali BO": "177204",
      "Chalet BO": "177204",
      "Chatara BO": "174306",
      "Tabba Behdala BO": "174306",
      "Beetan BO": "176601",
      "Biderwal BO": "176601",
      "Singan BO": "176601",
      "Badoh BO": "177201",
      "Basoli BO": "174303",
      "Dera Baba Rudra Nand BO": "174303",
      "Dangoli BO": "174303",
      "Dhamandri BO": "174303",
      "Jhamber BO": "174303",
      "Barnoh BO": "174303",
      "Daloh BO": "177203",
      "Charara BO": "174307",
      "Harot BO": "174307",
      "Jajjar BO": "177109",
      "Dhalwari BO": "177110",
      "Ghangret BO": "177110",
      "Nari BO": "177110",
      "Dangohkalan BO": "177204",
      "Mawa Kaholan BO": "177204",
      "Badehar BO": "174306",
      "Badoli BO": "174302",
      "Gondpurjaichand BO": "176601",
      "Hiran BO": "176601",
      "Kaloh BO": "177201",
      "Rainsary BO": "174303",
      "Takka BO": "174303",
      "Badsala BO": "174303",
      "Basal BO": "174303",
      "Kuriala BO": "174303",
      "Samoor Kalan BO": "174303",
      "Andora BO": "177203",
      "Jatehri BO": "174307",
      "Nari Devi Singh BO": "174307",
      "Thathoon BO": "174307",
      "Bhater BO": "177110",
      "Ambehra Dhiraj BO": "174314",
      "Bhalaun BO": "174314",
      "Satother BO": "174302",
      "Rakkar Colony BO": "174303",
      "Chalola BO": "174303",
      "Dathwara BO": "174303",
      "Nangal Salangri BO": "174303",
      "Kotla Khurd BO": "174303",
      "Kotla Kalan BO": "174303",
      "Dohgi Upperli BO": "174307",
      "Hatli BO": "174307",
      "Jassana BO": "174307",
      "Arn Behal BO": "177109",
      "Dharamsal BO": "177110",
      "Gindpur BO": "177110",
      "Jawal BO": "177110",
      "Joh BO": "177204",
      "Pirthipur BO": "177204",
      "Behdala BO": "174306",
      "Batuhi BO": "174302",
      "Gondpurbulla BO": "176601",
      "Kungrat BO": "176601",
      "Una HO": "174303",
      "Bhadsali SO": "174317",
      "Gondpur Banera SO": "177213",
      "Marwari SO": "174319",
      "Mehatpur SO Una": "174315",
      "Mubarikpur SO": "177202",
      "Oel SO Una": "177206",
      "Panjawar SO": "177208",
      "Raipur SO Una": "177031",
      "Bangana SO": "174307",
      "Bharwain SO": "177109",
      "Bhera SO": "174316",
      "Dulehar SO": "176601",
      "Ghanari SO": "177212",
      "Haroli SO": "177220",
      "Nehri Nauranga SO": "177210",
      "Pandogha SO": "177207",
      "Saloh SO": "177209",
      "Santokhgarh SO": "174301",
      "Thathal SO": "177211",
      "Tahliwal SO": "174507",
      "Daulatpurchowk SO": "177204",
      "Dehlan SO": "174306",
      "Dhussara SO": "174302",
      "Thanakalan SO": "174321",
      "Amb SO": "177203",
      "Ambota SO": "177205",
      "Chintpurni SO": "177110",
      "Chowki Maniar SO": "174314",
      "DisttCourt Una SO": "174303",
      "Gagret SO": "177201",
      "Lathiani SO": "174308",
      "Pubowal SO": "174503",
      "Sohari SO": "177039",
      "Sunkali SO": "177219",
      "Talmehra SO": "174320"
    },
    "SHIMLA": {
      "Galeha BO": "171204",
      "Baghar BO": "171202",
      "Devgarh BO": "171202",
      "Garog BO": "171202",
      "Gumma BO": "171018",
      "Purag BO": "171202",
      "Quinal BO": "171202",
      "Charoli BO": "171217",
      "Kanda Banah BO": "171217",
      "Kulag BO": "171217",
      "Jhalta BO": "171216",
      "Tooran BO": "171216",
      "Pahal BO": "171007",
      "Thailla BO": "171007",
      "Khunni BO": "171213",
      "Kiara BO": "171213",
      "Oddi BO": "171213",
      "Shilaru BO": "171213",
      "Kedi BO": "171210",
      "Kiarla BO": "171210",
      "Madhana BO": "171210",
      "Bachhunchh BO": "171207",
      "Jagothi BO": "171207",
      "Karasa BO": "171207",
      "Sungri BO": "171224",
      "Bakhol BO": "171202",
      "Kokunala BO": "171202",
      "Mahasu BO": "171202",
      "Bhalu BO": "171217",
      "Majholi BO": "171217",
      "Giltari BO": "171216",
      "Ghaini BO": "171007",
      "Kiarkoti BO": "171007",
      "Kandroo BO": "171212",
      "Mahog BO": "171212",
      "Shari BO": "171212",
      "Bhalawag BO": "171213",
      "Kanahar BO": "171213",
      "Kharahan BO": "171213",
      "Chanana Dhar BO": "171210",
      "Deiya BO": "171210",
      "Pawan BO": "171210",
      "Thangad BO": "171210",
      "Kaloti BO": "171207",
      "Poabo BO": "171006",
      "Jakha BO": "171221",
      "Panog BO": "171204",
      "Chalnair BO": "171202",
      "Darkoti BO": "171202",
      "Nagan BO": "171202",
      "Jokhar BO": "171217",
      "Bholad BO": "171216",
      "Jhagtan BO": "171216",
      "Durgapur BO": "171007",
      "Khatnol BO": "171007",
      "Jahu BO": "171213",
      "Madhawani BO": "171213",
      "Bour BO": "171210",
      "Eera BO": "171210",
      "Malat BO": "171210",
      "Ruslah BO": "171210",
      "Gawas BO": "171207",
      "Kansakoti BO": "171207",
      "Kui BO": "171207",
      "Seema BO": "171207",
      "Anandpur BO": "171219",
      "Kaithu BO": "171003",
      "Ratnari BO": "171225",
      "Bhujjal BO": "171226",
      "Kuthar BO": "171226",
      "Kariali BO": "171018",
      "Majhiwar BO": "171018",
      "Deothibalson BO": "171220",
      "Kiar BO": "171220",
      "Larot BO": "171208",
      "Tangnu BO": "171208",
      "Chauth BO": "171211",
      "Dhawas BO": "171211",
      "Nakorapul BO": "171211",
      "Darbhog BO": "171012",
      "Kufri BO": "171012",
      "Chalahal BO": "171103",
      "Sainj BO": "171220",
      "Thachi BO": "171103",
      "Majhar BO": "171209",
      "Dhadirawat BO": "171206",
      "Jharag BO": "171206",
      "Pandoa BO": "171019",
      "Devidhar BO": "171214",
      "Thana BO": "171214",
      "Deem BO": "171205",
      "Kayana BO": "171205",
      "Shailapani BO": "171205",
      "Deori Khaneti BO": "171204",
      "Himri BO": "171019",
      "Rawlakiar BO": "171202",
      "Tharola BO": "171202",
      "Baldeyan BO": "171007",
      "Dewla BO": "171007",
      "Bharana BO": "171212",
      "Kelvi BO": "171212",
      "Kotighat BO": "171212",
      "Nagjubber BO": "171212",
      "Halanidhar BO": "171213",
      "Kandyali BO": "171213",
      "Bharanu BO": "171210",
      "Bijmal BO": "171210",
      "Giahan BO": "171210",
      "Jublee BO": "171210",
      "Tharoach BO": "171210",
      "Tikkri Neol BO": "171210",
      "Telar BO": "171210",
      "Kuthara BO": "171207",
      "Lower Koti BO": "171207",
      "Pujarli No4 BO": "171207",
      "Samoli BO": "171207",
      "Kathog BO": "171222",
      "Lafughati BO": "171222",
      "Kamlanagar BO": "171006",
      "Malyana BO": "171006",
      "Dhari BO": "171219",
      "Salana BO": "171219",
      "Chaili BO": "171005",
      "Neripul BO": "171226",
      "Pulbahal BO": "171226",
      "Sari BO": "171226",
      "Chanair BO": "171220",
      "Dehabalson BO": "171220",
      "Mahori BO": "171220",
      "Parala BO": "171220",
      "Rohal BO": "171208",
      "Tikkari BO": "171208",
      "Khagna BO": "171211",
      "Marog BO": "171211",
      "Matal BO": "171211",
      "Pauria BO": "171211",
      "Sarain BO": "171211",
      "Mundghat BO": "171012",
      "Satlai BO": "171012",
      "Kalihatti BO": "171014",
      "Kohbag BO": "171014",
      "Okharoo BO": "171103",
      "Dhamandari BO": "171209",
      "Dharech BO": "171209",
      "Satog BO": "171209",
      "Tiyali BO": "171209",
      "Solang BO": "171206",
      "Dharogra BO": "171019",
      "Gadheri BO": "171019",
      "Dhar BO": "171205",
      "Praunthi BO": "171205",
      "Pujarli No2 BO": "171205",
      "Sheel BO": "171205",
      "Rajhana BO": "171009",
      "Bharari BO": "171003",
      "Nabha Estate BO": "171004",
      "Kalbog BO": "171225",
      "Khangteri BO": "171225",
      "Deothi Manjghaon BO": "171226",
      "Mundu BO": "171226",
      "Khera BO": "171018",
      "Dabri B.O.": "171018",
      "Ghoond BO": "171220",
      "Kalind BO": "171220",
      "Khashdhar BO": "171208",
      "Masli BO": "171208",
      "Dewat BO": "171211",
      "Jhiknipul BO": "171211",
      "Koti BO": "171012",
      "Maloothi BO": "171012",
      "Chanawag BO": "171103",
      "Toon BO": "171103",
      "Cheog BO": "171209",
      "Dhadighunsa BO": "171206",
      "Kathasu BO": "171206",
      "Ogli BO": "171019",
      "Ranol BO": "171214",
      "Dodra BO": "171221",
      "Bhont BO": "171003",
      "Khadrala BO": "171225",
      "Basadhar BO": "171226",
      "Dubloo BO": "173217",
      "Janedghat BO": "173217",
      "Bharara BO": "171018",
      "Kadarghat BO": "171018",
      "Bagri BO": "171220",
      "Balghar BO": "171220",
      "Chilala BO": "171208",
      "Gaonsari BO": "171208",
      "Kanthli BO": "171208",
      "Khabal BO": "171208",
      "Pekha BO": "171208",
      "Sindhasli BO": "171208",
      "Bamta BO": "171211",
      "Chambi BO": "171211",
      "Chharabra BO": "171012",
      "Jabri BO": "171103",
      "Anti BO": "171206",
      "Barthata BO": "171206",
      "Nandpur BO": "171206",
      "Pandranu BO": "171206",
      "Kangal BO": "171019",
      "Todsa BO": "171214",
      "Peeran BO": "173217",
      "Naula BO": "172001",
      "Duttnagar BO": "172001",
      "Sholi BO": "172001",
      "Thaili Chakti BO": "172001",
      "Shiwan BO": "172027",
      "Teshan BO": "172027",
      "Jaghori BO": "172101",
      "Kayab BO": "172101",
      "Labana BO": "172101",
      "Sugha BO": "172201",
      "Jais BO": "171201",
      "Kiartoonal BO": "171201",
      "Dharara BO": "171203",
      "Bychari BO": "171011",
      "Chanog BO": "171011",
      "Danawali BO": "172021",
      "Narain BO": "172022",
      "Barog BO": "171201",
      "Dharampur Madhan BO": "171201",
      "Kadiwan BO": "171203",
      "Samara BO": "171203",
      "Badehari BO": "171011",
      "Jubbarhatti BO": "171011",
      "Rewag BO": "171301",
      "Mandhor Ghat BO": "171301",
      "Sariun BO": "171201",
      "Sarog BO": "171201",
      "Sharontha BO": "171203",
      "Kanda BO": "171014",
      "Nehra BO": "171014",
      "Rampur Keonthal BO": "171011",
      "Rauri BO": "171011",
      "Shakarah BO": "171014",
      "Khamadi BO": "172001",
      "Dansa BO": "172001",
      "Barach BO": "172001",
      "Ganvi BO": "172101",
      "Koot BO": "172101",
      "Sarpara BO": "172201",
      "Chikul BO": "172024",
      "Galani BO": "172024",
      "Jar BO": "172029",
      "Sharambal Camp BO": "172029",
      "Munish Bhali BO": "172022",
      "Dofda BO": "172102",
      "Bhutti BO": "172030",
      "Kirti BO": "172030",
      "Surad BO": "172001",
      "Lailon BO": "172001",
      "Nirth BO": "172001",
      "Gaura BO": "172201",
      "Kartot BO": "172201",
      "Kotla BO": "172024",
      "Batari BO": "172031",
      "Jarol BO": "172031",
      "Bahli BO": "172022",
      "Darkali BO": "172022",
      "Dawara BO": "172022",
      "Kareri BO": "172022",
      "Chaba BO": "171301",
      "Juni BO": "171301",
      "Bhogra BO": "171201",
      "Chikar BO": "171222",
      "Ghasani BO": "171203",
      "Pujarli No3 BO": "171203",
      "Devnagar BO": "171014",
      "Jathia Devi BO": "171011",
      "Panesh BO": "171014",
      "Beolia BO": "171013",
      "Kungal Balti BO": "172001",
      "Shingla BO": "172001",
      "Khaneri BO": "172001",
      "Phancha BO": "172101",
      "Bhareri BO": "172024",
      "Janjheli BO": "172024",
      "Pharal BO": "172029",
      "Bharawali BO": "172022",
      "Deothi BO": "172022",
      "Kashapat BO": "172022",
      "Taklech BO": "172022",
      "Kinnu BO": "172102",
      "Majauli BO": "172102",
      "Shamathla BO": "172030",
      "Mashnoo BO": "172102",
      "Shahdhar BO": "172102",
      "Virgarh BO": "172030",
      "Rampur Bushahr HO": "172001",
      "Shimla GPO": "171001",
      "Baldeyan SO": "171015",
      "Distt Court Chakkar SO": "171005",
      "Ghanahatti SO": "171014",
      "Baragaon SO Shimla": "172027",
      "Delath SO": "172028",
      "Jeori SO": "172101",
      "Thanedhar SO": "172030",
      "AGPO SO": "171003",
      "Balag SO": "171226",
      "Fagu SO Shimla": "171209",
      "Jangla SO": "171214",
      "Jutogh SO": "171008",
      "Kiari SO": "171204",
      "Shoghi SO": "171219",
      "Summerhill SO": "171005",
      "Bagain SO": "171220",
      "Ambedkarchowk SO": "171004",
      "Chirgaon SO Shimla": "171208",
      "Jubbal SO": "171205",
      "Kawar SO": "171221",
      "Mandhole SO": "171215",
      "Mashobra SO": "171007",
      "Nerwa SO": "171210",
      "New Shimla SO": "171009",
      "Sanjauli SO": "171006",
      "Shimla High Court SO": "171001",
      "Baghi SO Shimla": "171225",
      "Basanatpur SO": "171018",
      "Busstand SO": "171001",
      "Chopal SO": "171211",
      "Combermere SO": "171001",
      "CPRI SO": "171001",
      "Hatkoti SO": "171206",
      "HPSectt SO": "171002",
      "Jalog SO": "171019",
      "Kotkhai SO": "171202",
      "Jhakri SO": "172201",
      "Kingal SO": "172024",
      "Kumarsain SO": "172029",
      "Nogli SO": "172022",
      "Sarahan BSR SO": "172102",
      "Bonda SO": "172034",
      "Kotgarh SO": "172031",
      "Nankhari SO": "172021",
      "Padam Nagar SO Shimla": "172001",
      "Kupvi SO": "171217",
      "Mandal SO Shimla": "171216",
      "Narkanda SO": "171213",
      "Sandhu SO": "171222",
      "Shimla East SO": "171002",
      "Summer Kot SO": "171224",
      "Tikkar SO": "171203",
      "Totu SO": "171011",
      "Mehli SO": "171013",
      "Arhal SO": "171223",
      "Dhalli SO": "171012",
      "Dhami SO": "171103",
      "IGMC SO": "171001",
      "Junga SO": "171218",
      "Kasumpti SO": "171009",
      "Khalini SO": "171002",
      "Matiana SO": "171212",
      "Rohru SO": "171207",
      "Sunni Bhajji SO": "171301",
      "Tara Devi SO": "171010",
      "Theog SO": "171201"
    },
    "SIRMAUR": {
      "Chhogtali BO": "173101",
      "Sanio Didag BO": "173101",
      "Shaya Chabron BO": "173101",
      "BaragBO": "173023",
      "Rajana BO": "173023",
      "Sainj BO": "173023",
      "Seon BO": "173023",
      "Mangarh BO": "173024",
      "Sarsoo BO": "173024",
      "Thakurdwara BO": "173024",
      "Wasni BO": "173024",
      "Jaman Ki Ser": "173024",
      "Harlog BO": "173029",
      "Kamrau BO": "173029",
      "Millah BO": "173029",
      "Hallan BO": "173027",
      "Jhakando BO": "173027",
      "Nainidhar BO": "173027",
      "Girinagar BO": "173031",
      "Korag BO": "173032",
      "Leonana BO": "173223",
      "Bharoli BO": "171226",
      "Habban BO": "173101",
      "Kathali Bharan BO": "173101",
      "Pabiana BO": "173101",
      "Rerughatti BO": "173101",
      "Redali BO": "173023",
      "Sharia BO": "173024",
      "Tikkari Kuthar BO": "173024",
      "Kantimashwa BO": "173029",
      "Kiari Gundah BO": "173029",
      "Korga BO": "173029",
      "Sharlimanpur BO": "173029",
      "Shawaga BO": "173029",
      "Shilla BO": "173029",
      "Tatiana BO": "173029",
      "Timbi BO": "173029",
      "BaliKoti  BO": "173027",
      "Bella BO": "173027",
      "Gawali BO": "173027",
      "Shirikiari BO": "173027",
      "Charna BO": "173032",
      "Bhalona BO": "173032",
      "Gorkhuwala BO": "173025",
      "Khodri BO": "173025",
      "Manpur Devra BO": "173025",
      "Nagheta BO": "173025",
      "Rajpur BO": "173025",
      "Shiva BO": "173025",
      "Shivpur BO": "173032",
      "Naina Tikkar BO": "173229",
      "Panwa BO": "173229",
      "Sanora BO": "173223",
      "Ganguwala Jamniwala BO": "173025",
      "Nihalgarh BO": "173025",
      "Bhuira BO": "173101",
      "Churwadhar BO": "173101",
      "Dimber BO": "173101",
      "Ser Jegas BO": "173101",
      "Thorniwar BO": "173101",
      "Andheri BO": "173023",
      "Lanapalar BO": "173023",
      "Bagpashog BO": "173024",
      "Bhellon BO": "173024",
      "Janot BO": "173024",
      "Malhoti BO": "173024",
      "Narag BO": "173024",
      "Jamna BO": "173029",
      "Koti Utraon BO": "173029",
      "Poka BO": "173029",
      "Rajban BO": "173029",
      "Jarwa BO": "173027",
      "Kando Bhatnaul BO": "173027",
      "Kharkah BO": "173027",
      "Manal BO": "173027",
      "Panog BO": "173027",
      "Baru Sahib BO": "173101",
      "Chhapang BO": "173101",
      "Dahan BO": "173101",
      "Bhajond BO": "173023",
      "Banahki Ser BO": "173024",
      "Daro Devria BO": "173024",
      "Dhangiar BO": "173024",
      "Jehar BO": "173024",
      "Mehandobag BO": "173024",
      "Bakras BO": "173029",
      "Chhachheti BO": "173029",
      "Dugana BO": "173029",
      "Kotibhunch BO": "173027",
      "Loza BO": "173027",
      "Ronhat BO": "173027",
      "Badol BO": "173032",
      "Sangana BO": "173032",
      "Bhawai BO": "173032",
      "Drabla BO": "173223",
      "Jadol Taproli BO": "173223",
      "Kotla Bangi BO": "173223",
      "Kujji BO": "173229",
      "Karganoo Sanora BO": "173223",
      "Kotla Panjola BO": "173223",
      "Banethi BO": "173001",
      "Bikram Bag BO": "173001",
      "Ramadhaun BO": "173001",
      "Kotla Molar BO": "173001",
      "Chakli BO": "173001",
      "Jamta BO": "173001",
      "Dingar Kinner BO": "173001",
      "Dhagera": "173001",
      "Bharog Baneri BO": "173022",
      "Birla BO": "173022",
      "Jamu BO": "173022",
      "Kangta Failag BO": "173022",
      "Thana Kashoga BO": "173022",
      "Bramapapri BO": "173030",
      "Chokar BO": "173104",
      "Devamanal BO": "173104",
      "Devna BO": "173104",
      "Gandhoori BO": "173104",
      "Banaur BO": "173025",
      "Bata Mandi BO": "173025",
      "Matar BO": "173001",
      "Surla BO": "173001",
      "Puruwala BO": "173001",
      "Shambhuwala BO": "173001",
      "Haripur Khol BO": "173001",
      "Bhatgarh BO": "173022",
      "Jarag BO": "173022",
      "Kansar BO": "173022",
      "Moginand BO": "173030",
      "Sainwala BO": "173030",
      "Kotribyas BO": "173021",
      "Kuffar Kiara BO": "173104",
      "Bhagani BO": "173025",
      "Danda Anj BO": "173025",
      "Shergaon BO": "173223",
      "Bagthan BO": "173001",
      "Gagal Shikor BO": "173001",
      "Parara BO": "173001",
      "Mahipur BO": "173001",
      "Panar BO": "173022",
      "Trilokpur BO": "173030",
      "Misserwala BO": "173021",
      "Sainwala Mubarakpur BO": "173021",
      "Punner BO": "173104",
      "Sertandula BO": "173104",
      "Chalana BO": "173001",
      "Panjahal BO": "173001",
      "Kolar BO": "173001",
      "Kotidhiman BO": "173022",
      "Udaina Kathwar BO": "173022",
      "Palion BO": "173030",
      "Bogdhar BO": "173104",
      "Lanacheta BO": "173104",
      "Bhudhana BO": "173025",
      "Nahan HO": "173001",
      "Sataun SO": "173029",
      "Court Road Nahan SO": "173001",
      "Dadahu SO": "173022",
      "Nohra SO": "173104",
      "Paonta Sahib SO": "173025",
      "Rajgarh Siramur SO": "173101",
      "Sarahan SO": "173024",
      "Dhualakuan": "173031",
      "Sangrah SO": "173023",
      "Shillai SO": "173027",
      "Haripurdhar": "173032",
      "Kala Amb SO": "173030",
      "Katcha Tank Nahan SO": "173001",
      "Kw Bhood SO": "173026",
      "Majra SO Sirmaur": "173021"
    },
    "SOLAN": {
      "Damkari BO": "173212",
      "Manjhyat BO": "173208",
      "Sujhaila BO": "173208",
      "Haripur Sandoli BO": "173205",
      "Sai BO": "173205",
      "Dangheel BO": "173217",
      "Nagali BO": "173217",
      "Tikker BO": "173217",
      "Beral BO": "171102",
      "Mangal BO": "171102",
      "Nagaon BO": "171102",
      "Dhar Ki Ber BO": "173209",
      "Bhumati BO": "173221",
      "Jobri BO": "173221",
      "Kot BO": "173225",
      "Gaighat BO": "173229",
      "Kabakalan BO": "173229",
      "Jubla BO": "173207",
      "Khararhatti BO": "173207",
      "Baruna BO": "174101",
      "Dabhota BO": "174101",
      "Goela Panner BO": "174101",
      "Khillian BO": "174101",
      "Lodhimajra BO": "174101",
      "Manpura BO": "174101",
      "Reru BO": "174101",
      "Kotla BO": "173212",
      "Hinner BO": "173217",
      "Mangoo BO": "171102",
      "Parnoo BO": "171102",
      "Mandodhar BO": "173209",
      "Rouri BO": "173209",
      "Saryanj BO": "173235",
      "Hanuman Barog BO": "173235",
      "Bhararighat BO": "173235",
      "Badhokhari BO": "173218",
      "Katal BO": "173218",
      "Maan BO": "173218",
      "Manlogkalan BO": "173218",
      "Balera BO": "173221",
      "Jagjit Nagar BO": "173225",
      "Kasauli MT BO": "173204",
      "Bhojnagar BO": "173229",
      "Koti BO": "173207",
      "Sayri BO": "173207",
      "Shardaghat BO": "173207",
      "Jhajra BO": "174101",
      "Joghon BO": "174101",
      "Kalibari BO": "174101",
      "Galanag BO": "173212",
      "Shamti BO": "173212",
      "Batal BO": "173208",
      "Palania BO": "173208",
      "Karuana BO": "173205",
      "Thana BO": "173205",
      "Jhaja BO": "173217",
      "Dharot BO": "173213",
      "Gaura BO": "173212",
      "Jaunaji BO": "173212",
      "Bakhalag BO": "173208",
      "Manjoo BO": "173208",
      "Palog BO": "173208",
      "Shalaghat BO": "173208",
      "Bhatoli Kalan BO": "173205",
      "Bhood BO": "173205",
      "Mandhala BO": "174103",
      "Surajpur BO": "174103",
      "Basal BO": "173213",
      "Chakhar Bughar BO": "171102",
      "Danoghat BO": "171102",
      "Ganagughat BO": "171102",
      "Sewra Chandi BO": "171102",
      "Jabli BO": "173209",
      "Kanda BO": "173209",
      "Materani BO": "173221",
      "Shehrol BO": "173221",
      "Kawarag BO": "173215",
      "Kasauli RI BO": "173204",
      "Sultanpur BO": "173229",
      "Bhainch Kuftoo BO": "173207",
      "Brauri BO": "173207",
      "DheolaBO": "173207",
      "Bhatian BO": "174101",
      "Bhogpur BO": "174101",
      "Nangal BO": "174101",
      "Panjhera BO": "174101",
      "Plassaikalan BO": "174101",
      "Rajpura BO": "174101",
      "Kashlog BO": "171102",
      "Piplughat BO": "173235",
      "Badhalag BO": "173218",
      "Jainagar BO": "173221",
      "Kunhar BO": "173221",
      "Sadhupul BO": "173215",
      "Tundal BO": "173215",
      "Bohli BO": "173229",
      "Kahala BO": "173207",
      "Galote BO": "174101",
      "Gurumajra BO": "174101",
      "Khera BO": "174101",
      "Kundlu BO": "174101",
      "Manjholi BO": "174101",
      "Ratwari BO": "174101",
      "Bagheri": "174101",
      "Ekhoo BO": "173233",
      "Salogra BO": "173214",
      "Baddal Goela BO": "173206",
      "Bharti BO": "173206",
      "Kakkar Hatti BO": "173206",
      "Malera BO": "173206",
      "Domeharbani BO": "173234",
      "Bisha BO": "173234",
      "Taksal BO": "173220",
      "Kot Beja BO": "173233",
      "Gunahkalan BO": "174102",
      "Lagdaghat BO": "174102",
      "Saur BO": "174102",
      "Darwa BO": "173206",
      "Basha BO": "173234",
      "Anji Brahamna BO": "173234",
      "Nayagram BO": "173220",
      "Badhaunighat BO": "173233",
      "Bandh Bhaguri BO": "173233",
      "Bhiyunkhari BO": "174102",
      "Chamdar BO": "174102",
      "Chhiachi BO": "174102",
      "Dharmana BO": "174102",
      "Loharghat BO": "174102",
      "Lunas BO": "174102",
      "Matuli BO": "174102",
      "Mittian BO": "174102",
      "Nand Karlata BO": "174102",
      "Barog RSBO": "173211",
      "Deothi BO": "173211",
      "Ghatti BO": "173211",
      "Chandi BO": "173206",
      "Dhakriana BO": "173206",
      "Gharsi BO": "173206",
      "Haripur BO": "173206",
      "Kaithlighat BO": "173234",
      "Chhausa BO": "173234",
      "Masulkhana BO": "173220",
      "Pratha BO": "173220",
      "Baila BO": "174102",
      "Doli BO": "174102",
      "Kohu BO": "174102",
      "Pole Da Khala BO": "174102",
      "Delgi BO": "173206",
      "Rampur BO": "173206",
      "Kiarighat BO": "173234",
      "Solan HO": "173212",
      "Nalagarh SO": "174101",
      "Nauni SO": "173230",
      "RR Solan SO": "173212",
      "Saproon SO": "173211",
      "Kasauli SO": "173204",
      "Kunihar SO": "173207",
      "Mamlig SO": "173222",
      "Patta SO": "173233",
      "Sector2 Parwanoo SO": "173220",
      "Waknaghat SO": "173234",
      "Oachghat SO": "173223",
      "Sanawar SO": "173202",
      "Solan Brewery SO": "173214",
      "Subathu SO": "173206",
      "Kuthar SO": "173236",
      "Kumarhatti SO": "173229",
      "Parwanoo SO": "173220",
      "Ramshahar SO": "174102",
      "Arki SO": "173208",
      "Dagshai SO": "173210",
      "Domehar SO": "173221",
      "Baddi SO": "173205",
      "Chail SO Solan": "173217",
      "Dharampur SO Solan": "173209",
      "Dhundan SO": "173235",
      "Garkhal SO": "173201",
      "Kandaghat SO": "173215",
      "Barotiwala SO": "174103",
      "Chambaghat SO": "173213",
      "Darla SO": "171102",
      "Diggal SO": "173218",
      "Jubbar SO": "173225"
    },
    "KINNAUR": {
      "Urni BO": "172104",
      "Ramni BO": "172104",
      "Wangtoo BO": "172104",
      "Yulla BO": "172104",
      "Chota Khamba BO": "172101",
      "Purbani BO": "172107",
      "Barang BO": "172107",
      "Kothi BO": "172107",
      "Khawangi BO": "172107",
      "Sapni BO": "172105",
      "Shong BO": "172105",
      "Chango BO": "172111",
      "Namgia BO": "172111",
      "Akpa BO": "172116",
      "Rarang BO": "172116",
      "Kamroo BO": "172106",
      "Rakchham BO": "172106",
      "Chagaon BO": "172104",
      "Mirro BO": "172104",
      "Chaura BO": "172101",
      "Nigulsari BO": "172101",
      "Taranda BO": "172101",
      "Powari BO": "172107",
      "Pangi BO": "172107",
      "Roghi BO": "172108",
      "Brua BO": "172105",
      "Kilba BO": "172105",
      "Bhaba BO": "172118",
      "Hango BO": "172112",
      "Jangi BO": "172109",
      "Dubling BO": "172111",
      "Nako BO": "172111",
      "Rispa BO": "172116",
      "Batseri BO": "172106",
      "Labrang BO": "172110",
      "Shiaso BO": "172110",
      "Panvi BO": "172104",
      "Nathpa BO": "172115",
      "Ponda Solding BO": "172115",
      "Sungra BO": "172115",
      "Asrang BO": "172109",
      "Kunnu BO": "172109",
      "Rupi BO": "172101",
      "Meber BO": "172107",
      "Bari BO": "172115",
      "Duni BO": "172108",
      "Charang BO": "172109",
      "Lippa BO": "172109",
      "Sumra BO": "172111",
      "Chansu BO": "172106",
      "Nesang BO": "172110",
      "Ropa BO": "172110",
      "Thangi BO": "172109",
      "Pooh Gaon BO": "172111",
      "Shalkhar BO": "172111",
      "Chitkul BO": "172106",
      "Giabong BO": "172110",
      "Kanam BO": "172110",
      "Sunnam BO": "172110",
      "Reckong Peo HO": "172107",
      "Karcham SO": "172105",
      "Liyo SO": "172112",
      "Speelo SO": "172110",
      "Tapri SO": "172104",
      "Kalpa SO": "172108",
      "Katgaon SO": "172118",
      "Moorang SO": "172109",
      "Pooh SO": "172111",
      "Ribba SO": "172116",
      "Sangla SO": "172106",
      "Nichar SO": "172103",
      "Bhaba Nagar SO": "172115"
    },
    "CHAMBA": {
      "Kupara BO": "176314",
      "Mangla BO": "176314",
      "Udaipur BO": "176314",
      "Singi BO": "176314",
      "Basodhan BO": "176314",
      "Paliur BO": "176314",
      "Sarahan BO": "176314",
      "Kohlari BO": "176314",
      "Athedgwalu BO": "176312",
      "Bhajotra BO": "176312",
      "Moda BO": "176312",
      "Baat BO": "176314",
      "Judera BO": "176314",
      "Kirri BO": "176314",
      "Rathiar BO": "176314",
      "Sillagharat BO": "176314",
      "Bhanota Salga BO": "176314",
      "Badka BO": "176312",
      "Chandilarog BO": "176312",
      "Pantah BO": "176312",
      "Barour BO": "176314",
      "Khajjiar BO": "176314",
      "Palwin BO": "176314",
      "Sach BO": "176323",
      "Sahu BO": "176314",
      "Dighai BO": "176312",
      "Drekari BO": "176312",
      "Koti Prahanuie BO": "176312",
      "Ligga BO": "176312",
      "Manjeer BO": "176312",
      "Salwan BO": "176312",
      "Seri Andral BO": "176312",
      "Killod BO": "176311",
      "Kuned BO": "176311",
      "Pareena BO": "176311",
      "Rari BO": "176311",
      "Samra BO": "176311",
      "Tikrigargh BO": "176321",
      "Charori BO": "176319",
      "Dugli BO": "176319",
      "Jhullara BO": "176319",
      "Kalhel BO": "176319",
      "Bhandal BO": "176320",
      "Dhullara BO": "176207",
      "Garnota BO": "176207",
      "Patka BO": "176207",
      "Rajain BO": "176207",
      "Samote BO": "176207",
      "Kail BO": "176301",
      "Tunuhatti BO": "176301",
      "Simni BO": "176308",
      "Wangal BO": "176308",
      "Ail BO": "176316",
      "Bairagarh BO": "176316",
      "Bhodas Mangli BO": "176316",
      "Jungra BO": "176316",
      "Ghared BO": "176315",
      "Hadsar BO": "176315",
      "Jatroon BO": "176302",
      "Bharari BO": "176301",
      "Deol BO": "176309",
      "Gareema BO": "176309",
      "Ulansa BO": "176309",
      "Chakloo BO": "176318",
      "Rajnagar BO": "176318",
      "Rajera BO": "176318",
      "Rajpura BO": "176318",
      "Kiani BO": "176318",
      "Bistholuj BO": "176323",
      "Dharwas BO": "176323",
      "Sunara BO": "176311",
      "Charda BO": "176321",
      "Deola BO": "176321",
      "Jassourgarh BO": "176321",
      "Kandhwara BO": "176321",
      "Leswin BO": "176321",
      "Thalli BO": "176321",
      "Kandla BO": "176319",
      "Masroond BO": "176319",
      "Kihar BO": "176320",
      "Baggi Kanged BO": "176325",
      "Bilana BO": "176207",
      "Kakroti BO": "176207",
      "Tikri BO": "176207",
      "Tundi BO": "176207",
      "Rakh BO": "176311",
      "Banatar BO": "176321",
      "Bhagaigarh BO": "176321",
      "Bharella BO": "176321",
      "Chanju BO": "176321",
      "Diur BO": "176320",
      "Killor BO": "176320",
      "Singadhar BO": "176320",
      "Tikru BO": "176320",
      "Bhunad BO": "176325",
      "Gola BO": "176207",
      "Naloh BO": "176207",
      "Balera BO": "176301",
      "Sudli BO": "176303",
      "Tritha BO": "176303",
      "Ghulei BO": "176316",
      "Jhajjakothi BO": "176316",
      "Seikothi BO": "176316",
      "Thaneikothi BO": "176316",
      "Tissa BO": "176316",
      "Pranghala BO": "176315",
      "Ghatasnipul BO": "176302",
      "Jandrog BO": "176302",
      "Khani BO": "176309",
      "Chhatrari BO": "176324",
      "Durgathi BO": "176324",
      "Koonr BO": "176324",
      "Ohraphati BO": "176324",
      "Urai BO": "176324",
      "Sirhkund BO": "176318",
      "Dehra BO": "176321",
      "Himgiri BO": "176321",
      "Lahra BO": "176321",
      "Kohal BO": "176319",
      "Sandhi BO": "176319",
      "Dand BO": "176320",
      "Kharoti BO": "176320",
      "Sanghani BO": "176320",
      "Dharun Banet BO": "176207",
      "Jolna BO": "176207",
      "Kathla BO": "176207",
      "Khargata BO": "176207",
      "Morthu BO": "176207",
      "Awan BO": "176313",
      "Hobar BO": "176313",
      "Kuddi BO": "176313",
      "Kothi BO": "176323",
      "Kumar BO": "176323",
      "Mindhal BO": "176323",
      "Purthi BO": "176323",
      "Shunudeen BO": "176323",
      "Bakani BO": "176311",
      "Bandla BO": "176311",
      "Nainikhad BO": "176301",
      "Garh BO": "176303",
      "Dradha BO": "176306",
      "Sherpur BO": "176306",
      "Matti BO": "176308",
      "Dehgram BO": "176316",
      "Ganed BO": "176316",
      "Sanwal BO": "176316",
      "Tarella BO": "176316",
      "Kugati BO": "176315",
      "Seri BO": "176315",
      "Banet BO": "176302",
      "Manhouta BO": "176302",
      "Raipur BO": "176302",
      "Bajoul BO": "176326",
      "Kuleth BO": "176326",
      "Nayagram BO": "176326",
      "Badgram BO": "176324",
      "Runukothi BO": "176324",
      "Bhadian BO": "176318",
      "Sarol BO": "176318",
      "Karian B.O": "176318",
      "Karyas BO": "176323",
      "Rai BO": "176323",
      "Sechunala BO": "176323",
      "Taisural BO": "176323",
      "Churi BO": "176311",
      "Janghi BO": "176311",
      "Ghatasni BO": "176301",
      "Mail BO": "176301",
      "Bagdhar BO": "176303",
      "Bailly BO": "176303",
      "Goli BO": "176306",
      "Ohra BO": "176308",
      "Bonderi BO": "176316",
      "Devikothi BO": "176316",
      "Khushnagari BO": "176316",
      "Sirdi BO": "176315",
      "Gahar BO": "176302",
      "Malunda BO": "176302",
      "Parchhore BO": "176302",
      "Rupaina BO": "176302",
      "Sahala BO": "176302",
      "Taragarh BO": "176302",
      "Chanhouta BO": "176309",
      "Lamu BO": "176326",
      "Siura BO": "176309",
      "Brehi BO": "176324",
      "Piura BO": "176324",
      "Tundah BO": "176324",
      "Luddu BO": "176318",
      "Uteep BO": "176318",
      "Karel Punto BO": "176323",
      "Sahli BO": "176323",
      "Darwin BO": "176311",
      "Khundail BO": "176311",
      "Chamba HO": "176310",
      "Banikhet SO": "176303",
      "Garola SO": "176309",
      "Hardaspura SO": "176318",
      "Nakror SO": "176321",
      "Samleu SO": "176325",
      "Sihunta SO": "176207",
      "Sundla SO": "176312",
      "BATHRI BAZAR SO": "176306",
      "Dalhousie SO": "176304",
      "Kakira SO": "176313",
      "Salooni SO": "176320",
      "Bakloh SO": "176301",
      "BHALEI SO": "176308",
      "Bharmour SO": "176315",
      "Dalhousie cantt": "176305",
      "Dalhousie Court Road": "176304",
      "Gehra SO": "176324",
      "Killar Pangi SO": "176323",
      "Mehla SO": "176311",
      "Sultanpur SO": "176314",
      "Surangani SO": "176317",
      "Bhanjraru Tissa": "176316",
      "Chowari SO": "176302",
      "Pukhri SO": "176319",
      "Rangmehal SO": "176310",
      "Holi SO": "176326"
    }
  },
  "HARYANA": {
    "JIND": {
      "Baniya Khera B.O": "126110",
      "Lajwan Kalan B.O": "126101",
      "Malwi B.O": "126101",
      "Mandi Kalan B.O": "126125",
      "Sandil B.O": "126125",
      "Shahpur B.O": "126125",
      "Dumarkhan Kalan B.O": "126116",
      "Garhi B.O": "126116",
      "Hamir Garh B.O": "126116",
      "Dalamwala B.O": "126110",
      "Khunga Kothi B.O": "126110",
      "Budda Khera Lather B.O": "126101",
      "Deorer B.O": "126101",
      "Fateh Garh B.O": "126101",
      "Nandgarh B.O": "126101",
      "Pauli B.O": "126101",
      "Badhana B.O": "126125",
      "Kuchrana Kalan B.O": "126125",
      "Lodhar B.O": "126125",
      "Belarkhan B.O": "126116",
      "Bhana Brahmana B.O": "126116",
      "Dablain Kalan B.O": "126116",
      "Dhabitek Singh B.O": "126116",
      "Karamgarh B.O": "126116",
      "Khrindwal B.O": "126116",
      "Lowan B.O": "126116",
      "Pharain Kalan B.O": "126116",
      "Ritauli B.O": "126110",
      "Hathwala B.O": "126101",
      "Kerela B.O": "126101",
      "Mehrara B.O": "126101",
      "Chhatar B.O": "126125",
      "Kendela B.O": "126125",
      "Dhamtan Sahib B.O": "126116",
      "Dharodi B.O": "126116",
      "Kalwan B.O": "126116",
      "Kharal B.O": "126116",
      "Phullian Kalan B.O": "126116",
      "Mohammad Khera B.O": "126110",
      "Karsaula B.O": "126101",
      "Kila Zaffargarh B.O": "126101",
      "Chuharpur B.O": "126125",
      "Dehola B.O": "126125",
      "Thua B.O": "126125",
      "Amargarh B.O": "126116",
      "Dhakal B.O": "126116",
      "Dhanori B.O": "126116",
      "Ghason Kalan B.O": "126116",
      "Jheel B.O": "126116",
      "Pipaltha B.O": "126116",
      "Rasidan B.O": "126116",
      "Sudkain Khurd B.O": "126116",
      "Ujhana B.O": "126116",
      "Singhwal B.O": "126116",
      "Sinsar B.O": "126116",
      "Sulhera B.O": "126116",
      "Ludana B.O": "126113",
      "Morkhi B.O": "126113",
      "Siwaha B.O": "126113",
      "Karsindu B.O": "126112",
      "Rajgarh Gurthali B.O": "126116",
      "Budha Khera B.O": "126113",
      "Malikpur B.O": "126112",
      "Mowana B.O": "126112",
      "Paju Kalan B.O": "126112",
      "Baroli B.O": "126114",
      "Bishanpura B.O": "126114",
      "Gogrian B.O": "126115",
      "Kakrod B.O": "126115",
      "Karsindhu B.O": "126115",
      "Mangalpur B.O": "126152",
      "Sachha Khera B.O": "126152",
      "Sainthali B.O": "126152",
      "Hadwa B.O": "126113",
      "Kalwa B.O": "126113",
      "Anchra Kalan B.O": "126112",
      "Bhuslana Kalan B.O": "126112",
      "Didwara B.O": "126112",
      "Rojhla B.O": "126112",
      "Butani B.O": "126112",
      "Dhigana B.O": "126114",
      "Gatauli B.O": "126114",
      "Kinana B.O": "126114",
      "Baroda B.O": "126115",
      "Bhongra B.O": "126115",
      "Sudkain Kalan B.O": "126115",
      "Bikhiwala B.O": "126152",
      "Jajanwala B.O": "126152",
      "Gangoli B.O": "126113",
      "Jamni B.O": "126113",
      "DHARAULI": "126113",
      "Bagru Kalan B.O": "126112",
      "Dharamgarh B.O": "126112",
      "Nimnabad B.O": "126112",
      "Silakheri B.O": "126112",
      "Malar B.O": "126112",
      "Buana B.O": "126114",
      "Garhwali B.O": "126114",
      "Barsola B.O": "126115",
      "Budain B.O": "126115",
      "Kabarchha B.O": "126115",
      "Kasun B.O": "126115",
      "Mohangarh B.O": "126115",
      "Uchana Khrud B.O": "126115",
      "Badanpur B.O": "126152",
      "Durjanpur B.O": "126152",
      "Assan B.O": "126113",
      "Bambhewa B.O": "126113",
      "Barthana B.O": "126113",
      "Hatt B.O": "126112",
      "Karkhana B.O": "126112",
      "Kheri Khermawati B.O": "126112",
      "Ram Nagar B.O": "126112",
      "Rohar B.O": "126112",
      "Singhana B.O": "126112",
      "Siwan Mal B.O": "126112",
      "Nidana B.O": "126114",
      "Kharakbhura B.O": "126115",
      "Khatkar B.O": "126115",
      "Makhand B.O": "126115",
      "Ram Rai B.O": "126102",
      "Nirjan B.O": "126102",
      "Durana B.O": "126111",
      "Roop Garh B.O": "126102",
      "Igrah B.O": "126102",
      "Jhanjkalan B.O": "126102",
      "Bibipur B.O": "126102",
      "Manohar Pur B.O": "126102",
      "Julani B.O": "126102",
      "Ahirka B.O": "126102",
      "Jajwan B.O": "126102",
      "Radhana B.O": "126102",
      "Nidani B.O": "126102",
      "Intal Kalan B.O": "126102",
      "Pegan B.O": "126111",
      "Dariyawala B.O": "126102",
      "Pindara B.O": "126102",
      "Sindhwi Kheri B.O": "126102",
      "Gulkani B.O": "126102",
      "Kharakramji B.O": "126102",
      "Ikkas B.O": "126102",
      "Bighana B.O": "126111",
      "Khanda B.O": "126111",
      "Dhilluwal B.O": "126111",
      "Jind H.O": "126102",
      "Dharthrath S.O": "126110",
      "Jind Mini Sectt. S.O": "126102",
      "Jind Rohtak Road S.O": "126102",
      "Julana S.O": "126101",
      "Narwana S.O": "126116",
      "Pillukhera S.O": "126113",
      "Shamlo Kalan S.O": "126114",
      "Uchana S.O": "126115",
      "Alewa S.O": "126111",
      "Jind Palika Bazar S.O": "126102",
      "Narwana City S.O": "126116",
      "Safidon S.O": "126112",
      "Jind Railway Station S.O": "126102",
      "Naguran S.O": "126125",
      "Safidon City S.O": "126112",
      "Jind Patiala Chowk S.O": "126102",
      "Jind Punjabi Bazar S.O": "126102",
      "Dhanoda Kalan S.O": "126152"
    },
    "PALWAL": {
      "DUDHOLA BO": "121102",
      "Asaoti BO": "121102",
      "Baghola BO": "121102",
      "Baroli BO": "121102",
      "Chant BO": "121102",
      "Ghori BO": "121102",
      "Jaindapur BO": "121102",
      "Siaroli BO": "121102",
      "Sondh BO": "121106",
      "Alawalpur BO": "121102",
      "Amroli BO": "121102",
      "Janauli BO": "121102",
      "Seeha BO": "121105",
      "Sihol BO": "121102",
      "Phulwari BO": "121102",
      "Alika BO": "121102",
      "Asaota BO": "121102",
      "Chhajju Nagar BO": "121102",
      "Prithla BO": "121102",
      "Rasulpur BO": "121102",
      "Teekri Brahman BO": "121102",
      "Aharwan BO": "121102",
      "Chirwari BO": "121102",
      "Dhatir BO": "121102",
      "Gadpuri BO": "121004",
      "Banswa BO": "121107",
      "Uttawar BO": "121103",
      "Lohina BO": "121106",
      "Pingore BO": "121105",
      "Seoli BO": "121105",
      "Bhandoli BO": "121107",
      "Bhiduki BO": "121107",
      "Tappa Bilochpur BO": "121107",
      "Chhainsa BO": "121103",
      "Gehlab BO": "121103",
      "Gharrot BO": "121103",
      "Hurithal BO": "121103",
      "Khaika BO": "121106",
      "Khambi BO": "121106",
      "Bamni Khera BO": "121105",
      "Khatela Sarai BO": "121105",
      "Nangal Jat BO": "121105",
      "Amarpur BO": "121004",
      "Likhi BO": "121107",
      "Kondal BO": "121103",
      "Madnaka BO": "121103",
      "Mandkola BO": "121103",
      "Rupraka BO": "121103",
      "Ali Meo BO": "121106",
      "Gorota BO": "121106",
      "Marraoli BO": "121106",
      "Bahin BO": "121105",
      "Dighot BO": "121105",
      "Manpur BO": "121105",
      "Gulawad BO": "121107",
      "Kot BO": "121103",
      "Malai BO": "121103",
      "Andhop BO": "121106",
      "Banchari BO": "121106",
      "Hathin SO": "121103",
      "Hodal SO": "121106",
      "Jawahar Nagar Palwal SO": "121102",
      "Palwal SO": "121102",
      "Aurangabad SO Faridabad": "121105",
      "Hassanpur SO": "121107",
      "New Township Palwal SO": "121102"
    },
    "PANCHKULA": {
      "Tikkar B.O": "134205",
      "Toda B.O": "134201",
      "Bhojkoti B.O": "134205",
      "Kharanwali B.O": "133302",
      "Mandhana B.O": "134205",
      "Thendog B.O": "134205",
      "Bhareli B.O": "134118",
      "Mauli B.O": "134118",
      "Ramgarh B.O": "134118",
      "Billa B.O": "134118",
      "Jaloli B.O": "134118",
      "Khatauli B.O": "134118",
      "Kot B.O": "134118",
      "Rattewali B.O": "134118",
      "Devi Nagar B.O": "134109",
      "Manak  Tabra B.O": "134204",
      "Railly B.O": "134109",
      "Basolan B.O": "134102",
      "Khetpurali B.O": "134204",
      "Suketri B.O": "134109",
      "Chiken B.O": "134102",
      "Damaloan B.O": "134102",
      "Mallah B.O": "134102",
      "Nanakpur B.O": "134102",
      "Garhi Kotaha B.O": "134204",
      "Hangola B.O": "134204",
      "Haripur B.O": "134204",
      "Kandiwala B.O": "134204",
      "B.C.W. Suraj Pur S.O": "133301",
      "G.K. Panchkula S.O": "134108",
      "H.M.T.Pinjore S.O": "134101",
      "Pinjore S.O": "134102",
      "Sector 26 Panchkula S.O": "134116",
      "Chandi Mandir Cantt S.O": "134107",
      "Chandi Mandir S.O": "134107",
      "I.T.B.P.  Bhanu S.O": "134103",
      "Industrial Estate  Panchkula S.O": "134113",
      "Kalka R.S. S.O": "133302",
      "Morni S.O": "134205",
      "Panchkula Sector 8 S.O": "134109",
      "Raipur Rani S.O": "134204",
      "C.R.P.F. Pinjore S.O": "134104",
      "Panchkula Sector 4 S.O": "134112",
      "Sector 15 Panchkula S.O": "134113",
      "Barwala S.O (Panchkula)": "134118",
      "Kalka S.O": "133302",
      "Mansa  Devi Sec 5 S.O": "134114",
      "Panchkula Sector 12 S.O": "134112",
      "Sector 20 Panchkula S.O": "134117",
      "Amravati  Enclave SO": "134105"
    },
    "AMBALA": {
      "Bhadauli B.O": "134203",
      "Bhareri Kalan B.O": "134203",
      "Bhurewala B.O": "134203",
      "Kathe Majra B.O": "134203",
      "Laha B.O": "134203",
      "Lakhnaura B.O": "134203",
      "Patwi B.O": "134201",
      "Baragaon B.O": "134203",
      "Nasrauli B.O": "134201",
      "Ambli B.O": "134203",
      "Jeoli B.O": "134203",
      "Akbarpur B.O": "134203",
      "Gadhauli B.O": "134203",
      "Hamidpur B.O": "134203",
      "Kurali B.O": "134203",
      "Ballana B.O": "134008",
      "Jansui B.O": "134008",
      "Kakroo B.O": "134008",
      "SAUNTA": "134008",
      "Budhangpur B.O": "134008",
      "Chaurmastpur B.O": "134008",
      "Dhankaur B.O": "134007",
      "Jalbera B.O": "134008",
      "Dhulkot B.O": "134007",
      "Mandhaur B.O": "134007",
      "SEGTI": "134008",
      "Dhurkara B.O": "134008",
      "UDAIPUR": "134008",
      "Lohgarh B.O": "134007",
      "Fatehgarh B.O": "134201",
      "Ghail B.O": "134007",
      "Baknaur B.O": "134007",
      "Danipur B.O": "134008",
      "MATHERI SEIKHAN": "134008",
      "Bhanokheri B.O": "134008",
      "Kathgarh Chhappar B.O": "134008",
      "LOHGARH": "134007",
      "Raiwali B.O": "134118",
      "Dhanana B.O": "134201",
      "Khanpur Brahmana B.O": "134201",
      "NAGGAL": "134008",
      "NANEOLA": "134008",
      "Panjokhara Sahib B.O": "134007",
      "Bharog B.O": "134201",
      "Adhoyi B.O": "133205",
      "Kambassi B.O": "133205",
      "Kaserla Kalan B.O": "133205",
      "Rajo Kheri B.O": "133201",
      "Rajouli B.O": "133201",
      "Tandwal B.O": "133201",
      "Sohata B.O": "133201",
      "Nagla Jattan B.O": "133102",
      "Pasiala B.O": "133102",
      "Dukheri B.O": "133004",
      "Durana B.O": "133004",
      "Mardon Sahib B.O": "133004",
      "Dhanaura B.O": "133203",
      "Kalpi B.O": "133104",
      "Sahela B.O": "133206",
      "Sardaheri B.O": "133206",
      "Panjlasa B.O": "134203",
      "Benaundi B.O": "134202",
      "Karasan B.O": "134202",
      "Pathreri B.O": "134202",
      "Manu Majra B.O": "133205",
      "Sewan Majra B.O": "133205",
      "Ugala B.O": "133205",
      "Kalarehri B.O": "133005",
      "Holi B.O": "133201",
      "Alipur Jahangir B.O": "133202",
      "Dinarpur B.O": "133102",
      "Landa B.O": "133102",
      "Baraula B.O": "133004",
      "Shah Pur B.O": "133004",
      "Sohana B.O": "133203",
      "Thakar Pura B.O": "133203",
      "Khudda Kalan B.O": "133104",
      "Sherpur Sulkhani B.O": "133206",
      "Lalpur B.O": "134203",
      "Korwakhurd B.O": "134202",
      "Thumber B.O": "133205",
      "Derasalimpur B.O": "133201",
      "Chudiala B.O": "133102",
      "Khanpur B.O": "133102",
      "Bara B.O": "133004",
      "Mohra B.O": "133004",
      "Gokal Garh B.O": "133203",
      "Mehmoodpur B.O": "133104",
      "Pilkhani B.O": "133104",
      "Binjalpur B.O": "133206",
      "Zaffarpur B.O": "133206",
      "Ganeshpur B.O": "134202",
      "Kakarmajra B.O": "134202",
      "Boh B.O": "133005",
      "Sarsehri B.O": "133005",
      "Keshopur Samalkha B.O": "133101",
      "Duliani B.O": "133202",
      "Manka Manki B.O": "133202",
      "Tharwa B.O": "133004",
      "P and T Colony B.O": "133004",
      "Nahoni B.O": "133104",
      "Samlerhi B.O": "133104",
      "Tepla B.O": "133104",
      "Durga Nagar S.O": "134008",
      "Bazar Basti Ram S.O": "134003",
      "Model Town Ambala City S.O": "134003",
      "Railway Road Ambala City S.O": "134003",
      "Kacha Bazar S.O": "133001",
      "Defence Colony S.O": "133010",
      "Prem Nagar S.O (Ambala)": "134003",
      "Adhoya S.O": "133205",
      "Babyal S.O": "133005",
      "Dhin S.O": "133202",
      "Gobind Nagar S.O": "133001",
      "Kharga Canteen S.O": "133001",
      "Kuldeep Nagar S.O": "133004",
      "M.M.E.Complex Mulana S.O": "133207",
      "Mullana S.O": "133203",
      "Ambala  City Kucthery S.O": "134003",
      "Baldev Nagar S.O": "134007",
      "D.A.V.College S.O": "134003",
      "Geeta Nagri S.O": "134007",
      "Jandli S.O": "134005",
      "Preet Nagar S.O (Ambala)": "134003",
      "Barara S.O": "133201",
      "Bihta S.O (Ambala)": "133101",
      "Hargolal S.O": "133001",
      "Ind estate S.O": "133006",
      "Kesri S.O": "133102",
      "Palam Vihar S.O (Ambala)": "133001",
      "Anaj Mandi S.O (Ambala)": "134003",
      "Jatwar S.O": "134201",
      "Naraingarh S.O": "134203",
      "Subzi  Mandi S.O": "134003",
      "Shahzadpur S.O.": "134202",
      "Commissioner Court S.O": "133001",
      "Mahesh Nagar S.O": "133001",
      "Ambala G.P.O.": "133001",
      "Ambala City H.O": "134003",
      "Top Khana Bazar S.O": "133001",
      "Majri S.O": "133008",
      "Punjabi Mohalla S.O": "133001",
      "Saha S.O": "133104",
      "Sadar Bazar S.O (Ambala)": "133001"
    },
    "REWARI": {
      "Zainabad BO": "123411",
      "Lohana BO": "123411",
      "Jakhala BO": "123301",
      "Dhawana BO": "123103",
      "Khaleta BO": "123103",
      "Mandola BO": "123103",
      "Bhatsana BO": "123106",
      "Dungerwas BO": "123106",
      "Maheshwari BO": "123106",
      "Raliawas BO": "123106",
      "Gugodh BO": "123302",
      "Juddi BO": "123302",
      "Mayan BO": "123103",
      "Basbatori BO": "123101",
      "Bhotwas Ahir BO": "123101",
      "Mamaria Ahir BO": "123101",
      "Pithrawas BO": "123101",
      "Tint BO": "123101",
      "Bhakli BO": "123302",
      "Masani BO": "123106",
      "Rattanthal BO": "123301",
      "Balwari BO": "123103",
      "Punsika BO": "123101",
      "Burthala BO": "123302",
      "Jhal BO": "123302",
      "Shyam Nagar BO": "123302",
      "Badhrana BO": "123412",
      "Rajgarh BO": "123412",
      "Tankri BO": "123412",
      "Kharkhara BO": "123106",
      "Nand Rampurbass BO": "123106",
      "Karnawas BO": "123401",
      "Kosli R S BO": "123302",
      "Lula Ahir BO": "123302",
      "Sadat Nagar BO": "123302",
      "Basduda BO": "123102",
      "Nangal Jamalpur BO": "123102",
      "Pali BO": "123102",
      "Bisowa BO": "123303",
      "Lilodh BO": "123303",
      "Nayagaon BO": "123303",
      "Guraora BO": "123035",
      "Rohrai BO": "123401",
      "Sulkha BO": "123401",
      "Dehlawas Gulabpur BO": "123401",
      "Musepur BO": "123401",
      "Gokalgarh BO": "123401",
      "Akera BO": "123106",
      "Surethi BO": "123302",
      "Tumna BO": "123302",
      "Jholri BO": "123303",
      "Karoli BO": "123303",
      "Asiaki Gorawas BO": "123035",
      "Karawara BO": "123035",
      "Bikaner BO": "123401",
      "Mohanpur BO": "123401",
      "Budhpur BO": "123401",
      "Nangli Godha BO": "123401",
      "Nangal Pathani BO": "123302",
      "Ahrod BO": "123102",
      "Bawwa BO": "123303",
      "Jharoda BO": "123303",
      "Kohrar BO": "123303",
      "Lookhi BO": "123303",
      "Kannaura BO": "123035",
      "Majra Gurdas BO": "123401",
      "Khandora BO": "123401",
      "Majra Sheoraj BO": "123401",
      "Chita Dungra BO": "123102",
      "Gothra BO": "123411",
      "Kolana BO": "123102",
      "Nehrugarh BO": "123303",
      "Saharanwas BO": "123401",
      "Bithwana BO": "123401",
      "Boria Kamalpur BO": "123401",
      "Mastapur BO": "123401",
      "Sangwari BO": "123401",
      "Bharawas BO": "123401",
      "Mohdinpur BO": "123401",
      "Jatusa RS BO": "123401",
      "Garhi Bolni BO": "123401",
      "B B Ashram BO": "123401",
      "Cheelarh BO": "122502",
      "Jaitpur BO": "122502",
      "Jant BO": "122502",
      "Mirpur BO": "122502",
      "Ramgarh BO": "122502",
      "Tatarpur BO": "122502",
      "Kakoria BO": "122502",
      "Turkiawas BO": "122502",
      "Baghthala BO": "123501",
      "Gujar Majra BO": "123501",
      "Pranpura BO": "123501",
      "Banipur BO": "123501",
      "Jaisinghpur Khera BO": "123501",
      "Nangal Teju BO": "123501",
      "Suthana BO": "123501",
      "Asalwas BO": "123501",
      "Jhabuwa BO": "123501",
      "Naichana BO": "123501",
      "Nangal Shahbazpur BO": "123501",
      "Dakhora BO": "123411",
      "Daroli BO": "123411",
      "Kanwali BO": "123411",
      "Mundi BO": "123411",
      "Buroli BO": "123411",
      "Lisan BO": "123411",
      "Nimoth BO": "123411",
      "Baldhan Kalan BO": "123411",
      "Motla Kalan BO": "123411",
      "Rampuri BO": "123411",
      "Kankarwali Rewari SO": "123401",
      "Dharan SO": "123412",
      "Gokal Bazar Rewari SO": "123401",
      "Khori SO": "123101",
      "Kund SO": "123102",
      "New Anaz Mandi Rewari SO": "123401",
      "Tehsil Road Rewari SO": "123401",
      "Rewari SO": "123401",
      "Bawal SO": "123501",
      "Dahina SO": "123411",
      "Nahar SO": "123303",
      "Dharuhera SO": "123106",
      "Guriani SO": "123301",
      "Industrial Area Dharuhera SO": "123110",
      "Khol SO": "123103",
      "Kosli SO": "123302",
      "Model Town  Rewari SO": "123401",
      "Palhawas SO": "123035"
    },
    "MAHENDRAGARH": {
      "Baghot BO": "123027",
      "Dhanaunda BO": "123027",
      "Kakrola BO": "123027",
      "Nautana BO": "123027",
      "Sihore BO": "123027",
      "Kheri BO": "123027",
      "Kotia BO": "123027",
      "Sehlong BO": "123027",
      "Siana BO": "123027",
      "Gurha BO": "123027",
      "Kanina Mandi BO": "123027",
      "Bharaf BO": "123027",
      "Chitrauli BO": "123027",
      "Pota BO": "123027",
      "Rambas BO": "123027",
      "Rasoolpur BO": "123027",
      "Behali BO": "123021",
      "Dulat Jat BO": "123021",
      "Sarai Bahadur BO": "123021",
      "Basai BO": "123029",
      "Beri BO": "123029",
      "Dulot Ahir BO": "123029",
      "Khatod BO": "123029",
      "Khudana BO": "123029",
      "Palri Panihara BO": "123029",
      "Dholera BO": "123023",
      "Nagal Nunia BO": "123023",
      "Sirohi Behali BO": "123023",
      "Barda BO": "123024",
      "Digrota BO": "123024",
      "Nangalmala BO": "123024",
      "Nangla BO": "123024",
      "Bachhod BO": "123021",
      "Bewal BO": "123021",
      "Dongra Ahir BO": "123021",
      "Rattan Kalan BO": "123021",
      "Buddin BO": "123029",
      "C R Mgrh BO": "123029",
      "Dhadhot BO": "123029",
      "Dulana BO": "123029",
      "Kurawata BO": "123029",
      "Lawan BO": "123029",
      "Mandola BO": "123029",
      "Nangal Dargu BO": "123023",
      "Niamatpur BO": "123023",
      "Sareli BO": "123023",
      "Dalanwas BO": "123024",
      "Madhogarh BO": "123024",
      "Nawan BO": "123024",
      "Bhocharia BO": "123021",
      "Garhi BO": "123021",
      "Gokalpur BO": "123021",
      "Tajpur BO": "123021",
      "Akoda BO": "123029",
      "Bawana BO": "123029",
      "Jhook BO": "123029",
      "Pali BO": "123029",
      "Bayal BO": "123023",
      "Budhwal BO": "123023",
      "Golwa BO": "123023",
      "Thanwas BO": "123023",
      "Kothal Khurd BO": "123028",
      "Sehma BO": "123028",
      "Jarwa BO": "123024",
      "Shyampura BO": "123024",
      "Ganiar BO": "123021",
      "Gujarwas BO": "123021",
      "Kanti BO": "123021",
      "Kanti Kheri BO": "123021",
      "Nimbi BO": "123029",
      "Akbarpur BO": "123023",
      "Bhungerka BO": "123023",
      "Bairawas BO": "123028",
      "Daroli Ahir BO": "123028",
      "Nihalawas BO": "123028",
      "Sureti Kalan BO": "123024",
      "Dhanota BO": "123001",
      "Koriawas BO": "123001",
      "Karota BO": "123001",
      "Mandi BO": "123001",
      "Azamabad Mukhota BO": "123001",
      "Bhushan Kalan BO": "123001",
      "Kultazpur BO": "123001",
      "Madhana Kalan BO": "123001",
      "Barkoda BO": "123001",
      "Dochana BO": "123001",
      "Krishan Nagar BO": "123001",
      "Kanwi BO": "123001",
      "Nizampur RS BO": "123001",
      "Neerpur BO": "123001",
      "Raghunathpura BO": "123001",
      "Dharson BO": "123001",
      "Kamania BO": "123001",
      "Dhor Kalan BO": "123001",
      "Bhojawas BO": "123034",
      "Chillro BO": "123001",
      "Hudina BO": "123001",
      "Dublana BO": "123001",
      "Nangal Katha BO": "123001",
      "Bashirpur BO": "123001",
      "Bhucholi BO": "123034",
      "Dewas BO": "123034",
      "Dhana BO": "123034",
      "Sundrah BO": "123034",
      "Jhagroli BO": "123034",
      "Pathera BO": "123034",
      "Hamidpur BO": "123001",
      "Narnaul HO": "123001",
      "Bawania SO": "123034",
      "Mini SecttNarnaul SO": "123001",
      "Nangal Sirohi SO": "123028",
      "Central University Haryana Mohindergarh SO": "123031",
      "Mohindergarh SO": "123029",
      "Mandi Ateli SO": "123021",
      "Nangal Chaudhry SO": "123023",
      "Narnaul City SO": "123001",
      "Kanina SO": "123027",
      "Narnaul Kty SO": "123001",
      "Satnali SO": "123024"
    },
    "ROHTAK": {
      "Kakrana BO": "124412",
      "Sundana BO": "124412",
      "Khairari BO": "124113",
      "Nigana BO": "124113",
      "Sampel BO": "124113",
      "Saman BO": "124112",
      "Sisarkhas BO": "124112",
      "Bhaini Maharajpur BO": "124112",
      "Basana BO": "124022",
      "Bahu Akbarpur BO": "124022",
      "Baland BO": "124010",
      "Bhali Anandpur BO": "124010",
      "Marodi Jatan BO": "124010",
      "Kahni BO": "124303",
      "Chandi BO": "124514",
      "Chiri BO": "124514",
      "Gharauthi BO": "124514",
      "Gugaheri BO": "124514",
      "Kharkhara BO": "124111",
      "Farmana BO": "124112",
      "Khidwali BO": "124303",
      "Rithal BO": "124303",
      "Basantpur BO": "124303",
      "Jassia BO": "124303",
      "Garnauthi BO": "124412",
      "Bakheta BO": "124406",
      "Morekheri BO": "124406",
      "Bhagwatipur BO": "124514",
      "Kharainti BO": "124514",
      "Nidana BO": "124514",
      "Samargopalpur BO": "124514",
      "Sunderpur BO": "124514",
      "Bharan BO": "124111",
      "Behlba BO": "124112",
      "Bhaini Bharon BO": "124112",
      "Bhaini Surjan BO": "124112",
      "Karontha BO": "124010",
      "Dobh BO": "124010",
      "Jindran BO": "124303",
      "Katesra BO": "124113",
      "Assan BO": "124406",
      "Humayunpur BO": "124406",
      "Bainsi BO": "124514",
      "Nandal BO": "124514",
      "Titauli BO": "124514",
      "Singhpura Kalan BO": "124514",
      "Ajaib BO": "124111",
      "Girawar BO": "124111",
      "Bhaini Chanderpal BO": "124112",
      "Gaddi Kheri BO": "124010",
      "Sunari Kalan BO": "124010",
      "Ghillaur Kalan BO": "124303",
      "Chamaria BO": "124303",
      "Lahli BO": "124411",
      "Patwapur BO": "124411",
      "Kharawar BO": "124021",
      "Kheri Sadh BO": "124021",
      "Pehrawar BO": "124021",
      "Samchana BO": "124404",
      "Garhi BO": "124501",
      "Ismaila BO": "124501",
      "Kultana BO": "124501",
      "Banyani BO": "124411",
      "Maina BO": "124021",
      "Baliana BO": "124401",
      "Kiloi BO": "124401",
      "Pilana BO": "124202",
      "Atail BO": "124501",
      "Gandhra BO": "124501",
      "Gijhi BO": "124501",
      "Nonaud BO": "124501",
      "Bohar BO": "124021",
      "Bhasro Kalan BO": "124501",
      "Chuliyana BO": "124501",
      "Naya Bans BO": "124501",
      "Garhi Ballab BO": "124411",
      "Kanheli BO": "124021",
      "Kabulpur BO": "124201",
      "Ritauli BO": "124201",
      "Paksma BO": "124401",
      "Polangi BO": "124401",
      "Rurkee BO": "124401",
      "Ladout BO": "124401",
      "Karor BO": "124021",
      "Dhamar BO": "124401",
      "Mungain BO": "124401",
      "Makrauli Kalan BO": "124401",
      "Asthal Bohar SO": "124021",
      "Bhalaut SO": "124401",
      "Kalanaur SO Rohtak": "124113",
      "Kansala SO": "124406",
      "Lakhan Majra SO": "124514",
      "Madina SO": "124111",
      "Model Town SO Rohtak": "124001",
      "Police Training Center Sunaria SO": "124010",
      "Medical College SO Rohtak": "124001",
      "Mehem SO": "124112",
      "Nindana SO": "124513",
      "Rohtak Sector I SO": "124001",
      "Bus Stand": "124001",
      "Sanghi SO": "124303",
      "Shivaji Colony SO": "124001",
      "MD University Rohtak SO": "124001",
      "DLF Colony Rohtak SO": "124001",
      "Gohana Road SO Rohtak": "124001",
      "Jhajjar Road Rohtak SO": "124001",
      "Rohtak Town SO": "124001",
      "Hassangarh SO": "124404",
      "Sampla SO": "124501",
      "Anwal SO": "124411",
      "Gandhi Camp SO": "124001",
      "Janta Colony Rohtak SO": "124001",
      "Kahnaur SO": "124412",
      "Mokhra SO": "124022",
      "Hissar Road Rohtak SO": "124001",
      "Rohtak HO": "124001"
    },
    "HISAR": {
      "Landhari BO": "125047",
      "Sandol BO": "125047",
      "Gangwa BO": "125007",
      "Chakpanihar BO": "125007",
      "Badhawar BO": "125121",
      "Bhaini Badshahpur BO": "125121",
      "Dhadh BO": "125121",
      "Dhani Khan Bahadur BO": "125121",
      "Kharkara BO": "125121",
      "Matloda BO": "125121",
      "Badala BO": "125042",
      "Kharbala BO": "125042",
      "Kuleri BO": "125047",
      "Nangthala BO": "125047",
      "Shamsukh BO": "125047",
      "Gawar BO": "125007",
      "Chaudhariwas BO": "125007",
      "Banbhori BO": "125121",
      "Faridpur BO": "125121",
      "Khedar BO": "125121",
      "Panihari BO": "125121",
      "Kirmara BO": "125047",
      "Chirod BO": "125007",
      "Gorchi BO": "125007",
      "Muklan BO": "125007",
      "Biana Khera BO": "125121",
      "Bugana BO": "125121",
      "Daultpur BO": "125121",
      "Rajli BO": "125121",
      "Sandlana BO": "125121",
      "Sarhera BO": "125121",
      "Sarsod BO": "125121",
      "Badchhpar BO": "125042",
      "Chikanwas BO": "125047",
      "Siwani Bolan BO": "125047",
      "Thaska BO": "125047",
      "Glf Hisar BO": "125011",
      "Ttc Hisar BO": "125011",
      "CSF Hisar BO": "125011",
      "Gaibipur BO": "125121",
      "Gurana BO": "125121",
      "Jeora BO": "125121",
      "Kharak Punia BO": "125121",
      "Kharar Alipur BO": "125044",
      "Qutabpur BO": "125044",
      "Raipur BO": "125044",
      "Litani BO": "125113",
      "Parbhuwala BO": "125113",
      "Kheri Gangan BO": "125049",
      "Bithmara BO": "125113",
      "Hassangarh BO": "125113",
      "Kumba Khera BO": "125113",
      "Masudpur BO": "125049",
      "Pali BO": "125049",
      "Bobua BO": "125113",
      "Chamar Khera BO": "125113",
      "Sahu BO": "125113",
      "Bhagana BO": "125044",
      "Mayar BO": "125044",
      "Datta BO": "125049",
      "Maijod BO": "125049",
      "Kallar Bhaini BO": "125113",
      "Surewala BO": "125113",
      "Neoli Kalan BO": "125004",
      "Burak BO": "125004",
      "Sundawas BO": "125004",
      "Dhana Kalan BO": "125033",
      "Dhana Khurd BO": "125033",
      "Dhanderi BO": "125033",
      "Dhani Peeranwali BO": "125033",
      "Puthimangal Khan BO": "125033",
      "Sindher BO": "125033",
      "Sorkhi BO": "125033",
      "Sultanpur BO": "125033",
      "Thurana BO": "125033",
      "Asrawan BO": "125052",
      "Chuli Bagrian BO": "125052",
      "Chuli Khurd BO": "125052",
      "Kajlan BO": "125052",
      "Sadalpur BO": "125052",
      "Niyana BO": "125005",
      "Mangali BO": "125005",
      "Singhran BO": "125005",
      "Talwandi Rana BO": "125005",
      "Behbalpur BO": "125005",
      "Harita BO": "125005",
      "Daya BO": "125005",
      "Kaimri BO": "125005",
      "Kanwari BO": "125037",
      "Bhaini Amirpur BO": "125039",
      "Gamra BO": "125039",
      "Bhodia Bishnoian BO": "125050",
      "Shahpur BO": "125004",
      "DOBHI BO": "125004",
      "Ebs Hisar BO": "125004",
      "Rawalwas Khurd BO": "125004",
      "Arya Nagar BO": "125004",
      "Bhatol Jattan BO": "125042",
      "Hajampur BO": "125033",
      "Kulana BO": "125033",
      "Mehanda BO": "125033",
      "Shaikhpura BO": "125033",
      "Umra BO": "125033",
      "Dahima BO": "125006",
      "Ladwa BO": "125006",
      "Dharam Kheri BO": "125038",
      "Sulchani BO": "125038",
      "Bagla BO": "125052",
      "Jakhod Khera BO": "125052",
      "Kishangarh BO": "125052",
      "Sarangpur BO": "125052",
      "Dabra BO": "125005",
      "Mirzapur BO": "125005",
      "Talwandi Rukka BO": "125005",
      "IACBP Hisar BO": "125005",
      "Kheri Barki BO": "125005",
      "Shaharwa BO": "125005",
      "Muzadpur BO": "125037",
      "Budana BO": "125039",
      "Koth Khurd BO": "125039",
      "Moth BO": "125039",
      "Nara BO": "125039",
      "Rakhi Shahpur BO": "125039",
      "Khairi BO": "125112",
      "Kirori BO": "125112",
      "Madanheri BO": "125042",
      "Sarsana BO": "125004",
      "Kirtan BO": "125004",
      "Kharia BO": "125004",
      "Tokas BO": "125004",
      "Bhatla BO": "125033",
      "Chainat BO": "125033",
      "Garhi BO": "125033",
      "Ghirai BO": "125033",
      "Kumbha BO": "125033",
      "Petwar BO": "125033",
      "Satroad Kalan BO": "125006",
      "Bhaklana BO": "125038",
      "Kagasar BO": "125038",
      "Daroli BO": "125052",
      "Ghursal BO": "125052",
      "Kohli BO": "125052",
      "Ladwi BO": "125052",
      "Salemgarh BO": "125052",
      "Siswal BO": "125052",
      "Dhansu BO": "125005",
      "Badya Brahamana BO": "125005",
      "Juglan BO": "125005",
      "Kapro BO": "125039",
      "Rajthal BO": "125039",
      "Kinala BO": "125112",
      "Haibatpur BO": "125039",
      "Majra BO": "125039",
      "Milakpur BO": "125039",
      "Mirchpur BO": "125039",
      "Sotha BO": "125039",
      "Kanoh Punia BO": "125112",
      "Mohla BO": "125042",
      "Puthi Samain BO": "125042",
      "Singhwa BO": "125042",
      "Mattar Sham BO": "125004",
      "Balsmand BO": "125004",
      "Bandaheri BO": "125004",
      "Chaudhariwali BO": "125004",
      "Jamawari BO": "125033",
      "Kharkari BO": "125033",
      "Kharkhara BO": "125042",
      "Khokha BO": "125033",
      "Ugalan BO": "125038",
      "Durjanpur BO": "125052",
      "Kabrel BO": "125052",
      "Kalirawan BO": "125052",
      "Khairampur BO": "125052",
      "Mahalsara BO": "125052",
      "Moda Khera BO": "125052",
      "Mohabatpur BO": "125052",
      "Kheri Jalab BO": "125039",
      "Lohari Ragho BO": "125039",
      "Madha BO": "125039",
      "Balak BO": "125112",
      "Hisar HO": "125001",
      "Agroha SO": "125047",
      "Anaj Mandi Hansi SO": "125033",
      "Azad Nagar Hisar SO": "125007",
      "BSF Hisar SO": "125011",
      "Bass SO": "125042",
      "Mini Secretariat Hansi SO": "125033",
      "Barwala SO Hisar": "125121",
      "Hansi SO": "125033",
      "BARWALA MANDI SO": "125121",
      "Barwala Road Hansi SO": "125033",
      "Gju Hisar SO": "125001",
      "HTM Hisar SO": "125001",
      "Ha U Hisar SO": "125004",
      "Urban Estate  2 Hisar SO": "125005",
      "Uklana Mandi SO": "125113",
      "Vidut Nagar Hisar SO": "125005",
      "Hansi City SO": "125033",
      "Hisar City SO": "125001",
      "Hisar Kty SO": "125001",
      "Khanda Kheri SO": "125038",
      "Mandi Adampur SO": "125052",
      "Modle Town Hisar SO": "125005",
      "Patel Nager Hisar SO": "125001",
      "Sisai SO Hisar": "125049",
      "Satroad Khurd SO": "125044",
      "Hisar  Nai Mandi SO": "125001",
      "Hisar Cantt SO": "125006",
      "MCHisar SO": "125001",
      "Mini Sectthisar SO": "125001",
      "NAM Hisar SO": "125001",
      "Nalwa SO": "125037",
      "Narnaund SO": "125039",
      "Pabra SO": "125112",
      "T C Hansi SO": "125033"
    },
    "SONIPAT": {
      "Rathdhana BO": "131001",
      "Delhi Road BO": "131001",
      "Lehrara BO": "131001",
      "Shapur Turk BO": "131001",
      "Tharuoldepur BO": "131001",
      "Barwasni BO": "131001",
      "RATTANGARH": "131001",
      "Qumaspur BO": "131021",
      "Mehlana BO": "131001",
      "Harsana Kalan BO": "131001",
      "Mohana BO": "131001",
      "Baroli BO": "131021",
      "Khewra BO": "131021",
      "Banwasa BO": "131304",
      "Dhanana Ahladpur BO": "131304",
      "Sandal Kalan BO": "131001",
      "Kakroi BO": "131001",
      "Bayanpur BO": "131001",
      "Rishikul Vidyapeeth BO": "131001",
      "FAZILPUR": "131001",
      "Deepalpur BO": "131021",
      "Chhapra BO": "131304",
      "Rindana BO": "131304",
      "Katwal BO": "131409",
      "Gangana BO": "131302",
      "Jhs Butana BO": "131302",
      "Kurar Brahimpur BO": "131039",
      "Pipli Khera BO": "131039",
      "Jasrana BO": "131408",
      "Bari BO": "131101",
      "Datauli BO": "131101",
      "Gumar BO": "131101",
      "Sheikhpura BO": "131101",
      "AhulanaGohana BO": "131301",
      "Barota BO": "131301",
      "Bidhal BO": "131301",
      "Jagsi BO": "131301",
      "Kathura Block BO": "131301",
      "Kheri Damkan BO": "131301",
      "Tihar BO": "131301",
      "Janti Kalan BO": "131028",
      "Sersa BO": "131028",
      "Bohla BO": "131024",
      "Mahra II BO": "131024",
      "Salimsar Majra BO": "131022",
      "Tihar Bagru BO": "131022",
      "Bhawar BO": "131302",
      "Garhwal BO": "131302",
      "Garhi Sisana ED BO": "131408",
      "Gorar BO": "131408",
      "Bega BO": "131101",
      "Kheri Gujjar BO": "131101",
      "Bhainswan Khurd BO": "131301",
      "Bidhal Pinana BO": "131301",
      "Chhichrana BO": "131301",
      "Jauli BO": "131301",
      "Kathura BO": "131301",
      "Puthi BO": "131301",
      "Rabra BO": "131301",
      "Rukhi BO": "131301",
      "Sikenderpur Majra BO": "131301",
      "Aterna BO": "131023",
      "Jhundpur BO": "131023",
      "Riwara BO": "131409",
      "Kohla BO": "131302",
      "Nuran Khera BO": "131302",
      "Larsauli BO": "131039",
      "Sanpera BO": "131039",
      "Guhna BO": "131408",
      "Silana BO": "131408",
      "Garhi Rajlu BO": "131101",
      "Ghasauli BO": "131101",
      "Khubru BO": "131101",
      "Rajpur BO": "131101",
      "Bali Brahman BO": "131301",
      "Khandrai BO": "131301",
      "Lath BO": "131301",
      "Kundli BO": "131028",
      "Karewari BO": "131024",
      "Rolad Latifpur BO": "131024",
      "Anwali BO": "131409",
      "Giwana BO": "131409",
      "Nizampur BO": "131302",
      "Bichpari BO": "131302",
      "Bhagan BO": "131039",
      "AhulanaGannur BO": "131101",
      "Bali Qutubpur BO": "131101",
      "Khizarpur Ahir BO": "131101",
      "Panchi Gujjaran BO": "131101",
      "Madina BO": "131301",
      "MahraI BO": "131301",
      "Mehmoodpur BO": "131301",
      "Moi Hooda BO": "131301",
      "Nayat BO": "131301",
      "Manauli BO": "131023",
      "Nangal Kalan BO": "131023",
      "Sitawali BO": "131024",
      "Ganewari BO": "131305",
      "Barona BO": "131402",
      "Thanakalan BO": "131402",
      "Asadpur Nandnaur BO": "131027",
      "Jainpur BO": "131027",
      "Nathupur BO": "131029",
      "Pritampura BO": "131029",
      "Moi Majri BO": "131102",
      "Panchijatan BO": "131102",
      "Pugthala BO": "131102",
      "Bindroli BO": "131403",
      "Jharot BO": "131403",
      "Kundal BO": "131402",
      "Pehladpur Kiroli BO": "131402",
      "Rohna BO": "131402",
      "Busana BO": "131306",
      "Chhetra BO": "131306",
      "Halalpur BO": "131103",
      "Kheri Manajat BO": "131103",
      "Mandaura BO": "131103",
      "Nahra BO": "131103",
      "Kanwali BO": "131403",
      "Khanpur Kalan BO": "131305",
      "Saragthal BO": "131305",
      "GKMatindu BO": "131402",
      "Khanda BO": "131402",
      "Sehri BO": "131402",
      "Chirana BO": "131306",
      "Shamri BO": "131306",
      "Akabarpur Barota BO": "131103",
      "Jatheri BO": "131029",
      "Rai BO": "131029",
      "Kailana BO": "131102",
      "Badhana BO": "131403",
      "Kasandi BO": "131305",
      "Bidhlan BO": "131402",
      "Gopalpur BO": "131402",
      "Pipli BO": "131402",
      "Saidpur BO": "131402",
      "Sohti BO": "131402",
      "Dhurana BO": "131306",
      "Jawahra BO": "131306",
      "Malikpur BO": "131027",
      "Chhetra Bhahadurpur BO": "131103",
      "Bajanakhurd BO": "131102",
      "Bahalgarh SO": "131021",
      "Butana SO": "131302",
      "Gohana Mandi SO": "131301",
      "Gohana SO": "131301",
      "Atlas Cycle SO": "131001",
      "Bhatgaon SO Sonipat": "131022",
      "Bus Stand Gohana SO": "131301",
      "Ganaur SO": "131101",
      "Ganzbazar SO": "131001",
      "Farmana SO": "131408",
      "Baroda SO": "131304",
      "Bhainswal Kalan SO": "131409",
      "Engg College Muthal SO": "131039",
      "Ganaur City SO": "131101",
      "Gohana Road SO Sonipat": "131001",
      "Industrial Estate Kundli SO": "131028",
      "Jakhauli SO": "131023",
      "Sonipat HO": "131001",
      "Kanyagurukul Khanpur SO": "131305",
      "Kharkhauda SO": "131402",
      "Mundlana SO": "131306",
      "Ram BazarSonipat SO": "131001",
      "Rathdhana Road Sonipat SO": "131001",
      "Sonipat Sector 14 SO": "131001",
      "TDI City Kundli SO": "131030",
      "Murthal SO": "131027",
      "PSRai SO": "131029",
      "Sonipat Mandi SO": "131001",
      "Mini Sectt Gohana": "131301",
      "HOUSING BOARD COLONY SONIPAT": "131001",
      "Model Town Sonipat SO": "131001",
      "Nahri SO": "131103",
      "Sonipat Kty SO": "131001",
      "Juan SO": "131024",
      "Purkhas SO": "131102",
      "Rohat SO Sonipat": "131403"
    },
    "FATEHABAD": {
      "Kumaharia BO": "125047",
      "Gorakhpur BO": "125047",
      "Dhanger BO": "125048",
      "Mahmadpur Rohi BO": "125048",
      "Bhoda BO": "125047",
      "Chinder BO": "125048",
      "Khara Kheri BO": "125048",
      "Nagpur BO": "125051",
      "Nangal BO": "125051",
      "Nathwan BO": "125051",
      "Palsar BO": "125051",
      "Phullan BO": "125051",
      "Pilchhian BO": "125051",
      "Sheikhpur Sotter BO": "125051",
      "Nangla BO": "125120",
      "Chander Kalan BO": "125120",
      "Fatehpuri BO": "125120",
      "Jamalpur Sheikhan BO": "125120",
      "Pirthala BO": "125120",
      "Samain BO": "125120",
      "Saniana BO": "125113",
      "Ratta Khera BO": "125051",
      "Gajuwala BO": "125120",
      "Lalauda BO": "125120",
      "Partan BO": "125120",
      "Rainwali BO": "125120",
      "Dangra BO": "125120",
      "Inda Chhoi BO": "125120",
      "Kanheri BO": "125120",
      "Kudni BO": "125120",
      "Bosti BO": "125113",
      "Buwan BO": "125113",
      "Chandrawal BO": "125111",
      "Chaubara BO": "125111",
      "Dhani Gopal BO": "125111",
      "Dholu BO": "125111",
      "Akanwali BO": "125106",
      "Degoh BO": "125106",
      "Bhodia Khera BO": "125050",
      "Daiyar BO": "125053",
      "Pili Mandori BO": "125053",
      "Ramsara BO": "125053",
      "Suli Khera BO": "125053",
      "Jandli Kalan BO": "125111",
      "Sanchla BO": "125111",
      "Handalwala BO": "125106",
      "Kullan BO": "125106",
      "Ratta Theh BO": "125106",
      "Bangaon BO": "125050",
      "Bighar BO": "125050",
      "Hajrawan Khurd BO": "125050",
      "Karnoli BO": "125050",
      "Munawali BO": "125050",
      "Nakhatia BO": "125050",
      "Theri BO": "125050",
      "Meond Kalan BO": "125133",
      "Nathuwal BO": "125133",
      "Baliala BO": "125051",
      "Bora BO": "125051",
      "Gurusar BO": "125051",
      "Hassanga BO": "125051",
      "Kamana BO": "125051",
      "Mehmra BO": "125051",
      "Mohmadpur Sotter BO": "125051",
      "Ban Mandori BO": "125053",
      "Dhabi Kalan BO": "125053",
      "Mehuwala BO": "125053",
      "Shekhupur Daroli BO": "125053",
      "Thuiyan BO": "125053",
      "Baijalpur BO": "125111",
      "Dullat BO": "125111",
      "Jandli Khurd BO": "125111",
      "Diwana BO": "125106",
      "Karandi BO": "125106",
      "Nanheri BO": "125106",
      "Shakarpura BO": "125106",
      "Bhuthan Kalan BO": "125050",
      "Dhani Majra BO": "125050",
      "Hajrawan Kalan BO": "125050",
      "Ratta Tibba BO": "125050",
      "Sadhanwas BO": "125133",
      "Talwara BO": "125133",
      "Mundlian BO": "125133",
      "Nehla BO": "125112",
      "Aharwan BO": "125051",
      "Ayalki BO": "125051",
      "Bahmanwala BO": "125051",
      "Haroli BO": "125051",
      "Jallopur BO": "125051",
      "Mirana BO": "125051",
      "Dariyapur BO": "125050",
      "Dhand BO": "125050",
      "Gillan Khera BO": "125050",
      "Sidhani BO": "125133",
      "Alika BO": "125051",
      "Badalgarh BO": "125051",
      "Khunan BO": "125051",
      "Dhingsara BO": "125053",
      "Jandwala BO": "125053",
      "Khabra Kalan BO": "125053",
      "Kirdhan BO": "125053",
      "Khajuri Jatti BO": "125111",
      "Nadhori BO": "125111",
      "Lehraian BO": "125106",
      "Manghera BO": "125106",
      "Musa Khera BO": "125106",
      "Ahlisadar BO": "125050",
      "Banawali BO": "125050",
      "Bhirdana BO": "125050",
      "Jhalnia BO": "125050",
      "Khairati Khera BO": "125050",
      "Kukranwali BO": "125050",
      "Amani BO": "125120",
      "Meond Khurd BO": "125133",
      "Dahman BO": "125112",
      "Biranbadi BO": "125051",
      "Chandoh Kalan BO": "125051",
      "Chimmon BO": "125051",
      "Ganda BO": "125051",
      "Hamzapur BO": "125051",
      "Hanspur BO": "125051",
      "Laduwas BO": "125051",
      "Lali BO": "125051",
      "Marh BO": "125051",
      "Bhattu Kalan SO": "125053",
      "Fatehabd Kty SO": "125050",
      "Bhuna SO": "125111",
      "Fatehabad SO Fatehabad": "125050",
      "Tohana Mandi SO": "125120",
      "Badopal SO": "125048",
      "Tohana SO": "125120",
      "M S Rattia SO": "125051",
      "Dharsul Kalan SO": "125106",
      "Nai Mandi Fatehabad SO": "125050",
      "Jakhal Mandi SO": "125133",
      "Rattia SO": "125051"
    },
    "JHAJJAR": {
      "Chamanpura BO": "124102",
      "Mehrana BO": "124102",
      "Gawalison BO": "124103",
      "Jondhi BO": "124103",
      "Talao BO": "124103",
      "Chimni BO": "124412",
      "Birohar BO": "124106",
      "Jharli BO": "124106",
      "Marot BO": "124106",
      "Jahangirpur BO": "124104",
      "Kheri Asra BO": "124104",
      "Ladain BO": "124146",
      "Madana Kalan BO": "124102",
      "Seria BO": "124102",
      "Dadanpur BO": "124103",
      "Dawla Raiya BO": "124103",
      "Gurukul Jhajjar BO": "124103",
      "Khatiwas BO": "124103",
      "Sulodha BO": "124103",
      "Utlodha BO": "124103",
      "Karodha BO": "124103",
      "Dharana BO": "124412",
      "Ahri BO": "124108",
      "Lohari BO": "124108",
      "Pataudah BO": "124108",
      "Chhuchhakwas BO": "124106",
      "Khachrauli BO": "124106",
      "Mundsa BO": "124106",
      "Jnv Kiloi BO": "124104",
      "Kablana BO": "124104",
      "Birar BO": "124146",
      "Mundahera BO": "124146",
      "Dadri Toe BO": "124103",
      "Gudha BO": "124103",
      "Hasanpur BO": "124103",
      "Jahazgarh BO": "124103",
      "Kheri Kumar BO": "124103",
      "MPMajra BO": "124103",
      "Palra BO": "124103",
      "Silani BO": "124103",
      "Yakubpur BO": "124103",
      "Bhatera BO": "124108",
      "Chhappar BO": "124108",
      "Kahri BO": "124108",
      "Khudan BO": "124108",
      "Nogawan BO": "124106",
      "Sasroli BO": "124106",
      "Sehlenga BO": "124106",
      "Ukhal Channa BO": "124104",
      "Surha BO": "124104",
      "Akheri Madanpur BO": "124146",
      "Bhurawas BO": "124146",
      "Jhanswa Kalan BO": "124146",
      "Nilaheri BO": "124146",
      "Silana BO": "124103",
      "Achhej BO": "124106",
      "Bajidpur Tappa Haveli BO": "124104",
      "Bhadani BO": "124104",
      "Khungai BO": "124104",
      "Luksar BO": "124508",
      "Noona Majra BO": "124508",
      "Sankhol BO": "124508",
      "Barahi BO": "124505",
      "Kulasi BO": "124505",
      "Kheri Jat BO": "124105",
      "Gubhana BO": "124105",
      "Chudani BO": "124504",
      "Nilothi BO": "124404",
      "Kharhar BO": "124501",
      "Goria BO": "124142",
      "Jhamri BO": "124142",
      "Tumbaheri BO": "124109",
      "Barhana BO": "124107",
      "Birdhana BO": "124102",
      "Kassar BO": "124508",
      "Jassaur Kheri BO": "124505",
      "Bamnoli BO": "124505",
      "Badsa BO": "124105",
      "Ladpur BO": "124105",
      "Sondhi BO": "124105",
      "Bhupnia BO": "124105",
      "Matan BO": "124501",
      "Bhambhewa BO": "124021",
      "Surheti BO": "124109",
      "Bhindawas BO": "124109",
      "Dhandlan BO": "124107",
      "Goela Kalan BO": "124508",
      "Kharman BO": "124508",
      "Jakhauda BO": "124505",
      "Pelpa BO": "124105",
      "Mundakhera BO": "124105",
      "Rewari Khera BO": "124504",
      "Tandaheri BO": "124506",
      "Loharheri BO": "124501",
      "Baghpur BO": "124201",
      "Bilochpura BO": "124109",
      "Kasni BO": "124109",
      "Samaspur Majra BO": "124109",
      "Subana BO": "124109",
      "Chhadwana BO": "124109",
      "Chhochi BO": "124107",
      "Gochhi BO": "124107",
      "Majra BO": "124202",
      "Sewana BO": "124202",
      "Daboda Kalan BO": "124508",
      "Daboda Khurd BO": "124508",
      "Dulhera BO": "124508",
      "Lowa Kalan BO": "124508",
      "Soldha BO": "124508",
      "KANONDA BO": "124505",
      "LADRAWAN BO": "124505",
      "Bamnaula BO": "124105",
      "Deverkhana BO": "124105",
      "Bhaproda BO": "124501",
      "Dehkora BO": "124501",
      "Rohad BO": "124501",
      "Khanpur Khurd BO": "124142",
      "Khorra BO": "124142",
      "Bakra BO": "124201",
      "Bishan BO": "124201",
      "Dhaur BO": "124201",
      "Darauli BO": "124109",
      "Khetawas BO": "124109",
      "Niwada BO": "124109",
      "Bahadurgarh Sector 6 SO": "124507",
      "Line Par Bahadurgarh SO": "124507",
      "Court Complex Jhajjar SO": "124103",
      "Beri SO": "124201",
      "Power Plant Jharli SO": "124141",
      "Bahadurgarh Mandi SO": "124508",
      "Assaudha SO": "124505",
      "Dighal SO": "124107",
      "Machrauli SO": "124108",
      "Matanhail SO": "124106",
      "Nehru College Jhajjar SO": "124104",
      "Badli SO Jhajjar": "124105",
      "Charra SO": "124504",
      "IABahadurgarh SO": "124507",
      "Bahu SO": "124142",
      "Dujana SO": "124102",
      "Sahlawas SO": "124146",
      "Main Bazar Bahadurgarh  SO": "124507",
      "Mandothi SO": "124506",
      "Dhakla SO": "124109",
      "Dubaldhan SO": "124202",
      "Jhajjar SO": "124103",
      "Bahadurgarh HO": "124507"
    },
    "KAITHAL": {
      "Baupur B.O": "136034",
      "Bhagal B.O": "136034",
      "Bhuna B.O": "136034",
      "Harigarh Kingan B.O": "136034",
      "Kharaudi B.O": "136034",
      "Mehmoodpur B.O": "136034",
      "Mengran B.O": "136034",
      "Rasina B.O": "136042",
      "Teontha B.O": "136042",
      "Geong B.O": "136027",
      "Guhna B.O": "136027",
      "Keorak B.O": "136027",
      "Kheri Simbal Wali B.O": "136027",
      "Lander Keema B.O": "136027",
      "Majra Nand Karan B.O": "136027",
      "Nauch B.O": "136027",
      "Padla B.O": "136027",
      "Patti Afgan B.O": "136027",
      "Badsui B.O": "136034",
      "Gaggarpur B.O": "136034",
      "Peedal B.O": "136034",
      "Chandlana B.O": "136020",
      "Jajjanpur B.O": "136020",
      "Naina Dhos B.O": "136042",
      "Duserpur B.O": "136035",
      "Chandana B.O": "136027",
      "Dewal B.O": "136027",
      "Harsola B.O": "136027",
      "Khurana B.O": "136027",
      "Ladana Baba B.O": "136027",
      "Narar B.O": "136027",
      "Arnauli B.O": "136034",
      "Balbera B.O": "136034",
      "Bhuslan B.O": "136034",
      "Daba B.O": "136034",
      "Jadola B.O": "136020",
      "Pabnawa B.O": "136020",
      "Mundri B.O": "136042",
      "Saunch B.O": "136042",
      "Baraut B.O": "136027",
      "Budha Khera B.O": "136027",
      "Gulyana Songri B.O": "136027",
      "Kichhana B.O": "136027",
      "Kultaran B.O": "136027",
      "Manas B.O": "136027",
      "Peoda B.O": "136027",
      "Agondh B.O": "136035",
      "Kharkada B.O": "136035",
      "Kharkan B.O": "136035",
      "Mastgarh B.O": "136035",
      "Seonmajra B.O": "136035",
      "Deoban B.O": "136027",
      "Jakholi B.O": "136027",
      "Kassan B.O": "136027",
      "Deohera B.O": "136027",
      "Barta BO": "136027",
      "Songal B.O": "136027",
      "Balu B.O": "136117",
      "Sirta B.O": "136027",
      "Teek B.O": "136027",
      "Badsikri Kalan B.O": "136117",
      "Batta B.O": "136117",
      "Dhundwa B.O": "136117",
      "Titram B.O": "136027",
      "Chaushala B.O": "136117",
      "Dubbal B.O": "136117",
      "Haripura B.O": "136117",
      "Kalayat Mandi B.O": "136117",
      "Kharak Pandwan B.O": "136117",
      "Bakal B.O": "136043",
      "Bhana B.O": "136043",
      "Kakot B.O": "136043",
      "Karora B.O": "136043",
      "Sirsal B.O": "136026",
      "Ladana Chaku B.O": "136033",
      "Mandi Sadra B.O": "136033",
      "Kurar B.O": "136117",
      "Ram Garh Pandwa B.O": "136117",
      "Chuhar Majra B.O": "136021",
      "Pilni B.O": "136043",
      "Sisla Sismore B.O": "136043",
      "Hajwana B.O": "136026",
      "Bir Bangran B.O": "136044",
      "Kangthali B.O": "136033",
      "Kolekhan B.O": "136117",
      "Mataur B.O": "136117",
      "Ahun B.O": "136021",
      "Kotra B.O": "136043",
      "Serhda B.O": "136043",
      "Barsana B.O": "136026",
      "Kakrala Inayat B.O": "136033",
      "Kawartan B.O": "136033",
      "Sair B.O": "136033",
      "Sajuma B.O": "136117",
      "Sanghan B.O": "136117",
      "Simla B.O": "136117",
      "Pharal B.O": "136021",
      "Sakra B.O": "136021",
      "Sanghrouli B.O": "136021",
      "Deeg B.O": "136026",
      "Habri B.O": "136026",
      "Kithana B.O": "136044",
      "Mandwal B.O": "136044",
      "Rohera B.O": "136044",
      "Santokh Majra B.O": "136044",
      "Kheri Gulam Ali B.O": "136033",
      "Kailram B.O": "136117",
      "Kalasar B.O": "136117",
      "Kaithal City S.O": "136027",
      "Kaithal S.O": "136027",
      "Pai S.O": "136043",
      "Model Town Kaithal S.O": "136027",
      "Karnal Road Kaithal S.O": "136027",
      "Guhla S.O": "136035",
      "Kalayat S.O": "136117",
      "Kaul S.O": "136021",
      "Pundri S.O": "136026",
      "Siwan Gate Kaithal S.O": "136027",
      "Rajound S.O": "136044",
      "Siwan S.O": "136033",
      "Chika S.O": "136034",
      "Dhand S.O": "136020",
      "Fatehpur S.O (Kaithal)": "136042"
    },
    "KURUKSHETRA": {
      "Ram Saran Majra B.O": "136156",
      "Batheri B.O": "136030",
      "Rohti B.O": "136129",
      "Ajrana Kalan B.O": "136130",
      "Sanghor B.O": "136156",
      "Bir Kalwa B.O": "136156",
      "Kakral Gujran B.O": "136030",
      "Ramgarh Ror B.O": "136030",
      "Seonsar B.O": "136030",
      "Chammu Kalan B.O": "136129",
      "Jalbehra B.O": "136129",
      "Thana B.O": "136030",
      "Naisi B.O": "136129",
      "Thaska Miranji B.O": "136129",
      "Bhusthala B.O": "136130",
      "Tangore B.O": "136130",
      "Jandola B.O": "136156",
      "Lakhmari B.O": "136156",
      "Bargat B.O": "136156",
      "Bhagwanpur B.O": "136156",
      "Dudhla B.O": "136156",
      "Kalal Majra B.O": "136156",
      "Bhor Saida B.O": "136119",
      "Dhurala B.O": "136119",
      "Gurukul B.O": "136119",
      "Hathira B.O": "136119",
      "Bapdi B.O": "136132",
      "Barout B.O": "136132",
      "Kalirano B.O": "136132",
      "Lohara B.O": "136132",
      "Niwarsi B.O": "136132",
      "Brahan BO": "136132",
      "Sirsala B.O": "136131",
      "Umri B.O": "136131",
      "Rattangarh B.O": "136135",
      "Rawa B.O": "136135",
      "Samalkhi B.O": "136135",
      "Sharif Garh B.O": "136135",
      "Ajrawar B.O": "136136",
      "Mandheri B.O": "136136",
      "Barna B.O": "136119",
      "Dabkheri B.O": "136119",
      "Hassanpur B.O": "136119",
      "Jyotisar B.O": "136119",
      "Kamoda B.O": "136119",
      "Kheri Ram Nagar B.O": "136119",
      "Gajlana B.O": "136132",
      "Kheri Dabdallan B.O": "136132",
      "Prahladpur B.O": "136132",
      "Karah B.O": "136128",
      "Murtzapur B.O": "136128",
      "Sandholi B.O": "136128",
      "Sarsa B.O": "136128",
      "Bodla B.O": "136131",
      "Khanpur Kolian B.O": "136131",
      "Deeg B.O": "136135",
      "Landi B.O": "136135",
      "Madanpur B.O": "136135",
      "Nalvi B.O": "136135",
      "Sudpur B.O": "136135",
      "Yara B.O": "136135",
      "Shanti Nagar B.O": "136136",
      "Bagthala B.O": "136119",
      "Gudha B.O": "136132",
      "Ishaq B.O": "136128",
      "Malikpur B.O": "136128",
      "Saina Saida B.O": "136128",
      "Urnai B.O": "136128",
      "Bir Mathana B.O": "136131",
      "Kohlapur B.O": "136131",
      "Palwal B.O": "136131",
      "Chaduni Jattan B.O": "136135",
      "Kharindwa B.O": "136135",
      "Nagla B.O": "136135",
      "Tigri B.O": "136135",
      "Kirmuch B.O": "136119",
      "Lukhi B.O": "136119",
      "Salarpur B.O": "136119",
      "Barwa B.O": "136119",
      "Bakali B.O": "136132",
      "Ban B.O": "136132",
      "Bakhli B.O": "136128",
      "Bhorakh B.O": "136128",
      "Bodhni B.O": "136128",
      "Diwana B.O": "136128",
      "Mathana B.O": "136131",
      "Golpura B.O": "136135",
      "Haripur B.O": "136135",
      "Jandheri B.O": "136135",
      "Kalsana B.O": "136135",
      "Kalyana B.O": "136135",
      "Ismailabad S.O": "136129",
      "Jhansa S.O": "136130",
      "Mohan Nagar S.O (Kurukshetra)": "136118",
      "Saraswati Mandir Pehowa S.O": "136128",
      "Judicial Complex Kurukshetra S.O": "136118",
      "Mohri S.O": "136134",
      "Kurukshetra University S.O": "136119",
      "Majri Mohalla Shahabad S.O": "136135",
      "Ngm Ladwa S.O": "136132",
      "Thanesar Town S.O": "136118",
      "Shahabad(M) S.O": "136135",
      "Gumthala Garhu S.O": "136030",
      "Ladwa S.O": "136132",
      "Pehowa S.O": "136128",
      "Pipli S.O": "136131",
      "R.E.C.K. S.O": "136119",
      "Sector 3 U E KKR S.O": "136118",
      "Thol S.O": "136136",
      "Babain S.O": "136156",
      "Birla Mandir S.O": "136118",
      "Kurukshetra H.O": "136118",
      "Amin S.O": "136038"
    },
    "KARNAL": {
      "Bahari B.O": "132039",
      "Bandarala B.O": "132039",
      "Biana B.O": "132054",
      "Nangal B.O": "132054",
      "Gagsina B.O": "132114",
      "Gudha B.O": "132114",
      "Kalron B.O": "132114",
      "HARI SINGH PUNDRI": "132114",
      "Khora Kheri B.O": "132114",
      "Arainpura B.O": "132114",
      "Sheikhpura Manchuri B.O": "132036",
      "Bajida Jattan B.O": "132037",
      "Barauta B.O": "132037",
      "Beejna B.O": "132037",
      "Aibla B.O": "132157",
      "Achhanpur B.O": "132024",
      "Agongh B.O": "132024",
      "Amupur B.O": "132024",
      "Bastali B.O": "132024",
      "Sirsi B.O": "132024",
      "Manjura B.O": "132024",
      "Bara Gaon B.O": "132023",
      "Gheer B.O": "132023",
      "Phaphrana B.O": "132046",
      "Sambhi B.O": "132116",
      "Saunkra B.O": "132116",
      "Bilona B.O": "132039",
      "Jai Singh Pura B.O": "132039",
      "Kheri Sarf Ali B.O": "132039",
      "Popran B.O": "132039",
      "Thal B.O": "132039",
      "Munak B.O": "132040",
      "Kalri Jagir B.O": "132054",
      "Bastara B.O": "132114",
      "Jamalpur B.O": "132114",
      "Kaimla B.O": "132114",
      "Raipur Jattan B.O": "132114",
      "Garhi Jattan B.O": "132041",
      "Johar Majra B.O": "132041",
      "Muradhgarh B.O": "132041",
      "Nagla Roran B.O": "132041",
      "Sanghowa B.O": "132041",
      "Kheri Naroo B.O": "132036",
      "Peont B.O": "132036",
      "Canal Colony B.O": "132001",
      "Jundla Gate B.O": "132001",
      "Khirajpur B.O": "132022",
      "Kutail B.O": "132037",
      "Dhakwala Gujran B.O": "132037",
      "S.P. Sohana B.O": "132037",
      "RASULPUR KHURD B.O": "132037",
      "Karsa Dod B.O": "132157",
      "Raison B.O": "132157",
      "Bairsal B.O": "132117",
      "Samana Bahu B.O": "132117",
      "Sidhpur B.O": "132117",
      "Thari B.O": "132046",
      "Bhaini Khrud B.O": "132116",
      "Padhana B.O": "132116",
      "Kachwa B.O": "132116",
      "Sagga B.O": "132116",
      "Ardhana B.O": "132039",
      "Chochra B.O": "132039",
      "Jalmana B.O": "132039",
      "Karsa Chor B.O": "132039",
      "Rahra B.O": "132039",
      "Uplana B.O": "132039",
      "Bal Rangan B.O": "132040",
      "Chogawan B.O": "132054",
      "Dabkoli Kalan B.O": "132054",
      "Kalsora B.O": "132054",
      "Barsat B.O": "132114",
      "Phurlak B.O": "132114",
      "S.P. Khalsa B.O": "132114",
      "Bibi Pur Jattan B.O": "132041",
      "Hanori B.O": "132041",
      "Pathera B.O": "132041",
      "Darar B.O": "132041",
      "Katleri B.O": "132036",
      "Padha B.O": "132036",
      "Picholia B.O": "132036",
      "Nalipar B.O": "132022",
      "Ghogripur B.O": "132037",
      "Uncha Samana B.O": "132037",
      "Phoosgarh B.O": "132037",
      "Ranwar B.O": "132037",
      "Jamba B.O": "132157",
      "Sitamai B.O": "132157",
      "Arjheri B.O": "132117",
      "Bhadson B.O": "132117",
      "Sandhir B.O": "132117",
      "Mehmal B.O": "132024",
      "Singhra B.O": "132024",
      "Subri B.O": "132023",
      "A.K.G.V.Mormajra B.O": "132046",
      "Kuruk Jagir B.O": "132116",
      "Nariana B.O": "132116",
      "Ramana Ramani B.O": "132116",
      "Shamgarh B.O": "132116",
      "Karna Lake B.O": "132116",
      "Uchana B.O": "132116",
      "Mardanheri B.O": "132039",
      "Chaura B.O": "132114",
      "Faridpur B.O": "132114",
      "Kohand B.O": "132114",
      "Lalupura B.O": "132114",
      "Staundi B.O": "132114",
      "Khanpur B.O": "132041",
      "Khera B.O": "132041",
      "Kheri Bhutan B.O": "132041",
      "Kheri Man Singh B.O": "132041",
      "Bansa B.O": "132036",
      "Chirao B.O": "132036",
      "Jani B.O": "132036",
      "Cssri B.O": "132001",
      "Dilawara B.O": "132037",
      "Ganjogarhi B.O": "132037",
      "Mohidinpur B.O": "132037",
      "Nagla Megha B.O": "132037",
      "Majra Rodan B.O": "132157",
      "Sanwat B.O": "132157",
      "Samlbhi B.O": "132157",
      "Sikri B.O": "132117",
      "Udana B.O": "132117",
      "Brass B.O": "132024",
      "Dachar B.O": "132024",
      "Gonder B.O": "132024",
      "Balu B.O": "132024",
      "Tikri B.O": "132023",
      "Goli B.O": "132046",
      "Kurlan B.O": "132046",
      "Ramba B.O": "132116",
      "Sultanpur B.O": "132116",
      "Karnal H.O": "132001",
      "Assandh S.O": "132039",
      "Ballah S.O": "132040",
      "Gharunda S.O": "132114",
      "Jundla S.O": "132036",
      "Karnal Model Town S.O": "132001",
      "Karnal New Prem Nagar S.O": "132001",
      "Karnal Partap Pura S.O": "132001",
      "Kunjpura S.O": "132022",
      "Mini sectt  sector 12 Kanral S.O": "132001",
      "Nigdhu S.O": "132157",
      "Salwan S.O": "132046",
      "Taraori S.O": "132116",
      "Madhuban S.O (Karnal)": "132037",
      "Nilokheri S.O": "132117",
      "S.S. Kunjpura S.O": "132023",
      "Garhi Birbal S.O": "132054",
      "Indri S.O": "132041",
      "Karnal Railway Road S.O": "132001",
      "Karnal Sector 6 S.O": "132001",
      "Madhuban PTC S.O": "132037",
      "Sector 8 Karnal S.O": "132001",
      "KARNAL KUTCHERY SO": "132001",
      "Indri Town S.O": "132041",
      "Kanral Industrial Area S.O": "132001",
      "Karnal GBS S.O": "132001",
      "Karnal HBC S.O": "132001",
      "Karnal NDRI S.O": "132001",
      "Karnal Ram Nagar S.O": "132001",
      "Karnal Sadar Bazar S.O": "132001",
      "Nissing S.O": "132024",
      "Sector 4 Karnal S.O": "132001",
      "Taroari Mandi S.O": "132116",
      "Nilokheri GIP S.O": "132117"
    },
    "SIRSA": {
      "Ahmedpur BO": "125055",
      "Chamal BO": "125055",
      "Jodhkan BO": "125055",
      "Madho Singhana BO": "125055",
      "Randhawa BO": "125055",
      "Kusumbhi BO": "125055",
      "Lehangewala BO": "125078",
      "Nagoki BO": "125078",
      "Jandwala Bishnoian BO": "125101",
      "Chadiwal BO": "125110",
      "Darba Kalan BO": "125110",
      "Gussiaiyana BO": "125110",
      "Suchan Kotli BO": "125055",
      "Bhuratwala BO": "125055",
      "Umedpura BO": "125055",
      "Keshopura BO": "125055",
      "Maujdin BO": "125055",
      "Gudia Kheda BO": "125055",
      "Bhiwan BO": "125078",
      "Jhorar Rohi BO": "125078",
      "Jamal BO": "125110",
      "Ludesar BO": "125110",
      "Bhamboor BO": "125055",
      "Ottu BO": "125055",
      "Arniawali BO": "125055",
      "Mallekan BO": "125055",
      "Kutewadh BO": "125055",
      "Jhiri BO": "125078",
      "Kurangawali BO": "125078",
      "Thiraj BO": "125078",
      "Asa Khera BO": "125101",
      "Chaharwala BO": "125110",
      "Hanziran BO": "125110",
      "Kagdana BO": "125110",
      "Chakarian BO": "125055",
      "Chattargarh Patti BO": "125055",
      "Ferozabad BO": "125055",
      "Mangala BO": "125055",
      "Jhornali BO": "125055",
      "Shahpur Begu BO": "125055",
      "Baruwalii BO": "125054",
      "Mauju Khera BO": "125102",
      "Patli Dabar BO": "125054",
      "Alika BO": "125078",
      "Anandgarh BO": "125078",
      "Bapp BO": "125078",
      "Bhadra BO": "125078",
      "Rupawas BO": "125110",
      "Shakar Mandori BO": "125110",
      "Khari Sureran BO": "125102",
      "Mirzapur BO": "125102",
      "Poharkan BO": "125102",
      "Banwala BO": "125103",
      "Keharwala BO": "125103",
      "Matdadu BO": "125103",
      "Jagmalwali BO": "125201",
      "Jalalana BO": "125201",
      "Takhatmal BO": "125201",
      "Taruana BO": "125201",
      "Khuiyana Malkana BO": "125104",
      "Mangiana BO": "125104",
      "Maujgarbh BO": "125104",
      "Sakta Khera BO": "125104",
      "Nuhiyanwali BO": "125077",
      "Sahuwala BO": "125077",
      "Sultanpuria BO": "125076",
      "Bharokhan BO": "125060",
      "Furwain Kalan BO": "125060",
      "Nozadela Kalan BO": "125060",
      "Phulkan BO": "125060",
      "Balasar BO": "125075",
      "Dudianwali BO": "125075",
      "Kariwala BO": "125075",
      "Sherpura BO": "125110",
      "Mochiwali BO": "125058",
      "Amritsar Kalan BO": "125102",
      "Berwala Khurd BO": "125102",
      "Mamera Kalan BO": "125102",
      "Mithanpura BO": "125102",
      "Bijuwali BO": "125103",
      "Chakkan BO": "125103",
      "Dadu BO": "125201",
      "Desu Mulkana BO": "125201",
      "Gadrana BO": "125201",
      "Pakka BO": "125201",
      "Phaggu BO": "125201",
      "Pipli BO": "125201",
      "Rori BO": "125201",
      "Abubshahar BO": "125104",
      "Chatha BO": "125104",
      "Dabwali Village BO": "125104",
      "Desu Jodha BO": "125104",
      "Mithri BO": "125104",
      "Shergarh BO": "125104",
      "Khairekan BO": "125077",
      "Nezadela Khurd BO": "125077",
      "Paniwala Mota BO": "125077",
      "Dohtar BO": "125076",
      "Jodhpuria BO": "125076",
      "Kharian BO": "125076",
      "Nanuana BO": "125076",
      "PANIHARI BO": "125060",
      "Banni BO": "125075",
      "Bharolianwali BO": "125075",
      "Damdama BO": "125075",
      "Dharampura BO": "125075",
      "Nathusari Kalan BO": "125110",
      "Sahuwala ii BO": "125110",
      "Kaluana BO": "125103",
      "Munnawali BO": "125103",
      "Rampur Bishnoian BO": "125103",
      "Lakarwali BO": "125201",
      "Surtia BO": "125201",
      "Habuana BO": "125104",
      "Lohgarh BO": "125104",
      "Paniwala Ruldu BO": "125104",
      "Panjuana BO": "125077",
      "Makhosarani BO": "125110",
      "Talwara Khurd BO": "125102",
      "Ganga BO": "125103",
      "Ghoranwali BO": "125103",
      "Risalia Khera BO": "125103",
      "Chakerian BO": "125201",
      "Singhpura BO": "125201",
      "Sukhchain BO": "125201",
      "Masitan BO": "125104",
      "Burj Bhangu BO": "125077",
      "Chormar BO": "125077",
      "Baidwala BO": "125060",
      "Bajekan BO": "125060",
      "Nakora BO": "125075",
      "Nathore BO": "125075",
      "Sant Nagar BO": "125075",
      "Darbi BO": "125060",
      "Moriwala BO": "125060",
      "Nezia Kheda BO": "125055",
      "Bahiya BO": "125075",
      "Haripura BO": "125075",
      "Thersahidan BO": "125075",
      "RASULPUR BO": "125060",
      "Sirsa HO": "125055",
      "Ellenabad SO": "125102",
      "Kalanwali SO": "125201",
      "Mandi Dabwali SO": "125104",
      "MiniSecttSirsa SO": "125055",
      "Sikander Pur SO": "125060",
      "Chautala SO": "125101",
      "Khairpur SO": "125055",
      "Odhan SO": "125077",
      "Rania SO": "125076",
      "Siri Jiwan Nagar SO": "125075",
      "Baragudha SO": "125078",
      "MTS Sirsa SO": "125055",
      "Nai Mandi Sirsa SO": "125055",
      "JCD Vidyapeeth Sirsa": "125056",
      "Bahaudin SO": "125054",
      "Begu Road Sirsa SO": "125055",
      "Chopta Nathu Sari SO": "125110",
      "Dabwali Town SO": "125104",
      "Ding SO": "125058",
      "Goriwala SO": "125103"
    },
    "PANIPAT": {
      "Dehra B.O": "132122",
      "Pardhana B.O": "132107",
      "Puther B.O": "132107",
      "Shahpur B.O": "132107",
      "Nara B.O": "132113",
      "Waisor B.O": "132113",
      "Chhajpur Kalan B.O": "132104",
      "Goela Kalan B.O": "132104",
      "Ugra Kheri B.O": "132104",
      "Chandoli B.O": "132104",
      "Nanhera B.O": "132104",
      "Babail B.O": "132104",
      "Barana B.O": "132104",
      "Noorwala B.O": "132104",
      "Panipat Kathery (U) B.O": "132104",
      "Rair Kalan B.O": "132140",
      "Babarpur B.O": "132140",
      "Kabri B.O": "132140",
      "Ganjbarh B.O": "132140",
      "Assan Kalan B.O": "132105",
      "Kalkha B.O": "132105",
      "Lohari B.O": "132105",
      "Sutana B.O": "132105",
      "Gandhi Samarak Nidhi B.O": "132102",
      "Mahoti B.O": "132102",
      "Beholi B.O": "132101",
      "Chulkana B.O": "132101",
      "Manana B.O": "132101",
      "Naraina B.O": "132101",
      "Dikadla B.O": "132122",
      "Karad B.O": "132107",
      "Urlana Kalan B.O": "132107",
      "Joshi B.O": "132113",
      "Qawi B.O": "132113",
      "Dadola B.O": "132108",
      "Pasina Kalan BO B.O": "132108",
      "Risalu B.O": "132104",
      "Jalalpur B.O": "132104",
      "Kurar B.O": "132104",
      "Rajkheri B.O": "132104",
      "Bursham B.O": "132106",
      "Dadlana B.O": "132140",
      "Jattal B.O": "132105",
      "Bhadar B.O": "132105",
      "Bhodwal Majri B.O": "132102",
      "Jaurasi B.O": "132101",
      "Machhrauli B.O": "132101",
      "Namunda B.O": "132101",
      "Khojkipur B.O": "132122",
      "Bandh B.O": "132107",
      "Buana Lakhu B.O": "132107",
      "Jondhan Kalan B.O": "132107",
      "Seenk B.O": "132107",
      "Allupur B.O": "132113",
      "Shera B.O": "132113",
      "Palri B.O": "132145",
      "Diwana B.O": "132108",
      "Siwaha B.O": "132108",
      "Bapoli B.O": "132104",
      "Sanauli Khurd B.O": "132104",
      "Binjhol B.O": "132106",
      "Untla B.O": "132105",
      "Shodapur B.O": "132105",
      "Karhans B.O": "132101",
      "Kiwana B.O": "132101",
      "Raksera B.O": "132115",
      "Ahar B.O": "132107",
      "Kurana B.O": "132107",
      "Mandi B.O": "132107",
      "Adyana B.O": "132113",
      "Bhandari B.O": "132113",
      "Ataula B.O": "132113",
      "Dahar B.O": "132145",
      "Didwari B.O": "132145",
      "PPT Camp No. 2 B.O": "132104",
      "Garhi Basic B.O": "132104",
      "Samalkha S.O": "132101",
      "Panipat H.O": "132103",
      "Patti Kalyana S.O": "132102",
      "Refinery Township Panipat SO": "132140",
      "Israna S.O": "132107",
      "Panipat Patel Nagar S.O": "132103",
      "Atta S.O": "132122",
      "Hathwala S.O": "132115",
      "Panipat Kishanpura S.O": "132103",
      "Panipat Kranti Nagar S.O": "132103",
      "Panipat Model Town S.O": "132103",
      "Panipat N.S.M. S.O": "132103",
      "Panipat Refinary S.O": "132140",
      "Panipat Sugar Mills S.O": "132103",
      "Madlauda S.O": "132113",
      "Neoltha S.O": "132145",
      "Panipat Beas Project S.O": "132108",
      "Panipat City S.O": "132103",
      "Panipat GT Road S.O": "132103",
      "Panipat NFL S.O": "132106",
      "Panipat Khadi Ashram S.O": "132104",
      "Panipat Thermal Project S.O": "132105"
    },
    "GURUGRAM": {
      "Raisina BO": "122102",
      "Rithoj BO": "122102",
      "Khera Khurampur BO": "122506",
      "Patil RS BO": "122506",
      "Sewari BO": "122506",
      "Sultanpur BO": "122506",
      "Budhera BO": "122505",
      "Dhankot BO": "122505",
      "Mankdola BO": "122505",
      "Wazipur BO": "122505",
      "Jatauli BO": "122504",
      "Karola BO": "122504",
      "Jasat BO": "122502",
      "Khandsa BO": "122004",
      "Carterpuri BO": "122017",
      "Baslambi BO": "122503",
      "Baspadamka BO": "122503",
      "Daulah BO": "122103",
      "Ghasera BO": "122103",
      "Ghungola BO": "122103",
      "Fazilpur BO": "122101",
      "Paltra BO": "122101",
      "Ghamroj BO": "122102",
      "Maruthi Kunj BO": "122102",
      "Moklawas BO": "122413",
      "Pathreri BO": "122413",
      "Bhangrola BO": "122505",
      "Jharsa BO": "122003",
      "Noorgarh BO": "122504",
      "Khatauli BO": "122414",
      "Lokra BO": "122414",
      "Kadarpur BO": "122101",
      "Damdama BO": "122102",
      "Pachgaon BO": "122413",
      "Sidhrawali BO": "122413",
      "TAJ NAGAR BO": "122506",
      "Gwal Pahari BO": "122003",
      "Smaspur BO": "122003",
      "Jataula BO": "122504",
      "Gudhana BO": "122504",
      "Pahari BO": "122502",
      "Inchhapuri BO": "122414",
      "Khor BO": "122414",
      "Sikanderpur BO": "122004",
      "Jamalpur BO": "122503",
      "Narhera BO": "122503",
      "Basai BO": "122006",
      "Bhirauti BO": "122103",
      "Lakhnaula BO": "122004",
      "Sikohpur BO": "122004",
      "Janaula BO": "122503",
      "Unchamajra BO": "122503",
      "Daultabad BO": "122006",
      "KherliLala BO": "122103",
      "Rewasan BO": "122103",
      "Garhi Wajidpur BO": "122103",
      "Teekli BO": "122101",
      "Kherla BO": "122102",
      "Bilaspur Khurd BO": "122413",
      "Dhani Chitarsain BO": "122413",
      "Wazirabad BO": "122003",
      "Khandewia BO": "122504",
      "Mehchana BO": "122504",
      "Sherpur BO": "122502",
      "Syed Shahpur BO": "122414",
      "Kherki Daula BO": "122004",
      "Kasan BO": "122051",
      "Gurgaon Village BO": "122006",
      "Gurgaon HO": "122001",
      "Bhondsi SO": "122102",
      "Badshahpur SO": "122101",
      "DLF QE SO": "122002",
      "Gurgaon Sector 17 SO": "122001",
      "Gurgaon South City I SO": "122001",
      "Gurgaon South City II SO": "122018",
      "Khalilpur SO": "122502",
      "Narsinghpur SO": "122004",
      "Nsg Camp Manesar SO": "122051",
      "Palam Road SO": "122015",
      "Shivaji Nagar SO Gurgaon": "122001",
      "Gurgaon Kty SO": "122001",
      "Gurgaon Sector 45 SO": "122003",
      "Mini Sectt SO": "122001",
      "Railwary Road SO": "122006",
      "DLF PhII SO": "122008",
      "DLF PhIII SO": "122010",
      "Farrukh Nagar SO": "122506",
      "Galleria DLFIV SO": "122009",
      "Garhi Harsaru SO": "122505",
      "Gurgaon Sector 56 SO": "122011",
      "Haillymandi SO": "122504",
      "Industrial Complex Dundahera SO": "122016",
      "Industrial Estate SO Gurgaon": "122007",
      "Nanukalan SO": "122414",
      "New Colony SO Gurgaon": "122001",
      "Sohna SO": "122103",
      "IMT Manesar SO": "122052",
      "Khandsa Road SO": "122001",
      "Palam Vihar SO Gurgaon": "122017",
      "Pataudi SO": "122503",
      "Vatika India Sec 82 SO": "122012",
      "D Block South City II Gurgaon": "122018",
      "Urban Estate Gurgaon SO": "122001",
      "Air Force SO": "122005",
      "Arjun Nagar SO": "122001",
      "Basai Road SO": "122001",
      "Bhorakalan SO": "122413",
      "CRPF Kadarpur SO": "122098"
    },
    "NUH": {
      "Sudaka BO": "122107",
      "Tain BO": "122107",
      "Tapkan BO": "122107",
      "Ujina BO": "122107",
      "Nai BO": "122508",
      "Shahchokha BO": "122508",
      "Sihri Singhalheri BO": "122508",
      "Sikrawa BO": "122508",
      "Singar BO": "122508",
      "Baghanki BO": "122105",
      "Dulawat BO": "122105",
      "Hasanpur BO": "122105",
      "Chharoda BO": "122105",
      "Goyla BO": "122105",
      "Hirwari BO": "122104",
      "Umra BO": "122108",
      "Akhera BO": "122107",
      "Kurthala BO": "122107",
      "Jamalgarh BO": "122508",
      "Naheda BO": "122508",
      "Rethath BO": "122508",
      "Khanpur Ghati BO": "122508",
      "Jaurasi BO": "122105",
      "Kalwari BO": "122105",
      "Agon BO": "122104",
      "Ferozepur Namak BO": "122107",
      "Malab BO": "122107",
      "Gulalta BO": "122508",
      "Lohinga Kalan BO": "122508",
      "Pingwan BO": "122508",
      "Chapera BO": "122103",
      "Kiranj BO": "122103",
      "Jhamuwas BO": "122105",
      "Mohamadpur Ahir BO": "122105",
      "Bewan BO": "122104",
      "Doha BO": "122104",
      "Rawli BO": "122104",
      "Bhadas BO": "122108",
      "Budarpur BO": "122108",
      "Mandikhera BO": "122108",
      "Moolthan BO": "122108",
      "Sakras BO": "122108",
      "Baded BO": "122508",
      "Badli BO": "122508",
      "Bichhor BO": "122508",
      "Bisru BO": "122508",
      "Indir Mewat BO": "122103",
      "Rojka Meo BO": "122103",
      "Rathiwas BO": "122105",
      "Sundh BO": "122105",
      "Mini Sectt NUH SO": "122107",
      "Ferozepur Jhirka SO": "122104",
      "Nagina SO Gurgaon": "122108",
      "Punhana SO": "122508",
      "Nuh SO": "122107",
      "Tauru SO": "122105"
    },
    "FARIDABAD": {
      "Badarpur Syed BO": "121101",
      "Kurali BO": "121101",
      "Alipur BO": "121101",
      "Manjhawali BO": "121101",
      "Bhainsrawali BO": "121101",
      "Bhuvapur BO": "121101",
      "Chandpur BO": "121101",
      "Faridpur BO": "121101",
      "Anangpur BO": "121003",
      "Dayalpur BO": "121004",
      "Dhauj BO": "121004",
      "Fatehpur Billoch BO": "121004",
      "Neemka BO": "121004",
      "Pali BO": "121004",
      "Panhera Khurd BO": "121004",
      "Sagarpur BO": "121004",
      "Bhaskola BO": "121002",
      "Gurukul Indraprashtha BO": "121003",
      "Baroli BO": "121004",
      "Jawan BO": "121004",
      "Mohna BO": "121004",
      "Seekri BO": "121004",
      "Tilpat BO": "121003",
      "Atali BO": "121004",
      "Chhainsa BO": "121004",
      "Deeg BO": "121004",
      "Fatehpur Tagga BO": "121004",
      "Gonchhi BO": "121004",
      "Machhgar BO": "121004",
      "Kheri Kalan BO": "121002",
      "Amarnagar SO Faridabad": "121003",
      "Faridabad City SO": "121002",
      "Faridabad Sector 12 SO": "121007",
      "Faridabad Sector 16a  SO": "121002",
      "Faridabad Sector 22 SO": "121005",
      "Faridabad Sector 3 SO": "121004",
      "Faridabad Sector 8 SO": "121006",
      "Industrial Area Faridabad SO": "121001",
      "Jawahar Colony Faridabad SO": "121005",
      "NIFM Faridabad SO": "121001",
      "Nh3 Faridabad SO": "121001",
      "Sector21D  SO": "121012",
      "Tigaon SO": "121101",
      "Faridabad NIT HO": "121001",
      "Chawla Colony Ballabgarh SO": "121004",
      "Escortsnagar Faridabad SO": "121007",
      "Faridabad Sector 15 SO": "121007",
      "Faridabad Sector 18 SO": "121002",
      "NTPCsector10 Faridabad SO": "121004",
      "Nhpc Colony Faridabad SO": "121010",
      "Sector55 PO": "121015",
      "SECTOR46": "121010",
      "Factory Area Faridabad SO": "121001",
      "Faridabad Sector 29 SO": "121008",
      "Faridabad Sector 9 SO": "121006",
      "Feroz Gandhi Nagar Faridabad SO": "121001",
      "GT Road Faridabad SO": "121006",
      "Nh2 Faridabad SO": "121001",
      "Nh4 Faridabad SO": "121001",
      "Sec91 SO": "121013",
      "Greater Faridabad PO": "121014",
      "Ballabgarh SO": "121004",
      "Faridabad Sector 16 SO": "121002",
      "Faridabad Sector 7 SO": "121006",
      "Mathura Road Faridabad SO": "121003",
      "Surajkund Faridabad SO": "121009"
    },
    "YAMUNANAGAR": {
      "Kalesar B.O": "135106",
      "Manglore B.O": "135102",
      "Marwa Kalan B.O": "135102",
      "Marwa Khurd B.O": "135102",
      "Mehar Majra B.O": "135101",
      "Sabapur B.O": "135101",
      "Bilauli B.O": "135103",
      "Darpur B.O": "135103",
      "Kot Kalsia B.O": "135103",
      "Lalheri Kalan B.O": "135103",
      "Balchhapar B.O": "135003",
      "Jroda B.O": "135003",
      "Khera B.O": "135003",
      "Mandhar B.O": "135133",
      "Udhamgarh B.O": "135003",
      "Hafizpur B.O": "135002",
      "Damla B.O": "135002",
      "Chhappar B.O": "133103",
      "Gadhaula B.O": "133103",
      "Alhar B.O": "135133",
      "Bakana B.O": "135133",
      "Banidi B.O": "135133",
      "Topra Kalan B.O": "135133",
      "Haveli B.O": "133204",
      "Laharpur B.O": "133204",
      "Mehmoodpur B.O": "133204",
      "Noshera B.O": "133204",
      "Fatehgarh Tumbi B.O": "133206",
      "Haibatpur B.O": "133206",
      "Kalanaur B.O": "135004",
      "Pansra B.O": "135004",
      "Malikpur Khadar B.O": "135106",
      "Tajewala B.O": "135106",
      "Chauli B.O": "135102",
      "Kopal Mochan B.O": "135102",
      "Mughalwali B.O": "135102",
      "Khadri B.O": "135101",
      "Rampur Khadar B.O": "135101",
      "Balachaur B.O": "135103",
      "Ledi B.O": "135103",
      "Taharpurkalan B.O": "135103",
      "Bherthal B.O": "135003",
      "Kharwan B.O": "135003",
      "Mussimbal B.O": "135003",
      "Pabni Kalan B.O": "135003",
      "Jagdholi B.O": "133103",
      "Talakaur B.O": "133103",
      "Bapa B.O": "135133",
      "Bhagu Majra B.O": "135133",
      "Jubbal B.O": "135133",
      "Khurdban B.O": "135133",
      "Pipliwala B.O": "133204",
      "Sadiqpur B.O": "133204",
      "Azizpur B.O": "133206",
      "Nagal Khajuri B.O": "135004",
      "Bakarwala B.O": "135021",
      "Muzafatkalan B.O": "135021",
      "Saran B.O": "133202",
      "Pipli Majra B.O": "135106",
      "Dayalgarh B.O": "135102",
      "Machrauli B.O": "135102",
      "Milakpur Banger B.O": "135102",
      "Amadalpur B.O": "135101",
      "Jaidhari B.O": "135101",
      "Salimpur Banger B.O": "135103",
      "Dadupur B.O": "135003",
      "Mehlanwali B.O": "135003",
      "Bhambol B.O": "133103",
      "Kalawar B.O": "133103",
      "Kandhari Kalan B.O": "133103",
      "Barsan B.O": "135133",
      "Bubka B.O": "135133",
      "Jathlana B.O": "135133",
      "Rasulpur B.O": "133204",
      "Safilpur B.O": "133204",
      "Shahpur Nurd B.O": "133206",
      "Khera Khurd B.O": "135004",
      "Deodhar B.O": "135021",
      "Basatianwala B.O": "135102",
      "Cagnoli B.O": "135102",
      "Fatehpur B.O": "135101",
      "Aurangabad B.O": "135002",
      "Harnaul B.O": "135002",
      "Gudhiana B.O": "133103",
      "Hangoli B.O": "133103",
      "Uncha Chandna B.O": "133103",
      "Chamrori B.O": "135133",
      "Ghillaur B.O": "135133",
      "Gumthala Rao B.O": "135133",
      "Hartan B.O": "135133",
      "Nachron B.O": "135133",
      "Silikalan B.O": "135133",
      "Salehpur B.O": "133204",
      "Shadi Pur B.O": "135004",
      "Nahar Pur B.O": "135004",
      "Yamunanagar H.O": "135001",
      "Bhudkalan S.O": "135106",
      "Bilaspur (Yamunanagar) S.O": "135102",
      "Chhachrauli S.O": "135103",
      "Jagadhri Court S.O": "135003",
      "Jagadhri S.O": "135003",
      "Jagdhari Work Shop S.O": "135002",
      "Sarawan S.O": "133206",
      "Yamuna Nagar Railway Station S.O": "135001",
      "Buriya S.O": "135101",
      "Mustafabad S.O (Yamuna Nagar)": "133103",
      "Parkash Chowk S.O": "135003",
      "Radaur S.O": "135133",
      "Jagadhri Town S.O": "135003",
      "Sadhaura S.O": "133204",
      "Thermal Colony Yamuna Nagar S.O": "135004",
      "Khirzrabad  East S.O": "135021",
      "Mud Hut Colony S.O": "135001",
      "Ram Pura Olony S.O": "135001",
      "Bhatia Nagar S.O": "135001",
      "Model Town S.O (Yamuna Nagar)": "135001",
      "Sugar Mill S.O": "135001"
    },
    "CHARKI DADRI": {
      "Bigowa BO": "127307",
      "Jhijhar BO": "127307",
      "Loharwara BO": "127307",
      "Morwala BO": "127307",
      "Gopi BO": "127308",
      "Mandhi Harya BO": "127312",
      "Aun BO": "127310",
      "Malkosh BO": "127025",
      "Bhagwi BO": "127307",
      "Arya Nagar BO": "127308",
      "Berla BO": "127312",
      "Chandwas BO": "127312",
      "Dalawas BO": "127308",
      "Nandha BO": "127308",
      "Dohka Harya BO": "127026",
      "Siswala BO": "127026",
      "Tiwala BO": "127026",
      "Kheri Bura BO": "127306",
      "Mankawas BO": "127306",
      "Neemli BO": "127306",
      "Chang Road BO": "127022",
      "Dudhwa BO": "127022",
      "Mauri BO": "127022",
      "Badhawana BO": "127310",
      "Misri BO": "127042",
      "Sanjarwas BO": "127042",
      "Sankror BO": "127042",
      "Atela Khurd BO": "127026",
      "Barsana BO": "127026",
      "Mehera BO": "127026",
      "Chappar BO": "127026",
      "Ghasola BO": "127306",
      "Kalyana BO": "127306",
      "Rawaldhi BO": "127306",
      "Sarupgarh BO": "127306",
      "Makrana BO": "127022",
      "Chandeni BO": "127310",
      "Rambass BO": "127312",
      "Bhagesari BO": "127307",
      "Badrai BO": "127312",
      "Dagroli BO": "127312",
      "Kadma BO": "127312",
      "Kakroli Sardara BO": "127308",
      "Khorda BO": "127308",
      "Charkhi BO": "127306",
      "Dhadhi Mandola BO": "127306",
      "Gudana Kalan BO": "127310",
      "Naurangabass Jattan BO": "127310",
      "Palari BO": "127310",
      "Ranila BO": "127042",
      "Badal BO": "127026",
      "Rasiwas BO": "127026",
      "Sarangpur B.O": "127026",
      "Dhani Phogat BO": "127306",
      "Imlota BO": "127306",
      "Paitawas Kalan BO": "127306",
      "Samaspur BO": "127306",
      "Dhadhi Adampur BO": "127310",
      "Jawa BO": "127310",
      "Pichopa Kalan BO": "127310",
      "Harodi BO": "127312",
      "Jewali BO": "127312",
      "Kari Dharani BO": "127308",
      "Kario Baniawalij BO": "127308",
      "Lad BO": "127308",
      "Chiriya SO": "127022",
      "Jhojhu SO": "127310",
      "Birhi Kalan SO": "127026",
      "Nihalgard PO": "127312",
      "Achina SO": "127307",
      "Charkhi  Dadri Hsgii SO": "127306",
      "Janta College Charkhi Dadri SO": "127306",
      "Sanwar SO Bhiwani": "127042",
      "Badhara SO": "127308",
      "Baund SO": "127025",
      "Charkhi Dadri City SO": "127306"
    },
    "BHIWANI": {
      "Bajina BO": "127111",
      "Devsar BO": "127111",
      "Roopgarh BO": "127311",
      "Dhirana BO": "127311",
      "Dhana Ladan Pur BO": "127311",
      "Rajgarh BO": "127311",
      "Baliali BO": "127032",
      "Matani BO": "127028",
      "Morka BO": "127028",
      "Noonsar BO": "127028",
      "Obra BO": "127028",
      "Patwan BO": "127028",
      "Sai BO": "127027",
      "Paposa BO": "127035",
      "Ratera BO": "127035",
      "Asalwas Marheta BO": "127030",
      "Bhangarh BO": "127030",
      "Dandama BO": "127030",
      "Chandawas BO": "127029",
      "Devrala BO": "127029",
      "Bamla BO": "127114",
      "Bardu Chaina BO": "127201",
      "Barwas BO": "127201",
      "Bisalwas BO": "127201",
      "Budhera BO": "127201",
      "Singhani BO": "127201",
      "Paju BO": "127201",
      "Kaila BO": "127309",
      "Kitlana BO": "127311",
      "Sandawa BO": "127043",
      "Dhanana BO": "127031",
      "Premnagar BO": "127031",
      "Paluwas BO": "127031",
      "Barsi BO": "127032",
      "Lohari Jatu BO": "127032",
      "Mithi BO": "127028",
      "Serla BO": "127028",
      "Surpura Khurd BO": "127028",
      "Rewari Khera BO": "127027",
      "Kirawar BO": "127035",
      "Dhabdhani BO": "127030",
      "Golpura BO": "127030",
      "Mandhana BO": "127032",
      "Milkpur BO": "127032",
      "Pur BO": "127032",
      "Siwara BO": "127032",
      "Rohnat BO": "127035",
      "Umarwas BO": "127030",
      "Lohani BO": "127029",
      "Kusumbhi BO": "127029",
      "Chahar Kalan BO": "127201",
      "Chahar Khurd BO": "127201",
      "Dhighawa Jattan BO": "127201",
      "Gignow BO": "127201",
      "Dhareru BO": "127309",
      "Fatehgarh Haryana BO": "127309",
      "Bhaini Kungar BO": "127041",
      "Jatai BO": "127041",
      "Kungar BO": "127041",
      "Siwana BO": "127041",
      "Bhariwas BO": "127043",
      "Bhushan BO": "127043",
      "Mandhan BO": "127043",
      "Gainadawas BO": "127046",
      "Ghanghala BO": "127046",
      "Gurera BO": "127046",
      "Jhumpa Kalan BO": "127046",
      "Daryapur BO": "127040",
      "Dulheri BO": "127040",
      "Garanpura Kalan BO": "127040",
      "Sagban BO": "127040",
      "Thilod BO": "127040",
      "Biran BO": "127111",
      "Dang BO": "127111",
      "Dinod BO": "127111",
      "Kohar BO": "127111",
      "Haluwas BO": "127311",
      "Nandgaon BO": "127311",
      "Durjanpur BO": "127032",
      "Sidhanwa BO": "127028",
      "Bhurtana BO": "127035",
      "Golagarh BO": "127030",
      "Pohkarwas BO": "127030",
      "Leghan BO": "127029",
      "Sungarpur BO": "127029",
      "Dhani Dhola BO": "127201",
      "Jhanjra Sheoran BO": "127201",
      "Kural BO": "127201",
      "Parvezpur BO": "127201",
      "Neemriwali BO": "127309",
      "Ajitpura BO": "127309",
      "Talu BO": "127041",
      "Bhera BO": "127043",
      "Jhully BO": "127043",
      "Hetampura BO": "127029",
      "Mansarbass BO": "127029",
      "Kalinga BO": "127114",
      "Fartia Bhima BO": "127201",
      "Kharkari BO": "127201",
      "Nakipur BO": "127201",
      "Sehar BO": "127201",
      "Sohansara BO": "127201",
      "Sanga BO": "127309",
      "Kaunt BO": "127309",
      "Isharwal BO": "127043",
      "Bidhwan BO": "127046",
      "Khera BO": "127046",
      "Miran BO": "127046",
      "Badesera BO": "127031",
      "Gujrani BO": "127031",
      "Sui BO": "127031",
      "Chappar Rangran BO": "127040",
      "Riwasa BO": "127040",
      "Mandholi Kalan BO": "127043",
      "Dhani Miran BO": "127046",
      "Kalod BO": "127046",
      "Lilas BO": "127046",
      "Mandholi Khurd BO": "127046",
      "Naloi BO": "127046",
      "Mitathal BO": "127031",
      "Dadam BO": "127040",
      "Dhani Mahu BO": "127040",
      "Khanak BO": "127040",
      "Kharkhari Sohan BO": "127040",
      "Bhiwani HO": "127021",
      "Behl SO": "127028",
      "Birla Colony Bhiwani SO": "127021",
      "Bus Stand Bhiwani SO": "127021",
      "Jamalpur SO Bhiwani": "127035",
      "Lohar Bazar SO": "127021",
      "Loharu SO": "127201",
      "Manheru SO": "127309",
      "Neemariwali PO": "127311",
      "Bapora SO": "127111",
      "Bawani Khera SO": "127032",
      "Bseh Bhiwani SO": "127021",
      "Chang SO": "127027",
      "Jalan Hospital Bhiwani SO": "127021",
      "Kharak Kalan SO": "127114",
      "Siwani SO": "127046",
      "Tigrana SO": "127031",
      "Tosham SO": "127040",
      "Halu Bajar Bhiwani SO": "127021",
      "Mundhal Khurd SO": "127041",
      "Barwa SO": "127045",
      "Jui Khurd SO": "127030",
      "Kairu SO": "127029",
      "Mini Sect Bhiwani SO": "127021",
      "Rodhan SO": "127043"
    }
  },
  "KERALA": {
    "THRISSUR": {
      "NODAL DELIVERY CENTER, THRISSUR": "680001",
      "Malakkapara BO": "680721",
      "KanjirappillyTCR BO": "680721",
      "Chalakudi R S BO": "680722",
      "Vijayaraghavapuram BO": "680722",
      "Krishnankotta BO": "680733",
      "Velupadam BO": "680303",
      "Edakulam BO": "680688",
      "Chentrappinni East BO": "680687",
      "Kannampallipuram BO": "680687",
      "Chaipankuzhi BO": "680724",
      "Eravathur BO": "680734",
      "Koovakkattukunnu BO": "680311",
      "Anandapuram BO": "680305",
      "Thottippal BO": "680310",
      "Konnakuzhy BO": "680721",
      "Poringalkuthu BO": "680721",
      "POOPATHY BO": "680733",
      "Nandikkara BO": "680301",
      "Chamakkala BO": "680687",
      "Cherpu Padinjattumuri BO": "680561",
      "Kalimbram BO": "680568",
      "Kuttamangalam BO": "680703",
      "Azhikode Jetty BO": "680666",
      "Madavana BO": "680666",
      "Porathissery BO": "680125",
      "Kaduppassery  South BO": "680683",
      "Koratti South BO": "680308",
      "Kuttikkad BO": "680724",
      "Mothirakkanni BO": "680724",
      "Vadama BO": "680732",
      "Kunnappilly BO": "680311",
      "Chokkana BO": "680699",
      "Vellikulangara BO": "680699",
      "CHIMMONI DAM BO": "680304",
      "Chattikulam BO": "680721",
      "Vettilappara BO": "680721",
      "Madathumpady BO": "680733",
      "Mannalamkunnu BO": "680518",
      "Kandanassery BO": "680102",
      "Blangad BO": "680506",
      "Kuranniyur BO": "680506",
      "Perakam BO": "680506",
      "Thiruvenkitam BO": "680101",
      "Chowannur BO": "680517",
      "Porkolangad BO": "680517",
      "Akathiyur BO": "680519",
      "Akkikavu BO": "680519",
      "Perumpilavu BO": "680519",
      "Chemmanthatta BO": "680501",
      "Chiranellur BO": "680501",
      "Eyyal BO": "680501",
      "Thalakkottukara BO": "680501",
      "Kunnamkulam City BO": "680523",
      "Kavida BO": "680505",
      "Madu BO": "680512",
      "Vattekkad BO": "680512",
      "Perumthuruthy BO": "680542",
      "Porkulam BO": "680542",
      "Brahmakulam BO": "680104",
      "Nemmini BO": "680104",
      "Kodannur BO": "680563",
      "Alapad BO": "680641",
      "Madakkathara BO": "680651",
      "Nettissery BO": "680651",
      "Anjur Mundur BO": "680541",
      "Avanur BO": "680541",
      "Ayyappankavu BO": "680751",
      "Mulayam BO": "680751",
      "Ollur Thaikkattussery BO": "680306",
      "Perinchery BO": "680306",
      "Ponnukkara BO": "680306",
      "Thalore BO": "680306",
      "Trikkur BO": "680306",
      "Chuvannamannu BO": "680652",
      "Kuttanellur BO": "680014",
      "Mannamangalam BO": "680014",
      "Marottichal BO": "680014",
      "Vettukad BO": "680014",
      "Nellikunnu BO": "680005",
      "Naduvilkkara BO": "680614",
      "Vatanapally Beach BO": "680614",
      "Kaliyarode BO": "680586",
      "Kurumala BO": "680586",
      "Painkulam BO": "679531",
      "Vettikkattiri RS BO": "679531",
      "Arangottukara BO": "679532",
      "Pallam Kottambathur BO": "679532",
      "Pallur BO": "679532",
      "Kuttanchery BO": "680584",
      "Thayyur BO": "680584",
      "Thichur BO": "680584",
      "Chiramanangad BO": "680604",
      "Pottore BO": "680581",
      "Tirur BO": "680581",
      "Kurumal BO": "680601",
      "Mundathicode BO": "680601",
      "Vellattanjur BO": "680601",
      "Velur Bazar BO": "680601",
      "Mundathicode West BO": "680623",
      "Elavally South BO": "680511",
      "Chemmannur BO": "680517",
      "Anjurkunnamkulam BO": "680523",
      "Thamarayur BO": "680505",
      "Vaka BO": "680602",
      "Chakkumkandam BO": "680522",
      "Annakara BO": "680508",
      "Thirunellur BO": "680508",
      "Kochannur BO": "679562",
      "Paralam BO": "680563",
      "Pullu BO": "680641",
      "Palissery BO": "680027",
      "Anchery BO": "680006",
      "Nedupuzha BO": "680007",
      "Kundukad BO": "680028",
      "Manalur HS BO": "680617",
      "Kozhukully BO": "680751",
      "Konikara BO": "680306",
      "Ollur North BO": "680306",
      "Pathiyarkulangara BO": "680552",
      "KootalaThrissur BO": "680652",
      "Vaniampara BO": "680652",
      "Chennaipara BO": "680653",
      "Chettupuzha BO": "680012",
      "Veluthur BO": "680012",
      "Kainoor BO": "680014",
      "Kolazhi RM BO": "680010",
      "Pangarappally BO": "680586",
      "Thonnurkkara BO": "680586",
      "Thalassery BO": "679532",
      "Karumathra BO": "680123",
      "Thekkumkara BO": "680589",
      "Katungode BO": "680584",
      "Minalur BO": "680581",
      "Poomala BO": "680581",
      "Kumbalacode BO": "680587",
      "Vennur BO": "680587",
      "Kumarappanal BO": "680585",
      "Tali BO": "680585",
      "Kiralur BO": "680601",
      "Parlikkad BO": "680623",
      "Vyasagiri BO": "680623",
      "Kakkassery BO": "680511",
      "Chittanjur BO": "680523",
      "Alur Mattom BO": "680602",
      "Nambazhikad BO": "680602",
      "Vayilathur BO": "679563",
      "Maruthayur BO": "680507",
      "Vemmanad BO": "680507",
      "Iringapuram BO": "680103",
      "Enamakkal BO": "680510",
      "Kannoth BO": "680510",
      "Eravu BO": "680620",
      "Ayyanthole North BO": "680003",
      "Nehrunagar BO": "680006",
      "Choolissery BO": "680541",
      "Tolurparappur BO": "680552",
      "Poovanchira BO": "680652",
      "West Fort BO": "680004",
      "Adat BO": "680551",
      "Edassery BO": "680569",
      "Thampankadavu BO": "680569",
      "Trithallur West BO": "680619",
      "Pulakode BO": "680586",
      "Venganellur BO": "680586",
      "Manalithara BO": "680589",
      "South Kondazhi BO": "679106",
      "Kanjirakode BO": "680590",
      "Attur BO": "680583",
      "Chelakode BO": "680587",
      "Kallepadam BO": "680587",
      "Malavattom BO": "680588",
      "Malesamangalam BO": "680588",
      "Pampady East BO": "680588",
      "Pampady West BO": "680588",
      "Thangalur BO": "680596",
      "Palayur BO": "680506",
      "Elavally BO": "680511",
      "Korattikkara BO": "680543",
      "Thippilissery BO": "680519",
      "Pengamuck BO": "680544",
      "Eranellur BO": "680501",
      "Pookode BO": "680505",
      "Mangad BO": "680542",
      "Chammannur BO": "679561",
      "Peruvallur BO": "680508",
      "KallurVadakkekkad BO": "679562",
      "Punnayur BO": "679562",
      "Padiyam BO": "680641",
      "Peringavu BO": "680008",
      "Chovvur BO": "680027",
      "Vadookkara BO": "680007",
      "Kattilapoovam BO": "680028",
      "Asarikkad BO": "680751",
      "Eravimangalam BO": "680751",
      "Avanisseri BO": "680306",
      "Marathakkara BO": "680306",
      "Edakkalathur BO": "680552",
      "Ponnore BO": "680552",
      "Kannara BO": "680652",
      "Manakkodi BO": "680012",
      "Chittilapilly BO": "680551",
      "Elanad BO": "680586",
      "Thozhupadam BO": "680586",
      "Netumpura BO": "679531",
      "Panjal BO": "679531",
      "Vazhani BO": "680589",
      "Chittissery BO": "680301",
      "Nenmenikkara BO": "680301",
      "Pootharakkal BO": "680561",
      "AzhikodeThrissur BO": "680666",
      "Avittathur BO": "680683",
      "Kaduppassery BO": "680683",
      "Kara BO": "680671",
      "Padinjare Vemballur BO": "680671",
      "Mambra BO": "680308",
      "Nalukettu BO": "680308",
      "Iranikulam BO": "680734",
      "Kottappuram Wri BO": "680584",
      "Nelluvaya BO": "680584",
      "Vellarakad BO": "680584",
      "Kuthampilly BO": "680594",
      "Kundannur BO": "680590",
      "Athani Thrissur BO": "680581",
      "Chottupara BO": "680581",
      "Peringandur BO": "680581",
      "Irunilamcode BO": "680583",
      "Vadakkethara BO": "680587",
      "Pattiparambu BO": "680588",
      "Kundur BO": "680734",
      "Kottamuri BO": "680732",
      "Kuruvilassery BO": "680732",
      "Pallipuram BO": "680732",
      "Murikkungal BO": "680699",
      "Elinjipra BO": "680721",
      "Kodassery BO": "680721",
      "Kanakamala BO": "680689",
      "Pazhayi BO": "680301",
      "Padiyur BO": "680688",
      "Chelur BO": "680121",
      "Chalingad BO": "680681",
      "Kaipamangalam Beach BO": "680681",
      "Koorikuzhi BO": "680681",
      "Pullur BO": "680683",
      "ALURKALLETTUMKARA BO": "680683",
      "Lokamaleswaram North BO": "680664",
      "Chittanda BO": "680585",
      "EdakkaraThrissur BO": "680518",
      "Pulakkad BO": "680585",
      "Panangattukara BO": "680623",
      "Puduruthy BO": "680623",
      "Anapuzha BO": "680667",
      "Nattikabeach BO": "680566",
      "Kannikulangara BO": "680682",
      "Kombathukadavu BO": "680682",
      "Puthenchira Kizhakkummuri BO": "680682",
      "Chulur BO": "680567",
      "Triprayar BO": "680567",
      "Valapad Beach BO": "680567",
      "Kalparamba BO": "680662",
      "Kottanallur BO": "680662",
      "Moorkkanad BO": "680711",
      "Kizhupillikkara BO": "680702",
      "Ponjanam BO": "680702",
      "Vallivattam BO": "680123",
      "Pathazhakkad BO": "680668",
      "INCHAMUDI BO": "680564",
      "Pazhuvil West BO": "680564",
      "Puthenchira Thekkummuri BO": "680682",
      "Karur BO": "680697",
      "Vallachira BO": "680562",
      "Thumbur BO": "680662",
      "Muriyad BO": "680683",
      "Panamkulam BO": "680711",
      "Karanchira BO": "680702",
      "Chazhur BO": "680571",
      "Thiruvanchikulam BO": "680664",
      "Santhipuram BO": "680668",
      "Kandamkulam BO": "680669",
      "Kurumbilavu BO": "680564",
      "Pullut North BO": "680663",
      "Vellani BO": "680701",
      "Arattupuzha BO": "680562",
      "Karayamvattam BO": "680567",
      "Karalam BO": "680711",
      "Chakkarappadam BO": "680686",
      "Perinjanam West BO": "680686",
      "Kuzhikkattussery BO": "680697",
      "Vellanchira BO": "680697",
      "AlathurThrissur BO": "680741",
      "Annallur BO": "680731",
      "Nandipulam BO": "680312",
      "Annanad BO": "680309",
      "Varakara BO": "680302",
      "Palayamparambu BO": "680741",
      "Poovathussery BO": "680741",
      "Inchakundu BO": "680312",
      "Mupliyam BO": "680312",
      "Chembuchira BO": "680684",
      "Manakulangara BO": "680684",
      "CHERUVALUR BO": "680308",
      "Muringoor Vadakkummuri BO": "680309",
      "Mattathurkkunnu BO": "680684",
      "Erayamkudi BO": "680308",
      "Koratti Kizhakkumuri BO": "680308",
      "Vattanathara BO": "680302",
      "Kottat BO": "680731",
      "Muttithadi BO": "680317",
      "Kadukutty BO": "680309",
      "Mattathur BO": "680684",
      "Kathikkudam BO": "680308",
      "Chalakudi HO": "680307",
      "Kunnamkulam HO": "680503",
      "Thrissur HO": "680001",
      "WadakancheryTC HO": "680582",
      "Irinjalakuda HO": "680121",
      "Alagappanagar SO": "680302",
      "Chalakudi South SO": "680307",
      "Chalakudi Town SO": "680307",
      "Kinfra Park Koratti SO": "680309",
      "Melur SO Thrissur": "680311",
      "Palappilly SO": "680304",
      "Perambrathrissur SO": "680689",
      "Poyya SO": "680733",
      "Varandarappilly SO": "680303",
      "Cherpu SO": "680561",
      "Edavilangu SO": "680671",
      "Irinjalakuda Mkt SO": "680121",
      "Irinjalakuda North SO": "680125",
      "Kallettumkara SO": "680683",
      "Karuvannur SO": "680711",
      "Koolimuttam SO": "680691",
      "Methala SO": "680669",
      "Ashtamichira SO": "680731",
      "Koratti SO": "680308",
      "Kuttichira SO": "680724",
      "Kuzhur SO": "680734",
      "Potta SO": "680722",
      "Pudukad SO": "680301",
      "Chentrappinni SO": "680687",
      "Edathirinji SO": "680122",
      "Eriyad SO": "680666",
      "Karupadanna SO": "680670",
      "Konathukunnu SO": "680123",
      "Kothaparamba SO": "680668",
      "Kottappuram SO": "680667",
      "Madayikonam SO": "680712",
      "Nadavaramba SO": "680661",
      "Nattika SO": "680566",
      "Panangad SO Thrissur": "680665",
      "Pazhuvil SO": "680564",
      "Peringottukara SO": "680565",
      "Perinjanam SO": "680686",
      "Thazhekkad SO": "680697",
      "Urakam SO": "680562",
      "Vellangallur SO": "680662",
      "Andathode SO": "679564",
      "Arthat SO": "680521",
      "Chengallur SO": "680312",
      "Malathrissur SO": "680732",
      "Edamuttam SO": "680568",
      "Edathuruthy SO": "680703",
      "Kaipamangalam SO": "680681",
      "Kattoor SO": "680702",
      "Kilakkummuri SO": "680571",
      "Kodungallur SO": "680664",
      "Pullut SO": "680663",
      "Thanissery SO": "680701",
      "Agalad SO": "680518",
      "Annamanada SO": "680741",
      "Kallur SO Thrissur": "680317",
      "Kodakara SO": "680684",
      "Nellayithrissur SO": "680305",
      "Pady SO": "680699",
      "Parappukkara SO": "680310",
      "Pariyaram SO Thrissur": "680721",
      "Aripalam SO": "680688",
      "Mathilakam SO": "680685",
      "Puthenchira SO": "680682",
      "Srinngapuram SO": "680664",
      "Vadakkummuri SO": "680570",
      "Valapad SO": "680567",
      "Ariyannur SO": "680102",
      "Kandassankadavu SO": "680613",
      "Pattikkad TC SO": "680652",
      "Kaiparamba SO": "680546",
      "Kanimangalam SO": "680027",
      "Kanjani SO": "680612",
      "Kuriachira SO": "680006",
      "Manalur SO": "680617",
      "Nadathara SO": "680751",
      "Ollukkara SO": "680655",
      "Parappur SO": "680552",
      "Poothole SO": "680004",
      "Kerala Agriuniversity SO": "680656",
      "Kurkancheri SO": "680007",
      "Kuruchikkara SO": "680028",
      "Kuttur SO Thrissur": "680013",
      "Mannuthy SO": "680651",
      "MundurTC SO": "680541",
      "Ollur SO": "680306",
      "Puranattukara SO": "680551",
      "Choondal SO": "680502",
      "Kanippayur SO": "680517",
      "Karikkad SO": "680519",
      "Paluvai SO": "680522",
      "Punnayurkulam SO": "679561",
      "Thozhiyur SO": "680520",
      "Ammadam SO": "680563",
      "Anthikad SO": "680641",
      "Aranattukara SO": "680618",
      "Ayyanthole SO": "680003",
      "Chavakkad SO": "680506",
      "Edakkaliyur SO": "680515",
      "Guruvayur Temple SO": "680101",
      "Kattakampal SO": "680544",
      "Koonamoochi SO": "680504",
      "Mattom SO": "680602",
      "Mullassery SO": "680509",
      "Nhamanghat SO": "679563",
      "Kanattukara SO": "680011",
      "Kundaliyur SO": "680616",
      "Peramangalam SO": "680545",
      "Pullazhi SO": "680012",
      "Punkunnu SO": "680002",
      "Puthenpeedika SO": "680642",
      "Orumanayur SO": "680512",
      "Puthanpalli SO": "680103",
      "Vadakkekad SO": "679562",
      "Elthuruth SO": "680611",
      "Peechi SO": "680653",
      "Chittattukara SO": "680511",
      "Kizhur SO": "680523",
      "Kottappadi SO": "680505",
      "Padoor SO": "680524",
      "Pazhanji SO": "680542",
      "Puvathur SO": "680508",
      "Thaikkad SO": "680104",
      "Tiruvatra SO": "680516",
      "Cherur SO": "680008",
      "Chiyyaram SO": "680026",
      "Guruvayur SO": "680101",
      "Kadappuram SO": "680514",
      "Kadavallur SO": "680543",
      "Kecheri SO": "680501",
      "Pavaratty SO": "680507",
      "Toyakkavu SO": "680513",
      "Venkitangu SO": "680510",
      "Amalanagar SO": "680555",
      "Arimpur SO": "680620",
      "Engandiyur SO": "680615",
      "Puzhakkal SO": "680553",
      "Talikulam SO": "680569",
      "Killimangalam SO": "680591",
      "Kondazhi SO": "679106",
      "Maruthancode SO": "680604",
      "Mulagunnathukavu SO": "680581",
      "Thiruvilwamala SO": "680588",
      "Thrissur Medical College SO": "680596",
      "Thiruvambady TSR SO": "680022",
      "Thrissur Engg College SO": "680009",
      "Trithallur SO": "680619",
      "Desamangalam SO": "679532",
      "Enkakad SO": "680589",
      "Mayannur SO": "679105",
      "PuthurThrissur SO": "680014",
      "Thrissur Central SO": "680001",
      "Thrissur City SO": "680020",
      "Thrissur R S SO": "680021",
      "Vatanappally SO": "680614",
      "Vellanikkara SO": "680654",
      "Kaniyarkod SO": "680594",
      "Kumaranellur TC SO": "680590",
      "Mullurkkara SO": "680583",
      "Pazhayannur SO": "680587",
      "WadakkancheriThrissur RS SO": "680623",
      "Ramavarmapuram SO": "680631",
      "Thrissur East SO": "680005",
      "Viyyur SO": "680010",
      "Chelakkara SO": "680586",
      "Cheruthuruthy SO": "679531",
      "Erumapetty SO": "680584",
      "Varavur SO": "680585",
      "Velur Thrissur SO": "680601"
    },
    "KANNUR": {
      "Madakkara B.O": "670301",
      "Muringeri BO": "670612",
      "Keezhallur BO": "670612",
      "Ottathai BO": "670571",
      "Udayagiri BO": "670571",
      "Vellad BO": "670571",
      "Vijayagiri BO": "670571",
      "Pooparamba BO": "670632",
      "Chunda BO": "670511",
      "Edavaramba BO": "670511",
      "Thirumeni BO": "670511",
      "Kottila BO": "670334",
      "Chuzhali BO": "670142",
      "Kanhirangad BO": "670142",
      "Koyyam BO": "670142",
      "Ettukudukka BO": "670521",
      "Ezhilode BO": "670309",
      "Kovvapuram BO": "670309",
      "Panapuzha BO": "670306",
      "Trichambaram BO": "670563",
      "Chithappilapoyil BO": "670502",
      "Thiruvattoor BO": "670502",
      "Annur BO": "670307",
      "Chamathachal BO": "670633",
      "Chandanakampara BO": "670633",
      "Kanhirakolly BO": "670633",
      "Malappattam BO": "670631",
      "Koorara BO": "670694",
      "Aniyaram BO": "670672",
      "Kuttikkakam BO": "670663",
      "Kalluvayal BO": "670703",
      "Vilakkode BO": "670703",
      "Eruvatty BO": "670642",
      "Malayampadi BO": "670674",
      "Santhigiri BO": "670674",
      "Kolithattu BO": "670706",
      "Kottayam Malabar BO": "670643",
      "Mangattidam BO": "670643",
      "Sankaranellur BO": "670643",
      "Kolari BO": "670702",
      "Mattanur College BO": "670702",
      "Porora BO": "670702",
      "Chendayad BO": "670692",
      "Mudiyanga BO": "670691",
      "Edapuzha BO": "670704",
      "Kakkengad BO": "670673",
      "Melmuringodi BO": "670673",
      "Vellarvelly BO": "670673",
      "Nedungome BO": "670631",
      "Peringome BO": "670353",
      "Pullookkara BO": "670672",
      "Kizhakke Kadirur BO": "670642",
      "Atakkathode BO": "670674",
      "Chettiamparamba BO": "670674",
      "Kanichar BO": "670674",
      "Randamkadavu BO": "670706",
      "Manantheri BO": "670643",
      "Mooriyad BO": "670643",
      "Pachapoika BO": "670643",
      "Chavasseri BO": "670702",
      "Kanhileri BO": "670702",
      "Kara Peravoor BO": "670702",
      "Kayani B.O": "670702",
      "Ambilat BO": "670701",
      "Melurtly BO": "670661",
      "Mokeri BO": "670692",
      "Puthurpanoor BO": "670692",
      "Perundattil BO": "670107",
      "Keezhuriritty BO": "670703",
      "Padiyurkannur BO": "670703",
      "Punnad BO": "670703",
      "Angadikadavu BO": "670706",
      "Perinkeri BO": "670706",
      "Chunkakunnu BO": "670651",
      "Naduvanad BO": "670702",
      "Thillenkeri BO": "670702",
      "Uliyil BO": "670702",
      "Uruvachal BO": "670702",
      "Vadakkumbad BO": "670105",
      "Mallannur BO": "670701",
      "Neerveli BO": "670701",
      "Palaparamba BO": "670701",
      "Koomanthode BO": "670704",
      "Mundayamparamba BO": "670704",
      "Payam East BO": "670704",
      "Veerpad BO": "670704",
      "Puliyanambram BO": "670675",
      "Mambram BO": "670741",
      "Parapram BO": "670741",
      "Kalanki BO": "670705",
      "Manikkadavu BO": "670705",
      "Manippara BO": "670705",
      "Kavumbhagam BO": "670649",
      "Kidanhi BO": "670675",
      "Kurichiyil BO": "670102",
      "Narikkodmala BO": "670693",
      "Vattiamthode BO": "670705",
      "Alacherry BO": "670650",
      "Kannavam Colony BO": "670650",
      "Rayarom BO": "670571",
      "Kayalampara BO": "670632",
      "Nellikutty BO": "670632",
      "Eruvattychapparapadava BO": "670581",
      "Kooveri BO": "670581",
      "Josegiri BO": "670511",
      "Kanul BO": "670562",
      "Kurumathur BO": "670142",
      "Muyyam BO": "670142",
      "Kakkara BO": "670306",
      "Vellora BO": "670306",
      "Areekamala BO": "670582",
      "Pulkurumba BO": "670582",
      "Vayattuparamba BO": "670582",
      "Eramam Desom BO": "670307",
      "Kandankali BO": "670307",
      "Mathil BO": "670307",
      "Payyanur RS BO": "670307",
      "Vellur BO": "670307",
      "Pazhassikari BO": "670633",
      "Ettikulam BO": "670308",
      "Vadakkumbadramanthali BO": "670308",
      "Chengalayi BO": "670631",
      "Kaithapram BO": "670631",
      "Therthally BO": "670571",
      "Chundakunnu BO": "670632",
      "Eruvassi BO": "670632",
      "Karippal BO": "670581",
      "Padappangad BO": "670581",
      "Thadikadavu BO": "670581",
      "Thimirichepparapadava BO": "670581",
      "Kozhichal BO": "670511",
      "Prapoil BO": "670511",
      "Thabore BO": "670511",
      "Thattummal BO": "670511",
      "Panniyur BO": "670142",
      "Kozhummal BO": "670521",
      "Kuniyan BO": "670521",
      "Eriam BO": "670306",
      "Kuttur BO": "670306",
      "Mathamangalam BO": "670306",
      "Kudiyanmala BO": "670582",
      "Mandalam BO": "670582",
      "Pottampilavu BO": "670582",
      "Nanicherry BO": "670563",
      "Aril BO": "670143",
      "Kandoth BO": "670307",
      "Kankol BO": "670307",
      "Kavvayi BO": "670307",
      "Korom BO": "670307",
      "Chempanthotty BO": "670631",
      "Cherikode BO": "670631",
      "Karthikapuram BO": "670571",
      "Kottayad BO": "670571",
      "Vayannur BO": "670650",
      "Kadamburkannur BO": "670663",
      "Madathil BO": "670703",
      "Manathana BO": "670674",
      "Vellunni BO": "670674",
      "Charal BO": "670706",
      "Kacherikadavu BO": "670706",
      "Koottupuzha BO": "670706",
      "Ambayathode BO": "670651",
      "Ayithara Mambram BO": "670643",
      "Keecheri BO": "670702",
      "Malur BO": "670702",
      "Pazhassiraja Nagar BO": "670702",
      "Sivapuram BO": "670702",
      "Elangot BO": "670692",
      "Kottayampoil BO": "670691",
      "Aralam BO": "670704",
      "Keezhpalli BO": "670704",
      "Velimanam BO": "670704",
      "Aralam Farm BO": "670673",
      "Kolakkad BO": "670673",
      "Mekkunnu BO": "670675",
      "Pathiriyad BO": "670741",
      "Ponniam BO": "670641",
      "Punnol BO": "670102",
      "Vilakkottur BO": "670693",
      "Nuchiyad BO": "670705",
      "Parikkalam BO": "670705",
      "Pathampara BO": "670571",
      "Kuniyampuzha BO": "670632",
      "Edakkom BO": "670581",
      "Kanamvayal BO": "670511",
      "Kuttikol BO": "670562",
      "Kuttiyeri BO": "670142",
      "Pallivayal BO": "670142",
      "Olayampadi BO": "670306",
      "Porakunnu BO": "670306",
      "Arang BO": "670582",
      "Kuppamtaliparamba BO": "670502",
      "Chalakkod BO": "670307",
      "Kanayi BO": "670307",
      "Karanthat BO": "670308",
      "Kootumugham BO": "670631",
      "Nediyanga BO": "670631",
      "Nhekly BO": "670353",
      "Padiotchal BO": "670353",
      "Panniyannur BO": "670671",
      "Vayalalam BO": "670671",
      "Pukkotkba BO": "670691",
      "Muzhakunnu BO": "670673",
      "Perumpunna BO": "670673",
      "Tholambra BO": "670673",
      "Thondiyil BO": "670673",
      "Cheruparamba BO": "670693",
      "Kallikandy BO": "670693",
      "Poyilur BO": "670693",
      "Moozhikkara BO": "670103",
      "Arabi BO": "670705",
      "Kannoth BO": "670650",
      "Kolayad BO": "670650",
      "Nedumpoil BO": "670650",
      "Peruva BO": "670650",
      "Poolakutty BO": "670650",
      "Cheruvancheri BO": "670650",
      "Palakode BO": "670305",
      "Alakodekuttaramba BO": "670571",
      "Arivilanjapoyil BO": "670571",
      "Chittodi BO": "670571",
      "Karuvanchal BO": "670571",
      "Manakadavu BO": "670571",
      "Nellipara BO": "670571",
      "Vengad BO": "670612",
      "Keezhara BO": "670301",
      "Thavam BO": "670301",
      "Thekkumbad BO": "670301",
      "Elampara BO": "670595",
      "Pattanur BO": "670595",
      "Koyyode BO": "670621",
      "Poduvachery BO": "670621",
      "Kanhirode BO": "670592",
      "Mullakodi BO": "670602",
      "Pavanoormotta BO": "670602",
      "Anchampeedika BO": "670331",
      "Makreri BO": "670622",
      "Nareekamvally BO": "670504",
      "Kadannapally BO": "670504",
      "Azhikode South BO": "670009",
      "Attadappa BO": "670006",
      "Munderi BO": "670591",
      "Kalliad BO": "670593",
      "Peruvalathuparamba BO": "670593",
      "Mavilayi BO": "670622",
      "Chattuvapara BO": "670592",
      "Kandakai BO": "670602",
      "Kuttiattur BO": "670602",
      "Iriveri BO": "670613",
      "Aroli BO": "670561",
      "Sreestha BO": "670303",
      "Vilayancode BO": "670504",
      "Azhikkal BO": "670009",
      "Cherukunnu RS BO": "670301",
      "Irinavu BO": "670301",
      "Kappad BO": "670006",
      "Chala East BO": "670621",
      "Kottali BO": "670005",
      "Cheleri BO": "670604",
      "Kannookara BO": "670012",
      "Cherupazhassi BO": "670601",
      "Chekkikulam BO": "670592",
      "Bavode BO": "670622",
      "Pappinisseri West BO": "670561",
      "Kizhunna BO": "670007",
      "Mundayad BO": "670594",
      "Othayammadom BO": "670301",
      "Chirakkal RS BO": "670011",
      "Kattampally BO": "670011",
      "Kusavanvayal BO": "670593",
      "Katalayi BO": "670003",
      "Narath BO": "670601",
      "Muzhappala BO": "670611",
      "Kayaralam BO": "670602",
      "Morazha BO": "670331",
      "Thalassery HO": "670101",
      "Kannur HO": "670001",
      "Taliparamba HO": "670141",
      "Chalil SO": "670102",
      "Champad SO": "670694",
      "Chokli SO": "670672",
      "Etakkad SO": "670663",
      "Kadavathur SO": "670676",
      "Kadirurtly SO": "670642",
      "New Mahe SO": "673311",
      "Pinarayi SO": "670741",
      "Cherakkara SO": "670104",
      "Kariyad South SO": "673316",
      "Kelakam SO": "670674",
      "Kottiyur SO": "670651",
      "Muzhappilangad SO": "670662",
      "Nirmalagiri SO": "670701",
      "Panoor SO": "670692",
      "Paral SO": "670671",
      "Peringadi SO": "673312",
      "Thalassery Courts SO": "670101",
      "Ulikkal SO": "670705",
      "Temple Gate SO": "670102",
      "Thalassery Bazar SO": "670101",
      "Thuvakunnu SO": "670693",
      "Kannur International Airport S.O": "670708",
      "Chittariparamba SO": "670650",
      "Eranholi SO": "670107",
      "Mattanur SO": "670702",
      "Nettur SO Kannur": "670105",
      "Palayad SO": "670661",
      "Payam SO": "670704",
      "Dharmadam SO": "670106",
      "Iritty SO": "670703",
      "Kiliyanthara SO": "670706",
      "Kuthuparamba SO": "670643",
      "Olavilam SO": "673313",
      "Pathayakunnu SO": "670691",
      "Peravoor SO": "670673",
      "Peringathur SO": "670675",
      "Ponniam West SO": "670641",
      "Tiruvangad SO": "670103",
      "Ummenchira SO": "670649",
      "Cherukunnu SO": "670301",
      "Chirakkal SO": "670011",
      "Chovva SO": "670006",
      "Kannur Thana SO": "670012",
      "Mowancheri SO": "670613",
      "Payangadi R S SO": "670358",
      "Pilathara SO": "670504",
      "Anjarakandy SO": "670612",
      "Eachur SO": "670591",
      "Irukkur SO": "670593",
      "Kannur City SO": "670003",
      "Mottammal SO": "670331",
      "Mundalur SO": "670622",
      "Pallikunnu SO": "670004",
      "Pappinisseri SO": "670561",
      "Payyambalam SO": "670001",
      "Vengarakannur SO": "670305",
      "Alakode SO": "670571",
      "Edat SO": "670327",
      "Kannur University Campus SO": "670567",
      "Karivellur SO": "670521",
      "Naduvil SO": "670582",
      "Talap SO Kannur": "670002",
      "Ezhimala Naval Academy SO": "670310",
      "Ezhome SO": "670334",
      "Kunhimangalam SO": "670309",
      "Mathamangalam Bazar SO": "670306",
      "Payyanur SO": "670307",
      "Sreekandapuram SO": "670631",
      "CRPF Camp Aravanchal SO": "670353",
      "Alavil SO": "670008",
      "Azhikode SO": "670009",
      "Chalad SO": "670014",
      "Civil Station Kannur SO": "670002",
      "Edayannur SO": "670595",
      "Kakkat SO": "670005",
      "Kannadiparamba SO": "670604",
      "Kannur District Hospital SO": "670017",
      "Koodali SO": "670592",
      "Madayi SO": "670304",
      "Mandurkannur SO": "670501",
      "Mayyil SO": "670602",
      "Thottada SO": "670007",
      "Valapattanam SO": "670010",
      "Chepparapadava SO": "670581",
      "Cherupuzha SO": "670511",
      "Kalliasseri SO": "670562",
      "Karimbam SO": "670142",
      "Kokkanisseri SO": "670307",
      "Parassinikadavu SO": "670563",
      "Burnacherry SO": "670013",
      "Kadachira SO": "670621",
      "Kannur Railway Station SO": "670001",
      "Kolacherry SO": "670601",
      "Mamba SO": "670611",
      "Mattul North SO": "670325",
      "Mattul SO": "670302",
      "Payangadi SO": "670303",
      "Thazhe Chovva SO": "670018",
      "Varam SO": "670594",
      "Kannur NDC": "670051",
      "Chemperi SO": "670632",
      "Pariyaram Medical College SO": "670503",
      "Pariyaramkannur SO": "670502",
      "Pattuvam SO": "670143",
      "Payyavur SO": "670633",
      "Ramanthali SO": "670308"
    },
    "ERNAKULAM": {
      "Kakkanad NDC": "682052",
      "Kalamassery Development Plot BO": "683104",
      "Rajagiri BO": "683104",
      "Vallarpadam BO": "682504",
      "Kumbalam BO": "682506",
      "Bhaktanandapuram BO": "682308",
      "Ezhakkaranadu South BO": "682308",
      "Meempara BO": "682308",
      "Kokkappilly BO": "682305",
      "Amballur BO": "682315",
      "Paingarapilly BO": "682314",
      "Perumpilly BO": "682314",
      "Eroor West BO": "682306",
      "Kusumagiri BO": "682030",
      "Chethicode BO": "682315",
      "Pulickamaly BO": "682314",
      "Vettickal BO": "682314",
      "Thiruvaniyoor BO": "682308",
      "Varikoli BO": "682308",
      "Kadungamangalam BO": "682305",
      "Kakkanad West BO": "682030",
      "Thengod BO": "682030",
      "Marithazham BO": "682315",
      "Thalacode BO": "682314",
      "Ezhakkaranad BO": "682308",
      "Poothrikka BO": "682308",
      "Vadayampadi BO": "682308",
      "Kandanad BO": "682305",
      "Vadacode Kailas Colony BO": "682021",
      "Manjummel BO": "683501",
      "Andikkadavu BO": "682008",
      "Neericode BO": "683511",
      "Panaikulam BO": "683511",
      "Aluvaasokapuram BO": "683101",
      "Thuravoor BO": "683572",
      "Nedumbassery BO": "683585",
      "SAduvassery BO": "683578",
      "Malayidumthuruth BO": "683561",
      "Mattoor BO": "683574",
      "Piraroor BO": "683574",
      "Thuravumkara BO": "683575",
      "Vattaparambu BO": "683579",
      "Kalady Plantation BO": "683581",
      "Elanthikara BO": "683594",
      "Vellarappilly South BO": "683580",
      "Mutholapuram BO": "686665",
      "Perumbadavam BO": "686665",
      "Ayavana BO": "686668",
      "Kadayirippu BO": "682311",
      "Kinginimattom BO": "682311",
      "Edayar BO": "686662",
      "Karimpana BO": "686662",
      "Marika BO": "686662",
      "Palakuzha BO": "686662",
      "Manary BO": "686673",
      "Perumballoor BO": "686673",
      "Kureekad BO": "682305",
      "Mamala BO": "682305",
      "Kochi Palace BO": "682301",
      "South Paravoor BO": "682307",
      "Vilangu BO": "683561",
      "Kottuvally BO": "683519",
      "Pattimattam BO": "683562",
      "Kongorpilly BO": "683518",
      "Airoor BO": "683579",
      "Ayyampuzha BO": "683581",
      "Chully BO": "683581",
      "Thathappilly BO": "683520",
      "Manjaly BO": "683520",
      "Azhakam BO": "683577",
      "Ezhattumugham BO": "683577",
      "Gothuruthy BO": "683516",
      "Maliankara BO": "683516",
      "West Kadungalloor BO": "683110",
      "Desom BO": "683102",
      "Meenkunnam BO": "686672",
      "Nagapuzha BO": "686668",
      "Thazhvankunnam BO": "686668",
      "Kadakkanad BO": "682311",
      "Karamala BO": "686662",
      "Mekkadambu BO": "682316",
      "Mazhuvannoor South BO": "686669",
      "Marady East BO": "686673",
      "Mulavoor BO": "686673",
      "Nirmala BO": "686673",
      "Puthupadi BO": "686673",
      "Nadakkavu BO": "682307",
      "Kaninad BO": "682310",
      "Pancode BO": "682310",
      "Kidangoor BO": "683572",
      "Nayathode BO": "683572",
      "Puliyanam BO": "683572",
      "Manickamangalam BO": "683574",
      "Naduvattam BO": "683574",
      "Neeleeswaram BO": "683574",
      "Paduvapuram BO": "683576",
      "Peringala BO": "683565",
      "Vempilly BO": "683565",
      "Anapparakalady BO": "683581",
      "Ezhikkara BO": "683513",
      "Nanthiattukunnam BO": "683513",
      "Marampally BO": "683105",
      "Kunjithai BO": "683522",
      "Kaloor BO": "686668",
      "Kavakkad BO": "686668",
      "Thirumarady BO": "686662",
      "Randar BO": "686673",
      "Thekkenmarady BO": "686673",
      "Vazhappilly East BO": "686673",
      "Vadacode BO": "682021",
      "Thekkumbhagom BO": "682301",
      "Poothotta BO": "682307",
      "Kuttikkattukara BO": "683501",
      "Karumalloor BO": "683511",
      "West Veliyathunad BO": "683511",
      "Elavoor BO": "683572",
      "Vappalassery BO": "683572",
      "Kunnukara BO": "683578",
      "Edathala North BO": "683561",
      "Yordhanapuram BO": "683574",
      "Parappuram BO": "683575",
      "Pazhamthottam BO": "683565",
      "Parakkadavu BO": "683579",
      "Thabore BO": "683577",
      "KuthiathodeEKM BO": "683594",
      "Uliyannoor BO": "683108",
      "South Vazhakulam BO": "683105",
      "Varapuzha Landing BO": "683517",
      "Memadangu BO": "686672",
      "Pandappily BO": "686672",
      "Kadamattam BO": "682311",
      "Karukappilli BO": "682311",
      "Kakkoor BO": "686662",
      "Kizhakompu BO": "686662",
      "Oliyapuram BO": "686662",
      "Mazhuvannoor BO": "686669",
      "Nellad BO": "686669",
      "Enanalloor BO": "686673",
      "Muvattupuzha Bazar BO": "686673",
      "Pezhakkappilly BO": "686673",
      "Mannathur BO": "686667",
      "Nechoor BO": "686664",
      "Chathamattam BO": "686671",
      "Kadavoor BO": "686671",
      "Kizhmuri BO": "686663",
      "Vadakodevazhakulam BO": "686670",
      "Bhoothathankettu BO": "686681",
      "Inchathotty BO": "686681",
      "Mamalakandom BO": "686681",
      "Thattekkad BO": "686681",
      "Alattuchira BO": "683544",
      "Periapuram BO": "686667",
      "Kakkad BO": "686664",
      "Kalampoor BO": "686664",
      "Manidu BO": "686664",
      "Paingattoor BO": "686671",
      "Pallarimangalam BO": "686671",
      "Mamalassery BO": "686663",
      "Vaikkara BO": "683549",
      "Keerampara BO": "686681",
      "Koovappara BO": "686681",
      "Kuttampuzha BO": "686681",
      "Malipara BO": "686681",
      "Pooyamkutty BO": "686681",
      "Urulanthanni BO": "686681",
      "Vadattupara BO": "686681",
      "Pulluvazhi BO": "683541",
      "Thrikkalathoor BO": "683541",
      "Anchelpetty BO": "686667",
      "North Piramadom BO": "686667",
      "Mulakulam BO": "686664",
      "Pazhoor BO": "686664",
      "Koovalloor BO": "686671",
      "Ooramana BO": "686663",
      "Kadalikkad BO": "686670",
      "Idamalayar BO": "686681",
      "Njayapalli BO": "686681",
      "Vettampara BO": "686681",
      "Aimurikara BO": "683544",
      "Onakkoor BO": "686667",
      "Pulinthanam BO": "686671",
      "Avoly BO": "686670",
      "Madakkathanam BO": "686670",
      "Mullapuzhachal BO": "686670",
      "Airapuram BO": "683541",
      "Karukadom BO": "686691",
      "Kozhipilly BO": "686691",
      "Methala BO": "683545",
      "Nedungapra BO": "683545",
      "Vengola BO": "683556",
      "Cheruvattoor BO": "686691",
      "Aruvappara BO": "683545",
      "Thuruthy BO": "683545",
      "Paniely BO": "683546",
      "Kumbalangi South BO": "682007",
      "Nedungad BO": "682509",
      "Edavoor BO": "683544",
      "Illambakapalli BO": "683544",
      "Kodanad BO": "683544",
      "Kuthukuzhy BO": "686691",
      "Nellikuzhy BO": "686691",
      "Varapetty BO": "686691",
      "Ponjassery BO": "683547",
      "Neendapara BO": "686693",
      "Oonnukal BO": "686693",
      "Pareekanni BO": "686693",
      "Thalakode BO": "686693",
      "Kottappady BO": "686692",
      "Panipra BO": "686692",
      "Plamudi BO": "686692",
      "Allapra BO": "683556",
      "Choondakuzhy BO": "683546",
      "Kombanad BO": "683546",
      "Mudakuzha BO": "683546",
      "CheranalloorPBR BO": "683544",
      "Iramalloor BO": "686691",
      "Kothamangalam Bazar BO": "686691",
      "Nadukani BO": "686691",
      "Rayamangalam BO": "683545",
      "Manikinar BO": "686693",
      "Neriamangalam BO": "686693",
      "PerumannoorKGM BO": "686693",
      "Airoopadam BO": "686692",
      "Pindimana BO": "686692",
      "Vengola West BO": "683556",
      "Chellanam BO": "682008",
      "SChellanam BO": "682008",
      "Azheekal BO": "682508",
      "Palluruthy South BO": "682006",
      "Nazreth BO": "682507",
      "Puthuvype BO": "682508",
      "Brahmapuram BO": "682303",
      "Kanayannoor BO": "682312",
      "Kuzhiyara BO": "682312",
      "Karimugal BO": "682303",
      "Edakkattuvayal BO": "682313",
      "Thirumarayoor BO": "682313",
      "Eroor South BO": "682306",
      "Veliyanad BO": "682313",
      "Kadamakudi BO": "682027",
      "Kothad BO": "682027",
      "Pizhala BO": "682027",
      "Kaipatoor BO": "682313",
      "Edapally North BO": "682024",
      "Thuruthippuram BO": "680667",
      "Ernakulam HO": "682011",
      "Kochi HO": "682001",
      "Muvattupuzha HO": "686661",
      "Aluva HO": "683101",
      "Perumbavoor HO": "683542",
      "Alangad SO": "683511",
      "Aluva Town Bus Stand SO": "683101",
      "Angamally South SO": "683573",
      "Athani SO Ernakulam": "683585",
      "Binanipuram SO": "683502",
      "Chendamangalam SO": "683512",
      "Chengamanad SO": "683578",
      "Chowara SO": "683571",
      "Edathala SO": "683561",
      "Karukutty SO": "683576",
      "Kizhakkambalam SO": "683562",
      "Kochi Airport SO": "683111",
      "Kurumassery SO": "683579",
      "Kalady SO": "683574",
      "Malayattoor SO": "683587",
      "Manjapra SO": "683581",
      "Mannam Paravur SO": "683520",
      "Mekkad SO": "683589",
      "Mookkannur SO": "683577",
      "Ambalamugal SO": "682302",
      "Cherai SO": "683514",
      "Erumathala SO": "683112",
      "Kaitharam SO": "683519",
      "Koonammavu SO": "683518",
      "Naval Armament Depot  Aluva SO": "683563",
      "Puthenvelikkara SO": "683594",
      "Sreemoolanagaram SO": "683580",
      "Thottakkattukara SO": "683108",
      "Vadakkekara SO": "683522",
      "Kalloorkkad SO": "686668",
      "Koothattukulam SO": "686662",
      "Pampakuda SO": "686667",
      "Piravom SO": "686664",
      "Pothanicaud SO": "686671",
      "Chelad Junction SO": "686681",
      "Nellimattam SO": "686693",
      "Rayonpuram SO": "683543",
      "Thrikkariyoor SO": "686692",
      "Vengoor SO": "683546",
      "Paravur SO Ernakulam": "683513",
      "Paravur Town SO": "683513",
      "Thaikkattukara SO": "683106",
      "Arakuzha SO": "686672",
      "Elanji SO": "686665",
      "Kunnackal SO": "682316",
      "Mudavoor SO": "686669",
      "Irimbanam SO": "682309",
      "Kadavanthara SO": "682020",
      "Maradu SO": "682304",
      "Nettoor SO": "682040",
      "Panampilly Nagar SO": "682036",
      "Panangad SO Ernakulam": "682506",
      "Perumanur SO": "682015",
      "Shanmugham Road SO": "682031",
      "Thevara SO": "682013",
      "Thrikkakara SO": "682021",
      "Tripunithura SO": "682301",
      "Udyogamandal SO": "683501",
      "Vennala SO": "682028",
      "InfoparkKochi SO": "682042",
      "Ayyampilly SO": "682501",
      "Edakochi SO": "682010",
      "Kannamali SO": "682008",
      "Mundamveli SO": "682507",
      "Narakkal SO": "682505",
      "Nayarambalam SO": "682509",
      "North End SO": "682009",
      "Thottumughom SO": "683105",
      "Vadakkumpuram SO": "683521",
      "Kolenchery SO": "682311",
      "Koovappady SO": "683544",
      "Aluva Bazar SO": "683101",
      "Angamally SO": "683572",
      "Kanjoor SO": "683575",
      "Kumarapuram SO Ernakulam": "683565",
      "Moothakunnam SO": "683516",
      "Muppathadam SO": "683110",
      "Palliport SO": "683515",
      "Vazhakulam SO": "686670",
      "Valayanchirangara SO": "683556",
      "ChittoorEkm SO": "682027",
      "Chottanikkara SO": "682312",
      "Ernakulam High Court SO": "682031",
      "Kochi MGRoad SO": "682016",
      "Mulanthuruthy SO": "682314",
      "Pachalam SO": "682012",
      "Poonithura SO": "682038",
      "Thammanam SO": "682032",
      "Paravur Market SO": "683513",
      "Union Christian College SO": "683102",
      "Varapuzha SO": "683517",
      "Muvattupuzha Market SO": "686673",
      "Ramamangalam SO": "686663",
      "Kothamangalam SO Ernakulam": "686691",
      "Okkal SO": "683550",
      "Iringole SO": "683548",
      "Asamannoor SO": "683549",
      "Keezhillam SO": "683541",
      "Kothamangalam College SO": "686666",
      "Kuruppampady SO": "683545",
      "Mudikkal SO": "683547",
      "AIMS Ponekkara SO": "682041",
      "Ambalamedu SO": "682303",
      "Arakunnam SO": "682313",
      "Changampuzha Nagar SO": "682033",
      "Cochin Special Economic Zone SO": "682037",
      "Elamakkara SO": "682026",
      "Ernakulam College SO": "682035",
      "Ernakulam North SO": "682018",
      "Eroor SO Ernakulam": "682306",
      "Kakkanad SO": "682030",
      "Kaloor SO": "682017",
      "Kanjiramattom SO": "682315",
      "Kochi University SO": "682022",
      "Mulavukad SO": "682504",
      "Puthencruz SO": "682308",
      "Vaduthala SO": "682023",
      "Vyttila SO": "682019",
      "Edavanakad SO": "682502",
      "Kumbalangi SO": "682007",
      "Malipuram SO": "682511",
      "Matsyapuri SO": "682029",
      "Palluruthy SO": "682006",
      "Willingdon Island SO": "682003",
      "Thiruvamkulam SO": "682305",
      "Udayamperoor SO": "682307",
      "Mattancherry Jetty SO": "682002",
      "Mattancherry Town SO": "682002",
      "Ochanthuruth SO": "682508",
      "Kochi Parcel Centre PO": "682051",
      "Cheranallur SO": "682034",
      "Edapally SO": "682024",
      "Hmt Colony SO": "683503",
      "Kalamassery SO": "683104",
      "Palarivattom SO": "682025",
      "Rajagiri Valley SO": "682039",
      "Tripunithura Fort SO": "682301",
      "Vadavucode SO": "682310",
      "International Business Centre IBC": "682050",
      "KULAYATTIKKARA": "682317",
      "Elamkunnapuzha SO": "682503",
      "Kochi Naval Base SO": "682004",
      "Mattancherry SO": "682002",
      "Thoppumpady SO": "682005"
    },
    "ALAPPUZHA": {
      "Kottankulangara BO": "688006",
      "Champakulam East BO": "688505",
      "Pullangadi BO": "688505",
      "Chennamkary BO": "688501",
      "Kuttamangalam BO": "688501",
      "Pollethai BO": "688522",
      "Kavalam North BO": "688506",
      "Ponnad BO": "688538",
      "Nedumudy BO": "688503",
      "Kannady West BO": "688504",
      "Punnakunnathussery BO": "688504",
      "Illichira BO": "688561",
      "Karumady BO": "688561",
      "Purakad BO": "688561",
      "Chempumpuram BO": "688505",
      "Thottuvathala BO": "688501",
      "Chathurthiakary BO": "688502",
      "Punnakunnathussery South BO": "688504",
      "Kattor Kalavoor BO": "688522",
      "Chennamkary East BO": "688506",
      "Cherukara Kuttanad BO": "688506",
      "Ponga BO": "688503",
      "Kunnumma Thakazhy BO": "688562",
      "Vattayal Ward BO": "688002",
      "Kalavamkodam B O": "688524",
      "Chethy BO": "688530",
      "Thaickal BO": "688530",
      "Kuruppankulangara BO": "688539",
      "Varanad BO": "688539",
      "Manappuram BO": "688526",
      "Panavally BO": "688526",
      "Mararikulam North BO": "688523",
      "Kokkothamangalam BO": "688527",
      "Thuravoor South BO": "688532",
      "Thottappally BO": "688561",
      "Komalapuram BO": "688006",
      "Vembanad Kayal BO": "688006",
      "Pandarakulam BO": "688009",
      "Kainakary East BO": "688501",
      "Narakathara BO": "688506",
      "Aryad North BO": "688538",
      "Kannady BO": "688504",
      "Kayalpuram BO": "688504",
      "Chandiroor BO": "688537",
      "Ezhupunna BO": "688537",
      "Cherthala South BO": "688539",
      "Vadackal BO": "688003",
      "Kelamangalam BO": "688562",
      "Ezhupunna South BO": "688537",
      "Vettackal BO": "688529",
      "Andhakaranazhy BO": "688531",
      "Pallithode BO": "688540",
      "Parayakad BO": "688540",
      "Thirunallur BO": "688541",
      "Naduvathunagar BO": "688526",
      "Olavaipu BO": "688526",
      "Trichattukulam BO": "688526",
      "Kannankara BO": "688527",
      "Karikkad BO": "688527",
      "Valamangalam BO": "688532",
      "Chirayakom BO": "688562",
      "Vaduthala Jetty BO": "688535",
      "Maruthorvattom BO": "688539",
      "Kochuramapuram BO": "688541",
      "Kanichukulangara BO": "688582",
      "Muttathiparambu BO": "688527",
      "Kunnamkary BO": "686102",
      "Kumarankary BO": "686103",
      "Eara North BO": "686534",
      "Kainady BO": "686534",
      "Perisserry BO": "689126",
      "Thonackad BO": "689511",
      "Pandanad North BO": "689124",
      "Kidangara BO": "686102",
      "Elanjimel BO": "689511",
      "Mundancavu BO": "689124",
      "Vazharmangalam BO": "689124",
      "Pandanad West BO": "689506",
      "Changankary BO": "689573",
      "Edanad BO": "689123",
      "Chekkidikkadu BO": "689573",
      "Piralassery BO": "689122",
      "Bhudhanoor BO": "689510",
      "Pandankary BO": "689573",
      "Thayamkary BO": "689573",
      "Thattakkattu Market BO": "690547",
      "Kannanakuzhy BO": "690505",
      "Evur BO": "690507",
      "Thannikunnu BO": "690534",
      "Mannarasala BO": "690514",
      "Payipad BO": "690514",
      "Arattupuzha BO": "690535",
      "Erickavu BO": "690516",
      "Cheruthana BO": "690517",
      "Karuvatta North BO": "690517",
      "Njakkanal BO": "690533",
      "Muthukulam BO": "690506",
      "Bharanickavu BO": "690503",
      "Illippakulam BO": "690503",
      "Kattanam BO": "690503",
      "Govindamuttom BO": "690527",
      "Chennithala South BO": "690105",
      "Erezha North BO": "690106",
      "Erezha South BO": "690106",
      "Peringilipuram BO": "689624",
      "Arunoottimangalam BO": "690110",
      "Punnamoodu BO": "690101",
      "Areekara BO": "689505",
      "Poomala BO": "689520",
      "Vedaraplavu BO": "690505",
      "Veeyapuram BO": "690514",
      "Mahadevikadu BO": "690516",
      "Kappil East BO": "690533",
      "Thamallackal BO": "690548",
      "Choolatheruvu BO": "690506",
      "Akamkudy BO": "690513",
      "Athikattukulangara BO": "690504",
      "Panayil BO": "690504",
      "Pallickal Naduvilemuri BO": "690503",
      "Pattolimarket BO": "690531",
      "Mangalam BO": "690515",
      "Kaduvinal BO": "690501",
      "Neduvaramkodu BO": "689508",
      "Eramathoor BO": "689622",
      "Puthiyacavu BO": "690102",
      "Varenickal BO": "690107",
      "Ayaparambu BO": "690517",
      "Pathiyoor BO": "690508",
      "Pattoor BO": "690529",
      "Arattupuzha North BO": "690515",
      "Pallana BO": "690515",
      "Thripperunthura BO": "690105",
      "Ezhakadavu BO": "690104",
      "Valiyakulangara BO": "690104",
      "Kotta BO": "689504",
      "Mampra BO": "689508",
      "Kallimel BO": "690509",
      "Komallur BO": "690505",
      "Thamallackal North BO": "690548",
      "Valiyazheekkal BO": "690535",
      "Karikuzhy BO": "689571",
      "Thalavady South BO": "689572",
      "Kunthirickal BO": "689572",
      "Veliyanadu North BO": "689590",
      "Eruva BO": "690572",
      "Valiyaparambu BO": "690516",
      "Pandy BO": "690517",
      "Payyanallur BO": "690504",
      "Vetticode BO": "690503",
      "Naduvattom BO": "690512",
      "Puthenchantha BO": "690501",
      "Kannamangalam BO": "690106",
      "Eravankara BO": "690108",
      "Ayiranikudy BO": "690558",
      "Pavukara BO": "689622",
      "Peringalamulakuzha BO": "689505",
      "Pallarimangalam BO": "690107",
      "Punthala BO": "689509",
      "Chungom BO": "688011",
      "Vettiyar BO": "690558",
      "Kandiyoor BO": "690103",
      "Karipuzha BO": "690103",
      "Pela BO": "690103",
      "Kodupunna BO": "689595",
      "Anaprambal BO": "689572",
      "Anaprambal North BO": "689572",
      "Kuppappuram BO": "688011",
      "Kakkazhom BO": "688005",
      "Kanjipadom BO": "688005",
      "Vysombhagom BO": "688005",
      "Kanjiramchira BO": "688007",
      "Mithrakary BO": "689595",
      "Urukari BO": "689595",
      "Vezhapra BO": "689595",
      "Eramallikkara BO": "689109",
      "Veliyanadu West BO": "689590",
      "Kommady Ward BO": "688007",
      "Ambalapuzha East  B O": "688561",
      "Kayangulam HO": "690502",
      "Mavelikara HO": "690101",
      "Cherthala HO": "688524",
      "Alappuzha HO": "688001",
      "Chengannur HO": "689121",
      "Charumoodu SO": "690505",
      "Chingoli SO": "690532",
      "Chunakara SO": "690534",
      "Kandallur SO": "690535",
      "Karuvatta SO": "690517",
      "Kayangulam College SO": "690502",
      "Krishnapuram SO Alappuzha": "690533",
      "Muthukulam South SO": "690506",
      "Muttomalleppey SO": "690511",
      "Pallipad SO": "690512",
      "Puthiyavila SO": "690531",
      "Thamarakulam SO": "690530",
      "Thrikkunnapuzha SO": "690515",
      "Vallikunnam SO": "690501",
      "Chettikulangara SO": "690106",
      "Karakkad SO": "689504",
      "Kuttemperur SO": "689623",
      "Mannar SO": "689622",
      "Mavelikara Court SO": "690101",
      "Olakettiambalam SO": "690510",
      "Pennukkara SO": "689520",
      "Thattarambalam SO": "690103",
      "Alappuzha Bazar SO": "688012",
      "Alappuzha Iron Bridge SO": "688011",
      "Alappuzha North SO": "688007",
      "Champakulam SO": "688505",
      "Punnapra North SO": "688014",
      "Punnapra SO": "688004",
      "Sanathanapuram SO": "688003",
      "Aroor SO": "688534",
      "Kuthiathode SO": "688533",
      "Pattanacaud SO": "688531",
      "Sethulekshmipuram SO": "688523",
      "Thirumalabhagom SO": "688540",
      "Thycattussery SO": "688528",
      "Vayalar SO": "688536",
      "Alappuzha District Hospital SO": "688011",
      "Alappuzha Mullackal SO": "688011",
      "Avalukkunnu SO": "688006",
      "Kalavoor SO": "688522",
      "Kavalam SO": "688506",
      "Moncombu Thekkekara SO": "688503",
      "Pulincunnu SO": "688504",
      "Thakazhy SO": "688562",
      "Keerikad SO": "690508",
      "Kumarapuram SO Alappuzha": "690548",
      "Perungala SO": "690559",
      "Chennithala SO": "690105",
      "Kallumala SO": "690110",
      "Kollakadavu SO": "690509",
      "Kudassanad SO": "689512",
      "Mankamkuzhy SO": "690558",
      "Melpadom SO": "689627",
      "Thumpoly SO": "688008",
      "Arookutty SO": "688535",
      "Mayithara Market SO": "688539",
      "Varanam SO": "688555",
      "Haripad SO": "690514",
      "Kareelakulangara SO": "690572",
      "Karthikappally SO": "690516",
      "Nangiarkulangara SO": "690513",
      "Padanilam SO": "690529",
      "Ennakkad SO": "689624",
      "Kodukulanji SO": "689508",
      "Kozhuvallur SO": "689521",
      "Thazhakara SO": "690102",
      "Ambalapuzha SO": "688561",
      "Mannancherry SO": "688538",
      "Pazhaveedu SO": "688009",
      "Thathampally SO": "688013",
      "Thiruvampady Junction SO": "688002",
      "Arthingal SO": "688530",
      "Kadakkarapally SO": "688529",
      "Pallippuram SO": "688541",
      "Sreenarayanapuram SO": "688582",
      "Thanneermukkom SO": "688527",
      "Thuravoor SO": "688532",
      "Alappuzha Collectorate SO": "688001",
      "Alappuzha Medical College SO": "688005",
      "Kainakary SO": "688501",
      "Moncombu SO": "688502",
      "Pathirappally SO": "688521",
      "Thondankulangara SO": "688013",
      "Cherthala Cutcherry SO": "688524",
      "Eramallur SO": "688537",
      "Muhamma SO": "688525",
      "Perumbalam SO": "688570",
      "Poochackal SO": "688526",
      "Cheppaud SO": "690507",
      "Nooranad SO": "690504",
      "Nooranad Sanatorium SO": "690571",
      "Pallickal SO": "690503",
      "Pullikanakku SO": "690537",
      "Puthuppally SO": "690527",
      "Cherukole SO": "690104",
      "Kunnam SO Alappuzha": "690108",
      "Mavelikara Cutcherry SO": "690101",
      "Mulakuzha SO": "689505",
      "Thekkekara SO": "690107",
      "Venmony SO": "689509",
      "Neelamperoor SO": "686534",
      "Angadical Chengannur SO": "689122",
      "Cheriyanadu SO": "689511",
      "Pandanad SO": "689506",
      "Muttar SO": "689574",
      "Thalavady SO": "689572",
      "Chengannur RS SO": "689121",
      "Kallisserry SO": "689124",
      "Edathua SO": "689573",
      "Neerattupuram SO": "689571",
      "Tiruvanvandur SO": "689109",
      "Ramankary SO": "689595",
      "Ala SO Alappuzha": "689126",
      "Puliyoor SO": "689510",
      "Puthencavu SO": "689123",
      "Veliyanadu SO": "689590"
    },
    "IDUKKI": {
      "Thattarathatta BO": "685586",
      "Adoormala BO": "685590",
      "Kanjar BO": "685590",
      "Koovappallykudayathur BO": "685590",
      "Kanthallur BO": "685620",
      "Michaelgiri BO": "685620",
      "Pius Nagar BO": "685620",
      "Mattupatty ISP BO": "685616",
      "Pallivasal Estate BO": "685612",
      "Pothamedu BO": "685612",
      "Edamalakudi BO": "685612",
      "Ezhallur BO": "685605",
      "Ezhumuttom BO": "685605",
      "Perumpillichira BO": "685605",
      "Muniyara BO": "685571",
      "C Kuthumkal BO": "685566",
      "Mammattikanam BO": "685566",
      "Ottalloor BO": "685586",
      "Vadakkummury BO": "685586",
      "Vandamattom BO": "685582",
      "Moolamattom East BO": "685589",
      "Pathippally BO": "685589",
      "LETCHMI ESTATE BO": "685612",
      "Mullarikudy BO": "685571",
      "Panickankudy BO": "685571",
      "Sahayagiri BO": "685620",
      "Edadidukki BO": "685589",
      "Ilappally BO": "685589",
      "Munnar Colony BO": "685612",
      "Ellumpuram BO": "685587",
      "Thudanganad BO": "685587",
      "Parapuzha BO": "685582",
      "West Kodikulam BO": "685582",
      "Kannickal BO": "685589",
      "Gudarle BO": "685612",
      "Mrala BO": "685587",
      "Cheenthalar BO": "685501",
      "Chinnar BO": "685501",
      "Pasupara BO": "685501",
      "Kochuthovala BO": "685514",
      "Santhigram BO": "685514",
      "Uppukandam BO": "685514",
      "Chellarcoil BO": "685512",
      "Kochukarimtharuvi BO": "685501",
      "Bethel BO": "685514",
      "Chempakapara BO": "685514",
      "Ettithope BO": "685514",
      "Valiyathovala BO": "685514",
      "Mulakuvally BO": "685602",
      "Nayarupara BO": "685602",
      "Pazhayarikandam BO": "685606",
      "Venmony BO": "685606",
      "Nellipara BO": "685515",
      "Vellayamkudy BO": "685515",
      "Karippalangad BO": "685601",
      "Attapallam BO": "685509",
      "Rajamudi BO": "685604",
      "Upputhode BO": "685604",
      "Vellaramkunnu BO": "685535",
      "Kailasanadu BO": "685553",
      "Mavady BO": "685553",
      "Glenmary BO": "685531",
      "Kuttikanam BO": "685531",
      "Murinjapuzha BO": "685532",
      "Paloorkavu Central BO": "685532",
      "Chemmannar BO": "685554",
      "Mattuthavalam BO": "685505",
      "Pullikkanam BO": "685503",
      "Nettithozhu BO": "685551",
      "Puttady BO": "685551",
      "Chottupara Periyar BO": "685533",
      "Mount BO": "685533",
      "Korangatti BO": "685561",
      "Mannamkandam BO": "685561",
      "Ellakallu BO": "685565",
      "Kunchithanni BO": "685565",
      "Pallivasal BO": "685565",
      "Thokkupara BO": "685565",
      "Anayirankal BO": "685613",
      "Chilavu BO": "685588",
      "Edavetty BO": "685588",
      "Mukkudam BO": "685562",
      "South Kathipara BO": "685562",
      "Cheppukulam BO": "685581",
      "Neyyassery BO": "685581",
      "Thattakuzha BO": "685581",
      "Kalthotty BO": "685507",
      "Fair Field BO": "685501",
      "Haileyburia BO": "685501",
      "Kolahalamedu BO": "685501",
      "Idinjamala BO": "685514",
      "Melekuppachampady BO": "685514",
      "Narakakanam BO": "685602",
      "Thadiampadu BO": "685602",
      "Balagram BO": "685552",
      "Sanniasioda BO": "685552",
      "Keerithode BO": "685606",
      "Thattekanni BO": "685606",
      "Anniyartholu BO": "685515",
      "Puliyanmala BO": "685515",
      "Vazhavara BO": "685515",
      "Chakkupallam BO": "685509",
      "Springvalley BO": "685509",
      "Rajapuram BO": "685604",
      "Sasthanoda BO": "685535",
      "Chembalam BO": "685553",
      "Ezhukunvayal BO": "685553",
      "Manjappara BO": "685553",
      "Karadikuzhy BO": "685531",
      "Lakshmi Coil BO": "685531",
      "Meloram BO": "685532",
      "Paloorkavu BO": "685532",
      "Thopramkduy BO": "685609",
      "Chathurangapara BO": "685554",
      "Kottamala BO": "685503",
      "Kochara BO": "685551",
      "Mali BO": "685551",
      "Pampupara BO": "685551",
      "Arnakal BO": "685533",
      "Chenkara BO": "685533",
      "Dymock BO": "685533",
      "Vallakadavu Periyar BO": "685533",
      "Koompanpara BO": "685561",
      "Machiplavu BO": "685561",
      "Josegiri BO": "685565",
      "Mankulam BO": "685565",
      "Meencut BO": "685565",
      "Sengulam BO": "685565",
      "Vattiar BO": "685565",
      "Alakode BO": "685588",
      "Devarupara BO": "685588",
      "Manipara BO": "685602",
      "Maniyaramkudy BO": "685602",
      "Mariyapuram BO": "685602",
      "Chottupara BO": "685552",
      "Combayar BO": "685552",
      "Kozhimala BO": "685511",
      "Nariampara BO": "685511",
      "Thoppipala BO": "685511",
      "Thovarayar BO": "685511",
      "Alpara BO": "685606",
      "Chelachuvadu BO": "685606",
      "Kamakshy BO": "685515",
      "Mulakaramedu BO": "685515",
      "Thekkady BO": "685509",
      "Anavilasam BO": "685535",
      "Pallikunnu BO": "685531",
      "Pambanar BO": "685531",
      "Kanayankavayal BO": "685532",
      "Marigiri BO": "685609",
      "Pandipara BO": "685609",
      "Perumthotty BO": "685609",
      "Prakash BO": "685609",
      "Lonetree BO": "685505",
      "Mathaipara BO": "685505",
      "Cumbumbettu BO": "685551",
      "Kuzhithozhu BO": "685551",
      "Thengakal BO": "685533",
      "Wallardie BO": "685533",
      "Padicap BO": "685561",
      "Valara BO": "685561",
      "Pottenkad BO": "685565",
      "Kottakomboor BO": "685615",
      "Koviloor BO": "685615",
      "Sethuparvathipuram BO": "685615",
      "Elamdesom BO": "685588",
      "Koovakandam BO": "685588",
      "Pannimattom BO": "685588",
      "Velliyamattom BO": "685588",
      "Panamkutty BO": "685562",
      "Thommankuthu BO": "685581",
      "Erattayar North BO": "685514",
      "Vimalagiri BO": "685602",
      "Karunapuram BO": "685552",
      "Koottar BO": "685552",
      "Pushpakandam BO": "685552",
      "Ramakkal Mettu BO": "685552",
      "Calvari Mount BO": "685515",
      "Kadamakuzhy BO": "685515",
      "Amaravathy BO": "685509",
      "Konnackamali BO": "685604",
      "Mankuva BO": "685604",
      "Padamugham BO": "685604",
      "Perinchankutty BO": "685604",
      "Pachady BO": "685553",
      "Pampadumpara BO": "685553",
      "Karimkulam Chappath BO": "685505",
      "Rajakandam BO": "685551",
      "Gramby BO": "685533",
      "Keerikara BO": "685533",
      "Moongalar BO": "685533",
      "Anaviratty BO": "685561",
      "Anakulam BO": "685565",
      "Bisonvalley BO": "685565",
      "Panniar Estate BO": "685613",
      "Koduveli BO": "685581",
      "Mulappuram BO": "685581",
      "Pannoor BO": "685581",
      "Wembly BO": "686514",
      "Mukkulam BO": "686514",
      "Mukkulam East BO": "686514",
      "Kuppakkayam BO": "686513",
      "Mundakayam East BO": "686513",
      "Kulaparachal BO": "685619",
      "Rajakumari South BO": "685619",
      "Vattappara UBC BO": "685619",
      "Chinnakanal BO": "685618",
      "Sinkukandam BO": "685618",
      "Cheenikuzhi BO": "685595",
      "Moolakad BO": "685595",
      "Purapuzha BO": "685583",
      "Selliampara BO": "685563",
      "Kumaramangala BO": "685608",
      "Manakkad BO": "685608",
      "Aruvilanchal BO": "685619",
      "Pethotty BO": "685619",
      "Poopara BO": "685619",
      "Puthady BO": "685619",
      "Rajakumari BO": "685619",
      "Thekkumbhagam BO": "685585",
      "Thodupuzha puthuperiyaram BO": "685608",
      "Mukkudil BO": "685566",
      "Chattamannar BO": "685614",
      "Amayapra BO": "685595",
      "Kaliyar BO": "685607",
      "Mullaringadu BO": "685607",
      "Mundanmudy BO": "685607",
      "Pulickathotty BO": "685607",
      "Arikuzha BO": "685608",
      "Kaloor East BO": "685608",
      "Kolani BO": "685608",
      "N R City BO": "685566",
      "Khajanapara BO": "685619",
      "Senapathy BO": "685619",
      "Anchiri BO": "685585",
      "Malayinchi BO": "685595",
      "Peringassery BO": "685595",
      "Kuninji BO": "685583",
      "Konnathady BO": "685563",
      "Ponmudi BO": "685563",
      "Mailacombu BO": "685608",
      "Nediyasala BO": "685608",
      "Thodupuzha HO": "685584",
      "Kattappana HO": "685508",
      "Santhanpara SO": "685619",
      "Surianalle SO": "685618",
      "Talliar SO": "685614",
      "Thodupuzha West SO": "685584",
      "Udumbannur SO": "685595",
      "Vazhithala SO": "685583",
      "Thodupuzha East SO": "685585",
      "Vellathooval SO": "685563",
      "Vannapuram SO": "685607",
      "Kattappana South SO": "685515",
      "Kumily SO": "685509",
      "Viswanathapuram SO": "685535",
      "Upputhara SO": "685505",
      "Kodikulam SO": "685582",
      "Mattuppatti SO": "685616",
      "Vengallur SO": "685608",
      "Ayyappancoil SO": "685507",
      "Idukki Painavu SO": "685603",
      "Kanjikuzhi  Idukki SO": "685606",
      "Murickassery SO": "685604",
      "Thankamany SO": "685609",
      "Udumbanchola SO": "685554",
      "Vagamon SO": "685503",
      "Adimali SO": "685561",
      "Arakulam SO": "685591",
      "Ellapatti SO": "685615",
      "Kalayanthani SO": "685588",
      "Kallarkutty SO": "685562",
      "Maraiyur SO": "685620",
      "Muthalakodam SO": "685605",
      "Anakkara SO Idukki": "685512",
      "Elappara SO": "685501",
      "Erattayar SO": "685514",
      "Idukki Colony SO": "685602",
      "Kallar SO": "685552",
      "Kulamavu SO": "685601",
      "Peermade SO": "685531",
      "Peruvanthanam SO": "685532",
      "Vandanmettu SO": "685551",
      "Karimkunnam SO": "685586",
      "Kudayathur SO": "685590",
      "Parathode SO Idukki": "685571",
      "Rajakad SO": "685566",
      "Kanchiyar SO": "685511",
      "Nedumkandam SO": "685553",
      "Vandiperiyar SO": "685533",
      "Chithirapuram SO": "685565",
      "Devikulam SO": "685613",
      "Karimannoor SO": "685581",
      "Moolamattom SO": "685589",
      "Munnar SO": "685612",
      "Muttom EK SO": "685587"
    },
    "WAYANAD": {
      "Nallara Chal BO": "673593",
      "Narikkundu BO": "673593",
      "Chennalode BO": "673122",
      "Kakka Vayal BO": "673122",
      "Vala Vayal BO": "673596",
      "Krishna Giri BO": "673591",
      "Varadoor BO": "673591",
      "Bhoodanam Colony BO": "673579",
      "Cheeyambam BO": "673579",
      "Chettapalam BO": "673579",
      "Kabanigiri BO": "673579",
      "Veliyambam BO": "673579",
      "Kuppadi BO": "673592",
      "Moodakolli BO": "673592",
      "Nulpuzha BO": "673592",
      "Pambra BO": "673592",
      "Pazhupathur BO": "673592",
      "Poomulla BO": "673592",
      "Bavali BO": "670646",
      "Payyampalli BO": "670646",
      "Tholpetty BO": "670646",
      "Tirunelli BO": "670646",
      "Tirunelli Temple BO": "670646",
      "Edavaka BO": "670645",
      "Ellumannam BO": "670645",
      "Cherukattoor BO": "670721",
      "Echchome BO": "670721",
      "Kalathu Vayal BO": "673593",
      "Karadipara BO": "673593",
      "Kaniyambetta BO": "673124",
      "Kavumannam BO": "673122",
      "Maniyangode BO": "673122",
      "Koleri BO": "673596",
      "Kolagapara BO": "673591",
      "Kumbaleri BO": "673591",
      "Cottanad BO": "673577",
      "Vallarmala BO": "673577",
      "Thariote North BO": "673575",
      "Achooranam BO": "673575",
      "Amara Kuni BO": "673579",
      "Kalanadi Kolli BO": "673579",
      "Marakadavu BO": "673579",
      "Palakolli BO": "673579",
      "Sasimala BO": "673579",
      "Beenachi BO": "673592",
      "Moolan Kavu BO": "673592",
      "Nenmeni BO": "673592",
      "Thovari Mala BO": "673592",
      "Valluvadi BO": "673592",
      "Cheengeri BO": "673593",
      "Karinkutty BO": "673124",
      "Mandad BO": "673122",
      "Muttil BO": "673122",
      "Pariyaram  Wynad BO": "673122",
      "Athirattu Kunnu BO": "673596",
      "Choothupara BO": "673596",
      "Karachal BO": "673591",
      "Mylambadi BO": "673591",
      "Chembra BO": "673577",
      "Mundakai BO": "673577",
      "Trikai Petta BO": "673577",
      "Thariote BO": "673575",
      "Varambetta BO": "673575",
      "Manal Vayal BO": "673579",
      "Mullankolli BO": "673579",
      "Perikallur BO": "673579",
      "Seetha Mount BO": "673579",
      "Chedalath BO": "673592",
      "Muthanga BO": "673592",
      "Kayakunnu BO": "670721",
      "Nadavayal BO": "670721",
      "Varayal BO": "670644",
      "Kunhome BO": "670731",
      "Makkiad BO": "670731",
      "Mattilayam BO": "670731",
      "Thettamala BO": "670731",
      "Kadalmat BO": "673581",
      "Panavally BO": "670646",
      "Thrissileri BO": "670646",
      "Arattuthara BO": "670645",
      "Kammana BO": "670645",
      "Kellur BO": "670645",
      "Nallurnad BO": "670645",
      "Arinjerummal BO": "670721",
      "Nirvaram BO": "670721",
      "Kampatti BO": "670644",
      "PorurWynad BO": "670644",
      "Kattayad BO": "670731",
      "Naiketty BO": "673592",
      "Vakeri BO": "673592",
      "Chellangode BO": "673581",
      "Anjukunnu BO": "670645",
      "Karakkamala BO": "670645",
      "Kunnamangalam Wayanad BO": "670645",
      "Kappattumala BO": "670644",
      "Periya BO": "670644",
      "Kottarakunnu BO": "670731",
      "Thondernadu BO": "670731",
      "Mookuthi Kunnu BO": "673595",
      "Nambiar Kunnu BO": "673595",
      "Nenmeni Kunnu BO": "673595",
      "Puthan Kunnu BO": "673595",
      "Thazhathur BO": "673595",
      "Kunnambetta BO": "673123",
      "Kottathara BO": "673124",
      "Madakkimala BO": "673122",
      "Madakunnu BO": "673122",
      "Pallikunnu Wynad BO": "673124",
      "Pinangode BO": "673122",
      "Puzhamutti BO": "673122",
      "Thekkumthara BO": "673124",
      "Vazhu Vatta BO": "673122",
      "Poothadi BO": "673596",
      "Thazha Munda BO": "673596",
      "Karani BO": "673591",
      "Kariyambadi BO": "673591",
      "Nathamkuni BO": "673577",
      "Puthumala BO": "673577",
      "Puthur Vayal BO": "673577",
      "Ripon Wynad BO": "673577",
      "Arambatta Kunnu BO": "673575",
      "Bibleland BO": "673575",
      "Manjoora BO": "673575",
      "Padinhara Thara BO": "673575",
      "Padichira BO": "673579",
      "Pakkom BO": "673579",
      "Chulliote BO": "673592",
      "Kidanganad BO": "673592",
      "Lakkidi BO": "673576",
      "Sugandhagiri BO": "673576",
      "Mundakutty BO": "670645",
      "Pilakavu BO": "670645",
      "Pudusserikadavu BO": "670645",
      "Tharuvana BO": "670645",
      "Valery BO": "670645",
      "Vemom BO": "670645",
      "Vimalanagar BO": "670645",
      "Alattil BO": "670644",
      "CherakkaraWynad BO": "670644",
      "Tavinhal BO": "670644",
      "Vallat BO": "670644",
      "Vanhode BO": "670731",
      "Pudusseri BO": "670645",
      "Kalpetta HO": "673121",
      "Meenangadi SO": "673591",
      "Meppadi SO": "673577",
      "Vatuvanchal SO": "673581",
      "Panamaram SO": "670721",
      "Thalappuzha SO": "670644",
      "Cheeral SO": "673595",
      "Kalpetta North SO": "673122",
      "Vythiri SO": "673576",
      "Mananthavady SO": "670645",
      "KAMBALAKKAD SO": "673124",
      "Pozhuthana SO": "673575",
      "Sulthan Bathery East SO": "673592",
      "Sulthan Bathery SO": "673592",
      "Kartikulam SO": "670646",
      "Vellamunda SO": "670731",
      "Ambalavayal SO": "673593",
      "Chundale SO": "673123",
      "Kenichira SO": "673596",
      "Pulpalli SO": "673579"
    },
    "MALAPPURAM": {
      "Vazhayur East BO": "673633",
      "Vazhayur BO": "673633",
      "Thennala BO": "676508",
      "Edayur BO": "676552",
      "Edayur North BO": "676552",
      "Karippol BO": "676552",
      "Cherur BO": "676304",
      "Iringallur BO": "676304",
      "Chullippara BO": "676508",
      "Venniyur BO": "676508",
      "Puramannur BO": "676552",
      "Vadakkumbram BO": "676552",
      "Parambilpeedika BO": "676317",
      "Kannamangalam BO": "676304",
      "Punnathala BO": "676552",
      "Tolavanur BO": "676552",
      "Valiyakunnu BO": "676552",
      "Velimukku South BO": "676317",
      "Kannattipadi BO": "676304",
      "Valiyora BO": "676304",
      "Kumminiparamba BO": "673638",
      "Melangadi BO": "673638",
      "Muthuparamba BO": "673638",
      "Peruvallur BO": "673638",
      "Thurakkal BO": "673638",
      "Puliyakkode BO": "673641",
      "Vilayil BO": "673641",
      "Meppadam BO": "676542",
      "Pullippadam BO": "676542",
      "Vadapuram BO": "676542",
      "Karakkode BO": "679333",
      "Marutha BO": "679333",
      "Nambooripotty BO": "679333",
      "Vazhikkadavu BO": "679333",
      "Elankur BO": "676122",
      "Mariyad BO": "676122",
      "Kerala Estate BO": "676525",
      "Pullengode BO": "676525",
      "Amayur BO": "676123",
      "Karuvambram West BO": "676123",
      "Kalkundu BO": "676523",
      "Arimbra BO": "673638",
      "Muthuvallur BO": "673638",
      "Nediyirippu BO": "673638",
      "PalakkadMLP BO": "673641",
      "Tavanurferoke BO": "673641",
      "Mampad College BO": "676542",
      "Narukara BO": "676122",
      "Pappinippara BO": "676122",
      "Ezhupathekkar BO": "676525",
      "Neelancheri BO": "676525",
      "Karakkunnu BO": "676123",
      "Koomankulam BO": "676123",
      "Tiruvali BO": "676123",
      "Trikkalangode BO": "676123",
      "Iringattiri BO": "676523",
      "Pulvetta BO": "676523",
      "Chirayil BO": "673638",
      "Olavattur BO": "673638",
      "Trippanachi BO": "673641",
      "Kambalakallu BO": "679333",
      "Nellikuth BO": "676122",
      "Payyanad BO": "676122",
      "Kololamba BO": "679576",
      "Sugapuram BO": "679576",
      "Kadancheri BO": "679582",
      "Othalur West BO": "679591",
      "Payinkanniyur BO": "679571",
      "Perasannur BO": "679571",
      "Athalur BO": "679573",
      "Iswaramangalam BO": "679573",
      "Gramam BO": "679579",
      "Palapetty BO": "679579",
      "Alathiyur BO": "676102",
      "Vengalur BO": "676102",
      "Vettompallippuram BO": "676102",
      "Vallikkunnu BO": "673314",
      "Karukathiruthy BO": "679584",
      "Ayirur BO": "679580",
      "Trikkanapuram BO": "679573",
      "Kuttur North BO": "676305",
      "Kotakkad BO": "676319",
      "Puthuparamba BO": "676501",
      "Vallikkunnu North BO": "673314",
      "Ayilakkad BO": "679576",
      "Biyyam BO": "679576",
      "Karthala BO": "679571",
      "Cheruvallur BO": "679575",
      "Nannamukku South BO": "679575",
      "Mudur BO": "679578",
      "Poyilisseri BO": "676102",
      "Puduppalli BO": "676102",
      "Purathur BO": "676102",
      "Klari BO": "676501",
      "Kuttippala BO": "676501",
      "Kallarmangalam BO": "676553",
      "Karad Paramba BO": "673632",
      "Perumparamba BO": "679576",
      "Polpakara BO": "679576",
      "Trikkanapuram South  BO": "679582",
      "Puranga BO": "679584",
      "Naduvattom BO": "679571",
      "Pazhur BO": "679571",
      "Pidavannur BO": "679574",
      "Kadavanad BO": "679586",
      "Ayankalam BO": "679573",
      "Nariparamba BO": "679573",
      "Pazhanjimlp BO": "679579",
      "Kannamangalam West BO": "676305",
      "Chamravattom BO": "676102",
      "Vettom BO": "676102",
      "Aliparamba BO": "679357",
      "Manalaya BO": "679357",
      "Thootha BO": "679357",
      "Valamkulam BO": "679357",
      "Eravimangalam BO": "679340",
      "Kunnakkavu BO": "679340",
      "Palathole BO": "679340",
      "Oorakam Kizhumuri BO": "676519",
      "Oorakam Melmuri BO": "676519",
      "Pattarkadavu BO": "676519",
      "Kuruvambalam BO": "679338",
      "Ambalakkadavu BO": "676525",
      "Anchachavady BO": "676525",
      "Arimanal BO": "676525",
      "Manhappatta BO": "676123",
      "Pathappiriyam BO": "676123",
      "Pathiriyal BO": "676123",
      "Pulpatta BO": "676123",
      "Kuttathy BO": "676523",
      "Tharis BO": "676523",
      "Karippur BO": "673638",
      "Akkaparamba BO": "673641",
      "Pullancheri BO": "676122",
      "Vakkethodi BO": "676122",
      "Aripra BO": "679321",
      "Kadungapurm BO": "679321",
      "Puthanangadi BO": "679321",
      "Elad BO": "679340",
      "Moorkkanad BO": "679338",
      "Panga Chendy BO": "679338",
      "Chembrassei BO": "676521",
      "Kadambode BO": "676521",
      "Amarambalam BO": "679332",
      "Chettippadam BO": "679332",
      "Vadakkumpadam BO": "679339",
      "Vazhenkada BO": "679357",
      "Cherakkaparamba BO": "679321",
      "Pariyapuram BO": "676302",
      "Hajiarpalli BO": "676519",
      "Palachode BO": "679338",
      "Panga BO": "679338",
      "Nallanthanni BO": "679330",
      "Aurvacode BO": "679329",
      "Eranhimangad BO": "679329",
      "Pandallur Hills BO": "676521",
      "Valluvangad South BO": "676521",
      "Chokkad BO": "679332",
      "Kavalamukkatta BO": "679332",
      "Kannamvettikavu BO": "673637",
      "Poolamanna BO": "679327",
      "Vellayur BO": "679327",
      "Amarambalam South BO": "679339",
      "Koorad BO": "679339",
      "Naduvath BO": "679328",
      "Azhinjilam BO": "673632",
      "Kanmanam BO": "676551",
      "Puzhakkattiri BO": "679321",
      "Ramapuram BO": "679321",
      "Tirurkad BO": "679321",
      "Chattipparamba BO": "676504",
      "Kuruga BO": "676551",
      "Thekkankuttur BO": "676551",
      "Parappur BO": "676503",
      "Padinharekkara BO": "676562",
      "Kavancheri BO": "676561",
      "Ponmala BO": "676528",
      "Ullanam North BO": "676303",
      "Athrisseri BO": "676106",
      "Puthiyakadappuram BO": "676302",
      "Omachapuzha BO": "676320",
      "Iringavur BO": "676103",
      "Pachattiri BO": "676105",
      "Athavanad BO": "676301",
      "Vyrancode BO": "676301",
      "Pantarangadi BO": "676306",
      "Chengottur BO": "676503",
      "Kuttippuramkottakkal BO": "676503",
      "Moonniyur South BO": "676311",
      "Vakkad BO": "676502",
      "Vellachal BO": "676106",
      "Ananthavur BO": "676301",
      "Kakkad BO": "676306",
      "Kooriyad BO": "676306",
      "Mampuram BO": "676306",
      "Karulai BO": "679330",
      "Chandakkunnu BO": "679329",
      "Edivanna BO": "679329",
      "Pandallur BO": "676521",
      "Valluvangad BO": "676521",
      "Chulliyode BO": "679332",
      "Mampattumoola BO": "679332",
      "Ayikkarapadi BO": "673637",
      "Valiyaparamba BO": "673572",
      "Palakkalvetta BO": "679327",
      "Karad BO": "679339",
      "Porur BO": "679339",
      "Karumarakkad BO": "673640",
      "Palengara BO": "679330",
      "Ramankuth BO": "679330",
      "Mannathipoyil BO": "679332",
      "TKColony BO": "679332",
      "Andiyoorkunnu BO": "673637",
      "Chenakkalangadi BO": "673636",
      "Puthurpallikkal BO": "673636",
      "Chembrasseri East BO": "679327",
      "Poongode BO": "679327",
      "Chathangottupuram BO": "679328",
      "Kappil BO": "679328",
      "Punnappala BO": "679328",
      "Karekkad BO": "676553",
      "Marakkara BO": "676553",
      "Valavannur BO": "676551",
      "Puthur kottakkal BO": "676503",
      "Muttanur BO": "676561",
      "Anjapura BO": "676303",
      "Neduva BO": "676303",
      "Keraladheeswarapuram BO": "676307",
      "Meenadathur BO": "676307",
      "Panangattur BO": "676302",
      "Tanur Nagaram BO": "676302",
      "Olakara BO": "676306",
      "Pathayakallu BO": "676553",
      "Kanmanamthekkummuri BO": "676551",
      "Parammalangadi BO": "676551",
      "Chappanangadi BO": "676503",
      "Indianur BO": "676503",
      "Pandamangalam BO": "676503",
      "Chennara BO": "676561",
      "Mattathur BO": "676528",
      "Ullanam BO": "676303",
      "Cheriyamundam BO": "676106",
      "Cherushola BO": "676510",
      "Ozhur BO": "676307",
      "Nannambra BO": "676320",
      "Mangattiri BO": "676105",
      "Kurumbathur BO": "676301",
      "Cherumukku BO": "676306",
      "Codacal BO": "676108",
      "Kadannamanna BO": "679324",
      "Padirikode BO": "679326",
      "Vengad BO": "670612",
      "Pazhamallur BO": "676506",
      "Vattalur BO": "676507",
      "Koottil BO": "679324",
      "Vadakkangara BO": "679324",
      "Kizhakkumpadam BO": "679326",
      "Morayur BO": "673642",
      "Olukur BO": "673642",
      "Anakkayam BO": "676509",
      "Perimbalam BO": "676509",
      "Chemmaniyode BO": "679325",
      "Poonthavanam BO": "679325",
      "Vengoor BO": "679325",
      "Maithra BO": "673639",
      "PeruparambaUgrapuram BO": "673639",
      "Valillapuzha BO": "673639",
      "Kolakkattuchali BO": "673634",
      "Erumamunda BO": "679334",
      "Uppada BO": "679334",
      "Velliyanchery BO": "679326",
      "Valluvambram BO": "673642",
      "Thachinganadam BO": "679325",
      "Thelakkad BO": "679325",
      "Amminikkad BO": "679322",
      "Kunnappally BO": "679322",
      "Pathaikara BO": "679322",
      "Ponniyakurissi BO": "679322",
      "Vellur BO": "670307",
      "Chelakkad BO": "679323",
      "Chemmalasseri BO": "679323",
      "Poovathikkal BO": "673639",
      "Thottilangadi BO": "673639",
      "Mundakkal BO": "673645",
      "Padiripadam BO": "679334",
      "Pallikuth BO": "679334",
      "Pookottumanna BO": "679334",
      "Palemad BO": "679331",
      "Chathallur BO": "676541",
      "Eranhikode BO": "676541",
      "Pannippara BO": "676541",
      "Padinhattumuri BO": "676506",
      "Vellila BO": "679324",
      "Vettathur BO": "679326",
      "Olamathil BO": "673642",
      "Valambur BO": "679325",
      "Mattarakkal BO": "679341",
      "Arkkuparamba BO": "679341",
      "Talekode West BO": "679341",
      "Iruvetti BO": "673639",
      "Kavanur BO": "673639",
      "Thottumukkam BO": "673639",
      "Urangattiri BO": "673639",
      "Pulliparamba BO": "673634",
      "Omanur BO": "673645",
      "Kurumbalangode BO": "679334",
      "Karapuram BO": "679331",
      "Perakamanna BO": "676541",
      "Modapoika BO": "679331",
      "Munda BO": "679331",
      "Panga South BO": "679338",
      "Perinthattiri BO": "676507",
      "Mankada Pallippuram BO": "679324",
      "Vallikkapatta BO": "679324",
      "Edapatta BO": "679326",
      "Edayattur BO": "679326",
      "Irumbuzhi BO": "676509",
      "Kizhattur BO": "679325",
      "Mannarmala BO": "679325",
      "Melmuri BO": "676517",
      "Valapuram BO": "679323",
      "Chemmarakkattur BO": "673639",
      "Kizhuparamba BO": "673639",
      "Panampilavu BO": "673639",
      "Vettilappara BO": "673639",
      "Pallikkal BO": "673634",
      "Chikkode BO": "673645",
      "Bhoodan Colony BO": "679334",
      "Pathar BO": "679334",
      "Kunnummalpotti BO": "679331",
      "Moothedam BO": "679331",
      "Theyyathumpadam BO": "679331",
      "Adakkakundu BO": "676525",
      "Malappuram HO": "676505",
      "Ponani HO": "679577",
      "Manjerikla HO": "676121",
      "TirurKerala HO": "676101",
      "Kuttippuram SO": "679571",
      "Ariyallur SO": "676312",
      "Kodinhi SO": "676309",
      "Moonniyur SO": "676311",
      "Parpanangadi SO": "676303",
      "Randathani SO": "676510",
      "Tirur East Bazar SO": "676101",
      "Triprangode SO": "676108",
      "Valancheri SO": "676552",
      "Kanhiramukku SO": "679584",
      "Mookkuthala SO": "679574",
      "Ponani Nagaram SO": "679583",
      "Ponani South SO": "679586",
      "Vattamkulam SO": "679578",
      "Veliankode SO": "679579",
      "Chettipadi SO": "676319",
      "Kadampuzha SO": "676553",
      "Kottakkal SO": "676503",
      "Niramaruthur SO": "676109",
      "Pookayil Bazar SO": "676107",
      "TanurMBR SO": "676302",
      "Tayyalingal SO": "676320",
      "Alankode SO": "679585",
      "Eramangalam SO": "679587",
      "KaladiMLP SO": "679582",
      "Marancheri SO": "679581",
      "Tavanur SO": "679573",
      "Abdurahiman Nagar SO": "676305",
      "Edarikode SO": "676501",
      "Irimbiliyam SO": "679572",
      "Kuttayi SO": "676562",
      "MangalamMLP SO": "676561",
      "Paravanna SO": "676502",
      "Tanalur SO": "676307",
      "Thekkummuri SO": "676105",
      "Tirunavaya SO": "676301",
      "Tirurangadi SO": "676306",
      "Trikkandiyur SO": "676104",
      "Valakolam SO": "676508",
      "Edapal SO": "679576",
      "Kokkur SO": "679591",
      "Nannamukku SO": "679575",
      "Perumbadappu SO": "679580",
      "Bettath Pudiangadi SO": "676102",
      "Kadalundinagaram SO": "673314",
      "Kalpakancheri SO": "676551",
      "Othukkungal SO": "676528",
      "Ponmundam SO": "676106",
      "Thalakkadathur SO": "676103",
      "Tirurangadi Bazar SO": "676306",
      "Velimukku SO": "676317",
      "Vengara MLP SO": "676304",
      "Angadipuram SO": "679321",
      "Kodurmalabar SO": "676504",
      "Mongam SO": "673642",
      "Areacode SO": "673639",
      "Chelembra SO": "673634",
      "Edavanna SO": "676541",
      "Karuvambram SO": "676123",
      "Pandikkad SO": "676521",
      "Cherukara SO": "679340",
      "Kottilangadi SO": "676506",
      "Makkaraparamba SO": "676507",
      "Melattur SO Malappuram": "679326",
      "Pattikkad SO": "679325",
      "Pookkottur SO": "676517",
      "Pulamanthole SO": "679323",
      "Cheruvayur SO": "673645",
      "Kalikavu SO": "676525",
      "Kolaparamba SO": "676522",
      "Kuzhimanna SO": "673641",
      "Anamangad SO": "679357",
      "Downhill SO": "676519",
      "KolathurMLP SO": "679338",
      "Malappuram Civil Station SO": "676505",
      "Mankada SO": "679324",
      "Munduparmba SO": "676509",
      "Talekode SO": "679341",
      "Calicut University SO": "673635",
      "Edakkaranilambur SO": "679331",
      "Karuvarakundu SO": "676523",
      "Mampad SO": "676542",
      "Manimooly SO": "679333",
      "Manjeri Bazar SO": "676121",
      "Manjeri College SO": "676122",
      "Pookkottumpadam SO": "679332",
      "Wandoor SO": "679328",
      "Nilambur RS SO": "679330",
      "Nilambur SO": "679329",
      "Tuvvur SO": "679327",
      "Perintalmanna SO": "679322",
      "Calicut Airport SO": "673647",
      "Chungathara SO": "679334",
      "Kondotti SO": "673638",
      "Pulikkal SO": "673637",
      "Tenhipalam SO": "673636",
      "Vaniyambalam SO": "679339",
      "Vazhakkad SO": "673640"
    },
    "KOZHIKODE": {
      "Puducode  Feroke BO": "673633",
      "Kanni Paramba BO": "673661",
      "Vaidyarangadi BO": "673633",
      "Edakkad  West Hill BO": "673005",
      "Kayal BO": "673661",
      "Olavanna BO": "673019",
      "Perumanna BO": "673019",
      "Thiruthiyad BO": "673004",
      "Pazhur BO": "673661",
      "Vellayikkode BO": "673019",
      "Tiruvannur BO": "673029",
      "West Hill Chungam BO": "673005",
      "Cheekilode BO": "673315",
      "Kolathur BO": "673315",
      "Thuruthiyad BO": "673612",
      "Vattoli Bazar BO": "673612",
      "MELUR BO": "673306",
      "Avala BO": "673524",
      "Cheruvannur Meladi BO": "673524",
      "Kolakkad BO": "673315",
      "Kongannur BO": "673315",
      "Kariyathankavu BO": "673612",
      "Karumala BO": "673612",
      "Kappad BO": "673304",
      "Thuvakkode BO": "673304",
      "Thandorapara BO": "673526",
      "Kannan Kara BO": "673616",
      "Vengeri BO": "673010",
      "Manipuram BO": "673572",
      "Modakkallur BO": "673323",
      "Kannadipoil BO": "673612",
      "Kinalur BO": "673612",
      "Tiruvangoor BO": "673304",
      "Chakkittapara BO": "673526",
      "Keezhariyur BO": "673307",
      "Kakkayam BO": "673527",
      "Pannikkottur BO": "673572",
      "Kunnamangalam Mini Industrial BO": "673571",
      "Padanilam BO": "673571",
      "Poovaranthod BO": "673604",
      "Pannicode BO": "673602",
      "Chathamangalam BO": "673601",
      "Chulur BO": "673601",
      "Malayamma BO": "673601",
      "Nayar Kuzhi BO": "673601",
      "Velimanna BO": "673582",
      "Venappara BO": "673582",
      "Adivaram Pudupadi BO": "673586",
      "Kakkad Pudupadi BO": "673586",
      "Kythapoyil BO": "673586",
      "Mailellampara BO": "673586",
      "Maikavu BO": "673573",
      "Parappanpoyil BO": "673573",
      "Thachampoyil BO": "673573",
      "Anakampoyil BO": "673603",
      "Ponnamkayam BO": "673603",
      "Pulluram Para BO": "673603",
      "Punnakkal BO": "673603",
      "Thambalamanna BO": "673603",
      "Beypore North BO": "673015",
      "Kottamparamba BO": "673008",
      "Kuttikkattur BO": "673008",
      "Mayanad BO": "673008",
      "Kuttoth BO": "673524",
      "Muyipoth BO": "673524",
      "Kottur BO": "673614",
      "Mannankavu BO": "673614",
      "Moolad BO": "673614",
      "Nochat BO": "673614",
      "Poozhithode BO": "673528",
      "Urallur BO": "673620",
      "Annasseri BO": "673317",
      "Chorode East BO": "673106",
      "Cheekonnummal  West BO": "673507",
      "Mokeri Nadapuram BO": "673507",
      "Mullambath BO": "673507",
      "Nitumannur BO": "673507",
      "Poolakkul BO": "673507",
      "Thinur BO": "673507",
      "Naripetta BO": "673506",
      "Nedumparamba BO": "673506",
      "Vanimal BO": "673506",
      "Varikoli BO": "673506",
      "Vishnumangalam BO": "673506",
      "Akkal BO": "673513",
      "Chappanthottam BO": "673513",
      "Chathangottunada BO": "673513",
      "Karandode BO": "673508",
      "Kayakodi BO": "673508",
      "Kurichagam BO": "673508",
      "Muthuvannacha BO": "673508",
      "Velom Peruvayal BO": "673508",
      "Siddhasamaj BO": "673104",
      "Vayikkilassery BO": "673104",
      "Eramala BO": "673501",
      "Puliyavil BO": "673509",
      "Thanakottur BO": "673509",
      "Purakkad BO": "673522",
      "Mandarathur BO": "673105",
      "Pathiyarakkara BO": "673105",
      "Irivallur BO": "673616",
      "Kizhakkumuri BO": "673611",
      "Murampathy BO": "673580",
      "Velancode BO": "673580",
      "Avilora BO": "673572",
      "Kilakkoth BO": "673572",
      "Vavad BO": "673572",
      "Konott BO": "673571",
      "Manha Kadavu BO": "673604",
      "Karasseri BO": "673602",
      "Madavoor BO": "673585",
      "Parannur BO": "673585",
      "Vellalasseri BO": "673601",
      "Kallurutty BO": "673582",
      "Santhi Nagar BO": "673582",
      "Nooramthode BO": "673586",
      "Chamal BO": "673573",
      "Kudathai BO": "673573",
      "Kudathai Bazar BO": "673573",
      "Muthappan Puzha BO": "673603",
      "Cherukulathur BO": "673008",
      "Devagiri College BO": "673008",
      "Karayad BO": "673524",
      "Kizhpayur BO": "673524",
      "Avitanallur BO": "673614",
      "Kavil BO": "673614",
      "Oravil BO": "673323",
      "Tiruvode BO": "673614",
      "Edavarad BO": "673525",
      "Koothali BO": "673525",
      "Chempanoda BO": "673528",
      "Naderi BO": "673620",
      "Mangad BO": "673574",
      "Vayalada BO": "673574",
      "Kunnummakkara BO": "673308",
      "Onchiyam BO": "673308",
      "Muttungal BO": "673106",
      "Edacheri North BO": "673502",
      "Cheekkonnummal BO": "673507",
      "Cherapuram BO": "673507",
      "Nittur BO": "673507",
      "Padiripetta BO": "673507",
      "Vatayam BO": "673507",
      "Kodiyura BO": "673506",
      "Vilangad BO": "673506",
      "Chelakkad BO": "673506",
      "Kunduthode BO": "673513",
      "Moilothara BO": "673513",
      "Adukkath BO": "673508",
      "Paleri BO": "673508",
      "Taliyil BO": "673508",
      "Rayarangoth BO": "673102",
      "Perode BO": "673504",
      "Meppayil BO": "673104",
      "Puthur BO": "673104",
      "Chekkiyad BO": "673509",
      "Pallikara BO": "673522",
      "Kotancheri BO": "673503",
      "Ayancheri BO": "673541",
      "Velur West BO": "673315",
      "Eramangalam BO": "673612",
      "Kokkallur BO": "673612",
      "Panangad Qdi BO": "673612",
      "Cheliya BO": "673306",
      "Kallanode BO": "673527",
      "Muchukunnu BO": "673307",
      "Mudadi BO": "673307",
      "Mudadi North BO": "673307",
      "Cherukad BO": "673527",
      "Mattanode BO": "673527",
      "Makkada BO": "673611",
      "Morikkara BO": "673611",
      "Palath BO": "673611",
      "Karuvasseri BO": "673010",
      "Nedungottur BO": "673010",
      "Kannoth BO": "673580",
      "Kuppayakode BO": "673580",
      "Meemutty BO": "673580",
      "Payimbra BO": "673571",
      "Peringalam BO": "673571",
      "Koombara BO": "673604",
      "Koombara Bazar BO": "673604",
      "Alli BO": "673602",
      "Manasseri BO": "673602",
      "Mysore Mala BO": "673602",
      "Nellika Paramba BO": "673602",
      "Kakkur BO": "673613",
      "Pavandur BO": "673613",
      "Punnasseri BO": "673585",
      "Punnur  Cherupalam BO": "673585",
      "Vakayad BO": "673614",
      "Maniyur BO": "673523",
      "Eravattur BO": "673525",
      "Kadiyangad BO": "673525",
      "Kayanna Bazar BO": "673525",
      "Kilinnanyam BO": "673525",
      "Chengaroth BO": "673528",
      "Muthukad BO": "673528",
      "Arikulam BO": "673620",
      "Kakkancheri BO": "673323",
      "Kunnathara BO": "673323",
      "Peruvattoor BO": "673620",
      "Katalur BO": "673529",
      "Ekarool BO": "673574",
      "Emmamparamba BO": "673574",
      "Iyyad BO": "673574",
      "Muttungal West BO": "673106",
      "Ayanikkad BO": "673521",
      "Kottakkaligl BO": "673521",
      "Palayad Nada BO": "673521",
      "Pasukkadavu BO": "673513",
      "Poothampara BO": "673513",
      "Chemmarathur BO": "673104",
      "Keezhil BO": "673104",
      "Kurikkilad BO": "673104",
      "Kilur Meladi BO": "673522",
      "Edakkara  Quilandy BO": "673616",
      "Kuruvattur BO": "673611",
      "Chembu Kadavu BO": "673580",
      "Mundur  Kozhikode BO": "673580",
      "Theyyappara BO": "673580",
      "Elettil BO": "673572",
      "Karuvampoyil BO": "673572",
      "Valiyaparamba BO": "673572",
      "Chelavur BO": "673571",
      "Karanthur BO": "673571",
      "Pilasseri BO": "673571",
      "Kakkatampoyil BO": "673604",
      "Kuliramutty BO": "673604",
      "Paropadi BO": "673009",
      "Parambil BO": "673012",
      "Chennamangallur BO": "673602",
      "Kodiyathur BO": "673602",
      "Kumaranellur BO": "673602",
      "Eravannur BO": "673585",
      "Muttancheri BO": "673585",
      "Neeleswaram BO": "673582",
      "Puthur Kotuvalli BO": "673582",
      "Perumpally BO": "673586",
      "Kattippara BO": "673573",
      "Kalpathur BO": "673524",
      "Kozhukkallur BO": "673524",
      "Karuvannur BO": "673614",
      "Punath BO": "673614",
      "Iringath BO": "673523",
      "Muthuuvana BO": "673523",
      "Chenoli BO": "673525",
      "Mennaniam BO": "673525",
      "Avadukka BO": "673528",
      "Kuruvangad BO": "673620",
      "Naduvathur BO": "673620",
      "Chingapuram BO": "673529",
      "Talayad BO": "673574",
      "Korothroad BO": "673309",
      "Katcheri BO": "673502",
      "Arur BO": "673507",
      "Vattoli BO": "673507",
      "Indira Nagar BO": "673506",
      "Karingad BO": "673513",
      "Marudonkara BO": "673513",
      "Vannathichira BO": "673513",
      "Paleri Town BO": "673508",
      "Velom BO": "673508",
      "Kannookkara BO": "673102",
      "Iyyangode BO": "673504",
      "Memunda BO": "673104",
      "Nadakkuthala BO": "673104",
      "Kuningad BO": "673503",
      "Muthuvadathur BO": "673503",
      "Perumukham BO": "673631",
      "Govinda Puram BO": "673016",
      "Kommeri BO": "673007",
      "Cheruvadi BO": "673661",
      "Chaniyankadavu BO": "673541",
      "Thodannur BO": "673541",
      "Kayappanichi BO": "673505",
      "Mudavantheri BO": "673505",
      "Chuzhali BO": "673517",
      "Kallunira BO": "673517",
      "Kurinhaliyode BO": "673542",
      "Mayyannur BO": "673542",
      "Ponmeri Parambil BO": "673542",
      "Valliyad BO": "673542",
      "Tharopoyil BO": "673541",
      "Bhumivathukkal BO": "673517",
      "Karthikappally BO": "673542",
      "Kottappalli BO": "673542",
      "Eranhikkal BO": "673303",
      "Puthiya Nirathu BO": "673303",
      "Vengalam BO": "673303",
      "Kottuli BO": "673016",
      "Nellicode BO": "673016",
      "Iringallur BO": "673014",
      "Sreerama Krishna Mission BO": "673003",
      "Pokkunnu BO": "673007",
      "Cherooppa BO": "673661",
      "Karuvanthuruthy BO": "673631",
      "Kannancheri BO": "673003",
      "Cherandathur BO": "673541",
      "Iringannur BO": "673505",
      "Cherumoth BO": "673517",
      "Katameri BO": "673542",
      "Abhayagiri BO": "673517",
      "Velliparamba BO": "673008",
      "Peruvayal BO": "673008",
      "Poovattu Paramba BO": "673008",
      "Chevarambalam BO": "673017",
      "Vrindavan Colony BO": "673017",
      "Calicut HO": "673001",
      "Koyilandi HO": "673305",
      "Calicut Civil Station HO": "673020",
      "Vadakara HO": "673101",
      "Atholi SO": "673315",
      "Balusseri SO": "673612",
      "Chemancheri SO": "673304",
      "Kollam SO": "673307",
      "Koorachundu SO": "673527",
      "Meppayur SO": "673524",
      "Iringal SO": "673521",
      "Kakkattil SO": "673507",
      "Kallachi SO": "673506",
      "Kavilampara SO": "673513",
      "Nadapuram SO": "673504",
      "Nut Street SO": "673104",
      "Parakkadavu SO": "673509",
      "Tuneri SO": "673505",
      "Naduvannur SO": "673614",
      "Thalakolathur SO": "673317",
      "Madappalli College SO": "673102",
      "Orkatteri SO": "673501",
      "Puduppanam SO": "673105",
      "Edakulam  Koyilandi SO": "673306",
      "Perampra SO": "673525",
      "Peruvannamuzhi SO": "673528",
      "Chombala SO": "673308",
      "Chorode SO": "673106",
      "Purameri SO": "673503",
      "Thiruvallur SO": "673541",
      "Vadakara Beach SO": "673103",
      "Villyappalli SO": "673542",
      "Kayanna SO": "673526",
      "Payyoli Angadi SO": "673523",
      "Quilandibazar SO": "673620",
      "Tikkoti SO": "673529",
      "Unnikulam SO": "673574",
      "ULLIYERI SO": "673323",
      "Azhiyur SO": "673309",
      "Edacheri SO": "673502",
      "Kuttiadi SO": "673508",
      "Payyoli SO": "673522",
      "Valayam SO": "673517",
      "West Hill Beach SO": "673005",
      "Vellayil SO": "673011",
      "Marikunnu SO": "673012",
      "Mokkam SO": "673602",
      "Narikkuni SO": "673585",
      "Nit  Campus PoKozhikode SO": "673601",
      "Puduppadi SO": "673586",
      "Arakinar SO": "673028",
      "Calicut Medical College SO": "673008",
      "Calicut RS SO": "673001",
      "Chevayur SO": "673017",
      "Farook College SO": "673632",
      "Feroke SO": "673631",
      "Guruvayurappan College SO": "673014",
      "Mannur SO Kozhikode": "673328",
      "Nadakavu SO": "673011",
      "Ramanattukara SO": "673633",
      "Tali SO": "673002",
      "Nanminda SO": "673613",
      "Feroke Pettah SO": "673631",
      "Kallaikozhikode SO": "673003",
      "Kuthiravattom SO": "673016",
      "Puthiyara SO": "673004",
      "West Hill SO": "673005",
      "KOZHIKODE PARCEL CENTRE": "673051",
      "Tamaracheri SO": "673573",
      "Tiruvambadi SO": "673603",
      "Calicut Beach SO": "673032",
      "Calicut City SO": "673004",
      "Chalapuram SO": "673002",
      "Chaliyam SO": "673301",
      "Elathur SO Kozhikode": "673303",
      "Kolathara SO": "673655",
      "Mankavu SO": "673007",
      "Mavoor SO Kozhikode": "673661",
      "Puthiyangadi SO": "673021",
      "Kutaranni SO": "673604",
      "Malaparamba SO": "673009",
      "Omasseri SO": "673582",
      "Beypore SO": "673015",
      "Calicut Arts  Science College SO": "673018",
      "Calicut Courts SO": "673032",
      "Cheruvannur SO": "673655",
      "East Hill SO": "673005",
      "Kadalundi SO": "673302",
      "Nallalam SO": "673027",
      "Pantheerankavu SO": "673019",
      "Parappil SO": "673001",
      "Tiruvannur Nada SO": "673029",
      "Calicut Collectorate SO": "673020",
      "Chelannur SO": "673616",
      "Kotancheritamaracheri SO": "673580",
      "Iim Kozhikode Campus SO": "673570",
      "Karaparamba SO": "673010",
      "Kunnamangalam SO": "673571",
      "Eranhipalam SO": "673006",
      "Kakkoti SO": "673611",
      "Kotuvalli SO": "673572"
    },
    "KOTTAYAM": {
      "Kadayanickad BO": "686541",
      "Mukkada BO": "686544",
      "Channanikadu BO": "686533",
      "Erathuvadakara BO": "686543",
      "Manthuruthy BO": "686542",
      "Mammoodu BO": "686536",
      "Kurichy BO": "686532",
      "Thottackad West BO": "686539",
      "Malakunnam BO": "686535",
      "Vakathanam South BO": "686538",
      "Manalunkal BO": "686503",
      "Champakara BO": "686540",
      "Chelacompu BO": "686540",
      "Cheruvally BO": "686543",
      "Fathimapuram BO": "686102",
      "Panachikavu BO": "686102",
      "Kottamurickal BO": "686105",
      "Nalunnackal BO": "686538",
      "Ponganthanam BO": "686538",
      "Kulathoorprayar BO": "686541",
      "Mundathanam BO": "686541",
      "Thazhathuvadakara BO": "686541",
      "Vellavoor BO": "686541",
      "Alapra BO": "686544",
      "Poovatholy BO": "686544",
      "Pulikkallu BO": "686544",
      "Santhipuram BO": "686545",
      "Anikad East BO": "686503",
      "Anikad West BO": "686503",
      "Aruvikuzhy BO": "686503",
      "Elampally BO": "686503",
      "Cheeranchira BO": "686106",
      "Edayarickapuzha BO": "686541",
      "Karikkattoor Centre BO": "686544",
      "Ponthenpuzha BO": "686544",
      "Koothrappally BO": "686540",
      "Veroor BO": "686104",
      "Amara BO": "686546",
      "Nedumanny BO": "686542",
      "Kurumpanadom BO": "686536",
      "Pathamuttom BO": "686532",
      "Eravuchira BO": "686539",
      "Umbidi BO": "686539",
      "Ithithanam BO": "686535",
      "Puthenchantha BO": "686538",
      "Ruby Nagar BO": "686103",
      "Kalloorkulam BO": "686503",
      "Moozhoor BO": "686503",
      "Anakkal BO": "686508",
      "Chemmalamattom BO": "686508",
      "Yendayar BO": "686514",
      "Rajendraprasad Colony BO": "686513",
      "Urakkanadu BO": "686512",
      "Vengathanam BO": "686512",
      "Thampalakkad BO": "686506",
      "Chirakadavu East BO": "686520",
      "Kannimala BO": "686509",
      "Panamattom BO": "686522",
      "Parathanam BO": "686514",
      "Chenappady BO": "686520",
      "Pazhayidom BO": "686520",
      "Kanakapalam BO": "686509",
      "Kuruvammoozhy BO": "686509",
      "Propose BO": "686509",
      "Thalumkal BO": "686514",
      "Panachepally BO": "686518",
      "Vizhikithode BO": "686518",
      "Karinilam BO": "686513",
      "Kooropada BO": "686502",
      "Lakkattoor BO": "686502",
      "Kanjiramattom BO": "686585",
      "Kanjirappara BO": "686555",
      "Chettuthode BO": "686508",
      "Kappadu BO": "686508",
      "Vanchimala BO": "686508",
      "Elamkadu BO": "686514",
      "Kanamala BO": "686510",
      "Muttappally BO": "686510",
      "Pampavally North BO": "686510",
      "Koruthode BO": "686513",
      "Pangada BO": "686502",
      "Pothenpuram BO": "686502",
      "Suryanarayana Puram BO": "686502",
      "Poothakuzhy BO": "686521",
      "Edakkunnam BO": "686512",
      "Inchiyani BO": "686512",
      "Chennakunnu BO": "686506",
      "Velanilam BO": "686514",
      "Palampra BO": "686518",
      "Edakadathy BO": "686510",
      "Madukka BO": "686513",
      "Punchavayal BO": "686513",
      "Kothala BO": "686502",
      "Chittadi BO": "686512",
      "Kanjirapally West BO": "686506",
      "Kanam BO": "686515",
      "Kavumbhagom BO": "686519",
      "Areeparampu BO": "686501",
      "Nariyanani BO": "686506",
      "Mannarakayam BO": "686506",
      "Ponkunnam Court BO": "686506",
      "Chirakadavu Centre BO": "686519",
      "Vazhoor East BO": "686504",
      "Kodumpidi BO": "686651",
      "Kurumannu BO": "686651",
      "Pravithanam BO": "686651",
      "Ullanad BO": "686651",
      "Kizhathadiyur BO": "686574",
      "Ponadkarur BO": "686574",
      "Vallichira BO": "686574",
      "Velliappally BO": "686574",
      "Edappady BO": "686578",
      "Idamattom BO": "686578",
      "Kizhaparayar BO": "686578",
      "Nadackal BO": "686121",
      "Padinjattinkara BO": "686571",
      "Kattachira BO": "686572",
      "Cholathadom BO": "686582",
      "Kaipally BO": "686582",
      "Kunnonni BO": "686582",
      "Pathampuzha BO": "686582",
      "Elikulam BO": "686577",
      "Arunoottimangalam BO": "686604",
      "Kallara South BO": "686611",
      "Perumthuruth BO": "686611",
      "Ambika Market BO": "686144",
      "Vechoor BO": "686144",
      "Chempu BO": "686608",
      "Enadi BO": "686608",
      "Maravanthuruthu BO": "686608",
      "Mannackanad BO": "686633",
      "Nazreth Hill BO": "686633",
      "Pakalomattom BO": "686633",
      "Vempally BO": "686633",
      "Kurianad BO": "686636",
      "Eravimangalam BO": "686613",
      "Ezhumanthuruth BO": "686613",
      "Ayyarkulangara BO": "686146",
      "Vaikaprayar BO": "686146",
      "Vaikom Thekkenada BO": "686146",
      "Mulakulam South BO": "686610",
      "Chemmanathukara BO": "686606",
      "Pallippurathussery BO": "686606",
      "Akkarapadom BO": "686143",
      "Elakad BO": "686587",
      "Kudalloor BO": "686587",
      "Vattukulam BO": "686587",
      "Sreekantamangalam BO": "686562",
      "Pulikkuttissery BO": "686015",
      "Punnathura West BO": "686631",
      "Arpookara BO": "686008",
      "Arpookara East BO": "686008",
      "Kothanallur BO": "686632",
      "Thiruvarppu BO": "686020",
      "Mariathuruthu BO": "686017",
      "Kumarakom North BO": "686563",
      "Amayannur BO": "686019",
      "Kottayam South BO": "686013",
      "Parippu BO": "686014",
      "Payyappady BO": "686011",
      "Kummanam BO": "686005",
      "Alanad BO": "686651",
      "Neeloor BO": "686651",
      "Payyappar BO": "686651",
      "Nechipuzhoor BO": "686574",
      "Melampara BO": "686578",
      "Chempilavu BO": "686584",
      "Punnathura BO": "686583",
      "Palakkattumala BO": "686635",
      "Kizhakkenmattom BO": "686652",
      "Chovvur BO": "686586",
      "Ezhacherry BO": "686651",
      "Kayyoor BO": "686651",
      "Chakkampuzha BO": "686574",
      "Edanad BO": "686574",
      "Kummannoor BO": "686572",
      "Kudakkachira BO": "686635",
      "Edamaruku BO": "686652",
      "Konipad BO": "686652",
      "Mary Land BO": "686652",
      "Melukavu BO": "686652",
      "Mechal BO": "686586",
      "Choondacherry BO": "686579",
      "Nariayanganam BO": "686579",
      "Chennad BO": "686581",
      "Mevada BO": "686573",
      "Mutholi BO": "686573",
      "Amanakara BO": "686576",
      "Idiyanal BO": "686576",
      "Kizhathiri BO": "686576",
      "Koodapalam BO": "686576",
      "Kurinji BO": "686576",
      "Thalanad BO": "686580",
      "Kappumthala BO": "686613",
      "Vadakkenirappu BO": "686612",
      "Ozhavur East BO": "686634",
      "Veliyannoor BO": "686634",
      "Brahmamangalam BO": "686605",
      "Edavattom BO": "686605",
      "Midayikunnu BO": "686605",
      "Vadakara  Thalayolaparambu BO": "686605",
      "Vadayar BO": "686605",
      "Kalathukadavu BO": "686579",
      "Adivaram BO": "686582",
      "Peringalam BO": "686582",
      "Mallikassery BO": "686577",
      "Njandupara BO": "686577",
      "Mediri BO": "686576",
      "Adukkam BO": "686580",
      "Velathusseri BO": "686580",
      "Poozhikole BO": "686604",
      "Kalathoor BO": "686633",
      "Kanjirathanam BO": "686603",
      "Manjoor South BO": "686603",
      "Puthuvely BO": "686636",
      "Kattampack BO": "686612",
      "Marangoli BO": "686612",
      "Kothavara BO": "686607",
      "Karipadom BO": "686605",
      "Keezhoor BO": "686605",
      "Karimpani BO": "686564",
      "Veloor BO": "686003",
      "Cheepunkal BO": "686563",
      "Thiruvanchoor BO": "686019",
      "Vattakunnu BO": "686516",
      "Devalokam BO": "686004",
      "Moolavattom BO": "686012",
      "Poovanthuruthu GDSBO": "686012",
      "Thrikothamangalam BO": "686011",
      "Mattathipara BO": "686651",
      "Pizhaku BO": "686651",
      "Kadappattoor BO": "686574",
      "Mundankal BO": "686574",
      "Ampara Nirappel BO": "686578",
      "Poovathode BO": "686578",
      "Kezhuvankulam BO": "686584",
      "Valavoor BO": "686635",
      "Erumapramattom BO": "686586",
      "Anjoottimangalam BO": "686579",
      "Madukkakunnu BO": "686577",
      "Meenachil BO": "686577",
      "Kozhuvanal BO": "686573",
      "Thodanal BO": "686573",
      "Ramapuram BO": "686576",
      "Vellikulam BO": "686580",
      "Memuri BO": "686611",
      "Kozha BO": "686633",
      "Chamakala BO": "686603",
      "Kuruppamthara BO": "686603",
      "Pious Mount BO": "686636",
      "Vakad BO": "686636",
      "Ayamkudy BO": "686613",
      "Thiruvanpady BO": "686612",
      "Kurichithanam BO": "686634",
      "Karikode BO": "686610",
      "Thottakom BO": "686607",
      "Irumpayam BO": "686605",
      "Pattithanam BO": "686631",
      "Vettimukal BO": "686631",
      "Villoonni BO": "686008",
      "Kurumulloor BO": "686632",
      "Kanjiram BO": "686020",
      "Kumarakom East BO": "686563",
      "Kumarakom South BO": "686563",
      "Malam BO": "686019",
      "Amalagiri BO": "686561",
      "Kollad BO": "686004",
      "Mariappally BO": "686013",
      "Moozhikulangara BO": "686601",
      "Eravinalloor BO": "686011",
      "Arumanur BO": "686564",
      "Kongandoor BO": "686564",
      "Mattakkara BO": "686564",
      "Neerikkad BO": "686564",
      "Paduva BO": "686564",
      "Kottakkapuram BO": "686631",
      "Onamthuruthu BO": "686602",
      "Perumbaikkad BO": "686016",
      "Parampuzha BO": "686004",
      "Kottayam HO": "686001",
      "Pala HO": "686575",
      "Vaikom HO": "686141",
      "Changanacherry HO": "686101",
      "Kanjirapally HO": "686507",
      "Athirampuzha SO": "686562",
      "Ayarkunnam SO": "686564",
      "Chengalam South SO": "686022",
      "Kaipuzha SO": "686602",
      "Kiliroor North SO": "686020",
      "Kottayam Collectorate SO": "686002",
      "Nattakom SO": "686013",
      "Pakkil SO": "686012",
      "Ettumanur Junction SO": "686631",
      "Ettumanur SO": "686631",
      "Kottayam West SO": "686003",
      "Kudamaloor SO": "686017",
      "Meenadom SO": "686516",
      "Muttambalam SO": "686004",
      "Thazhathangady SO": "686005",
      "Thirunakkara SO": "686001",
      "Kadanad Meenachil SO": "686653",
      "Moonnilavu SO": "686586",
      "Pala Town SO": "686575",
      "Plassanal SO": "686579",
      "Poonjar Thekkekara SO": "686582",
      "Ramapuram Bazar SO": "686576",
      "Kallara SO Kottayam": "686611",
      "Kulasekharamangalam SO": "686608",
      "Manjoor SO": "686603",
      "Mevelloor SO": "686609",
      "Newsprint Nagar SO": "686616",
      "Ozhavur SO": "686634",
      "Padinjarekkara SO": "686146",
      "Thalayazham SO": "686607",
      "Anthinad SO": "686651",
      "Aruvithura SO": "686122",
      "Bharananganam SO": "686578",
      "Cherpunkal SO": "686584",
      "Kidangoor SO": "686572",
      "Marangattupally SO": "686635",
      "Poovarani SO": "686577",
      "Puliyannoor SO": "686573",
      "Peruva SO": "686610",
      "Thalayolaparambu SO": "686605",
      "Vayala SO": "686587",
      "Thellakom SO": "686630",
      "Vadavathoor SO": "686010",
      "Arunapuram SO": "686574",
      "Melukavumattom SO": "686652",
      "Poonjar SO": "686581",
      "Thidanad SO": "686123",
      "Udayanapuram SO": "686143",
      "Pampady SO": "686502",
      "Aymanam SO": "686015",
      "Gandhi Nagar SO Kottayam": "686008",
      "Kanakari SO": "686632",
      "Kumarakom SO": "686563",
      "Kumaranalloor SO": "686016",
      "Manarcaudu SO": "686019",
      "Mannanam SO": "686561",
      "Olessa SO": "686014",
      "Pariyaram SO Kottayam": "686021",
      "Peroor SO": "686637",
      "Puthupalli SO": "686011",
      "Priyadarsini Hills SO": "686560",
      "Kuzhimattom SO": "686533",
      "Madappally SO": "686546",
      "Nalukody SO": "686548",
      "Pallickachirakavala SO": "686537",
      "Perumpanachy SO": "686536",
      "Sachivothamapuram SO": "686532",
      "Vakathanam SO": "686538",
      "Chakompathal SO": "686517",
      "Chengalam SO": "686585",
      "Kalaketty SO": "686508",
      "Koorali SO": "686522",
      "Kottayam North SO": "686001",
      "Malloossery SO": "686041",
      "Manganam SO": "686018",
      "Nattassery S H Mount SO": "686006",
      "Neendoor SO": "686601",
      "Pallom SO": "686007",
      "Changanacherry College SO": "686101",
      "Karikkattoor SO": "686544",
      "Karukachal SO": "686540",
      "Manimala SO": "686543",
      "Nedumkunnam SO": "686542",
      "Nedungadappally SO": "686545",
      "Thrickodithanam SO": "686105",
      "Thuruthy SO": "686535",
      "Erumely SO": "686509",
      "Koovapally SO": "686518",
      "Rubber Board SO": "686009",
      "Erattupetta SO": "686121",
      "Kadaplamattom SO": "686571",
      "Kidangoor South SO": "686583",
      "Pala Market Junction SO": "686575",
      "Teekoy SO": "686580",
      "Kaduthuruthy SO": "686604",
      "Kudavechoor SO": "686144",
      "Kuravilangadu SO": "686633",
      "Monippally SO": "686636",
      "Muttuchira SO": "686613",
      "Njizhoor SO": "686612",
      "Thirumani Venkita Puram SO": "686606",
      "Mundakayam SO": "686513",
      "Parathode SO Kottayam": "686512",
      "Ponkunnam SO": "686506",
      "Vazhoor SO": "686504",
      "Changanacherry Industrialnagar SO": "686106",
      "Changanacherry Market SO": "686101",
      "Chingavanam SO": "686531",
      "Kangazha SO": "686541",
      "Perunna SO": "686102",
      "Thottakadu SO": "686539",
      "Vazhappally West SO": "686103",
      "Chirakadavu SO": "686520",
      "Koottickal SO": "686514",
      "Kurisummoodu SO": "686104",
      "Anikad SO": "686503",
      "Devagiri SO": "686555",
      "Theerthapadapuram SO": "686505",
      "Velloor SO": "686501",
      "Pampady South SO": "686521",
      "Pulickakavala SO": "686515",
      "Thekkethukavala SO": "686519"
    },
    "PATHANAMTHITTA": {
      "Gavi BO": "685533",
      "Pampa Dam BO": "685533",
      "Mallappuzhassery BO": "689533",
      "Velliyara BO": "689612",
      "Kanjeettukara BO": "689611",
      "Poovathoor BO": "689531",
      "Edappavoor BO": "689614",
      "Thekkumkal BO": "689614",
      "Nellimala BO": "689542",
      "Kaithakody BO": "689614",
      "Muttumon BO": "689547",
      "Kunnathukara HSC BO": "689546",
      "Kolabhagom BO": "689545",
      "Narakathanni BO": "689544",
      "Paduthode BO": "689544",
      "Thelliyoor BO": "689544",
      "Kadamankulam BO": "689583",
      "Anjilithanam BO": "689582",
      "Neervilakom BO": "689122",
      "Nalkallikkal BO": "689533",
      "Malakara BO": "689532",
      "Eraviperoor East BO": "689542",
      "Kadapra Kumbanadu BO": "689547",
      "Kurunghazhabhagom BO": "689548",
      "Varayannur BO": "689548",
      "Kavungumprayar BO": "689543",
      "Mundamala BO": "689543",
      "Arattupuzha BO": "689123",
      "Mallappally North BO": "689594",
      "Kottoor BO": "689582",
      "Kallumkal BO": "689102",
      "Manthanam BO": "689581",
      "Mannadisala BO": "686511",
      "Kuravankuzhy BO": "689548",
      "Madathumbhagom North BO": "689543",
      "Valakuzhy BO": "689544",
      "Amichikary BO": "689112",
      "Kottangal BO": "686547",
      "Chalappally BO": "689586",
      "Venpala BO": "689102",
      "Padimon BO": "689587",
      "Mundiappally BO": "689581",
      "Edayaramula West BO": "689532",
      "Erumakkad BO": "689532",
      "Kurichimuttom BO": "689532",
      "Kariamplavu BO": "689615",
      "Chirayirambu BO": "689549",
      "Vellayil BO": "689613",
      "Alumthuruthy BO": "689113",
      "Perumpramavu BO": "689587",
      "Chathenthara BO": "686510",
      "Thulappally BO": "686510",
      "Venkurinji BO": "686510",
      "Attachakkal BO": "689692",
      "Ellimullumplackal BO": "689692",
      "Perinjottackal BO": "689692",
      "Kakkudumon BO": "689711",
      "Koonamkara BO": "689711",
      "Cherukulanji BO": "689673",
      "Kochukoikkal BO": "689667",
      "Kottamonpara BO": "689667",
      "Thuvayur South BO": "691552",
      "Padam BO": "689694",
      "Kodumon East BO": "691555",
      "Chenneerkara BO": "689503",
      "Panangad BO": "689503",
      "Musaliar College BO": "689653",
      "Vettur Kumbazha BO": "689653",
      "Thombikandam BO": "689676",
      "Mekozhur BO": "689678",
      "Mathur BO": "689647",
      "Vazhamuttom BO": "689647",
      "Adumpumkulam BO": "689692",
      "Madamon BO": "689711",
      "Mampara BO": "689711",
      "Uthimoodu BO": "689672",
      "Iythala BO": "689673",
      "Gurunathanmannu BO": "689667",
      "Thekkuthode BO": "689699",
      "Kumaramperoor Thekkekkara BO": "689662",
      "Maniyar BO": "689662",
      "Moozhiar BO": "689662",
      "Elappupara BO": "689656",
      "Marur BO": "691524",
      "Muttathukonam BO": "689625",
      "Thumpamon North BO": "689625",
      "Kaithaparambu BO": "691526",
      "Vadakkedathukavu Jn BO": "691526",
      "Angadical South BO": "691555",
      "Athirumkal BO": "689693",
      "Kaipuzha North BO": "689503",
      "Chengara BO": "689664",
      "Thalachira Eram BO": "689664",
      "Thengumcavu BO": "689646",
      "Vazhamuttom East BO": "689646",
      "Chengalthadom BO": "689671",
      "Naranganam North BO": "689642",
      "Naranganam West BO": "689642",
      "Adichipuzha BO": "689711",
      "Edakulam BO": "689672",
      "Keekozhur BO": "689672",
      "Mandiram Jn BO": "689672",
      "Puthusserimala BO": "689672",
      "Vayalathala BO": "689672",
      "Manneera BO": "689699",
      "Angamoozhy BO": "689662",
      "Pampa Triveni B O": "689662",
      "Pezhumpara BO": "689662",
      "Muthupezhumkal BO": "689698",
      "Njakkunilam BO": "689656",
      "MangaduElamannur BO": "691524",
      "Kulathumon BO": "689693",
      "Murinjakal BO": "689693",
      "Nedumoncavu BO": "689693",
      "Nirathupara BO": "689693",
      "Vadakkupuram BO": "689653",
      "Ranny Edamon BO": "689676",
      "Mannarakulanji BO": "689678",
      "Mammoodu BO": "689513",
      "Oonnukal BO": "689647",
      "Kudamurutty BO": "689711",
      "Naranamoozhy BO": "689711",
      "Karikulam BO": "689673",
      "Lahai BO": "689662",
      "Thumpamon Thazham BO": "689625",
      "Thazhathuvadakku BO": "691526",
      "Edakkad BO": "691552",
      "Karithotta BO": "689514",
      "Edathitta BO": "691555",
      "Manthuka BO": "689503",
      "Ullannur BO": "689503",
      "Choorakode BO": "691551",
      "Parakoottam BO": "691551",
      "Mudiyoorkonam BO": "689501",
      "Thengamom BO": "690522",
      "Nellikkamon BO": "689674",
      "Pulloopram BO": "689674",
      "Elanthur East BO": "689643",
      "Nellikala BO": "689643",
      "Valiyakavu BO": "689675",
      "Anthiyalankavu BO": "689649",
      "Angadical North BO": "689648",
      "Nellikkapara BO": "689691",
      "Kozhencherry East BO": "689641",
      "Kurampala South BO": "689501",
      "Paranthal BO": "689501",
      "Melood BO": "691554",
      "Pazhakulam BO": "691554",
      "Puthumala BO": "691554",
      "Theppupara BO": "691554",
      "Vayala Parakode BO": "691554",
      "Karikayam BO": "689663",
      "Neeliplavu BO": "689663",
      "Pampini BO": "689663",
      "Vayyattupuzha BO": "689663",
      "Aruvappulam BO": "689691",
      "Elakollur BO": "689691",
      "Kallely BO": "689691",
      "Kallely Thottam BO": "689691",
      "Kokkathode BO": "689691",
      "Vellappara BO": "689691",
      "Melukara BO": "689641",
      "Kizhakkupuram BO": "689653",
      "Kadapra Mannar BO": "689621",
      "Valanjavattom East BO": "689104",
      "Pallickal nooranad BO": "690504",
      "Chumathra BO": "689103",
      "Kizhakkumbhagom BO": "689621",
      "Niranam Central BO": "689621",
      "Karakkal BO": "689108",
      "Ulanad BO": "689503",
      "Nellimukal BO": "691551",
      "Peringanad BO": "691551",
      "Chayalode BO": "691556",
      "Mannam Nagar BO": "689501",
      "Mannam Sugar Mills BO": "689501",
      "Keerukuzhy BO": "689502",
      "Chethackal BO": "689677",
      "Elanthur Pariyaram BO": "689643",
      "Mundukottackal BO": "689649",
      "Aryavon BO": "689691",
      "Kummannoor BO": "689691",
      "Oottupara BO": "689691",
      "Anikad Mallappally GDS BO": "689585",
      "Nedumpuram BO": "689110",
      "Kozhimala BO": "689541",
      "Anandapally BO": "691525",
      "Parakara BO": "691525",
      "Muttom Thumpamon BO": "689502",
      "Oonnakavu BO": "689674",
      "Kattoor Kozhencherry BO": "689650",
      "Thonniamala BO": "689668",
      "Edapariyaram BO": "689643",
      "Karamvely BO": "689643",
      "Prakkanam BO": "689643",
      "Chandanapally BO": "689648",
      "Vallicode BO": "689648",
      "Palackathakidi BO": "689581",
      "Thengeli BO": "689106",
      "Pariyaram BO": "689585",
      "Kattode BO": "689105",
      "Pushpagiri Tiruvalla BO": "689105",
      "Perumthuruthy BO": "689107",
      "Vadakkumbhagom BO": "689621",
      "Nooromavu BO": "689589",
      "Kulathur BO": "689588",
      "Thottabhagom BO": "689541",
      "Vallamkulam East BO": "689541",
      "Adur Kla HO": "691523",
      "Tiruvalla HO": "689101",
      "Pathanamthitta HO": "689645",
      "Poozhikkad SO": "689515",
      "Kunnam Vechoochira SO": "686511",
      "Ayroor South SO": "689611",
      "Eraviperoor SO": "689542",
      "Koipuram SO": "689531",
      "Maramon SO": "689549",
      "Othera SO": "689546",
      "Thadiyur SO": "689545",
      "Theodical SO": "689613",
      "Chathankary SO": "689112",
      "Mukkoottuthara SO": "686510",
      "Kallooppara SO": "689583",
      "Kavumbhagom SO": "689102",
      "Kunnamthanam SO": "689581",
      "Kuttapuzha SO": "689103",
      "Niranam SO": "689621",
      "Podiyadi SO": "689110",
      "Tiruvalla RS SO": "689111",
      "Ayroor North SO": "689612",
      "Kottanad SO": "689615",
      "Kumbanadu SO": "689547",
      "Ezhumattoor SO": "689586",
      "Kuttur SO Pathanamthitta": "689106",
      "Manjady Jn SO": "689105",
      "Muthoor SO": "689107",
      "Parumala SO": "689626",
      "Punnavely SO": "689589",
      "Thirumoolapuram SO": "689115",
      "Thuruthicaud SO": "689597",
      "Tiruvalla Market Jn SO": "689101",
      "Vaipur SO": "689588",
      "Otherawest SO": "689551",
      "Pullad SO": "689548",
      "Puramattom SO": "689543",
      "Keezhvaipur SO": "689587",
      "Mallappally West SO": "689585",
      "Perumpatty SO": "689592",
      "Valanjavattom SO": "689104",
      "Vallamkulam SO": "689541",
      "Aranmula SO": "689533",
      "Edayarnmula SO": "689532",
      "Kottathoor SO": "689614",
      "Kuriannoor SO": "689550",
      "Vennikulam SO": "689544",
      "Azhiyadathuchira SO": "689113",
      "Chengaroor SO": "689594",
      "Chunkapara SO": "686547",
      "Kaviyoor SO": "689582",
      "Mallappally East SO": "689584",
      "Mepral SO": "689591",
      "Peringara SO": "689108",
      "Puthusserry South SO": "689602",
      "Elamannur SO": "691524",
      "Kadambanad SO": "691552",
      "Kidangannur SO": "689514",
      "Koodal SO": "689693",
      "Mezhuveli SO": "689507",
      "Nedumon SO": "691556",
      "Pandalam SO Pathanamthitta": "689501",
      "Parakode SO": "691554",
      "Thattayil SO": "691525",
      "Chellakkad SO": "689677",
      "Kaipattur SO": "689648",
      "Kozhencherry SO": "689641",
      "Kumbazhamuri SO": "689653",
      "Kuzhikala SO": "689644",
      "Makkankunnu SO": "689645",
      "Malayalapuzha Eram SO": "689664",
      "Mylapra SO": "689671",
      "Nariapuram SO": "689513",
      "Rannypazhavangadi SO": "689673",
      "Seethathode SO": "689667",
      "Thannithode SO": "689699",
      "Enathu SO": "691526",
      "Kadambanad South SO": "691553",
      "Mannady SO Pathanamthitta": "691530",
      "Chittar SO": "689663",
      "Churulicode SO": "689668",
      "Ettichuvadu SO": "689675",
      "Makkapuzha SO": "689676",
      "Mylapra Town SO": "689678",
      "Omallurkla SO": "689647",
      "Punnakkad SO": "689652",
      "Vadasserikara SO": "689662",
      "Vakayar SO": "689698",
      "Vallicode Kottayam SO": "689656",
      "Kalanjoor SO": "689694",
      "Kodumon SO": "691555",
      "Manakala SO": "691551",
      "Pandalam Medical Mission SO": "689501",
      "Angadi SO Pathanamthitta": "689674",
      "Cherukole Kozhencherri SO": "689650",
      "Elanthur SO": "689643",
      "Kadammanitta SO": "689649",
      "Konny SO": "689691",
      "Kozhencherry  Thekkemala SO": "689654",
      "Kumpalampoika SO": "689661",
      "Mallasseri SO": "689646",
      "Payyanamon SO": "689692",
      "Ranny Perinad SO": "689711",
      "SABARIMALA": "689713",
      "Elavanthitta SO": "689625",
      "Kulanada SO": "689503",
      "Thumpamon SO": "689502",
      "Kozhencherry College SO": "689641",
      "Malayalapuzha Thazham SO": "689666",
      "Naranganam SO": "689642",
      "Ranny SO": "689672"
    },
    "KOLLAM": {
      "Vattathamara BO": "691536",
      "Nellimukku BO": "691509",
      "Kollayil BO": "691541",
      "Venkolla BO": "691541",
      "Extension Trg Centre BO": "691531",
      "Kizhakketheruvu BO": "691531",
      "Mavadi BO": "691507",
      "Pavithreswaram BO": "691507",
      "Vendar BO": "691507",
      "Panavely BO": "691532",
      "Mailom BO": "691560",
      "Kulakkadathazham BO": "691521",
      "Nedumoncavu BO": "691509",
      "Thrippilazhikom BO": "691509",
      "Kudavattur BO": "691512",
      "Perumkulam BO": "691566",
      "Meeyannur BO": "691537",
      "Karikkom BO": "691531",
      "Iverkala East BO": "691507",
      "Thevalappuram BO": "691507",
      "Edayam BO": "691532",
      "Perumannur BO": "691532",
      "Thalachira BO": "691538",
      "Cherupoika BO": "691543",
      "Thamarakudy BO": "691560",
      "Kulakkada East BO": "691521",
      "Vakkanad BO": "691509",
      "Kaithode BO": "691535",
      "Muttara BO": "691512",
      "Kattadi Jn BO": "691537",
      "Mailode BO": "691537",
      "Nettayam BO": "691537",
      "Court Complex BO": "691531",
      "Karimpinpuzha BO": "691507",
      "Kottathala BO": "691507",
      "Ambalakkara BO": "691532",
      "Andoor BO": "691532",
      "Veliyam West BO": "691540",
      "Kokkad BO": "691538",
      "Akkal BO": "691516",
      "Cheriyavelinallur BO": "691516",
      "Chenkulam BO": "691510",
      "Meeyana BO": "691510",
      "Plappally BO": "691531",
      "Sadanandapuram BO": "691531",
      "Podiyattuvila BO": "691532",
      "Vayakkal BO": "691532",
      "Vattakarikkakom BO": "695562",
      "Edamulackal BO": "691306",
      "Ezhiyam Vattathra Mala Mukku BO": "691306",
      "Nediyara BO": "691306",
      "Vadamon BO": "691306",
      "Cheruvakkal BO": "691533",
      "Elamadu BO": "691533",
      "Manjappara BO": "691533",
      "Ozhukkuparackal BO": "691533",
      "Ayiranallur BO": "691307",
      "Mampazhathara BO": "691307",
      "Urukunnu BO": "691307",
      "Elicode BO": "691322",
      "Manalil BO": "691312",
      "Aryankavu BO": "691309",
      "Edapalayam BO": "691309",
      "Dally BO": "691310",
      "Koovakkad BO": "691310",
      "Samnagar BO": "691310",
      "Thingalkarikom BO": "691310",
      "Kundayam BO": "689695",
      "Maloor BO": "689695",
      "Achencoil BO": "689696",
      "Chembanaruvi BO": "689696",
      "Elikattoor BO": "689696",
      "Kamukumcherry BO": "689696",
      "Mancode BO": "689694",
      "Kottukkal BO": "691306",
      "Vayalaanchal BO": "691306",
      "Arkannur BO": "691533",
      "Thevannur BO": "691533",
      "Vengoor BO": "691533",
      "Anapettakongal BO": "691307",
      "Narikal BO": "691322",
      "Vilakkupara BO": "691312",
      "Venture BO": "691309",
      "Manjakala BO": "691508",
      "Thalavoor BO": "691508",
      "Pathirickal BO": "689695",
      "Poonkulanji BO": "689695",
      "Panthaplavu BO": "691522",
      "Karavoor BO": "689696",
      "Punnala BO": "689696",
      "Kariyara BO": "691332",
      "Ottackal BO": "691308",
      "Mathra BO": "691333",
      "Perungalam BO": "690538",
      "Chavara Bridge BO": "691583",
      "Kallelibhagom BO": "690519",
      "Mynagappally North BO": "690519",
      "Thottumugham BO": "690519",
      "Kuthirapanthy BO": "690523",
      "Koduvila BO": "691502",
      "Munroethuruthu BO": "691502",
      "Prakkulam BO": "691602",
      "Aduthala BO": "691579",
      "Edanad BO": "691579",
      "Kizhakkanela BO": "691574",
      "Velamannoor BO": "691574",
      "Inchavila BO": "691601",
      "Kureepuzha BO": "691601",
      "Mathilil BO": "691601",
      "Panayam BO": "691601",
      "Thattarkonam BO": "691005",
      "Koottikada BO": "691020",
      "Vellimon West BO": "691511",
      "Ummannur BO": "691520",
      "Mancodekadakkal BO": "691559",
      "Ambalathumkala BO": "691505",
      "Anakottur BO": "691505",
      "Idakkadom BO": "691505",
      "Irumpanangadu BO": "691505",
      "Chariparambu BO": "691536",
      "Edathara BO": "691536",
      "Kummil BO": "691536",
      "Kakkode BO": "691331",
      "Vilakkuvattom BO": "691331",
      "Alayamon BO": "691306",
      "Cherukulam BO": "691306",
      "Anakulam BO": "691311",
      "Mannuranchal BO": "691311",
      "Ayilara BO": "691312",
      "Bharatheepuram BO": "691312",
      "Kadamancode BO": "691312",
      "Ambanad BO": "691309",
      "Avaneeswaram BO": "691508",
      "Avaneeswaram RS BO": "691508",
      "Pidavoor BO": "689695",
      "Maniyarupunalur BO": "691333",
      "Placherry BO": "691331",
      "Areeplachy BO": "691333",
      "Karavaloor BO": "691333",
      "Shaliacarry Estate BO": "691331",
      "Manampuzha BO": "691553",
      "Puthenambalam BO": "691553",
      "Cheriyazheekal BO": "690573",
      "S V Market BO": "690573",
      "Arinallur South BO": "690538",
      "Panmana BO": "691583",
      "Ponmana BO": "691583",
      "Alumpeedika BO": "690547",
      "Edakulangara BO": "690523",
      "Kollaka BO": "690536",
      "Kummallur BO": "691573",
      "Nellettil BO": "691302",
      "Chirakkarathazham BO": "691578",
      "Vilavoorkonam BO": "691578",
      "Uliyanadu BO": "691579",
      "Maruthadi BO": "691003",
      "Nedumpaikulam BO": "691501",
      "Decent Jn BO": "691577",
      "Mukkoodu BO": "691503",
      "Ayathil BO": "691021",
      "Perumon BO": "691601",
      "Poredom BO": "691534",
      "Kura BO": "691557",
      "Valavupacha BO": "691559",
      "Karuvelil BO": "691505",
      "Neeleswaram BO": "691505",
      "Kuttikadu BO": "691536",
      "Pulippara Jn BO": "691536",
      "Kattilkadavu BO": "690542",
      "Kuzhithura BO": "690542",
      "Vadakkumbhagom BO": "691584",
      "Karunagappally North BO": "690544",
      "Thodiyur North BO": "690523",
      "Puthenkulam BO": "691302",
      "Ashtamudi BO": "691602",
      "Nedumpana BO": "691576",
      "Pallimon BO": "691576",
      "Mylakkadu BO": "691571",
      "Ambipoika BO": "691501",
      "Kanjiracode BO": "691501",
      "Kumbalam BO": "691503",
      "Polachira BO": "691334",
      "Mundakkal BO": "691010",
      "Peruvelikara BO": "691500",
      "Elampazhannur BO": "691534",
      "Thudayannur BO": "691536",
      "Karukone BO": "691306",
      "Thadicaud BO": "691306",
      "Vayyanam BO": "691533",
      "Kottavattom BO": "691322",
      "Marthandankara BO": "691312",
      "Rosemala BO": "691309",
      "Chozhiakode BO": "691310",
      "Villumala BO": "691310",
      "Ambalathinnirappu BO": "691508",
      "Chakkuvarakkal BO": "691508",
      "Melila BO": "691508",
      "Vilakudy BO": "691508",
      "Kurumbakara BO": "689695",
      "Maloor College BO": "689695",
      "Thekketheri BO": "691522",
      "Kumarankudy BO": "689696",
      "Vettithitta BO": "689696",
      "Kallada Irrigation Project BO": "691308",
      "Edappallycotta BO": "691583",
      "Panmana Puthen Chantha BO": "691583",
      "Pavumba BO": "690574",
      "Puthukkadukara BO": "691585",
      "Puthenthura BO": "691582",
      "Madathilkaranma BO": "690526",
      "Azheekkalthura BO": "690547",
      "Kadathur Ward BO": "690523",
      "Thodiyur BO": "690523",
      "Padinjattakkara BO": "690524",
      "Varavila BO": "690528",
      "Velichikala BO": "691573",
      "Kalakode BO": "691302",
      "Valathungal BO": "691011",
      "Chirakkara BO": "691578",
      "Kallumthazham BO": "691004",
      "Kilikollur East BO": "691015",
      "Kakkotumoola BO": "691303",
      "Alumoodu BO": "691577",
      "Padappakara BO": "691503",
      "Chemmakkad BO": "691601",
      "Pattamthuruth BO": "691601",
      "Kuriyode BO": "691534",
      "Valiyode BO": "691520",
      "Ayirakuzhy BO": "691559",
      "Kadakkode BO": "691505",
      "Maranad BO": "691505",
      "Channappara BO": "691536",
      "Venchempu BO": "691333",
      "Nellipally BO": "691331",
      "Mathira BO": "691536",
      "Pullupana BO": "691536",
      "Chelikuzhy BO": "691556",
      "Chathakulam BO": "690520",
      "Anayadi BO": "690561",
      "Ambalathumbhagom BO": "690520",
      "Muthupilakkad BO": "690520",
      "Parakadavu BO": "690561",
      "Karimthottuva BO": "690540",
      "Thuruthikara BO": "690540",
      "Karali Jn BO": "690521",
      "Pallisserickal BO": "690521",
      "Venga BO": "690521",
      "Vilanthara Jn BO": "690521",
      "Kakkakunnu BO": "690522",
      "Patharam BO": "690522",
      "Punalur HO": "691305",
      "Karunagappally HO": "690518",
      "Kottarakara HO": "691506",
      "Kollam HO": "691001",
      "Kollam Cantonment SO": "691001",
      "Kollam Civil Station SO": "691013",
      "Kundara East SO": "691501",
      "Mangad SO": "691015",
      "Mulavana SO": "691503",
      "Nallila SO": "691515",
      "Perumpuzha SO": "691504",
      "Vadakkevila SO": "691010",
      "Vellimon SO": "691511",
      "West Kallada SO": "691500",
      "Chengamanad Jn SO": "691557",
      "Ezhukone SO": "691505",
      "Kadakkal SO": "691536",
      "Kaithacode SO": "691543",
      "Kalayapuram SO": "691560",
      "Kuzhimathicaud SO": "691509",
      "Oyur SO": "691510",
      "Pooyapally SO": "691537",
      "Puthurkollam SO": "691507",
      "Veliyam SO": "691540",
      "Vettikavala SO": "691538",
      "Karamcode SO": "691579",
      "Kilikollur SO": "691004",
      "Kottiyam SO": "691571",
      "Mayyanad SO": "691303",
      "Paravur SO Kollam": "691301",
      "Sakthikulangara SO": "691581",
      "Thangasserry SO": "691007",
      "Thekkumbhagom SO": "691319",
      "Uliyakovil SO": "691019",
      "Cheppara SO": "691520",
      "Pallickalkottarakara SO": "691566",
      "Nellikunnam SO": "691527",
      "Kannanallur SO": "691576",
      "Kollam Cutchery SO": "691013",
      "Kollam Taluk Cutchery SO": "691001",
      "Kundara SO": "691501",
      "Parippally SO": "691574",
      "Pattathanam SO": "691021",
      "Perinad SO": "691601",
      "Pullichira SO": "691304",
      "Thirumullavaram SO": "691012",
      "Chadayamangalam SO": "691534",
      "Chithara SO": "691559",
      "Madathara SO": "691541",
      "Valakom SO": "691532",
      "Kavanad SO": "691003",
      "Kollam Bazar SO": "691001",
      "Mukathala SO": "691577",
      "Nedungolam SO": "691334",
      "Pallithottam SO": "691006",
      "T K M College SO": "691005",
      "Thattamala SO": "691020",
      "Thekkevila SO": "691016",
      "Thevally SO": "691009",
      "Umayanallur I E SO": "691589",
      "Karingannur SO": "691516",
      "Kulakada SO": "691521",
      "Nilamel SO": "691535",
      "Odanavattom SO": "691512",
      "Pulamon SO": "691531",
      "Sasthamcottah SO": "690521",
      "Tholicode SO": "691333",
      "Poruvazhy SO": "690520",
      "Sooranad North SO": "690561",
      "Sooranad SO": "690522",
      "Edamon SO": "691307",
      "Kunnicode SO": "691508",
      "Alumkadavu SO": "690573",
      "Athinad North SO": "690542",
      "Chavara SO": "691583",
      "Vadakkumthala East SO": "690536",
      "Amrithapuri SO": "690546",
      "East Kallada SO": "691502",
      "Kalluvathukkal SO": "691578",
      "Clappana SO": "690525",
      "Mynagappally SO": "690519",
      "Neendakara SO": "691582",
      "Ochira SO": "690526",
      "S R P Market SO": "690539",
      "Thevalakkara SO": "690524",
      "Kanjavely SO": "691602",
      "Arinallur SO": "690538",
      "Koivila SO": "691590",
      "Manappally North SO": "690574",
      "Prayar SO": "690547",
      "Thazhava SO": "690523",
      "Asramom SO": "691002",
      "Bhoothakulam SO": "691302",
      "Chandanathope SO": "691014",
      "Thenmala SO": "691308",
      "Kunnathur East SO": "690540",
      "Eroor SO Kollam": "691312",
      "Manchallur Pathanapuram SO": "689695",
      "Pathanapuram SO": "689695",
      "Pattazhy SO": "691522",
      "Piravanthur SO": "689696",
      "Valacode SO": "691331",
      "Chathannur SO": "691572",
      "Chavara South SO": "691584",
      "Anchal SO": "691306",
      "Ayur SO": "691533",
      "Kulasekharapuram SO": "690544",
      "Mukundapuram SO": "691585",
      "Vavvakkavu SO": "690528",
      "Adichanallur SO": "691573",
      "Eravipuram SO": "691011",
      "Kadappakada SO": "691008",
      "Channapettah SO": "691311",
      "Elampal SO": "691322",
      "Kalthuruthy SO": "691309",
      "Kulathupuzha SO": "691310",
      "Punalur Paper Mills SO": "691332"
    },
    "THIRUVANANTHAPURAM": {
      "Payattuvila BO": "695501",
      "Venpakal BO": "695123",
      "Russelpuram BO": "695501",
      "Vedivachankoil BO": "695501",
      "Vattavila BO": "695132",
      "Nellimoodu BO": "695524",
      "Bhagavathinada BO": "695501",
      "Chowara BO": "695501",
      "Kattachalkuzhy BO": "695501",
      "Kottukal BO": "695501",
      "Manchavilakom BO": "695503",
      "Kulappada BO": "695542",
      "Marangad BO": "695542",
      "Amachal BO": "695572",
      "KottoorTVM BO": "695574",
      "Paruthipally BO": "695574",
      "Mannurkonam BO": "695541",
      "Paruthikuzhy BO": "695541",
      "Koonanvenga BO": "695568",
      "Puliyarakonam BO": "695573",
      "Thamalam BO": "695012",
      "Ambalathara BO": "695026",
      "Pachallur BO": "695027",
      "Valiavila BO": "695006",
      "Cheriyakonni BO": "695013",
      "Kodunganur BO": "695013",
      "Manikanteswaram BO": "695013",
      "Nettayam   BO": "695013",
      "Memala BO": "695551",
      "Ponmudi BO": "695551",
      "Kottakkakom BO": "695542",
      "Vinobaniketan BO": "695542",
      "Ambalathinkala BO": "695572",
      "Kuruthamcode BO": "695572",
      "Kovalam Beach BO": "695527",
      "Kallayam BO": "695043",
      "Mukkolackal BO": "695043",
      "Kalliyal BO": "695574",
      "Kollode BO": "695571",
      "Malayam BO": "695571",
      "Chullimanoor BO": "695541",
      "Karipur BO": "695541",
      "Pravachambalam BO": "695020",
      "Meenmutty BO": "695562",
      "Panayam BO": "695568",
      "Panayamuttom BO": "695561",
      "Kochuvila BO": "695563",
      "Thennur BO": "695563",
      "Perukavu BO": "695573",
      "Vilappilsala BO": "695573",
      "Panniyode BO": "695575",
      "TVM  RK Mission BO": "695010",
      "Mithraniketan BO": "695543",
      "Maruthamala BO": "695551",
      "Parappara BO": "695551",
      "Kandala BO": "695512",
      "Kazhavur BO": "695526",
      "Arumanoor BO": "695525",
      "Kanjampazhanji BO": "695525",
      "Mayam BO": "695505",
      "Panachamoodu BO": "695505",
      "Thekkupara BO": "695505",
      "Meenankal BO": "695542",
      "Panacode BO": "695542",
      "Chekkakonam BO": "695564",
      "Karumom BO": "695002",
      "Neyyar Dam BO": "695572",
      "Pantha BO": "695572",
      "Veeranakavu BO": "695572",
      "Puthukulangara BO": "695541",
      "Tholicode BO": "695541",
      "Ookode BO": "695020",
      "Elavattom BO": "695562",
      "Karimancode BO": "695562",
      "Perayam BO": "695562",
      "Daivapura BO": "695563",
      "Idinjar BO": "695563",
      "Punalal BO": "695575",
      "Uriakode BO": "695543",
      "Veliyannur BO": "695543",
      "Anappara BO": "695551",
      "Chettachal BO": "695551",
      "Kallar Tvm BO": "695551",
      "Mullur BO": "695521",
      "Cheriakolla BO": "695504",
      "Kunnathukal BO": "695504",
      "Veliyamcode BO": "695512",
      "Mannamkonam BO": "695125",
      "Keezharur BO": "695124",
      "Lourdepuram BO": "695526",
      "Puthiathura BO": "695526",
      "Karode BO": "695506",
      "Kudayal BO": "695505",
      "Manali BO": "695505",
      "Nellivila BO": "695523",
      "Kokkotela BO": "695542",
      "Parandode BO": "695542",
      "Aruvikara BO": "695564",
      "Kattacode BO": "695572",
      "Mylakkara BO": "695572",
      "Attukal BO": "695009",
      "Anad BO": "695541",
      "Mancha BO": "695541",
      "Pallichal BO": "695020",
      "Exservicemens Colony BO": "695562",
      "Paluvally BO": "695562",
      "Irinchayam BO": "695561",
      "Poovathur BO": "695561",
      "Ilanchiyam BO": "695563",
      "Panangode BO": "695563",
      "Moongode BO": "695573",
      "Kuthirakalamvellanad BO": "695543",
      "Mulayara BO": "695543",
      "Mundela BO": "695543",
      "Bonaccord BO": "695551",
      "Peppara Dam BO": "695551",
      "Kottapuram BO": "695521",
      "Elluvila BO": "695504",
      "Manchamcode BO": "695125",
      "Ayira BO": "695502",
      "Anavoor BO": "695124",
      "Kottackal TVM BO": "695124",
      "Olathanni BO": "695133",
      "Kakkavila BO": "695506",
      "Venkadambu BO": "695506",
      "Kudappanamoodu BO": "695505",
      "Kuttamala BO": "695505",
      "Muttakadu BO": "695523",
      "Changa BO": "695542",
      "Dalmughom BO": "695125",
      "Poozhanad BO": "695125",
      "Vazhichal BO": "695125",
      "Cheruvarakonam BO": "695502",
      "Marayamuttom BO": "695124",
      "Aruvipuram BO": "695126",
      "Mulluvila BO": "695133",
      "Amboori BO": "695505",
      "Karikuzhi BO": "695505",
      "KoothaliTVM BO": "695505",
      "Kidarakuzhy BO": "695523",
      "Poikamukku BO": "695103",
      "Elakamon BO": "695310",
      "Elakamonkizhakkepuram BO": "695310",
      "Hariharapuram BO": "695310",
      "Kappil BO": "695311",
      "Odayam BO": "695311",
      "Thottakkad BO": "695605",
      "Vellallur BO": "695601",
      "Malakkal BO": "695602",
      "Njarayilkonam BO": "695602",
      "Muthuvila BO": "695610",
      "Neeramankadavuu BO": "695610",
      "Kanchinada BO": "695609",
      "Iroopara BO": "695584",
      "Keezhavur BO": "695584",
      "Koithurkonam BO": "695584",
      "Koduvazhannur BO": "695612",
      "Thalikuzhi BO": "695612",
      "Perumathura BO": "695303",
      "Pallithura BO": "695586",
      "Adayamon BO": "695614",
      "Kalamachal BO": "695606",
      "Janardhanapuram BO": "695141",
      "Varkala South BO": "695141",
      "Konchira BO": "695615",
      "Kuthirakulam BO": "695615",
      "Moonnanakuzhy BO": "695615",
      "Mukkudil BO": "695607",
      "Palamkonam BO": "695607",
      "Pirappancode BO": "695607",
      "Pullampara BO": "695607",
      "Vettoor BO": "695312",
      "Titanium BO": "695021",
      "Valiaveli BO": "695021",
      "Pangappara BO": "695581",
      "Prasanth Nagar BO": "695011",
      "Thuruvikkal BO": "695011",
      "Ulloor BO": "695011",
      "Thope BO": "695008",
      "Valiathura BO": "695008",
      "Arayur BO": "695122",
      "Altharamoodu BO": "695102",
      "Perumkulam BO": "695102",
      "Ayilam BO": "695103",
      "Ilamba BO": "695103",
      "Mudapuram BO": "695304",
      "Venkulam BO": "695311",
      "Anathalavattom BO": "695306",
      "Nilakkamukku BO": "695306",
      "Puthusserimukku BO": "695605",
      "Kodithookiyakunnu BO": "695608",
      "Nagaroor BO": "695601",
      "Pazhayakunnumel BO": "695601",
      "Oorupoika BO": "695104",
      "Kulamuttam BO": "695144",
      "Maruthikunnu BO": "695603",
      "Vettiyara BO": "695603",
      "Kaikara BO": "695307",
      "Moothala BO": "695604",
      "Sasthavattom BO": "695305",
      "Andoorkonam BO": "695584",
      "Panayara BO": "695145",
      "Mulakkalathukavu BO": "695614",
      "Kottukunnam BO": "695606",
      "Sivagiri mutt BO": "695141",
      "Aliyadu BO": "695607",
      "Karimanal BO": "695583",
      "Chakkai BO": "695024",
      "Pandalacode BO": "695028",
      "Venkode BO": "695028",
      "Mariyapuram BO": "695122",
      "Thannimoodu BO": "695123",
      "Mudakkal BO": "695103",
      "Katakam BO": "695304",
      "Pullanicode BO": "695311",
      "Karavaram BO": "695605",
      "Kurumbayam BO": "695608",
      "Chittattumukku BO": "695301",
      "Kilimanur Palace BO": "695601",
      "Peroor BO": "695601",
      "Parayathukonam BO": "695104",
      "Kavalayur BO": "695144",
      "Parakunnu BO": "695603",
      "Bharathannur BO": "695609",
      "Azhurmarket BO": "695305",
      "Kattaikonam BO": "695584",
      "Muttappalam BO": "695145",
      "Puthenthope BO": "695586",
      "Anakudy BO": "695606",
      "Karimkuttikara BO": "695606",
      "Cheeranikkara BO": "695615",
      "Koliakode BO": "695607",
      "Vellumannady BO": "695607",
      "Goureesapattom BO": "695004",
      "Cheruvikkal BO": "695011",
      "Chaikkottukonam BO": "695122",
      "Plamootukada BO": "695122",
      "Nedumparambu BO": "695102",
      "Vanchiyurattingal BO": "695102",
      "Poothura BO": "695309",
      "Melkadakkavur BO": "695306",
      "Keezhattingal BO": "695306",
      "Kattumpuram BO": "695608",
      "Channamkara BO": "695301",
      "Charupara BO": "695601",
      "Ponganadu BO": "695601",
      "Pullayil BO": "695601",
      "Edakode BO": "695104",
      "Kandukrishi BO": "695104",
      "Kurakkada BO": "695104",
      "Manjamala BO": "695313",
      "Muthana BO": "695146",
      "Kokkottukonam BO": "695604",
      "Pakalkuri BO": "695604",
      "Puliyurkonam BO": "695604",
      "Moonnumukku BO": "695609",
      "Mylamoodu BO": "695609",
      "Nethajipuram BO": "695589",
      "Palachira BO": "695143",
      "Thokkad BO": "695143",
      "Nellanad BO": "695606",
      "Thundathil BO": "695581",
      "Mg College BO": "695004",
      "Beemapally BO": "695008",
      "Kodungavila BO": "695123",
      "Attingal HO": "695101",
      "Thiruvananthapuram GPO": "695001",
      "Neyyattinkara HO": "695121",
      "Poojapura HO": "695012",
      "Anjengo SO": "695309",
      "Avanavancherry SO": "695103",
      "Ayroorvarkala SO": "695310",
      "Chirayinkeezhu SO": "695304",
      "Edava SO": "695311",
      "Kallambalam SO": "695605",
      "Kallara SO Thiruvananthapuram": "695608",
      "Kilmanur SO": "695601",
      "Kizhuvalam SO": "695104",
      "Kudavur SO": "695313",
      "Murukumpuzhaa SO": "695302",
      "Pallickal Kilimanur SO": "695604",
      "Pothencode SO": "695584",
      "Sainik School SO Thiruvananthapuram": "695585",
      "Vennicode SO": "695318",
      "Melvettoor SO": "695312",
      "Muttada SO": "695025",
      "Palkulangara SO": "695024",
      "PMG Jn SO": "695033",
      "Thiruvananthapuram  Chalai SO": "695036",
      "Thiruvananthapuram  Engg College SO": "695016",
      "Thiruvananthapuram  Fort SO": "695023",
      "Thiruvananthapuram  ISRO SO": "695022",
      "Vanchiyur SO": "695035",
      "Vikas Bhavan SO": "695033",
      "Technopark SO": "695581",
      "Amaravila SO": "695122",
      "Kadakkavur SO": "695306",
      "Mithirmala SO": "695610",
      "Navaikulam SO": "695603",
      "Palayamkunnu SO": "695146",
      "Thonnakkal SO": "695317",
      "Vamanapuram SO": "695606",
      "Varkala SO": "695141",
      "Vembayam SO": "695615",
      "Anayara SO": "695029",
      "Attakulangara SO": "695023",
      "Karyavattom SO": "695581",
      "Kazhakuttam SO": "695582",
      "Mannanathala SO": "695015",
      "Pattom Palace SO": "695004",
      "Thiruvananthapuram  AGs SO": "695001",
      "Thiruvananthapuram  Beach SO": "695007",
      "Powdikonam": "695588",
      "NDC TRIVANDRUM FORT": "695051",
      "Karakonam SO": "695504",
      "Kuvalassery SO": "695512",
      "Alamcode SO": "695102",
      "Cherunniyur SO": "695142",
      "Kaniyapuram SO": "695301",
      "Madavoorpallickal SO": "695602",
      "Manambur SO": "695611",
      "Nedunganda SO": "695307",
      "Pangode SO": "695609",
      "Perunguzhi SO": "695305",
      "Pulimath SO": "695612",
      "Puthencurichy SO": "695303",
      "Thattathumala SO": "695614",
      "Vadasserikonam SO": "695143",
      "Chempazhanthy SO": "695587",
      "Kaithamukku SO": "695024",
      "Moongode SO": "695144",
      "Pallipuram SO Thiruvananthapuram": "695316",
      "Santhigiri SO": "695589",
      "Sreenivasapuram SO": "695145",
      "StXaviers College SO": "695586",
      "Karikkakom SO": "695021",
      "Kulathur SO Thiruvananthapuram": "695583",
      "Nalanchira SO": "695015",
      "Public Office SO Thiruvananthapuram": "695033",
      "Sreekaryam SO": "695017",
      "Thiruvananthapuram  Medical College SO": "695011",
      "Vallakkadavoo SO": "695008",
      "Vanchiyoor Junction SO": "695035",
      "Vattappara SO": "695028",
      "Aralumoodu SO": "695123",
      "Chenkal SO": "695132",
      "Dhanuvachapuram SO": "695503",
      "Kanjiramkulam SO": "695524",
      "Vakkom SO": "695308",
      "Venjaramoodu SO": "695607",
      "Thiruvananthapuram  Pettah SO": "695024",
      "Thiruvananthapuram  University SO": "695034",
      "Balaramapuram SO": "695501",
      "Parasuvaickal SO": "695508",
      "Perumpazhuthoor SO": "695126",
      "Uchakada SO": "695506",
      "Ambalamukku SO": "695005",
      "Aramada SO": "695032",
      "Aryanad SO": "695542",
      "Cgo Complex Poonkulam SO": "695522",
      "Tirupuram SO": "695133",
      "Vellarada SO": "695505",
      "Industrial Estate SO Thiruvananthapuram": "695019",
      "Karamana SO": "695002",
      "Kovalam SO Thiruvananthapuram": "695527",
      "Malayinkil SO": "695571",
      "Panavoor SO": "695568",
      "Peringamala SO": "695563",
      "Peyad SO": "695573",
      "Poonthura SO": "695026",
      "Thycaud SO": "695014",
      "Vithura SO": "695551",
      "Cotton Hill SO": "695014",
      "Kaimanam SO": "695040",
      "Kanjirampara SO": "695030",
      "Kerala Governors Camp SO": "695099",
      "Manacaud SO": "695009",
      "Nemom SO": "695020",
      "Pacha SO": "695562",
      "Perurkada SO": "695005",
      "Sasthamangalam SO": "695010",
      "Thiruvallom SO": "695027",
      "Tirumala SO Thiruvananthapuram": "695006",
      "Vellanad SO": "695543",
      "Neyyattinkara Town SO": "695121",
      "Ooruttambalam SO": "695507",
      "Parassala SO": "695502",
      "Puvar SO": "695525",
      "Kalliyoor SO": "695042",
      "Kaudiar Square SO": "695003",
      "Kudappanakunnu SO": "695043",
      "Kuttichal SO": "695574",
      "Pappanamcode SO": "695018",
      "Poovachal SO": "695575",
      "PTP Nagar SO": "695038",
      "Vattiyoorkavu SO": "695013",
      "Vizhinjam SO": "695521",
      "Ottasekharamangalam SO": "695125",
      "Perumkadavila SO": "695124",
      "Pozhiyoor SO": "695513",
      "Pulluvila SO": "695526",
      "Venganur SO": "695523",
      "Vlathankara SO": "695134",
      "Jagathy SO": "695014",
      "Karakulam SO": "695564",
      "Kattakada SO": "695572",
      "Kaudiar SO": "695003",
      "Naruvamoodu SO": "695528",
      "Nedumangad SO": "695541",
      "Pazhakutty SO": "695561",
      "Poojapura Junction SO": "695012",
      "Valiamala SO": "695547",
      "Vellayani SO": "695522",
      "Machel SO": "695570"
    },
    "PALAKKAD": {
      "Nedungottur BO": "679308",
      "Melur BO": "679501",
      "Kuruvattur BO": "679336",
      "Amayur BO": "679303",
      "Erattakulam Alathur BO": "678682",
      "Thannilapuram BO": "678682",
      "Kairady BO": "678510",
      "Thiruvaliad BO": "678510",
      "Kozhalmannam Agraharam BO": "678702",
      "Perinkunnu BO": "678702",
      "Kazhani BO": "678543",
      "Vavulliapuram BO": "678543",
      "Olivemount BO": "678702",
      "Paruvasseri BO": "678686",
      "Alampallam BO": "678506",
      "Elavampadam BO": "678684",
      "Koranchira BO": "678684",
      "Mulangot BO": "678684",
      "Palakuzhy BO": "678684",
      "Pallanchathanur BO": "678571",
      "Thachangad BO": "678571",
      "Cheramangalam BO": "678703",
      "Elavancheri BO": "678508",
      "Kanimangalam BO": "678508",
      "Nelliampathy BO": "678508",
      "Padagiri BO": "678508",
      "Mangalam Dam BO": "678706",
      "Kallepulli BO": "678005",
      "Puthurpalakkad BO": "678005",
      "Newkalpathy BO": "678003",
      "Manikkasseri BO": "678631",
      "Mucheeri BO": "678631",
      "Parasseri BO": "678631",
      "Anakkal BO": "678651",
      "Nagaripuram BO": "678642",
      "Kallekkad BO": "678006",
      "Kunnamkattupathy BO": "678101",
      "Mannalur BO": "678502",
      "Thannisseri BO": "678501",
      "Karingarapully BO": "678551",
      "Olasseri BO": "678551",
      "Thiruvalathur BO": "678551",
      "Eruttenpadi BO": "678555",
      "Palaniyarpalayam BO": "678555",
      "Olalapadi BO": "678557",
      "Velanthavalam BO": "678557",
      "Chenthamaranagar BO": "678102",
      "Nanniode BO": "678534",
      "Kollengode RS BO": "678506",
      "Vattekkad BO": "678506",
      "Pulinelly BO": "678572",
      "Chimbukat BO": "678721",
      "Mathur Agraharam BO": "678571",
      "Nemmara College BO": "678508",
      "Athipotta BO": "678544",
      "Kudallur BO": "678688",
      "Chennangad BO": "678573",
      "Chulanur BO": "678574",
      "Pullode BO": "678545",
      "Thekkepotta BO": "678687",
      "Nechur BO": "678722",
      "Ayakkad BO": "678683",
      "Karinkayam BO": "678706",
      "Tadukkasseri BO": "678641",
      "Cheraya BO": "678631",
      "Mankarai RS BO": "678613",
      "Mannur West BO": "678642",
      "Nurani Agraharam BO": "678004",
      "Kinavallur BO": "678612",
      "Marudarode BO": "678007",
      "Erattakulam BO": "678622",
      "Kanjikode Ind Estate BO": "678621",
      "Kinasseri BO": "678701",
      "Rvp Pudur BO": "678555",
      "Eduppukulam BO": "678556",
      "Thekkedesam BO": "678553",
      "Verkoli BO": "678552",
      "Vilayodi BO": "678103",
      "Mudukurissi BO": "678593",
      "Pallikurup BO": "678593",
      "Thrikallur BO": "678593",
      "Kalluvazhi BO": "679514",
      "Chembra BO": "673577",
      "Cherukode BO": "679336",
      "Choorakode BO": "679336",
      "Cherukattupulam BO": "679522",
      "EdakodePavukonam BO": "679522",
      "Vilayur West BO": "679309",
      "Nagalassery BO": "679533",
      "Thirumittakode BO": "679533",
      "Poonchola BO": "678598",
      "Mannengode BO": "679307",
      "Kallipadam BO": "679122",
      "Met Ind Nagar BO": "679122",
      "Vadanamkurussi BO": "679121",
      "Kottappuram BO": "679513",
      "Kattukulam BO": "679514",
      "Kuttanasseri BO": "679514",
      "Varode BO": "679102",
      "Munnurkode BO": "679502",
      "Othalur  Ttl BO": "679534",
      "Thalakkasseri BO": "679534",
      "Panayur BO": "678552",
      "Thekke Vavanoor BO": "679533",
      "Konikazhi BO": "678632",
      "Kanayam BO": "679122",
      "Kayiliad BO": "679122",
      "Kulappulli BO": "679122",
      "Attasseri BO": "679513",
      "Viyyakurissi BO": "678593",
      "KottapadamTTL BO": "679534",
      "Chithali BO": "678702",
      "Kalapatti BO": "678702",
      "Kollengode West BO": "678506",
      "Nenmeni BO": "678506",
      "Panangattiri BO": "678506",
      "Cherukulam BO": "678572",
      "Kariyamkode BO": "678572",
      "Koottala BO": "678681",
      "Govindapuram BO": "678507",
      "Meenkara Dam BO": "678507",
      "Chandramala Estate BO": "678508",
      "Chathamangalam BO": "678508",
      "Pothundy Dam BO": "678508",
      "Sitharkunda BO": "678508",
      "Vallanghy BO": "678508",
      "Tarur BO": "678544",
      "Kattusseri BO": "678542",
      "Panniankara BO": "678683",
      "Chandrasekharapuram BO": "678611",
      "Dhoni BO": "678009",
      "Elakkad BO": "678631",
      "Nochupulli BO": "678592",
      "Pudanur BO": "678592",
      "Velikkad BO": "678592",
      "Vallikkode BO": "678594",
      "Pirayiri BO": "678004",
      "Tirunilayi BO": "678004",
      "Palakkad Industrial Estate BO": "678731",
      "Elapulli South BO": "678622",
      "Tenari BO": "678622",
      "Vengodi BO": "678622",
      "Vemballur BO": "678502",
      "Yakkara BO": "678701",
      "Attempathy BO": "678556",
      "Parassikkal BO": "678556",
      "Athicode BO": "678554",
      "Karippali BO": "678532",
      "Mala BO": "679534",
      "Mezhathur BO": "679534",
      "Karumanamkurissi BO": "679504",
      "Nellikattiri BO": "679533",
      "Ummanazhi BO": "678632",
      "Kilmuri BO": "679307",
      "Mundakkottukurissi BO": "679122",
      "Paruthipra BO": "679121",
      "Karimpuzha BO": "679513",
      "Valambillimangalam BO": "679513",
      "Kattukulam South BO": "679514",
      "Thirunayanapuram BO": "679514",
      "Vilathur BO": "679304",
      "Veetampara BO": "679102",
      "Pattithara BO": "679534",
      "Pathankulam BO": "679522",
      "Kannimari BO": "678534",
      "Kannanur BO": "678702",
      "Nochulli BO": "678702",
      "PadurKavasseri BO": "678543",
      "Anamari BO": "678506",
      "Payyalur BO": "678506",
      "Varodekottayi BO": "678572",
      "Kizhakkumuri BO": "678508",
      "Nemmara Old Village BO": "678508",
      "Naduvathupara BO": "678574",
      "Manappadam BO": "678687",
      "Kanakkanthuruthy BO": "678683",
      "Chittadi BO": "678706",
      "Olinkadavu BO": "678706",
      "Kundalasseri BO": "678641",
      "Vadasseri BO": "678641",
      "Kadukkamkunnu BO": "678651",
      "Kallurpalakkad BO": "678613",
      "Mankurussi BO": "678613",
      "Kilakkumbram BO": "678642",
      "Nambullipura BO": "678592",
      "Koduntharapully BO": "678004",
      "Akathethara BO": "678008",
      "Tunacadavu BO": "678661",
      "Tenur BO": "678612",
      "Kavalpad BO": "678012",
      "Moothanthara BO": "678012",
      "Pallatheri BO": "678007",
      "Chittur Courts BO": "678101",
      "Kuttipallam BO": "678101",
      "Ramasseri BO": "678622",
      "Pampampallam BO": "678621",
      "Pudusseri BO": "678623",
      "Koduvayur Agraharam BO": "678501",
      "Vannamada BO": "678555",
      "Karippode BO": "678503",
      "Vilayannur BO": "678671",
      "Chandrapuram BO": "678624",
      "Jellipara BO": "678581",
      "Kavundikkal BO": "678581",
      "SholayurPKD BO": "678581",
      "Kacheriparamba BO": "678601",
      "Tiruvalamkunnu BO": "678601",
      "Vattamannapuram BO": "678601",
      "Perumannur BO": "679536",
      "Mangode BO": "679503",
      "Panniyamkurissi BO": "679503",
      "Mulanhur BO": "679511",
      "Kanhikulam BO": "678596",
      "Vakkadapuram BO": "678595",
      "Thekkumuri CPL BO": "679506",
      "Mannampatta BO": "678633",
      "Vettakara BO": "678633",
      "Mannanur BO": "679523",
      "Chundampatta BO": "679337",
      "Mulayankavu BO": "679337",
      "Angadi BO": "679552",
      "Kalladathur BO": "679552",
      "Kappur BO": "679552",
      "MangalamOPM BO": "679301",
      "Kottopadam BO": "678583",
      "Kundurkunnu BO": "678583",
      "Chindaki BO": "678582",
      "Kalkandi BO": "678582",
      "Tenkara BO": "678582",
      "Etapalam BO": "679308",
      "Marayamangalam South BO": "679335",
      "Adakkaputhur BO": "679503",
      "Karattukurissi BO": "679503",
      "K A Samajam BO": "679123",
      "Kondurkara BO": "679313",
      "Irimbakachola BO": "678591",
      "Palakayam BO": "678591",
      "Cherottur BO": "679521",
      "Chethallur BO": "678583",
      "Kandamangalam BO": "678583",
      "Kodakkad BO": "678583",
      "Palode BO": "678583",
      "Ezhuvanthala BO": "679335",
      "Sreeramakrishnanagar BO": "679103",
      "Kodumunda BO": "679303",
      "Kolikkottusseri BO": "679303",
      "Nhangattiri BO": "679303",
      "Peringannur BO": "679535",
      "Karambathur BO": "679305",
      "Ambalavattom BO": "679501",
      "Kizhur BO": "679501",
      "Sankaramangalam BO": "679303",
      "Changileri BO": "678762",
      "Chathanur BO": "679535",
      "Gandhi Seva  Sadan BO": "679302",
      "Chavadiyur BO": "678581",
      "Chittur agali BO": "678581",
      "Karara BO": "678581",
      "Karkitamkunnu BO": "678601",
      "Uppukulam BO": "678601",
      "Kulakkad BO": "679503",
      "Veeramangalam BO": "679503",
      "Kanhirapuzha Dam BO": "678591",
      "Vazhumbram BO": "678595",
      "Kunduvampadam BO": "678633",
      "Punchapadam BO": "678633",
      "Malamalkkavu BO": "679554",
      "Thathanampully BO": "679337",
      "Eravakkad BO": "679552",
      "Ariyur BO": "678583",
      "Kumaramputhur BO": "678583",
      "Nattukal BO": "678583",
      "Payyanadam BO": "678583",
      "Kaithachira BO": "678582",
      "Thavalam BO": "678582",
      "Kaipuram BO": "679308",
      "Pombilaya BO": "679335",
      "Cherukutangad BO": "679305",
      "Parudur BO": "679305",
      "Cherambattakavu BO": "679501",
      "Kizhayur BO": "679303",
      "Muduthala BO": "679303",
      "Perumudiyur BO": "679303",
      "Chaliyattiri BO": "679535",
      "Kothachira BO": "679535",
      "Akalur BO": "679302",
      "Kottathara BO": "673122",
      "Mattathukad BO": "678581",
      "Pudur BO": "678581",
      "Bhimanad BO": "678601",
      "Edathanttukara BO": "678601",
      "Cherumundasseri BO": "679512",
      "Puliyanamkunnu BO": "679505",
      "Thanneercode BO": "679536",
      "Elambulasseri BO": "678595",
      "Pombra BO": "678595",
      "Moonnekkar BO": "678597",
      "Alangad BO": "678633",
      "Azhiyannur BO": "678633",
      "Kulakkattukurissi BO": "678633",
      "Koonathara BO": "679523",
      "Pallikunnu BO": "678583",
      "Kallamala BO": "678582",
      "Mukkali BO": "678582",
      "Paloor BO": "678582",
      "Pullisseri BO": "678582",
      "Maruthur BO": "679306",
      "Irimbalasseri BO": "679335",
      "Marayamangalam BO": "679335",
      "Panamanna South BO": "679501",
      "Taruvakonam BO": "679501",
      "Melmuri BO": "679307",
      "Ottapalam HO": "679101",
      "Alathur Mbr HO": "678541",
      "Olavakkot HO": "678002",
      "Palakkad HO": "678001",
      "Kannadi SO": "678701",
      "Kunnathurmedu SO": "678013",
      "Meenakshipuram SO": "678533",
      "Palakkad City SO": "678014",
      "Kanjikode West SO": "678623",
      "Kozhinjampara SO": "678555",
      "Menonpara SO": "678556",
      "Vandithavalam SO": "678534",
      "Sekharipuram SO": "678010",
      "Vadakanthara SO": "678012",
      "Chandranagar SO": "678007",
      "Elapulli SO": "678622",
      "Kakkayur SO": "678512",
      "Koduvayur SO": "678501",
      "Kozhipara SO": "678557",
      "Nallepilly SO": "678553",
      "Nattukal SO": "678554",
      "Palakkad Collectorate SO": "678001",
      "Polpulli SO": "678552",
      "Pudunagaram SO": "678503",
      "Thenkurussi SO": "678671",
      "Puduppariyaram SO": "678731",
      "Ettanur SO": "678502",
      "Kanjikode SO": "678621",
      "Kotambu SO": "678551",
      "Palakkad Fort SO": "678001",
      "Pattancheri SO": "678532",
      "Peruvemba SO": "678531",
      "Tattamangalam SO": "678102",
      "Tattamangalam South SO": "678102",
      "Thekkegramam SO": "678103",
      "Chittur College SO": "678104",
      "Chittur PG SO": "678101",
      "Ayalur SO": "678510",
      "Erimayur SO": "678546",
      "Nemmara SO": "678508",
      "Palampalakode SO": "678544",
      "Paruthipulli SO": "678573",
      "Kallekulangara SO": "678009",
      "Kongad SO": "678631",
      "Mannur SO Palakkad": "678642",
      "Muttikulangara SO": "678594",
      "PALAKKAD NDC": "678051",
      "Kavasseri SO": "678543",
      "Kollengode SO": "678506",
      "Kottayi SO": "678572",
      "Kunisseri SO": "678681",
      "Melarcode SO": "678703",
      "Peringottukurussi SO": "678574",
      "Perinkulam SO": "678542",
      "Tolanur SO": "678722",
      "Vandali SO": "678706",
      "Ambikapuram SO Palakkad": "678011",
      "Kottekkad SO": "678732",
      "Palakkad College SO": "678001",
      "Pallipuram PG SO": "678006",
      "Parambikulam SO": "678661",
      "Coyalmanna SO": "678702",
      "Kannambra SO": "678686",
      "Mudappallur SO": "678705",
      "Muthalamada SO": "678507",
      "Pallassana SO": "678505",
      "Pallavur SO": "678688",
      "Vadakkancherry MBR SO": "678683",
      "Chokkanathapuram SO": "678005",
      "Keralasseri SO": "678641",
      "Malampuzha Dam SO": "678651",
      "Mankarai SO": "678613",
      "Walayar Dam SO": "678624",
      "Chalavara SO": "679505",
      "Chalisseri SO": "679536",
      "Kadambur SO Palakkad": "679515",
      "Kanhirapuzha SO": "678591",
      "Katambazhipuram SO": "678633",
      "Manisseri SO": "679521",
      "Melepattambi SO": "679306",
      "Panamanna SO": "679501",
      "PerurOPM SO": "679302",
      "Pulappatta SO": "678632",
      "S G Press SO": "679122",
      "Tachampara SO": "678593",
      "Chittilancheri SO": "678704",
      "Kilakkancheri SO": "678684",
      "Kuttanur SO": "678721",
      "Mannapra SO": "678685",
      "Mathur PG SO": "678571",
      "Pudiyankam SO": "678545",
      "Puthucode SO": "678687",
      "Vadavannur SO": "678504",
      "Edathara SO": "678611",
      "Kalpathi SO": "678003",
      "Mundur Palakkad SO": "678592",
      "Nurani SO": "678004",
      "Palakkad Engineering College SO": "678008",
      "Parli PG SO": "678612",
      "Vaniamkulam SO": "679522",
      "Vellinezhi SO": "679504",
      "Alanallur SO": "678601",
      "Ganeshgiri SO": "679123",
      "Kalladipatta SO": "679313",
      "Kanniampuram SO": "679104",
      "Karalmanna SO": "679506",
      "Karimba SO": "678597",
      "Kavalappara SO": "679523",
      "Kudallur SO": "679554",
      "Kulukkallur SO": "679337",
      "Kumaranellur SO": "679552",
      "Mannarkad College SO": "678583",
      "Palappuram SO": "679103",
      "Perimbadari SO": "678762",
      "Thiruvazhiyode SO": "679514",
      "Agali SO Palakkad": "678581",
      "Anakkara SO Palakkad": "679551",
      "Chunangad SO": "679511",
      "Karakurissi SO": "678595",
      "Peringode SO": "679535",
      "Pulasseri SO": "679307",
      "Shornur SO": "679121",
      "Vengasseri SO": "679516",
      "Vilayur SO": "679309",
      "Ambalapara SO": "679512",
      "Cherpalcheri SO": "679503",
      "Kalladikode SO": "678596",
      "Kumbidi SO": "679553",
      "Lakkidi SO": "679301",
      "Mannarkkad SO": "678582",
      "Naduvattom SO": "679308",
      "Nellaya SO": "679335",
      "Pallipuram SO Palakkad": "679305",
      "Pattambi SO": "679303",
      "Pottasseri SO": "678598",
      "Srikrishnapuram SO": "679513",
      "Thiruvegapura SO": "679304",
      "Thottakkara SO": "679102",
      "Trikkatiri SO": "679502",
      "Trithala SO": "679534",
      "Vallapuzha SO": "679336",
      "Koottanad": "679533",
      "Anjumoorthy SO": "678682"
    },
    "KASARAGOD": {
      "Thayyeni BO": "670511",
      "Kanhirapoil BO": "671531",
      "Thayanoor BO": "671531",
      "Chittari BO": "671316",
      "Keekan BO": "671316",
      "Panayal BO": "671318",
      "Mandapam BO": "671326",
      "Bengalam BO": "671314",
      "Bheemanady BO": "671314",
      "Chathamath BO": "671314",
      "West Eleri BO": "671314",
      "Mavilakadapuram BO": "671312",
      "Padnekadapuram BO": "671312",
      "Valiyaparamba BO": "671312",
      "Kinanur BO": "671533",
      "Konnakad BO": "671534",
      "Muttomkadavil BO": "671534",
      "Natakkal BO": "671534",
      "Plachikara BO": "671534",
      "Kolichal BO": "671532",
      "Malakallu BO": "671532",
      "Panathady BO": "671532",
      "Udinur BO": "671310",
      "Vellap BO": "671310",
      "Bandadka BO": "671541",
      "Bedadka BO": "671541",
      "Edneer BO": "671541",
      "Karivedakam BO": "671541",
      "Kamballur BO": "670511",
      "Achikanam BO": "671531",
      "Kanhiradkom BO": "671531",
      "Kolavayal BO": "671531",
      "Paraklayi BO": "671531",
      "Movval BO": "671316",
      "Kaithakkad BO": "671313",
      "Podavur BO": "671313",
      "Valiapoil BO": "671313",
      "Udumbanthala BO": "671311",
      "Chayoth BO": "671314",
      "Erikulam BO": "671314",
      "Periyanganam BO": "671314",
      "Puthariadukkam BO": "671314",
      "Thaikadapuram BO": "671314",
      "Balal BO": "671533",
      "Darkas BO": "671534",
      "Punnakkunnu BO": "671534",
      "Chamundikunnu BO": "671532",
      "Ranipuram BO": "671532",
      "Achanthuruthi BO": "671351",
      "Maniyat BO": "671310",
      "Mylatti BO": "671319",
      "Kundankuzhy BO": "671541",
      "Manadka BO": "671541",
      "Manimoola BO": "671541",
      "Kannivayal BO": "670511",
      "Palavayal BO": "670511",
      "Ajanur BO": "671531",
      "Attenganam BO": "671531",
      "Balla BO": "671531",
      "Haripuram BO": "671531",
      "Iriya BO": "671531",
      "Kodoth BO": "671531",
      "Ravaneshwaram BO": "671316",
      "Kayyur BO": "671313",
      "Kilaikote BO": "671313",
      "Perumbatta BO": "671313",
      "Pettikundu BO": "671313",
      "Trikarpur South BO": "671311",
      "Karindala BO": "671314",
      "Kattipoil BO": "671314",
      "Kollampara BO": "671314",
      "Kottamala Estate BO": "671314",
      "Kottapuram BO": "671314",
      "Madikai BO": "671314",
      "Ozhinhavalappu BO": "671314",
      "Vallikadavu BO": "671534",
      "Edachakai BO": "671310",
      "Kotakkat BO": "671310",
      "Pilicode BO": "671310",
      "Trikarpur Kadapuram BO": "671310",
      "Bare BO": "671319",
      "UDMA  Padinhare BO": "671319",
      "Paravanadkam BO": "671317",
      "Mayipady BO": "671124",
      "Mogral Puthur BO": "671124",
      "Patla BO": "671124",
      "Ramdasnagar BO": "671124",
      "Shiribagilu BO": "671124",
      "Mugu BO": "671321",
      "Koliyur BO": "671323",
      "Majibail BO": "671323",
      "Miyapadavu BO": "671323",
      "Iriyanni BO": "671542",
      "Kanathur BO": "671542",
      "Kinningar BO": "671543",
      "Kuntar BO": "671543",
      "Movvar BO": "671543",
      "Nekraje BO": "671543",
      "Nettanige BO": "671543",
      "Urdur BO": "671543",
      "Bayar BO": "671348",
      "Padre BO": "671552",
      "Ammeri BO": "671322",
      "Bekur BO": "671322",
      "Alampady BO": "671123",
      "Kadumeni BO": "670511",
      "Kanhangad South BO": "671531",
      "Padimaruth BO": "671531",
      "Pullur BO": "671531",
      "Manikoth BO": "671316",
      "Pakkom BO": "673579",
      "Cheemeni BO": "671313",
      "Timiri  Chervathur BO": "671313",
      "Elerithattu BO": "671314",
      "Kalichanadukam BO": "671314",
      "Padannakkad BO": "671314",
      "Pudukai BO": "671314",
      "Uppilakai BO": "671314",
      "Chully BO": "671534",
      "Kanakappally BO": "671533",
      "Paramba BO": "671534",
      "Kallappally BO": "671532",
      "Kottody BO": "671532",
      "Panathur BO": "671532",
      "Olat BO": "671310",
      "Kolathuri BO": "671541",
      "Kuttikolu BO": "671541",
      "Sankarampady BO": "671541",
      "Chandragiri BO": "671317",
      "Adkathbail BO": "671121",
      "Madhur BO": "671124",
      "Arikady BO": "671321",
      "Kidoor BO": "671321",
      "Puthige BO": "671321",
      "Dharmathadka BO": "671324",
      "Ichilangodu BO": "671324",
      "Hosabettu BO": "671323",
      "Kadambar BO": "671323",
      "Pathoor BO": "671323",
      "Udyavara BO": "671323",
      "Malla BO": "671542",
      "Bellur BO": "671543",
      "Kakkebettu BO": "671543",
      "Pallathadka BO": "671551",
      "Katukukke BO": "671552",
      "Chippar BO": "671322",
      "Kurudapadavu BO": "671322",
      "Hidayathnagar BO": "671123",
      "Muttathody BO": "671123",
      "Samekochi BO": "671541",
      "Chamnad BO": "671317",
      "Perumbala BO": "671317",
      "Bedradka BO": "671124",
      "Angadimogaru BO": "671321",
      "Badur BO": "671321",
      "Kannur BO": "671321",
      "Nirchal BO": "671321",
      "Shiriya BO": "671321",
      "Ullody BO": "671321",
      "Heroor BO": "671324",
      "Badaje BO": "671323",
      "Kodlamogaru BO": "671323",
      "Kunjathur BO": "671323",
      "Moodambail BO": "671323",
      "Pavoor BO": "671323",
      "Vorkadi BO": "671323",
      "Karadka BO": "671542",
      "Kotoor BO": "671542",
      "Vattamthatta BO": "671542",
      "Delampady BO": "671543",
      "Kuntikana BO": "671551",
      "Yethadka BO": "671551",
      "Balemoola BO": "671552",
      "Sheni BO": "671552",
      "Beripadavu BO": "671322",
      "Kayyaru BO": "671322",
      "Cheroor BO": "671123",
      "Kallakatta BO": "671123",
      "Munnad BO": "671541",
      "Thekkil BO": "671541",
      "Thekkilferry BO": "671541",
      "Bela BO": "671321",
      "Bombrana BO": "671321",
      "Ednad BO": "671321",
      "Ichlampady BO": "671321",
      "Kodiamme BO": "671321",
      "Mogral BO": "671321",
      "Kudalmerkala BO": "671324",
      "Permude BO": "671324",
      "Anekallu BO": "671323",
      "Charla BO": "671323",
      "Adur BO": "671543",
      "Pandi BO": "671543",
      "Panjikkal BO": "671543",
      "Parappa  Delampady BO": "671543",
      "Ariyapady BO": "671551",
      "Kumbdaje BO": "671551",
      "Ukkinadka BO": "671552",
      "Vaninagar BO": "671552",
      "Uppala Gate BO": "671322",
      "Kasaragod HO": "671121",
      "Kanhangad HO": "671315",
      "Parappa SO": "671533",
      "Thuruthi SO": "671351",
      "Trikarpur SO": "671310",
      "Kalnad SO": "671317",
      "Kasaragod R S SO": "671121",
      "Kumbla SO": "671321",
      "Perla SO": "671552",
      "Bekal Fort SO": "671316",
      "Perdala SO": "671551",
      "Talangara SO": "671122",
      "Elambachi SO": "671311",
      "Nileshwar SO": "671314",
      "Padne SO": "671312",
      "Rajapuram SO": "671532",
      "Udma SO": "671319",
      "Vellarikundu SO": "671534",
      "PERIYE S.O": "671320",
      "Kudlu SO": "671124",
      "Mulleria SO": "671543",
      "Paivalike SO": "671348",
      "Bekal SO": "671318",
      "Chervathur SO": "671313",
      "Chittarikkal SO": "671326",
      "Changala SO": "671541",
      "Mangalpady SO": "671324",
      "Manjeshwar SO": "671323",
      "Muliyar SO": "671542",
      "Uppala SO": "671322",
      "Vidyanagar SO Kasargod": "671123",
      "Anandashrama SO": "671531"
    }
  },
  "DELHI": {
    "SOUTH": {
      "Fatehpur Beri S.O": "110074",
      "Satbari": "110074",
      "Sahpurjat BO": "110049",
      "Jeevan Nagar BO": "110014",
      "Aya Nagar BO": "110047",
      "Deoli BO": "110080",
      "Madanpur Khadar BO": "110076",
      "Ali BO": "110076",
      "Mandi BO": "110047",
      "Fatehpur Beri BO": "110074",
      "Sanjay Colony Bhati Mines BO": "110074",
      "Gadaipur BO": "110030",
      "Lado Sarai BO": "110030",
      "CSKM School BO": "110074",
      "Maidan Garhi BO": "110068",
      "Sultanpur BO": "110030",
      "Pul Pahladpur BO": "110044",
      "Jaunapur BO": "110047",
      "Satbari BO": "110074",
      "Ghitorni BO": "110030",
      "Chandanhoola BO": "110074",
      "Jaitpur BO": "110044",
      "Molarband BO": "110044",
      "Village Tugalkabad BO": "110044",
      "Lal Kuan BO": "110044",
      "Tehkhand BO": "110020",
      "Dera BO": "110074",
      "BHATI VILLAGE BO": "110074",
      "Safdarjung Enclave SO": "110029",
      "Technology Bhawan SO": "110016",
      "T B Hospital SO": "110030",
      "Lodi Road HO": "110003",
      "Air Force Station Tugalkabad SO": "110080",
      "Dr Ambedkar Nagar SO South Delhi": "110062",
      "New Friends Colony SO": "110025",
      "Pushpa Bhawan SO": "110062",
      "Sarita Vihar SO": "110076",
      "Distt Court Complex Saket SO": "110017",
      "Jungpura SO": "110014",
      "Malviya Nagar SO South Delhi": "110017",
      "Ansari Nagar SO": "110029",
      "Chattarpur SO": "110074",
      "Green Park Market SO": "110016",
      "Badarpur SO South Delhi": "110044",
      "Dakshinpuri PhaseII SO": "110062",
      "Dakshinpuri PhaseIII SO": "110062",
      "Greater Kailash SO": "110048",
      "Khanpur SO South Delhi": "110080",
      "Sangam Vihar SO": "110080",
      "Lajpat Nagar South Delhi SO": "110024",
      "MMTCSTC Colony SO": "110017",
      "Panchsheel Enclave SO": "110017",
      "Pushp Vihar SO": "110017",
      "Hauz Khas SO": "110016",
      "IT Hauz Khas SO": "110016",
      "NIE Campus SO": "110016",
      "BSF Camp Tigri SO": "110080",
      "Dakshinpuri PhaseI SO": "110062",
      "Hazrat Nizamuddin SO": "110013",
      "Saket SO South Delhi": "110017",
      "Sarvodya Enclave SO": "110017",
      "Sriniwaspuri SO": "110065",
      "Arjungarh SO": "110047",
      "Hauz Khas Market SO": "110016",
      "Nauroji Nagar SO": "110029",
      "Ignou SO": "110068",
      "Mehrauli SO": "110030",
      "Paryavaran Complex SO": "110030",
      "Hamdard Nagar SO": "110062",
      "Okhla Industrial Estate SO": "110020",
      "Talimabad SO": "110080",
      "Andrewsganj SO": "110049",
      "South Malviya Nagar SO": "110017"
    },
    "SOUTH WEST": {
      "Mundela Kalan B.O": "110073",
      "Ghuman Hera B.O": "110073",
      "Issapur B.O": "110073",
      "Jafarpur B.O": "110073",
      "Khera Dabur B.O": "110073",
      "Raota B.O": "110073",
      "Galib Pur B.O": "110073",
      "Malik Pur B.O": "110073",
      "Quazipur B.O": "110073",
      "Jharoda Kalan B.O": "110072",
      "Jhatikara B.O": "110043",
      "Khaira B.O": "110043",
      "Daulatpur B.O": "110043",
      "Pandwala Kalan B.O": "110043",
      "Surehra B.O": "110043",
      "Dabri B.O": "110045",
      "Nasirpur B.O": "110045",
      "Dhulsiras B.O": "110077",
      "Kair B.O": "110043",
      "Badusarai B.O": "110071",
      "Amberhai B.O": "110075",
      "Dichaun Kalan B.O": "110043",
      "Dindarpur B.O": "110043",
      "Mitraon B.O": "110043",
      "Rewla Khanpur B.O": "110043",
      "Kangan Heri B.O": "110071",
      "Kakrola B.O": "110078",
      "Papravat B.O": "110043",
      "Indira Park B.O": "110045",
      "Barthal B.O": "110077",
      "District Court Complex Dwarka S.O": "110075",
      "N.S.I.T. Dwarka S.O": "110078",
      "Chhawla S.O": "110071",
      "CRPF Jharoda Kalan S.O": "110072",
      "Dwarka Sec-6 S.O": "110075",
      "Najafgarh S.O": "110043",
      "Dhansa S.O": "110073",
      "Gopal Nagar SO": "110043",
      "Durga Park PO": "110043",
      "GGSIP University S.O": "110078",
      "Palam Extn (Harijan Basti) S.O": "110077",
      "Palam Village S.O": "110045",
      "Raj Nagar   II S.O": "110077",
      "SHYAM VIHAR S.O": "110043",
      "Ujwa S.O": "110073",
      "Qutub Vihar SO": "110071",
      "Arjun Park PO": "110043",
      "Mahavir Enclave": "110045",
      "Kapashera SO": "110097",
      "Bijwasan SO": "110061"
    },
    "WEST": {
      "Mundka SO": "110041",
      "Matiala B.O": "110059",
      "Bakkarwala B.O": "110041",
      "Hirankudna B.O": "110041",
      "Mundka B.O": "110041",
      "Peeragarhi B.O": "110087",
      "Nilothi B.O": "110041",
      "Tikri Kalan B.O": "110041",
      "Jawala Heri B.O": "110063",
      "Chaukhandi B.O": "110018",
      "Hastal Village B.O": "110059",
      "Jeevan Park B.O": "110059",
      "Nangloi   II B.O": "110041",
      "Ranhola B.O": "110041",
      "Neelwal BO": "110041",
      "Tilangpur Kotla B.O": "110043",
      "Baprola B.O": "110043",
      "Maya Puri S.O": "110064",
      "Mayapuri Shopping Centre S.O": "110064",
      "Ramesh Nagar H.O": "110015",
      "Chand Nagar S.O": "110018",
      "D.E.S.U. Colony S.O": "110058",
      "ESI S.O": "110015",
      "Khyala Phase   II S.O": "110018",
      "Madipur Slum Quarter S.O": "110063",
      "Madipur Village S.O": "110063",
      "Punjabi Bagh Sec   III S.O": "110026",
      "Subhash Nagar S.O (West Delhi)": "110027",
      "Tilak Nagar S.O (West Delhi)": "110018",
      "Vikas Puri S.O": "110018",
      "Ashoka Park Extn. S.O": "110026",
      "Janakpuri B 1 S.O": "110058",
      "Janakpuri C 4 S.O": "110058",
      "Karam Pura S.O": "110015",
      "Khyala Phase    I S.O": "110018",
      "M.B.S. Nagar S.O": "110018",
      "Inderpuri SO": "110012",
      "Patel Nagar South SO": "110008",
      "Mahabir Nagar S.O": "110018",
      "Mansarover Garden S.O": "110015",
      "Punjabi Bagh S.O": "110026",
      "Kunwar Singh Nagar PO": "110041",
      "K5 Extn. Mohan Garden": "110059",
      "Dada Ghosh Bhawan SO": "110008",
      "Multani Dhanda SO": "110055",
      "Ashok Nagar S.O (West Delhi)": "110018",
      "D. K. Mohan Garden S.O": "110059",
      "Janta Market S.O": "110027",
      "Paschim Vihar B Block S.O": "110063",
      "Rajouri Garden J 6 S.O": "110027",
      "Rajouri Market S.O": "110027",
      "Tagore Garden S.O": "110027",
      "Tilak Nagar East S.O": "110018",
      "Zakhira S.O": "110015",
      "Sanjay Enclave PO": "110059",
      "IARI SO": "110012",
      "National Physical Laboratory SO": "110012",
      "Patel Nagar SO Central Delhi": "110008",
      "Patel Nagar West SO": "110008",
      "Fateh Nagar S.O": "110018",
      "Hari Nagar BE Block S.O": "110064",
      "Hari Nagar Dadb Block S.O": "110064",
      "Hari Nagar S.O (West Delhi)": "110064",
      "Jail Road S.O (West Delhi)": "110058",
      "Janakpuri A 3 S.O": "110058",
      "Jwala Puri S.O": "110087",
      "L. M. Nagar Indl. Area S.O": "110015",
      "Nangloi   III S.O": "110041",
      "Nangloi S.O": "110041",
      "Paschim Vihar S.O": "110063",
      "Shivaji Park S.O (West Delhi)": "110026",
      "Subhash Nagar West S.O": "110027",
      "Sunder Vihar S.O": "110087",
      "Uttam Nagar S.O": "110059",
      "Vishnu Garden S.O": "110018",
      "Moti Nagar S.O": "110015",
      "Patel Nagar East SO": "110008"
    },
    "NORTH EAST": {
      "Dayalpur BO": "110094",
      "Khajoori Khas BO": "110090",
      "Johripur BO": "110094",
      "Mandoli Saboli BO": "110093",
      "Sabhapur BO": "110090",
      "Badarpur Khadar BO": "110090",
      "Garhi Mandu BO": "110053",
      "New Usmanpur BO": "110053",
      "Maujpur SO": "110053",
      "Nand Nagri C SO": "110093",
      "Seelampur SO": "110053",
      "Nand Nagri A SO": "110093",
      "Shaheed Bhagat Singh Colony SO": "110090",
      "Shriram Colony Rajeev Nagar SO": "110090",
      "Sonia Vihar SO": "110090",
      "Yamuna Vihar SO": "110053",
      "Sunder Nagari SO": "110093",
      "Brahampuri SO": "110053",
      "Gokal Puri SO": "110094",
      "Harsh Vihar SO": "110093",
      "Jagjit Nagar SO": "110053",
      "Karawal Nagar SO": "110090",
      "Housing Complex Loni Road SO": "110093",
      "Bhajan Pura SO": "110053",
      "Jafrabad SO East Delhi": "110053"
    },
    "NORTH": {
      "Kadipur BO": "110036",
      "Mukhmelpur BO": "110036",
      "Pooth Khurd BO": "110039",
      "Mungeshpur BO": "110039",
      "Shalamar BO": "110088",
      "Nangal Poona BO": "110036",
      "Palla BO": "110036",
      "Holambi Kalan BO": "110082",
      "Pehlad Pur BO": "110042",
      "Siraspur BO": "110042",
      "Mukundpur Village": "110042",
      "Jagatpur BO": "110084",
      "Hiranki BO": "110036",
      "Khampur BO": "110036",
      "Jat Khore BO": "110039",
      "Nangal Thakran BO": "110039",
      "Bhorgarh BO": "110040",
      "Jharoda Majraa BO": "110084",
      "Bakhtawar Pur BO": "110036",
      "Bakoli BO": "110036",
      "Auchandi BO": "110039",
      "Barwala BO": "110039",
      "Ghoga BO": "110039",
      "Hareveli BO": "110039",
      "Katewara BO": "110039",
      "Bhalaswa BO": "110033",
      "Khera Khurd BO": "110082",
      "Naya Bans BO": "110082",
      "Ashok Vihar HO": "110052",
      "Padam Nagar SO North Delhi": "110007",
      "Shakti Nagar SO North Delhi": "110007",
      "Jahangir Puri A Block SO": "110033",
      "Jahangir Puri D Block SO": "110033",
      "NSMandi SO": "110033",
      "Jawahar Nagar SO North Delhi": "110007",
      "RCAO SO": "110007",
      "Rana Pratap Bagh SO": "110007",
      "Roshan Ara Road SO": "110007",
      "Alipur SO": "110036",
      "DrMukerjee Nagar SO": "110009",
      "Haiderpur SO": "110088",
      "Jahangir Puri H Block SO": "110033",
      "Model Town II SO": "110009",
      "Delhi University SO": "110007",
      "Kamla Nagar SO North Delhi": "110007",
      "Bawana SO": "110039",
      "Khera Kalan SO": "110082",
      "Model Town III SO": "110009",
      "Narela SO": "110040",
      "Roop Nagar SO": "110007",
      "Adrash Nagar SO": "110033",
      "GTB Nagar SO": "110009",
      "HSSangh SO": "110009",
      "Nirankari Colony SO": "110009",
      "Shahbad Dairy PO": "110042",
      "Shastri Nagar SO North West Delhi": "110052",
      "NARELA TOWN": "110040",
      "Satyawati Nagar SO": "110052",
      "Shalimar Bagh SO North West Delhi": "110088",
      "Wazir Pur III SO": "110052",
      "G T B Nagar extension SO": "110009",
      "Baratooti SO": "110006",
      "Samai Pur SO": "110042",
      "Chandni Chowk SO": "110006"
    },
    "NORTH WEST": {
      "Jaunti BO": "110081",
      "Bankner BO": "110040",
      "Rampura BO": "110035",
      "Rithala BO": "110085",
      "Pooth Kalan BO": "110086",
      "Punjab Khor BO": "110081",
      "Rani Khera BO": "110081",
      "H S School": "110081",
      "Lampur BO": "110040",
      "Singhu BO": "110040",
      "Tikri Khurd BO": "110040",
      "Begumpur BO": "110086",
      "Qutabagarh BO": "110039",
      "Gheora BO": "110081",
      "Karala BO": "110081",
      "Lad Pur BO": "110081",
      "Budh Vihar BO": "110086",
      "Prem Nagar BO": "110086",
      "Chand Pur BO": "110081",
      "Majra Dabas BO": "110081",
      "Mubarak Pur Dabas BO": "110081",
      "Nizampur BO": "110081",
      "Kanya Gurukul BO": "110040",
      "Avantika SO": "110085",
      "Kanjhawla SO": "110081",
      "Mangolpuri A Block SO": "110083",
      "Keshavpuram SO": "110035",
      "Rani Bagh SO": "110034",
      "Delhi Engg College SO": "110042",
      "Ganeshpura SO": "110035",
      "Gujranwala Colony SO": "110009",
      "Mangolpuri I  Block SO": "110083",
      "Pooth Kalan Resettlement SO": "110086",
      "Prashant Vihar SO": "110085",
      "Rohini sec11 SO": "110085",
      "Gulabi Bagh SO": "110007",
      "Anandvas Shakurpur SO": "110034",
      "Badli SO North West Delhi": "110042",
      "C4 Keshav Puram SO North West Delhi": "110035",
      "Mangolpuri N Block SO": "110083",
      "Mangolpuri S Block SO": "110083",
      "Nimri SO": "110052",
      "Maurya Enclave SO": "110034",
      "Power House SO": "110035",
      "Rohini Courts SO": "110085",
      "Rohini Sector 15 SO": "110089",
      "Rohini Sector 5 SO": "110085",
      "Rohini Sector7 SO": "110085",
      "Sarai Rohilla SO": "110035",
      "KIRARI SULEMAN NAGAR SO": "110086",
      "Nodal Delivery Centre(Parcel), Rohini": "110110",
      "Saraswati Vihar SO": "110034",
      "Shakurbasti Rs SO": "110034",
      "Sultanpuri C Block SO": "110086",
      "Shakur Basti Depot SO": "110056",
      "Shakur Pur I  Block SO": "110034",
      "ROHINI SECTOR 23 SO": "110099",
      "Sri Nagar Colony SO": "110034",
      "Sultanpuri B Block SO": "110086",
      "Sultanpuri F Block SO": "110086",
      "Rohini Sector 16 PO": "110085",
      "INDERLOK SO": "110035",
      "Rohini Sector 15 extension So": "110089"
    },
    "NEW DELHI": {
      "Shahbad Mohammadpur BO": "110061",
      "Mahipalpur BO": "110037",
      "Masood Pur BO": "110070",
      "Aps Colony BO": "110010",
      "Rajokari BO": "110038",
      "Nangal Dewat BO": "110037",
      "Bagdola B.O": "110077",
      "R K Puram Sect7 SO": "110022",
      "R K Puram Sect8 SO": "110022",
      "R K Puram Sector  6 Postal SB SO": "110022",
      "R R Hospital SO": "110010",
      "R K Puram West SO": "110066",
      "R K Puram Sect4 SO": "110022",
      "R K Puram Sect5 SO": "110022",
      "Signal Enclave SO": "110010",
      "Station Road SO South West Delhi": "110010",
      "Vasant Kunj PktA SO": "110070",
      "Vasant Kunj SO": "110070",
      "South Delhi Campus SO": "110021",
      "Subroto Park SO": "110010",
      "Vasant Vihar1 SO": "110057",
      "Vasant Vihar2 SO": "110057",
      "Naraina Village S.O": "110028",
      "Nangal Raya S.O": "110046",
      "Sansad Marg HO": "110001",
      "New Delhi GPO": "110001",
      "Sarojini Nagar HO": "110023",
      "Naraina Industrial Estate H.O": "110028",
      "Supreme Court SO": "110001",
      "Connaught Place SO": "110001",
      "Election Commission SO": "110001",
      "Lady Harding Medical College SO": "110001",
      "Rail Bhawan SO": "110001",
      "Rashtrapati Bhawan SO": "110004",
      "Secretariat North SO": "110001",
      "Shastri Bhawan SO": "110001",
      "Union Public Service Commission SO": "110069",
      "Baroda House SO": "110001",
      "Pandara Road SO": "110003",
      "CAT EXTENSION COUNTER": "110001",
      "NGT EXTENSION COUNTER": "110001",
      "Sansadiya Soudh SO": "110001",
      "Udyog Bhawan SO": "110011",
      "Bhagat Singh Market SO": "110001",
      "RML EXTN COUNTER NDHO": "110001",
      "Delhi Cantt SO": "110010",
      "IGI Airport SO": "110037",
      "JNU SO": "110067",
      "Moti Bagh SO": "110021",
      "Netaji Nagar SO South West Delhi": "110023",
      "Palam Airport SO": "110037",
      "Pinto Park SO": "110010",
      "Delhi High Court SO": "110003",
      "Patiala House SO": "110001",
      "Bengali Market SO": "110001",
      "Janpath SO": "110001",
      "Nirman Bhawan SO": "110011",
      "South Avenue SO": "110001",
      "Sagarpur S.O": "110046",
      "A F Rajokari SO": "110038",
      "JNU New Campus SO": "110067",
      "Kirby Place SO": "110010",
      "Laxmi Bai Nagar SO": "110023",
      "Nanak Pura SO": "110021",
      "Delhi High Court Extension Counter SO": "110003",
      "Krishi Bhawan SO": "110001",
      "North Avenue SO": "110001",
      "Parliament House SO": "110001",
      "A F Palam SO": "110010",
      "CVD SO": "110010",
      "R K Puram Sect1 SO": "110022",
      "R K Puram Sect3 SO": "110022",
      "R K Puram Sect12 SO": "110022",
      "505 A B Workshop SO": "110010",
      "Anand Niketan SO": "110021",
      "Chanakya Puri SO": "110021",
      "COD SO South West Delhi": "110010",
      "Dhaula Kuan SO": "110010",
      "Gurgaon Road SO": "110037",
      "Kidwai Nagar East SO": "110023",
      "Kidwai Nagar West SO": "110023",
      "Malcha Marg SO": "110021",
      "Munirka SO": "110067",
      "R K Puram Main SO": "110066"
    },
    "EAST": {
      "Chilla BO": "110091",
      "Ghazipur BO": "110096",
      "Govind Pura SO": "110051",
      "Himmatpuri SO": "110091",
      "IP Extension SO": "110092",
      "Kalyanvas SO": "110091",
      "Laxmi Nagar SO East Delhi": "110092",
      "Mayur Vihar PhI SO": "110091",
      "Patparganj SO": "110091",
      "Rajgarh Colony SO": "110031",
      "Yozna Vihar SO": "110092",
      "Vasundhra Enclave SO": "110096",
      "Anand Vihar SO": "110092",
      "Mandawali Fazalpur SO": "110092",
      "Shakarpur SO": "110092",
      "Kalyanpuri SO": "110091",
      "Mayur Vihar PhIII SO": "110096",
      "Nirman Vihar SO": "110092",
      "Ram Nagar SO East Delhi": "110051",
      "Shastri Nagar SO East Delhi": "110031",
      "Trilok Puri SO": "110091",
      "Laxmi Nagar Extension SO": "110092"
    },
    "CENTRAL": {
      "NEW Nathupura": "110084",
      "Patrachar Vidyalay SO": "110054",
      "Indraprastha HO": "110002",
      "Delhi GPO": "110006",
      "Malka Ganj SO": "110007",
      "Burari SO": "110084",
      "Delhi Sadar Bazar SO": "110006",
      "Wazirabad Village SO": "110084",
      "Aruna Nagar SO": "110054",
      "Civil Lines SO North Delhi": "110054",
      "District Courts SO North Delhi": "110054",
      "Timarpur SO": "110054",
      "Darya Ganj SO": "110002",
      "Gandhi Smarak Nidhi SO": "110002",
      "Master Prithvi Nath Marg SO": "110005",
      "Nathupura Village SO": "110084",
      "Sant Nagar SO": "110084",
      "IPEstate SO": "110002",
      "Minto Road SO": "110002",
      "Pragati Maidan SO": "110001",
      "AGCR EXTENSION COUNTER": "110002",
      "Rouse Avenue Extension Counter SO": "110002",
      "Anand Parbat SO": "110005",
      "Karol Bagh SO": "110005",
      "Pahar Ganj SO": "110055",
      "Jama Masjid SO": "110006",
      "SRT NAGAR EXTENSION COUNTER": "110055",
      "Bank Street SO Central Delhi": "110005",
      "Desh Bandhu Gupta Road SO": "110005",
      "Sat Nagar SO": "110005",
      "Chawri Bazar SO": "110006",
      "Dareeba SO": "110006",
      "AGCR SO": "110002",
      "Ajmeri Gate Extn SO": "110002",
      "Hauz Qazi SO": "110006",
      "Civic Centre PO": "110002",
      "AKMarket SO": "110055",
      "Anand Parbat Indl Area SO": "110005",
      "Guru Gobind Singh Marg SO": "110005",
      "Rajender Nagar SO": "110060",
      "Swami Ram Tirth Nagar SO": "110055"
    },
    "SHAHDARA": {
      "Jhilmil Tahirpur BO": "110095",
      "Jhilmil HO": "110095",
      "Krishna Nagar HO": "110051",
      "Shahdara SO": "110032",
      "Gandhi Nagar SO East Delhi": "110031",
      "Vishwas Nagar SO": "110032",
      "Shivaji Park SO East Delhi": "110032",
      "Raghubar Pura SO": "110031",
      "Surajmal Vihar SO": "110092",
      "New Seemapuri SO": "110095",
      "Old Seemapuri SO": "110095",
      "Shahdara Mandi SO": "110032",
      "Azad Nagar SO East Delhi": "110051",
      "Distt Court KKD SO": "110032",
      "Kailash Nagar SO": "110031",
      "Vivek Vihar SO": "110095",
      "Rohtash Nagar SO": "110032",
      "Telewara SO": "110032",
      "Gandhi Nagar Bazar SO": "110031",
      "Geeta Colony SO": "110031",
      "Vishwakarma Nagar SO": "110095",
      "Balbir Nagar SO": "110032",
      "Bhola Nath Nagar SO": "110032",
      "Goverdhan Bihari Colony SO": "110032",
      "Man Sarovar Park SO": "110032",
      "Babarpur SO North East Delhi": "110032",
      "Dilshad Garden SO": "110095",
      "GTB Hospital SO": "110095",
      "Loni Road SO": "110032"
    },
    "South East": {
      "Kalkaji HO": "110019",
      "Alaknanda SO": "110019",
      "Jaitpur SO South Delhi": "110044",
      "Tugalkabad Railway Colony SO": "110044",
      "Zakir Nagar SO": "110025",
      "Aliganj SO South Delhi": "110003",
      "Amar Colony SO": "110024",
      "Dargah Sharif SO": "110013",
      "Gautam Nagar SO": "110049",
      "Hari Nagar Ashram SO": "110014",
      "New Delhi South ExtII SO": "110049",
      "Pratap Market SO": "110014",
      "Sadiq Nagar SO": "110049",
      "Chittranjan Park SO": "110019",
      "BTPS SO South Delhi": "110044",
      "Nehru Place SO": "110019",
      "Okhla Industrial Area Phasei SO": "110020",
      "Meethapur SO": "110044",
      "Defence Colony SO South Delhi": "110024",
      "East Of Kailash PhaseI SO": "110065",
      "Golf Links SO": "110003",
      "Nehru Nagar SO South Delhi": "110065",
      "Safdarjung Air Port SO": "110003",
      "Sant Nagar SO South Delhi": "110065",
      "Jamia Nagar SO": "110025",
      "Kailash Colony SO": "110048",
      "Sukhdev Vihar SO": "110025",
      "East Of Kailash SO": "110065",
      "Gulmohar Park SO": "110049",
      "Krishna Market SO": "110024",
      "Pragati Vihar SO": "110003",
      "C R R I SO South Delhi": "110020",
      "F F C Okhla SO": "110020",
      "Masjid Moth SO": "110048",
      "C G O Complex SO": "110003",
      "Kasturba Nagar SO South Delhi": "110003"
    }
  },
  "JAMMU AND KASHMIR": {
    "ANANTNAG": {
      "Bulbul Nowgam BO": "192201",
      "Chattargui BO": "192201",
      "Dethunagnarian BO": "192201",
      "Omanagri BO": "192201",
      "Shangas BO": "192201",
      "Brah BO": "192201",
      "Hardtour BO": "192201",
      "Nowgam B.O": "192201",
      "Utersoo BO": "192201",
      "Akingam BO": "192201",
      "Chakilpora BO": "192201",
      "Hiller Arahama BO": "192201",
      "Telwani BO": "192201",
      "Shalgam BO": "192124",
      "Shamsipora BO": "192124",
      "Obindora BO": "192211",
      "Danipora BO": "192202",
      "Kharapora BO": "192202",
      "Larnoo BO": "192202",
      "Laripora BO": "192126",
      "Yarkhoshipora BO": "192221",
      "Chowgam BO": "192221",
      "Mandhole BO": "192221",
      "Monghal BO": "192221",
      "Hapatnar BO": "192129",
      "Khayar BO": "192129",
      "Logripora BO": "192129",
      "Kanilwan BO": "192124",
      "Urran Hall BO": "192124",
      "Wanpoh BO": "192124",
      "Fateh Pora BO": "192210",
      "Hakura Badasgam BO": "192210",
      "Kriri Nowpora BO": "192211",
      "Quimoh BO": "192101",
      "Ahalangodol BO": "192202",
      "Nalasundhari BO": "192202",
      "Vandevalgam BO": "192202",
      "Gopal Pora BO": "192125",
      "Nambal BO": "192125",
      "Brinal Lammer BO": "192221",
      "Sopat Tengpora BO": "192221",
      "Arwani BO": "192124",
      "Tulkhana BO": "192124",
      "Hiller Shahabad BO": "192211",
      "Larkipora BO": "192210",
      "Buchoo BO": "192202",
      "Daksum BO": "192202",
      "Narapora BO": "192202",
      "Krandigam BO": "192124",
      "Marhama BO": "192124",
      "Naina BO": "192124",
      "Opzen BO": "192124",
      "Veeri BO": "192124",
      "Waghama BO": "192124",
      "Gosanigund BO": "192210",
      "Muti Handoo BO": "192202",
      "Nowbug BO": "192202",
      "Sagam B.O": "192202",
      "Soaf Shali BO": "192202",
      "Akura BO": "192125",
      "Hutmarah BO": "192125",
      "Nanil BO": "192125",
      "Ranbirpora BO": "192125",
      "Kund BO": "192221",
      "Nissu BO": "192221",
      "Panzeth BO": "192221",
      "Vesshu BO": "192221",
      "Wangund BO": "192221",
      "Levidoora BO": "192221",
      "Vailobrang BO": "192202",
      "Kragsoo BO": "192125",
      "Manjmoh BO": "192221",
      "Bumthan BO": "192221",
      "Chandrigam BO": "192129",
      "Ganeshpora BO": "192129",
      "Salia BO": "192129",
      "Siligam BO": "192129",
      "Ashmuqam BO": "192129",
      "Batakote BO": "192129",
      "Sallar BO": "192401",
      "Sirhama BO": "192401",
      "Wallarhama BO": "192401",
      "Nowgam BO": "192212",
      "Qanmar BO": "192212",
      "Sadinare BO": "192212",
      "Kharam BO": "192401",
      "Mohind BO": "192401",
      "Lower Mundah BO": "192212",
      "Batagund BO": "192212",
      "Dhawtoo BO": "192401",
      "Kathsoo BO": "192401",
      "Kullar BO": "192401",
      "Pushkriri BO": "192401",
      "Kaprin BO": "192212",
      "Beerwara BO": "192401",
      "Dalseer BO": "192401",
      "Hugam BO": "192401",
      "Bonagand BO": "192212",
      "Halsidar BO": "192212",
      "Anantnag HO": "192101",
      "Srigufwaea SO": "192401",
      "Achabal SO": "192201",
      "Dooru SO": "192211",
      "Janglath Mandi SO": "192101",
      "Khanabal SO": "192101",
      "Martand SO": "192125",
      "Phalgam SO": "192126",
      "S K Gund": "192129",
      "Verinaag SO": "192212",
      "Anantnag City SO": "192122",
      "Dialgam": "192210",
      "Bijbehara SO": "192124",
      "Qazigund SO": "192221",
      "Sarnal SO": "192101",
      "Kokarnag SO": "192202"
    },
    "POONCH": {
      "Hari Marhote BO": "185121",
      "Lassana BO": "185121",
      "Seri Khawaja BO": "185121",
      "Sialan BO": "185121",
      "Madana BO": "185121",
      "Sangiote BO": "185121",
      "Jara Wali Gali BO": "185121",
      "Sanai BO": "185121",
      "Sangla BO": "185121",
      "Ari BO": "185211",
      "Chuggan BO": "185211",
      "Naka Majari BO": "185211",
      "Prat BO": "185211",
      "Chella Dhangri BO": "185102",
      "Salunian BO": "185102",
      "Kalai BO": "185101",
      "Magnar BO": "185101",
      "Nangali Sahib BO": "185101",
      "Shahpur BO": "185101",
      "Bafliaz BO": "185121",
      "Chatral BO": "185211",
      "Chhajla BO": "185211",
      "Harni BO": "185211",
      "Jugal BO": "185211",
      "Mankot BO": "185211",
      "Ochhad BO": "185211",
      "Bedar Balnai BO": "185102",
      "Sathra BO": "185102",
      "Sawjian BO": "185102",
      "Ajote BO": "185101",
      "Jhulas BO": "185101",
      "Khanetar BO": "185101",
      "Bhata Dhurian BO": "185121",
      "Gursai Mohri BO": "185121",
      "Hari Budha BO": "185121",
      "Dharana BO": "185211",
      "Dhargloon BO": "185211",
      "Sagra BO": "185211",
      "Sakhi Maidan BO": "185211",
      "Salwah BO": "185211",
      "Fatehpur BO": "185102",
      "Gagerian BO": "185102",
      "Loran BO": "185102",
      "Palera BO": "185102",
      "Shindra BO": "185101",
      "Hari BO": "185121",
      "Galhuta BO": "185211",
      "Gursai BO": "185211",
      "Kalaban BO": "185211",
      "Kasbalari BO": "185211",
      "Arai BO": "185102",
      "Bandi Chichian BO": "185101",
      "Chandak BO": "185101",
      "Degwar Maldalyan BO": "185101",
      "Dhara Dhullian BO": "185101",
      "Chandi Marh BO": "185121",
      "Draba BO": "185121",
      "Fazalabad BO": "185121",
      "Gunthal BO": "185121",
      "Mandi SO": "185102",
      "Poonch SO": "185101",
      "Dharamsal Mendhar SO": "185211",
      "Samote SO": "185121"
    },
    "RAJOURI": {
      "Dharamsal BO": "185201",
      "Gonda BO": "185201",
      "Patrara BO": "185153",
      "Rahsiyot BO": "185153",
      "Shadhra Sharif BO": "185212",
      "Rehtal BO": "185133",
      "Harichuma BO": "185201",
      "Khawas BO": "185201",
      "Bhajwal BO": "185153",
      "Azamtabad BO": "185212",
      "Behrote BO": "185212",
      "Same BO": "185212",
      "Brehvi BO": "185201",
      "Khersoo BO": "185201",
      "Tareru BO": "185201",
      "Bhattian BO": "185212",
      "Dodasanbala BO": "185212",
      "Saj BO": "185212",
      "Fatehpur BO": "185133",
      "Chak Mathani BO": "185201",
      "Mohgla BO": "185201",
      "Panjah BO": "185201",
      "Rajdhani BO": "185212",
      "Dhani Dhar BO": "185133",
      "Bimblya BO": "185203",
      "Devak BO": "185203",
      "Gelhan BO": "185203",
      "Sarhoti BO": "185203",
      "Taryath BO": "185203",
      "Hathal BO": "185203",
      "BARNARA": "185153",
      "Muradpur BO": "185131",
      "Galuthi BO": "185131",
      "Kalsian BO": "185155",
      "Langer BO": "185155",
      "Kotranka BO": "185233",
      "Samote BO": "185233",
      "Tuli BO": "185233",
      "Dalhori BO": "185132",
      "Khajmola BO": "185132",
      "Jignicoal BO": "185202",
      "Panjnara BO": "185202",
      "Sair BO": "185202",
      "Dhok Banyar BO": "185156",
      "Tilla Tanda BO": "185156",
      "Dehra BO": "185152",
      "Prat BO": "185152",
      "Bajnoa BO": "185151",
      "Chingas BO": "185151",
      "Dabbar Potha BO": "185151",
      "Gagrote BO": "185151",
      "Rajal BO": "185151",
      "Seri BO": "185151",
      "JAJOTE KUNDU": "185151",
      "Dehri Ralyote BO": "185131",
      "Gambir Mughlan BO": "185131",
      "Manjakot BO": "185131",
      "Bathuni BO": "185131",
      "Kakora BO": "185131",
      "Sehar BO": "185155",
      "Shergarhi BO": "185233",
      "Chowkian BO": "185135",
      "Dodaj BO": "185135",
      "Raikban BO": "185135",
      "Dassal Jattan BO": "185131",
      "Gambir Brahmana BO": "185131",
      "Lam BO": "185155",
      "Laroka BO": "185155",
      "Kewal BO": "185233",
      "Mamanlot BO": "185233",
      "Shikari BO": "185233",
      "Dharsakri BO": "185132",
      "Gunni BO": "185132",
      "Kotdhara BO": "185234",
      "Palma BO": "185132",
      "Swari BO": "185132",
      "Metka BO": "185202",
      "Potha BO": "185202",
      "Thichka BO": "185156",
      "Dandesar BO": "185152",
      "Garan BO": "185152",
      "Bagla BO": "185151",
      "Bareri BO": "185151",
      "Chowki BO": "185151",
      "Deengmangot BO": "185151",
      "Doongi Brahmana BO": "185151",
      "Hanjana Thakra BO": "185151",
      "Qilla Darhal BO": "185151",
      "Badhoon BO": "185132",
      "Chambitrar BO": "185132",
      "Dhangri BO": "185132",
      "Panihad BO": "185132",
      "Peeri BO": "185132",
      "Saranu BO": "185132",
      "Trala BO": "185132",
      "Sialsui BO": "185202",
      "Tatapani BO": "185202",
      "Bharore BO": "185156",
      "Dhar BO": "185156",
      "Siot BO": "185152",
      "Thanda Pani BO": "185152",
      "Kheri BO": "185151",
      "Narian BO": "185151",
      "Natryal BO": "185151",
      "Nonial BO": "185151",
      "Sangpur BO": "185151",
      "Dalogora BO": "185131",
      "Tandwal BO": "185131",
      "Ghania BO": "185155",
      "Jhanger BO": "185155",
      "Bagnkot BO": "185233",
      "Chana Shikari BO": "185233",
      "Chasote BO": "185233",
      "Daraj BO": "185233",
      "Gakhrote BO": "185132",
      "Kalakas BO": "185132",
      "Kandi BO": "185132",
      "Nagrota BO": "185132",
      "Ujjan BO": "185234",
      "Dali BO": "185202",
      "Darkeri BO": "185202",
      "AMBLIGURHA": "185202",
      "Bagnoti BO": "185152",
      "Bakhar BO": "185152",
      "Chani BO": "185152",
      "Agrati BO": "185151",
      "Androoth BO": "185151",
      "Rajpur Kamila BO": "185151",
      "Rajouri HO": "185131",
      "Baba Ghulam Shah Badshah University SO": "185234",
      "Bhawani SO": "185155",
      "Budhal SO": "185233",
      "Darhal Malkan SO": "185135",
      "Kangri SO": "185156",
      "Jawaharnagar SO Rajauri": "185132",
      "Kalakot SO": "185202",
      "Solki SO": "185201",
      "Sunderbani SO": "185153",
      "Naushera SO": "185151",
      "Thanamandi SO": "185212",
      "Lamberi SO": "185152",
      "Post Graduate College Rajouri SO": "185133"
    },
    "SHOPIAN": {
      "Aglar BO": "192305",
      "Hirapora BO": "192303",
      "Kharawara BO": "192303",
      "Memendar BO": "192303",
      "Nadigam BO": "192303",
      "Sedow BO": "192303",
      "Tankiya Sahib BO": "192303",
      "Trenz BO": "192303",
      "Chitragam BO": "192124",
      "Herman BO": "192303",
      "Narapora BO": "192303",
      "Ramnagri BO": "192303",
      "Wachi BO": "192305",
      "Batpora B.O": "192303",
      "Pinjoora BO": "192303",
      "Saidpora BO": "192303",
      "Hef Shermal BO": "192305",
      "Sugan BO": "192305",
      "Turka Wangam BO": "192305",
      "Zanipora BO": "192124",
      "Brithipora BO": "192306",
      "Vaheel Chatarwatan BO": "192303",
      "Zoora BO": "192303",
      "Reban Gund BO": "192232",
      "Awenura BO": "192232",
      "Keller Mastpora BO": "191112",
      "Shopin SO": "192303"
    },
    "REASI": {
      "Thub BO": "182313",
      "Panthal BO": "182121",
      "Salal BO": "182312",
      "Vaishno Devi BO": "182301",
      "Angrala BO": "182315",
      "Balamatkot BO": "182315",
      "Sarh BO": "182315",
      "Dadoa BO": "185203",
      "Shajroo BO": "182313",
      "Dhanwan BO": "185203",
      "Thiloo BO": "182313",
      "Thuru BO": "182313",
      "Kakriyal BO": "182320",
      "Adhkawari BO": "182301",
      "Dera Baba Banda BO": "182301",
      "Nomain BO": "182301",
      "Bathoi BO": "182315",
      "Deval BO": "182315",
      "Larh BO": "182315",
      "Bharakh BO": "185203",
      "Khairlair BO": "185203",
      "Kund Kanyari BO": "185203",
      "Thanpal BO": "182313",
      "Aghar Baba Jitto BO": "182301",
      "Mangal BO": "182301",
      "Gulabgarh BO": "182315",
      "Allya BO": "185203",
      "Porakotla BO": "185203",
      "Ransoo BO": "185203",
      "Bakkal BO": "182311",
      "Kheral BO": "182311",
      "Sukhalghati BO": "182311",
      "Vijaypur BO": "182311",
      "Sadhoti BO": "185154",
      "Bhagga BO": "182311",
      "Sila BO": "182311",
      "Surjan Dhar BO": "182311",
      "Tote BO": "182311",
      "Mari BO": "182311",
      "Bagdar SERI BO": "182311",
      "TALWARA COLONY BO": "182311",
      "Kainthi BO": "182313",
      "Matlot BO": "182313",
      "Panasa BO": "182313",
      "Pattian BO": "182313",
      "Pul Kanthan BO": "182313",
      "Juda BO": "182313",
      "Sarthalkot BO": "182313",
      "Jij BO": "182313",
      "Dhannore BO": "182313",
      "BhudaraBhudan BO": "182313",
      "Darmari BO": "182313",
      "Jyotipuram SO": "182312",
      "Reasi SO": "182311",
      "SMVDU SO": "182320",
      "District office Complex Reasi SO": "182311",
      "Mahore SO Udhampur": "182315",
      "Arnas SO": "182313",
      "Katra SO Udhampur": "182301",
      "Poni SO": "185203"
    },
    "DODA": {
      "Assar BO": "182143",
      "Trungal BO": "182143",
      "Katyara BO": "182222",
      "Sungli Sartingal BO": "182222",
      "Jodhpur BO": "182202",
      "Chirala BO": "182201",
      "Dhara BO": "182201",
      "Goha BO": "182201",
      "Humble BO": "182201",
      "Mangota BO": "182201",
      "Ranka BO": "182143",
      "Bhagwa BO": "182202",
      "Dessa BO": "182202",
      "Ghat BO": "182202",
      "Dhandal BO": "182147",
      "Ganika BO": "182147",
      "Mundhar BO": "182147",
      "Manlnai BO": "182201",
      "Nai Bhalara BO": "182201",
      "Premnagar BO": "182201",
      "Rukali BO": "182201",
      "TrOwn BO": "182201",
      "Beoli BO": "182202",
      "Gundna BO": "182202",
      "Udyanpur BO": "182202",
      "Malhota BO": "182201",
      "Matindal BO": "182201",
      "Sindra BO": "182201",
      "Samthi BO": "182143",
      "Chanichinta BO": "182222",
      "Bajarni BO": "182202",
      "Dashnan BO": "182202",
      "Bhalla BO": "182221",
      "Jogote BO": "182201",
      "Malhori BO": "182201",
      "Mohalla BO": "182201",
      "Roat BO": "182201",
      "Shiva BO": "182201",
      "Chunri BO": "182203",
      "Chattarsori BO": "182221",
      "Chilli BO": "182203",
      "Dhosa BO": "182203",
      "Inharrah BO": "182203",
      "Jaura BO": "182203",
      "Bhalra BO": "182221",
      "Kursari BO": "182221",
      "Jakyas BO": "182203",
      "Kaljugasar BO": "182203",
      "Kilhotran BO": "182203",
      "Malanoo BO": "182203",
      "Nodinalla BO": "182203",
      "Malhoti BO": "182221",
      "GAJOTH BO": "182221",
      "Udrana SO": "182221",
      "GANDOH SO": "182207",
      "Doda SO Doda": "182202",
      "Kastigarh SO": "182147",
      "Khellani SO": "182201",
      "Thathri SO": "182203",
      "Bhaderwah SO": "182222"
    },
    "KISHTWAR": {
      "Badhat BO": "182204",
      "Aftee BO": "182205",
      "Chhatroo BO": "182205",
      "Chingam BO": "182205",
      "Gulabgarh BO": "182204",
      "Kukerwas BO": "182204",
      "Kuttal BO": "182204",
      "Mandel BO": "182204",
      "Padar BO": "182204",
      "Pochhal BO": "182204",
      "Sigdi BO": "182205",
      "Tagood BO": "182205",
      "Thakrai BO": "182205",
      "Dool BO": "182204",
      "Dachhan BO": "182205",
      "Mugal Maidan BO": "182205",
      "Galhar BO": "182204",
      "Kandni BO": "182204",
      "Sarthal BO": "182204",
      "MASSU BO": "182204",
      "Inderwal BO": "182205",
      "Nowpachi BO": "182205",
      "Banoon BO": "182203",
      "Dul Hasti Project SO": "182206",
      "Palmar SO": "182205",
      "Kishtwar SO": "182204"
    },
    "UDHAMPUR": {
      "Bain BO": "182141",
      "Dhanas BO": "182141",
      "Ladha BO": "182125",
      "Nagulta BO": "182141",
      "Sudhmahadev BO": "182141",
      "Malhar BO": "182121",
      "Mand BO": "182121",
      "Seen Thakrian BO": "182121",
      "Johnu BO": "182124",
      "Kaldi BO": "182124",
      "Sermanjla BO": "182124",
      "Madha BO": "182142",
      "Peoni BO": "182127",
      "Thalora BO": "182127",
      "Basantgarh BO": "182128",
      "Dudoo BO": "182128",
      "Jakhed BO": "182128",
      "Joffar BO": "182128",
      "Landhar BO": "182125",
      "Mongri BO": "182125",
      "Panjar BO": "182125",
      "Basahat BO": "182141",
      "Kithar BO": "182141",
      "Garnai BO": "182121",
      "Jangalgali BO": "182121",
      "Seen Bhramena BO": "182121",
      "Tikri BO": "182121",
      "Chanunta BO": "182124",
      "Sangote BO": "182142",
      "Khoon BO": "182127",
      "Khaned BO": "182128",
      "Siamehri BO": "182128",
      "Kalsote BO": "182125",
      "Charat BO": "182141",
      "Pakhlai BO": "182141",
      "Hartriyan BO": "182121",
      "Jib BO": "182121",
      "Barmeen BO": "182124",
      "Dhandal BO": "182124",
      "Karlah BO": "182142",
      "Battal BO": "182127",
      "Keya BO": "182128",
      "Pachound BO": "182128",
      "Kainthgali BO": "182125",
      "Kuddal BO": "182125",
      "Samroli BO": "182141",
      "Satuyalta BO": "182141",
      "Barola BO": "182121",
      "Charyari BO": "182121",
      "Hartrian BO": "182124",
      "Bapp BO": "182161",
      "Damnote BO": "182125",
      "Galiote BO": "182125",
      "Mansar BO": "184121",
      "Barigarh BO": "184121",
      "BANDHOLE BO": "182161",
      "Bland BO": "182122",
      "Dalsar BO": "182122",
      "Pattangarh BO": "182122",
      "Thial BO": "184205",
      "Sattian BO": "182122",
      "Sonetar BO": "182122",
      "Kaghote BO": "182126",
      "Dhanwalt BO": "182122",
      "Dhiari BO": "182122",
      "Nala Ghoria BO": "182122",
      "Bainsta BO": "182126",
      "Barerian BO": "182126",
      "Bhatiari BO": "182126",
      "Bari BO": "182122",
      "Chowki Jandrorh BO": "182122",
      "Kakrai BO": "184121",
      "Ghorari BO": "182122",
      "Jandrari BO": "182122",
      "Rang BO": "182122",
      "Amroh BO": "182122",
      "Kotwalt BO": "182122",
      "Marta BO": "182122",
      "Nagrota Panj Garain BO": "182122",
      "BADHOLE BO": "182122",
      "Kuhritti BO": "182126",
      "Babey BO": "184205",
      "Sundla BO": "184205",
      "GARH SAMNA BANJ BO": "180012",
      "Dhamma BO": "184205",
      "Krimchi BO": "182101",
      "PTS Udhampur BO": "182101",
      "Rathian BO": "182101",
      "Bali BO": "182101",
      "Salmehri BO": "182101",
      "Jakhani BO": "182101",
      "Kawa BO": "182101",
      "Gandala BO": "182101",
      "Chak Rakhwalan BO": "182101",
      "KASHIRAH BO": "182101",
      "Udhampur HO": "182101",
      "Majalta SO": "182127",
      "Mj Road Nd SO": "182101",
      "Shaktinagar SO Udhampur": "182101",
      "Kud SO": "182142",
      "Mantalai SO": "182161",
      "Mir SO": "182125",
      "Omara Morh SO": "182101",
      "PTC Udhampur SO": "182104",
      "Udhampur District Court SO": "182101",
      "Chenani SO": "182141",
      "Jaganoo SO": "182124",
      "Ramnagar SO Udhampur": "182122",
      "Garhi SO Udhampur": "182121",
      "Majouri SO": "182128",
      "Roan SO": "182126"
    },
    "RAMBAN": {
      "Chambalwas BO": "182146",
      "Chareel BO": "182146",
      "Kaskoot BO": "182146",
      "Halla BO": "182148",
      "Kainthi BO": "182148",
      "Kundi Karol BO": "182148",
      "Topnel Chuchtar BO": "182148",
      "Duligam BO": "182146",
      "Mahu BO": "182146",
      "Baggar BO": "182143",
      "Bhartund BO": "182148",
      "Neera BO": "182148",
      "Peera BO": "182148",
      "Chakka BO": "182148",
      "Deedah BO": "182144",
      "Gandhari BO": "182144",
      "Mangat BO": "182146",
      "Parindhar BO": "182146",
      "NOWGAM BO": "182146",
      "Sawni BO": "182148",
      "Dharamkund BO": "182144",
      "Gool BO": "182144",
      "Neel BO": "182146",
      "Thathar BO": "182146",
      "Sanasar BO": "182143",
      "Thopal BO": "182143",
      "Tringla BO": "182143",
      "Bhatni BO": "182144",
      "Chachwa BO": "182144",
      "Dalwah BO": "182144",
      "Batroo BO": "182145",
      "Khari BO": "182145",
      "Tarigam BO": "182145",
      "Khorial BO": "182145",
      "Maligam BO": "182145",
      "Paristan BO": "182145",
      "Pogal BO": "182145",
      "Ind BO": "182144",
      "Kanga BO": "182144",
      "Maitra Bazar BO": "182144",
      "Sangaldhan BO": "182144",
      "Thatharka BO": "182144",
      "Alambas BO": "182145",
      "Hoochak BO": "182145",
      "Banihal SO": "182146",
      "Chanderkot SO": "182148",
      "Ramsu SO": "182145",
      "Ramban SO": "182144",
      "Batote SO": "182143"
    },
    "KULGAM": {
      "Manzgam BO": "192233",
      "Nasnoor B.O": "192233",
      "Chadder BO": "192231",
      "Chambgund BO": "192231",
      "Dhane Bougund BO": "192231",
      "Malwan BO": "192231",
      "Shurat BO": "192231",
      "Vokey BO": "192231",
      "Aharbal BO": "192233",
      "Chemmar BO": "192233",
      "D K Marg BO": "192233",
      "Nehama BO": "192233",
      "Arrah BO": "192231",
      "Buchroo BO": "192231",
      "Gadipora BO": "192231",
      "Guddar BO": "192231",
      "HCGam BO": "192231",
      "Nellow BO": "192231",
      "Pariwan BO": "192231",
      "Ahmedabad Thussu BO": "192233",
      "Nandimarg BO": "192233",
      "Nasnoor BO": "192233",
      "Qaimoh B.O": "192124",
      "Gopalpora BO": "192233",
      "Khull BO": "192233",
      "Khuri Batpora B  BO": "192233",
      "Badjahalan BO": "192233",
      "Akhal BO": "192231",
      "Devsar BO": "192231",
      "Mirhama BO": "192231",
      "Nowpora BO": "192231",
      "Pahaloo BO": "192231",
      "Ratnipora BO": "192231",
      "Ashmuji BO": "192231",
      "Kanipora BO": "192231",
      "Kapran BO": "192231",
      "Kilam Bazgam BO": "192231",
      "Katrasoo BO": "192232",
      "Khigogipora BO": "192232",
      "Mgufan BO": "192232",
      "Noonmai BO": "192232",
      "Bugam BO": "192232",
      "Frisal BO": "192232",
      "Turigam Devgubh BO": "192232",
      "Behibagh BO": "192232",
      "Demidulla BO": "192232",
      "Tarigam BO": "192232",
      "Yaripora SO": "192232",
      "Damhal Hanji Pora SO": "192233",
      "Kulgam SO": "192231"
    },
    "PULWAMA": {
      "Ahagam BO": "192302",
      "Arihal BO": "192302",
      "Murram BO": "192301",
      "Newa BO": "192301",
      "Wasoora BO": "192305",
      "Barsoo BO": "192122",
      "Gairoo BO": "192122",
      "Panzgam BO": "192124",
      "Tokna BO": "192124",
      "Balpora BO": "192302",
      "Drabgam BO": "192306",
      "Qasbiyar BO": "192306",
      "Sindhshirmal BO": "192302",
      "Lajoora BO": "192301",
      "Mitrigam BO": "192301",
      "Pingliana BO": "192301",
      "Tiken Batpora BO": "192306",
      "Chakura BO": "192305",
      "Chandhara BO": "192122",
      "Cheersoo BO": "192122",
      "Digripora BO": "192124",
      "Klampora BO": "192306",
      "Ratnipora BO": "192304",
      "Sumboora BO": "192304",
      "Litter BO": "192305",
      "Gouripora BO": "192122",
      "Lathpora BO": "192122",
      "Turkoo Babuar BO": "192302",
      "Koil BO": "192301",
      "Malangpora BO": "192301",
      "Romoh BO": "192301",
      "Shale Tokna BO": "192301",
      "Bandzoo BO": "192301",
      "Inder BO": "192301",
      "Karimabad BO": "192301",
      "Parigam Jagir BO": "192301",
      "Tahaba Shadipora BO": "192301",
      "Waibugh BO": "192301",
      "Banderpora BO": "192301",
      "Batagund BO": "192123",
      "Bouli BO": "192123",
      "Buchoo BO": "192123",
      "Lurgam BO": "192123",
      "Mandoora BO": "192123",
      "Midroo BO": "192123",
      "Pastana BO": "192123",
      "Saimoh BO": "192123",
      "Abhama BO": "191112",
      "Honipora BO": "192121",
      "Aripal BO": "192123",
      "Bargam BO": "192123",
      "Bathnoor BO": "192123",
      "Chattergam BO": "192123",
      "Haripari BO": "192123",
      "Kahleel BO": "192123",
      "Pinglish BO": "192123",
      "Satura BO": "192123",
      "Mandakpal BO": "191103",
      "Baigund BO": "192123",
      "Dadsar BO": "192123",
      "Kachachakote BO": "192123",
      "Ludhoo BO": "191103",
      "Zantrag BO": "191103",
      "Konibal BO": "192121",
      "Pahroo BO": "192121",
      "Nehama BO": "192121",
      "Rajpora": "192306",
      "Tral SO": "192123",
      "Achan SO": "192305",
      "Awantipora SO": "192122",
      "Pulwama SO": "192301",
      "Pampore SO": "192121",
      "Hawl SO": "192302",
      "Khrew SO": "191103",
      "Wuyan SO": "191102",
      "Kakapora": "192304"
    },
    "BARAMULLA": {
      "Sultanpora Kandi B.O": "193101",
      "Bomai B.O": "193201",
      "Botingoo B.O": "193201",
      "Warpora B.O": "193201",
      "Watlab B.O": "193201",
      "Zaloora B.O": "193201",
      "Tarzoo B.O": "193201",
      "Bulgam B.O": "193201",
      "Seer B.O": "193201",
      "Sangrama B.O": "193201",
      "Jamia Qadim B.O": "193201",
      "Nambla B.O": "193123",
      "Parampilla B.O": "193123",
      "Salamabad B.O": "193123",
      "Sultanpora Khoi B.O": "193501",
      "Dangerpora B.O": "193201",
      "Dooru B.O": "193201",
      "Harwan B.O": "193201",
      "Seelu B.O": "193201",
      "Wadoora B.O": "193201",
      "Krankshivam B.O": "193201",
      "Haigam B.O": "193201",
      "Garkote B.O": "193123",
      "Shitloo B.O": "193301",
      "Doabgah B.O": "193201",
      "Hardushiva B.O": "193201",
      "Nowpora Kalan B.O": "193201",
      "Sagipora B.O": "193201",
      "Tujar B.O": "193201",
      "Isham B.O": "193123",
      "Kamalkote B.O": "193123",
      "Sultan Daki B.O": "193123",
      "Hathlangoo B.O": "193201",
      "Ladoora B.O": "193201",
      "Mundji B.O": "193201",
      "Balkote B.O": "193123",
      "Dachi B.O": "193123",
      "Jabla B.O": "193123",
      "Khaitangan B.O": "193109",
      "NOWPORA JAGIR B.O": "193109",
      "Singhpora Kalan B.O": "193103",
      "Wanigam B.O": "193108",
      "Tilgam B.O": "193108",
      "Saloosa B.O": "193108",
      "Bijhama B.O": "193122",
      "Chandanwari B.O": "193122",
      "Nehalpora B.O": "193121",
      "Seru Dangerpora B.O": "193121",
      "Shirpora Bangil B.O": "193121",
      "Tapper Waripora B.O": "193121",
      "Nadihal B.O": "193301",
      "CHANDOOSA B.O": "193109",
      "Gohan B.O": "193101",
      "Behrampora B.O": "193303",
      "Harduchanam B.O": "193303",
      "Kanispora B.O": "193103",
      "Gingle B.O": "193122",
      "Lachipora B.O": "193122",
      "Salamabad Dachina B.O": "193122",
      "Goshbugh B.O": "193121",
      "Gund Ibrahim B.O": "193121",
      "Lalpora Bangil B.O": "193121",
      "Mirgund B.O": "193121",
      "Palhallan B.O": "193121",
      "Singhpora B.O": "193121",
      "Yal B.O": "193121",
      "Panzala B.O": "193301",
      "Laridora B.O": "193101",
      "Ushkura B.O": "193101",
      "Gantmulla B.O": "193101",
      "Khaipora BO": "193402",
      "Kachawa Muqam B.O": "193109",
      "Kalantra B.O": "193109",
      "Sheeri B.O": "193101",
      "M.E.T B.O": "193201",
      "Chatoosa B.O": "193303",
      "Delina B.O": "193103",
      "Athoora B.O": "193108",
      "Dhanisaidan B.O": "193122",
      "Ijara B.O": "193122",
      "Trikanjan B.O": "193122",
      "Hanjiwera B.O": "193121",
      "Matipora B.O": "193121",
      "Chitloora B.O": "193301",
      "Heavan B.O": "193101",
      "Khadniyar B.O": "193101",
      "Malpora B.O": "193101",
      "Khanpora B.O": "193101",
      "Women College B.O": "193101",
      "MOHARA B.O": "193122",
      "Watergam B.O": "193303",
      "Zethan B.O": "193303",
      "Nowshera B.O": "193122",
      "Pringal B.O": "193122",
      "Andergam B.O": "193121",
      "Check Sariwarpora B.O": "193121",
      "Khanpeth B.O": "193121",
      "Khore B.O": "193121",
      "Mamoosa B.O": "193121",
      "Balhama B.O": "193301",
      "Binner B.O": "193301",
      "Chijhama B.O": "193301",
      "Hadipora B.O": "193301",
      "Khamoh B.O": "193301",
      "Ferozpora BO": "193402",
      "Hajibal BO": "193402",
      "Hariwatnoo BO": "193402",
      "Babareshi BO": "193402",
      "Hardichhloo BO": "193402",
      "Chandil Wanigam BO": "193404",
      "Chandilora BO": "193402",
      "Devpora Dardpora BO": "193404",
      "Kawarhama BO": "193404",
      "Tarahama BO": "193404",
      "Wailoo Kralpora BO": "193404",
      "Hardobora BO": "193404",
      "Devbough BO": "193404",
      "Mulgam BO": "193404",
      "Hardushora BO": "193404",
      "Beewah BO": "193404",
      "Dhobiwan BO": "193404",
      "Baramulla H.O": "193101",
      "Uri S.O": "193123",
      "Khawaja Bagh S.O": "193103",
      "Kreeri S.O": "193108",
      "Boniyar S.O": "193122",
      "Pattan S.O": "193121",
      "Rohama S.O": "193301",
      "Sopore S.O": "193201",
      "WAGOORA S.O": "193109",
      "Tangmarg SO": "193402",
      "Kunzer SO": "193404",
      "Gulmarg SO": "193403",
      "Dangiwacha S.O": "193303"
    },
    "SAMBA": {
      "Birpur BO": "181133",
      "Sarore BO": "181133",
      "Rajinderpura BO": "181143",
      "CENTRAL UNIVERSITY BO": "181143",
      "Khara Madana BO": "181145",
      "Dhiani BO": "184121",
      "Goran BO": "184121",
      "JNV Nud BO": "184121",
      "Sumb BO": "184121",
      "Taloor BO": "184121",
      "Guo Brahmna BO": "184120",
      "Jakh BO": "184120",
      "Koulpur BO": "184120",
      "Raika BO": "184120",
      "Smailpur BO": "181133",
      "Tarore BO": "181133",
      "Mandal BO": "181145",
      "Rahya BO": "181143",
      "Abtal BO": "181141",
      "Kesomanhasan BO": "181141",
      "Kalibari BO": "184121",
      "Mawa BO": "184121",
      "Pangdour BO": "184121",
      "Sarna BO": "184121",
      "Swankha BO": "184120",
      "Utter Behni BO": "181145",
      "Mandi Sangwali BO": "184121",
      "Nanak Chak BO": "184121",
      "Chak Salaria BO": "184120",
      "Sanjwan BO": "184120",
      "Jatwal BO": "184141",
      "Nandpur BO": "181141",
      "Nanga BO": "181141",
      "Nai Kali BO": "184121",
      "Rehiyan BO": "184121",
      "Bari Brahmna Icomplex SO": "181133",
      "Bari Brahmna SO": "181133",
      "Vijaypur SO": "184120",
      "Ghagwal SO": "184141",
      "Samba SO": "184121",
      "Ramgarh SO Jammu": "181141",
      "Samba Adda SO": "184121",
      "Purmandal SO": "181145"
    },
    "JAMMU": {
      "Darap BO": "181132",
      "Deoli BO": "181132",
      "Palli BO": "181132",
      "Gadigarh BO": "181101",
      "Chandu Chak BO": "181102",
      "Chohala BO": "181102",
      "Faloura BO": "181102",
      "Gharana BO": "181102",
      "Rangpur Malania BO": "181102",
      "Chowadi BO": "180011",
      "Bamal Colony BO": "181201",
      "Brui BO": "181201",
      "Gandharwan BO": "181201",
      "Gharatal BO": "181201",
      "Kanheri BO": "185154",
      "Sai Kalan BO": "181131",
      "Banachak BO": "181132",
      "Kanhal BO": "181132",
      "Kotli Mian Fateh BO": "181132",
      "Kalu Chak BO": "180010",
      "Bhour Camp BO": "181101",
      "Parlah BO": "181131",
      "Rangpur Trewa BO": "181131",
      "Talhar BO": "181131",
      "Chak Umrah BO": "181132",
      "Kheri BO": "181132",
      "Goondla BO": "181111",
      "Makwal BO": "180003",
      "Rattisn BO": "181101",
      "Simble Camp BO": "181101",
      "Badyal Brahmna BO": "181102",
      "Kotlishah Daula BO": "181102",
      "Shamka BO": "181102",
      "Ambaran BO": "181201",
      "Kaink Jagir BO": "181201",
      "Raipur BO": "181123",
      "Baran BO": "181122",
      "Jandial BO": "181122",
      "Ranjan BO": "181122",
      "Seri Panditan BO": "181122",
      "Dhana Dhanean BO": "185154",
      "Doori Dugar BO": "185154",
      "Jindrah BO": "181224",
      "Agra Chak BO": "181102",
      "Chakrohi BO": "181102",
      "Jassore BO": "181102",
      "Satrayan BO": "181102",
      "Suchetgarh BO": "181102",
      "Chak Chimna BO": "181141",
      "Sunjwan BO": "180011",
      "Bala BO": "181201",
      "Gurha Brahmna BO": "181201",
      "Kathar BO": "181201",
      "Pangyari BO": "181201",
      "Ghar Majoor BO": "185154",
      "Bhatyari BO": "181224",
      "Kanyala BO": "181224",
      "Kishanpur BO": "181224",
      "Adlehar BO": "181131",
      "Allah BO": "181131",
      "Kalyana BO": "181131",
      "Kool Kalan BO": "181131",
      "Pindicharka Kalan BO": "181131",
      "Pandorian Manhasan BO": "181132",
      "Rehal BO": "181132",
      "Magowali BO": "181111",
      "Rathana BO": "181111",
      "Salehar BO": "181111",
      "Mandal BO": "180003",
      "Sohanjana BO": "180003",
      "Khour Devian BO": "181101",
      "Kirpind BO": "181101",
      "Langotian BO": "181101",
      "Lehar BO": "181201",
      "Mandarian BO": "181201",
      "Mawa Brahmna BO": "181201",
      "Sungal BO": "181201",
      "Gharota BO": "181122",
      "Kot BO": "181122",
      "Rabta BO": "181122",
      "Sarote BO": "181122",
      "Badsu BO": "181224",
      "Batehra BO": "181206",
      "Gajansoo BO": "181206",
      "Misriwala BO": "181206",
      "Nagbani BO": "181206",
      "Paryal BO": "181206",
      "Bakore BO": "181202",
      "Dhoke Khalsa BO": "181202",
      "Maira BO": "181202",
      "JKotli BO": "181221",
      "Jagti BO": "181221",
      "Kaleeth BO": "181203",
      "Naryana BO": "181203",
      "Nathal BO": "181203",
      "Sainth BO": "181203",
      "AGOffice BO": "181121",
      "Topsherkhania BO": "181121",
      "Gura Manhasan BO": "181207",
      "Bhadrod BO": "180002",
      "Sangrampur BO": "180002",
      "Govind Nagar BO": "180002",
      "Kothar BO": "181224",
      "Kanachak BO": "181206",
      "Chak Kirpalpur BO": "181202",
      "Datial BO": "181202",
      "Panjgrain BO": "181221",
      "Gigrial BO": "181203",
      "Aitham BO": "180017",
      "Kana Chirgal BO": "180017",
      "Kot Maira BO": "181204",
      "Gho Manhasan BO": "180002",
      "Tahra BO": "181224",
      "Halqa BO": "181206",
      "Kangrial BO": "181206",
      "Karloop BO": "181206",
      "Nadore BO": "181221",
      "Chak Malal BO": "181203",
      "Danwal BO": "181203",
      "Surinsar BO": "180017",
      "Chak Shama BO": "181206",
      "Garkhal BO": "181206",
      "Bhalwal Brahmna BO": "181202",
      "Devipur BO": "181202",
      "Shiba BO": "181221",
      "Hamirpur Sidhar BO": "181203",
      "Kharah BO": "181203",
      "Nikkian BO": "181203",
      "Bain Bajalta BO": "180017",
      "Bardoh BO": "181204",
      "Akalpur BO": "180002",
      "Gol Gujral BO": "180002",
      "Jammu HO": "180001",
      "Gandhinagar HO": "180004",
      "Bathindi SO": "181152",
      "Chani Himat SO": "180015",
      "Dablehar SO": "181111",
      "Jammu Cantt SO": "180003",
      "NATC SO": "180003",
      "RSPura Adda SO": "181102",
      "RSPura SO": "181102",
      "SKUASTCHATHA SO": "180009",
      "TRIKUTA NAGAR": "180020",
      "Jammu Market SO": "180001",
      "Majeen SO": "180017",
      "New Secretariat Jammu SO": "180001",
      "Pacca Danga Akhnoor SO": "181201",
      "Pargwal SO": "181207",
      "Shaktinagar Jammu SO": "180001",
      "Talab Tillo SO": "180002",
      "Udheywala SO": "180018",
      "Nagrota Gujroo SO": "180012",
      "Gurah Salathia SO": "181143",
      "Guru Nanak Nagar SO Jammu": "180004",
      "New University Campus SO": "180006",
      "Bantalab SO": "181123",
      "Chowki Choura SO": "185154",
      "Dumana SO": "181206",
      "Jourian SO": "181202",
      "Kandoli Nagrota SO": "181221",
      "Karan Nagar SO Jammu": "180005",
      "Khour SO": "181203",
      "Kotli Colony SO": "180005",
      "Peermitha SO": "180001",
      "RNBazar SO": "180001",
      "Bishnah Adda SO": "181132",
      "Gangyal SO": "180010",
      "Miran Sahib SO": "181101",
      "New Fruit Market SO": "180012",
      "Qilla Bahu SO": "180006",
      "Railway Station SO": "180012",
      "Sainik Colony SO": "180011",
      "Meghdoot Bhawan": "180012",
      "Bsf Camp Paloura SO": "181124",
      "Janipur High Court SO": "180007",
      "Muthi SO": "181205",
      "OHRoad SO": "180001",
      "Paloura SO": "181121",
      "Roopnagar Jammu Tawi SO": "180013",
      "Mubarak Mandi SO": "180001",
      "Subash Nagar Jammu SO": "180005",
      "Vinaik Bazar SO": "180016",
      "Sidhra Housing colony": "180019",
      "Arnia SO": "181131",
      "Bishnah SO": "181132",
      "Greater Kailash SO": "180011",
      "Industrial Estate SO Jammu": "180003",
      "Akhnoor SO": "181201",
      "Bakshinagar SO": "180001",
      "Bhalwal SO": "181122",
      "Dansal SO": "181224",
      "Janipur SO": "180007",
      "Krishna Nagar SO Jammu": "180016",
      "Pallanwala SO": "181204",
      "Puran Nagar SO": "180005",
      "Rehari Mohalla SO": "180005",
      "Jagti Migrant Township S.O": "181221"
    },
    "BANDIPORA": {
      "Sadarkoot Bala B.O": "193504",
      "Sadunara B.O": "193504",
      "Gund Jahangir B.O": "193501",
      "Hajin B.O": "193501",
      "Madwan B.O": "193501",
      "Chiva B.O": "193504",
      "Asham B.O": "193504",
      "Amchikundal B.O": "193501",
      "Naidkhai B.O": "193501",
      "Nowgam B.O": "193501",
      "Shadipora B.O": "193501",
      "Nesbal B.O": "193501",
      "Shahgund B.O": "193501",
      "Hakbara B.O": "193504",
      "Chutimulla B.O": "193502",
      "Kaloosa B.O": "193502",
      "KENUSA  B.O": "193505",
      "Lawaypora B.O": "193502",
      "Sonerwani B.O": "193502",
      "Barnoi Kashpeth B.O": "193503",
      "Kanzalwan B.O": "193503",
      "Markoot B.O": "193503",
      "Puranatulail B.O": "193503",
      "Bandipora Chowk B.O": "193502",
      "Chithi Bandi B.O": "193502",
      "Garoora B.O": "193502",
      "Mantrigam B.O": "193502",
      "Onagam B.O": "193502",
      "Watapora B.O": "193505",
      "Bagtore B.O": "193503",
      "Gujran B.O": "193503",
      "Tarbal B.O": "193503",
      "Ayatmulla B.O": "193502",
      "Bankote B.O": "193502",
      "Gamroo B.O": "193502",
      "Malangam B.O": "193505",
      "Nadihal B.O": "193502",
      "Quilmuqam B.O": "193505",
      "Achoora B.O": "193503",
      "Badugam B.O": "193503",
      "Wampora B.O": "193503",
      "Ganasthan B.O": "193121",
      "Ajas B.O": "193502",
      "Arin B.O": "193502",
      "Ashtingoo B.O": "193505",
      "Baduab B.O": "193503",
      "Saradab B.O": "193503",
      "Bandipora S.O": "193502",
      "Aloosa S.O": "193505",
      "Sonawari S.O": "193501",
      "Gurez S.O": "193503"
    },
    "KUPWARA": {
      "Chandigam B.O": "193223",
      "Chamkote B.O": "193225",
      "Hajitarah B.O": "193225",
      "Aloosa B.O": "193224",
      "Budnambal B.O": "193224",
      "Chowkibal Reddy B.O": "193224",
      "Gazriyal B.O": "193224",
      "Kralpora B.O": "193224",
      "Manzgam B.O": "193224",
      "Meelyal B.O": "193224",
      "Owoora B.O": "193224",
      "Cheerkoot B.O": "193223",
      "Dever Inderbugh B.O": "193223",
      "Dardpora B.O": "193223",
      "Gogal B.O": "193223",
      "Nowgabra B.O": "193225",
      "Teetwal B.O": "193225",
      "Gugloosa B.O": "193224",
      "Kachhama B.O": "193224",
      "Panzgam B.O": "193224",
      "Vernow B.O": "193223",
      "Nachian B.O": "193225",
      "Tad B.O": "193225",
      "Hayan B.O": "193224",
      "Kakroosa B.O": "193224",
      "Tarathpora B.O": "193224",
      "Warsun B.O": "193224",
      "Krusan B.O": "193223",
      "Kuligam B.O": "193223",
      "Lalpora B.O": "193223",
      "Maidanpora B.O": "193223",
      "Putushy B.O": "193223",
      "Tekipora B.O": "193223",
      "Keran B.O": "193224",
      "Villgam B.O": "193224",
      "Zurhama B.O": "193224",
      "WAVOORA B.O": "193223",
      "Ashpora B.O": "193303",
      "Zachaldara B.O": "193221",
      "Batergam B.O": "193222",
      "Haihama B.O": "193222",
      "Halmatpora B.O": "193222",
      "Kalamchakla B.O": "193302",
      "Kralgund B.O": "193302",
      "Nowgam B.O": "193302",
      "Pohrupeth B.O": "193302",
      "Turkapora B.O": "193221",
      "Wadipora B.O": "193221",
      "Wagat B.O": "193221",
      "Batpora B.O": "193222",
      "Gulgam B.O": "193222",
      "Karihama B.O": "193222",
      "Nagrimalpora B.O": "193222",
      "Batagund B.O": "193302",
      "Gloora B.O": "193302",
      "Shatgund B.O": "193302",
      "Yunis Wahipora B.O": "193302",
      "Rengpeth B.O": "193303",
      "Maidan Chogal B.O": "193221",
      "Shilhal B.O": "193221",
      "Wadder Nichama B.O": "193221",
      "Drugmulla B.O": "193222",
      "Dudi Machil B.O": "193222",
      "Khumriyal B.O": "193222",
      "Pazipora B.O": "193222",
      "Haril B.O": "193302",
      "Sahipora B.O": "193302",
      "Yaroo B.O": "193302",
      "Kandi Khaas B.O": "193221",
      "Magam B.O": "193221",
      "Natnusa B.O": "193221",
      "Satkuji B.O": "193221",
      "Jaggerpora B.O": "193222",
      "Kalaroose B.O": "193222",
      "Sarkuli B.O": "193222",
      "Tangdhar S.O": "193225",
      "TREHGAM S.O": "193224",
      "Kupwara S.O": "193222",
      "Sogam S.O": "193223",
      "Handwara S.O": "193221",
      "Langate S.O": "193302"
    },
    "GANDERBAL": {
      "Batvina B.O": "193501",
      "Manigam BO": "191201",
      "Mamer BO": "191202",
      "S Bala BO": "191202",
      "Wangat BO": "191202",
      "Qasbalar BO": "191131",
      "Sehpora BO": "191131",
      "Shallabugh BO": "191131",
      "Theru BO": "191131",
      "Benihama BO": "191201",
      "Chattergul BO": "191201",
      "Akhal BO": "191202",
      "Hari Gaiwan BO": "191202",
      "Kulan BO": "191202",
      "Karhama BO": "191131",
      "Saloora BO": "191131",
      "Wakura BO": "191131",
      "Nuner BO": "191201",
      "Gund BO": "191202",
      "Haran BO": "191131",
      "Daderhama BO": "191201",
      "Haripora BO": "191201",
      "Wayil BO": "191201",
      "Wussan BO": "191201",
      "Yangoora BO": "191131",
      "Kangan SO": "191202",
      "Safapora S.O": "193504",
      "Ganderbal": "191201",
      "Tulmulla SO": "191131"
    },
    "SRINAGAR": {
      "Panzinara B.O": "193501",
      "Harwan BO": "191121",
      "Gulab Bagh BO": "190006",
      "Malbagh BO": "190006",
      "Saidpora Hamchi BO": "190006",
      "New Theed BO": "191121",
      "KPadshai Bagh BO": "190008",
      "Basurbagh BO": "190006",
      "Chatterhama BO": "190006",
      "Shuhama BO": "190006",
      "Telbal BO": "190006",
      "Anchar BO": "190011",
      "Pandrathan BO": "191101",
      "Zawan BO": "191101",
      "Bashipora BO": "190017",
      "Paipora BO": "190017",
      "Gund Hassibhat BO": "190017",
      "Nandpora BO": "190003",
      "Pandech BO": "190006",
      "Lasjan BO": "191101",
      "Abi Karlpora BO": "190003",
      "Balhama BO": "191101",
      "Khanmouh BO": "191101",
      "Srinagar GPO": "190001",
      "Badyar Balla SO": "190001",
      "Bemina SO": "190018",
      "Court Road": "190010",
      "Fateh Kadal SO": "190002",
      "Kashmir University": "190006",
      "Lal Chowk SO": "190001",
      "Noushara SO": "190011",
      "Parimpora SO": "190017",
      "Rainawari SO": "190003",
      "Sathu SO": "190001",
      "Batmaloo": "190010",
      "Khanyar SO": "190003",
      "Rambagh SO Srinagar": "190009",
      "Sanat Nagar SO": "190005",
      "Batwara SO": "190004",
      "Jamia Masjid SO": "190002",
      "Lal Bazar SO": "190023",
      "Nehru Park SO": "190001",
      "Nowgam SO": "190015",
      "Pantha Chowk SO": "191101",
      "Rajbagh SO": "190008",
      "SKSectrate SO": "190001",
      "SR Gunj SO": "190002",
      "Safukadul SO": "190002",
      "Zainakote SO": "190012",
      "Bachpora SO": "190020",
      "Bagh Mehtab SO": "190019",
      "Brein": "191121",
      "Central Market SO": "190009",
      "Jawahar Nagar": "190008",
      "Karan Nagar SO Srinagar": "190010",
      "Natipora SO": "190015",
      "New Secretariat Srinagar SO": "190009",
      "Skuast SO": "190025",
      "Zakoora": "190024"
    },
    "KATHUA": {
      "Seswan BO": "184144",
      "Gurah Mundian BO": "184142",
      "Sherpur BO": "184142",
      "Dilwan BO": "184102",
      "Jarai BO": "184102",
      "Basantpur BO": "184152",
      "Karroh BO": "184152",
      "Marapatti BO": "184202",
      "Changran BO": "184104",
      "Airwan BO": "184151",
      "Kotpunnu BO": "184151",
      "Chiliari BO": "184145",
      "Kahna Chack BO": "184148",
      "Marheen BO": "184148",
      "UCHAPIND BO": "180012",
      "Katli BO": "184144",
      "Sanoora BO": "184141",
      "Surara BO": "184141",
      "Kharote BO": "184102",
      "Krishnanagar BO": "184102",
      "Mehtabpur BO": "184102",
      "Parliwand BO": "184102",
      "Banhore BO": "184202",
      "Dhar Mahanpur BO": "184202",
      "Mooni BO": "184202",
      "Sabar BO": "184202",
      "Janglote BO": "184104",
      "Kothera BO": "184104",
      "Saidpur BO": "184151",
      "SAILNA BO": "180012",
      "GURAH KALYAL BO": "180012",
      "Daggar BO": "184206",
      "Duggan BO": "184206",
      "Dulangal BO": "184206",
      "Flote BO": "184143",
      "Ghatti BO": "184143",
      "Jandrota BO": "184201",
      "Plahi BO": "184201",
      "Plassy BO": "184201",
      "Baggan BO": "184204",
      "Dhar Dugnoo BO": "184204",
      "Huttar BO": "184204",
      "KishanpurI BO": "184204",
      "Dinga Amb BO": "184144",
      "Hamirpur BO": "184144",
      "Gitti BO": "184206",
      "Lowang BO": "184206",
      "Sitti BO": "184206",
      "Barnote BO": "184143",
      "Budhi BO": "184143",
      "Jasrota BO": "184143",
      "Rajbagh BO": "184143",
      "Bhoond BO": "184201",
      "Farnot BO": "184201",
      "Rehan BO": "184201",
      "Sandhar BO": "184201",
      "Maghloor BO": "184144",
      "Mela BO": "184144",
      "Prangoli BO": "184144",
      "Raikoota BO": "184141",
      "Garha Satura BO": "184142",
      "Kirian Gandial BO": "184152",
      "Mah BO": "184152",
      "Thein BO": "184152",
      "Tridwan BO": "184152",
      "Raipur BO": "184202",
      "Logate BO": "184104",
      "Rakh Lachhipura BO": "184104",
      "Babia BO": "184148",
      "Chakra BO": "184148",
      "Haripur Patil BO": "184148",
      "Naran BO": "184141",
      "Said BO": "184141",
      "Jandi BO": "184142",
      "Govindasr BO": "184102",
      "Hatli BO": "184152",
      "Karanwara BO": "184202",
      "Jakhbar BO": "184104",
      "Khokhial BO": "184151",
      "Galak BO": "184205",
      "Mukwal Chinji BO": "184205",
      "Khanpur BO": "184148",
      "LAKHRI BO": "180012",
      "Fatehpur BO": "184206",
      "Banjal BO": "184201",
      "Draman BO": "184201",
      "Poonda BO": "184201",
      "Sananghat BO": "184201",
      "KishanpurII BO": "184203",
      "Kohag BO": "184203",
      "Lahari BO": "184203",
      "Marhoon BO": "184204",
      "Thall BO": "184204",
      "Amla BO": "184144",
      "Dhamal BO": "184144",
      "Bandhar BO": "184206",
      "Chalog BO": "184206",
      "Kanthal BO": "184206",
      "Roulka BO": "184206",
      "Beradhani BO": "184143",
      "Palli BO": "184143",
      "Hutt BO": "184201",
      "Marta Nagrota BO": "184201",
      "Barotta BO": "184203",
      "Dharalta BO": "184203",
      "Phinter BO": "184203",
      "Badnota BO": "184204",
      "Machhedi BO": "184204",
      "Malti BO": "184204",
      "Chann Rorian BO": "184144",
      "Bathodi Duggan BO": "184203",
      "Durang": "184203",
      "Mandli BO": "184203",
      "Parnala BO": "184203",
      "Malhar BO": "184204",
      "Sukrala BO": "184204",
      "Chadwal BO": "184144",
      "Chandwan BO": "184144",
      "Chhapaki Kalan BO": "184144",
      "Kathua HO": "184101",
      "Billawar SO": "184204",
      "Mahanpur SO": "184202",
      "Bani SO Kathua": "184206",
      "Barwal SO": "184143",
      "Bhaddu SO": "184203",
      "Ie Kathua SO": "184102",
      "Sanjimore SO": "184148",
      "Lakhanpur SO Kathua": "184152",
      "Mini Sectt Kathua SO": "184104",
      "Parole SO": "184151",
      "Rajpura SO Kathua": "184145",
      "Ramkot SO Kathua": "184205",
      "Basoli SO": "184201",
      "Dialachak SO": "184144",
      "Hiranagar SO": "184142"
    },
    "Budgam": {
      "Chanthan Checkpora BO": "193411",
      "Chewdarah BO": "193411",
      "Khag BO": "193411",
      "Zugu Khyran BO": "193411",
      "Arigam BO": "191111",
      "Bandgam BO": "191111",
      "Gariend BO": "191111",
      "Ichgam BO": "191111",
      "Shogapora BO": "191111",
      "Sholipora BO": "191111",
      "Soibugh BO": "191111",
      "Watterhail BO": "191111",
      "R N Hall BO": "191113",
      "Sogam B.O": "191113",
      "Suraryan BO": "191113",
      "Watakala BO": "191113",
      "Narbal BO": "193401",
      "Ratsun BO": "193401",
      "Peth Kanihama BO": "193401",
      "A K Pora B.O": "190015",
      "Kralpora BO": "190019",
      "Dachan BO": "193411",
      "H Panzu BO": "193411",
      "Kandoora BO": "193411",
      "Bemina Chowk BO": "190018",
      "Kachwari BO": "191111",
      "Krim Shore BO": "191111",
      "Ompora BO": "191111",
      "Bandipora B.O": "191113",
      "Brinjan BO": "191113",
      "Gogjipathri BO": "191113",
      "Rangar BO": "191113",
      "Wanpora BO": "191113",
      "Wathura BO": "191113",
      "Darwan Nawgam BO": "191112",
      "Badran BO": "193401",
      "Kanihama BO": "193401",
      "Peth Makhama BO": "193401",
      "Khanda BO": "192121",
      "Iskanderpora BO": "193411",
      "Poshkar BO": "193411",
      "Qumroo BO": "193411",
      "Attina BO": "193411",
      "Arath BO": "191111",
      "Jawalapora BO": "191111",
      "Khan Shaib BO": "191111",
      "Later Chadoora BO": "191111",
      "Raithan BO": "191111",
      "Bogam Batapora BO": "191113",
      "Chattergam BO": "191113",
      "Hardudalwan BO": "191112",
      "Kenidajan BO": "191112",
      "Malmoh BO": "193401",
      "Lalpora BO": "193411",
      "Otligam BO": "193411",
      "Raiyar BO": "193411",
      "Sail BO": "193411",
      "Shonglipora BO": "193411",
      "Sebdan BO": "190018",
      "Hanjura BO": "191113",
      "Hayatpora BO": "191113",
      "Lalgam BO": "191113",
      "Nagam BO": "191113",
      "Kanir BO": "191113",
      "Pakherpora BO": "191112",
      "Aripanthan BO": "193401",
      "S K Pora BO": "193401",
      "Gund Khaja Kasim BO": "193401",
      "Kawoosa Khalisa BO": "193401",
      "Kenihama BO": "190015",
      "Kralweth BO": "193404",
      "Beerwah SO": "193411",
      "Hyderpora SO": "190014",
      "Chadoora SO": "191113",
      "Hamhama SO": "190021",
      "Magam SO": "193401",
      "Rangreth SO": "191132",
      "Sk Airport SO": "190007",
      "Budgam SO": "191111",
      "Charsharief SO": "191112"
    }
  },
  "MEGHALAYA": {
    "RI BHOI": {
      "Pillangkata B.O": "781029",
      "Patharkhmah B.O": "781131",
      "Warmawsaw B.O": "781131",
      "Umlapher B.O": "782410",
      "Jirang B.O": "781131",
      "Hatumling B.O": "793102",
      "Nongladew B.O": "793102",
      "Umdihar B.O": "793102",
      "Umrit B.O": "793102",
      "Mawbri B.O": "793116",
      "Rongmen B.O": "793103",
      "Umroi B.O": "793103",
      "Umsawnongbri B.O": "793102",
      "Umshakhon Mathon B.O": "793102",
      "Barua Basti B.O": "793104",
      "Mawlein Mawkhan B.O": "793104",
      "Kyrdem Kulai B.O": "793105",
      "Mawhati B.O": "793105",
      "Mawrong B.O": "793105",
      "Sanidon B.O": "793105",
      "Kynjoin Umran B.O": "793102",
      "Niangbari B.O": "793102",
      "Saiden B.O": "793102",
      "Umden B.O": "793102",
      "Mawlasnai B.O": "793116",
      "Umktieh B.O": "793103",
      "Kyrdem B.O": "793103",
      "Lailad B.O": "793102",
      "Marmain B.O": "793102",
      "Marngar B.O": "793102",
      "Mawlong B.O": "793102",
      "Umran B.O": "793105",
      "Umsohlait B.O": "793105",
      "Epip Byrnihat B.O": "793101",
      "Jorabat B.O": "793101",
      "Tamul Kuchi Gaon B.O": "793101",
      "Killing Centre B.O": "793101",
      "Byrnihat S.O": "793101",
      "Sumer S.O": "793104",
      "Ucc S.O": "793122",
      "Umiam S.O": "793103",
      "Bhoirymbong S.O": "793116",
      "Umsaw S.O": "793123",
      "Nongpoh S.O": "793102",
      "Umsning S.O": "793105"
    },
    "EAST KHASI HILLS": {
      "Tynrong B.O": "793108",
      "Pongtung B.O": "793110",
      "Puriang B.O": "793021",
      "Lyngiong B.O": "793121",
      "Marbisu B.O": "793121",
      "Mawkriah B.O": "793121",
      "Mawpun B.O": "793115",
      "Laitkynsew B.O": "793108",
      "Mawblang B.O": "793108",
      "Tyrna B.O": "793108",
      "Lad Mawphlang B.O": "793108",
      "Nongtyngur B.O": "793110",
      "Lawsohtun B.O": "793004",
      "Kynton   U   Mon B.O": "793021",
      "Pamora B.O": "793021",
      "Mahadeo B.O": "793108",
      "Wahlong B.O": "793108",
      "Pamshutia B.O": "793110",
      "Wahkdait B.O": "793110",
      "Bishnupur B.O": "793004",
      "Khlieh Lyngkhoi B.O": "793115",
      "Phlang Mawsyrpat B.O": "793113",
      "Phlangwanbroi B.O": "793113",
      "Rynkubazar B.O": "793113",
      "Syntein B.O": "793113",
      "Tynring B.O": "793018",
      "Madan Bitaw B.O": "793115",
      "Mawngap B.O": "793121",
      "Mawreng B.O": "793121",
      "Pongkung B.O": "793121",
      "Weiloi B.O": "793121",
      "Lawbah B.O": "793113",
      "Mawhiang B.O": "793113",
      "Thyllaw B.O": "793113",
      "Mawtawar B.O": "793022",
      "Mawklot B.O": "793009",
      "Mawtiehbah B.O": "793121",
      "Mawdongbazar B.O": "793113",
      "Tynger B.O": "793113",
      "Kynton Massar B.O": "793022",
      "Mylliem Syllai U Lar B.O": "793009",
      "Diengpasoh B.O": "793012",
      "Lyngkhoi B.O": "793120",
      "Nongspung B.O": "793121",
      "Sohpian B.O": "793121",
      "Nongumlong B.O": "793005",
      "Mawlong B.O": "793015",
      "Mawmluh B.O": "793108",
      "Sohbarpunjee B.O": "793108",
      "Sohkmie B.O": "793108",
      "Lyngkhat B.O": "793110",
      "Laitkor B.O": "793010",
      "Pomlakrai B.O": "793010",
      "Mawryngkneng B.O": "793021",
      "Mawkhanu B.O": "793018",
      "Rangshken B.O": "793121",
      "Tyrsad B.O": "793121",
      "Diengiei B.O": "793005",
      "Mawroh B.O": "793008",
      "Laitlyngkot B.O": "793110",
      "Umkdait B.O": "793006",
      "Ichamati B.O": "793112",
      "Kalatak B.O": "793112",
      "Mawkynrew B.O": "793015",
      "Mawlat B.O": "793015",
      "Mawlyngngad B.O": "793021",
      "Iewmawiong B.O": "793110",
      "Langkyrdem B.O": "793110",
      "Disong B.O": "793112",
      "Jongksha B.O": "793015",
      "Lynshing B.O": "793015",
      "Nongkrem B.O": "793015",
      "Thangsning B.O": "793015",
      "Mawbeh B.O": "793110",
      "Nongjri B.O": "793110",
      "Nongkynrih B.O": "793110",
      "Wahshiarkhmut B.O": "793110",
      "Dalia B.O": "793112",
      "Kharang B.O": "793015",
      "Ryngibah B.O": "793015",
      "Sohryngkham B.O": "793021",
      "Thynroit B.O": "793015",
      "Krang B.O": "793115",
      "Myllat B.O": "793110",
      "Umniuh   Tmar B.O": "793110",
      "Umphyrnai B.O": "793015",
      "Umsning B.O": "793015",
      "Dholai B.O": "793106",
      "Sonatola B.O": "793106",
      "Telsora B.O": "793106",
      "Mawkdok B.O": "793108",
      "Pyndeng Sohsaw B.O": "793106",
      "Laitduh B.O": "793108",
      "Ladmawphlang B.O": "793111",
      "Borsora B.O": "793106",
      "Makali B.O": "793106",
      "Laitryngew B.O": "793108",
      "Ramdait B.O": "793108",
      "Shillong G.P.O.": "793001",
      "Bholaganj Bazar S.O": "793107",
      "Cherrabazar S.O": "793111",
      "Cherrapunjee S.O": "793108",
      "Assam Rifles S.O": "793011",
      "Mawphlang S.O": "793121",
      "Nongmynsong S.O": "793019",
      "Nongthymmai S.O": "793014",
      "Phudmawri S.O": "793008",
      "Iewduh S.O": "793002",
      "Jaiaw S.O": "793002",
      "Laitkor Peak S.O": "793010",
      "Mawiong S.O": "793016",
      "Meghalaya Secretariat S.O": "793001",
      "Nehu S.O": "793022",
      "Rilbong S.O": "793004",
      "Upper Shillong S.O": "793005",
      "Laban S.O": "793004",
      "Laitumkhrah S.O": "793003",
      "Neigrihms S.O": "793018",
      "Nonglyer S.O": "793009",
      "Oakland S.O": "793001",
      "Pynursla S.O": "793110",
      "Smit S.O": "793015",
      "Sohiong S.O": "793115",
      "Happy Valley S.O": "793007",
      "Madanriting S.O": "793021",
      "Mawlai S.O": "793017",
      "Mawpat S.O": "793012",
      "Mawsynram S.O": "793113",
      "Rynjah S.O": "793006",
      "Shella S.O": "793112"
    },
    "WEST JAINTIA HILLS": {
      "Passadwar B.O": "793109",
      "Rongkhum B.O": "793109",
      "Sohkha B.O": "793109",
      "Kyndong Tuber B.O": "793150",
      "Mawkaiaw B.O": "793150",
      "Mawkyndeng B.O": "793150",
      "Trangblang B.O": "793161",
      "Yalang B.O": "793150",
      "Nongbareh B.O": "793161",
      "Padu B.O": "793161",
      "Umsyiem B.O": "793109",
      "Iawthymmai B.O": "793150",
      "Mustem B.O": "793150",
      "Pdengshakap B.O": "793161",
      "Shangpung B.O": "793150",
      "Yooksi B.O": "793150",
      "Amlari B.O": "793161",
      "Naljuri B.O": "793109",
      "Nongtalang B.O": "793109",
      "Barato B.O": "793150",
      "Jarain B.O": "793161",
      "Laskein B.O": "793150",
      "Mihmyntdu B.O": "793150",
      "Mupyut B.O": "793150",
      "Mynso B.O": "793150",
      "Raliang B.O": "793150",
      "Sahsniang B.O": "793150",
      "Thadmuthlong B.O": "793150",
      "Thangrain B.O": "793150",
      "Mawbakhon B.O": "793151",
      "Mookynniang B.O": "793151",
      "Namdong B.O": "793151",
      "Nongjngi B.O": "793151",
      "Saitsama B.O": "793151",
      "Mynsngad B.O": "793151",
      "Khanduli B.O": "793151",
      "Mawdymmai B.O": "793151",
      "Nartiang B.O": "793151",
      "Thangbuli B.O": "793161",
      "Darrang B.O": "793109",
      "Lamin B.O": "793109",
      "Muktapur B.O": "793109",
      "Syndai B.O": "793109",
      "Nongbah B.O": "793119",
      "Nongryngkoh B.O": "793150",
      "Sohmynting B.O": "793150",
      "Umladang B.O": "793151",
      "Ummulong B.O": "793151",
      "Wahiajer B.O": "793151",
      "Dawki S.O": "793109",
      "Jowai S.O": "793150",
      "Thadlaskein S.O": "793151",
      "Amlarem S.O": "793161"
    },
    "EAST JAINTIA HILLS": {
      "Huroi B.O": "793210",
      "Pala B.O": "793200",
      "Rata Cherra B.O": "793210",
      "Saipung B.O": "793200",
      "Sheruphie B.O": "793200",
      "Ratacherra B.O": "793210",
      "Sonapur B.O": "793210",
      "Khatdum B.O": "793210",
      "Mualsei B.O": "793200",
      "Umkiang B.O": "793210",
      "Bataw B.O": "793160",
      "Sohkymphor B.O": "793160",
      "Wapung B.O": "793160",
      "Chiruphi B.O": "793210",
      "Myndihati B.O": "793200",
      "Sutnga B.O": "793200",
      "Tuber Kmaishnong B.O": "793160",
      "Shnongrim B.O": "793200",
      "Mukhialong B.O": "793160",
      "Musniang B.O": "793160",
      "Rymbai B.O": "793160",
      "Sham Sham B.O": "793160",
      "Ladrymbai S.O": "793160",
      "Lumshnong S.O": "793210",
      "Khliehriat S.O": "793200"
    },
    "SOUTH WEST KHASI HILLS": {
      "Jakrem B.O": "793114",
      "Jashier B.O": "793114",
      "Laitnongrim B.O": "793114",
      "Phlang Kynshi B.O": "793114",
      "Mawsaw B.O": "793114",
      "Mawthapdoh B.O": "793114",
      "Pyndemsakwang B.O": "793114",
      "Mawlyngwir B.O": "793114",
      "Mawten B.O": "793114",
      "Phudjaud B.O": "793114",
      "Rangmaw B.O": "793114",
      "Rangthong B.O": "793114",
      "Umjarain B.O": "793114",
      "Sngimawlein B.O": "793114",
      "Ngunraw B.O": "793114",
      "Nonglang B.O": "793114",
      "Nongsynrih B.O": "793114",
      "Gumaghat B.O": "793106",
      "Sarin B.O": "793106",
      "Trongpleng B.O": "793106",
      "Nongnah B.O": "793114",
      "Khonjoy B.O": "793106",
      "Mawput B.O": "793106",
      "Ranikor B.O": "793106",
      "Puksora B.O": "793106",
      "Munai B.O": "793106",
      "Rajapara B.O": "793106",
      "Rongasora B.O": "793106",
      "Umpung B.O": "793106",
      "Balat S.O": "793106",
      "Mawkyrwat S.O": "793114"
    },
    "WEST KHASI HILLS": {
      "Dungki   Ingdong B.O": "793120",
      "Kynshi B.O": "793120",
      "Kynrut B.O": "793120",
      "Mawkarah B.O": "793120",
      "Myriaw B.O": "793120",
      "Byrki B.O": "793119",
      "Mawkohngei B.O": "793119",
      "Langdongdai B.O": "793119",
      "Mawthengkut B.O": "793119",
      "Nongthliew B.O": "793120",
      "Nongum B.O": "793120",
      "Pariong B.O": "793120",
      "Tiehnongbah B.O": "793120",
      "Umkrem B.O": "793120",
      "Khliehmawlieh B.O": "793119",
      "Laitkseh B.O": "793119",
      "Marskuin B.O": "793119",
      "Laitdombah B.O": "793120",
      "Mawshut B.O": "793120",
      "Nongkhlaw B.O": "793120",
      "Umthlong B.O": "793120",
      "Jaidoh B.O": "793119",
      "Maweitlyngngam B.O": "793119",
      "Seinduli B.O": "793126",
      "Shallang B.O": "793119",
      "Umsohpieng B.O": "793119",
      "Iewmaroid B.O": "793120",
      "Langtor B.O": "793120",
      "Lawbyrtun B.O": "793120",
      "Madanbynther B.O": "793120",
      "Manai B.O": "793120",
      "Nongshyrkon B.O": "793119",
      "Pam Briew B.O": "793119",
      "Rangblang B.O": "793119",
      "Nongsdad  Dkhar B.O": "793119",
      "Nongthynniew B.O": "793119",
      "Umdohlun B.O": "793119",
      "Wahkaji B.O": "793119",
      "Mawlieh B.O": "793119",
      "Nongpyndeng B.O": "793119",
      "Phlangdiloin B.O": "793119",
      "Rambrai B.O": "793119",
      "Thangpylleng Pyndemkseh B.O": "793119",
      "Umyap B.O": "793119",
      "Myriem B.O": "793119",
      "Mawthungkper B.O": "793119",
      "Nongkasen B.O": "793119",
      "Nonglang B.O": "793119",
      "Pyndengrei B.O": "793119",
      "Mairang S.O": "793120",
      "Nongstoin S.O": "793119",
      "Riangdo Bazar S.O": "793126"
    },
    "SOUTH WEST GARO HILLS": {
      "Betsing B.O": "794115",
      "Katuli B.O": "794115",
      "Balurghat B.O": "794106",
      "Gopinath Killa B.O": "794106",
      "Bandelkona B.O": "794115",
      "Kalaipara B.O": "794106",
      "Kawahagra B.O": "794106",
      "Majerchar B.O": "794106",
      "Nogorpara B.O": "794106",
      "Kalaichar B.O": "794115",
      "Salmanpara B.O": "794115",
      "Chapahati B.O": "794106",
      "Sulguri B.O": "794115",
      "Zigzak B.O": "794115",
      "Ampati S.O": "794115",
      "Mahendraganj S.O (West Garo Hills)": "794106"
    },
    "SOUTH GARO HILLS": {
      "Emangiri B.O": "794102",
      "Nilwalgiri B.O": "794102",
      "Jadigitim B.O": "794107",
      "Panda B.O": "794102",
      "Siju B.O": "794102",
      "Balkhalbazar B.O": "794102",
      "Balsalgiri B.O": "794102",
      "Mendikgiri B.O": "794102",
      "Dambuk Agal B.O": "794114",
      "Mahesh Khola B.O": "794114",
      "Warimagiri B.O": "794114",
      "Baghmara S.O": "794102",
      "Nangwalbibra S.O": "794107",
      "Rongra S.O": "794114"
    },
    "WEST GARO HILLS": {
      "Captain Reserve B.O": "794101",
      "Dimapara B.O": "794103",
      "Rimrangapara B.O": "794103",
      "Sasengpara B.O": "794103",
      "Silkhigiri B.O": "794103",
      "Gambigre B.O": "794005",
      "Bhaitbari B.O": "794104",
      "Bholarbhita B.O": "794104",
      "Holidayganj B.O": "794104",
      "Mechanpani B.O": "794104",
      "Rongmatchokgiri B.O": "794104",
      "Shyamnagar B.O": "794104",
      "Grenggandi Agal B.O": "794105",
      "Kalchengapara B.O": "794105",
      "Rongsakhona B.O": "794105",
      "Teporpara B.O": "794105",
      "Bolsong B.O": "794002",
      "Edenbari Rongkhon B.O": "794002",
      "Matchakgiri B.O": "794002",
      "Raja Apal B.O": "794002",
      "Rongram B.O": "794002",
      "Kapasipara B.O": "794103",
      "Kharapara B.O": "794103",
      "Killapara B.O": "794103",
      "Mihanpara B.O": "794103",
      "Purakhasia B.O": "794103",
      "Halchati B.O": "794103",
      "Dekubazar B.O": "794005",
      "Dhopgiri B.O": "794005",
      "Batabari B.O": "794104",
      "Gatsingbazar B.O": "794104",
      "Gumaijhora B.O": "794104",
      "Haripur B.O": "794104",
      "New Bhaitbari B.O": "794104",
      "Paham B.O": "794104",
      "Rajabala B.O": "794104",
      "Rombazar B.O": "794104",
      "Monabari B.O": "794105",
      "Mukhdangra B.O": "794105",
      "Okkapara B.O": "794105",
      "Zekabari B.O": "794105",
      "Dajongpara B.O": "794002",
      "Gabil B.O": "794002",
      "Jingjal B.O": "794002",
      "Mendal B.O": "794002",
      "Raribazar B.O": "794002",
      "Rongkhon B.O": "794002",
      "Dakopgiri B.O": "794101",
      "Chati B.O": "794103",
      "Gachuapara B.O": "794103",
      "Joshipara B.O": "794103",
      "Sibbari B.O": "794103",
      "Gongrengiri B.O": "794005",
      "Shankinigiri B.O": "794005",
      "Bhajamara B.O": "794104",
      "Manlakandi B.O": "794104",
      "Sabribari B.O": "794104",
      "Bikonggre B.O": "794104",
      "Haldibari B.O": "794105",
      "Melliam B.O": "794105",
      "Selsella B.O": "794105",
      "Achitchonggiri B.O": "794002",
      "Bajengdoba B.O": "794002",
      "Chandabhui B.O": "794103",
      "Chengapara B.O": "794103",
      "Ganchudari B.O": "794103",
      "Bolchugre B.O": "794005",
      "Chokpotgiri B.O": "794005",
      "Damalgiri B.O": "794105",
      "Garodoba B.O": "794105",
      "Anugiri B.O": "794002",
      "Pedaldoba B.O": "794109",
      "Photamati B.O": "794109",
      "Raksamgiri B.O": "794109",
      "Halloidanga B.O": "794109",
      "Rom Bazar B.O": "794003",
      "Belguri B.O": "794109",
      "Jengrapara B.O": "794109",
      "Bolangitak B.O": "794109",
      "Borjhora B.O": "794109",
      "Hatugaon B.O": "794109",
      "Tura H.O": "794001",
      "Mendipathar S.O": "794112",
      "Fulbari S.O (West Garo Hills)": "794104",
      "Garobadha S.O": "794105",
      "Lower Chandmari S.O": "794002",
      "Tikrikilla S.O": "794109",
      "Araimile S.O": "794101",
      "Barengapara S.O": "794103",
      "Dobasipara S.O": "794005",
      "Dadengiri S.O": "794003"
    },
    "NORTH GARO HILLS": {
      "Daram B.O": "794108",
      "Rongrong B.O": "794108",
      "Thapa B.O": "794108",
      "Dagal B.O": "794108",
      "Haluapara B.O": "794108",
      "Resubelpara S.O": "794108"
    },
    "EAST GARO HILLS": {
      "Dainadubi B.O": "794110",
      "Darugiri B.O": "794110",
      "Dokangsi B.O": "794110",
      "Gairong B.O": "794110",
      "Dabu B.O": "794110",
      "Gambil B.O": "794110",
      "Dawagre B.O": "794111",
      "Mangsang B.O": "794110",
      "Wagachi B.O": "794110",
      "Balkinigiri B.O": "794111",
      "Rombagiri B.O": "794111",
      "Songsak B.O": "794111",
      "Nongcharan B.O": "794110",
      "Rongmil B.O": "794110",
      "Rongrengiri B.O": "794111",
      "Samanda B.O": "794111",
      "Ronga Agal B.O": "794110",
      "Rongchek Akhong B.O": "794110",
      "Rongsakgiri B.O": "794111",
      "Sakhadamgiri B.O": "794111",
      "Williamnagar S.O": "794111",
      "Rongjeng S.O": "794110"
    }
  },
  "MANIPUR": {
    "IMPHAL EAST": {
      "Haraorou B.O": "795114",
      "Kairang Litan Makhong B.O": "795114",
      "Takhel B.O": "795005",
      "Keirao Wangkhem B.O": "795008",
      "Kitnapanung B.O": "795008",
      "Kongba Bazar B.O": "795008",
      "Khumidok (P) B.O": "795114",
      "Mapao Keithelmanbi B.O": "795114",
      "Satang B.O": "795114",
      "Uyumpok B.O": "795114",
      "Moirang Kampu B.O": "795005",
      "Irilbung B.O": "795008",
      "Keirao Makting B.O": "795008",
      "Kshetribangoon B.O": "795005",
      "Pukhao Ahallup B.O": "795114",
      "Sagolmang B.O": "795114",
      "Wakhen Phai B.O": "795114",
      "Yumnam Khunou B.O": "795114",
      "Awang Kongpal B.O": "795005",
      "Mongkhang Lambi B.O": "795008",
      "Khongbal Tangkhul B.O": "795114",
      "Liklikhong Bazar B.O": "795114",
      "Thangal Surung B.O": "795114",
      "Waiton B.O": "795114",
      "Khurai Khongnang Makhong B.O": "795005",
      "Keirao Bitra Salam B.O": "795008",
      "Kshetrigao B.O": "795005",
      "Laiphrak Maring B.O": "795008",
      "Uchekon B.O": "795008",
      "Soibam Leikai B.O": "795001",
      "Top Chingtha B.O": "795149",
      "Yairipok Tulihal B.O": "795149",
      "Angtha B.O": "795149",
      "Changamdabi B.O": "795149",
      "Andro B.O": "795149",
      "Lamlai B.O": "795010",
      "Ningthemchakhul B.O": "795010",
      "Taretkhul B.O": "795010",
      "Kyamgei B.O": "795003",
      "Nongada B.O": "795010",
      "Yaingangpokpi B.O": "795145",
      "Heingang B.O": "795002",
      "Heinoumakhong B.O": "795010",
      "Huidrom B.O": "795010",
      "Kameng Kakching B.O": "795010",
      "Sawombung B.O": "795010",
      "Yourbung B.O": "795010",
      "Arapti B.O": "795130",
      "Urup B.O": "795130",
      "Ahallup B.O": "795002",
      "Awangpotsangbam B.O": "795002",
      "Lembakhul B.O": "795149",
      "Huikap B.O": "795149",
      "Phaknung B.O": "795010",
      "Luwangsangbam B.O": "795002",
      "Porompat S.O": "795005",
      "Lamlong S.O": "795010",
      "Pngaei Yangdong S.O": "795114"
    },
    "IMPHAL WEST": {
      "Khongangpheidekpi B.O": "795008",
      "Awang Leikinthabi B.O": "795136",
      "Kanglatombi B.O": "795136",
      "Potsangbam Khoiru B.O": "795136",
      "Oinam Thingel B.O": "795008",
      "Tharoijam B.O": "795113",
      "Yurembam B.O": "795113",
      "Khoyathong B.O": "795001",
      "Sagoltongba Bazar B.O": "795113",
      "Takyel Khongbal B.O": "795113",
      "Natok Kabui B.O": "795113",
      "Patsoi Part II B.O": "795113",
      "Tairenpokpi B.O": "795113",
      "Maklang Bazar B.O": "795113",
      "New Keithelmanbi B.O": "795113",
      "Ngairangbam B.O": "795113",
      "Khamnam Bazar B.O": "795113",
      "Khumbong Bazar B.O": "795113",
      "Konthoujam B.O": "795113",
      "Langjing Achouba B.O": "795113",
      "Haorang Kairel B.O": "795113",
      "Yarou Mitram B.O": "795140",
      "Sangaiprou B.O": "795140",
      "Bitrarakhong B.O": "795009",
      "Hiyangthang B.O": "795009",
      "Kodompokpi B.O": "795009",
      "Paobitek B.O": "795009",
      "Samurou B.O": "795009",
      "Central Agriculture University B.O": "795004",
      "Sagolband Thingom Leikai B.O": "795004",
      "Tera Bazar B.O": "795004",
      "Lamdeng B.O": "795146",
      "Phayeng B.O": "795146",
      "Khurukhul B.O": "795002",
      "Loitang Leikinthabi B.O": "795002",
      "Komlakhong B.O": "795132",
      "Sekmaijin B.O": "795132",
      "Kangmong B.O": "795134",
      "Maibam B.O": "795134",
      "Manamayang B.O": "795134",
      "Yarou Bomdiar B.O": "795134",
      "Iroisemba B.O": "795004",
      "Lamboi Khongngangkhong B.O": "795004",
      "Langol Housing Complex B.O": "795004",
      "Naoremthong Bazar B.O": "795004",
      "Lairen Sajik B.O": "795146",
      "Mayang Langjing B.O": "795146",
      "Ningombam B.O": "795003",
      "Konthakhabam B.O": "795002",
      "Tendongyang B.O": "795002",
      "Heibongpokpi B.O": "795146",
      "Langthabal B.O": "795003",
      "Mongsangei B.O": "795003",
      "Bengoon Maning Leikai B.O": "795132",
      "Chabung Company B.O": "795132",
      "Chirai Muslim B.O": "795132",
      "Laphupat B.O": "795132",
      "Loukok Mayai Leikai B.O": "795132",
      "Mayang Impahl Bengoon B.O": "795132",
      "Mutum Phibou B.O": "795132",
      "Tera Khoidum Mayai Leikai B.O": "795132",
      "Uchiwa B.O": "795132",
      "Uchiwa Wangban B.O": "795132",
      "Awangjiri B.O": "795134",
      "Heikrujam B.O": "795134",
      "Khabi B.O": "795134",
      "Laiphrakom B.O": "795140",
      "Haoreibi B.O": "795009",
      "Irom Meijrao B.O": "795009",
      "Sayang Kuraomakhong B.O": "795004",
      "Chajing pt. 1 B.O": "795130",
      "Canchipur B.O": "795003",
      "Kunja (P) B.O": "795003",
      "Khongampat B.O": "795002",
      "Phoubakchao B.O": "795132",
      "Imphal H.O": "795001",
      "CRPF Camp Langjing S.O": "795113",
      "Lamsang S.O": "795146",
      "Sekmai S.O": "795136",
      "Singjamei S.O": "795008",
      "Tulihal S.O": "795140",
      "Manipur High Court S.O": "795001",
      "D.M College S.O": "795001",
      "Manipur University S.O": "795003",
      "Mayang Imphal S.O": "795132",
      "Imphal Bazar S.O": "795001",
      "Lamphelpat S.O": "795004",
      "Mantripukhri S.O": "795002",
      "Wangoi S.O": "795009"
    },
    "SENAPATI": {
      "Kaibi B.O": "795104",
      "Laii B.O": "795104",
      "Saranamei B.O": "795104",
      "Liyai B.O": "795104",
      "Phaibung Khullen B.O": "795104",
      "Tungjoy B.O": "795104",
      "Khongdei Simphung B.O": "795105",
      "Ngari Khullen B.O": "795105",
      "Thiwa B.O": "795144",
      "Chawanamei B.O": "795104",
      "Chingai Khullen B.O": "795104",
      "Oklong B.O": "795106",
      "Liyai Khunou B.O": "795104",
      "Paomata Centre B.O": "795104",
      "Siraffi B.O": "795104",
      "Tingsong B.O": "795006",
      "Willong B.O": "795007",
      "Lakhamei B.O": "795105",
      "Makhan Bazar B.O": "795105",
      "Lairouching B.O": "795007",
      "Oinam Hills B.O": "795007",
      "Rajamei B.O": "795007",
      "Thingba Khullen B.O": "795007",
      "Pfukhro B.O": "795150",
      "Phunanamei B.O": "795150",
      "Pudunamei B.O": "795150",
      "Phuba B.O": "795105",
      "Purul B.O": "795105",
      "Thingba Khunou B.O": "795007",
      "Yangkhullen B.O": "795007",
      "Koide B.O": "795105",
      "Maiba B.O": "795105",
      "Karong S.O": "795007",
      "Senapati S.O": "795106",
      "Mao S.O": "795150",
      "Maram S.O": "795105",
      "Tadubi S.O": "795104"
    },
    "TAMENGLONG": {
      "Illong B.O": "795125",
      "Jampii (T/C/D) B.O": "795125",
      "Khumphung B.O": "795125",
      "Bhalok B.O": "795141",
      "Bongoijang B.O": "795141",
      "Dailong B.O": "795141",
      "Songpram B.O": "795141",
      "Tamenglong Khunjao B.O": "795141",
      "Tharon B.O": "795141",
      "Thuilon B.O": "795141",
      "Kadi B.O": "795125",
      "Kuilong B.O": "795125",
      "New Lamlaba B.O": "795125",
      "Upper Selsi (T/c/d) B.O": "795125",
      "Akhui B.O": "795141",
      "Atengba B.O": "795141",
      "Khongjaron B.O": "795141",
      "Longpram B.O": "795141",
      "New Pallong B.O": "795141",
      "Tousem B.O": "795141",
      "Farmland B.O": "795141",
      "Chaiton B.O": "795125",
      "Dullen (T/C/D) B.O": "795125",
      "Lemta B.O": "795125",
      "Lenglong B.O": "795125",
      "Kahulong B.O": "795141",
      "Atang Khunou B.O": "795125",
      "Kasanlong B.O": "795125",
      "Magulong B.O": "795125",
      "Takou B.O": "795125",
      "Keikao B.O": "795141",
      "Khongjaron Khunthak B.O": "795141",
      "Namtiram B.O": "795141",
      "Wairengba B.O": "795141",
      "Nungkao B.O": "795115",
      "Keimai B.O": "795115",
      "New Keiphundai B.O": "795115",
      "Kashimpur B.O": "795115",
      "Khungdong Khungkhaiba B.O": "795146",
      "Tamenglong S.O": "795141",
      "Tamei S.O": "795125"
    },
    "JIRIBAM": {
      "Chongmun B.O": "795116",
      "Bidyanagar B.O": "795115",
      "Chingmun B.O": "795116",
      "Longpi B.O": "795116",
      "Ngamphabung B.O": "795115",
      "Patpuimun B.O": "795116",
      "Sonapur B.O": "795116",
      "BR Colony B.O": "795115",
      "Jakurdhar B.O": "795116",
      "Lalkhan B.O": "795115",
      "Latingkhal B.O": "795116",
      "Phaibok Mullen B.O": "795116",
      "Tuitengmun B.O": "795116",
      "Suangpuimun B.O": "795116",
      "Bongmun B.O": "795116",
      "Borobekra B.O": "795116",
      "Champanagar B.O": "795116",
      "Jiribam Bazar S.O": "795116",
      "Gularthol S.O": "795115"
    },
    "CHURACHANDPUR": {
      "Mual Vaiphei B.O": "795117",
      "Lama Camp B.O": "795139",
      "Lungchin B.O": "795139",
      "Mualmun B.O": "795139",
      "Vokbual B.O": "795139",
      "Suangdoh B.O": "795139",
      "Songtal B.O": "795139",
      "Tuining B.O": "795117",
      "Tuitengphai B.O": "795117",
      "Behiang B.O": "795139",
      "Hengtam B.O": "795139",
      "Kangkap B.O": "795139",
      "Siabu B.O": "795139",
      "Pamjal BO": "795006",
      "Khouwpuibung B.O": "795117",
      "Tuikham B.O": "795117",
      "Lungthul(L.Daijang) B.O": "795139",
      "Milongmun B.O": "795006",
      "Sawaiphaih (T/C/D) B.O": "795006",
      "Geljang B.O": "795128",
      "Takvom B.O": "795128",
      "Mission Compound B.O": "795128",
      "Chehjang B.O": "795128",
      "Kangvai Bazar B.O": "795128",
      "Kolhen B.O": "795128",
      "Lailong B.O": "795128",
      "Lungsai B.O": "795128",
      "Pearsonmun B.O": "795006",
      "South Kotlein B.O": "795128",
      "Tollen B.O": "795128",
      "Tuinom B.O": "795128",
      "Aina B.O": "795128",
      "Munpi B.O": "795128",
      "Kamkeilon B.O": "795128",
      "M.Songel B.O": "795128",
      "Hamkeilon B.O": "795128",
      "Henglep B.O": "795128",
      "Khanpi B.O": "795128",
      "Kumbipukhri B.O": "795128",
      "Kwanpui B.O": "795128",
      "Lingshiphai B.O": "795006",
      "Phaipheng B.O": "795128",
      "Saiden B.O": "795128",
      "Saikhul Village B.O": "795128",
      "Sangphou B.O": "795128",
      "Santing B.O": "795128",
      "Teiyong B.O": "795128",
      "Thangshi B.O": "795128",
      "Thinkew B.O": "795128",
      "Bungmual B.O": "795006",
      "Chothemunpi B.O": "795128",
      "Lungshung B.O": "795128",
      "Mualkoi B.O": "795006",
      "Panglian B.O": "795006",
      "Sielmet B.O": "795128",
      "Tolphei B.O": "795128",
      "Tulaphei B.O": "795128",
      "Ukha B.O": "795128",
      "Bunglon B.O": "795133",
      "Dopkon B.O": "795133",
      "Gelman (G.Gothal) B.O": "795133",
      "Molphei Tampak B.O": "795133",
      "Phousabung B.O": "795133",
      "Leimatak B.O": "795124",
      "Mayuran B.O": "795124",
      "Kangathel B.O": "795133",
      "Khoirentak B.O": "795133",
      "Nabil (P) B.O": "795133",
      "Nungthangtampak B.O": "795133",
      "Thumkhonglok B.O": "795133",
      "Charoi Khullel B.O": "795124",
      "Tokpalamdan B.O": "795124",
      "Khousabung B.O": "795133",
      "Jiban Nager B.O": "795124",
      "Haotakphailen B.O": "795133",
      "Khordak Ichin B.O": "795133",
      "Haotak Khullen B.O": "795011",
      "Ngarian B.O": "795126",
      "Chingkonpang S.O": "795128",
      "Churachandpur S.O": "795128",
      "Saikot S.O": "795117",
      "New Lamka S.O": "795006",
      "Singhat S.O": "795139"
    },
    "KAKCHING": {
      "Serou B.O": "795101",
      "Chairen B.O": "795101",
      "Mahou Tera B.O": "795101",
      "Mantak B.O": "795103",
      "Pangaltabi B.O": "795103",
      "Sora B.O": "795103",
      "Wabagai B.O": "795103",
      "Wangoo Laipham B.O": "795103",
      "Langmeidong B.O": "795103",
      "Tokpaching B.O": "795103",
      "Waikhong B.O": "795103",
      "Kakching Khunou B.O": "795103",
      "Mairembam B.O": "795103",
      "Sekmaijin Khunou Litan Makhong B.O": "795132",
      "Irong Umang Khunou B.O": "795132",
      "Santhel B.O": "795132",
      "Arong B.O": "795132",
      "Heibong Makhong B.O": "795132",
      "Maibam Konjil B.O": "795132",
      "Hayel Hangoon B.O": "795132",
      "Irong Chessaba B.O": "795132",
      "Khelakhong Khongjil B.O": "795132",
      "Sekmaijin  Khunou Konuma B.O": "795132",
      "Kakching S.O": "795103",
      "Sugnu S.O": "795101",
      "Pallel S.O": "795135"
    },
    "TENGNOUPAL": {
      "Khangbarol B.O": "795135",
      "Machi B.O": "795135",
      "Saibhom B.O": "795135",
      "Songjang B.O": "795135",
      "Lamlong Khunou B.O": "795135",
      "Liwachangning B.O": "795135",
      "Narum B.O": "795135",
      "Laiching Tangsang B.O": "795135",
      "Lamkang Khunou B.O": "795135",
      "Minou Khunjao B.O": "795135",
      "Aimol Kodamphai B.O": "795135",
      "Khousat (T/C/D) B.O": "795135",
      "Lamlong Khullen B.O": "795135",
      "Leibi B.O": "795135",
      "Bongjang B.O": "795131",
      "Changpol B.O": "795131",
      "Khudengthabi B.O": "795131",
      "Bongajang B.O": "795131",
      "Gamphajal B.O": "795131",
      "Maojam B.O": "795131",
      "New Somtal B.O": "795131",
      "T  Bongmun B.O": "795131",
      "Tengnoupal B.O": "795131",
      "T minou B.O": "795131",
      "Yangoulen B.O": "795131",
      "Molcham B.O": "795131",
      "Khenjoi B.O": "795131",
      "Moreh S.O": "795131"
    },
    "PHERZAWL": {
      "Hanship B.O": "795006",
      "Khajang B.O": "795006",
      "Leijangphai B.O": "795006",
      "Bukpi B.O": "795006",
      "Leison B.O": "795006",
      "Aibulon B.O": "795006",
      "Singzawl B.O": "795006",
      "Bungpilon B.O": "795006",
      "Pherzawl B.O": "795006",
      "Senvon B.O": "795006",
      "Tipaimukh (P) B.O": "795006",
      "Parbung B.O": "795006",
      "Phaijang B.O": "795006",
      "Tuabung B.O": "795006",
      "Taithu B.O": "795006",
      "Kh Jaikhan B.O": "795116",
      "Singjawl B.O": "795006",
      "Thanlon B.O": "795006",
      "Kwanpui B.O": "795006",
      "Pamjal B.O": "795006",
      "Leisan B.O": "795006"
    },
    "NONEY": {
      "Lukhambi B.O": "795159",
      "Khongsang B.O": "795147",
      "New Kabui Khullen B.O": "795159",
      "Khoupum B.O": "795126",
      "Mukti Khullen B.O": "795147",
      "Nungnang B.O": "795159",
      "Thingra B.O": "795159",
      "Kambiron B.O": "795147",
      "Haochong B.O": "795159",
      "Nagaching B.O": "795159",
      "Karuangmuan (Nungtek) B.O": "795159",
      "Rengpang B.O": "795147",
      "Sibilong B.O": "795147",
      "Christian Centre Haochong B.O": "795146",
      "Oktan B.O": "795146",
      "Ijairong B.O": "795146",
      "Awangkhul B.O": "795159",
      "Charoi Tupul B.O": "795159",
      "Zouzangtek B.O": "795126",
      "Dolang B.O": "795126",
      "Khongbung B.O": "795126",
      "Lamdangmei B.O": "795126",
      "Thangal B.O": "795126",
      "None S.O": "795159",
      "Nungba S.O": "795147"
    },
    "CHANDEL": {
      "Bongli B.O": "795135",
      "Khoibu B.O": "795135",
      "Sita B.O": "795135",
      "K. Molnam B.O": "795101",
      "Khongnangpheisabi B.O": "795101",
      "Chelhep B.O": "795135",
      "Khudei Khullen B.O": "795135",
      "Khunbi B.O": "795135",
      "Molhang B.O": "795135",
      "Julbalching B.O": "795101",
      "Kambang Khunou B.O": "795135",
      "Kharou Khullen B.O": "795135",
      "Thamnapokpi B.O": "795135",
      "M Bongmol B.O": "795101",
      "Sangaikot B.O": "795101",
      "Shahumphai B.O": "795101",
      "Angbrashu B.O": "795135",
      "Chatong B.O": "795135",
      "Moltek B.O": "795135",
      "Khambathel B.O": "795101",
      "Longja B.O": "795101",
      "Khudei Khunou B.O": "795103",
      "Purum Pantha B.O": "795103",
      "Leingangching B.O": "795103",
      "Mollen (T/C/D) B.O": "795149",
      "Sajik Tampak B.O": "795102",
      "Sehao B.O": "795101",
      "Semol B.O": "795101",
      "Duthang B.O": "795127",
      "Khubung Khullen B.O": "795102",
      "Phiran Machet B.O": "795102",
      "Zoupi B.O": "795101",
      "Thorchom B.O": "795102",
      "Toupokpi B.O": "795102",
      "Larong B.O": "795127",
      "Liwasarai B.O": "795127",
      "Mittong B.O": "795127",
      "Monbi B.O": "795102",
      "Aigejang B.O": "795101",
      "Anal Khullen B.O": "795102",
      "Gobok B.O": "795102",
      "Khengjoi B.O": "795102",
      "Chakpikarong S.O": "795102",
      "Chandel S.O": "795127"
    },
    "KANGPOKPI": {
      "Ichaigojang B.O": "795118",
      "Makeng Ngarolu B.O": "795118",
      "Mutukhong B.O": "795118",
      "Phaikon B.O": "795118",
      "Tumuyen Khullen B.O": "795106",
      "Cheljang B.O": "795112",
      "Bunglong B.O": "795118",
      "Dolang B.O": "795118",
      "Galam B.O": "795118",
      "Gangpijang B.O": "795118",
      "Luwangsangol B.O": "795136",
      "Makhan B.O": "795136",
      "Ganel B.O": "795112",
      "Irang B.O": "795112",
      "Dolaithabi B.O": "795114",
      "Molkon B.O": "795118",
      "Sangpei Khullen B.O": "795118",
      "T. Awkhumbung B.O": "795118",
      "Tingpibung B.O": "795118",
      "Zelengphai B.O": "795118",
      "Kolhen B.O": "795112",
      "Thengjang B.O": "795112",
      "Jangnoi B.O": "795118",
      "Makokchung B.O": "795118",
      "Pangjang B.O": "795118",
      "Ch. Khongnangpokpi B.O": "795136",
      "Chalwa (P) B.O": "795112",
      "Chandraman B.O": "795122",
      "Kheljang B.O": "795122",
      "Persian B.O": "795122",
      "Longa Koireng B.O": "795113",
      "Haipi B.O": "795122",
      "Keithelmanbi B.O": "795122",
      "Lungthar B.O": "795149",
      "Saram Patong B.O": "795149",
      "Phouoibi B.O": "795149",
      "Soichang B.O": "795149",
      "Theiyong B.O": "795149",
      "kongakhul BO": "795113",
      "Bongbal Khullen B.O": "795149",
      "Irong Tangkhul B.O": "795149",
      "Kamu Tampak B.O": "795149",
      "Haokhongching B.O": "795149",
      "Heinganglok B.O": "795149",
      "Kamu Tongnom B.O": "795149",
      "Kangpokpi Mission B.O": "795129",
      "Maohing B.O": "795129",
      "Kangchup Hill (P) B.O": "795146",
      "Karam Vaiphei B.O": "795146",
      "Karakhul B.O": "795002",
      "Thingsat B.O": "795107",
      "Tokpa B.O": "795122",
      "Taphou B.O": "795129",
      "Thonglang B.O": "795129",
      "Toribari B.O": "795129",
      "Ponlian B.O": "795146",
      "N. Khenjang B.O": "795107",
      "Nurathel B.O": "795107",
      "Thanamba B.O": "795122",
      "Chingmang B.O": "795010",
      "Irengnaga B.O": "795146",
      "Kangchup Chiru B.O": "795146",
      "Bungte Chiru B.O": "795134",
      "S.Bolkot B.O": "795107",
      "Saitu B.O": "795107",
      "Thingkai Khullen B.O": "795134",
      "Kamuching B.O": "795149",
      "Henbung B.O": "795129",
      "Maohiing B.O": "795129",
      "Laikoiching B.O": "795010",
      "Moirang Purel B.O": "795010",
      "Kangchup Makhong B.O": "795146",
      "Semol B.O": "795145",
      "Siyamongjang B.O": "795145",
      "J Phaijang B.O": "795107",
      "Sapermeina B.O": "795107",
      "Nungsai Chiru B.O": "795126",
      "Dolang Khunou B.O": "795126",
      "T Waichong S.O": "795112",
      "Kalapahar S.O": "795122",
      "Kangpokpi S.O": "795129",
      "Saikul S.O": "795118",
      "Motbung S.O": "795107"
    },
    "UKHRUL": {
      "Huime B.O": "795144",
      "Kachai B.O": "795144",
      "Phadang B.O": "795144",
      "Kharasom B.O": "795142",
      "Lamlang Gate B.O": "795142",
      "T.C.Compound B.O": "795142",
      "Tolloi B.O": "795142",
      "Tuinem B.O": "795142",
      "Chingjaroi (p) B.O": "795142",
      "Chither (P) B.O": "795142",
      "Huining B.O": "795142",
      "Hundung B.O": "795142",
      "Nungshang B.O": "795142",
      "Paorei B.O": "795142",
      "Phungcham B.O": "795142",
      "Poii B.O": "795142",
      "Pushing B.O": "795142",
      "Chingai (P) B.O": "795142",
      "Jessami B.O": "795142",
      "Khamasom B.O": "795142",
      "Ngaimu B.O": "795142",
      "Paoyii B.O": "795142",
      "Rajai Khunou B.O": "795142",
      "Siroi B.O": "795142",
      "Tushem B.O": "795142",
      "Lambui B.O": "795145",
      "Shangsak B.O": "795145",
      "Chamu B.O": "795142",
      "Kagai B.O": "795142",
      "Khayang B.O": "795142",
      "Mapum B.O": "795142",
      "Nungbi Khunou B.O": "795142",
      "Sirarakhong B.O": "795142",
      "Soraphung B.O": "795142",
      "Tungou B.O": "795142",
      "Sanakeithel B.O": "795145",
      "Somdal S.O": "795144",
      "Ukhrul S.O": "795142"
    },
    "THOUBAL": {
      "Khangabok B.O": "795138",
      "Kiyam Siphai B.O": "795138",
      "Athokpam Khunou B.O": "795138",
      "Haokha B.O": "795138",
      "Irong Thokchom (T/C/D) B.O": "795138",
      "Athokpam B.O": "795138",
      "Charangpat B.O": "795138",
      "Keibung Mamang B.O": "795138",
      "Khekman B.O": "795138",
      "Kakching Lamkhai B.O": "795103",
      "Arong Nongmaikhong B.O": "795103",
      "Kalikalok B.O": "795103",
      "Keirak B.O": "795103",
      "Elangkhangpokpi B.O": "795103",
      "Hiyanglam B.O": "795103",
      "K M College B.O": "795103",
      "Khoirom B.O": "795149",
      "Nongpok Sekmai B.O": "795149",
      "Yambem Laxmi Bazar B.O": "795149",
      "Khonglou Vaiphei (T/C/D) B.O": "795149",
      "Lourembam B.O": "795149",
      "Ningthounai B.O": "795149",
      "Phoudel B.O": "795138",
      "Poirou Kongjil B.O": "795138",
      "Salungpham B.O": "795148",
      "Samaram B.O": "795148",
      "Sangaiyumpham B.O": "795148",
      "Sapam Salai B.O": "795148",
      "Tekcham B.O": "795148",
      "Tentha B.O": "795148",
      "Kshetri Leikai B.O": "795138",
      "Okram Wangmataba B.O": "795138",
      "Khongjom B.O": "795148",
      "Puleipokpi B.O": "795148",
      "Langathel B.O": "795148",
      "Sabaltongba B.O": "795138",
      "Thoubal Block (T/C/D) B.O": "795138",
      "Thoubal Leisangthem B.O": "795138",
      "Thoubal Ningombam B.O": "795138",
      "Cherapur B.O": "795148",
      "Heirok Part 2 B.O": "795148",
      "Herok Part 1 B.O": "795148",
      "Haoreibi Mayai Leikai B.O": "795130",
      "Nungei B.O": "795130",
      "Phunalmaring B.O": "795130",
      "Thiyamkonjil B.O": "795130",
      "Turelahnabi B.O": "795130",
      "Lairabokhong B.O": "795130",
      "Moijing B.O": "795138",
      "Thoubal Khunou B.O": "795138",
      "Wangbal B.O": "795138",
      "Karongthel B.O": "795148",
      "Phundrei B.O": "795148",
      "Tollen B.O": "795148",
      "Heinoumakhong B.O": "795130",
      "Thoubal S.O": "795138",
      "Wangjing S.O": "795148",
      "Lilong S.O": "795130",
      "Yairipok S.O": "795149"
    },
    "KAMJONG": {
      "Nambasi B.O": "795149",
      "Nongdam Tangkhul B.O": "795010",
      "Aishi B.O": "795145",
      "Chadong B.O": "795145",
      "Chassad B.O": "795145",
      "Thawai B.O": "795145",
      "Kongpat Khunou B.O": "795145",
      "Leiting B.O": "795145",
      "Lungphu B.O": "795145",
      "Maku B.O": "795145",
      "Maokot B.O": "795145",
      "Phungyar B.O": "795145",
      "Sorde B.O": "795145",
      "Kasom Khullen B.O": "795149",
      "Tangkhul Hungdung B.O": "795010",
      "Grihang B.O": "795145",
      "L Tangkhul B.O": "795145",
      "Litan S.O": "795145"
    },
    "BISHNUPUR": {
      "Ethai Bazar B.O": "795133",
      "Naransena B.O": "795011",
      "Ngangkha Louwai B.O": "795133",
      "Sagang B.O": "795133",
      "Saiton B.O": "795133",
      "Kwakta B.O": "795133",
      "Thanga Karang B.O": "795133",
      "Isok B.O": "795134",
      "Keinou B.O": "795134",
      "Torbung B.O": "795133",
      "Tuisang Gothal B.O": "795133",
      "Wangoo B.O": "795133",
      "Langpok B.O": "795134",
      "Leimapokpam B.O": "795134",
      "Oinam B.O": "795134",
      "Pukhrambam B.O": "795134",
      "Utlou B.O": "795134",
      "Irengbam B.O": "795134",
      "Sadukhoiroi B.O": "795124",
      "Boroyangbi B.O": "795133",
      "Khathinungei B.O": "795133",
      "Kumbi (P) B.O": "795133",
      "Terakhongshangbi B.O": "795133",
      "Thanga(P) B.O": "795133",
      "Tronglaobi B.O": "795133",
      "Wangoo Tera B.O": "795133",
      "Kabowakching B.O": "795134",
      "Leimaram B.O": "795134",
      "Naorem B.O": "795134",
      "Khoijuman B.O": "795126",
      "Khunpi Naosem B.O": "795126",
      "Phubala B.O": "795011",
      "Thinungei B.O": "795011",
      "Ngaikhong Khullen B.O": "795126",
      "Potsangbam B.O": "795011",
      "Toubul B.O": "795126",
      "Loktak Project S.O": "795124",
      "Ningthoukhong SO": "795011",
      "Nambol S.O": "795134",
      "Bishnupur S.O (Bishnupur)": "795126",
      "Moirang S.O": "795133"
    }
  },
  "THE DADRA AND NAGAR HAVELI AND DAMAN AND DIU": {
    "DIU": {
      "Bucharvada BO": "362570",
      "Ghoghla SO": "362540",
      "Diu SO": "362520",
      "Wanakbara SO": "362570"
    },
    "DADRA AND NAGAR HAVELI": {
      "Masat BO": "396230",
      "Mota Randha BO": "396230",
      "Parzai BO": "396230",
      "Samarvarni BO": "396230",
      "Amboli BO": "396230",
      "Athola BO": "396230",
      "Khanvel BO": "396230",
      "Khutli BO": "396230",
      "Mandoni BO": "396230",
      "Rudana BO": "396230",
      "Selti BO": "396230",
      "Kharadpada BO": "396235",
      "Amli BO": "396230",
      "Dudhani BO": "396230",
      "Kherdi BO": "396230",
      "Kilvani BO": "396230",
      "Sili BO": "396230",
      "Umarkui BO": "396230",
      "Athal BO": "396235",
      "Bedpa BO": "396230",
      "Bonta BO": "396230",
      "Chisda BO": "396230",
      "Karachgam BO": "396230",
      "Karchond BO": "396230",
      "Khadoli BO": "396230",
      "Sindoni BO": "396230",
      "Velugam BO": "396230",
      "Chinchpada BO": "396240",
      "Rakholi BO": "396240",
      "Vasona BO": "396240",
      "Dapada BO": "396240",
      "Chikhli BO": "396240",
      "Saily BO": "396240",
      "Surangi BO": "396240",
      "Silvassa SO": "396230",
      "Naroli SO": "396235",
      "Dadra SO": "396193"
    },
    "DAMAN": {
      "Magarwada BO": "396220",
      "Dholar BO": "396220",
      "Dabhel BO": "396215",
      "Dunetha BO": "396210",
      "Nani Vankad BO": "396210",
      "Kachigam BO": "396215",
      "Bhimpore BO": "396210",
      "Varkund BO": "396210",
      "Kadaiya BO": "396210",
      "Marvad BO": "396210",
      "Daman SO": "396210",
      "Daman IE SO": "396215",
      "Moti Daman SO": "396220"
    }
  },
  "MIZORAM": {
    "SAITUAL": {
      "Suangpuilawn B.O": "796261",
      "Sihfa B.O": "796261",
      "Tualbung B.O": "796261",
      "Vanbawng B.O": "796261",
      "Zawngin B.O": "796261",
      "Kepran B.O": "796017",
      "Khanpui B.O": "796017",
      "Hrianghmun B.O": "796290",
      "Lamzawl B.O": "796290",
      "Teikhang B.O": "796290",
      "Pawlrang B.O": "796261",
      "Phuaibuang B.O": "796261",
      "Phullen B.O": "796261",
      "Khawkawn B.O": "796290",
      "Mimbung B.O": "796290",
      "Ne Khawdungsei B.O": "796290",
      "Luangpawn B.O": "796261",
      "Lungpher 'N' B.O": "796261",
      "Maite B.O": "796261",
      "Kawlbem B.O": "796290",
      "Buhban B.O": "796261",
      "Khawlian B.O": "796261",
      "Mualpheng B.O": "796261",
      "N.Khawlek B.O": "796261",
      "Ruallung B.O": "796261",
      "Saichal B.O": "796261",
      "Changzawl B.O": "796261",
      "N.E.Bualpui B.O": "796261",
      "Ngopa S.O": "796290",
      "Saitual S.O": "796261"
    },
    "SERCHHIP": {
      "Kanghmun 'S' B.O": "796186",
      "Keitum B.O": "796181",
      "Khawlailung B.O": "796181",
      "Lungchhuan B.O": "796184",
      "Lungkawlh B.O": "796184",
      "Lungpho B.O": "796181",
      "Baktawng B.O": "796161",
      "Chekawn B.O": "796181",
      "Chhipphir B.O": "796181",
      "New Serchhip B.O": "796181",
      "Sialsir B.O": "796184",
      "Zote 'S' B.O": "796181",
      "Zote South B.O": "796186",
      "Hmuntha B.O": "796161",
      "Khawbel B.O": "796161",
      "Bungtlang 'N' B.O": "796181",
      "Chhiahtlang B.O": "796181",
      "Sialhau B.O": "796181",
      "Hualtu B.O": "796161",
      "Thinglian B.O": "796181",
      "Chhingchhip B.O": "796161",
      "Khumtung B.O": "796161",
      "Thentlang B.O": "796161",
      "Tlungvel B.O": "796161",
      "Mualcheng B.O": "796370",
      "Sialhawk B.O": "796370",
      "Tlangpui B.O": "796370",
      "Rullam B.O": "796310",
      "Leng B.O": "796370",
      "Sailulak B.O": "796370",
      "Keifang B.O": "796261",
      "Lungdar S.O": "796370",
      "Thenzawl S.O": "796186",
      "Serchhip S.O": "796181",
      "N. Vanlaiphai S.O": "796184"
    },
    "KOLASIB": {
      "N.Chawnpui B.O": "796091",
      "Saiphai B.O": "796091",
      "Saipum B.O": "796091",
      "Tuirial H.E.P B.O": "796091",
      "Phainuam B.O": "796101",
      "Buhchang B.O": "796091",
      "Phaisen B.O": "796091",
      "Bualpui B.O": "796070",
      "Mualvum B.O": "796070",
      "Thingdawl B.O": "796081",
      "Hortoki B.O": "796070",
      "N.Chaltlang B.O": "796070",
      "Lungmuat B.O": "796070",
      "Zanlawn B.O": "796015",
      "Bukpui B.O": "796070",
      "N.Hlimen B.O": "796070",
      "Lungdai B.O": "796015",
      "Bairabi B.O": "796081",
      "Builum B.O": "796081",
      "Diakkawn B.O": "796081",
      "Mualkhang B.O": "796410",
      "Nisapui B.O": "796070",
      "Thingthelh B.O": "796070",
      "Serkhan B.O": "796070",
      "Saikhawthlir B.O": "796081",
      "Vengthar B.O": "796081",
      "Vairengte S.O": "796101",
      "Thingdawl S.O": "796075",
      "Kolasib S.O": "796081",
      "Bilkhawthlir S.O": "796091",
      "Kawnpui S.O": "796070"
    },
    "AIZAWL": {
      "Zuangtui B.O": "796017",
      "Luangmual B.O": "796009",
      "Sakawrtuichhun B.O": "796009",
      "Cti Sesawng B.O": "796017",
      "Khawruhlian B.O": "796017",
      "Sawleng B.O": "796017",
      "Rangvamual B.O": "796009",
      "Tanhril B.O": "796009",
      "Sesawng B.O": "796017",
      "Tuirial Airfield B.O": "796017",
      "Seling B.O": "796161",
      "Chawlhhmun B.O": "796009",
      "Dinthar B.O": "796009",
      "Govt. Complex B.O": "796009",
      "Phaileng 'E' B.O": "796017",
      "Maubuang B.O": "796190",
      "Phulpui B.O": "796190",
      "Sailam B.O": "796190",
      "Samlukhai B.O": "796190",
      "Electric Veng B.O": "796007",
      "Khawpuar B.O": "796111",
      "Lungsum B.O": "796111",
      "Mauchar B.O": "796111",
      "N.Serzawl B.O": "796111",
      "Sakawrdai B.O": "796111",
      "Hmuifang B.O": "796190",
      "Sumsuih B.O": "796190",
      "Sialsuk B.O": "796190",
      "Selesih B.O": "796015",
      "Durtlang B.O": "796014",
      "Armed Veng B.O": "796007",
      "New Vervek B.O": "796111",
      "Ratu B.O": "796111",
      "Thingsat B.O": "796111",
      "Edenthar B.O": "796007",
      "Lamchhip B.O": "796190",
      "Sateek B.O": "796190",
      "Tachhip B.O": "796190",
      "Thiak B.O": "796190",
      "Sihphir B.O": "796014",
      "Bethlehem B.O": "796007",
      "Ramthar B.O": "796007",
      "Tuithiang B.O": "796007",
      "N.Tinghmun B.O": "796111",
      "Palsang B.O": "796111",
      "Zohmun B.O": "796111",
      "Muthi B.O": "796015",
      "Sailutar B.O": "796111",
      "Vaitin B.O": "796111",
      "Vervek B.O": "796111",
      "Khawchhete B.O": "796005",
      "Mualpui B.O": "796005",
      "Thingdawlmelriat B.O": "796005",
      "Missionvengthlang B.O": "796005",
      "Mualmawi B.O": "796005",
      "S,hlimen B.O": "796005",
      "Sabualkawn B.O": "796005",
      "Chaltlang B.O": "796012",
      "Hualngohmun B.O": "796005",
      "N.Lungleng B.O": "796005",
      "Republic Veng B.O": "796005",
      "Lengpui B.O": "796410",
      "Ptc Lungverh B.O": "796410",
      "Bungkawn B.O": "796005",
      "College Veng B.O": "796005",
      "Kelsih B.O": "796005",
      "Maubawk B.O": "796005",
      "Muallungthu B.O": "796005",
      "Thakthingbazar B.O": "796005",
      "New Secretariat Complex B.O": "796005",
      "Aizawl H.O": "796001",
      "Mizoram University S.O": "796004",
      "Ramhlun S.O": "796012",
      "Sihphir S.O": "796036",
      "Sialsuk S.O": "796230",
      "Thingsulthliah S.O": "796161",
      "Vaivakawn S.O": "796009",
      "Zemabawk S.O": "796017",
      "Durtlang SO": "796015",
      "Sairang S.O": "796410",
      "Tlangnuam S.O": "796015",
      "Aibawk S.O": "796190",
      "Armed Veng S.O": "796008",
      "Chandmary S.O": "796007",
      "Darlawn S.O": "796111",
      "Bawngkawn S.O": "796014",
      "Kulikawn S.O": "796005",
      "Dawrpui S.O": "796001",
      "Lengpui Airport S.O": "796421"
    },
    "LUNGLEI": {
      "Haulawng B.O": "796691",
      "Mualthuam 'N' B.O": "796691",
      "Ramlaitui B.O": "796186",
      "Hnahchang B.O": "796691",
      "Pukpui B.O": "796691",
      "Serkawn B.O": "796691",
      "Kawnpui 'W' B.O": "796701",
      "Laisawral B.O": "796710",
      "Sachan B.O": "796701",
      "Sesawm B.O": "796701",
      "Ajasora B.O": "796770",
      "Borapansury B.O": "796770",
      "Darngawn 'W' B.O": "796701",
      "Sumsilui B.O": "796770",
      "Tiperaghat B.O": "796751",
      "Zodin B.O": "796751",
      "Saizawh B.O": "796770",
      "Udaisury B.O": "796770",
      "S.Chawilung B.O": "796751",
      "Tuikawi B.O": "796751",
      "Jarulsury B.O": "796770",
      "Kamalanagar B.O": "796770",
      "Diblibagh B.O": "796751",
      "Kajoisury B.O": "796751",
      "Nunsury B.O": "796751",
      "Puankhai B.O": "796751",
      "Changpui B.O": "796701",
      "Hrangchalkawn B.O": "796701",
      "Tawipui 'N' B.O": "796701",
      "Theiriat B.O": "796701",
      "Thuampui B.O": "796701",
      "Lungsen B.O": "796701",
      "Putlungasih B.O": "796017",
      "Tuichawng B.O": "796751",
      "Lungchem B.O": "796701",
      "Mualcheng 'S' B.O": "796701",
      "Ralvawng B.O": "796691",
      "Sazaikawn B.O": "796701",
      "Sertlangpui B.O": "796701",
      "Zohnuai B.O": "796691",
      "Rangte B.O": "796701",
      "Zawlpui B.O": "796701",
      "Bualte B.O": "796701",
      "Buarpui B.O": "796701",
      "Chandmary B.O": "796701",
      "Thingfal B.O": "796701",
      "Thualthu B.O": "796701",
      "Vaisam B.O": "796701",
      "Vanhne B.O": "796701",
      "Zobawk B.O": "796701",
      "Phairuangkai B.O": "796701",
      "Hauruang B.O": "796701",
      "Kikawn B.O": "796701",
      "Lunglawn B.O": "796701",
      "Tawipui 'S' B.O": "796701",
      "Thenhlum B.O": "796701",
      "Bunghmun B.O": "796701",
      "Belthei B.O": "796701",
      "Lungrang 'S' B.O": "796701",
      "Rualalung B.O": "796701",
      "Lunglei S.O": "796701",
      "Zotlang S.O": "796691",
      "Bunghmun S.O": "796710",
      "Chawngte S.O": "796770",
      "Tlabung S.O": "796751"
    },
    "MAMIT": {
      "Hriphaw B.O": "796470",
      "Lushaicherra B.O": "796470",
      "Zamuang B.O": "796470",
      "Kanhmunbazar B.O": "796470",
      "Momcherra B.O": "796470",
      "Zawlnuam B.O": "796470",
      "Boraibazar B.O": "796470",
      "Dampui B.O": "796441",
      "Tlangkhang B.O": "796441",
      "N.Chhippui B.O": "796431",
      "Pukzing B.O": "796431",
      "Saithah B.O": "796431",
      "Silsury B.O": "796431",
      "Kanghmun B.O": "796501",
      "Hmunpui B.O": "796421",
      "Hnahva B.O": "796431",
      "Tuipuibari II B.O": "796431",
      "Ailawng B.O": "796501",
      "Kawrtethawveng B.O": "796441",
      "N.Sabual B.O": "796441",
      "Rengdil B.O": "796470",
      "Lallen B.O": "796431",
      "Marpara B.O": "796431",
      "Parvatui B.O": "796431",
      "Rulpuihlim B.O": "796501",
      "S.Sabual B.O": "796501",
      "Suarhliap B.O": "796081",
      "Chuhvel B.O": "796081",
      "Darlak B.O": "796441",
      "Serhmun B.O": "796441",
      "Tuidam B.O": "796441",
      "Damparengpui B.O": "796431",
      "Khawhnai B.O": "796431",
      "Phuldungsei B.O": "796431",
      "Tuipuibari B.O": "796431",
      "Darlung B.O": "796501",
      "Khawrihnim B.O": "796501",
      "Dapchhuah B.O": "796410",
      "Rawpuichhip B.O": "796410",
      "Lungdar 'W' B.O": "796501",
      "Mamit S.O": "796441",
      "Reiek S.O": "796501",
      "Zawlnuam S.O": "796471",
      "Phaileng S.O": "796431",
      "Kawrthah S.O": "796470"
    },
    "Hnahthial": {
      "Bualpui H B.O": "796571",
      "Chhipphir B.O": "796186",
      "Leite B.O": "796571",
      "Pangzawl B.O": "796571",
      "Rawpui B.O": "796571",
      "S.Vanlaiphai B.O": "796571",
      "Tarpho B.O": "796571",
      "Muallianpui B.O": "796571",
      "Thiltlang B.O": "796571",
      "Darzo B.O": "796571",
      "Lungleng 's' B.O": "796571",
      "Tuipui 'D' B.O": "796571",
      "Thingsai B.O": "796571",
      "Aithur B.O": "796571",
      "Chawngtui B.O": "796571",
      "Cherhlun B.O": "796571",
      "Thingsai S.O": "796581",
      "Hnahthial S.O": "796571"
    },
    "CHAMPHAI": {
      "Kelkang B.O": "796321",
      "Khawnuam B.O": "796321",
      "Khuangleng B.O": "796321",
      "Khuangphah B.O": "796321",
      "Murlen B.O": "796321",
      "N.Khawbung B.O": "796321",
      "Ngur B.O": "796321",
      "Zokhawthar B.O": "796321",
      "Chhawkhlei B.O": "796321",
      "Hnahlan B.O": "796321",
      "Lungphunlian B.O": "796321",
      "Maulkawi B.O": "796321",
      "Ruantlang B.O": "796321",
      "Tlangsam B.O": "796321",
      "Vapar B.O": "796321",
      "Zote 'e' B.O": "796321",
      "Hmunhmeltha B.O": "796321",
      "Hruaikawn B.O": "796321",
      "Leisenzo B.O": "796321",
      "Sesih B.O": "796321",
      "Tualcheng B.O": "796321",
      "Vengthlang B.O": "796321",
      "Bethel B.O": "796321",
      "Leithum B.O": "796320",
      "Muallung B.O": "796320",
      "Samthang B.O": "796320",
      "Sazep B.O": "796320",
      "Selam B.O": "796290",
      "Vaikhawtlang B.O": "796321",
      "Bungzung B.O": "796320",
      "Farkawn B.O": "796320",
      "Vanzau B.O": "796320",
      "Dilkawn B.O": "796321",
      "Dungtlang B.O": "796320",
      "Khuangthing B.O": "796320",
      "Vangchhia B.O": "796320",
      "Vaphai B.O": "796320",
      "S.Khawbung S.O": "796320",
      "Champhai S.O": "796321"
    },
    "LAWNGTLAI": {
      "Udalthana B.O": "796770",
      "LawngtlB.O": "796770",
      "Balhlakawn B.O": "796891",
      "Bungtlang 'S' B.O": "796891",
      "Kawlchaw 'W' B.O": "796891",
      "Mualbukawn B.O": "796891",
      "Ngengpuikai B.O": "796891",
      "Vaseitlang B.O": "796891",
      "Diltlang B.O": "796891",
      "Karlui B.O": "796891",
      "Parva B.O": "796891",
      "Rulkual B.O": "796891",
      "Sabualtlang B.O": "796891",
      "Tuisentlang B.O": "796891",
      "Fungkah B.O": "796901",
      "Lungpher 'S' B.O": "796901",
      "Tuipuiferry B.O": "796901",
      "Vawmbuk B.O": "796901",
      "Mampui B.O": "796891",
      "Sangau B.O": "796901",
      "Chamdur B.O": "796891",
      "New Jagnasury B.O": "796891",
      "Paithar B.O": "796891",
      "Tuithumhnar B.O": "796891",
      "Vathuampui B.O": "796891",
      "Bualpui 'ng' B.O": "796901",
      "Rawmibawk B.O": "796901",
      "Pangkhua B.O": "796901",
      "Sangau S.O": "796810",
      "Kamalanagar S.O (Lawngtlai)": "796772",
      "Lawngtlai S.O": "796891"
    },
    "KHAWZAWL": {
      "Aiduzawl B.O": "796261",
      "Biate B.O": "796370",
      "Lungtan B.O": "796310",
      "Neihdawn B.O": "796310",
      "Vanchengpui B.O": "796310",
      "Ngaizawl B.O": "796310",
      "Puilo B.O": "796310",
      "Riangtlei B.O": "796310",
      "Tualpui B.O": "796310",
      "Chawngtlai B.O": "796310",
      "Chhawrtui B.O": "796310",
      "Dulte B.O": "796310",
      "Kawlkulh B.O": "796310",
      "Vangtlang B.O": "796310",
      "Chalrang B.O": "796310",
      "Khawhai B.O": "796310",
      "N.Chalrang B.O": "796310",
      "Tualte B.O": "796310",
      "Khawzawl S.O": "796310"
    },
    "SAIHA": {
      "Lungbun B.O": "796901",
      "Tuipang B.O": "796901",
      "New Maubawk B.O": "796901",
      "Tongkolong B.O": "796901",
      "Khopai B.O": "796901",
      "Laki B.O": "796901",
      "Serkawr B.O": "796901",
      "Tuisih B.O": "796901",
      "Chapui B.O": "796901",
      "Chhuarlung B.O": "796901",
      "Siata B.O": "796901",
      "Latawh B.O": "796901",
      "Lawngban B.O": "796901",
      "Vahai B.O": "796901",
      "Chakhang B.O": "796901",
      "Niawhtlang B.O": "796901",
      "Theiva B.O": "796901",
      "Lungtian B.O": "796901",
      "Cheural B.O": "796901",
      "Phura B.O": "796901",
      "Zawngling B.O": "796901",
      "Saiha S.O": "796901"
    }
  },
  "LADAKH": {
    "LEH LADAKH": {
      "Durbuk B.O": "194101",
      "Spituk B.O": "194101",
      "CHUCHOT SHAMMA B.O": "194104",
      "Ney B.O": "194107",
      "Saboo B.O": "194104",
      "Terchey B.O": "194401",
      "Tiger Sumur B.O": "194401",
      "CHUCHOT YOKMA B.O": "194104",
      "MATHOO B.O": "194104",
      "STOK B.O": "194104",
      "Horzey B.O": "194101",
      "Khardong B.O": "194401",
      "Kubat B.O": "194401",
      "BOGDANG B.O": "194401",
      "BASGO B.O": "194107",
      "Faing B.O": "194101",
      "Panamik B.O": "194401",
      "Turtuk B.O": "194401",
      "Chuchul B.O": "194101",
      "NIMOO B.O": "194107",
      "Chuchot Gongma B.O": "194104",
      "Hunder B.O": "194401",
      "Hemis Shukpacahan B.O": "194106",
      "LIKIR B.O": "194107",
      "Skurbuchan B.O": "194106",
      "Temisgam B.O": "194106",
      "Nurla B.O": "194106",
      "Takmachik B.O": "194106",
      "Tia B.O": "194106",
      "Chumathang B.O": "194202",
      "Hemis Changa B.O": "194201",
      "Kairy B.O": "194202",
      "Kungyam B.O": "194202",
      "Sakti B.O": "194201",
      "Alchi B.O": "194107",
      "Biama B.O": "194106",
      "Dumkhar B.O": "194106",
      "Hanoo B.O": "194106",
      "Lamayuru B.O": "194106",
      "Shara B.O": "194201",
      "Shey B.O": "194201",
      "Wanla B.O": "194106",
      "Chamray B.O": "194201",
      "Gia Meru B.O": "194201",
      "Hemiya B.O": "194202",
      "Igoo B.O": "194201",
      "Karoo B.O": "194201",
      "Leh H.O": "194101",
      "Chuglamsar S.O": "194104",
      "Saspol S.O": "194402",
      "Thiksay S.O": "194201",
      "NYOMA MUD": "194202",
      "Leh City S.O": "194101",
      "Diskit S.O": "194401",
      "Khalsi S.O": "194106",
      "Nyoma Mud S.O": "194404",
      "SASPOL S.O": "194107"
    },
    "KARGIL": {
      "SALISKOT B.O": "194103",
      "TAMBIS B.O": "194103",
      "Chokiyal B.O": "194102",
      "Matayan B.O": "194102",
      "Mushkoo B.O": "194102",
      "Pandrass B.O": "194102",
      "CHOSKORE B.O": "194103",
      "Bazgo B.O": "194105",
      "MINJI B.O": "194103",
      "Trespone B.O": "194103",
      "Bhimbat B.O": "194102",
      "Batalik B.O": "194103",
      "Garkon B.O": "194103",
      "Silmoh B.O": "194103",
      "Tumail Colony B.O": "194103",
      "Bodhkharboo B.O": "194109",
      "Karamba B.O": "194109",
      "KHANGRAL B.O": "194109",
      "Zangla B.O": "194302",
      "Barsoo B.O": "194301",
      "Lankarchey B.O": "194301",
      "PURTAKCHEY B.O": "194303",
      "Yuljuk B.O": "194303",
      "Akchamal B.O": "194103",
      "Chanigund B.O": "194103",
      "Yurbaltik B.O": "194103",
      "Lochum B.O": "194109",
      "Wakha B.O": "194109",
      "Karsha B.O": "194302",
      "Tikat B.O": "194301",
      "Hardas B.O": "194103",
      "Shaimshakharboo B.O": "194103",
      "Tumail B.O": "194103",
      "Chiktan B.O": "194109",
      "Shargol B.O": "194109",
      "Tache B.O": "194109",
      "CHA LUNGNAK B.O": "194302",
      "Khasgam Thuina B.O": "194301",
      "Namsuru B.O": "194303",
      "Sangra B.O": "194301",
      "Karkitchoo B.O": "194103",
      "Pashkum B.O": "194103",
      "Thasgam B.O": "194103",
      "Safi B.O": "194109",
      "Samray B.O": "194109",
      "Shakar B.O": "194109",
      "Omba B.O": "194301",
      "Parkachik B.O": "194303",
      "Baroo S.O": "194105",
      "Padum S.O": "194302",
      "Drass S.O": "194102",
      "Panikhar S.O": "194303",
      "Kargil S.O": "194103",
      "Mulbek S.O": "194109",
      "Sankoo S.O": "194301"
    }
  },
  "NAGALAND": {
    "DIMAPUR": {
      "Daroga Pathar B.O": "797115",
      "Diphupar B.O": "797115",
      "Aoyimti B.O": "797115",
      "Sukhovi B.O": "797115",
      "Sugar Mill Project B.O": "797115",
      "Eralibill B.O": "797115",
      "Showba Old B.O": "797115",
      "Ikishe B.O": "797115",
      "Agri College B.O": "797106",
      "Nihekhu B.O": "797103",
      "Rangapahar B.O": "797118",
      "Zeliangrong B.O": "797117",
      "Khehekhu B.O": "797116",
      "Singrijan B.O": "797112",
      "Pwd Colony B.O": "797117",
      "Thahekhu B.O": "797118",
      "Kushiabill B.O": "797116",
      "Padampukhuri B.O": "797116",
      "Vihokhu B.O": "797116",
      "Kuda B.O": "797112",
      "Nuiland B.O": "797112",
      "P C College B.O": "797103",
      "Pimla B.O": "797103",
      "Khermahal B.O": "797112",
      "Seluophe BO": "797112",
      "Khopoanaula B.O": "797103",
      "Tenyiphe B.O": "797103",
      "Singal Village B.O": "797117",
      "Kuhuboto B.O": "797116",
      "Doyapur B.O": "797112",
      "Phaipijan B.O": "797112",
      "Industrial Estate B.O": "797113",
      "Lengrijan B.O": "797113",
      "Nst Colony B.O": "797113",
      "D.C Complex B.O": "797113",
      "Piphima B.O": "797106",
      "Sirhima B.O": "797106",
      "Jharnapani B.O": "797106",
      "Pherima B.O": "797106",
      "Duncan Basti B.O": "797113",
      "Khaibung B.O": "797106",
      "Razaphema B.O": "797106",
      "Artc S.O": "797115",
      "Dimapur S.O": "797112",
      "Medziphema S.O": "797106",
      "Chumukedima S.O": "797103",
      "New Nepaligaon S.O": "797113",
      "Dimapur Bazar S.O": "797116",
      "Signal Village": "797118",
      "Circular Road S.O": "797117"
    },
    "MOKOKCHUNG": {
      "Merangkong B.O": "798618",
      "Phangsang B.O": "798614",
      "Yaongyimsen B.O": "798613",
      "Mongsenyimti B.O": "798614",
      "Salulamang B.O": "798614",
      "Ungar B.O": "798614",
      "Longchang B.O": "798615",
      "Sungratsu B.O": "798615",
      "Longkong B.O": "798614",
      "Yisemyong B.O": "798614",
      "Kubulong B.O": "798615",
      "Alungkima B.O": "798604",
      "Longnak B.O": "798604",
      "Mongchen B.O": "798604",
      "Luyang Valley B.O": "798618",
      "Molungkhimong B.O": "798618",
      "Molungyimsen B.O": "798618",
      "Kubza B.O": "798601",
      "Longmisa B.O": "798601",
      "Ongpangkong B.O": "798601",
      "Alungtaki B.O": "798604",
      "Longchem B.O": "798604",
      "Khensa B.O": "798601",
      "Asangma B.O": "798618",
      "Tamlu B.O": "798618",
      "Changki B.O": "798601",
      "Chungtia B.O": "798601",
      "Fazl Ali College B.O": "798601",
      "Longsa B.O": "798601",
      "Mangmentong B.O": "798601",
      "Nst Colony B.O": "798601",
      "S. E. Colony B.O": "798601",
      "Waromung B.O": "798604",
      "Aolijen B.O": "798601",
      "Longkhum B.O": "798601",
      "Ungma B.O": "798601",
      "Chungtia Yimsen B.O": "798604",
      "Khari B.O": "798604",
      "Barakangtsung B.O": "798618",
      "Wamaken B.O": "798618",
      "Mokokchung S.O": "798601",
      "Paper Nagar S.O": "798623",
      "Impur S.O": "798615",
      "Chantongia S.O": "798613",
      "Alichen S.O": "798607",
      "Chuchuyimlang S.O": "798614",
      "Mongkholemba S.O": "798604",
      "Tuli S.O": "798618"
    },
    "ZUNHEBOTO": {
      "Mishilimi B.O": "797105",
      "Akuhaito B.O": "798620",
      "Aizuto B.O": "798627",
      "Asukuto B.O": "798620",
      "Kilomi B.O": "797104",
      "Akuluto B.O": "798627",
      "Suruhuto B.O": "798620",
      "Surumi B.O": "798620",
      "Tokiye B.O": "798620",
      "V. K. Town B.O": "798601",
      "Pughoboto B.O": "797109",
      "Aghunato B.O": "798620",
      "Kichilimi B.O": "798620",
      "Saghemi B.O": "798620",
      "Satoi B.O": "798620",
      "Ghathashi B.O": "797109",
      "Lazami B.O": "797109",
      "Asukhomi B.O": "798620",
      "Asuto B.O": "798620",
      "Atoizu B.O": "798620",
      "Hosephu B.O": "798620",
      "Satakha B.O": "798620",
      "Satami B.O": "798620",
      "Lumami S.O": "798627",
      "Zunheboto S.O": "798620"
    },
    "KOHIMA": {
      "Botsa B.O": "797105",
      "Tuophema B.O": "797105",
      "Chiephobozou B.O": "797105",
      "Zhadima B.O": "797105",
      "Dihoma B.O": "797003",
      "Rusoma B.O": "797003",
      "Kidima B.O": "797006",
      "Kizocha B.O": "797003",
      "Khuzama B.O": "797006",
      "Mezoma B.O": "797002",
      "Jotsoma B.O": "797002",
      "Chakhabama B.O": "797003",
      "Lalmati B.O": "797120",
      "Mima B.O": "797006",
      "Phesama B.O": "797120",
      "Viswema B.O": "797006",
      "Chedema B.O": "797003",
      "Ciesema B.O": "797003",
      "Kigwema B.O": "797006",
      "Zubza B.O": "797120",
      "Khonoma B.O": "797002",
      "Thizama B.O": "797004",
      "Nisenyu B.O": "797109",
      "Chatashi B.O": "797109",
      "Phenshunyu B.O": "797109",
      "Tesophenyu B.O": "797109",
      "Tseminyu Old Town B.O": "797109",
      "Tsosesunyu B.O": "797109",
      "Zephenyu B.O": "797109",
      "Meriema B.O": "797004",
      "Asukika B.O": "797109",
      "Kandinu B.O": "797109",
      "Ehunnu B.O": "797109",
      "Phenwhenyu B.O": "797109",
      "Sendenyu B.O": "797109",
      "Kohima H.O": "797001",
      "New Sectt Complex S.O": "797004",
      "Jakhama S.O": "797006",
      "Chiechama S.O": "797105",
      "P.R.Hill S.O": "797120",
      "Kohima Science College S.O": "797002",
      "High School Junction S.O": "797121",
      "Kohima Village S.O": "797003",
      "Tseminyu S.O": "797109"
    },
    "MON": {
      "Tobu B.O": "798603",
      "Ukha B.O": "798603",
      "Angphang B.O": "798603",
      "Monyakshu B.O": "798603",
      "Chenloisho B.O": "798603",
      "Longching B.O": "798603",
      "Pessao B.O": "798603",
      "Chenwetnyu B.O": "798603",
      "Chingkao B.O": "798603",
      "Chinglong B.O": "798603",
      "Jakpang B.O": "798603",
      "Pongkong B.O": "798621",
      "Kongon B.O": "798622",
      "Wakching B.O": "798621",
      "Zaboka B.O": "798602",
      "Zangkham B.O": "798602",
      "Longpong Senghe B.O": "798621",
      "Totak B.O": "798621",
      "Baranamsang B.O": "798622",
      "Namsa B.O": "798602",
      "Yannu B.O": "798602",
      "Chui B.O": "798621",
      "Longwa B.O": "798621",
      "Singha Chingnyu B.O": "798621",
      "Tang B.O": "798621",
      "Waunching B.O": "798621",
      "Naginimora S.O": "798622",
      "Mon S.O": "798621",
      "Champang S.O": "798603",
      "Tizit S.O": "798602"
    },
    "PHEK": {
      "Middle Khomi B.O": "797108",
      "Chetheba B.O": "797104",
      "Yoribami B.O": "797104",
      "Chizami Village B.O": "797107",
      "Thechulumi B.O": "797107",
      "Dzulhami B.O": "797104",
      "Thevopesumi B.O": "797104",
      "Phugwu B.O": "797104",
      "Runguzumi B.O": "797104",
      "Tekhouba B.O": "797107",
      "Thipuzumi B.O": "797107",
      "Zuketsa B.O": "797107",
      "Zhamai B.O": "797107",
      "Ketsapo B.O": "797108",
      "Khuzami B.O": "797108",
      "Lozaphema B.O": "797108",
      "Mesolumi B.O": "797107",
      "Porba B.O": "797107",
      "Old Phek B.O": "797108",
      "Khezhakeno B.O": "797107",
      "Kikruma B.O": "797107",
      "Phesachuduma B.O": "797107",
      "Chizami Town B.O": "797107",
      "Akhegwo B.O": "797114",
      "Hutsu B.O": "797114",
      "Lephori B.O": "797114",
      "Pungkhuri B.O": "797114",
      "Wazhiho B.O": "797114",
      "Sakraba B.O": "797107",
      "Zhavame B.O": "797107",
      "Losami B.O": "797108",
      "Chozuba S.O": "797104",
      "Pfutsero S.O": "797107",
      "Meluri S.O": "797114",
      "Phek S.O": "797108"
    },
    "LONGLENG": {
      "Sakchi B.O": "798625",
      "Phomching B.O": "798625",
      "Yachem B.O": "798625",
      "Hukpang B.O": "798625",
      "Nian B.O": "798625",
      "Yongyah B.O": "798625",
      "Bhumnyu BO": "798625",
      "Longleng S.O": "798625"
    },
    "TUENSANG": {
      "Yangpi B.O": "798612",
      "Noksen B.O": "798612",
      "Yangli B.O": "798616",
      "Angangba B.O": "798616",
      "Chimonger B.O": "798616",
      "Chungtore B.O": "798616",
      "Chare B.O": "798601",
      "Tronger B.O": "798601",
      "Huker B.O": "798612",
      "Kuthur B.O": "798612",
      "Sangsanyu B.O": "798612",
      "Shiponger B.O": "798612",
      "Sotokur B.O": "798612",
      "Tuensang Village B.O": "798612",
      "Chessore B.O": "798612",
      "Shamator B.O": "798612",
      "Saramati B.O": "798612",
      "Shampur B.O": "798612",
      "Longkhim S.O": "798616",
      "Tuensang S.O": "798612"
    },
    "WOKHA": {
      "Ralan B.O": "797112",
      "Pangti B.O": "797111",
      "Sungro B.O": "797111",
      "Yamhon B.O": "797111",
      "Yampha B.O": "797112",
      "Aitepyong B.O": "797111",
      "Longtsung B.O": "797111",
      "Lotsu B.O": "797111",
      "Moilan B.O": "797111",
      "Nyiro B.O": "797111",
      "Sanis B.O": "797111",
      "Arree Old B.O": "798601",
      "Englan B.O": "797111",
      "Mekhukla B.O": "797111",
      "Doyang B.O": "797111",
      "Baghty B.O": "797111",
      "Bhandari B.O": "797111",
      "Chukitong B.O": "797111",
      "Elumnyu B.O": "797111",
      "N. Longidong B.O": "797111",
      "Wokha Village B.O": "797111",
      "Wozhru B.O": "797111",
      "Pongitong B.O": "797111",
      "Tsungtsutong B.O": "797111",
      "Humtsu B.O": "797111",
      "Yikhum B.O": "797111",
      "Wokha S.O": "797111",
      "Bhandari S.O": "797099"
    },
    "KIPHIRE": {
      "Amahatore B.O": "798611",
      "Phalonger B.O": "798611",
      "Pungro B.O": "798611",
      "Sitimi B.O": "798611",
      "Anatongere B.O": "798611",
      "Kisethong B.O": "798611",
      "Longmatra B.O": "798611",
      "Moya B.O": "798611",
      "Sikur B.O": "798611",
      "Singrup B.O": "798611",
      "Pokhpur B.O": "798611",
      "Seyochang B.O": "798611",
      "Phisami B.O": "798611",
      "Kiphire S.O": "798611"
    },
    "PEREN": {
      "Hening Kunglwa B.O": "797112",
      "Jalukiekam B.O": "797112",
      "Mhaikam B.O": "797103",
      "Poilwa B.O": "797002",
      "Mbaulwa B.O": "797101",
      "Gaili B.O": "797110",
      "Samjiuram B.O": "797110",
      "Bongkholong B.O": "797110",
      "Khelma B.O": "797110",
      "N.Song B.O": "797101",
      "Nchongram B.O": "797101",
      "Tening B.O": "797101",
      "Mhainamtsi B.O": "797110",
      "New Jalukie B.O": "797110",
      "Punglwa B.O": "797106",
      "Maova B.O": "797106",
      "Athibung B.O": "797110",
      "Jalukie 'B' B.O": "797110",
      "Lilen B.O": "797110",
      "Molvom B.O": "797106",
      "Zalukie S.O": "797110",
      "Peren S.O": "797101"
    },
    "Noklak": {
      "Noklak B.O": "798612",
      "Nokhu B.O": "798612",
      "Pangsha B.O": "798612",
      "Pessu B.O": "798612",
      "Panso B.O": "798612",
      "Choklangan B.O": "798612",
      "Sanglao B.O": "798612",
      "Chingmei B.O": "798612",
      "Thonokhunyu B.O": "798612"
    }
  },
  "TRIPURA": {
    "South Tripura": {
      "Dakshin Manubankul B.O": "799143",
      "Baishnabpur B.O": "799145",
      "Bijoynagar B.O": "799145",
      "Chalitacherra B.O": "799145",
      "Doulbari B.O": "799145",
      "Lowgang B.O": "799144",
      "Manpather B.O": "799144",
      "Amlighat B.O": "799143",
      "Magurcherra B.O": "799143",
      "Rangamura B.O": "799153",
      "Harina Bazar B.O": "799145",
      "Kathalcherri B.O": "799145",
      "East Bagafa B.O": "799144",
      "Kathaliacherra B.O": "799144",
      "Uttar Debipur B.O": "799144",
      "Guachand B.O": "799143",
      "Satchand B.O": "799143",
      "Sindukpathar B.O": "799143",
      "Srinagar B.O": "799143",
      "Kasari B.O": "799150",
      "Harbatali B.O": "799145",
      "Jalefa Bazar B.O": "799145",
      "Ludhua B.O": "799145",
      "Ludhua Tea Estate B.O": "799145",
      "Kanchannagar B.O": "799144",
      "Laxmicherra B.O": "799144",
      "Bhuratali B.O": "799143",
      "Bishnupur B.O": "799143",
      "Dakshin Fulcherri B.O": "799143",
      "Poangbari B.O": "799143",
      "Charakbai B.O": "799142",
      "Muhuri Ratanpur B.O": "799142",
      "Rupaicherri B.O": "799145",
      "Sonaicherri B.O": "799145",
      "Bagafa B.O": "799144",
      "Baikhora B.O": "799144",
      "Betaga B.O": "799144",
      "Purba Manu B.O": "799144",
      "Radhakishoreganj B.O": "799144",
      "Urrat Takmacherra B.O": "799144",
      "Gouranga Bazar B.O": "799157",
      "Gabtali B.O": "799157",
      "Siddhinagar B.O": "799157",
      "Barpathari B.O": "799155",
      "Paschim Pipariakhola B.O": "799155",
      "South Bharat Ch.Nagar B.O": "799155",
      "Takmacherra B.O": "799125",
      "Nalua B.O": "799156",
      "South Krishnagar B.O": "799156",
      "Madhya Pillak B.O": "799141",
      "Sakbari B.O": "799141",
      "Paikhola B.O": "799125",
      "Samarendraganj B.O": "799156",
      "Paschim Pillak B.O": "799141",
      "Thakurcherra B.O": "799141",
      "Dimatali B.O": "799157",
      "Puran Rajbari B.O": "799157",
      "Abhoyganj Bazar B.O": "799155",
      "Baspadua B.O": "799155",
      "Belonia aerodrome B.O": "799155",
      "Matai B.O": "799155",
      "Sarasima B.O": "799155",
      "Madhabnagar B.O": "799156",
      "Debdaru Bazar B.O": "799141",
      "Kwaifung B.O": "799141",
      "South srirampur B.O": "799157",
      "Chittamara B.O": "799155",
      "Dakshin Sonaicharri B.O": "799155",
      "Debipur B.O": "799155",
      "Subashnagar B.O": "799155",
      "Uttar Bharat Ch Nagar B.O": "799155",
      "Uttar Sonaicherri B.O": "799155",
      "Rajapur B.O": "799125",
      "Dakshin Hichacherri B.O": "799141",
      "Kalashi Bazar B.O": "799141",
      "Chottakhola B.O": "799157",
      "Manubazar S.O": "799143",
      "Radhanagar S.O (West Tripura)": "799153",
      "Beloniya S.O": "799155",
      "Hrishyamukh S.O": "799156",
      "Jolaibari S.O": "799141",
      "Muhuripur S.O": "799142",
      "Sabroom S.O": "799145",
      "Anandapur S.O (South Tripura)": "799157",
      "Rajnagar S.O (South Tripura)": "799150",
      "Santirbazar S.O": "799144"
    },
    "Sepahijala": {
      "Kemtali B.O": "799115",
      "Khas Chowmouhani B.O": "799115",
      "Lakshmandhepa B.O": "799115",
      "West Nalchar B.O": "799115",
      "Kamalnagar B.O": "799131",
      "Kathalia B.O": "799131",
      "Khedabari B.O": "799131",
      "Battali B.O": "799115",
      "Chowmouhani B.O": "799115",
      "Rudijala B.O": "799115",
      "Telkajla B.O": "799115",
      "Induria B.O": "799131",
      "Kalikrishnagar B.O": "799132",
      "Chandigarh B.O": "799115",
      "Durlavnarayan B.O": "799115",
      "Jumerdhepa B.O": "799115",
      "Nalchar B.O": "799115",
      "Urmai B.O": "799115",
      "Durgapur B.O": "799131",
      "Jatrapur B.O": "799132",
      "Manaipathar B.O": "799132",
      "Nidaya BO": "799131",
      "Matinagar B.O": "799131",
      "Nirvoypur B.O": "799132",
      "Taibandal B.O": "799105",
      "Bagabassa B.O": "799115",
      "Bardwal B.O": "799115",
      "Bejimara B.O": "799131",
      "Bhabanipur B.O": "799132",
      "Dhanpur B.O": "799131",
      "Kulubari B.O": "799131",
      "Maheshpur B.O": "799132",
      "Rabindranagar Colony B.O": "799131",
      "Charilam B.O": "799103",
      "Latiacherra B.O": "799103",
      "Promodenagar B.O": "799103",
      "Rangamala Bazar B.O": "799103",
      "Kamrangatali B.O": "799105",
      "Mohanbhog B.O": "799105",
      "Bagmara B.O": "799103",
      "Barjala B.O": "799103",
      "Padmanagar B.O": "799103",
      "Pathaliaghat B.O": "799103",
      "Ramnagar Bazar B.O": "799103",
      "Chechrimile B.O": "799103",
      "Goliraibari B.O": "799103",
      "South Charilam B.O": "799103",
      "Amarendranagar B.O": "799103",
      "Tekshapara B.O": "799103",
      "Chandul B.O": "799105",
      "Jampuijala Colony B.O": "799011",
      "Kaiyadhepa B.O": "799102",
      "Madhupur B.O": "799102",
      "Brajapur B.O": "799102",
      "Kamalasagar B.O": "799102",
      "Konabon B.O": "799102",
      "Nabinagar B.O": "799102",
      "Golaghati B.O": "799102",
      "Harishnagar T.E. B.O": "799102",
      "Jampuijala B.O": "799102",
      "Kalasimura B.O": "799102",
      "Kalkalia B.O": "799102",
      "Krishnakishorenagar B.O": "799102",
      "Lalsingmura B.O": "799102",
      "Nabasantiganj Bazar B.O": "799102",
      "Dhanirampur B.O": "799131",
      "Kanakraipara B.O": "799102",
      "Takarjala B.O": "799102",
      "Sankumabari B.O": "799102",
      "Boxonagar B.O": "799102",
      "Dhajanagar B.O": "799102",
      "Gazaria B.O": "799102",
      "Kalamcherra B.O": "799102",
      "Kendraicherra B.O": "799011",
      "Purba Laxmi Bill B.O": "799102",
      "Putia B.O": "799102",
      "Rohimpur B.O": "799102",
      "Rokhia G.T Project B.O": "799102",
      "Sepahijala B.O": "799102",
      "South Nehalchandranagar B.O": "799102",
      "Sutarmura B.O": "799102",
      "Purathalrajnagar B.O": "799102",
      "Veluarchar B.O": "799102",
      "Paschim Gokulnagar B.O": "799130",
      "Ujan Ghaniamara B.O": "799102",
      "No.2 Chandranagar B.O": "799102",
      "Purba Gokulnagar B.O": "799102",
      "West Laxmibill B.O": "799102",
      "Bishalgarh S.O": "799102",
      "Jampuijala SO": "799011",
      "Bishramganj S.O": "799103",
      "Melaghar S.O": "799115",
      "Sonamura S.O": "799131",
      "Kathalia S.O": "799132"
    },
    "Gomati": {
      "Samukcherra B.O": "799105",
      "Dakshin Maharani B.O": "799013",
      "Fulkumari B.O": "799013",
      "Holakhet B.O": "799013",
      "Upendranagar B.O": "799105",
      "Abani Reangpara B.O": "799013",
      "Dakshin Chandrapur B.O": "799013",
      "Jamjuri B.O": "799013",
      "Lakshipati B.O": "799013",
      "Murapara B.O": "799013",
      "Joalikhamar B.O": "799013",
      "Maharani B.O": "799013",
      "Bagma ED B.O": "799113",
      "Silghati B.O": "799105",
      "Debbari B.O": "799101",
      "Dhanlekha B.O": "799101",
      "Taidubari B.O": "799101",
      "Garjanmura B.O": "799113",
      "Khilpara B.O": "799114",
      "Raiyabari B.O": "799114",
      "Kalabon B.O": "799125",
      "Paschim Paticherri Colony B.O": "799125",
      "Lebacherra B.O": "799104",
      "Paticherri B.O": "799104",
      "Purba Manikya Dewan B.O": "799104",
      "East Mirza B.O": "799105",
      "Jitendranagar B.O": "799105",
      "Kishoreganj B.O": "799105",
      "Rani B.O": "799105",
      "Gamakubari B.O": "799101",
      "Paharpur B.O": "799101",
      "Palku B.O": "799101",
      "Bagma B.O": "799113",
      "Killarbazar B.O": "799114",
      "Pitra Bazar B.O": "799114",
      "Rajnagar Colony B.O": "799114",
      "Uttar Brojendranagar B.O": "799114",
      "Gangacherra B.O": "799125",
      "Jalaya B.O": "799104",
      "Dhuptali B.O": "799105",
      "Hadra B.O": "799105",
      "Kusumara B.O": "799105",
      "Palatana B.O": "799105",
      "Kurma B.O": "799101",
      "Nagrai B.O": "799101",
      "Rangamati B.O": "799101",
      "East Bagabassa B.O": "799113",
      "Kupilong B.O": "799113",
      "Manikya B.O": "799114",
      "Rajarbag B.O": "799114",
      "Salgarah B.O": "799114",
      "Tainani B.O": "799125",
      "Ghorakappa B.O": "799104",
      "Karbook B.O": "799104",
      "Suknacherri B.O": "799104",
      "Uttar Chellagonj B.O": "799104",
      "Ichacherra B.O": "799105",
      "Mogpuskarini B.O": "799105",
      "Paschim Mogpuskarini B.O": "799105",
      "Mahuamillan B.O": "799101",
      "Malbassa B.O": "799101",
      "Rangkhang B.O": "799101",
      "Sarbong B.O": "799101",
      "Thelakum B.O": "799114",
      "Barbil B.O": "799104",
      "Dumburnagar B.O": "799104",
      "Silacharri B.O": "799104",
      "Tirthamukh B.O": "799104",
      "Tuichama B.O": "799104",
      "Bazar Amtali B.O": "799105",
      "Bampur B.O": "799101",
      "Chellagong B.O": "799101",
      "Dakshin taidu B.O": "799101",
      "Ampinagar B.O": "799101",
      "Chechuajamatiabari B.O": "799101",
      "Radhakishorepur H.O": "799120",
      "Matabari S.O": "799013",
      "Tepania S.O": "799113",
      "Jatanbari S.O": "799104",
      "Gakulpur S.O": "799114",
      "Amarpur S.O (South Tripura)": "799101",
      "Garjee S.O": "799125",
      "Kakraban S.O": "799105"
    },
    "Dhalai": {
      "Raima B.O": "799104",
      "Boalkhali B.O": "799104",
      "Abhanga B.O": "799286",
      "Apareshkar B.O": "799286",
      "Katalutma B.O": "799286",
      "Karamcherra B.O": "799266",
      "West Nalkata B.O": "799266",
      "Betcherra B.O": "799266",
      "Purba Betcherra B.O": "799266",
      "Mahavir T.E. B.O": "799286",
      "Jamthing B.O": "799286",
      "Baralutma B.O": "799286",
      "Chengkap B.O": "799286",
      "Bagaicherri B.O": "799285",
      "Noagoan B.O": "799285",
      "Dhumacherra B.O": "799275",
      "Mainerma B.O": "799275",
      "Sindhukumarpara B.O": "799275",
      "Mechuria B.O": "799278",
      "Paschim Dalucherra B.O": "799278",
      "Ranipukur B.O": "799284",
      "Baligaon B.O": "799285",
      "Ramdurlavpur B.O": "799285",
      "Singibill B.O": "799285",
      "Balarambazar B.O": "799204",
      "Srirampur Lambucherra B.O": "799287",
      "Demchedrra Colony B.O": "799275",
      "Maslicherra B.O": "799275",
      "Maharani Bus Stop B.O": "799278",
      "Mendihaor B.O": "799278",
      "Laxmipur B.O": "799284",
      "Ganganagar Tribalcolony B.O": "799289",
      "Kamalacherra B.O": "799289",
      "Lakraichowdhuripara B.O": "799289",
      "Bindulal Karbaripara B.O": "799273",
      "Nalicherra B.O": "799204",
      "Kachucherra B.O": "799278",
      "Bhagirathpara B.O": "799284",
      "Bullongbassa B.O": "799284",
      "Dalapatipara B.O": "799284",
      "Durgacherra B.O": "799273",
      "Laldingabari B.O": "799273",
      "Manikpur B.O": "799273",
      "Durga Chowmuhani BO": "799286",
      "Chotosarma B.O": "799285",
      "Fulcherri B.O": "799285",
      "Garodtilla B.O": "799285",
      "Kamalpur Bazar B.O": "799285",
      "Maracherra B.O": "799285",
      "Kamalpur Aerodrome B.O": "799287",
      "Kuchainala B.O": "799287",
      "Nagbangshi B.O": "799287",
      "East Masli B.O": "799275",
      "Jamircherra B.O": "799275",
      "Karatichesdrra B.O": "799275",
      "Longtharai B.O": "799275",
      "Jagabandhu Para B.O": "799284",
      "Chandraipara B.O": "799289",
      "Harincherra B.O": "799289",
      "Kanchanpur Colony B.O": "799289",
      "Karnamunipara B.O": "799289",
      "Sikaribari B.O": "799289",
      "Chawmanu B.O": "799273",
      "Natinmanu B.O": "799273",
      "Ambassa S.O": "799289",
      "Chailengta S.O": "799273",
      "Kamalpur S.O (Dhalai)": "799285",
      "Manikbhander S.O": "799287",
      "Manughat S.O": "799275",
      "Salema S.O": "799278",
      "Sarma S.O": "799284",
      "Halahali S.O": "799286",
      "Kulaibazar S.O": "799204",
      "Kanchancherra": "799266"
    },
    "North Tripura": {
      "Sonarurbassa B.O": "799251",
      "Thana Road B.O": "799251",
      "Anandabazar B.O": "799271",
      "Piplacherra B.O": "799256",
      "Nayapara N.D B.O": "799251",
      "Paschimchandrapur B.O": "799251",
      "Fulbari B.O": "799262",
      "Sanicherra B.O": "799262",
      "Garchirampara B.O": "799271",
      "Sakhan Serhmun B.O": "799271",
      "Tuichama B.O": "799271",
      "Gobindapur B.O": "799251",
      "Huruah B.O": "799251",
      "Ichailalcherra B.O": "799251",
      "Ichaisonapur B.O": "799251",
      "Raghna B.O": "799251",
      "Sakaibari B.O": "799251",
      "Barhaldi B.O": "799271",
      "Kalacherra B.O": "799251",
      "Pratyekroy B.O": "799251",
      "Balicherra B.O": "799262",
      "Kheranjuri B.O": "799262",
      "Kalapania B.O": "799271",
      "Sabual B.O": "799269",
      "Sailo B.O": "799269",
      "Tlangsang B.O": "799269",
      "Brajendranagar B.O": "799261",
      "Kalagangar Par B.O": "799261",
      "Ranibari B.O": "799261",
      "Sarala B.O": "799261",
      "Tarakpur B.O": "799261",
      "Jubarajnagar B.O": "799254",
      "Kalagong B.O": "799269",
      "Phuldengsai B.O": "799269",
      "Pearacherra B.O": "799261",
      "Premtala B.O": "799261",
      "Suknacherra B.O": "799270",
      "Agnipassa B.O": "799260",
      "Deocherra B.O": "799260",
      "Juri R.F B.O": "799260",
      "Rahumcherra B.O": "799260",
      "Tilthai Nutanbazar B.O": "799260",
      "Bagbassa B.O": "799253",
      "Lalcherra Colony B.O": "799253",
      "Kacharicherra B.O": "799256",
      "Baithangbari B.O": "799254",
      "Dewanpassa B.O": "799254",
      "Rajnagar Laxmipur B.O": "799254",
      "Hmunpui B.O": "799269",
      "Kangrai B.O": "799269",
      "Kurit B.O": "799261",
      "Rakhalgang B.O": "799261",
      "Joyasree B.O": "799270",
      "Sibnagar B.O": "799270",
      "Bilthai B.O": "799260",
      "North Padmabil B.O": "799260",
      "Pekucherr B.O": "799260",
      "Rowabazar B.O": "799260",
      "Ujan Sailenbari B.O": "799260",
      "Algapur B.O": "799253",
      "Dharmanagar Bazar B.O": "799253",
      "Kakrirpar B.O": "799253",
      "Padmapur B.O": "799253",
      "South Ganganagar B.O": "799253",
      "Bakbaki B.O": "799251",
      "Bhagyapur B.O": "799251",
      "Balidhum B.O": "799254",
      "Paschim Radhapur B.O": "799254",
      "Belianchief B.O": "799269",
      "Hmungchuan B.O": "799269",
      "Amtilla B.O": "799261",
      "Laljuri B.O": "799270",
      "Satnala B.O": "799270",
      "Padmabil B.O": "799260",
      "Tilthai B.O": "799260",
      "Noagang B.O": "799260",
      "Dharmanagar College B.O": "799253",
      "Dhupirbond B.O": "799253",
      "East Huruah B.O": "799253",
      "East Kamesawar B.O": "799253",
      "Kameswargaon B.O": "799253",
      "Radhapur B.O": "799253",
      "Tripura Ganganagar B.O": "799253",
      "Zaithang B.O": "799253",
      "Indurail B.O": "799260",
      "Jalabazar B.O": "799260",
      "Jalebassa B.O": "799260",
      "Janata College B.O": "799260",
      "Uptakhali B.O": "799260",
      "West Panisagar B.O": "799260",
      "Krishnapur B.O": "799253",
      "Khedacherra B.O": "799256",
      "Narendranagar B.O": "799256",
      "Baruakandi B.O": "799251",
      "Dighalbak B.O": "799251",
      "Dharmanagar H.O": "799250",
      "Chandrapur S.O (North Tripura)": "799251",
      "Rajbari S.O": "799253",
      "Tripura Damcherra S.O": "799256",
      "Kadamtala S.O (North Tripura)": "799261",
      "Dasdabazar S.O": "799271",
      "Halflongcherra S.O": "799254",
      "Jampui S.O": "799269",
      "Kanchanpur S.O (North Tripura)": "799270",
      "Panisagar S.O": "799260",
      "Churaibari S.O": "799262"
    },
    "Khowai": {
      "Bharatsardarbari B.O": "799207",
      "Gouranga Tilla B.O": "799207",
      "Paglabari B.O": "799207",
      "Ramchandraghat B.O": "799207",
      "Baijalbari B.O": "799207",
      "Uttarchebri B.O": "799207",
      "Chankhala B.O": "799207",
      "Rajnagar Khowai B.O": "799207",
      "Sonatala B.O": "799207",
      "Dakshin Promode L. L.Colony B.O": "799203",
      "Uttat Pulinpur B.O": "799203",
      "Asharambari B.O": "799201",
      "Behalabari B.O": "799201",
      "Gakulbari B.O": "799201",
      "Khowai T. E B.O": "799201",
      "Paschim Belcherra B.O": "799201",
      "Subashpark B.O": "799201",
      "Barmura Project B.O": "799205",
      "Howaibari B.O": "799205",
      "Karailong B.O": "799205",
      "Khasiamangal B.O": "799205",
      "Maigonga B.O": "799205",
      "Rupacherra B.O": "799205",
      "Barmaidan Bazar B.O": "799203",
      "Durgapur B.O": "799203",
      "Ghilatali B.O": "799203",
      "Paschim Kalyanpur B.O": "799203",
      "Ramdayal Lendless Colony B.O": "799203",
      "Agagartilla B.O": "799201",
      "Champahaor B.O": "799201",
      "East Bachaibari B.O": "799201",
      "Paharmora B.O": "799201",
      "Paschim Laxmicherra B.O": "799201",
      "Ataromura B.O": "799205",
      "Kalitilla B.O": "799205",
      "Maharanipur B.O": "799205",
      "Uttar Gakulnagar B.O": "799205",
      "Dwarikapur B.O": "799203",
      "Kalyanpur T. E B.O": "799203",
      "Moharcherra B.O": "799203",
      "Paschim Kunjaban B.O": "799203",
      "Paschim Santinagar B.O": "799203",
      "Banbazar B.O": "799201",
      "Belcherra B.O": "799201",
      "Ganki B.O": "799201",
      "Karingicherra B.O": "799201",
      "Brahmacherra B.O": "799205",
      "Chakmaghat B.O": "799205",
      "Golabari B.O": "799205",
      "Hadrai B.O": "799205",
      "Ratia B.O": "799203",
      "Tablabari B.O": "799203",
      "Bachaibari B.O": "799201",
      "Ratanpurbazar B.O": "799201",
      "Samatal Padmabil B.O": "799201",
      "Singicherra B.O": "799201",
      "Mongtukupara B.O": "799205",
      "Nabakumar Rankhal Para B.O": "799205",
      "Netajinagar B.O": "799205",
      "Nunacherra B.O": "799205",
      "Khowai S.O": "799201",
      "Teliamura S.O": "799205",
      "Chebri S.O": "799207",
      "Kalyanpur S.O (West Tripura)": "799203",
      "Khowai Court S.O": "799202"
    },
    "Unakoti": {
      "Emrapassa B.O": "799290",
      "Fatikcherra B.O": "799290",
      "Gakulnagar B.O": "799290",
      "Bhagabannagar B.O": "799279",
      "Chinibagan B.O": "799279",
      "Ratacherra B.O": "799290",
      "Saidarpar B.O": "799290",
      "Tarapur B.O": "799290",
      "Teghari B.O": "799290",
      "Ganganagar B.O": "799290",
      "Paschimratacherra B.O": "799290",
      "Noagaon Bazar B.O": "799290",
      "Rajkandi B.O": "799290",
      "Uttar Radhanagar B.O": "799290",
      "Chandipur B.O": "799277",
      "Gulakpur T.E B.O": "799277",
      "Sadhanasram B.O": "799277",
      "Bhadrapally B.O": "799277",
      "Rangrung B.O": "799277",
      "Samrurpar B.O": "799277",
      "Jamtolibari B.O": "799277",
      "Taraninagar B.O": "799288",
      "Sayedabari B.O": "799264",
      "Chantail B.O": "799279",
      "Deora Cherra B.O": "799279",
      "Kailashahar Air Port B.O": "799279",
      "Zarultali B.O": "799279",
      "Govidabari B.O": "799263",
      "Krishnatilla B.O": "799263",
      "Machmara B.O": "799263",
      "Birchandranagar B.O": "799280",
      "Dhanbilash B.O": "799280",
      "Kalishahan B.O": "799277",
      "Sreerampur B.O": "799277",
      "Tapaspalli B.O": "799277",
      "Ujan Dodhpur B.O": "799288",
      "Pabiacherra B.O": "799264",
      "South Unokoti B.O": "799264",
      "Dhanicherra B.O": "799263",
      "Nabincherra B.O": "799263",
      "Dalugaon B.O": "799280",
      "Fultali B.O": "799280",
      "Rangauti B.O": "799281",
      "Bhatisonaimuri B.O": "799264",
      "Darchai B.O": "799264",
      "East Kanchanbari B.O": "799264",
      "Goldharpur B.O": "799279",
      "Gournagar B.O": "799279",
      "Kirtantali B.O": "799279",
      "Andharcherra B.O": "799263",
      "Karaicherra B.O": "799263",
      "Jagannathpur B.O": "799280",
      "Pechardahar B.O": "799280",
      "Ichabpur B.O": "799277",
      "Manuvelly B.O": "799277",
      "Noorpur B.O": "799277",
      "Dengdung B.O": "799288",
      "Dudhpur B.O": "799288",
      "Laljuri East B.O": "799288",
      "Masauli B.O": "799288",
      "Nepaltilla B.O": "799288",
      "Notting Chedrra B.O": "799264",
      "Nalkata B.O": "799263",
      "Ramgunapara B.O": "799263",
      "Ugalcherra B.O": "799263",
      "Balehar B.O": "799280",
      "Hiracherra B.O": "799281",
      "Irani B.O": "799281",
      "Latiapur B.O": "799281",
      "Tripura Tillabazar B.O": "799281",
      "Fatikroy S.O": "799290",
      "Kailashahar S.O": "799277",
      "Kanchanbari S.O": "799288",
      "Panichowkibazar S.O": "799277",
      "Baburbazar S.O": "799281",
      "Kumarghat S.O": "799264",
      "Paiturbazar S.O": "799279",
      "Sonamukhi S.O (North Tripura)": "799280",
      "Gournagar SO": "799282",
      "Pecharthal S.O": "799263"
    },
    "West Tripura": {
      "Durjaynagar B.O": "799009",
      "Narayanpur B.O": "799009",
      "Jarul Bachai B.O": "799004",
      "Bhattapukur B.O": "799003",
      "Charipara B.O": "799003",
      "Ishanchandranagar B.O": "799003",
      "Madhuban B.O": "799003",
      "Gurudas Colony B.O": "799045",
      "Janmejoynagar B.O": "799045",
      "Mandainagar B.O": "799045",
      "Mdhabbari B.O": "799045",
      "Radhamohanpur B.O": "799045",
      "Nutannagar B.O": "799009",
      "Jogendranagar B.O": "799004",
      "Purba Pratapgarh B.O": "799004",
      "Renters Colony B.O": "799004",
      "Town pratapgarh B.O": "799004",
      "Shantinagar B.O": "799045",
      "Belbari B.O": "799045",
      "Brigudaspara B.O": "799045",
      "Champaknagar B.O": "799045",
      "Tripura Engineering College B.O": "799045",
      "Bisrambari B.O.": "799045",
      "Gabordi B.O": "799004",
      "Nagicherra B.O": "799004",
      "Srinagar Kacharipara B.O": "799004",
      "Aralia B.O": "799004",
      "Dhupcherra B.O": "799004",
      "Badharghat B.O": "799003",
      "S.D.Mission Colony B.O": "799003",
      "Tebaria B.O": "799015",
      "Durganagar B.O": "799035",
      "Meghlipara B.O": "799035",
      "Pandavpur B.O": "799130",
      "Pravapur B.O": "799130",
      "Ishanpur B.O": "799212",
      "Simna B.O": "799212",
      "Sonaram Bazar B.O": "799212",
      "Banamalipur B.O": "799007",
      "Bodhjungnagar B.O": "799210",
      "Kalibazar B.O": "799210",
      "Khasnoagaon B.O": "799008",
      "Mariamnagar B.O": "799008",
      "Reshambagan B.O": "799008",
      "Indranagar B.O": "799006",
      "Kathalbagan B.O": "799006",
      "Barkathalia B.O": "799211",
      "Bijoynagar Bazar B.O": "799211",
      "Chachubazar B.O": "799211",
      "Dighalia Bazar B.O": "799211",
      "Burakha Landless Colony B.O": "799035",
      "Dinabandhupara B.O": "799035",
      "Majlishpur B.O": "799035",
      "Surjamaninagar B.O": "799130",
      "Viveknagar B.O": "799130",
      "Balubon B.O": "799212",
      "Darogamura B.O": "799212",
      "Sundartilla B.O": "799212",
      "Sonamani sepaipara B.O": "799035",
      "Gandhigram B.O": "799012",
      "Amtali B.O": "799130",
      "Champamura Bazar B.O": "799130",
      "Kanchanmala B.O": "799130",
      "Uttar Dasgharia B.O": "799212",
      "Lankamura B.O": "799009",
      "Anandanagar B.O": "799004",
      "Bardowali B.O": "799003",
      "Ranirkhamar B.O": "799003",
      "Siddhi Ashram B.O": "799003",
      "Ashigarh B.O": "799045",
      "Noabadi B.O": "799045",
      "Sanchindranagar Colony B.O": "799045",
      "Chechuria B.O": "799210",
      "Old Agartala B.O": "799008",
      "Paschim Noabadi B.O": "799008",
      "Ramachandranagar B.O": "799008",
      "Bankumari E/SB B.O": "799006",
      "Noagaon Krishnagar B.O": "799006",
      "Baikunthapur B.O": "799211",
      "Kalkalia T.E. B.O": "799211",
      "Subalsing B.O": "799211",
      "Krishnanagar B.O": "799002",
      "Harendranagar T. B.O": "799210",
      "Laifunga B.O": "799210",
      "Lembucherra B.O": "799210",
      "Kunjabon Road B.O": "799006",
      "Nandannagar B.O": "799006",
      "Thamakari B.O": "799211",
      "Uttar debendranagar B.O": "799211",
      "AgartalaGuard Post B.O": "799002",
      "Barjala B.O": "799002",
      "Bhati Abhoynagar B.O": "799002",
      "Border Rampur B.O": "799002",
      "Paschim Bhubanban B.O": "799002",
      "Town Rampur B.O": "799002",
      "Purba Noagaon B.O": "799035",
      "Wakinagar B.O": "799035",
      "Rayermura B.O": "799130",
      "Simna Colony B.O": "799212",
      "Fatikchhera B.O": "799210",
      "Neepco B.O": "799008",
      "Paschim Champamur B.O": "799008",
      "G.B.Hospital B.O": "799006",
      "Bamutia B.O": "799211",
      "Kalacherra T.E. B.O": "799211",
      "Madhuchoudhurypara B.O": "799211",
      "Patnipara B.O": "799211",
      "Taranagar B.O": "799211",
      "Tarapur B.O": "799211",
      "Agartala H.O": "799001",
      "NIT Agartala S.O": "799046",
      "Arundhutinagar S.O": "799003",
      "Birendranagar S.O": "799045",
      "Ranirbazar S.O": "799035",
      "Sidhai S.O": "799212",
      "Abhoynagar S.O": "799005",
      "Agartala Airport Building S.O": "799009",
      "Agartala College S.O": "799004",
      "Dhaleswar S.O": "799007",
      "Jaganath Bari Road S.O": "799001",
      "Mohanpur S.O (West Tripura)": "799211",
      "Salbagan S.O": "799012",
      "Tripura University S.O": "799022",
      "Agartala Bazar S.O": "799001",
      "Agartala ONGC S.O": "799014",
      "Agartala Secretariat S.O": "799010",
      "Khayerpur S.O": "799008",
      "Ramnagar S.O (West Tripura)": "799002",
      "Agartala Aerodrome S.O": "799009",
      "Agartala Court S.O": "799001",
      "Narayanpur Bazar SO": "799015",
      "Kamalghat S.O": "799210",
      "Kunjaban S.O": "799006",
      "Sekerkote S.O": "799130"
    }
  },
  "ARUNACHAL PRADESH": {
    "WEST SIANG": {
      "Bagra B.O": "791001",
      "Bene B.O": "791001",
      "Darka B.O": "791001",
      "Darak B.O": "791001",
      "Kambang B.O": "791001",
      "Logum Jining B.O": "791001",
      "Kombo B.O": "791001",
      "Nikte B.O": "791001",
      "Vivek Nagar B.O": "791001",
      "Yoji Yora B.O": "791001",
      "Yomcha B.O": "791001",
      "Liromoba B.O": "791101",
      "Along S.O": "791001"
    },
    "LOWER SUBANSIRI": {
      "Hari B.O": "791120",
      "Hong B.O": "791120",
      "Siiro B.O": "791120",
      "Yazali B.O": "791119",
      "Hija B.O": "791120",
      "Old Ziro B.O": "791120",
      "Yachuli B.O": "791120",
      "Deed B.O": "791120",
      "Godak B.O": "791120",
      "Joram B.O": "791120",
      "Talo B.O": "791120",
      "Ranga Nadi Project S.O": "791119",
      "Ziro S.O": "791120"
    },
    "PAPUM PARE": {
      "Jully B.O": "791113",
      "Kolaptukar B.O": "791123",
      "Mengio B.O": "791119",
      "Chimpu B.O": "791113",
      "Model Village B.O": "791110",
      "Yupia B.O": "791110",
      "Donyi Polo B.O": "791113",
      "Suchana Nagar B.O": "791113",
      "Vidya Vihar B.O": "791113",
      "Sonajuli B.O": "791123",
      "Arunachal University B.O": "791112",
      "Hawa Camp B.O": "791121",
      "Kokila B.O": "791123",
      "Kheel B.O": "791112",
      "Balijan B.O": "791123",
      "Midpu B.O": "791112",
      "Itanagar H.O": "791111",
      "Kimin S.O": "791121",
      "Naharlagun S.O": "791110",
      "Ram Krishna Mission S.O": "791113",
      "Sagalee S.O": "791114",
      "Arunachal Pradesh Secretariat S.O": "791111",
      "Banderdewa S.O": "791123",
      "Doimukh S.O": "791112",
      "Nirjuli S.O": "791109"
    },
    "CHANGLANG": {
      "Milonpur B.O": "792122",
      "Dharampur B.O": "792122",
      "Manabhum B.O": "792122",
      "Kharsang B.O": "792122",
      "Kutum Basti B.O": "792122",
      "Chopelling B.O": "792122",
      "Deban B.O": "792122",
      "Namchik B.O": "792122",
      "Namphai B.O": "792122",
      "Gandhigram B.O": "792055",
      "Two Hut B.O": "792055",
      "New Mohong B.O": "792056",
      "Vijoypur B.O": "792056",
      "Namdang B.O": "792120",
      "Ranglum B.O": "792120",
      "Kherem Bisa B.O": "792056",
      "Lallung B.O": "792056",
      "Bubang B.O": "792120",
      "Manmao B.O": "792121",
      "Rajanagar B.O": "792056",
      "Khemiyong B.O": "792120",
      "Namtok B.O": "792120",
      "Rangfra Govt.College B.O": "792120",
      "Yangkang B.O": "792120",
      "Jairampur S.O (Changlang)": "792121",
      "Vijoynagar S.O": "792055",
      "Bordumsa S.O": "792056",
      "Changlang S.O": "792120",
      "Miao S.O": "792122",
      "Nampong S.O": "792123"
    },
    "SIANG": {
      "Kaying B.O": "791001",
      "Boleng B.O": "791103",
      "Riga B.O": "791103",
      "Kebang B.O": "791103",
      "Pangin B.O": "791103",
      "Payum B.O": "791001",
      "Rumgong B.O": "791001",
      "Pessing B.O": "791001"
    },
    "SHI YOMI": {
      "Monigong B.O": "791001",
      "Tato B.O": "791001",
      "Mechuka S.O": "791003"
    },
    "TAWANG": {
      "Zemithang B.O": "790106",
      "Temple Gompa B.O": "790104",
      "Gispu B.O": "790106",
      "B.Supply B.O": "790104",
      "Kitpi B.O": "790104",
      "Lumberdung B.O": "790104",
      "Thingbu B.O": "790105",
      "Sakpret B.O": "790104",
      "Mukto B.O": "790105",
      "Lhou B.O": "790104",
      "Jang S.O": "790105",
      "Lumla S.O": "790106",
      "Tawang S.O": "790104"
    },
    "LOHIT": {
      "Changliang B.O": "792001",
      "Gohaingaon B.O": "792001",
      "Yealing B.O": "792111",
      "Lohitpur B.O": "792001",
      "Danglat B.O": "792001",
      "Loiliang B.O": "792001",
      "Tafragam B.O": "792001",
      "Tezu Govt. College B.O": "792001",
      "Tindolong B.O": "792001",
      "Wakro B.O": "792102",
      "Tezu S.O": "792001",
      "Sunpura S.O": "792111"
    },
    "EAST SIANG": {
      "Namsing B.O": "791104",
      "Rani B.O": "791102",
      "Yagrung B.O": "791102",
      "Ayeng B.O": "791104",
      "Sirem B.O": "791104",
      "Debing B.O": "791102",
      "Ruksin B.O": "791102",
      "Sille B.O": "791102",
      "Borguli B.O": "791104",
      "Ngopok B.O": "791104",
      "Silluk B.O": "791104",
      "Balek B.O": "791102",
      "Bilat B.O": "791102",
      "Renging B.O": "791103",
      "GTC B.O": "791103",
      "Ledum B.O": "791102",
      "Oyan B.O": "791102",
      "Hill Top S.O": "791103",
      "Pasighat S.O": "791102",
      "Mebo S.O": "791104"
    },
    "KURUNG KUMEY": {
      "Hiya B.O": "791118",
      "Koloriang B.O": "791118",
      "Sangram B.O": "791118",
      "Nyapin B.O": "791118",
      "Damin B.O": "791118",
      "Sarli B.O": "791118"
    },
    "EAST KAMENG": {
      "Bameng B.O": "790102",
      "Bana B.O": "790102",
      "Lada B.O": "790102",
      "Veo B.O": "790102",
      "Chyangtajo B.O": "790102",
      "Khenewa B.O": "790102",
      "Pipu dipu B.O": "790102",
      "Seppa S.O": "790102"
    },
    "NAMSAI": {
      "Padumani B.O": "792105",
      "Innao B.O": "792103",
      "Nampong B.O": "792103",
      "Piyong B.O": "792103",
      "Wingko B.O": "792103",
      "Diyun B.O": "792103",
      "Jaipur B.O": "792103",
      "Manmao B.O": "792103",
      "Nanam B.O": "792103",
      "Kumari Kachari B.O": "792105",
      "Udaipur B.O": "792103",
      "Kumsai B.O": "792103",
      "Lathao B.O": "792103",
      "Chakma B.O": "792102",
      "Medo B.O": "792102",
      "Alubari B.O": "792102",
      "Kamlang Nagar B.O": "792102",
      "Kherem B.O": "792102",
      "Momong B.O": "792102",
      "Mahadevpur S.O (Lohit)": "792105",
      "Namsai S.O": "792103",
      "Chowkham S.O": "792102"
    },
    "LOWER SIANG": {
      "Koyu B.O": "791102",
      "Korang B.O": "791102",
      "Nari B.O": "791102",
      "Garu B.O": "791125",
      "Gensi B.O": "791125",
      "Likabali S.O": "791125"
    },
    "LOWER DIBANG VALLEY": {
      "Abango B.O": "792110",
      "Desali B.O": "792110",
      "Elopa B.O": "792110",
      "Meka B.O": "792110",
      "Parbuk B.O": "792110",
      "Bolung B.O": "792110",
      "Dambuk B.O": "792110",
      "Jia B.O": "792110",
      "Kronli B.O": "792110",
      "Anupam B.O": "792110",
      "Bijari B.O": "792110",
      "Paglam B.O": "792110",
      "Santipur B.O": "792110",
      "Bomjir B.O": "792110",
      "Hunli B.O": "792110",
      "Iduli B.O": "792110",
      "Koronu B.O": "792110",
      "Roing S.O": "792110"
    },
    "UPPER SIANG": {
      "Damro B.O": "791103",
      "Migging B.O": "791105",
      "Shimong B.O": "791002",
      "Dalbing B.O": "791103",
      "Singa B.O": "791105",
      "Geku B.O": "791002",
      "Mariyang B.O": "791002",
      "Adipassi B.O": "791103",
      "Gelling B.O": "791105",
      "Karko B.O": "791002",
      "Tuting S.O": "791105",
      "Yingkiong S.O": "791002"
    },
    "PAKKE KESSANG": {
      "P.Kessang B.O": "790102",
      "Seijosa S.O": "790103"
    },
    "WEST KAMENG": {
      "Palizi B.O": "790001",
      "Singchung B.O": "790116",
      "Shergaon B.O": "790003",
      "Thrizino B.O": "790001",
      "Dahung B.O": "790116",
      "Dedza B.O": "790116",
      "Tippi B.O": "790114",
      "Dirang Basti B.O": "790101",
      "Lish B.O": "790101",
      "Salari B.O": "790001",
      "Balemu B.O": "790002",
      "Khellong B.O": "790114",
      "Nafra B.O": "790001",
      "Munna Camp B.O": "790101",
      "Rahung B.O": "790001",
      "Sangti B.O": "790101",
      "Senge B.O": "790101",
      "Tenzingaon B.O": "790002",
      "Bhalukpong S.O": "790114",
      "Kalaktang S.O": "790002",
      "Rupa S.O": "790003",
      "Bomdila S.O": "790001",
      "Dirang S.O": "790101",
      "Tenga Market S.O": "790116"
    },
    "KRA DAADI": {
      "Tali B.O": "791118",
      "Chambang B.O": "791118",
      "Palin S.O": "791118"
    },
    "DIBANG VALLEY": {
      "Etalin B.O": "792101",
      "Anelih B.O": "792110",
      "Alinye B.O": "792101",
      "Anini S.O": "792101"
    },
    "LONGDING": {
      "Kanubari B.O": "792130",
      "K/nokno B.O": "792131",
      "Longfong B.O": "792131",
      "Senewa B.O": "792131",
      "Wakka B.O": "792131",
      "Minthong B.O": "792131",
      "Nginu B.O": "792131",
      "pangchou B.O": "792131",
      "Khotnu B.O": "792131",
      "Niausa B.O": "792131",
      "Tissa B.O": "792131",
      "Longding S.O": "792131"
    },
    "UPPER SUBANSIRI": {
      "Muri B.O": "791122",
      "Nacho B.O": "791122",
      "Sippi B.O": "791122",
      "Siyum B.O": "791122",
      "Tabarijo B.O": "791122",
      "Taksing B.O": "791122",
      "Taliha B.O": "791122",
      "Dumporijo B.O": "791122",
      "Lemiking B.O": "791122",
      "Maro B.O": "791122",
      "Giba B.O": "791122",
      "Lepajaring B.O": "791122",
      "Daporijo S.O": "791122"
    },
    "TIRAP": {
      "Namsang Mukh B.O": "792129",
      "Narottam Nagar B.O": "792129",
      "Soha B.O": "792129",
      "Khela B.O": "792130",
      "Kheti B.O": "792130",
      "Lazu B.O": "792130",
      "Thinsa B.O": "792130",
      "Tupi B.O": "792130",
      "Borduria B.O": "792130",
      "Valley view B.O": "792130",
      "Namsang B.O": "792129",
      "Kaimai B.O": "792130",
      "Kapu B.O": "792130",
      "Khonsa Basti B.O": "792130",
      "Hukanjuri B.O": "792129",
      "Dadam B.O": "792130",
      "Khonsa S.O": "792130",
      "Deomali S.O": "792129"
    },
    "LEPARADA": {
      "Dali B.O": "791101",
      "Daring B.O": "791101",
      "Tirbin B.O": "791101",
      "Bame B.O": "791101",
      "Basar S.O (West Siang)": "791101"
    },
    "ANJAW": {
      "Goiliang B.O": "792104",
      "Khopa B.O": "792104",
      "Wallong B.O": "792104",
      "Chaglagam B.O": "792104",
      "Hawai B.O": "792104",
      "Kibitho B.O": "792104",
      "Meteliang B.O": "792104",
      "Yatong B.O": "792104",
      "Hayuliang S.O": "792104"
    },
    "KAMLE": {
      "Boasimla B.O": "791120",
      "Raga B.O": "791120"
    }
  },
  "LAKSHADWEEP": {
    "LAKSHADWEEP DISTRICT": {
      "Bithra B.O": "682554",
      "Kavaratti H.O": "682555",
      "Agathi S.O": "682553",
      "Chetlat S.O": "682554",
      "Kalpeni S.O": "682557",
      "Amini S.O": "682552",
      "Kadamat S.O": "682556",
      "Kiltan S.O": "682558",
      "Minicoy S.O": "682559",
      "Androth S.O": "682551"
    }
  },
  "PUDUCHERRY": {
    "MAHE": {
      "Pandakkal BO": "673310",
      "Naluthara BO": "673310",
      "Pallur BO": "673310",
      "Mahe SO": "673310"
    },
    "PONDICHERRY": {
      "Abishegapakkam BO": "605007",
      "Veerampattinam BO": "605007",
      "Courouvinatham BO": "607402",
      "Manamedu BO": "607402",
      "Thengaithittu BO": "605004",
      "Embalam BO": "605106",
      "Kariyamanikam BO": "605106",
      "Olugarai BO": "605010",
      "Moutrepalayam BO": "605009",
      "Karikkalampakkam BO": "605007",
      "Nallavadu BO": "605007",
      "Poornankuppam BO": "605007",
      "Kijour BO": "605106",
      "Thimmappanaickenpalayam BO": "605007",
      "Manapet BO": "607402",
      "Seliyamedu BO": "607402",
      "Mouroungapakkam BO": "605004",
      "Karayamputhur BO": "605106",
      "Calapet BO": "605014",
      "Mouttoupalayam BO": "605009",
      "Ariyur BO": "605102",
      "Thiruvandarkoil BO": "605102",
      "Sedarapet BO": "605111",
      "Arumparthapuram BO": "605110",
      "Vadhanur BO": "605501",
      "Sellipet BO": "605501",
      "Sorapattu BO": "605501",
      "Korkadu BO": "605110",
      "Odiampattu BO": "605110",
      "Vimacoundanpalayam BO": "605009",
      "Mannadipattu BO": "605501",
      "Mangalam BO": "605110",
      "Sulthanpet BO": "605110",
      "Pillayarkuppam BO": "607403",
      "Lingareddipalayam BO": "605107",
      "Coudapakkam BO": "605502",
      "Thirubuvanai BO": "605107",
      "Suthukeni BO": "605502",
      "Maducore BO": "605105",
      "Madagadipet BO": "605107",
      "Puranasingapalayam BO": "605107",
      "Katterikuppam BO": "605502",
      "Thondamanatham BO": "605502",
      "Pondicherry HO": "605001",
      "Ariyankuppam SO": "605007",
      "Bahoor SO": "607402",
      "Lawspet SO": "605008",
      "Muthialpet SO": "605003",
      "Kirumambakkam": "607403",
      "Nellithope SO": "605005",
      "Thattanchavady SO": "605009",
      "Venkata Nagar SO": "605011",
      "Dhanvantri Nagar SO": "605006",
      "Nettapakkam SO": "605106",
      "Pondicherry University SO": "605014",
      "Reddiarpalayam SO": "605010",
      "Tirukkanur SO": "605501",
      "Pondicherry Courts SO": "605004",
      "Mudaliarpet SO": "605004",
      "SaramPy SO": "605013",
      "Sri Aurobindo Ashram SO": "605002",
      "Villiyanur SO": "605110"
    },
    "KARAIKAL": {
      "Melakasakudi B.O": "609603",
      "Nallathur B.O": "609603",
      "Karukkangudi B.O": "609607",
      "Sellur B.O": "609607",
      "Surakudi B.O": "609607",
      "Varichikudi B.O": "609609",
      "Akkaraivattam B.O": "609604",
      "Karaikoilpathu B.O": "609605",
      "T.R.Pattinam South B.O": "609606",
      "Vizhithiyur B.O": "609607",
      "Nallambal B.O": "609601",
      "Seithur B.O": "609601",
      "Madagadi B.O": "609602",
      "Dharmapuram B.O": "609602",
      "Tiruvettakudi B.O": "609609",
      "Kurumbagaram B.O": "609603",
      "Karaikalmedu B.O": "609605",
      "Ambagarathur S.O": "609601",
      "Karaikal South S.O": "609602",
      "Karaikal Bazaar S.O": "609602",
      "Kottuchery S.O": "609609",
      "Karaikal S.O": "609602",
      "Nedungadu S.O": "609603",
      "Thalatheru S.O": "609605",
      "Tirunallar S.O": "609607",
      "Neravy S.O": "609604",
      "Tirumalairayanpattinam S.O": "609606"
    },
    "YANAM": {
      "Yanam S.O": "533464"
    }
  },
  "CHANDIGARH": {
    "CHANDIGARH": {
      "Kishangarh BO": "160101",
      "Behlana BO": "160003",
      "Dhanas BO": "160014",
      "Hallomajra BO": "160002",
      "Badheri BO": "160036",
      "Daria BO": "160101",
      "Raipur Kalan BO": "160102",
      "Behlolpur BO": "160014",
      "Tira BO": "160014",
      "Burail BO": "160047",
      "Chandigarh GPO": "160017",
      "Aerodrome SO": "160003",
      "Airforce Highground SO": "160004",
      "Engg College SO": "160012",
      "Ind Area Chandigarh SO": "160002",
      "Raj Bhawan SO Chandigarh": "160019",
      "Sector 14 Chandigarh SO": "160014",
      "Sector 19 Chandigarh SO": "160019",
      "Dadu Majra Colony SO": "160014",
      "High Court SO Chandigarh": "160001",
      "Mhc Manimajra SO": "160101",
      "Sector 11 Chandigarh SO": "160011",
      "Sector 16 Chandigarh SO": "160015",
      "Sector 22 Chandigarh SO": "160022",
      "Sector 29 Chandigarh SO": "160030",
      "Sector 26 Chandigarh SO": "160019",
      "Sector 34Chandigarh SO": "160022",
      "Sector 35 Chandigarh SO": "160022",
      "Vidhansadan SO": "160001",
      "IBC CHANDGIARH SO": "160005",
      "Sector 48 Chandigarh S.O": "160047",
      "NDC Chandigarh": "160006",
      "Sector 30 Chandigarh SO": "160030",
      "Maloya Colony SO": "160025",
      "Sector 18 Chandigarh SO": "160018",
      "Sector 20 Chandigarh SO": "160020",
      "Sector 36 Chandigarh SO": "160036",
      "Sector 8Chandgarh SO": "160009",
      "Sector43 Chandigarh": "160043",
      "Govt Press Chandigarh SO": "160018",
      "Manimajra SO": "160101",
      "Mauli Jagran SO": "160102",
      "New Sectt Chandigarh SO": "160001",
      "Ram Darbar SO": "160002",
      "Sector 10 Chandigarh SO": "160011",
      "Sector 12 Chandigarh SO": "160012",
      "Sector 15 Chandigarh SO": "160015",
      "Sector 21 Chandigarh SO": "160022",
      "Sector 23  Chandigarh SO": "160023",
      "Sector 27ChandigarhSO": "160019",
      "Sector 31 Chandigarh SO": "160030",
      "Sector 40 Chandigarh SO": "160036",
      "Sector 44 Chandigarh SO": "160047",
      "Sector 47 Chandigarh SO": "160047",
      "Sector 9 Chandigarh SO": "160009",
      "NODAL DELIVERY  SPEED POST  CHANDIGARH": "160016"
    }
  },
  "GOA": {
    "SOUTH GOA": {
      "Mangor Hill B.O": "403802",
      "Assolda B.O": "403714",
      "Cavorim B.O": "403714",
      "Thana B.O": "403710",
      "Balli B.O": "403703",
      "Panchwadi B.O": "403706",
      "Quirlapale B.O": "403706",
      "Xelvona B.O": "403706",
      "Sirvoi B.O": "403705",
      "Xeldem B.O": "403705",
      "Ugvem B.O": "403704",
      "Ambelim B.O": "403723",
      "Agonda B.O": "403702",
      "Cola B.O": "403702",
      "Sadolxem B.O": "403702",
      "Sigao B.O": "403410",
      "Sancoale B.O": "403710",
      "Barcem B.O": "403703",
      "Fatorpa B.O": "403703",
      "Talaulim B.O": "403707",
      "Calem B.O": "403704",
      "Nuvem B.O": "403713",
      "Cotigaon B.O": "403702",
      "Gaodongarim B.O": "403702",
      "Palolem B.O": "403702",
      "Poinguinim B.O": "403702",
      "Vanelim B.O": "403708",
      "Veroda B.O": "403703",
      "Camurlim B.O": "403718",
      "Betalbhatim B.O": "403713",
      "Utorda B.O": "403713",
      "Davorlim B.O": "403707",
      "Avedem B.O": "403705",
      "Pirla B.O": "403705",
      "Bati B.O": "403704",
      "Curdi B.O": "403704",
      "Molcarnem B.O": "403704",
      "Betul B.O": "403723",
      "ONGC Ipsem Betul B.O": "403723",
      "Bhatpal B.O": "403702",
      "Mollem B.O": "403410",
      "Seraulim B.O": "403708",
      "Cananguinim B.O": "403703",
      "Morpirla B.O": "403703",
      "Cacora B.O": "403706",
      "Macazana B.O": "403709",
      "Loliem Polem B.O": "403728",
      "Rivona B.O": "403705",
      "Netorlim B.O": "403704",
      "Valkini B.O": "403704",
      "Betki B.O": "403107",
      "Agapur Adpoi B.O": "403401",
      "Nirankal B.O": "403401",
      "Sancordem B.O": "403406",
      "Priol B.O": "403404",
      "Bandora B.O": "403401",
      "Borim B.O": "403401",
      "Curti B.O": "403401",
      "Verem De Ponda B.O": "403401",
      "Cundaim B.O": "403115",
      "Amona B.O": "403107",
      "Banastarim B.O": "403107",
      "Durbhat B.O": "403401",
      "Farmagudi B.O": "403401",
      "Tarvalem B.O": "403103",
      "Candepar B.O": "403406",
      "Darbandora B.O": "403406",
      "Pillem B.O": "403406",
      "Marcaim B.O": "403404",
      "Betora B.O": "403401",
      "Quela B.O": "403401",
      "Querim B.O": "403401",
      "Usgao B.O": "403406",
      "Margao H.O": "403601",
      "Marcela S.O": "403107",
      "Ponda Camp S.O": "403401",
      "Tisca S.O": "403406",
      "Cundaim I.E. S.O": "403115",
      "Ponda S.O": "403401",
      "Mardol S.O": "403404",
      "Shiroda S.O (South Goa)": "403103",
      "Aquem S.O": "403601",
      "Cansaulim S.O": "403712",
      "Chandor S.O": "403714",
      "Collem S.O": "403410",
      "Cuncolim S.O": "403703",
      "Curchorem S.O": "403706",
      "Fatorda S.O": "403602",
      "Gogol S.O": "403601",
      "Majorda S.O": "403713",
      "Vademnagar S.O": "403802",
      "Vasco Da Gama S.O": "403802",
      "Bogmalo S.O": "403806",
      "Dramapur S.O": "403725",
      "Loliem S.O": "403728",
      "Navelim Camp S.O": "403729",
      "Orlim S.O": "403724",
      "Raia S.O": "403720",
      "St. Jose De Areal S.O": "403709",
      "Vaddem S.O": "403802",
      "Assolna S.O": "403701",
      "Baina S.O": "403802",
      "Benaulim S.O": "403716",
      "Canacona S.O": "403702",
      "Carmona S.O": "403717",
      "Chicalim S.O": "403711",
      "Colva S.O": "403708",
      "Gandhi Market Complex Margao S.O": "403601",
      "Loutolim S.O": "403718",
      "Mormugao S.O": "403803",
      "Sada S.O": "403804",
      "Sanguem S.O": "403704",
      "Varca S.O": "403721",
      "Velim S.O": "403723",
      "Verna S.O": "403722",
      "A.P.Dabolim S.O": "403801",
      "A.P.Terminal S.O": "403801",
      "Cavelossim S.O": "403731",
      "Chinchinim S.O": "403715",
      "Betora I.E. S.O": "403409",
      "Cortalim S.O": "403710",
      "Curtorim S.O": "403709",
      "Navelim S.O": "403707",
      "Quepem S.O": "403705",
      "Sem rachol  Soso S.O": "403719",
      "Zuarinagar S.O": "403726"
    },
    "NORTH GOA": {
      "Caisua B.O": "403509",
      "Advalpal B.O": "403503",
      "Dodamarg B.O": "403503",
      "Quiranpani B.O": "403524",
      "Ibrampur B.O": "403503",
      "Corjuem B.O": "403508",
      "Nachinola B.O": "403508",
      "Querim B.O": "403505",
      "Mulgao B.O": "403503",
      "Camurlim B.O": "403507",
      "Ucassiam B.O": "403507",
      "Matri Indian Antartic Station": "403004",
      "Canca B.O": "403510",
      "Corgao B.O": "403512",
      "Poroscodem B.O": "403512",
      "Torxem B.O": "403512",
      "Virnora B.O": "403512",
      "Sangolda B.O": "403511",
      "Morlem B.O": "403505",
      "Poriem B.O": "403505",
      "Surla B.O": "403505",
      "Mauze B.O": "403506",
      "Nanorem B.O": "403506",
      "Carambolim B.O": "403110",
      "Gurim B.O": "403507",
      "Moira B.O": "403507",
      "Mandur B.O": "403104",
      "Velguem B.O": "403105",
      "Morjim B.O": "403512",
      "Nagzar B.O": "403512",
      "Tuem B.O": "403512",
      "Malar B.O": "403403",
      "Thana B.O": "403506",
      "Revora B.O": "403513",
      "Siridao B.O": "403108",
      "Assagao B.O": "403507",
      "Bastora B.O": "403507",
      "Advoi B.O": "403530",
      "Onda B.O": "403530",
      "Pissurlem B.O": "403530",
      "Parxem B.O": "403512",
      "Varconda B.O": "403512",
      "Nerul B.O": "403114",
      "Pilerne B.O": "403114",
      "Sem Saligao B.O": "403511",
      "Carapur B.O": "403505",
      "Cudnem B.O": "403505",
      "Oxel B.O": "403517",
      "Birondem B.O": "403506",
      "Cotorem B.O": "403506",
      "Guleli B.O": "403506",
      "Nagargaon B.O": "403506",
      "Cumbharjua B.O": "403107",
      "Agarwada B.O": "403512",
      "Cansarvornem B.O": "403512",
      "Tamboxem B.O": "403512",
      "Tuem I E B.O": "403512",
      "Chimbel B.O": "403006",
      "Navelim B.O": "403505",
      "Pratapnagar Harvale B.O": "403505",
      "Sirsaim B.O": "403502",
      "Sanvordem B.O": "403506",
      "Velguem O B.O": "403506",
      "Sirgao B.O": "403503",
      "Dhargalim B.O": "403513",
      "Salem B.O": "403503",
      "Penha De France B.O": "403101",
      "Mauliguem B.O": "403504",
      "Baga B.O": "403516",
      "Calvim B.O": "403523",
      "Saipem B.O": "403515",
      "Menkurem B.O": "403513",
      "Ozari B.O": "403513",
      "Pirna B.O": "403513",
      "Nanora B.O": "403503",
      "Salvador Do Mundo B.O": "403101",
      "Mayem B.O": "403504",
      "Pilgao B.O": "403504",
      "Arpora B.O": "403516",
      "Pomburpa B.O": "403523",
      "Panaji H.O": "403001",
      "Carona S.O": "403523",
      "Chorao S.O": "403102",
      "Goa University S.O": "403206",
      "N B Verem S.O": "403109",
      "Ribandar S.O": "403006",
      "Sant Estevam S.O": "403106",
      "Siolim S.O": "403517",
      "St Inez S.O": "403001",
      "Tivim S.O": "403502",
      "Assonora S.O": "403503",
      "Bambolim Complex S.O": "403202",
      "C.C.Altinho S.O": "403001",
      "Mapusa I.E. S.O": "403507",
      "Onda I.E. S.O": "403530",
      "Pale S.O": "403105",
      "Piedade S.O": "403403",
      "Saligao S.O": "403511",
      "Sanquelim S.O": "403505",
      "Tivim Ie S.O": "403526",
      "Aldona S.O": "403508",
      "Alto porvorim S.O": "403521",
      "Bambolim Camp S.O": "403201",
      "Bicholim Industrial Estate S.O": "403529",
      "Bicholim S.O": "403504",
      "Calangute S.O": "403516",
      "Corlim IE S.O": "403110",
      "Mandrem S.O": "403527",
      "Neura S.O": "403104",
      "Nio Dona Paula S.O": "403004",
      "Pernem S.O": "403512",
      "Pilar S.O (North Goa)": "403203",
      "Porvorim S.O": "403501",
      "Reis Magos S.O": "403114",
      "Secretariat S.O (North Goa)": "403521",
      "Valpoi S.O": "403506",
      "Miramar S.O": "403001",
      "Anjuna S.O": "403509",
      "Arambol S.O": "403524",
      "Betim S.O": "403101",
      "Candolim S.O": "403515",
      "Caranzalem S.O": "403002",
      "Colvale S.O": "403513",
      "Goa  velha S.O": "403108",
      "Mapusa S.O": "403507",
      "Parra S.O": "403510",
      "Santa Cruz S.O": "403005",
      "St. Lourence S.O": "403204",
      "Velha goa S.O": "403402",
      "Tapal Bhavan": "403001",
      "Alto Betim S.O": "403521"
    }
  },
  "UTTARAKHAND": {
    "ALMORA": {
      "Devayal BO": "244715",
      "Burakote BO": "244715",
      "Riquwasi BO": "244715",
      "Sankar BO": "244715",
      "Thala Manral BO": "244715",
      "Tukura BO": "244715",
      "Kharaun BO": "263601",
      "ITI Almora BO": "263601",
      "Syalidhar BO": "263601",
      "Sunoli BO": "263601",
      "Patia BO": "263601",
      "Petshal BO": "263601",
      "Pilkha BO": "263601",
      "Bhainsori ED BO": "263601",
      "Birora BO": "263601",
      "Dinapani BO": "263601",
      "Kanarichhina BO": "263624",
      "Khastilari BO": "263624",
      "Mangalta BO": "263624",
      "Maniagar BO": "263624",
      "Badiyar BO": "263622",
      "Kafalni BO": "263622",
      "Khatiyola BO": "263622",
      "Kheti BO": "263622",
      "Mayoli BO": "263622",
      "Bey BO": "263601",
      "Chaunsli BO": "263601",
      "Dhamas BO": "263601",
      "Bajwar BO": "263601",
      "Dova BO": "263601",
      "Ayarpani BO": "263601",
      "Balta BO": "263601",
      "Chaumu Uchyur BO": "263601",
      "Chitai BO": "263601",
      "Dal BO": "263601",
      "Almora College ED BO": "263601",
      "Nagarkhan BO": "263624",
      "Naraindewal BO": "263624",
      "Palyun BO": "263624",
      "Sainj BO": "263624",
      "Chaun Dungri BO": "263622",
      "Dasolibadiyar BO": "263622",
      "Dauligarh BO": "263622",
      "Dhura BO": "263622",
      "Gewapani BO": "263655",
      "Golchhina BO": "263655",
      "Rikhe BO": "263655",
      "Dhaura BO": "263601",
      "Kafarkhan BO": "263601",
      "Zoor BO": "263601",
      "Bhatkhola BO": "263601",
      "Kirara BO": "263601",
      "Lodhia BO": "263601",
      "Dhaulchhina ED BO": "263624",
      "Salla Bhatkote BO": "263624",
      "Dhaulara Totashilling BO": "263629",
      "Bhanoli ED BO": "263622",
      "Chamtola BO": "263622",
      "Jingoli Toli BO": "263622",
      "Pitoli BO": "263622",
      "Salparh BO": "263622",
      "Thali BO": "263622",
      "Ramara BO": "263655",
      "Bhainsiachhana BO": "263624",
      "Jamrari BO": "263624",
      "Lweshal BO": "263629",
      "Basoli BO": "263622",
      "Birkola BO": "263622",
      "Dhyari BO": "263622",
      "Pokhari BO": "263638",
      "Sona Shilling BO": "263622",
      "Tapani BO": "263622",
      "Bainskhet BO": "263655",
      "Basbhira BO": "263653",
      "Chantharia BO": "263653",
      "Asgoli ED BO": "263653",
      "Bitholi BO": "263653",
      "Chhatgulla BO": "263653",
      "Chitreshwar BO": "263653",
      "Dunagiri BO": "263653",
      "Gewar BO": "263653",
      "Gurkande BO": "263636",
      "Patalibangar BO": "263636",
      "Bhabu BO": "263626",
      "Birkham BO": "263626",
      "Mathena BO": "263625",
      "Motiapathar BO": "263625",
      "Nail BO": "263625",
      "Naura BO": "263625",
      "Satyun BO": "263625",
      "Kathpuria BO": "263643",
      "Bagswar BO": "263626",
      "Jhaldungra BO": "263626",
      "Rajyura BO": "263626",
      "Dharkhola BO": "263625",
      "Jakh BO": "263646",
      "Syunani BO": "263625",
      "Deolikhan BO": "263643",
      "Andoli BO": "263623",
      "Chelchhina BO": "263623",
      "Doram BO": "263623",
      "Khola BO": "263623",
      "Mirtola BO": "263623",
      "Nali BO": "263623",
      "Thikalna BO": "263623",
      "Suri BO": "263678",
      "Bhainsar Gaon BO": "263637",
      "Khirkhet BO": "263645",
      "Almiankande BO": "263645",
      "Bhujan BO": "263645",
      "Ganiadeoli BO": "263645",
      "Bamsyun BO": "263645",
      "Chilianaula BO": "263645",
      "Kafara ED BO": "263645",
      "Manela BO": "263645",
      "Ajoli Malli BO": "263646",
      "Kotuli Malli BO": "263646",
      "Panuwadeokhan BO": "263646",
      "Queralla BO": "263667",
      "Sinar BO": "263667",
      "Seem BO": "263680",
      "Ugalia BO": "263680",
      "Dhamera BO": "263660",
      "Barangal BO": "263659",
      "Chamarkhan BO": "263664",
      "Sagneti BO": "263664",
      "Chhatena BO": "263653",
      "Irah BO": "263653",
      "Ranban BO": "263638",
      "Bamanswal BO": "263623",
      "Banthok BO": "263623",
      "Chagethi BO": "263623",
      "Charchalikhan BO": "263623",
      "Naini BO": "263623",
      "Jalna BO": "263625",
      "Sinora BO": "263645",
      "Kalika Estate BO": "263645",
      "Masar BO": "263645",
      "Mirai Malli BO": "263645",
      "Pilkholi ED BO": "263645",
      "Bhaunkhal BO": "263646",
      "Harara BO": "263646",
      "Manila BO": "263667",
      "Manuli BO": "263667",
      "Ujrar BO": "263667",
      "Basot BO": "263680",
      "Pali BO": "263680",
      "Naila BO": "263660",
      "Naubara BO": "263660",
      "Chakargaon BO": "263659",
      "Jaikhal BO": "263659",
      "Munani BO": "263659",
      "Thapania BO": "263636",
      "Basantpur BO": "263626",
      "Chhana Kharkota BO": "263626",
      "Pubhaon BO": "263626",
      "Chaikhan BO": "263625",
      "Dhyuli BO": "263625",
      "Shaharphatak BO": "263625",
      "Unyura BO": "263625",
      "Darmar Tikhun BO": "263643",
      "Jeoli BO": "263643",
      "Dhauladevi ED BO": "263623",
      "Dunar BO": "263623",
      "Garanabanj BO": "263623",
      "Kasermanya BO": "263623",
      "Maharagaon BO": "263623",
      "Neoliharara BO": "263623",
      "Bhoolgaon BO": "263637",
      "Rasyaragaon BO": "263637",
      "Pandekota BO": "263645",
      "Haldiyani BO": "263645",
      "Darmar BO": "263645",
      "Chhana BO": "263645",
      "Uprari ED BO": "263645",
      "Ghatti BO": "263646",
      "Tolyun BO": "263646",
      "Totam BO": "263646",
      "Sainmanur BO": "263667",
      "Saknara BO": "263667",
      "Kotagiwai BO": "263680",
      "Pantgaon BO": "263680",
      "Taya BO": "263680",
      "Ghuguti Kelani BO": "263659",
      "Barsimi BO": "263636",
      "Bhagtola ED BO": "263636",
      "Anuli BO": "263625",
      "Bedchula BO": "263625",
      "Kayala BO": "263643",
      "Gunaditya BO": "263623",
      "Jageshwar BO": "263623",
      "Jhankarsaim BO": "263623",
      "Kafali Suwakhan BO": "263623",
      "Bergaon BO": "263678",
      "Dhaularh BO": "263637",
      "Dhaunigarh BO": "263637",
      "Jhupulchaura BO": "263637",
      "Lod BO": "263637",
      "Gananath Vidyapeeth BO": "263628",
      "Mangdoli BO": "263645",
      "Amyari BO": "263645",
      "Silor Mahadev BO": "263645",
      "Chaukuni BO": "263645",
      "Pantkotuli BO": "263645",
      "Binta BO": "263621",
      "Naulakote BO": "263621",
      "Machhor BO": "263646",
      "Dabhra BO": "263667",
      "Jamoli BO": "263667",
      "Kunhil BO": "263667",
      "Timtha BO": "263660",
      "Rikhon BO": "263659",
      "Uprari Chaukote BO": "263659",
      "Daurakhal BO": "263664",
      "Kanoli BO": "263664",
      "Bhatkote BO": "263656",
      "Bheltgaon BO": "263656",
      "Naikana BO": "263658",
      "Naula BO": "263658",
      "Sanara BO": "263658",
      "Nail Chaukote BO": "263665",
      "Jhimar BO": "263676",
      "Kafalta Malla BO": "263676",
      "Khumar BO": "263676",
      "Maithani BO": "263676",
      "Basai BO": "263661",
      "Bisrakhet BO": "263661",
      "Jalali ED BO": "263653",
      "Mahakaleshwar BO": "263653",
      "Bhagoti BO": "263656",
      "Dhamdewal BO": "263656",
      "Jairambakhal BO": "263656",
      "Jaurasi BO": "263656",
      "Khira BO": "263656",
      "Marku Bakhal BO": "263656",
      "Dwarson BO": "263652",
      "Timilkhal BO": "263658",
      "Bawari Kichar BO": "263665",
      "Chamkana BO": "263676",
      "Garkote Malla BO": "263676",
      "Painsia BO": "263676",
      "Chachroti BO": "263661",
      "Jayanteshwar Simalchaura BO": "263661",
      "Tamadhaun BO": "263661",
      "Kotar BO": "263663",
      "Shishuwa BO": "263663",
      "Godi BO": "263656",
      "Aina BO": "263652",
      "Ratgal BO": "263652",
      "Rotapani BO": "263658",
      "Turachaura BO": "263658",
      "Airari Bisht BO": "263665",
      "Bhyari BO": "263676",
      "Debikhal BO": "263676",
      "Manhet BO": "263676",
      "Gudlekh BO": "263661",
      "Kelani BO": "263661",
      "Udepur BO": "263661",
      "Sauni BO": "263663",
      "Khalna BO": "263653",
      "Nagarjhan BO": "263653",
      "Paithani BO": "263653",
      "Sure BO": "263653",
      "Chhitar BO": "263656",
      "Khatyari BO": "263656",
      "Panduwakhal BO": "263656",
      "Rampur BO": "263656",
      "Taragtal BO": "263656",
      "Bhainsoli BO": "263652",
      "Kulsibi BO": "263652",
      "Kuwali BO": "263652",
      "Gairkhet BO": "263658",
      "Jharkote BO": "263658",
      "Amdhar BO": "263676",
      "Bangidhar BO": "263676",
      "Pipna BO": "263676",
      "Khadalgaon BO": "263661",
      "Kulanteshwar BO": "263661",
      "Patharkhola BO": "263661",
      "Pipalkhal BO": "263661",
      "Rudoli BO": "263661",
      "Saraikhet BO": "263661",
      "Bayeri BO": "263663",
      "Billekh BO": "263663",
      "Ranikhet HO": "263645",
      "Almora HO": "263601",
      "Hawalbagh SO": "263636",
      "Kosi SO Almora": "263643",
      "Manan SO": "263638",
      "Takula SO": "263628",
      "Bhikiyasen SO": "263667",
      "Chaubattia SO": "263651",
      "Daula SO": "263660",
      "Deghat SO": "263659",
      "Ranikhet Kutchery SO": "263645",
      "Syalde SO": "263661",
      "Almora Court SO": "263601",
      "Barechhina SO": "263624",
      "Dania SO": "263622",
      "Lala Bazar SO": "263601",
      "Panuwanaula SO": "263623",
      "Shitalakhet SO": "263678",
      "Someshwar SO": "263637",
      "Bagwalipokhar SO": "263621",
      "Dwarahat SO": "263653",
      "Ganai SO": "263656",
      "Matela SO": "263665",
      "Maulekhal SO": "263676",
      "Daulaghat SO": "263655",
      "Jainti SO": "263626",
      "Laxmeshwar SO": "263601",
      "Pokharkhali SO": "263601",
      "Lamgara SO": "263625",
      "Bhatronjkhan SO": "263646",
      "Deolikhet SO": "263664",
      "Majkhali SO": "263652",
      "Masi SO": "263658",
      "Tarikhet SO": "263663",
      "Baldhoti SO": "263601",
      "Chanoda SO": "263629",
      "Vikas Bhawan Almora SO": "263601",
      "Chaunallia SO": "263680",
      "Ranikhet Sadar Bazar SO": "263645"
    },
    "UDAM SINGH NAGAR": {
      "Kunda BO": "244713",
      "Bhanga BO": "263148",
      "Darau BO": "263148",
      "Deoria BO": "263148",
      "Gokul Nagar BO": "263148",
      "Kunwarpur Sisaya BO": "263148",
      "Lalpur BO": "263148",
      "Chattarpur BO": "263153",
      "Ghusari BO": "262405",
      "Lamakhera BO": "262405",
      "Nakulia BO": "262405",
      "Pandari BO": "262405",
      "Shivrajpur BO": "244713",
      "Spinning Mill Kashipur BO": "244713",
      "Sultanpur BO": "244713",
      "Manua Patti BO": "263148",
      "Narayanpur BO": "263148",
      "Pratappur BO": "262311",
      "Shantpuri BO": "263148",
      "Haldi Udham Singh Nagar BO": "263145",
      "Patharchatta BO": "263145",
      "Bhurarani BO": "263153",
      "Kundeshwari BO": "244713",
      "Industrial Area Kashipur BO": "244713",
      "Bara BO": "263148",
      "Bhuria Coloney BO": "263148",
      "Uttamnagar BO": "263148",
      "Bhagwant Nagar BO": "244924",
      "Danpur BO": "263153",
      "TC Rudarpur BO": "263153",
      "Baruabagh BO": "262405",
      "Bijitipattia BO": "262405",
      "SAI Camp BO": "262405",
      "Gidhaur BO": "262308",
      "Jamaur BO": "262308",
      "Jhankat BO": "262308",
      "Khali Mahuwat BO": "262308",
      "Lohia Head BO": "262308",
      "Kaushal Ganj BO": "244923",
      "Khanpur BO": "263153",
      "Bidora BO": "262405",
      "Sisona BO": "262405",
      "Mahuwakhera BO": "244713",
      "Bagwara BO": "263148",
      "Nakatpura BO": "263148",
      "Sahdaura BO": "263148",
      "Suryanagar BO": "263148",
      "Uttarsia BO": "263148",
      "Beria Majhola BO": "262308",
      "Sarpuda Bagga Chauvan BO": "262308",
      "Bhura Kishani BO": "262308",
      "Chakarpur BO": "262308",
      "Naugaon Nath BO": "262308",
      "Nausar BO": "262308",
      "Sarasaria BO": "262311",
      "Bigra Bagh BO": "262308",
      "Charubetta BO": "262308",
      "Gaujhariya BO": "262308",
      "Naugaon Thagoo BO": "262308",
      "Sripur Bichwa BO": "262308",
      "Bhajuanagla BO": "262401",
      "Fauzi Coloney BO": "262401",
      "Adarshnagar BO": "263152",
      "Jhagarpuri BO": "263152",
      "Subashnagar BO": "263152",
      "Dharampur BO": "244712",
      "Dhakia No 1 BO": "244713",
      "Karanpur BO": "244713",
      "Bannakhera BO": "262401",
      "Barhani BO": "262401",
      "Kalinagar BO": "263160",
      "Majra Anand Singh BO": "263160",
      "Gadarpura BO": "263152",
      "Premnagar BO": "263152",
      "Barionwala BO": "244712",
      "Chaukhandi BO": "244713",
      "Dhanauri BO": "244713",
      "Ganeshnagar BO": "244713",
      "Gularbhoj BO": "262401",
      "Haripur Harsan BO": "262401",
      "Jogipura BO": "262401",
      "Mahuwadabara BO": "244712",
      "Doraha BO": "262401",
      "Gular Bhoj Canal Coloney BO": "262401",
      "Narainpur Dohania BO": "263152",
      "Raipur BO": "244712",
      "SM Nadehi SO": "244717",
      "SULTANPUR PATTI": "244720",
      "SF Bazpur SO": "262401",
      "Shaktifarm SO": "263151",
      "Sittarganj SO": "262405",
      "Hariawala Chauraha SO": "244713",
      "Nanakmatta SO": "262311",
      "Rudarpur SO": "263153",
      "Khatima SO": "262308",
      "31 Bn PAC Rudarpur SO": "263153",
      "COLLECTORATE PARISAR SO": "263153",
      "DF Nagla SO": "263149",
      "Gadarpur SO": "263152",
      "Jaspur SO": "244712",
      "Kashipur Udham Singh Nagar SO": "244713",
      "Kichha SO": "263148",
      "Bazpur SO": "262401",
      "RTC Hempur SO": "244716",
      "Kila Street SO": "244713",
      "Dineshpur SO": "263160",
      "Kelakhera SO": "263150",
      "Pantnagar SO": "263145"
    },
    "PAURI GARHWAL": {
      "Shivrajpur BO": "246149",
      "Binak BO": "246121",
      "Chai Damrara BO": "246121",
      "Chamkotkhal BO": "246121",
      "Devrana BO": "246121",
      "Khera BO": "246121",
      "Kimsar BO": "246121",
      "Pokhri Malla Udaipur BO": "246121",
      "Sar BO": "246121",
      "Ganga Bhogpur BO": "249306",
      "Mathana Bichala BO": "246127",
      "Syalinga BO": "246127",
      "Bamoli BO": "246128",
      "Bawansi BO": "246144",
      "Yamkeshwar BO": "246121",
      "Hanumanti BO": "246127",
      "Saurkhet BO": "246128",
      "Simlya BO": "246128",
      "Mandai BO": "246144",
      "Manjhyari BO": "246144",
      "Mohan Sankari BO": "246144",
      "Paranda BO": "246144",
      "Paukhal BO": "246144",
      "Simlana Malla BO": "246144",
      "Amola BO": "246121",
      "Dhansi BO": "246173",
      "Basola BO": "246275",
      "Bara BO": "246276",
      "Baundar Khutinga BO": "246276",
      "Devlad BO": "246277",
      "Digolikhal BO": "246277",
      "Jaraukhand BO": "246277",
      "Kinath Talla BO": "246277",
      "Kingorikhal BO": "246163",
      "Patotiya BO": "246277",
      "Toliyun BO": "246277",
      "Gaulikhal BO": "246279",
      "Manjhera Malla BO": "246279",
      "Parsoli BO": "246279",
      "Sankarpur BO": "246279",
      "Jhair BO": "246173",
      "Kandi BO": "246173",
      "Kathur Bara BO": "246173",
      "Sumersain BO": "246173",
      "Utinda BO": "246173",
      "Maral BO": "249304",
      "Mohanchatti BO": "249304",
      "Nail BO": "249304",
      "Neelkanth Mahadev BO": "249304",
      "Bansi BO": "246155",
      "Chundai BO": "246155",
      "Adhariyakhal BO": "246155",
      "Chamethakhal BO": "246155",
      "Mathali BO": "246155",
      "Dabri BO": "246155",
      "Kaligad BO": "246155",
      "Khanetha BO": "246155",
      "Jiwai BO": "246275",
      "Jogimarhi BO": "246275",
      "Ufaraikhal BO": "246275",
      "Jakhni Khatli BO": "246276",
      "Kamdai BO": "246276",
      "Kanda Talla BO": "246276",
      "Kanduli Bari BO": "246276",
      "Naun BO": "246276",
      "Silli BO": "246276",
      "Siroli BO": "246276",
      "Bhaun BO": "246277",
      "Gherwa BO": "246129",
      "Kandai BO": "246129",
      "Bachali BO": "246131",
      "Ira BO": "246131",
      "Raisoli BO": "246131",
      "Lokmanipur BO": "246149",
      "Jhandichaur BO": "246149",
      "Amsaur BO": "246149",
      "Padampur Motadhak BO": "246149",
      "Mawakot BO": "246149",
      "Kalalghati BO": "246149",
      "Nazibabad Road BO": "246149",
      "Badun BO": "246121",
      "Banchauri BO": "246121",
      "Heerakhal BO": "246121",
      "Thangar BO": "246121",
      "Rajbat BO": "246124",
      "Balli BO": "246127",
      "Diusa BO": "246146",
      "Pulyasu BO": "246113",
      "Dabolikhal BO": "246144",
      "Dhura Dhanai BO": "246144",
      "Kandakanikhal BO": "246144",
      "Syalna BO": "246144",
      "Gend BO": "246173",
      "Hathnoor BO": "246173",
      "Kinsur BO": "246173",
      "Diuli BO": "249304",
      "Asankhet BO": "246155",
      "Dhabhakhal BO": "246155",
      "Derikhal BO": "246155",
      "Sandhikhal BO": "246155",
      "Budhakot BO": "246275",
      "Dhaund BO": "246275",
      "Farsari BO": "246275",
      "Garkot Chhacharao BO": "246275",
      "Bhatwaron BO": "246276",
      "Gween BO": "246276",
      "Nakuri BO": "246276",
      "Sinduri BO": "246276",
      "Takulsari BO": "246276",
      "Adhora Walla BO": "246277",
      "Andrauli BO": "246277",
      "Ason BO": "246277",
      "Bandun BO": "246129",
      "Simar BO": "246131",
      "Mandoli Malli BO": "246193",
      "Devrajkhal BO": "246162",
      "Dharasu BO": "246162",
      "Irakhal BO": "246162",
      "Badiyargaon BO": "246179",
      "Bunga Talla BO": "246179",
      "Panikasain BO": "246179",
      "Sulmorikhal BO": "246179",
      "Timalsain BO": "246179",
      "Barkholu BO": "246172",
      "Kurigaon BO": "246172",
      "Naini BO": "246172",
      "Pundergaon BO": "246172",
      "Rithakhal BO": "246172",
      "Thalda BO": "246172",
      "Tilkholi BO": "246172",
      "Lachhi BO": "246278",
      "Jamnakhal BO": "246001",
      "Kyark BO": "246001",
      "Uziyari BO": "246001",
      "Chandolarain BO": "246001",
      "Bhainswara Ghandiyal BO": "246001",
      "Devikhal BO": "246149",
      "Balasaur BO": "246149",
      "Bhundkhal BO": "246161",
      "Chamara BO": "246161",
      "Kalinkakhal Kaleth BO": "246161",
      "Khadrasi BO": "246161",
      "Taria BO": "246161",
      "Chamnao BO": "246162",
      "Gawani BO": "246169",
      "Kolakhal BO": "246169",
      "Kunjkhal BO": "246169",
      "Chair Manjkhola BO": "246179",
      "Chaukuri BO": "246179",
      "Churani BO": "246179",
      "Kilbokhal BO": "246179",
      "Kherasain BO": "246172",
      "Kulhar BO": "246172",
      "Malethi BO": "246172",
      "Kasani BO": "246177",
      "Kota Mahadev BO": "246177",
      "Saindhar BO": "246177",
      "Chardhar BO": "246001",
      "Dhandri Bichli BO": "246001",
      "Dungrikhal BO": "246123",
      "Syoli Talli BO": "246123",
      "Tella BO": "246123",
      "Ranakot BO": "249301",
      "Baherakhal BO": "246146",
      "Bhandalu BO": "246146",
      "Jakh BO": "246147",
      "Nawakhal BO": "246147",
      "Pokhri Chalansyun BO": "246147",
      "Gaind BO": "246159",
      "Ghiri BO": "246159",
      "Karakot BO": "246159",
      "Jhatkandi BO": "246163",
      "DOVAL": "246167",
      "Kulasu BO": "249301",
      "Dungripanth BO": "246174",
      "Jaletha BO": "246174",
      "Kaliyasaur BO": "246174",
      "Bagwari BO": "246285",
      "Bhira BO": "246285",
      "Bungidhar BO": "246285",
      "Bagodgaon BO": "246121",
      "Timlibari BO": "246121",
      "Jameli BO": "246124",
      "Fatehpur BO": "246127",
      "Chelusain BO": "246128",
      "Gumkhal BO": "246128",
      "Birmoli BO": "246144",
      "Devikhet BO": "246144",
      "Gadsir BO": "246144",
      "Syalini Badron BO": "246144",
      "Garkot BO": "246173",
      "Gweel BO": "246173",
      "Mala BO": "249304",
      "Anganisain BO": "246155",
      "Kunjholi BO": "246155",
      "Dhauntiyal BO": "246155",
      "Bharnao BO": "246275",
      "Chaukhal BO": "246275",
      "Gadkharak Malla BO": "246275",
      "Jaspur BO": "246275",
      "Bhamraikhal BO": "246276",
      "Chandoli Malli BO": "246276",
      "Talai Khatli BO": "246276",
      "Apola BO": "246277",
      "Khutinda Malla BO": "246277",
      "Pipali Iriakot BO": "246277",
      "Khirarikhal BO": "246279",
      "Sald Mahadev BO": "246279",
      "Kotridhang BO": "246149",
      "Kumbhichaur BO": "246149",
      "Nimbuchaur BO": "246149",
      "Biyasi BO": "246161",
      "Moxan Uniyal BO": "246161",
      "Gadigaon BO": "246162",
      "Pinani BO": "246162",
      "Srikotkhal BO": "246131",
      "Gadiyunpul BO": "246179",
      "Takolikhal BO": "246179",
      "Bariyun BO": "246172",
      "Dandatalla BO": "246172",
      "Kandakhal Kauriya BO": "246172",
      "Sanglakoti BO": "246172",
      "Bangar BO": "246278",
      "Seramalla BO": "246278",
      "Kadola BO": "246177",
      "Girgaon BO": "246001",
      "Khandah BO": "246001",
      "Bareth BO": "246130",
      "Chaunra BO": "246130",
      "Bharsar BO": "246123",
      "Buransi BO": "246148",
      "Kalon BO": "246123",
      "Pinakot BO": "246123",
      "Sankarsain BO": "246123",
      "Jamri BO": "249301",
      "Sirala BO": "249301",
      "Kamalpur BO": "246194",
      "Kholachauri BO": "246194",
      "Salda BO": "246194",
      "Kimoli BO": "246113",
      "Tangroli BO": "246113",
      "Tairi BO": "246146",
      "Chamrara BO": "246147",
      "Jhanjhar BO": "246148",
      "Siron BO": "246163",
      "Tharapdhar BO": "246163",
      "Barkot BO": "246175",
      "Olna BO": "246175",
      "Bishald BO": "246164",
      "Champeshwar BO": "246164",
      "Nisni BO": "246164",
      "Sikukhal BO": "246165",
      "Bairhat Palla BO": "246161",
      "Bilkot BO": "246161",
      "Chamsain BO": "246161",
      "Bhimli Talli BO": "246166",
      "Pali BO": "246166",
      "Barsu BO": "246167",
      "Ringwari BO": "246167",
      "Sakinda BO": "246167",
      "Sason BO": "246167",
      "Masoor BO": "246174",
      "Sumari BO": "246174",
      "Ainthi BO": "246285",
      "Baundar BO": "246162",
      "Damadeval BO": "246162",
      "Jagsiakhal BO": "246162",
      "Pipali BO": "246162",
      "Bagrigar BO": "246169",
      "Pand BO": "246169",
      "Seriakhal BO": "246169",
      "Dhamdhar BO": "246179",
      "Dwari BO": "246179",
      "Gairoli BO": "246179",
      "Gudendi BO": "246179",
      "Naudanu BO": "246179",
      "Banghat BO": "246172",
      "Kharkoli BO": "246172",
      "Chorkinda Talla BO": "246177",
      "Gadwagad BO": "246001",
      "Khandusain BO": "246001",
      "Chopriun BO": "246001",
      "Kiwarsh BO": "246001",
      "Bangali BO": "246130",
      "Gadoli BO": "246130",
      "Bajwar BO": "246123",
      "Goda BO": "246123",
      "Patotee BO": "246123",
      "Sainji BO": "246123",
      "Dondal BO": "249301",
      "Muchiyali BO": "249301",
      "Silsu BO": "249301",
      "Pisoli BO": "246194",
      "Falda BO": "246113",
      "Thair BO": "246113",
      "Adwani BO": "246146",
      "Bughani BO": "246147",
      "Singori Kathuli BO": "246147",
      "Thandhar BO": "246147",
      "Dhandkur BO": "246148",
      "Bangaon Malla BO": "246159",
      "Gumain BO": "246159",
      "Raurkhal BO": "246163",
      "Soola BO": "246163",
      "Diusi BO": "246175",
      "Bidoli BO": "246164",
      "Molthi BO": "246165",
      "Uragi BO": "246165",
      "Kandara BO": "246166",
      "Nalai BO": "246166",
      "Bagyali BO": "246167",
      "Baunsal Talla BO": "246167",
      "Sarasu BO": "246167",
      "Langwalyun Bagar BO": "246174",
      "Bubakhal BO": "246001",
      "Bageli BO": "246130",
      "Banani BO": "246130",
      "Kathiur BO": "246130",
      "Mailli BO": "246130",
      "Nauri BO": "246130",
      "Chaplori BO": "246123",
      "Chaurikh BO": "246123",
      "Chopra  Kandarsyun BO": "246123",
      "Khand Malla BO": "246123",
      "Paithani BO": "246123",
      "Paral BO": "246123",
      "Rampur Chatti BO": "246125",
      "Ghindwara BO": "249301",
      "Kundi BO": "249301",
      "Dandapani BO": "246194",
      "Jamlakhal BO": "246194",
      "Bedgaon BO": "246113",
      "Nahsain BO": "246146",
      "Dewalgarh BO": "246147",
      "Masangaon BO": "246148",
      "Pundori BO": "246175",
      "Thapla BO": "246175",
      "Gadhkot BO": "246175",
      "Chair Malla BO": "246164",
      "Kalun BO": "246164",
      "Marora BO": "246164",
      "Tal BO": "246164",
      "Mason BO": "246167",
      "Matiyalna BO": "246167",
      "Pang BO": "246167",
      "Santudhar BO": "246167",
      "Satpali BO": "246167",
      "Sweet BO": "246174",
      "Dadoli Talli BO": "246285",
      "Kafald BO": "246285",
      "Mason Chauthan BO": "246285",
      "Ufalda BO": "246174",
      "Kulyani BO": "246285",
      "Riksal BO": "246285",
      "Agrora BO": "246176",
      "Chaurakhal BO": "246176",
      "Pipalpani BO": "246176",
      "Jainthi Dang BO": "246285",
      "Kaproli BO": "246285",
      "Pokhri Choprakot BO": "246285",
      "Pokhrikhet BO": "246176",
      "Kishanpur BO": "246149",
      "Kotdwara HO": "246149",
      "Lansdowne HO": "246155",
      "Pauri HO": "246001",
      "Dwarikhal SO": "246128",
      "BEL SO": "246149",
      "Dadamandi SO": "246124",
      "Kalagarh SO": "246142",
      "Kandakhal SO": "246144",
      "Baijrao A SO": "246275",
      "Bus Station Pauri SO": "246001",
      "Kamleshwar SO": "246174",
      "Kandoliya SO": "246001",
      "Kot SO Pauri Garhwal": "246148",
      "Lwali SO": "246159",
      "Naithana SO": "246175",
      "Parsundakhal SO": "246166",
      "Patisain SO": "246167",
      "Swargashram SO": "249304",
      "Dhumakot SO": "246277",
      "Dudharkhal SO": "246129",
      "Ekeshwar A SO": "246131",
      "Jahrikhal B SO": "246193",
      "Rikhnikhal A SO": "246179",
      "Satpuli SO": "246172",
      "Devprayag SO": "249301",
      "Srikot SO": "246178",
      "Silogi SO": "246173",
      "Bironkhal A SO": "246276",
      "Nainidanda B SO": "246161",
      "Pokhra A SO": "246169",
      "Chipalghat A SO": "246123",
      "GB Pant Engg College SO": "246194",
      "Kalzikhal SO": "246113",
      "Khirshu SO": "246147",
      "Mawadhar SO": "246163",
      "Paidul SO": "246165",
      "Srinagar SO Pauri Garhwal": "246174",
      "Toli SO": "246176",
      "Bhrigukhal A SO": "246121",
      "Dugadda SO": "246127",
      "Laxmanjhula B SO": "249302",
      "Padampur Sukhro": "246150",
      "Dungri SO Pauri Garhwal": "246279",
      "Naugaonkhal SO": "246162",
      "Syunsinagar SO": "246278",
      "Vedikhal SO": "246177",
      "Chakisain B SO": "246130",
      "Dehalchauri SO": "246125",
      "Kanskhet SO": "246146",
      "Pabau B SO": "246164",
      "Thalisain SO": "246285",
      "Upper Bazar SO": "246001",
      "Chila Colony SO": "249306",
      "Kotdwara Railway Station SO": "246149"
    },
    "NAINITAL": {
      "Padrani BO": "263126",
      "Pania Mehta BO": "263126",
      "Anandnagar BO": "244716",
      "Chhoi BO": "244715",
      "Karanpur BO": "244715",
      "Nalni BO": "263001",
      "Pangoot BO": "263001",
      "Babiyar BO": "263136",
      "Banana BO": "263136",
      "Chanfi BO": "263136",
      "Gagar BO": "263137",
      "Joshyua BO": "263132",
      "Kainchi BO": "263132",
      "Kashialekh BO": "263137",
      "Mehragaon BO": "263132",
      "Maldhanchaur BO": "244713",
      "Amritpur BO": "263126",
      "Damuadhunga BO": "263126",
      "Harishtal BO": "263126",
      "Okhaldhunga BO": "263126",
      "Dohania BO": "263159",
      "Don BO": "263159",
      "Gintigaon BO": "263159",
      "Patalia BO": "263159",
      "Chilkia BO": "244715",
      "Simalkhalia BO": "244715",
      "Rinchi BO": "263134",
      "Sethi Belgaon BO": "263134",
      "Sunsyari BO": "263134",
      "Unchakote BO": "263134",
      "Jangaliagaon BO": "263136",
      "Nakuchiatal BO": "263136",
      "Pokharar BO": "263136",
      "Sattal Seasonal  BO": "263136",
      "Dogara BO": "263126",
      "Rausila BO": "263126",
      "Ranibagh BO": "263126",
      "Amghari BO": "263159",
      "Sanana BO": "263159",
      "Syat BO": "263159",
      "Thari BO": "244716",
      "Bhairongkhal BO": "244715",
      "Dhikala Nc ParkSeasonal BO": "244715",
      "Dhikuli BO": "244715",
      "Peerumadra BO": "244715",
      "Khurpatal BO": "263001",
      "Haldiyani BO": "263134",
      "Dhari BO": "263136",
      "Jaikhola BO": "263136",
      "Padampuri BO": "263136",
      "Bhatalia BO": "263137",
      "Nai BO": "263132",
      "Paharpani BO": "263132",
      "Talla Bardho BO": "263135",
      "Mauna BO": "263138",
      "Nayeli BO": "263138",
      "Pyura BO": "263138",
      "Badon BO": "263157",
      "Jamani BO": "244715",
      "Mohan BO": "244715",
      "Manorapeak BO": "263001",
      "Ghangreti BO": "263134",
      "Bhumiadhar BO": "263132",
      "Dhaniakote BO": "263135",
      "Garjoli BO": "263135",
      "Jurasi Kutali BO": "263135",
      "Lohali BO": "263135",
      "Bist Estatre BO": "263127",
      "Nathuwakhan BO": "263158",
      "Deoli BO": "263157",
      "Jhargaon BO": "263157",
      "Khansyon BO": "263157",
      "Patlot BO": "263157",
      "Sui BO": "263157",
      "Hairakhan BO": "263126",
      "Bajunia Haldu BO": "263159",
      "Patkote BO": "263159",
      "Saur BO": "263159",
      "Dhela BO": "244715",
      "Khairali BO": "263134",
      "Churigarh BO": "263136",
      "Gunialekh BO": "263136",
      "Pandey Gaon BO": "263136",
      "Pokhari BO": "263136",
      "Dhanachuli BO": "263132",
      "Nartola BO": "263132",
      "Satbungs BO": "263137",
      "Supi BO": "263137",
      "Simalkha BO": "263135",
      "Suyal Bari BO": "263135",
      "Chopra BO": "263127",
      "Hartola BO": "263158",
      "Jhutia BO": "263158",
      "Adhora BO": "263157",
      "Kala Agar BO": "263157",
      "Suwakote Pokhari BO": "263157",
      "Tushrar BO": "263157",
      "Bel BO": "263128",
      "Sargakhet BO": "263137",
      "Sunderkhal BO": "263132",
      "Ratighat BO": "263135",
      "Simrar BO": "263135",
      "Gethia BO": "263127",
      "Dhyari BO": "263138",
      "Devdwar BO": "263158",
      "Amjhar BO": "263157",
      "Dalkania BO": "263157",
      "Padampur BO": "263157",
      "Surang BO": "263157",
      "Talli Pokhari BO": "263157",
      "Anandpur BO": "263139",
      "Fathepur BO": "263139",
      "Chakalua BO": "263139",
      "Indranagar BO": "263139",
      "Mota Haldu BO": "263139",
      "Gabuwa BO": "263140",
      "Pawalgarh BO": "263140",
      "DAULATPUR BO": "263139",
      "Bari Mukhani BO": "263139",
      "Kathgharia BO": "263139",
      "Manpur Paschim BO": "263139",
      "Dewalchaur BO": "263140",
      "Chausala BO": "263139",
      "Chorgalia BO": "263139",
      "Kamaluwaganja BO": "263139",
      "Bail Parao BO": "263140",
      "Bailpokhra BO": "263140",
      "Dhamola BO": "263140",
      "Arjunpur BO": "263139",
      "Industrial Estate BO": "263139",
      "Kunwarpur BO": "263139",
      "Lamachaur BO": "263139",
      "Kamola BO": "263140",
      "KISHANPUR BO": "263139",
      "Nainital HO": "263001",
      "Haldwani HO": "263139",
      "Betalghat SO": "263134",
      "Jeolikote SO": "263127",
      "Kumaon University Nainital SO": "263001",
      "Okhalkanda SO": "263157",
      "Vidyalayee Siksha Parisad Ramnagar": "244715",
      "Halduchaur S.O": "263142",
      "Bhowali SO": "263132",
      "High Court SO Nainital": "263001",
      "Narain Swamy Ashram SO": "263158",
      "Ramgarh SO Nainital": "263137",
      "Garampani SO": "263135",
      "Ghorakhal SO": "263156",
      "MukteshwarKumaon SO": "263138",
      "Nainital Kutchert Nainital SO": "263001",
      "Bhimtal SO": "263136",
      "Patwadanger SO": "263128",
      "Tallital SO": "263001",
      "Bareilly Road SO": "263139",
      "Kaladhungi Road SO": "263139",
      "Kaladhungi SO": "263140",
      "Kathgodam SO": "263126",
      "Kotabagh SO": "263159",
      "Bindhukhatta SO": "262402",
      "Kusumkhera SO": "263139",
      "Painth Parao SO": "263139",
      "Ramnagar SO Nainital": "244715",
      "Bhotia Parao SO": "263139",
      "Lalkua SO": "262402"
    },
    "CHAMPAWAT": {
      "Banbassa Canal BO": "262310",
      "Dhaun BO": "262523",
      "Swala BO": "262523",
      "Fungar BO": "262523",
      "Kotkendri BO": "262523",
      "Shyamlatal BO": "262523",
      "Sukhidhang BO": "262523",
      "Bhudam BO": "262523",
      "Rithakhal BO": "262580",
      "Manch BO": "262523",
      "Neer BO": "262523",
      "Pungla Amori BO": "262523",
      "Riyansi BO": "262523",
      "Gagar BO": "262580",
      "Dudhpokhra BO": "262523",
      "Kotajamrari BO": "262523",
      "Maurari BO": "262523",
      "Ramaila BO": "262523",
      "Saindark BO": "262523",
      "Simiyan BO": "262523",
      "Tamli BO": "262523",
      "Dholigaon BO": "262580",
      "Timla BO": "262580",
      "Ghat BO": "262529",
      "Chanda Regru BO": "262525",
      "Sungarkhal BO": "262527",
      "Chalthi BO": "262523",
      "Deuri BO": "262523",
      "Dhamisaun BO": "262523",
      "Jankandey BO": "262528",
      "Kanakote BO": "262528",
      "Madhuwa BO": "262524",
      "Madlak BO": "262524",
      "Mayawati BO": "262524",
      "Nidil BO": "262524",
      "Pulhindola BO": "262524",
      "Rausal BO": "262524",
      "Shillinga BO": "262524",
      "Chirra BO": "262525",
      "Mau BO": "262525",
      "Bardakhan BO": "262527",
      "Kothera BO": "262527",
      "Raigaon BO": "262527",
      "Bhingrara BO": "262528",
      "Birgul BO": "262528",
      "Machiyar BO": "262528",
      "Bibil BO": "262524",
      "Digalichaur BO": "262524",
      "Gallagaon BO": "262524",
      "Khateramalla BO": "262524",
      "Koyati BO": "262524",
      "Bhumwari BO": "262561",
      "Chauramehta BO": "262528",
      "Bagoti BO": "262524",
      "Chilkote BO": "262524",
      "Dhorja BO": "262524",
      "Khunabora BO": "262524",
      "Leti BO": "262524",
      "Thanta BO": "262524",
      "Sango BO": "262561",
      "Jhudeli BO": "262561",
      "Bapru BO": "262525",
      "Chaumel BO": "262525",
      "Bisrari BO": "262527",
      "Dhunaghat BO": "262528",
      "Gunthgarsari BO": "262528",
      "Banku BO": "262524",
      "Bhumlai BO": "262524",
      "Galchaura BO": "262524",
      "Ijara BO": "262524",
      "Karnkarayat BO": "262524",
      "Mulakote BO": "262561",
      "Simalkhet BO": "262561",
      "Chaurakote BO": "262561",
      "Abbotmount SO": "262525",
      "Devidhura SO": "262580",
      "Champawat SO": "262523",
      "Khetikhan SO": "262528",
      "Lohaghat SO": "262524",
      "Tanakpur SO": "262309",
      "Barakote SO": "262527",
      "Pati SO": "262561",
      "Collectorate Parisar": "262523",
      "Chandani SO": "262310"
    },
    "BAGESHWAR": {
      "Bhatoli BO": "263642",
      "Chirang BO": "263642",
      "Doba Katyur BO": "263642",
      "Gadera BO": "263642",
      "Jaulkande BO": "263642",
      "Purkuni BO": "263642",
      "Tuper BO": "263642",
      "Deonai BO": "263641",
      "Kapkoti BO": "263641",
      "Okhalson BO": "263641",
      "Rawaikhal BO": "263641",
      "Darimthok BO": "263642",
      "Ghiroli BO": "263642",
      "Harbarh BO": "263642",
      "Harsila BO": "263642",
      "Jagthana BO": "263642",
      "Amsarkote BO": "263642",
      "Are BO": "263642",
      "Ason BO": "263642",
      "Bahuli BO": "263642",
      "Malta BO": "263642",
      "Mandalsera BO": "263642",
      "Anna BO": "263641",
      "Bamrari BO": "263641",
      "Bantoli BO": "263641",
      "Nachati BO": "263679",
      "Udera BO": "263642",
      "Degree College BO": "263642",
      "Matena BO": "263641",
      "Mostgaon BO": "263641",
      "Tilsari BO": "263641",
      "Gasi BO": "263679",
      "Guler BO": "263679",
      "Harsingiabaghar BO": "263679",
      "Kandhar BO": "263635",
      "Kotiyura BO": "263635",
      "Kulaon BO": "263635",
      "Maigri Estate BO": "263635",
      "Payya BO": "263635",
      "Sirkote BO": "263635",
      "Wajyula BO": "263635",
      "Baira BO": "263634",
      "Banlekh BO": "263634",
      "Horali BO": "263634",
      "Nargarha BO": "263679",
      "Baisani BO": "263642",
      "Bilonasera BO": "263642",
      "Dewalchaura BO": "263642",
      "Falyati BO": "263642",
      "Kanyalikote BO": "263642",
      "Pandrapali BO": "263642",
      "Queralli BO": "263642",
      "Bheta BO": "263641",
      "Gagarigole ED BO": "263641",
      "Patli BO": "263641",
      "Farsali BO": "263679",
      "Jhuni BO": "263679",
      "Lahur BO": "263679",
      "Supi BO": "263679",
      "Sumgarh BO": "263679",
      "Dewaldhar BO": "263630",
      "Bhilkote BO": "263635",
      "Jakhera BO": "263635",
      "Ratisera BO": "263635",
      "Junayal BO": "263634",
      "Harkote BO": "263679",
      "Khati BO": "263679",
      "Loharkhet BO": "263679",
      "Janoti Palari BO": "263630",
      "Charson BO": "263635",
      "Pinglow BO": "263635",
      "Salani BO": "263635",
      "Jarati BO": "263634",
      "Kafali BO": "263634",
      "Bhataura BO": "263619",
      "Tachhani BO": "263619",
      "Khantoli BO": "263640",
      "Malsoona BO": "263640",
      "Syankote BO": "263640",
      "Bijaipur BO": "263640",
      "Nargoli BO": "263631",
      "Sani Udiyar BO": "263631",
      "Simkuna BO": "263631",
      "Badiakote BO": "263632",
      "Daula BO": "263632",
      "Kantali BO": "263639",
      "Lathi BO": "263633",
      "Namtichetabagar BO": "263633",
      "Bauri BO": "263628",
      "Chhani BO": "263628",
      "Khaulsir BO": "263628",
      "Simsyari BO": "263628",
      "Papon BO": "263634",
      "Chamarthal BO": "263619",
      "Chaura BO": "263619",
      "Dhapolasera BO": "263631",
      "Jethai BO": "263631",
      "Khatigaon BO": "263631",
      "Saneti BO": "263634",
      "Sangarh BO": "263634",
      "Gairar BO": "263619",
      "Gurna Kamsyar BO": "263619",
      "Bhantola BO": "263640",
      "Dhapti BO": "263640",
      "Jakhani BO": "263640",
      "Jhankra BO": "263640",
      "Rawatsera BO": "263631",
      "Uprara BO": "263631",
      "Karmi BO": "263632",
      "Lili BO": "263632",
      "Pothing BO": "263632",
      "Sorag BO": "263632",
      "Utraura BO": "263632",
      "Laubanj BO": "263639",
      "Naughar Estate BO": "263639",
      "Bhanar BO": "263633",
      "Gogina BO": "263633",
      "Kanoli BO": "263633",
      "KhetiDanpur BO": "263633",
      "Kafaligair BO": "263628",
      "Kathpurchhina BO": "263628",
      "Khankar BO": "263628",
      "Lob BO": "263628",
      "Bhairu Chaubatta BO": "263619",
      "Syaldova BO": "263619",
      "Mahruri BO": "263640",
      "Simgari BO": "263640",
      "Dewal Bichral BO": "263631",
      "Kapoori BO": "263631",
      "Mantoli BO": "263631",
      "Baghar BO": "263632",
      "Fulwari BO": "263632",
      "Lakhani BO": "263639",
      "Liti BO": "263633",
      "Ratirketi BO": "263633",
      "Ason Mallakote BO": "263628",
      "Bohala BO": "263628",
      "Okhalisirod BO": "263628",
      "Kameridevi SO": "263640",
      "Kanda SO": "263631",
      "Baijnath SO Bageshwar": "263641",
      "Billori SO": "263630",
      "Dangoli SO": "263635",
      "Dofar SO": "263634",
      "Ghingartola SO": "263619",
      "Kausani SO": "263639",
      "Shama SO": "263633",
      "Bageshwar SO": "263642",
      "Collectorate Bageshwar SO": "263642",
      "Bharari SO": "263679",
      "Kapkote SO": "263632",
      "Kausani Estate SO": "263620"
    },
    "PITHORAGARH": {
      "Gunji BO": "262546",
      "Rautera BO": "262522",
      "Rawalkhet BO": "262522",
      "Sinlekh BO": "262522",
      "Rasaipata BO": "262542",
      "Surauli BO": "262542",
      "Syankuri BO": "262545",
      "Tawaghat BO": "262545",
      "Teejam BO": "262545",
      "Atalgaon BO": "262551",
      "Bajani BO": "262551",
      "Bhanara BO": "262551",
      "Boragaon BO": "262551",
      "Kirauli BO": "262551",
      "Dhapna BO": "262532",
      "Dharidhumlakote BO": "262532",
      "Gaulchaura BO": "262532",
      "Ghorasil BO": "262532",
      "Rungari BO": "262532",
      "Saliya BO": "262532",
      "Sera Badoli BO": "262532",
      "Jakhniupreti BO": "262522",
      "Kamad BO": "262522",
      "Kanara BO": "262522",
      "Kandarachina BO": "262522",
      "Bisharh BO": "262502",
      "Bungachinna BO": "262542",
      "BalingS BO": "262545",
      "Jumma BO": "262545",
      "Ramtoli BO": "262545",
      "Sela BO": "262545",
      "Adichaura BO": "262551",
      "Bagjibala BO": "262551",
      "Borabunga BO": "262551",
      "Chaubati BO": "262551",
      "Lakhatigaon BO": "262551",
      "Banspatan BO": "262532",
      "Deoraripant BO": "262532",
      "Jakheri BO": "262532",
      "Birgoli BO": "262522",
      "Bungli BO": "262522",
      "Dasaithal GDS BO": "262522",
      "Duni BO": "262522",
      "Guptari BO": "262522",
      "Kharki Bajyura BO": "262522",
      "Khirmandey BO": "262522",
      "Kothera BO": "262522",
      "Chamu BO": "262542",
      "Pathrauli BO": "262542",
      "Dar BO": "262545",
      "DugtuS BO": "262545",
      "Garguwa BO": "262545",
      "Goe BO": "262545",
      "Khet BO": "262545",
      "Marchha BO": "262545",
      "Nagling BO": "262545",
      "Pamsyari BO": "262551",
      "Sandeo BO": "262551",
      "Saugaon BO": "262551",
      "Chaunala BO": "262522",
      "Chaurpal BO": "262522",
      "Chitgal BO": "262522",
      "Daulawalia BO": "262522",
      "Mauna BO": "262522",
      "Naichuna Bussail BO": "262522",
      "Nali BO": "262522",
      "Nanoli BO": "262522",
      "Pawwadhar BO": "262522",
      "Jhuni BO": "262501",
      "Pokhri BO": "262522",
      "Timta BO": "262522",
      "Paun BO": "262502",
      "Algara BO": "262542",
      "Bamdoli BO": "262542",
      "Urai BO": "262542",
      "BaunS BO": "262545",
      "Jamku BO": "262545",
      "Khela BO": "262545",
      "Ranthi Boragaon BO": "262545",
      "Suwa BO": "262545",
      "Jaurasi BO": "262551",
      "Naghar BO": "262551",
      "Panthyali BO": "262551",
      "Sinichama BO": "262551",
      "Bankote BO": "262532",
      "Batgari BO": "262532",
      "Kunalta BO": "262532",
      "Bhuwaneshwar BO": "262522",
      "Boyal BO": "262522",
      "Chahaj BO": "262522",
      "Dugai Agar BO": "262522",
      "Ganura BO": "262522",
      "Khulet BO": "262522",
      "Mallagarkha BO": "262522",
      "Toli BO": "262544",
      "Salla BO": "262529",
      "Daubans BO": "262540",
      "Dhaulkanda BO": "262540",
      "Garhgaon BO": "262540",
      "Markharayat BO": "262540",
      "Marmanley BO": "262540",
      "Baste BO": "262501",
      "Jajurali BO": "262501",
      "Chandak BO": "262501",
      "Daulaupreti BO": "262534",
      "Jarapani BO": "262534",
      "Nagaur BO": "262534",
      "Barabey GDSBO": "262530",
      "Jakhpuran BO": "262530",
      "Ajera BO": "262543",
      "Chausal BO": "262543",
      "Charchum BO": "262576",
      "Guiyyan BO": "262576",
      "Khumti BO": "262576",
      "Kharik BO": "262555",
      "Selmali BO": "262555",
      "Belkote BO": "262531",
      "Gartir BO": "262531",
      "Kandey BO": "262531",
      "Pipali Jabuka BO": "262531",
      "Raitoli BO": "262531",
      "Chingri BO": "262529",
      "Barmau BO": "262540",
      "Bhauri BO": "262540",
      "Bishonakhan BO": "262541",
      "Chanoli BO": "262541",
      "Charandeo BO": "262541",
      "Daura BO": "262541",
      "Pipali BO": "262541",
      "Bauna BO": "262554",
      "BurfuS BO": "262554",
      "Chauna BO": "262534",
      "Dhunamani BO": "262554",
      "Simkhola BO": "262547",
      "Sirkha BO": "262547",
      "Sosa BO": "262547",
      "Bhainskote BO": "262553",
      "Dekuna BO": "262553",
      "Dor BO": "262553",
      "Girgaon BO": "262553",
      "Hokra BO": "262553",
      "Sainranthi BO": "262553",
      "Namik BO": "262553",
      "Balgari BO": "262552",
      "Himtarh BO": "262529",
      "Rarikhunti BO": "262529",
      "Sel BO": "262529",
      "Bhulgaon BO": "262540",
      "Bisabajerh BO": "262540",
      "Gaunch BO": "262540",
      "Satgarh BO": "262540",
      "Totanaula BO": "262540",
      "Baram BO": "262544",
      "Kandar BO": "262544",
      "Lumti BO": "262544",
      "Metli BO": "262544",
      "Bandarlima BO": "262541",
      "Dungri BO": "262555",
      "Gudauli BO": "262541",
      "Khwankote BO": "262541",
      "Nwalichainpur BO": "262541",
      "Narayan Nagar BO": "262550",
      "Josha BO": "262554",
      "Madkote BO": "262554",
      "Sain BO": "262554",
      "Kailash BO": "262547",
      "Pangla BO": "262547",
      "Dashauli BO": "262533",
      "Kotgari Ghanjri BO": "262533",
      "Khatera BO": "262553",
      "Nachni BO": "262553",
      "Hajeti BO": "262552",
      "Lejam BO": "262552",
      "Bagartoli BO": "262521",
      "Mazirkanda BO": "262521",
      "Bin BO": "262501",
      "Digtoli BO": "262501",
      "Ram Mandir BO": "262534",
      "Ghingrani BO": "262543",
      "Jethigaon BO": "262543",
      "Majhera BO": "262543",
      "Ogla BO": "262543",
      "Titari BO": "262543",
      "Panthgaon BO": "262576",
      "Payyanpauri BO": "262576",
      "Dhamigaon BO": "262555",
      "Sera BO": "262555",
      "Chankana BO": "262531",
      "Devinagar BO": "262531",
      "Dharamghar GDS BO": "262531",
      "Beltari BO": "262520",
      "Simalkote BO": "262520",
      "Baret BO": "262552",
      "Barsayat BO": "262552",
      "Pamtori BO": "262552",
      "Patet BO": "262552",
      "Selavan BO": "262552",
      "Panthuri BO": "262521",
      "Sakun BO": "262521",
      "Gobrari BO": "262572",
      "Tarigaon BO": "262572",
      "Binayak BO": "262572",
      "Bera BO": "262529",
      "Meldungri BO": "262529",
      "Bichhul BO": "262540",
      "Chaupata BO": "262540",
      "Satshilling BO": "262540",
      "Baikote BO": "262544",
      "Kauli BO": "262544",
      "Tham BO": "262544",
      "Govarsa BO": "262541",
      "Hachila BO": "262541",
      "Khwantari BO": "262541",
      "Malan BO": "262541",
      "Dummar BO": "262554",
      "Leelam BO": "262554",
      "Ranthi BO": "262554",
      "Walthi BO": "262554",
      "Jipti BO": "262547",
      "Kurila BO": "262547",
      "Chausala BO": "262533",
      "Lachhima BO": "262533",
      "Hupuli BO": "262553",
      "Madalkiya BO": "262553",
      "Bhantarh BO": "262552",
      "Bhateri BO": "262521",
      "Katiyani BO": "262521",
      "Munakote BO": "262521",
      "Quitarh BO": "262521",
      "Baralu BO": "262521",
      "Gaurihat BO": "262521",
      "Jakhpant BO": "262521",
      "Marh BO": "262521",
      "Pabhain BO": "262501",
      "Roripali BO": "262501",
      "Bans BO": "262501",
      "Nakote GDS BO": "262501",
      "Chamachaur BO": "262534",
      "Shilling BO": "262530",
      "Shillingatoli BO": "262530",
      "Tharkote BO": "262530",
      "Dhungatoli BO": "262576",
      "Kalika BO": "262576",
      "Gurburani BO": "262531",
      "Tharp BO": "262531",
      "Tripuradevi BO": "262531",
      "Udiyari BO": "262531",
      "Cherra BO": "262501",
      "Dungara BO": "262501",
      "Bhurmuni BO": "262501",
      "Guwal BO": "262534",
      "Koteshwar BO": "262534",
      "Chamali BO": "262530",
      "Baira BO": "262543",
      "Dangti BO": "262543",
      "Singali BO": "262543",
      "Fultari BO": "262576",
      "Mawani Dawani BO": "262555",
      "Samkote BO": "262555",
      "Chaukori BO": "262531",
      "Lohathal BO": "262531",
      "Naini BO": "262531",
      "Bilai BO": "262520",
      "Nainipatal BO": "262540",
      "Nainisaini BO": "262540",
      "Basaur BO": "262544",
      "Garali BO": "262544",
      "Jamtari BO": "262544",
      "Jarajibli BO": "262544",
      "MillamS BO": "262554",
      "Ringu Chilkote BO": "262554",
      "Sevila BO": "262554",
      "Uchhaiti BO": "262554",
      "BundiS BO": "262547",
      "Chalma Chilasu BO": "262547",
      "Merla Sangaur BO": "262533",
      "Okhrani BO": "262533",
      "Quiti GDS BO": "262553",
      "Bhatigaon BO": "262552",
      "Dangigaon BO": "262552",
      "Badari BO": "262521",
      "Baltari BO": "262521",
      "Seloni BO": "262521",
      "Serikumdar BO": "262521",
      "Sirkuch BO": "262521",
      "Khatigaon BO": "262501",
      "Bhandarigaon BO": "262572",
      "Kukrauli BO": "262572",
      "Pithoragarh HO": "262501",
      "Collectorate SO Pithoragarh": "262501",
      "Gangolihat SO": "262522",
      "Garbyang SO": "262546",
      "Gurna SO": "262529",
      "Jauljibi SO": "262544",
      "Pangu SO": "262547",
      "Tejam SO": "262553",
      "Thal SO Pithoragarh": "262552",
      "Askote SO": "262543",
      "Baluwakote SO": "262576",
      "Bansbagar SO": "262555",
      "Dharchula SO": "262545",
      "Didihat SO": "262551",
      "Ganai Gangoli SO": "262532",
      "Jhulaghat SO": "262526",
      "Muwani SO": "262572",
      "Dewalthal SO": "262542",
      "Merthi SO": "262550",
      "Munsiari SO": "262554",
      "Shivalaya SO": "262501",
      "Siltham SO": "262501",
      "Agar SO": "262534",
      "Aincholi SO": "262530",
      "Berinag SO": "262531",
      "Bharkatia SO": "262520",
      "Degree College SO Pithoragarh": "262502",
      "Jajardewal SO": "262540",
      "Kanalichina SO": "262541",
      "Pankhu SO": "262533",
      "Wadda SO": "262521"
    },
    "TEHRI GARHWAL": {
      "Jaakhchoura BO": "249130",
      "Shanti Bazar BO": "249301",
      "Dalla Argrh BO": "249125",
      "Gadoliya BO": "249181",
      "Chamani BO": "249199",
      "Kyari BO": "249199",
      "Nakot BO": "249199",
      "Tingri BO": "249199",
      "Mundala BO": "249192",
      "Shivpuri BO": "249192",
      "Tapoban BO": "249192",
      "Mogi BO": "249186",
      "Pantwari BO": "249186",
      "Sendul BO": "249186",
      "Dwargarh BO": "249180",
      "Kinsoo BO": "249180",
      "Sirs BO": "249180",
      "Paurikhal BO": "249121",
      "Hinsriyakhal BO": "249126",
      "Aleru BO": "249131",
      "Okhla BO": "249131",
      "Raulakot BO": "249127",
      "Thauldhar BO": "249131",
      "Raurdhar BO": "249121",
      "Toli BO": "249121",
      "Souru BO": "249126",
      "Chherabdhar BO": "249127",
      "Ratnomalla BO": "249131",
      "Siyansu BO": "249132",
      "Jaulangi BO": "249130",
      "Kafal Pani BO": "249130",
      "Nail BO": "249130",
      "Pali BO": "249130",
      "Devtadhar BO": "249181",
      "Ghonti BO": "249181",
      "Mandar BO": "249181",
      "Lamkot BO": "249199",
      "Sabli BO": "249199",
      "Sweer BO": "249199",
      "Tungoli BO": "249199",
      "Dharkotudaikot BO": "249130",
      "Chotimani BO": "249131",
      "Dharkot Dharmandal BO": "249127",
      "Atali byasi BO": "249192",
      "Bachhelikhal BO": "249192",
      "Bairaigaon BO": "249192",
      "Banskatal BO": "249192",
      "Timli BO": "249192",
      "Maror BO": "249186",
      "Srikot BO": "249186",
      "Tikri BO": "249186",
      "Nelda BO": "249127",
      "Bhaldiyana BO": "249131",
      "Barkot BO": "249181",
      "Bhaatgaon BO": "249125",
      "Bhaneldi BO": "249125",
      "Kandikhal BO": "249131",
      "Madan Negi BO": "249127",
      "Pathiyana BO": "249127",
      "Saud Uppu BO": "249131",
      "Gulardogi BO": "249192",
      "Kakhoor BO": "249192",
      "Kaudiyala BO": "249192",
      "Kharsadi BO": "249192",
      "Kyara BO": "249192",
      "Manjiyari BO": "249192",
      "Kotipav BO": "249186",
      "Bangsil BO": "249180",
      "Bhalkatal BO": "249180",
      "Bhawan BO": "249180",
      "Chuliyani BO": "249180",
      "Parogi BO": "249180",
      "Chandreshwar BO": "249181",
      "Semandidhar BO": "249181",
      "Badshahithaul BO": "249199",
      "Hill Campus Pantnagar BO": "249199",
      "Bharpur BO": "249192",
      "Manderigaon BO": "249192",
      "Mindath BO": "249192",
      "Naidogi BO": "249192",
      "Silkani BO": "249192",
      "Myanilaloor BO": "249186",
      "Bangar BO": "249180",
      "Dhanolti BO": "249180",
      "Khyarsi BO": "249180",
      "Sadav BO": "249180",
      "Suwakholi BO": "249180",
      "Pangerkhal BO": "249001",
      "Gomukh BO": "249121",
      "Gyansoo BO": "249001",
      "Kuttha BO": "249001",
      "Garakot BO": "249121",
      "Panchoor BO": "249121",
      "Kumalda BO": "248008",
      "Tehri HO": "249001",
      "Bhigun BO": "249125",
      "Maid BO": "249125",
      "Sunargaon BO": "249125",
      "Anandchowk BO": "249145",
      "Chopriyalgaon BO": "249145",
      "Ringalgarh BO": "249145",
      "Maindkhal BO": "249132",
      "Nagrajadhar BO": "249196",
      "Amsari BO": "249146",
      "Chaka BO": "249146",
      "Kathud BO": "249146",
      "Sain BO": "249146",
      "Akhori BO": "249155",
      "Dangi BO": "249155",
      "Dhounikhal BO": "249155",
      "Kathoor BO": "249155",
      "Malgaon BO": "249155",
      "Purwalgaon BO": "249155",
      "Sankri BO": "249155",
      "Mahad BO": "249122",
      "Tipri BO": "249123",
      "Dharkot BO": "249161",
      "Ghandiyaldhar BO": "249161",
      "Kilkileshwar BO": "249161",
      "Maletha BO": "249161",
      "Nyuli BO": "249161",
      "Poukhal BO": "249161",
      "Khalargaon BO": "249165",
      "Kotalgaon BO": "249165",
      "Newsari BO": "249165",
      "Serabagwan BO": "249165",
      "Berni BO": "249175",
      "Duwadhar BO": "249175",
      "Gona BO": "249125",
      "Kandarsyun BO": "249125",
      "Kepars BO": "249125",
      "Kireth BO": "249125",
      "Tisriyara BO": "249125",
      "Bangiyal BO": "249132",
      "Kaushal BO": "249132",
      "Kothi BO": "249146",
      "Lawa BO": "249146",
      "Maroragad BO": "249146",
      "Beena BO": "249155",
      "Muyalgaon BO": "249155",
      "Odadhar BO": "249155",
      "Pangriyana BO": "249155",
      "Pokhar BO": "249155",
      "Bhainskot BO": "249122",
      "Durogi BO": "249122",
      "Jamnikhal BO": "249122",
      "Kundri BO": "249122",
      "Laloorikhal BO": "249122",
      "Sinwalidhar BO": "249122",
      "Chheti BO": "249123",
      "Patniyadevi BO": "249123",
      "Pipola BO": "249123",
      "Badon BO": "249161",
      "Chaurikhal BO": "249161",
      "Daang BO": "249161",
      "Dangchoura BO": "249161",
      "Jakhand BO": "249161",
      "Jakhidagar BO": "249161",
      "Kafna BO": "249161",
      "Pratap Nagar BO": "249165",
      "Raika BO": "249165",
      "Raimer BO": "249165",
      "Raunad BO": "249165",
      "Agar BO": "249175",
      "Bagi BO": "249175",
      "Banali BO": "249175",
      "Jardhargaon BO": "249175",
      "Nagni BO": "249175",
      "Odada BO": "249175",
      "Yamunapul BO": "248158",
      "Binaykhal BO": "249125",
      "Kafolgaon BO": "249125",
      "Khawara BO": "249125",
      "Kothiyara BO": "249125",
      "Sounp BO": "249125",
      "Bahera BO": "249145",
      "Hatwalgaon BO": "249145",
      "Kotmaniyar BO": "249145",
      "Saud BO": "249145",
      "Uniyalgaon BO": "249145",
      "Lawani BO": "249132",
      "Sarot BO": "249132",
      "Jakholi BO": "249146",
      "Naicholi BO": "249146",
      "Shantipur Sondi BO": "249146",
      "Bajiyalgaon BO": "249155",
      "Bhatgaon BO": "249155",
      "Dhopardhar BO": "249155",
      "Maighadhar BO": "249155",
      "Malyakot BO": "249155",
      "Samangaon BO": "249155",
      "Siliyara BO": "249155",
      "Amni BO": "249122",
      "Palethi BO": "249122",
      "Tyuna BO": "249122",
      "Khandogi BO": "249123",
      "Radhudhar BO": "249123",
      "Badiyargarh BO": "249161",
      "Dhari Dhundsir BO": "249161",
      "Dugadda BO": "249161",
      "Khola BO": "249161",
      "Magron BO": "249161",
      "Silkakhal BO": "249161",
      "Kandiyalgaon BO": "249165",
      "Rouniya BO": "249165",
      "Chamolgaon BO": "249175",
      "Dyuli BO": "249175",
      "Mawana Kolti BO": "248179",
      "Kempty BO": "248179",
      "Jad Gaon BO": "249145",
      "Jamthiyal Gaon BO": "249145",
      "Kakhwari BO": "249145",
      "Kanatal BO": "249145",
      "Manjhgaon BO": "249145",
      "Nagdev Kudiyal Gaon BO": "249145",
      "Ragar Gaon BO": "249145",
      "Gairi BO": "249196",
      "Khand BO": "249146",
      "Palkot BO": "249146",
      "Pokhri BO": "249146",
      "Ranakot BO": "249146",
      "Bhatwara BO": "249155",
      "Chanji BO": "249155",
      "Dewath BO": "249155",
      "Falenda BO": "249155",
      "Ghuttu BO": "249155",
      "Hadiyanakholi BO": "249155",
      "Jakhnyali BO": "249155",
      "Thati BO": "249125",
      "Pujargaon BO": "249122",
      "Manjkot BO": "249161",
      "Takoli BO": "249161",
      "Talli Ringoli BO": "249161",
      "Thati Dagar BO": "249161",
      "Khambakhal BO": "249165",
      "Majaf BO": "249165",
      "Mukhem BO": "249165",
      "Thapla BO": "249165",
      "Fakot BO": "249175",
      "Jajal BO": "249175",
      "Sigunisera SO": "249186",
      "D P Bazar SO": "249301",
      "Tehri Kutchery SO": "249001",
      "Rajakhet SO": "249127",
      "Thatyur SO": "249180",
      "VKPuram SO": "249130",
      "Kamand SO": "249131",
      "Dhalwala SO": "249137",
      "Kirtinagar SO": "249161",
      "New Tehri Collectrate SO": "249001",
      "Bhagirathipuram SO": "249124",
      "Bhallegaon SO": "249126",
      "Ghansali SO": "249155",
      "Hindolakhal SO": "249122",
      "Gajja SO": "249146",
      "Lambgaon SO": "249165",
      "Munikireti SO": "249137",
      "Anjanisain SO": "249121",
      "Chamiyala SO": "249125",
      "Chamma SO": "249145",
      "Chham SO": "249132",
      "Narendra Nagar SO Tehri Garhwal": "249175",
      "Ranichauri SO": "249199",
      "Shivanand Nagar SO": "249192",
      "Jakhnidhar SO": "249123",
      "Pilkhi SO": "249181"
    },
    "UTTAR KASHI": {
      "Dhakara BO": "249185",
      "Gundiyatgaon BO": "249185",
      "Kantari BO": "249185",
      "Bhankoli BO": "249193",
      "Bonga BO": "249193",
      "Netala BO": "249193",
      "Pata BO": "249193",
      "Barsu BO": "249135",
      "Gangnani BO": "249135",
      "Rainthal BO": "249135",
      "Hanuman Chatti BO": "249141",
      "Jankimai Chatti BO": "249141",
      "Gorsali BO": "249135",
      "Harsil BO": "249135",
      "Jamunachatti BO": "249141",
      "Nagangaon BO": "249141",
      "Kunwa BO": "249171",
      "Odgaon BO": "249171",
      "Rikhaun BO": "249171",
      "Sarigad Khamundi BO": "249171",
      "Hudoli BO": "249185",
      "Moltari BO": "249185",
      "Jhalla BO": "249135",
      "Bhansadi BO": "249141",
      "Gangani BO": "249141",
      "Gangtari BO": "249141",
      "Pujeli BO": "249141",
      "Rajgarhi BO": "249141",
      "Rana BO": "249141",
      "Boun BO": "249193",
      "Gangori BO": "249193",
      "Gawana BO": "249193",
      "Kaldiyani BO": "249193",
      "Raturisera BO": "249193",
      "Sald BO": "249193",
      "Uttaron BO": "249193",
      "Malla BO": "249135",
      "Gadoli BO": "249152",
      "Kharsali BO": "249141",
      "Pounthi BO": "249141",
      "Matli BO": "249193",
      "Kotiyalgaon BO": "249171",
      "Devjani BO": "249185",
      "Gadugad BO": "249185",
      "Bharangaon BO": "249193",
      "Manpur BO": "249193",
      "Mustik Sour BO": "249193",
      "New Barsali BO": "249193",
      "Badhangaon BO": "249196",
      "Baldogi BO": "249196",
      "Kyari BO": "249196",
      "Katkhet BO": "249151",
      "Ranari BO": "249151",
      "Kalyani BO": "249152",
      "Manjgaon BO": "249152",
      "Srikot BO": "249152",
      "Thandi BO": "249165",
      "Maneri BO": "249194",
      "Bhutanu BO": "249128",
      "Chinwa BO": "249128",
      "Bhatiya BO": "249171",
      "Kalogi BO": "249171",
      "Kandari BO": "249171",
      "Sarnol BO": "249141",
      "Siguni BO": "249151",
      "Thatidhanari BO": "249151",
      "Bangaon BO": "249152",
      "Diwarikhol BO": "249152",
      "Dhountri BO": "249165",
      "Gangar BO": "249128",
      "Jakhol BO": "249128",
      "Masri BO": "249128",
      "Damta BO": "249171",
      "Dewal BO": "249171",
      "Bagori BO": "249196",
      "Dharashu BO": "249196",
      "Khaand BO": "249196",
      "Margaon BO": "249196",
      "Rounthal BO": "249196",
      "Kali Gaon BO": "249151",
      "Pujargaon BO": "249151",
      "Tipri BO": "249151",
      "Banchaura BO": "249152",
      "Khurmola BO": "249152",
      "Tarakot BO": "249152",
      "Bharkot BO": "249165",
      "Siree BO": "249165",
      "Latasera BO": "249194",
      "Soura BO": "249194",
      "Dhatmeer BO": "249128",
      "Bagasu BO": "249171",
      "Bhankoliranwain BO": "249171",
      "Kafnol BO": "249171",
      "Dichli BO": "249196",
      "Jogath BO": "249196",
      "Kansi BO": "249196",
      "Khalsi BO": "249196",
      "Bhatwaridhanari BO": "249151",
      "Folddhanari BO": "249151",
      "Hitanubhalshi BO": "249151",
      "Junga BO": "249152",
      "Kotdhar BO": "249152",
      "Naggaon BO": "249152",
      "Patara BO": "249152",
      "Udri BO": "249165",
      "Arakot BO": "249128",
      "Doni BO": "249128",
      "Fitari BO": "249128",
      "Naitwar BO": "249128",
      "Sankri BO": "249128",
      "Thadiyar BO": "249128",
      "Tikochi BO": "249128",
      "Diyari BO": "249171",
      "Gaatu BO": "249171",
      "Gangotri Seasonal SO": "249136",
      "Uttarkashi SO": "249193",
      "Uttarkashi Collectorate SO": "249193",
      "Joshiyara SO": "249193",
      "Burkot SO": "249141",
      "MD Colony SO": "249194",
      "Bhatwari SO": "249135",
      "Chinyalisour SO": "249196",
      "Dunda SO": "249151",
      "Gyansu SO": "249193",
      "Geonla SO": "249152",
      "Mori SO": "249128",
      "Mahidanda BO": "249195",
      "Naugaon SO": "249171",
      "Purola SO": "249185"
    },
    "HARIDWAR": {
      "Tikola Kalan BO": "247670",
      "Ambuwala BO": "249404",
      "Dhanpura BO": "249404",
      "Sarai BO": "249404",
      "Bhalswagaj BO": "247668",
      "Nalhera Anantpur BO": "247668",
      "Khanpur BO": "247663",
      "Mohd Pur Buzurg BO": "247663",
      "Toda Kalyanpur BO": "247664",
      "Mundlana BO": "247656",
      "Toda Banhera BO": "247656",
      "Ransura BO": "247670",
      "PATHRI BO": "249404",
      "Majhaul BO": "247665",
      "Makdoompur BO": "247665",
      "Sherpur Khelmau BO": "247665",
      "Missarpur BO": "249408",
      "Shyampur BO": "249408",
      "Munda Khera Kalan BO": "247663",
      "Prahaledpur BO": "247663",
      "Shahpur Shitlakhera BO": "247663",
      "Subhashgarh BO": "247663",
      "Sultanpur BO": "247663",
      "Libberheri BO": "247656",
      "Daulatpur BO": "249405",
      "Aithal BO": "247663",
      "Badshahpur BO": "247663",
      "Bhogpur BO": "247663",
      "Chandpuri BO": "247663",
      "Dabki Kalan BO": "247663",
      "Gordhanpur BO": "247663",
      "Bijholi BO": "247666",
      "Dandhera BO": "247666",
      "Brahmpur Khanpur BO": "247671",
      "Maharajpur Kalan BO": "247671",
      "Niranjanpur BO": "247671",
      "Podowali BO": "247671",
      "Bahdarpur Jatt BO": "249404",
      "Manakpur Adampur BO": "247668",
      "Kheri Mubarakpur BO": "247663",
      "Tansipur BO": "247656",
      "Bhikampur BO": "247671",
      "Banderjud BO": "247662",
      "Kheri Shikohpur BO": "247662",
      "Buggawala BO": "247662",
      "Hassanpur Madanpur BO": "247662",
      "Sohelpur Sikroda BO": "247667",
      "Kota Muradnagar BO": "247667",
      "Mewar Kalan BO": "247667",
      "Sikroda BO": "247661",
      "Saliyar BO": "247667",
      "Bharapur Bhori BO": "247667",
      "Manu Bas BO": "247667",
      "Hallumajra BO": "247661",
      "Khubbanpur BO": "247661",
      "Harchadpur Nizampur BO": "247670",
      "Narsan Kalan BO": "247670",
      "Srichandi BO": "247661",
      "Paniyala BO": "247667",
      "Belra BO": "247667",
      "Imalikhera BO": "247667",
      "Dhanauri BO": "247667",
      "Aurangabad BO": "249402",
      "Garhmirpur BO": "249402",
      "Ibrahimpur Masahi BO": "247661",
      "Sikandarpur Bainswal BO": "247661",
      "Mohmadpur Fall BO": "247670",
      "Rajupur BO": "247670",
      "Dandhera Khwajgipur BO": "247667",
      "Marghoobpur BO": "247667",
      "Piran Kaliyar BO": "247667",
      "Salempur Rajputana BO": "247667",
      "Ibrahimpur BO": "249402",
      "Rohalki BO": "249402",
      "Salempur Mehdood BO": "249402",
      "Chudiala BO": "247661",
      "Harjoli Jatt BO": "247670",
      "Khera Jatt BO": "247670",
      "Nagla Salaru BO": "247670",
      "Roorkee HO": "247667",
      "BHEL SO Haridwar": "249403",
      "Haridwar SO": "249401",
      "Jwalapur Town SO": "249407",
      "Laksar SO": "247663",
      "Roorkee Cantt SO": "247667",
      "Roshnabad Kutchery SO": "249403",
      "Sadhubela Bhupatwala SO": "249410",
      "Shantikunj SO": "249411",
      "Shivalik Nagar SO": "249403",
      "Training Battalian SO": "247667",
      "Bahadrabad SO": "249402",
      "Bhagwanpur SO Haridwar": "247661",
      "Landhaura SO": "247664",
      "Mayapur SO Haridwar": "249401",
      "Milap Nagar SO": "247666",
      "Patanjali Yogpeeth SO": "249405",
      "Arya Nagar SO Haridwar": "249407",
      "Ganesh Vatika SO": "247667",
      "Ganeshpur SO": "247667",
      "Gurkul Narsan SO": "247670",
      "Gurukul Kangri SO": "249404",
      "Gurukul Pharmecy SO": "249404",
      "IIT Roorkee SO": "247667",
      "Iqbalpur SO": "247668",
      "Kankhal SO": "249408",
      "Raisi SO": "247671",
      "Ramnagar SO Haridwar": "247667",
      "Roorkee Kutchery SO": "247667",
      "Sapper Bazar SO": "247667",
      "SectorIII BHEL SO": "249403",
      "Shanti Nagar SO": "247667",
      "Adm BlockBHEL SO": "249403",
      "Jhabrera SO": "247665",
      "Jwalapur SO": "249407",
      "Manglour Town SO": "247656",
      "Roorkee City SO": "247667"
    },
    "DEHRADUN": {
      "Pingua BO": "248199",
      "WhtI BO": "248198",
      "Badogal BO": "248143",
      "Dharkot BO": "248143",
      "NIVH BO": "248001",
      "Mohbewala BO": "248002",
      "Bullawala BO": "248140",
      "Fatehpur Tanda BO": "248140",
      "Tunwala BO": "248005",
      "Shamshergarh BO": "248014",
      "Dhanyari BO": "248008",
      "Dwara BO": "248008",
      "Maldevta BO": "248008",
      "Haripur Kalan BO": "249205",
      "Dandi BO": "248145",
      "Kandoli BO": "248013",
      "Kulhan BO": "248013",
      "Mundhol BO": "248199",
      "Pachhmiwala BO": "248198",
      "K P Shetra BO": "248145",
      "Banjarawala BO": "248121",
      "Haldwari BO": "248143",
      "Sangaon BO": "248143",
      "Dodhli BO": "248140",
      "Nagal Bulandawala BO": "248140",
      "Barasi BO": "248008",
      "Nakronda BO": "248008",
      "Ranjhawala BO": "248008",
      "Tapovan BO": "248008",
      "Chhiddarwala BO": "249204",
      "Sarona BO": "248013",
      "Nirmal Block BO": "249202",
      "Bichli Jolly BO": "248016",
      "Mendrath BO": "248199",
      "Bhaniawala BO": "248140",
      "Ithrana BO": "248143",
      "Thano BO": "248143",
      "Badonwala BO": "248140",
      "Khairi BO": "248140",
      "Markhamgarant BO": "248140",
      "Nagal Jwalapur BO": "248140",
      "Nawada BO": "248005",
      "Nathuawala BO": "248008",
      "Saura Sarauli BO": "248008",
      "Kishanpur BO": "248009",
      "Gumaniwala BO": "249204",
      "Sahstradhara BO": "248013",
      "Anarwala BO": "248003",
      "Dehradun GPO": "248001",
      "Mothrowala BO": "248001",
      "Harawala BO": "248005",
      "Kanwali BO": "248171",
      "Doon University BO": "248012",
      "Lachhiwala BO": "248140",
      "Resham Majri BO": "248140",
      "Badripur BO": "248005",
      "Bhagwantpur BO": "248009",
      "Gadsar BO": "248124",
      "Lakhamandal BO": "248124",
      "Bhandrauli BO": "248123",
      "Koti BO": "248197",
      "Lohari BO": "248158",
      "Sujau BO": "248123",
      "Tungra BO": "248123",
      "Ambari BO": "248125",
      "Kata Pathar BO": "248125",
      "WhtII BO": "248142",
      "Khadar BO": "248159",
      "Laksyar BO": "248158",
      "Ludhera BO": "248158",
      "Nagthat BO": "248158",
      "Sainj BO": "248165",
      "Ubhreau BO": "248165",
      "Landaur Cantt BO": "248179",
      "Arkediagrant BO": "248007",
      "Bidholi BO": "248007",
      "Karbari Grant BO": "248007",
      "Pondha BO": "248007",
      "Umedpur BO": "248007",
      "Kainchiwala BO": "248197",
      "Rudrapur BO": "248197",
      "Sherpur BO": "248197",
      "Datnu BO": "248196",
      "Khamrauli BO": "248196",
      "Kothi BO": "248196",
      "Atal BO": "248199",
      "Birnad BO": "248199",
      "Jakhnilani BO": "248199",
      "Kathang BO": "248199",
      "Jaintanwala BO": "248003",
      "Matiyawa BO": "248123",
      "Mindal BO": "248123",
      "Madrasu BO": "248125",
      "Dhalipur BO": "248142",
      "Dharmawala BO": "248142",
      "Jassowala BO": "248142",
      "Kulhal BO": "248142",
      "Timli BO": "248142",
      "Chhibroo BO": "248159",
      "Haripur BO": "248159",
      "Bijau BO": "248158",
      "Gangroo BO": "248158",
      "Kamla BO": "248158",
      "Kyari BO": "248158",
      "Ambiwala BO": "248007",
      "Birmau BO": "248196",
      "Bullard BO": "248196",
      "Maletha BO": "248196",
      "Samalta BO": "248196",
      "Darmigad BO": "248199",
      "Shigali BO": "248003",
      "Jogio BO": "248124",
      "Kunna BO": "248124",
      "Kunawa BO": "248123",
      "Lorli BO": "248123",
      "Nagau BO": "248123",
      "Baniyana BO": "248123",
      "Ashok Ashram BO": "248125",
      "Langha BO": "248125",
      "Dhakrani BO": "248142",
      "Badho BO": "248158",
      "Lakhwar BO": "248158",
      "Mundhan BO": "248158",
      "Chandanwari BO": "248007",
      "Rajawala BO": "248007",
      "Kedarwala BO": "248197",
      "Rampur BO": "248197",
      "Sabhawala BO": "248197",
      "Tilwari BO": "248197",
      "Baila BO": "248196",
      "Dassau BO": "248196",
      "Haza BO": "248196",
      "Kuwanoo BO": "248196",
      "Naraya BO": "248196",
      "Chilhar BO": "248199",
      "Dangutha BO": "248199",
      "Fanar BO": "248199",
      "Kirar BO": "248199",
      "Dehradun Cantt HO": "248003",
      "Sinola BO": "248003",
      "Chauki Dhaulas BO": "248003",
      "Dawla BO": "248124",
      "Kandoi BO": "248124",
      "Khabau BO": "248124",
      "Kharsi BO": "248124",
      "Kota BO": "248124",
      "Myunda BO": "248124",
      "Nada BO": "248124",
      "Dungiara BO": "248123",
      "Ghanta BO": "248123",
      "Jaddi BO": "248123",
      "Kharora BO": "248123",
      "Marlau BO": "248123",
      "Masak BO": "248123",
      "Thaina BO": "248158",
      "Dessau BO": "248165",
      "Dimau BO": "248165",
      "Jissau BO": "248165",
      "Jharipani BO": "248179",
      "Bhauwala BO": "248007",
      "Manduwala BO": "248007",
      "Nayagaon BO": "248007",
      "VANAVASI ASHRAM BO": "248007",
      "Barwa BO": "248197",
      "Chharba BO": "248197",
      "Dobhri BO": "248197",
      "Horrawala BO": "248197",
      "Korwa BO": "248196",
      "Anu BO": "248199",
      "Bhagwat BO": "248199",
      "Kandoli Bharam BO": "248199",
      "Kailana SO": "248123",
      "Kaulagarh SO": "248003",
      "Mussoorie SO": "248179",
      "Panditwari SO": "248007",
      "Arhat Bazar SO": "248001",
      "Bhogpur SO Dehradun": "248143",
      "CDAAF SO": "248001",
      "Clementtown SO": "248002",
      "Dehradun Kty SO": "248001",
      "Doiwala SO": "248140",
      "Govindgarh SO Dehradun": "248001",
      "IIP SO": "248005",
      "Kanwali Road SO": "248001",
      "Majra SO Dehradun": "248171",
      "Raiwala SO": "249205",
      "Sayedwala SO": "248001",
      "Jollygrant SO": "248016",
      "Barontha SO": "248124",
      "Dakra SO": "248003",
      "INC SO": "248006",
      "Kalsi SO": "248158",
      "Savoy Hotel SO": "248179",
      "Vikasnagar SO Dehradun": "248198",
      "Ballupur SO": "248001",
      "Barlowganj SO": "248122",
      "Herbertpur SO": "248142",
      "IPE SO": "248195",
      "Koti SO": "248165",
      "NAA SO": "248179",
      "Prem Nagar SO Dehradun": "248007",
      "Sahaspur SO Dehradun": "248197",
      "Seemadwar SO": "248146",
      "Selaqui SO": "248011",
      "Telbhawan SO": "248003",
      "Tuini SO": "248199",
      "Araghar SO": "248001",
      "Dehradun City SO": "248001",
      "Nehrugram SO": "248014",
      "Neshvilla Road SO": "248001",
      "Pashulok SO": "249203",
      "Railway Road Rishikesh SO": "249201",
      "RaipurOF SO": "248008",
      "Rajpur SO Dehradun": "248009",
      "Sahastradhara Road SO": "248013",
      "Virbhadra SO": "249202",
      "Patel Nagar SO Dehradun": "248001",
      "Rishikesh SO": "249201",
      "SN Temple SO": "249204",
      "Turner Road SO": "248002",
      "Mehunwala SO": "248018",
      "Chakrata SO": "248123",
      "Dakpathar SO": "248125",
      "IMA SO": "248007",
      "Kalsi Gate SO": "248159",
      "Kingcraig SO": "248179",
      "Landaur SO": "248179",
      "Newforest SO": "248006",
      "Sahiya SO": "248196",
      "Sudhowala SO": "248015",
      "Ajabpur SO": "248121",
      "Cannaught Place SO": "248001",
      "Dalanwala SO": "248001",
      "Defence Colony SO": "248012",
      "Dilaram Bazar SO": "248001",
      "Hathi Barkala SO": "248001",
      "Karanpur SO": "248001",
      "Rani Pokhari SO": "248145",
      "Rispana SO": "248001",
      "Sachivalaya Parisar SO": "248001",
      "Balawala SO": "248019"
    },
    "RUDRA PRAYAG": {
      "Bhaunsal BO": "246421",
      "Dadoli BO": "246421",
      "Dangwal Gaon BO": "246421",
      "Kimana BO": "246421",
      "Makoomath BO": "246419",
      "Nagjagai BO": "246419",
      "Paldwari BO": "246419",
      "Parkandi BO": "246419",
      "Kyark Barsuri BO": "246425",
      "Nainipondar BO": "246425",
      "Pilloo BO": "246425",
      "Kurchhola BO": "246475",
      "Mussadhung BO": "246475",
      "Pandrola BO": "246475",
      "Uchadhungi BO": "246425",
      "Vinobapuri BO": "246425",
      "Bijarakot BO": "246429",
      "Ransi BO": "246439",
      "Tulanga BO": "246439",
      "Uniyana BO": "246439",
      "Rumsi BO": "246421",
      "Syurbangar BO": "246421",
      "Timli Badama BO": "246421",
      "Baksir BO": "246419",
      "Uchhola BO": "246419",
      "Chandra Nagar BO": "246425",
      "Jagoth BO": "246425",
      "Machkandi BO": "246425",
      "Kurjhan BO": "246495",
      "Kyuridasjula BO": "246429",
      "Andrwari BO": "246439",
      "Jaltalla BO": "246439",
      "Queelakhal BO": "246475",
      "Mayali BO": "246475",
      "Semlta BO": "246475",
      "Tuneta BO": "246475",
      "Agar": "246442",
      "Kyuri BO": "246442",
      "Chaura BO": "246141",
      "Panjana BO": "246141",
      "Purviyana BO": "246141",
      "Munnadewal BO": "246475",
      "Sidhsaur BO": "246475",
      "Taila BO": "246475",
      "Bhatwari BO": "246421",
      "Pathalidhar BO": "246421",
      "Silli BO": "246421",
      "Uttarsu BO": "246421",
      "Bareth BO": "246419",
      "Sursal BO": "246419",
      "Dhartondla BO": "246425",
      "Kandara BO": "246425",
      "Kandai BO": "246171",
      "Ladoli BO": "246429",
      "Bansu BO": "246439",
      "Diuli Bhanigram BO": "246439",
      "Lamgondi BO": "246439",
      "Raunlenk BO": "246439",
      "Vidhyapeeth BO": "246439",
      "Arkhund BO": "246425",
      "Barab BO": "246425",
      "Basti BO": "246425",
      "Basukedar BO": "246425",
      "Haretikhal BO": "246495",
      "Kotmalla BO": "246429",
      "Sari BO": "246469",
      "Kalimath BO": "246439",
      "Kotma BO": "246439",
      "Kanda BO": "246475",
      "Kumerisimli BO": "246475",
      "Sakalana BO": "246475",
      "Saurakhal BO": "246475",
      "Barsudi BO": "246171",
      "Biron BO": "246171",
      "Ghandiyalka BO": "246171",
      "Kamera BO": "246171",
      "Maiki Marhi BO": "246171",
      "Sumerpur BO": "246171",
      "Chauriyabhardar BO": "246475",
      "Devidharmamani BO": "246475",
      "Jakhal BO": "246475",
      "Daira BO": "246469",
      "Fafanj BO": "246469",
      "Mansoona BO": "246469",
      "Babai BO": "246442",
      "Durgadhar BO": "246442",
      "Falasi BO": "246442",
      "Ghimtoli BO": "246442",
      "Barsir BO": "246141",
      "Khaliyan BO": "246141",
      "Kotbangar BO": "246141",
      "Paunthi BO": "246141",
      "Gholtir BO": "246171",
      "Narkota BO": "246171",
      "Serabhardar BO": "246171",
      "Budna BO": "246475",
      "Jakhanoli BO": "246475",
      "Badasu BO": "246471",
      "Byung BO": "246471",
      "Gaurikund BO": "246471",
      "Rampur BO": "246471",
      "Trijuginarain BO": "246471",
      "Khankara BO": "246171",
      "Nawasu BO": "246171",
      "Pauri Nishni BO": "246171",
      "Ratura BO": "246171",
      "Sirwari BO": "246141",
      "Thatigadgu BO": "246469",
      "Narainkoti BO": "246471",
      "Gaharkhal BO": "246171",
      "Jakhdhar BO": "246171",
      "Kolli BO": "246171",
      "Saterakhal BO": "246171",
      "Khurar BO": "246171",
      "Chirbatiya BO": "246475",
      "Jakhani SO": "246442",
      "Rudraprayag SO": "246171",
      "Bhiri SO": "246419",
      "Chandrapuri SO": "246425",
      "Jakholi SO": "246141",
      "Okhimath SO": "246469",
      "Phata SO": "246471",
      "Chopra SO Rudraprayag": "246495",
      "Guptkashi SO": "246439",
      "Maikoti SO": "246448",
      "Augustmuni SO": "246421",
      "Kedarnath Seasional SO": "246445",
      "Pallabazar SO": "246171",
      "Tilwara SO": "246475"
    },
    "CHAMOLI": {
      "Dewalkot BO": "246440",
      "Kansuwa BO": "246440",
      "Kheti BO": "246440",
      "Kirsal BO": "246440",
      "Majiyari Malli BO": "246440",
      "Tentura BO": "246486",
      "Lambagar": "246486",
      "Bachher BO": "246424",
      "Bhimtalla BO": "246424",
      "Maithana BO": "246424",
      "Palethi BO": "246424",
      "Maikot BO": "246426",
      "Sawar BO": "246427",
      "Suya BO": "246427",
      "Torti BO": "246427",
      "Rohira BO": "246428",
      "Sarkot BO": "246428",
      "Bartoli BO": "246429",
      "Duwa BO": "246429",
      "Ghooni BO": "246435",
      "Gulari BO": "246435",
      "Kanol BO": "246435",
      "Kurur BO": "246435",
      "Luntra BO": "246435",
      "Perisutol BO": "246435",
      "Senti BO": "246435",
      "Bairangana BO": "246401",
      "Tangsa BO": "246401",
      "Majiyari Talli BO": "246440",
      "Jhumakhet BO": "246486",
      "Mana BO": "246422",
      "Gauna BO": "246424",
      "Irani BO": "246424",
      "Saikot BO": "246424",
      "Balan BO": "246427",
      "Beradhar BO": "246427",
      "Melkhet BO": "246427",
      "Nandkeshari BO": "246427",
      "Gaul BO": "246428",
      "Panchali BO": "246428",
      "Karchhuna BO": "246429",
      "Kharsain BO": "246429",
      "Bhenti BO": "246435",
      "Sutol BO": "246435",
      "Devsari BO": "246441",
      "Dhak BO": "246443",
      "Niti BO": "246443",
      "Pandukeshwar BO": "246443",
      "Bhatoli BO": "246444",
      "Jakh BO": "246444",
      "Ali BO": "246446",
      "Dhunglwali BO": "246446",
      "Sonla BO": "246446",
      "Malkot BO": "246431",
      "Barmoli BO": "246488",
      "Gabani BO": "246453",
      "Kafoli Malli BO": "246453",
      "Bagana BO": "246449",
      "Bhagoti BO": "246455",
      "Chhekura BO": "246455",
      "Kimoli BO": "246488",
      "Kobthan BO": "246455",
      "Mauna BO": "246455",
      "Nakholi BO": "246455",
      "Chaurasain BO": "246487",
      "Malai BO": "246487",
      "Ganaimolta BO": "246472",
      "Izzar BO": "246473",
      "Rauta BO": "246473",
      "Gwardewaldhar BO": "246401",
      "Mandal BO": "246401",
      "Nagali BO": "246440",
      "Ujjwal Pur BO": "246440",
      "Gari BO": "246424",
      "Lasiyari BO": "246424",
      "Ban BO": "246427",
      "Boragarh BO": "246427",
      "Kheta BO": "246427",
      "Mundoli BO": "246427",
      "Rain BO": "246427",
      "Ulangra BO": "246427",
      "Marora BO": "246428",
      "Ramra BO": "246428",
      "Sainji BO": "246428",
      "Khal BO": "246429",
      "Banjbagar BO": "246435",
      "Bura Alla BO": "246435",
      "Lankhi BO": "246435",
      "Ramani BO": "246435",
      "Sung BO": "246435",
      "Chiringa BO": "246441",
      "Dewarkhadora BO": "246401",
      "Pindwali BO": "246440",
      "Silpata BO": "246440",
      "Nailkhansar BO": "246486",
      "Saring Gaon BO": "246486",
      "Hanuman Chatti BO": "246422",
      "Ropa BO": "246424",
      "Sonla Baunli BO": "246424",
      "Chaur BO": "246427",
      "Choting BO": "246427",
      "Ghesh BO": "246427",
      "Jainbisht BO": "246427",
      "Lwani BO": "246427",
      "Andrapa BO": "246428",
      "Farkande Talli BO": "246428",
      "Kweenthi BO": "246429",
      "Ranoun BO": "246429",
      "Shantisadan BO": "246429",
      "Sidoli BO": "246429",
      "Bangali BO": "246435",
      "Ustoli BO": "246435",
      "Thalabair BO": "246473",
      "Dimmar BO": "246474",
      "Kankhul BO": "246474",
      "Kedarukhal": "246474",
      "Cheproun BO": "246481",
      "Dungri Pindarpar BO": "246481",
      "Gerur BO": "246481",
      "Maita BO": "246481",
      "Silori BO": "246481",
      "Bampa Seasonal BO": "246443",
      "Baragaon BO": "246443",
      "Bharki BO": "246443",
      "Jelam BO": "246443",
      "Ruingdranagiri BO": "246443",
      "Salurdungra BO": "246443",
      "Lambagar BO": "246443",
      "Lata BO": "246443",
      "malari Sesonal BO": "246443",
      "Triveni BO": "246443",
      "Urgam BO": "246443",
      "Bagoli BO": "246444",
      "Zilasu BO": "246446",
      "Kanchula BO": "246446",
      "Kanda Maikhura BO": "246446",
      "Chopta BO": "246453",
      "Masson BO": "246449",
      "Matai BO": "246449",
      "Sakand BO": "246449",
      "Sema BO": "246449",
      "Tefna BO": "246449",
      "Thirpak BO": "246449",
      "Chaliyapani BO": "246455",
      "Paithani BO": "246455",
      "Bainoli BO": "246487",
      "Langsi BO": "246472",
      "Kimana BO": "246472",
      "Beena Malla BO": "246473",
      "Bhikona BO": "246473",
      "Raduwa BO": "246473",
      "Salna BO": "246473",
      "Udamanda BO": "246473",
      "Gairoli BO": "246474",
      "Senu BO": "246474",
      "Regari BO": "246483",
      "Harmani BO": "246481",
      "Sunla BO": "246481",
      "Selang BO": "246443",
      "Subhain BO": "246443",
      "Suraithota BO": "246443",
      "Thaing BO": "246443",
      "Chaundali BO": "246444",
      "Garkot BO": "246444",
      "Jainta BO": "246444",
      "Ming Gadhera BO": "246444",
      "Nauli BO": "246444",
      "Umatta Chatti BO": "246444",
      "Saranaairas BO": "246446",
      "Beena Lohba BO": "246431",
      "Kothuli BO": "246453",
      "Lodla BO": "246453",
      "Kandaimanakhi BO": "246449",
      "Khunana BO": "246449",
      "Kotkandara BO": "246449",
      "Dungri Karakot BO": "246455",
      "Gadsira BO": "246455",
      "Naini Chandpur BO": "246487",
      "Bemaru BO": "246472",
      "Dumak BO": "246472",
      "Gadora BO": "246472",
      "Gulabkoti BO": "246472",
      "Pokhani BO": "246472",
      "Tangani BO": "246472",
      "Bishalkhal BO": "246473",
      "Kalsir BO": "246473",
      "Kujasu BO": "246473",
      "Masoli BO": "246473",
      "Koladungri BO": "246474",
      "Ratura BO": "246472",
      "Burjola BO": "246482",
      "Sunaonbhenta BO": "246482",
      "Kimani BO": "246481",
      "Kooni BO": "246481",
      "Kulsari BO": "246481",
      "Kurar BO": "246481",
      "Pokhata BO": "246442",
      "Bhyundhar BO": "246443",
      "Chain BO": "246443",
      "Govindghat BO": "246443",
      "Paini BO": "246443",
      "Rainipalla BO": "246443",
      "Ghandiyal BO": "246444",
      "Khainoli BO": "246444",
      "Saliyana BO": "246444",
      "Siwai BO": "246446",
      "Koonigarh Bichali BO": "246431",
      "Kalusain BO": "246488",
      "Jakhapatiyun BO": "246453",
      "Bansbara BO": "246449",
      "Kamera BO": "246449",
      "Mokh BO": "246449",
      "Pagna BO": "246449",
      "Trisula BO": "246449",
      "Aser Simli BO": "246455",
      "Jhinjhoni BO": "246455",
      "Naini BO": "246455",
      "Kanoth BO": "246487",
      "Malethi BO": "246487",
      "Dweeng BO": "246472",
      "Garurganga BO": "246472",
      "Mayapur BO": "246472",
      "Pagnapainkhanda BO": "246472",
      "Harishankar BO": "246473",
      "Jakhamala BO": "246473",
      "Simlasu BO": "246473",
      "Khandura BO": "246474",
      "Tungeshwar BO": "246482",
      "Gairbaram BO": "246481",
      "Ratgaon BO": "246481",
      "Gopeshwar HO": "246401",
      "Bachhuwaban SO": "246486",
      "Chamoli SO": "246424",
      "Gairsain SO": "246428",
      "Gopeshwar Degree College SO": "246401",
      "Gwaldam SO": "246441",
      "Joshimath SO": "246443",
      "Langasu SO": "246446",
      "Pokhari Nagnath SO": "246473",
      "Sunil": "246443",
      "Tharali SO": "246481",
      "Chhinka SO": "246426",
      "Ghat SO": "246435",
      "Gopeshwar Collectorate SO": "246401",
      "Mehalchauri SO": "246431",
      "Nalgaun SO": "246453",
      "Nauti SO": "246487",
      "Simli SO": "246474",
      "Vishnupuram SO": "246443",
      "Badrinath Seasonal SO": "246422",
      "Debal SO": "246427",
      "Karanprayag SO": "246444",
      "Narayan Bagar SO": "246455",
      "Talwari SO": "246482",
      "Adibadri SO": "246440",
      "Gauchar SO": "246429",
      "Nainisain SO": "246488",
      "Nandprayag SO": "246449",
      "Pipalkoti SO": "246472",
      "Tapoban SO": "246483"
    }
  },
  "SIKKIM": {
    "SOUTH DISTRICT": {
      "Melli Dara BO": "737128",
      "Lungchuk BO": "737128",
      "Manpur BO": "737128",
      "Namphing BO": "737134",
      "Tarku BO": "737134",
      "Temi Tarku BO": "737134",
      "Kerabari BO": "737128",
      "Neya BO": "737134",
      "Yangyang BO": "737134",
      "Sadam BO": "737128",
      "Turuk BO": "737128",
      "Kitam BO": "737126",
      "Maniram BO": "737126",
      "Wok BO": "737126",
      "Mamring BO": "737132",
      "Turung BO": "737132",
      "Ralang BO": "737139",
      "Tinkitam BO": "737139",
      "Perbing BO": "737126",
      "Phalidara BO": "737126",
      "Majitar BO": "737121",
      "Kateng Bokrang BO": "737132",
      "Barfung BO": "737139",
      "Ben BO": "737139",
      "Berang BO": "737139",
      "Kewzing BO": "737139",
      "Bermiok BO": "737134",
      "Payiong BO": "737128",
      "Sumbuk BO": "737128",
      "Assangthang BO": "737126",
      "Nandugaon BO": "737126",
      "Pabong BO": "737126",
      "Poklok BO": "737126",
      "Rong BO": "737126",
      "Shalghari BO": "737126",
      "Singhithang BO": "737126",
      "Phamtam BO": "737139",
      "Sangmoo BO": "737139",
      "Tingmoo BO": "737139",
      "Lingmoo BO": "737134",
      "Lunsing BO": "737139",
      "Rateypani BO": "737128",
      "Damthang BO": "737126",
      "Mic Khola BO": "737126",
      "Sorok BO": "737126",
      "Maney Dara BO": "737132",
      "Namthang BO": "737132",
      "Namchi SO": "737126",
      "Ravangla SO": "737139",
      "Melli Bazar SO": "737128"
    },
    "NORTH DISTRICT": {
      "Lachen BO": "737120",
      "Men Rong Rong BO": "737116",
      "Phamtam BO": "737116",
      "Tingvong BO": "737116",
      "Kabi BO": "737116",
      "Lingdem BO": "737116",
      "Lingthem BO": "737116",
      "Lower Dzongu BO": "737116",
      "Phensong BO": "737116",
      "Lachung BO": "737120",
      "Naga BO": "737120",
      "Shipgyare BO": "737120",
      "Ramthang BO": "737116",
      "Rangrang BO": "737116",
      "Singhik BO": "737116",
      "Gor BO": "737107",
      "Manul BO": "737116",
      "Namok BO": "737116",
      "Sangkalan BO": "737116",
      "Tingchim BO": "737116",
      "Phudong BO": "737116",
      "Bojoghari BO": "737103",
      "Lingdok BO": "737103",
      "Penlong BO": "737103",
      "Mangan SO": "737116",
      "Chungthang SO": "737120"
    },
    "WEST DISTRICT": {
      "Chingthang BO": "737111",
      "Rinchenpong BO": "737111",
      "Sinek BO": "737111",
      "Yangtey BO": "737111",
      "Arithang BO": "737111",
      "Bhaluthang BO": "737111",
      "Karjee BO": "737111",
      "Legship BO": "737111",
      "Lingchom BO": "737111",
      "Rangship BO": "737111",
      "Gerathang BO": "737111",
      "Tashiding BO": "737111",
      "Yangthang BO": "737111",
      "Buriakhop BO": "737121",
      "Chumbong BO": "737121",
      "Soreng BO": "737121",
      "Suldung BO": "737121",
      "Timburbong BO": "737121",
      "Darap BO": "737113",
      "Khechuperi BO": "737113",
      "Radhu Khandu BO": "737113",
      "Malbasey BO": "737121",
      "Okharey BO": "737121",
      "Pipalay BO": "737121",
      "Reshi BO": "737121",
      "Sanchabarey Daramdim BO": "737121",
      "Sanganath BO": "737121",
      "Namphu BO": "737113",
      "Yuksom BO": "737113",
      "Arubotay BO": "737121",
      "Takuthang BO": "737121",
      "Tharpu BO": "737121",
      "Dentam BO": "737113",
      "Hee Gaon BO": "737113",
      "Kaluk BO": "737113",
      "Karmatar BO": "737113",
      "Rimbi BO": "737113",
      "Thingling BO": "737113",
      "Budang BO": "737121",
      "Chakung BO": "737121",
      "Sombaria BO": "737121",
      "Sri Badam BO": "737121",
      "Tikpur BO": "737121",
      "Zoom BO": "737121",
      "Bermiok BO": "737113",
      "Mechi Aching BO": "737113",
      "Uttarey BO": "737113",
      "Pelling SO": "737113",
      "Gayzing SO": "737111",
      "Naya Bazar SO West Sikkim": "737121"
    },
    "EAST DISTRICT": {
      "Rakdong BO": "737107",
      "Nazitam BO": "737134",
      "Sakhu Busty BO": "737134",
      "West Pendam BO": "737134",
      "Dhajey BO": "737102",
      "Kupup BO": "737102",
      "Lumlingthyang BO": "737107",
      "Raley Khesey BO": "737107",
      "Samdong BO": "737107",
      "Sangkhola BO": "737134",
      "Sinchuthang BO": "737134",
      "SANG BO": "737134",
      "Sumin BO": "737134",
      "Tumin BO": "737134",
      "Makha BO": "737134",
      "Kyanglasha BO": "737102",
      "Lingdum BO": "737102",
      "Samdur BO": "737102",
      "Sherathang BO": "737102",
      "Pabyiok BO": "737102",
      "Linkey BO": "737106",
      "Pacheykhani BO": "737106",
      "Chujachen BO": "737131",
      "Phadamchen BO": "737131",
      "Middle Camp BO": "737135",
      "Rauteyrumtek BO": "737135",
      "Rumtek BO": "737135",
      "Rorathang BO": "737133",
      "Sudunglakha BO": "737133",
      "Dipudara Nhpc Complex BO": "737134",
      "Khamdong BO": "737134",
      "Pachey Sansung BO": "737106",
      "Chongey BO": "737103",
      "North Regu BO": "737131",
      "Rolep BO": "737131",
      "East Pendam BO": "737132",
      "Ahoo Busty BO": "737135",
      "Assam Lingzey BO": "737135",
      "Amba BO": "737133",
      "Aritar BO": "737133",
      "Bering BO": "737106",
      "Changayshanti BO": "737106",
      "Karthok BO": "737106",
      "Bhusuk BO": "737103",
      "Luing BO": "737103",
      "Dalapchand BO": "737131",
      "Latuk BO": "737131",
      "Duga BO": "737132",
      "Samlickmarchak BO": "737135",
      "Upper Martam BO": "737135",
      "Upper Dalapchand BO": "737133",
      "Upper Khamdong BO": "737133",
      "Bardang BO": "737134",
      "Kokalay BO": "737134",
      "Lingee BO": "737134",
      "Lingzey BO": "737134",
      "Namcheybong BO": "737106",
      "Tshalamthang BO": "737106",
      "Lingtam BO": "737131",
      "Parkha BO": "737106",
      "South Regu BO": "737131",
      "Upper Pendam BO": "737132",
      "Nandok BO": "737135",
      "Raymindu BO": "737135",
      "Shivalaya Mandir Lingsey BO": "737133",
      "Taza BO": "737133",
      "Beyong BO": "737134",
      "Gangkha Busty BO": "737134",
      "Gangtok HO": "737101",
      "Dikchu SO": "737107",
      "Majitar SO": "737136",
      "Rangpo SO": "737132",
      "Sichey Gaon SO": "737101",
      "Singtam SO": "737134",
      "Deorali SO": "737102",
      "Rajbhawan SO East Sikkim": "737103",
      "Rangli Bazar SO": "737131",
      "Tashiling SO": "737103",
      "Pakyong SO": "737106",
      "Ranipool SO": "737135",
      "Rhenock SO": "737133",
      "Tadong SO": "737102",
      "SMUSikkim Manipal University": "737102"
    }
  },
  "ANDAMAN AND NICOBAR ISLANDS": {
    "NORTH AND MIDDLE ANDAMAN": {
      "Nimbudera B.O": "744201",
      "Hathilevel B.O": "744202",
      "Pashimsagar B.O": "744202",
      "Sitanagar B.O": "744202",
      "Smith  Island B.O": "744202",
      "Weby B.O": "744204",
      "Mohanpur B.O": "744204",
      "Kanchangarh B.O": "744210",
      "Sabari B.O": "744205",
      "Pudumadurai B.O": "744204",
      "Rampur B.O": "744204",
      "Tugapur B.O": "744204",
      "Bakultala B.O": "744205",
      "Kaushalyanagar B.O": "744205",
      "Nimbutala B.O": "744205",
      "Panchawati B.O": "744205",
      "Pitchernalla B.O": "744201",
      "Aerial Bay B.O": "744202",
      "Ramnagar B.O": "744202",
      "Swarajgram B.O": "744202",
      "Sankarnalla B.O": "744210",
      "Parnasala B.O": "744205",
      "Swdeshnagar B.O": "744201",
      "Kalighat B.O": "744202",
      "Kishorinagar B.O": "744202",
      "Laxmipur B.O": "744202",
      "Navagram B.O": "744202",
      "Uttara B.O": "744209",
      "Diglipur S.O": "744202",
      "Long Island S.O": "744203",
      "Oralkatcha S.O": "744210",
      "Betapur S.O": "744201",
      "Kadamtala S.O (North And Middle Andaman)": "744209",
      "Mayabander S.O": "744204",
      "Rangat S.O": "744205"
    },
    "NICOBARS": {
      "Kondul Island B.O": "744302",
      "Champin B.O": "744303",
      "Trinket B.O": "744303",
      "Gandhinagar B.O": "744302",
      "Mus B.O": "744301",
      "Sawai B.O": "744301",
      "Mildera B.O": "744304",
      "Chowra B.O": "744303",
      "Teressa B.O": "744303",
      "Kakana B.O": "744301",
      "Lapathy B.O": "744301",
      "Nehrugram B.O": "744304",
      "Little Nicobar B.O": "744302",
      "Pilomilo Island B.O": "744302",
      "Shabnamnagar B.O": "744302",
      "Campbelbay S.O": "744302",
      "Carnicobar S.O": "744301",
      "Kapanga S.O": "744304",
      "Nancowrie S.O": "744303"
    },
    "SOUTH ANDAMANS": {
      "Humferygunj B.O": "744105",
      "Rutland B.O": "744105",
      "Sippighat B.O": "744105",
      "Herbertabad B.O": "744103",
      "Neil Island B.O": "744104",
      "Stewertgunj B.O": "744107",
      "Bimbiton B.O": "744105",
      "Radio Colony B.O": "744102",
      "Strait  Island B.O": "744211",
      "Kalapather B.O": "744211",
      "Ramakrishnapur B.O": "744207",
      "Brijgunj B.O": "744103",
      "Guptapara B.O": "744103",
      "Beachdera B.O": "744206",
      "Kalatong B.O": "744206",
      "Miletilak B.O": "744206",
      "Sitapur B.O": "744104",
      "Beodnabad B.O": "744105",
      "Calicut B.O": "744105",
      "Vivekandapur B.O": "744207",
      "Chouldari B.O": "744103",
      "Ograbanj B.O": "744103",
      "R.R Station B.O": "744206",
      "Shoalbay B.O": "744206",
      "Havelock  Bazar B.O": "744211",
      "Peal Island B.O": "744211",
      "Netajinagar B.O": "744207",
      "Dollygunj B.O": "744103",
      "Dundas Point B.O": "744206",
      "Jirkatong B.O": "744206",
      "Mathura B.O": "744206",
      "School Line B.O": "744103",
      "Tushnabad B.O": "744103",
      "Wandoor B.O": "744103",
      "Rubber Research Station B.O": "744206",
      "Port Blair H.O": "744101",
      "Delanipur S.O": "744102",
      "Marine Jetty S.O": "744101",
      "Minnie Bay S.O": "744103",
      "Wimberlygunj S.O": "744206",
      "Aberdeen  Bazar S.O": "744104",
      "Bambooflat S.O": "744107",
      "Hut  Bay S.O": "744207",
      "Junglighat S.O": "744103",
      "N.S.Building S.O": "744101",
      "Chatham S.O": "744102",
      "Shadipur S.O": "744106",
      "Chakargoan S.O": "744112",
      "Garacharama S.O": "744105",
      "Haddo S.O": "744102",
      "Havelock S.O": "744211"
    }
  }
};